/*

Bryntum Scheduler 2.2.4
Copyright(c) 2019 Bryntum AB
https://bryntum.com/contact
https://bryntum.com/license

*/
(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory();else if (typeof define === 'function' && define.amd) define("scheduler", [], factory);else if (typeof exports === 'object') exports["scheduler"] = factory();else root["bryntum"] = root["bryntum"] || {}, root["bryntum"]["scheduler"] = factory();
})(window, function () {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "./webpack.entry.js");
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "../Grid/lib/Common/Base.js":
      /*!**********************************!*\
        !*** ../Grid/lib/Common/Base.js ***!
        \**********************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Base;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_is_frozen__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.is-frozen */
        "../Grid/node_modules/core-js/modules/es6.object.is-frozen.js");
        /* harmony import */


        var core_js_modules_es6_object_is_frozen__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_is_frozen__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "../Grid/node_modules/core-js/modules/es6.object.freeze.js");
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.define-property */
        "../Grid/node_modules/core-js/modules/es6.reflect.define-property.js");
        /* harmony import */


        var core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.get-own-property-descriptor */
        "../Grid/node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");
        /* harmony import */


        var core_js_modules_es6_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ./helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler';
        /**
        * @module Common/Base
        */

        var defaultConfigSymbol = Symbol('defaultConfig'),
            propertyInitializersSymbol = Symbol('propertyInitializers'),
            classHierarchySymbol = Symbol('classHierarchy'),
            configurationSymbol = Symbol('configuration'),
            originalConfigSymbol = Symbol('originalConfig'),
            instancePropertiesSymbol = Symbol('instanceProperties');
        /**
         * Base class for all configurable classes.
         *
         * Subclasses do not have to implement a constructor with its restriction of having to call super()
         * before there is a `this` reference. Subclasses instead implement a `construct` method which is
         * called by the `Base` constructor. This may call its `super` implementation at any time.
         *
         * The `Base` constructor applies all configs to properties of the new instance. The instance
         * will have been configured after the `super.construct(config)` is called.
         *
         * See the Class System documentation in the guides for more information.
         *
         * @abstract
         */

        var Base =
        /*#__PURE__*/
        function () {
          // defaultConfig & properties made private to not spam all other classes

          /**
           * A getter for the default configuration of this class, which can be overridden by configurations passed at construction time.
           * @member {Object} defaultConfig
           * @static
           * @category Configuration
           * @private
           */

          /**
           * A getter for the default values of internal properties for this class
           * @member {Object} properties
           * @static
           * @category Configuration
           * @private
           */

          /**
           * Base constructor, passes arguments to {@link #function-construct}.
           * @param args
           * @function constructor
           * @category Lifecycle
           */
          function Base() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_12___default()(this, Base); // Allow subclasses to have a pseudo constructor with "this" already set;


            this.construct.apply(this, arguments);
            this.afterConstruct();
          }
          /**
           * Base implementation applies configuration.
           *
           * Subclasses need only implement this if they have to initialize instance specific
           * properties required by the class. Often a `construct` method is
           * unnecessary. All initialization of incoming configuration properties can be
           * done in a `set propName` implementation.
           * @param {Object} [config] Usually called with a config object, but accepts any params
           * @category Lifecycle
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_13___default()(Base, [{
            key: "construct",
            value: function construct() {
              // Passing null to base construct means bypass the config system and stack creation (to gain performance)
              if ((arguments.length <= 0 ? undefined : arguments[0]) !== null) {
                this.configure.apply(this, arguments);
              }

              this.afterConfigure();
            }
            /**
             * Destroys the object.
             * Do not override this in subclasses. To provide class-specific destruction, implement a
             * doDestroy method. It is a lifecycle hook that will be called during destruction.
             * @category Lifecycle
             */

          }, {
            key: "destroy",
            value: function destroy() {
              var me = this;
              me.isDestroying = true;
              me.doDestroy();
              Object.setPrototypeOf(this, null); // Clear all remaining instance properties.

              for (var key in me) {
                delete me[key];
              }

              delete me[originalConfigSymbol]; // Only one property remains to signal why the object is inert.

              me.isDestroyed = true;
            }
            /**
             * This method is required to help `unused` getters to survive production build process. Some tools, like angular,
             * will remove `unused` code in production build, making our side-effected getters behind, breaking code heavily.
             * @private
             * @param getter Getter to evaluate
             */

          }, {
            key: "_thisIsAUsedExpression",
            value: function _thisIsAUsedExpression(getter) {}
          }, {
            key: "startConfigure",

            /**
             * Base implementation so that all subclasses and mixins may safely call super.startConfigure.
             *
             * This is called by the Base class before setting configuration properties, but after
             * the active initial getters have been set, so all configurations are available.
             *
             * This method allows all classes in the hierarchy to force some configs to be evaluated before others.
             * @internal
             * @category Lifecycle
             * @params {Object} config The configuration object use to set the initial state.
             */
            value: function startConfigure(config) {}
            /**
             * Base implementation so that all subclasses and mixins may safely call super.finishConfigure.
             *
             * This is called by the Base class before exiting the {@link #function-configure} method.
             *
             * At this point, all configs have been applied, but the `isConfiguring` property is still set.
             *
             * This method allows all classes in the hierarchy to inject functionality
             * into the config phase.
             * @internal
             * @category Lifecycle
             * @params {Object} config The configuration object use to set the initial state.
             */

          }, {
            key: "finishConfigure",
            value: function finishConfigure(config) {}
            /**
             * Base implementation so that all subclasses and mixins may safely call `super.afterConfigure`. This is called by the Base class after the {@link #function-configure} method has been
             * called. At this point, all configs have been applied.
             *
             * This method allows all classes in the hierarchy to inject functionality
             * either before or after the super.afterConstruct();
             * @internal
             * @category Lifecycle
             */

          }, {
            key: "afterConfigure",
            value: function afterConfigure() {}
            /**
             * Base implementation so that all subclasses and mixins may safely call super.afterConstruct.
             *
             * This is called by the Base class after the {@link #function-construct} method has been
             * called.
             *
             * At this point, all configs have been applied.
             *
             * This method allows all classes in the hierarchy to inject functionality
             * either before or after the super.afterConstruct();
             * @internal
             * @function afterConstructor
             * @category Lifecycle
             */

          }, {
            key: "afterConstruct",
            value: function afterConstruct() {}
            /**
             * Provides a way of calling callbacks which may have been specified as the _name_ of a function
             * and optionally adds scope resolution.
             *
             * For example, if the callback is specified as a string, then if it is prefixed with `'this.'`
             * then the function is resolved in this object. This is useful when configuring listeners
             * at the class level.
             *
             * If the callback name is prefixed with `'up.'` then the ownership hierarchy is queried
             * using the `owner` property until an object with the named function is present, then the
             * named function is called upon that object.
             * @param {String/Function} handler The function to call, or the name of the function to call.
             * @param {Object} thisObj The `this` object of the function.
             * @param {Object[]} args The argument list to pass.
             */

          }, {
            key: "callback",
            value: function callback(fn, thisObject, args) {
              // Maintainer: do not make args ...args. This method may acquire more arguments
              if (thisObject === 'this') {
                thisObject = this;
              }

              var _this$resolveCallback = this.resolveCallback(fn, thisObject),
                  handler = _this$resolveCallback.handler,
                  thisObj = _this$resolveCallback.thisObj;

              return args ? handler.apply(thisObj, args) : handler.call(thisObj);
            }
          }, {
            key: "resolveCallback",
            value: function resolveCallback(handler) {
              var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this; // It's a string, we find it in its own thisObj

              if (handler.substr) {
                if (handler.startsWith('up.')) {
                  handler = handler.substr(3); // Empty loop until we find the function owner

                  for (thisObj = this.owner; thisObj && !thisObj[handler]; thisObj = thisObj.owner) {
                    ;
                  }
                } else if (handler.startsWith('this.')) {
                  thisObj = this;
                }

                handler = thisObj[handler];
              }

              return {
                handler: handler,
                thisObj: thisObj
              };
            }
            /**
             * Base implementation so that all subclasses and mixins may safely call super.
             * doDestroy is how all subclasses must clean themselves up. It is called by the
             * Base class *before* final destruction of the object.
             * @internal
             * @category Lifecycle
             */

          }, {
            key: "doDestroy",
            value: function doDestroy() {}
            /**
             * Destroys the named properties if they have been initialized, and if they have a `destroy` method.
             * Deletes the property from this object. For example:
             *
             *      this.destroyProperties('store', 'resourceStore', 'eventStore', 'dependencyStore', 'assignmentStore');
             *
             * @param {String} properties The names of the properties to destroy.
             * @internal
             * @category Lifecycle
             */

          }, {
            key: "destroyProperties",
            value: function destroyProperties() {
              var me = this;
              var key, propertyValue;

              for (var _len = arguments.length, properties = new Array(_len), _key = 0; _key < _len; _key++) {
                properties[_key] = arguments[_key];
              }

              for (var _i = 0; _i < properties.length; _i++) {
                key = properties[_i]; // If the value has *not* been pulled in from the configuration object yet
                // we must not try to access it, as that will cause the property to be initialized.

                if (key in me && (!me[configurationSymbol] || !me[configurationSymbol][key])) {
                  propertyValue = me[key];

                  if (propertyValue && propertyValue.destroy) {
                    propertyValue.destroy();
                  }

                  delete me[key];
                }
              }
            }
            /**
             * Called by the Base constructor to apply configs to this instance. The must not be called.
             * @param {Object} config The configuration object from which instance properties are initialized.
             * @private
             * @category Lifecycle
             */

          }, {
            key: "configure",
            value: function configure() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var me = this;
              me.initialConfig = config; // Important flag for setters to know whether they are being called during
              // configuration when this object is not fully alive, or whether it's being reconfgured.

              me.isConfiguring = true; // Assign any instance properties declared by the class.

              Object.assign(me, me.getProperties()); // Apply configuration to default (Which is safe, because it's a chained object) from class definition.
              // Cache me.config for use by get config.

              me.setConfig(me[originalConfigSymbol] = Base.assign(me.getDefaultConfiguration(), config), true);
              me.isConfiguring = false;
            }
            /**
             * Sets configuration options this object with all the properties passed in the parameter object.
             * Timing is taken care of. If the setter of one config is called first, and references
             * the value of another config which has not yet been set, that config will be set just
             * in time, and the *new* value will be used.
             * @param {Object} config An object containing configurations to change.
             * @category Configuration
             */

          }, {
            key: "setConfig",
            value: function setConfig(config, isConstructing) {
              var me = this,
                  wasConfiguring = me[configurationSymbol],
                  configDone = wasConfiguring ? me.configDone : me.configDone = {},
                  instanceProperties = me[instancePropertiesSymbol] = {};
              var key, instanceProperty; // Cache me.configuration for use by injected property initializers.

              me[configurationSymbol] = wasConfiguring ? Object.setPrototypeOf(Object.assign({}, config), wasConfiguring) : config; // For each incoming non-null configuration, create a temporary getter which will
              // pull the value in from the initialConfig so that it doesn't matter in
              // which order properties are set. You can access any property at any time.

              for (key in config) {
                // Don't default null configs inunless it's a direct property of the
                // the passed configuration. When used at construct time, defaultConfigs
                // will be prototype-chained onto the config.
                if (config[key] != null || config.hasOwnProperty(key)) {
                  // If there is an existing property with a getter/setter, *not* a value
                  // defined on the object for this config we must call it in our injected getter/setter.
                  // Maintainer, this is testing the truthiness of the assignment, *not* a botched equality test.
                  if (!instanceProperties[key] && (instanceProperty = Reflect.getOwnPropertyDescriptor(me, key)) && !('value' in instanceProperty)) {
                    instanceProperties[key] = instanceProperty;
                  } // Set up a temporary instance property which will
                  // Pull in the value from the initialConfig if the getter
                  // is called first.


                  Reflect.defineProperty(me, key, Base.createPropInitializer(key));

                  if (!isConstructing) {
                    configDone[key] = false;
                  }
                } else {
                  configDone[key] = true;
                }
              }

              if (isConstructing) {
                me.startConfigure(config);
              } // Set all our properties from the config object.
              // If one of the properties needs to access a property that has not
              // yet been set, the above temporary property will pull it through.
              // Can't use Object.assign because that only uses own properties.
              // config value blocks are prototype chained subclass->superclass


              for (key in config) {
                // Only push the value through if the property initializer is still present.
                // If it gets triggered to pull the configuration value in, it deleted itself.
                if (!configDone[key]) {
                  me[key] = config[key];
                }
              }

              if (wasConfiguring) {
                me[configurationSymbol] = wasConfiguring;
              } else {
                delete me[configurationSymbol];
              }

              if (isConstructing) {
                me.finishConfigure(config);
              }
            }
            /**
             * Returns a *copy* of the full configuration which was used to configure this object.
             * @returns {Object} All configuration properties which were used to configure this object.
             * @category Misc
             */

          }, {
            key: "getDefaultConfiguration",

            /**
             * Gets the full {@link #property-defaultConfig-static} block for this object's entire inheritance chain
             * all the way up to but not including {@link Common.Base}
             * @return {Object} All default config values for this class.
             * @private
             * @category Configuration
             */
            value: function getDefaultConfiguration() {
              return this.constructor.getDefaultConfiguration();
            }
            /**
             * Gets the full {@link #property-defaultConfig-static} block for the entire inheritance chain for this class
             * all the way up to but not including {@link Common.Base}
             * @return {Object} All default config values for this class.
             * @private
             * @category Configuration
             */

          }, {
            key: "getProperties",

            /**
             * Gets the full {@link #property-properties-static} block for this class's entire inheritance chain
             * all the way up to but not including {@link Common.Base}
             * @return {Object} All default config values for this class.
             * @private
             * @category Configuration
             */
            value: function getProperties() {
              var hierarchy = this.classHierarchy(),
                  len = hierarchy.length;
              var result = {},
                  i,
                  cls; // TODO: if properties block does not change this could be cached? would speed up loading of big data sets into grid
              // Gather the class result in *top-down* order so that a subclass's properties
              // overrides properties from superclasses.
              //for (cls of this.classHierarchy()) { // replaced for of since it transpiles badly and this is called a lot when creating many instances

              for (i = 0; i < len; i++) {
                cls = hierarchy[i]; // Skip classes which don't have it. We're going to ask its superclass anyway.

                if (cls.hasOwnProperty('properties')) {
                  Object.assign(result, cls.properties);
                }
              }

              return result;
            }
          }, {
            key: "classHierarchy",

            /**
             * Used by the Widget and GridFeatureManager class internally. Returns the class hierarchy of this object
             * starting from the `topClass` class (which defaults to `Base`).
             *
             * For example `classHierarchy(Widget)` on a Combo would yield `[Widget, Field, TextField, PickerField, Combo]`
             * @param {Function} [topClass] The topmost class constructor to start from.
             * @returns {Function[]} The class hierarchy of this instance.
             * @private
             * @category Configuration
             */
            value: function classHierarchy(topClass) {
              var cls = this.constructor,
                  fullClassHierarchy = cls.hasOwnProperty(classHierarchySymbol) ? cls[classHierarchySymbol] : null,
                  result; // Collect the full class hierarchy only once.

              if (!fullClassHierarchy) {
                // Using Object.getPrototypeOf instead of Refect.getPrototypeOf because:
                // 1. The are almost the same, according to the MDN difference is handling getPrototypeOf('string')
                // 2. It allows to pass security check is salesforce environment
                for (fullClassHierarchy = cls[classHierarchySymbol] = []; cls !== Base; cls = Object.getPrototypeOf(cls)) {
                  fullClassHierarchy.unshift(cls);
                } // Don't let anybody mutate this. It's cached.


                Object.freeze(fullClassHierarchy);
              } // Cut down to the requested topClass


              if (topClass) {
                for (var i = 0; !result && i < fullClassHierarchy.length; i++) {
                  if (fullClassHierarchy[i] === topClass) {
                    result = fullClassHierarchy.slice(i);
                  }
                }
              } else {
                result = fullClassHierarchy;
              }

              return result;
            }
            /**
             * Same as {@link #function-classHierarchy} but returns array of class names obtained via $name property
             *
             * @param {Function} [topClass] The topmost class constructor to start from.
             * @returns {String[]} The class name hierarchy of this instance.
             * @private
             * @category Configuration
             */

          }, {
            key: "classNameHierarchy",
            value: function classNameHierarchy(topClass) {
              return this.classHierarchy(topClass).map(function (f) {
                return f.$name;
              });
            }
            /**
             * Checks if an obj is of type using object's $name property and doing string comparision of the property with the type parameter.
             *
             * @param {String} type
             * @return {Boolean}
             */

          }, {
            key: "$name",
            get: function get() {
              return this.constructor.$name;
            }
          }, {
            key: "config",
            get: function get() {
              var result = {},
                  myConfig = this[originalConfigSymbol],
                  key; // The configuration was created as a prototype chain of the class hierarchy's
              // defaultConfig values hanging off a copy of the initialConfig object, so
              // we must loop and copy since Object.assign only copies own properties.

              for (key in myConfig) {
                result[key] = myConfig[key];
              }

              return result;
            }
          }], [{
            key: "getDefaultConfiguration",
            value: function getDefaultConfiguration() {
              var configDescriptor = this.getConfigDescriptor();
              return configDescriptor.needsFork ? this.fork(configDescriptor.defaultConfig) : Object.setPrototypeOf({}, configDescriptor.defaultConfig);
            }
            /**
             * Gets the full {@link #property-defaultConfig-static} block for this class's entire inheritance chain
             * all the way up to but not including {@link Common.Base}
             * @return {Object} All default config values for this class.
             * @private
             * @category Configuration
             */

          }, {
            key: "getConfigDescriptor",
            value: function getConfigDescriptor(shallow) {
              var me = this;
              var configDescriptor = !shallow && me.hasOwnProperty(defaultConfigSymbol) ? me[defaultConfigSymbol] : null,
                  defaults,
                  key,
                  cls,
                  value,
                  superConfigDescriptor;

              if (!configDescriptor) {
                configDescriptor = {
                  defaultConfig: defaults = me.hasOwnProperty('defaultConfig') ? me.defaultConfig : {},
                  // Use 1 instead of true because below we're using |= to or up all the flags from the class hierarchy
                  needsFork: 0
                }; // Only cache top level descriptors.

                if (!shallow) {
                  me[defaultConfigSymbol] = configDescriptor;
                }

                for (key in defaults) {
                  value = defaults[key]; // If any default properties are *mutable* Objects or Array we need to clone them.
                  // so that instances do not share configured values.

                  if (value && (value.constructor === Object || Array.isArray(value)) && !Object.isFrozen(value)) {
                    // Use 1 instead of true because below we're using |= to or up all the flags from the class hierarchy
                    configDescriptor.needsFork = 1;
                    break;
                  }
                } // Because of mixins being mixed into different parts of the class hiererchy,
                // we can't chain to an existing deep descriptor. We have to climb from
                // here and assemble the deep descriptor from shallow ones.
                // If any along the way need forking (have an Object or Array), so do we.
                // We chain them together because that is hundreds of times faster
                // than Object.assign: https://jsperf.com/setprototypeof-vs-object-assign/


                if (!shallow) {
                  for (cls = me.superclass; cls && cls !== Base; cls = cls.superclass) {
                    superConfigDescriptor = cls.getConfigDescriptor(true);

                    if (Object.keys(superConfigDescriptor.defaultConfig).length) {
                      configDescriptor.needsFork |= superConfigDescriptor.needsFork;
                      Object.setPrototypeOf(defaults, defaults = superConfigDescriptor.defaultConfig);
                    }
                  }
                }
              }

              return configDescriptor;
            }
          }, {
            key: "fork",
            value: function fork(obj) {
              var ret, key, value;

              if (obj && obj.constructor === Object && !Object.isFrozen(obj)) {
                ret = Object.setPrototypeOf({}, obj);

                for (key in obj) {
                  value = obj[key];

                  if (value) {
                    if (value.constructor === Object) {
                      ret[key] = this.fork(value);
                    } else if (value instanceof Array) {
                      ret[key] = value.slice();
                    }
                  }
                }
              } else {
                ret = obj;
              }

              return ret;
            }
          }, {
            key: "assign",
            value: function assign(dest) {
              var i = 0,
                  ln = arguments.length <= 1 ? 0 : arguments.length - 1,
                  source,
                  key;

              for (; i < ln; i++) {
                source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

                for (key in source) {
                  dest[key] = source[key];
                }
              }

              return dest;
            }
          }, {
            key: "createPropInitializer",
            value: function createPropInitializer(key) {
              // Because initializers for a property name are the same, cache them on the Base
              // class so that only one copy is created for each property name globally.
              var result = (this[propertyInitializersSymbol] || (this[propertyInitializersSymbol] = {}))[key];

              if (!result) {
                var initializingFlagName = 'initializing' + _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].capitalizeFirstLetter(key);

                result = this[propertyInitializersSymbol][key] = {
                  configurable: true,
                  get: function get() {
                    var me = this,
                        instanceProperty = me[instancePropertiesSymbol][key]; // If we took over from an instance property, replace it

                    if (instanceProperty) {
                      Reflect.defineProperty(me, key, instanceProperty);
                    } // Otherwise just delete the instance property who's getter we are in.
                    else {
                        delete me[key];
                      } // Set the value from the configuration.


                    me[initializingFlagName] = true;
                    me[key] = me[configurationSymbol][key];
                    me[initializingFlagName] = false; // The property has been *pulled* from the configuration.
                    // Prevent the setting loop in configure from setting it again.

                    me.configDone[key] = true; // Finally, allow the prototype getter to return the value.

                    return me[key];
                  },
                  set: function set(value) {
                    var me = this,
                        instanceProperty = me[instancePropertiesSymbol][key]; // If we took over from an instance property, replace it

                    if (instanceProperty) {
                      Reflect.defineProperty(me, key, instanceProperty);
                    } // Otherwise just delete the instance property who's getter we are in.
                    else {
                        delete me[key];
                      } // The config has been set (some internal code may have called the setter)
                    // so prevent it from being called again and overwritten with data from initialConfig.


                    me.configDone[key] = true; // Set the property normally (Any prototype setter will be invoked)

                    me[key] = value;
                  }
                };
              }

              return result;
            }
          }, {
            key: "isOfTypeName",
            value: function isOfTypeName(type) {
              return this.classNameHierarchy().includes(type);
            }
          }, {
            key: "$name",
            get: function get() {
              return this.hasOwnProperty('_$name') && this._$name || this.name;
            }
          }, {
            key: "superclass",
            get: function get() {
              return Object.getPrototypeOf(this);
            }
          }]);

          return Base;
        }();

        Base._$name = 'Base';
        /***/
      },

      /***/
      "../Grid/lib/Common/GlobalEvents.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Common/GlobalEvents.js ***!
        \******************************************/

      /*! exports provided: default, setupFocusListeners */

      /***/
      function GridLibCommonGlobalEventsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return GlobalEvents;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "setupFocusListeners", function () {
          return setupFocusListeners;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        var globaltouchStart,
            focusEventsSuspended = false,
            GlobalEvents = (window.bryntum || (window.bryntum = {})).GlobalEvents = new (
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(_class, _Events);

          function _class() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, _class);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(_class).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(_class, [{
            key: "suspendFocusEvents",
            value: function suspendFocusEvents() {
              focusEventsSuspended = true;
            }
          }, {
            key: "resumeFocusEvents",
            value: function resumeFocusEvents() {
              focusEventsSuspended = false;
            }
          }, {
            key: "lastInteractionType",
            get: function get() {
              return lastInteractionType;
            }
          }]);

          return _class;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_6__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])))(),
            lastInteractionType;

        function createWidgetEvent(eventName, target, relatedTarget, fromWidget, toWidget, backwards, options) {
          var result = new CustomEvent(eventName, options);
          Object.defineProperty(result, 'target', {
            get: function get() {
              return target;
            }
          });
          Object.defineProperty(result, 'relatedTarget', {
            get: function get() {
              return relatedTarget;
            }
          });
          result.fromWidget = fromWidget;
          result.toWidget = toWidget;
          result.backwards = backwards;
          return result;
        }

        function getCommonAncestor(from, to) {
          if (from === to) {
            return from;
          }

          var isWidget = from instanceof _widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"];

          while (from && !(from[isWidget ? 'owns' : 'contains'](to) || from === to)) {
            from = from[isWidget ? 'owner' : 'parentNode'];
          }

          return from;
        }

        var listeners = {
          element: document,
          touchstart: function touchstart(_touchstart) {
            if (!globaltouchStart && _touchstart.changedTouches.length === 1) {
              globaltouchStart = _touchstart.changedTouches[0];
            } else {
              globaltouchStart = null;
            }
          },
          // Just this one has to be passive: false so that we are allowed to preventDefault
          // if we are part of a contextmenu longpres emulation. Otherwise the gesture will
          // proceed to cause a mousedown event.
          touchend: {
            handler: function handler(event) {
              if (globaltouchStart) {
                // If the touchstart was used to synthesize a contextmenu event
                // stop the touch gesture processing right now.
                // Also prevent the conversion of the touch into  click.
                if (globaltouchStart.identifier === _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].contextMenuTouchId) {
                  event.stopImmediatePropagation();
                  event.preventDefault();
                } else if (event.changedTouches.length === 1 && event.changedTouches[0].identifier === globaltouchStart.identifier) {
                  GlobalEvents.trigger('globaltap', {
                    event: event
                  });
                }

                globaltouchStart = null;
              }
            },
            passive: false
          },
          mousedown: {
            handler: function handler(event) {
              lastInteractionType = 'mouse';

              if (!globaltouchStart) {
                GlobalEvents.trigger('globaltap', {
                  event: event
                });
              }
            },
            passive: false
          },
          keydown: function keydown() {
            lastInteractionType = 'key';
          },
          keypress: function keypress() {
            lastInteractionType = 'key';
          },
          focusin: function focusin(_focusin) {
            // https://app.assembla.com/spaces/bryntum/tickets/5503
            // Caused by the browser scrolling a focused element into view. The browser will do *whatever it takes*
            // to scroll a focused element so that as much of it is in view as possible. Its first point of scrolling will
            // be the float containing element. That must never scroll.
            _widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"].floatRoot.scrollTop = _widget_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"].floatRoot.scrollLeft = 0;

            if (focusEventsSuspended) {
              return;
            }

            var fromElement = _focusin.relatedTarget,
                toElement = _focusin.target || document.body,
                fromWidget = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].fromElement(fromElement),
                toWidget = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].fromElement(toElement),
                commonAncestor = getCommonAncestor(fromWidget, toWidget),
                // Flag if the fromElement is DOCUMENT_POSITION_FOLLOWING toElement
            backwards = !!(fromElement && toElement.compareDocumentPosition(fromElement) & 4);

            var event = createWidgetEvent('focusout', fromElement, toElement, fromWidget, toWidget, backwards); // Bubble focusout event up the "from" side of the tree

            for (var target = fromWidget; target && target !== commonAncestor; target = target.owner) {
              if (!(target.isDestroyed || target.isDestroying)) {
                target.onFocusOut && target.onFocusOut(event);
              }
            } // Focus is moving upwards to the ancestor widget.
            // Its focus method might delegate focus to a focusable descendant.


            if (commonAncestor && _focusin.target === commonAncestor.element) {
              // If one of the handlers above has not moved focus onwards
              // and the common ancestor is a container which delegates
              // focus inwards to a descendant, then give it the opportunity to do that.
              if (document.activeElement === toElement && commonAncestor.focusElement && commonAncestor.focusElement !== commonAncestor.element) {
                // Wait until out of the focusin handler to move focus on.
                setTimeout(function () {
                  return commonAncestor.focus && commonAncestor.focus();
                }, 0);
              }
            } // Focus is moving between two branches of a subtree.
            // Bubble focusin event up the "to" side of the tree
            else {
                event = createWidgetEvent('focusin', toElement, fromElement, fromWidget, toWidget, backwards);

                for (var _target = toWidget; _target && _target !== commonAncestor; _target = _target.owner) {
                  if (!(_target.isDestroyed || _target.isDestroying)) {
                    _target.onFocusIn && _target.onFocusIn(event);
                  }
                }
              } // Fire element focusmove event. Grid navigation will use  this when cells are focusable.


            var commonAncestorEl = getCommonAncestor(fromElement && fromElement.nodeType === 1 ? fromElement : null, toElement) || toElement.parentNode;
            event = createWidgetEvent('focusmove', toElement, fromElement, fromWidget, toWidget, backwards, {
              bubbles: true
            });
            commonAncestorEl.dispatchEvent(event);
          },
          focusout: function focusout(_focusout) {
            if (focusEventsSuspended) {
              return;
            }

            if (!_focusout.relatedTarget || !_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].fromElement(_focusout.relatedTarget)) {
              listeners.focusin({
                target: _focusout.relatedTarget,
                relatedTarget: _focusout.target
              });
            }
          },
          capture: true,
          passive: true
        };

        function setupFocusListeners() {
          var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

          var config = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].assign({}, listeners, {
            element: element
          });

          _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].on(config);
        }

        setupFocusListeners();
        /***/
      },

      /***/
      "../Grid/lib/Common/adapter/widget/BryntumWidgetAdapter.js":
      /*!*****************************************************************!*\
        !*** ../Grid/lib/Common/adapter/widget/BryntumWidgetAdapter.js ***!
        \*****************************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonAdapterWidgetBryntumWidgetAdapterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return BryntumWidgetAdapter;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/construct */
        "../Grid/node_modules/@babel/runtime/helpers/construct.js");
        /* harmony import */


        var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _widget_Mask_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../widget/Mask.js */
        "../Grid/lib/Common/widget/Mask.js");
        /* harmony import */


        var _widget_Menu_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../widget/Menu.js */
        "../Grid/lib/Common/widget/Menu.js");
        /* harmony import */


        var _widget_Popup_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../widget/Popup.js */
        "../Grid/lib/Common/widget/Popup.js");
        /* harmony import */


        var _widget_Toast_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../widget/Toast.js */
        "../Grid/lib/Common/widget/Toast.js");
        /* harmony import */


        var _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _widget_Button_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../widget/Button.js */
        "../Grid/lib/Common/widget/Button.js");
        /* harmony import */


        var _widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../widget/ButtonGroup.js */
        "../Grid/lib/Common/widget/ButtonGroup.js");
        /* harmony import */


        var _widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../widget/Checkbox.js */
        "../Grid/lib/Common/widget/Checkbox.js");
        /* harmony import */


        var _widget_Combo_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../widget/Combo.js */
        "../Grid/lib/Common/widget/Combo.js");
        /* harmony import */


        var _widget_Container_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../widget/Container.js */
        "../Grid/lib/Common/widget/Container.js");
        /* harmony import */


        var _widget_DateField_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../widget/DateField.js */
        "../Grid/lib/Common/widget/DateField.js");
        /* harmony import */


        var _widget_NumberField_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../widget/NumberField.js */
        "../Grid/lib/Common/widget/NumberField.js");
        /* harmony import */


        var _widget_Slider_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../widget/Slider.js */
        "../Grid/lib/Common/widget/Slider.js");
        /* harmony import */


        var _widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../../widget/TabPanel.js */
        "../Grid/lib/Common/widget/TabPanel.js");
        /* harmony import */


        var _widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../../widget/TextAreaField.js */
        "../Grid/lib/Common/widget/TextAreaField.js");
        /* harmony import */


        var _widget_TextField_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../../widget/TextField.js */
        "../Grid/lib/Common/widget/TextField.js");
        /* harmony import */


        var _widget_TimeField_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../../widget/TimeField.js */
        "../Grid/lib/Common/widget/TimeField.js");
        /* harmony import */


        var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../../helper/util/Point.js */
        "../Grid/lib/Common/helper/util/Point.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/adapter/widget/BryntumWidgetAdapter
         */

        /**
         * Adapter that allows {@link Common.helper.WidgetHelper} to use Bryntums widgets.
         * Not to be called directly.
         * @example
         * WidgetHelper.adapter = BryntumWidgetAdapter;
         */

        var BryntumWidgetAdapter =
        /*#__PURE__*/
        function () {
          function BryntumWidgetAdapter() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, BryntumWidgetAdapter);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(BryntumWidgetAdapter, [{
            key: "createWidget",
            // region Create, insert, append
            value: function createWidget(config) {
              return _util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__["default"].createWidget(config.type, config);
            }
          }, {
            key: "getClass",
            value: function getClass(type) {
              return _util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__["default"].getClass(type);
            }
          }, {
            key: "appendWidget",
            value: function appendWidget(config) {
              return this.createWidget(config);
            }
          }, {
            key: "appendWidgets",
            value: function appendWidgets(configArray, config) {
              var _this = this; // Prototype chained objects may be passed, so use ObjectHelper.


              return configArray.map(function (item) {
                return _this.appendWidget(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({}, config || {}, item));
              });
            } //endregion
            //region Window & popup

          }, {
            key: "openPopup",
            value: function openPopup(element, config) {
              // Prototype chained objects may be passed, so use ObjectHelper.
              return new _widget_Popup_js__WEBPACK_IMPORTED_MODULE_9__["default"](_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].assign({
                forElement: element
              }, typeof config === 'string' ? {
                html: config
              } : config));
            } //endregion
            //region Menu

          }, {
            key: "showContextMenu",
            value: function showContextMenu(element, config) {
              var me = this;

              if (me.currentContextMenu) {
                me.currentContextMenu.destroy();
              }

              if (element instanceof HTMLElement) {
                config.forElement = element;
              } else if (Array.isArray(element)) {
                config.forElement = {
                  target: _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_1___default()(_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_24__["default"], _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default()(element))
                };
              } else if (element instanceof _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_24__["default"]) {
                config.forElement = {
                  target: element
                };
              }

              me.currentContextMenu = new _widget_Menu_js__WEBPACK_IMPORTED_MODULE_8__["default"](config);
              me.currentContextMenu.on('destroy', function () {
                me.currentContextMenu = null;
              });
              return me.currentContextMenu;
            } //endregion
            //region Tooltip

          }, {
            key: "attachTooltip",
            value: function attachTooltip(element, configOrText) {
              if (typeof configOrText === 'string') configOrText = {
                html: configOrText
              }; // TODO: refactor this
              // eslint-disable-next-line no-new

              new _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__["default"](Object.assign({
                forElement: element
              }, configOrText));
              return element;
            }
          }, {
            key: "hasTooltipAttached",
            value: function hasTooltipAttached(element) {
              return _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__["default"].hasTooltipAttached(element);
            }
          }, {
            key: "destroyTooltipAttached",
            value: function destroyTooltipAttached(element) {
              return _widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__["default"].destroyTooltipAttached(element);
            } //endregion
            //region Mask

          }, {
            key: "mask",
            value: function mask(config) {
              var text = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Loading';

              if (config) {
                // Config object normalization
                if (config instanceof HTMLElement) {
                  config = {
                    element: config,
                    text: text
                  };
                }

                return _widget_Mask_js__WEBPACK_IMPORTED_MODULE_7__["default"].mask(config, config.element);
              }
            }
          }, {
            key: "unmask",
            value: function unmask(element) {
              var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

              if (element.mask) {
                if (close) {
                  element.mask.close();
                } else {
                  element.mask.hide();
                }
              }
            } //endregion
            //region Toast

          }, {
            key: "toast",
            value: function toast(msg) {
              return _widget_Toast_js__WEBPACK_IMPORTED_MODULE_10__["default"].show(msg);
            } //endregion
            //region Style
            // moved from WidgetHelper to avoid circular reference

          }, {
            key: "defaultStyle",
            set: function set(style) {
              this._defaultStyle = style;
            },
            get: function get() {
              return this._defaultStyle;
            } //endregion

          }]);

          return BryntumWidgetAdapter;
        }();

        if (!_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"]._adapter) _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].adapter = BryntumWidgetAdapter;
        BryntumWidgetAdapter._$name = 'BryntumWidgetAdapter';
        /***/
      },

      /***/
      "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js":
      /*!******************************************************************************!*\
        !*** ../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js ***!
        \******************************************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonAdapterWidgetUtilBryntumWidgetAdapterRegisterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return BryntumWidgetAdapterRegister;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);

        var productName = 'scheduler';
        /**
        * Keeps a map of registered widgets. Used by BryntumWidgetAdapter to create widgets using `{ type : 'xx' }`.
        * @private
        */

        var BryntumWidgetAdapterRegister =
        /*#__PURE__*/
        function () {
          function BryntumWidgetAdapterRegister() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, BryntumWidgetAdapterRegister);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(BryntumWidgetAdapterRegister, null, [{
            key: "register",
            value: function register(type, widgetClass) {
              var classEntry = widgetClassRegister[widgetClass]; // Create a mapping from the type to the class

              widgetRegister[type] = widgetClass; // Create a mapping from the class to its type identifier(s)

              if (classEntry) {
                classEntry[type] = 1;
              } else {
                widgetClassRegister[widgetClass] = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, type, 1);
              }
            }
          }, {
            key: "getClass",
            value: function getClass(type) {
              return widgetRegister[type];
            }
            /**
             * Determines whether the passed widget matches the passed type. So a {@link Common.widget.Combo}
             * would match any of its three registered types, `'combobox'`, '`combo'` or `'dropdown'`.
             *
             * Pass the `deep` parameter as `true` to test the class hierarchy also, so if `deep`, a
             * {@link Common.widget.Combo} would also match `'pickerfield'`, `'field'` and `'widget'`.
             *
             * Note that this is *type* matching, not querying, so patterns such as `'*'` will not match.
             * @param {Common.widget.Widget} widget The widget to test.
             * @param {String} type The stype string to test against. 
             * @param {Boolean} [deep] Whether to test the widget's superclass hierarchy. 
             * @returns {Boolean} `true` if the passed widget matches the passed selector.
             */

          }, {
            key: "isType",
            value: function isType(widget, type, deep) {
              for (var widgetClass = widget.constructor; widgetClass; widgetClass = deep && Object.getPrototypeOf(widgetClass)) {
                // Find a registered entry.
                // If it's an abstract based class which was not registered (such as PickerField),
                // create an entry for it using its lowercased $name
                var classEntry = widgetClassRegister[widgetClass] || widgetClass.$name && (widgetClassRegister[widgetClass] = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, widgetClass.$name.toLowerCase(), 1));

                if (classEntry && classEntry[type]) {
                  return true;
                }
              }
            }
          }, {
            key: "createWidget",
            value: function createWidget(type, config) {
              var widgetClass = this.getClass(type);

              if (widgetClass) {
                return new widgetClass(config);
              } // eslint-disable-next-line no-unreachable


              return null;
            }
          }]);

          return BryntumWidgetAdapterRegister;
        }();

        var widgetRegister = BryntumWidgetAdapterRegister.widgetRegister = {},
            widgetClassRegister = BryntumWidgetAdapterRegister.widgetClassRegister = {};
        BryntumWidgetAdapterRegister._$name = 'BryntumWidgetAdapterRegister';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/AjaxStore.js":
      /*!********************************************!*\
        !*** ../Grid/lib/Common/data/AjaxStore.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataAjaxStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return AjaxStore;
        });
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../Grid/node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "../Grid/node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/asyncToGenerator */
        "../Grid/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _Store_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ./Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../helper/AjaxHelper.js */
        "../Grid/lib/Common/helper/AjaxHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/AjaxStore
         */

        var processParamEntry = function processParamEntry(paramArray, entry) {
          if (Array.isArray(entry[1])) {
            entry[1].forEach(function (value) {
              return paramArray.push(entry[0] + '=' + value);
            });
          } else {
            paramArray.push(entry[0] + '=' + entry[1]);
          }

          return paramArray;
        },
            immediatePromise = new Promise(function (resolve) {
          return resolve();
        });
        /**
         * Store that does CRUD using Ajax.
         *
         * <h3>Create</h3>
         * Posts array of JSON data for newly added records to {@link #config-createUrl}, expects response containing an array of JSON objects
         * in same order with id set (uses Model#idField as id).
         *
         * <h3>Read</h3>
         * Reads array of JSON data from the data packet returned from the {@link #config-readUrl}. Unique id for each row is required.
         * By default looks in field 'id' but can be configured by setting {@link Common.data.Model#property-idField-static}.
         *
         * <h3>Update</h3>
         * Posts array of JSON data for newly modified records to {@link #config-updateUrl}.
         *
         * <h3>Destroy</h3>
         * Posts to {@link #config-deleteUrl} with removed records ids (for example id=1,4,7).
         *
         * @example
         * new AjaxStore({
         *   createUrl  : 'php/create',
         *   readUrl    : 'php/read',
         *   updateUrl  : 'php/update',
         *   deleteUrl  : 'php/delete',
         *   modelClass : Customer
         * });
         *
         * @extends Common/data/Store
         */


        var AjaxStore =
        /*#__PURE__*/
        function (_Store) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(AjaxStore, _Store);

          function AjaxStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, AjaxStore);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(AjaxStore).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(AjaxStore, [{
            key: "afterConstruct",

            /**
             * Url to post newly created records to.
             *
             * The response must be in the form:
             *
             *     {
             *         "success": true,
             *         "data": [{
             *             "id": 0, "name": "General Motors"
             *         }, {
             *             "id": 1, "name": "Apple"
             *         }]
             *     }
             *
             * Just the array of data may be returned, however that precludes the
             * orderly handling of errors encountered at the server.
             *
             * If the server encountered an error, the packet would look like this:
             *
             *     {
             *         "success": false,
             *         "message": "Some kind of database error"
             *     }
             *
             * And that packet would be available in the {@link #event-exception} handler
             * in the `response` property of the event.
             *
             * The `success` property may be ommitted, it defaults to `true`.
             *
             * @config {String} createUrl
             * @category CRUD
             */

            /**
             * Url to read data from.
             *
             * The response must be in the form:
             *
             *     {
             *         "success": true,
             *         "data": [{
             *             "id": 0, "name": "General Motors"
             *         }, {
             *             "id": 1, "name": "Apple"
             *         }]
             *     }
             *
             * Just the array of data may be returned, however that precludes the
             * orderly handling of errors encountered at the server.
             *
             * If the server encountered an error, the packet would look like this:
             *
             *     {
             *         "success": false,
             *         "message": "Some kind of database error"
             *     }
             *
             * And that packet would be available in the {@link #event-exception} handler
             * in the `response` property of the event.
             *
             * The `success` property may be omitted, it defaults to `true`.
             *
             * @config {String} readUrl
             * @category CRUD
             */

            /**
             * Url to post record modifications to.
             *
             * The response must be in the form:
             *
             *     {
             *         "success": true,
             *         "data": [{
             *             "id": 0, "name": "General Motors"
             *         }, {
             *             "id": 1, "name": "Apple"
             *         }]
             *     }
             *
             * Just the array of data may be returned, however that precludes the
             * orderly handling of errors encountered at the server.
             *
             * If the server encountered an error, the packet would look like this:
             *
             *     {
             *         "success": false,
             *         "message": "Some kind of database error"
             *     }
             *
             * And that packet would be available in the {@link #event-exception} handler
             * in the `response` property of the event.
             *
             * The `success` property may be ommitted, it defaults to `true`.
             *
             * @config {String} updateUrl
             * @category CRUD
             */

            /**
             * Url for destroying records.
             *
             * The response must be in the form:
             *
             *     {
             *         "success": true
             *     }
             *
             * If the server encountered an error, the packet would look like this:
             *
             *     {
             *         "success": false,
             *         "message": "Some kind of database error"
             *     }
             *
             * And that packet would be available in the {@link #event-exception} handler
             * in the `response` property of the event.
             *
             * The `success` property may be ommitted, it defaults to `true`.
             *
             * @config {String} deleteUrl
             * @category CRUD
             */

            /**
             * True to initiate a load when the store is instantiated
             * @config {Boolean} autoLoad
             * @category Common
             */
            //endregion
            value: function afterConstruct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(AjaxStore.prototype), "afterConstruct", this).call(this, config);

              if (this.autoLoad) {
                this.load().catch(function (e) {});
              }
            }
            /**
             * Returns true if the Store is currently loading
             * @property {Boolean}
             * @readonly
             * @category CRUD
             */

          }, {
            key: "buildQueryString",
            value: function buildQueryString() {
              for (var _len = arguments.length, paramObjects = new Array(_len), _key = 0; _key < _len; _key++) {
                paramObjects[_key] = arguments[_key];
              }

              var queryString = Object.entries(Object.assign.apply(Object, [{}].concat(paramObjects))).reduce(processParamEntry, []).join('&');
              return queryString ? '?' + queryString : '';
            }
          }, {
            key: "internalLoad",
            value: function internalLoad(params, eventName, successFn) {
              var me = this,
                  allParams = Object.assign({}, me.params, params),
                  event = {
                action: 'read' + eventName,
                params: allParams
              },
                  result = me.readUrl ? new Promise(function (resolve, reject) {
                if (me.trigger('beforeLoad' + eventName, event) === false) {
                  return reject(false); // eslint-disable-line
                }

                me._isLoading = true; // This may look redundant, but it allows for two levels of event listening.
                // Granular, where the observer observes only the events of interest, and
                // catch-all, where the observer is interested in all requests.

                me.trigger("load".concat(eventName, "Start"), event);
                me.trigger('beforeRequest', event);

                _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].get(me.readUrl + me.buildQueryString(allParams), Object.assign({
                  headers: me.headers,
                  parseJson: true
                }, me.fetchOptions)).then(function (response) {
                  var data = response.parsedJson,
                      isArray = Array.isArray(data),
                      success = isArray || data && data.success !== false;
                  me._isLoading = false;
                  event.response = response;
                  event.json = data;

                  if (success) {
                    event.data = isArray ? data : data[me.responseDataProperty];
                    successFn(event);
                    me.trigger('load' + eventName, event);
                    resolve(event);
                  } else {
                    event.exception = true;
                    event.exceptionType = 'server';
                    me.trigger('exception', event);
                    reject(event);
                  } // finally


                  me.trigger('afterRequest', event);
                }).catch(function (responseOrError) {
                  me._isLoading = false;
                  event.exception = true;

                  if (responseOrError instanceof Response) {
                    event.exceptionType = responseOrError.ok ? 'server' : 'network';
                    event.response = responseOrError;
                    event.error = responseOrError.error;
                  } else {
                    event.exceptionType = 'server';
                    event.error = responseOrError;
                  }

                  me.trigger('exception', event);
                  reject(event); // finally

                  me.trigger('afterRequest', event);
                });
              }) : null;
              return result;
            }
            /**
             * Load data from the {@link #config-readUrl}.
             * @param {Object} params A hash of parameters to append to querystring (will also append Store#params)
             * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
             * vetoed by a {@link #event-beforeLoad} handler, or if an {@link #event-exception} is detected.
             * The resolved function is passed the event object passed to any event handlers.
             * The rejected function is passed the {@link #event-exception} event if an exception occurred,
             * or `false` if the load was vetoed by a {@link #event-beforeLoad} handler.
             * @fires beforeLoad
             * @fires loadStart
             * @fires beforeRequest
             * @fires load
             * @fires exception
             * @fires afterRequest
             * @category CRUD
             */

          }, {
            key: "load",
            value: function load(params) {
              var me = this;
              return me.internalLoad(params, '', function (event) {
                // The set Data setter will trigger the refresh event with { action: 'dataset' }
                me.data = event.data;
              });
            }
            /**
             * Loads children into specified parent record. Parent records id is sent as a param (param name configured with
             * {@link #config-parentIdParamName}.
             * @param {Common.data.Model} parentRecord Parent record
             * @returns {Promise} A Promise which will be resolved if the load succeeds, and rejected if the load is
             * vetoed by a {@link #event-beforeLoadChildren} handler, or if an {@link #event-exception} is detected.
             * The resolved function is passed the event object passed to any event handlers.
             * The rejected function is passed the {@link #event-exception} event if an exception occurred,
             * or `false` if the load was vetoed by a {@link #event-beforeLoadChildren} handler.
             * @fires beforeLoadChildren
             * @fires loadChildrenStart
             * @fires beforeRequest
             * @fires loadChildren
             * @fires exception
             * @fires afterRequest
             * @category CRUD
             */

          }, {
            key: "loadChildren",
            value: function () {
              var _loadChildren = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(parentRecord) {
                var me;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        me = this;
                        return _context.abrupt("return", me.internalLoad(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, me.parentIdParamName, parentRecord.id), 'Children', function (event) {
                          event.parentRecord = parentRecord; // Append received children

                          parentRecord.data[parentRecord.constructor.childrenField] = event.data;
                          parentRecord.processChildren(parentRecord.stores);
                        }));

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              return function loadChildren(_x) {
                return _loadChildren.apply(this, arguments);
              };
            }()
            /**
             * Commits all changes (added, modified and removed) using corresponding urls ({@link #config-createUrl},
             * {@link #config-updateUrl} and {@link #config-deleteUrl})
             * @fires beforeCommit
             * @returns {Promise} A Promise which is resolved only if all pending changes (Create, Update and Delete) successfully resolve.
             * Both the resolve and reject functions are passed a `commitState` object which is stored the {@link #event-afterRequest}
             * event for each request. Each event contains the `exception`, `request` and `response` properties eg:
             *
             *     {
             *          success: true,                  // If *all* commits succeeded
             *          changes: {
             *              added: [records...],
             *              modified: [records...],
             *              removed: [records...],
             *          },
             *          added: {
             *              source: theStore,
             *              exception: true,            // Only if the add request triggered an exception
             *              exceptionType: 'server'/'network', // Only if the add request triggered an exception
             *              response: Response,
             *              json: parsedResponseObject
             *          },
             *          modified: {},                   // Same format as added
             *          removed: {}                     // Same format as added
             *     }
             *
             * If there were no pending changes, the resolve and reject functions are passed no parameters.
             *
             * Returns `false` if a commit operation is already in progress.
             * The resolved function is passed the event object passed to any event handlers.
             * The rejected function is passed the {@link #event-exception} event if an exception occurred,
             * @category CRUD
             */

          }, {
            key: "commit",
            value: function commit() {
              var me = this,
                  changes = me.changes,
                  allPromises = []; // not allowing additional commits while in progress
              // TODO: should queue

              if (me.commitPromise) return false; // No outstanding changes, return a Promise that resolves immediately.

              if (!changes) {
                return immediatePromise;
              } // Flag all affected records as being committed


              _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(changes.added).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(changes.modified), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(changes.removed)).forEach(function (record) {
                return record.meta.committing = true;
              }); // TODO: do we need a general way of disabling plugins?


              if (!me.disabled && me.trigger('beforeCommit', {
                changes: changes
              }) !== false) {
                var commitState = {
                  action: 'commit',
                  exception: false,
                  changes: changes
                },
                    p = me.commitRemoved(commitState);

                if (p) {
                  allPromises.push(p);
                }

                p = me.commitAdded(commitState);

                if (p) {
                  allPromises.push(p);
                }

                p = me.commitModified(commitState);

                if (p) {
                  allPromises.push(p);
                } // If there were no urls configured, behave as a local store


                if (!allPromises.length) {
                  me.modified.forEach(function (r) {
                    return r.clearChanges(false);
                  });
                  me.modified.clear();
                  me.added.forEach(function (r) {
                    return r.clearChanges(false);
                  });
                  me.added.clear();
                  me.removed.clear();
                  me.trigger('commit', {
                    changes: changes
                  });
                  return immediatePromise;
                } // The Promises from the commit methods all resolve whether the request
                // succeeded or not. They each contribute their afterrequest event to the
                // commitState which can be used to detect overall success or failure
                // and granular inspection of which operations succeeded or failed.
                // If there's only one operation, wait for it.
                // If there's more than one operation, we have to wait for allPromises to resolve.


                p = allPromises.length === 1 ? allPromises[0] : Promise.all(allPromises);
                return me.commitPromise = new Promise(function (resolve, reject) {
                  p.then(function () {
                    me.commitPromise = null;

                    if (commitState.exception) {
                      me.trigger('exception', commitState);
                      reject(commitState);
                    } else {
                      me.trigger('commit', {
                        changes: changes
                      });
                      resolve(commitState);
                    }
                  }).catch(function () {
                    me.commitPromise = null;
                    reject(commitState);
                  });
                });
              }
            } // TODO: need a way to abort commits

            /**
             * Commits added records by posting to {@link #config-createUrl}.
             * Server should return a JSON object with a 'success' property indicating whether the operation was succesful.
             * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
             * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
             * succeeds or fails. The resulting event is placed into the `add` property of the passed `commitState`
             * parameter. If there are no added records, `null` is returned.
             * The resolved function is passed the event object passed to any event handlers.
             * @private
             * @fires beforeRequest
             * @fires commitAdded
             * @fires refresh
             * @fires exception
             * @fires afterRequest
             */

          }, {
            key: "commitAdded",
            value: function commitAdded(commitState) {
              var me = this,
                  added = me.added,
                  event = {
                action: 'create',
                params: me.params
              },
                  result = added.count && me.createUrl ? new Promise(function (resolve) {
                var toAdd = added.values.map(function (r) {
                  return r.persistableData;
                });
                commitState.create = event;
                me.trigger('beforeRequest', event);
                var dataToSend = {
                  data: toAdd
                };

                if (me.sendAsFormData) {
                  var formData = new FormData();
                  formData.append('data', JSON.stringify(toAdd));
                  dataToSend = formData;
                }

                _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].post(me.createUrl + me.buildQueryString(me.params), dataToSend, Object.assign({
                  headers: me.headers,
                  parseJson: true
                }, me.fetchOptions)).then(function (response) {
                  var data = response.parsedJson,
                      isArray = Array.isArray(data),
                      success = isArray || data && data.success !== false;
                  event.json = data;
                  event.response = response;

                  if (success) {
                    // Copy updated fields and updated ID back into records
                    me.processReturnedData(added.values, isArray ? data : data[me.responseDataProperty]);
                    me.added.forEach(function (r) {
                      return r.clearChanges(false);
                    });
                    added.clear();
                    me.trigger('commitAdded'); // We must signal a full refresh because any number of records could have recieved any number of field updates
                    // back from the server, so a refresh is more efficient than picking through the received updates.

                    me.trigger('refresh', event);
                    resolve(commitState);
                  } else {
                    // Clear committing flag
                    added.forEach(function (r) {
                      return r.meta.committing = false;
                    });
                    commitState.exception = event.exception = true;
                    commitState.exceptionType = event.exceptionType = 'server';
                    me.trigger('exception', event);
                    resolve(commitState);
                  } // finally


                  me.trigger('afterRequest', event);
                }).catch(function (responseOrError) {
                  // Clear committing flag
                  added.forEach(function (r) {
                    return r.meta.committing = false;
                  });
                  commitState.exception = event.exception = true;

                  if (responseOrError instanceof Response) {
                    event.exceptionType = responseOrError.ok ? 'server' : 'network';
                    event.response = responseOrError;
                    event.error = responseOrError.error;
                  } else {
                    event.exceptionType = 'server';
                    event.error = responseOrError;
                  }

                  me.trigger('exception', event);
                  resolve(commitState); // finally

                  me.trigger('afterRequest', event);
                });
              }) : null;
              return result;
            }
            /**
             * Commits modified records by posting to {@link #config-updateUrl}.
             * Server should return a JSON object with a 'success' property indicating whether the operation was succesful.
             * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
             * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
             * succeeds or fails. The resulting event is placed into the `update` property of the passed `commitState`
             * parameter. If there are no added records, `null` is returned.
             * The resolved function is passed the event object passed to any event handlers.
             * @private
             * @fires beforeRequest
             * @fires commitModified
             * @fires refresh
             * @fires exception
             * @fires afterRequest
             */

          }, {
            key: "commitModified",
            value: function commitModified(commitState) {
              var me = this,
                  modified = me.modified,
                  event = {
                action: 'update',
                params: me.params
              },
                  result = modified.count && me.updateUrl ? new Promise(function (resolve) {
                var modifications = modified.map(function (r) {
                  return me.writeAllFields ? r.persistableData : r.modifications;
                });
                commitState.update = event;
                me.trigger('beforeRequest', event);
                var dataToSend = {
                  data: modifications
                };

                if (me.sendAsFormData) {
                  var formData = new FormData();
                  formData.append('data', JSON.stringify(modifications));
                  dataToSend = formData;
                }

                _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].post(me.updateUrl + me.buildQueryString(me.params), dataToSend, Object.assign({
                  headers: me.headers,
                  parseJson: true
                }, me.fetchOptions)).then(function (response) {
                  var data = response.parsedJson,
                      isArray = Array.isArray(data),
                      success = isArray || data && data.success !== false;
                  event.json = data;
                  event.response = response;

                  if (success) {
                    // Copy updated fields and updated ID back into records
                    me.processReturnedData(me.modified.values, isArray ? data : data[me.responseDataProperty], true); // Clear down modified fields cache

                    modified.forEach(function (r) {
                      return r.clearChanges(false);
                    });
                    modified.clear();
                    me.trigger('commitModified'); // We must signal a full refresh because any number of records could have recieved any number of field updates
                    // back from the server, so a refresh is more efficient than picking through the received updates.

                    me.trigger('refresh', event);
                    resolve(commitState);
                  } else {
                    // Clear committing flag
                    modified.forEach(function (r) {
                      return r.meta.committing = false;
                    });
                    commitState.exception = event.exception = true;
                    event.exceptionType = 'server';
                    me.trigger('exception', event);
                    resolve(commitState);
                  } // finally


                  me.trigger('afterRequest', event);
                }).catch(function (responseOrError) {
                  // Clear committing flag
                  modified.forEach(function (r) {
                    return r.meta.committing = false;
                  });
                  commitState.exception = event.exception = true;

                  if (responseOrError instanceof Response) {
                    event.exceptionType = responseOrError.ok ? 'server' : 'network';
                    event.response = responseOrError;
                    event.error = responseOrError.error;
                  } else {
                    event.exceptionType = 'server';
                    event.error = responseOrError;
                  }

                  me.trigger('exception', event);
                  resolve(commitState); // finally

                  me.trigger('afterRequest', event);
                });
              }) : null;
              return result;
            }
          }, {
            key: "processReturnedData",
            value: function processReturnedData(localRecords, returnedData) {
              var isUpdating = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  Model = me.modelClass,
                  idDataSource = Model.fieldMap.id.dataSource;
              returnedData.forEach(function (recData, i) {
                // Using syncId to update record's id with no flagging the property as modified.
                localRecords[i].syncId(recData[idDataSource]); // When updating, only want to apply the actual changes and not reapply defaults. When adding, also
                // apply the defaults

                Object.assign(localRecords[i].data, Model.processData(recData, isUpdating));
              });
            }
            /**
             * Commits removed records by posting to {@link #config-deleteUrl}.
             * Server should return a JSON object with a 'success' property indicating whether the operation was succesful.
             * @param {Object} commitState An object into which is added a `delete` property being the {@link #event-afterRequest} event.
             * @returns {Promise} If there are added records, a Promise which will be resolved whether the commit
             * succeeds or fails. The resulting event is placed into the `delete` property of the passed `commitState`
             * parameter. If there are no added records, `null` is returned.
             * The resolved function is passed the event object passed to any event handlers.
             * @private
             * @fires beforerequest
             * @fires commitremoved
             * @fires refresh
             * @fires exception
             * @fires afterrequest
             */

          }, {
            key: "commitRemoved",
            value: function commitRemoved(commitState) {
              var me = this,
                  removed = me.removed,
                  event = {
                action: 'delete',
                params: me.params
              },
                  result = removed.count && me.deleteUrl ? new Promise(function (resolve) {
                commitState.delete = event;
                me.trigger('beforeRequest', event);
                var dataToSend = {
                  ids: removed.map(function (r) {
                    return r.id;
                  })
                };

                if (me.sendAsFormData) {
                  var formData = new FormData();
                  formData.append('id', JSON.stringify(dataToSend.ids));
                  dataToSend = formData;
                }

                _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].post(me.deleteUrl + me.buildQueryString(me.params), dataToSend, Object.assign({
                  headers: me.headers,
                  parseJson: true
                }, me.fetchOptions)).then(function (response) {
                  var data = response.parsedJson,
                      isArray = Array.isArray(data),
                      success = isArray || data && data.success !== false;
                  event.json = data;
                  event.response = response;

                  if (success) {
                    removed.forEach(function (record) {
                      return record.meta.committing = false;
                    }); // In case used by other store etc.

                    removed.clear();
                    me.trigger('commitRemoved');
                    me.trigger('refresh', event);
                    resolve(commitState);
                  } else {
                    // Clear committing flag
                    removed.forEach(function (r) {
                      return r.meta.committing = false;
                    });
                    commitState.exception = event.exception = true;
                    event.exceptionType = 'server';
                    me.trigger('exception', event);
                    resolve(commitState);
                  } // finally


                  me.trigger('afterRequest', event);
                }).catch(function (responseOrError) {
                  // Clear committing flag
                  removed.forEach(function (r) {
                    return r.meta.committing = false;
                  });
                  commitState.exception = event.exception = true;

                  if (responseOrError instanceof Response) {
                    event.exceptionType = responseOrError.ok ? 'server' : 'network';
                    event.response = responseOrError;
                    event.error = responseOrError.error;
                  } else {
                    event.exceptionType = 'server';
                    event.error = responseOrError;
                  }

                  me.trigger('exception', event);
                  resolve(commitState); // finally

                  me.trigger('afterRequest', event);
                });
              }) : null;
              return result;
            }
          }, {
            key: "isLoading",
            get: function get() {
              return this._isLoading;
            }
            /**
             * Returns true if the Store is currently committing
             * @property {Boolean}
             * @readonly
             * @category CRUD
             */

          }, {
            key: "isCommitting",
            get: function get() {
              return Boolean(this.commitPromise);
            }
          }], [{
            key: "defaultConfig",
            // region Events

            /**
             * Fired when a remote request fails, either at the network level, or the server returns a failure, or an invalid response.
             *
             * Note that when a {@link #function-commit} fails, more than one exception event will be triggered. The individual operation,
             * `create`, `update` or `delete` will trigger their own `exception` event, but the encapsulating commit operation will also
             * trigger an `exception` event when all the operations have finished, so if exceptions are going to be handled gracefully,
             * the event's `action` property must be examined, and the constituent operations of the event must be examined.
             * @event exception
             * @param {Common.data.Store} source This Store
             * @param {Boolean} exception `true`
             * @param {String} action Action that failed, `'create'`, `'read'`, `'update'` or `'delete'`. May also be fired
             * with '`commit'` to indicate the failure of an aggregated `create`, `update` and `delete` operation. In this case,
             * the event will contain a property for each operation of the commit named `'create'`, `'update'` and `'delete'`,
             * each containing the individual `exception` events.
             * @param {String} exceptionType The type of failure, `'network'` or `'server'`
             * @param {Response} response the `Response` object
             * @param {Object} json The decoded response object *if the exceptionType is `'server'`*
             */

            /**
             * Fired after committing added records
             * @event commitAdded
             * @param {Common.data.Store} source This Store
             */

            /**
             * Fired after committing modified records
             * @event commitModified
             * @param {Common.data.Store} source This Store
             */

            /**
             * Fired on successful load
             * @event load
             * @param {Common.data.Store} source This Store
             * @param {Object[]} data Data loaded
             * @param {Response} response the `Response` object
             * @param {Object} json The decoded response object.
             */

            /**
             * Fired on successful load of remote child nodes for a tree node.
             * @event loadChildren
             * @param {Common.data.Store} source This Store
             * @param {Object[]} data Data loaded
             * @param {Object} json The decoded response object.
             */

            /**
             * Fired after committing removed records
             * @event commitRemoved
             * @param {Common.data.Store} source This Store
             */

            /**
             * Fired before loading starts. Allows altering parameters and is cancelable
             * @event beforeLoad
             * @param {Common.data.Store} source This Store
             * @param {Object} params An object containing property/name pairs which are the parameters.
             * This may be mutated to affect the parameters used in the Ajax requet.
             */

            /**
             * Fired before loading of remote child nodes of a tree node starts. Allows altering parameters and is cancelable
             * @event beforeLoadChildren
             * @param {Common.data.Store} source This Store
             * @param {Object} params An object containing property/name pairs which are the parameters.
             * This may be mutated to affect the parameters used in the Ajax requet.
             */

            /**
             * Fired when loading is beginning. This is not cancelable. Parameters in the event may still be
             * mutated at this stage.
             * @event loadStart
             * @param {Common.data.Store} source This Store
             * @param {Object} params An object containing property/name pairs which are the parameters.
             * This may be mutated to affect the parameters used in the Ajax requet.
             */

            /**
             * Fired when loading of remote child nodes into a tree node is beginning. This is not cancelable. Parameters in the event may still be
             * mutated at this stage.
             * @event loadChildrenStart
             * @param {Common.data.Store} source This Store
             * @param {Object} params An object containing property/name pairs which are the parameters.
             * This may be mutated to affect the parameters used in the Ajax requet.
             */

            /**
             * Fired before any remote request is initiated.
             * @event beforeRequest
             * @param {Common.data.Store} source This Store
             * @param {String} action Action that is making the request, `'create'`, `'read'`, `'update'` or `'delete'`
             */

            /**
             * Fired after any remote request has finished whether successfully or unsuccessfully.
             * @event afterRequest
             * @param {Boolean} exception `true`. *Only present if the request triggered an exception.*
             * @param {String} action Action that has finished, `'create'`, `'read'`, `'update'` or `'delete'`
             * @param {String} exceptionType The type of failure, `'network'` or `'server'`. *Only present if the request triggered an exception.*
             * @param {Response} response The `Response` object
             * @param {Object} json The decoded response object if there was no `'network'` exception.
             */
            // endregion
            //region Config
            get: function get() {
              return {
                /**
                 * An object containing the HTTP headers to add to each server request issued by this Store.
                 * @config {Object}
                 * @default
                 */
                headers: null,

                /**
                 * An object containing the Fetch options to pass to each server request issued by this Store. Use this to control if credentials are sent
                 * and other options, read more at [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch).
                 * @config {Object}
                 * @default
                 */
                fetchOptions: null,

                /**
                 * Specify `true` to send payloads as form data, `false` to send as regular JSON.
                 * @config {Boolean}
                 * @default
                 */
                sendAsFormData: false,

                /**
                 * Specify `true` to send all model fields when committing modified records (as opposed to just the modified fields)
                 * @config {Boolean}
                 * @default
                 */
                writeAllFields: false,

                /**
                 * The name of the HTTP parameter passed to this Store's {@link #config-readUrl} to indicate the node `id` to
                 * load when loading child nodes on demand if the node being expanded was created with data containing `children: true`.
                 * @config {String}
                 * @default
                 */
                parentIdParamName: 'id',

                /**
                 * The property name in JSON responses from the server that contains the data for the records
                 * ```
                 * {
                 *   "success" : true,
                 *   // The property name used here should match that of 'reponseDataProperty'
                 *   "data" : [
                 *     ...
                 *   ]
                 * }
                 * ```
                 * @config {String}
                 * @default
                 */
                responseDataProperty: 'data'
              };
            }
          }]);

          return AjaxStore;
        }(_Store_js__WEBPACK_IMPORTED_MODULE_17__["default"]);

        AjaxStore._$name = 'AjaxStore';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/DomDataStore.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/data/DomDataStore.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataDomDataStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DomDataStore;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);

        var productName = 'scheduler';
        /**
        * @module Common/data/DomDataStore
        */

        /**
         * Stores data on a dom element (by setting element._domData).
         * Instead of using HTML5:s element.dataset, which turned out to be slow.
         * @private
         */

        var DomDataStore =
        /*#__PURE__*/
        function () {
          function DomDataStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DomDataStore);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DomDataStore, null, [{
            key: "get",

            /**
             * Get data that is connected to specified element.
             * @param {HTMLElement} element DOM element
             * @param {String} [key] The name of the property in the element data to return;
             * @returns {Object} Data
             */
            value: function get(element, key) {
              var result = element._domData || (element._domData = {});

              if (key != null) {
                return result[key];
              }

              return result;
            }
            /**
             * Set data connected to specified element (completely replacing any existing).
             * To update data, use DomDataStore#assign instead.
             * @param {HTMLElement} element DOM element
             * @param {Object|String} data Data object to set, or property name to set
             * @param {*} [value] If the previous parameter was a property name, this is the value to set.
             */

          }, {
            key: "set",
            value: function set(element, data, value) {
              if (arguments.length === 3) {
                (element._domData || (element._domData = {}))[data] = value;
              } else {
                element._domData = data;
              }
            }
            /**
             * Updates data connected to specified element.
             * @param element DOM element
             * @param data Data to assign
             */

          }, {
            key: "assign",
            value: function assign(element, data) {
              Object.assign(element._domData || (element._domData = {}), data);
            }
          }]);

          return DomDataStore;
        }();

        DomDataStore._$name = 'DomDataStore';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/Model.js":
      /*!****************************************!*\
        !*** ../Grid/lib/Common/data/Model.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Model;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_reflect_own_keys__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.own-keys */
        "../Grid/node_modules/core-js/modules/es6.reflect.own-keys.js");
        /* harmony import */


        var core_js_modules_es6_reflect_own_keys__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_own_keys__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ./stm/mixin/ModelStm.js */
        "../Grid/lib/Common/data/stm/mixin/ModelStm.js");
        /* harmony import */


        var _mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ./mixin/TreeNode.js */
        "../Grid/lib/Common/data/mixin/TreeNode.js");

        var productName = 'scheduler';

        var internalProps = {
          children: 1,
          data: 1,
          meta: 1
        },
            emptyObject = {},
            convertDate = function convertDate(date) {
          if (!(date instanceof Date)) {
            date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].parse(date, this.format || this.dateFormat);
          } // if parsing has failed, we would like to return `undefined` to indicate the "absence" of data
          // instead of `null` (presence of "empty" data)


          return date || undefined;
        },
            isEqual = function isEqual(field, oldValue, value) {
          // using fn to keep field scope
          return field && field.isEqual ? field.isEqual(oldValue, value) : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isEqual(oldValue, value);
        },
            nullFn = function nullFn() {};
        /**
         * @module Common/data/Model
         */

        /**
         * A Model is a definition for a record in a store. It defines which fields the data contains and exposes an interface
         * to access and manipulate that data. Models are created from json objects, the raw json is stored in `Model#data`.
         *
         * ## Defining fields
         * A Model can either define its fields explicitly or have them created from its data. This snippet shows a model with
         * two fields:
         *
         * ```
         * class Person extends Model {
         *   static get fields() {
         *     return [
         *       'name',
         *       { name : 'birthday', type : 'date', dateFormat : 'YYYY-MM-DD' },
         *       { name : 'shoeSize', type : 'number', defaultValue : 11 },
         *       { name : 'age', readOnly : true }
         *     ];
         * }
         * ```
         *
         * The first field (name) has an unspecified type, which is fine in most cases since this is JavaScript. The second
         * field (birthday) is defined to be a date, which will make the model parse any supplied value into an actual date.
         * Currently date is the only specified type available.
         *
         * You can also set a defaultValue that will be used if the data doesn't contain a value for the field.
         *
         * ```
         *       { name : 'shoeSize', type : 'number', defaultValue : 11 }
         * ```
         *
         * To create a record from a Model, supply data to its constructor:
         *
         * ```
         * let guy = new Person({
         *   id       : 1,
         *   name     : 'Dude',
         *   birthday : '2014-09-01'
         * });
         * ```
         *
         * If no id is specified, a temporary id will be generated.
         *
         * ## Persisting fields
         * By default all fields are persisted. If you don't want particular field to get saved to the server, configure it with
         * `persist: false`. In this case field will not be among changes which are sent by
         * {@link Common/data/AjaxStore#function-commit store.commit()}, otherwise its behavior doesn't change.
         *
         * ```
         * class Person extends Model {
         *     static get fields() {
         *         return [
         *             'name',
         *             { name : 'age', persist : false }
         *         ];
         *     }
         * }
         * ```
         *
         * ## Id field
         * By default Model expects its id to be stored in a field named "id". The name of the field can be customized by
         * setting {@link #property-idField-static}:
         *
         * ```
         * // Id drawn from 'id' property by default; use custom field here
         * Person.idField = 'personId';
         *
         * let girl = new Person({
         *    personId : 2,
         *    name     : 'Lady',
         *    birthday : '2011-11-05'
         * });
         * ```
         *
         * ## Getting and setting values
         * Fields are used to generate getters and setters on the records. Use them to access or modify values (they are
         * reactive):
         *
         * ```
         * console.log(guy.name);
         * girl.birthday = new Date(2011,10,6);
         * ```
         *
         * NOTE: In an application with multiple different models you should subclass Model, since the prototype is decorated
         * with getters and setters. Otherwise you might got unforeseen collisions.
         *
         * ## Field data mapping
         * By default fields are mapped to data using their name. If you for example have a "name" field it expects data to be
         * `{ name: 'Some name' }`. If you need to map it to some other property, specify `dataSource` in your field definition:
         *
         * ```
         * class Person extends Model {
         *   static get fields {
         *     return [
         *       { name : 'name', dataSource : 'TheName' }
         *     ];
         * }
         *
         * // This is now OK:
         * let dude = new Person({ TheName : 'Manfred' });
         * console.log(dude.name); // --> Manfred
         * ```
         *
         * ## Tree API
         * This class mixes in the {@link Common/data/mixin/TreeNode TreeNode} mixin which provides an API for tree related functionality (only relevant if your
         * store is configured to be a {@link Common/data/Store#config-tree tree}).
         *
         * @mixes Common/data/mixin/TreeNode
         * @mixes Common/data/stm/mixin/ModelStm
         */


        var Model =
        /*#__PURE__*/
        function (_TreeNode) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(Model, _TreeNode);

          function Model() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, Model);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Model).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(Model, [{
            key: "construct",

            /**
             * Unique identifier for the record. Might be mapped to another dataSource using idField, but always exposed as
             * record.id. Will get a generated value if none is specified in records data.
             * @member {String|Number} id
             * @category Identification
             */
            //region Init

            /**
             * Constructs a new record from the supplied data.
             * @param {Object} [data] Raw data
             * @param {Common.data.Store} [store] Data store
             * @param {Object} [meta] Meta data
             * @function constructor
             * @category Misc
             */
            value: function construct() {
              var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var meta = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var skipExpose = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var me = this,
                  constructor = me.constructor,
                  fieldMap = constructor.fieldMap,
                  stores = store ? Array.isArray(store) ? store : [store] : [];
              store = stores[0];
              me.meta = Object.assign({
                modified: {}
              }, constructor.metaConfig, meta); // null passed to Base construct inhibits config processing.

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Model.prototype), "construct", this).call(this, null); // make getters/setters for fields, needs to be done before processing data to make sure defaults are available


              if (skipExpose) {
                if (!constructor.hasOwnProperty('fieldMap')) {
                  constructor.exposeProperties();
                }
              } else {
                constructor.exposeProperties(data);
              } // It's only valid to do this once, on construction of the first instance


              if (!constructor.hasOwnProperty('idFieldProcessed')) {
                // idField can be overridden from meta, or from the store if we have not had an idField set programmatically
                // and if we have not had an id field defined above the base Model class level.
                var overriddenIdField = me.meta.idField;

                if (!overriddenIdField) {
                  // Might have been set to Model after construction but before load
                  if (constructor._assignedIdField) {
                    overriddenIdField = constructor.idField;
                  } // idField on store was deprecated, but should still work to not break code
                  // TODO: Remove in 3.0? Or reintroduce it...
                  else if (store) {
                      overriddenIdField = store.idField;
                    }
                } // If it's overridden to something different than we already have, replace the 'id' field in the fieldMap


                if (overriddenIdField && overriddenIdField !== fieldMap.id.dataSource) {
                  constructor.createFieldDefinition({
                    name: 'id',
                    dataSource: overriddenIdField
                  });
                }

                constructor.idFieldProcessed = true;
              } // assign internalId, unique among all records


              me._internalId = Model._internalIdCounter++; // relation code expects store to be available for relation lookup, but actual join done below

              me.stores = []; // Superclass constructors may set this in their own way before this is called.

              if (!me.originalData) {
                me.originalData = data;
              } // Store configured with useRawData guarantees that data does not need processing (no default values will be
              // applied, no type conversion will take place)


              if (store && store.useRawData) {
                me.data = data;
              } else {
                me.data = constructor.processData(data);
              }

              if (me.id === undefined) {
                // Assign a generated id silently, record should not be considered modified
                me.setData('id', me.generateId());
              }

              if (me.data[constructor.childrenField]) {
                me.processChildren(stores);
              }

              me.generation = 0;
            }
            /**
             * Processes raw data, converting values and setting defaults.
             * @private
             * @param {Object} data Raw data
             * @param {Boolean} [ignoreDefaults] Ignore setting default values, used when updating
             * @returns {Object} Processed data
             * @category Fields
             */

          }, {
            key: "getFieldDefinition",

            /**
             * Convenience function to get the definition for a field from class.
             * @param {String} fieldName Field name
             * @returns {Object}
             * @category Fields
             */
            value: function getFieldDefinition(fieldName) {
              return this.constructor.getFieldDefinition(fieldName);
            }
            /**
             * Get the names of all fields in data.
             * @returns {String[]} Field names
             * @readonly
             * @category Fields
             */

          }, {
            key: "getDataSource",

            /**
             * Get the data source used by specified field. Returns the fieldName if no data source specified.
             * @param {String} fieldName Field name
             * @returns {String}
             * @category Fields
             */
            value: function getDataSource(fieldName) {
              var def = this.constructor.getFieldDefinition(fieldName);
              if (def) return def.dataSource || def.name;
            }
            /**
             * Processes input to a field, converting to expected type.
             * @param {String} fieldName Field dataSource
             * @param {*} value Value to process
             * @returns {*} Converted value
             * @category Fields
             */

          }, {
            key: "initRelations",
            //endregion
            //region Relations

            /**
             * Initializes model relations. Called from store when adding a record.
             * @private
             * @category Relations
             */
            value: function initRelations() {
              var me = this,
                  relations = me.constructor.relations;
              if (!relations) return; // TODO: feels strange to have to look at the store for relation config but didn't figure out anything better.
              // TODO: because other option would be to store it on each model instance, not better...

              me.stores.forEach(function (store) {
                if (!store.modelRelations) store.initRelations(); // TODO: not at all tested for multiple stores, can't imagine it works as is

                var relatedRecords = [];
                store.modelRelations && store.modelRelations.forEach(function (config) {
                  relatedRecords.push({
                    related: me.initRelation(config),
                    config: config
                  });
                });
                store.updateRecordRelationCache(me, relatedRecords);
              });
            }
            /**
             * Initializes/updates a single relation.
             * @param config Relation config
             * @returns {Common.data.Model} Related record
             * @private
             * @category Relations
             */

          }, {
            key: "initRelation",
            value: function initRelation(config) {
              var me = this,
                  keyValue = me.get(config.fieldName),
                  foreign = keyValue !== undefined && typeof config.store !== 'string' && config.store.getById(keyValue),
                  placeHolder = {
                id: keyValue,
                placeHolder: true
              };
              if (!me.meta.relationCache) me.meta.relationCache = {}; // apparently scheduler tests expect cache to work without matched related record, thus the placeholder

              me.meta.relationCache[config.relationName] = foreign || (keyValue != null ? placeHolder : null);
              return foreign;
            }
          }, {
            key: "removeRelation",
            value: function removeRelation(config) {
              // (have to check for existence before deleting to work in Safari)
              if (this.meta.relationCache[config.relationName]) {
                delete this.meta.relationCache[config.relationName];

                if (config.nullFieldOnRemove) {
                  // Setting to null silently, to not trigger additional relation behaviour
                  this.setData(config.fieldName, null);
                }
              }
            }
          }, {
            key: "getForeign",
            value: function getForeign(name) {
              return this.meta.relationCache && this.meta.relationCache[name];
            }
          }, {
            key: "setForeign",
            value: function setForeign(name, value, config) {
              var id = Model.asId(value);
              return this.set(config.fieldName, id);
            } //endregion
            //region Get/set values, data handling

            /**
             * Get value for specified field name. You can also use the generated getters if loading through a Store.
             * If model is currently in batch operation this will return updated batch values which are not applied to Model
             * until endBatch() is called.
             * @param {String} fieldName Field name to get value from
             * @returns {*} Fields value
             * @category Fields
             */

          }, {
            key: "get",
            value: function get(fieldName) {
              var me = this,
                  recData = me.meta.batchChanges ? Object.assign({}, me.data, me.meta.batchChanges) : me.data,
                  field = me.constructor.fieldMap[fieldName],
                  dataSource = field ? field.dataSource : fieldName;

              if (dataSource) {
                if (field && field.complexMapping) {
                  return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].getPath(recData, dataSource);
                }

                return dataSource in recData ? recData[dataSource] : recData[fieldName];
              }
            }
            /**
             * Internal function used to update a records underlying data block (record.data) while still respecting field
             * mappings. Needed in cases where a field needs setting without triggering any associated behaviour and it has a
             * dataSource with a different name.
             *
             * For example:
             * ```javascript
             * // startDate mapped to data.beginDate
             * { name : 'startDate', dataSource : 'beginDate' }
             *
             * // Some parts of our code needs to update the data block without triggering any of the behaviour associated with
             * // calling set. This would then not update "beginDate":
             * record.data.startDate = xx;
             *
             * // But this would
             * record.setData('startDate', xx);
             * ```
             * @internal
             * @category Editing
             */

          }, {
            key: "setData",
            value: function setData(fieldName, value) {
              var field = this.constructor.fieldMap[fieldName],
                  dataSource = field ? field.dataSource : fieldName;

              if (dataSource) {
                _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].setPath(this.data, dataSource, value);
              }
            }
            /**
             * Silently updates record's id with no flagging the property as modified.
             * Triggers onModelChange event for changed id.
             * @param {String|Number} value id value
             * @private
             */

          }, {
            key: "syncId",
            value: function syncId(value) {
              var oldValue = this.id;

              if (oldValue !== value) {
                this.setData('id', value);
                var data = {
                  id: {
                    value: value,
                    oldValue: oldValue
                  }
                };
                this.triggerChanges(data, data);
              }
            }
            /**
             * Set value for the specified field. You can also use the generated setters if loading through a Store.
             * @param {String|Object} field The field to set value for, or an object with multiple values to set in one call
             * @param {*} value Value to set
             * @param {Boolean} [silent] Set to true to not trigger events
             * @fires Store#idChange
             * @fires Store#update
             * @fires Store#change
             * @example
             * person.set('name', 'Donald');
             * @category Editing
             */

          }, {
            key: "set",
            value: function set(field, value) {
              var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var fromRelationUpdate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var me = this; // We use beforeSet/inSet/afterSet approach here because mixin interested in overriding set() method
              // like STM, for example, might be mixed before Model class or after. In general I have no control over this.
              // STM mixed before, so the only option to wrap set() method body is actually to call
              // beforeSet()/afterSet().

              if (me.isBatchUpdating) {
                me.inBatchSet(field, value);
                return null;
              } else {
                var preResult = me.beforeSet ? me.beforeSet(field, value, silent, fromRelationUpdate) : undefined,
                    wasSet = me.inSet(field, value, silent, fromRelationUpdate);
                me.afterSet && me.afterSet(field, value, silent, fromRelationUpdate, preResult, wasSet);
                return wasSet;
              }
            }
          }, {
            key: "fieldToKeys",
            value: function fieldToKeys(field, value) {
              var result;

              if (typeof field !== 'string') {
                result = {}; // will get in trouble when setting same field on multiple models without this

                Reflect.ownKeys(field).forEach(function (key) {
                  return result[key] = field[key];
                });
              } else {
                result = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_8___default()({}, field, value);
              }

              return result;
            }
          }, {
            key: "inBatchSet",
            value: function inBatchSet(field, value) {
              var _this = this;

              var toSet = this.fieldToKeys(field, value);
              Object.keys(toSet).forEach(function (key) {
                // Store batch changes
                _this.meta.batchChanges[key] = _this.constructor.processField(key, toSet[key]);
              });
            }
          }, {
            key: "inSet",
            value: function inSet(field, value, silent, fromRelationUpdate) {
              var me = this,
                  fieldMap = me.constructor.fieldMap,
                  myProto = me.constructor.prototype,
                  data = me.data,
                  wasSet = {},
                  toSet = me.fieldToKeys(field, value);
              var changed = false; // Give a chance to cancel action before records updated.

              if (!silent && !me.triggerBeforeUpdate(toSet)) {
                return null;
              }

              Object.keys(toSet).forEach(function (key) {
                var field = fieldMap[key],
                    readOnly = field && field.readOnly,
                    mapping = field ? field.dataSource : key,
                    useProp = !field && key in myProto,
                    oldValue = useProp ? me[mapping] : _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].getPath(data, mapping),
                    value = me.constructor.processField(key, toSet[key]),
                    val = toSet[key] = {
                  value: value
                },
                    relation = me.getRelationConfig(key);

                if (!readOnly && !isEqual(field, oldValue, value)) {
                  // Indicate to observers that data has changed.
                  me.generation++;
                  val.oldValue = oldValue;
                  changed = true; // changing back to old value? remove from modified
                  // `modified` should contain mapped field name, it is used in sync

                  if (isEqual(field, me.meta.modified[key], value)) {
                    delete me.meta.modified[key];
                  } else {
                    // store info on modification
                    me.meta.modified[key] = oldValue;

                    if (val.oldValue === undefined && 'oldValue' in val) {
                      delete val.oldValue;
                    }
                  } // The wasSet object keys must be the field *name*, not its dataSource.


                  wasSet[key] = val; // If we don't have a field, but we have a property defined
                  // eg, the fullDuration property defined in TaskModel, then
                  // use the property

                  if (useProp) {
                    me[key] = value;
                  } // Otherwise, push the value through into the data.
                  else {
                      _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].setPath(data, mapping, value);
                    } // changing foreign key


                  if (relation && !fromRelationUpdate) {
                    me.initRelation(relation);
                    me.stores.forEach(function (store) {
                      return store.cacheRelatedRecord(me, value, relation.relationName, val.oldValue);
                    });
                  }
                } else {
                  delete toSet[key];
                }
              });

              if (changed) {
                me.afterChange(toSet, wasSet, silent);
              }

              return changed ? wasSet : null;
            }
          }, {
            key: "afterChange",
            value: function afterChange(toSet, wasSet, silent) {
              var me = this; // TODO: these lines of logic should move to store

              me.stores.forEach(function (store) {
                // add or removed from modified
                if (me.isModified) {
                  if (!store.modified.includes(me) && !store.added.includes(me)) {
                    store.modified.add(me);

                    if (store.autoCommit) {
                      store.commit();
                    }
                  }
                } else {
                  store.modified.remove(me);
                }
              });

              if (!silent) {
                me.triggerChanges(toSet, wasSet);
              }
            }
            /**
             * True if this model has any uncommitted changes.
             * @property {Boolean}
             * @readonly
             * @category Editing
             */

          }, {
            key: "isFieldModified",

            /**
             * Returns true if this model has uncommitted changes for the provided field.
             * @param {String} fieldName Field name
             * @returns {Boolean} True if the field is changed
             */
            value: function isFieldModified(fieldName) {
              return this.isModified && this.meta.modified[fieldName];
            }
            /**
             * Returns field value that should be persisted, or `undefined` if field is configured with `persist: false`.
             * @param {String} name Name of the field to get value
             * @private
             * @category Fields
             */

          }, {
            key: "getFieldPersistentValue",
            value: function getFieldPersistentValue(name) {
              var field = this.getFieldDefinition(name);
              var result;

              if (!field || field.persist) {
                result = this[name]; // if serialize function is provided we use it to prepare the persistent value

                if (field && field.serialize) {
                  result = field.serialize.call(this, result, this);
                }
              }

              return result;
            }
            /**
             * Get modifications in form of an object.
             * @property {Object}
             * @readonly
             * @category Editing
             */

          }, {
            key: "clearChanges",

            /**
             * Clear stored changes, used on commit. Does not revert changes.
             * @param {Boolean} [removeFromStoreChanges] Update related stores modified collection or not
             * @param {Boolean} [includeDescendants] Set true to clear store descendants
             * @category Editing
             * @private
             */
            value: function clearChanges() {
              var removeFromStoreChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var includeDescendants = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var me = this,
                  meta = me.meta;
              meta.modified = {};
              meta.committing = false;

              if (removeFromStoreChanges) {
                me.stores.forEach(function (store) {
                  store.modified.remove(me);
                  store.added.remove(me);

                  if (includeDescendants) {
                    var descendants = store.collectDescendants(me).all;
                    store.added.remove(descendants);
                    store.modified.remove(descendants);
                  }
                });
              }
            } //endregion
            //region Id

            /**
             * Gets the records internalId. It is assigned during creation, guaranteed to be globally unique among models.
             * @property {Number}
             * @category Identification
             */

          }, {
            key: "generateId",

            /**
             * Generates id for new record which starts with _generated.
             * @category Identification
             */
            value: function generateId() {
              if (!this.constructor.generatedIdIndex) this.constructor.generatedIdIndex = 0;
              return '_generated' + this.$name + ++this.constructor.generatedIdIndex;
            }
            /**
             * Gets the id of specified model or the value if passed string/Number.
             * @param {Common.data.Model|String|Number} model
             * @returns {String|Number} id
             * @category Identification
             */

          }, {
            key: "toJSON",

            /**
             * Used by JSON.stringify to correctly convert this record to json. No point in calling it directly.
             * @private
             * @category Misc
             */
            value: function toJSON() {
              return this.data;
            } //endregion
            //region Batch

            /**
             * True if this Model is currently batching its changes.
             * @property {Boolean}
             * @readonly
             * @category Editing
             */

          }, {
            key: "beginBatch",

            /**
             * Begin a batch, which stores changes and commits them when the batch ends.
             * Prevents events from being fired during batch.
             * ```
             * record.beginBatch();
             * record.name = 'Mr Smith';
             * record.team = 'Golden Knights';
             * record.endBatch();
             * ```
             * Please note that you can also set multiple fields in a single call using {@link #function-set}, which in many
             * cases can replace using a batch:
             * ```
             * record.set({
             *   name : 'Mr Smith',
             *   team : 'Golden Knights'
             * });
             * ```
             * @category Editing
             */
            value: function beginBatch() {
              var me = this;

              if (!me.batching) {
                me.batching = 0;
                me.meta.batchChanges = {};
              }

              me.batching++;
            }
            /**
             * End a batch, triggering events if data has changed.
             * @param {Boolean} [silent] Specify `true` to not trigger events
             * @category Editing
            */

          }, {
            key: "endBatch",
            value: function endBatch() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  parentIdField = me.constructor.parentIdField;

              if (!me.batching) {
                return;
              }

              me.batching--;

              if (me.batching > 0) {
                return;
              } // Set pending batch changes


              if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isEmpty(me.meta.batchChanges)) {
                var batchChanges = Object.assign({}, me.meta.batchChanges);
                me.meta.batchChanges = null; // Move to its new parent before applying the other changes.

                if (batchChanges[parentIdField]) {
                  me.parentId = batchChanges[parentIdField];
                  delete batchChanges[parentIdField];
                }

                me.set(batchChanges, undefined, silent);
                me.cancelBatch();
              }
            }
            /**
             * Cancels current batch operation. Any changes during the batch are discarded.
             * @category Editing
             */

          }, {
            key: "cancelBatch",
            value: function cancelBatch() {
              this.batching = null;
              this.meta.batchChanges = null;
            } //endregion
            //region Events

            /**
             * Triggers beforeUpdate event for each store and checks if changes can be made from event return value.
             * @param {Object} changes Data changes
             * @returns {Boolean} returns true if data changes are accepted
             * @private
             */

          }, {
            key: "triggerBeforeUpdate",
            value: function triggerBeforeUpdate(changes) {
              var _this2 = this;

              return !this.stores.some(function (s) {
                if (s.trigger('beforeUpdate', {
                  record: _this2,
                  changes: changes
                }) === false) {
                  return true;
                }
              });
            }
            /**
             * Triggers idChange, update and change events for each store.
             * @param {Object} toSet Data to be changed
             * @param {Object} wasSet Actually changed data
             * @private
             */

          }, {
            key: "triggerChanges",
            value: function triggerChanges(toSet, wasSet) {
              var _this3 = this;

              this.stores.forEach(function (store) {
                return store.onModelChange(_this3, toSet, wasSet);
              });
            } //endregion
            //region Additional functionality

            /**
             * Makes a copy of this model, assigning the specified id or a generated id.
             * @param {Number|String|Object} [newId] Id to set (or config object), leave out to use generated id or specify false to also copy id
             * @param {Number|String} [newId.id] Id to set, leave out to use generated id or specify false to also copy id
             * @param {Boolean} [newId.deep] True to also clone children
             * @returns {Common.data.Model} Copy of this model
             * @category Editing
             */

          }, {
            key: "copy",
            value: function copy() {
              var newId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var data = Object.assign({}, this.data),
                  returnInstance = true,
                  idField = this.constructor.idField,
                  deep,
                  id,
                  copy;

              if (newId && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default()(newId) === 'object') {
                deep = newId.deep;
                id = newId.id; // Only use id once to avoid collisions

                delete newId.id;
              } else {
                id = newId;
              } // Iterate over instance children, because data may not reflect actual children state


              if (deep && this.children) {
                returnInstance = false;
                data.children = this.children.map(function (child) {
                  return child.copy(newId);
                });
              } else {
                delete data.children;
                delete data.expanded;
              }

              if (id) {
                data[idField] = id;
              } else if (id == null) {
                data[idField] = this.generateId();
              }

              if (returnInstance) {
                copy = new this.constructor(data);
              } else {
                copy = data;
              } // Store original record internal id to lookup from copy later


              copy.originalInternalId = this.internalId;
              return copy;
            }
            /**
             * Removes this record from all stores (and in a tree structure, also from its parent if it has one).
             * @param {Boolean} [silent] Specify `true` to not trigger events
             * @category Editing
             */

          }, {
            key: "remove",
            value: function remove() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  parent = this.parent; // Remove from parent if we're in a tree structure.
              // This informs the owning store(s)

              if (parent) {
                parent.removeChild(me);
              } // Store handles remove
              else if (me.stores.length) {
                  // Not sure what should happen if you try to remove a special row (group row for example), bailing out
                  if (!me.meta.specialRow) {
                    me.stores.forEach(function (s) {
                      return s.remove(me, silent, false, true);
                    });
                  }
                }
            }
            /**
             * Get the first store that this model is assigned to.
             * @returns {Common.data.Store}
             * @category Misc
             */

          }, {
            key: "getRelationConfig",

            /**
             * Get a relation config by name, from the first store.
             * @param {String} name
             * @returns {Object}
             * @private
             * @category Relations
             */
            value: function getRelationConfig(name) {
              // using first store for relations, might have to revise later..
              return this.firstStore && this.firstStore.modelRelations && this.firstStore.modelRelations.find(function (r) {
                return r.fieldName === name;
              });
            } //endregion
            //region Validation

            /**
             * Check if record has valid data. Default implementation returns true, override in your model to do actual validation.
             * @returns {Boolean}
             * @category Editing
             */

          }, {
            key: "joinStore",
            //endregion
            //region Store

            /**
             * Joins this record and any children to specified store, if not already joined.
             * @internal
             * @param {Common.data.Store} store Store to join
             * @category Misc
             */
            value: function joinStore(store) {
              var me = this,
                  stores = me.stores;

              if (!stores.includes(store)) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Model.prototype), "joinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Model.prototype), "joinStore", this).call(this, store);
                store.register(me);
                stores.push(store);
                me.isLoaded && me.children.forEach(function (child) {
                  return child.joinStore(store);
                });
                me.initRelations();
              }
            }
            /**
             * Unjoins this record and any children from specified store, if already joined.
             * @internal
             * @param {Common.data.Store} store Store to join
             * @category Misc
             */

          }, {
            key: "unJoinStore",
            value: function unJoinStore(store) {
              var me = this,
                  stores = me.stores;

              if (stores.includes(store)) {
                store.unregister(me);
                me.children && me.children.forEach(function (child) {
                  return child.unJoinStore(store);
                });
                stores.splice(stores.indexOf(store), 1);
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Model.prototype), "unJoinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Model.prototype), "unJoinStore", this).call(this, store); // remove from relation cache

                store.uncacheRelatedRecord(me);
              }

              if (!stores.length) {
                me.meta.removed = true;
              }
            }
            /**
             * Returns true if this record is contained in the specified store, or in any store if store param is omitted.
             * @internal
             * @param {Common.data.Store} store Store to join
             * @returns {Boolean}
             * @category Misc
             */

          }, {
            key: "isPartOfStore",
            value: function isPartOfStore(store) {
              if (store) {
                return store.indexOf(this) >= 0;
              }

              return this.stores.length > 0;
            } //endregion
            //region Per instance meta

            /**
             * Used to set per external instance meta data. For example useful when using a record in multiple grids to store some state
             * per grid.
             * @param {String|Object} instanceOrId External instance id or the instance itself, if it has id property
             * @private
             * @category Misc
             */

          }, {
            key: "instanceMeta",
            value: function instanceMeta(instanceOrId) {
              var meta = this.meta,
                  id = instanceOrId.id || instanceOrId;
              if (!meta.map) meta.map = {};
              return meta.map[id] || (meta.map[id] = {});
            } //endregion

          }, {
            key: "indexPath",

            /**
             * Returns index path to this node. This is the index of each node in the node path
             * starting from the topmost parent. (only relevant when its part of a tree store).
             * @returns {Number[]} The index of each node in the path from the topmost parent to this node.
             * @category Parent & children
             * @private
             */
            get: function get() {
              var indices = [];

              for (var task = this; task && !task.isRoot; task = task.parent) {
                indices.unshift(task.parentIndex + 1);
              }

              return indices;
            }
          }, {
            key: "fields",

            /**
             * Convenience getter to get field definitions from class.
             * @returns {Array}
             * @category Fields
             */
            get: function get() {
              return this.constructor.internalFields || this.constructor.fields;
            }
          }, {
            key: "fieldNames",
            get: function get() {
              return Object.keys(this.data);
            }
            /**
             * Get the definition for a field by name. Caches results.
             * @param {String} fieldName Field name
             * @returns {Object} Field definition or null if none found
             * @category Fields
             */

          }, {
            key: "isModified",
            get: function get() {
              return Boolean(this.meta.modified && Object.keys(this.meta.modified).length > 0);
            }
          }, {
            key: "modifications",
            get: function get() {
              var me = this;

              if (!me.isModified) {
                return null;
              }

              var data = {};
              Object.keys(me.meta.modified).forEach(function (key) {
                // TODO: isModified will report record as modified even if a modification wont be persisted here. Should it?
                var value = me.getFieldPersistentValue(key);

                if (value !== undefined) {
                  data[key] = value;
                }
              });
              data[me.constructor.idField] = me.id;
              return data;
            }
            /**
             * Get persistable data in form of an object.
             * @property {Object}
             * @internal
             * @readonly
             * @category Editing
             */

          }, {
            key: "persistableData",
            get: function get() {
              var me = this,
                  data = {};
              Object.keys(me.data).forEach(function (key) {
                var value = me.getFieldPersistentValue(key);

                if (value !== undefined) {
                  data[key] = value;
                }
              });
              return data;
            }
            /**
             * True if this models changes are currently being committed.
             * @property {boolean}
             * @category Editing
             */

          }, {
            key: "isCommitting",
            get: function get() {
              return Boolean(this.meta.committing);
            }
          }, {
            key: "internalId",
            get: function get() {
              return this._internalId;
            }
            /**
             * Returns true if the record is new and has not been persisted (and received a proper id).
             * @property {Boolean}
             * @readonly
             * @category Identification
             */

          }, {
            key: "isPhantom",
            get: function get() {
              return this.id === '' || this.id == null || this.hasGeneratedId;
            }
            /**
             * Checks if record has a generated id. New records are assigned a generated id (starting with _generated), which should be
             * replaced on commit.
             * @property {Boolean}
             * @category Identification
             */

          }, {
            key: "hasGeneratedId",
            get: function get() {
              return this.id && typeof this.id === 'string' && this.id.startsWith('_generated');
            }
          }, {
            key: "json",
            //endregion
            //region JSON

            /**
             * Get the records data as a json string.
             * @member {String}
             * @category Misc
             */
            get: function get() {
              return JSON.stringify(this.data);
            }
          }, {
            key: "isBatchUpdating",
            get: function get() {
              return Boolean(this.batching);
            }
          }, {
            key: "firstStore",
            get: function get() {
              return this.stores.length > 0 && this.stores[0];
            }
          }, {
            key: "isValid",
            get: function get() {
              return true;
            }
          }], [{
            key: "processData",
            value: function processData(data) {
              var ignoreDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var fieldMap = this.fieldMap,
                  defaultValues = this.defaultValues;
              var processed = Object.assign({}, data),
                  fieldName;

              if (!ignoreDefaults) {
                for (fieldName in defaultValues) {
                  if (processed[fieldName] === undefined) processed[fieldName] = defaultValues[fieldName];
                }
              } // Convert field types which need converting


              for (fieldName in fieldMap) {
                var fieldDefinition = fieldMap[fieldName],
                    name = fieldDefinition.name,
                    dataSource = fieldDefinition.dataSource,
                    useNameForValue = dataSource !== name && !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].pathExists(data, dataSource) && name in data; // Only action field definitions which have a convert function or remap data

                if (useNameForValue || fieldDefinition.convert) {
                  var value = useNameForValue ? data[name] : data[dataSource]; // When ignoringDefaults, do not convert unspecified values

                  if (!ignoreDefaults || useNameForValue && name in data || !useNameForValue && dataSource in data) {
                    _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].setPath(processed, dataSource, fieldDefinition.convert ? fieldDefinition.convert(value) : value); // Remove [startDate] from internal data holder, only keeping [myStartDate]


                    if (useNameForValue) {
                      delete processed[name];
                    }
                  }
                }
              }

              return processed;
            }
            /**
             * Makes getters and setters for fields (from definitions and data). Called once when class is defined and once when
             * data is loaded first time.
             * @internal
             * @param {Object} data Raw data
             * @category Fields
             */

          }, {
            key: "exposeProperties",
            value: function exposeProperties(data) {
              var me = this,
                  superclass = me.superclass,
                  rawFields = me.hasOwnProperty('fields') && me.fields; // Ensure that the class hierarchy processes its fields on first construction.

              if (superclass.exposeProperties && !superclass.hasOwnProperty('fieldMap')) {
                superclass.exposeProperties();
              } // Don't expose field properties if already done


              if (!me.hasOwnProperty('propertiesExposed')) {
                // Clone the superclass's defaults, and override that with our own defaults.
                // As we find fields with a defaultValue, more defaults may be added
                me.defaultValues = Object.assign({}, superclass.defaultValues, me.hasOwnProperty('defaults') ? me.defaults : null); // Hook up our field maps with the class hierarchy's fieldMaps.
                // We need to be able to look up field definitions by the name, or by the dataSource property name

                /**
                 * An object containing all the _defined_ fields for this Model class. This will include all superclass's
                 * defined fields through its prototype chain. So be aware that `Object.keys` and `Object.entries` will only
                 * access this class's defined fields.
                 * @member {Object} fieldMap
                 * @static
                 * @readonly
                 * @category Fields
                 */

                me.fieldMap = Object.setPrototypeOf({}, superclass.fieldMap || emptyObject);
                me.fieldDataSourceMap = Object.setPrototypeOf({}, superclass.fieldDataSourceMap || emptyObject); // Hook up our propertiesExposed with the superclass's version

                me.propertiesExposed = Object.setPrototypeOf({}, superclass.propertiesExposed || emptyObject); // If the idField is overridden at this level, create a new field

                if (me.hasOwnProperty('idField')) {
                  me.createFieldDefinition({
                    name: 'id',
                    dataSource: me.idField
                  });
                  me.propertiesExposed[me.idField] = true;
                } // Process fields defined in the class definition


                if (rawFields && rawFields.length) {
                  rawFields.map(me.createFieldDefinition, me);
                }
              } // Process the raw data properties and expose them as fields unless the property name
              // has already been used by the "dataSource" of a defined field.


              if (me.autoExposeFields && data && !me.hasOwnProperty('propertiesExposedForData')) {
                for (var dataProperty in data) {
                  if (!me.propertiesExposed[dataProperty]) {
                    // Create a field definition in our fieldMap with the flag that it's from data
                    me.createFieldDefinition({
                      name: dataProperty,
                      dataSource: dataProperty,
                      fromData: true
                    });
                  }
                }

                me.propertiesExposedForData = true;
              }

              me.exposeRelations();
            }
          }, {
            key: "createFieldDefinition",
            value: function createFieldDefinition(fieldDef) {
              if (fieldDef == null) {
                return;
              }

              if (typeof fieldDef === 'string') {
                fieldDef = {
                  name: fieldDef
                };
              }

              var me = this,
                  propertiesExposed = me.propertiesExposed,
                  defaultValues = me.defaultValues,
                  _fieldDef = fieldDef,
                  name = _fieldDef.name,
                  dataSource = fieldDef.dataSource || (fieldDef.dataSource = name);

              if (!fieldDef.hasOwnProperty('persist')) {
                fieldDef.persist = true;
              }

              if (fieldDef.type === 'date') {
                fieldDef.convert = convertDate;
              }

              me.fieldMap[name] = fieldDef;

              if (!me.fieldDataSourceMap[dataSource]) {
                me.fieldDataSourceMap[dataSource] = fieldDef;
              } // When iterating through the raw data, if autoExposeFields is set
              // We do not need to create properties for raw property names we've processed here


              if (dataSource.indexOf('.') === -1) {
                propertiesExposed[dataSource] = true;
              } // With complex mapping avoid exposing object as model field
              else {
                  fieldDef.complexMapping = true;
                  propertiesExposed[dataSource.split('.')[0]] = true;
                } // Maintain an object of defaultValues for fields.


              if ('defaultValue' in fieldDef) {
                defaultValues[dataSource] = fieldDef.defaultValue;
              } // Create a property on this Model's prototype, named for the defined field name
              // which reads the correct property out of the raw data object.


              me.createFieldProperty(name, dataSource, fieldDef);
              return fieldDef;
            }
            /**
             * Create getter and setter functions for the specified field name under the specified key.
             *
             * @param {String} fieldName The defined field name (or property name if this is created by exposing a raw property)
             * @param {String} propertyName The property name to read off the data property
             * @param {Object} fieldDef The full field definition.
             * @private
             * @category Fields
             */

          }, {
            key: "createFieldProperty",
            value: function createFieldProperty(fieldName, propertyName, fieldDef) {
              var me = this; // checking (fieldName in me.prototype) instead of hasOwnProperty to catch cases where getters/setters are
              // manually created on some parent

              if (!internalProps[propertyName]) {
                if (!(fieldName in me.prototype)) {
                  Object.defineProperty(me.prototype, fieldName, {
                    enumerable: true,
                    get: function get() {
                      // no arrow functions here, need `this` to change to instance
                      // noinspection JSPotentiallyInvalidUsageOfClassThis
                      return this.get(fieldName);
                    },
                    // Only create a real setter if the field is read/write.
                    // privately, we will use setData to set a field's value
                    set: fieldDef && fieldDef.readOnly ? nullFn : function (value) {
                      // no arrow functions here, need `this` to change to instance
                      // noinspection JSPotentiallyInvalidUsageOfClassThis
                      this.set(fieldName, value);
                    }
                  });
                }
              }
            }
            /**
             * Makes getters and setters for related records. Populates a Model#relation array with the relations, to allow it
             * to be modified later when assigning stores.
             * @internal
             * @category Relations
             */

          }, {
            key: "exposeRelations",
            value: function exposeRelations() {
              var me = this;
              if (me.hasOwnProperty('relationsExposed')) return;

              if (me.relationConfig) {
                me.relationsExposed = true;
                me.relations = [];
                me.relationConfig.forEach(function (relation) {
                  me.relations.push(relation);
                  var name = relation.relationName; // getter and setter for related object

                  if (!Reflect.ownKeys(me.prototype).includes(name)) {
                    Object.defineProperty(me.prototype, name, {
                      enumerable: true,
                      get: function get() {
                        // noinspection JSPotentiallyInvalidUsageOfClassThis
                        return this.getForeign(name);
                      },
                      set: function set(value) {
                        // noinspection JSPotentiallyInvalidUsageOfClassThis
                        this.setForeign(name, value, relation);
                      }
                    });
                  }
                });
              }
            } //endregion
            //region Fields

            /**
             * Flag checked from Store when loading data that determines if fields found in first records should be exposed in
             * same way as predefined fields.
             * @returns {Boolean}
             * @category Fields
             */

          }, {
            key: "getFieldDefinition",
            value: function getFieldDefinition(fieldName) {
              return this.fieldMap[fieldName];
            }
          }, {
            key: "processField",
            value: function processField(fieldName, value) {
              var field = this.fieldMap[fieldName];

              if (field && field.convert) {
                return field.convert(value);
              }

              return value;
            }
          }, {
            key: "asId",
            value: function asId(model) {
              return model instanceof Model ? model.id : model;
            }
          }, {
            key: "convertEmptyParentToLeaf",

            /**
             * Specify `true` to consider an empty parent to be a leaf.
             * @property {Boolean}
             * @category Parent & children
             */
            set: function set(value) {
              this._convertEmptyParentToLeaf = value;
            },
            get: function get() {
              return this._convertEmptyParentToLeaf;
            }
            /**
             * The name of the data field which provides the ID of instances of this Model.
             * @property {String}
             * @category Fields
             */

          }, {
            key: "idField",
            set: function set(idField) {
              this._assignedIdField = true;
              this._idField = idField;
            },
            get: function get() {
              return this._idField;
            }
            /**
             * The name of the data field which holds children of this Model when used in a tree structure
             * ```javascript
             * MyModel.childrenField = 'kids';
             * const parent = new MyModel({
             *   name : 'Dad',
             *   kids : [
             *     { name : 'Daughter' },
             *     { name : 'Son' }
             *   ]
             * });
             * ```
             * @property {String}
             * @category Fields
             */

          }, {
            key: "childrenField",
            set: function set(childrenField) {
              this._childrenField = childrenField;
            },
            get: function get() {
              return this._childrenField || 'children';
            }
          }, {
            key: "autoExposeFields",
            get: function get() {
              return true;
            }
            /**
             * Predefined fields, none per default, override in subclasses to add fields.
             * @returns {Object[]}
             * @readonly
             * @category Fields
             */

          }, {
            key: "fields",
            get: function get() {
              return [];
            }
          }, {
            key: "internalFields",
            get: function get() {
              var fieldMap = this.fieldMap;
              var result = this._internalFields; // Produce the array lazily - it probably will never be used.
              // Only available when we have exposed our properties.

              if (this.hasOwnProperty('fieldMap') && !result) {
                result = this._internalFields = [];

                for (var fieldName in fieldMap) {
                  result.push(fieldMap[fieldName]);
                }
              }

              return result;
            }
          }]);

          return Model;
        }(Object(_mixin_TreeNode_js__WEBPACK_IMPORTED_MODULE_22__["default"])(Object(_stm_mixin_ModelStm_js__WEBPACK_IMPORTED_MODULE_21__["default"])()));

        Model._idField = 'id';
        Model._internalIdCounter = 1;
        Model._assignedIdField = false;
        Model.exposeProperties();
        Model._$name = 'Model';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/Store.js":
      /*!****************************************!*\
        !*** ../Grid/lib/Common/data/Store.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Store;
        });
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.map */
        "../Grid/node_modules/core-js/modules/es6.map.js");
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "../Grid/node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../mixin/Pluggable.js */
        "../Grid/lib/Common/mixin/Pluggable.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _mixin_State_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../mixin/State.js */
        "../Grid/lib/Common/mixin/State.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ./Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../helper/MixinHelper.js */
        "../Grid/lib/Common/helper/MixinHelper.js");
        /* harmony import */


        var _util_Bag_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ../util/Bag.js */
        "../Grid/lib/Common/util/Bag.js");
        /* harmony import */


        var _util_Collection_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ../util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ./mixin/StoreCRUD.js */
        "../Grid/lib/Common/data/mixin/StoreCRUD.js");
        /* harmony import */


        var _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ./mixin/StoreFilter.js */
        "../Grid/lib/Common/data/mixin/StoreFilter.js");
        /* harmony import */


        var _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
        /*! ./mixin/StoreGroup.js */
        "../Grid/lib/Common/data/mixin/StoreGroup.js");
        /* harmony import */


        var _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
        /*! ./mixin/StoreRelation.js */
        "../Grid/lib/Common/data/mixin/StoreRelation.js");
        /* harmony import */


        var _mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
        /*! ./mixin/StoreSum.js */
        "../Grid/lib/Common/data/mixin/StoreSum.js");
        /* harmony import */


        var _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
        /*! ./mixin/StoreSearch.js */
        "../Grid/lib/Common/data/mixin/StoreSearch.js");
        /* harmony import */


        var _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
        /*! ./mixin/StoreSort.js */
        "../Grid/lib/Common/data/mixin/StoreSort.js");
        /* harmony import */


        var _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
        /*! ./mixin/StoreChained.js */
        "../Grid/lib/Common/data/mixin/StoreChained.js");
        /* harmony import */


        var _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
        /*! ./mixin/StoreState.js */
        "../Grid/lib/Common/data/mixin/StoreState.js");
        /* harmony import */


        var _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(
        /*! ./mixin/StoreTree.js */
        "../Grid/lib/Common/data/mixin/StoreTree.js");
        /* harmony import */


        var _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(
        /*! ./stm/mixin/StoreStm.js */
        "../Grid/lib/Common/data/stm/mixin/StoreStm.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(
        /*! ../helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/Store
        */

        /**
         * The Store represents a data container which holds flat data or tree structures. An item in the Store is often called a ´record´ and it is simply an instance of the
         * {@link Common.data.Model} (or any subclass thereof). Typically you load data into a store to display it in a Grid or a ComboBox. The Store is the backing data component for any component that is showing data in a list style UI.
         *
         * * {@link Grid.view.Grid}
         * * {@link Grid.view.TreeGrid}
         * * {@link Common.widget.List}
         * * {@link Common.widget.Combo}
         *
         * <h3>Data format</h3>
         * Data is store in a JSON array the Store offers an API to edit, filter, group and sort the records.
         *
         * <h3>Store with flat data</h3>
         * To create a flat store simply provide an array of objects that describe your records
         *
         * ```javascript
         * let store = new Store({
         *   data : [
         *     { id : 1, name : 'ABBA', country : 'Sweden' },
         *     { id : 2, name : 'Beatles', country : 'UK' }
         *   ]
         * });
         *
         * // retrieve record by id
         * let beatles = store.getById(2);
         * ```
         *
         * <h3>Store with tree data</h3>
         * To create a tree store use `children` property for descendant records
         *
         * ```javascript
         * let store = new Store({
         *   tree: true,
         *   data : [
         *     { id : 1, name : 'ABBA', country : 'Sweden', children: [
         *       { id: 2, name: 'Agnetha' },
         *       { id: 3, name: 'Bjorn' },
         *       { id: 4, name: 'Benny' },
         *       { id: 5, name: 'Anni-Frid' }
         *     ]},
         *   ]
         * });
         *
         * // retrieve record by id
         * let benny = store.getById(4);
         * ```
         *
         * <h3>Sharing stores</h3>
         * You cannot directly share a Store between widgets, but the data in a Store can be shared. There are two different
         * approaches depending on your needs, sharing data and chaining stores:
         *
         * <h4>Shared data</h4>
         * To create 2 widgets that share data, you can create 2 separate stores and pass records of the first store as the
         * dataset of the second store.
         *
         * ```javascript
         * let combo1 = new Combo({
         *     appendTo : document.body,
         *     store    : new Store({
         *         data : [
         *             { id : 1, name : 'ABBA', country : 'Sweden' },
         *             { id : 2, name : 'Beatles', country : 'UK' }
         *         ]
         *     }),
         *     valueField   : 'id',
         *     displayField : 'name'
         * });
         *
         * let combo2 = new Combo({
         *     appendTo : document.body,
         *     store    : new Store({
         *         data : combo1.store.records
         *     }),
         *     valueField   : 'id',
         *     displayField : 'name'
         * });
         *
         * combo1.store.first.name = 'foo';
         * combo2.store.first.name; // "foo"
         * ```
         *
         * <h4>Chained stores</h4>
         * Another more powerful option to share data between widgets is to create {@link Common.data.mixin.StoreChained chained stores}.
         * The easiest way to create a chained store is to call {@link #function-chain} function.
         *
         * ```javascript
         * let combo1 = new Combo({
         *     appendTo : document.body,
         *     store    : new Store({
         *         data : [
         *             { id : 1, name : 'ABBA', country : 'Sweden' },
         *             { id : 2, name : 'Beatles', country : 'UK' }
         *         ]
         *     }),
         *     valueField   : 'id',
         *     displayField : 'name'
         * });
         *
         * let combo2 = new Combo({
         *     appendTo : document.body,
         *     store    : combo1.store.chain(),
         *     valueField   : 'id',
         *     displayField : 'name'
         * });
         *
         * combo1.store.first.name = 'foo';
         * combo2.store.first.name; // "foo"
         * ```
         *
         * A chained store can optionally be created with a filtering function, to only contain a subset of the records from
         * the main store. In addition, the chained store will reflect record removals/additions to the master store, something
         * the shared data approach will not.
         *
         * @mixes Common/data/mixin/StoreChained
         * @mixes Common/data/mixin/StoreCRUD
         * @mixes Common/data/mixin/StoreFilter
         * @mixes Common/data/mixin/StoreGroup
         * @mixes Common/data/mixin/StoreRelation
         * @mixes Common/data/mixin/StoreSearch
         * @mixes Common/data/mixin/StoreSort
         * @mixes Common/data/mixin/StoreState
         * @mixes Common/data/mixin/StoreSum
         * @mixes Common/data/mixin/StoreTree
         * @mixes Common/mixin/Events
         * @mixes Common/data/stm/mixin/StoreStm
         *
         * @extends Common/Base
         */

        var Store =
        /*#__PURE__*/
        function (_base$mixes) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(Store, _base$mixes);

          function Store() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, Store);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Store).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(Store, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fired when the id of a record has changed
             * @event idChange
             * @param {Common.data.Store} source This Store
             * @param {Common.data.Model} record Modified record
             * @param {String|Number} oldValue Old id
             * @param {String|Number} value New id
             */

            /**
             * Fired before record is modified in this store.
             * Modification may be vetoed by returning `false` from a handler.
             * @event beforeUpdate
             * @param {Common.data.Store} source This Store
             * @param {Common.data.Model} record Modified record
             * @param {Object} toSet Modification data
             */

            /**
             * Fired when a record is modified
             * @event update
             * @param {Common.data.Store} source This Store
             * @param {Common.data.Model} record Modified record
             * @param {Object} toSet Modification data
             */

            /**
             * Fired when the root node is set
             * @event rootChange
             * @param {Common.data.Store} source This Store
             * @param {Common.data.Model} oldRoot The old root node.
             * @param {Common.data.Model} rootNode The new root node.
             */

            /**
             * Data in the store was changed. This is a catch-all event which is fired for all changes
             * which take place to the store's data.
             *
             * This includes mutation of individual records, adding and removal of records, as well as
             * setting a new data payload using the {@link #property-data} property, sorting, filtering,
             * and calling {@link Common.data.mixin.StoreCRUD#function-removeAll}.
             *
             * Simple databound widgets may use to the `change` event to refresh their UI without having to add multiple
             * listeners to the {@link #event-update}, {@link Common.data.mixin.StoreCRUD#event-add}, {@link Common.data.mixin.StoreCRUD#event-remove}, {@link #event-refresh}
             * and {@link Common.data.mixin.StoreCRUD#event-removeAll} events.
             *
             * A more complex databound widget such as a grid may use the more granular events to perform less
             * destructive updates more appropriate to each type of change. The properties will depend upon the value of the `action` property.
             * @event change
             * @param {Common.data.Store} source This Store.
             * @param {String} action Name of action which triggered the change. May be one of:
             * * `'remove'`
             * * `'removeAll'`
             * * `'add'`
             * * `'updatemultiple'`
             * * `'clearchanges'`
             * * `'filter'`
             * * `'sort'`
             * * `'update'`
             * * `'dataset'`
             * * `'replace'`
             */

            /**
             * Data in the store has completely changed, such as by a filter, or sort or load operation.
             * @event refresh
             * @param {Common.data.Store} source This Store.
             * @param {Boolean} batch Flag set to `true` when the refresh is triggered by ending a batch
             * @param {String} action Name of action which triggered the change. May be one of:
             * * `'dataset'`
             * * `'sort'`
             * * `'filter'`
             * * `'create'`
             * * `'update'`
             * * `'delete'`
             * * `'group'`.
             */
            //endregion
            //region Init
            value: function construct() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var me = this;
              me.added = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_26__["default"]();
              me.removed = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_26__["default"]();
              me.modified = new _util_Bag_js__WEBPACK_IMPORTED_MODULE_26__["default"]();
              me.idRegister = {};
              me.internalIdRegister = {};

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Store.prototype), "construct", this).call(this, config);

              me.on({
                idChange: me.onRecordIdChange,
                update: me.onUpdateRecord,
                thisObj: me
              });
              me.initRelations();
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this,
                  allRecords = me.registeredRecords;

              for (var i = allRecords.length - 1, rec; i >= 0; i--) {
                rec = allRecords[i];

                if (rec && !rec.isDestroyed) {
                  rec.unJoinStore(me);
                }
              }

              me.storage.destroy();
              delete Store.storeMap[me.id]; // Events superclass fires destroy event.

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Store.prototype), "doDestroy", this).call(this); //TODO abort any ongoing loads

            }
            /**
             * Stops this store from firing events until {@link #function-endBatch} is called. Multiple calls to `beginBatch`
             * stack up, and will require an equal number of `endBatch` calls to resume events.
             *
             * Upon call of {@link #function-endBatch}, a {@link #event-refresh} event is triggered to allow UIs to
             * update themselves based upon the new state of the store.
             *
             * This is extremely useful when making a large number of changes to a store. It is important not to trigger
             * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
             * store are only updated once at the end of the updates.
             */

          }, {
            key: "beginBatch",
            value: function beginBatch() {
              this.suspendEvents();
            }
            /**
             * Ends event suspension started by {@link #function-beginBatch}. Multiple calls to {@link #function-beginBatch}
             * stack up, and will require an equal number of `endBatch` calls to resume events.
             *
             * Upon call of `endBatch`, a {@link #event-refresh} event with `action: batch` is triggered to allow UIs to update
             * themselves based upon the new state of the store.
             *
             * This is extremely useful when making a large number of changes to a store. It is important not to trigger
             * too many UI updates for performance reasons. Batching the changes ensures that UIs attached to this
             * store are only updated once at the end of the updates.
             */

          }, {
            key: "endBatch",
            value: function endBatch() {
              if (this.resumeEvents()) {
                this.trigger('refresh', {
                  action: 'batch',
                  data: this.storage.values,
                  records: this.storage.values
                });
              }
            }
          }, {
            key: "onDataChange",

            /**
             * Responds to mutations of the underlying storage Collection
             * @param {Object} event
             * @private
             */
            value: function onDataChange(_ref) {
              var storage = _ref.source,
                  action = _ref.action,
                  added = _ref.added,
                  removed = _ref.removed,
                  replaced = _ref.replaced,
                  oldCount = _ref.oldCount,
                  item = _ref.item,
                  from = _ref.from,
                  to = _ref.to;
              var me = this,
                  addedCount = added && added.length,
                  removedCount = removed && removed.length;
              var record, filtersWereReapplied;
              me._idMap = null;

              if (addedCount) {
                added.forEach(function (added) {
                  added.joinStore(me);
                });
              }

              replaced && replaced.forEach(function (_ref2) {
                var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_10___default()(_ref2, 2),
                    oldRecord = _ref3[0],
                    newRecord = _ref3[1];

                oldRecord.unJoinStore(me);
                newRecord.joinStore(me);
              }); // Allow mixins to mutate the storage before firing events.
              // StoreGroup does this to introduce group records into the mix.

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_17___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(Store.prototype), "onDataChange", this).apply(this, arguments); // Join/unjoin incoming/outgoing records unless its as a result of TreeNode operations.
              // If we are a tree, joining is done when nodes are added/removed
              // as child nodes of a joined parent.


              if (!me.tree) {
                if (addedCount) {
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = added[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      record = _step.value;
                      record.joinStore(me);
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  me.added.add(added);
                  me.removed.remove(added); // Re-evaluate the current filter set silently so that the information we
                  // are broadcasting below is up to date.

                  filtersWereReapplied = me.filtered && me.reapplyFilterOnAdd;

                  if (filtersWereReapplied) {
                    me.filter(null, null, true);
                  }
                }

                if (removedCount) {
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = removed[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      record = _step2.value;
                      record.unJoinStore(me); // If was newly added, remove from added list

                      if (me.added.includes(record)) {
                        me.added.remove(record);
                      } // Else add to removed list
                      else {
                          me.removed.add(record);
                        }
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }

                  me.modified.remove(removed);
                  filtersWereReapplied = me.filtered;

                  if (filtersWereReapplied) {
                    me.filter(null, null, true);
                  }
                }
              }

              switch (action) {
                case 'clear':
                  // Clear our own relationCache, since we will be empty
                  me.relationCache = {}; // Signal to stores that depend on us

                  me.updateDependentStores('removeall');
                  me.trigger('removeAll');
                  me.trigger('change', {
                    action: 'removeall'
                  });
                  break;

                case 'splice':
                  if (addedCount) {
                    me.updateDependentStores('add', added);
                    var // Collection does not handle moves, figure out if and where a record was moved from by checking
                    // previous index value stored in meta
                    oldIndex = added.reduce(function (lowest, record) {
                      var previousIndex = record.meta.previousIndex;
                      if (previousIndex > -1 && previousIndex < lowest) lowest = previousIndex;
                      return lowest;
                    }, added[0].meta.previousIndex),
                        index = storage.indexOf(added[0]),
                        params = {
                      records: added,
                      index: index
                    }; // Only include param oldIndex when used

                    if (oldIndex > -1) {
                      params.oldIndex = oldIndex;
                    }

                    me.trigger('add', params);
                    me.trigger('change', Object.assign({
                      action: 'add'
                    }, params));

                    if (filtersWereReapplied) {
                      me.triggerFilterEvent({
                        action: 'filter',
                        filters: me.filters,
                        oldCount: oldCount,
                        records: me.storage.allValues
                      });
                    }
                  }

                  if (removed.length) {
                    me.updateDependentStores('remove', removed);
                    me.trigger('remove', {
                      records: removed
                    });
                    me.trigger('change', {
                      action: 'remove',
                      records: removed
                    });
                  }

                  if (replaced.length) {
                    // TODO: Remove in 2.2 if no problems til then
                    // me.trigger('updateMultiple', {
                    //     records : removed,
                    //     all     : me.records.length === replaced.length
                    // });
                    me.trigger('replace', {
                      records: replaced,
                      all: me.records.length === replaced.length
                    });
                    me.trigger('change', {
                      action: 'replace',
                      replaced: replaced,
                      all: me.records.length === replaced.length
                    });
                  }

                  break;

                case 'filter':
                  // Reapply grouping/sorting to make sure unfiltered records get sorted correctly
                  if (me.isGrouped) {
                    me.group();
                  } else if (me.isSorted) {
                    me.performSort();
                  }

                  break;

                case 'move':
                  // update parentIndex of records affected
                  for (var allRecords = me.storage.allValues, i = Math.min(from, to); i <= Math.max(from, to); i++) {
                    allRecords[i].parentIndex = i;
                  }
                  /**
                   * Fired when a record has been moved within this Store
                   * @event move
                   * @param {Common.data.Store} source This Store
                   * @param {Common.data.Model} record The record moved.
                   * @param {Number} from The index from which the record was removed.
                   * @param {Number} to The index at which the record was inserted.
                   */


                  me.trigger('move', {
                    record: item,
                    from: from,
                    to: to
                  });
                  me.trigger('change', {
                    action: action,
                    record: item,
                    from: from,
                    to: to
                  });
              }
            }
          }, {
            key: "onModelChange",
            value: function onModelChange(record, toSet, wasSet) {
              var me = this,
                  idField = record.constructor.idField;

              if (idField in toSet) {
                var _toSet$idField = toSet[idField],
                    oldValue = _toSet$idField.oldValue,
                    value = _toSet$idField.value;
                me.updateDependentRecordIds(oldValue, value);
                me.trigger('idChange', {
                  store: me,
                  record: record,
                  oldValue: oldValue,
                  value: value
                });
              }

              var event = {
                record: record,
                changes: wasSet
              };

              if (record.batching != null) {
                event.batch = true;
              }

              me.trigger('update', event);
              me.trigger('change', Object.assign({
                action: 'update'
              }, event));
            }
          }, {
            key: "buildRootNode",
            // a hook to build a customized root node
            value: function buildRootNode() {
              return {};
            }
            /**
             * Get a store from the store map by id.
             * @param {String|Number|Object[]} id The id of the store to retrieve, or an array of objects
             * from which to create the contents of a new Store.
             * @returns {Common.data.Store} The store with the specified id
             */

          }, {
            key: "loadData",
            value: function loadData(data) {
              var me = this,
                  storage = me.storage;

              if (me.allCount) {
                // clear without marking as removed
                me.clear(false);
              }

              me._idMap = null;

              if (data) {
                // Having any of groups collapsed at the time of data reloading using the same dataset
                // makes new data look differ comparing to the data which is already in the store.
                // So here we expand all groups and save the state to collapse them later.
                // This might be expensive, but it helps to prevent Id collision failure for now.
                me.storeCollapsedGroups();
                var isRaw = !(data[0] instanceof _Model_js__WEBPACK_IMPORTED_MODULE_23__["default"]);

                if (isRaw) {
                  me.modelClass.exposeProperties(data[0]);
                  var count = data.length,
                      records = new Array(count);

                  for (var i = 0; i < count; i++) {
                    records[i] = me.createRecord(data[i], true);
                    records[i].parentIndex = i;
                  }

                  storage.replaceValues(records, true, true);
                } else {
                  storage.replaceValues(data.slice(), true, true);
                }

                me.storage.allValues.forEach(function (r) {
                  r.joinStore(me);
                }); // Need to update group records info (headers and footers)

                me.prepareGroupRecords(); // Restore collapsed state

                me.restoreCollapsedGroups(); // The three operations below, filter, store and sort, all are passed
                // the "silent" parameter meaning they do not fire their own events.
                // The 'refresh' and 'change' events after are used to update UIs.

                if (me.isFiltered) {
                  me.filter(null, null, true);
                } // TODO: groupers must just be promoted to be the primary sorters.


                if (me.groupers.length > 0 && me.isGrouped) {
                  me.group(null, null, false, !me.sorters.length, true);
                }

                if (me.sorters.length) {
                  me.sort(null, null, false, true);
                } // Check for duplicate ids, unless user guarantees data validity


                if (!me.useRawData) {
                  var idMap = me.idMap;

                  if (Object.keys(idMap).length < me.storage.values.length) {
                    // idMap has fewer entries than expected, a duplicate id was used. pick idMap apart to find out which
                    var collisions = [];
                    me.storage.values.forEach(function (r) {
                      return idMap[r.id] ? delete idMap[r.id] : collisions.push(r);
                    });
                    throw new Error("Id collision on ".concat(collisions.map(function (r) {
                      return r.id;
                    })));
                  }
                }

                var event = {
                  action: 'dataset',
                  data: data,
                  records: me.storage.values
                };
                me.updateDependentStores(event.action, event.records);
                me.trigger('refresh', event);
                me.trigger('change', event);
              } else {
                me._data = null;
              }
            }
          }, {
            key: "getRange",

            /**
             * Creates an array of records from this store from the `start` to the `end' - 1
             * @param {Number} [start] The index of the first record to return
             * @param {Number} [end] The index *after* the last record to return `(start + length)`
             * @return {Common.data.Model[]} The requested records.
             * @category Records
             */
            value: function getRange(start, end) {
              var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
              return (all ? this.storage.allValues : this.storage.values).slice(start, end);
            }
            /**
             * Creates a model instance, used internally when data is set/added. Override this in a subclass to do your own custom
             * conversion from data to record.
             * @param data Json data
             * @param skipExpose Supply true when batch setting to not expose properties multiple times
             * @category Records
             */

          }, {
            key: "createRecord",
            value: function createRecord(data) {
              var skipExpose = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              return new this.modelClass(data, this, null, skipExpose);
            }
          }, {
            key: "refreshData",
            value: function refreshData() {
              this.filter();
              this.sort();
            }
          }, {
            key: "onRecordIdChange",
            value: function onRecordIdChange(_ref4) {
              var record = _ref4.record,
                  oldValue = _ref4.oldValue,
                  value = _ref4.value;
              var me = this,
                  idMap = me._idMap,
                  idRegister = me.idRegister;
              me.storage._indicesInvalid = true;

              if (idMap) {
                delete idMap[oldValue];
                idMap[value] = record;
              }

              me.added.changeId(oldValue, value);
              me.removed.changeId(oldValue, value);
              me.modified.changeId(oldValue, value);
              delete idRegister[oldValue];
              idRegister[value] = record;
              record.index = me.storage.indexOf(record);
            }
          }, {
            key: "onUpdateRecord",
            value: function onUpdateRecord(_ref5) {
              var record = _ref5.record,
                  changes = _ref5.changes;
              var internalId = changes.internalId,
                  internalIdRegister = this.internalIdRegister;

              if (internalId) {
                this.storage._indicesInvalid = true;
                delete internalIdRegister[internalId.oldValue];
                internalIdRegister[internalId.value] = record;
              } // Reapply filters when records change?


              if (this.reapplyFilterOnUpdate && this.isFiltered) {
                this.filter();
              }
            } //endregion
            //region Count

            /**
             * Number of records in the store
             * @param countProcessed Count processed (true) or real records (false)
             * @returns {Number} Record count
             * @category Records
             */

          }, {
            key: "getCount",
            value: function getCount() {
              var countProcessed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              return countProcessed ? this.count : this.originalCount;
            }
            /**
             * Record count, for data records. Not including records added for group headers etc.
             * @property {Number}
             * @readonly
             * @category Records
             */

          }, {
            key: "getAt",

            /**
             * Get the record at the specified index
             * @param {Number} index Index for the record
             * @returns {Common.data.Model} Record at the specified index
             * @category Records
             */
            value: function getAt(index) {
              var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // all means include filtered out records

              return this.storage.getAt(index, all);
            } // These are called by Model#join and Model#unjoin
            // register a record as a findable member keyed by id and internalId

          }, {
            key: "register",
            value: function register(record) {
              var me = this,
                  // Test for duplicate IDs on register only when a tree store.
              // loadData does it in the case of a non-tree
              existingRec = me.tree && me.idRegister[record.id];

              if (existingRec && existingRec !== record) {
                throw new Error("Id collision on ".concat(record.id));
              }

              me.idRegister[record.id] = record;
              me.internalIdRegister[record.internalId] = record;
            }
          }, {
            key: "unregister",
            value: function unregister(record) {
              delete this.idRegister[record.id];
              delete this.internalIdRegister[record.internalId];
            }
          }, {
            key: "getById",

            /**
             * Get a record by id. Find the record even if filtered out, part of collapsed group or collapsed node
             * @param {Common.data.Model|String|Number} id Id of record to return.
             * @returns {Common.data.Model} A record with the specified id
             * @category Records
             */
            value: function getById(id) {
              // In case `id` is a record, we use its ID to try to find the record in the store,
              // because if the record is removed from the store it shouldn't be found.
              // if (id instanceof Model) {
              //     id = id.id;
              // }
              if (id instanceof _Model_js__WEBPACK_IMPORTED_MODULE_23__["default"]) {
                return id;
              } //return this.tree ? this.idRegister[id] : this.storage.get(id);


              return this.idRegister[id];
            }
            /**
             * Checks if a record is visible, in the sense that it is not filtered out,
             * hidden in a collapsed group or in a collapsed node.
             * Deprecated in 2.2.3, please use {@link #function-isAvailable} instead
             * @param {Common.data.Model|String|Number} recordOrId Record to check
             * @returns {Boolean}
             * @deprecated 2.2.3
             */

          }, {
            key: "isVisible",
            value: function isVisible(recordOrId) {
              return this.storage.includes(this.getById(recordOrId));
            }
            /**
             * Checks if a record is available, in the sense that it is not filtered out,
             * hidden in a collapsed group or in a collapsed node.
             * @param {Common.data.Model|String|Number} recordOrId Record to check
             * @returns {Boolean}
             */

          }, {
            key: "isAvailable",
            value: function isAvailable(recordOrId) {
              return this.storage.includes(this.getById(recordOrId));
            }
            /**
             * Get a record by internalId.
             * @param {Number} internalId The internalId of the record to return
             * @returns {Common.data.Model} A record with the specified internalId
             * @category Records
             */

          }, {
            key: "getByInternalId",
            value: function getByInternalId(internalId) {
              return this.internalIdRegister[internalId];
            }
            /**
             * Checks if the specified record is contained in the store
             * @param {Common.data.Model|String|Number} recordOrId Record, or `id` of record
             * @returns {Boolean}
             * @category Records
             */

          }, {
            key: "includes",
            value: function includes(recordOrId) {
              if (this.tree) {
                return this.idRegister[_Model_js__WEBPACK_IMPORTED_MODULE_23__["default"].asId(recordOrId)] != null;
              }

              return this.indexOf(recordOrId) > -1;
            } //endregion
            //region Get index

            /**
             * Returns the index of the specified record/id, or `-1` if not found.
             * @param {Common.data.Model|String|Number} recordOrId Record, or `id` of record to return the index of.
             * @param {Boolean} [visibleRecords] Pass `true` to find the visible index.
             * as opposed to the dataset index. This omits group header records.
             * @returns {Number} Index for the record/id, or `-1` if not found.
             * @category Records
             */

          }, {
            key: "indexOf",
            value: function indexOf(recordOrId) {
              var visibleRecords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

              var id = _Model_js__WEBPACK_IMPORTED_MODULE_23__["default"].asId(recordOrId);

              if (!id) {
                return -1;
              } // When a tree, indexOf is always in the visible records - filtering is different in trees.


              if (this.tree) {
                return this.storage.indexOf(id);
              }

              var found = this.idMap[id];
              return found ? found[visibleRecords ? 'visibleIndex' : 'index'] : -1;
            }
          }, {
            key: "allIndexOf",
            value: function allIndexOf(recordOrId) {
              var _this = this;

              if (this.tree) {
                var record = this.getById(recordOrId);
                var result = -1; // Use the tree structure to get the index in tree walk order

                if (record) {
                  record.bubble(function (n) {
                    if (n.parent) {
                      result += n.parentIndex + 1;
                    } else if (n === _this.rootNode && _this.rootVisible) {
                      result += 1;
                    }
                  });
                }

                return result;
              } else {
                return this.storage.indexOf(recordOrId, true);
              }
            } //endregion
            //region Get values

            /**
             * Gets distinct values for the specified field.
             * @param field Field to extract values for
             * @returns {Array} Array of values
             * @category Values
             */

          }, {
            key: "getDistinctValues",
            value: function getDistinctValues(field) {
              var me = this,
                  values = [],
                  keys = {};
              var value;
              me.forEach(function (r) {
                if (!r.meta.specialRow && !r.isRoot) {
                  value = r.get(field);

                  if (!keys[value]) {
                    values.push(value);
                    keys[value] = 1;
                  }
                }
              });
              return values;
            }
            /**
             * Counts how many times specified value appears in the store
             * @param field Field to look in
             * @param value Value to look for
             * @returns {Number} Found count
             * @category Values
             */

          }, {
            key: "getValueCount",
            value: function getValueCount(field, value) {
              var me = this,
                  count = 0;
              me.forEach(function (r) {
                if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isEqual(r.get(field), value)) count++;
              });
              return count;
            } //endregion
            //region JSON & console

          }, {
            key: "toJSON",
            value: function toJSON() {
              // extract entire structure.
              // If we're a tree, then that consists of the payload of the rootNode.
              return (this.tree ? this.rootNode.children : this).map(function (record) {
                return record.toJSON();
              });
            } //endregion
            //region Iteration & traversing

            /**
             * Iterates over all normal records in store. Omits group header and footer records
             * if this store is grouped.
             * @param {Function} fn A function that is called for each record. Returning false from that function cancels iteration
             * @param {Object} thisObj `this` reference for the function
             * @category Iteration
             */

          }, {
            key: "forEach",
            value: function forEach(fn) {
              var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;

              var callback = function callback(r, i) {
                if (!r.isRoot && !r.meta.specialRow) {
                  return fn.call(thisObj, r, i);
                }
              };

              if (this.tree) {
                this.rootNode.traverseWhile(callback);
              } else {
                // native forEach cannot be aborted by returning false, have to loop "manually"
                var records = this.storage.values;

                for (var i = 0; i < records.length; i++) {
                  if (callback(records[i], i) === false) {
                    return;
                  }
                }
              }
            }
            /**
             * Equivalent to Array.map(). Creates a new array with the results of calling a provided function on every record
             * @param {Function} fn
             * @returns {Array}
             * @category Iteration
             */

          }, {
            key: "map",
            value: function map(fn) {
              var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
              return this.storage.values.map(fn, thisObj);
            }
            /**
             * Equivalent to Array.reduce(). Applies a function against an accumulator and each record (from left to right) to
             * reduce it to a single value.
             * @param {Function} fn
             * @param initialValue
             * @returns {*}
             * @category Iteration
             */

          }, {
            key: "reduce",
            value: function reduce(fn) {
              var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;

              if (thisObj !== this) {
                fn = fn.bind(thisObj);
              }

              return this.storage.values.reduce(fn, initialValue, thisObj);
            }
            /**
             * Iterator that allows you to do for (let record of store)
             * @category Iteration
             */

          }, {
            key: Symbol.iterator,
            value: function value() {
              return this.storage.values[Symbol.iterator]();
            }
            /**
             * Traverse all tree nodes
             * @param {Function} fn
             * @category Traverse
             */

          }, {
            key: "traverse",
            value: function traverse(fn) {
              if (this.tree) {
                this.rootNode.traverse(fn, true);
              } else {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = this.storage[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var record = _step3.value;
                    record.traverse(fn);
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }
            }
            /**
             * Finds the next record.
             * @param recordOrId Current record or its id
             * @param {Boolean} wrap Wrap at start/end or stop there
             * @returns {Common.data.Model} Next record or null if current is the last one
             * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
             * @category Traverse
             */

          }, {
            key: "getNext",
            value: function getNext(recordOrId) {
              var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var skipSpecialRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  records = me.storage.values,
                  idx = me.indexOf(recordOrId);

              if (idx >= records.length - 1) {
                if (wrap) {
                  idx = -1;
                } else {
                  return null;
                }
              }

              var record = records[idx + 1]; // Skip the result if it's a specialRow and we are told to skip them

              if (skipSpecialRows && record && record.meta.specialRow) {
                return me.getNext(records[idx + 1], wrap, true);
              }

              return record;
            }
            /**
             * Finds the previous record.
             * @param recordOrId Current record or id
             * @param {Boolean} wrap Wrap at start/end or stop there
             * @returns {Common.data.Model} Previous record or null if current is the last one
             * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
             * @category Traverse
             */

          }, {
            key: "getPrev",
            value: function getPrev(recordOrId) {
              var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var skipSpecialRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  records = me.storage.values,
                  idx = me.indexOf(recordOrId);

              if (idx === 0) {
                if (wrap) {
                  idx = records.length;
                } else {
                  return null;
                }
              }

              var record = records[idx - 1]; // Skip the result if it's a specialRow and we are told to skip them

              if (skipSpecialRows && record && record.meta.specialRow) {
                return me.getNext(records[idx + 1], wrap, true);
              }

              return record;
            }
            /**
             * Gets the next or the previous record. Optionally wraps from first -> last and vice versa
             * @param {String|Model} recordOrId Record or records id
             * @param {Boolean} next Next (true) or previous (false)
             * @param {Boolean} wrap Wrap at start/end or stop there
             * @param {Boolean} [skipSpecialRows=false] True to not return specialRows like group headers
             * @returns {Common.data.Model}
             * @category Traverse
             * @internal
             */

          }, {
            key: "getAdjacent",
            value: function getAdjacent(recordOrId) {
              var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var skipSpecialRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              return next ? this.getNext(recordOrId, wrap, skipSpecialRows) : this.getPrev(recordOrId, wrap, skipSpecialRows);
            }
            /**
             * Finds the next record among leaves (in a tree structure)
             * @param recordOrId Current record or its id
             * @param {Boolean} wrap Wrap at start/end or stop there
             * @returns {Common.data.Model} Next record or null if current is the last one
             * @category Traverse
             * @internal
             */

          }, {
            key: "getNextLeaf",
            value: function getNextLeaf(recordOrId) {
              var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  records = me.leaves,
                  record = me.getById(recordOrId),
                  idx = records.indexOf(record);

              if (idx >= records.length - 1) {
                if (wrap) {
                  idx = -1;
                } else {
                  return null;
                }
              }

              return records[idx + 1];
            }
            /**
             * Finds the previous record among leaves (in a tree structure)
             * @param recordOrId Current record or id
             * @param {Boolean} wrap Wrap at start/end or stop there
             * @returns {Common.data.Model} Previous record or null if current is the last one
             * @category Traverse
             * @internal
             */

          }, {
            key: "getPrevLeaf",
            value: function getPrevLeaf(recordOrId) {
              var wrap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  records = me.leaves,
                  record = me.getById(recordOrId),
                  idx = records.indexOf(record);

              if (idx === 0) {
                if (wrap) {
                  idx = records.length;
                } else {
                  return null;
                }
              }

              return records[idx - 1];
            }
            /**
             * Gets the next or the previous record among leaves (in a tree structure). Optionally wraps from first -> last and
             * vice versa
             * @param {String/Model} recordOrId Record or records id
             * @param {Boolean} next Next (true) or previous (false)
             * @param {Boolean} wrap Wrap at start/end or stop there
             * @returns {Common.data.Model}
             * @category Traverse
             * @internal
             */

          }, {
            key: "getAdjacentLeaf",
            value: function getAdjacentLeaf(recordOrId) {
              var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              return next ? this.getNextLeaf(recordOrId, wrap) : this.getPrevLeaf(recordOrId, wrap);
            } //endregion
            //region Chained store

            /**
             * Creates a chained store, a new Store instance that contains a subset of the records from current store.
             * Which records is determined by a filtering function, which is reapplied when data in the base store changes.
             * @param {Function} chainedFilterFn Function called for each records that determines if it should be included
             * (return true) or not (return false). Defaults to including all records (fn always returning true)
             * @param {String[]} chainedFields Array of fields that trigger filtering when they are updated
             * @param {Object} config Additional chained store configuration
             * @returns {Common.data.Store}
             * @example
             * let oldies = store.makeChained(record => record.age > 40);
             */

          }, {
            key: "makeChained",
            value: function makeChained() {
              var chainedFilterFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
                return true;
              };
              var chainedFields = arguments.length > 1 ? arguments[1] : undefined;
              var config = arguments.length > 2 ? arguments[2] : undefined;
              return new this.constructor(Object.assign(config || {}, {
                chained: true,
                tree: false,
                autoTree: false,
                masterStore: this,
                chainedFilterFn: chainedFilterFn,
                chainedFields: chainedFields
              }));
            }
            /**
             * Alias for {@link #function-makeChained}
             * @param {Function} chainedFilterFn Function called for each records that determines if it should be included
             * (return true) or not (return false). Defaults to including all records (fn always returning true)
             * @param {String[]} chainedFields Array of fields that trigger filtering when they are updated
             * @param {Object} config Additional chained store configuration
             * @returns {Common.data.Store}
             */

          }, {
            key: "chain",
            value: function chain() {
              return this.makeChained.apply(this, arguments);
            } //endregion

          }, {
            key: "storage",
            set: function set(storage) {
              var me = this;

              if (storage && storage.isCollection) {
                me._storage = storage;
              } else {
                me._storage = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_27__["default"](storage);
              }

              me._storage.autoFilter = me.reapplyFilterOnAdd; // Join all the constituent records to this Store

              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = me._storage[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var r = _step4.value;
                  r.joinStore(me);
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }

              me._storage.on({
                change: 'onDataChange',
                thisObj: me
              });
            },
            get: function get() {
              if (!this._storage) {
                this.storage = {};
              }

              return this._storage;
            }
          }, {
            key: "allRecords",
            get: function get() {
              var me = this;

              if (me.tree) {
                var result = me.collectDescendants(me.rootNode).all;

                if (me.rootVisible) {
                  result.unshift(me.rootNode);
                }

                return result;
              } else {
                return me.isGrouped ? me.collectGroupRecords() : me.storage.allValues;
              }
            }
          }, {
            key: "idMap",
            get: function get() {
              var me = this,
                  processedRecords = me.storage.values,
                  needsRebuild = !me._idMap,
                  idMap = me._idMap || (me._idMap = {});

              if (needsRebuild) {
                for (var record, index = 0, visibleIndex = 0; index < processedRecords.length; index++) {
                  record = processedRecords[index];
                  idMap[record.id] = {
                    index: index,
                    visibleIndex: visibleIndex,
                    record: record
                  };

                  if (!record.meta.specialRow) {
                    visibleIndex++;
                  }
                }
              }

              return idMap;
            }
            /**
             * Class used to represent records. Defaults to class Model.
             * @property {Common.data.Model}
             * @category Records
             * @typings { new(data: object): Model }
             */

          }, {
            key: "modelClass",
            get: function get() {
              return this._modelClass;
            },
            set: function set(ClassDef) {
              var fields = this.fields; // noinspection JSRedeclarationOfBlockScope

              var ClassDefEx = null; // Ensure our modelClass is exchanged for an extended of modelClass decorated with any configured fields.

              if (fields && fields.length) {
                ClassDefEx =
                /*#__PURE__*/
                function (_ClassDef) {
                  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(ClassDefEx, _ClassDef);

                  function ClassDefEx() {
                    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, ClassDefEx);

                    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(ClassDefEx).apply(this, arguments));
                  }

                  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_14___default()(ClassDefEx, null, [{
                    key: "fields",
                    get: function get() {
                      return fields;
                    }
                  }]);

                  return ClassDefEx;
                }(ClassDef);
              } // If we expose properties on Model we will pollute all other models, use internal subclass instead
              else {
                  ClassDefEx =
                  /*#__PURE__*/
                  function (_ClassDef2) {
                    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(ClassDefEx, _ClassDef2);

                    function ClassDefEx() {
                      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, ClassDefEx);

                      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(ClassDefEx).apply(this, arguments));
                    }

                    return ClassDefEx;
                  }(ClassDef);
                } // Need to properly expose relations on this new subclass


              ClassDefEx.exposeRelations();
              this._modelClass = ClassDefEx;
            } //endregion
            //region Store id & map
            // Deprecated.
            // TODO: Remove in 2.0 when all references have been removed from Scheduler and Gantt

          }, {
            key: "storeId",
            set: function set(storeId) {
              this.id = storeId;
            },
            get: function get() {
              return this.id;
            }
            /**
             * Get/set id, an unique identifier for the store.
             * Used to build a store map, use Store#getStore() to retrieve a store from the map.
             * @property {String|Number}
             * @category Store
             */

          }, {
            key: "id",
            set: function set(id) {
              var me = this;

              if (me._id) {
                delete Store.storeMap[me._id];
              }

              me._id = id === true ? _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_39__["default"].generateId('store-') : id;

              if (id) {
                Store.storeMap[id] = me;
              }
            },
            get: function get() {
              return this._id;
            }
          }, {
            key: "tree",
            get: function get() {
              return this._tree;
            },
            set: function set(tree) {
              this._tree = tree;

              if (tree && !this.rootNode) {
                this.rootNode = this.buildRootNode();
              }
            }
          }, {
            key: "rootNode",
            //endregion
            //region Data

            /**
             * The invisible root node of this tree.
             * @property {Common.data.Model}
             * @readonly
             */
            get: function get() {
              return this._rootNode;
            },
            set: function set(rootNode) {
              var me = this,
                  oldRoot = me._rootNode; // No change

              if (rootNode === oldRoot) {
                return;
              }

              if (oldRoot) {
                me.clear(false);
              }

              if (rootNode instanceof _Model_js__WEBPACK_IMPORTED_MODULE_23__["default"]) {
                // We insist that the rootNode is expanded otherwise no children will be added
                rootNode.instanceMeta(me).collapsed = false;
                me._rootNode = rootNode;
              } else {
                me._rootNode = rootNode = new me.modelClass(Object.assign(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({
                  expanded: true
                }, me.modelClass.idField, "".concat(me.id, "-rootNode")), rootNode), me, null, true);
                rootNode.isAutoRoot = true;
              }

              me._tree = true;
              rootNode.isRoot = true;
              rootNode.joinStore(me); // If there are nodes to be inserted into the flat storage
              // then onNodeAddChild knows how to do that and what events
              // to fire based upon rootNode.isLoading.

              if (rootNode.children && rootNode.children.length || me.rootVisible) {
                rootNode.isLoading = true;
                me.onNodeAddChild(rootNode, rootNode.children || [], 0);
                rootNode.isLoading = false;
              }

              me.trigger('rootChange', {
                oldRoot: oldRoot,
                rootNode: rootNode
              });
            }
            /**
             * Sets data in the store, called on initialization if data is in config otherwise call it yourself after
             * ajax call etc. Can also be used to get the raw original data.
             * @property {Object[]}
             * @fires refresh
             * @fires change
             * @category Records
             */

          }, {
            key: "data",
            set: function set(data) {
              var me = this; // Make sure that if the plugins have not been processed yet, we call
              // the temporary property getter which configuration injects to
              // process plugins at this point. Some plugins are required to
              // operate on incoming data.

              me._thisIsAUsedExpression(me.plugins); // In case someone is listening for load


              me.processConfiguredListeners();
              me._data = data; // Convert to being a tree store if any of the new rows have a children property

              me.tree = !me.chained && (me.tree || Boolean(me.autoTree && data && data.some(function (r) {
                return r[me.modelClass.childrenField];
              }))); // This means load the root node

              if (me.tree) {
                var root = me.rootNode; // Should signal stores to clear which clears UIs

                root.clearChildren();
                root.isLoading = true; // Append child will detect that this is a dataset operation and trigger sort + events needed

                root.appendChild(data);
                me.updateDependentStores('dataset', [root]);
                root.isLoading = false;
              } else {
                me.loadData(data);
              } // loading the store discards all tracked changes


              me.added.clear();
              me.removed.clear();
              me.modified.clear();
            },
            get: function get() {
              return this._data;
            }
          }, {
            key: "originalCount",
            get: function get() {
              return this.storage.totalCount;
            }
            /**
             * Record count, including records added for group headers etc.
             * @property {Number}
             * @readonly
             * @category Records
             */

          }, {
            key: "count",
            get: function get() {
              return this.storage.count;
            }
          }, {
            key: "allCount",
            get: function get() {
              return this.tree ? this.rootNode.descendantCount : this.storage.totalCount;
            } //endregion
            //region Get record(s)

            /**
             * Returns all "visible" records
             * @property {Common.data.Model[]}
             * @readonly
             * @category Records
             */

          }, {
            key: "records",
            get: function get() {
              return this.storage.values;
            }
            /**
             * Get the first record in the store.
             * @property {Common.data.Model}
             * @readonly
             * @category Records
             */

          }, {
            key: "first",
            get: function get() {
              return this.storage.values[0];
            }
            /**
             * Get the last record in the store.
             * @property {Common.data.Model}
             * @readonly
             * @category Records
             */

          }, {
            key: "last",
            get: function get() {
              return this.storage.values[this.storage.values.length - 1];
            }
          }, {
            key: "registeredRecords",
            get: function get() {
              return Object.values(this.idRegister);
            }
          }, {
            key: "json",
            get: function get() {
              return JSON.stringify(this, null, 4);
            }
          }], [{
            key: "getStore",
            value: function getStore(id, storeClass) {
              if (id instanceof Store) {
                return id;
              }

              if (this.storeMap[id]) {
                return this.storeMap[id];
              }

              if (Array.isArray(id)) {
                var storeModel;
                var storeData = id.map(function (item) {
                  if (item instanceof _Model_js__WEBPACK_IMPORTED_MODULE_23__["default"]) {
                    storeModel = item.constructor;
                  } else if (typeof item === 'string') {
                    item = {
                      text: item
                    };
                  } else {}

                  return item;
                });
                id = {
                  autoCreated: true,
                  data: storeData,
                  modelClass: storeModel ||
                  /*#__PURE__*/
                  function (_Model) {
                    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_18___default()(_class, _Model);

                    function _class() {
                      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_13___default()(this, _class);

                      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_15___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_16___default()(_class).apply(this, arguments));
                    }

                    return _class;
                  }(_Model_js__WEBPACK_IMPORTED_MODULE_23__["default"])
                };

                if (!storeClass) {
                  storeClass = Store;
                }
              }

              if (storeClass) {
                return new storeClass(id);
              }
            }
            /**
             * Get all registered stores
             * @returns {Common.data.Store[]}
             */

          }, {
            key: "properties",
            //region Config & properties
            get: function get() {
              return {
                relationCache: {},
                dependentStoreConfigs: new Map()
              };
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Deprecated in favour of {@link #config-id}
                 * @config {String|Number}
                 * @deprecated 2.0.0
                 */
                storeId: null,

                /**
                 * Store's unique identifier. When set the store is added to a store map accessible through Store#getStore(id)
                 * @config {String|Number}
                 * @category Common
                 */
                id: true,

                /**
                 * An array of field definitions used to create a Model (modelClass) subclass. Optional. If the Model
                 * already has fields defined, these fields will extend those.
                 * @config {Object[]}
                 * @category Common
                 */
                fields: null,

                /**
                 * Automatically detect from set data if used as tree store or flat store
                 * @config {Boolean}
                 * @default
                 * @category Tree
                 */
                autoTree: true,

                /**
                 * Class used to represent records
                 * @config {Common.data.Model}
                 * @default
                 * @category Common
                 * @typings { new(data: object): Model }
                 */
                modelClass: _Model_js__WEBPACK_IMPORTED_MODULE_23__["default"],

                /**
                 * Raw data to load initially
                 * @config {Object[]}
                 * @category Common
                 */
                data: null,

                /**
                 * `true` to act as a tree store.
                 * @config {Boolean}
                 * @category Tree
                 */
                tree: false,
                callOnFunctions: true,

                /**
                 * A {@link Common.util.Collection Collection}, or Collection config object
                 * to use to contain this Store's constituent records.
                 * @config {Common.util.Collection/Object}
                 */
                storage: null,

                /**
                 * Specify `true` to use the raw data when loading the store. This improves load performance, but comes
                 * with some caveats:
                 * * Data must not contain duplicate ids, duplication check is bypassed.
                 * * Default values will not be applied to fields.
                 * * No type conversions will be performed.
                 */
                useRawData: null
              };
            }
          }, {
            key: "stores",
            get: function get() {
              return Object.values(this.storeMap);
            }
          }]);

          return Store;
        }(Object(_helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_25__["base"])(_Base_js__WEBPACK_IMPORTED_MODULE_19__["default"]).mixes(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_21__["default"], _mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_20__["default"], _mixin_State_js__WEBPACK_IMPORTED_MODULE_22__["default"], _mixin_StoreFilter_js__WEBPACK_IMPORTED_MODULE_29__["default"], _mixin_StoreCRUD_js__WEBPACK_IMPORTED_MODULE_28__["default"], _mixin_StoreRelation_js__WEBPACK_IMPORTED_MODULE_31__["default"], _mixin_StoreSum_js__WEBPACK_IMPORTED_MODULE_32__["default"], _mixin_StoreSearch_js__WEBPACK_IMPORTED_MODULE_33__["default"], _mixin_StoreSort_js__WEBPACK_IMPORTED_MODULE_34__["default"], _mixin_StoreGroup_js__WEBPACK_IMPORTED_MODULE_30__["default"], _mixin_StoreChained_js__WEBPACK_IMPORTED_MODULE_35__["default"], _mixin_StoreState_js__WEBPACK_IMPORTED_MODULE_36__["default"], _mixin_StoreTree_js__WEBPACK_IMPORTED_MODULE_37__["default"], _stm_mixin_StoreStm_js__WEBPACK_IMPORTED_MODULE_38__["default"]));

        Store.storeMap = {};
        Store._$name = 'Store';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreCRUD.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreCRUD.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreCRUDJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "../Grid/node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "../Grid/node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../helper/ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreCRUD
         */

        /**
         * Mixin for Store that handles modifying records (add, remove etc).
         *
         * @example
         * // add new record to store
         * store.add({ id: 1, team: 'FC Krasnodar' });
         *
         * // remove a record from store, using id
         * store.remove(1);
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(StoreCRUD, _ref);

              function StoreCRUD() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StoreCRUD);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StoreCRUD).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(StoreCRUD, [{
                key: "remove",
                //endregion
                //region Events

                /**
                 * Fired after removing all records
                 * @event removeAll
                 * @param {Common.data.Store} source This Store
                 */

                /**
                 * Fired before committing changes. Return false from handler to abort commit
                 * @event beforeCommit
                 * @param {Common.data.Store} source This Store
                 * @param {Object} changes Modification data
                 */

                /**
                 * Fired after committing changes
                 * @event commit
                 * @param {Common.data.Store} source This Store
                 * @param {Object} changes Modification data
                 */

                /**
                 * Fired before records are removed from this store by the {@link #function-remove} or {@link #function-removeAll}.
                 * Also fired when removing a child record in a tree store using {@link Common.data.mixin.TreeNode#function-removeChild}.
                 * The remove may be vetoed by returning `false` from a handler.
                 * @event beforeRemove
                 * @param {Common.data.Store} source This Store
                 * @param {Common.data.Model[]} records The records which are to be removed.
                 * @param {Common.data.Model} parent The record from which children are being removed when using a tree store
                 * @param {Boolean} isMove Set to `true` if the child node is being removed by
                 * {@link Common.data.mixin.TreeNode#function-appendChild appendChild} to be moved
                 * _within the same tree_.
                 * @param {Boolean} removingAll Set to `true` if the operation is removing the store's entire data set.
                 */

                /**
                 * Fired before records are added to this store by the {@link #function-add} or {@link #function-insert}. In a tree
                 * store, also fired by {@link Common.data.mixin.TreeNode#function-appendChild} and
                 * {@link Common.data.mixin.TreeNode#function-insertChild}. The add or insert may be vetoed by returning `false`
                 * from a handler.
                 * @event beforeAdd
                 * @param {Common.data.Store} source This Store
                 * @param {Common.data.Model[]} records The records which are to be added
                 * @param {Common.data.Model} parent The parent node when using a tree store
                 * @preventable
                 */

                /**
                 * Fired after adding/inserting record(s). If the record was added to a parent, the `isChild` flag is set on the
                 * event. If it was inserted, event contains `index`
                 * @event add
                 * @param {Common.data.Store} source This Store
                 * @param {Common.data.Model[]} records Added records. In case of tree store, if branch is added, only branch root
                 * is returned
                 * @param {Common.data.Model[]} [allRecords] Flat list of all added records. In case of tree store, if branch is
                 * added, all new records are returned, not only branch root
                 * @param {Common.data.Model} [parent] If due to a {@link Common.data.mixin.TreeNode#function-appendChild appendChild}
                 * call, this is the parent node added to.
                 * @param {Number} [index] Set if record was inserted as opposed to appended/added
                 * @param {Number} [oldIndex] Set if inserted record was moved within the store
                 * @param {Boolean} [isChild] Flag which is set to true if the record is added to a parent record
                 * @param {Boolean} [isExpand] Flag which is set to true if records are added to the store by expanding parent
                 * @param {Common.data.Model} [oldParent] Previous parent if this record was moved within a tree structure
                 * @param {Boolean} [isMove] Passed as `true` if the add was part of a move operation within this Store.
                 */

                /**
                 * Fired when a record has been removed
                 * @event remove
                 * @param {Common.data.Store} source This Store
                 * @param {Common.data.Model[]} records Removed records. In case of tree store, if branch is removed, only branch root
                 * is returned
                 * @param {Common.data.Model[]} [allRecords] Flat list of all removed records. In case of tree store, if branch is
                 * removed, all removed records are returned, not only branch root
                 * @param {Common.data.Model} [parent] If due to a {@link Common.data.mixin.TreeNode#function-removeChild removeChild}
                 * call, this is the parent node removed from.
                 * @param {Number} [index] Visible index at which record was removed. In case record is removed from the collapsed
                 * branch -1 is returned.
                 * @param {Boolean} [isChild] Flag which is set to true if the record is added to a parent record
                 * @param {Boolean} [isCollapse] Flag which is set to true if records are removed from the store by collapsing parent
                 * @param {Boolean} [isMove] Passed as `true` if the remove was part of a move operation within this Store.
                 */
                //endregion
                //region Add, insert & remove

                /**
                 * Removes a record from this store.
                 * @param {String|String[]|Number|Number[]|Common.data.Model|Common.data.Model[]} records Record/array of records (or record ids) to remove
                 * @param {Boolean} silent Specify true to suppress events/autoCommit
                 * @returns {Common.data.Model[]} Removed records
                 * @fires beforeRemove
                 * @fires remove
                 * @fires change
                 * @category CRUD
                 */
                value: function remove(records) {
                  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var fromRemoveChild = arguments.length > 2 ? arguments[2] : undefined;
                  var me = this,
                      storage = me.storage; // Ensure we have an array of records in case we are passed IDs

                  records = (Array.isArray(records) ? records : [records]).reduce(function (result, r) {
                    r = me.getById(r);

                    if (r) {
                      result.push(r);
                    }

                    return result;
                  }, []);

                  if (records.length) {
                    if (me.tree) {
                      // In case it's a set of records from different parents, group them by parent
                      var removeChildArgs = records.reduce(function (result, child) {
                        var parent = child.parent;

                        if (parent) {
                          if (!result[parent.id]) {
                            result[parent.id] = [parent, []];
                          }

                          result[parent.id][1].push(child);
                        }

                        return result;
                      }, {}); // Remove the records each from their correct parent

                      var _arr = Object.values(removeChildArgs);

                      for (var _i = 0; _i < _arr.length; _i++) {
                        var argBlock = _arr[_i];
                        argBlock[0].removeChild(argBlock[1], false, fromRemoveChild);
                      }

                      return records;
                    } // Ensure that records in collapsed groups are removed and events fired.
                    else if (me.isGrouped) {
                        var oldCount = storage.count,
                            recordsInCollapsedGroups = [],
                            changedGroupParents = new Set(); // Collect any records which are in collapsed groups which will not be in the storage
                        // Collection, and so will not cause a store change.
                        // If we find some, we must fire the event which the store will react to and update itself.

                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                          for (var _iterator = records[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var rec = _step.value;

                            var _rec$instanceMeta = rec.instanceMeta(me),
                                groupParent = _rec$instanceMeta.groupParent;

                            if (groupParent && groupParent.meta.collapsed) {
                              recordsInCollapsedGroups.push(rec);
                            } // Collect group header records which change so they can announce this to cause UI updates.


                            _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].remove(groupParent.groupChildren, rec);

                            groupParent.meta.childCount--;
                            changedGroupParents.add(groupParent);
                          } // The changed group parents must announce their changes, otherwise the group headers
                          // in a UI will not refresh to reflect the change.

                        } catch (err) {
                          _didIteratorError = true;
                          _iteratorError = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                              _iterator.return();
                            }
                          } finally {
                            if (_didIteratorError) {
                              throw _iteratorError;
                            }
                          }
                        }

                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                          for (var _iterator2 = changedGroupParents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                            var groupParent = _step2.value;
                            me.onModelChange(groupParent, {}, {});
                          } // The store must react as if these records in collapsed groups have been removed from storage

                        } catch (err) {
                          _didIteratorError2 = true;
                          _iteratorError2 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                              _iterator2.return();
                            }
                          } finally {
                            if (_didIteratorError2) {
                              throw _iteratorError2;
                            }
                          }
                        }

                        if (recordsInCollapsedGroups.length) {
                          storage.trigger('change', {
                            action: 'splice',
                            removed: recordsInCollapsedGroups,
                            added: [],
                            replaced: [],
                            oldCount: oldCount
                          });
                        }
                      } // Give chance to veto or take action before records disappear.


                    if (!records.length || !silent && me.trigger('beforeRemove', {
                      records: records
                    }) === false) {
                      return null;
                    }

                    if (silent) {
                      me.suspendEvents();
                    }

                    storage.remove(records);

                    if (silent) {
                      me.resumeEvents();
                    }

                    if (me.autoCommit) {
                      me.commit();
                    }
                  }

                  return records;
                }
                /**
                 * Clears store data. Used by removeAll, separate function for using with chained stores.
                 * @private
                 * @category CRUD
                 */

              }, {
                key: "clear",
                value: function clear() {
                  var removing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                  var me = this,
                      storage = me.storage;

                  if (me.storage.totalCount) {
                    // Give chance to veto or take action before records disappear.
                    if (removing && me.trigger('beforeRemove', {
                      records: storage.allValues,
                      removingAll: true
                    }) === false) {
                      return null;
                    }

                    if (!removing) {
                      // If !removing, we suspend events, and Store#onDataChange won't get to
                      // do all this stuff.
                      var allRecords = me.registeredRecords;

                      for (var i = allRecords.length - 1, rec; i >= 0; i--) {
                        rec = allRecords[i];

                        if (rec && !rec.isDestroyed) {
                          rec.unJoinStore(me);
                        }
                      }

                      me.removed.clear();
                    }

                    if (!removing) storage.suspendEvents(); // Clearing the storage will trigger 'removeAll' and 'change' if `removing`

                    storage.clear();
                    if (!removing) storage.resumeEvents();
                    me.added.clear();
                    me.modified.clear();
                  }
                }
                /**
                 * Removes all records from the store.
                 * @param silent
                 * @fires removeAll
                 * @fires change
                 * @category CRUD
                 */

              }, {
                key: "removeAll",
                value: function removeAll(silent) {
                  var me = this,
                      storage = me.storage; // No reaction to the storage Collection's change event.

                  if (silent) {
                    storage.suspendEvents(); // If silent, the storage Collection won't fire the event we react to
                    // to unjoin, and we allow the removing flag in remove() to be true,
                    // so *it* will not do the unJoin, so if silent, so do it here.

                    var allRecords = me.registeredRecords;

                    for (var i = allRecords.length - 1, rec; i >= 0; i--) {
                      rec = allRecords[i];

                      if (rec && !rec.isDestroyed) {
                        rec.unJoinStore(me);
                      }
                    }
                  }

                  if (me.tree) {
                    me.rootNode.clear();
                  } else {
                    me.clear();
                  }

                  if (silent) {
                    storage.resumeEvents();
                  }
                }
                /**
                 * Add records to store.
                 * @param {Common.data.Model|Common.data.Model[]|Object|Object[]} records Array of records/data or a single record/data to add to store
                 * @param {Boolean} [silent] Specify true to suppress events
                 * @returns {Common.data.Model[]} Added records
                 * @fires add
                 * @fires change
                 * @category CRUD
                 */

              }, {
                key: "add",
                value: function add(records) {
                  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var me = this,
                      storage = me.storage,
                      added = [];

                  if (!Array.isArray(records)) {
                    records = [records];
                  } else if (!records.length) {
                    // Adding zero records, bail out
                    return;
                  }

                  me.tree = me.tree || Boolean(me.autoTree && records[0].children);

                  if (me.tree) {
                    return me.rootNode.appendChild(records, silent);
                  } // Give chance to cancel action before records added.


                  if (!silent) {
                    if (me.trigger('beforeAdd', {
                      records: records
                    }) === false) {
                      return null;
                    }
                  }

                  records.forEach(function (data) {
                    added.push(data instanceof _Model_js__WEBPACK_IMPORTED_MODULE_13__["default"] ? data : me.createRecord(data));
                  });

                  if (silent) {
                    me.suspendEvents();
                  }

                  storage.add(added);

                  if (silent) {
                    me.resumeEvents();
                  }

                  if (me.autoCommit) {
                    me.commit();
                  }

                  return added;
                }
                /**
                 * Insert records to store.
                 * @param index Index to insert at
                 * @param records Record(s) or data to insert
                 * @returns {Common.data.Model[]} Inserted records
                 * @fires add
                 * @fires change
                 * @category CRUD
                 */

              }, {
                key: "insert",
                value: function insert(index, records) {
                  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var me = this,
                      storage = me.storage,
                      added = [],
                      insertBefore = me.getAt(index),
                      _records = storage.values,
                      removeIndices = [];
                  if (!Array.isArray(records)) records = [records]; // Give chance to cancel action before records added.

                  if (me.trigger('beforeAdd', {
                    records: records
                  }) === false) {
                    return null;
                  }

                  var isNoop, start, i; // If the records starting at index or (index - 1), are the same sequence
                  // that we are being asked to add, this is a no-op.

                  if (_records[start = index] === records[0] || _records[start = index - 1] === records[0]) {
                    for (isNoop = true, i = 0; isNoop && i < records.length; i++) {
                      if (records[i] !== _records[start + i]) {
                        isNoop = false;
                      }
                    }
                  }

                  if (isNoop) {
                    return;
                  }

                  records.forEach(function (data) {
                    var record = data instanceof _Model_js__WEBPACK_IMPORTED_MODULE_13__["default"] ? data : me.createRecord(data),
                        removedAtIndex = storage.indexOf(record);

                    if (record.children && record.children.length && me.autoTree) {
                      me.tree = true;
                    }

                    added.push(record); // already in store, do some cleanup

                    if (removedAtIndex > -1) {
                      if (removedAtIndex < index && insertBefore) index--;
                      removeIndices.push(removedAtIndex);
                    } // Store previous index to be able to determine that it is a move, since Collection does not handle that


                    record.meta.previousIndex = removedAtIndex;
                  });

                  if (me.tree) {
                    var root = me.rootNode;
                    return root.insertChild(records, root.children && root.children[index]);
                  } // Silently remove them, so that they will be inserted into place.
                  // Collection is stable by default, and inserting an existing item
                  // is a no-op.


                  me.suspendEvents();
                  me.storage.remove(removeIndices);
                  me.resumeEvents();

                  if (silent) {
                    me.suspendEvents();
                  }

                  storage.splice.apply(storage, [index, 0].concat(added));

                  if (silent) {
                    me.resumeEvents();
                  }

                  if (me.autoCommit) {
                    me.commit();
                  }

                  return added;
                }
                /**
                 * Moves an individual item to another location.
                 * @param {Object} item The item to move.
                 * @param {Object} beforeItem the item to insert the first item before.
                 */

              }, {
                key: "move",
                value: function move(item, beforeItem) {
                  this.storage.move(item, beforeItem);
                } //endregion
                //region Update multiple

              }, {
                key: "setMultiple",
                value: function setMultiple(filterFn, field, value) {
                  var me = this,
                      records = [],
                      changes = [];
                  me.forEach(function (r) {
                    if (filterFn(r)) {
                      changes.push(r.set(field, value, true));
                      records.push(r);
                    }
                  }); // TODO: should consolidate with update, make it take an array instead? to only have to listen for one event outside of store?

                  me.trigger('updateMultiple', {
                    records: records,
                    all: me.records.length === records.length
                  });
                  me.trigger('change', {
                    action: 'updatemultiple',
                    records: records,
                    all: me.records.length === records.length
                  });
                  if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
                }
              }, {
                key: "setAll",
                value: function setAll(field, value) {
                  var me = this,
                      changes = [];
                  me.forEach(function (r) {
                    changes.push(r.set(field, value, true));
                  });
                  me.trigger('updateMultiple', {
                    records: me.records,
                    all: true
                  });
                  me.trigger('change', {
                    action: 'updatemultiple',
                    records: me.records,
                    all: true
                  });
                  if (me.reapplyFilterOnUpdate && me.isFiltered) me.filter();
                } //endregion
                //region Commit

                /**
                 * Commits changes, per default only returns changes and resets tracking.
                 * @returns {Object} Changes, see Store#changes
                 * @fires beforeCommit
                 * @fires commit
                 * @category CRUD
                 */

              }, {
                key: "commit",
                value: function commit() {
                  // resets stores tracking of changed records, doesn't store changes, only returns them
                  var me = this,
                      changes = me.changes;
                  return me.callPreventable('commit', {
                    changes: changes
                  }, function () {
                    me.modified.forEach(function (r) {
                      return r.clearChanges(false);
                    });
                    me.added.clear();
                    me.modified.clear();
                    me.removed.clear();
                    return changes;
                  });
                }
                /**
                 * Discards changes in the store.
                 * @fires change
                 * @category CRUD
                 * @private
                 */
                // TODO: Need to think of its name. `reject` is a candidate.

              }, {
                key: "clearChanges",
                value: function clearChanges() {
                  var me = this;
                  me.remove(me.added.values, true);
                  me.modified.forEach(function (r) {
                    return r.clearChanges(false);
                  }); // TODO: removed records should be restored

                  me.added.clear();
                  me.modified.clear();
                  me.removed.clear();
                  me.trigger('change', {
                    action: 'clearchanges'
                  });
                }
                /**
                 * Get uncommitted changes as an object of added/modified/removed arrays of records.
                 *
                 * ```
                 * // Format:
                 * {
                 *      added: [], // array of Common.data.Model
                 *      modified: [], // array of Common.data.Model
                 *      removed: [] // array of Common.data.Model
                 * }
                 * ```
                 *
                 * @property {Object} changes
                 * @property {Array} changes.added Records that have been added
                 * @property {Array} changes.modified Records that have been updated
                 * @property {Array} changes.removed Records that have been removed
                 * @readonly
                 * @category Records
                 */

              }, {
                key: "applyChangesFromStore",
                //endregion
                //region Changes from other store

                /**
                 * Applies changes from another store to this store. Usefull if cloning records in one store to display in a
                 * grid in a popup etc. to reflect back changes.
                 * @param {Common.data.Store} otherStore
                 * @category CRUD
                 */
                value: function applyChangesFromStore(otherStore) {
                  var me = this,
                      changes = otherStore.changes;
                  if (!changes) return;

                  if (changes.added) {
                    me.add(changes.added);
                  }

                  if (changes.removed) {
                    // Remove using id, otherwise indexOf in remove fn won't yield correct result
                    me.remove(changes.removed.map(function (r) {
                      return r.id;
                    }));
                  }

                  if (changes.modified) {
                    changes.modified.forEach(function (record) {
                      var localRecord = me.getById(record.id);
                      localRecord.set(record.modifications);
                    });
                  }
                } //endregion

              }, {
                key: "changes",
                get: function get() {
                  var me = this;
                  return me.added.count || me.modified.count || me.removed.count ? {
                    // Slicing to have changes intact when triggering commit
                    added: me.added.values.slice(),
                    modified: me.modified.values.slice(),
                    removed: me.removed.values.slice()
                  } : null;
                }
                /**
                 * Setting autoCommit to true automatically commits changes to records.
                 * @property {Boolean}
                 * @category Records
                 */

              }, {
                key: "autoCommit",
                get: function get() {
                  return this._autoCommit;
                },
                set: function set(auto) {
                  this._autoCommit = auto;
                  if (auto && this.changes) this.commit();
                }
              }], [{
                key: "defaultConfig",
                //region Config
                get: function get() {
                  return {
                    /**
                     * Commit changes automatically
                     * @config {Boolean}
                     * @default
                     * @category Common
                     */
                    autoCommit: false
                  };
                }
              }]);

              return StoreCRUD;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreChained.js":
      /*!*****************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreChained.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreChainedJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler'; // TODO: turn into plugin instead?

        /**
         * @module Common/data/mixin/StoreChained
         */

        /**
         * A chained Store contains a subset of records from a master store. Which records to include is determined by a
         * filtering function, {@link #config-chainedFilterFn}.
         *
         * @example
         * masterStore.makeChained(record => record.percent < 10);
         *
         * // or
         *
         * new Store({
         *   chained         : true,
         *   masterStore     : masterStore,
         *   chainedFilterFn : record => record.percent < 10
         * });
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(StoreChained, _ref);

              function StoreChained() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, StoreChained);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(StoreChained).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(StoreChained, [{
                key: "construct",
                //endregion
                value: function construct(config) {
                  var me = this;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(StoreChained.prototype), "construct", this).call(this, config); // TODO: No need for two configs which both mean the same thing. masterStore configured means it's changed.


                  if (me.chained) {
                    if (!me.masterStore) {
                      throw new Error('masterStore required on a chained store');
                    }

                    me.methodNamesToRelay.forEach(function (fnName) {
                      return me[fnName] = function () {
                        for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
                          params[_key] = arguments[_key];
                        }

                        return me.relayToMaster(fnName, params);
                      };
                    }); // TODO: prevent other functions?

                    me.masterStore.on({
                      change: me.onMasterDataChanged,
                      prio: 1,
                      thisObj: me
                    });

                    if (!me.masterStore.chainedStores) {
                      me.masterStore.chainedStores = [];
                    }

                    me.masterStore.chainedStores.push(me);
                    me.fillFromMaster();
                  }
                } //region Properties

                /**
                 * Is this a chained store?
                 * @property {Boolean}
                 * @readonly
                 * @category Store
                 */

              }, {
                key: "updateChainedStores",
                //endregion
                //region Internal
                value: function updateChainedStores() {
                  if (this.chainedStores) {
                    this.chainedStores.forEach(function (store) {
                      return store.fillFromMaster();
                    });
                  }
                }
                /**
                 * Updates records available in a chained store by filtering the master store records using
                 * {@link #config-chainedFilterFn}
                 * @internal
                 */

              }, {
                key: "fillFromMaster",
                value: function fillFromMaster() {
                  var me = this;

                  if (!me.chained) {
                    throw new Error('fillFromMaster only allowed on chained store');
                  }

                  if (me.keepUncommittedChanges) {
                    me.data = [].concat(me.added.values.filter(function (r) {
                      return !me.removed.includes(r);
                    }), me.masterStore.allRecords.filter(function (r) {
                      return !me.removed.includes(r) && !me.added.includes(r) && me.chainedFilterFn(r);
                    }));
                  } else {
                    me.data = me.masterStore.allRecords.filter(me.chainedFilterFn);
                  }
                }
                /**
                 * Commits changes back to master.
                 * - the records deleted from chained store and present in master will be deleted from master
                 * - the records added to chained store and missing in master will added to master
                 * Internally calls {Store#function-commit commit()}.
                 * @returns {Object} Changes, see Store#changes
                 * @internal
                 */

              }, {
                key: "commitToMaster",
                value: function commitToMaster() {
                  var me = this,
                      master = me.masterStore;

                  if (!me.chained) {
                    throw new Error('commitToMaster only allowed on chained store');
                  }

                  master.beginBatch();
                  master.remove(me.removed.values);
                  master.add(me.added.values);
                  master.endBatch();
                  return me.commit();
                }
                /**
                 * Relays some function calls to the master store
                 * @private
                 */

              }, {
                key: "relayToMaster",
                value: function relayToMaster(fnName, params) {
                  var _this$masterStore;

                  if (fnName === 'remove' && params.length === 4 && params[3] === true) return;
                  return (_this$masterStore = this.masterStore)[fnName].apply(_this$masterStore, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(params));
                }
                /**
                 * Handles changes in master stores data. Updates the chained store accordingly
                 * @private
                 */

              }, {
                key: "onMasterDataChanged",
                value: function onMasterDataChanged(_ref2) {
                  var action = _ref2.action,
                      changes = _ref2.changes;
                  var me = this;

                  if (action === 'update') {
                    // if a field not defined in chainedFields is changed, ignore the change.
                    // there is no need to refilter the store in such cases, the change will be available anyhow since data is
                    // shared
                    var refilter = me.chainedFields && me.chainedFields.some(function (field) {
                      return field in changes;
                    });
                    if (!refilter) return;
                  }

                  me.fillFromMaster();
                } //endregion

              }, {
                key: "isChained",
                get: function get() {
                  return this.chained;
                }
              }, {
                key: "chainedFilterFn",
                set: function set(chainedFilterFn) {
                  this._chainedFilterFn = this.thisObj ? chainedFilterFn.bind(this.thisObj) : chainedFilterFn;
                },
                get: function get() {
                  return this._chainedFilterFn;
                }
              }, {
                key: "methodNamesToRelay",
                get: function get() {
                  var _this = this;

                  var doIsArray = Array.isArray(this.doRelayToMaster),
                      dontIsArray = Array.isArray(this.dontRelayToMaster);
                  return doIsArray && this.doRelayToMaster.filter(function (name) {
                    return !dontIsArray || !_this.dontRelayToMaster.includes(name);
                  }) || [];
                }
              }], [{
                key: "defaultConfig",
                //region Config
                get: function get() {
                  return {
                    /**
                     * Create a chained store, must also specify masterStore and chainedFilterFn
                     * @config {Boolean}
                     * @default
                     * @category Chained store
                     */
                    chained: false,

                    /**
                     * Function used to filter records in the masterStore into a chained store
                     * @config {Function}
                     * @category Chained store
                     */
                    chainedFilterFn: null,

                    /**
                     * Array of fields that should trigger filtering of chained store when the fields are updated.
                     * @config {String[]}
                     * @category Chained store
                     */
                    chainedFields: null,

                    /**
                     * Master store that a chained store gets its records from.
                     * @config {Store}
                     * @category Chained store
                     */
                    masterStore: null,

                    /**
                     * Method names calls to which should be relayed to master store.
                     * @config {String[]}
                     * @category Chained store
                     */
                    doRelayToMaster: ['add', 'remove', 'insert', 'removeAll'],

                    /**
                     * Method names calls to which shouldn't be relayed to master store.
                     * @config {String}
                     * @category Chained store
                     */
                    dontRelayToMaster: [],

                    /**
                     * Flag showing whether to keep added/removed uncommitted records when filling the store from master.
                     * @config {Boolean}
                     * @category Chained store
                     */
                    keepUncommittedChanges: false
                  };
                }
              }]);

              return StoreChained;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_11__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreFilter.js":
      /*!****************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreFilter.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreFilterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../util/CollectionFilter.js */
        "../Grid/lib/Common/util/CollectionFilter.js");
        /* harmony import */


        var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../helper/FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony import */


        var _util_Collection_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreFilter
         */

        /**
         * Mixin for Store that handles filtering.
         * Filters are instances of {@link Common.util.CollectionFilter CollectionFilter} class.
         *
         * - Adding a filter for the same property will replace the current one (unless a unique {@link Common.util.CollectionFilter#config-id Id} is specified),
         * but will not clear any other filters.
         * - Adding a filter through the {@link #function-filterBy} function is ultimate.
         * It will clear all the property based filters and replace the current filterBy function if present.
         * - Removing records from the store does not remove filters!
         * The filters will be reapplied if {@link #config-reapplyFilterOnAdd}/{@link #config-reapplyFilterOnUpdate} are true and you add new records or update current.
         *
         * ```
         * // Add a filter
         * store.filter({
         *   property : 'score',
         *   value    : 10,
         *   operator : '>'
         * });
         *
         * // Reapply filters
         * store.filter();
         * ```
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(StoreFilter, _ref);

              function StoreFilter() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StoreFilter);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StoreFilter).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(StoreFilter, [{
                key: "traverseFilter",
                //endregion
                value: function traverseFilter(record) {
                  var me = this,
                      hitsCurrent = !record.isRoot && me.filtersFunction(record),
                      hitsChild = false,
                      children = record.unfilteredChildren || record.children; // leaf, bail out

                  if (!children || !children.length) {
                    return hitsCurrent;
                  }

                  if (!record.unfilteredChildren) {
                    record.unfilteredChildren = record.children.slice();
                  }

                  record.children = record.unfilteredChildren.filter(function (r) {
                    return me.traverseFilter(r);
                  });
                  if (record.children.length) hitsChild = true;
                  return hitsCurrent || hitsChild;
                }
              }, {
                key: "traverseClearFilter",
                value: function traverseClearFilter(record) {
                  var me = this;

                  if (record.children) {
                    record.children = record.unfilteredChildren || record.children;
                    record.children.forEach(function (r) {
                      return me.traverseClearFilter(r);
                    });
                  }
                } // TODO: Get rid of this.
                // The Filter feature of a Grid pokes around in the Store to ask this question.

              }, {
                key: "processFieldFilter",
                value: function processFieldFilter(filter, value) {
                  if (typeof filter === 'string') {
                    filter = {
                      property: filter,
                      value: value
                    };
                  }

                  filter = filter instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"] ? filter : new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"](filter); // We want notification upon change of field, value or operator

                  filter.owner = this; // Collection will replace any already existing filter on the field, unless it has id specified

                  this.filters.add(filter);
                }
                /**
                 * Filters the store by *adding* the specified filter or filters to the existing filters applied to this Store. Call without arguments to reapply filters.
                 * ```
                 * // Add a filter
                 * store.filter({
                 *   property : 'age',
                 *   operator : '>',
                 *   value    : 90
                 * });
                 *
                 * // Reapply filters
                 * store.filter();
                 * ```
                 * @param {String|Object|Object[]|function} field Field name or a filter config or a function to use for filtering
                 * @param value Value, used if field is a field name and not a config
                 * @fires filter
                 * @fires change
                 * @category Sort, group & filter
                 */

              }, {
                key: "filter",
                value: function filter(field, value) {
                  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var me = this,
                      storage = me.storage,
                      filters = me.filters,
                      rootNode = me.rootNode,
                      oldCount = me.count;

                  if (field) {
                    var fieldType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default()(field); // We will not be informed about Filter mutations while configuring.


                    me.isConfiguring = true; // If we provide array of objects looking like :
                    //  {
                    //      field : 'fieldName',
                    //      value : 'someValue',
                    //      [operator : '>']
                    //  }
                    //  or ...
                    //  {
                    //      field : 'fieldName',
                    //      filterBy : function (value, record) {
                    //          return value > 50;
                    //      }
                    //  }

                    if (Array.isArray(field)) {
                      // we omit "value" argument in this case
                      silent = value;
                      field.forEach(me.processFieldFilter, me);
                    } else if (fieldType === 'function') {
                      me.filters = field;
                    } else {
                      me.processFieldFilter(field, value);
                    } // Open up to recieving Filter mutation notifications again


                    me.isConfiguring = false; // We added a disabled filter to either no filters, or all disabled filters, so no change.

                    if (!me.isFiltered) {
                      return;
                    }
                  } // Invalidate the filtersFunction so that it has to be recalculated upon next access


                  me.filtersFunction = null;

                  if (me.tree) {
                    if (me.isFiltered) {
                      me.traverseFilter(rootNode);
                    } else {
                      me.traverseClearFilter(rootNode);
                    }

                    storage.replaceValues(me.collectDescendants(rootNode).visible, true);
                  } else {
                    if (me.isFiltered) {
                      storage.addFilter({
                        id: 'primary-filter',
                        filterBy: me.filtersFunction
                      });
                    } else {
                      storage.filters.clear();
                    }
                  }

                  me.resetRelationCache();

                  if (!silent) {
                    me.triggerFilterEvent({
                      action: 'filter',
                      filters: filters,
                      oldCount: oldCount,
                      records: me.storage.values
                    });
                  }
                }
              }, {
                key: "triggerFilterEvent",
                // Used from filter() and StoreCRUD when reapplying filters
                value: function triggerFilterEvent(event) {
                  this.trigger('filter', event);
                  this.trigger('refresh', event);
                  this.trigger('change', event);
                }
                /**
                 * Filter store using a function to test each record. Return true from the function to include record in filtered set
                 * @param {Function} fn Function used to test records
                 * @example
                 * store.filterBy(record => record.age > 25 && record.name.startsWith('A'));
                 * @category Sort, group & filter
                 */

              }, {
                key: "filterBy",
                value: function filterBy(fn) {
                  this.filter(fn);
                }
                /**
                 * Removes filtering from the specified field.
                 * @param {String} field Field to not filter the store on any longer
                 * @private
                 * @deprecated
                 * Only used by the Grid Filtering plugin which assumes one Filter per field.
                 * @category Sort, group & filter
                 */

              }, {
                key: "removeFieldFilter",
                value: function removeFieldFilter(field, silent) {
                  var me = this,
                      filter = me.filters.getBy('property', field); // If we have such a filter, remove it.

                  if (filter) {
                    me.filters.remove(filter); // Invalidate the filtersFunction so that it has to be recalculated upon next access

                    me._filtersFunction = null;

                    if (!silent) {
                      me.filter();
                    }
                  }
                }
                /**
                 * Removes all filters from the store.
                 * @category Sort, group & filter
                 */

              }, {
                key: "clearFilters",
                value: function clearFilters(silent) {
                  this.filters.clear();
                  this.filter(undefined, undefined, silent);
                }
              }, {
                key: "convertFilterToString",
                value: function convertFilterToString(field) {
                  var filter = this.filters.getBy('property', field),
                      result = '';

                  if (filter && !filter.filterBy) {
                    result = String(filter);
                  }

                  return result;
                }
              }, {
                key: "filters",
                //endregion
                //region Events

                /**
                 * Fired after applying filters to the store
                 * @event filter
                 * @param {Common.data.Store} source This Store
                 * @param {Common.util.Collection} filters Filters used by this Store
                 * @param {Common.data.Model[]} records Filtered records
                 */
                //endregion
                //region Properties

                /**
                 * Currently applied filters. A collection of {@link Common.util.CollectionFilter} instances.
                 * @type {Common.util.Collection}
                 * @readonly
                 * @category Sort, group & filter
                 */
                set: function set(filters) {
                  var me = this,
                      collection = me.filters;
                  collection.clear(); // Invalidate the filtersFunction so that it has to be recalculated upon next access

                  me._filtersFunction = null; // If we are being asked to filter, parse the filters.

                  if (filters) {
                    if (filters.constructor.name === 'Object') {
                      var _arr = Object.entries(filters);

                      for (var _i = 0; _i < _arr.length; _i++) {
                        var f = _arr[_i]; // Entry keys are either a field name with its value being the filter value
                        // or, there may be one filterBy property which specifies a filering function.

                        if (f[0] === 'filterBy' && typeof f[1] === 'function') {
                          collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
                            filterBy: f[1]
                          }));
                        } else {
                          collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"](f[1].constructor.name === 'Object' ? Object.assign({
                            property: f[0]
                          }, f[1]) : {
                            property: f[0],
                            value: f[1]
                          }));
                        }
                      }
                    } else if (Array.isArray(filters)) {
                      // Make sure we are adding CollectionFilters
                      collection.add.apply(collection, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(filters.map(function (filterConfig) {
                        if (filterConfig instanceof _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
                          return filterConfig;
                        }

                        return new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"](filterConfig);
                      })));
                    } else if (filters.isCollection) {
                      // Use supplied collection? Opting to use items from it currently
                      collection.add.apply(collection, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(filters.values));
                    } else {
                      collection.add(new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
                        filterBy: filters
                      }));
                    }

                    collection.forEach(function (item) {
                      return item.owner = me;
                    });
                  }
                },
                get: function get() {
                  return this._filters || (this._filters = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
                    extraKeys: ['property']
                  }));
                }
              }, {
                key: "filtersFunction",
                set: function set(filtersFunction) {
                  this._filtersFunction = filtersFunction;
                },
                get: function get() {
                  var me = this,
                      filters = me.filters,
                      isGrouped = me.isGrouped;

                  if (!me._filtersFunction) {
                    if (filters.count) {
                      var generatedFilterFunction = _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_13__["default"].generateFiltersFunction(filters);

                      me._filtersFunction = function (candidate) {
                        // A group record is filtered in if it has passing groupChildren.
                        if (isGrouped && candidate.meta.specialRow) {
                          return candidate.groupChildren.some(generatedFilterFunction);
                        } else {
                          return generatedFilterFunction(candidate);
                        }
                      };
                    } else {
                      me._filtersFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].returnTrue;
                    }
                  }

                  return me._filtersFunction;
                }
                /**
                 * Check if store is filtered
                 * @returns {Boolean}
                 * @readonly
                 * @category Sort, group & filter
                 */

              }, {
                key: "isFiltered",
                get: function get() {
                  return this.filters.values.some(function (filter) {
                    return !filter.disabled;
                  });
                }
              }, {
                key: "latestFilterField",
                get: function get() {
                  return this.filters.last ? this.filters.last.property : null;
                }
              }, {
                key: "filtered",
                get: function get() {
                  return this.storage.isFiltered;
                }
              }, {
                key: "filterState",
                get: function get() {
                  return this.filters.values.map(function (filter) {
                    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].cleanupProperties(filter.config);
                  });
                }
              }], [{
                key: "defaultConfig",
                //region Config
                get: function get() {
                  return {
                    /**
                     * Specify a filter config to use initial filtering
                     * @config {Object}
                     * @category Filtering
                     */
                    filters: null,

                    /**
                     * Specify true to reapply filters when a record is added to the store.
                     * @config {Boolean}
                     * @default
                     * @category Filtering
                     */
                    reapplyFilterOnAdd: false,

                    /**
                     * Specify true to reapply filters when a record is updated in the store.
                     * @config {Boolean}
                     * @default
                     * @category Filtering
                     */
                    reapplyFilterOnUpdate: false
                  };
                }
              }]);

              return StoreFilter;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreGroup.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreGroup.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreGroupJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "../Grid/node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreGroup
         */

        var resortActions = {
          add: 1,
          replace: 1
        };
        /**
         * Mixin for Store that handles grouping.
         *
         * @example
         * store.group('city');
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(StoreGroup, _ref);

              function StoreGroup() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StoreGroup);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StoreGroup).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(StoreGroup, [{
                key: "construct",
                //endregion
                //region Events

                /**
                 * Fired when grouping is stopped
                 * @event groupingOff
                 * @param {Common.data.Store} source This Store
                 */
                //endregion
                //region Init
                value: function construct(config) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StoreGroup.prototype), "construct", this).call(this, config); // For handling record mutation, *not* add/remove of records.
                  // Sorts dataset if necessary.


                  this.on('change', this.onDataChanged);
                }
              }, {
                key: "storeCollapsedGroups",
                value: function storeCollapsedGroups() {
                  var me = this;
                  me.collapsedGroupsHash = {}; // Remember which groups are collapsed

                  if (me.groupRecords && me.groupRecords.length) {
                    me.groupRecords.forEach(function (rec) {
                      if (me.expand(rec)) {
                        me.collapsedGroupsHash[rec.id] = true;
                      }
                    });
                    return true;
                  }

                  return false;
                }
              }, {
                key: "restoreCollapsedGroups",
                value: function restoreCollapsedGroups() {
                  var me = this;
                  Object.keys(me.collapsedGroupsHash).forEach(function (id) {
                    return me.collapse(me.getById(id));
                  });
                }
              }, {
                key: "onDataChange",
                value: function onDataChange(_ref2) {
                  var storage = _ref2.source,
                      action = _ref2.action,
                      removed = _ref2.removed;
                  var me = this;
                  var records = storage.values; // When records are added or removed, re-evaluate the group records
                  // so that when the events are fired by the super call, the group
                  // records are in place.

                  if (me.isGrouped) {
                    if (action === 'splice' && removed && removed.length) {
                      // Remember which groups are collapsed
                      if (me.storeCollapsedGroups()) {
                        me.storage.replaceValues(me.removeHeadersAndFooters(me.storage.values), true);
                      }

                      me.storage.replaceValues(me.prepareGroupRecords(me.storage.values), true); // Re-collapse the groups

                      me.restoreCollapsedGroups();
                    }
                  } // Remove all group headers and footers
                  else {
                      storage.replaceValues(me.removeHeadersAndFooters(records), true);
                    }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StoreGroup.prototype), "onDataChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StoreGroup.prototype), "onDataChange", this).apply(this, arguments);
                } // private function that collapses on the data level
                // TODO: make public and trigger events for grid to react to?

              }, {
                key: "collapse",
                value: function collapse(groupRecord) {
                  if (groupRecord && !groupRecord.meta.collapsed) {
                    this.excludeGroupRecords(groupRecord);
                    groupRecord.meta.collapsed = true;
                    return true;
                  }

                  return false;
                } // private function that expands on the data level
                // TODO: make public and trigger events for grid to react to?

              }, {
                key: "expand",
                value: function expand(groupRecord) {
                  if (groupRecord && groupRecord.meta.collapsed) {
                    this.includeGroupRecords(groupRecord);
                    groupRecord.meta.collapsed = false;
                    return true;
                  }

                  return false;
                }
              }, {
                key: "removeHeadersAndFooters",
                value: function removeHeadersAndFooters(records) {
                  var me = this;
                  return records.filter(function (r) {
                    if (r.meta.specialRow) {
                      me.unregister(r);
                      return false;
                    } else {
                      return true;
                    }
                  }, true);
                }
              }, {
                key: "prepareGroupRecords",
                value: function prepareGroupRecords() {
                  var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.registeredRecords;
                  var me = this;
                  records = me.removeHeadersAndFooters(records);

                  if (!me.isGrouped) {
                    return records;
                  }

                  var groupedRecords = [],
                      field = me.groupers[0].field,
                      groupRecords = [];
                  var curGroup = null,
                      curGroupRecord = null,
                      childCount = 0;

                  function addFooter() {
                    var val = curGroupRecord.meta.groupRowFor,
                        id = "group-footer-".concat(typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createId(val)),
                        footer = me.getById(id) || new me.modelClass({
                      id: id
                    }, me, {
                      specialRow: true,
                      groupFooterFor: val,
                      groupRecord: curGroupRecord
                    });
                    me.register(footer);
                    footer.groupChildren = curGroupRecord.groupChildren;
                    groupRecords.push(footer);
                    groupedRecords.push(footer);
                    me.allRecords.push(footer);
                    curGroupRecord.groupChildren.push(footer);
                    childCount++;
                    return footer;
                  }

                  records.forEach(function (record) {
                    var val = record[field],
                        id = "group-header-".concat(typeof val === 'number' ? val : _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createId(val)); // A group header or footer record of an empty group.
                    // Remove from the data

                    if (record.groupChildren && !record.groupChildren.length) {
                      me.unregister(record);
                      return;
                    }

                    if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].isEqual(val, curGroup)) {
                      if (curGroupRecord) {
                        // also add group footer? used by GroupSummary feature
                        if (me.useGroupFooters) {
                          addFooter(curGroupRecord);
                        }

                        curGroupRecord.meta.childCount = childCount;
                      }

                      curGroupRecord = me.getById(id) || new me.modelClass({
                        id: id
                      }, me, {
                        specialRow: true,
                        groupRowFor: val,
                        groupField: field
                      });
                      me.register(curGroupRecord);
                      curGroupRecord.groupChildren = [];
                      groupedRecords.push(curGroupRecord);
                      me.allRecords.push(curGroupRecord);
                      groupRecords.push(curGroupRecord);
                      curGroup = val;
                      childCount = 0;
                    }

                    record.instanceMeta(me.id).groupParent = curGroupRecord;
                    groupedRecords.push(record);
                    curGroupRecord.groupChildren.push(record);
                    childCount++;
                  }); // misses for last group without this

                  if (curGroupRecord) {
                    curGroupRecord.meta.childCount = childCount; // footer for last group

                    if (me.useGroupFooters) {
                      addFooter();
                    }
                  }

                  me.groupRecords = groupRecords;
                  return groupedRecords;
                } //endregion
                //region Group and ungroup

                /**
                 * Is store currently grouped?
                 * @property {Boolean}
                 * @readonly
                 * @category Sort, group & filter
                 */

              }, {
                key: "group",

                /**
                 * Currently used groupers
                 * @readonly
                 * @member {Object[]} groupers
                 * @category Sort, group & filter
                 */

                /**
                 * Group records.
                 * @param {String} field Field to group by
                 * @param {Boolean} ascending Group direction
                 * @param {Boolean} add Add grouper (true) or use only this grouper (false)
                 * @param {Boolean} performSort Trigger sort directly, which does the actual grouping
                 * @param {Boolean} silent True to not fire events
                 * @fires group
                 * @fires refresh
                 * @category Sort, group & filter
                 */
                value: function group(field, ascending) {
                  var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var performSort = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                  var silent = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                  var me = this;
                  var newGrouper;

                  if (add) {
                    me.groupers.push(newGrouper = {
                      field: field,
                      ascending: ascending,
                      complexMapping: field.includes('.')
                    });
                  } else if (field) {
                    if (ascending == undefined) {
                      ascending = me.groupInfo && me.groupInfo.field === field ? !me.groupInfo.ascending : true;
                    }

                    me.groupInfo = newGrouper = {
                      field: field,
                      ascending: ascending,
                      complexMapping: field.includes('.')
                    };
                    me.groupers = [me.groupInfo];
                  }

                  if (newGrouper) {
                    var prototype = me.modelClass.prototype; // Create a getter for complex field names like "get resource.city"

                    if (newGrouper.complexMapping && !prototype.hasOwnProperty(field)) {
                      Object.defineProperty(prototype, field, {
                        get: function get() {
                          return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getPath(this, field);
                        }
                      });
                    }
                  } // as far as the store is concerned, grouping is just more sorting. so trigger sort


                  if (performSort !== false) {
                    me.sort(null, null, false, true);
                  }

                  if (!silent) {
                    /**
                     * Fired when grouping changes
                     * @event group
                     * @param {Common.data.Store} source This Store
                     * @param {Object[]} groupers Applied groupers
                     * @param {Common.data.Model[]} records Grouped records
                     */
                    me.trigger('group', {
                      isGrouped: me.isGrouped,
                      groupers: me.groupers,
                      records: me.storage.values
                    });
                    me.trigger('refresh', {
                      action: 'group',
                      isGrouped: me.isGrouped,
                      groupers: me.groupers,
                      records: me.storage.values
                    });
                  }
                } // Internal since UI does not support multi grouping yet

                /**
                 * Add a grouping level (a grouper).
                 * @param {String} field Field to group by
                 * @param {Boolean} ascending Group direction
                 * @category Sort, group & filter
                 * @internal
                 */

              }, {
                key: "addGrouper",
                value: function addGrouper(field) {
                  var ascending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  this.group(field, ascending, true);
                } // Internal since UI does not support multi grouping yet

                /**
                 * Removes a grouping level (a grouper)
                 * @param {String} field Grouper to remove
                 * @category Sort, group & filter
                 * @internal
                 */

              }, {
                key: "removeGrouper",
                value: function removeGrouper(field) {
                  var me = this,
                      index = me.groupers.findIndex(function (grouper) {
                    return grouper.field === field;
                  });

                  if (index > -1) {
                    me.groupers.splice(index, 1);
                    me.group();
                  }
                }
                /**
                 * Removes all groupers, turning store grouping off.
                 * @fires groupingOff
                 * @category Sort, group & filter
                 */

              }, {
                key: "clearGroupers",
                value: function clearGroupers() {
                  var me = this,
                      groupers = me.groupers;

                  if (groupers.length) {
                    groupers.length = 0;
                    me.groupRecords.forEach(function (r) {
                      if (r.meta.collapsed) {
                        me.includeGroupRecords(r);
                      }
                    });
                    me.storage.replaceValues(me.removeHeadersAndFooters(me.registeredRecords), true);
                    me.group(null, null, null, false);

                    if ('groupRecords' in me) {
                      delete me.groupRecords;
                    }
                  }
                } //endregion
                //region Get and check

                /**
                 * Check if a record belongs to a certain group (only for the first grouping level)
                 * @param {Common.data.Model} record Record
                 * @param groupValue Groups value
                 * @returns {Boolean} True if the record belongs to the group, otherwise false
                 * @category Sort, group & filter
                 */

              }, {
                key: "isRecordInGroup",
                value: function isRecordInGroup(record, groupValue) {
                  if (!this.isGrouped) return null;
                  var me = this,
                      groupField = me.groupers[0] && me.groupers[0].field;
                  return record[groupField] === groupValue && !record.meta.specialRow;
                }
              }, {
                key: "isInCollapsedGroup",
                value: function isInCollapsedGroup(record) {
                  var parentGroupRec = record.instanceMeta(this).groupParent;
                  return parentGroupRec && parentGroupRec.meta.collapsed;
                }
                /**
                 * Returns all records in the group with specified groupValue.
                 * @param groupValue
                 * @returns {Common.data.Model[]} Records in specified group or null if store not grouped
                 * @category Sort, group & filter
                 */

              }, {
                key: "getGroupRecords",
                value: function getGroupRecords(groupValue) {
                  var me = this;
                  if (!me.isGrouped) return null;
                  return me.storage.values.filter(function (record) {
                    return me.isRecordInGroup(record, groupValue);
                  });
                }
                /**
                 * Get all group titles.
                 * @returns {String[]} Group titles
                 * @category Sort, group & filter
                 */

              }, {
                key: "getGroupTitles",
                value: function getGroupTitles() {
                  var me = this;
                  if (!me.isGrouped) return null;
                  return me.getDistinctValues(me.groupers[0] && me.groupers[0].field);
                } //endregion

              }, {
                key: "onDataChanged",
                value: function onDataChanged(event) {
                  if (this.isGrouped && ( // If an action flagged as requiring resort is performed...
                  !event.changes && resortActions[event.action] || // ...or if the group field has changes...
                  event.changes && this.groupers.some(function (grouper) {
                    return grouper.field in event.changes;
                  }))) {
                    // ...then resort
                    this.sort();
                  }
                }
                /**
                 * Adds or removes records in a group from storage. Used when expanding/collapsing groups.
                 * @private
                 * @param {Common.data.Model} groupRecord Group which records should be added or removed
                 * @param {Boolean} include Include (true) or exclude (false) records
                 * @category Grouping
                 */

              }, {
                key: "internalIncludeExcludeGroupRecords",
                value: function internalIncludeExcludeGroupRecords(groupRecord, include) {
                  var me = this,
                      index = me.indexOf(groupRecord),
                      mapId = me.id; // prevent removing from already collapsed and vice versa

                  if (groupRecord.meta.collapsed && !include) return;
                  if (!groupRecord.meta.collapsed && include) return;
                  groupRecord.groupChildren.forEach(function (child) {
                    return child.instanceMeta(mapId).hiddenByCollapse = !include;
                  });

                  if (include) {
                    var _me$storage$values;

                    (_me$storage$values = me.storage.values).splice.apply(_me$storage$values, [index + 1, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(groupRecord.groupChildren)));
                  } else {
                    me.storage.values.splice(index + 1, groupRecord.groupChildren.length);
                  }

                  me.storage._indicesInvalid = true;
                  me._idMap = null;
                }
                /**
                 * Removes records in a group from storage. Used when collapsing a group.
                 * @private
                 * @param groupRecord Group which records should be removed
                 * @category Grouping
                 */

              }, {
                key: "excludeGroupRecords",
                value: function excludeGroupRecords(groupRecord) {
                  this.internalIncludeExcludeGroupRecords(groupRecord, false);
                }
                /**
                 * Adds records in a group to storage. Used when expanding a group.
                 * @private
                 * @param groupRecord Group which records should be added
                 * @category Grouping
                 */

              }, {
                key: "includeGroupRecords",
                value: function includeGroupRecords(groupRecord) {
                  this.internalIncludeExcludeGroupRecords(groupRecord, true);
                }
                /**
                 * Collects all group headers + children, whether expanded or not
                 * @private
                 * @returns {Common.data.Model[]}
                 */

              }, {
                key: "collectGroupRecords",
                value: function collectGroupRecords() {
                  return this.records.reduce(function (records, record) {
                    if (record.meta.specialRow) {
                      records.push(record);

                      if ('groupRowFor' in record.meta) {
                        records.push.apply(records, record.groupChildren);
                      }
                    }

                    return records;
                  }, []);
                }
              }, {
                key: "isGrouped",
                get: function get() {
                  return Boolean(this.groupers.length);
                }
              }], [{
                key: "defaultConfig",
                //region Config
                get: function get() {
                  return {
                    /**
                     * Initial groupers, specify to have store grouped automatically after initially setting data
                     * @config {Object[]}
                     * @category Common
                     */
                    groupers: []
                  };
                }
              }]);

              return StoreGroup;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreRelation.js":
      /*!******************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreRelation.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreRelationJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../helper/ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreRelation
         */

        /**
         * Mixin for Store that handles relations with other stores (actually defined on model).
         *
         * @private
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(StoreRelation, _ref);

              function StoreRelation() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, StoreRelation);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(StoreRelation).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(StoreRelation, [{
                key: "initRelations",
                //region Init

                /**
                 * Initialized relations, called from constructor
                 * @private
                 */
                value: function initRelations(reset) {
                  var me = this,
                      relations = me.modelClass.relations;

                  if (reset && me.modelRelations) {
                    // reset will reinit all relations, stop listening for store events on existing ones
                    me.modelRelations.forEach(function (relation) {
                      if (relation.storeDetacher) relation.storeDetacher();
                    });
                  }

                  if ((!me.modelRelations || me.modelRelations.length === 0 || reset) && relations) {
                    me.modelRelations = []; // foreignKeys is filled when model exposes its properties

                    relations && relations.forEach(function (modelRelationConfig) {
                      var config = Object.assign({}, modelRelationConfig),
                          relatedStore = typeof config.store === 'string' ? me[config.store] : config.store;
                      config.dependentStore = me;
                      me.modelRelations.push(config);

                      if (relatedStore) {
                        config.storeProperty = config.store;
                        config.store = relatedStore; // repeated from initRelationStores, needed if stored is assigned late

                        var dependentStoreConfigs = relatedStore.dependentStoreConfigs; // Add link to dependent store

                        if (dependentStoreConfigs.has(me)) {
                          dependentStoreConfigs.get(me).push(config);
                        } else {
                          dependentStoreConfigs.set(me, [config]);
                        } // if foreign key specifies collectionName the related store should also be configured


                        if (config.collectionName) {
                          relatedStore.initRelationCollection(config, me);
                        }

                        if (relatedStore.count > 0) {
                          relatedStore.updateDependentStores('dataset', relatedStore.records);
                        }
                      }
                    });
                  }
                }
                /**
                 * Called from other end of an relation when this store should hold a collection of related records.
                 * @private
                 * @param config
                 * @param collectionStore
                 */

              }, {
                key: "initRelationCollection",
                value: function initRelationCollection(config, collectionStore) {
                  // TODO: parts of this should move to model?
                  var me = this,
                      name = config.collectionName;

                  if (!me.collectionStores) {
                    me.collectionStores = {};
                  }

                  me.collectionStores[name] = {
                    store: collectionStore,
                    config: config
                  };

                  if (!me[name + 'Store']) {
                    me[name + 'Store'] = collectionStore;
                  }

                  if (me.count > 0) {
                    me.initModelRelationCollection(name, me.records);
                  }
                }
              }, {
                key: "initModelRelationCollection",
                value: function initModelRelationCollection(name, records) {
                  var me = this; // add collection getter to each model

                  records.forEach(function (record) {
                    // Needs to work in trees also, if not a tree traverse just calls fn on self
                    record.traverse(function (node) {
                      !(name in node) && Object.defineProperty(node, name, {
                        enumerable: true,
                        get: function get() {
                          return me.getCollection(this, name);
                        },
                        set: function set(value) {
                          return me.setCollection(this, name, value);
                        }
                      });
                    });
                  });
                } //TODO: Do diff update, this is called on filtering and will be heavy with lots of records

                /**
                 * Updates relationCache for all records.
                 * @private
                 */

              }, {
                key: "resetRelationCache",
                value: function resetRelationCache() {
                  this.relationCache = {};
                  this.forEach(function (record) {
                    return record.initRelations();
                  });
                }
                /**
                 * Caches related records from related store on the local store.
                 * @private
                 * @param record Local record
                 * @param relations Relations to related store
                 */

              }, {
                key: "updateRecordRelationCache",
                value: function updateRecordRelationCache(record, relations) {
                  var me = this;
                  relations && relations.forEach(function (relation) {
                    // use related records id, or if called before "binding" is complete use foreign key
                    var foreignId = relation.related ? relation.related.id : record.get(relation.config.fieldName); // cache on that id, removing previously cached value if any

                    foreignId !== undefined && me.cacheRelatedRecord(record, foreignId, relation.config.relationName, foreignId);
                  });
                } //endregion
                //region Getters

                /**
                 * Returns records from a collection of related records. Not to be called directly, called from Model getter.
                 * TODO: Move to Model?
                 * @private
                 * @param model
                 * @param name
                 * @returns {*}
                 */

              }, {
                key: "getCollection",
                value: function getCollection(model, name) {
                  var _this$collectionStore = this.collectionStores[name],
                      config = _this$collectionStore.config,
                      store = _this$collectionStore.store;
                  return store.relationCache[config.relationName] && store.relationCache[config.relationName][model.id] || [];
                }
                /**
                 * Sets a collection of related records. Will updated the related store and trigger events from it. Not to be called
                 * directly, called from Model setter.
                 * @private
                 */

              }, {
                key: "setCollection",
                value: function setCollection(model, name, records) {
                  var _this$collectionStore2 = this.collectionStores[name],
                      config = _this$collectionStore2.config,
                      store = _this$collectionStore2.store;
                  if (!store.relationCache[config.relationName]) store.relationCache[config.relationName] = {};
                  var old = (store.relationCache[config.relationName][model.id] || []).slice(),
                      added = [],
                      removed = [];
                  store.suspendEvents(); // Remove any related records not in the new collection

                  old.forEach(function (record) {
                    if (!records.includes(record)) {
                      record[config.fieldName] = null;
                      store.remove(record);
                      removed.push(record);
                    }
                  }); // Add records from the new collection not already in store

                  records.forEach(function (record) {
                    if (record instanceof _Model_js__WEBPACK_IMPORTED_MODULE_15__["default"]) {
                      if (!record.stores.includes(store)) {
                        store.add(record);
                        added.push(record);
                      }
                    } else {
                      var _store$add = store.add(record);

                      var _store$add2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_store$add, 1);

                      record = _store$add2[0];
                      added.push(record);
                    } // Init relation


                    record[config.fieldName] = model.id;
                  });
                  store.resumeEvents();

                  if (removed.length) {
                    store.trigger('remove', {
                      records: removed
                    });
                    store.trigger('change', {
                      action: 'remove',
                      records: removed
                    });
                  }

                  if (added.length) {
                    store.trigger('add', {
                      records: added
                    });
                    store.trigger('change', {
                      action: 'add',
                      records: added
                    });
                  }
                } //endregion
                //region Caching

                /**
                 * Adds a record to relation cache, optionally removing it if already there.
                 * @private
                 * @param record
                 * @param id
                 * @param name
                 * @param uncacheId
                 */

              }, {
                key: "cacheRelatedRecord",
                value: function cacheRelatedRecord(record, id, name) {
                  var uncacheId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                  var me = this,
                      cache = me.relationCache[name] || (me.relationCache[name] = {});

                  if (uncacheId !== null) {
                    me.uncacheRelatedRecord(record, name, uncacheId);
                  }

                  if (id) {
                    // Only include of not already in relation cache, which might happen when removing and re-adding the same instance
                    _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].include(cache[id] || (cache[id] = []), record);
                  }
                }
                /**
                 * Removes a record from relation cache, for a specific relation (specifiy relation name and id) or for all relations
                 * @private
                 * @param record Record to remove from cache
                 * @param name Optional, relation name
                 * @param id Optional, id
                 */

              }, {
                key: "uncacheRelatedRecord",
                value: function uncacheRelatedRecord(record) {
                  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
                  var me = this;

                  function remove(relationName, relatedId) {
                    var cache = me.relationCache[relationName],
                        oldCache = cache && cache[relatedId]; // When unjoining a record from a filtered store the relationCache will also be filtered
                    // and might give us nothing, in which case we have nothing to clean up and bail out

                    if (oldCache) {
                      var uncacheIndex = oldCache.indexOf(record);
                      uncacheIndex >= 0 && oldCache.splice(uncacheIndex, 1);

                      if (oldCache.length === 0) {
                        delete cache[relatedId];
                      }
                    }
                  }

                  if (id !== null) {
                    remove(name, id);
                  } else {
                    if (record.meta.relationCache) {
                      Object.entries(record.meta.relationCache).forEach(function (_ref2) {
                        var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref2, 2),
                            relationName = _ref3[0],
                            relatedRecord = _ref3[1];

                        var relatedId = relatedRecord && relatedRecord.id;
                        remove(relationName, relatedId);
                      });
                    }
                  }
                }
                /**
                 * Updates related stores when store is cleared, a record is removed or added.
                 * @private
                 * @param {String} action
                 * @param {Common.data.Model[]} records
                 */

              }, {
                key: "updateDependentStores",
                value: function updateDependentStores(action, records) {
                  var _this = this;

                  this.dependentStoreConfigs.forEach(function (configs) {
                    configs.forEach(function (config) {
                      var dependentStore = config.dependentStore,
                          cache = dependentStore.relationCache[config.relationName];

                      if (action === 'dataset') {
                        config.collectionName && _this.initModelRelationCollection(config.collectionName, records);
                        dependentStore.forEach(function (record) {
                          var foreign = record.initRelation(config);
                          foreign && dependentStore.cacheRelatedRecord(record, foreign.id, config.relationName, foreign.id);
                        });
                        return;
                      }

                      if (action === 'removeall') {
                        dependentStore.forEach(function (record) {
                          record.removeRelation(config);
                        });
                        delete dependentStore.relationCache[config.relationName];
                        return;
                      }

                      if (action === 'add') {
                        config.collectionName && _this.initModelRelationCollection(config.collectionName, records);
                      }

                      if (action === 'add' || action === 'remove') {
                        records.forEach(function (record) {
                          var dependentRecords = cache && cache[record.id];

                          switch (action) {
                            case 'remove':
                              // removing related record removes from cache on model and store
                              if (dependentRecords) {
                                dependentRecords.forEach(function (dependentRecord) {
                                  return dependentRecord.removeRelation(config);
                                }); // Altered to not delete on self, simplifies taking actions on related records after remove if relation still lives
                                //delete cache[relatedRecord.id];
                              } // TODO: Should removing related set foreign key to null? (removing Team sets Player.teamId to null)


                              break;

                            case 'add':
                              // adding a new record in related store checks if any foreign keys match the new id,
                              // and if so it sets up the relation
                              dependentStore.forEach(function (dependentRecord) {
                                if (dependentRecord.get(config.fieldName) == record.id) {
                                  dependentRecord.initRelation(config);
                                  dependentStore.cacheRelatedRecord(dependentRecord, record.id, config.relationName);
                                }
                              });
                              break;
                          }
                        });
                      }
                    });
                  });
                }
                /**
                 * Updates relation cache and foreign key value when a related objects id is changed.
                 * @private
                 */

              }, {
                key: "updateDependentRecordIds",
                value: function updateDependentRecordIds(oldValue, value) {
                  this.dependentStoreConfigs && this.dependentStoreConfigs.forEach(function (configs) {
                    configs.forEach(function (config) {
                      var dependentStore = config.dependentStore,
                          cache = dependentStore.relationCache[config.relationName],
                          localRecords = cache && cache[oldValue] && cache[oldValue].slice();
                      localRecords && localRecords.forEach(function (localRecord) {
                        localRecord.set(config.fieldName, value, false, true);
                        dependentStore.cacheRelatedRecord(localRecord, value, config.relationName, oldValue);
                      });
                    });
                  });
                } //endregion

              }]);

              return StoreRelation;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreSearch.js":
      /*!****************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreSearch.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreSearchJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreSearch
         */

        var stringFound = function stringFound(value, find) {
          return String(value).toLowerCase().indexOf(find) !== -1;
        },
            comparisons = {
          string: stringFound,
          number: stringFound,
          boolean: stringFound,
          date: function date(value, find) {
            if (value instanceof Date && find instanceof Date) {
              return String(value) === String(find);
            }

            return String(value.getMonth() + 1).indexOf(find) !== -1 || String(value.getDate()).indexOf(find) !== -1 || String(value.getFullYear()).indexOf(find) !== -1;
          }
        };
        /**
         * Mixin for Store that handles searching (multiple records) and finding (single record).
         *
         * @example
         * // find all records that has a field containing the string john
         * let hits = store.search('john');
         *
         * @mixin
         */

        /* harmony default export */


        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(StoreSearch, _ref);

              function StoreSearch() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, StoreSearch);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(StoreSearch).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(StoreSearch, [{
                key: "search",
                //region Search (multiple hits)

                /**
                 * Find all hits.
                 * @param find Value to search for
                 * @param {Object[]} fields Fields to search value in
                 * @returns {*} Array of hits, in the format { index: x, data: record }
                 */
                value: function search(find) {
                  var fields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var records = this.storage.values,
                      len = records.length,
                      found = [];

                  if (find == null) {
                    return null;
                  }

                  if (typeof find === 'string') {
                    find = String(find).toLowerCase();
                  }

                  var i, record, value, valueType, comparison;

                  for (i = 0; i < len; i++) {
                    record = records[i];
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = (fields || record.fieldNames)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var key = _step.value;
                        value = record[key];
                        valueType = value instanceof Date ? 'date' : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default()(value);
                        comparison = comparisons[valueType];

                        if (value && comparison && comparison(value, find)) {
                          found.push({
                            index: i,
                            data: record,
                            field: key,
                            id: record.id
                          });
                        }
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }
                  }

                  return found;
                }
                /**
                 * Find all hits in a column
                 * @param field The store field to search in
                 * @param value Value to search for
                 * @returns {*} Array of hits, in the format { index: x, data: record }
                 */

              }, {
                key: "findByField",
                value: function findByField(field, value) {
                  var records = this.storage.values,
                      i,
                      len = records.length,
                      record,
                      found = [],
                      fieldValue;

                  if (value !== null && value !== undefined) {
                    value = String(value).toLowerCase();
                  }

                  for (i = 0; i < len; i++) {
                    record = records[i];
                    fieldValue = record[field];
                    var type = fieldValue instanceof Date ? 'date' : _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default()(fieldValue);
                    var comparison = {
                      'date': function date() {
                        return Boolean(fieldValue) && fieldValue.toLocaleString().includes(value);
                      },
                      'string': function string() {
                        return Boolean(fieldValue) && fieldValue.toLowerCase().includes(value);
                      },
                      'number': function number() {
                        return typeof fieldValue === 'number' && fieldValue.toString().includes(value);
                      },
                      'object': function object() {
                        return fieldValue === value;
                      },
                      // typeof null === object
                      'undefined': function undefined() {
                        return fieldValue === value;
                      }
                    };

                    if ((value === null || value === undefined) && fieldValue === value || value && comparison[type]()) {
                      found.push({
                        id: record.id,
                        index: i,
                        data: record
                      });
                    }
                  }

                  return found;
                } //endregion
                //region Find (single hit)

                /**
                 * Finds the first record for which the specified function returns true
                 * @param {Function} fn Comparison function, called with record as parameter
                 * @returns {Common.data.Model} Record or null if none found
                 *
                 * @example
                 * store.find(record => record.color === 'blue');
                 */

              }, {
                key: "find",
                value: function find(fn) {
                  return this.storage.values.find(fn);
                }
                /**
                 * Finds the first record for which the specified field has the specified value
                 * @param {String} fieldName Field name
                 * @param {*} value Value to find
                 * @returns {Common.data.Model} Record or null if none found
                 */

              }, {
                key: "findRecord",
                value: function findRecord(fieldName, value) {
                  var searchAllRecords = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                  var matchFn = function matchFn(r) {
                    return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isEqual(r[fieldName], value);
                  };

                  if (this.tree) {
                    return this.query(matchFn)[0];
                  }

                  return (searchAllRecords ? this.storage.allValues : this.storage.values).find(matchFn);
                }
                /**
                 * Searches the Store records using the passed function.
                 * @param fn A function that is called for each record. Return true to indicate a match
                 * @returns {Common.data.Model[]} An array of the matching Records
                 */

              }, {
                key: "query",
                value: function query(fn) {
                  if (this.isTree) {
                    var matches = [];
                    this.traverse(function (node) {
                      if (fn(node)) {
                        matches.push(node);
                      }
                    });
                    return matches;
                  }

                  return this.storage.values.filter(fn);
                } //endregion
                //region Others

                /**
                 * Returns true if the supplied function returns true for any record in the store
                 * @param fn
                 * @returns {Boolean}
                 *
                 * @example
                 * store.some(record => record.age > 95); // true if any record has age > 95
                 */

              }, {
                key: "some",
                value: function some(fn) {
                  return this.storage.values.some(fn);
                } //endregion

              }]);

              return StoreSearch;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_14__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreSort.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreSort.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreSortJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "../Grid/node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreSort
         */

        /**
         * Mixin for Store that handles simple sorting as well as multi-level sorting.
         *
         * ```javascript
         * // single sorter
         * store.sort('age');
         *
         * // single sorter as object, descending order
         * store.sort({ field : 'age', ascending : false });
         *
         * // multiple sorters
         * store.sort(['age', 'name']);
         *
         * // using locale specific sort (slow)
         * store.sort({ field : 'name', useLocaleSort : 'sv-SE' });
         * ```
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(StoreSort, _ref);

              function StoreSort() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StoreSort);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StoreSort).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(StoreSort, [{
                key: "sort",
                //endregion
                //region Add & remove sorters

                /**
                 * Sort records, either by replacing current sorters or by adding to them. A sorter can specify a custom sorter
                 * function which will be called with arguments (ascending, recordA, recordB). Works in the same way as a standard
                 * array sorter, except that returning null triggers the stores normal sorting routine.
                 * ```
                 * store.sort('age');
                 * store.sort(['age', 'name']);
                 * store.sort({ field: 'age', fn: (a, b, dir) => sorting logic... }
                 * store.sort({ field : 'name', useLocaleSort : 'sv-se' });
                 * ```
                 * @param {String|Object} field Field to sort by (can also be an array of sorters or a config containing a custom sort fn)
                 * @param {Boolean} [ascending] Sort order (used only if field specified as string)
                 * @param {Boolean} [add] Add a sorter or use only this sorter (used only if field specified as string)
                 * @param {Boolean} [silent] Set as true to not fire events
                 * @category Sort, group & filter
                 * @fires beforeSort
                 * @fires sort
                 * @fires refresh
                 */
                value: function sort(field, ascending) {
                  var add = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var silent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                  var me = this,
                      records = me.allRecords,
                      currentSorters = me.sorters.slice();
                  var currentDir = null,
                      curSort;

                  if (field) {
                    if (Array.isArray(field)) {
                      me.sorters = field.map(function (sorter) {
                        if (typeof sorter === 'string') return {
                          field: sorter
                        };
                        return sorter;
                      });
                    } else {
                      // extract field name if sorting by config object
                      var fieldName = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(field) === 'object' ? field.field : field; // check if currently sorted by this field

                      curSort = me.sorters.find(function (sorter) {
                        return sorter.field === fieldName;
                      }); // sort in opposite direction if not specified and already sorted, default to sorting ascending

                      if (ascending === undefined || ascending === null) {
                        var sameField = curSort && (typeof field === 'string' && curSort.field === field || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(field) === 'object' && curSort.field === field.field);
                        ascending = sameField ? !curSort.ascending : true;
                      }

                      var sorter = {
                        field: fieldName,
                        ascending: ascending
                      };

                      if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(field) === 'object') {
                        sorter.fn = field.fn;
                        sorter.useLocaleSort = field.useLocaleSort;
                      }

                      if (add) {
                        // Field already among sorters? change sort direction instead of adding new sorter
                        if (curSort) {
                          currentDir = curSort.ascending;
                          curSort.ascending = ascending;
                        } else {
                          me.sorters.push(sorter);
                        }
                      } else {
                        me.sorters = [sorter];
                      }
                    }
                  }

                  if (!silent && me.trigger('beforeSort', {
                    sorters: me.sorters,
                    records: records,
                    currentSorters: currentSorters
                  }) === false) {
                    // Restore sorters
                    me.sorters = currentSorters; // Restore sorting direction if toggled

                    if (currentDir !== null) {
                      curSort.ascending = currentDir;
                    }

                    return;
                  }

                  me.performSort(silent);

                  if (!silent) {
                    me.trigger('sort', {
                      sorters: me.sorters,
                      records: records
                    });
                    me.trigger('refresh', {
                      action: 'sort',
                      sorters: me.sorters,
                      records: records
                    });
                  }
                }
                /**
                 * Add a sorting level (a sorter).
                 * @param {String|Object} field Field to sort by (can also be an array of sorters or a config containing a custom sort fn)
                 * @param {Boolean} ascending Sort order (used only if field specified as string)
                 * @category Sort, group & filter
                 */

              }, {
                key: "addSorter",
                value: function addSorter(field) {
                  var ascending = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  this.sort(field, ascending, true);
                }
                /**
                 * Remove a sorting level (a sorter)
                 * @param field Stop sorting by this field
                 * @category Sort, group & filter
                 */

              }, {
                key: "removeSorter",
                value: function removeSorter(field) {
                  var me = this,
                      sorterIndex = me.sorters.findIndex(function (sorter) {
                    return sorter.field == field;
                  });

                  if (sorterIndex > -1) {
                    me.sorters.splice(sorterIndex, 1);
                    me.sort();
                  }
                }
                /**
                 * Removes all sorters, turning store sorting off.
                 * @category Sort, group & filter
                 */

              }, {
                key: "clearSorters",
                value: function clearSorters() {
                  var me = this;
                  me.sorters.length = 0;
                  me.sort();
                } //region
                //region Sorting logic

                /**
                 * Creates a function used with Array#sort when sorting the store. Override to use your own custom sorting logic.
                 * @param sorters
                 * @returns {Function}
                 * @category Sort, group & filter
                 */

              }, {
                key: "createSorterFn",
                value: function createSorterFn(sorters) {
                  var storeLocaleSort = this.useLocaleSort;
                  return function (lhs, rhs) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = sorters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _step$value = _step.value,
                            field = _step$value.field,
                            _step$value$ascending = _step$value.ascending,
                            ascending = _step$value$ascending === void 0 ? true : _step$value$ascending,
                            _step$value$fn = _step$value.fn,
                            fn = _step$value$fn === void 0 ? null : _step$value$fn,
                            _step$value$useLocale = _step$value.useLocaleSort,
                            useLocaleSort = _step$value$useLocale === void 0 ? storeLocaleSort : _step$value$useLocale;
                        var direction = ascending ? 1 : -1;

                        if (fn) {
                          var val = fn(lhs, rhs);
                          if (val !== null) return val * direction;
                        }

                        var lhsValue = lhs[field],
                            rhsValue = rhs[field];
                        if (lhsValue == null) return -direction;
                        if (rhsValue == null) return direction;

                        if (useLocaleSort) {
                          // Use systems locale
                          if (useLocaleSort === true) {
                            return String(lhsValue).localeCompare(rhsValue) * direction;
                          } // Use specified locale


                          if (typeof useLocaleSort === 'string') {
                            return String(lhsValue).localeCompare(rhsValue, useLocaleSort) * direction;
                          } // Use locale config


                          if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(useLocaleSort) === 'object') {
                            return String(lhsValue).localeCompare(rhsValue, useLocaleSort.locale, useLocaleSort) * direction;
                          }
                        }

                        if (lhsValue > rhsValue) return direction;
                        if (lhsValue < rhsValue) return -direction;
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    return 0;
                  };
                }
                /**
                 * Internal function that performs the sort
                 * @private
                 * @category Sort, group & filter
                 */

              }, {
                key: "performSort",
                value: function performSort() {
                  var me = this,
                      rootNode = me.rootNode,
                      storage = me.storage,
                      sorters = me.sorters,
                      sorter = me.createSorterFn(me.isGrouped ? me.groupers.concat(sorters) : sorters); // Temporarily remove group headers, will be re-added after sort

                  if (me.isGrouped) {
                    // Remember which groups are collapsed
                    if (me.storeCollapsedGroups()) {
                      storage.replaceValues(me.removeHeadersAndFooters(storage.values), true);
                    }
                  }

                  if (me.tree) {
                    rootNode.traverse(function (node) {
                      if (node.isLoaded && node.isParent) {
                        node.children = node.children.sort(sorter); // Since child nodes change order their parentIndex needs to be updated

                        node.updateChildrenIndex(node.children);
                      }
                    });
                    storage.replaceValues(me.collectDescendants(rootNode).visible, true);
                  } else {
                    storage.replaceValues(storage.values.sort(sorter), true);
                  }

                  me._idMap = null; // Apply grouping

                  if (me.isGrouped) {
                    storage.replaceValues(me.prepareGroupRecords(storage.values), true); // Re-collapse the groups

                    me.restoreCollapsedGroups();
                  }
                } //endregion

              }, {
                key: "isSorted",
                //endregion
                //region Events

                /**
                 * Fired before sorting
                 * @event beforeSort
                 * @param {Common.data.Store} source This Store
                 * @param {Object[]} sorters Sorter configs
                 * @param {Common.data.Model[]} records Records to sort
                 */

                /**
                 * Fired after sorting
                 * @event sort
                 * @param {Common.data.Store} source This Store
                 * @param {Object[]} sorters Sorter configs
                 * @param {Common.data.Model[]} records Sorted records
                 */
                //endregion
                //region Properties

                /**
                 * Currently applied sorters
                 * @member {Object[]} sorters
                 * @readonly
                 * @category Sort, group & filter
                 */

                /**
                 * Is store sorted?
                 * true
                 * @property {Boolean}
                 * @readonly
                 */
                get: function get() {
                  return Boolean(this.sorters.length) || this.isGrouped;
                }
              }], [{
                key: "defaultConfig",
                //region Config
                get: function get() {
                  return {
                    /**
                     * Default sorters, format is [{ field: '', ascending: false }, ...]
                     * @config {Object[]|string[]}
                     * @category Common
                     */
                    sorters: [],

                    /**
                     * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
                     * a locale string or a locale config to enable.
                     *
                     * Enabling this has big negative impact on sorting
                     * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
                     *
                     * Examples:
                     *
                     * ```javascript
                     * const store = new Store({
                     *     // Swedish sorting
                     *     useLocaleSort : 'sv-SE'
                     * });
                     *
                     * const store = new Store({
                     *     // Swedish sorting with custom casing order
                     *     useLocaleSort : {
                     *         locale    : 'sv-SE',
                     *         caseFirst : 'upper'
                     *     }
                     * });
                     * ```
                     *
                     * Can also be configured on a per sorter basis:
                     *
                     * ```javascript
                     * store.sort({ field: 'name', useLocaleSort : 'sv-SE' });
                     * ```
                     *
                     * @config {Boolean|String|Object}
                     * @default false
                     */
                    useLocaleSort: null
                  };
                }
              }]);

              return StoreSort;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreState.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreState.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreState
         */

        /**
         * Mixin for Store that handles store states.
         *  * sorters
         *  * groupers
         *  * filters
         * @private
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(StoreState, _ref);

              function StoreState() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, StoreState);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(StoreState).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(StoreState, [{
                key: "getState",

                /**
                 * Get store state. Used by State-plugin to serialize state
                 * @private
                 * @returns {{ sorters, groupers }}
                 */
                value: function getState() {
                  var me = this,
                      state = {};
                  if (me.sorters && me.sorters.length) state.sorters = me.sorters.slice();
                  if (me.groupers && me.groupers.length) state.groupers = me.groupers.slice();
                  if (me.filters && me.filters.values.length) state.filters = me.filterState;
                  return state;
                }
                /**
                 * Apply store state. Used by State-plugin to restore a previously serialized state
                 * @private
                 * @param {{ sorters, groupers }} state
                 */

              }, {
                key: "applyState",
                value: function applyState(state) {
                  var me = this;
                  if ('sorters' in state) me.sorters = state.sorters.slice();
                  if ('groupers' in state) me.groupers = state.groupers.slice();
                  if ('sorters' in state || 'groupers' in state) me.sort();

                  if ('filters' in state) {
                    me.filters = state.filters.slice();
                    me.filter();
                  }
                }
              }]);

              return StoreState;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_7__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreSum.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreSum.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreSumJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "../Grid/node_modules/core-js/modules/es6.number.constructor.js");
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreSum
         */

        /**
         * Mixin for Store that handles summaries.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(StoreSum, _ref);

              function StoreSum() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, StoreSum);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(StoreSum).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(StoreSum, [{
                key: "sum",

                /**
                 * Returns sum calculated by adding value of specified field for specified records. Defaults to using all records
                 * in store
                 * @param {String} field Field to summarize by
                 * @param {Common.data.Model[]} records Records to summarize, uses all records if unspecified.
                 * @returns {Number}
                 */
                value: function sum(field) {
                  var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
                  if (!records) return 0;
                  return records.reduce(function (sum, record) {
                    if (record.meta.specialRow) return sum;
                    var v = Number(record[field]);
                    return isNaN(v) ? sum : sum + v;
                  }, 0);
                }
                /**
                 * Returns min value for the specified field. Defaults to look through all records in store
                 * @param {String} field Field to find min value for
                 * @param {Common.data.Model[]} records Records to process, uses all records if unspecified
                 * @returns {Number}
                 */

              }, {
                key: "min",
                value: function min(field) {
                  var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
                  if (!records || !records.length) return 0;
                  return records.reduce(function (min, record) {
                    if (record[field] < min) min = record[field];
                    return min;
                  }, records[0][field]);
                }
                /**
                 * Returns max value for the specified field. Defaults to look through all records in store
                 * @param {String} field Field to find max value for
                 * @param {Common.data.Model[]} records Records to process, uses all records if unspecified
                 * @returns {Number}
                 */

              }, {
                key: "max",
                value: function max(field) {
                  var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
                  if (!records || !records.length) return 0;
                  return records.reduce(function (max, record) {
                    if (record[field] > max) max = record[field];
                    return max;
                  }, records[0][field]);
                }
                /**
                 * Returns the average value for the specified field. Defaults to look through all records in store
                 * @param {String} field Field to calculate average value for
                 * @param {Common.data.Model[]} records Records to process, uses all records if unspecified
                 * @returns {Number}
                 */

              }, {
                key: "average",
                value: function average(field) {
                  var records = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.storage.values;
                  if (!records || !records.length) return 0;
                  var count = 0,
                      sum = records.reduce(function (sum, record) {
                    if (record.meta.specialRow) return sum;
                    var v = parseFloat(record[field]);

                    if (!isNaN(v)) {
                      count++;
                      return sum + v;
                    } else {
                      return sum;
                    }
                  }, 0);
                  return sum / count;
                }
                /**
                 * Returns sum by adding value of specified field for records in the group with the specified groupValue.
                 * @param groupValue Group to summarize
                 * @param {String} field Field to summarize by
                 * @returns {Number} Sum or null if store not grouped
                 */

              }, {
                key: "groupSum",
                value: function groupSum(groupValue, field) {
                  return this.sum(field, this.getGroupRecords(groupValue));
                }
              }]);

              return StoreSum;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_8__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/StoreTree.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/StoreTree.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinStoreTreeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../Grid/node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "../Grid/node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/asyncToGenerator */
        "../Grid/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/StoreTree
         */

        /**
         * Mixin for store with tree related functionality. To learn more about working tree nodes please see the {@link Common/data/mixin/TreeNode} class and [this guide](#guides/data/treedata.md).
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(StoreTree, _ref);

              function StoreTree() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, StoreTree);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(StoreTree).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(StoreTree, [{
                key: "loadChildren",
                //endregion
                //region Children

                /**
                 * Loads children for a parent node that uses load on demand (when expanding it). Base implementation does nothing,
                 * either use AjaxStore which implements it, create your own subclass with an implementation or listen for
                 * `toggleNode` and insert records when you have them available.
                 * @param {Common.data.Model} parentRecord
                 */
                value: function () {
                  var _loadChildren = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.mark(function _callee(parentRecord) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_5___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function loadChildren(_x) {
                    return _loadChildren.apply(this, arguments);
                  };
                }()
                /**
                 * Called from Model when adding children. Not to be called directly, use Model#appendChild() instead.
                 * @internal
                 * @param {Common.data.mixin.TreeNode} parent
                 * @param {Common.data.mixin.TreeNode[]} children
                 * @param {Number} index
                 * @param {Object} isMove
                 * @param {Boolean} [silent]
                 * @fires add
                 * @fires change
                 */

              }, {
                key: "onNodeAddChild",
                value: function onNodeAddChild(parent, children, index, isMove, silent) {
                  var me = this,
                      isRootLoad = parent === me.rootNode && parent.isLoading,
                      storage = me.storage,
                      toAddToUI = [],
                      toAdd = [],
                      previousSibling = children[0].previousSibling;
                  var storeInsertionPoint;
                  me.collectDescendants(children, toAddToUI, toAdd, !(parent.isExpanded(me) && parent.ancestorsExpanded(me))); // Keep CRUD caches up to date unless it's a root load

                  if (!isRootLoad && toAdd.length) {
                    for (var _i = 0; _i < toAdd.length; _i++) {
                      var record = toAdd[_i]; // Only considered an add if not modified or moved

                      if (!me.modified.includes(record) && !isMove[record.id]) {
                        me.added.add(record);
                        me.removed.remove(record);
                      }
                    }
                  } // Root node inserted first


                  if (isRootLoad && me.rootVisible) {
                    toAddToUI.unshift(parent);
                    toAdd.unshift(parent);
                  }

                  if (toAddToUI.length) {
                    // Calculate the insertion point into the flat store.
                    // If the new node is the first, then it goes after the parent node.
                    if (index === 0 || !previousSibling) {
                      storeInsertionPoint = storage.indexOf(parent);
                    } // Otherwise it has to go after the previous visible node which has
                    // to be calculated. See indexOfPreviousVisibleNode for explanation.
                    else {
                        storeInsertionPoint = storage.indexOf(previousSibling) + previousSibling.getDescendantCount(true, me);
                      } // Insert added child nodes at correct location in storage.
                    // We must not react to change - we fire the events here.


                    storage.suspendEvents();
                    me.storage.splice(++storeInsertionPoint, 0, toAddToUI);
                    storage.resumeEvents();
                  } // Since we do not pass through Store#onDataChange we have to handle relations manually here. And since they are
                  // not tied to flat part of store, use all children


                  me.updateDependentStores('add', children); // If it's a root level set data op, then signal 'dataset'

                  if (isRootLoad && toAddToUI.length) {
                    // If we have initial sorters, perform a silent sort before triggering `dataset`
                    // NOTE: Records in toAddToUI will be in the original order, not affected by the sort
                    if (me.sorters.length) {
                      me.sort(null, null, false, true);
                    }

                    if (!silent) {
                      var event = {
                        action: 'dataset',
                        data: me._data,
                        records: toAddToUI
                      };
                      me.trigger('refresh', event);
                      me.trigger('change', event);
                    }
                  } // Else, continue as before to signal a bizarre "isChild" add.
                  else if (!silent) {
                      var _event = {
                        action: 'add',
                        parent: parent,
                        isChild: true,
                        isMove: isMove,
                        records: children,
                        allRecords: toAdd,
                        index: storeInsertionPoint
                      };
                      me.trigger('add', _event);
                      me.trigger('change', _event);
                    }
                }
              }, {
                key: "onNodeRemoveChild",
                value: function onNodeRemoveChild(parent, children, index, isMove) {
                  var me = this,
                      storage = me.storage,
                      toRemoveFromUI = [],
                      toRemove = [];
                  me.collectDescendants(children, toRemoveFromUI, toRemove, !(parent.isExpanded(me) && parent.ancestorsExpanded(me)));

                  if (!isMove) {
                    // Unjoin is recursive, use flat children array
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var _record = _step.value;

                        _record.unJoinStore(me);
                      } // Keep CRUD caches up to date

                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    if (toRemove.length) {
                      for (var _i2 = 0; _i2 < toRemove.length; _i2++) {
                        var record = toRemove[_i2];

                        if (record.stores.includes(me)) {
                          record.unJoinStore(me);
                        } // If was newly added, remove from added list


                        if (me.added.includes(record)) {
                          me.added.remove(record);
                        } // Else add to removed list
                        else {
                            me.removed.add(record);
                          }
                      }

                      me.modified.remove(toRemove);
                    }
                  } // Remove removed child nodes at correct location in storage


                  if (toRemoveFromUI.length) {
                    index = storage.indexOf(toRemoveFromUI[0]); // We must not react to change - we fire the events here.

                    if (index > -1) {
                      storage.suspendEvents();
                      storage.splice(index, toRemoveFromUI.length);
                      storage.resumeEvents();
                    }
                  } else {
                    // If nothing is removed from UI (storage) return -1, showing that removed node was in the collapsed branch
                    index = -1;
                  }

                  var event = {
                    action: 'remove',
                    parent: parent,
                    isChild: true,
                    isMove: isMove,
                    records: children,
                    allRecords: toRemove,
                    index: index
                  };
                  me.trigger('remove', event);
                  me.trigger('change', event);
                }
              }, {
                key: "collectDescendants",
                value: function collectDescendants(node) {
                  var visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                  var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
                  var inCollapsedBranch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                  var me = this,
                      children = Array.isArray(node) ? node : node.children;

                  if (children) {
                    for (var i = 0, len = children.length, child; i < len; i++) {
                      child = children[i];

                      if (!inCollapsedBranch) {
                        visible.push(child);
                      }

                      all.push(child);
                      me.collectDescendants(child, visible, all, inCollapsedBranch || !child.isExpanded(me));
                    }
                  }

                  return {
                    visible: visible,
                    all: all
                  };
                }
                /**
                 * Includes or excludes all records beneath parentRecord in storage. Used when expanding or collapsing
                 * nodes.
                 * @private
                 * @param parentRecord Parent record
                 * @param include Include (true) or exclude (false)
                 * @category Tree
                 */

              }, {
                key: "internalToggleTreeSubRecords",
                value: function internalToggleTreeSubRecords(parentRecord, include) {
                  var me = this,
                      storage = me.storage,
                      index = storage.indexOf(parentRecord),
                      children = [];
                  var excludeCount = 0,
                      parentCollapsed = -1;
                  parentRecord.traverse(function (child) {
                    var isExpanded = child.isExpanded(me),
                        mapMeta = child.instanceMeta(me.id); // at new subparent at the same (or lower) level as previous, reset collapsed check

                    if (parentCollapsed && child.childLevel <= parentCollapsed) parentCollapsed = -1; // records under already collapsed parent wont be processed

                    if (parentCollapsed === -1) {
                      // at a parent and it is collapsed, store its level for collapsed check
                      if (!child.isLeaf && !isExpanded) parentCollapsed = child.childLevel;

                      if (include) {
                        // if including subrecords, add those who are not hidden by a collapsed sub parent
                        children.push(child);
                      } else if (!mapMeta.hidden) {
                        children.push(child); // excluding, only need to count how many visible we have

                        excludeCount++;
                      }
                    }

                    mapMeta.hidden = !include;
                  }, true); // If we expanded a node which is yet to load children, the collected children
                  // array will be empty, so do not broadcast any change event.
                  // If we are collapsing a record which isn't visible (because parent is collapsed) we won't get an index,
                  // which is fine since it is already removed from processedRecords

                  if (children.length && index !== false) {
                    // We must not react to change - we fire the events here with a flag
                    // to tell responders that it's due to an expoand or collapse.
                    storage.suspendEvents();

                    if (include) {
                      storage.splice.apply(storage, [index + 1, 0].concat(children));
                      var event = {
                        action: 'add',
                        isExpand: true,
                        records: children,
                        index: index + 1
                      };
                      me.trigger('add', event);
                      me.trigger('change', event);
                    } else {
                      storage.splice(index + 1, excludeCount);
                      var _event2 = {
                        action: 'remove',
                        isCollapse: true,
                        records: children,
                        index: index + 1
                      };
                      me.trigger('remove', _event2);
                      me.trigger('change', _event2);
                    }

                    storage.resumeEvents();
                  }
                }
                /**
                 * Remove all records beneath parentRecord from storage.
                 * @private
                 * @param parentRecord Parent record
                 * @category Tree
                 */

              }, {
                key: "onNodeCollapse",
                value: function onNodeCollapse(parentRecord) {
                  return this.internalToggleTreeSubRecords(parentRecord, false);
                }
                /**
                 * Add all records beneath parentRecord from storage.
                 * @private
                 * @param parentRecord Parent record
                 * @category Tree
                 */

              }, {
                key: "onNodeExpand",
                value: function onNodeExpand(parentRecord) {
                  return this.internalToggleTreeSubRecords(parentRecord, true);
                } //endregion

              }, {
                key: "isTree",
                //region Getters

                /**
                 * True if this Store is configured to handle tree data (with `tree : true`).
                 * @property {Boolean}
                 * @readonly
                 * @category Tree
                 */
                get: function get() {
                  return this.tree;
                }
                /**
                 * Get all leaves in store with tree data
                 * @returns {Common.data.Model[]}
                 * @category Tree
                 */

              }, {
                key: "leaves",
                get: function get() {
                  var me = this,
                      result = [];

                  if (me.tree) {
                    me.traverse(function (record) {
                      if (record.isLeaf) {
                        result.push(record);
                      }
                    });
                    return result;
                  } else {
                    me.allRecords.forEach(function (r) {
                      if (r.isLeaf) {
                        result.push(r);
                      }

                      r.traverse(function (record) {
                        if (record.isLeaf) {
                          result.push(record);
                        }
                      }, true);
                    });
                  }

                  return result;
                }
              }]);

              return StoreTree;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/mixin/TreeNode.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/data/mixin/TreeNode.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataMixinTreeNodeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/mixin/TreeNode
         */

        /**
         * Mixin for Model with tree node related functionality. This class is mixed into the {@link Common/data/Model} class.
         *
         * ## Adding and removing child nodes
         * ```
         * const parent = store.getById(1),
         *
         * firstBorn = parent.insertChild({
         *      name : 'Child node'
         *  }, parent.children[0]); // Insert a child at a specific place in the children array
         *
         * parent.removeChild(parent.children[0]); // Removes a child node
         * parent.appendChild({ name : 'New child node' }); // Appends a child node
         * ```
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(TreeNode, _ref);

              function TreeNode() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, TreeNode);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(TreeNode).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(TreeNode, [{
                key: "ingestChildren",

                /**
                 * This is a read-only field provided in server synchronization packets to specify
                 * which record id is the parent of the record.
                 * @readonly
                 * @field {String|Number} parentId
                 */
                value: function ingestChildren(childRecord) {
                  var stores = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.stores;
                  var store = stores[0],
                      MyClass = this.constructor,
                      inProcessChildren = this.inProcessChildren;

                  if (childRecord === true) {
                    if (inProcessChildren) {
                      return true;
                    }

                    return [];
                  }

                  if (childRecord) {
                    if (!Array.isArray(childRecord)) {
                      childRecord = [childRecord];
                    }

                    var i = 0,
                        len = childRecord.length,
                        result = [],
                        child;

                    for (; i < len; i++) {
                      child = childRecord[i];
                      child = child instanceof _Model_js__WEBPACK_IMPORTED_MODULE_14__["default"] ? child : store ? store.createRecord(child) : new MyClass(child, null, null, true);
                      result.push(child);
                    }

                    return result;
                  }
                }
                /**
                 * Child nodes. To allow loading children on demand, specify `children : true` in your data.
                 * @member {Common.data.Model[]} children
                 * @category Parent & children
                 */

                /**
                 * Called during creation to also turn any children into Models joined to the same stores as this model
                 * @internal
                 * @category Parent & children
                 */

              }, {
                key: "processChildren",
                value: function processChildren() {
                  var stores = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.stores;
                  var me = this;
                  me.inProcessChildren = true;
                  var children = me.ingestChildren(me.data[me.constructor.childrenField], stores);

                  if (children) {
                    if (children.length) {
                      // We are processing a remote load
                      if (me.children === true) {
                        me.children = [];
                      }

                      me.appendChild(children);
                    } // Flagged for load on demand
                    else if (children === true) {
                        me.children = true;
                      }
                  }

                  me.inProcessChildren = false;
                }
                /**
                 * This property is `true` if this record has all expanded ancestors and is therefore
                 * eligible for inclusion in a UI.
                 * @property {Boolean}
                 * @readonly
                 * @category Parent & children
                 */

              }, {
                key: "ancestorsExpanded",
                value: function ancestorsExpanded(store) {
                  var parent = this.parent;
                  return !parent || parent.isExpanded(store) && parent.ancestorsExpanded(store);
                }
                /**
                 * Used by stores to assess the record's collapsed/expanded state in that store.
                 * @param {Common.data.Store} store
                 * @category Parent & children
                 */

              }, {
                key: "isExpanded",
                value: function isExpanded(store) {
                  var mapMeta = this.instanceMeta(store.id); // Default initial expanded/collapsed state when in the store
                  // to the record's original expanded property.

                  if (!mapMeta.hasOwnProperty('collapsed')) {
                    mapMeta.collapsed = !this.expanded;
                  }

                  return !mapMeta.collapsed;
                } // A read-only property. It provides the initial state upon load
                // The UI's expanded/collapsed state is in the store's meta map.

              }, {
                key: "getDescendantCount",

                /**
                 * Count visible (expanded)/all children for this node, optionally specifying for which store.
                 * @param {Boolean} [onlyVisible] Specify `true` to only count visible (expanded) children.
                 * @param {Common.data.Store} [store] A Store to which this node belongs
                 * @returns {Number}
                 * @category Parent & children
                 */
                value: function getDescendantCount() {
                  var onlyVisible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                  var store = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.firstStore;
                  var children = this.children;

                  if (!children || !Array.isArray(children) || onlyVisible && !this.isExpanded(store)) {
                    return 0;
                  }

                  return children.reduce(function (count, child) {
                    return count + child.getDescendantCount(onlyVisible);
                  }, children.length);
                }
                /**
                 * Retrieve all children (by traversing sub nodes)
                 * @returns {Common.data.Model[]}
                 * @category Parent & children
                 */

              }, {
                key: "traverse",

                /**
                 * Traverses all child nodes recursively calling the passed function
                 * on a target node **before** iterating the child nodes.
                 * @param fn
                 * @category Parent & children
                 */
                value: function traverse(fn) {
                  var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var children = this.children;

                  if (!skipSelf) {
                    fn.call(this, this);
                  } // Simply testing whether there is non-zero children length
                  // is 10x faster than using this.isLoaded


                  for (var i = 0, l = children && children.length; i < l; i++) {
                    children[i].traverse(fn);
                  }
                }
                /**
                 * Traverses all child nodes recursively calling the passed function
                 * on child nodes of a target **before** calling it it on the node.
                 * @param fn
                 * @category Parent & children
                 */

              }, {
                key: "traverseBefore",
                value: function traverseBefore(fn) {
                  var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var children = this.children; // Simply testing whether there is non-zero children length
                  // is 10x faster than using this.isLoaded

                  for (var i = 0, l = children && children.length; i < l; i++) {
                    children[i].traverse(fn);
                  }

                  if (!skipSelf) {
                    fn.call(this, this);
                  }
                }
                /**
                 * Traverses child nodes recursively while fn returns true
                 * @param {Function} fn
                 * @category Parent & children
                 * @returns {Boolean}
                 */

              }, {
                key: "traverseWhile",
                value: function traverseWhile(fn) {
                  var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var me = this;
                  var goOn = true;

                  if (!skipSelf) {
                    goOn = fn.call(me, me) !== false;
                  }

                  if (goOn && me.isLoaded) {
                    goOn = me.children.every(function (child) {
                      return child.traverseWhile(fn);
                    });
                  }

                  return goOn;
                }
                /**
                 * Bubbles up from this node, calling the specified function with each node.
                 *
                 * @param {Function} fn
                 * @category Parent & children
                 */

              }, {
                key: "bubble",
                value: function bubble(fn) {
                  var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var me = this;

                  if (!skipSelf) {
                    fn.call(me, me);
                  }

                  while (me.parent) {
                    me = me.parent;
                    fn.call(me, me);
                  }
                }
                /**
                 * Bubbles up from this node, calling the specified function with each node,
                 * while the function returns true.
                 *
                 * @param {Function} fn
                 * @category Parent & children
                 * @return {Boolean}
                 */

              }, {
                key: "bubbleWhile",
                value: function bubbleWhile(fn) {
                  var skipSelf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var me = this,
                      goOn = true;

                  if (!skipSelf) {
                    goOn = fn.call(me, me);
                  }

                  while (goOn && me.parent) {
                    me = me.parent;
                    goOn = fn.call(me, me);
                  }

                  return goOn;
                }
                /**
                 * Checks if this model contain another model as one of it's descendants
                 *
                 * @param {Common.data.Model|String|Number} childOrId child node or id
                 * @category Parent & children
                 * @returns {Boolean}
                 */

              }, {
                key: "contains",
                value: function contains(childOrId) {
                  if (childOrId && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default()(childOrId) === 'object') {
                    childOrId = childOrId.id;
                  }

                  return !this.traverseWhile(function (node) {
                    return node.id != childOrId;
                  });
                }
              }, {
                key: "getTopParent",
                value: function getTopParent(all) {
                  var result;

                  if (all) {
                    result = [];
                    this.bubbleWhile(function (t) {
                      result.push(t);
                      return t.parent && !t.parent.isRoot;
                    });
                  } else {
                    result = null;
                    this.bubbleWhile(function (t) {
                      if (!t.parent) {
                        result = t;
                      }

                      return t.parent && !t.parent.isRoot;
                    });
                  }

                  return result;
                }
                /**
                 * Append a child record(s) to any current children.
                 * @param {Common.data.Model|Common.data.Model[]} childRecord
                 * @param {Boolean} [silent] Specify true to suppress events
                 * @returns {Common.data.Model|Common.data.Model[]}
                 * @category Parent & children
                 */

              }, {
                key: "appendChild",
                value: function appendChild(childRecord) {
                  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  return this.insertChild(childRecord, null, silent);
                }
                /**
                 * Insert a child record(s) before an existing child record.
                 * @param {Common.data.Model|Common.data.Model[]} childRecord
                 * @param {Common.data.Model} [beforeRecord] insert child before this record
                 * @param {Boolean} [silent] Specify true to suppress events
                 * @returns {Common.data.Model|Common.data.Model[]}
                 * @category Parent & children
                 */

              }, {
                key: "insertChild",
                value: function insertChild(childRecord, beforeRecord) {
                  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // Handle deprecated signature

                  if (typeof childRecord === 'number') {
                    var _index = childRecord;
                    childRecord = beforeRecord;
                    beforeRecord = this.children[_index];
                  }

                  var me = this,
                      wasLeaf = me.isLeaf,
                      returnArray = Array.isArray(childRecord);

                  if (!silent) {
                    if (!me.stores.every(function (s) {
                      return s.trigger('beforeAdd', {
                        records: childRecord,
                        parent: me
                      }) !== false;
                    })) {
                      return null;
                    }
                  } // This call makes child record an array containing Models


                  childRecord = me.ingestChildren(childRecord); // NOTE: see comment in Model::set() about before/in/after calls approach.

                  var index = beforeRecord ? beforeRecord.parentIndex : me.children ? me.children.length : 0,
                      preResult = me.beforeInsertChild ? me.beforeInsertChild(childRecord) : undefined,
                      inserted = me.internalAppendInsert(childRecord, beforeRecord, silent); // If we've transitioned to being a branch node, signal a change event
                  // so that the UI updates.
                  // Not if it's due to root node loading. StoreTree#onNodeAddChild
                  // for the rootNode will fire a store refresh.

                  if (me.isLeaf !== wasLeaf && !me.root.isLoading && !silent) {
                    me.stores.forEach(function (s) {
                      var changes = {
                        isLeaf: false
                      };
                      s.trigger('update', {
                        record: me,
                        changes: changes
                      });
                      s.trigger('change', {
                        action: 'update',
                        record: me,
                        changes: changes
                      });
                    });
                  }

                  me.afterInsertChild && me.afterInsertChild(index, childRecord, preResult, inserted);
                  return returnArray || !inserted ? inserted : inserted[0];
                }
              }, {
                key: "internalAppendInsert",
                value: function internalAppendInsert(newRecords, beforeRecord, silent) {
                  var me = this,
                      stores = me.stores,
                      root = me.root,
                      rootStore = root.firstStore,
                      isMove = {};
                  var isNoop, start, i, newRecordsCloned; // The reference node must be one of our children. If not, fall back to an append.

                  if (beforeRecord && beforeRecord.parent !== me) {
                    beforeRecord = null;
                  } // If the records starting at insertAt or (insertAt - 1), are the same sequence
                  // that we are being asked to add, this is a no-op.


                  if (me.children) {
                    var children = me.children,
                        insertAt = beforeRecord ? beforeRecord.parentIndex : children.length;

                    if (children[start = insertAt] === newRecords[0] || children[start = insertAt - 1] === newRecords[0]) {
                      for (isNoop = true, i = 0; isNoop && i < newRecords.length; i++) {
                        if (newRecords[i] !== children[start + i]) {
                          isNoop = false;
                        }
                      }
                    }
                  } // Fulfill the contract of appendChild/insertChild even if we did not have to do anything.
                  // Callers must be able to correctly postprocess the returned value as an array.


                  if (isNoop) {
                    return newRecords;
                  } // Remove incoming child nodes from any current parent.


                  for (i = 0; i < newRecords.length; i++) {
                    var newRecord = newRecords[i],
                        oldParent = newRecord.parent; // Store added should not be modified for adds
                    // caused by moving.

                    isMove[newRecord.id] = newRecord.root === root; // Check if any descendants of the added node are moves.

                    rootStore && newRecord.traverse(function (r) {
                      if (r.root === root) {
                        isMove[r.id] = true;
                      }
                    }); // If the new record has a parent, remove from that parent.
                    // This operation may be vetoed by listeners.
                    // If it is vetoed, then remove from the newRecords and do not
                    // set the parent property

                    if (oldParent && oldParent.removeChild(newRecord, isMove[newRecord.id]) === false) {
                      if (!newRecordsCloned) {
                        newRecords = newRecords.slice();
                        newRecordsCloned = true;
                      }

                      newRecords.splice(i--, 1);
                    } else {
                      var parentIdField = newRecord.constructor.parentIdField,
                          parentId = me.isAutoRoot ? null : me.id;
                      newRecord.parent = me;
                      newRecord.data[parentIdField] = parentId; // If we are in the recursive inclusion of children at construction
                      // time, or in a store load, that must not be a data modification.
                      // Otherwise, we have to signal a change

                      if (!(me.inProcessChildren || me.isLoading)) {
                        var toSet = {
                          parentId: parentId
                        },
                            modified = newRecord.meta.modified,
                            oldParentId = oldParent ? oldParent.id : null,
                            wasSet = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()({}, parentIdField, {
                          value: me.id,
                          oldValue: oldParentId
                        }); // Changing back to its original value


                        if (modified[parentIdField] === me.id) {
                          delete modified[parentIdField];
                        } // Cache its original value
                        else if (!('parentId' in modified)) {
                            modified[parentIdField] = oldParentId;
                          }

                        newRecord.afterChange(toSet, wasSet);
                      }
                    }
                  } // Still records to insert after beforeRemove listeners may have vetoed some


                  if (newRecords.length) {
                    var _insertAt = me.addToChildren(me.children || (me.children = []), beforeRecord, newRecords);

                    me.addToChildren(me.unfilteredChildren, beforeRecord, newRecords, true);
                    stores.forEach(function (store) {
                      if (!store.chained) {
                        newRecords.forEach(function (newRecord) {
                          newRecord.instanceMeta(store.id).collapsed = !newRecord.expanded;
                          newRecord.joinStore(store);
                        }); // Add to store (will also add any child records and trigger events)

                        store.onNodeAddChild(me, newRecords, _insertAt, isMove, silent);
                      }
                    });
                  }

                  return newRecords;
                }
                /**
                 * Remove a child record. Only direct children of this node can be removed, others are ignored.
                 * @param {Common.data.Model|Common.data.Model[]} childRecords The record(s) to remove
                 * @param {Boolean} [isMove] Pass `true` if the record is being moved within the same store.
                 * @category Parent & children
                 */

              }, {
                key: "removeChild",
                value: function removeChild(childRecords) {
                  var isMove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var me = this,
                      wasLeaf = me.isLeaf,
                      children = me.children,
                      stores = me.stores;

                  if (!Array.isArray(childRecords)) {
                    childRecords = [childRecords];
                  }

                  childRecords = childRecords.filter(function (r) {
                    return r.parent === me;
                  }); // Allow store listeners to veto the beforeRemove event

                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = stores[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var store = _step.value;

                      if (!store.chained) {
                        if (store.trigger('beforeRemove', {
                          parent: me,
                          records: childRecords,
                          isMove: isMove
                        }) === false) {
                          return false;
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  var preResult = me.beforeRemoveChild ? me.beforeRemoveChild(childRecords, isMove) : undefined;
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    var _loop = function _loop() {
                      var childRecord = _step2.value;
                      var index = me.removeFromChildren(children, childRecord);
                      me.removeFromChildren(me.unfilteredChildren, childRecord, true);
                      stores.forEach(function (store) {
                        if (!store.chained) {
                          store.onNodeRemoveChild(me, [childRecord], index, isMove);
                        }
                      });
                      childRecord.parent = childRecord.parentIndex = childRecord.unfilteredIndex = childRecord.nextSibling = childRecord.previousSibling = null;
                    };

                    for (var _iterator2 = childRecords[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      _loop();
                    } // If we've transitioned to being a leaf node, signal a change event
                    // so that the UI updates

                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }

                  if (me.isLeaf !== wasLeaf) {
                    me.stores.forEach(function (s) {
                      var changes = {
                        isLeaf: true
                      };
                      s.trigger('update', {
                        record: me,
                        changes: changes
                      });
                      s.trigger('change', {
                        action: 'update',
                        record: me,
                        changes: changes
                      });
                    });
                  }

                  me.afterRemoveChild && me.afterRemoveChild(childRecords, preResult, isMove);
                }
              }, {
                key: "clearChildren",
                value: function clearChildren() {
                  var me = this,
                      children = me.children,
                      stores = me.stores;

                  if (children) {
                    me.children = [];

                    if (me.unfilteredChildren) {
                      me.unfilteredChildren = [];
                    }

                    stores.forEach(function (store) {
                      if (!store.chained) {
                        store.onNodeRemoveChild(me, children, 0);
                      }
                    });
                  }
                }
                /**
                 * Removes all records from the rootNode
                 * @private
                 */

              }, {
                key: "clear",
                value: function clear() {
                  var me = this,
                      stores = me.stores,
                      children = me.children.slice(); // only allow on root node, because we will be clearing everything

                  if (!me.isRoot) return;
                  var _iteratorNormalCompletion3 = true;
                  var _didIteratorError3 = false;
                  var _iteratorError3 = undefined;

                  try {
                    for (var _iterator3 = stores[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                      var store = _step3.value;

                      if (!store.chained) {
                        if (store.trigger('beforeRemove', {
                          parent: me,
                          records: children,
                          isMove: false,
                          removingAll: true
                        }) === false) {
                          return false;
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                      }
                    } finally {
                      if (_didIteratorError3) {
                        throw _iteratorError3;
                      }
                    }
                  }

                  me.children.length = 0;
                  stores.forEach(function (store) {
                    children.forEach(function (child) {
                      if (child.stores.includes(store)) {
                        // this will drill down the child, unregistering whole branch
                        child.unJoinStore(store);
                      }

                      child.parent = child.parentIndex = child.nextSibling = child.previousSibling = null;
                    });
                    store.storage.suspendEvents();
                    store.storage.clear();
                    store.storage.resumeEvents();
                    store.added.clear();
                    store.modified.clear();
                    store.trigger('removeAll');
                    store.trigger('change', {
                      action: 'removeall'
                    });
                  });
                }
              }, {
                key: "updateChildrenIndex",
                value: function updateChildrenIndex(children) {
                  var unfiltered = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex';
                  var previousSibling = null;

                  for (var i = 0; i < children.length; i++) {
                    var child = children[i];
                    child[indexName] = i;

                    if (!unfiltered) {
                      child.previousSibling = previousSibling;

                      if (previousSibling) {
                        previousSibling.nextSibling = child;
                      } // Last child never has a nextSibling


                      if (i === children.length - 1) {
                        child.nextSibling = null;
                      }

                      previousSibling = child;
                    }
                  }
                }
              }, {
                key: "addToChildren",
                value: function addToChildren(children, beforeRecord, newRecords) {
                  var unfiltered = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

                  if (children) {
                    var indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
                        index = beforeRecord ? beforeRecord[indexName] : children.length;
                    children.splice.apply(children, [index, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(newRecords)));
                    this.updateChildrenIndex(children, unfiltered);
                    return index;
                  }
                }
              }, {
                key: "removeFromChildren",
                value: function removeFromChildren(children, childRecord) {
                  var unfiltered = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                  if (children) {
                    var indexName = unfiltered ? 'unfilteredIndex' : 'parentIndex',
                        index = childRecord[indexName];

                    if (index > -1) {
                      children.splice(index, 1);
                      this.updateChildrenIndex(children, unfiltered);
                    }

                    return index;
                  }
                }
              }, {
                key: "expanded",
                get: function get() {
                  return this.data.expanded;
                }
                /**
                 * Depth in the tree at which this node exists. First visual level of nodes are at level 0, their direct children at
                 * level 1 and so on.
                 * @property {Number}
                 * @readonly
                 * @category Parent & children
                 */

              }, {
                key: "childLevel",
                get: function get() {
                  return this.parent ? this.parent.childLevel + 1 : this.isRoot ? -1 : 0;
                }
                /**
                 * Is a leaf node in a tree structure?
                 * @property {Boolean}
                 * @readonly
                 * @category Parent & children
                 */

              }, {
                key: "isLeaf",
                get: function get() {
                  return Boolean(!this.children || this.constructor.convertEmptyParentToLeaf && !this.children.length && !this.isRoot);
                }
                /**
                 * Is a parent node in a tree structure?
                 * @property {Boolean}
                 * @readonly
                 * @category Parent & children
                 */

              }, {
                key: "isParent",
                get: function get() {
                  return !this.isLeaf;
                }
                /**
                 * Returns true for parent nodes with children loaded (there might still be no children)
                 * @property {Boolean}
                 * @readonly
                 * @category Parent & children
                 */

              }, {
                key: "isLoaded",
                get: function get() {
                  return this.isParent && Array.isArray(this.children);
                }
                /**
                 * Count all children (including sub-children) for a node (in its `firstStore´)
                 * @member {Number}
                 * @category Parent & children
                 */

              }, {
                key: "descendantCount",
                get: function get() {
                  return this.getDescendantCount();
                }
                /**
                 * Count visible (expanded) children (including sub-children) for a node (in its `firstStore`)
                 * @member {Number}
                 * @category Parent & children
                 */

              }, {
                key: "visibleDescendantCount",
                get: function get() {
                  return this.getDescendantCount(true);
                }
              }, {
                key: "allChildren",
                get: function get() {
                  var children = this.children;
                  if (!children) return [];
                  return children.reduce(function (all, child) {
                    all.push(child); // push.apply is faster than push with array spread:
                    // https://jsperf.com/push-apply-vs-push-with-array-spread/1

                    all.push.apply(all, child.allChildren);
                    return all;
                  }, []);
                }
                /**
                 * Get the first child of this node
                 * @returns {Common.data.Model}
                 * @category Parent & children
                 */

              }, {
                key: "firstChild",
                get: function get() {
                  var children = this.children;
                  return children && children.length && children[0] || null;
                }
                /**
                 * Get the last child of this node
                 * @returns {Common.data.Model}
                 * @category Parent & children
                 */

              }, {
                key: "lastChild",
                get: function get() {
                  var children = this.children;
                  return children && children.length && children[children.length - 1] || null;
                }
                /**
                 * Returns count of all preceding sibling nodes (including their children).
                 * @property {Number}
                 * @category Parent & children
                 */

              }, {
                key: "previousSiblingsTotalCount",
                get: function get() {
                  var task = this.previousSibling,
                      count = this.parentIndex;

                  while (task) {
                    count += task.descendantCount;
                    task = task.previousSibling;
                  }

                  return count;
                }
              }, {
                key: "root",
                get: function get() {
                  return this.parent && this.parent.root || this;
                }
                /**
                 * Reading this property returns the id of the parent node, if this record is a child of a node.
                 *
                 * Setting this property appends this record to the record with the passed
                 * id **in the same store that this record is already in**.
                 *
                 * Note that setting this property is **only valid if this record is already
                 * part of a tree store**.
                 *
                 * This is not intended for general use. This is for when a server responds to a record
                 * mutation and the server decides to move a record to a new parent. If a `parentId` property
                 * is passed in the response data for a record, that record will be moved.
                 * @property {Number|String}
                 * @category Parent & children
                 */

              }, {
                key: "parentId",
                get: function get() {
                  return this.parent && !this.parent.isRoot ? this.parent.id : null;
                },
                set: function set(parentId) {
                  var me = this,
                      parent = me.parent,
                      newParent = parentId && me.firstStore.getById(parentId); // Handle exact equality of parent.
                  // Also handle one being null and the other being undefined meaning no change.

                  if (!(newParent === parent || !parent && !newParent)) {
                    // If we are batching, we do not trigger a change immediately.
                    // endBatch will set the field which will set the property again.
                    if (me.isBatchUpdating) {
                      me.meta.batchChanges.parentId = parentId;
                    } else {
                      if (newParent) {
                        newParent.appendChild(me);
                      } else {
                        me.parent.removeChild(me);
                      }
                    }
                  }
                }
              }], [{
                key: "parentIdField",
                set: function set(parentIdField) {
                  // Maintainer: the "this" references in here reference two different contexts.
                  // Outside of the property definition, it's the Model Class.
                  // In the getter and setter, it's the record instance.
                  this._parentIdField = parentIdField;
                  Object.defineProperty(this.prototype, parentIdField, {
                    set: function set(parentId) {
                      // no arrow functions here, need `this` to change to instance
                      // noinspection JSPotentiallyInvalidUsageOfClassThis
                      this.parentId = parentId;
                    },
                    get: function get() {
                      // no arrow functions here, need `this` to change to instance
                      // noinspection JSPotentiallyInvalidUsageOfClassThis
                      return this.parentId;
                    }
                  });
                },
                get: function get() {
                  return this._parentIdField || 'parentId';
                }
              }]);

              return TreeNode;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/Helpers.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/data/stm/Helpers.js ***!
        \**********************************************/

      /*! exports provided: resetQueue */

      /***/
      function GridLibCommonDataStmHelpersJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "resetQueue", function () {
          return resetQueue;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./Props.js */
        "../Grid/lib/Common/data/stm/Props.js");

        var productName = 'scheduler';

        var resetQueue = function resetQueue(stm, options) {
          var undo = options.undo,
              redo = options.redo;
          var newProps;

          if (undo && !redo) {
            var _newProps;

            newProps = (_newProps = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newProps, _Props_js__WEBPACK_IMPORTED_MODULE_1__["QUEUE_PROP"], stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["QUEUE_PROP"]].slice(stm.position)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newProps, _Props_js__WEBPACK_IMPORTED_MODULE_1__["POS_PROP"], 0), _newProps);
          } else if (redo && !undo) {
            newProps = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_1__["QUEUE_PROP"], stm[_Props_js__WEBPACK_IMPORTED_MODULE_1__["QUEUE_PROP"]].slice(0, stm.position));
          } else {
            var _newProps3;

            newProps = (_newProps3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newProps3, _Props_js__WEBPACK_IMPORTED_MODULE_1__["QUEUE_PROP"], []), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newProps3, _Props_js__WEBPACK_IMPORTED_MODULE_1__["POS_PROP"], 0), _newProps3);
          }

          ;
          return [newProps, function () {
            stm.notifyStoresAboutQueueReset(options);
          }];
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/Props.js":
      /*!********************************************!*\
        !*** ../Grid/lib/Common/data/stm/Props.js ***!
        \********************************************/

      /*! exports provided: STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP, PROPS */

      /***/
      function GridLibCommonDataStmPropsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "STATE_PROP", function () {
          return STATE_PROP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "STORES_PROP", function () {
          return STORES_PROP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "QUEUE_PROP", function () {
          return QUEUE_PROP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "POS_PROP", function () {
          return POS_PROP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TRANSACTION_PROP", function () {
          return TRANSACTION_PROP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "TRANSACTION_TIMER_PROP", function () {
          return TRANSACTION_TIMER_PROP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "AUTO_RECORD_PROP", function () {
          return AUTO_RECORD_PROP;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "PROPS", function () {
          return PROPS;
        });
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "../Grid/node_modules/core-js/modules/es6.object.freeze.js");
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__);

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/Props.js
        * @internal
        */

        var STATE_PROP = Symbol('STATE_PROP');
        var STORES_PROP = Symbol('STORES_PROP');
        var QUEUE_PROP = Symbol('QUEUE_PROP');
        var POS_PROP = Symbol('POS_PROP');
        var TRANSACTION_PROP = Symbol('TRANSACTION_PROP');
        var TRANSACTION_TIMER_PROP = Symbol('TRANSACTION_TIMER_PROP');
        var AUTO_RECORD_PROP = Symbol('AUTO_RECORD_PROP');
        var PROPS = Object.freeze([STATE_PROP, STORES_PROP, QUEUE_PROP, POS_PROP, TRANSACTION_PROP, TRANSACTION_TIMER_PROP, AUTO_RECORD_PROP]);
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/StateTrackingManager.js":
      /*!***********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/StateTrackingManager.js ***!
        \***********************************************************/

      /*! exports provided: makeModelUpdateAction, makeModelInsertChildAction, makeModelRemoveChildAction, makeStoreModelAddAction, makeStoreModelInsertAction, makeStoreModelRemoveAction, makeStoreRemoveAllAction, default */

      /***/
      function GridLibCommonDataStmStateTrackingManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeModelUpdateAction", function () {
          return makeModelUpdateAction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeModelInsertChildAction", function () {
          return makeModelInsertChildAction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeModelRemoveChildAction", function () {
          return makeModelRemoveChildAction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeStoreModelAddAction", function () {
          return makeStoreModelAddAction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeStoreModelInsertAction", function () {
          return makeStoreModelInsertAction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeStoreModelRemoveAction", function () {
          return makeStoreModelRemoveAction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "makeStoreRemoveAllAction", function () {
          return makeStoreRemoveAllAction;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return StateTrackingManager;
        });
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "../Grid/node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _state_StateBase_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ./state/StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");
        /* harmony import */


        var _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ./state/DisabledState.js */
        "../Grid/lib/Common/data/stm/state/DisabledState.js");
        /* harmony import */


        var _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ./state/ReadyState.js */
        "../Grid/lib/Common/data/stm/state/ReadyState.js");
        /* harmony import */


        var _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ./state/RecordingState.js */
        "../Grid/lib/Common/data/stm/state/RecordingState.js");
        /* harmony import */


        var _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ./state/RestoringState.js */
        "../Grid/lib/Common/data/stm/state/RestoringState.js");
        /* harmony import */


        var _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ./state/AutoReadyState.js */
        "../Grid/lib/Common/data/stm/state/AutoReadyState.js");
        /* harmony import */


        var _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ./state/AutoRecordingState.js */
        "../Grid/lib/Common/data/stm/state/AutoRecordingState.js");
        /* harmony import */


        var _state_Registry_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ./state/Registry.js */
        "../Grid/lib/Common/data/stm/state/Registry.js");
        /* harmony import */


        var _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ./action/UpdateAction.js */
        "../Grid/lib/Common/data/stm/action/UpdateAction.js");
        /* harmony import */


        var _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ./action/InsertChildAction.js */
        "../Grid/lib/Common/data/stm/action/InsertChildAction.js");
        /* harmony import */


        var _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ./action/RemoveChildAction.js */
        "../Grid/lib/Common/data/stm/action/RemoveChildAction.js");
        /* harmony import */


        var _action_AddAction_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ./action/AddAction.js */
        "../Grid/lib/Common/data/stm/action/AddAction.js");
        /* harmony import */


        var _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
        /*! ./action/InsertAction.js */
        "../Grid/lib/Common/data/stm/action/InsertAction.js");
        /* harmony import */


        var _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
        /*! ./action/RemoveAction.js */
        "../Grid/lib/Common/data/stm/action/RemoveAction.js");
        /* harmony import */


        var _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
        /*! ./action/RemoveAllAction.js */
        "../Grid/lib/Common/data/stm/action/RemoveAllAction.js");
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
        /*! ./Props.js */
        "../Grid/lib/Common/data/stm/Props.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/StateTrackingManager
        */

        var makeModelUpdateAction = function makeModelUpdateAction(model, newData, oldData) {
          return new _action_UpdateAction_js__WEBPACK_IMPORTED_MODULE_26__["default"]({
            model: model,
            newData: newData,
            oldData: oldData
          });
        };

        var makeModelInsertChildAction = function makeModelInsertChildAction(parentModel, insertIndex, childModels, context) {
          return new _action_InsertChildAction_js__WEBPACK_IMPORTED_MODULE_27__["default"]({
            parentModel: parentModel,
            childModels: childModels,
            insertIndex: insertIndex,
            context: context
          });
        };

        var makeModelRemoveChildAction = function makeModelRemoveChildAction(parentModel, childModels, context) {
          return new _action_RemoveChildAction_js__WEBPACK_IMPORTED_MODULE_28__["default"]({
            parentModel: parentModel,
            childModels: childModels,
            context: context
          });
        };

        var makeStoreModelAddAction = function makeStoreModelAddAction(store, modelList, silent) {
          return new _action_AddAction_js__WEBPACK_IMPORTED_MODULE_29__["default"]({
            store: store,
            modelList: modelList,
            silent: silent
          });
        };

        var makeStoreModelInsertAction = function makeStoreModelInsertAction(store, insertIndex, modelList, context, silent) {
          return new _action_InsertAction_js__WEBPACK_IMPORTED_MODULE_30__["default"]({
            store: store,
            insertIndex: insertIndex,
            modelList: modelList,
            context: context,
            silent: silent
          });
        };

        var makeStoreModelRemoveAction = function makeStoreModelRemoveAction(store, modelList, context, silent) {
          return new _action_RemoveAction_js__WEBPACK_IMPORTED_MODULE_31__["default"]({
            store: store,
            modelList: modelList,
            context: context,
            silent: silent
          });
        };

        var makeStoreRemoveAllAction = function makeStoreRemoveAllAction(store, allRecords, silent) {
          return new _action_RemoveAllAction_js__WEBPACK_IMPORTED_MODULE_32__["default"]({
            store: store,
            allRecords: allRecords,
            silent: silent
          });
        };

        var stateTransition = function stateTransition(stm, event) {
          for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
            args[_key - 2] = arguments[_key];
          }

          var newState = event.call.apply(event, [stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]], stm].concat(args));

          if (typeof newState === 'string') {
            stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_25__["default"].resolveStmState(newState);
          } else if (newState instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_18__["default"]) {
            stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]] = newState;
          } else if (Array.isArray(newState)) {
            var _newState = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(newState, 2),
                state = _newState[0],
                next = _newState[1];

            if (typeof state === 'string') {
              stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_25__["default"].resolveStmState(state);
            } else if (state instanceof _state_StateBase_js__WEBPACK_IMPORTED_MODULE_18__["default"]) {
              stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]] = state;
            } else if (state && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(state) === 'object') {
              stm = Object.assign(stm, state);
              stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_25__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]]);
            }

            if (typeof next === 'function') {
              stateTransition.apply(void 0, [stm, next].concat(args));
            }
          } else if (newState && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(newState) === 'object') {
            stm = Object.assign(stm, newState);
            stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]] = _state_Registry_js__WEBPACK_IMPORTED_MODULE_25__["default"].resolveStmState(stm[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]]);
          }
        };
        /**
         * State Tracking Manager.
         *
         * When enabled tracks state of every store registered via {@link #function-addStore}.
         * Use {@link #function-undo} / {@link #function-redo} method calls to restore state to a particular
         * point in time
         *
         * @example
         *
         * stm = new StateTrackingManager({
         *     autoRecord : true,
         *     listeners  : {
         *        'recordingstop' : () => {
         *            // your custom code to update undo/redo GUI controls
         *            updateUndoRedoControls();
         *        },
         *        'restoringstop' : ({ stm }) => {
         *            // your custom code to update undo/redo GUI controls
         *            updateUndoRedoControls();
         *        }
         *    },
         *    getTransactionTitle : (transaction) => {
         *        // your custom code to analyze the transaction and return custom transaction title
         *        const lastAction = transaction.queue[transaction.queue.length - 1];
         *
         *        if (lastAction instanceof AddAction) {
         *            let title = 'Add new record';
         *        }
         *
         *        return title;
         *    }
         * });
         *
         * stm.addStore(userStore);
         * stm.addStore(companyStore);
         * stm.addStore(otherStore);
         *
         * stm.enable();
         */


        var StateTrackingManager =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(StateTrackingManager, _Events);

          function StateTrackingManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, StateTrackingManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StateTrackingManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(StateTrackingManager, [{
            key: "construct",
            value: function construct() {
              var _Object$assign, _get2;

              var me = this;
              Object.assign(me, (_Object$assign = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"], _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_20__["default"]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"], []), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_33__["QUEUE_PROP"], []), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_33__["POS_PROP"], 0), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_33__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_33__["TRANSACTION_TIMER_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, _Props_js__WEBPACK_IMPORTED_MODULE_33__["AUTO_RECORD_PROP"], false), _Object$assign));

              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StateTrackingManager.prototype), "construct", this)).call.apply(_get2, [this].concat(args));
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(StateTrackingManager.prototype), "doDestroy", this).call(this);

              this.destroyProperties(_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]);
            }
            /**
             * Gets current state of the manager
             *
             * @return {Common.data.stm.state.StateBase}
             */

          }, {
            key: "hasStore",

            /**
             * Checks if a store has been added to the manager
             *
             * @param  {Common.data.Store} store
             * @return {Boolean}
             */
            value: function hasStore(store) {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"]].includes(store);
            }
            /**
             * Adds a store to the manager
             *
             * @param {Common.data.Store} store
             */

          }, {
            key: "addStore",
            value: function addStore(store) {
              if (!this.hasStore(store)) {
                this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"]].push(store);

                store.stm = this;
              }
            }
            /**
             * Removes a store from the manager
             *
             * @param {Common.data.Store} store
             */

          }, {
            key: "removeStore",
            value: function removeStore(store) {
              if (this.hasStore(store)) {
                this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"]] = this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"]].filter(function (s) {
                  return s !== store;
                });
                store.stm = null;
              }
            }
            /**
             * Returns previously added store by it's id or undefined if store with the given id isn't added.
             *
             * @param  {String|Number} id
             * @return {Common.data.Store}
             * @deprecated 2.1
             */

          }, {
            key: "getStoreById",
            value: function getStoreById(id) {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"]].find(function (s) {
                return s.id === id;
              });
            }
            /**
             * Calls `fn` for each store registered in STM.
             *
             * @param {Function} fn (store, id) => ...
             */

          }, {
            key: "forEachStore",
            value: function forEachStore(fn) {
              this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"]].forEach(function (s) {
                return fn(s, s.id);
              });
            }
            /**
             * Get/set manager disabled state
             *
             * @property {Boolean}
             */

          }, {
            key: "enable",

            /**
             * Enables manager
             */
            value: function enable() {
              this.disabled = false;
            }
            /**
             * Disables manager
             */

          }, {
            key: "disable",
            value: function disable() {
              this.disabled = true;
            }
            /**
             * Checks manager ready state
             *
             * @return {Boolean}
             */

          }, {
            key: "startTransaction",

            /**
             * Starts undo/redo recording transaction.
             *
             * @param {String} [title=nul]
             */
            value: function startTransaction() {
              var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              stateTransition(this, this.state.onStartTransaction, title);
            }
            /**
             * Stops undo/redo recording transaction
             *
             * @param {String} [title=null]
             */

          }, {
            key: "stopTransaction",
            value: function stopTransaction() {
              var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              stateTransition(this, this.state.onStopTransaction, title);
            }
            /**
             * Stops undo/redo recording transaction after {@link #config-autoRecordTransactionStopTimeout} delay.
             *
             * @private
             */

          }, {
            key: "stopTransactionDelayed",
            value: function stopTransactionDelayed() {
              stateTransition(this, this.state.onStopTransactionDelayed);
            }
            /**
             * Rejects currently recorded transaction.
             */

          }, {
            key: "rejectTransaction",
            value: function rejectTransaction() {
              stateTransition(this, this.state.onRejectTransaction);
            }
            /**
             * Gets currently recording STM transaction.
             *
             * @return {Common.data.stm.Transaction}
             */

          }, {
            key: "undo",

            /**
             * Undoes current undo/redo transaction.
             *
             * @param {Number} [steps=1]
             */
            value: function undo() {
              var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              stateTransition(this, this.state.onUndo, steps);
            }
            /**
             * Undoes all transactions.
             */

          }, {
            key: "undoAll",
            value: function undoAll() {
              this.undo(this.length);
            }
            /**
             * Redoes current undo/redo transaction.
             *
             * @param {Number} [steps=1]
             */

          }, {
            key: "redo",
            value: function redo() {
              var steps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
              stateTransition(this, this.state.onRedo, steps);
            }
            /**
             * Redoes all transactions.
             */

          }, {
            key: "redoAll",
            value: function redoAll() {
              this.redo(this.length);
            }
            /**
             * Resets undo/redo queue.
             */

          }, {
            key: "resetQueue",
            value: function resetQueue() {
              var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                undo: true,
                redo: true
              };
              stateTransition(this, this.state.onResetQueue, options);
            }
            /**
             * Resets undo queue.
             */

          }, {
            key: "resetUndoQueue",
            value: function resetUndoQueue() {
              this.resetQueue({
                undo: true
              });
            }
            /**
             * Resets redo queue.
             */

          }, {
            key: "resetRedoQueue",
            value: function resetRedoQueue() {
              this.resetQueue({
                redo: true
              });
            }
          }, {
            key: "notifyStoresAboutStateRecordingStart",
            value: function notifyStoresAboutStateRecordingStart(transaction) {
              var _this = this;

              this.forEachStore(function (store) {
                store.onStmRecordingStart && store.onStmRecordingStart(_this, transaction);
              });
              /**
               * Fired upon state recording operation starts.
               *
               * @event recordingStart
               * @param {Common.data.stm.StateTrackingManager} stm
               * @param {Common.data.stm.Transaction} transaction
               */

              this.trigger('recordingStart', {
                stm: this,
                transaction: transaction
              });
            }
          }, {
            key: "notifyStoresAboutStateRecordingStop",
            value: function notifyStoresAboutStateRecordingStop(transaction, reason) {
              var _this2 = this;

              this.forEachStore(function (store) {
                store.onStmRecordingStop && store.onStmRecordingStop(_this2, transaction, reason);
              });
              /**
               * Fired upon state recording operation stops.
               *
               * @event recordingStop
               * @param {Common.data.stm.StateTrackingManager} stm
               * @param {Common.data.stm.Transaction} transaction
               * @param {Object} reason Transaction stop reason
               * @param {Boolean} reason.stop Transaction recording has been stopped in a normal way.
               * @param {Boolean} reason.disabled Transaction recording has been stopped due to STM has been disabled.
               * @param {Boolean} reason.rejected Transaction recording has been stopped due to transaction has been rejected.
               */

              this.trigger('recordingStop', {
                stm: this,
                transaction: transaction,
                reason: reason
              });
            }
          }, {
            key: "notifyStoresAboutStateRestoringStart",
            value: function notifyStoresAboutStateRestoringStart() {
              var _this3 = this;

              this.forEachStore(function (store) {
                store.onStmRestoringStart && store.onStmRestoringStart(_this3);
              });
              /**
               * Fired upon state restoration operation starts.
               *
               * @event restoringStart
               * @param {Common.data.stm.StateTrackingManager} stm
               */

              this.trigger('restoringStart', {
                stm: this
              });
            }
          }, {
            key: "notifyStoresAboutStateRestoringStop",
            value: function notifyStoresAboutStateRestoringStop() {
              var _this4 = this;

              this.forEachStore(function (store) {
                store.onStmRestoringStop && store.onStmRestoringStop(_this4);
              });
              /**
               * Fired upon state restoration operation stops.
               *
               * @event restoringStop
               * @param {Common.data.stm.StateTrackingManager} stm
               */

              this.trigger('restoringStop', {
                stm: this
              });
            }
          }, {
            key: "notifyStoresAboutQueueReset",
            value: function notifyStoresAboutQueueReset(options) {
              var _this5 = this;

              this.forEachStore(function (store) {
                store.onStmQueueReset && store.onStmQueueReset(_this5, options);
              });
              /**
               * Fired upon state undo/redo queue reset.
               *
               * @event queueReset
               * @param {Common.data.stm.StateTrackingManager} stm
               */

              this.trigger('queueReset', {
                stm: this,
                options: options
              });
            }
            /**
             * Method to call from model STM mixin upon model update
             *
             * @param {Common.data.Model} model
             * @param {Object} newData
             * @param {Object} oldData
             *
             * @private
             */

          }, {
            key: "onModelUpdate",
            value: function onModelUpdate(model, newData, oldData) {
              stateTransition(this, this.state.onModelUpdate, model, newData, oldData);
            }
            /**
             * Method to call from model STM mixin upon tree model child insertion
             *
             * @param {Common.data.Model} parentModel Parent model
             * @param {Number} index Insertion index
             * @param {Common.data.Model[]} childModels Array of models inserted
             * @param {Map} context Map with inserted models as keys and objects with previous parent,
             *                      and index at previous parent.
             *
             * @private
             */

          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild(parentModel, index, childModels, context) {
              stateTransition(this, this.state.onModelInsertChild, parentModel, index, childModels, context);
            }
            /**
             * Method to call from model STM mixin upon tree model child removal
             *
             * @param {Common.data.Model} parentModel
             * @param {Common.data.Model[]} childModels
             * @param {Map} context
             *
             * @private
             */

          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild(parentModel, childModels, context) {
              stateTransition(this, this.state.onModelRemoveChild, parentModel, childModels, context);
            }
            /**
             * Method to call from store STM mixin upon store models adding
             *
             * @param {Common.data.Store} store
             * @param {Common.data.Model[]} models
             * @param {Boolean} silent
             *
             * @private
             */

          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd(store, models, silent) {
              stateTransition(this, this.state.onStoreModelAdd, store, models, silent);
            }
            /**
             * Method to call from store STM mixin upon store models insertion
             *
             * @param {Common.data.Store} store
             * @param {Number} index
             * @param {Common.data.Model[]} models
             * @param {Map} context
             * @param {Boolean} silent
             *
             * @private
             */

          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert(store, index, models, context, silent) {
              stateTransition(this, this.state.onStoreModelInsert, store, index, models, context, silent);
            }
            /**
             * Method to call from store STM mixin upon store models removal
             *
             * @param {Common.data.Store} store
             * @param {Common.data.Model[]} models
             * @param {Object} context
             * @param {Boolean} silent
             *
             * @private
             */

          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove(store, models, context, silent) {
              stateTransition(this, this.state.onStoreModelRemove, store, models, context, silent);
            }
            /**
             * Method to call from store STM mixin upon store clear
             *
             * @param {Common.data.Store} store
             * @param {Common.data.Model[]} allRecords
             * @param {Boolean} silent
             *
             * @private
             */

          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll(store, allRecords, silent) {
              stateTransition(this, this.state.onStoreRemoveAll, store, allRecords, silent);
            }
          }, {
            key: "state",
            get: function get() {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STATE_PROP"]];
            }
            /**
             * Gets current undo/redo queue position
             *
             * @return {Number}
             */

          }, {
            key: "position",
            get: function get() {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["POS_PROP"]];
            }
            /**
             * Gets current undo/redo queue length
             *
             * @return {Number}
             */

          }, {
            key: "length",
            get: function get() {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["QUEUE_PROP"]].length;
            }
            /**
             * Gets all the stores registered in STM
             *
             * @return {Common.data.Store[]}
             */

          }, {
            key: "stores",
            get: function get() {
              return Array.from(this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["STORES_PROP"]]);
            }
          }, {
            key: "disabled",
            get: function get() {
              return this.state === _state_DisabledState_js__WEBPACK_IMPORTED_MODULE_19__["default"];
            },
            set: function set(val) {
              var me = this;

              if (me.disabled != val) {
                if (val) {
                  stateTransition(me, me.state.onDisable, me);
                } else {
                  stateTransition(me, me.state.onEnable, me);
                }
              }
            }
          }, {
            key: "isReady",
            get: function get() {
              return this.state === _state_ReadyState_js__WEBPACK_IMPORTED_MODULE_20__["default"] || this.state === _state_AutoReadyState_js__WEBPACK_IMPORTED_MODULE_23__["default"];
            }
            /**
             * Checks manager recording state
             *
             * @return {Boolean}
             */

          }, {
            key: "isRecording",
            get: function get() {
              return this.state === _state_RecordingState_js__WEBPACK_IMPORTED_MODULE_21__["default"] || this.state === _state_AutoRecordingState_js__WEBPACK_IMPORTED_MODULE_24__["default"];
            }
            /**
             * Gets/sets manager auto record option
             *
             * @property {Boolean}
             */

          }, {
            key: "autoRecord",
            get: function get() {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["AUTO_RECORD_PROP"]];
            },
            set: function set(value) {
              var me = this;

              if (me.autoRecord != value) {
                if (value) {
                  stateTransition(me, me.state.onAutoRecordOn, me);
                } else {
                  stateTransition(me, me.state.onAutoRecordOff, me);
                }
              }
            }
          }, {
            key: "transaction",
            get: function get() {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["TRANSACTION_PROP"]];
            }
            /**
             * Gets titles of all recorded undo/redo transactions
             *
             * @return {String[]}
             */

          }, {
            key: "queue",
            get: function get() {
              return this[_Props_js__WEBPACK_IMPORTED_MODULE_33__["QUEUE_PROP"]].map(function (t) {
                return t.title;
              });
            }
            /**
             * Gets manager restoring state.
             *
             * @return {Boolean}
             */

          }, {
            key: "isRestoring",
            get: function get() {
              return this.state === _state_RestoringState_js__WEBPACK_IMPORTED_MODULE_22__["default"];
            }
            /**
             * Checks if the manager can undo.
             *
             * @return {Boolean}
             */

          }, {
            key: "canUndo",
            get: function get() {
              return this.state.canUndo(this);
            }
            /**
             * Checks if the manager can redo.
             *
             * @return {Boolean}
             */

          }, {
            key: "canRedo",
            get: function get() {
              return this.state.canRedo(this);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Default manager disabled state
                 *
                 * @config {Boolean}
                 * @default
                 */
                disabled: true,

                /**
                 * Whether to start transaction recording automatically in case the Manager is enabled.
                 *
                 * In the auto recording mode, the manager waits for the first change in any store being managed and starts a transaction, i.e.
                 * records any changes in its monitored stores. The transaction lasts for {@link #config-autoRecordTransactionStopTimeout} and
                 * afterwards creates one undo/redo step, including all changes in the stores during that period of time.
                 *
                 * In non auto recording mode you have to call {@link #function-startTransaction} / {@link #function-stopTransaction} to start and end
                 * a transaction.
                 *
                 * @config {Boolean}
                 * @default
                 */
                autoRecord: false,

                /**
                 * The transaction duration (in ms) for the auto recording mode {@link #config-autoRecord}
                 *
                 * @config {Number}
                 * @default
                 */
                autoRecordTransactionStopTimeout: 100,

                /**
                 * Store model update action factory
                 *
                 * @config {Function}
                 * @default
                 * @private
                 */
                makeModelUpdateAction: makeModelUpdateAction,

                /**
                 * Store insert child model action factory.
                 *
                 * @config {Function}
                 * @default
                 * @private
                 */
                makeModelInsertChildAction: makeModelInsertChildAction,

                /**
                 * Store remove child model action factory.
                 *
                 * @config {Function}
                 * @default
                 * @private
                 */
                makeModelRemoveChildAction: makeModelRemoveChildAction,

                /**
                 * Store add model action factory.
                 *
                 * @config {Function}
                 * @default
                 * @private
                 */
                makeStoreModelAddAction: makeStoreModelAddAction,

                /**
                 * Store insert model action factory.
                 *
                 * @config {Function}
                 * @default
                 * @private
                 */
                makeStoreModelInsertAction: makeStoreModelInsertAction,

                /**
                 * Store remove model action factory.
                 *
                 * @config {Function}
                 * @default
                 * @private
                 */
                makeStoreModelRemoveAction: makeStoreModelRemoveAction,

                /**
                 * Store remove all models action factory.
                 *
                 * @config {Function}
                 * @default
                 * @private
                 */
                makeStoreRemoveAllAction: makeStoreRemoveAllAction,

                /**
                 * Function to create a transaction title if none is provided.
                 *
                 * The function receives a transaction and should return a title.
                 *
                 * @config {Function}
                 * @default
                 */
                getTransactionTitle: null
              };
            }
          }]);

          return StateTrackingManager;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_16__["default"]));

        StateTrackingManager._$name = 'StateTrackingManager';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/Transaction.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/data/stm/Transaction.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmTransactionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Transaction;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/Transaction
        */

        var ACTION_QUEUE_PROP = Symbol('ACTION_QUEUE_PROP');
        /**
         * STM transaction class, holds list of actions constituting a transaction.
         *
         * A transaction can be undone and redone. Upon undo all the actions being held
         * are undone in reverse order. Upon redo all the actions being held are redone
         * in forward order.
         */

        var Transaction =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Transaction, _Base);

          function Transaction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Transaction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Transaction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Transaction, [{
            key: "construct",
            value: function construct() {
              var _get2;

              this[ACTION_QUEUE_PROP] = [];

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Transaction.prototype), "construct", this)).call.apply(_get2, [this].concat(args));
            }
            /**
             * Gets transaction's actions queue
             *
             * @property {Common.data.stm.action.ActionBase[]}
             */

          }, {
            key: "addAction",

            /**
             * Adds an action to the transaction.
             *
             * @param {Common.data.stm.action.ActionBase|Object} action
             */
            value: function addAction(action) {
              this[ACTION_QUEUE_PROP].push(action);
            }
            /**
             * Undoes actions held
             */

          }, {
            key: "undo",
            value: function undo() {
              var queue = this[ACTION_QUEUE_PROP];

              for (var i = queue.length - 1; i >= 0; --i) {
                queue[i].undo();
              }
            }
            /**
             * Redoes actions held
             */

          }, {
            key: "redo",
            value: function redo() {
              var queue = this[ACTION_QUEUE_PROP];

              for (var i = 0, len = queue.length; i < len; ++i) {
                queue[i].redo();
              }
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Transaction title
                 *
                 * @config {String}
                 * @default
                 */
                title: null
              };
            }
          }, {
            key: "queue",
            get: function get() {
              return this[ACTION_QUEUE_PROP].slice(0);
            }
            /**
             * Gets transaction's actions queue length
             *
             * @property {Number}
             */

          }, {
            key: "length",
            get: function get() {
              return this[ACTION_QUEUE_PROP].length;
            }
          }]);

          return Transaction;
        }(_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        Transaction._$name = 'Transaction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/ActionBase.js":
      /*!********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/ActionBase.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionActionBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ActionBase;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/action/ActionBase
        */

        var throwAbstractMethodCall = function throwAbstractMethodCall() {
          throw new Error('Abstract method call!');
        };
        /**
         * Base class for STM actions.
         *
         * @abstract
         */


        var ActionBase =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ActionBase, _Base);

          function ActionBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ActionBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ActionBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ActionBase, [{
            key: "undo",

            /**
             * Undoes an action
             */
            value: function undo() {
              throwAbstractMethodCall();
            }
            /**
             * Redoes an action
             */

          }, {
            key: "redo",
            value: function redo() {
              throwAbstractMethodCall();
            }
          }, {
            key: "type",

            /**
             * Gets the type of the action (stringified class name).
             *
             * @return {String}
             */
            get: function get() {
              return this.constructor.name;
            }
          }]);

          return ActionBase;
        }(_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        ActionBase._$name = 'ActionBase';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/AddAction.js":
      /*!*******************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/AddAction.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionAddActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return AddAction;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _ActionBase_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./ActionBase.js */
        "../Grid/lib/Common/data/stm/action/ActionBase.js");
        /* harmony import */


        var _Store_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/stm/action/AddAction
         */

        var STORE_PROP = Symbol('STORE_PROP');
        var MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
        /**
         * Action to record the fact of models adding to a store.
         */

        var AddAction =
        /*#__PURE__*/
        function (_ActionBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(AddAction, _ActionBase);

          function AddAction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, AddAction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(AddAction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(AddAction, [{
            key: "undo",
            value: function undo() {
              var me = this;
              me.store.remove(me.modelList, me.silent);
            }
          }, {
            key: "redo",
            value: function redo() {
              var me = this;
              me.store.add(me.modelList, me.silent);
            }
          }, {
            key: "type",
            get: function get() {
              return 'AddAction';
            }
          }, {
            key: "store",
            get: function get() {
              return this[STORE_PROP];
            },
            set: function set(store) {
              this[STORE_PROP] = store;
            }
          }, {
            key: "modelList",
            get: function get() {
              return this[MODEL_LIST_PROP];
            },
            set: function set(list) {
              this[MODEL_LIST_PROP] = list.slice(0);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Reference to a store models have been added into.
                 *
                 * @config {Common.data.Store}
                 * @default
                 */
                store: undefined,

                /**
                 * List of models added into the store.
                 *
                 * @config {Common.data.Model[]}
                 * @default
                 */
                modelList: undefined,

                /**
                 * Flag showing if undo/redo should be done silently i.e. with events suppressed
                 *
                 * @config {Boolean}
                 * @default
                 */
                silent: false
              };
            }
          }]);

          return AddAction;
        }(_ActionBase_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        AddAction._$name = 'AddAction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/InsertAction.js":
      /*!**********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/InsertAction.js ***!
        \**********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionInsertActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return InsertAction;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _ActionBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./ActionBase.js */
        "../Grid/lib/Common/data/stm/action/ActionBase.js");
        /* harmony import */


        var _Store_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/stm/action/InsertAction
         */

        var STORE_PROP = Symbol('STORE_PROP');
        var MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
        var INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
        var CONTEXT_PROP = Symbol('CONTEXT_PROP');
        /**
         * Action to record the fact of models inserting into a store.
         */

        var InsertAction =
        /*#__PURE__*/
        function (_ActionBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(InsertAction, _ActionBase);

          function InsertAction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, InsertAction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(InsertAction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(InsertAction, [{
            key: "undo",
            value: function undo() {
              var store = this.store,
                  modelList = this.modelList,
                  context = this.context,
                  silent = this.silent; // Let's sort models by index such that models with lesser index
              // were inserted back first, thus making valid index of models following.

              modelList.sort(function (lhs, rhs) {
                var lhsIndex = context.get(lhs),
                    rhsIndex = context.get(rhs);
                return lhsIndex !== undefined && rhsIndex !== undefined ? lhsIndex - rhsIndex : 0;
              });
              modelList.forEach(function (m) {
                var index = context.get(m);

                if (index !== undefined) {
                  // Insert at previous index
                  store.insert(index, m, silent);
                } else {
                  // Just remove
                  store.remove(m, silent);
                }
              });
            }
          }, {
            key: "redo",
            value: function redo() {
              var me = this;
              me.store.insert(me.insertIndex, me.modelList, me.silent);
            }
          }, {
            key: "type",
            get: function get() {
              return 'InsertAction';
            }
          }, {
            key: "store",
            get: function get() {
              return this[STORE_PROP];
            },
            set: function set(store) {
              this[STORE_PROP] = store;
            }
          }, {
            key: "modelList",
            get: function get() {
              return this[MODEL_LIST_PROP];
            },
            set: function set(list) {
              this[MODEL_LIST_PROP] = list.slice(0);
            }
          }, {
            key: "insertIndex",
            get: function get() {
              return this[INSERT_INDEX_PROP];
            },
            set: function set(index) {
              this[INSERT_INDEX_PROP] = index;
            }
          }, {
            key: "context",
            get: function get() {
              return this[CONTEXT_PROP];
            },
            set: function set(context) {
              this[CONTEXT_PROP] = context;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Reference to a store models have been inserted into.
                 *
                 * @config {Common.data.Store}
                 * @default
                 */
                store: undefined,

                /**
                 * List of models inserted into the store.
                 *
                 * @config {Common.data.Model[]}
                 * @default
                 */
                modelList: undefined,

                /**
                 * Index the models have been inserted at.
                 *
                 * @config {Number}
                 * @default
                 */
                insertIndex: undefined,

                /**
                 * Models move context (if models has been moved), if any.
                 * Map this {@link Common/data/Model} instances as keys and their
                 * previous index as values
                 *
                 * @config {Map}
                 * @default
                 */
                context: undefined,

                /**
                 * Flag showing if undo/redo should be done silently i.e. with events suppressed
                 *
                 * @config {Boolean}
                 * @default
                 */
                silent: false
              };
            }
          }]);

          return InsertAction;
        }(_ActionBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        InsertAction._$name = 'InsertAction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/InsertChildAction.js":
      /*!***************************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/InsertChildAction.js ***!
        \***************************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionInsertChildActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return InsertChildAction;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _ActionBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./ActionBase.js */
        "../Grid/lib/Common/data/stm/action/ActionBase.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/action/InsertChildAction
        */

        var PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
        var CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
        var INSERT_INDEX_PROP = Symbol('INSERT_INDEX_PROP');
        var CONTEXT_PROP = Symbol('CONTEXT_PROP');
        /**
         * Action to record the fact of adding a children models into a parent model.
         */

        var InsertChildAction =
        /*#__PURE__*/
        function (_ActionBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(InsertChildAction, _ActionBase);

          function InsertChildAction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, InsertChildAction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(InsertChildAction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(InsertChildAction, [{
            key: "undo",
            value: function undo() {
              var parentModel = this.parentModel,
                  context = this.context,
                  childModels = this.childModels; // Let's sort models by parent index such that models with lesser index
              // were inserted back first, thus making valid parent index of models following.

              childModels.sort(function (lhs, rhs) {
                var _ref = context.get(lhs) || {},
                    lhsParent = _ref.lhsParent,
                    lhsIndex = _ref.lhsIndex,
                    _ref2 = context.get(rhs) || {},
                    rhsParent = _ref2.rhsParent,
                    rhsIndex = _ref2.rhsIndex;

                return lhsParent && lhsParent === rhsParent ? lhsIndex - rhsIndex : 0;
              }); // Now let's re-insert records back to where they were or remove them
              // if they weren't anywhere

              childModels.forEach(function (m) {
                var _ref3 = context.get(m) || {},
                    parent = _ref3.parent,
                    index = _ref3.index;

                if (parent) {
                  // If we move within same parent then index must be adjusted
                  if (parent === parentModel) {
                    parent.insertChild(m, parent.children[index + 1]);
                  } else {
                    // Insert at previous index
                    parent.insertChild(m, parent.children[index]);
                  }
                } else {
                  // Just remove
                  parentModel.removeChild(m);
                }
              });
            }
          }, {
            key: "redo",
            value: function redo() {
              var me = this;
              me.parentModel.insertChild(me.insertIndex, me.childModels);
            }
          }, {
            key: "type",
            get: function get() {
              return 'InsertChildAction';
            }
          }, {
            key: "parentModel",
            get: function get() {
              return this[PARENT_MODEL_PROP];
            },
            set: function set(model) {
              this[PARENT_MODEL_PROP] = model;
            }
          }, {
            key: "childModels",
            get: function get() {
              return this[CHILD_MODELS_PROP];
            },
            set: function set(models) {
              this[CHILD_MODELS_PROP] = models.slice(0);
            }
          }, {
            key: "insertIndex",
            get: function get() {
              return this[INSERT_INDEX_PROP];
            },
            set: function set(index) {
              this[INSERT_INDEX_PROP] = index;
            }
          }, {
            key: "context",
            get: function get() {
              return this[CONTEXT_PROP];
            },
            set: function set(ctx) {
              this[CONTEXT_PROP] = ctx;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Reference to a parent model a child model has been added to.
                 *
                 * @config {Common.data.Model}
                 * @default
                 */
                parentModel: undefined,

                /**
                 * Children models inserted.
                 *
                 * @config {Common.data.Model[]}
                 * @default
                 */
                childModels: undefined,

                /**
                 * Index a children models are inserted at
                 *
                 * @config {Number}
                 * @default
                 */
                insertIndex: undefined,

                /**
                 * Map having children models as keys and values containing previous parent
                 * of each model and index at the previous parent.
                 *
                 * @config {Object}
                 * @default
                 */
                context: undefined
              };
            }
          }]);

          return InsertChildAction;
        }(_ActionBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        InsertChildAction._$name = 'InsertChildAction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/RemoveAction.js":
      /*!**********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/RemoveAction.js ***!
        \**********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionRemoveActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RemoveAction;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _ActionBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./ActionBase.js */
        "../Grid/lib/Common/data/stm/action/ActionBase.js");
        /* harmony import */


        var _Store_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/action/RemoveAction
        */

        var STORE_PROP = Symbol('STORE_PROP');
        var MODEL_LIST_PROP = Symbol('MODEL_LIST_PROP');
        var CONTEXT_PROP = Symbol('CONTEXT_PROP');
        /**
         * Action to record the fact of models removed from a store.
         */

        var RemoveAction =
        /*#__PURE__*/
        function (_ActionBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RemoveAction, _ActionBase);

          function RemoveAction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, RemoveAction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(RemoveAction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(RemoveAction, [{
            key: "undo",
            value: function undo() {
              var store = this.store,
                  context = this.context,
                  modelList = this.modelList,
                  silent = this.silent; // Let's sort models by index such that models with lesser index
              // were inserted back first, thus making valid index of models following.

              modelList.sort(function (lhs, rhs) {
                var lhsIndex = context.get(lhs),
                    rhsIndex = context.get(rhs); // Here, in contrast to InsertAction, index is always present

                return lhsIndex - rhsIndex;
              });
              modelList.forEach(function (m) {
                var index = context.get(m); // Insert at previous index

                store.insert(index, m, silent);
              });
            }
          }, {
            key: "redo",
            value: function redo() {
              var me = this;
              me.store.remove(me.modelList, me.silent);
            }
          }, {
            key: "type",
            get: function get() {
              return 'RemoveAction';
            }
          }, {
            key: "store",
            get: function get() {
              return this[STORE_PROP];
            },
            set: function set(store) {
              this[STORE_PROP] = store;
            }
          }, {
            key: "modelList",
            get: function get() {
              return this[MODEL_LIST_PROP];
            },
            set: function set(list) {
              this[MODEL_LIST_PROP] = list.slice(0);
            }
          }, {
            key: "context",
            get: function get() {
              return this[CONTEXT_PROP];
            },
            set: function set(context) {
              this[CONTEXT_PROP] = context;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Reference to a store models have been removed from.
                 *
                 * @config {Common.data.Store}
                 * @default
                 */
                store: undefined,

                /**
                 * List of models removed from the store.
                 *
                 * @config {Common.data.Model[]}
                 * @default
                 */
                modelList: undefined,

                /**
                 * Models removing context.
                 *
                 * @config {Object}
                 * @default
                 */
                context: undefined,

                /**
                 * Flag showing if undo/redo should be done silently i.e. with events suppressed
                 *
                 * @config {Boolean}
                 * @default
                 */
                silent: false
              };
            }
          }]);

          return RemoveAction;
        }(_ActionBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        RemoveAction._$name = 'RemoveAction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/RemoveAllAction.js":
      /*!*************************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/RemoveAllAction.js ***!
        \*************************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionRemoveAllActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RemoveAllAction;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _ActionBase_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./ActionBase.js */
        "../Grid/lib/Common/data/stm/action/ActionBase.js");
        /* harmony import */


        var _Store_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/action/RemoveAllAction
        */

        var STORE_PROP = Symbol('STORE_PROP');
        var ALL_RECORDS_PROP = Symbol('ALL_RECORDS_PROP');
        /**
         * Action to record store remove all operation.
         */

        var RemoveAllAction =
        /*#__PURE__*/
        function (_ActionBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(RemoveAllAction, _ActionBase);

          function RemoveAllAction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RemoveAllAction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RemoveAllAction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(RemoveAllAction, [{
            key: "undo",
            value: function undo() {
              var store = this.store,
                  allRecords = this.allRecords,
                  silent = this.silent;
              store.add(allRecords, silent);
            }
          }, {
            key: "redo",
            value: function redo() {
              var me = this;
              me.store.removeAll(me.silent);
            }
          }, {
            key: "type",
            get: function get() {
              return 'RemoveAllAction';
            }
          }, {
            key: "store",
            get: function get() {
              return this[STORE_PROP];
            },
            set: function set(store) {
              this[STORE_PROP] = store;
            }
          }, {
            key: "allRecords",
            get: function get() {
              return this[ALL_RECORDS_PROP];
            },
            set: function set(records) {
              this[ALL_RECORDS_PROP] = records.slice(0);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Reference to a store cleared.
                 *
                 * @config {Common.data.Store}
                 * @default
                 */
                store: undefined,

                /**
                 * All store records removed
                 *
                 * @config {Common.data.Model[]}
                 * @default
                 */
                allRecords: undefined,

                /**
                 * Flag showing if undo/redo should be done silently i.e. with events suppressed
                 *
                 * @config {Boolean}
                 * @default
                 */
                silent: false
              };
            }
          }]);

          return RemoveAllAction;
        }(_ActionBase_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        RemoveAllAction._$name = 'RemoveAllAction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/RemoveChildAction.js":
      /*!***************************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/RemoveChildAction.js ***!
        \***************************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionRemoveChildActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RemoveChildAction;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _ActionBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./ActionBase.js */
        "../Grid/lib/Common/data/stm/action/ActionBase.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        var PARENT_MODEL_PROP = Symbol('PARENT_MODEL_PROP');
        var CHILD_MODELS_PROP = Symbol('CHILD_MODELS_PROP');
        var CONTEXT_PROP = Symbol('CONTEXT_PROP');

        var RemoveChildAction =
        /*#__PURE__*/
        function (_ActionBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RemoveChildAction, _ActionBase);

          function RemoveChildAction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, RemoveChildAction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(RemoveChildAction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(RemoveChildAction, [{
            key: "undo",
            value: function undo() {
              var parentModel = this.parentModel,
                  context = this.context,
                  childModels = this.childModels; // Let's sort models by parent index such that models with lesser index
              // were inserted back first, thus making valid parent index of models following.

              childModels.sort(function (lhs, rhs) {
                var lhsIndex = context.get(lhs),
                    rhsIndex = context.get(rhs);
                return lhsIndex - rhsIndex;
              }); // Now let's re-insert records back to where they were

              childModels.forEach(function (m) {
                parentModel.insertChild(context.get(m), m);
              });
            }
          }, {
            key: "redo",
            value: function redo() {
              this.parentModel.removeChild(this.childModels);
            }
          }, {
            key: "type",
            get: function get() {
              return 'RemoveChildAction';
            }
          }, {
            key: "parentModel",
            get: function get() {
              return this[PARENT_MODEL_PROP];
            },
            set: function set(model) {
              this[PARENT_MODEL_PROP] = model;
            }
          }, {
            key: "childModels",
            get: function get() {
              return this[CHILD_MODELS_PROP];
            },
            set: function set(models) {
              this[CHILD_MODELS_PROP] = models.slice(0);
            }
          }, {
            key: "context",
            get: function get() {
              return this[CONTEXT_PROP];
            },
            set: function set(ctx) {
              this[CONTEXT_PROP] = ctx;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Reference to a parent model a child model has been removed to.
                 *
                 * @config {Common.data.Model}
                 * @default
                 */
                parentModel: undefined,

                /**
                 * Children models removed.
                 *
                 * @config {Common.data.Model[]}
                 * @default
                 */
                childModels: undefined,

                /**
                 * Map having children models as keys and values containing previous parent
                 * index at the parent.
                 *
                 * @config {Object}
                 * @default
                 */
                context: undefined
              };
            }
          }]);

          return RemoveChildAction;
        }(_ActionBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        RemoveChildAction._$name = 'RemoveChildAction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/action/UpdateAction.js":
      /*!**********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/action/UpdateAction.js ***!
        \**********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmActionUpdateActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return UpdateAction;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _ActionBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./ActionBase.js */
        "../Grid/lib/Common/data/stm/action/ActionBase.js");
        /* harmony import */


        var _Model_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/action/UpdateAction
        */

        var MODEL_PROP = Symbol('MODEL_PROP');
        var NEW_DATA_PROP = Symbol('NEW_DATA_PROP');
        var OLD_DATA_PROP = Symbol('OLD_DATA_PROP');
        /**
         * Action to record the fact that a model has been updated.
         */

        var UpdateAction =
        /*#__PURE__*/
        function (_ActionBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(UpdateAction, _ActionBase);

          function UpdateAction() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, UpdateAction);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(UpdateAction).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(UpdateAction, [{
            key: "undo",
            value: function undo() {
              this.model.set(this.oldData);
            }
          }, {
            key: "redo",
            value: function redo() {
              this.model.set(this.newData);
            }
          }, {
            key: "type",
            get: function get() {
              return 'UpdateAction';
            }
          }, {
            key: "model",
            get: function get() {
              return this[MODEL_PROP];
            },
            set: function set(value) {
              this[MODEL_PROP] = value;
            }
          }, {
            key: "newData",
            get: function get() {
              return this[NEW_DATA_PROP];
            },
            set: function set(value) {
              this[NEW_DATA_PROP] = Object.assign({}, value);
            }
          }, {
            key: "oldData",
            get: function get() {
              return this[OLD_DATA_PROP];
            },
            set: function set(value) {
              this[OLD_DATA_PROP] = Object.assign({}, value);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Reference to a model which has been updated.
                 *
                 * @config {Common.data.Model}
                 * @default
                 */
                model: undefined,

                /**
                 * Map of updated properties with new values.
                 *
                 * @config {Object}
                 * @default
                 */
                newData: undefined,

                /**
                 * Map of updated properties with old values.
                 *
                 * @config {Object}
                 * @default
                 */
                oldData: undefined
              };
            }
          }]);

          return UpdateAction;
        }(_ActionBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        UpdateAction._$name = 'UpdateAction';
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/mixin/ModelStm.js":
      /*!*****************************************************!*\
        !*** ../Grid/lib/Common/data/stm/mixin/ModelStm.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmMixinModelStmJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.map */
        "../Grid/node_modules/core-js/modules/es6.map.js");
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/mixin/ModelStm
        */

        var STM_PROP = Symbol('STM_PROP');
        /**
         * Mixin making a model compatible with {@link Common/data/stm/StateTrackingManager}
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(ModelStm, _ref);

              function ModelStm() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, ModelStm);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(ModelStm, [{
                key: "joinStore",
                value: function joinStore(store) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "joinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "joinStore", this).call(this, store);

                  if (!this.stm) {
                    this.stm = store.stm;
                  }
                }
              }, {
                key: "unJoinStore",
                value: function unJoinStore(store) {
                  if (this.stm === store.stm) {
                    this.stm = null;
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "unJoinStore", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "unJoinStore", this).call(this, store);
                }
              }, {
                key: "beforeSet",

                /**
                 * Overridden to collect initial data for the fields about to be changed.
                 * The method is called from within {@link Common/data/Model#function-set} method.
                 *
                 * @private
                 */
                value: function beforeSet(field, value, silent, fromRelationUpdate) {
                  var _this = this;

                  var preResult = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "beforeSet", this) ? _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "beforeSet", this).call(this, field, value, silent, fromRelationUpdate) : [];
                  var stm = this.stm;

                  if (stm && !stm.disabled) {
                    var newDataCandidate, oldDataCandidate;

                    if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default()(field) == 'object') {
                      var _Object$keys$reduce = Object.keys(field).reduce(function (data, fName) {
                        data[0][fName] = field[fName];
                        data[1][fName] = _this.get(fName);
                        return data;
                      }, [{}, {}]);

                      var _Object$keys$reduce2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(_Object$keys$reduce, 2);

                      newDataCandidate = _Object$keys$reduce2[0];
                      oldDataCandidate = _Object$keys$reduce2[1];
                    } else {
                      newDataCandidate = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, field, value);
                      oldDataCandidate = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, field, this.get(field));
                    }

                    preResult.push([newDataCandidate, oldDataCandidate]);
                  }

                  return preResult;
                }
                /**
                 * Overridden to store initial data of the changed fields and to notify STM
                 * manager about the change action if anything has been changed in result.
                 *
                 * The method is called from within {@link Common/data/Model#function-set} method.
                 *
                 * @private
                 */

              }, {
                key: "afterSet",
                value: function afterSet(field, value, silent, fromRelationUpdate, beforeResult, wasSet) {
                  var stm = this.stm;

                  if (stm && !stm.disabled) {
                    var preResult = beforeResult.pop();

                    if (wasSet) {
                      var _preResult = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(preResult, 2),
                          newDataCandidate = _preResult[0],
                          oldDataCandidate = _preResult[1];

                      var _Object$keys$reduce3 = Object.keys(wasSet).reduce(function (data, fName) {
                        data[0][fName] = newDataCandidate[fName];
                        data[1][fName] = oldDataCandidate[fName];
                        return data;
                      }, [{}, {}]),
                          _Object$keys$reduce4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(_Object$keys$reduce3, 2),
                          newData = _Object$keys$reduce4[0],
                          oldData = _Object$keys$reduce4[1];

                      stm.onModelUpdate(this, newData, oldData);
                    }
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "afterSet", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "afterSet", this).call(this, field, value, silent, fromRelationUpdate, beforeResult, wasSet);
                }
                /**
                 * Called from {@link Common/data/mixin/TreeNode#function-insertChild} to obtain inserted
                 * records initial parents and parent index, to be able to restore the state back upon undo.
                 *
                 * @param {Common.data.Model[]} childRecords
                 * @return {Array} Array of results from this call and any of super calls if any.
                 *               This result is consumed by {@link #function-afterInsertChild} which pops
                 *               from the result array to take only results of this method call and leave
                 *               results from super calls untouched.
                 *
                 * @private
                 */

              }, {
                key: "beforeInsertChild",
                value: function beforeInsertChild(childRecords) {
                  var _this2 = this;

                  var preResult = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "beforeInsertChild", this) ? _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "beforeInsertChild", this).call(this, childRecords) : [];
                  var stm = this.stm;

                  if (stm && !stm.disabled) {
                    preResult.push(childRecords.reduce(function (result, childRecord) {
                      // We are interested only in records from the same root node.
                      // Removing (which is done before insertion) of the records
                      // from another root (and store) should
                      // be handled by that store STM instance.
                      if (childRecord.root === _this2.root) {
                        result.set(childRecord, {
                          parent: childRecord.parent,
                          index: childRecord.parent ? childRecord.parentIndex : undefined
                        });
                      }

                      return result;
                    }, new Map()));
                  }

                  return preResult;
                }
                /**
                 * Called from {@link Common/data/mixin/TreeNode#function-insertChild} to notify {@link Common/data/stm/StateTrackingManager}
                 * about children insertion. Provides it with all necessary context information collected
                 * in {@link #function-beforeInsertChild} required to undo/redo the action.
                 *
                 * @private
                 */

              }, {
                key: "afterInsertChild",
                value: function afterInsertChild(index, childRecords, beforeResult, inserted) {
                  var stm = this.stm;

                  if (stm && !stm.disabled) {
                    var context = beforeResult.pop();

                    if (inserted) {
                      stm.onModelInsertChild(this, index, inserted, context);
                    }
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "afterInsertChild", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "afterInsertChild", this).call(this, index, childRecords, beforeResult, inserted);
                }
                /**
                 * Called from {@link Common/data/mixin/TreeNode#function-removeChild} to obtain removed
                 * records initial parent index, to be able to restore the state back upon undo.
                 *
                 * @param {Common.data.Model[]} childRecords
                 * @param {Boolean} isMove
                 * @return {Array} Array of results from this call and any of super calls if any.
                 *               This result is consumed by {@link #function-afterRemoveChild} which pops
                 *               from the result array to take only results of this method call and leave
                 *               results from super calls untouched.
                 *
                 * @private
                 */

              }, {
                key: "beforeRemoveChild",
                value: function beforeRemoveChild(childRecords, isMove) {
                  var preResult = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "beforeRemoveChild", this) ? _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "beforeRemoveChild", this).call(this, childRecords, isMove) : [];
                  var stm = this.stm; // If it's move then InsertChildAction will handle this case

                  if (stm && !stm.disabled && !isMove) {
                    // Child records we receive are guaranteed to be direct children
                    // of this node, see Common/data/mixin/TreeNode#removeChild method
                    // Here we interested in the original index for each child removed,
                    // we collect it and store for future use in RemoveChildAction
                    preResult.push(childRecords.reduce(function (result, childRecord) {
                      result.set(childRecord, childRecord.parentIndex);
                      return result;
                    }, new Map()));
                  }

                  return preResult;
                }
                /**
                 * Called from {@link Common/data/mixin/TreeNode#function-removeChild} to notify {@link Common/data/stm/StateTrackingManager}
                 * about children removing. Provides it with all necessary context information collected
                 * in {@link #function-beforeRemoveChild} required to undo/redo the action.
                 *
                 * @private
                 */

              }, {
                key: "afterRemoveChild",
                value: function afterRemoveChild(childRecords, beforeResult, isMove) {
                  var stm = this.stm; // If it's move then InsertChildAction will handle this case

                  if (stm && !stm.disabled && !isMove) {
                    var context = beforeResult.pop();

                    if (childRecords && childRecords.length) {
                      stm.onModelRemoveChild(this, childRecords, context);
                    }
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "afterRemoveChild", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(ModelStm.prototype), "afterRemoveChild", this).call(this, childRecords, beforeResult, isMove);
                }
              }, {
                key: "stm",
                get: function get() {
                  return this[STM_PROP];
                },
                set: function set(stm) {
                  this[STM_PROP] = stm;
                }
              }], [{
                key: "defaultConfig",
                get: function get() {
                  return {
                    /**
                     * Reference to STM manager
                     * @config {Common.data.stm.StateTrackingManager}
                     * @default
                     * @category Misc
                     */
                    stm: null
                  };
                }
              }]);

              return ModelStm;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_16__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/mixin/StoreStm.js":
      /*!*****************************************************!*\
        !*** ../Grid/lib/Common/data/stm/mixin/StoreStm.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonDataStmMixinStoreStmJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.map */
        "../Grid/node_modules/core-js/modules/es6.map.js");
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _data_Model_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../data/Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/mixin/StoreStm
        */

        var STM_PROP = Symbol('STM_PROP');
        /**
         * Store mixin to make it compatible with {@link Common.data.stm.StateTrackingManager}.
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(StoreStm, _ref);

              function StoreStm() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, StoreStm);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(StoreStm, [{
                key: "add",

                /**
                 * Overridden to notify STM about flat add action
                 *
                 * @private
                 */
                value: function add(records) {
                  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var result;
                  var stm = this.stm; // Tree adding is routed via rootNode.appendChild() it has it's own
                  // STM override thus if the store is tree we ignore the action

                  if (!this.tree && stm && !stm.disabled) {
                    // Flat adding here only, the only data needed to undo/redo the action
                    // is the list of records added.
                    result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "add", this).call(this, records, silent); // If adding wasn't vetoed and something has been added then
                    // notifying the STM about the fact.

                    if (result && result.length) {
                      stm.onStoreModelAdd(this, result, silent);
                    }
                  } else {
                    result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "add", this).call(this, records, silent);
                  }

                  return result;
                }
                /**
                 * Overridden to notify STM about flat insert action
                 *
                 * @private
                 */

              }, {
                key: "insert",
                value: function insert(index, records) {
                  var _this = this;

                  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var result;
                  var stm = this.stm; // Tree inserting is routed via rootNode.insertChild() it has it's own
                  // STM override thus if the store is tree we ignore the action

                  if (!this.tree && stm && !stm.disabled) {
                    // Flat inserting here only, the only data needed to undo/redo the action is:
                    // - the list of record inserted
                    // - index they are inserted at
                    // - index they have been at if they are part of this store already and are moved
                    // Here we are getting indexes of records which are in this store already
                    // not all records might be from this store, some might be new or from another store
                    var context = (Array.isArray(records) ? records : [records]).reduce(function (context, r) {
                      var index = r instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_13__["default"] ? _this.indexOf(r) : undefined;

                      if (index !== undefined && index !== -1) {
                        context.set(r, index);
                      }

                      return context;
                    }, new Map()); // Result here is the array of Models inserted or undefined,
                    // and it might be different from `records` we received as argument.

                    result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "insert", this).call(this, index, records); // Here we check if anything has been actually inserted.
                    // The insertion action might be vetoed by event handler or something

                    if (result && result.length) {
                      // We can't rely on `index` we've got as argument since `result` might
                      // differ from records.
                      index = this.indexOf(result[0]); // Notifying STM manager about the insertion action providing all
                      // the required data to undo/redo.

                      stm.onStoreModelInsert(this, index, result, context, silent);
                    }
                  } else {
                    result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "insert", this).call(this, index, records, silent);
                  }

                  return result;
                }
                /**
                 * Overridden to notify STM about flat removing action
                 *
                 * @private
                 */

              }, {
                key: "remove",
                value: function remove(recordsOrIds) {
                  var _this2 = this;

                  var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var fromRemoveChild = arguments.length > 2 ? arguments[2] : undefined;
                  var result;
                  var stm = this.stm; // Tree removing is routed via rootNode.removeChild() it has it's own
                  // STM override thus if the store is tree we ignore the action

                  if (!this.tree && stm && !stm.disabled) {
                    // Flat removing here only, the only date needed to undo/redo the actions is:
                    // - the list of records removed
                    // - their original index to re-insert them back correctly
                    var recordsOrIdsNormalized = (Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds]).map(function (r) {
                      return _this2.getById(r);
                    }).filter(function (r) {
                      return !!r;
                    });
                    var context = recordsOrIdsNormalized.reduce(function (context, r) {
                      var index = _this2.indexOf(r);

                      if (index !== undefined && index != -1) {
                        context.set(r, index);
                      }

                      return context;
                    }, new Map()); // Calling original store method

                    result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "remove", this).call(this, recordsOrIds, silent, fromRemoveChild); // Here we check if anything has been actually removed.
                    // The removing action might be vetoed by event handler or something

                    if (result && result.length) {
                      stm.onStoreModelRemove(this, result, context, silent);
                    }
                  } else {
                    result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "remove", this).call(this, recordsOrIds, silent, fromRemoveChild);
                  }

                  return result;
                }
                /**
                 * Overridden to notify STM about flat clear action
                 *
                 * @private
                 */

              }, {
                key: "removeAll",
                value: function removeAll(silent) {
                  var stm = this.stm;

                  if (stm && !stm.disabled) {
                    // Here we are to detect if anything has been removed
                    // the only way is to check if store has anything before removing all
                    // and has nothing after.
                    var tree = this.tree,
                        rootNode = this.rootNode,
                        allRecords = this.allRecords,
                        wasNotEmpty = allRecords.length,
                        records = tree ? rootNode.children.slice() : allRecords.slice();

                    _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "removeAll", this).call(this, silent); // The trick here is to distinguish tree and flat case
                    // For the flat case it's simple we just store all records
                    // For the tree we are to store root node children only
                    // Upon restoring store.add() will do the right thing for the flat case and tree case regardless.


                    if (wasNotEmpty && this.count === 0) {
                      stm.onStoreRemoveAll(this, records, silent);
                    }
                  } else {
                    _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(StoreStm.prototype), "removeAll", this).call(this, silent);
                  }
                }
              }, {
                key: "stm",
                get: function get() {
                  return this[STM_PROP];
                },
                set: function set(stm) {
                  var me = this;

                  if (me.stm != stm) {
                    if (me.stm && me.stm.hasStore(me)) {
                      me.stm.removeStore(me);
                    }

                    me[STM_PROP] = stm;

                    if (me.stm && !me.stm.hasStore(me)) {
                      me.stm.addStore(me);
                    }
                  }
                }
              }], [{
                key: "defaultConfig",
                get: function get() {
                  return {
                    /**
                     * Reference to STM manager
                     *
                     * @config {Common.data.stm.StateTrackingManager}
                     * @default
                     */
                    stm: null
                  };
                }
              }]);

              return StoreStm;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_12__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/state/AutoReadyState.js":
      /*!***********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/AutoReadyState.js ***!
        \***********************************************************/

      /*! exports provided: AutoReadyStateClass, default */

      /***/
      function GridLibCommonDataStmStateAutoReadyStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "AutoReadyStateClass", function () {
          return AutoReadyStateClass;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _StateBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");
        /* harmony import */


        var _Transaction_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../Transaction.js */
        "../Grid/lib/Common/data/stm/Transaction.js");
        /* harmony import */


        var _ReadyState_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./ReadyState.js */
        "../Grid/lib/Common/data/stm/state/ReadyState.js");
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../Props.js */
        "../Grid/lib/Common/data/stm/Props.js");
        /* harmony import */


        var _Registry_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./Registry.js */
        "../Grid/lib/Common/data/stm/state/Registry.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/state/AutoReadyState
        */

        /**
         * STM transaction autostart ready state class.
         *
         * @internal
         */

        var AutoReadyStateClass =
        /*#__PURE__*/
        function (_ReadyStateClass) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(AutoReadyStateClass, _ReadyStateClass);

          function AutoReadyStateClass() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, AutoReadyStateClass);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoReadyStateClass).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(AutoReadyStateClass, [{
            key: "onAutoRecordOn",
            value: function onAutoRecordOn() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onAutoRecordOff",
            value: function onAutoRecordOff() {
              var _ref;

              return _ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_9__["STATE_PROP"], 'readystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_9__["AUTO_RECORD_PROP"], false), _ref;
            }
          }, {
            key: "onStartTransaction",
            value: function onStartTransaction(stm, title) {
              var _ref2;

              var transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                title: title
              });
              return [(_ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_9__["STATE_PROP"], 'autorecordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_9__["TRANSACTION_PROP"], transaction), _ref2), function () {
                stm.notifyStoresAboutStateRecordingStart(transaction);
                stm.stopTransactionDelayed();
              }];
            }
          }, {
            key: "onModelUpdate",
            value: function onModelUpdate(stm, model, newData, oldData) {
              stm.startTransaction();
              stm.onModelUpdate(model, newData, oldData);
            }
          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild(stm, parentModel, index, childModels, context) {
              stm.startTransaction();
              stm.onModelInsertChild(parentModel, index, childModels, context);
            }
          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild(stm, parentModel, childModels, context) {
              stm.startTransaction();
              stm.onModelRemoveChild(parentModel, childModels, context);
            }
          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd(stm, store, models, silent) {
              stm.startTransaction();
              stm.onStoreModelAdd(store, models, silent);
            }
          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert(stm, store, index, models, context, silent) {
              stm.startTransaction();
              stm.onStoreModelInsert(store, index, models, silent);
            }
          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove(stm, store, models, context, silent) {
              stm.startTransaction();
              stm.onStoreModelRemove(store, models, context, silent);
            }
          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll(stm, store, allRecords, silent) {
              stm.startTransaction();
              stm.onStoreRemoveAll(store, allRecords, silent);
            }
          }]);

          return AutoReadyStateClass;
        }(_ReadyState_js__WEBPACK_IMPORTED_MODULE_8__["ReadyStateClass"]);
        /**
         * STM transaction autostart ready state.
         *
         * @internal
         */


        var AutoReadyState = new AutoReadyStateClass();
        /* harmony default export */

        __webpack_exports__["default"] = AutoReadyState;

        _Registry_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerStmState('autoreadystate', AutoReadyState);
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/state/AutoRecordingState.js":
      /*!***************************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/AutoRecordingState.js ***!
        \***************************************************************/

      /*! exports provided: AutoRecordingStateClass, default */

      /***/
      function GridLibCommonDataStmStateAutoRecordingStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "AutoRecordingStateClass", function () {
          return AutoRecordingStateClass;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _StateBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");
        /* harmony import */


        var _RecordingState_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./RecordingState.js */
        "../Grid/lib/Common/data/stm/state/RecordingState.js");
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../Props.js */
        "../Grid/lib/Common/data/stm/Props.js");
        /* harmony import */


        var _Registry_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./Registry.js */
        "../Grid/lib/Common/data/stm/state/Registry.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/state/AutoRecordingState
        */

        /**
         * STM recording state class.
         *
         * @internal
         */

        var AutoRecordingStateClass =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(AutoRecordingStateClass, _Delayable);

          function AutoRecordingStateClass() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, AutoRecordingStateClass);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(AutoRecordingStateClass, [{
            key: "onDisable",
            value: function onDisable(stm) {
              var _ref;

              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
              var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"]];

              if (timer) {
                this.clearTimeout(timer);
              }

              stm.notifyStoresAboutStateRecordingStop(transaction, {
                disabled: true
              });
              return _ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'disabledstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"], null), _ref;
            }
          }, {
            key: "onAutoRecordOn",
            value: function onAutoRecordOn(stm) {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_8__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onAutoRecordOff",
            value: function onAutoRecordOff(stm) {
              var _ref2;

              var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"]];

              if (timer) {
                this.clearTimeout(timer);
              }

              return _ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'recordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_10__["AUTO_RECORD_PROP"], false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"], null), _ref2;
            }
          }, {
            key: "onStopTransaction",
            value: function onStopTransaction(stm, title) {
              var _ref3;

              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]];
              var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"]];
              var position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["POS_PROP"]];
              var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["QUEUE_PROP"]];

              if (timer) {
                this.clearTimeout(timer);
              }

              if (transaction.length) {
                if (!transaction.title && !title && stm.getTransactionTitle) {
                  transaction.title = stm.getTransactionTitle(transaction);
                } else if (title) {
                  transaction.title = title;
                }

                queue[position] = transaction;
                queue.length = ++position;
              }

              return [(_ref3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'autoreadystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_10__["POS_PROP"], position), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"], null), _ref3), function () {
                stm.notifyStoresAboutStateRecordingStop(transaction, {
                  stop: true
                });
              }];
            }
          }, {
            key: "onStopTransactionDelayed",
            value: function onStopTransactionDelayed(stm) {
              var _ref4;

              var timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"]];

              if (timer) {
                this.clearTimeout(timer);
              }

              timer = this.setTimeout(function () {
                stm.stopTransaction();
              }, stm.autoRecordTransactionStopTimeout);
              return _ref4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], AutoRecordingState), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"], timer), _ref4;
            }
          }, {
            key: "onRejectTransaction",
            value: function onRejectTransaction(stm) {
              var _ref5;

              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"]],
                  timer = stm[_Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"]];

              if (timer) {
                this.clearTimeout(timer);
              }

              return [(_ref5 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref5, _Props_js__WEBPACK_IMPORTED_MODULE_10__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref5, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_PROP"], null), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref5, _Props_js__WEBPACK_IMPORTED_MODULE_10__["TRANSACTION_TIMER_PROP"], null), _ref5), function () {
                if (transaction.length) {
                  transaction.undo();
                }

                return ['autoreadystate', function () {
                  stm.notifyStoresAboutStateRecordingStop(transaction, {
                    rejected: true
                  });
                }];
              }];
            }
          }, {
            key: "onModelUpdate",
            value: function onModelUpdate(stm) {
              var _get2;

              for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                rest[_key - 1] = arguments[_key];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass.prototype), "onModelUpdate", this)).call.apply(_get2, [this, stm].concat(rest));

              stm.stopTransactionDelayed();
            }
          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild(stm) {
              var _get3;

              for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                rest[_key2 - 1] = arguments[_key2];
              }

              (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass.prototype), "onModelInsertChild", this)).call.apply(_get3, [this, stm].concat(rest));

              stm.stopTransactionDelayed();
            }
          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild(stm) {
              var _get4;

              for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                rest[_key3 - 1] = arguments[_key3];
              }

              (_get4 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass.prototype), "onModelRemoveChild", this)).call.apply(_get4, [this, stm].concat(rest));

              stm.stopTransactionDelayed();
            }
          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd(stm) {
              var _get5;

              for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                rest[_key4 - 1] = arguments[_key4];
              }

              (_get5 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass.prototype), "onStoreModelAdd", this)).call.apply(_get5, [this, stm].concat(rest));

              stm.stopTransactionDelayed();
            }
          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert(stm) {
              var _get6;

              for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                rest[_key5 - 1] = arguments[_key5];
              }

              (_get6 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass.prototype), "onStoreModelInsert", this)).call.apply(_get6, [this, stm].concat(rest));

              stm.stopTransactionDelayed();
            }
          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove(stm) {
              var _get7;

              for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                rest[_key6 - 1] = arguments[_key6];
              }

              (_get7 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass.prototype), "onStoreModelRemove", this)).call.apply(_get7, [this, stm].concat(rest));

              stm.stopTransactionDelayed();
            }
          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll(stm) {
              var _get8;

              for (var _len7 = arguments.length, rest = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
                rest[_key7 - 1] = arguments[_key7];
              }

              (_get8 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AutoRecordingStateClass.prototype), "onStoreRemoveAll", this)).call.apply(_get8, [this, stm].concat(rest));

              stm.stopTransactionDelayed();
            }
          }]);

          return AutoRecordingStateClass;
        }(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_7__["default"])(_RecordingState_js__WEBPACK_IMPORTED_MODULE_9__["RecordingStateClass"]));
        /**
         * STM recording state.
         *
         * @internal
         */


        var AutoRecordingState = new AutoRecordingStateClass();
        /* harmony default export */

        __webpack_exports__["default"] = AutoRecordingState;

        _Registry_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerStmState('autorecordingstate', AutoRecordingState);
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/state/DisabledState.js":
      /*!**********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/DisabledState.js ***!
        \**********************************************************/

      /*! exports provided: DisabledStateClass, default */

      /***/
      function GridLibCommonDataStmStateDisabledStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "DisabledStateClass", function () {
          return DisabledStateClass;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _StateBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../Props.js */
        "../Grid/lib/Common/data/stm/Props.js");
        /* harmony import */


        var _Registry_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Registry.js */
        "../Grid/lib/Common/data/stm/state/Registry.js");
        /* harmony import */


        var _Helpers_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../Helpers.js */
        "../Grid/lib/Common/data/stm/Helpers.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/state/DisabledState
        */

        /**
         * STM disabled state class.
         *
         * @internal
         */

        var DisabledStateClass =
        /*#__PURE__*/
        function (_StateBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DisabledStateClass, _StateBase);

          function DisabledStateClass() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DisabledStateClass);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DisabledStateClass).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DisabledStateClass, [{
            key: "canUndo",
            value: function canUndo() {
              return false;
            }
          }, {
            key: "canRedo",
            value: function canRedo() {
              return false;
            }
          }, {
            key: "onUndo",
            value: function onUndo() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onRedo",
            value: function onRedo() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onEnable",
            value: function onEnable(stm) {
              return stm.autoRecord ? 'autoreadystate' : 'readystate';
            }
          }, {
            key: "onDisable",
            value: function onDisable() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onAutoRecordOn",
            value: function onAutoRecordOn() {
              return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_7__["AUTO_RECORD_PROP"], true);
            }
          }, {
            key: "onAutoRecordOff",
            value: function onAutoRecordOff() {
              return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_7__["AUTO_RECORD_PROP"], false);
            }
          }, {
            key: "onStartTransaction",
            value: function onStartTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStopTransaction",
            value: function onStopTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStopTransactionDelayed",
            value: function onStopTransactionDelayed() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onRejectTransaction",
            value: function onRejectTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onResetQueue",
            value: function onResetQueue(stm, options) {
              return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_9__["resetQueue"])(stm, options);
            }
          }, {
            key: "onModelUpdate",
            value: function onModelUpdate() {}
          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild() {}
          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild() {}
          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd() {}
          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert() {}
          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove() {}
          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll() {}
          }]);

          return DisabledStateClass;
        }(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["default"]);
        /**
         * STM disabled state.
         *
         * @internal
         */


        var DisabledState = new DisabledStateClass();
        /* harmony default export */

        __webpack_exports__["default"] = DisabledState;

        _Registry_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerStmState('disabledstate', DisabledState);
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/state/ReadyState.js":
      /*!*******************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/ReadyState.js ***!
        \*******************************************************/

      /*! exports provided: ReadyStateClass, default */

      /***/
      function GridLibCommonDataStmStateReadyStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "ReadyStateClass", function () {
          return ReadyStateClass;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _StateBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");
        /* harmony import */


        var _Transaction_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../Transaction.js */
        "../Grid/lib/Common/data/stm/Transaction.js");
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../Props.js */
        "../Grid/lib/Common/data/stm/Props.js");
        /* harmony import */


        var _Registry_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Registry.js */
        "../Grid/lib/Common/data/stm/state/Registry.js");
        /* harmony import */


        var _Helpers_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../Helpers.js */
        "../Grid/lib/Common/data/stm/Helpers.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/state/ReadyState
        */

        /**
         * STM ready state class.
         *
         * @internal
         */

        var ReadyStateClass =
        /*#__PURE__*/
        function (_StateBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ReadyStateClass, _StateBase);

          function ReadyStateClass() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ReadyStateClass);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ReadyStateClass).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ReadyStateClass, [{
            key: "canUndo",
            value: function canUndo(stm) {
              //      v
              // |*|*|
              return 0 < stm.position && stm.position <= stm.length;
            }
          }, {
            key: "canRedo",
            value: function canRedo(stm) {
              //  v
              // |*|*|
              return 0 <= stm.position && stm.position < stm.length;
            }
          }, {
            key: "onUndo",
            value: function onUndo(stm, steps) {
              var _ref;

              var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_8__["QUEUE_PROP"]];
              var curPos = stm.position,
                  newPos = Math.max(0, curPos - steps);

              var next = function next() {
                stm.notifyStoresAboutStateRestoringStart();

                while (curPos != newPos) {
                  queue[--curPos].undo();
                }

                return [stm.autoRecord ? 'autoreadystate' : 'readystate', function () {
                  stm.notifyStoresAboutStateRestoringStop();
                }];
              };

              return [(_ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_8__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_8__["POS_PROP"], newPos), _ref), next];
            }
          }, {
            key: "onRedo",
            value: function onRedo(stm, steps) {
              var _ref2;

              var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_8__["QUEUE_PROP"]];
              var curPos = stm.position,
                  newPos = Math.min(queue.length, curPos + steps);

              var next = function next() {
                stm.notifyStoresAboutStateRestoringStart();

                do {
                  queue[curPos++].redo();
                } while (curPos != newPos);

                return [stm.autoRecord ? 'autoreadystate' : 'readystate', function () {
                  stm.notifyStoresAboutStateRestoringStop();
                }];
              };

              return [(_ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_8__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_8__["POS_PROP"], newPos), _ref2), next];
            }
          }, {
            key: "onEnable",
            value: function onEnable() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onDisable",
            value: function onDisable() {
              return 'disabledstate';
            }
          }, {
            key: "onAutoRecordOn",
            value: function onAutoRecordOn() {
              var _ref3;

              return _ref3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_8__["STATE_PROP"], 'autoreadystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_8__["AUTO_RECORD_PROP"], true), _ref3;
            }
          }, {
            key: "onAutoRecordOff",
            value: function onAutoRecordOff() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStartTransaction",
            value: function onStartTransaction(stm, title) {
              var _ref4;

              var transaction = new _Transaction_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                title: title
              });
              return [(_ref4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_8__["STATE_PROP"], 'recordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_8__["TRANSACTION_PROP"], transaction), _ref4), function () {
                stm.notifyStoresAboutStateRecordingStart(transaction);
              }];
            }
          }, {
            key: "onStopTransaction",
            value: function onStopTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStopTransactionDelayed",
            value: function onStopTransactionDelayed() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onRejectTransaction",
            value: function onRejectTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onResetQueue",
            value: function onResetQueue(stm, options) {
              return Object(_Helpers_js__WEBPACK_IMPORTED_MODULE_10__["resetQueue"])(stm, options);
            }
          }, {
            key: "onModelUpdate",
            value: function onModelUpdate() {}
          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild() {}
          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild() {}
          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd() {}
          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert() {}
          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove() {}
          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll() {}
          }]);

          return ReadyStateClass;
        }(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["default"]);
        /**
         * STM ready state.
         *
         * @internal
         */


        var ReadyState = new ReadyStateClass();
        /* harmony default export */

        __webpack_exports__["default"] = ReadyState;

        _Registry_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerStmState('readystate', ReadyState);
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/state/RecordingState.js":
      /*!***********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/RecordingState.js ***!
        \***********************************************************/

      /*! exports provided: RecordingStateClass, default */

      /***/
      function GridLibCommonDataStmStateRecordingStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "RecordingStateClass", function () {
          return RecordingStateClass;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _StateBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../Props.js */
        "../Grid/lib/Common/data/stm/Props.js");
        /* harmony import */


        var _Registry_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Registry.js */
        "../Grid/lib/Common/data/stm/state/Registry.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/state/RecordingState
        */

        /**
         * STM recording state class.
         *
         * @internal
         */

        var RecordingStateClass =
        /*#__PURE__*/
        function (_StateBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RecordingStateClass, _StateBase);

          function RecordingStateClass() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, RecordingStateClass);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(RecordingStateClass).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(RecordingStateClass, [{
            key: "canUndo",
            value: function canUndo() {
              return false;
            }
          }, {
            key: "canRedo",
            value: function canRedo() {
              return false;
            }
          }, {
            key: "onEnable",
            value: function onEnable() {}
          }, {
            key: "onDisable",
            value: function onDisable(stm) {
              var _ref;

              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              stm.notifyStoresAboutStateRecordingStop(transaction, {
                disabled: true
              });
              return _ref = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_7__["STATE_PROP"], 'disabledstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, _Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"], null), _ref;
            }
          }, {
            key: "onAutoRecordOn",
            value: function onAutoRecordOn(stm) {
              var _ref2;

              return [(_ref2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_7__["STATE_PROP"], 'autorecordingstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, _Props_js__WEBPACK_IMPORTED_MODULE_7__["AUTO_RECORD_PROP"], true), _ref2), function () {
                stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["STATE_PROP"]].onStopTransactionDelayed(stm);
              }];
            }
          }, {
            key: "onAutoRecordOff",
            value: function onAutoRecordOff() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStartTransaction",
            value: function onStartTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStopTransaction",
            value: function onStopTransaction(stm, title) {
              var _ref3;

              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              var position = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["POS_PROP"]];
              var queue = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["QUEUE_PROP"]];

              if (transaction.length) {
                if (!transaction.title && !title && stm.getTransactionTitle) {
                  transaction.title = stm.getTransactionTitle(transaction);
                } else if (title) {
                  transaction.title = title;
                }

                queue[position] = transaction;
                queue.length = ++position;
              }

              return [(_ref3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_7__["STATE_PROP"], 'readystate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_7__["POS_PROP"], position), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, _Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"], null), _ref3), function () {
                stm.notifyStoresAboutStateRecordingStop(transaction, {
                  stop: true
                });
              }];
            }
          }, {
            key: "onRejectTransaction",
            value: function onRejectTransaction(stm) {
              var _ref4;

              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              return [(_ref4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_7__["STATE_PROP"], 'restoringstate'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref4, _Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"], null), _ref4), function () {
                if (transaction.length) {
                  transaction.undo();
                }

                return ['readystate', function () {
                  stm.notifyStoresAboutStateRecordingStop(transaction, {
                    rejected: true
                  });
                }];
              }];
            }
          }, {
            key: "onStopTransactionDelayed",
            value: function onStopTransactionDelayed() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onQueueReset",
            value: function onQueueReset() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onModelUpdate",
            value: function onModelUpdate(stm, model, newData, oldData) {
              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              transaction.addAction(stm.makeModelUpdateAction(model, newData, oldData));
            }
          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild(stm, parentModel, index, childModel, previousParent, previousIndex) {
              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              transaction.addAction(stm.makeModelInsertChildAction(parentModel, index, childModel, previousParent, previousIndex));
            }
          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild(stm, parentModel, childModels, context) {
              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              transaction.addAction(stm.makeModelRemoveChildAction(parentModel, childModels, context));
            }
          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd(stm, store, models, silent) {
              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              transaction.addAction(stm.makeStoreModelAddAction(store, models, silent));
            }
          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert(stm, store, index, models, context, silent) {
              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              transaction.addAction(stm.makeStoreModelInsertAction(store, index, models, context, silent));
            }
          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove(stm, store, models, context, silent) {
              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              transaction.addAction(stm.makeStoreModelRemoveAction(store, models, context, silent));
            }
          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll(stm, store, allRecords, silent) {
              var transaction = stm[_Props_js__WEBPACK_IMPORTED_MODULE_7__["TRANSACTION_PROP"]];
              transaction.addAction(stm.makeStoreRemoveAllAction(store, allRecords, silent));
            }
          }]);

          return RecordingStateClass;
        }(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["default"]);
        /**
         * STM recording state.
         *
         * @internal
         */


        var RecordingState = new RecordingStateClass();
        /* harmony default export */

        __webpack_exports__["default"] = RecordingState;

        _Registry_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerStmState('recordingstate', RecordingState);
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/state/Registry.js":
      /*!*****************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/Registry.js ***!
        \*****************************************************/

      /*! exports provided: registerStmState, resolveStmState, default */

      /***/
      function GridLibCommonDataStmStateRegistryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "registerStmState", function () {
          return registerStmState;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "resolveStmState", function () {
          return resolveStmState;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.map */
        "../Grid/node_modules/core-js/modules/es6.map.js");
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _StateBase_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");

        var productName = 'scheduler';
        /**
         * @module Common/data/stm/state/Registry
         *
         * Provides map of registered STM states.
         *
         * Needed to remove states circular dependency.
         *
         * @internal
         */

        var registry = new Map();
        /**
         * Registers STM state class with the given name.
         *
         * @private
         *
         * @param {string} name
         * @param {Common.data.stm.state.StateBase} state
         */

        var registerStmState = function registerStmState(name, state) {
          registry.set(name, state);
        };
        /**
         * Resolves STM state class with the given name.
         *
         * @private
         *
         * @param {string} name
         * @return {Common.data.stm.state.StateBase} state
         */


        var resolveStmState = function resolveStmState(state) {
          if (typeof state === 'string') {
            state = registry.get(state);
          }

          return state;
        }; // UMD/module compatible export
        // NOTE: the most compatible way of exporting is:
        //       import registry from './Registry.js';
        //       { registerStmState, resolveStmState } = registry;
        //          or
        //       registry.registerStmState(...);

        /* harmony default export */


        __webpack_exports__["default"] = {
          registerStmState: registerStmState,
          resolveStmState: resolveStmState
        };
        /***/
      },

      /***/
      "../Grid/lib/Common/data/stm/state/RestoringState.js":
      /*!***********************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/RestoringState.js ***!
        \***********************************************************/

      /*! exports provided: RestoringStateClass, default */

      /***/
      function GridLibCommonDataStmStateRestoringStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "RestoringStateClass", function () {
          return RestoringStateClass;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _StateBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./StateBase.js */
        "../Grid/lib/Common/data/stm/state/StateBase.js");
        /* harmony import */


        var _Props_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../Props.js */
        "../Grid/lib/Common/data/stm/Props.js");
        /* harmony import */


        var _Registry_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Registry.js */
        "../Grid/lib/Common/data/stm/state/Registry.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/state/RestoringState
        */

        /**
         * STM restoring state class.
         *
         * @internal
         */

        var RestoringStateClass =
        /*#__PURE__*/
        function (_StateBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RestoringStateClass, _StateBase);

          function RestoringStateClass() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, RestoringStateClass);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(RestoringStateClass).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(RestoringStateClass, [{
            key: "canUndo",
            value: function canUndo() {
              return false;
            }
          }, {
            key: "canRedo",
            value: function canRedo() {
              return false;
            }
          }, {
            key: "onUndo",
            value: function onUndo() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onRedo",
            value: function onRedo() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onEnable",
            value: function onEnable() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onDisable",
            value: function onDisable() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onAutoRecordOn",
            value: function onAutoRecordOn() {
              return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_7__["AUTO_RECORD_PROP"], true);
            }
          }, {
            key: "onAutoRecordOff",
            value: function onAutoRecordOff() {
              return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, _Props_js__WEBPACK_IMPORTED_MODULE_7__["AUTO_RECORD_PROP"], false);
            }
          }, {
            key: "onStartTransaction",
            value: function onStartTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStopTransaction",
            value: function onStopTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onStopTransactionDelayed",
            value: function onStopTransactionDelayed() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onRejectTransaction",
            value: function onRejectTransaction() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onQueueReset",
            value: function onQueueReset() {
              Object(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["throwInvalidMethodCall"])();
            }
          }, {
            key: "onModelUpdate",
            value: function onModelUpdate() {}
          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild() {}
          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild() {}
          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd() {}
          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert() {}
          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove() {}
          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll() {}
          }]);

          return RestoringStateClass;
        }(_StateBase_js__WEBPACK_IMPORTED_MODULE_6__["default"]);
        /**
         * STM restoring state.
         *
         * @internal
         */


        var RestoringState = new RestoringStateClass();
        /* harmony default export */

        __webpack_exports__["default"] = RestoringState;

        _Registry_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerStmState('restoringstate', RestoringState);
        /***/

      },

      /***/
      "../Grid/lib/Common/data/stm/state/StateBase.js":
      /*!******************************************************!*\
        !*** ../Grid/lib/Common/data/stm/state/StateBase.js ***!
        \******************************************************/

      /*! exports provided: throwAbstractMethodCall, throwInvalidMethodCall, default */

      /***/
      function GridLibCommonDataStmStateStateBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "throwAbstractMethodCall", function () {
          return throwAbstractMethodCall;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "throwInvalidMethodCall", function () {
          return throwInvalidMethodCall;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return StateBase;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
        * @module Common/data/stm/state/StateBase
        */

        var throwAbstractMethodCall = function throwAbstractMethodCall() {
          throw new Error('Abstract method call!');
        };

        var throwInvalidMethodCall = function throwInvalidMethodCall() {
          throw new Error('Method cannot be called at this state!');
        };
        /**
         * Abstract class for STM states
         *
         * Every on* method should return a state for the STM which it should switch to
         * or throw an exception that this call at this state is illegal.
         *
         * Interface of this class mirrors interface of {@link Common.data.stm.StateTrackingManager}.
         *
         * @abstract
         */


        var StateBase =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(StateBase, _Base);

          function StateBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, StateBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(StateBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(StateBase, [{
            key: "canUndo",
            value: function canUndo(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "canRedo",
            value: function canRedo(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onUndo",
            value: function onUndo(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onRedo",
            value: function onRedo(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onStartTransaction",
            value: function onStartTransaction(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onStopTransaction",
            value: function onStopTransaction(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onStopTransactionDelayed",
            value: function onStopTransactionDelayed(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onRejectTransaction",
            value: function onRejectTransaction(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onEnable",
            value: function onEnable(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onDisable",
            value: function onDisable(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onAutoRecordOn",
            value: function onAutoRecordOn(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onAutoRecordOff",
            value: function onAutoRecordOff(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onResetQueue",
            value: function onResetQueue(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onModelUpdate",
            value: function onModelUpdate(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onStoreModelAdd",
            value: function onStoreModelAdd(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onStoreModelInsert",
            value: function onStoreModelInsert(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onStoreModelRemove",
            value: function onStoreModelRemove(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onStoreModelRemoveAll",
            value: function onStoreModelRemoveAll(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onModelInsertChild",
            value: function onModelInsertChild(stm) {
              throwAbstractMethodCall();
            }
          }, {
            key: "onModelRemoveChild",
            value: function onModelRemoveChild(stm) {
              throwAbstractMethodCall();
            }
          }]);

          return StateBase;
        }(_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        StateBase._$name = 'StateBase';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/AjaxHelper.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/helper/AjaxHelper.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperAjaxHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return AjaxHelper;
        });
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/AjaxHelper
        */

        /**
         * Simplifies Ajax requests. Uses fetch & promises.
         *
         * @example
         * AjaxHelper.get('someurl').then(response => {
         *  // process request response here
         * });
         */

        var AjaxHelper =
        /*#__PURE__*/
        function () {
          function AjaxHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, AjaxHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(AjaxHelper, null, [{
            key: "get",

            /**
             * Make a request (using GET) to the specified url.
             * @param {String} url Url
             * @param {Object} [options] The options for the `fetch` API. Please see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch for details
             * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
             * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
             * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
             * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
             * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
             * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
             * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
             */
            value: function get(url, options) {
              return this.fetch(url, options);
            }
            /**
             * POST data to the specified URL.
             * @param {String} url The URL
             * @param {String|Object|FormData} payload The data to post. If an object is supplied, it will be stringified
             * @param {Object} options The options for the `fetch` API. Please see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch for details
             * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
             * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
             * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
             * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
             * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
             * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
             * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
             */

          }, {
            key: "post",
            value: function post(url, payload) {
              var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

              if (!(payload instanceof FormData) && !(typeof payload === 'string')) {
                payload = JSON.stringify(payload);
              }

              return this.fetch(url, Object.assign({
                method: 'POST',
                body: payload
              }, options));
            }
            /**
             * Fetch the specified resource using the `fetch` API.
             * @param {String} url object to fetch
             * @param {Object} options The options for the `fetch` API. Please see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch for details
             * @param {Object} [options.method] The request method, e.g., GET, POST
             * @param {Object} [options.queryParams] A key-value pair Object containing the params to add to the query string
             * @param {Object} [options.headers] Any headers you want to add to your request, contained within a `Headers object or an object literal with ByteString values
             * @param {Object} [options.body] Any body that you want to add to your request: this can be a Blob, BufferSource, FormData, URLSearchParams, or USVString object. Note that a request using the GET or HEAD method cannot have a body.
             * @param {Object} [options.mode] The mode you want to use for the request, e.g., cors, no-cors, or same-origin.
             * @param {Object} [options.credentials] The request credentials you want to use for the request: omit, same-origin, or include. To automatically send cookies for the current domain, this option must be provided
             * @param {Object} [options.parseJson] Specify `true` to parses the response and attach the resulting object to the `Response` object as `parsedJson`
             * @returns {Promise} The fetch Promise, which can be aborted by calling a special `abort` method
             */

          }, {
            key: "fetch",
            value: function (_fetch) {
              function fetch(_x) {
                return _fetch.apply(this, arguments);
              }

              fetch.toString = function () {
                return _fetch.toString();
              };

              return fetch;
            }(function (url) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var controller = new AbortController();
              options.signal = controller.signal;

              if (!('credentitals' in options)) {
                options.credentials = 'include';
              }

              if (options.queryParams) {
                var params = Object.entries(options.queryParams);

                if (params.length) {
                  url += '?' + params.map(function (_ref) {
                    var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_ref, 2),
                        param = _ref2[0],
                        value = _ref2[1];

                    return "".concat(param, "=").concat(encodeURIComponent(value));
                  }).join('&');
                }
              } // Promise that will be resolved either when network request is finished or when json is parsed


              var promise = new Promise(function (resolve, reject) {
                fetch(url, options).then(function (response) {
                  if (options.parseJson) {
                    response.json().then(function (json) {
                      response.parsedJson = json;
                      resolve(response);
                    }).catch(function (error) {
                      response.parsedJson = null;
                      response.error = error;
                      reject(response);
                    });
                  } else {
                    resolve(response);
                  }
                }).catch(function (error) {
                  reject(error);
                });
              });

              promise.abort = function () {
                controller.abort();
              };

              return promise;
            })
          }]);

          return AjaxHelper;
        }();

        AjaxHelper._$name = 'AjaxHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/ArrayHelper.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/helper/ArrayHelper.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperArrayHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ArrayHelper;
        });
        /* harmony import */


        var core_js_modules_es6_reflect_set__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.set */
        "../Grid/node_modules/core-js/modules/es6.reflect.set.js");
        /* harmony import */


        var core_js_modules_es6_reflect_set__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_set__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_number_is_nan__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.number.is-nan */
        "../Grid/node_modules/core-js/modules/es6.number.is-nan.js");
        /* harmony import */


        var core_js_modules_es6_number_is_nan__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_is_nan__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "../Grid/node_modules/core-js/modules/es6.number.constructor.js");
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_reflect_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.get */
        "../Grid/node_modules/core-js/modules/es6.reflect.get.js");
        /* harmony import */


        var core_js_modules_es6_reflect_get__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_get__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/ArrayHelper
        */

        /**
         * Helper with useful functions for handling Arrays
         * @internal
         */

        var ArrayHelper =
        /*#__PURE__*/
        function () {
          function ArrayHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, ArrayHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(ArrayHelper, [{
            key: "magnitudeCompare",
            value: function magnitudeCompare(lhs, rhs) {
              return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
            }
          }, {
            key: "lexicalCompare",
            value: function lexicalCompare(lhs, rhs) {
              lhs = String(lhs);
              rhs = String(rhs);
              return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
            }
            /**
             * Similar to Array.prototype.fill(), but constructs a new array with the specified item count and fills it with
             * clones of the supplied item.
             * @param {Number} count Number of entries to create
             * @param {Object|Array} itemOrArray Item or array of items to clone (uses object spread to create shallow clone)
             * @param {Function} [fn] An optional function that is called for each item added, to allow processing
             * @returns {Array} A new populated array
             */

          }], [{
            key: "clean",
            value: function clean(array) {
              return array.reduce(function (res, item) {
                if (item !== null && item !== undefined && !(Array.isArray(item) && item.length === 0) && item !== '') res.push(item);
                return res;
              }, []);
            }
            /**
             * Remove one or more items from an array
             * @param {Array} array Array to remove from
             * @param {Object} items One or more items to remove
             * @returns {boolean} Returns true if any item was removed
             */

          }, {
            key: "remove",
            value: function remove(array) {
              var index,
                  item,
                  removed = false;

              for (var i = 0; i < (arguments.length <= 1 ? 0 : arguments.length - 1); i++) {
                item = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

                if ((index = array.indexOf(item)) !== -1) {
                  array.splice(index, 1);
                  removed = true;
                }
              }

              return removed;
            }
            /*
             * Calculates the insertion index of a passed object into the passed Array according
             * to the passed comparator function. Note that the passed Array *MUST* already be ordered.
             * @param {Object} item The item to calculate the insertion index for.
             * @param {Array} The array into which the item is to be inserted.
             * @param {Function} comparatorFn The comparison function. Must return -1 or 0 or 1.
             * @param {Object} comparatorFn.lhs The left object to compare.
             * @param {Object} comparatorFn.rhs The right object to compare.
             * @param {Number} index The possible correct index to try first before a binary
             * search is instigated.
             */

          }, {
            key: "findInsertionIndex",
            value: function findInsertionIndex(item, array) {
              var comparatorFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.lexicalCompare;
              var index = arguments.length > 3 ? arguments[3] : undefined;
              var len = array.length;
              var beforeCheck, afterCheck;

              if (index < len) {
                beforeCheck = index > 0 ? comparatorFn(array[index - 1], item) : 0;
                afterCheck = index < len - 1 ? comparatorFn(item, array[index]) : 0;

                if (beforeCheck < 1 && afterCheck < 1) {
                  return index;
                }
              }

              return this.binarySearch(array, item, comparatorFn);
            }
            /**
             * This method returns the index that a given item would be inserted into the
             * given (sorted) `array`. Note that the given `item` may or may not be in the
             * array. This method will return the index of where the item *should* be.
             *
             * For example:
             *
             *      var array = [ 'A', 'D', 'G', 'K', 'O', 'R', 'X' ];
             *      var index = ArrayHelper.binarySearch(array, 'E');
             *
             *      console.log('index: ' + index);
             *      // logs "index: 2"
             *
             *      array.splice(index, 0, 'E');
             *
             *      console.log('array : ' + array.join(''));
             *      // logs "array: ADEGKORX"
             *
             * @param {Object[]} array The array to search.
             * @param {Object} item The item that you want to insert into the `array`.
             * @param {Number} [begin=0] The first index in the `array` to consider.
             * @param {Number} [end=array.length] The index that marks the end of the range
             * to consider. The item at this index is *not* considered.
             * @param {Function} [compareFn] The comparison function that matches the sort
             * order of the `array`. The default `compareFn` compares items using less-than
             * and greater-than operators.
             * @return {Number} The index for the given item in the given array based on
             * the passed `compareFn`.
             */

          }, {
            key: "binarySearch",
            value: function binarySearch(array, item) {
              var begin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              var end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : array.length;
              var compareFn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.lexicalCompare;
              var length = array.length;
              var middle, comparison;

              if (begin instanceof Function) {
                compareFn = begin;
                begin = 0;
              } else if (end instanceof Function) {
                compareFn = end;
                end = length;
              }

              --end;

              while (begin <= end) {
                middle = begin + end >> 1;
                comparison = compareFn(item, array[middle]);

                if (comparison >= 0) {
                  begin = middle + 1;
                } else if (comparison < 0) {
                  end = middle - 1;
                }
              }

              return begin;
            }
          }, {
            key: "fill",
            value: function fill(count) {
              var itemOrArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var fn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var result = [],
                  items = Array.isArray(itemOrArray) ? itemOrArray : [itemOrArray];

              for (var i = 0; i < count; i++) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value; // Using object spread here forces us to use more babel plugins and will make
                    // react_typescript demo very difficult to setup

                    var processedItem = Object.assign({}, item);

                    if (fn) {
                      fn(processedItem, i);
                    }

                    result.push(processedItem);
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }

              return result;
            }
            /**
             * Populates an array with the return value from `fn`.
             * @param {Number} count Number of entries to create
             * @param {Function} fn A function that is called `count` times, return value is added to array
             * @param {Number} fn.index Current index in the array
             * @returns {Array} A new populated array
             */

          }, {
            key: "populate",
            value: function populate(count, fn) {
              var items = [];

              for (var i = 0; i < count; i++) {
                items.push(fn(i));
              }

              return items;
            }
            /**
             * Pushes `item` on to the `array` if not already included
             * @param {Array}  array Array to push to
             * @param {Object} item Item to push if not already included
             */

          }, {
            key: "include",
            value: function include(array, item) {
              if (!array.includes(item)) {
                array.push(item);
              }
            } // Wanted to create an indexer on Stores, based on this. But turns out Proxy cannot be transpiled/polyfill for IE11
            // Keeping it for future reference

          }, {
            key: "allowNegative",
            value: function allowNegative(array) {
              // From https://github.com/sindresorhus/negative-array
              return new Proxy(array, {
                get: function get(target, name, receiver) {
                  if (typeof name !== 'string') {
                    return Reflect.get(target, name, receiver);
                  }

                  var index = Number(name);

                  if (Number.isNaN(index)) {
                    return Reflect.get(target, name, receiver);
                  }

                  return target[index < 0 ? target.length + index : index];
                },
                set: function set(target, name, value, receiver) {
                  if (typeof name !== 'string') {
                    return Reflect.set(target, name, value, receiver);
                  }

                  var index = Number(name);

                  if (Number.isNaN(index)) {
                    return Reflect.set(target, name, value, receiver);
                  }

                  target[index < 0 ? target.length + index : index] = value;
                  return true;
                }
              });
            }
          }]);

          return ArrayHelper;
        }();

        ArrayHelper._$name = 'ArrayHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/BrowserHelper.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/helper/BrowserHelper.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperBrowserHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return BrowserHelper;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.match */
        "../Grid/node_modules/core-js/modules/es6.regexp.match.js");
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/BrowserHelper
        */

        /**
         * Static helper class that does browser/feature detection.
         * @internal
         */

        var BrowserHelper =
        /*#__PURE__*/
        function () {
          function BrowserHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, BrowserHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(BrowserHelper, null, [{
            key: "cacheFlags",
            value: function cacheFlags() {
              var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.platform;
              var userAgent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : navigator.userAgent;
              var me = this; // os

              me._isLinux = Boolean(platform.match(/Linux/));
              me._isMac = Boolean(platform.match(/Mac/));
              me._isWindows = Boolean(platform.match(/Win32/)); // browser

              me._isIE11 = Boolean(userAgent.match(/rv:11/));
              me._edgeVersion = me.getVersion(userAgent, /Edge\/(\d+)\./);
              me._isEdge = me._edgeVersion > 0; // Edge user agent contain webkit too

              me._isWebkit = Boolean(userAgent.match(/WebKit/)) && !me._isEdge;
              me._firefoxVersion = me.getVersion(userAgent, /Firefox\/(\d+)\./);
              me._isFirefox = me._firefoxVersion > 0;
              me._chromeVersion = !me._isEdge ? me.getVersion(userAgent, /Chrom(?:e|ium)\/(\d+)\./) : 0;
              me._isChrome = me._chromeVersion > 0;
              me._isSafari = Boolean(userAgent.match(/Safari/)) && !me._isChrome && !me._isEdge;
              me._isMobileSafari = Boolean(userAgent.match(/Mobile.*Safari/));

              try {
                document.querySelector(':scope'); // Scoped queries are not supported for custom element polyfill in firefox
                // https://app.assembla.com/spaces/bryntum/tickets/6781

                me.supportsQueryScope = !me._isFirefox;
              } catch (e) {
                me.supportsQueryScope = false;
              }

              me._supportsPassive = false;

              try {
                // If the browser asks the options object to yield its passive
                // property, we know it supports the object form options object
                // and passive listeners.
                document.addEventListener('__notvalid__', null, {
                  get passive() {
                    me._supportsPassive = true;
                  }

                });
              } catch (e) {} //document.addEventListener("DOMContentLoaded", me.onDocumentReady);

            } // NOTE: Not allowed with CSP, moved to Grid#render()
            // /**
            //  * Feature and browser detection which requires the document to be loaded.
            //  * @private
            //  */
            // static onDocumentReady() {
            //     // Firefox includes a part of the Y scroller jutting up which is not needed.
            //     // Also need to "mitre" the horizontal scrollbar to leave the gap at the end.
            //     if (BrowserHelper.isFirefox) {
            //         CSSHelper.insertRule(`.b-virtual-scroller {height: ${DomHelper.scrollBarWidth}px;}`);
            //         CSSHelper.insertRule(`.b-virtual-scrollers {padding-right: ${DomHelper.scrollBarWidth}px;}`);
            //     }
            // }

            /**
             * Returns matched version for userAgent
             * @param String versionRe version match regular expression
             * @returns {Number} matched version
             * @readonly
             * @private
             */

          }, {
            key: "getVersion",
            value: function getVersion(userAgent, versionRe) {
              var match = userAgent.match(versionRe);
              return match ? parseInt(match[1]) : 0;
            }
            /**
             * Tries to determine if the user is using a touch device
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "setLocalStorageItem",
            value: function setLocalStorageItem(key, value) {
              this.storageAvailable && localStorage.setItem(key, value);
            }
          }, {
            key: "getLocalStorageItem",
            value: function getLocalStorageItem(key) {
              return this.storageAvailable && localStorage.getItem(key);
            }
          }, {
            key: "removeLocalStorageItem",
            value: function removeLocalStorageItem(key) {
              this.storageAvailable && localStorage.removeItem(key);
            }
          }, {
            key: "isTouchDevice",
            get: function get() {
              if ('_isTouchDevice' in this) return this._isTouchDevice;
              return 'ontouchstart' in window || // edge tends to always have this with a value 2
              !this.isEdge && navigator.maxTouchPoints > 0 || // but if env is actually touchable, then window has this class present
              this.isEdge && window.TouchEvent || navigator.msMaxTouchPoints > 0;
            } // Since touch screen detection is unreliable we should allow client to configure it, or detect first touch
            ,
            set: function set(value) {
              this._isTouchDevice = value;
            }
            /**
             * Checks if platform is mac
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isMac",
            get: function get() {
              return this._isMac;
            }
            /**
             * Checks if platform is windows
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isWindows",
            get: function get() {
              return this._isWindows;
            }
            /**
             * Checks if platform is linux
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isLinux",
            get: function get() {
              return this._isLinux;
            }
            /**
             * Checks if browser is IE11
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isIE11",
            get: function get() {
              return this._isIE11;
            }
            /**
             * Checks if browser is Edge
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isEdge",
            get: function get() {
              return this._isEdge;
            }
            /**
             * Find the major Edge version
             * @returns {Number} Edge version or 0 for other browsers
             * @readonly
             */

          }, {
            key: "edgeVersion",
            get: function get() {
              return this._edgeVersion;
            }
            /**
             * Checks if browser is Webkit
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isWebkit",
            get: function get() {
              return this._isWebkit;
            }
            /**
             * Checks if browser is Chrome
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isChrome",
            get: function get() {
              return this._isChrome;
            }
            /**
             * Find the major Chrome version
             * @returns {Number} Chrome version or 0 for other browsers
             * @readonly
             */

          }, {
            key: "chromeVersion",
            get: function get() {
              return this._chromeVersion;
            }
            /**
             * Checks if browser is Firefox
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isFirefox",
            get: function get() {
              return this._isFirefox;
            }
            /**
             * Find the major Firefox version.
             * @returns {Number} Firefox version or 0 for other browsers
             * @readonly
             */

          }, {
            key: "firefoxVersion",
            get: function get() {
              return this._firefoxVersion;
            }
            /**
             * Checks if browser is Safari
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isSafari",
            get: function get() {
              return this._isSafari;
            }
            /**
             * Checks if browser is mobile Safari
             * @returns {Boolean}
             * @readonly
             */

          }, {
            key: "isMobileSafari",
            get: function get() {
              return this._isMobileSafari;
            }
            /**
             * Returns `true` if the browser supports passive event listeners.
             */

          }, {
            key: "supportsPassive",
            get: function get() {
              return this._supportsPassive;
            } // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API

          }, {
            key: "storageAvailable",
            get: function get() {
              var storage, x;

              try {
                storage = localStorage;
                x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
              } catch (e) {
                return e instanceof DOMException && ( // everything except Firefox
                e.code === 22 || // Firefox
                e.code === 1014 || // test name field too, because code might not be present
                // everything except Firefox
                e.name === 'QuotaExceededError' || // Firefox
                e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
                storage.length !== 0;
              }
            }
          }]);

          return BrowserHelper;
        }();

        BrowserHelper.cacheFlags();
        BrowserHelper._$name = 'BrowserHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/CSSHelper.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/helper/CSSHelper.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperCSSHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CSSHelper;
        });
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/CSSHelper
         */

        /**
         * Provides methods to add and manipulate CSS style rules.
         *
         * Note that this class is incompatible with [CSP](https://developer.mozilla.org/en-US/docs/Web/HTTP/CSP)
         *
         * ```
         * this.criticalRule = CSSHelper.insertRule(`#${this.id} .b-sch-event.critical {background-color:${this.criticalColor}}`);
         * ```
         */

        var CSSHelper =
        /*#__PURE__*/
        function () {
          function CSSHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, CSSHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(CSSHelper, null, [{
            key: "insertRule",

            /**
             * Inserts a CSS style rule based upon the passed text
             * @param {String} cssText The text of the rule including selector and rule body just as it would
             * be specified in a CSS file.
             * @returns {CSSRule} The resulting CSS Rule object if the add was successful.
             */
            value: function insertRule(cssText) {
              var styleSheet = this.styleSheet,
                  oldCount = styleSheet.cssRules.length;
              styleSheet.insertRule(cssText, 0); // Only return element zero if the add was successful.

              if (styleSheet.cssRules.length > oldCount) {
                return styleSheet.cssRules[0];
              }
            }
            /**
             * Looks up the first rule which matched the passed selector.
             * @param {String/Function} selector Either the selector string to exactly match or a function which
             * when passed a required selector, returns `true`.
             * @returns {CSSRule} The first matching CSS Rule object if any found.
             */

          }, {
            key: "findRule",
            value: function findRule(selector) {
              var result,
                  isFn = typeof selector === 'function'; // Array#find will stop when the function returns true, stop when the inner
              // find call yields a value from the search string.
              // Array#find better: to http://www.andygup.net/fastest-way-to-find-an-item-in-a-javascript-array/

              Array.prototype.find.call(document.head.querySelectorAll('link[rel=stylesheet],style[type*=css]'), function (element) {
                result = Array.prototype.find.call(element.sheet.rules || element.sheet.cssRules, function (r) {
                  return isFn ? selector(r) : r.selectorText === selector;
                });

                if (result) {
                  return true;
                }
              });
              return result;
            }
          }, {
            key: "styleSheet",
            get: function get() {
              if (!this._stylesheet) {
                this._stylesheet = _DomHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].createElement({
                  tag: 'style',
                  id: 'bryntum-private-styles',
                  type: 'text/css',
                  parent: document.head
                }).sheet;
              }

              return this._stylesheet;
            }
          }]);

          return CSSHelper;
        }();

        CSSHelper._$name = 'CSSHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/DateHelper.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/helper/DateHelper.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperDateHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DateHelper;
        });
        /* harmony import */


        var core_js_modules_es6_math_sign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.math.sign */
        "../Grid/node_modules/core-js/modules/es6.math.sign.js");
        /* harmony import */


        var core_js_modules_es6_math_sign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_math_sign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/construct */
        "../Grid/node_modules/@babel/runtime/helpers/construct.js");
        /* harmony import */


        var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.match */
        "../Grid/node_modules/core-js/modules/es6.regexp.match.js");
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! core-js/modules/es6.string.ends-with */
        "../Grid/node_modules/core-js/modules/es6.string.ends-with.js");
        /* harmony import */


        var core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var core_js_modules_es7_string_pad_end__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! core-js/modules/es7.string.pad-end */
        "../Grid/node_modules/core-js/modules/es7.string.pad-end.js");
        /* harmony import */


        var core_js_modules_es7_string_pad_end__WEBPACK_IMPORTED_MODULE_19___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_string_pad_end__WEBPACK_IMPORTED_MODULE_19__);
        /* harmony import */


        var core_js_modules_es7_string_pad_start__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! core-js/modules/es7.string.pad-start */
        "../Grid/node_modules/core-js/modules/es7.string.pad-start.js");
        /* harmony import */


        var core_js_modules_es7_string_pad_start__WEBPACK_IMPORTED_MODULE_20___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_string_pad_start__WEBPACK_IMPORTED_MODULE_20__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_21___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_21__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "../Grid/node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_22___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_22__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_23___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_23__);
        /* harmony import */


        var core_js_modules_es6_regexp_constructor__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.constructor */
        "../Grid/node_modules/core-js/modules/es6.regexp.constructor.js");
        /* harmony import */


        var core_js_modules_es6_regexp_constructor__WEBPACK_IMPORTED_MODULE_24___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_constructor__WEBPACK_IMPORTED_MODULE_24__);
        /* harmony import */


        var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");
        /* harmony import */


        var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ../localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");
        /* harmony import */


        var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ./BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler';
        /*
        Not ported:
        -----------
        Week of Year w 1 2 ... 52 53
        wo 1st 2nd ... 52nd 53rd
        ww 01 02 ... 52 53
        Week Year gg 70 71 ... 29 30
        gggg 1970 1971 ... 2029 2030
        Week Year (ISO) GG 70 71 ... 29 30
        GGGG 1970 1971 ... 2029 2030
        Time Zone z or zz EST CST ... MST PST
        Note: as of 1.6.0, the z/zz format tokens have been deprecated from plain moment objects. Read more about it here. However, they do work if you are using a specific time zone with the moment-timezone addon.
        Z -07:00 -06:00 ... +06:00 +07:00
        ZZ -0700 -0600 ... +0600 +0700
        Unix Timestamp X 1360013296
        Unix Millisecond Timestamp x 1360013296123
        */

        var enOrdinalSuffix = function enOrdinalSuffix(number) {
          return number + ({
            '1': 'st',
            '2': 'nd',
            '3': 'rd'
          }[number[number.length - 1]] || 'th');
        }; // Left-to-right unicode mark
        // https://www.codetable.net/decimal/8206


        var LTRSymbolRegexp = new RegExp("\u200E"); // These vars are set when changing locale

        var locale = 'en-US',
            ordinalSuffix = enOrdinalSuffix,
            // Used to cache used formats, to not have to parse format string each time
        formatCache = {},
            intlFormatterCache = {},
            parserCache = {};

        function useIntlFormat(name, options, date) {
          var formatter = intlFormatterCache[name] || (intlFormatterCache[name] = new Intl.DateTimeFormat(locale, options));
          var result = formatter.format(date); // IE11 inserts direction control characters to the start of the string
          // This breaks substring(0, 2). Skipping first character in the row for I
          // https://stackoverflow.com/questions/25574963/ies-tolocalestring-has-strange-characters-in-results

          if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].isIE11) {
            result = result.replace(LTRSymbolRegexp, '');
          }

          return result;
        }

        var MS_PER_DAY = 864e5,
            MS_PER_WEEK = MS_PER_DAY * 7,
            defaultFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ',
            formats = {
          // 1, 2, ... 11, 12
          'M': function M(date) {
            return date.getMonth() + 1;
          },
          //date.toLocaleDateString(locale, { month : 'numeric' }),
          // 1st, 2nd, 3rd, 4th, ... 11th, 12th
          'Mo': function Mo(date) {
            return ordinalSuffix(formats['M'](date).toString());
          },
          // 01, 02, ...
          'MM': function MM(date) {
            return (date.getMonth() + 1).toString().padStart(2, '0');
          },
          //date.toLocaleDateString(locale, { month : '2-digit' }),
          // Jan, Feb, ...
          'MMM': function MMM(date) {
            return useIntlFormat('MMM', {
              month: 'short'
            }, date);
          },
          // January, February, ...
          'MMMM': function MMMM(date) {
            return useIntlFormat('MMMM', {
              month: 'long'
            }, date);
          },
          // 1, 2, ...
          'Q': function Q(date) {
            return Math.ceil((date.getMonth() + 1) / 4);
          },
          // 1st, 2nd, ...
          'Qo': function Qo(date) {
            return ordinalSuffix(formats['Q'](date).toString());
          },
          // 1, 2, ...
          'D': function D(date) {
            return date.getDate();
          },
          //date.toLocaleDateString(locale, { day : 'numeric' }),
          // 1st, 2nd, ...
          'Do': function Do(date) {
            return ordinalSuffix(formats['D'](date).toString());
          },
          // 01, 02, ...
          'DD': function DD(date) {
            return date.getDate().toString().padStart(2, '0');
          },
          //date.toLocaleDateString(locale, { day : '2-digit' }),
          // 1, 2, ..., 365, 365
          'DDD': function DDD(date) {
            return Math.ceil((new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0) - new Date(date.getFullYear(), 0, 0, 12, 0, 0)) / MS_PER_DAY);
          },
          // 1st, 2nd, ...
          'DDDo': function DDDo(date) {
            return ordinalSuffix(formats['DDD'](date).toString());
          },
          // 001, 002, ...
          'DDDD': function DDDD(date) {
            return formats['DDD'](date).toString().padStart(3, '0');
          },
          // 0, 1, ..., 6
          'd': function d(date) {
            return date.getDay();
          },
          // 0th, 1st, ...
          'do': function _do(date) {
            return ordinalSuffix(date.getDay().toString());
          },
          // Su, Mo, ...
          'dd': function dd(date) {
            return formats['ddd'](date).substring(0, 2);
          },
          // Sun, Mon, ...
          'ddd': function ddd(date) {
            return useIntlFormat('ddd', {
              weekday: 'short'
            }, date);
          },
          // Sunday, Monday, ...
          'dddd': function dddd(date) {
            return useIntlFormat('dddd', {
              weekday: 'long'
            }, date);
          },
          'e': function e(date) {
            return date.getDay();
          },
          'E': function E(date) {
            return date.getDay() + 1;
          },
          // ISO week, 1, 2, ...
          'W': function W(date) {
            // Adapted from https://www.epochconverter.com/weeknumbers
            var target = new Date(date.valueOf());
            target.setDate(target.getDate() - (date.getDay() + 6) % 7 + 3);
            var firstThursday = target.valueOf();
            target.setMonth(0, 1);

            if (target.getDay() !== 4) {
              target.setMonth(0, 1 + (4 - target.getDay() + 7) % 7);
            }

            return 1 + Math.ceil((firstThursday - target) / MS_PER_WEEK);
          },
          'Wo': function Wo(date) {
            return ordinalSuffix(formats['W'](date).toString());
          },
          'WW': function WW(date) {
            return formats['W'](date).toString().padStart(2, '0');
          },
          // 1979, 2018
          'Y': function Y(date) {
            return date.getFullYear();
          },
          //date.toLocaleDateString(locale, { year : 'numeric' }),
          // 79, 18
          'YY': function YY(date) {
            return date.getFullYear() % 100;
          },
          //date.toLocaleDateString(locale, { year : '2-digit' }),
          // 1979, 2018
          'YYYY': function YYYY(date) {
            return date.getFullYear();
          },
          //date.toLocaleDateString(locale, { year : 'numeric' }),
          // AM, PM
          'A': function A(date) {
            return date.getHours() < 12 ? 'AM' : 'PM';
          },
          'a': function a(date) {
            return date.getHours() < 12 ? 'am' : 'pm';
          },
          // 0, 1, ... 23
          'H': function H(date) {
            return date.getHours();
          },
          // 00, 01, ...
          'HH': function HH(date) {
            return date.getHours().toString().padStart(2, '0');
          },
          // 1, 2, ... 12
          'h': function h(date) {
            return date.getHours() % 12 || 12;
          },
          // 01, 02, ...
          'hh': function hh(date) {
            return formats['h'](date).toString().padStart(2, '0');
          },
          // 1, 2, ... 24
          'k': function k(date) {
            return date.getHours() + 1;
          },
          // 01, 02, ...
          'kk': function kk(date) {
            return formats['k'](date).toString().padStart(2, '0');
          },
          // Locale specific (0 -> 24 or 1 AM -> 12 PM)
          'K': function K(date) {
            return useIntlFormat('K', {
              hour: 'numeric'
            }, date);
          },
          // Locale specific (00 -> 24 or 1 AM -> 12 PM)
          'KK': function KK(date) {
            return useIntlFormat('KK', {
              hour: '2-digit'
            }, date);
          },
          // 0, 1, ... 59
          'm': function m(date) {
            return date.getMinutes();
          },
          //date.toLocaleTimeString(locale, { minute : 'numeric' }),
          // 00, 01, ...
          'mm': function mm(date) {
            return formats['m'](date).toString().padStart(2, '0');
          },
          // 0, 1, ... 59
          's': function s(date) {
            return date.getSeconds();
          },
          //date.toLocaleTimeString(locale, { second : 'numeric' }),
          // 00, 01, ...
          'ss': function ss(date) {
            return formats['s'](date).toString().padStart(2, '0');
          },
          // 0, 1, ... 9
          'S': function S(date) {
            return date.getMilliseconds().toString().substr(0, 1);
          },
          // 00, 01, ... 99
          'SS': function SS(date) {
            return date.getMilliseconds().toString().substr(0, 2).padEnd(2, '0');
          },
          // 000, 001, ... 999
          'SSS': function SSS(date) {
            return date.getMilliseconds().toString().substr(0, 3).padEnd(3, '0');
          },
          'z': function z(date) {
            return useIntlFormat('z', {
              timeZoneName: 'short'
            }, date);
          },
          'zz': function zz(date) {
            return useIntlFormat('zz', {
              timeZoneName: 'long'
            }, date);
          },
          'LT': function LT(date) {
            return useIntlFormat('LT', {
              hour: '2-digit',
              minute: '2-digit'
            }, date);
          },
          'LTS': function LTS(date) {
            return useIntlFormat('LTS', {
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit'
            }, date);
          },
          'L': function L(date) {
            return useIntlFormat('L', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }, date);
          },
          'l': function l(date) {
            return useIntlFormat('l', {
              year: 'numeric',
              month: 'numeric',
              day: 'numeric'
            }, date);
          },
          'LL': function LL(date) {
            return useIntlFormat('LL', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            }, date);
          },
          'll': function ll(date) {
            return useIntlFormat('ll', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            }, date);
          },
          'LLL': function LLL(date) {
            return useIntlFormat('LLL', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit'
            }, date);
          },
          'lll': function lll(date) {
            return useIntlFormat('lll', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit'
            }, date);
          },
          'LLLL': function LLLL(date) {
            return useIntlFormat('LLLL', {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              weekday: 'long'
            }, date);
          },
          'llll': function llll(date) {
            return useIntlFormat('llll', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: '2-digit',
              weekday: 'short'
            }, date);
          }
        },
            // Want longest keys first, to not stop match at L of LTS etc.
        formatKeys = Object.keys(formats).sort(function (a, b) {
          return b.length - a.length;
        }),
            formatRegexp = "^(?:".concat(formatKeys.join('|'), ")"),
            // return empty object, meaning value cannot be processed to a valuable date part
        emptyFn = function emptyFn() {
          return {};
        },
            parsers = {
          'YYYY': function YYYY(str) {
            return {
              year: parseInt(str)
            };
          },
          'Y': function Y(str) {
            return {
              year: parseInt(str)
            };
          },
          'YY': function YY(str) {
            var year = parseInt(str);
            return {
              year: year + (year > 1968 ? 1900 : 2000)
            };
          },
          'MM': function MM(str) {
            return {
              month: parseInt(str) - 1
            };
          },
          'Mo': function Mo(str) {
            return {
              month: parseInt(str) - 1
            };
          },
          'DD': function DD(str) {
            return {
              date: parseInt(str)
            };
          },
          'M': function M(str) {
            return {
              month: parseInt(str) - 1
            };
          },
          'D': function D(str) {
            return {
              date: parseInt(str)
            };
          },
          'Do': function Do(str) {
            return {
              date: parseInt(str)
            };
          },
          'DDD': emptyFn,
          'MMM': emptyFn,
          'MMMM': emptyFn,
          'DDDo': emptyFn,
          'DDDD': emptyFn,
          'd': emptyFn,
          'do': emptyFn,
          'dd': emptyFn,
          'ddd': emptyFn,
          'dddd': emptyFn,
          'Q': emptyFn,
          'Qo': emptyFn,
          'W': emptyFn,
          'Wo': emptyFn,
          'WW': emptyFn,
          'e': emptyFn,
          'E': emptyFn,
          'HH': function HH(str) {
            return {
              hours: parseInt(str)
            };
          },
          'mm': function mm(str) {
            return {
              minutes: parseInt(str)
            };
          },
          'H': function H(str) {
            return {
              hours: parseInt(str)
            };
          },
          'm': function m(str) {
            return {
              minutes: parseInt(str)
            };
          },
          'ss': function ss(str) {
            return {
              seconds: parseInt(str)
            };
          },
          's': function s(str) {
            return {
              seconds: parseInt(str)
            };
          },
          'S': function S(str) {
            return {
              milliseconds: parseInt(str)
            };
          },
          'SS': function SS(str) {
            return {
              milliseconds: parseInt(str)
            };
          },
          'SSS': function SSS(str) {
            return {
              milliseconds: parseInt(str)
            };
          },
          'A': function A(str) {
            return {
              amPm: str.toLowerCase()
            };
          },
          'a': function a(str) {
            return {
              amPm: str.toLowerCase()
            };
          },
          'L': 'MM/DD/YYYY',
          'LT': 'HH:mm A',
          // Can either be Z (=UTC, 0) or +-HH:MM
          'Z': function Z(str) {
            if (!str) {
              return {};
            }

            var timeZone = 0; // If string being parsed is more "detailed" than the format specified we can have more chars left,
            // thus check the last (for example HH:mmZ with input HH:mm:ssZ -> ssZ)

            if (!str.endsWith('Z')) {
              var matches = timeZoneRegEx.exec(str); // If timezone regexp matches, sting has time zone offset like '+02:00'

              if (matches) {
                var sign = matches[1] === '+' ? 1 : -1,
                    hours = parseInt(matches[2]) || 0,
                    minutes = parseInt(matches[3]) || 0;
                timeZone = sign * (hours * 60 + minutes);
              } // otherwise we just return current time zone, because there's a Z key in the input
              else {
                  timeZone = -1 * new Date().getTimezoneOffset();
                }
            }

            return {
              timeZone: timeZone
            };
          }
        },
            parserKeys = Object.keys(parsers).sort(function (a, b) {
          return b.length - a.length;
        }),
            parserRegexp = new RegExp("(".concat(parserKeys.join('|'), ")")),
            // Following regexp includes all formats that should be handled by Date class
        localeStrRegExp = new RegExp('(l|LL|ll|LLL|lll|LLLL|llll)'),
            //    ISODateRegExp             = new RegExp('YYYY-MM-DD[T ]HH:mm:ss(.s+)?Z'),
        // Some validConversions are negative to show that it's not an exact conversion, just an estimate.
        validConversions = {
          // The units below assume:
          // 30 days in a month, 91 days for a quarter and 365 for a year
          // 52 weeks per year, 4 per month, 13 per quarter
          'year': {
            year: 1,
            quarter: 4,
            month: 12,
            week: 52,
            day: 365,
            hour: 24 * 365,
            minute: 1440 * 365,
            second: 86400 * 365,
            millisecond: 86400000 * 365
          },
          'quarter': {
            year: 1 / 4,
            quarter: 1,
            month: 3,
            week: 4,
            day: 91,
            hour: 24 * 91,
            minute: 1440 * 91,
            second: 86400 * 91,
            millisecond: 86400000 * 91
          },
          'month': {
            year: 1 / 12,
            quarter: 1 / 3,
            month: 1,
            week: 4,
            day: -30,
            hour: -24 * 30,
            minute: -1440 * 30,
            second: -86400 * 30,
            millisecond: -86400000 * 30
          },
          'week': {
            year: -1 / 52,
            quarter: -1 / 13,
            month: -1 / 4,
            day: 7,
            hour: 168,
            minute: 10080,
            second: 604800,
            millisecond: 604800000
          },
          'day': {
            year: -1 / 365,
            quarter: -1 / 91,
            month: -1 / 30,
            week: 1 / 7,
            hour: 24,
            minute: 1440,
            second: 86400,
            millisecond: 86400000
          },
          'hour': {
            year: -1 / (365 * 24),
            quarter: -1 / (91 * 24),
            month: -1 / (30 * 24),
            week: 1 / 168,
            day: 1 / 24,
            minute: 60,
            second: 3600,
            millisecond: 3600000
          },
          'minute': {
            year: -1 / (365 * 1440),
            quarter: -1 / (91 * 1440),
            month: -1 / (30 * 1440),
            week: 1 / 10080,
            day: 1 / 1440,
            hour: 1 / 60,
            second: 60,
            millisecond: 60000
          },
          'second': {
            year: -1 / (365 * 86400),
            quarter: -1 / (91 * 86400),
            month: -1 / (30 * 86400),
            week: 1 / 604800,
            day: 1 / 86400,
            hour: 1 / 3600,
            minute: 1 / 60,
            millisecond: 1000
          },
          'millisecond': {
            year: -1 / (365 * 86400000),
            quarter: -1 / (91 * 86400000),
            month: -1 / (30 * 86400000),
            week: 1 / 604800000,
            day: 1 / 86400000,
            hour: 1 / 3600000,
            minute: 1 / 60000,
            second: 1 / 1000
          }
        },
            normalizedUnits = {
          'ms': 'millisecond',
          'milliseconds': 'millisecond',
          's': 'second',
          'seconds': 'second',
          'm': 'minute',
          'minutes': 'minute',
          'h': 'hour',
          'hours': 'hour',
          'd': 'day',
          'days': 'day',
          'w': 'week',
          'weeks': 'week',
          'M': 'month',
          'months': 'month',
          'q': 'quarter',
          'quarters': 'quarter',
          'y': 'year',
          'years': 'year'
        },
            withDecimalsDurationRegex = /^\s*([-+]?\d+(?:[.,]\d*)?|[-+]?(?:[.,]\d+))\s*([^\s]+)?/i,
            noDecimalsDurationRegex = /^\s*([-+]?\d+)(?![.,])\s*([^\s]+)?/i,
            canonicalUnitNames = ['millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'],
            deltaUnits = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'],
            // Used when creating a date from an object, to fill in any blanks
        dateProperties = ['milliseconds', 'seconds', 'minutes', 'hours', 'date', 'month', 'year'],
            // TODO: Should we provide special number parsing?
        parseNumber = function parseNumber(n) {
          var result = parseFloat(n);
          return isNaN(result) ? null : result;
        },
            timeZoneRegEx = /([+-])(\d\d):*(\d\d)*$/,
            unitMagnitudes = {
          millisecond: 0,
          second: 1,
          minute: 2,
          hour: 3,
          day: 4,
          week: 5,
          month: 6,
          quarter: 7,
          year: 8
        };
        /**
         * @module Common/helper/DateHelper
         */

        /**
         * Helps with date manipulation, comparison, parsing, formatting etc.
         *
         * ## Parsing strings
         * Use DateHelper.parse() to parse strings into dates. It accepts a date string and a format specifier.
         * The format specifier is string built up using the following tokens:
         *
         * | Unit        | Token | Description                |
         * |-------------|-------|----------------------------|
         * | Year        | YYYY  | 2018                       |
         * |             | YY    | < 68 -> 2000, > 68 -> 1900 |
         * | Month       | MM    | 01 - 12                    |
         * | Date        | DD    | 01 - 31                    |
         * | Hour        | HH    | 00 - 23 or 1 - 12          |
         * | Minute      | mm    | 00 - 59                    |
         * | Second      | ss    | 00 - 59                    |
         * | Millisecond | S     | 0 - 9                      |
         * |             | SS    | 00 - 99                    |
         * |             | SSS   | 000 - 999                  |
         * | AM/PM       | A     | AM or PM                   |
         * |             | a     | am or pm                   |
         * | TimeZone    | Z     | Z for UTC or +-HH:mm       |
         * | Predefined  | L     | Long date, MM/DD/YYYY      |
         * |             | LT    | Long time, HH:mm A         |
         *
         * For example:
         * ```
         * DateHelper.parse('2018-11-06', 'YYYY-MM-DD');
         * DateHelper.parse('13:14', 'HH:mm');
         * DateHelper.parse('6/11/18', 'DD/MM/YY');
         * ```
         *
         * ## Formatting dates
         * Use DateHelper.format() to create a string from a date using a format specifier. The format specifier is similar to
         * that used when parsing strings. It can use the following tokens (input used for output below is
         * `new Date(2018,8,9,18,7,8,145)`):
         *
         * | Unit                  | Token | Description & output                  |
         * |-----------------------|-------|---------------------------------------|
         * | Year                  | YYYY  | 2018                                  |
         * |                       | YY    | 18                                    |
         * |                       | Y     | 2018                                  |
         * | Quarter               | Q     | 3                                     |
         * |                       | Qo    | 3rd                                   |
         * | Month                 | MMMM  | September                             |
         * |                       | MMM   | Sep                                   |
         * |                       | MM    | 09                                    |
         * |                       | Mo    | 9th                                   |
         * |                       | M     | 9                                     |
         * | Week (iso)            | WW    | 36 (2 digit)                          |
         * |                       | Wo    | 36th                                  |
         * |                       | W     | 36                                    |
         * | Date                  | DDDD  | Day of year, 3 digits                 |
         * |                       | DDDo  | Day of year, ordinal                  |
         * |                       | DDD   | Day of year                           |
         * |                       | DD    | 09                                    |
         * |                       | Do    | 9th                                   |
         * |                       | D     | 9                                     |
         * | Weekday               | dddd  | Sunday                                |
         * |                       | ddd   | Sun                                   |
         * |                       | dd    | Su                                    |
         * |                       | do    | 0th                                   |
         * |                       | d     | 0                                     |
         * | Hour                  | HH    | 18 (00 - 23)                          |
         * |                       | H     | 18 (0 - 23)                           |
         * |                       | hh    | 06 (00 - 12)                          |
         * |                       | h     | 6 (0 - 12)                            |
         * |                       | KK    | 19 (01 - 24)                          |
         * |                       | K     | 19 (1 - 24)                           |
         * |                       | kk    | 06 or 18, locale determines           |
         * |                       | k     | 6 or 18, locale determines            |
         * | Minute                | mm    | 07                                    |
         * |                       | m     | 7                                     |
         * | Second                | ss    | 08                                    |
         * |                       | s     | 8                                     |
         * | Millisecond           | S     | 1                                     |
         * |                       | SS    | 14                                    |
         * |                       | SSS   | 145                                   |
         * | AM/PM                 | A     | AM or PM                              |
         * |                       | a     | am or pm                              |
         * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
         * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
         * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
         * |                       | l     | Y: n, M : n, D : n                    |
         * |                       | LL    | Y: n, M : long (l), D : n             |
         * |                       | ll    | Y: n, M : short (s), D : n            |
         * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
         * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
         * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
         * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
         *
         * For example:
         *
         * ```
         * DateHelper.format(new Date(2018,10,6), 'YYYY-MM-DD'); // 2018-11-06
         * DateHelper.format(new Date(2018,10,6), 'M/D/YY'); // 11/6/18
         * ```
         *
         * Arbitrary text can be embedded in the format string by wrapping it with {}:
         *
         * ```
         * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
         * ```
         *
         * ## Unit names
         * Many DateHelper functions (for example add, as, set) accepts a unit among their params. The following units are
         * available:
         *
         * | Unit        | Aliases                       |
         * |-------------|-------------------------------|
         * | millisecond | millisecond, milliseconds, ms |
         * | second      | second, seconds, s            |
         * | minute      | minute, minutes, m            |
         * | hour        | hour, hours, h                |
         * | day         | day, days, d                  |
         * | week        | week, weeks, w                |
         * | month       | month, months, M              |
         * | quarter     | quarter, quarters, q          |
         * | year        | year, years, y                |
         *
         * For example:
         * ```
         * DateHelper.add(date, 2, 'days');
         * DateHelper.as('hour', 7200, 'seconds');
         * ```
         */


        var DateHelper =
        /*#__PURE__*/
        function (_Localizable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(DateHelper, _Localizable);

          function DateHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, DateHelper);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_12___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(DateHelper).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(DateHelper, [{
            key: "formatContainsHourInfo",
            value: function formatContainsHourInfo(format) {
              return format.match(/[Hhk]/);
            }
            /**
             * Returns true for 24 hour format.
             * @param {String} format Date format
             * @returns {Boolean}
             * @category Parse & format
             */

          }], [{
            key: "buildParser",
            //region Parse & format
            value: function buildParser(format) {
              var _this = this; // Split input format by regexp, which includes predefined patterns. Normally format would have some
              // splitters, like 'YYYY-MM-DD' or 'D/M YYYY' so output will contain matched patterns as well as splitters
              // which would serve as anchors. E.g. provided format is 'D/M!YYYY' and input is `11/6!2019` algorithm would work like:
              // 1. split format by regexp                // ['', 'D', '/', 'M', '!', 'YYYY', '']
              // 2. find splitters                        // ['/', '!']
              // 3. split input by seps, step by step     // ['11', ['6', ['2019']]]
              //
              // Inputs like 'YYYYY' (YYYY + Y) are kinda invalid, need to figure smth when
              // we encounter them.


              var parts = format.split(parserRegexp),
                  parser = []; // if length of the parts array is 1 - there are no regexps in the input string. thus - no parsers
              // do same if there are patterns matching locale strings (l, ll, LLLL etc.)
              // returning empty array to use new Date() as parser

              if (parts.length === 1 || localeStrRegExp.test(format)) {
                return [];
              } else {
                parts.reduce(function (prev, curr, index, array) {
                  // ignore first and last empty string
                  if (index !== 0 || curr !== '') {
                    // if current element matches parser regexp store it as a parser
                    if (parserRegexp.test(curr)) {
                      var localeParsers = _this.L('parsers') !== 'parsers' && _this.L('parsers') || {},
                          fn = localeParsers[curr] || parsers[curr]; // Z should be last element in the string that matches regexp. Last array element is always either
                      // an empty string (if format ends with Z) or splitter (everything that doesn't match regexp after Z)
                      // If there is a pattern after Z, then Z index will be lower than length - 2

                      if (curr === 'Z' && index < array.length - 2) {
                        throw new Error("Invalid format ".concat(format, " TimeZone (Z) must be last token"));
                      } // If fn is a string, we found an alias (L, LLL, l etc.).
                      // Need to build parsers from mapped format and merge with existing


                      if (typeof fn === 'string') {
                        // we are going to merge nested parsers with current, some cleanup required:
                        // 1. last element is no longer last
                        // 2. need to pass last parser to the next step
                        var nestedParsers = DateHelper.buildParser(fn),
                            lastItem = nestedParsers.pop();
                        delete lastItem.last; // elevate nested parsers

                        parser.push.apply(parser, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_7___default()(nestedParsers));
                        prev = lastItem;
                      } else {
                        prev.pattern = curr;
                        prev.fn = parsers[curr];
                      }
                    } // if it doesn't match - we've found a splitter
                    else {
                        prev.splitter = curr;
                        parser.push(prev);
                        prev = {};
                      }
                  } else if (prev.hasOwnProperty('pattern')) {
                    parser.push(prev);
                  }

                  return prev;
                }, {});
              }

              parser[parser.length - 1].last = true;
              return parser;
            }
            /**
             * Returns a date created from the supplied string using the specified format. Will try to create even if format
             * is left out, by first using the default format (YYYY-MM-DDTHH:mm:ssZ) and then using `new Date(dateString)`.
             * Supported tokens:
             *
             * | Unit        | Token | Description                |
             * |-------------|-------|----------------------------|
             * | Year        | YYYY  | 2018                       |
             * |             | YY    | < 68 -> 2000, > 68 -> 1900 |
             * | Month       | MM    | 01 - 12                    |
             * | Date        | DD    | 01 - 31                    |
             * | Hour        | HH    | 00 - 23 or 1 - 12          |
             * | Minute      | mm    | 00 - 59                    |
             * | Second      | ss    | 00 - 59                    |
             * | Millisecond | S     | 0 - 9                      |
             * |             | SS    | 00 - 99                    |
             * |             | SSS   | 000 - 999                  |
             * | AM/PM       | A     | AM or PM                   |
             * |             | a     | am or pm                   |
             * | TimeZone    | Z     | Z for UTC or +-HH:mm       |
             * | Predefined  | L     | Long date, MM/DD/YYYY      |
             * |             | LT    | Long time, HH:mm A         |
             *
             * Predefined formats and functions used to parse tokens can be localized, see for example the swedish locale SvSE.js
             *
             * @param {String} dateString Date string
             * @param {String} format Date format
             * @returns {Date}
             * @category Parse & format
             */

          }, {
            key: "parse",
            value: function parse(dateString) {
              var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFormat;

              if (!dateString) {
                return null;
              }

              if (dateString instanceof Date) {
                return dateString;
              } // // For ISO 8601 native is faster, but not very forgiving
              // if (format === defaultFormat) {
              //     const dt = new Date(dateString);
              //     if (!isNaN(dt)) {
              //         return dt;
              //     }
              // }


              var config = {
                year: 0,
                month: 0,
                date: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
                milliseconds: 0
              },
                  parser = parserCache[format],
                  result;

              if (!parser) {
                parser = parserCache[format] = DateHelper.buildParser(format);
              } // Each parser knows its pattern and splitter. It looks for splitter in the
              // input string, takes first substring and tries to process it. Remaining string
              // is passed to the next parser.


              parser.reduce(function (dateString, parser) {
                if (parser.last) {
                  Object.assign(config, parser.fn(dateString));
                } else {
                  var splitAt; // ISO 8601 says that T symbol can be replaced with a space

                  if (parser.splitter === 'T' && dateString.indexOf('T') === -1) {
                    splitAt = dateString.indexOf(' ');
                  } else {
                    splitAt = dateString.indexOf(parser.splitter);
                  }

                  var part, rest; // If splitter is not found in the current string we may be dealing with
                  // 1. partial input - in that case we just feed all string to current parser and move on
                  // 2. time zone (ssZ - splitter is empty string), see comment below

                  if (splitAt === -1 || parser.splitter === '') {
                    // NOTE: parantheses are required here as + and - signs hold valuable information
                    // with parantheses we get array like ['00','+','01:00'], omitting them we won't get
                    // regexp match in result, loosing information
                    var chunks = dateString.split(/([Z\-+])/); // If splitter is not found in the string, we may be dealing with string that contains info about TZ.
                    // For instance, if format contains Z as last arg which is not separated (normally it is not indeed),
                    // like `YYYY-MM-DD HH:mm:ssZ`, then second to last parser will have string that it cannot just parse, like
                    // '2010-01-01 10:00:00'        -> '00'
                    // '2010-01-01 10:00:00Z'       -> '00Z'
                    // '2010-01-01 10:00:00-01'     -> '00-01'
                    // '2010-01-01 10:00:00+01:30'  -> '00+01:30'
                    // this cannot be processed by date parsers, so we need to process that additionally. So we
                    // split string by symbols that can be found around timezone info: Z,-,+

                    if (chunks.length === 1) {
                      part = dateString;
                      rest = '';
                    } else {
                      part = chunks[0];
                      rest = "".concat(chunks[1]).concat(chunks[2]);
                    }
                  } else {
                    part = dateString.substring(0, splitAt) || dateString;
                    rest = dateString.substring(splitAt + parser.splitter.length);
                  }

                  parser.fn && Object.assign(config, parser.fn(part));
                  return rest;
                }
              }, dateString);
              var date = this.create(config);

              if (date) {
                result = date;
              } else {
                // Last resort, try if native passing can do it
                result = new Date(dateString);
              }

              return result;
            }
            /**
             * Creates a date from a date definition object. The object can have the following properties:
             * - year
             * - month
             * - date (day in month)
             * - hours
             * - minutes
             * - seconds
             * - milliseconds
             * - amPm : 'am' or 'pm', implies 12 hour clock
             * - timeZone : offset from UTC in minutes
             * @param {Object} definition
             * @returns {Date}
             * @category Parse & format
             */

          }, {
            key: "create",
            value: function create(definition) {
              // Shallow clone to not alter input
              var def = Object.assign({}, definition); // Not much validation yet, only considered invalid if all properties are 0

              var invalid = true,
                  useUTC = false; // Fill in blanks and replace any NaN with 0

              dateProperties.forEach(function (property) {
                if (!(property in def) || isNaN(def[property])) {
                  def[property] = 0;
                }

                if (def[property] > 0) invalid = false;
              });

              if (def.amPm === 'pm') {
                def.hours = def.hours % 12 + 12;
              }

              if ('timeZone' in def) {
                useUTC = true;
                def.minutes -= def.timeZone;
              }

              if (invalid) {
                return null;
              }

              var args = [def.year, def.month, def.date, def.hours, def.minutes, def.seconds, def.milliseconds];
              return useUTC ? new Date(Date.UTC.apply(Date, args)) : _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_5___default()(Date, args);
            }
            /**
             * Converts a date to string with the specified format. Formats heavily inspired by https://momentjs.com.
             * Available formats (input used for output below is `new Date(2018,8,9,18,7,8,145)`):
             *
             * | Unit                  | Token | Description & output                  |
             * |-----------------------|-------|---------------------------------------|
             * | Year                  | YYYY  | 2018                                  |
             * |                       | YY    | 18                                    |
             * |                       | Y     | 2018                                  |
             * | Quarter               | Q     | 3                                     |
             * |                       | Qo    | 3rd                                   |
             * | Month                 | MMMM  | September                             |
             * |                       | MMM   | Sep                                   |
             * |                       | MM    | 09                                    |
             * |                       | Mo    | 9th                                   |
             * |                       | M     | 9                                     |
             * | Week (iso)            | WW    | 36 (2 digit)                          |
             * |                       | Wo    | 36th                                  |
             * |                       | W     | 36                                    |
             * | Date                  | DDDD  | Day of year, 3 digits                 |
             * |                       | DDDo  | Day of year, ordinal                  |
             * |                       | DDD   | Day of year                           |
             * |                       | DD    | 09                                    |
             * |                       | Do    | 9th                                   |
             * |                       | D     | 9                                     |
             * | Weekday               | dddd  | Sunday                                |
             * |                       | ddd   | Sun                                   |
             * |                       | dd    | Su                                    |
             * |                       | do    | 0th                                   |
             * |                       | d     | 0                                     |
             * | Hour                  | HH    | 18 (00 - 23)                          |
             * |                       | H     | 18 (0 - 23)                           |
             * |                       | hh    | 06 (00 - 12)                          |
             * |                       | h     | 6 (0 - 12)                            |
             * |                       | KK    | 19 (01 - 24)                          |
             * |                       | K     | 19 (1 - 24)                           |
             * |                       | kk    | 06 or 18, locale determines           |
             * |                       | k     | 6 or 18, locale determines            |
             * | Minute                | mm    | 07                                    |
             * |                       | m     | 7                                     |
             * | Second                | ss    | 08                                    |
             * |                       | s     | 8                                     |
             * | Millisecond           | S     | 1                                     |
             * |                       | SS    | 14                                    |
             * |                       | SSS   | 145                                   |
             * | AM/PM                 | A     | AM or PM                              |
             * |                       | a     | am or pm                              |
             * | Predefined            | LT    | H: 2-digit (2d), m: 2d                |
             * | (uses browser locale) | LTS   | H: 2d, m: 2d, s : 2d                  |
             * |                       | L     | Y: numeric (n), M : 2d, D : 2d        |
             * |                       | l     | Y: n, M : n, D : n                    |
             * |                       | LL    | Y: n, M : long (l), D : n             |
             * |                       | ll    | Y: n, M : short (s), D : n            |
             * |                       | LLL   | Y: n, M : l, D : n, H: n, m: 2d       |
             * |                       | lll   | Y: n, M : s, D : n, H: n, m: 2d       |
             * |                       | LLLL  | Y: n, M : l, D : n, H: n, m: 2d, d: l |
             * |                       | llll  | Y: n, M : s, D : n, H: n, m: 2d, d: s |
             *
             * Some examples:
             *
             * ```
             * DateHelper.format(new Date(2019, 7, 16), 'dddd') -> Friday
             * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'HH:mm') --> 14:27
             * DateHelper.format(new Date(2019, 7, 16, 14, 27), 'L HH') --> 2019-07-16 14
             * ```
             *
             * Arbitrary text can be embedded in the format string by wrapping it with {}:
             *
             * ```
             * DateHelper.format(new Date(2019, 7, 16), '{It is }dddd{, yay!}') -> It is Friday, yay!
             * ```
             *
             * @param {Date} date Date
             * @param {String} format Desired format
             * @returns {String} Formatted string
             * @category Parse & format
             */

          }, {
            key: "format",
            value: function format(date) {
              var _format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFormat;

              if (!date) {
                return null;
              }

              var formatter = formatCache[_format],
                  output = '';

              if (!formatter) {
                formatter = formatCache[_format] = []; // Build formatter array with the steps needed to format the date

                for (var i = 0; i < _format.length; i++) {
                  // Matches a predefined format?
                  var formatMatch = _format.substr(i).match(formatRegexp),
                      predefined = formatMatch && formatMatch[0];

                  if (predefined) {
                    var localeFormats = this.L('formats') !== 'formats' && this.L('formats') || {},
                        fn = localeFormats[predefined] || formats[predefined];
                    formatter.push(fn);
                    i += predefined.length - 1;
                  } // Start of text block? Append it
                  else if (_format[i] === '{') {
                      // Find closing brace
                      var index = _format.indexOf('}', i + 1); // No closing brace, grab rest of string


                      if (index === -1) {
                        formatter.push(_format.substr(i + 1));
                        i = _format.length;
                      } // Closing brace found
                      else {
                          formatter.push(_format.substring(i + 1, index)); // Carry on after closing brace

                          i = index;
                        }
                    } // Otherwise append to output (for example - / : etc)
                    else {
                        formatter.push(_format[i]);
                      }
                }
              }

              formatter.forEach(function (step) {
                if (typeof step === 'string') {
                  output += step;
                } else {
                  output += step(date);
                }
              }); // MS inserts a Left-to-right control char between localized date parts, remove it to have the expected string
              // output. Otherwise comparision with typed strings will fail

              if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].isIE11) {
                output = output.replace(/\u200E/g, '');
              }

              return output;
            }
            /**
             * Converts the specified amount of desired unit into milliseconds. Can be called by only specifying a unit as the
             * first argument, it then uses amount = 1. For example: asMilliseconds('hour') == asMilliseconds(1, 'hour')
             * @param {Number/String} amount Amount, what of is decided by specifying unit (also takes a unit which implies an amount of 1)
             * @param {String} unit Time unit (s, hour, months etc.)
             * @returns {Number}
             * @category Parse & format
             */

          }, {
            key: "asMilliseconds",
            value: function asMilliseconds(amount) {
              var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

              if (typeof amount === 'string') {
                unit = amount;
                amount = 1;
              }

              return this.as('millisecond', amount, unit);
            }
            /**
             * Converts a millisecond time delta to a human readable form. For example `1000 * 60 * 60 * 50`
             * milliseconds would be rendered as "2 days, 2 hours"
             * @param {Number} delta The millisecond delta value.
             * @param {Boolean} [abbrev] Pass `true` to use abbreviated unit names, eg "2d, 2h" for the above example.
             */

          }, {
            key: "formatDelta",
            value: function formatDelta(delta) {
              var abbrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var result = [],
                  getUnit = abbrev ? this.getShortNameOfUnit : this.getLocalizedNameOfUnit,
                  sep = abbrev ? '' : ' '; // Loop downwards through the magnitude of units from year -> ms

              for (var _i = 0; _i < deltaUnits.length; _i++) {
                var unitName = deltaUnits[_i];
                var d = Math.floor(this.as(unitName, delta)); // If there's a non-zero integer quantity of this unit, add it to result
                // and subtract from the delta, then go round to next unit down.

                if (d) {
                  result.push("".concat(d).concat(sep).concat(getUnit.call(this, unitName, d > 1)));
                  delta -= this.as('ms', d, unitName);
                }

                if (!delta) {
                  break;
                }
              }

              return result.join(', ');
            }
            /**
             * Converts the specified amount of one unit (fromUnit) into an amount of another unit (toUnit)
             * @param toUnit
             * @param amount
             * @param fromUnit
             * @returns {Number}
             * @category Parse & format
             */

          }, {
            key: "as",
            value: function as(toUnit, amount) {
              var fromUnit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ms';
              if (toUnit === fromUnit) return amount;
              toUnit = this.normalizeUnit(toUnit);
              fromUnit = this.normalizeUnit(fromUnit); // validConversions[][] can be negative to signal that conversion is not exact, ignore sign here

              if (unitMagnitudes[fromUnit] > unitMagnitudes[toUnit]) {
                return amount * Math.abs(validConversions[fromUnit][toUnit]);
              } else {
                return amount / Math.abs(validConversions[toUnit][fromUnit]);
              }
            }
          }, {
            key: "is24HourFormat",
            value: function is24HourFormat(format) {
              return this.format(new Date(1970, 0, 0, 13, 0, 0), format).includes('13');
            } //endregion
            //region Manipulate

            /**
             * Add days, hours etc. to a date. Always clones the date, original will be left unaffected.
             * @param {Date} date Original date
             * @param {Number} amount Amount of days, hours etc
             * @param {String} unit Unit for amount
             * @returns {Date} New calculated date
             * @category Manipulate
             */

          }, {
            key: "add",
            value: function add(date, amount) {
              var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ms';
              var me = this;
              var d;

              if (typeof date === 'string') {
                d = me.parse(date);
              } else {
                d = new Date(date.getTime());
              }

              if (!unit || amount === 0) return d;
              unit = DateHelper.normalizeUnit(unit);

              switch (unit) {
                case 'millisecond':
                  d = new Date(d.getTime() + amount);
                  break;

                case 'second':
                  d = new Date(d.getTime() + amount * 1000);
                  break;

                case 'minute':
                  d = new Date(d.getTime() + amount * 60000);
                  break;

                case 'hour':
                  d = new Date(d.getTime() + amount * 3600000);
                  break;

                case 'day':
                  // Integer value added, do calendar calculation to correctly handle DST etc.
                  if (amount % 1 === 0) {
                    d.setDate(d.getDate() + amount);
                  } // No browsers support fractional values for dates any longer, do time based calculation
                  else {
                      d = new Date(d.getTime() + amount * 86400000);
                    }

                  if (d.getHours() === 23 && d.getHours() === 0) {
                    d = me.add(d, 1, 'hour');
                  }

                  break;

                case 'week':
                  d.setDate(d.getDate() + amount * 7);
                  break;

                case 'month':
                  var day = d.getDate();

                  if (day > 28) {
                    day = Math.min(day, me.getLastDateOfMonth(me.add(me.getFirstDateOfMonth(d), amount, 'month')).getDate());
                  }

                  d.setDate(day);
                  d.setMonth(d.getMonth() + amount);
                  break;

                case 'quarter':
                  d = me.add(d, amount * 3, 'month');
                  break;

                case 'year':
                  d.setFullYear(d.getFullYear() + amount);
                  break;
              }

              return d;
            }
            /**
             * Calculates the difference between two dates, in the specified unit.
             * @param {Date} start First date
             * @param {Date} end Second date
             * @param {String} unit Unit to calculate difference in
             * @param {Boolean} fractional Specify false to round result
             * @returns {Number} Difference in the specified unit
             * @category Manipulate
             */

          }, {
            key: "diff",
            value: function diff(start, end) {
              var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ms';
              var fractional = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
              unit = DateHelper.normalizeUnit(unit);
              if (!start || !end) return 0;
              var amount;

              switch (unit) {
                case 'year':
                  amount = this.diff(start, end, 'month') / 12;
                  break;

                case 'quarter':
                  amount = this.diff(start, end, 'month') / 3;
                  break;

                case 'month':
                  amount = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
                  break;

                case 'week':
                  amount = this.diff(start, end, 'day') / 7;
                  break;

                case 'day':
                  var dstDiff = start.getTimezoneOffset() - end.getTimezoneOffset();
                  amount = (end - start + dstDiff * 60 * 1000) / 86400000;
                  break;

                case 'hour':
                  amount = (end - start) / 3600000;
                  break;

                case 'minute':
                  amount = (end - start) / 60000;
                  break;

                case 'second':
                  amount = (end - start) / 1000;
                  break;

                case 'millisecond':
                  amount = end - start;
                  break;
              }

              return fractional ? amount : Math.round(amount);
            }
            /**
             * Sets the date to the start of the specified unit, by default returning a clone of the date instead of changing it
             * inplace.
             * @param {Date} date Original date
             * @param {String} unit Start of this unit, 'day', 'month' etc.
             * @param {Boolean} clone Manipulate a copy of the date
             * @returns {Date} Manipulated date
             * @category Manipulate
             */

          }, {
            key: "startOf",
            value: function startOf(date) {
              var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'day';
              var clone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

              if (!date) {
                return null;
              }

              unit = this.normalizeUnit(unit);
              if (clone) date = this.clone(date);
              var toSet = {},
                  index = canonicalUnitNames.indexOf(unit);

              for (var i = 0; i < index; i++) {
                var currentUnit = canonicalUnitNames[i]; // Week and quarter are not part of the date

                if (currentUnit !== 'quarter' && currentUnit !== 'week') {
                  toSet[currentUnit] = currentUnit === 'day' ? 1 : 0; // day is 1 based
                }
              } // Special handling of quarter and week


              if (unit === 'quarter') {
                toSet.month = (this.get(date, 'quarter') - 1) * 3;
              } else if (unit === 'week') {
                var delta = date.getDay() - this.weekStartDay;
                toSet.day = date.getDate() - delta;
              }

              return this.set(date, toSet);
            }
            /**
             * Creates a clone of the specified date
             * @param {Date} date Original date
             * @returns {Date} Cloned date
             * @category Manipulate
             */

          }, {
            key: "clone",
            value: function clone(date) {
              return new Date(date.getTime());
            }
            /**
             * Removes time from a date (same as calling #startOf(date, 'day'))
             * @param {Date} date Date to remove time from
             * @param {Boolean} clone Manipulate a copy of the date
             * @returns {Date} Manipulated date
             * @category Manipulate
             */

          }, {
            key: "clearTime",
            value: function clearTime(date) {
              var clone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              return DateHelper.startOf(date, 'day', clone);
            }
            /**
             * Sets a part of a date (in place)
             * @param {Date} date Date to manipulate
             * @param {String|Object} unit Part of date to set, for example 'minute'. Or an object like { second: 1, minute: 1 }
             * @param {Number} amount Value to set
             * @returns {Date} Modified date
             * @category Manipulate
             */

          }, {
            key: "set",
            value: function set(date, unit, amount) {
              var _this2 = this;

              if (!unit) {
                return date;
              }

              if (typeof unit === 'string') {
                switch (this.normalizeUnit(unit)) {
                  case 'millisecond':
                    // Setting value to 0 when it is 0 at DST crossing messes it up
                    if (amount !== 0 || date.getMilliseconds() > 0) {
                      date.setMilliseconds(amount);
                    }

                    break;

                  case 'second':
                    // Setting value to 0 when it is 0 at DST crossing messes it up
                    if (amount !== 0 || date.getSeconds() > 0) {
                      date.setSeconds(amount);
                    }

                    break;

                  case 'minute':
                    // Setting value to 0 when it is 0 at DST crossing messes it up
                    if (amount !== 0 || date.getMinutes() > 0) {
                      date.setMinutes(amount);
                    }

                    break;

                  case 'hour':
                    date.setHours(amount);
                    break;

                  case 'day':
                  case 'date':
                    date.setDate(amount);
                    break;

                  case 'week':
                    throw new Error('week not implemented');

                  case 'month':
                    date.setMonth(amount);
                    break;

                  case 'quarter':
                    // Setting quarter = first day of first month of that quarter
                    date.setDate(1);
                    date.setMonth((amount - 1) * 3);
                    break;

                  case 'year':
                    date.setFullYear(amount);
                    break;
                }
              } else {
                Object.entries(unit) // Make sure smallest unit goes first, to not change month before changing day
                .sort(function (a, b) {
                  return canonicalUnitNames.indexOf(a[0]) - canonicalUnitNames.indexOf(b[0]);
                }).forEach(function (_ref) {
                  var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_ref, 2),
                      unit = _ref2[0],
                      amount = _ref2[1];

                  _this2.set(date, unit, amount);
                });
              }

              return date;
            }
            /**
             * Constrains the date within a min and a max date
             * @param {Date} date The date to constrain
             * @param {Date} min Min date
             * @param {Date} max Max date
             * @return {Date} The constrained date
             * @category Manipulate
             */

          }, {
            key: "constrain",
            value: function constrain(date, min, max) {
              return this.min(this.max(date, min), max);
            }
            /**
             * Returns time only (same as calling new Date(1970, 0, 1, hours, minutes, seconds))
             * @param {Number} hours Hours value
             * @param {Number} minutes Minutes value
             * @param {Number} seconds Seconds value
             * @returns {Date} Date value for input hours, minutes, seconds parameters
             * @category Manipulate
             */

          }, {
            key: "getTime",
            value: function getTime(hours) {
              var minutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var seconds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
              return new Date(1970, 0, 1, hours, minutes, seconds);
            } //endregion
            //region Comparison

          }, {
            key: "isDST",
            value: function isDST(date) {
              // from https://stackoverflow.com/questions/11887934/how-to-check-if-the-dst-daylight-saving-time-is-in-effect-and-if-it-is-whats
              var jan = new Date(date.getFullYear(), 0, 1),
                  jul = new Date(date.getFullYear(), 6, 1);
              return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
            }
            /**
             * Determines if a date precedes another.
             * @param first First date
             * @param second Second date
             * @returns {Boolean} true if first precedes second, otherwise false
             * @category Comparison
             */

          }, {
            key: "isBefore",
            value: function isBefore(first, second) {
              return first < second;
            }
            /**
             * Determines if a date succeeds another.
             * @param first First date
             * @param second Second date
             * @returns {Boolean} true if first succeeds second, otherwise false
             * @category Comparison
             */

          }, {
            key: "isAfter",
            value: function isAfter(first, second) {
              return first > second;
            }
            /**
             * Checks if two dates are equal.
             * @param first First date
             * @param second Second date
             * @param unit If not given, the comparison will be done up to a millisecond
             * @returns {Boolean} true if the dates are equal
             * @category Comparison
             */

          }, {
            key: "isEqual",
            value: function isEqual(first, second) {
              var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              if (unit === null) return first - second === 0;
              return this.startOf(first, unit) - this.startOf(second, unit) === 0;
            }
            /**
             * Compares two dates using the specified precision
             * @param {Date} first
             * @param {Date} second
             * @param {String} unit
             * @returns {Number} 0 = equal, -1 first before second, 1 first after second
             * @category Comparison
             */

          }, {
            key: "compare",
            value: function compare(first, second) {
              var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var DH = this; // Unit specified, cut the rest out

              if (unit) {
                first = DH.startOf(first, unit);
                second = DH.startOf(second, unit);
              } // Comparision on ms level


              if (DH.isBefore(first, second)) return -1;
              if (DH.isAfter(first, second)) return 1;
              return 0;
            }
            /**
             * Checks if date is the start of specified unit
             * @param {Date} date
             * @param {String} unit
             * @returns {Boolean}
             * @category Comparison
             */

          }, {
            key: "isStartOf",
            value: function isStartOf(date, unit) {
              return this.isEqual(date, this.startOf(date, unit));
            }
            /**
             * Checks if this date is >= start and < end.
             * @param {Date} date The source date
             * @param {Date} start Start date
             * @param {Date} end End date
             * @return {Boolean} true if this date falls on or between the given start and end dates.
             * @category Comparison
             */

          }, {
            key: "betweenLesser",
            value: function betweenLesser(date, start, end) {
              //return start <= date && date < end;
              return start.getTime() <= date.getTime() && date.getTime() < end.getTime();
            }
            /**
             * Checks if this date is >= start and <= end.
             * @param {Date} date The source date
             * @param {Date} start Start date
             * @param {Date} end End date
             * @return {Boolean} true if this date falls on or between the given start and end dates.
             * @category Comparison
             */

          }, {
            key: "betweenLesserEqual",
            value: function betweenLesserEqual(date, start, end) {
              return start.getTime() <= date.getTime() && date.getTime() <= end.getTime();
            }
            /**
             * Returns true if dates intersect
             * @param {Date} date1Start
             * @param {Date} date1End
             * @param {Date} date2Start
             * @param {Date} date2End
             * @return {Boolean} Returns true if dates intersect
             * @category Comparison
             */

          }, {
            key: "intersectSpans",
            value: function intersectSpans(date1Start, date1End, date2Start, date2End) {
              return this.betweenLesser(date1Start, date2Start, date2End) || this.betweenLesser(date2Start, date1Start, date1End);
            }
            /**
             * Returns 1 if first param is a greater unit than second param, -1 if the opposite is true or 0 if they're equal
             * @param {String} unit1 The 1st unit
             * @param {String} unit2 The 2nd unit
             * @category Comparison
             */

          }, {
            key: "compareUnits",
            value: function compareUnits(unit1, unit2) {
              var index1 = canonicalUnitNames.indexOf(unit1),
                  index2 = canonicalUnitNames.indexOf(unit2);
              return Math.sign(index1 - index2);
            }
            /**
             * Returns true if the first time span completely 'covers' the second time span.
             * @example
             * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 4)) ==> true
             * DateHelper.timeSpanContains(new Date(2010, 1, 2), new Date(2010, 1, 5), new Date(2010, 1, 3), new Date(2010, 1, 6)) ==> false
             * @param {Date} spanStart The start date for initial time span
             * @param {Date} spanEnd The end date for initial time span
             * @param {Date} otherSpanStart The start date for the 2nd time span
             * @param {Date} otherSpanEnd The end date for the 2nd time span
             * @return {Boolean}
             * @category Comparison
             */

          }, {
            key: "timeSpanContains",
            value: function timeSpanContains(spanStart, spanEnd, otherSpanStart, otherSpanEnd) {
              return otherSpanStart - spanStart >= 0 && spanEnd - otherSpanEnd >= 0;
            } //endregion
            //region Query

            /**
             * Get the first day of week, 0-6 (Sunday-Saturday). This is determined by the used locale.
             * @readonly
             */

          }, {
            key: "get",

            /**
             * Get the specified part of a date
             * @param {Date} date
             * @param {String} unit Part of date, hour, minute etc.
             * @category Query
             */
            value: function get(date, unit) {
              switch (this.normalizeUnit(unit)) {
                case 'millisecond':
                  return date.getMilliseconds();

                case 'second':
                  return date.getSeconds();

                case 'minute':
                  return date.getMinutes();

                case 'hour':
                  return date.getHours();

                case 'date':
                case 'day':
                  // Scheduler has a lot of calculations expecting this to work
                  return date.getDate();

                case 'week':
                  return formats.W(date);

                case 'month':
                  return date.getMonth();

                case 'quarter':
                  return Math.floor(date.getMonth() / 3) + 1;

                case 'year':
                  return date.getFullYear();
              }

              return null;
            }
            /**
             * Get number of days in the current month for the supplied date
             * @param {Date} date Date which month should be checked
             * @returns {Number} Days in month
             * @category Query
             */

          }, {
            key: "daysInMonth",
            value: function daysInMonth(date) {
              var d = this.clone(date);
              d.setDate(1);
              d.setMonth(date.getMonth() + 1);
              d.setDate(0);
              return d.getDate();
            }
            /**
             * Get the first date of the month for the supplied date
             * @param {Date} date
             * @returns {Date}
             * @category Query
             */

          }, {
            key: "getFirstDateOfMonth",
            value: function getFirstDateOfMonth(date) {
              return new Date(date.getFullYear(), date.getMonth(), 1);
            }
            /**
             * Get the last date of the month for the supplied date
             * @param {Date} date
             * @returns {Date}
             * @category Query
             */

          }, {
            key: "getLastDateOfMonth",
            value: function getLastDateOfMonth(date) {
              return new Date(date.getFullYear(), date.getMonth() + 1, 0);
            }
            /**
             * Get the earliest of two dates
             * @param {Date} first
             * @param {Date} second
             * @returns {Date} Earliest date
             * @category Query
             */

          }, {
            key: "min",
            value: function min(first, second) {
              return first.getTime() < second.getTime() ? first : second;
            }
            /**
             * Get the latest of two dates
             * @param {Date} first
             * @param {Date} second
             * @returns {Date} Latest date
             * @category Query
             */

          }, {
            key: "max",
            value: function max(first, second) {
              return first.getTime() > second.getTime() ? first : second;
            }
            /**
             * Get an incremented date. Incrementation based on specified unit and optional amount
             * @param {Date} date
             * @param {String} unit
             * @param {Number} [increment]
             * @param {Number} [weekStartDay] Will default to what is set in locale
             * @returns {Date}
             * @category Query
             */

          }, {
            key: "getNext",
            value: function getNext(date, unit) {
              var increment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var weekStartDay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.weekStartDay;
              var me = this;

              if (unit === 'week') {
                var dt = me.clone(date),
                    day = dt.getDay();
                dt = me.startOf(dt, 'day');
                dt = me.add(dt, weekStartDay - day + 7 * (increment - (weekStartDay <= day ? 0 : 1)), 'day'); // For south american timezones, midnight does not exist on DST transitions, adjust...

                if (dt.getDay() !== weekStartDay) me.add(dt, 1, 'hour');
                return dt;
              }

              return me.startOf(me.add(date, increment, unit), unit);
            }
            /**
             * Get the start of the next day
             * @param {Date} date
             * @param {Boolean} clone
             * @param {Boolean} noNeedToClearTime
             * @returns {Date}
             * @category Query
             */

          }, {
            key: "getStartOfNextDay",
            value: function getStartOfNextDay(date, clone, noNeedToClearTime) {
              var nextDay = DateHelper.add(noNeedToClearTime ? date : DateHelper.clearTime(date, clone), 1, 'day'); // DST case

              if (nextDay.getDate() == date.getDate()) {
                var offsetNextDay = DateHelper.add(DateHelper.clearTime(date, clone), 'day', 2).getTimezoneOffset(),
                    offsetDate = date.getTimezoneOffset();
                nextDay = DateHelper.add(nextDay, offsetDate - offsetNextDay, 'minute');
              }

              return nextDay;
            }
            /**
             * Get the end of previous day
             * @param {Date} date
             * @param {Boolean} noNeedToClearTime
             * @returns {Date}
             * @category Query
             */

          }, {
            key: "getEndOfPreviousDay",
            value: function getEndOfPreviousDay(date, noNeedToClearTime) {
              var dateOnly = noNeedToClearTime ? date : DateHelper.clearTime(date, true); // dates are different

              if (dateOnly - date) {
                return dateOnly;
              } else {
                return this.add(dateOnly, -1, 'day');
              }
            } //endregion
            //region Unit helpers

            /**
             * Turns (10, 'day') into '10 days' etc.
             * @param {Number} count Amount of unit
             * @param {String} unit Unit, will be normalizes (days, d -> day etc.)
             * @returns {String}
             * @category Unit helpers
             */

          }, {
            key: "formatCount",
            value: function formatCount(count, unit) {
              unit = DateHelper.normalizeUnit(unit);
              if (count !== 1) unit += 's';
              return count + ' ' + unit;
            }
            /**
             * Get the ratio between two units ( year, month -> 1/12 )
             * @param {String} baseUnit
             * @param {String} unit
             * @param {Boolean} acceptEstimate If true, process negative values of validConversions. Defaults to false.
             * @returns {Number} Ratio
             * @category Unit helpers
             */

          }, {
            key: "getUnitToBaseUnitRatio",
            value: function getUnitToBaseUnitRatio(baseUnit, unit) {
              var acceptEstimate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              baseUnit = DateHelper.normalizeUnit(baseUnit);
              unit = DateHelper.normalizeUnit(unit);
              if (baseUnit === unit) return 1; // Some validConversions have negative sign to signal that it is not an exact conversion.
              // Ignore those here unless acceptEstimate is provided.

              if (validConversions[baseUnit] && validConversions[baseUnit][unit] && (acceptEstimate || validConversions[baseUnit][unit] > 0)) {
                return 1 / DateHelper.as(unit, 1, baseUnit);
              }

              if (validConversions[unit] && validConversions[unit][baseUnit] && (acceptEstimate || validConversions[unit][baseUnit] > 0)) {
                return DateHelper.as(baseUnit, 1, unit);
              }

              return -1;
            }
            /**
             * Get unit suitable to use in calculations (?)
             * @param unit
             * @returns {*}
             * @category Unit helpers
             */

          }, {
            key: "getMeasuringUnit",
            value: function getMeasuringUnit(unit) {
              if (unit === 'week') return 'day';
              return unit;
            }
            /**
             * Returns a localized abbreviated form of the name of the duration unit.
             * For example in the `EN` locale, for `"qrt"` it will return `"q"`.
             * @param {String} unit Duration unit
             * @return {String}
             * @category Unit helpers
             */

          }, {
            key: "getShortNameOfUnit",
            value: function getShortNameOfUnit(unit) {
              var me = this; // Convert abbreviations to the canonical name.
              // See locale file and the applyLocale method below.

              unit = me.parseTimeUnit(unit); // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

              return me.unitLookup[unit].abbrev;
            }
            /**
             * Returns a localized full name of the duration unit.
             * For for example in the `EN` locale, for `"d"` it will return either
             * `"day"` or `"days"`, depending from the `plural` argument
             * @static
             * @param {String} unit Time unit
             * @param {Boolean} plural Whether to return a plural name or singular
             * @return {String}
             * @category Unit helpers
             */

          }, {
            key: "getLocalizedNameOfUnit",
            value: function getLocalizedNameOfUnit(unit, plural) {
              var me = this; // Normalize to not have to have translations for each variation used in code

              unit = me.normalizeUnit(unit); // Convert abbreviations to the canonical name.
              // See locale file and the applyLocale method below.

              unit = me.parseTimeUnit(unit); // unitLookup is keyed by eg 'DAY', 'day', 'MILLISECOND', 'millisecond' etc

              return me.unitLookup[unit][plural ? 'plural' : 'single'];
            }
            /**
             * Normalizes a unit for easier usage in conditionals. For example year, years, y -> year
             * @param {String} unit
             * @returns {String}
             * @category Unit helpers
             */

          }, {
            key: "normalizeUnit",
            value: function normalizeUnit(unit) {
              if (!unit) {
                return null;
              }

              if (unit.toLowerCase() === 'date') {
                return unit.toLowerCase();
              }

              return canonicalUnitNames.includes(unit.toLowerCase()) // Already valid
              ? unit.toLowerCase() // Trying specified case first, since we have both "M" for month and "m" for minute
              : normalizedUnits[unit] || normalizedUnits[unit.toLowerCase()];
            }
          }, {
            key: "getUnitByName",
            value: function getUnitByName(name) {
              // Allow either a canonical name to be passed, or, if that fails, parse it as a localized name or abbreviation.
              return DateHelper.normalizeUnit(name) || DateHelper.normalizeUnit(this.parseTimeUnit(name));
            }
            /**
             * Returns a duration of the timeframe in the given unit.
             * @param {Date} start The start date of the timeframe
             * @param {Date} end The end date of the timeframe
             * @param {String} unit Duration unit
             * @return {Number} The duration in the units
             * @category Unit helpers
             * @ignore
             */

          }, {
            key: "getDurationInUnit",
            value: function getDurationInUnit(start, end, unit, doNotRound) {
              return this.diff(start, end, unit, doNotRound);
            }
            /**
             * Checks if two date units align
             * @private
             * @param {String} majorUnit
             * @param {String} minorUnit
             * @returns {Boolean}
             * @category Unit helpers
             */

          }, {
            key: "doesUnitsAlign",
            value: function doesUnitsAlign(majorUnit, minorUnit) {
              // TODO: probably needs some fleshing out to be generally useful, otherwise move to TimeAxisViewModel?
              // Maybe also use getUnitToBaseUnitRatio() for assertion?
              if (majorUnit !== minorUnit && minorUnit === 'week') return false;
              return true;
            }
          }, {
            key: "getSmallerUnit",
            value: function getSmallerUnit(unit) {
              return canonicalUnitNames[unitMagnitudes[this.normalizeUnit(unit)] - 1] || null;
            }
          }, {
            key: "getLargerUnit",
            value: function getLargerUnit(unit) {
              return canonicalUnitNames[unitMagnitudes[this.normalizeUnit(unit)] + 1] || null;
            } //endregion
            //region Date picker format

            /**
             * Parses a typed duration value according to locale rules.
             *
             * The value is taken to be a string consisting of the numeric magnitude and the units.
             * The units may be a recognised unit abbreviation of this locale or the full local unit name.
             *
             * For example: "2d", "2 d", "2 day", "2 days" will be turned into `{ magnitude : 2, unit : "day" }`
             *
             * **NOTE:** Doesn't work with complex values like "2 days, 2 hours"
             *
             * @param {String} value The value to parse.
             * @param {Boolean} [allowDecimals=true] Decimals are allowed in the magnitude.
             * @param {String} [defaultUnit] Default unit to use if only magnitude passed.
             * @returns {Object} If successfully parsed, the result contains two properties,
             * `magnitude` being a number, and `unit` being the canonical unit name, *NOT*
             * a localized name. If parsing was unsuccessful, `null` is returned.
             * @category Parse & format
             */

          }, {
            key: "parseDuration",
            value: function parseDuration(value) {
              var allowDecimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var defaultUnit = arguments.length > 2 ? arguments[2] : undefined;
              var me = this,
                  durationRegEx = allowDecimals ? withDecimalsDurationRegex : noDecimalsDurationRegex,
                  match = durationRegEx.exec(value);

              if (value == null || !match) {
                return null;
              }

              var magnitude = parseNumber(match[1]),
                  unit = me.parseTimeUnit(match[2]) || defaultUnit;

              if (!unit) {
                return null;
              }

              return {
                magnitude: magnitude,
                unit: unit
              };
            }
            /**
             * Parses a typed unit name, for example `"ms"` or `"hr"` or `"yr"` into the
             * canonical form of the unit name which may be passed to {@link #function-add-static}
             * or {@link #function-diff-static}
             * @param {*} unitName
             * @category Parse & format
             */

          }, {
            key: "parseTimeUnit",
            value: function parseTimeUnit(unitName) {
              // NOTE: In case you get a crash here when running tests, it is caused by missing locale. Build locales
              // using `scripts/build.js locales` to resolve.
              var unitMatch = unitName == null ? null : this.durationRegEx.exec(unitName.toLowerCase());

              if (!unitMatch) {
                return null;
              } // See which group in the unitAbbrRegEx matched match[2]


              for (var unitOrdinal = 0; unitOrdinal < canonicalUnitNames.length; unitOrdinal++) {
                if (unitMatch[unitOrdinal + 1]) {
                  return canonicalUnitNames[unitOrdinal];
                }
              }
            } //endregion

          }, {
            key: "applyLocale",
            value: function applyLocale() {
              var me = this,
                  unitAbbreviations = me.L('unitAbbreviations'),
                  unitNames = me.unitNames = me.L('unitNames'); // This happens when applying an incomplete locale, as done in Localizable.t.js.
              // Invalid usecase, but return to prevent a crash in that test.

              if (unitNames === 'unitNames') {
                return;
              }

              locale = me.L('locale') || 'en-US';

              if (locale === 'en-US') {
                // TODO: Include in En locale instead?
                ordinalSuffix = enOrdinalSuffix;
              } else if (me.L('ordinalSuffix') !== 'ordinalSuffix') {
                ordinalSuffix = me.L('ordinalSuffix');
              }

              formatCache = {};
              parserCache = {};
              intlFormatterCache = {};
              var unitAbbrRegEx = '';
              me.unitLookup = {};

              for (var i = 0; i < unitAbbreviations.length; i++) {
                var a = unitAbbreviations[i],
                    n = unitNames[i];
                n.canonicalUnitName = canonicalUnitNames[i]; // Create a unitLookup object keyed by unit full names
                // both lower and upper case to be able to look up plurals or abbreviations
                // also always include english names, since those are used in sources

                me.unitLookup[n.single] = me.unitLookup[n.single.toUpperCase()] = me.unitLookup[n.canonicalUnitName] = me.unitLookup[n.canonicalUnitName.toUpperCase()] = n;
                unitAbbrRegEx += "".concat(i ? '|' : '', "(");

                for (var j = 0; j < a.length; j++) {
                  unitAbbrRegEx += "".concat(a[j], "|");
                }

                unitAbbrRegEx += "".concat(n.single, "|").concat(n.plural, "|").concat(n.canonicalUnitName, ")");
              }

              me.durationRegEx = new RegExp("^(?:".concat(unitAbbrRegEx, ")$"));
            }
          }, {
            key: "weekStartDay",
            get: function get() {
              // Try locale first
              var weekStartDay = this.L('weekStartDay');

              if (weekStartDay !== 'weekStartDay') {
                return weekStartDay;
              } // Default to 0, should not need to happen in real world scenarios when a locale is always loaded


              return 0;
            }
          }, {
            key: "locale",
            set: function set(name) {
              locale = name;
            },
            get: function get() {
              return locale;
            }
          }]);

          return DateHelper;
        }(Object(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_25__["default"])());
        /*  */


        DateHelper._$name = 'DateHelper'; // Update when changing locale

        _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_26__["default"].on({
          locale: 'applyLocale',
          thisObj: DateHelper
        }); // Apply default locale


        if (_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_26__["default"].locale) DateHelper.applyLocale();
        DateHelper._$name = 'DateHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/DomHelper.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/helper/DomHelper.js ***!
        \**********************************************/

      /*! exports provided: roundPx, default */

      /***/
      function GridLibCommonHelperDomHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "roundPx", function () {
          return roundPx;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DomHelper;
        });
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "../Grid/node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "../Grid/node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_19___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_19__);
        /* harmony import */


        var _WidgetHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ./WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ./BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _StringHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ./StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ./util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ./ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ./ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");

        var productName = 'scheduler';
        /* eslint-disable standard/no-callback-literal */
        // Gives circular dependencies which I could not solve, called from global scope instead
        //import GlobalEvents from '../GlobalEvents.js';
        // https://app.assembla.com/spaces/bryntum/tickets/7903-rendering-fails
        // HACK: this value is required to calculate width if it was configured relative to font size (em) but no element is set

        var DEFAULT_FONT_SIZE = 14,
            t0t0 = {
          align: 't0-t0'
        }; // We only do the measurement once, if the value is null

        var scrollBarWidth = null,
            idCounter = 0,
            themeInfo = null;
        var // Transform matrix parse Regex. CSS transform computed style looks like this:
        // matrix(scaleX(), skewY(), skewX(), scaleY(), translateX(), translateY())
        // or
        // matrix3d(scaleX(), skewY(), 0, 0, skewX(), scaleY(), 0, 0, 0, 0, 1, 0, translateX(), translateY())
        // This is more reliable than using the style literal which may include
        // relative styles such as "translateX(-20em)", or not include the translation at all if it's from a CSS rule.
        // Use a const so as to only compile RexExp once
        translateMatrixRe = /(?:matrix\((?:-?\d*\.?[0-9]*),\s?(?:-?\d*\.?[0-9]*),\s?(?:-?\d*\.?[0-9]*),\s?(?:-?\d*\.?[0-9]*),\s?(-?\d*\.?[0-9]*),\s?(-?\d*\.?[0-9]*))|(?:matrix3d\((?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(?:-?\d*),\s?(-?\d*),\s?(-?\d*))/,
            pxTtranslateXRe = /translate(3d|X)?\((-?\d*\.?[0-9]*)px(?:,\s?(-?\d*\.?[0-9]*)px)?/,
            pxTtranslateYRe = /translate(3d|Y)?\((-?\d*\.?[0-9]*)px(?:,\s?(-?\d*\.?[0-9]*)px)?/,
            domIdRe = /^[^a-z]+|[^\w:.-]+/gi,
            whiteSpaceRe = /\s+/,
            // DomHelper#createElement properties which require special processing.
        // All other configs such as id and type are applied directly to the element.
        elementCreateProperties = {
          tag: 1,
          html: 1,
          children: 1,
          tooltip: 1,
          style: 1,
          dataset: 1,
          parent: 1,
          nextSibling: 1,
          ns: 1,
          reference: 1,
          unmatched: 1,
          // Used by syncId approach
          _element: 1,
          // Used by sync to assign used element back to the config, for usage by the caller
          onlyChildren: 1,
          // Used by sync to not touch the target element itself,
          elementData: 1,
          compareHtml: 1 // Sync

        },
            // Attributes to ignore on sync
        syncIgnoreAttributes = {
          tag: 1,
          html: 1,
          children: 1,
          tooltip: 1,
          parent: 1,
          nextSibling: 1,
          ns: 1,
          reference: 1,
          _element: 1,
          elementData: 1,
          retainElement: 1,
          compareHtml: 1
        },
            styleIgnoreProperties = {
          length: 1,
          parentRule: 1
        },
            styleDimensionProperties = {
          width: 1,
          height: 1,
          top: 1,
          left: 1,
          minWidth: 1,
          minHeight: 1,
          maxWidth: 1,
          maxHeight: 1,
          fontSize: 1
        },
            nativeFocusableTags = {
          BUTTON: 1,
          IFRAME: 1,
          EMBED: 1,
          INPUT: 1,
          OBJECT: 1,
          SELECT: 1,
          TEXTAREA: 1,
          HTML: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isIE11 ? 1 : 0,
          BODY: _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isIE11 ? 0 : 1
        },
            win = window,
            doc = document,
            emptyObject = {},
            emptyArray = [],
            arraySlice = Array.prototype.slice,
            immediatePromise = new Promise(function (resolve) {
          return resolve();
        }),
            devicePixelRatio = window.devicePixelRatio || 1,
            roundPx = devicePixelRatio === 1 ? Math.round : function (px) {
          return Math.round(px * devicePixelRatio) / devicePixelRatio;
        },
            fontProps = ['font-size', 'font-size-adjust', 'font-style', 'font-weight', 'font-family', 'font-kerning', 'font-stretch', 'line-height', 'text-transform', 'text-decoration', 'letter-spacing', 'word-break'],
            // Used in sync to give ObjectHelper.isDeeplyEqual() some domain knowledge
        syncEqualityEvaluator = {
          // Attributes used during creation that should not be compared
          ignore: {
            '_element': 1,
            'parent': 1,
            'elementData': 1,
            'ns': 1
          },
          // Function to evaluate 'compareHtml' property instead of 'html' for DocumentFragments
          evaluate: function evaluate(property, a, b) {
            if (property === 'html' && typeof a.value !== 'string') {
              // DocumentFragment, compare separately supplied html
              return a.object.compareHtml === b.object.compareHtml;
            }
          }
        };
        var templateElement, htmlParser;
        /**
         * @module Common/helper/DomHelper
         */

        /**
         * Helps with dom querying and manipulation.
         * ```
         * DomHelper.createElement({
         *   tag: 'div',
         *   className: 'parent',
         *   style: 'background: red',
         *   children: [
         *      { tag: 'div', className: 'child' },
         *      { tag: 'div', className: 'child' }
         *   ]
         * });
         * ```
         */

        var DomHelper =
        /*#__PURE__*/
        function () {
          function DomHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default()(this, DomHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default()(DomHelper, null, [{
            key: "isFocusable",

            /**
             * Returns `true` if the passed element is focusable either programatically or through pointer gestures.
             * @param {HTMLElement} element The element to test.
             */
            value: function isFocusable(element) {
              var skipAccessibilityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

              if (!skipAccessibilityCheck) {
                // offsetParent indicates that the element has layout, ie it is deeply visible.
                // document.body does not have an offsetParent.
                if (element !== document.body && !element.offsetParent) {
                  return false;
                }
              }

              var nodeName = element.nodeName;
              /*
               * An element is focusable if:
               *   - It is natively focusable, or
               *   - It is an anchor or link with href attribute, or
               *   - It has a tabIndex, or
               *   - It is an editing host (contenteditable="true")
               */

              return nativeFocusableTags[nodeName] || (nodeName === 'A' || nodeName === 'LINK') && !!element.href || element.getAttribute('tabIndex') != null || element.contentEditable === 'true';
            }
            /**
             * Returns `true` if the passed element is currently visible in the browser viewport, i.e. user can find it on screen
             * @param {HTMLElement} element The element to test.
             * @param {Boolean} whole Whether to check that whole element is visible, not just part of it.
             */

          }, {
            key: "isInView",
            value: function isInView(el) {
              var whole = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

              var elRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_23__["default"].from(el),
                  inView = true;

              var fullHeight = elRect.height,
                  fullWidth = elRect.width;

              while (inView && el.parentElement) {
                el = el.parentElement;
                elRect = elRect.intersect(_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_23__["default"].from(el));
                inView = elRect && (!whole || elRect.height >= fullHeight && elRect.width >= fullWidth);
              }

              return inView;
            }
          }, {
            key: "isCustomElement",

            /**
             * Returns true if element has opened shadow root
             * @param {HTMLElement} element Element to check
             * @returns {Boolean}
             */
            value: function isCustomElement(element) {
              return element && element.shadowRoot;
            }
            /**
             * Resolves element from point, checking shadow DOM if requried
             * @param {Number} x
             * @param {Number} y
             * @returns {HTMLElement}
             */

          }, {
            key: "elementFromPoint",
            value: function elementFromPoint(x, y) {
              var el = document.elementFromPoint(x, y); // Try to check shadow dom if it exists

              if (DomHelper.isCustomElement(el)) {
                el = el.shadowRoot.elementFromPoint(x, y) || el;
              }

              return el;
            }
            /**
             * Returns active element checking shadow dom too
             * @returns {HTMLElement}
             */

          }, {
            key: "getId",

            /**
             * Returns the `id` of the passed element. Generates a unique `id` if the element does not have one.
             * @param {HTMLElement} element The element to return the `id` of.
             */
            value: function getId(element) {
              return element.id || (element.id = 'b-element-' + ++idCounter);
            } //region Internal

            /**
             * Internal convenience fn to allow specifying either an element or a CSS selector to retrieve one
             * @private
             * @param {String|HTMLElement} elementOrSelector element or selector to lookup in DOM
             * @returns {HTMLElement}
             */

          }, {
            key: "getElement",
            value: function getElement(elementOrSelector) {
              // also used for SVG elements, so need to use more basic class, that is also returned by querySelector
              if (elementOrSelector instanceof Element) {
                return elementOrSelector;
              }

              return doc.querySelector(elementOrSelector);
            }
            /**
             * Sets attributes passed as object to given element
             * @private
             * @param {String|Element} elementOrSelector
             * @param {Object} attributes
             */

          }, {
            key: "setAttributes",
            value: function setAttributes(elementOrSelector, attributes) {
              var element = this.getElement(elementOrSelector);
              Object.entries(attributes).forEach(function (_ref) {
                var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_13___default()(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                return element.setAttribute(key, value);
              });
            }
            /**
             * Sets a CSS [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length) style value.
             * @param {String|HTMLElement} element The element to set the style in, or, if just the result is required,
             * the style magnitude to return with units added.
             * @param {String} [style] The name of a style property which specifies a [length](https://developer.mozilla.org/en-US/docs/Web/CSS/length)
             * @param {Number|String} [value] The magnitude. If a number is used, the value will be set in `px` units.
             * @returns {String} The style value string.
             */

          }, {
            key: "setLength",
            value: function setLength(element, style, value) {
              if (arguments.length === 1) {
                return typeof element === 'number' ? "".concat(element, "px") : element;
              } else {
                element = this.getElement(element);
                return element.style[style] = typeof value === 'number' ? "".concat(value, "px") : value;
              }
            } //endregion
            //region Children, going down...

            /**
             * Gets the first direct child of `element` that matches `selector.
             * @param {HTMLElement} element Parent element
             * @param {String} selector CSS selector
             * @returns {HTMLElement}
             * @category Query children
             */

          }, {
            key: "getChild",
            value: function getChild(element, selector) {
              // TODO: Only IE11 doesn't support :scope
              if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].supportsQueryScope) {
                selector = ':scope>' + selector;
              } else {
                var elId = element.id || (element.id = 'b-element-' + ++idCounter);
                selector = "#".concat(elId, " > ").concat(selector);
              }

              return element.querySelector(selector);
            }
            /**
             * Checks if `element` has any child that matches `selector`.
             * @param {HTMLElement} element Parent element
             * @param {String} selector CSS selector
             * @returns {Boolean} true if any child matches selector
             * @category Query children
             */

          }, {
            key: "hasChild",
            value: function hasChild(element, selector) {
              return DomHelper.getChild(element, selector) != null;
            }
            /**
             * Returns all child elements (not necessarily direct children) that matches `selector.
             * @param {HTMLElement} element Parent element
             * @param {String} selector CSS selector
             * @returns {HTMLElement[]} Matched elements, somewhere below `element
             * @category Query children
             */

          }, {
            key: "children",
            value: function children(element, selector) {
              return Array.from(element.querySelectorAll(selector));
            }
            /**
             * Looks at the specified `element` and all of its children for the one that first matches `selector.
             * @param {HTMLElement} element Parent element
             * @param {String} selector CSS selector
             * @returns {HTMLElement} Matched element, either element or an element below it
             * @category Query children
             */

          }, {
            key: "down",
            value: function down(element, selector) {
              if (!element) {
                return null;
              }

              if (element.matches && element.matches(selector)) {
                return element;
              }

              if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].supportsQueryScope) {
                selector = ':scope ' + selector;
              } else {
                var elId = element.id || (element.id = 'b-element-' + ++idCounter);
                selector = "#".concat(elId, " ").concat(selector);
              }

              return element.querySelector(selector);
            }
            /**
             * Checks if childElement is a descendant of parentElement (contained in it or a sub element)
             * @param {HTMLElement} parentElement Parent element
             * @param {HTMLElement} childElement Child element, at any level below parent
             * @returns {Boolean}
             * @category Query children
             */

          }, {
            key: "isDescendant",
            value: function isDescendant(parentElement, childElement) {
              // In case of IE11 and parentElement is <html>, HTMLDocument#contains is not supported - fallback to body
              if (!parentElement.contains) {
                parentElement = parentElement.body;
              }

              return parentElement.contains(childElement);
            }
            /**
             * Iterates over each result returned from `element.querySelectorAll(selector)`. First turns it into an array to
             * work in IE. Can also be called with only two arguments, in which case the first argument is used as selector and
             * document is used as the element.
             * @param {HTMLElement} element Parent element
             * @param {String} selector CSS selector
             * @param {Function} fn Function called for each found element
             * @category Query children
             */

          }, {
            key: "forEachSelector",
            value: function forEachSelector(element, selector, fn) {
              if (typeof element === 'string') {
                fn = selector;
                selector = element;
                element = doc;
              }

              this.children(element, selector).forEach(fn);
            }
            /**
             * Iterates over the direct child elements of the specified element. First turns it into an array to
             * work in IE.
             * @param {HTMLElement} element Parent element
             * @param {Function} fn Function called for each child element
             * @category Query children
             */

          }, {
            key: "forEachChild",
            value: function forEachChild(element, fn) {
              Array.from(element.children).forEach(fn);
            }
            /**
             * Removes each element returned from `element.querySelectorAll(selector)`.
             * @param {HTMLElement} element
             * @param {String} selector
             * @category Query children
             */

          }, {
            key: "removeEachSelector",
            value: function removeEachSelector(element, selector) {
              this.forEachSelector(element, selector, function (child) {
                return child.remove();
              });
            }
          }, {
            key: "removeClsGlobally",
            value: function removeClsGlobally(element) {
              var _this = this;

              for (var _len = arguments.length, classes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                classes[_key - 1] = arguments[_key];
              }

              classes.forEach(function (cls) {
                return _this.forEachSelector(element, '.' + cls, function (child) {
                  return child.classList.remove(cls);
                });
              });
            } //endregion
            //region Parents, going up...

            /**
             * Looks at the specified element and all of its parents for the one that first matches selector.
             * @param {HTMLElement} element Element
             * @param {String} selector CSS selector
             * @returns {HTMLElement} Matched element, either the passed in element or an element above it
             * @category Query parents
             */

          }, {
            key: "up",
            value: function up(element, selector) {
              /*let parent = element;
              while (parent && !parent.matches(selector)) parent = parent.parentElement;
              return parent;*/
              return element && element.closest(selector);
            }
          }, {
            key: "getAncestor",
            value: function getAncestor(element, possibleAncestorParents) {
              var outerElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var found = false,
                  ancestor,
                  parent = element;
              if (!Array.isArray(possibleAncestorParents)) possibleAncestorParents = [possibleAncestorParents];

              while (parent = parent.parentElement) {
                if (possibleAncestorParents.includes(parent)) {
                  found = true;
                  break;
                }

                if (outerElement && parent === outerElement) break;
                ancestor = parent;
              }

              if (!found) return null;
              return ancestor || element;
            } //endregion
            //region Creation

            /**
             * Converts the passed id to an id valid for usage as id on a DOM element.
             * @param {String} id
             * @returns {String}
             */

          }, {
            key: "makeValidId",
            value: function makeValidId(id) {
              if (id == null) return null;
              return String(id).replace(domIdRe, '');
            }
            /**
             * Creates an Element. Example usage:
             * @example
             * DomHelper.createElement({
             *   tag         : 'table', // defaults to 'div'
             *   cellSpacing : 0,
             *   className   : 'nacho',
             *   html        : 'I am a nacho',
             *   children    : [ { tag: 'tr', ... }, myDomElement ],
             *   parent      : myExistingElement // Or its id
             *   style       : 'font-weight: bold;color: red',
             *   dataset     : { index: 0, size: 10 },
             *   tooltip     : 'Yay!',
             *   ns          : 'http://www.w3.org/1999/xhtml'
             * });
             * @param {Object} config Element config, as in example
             * @param {Boolean} returnAll Specify true to return all elements & child elements created as an array
             * @returns {HTMLElement|HTMLElement[]|Object} Single element or array of elements `returnAll` was set to true.
             * If any elements had a `reference` property, this will be an object containing a reference to
             * all those elements, keyed by the reference name.
             * @category Creation
             */

          }, {
            key: "createElement",
            value: function createElement() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var returnAll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var refs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var syncIdField = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

              if (typeof config.parent === 'string') {
                config.parent = document.getElementById(config.parent);
              } // nextSibling implies a parent


              var parent = config.parent || config.nextSibling && config.nextSibling.parentNode;
              var element;

              if (config.ns) {
                element = doc.createElementNS(config.ns, config.tag || 'svg');
              } else {
                element = doc.createElement(config.tag || 'div');
              }

              if (config.html) {
                if (config.html instanceof DocumentFragment) {
                  element.appendChild(config.html);
                } else {
                  element.innerHTML = config.html;
                }
              }

              if (config.tooltip) {
                _WidgetHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].attachTooltip(element, config.tooltip);
              }

              if (config.style) {
                this.applyStyle(element, config.style);
              }

              if (config.dataset) {
                Object.assign(element.dataset, config.dataset);
              }

              if (parent) {
                parent.insertBefore(element, config.nextSibling);
              }

              if (config.reference) {
                (refs || (refs = {}))[config.reference] = element;
                element.setAttribute('reference', config.reference);
              } // Attach custom data to the element, not visible


              if (config.elementData) {
                element.elementData = config.elementData;
              } // Handle things like id, className, type, rel, cellSpacing, href etc which just get assigned.


              var _arr = Object.keys(config);

              for (var _i = 0; _i < _arr.length; _i++) {
                var prop = _arr[_i];

                if (!elementCreateProperties[prop]) {
                  if (config.ns) {
                    element.setAttribute(prop, config[prop]); //element.setAttributeNS(config.ns, prop, config[prop]);
                  } else {
                    element[prop] = config[prop];
                  }
                }
              } // if returnAll is true, use array


              if (returnAll === true) {
                returnAll = [element];
              } // if it already is an array, add to it (we are probably a child)
              else if (Array.isArray(returnAll)) {
                  returnAll.push(element);
                }

              if (config.children) {
                if (syncIdField) {
                  // Map syncId -> child element to avoid querying dom later on
                  element.syncIdMap = {};
                }

                config.children.forEach(function (child) {
                  // Append string children as text nodes
                  if (typeof child === 'string') {
                    element.appendChild(document.createTextNode(child));
                  } // Just append Elements directly.
                  else if (isNaN(child.nodeType)) {
                      child.parent = element;

                      if (!child.ns) {
                        child.ns = config.ns;
                      }

                      var childElement = DomHelper.createElement(child, returnAll, refs, syncIdField),
                          syncId = child.dataset && child.dataset[syncIdField]; // syncId is used with DomHelper.sync to match elements. Populate a map here to make finding them faster

                      if (syncId != null) {
                        element.syncIdMap[syncId] = childElement;
                      } // Do not want to alter the initial config


                      delete child.parent;
                    } else {
                      element.appendChild(child);
                    }
                });
              }

              if (syncIdField) {
                // Store used config, to be able to compare on sync to determine if changed without hitting dom
                element.lastConfig = config;
              } // If references were used, return them in an object
              // If returnAll was specified, return the array
              // By default, return the root element


              return refs || returnAll || element;
            }
            /**
             * Create element(s) from a template (html string). Note that
             * `textNode`s are discarded unless the `raw` option is passed
             * as `true`.
             *
             * If the template has a single root element, then the single element will be returned
             * unless the `array` option is passed as `true`.
             *
             * If there are multiple elements, then an Array will be returned.
             *
             * @param {String} template The HTML string from which to create DOM content
             * @param {Object} [options] An object containing properties to modify how the DOM is created and returned.
             * @param {Boolean} [options.array] `true` to return an array even if there's only one resulting element.
             * @param {Boolean} [options.raw] Return all child nodes, including text nodes.
             * @param {Boolean} [options.fragment] Return a DocumentFragment.
             * @private
             */

          }, {
            key: "createElementFromTemplate",
            value: function createElementFromTemplate(template) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject;
              var array = options.array,
                  raw = options.raw,
                  fragment = options.fragment;
              var result; // Use template by preference if it exists. It's faster on most supported platforms
              // https://jsperf.com/domparser-vs-template/

              if (DomHelper.supportsTemplate) {
                (templateElement || (templateElement = doc.createElement('template'))).innerHTML = template;
                result = templateElement.content;

                if (fragment) {
                  // The template is reused, so therefore is its fragment.
                  // If we release the fragment to a caller, it must be a clone.
                  return result.cloneNode(true);
                }
              } else {
                (htmlParser || (htmlParser = new DOMParser())).parseFromString(template, 'text/html');
                result = htmlParser.parseFromString(template, 'text/html').body; // We must return a DocumentFragment.
                // myElement.append(fragment) inserts the contents of the fragment, not the fragment itself.

                if (fragment) {
                  // Empty string results in *no document.body* on IE!
                  var nodes = result ? result.childNodes : emptyArray;
                  result = document.createDocumentFragment();

                  while (nodes.length) {
                    result.appendChild(nodes[0]);
                  }

                  return result;
                } // Happens with empty template in IE11
                else if (!result) {
                    result = {
                      children: [],
                      childNodes: []
                    };
                  }
              } // Raw means all child nodes are returned


              if (raw) {
                result = result.childNodes;
              } // Otherwise, only element nodes
              else {
                  result = result.children;
                }

              return result.length === 1 && !array ? result[0] : arraySlice.call(result);
            }
            /**
             * Inserts an `element` at first position in `into`.
             * @param {HTMLElement} into Parent element
             * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
             * @returns {HTMLElement}
             * @category Creation
             */

          }, {
            key: "insertFirst",
            value: function insertFirst(into, element) {
              if (element && element.nodeType !== Node.ELEMENT_NODE && element.tag) {
                element = DomHelper.createElement(element);
              }

              return into.insertBefore(element, into.firstElementChild);
            }
            /**
             * Inserts a `element` before `beforeElement` in `into`.
             * @param {HTMLElement} into Parent element
             * @param {HTMLElement} element Element to insert, or an element config passed on to createElement()
             * @param {HTMLElement} beforeElement Element before which passed element should be inserted
             * @returns {HTMLElement}
             * @category Creation
             */

          }, {
            key: "insertBefore",
            value: function insertBefore(into, element, beforeElement) {
              if (element && element.nodeType !== Node.ELEMENT_NODE && element.tag) {
                element = DomHelper.createElement(element);
              }

              return beforeElement ? into.insertBefore(element, beforeElement) : DomHelper.insertFirst(into, element);
            }
            /**
             * Appends element to parentElement.
             * @param {HTMLElement} parentElement Parent element
             * @param {HTMLElement|Object|String} elementOrConfig Element to insert, or an element config passed on to createElement(), or an html string passed to createElementFromTemplate
             * @returns {HTMLElement}
             * @category Creation
             */

          }, {
            key: "append",
            value: function append(parentElement, elementOrConfig) {
              if (elementOrConfig) {
                if (typeof elementOrConfig === 'string') {
                  elementOrConfig = DomHelper.createElementFromTemplate(elementOrConfig);
                } else if (elementOrConfig.nodeType !== Node.ELEMENT_NODE && elementOrConfig.tag) {
                  elementOrConfig = DomHelper.createElement(elementOrConfig);
                }
              }

              if (Array.isArray(elementOrConfig)) {
                return elementOrConfig.map(function (element) {
                  return parentElement.appendChild(element);
                });
              } else {
                return parentElement.appendChild(elementOrConfig);
              }
            } //endregion
            //region Get position

            /**
             * Returns the element's `transform translateX` value in pixels.
             * @param {HTMLElement} element
             * @returns {Number} X transform
             * @category Position, get
             */

          }, {
            key: "getTranslateX",
            value: function getTranslateX(element) {
              var transformStyle = element.style.transform,
                  matches = pxTtranslateXRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateX(npx"

              if (matches) {
                return parseInt(matches[2]);
              } else {
                // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
                matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(this.getStyleValue(this.getElement(element), 'transform'));
                return matches ? parseInt(matches[1] || matches[3]) : 0;
              }
            }
            /**
             * Returns the element's `transform translateY` value in pixels.
             * @param {HTMLElement} element
             * @returns {Number} Y coordinate
             * @category Position, get
             */

          }, {
            key: "getTranslateY",
            value: function getTranslateY(element) {
              var transformStyle = element.style.transform,
                  matches = pxTtranslateYRe.exec(transformStyle); // Use inline transform style if it contains "translate(npx, npx" or "translate3d(npx, npx" or "translateY(npx"

              if (matches) {
                // If it was translateY(npx), use first item in the parens.
                var y = parseInt(matches[matches[1] === 'Y' ? 2 : 3]); // FF will strip `translate(x, 0)` -> `translate(x)`, so need to check for isNaN also

                return isNaN(y) ? 0 : y;
              } else {
                // If the inline style is the matrix() form, then use that, otherwise, use computedStyle
                matches = translateMatrixRe.exec(transformStyle) || translateMatrixRe.exec(this.getStyleValue(this.getElement(element), 'transform'));
                return matches ? parseInt(matches[2] || matches[4]) : 0;
              }
            }
            /**
             * Gets both X and Y coordinates as an array [x, y]
             * @param {HTMLElement} element
             * @returns {Number[]} [x, y]
             * @category Position, get
             */

          }, {
            key: "getTranslateXY",
            value: function getTranslateXY(element) {
              return [this.getTranslateX(element), this.getTranslateY(element)];
            }
            /**
             * Get elements X offset within a containing element
             * @param {HTMLElement} element
             * @param {HTMLElement} container
             * @returns {Number} X offset
             * @category Position, get
             */

          }, {
            key: "getOffsetX",
            value: function getOffsetX(element) {
              var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return container ? element.getBoundingClientRect().left - container.getBoundingClientRect().left : element.offsetLeft;
            }
            /**
             * Get elements Y offset within a containing element
             * @param {HTMLElement} element
             * @param {HTMLElement} container
             * @returns {Number} Y offset
             * @category Position, get
             */

          }, {
            key: "getOffsetY",
            value: function getOffsetY(element) {
              var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return container ? element.getBoundingClientRect().top - container.getBoundingClientRect().top : element.offsetTop;
            }
            /**
             * Gets elemnts X and Y offset within containing element as an array [x, y]
             * @param {HTMLElement} element
             * @param {HTMLElement} container
             * @returns {Number[]} [x, y]
             * @category Position, get
             */

          }, {
            key: "getOffsetXY",
            value: function getOffsetXY(element) {
              var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              return [this.getOffsetX(element, container), this.getOffsetY(element, container)];
            }
            /**
             * Focus element without scrolling the element into view.
             * @param {HTMLElement} element
             */

          }, {
            key: "focusWithoutScrolling",
            value: function focusWithoutScrolling(element) {
              // Check browsers which do support focusOptions
              // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus
              var preventScrollSupported = _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].chromeVersion >= 64 || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].fireFoxVersion >= 68;

              if (preventScrollSupported) {
                element.focus({
                  preventScroll: true
                });
              } else {
                // Examine every parentNode of the target and cache the scrollLeft and scrollTop,
                // and restore all values after the focus has taken place
                var scrollHierarchy = [];
                var parent = element.parentNode;

                while (parent && parent.scrollLeft != null) {
                  scrollHierarchy.push({
                    element: parent,
                    scrollLeft: parent.scrollLeft,
                    scrollTop: parent.scrollTop
                  });
                  parent = parent.parentNode;
                }

                element.focus();
                scrollHierarchy.forEach(function (_ref3) {
                  var element = _ref3.element,
                      scrollLeft = _ref3.scrollLeft,
                      scrollTop = _ref3.scrollTop; // Check first to avoid triggering unnecessary `scroll` events

                  if (element.scrollLeft !== scrollLeft) {
                    element.scrollLeft = scrollLeft;
                  }

                  if (element.scrollTop !== scrollTop) {
                    element.scrollTop = scrollTop;
                  }
                });
              }
            }
            /**
             * Get elements X position on page
             * @param {HTMLElement} element
             * @returns {Number}
             * @category Position, get
             */

          }, {
            key: "getPageX",
            value: function getPageX(element) {
              return element.getBoundingClientRect().left + win.pageXOffset; // no window.scrollX in IE11
            }
            /**
             * Get elements Y position on page
             * @param {HTMLElement} element
             * @returns {Number}
             * @category Position, get
             */

          }, {
            key: "getPageY",
            value: function getPageY(element) {
              return element.getBoundingClientRect().top + win.pageYOffset; // no window.scrollY in IE11
            }
            /**
             * Returns extremal (min/max) size (height/width) of the element in pixels
             * @param {HTMLElement} element
             * @param {String} style minWidth/minHeight/maxWidth/maxHeight
             * @returns {number}
             * @internal
             */

          }, {
            key: "getExtremalSizePX",
            value: function getExtremalSizePX(element, style) {
              var prop = _StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].hyphenate(style),
                  measure = prop.split('-')[1],
                  value = this.getStyleValue(element, prop);

              if (/%/.test(value)) {
                // Element might be detached from DOM
                if (element.parentElement) {
                  value = parseInt(this.getStyleValue(element.parentElement, measure), 10);
                } else {
                  value = NaN;
                }
              } else {
                value = parseInt(value, 10);
              }

              return value;
            } //endregion
            //region Set position

            /**
             * Set element's `X` translation in pixels.
             * @param {HTMLElement} element
             * @param {Number} x The value by which the element should be translated from its default position.
             * @category Position, set
             */

          }, {
            key: "setTranslateX",
            value: function setTranslateX(element, x) {
              var t = DomHelper.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

              x = roundPx(x);

              if (t.length > 1) {
                t[t[0].startsWith('matrix3d') ? 12 : 4] = x;
                element.style.transform = t.join(',');
              } else {
                element.style.transform = "translateX(".concat(x, "px)");
              }
            }
            /**
             * Set element's `Y` translation in pixels.
             * @param {HTMLElement} element
             * @param {Number} y  The value by which the element should be translated from its default position.
             * @category Position, set
             */

          }, {
            key: "setTranslateY",
            value: function setTranslateY(element, y) {
              var t = DomHelper.getStyleValue(element, 'transform').split(/,\s*/); // Avoid blurry text on non-retina displays

              y = roundPx(y);

              if (t.length > 1) {
                t[t[0].startsWith('matrix3d') ? 13 : 5] = y;
                element.style.transform = t.join(',') + ')';
              } else {
                element.style.transform = "translateY(".concat(y, "px)");
              }
            }
            /**
             * Set element's style `top`.
             * @param {HTMLElement} element
             * @param {Number/String} y The top position. If numeric, `'px'` is used as the unit.
             * @category Position, set
             */

          }, {
            key: "setTop",
            value: function setTop(element, y) {
              this.setLength(element, 'top', y);
            }
            /**
             * Set element's style `left`.
             * @param {HTMLElement} element
             * @param {Number/String} x The top position. If numeric, `'px'` is used as the unit.
             * @category Position, set
             */

          }, {
            key: "setLeft",
            value: function setLeft(element, x) {
              this.setLength(element, 'left', x);
            }
            /**
             * Set elements `X` and `Y` translation in pixels.
             * @param {HTMLElement} element
             * @param {Number} [x] The `X translation.
             * @param {Number} [y] The `Y translation.
             * @category Position, set
             */

          }, {
            key: "setTranslateXY",
            value: function setTranslateXY(element, x, y) {
              if (x == null) {
                return this.setTranslateY(element, y);
              }

              if (y == null) {
                return this.setTranslateX(element, x);
              } // Avoid blurry text on non-retina displays


              x = roundPx(x);
              y = roundPx(y);
              var t = DomHelper.getStyleValue(element, 'transform').split(/,\s*/),
                  is3d = t[0].startsWith('matrix3d');

              if (t.length > 1) {
                t[is3d ? 12 : 4] = x;
                t[is3d ? 13 : 5] = y;
                element.style.transform = t.join(',') + ')';
              } else {
                element.style.transform = "translateX(".concat(x, "px) translateY(").concat(y, "px)");
              }
            }
            /**
             * Increase `X` translation
             * @param {HTMLElement} element
             * @param {Number} x The number of pixels by which to increase the element's `X` translation.
             * @category Position, set
             */

          }, {
            key: "addTranslateX",
            value: function addTranslateX(element, x) {
              DomHelper.setTranslateX(element, DomHelper.getTranslateX(element) + x);
            }
            /**
             * Increase `Y` position
             * @param {HTMLElement} element
             * @param {Number} y The number of pixels by which to increase the element's `Y` translation.
             * @category Position, set
             */

          }, {
            key: "addTranslateY",
            value: function addTranslateY(element, y) {
              DomHelper.setTranslateY(element, DomHelper.getTranslateY(element) + y);
            }
            /**
             * Increase X position
             * @param {HTMLElement} element
             * @param x
             * @category Position, set
             */

          }, {
            key: "addLeft",
            value: function addLeft(element, x) {
              DomHelper.setLeft(element, DomHelper.getOffsetX(element) + x);
            }
            /**
             * Increase Y position
             * @param {HTMLElement} element
             * @param y
             * @category Position, set
             */

          }, {
            key: "addTop",
            value: function addTop(element, y) {
              DomHelper.setTop(element, DomHelper.getOffsetY(element) + y);
            }
            /**
             * Align the passed element with the passed target according to the align spec.
             * @param {HTMLElement} element The element to align.
             * @param {HTMLElement|Common.helper.util.Rectangle} target The target element or rectangle to align to
             * @param {Object} alignSpec See {@link Common.helper.util.Rectangle#function-alignTo} Defaults to `{ align : 't0-t0' }`
             */

          }, {
            key: "alignTo",
            value: function alignTo(element, target) {
              var alignSpec = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t0t0;
              target = target instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_23__["default"] ? target : _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_23__["default"].from(target, null, true);

              var elXY = this.getTranslateXY(element),
                  elRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_23__["default"].from(element, null, true),
                  targetRect = elRect.alignTo(Object.assign(alignSpec, {
                target: target
              }));

              this.setTranslateXY(element, elXY[0] + targetRect.x - elRect.x, elXY[1] + targetRect.y - elRect.y);
            } //endregion
            //region Styles & CSS

            /**
             * Returns a style value or values for the passed element.
             * @param {HTMLElement} element The element to read styles from
             * @param {String|String[]} propName The property or properties to read
             * @param {Boolean} [inline=false] Pass as `true` to read the element's inline style.
             * Note that this could return inaccurate results if CSS rules apply to this element.
             * @return {String|Object} The value or an object containing the values keyed by the requested property name.
             * @category CSS
             */

          }, {
            key: "getStyleValue",
            value: function getStyleValue(element, propName, inline, pseudo) {
              var styles = inline ? element.style : element.ownerDocument.defaultView.getComputedStyle(element, pseudo);

              if (Array.isArray(propName)) {
                var result = {};
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = propName[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var prop = _step.value;
                    result[prop] = styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].hyphenate(prop));
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                return result;
              } // Use the elements owning view to get the computed style.
              // Ensure the property name asked for is hyphenated.
              // getPropertyValue doesn't work with camelCase


              return styles.getPropertyValue(_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].hyphenate(propName));
            }
            /**
             * Applies specified style to the passed element. Style can be an object or a string.
             * @param {HTMLElement} element Target element
             * @param {String|Object} style Style to apply, 'border: 1px solid black' or { border: '1px solid black' }
             * @param {Boolean} [overwrite] Specify `true` to replace style instead of applying changes
             * @category CSS
             */

          }, {
            key: "applyStyle",
            value: function applyStyle(element, style) {
              var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

              if (typeof style === 'string') {
                if (overwrite) {
                  // Only assign if either end has any styles, do not want to add empty `style` tag on element
                  if (style.length || element.style.cssText.length) {
                    element.style.cssText = style;
                  }
                } else {
                  // Add style so as not to delete configs in style such as width, height, flex etc.
                  // If a style is already there, the newest, appended one will take precedence.
                  element.style.cssText += style;
                }
              } else {
                if (overwrite) {
                  element.style.cssText = ''; //element.removeAttribute('style');
                } // Prototype chained objects may be passed, so use direct loop.


                for (var key in style) {
                  // Ignore readonly properties of the CSSStyleDeclaration object:
                  // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
                  if (!styleIgnoreProperties[key]) {
                    // Append 'px' for numeric dimensions
                    if (styleDimensionProperties[key] && typeof style[key] == 'number') {
                      element.style[_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].hyphenate(key)] = style[key] + 'px';
                    } else {
                      element.style[_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].hyphenate(key)] = style[key];
                    }
                  }
                }
              }
            }
          }, {
            key: "getCSSText",
            value: function getCSSText(style) {
              if (typeof style === 'string') {
                return style;
              }

              var cssText = '';

              for (var key in style) {
                // Ignore readonly properties of the CSSStyleDeclaration object:
                // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration
                if (!styleIgnoreProperties[key]) {
                  cssText += "".concat(_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].hyphenate(key), ":").concat(style[key], ";");
                }
              }

              return cssText;
            } // For IE11, it doesn't support adding/removing multiple classes at once

            /**
             * Add multiple classes to elements classList. Helper for IE11 which does not support it directly
             * @param {HTMLElement} element
             * @param {String[]} classes
             * @category CSS
             */

          }, {
            key: "addClasses",
            value: function addClasses(element, classes) {
              classes.forEach(function (cls) {
                return element.classList.add(cls);
              });
            }
            /**
             * Remove multiple classes to elements classList. Helper for IE11 which does not support it directly
             * @param {HTMLElement} element
             * @param {String[]} classes
             * @category CSS
             */

          }, {
            key: "removeClasses",
            value: function removeClasses(element, classes) {
              classes.forEach(function (cls) {
                return element.classList.remove(cls);
              });
            }
            /**
             * Toggle multiple classes in elements classList. Helper for IE11 which does not support toggling with force or for
             * multiple classes at once.
             * @param {HTMLElement} element
             * @param {String[]} classes
             * @param {Boolean} [force] Specify true to add classes, false to remove. Leave blank to toggle
             * @category CSS
             */

          }, {
            key: "toggleClasses",
            value: function toggleClasses(element, classes) {
              var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

              if (!Array.isArray(classes)) {
                classes = [classes];
              }

              if (force === true) {
                this.addClasses(element, classes);
              } else if (force === false) {
                this.removeClasses(element, classes);
              } else {
                classes.forEach(function (cls) {
                  return element.classList.toggle(cls);
                });
              }
            }
            /**
             * Adds a CSS class to an element during the specified duration
             * @param {HTMLElement} element Target element
             * @param {String} cls CSS class to add temporarily
             * @param {Number} duration Duration in ms, 0 means cls will not be applied
             * @category CSS
             */

          }, {
            key: "addTemporaryClass",
            value: function addTemporaryClass(element, cls, duration) {
              if (duration > 0) {
                element.classList.add(cls);
                setTimeout(function () {
                  element && element.classList.remove(cls);
                }, duration);
              }
            } //endregion
            //region Effects

            /**
             * Highlights the passed element or Rectangle according to the theme's highlihghting rules.
             * Usually an animated framing effect.
             * @param {HTMLElement/Common.helper.util.Rectangle} element The element or Rectangle to highlight.
             */

          }, {
            key: "highlight",
            value: function highlight(element) {
              if (element instanceof _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_23__["default"]) {
                return element.highlight();
              }

              return new Promise(function (resolve) {
                setTimeout(function () {
                  element.classList.add('b-fx-highlight');
                  setTimeout(function () {
                    element.classList.remove('b-fx-highlight');
                    resolve();
                  }, 1000);
                }, 0);
              });
            } //endregion
            //region Measuring / Scrollbar

            /**
             * Measures the scrollbar width using a hidden div. Caches result
             * @returns {Number}
             * @readonly
             */

          }, {
            key: "resetScrollBarWidth",

            /**
             * Resets DomHelper.scrollBarWidth cache, triggering a new measurement next time it is read
             */
            value: function resetScrollBarWidth() {
              scrollBarWidth = null;
            }
            /**
             * Measures the text width using a hidden div
             * @param {String} text
             * @param {HTMLElement} sourceElement
             * @returns {Number} width
             * @category Measure
             */

          }, {
            key: "measureText",
            value: function measureText(text, sourceElement, useHTML, parentElement) {
              var offScreenDiv = this.getMeasureElement(sourceElement, parentElement);
              offScreenDiv[useHTML ? 'innerHTML' : 'innerText'] = text;
              var result = offScreenDiv.clientWidth;
              offScreenDiv.className = '';
              return result;
            }
            /**
             * Measures a relative size, such as a size specified in `em` units for the passed element.
             * @param {String} size The CSS size value to measure.
             * @param {HTMLElement} sourceElement
             * @returns {Number} size The size in pixels of the passed relative measurement.
             * @category Measure
             */

          }, {
            key: "measureSize",
            value: function measureSize(size, sourceElement) {
              if (!size) {
                return 0;
              }

              if (typeof size === 'number') {
                return size;
              }

              if (!size.length) {
                return 0;
              }

              if (/^\d+(px)?$/.test(size)) {
                return parseInt(size);
              }

              if (sourceElement) {
                var offScreenDiv = this.getMeasureElement(sourceElement);
                offScreenDiv.innerHTML = '';
                offScreenDiv.style.width = DomHelper.setLength(size); //const result = BrowserHelper.isIE11 ?  offScreenDiv.offsetWidth : offScreenDiv.clientWidth;

                var result = offScreenDiv.offsetWidth;
                offScreenDiv.style.width = offScreenDiv.className = '';
                return result;
              }

              if (/^\d+em$/.test(size)) {
                return parseInt(size) * DEFAULT_FONT_SIZE;
              }

              return isNaN(size) ? 0 : parseInt(size);
            } // parentElement allows measurement to happen inside a specific element, allowing scoped css rules to match

          }, {
            key: "getMeasureElement",
            value: function getMeasureElement(sourceElement) {
              var parentElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : doc.body;
              var sourceElementStyle = win.getComputedStyle(sourceElement),
                  offScreenDiv = parentElement.offScreenDiv = parentElement.offScreenDiv || DomHelper.createElement({
                parent: parentElement,
                style: 'position:fixed;top:-10000px;left:-10000px;visibility:hidden;contain:strict',
                className: 'b-measure-element',
                children: [{
                  style: 'white-space:nowrap;display:inline-block;will-change:contents;width:auto;contain:none'
                }]
              }, true)[1];
              fontProps.forEach(function (prop) {
                if (offScreenDiv.style[prop] !== sourceElementStyle[prop]) {
                  offScreenDiv.style[prop] = sourceElementStyle[prop];
                }
              });
              offScreenDiv.className = sourceElement.className; // In case the measure element was moved/removed, re-add it

              if (offScreenDiv.parentElement.parentElement !== parentElement) {
                parentElement.appendChild(offScreenDiv.parentElement);
              }

              return offScreenDiv;
            } //endregion
            //region Sync

            /**
             * Sync one source element attributes, children etc. to a target element. Source element can be specified as a html
             * string, as a `createElement` config or an actual HTMLElement
             * @param {String|HTMLElement|Object} config Source "element" to copy from or a config object with the following options:
             * @param {HTMLElement} [config.sourceElement] Source element to copy from. Mutually exclusive with `html` and `elementConfig`
             * @param {String} [config.html] HTML string to use instead of source element. Mutually exclusive with `sourceElement` and `elementConfig`
             * @param {Object} [config.elementConfig] A `createElement` config object defining a source element. Mutually exclusive with `sourceElement` and `html`
             * @param {Object} [config.targetElement] Target element to apply to
             * @param {Boolean|String} [config.useSyncId] Specify `true` to use `dataset.syncId` for element re-usage, or a string to match elements on another dataset field. Only valid in combination with `elementConfig`
             * @param {Function} [config.callback] A function that will be called on element reusage, creation and similar
             * @param {HTMLElement} targetElement Target element to apply to, can also be specified as part of the config object
             * @returns {HTMLElement} Returns the updated targetElement (which is also updated in place)
             */

          }, {
            key: "sync",
            value: function sync(config, targetElement) {
              var element = config,
                  useSyncId = false;

              if (!(config instanceof HTMLElement) && typeof config !== 'string') {
                if (config.sourceElement) {
                  element = config.sourceElement;
                } else if (config.html) {
                  element = config.html;
                } else if (config.elementConfig) {
                  element = config.elementConfig;
                }

                if (config.targetElement) {
                  targetElement = config.targetElement;
                }

                var useSyncIdValue = (config.elementConfig ? config.elementConfig.useSyncId : null) || config.useSyncId; // true -> syncId, otherwise use specified value

                useSyncId = useSyncIdValue === true ? 'syncId' : useSyncIdValue;

                if (useSyncId && !config.elementConfig) {
                  throw new Error('syncId can only be used in combination with elementConfig');
                }
              }

              if (typeof element === 'string') {
                element = this.createElementFromTemplate(element);
              }

              this.performSync(element, targetElement, useSyncId, config.callback);
              return targetElement;
            } // Internal helper used for recursive syncing

          }, {
            key: "performSync",
            value: function performSync(sourceElement, targetElement, useSyncId, callback) {
              var isElement = sourceElement instanceof HTMLElement,
                  onlyChildren = !isElement ? sourceElement.onlyChildren : false; // Syncing identical elements is a no-op

              if ( // When syncing elements, compare outerHTML
              isElement && sourceElement.outerHTML !== targetElement.outerHTML || // When syncing a config, compare to config cached on target element
              !isElement && (!useSyncId || !_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isDeeplyEqual(sourceElement, targetElement.lastConfig, syncEqualityEvaluator))) {
                // TODO: Since targetElement holds its previously used config in lastConfig it would be possible to compare to
                //   that instead of to the actual element, to gain some speed
                // Sync without affecting then containing element?
                if (!onlyChildren) {
                  this.syncAttributes(sourceElement, targetElement);
                  this.syncContent(sourceElement, targetElement);
                }

                this.syncChildren(sourceElement, targetElement, useSyncId, callback); // When using config, cache the config on the target for future comparison

                if (!isElement) {
                  targetElement.lastConfig = sourceElement;
                }

                return true;
              } else if (!isElement) {
                // Sync took no action, notify the world
                callback && callback({
                  action: 'none',
                  config: sourceElement,
                  element: targetElement
                });
              }

              return false;
            } // Attributes as map { attr : value, ... }, either from an html element or from a config

          }, {
            key: "getSyncAttributes",
            value: function getSyncAttributes(elementOrConfig) {
              var attributes = {},
                  // Attribute names, simplifies comparisons and calls to set/removeAttribute
              names = []; // Extract from element

              if (elementOrConfig instanceof HTMLElement) {
                for (var i = 0; i < elementOrConfig.attributes.length; i++) {
                  var attr = elementOrConfig.attributes[i];

                  if (attr.specified) {
                    var name = attr.name.toLowerCase();
                    attributes[name] = attr.value;
                    names.push(name);
                  }
                }
              } // Or from elementConfig
              else {
                  Object.keys(elementOrConfig).forEach(function (attr) {
                    if (!syncIgnoreAttributes[attr]) {
                      var originalAttr = attr;

                      if (attr === 'className') {
                        attr = 'class';
                      }

                      var _name = attr.toLowerCase();

                      attributes[_name] = elementOrConfig[originalAttr];
                      names.push(_name);
                    }
                  });
                }

              return {
                attributes: attributes,
                names: names
              };
            }
            /**
             * Syncs attributes from sourceElement to targetElement.
             * @private
             * @param {HTMLElement|Object} sourceElement
             * @param {HTMLElement} targetElement
             */

          }, {
            key: "syncAttributes",
            value: function syncAttributes(sourceElement, targetElement) {
              var _this$getSyncAttribut = this.getSyncAttributes(sourceElement),
                  sourceAttributes = _this$getSyncAttribut.attributes,
                  sourceNames = _this$getSyncAttribut.names,
                  _this$getSyncAttribut2 = this.getSyncAttributes(targetElement),
                  targetAttributes = _this$getSyncAttribut2.attributes,
                  targetNames = _this$getSyncAttribut2.names,
                  hasDataset = sourceNames.includes('dataset'),
                  toAdd = sourceNames.filter(function (attr) {
                return !targetNames.includes(attr);
              }),
                  toRemove = targetNames.filter(function (attr) {
                return !sourceNames.includes(attr) && (!hasDataset || !attr.startsWith('data-'));
              }),
                  toSync = sourceNames.filter(function (attr) {
                return targetNames.includes(attr);
              });

              if (toAdd.length > 0) {
                for (var i = 0; i < toAdd.length; i++) {
                  var attr = toAdd[i]; // Style requires special handling

                  if (attr === 'style') {
                    this.applyStyle(targetElement, sourceAttributes.style, true);
                  } // So does dataset
                  else if (attr === 'dataset') {
                      Object.assign(targetElement.dataset, sourceAttributes.dataset);
                    } // Other attributes are set using setAttribute (since it calls toString() DomClassList works fine)
                    else {
                        targetElement.setAttribute(attr, sourceAttributes[attr]);
                      }
                }
              }

              if (toRemove.length > 0) {
                for (var _i2 = 0; _i2 < toRemove.length; _i2++) {
                  targetElement.removeAttribute(toRemove[_i2]);
                }
              }

              if (toSync.length > 0) {
                for (var _i3 = 0; _i3 < toSync.length; _i3++) {
                  var _attr = toSync[_i3]; // Set all attributes that has changed, with special handling for style

                  if (_attr === 'style') {
                    // TODO: Check for changes?
                    this.applyStyle(targetElement, sourceAttributes.style, true);
                  } // And dataset
                  else if (_attr === 'dataset') {
                      // TODO: Any cost to assigning same values?
                      Object.assign(targetElement.dataset, sourceAttributes.dataset);
                    } // And class, which might be a DomClassList
                    else if (_attr === 'class' && sourceAttributes[_attr].isDomClassList) {
                        if (!sourceAttributes.class.isEqual(targetAttributes.class)) {
                          targetElement.setAttribute('class', sourceAttributes.class);
                        }
                      } else if (targetAttributes[_attr] !== sourceAttributes[_attr]) {
                        targetElement.setAttribute(_attr, sourceAttributes[_attr]);
                      }
                }
              }
            }
            /**
             * Sync content (innerText) from sourceElement to targetElement
             * @private
             * @param {HTMLElement|Object} sourceElement
             * @param {HTMLElement} targetElement
             */

          }, {
            key: "syncContent",
            value: function syncContent(sourceElement, targetElement) {
              var sourceChildCount,
                  html = null;

              if (sourceElement instanceof HTMLElement) {
                sourceChildCount = sourceElement.childElementCount;
              } else {
                sourceChildCount = sourceElement.children ? sourceElement.children.length : 0;
                html = sourceElement.html; // elementData holds custom data that we want to attach to the element (not visible in dom)

                if (sourceElement.elementData) {
                  targetElement.elementData = sourceElement.elementData;
                }
              } // No child elements in source, remove any from target


              if (sourceChildCount === 0 && targetElement.childElementCount > 0 && !html) {
                targetElement.innerHTML = '';
              } // Apply html from config
              else if (html) {
                  // If given a DocumentFragment, replace content with it
                  if (html instanceof DocumentFragment) {
                    // Syncing a textNode to a textNode? Use shortcut
                    if (targetElement.childNodes.length === 1 && targetElement.childElementCount === 0 && html.childNodes.length === 1 && html.childElementCount === 0) {
                      this.setInnerText(targetElement, html.firstChild.data);
                    } else {
                      // TODO: Is there a faster way?
                      targetElement.innerHTML = '';
                      targetElement.appendChild(html);
                    }
                  } // Something that might be html, set innerHTML
                  else if (html.includes('<')) {
                      targetElement.innerHTML = html;
                    } // Plain text, prefer setting data on first text node
                    else {
                        this.setInnerText(targetElement, html);
                      }
                }
            }
          }, {
            key: "setInnerText",
            value: function setInnerText(targetElement, text) {
              // setting firstChild.data is faster than innerText (and innerHTML),
              // but in some cases the inner node is lost and needs to be recreated
              var firstChild = targetElement.firstChild;

              if (firstChild) {
                firstChild.data = text;
              } else {
                // textContent is supposed to be faster than innerText, since it does not trigger layout
                targetElement.textContent = text;
              }
            } // Sync children of one element to another

          }, {
            key: "syncChildrenElement",
            value: function syncChildrenElement(sourceElement, targetElement) {
              var me = this,
                  sourceNodes = arraySlice.call(sourceElement.childNodes),
                  targetNodes = arraySlice.call(targetElement.childNodes);

              while (sourceNodes.length) {
                var sourceNode = sourceNodes.shift(),
                    targetNode = targetNodes.shift(); // only textNodes and elements allowed (no comments)

                if (sourceNode && sourceNode.nodeType !== Node.TEXT_NODE && sourceNode.nodeType !== Node.ELEMENT_NODE) {
                  throw new Error("Source node type ".concat(sourceNode.nodeType, " not supported by DomHelper.sync()"));
                }

                if (targetNode && targetNode.nodeType !== Node.TEXT_NODE && targetNode.nodeType !== Node.ELEMENT_NODE) {
                  throw new Error("Target node type ".concat(targetNode.nodeType, " not supported by DomHelper.sync()"));
                }

                if (!targetNode) {
                  // out of target nodes, add to target
                  targetElement.appendChild(sourceNode);
                } else {
                  // match node
                  if (sourceNode.nodeType === targetNode.nodeType) {
                    // same type of node, take action depending on which type
                    if (sourceNode.nodeType === Node.TEXT_NODE) {
                      // text
                      targetNode.data = sourceNode.data;
                    } else {
                      if (sourceNode.tagName === targetNode.tagName) {
                        me.performSync(sourceNode, targetNode);
                      } else {
                        // new tag, remove targetNode and insert new element
                        targetElement.insertBefore(sourceNode, targetNode);
                        targetNode.remove();
                      }
                    }
                  } // Trying to set text node as element, use it as innerText
                  // (we get this in FF with store mutations and List)
                  else if (sourceNode.nodeType === Node.TEXT_NODE && targetNode.nodeType === Node.ELEMENT_NODE) {
                      targetElement.innerText = sourceNode.data.trim();
                    } else {
                      throw new Error('Currently no support for transforming nodeType');
                    }
                }
              } // Out of source nodes, remove remaining target nodes


              targetNodes.forEach(function (targetNode) {
                targetNode.remove();
              });
            } // Sync children from a config object to an element, able to reuse elements

          }, {
            key: "syncChildrenConfig",
            value: function syncChildrenConfig(config, targetElement, syncIdField, callback) {
              // Having specified html replaces all inner content, no point in syncing
              if (config.html) {
                return;
              }

              var me = this,
                  sourceConfigs = arraySlice.call(config.children || []),
                  targetElements = arraySlice.call(targetElement.children),
                  syncIdMap = targetElement.syncIdMap || {};
              var syncId; // Always repopulate the map, since elements might get used by other syncId below

              if (syncIdField) {
                targetElement.syncIdMap = {};
              }

              while (sourceConfigs.length) {
                var sourceConfig = sourceConfigs.shift(); // If syncIdField was supplied, we should first try to reuse element with matching "id"

                if (syncIdField && sourceConfig.dataset) {
                  syncId = sourceConfig.dataset[syncIdField]; // We have an id to look for

                  if (syncId != null && !sourceConfig.unmatched) {
                    // Find any matching element
                    var syncTargetElement = syncIdMap[syncId];

                    if (syncTargetElement) {
                      if ( // Ignore if flagged with `retainElement` (for example during dragging)
                      !sourceConfig.retainElement && // Otherwise sync with the matched element
                      me.performSync(sourceConfig, syncTargetElement, syncIdField, callback)) {
                        // Sync took some action, notify the world
                        callback && callback({
                          action: 'reuseOwnElement',
                          config: sourceConfig,
                          element: syncTargetElement,
                          syncId: syncId
                        });
                      } // Since it wont sync above when flagged to be retained, we need to apply the flag here


                      if (sourceConfig.retainElement) {
                        syncTargetElement.retainElement = true;
                      } // And remove it when no longer needed
                      else if (syncTargetElement.retainElement) {
                          syncTargetElement.retainElement = false;
                        } // Cache the element on the syncId for faster retrieval later


                      targetElement.syncIdMap[syncId] = syncTargetElement; // Attach to config to be reachable by caller

                      sourceConfig._element = syncTargetElement; // Remove our target from targetNodes, no other node is allowed to sync with it

                      _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].remove(targetElements, syncTargetElement);

                      syncTargetElement.isReleased = false;
                    } else {
                      // No match, move to end of queue to not steal some one else's element
                      sourceConfigs.push(sourceConfig); // Also flag as unmatched to know that when we reach this element again

                      sourceConfig.unmatched = true;
                    } // Node handled, carry on with next one


                    continue;
                  }
                } // Avoid polluting the config object when done


                if (sourceConfig.unmatched) {
                  delete sourceConfig.unmatched;
                } // Skip over any retained elements


                var targetNode = void 0;

                for (var i = 0; i < targetElements.length && !targetNode; i++) {
                  if (!targetElements[i].retainElement) {
                    targetNode = targetElements[i]; // shift is much faster than splice...

                    if (i === 0) {
                      targetElements.shift();
                    } else {
                      targetElements.splice(i, 1);
                    }
                  }
                } // Out of target nodes, add to target


                if (!targetNode) {
                  // Create a new element, passing along the syncIdField if used, to allow populating the syncIdMap during creation
                  var newElement = targetElement.appendChild(DomHelper.createElement(sourceConfig, false, null, syncIdField)); // TODO: Move to createElement?

                  if (syncId != null) {
                    targetElement.syncIdMap[syncId] = newElement;
                  }

                  sourceConfig._element = newElement;
                  callback && callback({
                    action: 'newElement',
                    config: sourceConfig,
                    element: newElement,
                    syncId: syncId
                  });
                } // We have targets left
                else {
                    // Matching element tag, sync it
                    if ((sourceConfig.tag || 'div').toLowerCase() === targetNode.tagName.toLowerCase()) {
                      var oldConfig = targetNode.lastConfig;
                      me.performSync(sourceConfig, targetNode, syncIdField, callback);

                      if (syncId != null) {
                        targetElement.syncIdMap[syncId] = targetNode;
                        targetNode.isReleased = false;
                      }

                      sourceConfig._element = targetNode;
                      callback && callback({
                        action: 'reuseElement',
                        config: sourceConfig,
                        oldConfig: oldConfig,
                        element: targetNode,
                        syncId: syncId
                      });
                    } // Not matching, replace it
                    else {
                        var _newElement = targetElement.insertBefore(DomHelper.createElement(sourceConfig), targetNode); // TODO: Move to createElement?


                        if (syncId != null) {
                          targetElement.syncIdMap[syncId] = _newElement;
                        }

                        sourceConfig._element = _newElement;
                        callback && callback({
                          action: 'newElement',
                          config: sourceConfig,
                          element: _newElement,
                          syncId: syncId
                        });
                        targetNode.remove();
                      }
                  }
              } // Out of source nodes, remove remaining target nodes


              targetElements.forEach(function (targetNode) {
                // Element might be retained, hands off (for example while dragging)
                if (!targetNode.retainElement) {
                  // When using syncId to reuse elements, "release" left over elements instead of removing them
                  if (syncIdField) {
                    // Prevent releasing already released element
                    if (!targetNode.isReleased) {
                      targetNode.className = 'b-released';
                      targetNode.isReleased = true;
                      callback && callback({
                        action: 'releaseElement',
                        config: targetNode.lastConfig,
                        oldConfig: targetNode.lastConfig,
                        element: targetNode
                      });
                      targetNode.elementData = targetNode.lastConfig = null;
                    }
                  } // In normal sync mode, remove left overs
                  else {
                      targetNode.remove();
                    }
                } else if (syncIdField) {
                  // Keep retained element in map
                  targetElement.syncIdMap[targetNode.dataset[syncIdField]] = targetNode;
                }
              });
            }
            /**
             * Sync traversing children
             * @private
             * @param {HTMLElement|Object} sourceElement Source element
             * @param {HTMLElement} targetElement Target element
             * @param {String} syncIdField Field in dataset to use for element re-usage
             */

          }, {
            key: "syncChildren",
            value: function syncChildren(sourceElement, targetElement, syncIdField, callback) {
              if (sourceElement instanceof HTMLElement) {
                this.syncChildrenElement(sourceElement, targetElement, syncIdField, callback);
              } else {
                this.syncChildrenConfig(sourceElement, targetElement, syncIdField, callback);
              }
            }
            /**
             * Synchronizes the passed element's `classList` with the class names
             * passed in either Array or String format or Object. Avoiding mutating an element's
             * `classList` or `className` can avoid browser style recalculations.
             * @param {HTMLElement} element The element whose class list to synchronize.
             * @param {String[]|String|Object} newClasses The incoming class names to set on the element.
             * @category CSS
             */

          }, {
            key: "syncClassList",
            value: function syncClassList(element, newClasses) {
              var classList = element.classList,
                  isString = typeof newClasses === 'string',
                  newClsArray = isString ? newClasses.trim().split(whiteSpaceRe) : Array.isArray(newClasses) ? newClasses : _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getTruthyKeys(newClasses),
                  classCount = newClsArray.length;
              var changed = classList.length !== classCount,
                  i; // If the incoming and existing class lists are the same length
              // then check that each contains the same names. As soon as
              // we find a non-matching name, we know we have to update the
              // className.

              for (i = 0; !changed && i < classCount; i++) {
                changed = !classList.contains(newClsArray[i]);
              }

              if (changed) {
                element.className = isString ? newClasses : newClsArray.join(' ');
              }
            }
            /**
             * Changes the theme to the passed theme name if possible.
             *
             * Theme names are case insensitive. The `href` used is all lower case.
             *
             * To use this method, the `<link rel="stylesheet">` _must_ use the default,
             * Bryntum-supplied CSS files where the `href` end with `<themeName>.css`, so that
             * it can be found in the document, and switched out for a new link with
             * the a modified `href`. The new `href` will use the same path, just
             * with the `themeName` portion subsituted for the new name.
             *
             * If no `<link>` with that name pattern can be found, an error will be thrown.
             *
             * If you use this method, you  must ensure that the theme files are
             * all accessible on your server.
             *
             * Because this is an asynchronous operation, a `Promise` is returned.
             * The theme change event is passed to the success function. If the
             * theme was not changed, because the theme name passed is the current theme,
             * nothing is passed to the success function.
             *
             * The theme change event contains two properties:
             *
             *  - `prev` The previous Theme name.
             *  - `theme` The new Theme name.
             *
             * @param {String} newThemeName
             * @returns {Promise} A promise who's success callback receives the theme change
             * event if the theme in fact changed. If the theme `href` could not be loaded,
             * the failure callback is called, passing the error event caught.
             */

          }, {
            key: "setTheme",
            value: function setTheme(newThemeName) {
              newThemeName = newThemeName.toLowerCase();
              var oldThemeName = this.themeInfo.name.toLowerCase(),
                  oldThemeLink = document.head.querySelector('#bryntum-theme') || document.head.querySelector("[href$=\"".concat(oldThemeName, ".css\"]")); // Theme link href ends with <themeName>.css also there could be a query - css?11111...

              if (!oldThemeLink || !oldThemeLink.href.includes("".concat(oldThemeName, ".css"))) {
                throw new Error("Theme link for ".concat(oldThemeName, " not found"));
              } // Do not reapply same theme


              if (oldThemeLink.href.includes(newThemeName)) {
                return immediatePromise;
              }

              return new Promise(function (resolve, reject) {
                var newThemeLink = document.createElement('link'),
                    nextSibling = oldThemeLink.nextSibling,
                    oldThemeName = DomHelper.themeInfo.name.toLowerCase(),
                    themeEvent = {
                  theme: newThemeName,
                  prev: oldThemeName
                },
                    onThemeLoad = function onThemeLoad() {
                  themeInfo = null;
                  oldThemeLink.remove();
                  window.bryntum.GlobalEvents.trigger('theme', themeEvent);
                  resolve(themeEvent);
                },
                    onThemeLoadError = function onThemeLoadError(e) {
                  reject(e);
                };

                newThemeLink.rel = 'stylesheet';
                newThemeLink.id = 'bryntum-theme';
                newThemeLink.addEventListener('load', onThemeLoad);
                newThemeLink.addEventListener('error', onThemeLoadError);
                newThemeLink.href = oldThemeLink.href.replace(oldThemeName, newThemeName);
                nextSibling.parentNode.insertBefore(newThemeLink, nextSibling);
              });
            }
            /**
             * A theme information object about the current theme.
             *
             * Currently this has only one property:
             *
             *   - `name` The current theme name.
             * @property {Object}
             * @readonly
             */

          }, {
            key: "activeElement",
            get: function get() {
              var el = document.activeElement;

              while (el.shadowRoot) {
                el = el.shadowRoot.activeElement;
              }

              return el;
            }
          }, {
            key: "scrollBarWidth",
            get: function get() {
              // Ensure the measurement is only done once, when the value is null and body is available
              if (scrollBarWidth === null && doc.body) {
                var element = DomHelper.createElement({
                  parent: doc.body,
                  style: 'position:absolute;top:-999px;width:100px;height:100px;overflow:scroll'
                });
                scrollBarWidth = element.offsetWidth - element.clientWidth;
                element.remove();
              }

              return scrollBarWidth;
            }
          }, {
            key: "themeInfo",
            get: function get() {
              if (!themeInfo) {
                var testDiv = this.createElement({
                  parent: document.body,
                  className: 'b-theme-info'
                }),
                    // Need to be a pseudo element for Edge to report content correctly
                themeData = this.getStyleValue(testDiv, 'content', false, ':before');

                if (themeData) {
                  // themeData could be invalid JSON string in case there is no content rule
                  try {
                    themeInfo = JSON.parse(themeData.replace(/^["']|["']$|\\/g, ''));
                  } catch (e) {
                    themeInfo = null;
                  }
                }

                testDiv.remove();
              }

              return themeInfo;
            } //endregion

          }]);

          return DomHelper;
        }();

        var clearTouchTimer;

        var clearTouchEvent = function clearTouchEvent() {
          return DomHelper.isTouchEvent = false;
        },
            setTouchEvent = function setTouchEvent() {
          DomHelper.isTouchEvent = true; // Jump round the click delay

          clearTimeout(clearTouchTimer);
          clearTouchTimer = setTimeout(clearTouchEvent, 400);
        }; // Set event type flags so that mousedown and click handlers can know whether a touch gesture was used.
        // This is used. This must stay until we have a unified DOM event system which handles both touch and mouse events.


        doc.addEventListener('touchstart', setTouchEvent, true);
        doc.addEventListener('touchend', setTouchEvent, true);
        DomHelper.supportsTemplate = 'content' in doc.createElement('template'); //region Polyfills
        // TODO: include babels polyfills instead of keeping own?

        if (!('children' in Node.prototype)) {
          var elementFilter = function elementFilter(node) {
            return node.nodeType === 1;
          };

          Object.defineProperty(Node.prototype, 'children', {
            get: function get() {
              return Array.prototype.filter.call(this.childNodes, elementFilter);
            }
          });
        }

        if (!Element.prototype.matches) {
          Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                i = matches.length;

            while (--i >= 0 && matches.item(i) !== this) {}

            return i > -1;
          };
        }

        if (win.Element && !Element.prototype.closest) {
          Node.prototype.closest = Element.prototype.closest = function (s) {
            var el = this;
            if (!doc.documentElement.contains(el)) return null;

            do {
              if (el.matches(s)) return el;
              el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);

            return null;
          };
        } else {
          // It's crazy that closest is not already on the Node interface!
          Node.prototype.closest = function (selector) {
            return this.parentNode.closest(selector);
          };
        } // from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md


        (function (arr) {
          arr.forEach(function (item) {
            if (item.hasOwnProperty('remove')) {
              return;
            }

            Object.defineProperty(item, 'remove', {
              configurable: true,
              enumerable: true,
              writable: true,
              value: function remove() {
                this.parentNode && this.parentNode.removeChild(this);
              }
            });
          });
        })([Element.prototype, CharacterData.prototype, DocumentType.prototype]); // IE11 polyfill


        if (!SVGElement.prototype.contains) {
          SVGElement.prototype.contains = function (node) {
            do {
              if (this === node) {
                return true;
              }

              node = node.parentNode;
            } while (node);

            return false;
          };
        } // IE11 polyfill for Event constructors


        if (typeof win.CustomEvent !== 'function') {
          var evt, _constructor;

          win.CustomEvent = _constructor = function _constructor(event) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              bubbles: false,
              cancelable: false,
              detail: undefined
            };
            evt = doc.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
          };

          _constructor.prototype = win.Event.prototype;

          win.MouseEvent = _constructor = function _constructor(event) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              bubbles: false,
              cancelable: false,
              detail: undefined
            };
            evt = doc.createEvent('MouseEvents');
            evt.initMouseEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.detail, params.screenX, params.screenY, params.clientX, params.clientY, false, false, false, false, 0, document);
            return evt;
          };

          _constructor.prototype = win.Event.prototype;

          win.KeyboardEvent = _constructor = function _constructor(event) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
              bubbles: false,
              cancelable: false,
              detail: undefined
            };
            var modifiers = "".concat(params.shiftKey ? 'Shift ' : '').concat(params.ctrlKey ? 'Control' : '');
            evt = doc.createEvent('KeyboardEvent');
            evt.initKeyboardEvent(event, params.bubbles, params.cancelable, doc.defaultView || win, params.key, params.location, modifiers, false, '');
            return evt;
          };

          _constructor.prototype = win.Event.prototype;
        } //endregion
        // https://gist.github.com/brettz9/4093766


        if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].isEdge) {
          if (!Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset') || !Object.getOwnPropertyDescriptor(SVGElement.prototype, 'dataset').get) {
            var propDescriptor = {
              enumerable: true,
              get: function get() {
                'use strict';

                var i,
                    that = this,
                    map = {},
                    attrVal,
                    attrName,
                    propName,
                    attribute,
                    attributes = this.attributes,
                    attsLength = attributes.length,
                    toUpperCase = function toUpperCase(n0) {
                  return n0.charAt(1).toUpperCase();
                },
                    getter = function getter() {
                  return this;
                },
                    setter = function setter(attrName, value) {
                  return typeof value !== 'undefined' ? this.setAttribute(attrName, value) : this.removeAttribute(attrName);
                };

                for (i = 0; i < attsLength; i++) {
                  attribute = attributes[i]; // Fix: This test really should allow any XML Name without
                  //         colons (and non-uppercase for XHTML)

                  if (attribute && attribute.name && /^data-\w[\w-]*$/.test(attribute.name)) {
                    attrVal = attribute.value;
                    attrName = attribute.name; // Change to CamelCase

                    propName = attrName.substr(5).replace(/-./g, toUpperCase);
                    Object.defineProperty(map, propName, {
                      enumerable: this.enumerable,
                      get: getter.bind(attrVal || ''),
                      set: setter.bind(that, attrName)
                    });
                  }
                }

                return map;
              }
            }; // FF enumerates over element's dataset, but not
            // SVGElement.prototype.dataset; IE9 iterates over both

            Object.defineProperty(SVGElement.prototype, 'dataset', propDescriptor);
          }
        } // Polyfill to allow an array to be passed to classList.add/remove


        var nativeAdd = DOMTokenList.prototype.add,
            nativeRemove = DOMTokenList.prototype.remove;

        DOMTokenList.prototype.add = function (cls) {
          if (Array.isArray(cls)) {
            nativeAdd.call.apply(nativeAdd, [this].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(cls)));
          } else {
            nativeAdd.call.apply(nativeAdd, [this].concat(Array.prototype.slice.call(arguments)));
          }
        };

        DOMTokenList.prototype.remove = function (cls) {
          if (Array.isArray(cls)) {
            nativeRemove.call.apply(nativeRemove, [this].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(cls)));
          } else {
            nativeRemove.call.apply(nativeRemove, [this].concat(Array.prototype.slice.call(arguments)));
          }
        };

        DomHelper._$name = 'DomHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/DragHelper.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/helper/DragHelper.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperDragHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DragHelper;
        });
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./mixin/DragHelperContainer.js */
        "../Grid/lib/Common/helper/mixin/DragHelperContainer.js");
        /* harmony import */


        var _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./mixin/DragHelperTranslate.js */
        "../Grid/lib/Common/helper/mixin/DragHelperTranslate.js");
        /* harmony import */


        var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _MixinHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./MixinHelper.js */
        "../Grid/lib/Common/helper/MixinHelper.js");
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler'; //TODO: add touch support
        //TODO: add pointer events support

        /**
         * @module Common/helper/DragHelper
         */

        var documentListeners = {
          down: 'onMouseDown',
          move: 'onMouseMove',
          up: 'onMouseUp',
          docclick: 'onDocumentClick',
          touchstart: 'onTouchStart',
          touchmove: 'onTouchMove',
          touchend: 'onTouchEnd',
          keydown: 'onKeyDown'
        };
        /**
         * Helps with drag and drop. Supports two modes of dragging:
         * * `container` - moving/rearranging elements within and between specified containers
         * * `translateXY` - repositioning an element withing its container
         *
         * Usage examples:
         * ```
         * // dragging element between containers
         * let dragHelper = new DragHelper({
         *   mode       : 'container',
         *   containers : [ container1, container2 ]
         * });
         *
         * // dragging element within container
         * let dragHelper = new DragHelper({
         *   mode    : 'translateXY',
         *   targetSelector: 'div.moveable'
         * });
         * ```
         * In the various Drag event handlers, you will have access to the raw DOM event and some useful `context` of the drag operation:
         *
         * ```
         *  myDrag.on({
         *      drag : ({event , context}) {
         *            // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
         *           const element = context.element;
         *
         *           // The original mousedown element upon which triggered the drag operation
         *           const grabbed = context.grabbed;
         *
         *           // The target under the current mouse / pointer / touch position
         *           const target = context.target;
         *       }
         *  });
         * ```
         *
         * Simple drag drop with a drop target specified:
         * ```
         * export default class MyDrag extends DragHelper {
                static get defaultConfig() {
                    return {
                        // Don't drag the actual cell element, clone it
                        cloneTarget        : true,
                        mode               : 'translateXY',
                        // Only allow drops on DOM elements with 'yourDropTarget' CSS class specified
                        dropTargetSelector : '.yourDropTarget',
        
                        // Only allow dragging elements with the 'draggable' CSS class
                        targetSelector : '.draggable'
                    };
                }
        
                construct(config) {
                    const me = this;
        
                    super.construct(config);
        
                    me.on({
                        dragstart : me.onDragStart
                    });
                }
        
                onDragStart({ event, context }) {
                    const target = context.target;
        
                    // Here you identify what you are dragging (an image of a user, grid row in an order table etc) and map it to something in your
                    // data model. You can store your data on the context object which is available to you in all drag-related events
                    context.userId = target.dataset.userId;
                }
        
                onEquipmentDrop({ context, event }) {
                    const me = this;
        
                    if (context.valid) {
                        const userId   = context.userId,
                              droppedOnTarget = context.target;
        
                        console.log(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`, droppedOnTarget);
        
                        // Dropped on a scheduled event, display toast
                        WidgetHelper.toast(`You dropped user ${userStore.getById(userId).name} on ${droppedOnTarget}`);
        
                        // tell the drag helper the operation is finished
                        me.context.finalize();
                    }
                }
            };
         * ```
         * @mixes Common/helper/mixin/DragHelperContainer
         * @mixes Common/helper/mixin/DragHelperTranslate
         * @mixes Common/mixin/Events
         * @extends Common/Base
         */

        var DragHelper =
        /*#__PURE__*/
        function (_base$mixes) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(DragHelper, _base$mixes);

          function DragHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DragHelper);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DragHelper).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DragHelper, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fired before dragging starts, return false to prevent the drag operation.
             * @preventable
             * @event beforeDragStart
             * @param {DragHelper} source
             * @param {Object} context
             * @param {MouseEvent|TouchEvent} event
             */

            /**
             * Fired when dragging starts.
             * @event dragStart
             * @param {DragHelper} source
             * @param {Object} context
             * @param {MouseEvent|TouchEvent} event
             */

            /**
             * Fired while dragging, you can signal that the drop is valid or invalid by setting `context.valid = false;`
             * @event drag
             * @param {DragHelper} source
             * @param {Object} context
             * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
             * @param {MouseEvent} event
             */
            //endregion
            //region Init

            /**
             * Initializes a new DragHelper.
             * @param {Object} config Configuration object, accepts options specified under Configs above
             * @example
             * new DragHelper({
             *   containers: [div1, div2],
             *   isElementDraggable: element => element.className.contains('handle'),
             *   outerElement: topParent,
             *   listeners: {
             *     drop: onDrop,
             *     thisObj: this
             *   }
             * });
             * @function constructor
             */
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DragHelper.prototype), "construct", this).call(this, config);

              me.initListeners();

              if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isTouchDevice) {
                me.handleSize = me.touchHandleSize;
              }

              if (me.mode === 'container') {
                me.initContainerDrag();
              } else if (me.mode.startsWith('translate')) {
                if (me.lockY) {
                  me.mode = 'translateX';
                } else if (me.lockX) {
                  me.mode = 'translateY';
                }

                me.initTranslateDrag();
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              // Abort dragging
              this.abort(true);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DragHelper.prototype), "doDestroy", this).call(this);
            }
            /**
             * Initialize listener
             * @private
             */

          }, {
            key: "initListeners",
            value: function initListeners() {
              var dragStartListeners = {
                element: this.outerElement,
                mousedown: documentListeners.down,
                thisObj: this
              };

              if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isTouchDevice) {
                dragStartListeners.touchstart = documentListeners.touchstart;
              } // These will be autoDetached upon destroy


              _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on(dragStartListeners);
            } //endregion
            //region Events

            /**
             * Fires after drop. For valid drops, it exposes `context.async` which you can set to true to signal that additional
             * processing is needed before finalizing the drop (such as showing some dialog). When that operation is done, call
             * `context.finalize(true/false)` with a boolean that determines the outcome of the drop.
             * @event drop
             * @param {DragHelper} dragHelper
             * @param {Object} context
             */

          }, {
            key: "onPointerDown",
            value: function onPointerDown(event) {
              var me = this,
                  handled = false,
                  isTouch = 'touches' in event; // If a drag is ongoing already, finalize it and don't proceed with new drag (happens if user does mouseup
              // outside browser window). Also handles the edge case of trying to start a new drag while previous is awaiting
              // finalization, in which case it just bails out.

              if (me.context) {
                if (!me.context.awaitingFinalization) {
                  me.onMouseUp(event);
                  me.reset();
                }

                return;
              }

              me.startEvent = event;
              if (me.isElementDraggable && !me.isElementDraggable(event.target, event)) return;

              if (me.mode) {
                if (!handled && me.mode === 'container') handled = me.grabContainerDrag(event);
                if (!handled && me.mode.startsWith('translate')) handled = me.grabTranslateDrag(event);
              }

              if (handled) {
                var dragListeners = {
                  element: document,
                  thisObj: me,
                  keydown: documentListeners.keydown
                };

                if (isTouch) {
                  dragListeners.touchmove = {
                    handler: documentListeners.touchmove,
                    passive: false // We need to be able to preventDefault on the touchmove

                  }; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
                  // iOS do fire touchend

                  dragListeners.touchend = dragListeners.pointerup = documentListeners.touchend;
                } else {
                  dragListeners.mousemove = documentListeners.move;
                  dragListeners.mouseup = documentListeners.up;
                } // A listener detacher is returned;


                me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on(dragListeners);

                if (me.dragWithin && me.dragWithin !== me.outerElement) {
                  var box = me.dragWithin.getBoundingClientRect();
                  me.minY = box.top;
                  me.maxY = box.bottom;
                  me.minX = box.left;
                  me.maxX = box.right;
                }
              }
            }
            /**
             * @param event
             * @private
             */

          }, {
            key: "onTouchStart",
            value: function onTouchStart(event) {
              var me = this; // only allowing one finger for now...

              if (event.touches.length === 1) {
                me.touchStartTimer = me.setTimeout(function () {
                  me.touchStartTimer = null;
                }, me.touchStartDelay);
                me.onPointerDown(event);
              }
            }
            /**
             * Grab draggable element on mouse down.
             * @private
             * @param event
             */

          }, {
            key: "onMouseDown",
            value: function onMouseDown(event) {
              // only dragging with left mouse button
              if (event.button === 0) {
                this.onPointerDown(event);
              }
            }
          }, {
            key: "internalMove",
            value: function internalMove(event) {
              var me = this,
                  context = me.context,
                  distance = _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getDistanceBetween(me.startEvent, event),
                  abortTouchDrag = me.touchStartTimer && distance > me.dragThreshold;

              if (abortTouchDrag) {
                me.abort(true);
                return;
              }

              if (!me.touchStartTimer && context && context.element && // Only target Elements, not text nodes
              event.target.nodeType === Node.ELEMENT_NODE && (context.started || distance >= me.dragThreshold)) {
                if (!context.started) {
                  // triggers beforeDragStart, dragStart. returning false from beforeDragStart aborts drag
                  if (me.callPreventable('dragStart', {
                    context: context,
                    event: event
                  }, function () {
                    var direction = me.lockX ? 'vertical' : me.lockY ? 'horizontal' : 'both';

                    if (context.action.startsWith('translate')) {
                      me.startTranslateDrag(event);
                    } else if (context.action === 'container') {
                      me.startContainerDrag(event);
                    }

                    context.started = true; // Now that the drag drop is confirmed to be starting, activate the configured scrollManager if present

                    if (me.scrollManager) {
                      me.scrollManager.startMonitoring({
                        direction: direction,
                        element: me.dragWithin || me.outerElement,
                        callback: function callback(config) {
                          if (me.context.element && me.lastMouseMoveEvent) {
                            // Indicate that this is a 'fake' mousemove event as a result of the scrolling
                            me.lastMouseMoveEvent.isScroll = true;
                            me.update(me.lastMouseMoveEvent, config);
                          }
                        },
                        thisObj: me
                      });
                    } // Global informatoinal class for when DragHelper is dragging


                    document.body.classList.add('b-draghelper-active');
                  }) === false) {
                    return me.abort();
                  }
                } // to prevent view drag (scroll) on ipad


                if (event.type === 'touchmove') {
                  event.preventDefault();
                  event.stopImmediatePropagation();
                }

                me.update(event);
              }
            }
          }, {
            key: "onTouchMove",
            value: function onTouchMove(event) {
              this.internalMove(event);
            }
            /**
             * Move drag element with mouse.
             * @param event
             * @fires beforeDragStart
             * @fires dragStart
             * @private
             */

          }, {
            key: "onMouseMove",
            value: function onMouseMove(event) {
              this.internalMove(event);
            }
            /**
             * Updates drag, called when an element is grabbed and mouse moves
             * @private
             * @fires drag
             */

          }, {
            key: "update",
            value: function update(event, scrollManagerConfig) {
              var me = this,
                  context = me.context,
                  draggingElement = context.dragProxy || context.element; // two different modes used

              var target = event.target,
                  scrollingPageElement = document.scrollingElement || document.body; // "pointer-events:none" touchmove has no effect for the touchmove event target, meaning we cannot know
              // what's under the cursor as easily in touch devices

              if (event.type === 'touchmove') {
                var touch = event.changedTouches[0];
                target = _DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].elementFromPoint(touch.clientX + scrollingPageElement.scrollLeft, touch.clientY + scrollingPageElement.scrollTop);
              }

              context.target = target;

              if (me.dropTargetSelector) {
                context.valid = Boolean(target.closest(me.dropTargetSelector));
              } else {
                // assume valid drop location
                context.valid = true;
              } // Move the drag proxy or dragged element before triggering the drag event


              if (context.action) {
                if (context.action === 'container') {
                  me.updateContainerProxy(event, scrollManagerConfig);
                }

                if (context.action.startsWith('translate')) {
                  me.updateTranslateProxy(event, scrollManagerConfig);
                }
              } // Allow external code to validate the context before updating a container drag


              me.trigger('drag', {
                context: context,
                event: event
              }); // Move the placeholder element into its new place.
              // This will see the new state of context if mutated by a drag listener.

              if (context.action === 'container') {
                me.updateContainerDrag(event, scrollManagerConfig);
              } // change to toggle with force when not supporting IE11 any longer


              draggingElement.classList[context.valid ? 'remove' : 'add'](me.invalidCls);
              if (event) me.lastMouseMoveEvent = event;
            }
            /**
             * Abort dragging
             * @fires abort
             */

          }, {
            key: "abort",
            value: function abort() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  context = me.context;
              me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);

              if (context) {
                // Force a synchronous layout so that transitions from this point will work.
                context.element.getBoundingClientRect(); // Aborted drag not considered valid

                context.valid = false;

                if (context.action === 'container') {
                  me.abortContainerDrag(undefined, undefined, silent);
                } else {
                  me.abortTranslateDrag(undefined, undefined, silent);
                }
              }

              me.reset();
            } // Empty class implementation. If listeners *are* added, the detacher is added
            // as an instance property. So this is always callable.

          }, {
            key: "removeListeners",
            value: function removeListeners() {} // Called when a drag operation is completed, aborted, or when drag doesn't start (simple click)
            // Removes DOM listeners and resets context

          }, {
            key: "reset",
            value: function reset() {
              document.body.classList.remove('b-draghelper-active');
              this.removeListeners();
              /**
               * Fired when a drag operation is completed, aborted, or when drag doesn't start (simple click)
               * @event reset
               * @private
               * @param {DragHelper} dragHelper
               */

              this.trigger('reset');
              this.context = this.lastMouseMoveEvent = null;
            }
          }, {
            key: "onTouchEnd",
            value: function onTouchEnd(event) {
              this.onMouseUp(event);
            }
            /**
             * This is a capture listener, only added during drag, which prevents a click gesture
             * propagating from the terminating mouseup geature
             * @param {MouseEvent} event
             * @private
             */

          }, {
            key: "onDocumentClick",
            value: function onDocumentClick(event) {
              event.stopPropagation();
            }
            /**
             * Drop on mouse up (if dropped on valid target).
             * @param event
             * @private
             */

          }, {
            key: "onMouseUp",
            value: function onMouseUp(event) {
              var me = this,
                  context = me.context;
              me.removeListeners();

              if (context) {
                me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);

                if (context.action === 'container') {
                  me.finishContainerDrag(event);
                } else if (context.started && context.action.startsWith('translate')) {
                  me.finishTranslateDrag(event);
                }

                if (context.started) {
                  // Prevent the impending document click from the mouseup event from propagating
                  // into a click on our element.
                  var clickPreventer = _EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
                    element: document,
                    thisObj: me,
                    click: documentListeners.docclick,
                    capture: true,
                    once: true
                  }); // In case a click did not ensue, remove the listener


                  me.setTimeout(clickPreventer, 50);
                } else {
                  me.reset();
                }
              }
            }
            /**
             * Cancel on ESC key
             * @param event
             * @private
             */

          }, {
            key: "onKeyDown",
            value: function onKeyDown(event) {
              if (event.key === 'Escape') this.abort();
            }
            /**
             * Creates the proxy element to be dragged, when using {@link #config-cloneTarget}. Clones the original element by default
             */

          }, {
            key: "createProxy",
            value: function createProxy(element) {
              var clone = element.cloneNode(true);
              clone.removeAttribute('id');
              return clone;
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Drag proxy CSS class
                 * @config {String}
                 * @default
                 * @private
                 */
                dragProxyCls: 'b-drag-proxy',

                /**
                 * CSS class added when drag is invalid
                 * @config {String}
                 * @default
                 */
                invalidCls: 'b-drag-invalid',

                /**
                 * CSS class added to the source element in Container drag
                 * @config {String}
                 * @default
                 * @private
                 */
                draggingCls: 'b-dragging',

                /**
                 * CSS class added to the source element in Container drag
                 * @config {String}
                 * @default
                 * @private
                 */
                dropPlaceholderCls: 'b-drop-placeholder',

                /**
                 * CSS class added when resizing
                 * @config {String}
                 * @default
                 * @private
                 */
                resizingCls: 'b-resizing',

                /**
                 * The amount of pixels to move mouse before it counts as a drag operation
                 * @config {Number}
                 * @default
                 */
                dragThreshold: 5,

                /**
                 * Resizing handle size
                 * @config {Number}
                 * @default
                 */
                handleSize: 10,

                /**
                 * Resizing handle size on touch devices
                 * @config {Number}
                 * @default
                 */
                touchHandleSize: 30,

                /**
                 * Minimum width when resizing
                 * @config {Number}
                 * @default
                 */
                minWidth: 1,

                /**
                 * The outer element where the drag helper will operate (attach events to it and use as outer limit when looking for ancestors)
                 * @config {HTMLElement}
                 * @default
                 */
                outerElement: document.body,

                /**
                 * Outer element that limits where element can be dragged
                 * @config {HTMLElement}
                 * @default
                 */
                dragWithin: null,

                /**
                 * Constrain translate drag to dragWithin elements bounds (set to false to allow it to "overlap" edges)
                 * @config {Boolean}
                 * @default
                 */
                constrain: true,

                /**
                 * Smallest allowed x when dragging horizontally.
                 * @config {Number}
                 * @default
                 */
                minX: null,

                /**
                 * Largest allowed x when dragging horizontally.
                 * @config {Number}
                 * @default
                 */
                maxX: null,

                /**
                 * Smallest allowed y when dragging horizontally.
                 * @config {Number}
                 * @default
                 */
                minY: null,

                /**
                 * Largest allowed y when dragging horizontally.
                 * @config {Number}
                 * @default
                 */
                maxY: null,

                /**
                 * Enabled dragging, specify mode:
                 * <table>
                 * <tr><td>container<td>Allows reordering elements within one and/or between multiple containers
                 * <tr><td>translateXY<td>Allows dragging within a parent container
                 * </table>
                 * @config {String}
                 * @default
                 * @private
                 */
                mode: null,

                /**
                 * A function that determines if dragging an element is allowed. Gets called with the element as argument,
                 * return true to allow dragging or false to prevent.
                 * @config {Function}
                 * @default
                 */
                isElementDraggable: null,

                /**
                 * A CSS selector used to determine if dragging an element is allowed.
                 * @config {String}
                 * @default
                 */
                targetSelector: null,

                /**
                 * A CSS selector used to determine if a drop is allowed at the current position.
                 * @config {String}
                 * @default
                 */
                dropTargetSelector: null,

                /**
                 * Set to true to clone the dragged target, and not move the actual target DOM node.
                 * @config {Boolean}
                 * @default
                 */
                cloneTarget: false,

                /**
                 * Set to true to hide the original element while dragging (applicable when `cloneTarget` is true).
                 * @config {Boolean}
                 * @default
                 */
                hideOriginalElement: false,

                /**
                 * Containers whose elements can be rearranged (and moved between the containers). Used when
                 * mode is set to "container".
                 * @config {HTMLElement[]}
                 * @default
                 */
                containers: null,

                /**
                 * A CSS selector used to exclude elements when using container mode
                 * @config {String}
                 * @default
                 */
                ignoreSelector: null,

                /**
                 * A CSS selector used to determine where handles should be "displayed" when resizing. Defaults to
                 * targetSelector if unspecified
                 * @config {String}
                 * @default
                 */
                handleSelector: null,
                startEvent: null,

                /**
                 * Configure as `true` to disallow dragging in the `X` axis. The dragged element will only move vertically.
                 * @config {Boolean}
                 * @default
                 */
                lockX: false,

                /**
                 * Configure as `true` to disallow dragging in the `Y` axis. The dragged element will only move horizontally.
                 * @config {Boolean}
                 * @default
                 */
                lockY: false,
                touchStartDelay: 300,
                ignoreSamePositionDrop: true
              };
            }
          }]);

          return DragHelper;
        }(Object(_MixinHelper_js__WEBPACK_IMPORTED_MODULE_13__["base"])(_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"]).mixes(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_8__["default"], _mixin_DragHelperContainer_js__WEBPACK_IMPORTED_MODULE_9__["default"], _mixin_DragHelperTranslate_js__WEBPACK_IMPORTED_MODULE_10__["default"]));

        DragHelper._$name = 'DragHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/EventHelper.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/helper/EventHelper.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperEventHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventHelper;
        });
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _util_Point_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./util/Point.js */
        "../Grid/lib/Common/helper/util/Point.js");
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony import */


        var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/EventHelper
         */

        var touchProperties = ['clientX', 'clientY', 'pageX', 'pageY', 'screenX', 'screenY'],
            isOption = {
          element: 1,
          thisObj: 1,
          once: 1,
          delegate: 1,
          delay: 1,
          capture: 1,
          passive: 1,
          throttled: 1,
          autoDetach: 1
        },
            ctrlKeyProp = {
          get: function get() {
            return true;
          }
        },
            normalizedKeyNames = {
          Spacebar: 'Space',
          Del: 'Delete',
          Esc: 'Escape',
          Left: 'ArrowLeft',
          Up: 'ArrowUp',
          Right: 'ArrowRight',
          Down: 'ArrowDown'
        },
            fixEvent = function fixEvent(event) {
          var type = event.type; // Normalize key names

          if (type.startsWith('key')) {
            var normalizedKeyName = normalizedKeyNames[event.key];

            if (normalizedKeyName) {
              Object.defineProperty(event, 'key', {
                get: function get() {
                  return normalizedKeyName;
                }
              });
            } // Polyfill the code property for SPACE because it is not set for synthetic events.


            if (event.key === ' ' && !event.code) {
              Object.defineProperty(event, 'code', {
                get: function get() {
                  return 'Space';
                }
              });
            }
          } // Sync OSX's meta key with the ctrl key. This will only happen on Mac platform.
          // It's read-only, so define a local property to return true for ctrlKey.


          if (event.metaKey && !event.ctrlKey) {
            Object.defineProperty(event, 'ctrlKey', ctrlKeyProp);
          } // When we listen to event on document and get event which bubbled from shadow dom, reading its target would
          // return shadow root element. We need actual element which started the event


          if (event.target && event.target.shadowRoot && event.composedPath && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isIE11 && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isEdge) {
            var targetElement = event.composedPath()[0],
                originalTarget = event.target; // Can there be an event which actually originated from custom element, not its shadow dom?

            if (event.target !== targetElement) {
              Object.defineProperty(event, 'target', {
                get: function get() {
                  return targetElement;
                }
              }); // Save original target just in case

              Object.defineProperty(event, 'originalTarget', {
                get: function get() {
                  return originalTarget;
                }
              });
            }
          } // Firefox has a bug where it can report that the target is the #document when mouse is over a pseudo element


          if (event.target && event.target.nodeType === 9 && 'clientX' in event) {
            var _targetElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].elementFromPoint(event.clientX, event.clientY);

            Object.defineProperty(event, 'target', {
              get: function get() {
                return _targetElement;
              }
            });
          } // Firefox has a bug where it can report a textNode as an event target/relatedTarget.
          // We standardize this to report the parentElement.


          if (event.target && event.target.nodeType === 3) {
            var _targetElement2 = event.target.parentElement;
            Object.defineProperty(event, 'target', {
              get: function get() {
                return _targetElement2;
              }
            });
          }

          if (event.relatedTarget && event.relatedTarget.nodeType === 3) {
            var relatedTargetElement = event.target.parentElement;
            Object.defineProperty(event, 'relatedTarget', {
              get: function get() {
                return relatedTargetElement;
              }
            });
          } // If it's a touch event, move the positional details
          // of touches[0] up to the event.


          if (type.startsWith('touch') && event.touches.length) {
            EventHelper.normalizeEvent(event);
          }

          return event;
        };
        /**
         * Utility methods for dealing with Events, normalizing Touch/Pointer/Mouse events.
         */


        var EventHelper =
        /*#__PURE__*/
        function () {
          function EventHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, EventHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(EventHelper, null, [{
            key: "normalizeEvent",
            value: function normalizeEvent(event) {
              return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].copyPropertiesIf(event, event.touches[0] || event.changedTouches[0], touchProperties);
            }
            /**
             * Returns the `[x, y]` coordinates of the event in the viewport coordinate system.
             * @param {Event} event The event
             * @return {Number[]} The coordinate.
             */

          }, {
            key: "getXY",
            value: function getXY(event) {
              if (event.touches) {
                event = event.touches[0];
              }

              return [event.clientX, event.clientY];
            }
            /**
             * Returns the pixel distance between two mouse/touch/pointer events.
             * @param {Event} event1 The first event.
             * @param {Event} event2 The second event.
             * @return {Number} The distance in pixels between the two events.
             */

          }, {
            key: "getDistanceBetween",
            value: function getDistanceBetween(event1, event2) {
              var xy1 = this.getXY(event1),
                  xy2 = this.getXY(event2); // No point in moving this to Point. We are dealing only with number values here.

              return Math.sqrt(Math.pow(xy1[0] - xy2[0], 2) + Math.pow(xy1[1] - xy2[1], 2));
            }
            /**
             * Returns a {@link Common.helper.util.Point} which encapsulates the `pageX/Y` position of the event.
             * May be used in {@link Common.helper.util.Rectangle} events.
             * @param {Event} event A browser mouse/touch/pointer event.
             * @return {Common.helper.util.Point} The page point.
             */

          }, {
            key: "getPagePoint",
            value: function getPagePoint(event) {
              return new _util_Point_js__WEBPACK_IMPORTED_MODULE_6__["default"](event.pageX, event.pageY);
            }
            /**
             * Returns a {@link Common.helper.util.Point} which encapsulates the `clientX/Y` position of the event.
             * May be used in {@link Common.helper.util.Rectangle} events.
             * @param {Event} event A browser mouse/touch/pointer event.
             * @return {Common.helper.util.Point} The page point.
             */

          }, {
            key: "getClientPoint",
            value: function getClientPoint(event) {
              return new _util_Point_js__WEBPACK_IMPORTED_MODULE_6__["default"](event.clientX, event.clientY);
            }
            /**
             * Add a listener or listeners to an element
             * @param {HTMLElement} element The element to add a listener/listeners to.
             * @param {String|Object} eventName Either a string, being the name of the event to listen for,
             * or an options object containing event names and options as keys. See the options parameter
             * for details, or the {@link #function-on-static} method for details.
             * @param {Function} [handler] If the second parameter is a string event name, this is the handler function.
             * @param {Object} [options] If the second parameter is a string event name, this is the options.
             * @param {HTMLElement} options.element The element to add the listener to.
             * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
             * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
             * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
             * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
             * @param {Number} [options.delay] The number of millieconds to delay the handler call after the event fires:
             *
             *     {
             *         once       : true,           // Removed upon first firing
             *         delegate   : this.iconCls,   // Only when clicking the icon
             *         thisObj    : this            // The this reference when the handler is called
             *                                      // Listener is removed when thisObj is destroyed
             *     }
             * @returns {Function} A detacher function which removes all the listeners when called.
             */

          }, {
            key: "addListener",
            value: function addListener(element, eventName, handler, options) {
              if (element.nodeType) {
                // All separate params, element, eventname and handler
                if (typeof eventName === 'string') {
                  options = Object.assign(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()({
                    element: element
                  }, eventName, handler), options);
                } // element, options
                else {
                    options = Object.assign({
                      element: element
                    }, eventName);
                  }
              } // Just an options object passed
              else {
                  options = element;
                }

              return this.on(options);
            }
            /**
             * Adds a listener or listeners to an element.
             * all property names other than the options listed below are taken to be event names,
             * and the values as handler specs.
             *
             * A handler spec is usually a function reference or the name of a function in the `thisObj`
             * option.
             *
             * But a handler spec may also be an options object containing a `handler` property which is
             * the function or function name, and local options, including `element` and `thisObj`
             * which override the top level options.
             *
             *  Usage example
             *
             * ```javascript
             * construct(config) {
             *     super.construct(config);
             *
             *     // Add auto detaching event handlers to this Widget's reference elements
             *     EventHelper.on({
             *         element : this.iconElement,
             *         click   : '_handleIconClick',
             *         thisObj : this,
             *         contextmenu : {
             *             element : document,
             *             handler : '_handleDocumentContextMenu'
             *         }
             *     });
             * }
             *```
             *
             * The `click` handler on the `iconElement` calls `this._handleIconClick`.
             *
             * The `contextmenu` handler is added to the `document` element, but the `thisObj`
             * is defaulted in from the top `options` and calls `this._handleDocumentContextMenu`.
             *
             * Note that on touch devices, `dblclick` and `contextmenu` events are synthesized.
             * Synthesized events contain a `browserEvent` property containing the final triggering
             * event of the gesture. For example a synthesized `dblclick` event would contain a
             * `browserEvent` property which is the last `touchend` event. A synthetic `contextmenu`
             * event will contain a `browserEvent` property which the longstanding `touchstart` event.
             *
             * @param {Object} options The full listener specification.
             * @param {HTMLElement} options.element The element to add the listener to.
             * @param {Object} options.thisObj The default `this` reference for all handlers added in this call.
             * @param {Boolean} [options.autoDetach=true] The listeners are automatically removed when the `thisObj` is destroyed.
             * @param {String} [options.delegate] A CSS selector string which only fires the handler when the event takes place in a matching element.
             * @param {Boolean} [options.once] Specify as `true` to have the listener(s) removed upon first invocation.
             * @param {Number} [options.delay] The number of millieconds to delay the handler call after the event fires.
             * @param {Number} [options.throttled] For rapidly repeating events (Such as `wheel` or `scroll` or `mousemove`)
             * this is the number of millieconds to delay subsequent handler calls after first invocation which happens immediately.
             * @returns {Function} A detacher function which removes all the listeners when called.
             *
             */

          }, {
            key: "on",
            value: function on(options) {
              var EventHelper = this,
                  element = options.element,
                  thisObj = options.thisObj,
                  handlerDetails = [],
                  keys = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].allKeys(options);

              var len = keys.length,
                  i,
                  eventName;

              for (i = 0; i < len; i++) {
                eventName = keys[i]; // Only treat it as an event name if it's not a supported option

                if (!isOption[eventName]) {
                  var handlerSpec = options[eventName];

                  if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(handlerSpec) !== 'object') {
                    handlerSpec = {
                      handler: handlerSpec
                    };
                  }

                  var targetElement = handlerSpec.element || element; // If we need to convert taphold to an emulated contextmenu, add a wrapping function
                  // in addition to the contextmenu listener. Platforms may support mouse *and* touch.

                  if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isTouchDevice) {
                    if (eventName === 'contextmenu') {
                      handlerDetails.push(EventHelper.addElementListener(targetElement, 'touchstart', {
                        handler: EventHelper.createContextMenuWrapper(handlerSpec.handler, handlerSpec.thisObj || thisObj)
                      }, options));
                    } else if (eventName === 'dblclick') {
                      handlerDetails.push(EventHelper.addElementListener(targetElement, 'touchend', {
                        handler: EventHelper.createDblClickWrapper(targetElement, handlerSpec.handler, handlerSpec.thisObj || thisObj),
                        delay: 10,
                        capture: true
                      }, options));
                    }
                  } // Keep track of the real handlers added.
                  // addElementLister returns [ element, eventName, addedfunction, capture ]


                  handlerDetails.push(EventHelper.addElementListener(targetElement, eventName, handlerSpec, options));
                }
              }

              var detacher = function detacher() {
                len = handlerDetails.length;

                for (i = 0; i < len; i++) {
                  var _handlerSpec = handlerDetails[i];

                  _handlerSpec[0].removeEventListener(_handlerSpec[1], _handlerSpec[2], _handlerSpec[3]);
                }

                handlerDetails.length = 0;
              }; // { autoDetach : true, thisObj : scheduler } means remove all listeners when the scheduler dies.


              if (thisObj && options.autoDetach !== false) {
                thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].createInterceptor(thisObj.doDestroy, detacher, thisObj);
              }

              return detacher;
            }
            /**
             * Used internally to add a single event handler to an element.
             * @param {HTMLElement} element The element to add the handler to.
             * @param {String} eventName The name of the event to add a handler for.
             * @param {Function|String|Object} handlerSpec Either a function to call, or
             * the name of a function to call in the `thisObj`, or an object containing
             * the handler local options.
             * @param {Function|String} [handlerSpec.handler] Either a function to call, or
             * the name of a function to call in the `thisObj`.
             * @param {HTMLElement} [handlerSpec.element] Optionally a local element for the listener.
             * @param {Object} [handlerSpec.thisObj] A local `this` specification for the handler.
             * @param {Object} defaults The `options` parameter from the {@link #function-addListener-static} call.
             * @private
             */

          }, {
            key: "addElementListener",
            value: function addElementListener(element, eventName, handlerSpec, defaults) {
              var handler = this.createHandler(element, eventName, handlerSpec, defaults),
                  handlerHasPassive = 'passive' in handlerSpec;
              var options = handlerSpec.capture || defaults.capture; // If we are passed the passive option and the browser supports it, then convert
              // The capture option into the object options form.

              if ((handlerHasPassive || 'passive' in defaults) && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].supportsPassive) {
                options = {
                  capture: !!options,
                  passive: handlerHasPassive ? handlerSpec.passive : defaults.passive
                };
              }

              element.addEventListener(eventName, handler, options);
              return [element, eventName, handler, options];
            }
          }, {
            key: "createHandler",
            value: function createHandler(element, eventName, handlerSpec, defaults) {
              var _this = this;

              var delay = handlerSpec.delay || defaults.delay,
                  throttled = handlerSpec.throttled || defaults.throttled,
                  once = handlerSpec.once || defaults.once,
                  thisObj = handlerSpec.thisObj || defaults.thisObj,
                  capture = handlerSpec.capture || defaults.capture,
                  delegate = handlerSpec.delegate || defaults.delegate; //Capture initial conditions in case of destruction of thisObj.
              // Destruction completely wipes the object.

              var wrappedFn = handlerSpec.handler,
                  // Innermost level of wrapping which calls the user's handler.
              // Normalize the event cross-browser, and attempt to normalize touch events.
              // Resolve named functions in the thisObj.
              _handler = function handler(event) {
                var _wrappedFn; // When playing a demo using DemoBot, only handle synthetic events


                if (_this.playingDemo && event.isTrusted) {
                  return;
                } // If the thisObj is already destroyed, we cannot call the function.
                // If in dev mode, warn the developer with a JS error.


                if (thisObj && thisObj.isDestroyed) {
                  // eslint-disable-next-line
                  return;
                } // Fix up events to handle various browser inconsistencies


                fixEvent(event); // delegate: '.b-field-trigger' only fires when click is in a matching el.
                // currentTarget becomes the delegate.

                if (delegate) {
                  // Maintainer: In Edge event.target can be an empty object for transitionend events
                  var delegatedTarget = event.target instanceof HTMLElement && event.target.closest(delegate);

                  if (!delegatedTarget) {
                    return;
                  } // Allow this to be redefined as it bubbles through listeners up the parentNode axis
                  // which might have their own delegate settings.


                  Object.defineProperty(event, 'currentTarget', {
                    get: function get() {
                      return delegatedTarget;
                    },
                    configurable: true
                  });
                }

                if (typeof wrappedFn === 'string') {
                  wrappedFn = thisObj[wrappedFn];
                }

                for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                  args[_key - 1] = arguments[_key];
                }

                (_wrappedFn = wrappedFn).call.apply(_wrappedFn, [thisObj, event].concat(args));
              }; // Go through options, each creates a new handler by wrapping the previous handler to implement the options.
              // Right now, we have delay. Note that it may be zero, so test != null


              if (delay != null) {
                var _wrappedFn2 = _handler;

                _handler = function handler() {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }

                  setTimeout(function () {
                    _wrappedFn2.apply(void 0, args);
                  }, delay);
                };
              } // If they specified the throttled option, wrap the hander in a createdThrottled
              // version. Allow the called to specify an alt function to call when the event
              // fires before the buffer time has expired.


              if (throttled != null) {
                var alt,
                    buffer = throttled;

                if (throttled.buffer) {
                  alt = function alt(e) {
                    return throttled.alt.call(_this, fixEvent(e));
                  };

                  buffer = throttled.buffer;
                }

                _handler = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].createThrottled(_handler, buffer, thisObj, null, alt);
              } // This must always be the last option processed so that it is the outermost handler
              // which is the one added to the element and is called immediately so that the
              // handler is removed immediately.
              // TODO: Use the native once option when all browsers support it. Only IE11 doesn't.


              if (once) {
                var _wrappedFn3 = _handler;

                _handler = function handler() {
                  element.removeEventListener(eventName, _handler, capture);

                  _wrappedFn3.apply(void 0, arguments);
                };
              } // Only autoDetach here if there's a local thisObj is in the handlerSpec for this one listener.
              // If it's in the defaults, then the "on" method will handle it.


              if (handlerSpec.thisObj && handlerSpec.autoDetach !== false) {
                thisObj.doDestroy = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].createInterceptor(thisObj.doDestroy, function () {
                  return element.removeEventListener(eventName, _handler);
                }, thisObj);
              }

              return _handler;
            }
            /**
             * Private function to wrap the passed function. The returned wrapper function to be used as
             * a `touchstart` handler which will call the passed function passing a fabricated `contextmenu`
             * event if there's no `touchend` or `touchmove` after a default of 400ms.
             * @param {String|Function} handler The handler to call.
             * @param {Object} thisObj The owner of the function.
             * @private
             */

          }, {
            key: "createContextMenuWrapper",
            value: function createContextMenuWrapper(handler, me) {
              var EventHelper = this;
              return function (event) {
                // Only attempt conversion to contextmenu if it's a single touch start.
                if (event.touches.length === 1) {
                  var tapholdStartTouch = event.touches[0],
                      // Dispatch a synthetic "contextmenu" event from the touchpoint in <longPressTime> milliseconds.
                  tapholdTimer = setTimeout(function () {
                    // Remove the gesture cancelling listeners
                    touchMoveRemover();
                    var contextmenuEvent = new MouseEvent('contextmenu', tapholdStartTouch);
                    Object.defineProperty(contextmenuEvent, 'target', {
                      get: function get() {
                        return tapholdStartTouch.target;
                      }
                    });

                    if (typeof handler === 'string') {
                      handler = me[handler];
                    }

                    contextmenuEvent.browserEvent = event; // Call the wrapped handler passing the fabricated contextmenu event

                    handler.call(me, contextmenuEvent);
                    EventHelper.contextMenuTouchId = tapholdStartTouch.identifier;
                  }, EventHelper.longPressTime),
                      // This is what gets called if the user moves their touchpoint,
                  // or releases the touch before <longPressTime>ms is up
                  cancelTapholdTimer = function cancelTapholdTimer() {
                    EventHelper.contextMenuTouchId = null;
                    touchMoveRemover();
                    clearTimeout(tapholdTimer);
                  },
                      // Touchmove or touchend before that timer fires cancels the timer and removes these listeners.
                  touchMoveRemover = EventHelper.on({
                    element: document,
                    touchmove: cancelTapholdTimer,
                    touchend: cancelTapholdTimer,
                    pointermove: cancelTapholdTimer,
                    pointerup: cancelTapholdTimer,
                    capture: true
                  });
                }
              };
            }
            /**
             * Private function to wrap the passed function. The returned wrapper function to be used as
             * a `touchend` handler which will call the passed function passing a fabricated `dblclick`
             * event if there is a `click` within 300ms.
             * @param {String|Function} handler The handler to call.
             * @param {Object} thisObj The owner of the function.
             * @private
             */

          }, {
            key: "createDblClickWrapper",
            value: function createDblClickWrapper(element, handler, me) {
              var EventHelper = this;
              var startId, secondListenerDetacher, tapholdTimer;
              return function () {
                if (!secondListenerDetacher) {
                  secondListenerDetacher = EventHelper.on({
                    element: element,
                    // We only get here if a touchstart arrives within 300ms of a click
                    touchstart: function touchstart(secondStart) {
                      startId = secondStart.changedTouches[0].identifier; // Prevent zoom

                      secondStart.preventDefault();
                    },
                    touchend: function touchend(secondClick) {
                      if (secondClick.changedTouches[0].identifier === startId) {
                        secondClick.preventDefault();
                        clearTimeout(tapholdTimer);
                        startId = secondListenerDetacher = null;

                        var targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(secondClick.changedTouches[0].target, null, true),
                            offsetX = secondClick.changedTouches[0].pageX - targetRect.x,
                            offsetY = secondClick.changedTouches[0].pageY - targetRect.y,
                            dblclickEventConfig = Object.assign({
                          browserEvent: secondClick
                        }, secondClick),
                            dblclickEvent = new MouseEvent('dblclick', dblclickEventConfig);

                        Object.defineProperty(dblclickEvent, 'target', {
                          get: function get() {
                            return secondClick.target;
                          }
                        });
                        Object.defineProperty(dblclickEvent, 'offsetX', {
                          get: function get() {
                            return offsetX;
                          }
                        });
                        Object.defineProperty(dblclickEvent, 'offsetY', {
                          get: function get() {
                            return offsetY;
                          }
                        });

                        if (typeof handler === 'string') {
                          handler = me[handler];
                        } // Call the wrapped handler passing the fabricated dblclick event


                        handler.call(me, dblclickEvent);
                      }
                    },
                    once: true
                  }); // Cancel the second listener is there's no second click within <dblClickTime> milliseconds.

                  tapholdTimer = setTimeout(function () {
                    secondListenerDetacher();
                    startId = secondListenerDetacher = null;
                  }, EventHelper.dblClickTime);
                }
              };
            }
          }, {
            key: "lockComposedPath",
            value: function lockComposedPath(event) {
              if (event.composedPath) {
                event.composedPath = function (path) {
                  return function () {
                    return path;
                  };
                }(event.composedPath());
              }
            }
          }]);

          return EventHelper;
        }();
        /**
         * The time in milliseconds for a `taphold` gesture to trigger a `contextmenu` event.
         * @member {Number} [longPressTime=500]
         * @readonly
         * @static
         */


        EventHelper.longPressTime = 500;
        /**
         * The time in milliseconds within which a second touch tap event triggers a `dblclick` event.
         * @member {Number} [dblClickTime=300]
         * @readonly
         * @static
         */

        EventHelper.dblClickTime = 300; // Flag body if last user action used keyboard, used for focus styling etc.

        EventHelper.on({
          element: document,
          mousedown: function mousedown() {
            if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isTouchEvent) {
              _DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].usingKeyboard = false;
              document.body.classList.remove('b-using-keyboard');
            }
          },
          touchmove: function touchmove() {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].usingKeyboard = false;
            document.body.classList.remove('b-using-keyboard');
          },
          keydown: function keydown() {
            _DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].usingKeyboard = true;
            document.body.classList.add('b-using-keyboard');
          }
        }); // When dragging on a touch device, we need to prevent scrolling from happening.
        // Dragging only starts on a touchmove event, by which time it's too late to preventDefault
        // on the touchstart event which started it.
        // To do this we need a capturing, non-passive touchmove listener at the document level so we can preventDefault.
        // This is in lieu of a functioning touch-action style on iOS Safari. When that's fixed, this will not be needed.

        if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isTouchDevice) {
          EventHelper.on({
            element: document,
            touchmove: function touchmove(event) {
              // If we're touching a b-dragging event, then stop any panning by preventing default.
              if (event.target.closest('.b-dragging')) {
                event.preventDefault();
              }
            },
            passive: false,
            capture: true
          });
        }

        EventHelper._$name = 'EventHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/FunctionHelper.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/helper/FunctionHelper.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperFunctionHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return FunctionHelper;
        });
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/FunctionHelper
        */

        /**
         * Provides functionality for working with functions
         * @internal
         */

        var FunctionHelper =
        /*#__PURE__*/
        function () {
          function FunctionHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, FunctionHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(FunctionHelper, null, [{
            key: "curry",
            value: function curry(func) {
              return function curried() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                if (args.length >= func.length) {
                  return func.apply(this, args);
                } else {
                  return function () {
                    for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                      args2[_key2] = arguments[_key2];
                    }

                    return curried.apply(this, args.concat(args2));
                  };
                }
              };
            }
          }, {
            key: "bindAll",
            value: function bindAll(obj) {
              for (var key in obj) {
                if (typeof obj[key] === 'function') {
                  obj[key] = obj[key].bind(obj);
                }
              }
            }
            /**
             * Returns a function which calls the passed `interceptor` function first, and the passed `original` after
             * as long as the `interceptor` does not return `false`.
             * @param {Function} original The function to call second.
             * @param {Function} interceptor The function to call first.
             * @param {Object} [thisObj] The `this` reference when the functions are called.
             * @returns The return value from the `original` function **if it was called**, else `false`.
             */

          }, {
            key: "createInterceptor",
            value: function createInterceptor(original, interceptor, thisObj) {
              return function () {
                for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                  args[_key3] = arguments[_key3];
                }

                if (interceptor.call.apply(interceptor, [thisObj].concat(args)) !== false) {
                  return original.call.apply(original, [thisObj].concat(args));
                }

                return false;
              };
            }
            /**
             * Returns a function which calls the passed `sequence` function after calling
             * the passed `original`.
             * @param {Function} original The function to call first.
             * @param {Function} sequence The function to call second.
             * @param {Object} [thisObj] The `this` reference when the functions are called.
             * @returns The value returned from the sequence if it returned a value, else the return
             * value from the original function.
             */

          }, {
            key: "createSequence",
            value: function createSequence(original, sequence, thisObj) {
              return function () {
                for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                  args[_key4] = arguments[_key4];
                }

                var origResult = original.call.apply(original, [thisObj].concat(args)),
                    sequenceResult = sequence.call.apply(sequence, [thisObj].concat(args));
                return sequenceResult === void 0 ? origResult : sequenceResult;
              };
            }
            /**
             * Create a "debounced" function which will call on the "leading edge" of a timer period.
             * When first invoked will call immediately, but invocations after that inside its buffer
             * period will be rejected, and *one* invocation will be made after the buffer period has expired.
             *
             * This is useful for responding immediately to a first mousemove, but from then on, only
             * calling the action function on a regular timer while the mouse continues to move.
             *
             * @param {Function} fn The function to call.
             * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
             * @param {Object} [thisObj] `this` reference for the function.
             * @param {Array} [extraArgs] The argument list to append to those passed to the function.
             * @param {Function} [alt] A function to call when the invocation is rejected due to buffer time not having expired.
             */

          }, {
            key: "createThrottled",
            value: function createThrottled(fn, buffer, thisObj, extraArgs, alt) {
              var lastCallTime = 0,
                  callArgs,
                  timerId,
                  result;

              var invoke = function invoke() {
                timerId = 0;
                lastCallTime = performance.now();
                callArgs.push.apply(callArgs, extraArgs);
                fn.apply(thisObj, callArgs);
              };

              result = function result() {
                var elapsed = performance.now() - lastCallTime;

                for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }

                callArgs = args; // If it's been more then the buffer period since we invoked, we can call it now

                if (elapsed >= buffer) {
                  clearTimeout(timerId);
                  invoke();
                } // Otherwise, kick off a timer for the requested period.
                else {
                    if (!timerId) {
                      timerId = setTimeout(invoke, buffer - elapsed);
                    }

                    if (alt) {
                      callArgs.push.apply(callArgs, extraArgs);
                      alt.apply(thisObj, callArgs);
                    }
                  }
              };

              result.cancel = function () {
                return clearTimeout(timerId);
              };

              return result;
            }
            /**
             * Create a "debounced" function which will call on the "trailing edge" of a timer period.
             * When first invoked will wait until the buffer period has expired to call the function, and
             * more calls within that time will restart the timer.
             *
             * This is useful for responding to keystrokes, but deferring action until the user pauses typing.
             *
             * @param {Function} fn The function to call.
             * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
             * @param {Object} [thisObj] `this` reference for the function.
             * @param {Array} [args] The argument list to append to those passed to the function.
             */

          }, {
            key: "createBuffered",
            value: function createBuffered(fn, buffer, thisObj, args) {
              var callArgs, timerId, result;

              var invoke = function invoke() {
                timerId = 0;
                callArgs.push.apply(callArgs, args);
                fn.apply(thisObj, callArgs);
              };

              result = function result() {
                for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                  args[_key6] = arguments[_key6];
                }

                callArgs = args; // Cancel any impending invocation. It's pushed out for <buffer> ms from each call

                if (timerId) {
                  clearTimeout(timerId);
                }

                timerId = setTimeout(invoke, buffer);
              };

              result.cancel = function () {
                return clearTimeout(timerId);
              };

              return result;
            }
          }, {
            key: "returnTrue",
            value: function returnTrue() {
              return true;
            }
          }, {
            key: "animate",
            value: function animate(duration, fn, scope) {
              var _this = this;

              var easing = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'linear';
              var cancel = false;
              var result = new Promise(function (resolve) {
                var start = performance.now(),
                    iterate = function iterate() {
                  var progress = Math.min((performance.now() - start) / duration, 1);

                  if (!cancel) {
                    if (fn.call(scope, _this.easingFunctions[easing](progress)) === false) {
                      resolve();
                    }
                  }

                  if (cancel || progress === 1) {
                    // Push resolution into the next animation frame so that
                    // this frame completes before the resolution handler runs.
                    requestAnimationFrame(function () {
                      return resolve();
                    });
                  } else {
                    requestAnimationFrame(iterate);
                  }
                };

                iterate();
              });

              result.cancel = function () {
                cancel = true;
                return false;
              };

              return result;
            }
          }]);

          return FunctionHelper;
        }();
        /* eslint-disable */


        var half = 0.5,
            e1 = 1.70158,
            e2 = 7.5625,
            e3 = 1.525,
            e4 = 2 / 2.75,
            e5 = 2.25 / 2.75,
            e6 = 1 / 2.75,
            e7 = 1.5 / 2.75,
            e8 = 2.5 / 2.75,
            e9 = 2.625 / 2.75,
            e10 = 0.75,
            e11 = 0.9375,
            e12 = 0.984375;
        FunctionHelper.easingFunctions = {
          linear: function linear(t) {
            return t;
          },
          easeInQuad: function easeInQuad(t) {
            return Math.pow(t, 2);
          },
          easeOutQuad: function easeOutQuad(t) {
            return -(Math.pow(t - 1, 2) - 1);
          },
          easeInOutQuad: function easeInOutQuad(t) {
            return (t /= half) < 1 ? half * Math.pow(t, 2) : -half * ((t -= 2) * t - 2);
          },
          easeInCubic: function easeInCubic(t) {
            return Math.pow(t, 3);
          },
          easeOutCubic: function easeOutCubic(t) {
            return Math.pow(t - 1, 3) + 1;
          },
          easeInOutCubic: function easeInOutCubic(t) {
            return (t /= half) < 1 ? half * Math.pow(t, 3) : half * (Math.pow(t - 2, 3) + 2);
          },
          easeInQuart: function easeInQuart(t) {
            return Math.pow(t, 4);
          },
          easeOutQuart: function easeOutQuart(t) {
            return -(Math.pow(t - 1, 4) - 1);
          },
          easeInOutQuart: function easeInOutQuart(t) {
            return (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2);
          },
          easeInQuint: function easeInQuint(t) {
            return Math.pow(t, 5);
          },
          easeOutQuint: function easeOutQuint(t) {
            return Math.pow(t - 1, 5) + 1;
          },
          easeInOutQuint: function easeInOutQuint(t) {
            return (t /= half) < 1 ? half * Math.pow(t, 5) : half * (Math.pow(t - 2, 5) + 2);
          },
          easeInSine: function easeInSine(t) {
            return -Math.cos(t * (Math.PI / 2)) + 1;
          },
          easeOutSine: function easeOutSine(t) {
            return Math.sin(t * (Math.PI / 2));
          },
          easeInOutSine: function easeInOutSine(t) {
            return -half * (Math.cos(Math.PI * t) - 1);
          },
          easeInExpo: function easeInExpo(t) {
            return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
          },
          easeOutExpo: function easeOutExpo(t) {
            return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
          },
          easeInOutExpo: function easeInOutExpo(t) {
            return t === 0 ? 0 : t === 1 ? 1 : (t /= half) < 1 ? half * Math.pow(2, 10 * (t - 1)) : half * (-Math.pow(2, -10 * --t) + 2);
          },
          easeInCirc: function easeInCirc(t) {
            return -(Math.sqrt(1 - t * t) - 1);
          },
          easeOutCirc: function easeOutCirc(t) {
            return Math.sqrt(1 - Math.pow(t - 1, 2));
          },
          easeInOutCirc: function easeInOutCirc(t) {
            return (t /= half) < 1 ? -half * (Math.sqrt(1 - t * t) - 1) : half * (Math.sqrt(1 - (t -= 2) * t) + 1);
          },
          easeOutBounce: function easeOutBounce(t) {
            return t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12;
          },
          easeInBack: function easeInBack(t) {
            return t * t * ((e1 + 1) * t - e1);
          },
          easeOutBack: function easeOutBack(t) {
            return (t = t - 1) * t * ((e1 + 1) * t + e1) + 1;
          },
          easeInOutBack: function easeInOutBack(t) {
            var s = 1.70158;
            return (t /= half) < 1 ? half * (t * t * (((s *= e3) + 1) * t - s)) : half * ((t -= 2) * t * (((s *= e3) + 1) * t + s) + 2);
          },
          elastic: function elastic(t) {
            return -1 * Math.pow(4, -8 * t) * Math.sin((t * 6 - 1) * (2 * Math.PI) / 2) + 1;
          },
          swingFromTo: function swingFromTo(t) {
            var s = 1.70158;
            return (t /= half) < 1 ? half * (t * t * (((s *= e3) + 1) * t - s)) : half * ((t -= 2) * t * (((s *= e3) + 1) * t + s) + 2);
          },
          swingFrom: function swingFrom(t) {
            return t * t * ((e1 + 1) * t - e1);
          },
          swingTo: function swingTo(t) {
            return (t -= 1) * t * ((e1 + 1) * t + e1) + 1;
          },
          bounce: function bounce(t) {
            return t < e6 ? e2 * t * t : t < e4 ? e2 * (t -= e7) * t + e10 : t < e8 ? e2 * (t -= e5) * t + e11 : e2 * (t -= e9) * t + e12;
          },
          bouncePast: function bouncePast(t) {
            return t < e6 ? e2 * t * t : t < e4 ? 2 - (e2 * (t -= e7) * t + e10) : t < e8 ? 2 - (e2 * (t -= e5) * t + e11) : 2 - (e2 * (t -= e9) * t + e12);
          },
          easeFromTo: function easeFromTo(t) {
            return (t /= half) < 1 ? half * Math.pow(t, 4) : -half * ((t -= 2) * Math.pow(t, 3) - 2);
          },
          easeFrom: function easeFrom(t) {
            return Math.pow(t, 4);
          },
          easeTo: function easeTo(t) {
            return Math.pow(t, 0.25);
          }
        };
        FunctionHelper._$name = 'FunctionHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/IdHelper.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/helper/IdHelper.js ***!
        \*********************************************/

      /*! exports provided: default, widgetMatches */

      /***/
      function GridLibCommonHelperIdHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return IdHelper;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "widgetMatches", function () {
          return widgetMatches;
        });
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "../Grid/node_modules/core-js/modules/es6.number.constructor.js");
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/IdHelper
         */

        function isInstanceOfClass(instance, type) {
          var classHierarchy = instance.classHierarchy();

          for (var i = 0; i < classHierarchy.length; i++) {
            if (classHierarchy[i].$name.toLowerCase() === type) {
              return true;
            }
          }

          return false;
        }
        /**
         * IdHelper keeps an internal map of objects and ids, allowing easy retrieval by id. It can generate and assign
         * unique ids (in IdHelper context, not guaranteed to be unique on page), either explicitly or when registering objects
         * in its map.
         *
         * IdHelper also supplies some useful functions for querying Widgets.
         *
         * This class is not intended for application use, it is used internally by the Brytum infrastructure.
         * @internal
         * @private
         */


        var IdHelper =
        /*#__PURE__*/
        function () {
          function IdHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, IdHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(IdHelper, null, [{
            key: "generateId",

            /**
             * Generate a new id, using IdHelpers internal counter and a prefix
             * @param {String} prefix Id prefix
             * @returns {String} Generated id
             */
            value: function generateId() {
              var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'generatedId';
              return prefix + ++IdHelper.idCounter;
            }
            /**
             * Register an object with IdHelper, assigning it a generated id if it has none. Throws if objects id is already
             * in use.
             * @param {Object} obj Any object
             * @param {String} prefix Prefix for generated id
             */

          }, {
            key: "register",
            value: function register(obj) {
              var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
              var objId = obj.id;

              if (objId == null) {
                objId = obj.id = IdHelper.generateId(prefix);
                obj.hasGeneratedId = true;
              } // Code editor sets `disableThrow` to not get conflicts when loading the same module again


              if (objId in IdHelper.idMap && !this.disableThrow) {
                throw new Error('Id ' + objId + ' already in use');
              }

              IdHelper.idMap[objId] = obj;
            }
            /**
             * Unregister from IdHelper, normally done on destruction
             * @param {Object} obj Object to unregister
             */

          }, {
            key: "unregister",
            value: function unregister(obj) {
              // (have to check for existence before deleting to work in Safari)
              if (IdHelper.idMap[obj.id]) delete IdHelper.idMap[obj.id];
            }
            /**
             * Get an object using id
             * @param {String} id Object id
             * @returns {*} Object or undefined if none found
             */

          }, {
            key: "get",
            value: function get(id) {
              return IdHelper.idMap[id];
            }
            /**
             * Analogous to document.querySelector, finds the first Bryntum widget matching the passed
             * selector. Right now, only class name (lowercased) selector strings, or
             * a filter function which returns `true` for required object are allowed:
             * ```
             * bryntum.query('grid').destroy();
             * ```
             * @param {String|Function} selector A lowercased class name, or a filter function.
             * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
             *   example 'widget' would then find a Grid
             * @return {Common.widget.Widget} The first matched widget if any.
             */

          }, {
            key: "query",
            value: function query(selector) {
              var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var idMap = IdHelper.idMap;

              for (var id in idMap) {
                if (widgetMatches(idMap[id], selector, deep)) {
                  return idMap[id];
                }
              }

              return null;
            }
            /**
             * Analogous to document.querySelectorAll, finds all Bryntum widgets matching the passed
             * selector. Right now, only registered widget `type` strings, or a filter function which
             * returns `true` for required object are allowed:
             * ```
             * let allFields = bryntum.queryAll('field', true);
             * ```
             * @param {String|Function} selector A lowercased class name, or a filter function.
             * @param {Boolean} [deep] Specify `true` to search the prototype chain (requires supplying a string `selector`). For
             *   example 'widget' would then find a Grid
             * @return {Common.widget.Widget[]} The first matched widgets if any - an empty array will be returned
             * if no matches are found.
             */

          }, {
            key: "queryAll",
            value: function queryAll(selector) {
              var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var idMap = IdHelper.idMap,
                  result = [];

              for (var id in idMap) {
                if (widgetMatches(idMap[id], selector, deep)) {
                  result.push(idMap[id]);
                }
              }

              return result;
            }
            /**
             * Returns the Widget which owns the passed element (or event).
             * @param {HTMLElement|Event} element The element or event to start from
             * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
             * class name. Or a filter function which returns `true` for the required Widget.
             * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
             * match of the type parameter, or the element to stop at.
             * @return {Widget} The found Widget or null.
             */

          }, {
            key: "fromElement",
            value: function fromElement(element, type, limit) {
              var typeOfType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(type); // Event passed


              if (element && element instanceof Event) {
                element = element.target;
              }

              if (typeOfType === 'number' || type && type.nodeType === 1) {
                limit = type;
                type = null;
              }

              var target = element,
                  cache = IdHelper.idMap,
                  depth = 0,
                  topmost,
                  cmpId,
                  cmp;

              if (typeof limit !== 'number') {
                topmost = limit;
                limit = Number.MAX_VALUE;
              }

              if (typeOfType === 'string') {
                type = type.toLowerCase();
              }

              while (target && target.nodeType === 1 && depth < limit && target !== topmost) {
                cmpId = target.dataset && target.dataset.ownerCmp || target.id;

                if (cmpId) {
                  cmp = cache[cmpId];

                  if (cmp) {
                    if (type) {
                      if (typeOfType === 'function') {
                        if (type(cmp)) {
                          return cmp;
                        }
                      } else if (widgetMatches(cmp, type) || isInstanceOfClass(cmp, type)) {
                        return cmp;
                      }
                    } else {
                      return cmp;
                    }
                  } // Increment depth on every *Widget* found


                  depth++;
                }

                target = target.parentNode;
              }

              return null;
            }
          }]);

          return IdHelper;
        }();

        function widgetMatches(candidate, selector, deep) {
          if (selector === '*') {
            return true;
          }

          if (typeof selector === 'function') {
            return selector(candidate);
          }

          return _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_4__["default"].isType(candidate, selector, deep);
        }

        IdHelper.idCounter = 0;
        IdHelper.idMap = {}; // Simplify querying widgets by exposing fns in bryntum ns

        (window.bryntum || (window.bryntum = {})).get = IdHelper.get;
        window.bryntum.IdHelper = IdHelper;
        window.bryntum.query = IdHelper.query;
        window.bryntum.queryAll = IdHelper.queryAll;
        window.bryntum.fromElement = IdHelper.fromElement;
        IdHelper._$name = 'IdHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/MixinHelper.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/helper/MixinHelper.js ***!
        \************************************************/

      /*! exports provided: base */

      /***/
      function GridLibCommonHelperMixinHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "base", function () {
          return base;
        });
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler'; //inspired by http://justinfagnani.com/2015/12/21/real-mixins-with-javascript-classes/

        var base = function base(baseClass) {
          return {
            mixes: function mixes() {
              for (var _len = arguments.length, mixins = new Array(_len), _key = 0; _key < _len; _key++) {
                mixins[_key] = arguments[_key];
              }

              return mixins.reduce(function (result, mixin) {
                return mixin(result);
              }, baseClass || _Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]);
            }
          };
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/helper/ObjectHelper.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/helper/ObjectHelper.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperObjectHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ObjectHelper;
        });
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "../Grid/node_modules/core-js/modules/es6.number.constructor.js");
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ./DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/ObjectHelper
         */

        var whiteSpaceRe = /\s+/,
            typeOf = function typeOf(value) {
          var baseType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(value); // If not atomic type, we handle date or null


          if (baseType === 'object') {
            if (value === null) {
              return 'null';
            }

            if (Object.prototype.toString.call(value) === '[object Date]') {
              return 'date';
            }
          }

          return baseType;
        }; // Detect if browser has bad implementation of toFixed()


        var toFixedFix = 1.005.toFixed(2) === '1.01' ? null : function (number, fractionDigits) {
          var split = number.toString().split('.'),
              newNumber = +(!split[1] ? split[0] : split.join('.') + '1');
          return number.toFixed.call(newNumber, fractionDigits);
        };
        /**
         * Helper for Object manipulation.
         */

        var ObjectHelper =
        /*#__PURE__*/
        function () {
          function ObjectHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, ObjectHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(ObjectHelper, null, [{
            key: "isEqual",

            /**
             * Checks if two values are equal. Basically === but special handling of dates.
             * @param a First value
             * @param b Second value
             * @returns {*} true if values are equal, otherwise false
             */
            value: function isEqual(a, b) {
              var _this = this;

              var useIsDeeply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // Eliminate null vs undefined mismatch

              if (a === null && b !== null || a === undefined && b !== undefined || b === null && a !== null || b === undefined && a !== undefined) {
                return false;
              } // Covers undefined === undefined and null === null, since mismatches are elminiated above


              if (a == null && b == null) {
                return true;
              }

              var typeA = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(a),
                  typeB = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(b);

              if (typeA === typeB) {
                switch (typeA) {
                  case 'number':
                  case 'string':
                  case 'boolean':
                    return a === b;
                }

                switch (true) {
                  case a instanceof Date && b instanceof Date:
                    // faster than calling DateHelper.isEqual
                    return a - b === 0;

                  case Array.isArray(a) && Array.isArray(b):
                    return a.length === b.length ? a.every(function (v, idx) {
                      return _this.isEqual(v, b[idx], useIsDeeply);
                    }) : false;

                  case typeA === 'object' && a.constructor.prototype === b.constructor.prototype:
                    return useIsDeeply ? this.isDeeplyEqual(a, b, useIsDeeply) : JSON.stringify(a) === JSON.stringify(b);
                }
              }

              return String(a) === String(b);
            }
            /**
             * Checks if two objects are deeply equal
             * @param {Object} a
             * @param {Object} b
             * @param {Object} [options] Additional comparison options
             * @param {Object} [options.ignore] Map of property names to ignore when comparing
             * @param {Function} [options.shouldEvaluate] Function used to evaluate if a property should be compared or not.
             * Return false to prevent comparision
             * @param {Function} [options.evaluate] Function used to evaluate equality. Return `true`/`false` as evaluation
             * result or anything else to let `isEqual` handle the comparision
             * @returns {Boolean}
             */

          }, {
            key: "isDeeplyEqual",
            value: function isDeeplyEqual(a, b) {
              var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}; // Same object, equal :)

              if (a === b) {
                return true;
              } // Nothing to compare, not equal


              if (!a || !b) {
                return false;
              } // Property names excluding ignored


              var aKeys = this.keys(a, options.ignore),
                  bKeys = this.keys(b, options.ignore); // Property count differs, not equal

              if (aKeys.length !== bKeys.length) {
                return false;
              }

              for (var i = 0; i < aKeys.length; i++) {
                var aKey = aKeys[i];
                var bKey = bKeys[i]; // Property name differs, not equal

                if (aKey !== bKey) {
                  return false;
                }

                var aVal = a[aKey];
                var bVal = b[bKey]; // Allow caller to determine if property values should be evaluated or not
                // TODO: Not currently used

                if (options.shouldEvaluate) {
                  if (options.shouldEvaluate(aKey, {
                    value: aVal,
                    object: a
                  }, {
                    value: bVal,
                    object: b
                  }) === false) {
                    continue;
                  }
                } // Allow caller to determine equality of properties


                if (options.evaluate) {
                  var result = options.evaluate(aKey, {
                    value: aVal,
                    object: a
                  }, {
                    value: bVal,
                    object: b
                  }); // Not equal

                  if (result === false) {
                    return false;
                  } // Equal, skip isEqual call below


                  if (result === true) {
                    continue;
                  }
                } // Values differ, not equal (also digs deeper)


                if (!this.isEqual(aVal, bVal, options)) {
                  return false;
                }
              } // Found to be equal


              return true;
            }
            /**
             * Checks if value B is partially equal to value A.
             * @param a First value
             * @param b Second value
             * @returns {Boolean} true if values are partially equal, false otherwise
             */

          }, {
            key: "isPartial",
            value: function isPartial(a, b) {
              a = String(a).toLowerCase();
              b = String(b).toLowerCase();
              return a.indexOf(b) != -1;
            }
            /**
             * Checks if value a is smaller than value b.
             * @param a First value
             * @param b Second value
             * @returns {Boolean} true if a < b
             */

          }, {
            key: "isLessThan",
            value: function isLessThan(a, b) {
              if (a instanceof Date && b instanceof Date) {
                return _DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isBefore(a, b);
              }

              return a < b;
            }
            /**
             * Checks if value a is bigger than value b.
             * @param a First value
             * @param b Second value
             * @returns {Boolean} true if a > b
             */

          }, {
            key: "isMoreThan",
            value: function isMoreThan(a, b) {
              if (a instanceof Date && b instanceof Date) {
                return _DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isAfter(a, b);
              }

              return a > b;
            }
            /**
             * Used by the Base class to make deep copies of defaultConfig blocks
             * @private
             */

          }, {
            key: "fork",
            value: function fork(obj) {
              var ret, key, value;

              if (obj && obj.constructor === Object) {
                ret = Object.setPrototypeOf({}, obj);

                for (key in obj) {
                  value = obj[key];

                  if (value) {
                    if (value.constructor === Object) {
                      ret[key] = this.fork(value);
                    } else if (value instanceof Array) {
                      ret[key] = value.slice();
                    }
                  }
                }
              } else {
                ret = obj;
              }

              return ret;
            }
          }, {
            key: "assign",
            value: function assign(dest) {
              var i = 0,
                  ln = arguments.length <= 1 ? 0 : arguments.length - 1,
                  source,
                  key;

              for (; i < ln; i++) {
                source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

                for (key in source) {
                  dest[key] = source[key];
                }
              }

              return dest;
            }
          }, {
            key: "clone",
            value: function clone(source) {
              if (source == null) {
                return source;
              }

              var type = source.constructor.name,
                  result = source,
                  i,
                  key; // Date

              if (type === 'Date') {
                return new Date(source.getTime());
              } // Array


              if (type === 'Array') {
                i = source.length;
                result = [];

                while (i--) {
                  result[i] = this.clone(source[i]);
                }
              } // Object
              else if (type === 'Object') {
                  result = {};

                  for (key in source) {
                    result[key] = this.clone(source[key]);
                  }
                }

              return result;
            }
          }, {
            key: "merge",
            value: function merge(dest) {
              var i = 0,
                  ln = arguments.length <= 1 ? 0 : arguments.length - 1,
                  source,
                  key,
                  value,
                  sourceKey;

              for (; i < ln; i++) {
                source = i + 1 < 1 || arguments.length <= i + 1 ? undefined : arguments[i + 1];

                for (key in source) {
                  value = source[key];

                  if (value && value.constructor === Object) {
                    sourceKey = dest[key];

                    if (sourceKey && sourceKey.constructor.name === 'Object') {
                      this.merge(sourceKey, value);
                    } else {
                      dest[key] = this.clone(value);
                    }
                  } else {
                    dest[key] = value;
                  }
                }
              }

              return dest;
            }
            /**
             * Copies the named properties from the `source` parameter into the `dest` parameter.
             * @param {Object} dest The destination into which properties are copied.
             * @param {Object} source The source from which properties are copied.
             * @param {String[]} props The list of property names.
             * @returns The `dest` object.
             */

          }, {
            key: "copyProperties",
            value: function copyProperties(dest, source, props) {
              var prop, i;

              for (i = 0; i < props.length; i++) {
                prop = props[i];

                if (prop in source) {
                  dest[prop] = source[prop];
                }
              }

              return dest;
            }
            /**
             * Copies the named properties from the `source` parameter into the `dest` parameter
             * unless the property already exists in the `dest`.
             * @param {Object} dest The destination into which properties are copied.
             * @param {Object} source The source from which properties are copied.
             * @param {String[]} props The list of property names.
             * @returns The `dest` object.
             */

          }, {
            key: "copyPropertiesIf",
            value: function copyPropertiesIf(dest, source, props) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = props[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var prop = _step.value;

                  if (!(prop in dest)) {
                    dest[prop] = source[prop];
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              return dest;
            }
            /**
             * Returns an array containing all enumerable property names from every prototype level for the object.
             * @param {Object} object Object to retrieve property names from
             * @param {Object} [ignore] Optional map of names to ignore
             * @returns {String[]} All keys from every prototype level.
             */

          }, {
            key: "keys",
            value: function keys(object) {
              var ignore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var result = [];

              for (var p in object) {
                if (!ignore || !ignore[p]) {
                  result.push(p);
                }
              }

              return result;
            }
            /**
             * Tests whether a passed object has any enumerable properties.
             * @param {Object} object
             * @returns {Boolean} `true` if the passed object has no enumerable properties.
             */

          }, {
            key: "isEmpty",
            value: function isEmpty(object) {
              for (var p in object) {
                // eslint-disable-line no-unused-vars
                return false;
              }

              return true;
            }
            /**
             * Gathers the names of properties which have truthy values into an array.
             *
             * This is useful when gathering CSS class names for complex element production.
             * Instead of appending to an array or string which may already contain the
             * name, and instead of contending with space separation and concatenation
             * and conditional execution, just set the properties of an object:
             *
             *     cls = {
             *         [this.selectedCls] : this.isSelected(thing),
             *         [this.dirtyCls] : this.isDirty(thing)
             *     };
             *
             * @param {Object} source Source of keys to gather into an array.
             * @returns {String[]} The keys which had a truthy value.
             */

          }, {
            key: "getTruthyKeys",
            value: function getTruthyKeys(source) {
              var keys = Object.keys(source);

              for (var i = 0; i < keys.length;) {
                if (source[keys[i]]) {
                  i++;
                } else {
                  keys.splice(i, 1);
                }
              }

              return keys;
            }
            /**
             * Gathers the values of properties which are truthy into an array.
             * @param {Object} source Source of values to gather into an array.
             * @returns {String[]} The truthy values from the passed object.
             */

          }, {
            key: "getTruthyValues",
            value: function getTruthyValues(source) {
              var keys = Object.keys(source);

              for (var i = 0; i < keys.length;) {
                if (source[keys[i]]) {
                  keys[i] = source[keys[i++]];
                } else {
                  keys.splice(i, 1);
                }
              }

              return keys;
            }
            /**
             * Converts a list of names, either an a space separated string, or
             * from an array, into a series of properties in an object with truthy
             * values. The Converse of {@link #function-getTruthyKeys-static}
             * @param {String|String[]} The list of names to convert to object form.
             */

          }, {
            key: "createTruthyKeys",
            value: function createTruthyKeys(source) {
              if (typeof source === 'string') {
                source = source.split(whiteSpaceRe);
              }

              var result = {};
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = source[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var key = _step2.value;

                  if (key.length) {
                    result[key] = 1;
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              return result;
            }
            /**
             * Returns an array of a given object's properties names including properties in
             * all superclasses, in the same order as we get with a normal loop.
             * @param {Object} source An object which may have properties in a prototype
             * chain, such as a configuration (These are chained because of inheritance).
             * @returns {String[]} The property names.
             */

          }, {
            key: "allKeys",
            value: function allKeys(object) {
              var result = [];

              for (object; object; object = Object.getPrototypeOf(object)) {
                result.push.apply(result, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(Object.keys(object)));
              }

              return result;
            }
            /**
             * Checks if a given path exists in an object
             * @param {Object} object Object to check path on
             * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
             * @returns {Boolean} Returns `true` if path exists or `false` if it does not
             */

          }, {
            key: "pathExists",
            value: function pathExists(object, path) {
              var properties = path.split('.');
              return properties.every(function (property) {
                if (!(property in object)) {
                  return false;
                }

                object = object[property];
                return true;
              });
            }
            /**
             * Returns value for a given path in the object
             * @param {Object} object Object to check path on
             * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
             * @returns {*} Value associated with passed key
             */

          }, {
            key: "getPath",
            value: function getPath(object, path) {
              return path.split('.').reduce(function (result, key) {
                return (result || {})[key];
              }, object);
            }
            /**
             * Sets value for a given path in the object
             * @param {Object} object Target object
             * @param {String} path Dot-separated path, e.g. 'object.childObject.someKey'
             * @param {*} value Value for a given path
             */

          }, {
            key: "setPath",
            value: function setPath(object, path, value) {
              path.split('.').reduce(function (result, key, index, array) {
                var isLast = index === array.length - 1;

                if (isLast) {
                  return result[key] = value;
                } else if (!(result[key] instanceof Object)) {
                  result[key] = {};
                }

                return result[key];
              }, object);
            }
          }, {
            key: "coerce",
            value: function coerce(from, to) {
              var fromType = typeOf(from),
                  toType = typeOf(to),
                  isString = typeof from === 'string';

              if (fromType !== toType) {
                switch (toType) {
                  case 'string':
                    return String(from);

                  case 'number':
                    return Number(from);

                  case 'boolean':
                    // See http://ecma262-5.com/ELS5_HTML.htm#Section_11.9.3 as to why '0'.
                    // TL;DR => ('0' == 0), so if given string '0', we must return boolean false.
                    return isString && (!from || from === 'false' || from === '0') ? false : Boolean(from);

                  case 'null':
                    return isString && (!from || from === 'null') ? null : false;

                  case 'undefined':
                    return isString && (!from || from === 'undefined') ? undefined : false;

                  case 'date':
                    return isString && isNaN(from) ? _DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].parse(from) : Date(Number(from));
                }
              }

              return from;
            }
          }, {
            key: "wrapProperty",
            value: function wrapProperty(object, propertyName, newGetter, newSetter) {
              var deep = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
              var newProperty = {};
              var proto = Object.getPrototypeOf(object),
                  existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);

              while (!existingProperty && proto && deep) {
                proto = Object.getPrototypeOf(proto);

                if (proto) {
                  existingProperty = Object.getOwnPropertyDescriptor(proto, propertyName);
                }
              }

              if (existingProperty) {
                if (existingProperty.set) {
                  newProperty.set = function (v) {
                    existingProperty.set.call(object, v); // Must invoke the getter in case "v" has been transformed.

                    newSetter && newSetter.call(object, existingProperty.get.call(object));
                  };
                } else {
                  newProperty.set = newSetter;
                }

                if (existingProperty.get) {
                  newProperty.get = function () {
                    var result = existingProperty.get.call(object);

                    if (newGetter) {
                      result = newGetter.call(object, result);
                    }

                    return result;
                  };
                } else {
                  newProperty.get = newGetter;
                }
              } else {
                newProperty.set = function (v) {
                  object["_".concat(propertyName)] = v;
                  newSetter && newSetter.call(object, v);
                };

                newProperty.get = function () {
                  var result = object["_".concat(propertyName)];

                  if (newGetter) {
                    result = newGetter.call(object, result);
                  }

                  return result;
                };
              }

              Object.defineProperty(object, propertyName, newProperty);
            }
            /**
             * Finds a property descriptor for the passed object from all inheritance levels.
             * @param {Object} object The Object whos property to find.
             * @param {String} propertyName The name of the property to find.
             * @returns {Object} An ECMA property descriptor is the property was found, otherwise `null`
             */

          }, {
            key: "getPropertyDescriptor",
            value: function getPropertyDescriptor(object, propertyName) {
              var result = null;

              for (var obj = object; !result && obj !== _Base_js__WEBPACK_IMPORTED_MODULE_16__["default"]; obj = Object.getPrototypeOf(obj)) {
                result = Object.getOwnPropertyDescriptor(obj, propertyName);
              }

              return result;
            }
            /**
             * Changes the passed object and removes all null and undefined properties from it
             * @param {Object} object Target object
             * @returns {Object} Passed object
             */

          }, {
            key: "cleanupProperties",
            value: function cleanupProperties(obj) {
              Object.entries(obj).forEach(function (_ref) {
                var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
                    key = _ref2[0],
                    value = _ref2[1];

                return value == null && delete obj[key];
              });
              return obj;
            }
            /**
             * Checks that the supplied value is of the specified type. Throws if it is not
             * @param {Object} value Value to check type of
             * @param {String} type Expected type
             * @param {String} name Name of the value, used in error message
             */

          }, {
            key: "assertType",
            value: function assertType(value, type, name) {
              // eslint-disable-next-line valid-typeof
              if (value != null && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(value) !== type) {
                throw new Error("Incorrect type \"".concat(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_14___default()(value), "\" for ").concat(name, ", expected \"").concat(type, "\""));
              }
            }
            /**
             * Checks that the supplied value is a number.  Throws if it is not
             * @param {Object} value Value to check type of
             * @param {String} name Name of the value, used in error message
             */

          }, {
            key: "assertNumber",
            value: function assertNumber(value, name) {
              this.assertType(value, 'number', name);
            }
            /**
             * Checks that the supplied value is a boolean.  Throws if it is not
             * @param {Object} value Value to check type of
             * @param {String} name Name of the value, used in error message
             */

          }, {
            key: "assertBoolean",
            value: function assertBoolean(value, name) {
              this.assertType(value, 'boolean', name);
            }
            /**
             * Number.toFixed(), with polyfill for browsers that needs it
             * @param {Number } number
             * @param {Number} digits
             * @returns {*}
             */

          }, {
            key: "toFixed",
            value: function toFixed(number, digits) {
              if (toFixedFix) {
                return toFixedFix(number, digits);
              }

              return number.toFixed(digits);
            }
          }]);

          return ObjectHelper;
        }();

        ObjectHelper._$name = 'ObjectHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/ResizeHelper.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/helper/ResizeHelper.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperResizeHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResizeHelper;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");

        var productName = 'scheduler'; //TODO: add pointer events support

        var documentListeners = {
          down: 'onMouseDown',
          move: 'onMouseMove',
          up: 'onMouseUp',
          docclick: 'onDocumentClick',
          touchstart: 'onTouchStart',
          touchmove: 'onTouchMove',
          touchend: 'onTouchEnd',
          keydown: 'onKeyDown'
        };
        /**
         * @module Common/helper/ResizeHelper
         */

        /**
         * Handles resizing of elements using handles. Handles can be actual elements or virtual handles specified as a border
         * area on elements left and right edges.
         *
         * ```
         * // enable resizing all elements with class 'resizable'
         * let resizer = new ResizeHelper({
         *   targetSelector: '.resizable'
         * });
         * ```
         *
         * @mixes Common/mixin/Events
         * @internal
         */

        var ResizeHelper =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ResizeHelper, _Events);

          function ResizeHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ResizeHelper);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ResizeHelper).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ResizeHelper, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fires after resize
             * @event resize
             * @param {Common.helper.ResizeHelper} source
             * @param {Object} context Resize context
             */

            /**
             * Fires when a resize is canceled (width is unchanged)
             * @event cancel
             * @param {Common.helper.ResizeHelper} source
             * @param {Object} context Resize context
             * @param {MouseEvent|TouchEvent} event Browser event
             */

            /**
             * Fired while dragging
             * @event resizing
             * @param {Common.helper.ResizeHelper} source
             * @param {Object} context Resize context
             * @param {MouseEvent} event Browser event
             */

            /**
             * Fired when dragging starts.
             * @event resizeStart
             * @param {Common.helper.ResizeHelper} source
             * @param {Object} context Resize context
             * @param {MouseEvent|TouchEvent} event Browser event
             */
            //endregion
            //region Init
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ResizeHelper.prototype), "construct", this).call(this, config); // Larger grabbable zones on touch devices


              if (!me.handleSelector && _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isTouchDevice) {
                me.handleSize = me.touchHandleSize;
              }

              me.handleVisibilityThreshold = me.handleVisibilityThreshold || 2 * me.handleSize;
              me.initListeners();
              me.initResize();
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.abort(true);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ResizeHelper.prototype), "doDestroy", this).call(this);
            }
            /**
             * Initializes resizing
             * @private
             */

          }, {
            key: "initResize",
            value: function initResize() {
              var me = this;

              if (!me.isElementResizable && me.targetSelector) {
                me.isElementResizable = function (element) {
                  return _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(element, me.targetSelector);
                };
              }

              if (me.grab) {
                var _me$grab = me.grab,
                    edge = _me$grab.edge,
                    element = _me$grab.element,
                    event = _me$grab.event;
                me.startEvent = event; // emulates mousedown & grabResize

                me.context = {
                  element: element,
                  edge: edge,
                  valid: true,
                  async: false,
                  elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateX(element) || element.offsetLeft,
                  // extract x from translate
                  elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateY(element) || element.offsetTop,
                  // extract x from translate
                  newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateX(element) || element.offsetLeft,
                  // No change yet on start, but info must be present
                  newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateY(element) || element.offsetTop,
                  // No change yet on start, but info must be present
                  elementWidth: element.offsetWidth,
                  elementHeight: element.offsetHeight,
                  startX: event.clientX + me.scrollLeft,
                  startY: event.clientY + me.scrollTop,
                  started: true,
                  finalize: function finalize() {
                    return me.reset && me.reset();
                  }
                };
                element.classList.add(me.resizingCls);
                me.internalStartResize(me.isTouch);
              }
            }
            /**
             * Initialize listeners
             * @private
             */

          }, {
            key: "initListeners",
            value: function initListeners() {
              var me = this,
                  dragStartListeners = {
                element: me.outerElement,
                mousedown: documentListeners.down,
                thisObj: me
              };

              if (_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isTouchDevice) {
                dragStartListeners.touchstart = documentListeners.touchstart;
              } else if (!me.handleSelector) {
                dragStartListeners.mousemove = {
                  handler: documentListeners.move,
                  // Filter events for checkResizeHandles so we only get called if the mouse
                  // is over one of our targets.
                  delegate: me.targetSelector
                }; // We need to clean up when we exit one of our targets

                dragStartListeners.mouseleave = {
                  handler: 'onMouseLeaveTarget',
                  delegate: me.targetSelector,
                  capture: true
                };
              } // These will be autoDetached upon destroy


              me.removeListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on(dragStartListeners);
            }
          }, {
            key: "removeListeners",
            value: function removeListeners() {} //endregion
            //region Scroll helpers

          }, {
            key: "internalStartResize",
            //endregion
            //region Events
            value: function internalStartResize(isTouch) {
              var me = this,
                  dragListeners = {
                element: document,
                keydown: documentListeners.keydown,
                thisObj: me
              };

              if (isTouch) {
                dragListeners.touchmove = documentListeners.touchmove; // Touch desktops don't fire touchend event when touch has ended, instead pointerup is fired
                // iOS do fire touchend

                dragListeners.touchend = dragListeners.pointerup = documentListeners.touchend;
              } else {
                dragListeners.mousemove = documentListeners.move;
                dragListeners.mouseup = documentListeners.up;
              } // A listener detacher is returned;


              me.removeDragListeners = _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on(dragListeners);
              me.scrollManager && me.scrollManager.startMonitoring({
                direction: me.direction,
                // TODO Update this then when we add support for vertical resizing too
                element: me.dragWithin || me.outerElement,
                callback: function callback(config) {
                  return me.context && me.context.element && me.lastMouseMoveEvent && me.update(me.lastMouseMoveEvent, config);
                },
                thisObj: me
              });
            } // Empty class implementation. If listeners *are* added, the detacher is added
            // as an instance property. So this is always callable.

          }, {
            key: "removeDragListeners",
            value: function removeDragListeners() {}
          }, {
            key: "reset",
            value: function reset() {
              this.removeDragListeners();
              this.context = null;
            }
          }, {
            key: "onPointerDown",
            value: function onPointerDown(isTouch, event) {
              var me = this;
              me.startEvent = event;

              if (!me.isElementResizable || me.isElementResizable(event.target, event)) {
                if (me.grabResizeHandle(isTouch, event)) {
                  // Stop event if resize handle was grabbed (resize started)
                  event.stopImmediatePropagation();
                  me.internalStartResize(isTouch);
                }
              }
            }
          }, {
            key: "onTouchStart",
            value: function onTouchStart(event) {
              // only allowing one finger for now...
              if (event.touches.length > 1) {
                return;
              }

              this.onPointerDown(true, event);
            }
            /**
             * Grab draggable element on mouse down.
             * @private
             * @param event
             */

          }, {
            key: "onMouseDown",
            value: function onMouseDown(event) {
              // only dragging with left mouse button
              if (event.button !== 0) {
                return;
              }

              this.onPointerDown(false, event);
            }
          }, {
            key: "internalMove",
            value: function internalMove(isTouch, event) {
              var me = this,
                  context = me.context;

              if (context && context.element && (context.started || _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getDistanceBetween(me.startEvent, event) >= me.dragThreshold)) {
                if (!context.started) {
                  me.trigger('resizeStart', {
                    context: context,
                    event: event
                  });
                  context.started = true;
                }

                me.update(event);
              } // If a mousemove, and we are using zones, and not handles, we have to
              // programatically check whether we are over a handle, and add/remove
              // classes to change the mouse cursor to resize.
              // If we are using handles, their CSS will set the mouse cursor.
              else if (!isTouch && !me.handleSelector) {
                  me.checkResizeHandles(event);
                }
            }
          }, {
            key: "onTouchMove",
            value: function onTouchMove(event) {
              this.internalMove(true, event);
            }
            /**
             * Move grabbed element with mouse.
             * @param event
             * @fires resizestart
             * @private
             */

          }, {
            key: "onMouseMove",
            value: function onMouseMove(event) {
              this.internalMove(false, event);
            }
          }, {
            key: "internalEnd",
            value: function internalEnd(isTouch, event) {
              var me = this,
                  context = me.context;
              me.removeDragListeners();

              if (context) {
                me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);
                me.finishResize(event); // Resize could have not been finalized

                if (me.context) {
                  // Prevent the impending document click from the mouseup event from propagating
                  // into a click on our element.
                  _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                    element: document,
                    thisObj: me,
                    click: documentListeners.docclick,
                    capture: true,
                    once: true
                  });
                }
              }
            }
          }, {
            key: "onTouchEnd",
            value: function onTouchEnd(event) {
              this.internalEnd(true, event);
            }
            /**
             * Drop on mouse up (if dropped on valid target).
             * @param event
             * @private
             */

          }, {
            key: "onMouseUp",
            value: function onMouseUp(event) {
              this.internalEnd(false, event);
            }
            /**
             * This is a capture listener, only added during drag, which prevents a click gesture
             * propagating from the terminating mouseup geature
             * @param {MouseEvent} event
             * @private
             */

          }, {
            key: "onDocumentClick",
            value: function onDocumentClick(event) {
              event.stopPropagation();
            }
            /**
             * Cancel on ESC key
             * @param event
             * @private
             */

          }, {
            key: "onKeyDown",
            value: function onKeyDown(event) {
              if (event.key === 'Escape') {
                this.abort();
              }
            } //endregion
            //region Grab, update, finish

            /**
             * Updates resize, called when an element is grabbed and mouse moves
             * @private
             * @fires resizing
             */

          }, {
            key: "update",
            value: function update(event) {
              var me = this,
                  context = me.context,
                  parentRectangle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(me.outerElement.parentElement); // Calculate the current pointer X. Do not allow overflowing either edge


              context.currentX = Math.max(Math.min(event.clientX, parentRectangle.right - 1), parentRectangle.x) + me.scrollLeft;
              context.currentY = Math.max(Math.min(event.clientY, parentRectangle.bottom - 1), parentRectangle.y) + me.scrollTop;
              me.updateResize(event);
              me.trigger('resizing', {
                context: context,
                event: event
              });
              context.element.classList[context.valid === false ? 'add' : 'remove'](me.invalidCls); // When IE11 support is dropped
              // context.grabbed.classList.toggle(me.invalidCls, context.valid === false);

              if (event) {
                me.lastMouseMoveEvent = event;
              }
            }
            /**
             * Abort dragging
             */

          }, {
            key: "abort",
            value: function abort() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this;
              me.scrollManager && me.scrollManager.stopMonitoring(me.dragWithin || me.outerElement);

              if (me.context) {
                me.abortResize(null, silent);
              }
            }
            /**
             * Starts resizing, updates ResizeHelper#context with relevant info.
             * @private
             * @param {Boolean} isTouch
             * @param {MouseEvent} event
             * @returns {Boolean} True if handled, false if not
             */

          }, {
            key: "grabResizeHandle",
            value: function grabResizeHandle(isTouch, event) {
              var me = this;

              if (me.allowResize && !me.allowResize(event.target, event)) {
                return false;
              }

              var handleSelector = me.handleSelector,
                  coordsFrom = event.type === 'touchstart' ? event.changedTouches[0] : event,
                  clientX = coordsFrom.clientX,
                  clientY = coordsFrom.clientY,
                  // go up from "handle" to resizable element
              element = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(event.target, me.targetSelector) : event.target;

              if (element) {
                var edge; // Calculate which edge to resize
                // If there's a handle selector, see if it's anchored on the left or the right

                if (handleSelector) {
                  if (event.target.matches(handleSelector)) {
                    if (me.direction === 'horizontal') {
                      if (event.pageX < _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getPageX(element) + element.offsetWidth / 2) {
                        edge = 'left';
                      } else {
                        edge = 'right';
                      }
                    } else {
                      if (event.pageY < _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getPageY(element) + element.offsetHeight / 2) {
                        edge = 'top';
                      } else {
                        edge = 'bottom';
                      }
                    }
                  } else {
                    return false;
                  }
                } // If we're not using handles, but just active zones
                // then test whether the event position is in an active resize zone.
                else {
                    if (me.direction === 'horizontal') {
                      if (me.overLeftHandle(event, element)) {
                        edge = 'left';
                      } else if (me.overRightHandle(event, element)) {
                        edge = 'right';
                      }
                    } else {
                      if (me.overTopHandle(event, element)) {
                        edge = 'top';
                      } else if (me.overBottomHandle(event, element)) {
                        edge = 'bottom';
                      }
                    }

                    if (!edge) {
                      me.context = null; // not over an edge, abort

                      return false;
                    }
                  } // If resizing is initiated by a touch, we must preventDefault on the touchstart
                // so that scrolling is not invoked when dragging. This is in lieu of a functioning
                // touch-action style on iOS Safari. When that's fixed, this will not be needed.


                if (event.type === 'touchstart') {
                  event.preventDefault();
                }

                if (me.trigger('beforeResizeStart', {
                  element: element,
                  event: event
                }) !== false) {
                  // store initial size
                  me.context = {
                    element: element,
                    edge: edge,
                    valid: true,
                    async: false,
                    direction: me.direction,
                    isTouch: isTouch,
                    elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateX(element) || element.offsetLeft,
                    // extract x from translate
                    elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateY(element) || element.offsetTop,
                    // extract y from translate
                    newX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateX(element) || element.offsetLeft,
                    // No change yet on start, but info must be present
                    newY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getTranslateY(element) || element.offsetTop,
                    // No change yet on start, but info must be present
                    elementWidth: element.offsetWidth,
                    elementHeight: element.offsetHeight,
                    startX: clientX + me.scrollLeft,
                    startY: clientY + me.scrollTop,
                    finalize: function finalize() {
                      return me.reset && me.reset();
                    }
                  };
                  element.classList.add(me.resizingCls);
                  return true;
                }
              }

              return false;
            }
            /**
             * Check if mouse is over a resize handle (virtual). If so, highlight.
             * @private
             * @param event
             */

          }, {
            key: "checkResizeHandles",
            value: function checkResizeHandles(event) {
              var me = this,
                  target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(event.target, me.targetSelector) : event.target; // mouse over a target element and allowed to resize?

              if (target && (!me.allowResize || me.allowResize(event.target, event))) {
                me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(event.target, me.handleContainerSelector) : event.target;

                if (me.currentElement) {
                  var over = false;

                  if (me.direction === 'horizontal') {
                    over = me.overLeftHandle(event, target) || me.overRightHandle(event, target);
                  } else {
                    over = me.overTopHandle(event, target) || me.overBottomHandle(event, target);
                  }

                  if (over) {
                    me.highlightHandle(); // over handle
                  } else {
                    me.unHighlightHandle(); // not over handle
                  }
                }
              } else if (me.currentElement) {
                me.unHighlightHandle(); // outside element
              }
            }
          }, {
            key: "onMouseLeaveTarget",
            value: function onMouseLeaveTarget(event) {
              var me = this;
              me.currentElement = me.handleContainerSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(event.target, me.handleContainerSelector) : event.target;

              if (me.currentElement) {
                me.unHighlightHandle();
              }
            }
            /**
             * Updates size of target (on mouse move).
             * @private
             * @param event
             */

          }, {
            key: "updateResize",
            value: function updateResize(event) {
              var me = this,
                  context = me.context; // flip which edge is being dragged depending on whether we're to the right or left of the mousedown

              if (me.allowEdgeSwitch) {
                if (me.direction === 'horizontal') {
                  context.edge = context.currentX > context.startX ? 'right' : 'left';
                } else {
                  context.edge = context.currentY > context.startY ? 'bottom' : 'top';
                }
              }

              var // limit to outerElement if set
              deltaX = context.currentX - context.startX,
                  deltaY = context.currentY - context.startY,
                  minWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getExtremalSizePX(context.element, 'minWidth') || me.minWidth,
                  maxWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getExtremalSizePX(context.element, 'maxWidth') || me.maxWidth,
                  minHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getExtremalSizePX(context.element, 'minHeight') || me.minHeight,
                  maxHeight = _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getExtremalSizePX(context.element, 'maxHeight') || me.maxHeight,
                  // dragging right edge right increases width, dragging left edge right decreases width
              sign = context.edge === 'right' || context.edge === 'bottom' ? 1 : -1,
                  // new width, not allowed to go below minWidth
              newWidth = context.elementWidth + deltaX * sign,
                  width = Math.max(minWidth, newWidth),
                  newHeight = context.elementHeight + deltaY * sign,
                  height = Math.max(minHeight, newHeight);

              if (maxWidth > 0) {
                width = Math.min(width, maxWidth);
              }

              if (maxHeight > 0) {
                height = Math.min(height, maxHeight);
              } // remove flex when resizing


              if (context.element.style.flex) {
                context.element.style.flex = '';
              }

              if (me.direction === 'horizontal') {
                context.element.style.width = Math.abs(width) + 'px';
                context.newWidth = width; // when dragging left edge, also update position (so that right edge remains in place)

                if (context.edge === 'left' || width < 0) {
                  context.newX = Math.max(Math.min(context.elementStartX + context.elementWidth - me.minWidth, context.elementStartX + deltaX), 0);

                  if (!me.skipTranslate) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateX(context.element, context.newX);
                  }
                } // When dragging the right edge and we're allowed to flip the drag from left to right
                // through the start point (eg drag event creation) the element must be at its initial X position
                else if (context.edge === 'right' && me.allowEdgeSwitch && !me.skipTranslate) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateX(context.element, context.elementStartX);
                  }
              } else {
                context.element.style.height = Math.abs(height) + 'px';
                context.newHeight = height; // when dragging top edge, also update position (so that bottom edge remains in place)

                if (context.edge === 'top' || height < 0) {
                  context.newY = Math.max(Math.min(context.elementStartY + context.elementHeight - me.minHeight, context.elementStartY + deltaY), 0);

                  if (!me.skipTranslate) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateY(context.element, context.newY);
                  }
                } // When dragging the bottom edge and we're allowed to flip the drag from top to bottom
                // through the start point (eg drag event creation) the element must be at its initial Y position
                else if (context.edge === 'bottom' && me.allowEdgeSwitch && !me.skipTranslate) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateY(context.element, context.elementStartY);
                  }
              }
            }
            /**
             * Finalizes resize, fires drop.
             * @private
             * @param event
             * @fires resize
             * @fires cancel
             */

          }, {
            key: "finishResize",
            value: function finishResize(event) {
              var me = this,
                  context = me.context,
                  eventObject = {
                context: context,
                event: event
              };
              context.element.classList.remove(me.resizingCls);
              var changed = false;

              if (me.direction === 'horizontal') {
                changed = context.newWidth && context.newWidth !== context.elementWidth;
              } else {
                changed = context.newHeight && context.newHeight !== context.elementHeight;
              }

              me.trigger(changed ? 'resize' : 'cancel', eventObject);

              if (!context.async) {
                context.finalize();
              }
            }
            /**
             * Abort resizing
             * @private
             * @fires cancel
             */

          }, {
            key: "abortResize",
            value: function abortResize() {
              var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  context = me.context;
              context.element.classList.remove(me.resizingCls);

              if (me.direction === 'horizontal') {
                _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateX(context.element, context.elementStartX);

                context.element.style.width = context.elementWidth + 'px';
              } else {
                _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateY(context.element, context.elementStartY);

                context.element.style.height = context.elementHeight + 'px';
              }

              !silent && me.trigger('cancel', {
                context: context,
                event: event
              });

              if (!me.isDestroyed) {
                me.reset();
              }
            } //endregion
            //region Handles
            // /**
            //  * Constrain resize to outerElements bounds
            //  * @private
            //  * @param x
            //  * @returns {*}
            //  */
            // constrainResize(x) {
            //     const me = this;
            //
            //     if (me.outerElement) {
            //         const box = me.outerElement.getBoundingClientRect();
            //         if (x < box.left) x = box.left;
            //         if (x > box.right) x = box.right;
            //     }
            //
            //     return x;
            // }

            /**
             * Highlights handles (applies css that changes cursor).
             * @private
             */

          }, {
            key: "highlightHandle",
            value: function highlightHandle() {
              var me = this,
                  target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(me.currentElement, me.targetSelector) : me.currentElement; // over a handle, add cls to change cursor

              me.currentElement.classList.add('b-resize-handle');
              target.classList.add('b-over-resize-handle');
            }
            /**
             * Unhighlight handles (removes css).
             * @private
             */

          }, {
            key: "unHighlightHandle",
            value: function unHighlightHandle() {
              var me = this,
                  target = me.targetSelector ? _DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(me.currentElement, me.targetSelector) : me.currentElement;
              target && target.classList.remove('b-over-resize-handle');
              me.currentElement.classList.remove('b-resize-handle');
              me.currentElement = null;
            }
          }, {
            key: "overAnyHandle",
            value: function overAnyHandle(event, target) {
              return this.overStartHandle(event, target) || this.overEndHandle(event, target);
            }
          }, {
            key: "overStartHandle",
            value: function overStartHandle(event, target) {
              return this.direction === 'horizontal' ? this.overLeftHandle(event, target) : this.overTopHandle(event, target);
            }
          }, {
            key: "overEndHandle",
            value: function overEndHandle(event, target) {
              return this.direction === 'horizontal' ? this.overRightHandle(event, target) : this.overBottomHandle(event, target);
            }
            /**
             * Check if over left handle (virtual).
             * @private
             * @param {MouseEvent} event MouseEvent
             * @param {HTMLElement} target The current target element
             * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
             */

          }, {
            key: "overLeftHandle",
            value: function overLeftHandle(event, target) {
              if (this.leftHandle && target.offsetWidth >= this.handleVisibilityThreshold) {
                var leftHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(target);

                leftHandle.width = this.handleSize;
                return leftHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getPagePoint(event));
              }

              return false;
            }
            /**
             * Check if over right handle (virtual).
             * @private
             * @param {MouseEvent} event MouseEvent
             * @param {HTMLElement} target The current target element
             * @returns {Boolean} Returns true if mouse is over left handle, otherwise false
             */

          }, {
            key: "overRightHandle",
            value: function overRightHandle(event, target) {
              if (this.rightHandle && target.offsetWidth >= this.handleVisibilityThreshold) {
                var rightHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(target);

                rightHandle.x = rightHandle.right - this.handleSize;
                return rightHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getPagePoint(event));
              }

              return false;
            }
            /**
             * Check if over top handle (virtual).
             * @private
             * @param {MouseEvent} event MouseEvent
             * @param {HTMLElement} target The current target element
             * @returns {Boolean} Returns true if mouse is over top handle, otherwise false
             */

          }, {
            key: "overTopHandle",
            value: function overTopHandle(event, target) {
              if (this.topHandle && target.offsetHeight >= this.handleVisibilityThreshold) {
                var topHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(target);

                topHandle.height = this.handleSize;
                return topHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getPagePoint(event));
              }

              return false;
            }
            /**
             * Check if over bottom handle (virtual).
             * @private
             * @param {MouseEvent} event MouseEvent
             * @param {HTMLElement} target The current target element
             * @returns {Boolean} Returns true if mouse is over bottom handle, otherwise false
             */

          }, {
            key: "overBottomHandle",
            value: function overBottomHandle(event, target) {
              if (this.bottomHandle && target.offsetHeight >= this.handleVisibilityThreshold) {
                var bottomHandle = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(target);

                bottomHandle.y = bottomHandle.bottom - this.handleSize;
                return bottomHandle.contains(_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getPagePoint(event));
              }

              return false;
            } //endregion

          }, {
            key: "scrollLeft",
            get: function get() {
              if (this.scroller) {
                return this.scroller.x;
              }

              return this.outerElement.scrollLeft;
            }
          }, {
            key: "scrollTop",
            get: function get() {
              if (this.scroller) {
                return this.scroller.y;
              }

              return this.outerElement.scrollTop;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * CSS class added when resizing
                 * @config {String}
                 * @default
                 */
                resizingCls: 'b-resizing',

                /**
                 * The amount of pixels to move mouse before it counts as a drag operation
                 * @config {Number}
                 * @default
                 */
                dragThreshold: 5,

                /**
                 * Resizing handle size
                 * @config {Number}
                 * @default
                 */
                handleSize: 10,

                /**
                 * Resizing handle size on touch devices
                 * @config {Number}
                 * @default
                 */
                touchHandleSize: 30,

                /**
                 * Minimum width when resizing
                 * @config {Number}
                 * @default
                 */
                minWidth: 1,

                /**
                 * Max width when resizing.
                 * @config {Number}
                 * @default
                 */
                maxWidth: 0,

                /**
                 * Minimum height when resizing
                 * @config {Number}
                 * @default
                 */
                minHeight: 1,

                /**
                 * Max height when resizing
                 * @config {Number}
                 * @default
                 */
                maxHeight: 0,
                // outerElement, attach events to it and use as outer limit when looking for ancestors
                outerElement: document.body,

                /**
                 * Optional scroller used to read scroll position. If unspecified, the outer element will be used.
                 * @config {Common.helper.util.Scroller}
                 */
                scroller: null,

                /**
                 * Assign a function to determine if a hovered element can be resized or not
                 * @config {Function}
                 * @default
                 */
                allowResize: null,

                /**
                 * Outer element that limits where element can be dragged
                 * @config {HTMLElement}
                 * @default
                 */
                dragWithin: null,

                /**
                 * A function that determines if dragging an element is allowed. Gets called with the element as argument,
                 * return true to allow dragging or false to prevent.
                 * @config {Function}
                 * @default
                 */
                isElementResizable: null,

                /**
                 * A CSS selector used to determine if resizing an element is allowed.
                 * @config {String}
                 * @default
                 */
                targetSelector: null,

                /**
                 * Use left handle when resizing. Only applies when `direction` is 'horizontal'
                 * @config {Boolean}
                 * @default
                 */
                leftHandle: true,

                /**
                 * Use right handle when resizing. Only applies when `direction` is 'horizontal'
                 * @config {Boolean}
                 * @default
                 */
                rightHandle: true,

                /**
                 * Use top handle when resizing. Only applies when `direction` is 'vertical'
                 * @config {Boolean}
                 * @default
                 */
                topHandle: true,

                /**
                 * Use bottom handle when resizing. Only applies when `direction` is 'vertical'
                 * @config {Boolean}
                 * @default
                 */
                bottomHandle: true,

                /**
                 * A CSS selector used to determine where handles should be "displayed" when resizing. Defaults to
                 * targetSelector if unspecified
                 * @config {String}
                 * @default
                 */
                handleSelector: null,

                /**
                 * A CSS selector used to determine which inner element contains handles.
                 * @config {String}
                 * @default
                 */
                handleContainerSelector: null,
                startEvent: null,

                /*
                 * Optional config object, used by EventResize feature: it appends proxy and has to start resizing immediately
                 * @config {Object}
                 * @private
                 */
                grab: null,

                /**
                 * CSS class added when the resize state is invalid
                 * @config {String}
                 * @default
                 */
                invalidCls: 'b-resize-invalid',
                // A number that controls whether or not the element is wide enough for it to make sense to show resize handles
                // e.g. handle width is 10px, so doesn't make sense to show them unless handles on both sides fit
                handleVisibilityThreshold: null,
                // Private config that disables translation when resizing left edge. Useful for example in cases when element
                // being resized is part of a flex layout
                skipTranslate: false,

                /**
                 * Direction to resize in, either 'horizontal' or 'vertical'
                 * @config {String}
                 * @default
                 */
                direction: 'horizontal'
              };
            }
          }]);

          return ResizeHelper;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"]));

        ResizeHelper._$name = 'ResizeHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/ResizeMonitor.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/helper/ResizeMonitor.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperResizeMonitorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResizeMonitor;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");

        var productName = 'scheduler';
        /* globals ResizeObserver: true */

        var resizeFireTimer = null;

        var resizedQueue = [],
            isAbsolutelyPositioned = function isAbsolutelyPositioned(n) {
          return n.nodeType === 1 && n.ownerDocument.defaultView.getComputedStyle(n).getPropertyValue('position') === 'absolute';
        };
        /**
         * @module Common/helper/ResizeMonitor
         */

        /**
         * Allows size monitoring of elements.
         *
         * ```
         * ResizeMonitor.addResizeListener(
         *   myElement,
         *   element => {
         *      console.log(element, ' changed size');
         *   }
         * );
         * ```
         *
         * @internal
         */


        var ResizeMonitor =
        /*#__PURE__*/
        function () {
          function ResizeMonitor() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ResizeMonitor);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ResizeMonitor, null, [{
            key: "addResizeListener",

            /**
             * Adds a resize listener to the passed element which is called when the element
             * is resized by layout.
             * @param {HTMLElement} element The element to listen for resizing.
             * @param {Function} handler The handling function. Will be passed the element.
             */
            value: function addResizeListener(element, handler) {
              var me = this;

              if (element === document || element === window) {
                element = document.body;
              }

              if (!element.classList.contains('b-resize-monitored')) {
                element.classList.add('b-resize-monitored');
                element._bResizemonitor = {
                  handlers: []
                };
              } // If we're looking at the document, or body, use a window resize listener.


              if (element === document.body) {
                if (!me.hasWindowResizeListener) {
                  // Throttle the reaction to window resize to only fire once every 100ms
                  window.addEventListener('resize', me.onWindowResize);
                  me.hasWindowResizeListener = true;
                }
              } // Regular element - use ResizeObserver by preference
              else if (window.ResizeObserver) {
                  if (!me.resizeObserver) {
                    me.resizeObserver = new ResizeObserver(me.onElementResize);
                  }

                  me.resizeObserver.observe(element);
                } // Polyfill ResizeObesrver
                else {
                    var _DomHelper$createElem = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].createElement({
                      parent: element,
                      className: 'b-resize-monitors',
                      children: [{
                        className: 'b-resize-monitor-expand'
                      }, {
                        className: 'b-resize-monitor-shrink'
                      }]
                    }, true),
                        _DomHelper$createElem2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(_DomHelper$createElem, 3),
                        monitors = _DomHelper$createElem2[0],
                        expand = _DomHelper$createElem2[1],
                        shrink = _DomHelper$createElem2[2];

                    expand.scrollLeft = expand.scrollTop = shrink.scrollLeft = shrink.scrollTop = 1000000;
                    expand.addEventListener('scroll', me.onSizeMonitorScroll, true);
                    shrink.addEventListener('scroll', me.onSizeMonitorScroll, true); // Also need to fake a resize-scroll on DOM mutation

                    (handler.targetMutationMonitor = new MutationObserver(function (m) {
                      var changedNodes = [];
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                          var mr = _step.value;

                          if (mr.type === 'childList') {
                            changedNodes.push.apply(changedNodes, mr.removedNodes);
                            changedNodes.push.apply(changedNodes, mr.addedNodes);
                          }
                        } // If the changed nodes were absolutely positioned, then they won't
                        // cause a resize, so return

                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }

                      if (changedNodes.length > 0 && changedNodes.every(isAbsolutelyPositioned)) {
                        return;
                      }

                      expand.dispatchEvent(new CustomEvent('scroll', {}));
                    })).observe(element, {
                      childList: true,
                      subtree: true
                    }); // store reference for easier cleanup later

                    handler.monitorElement = monitors;
                  }

              element._bResizemonitor.handlers.push(handler);
            }
            /**
             * Removes a resize listener from the passed element.
             * @param {HTMLElement} element The element to listen for resizing.
             * @param {Function} handler The handling function to remove.
             */

          }, {
            key: "removeResizeListener",
            value: function removeResizeListener(element, handler) {
              if (element) {
                if (element === document || element === window) {
                  element = document.body;
                }

                var resizeMonitor = element._bResizemonitor;
                var listenerCount = 0;

                if (resizeMonitor && resizeMonitor.handlers) {
                  _ArrayHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].remove(resizeMonitor.handlers, handler); // See if we should unobserve the element


                  listenerCount = resizeMonitor.handlers.length;
                } // Down to no listeners.


                if (!listenerCount) {
                  element.classList.remove('b-resize-monitored');

                  if (this.resizeObserver) {
                    this.resizeObserver.unobserve(element);
                  } // Remove the polyfill resize listeners
                  else {
                      // remove any added elements
                      if (handler.monitorElement) {
                        handler.monitorElement.remove();
                        handler.monitorElement = null;
                      } // remove the DOM mutation observer


                      if (handler.targetMutationMonitor) {
                        handler.targetMutationMonitor.disconnect();
                      }
                    }
                }
              }
            }
          }, {
            key: "onElementResize",
            value: function onElementResize(entries) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = entries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var resizeObserverEntry = _step2.value;
                  var resizedElement = resizeObserverEntry.target,
                      resizeMonitor = resizedElement._bResizemonitor,
                      newRect = resizeObserverEntry.contentRect || resizedElement.getBoundingClientRect();

                  if (resizedElement.offsetParent) {
                    if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
                      var oldRect = resizeMonitor.rectangle;
                      resizeMonitor.rectangle = newRect;
                      var _iteratorNormalCompletion3 = true;
                      var _didIteratorError3 = false;
                      var _iteratorError3 = undefined;

                      try {
                        for (var _iterator3 = resizeMonitor.handlers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                          var resizeHandler = _step3.value;
                          resizeHandler(resizedElement, oldRect, newRect);
                        }
                      } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                          }
                        } finally {
                          if (_didIteratorError3) {
                            throw _iteratorError3;
                          }
                        }
                      }
                    }
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          }, {
            key: "onSizeMonitorScroll",
            value: function onSizeMonitorScroll(e) {
              // If the element has gone, ignore the event; the listener will be removed automatically.
              if (document.body.contains(e.target)) {
                e.stopPropagation();
                var monitorNode = e.target.parentNode,
                    resizedElement = monitorNode.parentNode,
                    resizeMonitor = resizedElement._bResizemonitor,
                    newRect = resizedElement.getBoundingClientRect();

                if (!resizeMonitor.rectangle || newRect.width !== resizeMonitor.rectangle.width || newRect.height !== resizeMonitor.rectangle.height) {
                  resizedQueue.push([resizedElement, resizeMonitor.rectangle, newRect]);
                  resizeMonitor.rectangle = newRect;

                  if (!resizeFireTimer) {
                    resizeFireTimer = requestAnimationFrame(ResizeMonitor.fireResizeEvents);
                  }
                }

                monitorNode.firstChild.scrollLeft = monitorNode.firstChild.scrollTop = monitorNode.childNodes[1].scrollTop = monitorNode.childNodes[1].scrollLeft = 1000000;
              }
            }
          }, {
            key: "onWindowResize",
            value: function onWindowResize(e) {
              var resizedElement = document.body,
                  resizeMonitor = resizedElement._bResizemonitor,
                  oldRect = resizeMonitor.rectangle;
              resizeMonitor.rectangle = document.documentElement.getBoundingClientRect();
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = resizedElement._bResizemonitor.handlers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var resizeHandler = _step4.value;
                  resizeHandler(resizedElement, oldRect, resizeMonitor.rectangle);
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          }, {
            key: "fireResizeEvents",
            value: function fireResizeEvents() {
              for (var _i = 0; _i < resizedQueue.length; _i++) {
                var resizedEntry = resizedQueue[_i];
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                  for (var _iterator5 = resizedEntry[0]._bResizemonitor.handlers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var resizeHandler = _step5.value; // Checking offsetParent to avoid resizing of elements which are not visible or exist in DOM

                    if (resizedEntry[0].offsetParent) {
                      resizeHandler.apply(this, resizedEntry);
                    }
                  }
                } catch (err) {
                  _didIteratorError5 = true;
                  _iteratorError5 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                      _iterator5.return();
                    }
                  } finally {
                    if (_didIteratorError5) {
                      throw _iteratorError5;
                    }
                  }
                }
              }

              resizeFireTimer = null;
              resizedQueue.length = 0;
            }
          }]);

          return ResizeMonitor;
        }();

        ResizeMonitor._$name = 'ResizeMonitor';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/StringHelper.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/helper/StringHelper.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperStringHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return StringHelper;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "../Grid/node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_3__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/StringHelper
        */

        var camelLettersRe = /([a-z])([A-Z])/g,
            escapeRegExpRe = /[.*+?^${}()|[\]\\]/g,
            idRe = /(^[^a-z]+|[^\w]+)/gi,
            replaceCamelLetters = function replaceCamelLetters(all, g1, g2) {
          return g1 + '-' + g2.toLowerCase();
        },
            replaceNonIdChar = function replaceNonIdChar(c) {
          if (c) {
            return "_x".concat(c.charCodeAt(0).toString(16));
          }

          return '__blank__';
        },
            hyphenateCache = {};
        /**
         * Helper for string manipulation.
         */


        var StringHelper =
        /*#__PURE__*/
        function () {
          function StringHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, StringHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(StringHelper, null, [{
            key: "capitalizeFirstLetter",

            /**
             * Capitalizes the first letter of a string, myString -> MyString.
             * Doesn't alter the original string, use return value
             * @param string String to capitalize
             * @returns {String} Capitalized string
             */
            value: function capitalizeFirstLetter(string) {
              if (!string) return null;
              return string[0].toUpperCase() + string.substr(1);
            }
            /**
             * Makes the first letter of a string lowercase, MyString -> myString.
             * Doesn't alter the original string, use return value
             * @param string String to alter
             * @returns {String} Altered string
             */

          }, {
            key: "lowercaseFirstLetter",
            value: function lowercaseFirstLetter(string) {
              if (!string) return null;
              return string[0].toLowerCase() + string.substr(1);
            }
            /**
             * Converts the passed camelCased string to a hyphen-separated string. eg "minWidth" -> "min-width"
             * @param string The string to convert.
             * @return {String} The string with adjoining lower and upper case letters
             * separated by hyphens and converted to lower case.
             */

          }, {
            key: "hyphenate",
            value: function hyphenate(string) {
              // Cached since it is used heavily with DomHelper.sync()
              var cached = hyphenateCache[string];

              if (cached) {
                return cached;
              }

              return hyphenateCache[string] = string.replace(camelLettersRe, replaceCamelLetters);
            }
            /**
             * Parses JSON within a try-catch.
             * @param {String} string String to parse
             * @returns {Object} Resulting object or null if parse failed
             */

          }, {
            key: "safeJsonParse",
            value: function safeJsonParse(string) {
              var parsed = null;

              try {
                parsed = JSON.parse(string);
              } catch (e) {
                console.error(e);
              }

              return parsed;
            }
            /**
             * Stringifies an object within a try-catch.
             * @param {Object} object The object to stringify
             * @returns {Object} Resulting object or null if stringify failed
             */

          }, {
            key: "safeJsonStringify",
            value: function safeJsonStringify(obj) {
              var result = null;

              try {
                result = JSON.stringify(obj);
              } catch (e) {
                console.error(e);
              }

              return result;
            }
            /**
             * Creates an alphanuneric identifier from any passed string. Encodes spaces and non-alpha characters.
             * @param inString The string from which to strip non-identifier characters.
             * @return {String}
             */

          }, {
            key: "createId",
            value: function createId(inString) {
              return String(inString).replace(idRe, replaceNonIdChar);
            } // https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex

          }, {
            key: "escapeRegExp",
            value: function escapeRegExp(string) {
              // $& means the whole matched string
              return string.replace(escapeRegExpRe, '\\$&');
            }
          }]);

          return StringHelper;
        }();

        StringHelper._$name = 'StringHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/TemplateHelper.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/helper/TemplateHelper.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperTemplateHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TemplateHelper;
        });
        /* harmony import */


        var core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.repeat */
        "../Grid/node_modules/core-js/modules/es6.string.repeat.js");
        /* harmony import */


        var core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "../Grid/node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/TemplateHelper
        */

        var tagSpaceRe = />[ \t\r\n]+</g,
            multiSpaceRe = /\s\s+/g;
        /**
         * Helper for template strings, use as tag function
         * @example
         * TemplateHelper.tpl`...`
         * @internal
         */

        var TemplateHelper =
        /*#__PURE__*/
        function () {
          function TemplateHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, TemplateHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TemplateHelper, null, [{
            key: "tpl",

            /**
             * Tag function for template literals that does some basic cleanup
             * @private
             */
            value: function tpl(strings) {
              for (var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                values[_key - 1] = arguments[_key];
              }

              var count = 0,
                  output = values.map(function (val, i) {
                // TODO: pad output nicely instead of just trimming away
                var ret = strings[i];

                if (Array.isArray(val)) {
                  ret += val.reduce(function (ack, item) {
                    return ack += (typeof item === 'string' ? item.trim() : item) + '\n';
                  }, '');
                } else {
                  if (val === undefined) {
                    val = '';
                  }

                  ret += typeof val === 'string' ? val.trim() : val;
                }

                count++;
                return ret;
              }).join('');

              if (count <= strings.length) {
                output += strings[strings.length - 1];
              } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
              // matches non-breaking spaces which need to be preserved.
              // Also reduce any usage of multiple spaces to single, since they have no value in html


              return output.replace(tagSpaceRe, '><').replace(multiSpaceRe, ' ').trim();
            }
            /**
             * Tag function for template literals that does some basic cleanup. Version for docs that do not remove blank space,
             * to keep code snippets formatting intact.
             * @private
             */

          }, {
            key: "docsTpl",
            value: function docsTpl(strings) {
              for (var _len2 = arguments.length, values = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                values[_key2 - 1] = arguments[_key2];
              }

              var count = 0,
                  output = values.map(function (val, i) {
                // TODO: pad output nicely instead of just trimming away
                var str = strings[i],
                    ret = str;

                if (Array.isArray(val)) {
                  ret += val.reduce(function (ack, item) {
                    return ack += (typeof item === 'string' ? item.trim() : item) + '\n';
                  }, '');
                } else {
                  if (val === undefined) {
                    val = '';
                  }

                  ret += typeof val === 'string' ? val.trim() : val;
                }

                count++;
                return ret;
              }).join('');

              if (count <= strings.length) {
                output += strings[strings.length - 1];
              } // Excise unnecessary *soft* whitespace textNodes. We cannot use \s because that
              // matches non-breaking spaces which need to be preserved.


              return output.replace(tagSpaceRe, '><').trim();
            }
          }, {
            key: "repeat",
            value: function repeat(times) {
              return function () {
                return TemplateHelper.tpl.apply(TemplateHelper, arguments).repeat(times);
              };
            }
          }, {
            key: "loop",
            value: function loop(times) {}
          }]);

          return TemplateHelper;
        }();

        TemplateHelper._$name = 'TemplateHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/VersionHelper.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/helper/VersionHelper.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperVersionHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return VersionHelper;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "../Grid/node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/VersionHelper
        */

        /**
         * Helper for version handling
         * @private
         * @example
         *
         * VersionHelper.setVersion('grid', '1.5');
         *
         * if (VersionHelper.getVersion('grid').isNewerThan('1.0')) {
         *   ...
         * }
         */

        var VersionHelper =
        /*#__PURE__*/
        function () {
          function VersionHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, VersionHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(VersionHelper, null, [{
            key: "setVersion",

            /**
             * Set version for specified product
             * @private
             * @param {String} product
             * @param {String} version
             */
            value: function setVersion(product, version) {
              product = product.toLowerCase();
              this[product] = {
                version: version,
                isNewerThan: function isNewerThan(otherVersion) {
                  return otherVersion < version;
                },
                isOlderThan: function isOlderThan(otherVersion) {
                  return otherVersion > version;
                }
              };

              if (!window.bryntum) {
                window.bryntum = {};
              }

              var bundleFor = ''; // Var productName is only defined in bundles, it is internal to bundle so not available on window. Used to
              // tell importing combinations of grid/scheduler/gantt bundles apart from loading same bundle twice

              try {
                // eslint-disable-next-line no-undef
                bundleFor = productName;
              } catch (e) {} // Set "global" flag to detect bundle being loaded twice


              var globalKey = "".concat(bundleFor, ".").concat(product).concat(version.replace(/\./g, '-'));

              if (window.bryntum[globalKey] === true) {
                if (window.parent.Siesta) {
                  window.BUNDLE_EXCEPTION = true;
                } else {
                  throw new Error('Bundle included twice, check cache-busters and file types (.js)');
                }
              } else {
                window.bryntum[globalKey] = true;
              }
            }
            /**
             * Get (previously set) version for specified product
             * @private
             * @param {String} product
             */

          }, {
            key: "getVersion",
            value: function getVersion(product) {
              product = product.toLowerCase();

              if (!this[product]) {
                throw new Error('No version specified');
              }

              return this[product].version;
            }
          }]);

          return VersionHelper;
        }();

        VersionHelper._$name = 'VersionHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/WalkHelper.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/helper/WalkHelper.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperWalkHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return WalkHelper;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.map */
        "../Grid/node_modules/core-js/modules/es6.map.js");
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/WalkHelper
        */

        /**
         * Tree walking helper
         * @internal
         */

        var WalkHelper =
        /*#__PURE__*/
        function () {
          function WalkHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, WalkHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(WalkHelper, null, [{
            key: "preWalk",

            /**
             * Pre-walks any hierarchical data structure
             *
             * @param data Walking starting point
             * @param {Function} childrenFn Function to return `data` children entries in an array
             *                   or null if no children exists for the entry
             * @param {Function} fn Function to call on each entry
             */
            value: function preWalk(data, childrenFn, fn) {
              var walkStack = [data],
                  node,
                  children;

              while (walkStack.length) {
                node = walkStack.pop();
                fn(node);
                children = childrenFn(node);

                if (children) {
                  walkStack = walkStack.concat(children.slice().reverse());
                }
              }
            }
            /**
             * Pre-walk unordered.
             *
             * Like {@link #function-preWalk-static preWalk} but doesn't reverses children before walk,
             * thus children will be walked last child first - first child last
             *
             * @param data Walking starting point
             * @param {Function} childrenFn Function to return `data` children entries in an array
             *                   or null if no children exists for the entry
             * @param {Function} fn Function to call on each entry
             */

          }, {
            key: "preWalkUnordered",
            value: function preWalkUnordered(data, childrenFn, fn) {
              var walkStack = [data],
                  node,
                  children;

              while (walkStack.length) {
                node = walkStack[walkStack.length - 1];
                fn(node);
                children = childrenFn(node);

                if (children) {
                  walkStack.splice.apply(walkStack, [walkStack.length - 1, 1].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(children)));
                } else {
                  walkStack.length = walkStack.length - 1;
                }
              }
            }
            /**
             * Post-walks any hierarchical data structure
             *
             * @param data Walking starting point
             * @param {Function} childrenFn Function to return `data` children entries in an array
             *                   or null if no children exists for the entry
             * @param {Function} fn Function to call on each entry
             */

          }, {
            key: "postWalk",
            value: function postWalk(data, childrenFn, fn) {
              var visited = new Map(),
                  walkStack = [data],
                  node,
                  children;

              while (walkStack.length) {
                node = walkStack[walkStack.length - 1];

                if (visited.has(node)) {
                  fn(node);
                  walkStack.pop();
                } else {
                  children = childrenFn(node);

                  if (children) {
                    walkStack = walkStack.concat(children.slice().reverse());
                  }

                  visited.set(node, node);
                }
              }
            }
            /**
             * Pre/Post-walks any hierarchical data structure calling inFn each node when it walks in,
             * and outFn when it walks out.
             *
             * @param data Walking starting point
             * @param {Function} childrenFn Function to return `data` children entries in an array
             *                   or null if no children exists for the entry
             * @param {Function} inFn  Function to call on each entry upon enter
             * @param {Function} outFn Function to call on each entry upon exit
             */

          }, {
            key: "prePostWalk",
            value: function prePostWalk(data, childrenFn, inFn, outFn) {
              var visited = new Map(),
                  walkStack = [data],
                  node,
                  children;

              while (walkStack.length) {
                node = walkStack[walkStack.length - 1];

                if (visited.has(node)) {
                  outFn(node);
                  walkStack.pop();
                } else {
                  inFn(node);
                  children = childrenFn(node);

                  if (children) {
                    walkStack = walkStack.concat(children.slice().reverse());
                  }

                  visited.set(node, node);
                }
              }
            }
          }]);

          return WalkHelper;
        }();

        WalkHelper._$name = 'WalkHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/WidgetHelper.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/helper/WidgetHelper.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperWidgetHelperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return WidgetHelper;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _IdHelper_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/WidgetHelper
         */

        /**
         * Helper for creating widgets. Needs an adapter to do the actual work, see
         * {@link Common.adapter.widget.BryntumWidgetAdapter} which is used in examples.
         *
         * NOTE: This concept is not yet fully realized.
         */

        var WidgetHelper =
        /*#__PURE__*/
        function () {
          function WidgetHelper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, WidgetHelper);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(WidgetHelper, null, [{
            key: "getById",
            //endregion
            //region Querying

            /**
             * Returns the widget with the specified id.
             * @param id Id of widget to find
             * @returns {Common.widget.Widget} The widget if any
             * @category Querying
             */
            value: function getById(id) {
              return _IdHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].get(id);
            }
            /**
             * Returns the Widget which owns the passed element (or event).
             * @param {HTMLElement|Event} element The element or event to start from
             * @param {String|Function} [type] The type of Widget to scan upwards for. The lowercase
             * class name. Or a filter function which returns `true` for the required Widget.
             * @param {HTMLElement|Number} [limit] The number of components to traverse upwards to find a
             * match of the type parameter, or the element to stop at.
             * @returns {Common.widget.Widget} The found Widget or null.
             * @category Querying
             * @typings any
             */

          }, {
            key: "fromElement",
            value: function fromElement(element, type, limit) {
              return _IdHelper_js__WEBPACK_IMPORTED_MODULE_2__["default"].fromElement(element, type, limit);
            } //endregion
            //region Widgets

            /**
             * Create a widget.
             * @example
             * WidgetHelper.createWidget({
             *   type: 'button',
             *   icon: 'user',
             *   text: 'Edit user'
             * });
             * @param config Widget config
             * @returns {Object} The widget
             * @category Widgets
             */

          }, {
            key: "createWidget",
            value: function createWidget() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              return this.adapter.createWidget(config);
            }
            /**
             * Appends a widget (array of widgets) to the DOM tree. If config is empty, widgets are appended to the DOM. To
             * append widget to certain position you can pass HTMLElement or its id as config, or as a config, that will be
             * applied to all passed widgets.
             *
             * Usage:
             *
             * ```javascript
             * // Will append button as last item to element with id 'container'
             * let [button] = WidgetHelper.append({ type : 'button' }, 'container');
             *
             * // Same as above, but will add two buttons
             * let [button1, button2] = WidgetHelper.append([
             *     { type : 'button' },
             *     { type : 'button' }
             *     ], { appendTo : 'container' });
             *
             * // Will append two buttons before element with id 'someElement'. Order will be preserved and all widgets will have
             * // additional class 'my-cls'
             * let [button1, button2] = WidgetHelper.append([
             *     { type : 'button' },
             *     { type : 'button' }
             *     ], {
             *         insertBefore : 'someElement',
             *         cls          : 'my-cls'
             *     });
             * ```
             *
             * @param {Object|Object[]} widget Widget config or array of such configs
             * @param {HTMLElement|String|Object} [config] Element (or element id) to which to append the widget or config to apply to all passed widgets
             * @returns {Common.widget.Widget[]} Array or widgets
             * @category Widgets
             */

          }, {
            key: "append",
            value: function append(widget, config) {
              widget = Array.isArray(widget) && widget || [widget];

              if (config instanceof HTMLElement || typeof config === 'string') {
                config = {
                  appendTo: config
                };
              } // We want to fix position to insert into to keep order of passed widgets


              if (config.insertFirst) {
                var target = typeof config.insertFirst === 'string' ? document.getElementById(config.insertFirst) : config.insertFirst;

                if (target.firstChild) {
                  config.insertBefore = target.firstChild;
                } else {
                  config.appendTo = target;
                }
              }

              return this.adapter.appendWidgets(widget, config);
            } //endregion
            //region Popups
            // TODO: Implement openWindow
            // /**
            //  * Opens a window with specified widgets. Not implemented yet...
            //  * @param config
            //  * @returns {Object}
            //  * @category Popups
            //  */
            // static openWindow(config) {
            //     return this.adapter.openWindow(config);
            // }

            /**
             * Shows a popup (~tooltip) containing widgets connected to specified element.
             * @example
             * WidgetHelper.openPopup(element, {
             *   position: 'bottom center',
             *   items: [
             *      { widgetConfig }
             *   ]
             * });
             * @param element Element to connect popup to
             * @param config Config object, or string to use as html in popup
             * @returns {*|{close, widgets}}
             * @category Popups
             */

          }, {
            key: "openPopup",
            value: function openPopup(element, config) {
              return this.adapter.openPopup(element, config);
            }
            /**
             * Shows a context menu connected to the specified element.
             * @example
             * WidgetHelper.showContextMenu(element, {
             *   items: [
             *      { id: 'addItem', icon: 'add', text: 'Add' },
             *      ...
             *   ],
             *   onItem: item => alert('Clicked ' + item.text)
             * });
             * @param {HTMLElement|Number[]} element Element (or a coordinate) to show the context menu for
             * @param {Object} config Context menu config, see example
             * @returns {*|{close}}
             * @category Popups
             */

          }, {
            key: "showContextMenu",
            value: function showContextMenu(element, config) {
              return this.adapter.showContextMenu(element, config);
            }
            /**
             * Attached a tooltip to the specified element.
             * @example
             * WidgetHelper.attachTooltip(element, {
             *   text: 'Useful information goes here'
             * });
             * @param element Element to attach tooltip for
             * @param configOrText Tooltip config or tooltip string, see example and source
             * @returns {Object}
             * @category Popups
             */

          }, {
            key: "attachTooltip",
            value: function attachTooltip(element, configOrText) {
              return this.adapter.attachTooltip(element, configOrText);
            }
            /**
             * Checks if element has tooltip attached
             *
             * @param element Element to check
             * @return {Boolean}
             * @category Popups
             */

          }, {
            key: "hasTooltipAttached",
            value: function hasTooltipAttached(element) {
              return this.adapter.hasTooltipAttached(element);
            }
            /**
             * Destroys any tooltip attached to an element, removes it from the DOM and unregisters any tip related listeners
             * on the element.
             *
             * @param element Element to remove tooltip from
             * @category Popups
             */

          }, {
            key: "destroyTooltipAttached",
            value: function destroyTooltipAttached(element) {
              return this.adapter.destroyTooltipAttached(element);
            } //endregion
            //region Mask

            /**
             * Masks the specified element, showing a message in the mask.
             * @param element Element to mask
             * @param msg Message to show in the mask
             * @category Mask
             */

          }, {
            key: "mask",
            value: function mask(element, msg) {
              return this.adapter.mask(element, msg);
            }
            /**
             * Unmask the specified element.
             * @param element
             * @category Mask
             */

          }, {
            key: "unmask",
            value: function unmask(element) {
              var close = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              this.adapter.unmask(element);
            } //endregion
            //region Toast

            /**
             * Show a toast
             * @param {String} msg message to show in the toast
             * @category Mask
             */

          }, {
            key: "toast",
            value: function toast(msg) {
              this.adapter.toast(msg);
            } //endregion
            //region Style

          }, {
            key: "adapter",
            //region Adapter

            /**
             * Gets/sets the adapter used for widgets.
             * @param adapterClass Adapter class
             * @category Adapter
             */
            set: function set(adapterClass) {
              this._adapter = new adapterClass();
            },
            get: function get() {
              if (!this._adapter) throw new Error('No widget adapter set');
              return this._adapter;
            }
            /**
             * Checks if an adapter is assigned
             * @returns {Boolean}
             * @category Adapter
             * @readonly
             */

          }, {
            key: "hasAdapter",
            get: function get() {
              return !!this._adapter;
            }
          }, {
            key: "defaultStyle",
            set: function set(style) {
              this.adapter.defaultStyle = style;
            },
            get: function get() {
              return this.adapter.defaultStyle;
            } //endregion

          }]);

          return WidgetHelper;
        }();

        WidgetHelper._$name = 'WidgetHelper';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/mixin/DragHelperContainer.js":
      /*!**************************************************************!*\
        !*** ../Grid/lib/Common/helper/mixin/DragHelperContainer.js ***!
        \**************************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperMixinDragHelperContainerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler'; // TODO: Use mousedown pos and not center too reposition

        /**
         * @module Common/helper/mixin/DragHelperContainer
         */

        /**
         * Mixin for DragHelper that handles dragging elements between containers (or rearranging within)
         *
         * @private
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(DragHelperContainer, _ref);

              function DragHelperContainer() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, DragHelperContainer);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(DragHelperContainer).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(DragHelperContainer, [{
                key: "initContainerDrag",
                //region Init

                /**
                 * Initialize container drag mode.
                 * @private
                 */
                value: function initContainerDrag() {
                  var me = this; //use container drag as default mode

                  if (!me.mode) me.mode = 'container';
                  if (me.mode === 'container' && !me.containers) throw new Error('Container drag mode must specify containers');
                } //endregion
                //region Grab, update, finish

                /**
                 * Grab an element which can be dragged between containers.
                 * @private
                 * @param event
                 * @returns {Boolean}
                 */

              }, {
                key: "grabContainerDrag",
                value: function grabContainerDrag(event) {
                  var me = this; // allow specified selectors to prevent drag

                  if (!me.ignoreSelector || !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].up(event.target, me.ignoreSelector)) {
                    // go up from "handle" to draggable element
                    var element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getAncestor(event.target, me.containers, me.outerElement);

                    if (element) {
                      var box = element.getBoundingClientRect();
                      me.context = {
                        element: element,
                        valid: true,
                        action: 'container',
                        offsetX: event.pageX - box.left,
                        offsetY: event.pageY - box.top,
                        originalPosition: {
                          parent: element.parentElement,
                          prev: element.previousElementSibling,
                          next: element.nextElementSibling
                        }
                      };
                    }

                    return true;
                  }

                  return false;
                }
                /**
                 * Starts dragging, called when mouse moves first time after grabbing
                 * @private
                 * @param event
                 */

              }, {
                key: "startContainerDrag",
                value: function startContainerDrag(event) {
                  var context = this.context,
                      dragElement = context.element,
                      div = dragElement.cloneNode(true),
                      box = dragElement.getBoundingClientRect(); // init drag proxy

                  div.classList.add(this.dragProxyCls);
                  div.classList.add(this.draggingCls);
                  document.body.appendChild(div);
                  context.dragProxy = div; // Always set the proxy element width manually, drag target could be sized with flex or % width

                  div.style.width = box.width + 'px';
                  div.style.height = box.height + 'px';

                  _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setTranslateXY(context.dragProxy, box.left, box.top); // style dragged element


                  context.dragging = dragElement;
                  dragElement.classList.add(this.dropPlaceholderCls);
                }
                /**
                 * Move the placeholder element into its new position on valid drag.
                 * @private
                 * @param event
                 */

              }, {
                key: "updateContainerDrag",
                value: function updateContainerDrag(event) {
                  var me = this,
                      context = me.context;
                  if (!context.started || !context.targetElement) return;

                  var containerElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getAncestor(context.targetElement, me.containers, 'b-grid'),
                      willLoseFocus = context.dragging && context.dragging.contains(document.activeElement);

                  if (containerElement && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isDescendant(context.element, containerElement)) {
                    // dragging over part of self, do nothing
                    return;
                  } // The dragging element contains focus, and moving it within the DOM
                  // will cause focus loss which might affect an encapsulating autoClose Popup.
                  // Prevent focus loss handling during the DOM move.


                  if (willLoseFocus) {
                    _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].suspendFocusEvents();
                  }

                  if (containerElement && context.valid) {
                    me.moveNextTo(containerElement, event);
                  } else {
                    // dragged outside of containers, revert position
                    me.revertPosition();
                  }

                  if (willLoseFocus) {
                    _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_6__["default"].resumeFocusEvents();
                  }

                  event.preventDefault();
                }
                /**
                 * Finalize drag, fire drop.
                 * @private
                 * @param event
                 * @fires drop
                 */

              }, {
                key: "finishContainerDrag",
                value: function finishContainerDrag(event) {
                  var _this = this;

                  var me = this,
                      context = me.context,
                      dragging = context.dragging,
                      dragProxy = context.dragProxy,
                      valid = context.valid,
                      draggedTo = context.draggedTo,
                      insertBefore = context.insertBefore,
                      originalPosition = context.originalPosition;

                  if (dragging) {
                    // needs to have a valid target
                    context.valid = valid && draggedTo && ( // no drop on self or parent
                    dragging !== insertBefore || originalPosition.parent !== draggedTo);

                    context.finalize = function () {
                      var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : context.valid; // revert if invalid (and context still exists, might have been aborted from outside)

                      if (!valid && _this.context) {
                        me.revertPosition();
                      }

                      dragging.classList.remove(me.dropPlaceholderCls);
                      dragProxy.remove();
                      me.reset();
                    }; // allow async finalization by setting async to true on context in drop handler,
                    // requires implementer to call context.finalize later to finish the drop


                    context.async = false;
                    me.trigger('drop', {
                      context: context,
                      event: event
                    });

                    if (!context.async) {
                      // finalize immediately
                      context.finalize();
                    } else {
                      context.awaitingFinalization = true;
                    }
                  }
                }
                /**
                 * Aborts a drag operation.
                 * @private
                 * @param {Boolean} [invalid]
                 * @param {Object} [event]
                 * @param {Boolean} [silent]
                 */

              }, {
                key: "abortContainerDrag",
                value: function abortContainerDrag() {
                  var invalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var me = this,
                      context = me.context;

                  if (context.dragging) {
                    context.dragging.classList.remove(me.dropPlaceholderCls);
                    context.dragProxy.remove();
                    me.context = {};
                  }

                  if (!silent) {
                    me.trigger(invalid ? 'drop' : 'abort', {
                      context: context,
                      event: event
                    });
                  }
                } //endregion
                //region Helpers

                /**
                 * Starts a drag operation by creating a proxy and storing which element is being dragged.
                 * @private
                 */
                // startDrag() {
                //     const context = this.context,
                //           div      = context.element.cloneNode(true);
                //
                //     // init drag proxy
                //     div.classList.add('b-drag-proxy');
                //     document.body.appendChild(div);
                //     context.dragProxy = div;
                //
                //     // style dragged element
                //     context.dragging = context.element;
                //     context.dragging.classList.add('myClass');
                // }

                /**
                 * Updates the drag proxy position.
                 * @private
                 * @param event
                 */

              }, {
                key: "updateContainerProxy",
                value: function updateContainerProxy(event) {
                  var me = this,
                      context = me.context,
                      proxy = context.dragProxy;
                  var newX = event.pageX - context.offsetX,
                      newY = event.pageY - context.offsetY;

                  if (typeof me.minX === 'number') {
                    newX = Math.max(me.minX, newX);
                  }

                  if (typeof me.maxX === 'number') {
                    newX = Math.min(me.maxX - proxy.offsetWidth, newX);
                  }

                  if (typeof me.minY === 'number') {
                    newY = Math.max(me.minY, newY);
                  }

                  if (typeof me.maxY === 'number') {
                    newY = Math.min(me.maxY - proxy.offsetHeight, newY);
                  }

                  if (me.lockX) {
                    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setTranslateY(proxy, newY);
                  } else if (me.lockY) {
                    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setTranslateX(proxy, newX);
                  } else {
                    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setTranslateXY(proxy, newX, newY);
                  }

                  var targetElement;

                  if (event.type === 'touchmove') {
                    var touch = event.changedTouches[0];
                    targetElement = document.elementFromPoint(touch.clientX, touch.clientY);
                  } else {
                    targetElement = event.target;
                  }

                  context.targetElement = targetElement;
                }
                /**
                 * Positions element being dragged in relation to targetElement.
                 * @private
                 * @param targetElement
                 * @param event
                 */

              }, {
                key: "moveNextTo",
                value: function moveNextTo(targetElement, event) {
                  var context = this.context,
                      dragElement = context.dragging,
                      parent = targetElement.parentElement;

                  if (targetElement !== dragElement) {
                    // dragged over a container and not over self, calculate where to insert
                    var centerX = targetElement.getBoundingClientRect().left + targetElement.offsetWidth / 2;

                    if (event.pageX < centerX) {
                      // dragged left of target center, insert before
                      parent.insertBefore(dragElement, targetElement);
                      context.insertBefore = targetElement;
                    } else {
                      // dragged right of target center, insert after
                      if (targetElement.nextElementSibling) {
                        // check that not dragged to the immediate left of self. in such case, position should not change
                        if (targetElement.nextElementSibling !== dragElement) {
                          context.insertBefore = targetElement.nextElementSibling;
                          parent.insertBefore(dragElement, targetElement.nextElementSibling);
                        } else if (!context.insertBefore && dragElement.parentElement.lastElementChild !== dragElement) {
                          // dragged left initially, should stay in place (checked in finishContainerDrag)
                          // TODO: or flag as invalid drag? since no change...
                          context.insertBefore = targetElement.nextElementSibling;
                        }
                      } else {
                        parent.appendChild(dragElement);
                        context.insertBefore = null;
                      }
                    }

                    context.draggedTo = parent;
                  }
                }
                /**
                 * Moves element being dragged back to its original position.
                 * @private
                 */

              }, {
                key: "revertPosition",
                value: function revertPosition() {
                  var context = this.context,
                      original = context.originalPosition; // revert to correct location

                  if (original.next) {
                    var isNoop = original.next && original.next.previousSibling === context.dragging || !original.next && context.dragging === original.parent.lastChild;

                    if (!isNoop) {
                      original.parent.insertBefore(context.dragging, original.next);
                    }
                  } else {
                    original.parent.appendChild(context.dragging);
                  } // no target container


                  context.draggedTo = null;
                } //endregion

              }]);

              return DragHelperContainer;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/helper/mixin/DragHelperTranslate.js":
      /*!**************************************************************!*\
        !*** ../Grid/lib/Common/helper/mixin/DragHelperTranslate.js ***!
        \**************************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperMixinDragHelperTranslateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/mixin/DragHelperTranslate
         */

        var noScroll = {
          pageXOffset: 0,
          pageYOffset: 0
        };
        /**
         * Mixin for DragHelper that handles repositioning (translating) an element within its container
         *
         * @private
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_Delayable) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(DragHelperTranslate, _Delayable);

              function DragHelperTranslate() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DragHelperTranslate);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(DragHelperTranslate).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DragHelperTranslate, [{
                key: "initTranslateDrag",
                //region Init

                /**
                 * Initialize translation drag mode.
                 * @private
                 */
                value: function initTranslateDrag() {
                  var me = this;

                  if (!me.isElementDraggable && me.targetSelector) {
                    me.isElementDraggable = function (element) {
                      return _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(element, me.targetSelector);
                    };
                  }
                } //endregion
                //region Grab, update, finish

                /**
                 * Grab an element which can be moved using translation.
                 * @private
                 * @param event
                 * @returns {Boolean}
                 */

              }, {
                key: "grabTranslateDrag",
                value: function grabTranslateDrag(event) {
                  var me = this,
                      element = me.getTarget(event);

                  if (element) {
                    me.context = {
                      valid: true,
                      action: me.mode,
                      // translateX or translateXY...
                      element: element,
                      startPageX: event.pageX,
                      startPageY: event.pageY,
                      startClientX: event.clientX,
                      startClientY: event.clientY
                    };
                    return true;
                  }

                  return false;
                }
              }, {
                key: "getTarget",
                value: function getTarget(event) {
                  return _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(event.target, this.targetSelector);
                }
                /**
                 * Start translating, called on first mouse move after dragging
                 * @private
                 * @param event
                 */

              }, {
                key: "startTranslateDrag",
                value: function startTranslateDrag(event) {
                  var me = this,
                      context = me.context,
                      relatedElements = context.relatedElements;
                  var element = context.dragProxy || context.element;

                  if (element && !context.started) {
                    var grabbed = element,
                        grabbedParent = element.parentElement,
                        // When cloning an element to be dragged, we place it in BODY by default
                    dragWithin = me.dragWithin = me.dragWithin || me.cloneTarget && document.body,
                        outerElement = me.outerElement;

                    if (me.cloneTarget) {
                      var offsetX = _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getOffsetX(element, dragWithin),
                          offsetY = _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getOffsetY(element, dragWithin),
                          offsetWidth = element.offsetWidth,
                          offsetheight = element.offsetHeight;

                      element = this.createProxy(element); // Match the grabbed element's size and position.

                      _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateXY(element, offsetX, offsetY);

                      element.style.width = "".concat(offsetWidth, "px");
                      element.style.height = "".concat(offsetheight, "px");
                      element.classList.add(me.dragProxyCls);
                      dragWithin.appendChild(element);
                      grabbed.classList.add('b-drag-original');

                      if (me.hideOriginalElement) {
                        grabbed.classList.add('b-hidden');
                      }
                    }

                    Object.assign(me.context, {
                      // The element which we're moving, could be a cloned version of grabbed, or the grabbed element itself
                      element: element,
                      // The original element upon which the mousedown event triggered a drag operation
                      grabbed: grabbed,
                      // The parent of the original element where the pointerdown was detected - to be able to restore after an invalid drop
                      grabbedParent: grabbedParent,
                      // The next sibling of the original element where the pointerdown was detected - to be able to restore after an invalid drop
                      grabbedNextSibling: element.nextElementSibling,
                      // elements position within parent element
                      elementStartX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getTranslateX(element),
                      elementStartY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getTranslateY(element),
                      elementX: _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getOffsetX(element, dragWithin || outerElement),
                      elementY: _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getOffsetY(element, dragWithin || outerElement),
                      scrollX: 0,
                      scrollY: 0,
                      scrollManagerElementContainsDragProxy: !me.cloneTarget || dragWithin === outerElement
                    });
                    element.classList.add(me.draggingCls);

                    if (dragWithin) {
                      context.parentElement = element.parentElement;

                      if (dragWithin !== element.parentElement) {
                        dragWithin.appendChild(element);
                      }

                      me.updateTranslateProxy(event);
                    }

                    if (relatedElements) {
                      relatedElements.forEach(function (r) {
                        r.classList.add(me.draggingCls);
                      });
                    }
                  }
                }
                /**
                 * Limit translation to outer bounds and specified constraints
                 * @private
                 * @param element
                 * @param x
                 * @param y
                 * @returns {{constrainedX: *, constrainedY: *}}
                 */

              }, {
                key: "applyConstraints",
                value: function applyConstraints(element, x, y) {
                  var me = this,
                      dragWithin = me.dragWithin,
                      _ref = dragWithin === document.body ? window : noScroll,
                      pageXOffset = _ref.pageXOffset,
                      pageYOffset = _ref.pageYOffset; // limit to outer elements edges


                  if (dragWithin && me.constrain) {
                    if (x < 0) x = 0;
                    if (x + element.offsetWidth > dragWithin.scrollWidth) x = dragWithin.scrollWidth - element.offsetWidth;
                    if (y < 0) y = 0;
                    if (y + element.offsetHeight > dragWithin.scrollHeight) y = dragWithin.scrollHeight - element.offsetHeight;
                  } // limit horizontally


                  if (typeof me.minX === 'number') {
                    x = Math.max(me.minX + pageXOffset, x);
                  }

                  if (typeof me.maxX === 'number') {
                    x = Math.min(me.maxX + pageXOffset, x);
                  } // limit vertically


                  if (typeof me.minY === 'number') {
                    y = Math.max(me.minY + pageYOffset, y);
                  }

                  if (typeof me.maxY === 'number') {
                    y = Math.min(me.maxY + pageYOffset, y);
                  }

                  return {
                    constrainedX: x,
                    constrainedY: y
                  };
                }
                /**
                 * Update elements translation on mouse move.
                 * @private
                 * @param event
                 */

              }, {
                key: "updateTranslateProxy",
                value: function updateTranslateProxy(event, scrollManagerConfig) {
                  var me = this,
                      mode = me.mode,
                      lockX = me.lockX,
                      lockY = me.lockY,
                      context = me.context,
                      element = context.dragProxy || context.element,
                      relatedElements = context.relatedElements,
                      relatedElDragFromPos = context.relatedElDragFromPos; // If we are cloning the dragged element outside of the element(s) monitored by the ScrollManager, then no need to take the scrollManager scroll values into account
                  // since it is only relevant when dragProxy is inside the Grid (where scroll manager operates).

                  if (context.scrollManagerElementContainsDragProxy && scrollManagerConfig) {
                    context.scrollX = scrollManagerConfig.scrollRelativeLeft;
                    context.scrollY = scrollManagerConfig.scrollRelativeTop;
                  }

                  context.pageX = event.pageX;
                  context.pageY = event.pageY;
                  context.clientX = event.clientX;
                  context.clientY = event.clientY;

                  var newX = context.elementStartX + event.pageX - context.startPageX + context.scrollX,
                      newY = context.elementStartY + event.pageY - context.startPageY + context.scrollY,
                      _me$applyConstraints = me.applyConstraints(element, newX, newY),
                      constrainedX = _me$applyConstraints.constrainedX,
                      constrainedY = _me$applyConstraints.constrainedY;

                  if (mode === 'translateXY' && !(lockX || lockY)) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateXY(element, constrainedX, constrainedY);
                  } else if (mode === 'translateX' || lockY) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateX(element, constrainedX);
                  } else if (mode === 'translateY' || lockX) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateY(element, constrainedY);
                  }

                  if (relatedElements) {
                    var deltaX = !lockX && mode !== 'translateY' ? constrainedX - context.elementStartX : 0,
                        deltaY = !lockY && mode !== 'translateX' ? constrainedY - context.elementStartY : 0;
                    relatedElements.forEach(function (r, i) {
                      var _relatedElDragFromPos = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(relatedElDragFromPos[i], 2),
                          x = _relatedElDragFromPos[0],
                          y = _relatedElDragFromPos[1];

                      _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateXY(r, x + deltaX, y + deltaY);
                    });
                  }

                  context.newX = constrainedX;
                  context.newY = constrainedY;
                }
                /**
                 * Finalize drag, fire drop.
                 * @private
                 * @param event
                 * @fires drop
                 */

              }, {
                key: "finishTranslateDrag",
                value: function finishTranslateDrag(event) {
                  var me = this,
                      context = me.context,
                      xChanged = context.newX !== context.elementStartX,
                      yChanged = context.newY !== context.elementStartY,
                      element = context.dragProxy || context.element,
                      relatedElements = context.relatedElements;

                  function cleanUp() {
                    element.classList.remove(me.invalidCls);
                    element.classList.remove(me.draggingCls);

                    if (relatedElements) {
                      relatedElements.forEach(function (r) {
                        r.classList.remove(me.invalidCls);
                        r.classList.remove(me.draggingCls);
                      });
                    } // If we're currently aborting, the b-hidden CSS class will be removed after animation is complete


                    if (!element.classList.contains('b-aborting')) {
                      if (me.hideOriginalElement) {
                        context.grabbed.classList.remove('b-hidden');
                      }

                      context.grabbed.classList.remove('b-drag-original');
                    }
                  }

                  if (!me.ignoreSamePositionDrop || me.mode !== 'translateY' && xChanged || me.mode !== 'translateX' && yChanged) {
                    if (context.valid === false) {
                      me.abortTranslateDrag(true, event);
                    } else {
                      var targetRect = _util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(me.dragWithin || me.outerElement);

                      if (!me.minX && event.pageX < targetRect.left || !me.maxX && event.pageX > targetRect.right || !me.minY && event.pageY < targetRect.top || !me.maxY && event.pageY > targetRect.bottom) {
                        // revert location when dropped outside allowed element
                        context.valid = false;
                        me.abortTranslateDrag(true, event);
                      } else {
                        context.finalize = function () {
                          var valid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : context.valid;

                          if (context.asyncCleanup) {
                            cleanUp();
                          } // abort if invalid (and context still exists, might have been aborted from outside)


                          if (!valid && me.context) {
                            // abort if flagged as invalid, without triggering abort or drop again
                            me.abortTranslateDrag(true, null, true);
                          } else if (me.cloneTarget || context.dragProxy) {
                            element.remove();
                          }

                          me.reset();
                        }; // allow async finalization by setting async to true on context in drop handler,
                        // requires implementer to call context.finalize later to finish the drop


                        context.async = false;
                        me.trigger('drop', {
                          context: context,
                          event: event
                        });

                        if (!context.async) {
                          // finalize immediately
                          context.finalize();
                        } else {
                          context.awaitingFinalization = true;
                        }
                      }
                    }

                    if (!context.asyncCleanup) {
                      cleanUp();
                    }
                  } else {
                    // no change, abort but not as invalid
                    me.abortTranslateDrag(false, event);
                  }
                }
                /**
                 * Abort translation
                 * @private
                 * @param invalid
                 * @fires abort
                 */

              }, {
                key: "abortTranslateDrag",
                value: function abortTranslateDrag() {
                  var invalid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var me = this,
                      context = me.context,
                      relatedElements = context.relatedElements,
                      relatedElStartPos = context.relatedElStartPos,
                      grabbed = context.grabbed,
                      element = context.dragProxy || context.element,
                      resetEl = me.cloneTarget && me.hideOriginalElement ? grabbed : element;
                  var elementStartX = context.elementStartX,
                      elementStartY = context.elementStartY;

                  if (element && context.started) {
                    // Put the dragged element back where it was
                    if (!me.cloneTarget && me.dragWithin && me.dragWithin !== context.grabbedParent) {
                      context.grabbedParent.insertBefore(element, context.grabbedNextSibling);
                    }

                    grabbed.classList.remove('b-hidden'); // Align the now visible grabbed element with the clone, so that it looks like it's
                    // sliding back into place when the clone is removed

                    if (me.cloneTarget) {
                      if (me.hideOriginalElement) {
                        var _DomHelper$getTransla = _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getTranslateXY(grabbed);

                        var _DomHelper$getTransla2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_DomHelper$getTransla, 2);

                        elementStartX = _DomHelper$getTransla2[0];
                        elementStartY = _DomHelper$getTransla2[1];

                        _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].alignTo(grabbed, element); // The getBoundingClientRect is important. The aligning above must be processed
                        // by a forced synchronous layout *before* the b-aborting class is added below.


                        resetEl.getBoundingClientRect();
                      }

                      element.remove();
                    } // animated restore of position.


                    resetEl.classList.add('b-aborting'); // Move the elements back to their original positions.

                    if (me.mode === 'translateXY' && !(me.lockX || me.lockY)) {
                      _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateXY(resetEl, elementStartX, elementStartY);

                      relatedElements && relatedElements.forEach(function (element, i) {
                        element.classList.add('b-aborting');

                        _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateXY(element, relatedElStartPos[i][0], relatedElStartPos[i][1]);
                      });
                    }

                    if (me.mode === 'translateX' || me.lockY) {
                      _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateX(resetEl, elementStartX);

                      relatedElements && relatedElements.forEach(function (element, i) {
                        element.classList.add('b-aborting');

                        _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateX(element, relatedElStartPos[i][0]);
                      });
                    }

                    if (me.mode === 'translateY' || me.lockX) {
                      _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateY(resetEl, elementStartY);

                      relatedElements && relatedElements.forEach(function (element, i) {
                        element.classList.add('b-aborting');

                        _DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateY(element, relatedElStartPos[i][1]);
                      });
                    }

                    me.setTimeout(function () {
                      resetEl.classList.remove('b-aborting');
                      grabbed.classList.remove('b-dragging');
                      grabbed.classList.remove('b-drag-original');

                      if (!me.cloneTarget) {
                        relatedElements && relatedElements.forEach(function (element, i) {
                          element.classList.remove('b-aborting');
                        });
                        element.classList.remove('b-aborting');
                        element.classList.remove(me.draggingCls);
                        element.classList.remove(me.invalidCls);
                      }
                    }, 300, undefined, true);

                    if (!silent) {
                      me.trigger(invalid ? 'drop' : 'abort', {
                        context: context,
                        event: event
                      });
                    }
                  }

                  me.reset();
                } //endregion

              }]);

              return DragHelperTranslate;
            }(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__["default"])(Target || _Base_js__WEBPACK_IMPORTED_MODULE_8__["default"]))
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/helper/util/DataGenerator.js":
      /*!*******************************************************!*\
        !*** ../Grid/lib/Common/helper/util/DataGenerator.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilDataGeneratorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DataGenerator;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../Grid/node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "../Grid/node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./RandomGenerator.js */
        "../Grid/lib/Common/helper/util/RandomGenerator.js");
        /* harmony import */


        var _DateHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';

        var DataGenerator =
        /*#__PURE__*/
        function () {
          function DataGenerator() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DataGenerator);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DataGenerator, null, [{
            key: "reset",
            //region Random
            value: function reset() {
              this.rnd.reset();
              this.rndTime.reset();
            } //endregion
            //region Generate data

          }, {
            key: "generate",
            value:
            /*#__PURE__*/
            _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function generate(count) {
              var randomHeight,
                  initialId,
                  me,
                  rnd,
                  rndTime,
                  firstNames,
                  surNames,
                  teams,
                  foods,
                  colors,
                  cities,
                  i,
                  firstName,
                  surName,
                  name,
                  startDay,
                  start,
                  finish,
                  row,
                  _args = arguments;
              return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function generate$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      randomHeight = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;
                      initialId = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1;
                      me = this, rnd = me.rnd, rndTime = me.rndTime, firstNames = me.firstNames, surNames = me.surNames, teams = me.teams, foods = me.foods, colors = me.colors, cities = me.cities;
                      i = 0;

                    case 4:
                      if (!(i < count)) {
                        _context.next = 12;
                        break;
                      }

                      firstName = rnd.fromArray(firstNames), surName = rnd.fromArray(surNames), name = "".concat(firstName, " ").concat(String.fromCharCode(65 + i % 25), " ").concat(surName), startDay = rnd.nextRandom(60) + 1, start = new Date(2019, 0, startDay), finish = new Date(2019, 0, startDay + rnd.nextRandom(30) + 2), row = {
                        id: i + initialId,
                        title: 'Row ' + i,
                        name: name,
                        firstName: firstName,
                        surName: surName,
                        city: rnd.fromArray(cities),
                        team: rnd.fromArray(cities) + ' ' + rnd.fromArray(teams),
                        age: 10 + rnd.nextRandom(80),
                        food: rnd.fromArray(foods),
                        color: rnd.fromArray(colors),
                        score: rnd.nextRandom(100) * 10,
                        rank: rnd.nextRandom(100) + 1,
                        start: start,
                        finish: finish,
                        time: _DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getTime(rndTime.nextRandom(24), rndTime.nextRandom(12) * 5),
                        percent: rnd.nextRandom(100),
                        done: rnd.nextRandom(100) < 50,
                        rating: Math.round(Math.random() * 5),
                        relatedTo: Math.min(count - 1, i + initialId + rnd.nextRandom(10))
                      };

                      if (randomHeight) {
                        row.rowHeight = rnd.nextRandom(randomHeight === true ? 20 : randomHeight) * 5 + 20;
                      }

                      _context.next = 9;
                      return row;

                    case 9:
                      i++;
                      _context.next = 4;
                      break;

                    case 12:
                    case "end":
                      return _context.stop();
                  }
                }
              }, generate, this);
            }) // Param reset defaults to true to ensure we get the same dataset on consecutive calls. Without it, code editor
            // reloading modules yields different data each time

          }, {
            key: "generateData",
            value: function generateData(count) {
              var randomHeight = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var initialId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              var reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
              if (reset) this.reset();
              var rows = [],
                  number = DataGenerator.overrideRowCount ? DataGenerator.overrideRowCount : count,
                  generator = this.generate(number, randomHeight, initialId);

              for (var i = 0; i < number; i++) {
                rows.push(generator.next().value);
              }

              return rows;
            } //endregion

          }]);

          return DataGenerator;
        }();

        Object.assign(DataGenerator, {
          rnd: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_5__["default"](),
          rndTime: new _RandomGenerator_js__WEBPACK_IMPORTED_MODULE_5__["default"](),
          rating: 0,
          cities: ['Stockholm', 'Barcelona', 'Paris', 'Dubai', 'New York', 'San Francisco', 'Washington', 'Moscow'],
          firstNames: ['Mike', 'Linda', 'Don', 'Karen', 'Doug', 'Jenny', 'Daniel', 'Melissa', 'John', 'Jane', 'Theo', 'Lisa', 'Adam', 'Mary', 'Barbara', 'James', 'David'],
          surNames: ['McGregor', 'Ewans', 'Scott', 'Smith', 'Johnson', 'Adams', 'Williams', 'Brown', 'Jones', 'Miller', 'Davis', 'More', 'Wilson', 'Taylor', 'Anderson', 'Thomas', 'Jackson'],
          teams: ['Lions', 'Eagles', 'Tigers', 'Horses', 'Dogs', 'Cats', 'Panthers', 'Rats', 'Ducks', 'Cougars', 'Hens', 'Roosters'],
          foods: ['Pancake', 'Burger', 'Fish n chips', 'Carbonara', 'Taco', 'Salad', 'Bolognese', 'Mac n cheese', 'Waffles'],
          colors: ['Blue', 'Green', 'Red', 'Yellow', 'Pink', 'Purple', 'Orange', 'Teal', 'Black']
        });
        DataGenerator._$name = 'DataGenerator';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/DemoBot.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/helper/util/DemoBot.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilDemoBotJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DemoBot;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.repeat */
        "../Grid/node_modules/core-js/modules/es6.string.repeat.js");
        /* harmony import */


        var core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Rectangle_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _IdHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");

        var productName = 'scheduler';
        var knownProps = ['action', 'target', 'to', 'deltaX', 'deltaY', 'x', 'y', 'text'];

        var DemoBot =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(DemoBot, _Events);

          function DemoBot() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, DemoBot);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DemoBot).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(DemoBot, [{
            key: "construct",
            // expects an outer element (grid.element/scheduler.element) and an array of steps similar to chain steps in siesta
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DemoBot.prototype), "construct", this).call(this, config);

              var me = this;

              if (me.widget) {
                me.outerElement = me.widget.element;
                me.widget.playingDemo = true;
              }

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].playingDemo = true;
              Object.assign(me, {
                prevTarget: null,
                currentStep: 0,
                mouse: _DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createElement({
                  parent: me.outerElement,
                  tag: 'div',
                  className: 'simulated-mouse'
                }),
                timeoutId: null,
                innerIntervalId: null,
                mouseOutElements: []
              });
              me.intervalId = me.setInterval(me.nextStep.bind(me), 1000);
              me.outerElement.classList.add('b-playing-demo');
              me.outerElement.addEventListener('click', function (event) {
                if (event.isTrusted) {
                  me.abort();
                }
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.abort();
            } // stops the bot

          }, {
            key: "abort",
            value: function abort() {
              var atEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this;
              me.mouse.style.top = '-100px';
              me.clearInterval(me.intervalId);
              me.timeoutId && me.clearTimeout(me.timeoutId);
              me.innerIntervalId && me.clearInterval(me.innerIntervalId);
              me.outerElement.classList.remove('b-playing-demo');

              if (me.widget) {
                me.widget.playingDemo = false;
              }

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].playingDemo = false;
              me.trigger(atEnd ? 'done' : 'abort');
            } // triggers a synthetic event

          }, {
            key: "triggerEvent",
            value: function triggerEvent(element, type, data) {
              if (!element) return null;
              var event;

              if (type.startsWith('mouse')) {
                var box = this.mouse.getBoundingClientRect();
                event = new MouseEvent(type, Object.assign({
                  view: window,
                  bubbles: true,
                  cancelable: true,
                  clientX: box.left,
                  clientY: box.top
                }, data || {}));
              } else {
                event = document.createEvent('Event');
                event.initEvent(type, true, false);
              }

              element.dispatchEvent(event);
              return event;
            } // moves mouse to target in 10 steps, with animated transition between steps

          }, {
            key: "handleMouseMove",
            value: function handleMouseMove(step, target) {
              var me = this,
                  mouse = me.mouse;
              mouse.classList.add('quick');
              if (me.mouseDown) mouse.classList.add('drag');

              var mouseBox = _Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(mouse, me.outerElement),
                  x = mouseBox.x,
                  y = mouseBox.y,
                  deltaX = 0,
                  deltaY = 0;

              if (step.to) {
                if (typeof step.to === 'string') {
                  var toElement = me.outerElement.querySelector(step.to);

                  if (toElement) {
                    var rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(toElement, me.outerElement),
                        toX = rect.x + rect.width / 2,
                        toY = rect.y + rect.height / 2;

                    deltaX = (toX - x) / 10;
                    deltaY = (toY - y) / 10;
                  }
                } else if (step.to.x) {
                  deltaX = (step.to.x - x) / 10;
                } else {
                  deltaX = step.to[0] / 10;
                  deltaY = step.to[1] / 10;
                }
              } else if (step.deltaX) {
                deltaX = step.deltaX / 10;
              } else if (step.x) {
                deltaX = (step.x - x) / 10;
              }

              if (step.deltaY) {
                deltaY = step.deltaY / 10;
              }

              var i = 0;
              me.innerIntervalId = me.setInterval(function () {
                // Only move mouse if in view and not scrolling
                if (me.shouldPause) {
                  return;
                }

                if (i++ === 9) {
                  clearInterval(me.innerIntervalId);

                  if (step.then) {
                    step.then();
                  }
                }

                var mouseX = x + deltaX * i,
                    mouseY = y + deltaY * i; // Move mouse there also

                mouse.style.left = mouseX + 'px';
                mouse.style.top = mouseY + 'px';
                var mouseBounds = mouse.getBoundingClientRect(),
                    clientX = mouseBounds.left,
                    clientY = mouseBounds.top,
                    eventTarget = document.elementFromPoint(clientX, clientY);

                if (eventTarget !== me.prevTarget) {
                  if (me.prevTarget) {
                    me.mouseOutElements.push(me.prevTarget);

                    if (!_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isDescendant(me.mouseOutElements[0], eventTarget)) {
                      me.mouseOutElements.forEach(function (element) {
                        return me.triggerEvent(element, 'mouseout');
                      });
                      me.mouseOutElements.length = 0;
                    }
                  }

                  me.prevTarget = eventTarget;
                  me.triggerEvent(eventTarget, 'mouseover');
                }

                me.triggerEvent(eventTarget, step.action, {
                  clientX: clientX,
                  clientY: clientY
                });
              }, 50);
            } // target can be a string selector, a function or blank to use last target or outerElement if first time

          }, {
            key: "getTarget",
            value: function getTarget(step) {
              var me = this,
                  target = step.target;

              if (!target) {
                return me.prevTarget || me.outerElement;
              }

              if (typeof target === 'function') {
                return target(step);
              }

              return document.querySelector(target);
            } // action can be a function, a string or extracted from a property by scanning for unknown names

          }, {
            key: "normalizeStep",
            value: function normalizeStep(step) {
              if (step.action) {
                if (typeof step.action === 'function') {
                  return step.action(step);
                }

                return step;
              }

              if (typeof step === 'function') {
                step();
                return step;
              } // try to find action among properties


              for (var prop in step) {
                if (step.hasOwnProperty(prop) && !knownProps.includes(prop)) {
                  step.action = prop.toLowerCase();
                  step.to = step[prop];
                }
              }

              if (!step.target && (typeof step.to === 'string' || typeof step.to === 'function')) step.target = step.to;
              return step;
            }
          }, {
            key: "nextStep",
            // process the next step
            value: function nextStep() {
              var me = this; // Only perform step if in view and not scrolling

              if (me.shouldPause) {
                return;
              }

              if (me.currentStep === me.steps.length) {
                if (me.repeat) {
                  me.currentStep = 0;
                } else {
                  return me.abort(true);
                }
              } // First step, signal to let demo initialize stuff


              if (me.currentStep === 0) {
                me.trigger('initialize');
              }

              var mouse = me.mouse,
                  step = me.normalizeStep(me.steps[me.currentStep++]),
                  target = me.getTarget(step),
                  action = step.action;

              if (target && action) {
                mouse.className = 'simulated-mouse';

                if (action === 'mousemove') {
                  me.handleMouseMove(step, target);
                } else {
                  // First move mouse into position
                  if (target !== me.prevTarget) {
                    var rect = _Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(target, me.outerElement);

                    mouse.style.left = rect.x + rect.width / 2 + 'px';
                    mouse.style.top = rect.y + rect.height / 2 + 'px';
                  }

                  if (action === 'mousedown') {
                    me.mouseDown = true;
                  }

                  if (action === 'mouseup') {
                    me.mouseDown = false;
                  } // Then trigger action


                  me.timeoutId = me.setTimeout(function () {
                    me.prevTarget = target; // Animate click etc.

                    mouse.classList.add(action);

                    if (action === 'type') {
                      var field = _IdHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].fromElement(target),
                          parts = step.text.split('|');

                      field.value = parts[parts.length === 1 || field.value != parts[0] ? 0 : 1];
                    } else {
                      me.triggerEvent(target, action);
                    }
                  }, action === 'type' ? 100 : 550);
                }
              }
            }
          }, {
            key: "isScrolling",
            get: function get() {
              var me = this,
                  box = me.outerElement.getBoundingClientRect(),
                  scrolled = me.lastTop && box.top !== me.lastTop;
              me.lastTop = box.top;
              return scrolled;
            }
          }, {
            key: "isInView",
            get: function get() {
              var box = this.outerElement.getBoundingClientRect();
              return box.top < window.innerHeight && box.bottom > 0;
            }
          }, {
            key: "shouldPause",
            get: function get() {
              return !this.isInView || this.isScrolling || document.hidden || !document.hasFocus();
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                repeat: true,
                outerElement: document.body,
                callOnFunctions: true
              };
            }
          }]);

          return DemoBot;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__["default"])(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_17__["default"])()));

        DemoBot._$name = 'DemoBot';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/DomClassList.js":
      /*!******************************************************!*\
        !*** ../Grid/lib/Common/helper/util/DomClassList.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilDomClassListJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DomClassList;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "../Grid/node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/util/DomClassList
         */

        /**
         * This class encapsulates a list of CSS classes which can be set as the `className`
         * on an `HTMLElement`.
         *
         * Properties names set on this class equate to *adding* a class if the property's value
         * is _truthy_, or removing a class if the value is _falsy_.
         *
         * ```javascript
         * const myClassList = new DomClassList('b-test-button');
         *
         * myClassList.add('test-class');
         * myClassList.important = 1;
         *
         * myHtmlElement.className = myClassList; // Sets it to "b-test-button test-class important"
         * ```
         */

        var DomClassList =
        /*#__PURE__*/
        function () {
          function DomClassList() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_10___default()(this, DomClassList);

            for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
              classes[_key] = arguments[_key];
            }

            if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_9___default()(classes[0]) === 'object') {
              Object.assign(this, classes[0]);
            } else {
              this.process(1, classes);
            } // String value needs recalculating


            this[dirtySymbol] = true;
          }
          /**
           * Returns a clone of this DomClassList with all the same keys set.
           * @returns {Common.helper.util.DomClassList} A clone of this DomClassList.
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_11___default()(DomClassList, [{
            key: "clone",
            value: function clone() {
              return new DomClassList(this);
            } // An instance of this class may be assigned directly to an element's className
            // it will be coerced to a string value using this method.

          }, {
            key: "toString",
            value: function toString() {
              // Adding space at the end if there is content to make concatenation code simpler in renderers.
              return this.length ? "".concat(this.value, " ") : '';
            }
            /**
             * Analogous to string.trim, returns the string value of this `DomClassList` with no trailing space.
             * @returns {String} A concatenated string value of all the class names in this `DomClassList`
             * separated by spaces.
             */

          }, {
            key: "trim",
            value: function trim() {
              return this.value;
            }
            /**
             * Compares this ClassList to another ClassList (or class name string of space separated classes).
             * If the *same class names, regardless of order* are present, the two are considered equal.
             *
             * So `new DomClassList('foo bar bletch').isEqual('bletch bar foo')` would return `true`
             * @param {Common.helper.util.DomClassList|String} other The `DomClassList` or string of classes to compare to.
             * @returns {Boolean} `true` if the two contain the same class names.
             */

          }, {
            key: "isEqual",
            value: function isEqual(other) {
              if (typeof other === 'string') {
                testClassList.value = other;
                other = testClassList;
              }

              if (this.length === other.length) {
                var otherClasses = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getTruthyKeys(other);

                for (var i = 0, len = otherClasses.length; i < len; i++) {
                  if (!this[otherClasses[i]]) {
                    return false;
                  }
                }

                return true;
              }

              return false;
            }
          }, {
            key: "process",
            value: function process(value, classes) {
              var len = classes.length;

              for (var i = 0; i < len; i++) {
                if (classes[i]) {
                  var cls = classes[i],
                      splitClasses = cls.values ? Array.from(cls.values()) : cls.item ? Array.from(cls) : cls.split(whiteSpaceRe),
                      _len2 = splitClasses.length;

                  for (var _i = 0; _i < _len2; _i++) {
                    if (splitClasses[_i]) {
                      this[splitClasses[_i]] = value;
                    }
                  }
                }
              } // String value needs recalculating


              this[dirtySymbol] = true;
            }
            /**
             * Add CSS class(es)
             * ```
             * myClassList.add('bold', 'small');
             * ```
             * @param {String} classes CSS classes to add
             */

          }, {
            key: "add",
            value: function add() {
              for (var _len3 = arguments.length, classes = new Array(_len3), _key2 = 0; _key2 < _len3; _key2++) {
                classes[_key2] = arguments[_key2];
              }

              this.process(1, classes);
            }
            /**
             * Remove CSS class(es)
             * ```
             * myClassList.remove('bold', 'small');
             * ```
             * @param {String} classes CSS classes to remove
             */

          }, {
            key: "remove",
            value: function remove() {
              for (var _len4 = arguments.length, classes = new Array(_len4), _key3 = 0; _key3 < _len4; _key3++) {
                classes[_key3] = arguments[_key3];
              }

              this.process(0, classes);
            }
            /**
             * Analogous to the `String#split` method, but with no delimiter
             * parameter. This method returns an array containing the individual
             * CSS class names set.
             * @returns {String[]} The individual class names in this `DomClassList`
             */

          }, {
            key: "split",
            value: function split() {
              return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getTruthyKeys(this);
            }
          }, {
            key: "forEach",
            value: function forEach(fn) {
              return _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getTruthyKeys(this).forEach(fn);
            } // To gain some speed in DomHelper.sync(), faster than instanceof etc

          }, {
            key: "value",
            get: function get() {
              var me = this;

              if (me[dirtySymbol]) {
                var keys = _ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getTruthyKeys(me);

                me[lengthSymbol] = keys.length;
                me[valueSymbol] = keys.join(' ');
                me[dirtySymbol] = false;
              }

              return me[valueSymbol];
            },
            set: function set(value) {
              var me = this,
                  keys = Object.keys(me),
                  len = keys.length;

              for (var i = 0; i < len; i++) {
                delete me[keys[i]];
              }

              if (value) {
                me.process(1, [value]);
              } else {
                // String value needs recalculating
                me[dirtySymbol] = true;
              }
            }
          }, {
            key: "length",
            get: function get() {
              // Maintainer: We MUST access the value getter to force
              // the value to be calculated if it's currently dirty.
              return this.value ? this[lengthSymbol] : 0;
            }
          }, {
            key: "isDomClassList",
            get: function get() {
              return true;
            }
          }]);

          return DomClassList;
        }();

        ;
        var whiteSpaceRe = /\s+/,
            valueSymbol = Symbol('value'),
            lengthSymbol = Symbol('length'),
            dirtySymbol = Symbol('dirty'),
            testClassList = new DomClassList();
        DomClassList._$name = 'DomClassList';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/Fullscreen.js":
      /*!****************************************************!*\
        !*** ../Grid/lib/Common/helper/util/Fullscreen.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilFullscreenJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Fullscreen;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "../Grid/node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _StringHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/util/Fullscreen
         */

        /**
         * Encapsulates the functionality related to switching cross-browser to full screen view and back.
         */

        var Fullscreen =
        /*#__PURE__*/
        function () {
          function Fullscreen() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Fullscreen);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Fullscreen, null, [{
            key: "init",
            value: function init() {
              var fnNames = ['fullscreenEnabled', 'requestFullscreen', 'exitFullscreen', 'fullscreenElement'],
                  // turns fnNames into function calls to prefixed functions, fullscreenEnabled -> document.mozFullscreenEnabled
              prefixFn = function prefixFn(prefix) {
                return fnNames.map(function (fn) {
                  var result = prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalizeFirstLetter(fn); // fullscreenEnabled in Firefox is called fullScreenEnabled


                  if (prefix === 'moz') {
                    result = result.replace('screen', 'Screen'); // #6555 - Crash when clicking full screen button twice
                    // firefox doesn't support exitFullScreen method

                    if ('mozCancelFullScreen' in document && fn === 'exitFullscreen') {
                      result = 'mozCancelFullScreen';
                    }
                  }

                  return result;
                });
              };

              this.functions = 'fullscreenEnabled' in document && fnNames || 'webkitFullscreenEnabled' in document && prefixFn('webkit') || 'mozFullScreenEnabled' in document && prefixFn('moz') || 'msFullscreenEnabled' in document && prefixFn('ms') || [];

              var eventNames = ['fullscreenchange', 'fullscreenerror'],
                  msEventNames = ['MSFullscreenChange', 'MSFullscreenError'],
                  prefixEvt = function prefixEvt(prefix) {
                return eventNames.map(function (eventName) {
                  return prefix + _StringHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].capitalizeFirstLetter(eventName);
                });
              };

              this.events = 'fullscreenEnabled' in document && eventNames || 'webkitFullscreenEnabled' in document && prefixEvt('webkit') || 'mozFullscreenEnabled' in document && prefixEvt('moz') || 'msFullscreenEnabled' in document && msEventNames || [];
            }
            /**
             * True if the fullscreen mode is supported and enabled, false otherwise
             * @property {Boolean}
             */

          }, {
            key: "request",

            /**
             * Request entering the fullscreen mode. 
             * @param {HTMLElement} element Element to be displayed fullscreen
             */
            value: function request(element) {
              return element[this.functions[1]](element);
            }
            /**
             * Exit the previously entered fullscreen mode.
             */

          }, {
            key: "exit",
            value: function exit() {
              return document[this.functions[2]]();
            }
            /**
             * True if fullscreen mode is currently active, false otherwise
             * @return {Boolean}
             */

          }, {
            key: "onFullscreenChange",

            /**
             * Installs the passed listener to fullscreenchange event
             * @param {Function} fn The listener to install
             */
            value: function onFullscreenChange(fn) {
              document.addEventListener(this.events[0], fn);
            }
            /**
             * Uninstalls the passed listener from fullscreenchange event
             * @param {Function} fn 
             */

          }, {
            key: "unFullscreenChange",
            value: function unFullscreenChange(fn) {
              document.removeEventListener(this.events[0], fn);
            }
          }, {
            key: "enabled",
            get: function get() {
              return document[this.functions[0]];
            }
          }, {
            key: "isFullscreen",
            get: function get() {
              return !!document[this.functions[3]];
            }
          }]);

          return Fullscreen;
        }();

        Fullscreen.init();
        Fullscreen._$name = 'Fullscreen';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/Navigator.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/helper/util/Navigator.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilNavigatorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Navigator;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/util/Navigator
         */

        /**
         * A helper class which allows keyboard navigation within the {@link #config-target} element.
         * @private
         */

        var Navigator =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Navigator, _Events);

          function Navigator() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Navigator);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Navigator).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Navigator, [{
            key: "onKeyDown",
            value: function onKeyDown(keyEvent) {
              var me = this,
                  ownerCmp = me.ownerCmp,
                  activeItem = me.activeItem,
                  firstItem = me.target.querySelector(me.itemSelector),
                  keyName = keyEvent.key.trim() || keyEvent.code,
                  composedKeyName = "".concat(keyEvent.ctrlKey ? 'CTRL+' : '').concat(keyEvent.shiftKey ? 'SHIFT+' : '').concat(keyEvent.altKey ? 'ALT+' : '').concat(keyName);

              if (firstItem && me.target.offsetParent) {
                // Detect whether the navigable items flow inline or downwards.
                if (me.inlineFlow == null) {
                  var itemContainer = firstItem.parentNode,
                      itemPositionStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(firstItem, 'position'),
                      itemDisplayStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(firstItem, 'display'),
                      itemFloatStyle = _DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(firstItem, 'float'); // This is how we know that RIGHT and LEFT arrow should be used for next and previous.
                  // If inlineFlow is false, we use UP and DOWN. Consider tabs in a tab bar.


                  me.inlineFlow = itemPositionStyle === 'absolute' || itemDisplayStyle === 'inline' || itemDisplayStyle === 'inline-block' || itemFloatStyle === 'left' || itemFloatStyle === 'right' || _DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(itemContainer, 'display') === 'flex' && _DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getStyleValue(itemContainer, 'flex-direction') === 'row';

                  if (me.inlineFlow) {
                    me.prevKey = 'ArrowLeft';
                    me.nextKey = 'ArrowRight';
                  } else {
                    me.prevKey = 'ArrowUp';
                    me.nextKey = 'ArrowDown';
                  }
                } // Feed the key event through our configured processor, process the event that returns if any.


                if (me.processEvent) {
                  keyEvent = me.processEvent.call(ownerCmp, keyEvent);

                  if (!keyEvent) {
                    return;
                  }
                }

                if (activeItem) {
                  switch (keyName) {
                    case me.prevKey:
                      if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
                        return;
                      }

                      if (keyEvent.shiftKey && !me.allowShiftKey) {
                        return;
                      }

                      keyEvent.preventDefault();
                      me.navigatePrevious(keyEvent);
                      break;

                    case me.nextKey:
                      if (me.disabled || keyEvent.ctrlKey && !me.allowCtrlKey) {
                        return;
                      }

                      if (keyEvent.shiftKey && !me.allowShiftKey) {
                        return;
                      }

                      keyEvent.preventDefault();
                      me.navigateNext(keyEvent);
                      break;

                    default:
                      var keyHandler = me.keys && me.keys[composedKeyName];

                      if (keyHandler && !me.disabled) {
                        me.callback(keyHandler, me.thisObj || ownerCmp, [keyEvent]);
                      } // Note that even if this.disabled, the ownerCmp will expect
                      // to have its key down hander invoked.
                      else if (ownerCmp.onInternalKeyDown) {
                          ownerCmp.onInternalKeyDown(keyEvent);
                        }

                  }
                } else {
                  me.activeItem = me.previousActiveItem || me.getDefaultNavigationItem(keyEvent);
                }

                if (me.activeItem !== activeItem) {
                  /**
                   * Fired when a user gesture causes the active item to change _or become `null`_.
                   * @event navigate
                   * @param {Event} event The browser event which instigated navigation. May be a click or key or focus move event.
                   * @param {HTMLElement} item The newly active item, or `null` if focus moved out.
                   */
                  me.trigger('navigate', {
                    event: keyEvent,
                    item: me.activeItem
                  });
                }
              }
            }
          }, {
            key: "getDefaultNavigationItem",
            value: function getDefaultNavigationItem(keyEvent) {
              var target = this.target,
                  itemSelector = this.itemSelector,
                  prevKey = this.prevKey,
                  nextKey = this.nextKey; // Navigating backwards from after the component, we default to last item

              if (target.compareDocumentPosition(keyEvent.target) & 4 && keyEvent.key === prevKey) {
                return target.querySelector("".concat(itemSelector, ":last-of-type"));
              } // Navigating forwards from before the component we default to the first item


              if (target.compareDocumentPosition(keyEvent.target) & 2 && keyEvent.key === nextKey) {
                return target.querySelector("".concat(itemSelector));
              }
            }
          }, {
            key: "navigatePrevious",
            value: function navigatePrevious(keyEvent) {
              var me = this,
                  previous = me.previous;
              keyEvent.preventDefault();

              if (previous) {
                me.ownerCmp.scrollable.scrollIntoView(previous, {
                  animate: 50
                }).then(function () {
                  me.activeItem = previous;
                  me.trigger('navigate', {
                    event: keyEvent,
                    item: me.activeItem
                  });
                });
              }
            }
          }, {
            key: "navigateNext",
            value: function navigateNext(keyEvent) {
              var me = this,
                  next = me.next;
              keyEvent.preventDefault();

              if (next) {
                me.ownerCmp.scrollable.scrollIntoView(next, {
                  animate: 50
                }).then(function () {
                  me.activeItem = next;
                  me.trigger('navigate', {
                    event: keyEvent,
                    item: me.activeItem
                  });
                });
              }
            }
          }, {
            key: "onTargetFocusIn",
            value: function onTargetFocusIn(focusInEvent) {
              if (focusInEvent.target.matches(this.itemSelector)) {
                this.activeItem = focusInEvent.target;
              }
            }
          }, {
            key: "onTargetFocusOut",
            value: function onTargetFocusOut(focusOutEvent) {
              if (!focusOutEvent.relatedTarget || !this.target.contains(focusOutEvent.relatedTarget)) {
                this.activeItem = null;
              }
            }
          }, {
            key: "onTargetMouseDown",
            value: function onTargetMouseDown(mousedownEvent) {
              // Mousedown is the focus gesture.
              // This holds true even on touch platforms
              // where the mousedown event is synthesized -
              // preventing default prevents focus on the upcoming touchend.
              this.onFocusGesture(mousedownEvent);
            }
          }, {
            key: "onTargetClick",
            value: function onTargetClick(clickEvent) {
              var me = this;

              if (me.disabled) {
                return;
              } // ownerCmp's preprocessing of any navigate event.


              if (me.processEvent) {
                clickEvent = me.processEvent.call(me.ownerCmp, clickEvent);
              }

              if (clickEvent) {
                me.activeItem = clickEvent.target.closest(me.itemSelector);
                me.trigger('navigate', {
                  event: clickEvent,
                  item: me.activeItem
                });
              }
            } // We have to prevent focus moving from eg, an input field when we mousedown
            // or touchtap a non focusable item when ownerCmp has itemsFocusable: false.
            // If the event was not on an item, we must allow it through to allow Lists
            // to contain other widgets.

          }, {
            key: "onFocusGesture",
            value: function onFocusGesture(event) {
              if (event.target === this.ownerCmp.contentElement || event.target.closest(this.itemSelector) && this.ownerCmp.itemsFocusable === false) {
                event.preventDefault();
              }
            }
          }, {
            key: "acceptNode",
            value: function acceptNode(node) {
              return node.offsetParent && node.matches && node.matches(this.itemSelector) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
            }
          }, {
            key: "onTargetChildListChange",
            value: function onTargetChildListChange() {
              var activeItem = this.activeItem; // On DOM mutation, if the activeItem got changed, pull the one with the same ID out again.

              if (activeItem && !this.target.contains(activeItem)) {
                this.activeItem = this.target.querySelector("".concat(this.itemSelector, "[data-id=\"").concat(activeItem.dataset.id, "\"]"));
              }
            }
          }, {
            key: "itemSelector",
            set: function set(itemSelector) {
              this._itemSelector = itemSelector;
            },
            get: function get() {
              // Defaults to the itemCls of the owning Component (Most likely a List which must have itemCls)
              return this._itemSelector || ".".concat(this.ownerCmp.itemCls);
            }
          }, {
            key: "owner",
            get: function get() {
              return this.ownerCmp;
            }
          }, {
            key: "previous",
            get: function get() {
              var treeWalker = this.treeWalker;
              treeWalker.currentNode = this.activeItem;
              treeWalker.previousNode();

              if (treeWalker.currentNode !== this.activeItem) {
                return treeWalker.currentNode;
              }
            }
          }, {
            key: "next",
            get: function get() {
              var treeWalker = this.treeWalker;
              treeWalker.currentNode = this.activeItem;
              treeWalker.nextNode();

              if (treeWalker.currentNode !== this.activeItem) {
                return treeWalker.currentNode;
              }
            }
          }, {
            key: "activeItem",
            get: function get() {
              return this._activeItem;
            },
            set: function set(activeItem) {
              var me = this,
                  scroller = me.ownerCmp.scrollable; // Allow index to be passed

              if (typeof activeItem === 'number') {
                activeItem = me.target.querySelectorAll(me.itemSelector)[activeItem];
              } // This may be set to null on focusout of the target element.


              if (activeItem) {
                // If we are being called in response to focus movement, it will already be the document.activeElement
                // so in that case, behave is if we were in non-focusing mode, and just add the focused class.
                if (_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isFocusable(activeItem) && activeItem !== document.activeElement) {
                  scroller.scrollIntoView(activeItem, {
                    block: 'nearest',
                    focus: true,
                    silent: me.scrollSilently
                  });
                } else {
                  if (me.activeItem) {
                    me.previousActiveItem = me.activeItem;
                    me.activeItem.classList.remove(me.focusCls);
                  }

                  scroller.scrollIntoView(activeItem, {
                    block: 'nearest',
                    silent: me.scrollSilently
                  });
                  activeItem.classList.add(me.focusCls);
                  me._activeItem = activeItem;
                }
              } else {
                // We are being called programatically
                if (activeItem === document.activeElement) {
                  me.ownerCmp.revertFocus();
                } // In response to focus movement
                else if (me.activeItem) {
                    me.activeItem.classList.remove(me.focusCls);
                  }

                me.previousActiveItem = me.target.contains(me.activeItem) ? me.activeItem : null;
                me._activeItem = null;
              }
            }
          }, {
            key: "target",
            get: function get() {
              return this._target;
            },
            set: function set(target) {
              var me = this,
                  listeners = {
                element: target,
                thisObj: me,
                focusin: 'onTargetFocusIn',
                focusout: 'onTargetFocusOut',
                click: 'onTargetClick'
              };
              me._target = target;

              if (!me.hasOwnProperty('acceptNode')) {
                me.acceptNode = me.acceptNode.bind(me); // https://github.com/webcomponents/webcomponentsjs/issues/556
                // Work around Internet Explorer wanting a function instead of an object.
                // IE also *requires* this argument where other browsers don't.

                me.acceptNode.acceptNode = me.acceptNode;
              }

              if (me.ownerCmp.itemsFocusable === false) {
                listeners.mousedown = 'onTargetMouseDown';
              }

              _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on(listeners); // This Navigator object acts as the filter for the TreeWalker. We must implement acceptNode(node)


              me.treeWalker = document.createTreeWalker(target, NodeFilter.SHOW_ELEMENT, me.acceptNode, false); // If we were not configured with an outside key event provider (think the input field providing UP/DOWN keys for the dropdown)
              // then use the target element as the source.

              if (!me.keyEventTarget) {
                me.keyEventTarget = target;
              } // If the activeItem gets removed, we must know, and deactivate.


              (me.targetMutationMonitor = new MutationObserver(me.onTargetChildListChange.bind(me))).observe(target, {
                childList: true
              });
            }
          }, {
            key: "keyEventTarget",
            get: function get() {
              return this._keyEventTarget;
            },
            set: function set(keyEventTarget) {
              this._keyEventTarget = keyEventTarget;

              _EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                element: keyEventTarget,
                keydown: 'onKeyDown',
                thisObj: this
              });
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The owning Widget which is using this Navigator.
                 * @config {Common.widget.Widget}
                 */
                ownerCmp: null,

                /**
                 * The encapsulating element in which navigation takes place.
                 * @config {HTMLElement}
                 */
                target: null,

                /**
                 * The element which provides key events for navigation. Optional. Defaults to the {@link #config-target} element.
                 * @config {HTMLElement}
                 */
                keyEventTarget: null,

                /**
                 * An optional key event processor which may preprocess the key event. Returning `null` prevents processing of the event.
                 * @config {Function}
                 */
                processEvent: null,

                /**
                 * A query selector which identifies descendant elements within the {@link #config-target} which are navigable.
                 * @config {String}
                 */
                itemSelector: null,

                /**
                 * A CSS class name to add to focused elements.
                 * @config {String}
                 * @default
                 */
                focusCls: 'b-active',

                /**
                 * An object containing key definitions keys by the key name eg:
                 *
                 * ```javascript
                 *  keys : {
                 *      "CTRL+SPACE" : 'onCtrlSpace',
                 *      ENTER        : 'onEnterKey'
                 *  }```
                 *
                 * The {@link #config-ownerCmp} is used as the `this` reference and to resolve string method names.
                 *
                 * Modified key names must be created prepending one or more `'CTRL+'`, `'SHIFT+'`, `'ALT+'`
                 * in that order, for example `"CTRL+SHIFT+ENTER" : 'showMenu'`
                 * @config {Object}
                 * @default
                 */
                keys: null,

                /**
                 * Configure as `true` to also navigate when the `CTRL` modifier key is used along with
                 * navigation keys.
                 * @config {Boolean}
                 * @default false
                 */
                allowCtrlKey: null,

                /**
                 * Configure as `true` to also navigate when the `SHIFT` modifier key is used along with
                 * navigation keys.
                 * @config {Boolean}
                 * @default false
                 */
                allowShiftKey: null
              };
            }
          }]);

          return Navigator;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_10__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"]));

        Navigator._$name = 'Navigator';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/Point.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/helper/util/Point.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilPointJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Point;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Rectangle_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");

        var productName = 'scheduler';
        /**
         * @module Common/helper/util/Point
         */

        /**
         * Encapsulates an X,Y coordinate point.
         * @extends Common/helper/util/Rectangle
         */

        var Point =
        /*#__PURE__*/
        function (_Rectangle) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Point, _Rectangle);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Point, null, [{
            key: "from",

            /**
             * Creates a new Point encapsulting the event's page position.
             * @param {Event} event
             * @typings ignore
             */
            value: function from(event) {
              var touchPoints = event.changedTouches;
              return new Point(touchPoints ? touchPoints[0].screenX : event.screenX, touchPoints ? touchPoints[0].screenY : event.pageY);
            }
            /**
             * Constructs a Point
             * @param x The X coordinate
             * @param y The Y coordinate
             */

          }]);

          function Point(x, y) {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Point);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(Point).call(this, x, y, 0, 0));
          }
          /**
           * Coerces this Point to be within the passed Rectangle. Translates it into the bounds.
           * @param {Common.helper.util.Rectangle} into The Rectangle into which to coerce this Point.
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Point, [{
            key: "constrain",
            value: function constrain(into) {
              this.x = Math.min(Math.max(this.x, into.x), into.right - 1);
              this.y = Math.min(Math.max(this.y, into.y), into.bottom - 1);
              return this;
            }
          }, {
            key: "toArray",
            value: function toArray() {
              return [this.x, this.y];
            }
          }]);

          return Point;
        }(_Rectangle_js__WEBPACK_IMPORTED_MODULE_5__["default"]); // The Rectangle class uses the Point class, but cannot import it.
        // TODO: find a better way of getting a reference to the Point class in Rectangle.
        // #8224 - Gantt angular demo doesn't work in production
        // eslint-disable-next-line no-proto


        Point.__proto__.Point = Point;
        Point._$name = 'Point';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/RandomGenerator.js":
      /*!*********************************************************!*\
        !*** ../Grid/lib/Common/helper/util/RandomGenerator.js ***!
        \*********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilRandomGeneratorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RandomGenerator;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);

        var productName = 'scheduler';
        /**
        * @module Common/helper/util/RandomGenerator
        */

        /**
         * Generates pseudo random numbers from predefined sequence of 100 numbers
         */

        var RandomGenerator =
        /*#__PURE__*/
        function () {
          function RandomGenerator() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RandomGenerator);

            this.random100 = [46, 2, 36, 46, 54, 59, 18, 20, 71, 55, 88, 98, 13, 61, 61, 40, 2, 15, 3, 32, 51, 45, 64, 25, 81, 85, 54, 13, 57, 49, 64, 22, 81, 94, 0, 62, 17, 7, 11, 2, 33, 99, 85, 26, 83, 83, 96, 26, 20, 89, 91, 38, 26, 13, 11, 79, 32, 30, 5, 51, 70, 7, 5, 56, 58, 77, 37, 89, 40, 80, 78, 59, 26, 36, 8, 51, 60, 23, 86, 5, 11, 96, 64, 94, 87, 64, 4, 78, 17, 85, 35, 0, 90, 86, 23, 55, 53, 9, 35, 59, 29, 2, 64, 42, 8, 49, 43, 73, 6, 53, 38, 9, 39, 31, 32, 40, 49, 13, 78, 68, 20, 99, 24, 78, 35, 91, 73, 46, 67, 76, 89, 69, 30, 69, 25, 3, 4, 55, 1, 65, 66, 76, 83, 19, 67, 1, 95, 24, 54, 45, 56, 40, 67, 92, 72, 4, 69, 8, 47, 50, 27, 2, 38, 9, 14, 83, 12, 14, 62, 95, 22, 47, 35, 18, 38, 14, 86, 64, 68, 61, 52, 69, 39, 93, 20, 73, 32, 52, 74, 6, 56, 68, 99, 29, 24, 92, 40, 67, 6, 72, 31, 41, 91, 53, 80, 55, 33, 97, 97, 99, 18, 20, 5, 27, 82, 84, 61, 78, 27, 67, 7, 42, 75, 95, 91, 25, 63, 21, 70, 36, 46, 0, 1, 45, 84, 6, 86, 15, 10, 62, 96, 94, 10, 23, 93, 83, 94, 47, 5, 29, 29, 52, 51, 37, 77, 96, 43, 72, 43, 14, 54, 14, 72, 52, 4, 39, 15, 26, 68, 28, 25, 76, 60, 50, 22, 40, 72, 74, 68, 58, 8, 48, 40, 62, 52, 24, 9, 26, 47, 44, 49, 96, 7, 77, 90, 45, 76, 47, 5, 86, 1, 36, 18, 42, 19, 90, 34, 23, 70, 32, 69, 79, 0, 99, 57, 80, 72, 21, 19, 72, 85, 68, 4, 40, 86, 62, 0, 63, 4, 11, 69, 31, 78, 31, 21, 78, 29, 84, 13, 53, 57, 10, 26, 50, 24, 30, 90, 42, 51, 96, 93, 21, 99, 23, 81, 0, 89, 43, 86, 63, 93, 19, 54, 71, 92, 36, 4, 95, 37, 99, 60, 29, 23, 50, 68, 95, 57, 95, 77, 53, 99, 78, 75, 12, 92, 47, 23, 14, 0, 41, 98, 11, 34, 64, 26, 90, 50, 23, 38, 31, 74, 76, 16, 76, 66, 23, 22, 72, 48, 50, 20, 36, 37, 58, 5, 43, 49, 64, 81, 30, 8, 21, 98, 75, 60, 17, 50, 42, 27, 38, 90, 74, 45, 68, 67, 27, 31, 15, 58, 76, 41, 99, 23, 98, 53, 98, 56, 19, 79, 2, 4, 38, 96, 24, 65, 51, 43, 42, 41, 60, 46, 7, 90, 65, 3, 27, 63, 99, 51, 44, 86, 1, 54, 40, 15, 74, 3, 81, 51, 63, 87, 79, 84, 72, 22, 38, 96, 95, 33, 41, 21, 99, 21, 69, 7, 49, 40, 52, 41, 6, 91, 19, 76, 40, 54, 17, 33, 11, 11, 0, 1, 32, 94, 33, 13, 18, 45, 7, 85, 61, 42, 54, 45, 72, 78, 96, 17, 9, 80, 87, 41, 96, 66, 0, 8, 59, 18, 21, 2, 28, 64, 75, 97, 32, 80, 86, 97, 97, 55, 2, 73, 75, 11, 89, 67, 58, 70, 76, 12, 46, 64, 17, 22, 97, 25, 35, 93, 57, 82, 46, 57, 61, 31, 74, 27, 4, 32, 85, 53, 86, 53, 53, 42, 5, 28, 50, 65, 63, 70, 61, 73, 37, 13, 80, 7, 34, 22, 3, 26, 6, 62, 78, 12, 56, 87, 41, 58, 64, 31, 27, 45, 35, 18, 66, 62, 43, 89, 69, 94, 93, 33, 74, 2, 43, 85, 37, 82, 41, 74, 9, 15, 44, 33, 42, 65, 19, 1, 49, 78, 12, 29, 9, 78, 7, 55, 12, 45, 40, 33, 16, 86, 14, 52, 16, 73, 76, 0, 98, 75, 91, 78, 46, 99, 95, 90, 69, 78, 45, 62, 55, 37, 88, 49, 77, 27, 83, 38, 73, 39, 1, 75, 40, 65, 83, 54, 95, 7, 73, 4, 30, 26, 36, 89, 21, 5, 95, 11, 14, 87, 45, 36, 21, 77, 55, 5, 66, 51, 98, 48, 62, 74, 58, 23, 82, 30, 28, 19, 53, 89, 76, 98, 8, 34, 70, 28, 54, 16, 52, 35, 93, 54, 54, 72, 49, 18, 93, 72, 90, 71, 73, 15, 60, 38, 80, 76, 53, 70, 39, 69, 25, 5, 31, 61, 46, 6, 54, 34, 31, 52, 33, 36, 79, 76, 44, 29, 28, 38, 1, 66, 2, 90, 91, 1, 76, 78, 31, 55, 37, 71, 2, 3, 38, 85, 0, 95, 42, 2, 39, 57, 87, 61, 77, 98, 2, 24, 80, 48, 27, 47, 71, 15, 7, 49, 60, 86, 3, 2, 29, 38, 54, 36, 59, 83, 27, 47, 9, 36, 42, 8, 73, 85, 9, 16, 73, 60, 39, 12, 43, 25, 23, 29, 28, 47, 40, 77, 20, 89, 22, 30, 41, 59, 96, 19, 56, 20, 76, 73, 39, 46, 72, 40, 47, 37, 52, 29, 79, 37, 39, 50, 41, 87, 66, 17, 75, 31, 45, 26, 88, 70, 11, 90, 40, 74, 9, 32, 65, 72, 61, 6, 93, 54, 15, 84, 22, 99, 47, 10, 96, 4, 84, 19, 85, 73, 45, 25, 16, 8, 94, 99, 39, 28, 26, 68, 87, 48, 1, 65, 86, 46, 86, 7, 60, 82, 45, 75, 38, 56, 41, 35, 30, 86, 91, 97, 85, 45, 5, 14, 69, 85, 96, 37, 18, 26, 16, 38, 16, 1, 44, 94, 85, 58, 60, 20, 5, 47, 52, 41, 50, 71, 43, 42, 67, 64, 38, 65, 83, 99, 78, 96, 33, 20, 98, 24, 6, 2, 25, 16, 16, 44, 63, 24, 68, 56, 49, 91, 15, 59, 99, 27, 43, 34, 28, 36, 45, 1, 10, 19, 54, 26, 75, 17, 88, 96, 63, 24, 71, 93, 72, 97, 66, 87, 18, 86];
            this.randomCache = {};
            this.rndIndex = 0;
          }
          /**
           * Returns next pseudo random integer number from sequence between 0 and max parameter value (99 is maximum value)
           * @param max max value
           * @returns {number}
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(RandomGenerator, [{
            key: "nextRandom",
            value: function nextRandom(max) {
              var randomCache = this.randomCache,
                  randomNumbers;

              if (randomCache[max]) {
                randomNumbers = randomCache[max];
              } else {
                randomNumbers = this.random100.filter(function (num) {
                  return num < max;
                });
                randomCache[max] = randomNumbers;
              }

              return randomNumbers[this.rndIndex++ % randomNumbers.length];
            }
            /**
             * Resets sequence to initial number
             */

          }, {
            key: "reset",
            value: function reset() {
              this.rndIndex = 0;
            }
            /**
             * Returns pseudo random array element
             * @param array input array
             * @returns {*}
             */

          }, {
            key: "fromArray",
            value: function fromArray(array) {
              return array[this.nextRandom(array.length)];
            }
          }]);

          return RandomGenerator;
        }();

        RandomGenerator._$name = 'RandomGenerator';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/Rectangle.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/helper/util/Rectangle.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilRectangleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Rectangle;
        });
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "../Grid/node_modules/core-js/modules/es6.number.constructor.js");
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "../Grid/node_modules/core-js/modules/es6.object.freeze.js");
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler';
        /**
        * @module Common/helper/util/Rectangle
        */

        var allBorders = ['border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width'],
            allPaddings = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left'],
            borderNames = {
          t: 'border-top-width',
          r: 'border-right-width',
          b: 'border-bottom-width',
          l: 'border-left-width'
        },
            paddingNames = {
          t: 'padding-top',
          r: 'padding-right',
          b: 'padding-bottom',
          l: 'padding-left'
        },
            zeroBased = Object.freeze({
          x: 0,
          y: 0
        }),
            alignSpecRe = /^([trblc])(\d*)-([trblc])(\d*)$/i,
            alignPointRe = /^([trblc])(\d*)$/i,
            edgeNames = ['top', 'right', 'bottom', 'left'],
            edgeIndices = {
          t: 0,
          r: 1,
          b: 2,
          l: 3
        },
            defaultAlignments = ['b-t', 'l-r', 't-b', 'r-l'],
            zeroOffsets = Object.freeze([0, 0]),
            matchDimensions = ['width', 'height']; // Parse a l0-r0 (That's how Menus align to their owning MenuItem) slign spec.

        function parseAlign(alignSpec) {
          var parts = alignSpecRe.exec(alignSpec),
              myOffset = parseInt(parts[2] || 50),
              targetOffset = parseInt(parts[4] || 50); // Comments assume the Menu's alignSpec of l0-r0 is used.

          return {
            myAlignmentPoint: parts[1] + myOffset,
            // l0
            myEdge: parts[1],
            // l
            myOffset: myOffset,
            // 0
            targetAlignmentPoint: parts[3] + targetOffset,
            // r0
            targetEdge: parts[3],
            // r
            targetOffset: targetOffset,
            // 0
            startZone: edgeIndices[parts[3]] // 1 - start trying zone 1 in TRBL order

          };
        } // Takes a result from the above function and flips edges for the axisLock config


        function flipAlign(align) {
          return "".concat(edgeNames[(edgeIndices[align.myEdge] + 2) % 4][0]).concat(align.myOffset, "-").concat(edgeNames[(edgeIndices[align.targetEdge] + 2) % 4][0]).concat(align.targetOffset);
        }

        function createOffsets(offset) {
          if (offset == null) {
            return zeroOffsets;
          } else if (typeof offset === 'number') {
            return [offset, offset];
          }

          return offset;
        }
        /**
         * Encapsulates rectangular areas for comparison, intersection etc.
         *
         * Note that the `right` and `bottom` properties are *exclusive*.
         *
         */


        var Rectangle =
        /*#__PURE__*/
        function () {
          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Rectangle, [{
            key: "$name",
            get: function get() {
              return this.constructor.$name;
            }
            /**
             * Constructs a Rectangle
             * @param x The X coordinate
             * @param y The Y coordinate
             * @param width The width
             * @param height The height
             */

          }], [{
            key: "from",

            /**
             * Returns the Rectangle in document based coordinates of the passed element.
             *
             * *Note:* If the element passed is the `document` or `window` the `window`'s
             * rectangle is returned which is always at `[0, 0]` and encompasses the
             * browser's entire document viewport.
             * @param {HTMLElement} element The element to calculate the Rectangle for.
             * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
             * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
             * @return {Common.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
             */
            value: function from(element, relativeTo) {
              var ignorePageScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

              if (element instanceof Rectangle) {
                return element;
              }

              if (relativeTo) {
                // TODO: nige should figure out if there is a better solution
                var _relativeTo = relativeTo,
                    scrollLeft = _relativeTo.scrollLeft,
                    scrollTop = _relativeTo.scrollTop;

                if ((_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isEdge || _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isSafari) && relativeTo === document.body) {
                  scrollLeft = scrollTop = 0;
                }

                relativeTo = Rectangle.from(relativeTo).translate(-scrollLeft, -scrollTop);
              } else {
                relativeTo = zeroBased;
              } // Viewport is denoted by requesting window or document.
              // document.body may overflow the viewport, so this must not be evaluated as the viewport.


              var isViewport = element === document || element === window,
                  viewRect = isViewport ? new Rectangle(0, 0, window.innerWidth, window.innerHeight) : element.getBoundingClientRect(),
                  scrollOffset = ignorePageScroll || isViewport ? [0, 0] : [window.pageXOffset, window.pageYOffset];
              return new Rectangle(viewRect.left + scrollOffset[0] - relativeTo.x, viewRect.top + scrollOffset[1] - relativeTo.y, viewRect.width, viewRect.height);
            }
            /**
             * Returns the inner Rectangle (within border) in document based coordinates
             * of the passed element.
             * @param element The element to calculate the Rectangle for.
             * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
             * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
             * @return {Common.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
             */

          }, {
            key: "inner",
            value: function inner(element, relativeTo) {
              var ignorePageScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

              if (document.body.contains(element)) {
                var borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(element, allBorders);

                result.x += parseInt(borders[borderNames.l]);
                result.y += parseInt(borders[borderNames.t]);
                result.right -= parseInt(borders[borderNames.r]);
                result.bottom -= parseInt(borders[borderNames.b]);
              }

              return result;
            }
            /**
             * Returns the content Rectangle (within border and padding) in document based coordinates
             * of the passed element.
             * @param element The element to calculate the Rectangle for.
             * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
             * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
             * @return {Common.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
             */

          }, {
            key: "content",
            value: function content(element, relativeTo) {
              var ignorePageScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var result = this.from(element, relativeTo, ignorePageScroll); // Can only ask for the following styles if element is in the document.

              if (document.body.contains(element)) {
                var borders = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(element, allBorders),
                    padding = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(element, allPaddings);

                result.x += parseInt(borders[borderNames.l]) + parseInt(padding[paddingNames.l]);
                result.y += parseInt(borders[borderNames.t]) + parseInt(padding[paddingNames.t]);
                result.right -= parseInt(borders[borderNames.r]) + parseInt(padding[paddingNames.r]);
                result.bottom -= parseInt(borders[borderNames.b]) + parseInt(padding[paddingNames.b]);
              }

              return result;
            }
            /**
             * Returns the client Rectangle (within border and padding and scrollbars) in document based coordinates
             * of the passed element.
             * @param element The element to calculate the Rectangle for.
             * @param {HTMLElement} [relativeTo] Optionally, a parent element in whose space to calculate the Rectangle.
             * @param {Boolean} [ignorePageScroll] Use browser viewport based coordinates.
             * @return {Common.helper.util.Rectangle} The Rectangle in document based (or, optionally viewport based) coordinates. Relative to the _relativeTo_ parameter if passed.
             */

          }, {
            key: "client",
            value: function client(element, relativeTo) {
              var ignorePageScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var result = this.content(element, relativeTo, ignorePageScroll),
                  scrollbarWidth = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].scrollBarWidth,
                  padding;

              if (scrollbarWidth) {
                // Capture width taken by any vertical scrollbar.
                // If there is a vertical scrollbar, shrink the box.
                // TODO: We may have to shrink from the left in RTL mode.
                if (element.scrollHeight > element.clientHeight) {
                  padding = parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(element, 'padding-right'));
                  result.right += padding - Math.max(padding, scrollbarWidth);
                } // Capture height taken by any horizontal scrollbar.
                // If there is a horizontal scrollbar, shrink the box.


                if (element.scrollWidth > element.clientWidth) {
                  padding = parseInt(_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getStyleValue(element, 'padding-bottom'));
                  result.bottom += padding - Math.max(padding, scrollbarWidth);
                }
              } // The client region excluding any scrollbars.


              return result;
            }
            /**
             * Returns a new rectangle created as the union of all supplied rectangles.
             * @param {Common.helper.util.Rectangle[]} rectangles
             * @return {Common.helper.util.Rectangle}
             */

          }, {
            key: "union",
            value: function union() {
              var _ref = arguments.length <= 0 ? undefined : arguments[0],
                  x = _ref.x,
                  y = _ref.y,
                  right = _ref.right,
                  bottom = _ref.bottom,
                  current;

              if (arguments.length > 1) {
                for (var i = 1; i < arguments.length; i++) {
                  current = i < 0 || arguments.length <= i ? undefined : arguments[i];

                  if (current.x < x) {
                    x = current.x;
                  }

                  if (current.y < y) {
                    y = current.y;
                  }

                  if (current.right > right) {
                    right = current.right;
                  }

                  if (current.bottom > bottom) {
                    bottom = current.bottom;
                  }
                }
              }

              return new Rectangle(x, y, right - x, bottom - y);
            } // This class doesn't extend Base and extending doesn't seem to be
            // the way to go. Instead we duplicate smallest piece of logic here

          }, {
            key: "$name",
            get: function get() {
              return this.hasOwnProperty('_$name') && this._$name || this.name;
            }
          }]);

          function Rectangle(x, y, width, height) {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Rectangle);

            var me = this;
            me._x = x;
            me._y = y;
            me._width = width;
            me._height = height;
          }
          /**
           * Creates a copy of this Rectangle.
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Rectangle, [{
            key: "clone",
            value: function clone() {
              var me = this,
                  result = new Rectangle(me.x, me.y, me.width, me.height);
              result.minHeight = me.minHeight;
              result.minWidth = me.minWidth;
              return result;
            }
            /**
             * Returns `true` if this Rectangle wholly contains the passed rectangle.
             *
             * Note that a {@link Common.helper.util.Point} may be passed.
             * @param other The Rectangle to test for containment within this Rectangle
             * @return {Boolean} `true` if the other Rectangle is wholly contained within this Rectangle
             */

          }, {
            key: "contains",
            value: function contains(other) {
              var me = this;

              if (other instanceof Rectangle) {
                return other._x >= me._x && other._y >= me._y && other.right <= me.right && other.bottom <= me.bottom;
              } else {
                return false;
              }
            }
            /**
             * Checks if this Rectangle intersects the passed Rectangle
             * @param {Common.helper.util.Rectangle} other The Rectangle to intersect with this.
             * @param {Boolean} useBoolean Specify `true` to return a boolean value instead of constructing a new Rectangle
             * @return {Common.helper.util.Rectangle|Boolean} Returns the intersection Rectangle or `false` if there is no intersection.
             */

          }, {
            key: "intersect",
            value: function intersect(other) {
              var useBoolean = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  y = Math.max(me.y, other.y),
                  r = Math.min(me.right, other.right),
                  b = Math.min(me.bottom, other.bottom),
                  x = Math.max(me.x, other.x);

              if (b > y && r > x) {
                return useBoolean ? true : new Rectangle(x, y, r - x, b - y);
              } else {
                return false;
              }
            }
          }, {
            key: "equals",
            value: function equals(other) {
              var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var processor = round ? function (x) {
                return Math.round(x);
              } : function (x) {
                return x;
              };
              return other instanceof Rectangle && processor(other.x) === processor(this.x) && processor(other.y) === processor(this.y) && processor(other.width) === processor(this.width) && processor(other.height) === processor(this.height);
            }
            /**
             * Translates this Rectangle by the passed vector. Size is maintained.
             * @param {Number} x The X translation vector.
             * @param {Number} y The Y translation vector.
             * @returns This Rectangle;
             */

          }, {
            key: "translate",
            value: function translate(x, y) {
              this._x += x || 0;
              this._y += y || 0;
              return this;
            }
            /**
             * Moves this Rectangle to the passed `x`, `y` position. Size is maintained.
             * @param {Number} x The new X position.
             * @param {Number} y The new Y position.
             * @returns This Rectangle;
             */

          }, {
            key: "moveTo",
            value: function moveTo(x, y) {
              if (x != null) {
                this._x = x;
              }

              if (y != null) {
                this._y = y;
              }

              return this;
            }
            /**
             * Returns the vector which would translate this Rectangle (or Point) to the same position as the other Rectangle (or point)
             * @param {Common.helper.util.Rectangle/Common.helper.util.Point} other The Rectangle or Point to calculate the delta to.
             */

          }, {
            key: "getDelta",
            value: function getDelta(other) {
              return [other.x - this.x, other.y - this.y];
            }
            /**
             * The center point of this rectangle.
             * @property {Common.helper.util.Point}
             */

          }, {
            key: "adjust",

            /**
             * Modifies the bounds of this Rectangle by the specified deltas.
             * @param {Number} x How much to *add* to the x position.
             * @param {Number} y  How much to *add* to the y position.
             * @param {Number} width  How much to add to the width.
             * @param {Number} height  How much to add to the height.
             * @returns This Rectangle
             */
            value: function adjust(x, y, width, height) {
              var me = this;
              me.x += x;
              me.y += y;
              me.width += width;
              me.height += height;
              return me;
            }
            /**
             * Modifies the bounds of this rectangle by moving them by the specified amount in all directions.
             * @param {Number} amount How much to inflate
             * @returns {Common.helper.util.Rectangle} This Rectangle
             */

          }, {
            key: "inflate",
            value: function inflate(amount) {
              return this.adjust(-amount, -amount, amount, amount);
            }
            /**
             * Attempts constrain this Rectangle into the passed Rectangle. If the `strict` parameter is `true`
             * then this method will return `false` if constraint could not be acheived.
             *
             * If this Rectangle has a `minHeight` or `minWidth` property, size will be adjusted while attempting to constrain.
             *
             * Right and bottom are adjusted first leaving the top and bottom sides to "win" in the case that this Rectangle overflows
             * the constrainTo Rectangle.
             * @param {Common.helper.util.Rectangle} constrainTo The Rectangle to constrain this Rectangle into if possible.
             * @param {Boolean} strict Pass `true` to return false, and leave this Rectangle unchanged if constraint
             * could not be achieved.
             * @returns This Rectangle. If `strict` is true, and constraining was not successful, `false`.
             */

          }, {
            key: "constrainTo",
            value: function constrainTo(_constrainTo, strict) {
              var me = this,
                  originalHeight = me.height,
                  originalY = me.y,
                  minWidth = me.minWidth || me.width,
                  minHeight = me.minHeight || me.height;

              if (me.height >= _constrainTo.height) {
                // If we're strict, fail if we could *never* fit into available height.
                if (strict && minHeight > _constrainTo.height) {
                  return false;
                } // If we are >= constrain height, we will have to be at top edge of constrainTo


                me._y = _constrainTo.y;
                me.height = _constrainTo.height;
              }

              if (me.width >= _constrainTo.width) {
                // If we're strict, fail if we could *never* fit into available width.
                if (strict && minWidth > _constrainTo.width) {
                  // Could not be constrained; undo any previous attempt with height
                  me.y = originalY;
                  me.height = originalHeight;
                  return false;
                } // If we are >= constrain width, we will have to be at left edge of constrainTo


                me._x = _constrainTo.x;
                me.width = _constrainTo.width;
              }

              var overflow = me.bottom - _constrainTo.bottom; // Overflowing the bottom side, translate upwards.

              if (overflow > 0) {
                me.translate(0, -overflow);
              }

              overflow = me.right - _constrainTo.right; // Overflowing the right side, translate leftwards.

              if (overflow > 0) {
                me.translate(-overflow);
              }

              overflow = _constrainTo.y - me.y; // Now, after possible translation upwards, we overflow the top, translate downwards.

              if (overflow > 0) {
                me.translate(0, overflow);
              }

              overflow = _constrainTo.x - me.x; // Now, after possible translation leftwards, we overflow the left, translate rightwards.

              if (overflow > 0) {
                me.translate(overflow);
              }

              return me;
            }
            /**
             * Returns a cloned version of this Rectangle aligned to a target Rectangle, or element or {@link Common.widget.Widget}.
             * @param {Object} spec Alignment specification.
             * @param {HTMLElement|Common.widget.Widget|Common.helper.util.Rectangle} spec.target The Widget or element or Rectangle to align to.
             * @param {Number[]} [spec.anchorSize] The `[width, height]` of the anchor pointer when in `top` position. The
             * width is the baseline length, and the height is the height of the arrow. If passed, the anchor position
             * will be calculated to be at the centre of the overlap of the two aligned edges and returned in the `anchor`
             * property of the resulting Rectangle:
             *
             *     {
             *         edge: 'top',         // or 'right' or 'bottom' or 'left'
             *         x/y: offset          // dimension to translate and value to translate by.
             *     }
             *
             * @param {Object} [spec.anchorPosition] an `{ x: n, y: n }` anchor translation to be used *if the requested alignment
             * succeeds without violating constraints*. If a fallback alignment is used, the anchor will be centered in the
             * overlap of the aligned edges as usual.
             * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
             * @param {String} spec.align The edge alignment specification string, specifying two points to bring together.
             * The form is `[trblc][n]-[trblc][n]. The `n` is a percentage offset
             * along that edge which defines the alignment point. This is not valid for alignment point `c`.
             * For example `t0-b0' would align this Rectangle's top left corner with the bottom left corner of the `target`.
             * @param {HTMLElement|Common.widget.Widget|Common.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
             * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
             * to the `minWidth` and `minHeight` properties of this rectangle), then it will try aligning at other edges
             * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
             * @param {Boolean} [spec.axisLock] Specify as a truthy value to fall back to aligning against the opposite
             * edge first if the requested alignment cannot be constrained into the `constrainTo` option. If specified
             * as `'flexible'`, then fallback will continue searching for solutions on the remaining two sides.
             * @param {Number|Number[]} [spec.offset] The 'x' and 'y' offset values to create an extra margin round the target
             * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
             * towards the target - for example producing the effect of the anchor pointer piercing the target.
             * @returns {Common.helper.util.Rectangle} A new Rectangle aligned as requested if possible, but if the requested position violates
             * the `constrainTo` Rectangle, the shortest translation from the requested position which obeys constraints will be used.
             */

          }, {
            key: "alignTo",
            value: function alignTo(spec) {
              // The target and constrainTo may be passed as HtmlElements or Widgets.
              // If so, extract the Rectangles without mutating the incoming spec.
              var result = this.clone(),
                  target = spec.target,
                  constrainTo = spec.constrainTo,
                  calculatedAnchorPosition,
                  zone,
                  resultZone,
                  constrainingToViewport;

              if (target && !(target instanceof Rectangle)) {
                target = Rectangle.from(target.element ? target.element : target);
              }

              if (constrainTo && !(constrainTo instanceof Rectangle)) {
                // Viewport is denoted by requesting window or document.
                // document.body may overflow the viewport, so this must not be evaluated as the viewport.
                constrainingToViewport = constrainTo === window || constrainTo === document;
                constrainTo = Rectangle.from(constrainTo.element ? constrainTo.element : constrainTo, null, spec.ignorePageScroll);
              }

              var me = this,
                  targetOffsets = createOffsets(spec.offset),
                  align = spec.align,
                  axisLock = spec.axisLock,
                  anchorSize = spec.anchorSize,
                  anchorPosition = spec.anchorPosition,
                  alignSpec = parseAlign(align),
                  position = spec.position || (target && target.$name === 'Point' ? target : null),
                  targetConstrainRect = constrainTo && constrainTo.clone(),
                  constraintZones = [],
                  zoneOrder = [{
                zone: zone = alignSpec.startZone,
                align: align
              }],
                  matchDimension = spec.matchSize && matchDimensions[alignSpec.startZone & 1],
                  originalSize = me[matchDimension]; // Match the size of the edge we are aligning against

              if (matchDimension && axisLock) {
                result[matchDimension] = target[matchDimension];
              } // Ensure we will fit before trying


              if (constrainTo) {
                result.constrainTo(constrainTo);
              } // If we are aligning edge-to-edge, then plan our fallback strategy when we are constrained.


              if (constrainTo && alignSpec.startZone != null) {
                // Create the list of zone numbers and alignments to try in the preferred order.
                //
                // In the case of axisLock, go through the zones by each axis.
                // So if they asked for t-b, which is zone 2,
                // the array will be [2, 0, 3, 1] (t-b, b-t, r-l, l-r)
                if (axisLock) {
                  // First axis flip has to maintain the offset along that axis.
                  // so align: l0-r0 has to flip to align: r0-l0. See submenu flipping when
                  // constrained to the edge. It flips sides but maintains vertical position.
                  zoneOrder.push({
                    zone: zone = (zone + 2) % 4,
                    align: flipAlign(alignSpec)
                  }); // Only try the other axis is axisLock is 'flexible'

                  if (axisLock === 'flexible') {
                    zoneOrder.push({
                      zone: zone = (alignSpec.startZone + 1) % 4,
                      align: defaultAlignments[zone]
                    });
                    zoneOrder.push({
                      zone: zone = (zone + 2) % 4,
                      align: defaultAlignments[zone]
                    });
                  }
                } // Go through the zones in order from the requested start.
                // So if they asked for t-b, which is zone 2,
                // the array will be [2, 3, 0, 1] (t-b, r-l, b-t, l-r)
                else {
                    for (var i = 1; i < 4; i++) {
                      zoneOrder.push({
                        zone: zone = (zone + 1) % 4,
                        align: defaultAlignments[zone]
                      });
                    }
                  }
              } // Allow them to pass anchorPosition: {x: 10} to indicate that after a fully successful,
              // unconstrained align, the anchor should be 10px from the start.


              if (anchorPosition) {
                var _calculatedAnchorPosi;

                var pos = alignSpec.startZone & 1 ? 'y' : 'x';
                calculatedAnchorPosition = (_calculatedAnchorPosi = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_calculatedAnchorPosi, pos, anchorPosition[pos]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_calculatedAnchorPosi, "edge", edgeNames[(alignSpec.startZone + 2) % 4]), _calculatedAnchorPosi);
              } // Keep the target within reach. If it's way outside, pull it back so that it's only just outside);


              if (targetConstrainRect && target) {
                targetConstrainRect.adjust(-target.width, -target.height, target.width, target.height);
                target.constrainTo(targetConstrainRect);
              } // As part of fallback process when fitting within constraints, result may shrink to our minima


              result.minWidth = me.minWidth;
              result.minHeight = me.minHeight; // We're being commanded to try to align at a position

              if (position) {
                result.moveTo(position.x, position.y);

                if (constrainTo) {
                  result.constrainTo(constrainTo);
                }
              } // We're aligning to a Target Rectangle within a ConstrainTo Rectangle, taking into account
              // a possible anchor pointer, or x/y offsets. Here's the situation:
              //
              //                             <-- ConstrainTo Rectangle -->
              //  +-----------------------------------+--------------------+-------------------------+
              //  |                                   |                    |                         |
              //  |                                   |                    |                         |
              //  |                                   |                    |                         |
              //  |-----------------------------------+--------------------+-------------------------+
              //  |                                   |          ▼         |                         |
              //  |                                   | +----------------+ |                         |
              //  |                                   | |                | |                         |
              //  |                                   | |                | |                         |
              //  |                                   |▶|     Target     |◀|                         |
              //  |                                   | |                | |                         |
              //  |                                   | |                | |                         |
              //  |                                   | +----------------+ |                         |
              //  |                                   |          ▲         |                         |
              //  +-----------------------------------+--------------------+-------------------------|
              //  |                                   |                    |                         |
              //  |                                   |                    |                         |
              //  |                                   |                    |                         |
              //  +-----------------------------------+--------------------+-------------------------+
              //
              // Which results in the four possible constraint zones above, which we index in standard CSS order.
              //
              // Top    = 0
              // Right  = 1
              // Bottom = 2
              // Left   = 3
              //
              // If the initially requested alignment is not within the constrainTo rectangle
              // then, calculate these four, and then loop through them, beginning at the requested one,
              // quitting when we find a position which does not violate constraints. This includes
              // shrinking the aligning Rectangle towards its minima to attempt a fit.
              //
              // The final fallback, if there is no position which does not violate constraints
              // is to position in whichever of the four rectangles has the largest area shrinking overflowing
              // dimensions down to minima if specified.
              //
              else {
                  // Offsets: If we are using an anchor to move away from the target, use anchor height in both dimensions.
                  // It's rotated so that "height" always has the same meaning. It's the height of the arrow.
                  var offsets = anchorSize ? [anchorSize[1] + targetOffsets[0], anchorSize[1] + targetOffsets[1]] : targetOffsets,
                      targetPoint = target.getAlignmentPoint(alignSpec.targetAlignmentPoint, offsets),
                      myPoint = result.getAlignmentPoint(alignSpec.myAlignmentPoint);
                  result.translate(targetPoint[0] - myPoint[0], targetPoint[1] - myPoint[1]); // If an overlapping position was requested, then we are *not* trying out those four zones.
                  // We just respect constraint, and that's it.

                  var overlap = result.intersect(target, true); // If we are aligned over our target, we just obey that within any constraint.
                  // No complex edge alignment attempts to fall back to.

                  if (overlap) {
                    if (constrainTo) {
                      result.constrainTo(constrainTo);
                    }

                    resultZone = alignSpec.startZone;
                  } // Aligned to outside of our target, and we need to be constrained
                  else if (constrainTo && !constrainTo.contains(result)) {
                      var requestedResult = result.clone(),
                          solutions = [],
                          _zone,
                          largestZone; // Any configured anchorPosition becomes invalid now that we're having to move the resulting zone
                      // to some unpredictable new place where it fits. It will have to be calculated based upon where
                      // we end up aligning.


                      calculatedAnchorPosition = null; // Calculate the four constraint zones illustrated above.
                      // Top

                      constraintZones[0] = _zone = constrainTo.clone();
                      _zone.bottom = target.y - offsets[1]; // Right

                      constraintZones[1] = _zone = constrainTo.clone();
                      _zone.x = target.right + offsets[0]; // Bottom

                      constraintZones[2] = _zone = constrainTo.clone();
                      _zone.y = target.bottom + offsets[1]; // Left

                      constraintZones[3] = _zone = constrainTo.clone();
                      _zone.right = target.x - offsets[0]; // Start from the preferred edge and see if we are able to constrain to within each rectangle

                      for (var _i = 0; _i < zoneOrder.length; _i++) {
                        // Revert to incoming dimension for fallback out of axisLock
                        if (matchDimension && _i == 2) {
                          result[matchDimension] = originalSize;
                        }

                        _zone = constraintZones[resultZone = zoneOrder[_i].zone]; // Perform unconstrained alignment at the calculated alignment for the zone

                        result = result.alignTo({
                          target: target,
                          offsets: offsets,
                          align: zoneOrder[_i].align
                        }); // If we are able to strictly constrain into this area, then it's one of the possible solutions.
                        // We choose the solution which result in the shortest translation from the initial position.

                        if (result.constrainTo(_zone, true)) {
                          solutions.push({
                            result: result,
                            zone: resultZone
                          }); // If this successful constraint is at the requested alignment, or at a fallback
                          // alignment which has used min size constraints, then that's the correct solution.
                          // If there's no size compromising, we have to pick the shortest translation.

                          if (!largestZone || result.width < me.width || result.height < me.height) {
                            result.align = zoneOrder[_i].align;
                            break;
                          }
                        } // Cache the largest zone we find in case we need the final fallback.


                        if (!largestZone || _zone.area > largestZone.area) {
                          var r = result.clone(); // And just move the result clone into the edge zone

                          switch (resultZone) {
                            // Top
                            case 0:
                              r.moveTo(null, _zone.bottom - r.height);
                              break;
                            // Right

                            case 1:
                              r.moveTo(_zone.left);
                              break;
                            // Bottom

                            case 2:
                              r.moveTo(null, _zone.top);
                              break;
                            // Left

                            case 3:
                              r.moveTo(_zone.right - r.width);
                              break;
                          }

                          largestZone = {
                            area: _zone.area,
                            result: r,
                            zone: resultZone
                          };
                        }
                      } // The loop found at least one solution


                      if (solutions.length) {
                        // Multiple fallbacks with no axisLock.
                        // Use the solution which resulted in the shortest translation distance from the requested alignment.
                        if (solutions.length > 1 && !axisLock) {
                          solutions.sort(function (s1, s2) {
                            var s1TranslationDistance = Math.sqrt(Math.pow(requestedResult.x - s1.result.x, 2) + Math.pow(requestedResult.y - s1.result.y, 2)),
                                s2TranslationDistance = Math.sqrt(Math.pow(requestedResult.x - s2.result.x, 2) + Math.pow(requestedResult.y - s2.result.y, 2));
                            return s1TranslationDistance - s2TranslationDistance;
                          });
                        } // Initial success, or axisLock. Use first successful solution.


                        result = solutions[0].result;
                        resultZone = solutions[0].zone;
                      } // No solutions found - use the largest rectangle.
                      else {
                          result = largestZone.result;
                          resultZone = largestZone.zone; // When we are constraining to the viewport, we must still must be constrained,
                          // even after we've given up making it align *and* constrain.

                          if (constrainingToViewport) {
                            result.constrainTo(constrainTo);
                          }
                        }
                    } else {
                      resultZone = alignSpec.startZone;
                    }

                  result.zone = resultZone; // If they included an anchor, calculate its position along its edge.
                  // TODO: Handle the edge overlap being less than anchor width.

                  if (anchorSize) {
                    // If we were passed an anchorPosition, and it has remnained valid (meaning the requested
                    // alignment succeeded with no constraint), then anchorPosition will be set. If not,
                    // we have to calculate it based upon the aligned edge.
                    if (!calculatedAnchorPosition) {
                      var _calculatedAnchorPosi2;

                      var isLeftOrRight = resultZone & 1,
                          start = isLeftOrRight ? 'y' : 'x',
                          end = isLeftOrRight ? 'bottom' : 'right',
                          startValue = Math.max(target[start], result[start]),
                          endValue = Math.min(target[end], result[end]),
                          anchorStart = startValue + (endValue - startValue) / 2 - anchorSize[0] / 2,
                          anchorEnd = anchorStart + anchorSize[0];

                      if (anchorEnd > result[end]) {
                        anchorStart -= anchorEnd - result[end];
                      }

                      if (anchorStart < result[start]) {
                        anchorStart += result[start] - anchorStart;
                      } // Return an anchor property which will have an x or y property and an edge name onto which the
                      // arrow should be aligned.


                      calculatedAnchorPosition = (_calculatedAnchorPosi2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_calculatedAnchorPosi2, start, anchorStart - result[start]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_calculatedAnchorPosi2, "edge", edgeNames[(resultZone + 2) % 4]), _calculatedAnchorPosi2);
                    }

                    result.anchor = calculatedAnchorPosition;
                  }
                }

              return result;
            }
            /**
             * Returns the `[x, y]` position of the specified anchor point of this Rectangle in <edge><offset> format.
             * for example passing "t50" will return the centre point of the top edge, passing "r0" will return the start
             * position of the right edge (the top right corner).
             *
             * Note that the offset defaults to 50, so "t" means the centre of the top edge.
             * @param {String} alignmentPoint The alignment point to calculate. Must match the RegExp `[trbl]\d*`
             * @param {Number[]} offsets The `[x, y]` offsets to add from the left/right, top/bottom edge.
             */

          }, {
            key: "getAlignmentPoint",
            value: function getAlignmentPoint(alignmentPoint) {
              var offsets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : zeroOffsets;
              var me = this,
                  parts = alignPointRe.exec(alignmentPoint),
                  edge = parts[1].toLowerCase(),
                  offset = Math.min(Math.max(parseInt(parts[2] || 50), 0), 100) / 100;

              switch (edge) {
                case 't':
                  return [me.x + me.width * offset, me.y - offsets[1]];

                case 'r':
                  return [me.right + offsets[0], me.y + me.height * offset];

                case 'b':
                  return [me.x + me.width * offset, me.bottom + offsets[1]];

                case 'l':
                  return [me.x - offsets[0], me.y + me.height * offset];

                case 'c':
                  var center = me.center;
                  return [center.x + offsets[0], center.y + offsets[1]];
              }
            }
            /**
             * Highlights this Rectangle using the highlighting effect of {@link Common.helper.DomHelper}
             * on a transient element which encapsulates the region's area.
             */

          }, {
            key: "highlight",
            value: function highlight() {
              var me = this,
                  highlightElement = _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].createElement({
                parent: document.body,
                style: "position:absolute;z-index:9999999;pointer-events:none;\n                            left:".concat(me.x, "px;top:").concat(me.y, "px;width:").concat(me.width, "px;height:").concat(me.height, "px")
              });

              return _DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].highlight(highlightElement).then(function () {
                return highlightElement.remove();
              });
            }
          }, {
            key: "center",
            get: function get() {
              return new Rectangle.Point(this.x + this.width / 2, this.y + this.height / 2);
            }
            /**
             * Get/sets the X coordinate of the Rectangle. Note that this does *not* translate the
             * Rectangle. The requested {@link #property-width} will change.
             * @property {Number}
             */

          }, {
            key: "x",
            set: function set(x) {
              var xDelta = x - this._x;
              this._x = x;
              this._width -= xDelta;
            },
            get: function get() {
              return this._x;
            }
            /**
             * Alias for x. To match DOMRect.
             * @property {Number}
             */

          }, {
            key: "left",
            set: function set(x) {
              this.x = x;
            },
            get: function get() {
              return this.x;
            }
            /**
             * Alias for y. To match DOMRect.
             * @property {Number}
             */

          }, {
            key: "top",
            set: function set(y) {
              this.y = y;
            },
            get: function get() {
              return this.y;
            }
            /**
             * Get/sets the Y coordinate of the Rectangle. Note that this does *not* translate the
             * Rectangle. The requested {@link #property-height} will change.
             * @property {Number}
             */

          }, {
            key: "y",
            set: function set(y) {
              var yDelta = y - this._y;
              this._y = y;
              this._height -= yDelta;
            },
            get: function get() {
              return this._y;
            }
            /**
             * Get/sets the width of the Rectangle. Note that the requested {@link #property-right} will change.
             * @property {Number}
             */

          }, {
            key: "width",
            set: function set(width) {
              this._width = width;
            },
            get: function get() {
              return this._width;
            }
            /**
             * Get/sets the height of the Rectangle. Note that the requested {@link #property-bottom} will change.
             * @property {Number}
             */

          }, {
            key: "height",
            set: function set(height) {
              this._height = height;
            },
            get: function get() {
              return this._height;
            }
            /**
             * Get/sets the right edge of the Rectangle. Note that the requested {@link #property-width} will change.
             *
             * The right edge value is exclusive of the calculated rectangle width. So x=0 and right=10
             * means a width of 10.
             * @property {Number}
             */

          }, {
            key: "right",
            set: function set(right) {
              this._width = right - this._x;
            },
            get: function get() {
              return this._x + this._width;
            }
            /**
             * Get/sets the bottom edge of the Rectangle. Note that the requested {@link #property-height} will change.
             *
             * The bottom edge value is exclusive of the calculated rectangle height. So y=0 and bottom=10
             * means a height of 10.
             * @property {Number}
             */

          }, {
            key: "bottom",
            set: function set(bottom) {
              this._height = bottom - this._y;
            },
            get: function get() {
              return this._y + this._height;
            }
          }, {
            key: "area",
            get: function get() {
              return this.width * this.height;
            }
          }, {
            key: "minWidth",
            set: function set(minWidth) {
              var me = this;

              if (isNaN(minWidth)) {
                me._minWidth = null;
              } else {
                me._minWidth = Number(minWidth);
                me.width = Math.max(me.width, me._minWidth);
              }
            },
            get: function get() {
              return this._minWidth;
            }
          }, {
            key: "minHeight",
            set: function set(minHeight) {
              var me = this;

              if (isNaN(minHeight)) {
                me._minHeight = null;
              } else {
                me._minHeight = Number(minHeight);
                me.height = Math.max(me.height, me._minHeight);
              }
            },
            get: function get() {
              return this._minHeight;
            }
          }]);

          return Rectangle;
        }();

        Rectangle._$name = 'Rectangle';
        /***/
      },

      /***/
      "../Grid/lib/Common/helper/util/Scroller.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/helper/util/Scroller.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonHelperUtilScrollerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Scroller;
        });
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Rectangle_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Point_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ./Point.js */
        "../Grid/lib/Common/helper/util/Point.js");
        /* harmony import */


        var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony import */


        var _util_Collection_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../../util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _IdHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _BrowserHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _EventHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler'; // eslint-disable-line

        /**
         * @module Common/helper/util/Scroller
         */

        var scrollLiterals = {
          true: 'auto',
          false: 'hidden',
          'hidden-scroll': 'auto'
        },
            scrollerCls = 'b-widget-scroller',
            defaultScrollOptions = {
          block: 'nearest'
        },
            immediatePromise = new Promise(function (resolve) {
          return resolve();
        }),
            xAxis = {
          x: 1
        };
        /**
         * Encapsulates scroll functionality for a Widget. All requests for scrolling and scrolling information
         * must go through a Widget's {@link Common.widget.Widget#config-scrollable} property.
         * @extends Common/Base
         */

        var Scroller =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Scroller, _Delayable);

          function Scroller() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Scroller);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Scroller).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Scroller, [{
            key: "addPartner",

            /**
             * Fired when scrolling happens on this Scroller's element. The event object is a native `scroll` event
             * with the described extra properties injected.
             * @event scroll
             * @param {Common.widget.Widget} widget The owning Widget which has been scrolled.
             * @param {Common.helper.util.Scroller} source This Scroller
             */

            /**
             * Fired when scrolling finished on this Scroller's element. The event object is the last native `scroll` event
             * fires by the element with the described extra properties injected.
             * @event scrollend
             * @param {Common.widget.Widget} widget The owning Widget which has been scrolled.
             * @param {Common.helper.util.Scroller} source This Scroller
             */

            /**
             * Partners this Scroller with the passed scroller in order to sync the scrolling position in the passed axes
             * @param {Common.helper.util.Scroller} otherScroller
             * @param {String|Object} [axes='x'] `'x'` or `'y'` or `{x: true/false, y: true/false}` axes to sync
             */
            value: function addPartner(otherScroller) {
              var axes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : xAxis;

              if (typeof axes === 'string') {
                axes = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()({}, axes, 1);
              }

              (this.partners || (this.partners = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_20__["default"]())).add({
                id: otherScroller.id,
                scroller: otherScroller,
                axes: axes
              }); // It's a mutual relationship - the other scroller partners with us.

              if (!otherScroller.partners || !otherScroller.partners.includes(this.id)) {
                otherScroller.addPartner(this, axes);
              }
            }
            /**
             * Breaks the link between this Scroller and the passed Scroller set up by the
             * {@link #function-addPartner} method.
             * @param {Common.helper.util.Scroller} otherScroller The Scroller to unlink from.
             */

          }, {
            key: "removePartner",
            value: function removePartner(otherScroller) {
              if (this.partners && this.partners.includes(otherScroller)) {
                this.partners.remove(otherScroller);
                otherScroller.removePartner(this);
              }
            }
            /**
             * Scrolls the passed element or {@link Common.helper.util.Rectangle} into view according to the passed options.
             * @param {HTMLElement|Common.helper.util.Rectangle} element The element or a Rectangle in document space to scroll into view.
             * @param {Object} [options] How to scroll.
             * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
             * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
             * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
             * or the number of milliseconds to animate over, or an animation config object.
             * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
             * @param {String} [options.animate.easing] The name of an easing function.
             * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
             * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
             * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
             * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
             * @returns {Promise} A promise which is resolved when the element has been scrolled into view.
             */

          }, {
            key: "scrollIntoView",
            value: function scrollIntoView(element) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;

              var isRectangle = element instanceof _Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"],
                  originalRect = isRectangle ? element : _Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(element),
                  _this$getDeltaTo = this.getDeltaTo(element, options),
                  xDelta = _this$getDeltaTo.xDelta,
                  yDelta = _this$getDeltaTo.yDelta,
                  result = this.scrollBy(xDelta, yDelta, options);

              if (options.highlight || options.focus) {
                result.then(function () {
                  if (isRectangle) {
                    element = originalRect.translate(-xDelta, -yDelta);
                  }

                  if (options.highlight) {
                    _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].highlight(element);
                  }

                  if (options.focus) {
                    element.focus();
                  }
                });
              }

              return result;
            }
            /**
             * Scrolls by the passed deltas according to the passed options.
             * @param {Number} [xDelta=0] How far to scroll in the X axis.
             * @param {Number} [yDelta=0] How far to scroll in the Y axis.
             * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
             * @param {Boolean} [options.silent] Set to `true` to suspend `scroll` events during scrolling.
             * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
             * or the number of milliseconds to animate over, or an animation config object.
             * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
             * @param {String} [options.animate.easing] The name of an easing function.
             * @returns {Promise} A promise which is resolved when the scrolling has fnished.
             */

          }, {
            key: "scrollBy",
            value: function scrollBy() {
              var xDelta = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var yDelta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
              var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultScrollOptions;
              var me = this,
                  animate = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(options) === 'object' ? options.animate : options,
                  absX = Math.abs(xDelta),
                  absY = Math.abs(yDelta);

              if (me.scrollAnimation) {
                me.scrollAnimation.cancel();
                me.scrollAnimation = null;
              } // Only set the flag if there is going to be scrolling done.
              // It is cleared by the scrollEnd handler, so there must be scrolling.


              if (xDelta || yDelta) {
                me.silent = options.silent;
              }

              var duration = animate && (typeof animate === 'number' ? animate : typeof animate.duration === 'number' ? animate.duration : 300); // Only go through animation if there is significant scrolling to do.

              if (duration && (absX > 10 || absY > 10)) {
                var x = me.x,
                    y = me.y;
                var lastX = x,
                    lastY = y; // For small distances, constrain duration

                if (Math.max(absX, absY) < 50) {
                  duration = Math.min(duration, 500);
                }

                me.scrollAnimation = _FunctionHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"].animate(duration, function (progress) {
                  var isEnd = progress === 1;

                  if (xDelta) {
                    // If the user, or another process has changed the position since last time, abort.
                    // Unless called with the force option to proceed regardless.
                    if (me.x !== lastX && !options.force) {
                      return me.scrollAnimation && me.scrollAnimation.cancel();
                    }

                    lastX = me.x = Math.max(x + (isEnd ? xDelta : Math.round(xDelta * progress)), 0);
                  }

                  if (yDelta) {
                    // If the user, or another process has changed the position since last time, abort.
                    // Unless called with the force option to proceed regardless.
                    if (me.y !== lastY && !options.force) {
                      return me.scrollAnimation && me.scrollAnimation.cancel();
                    }

                    lastY = me.y = Math.max(y + (isEnd ? yDelta : Math.round(yDelta * progress)), 0);
                  }
                }, null, animate.easing);
                me.scrollAnimation.then(function () {
                  me.scrollAnimation = null;
                });
                return me.scrollAnimation;
              } else {
                me.x += xDelta;
                me.y += yDelta;
                return immediatePromise;
              }
            }
            /**
             * Scrolls to the passed position according to the passed options.
             * @param {Number} [toX=0] Where to scroll to in the X axis.
             * @param {Number} [toY=0] Where to scroll to in the Y axis.
             * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
             * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
             * or the number of milliseconds to animate over, or an animation config object.
             * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
             * @param {String} [options.animate.easing] The name of an easing function.
             * @returns {Promise} A promise which is resolved when the scrolling has finished.
             */

          }, {
            key: "scrollTo",
            value: function scrollTo(toX, toY, options) {
              var x = this.x,
                  y = this.y,
                  xDelta = toX == null ? 0 : toX - x,
                  yDelta = toY == null ? 0 : toY - y;
              return this.scrollBy(xDelta, yDelta, options);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;

              if (me._element) {
                me._element.removeEventListener('scroll', me.scrollHandler);

                me.wheelListenerRemover && me.wheelListenerRemover();
              }

              if (me.scrollAnimation) {
                me.scrollAnimation.cancel();
              }

              me.partners && me.partners.forEach(function (partner) {
                return partner.scroller.removePartner(me);
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Scroller.prototype), "doDestroy", this).call(this);
            }
            /**
             * Respond to style changes to monitor scroll *when this Scroller is in `translate: true` mode.*
             * @param {Object[]} mutations The ElementMutation records.
             * @private
             */

          }, {
            key: "onElMutation",
            value: function onElMutation(mutations) {
              var me = this,
                  _DomHelper$getTransla = _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].getTranslateXY(me.element),
                  _DomHelper$getTransla2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_DomHelper$getTransla, 2),
                  x = _DomHelper$getTransla2[0],
                  y = _DomHelper$getTransla2[1]; // If the mutation was due to a change in the translateX/Y styles, this is
              // a scroll event, so inform observers and partners


              if (me._x !== -x || me.y !== -y) {
                var scrollEvent = new CustomEvent('scroll', {
                  bubbles: true
                });
                Object.defineProperty(scrollEvent, 'target', {
                  get: function get() {
                    return me.element;
                  }
                });
                me.onScroll(scrollEvent);
              }
            }
          }, {
            key: "onScroll",
            value: function onScroll(e) {
              var me = this;

              if (!me.widget || !me.widget.isDestroyed) {
                // Don't read the value until we have to. The x & y getters will check this flag
                me.positionDirty = true;
                e.widget = me.widget; // If we have the scroll silent flag, do not fire the event.

                if (!me.silent) {
                  me.trigger('scroll', e);
                } // Keep partners in sync


                if (me.partners) {
                  me.partners.forEach(function (_ref) {
                    var axes = _ref.axes,
                        scroller = _ref.scroller; // Don't feed back to the one who's just told us to scroll here.

                    if (scroller !== me.controllingPartner) {
                      scroller.sync(me, axes);
                    }
                  });
                } // If this scroll impulse was from a controlling partner, clear that now


                me.controllingPartner = null; // Will fire in 100ms, unless another scroll event comes round.
                // In which case execution will be pushed out by another 100ms.

                me.scrollEndHandler(e);
              }
            }
          }, {
            key: "onScrollEnd",
            value: function onScrollEnd(e) {
              if (this.silent) {
                this.silent = false;
              }

              this.trigger('scrollEnd', e);
            }
            /**
             * Returns the xDelta and yDelta values in an object from the current scroll position to the
             * passed element or Rectangle.
             * @param {HTMLElement|Common.helper.util.Rectangle} element The element or a Rectangle to calculate deltas for.
             * @param {Object} [options] How to scroll.
             * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
             * @param {Number} [options.edgeOffset] A margin around the element or rectangle to bring into view.
             * @param {Boolean} [options.x] Pass as `false` to disable scrolling in the `X` axis.
             * @param {Boolean} [options.y] Pass as `false` to disable scrolling in the `Y` axis.
             * @returns {Object} `{ xDelta, yDelta }`
             * @internal
             */

          }, {
            key: "getDeltaTo",
            value: function getDeltaTo(element, options) {
              if (!(element instanceof _Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"])) {
                element = _Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(element);
              }

              var me = this,
                  block = options.block || 'nearest',
                  scrollerRect = me.viewport,
                  edgeOffset = options.edgeOffset || 0,
                  // Only include the offset round the target is the viewport is big enough to accommodate it.
              xOffset = scrollerRect.width >= element.width + edgeOffset * 2 ? edgeOffset : 0,
                  yOffset = scrollerRect.height >= element.height + edgeOffset * 2 ? edgeOffset : 0,
                  elRect = element.clone().adjust(-xOffset, -yOffset, xOffset, yOffset).constrainTo(new _Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"](scrollerRect.x - me.x, scrollerRect.y - me.y, me.scrollWidth, me.scrollHeight)),
                  targetRect = elRect.clone();
              var xDelta = 0,
                  yDelta = 0;

              if (block === 'start') {
                targetRect.moveTo(scrollerRect.x, scrollerRect.y);
                xDelta = elRect.x - targetRect.x;
                yDelta = elRect.y - targetRect.y;
              } else if (block === 'end') {
                targetRect.translate(scrollerRect.right - targetRect.right, scrollerRect.bottom - targetRect.bottom);
                xDelta = elRect.x - targetRect.x;
                yDelta = elRect.y - targetRect.y;
              } else if (block === 'center') {
                var center = scrollerRect.center;
                targetRect.moveTo(center.x - targetRect.width / 2, center.y - targetRect.height / 2);
                xDelta = elRect.x - targetRect.x;
                yDelta = elRect.y - targetRect.y;
              } // Use "nearest"
              else {
                  // If it's *possible* to scroll to nearest x, calculate the delta
                  if (targetRect.width <= scrollerRect.width) {
                    if (targetRect.right > scrollerRect.right) {
                      xDelta = targetRect.right - scrollerRect.right;
                    } else if (targetRect.x < scrollerRect.x) {
                      xDelta = targetRect.x - scrollerRect.x;
                    }
                  } // If it's *possible* to scroll to nearest y, calculate the delta


                  if (targetRect.height <= scrollerRect.height) {
                    if (targetRect.bottom > scrollerRect.bottom) {
                      yDelta = targetRect.bottom - scrollerRect.bottom;
                    } else if (targetRect.y < scrollerRect.y) {
                      yDelta = targetRect.y - scrollerRect.y;
                    }
                  }
                } // Do not allow deltas which would produce -ve scrolling or scrolling past the maxX/Y


              return {
                // When calculating how much delta is necessary to scroll the targetRect to the center
                // constrain that to what is *possible*. If what you are trying to scroll into the
                // center is hard against the right edge of the scroll range, then it cannot scroll
                // to the center, and the result must reflect that even though scroll is self limiting.
                // This is because highlighting the requested "element", if that element is in fact
                // a Rectangle, uses a temporary element placed at the requested region which
                // MUST match where the actual scroll has moved the requested region.
                xDelta: options.x === false ? 0 : Math.max(Math.min(xDelta, me.maxX - me.x), -me.x),
                yDelta: options.y === false ? 0 : Math.max(Math.min(yDelta, me.maxY - me.y), -me.y)
              };
            }
            /**
             * A {@link Common.helper.util.Rectangle Rectangle} describing the bounds of the scrolling viewport.
             * @property {Common.helper.util.Rectangle}
             */

          }, {
            key: "sync",
            value: function sync(controllingPartner, axes) {
              var x = axes.x,
                  y = axes.y;
              this.controllingPartner = controllingPartner;

              if (x != null) {
                this.x = controllingPartner.x;
              }

              if (y != null) {
                this.y = controllingPartner.y;
              }
            }
            /**
             * The vertical scroll position of the widget.
             * @property {Number}
             */

          }, {
            key: "updateOverflowX",
            value: function updateOverflowX(overflowX) {
              var element = this.element,
                  translate = this.translate; // Scroll, but without showing scrollbars.
              // For example a grid header. Only works on platforms which
              // support suppression of scrollbars through CSS.

              if (overflowX === 'hidden-scroll' && !translate) {
                element.classList.add('b-hide-scroll'); // Adds a wheel listener if needed - there is scrollbar width
                // and we don't already have one.

                this.enableWheel();
              }

              if (!translate) {
                element.style.overflowX = scrollLiterals[overflowX] || overflowX;
              }

              this.positionDirty = true;
            }
            /**
             * The `overflow-y` setting for the widget. `true` means `'auto'`.
             * @property {Boolean/String}
             */

          }, {
            key: "updateOverflowY",
            value: function updateOverflowY(overflowY) {
              var element = this.element,
                  translate = this.translate; // Scroll, but without showing scrollbars.
              // For example a grid header. Only works on platforms which
              // support suppression of scrollbars through CSS.

              if (overflowY === 'hidden-scroll' && !translate) {
                element.classList.add('b-hide-scroll'); // Adds a wheel listener if needed - there is scrollbar width
                // and we don't already have one.

                this.enableWheel();
              }

              if (!translate) {
                element.style.overflowY = scrollLiterals[overflowY] || overflowY;
              }

              this.positionDirty = true;
            }
          }, {
            key: "enableWheel",
            value: function enableWheel() {
              if (!_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isChrome && !_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].isSafari && !this.wheelListenerRemover) {
                this.wheelListenerRemover = _EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
                  element: this.element,
                  wheel: 'onWheel',
                  thisObj: this
                });
              }
            }
          }, {
            key: "onWheel",
            value: function onWheel(e) {
              if (e.deltaX > e.deltaY && this.overflowX !== false) {
                this.x += e.deltaX;
              } else if (this.overflowY !== false) {
                this.y += e.deltaY;
              }
            }
            /**
             * The horizontal scroll range of the widget.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The element which is to scroll.
                 * @config {HTMLElement}
                 */
                element: null,

                /**
                 * How to handle overflowing in the `X` axis.
                 * May be:
                 * * `'auto'`
                 * * `'visible'`
                 * * `'hidden'`
                 * * `'scroll'`
                 * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar,
                 * for example a grid header. Only on platforms which support this feature.
                 * * `true` - meaning `'auto'`
                 * * `false` - meaning `'hidden'`
                 * @config {String/Boolean}
                 */
                overflowX: null,

                /**
                 * How to handle overflowing in the `Y` axis.
                 * May be:
                 * * `'auto'`
                 * * `'visible'`
                 * * `'hidden'`
                 * * `'scroll'`
                 * * `'hidden-scroll'` Meaning scrollable from the UI but with no scrollbar.
                 * Only on platforms which support this feature.
                 * * `true` - meaning `'auto'`
                 * * `false` - meaning `'hidden'`
                 * @config {String/Boolean}
                 */
                overflowY: null,

                /**
                 * If configured as `true`, the {@link #config-element} is not scrolled
                 * but is translated using CSS transform when controlled by this class's API.
                 * Scroll events are fired when the element is translated.
                 * @default
                 * @config {Boolean}
                 */
                translate: null
              };
            }
          }, {
            key: "viewport",
            get: function get() {
              return _Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(this.element);
            }
          }, {
            key: "element",
            get: function get() {
              return this._element;
            },
            set: function set(element) {
              var me = this,
                  scrollHandler = me.scrollHandler || (me.scrollHandler = me.onScroll.bind(me));

              if (!me.scrollEndHandler) {
                me.scrollEndHandler = me.buffer(me.onScrollEnd, 100);
              }

              if (me._element) {
                if (me.translate) {
                  me.mutationObserver && me.mutationObserver.disconnect(me._element);
                } else {
                  me._element.removeEventListener('scroll', scrollHandler);

                  me._element.classList.remove(scrollerCls);
                }
              }

              me._element = element;

              if (me.translate) {
                if (!me.mutationObserver) {
                  me.mutationObserver = new MutationObserver(function (mutations) {
                    return me.onElMutation(mutations);
                  });
                }

                me.mutationObserver.observe(element, {
                  attributes: true
                });
                me._x = me._y = 0;

                if (document.contains(element)) {
                  var _DomHelper$getTransla3 = _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].getTranslateXY(element),
                      _DomHelper$getTransla4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_DomHelper$getTransla3, 2),
                      x = _DomHelper$getTransla4[0],
                      y = _DomHelper$getTransla4[1];

                  me._x = -x;
                  me._y = -y;
                }
              } else {
                element.addEventListener('scroll', scrollHandler);
                element.classList.add(scrollerCls);
              } // Ensure the overflow configs, which are unable to process themselves
              // in the absence of the element get applied to the newly arrived element.


              me.updateOverflowX(me.overflowX);
              me.updateOverflowY(me.overflowY);
            }
            /**
             * The horizontal scroll position of the widget.
             * @property {Number}
             */

          }, {
            key: "x",
            get: function get() {
              var me = this,
                  element = me.element;

              if (element && me.positionDirty) {
                if (me.translate) {
                  var _DomHelper$getTransla5 = _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].getTranslateXY(element),
                      _DomHelper$getTransla6 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_DomHelper$getTransla5, 2),
                      x = _DomHelper$getTransla6[0],
                      y = _DomHelper$getTransla6[1];

                  me._x = -x;
                  me._y = -y;
                } else {
                  me._x = element.scrollLeft;
                  me._y = element.scrollTop;
                }

                me.positionDirty = false;
              }

              return me._x;
            },
            set: function set(x) {
              var element = this.element;
              this._x = x;

              if (element) {
                if (this.translate) {
                  _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].setTranslateX(element, -x);
                } else {
                  element.scrollLeft = x;
                } // The scroll position will need to be read before we can return it.
                // Do not read it back now, that would cause a forced synchronous layout.


                this.positionDirty = true;
              }
            }
          }, {
            key: "y",
            get: function get() {
              var me = this,
                  element = me.element;

              if (element && me.positionDirty) {
                if (me.translate) {
                  var _DomHelper$getTransla7 = _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].getTranslateXY(element),
                      _DomHelper$getTransla8 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_DomHelper$getTransla7, 2),
                      x = _DomHelper$getTransla8[0],
                      y = _DomHelper$getTransla8[1];

                  me._x = -x;
                  me._y = -y;
                } else {
                  me._x = element.scrollLeft;
                  me._y = element.scrollTop;
                }

                me.positionDirty = false;
              }

              return me._y;
            },
            set: function set(y) {
              var element = this.element;
              this._y = y;

              if (element) {
                if (this.translate) {
                  _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].setTranslateY(element, -y);
                } else {
                  element.scrollTop = y;
                } // The scroll position will need to be read before we can return it.
                // Do not read it back now, that would cause a forced synchronous layout.


                this.positionDirty = true;
              }
            }
            /**
             * The maximum `X` scrollable position of the widget.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "maxX",
            get: function get() {
              return this.scrollWidth - this.clientWidth;
            }
            /**
             * The maximum `Y` scrollable position of the widget.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "maxY",
            get: function get() {
              return this.scrollHeight - this.clientHeight;
            }
            /**
             * The `overflow-x` setting for the widget. `true` means `'auto'`.
             * @property {Boolean/String}
             */

          }, {
            key: "overflowX",
            get: function get() {
              return this._overflowX;
            },
            set: function set(overflowX) {
              this._overflowX = overflowX;

              if (this.element) {
                this.updateOverflowX(overflowX);
              }
            }
          }, {
            key: "overflowY",
            get: function get() {
              return this._overflowY;
            },
            set: function set(overflowY) {
              this._overflowY = overflowY;

              if (this.element) {
                this.updateOverflowY(overflowY);
              }
            }
          }, {
            key: "scrollWidth",
            get: function get() {
              return this.element ? this.element.scrollWidth : 0;
            },
            set: function set(scrollWidth) {
              var me = this;
              var stretcher = me.widthStretcher; // "Unsetting" scrollWidth removes the stretcher

              if (stretcher && scrollWidth == null) {
                stretcher.remove();
                me.widthStretcher = null;
              } else if (scrollWidth) {
                if (!stretcher) {
                  stretcher = me.widthStretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].createElement({
                    className: 'b-scroller-stretcher'
                  });
                }

                stretcher.style.transform = "translateX(".concat(scrollWidth - 1, "px)");

                if (me.element && me.element.lastChild !== stretcher) {
                  me.element.appendChild(stretcher);
                }
              }
            }
          }, {
            key: "scrollHeight",
            get: function get() {
              return this.element ? this.element.scrollHeight : 0;
            }
            /**
             * The vertical scroll range of the widget. May be set to larger than the actual data
             * height to enable virtual scrolling. This is how the grid extends its scroll range
             * while only rendering a small subset of the dataset.
             * @property {Number}
             */
            ,
            set: function set(scrollHeight) {
              var me = this,
                  stretcher = me.stretcher || (me.stretcher = _DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].createElement({
                className: 'b-scroller-stretcher'
              }));

              stretcher.style.transform = "translateY(".concat(scrollHeight - 1, "px)");

              if (me.element && me.element.lastChild !== stretcher) {
                me.element.appendChild(stretcher);
              }
            }
            /**
             * The client width of the widget.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "clientWidth",
            get: function get() {
              return this.element ? this.element.clientWidth : 0;
            }
            /**
             * The client height of the widget.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "clientHeight",
            get: function get() {
              return this.element ? this.element.clientHeight : 0;
            }
            /**
             * The unique ID of this Scroller
             * @property {String}
             * @readonly
             */

          }, {
            key: "id",
            get: function get() {
              if (!this._id) {
                if (this.widget) {
                  this._id = "".concat(this.widget.id, "-scroller");
                } else {
                  this._id = _IdHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].generateId('scroller-');
                }
              }

              return this._id;
            }
          }]);

          return Scroller;
        }(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_16__["default"])(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_17__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])));

        Scroller._$name = 'Scroller';
        /***/
      },

      /***/
      "../Grid/lib/Common/localization/En.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/localization/En.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonLocalizationEnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../../Common/localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");

        var productName = 'scheduler';
        var locale = {
          localeName: 'En',
          localeDesc: 'English',
          //region Columns
          TemplateColumn: {
            noTemplate: 'TemplateColumn needs a template',
            noFunction: 'TemplateColumn.template must be a function'
          },
          ColumnStore: {
            columnTypeNotFound: function columnTypeNotFound(data) {
              return "Column type '".concat(data.type, "' not registered");
            }
          },
          //endregion
          //region Mixins
          InstancePlugin: {
            fnMissing: function fnMissing(data) {
              return "Trying to chain fn ".concat(data.plugIntoName, "#").concat(data.fnName, ", but plugin fn ").concat(data.pluginName, "#").concat(data.fnName, " does not exist");
            },
            overrideFnMissing: function overrideFnMissing(data) {
              return "Trying to override fn ".concat(data.plugIntoName, "#").concat(data.fnName, ", but plugin fn ").concat(data.pluginName, "#").concat(data.fnName, " does not exist");
            }
          },
          //endregion
          //region Features
          ColumnPicker: {
            columnsMenu: 'Columns',
            hideColumn: 'Hide column',
            hideColumnShort: 'Hide'
          },
          Filter: {
            applyFilter: 'Apply filter',
            filter: 'Filter',
            editFilter: 'Edit filter',
            on: 'On',
            before: 'Before',
            after: 'After',
            equals: 'Equals',
            lessThan: 'Less than',
            moreThan: 'More than',
            removeFilter: 'Remove filter'
          },
          FilterBar: {
            enableFilterBar: 'Show filter bar',
            disableFilterBar: 'Hide filter bar'
          },
          Group: {
            groupAscending: 'Group ascending',
            groupDescending: 'Group descending',
            groupAscendingShort: 'Ascending',
            groupDescendingShort: 'Descending',
            stopGrouping: 'Stop grouping',
            stopGroupingShort: 'Stop'
          },
          Search: {
            searchForValue: 'Search for value'
          },
          Sort: {
            'sortAscending': 'Sort ascending',
            'sortDescending': 'Sort descending',
            'multiSort': 'Multi sort',
            'removeSorter': 'Remove sorter',
            'addSortAscending': 'Add ascending sorter',
            'addSortDescending': 'Add descending sorter',
            'toggleSortAscending': 'Change to ascending',
            'toggleSortDescending': 'Change to descending',
            'sortAscendingShort': 'Ascending',
            'sortDescendingShort': 'Descending',
            'removeSorterShort': 'Remove',
            'addSortAscendingShort': '+ Ascending',
            'addSortDescendingShort': '+ Descending'
          },
          Tree: {
            noTreeColumn: 'To use the tree feature one column must be configured with tree: true'
          },
          //endregion
          //region Grid
          Grid: {
            featureNotFound: function featureNotFound(data) {
              return "Feature '".concat(data, "' not available, make sure you have imported it");
            },
            invalidFeatureNameFormat: function invalidFeatureNameFormat(data) {
              return "Invalid feature name '".concat(data, "', must start with a lowercase letter");
            },
            removeRow: 'Delete row',
            removeRows: 'Delete rows',
            loadMask: 'Loading...',
            loadFailedMessage: 'Data loading failed.',
            moveColumnLeft: 'Move to left section',
            moveColumnRight: 'Move to right section',
            noRows: 'Loading Records...'
          },
          //endregion
          //region Widgets
          Field: {
            invalidValue: 'Invalid field value',
            minimumValueViolation: 'Minimum value violation',
            maximumValueViolation: 'Maximum value violation',
            fieldRequired: 'This field is required',
            validateFilter: 'Value must be selected from the list'
          },
          DateField: {
            invalidDate: 'Invalid date input'
          },
          TimeField: {
            invalidTime: 'Invalid time input'
          },
          //endregion
          //region Others
          DateHelper: {
            locale: 'en-US',
            shortWeek: 'W',
            shortQuarter: 'q',
            week: 'Week',
            weekStartDay: 0,
            unitNames: [{
              single: 'millisecond',
              plural: 'ms',
              abbrev: 'ms'
            }, {
              single: 'second',
              plural: 'seconds',
              abbrev: 's'
            }, {
              single: 'minute',
              plural: 'minutes',
              abbrev: 'min'
            }, {
              single: 'hour',
              plural: 'hours',
              abbrev: 'h'
            }, {
              single: 'day',
              plural: 'days',
              abbrev: 'd'
            }, {
              single: 'week',
              plural: 'weeks',
              abbrev: 'w'
            }, {
              single: 'month',
              plural: 'months',
              abbrev: 'mon'
            }, {
              single: 'quarter',
              plural: 'quarters',
              abbrev: 'q'
            }, {
              single: 'year',
              plural: 'years',
              abbrev: 'yr'
            }],
            // Used to build a RegExp for parsing time units.
            // The full names from above are added into the generated Regexp.
            // So you may type "2 w" or "2 wk" or "2 week" or "2 weeks" into a DurationField.
            // When generating its display value though, it uses the full localized names above.
            unitAbbreviations: [['mil'], ['s', 'sec'], ['m', 'min'], ['h', 'hr'], ['d'], ['w', 'wk'], ['mo', 'mon', 'mnt'], ['q', 'quar', 'qrt'], ['y', 'yr']],
            parsers: {
              'L': 'MM/DD/YYYY',
              'LT': 'HH:mm A'
            },
            ordinalSuffix: function ordinalSuffix(number) {
              return number + ({
                '1': 'st',
                '2': 'nd',
                '3': 'rd'
              }[number[number.length - 1]] || 'th');
            }
          },
          BooleanCombo: {
            'Yes': 'Yes',
            'No': 'No' //endregion

          }
        };
        /* harmony default export */

        __webpack_exports__["default"] = locale;

        _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale('En', {
          desc: 'English',
          locale: locale
        });
        /***/

      },

      /***/
      "../Grid/lib/Common/localization/LocaleManager.js":
      /*!********************************************************!*\
        !*** ../Grid/lib/Common/localization/LocaleManager.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonLocalizationLocaleManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../helper/AjaxHelper.js */
        "../Grid/lib/Common/helper/AjaxHelper.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");

        var productName = 'scheduler';
        /**
         * Singleton that handles switching locale. Locales can be included on page with `<script type="module">` tags or
         * loaded using ajax. When using script tags the first locale loaded is used per default, if another should be used as
         * default specify it on the script tag for the grid (see example below).
         *
         * ```
         * // Using Ecma 6 modules
         * &lt;script type="module" src="./Common/localization/SvSE.js"&gt;
         *
         * // Specify default when using scripts
         * &lt;script src="build/locales/grid-locale-SvSE.js"&gt;
         * &lt;script data-default-locale="En" src="build/grid-all.js"&gt;
         *
         * import LocaleManager from 'Common/localization/LocaleManager.js';
         * LocaleManager.applyLocale('SvSE');
         * ```
         *
         * @demo localization
         */

        var LocaleManager =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(LocaleManager, _Events);

          function LocaleManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, LocaleManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(LocaleManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(LocaleManager, [{
            key: "construct",
            value: function construct() {
              var _get2;

              var me = this;

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(LocaleManager.prototype), "construct", this)).call.apply(_get2, [this].concat(args)); // currentScript not working in IE11
              // if (document.currentScript && document.currentScript.dataset.defaultLocale) {
              //     me.defaultLocaleName = document.currentScript.dataset.defaultLocale;
              // }


              var scriptTag = document.querySelector('script[data-default-locale]');

              if (scriptTag) {
                me.defaultLocaleName = scriptTag.dataset.defaultLocale;
              }

              if (window.bryntum && window.bryntum.locales) {
                Object.keys(window.bryntum.locales).forEach(function (localeName) {
                  // keeping this check in case some client tries to use an old locale
                  if (!localeName.startsWith('moment')) {
                    var locale = window.bryntum.locales[localeName];

                    if (locale.extends) {
                      me.extendLocale(locale.extends, locale);
                    } else {
                      me.registerLocale(locale.localeName, {
                        desc: locale.localeDesc,
                        locale: locale
                      });
                    }
                  }
                });

                if (!me.locale) {
                  // English locale is built in, no need to apply it here since it will be applied anyway
                  if (me.defaultLocaleName !== 'En') {
                    // No locale applied, use default or first found
                    me.applyLocale(me.defaultLocaleName || Object.keys(me.locales)[0]);
                  }
                }
              }
            }
          }, {
            key: "registerLocale",

            /**
             * Register a locale to make it available for applying
             * @param name
             * @param config
             */
            value: function registerLocale(name, config) {
              var me = this,
                  isDefault = me.defaultLocaleName === name,
                  isCurrent = me.locale && me.locale.localeName === name,
                  isFirst = Object.keys(me.locales).length === 0;
              me.locales[name] = config; // if no default locale specified, use the first one. otherwise apply the default when it is registered
              // also reapply if current locale is registered again (first grid, then scheduler etc).

              if (isDefault || !me.defaultLocaleName && (isFirst || isCurrent)) {
                me.internalApplyLocale(config);
              }
            }
            /**
             * Extend an already loaded locale to add additional translations
             * @param name
             * @param config
             */

          }, {
            key: "extendLocale",
            value: function extendLocale(name, config) {
              var locale = this.locales[name];
              if (!locale) return false;
              Object.keys(config).forEach(function (cls) {
                if (!locale.locale[cls]) {
                  locale.locale[cls] = config[cls];
                } else {
                  Object.assign(locale.locale[cls], config[cls]);
                }
              });
              delete locale.locale.extends;
              return true;
            }
          }, {
            key: "internalApplyLocale",
            value: function internalApplyLocale(localeConfig) {
              var me = this;
              me._locale = localeConfig.locale;
              me.trigger('locale', localeConfig);
            }
            /**
             * Apply a locale. Locale must be defined in LocaleManager#locales. If it is not loaded it will be loaded using ajax
             * and then applied.
             * @param {String} name Name of locale to apply (for example En or SvsE)
             * @returns {boolean|Promise}
             */

          }, {
            key: "applyLocale",
            value: function applyLocale(name) {
              var forceApply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var ignoreError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  localeConfig = me.locales[name];

              if (localeConfig && localeConfig.locale && me._locale === localeConfig.locale && !forceApply) {
                // no need to apply same locale again
                return true;
              } // ignoreError is used in examples where one example might have defined a locale not available in another


              if (!localeConfig) {
                if (ignoreError) return true;
                throw new Error("Locale ".concat(name, " not registered"));
              }

              function internalApply() {
                me.internalApplyLocale(localeConfig);
              }

              if (!localeConfig.locale) {
                return new Promise(function (resolve, reject) {
                  me.loadLocale(localeConfig.path).then(function (response) {
                    //const text      = response.substring(response.indexOf('{'), response.lastIndexOf('};') + 1),
                    //      getLocale = new Function('return ' + text);
                    response.text().then(function (text) {
                      // eslint-disable-next-line no-new-func
                      var parseLocale = new Function(text);
                      parseLocale();
                      localeConfig.locale = window.bryntum.locales[name];
                      internalApply();
                      resolve(localeConfig);
                    });
                  }).catch(function (response) {
                    return reject(response);
                  });
                });
              }

              internalApply();
              return true;
            }
            /**
             * Loads a locale using ajax
             * @private
             * @param {String} path Path to locale file
             * @returns {Promise}
             */

          }, {
            key: "loadLocale",
            value: function loadLocale(path) {
              return _helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].get(path);
            }
          }, {
            key: "locales",
            set: function set(localeConfigs) {
              this._locales = localeConfigs;
            },
            get: function get() {
              return this._locales;
            }
            /**
             * Get/set currently used locale. Set a name of a locale to have it applied, or give a locale configuration to
             * have it registered and then applied
             * @property {String|Object}
             */

          }, {
            key: "locale",
            set: function set(locale) {
              if (typeof locale === 'string') {
                this.applyLocale(locale);
              } else {
                if (!locale.locale) {
                  locale = {
                    locale: locale,
                    localeName: locale.localeName || 'custom'
                  };
                }

                this.registerLocale(locale.localeName, locale);
                this.applyLocale(locale.localeName);
              }
            },
            get: function get() {
              return this._locale;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                locales: {}
              };
            }
          }]);

          return LocaleManager;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_13__["default"]));

        var LocaleManagerSingelton = new LocaleManager();
        /* harmony default export */

        __webpack_exports__["default"] = LocaleManagerSingelton;
        /***/
      },

      /***/
      "../Grid/lib/Common/localization/Localizable.js":
      /*!******************************************************!*\
        !*** ../Grid/lib/Common/localization/Localizable.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonLocalizationLocalizableJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _LocaleManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");

        var productName = 'scheduler';
        /**
         * @module Common/localization/Localizable
         */

        /**
         * Mixin that simplifies localization of strings in a class.
         *
         * ```
         * // Get localized string
         * grid.L('sort')
         * ```
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Localizable, _ref);

              function Localizable() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Localizable);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Localizable).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Localizable, [{
                key: "construct",
                value: function construct() {
                  var _get2;

                  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  var me = this; // Base class applies configs.

                  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                  }

                  (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Localizable.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args));

                  _LocaleManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].on('locale', me.updateLocalization, me);

                  me.updateLocalization();
                }
              }, {
                key: "updateLocalization",
                value: function updateLocalization() {
                  var me = this;
                  me.localizableProperties && me.localizableProperties.forEach(function (name) {
                    // No need to translate properties which are not defined
                    if (me[name] === undefined) return;
                    me.originalLocales = me.originalLocales || {}; // Need to save original values since they will be overridden by localizable equivalents

                    me.originalLocales[name] = me.originalLocales[name] || me[name]; // Doing localization from the original values

                    if (me.originalLocales[name]) {
                      me[name] = Localizable.L.call(me, me.originalLocales[name]);
                    }
                  });
                }
                /**
                 * Get localized string, returns value of `text` if no localized string found
                 * @param {String} text String key
                 * @param {Object} [templateData] Data to supply to template if localized string is one
                 * @returns {String}
                 */

              }, {
                key: "L",

                /**
                 * Convenience function that can be called directly on the class that mixes Localizable in
                 * @param {String} text String key
                 * @param {Object} [templateData] Data to supply to template if localized string is one
                 * @returns {String}
                 * @category Misc
                 * @example
                 * button.text = grid.L('group');
                 */
                value: function L(text, templateData) {
                  return Localizable.L(text, templateData, this.constructor);
                }
                /**
                 * Get the global LocaleManager
                 * @returns {Common.localization.LocaleManager}
                 * @category Misc
                 */

              }, {
                key: "localeClass",
                get: function get() {
                  // Trying to extract localeClass from a parent widget. null by default
                  return this._localeClass || this.parent && this.parent.localeClass || null;
                },
                set: function set(key) {
                  this._localeClass = key;
                }
              }, {
                key: "localeManager",
                get: function get() {
                  return _LocaleManager_js__WEBPACK_IMPORTED_MODULE_9__["default"];
                }
              }], [{
                key: "parseText",
                // In case it's wrapped in 'L{text}'
                value: function parseText(text) {
                  var match = this.inTextLocaleRegExp.exec(text);
                  return match ? match[1] : text;
                }
              }, {
                key: "L",
                value: function L(text, templateData) {
                  var current = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.localeClass || this;

                  if (_LocaleManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].locale) {
                    // traverse prototypes to find localization
                    while (current) {
                      var name = current.$name || current.name,
                          localeClass = _LocaleManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].locale[name],
                          localeText = localeClass && localeClass[Localizable.parseText(text)];

                      if (localeText) {
                        return typeof localeText === 'function' && templateData != null ? localeText(templateData) : localeText;
                      }

                      current = Object.getPrototypeOf(current);
                    }
                  }

                  return text;
                }
              }, {
                key: "defaultConfig",
                get: function get() {
                  return {
                    localeClass: null,
                    localizableProperties: []
                  };
                }
              }, {
                key: "inTextLocaleRegExp",
                get: function get() {
                  return /L\{([^}]+)\}/g;
                }
              }]);

              return Localizable;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_8__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/mixin/Delayable.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/mixin/Delayable.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonMixinDelayableJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "../Grid/node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/mixin/Delayable
         */

        /**
         * Tracks setTimeout, setInterval and requestAnimationFrame calls and clears them on destroy.
         *
         * @example
         * someClass.setTimeout(() => console.log('hi'), 200);
         * someClass.setInterval(() => console.log('annoy'), 100);
         * // can also use named timeouts for easier tracking
         * someClass.setTimeout(() => console.log('named'), 300, 'named');
         * someClass.clearTimeout('named');
         *
         * @private
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(Delayable, _ref);

              function Delayable() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Delayable);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Delayable).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Delayable, [{
                key: "doDestroy",
                value: function doDestroy() {
                  var me = this;

                  if (me.timeoutIds) {
                    Object.keys(me.timeoutIds).forEach(function (id) {
                      if (typeof me.timeoutIds[id] === 'function') {
                        me.timeoutIds[id]();
                      }

                      clearTimeout(id);
                    });
                    me.timeoutIds = null;
                  }

                  if (me.timeoutMap) {
                    Object.values(me.timeoutMap).forEach(function (id) {
                      return clearTimeout(id);
                    });
                    me.timeoutMap = null;
                  }

                  if (me.intervalIds) {
                    Object.keys(me.intervalIds).forEach(function (id) {
                      return clearInterval(id);
                    });
                    me.intervalIds = null;
                  }

                  if (me.animationFrameIds) {
                    Object.keys(me.animationFrameIds).forEach(function (id) {
                      return cancelAnimationFrame(id);
                    });
                    me.animationFrameIds = null;
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Delayable.prototype), "doDestroy", this).call(this);
                }
                /**
                 * Check if a named timeout is active
                 * @param name
                 */

              }, {
                key: "hasTimeout",
                value: function hasTimeout(name) {
                  return !!(this.timeoutMap && this.timeoutMap[name]);
                }
                /**
                 * Same as native setTimeout, but will be cleared automatically on destroy. If a propertyName is supplied it will
                 * be used to store the timeout id.
                 * @param {Object} timeoutSpec An object containing the details about that function, and the time delay.
                 * @param {Function|String} timeoutSpec.fn The function to call, or name of function in this object to call. Used as the `name` parameter if a string.
                 * @param {Number} timeoutSpec.delay The milliseconds to delay the call by.
                 * @param {String} [timeoutSpec.name] The name under which to register the timer. Defaults to `fn.name`.
                 * @param {Boolean} [timeoutSpec.runOnDestroy] Pass `true` if this function should be executed if the Delayable instance is destroyed while function is scheduled.
                 * @param {Boolean} [timeoutSpec.cancelOutstanding] Pass `true` to cancel any outstanding invocation of the passed function.
                 * @returns {Number}
                 */

              }, {
                key: "setTimeout",
                value: function (_setTimeout) {
                  function setTimeout(_x) {
                    return _setTimeout.apply(this, arguments);
                  }

                  setTimeout.toString = function () {
                    return _setTimeout.toString();
                  };

                  return setTimeout;
                }(function (_ref2) {
                  var fn = _ref2.fn,
                      delay = _ref2.delay,
                      name = _ref2.name,
                      runOnDestroy = _ref2.runOnDestroy,
                      cancelOutstanding = _ref2.cancelOutstanding;

                  if (arguments.length > 1 || typeof arguments[0] === 'function') {
                    var _arguments = Array.prototype.slice.call(arguments);

                    fn = _arguments[0];
                    delay = _arguments[1];
                    name = _arguments[2];
                    runOnDestroy = _arguments[3];
                  }

                  if (typeof fn === 'string') {
                    name = fn;
                  } else if (!name) {
                    name = fn.name;
                  }

                  if (cancelOutstanding) {
                    this.clearTimeout(name);
                  }

                  var me = this,
                      timeoutIds = me.timeoutIds || (me.timeoutIds = {}),
                      timeoutMap = me.timeoutMap || (me.timeoutMap = {}),
                      timeoutId = setTimeout(function () {
                    if (typeof fn === 'string') {
                      fn = me[name];
                    }

                    fn.call(me);
                    if (timeoutIds && timeoutId in timeoutIds) delete timeoutIds[timeoutId];
                    if (timeoutMap && name in timeoutMap) delete timeoutMap[name];
                  }, delay);
                  timeoutIds[timeoutId] = runOnDestroy ? fn : true;

                  if (name) {
                    timeoutMap[name] = timeoutId;
                  }

                  return timeoutId;
                })
                /**
                 * clearTimeout wrapper, either call with timeout id as normal clearTimeout or with timeout name (if you specified
                 * a name to setTimeout())
                 * property to null.
                 * @param {Number|String} idOrName timeout id or name
                 */

              }, {
                key: "clearTimeout",
                value: function (_clearTimeout) {
                  function clearTimeout(_x2) {
                    return _clearTimeout.apply(this, arguments);
                  }

                  clearTimeout.toString = function () {
                    return _clearTimeout.toString();
                  };

                  return clearTimeout;
                }(function (idOrName) {
                  var id = idOrName;

                  if (typeof id === 'string') {
                    if (this.timeoutMap) {
                      id = this.timeoutMap[idOrName];
                      delete this.timeoutMap[idOrName];
                    } else {
                      return;
                    }
                  }

                  clearTimeout(id);
                  this.timeoutIds && delete this.timeoutIds[id];
                })
                /**
                 * clearInterval wrapper
                 * @param {Number} id
                 */

              }, {
                key: "clearInterval",
                value: function (_clearInterval) {
                  function clearInterval(_x3) {
                    return _clearInterval.apply(this, arguments);
                  }

                  clearInterval.toString = function () {
                    return _clearInterval.toString();
                  };

                  return clearInterval;
                }(function (id) {
                  clearInterval(id);
                  this.intervalIds && delete this.intervalIds[id];
                })
                /**
                 * Same as native setInterval, but will be cleared automatically on destroy
                 * @param fn
                 * @param delay
                 * @returns {Number}
                 */

              }, {
                key: "setInterval",
                value: function (_setInterval) {
                  function setInterval(_x4, _x5) {
                    return _setInterval.apply(this, arguments);
                  }

                  setInterval.toString = function () {
                    return _setInterval.toString();
                  };

                  return setInterval;
                }(function (fn, delay) {
                  var me = this,
                      intervalId = setInterval(fn, delay);
                  if (!me.intervalIds) me.intervalIds = {};
                  me.intervalIds[intervalId] = true;
                  return intervalId;
                })
                /**
                 * Relays to native requestAnimationFrame and adds to tracking to have call automatically canceled on destroy.
                 * @param {Function} fn
                 * @param {Object[]} [args] The argument list to append to those passed to the function.
                 * @param {Object} [thisObj] `this` reference for the function.
                 * @returns {Number}
                 */

              }, {
                key: "requestAnimationFrame",
                value: function (_requestAnimationFrame) {
                  function requestAnimationFrame(_x6, _x7, _x8) {
                    return _requestAnimationFrame.apply(this, arguments);
                  }

                  requestAnimationFrame.toString = function () {
                    return _requestAnimationFrame.toString();
                  };

                  return requestAnimationFrame;
                }(function (fn, extraArgs, thisObj) {
                  var handler = extraArgs || thisObj ? function () {
                    return fn.apply(thisObj, extraArgs);
                  } : fn,
                      frameId = requestAnimationFrame(handler);
                  (this.animationFrameIds || (this.animationFrameIds = {}))[frameId] = true;
                  return frameId;
                })
                /**
                 * Creates a function which will execute once, on the next animation frame. However many time it is
                 * called in one event run, it will only be scheduled to run once.
                 * @param {Function|String} fn The function to call, or name of function in this object to call.
                 * @param {Object[]} [args] The argument list to append to those passed to the function.
                 * @param {Object} [thisObj] `this` reference for the function.
                 * @param {Boolean} [cancelOutstanding] Cancel any outstanding queued invocation upon call.
                 */

              }, {
                key: "createOnFrame",
                value: function createOnFrame(fn) {
                  var _this = this;

                  var extraArgs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                  var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
                  var cancelOutstanding = arguments.length > 3 ? arguments[3] : undefined;

                  var me = this,
                      rafId,
                      result = function result() {
                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                      args[_key] = arguments[_key];
                    } // Cancel if outstanding if requested


                    if (rafId && cancelOutstanding) {
                      me.cancelAnimationFrame(rafId);
                      rafId = null;
                    }

                    if (!rafId) {
                      rafId = _this.requestAnimationFrame(function () {
                        if (typeof fn === 'string') {
                          fn = thisObj[fn];
                        }

                        rafId = null;
                        args.push.apply(args, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(extraArgs));
                        fn.apply(thisObj, args);
                      });
                    }
                  };

                  result.cancel = function () {
                    return me.cancelAnimationFrame(rafId);
                  };

                  return result;
                }
                /**
                 * Relays to native cancelAnimationFrame and removes from tracking.
                 * @param {Number} handle
                 */

              }, {
                key: "cancelAnimationFrame",
                value: function (_cancelAnimationFrame) {
                  function cancelAnimationFrame(_x9) {
                    return _cancelAnimationFrame.apply(this, arguments);
                  }

                  cancelAnimationFrame.toString = function () {
                    return _cancelAnimationFrame.toString();
                  };

                  return cancelAnimationFrame;
                }(function (handle) {
                  cancelAnimationFrame(handle);
                  this.animationFrameIds && delete this.animationFrameIds[handle];
                })
                /**
                 * Wraps a function with another function that delays it specified amount of time, repeated calls to the wrapper
                 * resets delay.
                 * @param {Function|String} fn Function to buffer, or name of function in this object to call.
                 * @param {Number} delay Delay in ms
                 * @param {Object} [thisObj] `this` reference for the function.
                 * @returns {Function} Wrapped function, call this
                 */

              }, {
                key: "buffer",
                value: function buffer(fn, delay) {
                  var _this2 = this;

                  var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
                  var timeoutId = null;

                  if (typeof fn === 'string') {
                    fn = thisObj[fn];
                  }

                  var func = function func() {
                    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                      params[_key2] = arguments[_key2];
                    }

                    func.called = false;

                    if (timeoutId !== null) {
                      _this2.clearTimeout(timeoutId);
                    }

                    timeoutId = _this2.setTimeout(function () {
                      var _fn;

                      (_fn = fn).call.apply(_fn, [thisObj].concat(params)); // this will be instance of class that we are mixed into.


                      func.called = true;
                    }, delay);
                  };

                  return func;
                }
                /**
                 * Create a "debounced" function which will call on the "leading edge" of a timer period.
                 * When first invoked will call immediately, but invocations after that inside its buffer
                 * period will be rejected, and *one* invocation will be made after the buffer period has expired.
                 *
                 * This is useful for responding immediately to a first mousemove, but from then on, only
                 * calling the action function on a regular timer while the mouse continues to move.
                 *
                 * @param {Function} fn The function to call.
                 * @param {Number} buffer The milliseconds to wait after each execution before another execution takes place.
                 */

              }, {
                key: "throttle",
                value: function throttle(fn, buffer) {
                  var me = this,
                      lastCallTime = 0,
                      callArgs,
                      timerId,
                      _result;

                  var invoke = function invoke() {
                    timerId = 0;
                    lastCallTime = performance.now();
                    fn.apply(me, callArgs);
                    _result.called = true;
                  };

                  _result = function result() {
                    var elapsed = performance.now() - lastCallTime;

                    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                      args[_key3] = arguments[_key3];
                    }

                    callArgs = args; // If it's been more then the buffer period since we invoked, we can call it now

                    if (elapsed >= buffer) {
                      me.clearTimeout(timerId);
                      invoke();
                    } // Otherwise, kick off a timer for the requested period.
                    else if (!timerId) {
                        timerId = me.setTimeout(invoke, buffer - elapsed);
                        _result.called = false;
                      }
                  };

                  _result.cancel = function () {
                    return me.clearTimeout(timerId);
                  };

                  return _result;
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return Delayable;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/mixin/Events.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Common/mixin/Events.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonMixinEventsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.define-property */
        "../Grid/node_modules/core-js/modules/es6.reflect.define-property.js");
        /* harmony import */


        var core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_object_is_extensible__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.object.is-extensible */
        "../Grid/node_modules/core-js/modules/es6.object.is-extensible.js");
        /* harmony import */


        var core_js_modules_es6_object_is_extensible__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_is_extensible__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "../Grid/node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../helper/ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");
        /* harmony import */


        var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler'; //TODO: Implement mon

        /**
         * @module Common/mixin/Events
         */
        // Used to distinguish event names from listener options in addListener object config.

        var specialProperties = {
          thisObj: 1,
          detachable: 1,
          once: 1,
          detacher: 1,
          prio: 1,
          args: 1,
          _oldDestructor: 1
        },
            priorityComparator = function priorityComparator(a, b) {
          return b.prio - a.prio;
        };
        /**
         * Mix this into another class to enable event handling.
         *
         * ## Basic usage
         * Listeners can be added either through config:
         *
         * ```javascript
         * let button = new Button({
         *   listeners: {
         *     click: () => {},
         *     press: () => {},
         *     ...
         *   }
         * });
         * ```
         *
         * *NOTE*: Do not reuse listeners config object, use new every time:
         * ```javascript
         * // wrong
         * let config = { click : () => {} }
         * new Button({
         *     listeners : config
         * })
         * new Button({
         *     listeners : config
         * })
         * // right
         * new Button({
         *     listeners : { click : () => {} }
         * })
         * new Button({
         *     listeners : { click : () => {} }
         * })
         * ```
         *
         * Or by calling on()/addListener():
         *
         * ```javascript
         * let button = new Button();
         *
         * button.addListener('press', () => {});
         * // on is an alias for addListener
         * button.on('click', () => {});
         * ```
         *
         * This style also accepts multiple listeners in same way as when using config:
         *
         * ```javascript
         * button.on({
         *   click: () => {},
         *   press: () => {},
         *   ...
         * });
         * ```
         *
         * ## Options
         * ### Once
         * Listeners can be configured to automatically deregister after first trigger by specifing config option `once`:
         *
         * ```javascript
         * button.on({
         *   click: () => {},
         *   once: true
         * });
         * ```
         *
         * ### Priority
         * Specifying priority affects the order in which listeners are called when triggering an event. Higher prios will be
         * called before lower. Default value is 0.
         *
         * ```javascript
         * button.on({
         *   click: this.onClick,
         *   prio: 1
         * });
         * ```
         *
         * ### This reference
         * If desired, you can specify thisObj when configuring listeners. There is no need if you are using arrow functions as
         * listeners, but might be handy in other cases. Of course, you can also use bind to set `this` reference.
         *
         * ```javascript
         * button.on({
         *   click: this.onClick,
         *   thisObj: this
         * });
         *
         * // or
         *
         * button.on({
         *   click: this.onClick.bind(this)
         * });
         * ```
         *
         * ### Detacher
         * A convenient way of unregistering events is to use a detacher, a function returned when adding listeners that you
         * call later to deregister them. As of version 1.0, detachable defaults to true.
         *
         * ```javascript
         * let detacher = button.on({
         *   click: () => {},
         *   press: () => {},
         *   detachable: true
         * });
         *
         * // when you want to detach, for example in destroy()
         * detacher();
         * ```
         *
         * ### Auto detaching
         * When listeners are bound to a class instance using `thisObj`, the `thisObj`'s `doDestroy` method
         * is overridden to remove the listeners before calling the overridden doDestroy.
         *
         * ```javascript
         * class MyClass extends Base {
         *   construct() {
         *     let button = new Button({
         *       listeners: {
         *         click: () => {},
         *         thisObj: this
         *       }
         *     });
         *   }
         *
         *   doDestroy() {
         *     // clean up stuff
         *   }
         * }
         *
         * let myObj = new MyClass();
         * // clean up, also removes listeners
         * myObj.destroy();
         * ```
         *
         * ### On-functions
         * When mixing Events into another class it can be configured to call on-functions when events are triggered.
         * On-functions are functions named 'onEventname', for example 'onClick', 'onPress' declared on the class triggering
         * the event.
         *
         * ```javascript
         * // mix Events in with on-functions activated
         * let button = new Button({
         *   callOnFunctions: true,
         *
         *   onClick: () => {}
         * });
         *
         * // or add a getter in class declaration
         * ```
         *
         * ### Catching all events
         * By specifying a listener for `catchAll` a function can be notified when any event is triggered:
         *
         * ```javascript
         * const button = new Button({
         *    listeners : {
         *        catchAll(event) {
         *            // All events on the button will pass through here
         *        }
         *    }
         * });
         * ```
         *
         * @mixin
         */

        /* harmony default export */


        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default()(Events, _ref);

              function Events() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, Events);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Events).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(Events, [{
                key: "destroy",
                //region Events

                /**
                 * Fires before an object is destroyed.
                 * @event beforeDestroy
                 * @param {Object} source The Object that is being destroyed.
                 */

                /**
                 * Fires when an object is destroyed.
                 * @event destroy
                 * @param {Object} source The Object that is being destroyed.
                 */
                //endregion
                //region Config

                /**
                 * Listeners can be specified in target class config.
                 * ```
                 * let store = new Store({
                 *   listeners: {
                 *     load: () => {},
                 *     ...
                 *   }
                 * });
                 * ```
                 * @config {Object} listeners
                 */
                value: function destroy() {
                  this.trigger('beforeDestroy');

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Events.prototype), "destroy", this).call(this);
                } //endregion
                //region Init
                // TODO: Check, because not sure about using @function constructor here

                /**
                 * Adds configured listeners
                 * @private
                 * @function constructor
                 */

              }, {
                key: "construct",
                value: function construct() {
                  var _get2;

                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Events.prototype), "construct", this)).call.apply(_get2, [this].concat(args));

                  this.processConfiguredListeners();
                }
              }, {
                key: "processConfiguredListeners",
                value: function processConfiguredListeners() {
                  var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.listeners;
                  var me = this; // make sure main object contains `listeners` property

                  me.listeners = listeners; // TODO: listeners should be added first, so that any setters which fire or rely on listeners work.
                  // This may also expose bugs where listeners are fired too early.

                  if (me.listeners && !me.defaultListenersInitialized) {
                    var ret = me.addListener(me.listeners, me);
                    if (me.listeners.detachable !== false) me.listeners.detacher = ret;
                    me.defaultListenersInitialized = true;
                  }
                }
                /**
                 * Auto detaches listeners registered from start, if set as detachable
                 * @internal
                 */

              }, {
                key: "doDestroy",
                value: function doDestroy() {
                  var me = this;
                  me.trigger('destroy');

                  if (me.listeners && me.listeners.detacher) {
                    me.listeners.detacher();
                  }

                  me.removeAllListeners();

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Events.prototype), "doDestroy", this).call(this);
                } //endregion
                //region Listeners

                /**
                 * Adds an event listener. This method accepts parameters in the following format:
                 *
                 * ```javascript
                 *  {
                 *      thisObj    : this,          // The this reference for the handlers
                 *      eventname2 : 'functionName' // Resolved at invocation time using the thisObj,
                 *      otherevent : {
                 *          fn      : 'handlerFnName',
                 *          once    : true          // Just this handler is auto-removed on fire
                 *      },
                 *      yetanother  : {
                 *          fn      : 'yetAnotherHandler',
                 *          args    : [ currentState1, currentState2 ] // Capture info to be passed to handler
                 *      }
                 *      prio        : 100           // Higher prio listeners are called before lower
                 *  }
                 * ```
                 *
                 * When listeners have a `thisObj` option, they are linked to the lifecycle of that object.
                 * When it is destroyed, those listeners are removed.
                 *
                 * @param {Object} config An object containing listener definitions.
                 * @param {Object} [config.thisObj] The `this` reference for all listeners.
                 * (May be overridden if a handler is specified in object form)
                 * @param {Boolean} [config.once] Specify as `true` to remove the listener as soon as it is invoked.
                 * @param {Object[]} [config.args] An array of arguments to be passed to the handler before the event object.
                 * @param {Object} [thisObj] `this` reference for all listeners.
                 * @param {Number} [prio] The priority for all listeners; higher priority listeners are caled before lower.
                 * @returns {Function} Returns a detacher function unless configured with `detachable: false`. Call detacher to remove listeners
                 */

              }, {
                key: "addListener",
                value: function addListener(config, thisObj, arg2) {
                  var me = this,
                      events = me.eventListeners || (me.eventListeners = {});

                  if (typeof config === 'string') {
                    var _me$addListener; // arguments[2] is thisObj if (eventname, handler, thisObj) form called.
                    // Note that the other side of the if compares to undefined, so this will work.


                    return me.addListener((_me$addListener = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_me$addListener, config, thisObj), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_me$addListener, "detachable", thisObj.detachable !== false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_me$addListener, "thisObj", arg2), _me$addListener));
                  } else {
                    // If the thisObj came from the parameter, ensure the config object has it
                    // because this is how autoDetaching works.
                    thisObj = config.thisObj !== undefined ? config.thisObj : config.thisObj = thisObj;

                    for (var key in config) {
                      if (!specialProperties[key]) {
                        var listenerSpec = config[key],
                            listener = {
                          fn: _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_12___default()(listenerSpec) === 'object' ? listenerSpec.fn : listenerSpec,
                          thisObj: listenerSpec.thisObj !== undefined ? listenerSpec.thisObj : thisObj,
                          args: listenerSpec.args || config.args,
                          prio: listenerSpec.prio !== undefined ? listenerSpec.prio : config.prio !== undefined ? config.prio : 0,
                          once: listenerSpec.once !== undefined ? listenerSpec.once : config.once !== undefined ? config.once : false,
                          catchAll: key === 'catchAll'
                        },
                            eventName = key.toLowerCase(),
                            listeners = events[eventName] || (events[eventName] = []); // Insert listener directly in prio order

                        listeners.splice(_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"].findInsertionIndex(listener, listeners, priorityComparator, listeners.length), 0, listener);
                      }
                    }

                    if (config.relayAll) {
                      me.relayAll(config.relayAll);
                    } // Hook into the thisObj's destruction sequence to remove these listeners.


                    if (thisObj) {
                      me.attachAutoDetacher(config);
                    }

                    if (config.detachable !== false) {
                      return function () {
                        return me.removeListener(config);
                      };
                    }
                  }
                }
                /**
                 * Shorthand for addListener
                 * @param config
                 * @param [thisObj]
                 */

              }, {
                key: "on",
                value: function on() {
                  return this.addListener.apply(this, arguments);
                }
                /**
                 * Shorthand for removeListener
                 * @param config
                 * @param thisObj
                 */

              }, {
                key: "un",
                value: function un() {
                  this.removeListener.apply(this, arguments);
                }
                /**
                 * Removes an event listener. Same API signature as {@link #function-addListener}
                 * @param {Object} config Listeners
                 * @param {Object} thisObj `this` reference for all listeners
                 */

              }, {
                key: "removeListener",
                value: function removeListener(config) {
                  var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : config.thisObj;
                  var me = this;

                  if (typeof config === 'string') {
                    me.removeListener(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()({}, config, thisObj), (arguments.length <= 2 ? 0 : arguments.length - 2) > 0 ? arguments.length <= 2 ? undefined : arguments[2] : true);
                    return;
                  }

                  Object.entries(config).forEach(function (_ref2) {
                    var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_8___default()(_ref2, 2),
                        key = _ref3[0],
                        configListener = _ref3[1];

                    if (specialProperties[key]) {
                      return;
                    }

                    var eventName = key.toLowerCase(),
                        listeners = me.eventListeners && me.eventListeners[eventName];

                    if (listeners) {
                      var index = listeners.findIndex(function (listener) {
                        return (listener.fn === configListener || listener.fn === configListener.fn) && (listener.thisObj === thisObj || listener.thisObj === configListener.thisObj || !thisObj);
                      });

                      if (index >= 0) {
                        listeners.splice(index, 1);

                        if (!listeners.length) {
                          delete me.eventListeners[eventName];
                        }
                      }
                    }
                  });

                  if (config.thisObj && !config.thisObj.isDestroyed) {
                    me.detachAutoDetacher(config);
                  }
                }
                /**
                 * Check if any listener is registered for the specified eventName
                 * @param {String} eventName
                 * @returns {Boolean} `true` if listener is registered, otherwise `false`
                 */

              }, {
                key: "hasListener",
                value: function hasListener(eventName) {
                  return Boolean(this.eventListeners && this.eventListeners[eventName]);
                }
                /**
                 * Relays all events through another object that also implements Events mixin. Adds a prefix to the event name
                 * before relaying, for example add -> storeAdd
                 * ```
                 * // Relay all events from store through grid, will make it possible to listen for store events prefixed on grid:
                 * 'storeLoad', 'storeChange', 'storeRemoveAll' etc.
                 * store.relayAll(grid, 'store');
                 *
                 * grid.on('storeLoad', () => console.log('Store loaded');
                 * ```
                 * @param {Common.mixin.Events} through Object to relay the events through, needs to mix Events mixin in
                 * @param {String} prefix Prefix to add to event name
                 * @param {Boolean} [transformCase] Specify false to prevent making first letter of event name uppercase
                 */

              }, {
                key: "relayAll",
                value: function relayAll(through, prefix) {
                  var transformCase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                  var me = this;
                  if (!me.relayAllTargets) me.relayAllTargets = [];
                  me.relayAllTargets.push({
                    through: through,
                    prefix: prefix,
                    transformCase: transformCase
                  });
                }
                /**
                 * Removes all listeners registered to this object
                 */

              }, {
                key: "removeAllListeners",
                value: function removeAllListeners() {
                  var me = this,
                      listeners = me.eventListeners || (me.eventListeners = {});

                  var _loop = function _loop(event) {
                    listeners[event].forEach(function (cfg) {
                      return me.removeListener(event, cfg);
                    });
                  };

                  for (var event in listeners) {
                    _loop(event);
                  }
                }
              }, {
                key: "relayEvents",
                value: function relayEvents(source, eventNames, prefix) {
                  var me = this,
                      listenerConfig = {
                    detachable: true
                  };

                  function retrigger(eventName) {
                    for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                      params[_key2 - 1] = arguments[_key2];
                    }

                    return me.trigger.apply(me, [(prefix || '') + eventName].concat(params));
                  }

                  eventNames.forEach(function (eventName) {
                    listenerConfig[eventName] = function () {
                      for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                        params[_key3] = arguments[_key3];
                      }

                      return retrigger.apply(void 0, [eventName].concat(params));
                    };
                  });
                  return source.on(listenerConfig);
                }
                /**
                 * Internal function used to hook destroy() calls when using thisObj
                 * @private
                 */

              }, {
                key: "attachAutoDetacher",
                value: function attachAutoDetacher(config) {
                  var _this = this;

                  var target = config.thisObj,
                      // If it's a Bryntyum Base subclass, hook doDestroy, otherwise, destroy
                  destructorName = 'doDestroy' in target ? 'doDestroy' : 'destroy';

                  if (destructorName in target) {
                    config._oldDestructor = target[destructorName];

                    target[destructorName] = function () {
                      // Remove listeners first, so that they do not fire during destruction.
                      // The observable being listened to by the thisObj may already have
                      // been destroyed in a clean up sequence
                      if (!_this.isDestroyed) {
                        _this.removeListener(config);
                      }

                      config._oldDestructor.call(target);
                    };
                  } else {
                    target[destructorName] = function () {
                      _this.removeListener(config);
                    };
                  }
                }
                /**
                 * Internal function used restore hooked destroy() calls when using thisObj
                 * @private
                 */

              }, {
                key: "detachAutoDetacher",
                value: function detachAutoDetacher(config) {
                  var target = config.thisObj,
                      destructorName = 'doDestroy' in target ? 'doDestroy' : 'destroy';

                  if (config._oldDestructor) {
                    target[destructorName] = config._oldDestructor;
                  }
                } //endregion
                //region Promise based workflow
                // experimental, used in tests to support async/await workflow

              }, {
                key: "await",
                value: function _await(eventName) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    checkLog: true,
                    resetLog: true
                  };
                  var me = this;
                  return new Promise(function (resolve) {
                    var _me$on; // check if previously triggered?


                    if (options.checkLog && me._triggered && me._triggered[eventName]) {
                      // resolve immediately, no params though...
                      resolve(); // reset log to be able to await again

                      if (options.resetLog) {
                        me.clearLog(eventName);
                      }
                    }

                    me.on((_me$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_me$on, eventName, function () {
                      // resolve when event is caught
                      resolve.apply(void 0, arguments); // reset log to be able to await again

                      if (options.resetLog) {
                        me.clearLog(eventName);
                      }
                    }), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_me$on, "prio", -10000), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_13___default()(_me$on, "once", true), _me$on));
                  });
                }
              }, {
                key: "clearLog",
                value: function clearLog(eventName) {
                  if (this._triggered) {
                    if (eventName) {
                      delete this._triggered[eventName];
                    } else {
                      this._triggered = {};
                    }
                  }
                } //endregion
                //region Trigger

                /**
                 * Wraps a function with event triggering. First triggers before[eventName] with the supplied eventObject. If it is
                 * not prevented (by returning false) the supplied fn is called with the eventObject as first argument and any
                 * optional arguments after that. It then triggers [eventName] with the eventObject (that might have been altered in
                 * fn). Finally it returns the return value from the fn.
                 * @param {String} eventName Event name, used to trigger 'beforeEventName' and 'eventName'
                 * @param {Object} eventObject Passed when triggering events
                 * @param {Function} fn Function to call if before is not prevented
                 * @param {Array} args Arguments to pass to fn
                 * @param {Boolean} quiet Specify true to not trigger events
                 * @returns {*} Result returned from calling fn, or false if prevented
                 * @internal
                 */

              }, {
                key: "callPreventable",
                value: function callPreventable(eventName, eventObject, fn) {
                  var args = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
                  var quiet = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                  var me = this;

                  if (!quiet && me.trigger('before' + _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].capitalizeFirstLetter(eventName), eventObject) === false) {
                    return false;
                  }

                  var result = fn.apply(void 0, [eventObject].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default()(args)));

                  if (!quiet) {
                    me.trigger(eventName, eventObject);
                  }

                  return result;
                }
                /**
                 * Triggers an event, calling all registered listeners with the supplied arguments. Returning false from any listener
                 * makes function return false.
                 * @param {String} eventName Event name for which to trigger listeners
                 * @param {Object} param Single parameter passed on to listeners, source property will be added to it (this)
                 * @param {Boolean} [param.bubbles] Pass as `true` to indicate that the event will bubble up the widget
                 * ownership hierarchy. For example up a Menu->parent Menu tree, or a Field->Container tree.
                 * @returns {Boolean} Returns false if any listener returned false, otherwise true
                 */
                // TODO: should returning false from a listener really prevent other listeners from executing?

              }, {
                key: "trigger",
                value: function trigger(eventName, param) {
                  var me = this,
                      name = eventName.toLowerCase(),
                      eventsSuspended = me.eventsSuspended,
                      relayAllTargets = me.relayAllTargets,
                      callOnFunctions = me.callOnFunctions;
                  var listeners = me.eventListeners && me.eventListeners[name],
                      doSlice = true; // log trigger, used by experimental promise support to resolve immediately when needed

                  if (!me._triggered) {
                    me._triggered = {};
                  }

                  me._triggered[eventName] = true;

                  if (eventsSuspended) {
                    if (eventsSuspended.shouldQueue) eventsSuspended.queue.push(arguments);
                    return true;
                  } // Include catchall listener for all events.
                  // Do not push the catchAll listeners onto the events own listener array.


                  if (me.eventListeners && me.eventListeners.catchall) {
                    var _listeners;

                    (_listeners = listeners = listeners ? listeners.slice() : []).push.apply(_listeners, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default()(me.eventListeners.catchall)); // The catchAll listeners must honour their prio settings.


                    listeners.sort(priorityComparator);
                    doSlice = false;
                  }

                  if (!listeners && !relayAllTargets && !callOnFunctions) return true; // default to include source : this in param

                  if (param) {
                    if (!('source' in param)) {
                      if (Object.isExtensible(param)) {
                        param.source = me;
                      } else {
                        param = Object.setPrototypeOf({
                          source: me
                        }, param);
                      }
                    }
                  } else {
                    param = {
                      source: me
                    };
                  } // Lowercased event name should be the "type" property in keeping with DOM events.


                  if (param.type !== name) {
                    // Create instance property because "type" is read only
                    if (param.constructor !== Object) {
                      Reflect.defineProperty(param, 'type', {
                        get: function get() {
                          return name;
                        }
                      });
                    } else {
                      param.type = name;
                    }
                  }

                  if (callOnFunctions) {
                    var fnName = 'on' + _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].capitalizeFirstLetter(eventName);

                    if (fnName in me) {
                      me.callback(me[fnName], me, [param]); // See if the called function was injected into the instance
                      // masking an implementation in the prototype.
                      // we must call the class's implementation after the injected one.
                      // Note: The handler may have resulted in destruction.

                      if (!me.isDestroyed && me.hasOwnProperty(fnName)) {
                        var myProto = Object.getPrototypeOf(me);

                        if (fnName in myProto) {
                          myProto[fnName].call(me, param); // A handler may have resulted in destruction.

                          if (me.isDestroyed) {
                            return;
                          }
                        }
                      }
                    }
                  }

                  if (listeners) {
                    var i = 0,
                        listener,
                        handler; // Make a flat copy of the listeners to protect against a situation where an event listener
                    // adds another listener while triggering the event, which we do not want.
                    // The array may already be a copy if there are catchAll listeners. See above.

                    if (doSlice) {
                      listeners = listeners.slice();
                    } // If any listener resulted in our destruction, abort.


                    for (i; i < listeners.length && !me.isDestroyed; i++) {
                      listener = listeners[i];
                      var thisObj = listener.thisObj; // Listeners that have thisObj are auto removed when thisObj is destroyed. If thisObj is destroyed from
                      // a listener we might still end up here, since listeners are sliced and not affected by the removal

                      if (!thisObj || !thisObj.isDestroyed) {
                        if (listener.once) {
                          me.removeListener(name, listener);
                        }

                        if (typeof listener.fn === 'string') {
                          if (thisObj) {
                            handler = thisObj[listener.fn];
                          } // keep looking for the callback in the hierarchy


                          if (!handler) {
                            var result = me.resolveCallback(listener.fn);
                            handler = result.handler;
                            thisObj = result.thisObj;
                          }
                        } else {
                          handler = listener.fn;
                        } // If listener was declared with args, send our param after them


                        if (listener.args) {
                          var _handler;

                          if ((_handler = handler).call.apply(_handler, [thisObj || me].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default()(listener.args), [param])) === false) {
                            return false;
                          }
                        } else {
                          if (handler.call(thisObj || me, param) === false) {
                            return false;
                          }
                        }
                      }
                    }
                  } // relay all?


                  if (relayAllTargets) {
                    relayAllTargets.forEach(function (config) {
                      var name = eventName;
                      if (config.transformCase) name = _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].capitalizeFirstLetter(name);
                      if (config.prefix) name = config.prefix + name;
                      if (config.through.trigger(name, param) === false) return false;
                    });
                  } // Use DOM standard event property name to indicate that the event
                  // bubbles up the owner axis.
                  // False from any handler cancels the bubble.


                  if (param.bubbles) {
                    var owner = me.owner;

                    if (owner) {
                      return owner.trigger(eventName, param);
                    }
                  }

                  return true;
                }
                /**
                 * Prevents events from being triggered until {@link #function-resumeEvents()} is called. Optionally queues events that are triggered while
                 * suspended. Multiple calls stack to require matching calls to `resumeEvents()` before actually resuming.
                 * @param {Boolean} queue Specify true to queue events triggered while suspended
                 */

              }, {
                key: "suspendEvents",
                value: function suspendEvents() {
                  var queue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                  var eventsSuspended = this.eventsSuspended || (this.eventsSuspended = {
                    shouldQueue: queue,
                    queue: [],
                    count: 0
                  });
                  eventsSuspended.count++;
                }
                /**
                 * Resume event triggering after a call to {@link #function-suspendEvents()}. If any triggered events were queued they will be triggered.
                 * @returns `true` if events have been resumed (multiple calls to suspend require an equal number of resume calls to resume).
                 */

              }, {
                key: "resumeEvents",
                value: function resumeEvents() {
                  var suspended = this.eventsSuspended;

                  if (suspended) {
                    if (--suspended.count === 0) {
                      this.eventsSuspended = null;

                      if (suspended.shouldQueue) {
                        var _iteratorNormalCompletion = true;
                        var _didIteratorError = false;
                        var _iteratorError = undefined;

                        try {
                          for (var _iterator = suspended.queue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var queued = _step.value;
                            this.trigger.apply(this, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_5___default()(queued));
                          }
                        } catch (err) {
                          _didIteratorError = true;
                          _iteratorError = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                              _iterator.return();
                            }
                          } finally {
                            if (_didIteratorError) {
                              throw _iteratorError;
                            }
                          }
                        }
                      }
                    }
                  }

                  return !Boolean(this.eventsSuspended);
                } //endregion

              }]);

              return Events;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_20__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/mixin/InstancePlugin.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/mixin/InstancePlugin.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonMixinInstancePluginJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return InstancePlugin;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");

        var productName = 'scheduler';
        /**
         * @module Common/mixin/InstancePlugin
         */

        /**
         * Base class for plugins. Published functions will be available from the other class. `this` in published functions is
         * referenced to the plugin, access the other class using `this.pluggedInto`.
         *
         * Observe that plugin doesn't apply itself on class level but instead on instance level. Plugin is its own instance
         * that can have own functions and data that is not exposed to target class.
         *
         * Functions can be published in four ways:
         *
         * * `assign` (when function is not already available on target)
         * * `before` (when function is already available on target, will be called before original function)
         * * `after` (when function is already available on target, will be called after original function)
         * * `override` (replaces function on target, but old function can be reached)
         *
         * To configure which functions get published and in what way, specify `pluginConfig` getter on plugin:
         *
         * ```
         * class Sort extends InstancePlugin {
         *   static get pluginConfig {
         *      return {
         *          before   : ['init'],
         *          after    : ['destroy', 'onElementClick'],
         *          override : ['render']
         *      };
         *   }
         * }
         * ```
         *
         * @mixes Common/localization/Localizable
         * @mixes Common/mixin/Events
         */

        var InstancePlugin =
        /*#__PURE__*/
        function (_Localizable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(InstancePlugin, _Localizable);

          function InstancePlugin() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, InstancePlugin);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(InstancePlugin).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(InstancePlugin, [{
            key: "construct",

            /**
             * Initializes the plugin.
             * @internal
             * @param plugInto Target instance to plug into
             * @function constructor
             */
            value: function construct(plugInto, config) {
              /**
               * The Widget which was passed into the constructor,
               * which is the Widget we are providing extra services for.
               * @property {Common.widget.Widget}
               * @readonly
               */
              this.client = plugInto;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(InstancePlugin.prototype), "construct", this).call(this, config);

              this.applyPluginConfig(plugInto);
            }
            /**
             * Applies config as found in plugInto.pluginConfig, or published all if no config found.
             * @private
             * @param plugInto Target instance to plug into
             */

          }, {
            key: "applyPluginConfig",
            value: function applyPluginConfig(plugInto) {
              var me = this,
                  config = me.pluginConfig || me.constructor.pluginConfig,
                  assign = config && config.assign,
                  chain = config && (config.chain || config.after),
                  before = config && config.before,
                  override = config && config.override;
              me.pluggedInto = plugInto; // fill unpublished[] with all fnNames not in chain or override
              // apply chains and overrides.

              if (assign) me.applyAssign(plugInto, assign);
              if (chain) me.applyChain(plugInto, chain);
              if (before) me.applyChain(plugInto, before, false);
              if (override) me.applyOverride(plugInto, override);
            }
            /**
             * Applies assigning for specified functions.
             * @private
             * @param plugInto
             * @param fnNames
             */

          }, {
            key: "applyAssign",
            value: function applyAssign(plugInto, fnNames) {
              var _this = this;

              fnNames.forEach(function (fnName) {
                return _this.assign(plugInto, fnName);
              });
            }
            /**
             * Applys chaining for specified functions.
             * @private
             * @param plugInto
             * @param fnNames
             * @param after
             */

          }, {
            key: "applyChain",
            value: function applyChain(plugInto, fnNames) {
              var after = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
              var me = this;
              fnNames.forEach(function (fnName) {
                if (plugInto[fnName]) {
                  me.chain(plugInto, fnName, after);
                } else {
                  me.assign(plugInto, fnName);
                }
              });
            }
            /**
             * Applies override for specified functions.
             * @private
             * @param plugInto
             * @param fnNames
             */

          }, {
            key: "applyOverride",
            value: function applyOverride(plugInto, fnNames) {
              var _this2 = this;

              var me = this;
              if (!me.overridden) me.overridden = {};
              fnNames.forEach(function (fnName) {
                if (!me[fnName]) {
                  throw new Error(_this2.L('overrideFnMissing', {
                    plugIntoName: plugInto.$name,
                    pluginName: me.$name,
                    fnName: fnName
                  }));
                } // override


                if (typeof plugInto[fnName] === 'function') me.overridden[fnName] = plugInto[fnName].bind(plugInto);
                plugInto[fnName] = me[fnName].bind(me);
              });
            }
            /**
             * Assigns specified functions.
             * @private
             * @param plugInto
             * @param fnName
             */

          }, {
            key: "assign",
            value: function assign(plugInto, fnName) {
              var me = this,
                  property = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(me), fnName);

              if (property && (property.get || property.set)) {
                // getter/setter, define corresponding property on target
                Object.defineProperty(plugInto, fnName, {
                  configurable: true,
                  enumerable: true,
                  get: property.get && property.get.bind(me),
                  set: property.set && property.set.bind(me)
                });
              } else {
                plugInto[fnName] = me[fnName].bind(me);
              }
            } //endregion
            //region Chaining

            /**
             * Chains functions. When the function is called on the target class all functions in the chain will be called in
             * the order they where added.
             * @private
             * @param plugInto
             * @param key
             */

          }, {
            key: "chain",
            value: function chain(plugInto, key) {
              var after = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
              var me = this,
                  chain = plugInto.pluginFunctionChain || (plugInto.pluginFunctionChain = {}); // duplicate function, make chain and use function to run all functions in it upon call...

              if (!chain[key]) {
                chain[key] = [plugInto[key].bind(plugInto)];
              }

              if (!me[key]) {
                throw new Error(this.L('fnMissing', {
                  plugIntoName: plugInto.$name,
                  pluginName: me.$name,
                  fnName: key
                })); //throw new Error(`Trying to plug function ${plugInto.$name}#${key}, but InstancePlugin ${me.$name}#${key} does not exist`);
              }

              if (after) {
                chain[key].push(me[key].bind(me));
              } else {
                chain[key].unshift(me[key].bind(me));
              } // use function to run all functions in chain on call


              plugInto[key] = function () {
                for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
                  params[_key] = arguments[_key];
                }

                return me.functionChainRunner.apply(me, [key].concat(params));
              };
            }
            /**
             * Used to run multiple plugged in functions with the same name, see chain above. Returning false from a
             * function will abort chain.
             * @private
             * @param fnName
             * @param params
             * @returns value returned from last function in chain (or false if any returns false)
             */

          }, {
            key: "functionChainRunner",
            value: function functionChainRunner(fnName) {
              var chain = this.pluggedInto.pluginFunctionChain[fnName];
              var returnValue; // changed from for..of to try and fix Edge problems

              for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                params[_key2 - 1] = arguments[_key2];
              }

              for (var i = 0; i < chain.length; i++) {
                returnValue = chain[i].apply(chain, params);
                if (returnValue === false) return false;
              }

              return returnValue;
            } //endregion

            /**
             * Get/set the plugin disabled state
             * @property {Boolean}
             */

          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              this._disabled = disabled;
            }
          }], [{
            key: "initPlugins",
            //endregion
            //region Init

            /**
             * Call from another instance to add plugins to it.
             * @example
             * InstancePlugin.initPlugins(this, Search, Stripe);
             * @param plugInto Instance to mix into (usually this)
             * @param plugins Classes to plug in
             * @internal
             */
            value: function initPlugins(plugInto) {
              var property = plugInto.plugins || (plugInto.plugins = {});

              for (var _len3 = arguments.length, plugins = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                plugins[_key3 - 1] = arguments[_key3];
              }

              for (var _i = 0; _i < plugins.length; _i++) {
                var PluginClass = plugins[_i];
                property[PluginClass.$name] = new PluginClass(plugInto);
              }
            }
          }, {
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * The plugin disabled state
                 * @config {Boolean}
                 * @default
                 */
                disabled: false
              };
            }
          }]);

          return InstancePlugin;
        }(Object(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_8__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"])));

        InstancePlugin._$name = 'InstancePlugin';
        /***/
      },

      /***/
      "../Grid/lib/Common/mixin/Override.js":
      /*!********************************************!*\
        !*** ../Grid/lib/Common/mixin/Override.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonMixinOverrideJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Override;
        });
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_reflect_own_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.own-keys */
        "../Grid/node_modules/core-js/modules/es6.reflect.own-keys.js");
        /* harmony import */


        var core_js_modules_es6_reflect_own_keys__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_own_keys__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../helper/VersionHelper.js */
        "../Grid/lib/Common/helper/VersionHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/mixin/Override
         */

        var excludedPropNames = {
          constructor: 1,
          prototype: 1,
          name: 1,
          length: 1,
          arguments: 1,
          caller: 1,
          callee: 1,
          __proto__: 1
        };
        /**
         * Simplifies overriding class methods by allowing methods from another class to be used as overrides.
         * Overrides are defined as own classes. They must at a minimum contain a static getter named targetClass, which
         * should return the class to override. Apply the override by calling {@link #function-apply-static apply()}.
         *
         * @example
         * class TemplateColumnOverride {
         *   static get target() {
         *     return {
         *             class: TemplateColumn,
         *             product: 'grid',
         *             minVersion: '1.0',
         *             maxVersion: '1.5'
         *     }
         *   }
         *
         *   renderer(renderData) {
         *       // call overridden function (optional)
         *       const value = this._overridden.renderer.call(this, renderData);
         *
         *       return 'HELLO' + value;
         *   }
         * }
         * Override.apply(TemplateColumnOverride);
         */

        var Override =
        /*#__PURE__*/
        function () {
          function Override() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, Override);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Override, null, [{
            key: "apply",

            /**
             * Apply override. We strongly suggest that you at least specify a maxVersion for your overrides.
             * ```
             * class OriginalOverride {
             *     static get target() {
             *         return {
             *             class: Original,
             *             product: 'grid',
             *             minVersion: '1.0',
             *             maxVersion: '1.5'
             *         }
             *     }
             * }
             * ```
             * @param override An override class definition
             */
            value: function apply(override) {
              if (!override.target) throw new Error('Override must specify what it overrides, using static getter target');
              if (!override.target.class) throw new Error('Override must specify which class it overrides, using target.class');
              if (!this.shouldApplyOverride(override)) return false;
              var staticKeys = Object.getOwnPropertyNames(override),
                  instanceKeys = Object.getOwnPropertyNames(override.prototype);
              staticKeys.splice(staticKeys.indexOf('target'), 1);
              this.internalOverrideAll(override.target.class, staticKeys, override);
              this.internalOverrideAll(override.target.class.prototype, instanceKeys, override.prototype);
              return true;
            }
          }, {
            key: "internalOverrideAll",
            value: function internalOverrideAll(targetClass, properties, overrideDefinition) {
              var _this = this;

              Reflect.ownKeys(overrideDefinition).forEach(function (key) {
                if (properties.includes(key) && !excludedPropNames[key]) {
                  var desc = Object.getOwnPropertyDescriptor(overrideDefinition, key);
                  var currentTargetClass = targetClass;
                  var targetProperty = null; // Walk up the prototype chain to find fn, needed for mixin overrides applied to class that has them
                  // mixed in

                  while (!targetProperty && currentTargetClass) {
                    targetProperty = Object.getOwnPropertyDescriptor(currentTargetClass, key);

                    if (!targetProperty) {
                      currentTargetClass = Object.getPrototypeOf(currentTargetClass);
                    }
                  }

                  if (targetProperty) {
                    _this.internalOverride(currentTargetClass, key, desc, targetProperty);
                  }
                }
              });
            }
          }, {
            key: "internalOverride",
            value: function internalOverride(target, key, desc, targetDesc) {
              var overrides = target._overridden = target._overridden || {};
              overrides[key] = target[key];

              if (targetDesc.get) {
                Object.defineProperty(target, key, {
                  enumerable: false,
                  configurable: true,
                  get: desc.get
                });
              } else {
                target[key] = desc.value;
              }
            }
            /**
             * Checks versions if an override should be applied. Specify version in your overrides target config
             * @param override
             * @returns {Boolean}
             * @example
             * class OriginalOverride {
             *     static get target() {
             *         return {
             *             class: Original,
             *             product: 'grid',
             *             minVersion: '1.0',
             *             maxVersion: '1.5'
             *         }
             *     }
             * }
             * @private
             */

          }, {
            key: "shouldApplyOverride",
            value: function shouldApplyOverride(override) {
              var config = override.target; // not using versioning, allow override

              if (!config.maxVersion && !config.minVersion) return true; // must specify product to be able to lookup versions

              if (!config.product) throw new Error('Override must specify product when using versioning'); // override is for older version, disallow

              if (config.maxVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"][config.product].isNewerThan(config.maxVersion)) {
                return false;
              } // override is for newer version, disallow


              if (config.minVersion && _helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"][config.product].isOlderThan(config.minVersion)) {
                return false;
              } // override is for current version, allow


              return true;
            }
          }]);

          return Override;
        }();

        Override._$name = 'Override';
        /***/
      },

      /***/
      "../Grid/lib/Common/mixin/Pluggable.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/mixin/Pluggable.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonMixinPluggableJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");

        var productName = 'scheduler';
        /**
         * @module Common/mixin/Pluggable
         */

        /**
         * Enables using plugins for a class by specifing property plugins as an array of plugin classes. If only a single plugin
         * is used, just give the plugin class instead of an array. This class isn't required for using plugins, just makes it
         * easier. Without mixin you can otherwise use `InstancePlugin.initPlugins(this, PluginClass)`.
         *
         * @example
         * new Store({
         *   plugins: [PluginClass, ...]
         * });
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Pluggable, _ref);

              function Pluggable() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Pluggable);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Pluggable).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Pluggable, [{
                key: "initPlugins",

                /**
                 * Template method which may be implemented in subclasses to initialize any plugins.
                 * This method is empty in the `Pluggable` base class.
                 * @internal
                 */
                value: function initPlugins() {}
                /**
                 * Adds plugins to an instance.
                 * @param plugins Plugins to add
                 */

              }, {
                key: "addPlugins",
                value: function addPlugins() {
                  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
                    plugins[_key] = arguments[_key];
                  }

                  _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"].initPlugins.apply(_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"], [this].concat(plugins));
                }
                /**
                 * Checks if instance has plugin.
                 * @param pluginClassOrName Plugin or name to check for
                 * @returns {Boolean}
                 */

              }, {
                key: "hasPlugin",
                value: function hasPlugin(pluginClassOrName) {
                  return this.getPlugin(pluginClassOrName) != null;
                }
                /**
                 * Get a plugin instance.
                 * @param pluginClassOrName
                 * @returns {Object}
                 */

              }, {
                key: "getPlugin",
                value: function getPlugin(pluginClassOrName) {
                  if (typeof pluginClassOrName === 'function') pluginClassOrName = pluginClassOrName.$name;
                  return this.plugins && this.plugins[pluginClassOrName];
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "plugins",

                /**
                 * Specify plugins (an array of classes) in config
                 * @config {Function[]} plugins
                 * @category Misc
                 */

                /**
                 * Map of applied plugins
                 * @property {Object}
                 * @readonly
                 * @category Misc
                 */
                get: function get() {
                  if (!this._plugins) {
                    this._plugins = {};
                  }

                  return this._plugins;
                },
                set: function set(plugins) {
                  if (plugins) {
                    if (!Array.isArray(plugins)) plugins = [plugins];

                    _InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"].initPlugins.apply(_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"], [this].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(plugins)));
                  }

                  this.initPlugins();
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return Pluggable;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/mixin/State.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Common/mixin/State.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonMixinStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/mixin/State
         */

        /**
         * Mixin that simplifies handling state for an ui component. Classes that uses this mixin must implement `getState()` and
         * `applyState(state)`.
         *
         * ```
         * class MyUIComponent extends State() {
         *   getState() {
         *     return {
         *       this.text,
         *       this.size
         *     }
         *   }
         *
         *   applyState(state) {
         *      this.text = state.text;
         *      this.size = state.size;
         *   }
         * }
         * ```
         *
         * @demo state
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(State, _ref);

              function State() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, State);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(State).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(State, [{
                key: "state",
                //getState() {}
                //applyState(State) {}

                /**
                 * Gets or sets a component´s state
                 * @property {Object}
                 */
                get: function get() {
                  this._state = this.getState();
                  return this._state;
                },
                set: function set(state) {
                  this._state = state;
                  this.applyState(state);
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return State;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Common/util/Bag.js":
      /*!**************************************!*\
        !*** ../Grid/lib/Common/util/Bag.js ***!
        \**************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonUtilBagJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Bag;
        });
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "../Grid/node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Collection_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./Collection.js */
        "../Grid/lib/Common/util/Collection.js");

        var productName = 'scheduler';
        /**
         * @module Common/util/Bag
         */

        /**
         * A simple collection class to contain unique, keyed items.
         */

        var Bag =
        /*#__PURE__*/
        function () {
          function Bag(config) {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, Bag);

            var me = this;
            me.generation = 0;
            me.items = new Set();
            me.idMap = {};
            me.idProperty = 'id';

            if (config) {
              if (config.idProperty) {
                me.idProperty = config.idProperty;
              }

              if (config.values) {
                me.values = config.values;
              }
            }

            me.idProperty = config && config.idProperty || 'id';
          }
          /**
           * Returns the item with the passed `id`.
           *
           * @param {*} id The `id` to find.
           * @returns {Object} The found item, or `undefined`.
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(Bag, [{
            key: "get",
            value: function get(key) {
              return this.idMap[Object(_Collection_js__WEBPACK_IMPORTED_MODULE_10__["safeIndexKey"])(key)];
            }
            /**
             * The number of items in this Bag.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "add",

            /**
             * Adds the passed item(s) to this Bag. Existing items with the same ID
             * will be replaced.
             * @param {Object|Object[]} toAdd Item(s) to add.
             */
            value: function add(toAdd) {
              if (!Array.isArray(toAdd)) {
                toAdd = [toAdd];
              }

              var me = this,
                  items = me.items,
                  idMap = me.idMap,
                  idProperty = me.idProperty,
                  len = toAdd.length;

              for (var i = 0; i < len; i++) {
                var item = toAdd[i],
                    key = Object(_Collection_js__WEBPACK_IMPORTED_MODULE_10__["safeIndexKey"])(item[idProperty]),
                    existingItem = idMap[key]; // Not already present

                if (existingItem == null) {
                  idMap[key] = item;
                  items.add(item);
                  me.generation++;
                } // Already present, replace it if different. No generational change.
                // IDs rule.
                else if (existingItem !== item) {
                    idMap[key] = item;
                    items.delete(existingItem);
                    items.add(item);
                  }
              }
            }
            /**
             * Removes the passed item(s) from this Bag.
             * @param {Object|Object[]} toAdd Item(s) to remove.
             */

          }, {
            key: "remove",
            value: function remove(toRemove) {
              if (!Array.isArray(toRemove)) {
                toRemove = [toRemove];
              }

              var items = this.items,
                  idMap = this.idMap,
                  idProperty = this.idProperty,
                  len = toRemove.length;

              for (var i = 0; i < len; i++) {
                var item = toRemove[i],
                    key = Object(_Collection_js__WEBPACK_IMPORTED_MODULE_10__["safeIndexKey"])(item[idProperty]),
                    existingItem = idMap[key]; // Found natch, so delete it

                if (existingItem != null) {
                  items.delete(existingItem);
                  delete idMap[key];
                  this.generation++;
                }
              }
            }
          }, {
            key: "clear",
            value: function clear() {
              this.items.clear();
              this.idMap = {};
              this.generation++;
            }
            /**
             * Change the id of an existing member by mutating its idProperty.
             * @param {String|Number|Object} item The item or id of the item to change.
             * @param {String|Number} newId The id to set in the existing member.
             */

          }, {
            key: "changeId",
            value: function changeId(item, newId) {
              var me = this,
                  idMap = me.idMap,
                  idProperty = me.idProperty,
                  oldId = _Collection_js__WEBPACK_IMPORTED_MODULE_10__["keyTypes"][_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default()(item)] ? item : Object(_Collection_js__WEBPACK_IMPORTED_MODULE_10__["safeIndexKey"])(item[idProperty]),
                  member = me.get(oldId);

              if (member) {
                var existingMember = me.get(newId);

                if (existingMember && member !== existingMember) {
                  throw new Error("Attempt to set item ".concat(oldId, " to already existing member's id ").concat(newId));
                }

                member[idProperty] = newId;
                delete idMap[oldId];
                idMap[newId] = member;
              }
            }
            /**
             * Returns `true` if this Collection includes an item with the same `id` as the passed item.
             *
             * @param {Object|String|Number} item The item to find, or an `id` to find.
             * @returns {Boolean} True if the passed item is found.
             */

          }, {
            key: "includes",
            value: function includes(item) {
              var key = _Collection_js__WEBPACK_IMPORTED_MODULE_10__["keyTypes"][_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default()(item)] ? item : Object(_Collection_js__WEBPACK_IMPORTED_MODULE_10__["safeIndexKey"])(item[this.idProperty]);
              return Boolean(this.idMap[key]);
            }
            /**
             * Extracts the content of this Bag into an array based upon the passed
             * value extraction function.
             * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
             * @param {Object} [thisObj] The `this` reference when the function is called.
             * @returns {Object[]} An array of values extracted from this Bag.
             */

          }, {
            key: "map",
            value: function map(fn, thisObj) {
              var items = this.items,
                  result = new Array(items.size); // Set has no map

              var i = 0;
              items.forEach(function (item) {
                return result[i] = fn.call(thisObj, item, i, items);
              });
              return result;
            }
            /**
             * Executes the passed function for each item in this Bag, passing in the item.
             * @param {Function} fn The function to execute.
             * @param {Object} [thisObj] The `this` reference when the function is called.
             */

          }, {
            key: "forEach",
            value: function forEach(fn, thisObj) {
              return this.items.forEach(fn, thisObj);
            }
            /**
             * Returns the first item in this Bag which elicits a *truthy* return value from the passed funtion.
             * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
             * @returns {Object} The matched item, or `undefined`.
             */

          }, {
            key: "find",
            value: function find(fn) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = this.items[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var div = _step.value;

                  if (fn(div)) {
                    return div;
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              return undefined;
            }
            /**
             * Iterator that allows you to do for (let item of bag)
             */

          }, {
            key: Symbol.iterator,
            value: function value() {
              return this.items[Symbol.iterator]();
            }
            /**
             * The set of values of this Bag.
             *
             * Setting this property replaces the data set.
             * @property {Object[]}
             */

          }, {
            key: "count",
            get: function get() {
              return this.items.size;
            }
          }, {
            key: "values",
            get: function get() {
              return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(this.items);
            },
            set: function set(values) {
              var generation = this.generation;
              this.clear();
              this.add(values);
              this.generation = generation + 1;
            }
          }]);

          return Bag;
        }();

        Bag._$name = 'Bag';
        /***/
      },

      /***/
      "../Grid/lib/Common/util/ClickRepeater.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/util/ClickRepeater.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonUtilClickRepeaterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ClickRepeater;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../helper/FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/util/ClickRepeater
         */

        /**
         * A helper class, which, when applied to an {@link #config-element} means that a mousedown
         * and hold on that element will, after a configured {@link #config-delay}, begin
         * autorepeating `click` events on that element, starting at a rate of
         * {@link #config-startRate} clicks per second, and over {@link #config-accelerateDuration}
         * milliseconds, accelerate to firing clicks at {@link #config-endRate} times per second.
         *
         * An example of this is used by the {@link Common.widget.NumberField NumberField}'s
         * spinner triggers.
         */

        var ClickRepeater =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ClickRepeater, _Delayable);

          function ClickRepeater() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ClickRepeater);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ClickRepeater).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ClickRepeater, [{
            key: "doDestroy",
            value: function doDestroy() {
              this.mousedownRemover && this.mousedownRemover();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ClickRepeater.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "onMouseDown",
            value: function onMouseDown(e) {
              var me = this,
                  target = me.delegate ? e.target.closest(me.delegate) : me.element;

              if (target) {
                me.triggerEvent = e;

                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].lockComposedPath(me.triggerEvent);

                me.activeListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                  mouseup: {
                    element: document,
                    handler: 'onMouseUp'
                  },
                  mousemove: {
                    element: target,
                    handler: 'onTargetMouseMove'
                  },
                  mouseleave: {
                    element: target,
                    handler: 'onTargetMouseLeave'
                  },
                  mouseenter: {
                    element: target,
                    handler: 'onTargetMouseEnter'
                  },
                  thisObj: me
                });
                me.setTimeout('startAutoRepeat', me.delay);
              }
            }
          }, {
            key: "onMouseUp",
            value: function onMouseUp(e) {
              var me = this;
              me.acceleration && me.acceleration.cancel();
              me.activeListenerRemover && me.activeListenerRemover();
              me.clearTimeout('startAutoRepeat');
              me.clearInterval(me.repeatTimer);
            }
          }, {
            key: "onTargetMouseLeave",
            value: function onTargetMouseLeave() {
              this.clearInterval(this.repeatTimer);
            }
          }, {
            key: "onTargetMouseEnter",
            value: function onTargetMouseEnter(e) {
              this.triggerEvent = e;
              this.fireClick();
            }
          }, {
            key: "onTargetMouseMove",
            value: function onTargetMouseMove(e) {
              this.triggerEvent = e;
            }
          }, {
            key: "startAutoRepeat",
            value: function startAutoRepeat() {
              var me = this;
              me.interval = me.startInterval = 1000 / me.startRate;
              me.accelerationDelta = me.startInterval - 1000 / me.endRate; // Begin animating the interval from 1000/me.startRate to 1000/me.endRate

              me.fireClick();
              me.acceleration = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].animate(me.accelerateDuration, me.nextTick, me, 'easeOutQuad');
            }
          }, {
            key: "nextTick",
            value: function nextTick(progress) {
              this.interval = this.startInterval - this.accelerationDelta * progress;
            }
          }, {
            key: "fireClick",
            value: function fireClick() {
              var me = this,
                  clickEvent = new MouseEvent('click', me.triggerEvent);
              me.triggerEvent.target.dispatchEvent(clickEvent);
              me.repeatTimer = me.setTimeout(me.fireClick, me.interval);
            }
          }, {
            key: "element",
            set: function set(element) {
              this._element = element;
              this.mousedownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                element: element,
                mousedown: 'onMouseDown',
                thisObj: this
              });
            },
            get: function get() {
              return this._element;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The element on which to fire autorepeating `click` events when the mouse is held down.
                 * @config {HTMLElement}
                 */
                element: null,

                /**
                 * A query selector which specifies subtargets of this ClickRepeater's {@link #config-element}
                 * which act as the click auto repeat event targets.
                 * @config {String}
                 * @default
                 */
                delegate: null,

                /**
                 * How long in milliSeconds to pause before starting the click repeats.
                 * @config {Number}
                 * @default
                 */
                delay: 500,

                /**
                 * Clicks per second to start firing after the initial {@link #config-delay}
                 * @config {Number}
                 * @default
                 */
                startRate: 2,

                /**
                 * Clicks per second to fire at top speed, after accelerating over the {@link #config-accelerateDuration}
                 * @config {Number}
                 * @default
                 */
                endRate: 20,

                /**
                 * How long in millieconds to accelerate from the
                 * {@link #config-startRate} to the {@link #config-startRate}.
                 * @config {Number}
                 * @default
                 */
                accelerateDuration: 4000
              };
            }
          }]);

          return ClickRepeater;
        }(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_7__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"]));

        ClickRepeater._$name = 'ClickRepeater';
        /***/
      },

      /***/
      "../Grid/lib/Common/util/Collection.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/util/Collection.js ***!
        \*********************************************/

      /*! exports provided: default, safeIndexKey, keyTypes */

      /***/
      function GridLibCommonUtilCollectionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Collection;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "safeIndexKey", function () {
          return safeIndexKey;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "keyTypes", function () {
          return keyTypes;
        });
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "../Grid/node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es6_weak_map__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es6.weak-map */
        "../Grid/node_modules/core-js/modules/es6.weak-map.js");
        /* harmony import */


        var core_js_modules_es6_weak_map__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_weak_map__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "../Grid/node_modules/core-js/modules/es6.object.freeze.js");
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ./CollectionFilter.js */
        "../Grid/lib/Common/util/CollectionFilter.js");
        /* harmony import */


        var _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ./CollectionSorter.js */
        "../Grid/lib/Common/util/CollectionSorter.js");
        /* harmony import */


        var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../helper/FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/util/Collection
         */

        var return0 = function return0() {
          return 0;
        },
            reverseNumericSortFn = function reverseNumericSortFn(a, b) {
          return b - a;
        },
            filteredIndicesProperty = Symbol('filteredIndicesProperty'),
            emptyArray = Object.freeze([]),
            sortEvent = Object.freeze({
          action: 'sort',
          added: emptyArray,
          removed: emptyArray,
          replaced: emptyArray
        }),
            filterEvent = Object.freeze({
          action: 'filter',
          added: emptyArray,
          removed: emptyArray,
          replaced: emptyArray
        }),
            keyTypes = {
          string: 1,
          number: 1
        },
            nonPrimitives = new WeakMap(),
            safeIndexKey = function safeIndexKey(value) {
          if (value && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default()(value) === 'object') {
            var substitute = nonPrimitives.get(value);

            if (substitute === undefined) {
              substitute = Symbol('bscik'); // Bryntum safe collection index key

              nonPrimitives.set(value, substitute);
            }

            value = substitute;
          }

          return value;
        };
        /**
         * A class which encapsulates a {@link #function-get keyed},
         * {@link #function-addFilter filterable}, {@link #function-addSorter sortable}
         * collection of objects. Entries may not be atomic data types such as `string` or `number`.
         *
         * The entries are keyed by their `id` which is determined by interrogating the {@link #config-idProperty}.
         *
         * To filter a Collection, add a {@link Common.util.CollectionFilter CollectionFilter}
         * using the {@link #function-addFilter} method. A Filter config object may be specified here
         * which will be promoted to a CollectionFilter instance.
         *
         * To sort a Collection, add a {@link Common.util.CollectionSorter CollectionSorter}
         * using the {@link #function-addSorter} method. A Sorter config object may be specified here
         * which will be promoted to a CollectionSorter instance.
         */


        var Collection =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Collection, _Events);

          function Collection() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, Collection);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Collection).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Collection, [{
            key: "construct",
            value: function construct(config) {
              /**
               * A counter which is incremented whenever the Collection is mutated in a meaningful way.
               *
               * If a {@link #function-splice} call results in no net replacement, removal or addition,
               * then the `generation` will not be incremented.
               * @property {Number}
               * @readonly
               */
              this.generation = 0;
              this._values = [];

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Collection.prototype), "construct", this).call(this, config);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Collection.prototype), "doDestroy", this).call(this);

              this._values.length = 0;

              if (this.isFiltered) {
                this._filteredValues.length = 0;
                this.filters.destroy();
              }

              this._sorters && this._sorters.destroy();
            }
          }, {
            key: "clear",

            /**
             * Clears this collection.
             */
            value: function clear() {
              var me = this,
                  removed = this._values.slice();

              if (me.totalCount) {
                me._values.length = 0;

                if (me._filteredValues) {
                  me._filteredValues.length = 0;
                }

                me._indicesInvalid = true; // Indicate to obervers that data has changed.

                me.generation++;
                me.trigger('change', {
                  action: 'clear',
                  removed: removed
                });
              }
            }
            /**
             * Replaces the internal values array with the passed array. Note that this takes ownership of the array, and the array
             * must not be mutated by outside code.
             *
             * This is an internal utility method, not designed for use by application code.
             * @internal
             * @param {Object[]} values The new values array
             */

          }, {
            key: "replaceValues",
            value: function replaceValues(values, silent, ignoreFilters) {
              var me = this;
              var removed;

              if (me.isFiltered && !ignoreFilters) {
                removed = me._filteredValues;
                me._filteredValues = values;
              } else {
                removed = me._values;
                me._values = values;

                if (me._filteredValues) {
                  me._filteredValues.length = 0;
                }
              }

              me._indicesInvalid = true; // Indicate to obervers that data has changed.

              me.generation++;

              if (!silent) {
                me.trigger('change', {
                  action: 'replaceValues',
                  removed: removed,
                  values: values,
                  replaced: []
                });
              }
            }
          }, {
            key: Symbol.iterator,

            /**
             * Iterator that allows you to do for (let item of collection)
             */
            value: function value() {
              return this.values[Symbol.iterator]();
            }
            /**
             * Executes the passed function for each item in this Collection, passing in the item,
             * ths index, and the full item array.
             * @param {Function} fn The function to execute.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to include all items, bypassing filters.
             */

          }, {
            key: "forEach",
            value: function forEach(fn) {
              var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).forEach(fn);
            }
            /**
             * Extracts ths content of this Collection into an array based upon the passed
             * value extraction function.
             * @param {Function} fn A function, which, when passed an item, returns a value to place into the resulting array.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to process an item even if it is filtered out.
             * @returns {Object[]} An array of values extracted from this Collection.
             */

          }, {
            key: "map",
            value: function map(fn) {
              var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).map(fn);
            }
            /**
             * Returns the first item in this Collection which elicits a *truthy* return value from the passed funtion.
             * @param {Function} fn A function, which, when passed an item, returns `true` to select it as the item to return.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to include filtered out items.
             * @returns {Object} The matched item, or `undefined`.
             */

          }, {
            key: "find",
            value: function find(fn) {
              var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              return (this.isFiltered && !ignoreFilters ? this._filteredValues : this._values).find(fn);
            }
          }, {
            key: "add",

            /**
             * Adds items to this Collection. Multiple new items may be passed.
             *
             * By default, new items are appended to the existing values.
             *
             * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
             *
             * Any {@link #property-filters} {@link #property-filters} present are re-run.
             *
             * *Note that if application functionality requires add and remove, the
             * {@link #function-splice} operation is preferred as it performs both
             * operations in an atomic manner*
             * @param  {...Object} items The item(s) to add.
             */
            value: function add() {
              for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
                items[_key] = arguments[_key];
              }

              if (items.length === 1) {
                this.splice.apply(this, [this._values.length, null].concat(items));
              } else {
                this.splice(this._values.length, null, items);
              }
            }
            /**
             * Removes items from this Collection. Multiple items may be passed.
             *
             * Any {@link #property-sorters} {@link #property-sorters} present are re-run.
             *
             * Any {@link #property-filters} {@link #property-filters} present are re-run.
             *
             * *Note that if application functionality requires add and remove, the
             * {@link #function-splice} operation is preferred as it performs both
             * operations in an atomic manner*
             * @param  {...Object} items The item(s) to remove.
             */

          }, {
            key: "remove",
            value: function remove() {
              for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                items[_key2] = arguments[_key2];
              }

              if (items.length === 1) {
                this.splice.apply(this, [0].concat(items));
              } else {
                this.splice(0, items);
              }
            }
            /**
             * Moves an individual item to another location.
             * @param {Object} item The item to move.
             * @param {Object} [beforeItem] the item to insert the first item before. If omitted, the `item`
             * is moved to the end of the Collection.
             * @returns {Number} The new index of the `item`.
             */

          }, {
            key: "move",
            value: function move(item, beforeItem) {
              var me = this,
                  _values = me._values,
                  itemIndex = me.indexOf(item, true);
              var beforeIndex = beforeItem ? me.indexOf(beforeItem, true) : _values.length;

              if (itemIndex === -1 || beforeIndex === -1) {
                throw new Error('Collection move parameters must be present in Collection');
              }

              if (itemIndex !== beforeIndex && itemIndex !== beforeIndex - 1) {
                if (itemIndex < beforeIndex) {
                  beforeIndex--;
                }

                _values.splice(itemIndex, 1);

                _values.splice(beforeIndex, 0, item);

                me._indicesInvalid = true;
                me.trigger('change', {
                  action: 'move',
                  item: item,
                  from: itemIndex,
                  to: beforeIndex
                });
              }

              return beforeIndex;
            }
            /**
             * The core data set mutation method. Removes and adds at the same time. Analogous
             * to the `Array` `splice` method.
             *
             * Note that if items that are specified for removal are also in the `toAdd` array,
             * then those items are *not* removed then appended. They remain in the same position
             * relative to all remaning items.
             *
             * @param {Number} index Index at which to remove a block of items. Only valid if the
             * second, `toRemove` argument is a number.
             * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
             * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
             * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
             */

          }, {
            key: "splice",
            value: function splice() {
              var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
              var toRemove = arguments.length > 1 ? arguments[1] : undefined;

              for (var _len3 = arguments.length, toAdd = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
                toAdd[_key3 - 2] = arguments[_key3];
              }

              var me = this,
                  idProperty = me.idProperty,
                  values = me._values,
                  newIds = {},
                  removed = [],
                  replaced = [],
                  oldCount = me.totalCount;
              var added, mutated; // Create an "newIds" map of the new items so remove ops know if it's really a replace
              // {
              //     1234 : true
              // }
              // And an "added" array of the items that need adding (there was not already an entry for the id)
              //

              if (toAdd) {
                if (toAdd.length === 1 && Array.isArray(toAdd[0])) {
                  toAdd = toAdd[0];
                } // Check for replacements if we contain any data


                if (oldCount && toAdd.length) {
                  // Only risk rebuilding the indices if we are adding
                  var idIndex = me.indices[idProperty];
                  added = [];

                  for (var i = 0; i < toAdd.length; i++) {
                    var newItem = toAdd[i],
                        id = safeIndexKey(newItem[idProperty]),
                        existingIndex = idIndex[id]; // Register incoming id so that removal leaves it be

                    newIds[id] = true; // Incoming id is already present.
                    // Replace it in place.

                    if (existingIndex != null) {
                      // If incoming is the same object, it's a no-op
                      if (values[existingIndex] !== newItem) {
                        replaced.push([values[existingIndex], newItem]);
                        values[existingIndex] = newItem;
                      }
                    } else {
                      added.push(newItem);
                    }
                  }
                } // Empty Collection, we simply add what we're passed
                else {
                    added = toAdd;
                  }
              }

              if (toRemove) {
                // We're removing a chunk starting at index
                if (typeof toRemove === 'number') {
                  for (var removeIndex = index; toRemove; --toRemove) {
                    var _id = safeIndexKey(values[removeIndex][idProperty]); // If the entry here is being replaced, skip the insertion index past it


                    if (newIds[_id]) {
                      index++;
                      removeIndex++;
                    } // If the id is not among incoming items, remove it
                    else {
                        removed.push(values[removeIndex]);
                        values.splice(removeIndex, 1);
                        me._indicesInvalid = mutated = true;
                      }
                  }
                } // We are removing an item/items
                else {
                    var contiguous = added.length === 0,
                        lastIdx;

                    if (!Array.isArray(toRemove)) {
                      toRemove = [toRemove];
                    } // Create array of index points to remove.
                    // They must be in reverse order so that removal leaves following remove indices stable


                    var removeIndices = toRemove.reduce(function (result, item) {
                      var isNumeric = typeof item === 'number',
                          idx = isNumeric ? item : me.indexOf(item, true); // Drop out of contiguous mode if we find a non-contiguous record, or a remove *index*

                      if (contiguous && (lastIdx != null && idx !== lastIdx + 1 || isNumeric)) {
                        contiguous = false;
                      } // Do not include indices out of range in our removeIndices


                      if (idx >= 0 && idx < oldCount) {
                        result.push(idx);
                      }

                      lastIdx = idx;
                      return result;
                    }, []).sort(reverseNumericSortFn); // If it's a pure remove of contiguous items with no adds, fast track it.

                    if (contiguous) {
                      // If reduced to zero by being asked to remove items we do not contain
                      // then this is a no-op
                      if (removeIndices.length) {
                        removed.push.apply(removed, toRemove);
                        values.splice(removeIndices[removeIndices.length - 1], removeIndices.length);
                        me._indicesInvalid = mutated = true;
                      }
                    } else {
                      // Loop through removeIndices splicing each index out of the values
                      // unless there's an incoming identical id.
                      for (var _i = 0; _i < removeIndices.length; _i++) {
                        var _removeIndex = removeIndices[_i];

                        if (_removeIndex !== -1) {
                          var _id2 = safeIndexKey(values[_removeIndex][idProperty]); // If the id is not among incoming items, remove it


                          if (!newIds[_id2]) {
                            removed.unshift(values[_removeIndex]);
                            values.splice(_removeIndex, 1);
                            me._indicesInvalid = mutated = true;
                          }
                        }
                      }
                    }
                  }
              } // If we collected genuinely new entries, insert them at the splice index


              if (added.length) {
                values.splice.apply(values, [Math.min(index, values.length), 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default()(added)));
                me._indicesInvalid = mutated = true;
              } // Ensure order of values matches the sorters


              if (me.isSorted) {
                me.onSortersChanged();
              } // The sort will also recreate the filteredValues so that it can be in correct sort order
              else if (me.isFiltered) {
                  if (me.autoFilter) {
                    me.onFiltersChanged();
                  } else {
                    var _me$_filteredValues;

                    (_me$_filteredValues = me._filteredValues).push.apply(_me$_filteredValues, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_2___default()(added));
                  }
                } // If we either added or removed items, or we did an in-place replace operation
              // then inform all interested parties.


              if (mutated || replaced.length) {
                // Indicate to obervers that data has changed.
                me.generation++;
                /**
                 * Fired when items are added, replace or removed
                 * @event change
                 * @param {String} action The underlying operation which caused data change.
                 * May be `'splice'` (meaning an atomic add/remove operation, `'sort'` or `'filter'`)
                 * @param {Common.util.Collection} source This Collection.
                 * @param {Object[]} removed An array of removed items.
                 * @param {Object[]} added An array of added items.
                 * @param {Object[]} replaced An array of replacements, each entry of which contains `[oldValue, newValue]`.
                 * @param {Number} oldCount The number of items in the full, untiltered collection prior to the splice operation.
                 */

                me.trigger('change', {
                  action: 'splice',
                  removed: removed,
                  added: added,
                  replaced: replaced,
                  oldCount: oldCount
                });
              } else {
                /**
                 * Fired when a {@link #function-splice} operation is requested but the operation
                 * is a no-op and has caused no change to this Collection's dataset. The splice
                 * method's parameters are passed for reference.
                 * @event noChange
                 * @param {Number} index Index at which to remove a block of items.
                 * @param {Object[]|Number} [toRemove] Either the number of items to remove starting
                 * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
                 * @param  {Object[]|Object} [toAdd] An item, or an array of items to add.
                 */
                me.trigger('noChange', {
                  index: index,
                  toRemove: toRemove,
                  toAdd: toAdd
                });
              }
            }
            /**
             * Change the id of an existing member by mutating its {@link #config-idProperty}.
             * @param {String|Number|Object} item The item or id of the item to change.
             * @param {String|Number} newId The id to set in the existing member.
             */

          }, {
            key: "changeId",
            value: function changeId(item, newId) {
              var me = this,
                  idProperty = me.idProperty,
                  oldId = keyTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default()(item)] ? item : item[idProperty],
                  member = me.get(oldId);

              if (member) {
                var existingMember = me.get(newId);

                if (existingMember && member !== existingMember) {
                  throw new Error("Attempt to set item ".concat(oldId, " to already existing member's id ").concat(newId));
                }

                member[idProperty] = newId; // If indices are valid, keep the id index correct

                if (!me._indicesInvalid) {
                  var idIndex = me.indices.id,
                      memberIndex = idIndex[oldId];
                  delete idIndex[oldId];
                  idIndex[newId] = memberIndex;
                }
              }
            }
            /**
             * Returns the item with the passed `id`. By default, filtered are honoured, and
             * if the item with the requested `id` is filtered out, nothing will be returned.
             *
             * To return the item even if it has been filtered out, pass the second parameter as `true`.
             * @param {*} id The `id` to find.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
             * @returns {Object} The found item, or `undefined`.
             */

          }, {
            key: "get",
            value: function get(id) {
              var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              return this.getBy(this.idProperty, id, ignoreFilters);
            }
          }, {
            key: "getAt",
            value: function getAt(index) {
              var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

              if (this.isFiltered && !ignoreFilters) {
                return this._filteredValues[index];
              } else {
                return this._values[index];
              }
            }
            /**
             * Returns the item with passed property name equal to the passed value. By default,
             * filtered are honoured, and if the item with the requested `id` is filtered out,
             * nothing will be returned.
             *
             * To return the item even if it has been filtered out, pass the third parameter as `true`.
             * @param {String} propertyName The property to test.
             * @param {*} value The value to find.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to return an item even if it is filtered out.
             * @returns {Object} The found item, or `undefined`.
             */

          }, {
            key: "getBy",
            value: function getBy(propertyName, value) {
              var ignoreFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this;

              if (me.isFiltered && ignoreFilters) {
                var index = me.findIndex(propertyName, value, true);

                if (index !== -1) {
                  return me._values[index];
                }
              } else {
                var _index = me.findIndex(propertyName, value);

                if (_index !== -1) {
                  return me.values[_index];
                }
              }
            }
            /**
             * The number of items in this collection. Note that this honours filtering.
             * See {@link #property-totalCount};
             * @property {Number}
             * @readonly
             */

          }, {
            key: "addSorter",

            /**
             * Adds a Sorter to the Collection of Sorters which are operating on this Collection.
             *
             * A Sorter may be an specified as an instantiated {@link Common.util.CollectionSorter
             * CollectionSorter}, or a config object for a CollectionSorter of the form
             *
             *     {
             *         property  : 'age',
             *         direction : 'desc'
             *     }
             *
             * Note that by default, a Sorter *replaces* a Sorter with the same `property` to make
             * it easy to change existing Sorters. A Sorter's `id` is its `property` by default. You
             * can avoid this and add multiple Sorters for one property by configuring Sorters with `id`s.
             *
             * A Sorter may also be specified as a function which compares two objects eg:
             *
             *     (lhs, rhs) => lhs.customerDetails.age - rhs.customerDetails.age
             *
             * @param {Object} sorter A Sorter of Sorter configuration object to add to the Collection
             * of Sorters operating on this Collection.
             * @returns {Common.util.CollectionSorter} The resulting Sorter to make it easy to remove Sorters.
             */
            value: function addSorter(sorter) {
              var result = sorter instanceof _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_21__["default"] ? sorter : new _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_21__["default"](sorter);
              this.sorters.add(result);
              return result;
            }
            /**
             * A flag which is `true` if this Collection has active {@link #property-sorters}.
             * @property {Boolean}
             * @readonly
             */

          }, {
            key: "onSortersChanged",
            value: function onSortersChanged() {
              var me = this;
              delete me._sortFunction;

              me._values.sort(me.sortFunction);

              me._indicesInvalid = true;
              me.trigger('change', sortEvent);
            }
            /**
             * A sorter function which encapsulates the {@link Common.util.CollectionSorter Sorters}
             * for this Collection.
             * @property {Function}
             * @readonly
             */

          }, {
            key: "addFilter",

            /**
             * Adds a Filter to the Collection of Filters which are operating on this Collection.
             *
             * A Filter may be an specified as an instantiated {@link Common.util.CollectionFilter
             * CollectionFilter}, or a config object for a CollectionFilter of the form
             *
             *     {
             *         property : 'age',
             *         operator : '>=',
             *         value    : 21
             *     }
             *
             * Note that by default, a Filter *replaces* a Filter with the same `property` to make
             * it easy to change existing Filters. A Filter's `id` is its `property` by default. You
             * can avoid this and add multiple Filters for one property by configuring Filters with `id`s.
             *
             * A Filter may also be specified as a function which filters candidate objects eg:
             *
             *     candidate => candidate.customerDetails.age >= 21
             *
             * @param {Object} filter A Filter or Filter configuration object to add to the Collection
             * of Filters operating on this Collection.
             * @returns {Common.util.CollectionFilter} The resulting Filter to make it easy to remove Filters.
             */
            value: function addFilter(filter) {
              var result = filter instanceof _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_20__["default"] ? filter : new _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_20__["default"](filter);
              this.filters.add(result);
              return result;
            }
            /**
             * A flag which is `true` if this Collection has active {@link #property-filters}.
             * @property {Boolean}
             * @readonly
             */

          }, {
            key: "onFiltersChanged",
            value: function onFiltersChanged() {
              var me = this;
              me._filterFunction = null;
              me._filteredValues = me._values.filter(me.filterFunction);
              me._indicesInvalid = true;
              me.trigger('change', filterEvent);
            }
            /**
             * A filter function which encapsulates the {@link Common.util.CollectionFilter Filters}
             * for this Collection.
             * @property {Function}
             * @readonly
             */

          }, {
            key: "addIndex",

            /**
             * Adds a lookup index for the passed property name. The index is built lazily when
             * an index is serched,
             * @internal
             * @param {String} indexProperty The property name to add an index for.
             */
            value: function addIndex(indexProperty) {
              (this._indices || (this._indices = {}))[indexProperty] = {}; // Indices need a rebuild now.

              this._indicesInvalid = true;
              /**
               * this.indices is keyed by the property name, and contains the keys linked to the index in the _values array.
               * So collection.add({id : foo, name : 'Nige'}, {id : 'bar', name : 'Faye'}) where collection has had an index
               * added for the "name" property would result in:
               *
               * {
               *     id : {
               *         foo : 0,
               *         bar : 1
               *     },
               *     name : {
               *         Nige : 0,
               *         Faye : 1
               *     }
               * }
               */
            }
            /**
             * Return the index of the item with the specified key having the specified value.
             * By default, filtering is taken into account and this returns the index in the filtered
             * dataset if present. To bypass this, pass the third parameter as `true`.
             * @param {String} propertyName The name of the property to test.
             * @param {*} value The value to test for.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to return the index in
             * the original data set if the item is filtered out.
             * @returns {Number} The index of the item, or `-1` if not found.
             */

          }, {
            key: "findIndex",
            value: function findIndex(propertyName, value) {
              var ignoreFilters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  isFiltered = me.isFiltered,
                  index = isFiltered && !ignoreFilters ? me.indices[filteredIndicesProperty][propertyName] : me.indices[propertyName];

              if (index) {
                var itemIndex = index[safeIndexKey(value)];

                if (itemIndex != null) {
                  return itemIndex;
                }
              } else {
                // Search the filtered values if we are filtered and not ignoreing filters
                var values = isFiltered && !ignoreFilters ? me._filteredValues : me._values,
                    count = values.length;

                for (var i = 0; i < count; i++) {
                  if (values[i][propertyName] == value) {
                    return i;
                  }
                }
              } // Not found


              return -1;
            }
            /**
             * Returns the index of the item with the same `id` as the passed item.
             *
             * By default, filtering is honoured, so if the item in question has been added,
             * but is currently filtered out of visibility, `-1` will be returned.
             *
             * To find the index in the master, unfiltered dataset, pass the second parameter as `true`;
             * @param {Object|String|Number} item The item to find, or an `id` to find.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
             * @returns {Number} The index of the item, or `-1` if not found.
             */

          }, {
            key: "indexOf",
            value: function indexOf(item) {
              var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              return this.findIndex(this.idProperty, keyTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_10___default()(item)] ? item : item[this.idProperty], ignoreFilters);
            }
            /**
             * Returns `true` if this Collection includes an item with the same `id` as the passed item.
             *
             * By default, filtering is honoured, so if the item in question has been added,
             * but is currently filtered out of visibility, `false` will be returned.
             *
             * To query inclusion in the master, unfiltered dataset, pass the second parameter as `true`;
             * @param {Object|String|Number} item The item to find, or an `id` to find.
             * @param {Boolean} [ignoreFilters=false] Pass `true` to find the index in the master, unfiltered data set.
             * @returns {Boolean} True if the passed item is found.
             */

          }, {
            key: "includes",
            value: function includes(item) {
              var ignoreFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              return this.indexOf(item, ignoreFilters) !== -1;
            }
          }, {
            key: "rebuildIndices",

            /**
             * Called when the Collection is mutated and the indices have been flagged as invalid.
             *
             * Rebuilds the indices object to allow lookup by keys.
             * @internal
             */
            value: function rebuildIndices() {
              var me = this,
                  isFiltered = me.isFiltered,
                  indices = me._indices || (me._indices = {}),
                  keyProps = Object.keys(indices),
                  indexCount = keyProps.length,
                  values = me._values,
                  count = values.length;
              var i, j; // First, clear indices.

              if (isFiltered) {
                indices[filteredIndicesProperty] = {};
              }

              for (i = 0; i < indexCount; i++) {
                indices[keyProps[i]] = {};

                if (isFiltered) {
                  indices[filteredIndicesProperty][keyProps[i]] = {};
                }
              }
              /*
               * Rebuild the indices object.
               * Loop through all items adding an entry for each one to each index.
               * So collection.add({id : foo, name : 'Nige'}, {id : 'bar', name : 'Faye'}) where collection has had an index
               * added for the "name" property would result in:
               *
               * {
               *     id : {
               *         foo : 0,
               *         bar : 1
               *     },
               *     name : {
               *         Nige : 0,
               *         Faye : 1
               *     }
               * }
               */


              for (i = 0; i < count; i++) {
                var item = values[i];

                for (j = 0; j < indexCount; j++) {
                  var keyProp = keyProps[j]; // This does indices.name['Nige'] = 0

                  indices[keyProp][safeIndexKey(item[keyProp])] = i;
                }
              } // Create a parallel lookup structure into the _filteredValues


              if (isFiltered) {
                var _values2 = me._filteredValues,
                    _count = _values2.length,
                    _indices = me._indices[filteredIndicesProperty];

                for (i = 0; i < _count; i++) {
                  var _item = _values2[i];

                  for (j = 0; j < indexCount; j++) {
                    var _keyProp = keyProps[j]; // This does indices[filteredIndicesProperty].name['Nige'] = 0

                    _indices[_keyProp][safeIndexKey(_item[_keyProp])] = i;
                  }
                }
              }

              me._indicesInvalid = false;
            }
          }, {
            key: "isCollection",
            get: function get() {
              return true;
            }
          }, {
            key: "values",
            set: function set(values) {
              this.splice(0, this._values.length, values);
            }
            /**
             * The set of values of this Collection. If this Collection {@link #property-isFiltered},
             * this yields the filtered data set.
             *
             * Setting this property replaces the data set.
             * @property {Object[]}
             */
            ,
            get: function get() {
              return this.isFiltered ? this._filteredValues : this._values;
            }
          }, {
            key: "first",
            get: function get() {
              return this.values[0];
            }
          }, {
            key: "last",
            get: function get() {
              return this.values[this.count - 1];
            }
            /**
             * The set of all values of this Collection regardless of filters applied.
             * @readonly
             * @property {Object[]}
             */

          }, {
            key: "allValues",
            get: function get() {
              return this._values;
            }
          }, {
            key: "count",
            get: function get() {
              return this.values.length;
            }
            /**
             * The number of items in this collection regardless of filtering.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "totalCount",
            get: function get() {
              return this._values.length;
            }
          }, {
            key: "idProperty",
            set: function set(idProperty) {
              this._idProperty = idProperty;
              this.addIndex(idProperty);
            }
            /**
             * The property name used to extract item `id`s from added objects.
             * @property {String}
             */
            ,
            get: function get() {
              return this._idProperty;
            }
          }, {
            key: "extraKeys",
            set: function set(extraKeys) {
              if (!Array.isArray(extraKeys)) {
                extraKeys = [extraKeys];
              }

              for (var i = 0; i < extraKeys.length; i++) {
                this.addIndex(extraKeys[i]);
              }
            }
            /**
             * The Collection of {@link Common.util.CollectionSorter Sorters} for this Collection.
             * @property {Common.util.Collection}
             * @readonly
             */

          }, {
            key: "sorters",
            get: function get() {
              if (!this._sorters) {
                this._sorters = new Collection({
                  listeners: {
                    change: 'onSortersChanged',
                    thisObj: this
                  }
                });
              }

              return this._sorters;
            }
          }, {
            key: "isSorted",
            get: function get() {
              return Boolean(this._sorters && this._sorters.count);
            }
          }, {
            key: "sortFunction",
            get: function get() {
              if (!this._sortFunction) {
                if (this.isSorted) {
                  this._sortFunction = _CollectionSorter_js__WEBPACK_IMPORTED_MODULE_21__["default"].generateSortFunction(this.sorters.values);
                } else {
                  this._sortFunction = return0;
                }
              }

              return this._sortFunction;
            }
            /**
             * The Collection of {@link Common.util.CollectionFilter Filters} for this Collection.
             * @property {Common.util.Collection}
             * @readonly
             */

          }, {
            key: "filters",
            get: function get() {
              if (!this._filters) {
                this._filters = new Collection({
                  listeners: {
                    change: 'onFiltersChanged',
                    thisObj: this
                  }
                });
              }

              return this._filters;
            }
          }, {
            key: "isFiltered",
            get: function get() {
              return Boolean(this._filters && this._filters.count);
            }
          }, {
            key: "filterFunction",
            get: function get() {
              if (!this._filterFunction) {
                if (this.isFiltered) {
                  this._filterFunction = _CollectionFilter_js__WEBPACK_IMPORTED_MODULE_20__["default"].generateFiltersFunction(this.filters.values);
                } else {
                  this._filterFunction = _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].returnTrue;
                }
              }

              return this._filterFunction;
            }
          }, {
            key: "indices",
            get: function get() {
              if (this._indicesInvalid) {
                this.rebuildIndices();
              }

              return this._indices;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Specify the name of the property of added objects which provides the lookup key
                 * @config {String}
                 * @default
                 */
                idProperty: 'id',

                /**
                 * Specify the names of properties which are to be indexed for fast lookup.
                 * @config {String[]}
                 */
                extraKeys: null,

                /**
                 * Automatically apply filters on item add.
                 * @config {String[]}
                 * @default
                 */
                autoFilter: true
              };
            }
          }]);

          return Collection;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_19__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_18__["default"])); // These are used by Bag for the same purpose


        Collection._$name = 'Collection';
        /***/
      },

      /***/
      "../Grid/lib/Common/util/CollectionFilter.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/util/CollectionFilter.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonUtilCollectionFilterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CollectionFilter;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.ends-with */
        "../Grid/node_modules/core-js/modules/es6.string.ends-with.js");
        /* harmony import */


        var core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "../Grid/node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/util/CollectionFilter
         */

        /**
         * A class which encapsulates a single filter operation which may be applied to any object to decide whether to
         * include or exclude it from a set.
         *
         * A CollectionFilter generally has at least three main properties:
         *
         * * `property` - The name of a property in candidate objects from which to extract the value to test
         * * `value` - The value which  this filter uses to test against.
         * * `operator` - The comparison operator, eg: `'='` or `'>'` etc.
         *
         * Given these three essential values, further configurations may affect how the filter is applied:
         *
         * * `caseSensitive` - If configured as `false`, string comparisons are case insensitive.
         * * `convert` - A function which, when passed the extracted value from the candidate object, returns the value to test.
         *
         * A filter may also be configured with a single `filterBy` property. This function is just passed the raw
         * candidate object and must return `true` or `false`.
         *
         * A CollectionFilter may be configured to encapsulate a single filtering function by passing that function as the sole
         * parameter to the constructor:
         *
         *     new CollectionFilter(candidate => candidate.title.contains('search string'));
         *
         */

        var CollectionFilter =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(CollectionFilter, _Base);

          function CollectionFilter() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, CollectionFilter);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(CollectionFilter).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(CollectionFilter, [{
            key: "construct",
            value: function construct(config) {
              if (typeof config === 'function') {
                config = {
                  filterBy: config
                };
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(CollectionFilter.prototype), "construct", this).call(this, config);
            }
            /**
             * When in a Collection (A Collection holds its Filters in a Collection), we need an id.
             * @property {String}
             * @private
             */

          }, {
            key: "onChange",
            value: function onChange(propertyChanged) {
              var me = this; // Inform any owner (eg a Store), that it has to reassess its CollectionFilters

              if (!me.isConfiguring && me.owner && !me.owner.isConfiguring && me.owner.onFilterChanged) {
                me.owner.onFilterChanged(me, propertyChanged);
              }
            }
          }, {
            key: "defaultFilterBy",
            value: function defaultFilterBy(candidate) {
              return this[this.operator](this.convert(candidate[this.property]));
            }
            /**
             * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
             * @type {String}
             */

          }, {
            key: "convert",
            value: function convert(value) {
              return !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value;
            }
          }, {
            key: "filter",
            value: function filter(candidate) {
              return this.filterBy(candidate);
            }
          }, {
            key: "startsWith",
            value: function startsWith(v) {
              return String(v).startsWith(this.value);
            }
          }, {
            key: "endsWith",
            value: function endsWith(v) {
              return String(v).endsWith(this.value);
            }
          }, {
            key: '=',
            value: function _(v) {
              return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEqual(v, this.value);
            }
          }, {
            key: '!=',
            value: function _(v) {
              return !_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEqual(v, this.value);
            }
          }, {
            key: '>',
            value: function _(v) {
              return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isMoreThan(v, this.value);
            }
          }, {
            key: '>=',
            value: function _(v) {
              return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isMoreThan(v, this.value) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEqual(v, this.value);
            }
          }, {
            key: '<',
            value: function _(v) {
              return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isLessThan(v, this.value);
            }
          }, {
            key: '<=',
            value: function _(v) {
              return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isLessThan(v, this.value) || _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEqual(v, this.value);
            }
          }, {
            key: '*',
            value: function _(v) {
              return _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isPartial(v, this.value);
            } // Accepts an array or a Collection

          }, {
            key: "id",
            get: function get() {
              return this._id || (this._id = this.property || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].generateId('b-filter'));
            },
            set: function set(id) {
              this._id = id;
            }
          }, {
            key: "filterBy",
            get: function get() {
              return this._filterBy || this.defaultFilterBy;
            }
            /**
             * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
             * accepts a candidate object and returns `true` or `false`
             * @type {Function}
             */
            ,
            set: function set(filterBy) {
              this._filterBy = filterBy;
            }
          }, {
            key: "property",
            set: function set(property) {
              this._property = property; // Signal to owner about filter change

              this.onChange('property');
            },
            get: function get() {
              return this._property;
            }
            /**
             * The value against which to compare the {@link #config-property} of candidate objects.
             * @type {*}
             */

          }, {
            key: "value",
            set: function set(value) {
              this._value = !this.caseSensitive && typeof value === 'string' ? value.toLowerCase() : value; // Signal to owner about filter change

              this.onChange('value');
            },
            get: function get() {
              return this._value;
            }
            /**
             * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
             * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`
             * @type {String}
             */

          }, {
            key: "operator",
            set: function set(operator) {
              this._operator = operator; // Signal to owner about filter change

              this.onChange('operator');
            },
            get: function get() {
              return this._operator || (typeof this.value === 'string' ? '*' : '=');
            }
          }], [{
            key: "generateFiltersFunction",
            value: function generateFiltersFunction(filters) {
              if (!filters || !filters.length && !filters.count) {
                return _helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].returnTrue;
              }

              return function (candidate) {
                var match = true;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var filter = _step.value; // Skip disabled filters

                    if (!filter.disabled) {
                      match = filter.filter(candidate);
                    }

                    if (!match) {
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                return match;
              };
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The name of a property of candidate objects which yields the value to compare against this CollectionFilter's {@link #config-value}.
                 * @config {String}
                 */
                property: null,

                /**
                 * The value against which to compare the {@link #config-property} of candidate objects.
                 * @config {*}
                 */
                value: null,

                /**
                 * The operator to use when comparing a candidate object's {@link #config-property} with this CollectionFilter's {@link #config-value}.
                 * May be: `'='`, `'!='`, `'>'`, `'>='`, `'<'`, `'<='`, `'*'`, `'startsWith'`, `'endsWith'`
                 * @config {String}
                 */
                operator: null,

                /**
                 * May be used in place of the {@link #config-property}, {@link #config-value} and {@link #config-property} configs. A function which
                 * accepts a candidate object and returns `true` or `false`
                 * @config {Function}
                 */
                filterBy: null,

                /**
                 * A function which accepts a value extracted from a candidate object using the {@link #config-property} name, and
                 * returns the value which the filter should use to compare against its {@link #config-value}.
                 * @config {Function}
                 */
                convert: null,

                /**
                 * Configure as `false` to have string comparisons case insensitive.
                 * @config {Boolean}
                 */
                caseSensitive: true,

                /**
                 * The `id` of this Filter for when used by a {@link Common.util.Collection} Collection.
                 * By default the `id` is the {@link #config-property} value.
                 * @config {String}
                 */
                id: null
              };
            }
          }]);

          return CollectionFilter;
        }(_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]);

        CollectionFilter._$name = 'CollectionFilter';
        /***/
      },

      /***/
      "../Grid/lib/Common/util/CollectionSorter.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Common/util/CollectionSorter.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonUtilCollectionSorterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CollectionSorter;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/util/CollectionSorter
         */

        /**
         * A class which encapsulates a single sorter operation which may be applied to any object to decide whether to
         * include or exclude it from a set.
         *
         * A CollectionSorter generally has two properties:
         *
         * * `property` - The name of a property in collection objects by which to sort
         * * `direction` - The sort direction, `'ASC'` or `'DESC'`.
         *
         * It may also be configured with just a {@link #config-sortFn} function which returns the desired comparison
         * result when passed two objects to compare. Note that this does *not* require or use the
         * {@link #config-property} config. Two collection items are passed for comparison.
         *
         * Further configurations may affect how the sorter is applied:
         *
         * * `convert` - A function which, when passed the {@link #config-property} value from
         * a collection object, returns the value to sort by.
         *
         * A CollectionSorter may be configured to encapsulate a {@link #config-sortFn} by passing that function as the sole
         * parameter to the constructor:
         *
         *     new CollectionSorter((lhs, rhs) => {
         *         lhs = lhs.customerDetails.companyName.toLowerCase();
         *         rhs = rhs.customerDetails.companyName.toLowerCase();
         *
         *         if (lhs < rhs) {
         *             return -1;
         *         }
         *         else if (lhs > rhs) {
         *             return 1;
         *         }
         *         else {
         *             return 0;
         *         }
         *     });
         *
         */

        var CollectionSorter =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(CollectionSorter, _Base);

          function CollectionSorter() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, CollectionSorter);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(CollectionSorter).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(CollectionSorter, [{
            key: "construct",
            value: function construct(config) {
              if (typeof config === 'function') {
                config = {
                  sortFn: config
                };
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(CollectionSorter.prototype), "construct", this).call(this, config);
            }
            /**
             * When in a Collection (A Collection holds its Sorters in a Collection), we need an id.
             * @property {String}
             * @private
             */

          }, {
            key: "defaultSortFn",

            /**
             * Default sortFn used when no sortFn specified. Uses the {@link #config-property},
             * {@link #config-direction}, and {@link #config-convert}.
             * @private
            */
            value: function defaultSortFn(lhs, rhs) {
              var me = this,
                  convert = me.convert,
                  property = me.property,
                  useLocaleSort = me.useLocaleSort,
                  multiplier = me.direction.toLowerCase() === 'desc' ? -1 : 1;
              lhs = lhs[property];
              rhs = rhs[property];

              if (convert) {
                lhs = convert(lhs);
                rhs = convert(rhs);
              }

              if (useLocaleSort && lhs != null && rhs != null) {
                // Use systems locale
                if (useLocaleSort === true) {
                  return String(lhs).localeCompare(rhs);
                } // Use specified locale


                if (typeof useLocaleSort === 'string') {
                  return String(lhs).localeCompare(rhs, useLocaleSort);
                } // Use locale config


                if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(useLocaleSort) === 'object') {
                  return String(lhs).localeCompare(rhs, useLocaleSort.locale, useLocaleSort);
                }
              }

              return (lhs > rhs ? 1 : lhs < rhs ? -1 : 0) * multiplier;
            }
          }, {
            key: "id",
            get: function get() {
              return this._id || (this._id = this.property || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].generateId('b-sorter'));
            },
            set: function set(id) {
              this._id = id;
            }
          }, {
            key: "sortFn",
            set: function set(sortFn) {
              this._sortFn = sortFn;
            },
            get: function get() {
              if (this._sortFn) {
                return this._sortFn;
              }

              return this.defaultSortFn;
            }
          }], [{
            key: "generateSortFunction",
            value: function generateSortFunction(sorters, tieBreaker) {
              var items = sorters.isCollection ? sorters.values : sorters,
                  n = items.length;
              return function (lhs, rhs) {
                var comp, i;

                for (i = 0; i < n; ++i) {
                  comp = items[i].sortFn(lhs, rhs);

                  if (comp) {
                    return comp;
                  }
                }

                return tieBreaker ? tieBreaker(lhs, rhs) : 0;
              };
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The name of a property of collection objects which yields the value to sort by.
                 * @config {String}
                 */
                property: null,

                /**
                 * The direction to sort in, `'ASC'` or `'DESC'`
                 * @config {String}
                 * @default
                 */
                direction: 'ASC',

                /**
                 * A function which takes the place of using {@link #config-property} and {@link #config-direction}.
                 * The function is passed two objects from the collection to compare andmiust return the comparison result.
                 * @config {Function}
                 */
                sortFn: null,

                /**
                 * When using {@link #config-property}, this may be specified as a function which takes the raw
                 * property value and returns the value to actually sort by.
                 * @config {Function}
                 */
                convert: null,

                /**
                 * The `id` of this Sorter for when used by a {@link Common.util.Collection} Collection.
                 * By default the `id` is the {@link #config-property} value.
                 * @config {String}
                 */
                id: null,

                /**
                 * Use `localeCompare()` when sorting, which lets the browser sort in a locale specific order. Set to `true`,
                 * a locale string or a locale config to enable.
                 *
                 * Enabling this has big negative impact on sorting
                 * performance. For more info on `localeCompare()`, see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/localeCompare).
                 *
                 * ```javascript
                 * collection.addSorter({ field: 'name', useLocaleSort : 'sv-SE' });
                 * ```
                 *
                 * @config {Boolean|String|Object}
                 * @default false
                 */
                useLocaleSort: null
              };
            }
          }]);

          return CollectionSorter;
        }(_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        CollectionSorter._$name = 'CollectionSorter';
        /***/
      },

      /***/
      "../Grid/lib/Common/util/Month.js":
      /*!****************************************!*\
        !*** ../Grid/lib/Common/util/Month.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonUtilMonthJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Month;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ../localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/util/Month
         */

        /**
         * A class which encapsulates a calendar view of a month, and offers information about 
         * the weeks and days within that calendar view.
         * ```
         *   const m = new Month({
         *       date         : '2018-12-01',
         *       weekStartDay : 1
         *   }) // December 2018 using Monday as week start
         *   m.eachWeek((week, dates) => console.log(dates.map(d => d.getDate())))
         * ```
         */

        var Month =
        /*#__PURE__*/
        function () {
          /**
           * Constructs a Month from a config object which *must* contain a `date` property.
           * @param {Object} config An object containing initialization properties.
           * @param {Date|String|Number} config.date The date which the month should encapsulate. May be
           * a `Date` object, or a value, which, when passed to the `Date` constructor yields a
           * valid `Date` object. Mutating a passed `Date` after initializing a `Month` object
           * has no effect on the `Month` object.
           * @param {Number} [config.weekStartDay] Optional. Week start day override. Defaults to the
           * locale's {@link Common.helper.DateHelper#property-weekStartDay-static}.
           * @param {Boolean} [config.sixWeeks] Optional. Pass `true` to always have the month encapsulate six weeks.
           * This is ueful for UIs which must be a fixed height.
           * @function constructor
           */
          function Month(config) {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Month);

            var date = config.date,
                weekStartDay = config.weekStartDay,
                sixWeeks = config.sixWeeks;
            this.constructor.updateDayNumbers(weekStartDay);
            this.sixWeeks = sixWeeks;
            this.date = date;
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Month, [{
            key: "eachDay",

            /**
             * Iterates through all calendar cells in this month, calling the passed function
             * for each date.
             * @param {Function} fn The function to call.
             * <h4>Parameters</h4>
             *  - date [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) The date for the cell.
             */
            value: function eachDay(fn) {
              var me = this;

              for (var dayOfMonth = me.startDayOfMonth; dayOfMonth <= me.endDayOfMonth; dayOfMonth++) {
                fn(new Date(me.year, me.month, dayOfMonth));
              }
            }
            /**
             * Iterates through all weeks in this month, calling the passed function
             * for each week. The function is passed the following parameters:
             * @param {Function} fn The function to call.
             * <h4>Parameters</h4>
             *  - week [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) An array containing `[year, weekNumber]`.
             *  - date [Date[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) The dates for the week.
             */

          }, {
            key: "eachWeek",
            value: function eachWeek(fn) {
              var me = this,
                  weekCount = me.weekCount;

              for (var dayOfMonth = me.startDayOfMonth, week = 0; week < weekCount; week++) {
                var weekDates = [],
                    weekOfYear = me.getWeekNumber(new Date(me.year, me.month, Math.max(dayOfMonth, 1)));

                for (var day = 0; day < 7; day++, dayOfMonth++) {
                  weekDates.push(new Date(me.year, me.month, dayOfMonth));
                }

                fn(weekOfYear, weekDates);
              }
            }
          }, {
            key: "getWeekNumber",
            value: function getWeekNumber(date) {
              var me = this,
                  weekStartDay = me.weekStartDay;
              date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].clearTime(date); // If it's a date that our known year does not contain
              // create a new Month to find the answer.

              if (date < me.startDate || date > me.endDate) {
                return new Month({
                  date: date,
                  weekStartDay: weekStartDay
                }).getWeekNumber(date);
              }

              var weekNo = Math.floor((date - me.weekBase) / 86400000 / 7),
                  year = date.getFullYear(); // No week 0. It's the last week of last year

              if (!weekNo) {
                var lastDec31 = new Date(me.year, 0, 0); // Week is the week of last year's 31st Dec

                return new Month({
                  date: lastDec31,
                  weekStartDay: weekStartDay
                }).getWeekNumber(lastDec31);
              } // Only week 53 if year ends before our week's 5th day
              else if (weekNo === 53 && !me.has53weeks) {
                  weekNo = 1;
                  year++;
                } // Return array of year and week number


              return [year, weekNo];
            }
          }, {
            key: "date",
            set: function set(date) {
              if (!(date instanceof Date)) {
                date = new Date(date);

                if (isNaN(date)) {
                  throw new Error('Month constructor must be passed a Date, or a valid argument to the Date constructor');
                } // Edge parses YYYY-MM-DD as UTC, not local, so in other locales, the value
                // may end up not being 00:00:00 in the date, so remove any time zone offset.


                var tzo = date.getTimezoneOffset();

                if (tzo) {
                  date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].add(date, tzo, 'minute');
                }
              }

              var me = this,
                  monthStart = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getFirstDateOfMonth(date),
                  monthEnd = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].getLastDateOfMonth(monthStart),
                  startWeekDay = me.dayNumbers[monthStart.getDay()],
                  endWeekDay = me.dayNumbers[monthEnd.getDay()];

              me._date = date; // These comments assume ISO standard of Monday as week start day.
              //
              // This is the date of month that is the beginning of the first week row.
              // So this may be -ve. Eg: for Dec 2018, Monday 26th Nov is the first
              // cell on the calendar which is the -4th of December. Note that the 0th
              // of December was 31st of November, so needs -4 to get back to the 26th.

              me.startDayOfMonth = 1 - startWeekDay; // This is the date of month that is the end of the last week row.
              // So this may be > month end. Eg: for Dec 2018, Sunday 6th Jan is the last
              // cell on the calendar which is the 37th of December.

              me.endDayOfMonth = monthEnd.getDate() + (6 - endWeekDay);

              if (me.sixWeeks) {
                while (me.weekCount < 6) {
                  me.endDayOfMonth += 7;
                }
              }

              me.year = date.getFullYear();
              me.month = date.getMonth();
              var jan1 = new Date(me.year, 0, 1),
                  dec31 = new Date(me.year, 1, 31),
                  january = me.month ? new Month({
                date: jan1,
                weekStartDay: me.weekStartDay
              }) : me; // First 7 days are in last week of previous year if the year
              // starts after our 4th day of week.

              if (me.dayNumbers[jan1.getDay()] > 3) {
                // Week base is calculated from the year start
                me.weekBase = january.startDate;
              } // First 7 days are in week 1 of this year
              else {
                  // Week base is the start of week before
                  me.weekBase = new Date(me.year, 0, january.startDayOfMonth - 7);
                } // Our year only has a 53rd week if the year ends before our week's 5th day


              me.has53weeks = dec31.getDay() < 4;
            },
            get: function get() {
              return this._date;
            }
            /**
             * The number of days in the calendar for this month. This will always be
             * a multiple of 7, because this represents the number of calendar cells
             * occupied by this month.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "dayCount",
            get: function get() {
              // So for the example month, Dec 2018 has 42 days, from Mon 26th Nov (-4th Dec) 2018
              // to Sun 6th Jan (37th Dec) 2019
              return this.endDayOfMonth + 1 - this.startDayOfMonth;
            }
            /**
             * The number of weeks in the calendar for this month.
             * @property {Number}
             * @readonly
             */

          }, {
            key: "weekCount",
            get: function get() {
              return this.dayCount / 7;
            }
            /**
             * The date of the first cell in the calendar view of this month.
             * @property {Date}
             * @readonly
             */

          }, {
            key: "startDate",
            get: function get() {
              return new Date(this.year, this.month, this.startDayOfMonth);
            }
            /**
             * The date of the last cell in the calendar view of this month.
             * @property {Date}
             * @readonly
             */

          }, {
            key: "endDate",
            get: function get() {
              return new Date(this.year, this.month, this.endDayOfMonth);
            }
          }], [{
            key: "applyLocale",
            value: function applyLocale() {
              this.updateDayNumbers();
            }
          }, {
            key: "updateDayNumbers",
            value: function updateDayNumbers() {
              var weekStartDay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_3__["default"].weekStartDay;
              var me = this.prototype,
                  dayNumbers = me.dayNumbers = [],
                  canonicalDayNumbers = me.canonicalDayNumbers = [];
              me.weekStartDay = weekStartDay; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
              // have mapping of internal day number to canonical day number (as used by Date class)
              // and to abbreviated day name like this:
              // canonicalDayNumbers = [1, 2, 3, 4, 5, 6, 0] // Use for translation from our day number to Date class's day number
              // dayNumbers          = [6, 0, 1, 2, 3, 4, 5] // Use for translation from Date object's day number to ours

              for (var i = 0; i < 7; i++) {
                var canonicalDay = (weekStartDay + i) % 7;
                canonicalDayNumbers[i] = canonicalDay;
                dayNumbers[canonicalDay] = i;
              }
            }
          }]);

          return Month;
        }(); // Update when changing locale


        _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_2__["default"].on({
          locale: 'applyLocale',
          thisObj: Month
        });

        Month._$name = 'Month';
        /***/
      },

      /***/
      "../Grid/lib/Common/widget/BooleanCombo.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/widget/BooleanCombo.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetBooleanComboJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return BooleanCombo;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Combo_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Combo.js */
        "../Grid/lib/Common/widget/Combo.js");
        /* harmony import */


        var _data_Store_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        var productName = 'scheduler';
        /**
         * Boolean combo, a combo box with two options corresponding to true or false
         *
         * @classType booleancombo
         * @extends Common/widget/Combo
         */

        var BooleanCombo =
        /*#__PURE__*/
        function (_Localizable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(BooleanCombo, _Localizable);

          function BooleanCombo() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, BooleanCombo);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(BooleanCombo).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(BooleanCombo, [{
            key: "store",
            //endregion
            get: function get() {
              if (!this._store) {
                this.store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                  data: [{
                    id: this.positiveValue,
                    text: this.positiveText || this.L('Yes')
                  }, {
                    id: this.negativeValue,
                    text: this.negativeText || this.L('No')
                  }]
                });
              }

              return this._store;
            },
            set: function set(store) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(BooleanCombo.prototype), "store", store, this, true);
            }
          }], [{
            key: "type",
            get: function get() {
              return 'booleancombo';
            } //region Config

          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Positive option value
                 *
                 * @config {*}
                 */
                positiveValue: true,

                /**
                 * Positive option display value
                 *
                 * @config {String}
                 */
                positiveText: null,

                /**
                 * Negative option value
                 *
                 * @config {*}
                 */
                negativeValue: false,

                /**
                 * False option display value
                 *
                 * @config {String}
                 */
                negativeText: null,

                /**
                 * Default value
                 *
                 * @config {*}
                 */
                value: false
              };
            }
          }]);

          return BooleanCombo;
        }(Object(_Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_8__["default"])(_Combo_js__WEBPACK_IMPORTED_MODULE_6__["default"]));

        BooleanCombo._$name = 'BooleanCombo';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__["default"].register(BooleanCombo.type, BooleanCombo);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Button.js":
      /*!*******************************************!*\
        !*** ../Grid/lib/Common/widget/Button.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetButtonJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Button;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./mixin/Badge.js */
        "../Grid/lib/Common/widget/mixin/Badge.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default()(["\n            <button class=\"", " ", "\" ", ">\n                \xA0\n            </button>\n        "], ["\n            <button class=\"", " ", "\" ", ">\n                \\xa0\n            </button>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler'; //TODO: should togglebutton be own class implemented as input type=checkbox?
        //TODO: A toggling widget's focusElement should be an opacity:0 input type=checkbox which covers the clickable area.

        /**
         * @module Common/widget/Button
         */

        var bIcon = /^b-icon-/,
            bFa = /^b-fa-/;
        /**
         * Button widget, wraps and styles a regular <code>&lt;button&gt;</code> element. Can display text and icon and allows specifying button color.
         *
         * @extends Common/widget/Widget
         * @mixes Common/widget/mixin/Badge
         *
         * @example
         * // button with text and icon
         * let button = new Button({
         *   icon: 'b-fa-plus-circle',
         *   text: 'Add',
         *   color: 'green',
         *   onClick: () => {}
         * });
         *
         * @classType button
         * @externalexample widget/Button.js
         */

        var Button =
        /*#__PURE__*/
        function (_Badge) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Button, _Badge);

          function Button() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Button);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Button).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Button, [{
            key: "template",
            value: function template() {
              var me = this;
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].tpl(_templateObject(), me.color || '', me.toggleable && me.pressed ? 'b-pressed' : '', me.toggleGroup ? "data-group=\"".concat(me.toggleGroup, "\"") : '');
            } //endregion
            //region Construct/Destroy

          }, {
            key: "construct",
            value: function construct() {
              var _get2;

              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

              if (config.toggleGroup) {
                config.toggleable = true;
              }

              for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Button.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args));

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
                element: this.element,
                click: 'onInternalClick',
                thisObj: this
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.destroyProperties('menu');

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Button.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Getters/Setters

          }, {
            key: "onInternalClick",
            //endregion
            //region Events

            /**
             * Triggers events when user clicks button
             * @fires click
             * @fires action
             * @private
             */
            value: function onInternalClick(event) {
              var me = this,
                  bEvent = {
                event: event
              };

              if (me.toggleable) {
                // Clicking the pressed button in a toggle group should do nothing
                if (me.toggleGroup && me.pressed) {
                  return;
                }

                me.toggle(!me.pressed);
              }
              /**
               * User clicked button
               * @event click
               * @property {Common.widget.Button} button - Clicked button
               * @property {Event} event - DOM event
               */


              me.trigger('click', bEvent);
              /**
               * User performed the default action (clicked the button)
               * @event action
               * @property {Common.widget.Button} button - Clicked button
               * @property {Event} event - DOM event
               */
              // A handler may have resulted in destruction.

              if (!me.isDestroyed) {
                me.trigger('action', bEvent);
              } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction
              // stop the event since it has been handled


              event.preventDefault();
              event.stopPropagation();
            } //endregion
            //region Toggle

            /**
             * Toggle button state (only use with toggleable = true)
             * @param {Boolean} pressed Specify to force a certain toggle state
             * @fires toggle
             */

          }, {
            key: "toggle",
            value: function toggle() {
              var pressed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var me = this,
                  menu = me.menu;

              if (!me.toggleable) {
                return;
              }

              if (pressed === null) {
                pressed = !me.pressed;
              }

              me.pressed = pressed; // For handlers from the code below to detect and avoid recursion

              me.toggling = true;

              if (menu) {
                menu.minWidth = me.width;
                menu[pressed ? 'show' : 'hide']();
              }

              me.syncIconCls();
              /**
               * Button state was toggled
               * @event toggle
               * @property {Common.widget.Button} button - Button
               * @property {Boolean} pressed - New pressed state
               */

              me.trigger('toggle', {
                pressed: pressed
              });
              me.toggling = false;
            } //endregion
            //region Other

          }, {
            key: "syncIconCls",
            value: function syncIconCls() {
              var me = this;
              var iconEl = me._iconEl;

              if (me.icon) {
                if (!iconEl) {
                  iconEl = me._iconEl = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].createElement({
                    tag: 'i',
                    nextSibling: me.element.firstChild
                  });
                }

                var iconCls = me.pressed && me.pressedIcon ? me.pressedIcon : me.icon;
                me._iconEl.className = iconCls; // if it's a supplied icon class b-fa-xxx or b-icon-xxx, add extra class
                // so user doesn't have to; they can just specify the icon

                if (bIcon.test(iconCls)) {
                  iconEl.classList.add('b-icon');
                } else if (bFa.test(iconCls)) {
                  iconEl.classList.add('b-fa');
                }
              } else {
                iconEl && iconEl.remove();
              }
            } //endregion

          }, {
            key: "focusElement",
            get: function get() {
              return this.element;
            }
            /**
             * Get/set text displayed on the button.
             * @property {String}
             */

          }, {
            key: "text",
            get: function get() {
              return this._text;
            },
            set: function set(text) {
              var element = this.element;
              if (text === null || text === undefined) text = '';
              element.lastChild.data = this._text = text;
              element.classList[text ? 'add' : 'remove']('b-text');
            }
            /**
             * Returns the instantiated menu widget as configured by {@link #config-menu}.
             * @property {Common.widget.Widget}
             * @readonly
             */

          }, {
            key: "menu",
            get: function get() {
              var me = this;
              var result = me._menu;

              if (result && !(result instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"])) {
                // This covers both Array and Object which are valid items config formats.
                // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
                // child items or html property in it, it's the main config
                if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(result) === 'object' && !('items' in result || 'widgets' in result || 'html' in result)) {
                  result = {
                    items: result
                  };
                }

                result = me.menu = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].createWidget(Object.assign({
                  type: 'menu',
                  autoShow: false,
                  autoClose: true,
                  scrollAction: 'realign',
                  constrainTo: document.body,
                  forElement: me.element,
                  align: 't0-b0',
                  owner: me,
                  onHide: function onHide() {
                    // In case the reason for the hide is a mousedown
                    // on this button, wait until after any impending
                    // click handler to sync our state with the visibility.
                    me.setTimeout(function () {
                      return me.toggle(false);
                    }, 300);
                  }
                }, result));
              }

              return result;
            },
            set: function set(menu) {
              this._menu = menu; // We are toggleable if there's a menu.
              // Pressed means menu visible, not pressed means menu hidden.

              this.toggleable = Boolean(menu);
            }
            /**
             * Get/set button pressed state
             * @property {Boolean}
             */

          }, {
            key: "pressed",
            set: function set(pressed) {
              var me = this;

              if (pressed && me.toggleGroup) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].forEachSelector("button[data-group=".concat(me.toggleGroup, "]"), function (btnEl) {
                  if (btnEl !== me.element) {
                    _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].getById(btnEl.id).toggle(false);
                  }
                });
              }

              me._pressed = pressed;
              if (me.element) me.element.classList[pressed ? 'add' : 'remove']('b-pressed');
            },
            get: function get() {
              return this._pressed;
            }
            /**
             * Get/set the Button icon
             * @property {String}
             */

          }, {
            key: "icon",
            set: function set(icon) {
              this._icon = icon;
              this.syncIconCls();
            },
            get: function get() {
              return this._icon;
            }
            /**
             * Get/set the Button pressed icon
             * @property {String}
             */

          }, {
            key: "pressedIcon",
            set: function set(icon) {
              this._pressedIcon = icon;
              this.syncIconCls();
            },
            get: function get() {
              return this._pressedIcon;
            }
            /**
             * Get/Set the Button icon alignment.
             * May be `'start'` or `'end'`. Defaults to `'start'`
             * @property {String}
             */

          }, {
            key: "iconAlign",
            set: function set(iconAlign) {
              var me = this,
                  oldAlign = me._iconAlign;

              if (iconAlign !== oldAlign) {
                if (oldAlign) {
                  me.element.classList.remove("b-icon-align-".concat(oldAlign));
                }

                me.element.classList.add("b-icon-align-".concat(iconAlign));
                me._iconAlign = iconAlign;
              }
            },
            get: function get() {
              return this._iconAlign;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Button icon class.
                 *
                 * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
                 *
                 * Otherwise this is a developer-defined CSS class string which results in the desired icon.
                 * @config {String}
                 */
                icon: null,

                /**
                 * Icon class for the buttons pressed state. Only applies to toggle buttons
                 *
                 * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
                 *
                 * Otherwise this is a developer-defined CSS class string which results in the desired icon.
                 *
                 * ```
                 * new Button({
                 *    // Icon for unpressed button
                 *    icon        : 'b-fa-wine-glass',
                 *
                 *    // Icon for pressed button
                 *    pressedIcon : 'b-fa-wine-glass-alt',
                 *
                 *    // Only applies to toggle buttons
                 *    toggleable  : true
                 * });
                 * ```
                 *
                 * @config {String}
                 */
                pressedIcon: null,

                /**
                 * Button icon alignment. May be `'start'` or `'end'`. Defaults to `'start'`
                 * @config {String}
                 */
                iconAlign: 'start',

                /**
                 * Button text
                 * @config {String}
                 */
                text: '',

                /**
                 * Button color (should have match in button.scss or your custom styling). Valid values in Bryntum themes
                 * are:
                 * * b-amber
                 * * b-blue
                 * * b-dark-gray
                 * * b-deep-orange
                 * * b-gray
                 * * b-green
                 * * b-indigo
                 * * b-lime
                 * * b-light-gray
                 * * b-light-green
                 * * b-orange
                 * * b-purple
                 * * b-red
                 * * b-teal
                 * * b-white
                 * * b-yellow
                 * Combine with specifying `b-raised` for raised/filled style (theme dependent).
                 *
                 * ```
                 * new Button({
                 *    color : 'b-teal b-raised'
                 * });
                 * ```
                 *
                 * @config {String}
                 */
                color: null,

                /**
                 * Enabled toggling of the button (stays pressed when pressed).
                 * @config {Boolean}
                 * @default
                 */
                toggleable: false,

                /**
                 * Initially pressed or not. Only applies with `toggleable = true`.
                 * ```
                 * const toggleButton = new Button({
                 *    toggleable : true,
                 *    text : 'Enable cool action'
                 * });
                 * ```
                 * @config {Boolean}
                 * @default
                 */
                pressed: false,

                /**
                 * Indicate that this button is part of a group where only one button can be pressed. Assigning a value
                 * also sets `toggleable` to `true`.
                 * ```
                 * const yesButton = new Button({
                 *    toggleGroup : 'yesno',
                 *    text        : 'Yes'
                 * });
                 *
                 * const noButton = new Button({
                 *    toggleGroup : 'yesno',
                 *    text        : 'No'
                 * });
                 * ```
                 * @config {String}
                 */
                toggleGroup: null,
                ripple: {
                  radius: 75
                },
                defaultBindProperty: 'text',
                localizableProperties: ['text'],

                /**
                 * A submenu configuration object, or an array of MenuItem configuration
                 * objects from which to create a submenu which is shown when this button is pressed.
                 *
                 * Note that this does not have to be a Menu. The `type` config can be used
                 * to specify any widget as the submenu.
                 * @config {Object|Object[]}
                 */
                menu: null
              };
            }
          }]);

          return Button;
        }(Object(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_11__["default"])(_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"]));

        Button._$name = 'Button';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_12__["default"].register('button', Button);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/ButtonGroup.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/widget/ButtonGroup.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetButtonGroupJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ButtonGroup;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Container_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Container.js */
        "../Grid/lib/Common/widget/Container.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Button_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Button.js */
        "../Grid/lib/Common/widget/Button.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/ButtonGroup
         */

        /**
         * A specialized container that holds buttons, displaying them in a horizontal group with borders adjusted to make them
         * stick together.
         *
         * Trying to add other widgets than buttons will throw an exception.
         *
         * ```javascript
         * new ButtonGroup({
         *   items : [
         *       { icon : 'b-fa b-fa-kiwi-bird' },
         *       { icon : 'b-fa b-fa-kiwi-otter' },
         *       { icon : 'b-fa b-fa-kiwi-rabbit' },
         *       ...
         *   ]
         * });
         * ```
         *
         * @externalexample widget/ButtonGroup.js
         * @classType buttonGroup
         * @extends Common/widget/Container
         */

        var ButtonGroup =
        /*#__PURE__*/
        function (_Container) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ButtonGroup, _Container);

          function ButtonGroup() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ButtonGroup);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ButtonGroup).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ButtonGroup, [{
            key: "createWidget",
            value: function createWidget(widget) {
              var me = this;

              if (me.color && !widget.color) {
                widget.color = me.color;
              }

              if (me.toggleGroup && !widget.toggleGroup) {
                if (typeof me.toggleGroup === 'boolean') {
                  me.toggleGroup = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].generateId('toggleGroup');
                }

                widget.toggleGroup = me.toggleGroup;
              }

              var button = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ButtonGroup.prototype), "createWidget", this).call(this, widget);

              if (!(button instanceof _Button_js__WEBPACK_IMPORTED_MODULE_8__["default"])) {
                throw new Error('A ButtonGroup can only contain buttons');
              }

              return button;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                defaultType: 'button',

                /**
                 * Custom CSS class to add to element. When using raised buttons (cls 'b-raised' on the buttons), the group
                 * will look nicer if you also set that cls on the group.
                 *
                 * ```
                 * new ButtonGroup({
                 *   cls : 'b-raised,
                 *   items : [
                 *       { icon : 'b-fa b-fa-unicorn', cls : 'b-raised' },
                 *       ...
                 *   ]
                 * });
                 * ```
                 *
                 * @config {String}
                 * @category CSS
                 */
                cls: null,

                /**
                 * An array of Buttons or typed Button config objects.
                 * @config {Object[]|Common.widget.Button[]}
                 */
                items: null,

                /**
                 * Default color to apply to all contained buttons, see {@link Common.widget.Button#config-color Button#color}.
                 * Individual buttons can override the default.
                 * @config {String}
                 */
                color: null,

                /**
                 * Set to `true` to turn the ButtonGroup into a toggle group, assigning a generated value to each contained
                 * buttons {@link Common.widget.Button#config-toggleGroup toggleGroup config}. Individual buttons can
                 * override the default.
                 */
                toggleGroup: null
              };
            }
          }]);

          return ButtonGroup;
        }(_Container_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        ButtonGroup._$name = 'ButtonGroup';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_7__["default"].register('buttonGroup', ButtonGroup);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/CalendarPanel.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/widget/CalendarPanel.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetCalendarPanelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CalendarPanel;
        });
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "../Grid/node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Panel_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./Panel.js */
        "../Grid/lib/Common/widget/Panel.js");
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _util_Month_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../util/Month.js */
        "../Grid/lib/Common/util/Month.js");
        /* harmony import */


        var _Tooltip_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/CalendarPanel
         */

        /**
         * A Panel which can display a month of date cells.
         *
         * This is a base class for UI widgets which need to make use of a calendar layout
         * and should not be used directly.
         */

        var CalendarPanel =
        /*#__PURE__*/
        function (_Panel) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(CalendarPanel, _Panel);

          function CalendarPanel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, CalendarPanel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(CalendarPanel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(CalendarPanel, [{
            key: "construct",
            value: function construct(config) {
              _localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
                locale: calculateDayNames
              });

              calculateDayNames();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(CalendarPanel.prototype), "construct", this).call(this, config);

              this.refresh();
            }
          }, {
            key: "ingestDate",
            value: function ingestDate(date) {
              if (!(date instanceof Date)) {
                date = new Date(date);

                if (isNaN(date)) {
                  throw new Error('CalendarPanel date ingestion must be passed a Date, or a valid argument to the Date constructor');
                } // Edge parses YYYY-MM-DD as UTC, not local, so in other locales, the value
                // may end up not being 00:00:00 in the date, so remove any time zone offset.


                var tzo = date.getTimezoneOffset();

                if (tzo) {
                  date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(date, tzo, 'minute');
                }
              }

              return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].clearTime(date);
            }
          }, {
            key: "refresh",
            value: function refresh() {
              var me = this,
                  today = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].clearTime(new Date()),
                  cellElements = me.cellElements,
                  weekElements = me.weekElements,
                  date = me.date,
                  month = me.month,
                  cellCls = me.cellCls,
                  disabledCls = me.disabledCls,
                  otherMonthCls = me.otherMonthCls,
                  weekendCls = me.weekendCls,
                  todayCls = me.todayCls; // If we have not been initialized with a current date, use today


              if (!date) {
                return me.date = today;
              } // Clear all content and CSS


              for (var i = 0, len = cellElements.length; i < len; i++) {
                cellElements[i].className = cellElements[i].innerHTML = '';
              }

              for (var _i = 0; _i < 7; _i++) {
                var cell = me.weekdayCells[_i];
                cell.className = cell.innerHTML = '';

                if (me.headerRenderer) {
                  me.headerRenderer(cell, _i);
                } else {
                  cell.innerHTML = shortDayNames[me.canonicalDayNumbers[_i]];
                }

                cell.classList.add('b-calendar-day-header');
              } // Create cell content


              var weekIndex = 0,
                  cellIndex = 0;
              month.eachWeek(function (week, dates) {
                var weekElement = weekElements[weekIndex],
                    weekCells = weekElement.children;
                weekCells[0].className = 'b-week-number-cell';

                if (me.weekRenderer) {
                  me.weekRenderer(weekCells[0], week);
                } else {
                  weekCells[0].innerHTML = week[1];
                }

                for (var _i2 = 0; _i2 < 7; _i2++) {
                  var cellDate = dates[_i2],
                      cellDay = cellDate.getDay(),
                      _cell = weekCells[_i2 + 1],
                      cellClassList = _cell.classList;
                  cellClassList.add(cellCls);

                  if (me.isDisabledDate(cellDate)) {
                    cellClassList.add(disabledCls);
                  }

                  if (cellDate.getMonth() !== month.month) {
                    cellClassList.add(otherMonthCls);
                  }

                  if (cellDay === 0 || cellDay === 6) {
                    cellClassList.add(weekendCls);
                  }

                  if (cellDate.getTime() === today.getTime()) {
                    cellClassList.add(todayCls);
                  }

                  _cell.dataset.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].format(cellDate, 'YYYY-MM-DD');
                  _cell.dataset.cellIndex = cellIndex;

                  if (me.cellRenderer) {
                    me.cellRenderer(_cell, cellDate);
                  } else {
                    _cell.innerHTML = cellDate.getDate();
                  }

                  cellIndex++;
                }

                weekIndex++;
              });

              if (me.floating) {
                // Must realign because content change might change dimensions
                if (!me.isAligning) {
                  me.realign();
                }
              }
            }
          }, {
            key: "isDisabledDate",
            value: function isDisabledDate(date) {
              var day = date.getDay(),
                  disabledDates = this.disabledDates;

              if (this.disableWeekends && (day === 0 || day === 6)) {
                return true;
              }

              if (disabledDates) {
                if (typeof disabledDates === 'function') {
                  return disabledDates(date);
                }

                if (Array.isArray(disabledDates)) {
                  return disabledDates.some(function (d) {
                    return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].clearDate(d, true).getTime() === _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].clearDate(date, true).getTime();
                  });
                }
              }
            }
          }, {
            key: "onTipOverCell",
            value: function onTipOverCell(_ref) {
              var tip = _ref.source,
                  target = _ref.target;
              tip.date = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].parse(target.dataset.date, 'YYYY-MM-DD');
            }
          }, {
            key: "tip",
            set: function set(tip) {
              this._tip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_14__["default"](Object.assign({
                forElement: this.element,
                forSelector: '.b-calendar-cell'
              }, tip));

              this._tip.on({
                pointerOver: 'onTipOverCell',
                thisObj: this
              });
            },
            get: function get() {
              return this._tip;
            }
          }, {
            key: "element",
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(CalendarPanel.prototype), "element", this);
            },
            set: function set(element) {
              var me = this;

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(CalendarPanel.prototype), "element", element, this, true);

              me.weekElements = Array.from(me.element.querySelectorAll('.b-calendar-week'));
              me.cellElements = Array.from(me.element.querySelectorAll('.b-calendar-week > div'));
            }
            /**
             * The date which this CalendarPanel encapsulates. Setting this causes the
             * content to be refreshed.
             * @property {Date}
             */

          }, {
            key: "date",
            set: function set(date) {
              var me = this;
              date = me._date = me.ingestDate(date);

              if (!me.month || me.month.month !== date.getMonth()) {
                me.month = new _util_Month_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
                  date: date,
                  weekStartDay: me.weekStartDay,
                  sixWeeks: me.sixWeeks
                });
              }

              me.refresh();
            },
            get: function get() {
              return this._date;
            }
          }, {
            key: "showWeekNumber",
            set: function set(showWeekNumber) {
              var me = this;
              me.element.classList[showWeekNumber ? 'add' : 'remove']('b-show-week-number');

              if (me.floating) {
                // Must realign because content change might change dimensions
                if (!me.isAligning) {
                  me.realign();
                }
              }
            }
          }, {
            key: "bodyConfig",
            get: function get() {
              var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(CalendarPanel.prototype), "bodyConfig", this),
                  weeksContainerChildren = [];

              result.children = [{
                tag: 'div',
                className: 'b-calendar-row b-calendar-weekdays',
                children: this.dayNameCells
              }, {
                className: 'b-weeks-container',
                children: weeksContainerChildren
              }];

              for (var i = 0; i < 6; i++) {
                var weekRow = {
                  className: 'b-calendar-row b-calendar-week',
                  children: []
                }; // Generate cells for week number plus seven day cells

                for (var j = 0; j < 8; j++) {
                  weekRow.children.push({});
                }

                weeksContainerChildren.push(weekRow);
              }

              return result;
            }
            /**
             * Set to 0 for Sunday (the default), 1 for Monday etc.
             */

          }, {
            key: "weekStartDay",
            set: function set(weekStartDay) {
              var me = this;
              me.dayNames = [];
              me.dayNumbers = [];
              me.canonicalDayNumbers = [];
              me._weekStartDay = weekStartDay != null ? weekStartDay : _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].weekStartDay; // So, if they set weekStartDay to 1 meaning Monday which is ISO standard, we will
              // have mapping of internal day number to canonical day number (as used by Date class)
              // and to abbreviated day name like this:
              // canonicalDayNumbers = [1, 2, 3, 4, 5, 6, 0] // Use for translation from our day number to Date class's day number
              // dayNumbers          = [6, 0, 1, 2, 3, 4, 5] // Use for translation from Date object's day number to ours
              // dayNames            = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

              for (var i = 0; i < 7; i++) {
                var canonicalDay = (me._weekStartDay + i) % 7;
                me.canonicalDayNumbers[i] = canonicalDay;
                me.dayNumbers[canonicalDay] = i;
                me.dayNames[i] = shortDayNames[canonicalDay];
              }
            },
            get: function get() {
              if (!this.hasOwnProperty('_weekStartDay')) {
                this.weekStartDay = undefined;
              }

              return this._weekStartDay;
            }
          }, {
            key: "dayNameCells",
            get: function get() {
              var me = this,
                  weekNumberHeader = document.createElement('div'),
                  result = [weekNumberHeader],
                  weekdayCells = me.weekdayCells = [];
              weekNumberHeader.className = 'b-week-number-cell'; // Ensure our week is initialized by set weekStartDay

              me._thisIsAUsedExpression(me.weekStartDay);

              for (var i = 0; i < 7; i++) {
                var cell = document.createElement('div');
                result.push(cell);
                weekdayCells.push(cell);
              }

              return result;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The week start day, 0 meaning Sunday, 6 meaning Saturday.
                 * Defaults to the locale's week start day.
                 * @config {Number}
                 */
                weekStartDay: null,

                /**
                 * Configure as `true` to always show a six week calendar.
                 * @config {Boolean}
                 * @default
                 */
                sixWeeks: true,

                /**
                 * Configure as `true` to show a week number column at the start of the calendar block.
                 * @config {Boolean}
                 */
                showWeekNumber: false,

                /**
                 * Either an array of `Date` objects which are to be disabled, or
                 * a function, which, when passed a `Date` returns `true` if the
                 * date is disabled.
                 * @config {Function|Date[]}
                 */
                disabledDates: null,

                /**
                 * A function which creates content in, and may mutate a day header element.
                 * The following parameters are passed:
                 *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
                 *  - day [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The day number conforming to the specified {@link #config-weekStartDay}. Will be in the range 0 to 6.
                 * @config {Function}
                 */
                headerRenderer: null,

                /**
                 * A function which creates content in, and may mutate the week cell element at the start of a week row.
                 * The following parameters are passed:
                 *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
                 *  - week [Number[]](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) An array containing `[year, weekNumber]`.
                 * @config {Function}
                 */
                weekRenderer: null,

                /**
                 * A function which creates content in, and may mutate a day cell element.
                 * The following parameters are passed:
                 *  - cell [HTMLElement](https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement) The header element.
                 *  - date [Date](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date) The date for the cell.
                 * @config {Function}
                 */
                cellRenderer: null,

                /**
                 * Configure as `true` to render weekends as {@link #config-disabledDates}.
                 * @config {Boolean}
                 */
                disableWeekends: null,

                /**
                 * A config object to create a tooltip which will show on hover of a date cell
                 * including disabled, weekend, and "other month" cells.
                 *
                 * It is the developer's responsibility to hook the `beforeshow` event
                 * to either veto the show by returning `false` or provide contextual
                 * content for the date.
                 *
                 * The tip instance will be primed with a `currentDate` property.
                 * @config {Object}
                 */
                tip: null,

                /**
                 * The class name to add to calendar cells.
                 * @config {String}
                 * @private
                 */
                cellCls: 'b-calendar-cell',

                /**
                 * The class name to add to disabled calendar cells.
                 * @config {String}
                 * @private
                 */
                disabledCls: 'b-disabled-date',

                /**
                 * The class name to add to calendar cells which are in the previous or next month.
                 * @config {String}
                 * @private
                 */
                otherMonthCls: 'b-other-month',

                /**
                 * The class name to add to calendar cells which are weekend dates.
                 * @config {String}
                 * @private
                 */
                weekendCls: 'b-weekend',

                /**
                 * The class name to add to the calendar cell which contains today's date.
                 * @config {String}
                 * @private
                 */
                todayCls: 'b-today'
              };
            }
          }]);

          return CalendarPanel;
        }(_Panel_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        function calculateDayNames() {
          shortDayNames.length = 0;

          for (var date = 2; date < 9; date++) {
            d.setDate(date);
            shortDayNames.push(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].format(d, 'ddd'));
          }
        } // In the Date class, 0=Sunday, 6=Saturday. 2nd Jan 2000 is Sunday.
        // Collect local shortDayNames in default order.


        var d = new Date('2000-01-01T00:00:00'),
            shortDayNames = [];
        CalendarPanel._$name = 'CalendarPanel';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_12__["default"].register('calendarpanel', CalendarPanel);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Checkbox.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/widget/Checkbox.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetCheckboxJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Checkbox;
        });
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Field_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Field.js */
        "../Grid/lib/Common/widget/Field.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n            <input type=\"checkbox\" id=\"", "_input\" reference=\"input\"/>\n            <label class=\"b-checkbox-label\" for=\"", "_input\" reference=\"textLabel\">", "</label>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/Checkbox
         */

        /**
         * Checkbox field, wraps <code>&lt;input type="checkbox"&gt;</code>.
         * Color can be specified and you can optionally configure {@link #config-text}
         * to display in a label to the right of the checkbox in addition to a standard
         * field {@link #config-label}.
         *
         * @extends Common/widget/Field
         *
         * @example
         * // checkbox with a label and a handler
         * let checkbox = new Checkbox({
         *   text: 'Check me, please',
         *   onAction: () => {}
         * });
         *
         * @classType checkbox
         * @externalexample widget/Checkbox.js
         */

        var Checkbox =
        /*#__PURE__*/
        function (_Field) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Checkbox, _Field);

          function Checkbox() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Checkbox);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Checkbox).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Checkbox, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Checkbox.prototype), "construct", this).call(this, config);

              var me = this;
              if (me.initialConfig.readOnly) me.readOnly = true;
            }
          }, {
            key: "inputTemplate",
            value: function inputTemplate() {
              var me = this;
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].tpl(_templateObject(), me.id, me.id, me.text || '');
            }
          }, {
            key: "check",

            /**
             * Check the box
             */
            value: function check() {
              this.checked = true;
            }
            /**
             * Uncheck the box
             */

          }, {
            key: "uncheck",
            value: function uncheck() {
              this.checked = false;
            }
            /**
             * Toggle checked state. If you want to force a certain state, assign to {@link #property-checked} instead.
             */

          }, {
            key: "toggle",
            value: function toggle() {
              this.checked = !this.checked;
            } //endregion
            //region Events

            /**
             * Triggers events when user toggles the checkbox
             * @fires beforeChange
             * @fires change
             * @fires action
             * @private
             */

          }, {
            key: "internalOnChange",
            value: function internalOnChange(event) {
              /**
               * Fired before checkbox is toggled. Returning false from a listener prevents the checkbox from being toggled.
               * @event beforeChange
               * @preventable
               * @param {Common.widget.Checkbox} source Checkbox
               * @param {Boolean} checked Checked or not
               */

              /**
               * Fired when checkbox is toggled
               * @event change
               * @param {Common.widget.Checkbox} source Checkbox
               * @param {Boolean} checked Checked or not
               */
              this.triggerChange(true);
            }
            /**
             * Triggers events when checked state is changed
             * @fires beforeChange
             * @fires change
             * @fires action
             * @private
             */

          }, {
            key: "triggerChange",
            value: function triggerChange(userAction) {
              var me = this; // Since Widget has Events mixed in configured with 'callOnFunctions' this will also call onBeforeChange, onChange and onAction

              var prevented = !me.callPreventable('change', {
                checked: me.input.checked,
                userAction: userAction
              }, function (eventObject) {
                /**
                * User performed the default action (toggled the checkbox)
                * @event action
                * @param {Common.widget.Checkbox} source Checkbox
                * @param {Boolean} checked Checked or not
                */
                me.trigger('action', eventObject);
                return true;
              }); // If prevented need to rollback the checkbox input

              if (prevented) {
                // Input change is not preventable, so need to revert the changes
                // The change event does not fire on programmatic change of input, so no need to suspend
                me.input.checked = !me.input.checked;
              }
            } //endregion

          }, {
            key: "element",
            set: function set(element) {
              var me = this;

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Checkbox.prototype), "element", element, this, true);

              if (me.color) {
                me.element.classList.add(me.color);
              }

              if (me.text) {
                me.element.classList.add('b-text');
              }
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Checkbox.prototype), "element", this);
            } //endregion
            //region Toggle

            /**
             * Get/set label
             * @property {String}
             */

          }, {
            key: "text",
            get: function get() {
              return this._text;
            },
            set: function set(value) {
              this._text = value;

              if (this.textLabel) {
                this.textLabel.innerHTML = value;
              }
            }
            /**
             * Get/set value
             * @property {String}
             */

          }, {
            key: "value",
            get: function get() {
              return this.input.value;
            },
            set: function set(value) {
              this.input.value = value;
            }
            /**
             * Get/set checked state
             * @property {Boolean}
             */

          }, {
            key: "checked",
            get: function get() {
              return this.input.checked;
            },
            set: function set(checked) {
              checked = Boolean(checked); // Only do action if change needed.

              if (this.input.checked !== checked) {
                this.input.checked = checked; // The change event does not fire on programmatic change of input.

                if (!this.isConfiguring) {
                  this.triggerChange(false);
                }
              }
            }
            /**
             * Get/set readonly state (disabled underlying input)
             * @property {Boolean}
             */

          }, {
            key: "readOnly",
            get: function get() {
              return this._readOnly;
            },
            set: function set(readOnly) {
              this._readOnly = readOnly;
              this.element.classList[readOnly ? 'add' : 'remove']('b-readonly');
              this.input.disabled = readOnly;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Text to display on checkbox label
                 * @config {String}
                 */
                text: '',

                /**
                 * Checkbox color, must have match in css
                 * @config {String}
                 */
                color: null,

                /**
                 * Sets input fields value attribute
                 * @config {String}
                 */
                value: '',
                defaultBindProperty: 'value'
              };
            }
          }]);

          return Checkbox;
        }(_Field_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        Checkbox._$name = 'Checkbox';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('checkbox', Checkbox);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('check', Checkbox);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/ChipView.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/widget/ChipView.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetChipViewJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ChipView;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _List_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./List.js */
        "../Grid/lib/Common/widget/List.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default()(["", "\n            ", "\n            ", ""]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/ChipView
         */

        /**
         * Displays an inline series of Chips which may be navigated to, selected and deleted.
         * @extends Common/widget/List
         *
         * @classType chipview
         */

        var ChipView =
        /*#__PURE__*/
        function (_List) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ChipView, _List);

          function ChipView() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ChipView);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ChipView).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ChipView, [{
            key: "itemContentTpl",
            value: function itemContentTpl(record, i) {
              var me = this;
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].tpl(_templateObject(), me.iconTpl ? this.iconTpl(record) : '', me.itemTpl(record, i), me.closable ? '<div class="b-icon b-close-icon b-icon-clear" data-noselect></div>' : '');
            }
          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(event) {
              if (event.key === 'Delete' || event.key === 'Backspace' && this.selected.count) {
                this.callback(this.closeHandler, this.owner, [this.selected.values, {
                  isKeyEvent: true
                }]);
              } else {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ChipView.prototype), "onInternalKeyDown", this).call(this, event);
              }
            }
          }, {
            key: "onClick",
            value: function onClick(event) {
              var me = this,
                  item = event.target.closest(".".concat(me.itemCls));

              if (me.closable && event.target.classList.contains('b-close-icon')) {
                var record = me.store.getAt(parseInt(item.dataset.index));
                me.callback(me.closeHandler, me.owner, [[record]]);
              } else {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ChipView.prototype), "onClick", this).call(this, event);
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                itemCls: 'b-chip',

                /**
                 * Configure as `true` to display a clickable close icon after the {@link Common.widget.List#config-itemTpl}.
                 * When tapped, the configured {@link #config-closeHandler} is called passing the
                 * associated record.
                 *
                 * Chips may also be selected using the `LEFT` and `RIGHT` arrows (And the `Shift` key to
                 * do multiple, contiguous election). Pressing the `DELETE` or `BACKSPACE` key passes the
                 * selected records to the {@link #config-closeHandler}
                 * @config {Boolean}
                 * @default
                 */
                closable: true,

                /**
                 * A template function, which, when passed a record, returns the markup which
                 * encapsulates a chip's icon to be placed before the {@link Common.widget.List#config-itemTpl}.
                 * @config {Function}
                 */
                iconTpl: null,

                /**
                 * If {@link #config-closable} is `true`, this is the name of a callback function
                 * to handle what the "close" action means.
                 * @config {String|Function}
                 */
                closeHandler: null
              };
            }
          }]);

          return ChipView;
        }(_List_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        ChipView._$name = 'ChipView';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__["default"].register('chipview', ChipView);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Combo.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Common/widget/Combo.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetComboJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Combo;
        });
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _data_Store_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _data_Model_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../util/CollectionFilter.js */
        "../Grid/lib/Common/util/CollectionFilter.js");
        /* harmony import */


        var _PickerField_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ./PickerField.js */
        "../Grid/lib/Common/widget/PickerField.js");
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _List_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ./List.js */
        "../Grid/lib/Common/widget/List.js");
        /* harmony import */


        var _ChipView_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ./ChipView.js */
        "../Grid/lib/Common/widget/ChipView.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _util_Collection_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ../helper/util/Navigator.js */
        "../Grid/lib/Common/helper/util/Navigator.js");

        var productName = 'scheduler';
        var comboQueryAll = Symbol('Combo.queryAll'),
            comboQueryLast = Symbol('Combo.queryLast'),
            fieldRequiredErrorName = 'fieldRequired',
            fieldvalidateFilterErrorName = 'validateFilter';
        /**
         * @module Common/widget/Combo
         */

        /**
         * Combo (dropdown) widget. Consists of a text field with a trigger icon, which displays a List. Can be
         * populated from a Store.
         *
         * @extends Common/widget/PickerField
         *
         * @example
         * // items as strings
         * let combo = new Combo({
         *   items: ['Small', 'Smaller', 'Really small', 'Tiny', 'Super tiny', '?'],
         *   placeholder: 'Pick size of diamond for ring'
         * });
         *
         * @example
         * // items as configs
         * let combo = new Combo({
         *   items: [{ value: 'a', text: 'First' }, { value: 'z', text: 'Last' }]
         * });
         *
         * @example
         * // items from store
         * let combo = new Combo({
         *   store: memberStore,
         *   valueField: 'id',
         *   displayField: 'name'
         * });
         *
         * @classType combo
         * @externalexample widget/Combo.js
         */

        var Combo =
        /*#__PURE__*/
        function (_PickerField) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(Combo, _PickerField);

          function Combo() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Combo);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Combo, [{
            key: "afterConfigure",
            //endregion
            value: function afterConfigure() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "afterConfigure", this).call(this);

              if (!('_value' in this)) {
                this._value = this.valueField === this.displayField ? '' : null;
              }
            }
          }, {
            key: "eachWidget",
            value: function eachWidget(fn) {
              var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var _arr = [this.chipView, this._picker];

              for (var _i = 0; _i < _arr.length; _i++) {
                var widget = _arr[_i];

                if (widget) {
                  if (fn(widget) === false) {
                    return;
                  }

                  if (deep && widget.eachWidget) {
                    widget.eachWidget(fn, deep);
                  }
                }
              }
            }
          }, {
            key: "onChipViewMousedown",
            value: function onChipViewMousedown(mousedownEvent) {
              mousedownEvent.preventDefault();

              if (!this.containsFocus) {
                this.focus();
              }
            }
          }, {
            key: "onChipClose",
            value: function onChipClose(records) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // Do not clean value collection if input field is not empty - probably text is selected
              // and user just wants to remove it, not the picked values

              if (options.isKeyEvent && this.input.value === '' || !options.isKeyEvent) {
                this.valueCollection.remove(records);
              }
            }
          }, {
            key: "syncInputFieldValue",
            value: function syncInputFieldValue() {
              // We only sync the input's value if we are not multiselecting.
              // If we are multiselecting, our value is represented by a ChipView.
              // The ChipView automatically syncs itself with our valueCollection.
              if (!this.multiSelect) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "syncInputFieldValue", this).call(this);
              }
            }
          }, {
            key: "onEditComplete",
            //endregion
            //region Value handling

            /**
             * Check if field value is valid
             * @internal
             */
            value: function onEditComplete() {
              var me = this,
                  selectionCount = me.valueCollection.count;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "onEditComplete", this).call(this); // Ensure the input area matches the selected value


              if (selectionCount) {
                me.clearError(fieldvalidateFilterErrorName);
                me.syncInputFieldValue();
              }

              if (me.required && !selectionCount) {
                me.setError(fieldRequiredErrorName);
              }
            } //endregion
            //region Events

            /**
             * User clicked trigger icon, toggle list.
             * @private
             */

          }, {
            key: "onTriggerClick",
            value: function onTriggerClick() {
              var me = this;

              if (me.pickerVisible) {
                me.hidePicker();
              } else {
                if (!me.readOnly && !me.disabled) {
                  switch (me.triggerAction) {
                    case comboQueryAll:
                      me.doFilter(null);
                      break;

                    case comboQueryLast:
                      me.doFilter(me.lastQuery);
                      break;

                    default:
                      me.doFilter(me.input.value);
                  }
                }
              }
            }
            /**
             * User types into input field in editable combo, show list and filter it.
             * @private
             */

          }, {
            key: "internalOnInput",
            value: function internalOnInput(event) {
              var me = this,
                  inputLen = me.input.value.length; // IE11 triggers input event on focus for some reason, ignoring it if not editable

              if (!me.editable) return;
              me.updateEmpty();

              if (inputLen >= me.minChars) {
                me.filterList(me.input.value);
              } else {
                if (me.validateFilter) {
                  me[inputLen ? 'setError' : 'clearError'](fieldvalidateFilterErrorName);
                }

                me.hidePicker();
              }
              /**
               * User typed into the field. Please note that the value attached to this event is the raw input field value and
               * not the combos value
               * @event input
               * @param {Common.widget.Combo} source - The combo
               * @param {String} value - Raw input value
               */


              me.trigger('input', {
                value: me.input.value,
                event: event
              });
            } // This is potentially a buffered function to respond to keystrokes in a buffered manner.
            // This only becomes useful as a saving when using remote querying where each filter is an Ajax request.

          }, {
            key: "filterList",
            value: function filterList(queryString) {
              this.doFilter(queryString);
            }
          }, {
            key: "doFilter",
            value: function doFilter(queryString) {
              var me = this,
                  store = me.store,
                  disableFilter = queryString == null || queryString == '';
              me.lastQuery = queryString;
              me.primaryFilter.setConfig({
                value: queryString,
                disabled: disableFilter
              });
              store.filter();
              me.showPicker();

              if (store.count) {
                // If we are filtering, activate the first match
                if (!disableFilter) {
                  me.picker.navigator.activeItem = 0;
                }
              } // If we were actively filtering on a string but there were no matches
              // and we are validateFilter: true, then mark as invalid even though we
              // may have an underlying valid selected value.
              else if (!disableFilter && me.validateFilter) {
                  me.setError(fieldvalidateFilterErrorName);
                }
            }
            /**
             * This reacts to our {@link #property-valueCollection} being mutated in any way.
             * The `change`, `select` and `action` events are fired here.
             *
             * This could happen in four ways:
             *
             *  - User selected or deselected an item in the dropdown list.
             *  - `set value` changes the content.
             *  - The {@link #config-multiSelect} Chip view (which uses this in its store) deletes a record.
             *  - The application programmatically mutates the {@link #property-valueCollection}.
             *
             * @private
             */

          }, {
            key: "onValueCollectionChange",
            value: function onValueCollectionChange(_ref) {
              var valueCollection = _ref.source;
              var me = this,
                  multiSelect = me.multiSelect,
                  hidePicker = 'hidePickerOnSelect' in me ? me.hidePickerOnSelect : !multiSelect,
                  record = multiSelect ? valueCollection.values.slice() : valueCollection.first,
                  records = valueCollection.values.slice(),
                  isUserAction = me._isUserAction || hidePicker && me.pickerVisible || false,
                  oldValue = me._value;

              if (hidePicker) {
                me.hidePicker();
              }

              if (!valueCollection.count && me.required) {
                me.setError(fieldRequiredErrorName);
              } else {
                me.clearError(fieldRequiredErrorName);
                me.clearError(fieldvalidateFilterErrorName);
              }

              if (me.validateFilter && record) {
                me.clearError(fieldvalidateFilterErrorName);
              } // Re-evaluate the filtering so that selected items are filtered out of the dropdown


              if (me.filterSelected) {
                me.store.filter();
              } // Clear the cached value so that there's no fallback when we read back the value below


              me._value = null; // Cache the value for use by our change handler next time, and also so that
              // if we just cleared the valueCollection, the fallback to ._value will be correct

              var value = me._value = me.value;
              me.syncInputFieldValue();
              me.updateEmpty();

              if (!me.isConfiguring) {
                me.trigger('change', {
                  value: value,
                  oldValue: oldValue,
                  userAction: isUserAction,
                  valid: me.isValid
                });
                /**
                 * User selected an item in the list
                 * @event select
                 * @property {Combo} combo - Combo
                 * @property {Common.data.Model} record - Selected record
                 * @property {Common.data.Model} records - Selected records as an array if {@link #config-multiSelect} is `true`
                 * @property {Boolean} userAction - `true` if the value change is due to user interaction.
                 */

                me.trigger('select', {
                  record: record,
                  records: records,
                  userAction: me.containsFocus
                });
                /**
                 * User performed the default action in the list (selected an item)
                 * @event action
                 * @property {Combo} combo - Combo
                 * @property {Mixed} value - The {@link #valueField} of the selected record
                 * @property {Common.data.Model} record - Selected record
                 * @property {Common.data.Model} records - Selected records as an array if {@link #config-multiSelect} is `true`
                 */

                if (me.defaultAction === 'select') {
                  me.trigger('action', {
                    value: value,
                    record: record,
                    records: records
                  });
                }
              }
            }
            /**
             * This listens for when a record from the list is selected, but is already part of
             * the selection and so the {@link #property-valueCollection} rejects that as a no-op.
             * At this point, the user will still expect the picker to hide.
             * @param {Object} event The noChange event containing the splice parameters
             * @private
             */

          }, {
            key: "onValueCollectionNoChange",
            value: function onValueCollectionNoChange(_ref2) {
              var toAdd = _ref2.toAdd;

              if (!this.multiSelect && toAdd.length && this.pickerVisible) {
                this.picker.hide();
              }
            } //endregion
            //region Picker

          }, {
            key: "showPicker",
            value: function showPicker() {
              var me = this,
                  picker = me.picker;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "showPicker", this).call(this); // Once we have access to the anchor size, overlay the anchor pointer over the target if configured to do so.


              if (me.overlayAnchor && !picker.align.offset) {
                picker.align.offset = -picker.anchorSize[1];
                picker.realign();
              }

              if (me.selected) {
                picker.navigator.activeItem = me.store.indexOf(me.selected);
              }

              me.input.focus();
            }
            /**
             * Creates default picker widget
             *
             * @internal
             */

          }, {
            key: "createPicker",
            value: function createPicker(pickerConfig) {
              var me = this,
                  multiSelect = me.multiSelect,
                  pickerWidth = me.pickerWidth,
                  picker = new _List_js__WEBPACK_IMPORTED_MODULE_21__["default"](_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].merge({
                owner: me,
                floating: true,
                scrollAction: 'realign',
                itemsFocusable: false,
                activateOnMouseover: true,
                store: me.store,
                selected: me.valueCollection,
                multiSelect: multiSelect,
                cls: me.listCls,
                itemTpl: me.listItemTpl || function (item) {
                  return item[me.displayField];
                },
                forElement: me[me.pickerAlignElement],
                align: {
                  align: 't-b',
                  axisLock: true,
                  matchSize: pickerWidth == null,
                  anchor: me.overlayAnchor,
                  target: me[me.pickerAlignElement]
                },
                width: pickerWidth,
                navigator: {
                  keyEventTarget: me.input
                },
                maxHeight: 324,
                scrollable: {
                  overflowY: true
                },
                autoShow: false,
                focusOnHover: false
              }, pickerConfig));
              picker.element.dataset.emptyText = me.emptyText || me.L('No results');
              return picker;
            }
          }, {
            key: "onPickerHide",
            value: function onPickerHide() {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "onPickerHide", this).call(this); // https://app.assembla.com/spaces/bryntum/tickets/7736


              if (me.multiSelect && me.clearTextOnPickerHide) {
                me.input.value = '';
              }
            } //endregion

          }, {
            key: "element",
            set: function set(element) {
              var me = this;

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "element", element, this, true); // If we are multiSelect, create a ChipView who's store is backed
              // by our valueCollection - the collection of selected records.


              if (me.multiSelect) {
                me.element.classList.add('b-multiselect');
                me.chipView = new MultiSelectChipView(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].assign({
                  parent: me,
                  insertBefore: me.input,
                  store: me.chipStore = new _data_Store_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
                    storage: me.valueCollection
                  }),
                  navigator: {
                    class: MultiSelectChipNavigator,
                    keyEventTarget: me.input
                  }
                }, me.chipView)); // Insert the input field

                me.chipView.element.appendChild(me.input); // Focus must flow into this field from the ChipView

                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].on({
                  element: me.chipView.element,
                  mousedown: 'onChipViewMousedown',
                  thisObj: me
                });
              }
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "element", this);
            } //region Getters/setters

          }, {
            key: "keyStrokeFilterDelay",
            set: function set(delay) {
              var me = this;

              if (delay) {
                me.filterList = me.buffer(me.doFilter, delay);
              }

              me._keyStrokeFilterDelay = delay;
            },
            get: function get() {
              return this._keyStrokeFilterDelay;
            }
            /**
             * Prepares items to work in attached menu (converts strings to items)
             * @private
             */

          }, {
            key: "items",
            set: function set(items) {
              if (items == null) {
                items = [];
              }

              if (items instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_16__["default"]) {
                return this.store = items;
              }

              var itemModel,
                  valueField = this.valueField,
                  storeData;
              var me = this,
                  displayField = me.displayField;

              if (Array.isArray(items)) {
                storeData = items.map(function (item) {
                  var result = item;

                  if (item instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_17__["default"]) {
                    itemModel = item.constructor;

                    if (!valueField) {
                      me.valueField = valueField = itemModel.idField;
                    }
                  } else {
                    if (typeof item === 'string') {
                      var _result;

                      if (!valueField) {
                        me.valueField = valueField = me.displayField;
                      }

                      result = (_result = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_result, valueField, item), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_result, displayField, item), _result);
                    } else {
                      if (!valueField) {
                        me.valueField = valueField = 'value';
                      }

                      if (Array.isArray(item)) {
                        var _result2;

                        result = (_result2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_result2, valueField, item[0]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_result2, displayField, item[1]), _result2);
                      }
                    }
                  }

                  if (result.selected) {
                    me.value = result;
                  }

                  return result;
                });
              } // Must be a value -> text map
              else {
                  if (!valueField) {
                    me.valueField = valueField = 'value';
                  }

                  storeData = [];
                  Object.entries(items).forEach(function (_ref3) {
                    var _storeData$push;

                    var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref3, 2),
                        key = _ref4[0],
                        value = _ref4[1];

                    storeData.push((_storeData$push = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_storeData$push, valueField, key), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_storeData$push, displayField, value), _storeData$push));
                  });
                } // Allow reconfiguring with a new set of items


              if (me.store) {
                me.store.data = storeData;
              } else {
                var valueFieldDefinition = valueField === displayField ? {
                  name: 'value',
                  dataSource: displayField
                } : valueField;
                me.store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
                  data: storeData,
                  idField: valueField,
                  modelClass: itemModel ||
                  /*#__PURE__*/
                  function (_Model) {
                    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(_class, _Model);

                    function _class() {
                      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, _class);

                      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(_class).apply(this, arguments));
                    }

                    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(_class, null, [{
                      key: "idField",
                      get: function get() {
                        return valueField;
                      },
                      set: function set(idField) {
                        _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(_class), "idField", idField, this, true);
                      }
                    }, {
                      key: "fields",
                      get: function get() {
                        return [valueFieldDefinition, displayField];
                      }
                    }]);

                    return _class;
                  }(_data_Model_js__WEBPACK_IMPORTED_MODULE_17__["default"])
                });
              }
            },
            get: function get() {
              return this.store.allRecords;
            }
            /**
             * Get/sets combo value, selects corresponding item in the list
             * Setting null clears the field.
             *
             * If {@link #config-multiSelect} is `true`, then multiple values may be passed as an array.
             * If the values are records, these become the selected record set held by {@link #property-valueCollection},
             * and the `value` yielded by this field is an array of all the {@link #config-valueField}s from the records.
             * @fires select
             * @fires action
             * @property {Object}
             */

          }, {
            key: "value",
            set: function set(value) {
              var me = this;

              if (value === me.value) {
                // prevent highlighting animation on clear
                var old = me.highlightExternalChange;
                me.highlightExternalChange = false;
                me.syncInputFieldValue();
                me.highlightExternalChange = old;
                return;
              }

              if (!me.multiSelect && Array.isArray(value) && value.length > 1) {
                throw new Error('Multiple values cannot be set to a non-multiselect Combo');
              } // This forces promotion of the items config into a Store if it has not already been injected


              me._thisIsAUsedExpression(me.items);

              var valueField = me.valueField,
                  displayField = me.displayField,
                  store = me.store,
                  valueCollection = me.valueCollection; // Unfilter the store so we can do the value lookup.

              if (store.filtered) {
                me.primaryFilter.disabled = true;
                store.filter();
              }

              var record;

              if (value != null) {
                var values = Array.isArray(value) ? value : [value];

                for (var i = 0, len = values.length; i < len; i++) {
                  var _value = values[i];

                  if (_value instanceof _data_Model_js__WEBPACK_IMPORTED_MODULE_17__["default"]) {
                    // The required record value may not yet be in the store. Add it if not.
                    if (!store.storage.includes(_value)) {
                      store.add(_value);
                    }
                  } else {
                    var isObject = _value instanceof Object; // If they passed a data object, match the valueField

                    if (isObject) {
                      _value = _value[valueField];
                    } // Use the Store Collection's extra indices to quickly find a match


                    record = store.storage.getBy(displayField, _value) || store.storage.getBy(valueField, _value);

                    if (record) {
                      // If the incoming value was a matched object, use it to update the record
                      if (isObject) {
                        record.set(values[i]);
                      }

                      values[i] = record;
                    } else {
                      values.splice(i, 1);
                      len--;
                      i--;
                    }
                  }
                } // Remove all old values, add new values in one shot.


                var vcGen = valueCollection.generation;
                valueCollection.splice(0, valueCollection.count, values); // If no change has fed through to onValueCollectionChange, just ensure the input matches

                if (valueCollection.generation === vcGen) {
                  me.syncInputFieldValue();
                } // If we got no matches, onValueCollectionChange will set the _value to null.
                // Tests specify that the _value should be set to the incoming unmatched value


                if (!values.length) {
                  me._value = value;
                }
              } else {
                if (valueCollection.count) {
                  valueCollection.clear();
                } else {
                  var oldValue = me._value; // Cache the value for use by our change handler next time, and also so that
                  // when get value yields null, the fallback to ._value will be correct

                  me._value = null;
                  me.syncInputFieldValue();
                  me.updateEmpty();

                  if (!me.isConfiguring) {
                    me.trigger('change', {
                      value: value,
                      oldValue: oldValue,
                      userAction: me._isUserAction,
                      valid: me.isValid
                    });
                  }
                }
              }
            },
            get: function get() {
              var me = this;
              return me.multiSelect ? me.valueCollection.map(function (r) {
                return r[me.valueField];
              }) : me.valueCollection.count ? me.valueCollection.first[me.valueField] : me._value;
            }
          }, {
            key: "isEmpty",
            get: function get() {
              return this.valueCollection.count === 0;
            }
          }, {
            key: "isValid",
            get: function get() {
              if (this.required && !this.valueCollection.count) {
                this.setError(fieldRequiredErrorName, true);
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Combo.prototype), "isValid", this);
            }
          }, {
            key: "inputValue",
            get: function get() {
              // This must be evaluated first, and NOT moved to be directly used as the
              // second expression in the ternary. If called during configuration, this
              // will import the configured value from the config object and ensure the
              // value is matched against the store, and that the "selected" property is set.
              var me = this,
                  result = me.value;
              result = me.selected ? me.selected[me.displayField] : result;

              if (me.displayValueRenderer) {
                result = this.displayValueRenderer(me.selected);
              }

              return result == null ? '' : result;
            }
          }, {
            key: "displayValueRenderer",
            set: function set(value) {
              this._displayValueRenderer = value;
            },
            get: function get() {
              return this._displayValueRenderer;
            }
            /**
             * A {@link Common.util.Collection Collection} which holds the currently seleted records
             * from the store which dictates this field's value.
             *
             * Usually, this will contain one record, the record selected.
             *
             * When {@link #config-multiSelect} is `true`, there may be several records selected.
             */

          }, {
            key: "valueCollection",
            get: function get() {
              if (!this._valueCollection) {
                this._valueCollection = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_25__["default"]({
                  listeners: {
                    noChange: 'onValueCollectionNoChange',
                    change: 'onValueCollectionChange',
                    prio: -1000,
                    // The ChipView must react to changes first.
                    thisObj: this
                  }
                });
              }

              return this._valueCollection;
            }
            /**
             * Get/set store to display items from. Also accepts a Store config object
             * @property {Common.data.Store|Object}
             */

          }, {
            key: "store",
            set: function set(store) {
              var me = this,
                  storeFilters = [];

              if (Array.isArray(store)) {
                me.initialConfig.store = null;
                return me.items = store;
              } // Config object supplied, create a store


              if (store && !(store instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_16__["default"])) {
                store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_16__["default"](store);
              }

              if (!me.valueField) {
                me.valueField = store.modelClass.idField;
              } // This is the filter that performs filtering on typing.


              if (!me.primaryFilter) {
                // Need an id to replace any existing combo filter on the store. Precommit hook wont allow it to be set
                // directly...
                var id = 'primary';
                me.primaryFilter = new _util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_18__["default"]({
                  id: id,
                  property: me.displayField,
                  operator: me.filterOperator,
                  disabled: true,
                  caseSensitive: me.caseSensitive
                });
              }

              storeFilters.push(me.primaryFilter);

              if (me.filterSelected) {
                me.selectedItemsFilter = function (r) {
                  return !me.valueCollection.includes(r);
                };

                storeFilters.push(me.selectedItemsFilter);
              }

              store.filter(storeFilters);
              me._store = store; // Allow fast lookup by value or displayed value

              store.storage.addIndex(me.displayField);
              store.storage.addIndex(me.valueField);

              if (me.displayValueRenderer) {
                store.on({
                  change: function change() {
                    return me.syncInputFieldValue();
                  }
                });
                me.syncInputFieldValue();
              }
            },
            get: function get() {
              return this._store;
            }
            /**
             * Get selected record.
             * @property {Common.data.Model[]}
             * @readonly
             */

          }, {
            key: "record",
            get: function get() {
              return this.selected;
            }
            /**
             * Get the selected record(s).
             * @property {Common.data.Model[]}
             * @readonly
             */

          }, {
            key: "records",
            get: function get() {
              return this.valueCollection.values.slice();
            }
          }, {
            key: "selected",
            get: function get() {
              return this.valueCollection.first;
            }
          }, {
            key: "picker",
            get: function get() {
              if (!this._picker) {
                this.picker = true;
              }

              return this._picker;
            },
            set: function set(picker) {
              var me = this;

              if (me._picker) {
                me._picker.destroy();
              }

              if (picker instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_20__["default"]) {
                me._picker = picker;
              } else {
                me._picker = me.createPicker(picker);
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Rows to display in the dropdown (list items).
                 *
                 * If an object, the property names provide the {@link #config-value} for the Combo, and
                 * the property values provide the displayed test in the list and input area eg:
                 *
                 *     items : {
                 *         small  : 'Small',
                 *         medium : 'Medium',
                 *         large  : 'Large'
                 *     }
                 *
                 * If an array, each entry may be
                 *  - an object containing properties which must include
                 * the {@link #config-valueField} and {@link #config-displayField} which populates the dropdown
                 * with text and provides the corresponding field value.
                 *  - An array whos first value provides the {@link #config-value} for the Combo and whos
                 * second value provides the displayed test in the list and input area.
                 *  - An array of values where the {@link #config-valueField} and {@link #config-displayField} are the same.
                 *
                 * eg:
                 *
                 *     items : [
                 *         {value : 'small',  text : 'Small'},
                 *         {value : 'medium', text : 'Medium'},
                 *         {value : 'large',  text : 'Large'},
                 *     ]
                 *
                 * or
                 *
                 *     items : [
                 *         ['small',  'Small'],
                 *         ['medium', 'Medium'],
                 *         ['large',  'Large'],
                 *     ]
                 *
                 * or
                 *
                 *     items : [ 'Small', 'Medium', 'Large' ]
                 *
                 * @config {Object[]|String[]|Object}
                 */
                items: null,

                /**
                 * A store used to populate items
                 * @config {Common.data.Store}
                 */
                store: null,

                /**
                 * Field used for item value when populating from store
                 * @config {String}
                 */
                valueField: null,

                /**
                 * Field used for item text when populating from store
                 * @config {String}
                 */
                displayField: 'text',

                /**
                 * Width of picker, defaults to this combo's {@link #config-pickerAlignElement} width
                 * @config {Number}
                 */
                pickerWidth: null,

                /**
                 * The minimum string length to trigger the filtering, only relevant when {@link #config-editable} is true
                 * @config {Number}
                 * @default
                 */
                minChars: 1,
                selected: null,

                /**
                 * Template for rendering list items contents
                 * @config {Function}
                 */
                listItemTpl: null,

                /**
                 * Template function that can be used to customize the displayed value
                 * @config {Function}
                 */
                displayValueRenderer: null,

                /**
                 * CSS class to add to picker
                 * @config {String}
                 */
                listCls: null,
                triggers: {
                  expand: {
                    cls: 'b-icon-picker',
                    handler: 'onTriggerClick'
                  }
                },

                /**
                 * This implies that the picker will display an anchor pointer, but also means that the picker will align closer
                 * to the input field so that the pointer pierces the {@link #config-pickerAlignElement}
                 * @config {Boolean}
                 * @default false
                 */
                overlayAnchor: null,

                /**
                 * The delay in milliseconds to wait after the last keystroke before filtering the list.
                 * @config {Number}
                 * @default
                 */
                keyStrokeFilterDelay: null,
                defaultAction: 'select',

                /**
                 * How to query the store upon click of the expand trigger. There are two constants provided:
                 *
                 * * `Combo.queryAll` - Clear the filter and display the whole dataset in the dropdown.
                 * * `Combo.queryLast` - Filter the dataset using the last filter value.
                 * * `null`/any other - Use the value in the input field to filter the dataset.
                 *
                 * @config {Object}
                 * @default Combo.QueryAll
                 */
                triggerAction: comboQueryAll,

                /**
                 * The name of an operator type as implemented in {@link Common.util.CollectionFilter#config-operator}
                 * to use when filtering the dropdown list based upon the typed value.
                 *
                 * This defaults to `'startsWith'`, but the `'*'` operator may be used to match all
                 * values which _contain_ the typed value.
                 *
                 * @config {String}
                 */
                filterOperator: 'startsWith',

                /**
                 * Configure as `true` to force case matching when filtering the dropdown list based upon the typed value.
                 *
                 * @config {Boolean}
                 * @default false
                 */
                caseSensitive: false,

                /**
                 * Configure as `true` to allow selection of multiple values from the dropdown list.
                 *
                 * Each value is displayed as a "Chip" to the left of the input area. Chips may be
                 * selected using the `LEFT` and `RIGHT` arrow keys and deleted using the `DELETE` key
                 * to remove values from the field. There is also a clickable close icon in each chip.
                 *
                 * @config {Boolean}
                 * @default false
                 */
                multiSelect: null,

                /**
                 * By default, the picker is hidden on selection in single select mode, and
                 * remains to allow more selections when {@link #config-multiSelect} is `true`.
                 * Setting this to a `Boolean` value can override that default.
                 */
                hidePickerOnSelect: null,

                /**
                 * A config object to configure the {@link Common.widget.ChipView} to display the
                 * selected value set when {@link #config-multiSelect} is `true.
                 *
                 * For example the {@link Common.widget.List#config-itemTpl} or
                 * {@link Common.widget.ChipView#config-iconTpl} might be configured to display
                 * richer chips for selected items.
                 * @config {Boolean}
                 */
                chipView: null,

                /**
                 * When {@link #config-multiSelect} is `true`, you may configure `filterSelected` as
                 * `true` to hide items in the dropdown when they are added to the selection.
                 * It will appear as if the requested item has "moved" into the field's
                 * {@link #config-chipView ChipView}.
                 *
                 * @config {Boolean}
                 * @default false
                 */
                filterSelected: null,

                /**
                 * Text to display in the drop down when there are no items in the underlying store
                 * @config {String}
                 * @default
                 */
                emptyText: null,

                /**
                 * The initial value of this Combo box. In single select mode (default) it's a simple string value, for {@link #config-multiSelect} mode, it should be an array of record ids.
                 * @config {String|Number[]|String[]}
                 * @default
                 */
                value: null,

                /**
                 * `true` to cause the field to be in an invalid state while the typed filter string does not match a record in the store.
                 * @config {Boolean}
                 * @default
                 */
                validateFilter: true,

                /**
                 * `true` to clear value typed to a multiselect combo when picker is collapsed
                 * @config {Boolean}
                 * @default
                 */
                clearTextOnPickerHide: true
              };
            }
          }]);

          return Combo;
        }(_PickerField_js__WEBPACK_IMPORTED_MODULE_19__["default"]); // Constants for how to query on clicking the trigger.
        // queryAll means disable the primaryFilter
        // queryLast means query using the last query string
        // Any other value means use the input field's content

        /**
         * A constant value for the {@link #config-triggerAction} config to indicate that clicking the trigger should
         * clear the filter and display the whole dataset in the dropdown.
         * @member {Symbol} queryAll
         * @readonly
         * @static
         */


        Combo.queryAll = comboQueryAll;
        /**
         * A constant value for the {@link #config-triggerAction} config to indicate that clicking the trigger should
         * filter the dataset usiong the last filter query string, *not* the input field value.
         * @member {Symbol} queryLast
         * @readonly
         * @static
         */

        Combo.queryLast = comboQueryLast;

        var MultiSelectChipView =
        /*#__PURE__*/
        function (_ChipView) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(MultiSelectChipView, _ChipView);

          function MultiSelectChipView() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MultiSelectChipView);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipView).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(MultiSelectChipView, null, [{
            key: "defaultConfig",
            get: function get() {
              return {
                cls: 'b-combo-chip-list',
                itemsFocusable: false,
                multiSelect: true,
                closeHandler: 'up.onChipClose',
                itemTpl: function itemTpl(record) {
                  return record[this.owner.displayField];
                }
              };
            }
          }]);

          return MultiSelectChipView;
        }(_ChipView_js__WEBPACK_IMPORTED_MODULE_22__["default"]);

        var MultiSelectChipNavigator =
        /*#__PURE__*/
        function (_Navigator) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(MultiSelectChipNavigator, _Navigator);

          function MultiSelectChipNavigator() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, MultiSelectChipNavigator);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipNavigator).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(MultiSelectChipNavigator, [{
            key: "onTargetClick",
            value: function onTargetClick(clickEvent) {
              var item = clickEvent.target.closest(this.itemSelector);

              if (item && !clickEvent.shiftKey && !item.contains(clickEvent.target.closest('[data-noselect]'))) {
                this.ownerCmp.selected.clear();
              } // Our own set activeItem also selects because on superclass *key* navigation
              // (which is async on scroll end), it sets activeItem, and we select at that time.
              // So on click we skip this class and go straight to the superclass because the
              // List's onItemClick must run, and that does selection.


              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipNavigator.prototype), "activeItem", item, this, true);
            }
          }, {
            key: "onKeyDown",
            value: function onKeyDown(keyEvent) {
              // ENTER does not toggle selectedness in a ChipView.
              // ChipView's selection is bound to navigation.
              if (keyEvent.key !== 'Enter') {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipNavigator.prototype), "onKeyDown", this).call(this, keyEvent);
              }
            }
          }, {
            key: "navigatePrevious",
            value: function navigatePrevious(keyEvent) {
              var chipView = this.ownerCmp;

              if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
                chipView.selected.clear();
              }

              if (this.previous) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipNavigator.prototype), "navigatePrevious", this).call(this, keyEvent);
              } else {
                this.activeItem = null;
              }
            }
          }, {
            key: "navigateNext",
            value: function navigateNext(keyEvent) {
              var chipView = this.ownerCmp; // SHIFT+navigate preserves selection

              if (chipView.navigator.activeItem && !keyEvent.shiftKey) {
                chipView.selected.clear();
              }

              if (this.next) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipNavigator.prototype), "navigateNext", this).call(this, keyEvent);
              } else {
                this.activeItem = null;
              }
            }
          }, {
            key: "activeItem",
            set: function set(activeItem) {
              var chipView = this.ownerCmp;

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipNavigator.prototype), "activeItem", activeItem, this, true); // Selection simply follows navigation in a ChipView


              if (activeItem) {
                chipView.selected.add(chipView.getRecord(activeItem));
              }
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(MultiSelectChipNavigator.prototype), "activeItem", this);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                allowShiftKey: true
              };
            }
          }]);

          return MultiSelectChipNavigator;
        }(_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_27__["default"]);

        Combo._$name = 'Combo';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_23__["default"].register('combo', Combo);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_23__["default"].register('combobox', Combo);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_23__["default"].register('dropdown', Combo);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Container.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/widget/Container.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetContainerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Container;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "../Grid/node_modules/core-js/modules/es6.object.freeze.js");
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _layout_Layout_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./layout/Layout.js */
        "../Grid/lib/Common/widget/layout/Layout.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Ripple_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ./Ripple.js */
        "../Grid/lib/Common/widget/Ripple.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Container
         */

        var emptyObject = Object.freeze({});
        /**
         * Widget that can contain other widgets. Layout is flexbox by default, see the {@link #config-layout} config.
         *
         * @extends Common/widget/Widget
         *
         * @example
         * // create a container with two widgets
         * let container = new Container({
         *   widgets : [
         *     { type : 'text', label : 'Name' },
         *     { type : 'number', label : 'Score' }
         *   ]
         * });
         *
         * @classType container
         * @externalexample widget/Container.js
         */

        var Container =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Container, _Widget);

          function Container() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Container);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Container).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Container, [{
            key: "setConfig",
            // TODO: Remove when `widgets` is removed.
            value: function setConfig(config, isConstructing) {
              // Assign deprecated widgets to items as early as possible to not have to have special handling in getters/setters
              if (config.widgets) {
                config.items = config.widgets;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Container.prototype), "setConfig", this).call(this, config, isConstructing);
            }
          }, {
            key: "startConfigure",
            value: function startConfigure(config) {
              // Set a flag so that code can test for presence of items without tickling
              // any initial getter.
              var items = this.items;
              this.hasItems = Boolean(items && items.length);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Container.prototype), "startConfigure", this).call(this, config);
            }
          }, {
            key: "processItemsArray",
            value: function processItemsArray(items, result) {
              var len = items.length;
              var i, item;

              for (i = 0; i < len; i++) {
                item = items[i];

                if (!(item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_11__["default"])) {
                  item = this.createWidget(item);
                } else {
                  item.parent = this;
                } // If the widget creation function returns null, nothing to add


                if (item) {
                  result.push(item); // Add current item to this and every parent widget map
                  // cannot use prototype chain here for two reasons:
                  // 1. performance
                  // 2. prototypes would require new prototype chain for every branch - not optimal

                  this.registerReference(item, item.ref || item.id);
                }
              }
            }
          }, {
            key: "processItemsObject",
            value: function processItemsObject(items) {
              var namedItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyObject;
              var result = arguments.length > 2 ? arguments[2] : undefined;
              var item, ref;

              for (ref in items) {
                item = items[ref]; // It might come in as itemRef : false

                if (item) {
                  // If this class or instance has a "namedItems" object
                  // named by this ref, then use it as the basis for the item
                  if (ref in namedItems) {
                    item = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(item) === 'object' ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].merge(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].clone(namedItems[ref]), item) : namedItems[ref];
                  } // Allow namedItems to be overridden with itemKey : false to indicate unavailability of an item


                  if (item) {
                    if (!(item instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_11__["default"])) {
                      item = this.createWidget(item);
                    } else {
                      item.parent = this;
                    } // If the widget creation function returns null, nothing to add


                    if (item) {
                      result.push(item); // Add current item to this and every parent widget map
                      // cannot use prototype chain here for two reasons:
                      // 1. performance
                      // 2. prototypes would require new prototype chain for every branch - not optimal

                      this.registerReference(item, ref);
                    }
                  }
                }
              }
            }
          }, {
            key: "registerReference",
            value: function registerReference(item, ref) {
              for (var current = this; current; current = current.parent) {
                if (!current.widgetMap[ref]) {
                  current.widgetMap[ref] = item;
                }
              }
            }
            /**
             * An object which contains a map of descendant widgets keyed by their {@link Common.widget.Widget#config-ref ref}.
             * All descendant widgets will be available in the `widgetMap`.
             * @property {Object}
             * @readonly
             * @typings any
             */

          }, {
            key: "eachWidget",

            /**
             * Iterate over all widgets in this container and below.
             *
             * *Note*: Due to this method aborting when the function returns
             * `false`, beware of using short form arrow functions. If the expression
             * executed evaluates to `false`, iteration will terminate.
             * @param {Function} fn A function to execute upon all descendant widgets.
             * Iteration terminates if this function returns `false`.
             * @param {Boolean} [deep=true] Pass as `false` to only consider immediate child widgets.
             */
            value: function eachWidget(fn) {
              var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var widgets = this.items,
                  length = widgets ? widgets.length : 0;

              for (var i = 0; i < length; i++) {
                var widget = widgets[i];

                if (fn(widget) === false) {
                  return;
                }

                if (deep && widget.eachWidget) {
                  widget.eachWidget(fn, deep);
                }
              }
            }
            /**
             * Returns an array of all descendant widgets which the passed
             * filter function returns `true` for.
             * @param {Function} filter A function which, when passed a widget,
             * returns `true` to include the widget in the results.
             * @returns {Common.widget.Widget[]} All matching descendant widgets.
             */

          }, {
            key: "queryAll",
            value: function queryAll(filter) {
              var result = [];
              this.eachWidget(function (w) {
                if (filter(w)) {
                  result.push(w);
                }
              });
              return result;
            }
            /**
             * Returns the first descendant widgets which the passed
             * filter function returns `true` for.
             * @param {Function} filter A function which, when passed a widget,
             * returns `true` to return the widget as the sole result.
             * @returns {Common.widget.Widget} The first matching descendant widget.
             */

          }, {
            key: "query",
            value: function query(filter) {
              var result = null;
              this.eachWidget(function (w) {
                if (filter(w)) {
                  result = w;
                  return false;
                }
              });
              return result;
            }
            /**
             * Returns a directly contained widget by id
             * @param {String} id The widget id
             * @returns {Common.widget.Widget}
             */

          }, {
            key: "getWidgetById",
            value: function getWidgetById(id) {
              return this.widgetMap[id];
            }
            /**
             * This function is called prior to creating widgets, override it in subclasses to allow containers to modify the
             * configuration of each widget. When adding a widget to a container hierarchy each parent containers
             * `processWidgetConfig` will be called. Returning false from the function prevents the widget from being added at
             * all.
             */

          }, {
            key: "processWidgetConfig",
            value: function processWidgetConfig(widget) {}
            /**
             * This function converts a Widget config object into a Widget.
             * @param {Object} widget A Widget config object.
             * @internal
             */

          }, {
            key: "createWidget",
            value: function createWidget(widget) {
              var me = this;

              if (!widget.type) {
                widget.type = me.defaultType;
              } // A contained Widget must know its parent, and knowing it during construction
              // is important, but me must not mutate incoming config objects.


              widget = Object.setPrototypeOf({
                parent: me
              }, widget);
              var ancestor = widget;

              while (ancestor = ancestor.parent) {
                if (ancestor.processWidgetConfig(widget) === false) {
                  return null;
                }
              }

              if (me.trigger('beforeWidgetCreate', {
                widget: widget
              }) === false) {
                return null;
              }

              return _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createWidget(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assign({}, me.defaults, widget), me.defaultType || 'widget');
            }
          }, {
            key: "render",
            value: function render(appendToElement) {
              // Outer container has to be in place first.
              // Pass triggerPaint as false, as when contained, the outermost
              // container calls that at the end of its render
              var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Container.prototype), "render", this).call(this, appendToElement, false);

              this.layout.renderChildren(); // The outermost container must trigger paint after all children have
              // been rendered, and this cascades down through all descendants.

              if (!this.parent) {
                this.triggerPaint();
              }

              return result;
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              // Only destroy the widgets if they have been instanced.
              if (!this._itemsInvalid && this.items) {
                this.items.forEach(function (widget) {
                  return widget.destroy && widget.destroy();
                });
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Container.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "widgets",
            set: function set(widgets) {
              console.warn('`widgets` was deprecated in 2.1, please change your code to use `items`'); // Does nothing on purpose
            },
            get: function get() {
              console.warn('`widgets` was deprecated in 2.1, please change your code to use `items`');
              return this.items;
            }
          }, {
            key: "items",
            set: function set(items) {
              this._items = items;
              this._itemsInvalid = this.itemsInitialized = true;
            }
            /**
             * The array of instantiated child Widgets.
             * @property {Common.widget.Widget[]}
             * @readonly
             */
            ,
            get: function get() {
              var me = this,
                  items = me._items; // _widgetMap must exist even if there are no items because of other widget containment
              // situations such as docked toolbars.

              if (!me._widgetMap) {
                me._widgetMap = {};
              } // Only convert the widget config objects into widgets
              // when we first access the widgets. This is more efficient
              // if this Container is never rendered.


              if (me._itemsInvalid) {
                var instancedItems = me._items = [];

                if (Array.isArray(items)) {
                  me.processItemsArray(items, instancedItems);
                } else if (items) {
                  me.processItemsObject(items, me.namedItems, instancedItems);
                } // Allow child items to have a weight to establish their order


                if (instancedItems.some(function (i) {
                  return i.weight;
                })) {
                  instancedItems.sort(function (a, b) {
                    return (a.weight || 0) - (b.weight || 0);
                  });
                }

                me._itemsInvalid = false;
              }

              return me._items;
            }
          }, {
            key: "widgetMap",
            get: function get() {
              // Force evaluation of the widgets array by the getter
              // so that configs are promoted to widgets and the widgetMap
              // is created, and if there are widgets, populated.
              if (!this._widgetMap) {
                this._thisIsAUsedExpression(this.items);
              }

              return this._widgetMap;
            }
          }, {
            key: "record",
            set: function set(record) {
              var me = this,
                  widgets = me.queryAll(function (w) {
                return w.name;
              }),
                  len = widgets.length,
                  cl = me.element.classList; // Though we set highlightExternalChange on the widgets we change
              // the value of, onChange listeners may update others, so inhibit
              // field update highlighting at the CSS level.

              cl.add('b-form-updating');

              for (var i = 0; i < len; i++) {
                var widget = widgets[i],
                    name = widget.name,
                    hec = widget.highlightExternalChange; // Don't want a field highlight on mass change

                widget.highlightExternalChange = false; // Setting record to null clears values

                if (!record && name) {
                  widget.value = null;
                } else if (record && name in record) {
                  widget.value = record[name];
                }

                widget.highlightExternalChange = hec;
              }

              me.setTimeout(function () {
                return cl.remove('b-form-updating');
              }, 1500);
              me._record = record;
            }
            /**
             * The {@link Common.data.Model record} to be applied to the fields contained in this Container.
             * Any descendant widgets of this Container with a `name` property will have its value set to the
             * value of that named property of the record. If no record is passed, the widget has its value
             * set to `null`.
             * @property {Common.data.Model}
             */
            ,
            get: function get() {
              return this._record;
            }
            /**
             * Sets multiple flexbox settings which affect how child widgets are arranged.
             *
             * By default, Containers use flexbox layout, so this property
             * may contain the following properties:
             *
             * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
             * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
             * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
             * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
             * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
             * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
             * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
             * @property {Object}
             * @category Layout
             */

          }, {
            key: "layoutStyle",
            set: function set(layoutStyle) {
              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].applyStyle(this.contentElement, layoutStyle);

              this._layoutStyle = layoutStyle;
            },
            get: function get() {
              return this._layoutStyle;
            }
          }, {
            key: "layout",
            set: function set(layout) {
              this._layout = _layout_Layout_js__WEBPACK_IMPORTED_MODULE_14__["default"].getLayout(layout, this);
            },
            get: function get() {
              return this._layout || (this._layout = new _layout_Layout_js__WEBPACK_IMPORTED_MODULE_14__["default"]());
            }
          }, {
            key: "focusElement",
            get: function get() {
              var firstFocusable = this.query(this.defaultFocus || function (w) {
                return w.focusElement;
              });

              if (firstFocusable) {
                return firstFocusable.focusElement;
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Container.prototype), "focusElement", this);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * An array of Widgets or typed Widget config objects.
                 *
                 * If configured as an Object, the property names are used as the child component's
                 * {@link Common.widget.Widget#config-ref ref} name, and the value is the child component's config object.
                 *
                 * '''javascript
                 *  new Panel({
                 *      title    : 'Test Panel',
                 *      floating : true,
                 *      centered : true,
                 *      width    : 600,
                 *      height   : 400,
                 *      layout   : 'fit',
                 *      items    : {
                 *          tabs : {
                 *              type : 'tabpanel',
                 *              items : {
                 *                  general : {
                 *                      title : 'General',
                 *                      html  : 'General content'
                 *                  },
                 *                  details : {
                 *                      title : 'Details',
                 *                      html  : 'Details content'
                 *                  }
                 *              }
                 *          }
                 *      }
                 *  }).show();```
                 *
                 * @config {Object[]|Common.widget.Widget[]|Object}
                 */
                items: null,

                /**
                 * Synonym for the {@link #config-items} config option.
                 * @config {Object[]|Common.widget.Widget[]|Object}
                 * @deprecated 2.1
                 */
                widgets: null,

                /**
                 * A config object containing default settings to apply to all child widgets.
                 * @config {Object}
                 */
                defaults: null,
                defaultType: 'widget',

                /**
                 * The CSS style properties to apply to the {@link Common.widget.Widget#property-contentElement}.
                 *
                 * By default, a Container's {@link Common.widget.Widget#property-contentElement} uses flexbox layout, so this config
                 * may contain the following properties:
                 *
                 * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-direction">flexDirection</a> default '`row`'
                 * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-wrap">flexWrap</a>
                 * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex-flow">flexFlow</a>
                 * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/justify-content">justifyContent</a>
                 * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-items">alignItems</a>
                 * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-content">alignContent</a>
                 * - <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/place-content">placeContent</a>
                 * @config {Object}
                 */
                layoutStyle: null,

                /**
                 * An optional CSS class to add to child items of this container.
                 * @config {String}
                 */
                itemCls: null,

                /**
                 * The short name of a helper class which manages rendering and styling of child items.
                 *
                 * By default, the only special processing that is applied is that the Container class's
                 * {@link #config-itemCls} is added to child items.
                 *
                 * Containers use CSS flexbox in its default configuration to arrange child items. You may either
                 * use the {@link #config-layoutStyle} configuration to tune how child items are layed out,
                 * or use one of the built in helper classes which include:
                 *
                 *  - `card` Child items are displayed one at a time, size to fit the {@link Common.widget.Widget#property-contentElement}
                 * and are slid in from the side when activated.
                 * @config {String}
                 */
                layout: 'default',

                /**
                 * An object containing named config objects which may be referenced by name in any {@link #config-items}
                 * object. For example, a specialized {@link Common.widget.Menu Menu} subclass may have a `namedItems`
                 * default value defined like this:
                 *
                 * ```javascript
                 *  namedItems : {
                 *      removeRow : {
                 *          text : 'Remove row',
                 *          onItem() {
                 *              this.ownerGrid.remove(this.ownerGrid.selectedRecord);
                 *          }
                 *      }
                 *  }
                 * ```
                 *
                 * Then whenever that subclass is instantiated and configured with an {@link #config-items}
                 * object, the items may be configured like this:
                 *
                 * ```javascript
                 *  items : {
                 *      removeRow : true,   // The referenced namedItem will be applied to this
                 *      otherItemRef : {
                 *          text : 'Option 2',
                 *          onItem() {
                 *          }
                 *      }
                 * }
                 * ```
                 * @config {Object}
                 */
                namedItems: null
              };
            }
          }]);

          return Container;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_11__["default"]);

        Container._$name = 'Container';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('container', Container);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/DateField.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/widget/DateField.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetDateFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DateField;
        });
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _PickerField_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./PickerField.js */
        "../Grid/lib/Common/widget/PickerField.js");
        /* harmony import */


        var _DatePicker_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./DatePicker.js */
        "../Grid/lib/Common/widget/DatePicker.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3___default()(["<input type=\"", "\"\n            reference=\"input\"\n            class=\"", "\"\n            min=\"", "\"\n            max=\"", "\"\n            placeholder=\"", "\"\n            name=\"", "\"\n            id=\"", "\"/>"]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler'; //TODO: picker icon (calendar) should show day number

        /**
         * @module Common/widget/DateField
         */

        /**
         * Date field widget (text field + date picker).
         *
         * @extends Common/widget/PickerField
         *
         * @example
         * // minimal DateField config with date format specified
         * let dateField = new DateField({
         *   format: 'YYMMDD'
         * });
         *
         * @classType datefield
         * @externalexample widget/DateField.js
         */

        var DateField =
        /*#__PURE__*/
        function (_PickerField) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(DateField, _PickerField);

          function DateField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, DateField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(DateField, [{
            key: "inputTemplate",
            //endregion
            //region Init & destroy
            value: function inputTemplate() {
              var me = this;
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].tpl(_templateObject(), me.inputType || 'text', me.inputCls || '', me.min, me.max, me.placeholder, me.name || me.id, me.id + '_input');
            }
          }, {
            key: "onBackClick",
            //region Click listeners
            value: function onBackClick() {
              var me = this,
                  min = me.min;

              if (!me.readOnly && me.value) {
                var newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].add(me.value, -1 * me._step.magnitude, me._step.unit);

                if (!min || min.getTime() <= newValue) {
                  me.value = newValue;
                }
              }
            }
          }, {
            key: "onForwardClick",
            value: function onForwardClick() {
              var me = this,
                  max = me.max;

              if (!me.readOnly && me.value) {
                var newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].add(me.value, me._step.magnitude, me._step.unit);

                if (!max || max.getTime() >= newValue) {
                  me.value = newValue;
                }
              }
            } //endregion
            //region Toggle picker

          }, {
            key: "showPicker",
            value: function showPicker(focusPicker) {
              this.picker.value = this.picker.activeDate = this.value;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "showPicker", this).call(this, focusPicker);
            }
          }, {
            key: "focusPicker",
            value: function focusPicker() {
              this.picker.focus();
            } //endregion
            // region Validation

          }, {
            key: "transformDateValue",
            //endregion
            //region Getters/setters
            value: function transformDateValue(value) {
              if (value != null) {
                if (!(value.constructor.name === 'Date')) {
                  if (typeof value === 'string') {
                    // If date cannot be parsed with set format, try fallback - the more general one
                    value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].parse(value, this.format) || _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].parse(value, this.fallbackFormat);
                  } else {
                    value = new Date(value);
                  }
                } // We insist on a *valid* Date as the value.
                // An invalid Date object returns NaN as its valueof().


                if (value && value.constructor.name === 'Date' && !isNaN(value.valueOf())) {
                  return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].clearTime(value);
                }
              }

              return null;
            }
            /**
             * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "hasChanged",
            value: function hasChanged(oldValue, newValue) {
              if (oldValue && oldValue.getTime && newValue && newValue.getTime) {
                return oldValue.getTime() !== newValue.getTime();
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "hasChanged", this).call(this, oldValue, newValue);
            }
          }, {
            key: "updateLocalization",
            //endregion
            //region Localization
            value: function updateLocalization() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "updateLocalization", this).call(this);

              this.syncInputFieldValue();
            } //endregion
            //region Other

          }, {
            key: "internalOnKeyPress",
            value: function internalOnKeyPress(event) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "internalOnKeyPress", this).call(this, event);

              if (event.key === 'Enter' && this.isValid) {
                this.picker.hide();
              }
            } //endregion

          }, {
            key: "picker",
            get: function get() {
              if (!this._picker) {
                this.picker = true;
              }

              return this._picker;
            },
            set: function set(picker) {
              var me = this;

              if (me._picker) {
                me._picker.destroy();
              }

              me._picker = picker = new _DatePicker_js__WEBPACK_IMPORTED_MODULE_12__["default"](Object.assign({
                owner: me,
                forElement: me[me.pickerAlignElement],
                floating: true,
                scrollAction: 'realign',
                align: {
                  align: 't0-b0',
                  axisLock: true,
                  anchor: me.overlayAnchor,
                  target: me[me.pickerAlignElement]
                },
                value: me.value,
                minDate: me.min,
                maxDate: me.max,
                onSelectionChange: function onSelectionChange(_ref) {
                  var selection = _ref.selection; // We only care about what DatePicker does if it has been opened

                  if (picker.isVisible) {
                    me._isUserAction = true;
                    me.value = selection[0];
                    me._isUserAction = false;
                    picker.hide();
                  }
                }
              }, picker));

              if (me.calendarContainerCls) {
                picker.element.classList.add(me.calendarContainerCls);
              }
            } //endregion

          }, {
            key: "triggers",
            set: function set(triggers) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "triggers", _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].assign(triggers, this.stepTriggers), this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "triggers", this);
            }
          }, {
            key: "isValid",
            get: function get() {
              var me = this,
                  min = me.min,
                  max = me.max;
              me.clearError('minimumValueViolation', true);
              me.clearError('maximumValueViolation', true);
              var value = me.value;

              if (value) {
                value = value.getTime();

                if (min && min.getTime() > value) {
                  me.setError('minimumValueViolation', true);
                  return false;
                }

                if (max && max.getTime() < value) {
                  me.setError('maximumValueViolation', true);
                  return false;
                }
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "isValid", this);
            }
          }, {
            key: "min",
            set: function set(value) {
              var me = this;
              me._min = me.transformDateValue(value);
              me.input && (me.input.min = me._min);

              if (me._picker) {
                me._picker.minDate = me._min;
              }

              me.updateInvalid();
            },
            get: function get() {
              return this._min;
            }
            /**
             * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "max",
            set: function set(value) {
              var me = this;
              me._max = me.transformDateValue(value);
              me.input && (me.input.max = me._max);

              if (me._picker) {
                me._picker.maxDate = me._max;
              }

              me.updateInvalid();
            },
            get: function get() {
              return this._max;
            }
          }, {
            key: "value",
            set: function set(value) {
              var me = this,
                  oldValue = me.value,
                  picker = me._picker,
                  newValue = me.transformDateValue(value); // A value we could not parse

              if (value && !newValue) {
                // setError uses localization
                me.setError('invalidDate');
                return;
              }

              me.clearError('invalidDate'); // Reject non-change

              if (!me.hasChanged(oldValue, newValue)) {
                return;
              }

              if (picker && !me.inputting) {
                picker.value = newValue;
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "value", newValue, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DateField.prototype), "value", this);
            }
            /**
             *  The `step` property may be set in Object form specifying two properties,
             * `magnitude`, a Number, and `unit`, a String.
             *
             * If a Number is passed, the steps's current unit is used (or `day` if no current step set)
             * and just the magnitude is changed.
             *
             * If a String is passed, it is parsed in accordance with (see {@link Common.helper.DateHelper#function-format-static}.
             * The string is taken to be the numeric magnitude then an abbreviation, or name of the unit.
             *
             * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
             * @property {String|Number|Object}
             * */

          }, {
            key: "step",
            set: function set(value) {
              var me = this; // If a step is configured, show the steppers

              me.element.classList[value ? 'add' : 'remove']('b-show-steppers');

              if (typeof value === 'number') {
                value = {
                  magnitude: value,
                  unit: me._step ? me._step.unit : 'day'
                };
              } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) !== 'object') {
                value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].parseDuration(value);
              }

              if (value && value.magnitude && value.unit) {
                value.magnitude = Math.abs(value.magnitude);
                me._step = value;
                me.updateInvalid();
              }
            },
            get: function get() {
              return this._step;
            }
          }, {
            key: "inputValue",
            get: function get() {
              // Do not use the _value property. If called during configuration, this
              // will import the configured value from the config object.
              var date = this.value;
              return date ? _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].format(date, this.format) : '';
            }
            /**
             * Get/Set format for date displayed in field (see {@link Common.helper.DateHelper#function-format-static} for formatting options)
             * @property {String}
             */

          }, {
            key: "format",
            set: function set(value) {
              var me = this;
              me._format = value;
              me.syncInputFieldValue();
            },
            get: function get() {
              return this._format;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Format for date displayed in field. Defaults to using long date format, as defined by current locale (`L`)
                 * @config {String}
                 * @default
                 */
                format: 'L',
                fallbackFormat: 'YYYY-MM-DD',
                // same for all languages

                /**
                 * Format for date in picker. Uses localized format per default
                 * @config {String}
                 */
                pickerFormat: null,
                triggers: {
                  expand: {
                    cls: 'b-icon-calendar',
                    handler: 'onTriggerClick',
                    weight: 200
                  }
                },
                stepTriggers: {
                  back: {
                    cls: 'b-icon-angle-left b-step-trigger',
                    handler: 'onBackClick',
                    align: 'start',
                    weight: 100
                  },
                  forward: {
                    cls: 'b-icon-angle-right b-step-trigger',
                    handler: 'onForwardClick',
                    align: 'end',
                    weight: 100
                  }
                },
                // An optional extra CSS class to add to the picker container element
                calendarContainerCls: '',

                /**
                 * Min value
                 * @config {String|Date}
                 */
                min: null,

                /**
                 * Max value
                 * @config {String|Date}
                 */
                max: null,

                /**
                 * Time increment duration value. If specified, `forward` and `back` triggers are displayed.
                 * The value is taken to be a string consisting of the numeric magnitude and the units.
                 * The units may be a recognised unit abbreviation of this locale or the full local unit name.
                 * For example `'1d'` or `'1w'` or `'1 week'`. This may be specified as an object containing
                 * two properties: `magnitude`, a Number, and `unit`, a String
                 * @config {String|Number|Object}
                 */
                step: null,

                /**
                 * A config object used to configure the {@link Common.widget.DatePicker datePicker}.
                 * ```javascript
                 * dateField = new DateField({
                 *      picker    : {
                 *          multiSelect : true
                 *      }
                 *  });
                 * ```
                 * @config {Object}
                 */
                picker: null
              };
            }
          }]);

          return DateField;
        }(_PickerField_js__WEBPACK_IMPORTED_MODULE_11__["default"]);

        DateField._$name = 'DateField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__["default"].register('datefield', DateField);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__["default"].register('date', DateField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/DatePicker.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/widget/DatePicker.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetDatePickerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DatePicker;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _CalendarPanel_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./CalendarPanel.js */
        "../Grid/lib/Common/widget/CalendarPanel.js");
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/DatePicker
         */

        /**
         * A Panel which can display a month of date cells, which navigates between the cells,
         * fires events upon user selection actions, optionally navigates to other months
         * in response to UI gestures, and optionally displays information about each date cell.
         *
         * This class is not intended for use in applications. It is used internally by the
         * {@link Common.widget.DateField} class.
         *
         * @classtype datepicker
         */

        var DatePicker =
        /*#__PURE__*/
        function (_CalendarPanel) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(DatePicker, _CalendarPanel);

          function DatePicker() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, DatePicker);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(DatePicker).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(DatePicker, [{
            key: "construct",

            /**
             * Fires when a date is selected. If {@link #config-multiSelect} is specified, this
             * will fire upon deselection and selection of dates.
             * @event selectionChange
             * @param {Date[]} selection The selected date. If {@link #config-multiSelect} is specified
             * this may be a two element array specifying start and end dates.
             */
            value: function construct(config) {
              var me = this;
              me.selection = [];
              me.refresh = me.createOnFrame(me.refresh);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(DatePicker.prototype), "construct", this).call(this, config);

              me.element.setAttribute('aria-activedescendant', "".concat(me.id, "-active-day"));

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
                element: me.element,
                mousedown: 'onPickerMousedown',
                click: {
                  delegate: ".".concat(me.cellCls, ":not(.").concat(me.disabledCls, "):not(.").concat(me.outOfRangeCls, ")"),
                  handler: 'onCellClick'
                },
                keydown: 'onPickerKeyDown',
                thisObj: me
              });
            }
          }, {
            key: "refresh",
            value: function refresh() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(DatePicker.prototype), "refresh", this).call(this);

              this.title = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].format(this.month.date, 'MMMM YYYY');
            }
          }, {
            key: "cellRenderer",
            value: function cellRenderer(cell, cellDate) {
              var me = this,
                  activeCls = me.activeCls,
                  selectedCls = me.selectedCls,
                  cellClassList = cell.classList;
              cell.innerHTML = cellDate.getDate();
              cell.setAttribute('aria-label', _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].format(cellDate, 'MMMM D, YYYY'));

              if (me.isActiveDate(cellDate)) {
                cellClassList.add(activeCls);
                cell.id = "".concat(me.id, "-active-day");
              }

              if (me.isSelectedDate(cellDate)) {
                cellClassList.add(selectedCls);
              }

              if (me.minDate && cellDate < me.minDate) {
                cellClassList.add(me.outOfRangeCls);
              } else if (me.maxDate && cellDate > me.maxDate) {
                cellClassList.add(me.outOfRangeCls);
              }
            }
          }, {
            key: "onPickerMousedown",
            value: function onPickerMousedown(event) {
              event.preventDefault();
            }
          }, {
            key: "onCellClick",
            value: function onCellClick(event) {
              this.onDateActivate(_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].parse(event.target.dataset.date, 'YYYY-MM-DD'), event);
            }
          }, {
            key: "onDateActivate",
            value: function onDateActivate(date, event) {
              var me = this,
                  lastClickedDate = me.lastClickedDate,
                  selection = me.selection;
              me.activeDate = date;
              me.lastClickedDate = date; // Handle multi selecting.
              // * single contiguous date range, eg: an event start and end
              // * multiple discontiguous ranges

              if (me.multiSelect) {
                if (me.multiRange) {// TODO: multiple date ranges
                } else if (!lastClickedDate || date.getTime() !== lastClickedDate.getTime()) {
                  if (lastClickedDate && event.shiftKey) {
                    selection[1] = date;
                    selection.sort();
                  } else {
                    selection.length = 0;
                    selection[0] = date;
                  }

                  me.trigger('selectionChange', {
                    selection: selection
                  });
                }
              } else {
                if (!me.value || me.value.getTime() !== date.getTime()) {
                  me.value = date;
                } else {
                  me.hide();
                }
              }
            }
          }, {
            key: "onPickerKeyDown",
            value: function onPickerKeyDown(keyEvent) {
              var me = this,
                  keyName = keyEvent.key.trim() || keyEvent.code,
                  activeDate = me.activeDate;
              var newDate = new Date(activeDate);

              if (activeDate) {
                do {
                  switch (keyName) {
                    case 'Escape':
                      me.hide();
                      break;

                    case 'ArrowLeft':
                      if (keyEvent.ctrlKey) {
                        // Disable browser use of this key
                        keyEvent.preventDefault();
                        newDate.setMonth(newDate.getMonth() - 1);
                      } else {
                        newDate.setDate(newDate.getDate() - 1);
                      }

                      break;

                    case 'ArrowUp':
                      newDate.setDate(newDate.getDate() - 7);
                      break;

                    case 'ArrowRight':
                      if (keyEvent.ctrlKey) {
                        // Disable browser use of this key
                        keyEvent.preventDefault();
                        newDate.setMonth(newDate.getMonth() + 1);
                      } else {
                        newDate.setDate(newDate.getDate() + 1);
                      }

                      break;

                    case 'ArrowDown':
                      newDate.setDate(newDate.getDate() + 7);
                      break;

                    case 'Enter':
                      me.onDateActivate(activeDate, keyEvent);
                      break;
                  }
                } while (me.isDisabledDate(newDate) && !me.focusDisabledDates); // Don't allow navigation to outside of date bounds.


                if (me.minDate && newDate < me.minDate) {
                  return;
                }

                if (me.maxDate && newDate > me.maxDate) {
                  return;
                }

                me.activeDate = newDate;
              }
            }
          }, {
            key: "gotoPrevMonth",
            value: function gotoPrevMonth() {
              var date = this.date;
              date.setMonth(date.getMonth() - 1);
              this.date = date;
            }
          }, {
            key: "gotoNextMonth",
            value: function gotoNextMonth() {
              var date = this.date;
              date.setMonth(date.getMonth() + 1);
              this.date = date;
            }
          }, {
            key: "isActiveDate",
            value: function isActiveDate(date) {
              return this.activeDate && this.ingestDate(date).getTime() === this.activeDate.getTime();
            }
          }, {
            key: "isSelectedDate",
            value: function isSelectedDate(date) {
              return this.selection.some(function (d) {
                return d.getTime() === date.getTime();
              });
            }
          }, {
            key: "focusElement",
            get: function get() {
              return this.element;
            }
          }, {
            key: "minDate",
            set: function set(minDate) {
              this._minDate = minDate ? this.ingestDate(minDate) : null;
              this.refresh();
            },
            get: function get() {
              return this._minDate;
            }
          }, {
            key: "maxDate",
            set: function set(maxDate) {
              this._maxDate = maxDate ? this.ingestDate(maxDate) : null;
              this.refresh();
            },
            get: function get() {
              return this._maxDate;
            }
          }, {
            key: "activeDate",
            set: function set(activeDate) {
              var me = this;

              if (activeDate) {
                me._activeDate = me.ingestDate(activeDate);
              } else {
                me._activeDate = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].clearTime(new Date());
              } // New active date is in another month


              if (me.month.month !== me._activeDate.getMonth()) {
                me.month.date = me._activeDate;
              }

              me.refresh();
            },
            get: function get() {
              return this._activeDate;
            }
          }, {
            key: "value",
            set: function set(date) {
              var me = this,
                  selection = me.selection;
              var changed;

              if (date) {
                date = me.ingestDate(date);

                if (!me.value || date.getTime() !== me.value.getTime()) {
                  selection.length = 0;
                  selection[0] = date;
                  me.date = date;
                  changed = true;
                }
              } else {
                changed = selection.length;
                selection.length = 0; // Clearing the value - go to today's calendar

                me.date = new Date();
              }

              if (changed) {
                me.trigger('selectionChange', {
                  selection: selection
                });
              }
            },
            get: function get() {
              return this.selection[this.selection.length - 1];
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                focusable: true,
                tools: {
                  prevMonth: {
                    align: 'start',
                    cls: 'b-icon b-icon-angle-left',
                    handler: 'gotoPrevMonth'
                  },
                  nextMonth: {
                    align: 'end',
                    cls: 'b-icon b-icon-angle-right',
                    handler: 'gotoNextMonth'
                  }
                },
                header: {
                  title: '\xa0',
                  titleAlign: 'center'
                },

                /**
                 * The minimum selectable date. Selection of and navigtion to dates prior
                 * to this date will not be possible.
                 * @config {Date}
                 */
                minDate: null,

                /**
                 * The maximum selectable date. Selection of and navigtion to dates after
                 * this date will not be possible.
                 * @config {Date}
                 */
                maxDate: null,

                /**
                 * The class name to add to the calendar cell whose date which is outside of the
                 * {@link #config-minDate}/{@link #config-maxDate} range.
                 * @config {String}
                 * @private
                 */
                outOfRangeCls: 'b-out-of-range',

                /**
                 * The class name to add to the currently focused calendar cell.
                 * @config {String}
                 * @private
                 */
                activeCls: 'b-active-date',

                /**
                 * The class name to add to selected calendar cells.
                 * @config {String}
                 * @private
                 */
                selectedCls: 'b-selected-date',

                /**
                 * By default, disabled dates cannot be navigated to, and they are skipped over
                 * during keyboard navigation. Configure this as `true` to enable navigation to
                 * disabled dates.
                 * @config {Boolean}
                 * @default
                 */
                focusDisabledDates: null,

                /**
                 * Configure as `true` to enable selecting a single date range by selecting a
                 * start and end date.
                 * @config {Boolean}
                 * @default
                 */
                multiSelect: false
              };
            }
          }]);

          return DatePicker;
        }(_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        DatePicker._$name = 'DatePicker';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__["default"].register('datepicker', DatePicker);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/DisplayField.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Common/widget/DisplayField.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetDisplayFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DisplayField;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _TextField_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./TextField.js */
        "../Grid/lib/Common/widget/TextField.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/DisplayField
         */

        /**
         * DisplayField widget used to show a read only value
         *
         * @extends Common/widget/Field
         *
         * @example
         * let displayField = new DisplayField({
         *   label: 'name',
         *   value : 'John Doe'
         * });
         *
         * @classType DisplayField
         * @externalexample widget/DisplayField.js
         */

        var DisplayField =
        /*#__PURE__*/
        function (_TextField) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(DisplayField, _TextField);

          function DisplayField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, DisplayField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(DisplayField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(DisplayField, [{
            key: "focusElement",
            get: function get() {// we're not focusable.
            }
          }, {
            key: "readOnly",
            set: function set(value) {// empty, to not allow changing readOnly status
            },
            get: function get() {
              return true;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                readOnly: true,
                editable: false,
                cls: 'b-display-field'
              };
            }
          }]);

          return DisplayField;
        }(_TextField_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        DisplayField._$name = 'DisplayField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__["default"].register('display', DisplayField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/DurationField.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/widget/DurationField.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetDurationFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DurationField;
        });
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _TextField_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./TextField.js */
        "../Grid/lib/Common/widget/TextField.js");
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/DurationField
         */

        /**
         * A specialized field allowing a user to also specify duration unit when editing the duration value.
         *
         * @extends Common/widget/TextField
         *
         * @classType durationfield
         */

        var DurationField =
        /*#__PURE__*/
        function (_TextField) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(DurationField, _TextField);

          function DurationField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DurationField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(DurationField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DurationField, [{
            key: "valueToVisible",
            value: function valueToVisible(magnitude, unit) {
              if (!isNaN(magnitude)) {
                var valueInt = parseInt(magnitude, 10); // could happen if magnitude is null

                if (!isNaN(valueInt)) {
                  var valueFixed = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].toFixed(magnitude, this.decimalPrecision);

                  return String(valueInt == valueFixed ? valueInt : valueFixed) + ' ' + _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"][this.useAbbreviation ? 'getShortNameOfUnit' : 'getLocalizedNameOfUnit'](unit || this.unit, magnitude !== 1);
                }
              }

              return '';
            }
          }, {
            key: "parseDuration",
            value: function parseDuration(value) {
              if (value == null) {
                return null;
              }

              var duration = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].parseDuration(value, this.allowDecimals, this.unit);

              if (!duration) {
                return null;
              }

              duration.unit = duration.unit || this.unit;
              return duration;
            }
          }, {
            key: "internalOnChange",
            value: function internalOnChange(event) {
              var me = this,
                  value = me.value,
                  oldVal = me._lastValue;

              if (me.hasChanged(oldVal, value)) {
                me._lastValue = value;
                me.trigger('change', {
                  value: value,
                  event: event,
                  userAction: true,
                  valid: me.isValid
                });
              }
            }
          }, {
            key: "onFocusOut",
            value: function onFocusOut(e) {
              this.syncInputFieldValue();
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(DurationField.prototype), "onFocusOut", this).call(this, e);
            }
            /**
             * The `value` property may be set in Object form specifying two properties,
             * `magnitude`, a Number, and `unit`, a String.
             *
             * If a Number is passed, the field's current unit is used and just the magnitude is changed.
             *
             * If a String is passed, it is parsed in accordance with current locale rules.
             * The string is taken to be the numeric magnitude, followed by whitespace, then an abbreviation, or name of the unit.
             *
             * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
             * @property {String|Number|Object}
            */

          }, {
            key: "hasChanged",
            value: function hasChanged(oldValue, newValue) {
              return newValue && !oldValue || !newValue && oldValue || newValue && oldValue && (newValue.magnitude != oldValue.magnitude || newValue.unit != oldValue.unit);
            }
            /**
             * The `milliseconds` property is a read only property which returns the
             * number of milliseconds in this field's value
             * @property {Number}
             */

          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(keyEvent) {
              if (keyEvent.key === 'ArrowUp') {
                this.doSpinUp();
              } else if (keyEvent.key === 'ArrowDown') {
                this.doSpinDown();
              }
            }
          }, {
            key: "doSpinUp",
            value: function doSpinUp() {
              var me = this,
                  value = me.value;
              me._isUserAction = true;
              me.value = {
                unit: value.unit,
                // null magnitude will result NaN
                magnitude: (value.magnitude || 0) + me.step
              };
              me._isUserAction = false;
            }
          }, {
            key: "doSpinDown",
            value: function doSpinDown() {
              var me = this,
                  value = me.value;

              if (me.allowNegative || value.magnitude > 0) {
                me._isUserAction = true;
                me.value = {
                  unit: value.unit,
                  // null magnitude will result NaN
                  magnitude: (value.magnitude || 0) - me.step
                };
                me._isUserAction = false;
              }
            }
          }, {
            key: "inputValue",
            get: function get() {
              // Do not use the _value property. If called during configuration, this
              // will import the configured value from the config object.
              var value = this.value;
              return value == null ? '' : this.valueToVisible(value.magnitude, value.unit);
            }
          }, {
            key: "unit",
            set: function set(unit) {
              this.value = {
                magnitude: _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(DurationField.prototype), "value", this),
                unit: unit
              };
            },
            get: function get() {
              return this._unit;
            }
          }, {
            key: "isValid",
            get: function get() {
              var me = this;
              return me.value == null && me.clearable && !me.required || me.value != null && (me.allowNegative || me.value.magnitude >= 0);
            }
          }, {
            key: "value",
            set: function set(value) {
              var me = this; // A number means maintain the unit type

              if (typeof value === 'number') {
                value = {
                  magnitude: value,
                  unit: me._unit
                };
              } // Not an object, parse as a string
              else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) !== 'object') {
                  value = me.parseDuration(value);
                }

              if (me.value !== value) {
                // Only change the value if the input is valid
                if (value) {
                  me._unit = value.unit;

                  _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(DurationField.prototype), "value", value, this, true);
                } else {
                  me._unit = me.clearable ? null : 0;

                  _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(DurationField.prototype), "value", me.clearable ? null : 0, this, true);
                }
              }
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(DurationField.prototype), "value", this);
            }
          }, {
            key: "milliseconds",
            get: function get() {
              var v = this.value;
              return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].asMilliseconds(v.magnitude, v.unit);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The `value` config may be set in Object form specifying two properties,
                 * `magnitude`, a Number, and `unit`, a String.
                 *
                 * If a String is passed, it is parsed in accordance with current locale rules.
                 * The string is taken to be the numeric magnitude, followed by whitespace, then an abbreviation, or name of the unit.
                 * @config {Object|String}
                */
                value: null,
                step: 1,

                /**
                 * The duration unit to use with the current magnitude value.
                 * @config {String}
                 */
                unit: null,

                /**
                 * When set to `true` the field will use short names of unit durations
                 * (as returned by {@link Common.helper.DateHelper#function-getShortNameOfUnit-static}) when creating the
                 * input field's display value.
                 * @config {Boolean}
                 */
                useAbbreviation: false,

                /**
                 * Set to `true` to allow negative duration
                 * @config {Boolean}
                 */
                allowNegative: false,
                triggers: {
                  spin: {
                    type: 'spintrigger'
                  }
                }
              };
            }
          }]);

          return DurationField;
        }(_TextField_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        DurationField._$name = 'DurationField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('durationfield', DurationField);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('duration', DurationField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Editor.js":
      /*!*******************************************!*\
        !*** ../Grid/lib/Common/widget/Editor.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetEditorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Editor;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _Container_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Container.js */
        "../Grid/lib/Common/widget/Container.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");
        /* harmony import */


        var _layout_Fit_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ./layout/Fit.js */
        "../Grid/lib/Common/widget/layout/Fit.js");
        /* harmony import */


        var _helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Editor
         */

        /**
         * Displays an input field, optionally editing a field of a record at a particular position.
         *
         * Offers events to signal edit completion upon `ENTER` or focus loss (if configured to do so),
         * or edit cancellation on `ESC`, or focus loss if configured that way.
         * @extends Common/widget/Container
         *
         * @classType Editor
         */

        var Editor =
        /*#__PURE__*/
        function (_Container) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Editor, _Container);

          function Editor() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Editor);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Editor).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Editor, [{
            key: "afterConfigure",
            //endregion
            //region Events

            /**
             * Fired before the editor is shown to start an edit operation. Returning `false` from a handler vetoes the edit operation.
             * @event beforestart
             * @property {Object} value - The value to be edited.
             * @preventable
             */

            /**
             * Fired when an edit operation has begun.
             * @event start
             * @property {Object} value - The starting value of the field.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             */

            /**
             * Fired when an edit completion has been requested, either by `ENTER`, or focus loss (if configured to complete on blur).
             * The completion may be vetoed, in which case, focus is moved back into the editor.
             * @event beforecomplete
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The new value.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             * @preventable
             */

            /**
             * Edit has been completed, and any associated record or element has been updated.
             * @event complete
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The new value.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             */

            /**
             * Fired when cancellation has been requested, either by `ESC`, or focus loss (if configured to cancel on blur).
             * The cancellation may be vetoed, in which case, focus is moved back into the editor.
             * @event beforecancel
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The new value.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             * @preventable
             */

            /**
             * Edit has been canceled without updating the associated record or element.
             * @event cancel
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The value of the field.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             */

            /**
             * Fire to relay a `keypress` event from the field.
             * @event keypress
             * @property {Event} event - The key event.
             */
            //endregion
            value: function afterConfigure() {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Editor.prototype), "afterConfigure", this).call(this);

              if (me.completeKey || me.cancelKey) {
                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on({
                  element: me.element,
                  keydown: 'onKeyDown',
                  thisObj: me
                });
              }

              _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].on({
                locale: 'onLocaleChange',
                thisObj: me
              });
            }
          }, {
            key: "onLocaleChange",
            value: function onLocaleChange() {
              var me = this;

              if (me.inputField) {
                me.inputField.syncInputFieldValue();
              }
            }
            /**
             * Start editing
             * @param {Object} editObject An object containing details about what to edit.
             * @param {HTMLElement/Common.helper.util.Rectangle} editObject.target the element or Rectangle to align to.
             * @param {String} [editObject.align=t0-t0] How to align to the target.
             * @param {Boolean} [editObject.matchSize=true] Match editor size to target size.
             * @param {Common.data.Model} [editObject.record] The record to edit.
             * @param {String} [editObject.field] The field name in the record to edit. This defaults to the `name` of the {@link #config-inputField}.
             * Also if record has method set + capitalized field, method will be called, e.g. if record has method named
             * `setFoobar` and this config is `foobar`, then instead of `record.foobar = value`, `record.setFoobar(value)` will be called.
             * @param {Object} [editObject.value] The value to edit.
             * @param {Boolean} [editObject.focus=true] Focus the field.
             */

          }, {
            key: "startEdit",
            value: function startEdit(_ref) {
              var target = _ref.target,
                  _ref$align = _ref.align,
                  align = _ref$align === void 0 ? 't0-t0' : _ref$align,
                  _ref$matchSize = _ref.matchSize,
                  matchSize = _ref$matchSize === void 0 ? true : _ref$matchSize,
                  value = _ref.value,
                  record = _ref.record,
                  _ref$field = _ref.field,
                  field = _ref$field === void 0 ? this.inputField.name : _ref$field,
                  _ref$focus = _ref.focus,
                  focus = _ref$focus === void 0 ? true : _ref$focus;
              var me = this,
                  inputField = me.inputField,
                  targetRect = target instanceof _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"] ? target : _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].inner(target);

              if (me.trigger('beforestart', {
                value: value
              }) !== false) {
                if (record && field && value === undefined) {
                  me.record = record;
                  me.dataField = field;
                  value = record[field];
                }

                if (matchSize) {
                  me.width = targetRect.width;
                  me.height = targetRect.height;
                }

                inputField.value = value;
                me.showBy({
                  target: target,
                  align: align
                });

                if (focus && me.inputField.focus) {
                  me.inputField.focus();
                }

                if (target.nodeType === 1) {
                  target.classList.add('b-editing');
                } // Passed value may have been '10/06/2019', send the live field value to startedit


                me.trigger('start', {
                  value: inputField.value
                });
                me.oldValue = inputField.value; // If the value from th value getter is an array, we must clone it because
                // if it's the same *instance*, the ObjectHelper.isEqual test in completeEdit
                // will find that there are no changes.

                if (Array.isArray(me.oldValue)) {
                  me.oldValue = me.oldValue.slice();
                }

                return true;
              }

              return false;
            }
          }, {
            key: "refreshEdit",
            value: function refreshEdit() {
              if (this.isVisible) {
                var record = this.record,
                    dataField = this.dataField,
                    inputField = this.inputField;

                if (record && dataField) {
                  var value = record[dataField]; // Only update the field if the value has changed

                  if (!_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isEqual(inputField.value, value)) {
                    inputField.value = value;
                  }
                }
              }
            }
          }, {
            key: "onKeyDown",
            value: function onKeyDown(event) {
              var me = this;

              switch (event.key) {
                case me.completeKey:
                  me.completeEdit();
                  event.stopImmediatePropagation();
                  break;

                case me.cancelKey:
                  me.cancelEdit();
                  event.stopImmediatePropagation();
                  break;
              }

              me.trigger('keydown', {
                event: event
              });
            }
          }, {
            key: "onFocusOut",
            value: function onFocusOut(event) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Editor.prototype), "onFocusOut", this).call(this, event);

              if (!this.isFinishing) {
                var method = this["".concat(this.blurAction, "Edit")];

                if (method) {
                  method.call(this);
                }
              }
            }
            /**
             * Complete the edit, and, if associated with a record, update the record if possible.
             * If editing is completed, the editor is hidden.
             *
             * If the field is invalid, and this Editor is configured `{@link #config-allowInvalid}: false`
             * then editing is not completed.
             *
             * If a {@link #event-beforecomplete} handler returns `false` then editing is not completed.
             *
             * If the field's valus has not been changed, then editing is terminated through {@link #function-cancelEdit}.
             *
             * @returns `true` if editing ceased, `false` if the editor is still active.
             */

          }, {
            key: "completeEdit",
            value: function completeEdit() {
              var me = this,
                  inputField = me.inputField,
                  oldValue = me.oldValue,
                  value = inputField.value; // If we're configured not to allow invalid values, refocus the field in case complete was triggered by focusout.

              if (!inputField.isValid && !(me.allowInvalid || inputField.allowInvalid)) {
                inputField.focus && inputField.focus();
                return false;
              } // No change means a cancel.
              else if (_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isEqual(value, oldValue)) {
                  me.cancelEdit();
                  return true;
                } // Allow veto of the completion
                else {
                    var context = {
                      value: value,
                      oldValue: oldValue
                    };

                    if (me.trigger('beforecomplete', context) === false) {
                      inputField.focus && inputField.focus();
                    } // EXPERIMENTAL: Allow async finalization of the editing, implementer may want to show a confirmation popup etc
                    else if (context.async) {
                        context.async.then(function (result) {
                          if (result === true) {
                            me.onEditComplete();
                          } else {
                            inputField.setError(result || inputField.L('invalidValue'));

                            if (!(me.allowInvalid || inputField.allowInvalid)) {
                              inputField.focus && inputField.focus();
                            }
                          }
                        });
                        return false;
                      } // Successful completion
                      else {
                          me.onEditComplete();
                          return true;
                        }
                  }

              return false;
            }
            /**
             * Cancel the edit and hide the editor.
             */

          }, {
            key: "cancelEdit",
            value: function cancelEdit() {
              var me = this,
                  inputField = me.inputField,
                  oldValue = me.oldValue,
                  value = inputField.value;

              if (!me.isFinishing && me.trigger('beforecancel', {
                value: value,
                oldValue: oldValue
              }) !== false) {
                // Hiding must not trigger our blurAction
                me.isFinishing = true;
                me.hide();
                me.trigger('cancel', {
                  value: value,
                  oldValue: oldValue
                });
                me.isFinishing = false;
              }
            } // Handle updating what needs to be updated.

          }, {
            key: "onEditComplete",
            value: function onEditComplete() {
              var me = this,
                  record = me.record,
                  dataField = me.dataField,
                  inputField = me.inputField,
                  oldValue = me.oldValue,
                  lastAlignSpec = me.lastAlignSpec,
                  target = lastAlignSpec.target,
                  value = inputField.value;

              if (!me.isFinishing) {
                // Hiding must not trigger our blurAction
                me.isFinishing = true;
                me.hide();

                if (record) {
                  var setterName = "set".concat(_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].capitalizeFirstLetter(dataField));

                  if (record[setterName]) {
                    record[setterName](value);
                  } else {
                    record[dataField] = value;
                  }
                }

                me.trigger('complete', {
                  value: value,
                  oldValue: oldValue
                });

                if (target.nodeType === 1) {
                  target.classList.remove('b-editing');
                }

                me.isFinishing = false;
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              if (this.createdInputField) {
                this.inputField.destroy();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Editor.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "owner",
            set: function set(owner) {
              this._owner = owner;
            } // This is a positioned widget appended to a Widget's contentElement. It has no owner link.
            // Grab the owner by finding what widget it is inside.
            ,
            get: function get() {
              return this._owner || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].fromElement(this.element.parentNode);
            }
          }, {
            key: "items",
            get: function get() {
              return this._items = [this.inputField];
            }
          }, {
            key: "inputField",
            set: function set(inputField) {
              var me = this;

              if (me._inputField) {
                me._inputField.destroy();
              }

              if (typeof inputField === 'string') {
                inputField = {
                  type: inputField
                };
              }

              if (inputField instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_7__["default"]) {
                me._inputField = inputField;
              } else {
                me._inputField = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].createWidget(inputField);
                me.createdInputField = true; // So we know we can destroy it
              }

              me._inputField.parent = me;
            },
            get: function get() {
              return this._inputField;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                positioned: true,
                hidden: true,
                layout: 'fit',

                /**
                 * A config object, or the `type` string of the input field which this editor will encapsulate.
                 * @config {Object|String}
                 * @default
                 */
                inputField: 'textfield',

                /**
                 * What action should be taken when focus moves out of the editor, either by `TAB` or clicking outside.
                 * May be `'complete'` or `'cancel`'. Any other value results in no action being taken upon focus leaving the editor
                 * leaving the application to listen for the {@link Common.widget.Widget#event-focusout focusout} event.
                 * @config {String}
                 * @default
                 */
                blurAction: 'complete',

                /**
                 * The name of the `key` which completes the edit.
                 *
                 * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
                 * @config {String}
                 * @default
                 */
                completeKey: 'Enter',

                /**
                 * The name of the `key` which cancels the edit.
                 *
                 * See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values for key names.
                 * @config {String}
                 * @default
                 */
                cancelKey: 'Escape',

                /**
                 * Configure as `true` to allow editing to complete when the field is invalid. Editing may always be _canceled_.
                 * @config {String}
                 * @default
                 */
                allowInvalid: false
              };
            }
          }]);

          return Editor;
        }(_Container_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        Editor._$name = 'Editor';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_14__["default"].register('editor', Editor);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Field.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Common/widget/Field.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Field;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _Tooltip_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _mixin_Badge_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./mixin/Badge.js */
        "../Grid/lib/Common/widget/mixin/Badge.js");
        /* harmony import */


        var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../util/ClickRepeater.js */
        "../Grid/lib/Common/util/ClickRepeater.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Field
         */

        var byWeight = function byWeight(l, r) {
          return (l.weight || 0) - (r.weight || 0);
        },
            byWeightReverse = function byWeightReverse(l, r) {
          return (r.weight || 0) - (l.weight || 0);
        },
            arrayOption = {
          array: true
        };
        /**
         * Base class for TextField and NumberField. Not to be used directly.
         * @extends Common/widget/Widget
         * @mixes Common/widget/mixin/Badge
         * @abstract
         */


        var Field =
        /*#__PURE__*/
        function (_Badge) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Field, _Badge);

          function Field() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Field);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Field).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Field, [{
            key: "doDestroy",
            value: function doDestroy() {
              var errorTip = Field._errorTip;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Field.prototype), "doDestroy", this).call(this); // The errorTip references this field, hide it when we die.


              if (errorTip && errorTip.field === this) {
                errorTip.hide();
              }
            }
            /**
             * A singleton error tooltip which activates on hover of invalid fields.
             * before show, it gets a reference to the field and interrogates its
             * active error list to display as the tip content.
             * @member {Common.widget.Tooltip}
             * @readonly
             */

          }, {
            key: "construct",
            //endregion
            //region Event

            /**
             * User typed into the field
             * @event input
             * @param {Common.widget.Field} source - The field
             * @param {String} value - Value
             */

            /**
             * Fired when the field value changes
             * @event change
             * @param {String} value - Value
             * @param {String} oldValue - Previous value
             * @param {Boolean} userAction - Triggered by user taking an action (`true`) or by setting a value (`false`)
             * @param {Common.widget.Field} source - Field
             */

            /**
             * User performed default action (typed into the field)
             * @event click
             * @param {Common.widget.Field} field - Field
             * @param {String} value - Value
             */

            /**
             * User clicked fields clear icon
             * @event clear
             * @param {Common.widget.Field} field - Field
             */

            /*
             * User clicked on one of the field's {@link #property-triggers}
             * @event trigger
             * @param {Common.widget.Field.Trigger} trigger The trigger activated by click or touch tap.
             * @param {Common.widget.Field} trigger.field The trigger's owning Field.
             */
            //endregion
            //region Init
            value: function construct(config) {
              var me = this;
              me.highlightChanged = me.createOnFrame('addUpdatedCls');

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Field.prototype), "construct", this).call(this, config); // Instantiate error tip
              // eslint-disable-next-line


              Field.errorTip;

              if (me.keyStrokeChangeDelay) {
                me.changeOnKeyStroke = me.buffer(me.internalOnChange, me.keyStrokeChangeDelay);
              }
            }
          }, {
            key: "onFocusOut",
            value: function onFocusOut(e) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Field.prototype), "onFocusOut", this).call(this, e); // Check field consistency on blur


              this.onEditComplete();
            }
            /**
             * Template function which may be implemented by subclasses to synchronize
             * input state and validity state upon completion of the edit.
             * @internal
             */

          }, {
            key: "onEditComplete",
            value: function onEditComplete() {}
          }, {
            key: "select",

            /**
             * Selects the field contents. Optionally may be passed a start and end.
             * NOTE: This method is async for IE11
             * @param {Number} [start] The start index from which to select the input.
             * @param {Number} [end] The index at which to end the selection of the input.
             */
            value: function select(start, end) {
              // Use focusElement which is the input field in this class
              // but allows subclasses to use other elements.
              // See, for example, TextAreaField
              var input = this.focusElement;

              if (input.value.length) {
                if (arguments.length === 0) {
                  this.selectAll();
                  return;
                } // Only allowed to select range in certain element / input types


                if (!this.supportsTextSelection) {
                  return; // throw new Error('Trying to select text on an invalid element type');
                }

                if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isIE11) {
                  // this.clearTimeout(this.selectTimeout);
                  // HACK: IE focus processing is async and we can't select text until field is focused
                  // Getting flaky exception in IE, something timing related. Found no way to detect it so using this
                  // workaround for now
                  input.focus();
                  input.setSelectionRange(start, end); //
                  // this.selectTimeout = this.setTimeout(() => {
                  //     input && input.setSelectionRange(start, end);
                  // }, 10);
                } else {
                  input.setSelectionRange(start, end);
                }
              }
            }
          }, {
            key: "moveCaretToEnd",
            value: function moveCaretToEnd() {
              var input = this.input;

              if (input.createTextRange) {
                var range = input.createTextRange();
                range.collapse(false);
                range.select();
              } else if (this.supportsTextSelection) {
                // Move caret to the end if possible
                this.select(input.value.length, input.value.length);
              }
            }
          }, {
            key: "selectAll",
            value: function selectAll() {
              this.focusElement.select();
            } // called on value changes to update styling of empty vs non-empty field

          }, {
            key: "updateEmpty",
            value: function updateEmpty() {
              var isEmptyInput = this.isEmptyInput,
                  isEmpty = this.isEmpty,
                  element = this.element,
                  clearIcon = this.clearIcon,
                  empty = isEmptyInput && isEmpty;

              if (element) {
                if (clearIcon) {
                  // IE11...
                  clearIcon.classList[empty ? 'add' : 'remove']('b-icon-hidden');
                } // IE11...


                element.classList[empty ? 'add' : 'remove']('b-empty');
              }
            }
          }, {
            key: "updateInvalid",
            value: function updateInvalid() {
              var isValid = this.isValid,
                  element = this.element,
                  errorTip = this.errorTip,
                  inputWrap = this.inputWrap;

              if (element) {
                element.classList[isValid ? 'remove' : 'add']('b-invalid'); // We achieved validity, so ensure the error tip is hidden

                if (isValid) {
                  if (errorTip.isVisible && errorTip.field === this) {
                    errorTip.hide();
                  }
                } // If the mouse is over, the tip should spring into view
                else if (inputWrap.contains(_Tooltip_js__WEBPACK_IMPORTED_MODULE_10__["default"].currentOverElement)) {
                    // Already shown by this field's inputWrap, just update content.
                    if (errorTip.activeTarget === inputWrap && errorTip.isVisible) {
                      errorTip.onBeforeShow();
                    } else {
                      errorTip.activeTarget = inputWrap;
                      errorTip.showBy(inputWrap);
                    }
                  }
              }
            } //endregion
            //region Getters/setters

          }, {
            key: "hasChanged",

            /**
             * Compare's this field's value with its previous value. May be overridden in subclasses
             * which have more complex value types. See, for example, {@link Common.widget.DurationField}.
             * @param {*} oldValue
             * @param {*} newValue
             * @private
             */
            value: function hasChanged(oldValue, newValue) {
              return newValue !== oldValue;
            }
            /**
             * Called by the base Field class's `set value` to sync the state of the UI with the field's value.
             *
             * Relies upon the class implementation of `get inputValue` to return a string representation of
             * the value for user consumption and editing.
             * @private
             */

          }, {
            key: "syncInputFieldValue",
            value: function syncInputFieldValue() {
              var me = this,
                  input = me.input; // If we are updating from internalOnInput, we must not update the input field

              if (input && !me.inputting) {
                // Subclasses may implement their own read only inputValue property.
                me.input.value = me.inputValue; // If it's being manipulated from the outside, highlight it

                if (!me.isConfiguring && !me.containsFocus && me.highlightExternalChange) {
                  input.classList.remove('b-field-updated');
                  me.clearTimeout('removeUpdatedCls');
                  me.highlightChanged();
                }
              }

              me.updateEmpty();
              me.updateInvalid();
            }
          }, {
            key: "addUpdatedCls",
            value: function addUpdatedCls() {
              this.input.classList.add('b-field-updated');
              this.setTimeout('removeUpdatedCls', 1500);
            }
          }, {
            key: "removeUpdatedCls",
            value: function removeUpdatedCls() {
              this.input.classList.remove('b-field-updated');
            }
            /**
             * A String representation of the value of this field for {@link #function-syncInputFieldValue} to use
             * as the input element's value.
             *
             * Subclasses may override this to create string representations.
             *
             * For example, {@link Common.widget.DateField}'s implementation will format the field date
             * value according to its configured {@link Common.widget.DateField#config-format}. And {@link Common.widget.Combo}'s
             * implementation will return the {@link Common.widget.Combo#config-displayField} of the selected record.
             * @internal
             * @readOnly
             */

          }, {
            key: "internalOnInputFocus",
            //endregion
            //region Events
            value: function internalOnInputFocus() {
              var length = this.input.value.length; // Help IE to set caret at the end like the other browsers

              if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isIE11 && length && !this.autoSelect) {
                this.select(length, length);
              }
            }
            /**
             * Trigger event when fields input changes
             * @fires change
             * @private
             */

          }, {
            key: "internalOnChange",
            value: function internalOnChange(event) {
              var me = this,
                  value = me.value,
                  oldValue = me._lastValue; // Don't trigger change if we enter invalid value or if value has not changed (for IE when pressing ENTER)

              if (me.isValid && value !== oldValue) {
                me._lastValue = value; // trigger change event, signaling that origin is from user

                me.trigger('change', {
                  value: value,
                  oldValue: oldValue,
                  event: event,
                  userAction: true
                }); // per default Field triggers action event on change, but might be reconfigured in subclasses (such as Combo)

                if (me.defaultAction === 'change') {
                  me.trigger('action', {
                    value: value,
                    oldValue: oldValue,
                    event: event
                  });
                }
              } // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onClick and onAction

            }
            /**
             * Trigger event when user inputs into field
             * @fires input
             * @param event
             * @private
             */

          }, {
            key: "internalOnInput",
            value: function internalOnInput(event) {
              var me = this; // Keep the value synced with the inputValue at all times.

              me.inputting = true;
              me.value = me.input.value;
              me.inputting = false;
              me.trigger('input', {
                value: me.value,
                event: event
              });
              me.changeOnKeyStroke && me.changeOnKeyStroke(event); // since Widget has Events mixed in configured with 'callOnFunctions' this will also call onInput
            }
          }, {
            key: "internalOnKeyPress",
            value: function internalOnKeyPress(event) {
              var me = this;

              if (event.type === 'keydown') {
                if (event.key === 'Escape' && !me.readOnly && me.clearable) {
                  me.clear(); // don't allow further processing of this event if it had destructive consequences

                  if (me.isDestroyed) {
                    event.stopImmediatePropagation();
                    return;
                  }
                } // #5730 - IE11 doesn't trigger "change" event by Enter click
                else if (event.key === 'Enter' && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isIE11) {
                    this.internalOnChange(event);
                  }
              }

              me.trigger(event.type, {
                event: event
              });
            }
          }, {
            key: "clear",
            value: function clear() {
              this.value = null;
              this.trigger('clear');
            } //endregion
            //region Error

            /**
             * Adds an error message to the list of errors on this field.
             * By default the field's valid/invalid state is updated; pass
             * `false` as the second parameter to disable that if multiple
             * changes are being made to the error state.
             * @param {String} error A locale string, or message to use as an error message.
             * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
             */

          }, {
            key: "setError",
            value: function setError(error, silent) {
              (this.errors || (this.errors = {}))[error] = this.L(error);

              if (!silent) {
                this.updateInvalid();
              }
            }
            /**
             * Removes an error message from the list of errors on this field.
             * By default the field's valid/invalid state is updated; pass
             * `false` as the second parameter to disable that if multiple
             * changes are being made to the error state.
             * @param {String} error A locale string, or message to remove.
             * @param {Boolean} [silent=false] Pass as `true` to skip updating the field's valid/invalid state.
             */

          }, {
            key: "clearError",
            value: function clearError(error, silent) {
              if (this.errors) {
                delete this.errors[error];
              }

              if (!silent) {
                this.updateInvalid();
              }
            }
            /**
             * Returns an array of error messages as set by {@link #function-setError}, or
             * `undefined` if there are currently no errors.
             * @return {String[]} The errors for this field, or `undefined` if there are no errors.
             */

          }, {
            key: "getErrors",
            value: function getErrors() {
              if (!this.isValid) {
                var errors = this.errors ? _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getTruthyValues(this.errors) : [this.input.validationMessage || this.L('invalidValue')];

                if (errors && errors.length) {
                  return errors;
                }
              }
            } //endregion

          }, {
            key: "errorTip",
            get: function get() {
              return this.constructor.errorTip;
            }
            /**
             * A singleton error tooltip which activates on hover of invalid fields.
             * before show, it gets a reference to the field and interrogates its
             * active error list to display as the tip content.
             * @member {Common.widget.Tooltip}
             * @readonly
             * @static
             */

          }, {
            key: "element",
            set: function set(element) {
              var me = this,
                  value = me.initialConfig.value,
                  innerElements = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].createElementFromTemplate(me.inputTemplate(me), arrayOption),
                  children = [{
                className: 'b-field-inner',
                reference: 'inputWrap',
                children: innerElements
              }],
                  startTriggers = [],
                  endTriggers = [];

              if (me.label) {
                children.unshift({
                  tag: 'label',
                  reference: 'labelElement',
                  htmlFor: "".concat(me.id, "_input"),
                  html: me.label
                });
              } // Read the clearable config which will force evaluation of triggers
              // to include clearable trigger.


              me._thisIsAUsedExpression(me.clearable);

              for (var triggerRef in me.triggers) {
                var trigger = me.triggers[triggerRef];

                if (trigger.align === 'start') {
                  startTriggers.unshift(trigger);
                } else {
                  endTriggers.push(trigger);
                }
              } // The triggers at each end are sorted "gavitationally".
              // Higher weight sorts towards the center which is the input element.


              startTriggers.sort(byWeight);
              endTriggers.sort(byWeightReverse);
              innerElements.unshift.apply(innerElements, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(startTriggers.map(function (t) {
                return t.element;
              })));
              innerElements.push.apply(innerElements, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(endTriggers.map(function (t) {
                return t.element;
              })));

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Field.prototype), "element", {
                className: me.label ? 'b-has-label' : '',
                children: children
              }, this, true); // Value must be injected into the input element after it has been constructed, not in the
              // initial template, otherwise the caret position will not be as expected.


              if (value != null) {
                me.value = value;
              }

              me.updateEmpty();
              me.updateInvalid();
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Field.prototype), "element", this);
            } //endregion
            //region Focus & select

          }, {
            key: "focusElement",
            get: function get() {
              return this.input;
            }
          }, {
            key: "editable",
            get: function get() {
              return this._editable && !this.readOnly;
            },
            set: function set(editable) {
              var me = this,
                  input = me.input;
              me._editable = editable;

              if (input) {
                if (!me.readOnly) {
                  input.readOnly = editable === false ? 'readOnly' : null;
                }

                if (editable !== false) {
                  me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on({
                    element: input,
                    thisObj: me,
                    focus: 'internalOnInputFocus',
                    change: 'internalOnChange',
                    input: 'internalOnInput',
                    keydown: 'internalOnKeyPress',
                    keypress: 'internalOnKeyPress',
                    keyup: 'internalOnKeyPress'
                  });
                } else {
                  me.inputListenerRemover && me.inputListenerRemover();
                }
              }
            }
          }, {
            key: "clearable",
            set: function set(clearable) {
              this._clearable = clearable;

              if (clearable && !this.triggers) {
                this.triggers = {};
              }
            },
            get: function get() {
              return this._clearable;
            }
            /**
             * The trigger Widgets as specified by the {@link #config-triggers} configuration and the {@link #config-clearable} configuration.
             * Each is a {@link Common.widget.Widget Widget} instance which may be hidden, shown and observed and styled just like any other widget.
             * @property {Object}
             */

          }, {
            key: "triggers",
            set: function set(triggers) {
              var me = this,
                  myTriggers = me._triggers = {};

              if (me.clearable) {
                (triggers || (triggers = {})).clear = {
                  cls: 'b-icon-remove',
                  handler: function handler() {
                    me._isUserAction = true;
                    me.clear();
                    me._isUserAction = false;
                  },
                  weight: 1000
                };
              }

              for (var triggerRef in triggers) {
                myTriggers[triggerRef] = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createWidget(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].assign({
                  type: 'trigger',
                  reference: triggerRef,
                  parent: me
                }, triggers[triggerRef]), me.defaultTriggerType || 'trigger');
              }
            },
            get: function get() {
              return this._triggers;
            }
          }, {
            key: "labelWidth",
            set: function set(labelWidth) {
              if (this.labelElement) {
                this.labelElement.style.flex = "0 0 ".concat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].setLength(labelWidth)); // If there's a label width, the input must conform with it, and not try to expand to 100%

                this.inputWrap.style.flexBasis = labelWidth == null ? '' : 0;
              }
            }
            /**
             * Get/set fields label. Please note that the Field needs to have a label specified from start for this to work,
             * otherwise no element is created.
             * @property {String}
             */

          }, {
            key: "label",
            get: function get() {
              return this._label;
            },
            set: function set(label) {
              if (label === null || label === undefined) label = '';
              this._label = label; // since value is used in template it is not certain that element is available
              // TODO: move the code from template here instead

              if (this.labelElement) {
                // using innerHTML since we sometimes use icons as label
                this.labelElement.innerHTML = label;
              }
            }
            /**
             * Get/set read only
             * @property {Boolean}
             */

          }, {
            key: "readOnly",
            get: function get() {
              // Fields which are disabled cannot be updated.
              // This ensures ESC and clear click won't be able to clear disabled fields.
              return this._readOnly || this.disabled;
            },
            set: function set(readOnly) {
              this._readOnly = readOnly;
              this.element.classList[readOnly ? 'add' : 'remove']('b-readonly');

              if (readOnly) {
                this.input.setAttribute('readonly', '');
              } else {
                this.input.removeAttribute('readonly');
              }
            }
            /**
             * Returns true if the field value is valid
             * @type {Boolean}
             * @readonly
             */

          }, {
            key: "isValid",
            get: function get() {
              if (this.errors && _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getTruthyValues(this.errors).length) {
                return false;
              }

              if (this.input && this.input.validity) {
                return this.input.validity.valid;
              }

              return true;
            }
            /**
             * Returns true if the field value is empty
             * @type {boolean}
             * @readonly
             */

          }, {
            key: "isEmpty",
            get: function get() {
              return this.value == null || this.value === '';
            }
            /**
             * Returns true if the field's input is empty
             * @type {boolean}
             * @readonly
             */

          }, {
            key: "isEmptyInput",
            get: function get() {
              return !this.input || this.input.value == null || this.input.value === '';
            }
            /**
             * Gets or sets the value. The returned type will depend upon the Field subclass.
             *
             * `TextField` returns a `String`.
             *
             * `NumberField` returns a `Number`.
             *
             * `DateField` and `TimeField` return a `Date` object, and `null` if the field is empty.
             *
             * `Combo` will return a `String` if configured with `items` as a simple string array.
             * Otherwise it will return the {@link Common.widget.Combo#config-valueField} value from the
             * selected record, or `null` if no selection has been made.
             * @property {*}
             */

          }, {
            key: "value",
            get: function get() {
              return this._value;
            },
            set: function set(value) {
              var me = this,
                  oldValue = me._value;

              if (me.hasChanged(oldValue, value)) {
                // lastValue is used for IE to check if a change event should be triggered when pressing ENTER
                if (!me.inputting) {
                  me._lastValue = value;
                }

                me._value = value;

                if (me.required && (value == '' || value == null)) {
                  me.setError('fieldRequired', true);
                } else {
                  me.clearError('fieldRequired', true);
                } // Do not trigger change event during configuration phase
                // or during keyboard input


                if (!me.isConfiguring && !me.inputting) {
                  // trigger change event, signaling that origin is from set operation,
                  // makes it easier to ignore such events in applications that set value on load etc
                  me.trigger('change', {
                    value: me.value,
                    oldValue: oldValue,
                    userAction: Boolean(me._isUserAction),
                    valid: me.isValid
                  });
                }

                me.syncInputFieldValue();
              }
            }
          }, {
            key: "inputValue",
            get: function get() {
              // Do not use the _value property. If called during configuration, this
              // will import the configured value from the config object.
              return this.value == null ? '' : this.value;
            }
          }, {
            key: "supportsTextSelection",
            get: function get() {
              var input = this.focusElement; // Text selection using setSelectionRange is allowed in Chrome for certain elements. Edge supports it even for input[type=number]

              return input && (input.tagName.toLowerCase() === 'textarea' || input.type && (/text|search|password|tel|url/.test(input.type) || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isEdge));
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Text to display in empty field.
                 * @config {String}
                 */
                placeholder: '',

                /**
                 * Default value
                 * @config {String}
                 */
                value: '',

                /**
                 * Label, prepended to field
                 * @config {String}
                 */
                label: null,

                /**
                 * Configure as `true` to indicate that a `null` field value is to be marked as invalid.
                 * @config {Boolean}
                 * @default false
                 */
                required: null,

                /**
                 * Show a trigger to clear field, and allow `ESC` key to clear field if this field is
                 * not {@link #config-readOnly}. The trigger is available in the {@link #property-triggers} object
                 * under the name `clear`.
                 * @config {Boolean}
                 * @default false
                 */
                clearable: null,

                /**
                 * The width to apply to the `<label>` element. If a number is specified, `px` will be used.
                 * @config {String|Number}
                 */
                labelWidth: null,

                /**
                 * The width to apply to the `<input>` element. If a number is specified, `px` will be used.
                 * @config {String|Number}
                 */
                inputWidth: null,

                /**
                 * The delay in milliseconds to wait after the last keystroke before triggering a change event.
                 * Set to 0 to not trigger change events from keystrokes (listen for input event instead to have
                 * immediate feedback, change will still be triggered on blur)
                 * @config {Number}
                 * @default
                 */
                keyStrokeChangeDelay: 0,

                /**
                 * Makes the field unmodifiable by user action. The input area is not editable.
                 * @config {Boolean}
                 */
                readOnly: null,

                /**
                 * Set to false to prevent user from editing the field. For TextFields it is basically the same as setting
                 * {@link #config-readOnly}, but for PickerFields there is a distinction where it allows you to pick a value but not to type
                 * one in the field.
                 * @config {Boolean}
                 * @default true
                 */
                editable: true,
                defaultAction: 'change',

                /**
                 * The triggers to add either before or after the input field. Each property name is the reference by which an
                 * instantiated Trigger Widget may be retrieved from the live `{@link #property-triggers}` property.
                 * Each trigger may have the following properties:
                 * * `cls` The CSS class to apply.
                 * * `handler` A method in the field to call upon click
                 * * `align` `'start'` or `'end'` which end of the field the trigger should go.
                 * * `weight` (Optional) Heigher weighted triggers gravitate towards the input field.
                 * @config {Object}
                 */
                triggers: null,

                /**
                 * Specify `false` to prevent field from being highlighted when on external value changes
                 * @config {Boolean}
                 */
                highlightExternalChange: true,
                localizableProperties: ['label', 'title'],
                autoSelect: false,

                /**
                 * Sets the native `autocomplete` property of the underlying input element. For more information, please refer to
                 * [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete)
                 * @config {String}
                 * @default
                 */
                autoComplete: 'off'
              };
            }
          }, {
            key: "errorTip",
            get: function get() {
              return Field._errorTip || (Field._errorTip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
                cls: 'b-field-error-tip',
                forSelector: '.b-field.b-invalid .b-field-inner',
                align: 'l-r',
                scrollAction: 'realign',
                onBeforeShow: function onBeforeShow() {
                  var tip = this,
                      field = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].fromElement(tip.activeTarget);

                  if (field) {
                    var errors = field.getErrors();

                    if (errors) {
                      tip.html = errors.join('<br>');
                      tip.field = field;
                      return true;
                    }
                  } // Veto show


                  return false;
                }
              }));
            }
          }]);

          return Field;
        }(Object(_mixin_Badge_js__WEBPACK_IMPORTED_MODULE_11__["default"])(_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"]));
        /**
         * Base class for field triggers May be configured with a `cls` and a `handler` which is a function (or name of a function)
         * in the owning Field.
         * @extends Common/widget/Widget
         */


        Field.Trigger =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(FieldTrigger, _Widget);

          function FieldTrigger() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, FieldTrigger);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(FieldTrigger).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(FieldTrigger, [{
            key: "template",
            value: function template() {
              return "<div class=\"b-icon b-align-".concat(this.align || 'end', "\"></div>");
            }
          }, {
            key: "construct",
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(FieldTrigger.prototype), "construct", this).call(this, config);

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on({
                element: this.element,
                click: {
                  handler: 'onClick',
                  thisObj: this
                },
                mousedown: {
                  handler: 'onMousedown',
                  thisObj: this
                }
              });
            }
          }, {
            key: "onClick",
            value: function onClick(e) {
              var me = this,
                  field = me.field,
                  handler = typeof me.handler === 'function' ? me.handler : field[me.handler];

              if (field.disabled || field.readOnly) {
                return;
              }

              if (handler && field.trigger('trigger', {
                trigger: me
              }) !== false) {
                handler.call(field, e);
              }
            }
          }, {
            key: "onMousedown",
            value: function onMousedown(e) {
              var field = this.field,
                  isKeyEvent = 'key' in e; // If it's a touch tap on the trigger of an editable, then
              // avoid the keyboard by setting the field to not be editable
              // before focusing the field. Reset to be editable after focusing
              // has happened. Keyboard will not appear.

              if (!isKeyEvent && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isTouchEvent) {
                if (field.editable) {
                  field.editable = false;
                  field.setTimeout(function () {
                    return field.editable = true;
                  }, 500);
                }
              }

              e.preventDefault();

              if (document.activeElement !== field.input) {
                field.focus();
              }
            }
          }, {
            key: "field",
            get: function get() {
              return this.parent;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                align: null
              };
            }
          }]);

          return FieldTrigger;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        Field.SpinTrigger =
        /*#__PURE__*/
        function (_Field$Trigger) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(SpinTrigger, _Field$Trigger);

          function SpinTrigger() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, SpinTrigger);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(SpinTrigger).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(SpinTrigger, [{
            key: "template",
            value: function template() {
              return "<div class=\"b-icon b-align-".concat(this.align || 'end', "\">\n                    <div reference=\"upButton\" class=\"b-icon b-spin-up\"></div>\n                    <div reference=\"downButton\" class=\"b-icon b-spin-down\"></div>\n                </div>");
            }
          }, {
            key: "onClick",
            value: function onClick(e) {
              var me = this,
                  field = me.field;

              if (field.disabled) {
                return;
              }

              if (e.target === me.upButton) {
                field.doSpinUp();
              } else if (e.target === me.downButton) {
                field.doSpinDown();
              }
            }
          }, {
            key: "repeat",
            set: function set(repeat) {
              var me = this;

              if (repeat) {
                me.clickRepeater = new _util_ClickRepeater_js__WEBPACK_IMPORTED_MODULE_18__["default"](Object.assign({
                  element: me.element
                }, repeat));
              } else if (me.clickrepeater) {
                me.clickRepeater.destroy();
                me.clickrepeater = null;
              }
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                repeat: true
              };
            }
          }]);

          return SpinTrigger;
        }(Field.Trigger); // Those two classes are defined in a very unusual manner, have to specify names directly


        Field.Trigger._$name = 'FieldTrigger';
        Field.SpinTrigger._$name = 'SpinTrigger';
        Field._$name = 'Field';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_19__["default"].register('trigger', Field.Trigger);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_19__["default"].register('spintrigger', Field.SpinTrigger);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/FileField.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/widget/FileField.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetFileFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return FileField;
        });
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _lib_Common_widget_Field_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../lib/Common/widget/Field.js */
        "../Grid/lib/Common/widget/Field.js");
        /* harmony import */


        var _lib_Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../lib/Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _lib_Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n            <input\n             type=\"file\"\n             id=\"", "_input\"\n             class=\"", "\"\n             ", "\n             accept=\"", "\"\n            />\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/FileField
         */

        /**
         * Filefield widget. Wraps native &lt;input type="file"&gt;.
         *
         * There is a nicer styled wrapper for this field, see {@link Common/widget/FilePicker}
         *
         * @extends Common/widget/Field
         * @example
         *
         * let fileField = new FileField({
         *   multiple : true,
         *   accept   : "image/*"
         * });
         *
         * @classType filefield
         * @externalexample widget/FileField.js
         */

        var FileField =
        /*#__PURE__*/
        function (_Field) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(FileField, _Field);

          function FileField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, FileField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(FileField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(FileField, [{
            key: "inputTemplate",
            value: function inputTemplate() {
              var me = this; // Not using reference="input" here intentionally.
              // In IE11/Edge when you pick file first time, field.value reports empty string while field.files.length is
              // non zero. Trying to fix this and embed file field to common field behavior is very tricky because cannot
              // be covered with siesta tests (it looks like).
              // Also we don't need much from this field - only `change` event.

              return _lib_Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].tpl(_templateObject(), me.id, me.inputCls || '', me.multiple ? 'multiple' : '', me.accept || '');
            }
          }, {
            key: "construct",
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(FileField.prototype), "construct", this).call(this, config);

              me.input = me.element.querySelector('input');

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
                element: me.input,
                change: me.onFileInputChange,
                thisObj: me
              });
            }
          }, {
            key: "pickFile",

            /**
             * Opens browser file picker
             * @internal
             */
            value: function pickFile() {
              this.input.click();
            }
            /**
             * Clears field value
             */

          }, {
            key: "clear",
            value: function clear() {
              this.input.value = null;
            }
          }, {
            key: "onFileInputChange",
            value: function onFileInputChange() {
              var me = this,
                  value = me.input.value,
                  oldValue = me.oldValue;
              this.trigger('change', {
                value: value,
                oldValue: oldValue,
                userAction: true,
                valid: true
              });
              me.oldValue = value;
            }
          }, {
            key: "oldValue",
            get: function get() {
              return this._oldValue;
            },
            set: function set(value) {
              this._oldValue = value;
            }
            /**
             * Returns list of selected files
             * @returns {FileList}
             * @readonly
             */

          }, {
            key: "files",
            get: function get() {
              return this.input.files;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Set to true to allow picking multiple files
                 * @config {Boolean}
                 * @default
                 */
                multiple: false,

                /**
                 * Comma-separated list of file extensions or MIME type to to accept. E.g.
                 * ".jpg,.png,.doc" or "image/*". Null by default, allowing all files.
                 * @config {String}
                 */
                accept: null
              };
            }
          }]);

          return FileField;
        }(_lib_Common_widget_Field_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        FileField._$name = 'FileField';

        _lib_Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__["default"].register('filefield', FileField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/FilePicker.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/widget/FilePicker.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetFilePickerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return FilePicker;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "../Grid/node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _lib_Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _lib_Common_widget_Container_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../lib/Common/widget/Container.js */
        "../Grid/lib/Common/widget/Container.js");
        /* harmony import */


        var _lib_Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../lib/Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _lib_Common_widget_Button_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../lib/Common/widget/Button.js */
        "../Grid/lib/Common/widget/Button.js");
        /* harmony import */


        var _FileField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./FileField.js */
        "../Grid/lib/Common/widget/FileField.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/FilePicker
         */

        /**
         * File input field wrapped into {@link Common/widget/Button button}. Clicking button opens browser file picker window.
         * When files are chosen, badge appears showing amount of files. Hovering the button shows tip with file names.
         *
         * By default only single file allowed.
         *
         * @extends Common/widget/Container
         * @example
         *
         * let fileField = new FilePicker({
         *   fileFieldConfig : {
         *      multiple : true,
         *      accept   : "image/*"
         *   },
         *   buttonConfig : {
         *       text : 'Pick file...'
         *   }
         * });
         *
         * @classType filepicker
         * @externalexample widget/FilePicker.js
         */

        var FilePicker =
        /*#__PURE__*/
        function (_Container) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(FilePicker, _Container);

          function FilePicker() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, FilePicker);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(FilePicker).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(FilePicker, [{
            key: "construct",
            value: function construct() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var me = this;
              config.items = [Object.assign({
                type: 'button',
                ref: 'fileButton',
                text: 'File'
              }, config.buttonConfig), Object.assign({
                type: 'filefield',
                ref: 'fileField',
                style: 'display: none'
              }, config.fileFieldConfig)].concat(config.items || []);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(FilePicker.prototype), "construct", this).call(this, config);

              me.button.on({
                click: me.onButtonClick,
                thisObj: me
              });
              me.fileField.on({
                change: me.onFileFieldChange,
                thisObj: me
              });

              me._thisIsAUsedExpression(me.fileTip);
            }
          }, {
            key: "clear",

            /**
             * Clears field
             */
            value: function clear() {
              var me = this;
              me.fileField.clear();
              me.button.badge = '';
              me.trigger('clear');
            }
          }, {
            key: "onButtonClick",
            value: function onButtonClick(_ref) {
              var event = _ref.event;
              var me = this; // forward click to the file input to open browser file picker
              // me.fileField.input.click();

              me.fileField.pickFile();
              event.preventDefault();
            }
          }, {
            key: "onFileFieldChange",
            value: function onFileFieldChange() {
              var me = this;
              me.button.badge = me.files.length || '';
              me.trigger('change', {
                files: me.files
              });
            }
          }, {
            key: "button",
            get: function get() {
              return this.widgetMap.fileButton;
            }
          }, {
            key: "fileField",
            get: function get() {
              return this.widgetMap.fileField;
            }
            /**
             * List of selected files
             * @returns {FileList}
             * @readonly
             */

          }, {
            key: "files",
            get: function get() {
              return this.fileField.files;
            }
          }, {
            key: "fileTip",
            get: function get() {
              var me = this;
              return me._fileTip || (me._fileTip = new _lib_Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
                cls: 'b-file-tip',
                forElement: me.button.element,
                showOnHover: true,
                align: 'b-t',
                scrollAction: 'realign',
                listeners: {
                  beforeshow: function beforeshow() {
                    var tip = this,
                        files = me.files;

                    if (files && files.length) {
                      tip.html = "".concat(Array.from(files).map(function (file) {
                        return file.name;
                      }).join('<br>'));
                      return true;
                    } // Veto show


                    return false;
                  }
                }
              }));
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Fires after user closes file picker dialog.
                 * @event change
                 * @param {FileList} files List of picked files
                 */

                /**
                 * Fires when field is cleared with {@link #function-clear} method
                 * @event clear
                 */

                /**
                 * Wrapper button config object. See {@link Common/widget/Button} for list of available configs.
                 * @config {Object}
                 */
                buttonConfig: null,

                /**
                 * Underlying field config object. See {@link Common/widget/FileField} for list of available configs.
                 * @config {Object}
                 */
                fileFieldConfig: null
              };
            }
          }]);

          return FilePicker;
        }(_lib_Common_widget_Container_js__WEBPACK_IMPORTED_MODULE_11__["default"]);

        FilePicker._$name = 'FilePicker';

        _lib_Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('filepicker', FilePicker);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/FlagField.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/widget/FlagField.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetFlagFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return FlagField;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Checkbox_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Checkbox.js */
        "../Grid/lib/Common/widget/Checkbox.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/FlagField
         */

        /**
         * Flag field is a checkbox which is driven by its boolean value and vice-versa.
         * When value is `true` then checkbox is checked, when it's `false` then checkbox
         * is unchecked.
         */

        var FlagField =
        /*#__PURE__*/
        function (_Checkbox) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(FlagField, _Checkbox);

          function FlagField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, FlagField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(FlagField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(FlagField, [{
            key: "value",
            get: function get() {
              return this.checked;
            },
            set: function set(v) {
              v = Boolean(v);

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(FlagField.prototype), "value", v, this, true);

              if (!this.inputting) {
                this.checked = v;
              }
            }
          }], [{
            key: "type",
            get: function get() {
              return 'flagfield';
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                value: ''
              };
            }
          }]);

          return FlagField;
        }(_Checkbox_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        FlagField._$name = 'FlagField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_7__["default"].register(FlagField.type, FlagField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/List.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Common/widget/List.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetListJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return List;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _data_Store_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _util_Collection_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../helper/util/Navigator.js */
        "../Grid/lib/Common/helper/util/Navigator.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        function _templateObject3() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_6___default()(["", "", ""]);

          _templateObject3 = function _templateObject3() {
            return data;
          };

          return data;
        }

        function _templateObject2() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_6___default()(["<div class=\"", "\" data-index=\"", "\" data-id=\"", "\" ", ">\n            ", "\n            </div>"]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_6___default()(["", ""]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/List
         */

        var itemRange = document.createRange();
        /**
         * Displays a list of items which the user can navigate using the keyboard and select using either pointer gestures or the keyboard.
         * @extends Common/widget/Widget
         *
         * @classType list
         * @externalexample widget/List.js
         */

        var List =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(List, _Widget);

          function List() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, List);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(List, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * User activated an item in the list either by pointer or keyboard.
             * The active record, list item index, and the triggering event are passed.
             * @event item
             * @property {Object} record - Activated record
             * @property {Number} index - List item index
             * @property {Event} event - Triggering event
             */
            //endregion
            value: function construct(config) {
              var _get2;

              var me = this; // We can be created from a raw array. It becomes our items which we translate to a Store.

              if (Array.isArray(config)) {
                config = {
                  items: config
                };
              }

              for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "construct", this)).call.apply(_get2, [this, config].concat(args));

              var element = me.element,
                  classList = element.classList;

              if (me.multiSelect) {
                classList.add('b-multiselect');
              }

              if (me.store.count) {
                me.refresh();
              } else {
                classList.add('b-empty');
              }

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].on({
                element: element,
                delegate: me.itemSelector,
                mouseover: 'onMouseOver',
                click: 'onClick',
                thisObj: me
              });

              me.storeDetacher = me.store.on({
                change: 'onStoreChange',
                refresh: 'onStoreRefresh',
                thisObj: me
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              if (this.storeDetacher) {
                this.storeDetacher();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "contentTpl",
            value: function contentTpl() {
              var _this = this;

              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].tpl(_templateObject(), this.store.records.map(function (record, i) {
                return _this.itemWrapperTpl(record, i);
              }));
            }
          }, {
            key: "itemWrapperTpl",
            value: function itemWrapperTpl(record, i) {
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].tpl(_templateObject2(), this.getItemClasses(record, i), i, record.id, this.itemsFocusable ? 'tabindex="-1"' : '', this.itemContentTpl(record, i));
            }
          }, {
            key: "itemContentTpl",
            value: function itemContentTpl(record, i) {
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].tpl(_templateObject3(), this.multiSelect ? '<div class="b-selected-icon b-icon b-icon-check"></div>' : '', this.itemTpl(record, i));
            }
          }, {
            key: "getItemClasses",
            value: function getItemClasses(record) {
              var me = this,
                  activeItem = me._navigator && me._navigator.activeItem,
                  isActive = activeItem && activeItem.dataset.id == record.id,
                  isSelected = me.selected.includes(record);
              return "".concat(me.itemCls, " ").concat(record.cls || '', " ").concat(isSelected ? me.selectedCls : '', " ").concat(isActive ? me.navigator.focusCls : '');
            }
          }, {
            key: "onStoreChange",
            value: function onStoreChange(_ref) {
              var store = _ref.source,
                  action = _ref.action,
                  records = _ref.records,
                  record = _ref.record;

              switch (action) {
                case 'remove':
                  this.selected.remove(records);
                  break;

                case 'clear':
                  this.selected.clear();
                  break;

                case 'update':
                  this.refreshItem(record);
                  return;
              }

              this.refresh();
            }
          }, {
            key: "onStoreRefresh",
            value: function onStoreRefresh() {
              this.refresh();
            }
          }, {
            key: "refresh",
            value: function refresh() {
              var me = this;

              if (me.isVisible) {
                me.clearItems().insertNode(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createElementFromTemplate(me.contentTpl(), {
                  fragment: true
                }));
                me.element.classList[me.store.count > 0 ? 'remove' : 'add']('b-empty');
              } else {
                me.on({
                  paint: function paint() {
                    return me.refresh();
                  },
                  once: true
                });
              }
            }
          }, {
            key: "clearItems",
            value: function clearItems() {
              var me = this,
                  firstItem = me.contentElement.querySelector(me.itemSelector),
                  lastChild = me.contentElement.lastChild;

              if (firstItem) {
                itemRange.setStartBefore(firstItem);
                itemRange.setEndAfter(me.contentElement.querySelector("".concat(me.itemSelector, ":last-of-type")));
                itemRange.deleteContents();
              } else {
                // Allow a static set of elements to be at the top of the list
                if (lastChild) {
                  itemRange.setStartAfter(lastChild);
                  itemRange.setEndAfter(lastChild);
                } else {
                  itemRange.setStart(me.contentElement, 0);
                  itemRange.setEnd(me.contentElement, 0);
                }
              }

              return itemRange;
            }
          }, {
            key: "refreshItem",
            value: function refreshItem() {
              for (var _len2 = arguments.length, records = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                records[_key2] = arguments[_key2];
              }

              for (var _i = 0; _i < records.length; _i++) {
                var record = records[_i];
                var item = this.getItem(record); // Maybe a record which is filtered out announces a change.
                // There will be no item.

                if (item) {
                  var index = this.store.indexOf(record),
                      newItem = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createElementFromTemplate(this.itemWrapperTpl(record, index));

                  _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].sync(newItem, item);
                }
              }
            }
          }, {
            key: "getItem",
            value: function getItem(recordOrId) {
              if (typeof recordOrId === 'number') {
                return this.contentElement.querySelector("[data-index=\"".concat(recordOrId, "\"]"));
              }

              if (recordOrId.id != null) {
                recordOrId = recordOrId.id;
              }

              return this.contentElement.querySelector("[data-id=\"".concat(recordOrId, "\"]"));
            }
          }, {
            key: "getRecord",
            value: function getRecord(dom) {
              if (dom.target) {
                dom = dom.target;
              }

              dom = dom.closest(this.itemSelector);
              return this.store.getAt(parseInt(dom.dataset.index));
            } //region getters/setters

            /**
             * May be *set* as an array of Objects which are converted into records and used to create this
             * List's {@link #config-store}
             * @property {Object[]}
             */

          }, {
            key: "alignTo",
            //endregion
            //region Hide/Show
            value: function alignTo() {
              var _get3; // When aligning, if the items total height is less than minHeight, use that.


              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "minHeight", this.minAlignHeight, this, true);

              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }

              (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "alignTo", this)).call.apply(_get3, [this].concat(args));
            }
          }, {
            key: "hide",
            value: function hide() {
              var _get4;

              this.navigator.activeItem = null;

              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }

              (_get4 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "hide", this)).call.apply(_get4, [this].concat(args));
            }
          }, {
            key: "show",
            value: function show() {
              // Restore the configured minHeight
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "minHeight", this._minHeight, this, true);

              var activeItem = this.navigator.previousActiveItem;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "show", this).call(this);

              if (activeItem) {
                if (!this.element.contains(activeItem)) {
                  activeItem = this.element.querySelector("[data-id=\"".concat(activeItem.dataset.id, "\"]"));
                }

                this.navigator.activeItem = activeItem;
              }
            } //endregion
            //region Events

            /**
             * Focuses list items on hover.
             * @private
             */

          }, {
            key: "onMouseOver",
            value: function onMouseOver(event) {
              var me = this,
                  itemElement = event.target.closest(me.itemSelector);

              if (itemElement && me.navigator && me.activateOnMouseover) {
                me.navigator.activeItem = itemElement;
              }
            }
            /**
             * Selects list items on click.
             * @private
             */

          }, {
            key: "onClick",
            value: function onClick(event) {
              var itemElement = event.target.closest(this.itemSelector);

              if (itemElement) {
                this.onItemClick(itemElement, event);
              }
            }
            /**
             * Key events which are not navigation are delegated up to here by the Navigator
             * @private
             */

          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(event) {
              var me = this,
                  active = me.navigator.activeItem;

              switch (event.key) {
                case ' ':
                  if (!event.target.readOnly) {
                    break; // eslint-disable-line
                  }

                case 'Enter':
                  // eslint-disable-line
                  if (active) {
                    this.onItemClick(active, event); // Stop the keydown from bubbling.
                    // And stop it from creating a keypress event.
                    // No further action should be taken after item selection.

                    event.stopImmediatePropagation();
                    event.preventDefault();
                  }

              }
            } //endregion

          }, {
            key: "onItemClick",
            value: function onItemClick(item, event) {
              var me = this,
                  index = parseInt(item.dataset.index),
                  record = me.store.getAt(index),
                  selected = me.selected,
                  isSelected = selected.includes(record);
              me.trigger('item', {
                item: item,
                record: record,
                index: index,
                event: event
              }); // Clicking on any element with the data-noselect attribute means no selection

              if (!item.contains(event.target.closest('[data-noselect]'))) {
                if (me.multiSelect) {
                  selected[isSelected ? 'remove' : 'add'](record);
                } else {
                  selected.splice(0, selected.count, record);
                }
              }

              me.lastClicked = record;
            }
            /**
             * Handles items being added or removed from the selected Collection
             * @param {Object} changeEvent
             * @private
             */

          }, {
            key: "onSelectionChange",
            value: function onSelectionChange(_ref2) {
              var action = _ref2.action,
                  removed = _ref2.removed,
                  added = _ref2.added,
                  replaced = _ref2.replaced;
              var me = this,
                  selectedCls = me.selectedCls;
              var record, item;

              if (action === 'clear') {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = me.element.querySelectorAll(".".concat(selectedCls))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    item = _step.value;
                    item.classList.remove(selectedCls);
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              } else {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = removed[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    record = _step2.value;
                    item = me.getItem(record);
                    item && item.classList.remove(selectedCls);
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = added[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    record = _step3.value;
                    item = me.getItem(record);
                    item && item.classList.add(selectedCls);
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }
            }
          }, {
            key: "items",
            set: function set(items) {
              var me = this;

              if (me.store && me.store.autoCreated) {
                me.store.destroy();
              }

              me.store = _data_Store_js__WEBPACK_IMPORTED_MODULE_15__["default"].getStore(items);
            }
          }, {
            key: "selected",
            set: function set(selected) {
              if (!(selected && selected instanceof _util_Collection_js__WEBPACK_IMPORTED_MODULE_19__["default"])) {
                selected = new _util_Collection_js__WEBPACK_IMPORTED_MODULE_19__["default"](selected);
              }

              this._selected = selected;
              selected.on({
                change: 'onSelectionChange',
                thisObj: this
              });
            },
            get: function get() {
              return this._selected;
            }
            /**
             * Get the backing store, a {@link Common.data.Store} holding the records used to generate list items
             * @property {Common.data.Store}
             * @readonly
             */

          }, {
            key: "itemSelector",
            get: function get() {
              return ".".concat(this.itemCls);
            }
          }, {
            key: "store",
            get: function get() {
              // Ensure any configured items is processed into a store before we try to return it.
              this._thisIsAUsedExpression(this.items);

              return this._store;
            },
            set: function set(store) {
              if (!(store instanceof _data_Store_js__WEBPACK_IMPORTED_MODULE_15__["default"])) {
                store = new _data_Store_js__WEBPACK_IMPORTED_MODULE_15__["default"](store);
              }

              this._store = store;
            }
          }, {
            key: "navigator",
            get: function get() {
              return this._navigator;
            },
            set: function set(navigator) {
              var me = this,
                  element = me.element;

              if (element) {
                me._navigator = new (navigator.class || _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_20__["default"])(Object.assign({
                  ownerCmp: me,
                  target: element,
                  keyEventTarget: element
                }, navigator));
              } else {
                me._navigator = navigator;
              }
            }
          }, {
            key: "minHeight",
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "minHeight", this);
            },
            set: function set(minHeight) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(List.prototype), "minHeight", this._minHeight = minHeight, this, true);
            }
          }, {
            key: "minAlignHeight",
            get: function get() {
              var lastItem = this.element.lastElementChild,
                  minHeight = this.minHeight; // No minHeight specified, always defer to the items height

              if (minHeight != null) {
                return this.store.count ? Math.min(lastItem.offsetTop + lastItem.offsetHeight, minHeight) : 0;
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                itemCls: 'b-list-item',
                selectedCls: 'b-selected',

                /**
                 * An array of Objects which are converted into records and used to create this
                 * List's {@link #config-store}
                 * @config {Object[]}
                 */
                items: null,

                /**
                 * A {@link Common.data.Store} which provides the records which map to List items. Each record is passed through the
                 * {@link #config-itemTpl} to produce the DOM structure of the List. May be generated from an array of {@link #config-items}.
                 * @config {Object/Common.data.Store}
                 */
                store: null,
                navigator: true,
                scrollable: {
                  x: false,
                  y: true
                },
                itemsFocusable: true,
                multiSelect: false,

                /**
                 * Template function which, when passed a record, returns the textual HTML for that item. Defaults to a
                 * function returning the value of records `text` field
                 * @config {Function} itemTpl
                 */
                itemTpl: function itemTpl(record) {
                  return record.text;
                },

                /**
                 * A {@link Common.util.Collection Collection}, or Collection config object
                 * to use to contain this List's selected records.
                 * @config {Common.util.Collection/Object}
                 */
                selected: {},

                /**
                 * Configure as `true` to activate items on mouseover. This is used by the Combo
                 * field whenm using a List as its dropdown.
                 * @config {Boolean}
                 */
                activateOnMouseover: null
              };
            }
          }]);

          return List;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_14__["default"]);

        List.prototype.navigatorClass = _helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_20__["default"];
        List._$name = 'List';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_21__["default"].register('list', List);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Mask.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Common/widget/Mask.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetMaskJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Mask;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.ends-with */
        "../Grid/node_modules/core-js/modules/es6.string.ends-with.js");
        /* harmony import */


        var core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_ends_with__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler'; //TODO: add loader

        /**
         * @module Common/widget/Mask
         */

        /**
         * Masks an element (document.body if no element specified). Call static methods for ease of use or make instance for
         * reusability.
         *
         * @example
         * Mask.mask('hello');
         * Mask.unmask();
         *
         * @externalexample widget/Mask.js
         */

        var Mask =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Mask, _Delayable);

          function Mask() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Mask);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Mask).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Mask, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Mask.prototype), "construct", this).call(this, config);

              if (!this.element) {
                this.element = document.body;
              }

              this.show();
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;

              if (me.maskElement) {
                me.maskElement.remove();
                me.maskElement = null;

                if (me.mode.endsWith('blur')) {
                  _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].forEachChild(me.element, function (child) {
                    child.classList.remove("b-masked-".concat(me.mode));
                  });
                }

                me.element.mask = null;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Mask.prototype), "doDestroy", this).call(this);
            }
            /**
             * Creates mask element
             * @private
             */

          }, {
            key: "create",
            value: function create() {
              var me = this.element.mask = this;
              me.maskElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].createElement({
                parent: me.element,
                className: "b-mask b-widget b-mask-".concat(me.mode)
              });
              me.text = me._text;
            } //endregion
            //region Static

            /**
             * Shows a mask with the specified message
             * @param {String|Object} text Message
             * @param {HTMLElement} element Element to mask
             * @returns {Common.widget.Mask}
             */

          }, {
            key: "show",
            //endregion
            //region Show & hide

            /**
             * Show mask
             */
            value: function show() {
              var me = this;

              if (me.hasTimeout('hide')) {
                // TODO: Consider this behaviour, should showing a mask which is not fully hidden resolve?
                me.resolve();
                me.clearTimeout('hide');
              }

              if (!me.element.mask) {
                me.create();
              }

              var element = me.element,
                  maskElement = me.maskElement;
              if (!maskElement) return; // already masked by other instance, only allowing one

              element.classList.add('b-masked');
              maskElement.classList.add('b-visible');
              maskElement.classList.remove('b-hidden');
              me.shown = true; // blur has to blur child elements

              if (me.mode.endsWith('blur')) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].forEachChild(element, function (child) {
                  if (child !== maskElement) {
                    child.classList.add("b-masked-".concat(me.mode));
                  }
                });
              }
            }
            /**
             * Hide mask
             * @returns {Promise} A promise which is resolved when the mask is hidden, or immediately if already hidden
             */

          }, {
            key: "hide",
            value: function hide() {
              var me = this,
                  element = me.element,
                  maskElement = me.maskElement;
              return new Promise(function (resolve) {
                if (me.shown) {
                  me.shown = false;
                  maskElement.classList.remove('b-visible');
                  maskElement.classList.add('b-hidden');
                  element.classList.remove('b-masked');

                  if (me.mode.endsWith('blur')) {
                    _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].forEachChild(element, function (child) {
                      if (child !== maskElement) {
                        child.classList.remove("b-masked-".concat(me.mode));
                      }
                    });
                  } // TODO: use AnimationHelper when available


                  me.resolve = resolve;
                  me.setTimeout(function () {
                    return resolve();
                  }, 500, 'hide');
                } else {
                  resolve();
                }
              });
            }
            /**
             * Close mask (removes it)
             * @returns {Promise} A promise which is resolved when the mask is closed
             */

          }, {
            key: "close",
            value: function close() {
              var _this = this;

              return new Promise(function (resolve) {
                _this.hide().then(function () {
                  _this.destroy();

                  resolve();
                });
              });
            } //endregion

          }, {
            key: "text",
            //endregion
            //region Mask content

            /**
             * Gets or sets the text displayed in the mask
             * @property {String}
             */
            set: function set(txt) {
              var me = this;
              me._text = txt || '';

              if (me.maskElement) {
                me.maskElement.innerHTML = "<div class=\"b-mask-content\"><i class=\"b-mask-icon ".concat(me.icon, "\"></i>").concat(me._text, "</i>");
              }
            },
            get: function get() {
              return this._text;
            }
          }], [{
            key: "mask",
            value: function mask(text) {
              var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;
              return new Mask(typeof text !== 'string' ? Object.assign({
                element: element
              }, text) : {
                element: element,
                text: text
              });
            }
            /**
             * Unmask
             * @param {HTMLElement} element Element to unmask
             * @returns {Promise} A promise which is resolved when the mask is gone
             */

          }, {
            key: "unmask",
            value: function unmask() {
              var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
              return element.mask && element.mask.close();
            }
          }, {
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Mode: bright, bright-blur, dark or dark-blur
                 * @config {String}
                 * @default
                 */
                mode: 'dark',

                /**
                 * The icon to show next to the text. Defaults to showing a spinner
                 * @config {String}
                 * @default
                 */
                icon: 'b-icon b-icon-spinner',

                /**
                 * The text (or HTML) to show in mask
                 * @config {String}
                 */
                text: null
              };
            }
          }]);

          return Mask;
        }(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_9__["default"])());

        Mask._$name = 'Mask';
        /***/
      },

      /***/
      "../Grid/lib/Common/widget/Menu.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Common/widget/Menu.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetMenuJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Menu;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Popup_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Popup.js */
        "../Grid/lib/Common/widget/Popup.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _MenuItem_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./MenuItem.js */
        "../Grid/lib/Common/widget/MenuItem.js");

        var productName = 'scheduler';
        var validKeys = {
          ArrowUp: 1,
          ArrowDown: 1,
          ArrowRight: 1,
          ArrowLeft: 1,
          Enter: 1,
          Escape: 1
        };
        /**
         * @module Common/widget/Menu
         */

        /**
         * Menu widget, displays a list of items which the user can select from using mouse or keyboard. Can have submenus.
         *
         * @extends Common/widget/Popup
         *
         * @example
         * let menu = new Menu({
         *     forElement : btn.element,
         *     items      : [{
         *         icon : 'b-icon b-icon-add',
         *         text : 'Add'
         *     }, {
         *         icon : 'b-icon b-icon-trash',
         *         text : 'Remove'
         *     }, {
         *         text : 'Sub menu',
         *         menu : [{
         *             icon : 'b-icon fa-play',
         *             text : 'Play'
         *         }]
         *     }],
         *     // Method is called for all ancestor levels
         *     onItem({ item }) {
         *         Toast.show('You clicked ' + item.text);
         *     }
         * });
         *
         * @classType menu
         * @externalexample widget/Menu.js
         */

        var Menu =
        /*#__PURE__*/
        function (_Popup) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Menu, _Popup);

          function Menu() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Menu);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Menu, [{
            key: "construct",
            //endregion

            /**
             * A descendant menu item has been activated.
             *
             * Note that this event bubbles up through parents and can be
             * listened for on a top level {@link Common.widget.Menu Menu} for convenience.
             * @event item
             * @param {Common.widget.MenuItem} item - The menu item which is being actioned.
             * @param {Common.widget.Menu} menu - Menu containing the menu item
             */

            /**
             * The checked state of a descendant menu item has changed.
             *
             * Note that this event bubbles up through parents and can be
             * listened for on a top level {@link Common.widget.Menu Menu} for convenience.
             * @event toggle
             * @param {Common.widget.MenuItem} item - The menu item whose checked state changed.
             * @param {Common.widget.Menu} menu - Menu containing the menu item
             * @param {Boolean} checked - The _new_ checked state.
             */
            //region Init
            value: function construct(config) {
              if (Array.isArray(config)) {
                config = {
                  items: config
                };
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu.prototype), "construct", this).call(this, config);

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
                element: this.element,
                click: 'onMouseClick',
                mouseover: 'onMouseOver',
                mouseleave: 'onMouseLeave',
                thisObj: this
              });
            }
          }, {
            key: "afterShow",
            value: function afterShow(resolveFn) {
              // Don't instantiate all our items' subMenus right now.
              // Use our private _menu property which will still be a config item.
              var hasSubmenu = this.items.some(function (item) {
                return Boolean(item._menu);
              }); // afterShow is called before alignment, so this is the correct time
              // to mutate things which will change this Widget's size.

              if (hasSubmenu) {
                this.element.classList.add('b-menu-with-submenu');
              } // Add CSS class to menu if any item has an icon, to allow aligning icon-less items


              var hasIcon = this.items.some(function (item) {
                return item.icon;
              });

              if (hasIcon) {
                this.element.classList.add('b-menu-with-icon');
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu.prototype), "afterShow", this).call(this, resolveFn);
            }
          }, {
            key: "createWidget",
            value: function createWidget(item) {
              if (typeof item === 'string') {
                item = {
                  text: item
                };
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu.prototype), "createWidget", this).call(this, item);
            }
          }, {
            key: "onDocumentMouseDown",
            //endregion
            value: function onDocumentMouseDown(event) {
              // It's not a click outside if its a click on our owner Menu
              if (!this.parentMenu || !this.parentMenu.owns(event.event.target)) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu.prototype), "onDocumentMouseDown", this).call(this, event);
              }
            } //region Show

          }, {
            key: "hide",
            value: function hide(animate) {
              if (this.currentSubMenu) {
                this.currentSubMenu.hide(animate);
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu.prototype), "hide", this).call(this, animate);

              if (this.parentMenu) {
                this.parentMenu.currentSubMenu = null;
              }
            } //endregion
            //region Events

            /**
             * Activates a menu item if user clicks on it
             * @private
             */

          }, {
            key: "onMouseClick",
            value: function onMouseClick(event) {
              var me = this,
                  menuItem = event.target.closest('.b-menuitem');

              if (menuItem) {
                me.triggerElement(menuItem, event); // IE / Edge still triggers event listeners that were removed in a listener - prevent this

                event.stopImmediatePropagation();
              }
            }
            /**
             * Activates menu items on hover. On real mouse hover, not on a touchstart.
             * @private
             */

          }, {
            key: "onMouseOver",
            value: function onMouseOver(event) {
              if (this.focusOnHover !== false) {
                var fromItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].up(event.relatedTarget, '.b-widget'),
                    toItemElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].up(event.target, '.b-widget'),
                    overItem = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].fromElement(toItemElement);

                if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isTouchEvent && toItemElement && toItemElement !== fromItemElement && overItem.parent === this) {
                  overItem && overItem.focus();
                }
              }
            } // unselect any menu item if mouse leaves the menu element (unless it enters a child menu)

          }, {
            key: "onMouseLeave",
            value: function onMouseLeave(event) {
              var me = this,
                  relatedTarget = event.relatedTarget,
                  leavingToChild = relatedTarget && me.owns(relatedTarget);

              var targetCmp = relatedTarget && relatedTarget instanceof HTMLElement && _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].fromElement(relatedTarget),
                  shouldHideMenu = !leavingToChild;

              if (targetCmp) {
                while (targetCmp.ownerCmp) {
                  targetCmp = targetCmp.ownerCmp;
                } // Or was found and does not belong to current menu DOM tree
                // This condition will not allow possibly existing picker to hide
                // Covered by Menu.t.js


                shouldHideMenu &= !_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getAncestor(targetCmp.element, [event.target]);
              }

              if (!leavingToChild && shouldHideMenu) {
                me.currentSubMenu && me.currentSubMenu.hide();
                me.currentSubMenu = me.selectedElement = null; // Deactivate currently active *menu items* on mouseleave

                if (me.element.contains(document.activeElement) && document.activeElement.matches('.b-menuitem')) {
                  me.element.focus();
                }
              }
            }
            /**
             * Keyboard navigation. Up/down, close with esc, activate with enter
             * @private
             */

          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(event) {
              var sourceWidget = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].fromElement(event),
                  isFromWidget = sourceWidget && sourceWidget !== this && !(sourceWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_11__["default"]);

              if (event.key === 'Escape') {
                // Only close this menu if the ESC was in a child input Widget
                (isFromWidget ? this : this.rootMenu).close();
                return;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu.prototype), "onInternalKeyDown", this).call(this, event); // Do not process keys from certain elemens


              if (isFromWidget) {
                return;
              }

              if (validKeys[event.key]) {
                event.preventDefault();
              }

              var active = document.activeElement,
                  el = this.element;
              this.navigateFrom(active !== el && el.contains(active) ? active : null, event.key, event);
            }
          }, {
            key: "navigateFrom",
            value: function navigateFrom(active, key, event) {
              var me = this,
                  treeWalker = me.treeWalker,
                  item = active && me.getItemFromElement(active);
              var toActivate;

              switch (key) {
                case 'ArrowUp':
                  treeWalker.currentNode = active || (active = me.bottomFocusTrap);
                  treeWalker.previousNode();
                  toActivate = treeWalker.currentNode;
                  break;

                case 'ArrowDown':
                  treeWalker.currentNode = active || (active = me.topFocusTrap);
                  treeWalker.nextNode();
                  toActivate = treeWalker.currentNode;
                  break;

                case ' ':
                  if (active && !active.classList.contains('b-disabled')) {
                    if (item && item.menu) {
                      me.openSubMenu(active, item);
                    } else {
                      me.triggerElement(active, event);
                    }
                  }

                  break;

                case 'ArrowRight':
                  if (active && item && item.menu && !active.classList.contains('b-disabled')) {
                    // opening with arrow keys highlights first item (as in menus on mac)
                    var openedMenu = me.openSubMenu(active, item); // If show hs not been vetoed, ask it to focus.
                    // Container will delegate focus inward if possible.

                    if (openedMenu) {
                      openedMenu.focus();
                    }
                  } else {
                    treeWalker.currentNode = active || (active = me.topFocusTrap);
                    treeWalker.nextNode();
                    toActivate = treeWalker.currentNode;
                  }

                  break;

                case 'ArrowLeft':
                  if (me.isSubMenu) {
                    me.hide();
                  } else if (!active) {
                    treeWalker.currentNode = active || (active = me.topFocusTrap);
                    treeWalker.nextNode();
                    toActivate = treeWalker.currentNode;
                  }

                  break;

                case 'Enter':
                  if (active && !active.classList.contains('b-disabled')) {
                    me.triggerElement(active, event);
                  }

                  break;
              } // Move focus to wherever we have calculated


              if (toActivate) {
                // Previous moved to encapsulating element; wrap from end
                if (toActivate === me.element) {
                  me.navigateFrom(me.bottomFocusTrap, 'ArrowUp', event);
                } // Next could not move because we're at the end; wrap from top
                else if (toActivate === active) {
                    me.navigateFrom(me.topFocusTrap, 'ArrowDown', event);
                  } else {
                    toActivate.focus();
                  }
              }
            } //endregion
            //region Activate menu item

          }, {
            key: "getItemFromElement",
            value: function getItemFromElement(menuItemElement) {
              return _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].fromElement(menuItemElement, 'menuitem', this.contentElement);
            }
            /**
             * Activate a menu item (from its element)
             * @private
             * @fires item
             * @param menuItemElement
             */

          }, {
            key: "triggerElement",
            value: function triggerElement(menuItemElement, event) {
              var menu = this,
                  item = menu.getItemFromElement(menuItemElement); // If the trigger gesture happened on a non-MenuItem
              // item will be undefined. Do not action on a non-MenuItem
              // or a disabled MenuItem

              if (item && !item.disabled) {
                item.doAction(event);
              }
            }
            /**
             * Returns true if this menu is a sub menu.
             * To find out which menu is the parent, check {@link #property-parentMenu}.
             * @type {boolean}
             * @readonly
             */

          }, {
            key: "openSubMenu",

            /**
             * Opens a submenu anchored to a menu item
             * @private
             * @param element
             * @param item
             */
            value: function openSubMenu(element, item) {
              var me = this,
                  subMenu = item.menu;

              if (subMenu) {
                if (!subMenu.isVisible) {
                  var event = {
                    item: item,
                    element: element
                  };

                  if (me.trigger('beforeSubMenu', event) === false) {
                    return;
                  }

                  if (item.onBeforeSubMenu && item.onBeforeSubMenu(event) === false) {
                    return;
                  }

                  subMenu.show();
                }
                /**
                 * Currently open sub menu, if any
                 * @member {Common.widget.Menu} currentSubMenu
                 * @readonly
                 */


                return me.currentSubMenu = subMenu;
              }
            }
            /**
             * Get/set focused menu item.
             * Shows submenu if newly focused item has a menu and is not disabled.
             * @property {HTMLElement}
             */

          }, {
            key: "selectFirst",
            value: function selectFirst() {
              var treeWalker = this.treeWalker;
              treeWalker.currentNode = this.topFocusTrap;
              treeWalker.nextNode(); // If we are under keyboard control, this must happen in the next
              // animation frame so that the keydown event doesn't fire on the
              // newly focused node.

              this.requestAnimationFrame(function () {
                return treeWalker.currentNode.focus();
              });
            } //endregion
            //region Close

            /**
             * Gets the parent Menu if this Menu is a submenu.
             * @returns {Common.widget.Menu} The parent menu if this is a submenu, otherwise, `undefined`.
             */

          }, {
            key: "focusElement",
            get: function get() {
              var fromParentMenu = this.parentMenu && this.parentMenu.element.contains(document.activeElement),
                  firstWidget = this.items[0];

              if (fromParentMenu || !(firstWidget instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_11__["default"])) {
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Menu.prototype), "focusElement", this);
              }

              return this.element;
            }
          }, {
            key: "isSubMenu",
            get: function get() {
              return this.owner && this === this.owner.menu;
            }
          }, {
            key: "selectedElement",
            set: function set(element) {
              var me = this,
                  lastSelected = me._selectedElement;

              if (lastSelected) {
                var lastItem = me.getItemFromElement(lastSelected),
                    lastItemMenu = lastItem && lastItem.menu;

                if (lastItemMenu) {
                  lastItemMenu.hide();
                }

                lastSelected.classList.remove('b-active');
              }

              me._selectedElement = element; // might set to null to deselect

              if (element) {
                var doFocus = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isFocusable(element);

                element.classList.add('b-active');
                me.scrollable.scrollIntoView(element, {
                  animate: !doFocus,
                  focus: doFocus
                });
              }
            },
            get: function get() {
              return this._selectedElement;
            }
          }, {
            key: "parentMenu",
            get: function get() {
              var result = this.owner;

              if (result instanceof _MenuItem_js__WEBPACK_IMPORTED_MODULE_11__["default"]) {
                result = result.owner;
              }

              if (result instanceof Menu) {
                return result;
              }
            }
            /**
             * Gets this menus root menu, the very first menu shown in a sub menu hierarchy
             * @property {Common.widget.Menu}
             * @private
             */

          }, {
            key: "rootMenu",
            get: function get() {
              var menu = this;

              while (menu.parentMenu && menu.parentMenu instanceof this.constructor) {
                menu = menu.parentMenu;
              }

              return menu;
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                align: 't-b',
                scrollAction: 'hide',

                /**
                 * Specify false to prevent the menu from getting focus when hovering items
                 * @default
                 * @config {Boolean}
                 */
                focusOnHover: null,
                // We do need a Scroller so that we can use its API to scroll around.
                // But the overflow flags default to false.
                scrollable: false,
                defaultType: 'menuitem'
              };
            }
          }]);

          return Menu;
        }(_Popup_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        Menu._$name = 'Menu';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_8__["default"].register('menu', Menu);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/MenuItem.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/widget/MenuItem.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetMenuItemJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return MenuItem;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_3___default()(["\n            <", " ", " ", " class=\"", "\" ", " tabIndex=\"-1\">\n                ", "\n                <span class=\"b-menu-text\" reference=\"textElement\">", "</span>\n                ", "\n            </", ">"]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/MenuItem
         */

        var bIcon = /^b-icon-/,
            bFa = /^b-fa-/;
        /**
         * Menu item widget, encapsulates a menu item within a Menu.
         *
         * May be configured with a {@link #config-checked} state which creates
         * a checkbox which may bwe toggled.
         *
         * Fires events when activated which bubble up through the parent hierachy
         * and may be listened for on an ancestor. See {@link Common.widget.Menu Menu}
         * for more details on usage.
         *
         * @extends Common/widget/Widget
         *
         * @classType menuitem
         */

        var MenuItem =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(MenuItem, _Widget);

          function MenuItem() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, MenuItem);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(MenuItem).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(MenuItem, [{
            key: "doAction",

            /**
             * Actions this item. Fires the {@link #event-item} event, and if this
             * if a {@link #config-checked} item, toggles the checked state, firing
             * the {@link #event-toggle} event.
             */
            value: function doAction(event) {
              var item = this,
                  menu = this.parent,
                  itemEvent = {
                menu: menu,
                item: item,
                element: item.element,
                bubbles: true
              };

              if (typeof item.checked === 'boolean') {
                item.checked = !item.checked;
              } // Give internal handlers a chance to inject extra information before
              // user-supplied "item" handlers see the event.
              // Scheduler's ContextMenu feature does this


              item.trigger('beforeItem', itemEvent);
              /**
               * This menu item has been activated.
               *
               * Note that this event bubbles up through parents and can be
               * listened for on a top level {@link Common.widget.Menu Menu} for convenience.
               * @event item
               * @param {Common.widget.MenuItem} item - The menu item which is being actioned.
               * @param {Common.widget.Menu} menu - Menu containing the menu item
               */

              item.trigger('item', itemEvent); // Collapse the owning menu hierarchy if configured to do so

              if (item.closeParent && menu) {
                menu.rootMenu.close(); // Don't prevent links doing their thing

                if (event && !item.href) {
                  event.preventDefault();
                }
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var menu = this._menu;

              if (menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
                menu.destroy();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(MenuItem.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "template",
            value: function template(me) {
              var icon = me.icon || (typeof me.checked === 'boolean' ? "b-fw-icon b-icon-".concat(me.checked ? '' : 'un', "checked") : ''),
                  iconExtraCls = bIcon.test(icon) ? ' b-icon' : bFa.test(icon) ? ' b-fa' : '',
                  tag = me.href ? 'a' : 'div';
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].tpl(_templateObject(), tag, tag === 'a' ? "href=\"".concat(me.href, "\"") : '', tag === 'a' && me.target ? "target=\"".concat(me.target, "\"") : '', me.hasMenu ? 'b-has-submenu' : '', me.name ? "data-name=\"".concat(me.name, "\"") : '', icon ? "<i class=\"b-menuitem-icon ".concat(icon).concat(iconExtraCls, "\" reference=\"iconElement\"></i>") : '', me.text, me.hasMenu ? '<i class="b-fw-icon b-icon-sub-menu" reference="subMenuIcon"></i>' : '', tag);
            }
          }, {
            key: "onFocusIn",
            value: function onFocusIn(e) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(MenuItem.prototype), "onFocusIn", this).call(this, e);

              if (!this.disabled && this.menu) {
                this.openMenu();
              }
            }
          }, {
            key: "onFocusOut",
            value: function onFocusOut(e) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(MenuItem.prototype), "onFocusOut", this).call(this, e);

              this.closeMenu();
            }
          }, {
            key: "openMenu",
            value: function openMenu(andFocus) {
              var menu = this.menu;

              if (!this.disabled && menu) {
                menu.focusOnToFront = andFocus;
                menu.show();
                this.owner.currentSubMenu = menu;
              }
            }
          }, {
            key: "closeMenu",
            value: function closeMenu() {
              if (this._menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
                this.menu.close();
              }
            }
            /**
             * Get/sets the checked state of thie `MenuItem` and fires the {@link #event-toggle}
             * event upon change.
             *
             * Note that this must be configured as a `Boolean` to enable the checkbox UI.
             * @property {Boolean}
             */

          }, {
            key: "focusElement",
            get: function get() {
              return this.element;
            }
          }, {
            key: "contentElement",
            get: function get() {
              return this.textElement;
            }
          }, {
            key: "isFocusable",
            get: function get() {
              var focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
              // it must have layout - an offsetParent. Body does not have offsetParent.
              // Disabled menu items are focusable but cannot be activated.
              // https://www.w3.org/TR/wai-aria-practices/#h-note-17

              return focusElement && this.isVisible && (focusElement === document.body || focusElement.offsetParent);
            }
          }, {
            key: "checked",
            set: function set(checked) {
              var me = this,
                  isConfiguring = me.isConfiguring; // If we began life as a non-checkitem, then reject attempts to set checked status.

              if (!isConfiguring && !(typeof me._checked === 'boolean')) {
                return;
              } // Ensure we're always dealing with a Boolean


              checked = !!checked; // Reject non-changes.

              if (checked !== me._checked) {
                me._checked = checked; // During config this is initial state; do not fire change events.
                // Initial icon state is set in the template.

                if (!isConfiguring) {
                  me.iconElement.classList[checked ? 'add' : 'remove']('b-icon-checked');
                  me.iconElement.classList[checked ? 'remove' : 'add']('b-icon-unchecked');
                  /**
                   * The checked state of this menu item has changed.
                   *
                   * Note that this event bubbles up through parents and can be
                   * listened for on a top level {@link Common.widget.Menu Menu} for convenience.
                   * @event toggle
                   * @param {Common.widget.MenuItem} item - The menu item whose checked state changed.
                   * @param {Common.widget.Menu} menu - Menu containing the menu item
                   * @param {Boolean} checked - The _new_ checked state.
                   */

                  me.trigger('toggle', {
                    menu: me.owner,
                    item: me,
                    checked: me._checked,
                    element: me.element,
                    bubbles: true
                  });
                }
              }
            },
            get: function get() {
              return this._checked;
            }
          }, {
            key: "menu",
            set: function set(menu) {
              this._menu = menu;
            },

            /**
             * Returns the instantiated menu widget as configured by {@link #config-menu}.
             * @property {Common.widget.Widget}
             * @readonly
             */
            get: function get() {
              var me = this;
              var result = me._menu;

              if (result && !(result instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"])) {
                // This covers both Array and Object which are valid items config formats.
                // menu could be { itemRef : { text : 'sub item 1 } }. But if it has
                // child items or html property in it, it's the main config
                if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(result) === 'object' && !('items' in result || 'widgets' in result || 'html' in result)) {
                  result = {
                    items: result
                  };
                }

                result = me.menu = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createWidget(Object.assign({
                  type: 'menu',
                  autoShow: false,
                  autoClose: true,
                  scrollAction: me.owner.scrollAction,
                  constrainTo: me.owner.constrainTo,
                  forElement: me.element,
                  align: 'l0-r0',
                  anchor: true,
                  owner: me,
                  cls: 'b-sub-menu' // Makes the anchor hoverable to avoid mouseleave

                }, result));
              }

              return result;
            }
          }, {
            key: "text",
            get: function get() {
              return this.html;
            },
            set: function set(text) {
              this.html = text;
            }
          }, {
            key: "closeParent",
            set: function set(closeParent) {
              this._closeParent = closeParent;
            },
            get: function get() {
              var result = typeof this.checked === 'boolean' ? this._closeParent : this._closeParent !== false;
              return result && !this.hasMenu;
            }
          }, {
            key: "hasMenu",
            get: function get() {
              var menu = this.isConfiguring ? this.initialConfig.menu : this._menu;
              return menu && (menu instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"] || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(menu) === 'object' || menu.length > 0);
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * A submenu configuration object, or an array of MenuItem configuration
                 * objects from which to create a submenu.
                 *
                 * Note that this does not have to be a Menu. The `type` config can be used
                 * to specify any widget as the submenu.
                 * @config {Object|Object[]}
                 */
                menu: null,

                /**
                 * Item icon class.
                 *
                 * All [Font Awesome](https://fontawesome.com/cheatsheet) icons may also be specified as `'b-fa-' + iconName`.
                 *
                 * Otherwise this is a developer-defined CSS class string which results in the desired icon.
                 * @config {String}
                 */
                icon: null,

                /**
                 * The text to be displayed in the item
                 * @config {String}
                 */
                text: null,

                /**
                 * If configured with a `Boolean` value, a checkbox is displayed
                 * as the start icon, and the {@link #event-toggle} event is fired
                 * when the checked state changes.
                 * @config {Boolean}
                 */
                checked: null,

                /**
                 * By default, upon activate, non-checkbox menu items will collapse
                 * the owning menu hierarchy.
                 *
                 * Configure this as `false` to cause the menu to persist after
                 * activating an item
                 * @config {Boolean}
                 */
                closeParent: null,
                localizableProperties: ['text']
              };
            }
          }]);

          return MenuItem;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        MenuItem._$name = 'MenuItem';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__["default"].register('menuitem', MenuItem);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/NumberField.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/widget/NumberField.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetNumberFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return NumberField;
        });
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "../Grid/node_modules/core-js/modules/es6.number.constructor.js");
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Field_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./Field.js */
        "../Grid/lib/Common/widget/Field.js");
        /* harmony import */


        var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_2___default()(["\n            <input type=\"number\"\n                reference=\"input\"\n                min=\"", "\"\n                max=\"", "\"\n                step=\"any\"\n                value=\"", "\"\n                autocomplete=\"", "\"\n                placeholder=\"", "\"\n                name=\"", "\"\n                id=\"", "_input\"\n                ", "/>\n            "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/NumberField
         */

        /**
         * Number field widget. Wraps native `<input type="number">`
         *
         * @extends Common/widget/Field
         *
         * @example
         * let number = new NumberField({
         *   min: 1,
         *   max: 5,
         *   value: 3
         * });
         *
         * @classType numberfield
         * @externalexample widget/NumberField.js
         */

        var NumberField =
        /*#__PURE__*/
        function (_Field) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(NumberField, _Field);

          function NumberField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, NumberField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(NumberField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(NumberField, [{
            key: "internalOnKeyPress",
            value: function internalOnKeyPress(e) {
              if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isEdge && e.type === 'keydown') {
                if (e.key === 'ArrowUp') {
                  this.doSpinUp();
                  e.preventDefault();
                } else if (e.key === 'ArrowDown') {
                  this.doSpinDown();
                  e.preventDefault();
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(NumberField.prototype), "internalOnKeyPress", this).call(this, e);
            } //endregion

          }, {
            key: "inputTemplate",
            value: function inputTemplate() {
              var me = this,
                  style = 'inputWidth' in me ? "style=\"width:".concat(me.inputWidth).concat(typeof me.inputWidth === 'number' ? 'px' : '', "\"") : '';
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].tpl(_templateObject(), me.min, me.max, me._value, me.autoComplete, me.placeholder, me.name || me.id, me.id, style);
            }
          }, {
            key: "doSpinUp",
            value: function doSpinUp() {
              var newValue = (this.value || 0) + this.step,
                  min = this.min,
                  max = this.max;

              if (!isNaN(min) && newValue < min) {
                newValue = min;
              }

              if (isNaN(max) || newValue <= max) {
                this._isUserAction = true;
                this.value = newValue;
                this._isUserAction = false;
              }
            }
          }, {
            key: "doSpinDown",
            value: function doSpinDown() {
              var newValue = (this.value || 0) - this.step,
                  min = this.min,
                  max = this.max;

              if (!isNaN(max) && newValue > max) {
                newValue = max;
              }

              if (isNaN(min) || newValue >= min) {
                this._isUserAction = true;
                this.value = newValue;
                this._isUserAction = false;
              }
            }
          }, {
            key: "step",
            set: function set(step) {
              this.element.classList[step ? 'remove' : 'add']('b-hide-spinner');
              this._step = step;
            },
            get: function get() {
              return this._step;
            }
            /**
             * Min value
             * @property {Number}
             */

          }, {
            key: "min",
            set: function set(min) {
              this._min = min;

              if (this.input) {
                this.input.min = min;
              }
            },
            get: function get() {
              return this._min;
            }
            /**
             * Max value
             * @property {Number}
             */

          }, {
            key: "max",
            set: function set(max) {
              this._max = max;

              if (this.input) {
                this.input.max = max;
              }
            },
            get: function get() {
              return this._max;
            }
          }, {
            key: "value",
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(NumberField.prototype), "value", this);
            },
            set: function set(value) {
              if (value || value === 0) {
                // We insist on a number as the value
                if (typeof value !== 'number') {
                  value = typeof value === 'string' ? parseFloat(value) : Number(value);

                  if (isNaN(value)) {
                    value = '';
                  }
                }
              } else {
                value = this.clearable ? undefined : 0;
              } // Reject non-changes & not interested in non-number values


              if (this.value !== value) {
                _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(NumberField.prototype), "value", value, this, true);
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Min value
                 * @config {Number}
                 */
                min: null,

                /**
                 * Max value
                 * @config {Number}
                 */
                max: null,

                /**
                 * Step size. Use a decimal value to allow decimal input
                 * @config {Number}
                 */
                step: 1,

                /**
                 * Initial value
                 * @config {Number}
                 */
                value: 0,
                triggers: {
                  spin: {
                    type: 'spintrigger'
                  }
                }
              };
            }
          }]);

          return NumberField;
        }(_Field_js__WEBPACK_IMPORTED_MODULE_12__["default"]);

        NumberField._$name = 'NumberField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('numberfield', NumberField);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('number', NumberField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Panel.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Common/widget/Panel.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetPanelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Panel;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "../Grid/node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Tool_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./Tool.js */
        "../Grid/lib/Common/widget/Tool.js");
        /* harmony import */


        var _Container_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./Container.js */
        "../Grid/lib/Common/widget/Container.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Toolbar_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ./Toolbar.js */
        "../Grid/lib/Common/widget/Toolbar.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Panel
         */

        var acceptNode = function acceptNode(e) {
          return !e.classList.contains('b-focus-trap') && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].isFocusable(e) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        },
            byWeight = function byWeight(l, r) {
          return (l.weight || 0) - (r.weight || 0);
        },
            byWeightReverse = function byWeightReverse(l, r) {
          return (r.weight || 0) - (l.weight || 0);
        }; // https://github.com/webcomponents/webcomponentsjs/issues/556
        // Work around Internet Explorer wanting a function instead of an object.
        // IE also *requires* this argument where other browsers don't.


        acceptNode.acceptNode = acceptNode;
        /**
         * Panel widget. A general pupose container which may be used to contain child {@link Common.widget.Container#config-items}
         * or {@link Common.widget.Widget#config-html}.
         *
         * Also may dock a {@link #config-header} and {@link #config-footer} either at top/bottom or left/right
         *
         * @extends Common/widget/Container
         *
         * @example
         * let panel = new Panel({
         *   title   : 'A Test Panel',
         *   widgets : [
         *     { type : 'text', placeholder: 'Text' },
         *   ],
         *   bbar : [{
         *     text : 'Proceed',
         *     onClick : () => {
         *       alert('Proceeding!');
         *     }
         *   }]
         * });
         *
         * @classType panel
         */

        var Panel =
        /*#__PURE__*/
        function (_Container) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Panel, _Container);

          function Panel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Panel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Panel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Panel, [{
            key: "eachWidget",
            // Override to iterate docked Toolbars in the correct order around
            // contained widgets.
            value: function eachWidget(fn) {
              var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var me = this,
                  widgets = me.items ? me.items.slice() : [];

              if (me.tools) {
                widgets.unshift.apply(widgets, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(Object.values(me.tools)));
              }

              if (me.tbar) {
                widgets.unshift(me.tbar);
              }

              if (me.bbar) {
                widgets.push(me.bbar);
              }

              for (var i = 0; i < widgets.length; i++) {
                var widget = widgets[i];

                if (fn(widget) === false) {
                  return;
                }

                if (deep && widget.eachWidget) {
                  widget.eachWidget(fn, deep);
                }
              }
            }
            /**
             * The tool Widgets as specified by the {@link #config-tools} configuration
             * (and the {@link Common.widget.Popup#config-closable} configuration in the Popup subclass).
             * Each is a {@link Common.widget.Widget Widget} instance which may be hidden, shown and observed and styled just like any other widget.
             * @property {Object}
             */

          }, {
            key: "onFocusTrapped",
            value: function onFocusTrapped(e) {
              var me = this,
                  treeWalker = me.treeWalker; // The only way of focusing these invisible elements is by TABbing to them.
              // If we hit the bottom one, wrap to the top.

              if (e.target === me.bottomFocusTrap) {
                treeWalker.currentNode = me.topFocusTrap;
                treeWalker.nextNode();
              } // If we hit the top one, wrap to the bottom.
              else {
                  treeWalker.currentNode = me.bottomFocusTrap;
                  treeWalker.previousNode();
                }

              me.requestAnimationFrame(function () {
                return treeWalker.currentNode.focus();
              });
            }
          }, {
            key: "doDestroy",
            //endregion
            value: function doDestroy() {
              // Only destroy the widgets if they have been instanced.
              if (this.tbar) {
                this.tbar.destroy();
              }

              if (this.bbar) {
                this.bbar.destroy();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Panel.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "element",
            //endregion

            /**
             * A header {@link #config-tools tool} has been clicked.
             * @event toolclick
             * @param {Common.widget.Tool} source - This Panel.
             * @param {Common.widget.Tool} tool - The tool which is being clicked.
             */
            //region Init & destroy
            set: function set(element) {
              var me = this,
                  headerFromTitle = me.title && (!me.parent || !me.parent.suppressChildHeaders),
                  // If tools exist, we need to create the header infrastructure
              header = me.header || (me.tools || headerFromTitle ? {} : null),
                  footer = me.footer,
                  title = header && (typeof header === 'string' ? header : me.title || header.title),
                  titleAlign = header && (header.titleAlign || 'start'),
                  headerClass = me.classHierarchy(Panel).map(function (cls) {
                return "b-".concat(cls.$name.toLowerCase(), "-header");
              }).join(' '),
                  tbar = me.tbar,
                  bbar = me.bbar || me.buttons,
                  children = [{
                reference: 'topFocusTrap',
                className: 'b-focus-trap',
                tabIndex: 0
              }],
                  startTools = [],
                  endTools = [],
                  result = {
                children: children
              };

              if (me.hasItems || me.focusable) {
                result.tabIndex = 0;
              }

              if (header) {
                var headerChildren = [{
                  reference: 'titleElement',
                  className: 'b-header-title',
                  style: "text-align:".concat(titleAlign),
                  html: title
                }];

                for (var toolRef in me.tools) {
                  var tool = me.tools[toolRef];

                  if (tool.align === 'start') {
                    startTools.unshift(tool);
                  } else {
                    endTools.push(tool);
                  }
                } // The tools at each end are sorted "gravitationally".
                // Higher weight sorts towards the center which is the title element.


                startTools.sort(byWeight);
                endTools.sort(byWeightReverse);
                headerChildren.unshift.apply(headerChildren, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(startTools.map(function (t) {
                  return t.element;
                })));
                headerChildren.push.apply(headerChildren, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(endTools.map(function (t) {
                  return t.element;
                })));
                children.push({
                  tag: 'header',
                  reference: 'headerElement',
                  className: "".concat(headerClass, " b-dock-").concat(header.dock || 'top', " ").concat(header.cls || ''),
                  children: headerChildren
                });
              }

              if (tbar) {
                tbar.layout.renderChildren();
                children.push(tbar.element);
              }

              children.push(me.bodyConfig);

              if (bbar) {
                bbar.layout.renderChildren();
                children.push(bbar.element);
              }

              if (footer) {
                children.push({
                  tag: 'footer',
                  reference: 'footerElement',
                  className: "".concat(headerClass, " b-dock-").concat(footer.dock || 'bottom', " ").concat(footer.cls || '')
                });
              }

              children.push({
                reference: 'bottomFocusTrap',
                className: 'b-focus-trap',
                tabIndex: 0
              });

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Panel.prototype), "element", result, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Panel.prototype), "element", this);
            }
          }, {
            key: "bodyConfig",
            set: function set(bodyConfig) {
              this._bodyConfig = bodyConfig;
            },
            get: function get() {
              return this._bodyConfig || {
                reference: 'bodyElement',
                className: this.classHierarchy(Panel).map(function (cls) {
                  return "b-".concat(cls.$name.toLowerCase(), "-content");
                }).join(' '),
                html: this.html
              };
            }
          }, {
            key: "tbar",
            set: function set(tbar) {
              if (tbar instanceof _Toolbar_js__WEBPACK_IMPORTED_MODULE_19__["default"]) {
                tbar.parent = this;
              } else {
                if (Array.isArray(tbar)) {
                  tbar = {
                    items: tbar
                  };
                }

                tbar = new _Toolbar_js__WEBPACK_IMPORTED_MODULE_19__["default"](Object.assign({
                  parent: this
                }, tbar));
              }

              tbar.element.classList.add('b-top-toolbar', "b-dock-".concat(tbar.dock || 'top'));
              this._tbar = tbar;
            },
            get: function get() {
              return this._tbar;
            }
          }, {
            key: "bbar",
            set: function set(bbar) {
              if (bbar instanceof _Toolbar_js__WEBPACK_IMPORTED_MODULE_19__["default"]) {
                bbar.parent = this;
              } else {
                if (Array.isArray(bbar)) {
                  bbar = {
                    items: bbar
                  };
                }

                bbar = new _Toolbar_js__WEBPACK_IMPORTED_MODULE_19__["default"](Object.assign({
                  parent: this
                }, bbar));
              }

              bbar.element.classList.add('b-bottom-toolbar', "b-dock-".concat(bbar.dock || 'bottom'));
              this._bbar = bbar;
            },
            get: function get() {
              return this._bbar;
            }
          }, {
            key: "tools",
            set: function set(tools) {
              var me = this,
                  myTools = me._tools = {};

              for (var toolRef in tools) {
                var tool = myTools[toolRef] = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createWidget(_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].assign({
                  type: 'tool',
                  ref: toolRef,
                  //@nige: Widget defines ref but not reference, typo?
                  reference: toolRef,
                  parent: me
                }, tools[toolRef]), me.defaultToolType || 'tool');

                me.registerReference(tool, tool.ref);
              }
            },
            get: function get() {
              return this._tools;
            }
          }, {
            key: "trapFocus",
            set: function set(trapFocus) {
              var me = this;
              me.element.classList[trapFocus ? 'add' : 'remove']('b-focus-trapped');

              if (trapFocus) {
                me.focusTrapListener = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
                  element: me.element,
                  focusin: 'onFocusTrapped',
                  delegate: '.b-focus-trap',
                  thisObj: me
                }); // Create a TreeWalker which visits focusable elements.

                if (!me.treeWalker) {
                  me.treeWalker = document.createTreeWalker(me.element, NodeFilter.SHOW_ELEMENT, acceptNode, false);
                }
              } else {
                if (me.focusTrapListener) {
                  me.focusTrapListener();
                  me.focusTrapListener = null;
                }
              }

              me._trapFocus = trapFocus;
            },
            get: function get() {
              return this._trapFocus;
            }
          }, {
            key: "focusElement",
            get: function get() {
              // Either use our Containerness to yield the focus element of
              // a descendant or fall back to the encapsulating element.
              return this.hasItems && (_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Panel.prototype), "focusElement", this) || this.element);
            }
          }, {
            key: "contentElement",
            get: function get() {
              return this.element && this.bodyElement;
            }
          }, {
            key: "widgetClassList",
            get: function get() {
              var me = this,
                  result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Panel.prototype), "widgetClassList", this),
                  header = me.header;

              if (header || me.title || me.tools) {
                result.push("b-panel-has-header b-header-dock-".concat(header && header.dock || 'top'));
              }

              if (me.tbar) {
                result.push("b-panel-has-top-toolbar");
              }

              if (me.bbar) {
                result.push("b-panel-has-bottom-toolbar");
              }

              return result;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * By default, tabbing within a Panel is not contained, ie you can TAB out of the Panel
                 * forwards or backwards.
                 * Configure this as `true` to disallow tabbing out of the Panel, and make tabbing circular within this Panel.
                 * @config {Boolean}
                 * @default false
                 */
                trapFocus: null,

                /**
                 * A title to display in the header. Causes creation and docking of a header
                 * to the top if no header is configured.
                 *
                 * If specified, overrides any title configured within the {@link #config-header} configuration.
                 * @default
                 * @config {String}
                 */
                title: null,

                /**
                 * Config object of a header. May contain a `title`, `titleAlign`, `dock`
                 * and a `cls` property. If passed as a string, the value is used
                 * as the title, dock is defaulted to `'top', and titleAlign` is defaulted to `start`.
                 *
                 * The `dock` property may be `top`, `right`, `bottom` or `left`.
                 * The `titleAlign` property may be `start`, `center` or `end`.
                 * @default
                 * @config {Object|String}
                 */
                header: null,

                /**
                 * Config object of a footer. May contain a `dock`
                 * and a `cls` property.
                 *
                 * The `dock` property may be `top`, `right`, `bottom` or `left`.
                 * @default
                 * @config {Object|String}
                 */
                footer: null,

                /**
                 * The tools to add either before or after the title in the Panel header.
                 * Each property name is the reference by which an instantiated Tool Widget
                 * may be retrieved from the live `{@link #property-tools}` property.
                 * Each tool may have the following properties:
                 * * `cls` The CSS class to apply.
                 * * `handler` A method in the field to call upon click
                 * * `align` `'start'` or `'end'` which end of the header the tool should go.
                 * * `weight` (Optional) Heigher weighted tools gravitate towards the centre.
                 * @config {Object}
                 */
                tools: null,

                /**
                 * A Config object representing the configuration of a {@link Common.widget.Toolbar},
                 * or array of config objects representing the child items of a Toolbar.
                 *
                 * This creates a toolbar docked to the top of the panel immediately below the header.
                 * @config {Object[]|Object}
                 */
                tbar: null,

                /**
                 * A Config object representing the configuration of a {@link Common.widget.Toolbar},
                 * or array of config objects representing the child items of a Toolbar.
                 *
                 * This creates a toolbar docked to the bottom of the panel immediately above the footer.
                 * @config {Object[]|Object}
                 */
                bbar: null
              };
            }
          }]);

          return Panel;
        }(_Container_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        Panel._$name = 'Panel';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_14__["default"].register('panel', Panel);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/PickerField.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/widget/PickerField.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetPickerFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return PickerField;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _TextField_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./TextField.js */
        "../Grid/lib/Common/widget/TextField.js");
        /* harmony import */


        var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/PickerField
         */

        /**
         * Base class used for {@link Common.widget.Combo Combo}, {@link Common.widget.DateField DateField}, and {@link Common.widget.TimeField TimeField}.
         * Displays a picker ({@link Common.widget.List List}, {@link Common.widget.DatePicker DatePicker}) anchored to the field.
         * Not intended to be used directly
         *
         * When focused by means of *touch* tapping on the trigger element (eg, the down arrow on a Combo)
         * on a tablet, the keyboard will not be shown by default to allow for interaction with the dropdown.
         *
         * A second tap on the input area will then show the keyboard is required.
         *
         * @extends Common/widget/TextField
         * @abstract
         */

        var PickerField =
        /*#__PURE__*/
        function (_TextField) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(PickerField, _TextField);

          function PickerField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, PickerField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(PickerField, [{
            key: "doDestroy",
            //endregion
            //region Init & destroy
            value: function doDestroy() {
              var me = this; // Remove touch keyboard showing listener if we added it

              me.globalTapListener && me.globalTapListener();

              if (me._picker) {
                me.hidePicker();

                me._picker.destroy();

                me.pickerVisible = false;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "finalizeInit",
            value: function finalizeInit() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField.prototype), "finalizeInit", this).call(this);

              var me = this,
                  element = me.element;

              if (me.editable === false) {
                element.classList.add('b-not-editable');

                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
                  element: me.input,
                  click: 'onTriggerClick',
                  thisObj: me
                });
              } else {
                // In case the field was temporarily set to readOnly="true" to prevent
                // the intrusive keyboard (This happens when tapping the trigger
                // and when focused by the container in response to a touch tap),
                // allow a subsequent touch tap to show the keyboard.
                me.globalTapListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_7__["default"].on({
                  globaltap: 'showKeyboard',
                  thisObj: me
                });
              }
            } //endregion
            //region Events

            /**
             * Check if field value is valid
             * @internal
             */

          }, {
            key: "onEditComplete",
            value: function onEditComplete() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField.prototype), "onEditComplete", this).call(this);

              this.autoClosePicker();
            }
          }, {
            key: "onElementResize",
            value: function onElementResize(resizedElement) {
              var me = this; // If the field changes size while the picker is visible, the picker
              // must be kept in alignment. For example a multiSelect: true
              // ComboBox with a wrapped ChipView.

              if (me.pickerVisible) {
                // Push realignment out to the next AF, because this picker itself may move in
                // response to the element resize, and the picker must realign *after* that happens.
                // For example a multiSelect: true ComboBox with a wrapped ChipView inside
                // a Popup that is aligned *above* an element. When the ChipView gains or
                // loses height, the Popup must realign first, and then the List must align to the
                // new position of the ComboBox.
                me.picker.requestAnimationFrame(me.picker.realign, null, me.picker);
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField.prototype), "onElementResize", this).call(this, resizedElement);
            }
            /**
             * Allows using arrow keys to open/close list. Relays other keypresses to list if open.
             * @private
             */

          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(event) {
              var me = this;
              if (me.disabled) return;

              if (me.pickerVisible) {
                var picker = me.picker;

                if (event.key === 'Escape') {
                  event.stopPropagation();
                  me.hidePicker();
                } else if (picker.onInternalKeyDown) {
                  // if picker is visible, give it a shot at the event
                  picker.onInternalKeyDown(event);
                } else if (event.key === 'ArrowDown') {
                  if (picker.focusable) {
                    picker.focus();
                  }
                }
              } else if (event.key === 'ArrowDown') {
                me.onTriggerClick(event);
              }
            }
          }, {
            key: "onFocusIn",
            value: function onFocusIn(e) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField.prototype), "onFocusIn", this).call(this, e);

              if (this.autoExpand) {
                this.onTriggerClick(e);
              }
            }
          }, {
            key: "onFocusOut",
            value: function onFocusOut(e) {
              this.autoClosePicker();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField.prototype), "onFocusOut", this).call(this, e);
            }
            /**
             * User clicked trigger icon, toggle list.
             * @private
             */

          }, {
            key: "onTriggerClick",
            value: function onTriggerClick(event) {
              if (!this.disabled) {
                // Pass focus flag as true if invoked by a key event
                this.togglePicker('key' in event);
              }
            }
            /**
             * User clicked on an editable input field. If it's a touch event
             * ensure that the keyboard is shown.
             * @private
             */

          }, {
            key: "showKeyboard",
            value: function showKeyboard(_ref) {
              var event = _ref.event;
              var input = this.input;

              if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isTouchEvent && document.activeElement === input && event.target === input) {
                _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_7__["default"].suspendFocusEvents();

                input.blur();
                input.focus();

                _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_7__["default"].resumeFocusEvents();
              }
            } //endregion
            //region Toggle picker

            /**
             * Toggle picker display
             */

          }, {
            key: "togglePicker",
            value: function togglePicker(focusPicker) {
              if (this.pickerVisible) {
                this.hidePicker();
              } else {
                this.showPicker(focusPicker);
              }
            }
            /**
             * Show picker
             */

          }, {
            key: "showPicker",
            value: function showPicker(focusPicker) {
              var me = this,
                  picker = me.picker;

              if (!me.pickerHideShowListenersAdded) {
                picker.on({
                  show: 'onPickerShow',
                  hide: 'onPickerHide',
                  thisObj: me
                });
                me.pickerHideShowListenersAdded = true;
              }

              picker.autoClose = me.autoClose;
              picker.show(); // Not been vetoed

              if (picker.isVisible) {
                if (focusPicker) {
                  me.focusPicker();
                }
              }
            }
          }, {
            key: "onPickerShow",
            value: function onPickerShow() {
              var me = this;
              me.pickerVisible = true;
              me.element.classList.add('b-open');
              me.trigger('togglePicker', {
                show: true
              });
              me.pickerTapOutRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_7__["default"].on({
                globaltap: 'onPickerTapOut',
                thisObj: me
              });
              me.pickerKeyDownRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
                element: me.picker.element,
                keydown: 'onPickerKeyDown',
                thisObj: me
              });
            }
          }, {
            key: "onPickerHide",
            value: function onPickerHide() {
              var me = this;
              me.pickerVisible = false;
              me.element.classList.remove('b-open');
              me.trigger('togglePicker', {
                show: false
              });
              me.pickerTapOutRemover && me.pickerTapOutRemover();
              me.pickerKeyDownRemover && me.pickerKeyDownRemover();
            }
          }, {
            key: "onPickerTapOut",
            value: function onPickerTapOut(_ref2) {
              var event = _ref2.event;

              if (!this.owns(event.target)) {
                this.autoClosePicker();
              }
            }
          }, {
            key: "onPickerKeyDown",
            value: function onPickerKeyDown(event) {
              if (event.key === 'Tab') {
                var activeEl = document.activeElement; // Offer our own element a shot at the TAB event.
                // Some widgets or plugins may actively navigate.

                this.input.dispatchEvent(new KeyboardEvent('keydown', event)); // No listener intervened, point the TAB event at the input,
                // and user agent default navigation will proceed.

                if (document.activeElement === activeEl) {
                  this.input.focus();
                } // Some listener *did* navigate, prevent user agent default.
                else {
                    event.preventDefault();
                  } // If listeners have not destroyed us, close our picker.


                if (!this.isDestroyed) {
                  this.hidePicker();
                }
              }
            } //endregion
            //region Visibility

          }, {
            key: "autoClosePicker",
            value: function autoClosePicker() {
              if (this.autoClose) {
                this.hidePicker();
              }
            }
            /**
             * Hide picker
             */

          }, {
            key: "hidePicker",
            value: function hidePicker() {
              if (this.pickerVisible) {
                this.picker.hide();
              }
            }
          }, {
            key: "focusPicker",
            value: function focusPicker() {}
          }, {
            key: "focus",
            value: function focus() {
              var input = this.input; // If we are focusing an editable PickerField from a touch event, temporarily
              // set it to readOnly to prevent the showing of the intrusive keyboard.
              // It's more likely that a user on a touch device will interact with the picker
              // rather than the input field.
              // A second touch tap on an already focused input will show the keyboard;
              // see the showKeyboard method.

              if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isTouchEvent && this.editable) {
                input.readOnly = true;
                setTimeout(function () {
                  return input.readOnly = false;
                }, 500);
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PickerField.prototype), "focus", this).call(this);
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * User can edit text in text field (otherwise only pick from attached picker)
                 * @config {Boolean}
                 * @default
                 */
                editable: true,

                /**
                 * The name of the element property to which the picker should size and align itself.
                 * @config {String}
                 * @default element
                 */
                pickerAlignElement: 'inputWrap',
                // Does not get set, but prevents PickerFields inheriting value:'' from Field.
                value: null,
                triggers: {
                  expand: {
                    cls: 'bars'
                  }
                },

                /**
                 * By default PickerFiled's picker is transient, and will {@link #function-hidePicker} when the user clicks or
                 * taps outside or when focus moves outside picker.
                 *
                 * Configure as `false` to make picker non-transient.
                 * @config {Boolean}
                 * @default
                 */
                autoClose: true,

                /**
                 * Configure as `true` to have the picker expand upon focus enter.
                 * @config {Boolean}
                 */
                autoExpand: null,

                /**
                 * A config object which is merged into the generated picker configuration to allow specific use cases
                 * to override behaviour. For example:
                 *
                 *     picker: {
                 *         align: {
                 *             anchor: true
                 *         }
                 *     }
                 *
                 * @config {Object}
                 * @default
                 */
                picker: null,
                inputType: 'text',
                // We need to realign the picker if we resize (eg a multiSelect Combo's ChipView wrapping)
                monitorResize: true
              };
            }
          }]);

          return PickerField;
        }(_TextField_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        PickerField._$name = 'PickerField';
        /***/
      },

      /***/
      "../Grid/lib/Common/widget/Popup.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Common/widget/Popup.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetPopupJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Popup;
        });
        /* harmony import */


        var core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.anchor */
        "../Grid/node_modules/core-js/modules/es6.string.anchor.js");
        /* harmony import */


        var core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Panel_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Panel.js */
        "../Grid/lib/Common/widget/Panel.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Popup
         */

        /**
         * Popup widget, used as base class for Menu but can also be used as is to contain widgets or html
         *
         * @extends Common/widget/Panel
         *
         * @example
         * let popup = new Popup({
         *   forElement : document.querySelector('button'),
         *   widgets    : [
         *     { type : 'text', placeholder: 'Text' },
         *     { type: 'button', text: 'Okey', style: 'width: 100%', color: 'orange'}
         *   ]
         * });
         *
         * @classType popup
         * @externalexample widget/Popup.js
         */

        var Popup =
        /*#__PURE__*/
        function (_Panel) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Popup, _Panel);

          function Popup() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Popup);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Popup, [{
            key: "startConfigure",
            //endregion
            value: function startConfigure(config) {
              // Read the closable config which will force evaluation of tools
              // to include close tool.
              this._thisIsAUsedExpression(this.closable);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "startConfigure", this).call(this, config);
            } //region Init & destroy

          }, {
            key: "finalizeInit",
            value: function finalizeInit() {
              var me = this;
              me.anchoredTo = me.forElement;
              me.initialAnchor = me.anchor;

              if (me.forElement && me.showOnClick) {
                // disable autoShow if not enabled by config
                if (!me.initialConfig.autoShow) {
                  me.autoShow = false;
                }

                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
                  element: me.forElement,
                  click: 'onElementUserAction',
                  thisObj: me
                });
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "finalizeInit", this).call(this);

              if (me.autoShow) {
                if (me.autoShow === true) {
                  me.show();
                } else {
                  me.setTimeout(function () {
                    return me.show();
                  }, me.autoShow);
                }
              }
            } //endregion
            //region Show/hide

            /**
             * Performs the configured {@link #config-closeAction} upon this popup.
             * By default, the popup hides. The {@link #config-closeAction} may be
             * configured as `'destroy'`.
             * @fires beforeclose If popup is not hidden
             */

          }, {
            key: "close",
            value: function close() {
              /**
               * Fired when the {@link #function-close} method is called and the popup is not hidden.
               * May be vetoed by returning `false` from a handler.
               * @event beforeClose
               * @param {Common.widget.Popup} source - This Popup
               */
              if (!this._hidden && this.trigger('beforeClose') !== false || // we should destroy it even if it's hidden just omit beforeclose event
              this._hidden && this.closeAction == 'destroy') {
                return this[this.closeAction]();
              }
            } //endregion
            //region Events

          }, {
            key: "onElementResize",
            value: function onElementResize(resizedElement, lastRect, myRect) {
              var me = this,
                  lastAlignSpec = me.lastAlignSpec; // If this Popup changes size while we are aligned and we are aligned to
              // a target (not a position), then we might need to realign.

              if (me.isVisible && lastAlignSpec && lastAlignSpec.target) {
                var heightChange = !lastRect || myRect.height !== lastRect.height,
                    widthChange = !lastRect || myRect.width !== lastRect.width; // Only realign if:
                // the height has changed and we are not aligned below, or
                // the width has changed and we are not aligned to the right.

                if (heightChange && lastAlignSpec.zone !== 2 || widthChange && lastAlignSpec.zone !== 1) {
                  // Must move to next AF because in Chrome, the resize monitor might fire
                  // before the element is painted and the anchor color matching
                  // scheme cannot work in that case.
                  me.requestAnimationFrame(function () {
                    return me.realign();
                  });
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "onElementResize", this).call(this, resizedElement);
            }
          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(event) {
              // close on escape key
              if (event.key === 'Escape') {
                event.stopImmediatePropagation();
                this.close(true);
              }
            }
          }, {
            key: "onDocumentMouseDown",
            value: function onDocumentMouseDown(_ref) {
              var event = _ref.event;
              var me = this;

              if (me.modal && event.target === Popup.modalMask) {
                event.preventDefault();

                if (me.modal.closeOnMaskTap) {
                  me.close();
                } else if (!me.containsFocus) {
                  me.focus();
                }
              } // in case of outside click and if popup is focused, focusout will trigger closing
              else if (!me.owns(event.target) && me.autoClose && !me.containsFocus) {
                  me.close();
                }
            }
          }, {
            key: "onFocusIn",
            value: function onFocusIn(e) {
              var activeEl = document.activeElement;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "onFocusIn", this).call(this, e); // No event handler has moved focus, and target is outermost el
              // then delegate to the focusElement which for a Container
              // is found by finding the first visible, focusable descendant widget.


              if (document.activeElement === activeEl && e.target === this.element) {
                this.focus();
              }
            }
          }, {
            key: "onFocusOut",
            value: function onFocusOut(e) {
              if (this.autoClose) {
                this.close();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "onFocusOut", this).call(this, e);
            }
          }, {
            key: "onShow",
            value: function onShow() {
              var me = this;

              if (me.autoClose && !me.mouseDownRemover) {
                me.mouseDownRemover = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
                  globaltap: 'onDocumentMouseDown',
                  thisObj: me
                });
              } // TODO: It's the floating "toFront" operation that should handle
              // focusing based on config focusOnToFront.


              if (me.focusOnToFront) {
                me.focus();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "onShow", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "onShow", this).call(this); // Insert the modal mask below this Popup

              if (me.modal) {
                // If we have not been explicitly positioned, a modal is centered.
                if (!me._x && !me._y) {
                  me.centered = true;
                }

                var modalMask = Popup.modalMask;
                modalMask.classList.remove('b-hide-display');
                modalMask.parentNode.insertBefore(modalMask, me.element);
              }
            }
          }, {
            key: "onHide",
            value: function onHide() {
              var me = this;

              if (me.mouseDownRemover) {
                me.mouseDownRemover();
                me.mouseDownRemover = null;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "onHide", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "onHide", this).call(this); // Hide the modal mask.

              if (me.modal) {
                Popup.modalMask.classList.add('b-hide-display');
              }
            }
          }, {
            key: "onElementUserAction",
            value: function onElementUserAction() {
              this.show();
            } //endregion

          }, {
            key: "closable",
            set: function set(closable) {
              this._closable = closable;

              if (!this.tools) {
                this.tools = {};
              }
            },
            get: function get() {
              return this._closable;
            }
          }, {
            key: "tools",
            set: function set(tools) {
              var me = this;

              if (me.closable) {
                (tools || (tools = {})).close = {
                  cls: 'b-popup-close',
                  handler: 'close',
                  weight: -1000
                };
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "tools", tools, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Popup.prototype), "tools", this);
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                autoShow: true,

                /**
                 * By default a Popup is transient, and will {@link #function-close} when the user clicks or
                 * taps outside its owned widgets and when focus moves outside its owned widgets.
                 *
                 * Configure as `false` to make a Popup non-transient.
                 * @config {Boolean}
                 * @default
                 */
                autoClose: true,

                /**
                 * Show popup when user clicks the element that it is anchored to. Cannot be combined with showOnHover
                 * @config {Boolean}
                 * @default
                 */
                showOnClick: false,
                forElement: null,
                monitorResize: true,
                floating: true,
                hidden: true,
                axisLock: true,
                // Flip edges if align violates constrainTo
                hideAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isIE11 ? null : {
                  opacity: {
                    from: 1,
                    to: 0,
                    duration: '.3s',
                    delay: '0s'
                  }
                },
                showAnimation: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isIE11 ? null : {
                  opacity: {
                    from: 0,
                    to: 1,
                    duration: '.4s',
                    delay: '0s'
                  }
                },

                /**
                 * The action to take when calling the {@link #function-close} method.
                 * By default, the popup is hidden.
                 *
                 * This may be set to `'destroy'` to destroy the popup upon close.
                 * @config {String}
                 * @default
                 */
                closeAction: 'hide',

                /**
                 * By default, tabbing within a Popup is circular - that is it does not exit.
                 * Configure this as `false` to allow tabbing out of the Popup.
                 * @config {Boolean}
                 * @default
                 */
                trapFocus: true,

                /**
                 * By default a Popup is focused when it is shown.
                 * Configure this as `false` to prevent automatic focus on show.
                 * @config {Boolean}
                 * @default
                 */
                focusOnToFront: true,

                /**
                 * Show a tool in the header to close this Popup, and allow `ESC` close it.
                 * The tool is available in the {@link #property-tools} object
                 * under the name `close`. It uses the CSS class `b-popup-close` to apply a
                 * default close icon. This may be customized with your own CSS rules.
                 * @config {Boolean}
                 * @default
                 */
                closable: null,

                /**
                 * Optionally show an opaque mask below this Popup when shown.
                 * Configure this as `true` to show the mask.
                 *
                 * When a Popup is modal, it defaults to being {@link Common.widget.Widget#config-centered centered}
                 *
                 * May also be an object containing the following properties:
                 * * `closeOnMaskTap` Specify as `true` to {@link #function-close} when mask is tapped.
                 * The default action is to focus the popup.
                 *
                 * Usage:
                 * ```javascript
                 * new Popup({
                 *     title  : 'I am modal',
                 *     modal  : {
                 *         closeOnMaskTap : true
                 *     },
                 *     height : 100,
                 *     width  : 200
                 * });
                 * ```
                 *
                 * @config {Boolean}
                 * @default
                 */
                modal: null
              };
            }
          }, {
            key: "modalMask",
            get: function get() {
              if (!this._modalMask) {
                this._modalMask = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].createElement({
                  className: 'b-modal-mask b-hide-display',
                  parent: this.floatRoot
                });
              }

              return this._modalMask;
            }
          }]);

          return Popup;
        }(_Panel_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        Popup._$name = 'Popup';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__["default"].register('popup', Popup);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Ripple.js":
      /*!*******************************************!*\
        !*** ../Grid/lib/Common/widget/Ripple.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetRippleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Ripple;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        var lastTouchTime = 0;

        var hasRipple = function hasRipple(w) {
          return w.ripple;
        },
            Ripple = window.Ripple = new (
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Ripple, _Widget);

          function Ripple() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Ripple);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Ripple).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Ripple, [{
            key: "afterConstruct",
            value: function afterConstruct() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Ripple.prototype), "afterConstruct", this).call(this);

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
                element: document,
                DOMContentLoaded: 'doEnableDisable',
                thisObj: this
              });

              _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
                theme: 'doEnableDisable',
                thisObj: this
              });
            }
          }, {
            key: "doEnableDisable",
            value: function doEnableDisable() {
              var me = this;
              me.show();

              var rippleAnimation = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getStyleValue(me.circleElement, 'animationName');

              me.hide(); // If our theme supports ripples, add our listeners

              if (rippleAnimation && rippleAnimation !== 'none') {
                me.listenerDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
                  // Trap all mousedowns and see if the encapsulating Component is configured to ripple
                  mousedown: {
                    element: document,
                    capture: true,
                    handler: 'onDocumentMousedown'
                  },
                  touchstart: {
                    element: document,
                    capture: true,
                    handler: 'onDocumentTouchStart'
                  },
                  // Hide at the end of the ripple
                  animationend: {
                    element: me.circleElement,
                    handler: 'onAnimationEnd'
                  },
                  thisObj: me
                });
              } // If not, remove them.
              else {
                  me.listenerDetacher && me.listenerDetacher();
                }
            }
          }, {
            key: "onDocumentTouchStart",
            value: function onDocumentTouchStart(event) {
              lastTouchTime = performance.now();
              this.handleTriggerEvent(event);
            }
          }, {
            key: "onDocumentMousedown",
            value: function onDocumentMousedown(event) {
              // We need to prevent a touchend->mousedown simulated mousedown from triggering a ripple.
              // https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent
              if (performance.now() - lastTouchTime > 200) {
                this.handleTriggerEvent(event);
              }
            }
          }, {
            key: "handleTriggerEvent",
            value: function handleTriggerEvent(event) {
              var targetWidget = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].fromElement(event.target, hasRipple);

              if (targetWidget) {
                var rippleCfg = targetWidget.ripple,
                    target = rippleCfg.delegate ? event.target.closest(rippleCfg.delegate) : targetWidget.focusElement || targetWidget.element;

                if (target) {
                  var ripple = _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].assign({
                    event: event,
                    target: target,
                    radius: this.radius
                  }, rippleCfg); // The clip option is specified as a string property name or delegate


                  if (typeof ripple.clip === 'string') {
                    ripple.clip = targetWidget[ripple.clip] || event.target.closest(ripple.clip); // Not inside an instance of the clip delegate, then no ripple

                    if (!ripple.clip) {
                      return;
                    }
                  }

                  this.ripple(ripple);
                }
              }
            }
          }, {
            key: "ripple",
            value: function ripple(_ref) {
              var event = _ref.event,
                  _ref$point = _ref.point,
                  point = _ref$point === void 0 ? _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getClientPoint(event) : _ref$point,
                  _ref$target = _ref.target,
                  target = _ref$target === void 0 ? event.target : _ref$target,
                  _ref$clip = _ref.clip,
                  clip = _ref$clip === void 0 ? target : _ref$clip,
                  _ref$radius = _ref.radius,
                  radius = _ref$radius === void 0 ? this.radius : _ref$radius,
                  _ref$color = _ref.color,
                  color = _ref$color === void 0 ? this.color : _ref$color;
              this.clip = clip;
              clip = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__["default"].from(clip, null, true);
              var me = this,
                  centreDelta = clip.getDelta(point),
                  rippleStyle = me.rippleElement.style,
                  circleElement = me.circleElement;
              me.hide();
              me.alignTo(clip);
              rippleStyle.transform = "translateX(".concat(centreDelta[0], "px) translateY(").concat(centreDelta[1], "px)");
              rippleStyle.height = rippleStyle.width = "".concat(radius, "px");
              circleElement.setAttribute('r', radius);
              circleElement.setAttribute('fill', color);
              me.show(); // Push binding to the scroll position out until the next animation frame.
              // This is in case the calling code is going to cause a scroll.
              // Mousedown is a focusing gesture which may cause a scroll
              // to fire as the target element moves into view.

              me.requestAnimationFrame(function () {
                document.addEventListener('scroll', me.callRealign, true);
                me.documentScrollListener = true;
              }, 0);
            }
          }, {
            key: "alignTo",
            value: function alignTo(clip) {
              if (clip.nodeType === 1) {
                clip = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_7__["default"].from(clip, null, true);
              }

              var me = this,
                  _clip = clip,
                  x = _clip.x,
                  y = _clip.y,
                  width = _clip.width,
                  height = _clip.height;
              me.x = x;
              me.y = y;
              me.height = height;
              me.width = width;
            } // When fully expanded, it's all over.

          }, {
            key: "onAnimationEnd",
            value: function onAnimationEnd(event) {
              if (event.animationName === 'b-ripple-expand') {
                this.hide();
              }
            }
          }, {
            key: "realign",
            value: function realign() {
              if (this.isVisible) {
                this.alignTo(this.clip);
              }
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                old_element: {
                  children: [{
                    className: 'b-ripple-inner',
                    reference: 'rippleElement'
                  }]
                },
                element: {
                  children: [{
                    tag: 'svg',
                    class: 'b-ripple-inner',
                    reference: 'rippleElement',
                    ns: 'http://www.w3.org/2000/svg',
                    version: '1.1',
                    viewBox: '0 0 100 100',
                    children: [{
                      reference: 'circleElement',
                      tag: 'circle',
                      cx: '0',
                      cy: '0',
                      r: 10
                    }]
                  }]
                },
                floating: true,
                hideAnimation: false,
                showAnimation: false,
                scrollAction: 'realign',
                color: 'rgba(0,0,0,.3)',
                startRadius: 10,
                radius: 100
              };
            }
          }, {
            key: "$name",
            get: function get() {
              return 'Ripple';
            }
          }]);

          return Ripple;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"]))();
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Slider.js":
      /*!*******************************************!*\
        !*** ../Grid/lib/Common/widget/Slider.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetSliderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Slider;
        });
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Tooltip_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n            <div class=\"", "\">\n                <input type=\"range\"\n                   reference=\"input\"\n                   id=\"", "_input\"\n                   min=\"", "\"\n                   max=\"", "\"\n                   step=\"", "\"\n                   value=\"", "\">\n                <label reference=\"label\" for=\"", "_input\">", "</label>\n            </div>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/Slider
         */

        /**
         * Wraps native &lt;input type="range"&gt;
         *
         * @extends Common/widget/Widget
         *
         * @example
         * let slider = new Slider({
         *   text: 'Choose value'
         * });
         *
         * @classType slider
         * @externalexample widget/Slider.js
         */

        var Slider =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Slider, _Widget);

          function Slider() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Slider);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Slider).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Slider, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Slider.prototype), "construct", this).call(this, config);

              me.updateLabel();

              if (me.showTooltip) {
                me.tip = new _Tooltip_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
                  forElement: me.input,
                  anchor: false,
                  // No anchor displayed since thumbSize is different for different themes
                  align: 'b-t',
                  axisLock: true
                });
              }

              me.input.addEventListener('input', me.onInternalInput.bind(me));
              me.input.addEventListener('change', me.onInternalChange.bind(me));
              me.input.addEventListener('mouseover', me.onInternalMouseOver.bind(me));
              me.input.addEventListener('mouseout', me.onInternalMouseOut.bind(me));
            }
          }, {
            key: "template",
            value: function template(widget) {
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].tpl(_templateObject(), widget.text ? 'b-text b-has-label' : '', widget.id, widget.min, widget.max, widget.step, widget.value, widget.id, widget.text);
            }
          }, {
            key: "onInternalInput",
            //endregion
            //region Events
            value: function onInternalInput(event) {
              var me = this;
              me._value = parseInt(me.input.value);
              me.updateUI();
              me.trigger('input', {
                value: me.value
              });
            }
          }, {
            key: "onInternalChange",
            value: function onInternalChange(event) {
              var me = this;
              me.updateUI();
              me.triggerChange(true);
              me.trigger('action', {
                value: me.value
              });
            }
          }, {
            key: "onInternalMouseOver",
            value: function onInternalMouseOver(event) {
              var me = this;
              me.updateLabel();

              if (me.tip) {
                me.tip.showBy({
                  target: me.calcThumbPosition(),
                  offset: 5
                });
              }
            }
          }, {
            key: "onInternalMouseOut",
            value: function onInternalMouseOut(event) {
              if (this.tip) {
                this.tip.hide();
              }
            }
          }, {
            key: "triggerChange",
            value: function triggerChange(userAction) {
              this.trigger('change', {
                value: this.value,
                userAction: userAction
              });
            } //endregion
            //region Getters/setters

            /**
             * Get/Set text. Appends value if Slider.showValue is true
             * @property {String}
             */

          }, {
            key: "updateLabel",
            //endregion
            //region Util

            /**
             * Refresh label text
             * @private
             */
            value: function updateLabel() {
              this.text = this._text;
            }
            /**
             * Refresh tooltip position
             * @private
             */

          }, {
            key: "updateTooltipPosition",
            value: function updateTooltipPosition() {
              if (this.tip) {
                this.tip.alignTo({
                  target: this.calcThumbPosition(),
                  offset: 5
                });
              }
            }
            /**
             * Refresh slider UI
             * @private
             */

          }, {
            key: "updateUI",
            value: function updateUI() {
              this.updateLabel();
              this.updateTooltipPosition();
            }
          }, {
            key: "calcThumbPosition",
            value: function calcThumbPosition() {
              var me = this,
                  inputRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_10__["default"].from(me.input),
                  offset = (inputRect.width - me.thumbSize) * me.calcPercentProgress() / 100;

              return new _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_10__["default"](inputRect.x + offset, inputRect.y + inputRect.height / 2 - me.thumbSize / 2, me.thumbSize, me.thumbSize);
            }
          }, {
            key: "calcPercentProgress",
            value: function calcPercentProgress() {
              return (this.value - this.min) / (this.max - this.min) * 100;
            } //endregion

          }, {
            key: "focusElement",
            get: function get() {
              return this.input;
            }
          }, {
            key: "text",
            get: function get() {
              return this._text;
            },
            set: function set(text) {
              var me = this;
              me._text = text;

              if (me.label) {
                if (me.showValue) {
                  text = text ? "".concat(text, " (").concat(me.value, ")") : me.value;
                }

                me.label.innerHTML = text;
              }

              if (me.tip) {
                me.tip.html = me.value;
              }
            }
            /**
             * Get/set value
             * @property {Number}
             */

          }, {
            key: "value",
            get: function get() {
              return this.input ? parseInt(this.input.value) : this._value;
            },
            set: function set(value) {
              var me = this;

              if (me._value !== value) {
                if (me.input) {
                  me.input.value = value;
                  me.updateUI();
                  me.triggerChange(false);
                }

                me._value = value;
              }
            }
            /**
             * Get/set min value
             * @property {Number}
             */

          }, {
            key: "min",
            get: function get() {
              return this.input ? this.input.min : this._min;
            },
            set: function set(min) {
              var me = this;

              if (me.input) {
                me.input.min = min;

                if (me._value < min) {
                  me.value = min;
                  me.trigger('input', {
                    value: me.value
                  });
                }
              }

              me._min = min;
            }
            /**
             * Get/set max value
             * @property {Number}
             */

          }, {
            key: "max",
            get: function get() {
              return this.input ? this.input.max : this._max;
            },
            set: function set(max) {
              var me = this;

              if (me.input) {
                me.input.max = max;

                if (me._value > max) {
                  me.value = max;
                  me.trigger('input', {
                    value: me.value
                  });
                }
              }

              me._max = max;
            }
            /**
             * Get/set step size
             * @property {Number}
             */

          }, {
            key: "step",
            get: function get() {
              return this.input ? this.input.step : this._step;
            },
            set: function set(step) {
              if (this.input) this.input.step = step;
              this._step = step;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Slider label text
                 * @config {String}
                 */
                text: '',

                /**
                 * Show value in label (appends in () if text is set)
                 * @config {Boolean}
                 * @default
                 */
                showValue: true,

                /**
                 * Show value in tooltip
                 * @config {Boolean}
                 * @default
                 */
                showTooltip: false,

                /**
                 * Minimum value
                 * @config {Number}
                 * @default
                 */
                min: 0,

                /**
                 * Maximum value
                 * @config {Number}
                 * @default
                 */
                max: 100,

                /**
                 * Step size
                 * @config {Number}
                 * @default
                 */
                step: 1,

                /**
                 * Initial value
                 * @config {Number}
                 */
                value: null,
                // The value is set in the Light theme. The Material theme will have different value.
                thumbSize: 20,
                localizableProperties: ['text']
              };
            }
          }]);

          return Slider;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        Slider._$name = 'Slider';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__["default"].register('slider', Slider);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/TabPanel.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Common/widget/TabPanel.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetTabPanelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TabPanel;
        });
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Container_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Container.js */
        "../Grid/lib/Common/widget/Container.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _layout_Card_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./layout/Card.js */
        "../Grid/lib/Common/widget/layout/Card.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n                <div>\n                    <div class=\"b-tabpanel-tabs\" reference=\"tabStrip\">\n                        ", "\n                    </div>\n                    <div class=\"b-tabpanel-body\" reference=\"tabPanelBody\" data-activeIndex=\"", "\">\n                    </div>\n                </div>\n            "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/TabPanel
         */

        /**
         * Tab panel widget, displays a collection of tabs which each can contain other widgets. Layout is handled using css
         *
         * @extends Common/widget/Widget
         * @example
         * let tabPanel = new TabPanel({
         *  items: [
         *      {
         *          title: 'First',
         *          items: [
         *              { type: 'textfield', label: 'Name' },
         *              ...
         *          ]
         *      }, {
         *          title: 'Last',
         *          items: [
         *              ...
         *          ]
         *      }
         *  ]
         * });
         *
         * @classType tabpanel
         * @externalexample widget/TabPanel.js
         */

        var TabPanel =
        /*#__PURE__*/
        function (_Container) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(TabPanel, _Container);

          function TabPanel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, TabPanel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TabPanel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TabPanel, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TabPanel.prototype), "construct", this).call(this, config); // assign elements to titleElement, so they can get updated automatically when title is changed


              me.items.forEach(function (tab, i) {
                tab.titleElement = me.element.querySelector("div.b-tabpanel-tab[data-index=\"".concat(i, "\"] span"));
              });

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
                element: me.tabStrip,
                delegate: '.b-tabpanel-tab',
                click: 'onTabElementClick',
                thisObj: me
              });
            } //endregion

          }, {
            key: "onTabElementClick",
            //endregion
            //region Events
            value: function onTabElementClick(event) {
              this.activeTab = event.currentTarget.dataset.index;
            } //endregion

          }, {
            key: "tabMinWidth",
            set: function set(width) {
              this._tabMinWidth = width;
              this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].forEachSelector(this.element, '.b-tabpanel-tab', function (tab) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].setLength(tab, 'minWidth', width || null);
              });
            },
            get: function get() {
              return this._tabMinWidth;
            }
          }, {
            key: "tabMaxWidth",
            set: function set(width) {
              this._tabMaxWidth = width;
              this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].forEachSelector(this.element, '.b-tabpanel-tab', function (tab) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].setLength(tab, 'maxWidth', width || null);
              });
            },
            get: function get() {
              return this._tabMaxWidth;
            }
          }, {
            key: "layout",
            set: function set(layout) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TabPanel.prototype), "layout", layout, this, true);

              this.layout.animateCardChange = this.animateTabChange;
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TabPanel.prototype), "layout", this);
            } //region Tabs

          }, {
            key: "contentElement",
            get: function get() {
              return this.tabPanelBody;
            }
          }, {
            key: "focusElement",
            get: function get() {
              var activeTab = this.items[this.activeTab || 0],
                  tabFocusElement = activeTab && activeTab.focusElement;
              return tabFocusElement || this.tabStrip.children[this.activeTab];
            }
            /**
             * Get/set active tab, using index or the Widget to activate.
             * @property {Common.widget.Widget|Number}
             */

          }, {
            key: "activeTab",
            set: function set(index) {
              var me = this;

              if (me.isConfiguring) {
                me._activeTab = index;
              } else {
                var tabchangeEvent = me.layout.setActiveItem(index),
                    promise = tabchangeEvent.promise,
                    activeIndex = tabchangeEvent.activeIndex,
                    activeItem = tabchangeEvent.activeItem; // If the layout successfully activated a new item...

                if (activeItem) {
                  var tabStrip = me.tabStrip,
                      prevTabElement = tabStrip.children[me._activeTab]; // Our UI changes immediately, our state must be accurate

                  me._activeTab = activeIndex; // Deactivate previous active tab

                  if (prevTabElement) {
                    prevTabElement.classList.remove('b-active');
                  } // Activate the new tab


                  tabStrip.children[activeIndex].classList.add('b-active');
                  promise.then(function () {
                    /**
                     * The active tab has changed.
                     * @event tabchange
                     * @param {Common.widget.Widget} prevActiveItem - The previous active child widget.
                     * @param {Number} prevActiveIndex - The previous active index.
                     * @param {Common.widget.Widget} activeItem - The new active child widget.
                     * @param {Number} activeIndex - The new active index.
                     */
                    me.trigger('tabchange', tabchangeEvent);
                  });
                }
              }
            }
            /**
             * The active tab index. Setting must be done through {@link #property-activeTab}
             * @property {Number}
             * @readonly
             */
            ,
            get: function get() {
              return this._activeTab;
            }
            /**
             * The active child widget. Setting must be done through {@link #property-activeTab}
             * @property {Common.widget.Widget}
             * @readonly
             */

          }, {
            key: "activeIndex",
            get: function get() {
              return this.activeTab;
            }
          }, {
            key: "activeItem",
            get: function get() {
              return this.layout.activeItem;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                template: function template(me) {
                  return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].tpl(_templateObject(), me.items.map(function (tab, i) {
                    return "\n                        <div tabindex=\"-1\" data-index=\"".concat(i, "\" class=\"b-tabpanel-tab ").concat(i === me.activeIndex ? 'b-active' : '', " ").concat(tab.cls || '', "\" style=\"").concat(me.tabMinWidth ? 'min-width:' + _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].setLength(me.tabMinWidth) + ';' : '', " ").concat(me.tabMaxWidth ? 'max-width:' + _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].setLength(me.tabMaxWidth) + ';' : '', "\" >\n                            <span class=\"b-tabpanel-tab-title\">").concat(tab.title, "</span>\n                        </div>\n                        ");
                  }), me.activeIndex);
                },
                itemCls: 'b-tabpanel-item',
                defaultType: 'container',

                /**
                 * The index of the initially active tab.
                 * @config {Number}
                 * @default
                 */
                activeTab: 0,

                /**
                 * Min width of a tab title. 0 means no minimum width. This is default.
                 * @config {Number}
                 * @default
                 */
                tabMinWidth: null,

                /**
                 * Max width of a tab title. 0 means no maximum width. This is default.
                 * @config {Number}
                 * @default
                 */
                tabMaxWidth: null,

                /**
                 * Specifies whether to slide tabs in and out of visibility.
                 * @config {Boolean}
                 * @default
                 */
                animateTabChange: true,
                layout: 'card',
                // Prevent child panels from displaying a header unless explicitly configured with one
                suppressChildHeaders: true
              };
            }
          }]);

          return TabPanel;
        }(_Container_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        TabPanel._$name = 'TabPanel';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__["default"].register('tabpanel', TabPanel);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__["default"].register('tabs', TabPanel);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/TextAreaField.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/widget/TextAreaField.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetTextAreaFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TextAreaField;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _PickerField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./PickerField.js */
        "../Grid/lib/Common/widget/PickerField.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        function _templateObject2() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default()(["<input type=\"text\"\n                readOnly=\"readonly\"\n                reference=\"displayElement\"\n                placeholder=\"", "\"/>"]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default()(["<textarea\n                reference=\"input\"\n                class=\"", "\"\n                placeholder=\"", "\"\n                name=\"", "\"\n                style=\"resize:", "\"\n                id=\"", "\"></textarea>"]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Common/widget/TextAreaField
         */

        /**
         * TextAreaField widget. Wraps native &lt;input type="text"&gt;
         *
         * @extends Common/widget/Field
         *
         * @example
         * let textAreaField = new TextAreaField({
         *   placeholder: 'Enter some text'
         * });
         *
         * @classType textareafield
         */

        var TextAreaField =
        /*#__PURE__*/
        function (_PickerField) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(TextAreaField, _PickerField);

          function TextAreaField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, TextAreaField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TextAreaField, [{
            key: "startConfigure",
            value: function startConfigure(config) {
              // Read the inline config which will force evaluation of triggers.
              this._thisIsAUsedExpression(this.inline);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "startConfigure", this).call(this, config);
            }
          }, {
            key: "inputTemplate",
            value: function inputTemplate() {
              var me = this;

              if (me.inline) {
                return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].tpl(_templateObject(), me.inputCls || '', me.placeholder, me.name || me.id, me.resize, me.id + '_input');
              } else {
                return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].tpl(_templateObject2(), me.placeholder);
              }
            }
          }, {
            key: "showPicker",
            value: function showPicker() {
              var me = this,
                  picker = me.picker;
              picker.width = me.pickerWidth || me[me.pickerAlignElement].offsetWidth; // Always focus the picker.

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "showPicker", this).call(this, true);
            }
          }, {
            key: "focusPicker",
            value: function focusPicker() {
              this.input.focus();
            }
          }, {
            key: "onPickerKeyDown",
            value: function onPickerKeyDown(keyEvent) {
              var me = this,
                  realInput = me.input;

              switch (keyEvent.key.trim() || keyEvent.code) {
                case 'Escape':
                  // TODO: revert value?
                  me.picker.hide();
                  return;

                case 'Enter':
                  if (keyEvent.ctrlKey) {
                    me.syncInputFieldValue();
                    me.picker.hide();
                  }

                  break;
              } // Super's onPickerKeyDown fires through this.input, so avoid infinite recursion
              // by redirecting it through the displayElement.


              me.input = me.displayElement;

              var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "onPickerKeyDown", this).call(this, keyEvent);

              me.input = realInput;
              return result;
            }
          }, {
            key: "syncInputFieldValue",
            value: function syncInputFieldValue() {
              if (this.displayElement) {
                this.displayElement.value = this.inputValue;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "syncInputFieldValue", this).call(this);
            }
          }, {
            key: "focusElement",
            get: function get() {
              return this.inline || this._picker && this._picker.isVisible ? this.input : this.displayElement;
            }
          }, {
            key: "value",
            set: function set(value) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "value", value == null ? '' : value, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "value", this);
            }
          }, {
            key: "inline",
            set: function set(inline) {
              this._inline = inline;

              if (!inline && !this.triggers) {
                this.triggers = {};
              }
            },
            get: function get() {
              return this._inline;
            }
          }, {
            key: "triggers",
            set: function set(triggers) {
              if (!this.inline) {
                (triggers || (triggers = {})).expand = {
                  cls: 'b-icon-picker',
                  handler: 'onTriggerClick'
                };
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "triggers", triggers, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextAreaField.prototype), "triggers", this);
            }
          }, {
            key: "picker",
            get: function get() {
              if (!this._picker) {
                this.picker = true;
              }

              return this._picker;
            },
            set: function set(picker) {
              var me = this;

              if (me._picker) {
                me._picker.destroy();
              } // Allow configuring pickerWidth in one go. Setting `picker = { width : 300 }` will otherwise be overridden by
              // pickerWidth or fields width.


              if (picker.width) {
                me.pickerWidth = picker.width;
              }

              me._picker = new _Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"](_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].merge({
                cls: 'b-textareafield-picker',
                owner: me,
                floating: true,
                scrollAction: 'realign',
                forElement: me[me.pickerAlignElement],
                align: {
                  align: 't-b',
                  axisLock: true,
                  anchor: me.overlayAnchor,
                  target: me[me.pickerAlignElement]
                },
                html: "<textarea id=\"".concat(me.id + '_input', "\" style=\"resize:").concat(me.resize, "\">").concat(me.value, "</textarea>"),
                autoShow: false
              }, picker));
              var input = me.input = me.picker.element.querySelector("#".concat(me.id, "_input"));
              me.inputListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
                element: input,
                thisObj: me,
                focus: 'internalOnInputFocus',
                change: 'internalOnChange',
                input: 'internalOnInput',
                keydown: 'internalOnKeyPress',
                keypress: 'internalOnKeyPress',
                keyup: 'internalOnKeyPress'
              });
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                triggers: null,
                // Override PickerField. We don't have a trigger by default

                /**
                 * Configure as `false` to have the field render as a non-editable picker field which
                 * shows a `<textarea>` input when expanded.
                 * @config {Boolean}
                 * @default
                 */
                inline: true,

                /**
                 * The resize style to apply to the `<textarea>` element.
                 * @config {String}
                 * @default
                 */
                resize: 'none'
              };
            }
          }]);

          return TextAreaField;
        }(_PickerField_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        TextAreaField._$name = 'TextAreaField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__["default"].register('textareafield', TextAreaField);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__["default"].register('textarea', TextAreaField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/TextField.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/widget/TextField.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetTextFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TextField;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Field_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Field.js */
        "../Grid/lib/Common/widget/Field.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default()(["<input type=\"", "\"\n            reference=\"input\"\n            class=\"", "\"\n            placeholder=\"", "\" \n            autocomplete=\"", "\"\n            name=\"", "\"\n            id=\"", "\"\n            ", "/>"]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler'; //TODO: label should be own element

        /**
         * @module Common/widget/TextField
         */

        /**
         * Textfield widget. Wraps native &lt;input type="text"&gt;
         *
         * @extends Common/widget/Field
         *
         * @example
         * let textField = new TextField({
         *   placeholder: 'Enter some text'
         * });
         *
         * @classType textfield
         * @externalexample widget/TextField.js
         */

        var TextField =
        /*#__PURE__*/
        function (_Field) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(TextField, _Field);

          function TextField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, TextField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TextField, [{
            key: "inputTemplate",
            value: function inputTemplate() {
              var me = this,
                  style = 'inputWidth' in me ? "style=\"width:".concat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].setLength(me.inputWidth), "\"") : '';
              return _helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].tpl(_templateObject(), me.inputType || 'text', me.inputCls || '', me.placeholder, me.autoComplete, me.name || me.id, me.id + '_input', style);
            }
          }, {
            key: "value",
            set: function set(value) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextField.prototype), "value", this.$name === 'TextField' && value == null ? '' : value, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TextField.prototype), "value", this);
            }
          }]);

          return TextField;
        }(_Field_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        TextField._$name = 'TextField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('textfield', TextField);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('text', TextField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/TimeField.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Common/widget/TimeField.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetTimeFieldJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeField;
        });
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _PickerField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./PickerField.js */
        "../Grid/lib/Common/widget/PickerField.js");
        /* harmony import */


        var _TimePicker_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./TimePicker.js */
        "../Grid/lib/Common/widget/TimePicker.js");
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");

        var productName = 'scheduler'; //TODO: picker icon (clock) should be clock that shows actual time

        /**
         * @module Common/widget/TimeField
         */

        /**
         * Time field widget (text field + time picker).
         *
         * @extends Common/widget/PickerField
         *
         * @example
         * let field = new TimeField({
         *   format: 'HH'
         * });
         *
         * @classType timefield
         * @externalexample widget/TimeField.js
         */

        var TimeField =
        /*#__PURE__*/
        function (_PickerField) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(TimeField, _PickerField);

          function TimeField() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TimeField);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimeField, [{
            key: "onBackClick",
            //endregion
            //region Click listeners
            value: function onBackClick() {
              var me = this,
                  min = me.min;

              if (!me.readOnly && me.value) {
                var newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(me.value, -1 * me._step.magnitude, me._step.unit);

                if (!min || min.getTime() <= newValue) {
                  me._isUserAction = true;
                  me.value = newValue;
                  me._isUserAction = false;
                }
              }
            }
          }, {
            key: "onForwardClick",
            value: function onForwardClick() {
              var me = this,
                  max = me.max;

              if (!me.readOnly && me.value) {
                var newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].add(me.value, me._step.magnitude, me._step.unit);

                if (!max || max.getTime() >= newValue) {
                  me._isUserAction = true;
                  me.value = newValue;
                  me._isUserAction = false;
                }
              }
            } //endregion
            // region Validation

          }, {
            key: "hasChanged",
            value: function hasChanged(oldValue, newValue) {
              if (oldValue && oldValue.getTime && newValue && newValue.getTime) {
                return oldValue.getTime() !== newValue.getTime();
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField.prototype), "hasChanged", this).call(this, oldValue, newValue);
            } //endregion
            //region Toggle picker

            /**
             * Show picker
             */

          }, {
            key: "showPicker",
            value: function showPicker(focusPicker) {
              var me = this,
                  picker = me.picker;
              picker.initialValue = me.value;
              picker.format = me.format;
              picker.maxTime = me.max;
              picker.minTime = me.min; // Show valid time from picker while editor has undefined value

              me.value = picker.value;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField.prototype), "showPicker", this).call(this, focusPicker);
            }
          }, {
            key: "onPickerShow",
            value: function onPickerShow() {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField.prototype), "onPickerShow", this).call(this); // Remove PickerField key listener


              me.pickerKeyDownRemover && me.pickerKeyDownRemover();
            }
            /**
             * Focus time picker
             */

          }, {
            key: "focusPicker",
            value: function focusPicker() {
              this.picker.focus();
            } //endregion
            //region Getters/setters

          }, {
            key: "transformTimeValue",
            value: function transformTimeValue(value) {
              if (value != null) {
                if (!(value.constructor.name === 'Date')) {
                  if (typeof value === 'string') {
                    value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parse(value, this.format);
                  } else {
                    value = new Date(value);
                  }
                } // We insist on a *valid* Time as the value.
                // An invalid Date object returns NaN as its valueof().


                if (value && value.constructor.name === 'Date' && !isNaN(value.valueOf())) {
                  // Clear date part back to zero so that all we have is the time part of the epoch.
                  value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clone(value);
                  value.setFullYear(1970, 0, 1);
                  return value;
                }
              }

              return null;
            }
            /**
             * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "updateLocalization",
            //endregion
            //region Localization
            value: function updateLocalization() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField.prototype), "updateLocalization", this).call(this);

              this.syncInputFieldValue();
            } //endregion

          }, {
            key: "picker",
            //endregion
            //region Init & destroy
            get: function get() {
              if (!this._picker) {
                this.picker = true;
              }

              return this._picker;
            },
            set: function set(picker) {
              var me = this;

              if (me._picker) {
                me._picker.destroy();
              }

              me._picker = new _TimePicker_js__WEBPACK_IMPORTED_MODULE_11__["default"](Object.assign({
                owner: me,
                floating: true,
                forElement: me[me.pickerAlignElement],
                align: {
                  align: 't0-b0',
                  axisLock: true,
                  anchor: me.overlayAnchor,
                  target: me[me.pickerAlignElement]
                },
                value: me.value,
                format: me.format,
                onTimeChange: function onTimeChange(_ref) {
                  var time = _ref.time;
                  me._isUserAction = true;
                  me.value = time;
                  me._isUserAction = false;
                }
              }, picker));
            }
          }, {
            key: "isValid",
            get: function get() {
              var me = this;
              me.clearError('minimumValueViolation', true);
              me.clearError('maximumValueViolation', true);
              var value = me.value;

              if (value) {
                value = value.getTime();

                if (me._min && me._min.getTime() > value) {
                  me.setError('minimumValueViolation', true);
                  return false;
                }

                if (me._max && me._max.getTime() < value) {
                  me.setError('maximumValueViolation', true);
                  return false;
                }
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField.prototype), "isValid", this);
            }
          }, {
            key: "min",
            set: function set(value) {
              var me = this;
              me._min = me.transformTimeValue(value);
              me.input && (me.input.min = me._min);
              me.updateInvalid();
            },
            get: function get() {
              return this._min;
            }
            /**
             * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "max",
            set: function set(value) {
              var me = this;
              me._max = me.transformTimeValue(value);
              me.input && (me.input.max = me._max);
              me.updateInvalid();
            },
            get: function get() {
              return this._max;
            }
            /**
             * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "value",
            set: function set(value) {
              var me = this,
                  oldValue = me.value,
                  newValue = me.transformTimeValue(value); // A value we could not parse

              if (value && !newValue) {
                // setError uses localization
                me.setError('invalidTime');
                return;
              }

              me.clearError('invalidTime'); // Reject non-change

              if (!me.hasChanged(oldValue, newValue)) {
                return;
              } // This makes to clock icon show correct time


              if (me.triggers.expand && newValue) {
                me.triggers.expand.element.firstElementChild.style.animationDelay = -((newValue.getHours() * 60 + newValue.getMinutes()) / 10) + 's';
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField.prototype), "value", newValue, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimeField.prototype), "value", this);
            }
            /**
             *  The `step` property may be set in Object form specifying two properties,
             * `magnitude`, a Number, and `unit`, a String.
             *
             * If a Number is passed, the steps's current unit is used and just the magnitude is changed.
             *
             * If a String is passed, it is parsed in accordance with (see {@link Common.helper.DateHelper#function-format-static}.
             * The string is taken to be the numeric magnitude then an abbreviation, or name of the unit.
             *
             * Upon read, the value is always returned in object form containing `magnitude` and `unit`.
             * @property {String|Number|Object}
             * */

          }, {
            key: "step",
            set: function set(value) {
              var me = this;

              if (typeof value === 'number') {
                value = {
                  magnitude: value,
                  unit: me._step.unit
                };
              } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value) !== 'object') {
                value = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parseDuration(value);
              }

              if (value && value.magnitude && value.unit) {
                value.magnitude = Math.abs(value.magnitude);
                me._step = value;
                me.updateInvalid();
              }
            },
            get: function get() {
              return this._step;
            }
            /**
             * Get/Set format for time displayed in field (see {@link Common.helper.DateHelper#function-format-static} for formatting options)
             * @property {String}
             */

          }, {
            key: "format",
            set: function set(value) {
              var me = this;
              me._format = value;
              me.syncInputFieldValue();
            },
            get: function get() {
              return this._format;
            }
          }, {
            key: "inputValue",
            get: function get() {
              return _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(this.value, this.format);
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              var _this = this;

              return {
                /**
                 * Format for date displayed in field (see Common.helper.DateHelper#function-format-static for formatting options)
                 * @config {String}
                 * @default
                 */
                format: 'LT',
                triggers: {
                  back: {
                    cls: 'b-icon b-icon-angle-left',
                    handler: 'onBackClick',
                    align: 'start'
                  },
                  expand: {
                    template: function template() {
                      return "<div class=\"b-align-".concat(_this.align || 'end', "\"><div class=\"b-icon-clock-live\"></div></div>");
                    },
                    handler: 'onTriggerClick',
                    align: 'end'
                  },
                  forward: {
                    cls: 'b-icon b-icon-angle-right',
                    handler: 'onForwardClick',
                    align: 'end'
                  }
                },

                /**
                 * Min time value
                 * @config {String|Date}
                 */
                min: null,

                /**
                 * Max time value
                 * @config {String|Date}
                 */
                max: null,

                /**
                 * Time increment duration value. Defaults to 5 minutes.
                 * The value is taken to be a string consisting of the numeric magnitude and the units.
                 * The units may be a recognised unit abbreviation of this locale or the full local unit name.
                 * For example `"10m"` or `"5min"` or `"2 hours"`
                  * @config {String}
                 */
                step: '5m'
              };
            }
          }]);

          return TimeField;
        }(_PickerField_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        TimeField._$name = 'TimeField';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__["default"].register('timefield', TimeField);

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_13__["default"].register('time', TimeField);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/TimePicker.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/widget/TimePicker.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetTimePickerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimePicker;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Popup_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./Popup.js */
        "../Grid/lib/Common/widget/Popup.js");
        /* harmony import */


        var _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/TimePicker
         */

        /**
         * A Popup which displays hour and minute number fields and AM/PM switcher buttons for 12 hour time format.
         * Fires timeChange event upon user changes time.
         *
         * This class is not intended for use in applications. It is used internally by the
         * {@link Common.widget.TimeField} class.
         *
         * @classType timepicker
         * @private
         */

        var TimePicker =
        /*#__PURE__*/
        function (_Popup) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(TimePicker, _Popup);

          function TimePicker() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TimePicker);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(TimePicker).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TimePicker, [{
            key: "construct",
            //endregion
            //region Init

            /**
             * Fires when a time is changed.
             * @event timeChange
             * @param {Date} time The selected time.
             */
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(TimePicker.prototype), "construct", this).call(this, config);

              me._pm = false;
              me.fieldHours.on('change', me.onFieldChange, me);
              me.fieldMinutes.on('change', me.onFieldChange, me);
              me.buttonAM.on('click', me.onButtonAMClick, me);
              me.buttonPM.on('click', me.onButtonPMClick, me);

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                element: me.element,
                keydown: 'onPickerKeyDown',
                thisObj: me
              });

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                element: me.fieldHours.element,
                keydown: 'onPickerKeyDown',
                thisObj: me
              });

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                element: me.fieldMinutes.element,
                keydown: 'onPickerKeyDown',
                thisObj: me
              });

              me.refresh();
            } //endregion
            //region Event listeners

          }, {
            key: "onFieldChange",
            value: function onFieldChange() {
              var me = this;

              if (me._time) {
                me.value = me.pickerToTime();
              }
            }
          }, {
            key: "onButtonAMClick",
            value: function onButtonAMClick() {
              var me = this;
              me._pm = false;

              if (me._time) {
                me.value = me.pickerToTime();
              }
            }
          }, {
            key: "onButtonPMClick",
            value: function onButtonPMClick() {
              var me = this;
              me._pm = true;

              if (me._time) {
                me.value = me.pickerToTime();
              }
            }
          }, {
            key: "onPickerKeyDown",
            value: function onPickerKeyDown(keyEvent) {
              var me = this,
                  keyName = keyEvent.key && keyEvent.key.trim() || keyEvent.code;

              switch (keyName) {
                case 'Escape':
                  // Support for undefined initial time
                  me.triggerTimeChange(me._initialValue);
                  me.hide();
                  keyEvent.preventDefault();
                  break;

                case 'Enter':
                  me.value = me.pickerToTime();
                  me.hide();
                  keyEvent.preventDefault();
                  break;
              }
            } //endregion
            //region Internal functions

          }, {
            key: "pickerToTime",
            value: function pickerToTime() {
              var me = this,
                  pm = me._pm;
              var hours = me.fieldHours.value,
                  newValue = new Date(me._time);

              if (!me._is24Hour) {
                if (pm && hours < 12) hours = hours + 12;
                if (!pm && hours === 12) hours = 0;
              }

              newValue.setHours(hours);
              newValue.setMinutes(me.fieldMinutes.value);

              if (me._min) {
                newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].max(me._min, newValue);
              }

              if (me._max) {
                newValue = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].min(me._max, newValue);
              }

              return newValue;
            }
          }, {
            key: "triggerTimeChange",
            value: function triggerTimeChange(time) {
              this.trigger('timeChange', {
                time: time
              });
            } //endregion
            //region Getters / Setters

            /**
             * Get/set value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "refresh",
            //endregion
            //region Display
            value: function refresh() {
              var me = this;

              if (!me.isConfiguring) {
                var time = me._time,
                    is24 = me._is24Hour,
                    hours = time.getHours(),
                    pm = me._pm = hours >= 12,
                    fieldHours = me.fieldHours;
                me.element.classList[is24 ? 'add' : 'remove']('b-24h');
                fieldHours.min = is24 ? 0 : 1;
                fieldHours.max = is24 ? 23 : 12;
                fieldHours.value = is24 ? hours : hours % 12 || 12;
                me.fieldMinutes.value = time.getMinutes();
                me.buttonAM.pressed = !pm;
                me.buttonPM.pressed = pm;
                me.buttonAM.hidden = me.buttonPM.hidden = is24;
              }
            } //endregion

          }, {
            key: "value",
            set: function set(newTime) {
              var me = this;
              var changed = false;

              if (!newTime || !me._time) {
                me._time = TimePicker.defaultConfig.value;
                changed = true;
              } else if (newTime.getTime() !== me._time.getTime()) {
                me._time = newTime;
                changed = true;
              }

              if (changed) {
                if (me.isVisible) {
                  me.triggerTimeChange(me.value);
                }

                me.refresh();
              }
            },
            get: function get() {
              return this._time;
            }
            /**
             * Get/Set format for time displayed in field (see Common.helper.DateHelper#format for formatting options)
             * @property {String}
             */

          }, {
            key: "format",
            set: function set(value) {
              var me = this;
              me._format = value;
              me._is24Hour = _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].is24HourFormat(me._format);
              me.refresh();
            },
            get: function get() {
              return this._format;
            }
            /**
             * Get/set max value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "min",
            set: function set(value) {
              this._min = value;
            },
            get: function get() {
              return this._min;
            }
            /**
             * Get/set min value, which can be a Date or a string. If a string is specified, it will be converted using the
             * specified {@link #config-format}
             * @property {Date|String}
             */

          }, {
            key: "max",
            set: function set(value) {
              this._max = value;
            },
            get: function get() {
              return this._max;
            }
            /**
             * Get/set initial value and value, which can be a Date or a string. If a string is specified,
             * it will be converted using the specified {@link #config-format}. Initial value is restored on Escape click
             * @property {Date|String}
             */

          }, {
            key: "initialValue",
            set: function set(value) {
              this.value = value;
              this._initialValue = value;
            },
            get: function get() {
              return this._initialValue;
            } //endregion
            //region Internal widgets getters

          }, {
            key: "buttonAM",
            get: function get() {
              return this.widgetMap.buttonAM;
            }
          }, {
            key: "buttonPM",
            get: function get() {
              return this.widgetMap.buttonPM;
            }
          }, {
            key: "fieldHours",
            get: function get() {
              return this.widgetMap.fieldHours;
            }
          }, {
            key: "fieldMinutes",
            get: function get() {
              return this.widgetMap.fieldMinutes;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                items: [{
                  type: 'number',
                  ref: 'fieldHours',
                  min: 0,
                  max: 23
                }, {
                  html: '<label>:</label>'
                }, {
                  type: 'number',
                  ref: 'fieldMinutes',
                  min: 0,
                  max: 59
                }, {
                  type: 'button',
                  text: 'AM',
                  toggleGroup: 'am-pm',
                  ref: 'buttonAM',
                  cls: 'b-blue'
                }, {
                  type: 'button',
                  text: 'PM',
                  toggleGroup: 'am-pm',
                  ref: 'buttonPM',
                  cls: 'b-blue'
                }],
                float: '1',
                autoShow: false,
                trapFocus: true,

                /**
                 * Default time value
                 * @config {Date}
                 */
                value: _helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getTime(0),

                /**
                 * Time format. Used to set appropriate 12/24 hour format to display.
                 * See Common.helper.DateHelper#format for formatting options.
                 * @config {String}
                 */
                format: null
              };
            }
          }]);

          return TimePicker;
        }(_Popup_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        TimePicker._$name = 'TimePicker';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__["default"].register('timepicker', TimePicker);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Toast.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Common/widget/Toast.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetToastJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Toast;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Toast
         */

        /**
         * Basic toast. Toasts are stacked on top of each other
         * @example
         * // simplest possible
         * Toast.show('Just toasting');
         *
         * // with config
         * Toast.show({
         *   html: 'Well toasted',
         *   showProgress: false
         * });
         *
         * // as instance (instance is also returned from Toast.show()
         * let toast = new Toast({
         *   html: 'Not going away',
         *   timeout: 0
         * });
         *
         * toast.show();
         *
         * @classType toast
         * @externalexample widget/Toast.js
         */

        var Toast =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Toast, _Widget);

          function Toast() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Toast);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Toast).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Toast, [{
            key: "doDestroy",
            value: function doDestroy() {
              var index = Toast.toasts.indexOf(this);

              if (index > -1) {
                Toast.toasts.splice(index, 1);
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Toast.prototype), "doDestroy", this).call(this);
            } // Toasts must not create their element until show.

          }, {
            key: "show",

            /**
             * Show the toast
             */
            value: function show() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Toast.prototype), "show", this).call(this);

              if (this.timeout > 0) {
                this.hideTimeout = this.setTimeout('hide', this.timeout);
              }
            }
            /**
             * Hide the toast
             */

          }, {
            key: "hide",
            value: function hide() {
              var me = this;

              if (!me.destroyTimeout) {
                me.element.classList.add('b-toast-hide');
                me.element.style.bottom = '';
                me.animationTimeout = me.setTimeout('destroy', 200);
              }
            }
            /**
             * Hide all visible toasts
             */

          }, {
            key: "element",
            set: function set(element) {},
            get: function get() {
              // Toasts must not create their element until show.
              if (!this._element && !this.isConfiguring) {
                var me = this,
                    topToast = Toast.toasts.length && Toast.toasts[0].element,
                    bottom = topToast ? topToast._nextBottom : me.bottomMargin,
                    element = _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Toast.prototype), "element", _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].createElement({
                  parent: me.appendTo || _Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"].floatRoot,
                  children: me.showProgress ? [{
                    className: 'b-toast-progress',
                    style: "animation-duration:".concat(me.timeout / 1000, "s;")
                  }] : null,
                  html: me._html,
                  className: me.color || '',
                  style: me._style || ''
                }), this, true);

                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].on({
                  element: element,
                  click: 'hide',
                  thisObj: me
                });

                Toast.toasts.unshift(me);
                element._nextBottom = bottom + element.offsetHeight + me.bottomMargin; // Transitioned style props must be set dynamically

                element.style.cssText += ";bottom:".concat(bottom, "px;transform:translateY(0)");
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Toast.prototype), "element", this);
            }
          }], [{
            key: "hideAll",
            value: function hideAll() {
              Toast.toasts.reverse().forEach(function (toast) {
                return toast.hide();
              });
            }
            /**
             * Easiest way to show a toast
             * @param {String|Object} msgOrConfig Message or toast config object
             * @returns {Common.widget.Toast}
             * @example
             * Toast.show('Hi');
             * @example
             * Toast.show({
             *   html   : 'Read quickly, please',
             *   timeout: 1000
             * });
             */

          }, {
            key: "show",
            value: function show(msgOrConfig) {
              var toast = new Toast(typeof msgOrConfig === 'string' ? {
                html: msgOrConfig
              } : msgOrConfig);
              toast.show();
              return toast;
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                floating: true,

                /**
                 * Timeout (in ms) until the toast is automatically dismissed. Set to 0 to never hide.
                 * @config {Number}
                 * @default
                 */
                timeout: 2500,

                /**
                 * Show a progress bar indicating the time remaining until the toast is dismissed.
                 * @config {Boolean}
                 * @default
                 */
                showProgress: true,

                /**
                 * Toast color (should have match in toast.scss or your custom styling).
                 * Valid values in Bryntum themes are:
                 * * b-amber
                 * * b-blue
                 * * b-dark-gray
                 * * b-deep-orange
                 * * b-gray
                 * * b-green
                 * * b-indigo
                 * * b-lime
                 * * b-light-gray
                 * * b-light-green
                 * * b-orange
                 * * b-purple
                 * * b-red
                 * * b-teal
                 * * b-white
                 * * b-yellow
                 *
                 * ```
                 * new Toast({
                 *    color : 'b-blue'
                 * });
                 * ```
                 *
                 * @config {String}
                 */
                color: null,
                bottomMargin: 20
              };
            }
          }]);

          return Toast;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        Toast.toasts = [];
        Toast._$name = 'Toast';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_8__["default"].register('toast', Toast);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Tool.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Common/widget/Tool.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetToolJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Tool;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Tool
         */

        /**
         * Base class for tools.
         *
         * May be configured with a `cls` and a `handler` which is a function (or name of a function)
         * in the owning Panel.
         * @extends Common/widget/Widget
         *
         * @classType tool
         */

        var Tool =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Tool, _Widget);

          function Tool() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Tool);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Tool).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Tool, [{
            key: "template",
            value: function template() {
              return "<div class=\"b-icon\"></div>";
            }
          }, {
            key: "construct",
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Tool.prototype), "construct", this).call(this, config);

              _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].on({
                element: this.element,
                click: 'onClick',
                mousedown: 'onMousedown',
                thisObj: this
              });
            }
          }, {
            key: "onClick",
            value: function onClick(e) {
              var me = this,
                  panel = me.panel,
                  handler = typeof me.handler === 'function' ? me.handler : panel[me.handler];

              if (panel.trigger('toolclick', {
                tool: me
              }) !== false) {
                handler && me.callback(handler, panel, [e]);
              }
            }
          }, {
            key: "onMousedown",
            value: function onMousedown(e) {
              var panel = this.panel,
                  focusEl = panel.focusElement;
              e.preventDefault();

              if (focusEl && document.activeElement !== focusEl) {
                panel.focus();
              }
            }
          }, {
            key: "panel",
            get: function get() {
              return this.parent;
            }
          }]);

          return Tool;
        }(_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        Tool._$name = 'Tool';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_7__["default"].register('tool', Tool);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Toolbar.js":
      /*!********************************************!*\
        !*** ../Grid/lib/Common/widget/Toolbar.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetToolbarJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Toolbar;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Container_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./Container.js */
        "../Grid/lib/Common/widget/Container.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/Toolbar
         */

        /**
         * Widget that is themed to contain Buttons which is docked to the bottom or top of
         * a {@link Common.widget.Panel Panel}.
         *
         * ```javascript
         * // create a toolbar with two buttons
         * let container = new Toolbar({
         *   items : [
         *     { text : 'Add' },
         *     { text : 'Delete' }
         *   ]
         * });
         * ```
         *
         * @extends Common/widget/Container
         * @classType toolbar
         */

        var Toolbar =
        /*#__PURE__*/
        function (_Container) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Toolbar, _Container);

          function Toolbar() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Toolbar);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Toolbar).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Toolbar, [{
            key: "createWidget",
            value: function createWidget(widget) {
              if (widget === '->') {
                widget = {
                  cls: 'b-toolbar-fill'
                };
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Toolbar.prototype), "createWidget", this).call(this, widget);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                defaultType: 'button',
                layout: 'default'
              };
            }
          }]);

          return Toolbar;
        }(_Container_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        Toolbar._$name = 'Toolbar';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_6__["default"].register('toolbar', Toolbar);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Tooltip.js":
      /*!********************************************!*\
        !*** ../Grid/lib/Common/widget/Tooltip.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetTooltipJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Tooltip;
        });
        /* harmony import */


        var core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.anchor */
        "../Grid/node_modules/core-js/modules/es6.string.anchor.js");
        /* harmony import */


        var core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Popup_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Popup.js */
        "../Grid/lib/Common/widget/Popup.js");
        /* harmony import */


        var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../helper/util/Point.js */
        "../Grid/lib/Common/helper/util/Point.js");
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        var realignTransitions = {
          left: true,
          right: true,
          top: true,
          bottom: true,
          transform: true
        };
        /**
         * @module Common/widget/Tooltip
         */

        /**
         * Tooltip. Easiest way of assigning a tooltip to a widget is by setting {@link Common.widget.Widget#config-tooltip}, see example below.
         *
         * ```javascript
         * button.tooltip = 'Click me and you wont believe what happens next';
         * ```
         *
         * ## Showing async content
         * To create async tooltip and show {@link #config-loadingMsg}, set {@link #property-html} to `false`:
         *
         * ```javascript
         * new Tooltip({
         *     listeners : {
         *         beforeShow : ({ source : tip }) => {
         *             tip.html = false;
         *             AjaxHelper.get('someurl').then(response => tip.html = 'Done!');
         *         }
         *     }
         * });
         * ```
         *
         * @extends Common/widget/Widget
         * @classType tooltip
         * @externalexample widget/Tooltip.js
         */

        var Tooltip =
        /*#__PURE__*/
        function (_Popup) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Tooltip, _Popup);

          function Tooltip() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Tooltip);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Tooltip, [{
            key: "afterConstruct",
            //endregion
            //region Events

            /**
             * Triggered when a mouseover event is detected on a potential target element.
             * Return false to prevent the action
             * @event pointerOver
             * @param {Common.widget.Tooltip} sourceThe tooltip instance.
             * @param {Event} event The mouseover event.
             */
            //endregion
            //region Properties

            /**
             * The HTML element that triggered this Tooltip to show
             * @member {HTMLElement} activeTarget
             */
            //endregion
            //region Init & destroy
            value: function afterConstruct() {
              var me = this,
                  forSelector = me.forSelector;

              if (forSelector) {
                me.showOnHover = true;

                if (!me.forElement) {
                  me.trackMouse = true;
                  me.forElement = document.body;
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "afterConstruct", this).call(this); // There's a triggering element, and we're showing on hover, add the mouse listeners


              if (me.forElement && me.showOnHover) {
                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
                  element: me.forElement,
                  mouseover: 'internalOnPointerOver',
                  mouseout: 'onPointerOut',
                  transitionend: 'onTransitionEnd',
                  thisObj: me
                });
              }

              if (me.autoShow) {
                me.show();
              }

              if (me.allowOver) {
                _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
                  element: me.element,
                  mouseenter: 'onOwnElementMouseEnter',
                  mouseleave: 'onPointerOut',
                  thisObj: me
                });
              }
            }
          }, {
            key: "internalOnPointerOver",
            //endregion
            //region Hovering, show and hide
            value: function internalOnPointerOver(event) {
              var me = this,
                  forElement = me.forElement,
                  forSelector = me.forSelector,
                  activeTarget = me.activeTarget;
              var newTarget;

              if (me.disabled) {
                return;
              } // If the mouse moves over this tooltip, it is theoretically a mouseout of its
              // forElement, but allowOver lets us tolerate this ane remain visible.


              if (me.allowOver && me.element.contains(event.target)) {
                return;
              } // There's been a mouseover. If we have a forSelector, we have to check
              // if it's an enter of a matching child


              if (forSelector) {
                // Moving inside a forSelector matching element
                if (activeTarget && activeTarget.contains(event.target) && activeTarget.contains(event.relatedTarget)) {
                  return;
                }

                newTarget = event.target.closest(forSelector); // Mouseovers while within a target do nothing

                if (newTarget && event.relatedTarget && event.relatedTarget.closest(forSelector) === newTarget) {
                  return;
                }
              } // There's no forSelector, so check if we moved from outside the target
              else if (!forElement.contains(event.relatedTarget)) {
                  newTarget = forElement;
                } // Mouseover caused by moving from child to child inside the target
                else {
                    return;
                  } // If pointer entered the target or a forSelector child, then show.


              if (newTarget) {
                me.handleForElementOver(event, newTarget);
              } // If over a non-forSelector child, behave as in forElement out
              else if (activeTarget) {
                  me.handleForElementOut();
                }
            } // Handle a transitioned reposition when the activeTarget moved beneath the pointer.
            // When it comes to an end, if the mouseout has not hidden, then realign at the new position
            // if the activeTarget is still beneath the pointer.

          }, {
            key: "onTransitionEnd",
            value: function onTransitionEnd(event) {
              var me = this,
                  currOver = Tooltip.currentOverElement;

              if (realignTransitions[event.propertyName]) {
                // Don't realign if the mouse is over this, and is allowed to be over this
                // If user is interacting with this Toolltip, they won't expect it to move.
                if (me.allowOver && me.element.contains(currOver)) {
                  return;
                } // If we are still visible, and mouse is still over the activeTarget, realign


                if (me.isVisible && me.activeTarget.contains(currOver) && !me.trackMouse) {
                  me.realign();
                }
              }
            }
          }, {
            key: "handleForElementOver",
            value: function handleForElementOver(event, newTarget) {
              var me = this; // Vetoed, then behave as is a targetout

              if (me.trigger('pointerOver', {
                event: event,
                target: newTarget
              }) === false) {
                me.onPointerOut(event);
              } else {
                me.pointerEvent = event;
                me.abortDelayedHide(); // We are over a new target. If we are still visible, we
                // do not want to hide to avoid flickering. But if there is a
                // beforeshow listener which may mutate us, we still have to
                // consult it. If it returns a veto, then we do in fact hide.
                // Under normal circumstances we just alignTo the new target.
                // We must handle the post show tasks like starting the dismiss timer etc.

                if (me.isVisible && !me.hideOnDelegateChange) {
                  me.updateActiveTarget(newTarget);

                  if (me.trigger('beforeShow') === false) {
                    return me.hide();
                  }

                  me.alignTo({
                    target: me.anchorToTarget ? newTarget : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_10__["default"](me.pointerEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.pointerEvent.pageY - window.pageYOffset + me.mouseOffsetY),
                    overlap: !(me.anchorToTarget && me.anchor)
                  });
                  me.trigger('show');
                  me.afterShowByTarget();
                } else {
                  if (me.hideOnDelegateChange) {
                    me.hide();
                  }

                  me.updateActiveTarget(newTarget);
                  me.delayShow(newTarget);
                }
              }
            }
          }, {
            key: "delayShow",
            value: function delayShow(target) {
              var me = this; // Caught in an animation - cancel it

              if (me.currentAnimation) {
                me.cancelHideShowAnimation();
                me._hidden = true;
              }

              if (!me.isVisible && !me.hasTimeout('show')) {
                // Allow hoverDelay:0 or rapid movement from delegate to delegate to show immediately
                if (!me.hoverDelay || me.forSelector && Date.now() - me.lastHidden < me.quickShowInterval) {
                  me.showByTarget(target);
                } else {
                  // If we're not going to anchor to the hovered element, then we need to keep track
                  // of mousemoves until the show happens so we can show where the mouse currently is.
                  if (!me.listeningForMouseMove && !me.anchorToTarget) {
                    me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
                      element: document,
                      mousemove: 'onMouseMove',
                      thisObj: me
                    });
                  } // If a tap event triggered, do not wait. Show immediately.


                  me.setTimeout(function () {
                    return me.showByTarget(target);
                  }, !me.pointerEvent || me.pointerEvent.type === 'mouseover' ? me.hoverDelay : 0, 'show');
                }
              } else if (me.isVisible) {
                me.showByTarget(target);
              }
            }
          }, {
            key: "showByTarget",
            value: function showByTarget(target) {
              var me = this;

              if (me.mouseMoveRemover) {
                me.mouseMoveRemover();
                me.mouseMoveRemover = null;
              } // Show by the correct thing.
              // If we are not anchored to the target, then it's the current pointer event.
              // Otherwise it's the activeTarget.


              me.showBy({
                target: me.anchorToTarget ? target : new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_10__["default"](me.pointerEvent.pageX - window.pageXOffset + me.mouseOffsetX, me.pointerEvent.pageY - window.pageYOffset + me.mouseOffsetY),
                overlap: !(me.anchorToTarget && me.anchor)
              });
            }
          }, {
            key: "afterShowByTarget",
            value: function afterShowByTarget() {
              var me = this,
                  dismissDelay = me.dismissDelay;
              me.abortDelayedShow();

              if (dismissDelay) {
                me.setTimeout('hide', dismissDelay);
              }

              me.toFront();
            }
          }, {
            key: "updateActiveTarget",
            value: function updateActiveTarget(newTarget) {
              var me = this,
                  lastTarget = me.activeTarget;
              me.activeTarget = newTarget;

              if (!me.isConfiguring) {
                me.trigger('overtarget', {
                  newTarget: newTarget,
                  lastTarget: lastTarget
                });
              }
            }
          }, {
            key: "onPointerOut",
            value: function onPointerOut(event) {
              var me = this,
                  toElement = event.relatedTarget; // Edge case: If there is no space to fit the tooltip, and as a result of showing the tooltip - the mouse is over the tooltip
              // Make sure we don't end up in an infinite hide/show loop

              if (me.allowOver && me.element.contains(toElement)) {
                return;
              } // If we were in an allowOver situation and exited
              // into the activeTarget, do nothing; in this situation
              // the tip is treated as if it were part of the target.


              if (me.element.contains(event.target) && me.activeTarget && me.activeTarget.contains(toElement)) {
                return;
              } // We have exited the active target


              if (me.activeTarget && !me.activeTarget.contains(event.relatedTarget)) {
                me.handleForElementOut();
              }
            }
          }, {
            key: "handleForElementOut",
            value: function handleForElementOut() {
              // Separated from onTargetOut so that subclasses can handle target out in any way.
              var me = this,
                  hideDelay = me.hideDelay;
              me.abortDelayedShow(); // Even if there is a hide timer, it's a *dismiss* timer which hides the tip
              // after a hover time. We begin a new delay on target out.

              if (me.isVisible && hideDelay !== false) {
                me.abortDelayedHide();

                if (hideDelay > 0) {
                  me.setTimeout('hide', hideDelay);
                } else {
                  // Hide immediately when configured with `hideDelay: 0`. Used by async cell tooltips that always should
                  // retrigger `hoverDelay`, to not spam the backend
                  me.hide();
                }
              }
            }
          }, {
            key: "show",
            value: function show() {
              var me = this; // If we know what element to show it by, and we are anchoring to it
              // and there's no ambiguity with a selector for sub elements,
              // then show it by our forElement (Unless we're being called from showBy)

              if (me.forElement && me.anchorToTarget && !me.forSelector && !me.inShowBy) {
                me.showByTarget(me.forElement);
              } // All we can do is the basic Widget show.
              else {
                  if (me.inShowBy) {
                    me.y = -10000;
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "show", this).call(this);
                }

              me.afterShowByTarget(); // If we've shown, and are tracking the mouse and not anchored to (aligned to) the target, track the mouse

              if (!me.mouseMoveRemover && !me._hidden && me.trackMouse) {
                me.mouseMoveRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
                  element: document,
                  mousemove: 'onMouseMove',
                  thisObj: me
                });
              }
            }
          }, {
            key: "hide",
            value: function hide() {
              var me = this;

              if (me.isVisible) {
                var _get2;

                me.abortDelayedShow();
                me.abortDelayedHide();

                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = arguments[_key];
                }

                (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "hide", this)).call.apply(_get2, [this].concat(args));

                me.lastHidden = Date.now();
                me.activeTarget = null;

                if (me.mouseMoveRemover) {
                  me.mouseMoveRemover();
                  me.mouseMoveRemover = null;
                }

                me.listeningForMouseMove = false;
              }
            }
          }, {
            key: "abortDelayedShow",
            value: function abortDelayedShow() {
              var me = this;

              if (me.hasTimeout('show')) {
                me.clearTimeout('show');

                if (me.mouseMoveRemover) {
                  me.mouseMoveRemover();
                  me.mouseMoveRemover = null;
                }
              }
            }
            /**
             * Stops both timers which may hide this tooltip, the one which counts down from mouseout
             * and the one which counts down from mouseover show for dismissDelay ms
             * @private
             */

          }, {
            key: "abortDelayedHide",
            value: function abortDelayedHide() {
              this.clearTimeout('hide');
            }
          }, {
            key: "realign",
            value: function realign(el) {
              var me = this,
                  spec = me.lastAlignSpec,
                  clippedBy = me.clippedBy; // If we are hidden because our align target scrolled, or otherwise
              // moved out of its clipping boundaries, then check if it's moved back in.
              // For example EventDrag might move the element outside of the scheduler
              // SubGrid, which will cause the tip to hide, but then moving it back in
              // must reshow it.

              if (!me.isConfiguring && clippedBy && !me.isVisible && spec.targetHidden) {
                var target = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"].from(spec.target, me.positioned ? me.element.offsetParent : null, !me.positioned),
                    clippedTarget = target.intersect(clippedBy); // If there is an intersecting Rectangle with the forElement, align


                if (clippedTarget) {
                  me.show();
                  spec.targetHidden = false;
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "realign", this).call(this, el);
            }
          }, {
            key: "alignTo",
            value: function alignTo(spec) {
              var me = this;
              if (!me.isVisible) return; // getHtml implies update on align.
              // Must update HTML before calculating position

              if (me.getHtml) {
                // If mouse pointer is over this, do not attempt
                // to call the getHtml method.
                if (!(me.pointerEvent && me.element.contains(me.pointerEvent.target))) {
                  if (spec.nodeType === 1) {
                    spec = {
                      target: spec
                    };
                  }

                  var xy = spec instanceof _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_10__["default"] ? spec : spec.position || (spec.target.nodeType === 1 ? _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"].from(spec.target) : spec.target); // setHtml attempts to realign to previous alignment unless this flag is set

                  me.isAligning = true;
                  me.html = me.getHtml({
                    tip: me,
                    element: me.element,
                    forElement: me.activeTarget,
                    x: xy.x,
                    y: xy.y,
                    event: me.pointerEvent
                  });
                  me.isAligning = false;
                }
              }

              if (me.isVisible) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "alignTo", this).call(this, spec);
              }
            } //endregion
            //region Tooltip contents

          }, {
            key: "onMouseMove",
            //endregion
            //region Events

            /**
             * Mouse move event listener which updates tooltip
             * @private
             */
            value: function onMouseMove(event) {
              var me = this,
                  x = event.pageX - window.pageXOffset + me.mouseOffsetX,
                  y = event.pageY - window.pageYOffset + me.mouseOffsetY,
                  // If we are trackMouse: true
              // we must keep out of the way of the mouse by continuing
              // to track if we are on the way out due to a hide timer.
              isHiding = me.hasTimeout('hide'),
                  target = event.target; // MouseMove is listened for during the hover show timer wait phase if anchorToTarget is false
              // so that when the timer fires, it can show near the most recent pointer position.
              // It's also listened for after show when we are not anchored to the target and so tracking the mouse.

              me.pointerEvent = event; // Check that we are still valid to be visible, and if so, track the mouse.

              if (!me._hidden) {
                // Check whether the element we are over is still a valid delegate matching the forSelector,
                // or it's the tip element, and we're allowOver. If not, we have to hide.
                // nodeType check is for FF on Linux, event.target is sometimes a text node
                if (me.forSelector && !isHiding && target.nodeType === 1 && !target.matches(me.forSelector) && !(me.allowOver && me.element.contains(target))) {
                  me.handleForElementOut();
                } // If we are not hiding due to moving mouse outside our forElement, tooltip stays visible and optionally realigns based on trackMouse setting.
                else if (!isHiding || me.forElement.contains(target)) {
                    // Mousemoves restart the dismiss timer.
                    if (me.dismissDelay && !isHiding) {
                      me.setTimeout('hide', me.dismissDelay);
                    } // If we're not anchoring to the target, track the mouse


                    if (me.trackMouse) {
                      me.alignTo({
                        position: new _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_10__["default"](x, y),
                        ignorePageScroll: true
                      });
                    }
                  }
              }
            }
          }, {
            key: "onOwnElementMouseEnter",
            value: function onOwnElementMouseEnter(event) {
              this.abortDelayedHide();
            } //endregion

          }, {
            key: "focusElement",
            get: function get() {
              var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "focusElement", this);

              if (result !== this.element) {
                return result;
              }
            }
          }, {
            key: "anchorToTarget",
            get: function get() {
              return this._anchorToTarget;
            },
            set: function set(anchorToTarget) {
              this._anchorToTarget = anchorToTarget;
              if (!anchorToTarget) this.anchor = false;
            }
          }, {
            key: "trackMouse",
            set: function set(trackMouse) {
              this._trackMouse = trackMouse;
            },
            get: function get() {
              // We do not track the mouse if we are anchored to (aligned to) the target
              return this._trackMouse && !this.anchorToTarget;
            }
          }, {
            key: "textContent",
            set: function set(value) {
              this._textContent = value;
              this.element.classList[value ? 'add' : 'remove']('b-tooltip-text-content');
            },
            get: function get() {
              return this._textContent;
            }
          }, {
            key: "html",
            set: function set(html) {
              var me = this; // setting to false signals async tooltip, show loading message.
              // TODO: Load masking should be a general Widget ability.

              if (html === false) {
                html = "<div class=\"b-tooltip-loading\"><div class=\"b-icon b-icon-spinner\"></div>".concat(me.L(me.loadingMsg), "</div>");
              } else if (html != null) {
                html = String(html); // in case a number was passed in
              } // we have something to show...


              if (html) {
                // When setting the html, we must inhibit any configured html getter
                var getHtml = me.getHtml;
                me.getHtml = null;

                _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "html", html, this, true); // Must realign before restoring getHtml, to not get stuck in infinite html setting loop


                if (!me.isAligning) {
                  me.realign();
                }

                me.getHtml = getHtml;
                me.trigger('innerHtmlUpdate');
              } else {
                // do not show empty tooltips
                me.hide();
              }
            }
            /**
             * Get/set HTML to display. When specifying HTML, this widget's element will also have `b-html` added to its
             * classList, to allow targeted styling. To create async tooltip and show {@link #config-loadingMsg}, set it to `false`.
             * For example:
             *
             * ```javascript
             * new Tooltip({
             *     listeners : {
             *         beforeShow : ({ source : tip }) => {
             *             tip.html = false;
             *             AjaxHelper.get('someurl').then(response => tip.html = 'Done!');
             *         }
             *     }
             * });
             * ```
             *
             * @property {String}
             * @category DOM
             */
            ,
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Tooltip.prototype), "html", this);
            }
          }], [{
            key: "defaultConfig",
            //region Default config
            get: function get() {
              return {
                /**
                 * Horizontal offset from mouse when {@link #config-anchorToTarget} is `false`
                 * @config {Number}
                 * @default
                 */
                mouseOffsetX: 15,

                /**
                 * Vertical offset from mouse when {@link #config-anchorToTarget} is `false`
                 * @config {Number}
                 * @default
                 */
                mouseOffsetY: 15,
                floating: true,

                /**
                 * Set to a function that returns a string to update tooltips contents. Called on each mouse move event.
                 * @config {Function}
                 */
                getHtml: null,

                /**
                 * DOM element to attach tooltip to. By default, the mouse entering this element will kick off a timer
                 * (see {@link #config-hoverDelay}) to show itself.
                 *
                 * If the {@link #config-forSelector} is specified, then mouse entering matching elements within the `forElement`
                 * will trigger the show timer to start.
                 *
                 * Note that when moving from matching element to matching element within the `forElement`, the tooltip
                 * will remain visible for {@link #config-hideDelay} milliseconds after exiting one element, so that rapidly
                 * entering another matching element will not cause hide+show flicker. To prevent this behaviour configure
                 * with `hideDelay: 0`.
                 * @config {HTMLElement}
                 */
                forElement: null,
                trackMouse: null,

                /**
                 * Shows tooltip for all elements that match this selector within the {@link #config-forElement}.
                 * @config {String}
                 */
                forSelector: null,

                /**
                 * By default, when moving rapidly from target to target, if, when mouseing over
                 * a new target, the tip is still visible, the tooltip does not hide, it remains
                 * visible, but updates its content however it is configured to do so.
                 *
                 * Configure `hideOnDelegateChange : true` to have the tip hide, and then trigger
                 * a new show delay upon entry of a new target while still visible.
                 * @config {Boolean}
                 * @default false
                 */
                hideOnDelegateChange: null,

                /**
                 * Set to true to anchor tooltip to the triggering target. If set to `false`, the tooltip
                 * will align to the mouse position. When set to `false`, it will also set `anchor: false`
                 * to hide anchor arrow.
                 * @config {Boolean}
                 * @default true
                 */
                anchorToTarget: true,

                /**
                 * Show on hover
                 * @config {Boolean}
                 * @default
                 */
                showOnHover: false,

                /**
                 * The amount of time to hover before showing
                 * @config {Number}
                 * @default
                 */
                hoverDelay: 500,

                /**
                 * Show immediately when created
                 * @config {Boolean}
                 * @default
                 */
                autoShow: false,

                /**
                 * The time (in milliseconds) that the Tooltip should stay visible for when it shows over its
                 * target. If the tooltip is anchored to its target, then moving the mouse during this time
                 * resets the timer so that the tooltip will remain visible.
                 *
                 * Defaults to `0` which means the Tooltip will persist until the mouse leaves the target.
                 * @config {Number}
                 * @default
                 */
                dismissDelay: 0,

                /**
                 * The time (in milliseconds) for which the Tooltip remains visible when the mouse leaves the target.
                 *
                 * May be configured as `false` to persist visible after the mouse exits the target element. Configure it
                 * as 0 to always retrigger `hoverDelay` even when moving mouse inside `fromElement`
                 * @config {Number}
                 * @default
                 */
                hideDelay: 500,

                /**
                 * Loading message for async tooltips.
                 * @config {String}
                 * @default
                 */
                loadingMsg: 'Loading...',

                /**
                 * Keep the tooltip open if user hovers it
                 * @config {Boolean}
                 * @default
                 */
                allowOver: false,

                /**
                 * Specify `true` for a tooltip used to show unformatted text. It will apply the `b-tooltip-text-content`
                 * class which specifies a default max width that makes long text more readable.
                 */
                textContent: false,
                anchor: true,
                align: 'b-t',
                axisLock: true,
                showAnimation: null,
                hideAnimation: null
              };
            }
          }]);

          return Tooltip;
        }(_Popup_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].on({
          element: document,
          mouseenter: function mouseenter(event) {
            return Tooltip.currentOverElement = event.target;
          },
          capture: true
        });
        /**
         * Updated dynamically with the current element that the mouse is over. For use when showing a Tooltip
         * from code which is not triggered by a pointer event so that a tooltip can be positioned.
         * @member {HTMLElement} currentOverElement
         * @readonly
         * @static
         */


        Tooltip._$name = 'Tooltip';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_11__["default"].register('tooltip', Tooltip);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/Widget.js":
      /*!*******************************************!*\
        !*** ../Grid/lib/Common/widget/Widget.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetWidgetJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Widget;
        });
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.get-own-property-descriptor */
        "../Grid/node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js");
        /* harmony import */


        var core_js_modules_es6_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_get_own_property_descriptor__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.match */
        "../Grid/node_modules/core-js/modules/es6.regexp.match.js");
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.string.anchor */
        "../Grid/node_modules/core-js/modules/es6.string.anchor.js");
        /* harmony import */


        var core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_anchor__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20__);
        /* harmony import */


        var _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ../helper/ResizeMonitor.js */
        "../Grid/lib/Common/helper/ResizeMonitor.js");
        /* harmony import */


        var _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ../helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ../helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
        /*! ../helper/util/Point.js */
        "../Grid/lib/Common/helper/util/Point.js");
        /* harmony import */


        var _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
        /*! ../helper/util/Scroller.js */
        "../Grid/lib/Common/helper/util/Scroller.js");
        /* harmony import */


        var _localization_En_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
        /*! ../localization/En.js */
        "../Grid/lib/Common/localization/En.js");
        /* harmony import */


        var _localization_Localizable_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
        /*! ../localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
        /*! ../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
        /*! ../mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
        /*! ../GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");

        var productName = 'scheduler'; // TODO: Needs more docs

        /**
         * @module Common/widget/Widget
         */

        var isTransparent = /transparent|rgba\(0,\s*0,\s*0,\s*0\)/,
            textInputTypes = {
          INPUT: 1,
          TEXTAREA: 1
        },
            widgetTriggerPaint = function widgetTriggerPaint(w) {
          return w.isVisible && w.trigger('paint');
        },
            negationPseudo = /^:not\((.+)\)$/,
            isRealigningFloater = function isRealigningFloater(w) {
          return w.floating && w.scrollAction === 'realign';
        },
            dragGhost = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElement({
          // Safari won't allow dragging an empty node
          html: '\xa0',
          style: 'position:absolute;top:-10000em;left:-10000em'
        });
        /**
         * Base class for other widgets. The Widget base class simply encapsulates an element, and may optionally contain some
         * specified {@link #config-html}.
         *
         * Subclasses should at override the {@link #function-template} member function to return an HTML string to create their own encapsulating element
         * and internal structure.
         *
         * @mixes Common/mixin/Events
         * @mixes Common/localization/Localizable
         * @extends Common/Base
         * @classType widget
         */


        var Widget =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_20___default()(Widget, _Delayable);

          function Widget() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_15___default()(this, Widget);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_17___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Widget).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_16___default()(Widget, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var me = this; // Flag so we know when our dimensions have been constrained during alignment

              me.alignConstrained = 0;
              me.afterHideShowAnimate = me.afterHideShowAnimate.bind(me);
              me.callRealign = me.realign.bind(me);
              me.doHideOrRealign = me.doHideOrRealign.bind(me);
              me.initialRender = true;
              me._isUserAction = false; // Base class applies configs.

              for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Widget.prototype), "construct", this).call(this, config, args);

              me.finalizeInit();
            }
          }, {
            key: "isType",
            value: function isType(type, deep) {
              return _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isType(this, type, deep);
            }
          }, {
            key: "startConfigure",
            value: function startConfigure(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Widget.prototype), "startConfigure", this).call(this, config); // Force construction of the widget's element before all other configs are evaluated.


              this._thisIsAUsedExpression(this.element);
            }
          }, {
            key: "finalizeInit",

            /**
             * Called by the Base constructor after all configs have been applied.
             * @internal
             * @category Lifecycle
             */
            value: function finalizeInit() {
              if (this.insertBefore || this.appendTo || this.insertFirst) {
                this.render();
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this,
                  element = me._element;
              me.scrollable && me.scrollable.destroy();
              me._tooltip && me._tooltip.destroy();
              me.unmask();

              if (element) {
                // Remove listeners which are only added during the visible phase.
                // In its own method because it's called on hide and destroy.
                me.removeTransientListeners();
                me.revertFocus();

                _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].removeResizeListener(element.parentElement, me.onParentElementResize);

                _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].removeResizeListener(element, me.onElementResize);

                element.remove();
                me.dragEventDetacher && me.dragEventDetacher();
                me.dragOverEventDetacher && me.dragOverEventDetacher();
                dragGhost.remove();
              }

              _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].unregister(me);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_19___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_18___default()(Widget.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Render

          }, {
            key: "render",
            value: function render(appendToElement) {
              var triggerPaint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var me = this,
                  element = me.element,
                  contentRange = me.contentRange,
                  contentElement = me.contentElement;

              _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].removeResizeListener(element.parentElement, me.onParentElementResize);

              _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].removeResizeListener(element, me.onElementResize);

              me.emptyCache();

              if (me.syncElement && me.currentElement) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].sync(element, me.currentElement);
              } else {
                // Use passed element to insert this widget directly
                if (appendToElement) {
                  me.appendTo = typeof appendToElement === 'string' ? document.getElementById(appendToElement) : appendToElement;
                  me.appendTo.appendChild(element);
                } // If nothing was passed directly, try to use configs preferring `insertBefore` first
                else if (me.insertBefore) {
                    me.insertBefore = typeof me.insertBefore === 'string' ? document.getElementById(me.insertBefore) : me.insertBefore;
                    me.insertBefore.parentElement.insertBefore(element, me.insertBefore);
                  } else if (me.insertFirst) {
                    me.insertFirst = typeof me.insertFirst === 'string' ? document.getElementById(me.insertFirst) : me.insertFirst; // Try to insert as a first child

                    if (me.insertFirst.firstChild) {
                      me.insertFirst.insertBefore(element, me.insertFirst.firstChild);
                    } // insertBefore will throw exceptions if firstChild element not exists. Add as only child then.
                    else {
                        me.insertFirst.appendChild(element);
                      }
                  } else if (me.appendTo) {
                    me.appendTo = typeof me.appendTo === 'string' ? document.getElementById(me.appendTo) : me.appendTo;
                    me.appendTo.appendChild(element);
                  }

                me.currentElement = element;
              } // If it's a rerender from being removed, restore from cached pointers


              if ('contentRangeStart' in me) {
                contentRange.setStart(contentElement, me.contentRangeStart);
                contentRange.setEnd(contentElement, me.contentRangeEnd);
              } else {
                contentRange.setStart(me.contentElement, 0);
                contentRange.setEnd(me.contentElement, me.contentElement.childNodes.length);
              } // Not for public use, only used in docs


              if (me.scaleToFitWidth) {
                me.onParentElementResize = me.onParentElementResize.bind(me);

                _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].addResizeListener(element.parentElement, me.onParentElementResize);

                if (me.isVisible) {
                  me.updateScale();
                }
              } // Mutually exclusive with scaleToFitWidth
              else if (me.monitorResize) {
                  me.onElementResize = me.onElementResize.bind(me);

                  _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].addResizeListener(element, me.onElementResize); // On render, we should announce our size immediately.
                  // When the real event comes along, onElementResize will reject it because the size will be the same.


                  _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].onElementResize([{
                    target: element
                  }]);
                }

              if (triggerPaint) {
                me.triggerPaint();
              }
            }
            /**
             * A function which, when passed an instance of this Widget, produces a valid HTML string which is compiled
             * to create the encapsulating element for this Widget, and its own internal DOM structure.
             *
             * Note that this just creates the DOM structure that *this* Widget owns. If it contains child widgets
             * (Such as for example a grid), this is not included. The template creates own structure.
             *
             * Certain elements within the generated element can be identified as special elements with a `reference="name"`
             * property. These will be extracted from the element upon creation and injected as the named property into
             * the Widget. For example, a {@link Common.widget.TextField} will have an `input` property which is its
             * `<input>` element.
             * @param {Common.widget.Widget} me The widget for which to produce the initial HTML structure.
             * @internal
             */

          }, {
            key: "template",
            value: function template(me) {
              return "<div class=\"".concat(me.html ? 'b-html' : '', "\" ").concat(me.name ? "data-name=\"".concat(me.name, "\"") : '', ">").concat(me.html || '', "</div>");
            } //endregion
            //region floating

            /**
             * If this Widget is {@link #config-floating} or {@link #config-positioned}, and visible,
             * aligns the widget according to the passed specification.
             * For details, see the {@link #function-showBy} method.
             * @param {Object} spec Alignment options. May be an object as processed by the {@link #function-showBy} method,
             * or an `HTMLElement` to align to using this Widget's {@link #config-align} configuration.
             * @category Float & align
             */

          }, {
            key: "alignTo",
            value: function alignTo(spec) {
              // You can "alignTo" an element or a Widget or a Point, and allow our align config.
              // property to specify how.
              if (spec.nodeType === 1 || spec instanceof Widget || spec instanceof _helper_util_Point_js__WEBPACK_IMPORTED_MODULE_30__["default"]) {
                spec = {
                  target: spec
                };
              } // Release size constraints so we can align from scratch each time.


              this.releaseSizeConstraints();

              var me = this,
                  scrollable = me.scrollable,
                  element = me.element,
                  passedTarget = spec.target,
                  target = passedTarget && (passedTarget instanceof _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"] ? passedTarget : passedTarget.element || passedTarget),
                  myPosition = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].from(element, me.positioned ? element.offsetParent : null, true),
                  aligningToElement = target && target.nodeType === 1;

              spec = Object.assign({
                // Constraining is a viewport coordinate based thing. not relevant to positioned
                // Widgets which are within their owning Widget and thereby constrained anyway.
                constrainTo: me.positioned ? null : me.constrainTo,
                axisLock: me.axisLock,
                anchor: me.anchor
              }, _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(me.align) === 'object' ? me.align : {
                align: me.align
              }, spec); // As part of fallback process when fitting within constraints, this may shrink to minima specified
              // either on the align spec or the widget itself.

              myPosition.minWidth = spec.minWidth || me.minWidth;
              myPosition.minHeight = spec.minHeight || me.minHeight; // This is used by the realign call which may be called either when a global scroll is detected
              // or the constraining element is resized.

              me.lastAlignSpec = spec;

              if (aligningToElement && target.offsetParent) {
                // Translate the element into a browser viewport based Rectangle. Rectangle
                // Doesn't have the knowledge that we do to make this decision. Floating
                // alignment all takes place within browser viewport space, not document space.
                // Don't destroy the spec which was cached above with the element in it.
                spec = Object.setPrototypeOf({}, spec);
                spec.target = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].from(target, me.positioned ? element.offsetParent : null, !me.positioned); // Force the target to have an area so that intersect works.

                spec.target.height = Math.max(spec.target.height, 1);
                spec.target.width = Math.max(spec.target.width, 1); // Handle the target being clipped by the bounds of various elements.
                // For example in a grid, the SubGrid element will clip the left and right
                // but the main grid bodyContainer will clip the top and bottom.

                var clippedBy = me.clippedBy;

                if (clippedBy) {
                  var clippedTarget = spec.target.intersect(clippedBy); // If there is an intersecting Rectangle with the forElement, align

                  if (clippedTarget) {
                    spec.target = clippedTarget;
                  } // This is the case where the target is scrolled or positioned out of view.
                  else {
                      var _result = me.hide(); // The hide method clears this flag.
                      // Only this hide invocation must complete with the
                      // targetHidden flag as true


                      me.lastAlignSpec.targetHidden = true;
                      return _result;
                    }
                } // This is the element which determines our position.
                // This is used in doHideOrRealign to see if a scroll event
                // will have affected our position.


                me.anchoredTo = target;
              } else {
                me.anchoredTo = null;
              }

              if (spec.anchor) {
                spec.anchorSize = me.anchorSize;
                element.appendChild(me.anchorElement);
              } // Flag to prevent infinite loop when setting html from a beforeAlign listener


              me.isAligning = true; // Allow outside world to modify the suggested position

              me.trigger('beforeAlign', spec);
              me.isAligning = false; // Calculate the best position WRT target rectangle, our rectangle, a constrainTo rectangle
              // and the rectangle of an anchor pointer.

              var _spec = spec,
                  constrainTo = _spec.constrainTo,
                  constrainToWindow = constrainTo === window || constrainTo === document,
                  result = myPosition.alignTo(spec); // May change if constraint changes our shape, and we have to go round again

              var align = result.align,
                  anchor = result.anchor,
                  x = result.x,
                  y = result.y,
                  width = result.width,
                  height = result.height,
                  bottom = result.bottom,
                  right = result.right; // Which zone, T=0, R=1, B=2, L=3 the result is in

              me.lastAlignSpec.zone = result.zone; // If the alignment specified that we must constrain a dimension in order to
              // fit within our constrainTo, then obey that. If we own a Scroller, then
              // inform it that we do now need to scroll that dimension.
              // These conditions are released upon each alignment call because conditions may change.

              if (height !== myPosition.height) {
                if (!('configuredHeight' in me)) {
                  me.configuredHeight = element.style.height;
                }

                me.height = height;
                me.alignConstrained = me.alignConstrained | 1;

                if (scrollable) {
                  scrollable.overflowY = true;
                }
              }

              if (width !== myPosition.width) {
                if (!('configuredWidth' in me)) {
                  me.configuredWidth = element.style.width;
                }

                me.width = width;
                me.alignConstrained = me.alignConstrained | 2;

                if (scrollable) {
                  scrollable.overflowX = true;
                }
              } // If either dimension has been constrained, we may have changed shape
              // due to text wrapping/overflowing, so we have to realign at the
              // successful align setting.


              if (align && me.alignConstrained) {
                spec.align = align;

                var newResult = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].from(element, me.positioned ? element.offsetParent : null, true).alignTo(spec);

                anchor = newResult.anchor;
                x = newResult.x;
                y = newResult.y;
                width = newResult.width;
                height = newResult.height;
                bottom = newResult.bottom;
                right = newResult.right;
              }

              me.setXY(x, y); // If we asked it to also calculate our anchor position, position our anchor

              if (anchor) {
                var _document;

                var _anchor = anchor,
                    edge = _anchor.edge,
                    anchorElement = me.anchorElement,
                    colorMatchPoint = [],
                    stylePointerEvents = element.style.pointerEvents; // Enable pointerEvents to make discoverable by elementFromPoint()

                element.style.pointerEvents = 'all'; // Make the anchor color match the color of the closest adjacent element

                if (edge === 'top' || edge === 'bottom') {
                  colorMatchPoint[0] = x + anchor.x;
                  colorMatchPoint[1] = edge === 'top' ? y + 1 : bottom - 1;
                } else {
                  colorMatchPoint[0] = edge === 'left' ? x + 1 : right - 1;
                  colorMatchPoint[1] = y + anchor.y;
                }

                var colourSource = (_document = document).elementFromPoint.apply(_document, colorMatchPoint);

                element.style.pointerEvents = stylePointerEvents || null; // If  it's off the edge of the screen, we won't be able to read it.
                // But that's fine, the anchor will be off the edge in that case.

                if (colourSource) {
                  var fillColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(colourSource, 'background-color');

                  if (fillColour.match(isTransparent)) {
                    me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
                  } else {
                    me.anchorPathElement.setAttribute('fill', fillColour);
                  }
                }

                anchorElement.classList.remove('b-hide-display');
                anchorElement.style.transform = '';
                anchorElement.className = "b-anchor b-anchor-".concat(edge);

                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setTranslateXY(anchorElement, anchor.x, anchor.y);
              } else if (me._anchorElement) {
                me.anchorElement.classList.add('b-hide-display');
              } // If we are to hide on scroll, we still need to know if the element we are
              // aligned to moves. If we have not been *explicitly* aligned to an element,
              // Use the element at our display position. For example, when a context menu
              // is shown on a grid header, then is the grid header is moved by a scroll
              // event, then we must hide.


              if (me.scrollAction === 'hide' && !aligningToElement) {
                // Our element is over the X, Y point now,
                // elementFromPoint must "see through" it.
                element.style.pointerEvents = 'none';
                me.anchoredTo = document.elementFromPoint(x, y);
                element.style.pointerEvents = '';
              } // If we're aligning to an element, then listen for scrolls so that we can remain aligned.
              // Scrolls can be instigated with no mousedown, so transient floating Widgets can be put
              // out of alignment by scrolls.


              if ((me.scrollAction === 'realign' && aligningToElement || me.scrollAction === 'hide') && !me.documentScrollListener) {
                // Push binding to the scroll position out until the next animation frame.
                // This is in case the calling code is going to cause a scroll.
                // for example contextmenu is a focusing gesture which may cause a scroll
                // to fire as the target element moves into view.
                me.setTimeout(function () {
                  document.addEventListener('scroll', me.doHideOrRealign, true);
                  me.documentScrollListener = true;
                }, 0);
              }

              if (constrainTo && (constrainTo.nodeType === 1 || constrainToWindow) && !me.constrainListeners) {
                _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].addResizeListener(constrainTo, me.callRealign); // Do not listen for constrainTo mutations if it's the viewport.
                // Mutating it won't change its size.


                if (!constrainToWindow) {
                  me.constrainMutationMonitor || (me.constrainMutationMonitor = new MutationObserver(me.callRealign)).observe(constrainTo, {
                    // eslint-disable-line no-undef
                    attributes: true,
                    childList: true
                  });
                }

                me.constrainListeners = true;
              }
            }
          }, {
            key: "realign",
            value: function realign(el) {
              var me = this;

              if (me.isVisible && (me.floating || me.positioned) && me.lastAlignSpec) {
                var target = me.lastAlignSpec.target; // If there was a DOM mutation which caused our target to become not layed out, or the target
                // is outside of the passed element's rectangle (passed from scroll handler), we must hide

                if (target && target.nodeType === 1) {
                  var targetRect = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].from(target); // We can align to an element which has a zero dimension, but the
                  // intersection check requires that both dimensions are non-zero.


                  targetRect.minHeight = targetRect.minWidth = 1;

                  if (target !== document.body && !target.offsetParent || el && el.nodeType === 1 && el.contains(target) && !_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].from(el).intersect(targetRect)) {
                    return me.hide();
                  }
                }

                me.alignTo(me.lastAlignSpec);
              }
            }
          }, {
            key: "releaseSizeConstraints",
            value: function releaseSizeConstraints() {
              var me = this,
                  scroller = me.scrollable; // Release constraints so we can align from scratch each time.

              if (me.alignConstrained & 1) {
                me.height = me.configuredHeight;

                if (scroller) {
                  scroller.overflowY = scroller.config.overflowY;
                }
              }

              if (me.alignConstrained & 2) {
                me.width = me.configuredWidth;

                if (scroller) {
                  scroller.overflowX = scroller.config.overflowX;
                }
              }

              me.alignConstrained = 0;
            }
            /**
             * Only valid for {@link #config-floating} Widgets. Moves to the front of the visual stacking order.
             * @category Float & align
             */

          }, {
            key: "toFront",
            value: function toFront() {
              if (this.element && this.element.nextSibling) {
                this.element.parentNode.appendChild(this.element);
              }
            } //endregion
            //region Getters/setters

          }, {
            key: "onThemeChange",
            value: function onThemeChange() {
              // If we have a *visible* anchor element, then a theme change may
              // invalidate it's size or this.defaultAnchorBackgroundColor, so a
              // run through realign (and get anchorSize) will fix that.
              if (this.anchorElement && this.anchorElement.offsetParent) {
                this._anchorSize = null;
                this.realign();
              }
            }
            /**
             * Returns an `[x, y]` array containing the width and height of the anchor arrow used when
             * aligning this Widget to another Widget or element.
             *
             * The height is the height of the arrow when pointing upwards, the width is the width
             * of the baseline.
             * @property {Number[]}
             * @category Float & align
             */

          }, {
            key: "onWidgetDragStart",
            value: function onWidgetDragStart(e) {
              var me = this,
                  actualTarget = document.elementFromPoint(e.clientX, e.clientY),
                  handleSelector = me.draggable.handleSelector;

              if (handleSelector) {
                var blacklist = negationPseudo.exec(handleSelector)[1]; // Extract the content of :not()
                // If the selector was :not(), then if we are a descendant of a matching element, it's a no-drag

                if (blacklist) {
                  if (actualTarget.closest("#".concat(me.element.id, " ").concat(blacklist))) {
                    e.preventDefault();
                    return;
                  }
                } // If we are not the descendant of a matching element, it's a no-drag
                else if (!actualTarget.closest("#".concat(me.element.id, " ").concat(handleSelector))) {
                    e.preventDefault();
                    return;
                  }
              } // Opt out of auto-alignment on scroll or DOM mutation.


              me.removeTransientListeners();
              var dragStartX = e.clientX,
                  dragStartY = e.clientY,
                  scrollingPageElement = document.scrollingElement || document.body,
                  widgetX = me.getXY()[0],
                  widgetY = me.getXY()[1];
              document.body.appendChild(dragGhost);

              if (e.dataTransfer.setDragImage) {
                // Firefox requires this to be called before setDragImage
                e.dataTransfer.setData('application/node type', ''); // Override the default HTML5 drag ghost and just drag an empty node

                e.dataTransfer.setDragImage(dragGhost, 0, 0);
              } // Prevent special cursor from being shown


              e.dataTransfer.effectAllowed = 'none';
              me.dragOverEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].addListener({
                element: document.body,
                dragover: function dragover(event) {
                  return me.setXY(widgetX + event.clientX - dragStartX - scrollingPageElement.scrollLeft, widgetY + event.clientY - dragStartY - scrollingPageElement.scrollTop);
                }
              }); // Opt out of anchoring

              me.anchor = null;
            }
          }, {
            key: "onWidgetDragEnd",
            value: function onWidgetDragEnd(e) {
              dragGhost.remove();
              this.dragOverEventDetacher();
            }
          }, {
            key: "getXY",
            value: function getXY() {
              return [_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getPageX(this.element), _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getPageY(this.element)];
            }
            /**
             * Moves this Widget to the x,y position. Both arguments can be omitted to just set one value.
             *
             * *For {@link #config-floating} Widgets, this is a position in the browser viewport.*
             * *For {@link #config-positioned} Widgets, this is a position in the element it was rendered into.*
             *
             * @param {Number} [x]
             * @param {Number} [y]
             * @category Float & align
             */

          }, {
            key: "setXY",
            value: function setXY(x, y) {
              var me = this;

              if (me.floating || me.positioned) {
                if (x != null) {
                  me._x = x;
                  me.centered = false;
                }

                if (y != null) {
                  me._y = y;
                  me.centered = false;
                }

                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setTranslateXY(me.element, me._x || 0, me._y || 0);
              }
            }
            /**
             * Moves this Widget to the desired x position. *Only valid for {@link #config-floating} Widgets.
             * @param {Number} x
             * @category Float & align
             */

          }, {
            key: "fixIEMaxHeightBug",
            value: function fixIEMaxHeightBug() {
              var element = this.element,
                  contentElement = this.contentElement; // If this widget is flexed vertically, the maxHeight of the encapsulating element must be
              // propapagated onto the contentElement.

              if (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(element, 'flex-direction') === 'column') {
                // Release previous height constraint
                contentElement.style.maxHeight = '';

                var availableHeight = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].client(element).height;

                var siblings = element.childNodes,
                    len = siblings.length; // In case there are height-consuming siblings of the contentElement.
                // For example a header/footer. The heights of these must be subtracted.

                for (var i = 0; i < len; i++) {
                  var sibling = siblings[i];

                  if (sibling !== contentElement && !sibling.classList.contains('b-resize-monitors')) {
                    availableHeight -= sibling.offsetHeight;
                  }
                } // Apply the adjusted height constraint to the contentElement


                this.contentElement.style.maxHeight = "".concat(availableHeight, "px");
              }
            }
            /**
             * Get/set element's minHeight. Getter returns min-height from elements style, which is always a string. Setter
             * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
             * _reading_ the value will return the numeric value in pixels.
             * @property {String|Number}
             * @category Layout
             */

          }, {
            key: "disable",

            /**
             * Disable the widget
             */
            value: function disable() {
              this.disabled = true;
            }
            /**
             * Enable the widget
             */

          }, {
            key: "enable",
            value: function enable() {
              this.disabled = false;
            }
          }, {
            key: "focus",

            /**
             * Focuses this widget if it has a focusable element.
             */
            value: function focus() {
              if (this.isFocusable) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].focusWithoutScrolling(this.focusElement);
              }
            }
            /**
             * Get this widget's primary focus holding element if this widget is itself focusable, or contains focusable widgets.
             * @property {HTMLElement}
             * @readonly
             * @category DOM
             */

          }, {
            key: "show",

            /**
             * Show widget
             * @category Visibility
             * @returns {Promise} A promise which is resolved when the widget is shown
             */
            value: function show() {
              var _this = this;

              return new Promise(function (resolve) {
                var me = _this,
                    showAnimation = me.showAnimation,
                    element = me.element,
                    floatRoot = Widget.floatRoot,
                    style = element.style;
                var styleProp, animProps;
                /**
                 * Triggered before a widget is shown. Return `false` to prevent the action.
                 * @event beforeShow
                 * @param {Common.widget.Widget} source The widget being shown.
                 */

                if (!me.isVisible && me.trigger('beforeShow') !== false) {
                  // Cancel any current hide/show animation
                  me.cancelHideShowAnimation();

                  if (showAnimation) {
                    // setting transitions initial value before showing, to ensure transition will animate
                    styleProp = Object.keys(showAnimation)[0];
                    animProps = showAnimation[styleProp];
                    me.currentAnimation = {
                      styleProp: styleProp
                    };
                    element.addEventListener('transitionend', me.afterHideShowAnimate); // setting transitions initial value before showing, to ensure transition will animate

                    style[styleProp] = animProps.from;
                  }

                  if (me.floating) {
                    if (!floatRoot.contains(element)) {
                      me.render(floatRoot);
                    }

                    if (!document.body.contains(floatRoot)) {
                      document.body.appendChild(floatRoot);
                    }
                  }

                  me._hidden = false;
                  element.classList.remove('b-hidden');

                  if (showAnimation) {
                    style.transition = "".concat(styleProp, " ").concat(animProps.duration, " ease ").concat(animProps.delay);
                    style[styleProp] = animProps.to;
                  }

                  me.afterShow(resolve); // If we're not being called from showBy, do default aligning

                  if (!me.inShowBy && me.floating && me.forElement) {
                    me.alignTo(me.forElement);
                  }
                }
              });
            }
            /**
             * Show aligned to another target element or {@link Common.widget.Widget} or {@link Common.helper.util.Rectangle}
             * @param {Object/HTMLElement} spec Alignment specification, or the element to align to using the configured
             * {@link #config-align}.
             * @param {HTMLElement|Common.widget.Widget|Common.helper.util.Rectangle} spec.target The Widget or Element or Rectangle to align to.
             * @param {Boolean} [spec.anchor] True to show a pointer arrow connecting to the target. Defaults to false.
             * @param {Boolean} [spec.overlap] True to allow this to overlap the target.
             * @param {String} spec.align The alignment specification string, `[trbl]n-[trbl]n`. Defaults to this instance's
             * {@link #config-align} setting.
             * @param {HTMLElement|Common.widget.Widget|Common.helper.util.Rectangle} [spec.constrainTo] The Widget or Element or Rectangle to constrain to.
             * If the requested alignment cannot be constrained (it will first shrink the resulting Rectangle according
             * to the `minWidth` and `minHeight` properties of this spec, or the Widget), then it will try aligning at other edges
             * (honouring the `axisLock` option), and pick the fallback alignment which results in the shortest translation.
             * @param {Number} [spec.minHeight] The minimum height this widget may be compressed to when constraining within the `constrainTo` option.
             * @param {Number} [spec.minWidth] The minimum width this widget may be compressed to when constraining within the `constrainTo` option.
             * @param {Boolean} [spec.axisLock] Specify as `true` to fall back to aligning against the opposite
             * edge if the requested alignment cannot be constrained into the `constrainTo` option. Specify as
             * `'flexible'` to allow continuation to try the other edges if a solution cannot be found on the origially requested axis.
             * @param {Boolean} [spec.matchSize] *Only honoured when `axisLock` is enabled and alignment succeeds on the requested axis.
             * Specify as `true` to have this widget's size along the aligned edge match the size of the target's edge.
             * For example, a combobox's dropdown should match the width of the combobox.
             * @param {Number|Number[]} [spec.offset] The offset to create an extra margin round the target
             * to offset the aligned widget further from the target. May be configured as -ve to move the aligned widget
             * towards the target - for example producing the effect of the anchor pointer piercing the target.
             * @category Float & align
             */

          }, {
            key: "showBy",
            value: function showBy(spec) {
              var me = this; // Prevent show from rerouting here.

              me.inShowBy = true;
              me.show();
              me.inShowBy = false;

              if (me.isVisible) {
                me.alignTo(spec);
              }
            }
            /**
             * Show this widget anchored to a coordinate
             * @param {Number|Number[]} x The x position (or an array with [x,y] values) to show by
             * @param {Number} [y] The y position to show by
             * @param {Object} [options] See {@link #function-showBy} for reference
             * @category Float & align
             */

          }, {
            key: "showByPoint",
            value: function showByPoint(x, y, options) {
              var xy = arguments.length === 1 ? x : [x, y];
              this.showBy(Object.assign({
                target: new _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"](xy[0], xy[1], 1, 1),
                align: 't-b'
              }, options));
            }
          }, {
            key: "afterShow",
            value: function afterShow(resolveFn) {
              // This method is injected when maxHeight is set on IE11.
              // Flexbox does not handle overflow correctly when a vertically
              // flexed item is constrained by the maxHeight of its containing el.
              // So we have to propagate the maxHeight from the encapsulating element
              // onto the contentElement.
              if (this.boundMaxHeightBugHandler) {
                this.boundMaxHeightBugHandler();
              }

              this.trigger('show');
              this.triggerPaint();
              resolveFn();
            }
          }, {
            key: "triggerPaint",
            value: function triggerPaint() {
              var me = this;

              if (me.isVisible) {
                /**
                 * Triggered when a widget which had been in a non-visible state for any reason
                 * achieves visibility.
                 *
                 * A non-visible state *might* mean the widget is hidden and has just been shown.
                 *
                 * But this event will also fire on widgets when a non-visible (unrendered, or hidden)
                 * ancestor achieves visibility, for example a {@link Common.widget.Popup Popup} being shown.
                 * @event paint
                 * @param {Common.widget.Widget} source The widget being painted.
                 */
                me.trigger('paint');

                if (me.eachWidget) {
                  me.eachWidget(widgetTriggerPaint, true);
                }
              }
            }
          }, {
            key: "cancelHideShowAnimation",
            value: function cancelHideShowAnimation() {
              var me = this,
                  element = me.element,
                  style = element.style;

              if (me.currentAnimation) {
                element.classList.remove('b-hiding');
                element.removeEventListener('transitionend', me.afterHideShowAnimate);
                style.transition = style[me.currentAnimation.styleProp] = '';
                me.currentAnimation = null;
              }
            }
          }, {
            key: "afterHideShowAnimate",
            value: function afterHideShowAnimate(event) {
              // If menu is destroyed too soon in Edge, this method will be invoked for destroyed element
              if (this.isDestroyed) {
                return;
              }

              var me = this,
                  element = me.element,
                  style = element.style,
                  _me$currentAnimation = me.currentAnimation,
                  styleProp = _me$currentAnimation.styleProp,
                  resolve = _me$currentAnimation.resolve;

              if (event.target === element && event.propertyName === styleProp) {
                element.classList.remove('b-hiding');
                me.currentAnimation = null;
                element.removeEventListener('transitionend', me.afterHideShowAnimate);
                style.transition = style[styleProp] = ''; // Element must be fully hidden after the animation effect finishes

                if (me._hidden) {
                  me.afterHideAnimation(); // We want to fire 'hide' event immediately so since it's already fired we do not want to have 'hide' event fired twice

                  me.afterHide(resolve, false);
                }
              }
            }
            /**
             * Hide widget
             * @param {Boolean} animate Pass `true` (default) to animate the hide action
             * @category Visibility
             * @returns {Promise} A promise which is resolved when the widget has been hidden
             */

          }, {
            key: "hide",
            value: function hide() {
              var _this2 = this;

              var animate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              return new Promise(function (resolve) {
                var me = _this2,
                    element = me.element,
                    style = element.style,
                    hideAnimation = animate && me.hideAnimation; // replaced check for isVisible with _hidden, need to hide a component not yet in view in EventEditor

                if (!me._hidden && me.trigger('beforeHide') !== false) {
                  me._hidden = true;
                  if (!element) return;
                  me.revertFocus(); // Focus exit causes close if autoClose: true, and if closeAction: 'hide'
                  // that might destroy us, so exit now if that happens.

                  if (me.isDestroyed) {
                    resolve();
                    return;
                  } // Cancel any current hide/show animation


                  if (me.currentAnimation) {
                    me.cancelHideShowAnimation();
                  }

                  if (hideAnimation) {
                    var styleProp = Object.keys(hideAnimation)[0],
                        animProps = hideAnimation[styleProp];
                    me.currentAnimation = {
                      styleProp: styleProp,
                      resolve: resolve
                    }; // Element must behave as though it were not there during
                    // the animated hide. This means pointer-events:none

                    element.classList.add('b-hiding');
                    element.addEventListener('transitionend', me.afterHideShowAnimate);
                    style[styleProp] = animProps.from;
                    style.transition = "".concat(styleProp, " ").concat(animProps.duration, " ease ").concat(animProps.delay);
                    me.requestAnimationFrame(function () {
                      style[styleProp] = animProps.to;
                    });
                  } else {
                    element.classList.add('b-hidden');
                  } // only supply resolve function if not using animation


                  me.afterHide(!hideAnimation && resolve);
                }
              });
            }
          }, {
            key: "doHideOrRealign",
            value: function doHideOrRealign(event) {
              var me = this,
                  anchoredTo = me.anchoredTo,
                  activeEl = document.activeElement; // If we're scrolling because a focused textual input field which we contain is being shifted into view,
              // we must not reposition - we'll just move with the document content.

              if (event.target.nodeType === 9 && me.element.contains(activeEl) && textInputTypes[activeEl] && window.innerHeight < document.body.offsetHeight) {
                return;
              } // If we either don't know what element we're anchored to (or not anchored to one at all),
              // or the element we're anchored to has been affected by the scroll, we must hide.


              if (me.scrollAction === 'hide' && (!anchoredTo || _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isDescendant(event.target, anchoredTo))) {
                me.hide();
              } // If the scrolling element contains the element we're anchored to, or we are anchored to something which is itself
              // inside a realigning floated widget, then we must realign
              else if (me.scrollAction === 'realign' && (_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].isDescendant(event.target, anchoredTo) || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].fromElement(anchoredTo, isRealigningFloater)) && event.target !== (document.scrollingElement || document.body)) {
                  me.realign(event.target);
                }
            }
          }, {
            key: "afterHide",
            value: function afterHide() {
              var resolveFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var fireEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var me = this,
                  lastAlignSpec = me.lastAlignSpec; // The flag must be cleared on a normal hide.
              // It's set after the hide() call in alignTo
              // if the target is outside our clippedTo region.

              if (lastAlignSpec) {
                lastAlignSpec.targetHidden = null;
              } // Remove listeners which are only added during the visible phase.
              // In its own method because it's called on hide and destroy.


              me.removeTransientListeners(); // Postprocessing to be done after the hideAnimation finishes.
              // If there's no animation, we call it immediately.
              // We set the element to be hidden here, after any animation completes.
              // We also remove floating Widgets from the DOM when they are hidden.

              if (!me.hideAnimation) {
                me.afterHideAnimation();
              }

              fireEvent && me.trigger('hide');
              resolveFn && resolveFn();
            }
          }, {
            key: "removeTransientListeners",
            value: function removeTransientListeners() {
              var me = this;

              if (me.documentScrollListener) {
                document.removeEventListener('scroll', me.doHideOrRealign, true);
                me.documentScrollListener = false;
              }

              if (me.constrainListeners) {
                _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].removeResizeListener(me.lastAlignSpec.constrainTo, me.callRealign);

                me.constrainMutationMonitor && me.constrainMutationMonitor.disconnect();
                me.constrainListeners = false;
              }
            }
          }, {
            key: "afterHideAnimation",
            value: function afterHideAnimation() {
              var me = this,
                  element = me.element,
                  contentRange = me.contentRange;

              if (me.floating && Widget.floatRoot.contains(element)) {
                if (contentRange) {
                  me.contentRangeStart = contentRange.start;
                  me.contentRangeEnd = contentRange.end;
                }

                element.remove();
              } else {
                element.classList.add('b-hidden');
              }
            }
            /**
             * Show or hide widget. Deprecated in 2.2.3, please use {@link #property-hidden} instead
             * @type {Boolean}
             * @category Visibility
             * @deprecated 2.2.3
             */

          }, {
            key: "up",

            /**
             * Looks up the {@link #property-owner} axis to find an ancestor which matches the passed selector.
             * The selector may be a widget type identifier, such as `'grid'`, or a function which will return
             * `true` when passed the desired ancestore.
             * @param {String|Function} selector A Type identifier or selection function.
             * @param {Boolean} [deep] When using a string identifier, pass `true` if all superclasses should be included, ie if a `Grid` should match `'widget'`.
             * @param {Number|String|Common.widget.Widget} [limit] how many steps to step up before aborting the search, or a selector to stop at or the topmost ancestor to consider.
             */
            value: function up(selector, deep, limit) {
              var limitType = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_11___default()(limit),
                  numericLimit = limitType === 'number',
                  selectorLimit = limitType === 'string';

              for (var result = this.owner, steps = 1; result; result = result.owner, steps++) {
                if (Object(_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["widgetMatches"])(result, selector, deep)) {
                  return result;
                }

                if (numericLimit && steps >= limit) {
                  return;
                } else if (selectorLimit && Object(_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["widgetMatches"])(result, limit, deep)) {
                  return;
                } else if (result === limit) {
                  return;
                }
              }
            }
            /**
             * Returns `true` if this Widget owns the passed Element or Widget. This is based on the
             * widget hierarchy, not DOM containment. So an element in a `Combo`'s dropdown list
             * will be owned by the `Combo`.
             * @param {HTMLElement|Common.widget.Widget} target The element or Widget to test for being
             * within the ownership tree of this Widget.
             */

          }, {
            key: "owns",
            value: function owns(target) {
              // We were passed an HtmlElement
              if (target && target.nodeType === 1) {
                if (this.element.contains(target)) {
                  return true;
                }

                target = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].fromElement(target);
              }

              while (target) {
                if (target === this) {
                  return true;
                }

                target = target.owner;
              }

              return false;
            }
          }, {
            key: "onFocusIn",
            value: function onFocusIn(e) {
              var me = this,
                  element = me.element;
              me.containsFocus = true;
              me.focusInEvent = e;
              element.classList.add('b-contains-focus');

              if (element.contains(e.target) && me.onInternalKeyDown && !me.keyDownListenerRemover) {
                me.keyDownListenerRemover = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].on({
                  element: element,
                  keydown: 'onInternalKeyDown',
                  thisObj: me
                });
              }
              /**
               * Fired when focus enters this Widget.
               * @event focusin
               * @param {Common.widget.Widget} source - This Widget
               * @param {HTMLElement} fromElement The element which lost focus.
               * @param {HTMLElement} toElement The element which gained focus.
               * @param {Common.widget.Widget} fromWidget The widget which lost focus.
               * @param {Common.widget.Widget} toWidget The widget which gained focus.
               * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
               */


              me.trigger('focusin', e);
            }
          }, {
            key: "onFocusOut",
            value: function onFocusOut(e) {
              var me = this;

              if (me.keyDownListenerRemover) {
                me.keyDownListenerRemover();
                me.keyDownListenerRemover = null;
              }

              if (!me.isDestroyed) {
                me.containsFocus = false;
                me.focusInEvent = null;
                me.element.classList.remove('b-contains-focus');
                /**
                 * Fired when focus exits this Widget's ownership tree. This is different from a `blur` event.
                 * focus moving from within this Widget's ownership tree, even if there are floating widgets
                 * will not trigger this event. This is when focus exits this widget completely.
                 * @event focusout
                 * @param {Common.widget.Widget} source - This Widget
                 * @param {HTMLElement} fromElement The element which lost focus.
                 * @param {HTMLElement} toElement The element which gained focus.
                 * @param {Common.widget.Widget} fromWidget The widget which lost focus.
                 * @param {Common.widget.Widget} toWidget The widget which gained focus.
                 * @param {Boolean} backwards `true` if the `toElement` is before the `fromElement` in document order.
                 */

                me.trigger('focusout', e);
              }
            }
            /**
             * If this Widget contains focus, focus is reverted to the source from which it entered if possible.
             */

          }, {
            key: "revertFocus",
            value: function revertFocus() {
              // TODO: look for fallback focus targets if the target is no longer focusable (disabled/hidden etc)
              if (this.focusInEvent && this.focusInEvent.relatedTarget && this.focusInEvent.relatedTarget.nodeType === 1 && this.element.contains(document.activeElement)) {
                _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].focusWithoutScrolling(this.focusInEvent.relatedTarget);
              }
            }
            /**
             * Returns `true` if this Widget contains focus.
             */

          }, {
            key: "isFocused",
            value: function isFocused() {
              return this.element.classList.contains('b-contains-focus');
            }
            /**
             * Used by the Widget class internally to create CSS classes based on this Widget's
             * inheritance chain to allow styling from each level to apply.
             *
             * For example Combo would yield `"["b-widget", "b-field", "b-textfield", "b-pickerfield", "b-combo"]"`
             *
             * May be implemented in subclasses to add or remove classes from the super.widgetClassList
             * @returns {String[]} The css class list named using the class name.
             * @internal
             * @category DOM
             */

          }, {
            key: "fromCache",
            //endregion
            //region Cache

            /**
             * Gets dom elements in the view. Caches the results for faster future calls.
             * @param {String} query CSS selector
             * @param {Boolean} children true to fetch multiple elements
             * @param {HTMLElement} element Element to use as root for the query, defaults to the views outermost element
             * @returns {HTMLElement|HTMLElement[]|null} A single element or an array of elements (if parameter children is set to true)
             * @internal
             * @category DOM
             */
            value: function fromCache(query) {
              var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.element;
              if (!element) return null;
              var me = this;

              if (!me.cache[query]) {
                me.cache[query] = children ? _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].children(element, query) : _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].down(element, query);
              }

              return me.cache[query];
            }
            /**
             * Clear caches, forces all calls to fromCache to requery dom. Called on render/rerender.
             * @internal
             * @category DOM
             */

          }, {
            key: "emptyCache",
            value: function emptyCache() {
              this.cache = {};
            } //endregion
            //region Mask

            /**
             * Mask the widget, showing the specified message
             * @param {String|Object} msg Mask message (or a {@link Common.widget.Mask} config object
             * @returns {Common.widget.Mask}
             */

          }, {
            key: "mask",
            value: function mask(msg) {
              var me = this;

              if (me.maskInstance) {
                me.maskInstance.destroy();
              }

              if (typeof msg === 'string') {
                return me.maskInstance = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].mask(me.element, msg);
              }

              msg.element = me.element;
              return me.maskInstance = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].mask(msg);
            }
            /**
             * Unmask the widget
             */

          }, {
            key: "unmask",
            value: function unmask() {
              if (this.maskInstance) {
                _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].unmask(this.element);

                this.maskInstance = null;
              }
            } //endregion
            //region Monitor resize

          }, {
            key: "onInternalResize",
            value: function onInternalResize(element, width, height, oldWidth, oldHeight) {
              this._width = element.offsetWidth;
              this._height = element.offsetHeight;
            }
          }, {
            key: "onElementResize",
            value: function onElementResize(resizedElement) {
              var me = this,
                  element = me.element,
                  oldWidth = me._width,
                  oldHeight = me._height,
                  newWidth = element.offsetWidth,
                  newHeight = element.offsetHeight;

              if (!me.suspendResizeMonitor && (oldWidth !== newWidth || oldHeight !== newHeight)) {
                me.onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight);
                /**
                 * Fired when the encapsulating element of a Widget resizes *only when {@link #config-monitorResize} is `true`*.
                 * @event resize
                 * @param {Common.widget.Widget} source - This Widget
                 * @param {Number} width The new width
                 * @param {Number} height The new height
                 * @param {Number} oldWidth The old width
                 * @param {Number} oldHeight The old height
                 */

                me.trigger('resize', {
                  width: newWidth,
                  height: newHeight,
                  oldWidth: oldWidth,
                  oldHeight: oldHeight
                });
              }
            }
          }, {
            key: "updateScale",
            value: function updateScale() {
              var me = this,
                  element = me.element,
                  parentElement = element.parentElement; // this could be placed elsewhere but want to keep it contained to not spam other code,
              // since this is a very specific usecase in our docs

              if (!me.configuredWidth) {
                me.configuredWidth = me.width;
              } // TODO: handle autoHeight, but seems it assigns height to late with current setup


              if (!me.parentHeight) {
                me.parentHeight = parentElement.offsetHeight;
              } // We are scaling to fit inside the width, so ensure that we are not the cause of a scrollbar
              // in our current, unscaled state by hiding while we measure the parent's offsetWidth which
              // we are going to scale to.


              element.style.display = 'none';
              var scale = parentElement.offsetWidth / me.configuredWidth,
                  adjustedScale = me.allowGrowWidth ? Math.min(scale, 1) : scale;
              element.style.transform = "scale(".concat(adjustedScale, ")");
              element.style.transformOrigin = 'top left';
              element.style.display = '';
              parentElement.style.height = me.parentHeight * adjustedScale + 'px';

              if (me.allowGrowWidth && scale > 1) {
                // increase width
                me.width = me.configuredWidth * scale;
              }
            }
          }, {
            key: "onParentElementResize",
            value: function onParentElementResize(event) {
              this.updateScale();
            } //endregion

            /**
             * Returns a `TRBL` array of values parse from the passed specification. This can be used to parse`
             * a value list for `margin` or `padding` or `border-width` etc - any CSS value which takes a `TRBL` value.
             * @param {Number|String|String[]} values The `TRBL` value
             * @param {String} [units=px] The units to add to values which are specified as numeric.
             */

          }, {
            key: "parseTRBL",
            value: function parseTRBL(values) {
              var units = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
              values = values || 0;

              if (typeof values === 'number') {
                return ["".concat(values).concat(units), "".concat(values).concat(units), "".concat(values).concat(units), "".concat(values).concat(units)];
              }

              var parts = values.split(' '),
                  len = parts.length;

              if (len === 1) {
                parts[1] = parts[2] = parts[3] = parts[0];
              } else if (len === 2) {
                parts[2] = parts[0];
                parts[3] = parts[1];
              } else if (len === 3) {
                parts[3] = parts[1];
              }

              return [isFinite(parts[0]) ? "".concat(parts[0]).concat(units) : parts[0], isFinite(parts[1]) ? "".concat(parts[1]).concat(units) : parts[2], isFinite(parts[2]) ? "".concat(parts[2]).concat(units) : parts[3], isFinite(parts[3]) ? "".concat(parts[3]).concat(units) : parts[4]];
            }
          }, {
            key: "title",
            set: function set(title) {
              this._title = title;

              if (this.titleElement) {
                this.titleElement.innerHTML = title;
              }
            },
            get: function get() {
              return this._title;
            }
            /**
             * Get this widget's encapsulating HTMLElement, which is created along with the widget but added to DOM at render time
             * @property {HTMLElement}
             * @readonly
             * @category DOM
             */

          }, {
            key: "element",
            get: function get() {
              return this._element;
            },
            set: function set(element) {
              var me = this;

              if (typeof element === 'string') {
                element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElementFromTemplate(element);
              } else if (element.constructor.name === 'Object') {
                element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElement(element);
              } else if (element.nodeType !== 1) {
                element = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElementFromTemplate(me.template(me));
              }

              me._element = element;
              var classList = element.classList;
              element.id = me.id; // Add the hierarchy, eg ['b-combo b-pickerfield b-textfield b-widget']
              // TODO: apply not needed when IE11 not supported, classList.add takes multiple classes
              //classList.add(...me.widgetClassList);

              element.className += ' ' + me.widgetClassList.join(' ');

              if (me._hidden) {
                classList.add('b-hidden');
              } // The environmental classes only need to be added to a naked Widget.
              // If we have a parent container, that will have them.


              if (!me.parent) {
                classList.add('b-outer');

                if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isTouchDevice) {
                  classList.add('b-touch-events');
                }

                if (!_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].scrollBarWidth) {
                  classList.add('b-overlay-scrollbar');
                }

                if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isChrome) {
                  classList.add('b-chrome');
                } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isSafari) {
                  classList.add('b-safari');
                } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isFirefox) {
                  classList.add('b-firefox');
                } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11) {
                  classList.add('b-ie');
                } else if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isEdge) {
                  classList.add('b-edge');
                }
              }

              var namedElements = element.querySelectorAll('[reference]');
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = namedElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var el = _step.value;
                  var name = el.getAttribute('reference');
                  el.removeAttribute('reference'); // Set a reference directly to significant elements.
                  // For example the 'input' element of a field.

                  me[name] = el; // Key elements contain owner pointer if data is supported (Not on IE SVG).

                  el.dataset && (el.dataset.ownerCmp = me.id);
                } // Create Range which encapsulates content set by the content property.
                // It will be set to encapsulate initial content upon render.

              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              me.contentRange = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11 ? document.createRange() : new Range();
            }
          }, {
            key: "constrainTo",
            set: function set(constrainTo) {
              this._constrainTo = constrainTo;
            },
            get: function get() {
              return '_constrainTo' in this ? this._constrainTo : window;
            }
          }, {
            key: "centered",
            set: function set(value) {
              this._centered = value;

              if (value && !this.floating) {
                throw new Error('`centered` is only relevant when a Widget is `floating`');
              }

              if (value) {
                this.element.classList.add('b-centered');
              } else {
                this.element.classList.remove('b-centered');
              }
            },
            get: function get() {
              return this._centered;
            }
            /**
             * The child element into which content should be placed. This means where {@link #config-html} should be put,
             * or, for {@link Common.widget.Container Container}s, where child items should be rendered.
             * @property {HTMLElement}
             * @category DOM
             */

          }, {
            key: "contentElement",
            get: function get() {
              return this.element;
            }
            /**
             * Get/set widgets id
             * @property {String}
             * @category DOM
             */

          }, {
            key: "id",
            get: function get() {
              return this._id;
            },
            set: function set(id) {
              var me = this,
                  oldId = me._id;

              if (oldId) {
                _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].unregister(me);
              }

              if (!id) {
                id = _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].generateId("b-".concat(me.$name.toLowerCase(), "-"));
                me.hasGeneratedId = true;
              }

              me._id = id;

              _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].register(me);
            }
            /**
             * Get/set widgets elements style. The setter accepts a cssText string or a style config object, the getter always
             * returns a CSSStyleDeclaration
             * @property {String|Object|CSSStyleDeclaration}
             * @category DOM
             */

          }, {
            key: "style",
            get: function get() {
              return this.element ? this.element.ownerDocument.defaultView.getComputedStyle(this.element) : this._style;
            },
            set: function set(style) {
              this._style = style;
              this.element && _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].applyStyle(this.element, this._style);
            }
            /**
             * Get widgets elements dataset or assign to it
             * @property {Object}
             * @category DOM
             */

          }, {
            key: "dataset",
            get: function get() {
              return this.element.dataset;
            },
            set: function set(dataset) {
              Object.assign(this.dataset, dataset);
            }
          }, {
            key: "ref",
            set: function set(ref) {
              this._ref = ref;
              this.element.dataset.ref = ref;
            },
            get: function get() {
              return this._ref;
            }
          }, {
            key: "clippedBy",
            set: function set(clippedBy) {
              this._clippedBy = Array.isArray(clippedBy) ? clippedBy : clippedBy ? [clippedBy] : null;
            },
            get: function get() {
              var clippedBy = this._clippedBy;

              if (clippedBy) {
                var result = _helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].from(clippedBy[0], null, true),
                    i;

                for (i = 1; i < clippedBy.length; i++) {
                  result = result.intersect(_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_29__["default"].from(clippedBy[i], null, true));
                }

                return result;
              }
            }
          }, {
            key: "overflowElement",
            get: function get() {
              return this.contentElement;
            }
          }, {
            key: "maxHeightElement",
            get: function get() {
              return this.element;
            }
          }, {
            key: "scrollable",
            set: function set(scrollable) {
              var overflowElement = this.overflowElement;

              if (typeof scrollable === 'boolean') {
                scrollable = {
                  overflowX: scrollable,
                  overflowY: scrollable
                };
              }

              if (overflowElement) {
                scrollable.element = overflowElement;
              }

              scrollable.widget = this;
              this._scrollable = new this.scrollerClass(scrollable);
            }
            /**
             * Accessor to the {@link Common.helper.util.Scroller} which can be used
             * to both set and read scroll information.
             * @property {Common.helper.util.Scroller} scrollable
             */
            ,
            get: function get() {
              return this._scrollable;
            }
            /**
             * Get/set HTML to display. When specifying HTML, this widget's element will also have `b-html` added to its
             * classList, to allow targeted styling.
             * @property {String}
             * @category DOM
             */

          }, {
            key: "html",
            get: function get() {
              // Maintainer, we cannot use a ternary here, we need the this.initializingElement test to shortcut
              // to the true case to return the _html property to avoid infinite loops.
              if (this.initializingElement || !this.element) {
                return this.content || this._html;
              }

              return this.contentElement.innerHTML;
            },
            set: function set(html) {
              var me = this,
                  isClearing = html == null,
                  element = me.element,
                  contentElement = me.contentElement;

              if (me._html !== html) {
                me._html = html;

                if (element) {
                  var anchorEl = contentElement === element && me._anchorElement; // Flag class that we are an HTML carrying element

                  element.classList[isClearing ? 'remove' : 'add']('b-html'); // Setting innerHTML destroys the anchorElement in some browsers
                  // so we must temporarily remove it to preserve it.
                  // Only if the contentElement is the main element.

                  if (anchorEl) {
                    me.element.removeChild(anchorEl);
                  }

                  me.contentElement.innerHTML = isClearing ? '' : html;

                  if (anchorEl) {
                    element.appendChild(anchorEl);
                  }

                  if (me.floating || me.positioned) {
                    // Must realign because content change might change dimensions
                    if (!me.isAligning) {
                      me.realign();
                    }
                  }
                }
              }
            }
            /**
             * Set HTML content safely, without disturbing sibling elements which may have been
             * added to the {@link #property-contentElement} by plugins and features.
             * When specifying html, this widget's element will also have `b-html` added to its
             * classList, to allow targeted styling.
             * @property {String}
             * @category DOM
             */

          }, {
            key: "content",
            set: function set(html) {
              var me = this,
                  isClearing = html == null,
                  element = me.element;

              if (me._html !== html) {
                me._html = html;

                if (element) {
                  var contentRange = me.contentRange; // Flag class that we are an HTML carrying element

                  element.classList[isClearing ? 'remove' : 'add']('b-html'); // Replace the contents of our content range with the new content

                  contentRange.deleteContents();

                  if (!isClearing) {
                    contentRange.insertNode(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElementFromTemplate(html, {
                      fragment: true
                    }));
                  } // Must realign because content change might change dimensions


                  if (!me.isAligning || me.positioned) {
                    me.realign();
                  }
                }
              }
            }
          }, {
            key: "anchorSize",
            get: function get() {
              var me = this;
              var result = this._anchorSize;

              if (!result) {
                // TODO: Move the anchoring scheme to the Panel class when we have it.
                // These values will be in the SASS and styled into the SVG through the Panel's theme.
                var borderWidth = parseFloat(_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(me.element, 'border-top-width')),
                    borderColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(me.element, 'border-top-color'),
                    anchorElement = me.anchorElement,
                    svgEl = anchorElement.firstElementChild,
                    pathElement = me.anchorPathElement = svgEl.lastElementChild,
                    hidden = me._hidden;

                var backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(me.contentElement, 'background-color'); // If the background colour comes through from the outer element, use that.


                if (backgroundColour.match(isTransparent)) {
                  backgroundColour = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStyleValue(me.element, 'background-color');
                }

                me.defaultAnchorBackgroundColor = backgroundColour;
                result = anchorElement.getBoundingClientRect();

                var _result2 = result = me._anchorSize = [result.width, result.height],
                    _result3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_result2, 2),
                    width = _result3[0],
                    height = _result3[1];

                svgEl.setAttribute('height', height + borderWidth);
                svgEl.setAttribute('width', width);
                pathElement.setAttribute('d', "M0,".concat(height, "L").concat(width / 2, ",0.5L").concat(width, ",").concat(height));

                if (borderWidth) {
                  pathElement.setAttribute('stroke-width', borderWidth);
                  pathElement.setAttribute('stroke', borderColour);
                }

                result[1] -= borderWidth;

                if (hidden) {
                  me.element.classList.add('b-hidden');
                }

                if (!me.themeChangeListener) {
                  me.themeChangeListener = _GlobalEvents_js__WEBPACK_IMPORTED_MODULE_36__["default"].on({
                    theme: 'onThemeChange',
                    thisObj: me
                  });
                }
              } // Reset to default in case it has been positioned by a coloured header


              me.anchorPathElement.setAttribute('fill', me.defaultAnchorBackgroundColor);
              return result;
            }
          }, {
            key: "anchorElement",
            get: function get() {
              var result = this._anchorElement;

              if (!result) {
                result = this._anchorElement = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElement({
                  parent: this.element,
                  className: 'b-anchor b-anchor-top',
                  children: [{
                    tag: 'svg',
                    ns: 'http://www.w3.org/2000/svg',
                    version: '1.1',
                    class: 'b-pointer-el',
                    children: [{
                      tag: 'defs',
                      children: [{
                        tag: 'filter',
                        id: 'shadow-filter',
                        children: [{
                          tag: 'feDropShadow',
                          dx: 0,
                          dy: -1,
                          stdDeviation: 2,
                          'flood-opacity': 0.05
                        }]
                      }]
                    }, {
                      tag: 'path',
                      filter: _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11 || _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isEdge ? null : 'url(#shadow-filter)'
                    }]
                  }]
                });
              }

              return result;
            }
          }, {
            key: "anchor",
            set: function set(anchor) {
              this._anchor = anchor;

              if (this._anchorElement) {
                this._anchorElement.classList[anchor ? 'remove' : 'add']('b-hide-display');
              }
            },
            get: function get() {
              return this._anchor;
            }
          }, {
            key: "draggable",
            get: function get() {
              return this._draggable;
            },
            set: function set(draggable) {
              var me = this,
                  element = me.element;
              me._draggable = draggable;
              element.setAttribute('draggable', Boolean(draggable));

              if (draggable) {
                me.dragEventDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_28__["default"].addListener({
                  element: me.element,
                  dragstart: me.onWidgetDragStart,
                  dragend: me.onWidgetDragEnd,
                  thisObj: me
                });
              } else {
                me.dragEventDetacher && me.dragEventDetacher();
                me.dragOverEventDetacher && me.dragOverEventDetacher();
              }
            }
          }, {
            key: "floating",
            get: function get() {
              return this._floating;
            },
            set: function set(floating) {
              // Coerce all to boolean so that we have a true/false value
              floating = Boolean(floating);

              if (Boolean(this.floating) !== floating) {
                this._floating = floating;
              }
            }
          }, {
            key: "positioned",
            get: function get() {
              return this._positioned;
            },
            set: function set(positioned) {
              // Coerce all to boolean so that we have a true/false value
              positioned = Boolean(positioned);

              if (Boolean(this.positioned) !== positioned) {
                this.element.classList[positioned ? 'add' : 'remove']('b-positioned');
                this._positioned = positioned;
              }
            }
          }, {
            key: "x",
            set: function set(x) {
              this.setXY(x);
            },
            get: function get() {
              return this.getXY()[0];
            }
            /**
             * Moves this Widget to the desired y position. *Only valid for {@link #config-floating} Widgets.
             * @param {Number} y
             * @category Float & align
             */

          }, {
            key: "y",
            set: function set(y) {
              this.setXY(null, y);
            },
            get: function get() {
              return this.getXY()[1];
            }
            /**
             * Get elements offsetWidth or sets its style.width, or specified width if element not created yet.
             * @property {Number|String}
             * @category Layout
             */

          }, {
            key: "width",
            get: function get() {
              var me = this,
                  element = me.element;

              if (me.monitorResize) {
                // If the width is invalid, read it now.
                if (me._width == null) {
                  me._width = element.offsetWidth;
                } // Usually this will be set in onInternalResize


                return me._width;
              } // No monitoring, we have to measure;


              return element.offsetWidth;
            },
            set: function set(width) {
              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setLength(this.element, 'width', width); // Invalidate the width, so it will be read from the DOM if a read is requested before the resize event


              this._width = null; // Setting width explicitly should reset flex, since it's not flexed anymore

              this._flex = null;
              this.element.style.flex = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11 ? '' : null;
            }
            /**
             * Get/set elements maxWidth. Getter returns max-width from elements style, which is always a string. Setter accepts
             * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
             * _reading_ the value will return the numeric value in pixels.
             * @property {String|Number}
             * @category Layout
             */

          }, {
            key: "maxWidth",
            get: function get() {
              return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].measureSize(this.element.style.maxWidth, this.element);
            },
            set: function set(maxWidth) {
              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setLength(this.element, 'maxWidth', maxWidth);
            }
            /**
             * Get/set elements minWidth. Getter returns min-width from elements style, which is always a string. Setter accepts
             * either a String or a Number (which will have 'px' appended). Note that like {@link #config-width},
             * _reading_ the value will return the numeric value in pixels.
             * @property {String|Number}
             * @category Layout
             */

          }, {
            key: "minWidth",
            get: function get() {
              return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].measureSize(this.element.style.minWidth, this.element);
            },
            set: function set(minWidth) {
              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setLength(this.element, 'minWidth', minWidth);
            }
          }, {
            key: "flex",
            get: function get() {
              return this._flex;
            }
            /**
             * Get element's flex property. This may be configured as a single number or a `<flex-grow> <flex-shrink> <flex-basis>` format string.
             * numeric-only values are interpreted as the `flex-grow` value.
             * @property {Number|String}
             * @category Layout
             */
            ,
            set: function set(flex) {
              this._flex = flex; // Default grow to the same as flex and basis to 0.

              if (typeof flex === 'number' || typeof flex === 'string' && flex.split(/\s/).length === 1) {
                flex = "".concat(flex, " ").concat(flex);
              }

              this.element.style.flex = flex;
              this.element.style.width = _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11 ? '' : null;
            }
            /**
             * Get/set this widget's `align-self` flexbox setting. This may be set to modify
             * how this widget is aligned within the cross axis of a flexbox layout container.
             * @property {String}
             * @category Layout
             */

          }, {
            key: "alignSelf",
            get: function get() {
              return this._alignSelf;
            },
            set: function set(alignSelf) {
              this.element.style.alignSelf = alignSelf;
            }
            /**
             * Get element's margin property. This may be configured as a single number or a `TRBL` format string.
             * numeric-only values are interpreted as pixels.
             * @property {Number|String}
             * @category Layout
             */

          }, {
            key: "margin",
            get: function get() {
              return this._margin;
            },
            set: function set(margin) {
              // Convert eg 1 to "1px 1px 1px 1px" or "0 8px" to "0px 8px 0px 8px"
              this.element.style.margin = this._margin = this.parseTRBL(margin).join(' ');
            }
            /**
             * Get element's offsetHeight or sets its style.height, or specified height if element no created yet.
             * @property {Number|String}
             * @category Layout
             */

          }, {
            key: "height",
            get: function get() {
              var me = this,
                  element = me.element;

              if (me.monitorResize) {
                // If the height is invalid, read it now.
                if (me._height == null) {
                  me._height = element.offsetHeight;
                } // Usually this will be set in onInternalResize


                return me._height;
              } // No monitoring, we have to measure;


              return element.offsetHeight;
            },
            set: function set(height) {
              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setLength(this.element, 'height', height); // Invalidate the height, so it will be read from the DOM if a read is requested before the resize event


              this._height = null;
            }
            /**
             * Get/set element's maxHeight. Getter returns max-height from elements style, which is always a string. Setter
             * accepts either a String or a Number (which will have 'px' appended). Note that like {@link #config-height},
             * _reading_ the value will return the numeric value in pixels.
             * @property {String|Number}
             * @category Layout
             */

          }, {
            key: "maxHeight",
            get: function get() {
              return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].measureSize(this.maxHeightElement.style.maxHeight, this.element);
            },
            set: function set(maxHeight) {
              var me = this,
                  element = me.element;

              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setLength(me.maxHeightElement, 'maxHeight', maxHeight); // Flexbox does not handle overflow correctly when a vertically
              // flexed item is constrained by the maxHeight of its containing el.
              // So we have to propagate the maxHeight from the encapsulating element
              // onto the contentElement.


              if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11 && me.contentElement !== element) {
                if (maxHeight == null) {
                  _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].removeResizeListener(element, me.boundMaxHeightBugHandler);
                } else {
                  _helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_26__["default"].addResizeListener(element, me.boundMaxHeightBugHandler || (me.boundMaxHeightBugHandler = me.fixIEMaxHeightBug.bind(me)));

                  if (document.body.contains(element)) {
                    me.fixIEMaxHeightBug();
                  }
                }
              }
            }
          }, {
            key: "minHeight",
            get: function get() {
              return _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].measureSize(this.element.style.minHeight, this.element);
            },
            set: function set(minHeight) {
              _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].setLength(this.element, 'minHeight', minHeight);
            }
            /**
             * Get/set element's disabled state
             * @property {Boolean}
             * @category Misc
             */

          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              var el = this.element,
                  focusEl = this.focusElement;
              disabled && this.revertFocus();

              if (el) {
                el.classList[disabled ? 'add' : 'remove']('b-disabled');

                if (focusEl) {
                  focusEl.disabled = disabled;
                }
              }

              this._disabled = disabled;
            }
          }, {
            key: "tooltip",
            get: function get() {
              return this._tooltip;
            } //noinspection JSAnnotator

            /**
             * Get/set a tooltip on the widget. Accepts a string or tooltip config (specify true (or 'true') to use placeholder
             * as tooltip). When using a string it will configure the tooltip with `textContent: true` which enforces a default
             * max width.
             *
             * @property {String|Object}
             * @category Misc
             */
            ,
            set: function set(config) {
              var me = this;

              if (me._tooltip) {
                me._tooltip.destroy();

                me._tooltip = null;
              }

              if (config && !(me.preventTooltipOnTouch && _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isTouchDevice)) {
                if (config.constructor.name !== 'Object') {
                  config = {
                    html: typeof config === 'string' ? config : me.placeholder,
                    textContent: true
                  };
                }

                config.type = 'tooltip';
                if (!config.forElement) config.forElement = me.element;
                if (!('showOnHover' in config)) config.showOnHover = true;
                if (!('autoClose' in config)) config.autoClose = true;
                me._tooltip = _helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].createWidget(config);
              }
            }
            /**
             * Determines visibility by checking if the Widgets is hidden, if not it checks if its element is available in DOM
             * @property {Boolean}
             * @readonly
             */

          }, {
            key: "isVisible",
            get: function get() {
              var element = this.element;
              var result = element && !this._hidden; // TODO: When we have a containment hierarchy, this needs to take the hierarchy into account.
              // A descendant of a hidden, or non rendered (in the sense of being inserted into the document)
              // ancestor is not visible even if it is not hidden.

              if (result) {
                if (!document.body.contains(element) || this.requireSize && element.offsetWidth === 0 && element.offsetHeight === 0) {
                  // element wasn't found in document, set visibility flag to false
                  result = false; // No shadowroot support in IE11/Edge

                  if (window.ShadowRoot) {
                    // if element cannot be found in document, it may be in the shadow dom
                    // walk through parentNodes, checking instances
                    var current = element;

                    while (current = current.parentNode) {
                      if (current instanceof window.ShadowRoot) {
                        result = true;
                      }
                    }
                  }
                }
              }

              return result;
            }
          }, {
            key: "focusElement",
            get: function get() {// Override in widgets which are focusable.
            }
          }, {
            key: "isFocusable",
            get: function get() {
              var focusElement = this.focusElement; // We are only focusable if the focusEl is deeply visible, that means
              // it must have layout - an offsetParent. Body does not have offsetParent.

              return focusElement && this.isVisible && !this.disabled && (focusElement === document.body || focusElement.offsetParent);
            }
          }, {
            key: "visible",
            set: function set(show) {
              this.hidden = !show;
            }
            /**
             * Hide or show widget
             * @type {Boolean}
             * @category Visibility
             */

          }, {
            key: "hidden",
            set: function set(hide) {
              if (this.isConfiguring) {
                this._hidden = hide;
                this.element.classList[hide ? 'add' : 'remove']('b-hidden');
              } else {
                if (hide) {
                  this.hide();
                } else {
                  this.show();
                }
              }
            }
            /**
             * Get id assigned by user (not generated id)
             * @returns {String}
             * @readonly
             * @private
             * @category Misc
             */

          }, {
            key: "assignedId",
            get: function get() {
              return this.hasGeneratedId ? null : this.id;
            }
            /**
             * Get the owning Widget of this Widget. If this Widget is directly contained, then the containing
             * Widget is returned. If this Widget is floating, the configured `owner` property is returned.
             * If there is a `forElement`, that element's encapsulating Widget is returned.
             * @category Misc
             */

          }, {
            key: "owner",
            get: function get() {
              return this.parent || this._owner || _helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].fromElement(this.forElement || this.element.parentNode);
            },
            set: function set(owner) {
              this._owner = owner;
            }
          }, {
            key: "widgetClassList",
            get: function get() {
              var me = this;
              var myCls = me.cls,
                  result = me.classHierarchy(Widget).reduce(function (target, cls) {
                var widgetClassProperty = Reflect.getOwnPropertyDescriptor(cls.prototype, 'widgetClass'),
                    widgetClass; // If the Class has its own get widgetClass, call it upon this instance.

                if (widgetClassProperty && widgetClassProperty.get) {
                  widgetClass = widgetClassProperty.get.call(me);
                } else {
                  widgetClass = "b-".concat(cls.$name.toLowerCase());
                }

                if (widgetClass) {
                  // The result is used as a DOM classList. Must not contain spaces.
                  target.push.apply(target, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(widgetClass.split(' ')));
                }

                return target;
              }, myCls ? myCls.split(' ') : []);

              if (me.floating) {
                result.push('b-floating');
              }

              if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isTouchDevice) {
                result.push('b-touch');
              }

              return result;
            }
          }], [{
            key: "fromElement",
            value: function fromElement(element, selector, limit) {}
          }, {
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * A {@link Common.helper.DomHelper#function-createElement-static} config object or HTML string from which to
                 * create the Widget's element.
                 * @private
                 * @config {Object|String}
                 * @category DOM
                 */
                element: true,
                callOnFunctions: true,

                /**
                 * Widget id, if not specified one will be generated. Also used for lookups through WidgetHelper
                 * @config {String}
                 * @category DOM
                 */
                id: '',

                /**
                 * Html to display initially
                 * @config {String}
                 * @category DOM
                 */
                html: null,

                /**
                 * true if no id was set, will use generated id instead (widget1, ...). Toggle automatically on creation
                 * @default false
                 * @type {Boolean}
                 * @private
                 * @category Misc
                 */
                hasGeneratedId: null,

                /**
                 * Custom CSS class to add to element
                 * @config {String}
                 * @category CSS
                 */
                cls: null,

                /**
                 * Custom style spec to add to element
                 * @config {String}
                 * @category CSS
                 */
                style: null,

                /**
                 * Disabled or enabled
                 * @default false
                 * @config {Boolean}
                 * @category Misc
                 */
                disabled: null,

                /**
                 * Element (or element id) to append this widgets element to
                 * @config {HTMLElement|String}
                 * @default
                 * @category DOM
                 */
                appendTo: null,

                /**
                 * Element (or element id) to insert this widget before. If provided, {@link #config-appendTo} config is ignored.
                 * @config {HTMLElement|String}
                 * @category DOM
                 */
                insertBefore: null,

                /**
                 * Element (or element id) to append this widget element to, as a first child. If provided, {@link #config-appendTo} config is ignored.
                 * @config {HTMLElement|String}
                 * @category DOM
                 */
                insertFirst: null,

                /**
                 * Object to apply to elements dataset (each key will be used as a data-attribute on the element)
                 * @config {Object}
                 * @category DOM
                 */
                dataset: null,

                /**
                 * Tooltip for the widget, either as a string or as a Tooltip config object
                 * @config {String|Object}
                 * @category Misc
                 */
                tooltip: null,

                /**
                 * Prevent tooltip from being displayed on touch devices. Useful for example for buttons that display a
                 * menu on click etc, since the tooltip would be displayed at the same time.
                 * @config {Boolean}
                 * @default false
                 * @category Misc
                 */
                preventTooltipOnTouch: null,

                /**
                 * Specify true to have widget monitoring window resize.
                 * @config {Boolean}
                 * @default false
                 * @category Misc
                 */
                monitorResize: null,
                cache: {},

                /**
                 * Set to `true` to move the widget out of the document flow and position it
                 * absolutely in browser viewport space.
                 * @config {Boolean}
                 * @default
                 * @category Float & align
                 */
                floating: null,

                /**
                 * Set to `true` when a widget is rendered into another widget's  {@link #property-contentElement}, but must not
                 * participate in the standard layout of that widget, and must be positioned relatively to that
                 * widget's {@link #property-contentElement}.
                 *
                 * {@link Common.widget.Editor Editor}s are positioned widgets.
                 * @config {Boolean}
                 * @default
                 * @category Float & align
                 */
                positioned: null,

                /**
                 * Only valid if this Widget is {@link #config-floating}
                 * Set to `true` to be able to drag a widget freely on the page. Or set to an object with a ´handleSelector´ property which controls when a drag
                 * should start.
                 *
                 * ```javascript
                 *
                 * draggable : {
                 *     handleSelector : ':not(button)'
                 * }
                 *
                 * ```
                 *
                 * @config {Boolean/Object}
                 * @default false
                 * @category Float & align
                 */
                draggable: null,

                /**
                 * Only valid if this Widget is {@link #config-floating}
                 * The edge alignment spec to use by default when {@link #function-showBy} or {@link #function-alignTo} is used.
                 * Format is `'[trbl]n-[trbl]n'` and it specifies our edge and the target edge plus optional
                 * offsets from 0 to 100 along the edges to align to. See the {@link #function-showBy} function for more details.
                 * @default
                 * @config {String}
                 * @category Float & align
                 */
                align: 't-b',

                /**
                 * Only valid if this Widget is {@link #config-floating}
                 * Set to `true` to centre the Widget in browser viewport space.
                 * @config {Boolean}
                 * @default
                 * @category Float & align
                 */
                centered: null,

                /**
                 * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
                 * Element, Widget or Rectangle to which this Widget is constrained.
                 * @config {HTMLElement|Common.widget.Widget|Common.helper.util.Rectangle}
                 * @default document.body
                 * @category Float & align
                 */
                constrainTo: null,

                /**
                 * Only valid if this Widget is {@link #config-floating} and being shown through {@link #function-showBy}.
                 * `true` to show a connector arrow pointing to the align target.
                 * @config {Boolean}
                 * @default false
                 * @category Float & align
                 */
                anchor: null,

                /**
                 * Defines what to do if document is scrolled while Widget is visible (only relevant when floating is set to true).
                 * Valid values: ´null´: do nothing, ´hide´: hide the widget or ´realign´: realign to the target if possible.
                 * @config {String}
                 * @default
                 * @category Float & align
                 */
                scrollAction: null,

                /**
                 * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
                 * property should be animated upon hide, and how it should be animated eg:
                 *
                 * ```javascript
                 * {
                 *    opacity: {
                 *        to : 0,
                 *        duration: '10s',
                 *        delay: '0s'
                 *    }
                 * }
                 * ```
                 *
                 * Set to `'false'` to disable animation.
                 *
                 * @config {Boolean|Object}
                 * @default
                 * @category Float & align
                 */
                hideAnimation: null,

                /**
                 * Only valid if this Widget is {@link #config-floating}. An object which defined which CSS style
                 * property should be animated upon show, and how it should be animated eg:
                 *
                 * ```javascript
                 * {
                 *    opacity: {
                 *        to : 1,
                 *        duration: '10s',
                 *        delay: '0s'
                 *    }
                 * }
                 * ```
                 *
                 * Set to `'false'` to disable animation.
                 *
                 * @config {Boolean|Object}
                 * @category Float & align
                 */
                showAnimation: null,

                /**
                 * Only valid if this Widget is {@link #config-floating}. The x position for the widget.
                 *
                 * @config {Number}
                 * @default
                 * @category Float & align
                 */
                x: null,

                /**
                 * Only valid if this Widget is {@link #config-floating}. The y position for the widget.
                 *
                 * @config {Number}
                 * @default
                 * @category Float & align
                 */
                y: null,

                /**
                 * Specifies whether (and optionally in which axes) a Widget may scroll. `true` means this widget
                 * may scroll in both axes. May be an object containing boolean `overflowX` and `overflowY` properties which are applied
                 * to CSS style properties `overflowX` and `overflowY`. If they are boolean, they are translated
                 * to CSS overflow properties thus:
                 *
                 * *`true` -> `'auto'`
                 * *`false` -> `'hidden'`
                 *
                 * After initialization, this property yields a {@link Common.helper.util.Scroller} which may be used
                 * to both set and read scroll information.
                 *
                 * A Widget uses its `get overflowElement` property to select which element is to be scrollable.
                 * By default, in the base `Widget` class, this is the Widget's encapsulating element. Subclasses
                 * may implement `get overflowElement` to scroll inner elements.
                 * @config {Boolean/Object}
                 * @default false
                 * @category Scrolling
                 */
                scrollable: null,

                /**
                 * The class to instantiate to use as the {@link #config-scrollable}. Defaults to {@link Common.helper.util.Scroller}.
                 * @internal
                 * @config {Common.helper.util.Scroller}
                 * @category Scrolling
                 */
                scrollerClass: _helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_31__["default"],

                /**
                 * The name of the property to set when a single value is to be applied to this Widget. Such as when used
                 * in a grid WidgetColumn, this is the property to which the column's `field` is applied.
                 * @config {String}
                 * @default 'html'
                 * @category Misc
                 */
                defaultBindProperty: 'html',

                /**
                 * Event that should be considered the default action of the widget. When that event is triggered the
                 * widget is also expected to trigger an `action` event. Purpose is to allow reacting to most widgets in
                 * a coherent way.
                 * @private
                 * @config {String}
                 * @category Misc
                 */
                defaultAction: null,

                /**
                 * Widget's width, used to set element style.width. Either specify a valid width string or a number, which
                 * will get 'px' appended. We recommend using CSS as the primary way to control width, but in some cases
                 * this config is convenient.
                 * @config {String|Number}
                 * @category Layout
                 */
                width: null,

                /**
                 * Widget's height, used to set element style.height. Either specify a valid height string or a number, which
                 * will get 'px' appended. We recommend using CSS as the primary way to control height, but in some cases
                 * this config is convenient.
                 * @config {String|Number}
                 * @category Layout
                 */
                height: null,
                // not public, only used by us in docs
                scaleToFitWidth: null,
                allowGrowWidth: true,
                // only used if scaleToFitWidth is true

                /**
                 * Widget's margin. This may be configured as a single number or a `TRBL` format string.
                 * numeric-only values are interpreted as pixels.
                 * @config {Number|String}
                 * @category Layout
                 */
                margin: null,

                /**
                 * When this widget is a child of a {@link Common.widget.Container},
                 * it will by default be participating in a flexbox layout. This config
                 * allows you to set this widget's <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/flex">flex</a> style.
                 * This may be configured as a single number or a `<flex-grow> <flex-shrink> <flex-basis>` format string.
                 * numeric-only values are interpreted as the `flex-grow` value.
                 * @config {Number|String}
                 * @category Layout
                 */
                flex: null,

                /**
                 * When this widget is a child of a {@link Common.widget.Container},
                 * it will by default be participating in a flexbox layout. This config
                 * allows you to set this widget's <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/align-self">align-self</a> style.
                 * @config {String}
                 * @category Layout
                 */
                alignSelf: null,

                /**
                 * Configure as `true` to have the component display a translucent ripple when its
                 * {@link #property-focusElement}, or {@link #property-element} is tapped *if the
                 * current theme supports ripples*. Out of the box, only the Material theme supports ripples.
                 *
                 * This may also be a config object containing the following properties:
                 *
                 *  - `delegate  ` Optional. A CSS selector to filter which child elements trigger ripples. By default
                 * the ripple is clipped to the triggering element.
                 *  - `color     ` Optional, default = `#000`. A CSS color name or specification.
                 *  - `radius    ` Optional, default is 100. The ending radius of the ripple.
                 * Note that it will be clipped by the target element by default.
                 *  - `clip      ` A string which describes how to clip the ripple if it is not to be clipped to the default
                 * element. Either the property of the widget to use as the clipping element, or a selector to
                 * allow clipping to the closest matching ancestor to the target element.
                 *
                 * eg:
                 *```
                 *    columns  : [{}...],
                 *    ripple   : {
                 *        color : 'red',
                 *        clip  : '.b-grid-row'
                 *    },
                 *    ...
                 *```
                 * @config {Boolean|Object}
                 * @category Misc
                 */
                ripple: null,

                /**
                 * A title to display for the widget. Only in effect when inside a container that uses it (such as TabPanel)
                 * @default
                 * @config {String}
                 */
                title: null,
                localizableProperties: ['title'],
                // Set this flag to require element to have a size to be considered visible
                requireSize: false,

                /**
                 * An identifier by which this widget will be registered in the {@link Common.widget.Container#property-widgetMap}
                 * of all ancestor containers.
                 *
                 * If omitted, this widget will be registered using its {@link #config-id}. In most cases `ref` is
                 * preferable over `id` since `id` is required to be globally unique while `ref` is not.
                 *
                 * The `ref` value is also added to the elements dataset, to allow targeting it using CSS etc.
                 * @default
                 * @config {String}
                 */
                ref: null,

                /**
                 * Configure with true to make widget initially hidden
                 * @default false
                 * @config {Boolean}
                 */
                hidden: null
              };
            }
          }, {
            key: "floatRoot",
            get: function get() {
              var me = this;

              if (!me._floatRoot) {
                // Reuse any existing floatRoot. There might be one if using multiple product bundles
                me._floatRoot = document.querySelector('.b-float-root');

                if (!me._floatRoot) {
                  me._floatRoot = _helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].createElement({
                    className: 'b-float-root',
                    parent: document.body
                  });
                }
              }

              return me._floatRoot;
            }
          }]);

          return Widget;
        }(Object(_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_35__["default"])(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_34__["default"])(Object(_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_33__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_22__["default"]))));

        Widget._$name = 'Widget';

        _adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_21__["default"].register('widget', Widget);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/layout/Card.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/widget/layout/Card.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetLayoutCardJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Card;
        });
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Layout_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./Layout.js */
        "../Grid/lib/Common/widget/layout/Layout.js");
        /* harmony import */


        var _Widget_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/layout/Card
         */

        var animationClasses = ['b-slide-out-left', 'b-slide-out-right', 'b-slide-in-left', 'b-slide-in-right'];
        /**
         * A helper class for containers which must manage multiple child widgets, of which only one may be visible at once such
         * as a {@link Common.widget.TabPanel}. This class offers an active widget switching API, and optional slide-in,
         * slide-out animations from child to child.
         */

        var Card =
        /*#__PURE__*/
        function (_Layout) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Card, _Layout);

          function Card() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Card);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Card).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Card, [{
            key: "setActiveItem",

            /**
             * Get/set active item, using index or the Widget to activate
             * @param {Common.widget.Widget|Number} activeItem
             * @returns {Object} An object describing the card change containing the following properties:
             *
             *  - `prevActiveIndex` The previously active index.
             *  - `prevActiveItem ` The previously active child item.
             *  - `activeIndex    ` The newly active index.
             *  - `activeItem     ` The newly active child item.
             *  - `promise        ` A promise which completes when the slide-in animation finishes and the child item contains
             * focus if it is focusable.
             */
            value: function setActiveItem(activeIndex) {
              var me = this,
                  owner = me.owner,
                  contentElement = owner.contentElement,
                  items = owner.items,
                  widgetPassed = activeIndex instanceof _Widget_js__WEBPACK_IMPORTED_MODULE_8__["default"],
                  prevActiveIndex = parseInt(contentElement.dataset.activeIndex),
                  prevActiveItem = items[prevActiveIndex],
                  newActiveItem = owner.items[activeIndex = widgetPassed ? activeIndex = items.indexOf(activeIndex) : parseInt(activeIndex)],
                  event = {
                prevActiveIndex: prevActiveIndex,
                prevActiveItem: prevActiveItem
              }; // There's a child widget at that index to activate

              if (newActiveItem && newActiveItem !== prevActiveItem) {
                var prevItemElement = prevActiveItem.element,
                    newActiveElement = newActiveItem && newActiveItem.element;
                event.activeIndex = activeIndex;
                event.activeItem = newActiveItem; // A previous card change is in progress, abort it and clean the items it was operating upon

                if (me.animateDetacher) {
                  var _abortedEvent$activeI;

                  var abortedEvent = me.animateDetacher.event;
                  me.animateDetacher();
                  abortedEvent.prevActiveItem.element.classList.remove(animationClasses);

                  (_abortedEvent$activeI = abortedEvent.activeItem.element.classList).remove.apply(_abortedEvent$activeI, ['b-active'].concat(animationClasses));

                  me.animateDetacher = null;
                }

                event.promise = new Promise(function (resolve, reject) {
                  // If there's something to slide out, slide it out, and slide the new item in
                  if (prevItemElement && me.animateCardChange) {
                    prevItemElement.classList.add(activeIndex > prevActiveIndex ? 'b-slide-out-left' : 'b-slide-out-right');
                    newActiveElement.classList.add('b-active', activeIndex < prevActiveIndex ? 'b-slide-in-left' : 'b-slide-in-right'); // Paint early, to have contents in place when sliding in

                    newActiveItem.triggerPaint(); // When the new widget is in place, clean up

                    me.animateDetacher = _helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                      element: newActiveElement,
                      animationend: function animationend() {
                        var _newActiveElement$cla;

                        me.animateDetacher = null; // Clean incoming widget's animation classes

                        (_newActiveElement$cla = newActiveElement.classList).remove.apply(_newActiveElement$cla, animationClasses); // If there's an outgoing item, clean its animation classes and hide it


                        if (prevItemElement) {
                          var _prevItemElement$clas;

                          (_prevItemElement$clas = prevItemElement.classList).remove.apply(_prevItemElement$clas, ['b-active'].concat(animationClasses));
                        }

                        contentElement.dataset.activeIndex = activeIndex; // Note that we have to call focus *after* the element is in its new position
                        // because focus({preventScroll:true}) is not supported everywhere
                        // and crazy browser scrolling behaviour on focus breaks the animation.

                        newActiveItem.focus();
                        resolve(event);
                      },
                      once: true
                    });
                    me.animateDetacher.reject = reject;
                    me.animateDetacher.event = event;
                  } // Nothing to slide out or we are not animating.
                  else {
                      if (prevItemElement) {
                        prevItemElement.classList.remove('b-active');
                      }

                      newActiveElement.classList.add('b-active');
                      contentElement.dataset.activeIndex = activeIndex;
                      newActiveItem.focus();
                      newActiveItem.triggerPaint();
                      resolve(event);
                    }
                });
              }

              return event;
            }
          }, {
            key: "renderChildren",
            value: function renderChildren() {
              var owner = this.owner,
                  activeIndex = owner.activeIndex; // The usual; not working on IE11

              if (_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isIE11) {
                this.animateCardChange = false;
              } // Ensure activeIndex of the owning Container at render time is honoured.


              if (owner.items && activeIndex != null && owner.items[activeIndex]) {
                owner.contentElement.dataset.activeIndex = activeIndex;
                owner.items[activeIndex].element.classList.add('b-active');
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Card.prototype), "renderChildren", this).call(this);
            }
            /**
             * The active child index. Setting must be done through {@link #function-setActiveItem}
             * @property {Number}
             * @readonly
             */

          }, {
            key: "activeIndex",
            get: function get() {
              return parseInt(this.owner.contentElement.dataset.activeIndex);
            }
            /**
             * The active child item. Setting must be done through {@link #function-setActiveItem}
             * @property {Common.widget.Widget}
             * @readonly
             */

          }, {
            key: "activeItem",
            get: function get() {
              return this.owner.items[parseInt(this.owner.contentElement.dataset.activeIndex)];
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                containerCls: 'b-card-container',
                itemCls: 'b-card-item',

                /**
                 * Specifies whether to slide tabs in and out of visibility.
                 * @config {Boolean}
                 * @default
                 */
                animateCardChange: true
              };
            }
          }]);

          return Card;
        }(_Layout_js__WEBPACK_IMPORTED_MODULE_7__["default"]); // Layouts must register themselves so that the static layout instantiation
        // in Layout knows what to do with layout type names


        Card._$name = 'Card';

        _Layout_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerLayout(Card);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/layout/Fit.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Common/widget/layout/Fit.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetLayoutFitJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Fit;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Layout_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./Layout.js */
        "../Grid/lib/Common/widget/layout/Layout.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/layout/Fit
         */

        /**
         * A helper class for containers which must manage a single child widget which must fit the container's
         * {@link Common.widget.Widget#property-contentElement contentElement}.
         */

        var Fit =
        /*#__PURE__*/
        function (_Layout) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(Fit, _Layout);

          function Fit() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Fit);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Fit).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Fit, null, [{
            key: "defaultConfig",
            get: function get() {
              return {
                containerCls: 'b-fit-container',
                itemCls: 'b-fit-item'
              };
            }
          }]);

          return Fit;
        }(_Layout_js__WEBPACK_IMPORTED_MODULE_5__["default"]); // Layouts must register themselves so that the static layout instantiation
        // in Layout knows what to do with layout type names


        Fit._$name = 'Fit';

        _Layout_js__WEBPACK_IMPORTED_MODULE_5__["default"].registerLayout(Fit);
        /***/

      },

      /***/
      "../Grid/lib/Common/widget/layout/Layout.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Common/widget/layout/Layout.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetLayoutLayoutJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Layout;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/layout/Layout
         */

        /**
          * A helper class used by {@link Common.widget.Container Container}s which renders child widgets to their
          * {@link Common.widget.Widget#property-contentElement}. It also adds the Container's
          * {@link Common.widget.Container#config-itemCls} class to child items.
          *
          * Subclasses may modify the way child widgets are rendered, or may offer APIs for manipulating the child widgets.
          *
          * The {@link Common.widget.layout.Card Card} layout class offers slide-in, slide-out animation of multiple
          * child widgets. {@link Common.widget.TabPanel} uses Card layout.
          */

        var Layout =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Layout, _Events);

          function Layout() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Layout);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Layout).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Layout, [{
            key: "renderChildren",
            value: function renderChildren() {
              var owner = this.owner,
                  containerCls = this.containerCls,
                  itemCls = this.itemCls,
                  contentElement = owner.contentElement,
                  items = owner.items,
                  ownerItemCls = owner.itemCls,
                  itemCount = items && items.length;
              contentElement.classList.add('b-content-element');

              if (containerCls) {
                contentElement.classList.add(containerCls);
              } // Need to check that container has widgets, for example TabPanel can have no tabs


              if (itemCount) {
                for (var i = 0; i < itemCount; i++) {
                  var item = items[i],
                      element = item.element;
                  element.dataset.index = i;

                  if (itemCls) {
                    element.classList.add(itemCls);
                  }

                  if (ownerItemCls) {
                    element.classList.add(ownerItemCls);
                  } // If instantiated by the app developer, external to Container#createWidget
                  // a widget will have the b-outer class. Remove that if it' contained.


                  element.classList.remove('b-outer');
                  item.render(contentElement);
                }
              }
            }
            /**
             * The owning Widget
             * @property {String} owner
             * @readonly
             */

          }], [{
            key: "getLayout",
            value: function getLayout(layout, owner) {
              if (layout instanceof Layout) {
                return layout;
              }

              var isString = typeof layout === 'string',
                  config = {
                owner: owner
              };
              return new (isString ? layoutClasses[layout] : layout)(isString ? config : Object.assign(config, layout));
            }
          }, {
            key: "registerLayout",
            value: function registerLayout(cls) {
              var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : cls.$name.toLowerCase();
              layoutClasses[name] = cls;
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The CSS class which should be added to the owning {@link Common.widget.Container Container}'s
                 * {@link Common.widget.Widget#property-contentElement}.
                 */
                containerCls: null,

                /**
                 * The CSS class which should be added to the encapsulating element of child items.
                 */
                itemCls: null
              };
            }
          }]);

          return Layout;
        }(Object(_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__["default"])(_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"]));

        var layoutClasses = {
          default: Layout
        };
        Layout._$name = 'Layout';
        /***/
      },

      /***/
      "../Grid/lib/Common/widget/mixin/Badge.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Common/widget/mixin/Badge.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibCommonWidgetMixinBadgeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Common/widget/mixin/Badge
         */

        /**
         * Mixin that allows a widget to display a badge (mostly done as css)
         *
         * @example
         * // show badge
         * button.badge = 5;
         *
         * // hide badge
         * button.badge = null;
         *
         * @externalexample widget/Badge.js
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Badge, _ref);

              function Badge() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Badge);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Badge).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Badge, [{
                key: "construct",
                value: function construct(config) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Badge.prototype), "construct", this).call(this, config); // set after we have element to display badge from start


                  if (this._badge) this.badge = this._badge;
                }
                /**
                 * Initial text to show in badge
                 * @config {String} badge
                 */

                /**
                 * Get/sets and display badge, set to null or empty string to hide
                 * @property {String}
                 */

              }, {
                key: "badge",
                set: function set(badge) {
                  var element = this.element;
                  this._badge = badge;

                  if (element) {
                    if (badge != null && badge !== '') {
                      element.dataset.badge = badge;
                      element.classList.add('b-badge');
                    } else {
                      if (element.dataset.badge) delete element.dataset.badge;
                      element.classList.remove('b-badge');
                    }
                  }
                },
                get: function get() {
                  return this._badge;
                } // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {
                  // If we don't have a badge, our classList doesn't include "b-badge"
                  if (this.badge) {
                    return 'b-badge';
                  }
                }
              }]);

              return Badge;
            }(Target || _Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/column/CheckColumn.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Grid/column/CheckColumn.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnCheckColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CheckColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _WidgetColumn_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./WidgetColumn.js */
        "../Grid/lib/Grid/column/WidgetColumn.js");

        var productName = 'scheduler'; //TODO: Reuse checkbox instead of creating a new one

        /**
         * @module Grid/column/CheckColumn
         */

        /**
         * A column that displays a checkbox in the cell. The value of the backing field is toggled by the checkbox.
         *
         * @extends Grid/column/WidgetColumn
         *
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *         { type: 'check', field: 'allow' }
         *     ]
         * });
         *
         * @classType check
         * @externalexample column/CheckColumn.js
         */

        var CheckColumn =
        /*#__PURE__*/
        function (_WidgetColumn) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(CheckColumn, _WidgetColumn);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CheckColumn, null, [{
            key: "type",
            //region Config
            get: function get() {
              return 'check';
            }
          }, {
            key: "fields",
            get: function get() {
              return ['checkCls'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                align: 'center',

                /**
                 * CSS class name to add to checkbox
                 * @config {String}
                 * @category Rendering
                 */
                checkCls: null,
                widgets: [{
                  type: 'checkbox',
                  valueProperty: 'checked'
                }]
              };
            }
          }]);

          function CheckColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, CheckColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(CheckColumn).apply(this, arguments));
            _this.internalCellCls = 'b-check-cell';
            return _this;
          } //endregion
          //region Widget rendering


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(CheckColumn, [{
            key: "onBeforeWidgetCreate",
            value: function onBeforeWidgetCreate(widgetCfg, event) {
              widgetCfg.cls = this.checkCls;
            }
          }, {
            key: "onAfterWidgetCreate",
            value: function onAfterWidgetCreate(widget, event) {
              event.cellElement.widget = widget;
              widget.on({
                beforeChange: 'onBeforeCheckboxChange',
                change: 'onCheckboxChange',
                thisObj: this
              });
            }
          }, {
            key: "onBeforeWidgetSetValue",
            value: function onBeforeWidgetSetValue(widget) {
              widget.record = widget.cellInfo.record;
            } //endregion
            //region Events

          }, {
            key: "onBeforeCheckboxChange",
            value: function onBeforeCheckboxChange(_ref) {
              var source = _ref.source,
                  checked = _ref.checked;
              /**
               * Fired when a cell is clicked to toggle its checked status. Returning `false` will prevent status change.
               * @event beforeToggle
               * @param {Grid.column.Column} source This Column
               * @param {Common.data.Model} record The record for the row containing the cell.
               * @param {Boolean} checked The new checked status of the cell.
               */

              return this.trigger('beforeToggle', {
                record: source.cellInfo.record,
                checked: checked
              });
            }
          }, {
            key: "onCheckboxChange",
            value: function onCheckboxChange(_ref2) {
              var source = _ref2.source,
                  checked = _ref2.checked;
              var record = source.cellInfo.record,
                  field = this.field;

              if (field) {
                var setterName = "set".concat(_Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_5__["default"].capitalizeFirstLetter(field));

                if (record[setterName]) {
                  record[setterName](checked);
                } else {
                  record.set(field, checked);
                }
              }
              /**
               * Fired when a cell is clicked to toggle its checked status.
               * @event toggle
               * @param {Grid.column.Column} source This Column
               * @param {Common.data.Model} record The record for the row containing the cell.
               * @param {Boolean} checked The new checked status of the cell.
               */


              this.trigger('toggle', {
                record: record,
                checked: checked
              });
            } //endregion

          }]);

          return CheckColumn;
        }(_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerColumnType(CheckColumn);

        CheckColumn._$name = 'CheckColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/Column.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Grid/column/Column.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Column;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "../Grid/node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/Column
         */

        /**
         * Base class for other column types, used if no type is specified on a column.
         *
         * ```
         * const grid = new Grid({
         *   columns : [
         *      { field : 'name', text : 'Name' }, // Will use Column
         *      { type : 'number', field : 'age', text : 'Age' } // Will use NumberColumn
         *   ]
         * });
         * ```
         *
         * @extends Common/data/Model
         * @classType column
         * @mixes Common/mixin/Events
         * @mixes Common/localization/Localizable
         */

        var Column =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Column, _Events);

          function Column() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Column);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Column).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Column, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(data, store) {
              var me = this;
              me.masterStore = store; // Store might be an array

              if (store) {
                me._grid = Array.isArray(store) ? store[0].grid : store.grid;
              }

              me.localizableProperties = data.localizableProperties || ['text'];

              if (data.localeClass) {
                me.localeClass = data.localeClass;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Column.prototype), "construct", this).call(this, data, store, null, false);

              me.processConfiguredListeners(data.listeners); // Default value for region is assigned by the ColumnStore in createRecord(), same for `locked`
              // Allow field : null if the column does not rely on a record field.
              // For example the CheckColumn when used by GridSelection.

              if (!('field' in me.data)) {
                me.field = '_' + (me.type || '') + ++Column.emptyCount;
              } // If our field is a dot separated path, we must use ObjectHelper.getPath to extract our value


              me.hasComplexMapping = me.field && me.field.includes('.');

              if (!me.width && !me.flex && !me.children) {
                // Set the width silently because we're in construction.
                me.set({
                  width: Column.defaultWidth,
                  flex: null
                }, null, true);
              }
            }
            /**
             * Extracts the value from the record specified by this Column's {@link #config-field} specification.
             *
             * This will work if the field is a dot-separated path to access fields in associated records, eg
             *
             * ```javascript
             *  field : 'resource.calendar.name'
             * ```
             *
             * **Note:** This is the raw field value, not the value returned by the {@link #config-renderer}.
             * @param {Common.data.Model} record The record from which to extract the field value.
             * @returns {*} The value of the referenced field if any.
             */

          }, {
            key: "getRawValue",
            value: function getRawValue(record) {
              var me = this;

              if (me.hasComplexMapping) {
                return _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].getPath(record, me.field);
              }

              return record[me.field] || record.get(me.field);
            }
          }, {
            key: "hide",
            //endregion
            //region Show/hide

            /**
             * Hides this column.
             */
            value: function hide() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  parent = me.parent; // Reject non-change

              if (!me.hidden) {
                me.hidden = true;

                if (parent && !parent.isRoot) {
                  // check if all sub columns are hidden, if so hide parent
                  var anyVisible = parent.children.some(function (child) {
                    return child.hidden !== true;
                  });

                  if (!anyVisible && !parent.hidden) {
                    silent = true; // hiding parent will trigger event

                    parent.hide();
                  }
                }

                if (me.children) {
                  me.children.forEach(function (child) {
                    return child.hide(true);
                  });
                }

                if (!silent) {
                  me.stores.forEach(function (store) {
                    return store.trigger('hideColumn');
                  });
                }
              }
            }
            /**
             * Shows this column.
             */

          }, {
            key: "show",
            value: function show() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  parent = me.parent; // Reject non-change

              if (me.hidden) {
                me.hidden = false;

                if (parent && parent.hidden) {
                  parent.show();
                }

                if (me.children) {
                  me.children.forEach(function (child) {
                    return child.show(true);
                  });
                } // event is triggered on chained stores


                if (!silent) {
                  me.stores.forEach(function (store) {
                    return store.trigger('showColumn');
                  });
                }
              }
            }
            /**
             * Toggles the column visibility.
             * @param {Boolean} force Set to true (visible) or false (hidden) to force a certain state
             */

          }, {
            key: "toggle",
            value: function toggle() {
              var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              if (this.hidden && force === undefined || force === true) return this.show();
              if (!this.hidden && force === undefined || force === false) return this.hide();
            } //endregion
            //region Index & id

            /**
             * Generates an id for the column when none is set. Generated ids are 'col1', 'col2' and so on. If a field is
             * specified (as it should be in most cases) the field name is used instead: 'name1', 'age2' ...
             * @private
             * @returns {String}
             */

          }, {
            key: "generateId",
            value: function generateId() {
              if (!Column.generatedIdIndex) Column.generatedIdIndex = 0;
              return (this.field ? this.field.replace(/\./g, '-') : 'col') + ++Column.generatedIdIndex;
            }
            /**
             * Index among all flattened columns
             * @property {Number}
             * @readOnly
             * @internal
             */

          }, {
            key: "measureSize",
            // Returns size in pixels for measured value
            value: function measureSize(value) {
              return _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].measureSize(value, this.subGrid ? this.subGrid.element : undefined);
            } // This method is used to calculate minimum row width for edge and safari
            // It calculates minimum width of the row taking column hierarchy into account

          }, {
            key: "calculateMinWidth",
            value: function calculateMinWidth() {
              var me = this,
                  width = me.measureSize(me.width),
                  minWidth = me.measureSize(me.minWidth);
              var minChildWidth = 0;

              if (me.children) {
                minChildWidth = me.children.reduce(function (result, column) {
                  return result + column.calculateMinWidth();
                }, 0);
              }

              return Math.max(width, minWidth, minChildWidth);
            }
            /**
             * Resizes the column to match the widest string in it. By default it also measures the column header, this
             * behaviour can be configured by setting {@link Grid.view.Grid#config-resizeToFitIncludesHeader}.
             *
             * Called internally when you double click the edge between
             * column headers, but can also be called programmatically. For performance reasons it is limited to checking 1000
             * rows surrounding the current viewport.
             */

          }, {
            key: "resizeToFitContent",
            value: function resizeToFitContent() {
              var me = this,
                  grid = me.grid,
                  renderer = me.renderer,
                  defaultRenderer = me.defaultRenderer,
                  element = me.element,
                  rowManager = grid.rowManager,
                  store = grid.store,
                  count = store.count,
                  useRenderer = renderer || defaultRenderer;
              if (count <= 0) return;
              var cellElement = grid.element.querySelector(".b-grid-cell[data-column-id=".concat(me.id, "]")),
                  originalStyle = cellElement.cssText,
                  // Renderer might overwrite
              originalClassName = cellElement.className; // Renderer might overwrite

              var maxWidth = 0,
                  start,
                  end,
                  i,
                  record,
                  value; // Measure header unless configured not to

              if (grid.resizeToFitIncludesHeader) {
                var style = window.getComputedStyle(element); // Header always in view, use its element

                maxWidth = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].measureText(element.innerText, element, false, element.parentElement) + parseInt(style.paddingLeft); // Seems to miss the padding, have not found why
                // Remove measuring element, it messes some styling rules up if left in DOM

                element.parentElement.offScreenDiv.parentElement.remove();
              } // If it's a very large dataset, measure the maxWidth of the field in the 1000 rows
              // surrounding the rendered block.


              if (count > 1000) {
                start = Math.max(Math.min(rowManager.topIndex + rowManager.rowCount / 2 - 500, count - 1000), 0);
                end = start + 1000;
              } else {
                start = 0;
                end = count;
              }

              for (i = start; i < end; i++) {
                record = store.getAt(i);
                value = me.getRawValue(record);

                if (useRenderer) {
                  value = useRenderer.call(me, {
                    cellElement: cellElement,
                    rowElement: cellElement.parentNode,
                    value: value,
                    record: record,
                    column: me,
                    size: {
                      height: record.rowHeight || 0
                    },
                    grid: grid,
                    row: {},
                    updatingSingleRow: false
                  }); // Cell renderer is allowed to direction manipulate the cell element, if so it wont return a value

                  value = value == null ? cellElement.innerHTML : String(value);
                }

                if (value) {
                  // Measure withing the SubGrid, allows more css rules to apply. Not measuring inside rows sine that might get to costly performance wise
                  maxWidth = Math.max(maxWidth, _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].measureText(value, cellElement, !(me.htmlEncode && !me.disableHtmlEncode), me.subGrid.element));
                }
              } // Restore top cell which may be mutated by the repeated call of the renderer.


              cellElement.className = originalClassName;
              cellElement.cssText = originalStyle;
              return me.width = maxWidth;
            } //endregion
            //region State

            /**
             * Get column state, used by State mixin
             * @private
             */

          }, {
            key: "getState",
            value: function getState() {
              var _state; // TODO: exclude those with value = default?


              var me = this,
                  state = (_state = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, me.flex ? 'flex' : 'width', me.flex ? me.flex : me.width), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, "id", me.id), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, "hidden", me.hidden), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, "index", me.allIndex), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, "region", me.region), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, "filterable", me.filterable), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, "text", me.text), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_state, "locked", me.locked), _state);
              if (me.children) state.children = me.children.map(function (child) {
                return child.getState();
              });
              return state;
            }
            /**
             * Apply state to column, used by State mixin
             * @private
             */

          }, {
            key: "applyState",
            value: function applyState(state) {
              var me = this;
              me.beginBatch();

              if ('locked' in state) {
                me.locked = state.locked;
              }

              if ('minWidth' in state) {
                me.minWidth = state.minWidth;
              }

              if ('width' in state) {
                me.width = state.width;
              }

              if ('flex' in state) {
                me.flex = state.flex;
              }

              if ('width' in state && me.flex) {
                me.flex = undefined;
              } else if ('flex' in state && me.width) {
                me.width = undefined;
              }

              if ('text' in state) {
                me.text = state.text;
              }

              if ('region' in state) {
                me.region = state.region;
              }

              if ('renderer' in state) {
                me.renderer = state.renderer;
              }

              if ('filterable' in state) {
                me.filterable = state.filterable;
              }

              me.endBatch();

              if ('hidden' in state) {
                me.toggle(state.hidden !== true);
              }
            } //endregion
            //region Other

            /**
             * Clear cell contents. Base implementation which just sets innerHTML to blank string.
             * Should be overridden in subclasses to clean up for examples widgets.
             * @param {HTMLElement} cellElement
             * @internal
             */

          }, {
            key: "clearCell",
            value: function clearCell(cellElement) {
              cellElement.innerHTML = '';
            }
            /**
             * Override in subclasses to allow/prevent editing of certain rows.
             * @param {Common.data.Model} record
             * @internal
             */

          }, {
            key: "canEdit",
            value: function canEdit(record) {
              return true;
            } //endregion

          }, {
            key: "nextVisibleSibling",
            get: function get() {
              var next = this.nextSibling;

              while (next && next.hidden) {
                next = next.nextSibling;
              }

              return next;
            }
          }, {
            key: "isLast",
            get: function get() {
              return !this.nextVisibleSibling && (!this.parent || this.parent.isLast);
            }
          }, {
            key: "isLastInSubGrid",
            get: function get() {
              return (!this.nextVisibleSibling || this.nextVisibleSibling.region !== this.region) && (!this.parent || this.parent.isLastInSubGrid);
            }
            /**
             * The header element for this Column. *Only available after the grid has been rendered*.
             *
             * **Note that column headers are rerendered upon mutation of Column values, so this
             * value is volatile and should not be cached, but should be read whenever needed.**
             * @property {HTMLElement}
             * @readonly
             */

          }, {
            key: "element",
            get: function get() {
              return this.grid.getHeaderElement(this);
            }
            /**
             * The text wrapping element for this Column. *Only available after the grid has been rendered*.
             *
             * This is the full-width element which *contains* the text-bearing element and any icons.
             *
             * **Note that column headers are rerendered upon mutation of Column values, so this
             * value is volatile and should not be cached, but should be read whenever needed.**
             * @property {HTMLElement}
             * @readonly
             */

          }, {
            key: "textWrapper",
            get: function get() {
              return _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].getChild(this.element, '.b-grid-header-text');
            }
            /**
             * The text containing element for this Column. *Only available after the grid has been rendered*.
             *
             * **Note that column headers are rerendered upon mutation of Column values, so this
             * value is volatile and should not be cached, but should be read whenever needed.**
             * @property {HTMLElement}
             * @readonly
             */

          }, {
            key: "textElement",
            get: function get() {
              return _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].down(this.element, '.b-grid-header-text-content');
            }
            /**
             * The child element into which content should be placed. This means where any
             * contained widgets such as filter input fields should be rendered. *Only available after the grid has been rendered*.
             *
             * **Note that column headers are rerendered upon mutation of Column values, so this
             * value is volatile and should not be cached, but should be read whenever needed.**
             * @property {HTMLElement}
             * @readonly
             */

          }, {
            key: "contentElement",
            get: function get() {
              return _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].down(this.element, '.b-grid-header-children');
            }
            /**
             * The Field to use as editor for this column
             * @private
             * @readonly
             */

          }, {
            key: "editor",
            get: function get() {
              var editor = this.data.editor;

              if (editor && !(editor instanceof _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_16__["default"])) {
                if (typeof editor === 'string') {
                  editor = {
                    type: editor
                  };
                }

                editor = this.data.editor = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createWidget(Object.assign(this.defaultEditor, editor));
              }

              return editor;
            },
            set: function set(editor) {
              this.data.editor = editor;
            }
            /**
             * A config object specifying the editor to use to edit this column.
             * @private
             * @readonly
             */

          }, {
            key: "defaultEditor",
            get: function get() {
              return {
                type: 'textfield',
                name: this.field
              };
            }
            /**
             * Default settings for the column, applied in constructor. None by default, override in subclass.
             * @member {Object} defaults
             * @returns {Object}
             * @readonly
             */
            //get defaults() {
            //    return {};
            //}
            //endregion
            //region Properties

          }, {
            key: "grid",
            get: function get() {
              return this._grid || this.parent && this.parent.grid;
            }
          }, {
            key: "locked",
            get: function get() {
              return this.data.region === 'locked';
            },
            set: function set(locked) {
              this.region = locked ? 'locked' : 'normal';
            } // parent headers cannot be sorted by

          }, {
            key: "sortable",
            get: function get() {
              return this.isLeaf && this.data.sortable;
            },
            set: function set(sortable) {
              this.set('sortable', sortable);
            } // parent headers cannot be grouped by

          }, {
            key: "groupable",
            get: function get() {
              return this.isLeaf && this.data.groupable;
            },
            set: function set(groupable) {
              this.set('groupable', groupable);
            }
          }, {
            key: "allIndex",
            get: function get() {
              return this.masterStore.indexOf(this);
            } //endregion
            //region Width

            /**
             * Get/set columns width in px. If column uses flex, width will be undefined.
             * Setting a width on a flex column cancels out flex.
             *
             * **NOTE:** Grid might be configured to always stretch the last column, in which case the columns actual width
             * might deviate from the configured width.
             *
             * ```javascript
             * let grid = new Grid({
             *     appendTo : 'container',
             *     height   : 200,
             *     width    : 400,
             *     columns  : [{
             *         text  : 'First column',
             *         width : 100
             *     }, {
             *         text  : 'Last column',
             *         width : 100 // last column in the grid is always stretched to fill the free space
             *     }]
             * });
             *
             * grid.columns.last.element.offsetWidth; // 300 -> this points to the real element width
             * ```
             * @property {Number|String}
             */

          }, {
            key: "width",
            get: function get() {
              return this.data.width;
            },
            set: function set(width) {
              var data = {
                width: width
              };

              if (width) {
                data.flex = null; // remove flex when setting width to enable resizing flex columns
              }

              this.set(data);
            } //Returns subGrid for the column

          }, {
            key: "subGrid",
            get: function get() {
              return this.grid ? this.grid.getSubGridFromColumn(this) : undefined;
            }
          }], [{
            key: "fields",
            //region Config
            get: function get() {
              return [//region Common

              /**
               * Get/set header text
               * @member {String} text
               */

              /**
               * Text to display in the header
               * @config {String} text
               * @category Common
               */
              'text',
              /**
               * The {@link Common.data.Model Model} field name to read data from
               * @config {String} field
               * @category Common
               */
              'field',
              /**
               * Renderer function, used to format and style the content displayed in the cell. Return the cell text you want to display.
               * Can also affect other aspects of the cell, such as styling.
               * @param {HTMLElement} cellElement Cell element, for adding CSS classes, styling etc
               * @param {*} value Value to be displayed in the cell
               * @param {Common.data.Model} record Record for the row
               * @param {Grid.column.Column} column This column
               * @param {Grid.view.Grid} grid This grid
               * @param {Grid.row.Row} row Row object
               * @param {Object} size Set `size.height` to specify the desired row height for the current row. Largest specified height will be used, including the configured {@link Grid/view/Grid#config-rowHeight}
               * @config {Function} renderer
               * @category Common
               */
              'renderer',
              /**
               * Column width. If value is Number then width is in pixels
               * @config {Number|String} width
               * @category Common
               */
              'width',
              /**
               * Gets or sets the column flex weight
               * @member {String} flex
               */

              /**
               * Column width as a flex weight. All columns with flex specified divide the available space (after
               * subtracting fixed widths) between them according to the flex value. Columns that have flex 2 will be
               * twice as wide as those with flex 1 (and so on)
               * @config {Number} flex
               * @category Common
               */
              'flex', //endregion
              //region Interaction

              /**
               * Specifies if this column should be editable, and define which editor to use for editing cells in the
               * column (if {@link Grid/feature/CellEdit CellEdit} feature is enabled). Editor refers to {@link #config-field} for a data source. If
               * record has method set + capitalized field, method will be called, e.g. if record has method named
               * `setFoobar` and this config is `foobar`, then instead of `record.foobar = value`,
               * `record.setFoobar(value)` will be called.
               * @config {String|Object|Boolean} editor
               * @category Interaction
               */
              {
                name: 'editor',
                defaultValue: {}
              },
              /**
               * Allow sorting of data in the column. You can pass true/false to enable/disable sorting, or provide a
               * custom sorting function, or a config object for a {@link Common.util.CollectionSorter}
               *
               * ```javascript
               * const grid = new Grid({
               *     columns : [
               *          {
               *              // Disable sorting for this column
               *              sortable : false
               *          },
               *          {
               *              // Custom sorting for this column
               *              sortable : function(user1, user2) {
               *                  return user1.name < user2.name ? -1 : 1;
               *              }
               *          },
               *          {
               *              // A config object for a Common.util.CollectionSorter
               *              sortable : {
               *                  property         : 'someField',
               *                  direction        : 'DESC',
               *                  useLocaleCompare : 'sv-SE'
               *              }
               *          }
               *     ]
               * });
               * ```
               *
               * @config {Boolean/Function/Object} sortable
               * @default true
               * @category Interaction
               */
              {
                name: 'sortable',
                defaultValue: true
              },
              /**
               * Allow searching in the column (respected by QuickFind and Search features)
               * @config {Boolean} searchable
               * @default true
               * @category Interaction
               */
              {
                name: 'searchable',
                defaultValue: true
              },
              /**
               * Allow filtering data in the column (if Filter or FilterBar feature is enabled). Also allows passing a
               * custom filtering function that will be called for each record with a single argument of format
               * { value, record, [operator] }. Returning `true` from the function includes the record in the filtered set.
               *
               * ```
               * const grid = new Grid({
               *     columns : [
               *          {
               *              field : 'name',
               *              // Disable filtering for this column
               *              filterable : false
               *          },
               *          {
               *              field : 'age',
               *              // Custom filtering for this column
               *              filterable: ({ value, record }) => Math.abs(record.age - value) < 10
               *          }
               *     ]
               * });
               * ```
               *
               * @config {Boolean/Function} filterable
               * @default true
               * @category Interaction
               */
              {
                name: 'filterable',
                defaultValue: true
              },
              /**
               * Allow column visibility to be toggled through UI
               * @config {Boolean} hideable
               * @default true
               * @category Interaction
               */
              {
                name: 'hideable',
                defaultValue: true
              },
              /**
               * Set to false to prevent this column header from being dragged
               * @config {Boolean} draggable
               * @category Interaction
               */
              {
                name: 'draggable',
                defaultValue: true
              },
              /**
               * Set to false to prevent grouping by this column
               * @config {Boolean} groupable
               * @category Interaction
               */
              {
                name: 'groupable',
                defaultValue: true
              },
              /**
               * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
               * @config {Boolean} resizable
               * @default true
               * @category Interaction
               */
              {
                name: 'resizable',
                defaultValue: true
              }, //endregion
              //region Rendering

              /**
               * Renderer function for group headers (when using Group feature).
               * @param {HTMLElement} cellElement Cell element, for adding CSS classes, styling etc.
               * @param {*} groupRowFor Current group value
               * @param {Common.data.Model} record Record for the row
               * @param {Grid.column.Column} groupColumn Column that the grid is grouped by
               * @config {Function} groupRenderer
               * @returns {String} The header grouping text
               * @category Rendering
               */
              'groupRenderer',
              /**
               * Renderer function for the column header.
               * @param {Object} renderData
               * @param {Grid.column.Column} renderData.column This column
               * @param {HTMLElement} renderData.headerElement The header element
               * @config {Function} headerRenderer
               * @category Rendering
               */
              'headerRenderer',
              /**
               * Renderer function for cell tooltips header (used with CellTooltip feature). Specify false to prevent
               * tooltip for that column.
               * @param {HTMLElement} cellElement Cell element
               * @param {Common.data.Model} record Record for cell row
               * @param {Grid.column.Column} column Cell column
               * @param {CellTooltip} cellTooltip Feature instance, used to set tooltip content async
               * @param {MouseEvent} event The event that triggered the tooltip
               * @config {Function} tooltipRenderer
               * @category Rendering
               */
              'tooltipRenderer',
              /**
               * CSS class added to each cell in this column
               * @config {String} cellCls
               * @category Rendering
               */
              'cellCls',
              /**
               * CSS class added to the header of this column
               * @config {String} cls
               * @category Rendering
               */
              'cls',
              /**
               * Get/set header icon class
               * @member {String} icon
               */

              /**
               * Icon to display in header. Specifying an icon will render a `<i>` element with the icon as value for the
               * class attribute
               * @config {String} icon
               * @category Rendering
               */
              'icon', //endregion
              //region Layout

              /**
               * Text align (left, center, right)
               * @config {String} align
               * @category Layout
               */
              'align',
              /**
               * Column minimal width. If value is Number then minimal width is in pixels
               * @config {Number|String} minWidth
               * @default 60
               * @category Layout
               */
              {
                name: 'minWidth',
                defaultValue: 60
              },
              /**
               * Get/set columns hidden state. Specify `true` to hide the column, `false` to show it.
               * @member {Boolean} hidden
               */

              /**
               * Hide the column from start
               * @config {Boolean} hidden
               * @category Layout
               */
              {
                name: 'hidden',
                defaultValue: false
              },
              /**
               * Convenient way of putting a column in the "locked" region. Same effect as specifying region: 'locked'.
               * If you have defined your own regions (using {@link Grid.view.Grid#config-subGridConfigs}) you should use
               * {@link #config-region} instead of this one.
               * @config {Boolean} locked
               * @default false
               * @category Layout
               */
              {
                name: 'locked'
              },
              /**
               * Region (part of the grid, it can be configured with multiple) where to display the column. Defaults to
               * {@link Grid.view.Grid#config-defaultRegion}.
               * @config {String} region
               * @category Layout
               */
              {
                name: 'region'
              }, //endregion
              // region Menu

              /**
               * Show column picker for the column
               * @config {Boolean} showColumnPicker
               * @default true
               * @category Menu
               */
              {
                name: 'showColumnPicker',
                defaultValue: true
              },
              /**
               * false to prevent showing a context menu on the column header element
               * @config {Boolean} enableHeaderContextMenu
               * @default true
               * @category Menu
               */
              {
                name: 'enableHeaderContextMenu',
                defaultValue: true
              },
              /**
               * false to prevent showing a context menu on the cell elements in this column
               * @config {Boolean} enableCellContextMenu
               * @default true
               * @category Menu
               */
              {
                name: 'enableCellContextMenu',
                defaultValue: true
              },
              /**
               * Extra items to show in the header context menu for this column
               * @config {Object[]} headerMenuItems
               * @category Menu
               */
              'headerMenuItems',
              /**
               * Extra items to show in the cell context menu for this column
               * @config {Object[]} cellMenuItems
               * @category Menu
               */
              'cellMenuItems', //endregion
              //region Summary

              /**
               * Summary type (when using Summary feature). Valid types are:
               * <dl class="wide">
               * <dt>sum <dd>Sum of all values in the column
               * <dt>add <dd>Alias for sum
               * <dt>count <dd>Number of rows
               * <dt>countNotEmpty <dd>Number of rows containing a value
               * <dt>average <dd>Average of all values in the column
               * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
               * </dl>
               * @config {String} sum
               * @category Summary
               */
              'sum',
              /**
               * Summary configs, use if you need multiple summaries per column. Replaces {@link #config-sum} and
               * {@link #config-summaryRenderer} configs. Accepts an array of objects with the following fields:
               * * sum - Matching {@link #config-sum}
               * * renderer - Matching {@link #config-summaryRenderer}
               * * seed - Initial value when using a function as `sum`
               * @config {Object[]} summaries
               * @category Summary
               */
              'summaries',
              /**
               * Renderer function for summary (when using Summary feature). The renderer is called with the calculated
               * summary as only argument.
               * @config {Function} summaryRenderer
               * @category Summary
               */
              'summaryRenderer', //region Misc

              /**
               * Column settings at different responsive levels, see responsive demo under examples/
               * @config {Object} responsiveLevels
               * @category Misc
               */
              'responsiveLevels',
              /**
               * Tags, may be used by ColumnPicker feature for grouping columns by tag in the menu
               * @config {String[]} tags
               * @category Misc
               */
              'tags',
              /**
               * Column config to apply to normal config if viewed on a touch device
               * @config {Object} touchConfig
               * @category Misc
               */
              'touchConfig',
              /**
               * When using the tree feature, exactly one column should specify { tree: true }
               * @config {Boolean} tree
               * @category Misc
               */
              'tree',
              /**
               * Determines which type of filtering to use for the column. Usually determined by the column type used,
               * but may be overridden by setting this field.
               * @config {String} filterType
               * @category Misc
               */
              'filterType',
              /**
               * By default, any rendered column text content is HTML-encoded. Set this flag to `false` disable this and allow rendering html elements
               * @config {Boolean} htmlEncode
               * @default true
               * @category Misc
               */
              {
                name: 'htmlEncode',
                defaultValue: true
              },
              /**
               * Set to `true`to automatically call DomHelper.sync for html returned from a renderer. Should in most cases
               * be more performant than replacing entire innerHTML of cell and also allows CSS transitions to work. Has
               * no effect unless `htmlEncode` is enabled. Returned html must contain a single root element (that can have
               * multiple children). See PercentColumn for example usage.
               * @config {Boolean} autoSyncHtml
               * @default false
               * @category Misc
               */
              {
                name: 'autoSyncHtml',
                defaultValue: false
              }, 'type',
              /**
               * Set to `true` to have the {@link Grid.feature.CellEdit CellEdit} feature update the record being
               * edited live upon field edit instead of when editing is finished by using `TAB` or `ENTER`
               */
              {
                name: 'instantUpdate',
                defaultValue: false
              }, {
                name: 'repaintOnResize',
                defaultValue: false
              },
              /**
              * An optional query selector to select a sub element within the cell being
              * edited to align a cell editor's `X` position and `width` to.
              * @config {String} editTargetSelector
              */
              'editTargetSelector' //endregion
              ];
            } // prevent undefined fields from being exposed, to simplify spotting errors

          }, {
            key: "autoExposeFields",
            get: function get() {
              return false;
            }
          }, {
            key: "type",
            get: function get() {
              return 'column';
            }
          }, {
            key: "text",
            get: function get() {
              return this.defaultValues.text;
            }
          }]);

          return Column;
        }(Object(_Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_15__["default"])(Object(_Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_13__["default"])(_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_12__["default"]))); // Registered in ColumnStore as we can't have this in Column due to circular dependencies
        // ColumnStore.registerColumnType(Column);


        Column.emptyCount = 0;
        Column.defaultWidth = 100;
        Column.exposeProperties();
        Column._$name = 'Column';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/DateColumn.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Grid/column/DateColumn.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnDateColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DateColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/DateColumn
         */

        /**
         * A column that displays a date in the specified format (see {@link Common.helper.DateHelper#function-format-static} for formatting options),
         * with a date picker as default editor.
         *
         * @extends Grid/column/Column
         *
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *          { type: 'date', text: 'Start date', format: 'YYYY-MM-DD', data: 'start' }
         *     ]
         * });
         *
         * @classType date
         * @externalexample column/DateColumn.js
         */

        var DateColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(DateColumn, _Column);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(DateColumn, null, [{
            key: "type",
            //region Config
            get: function get() {
              return 'date';
            }
          }, {
            key: "fields",
            get: function get() {
              return ['format', 'pickerFormat', 'step'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                /**
                 * Date format
                 * @config {String}
                 * @category Common
                 */
                format: 'L',

                /**
                 * Date format used for date picker
                 * @config {String}
                 * @category Common
                 */
                pickerFormat: null,

                /**
                 * Time increment duration value. See {@link Common.widget.DateField#config-step} for more information
                 * @config {String|Number|Object}
                 * @category Common
                 */
                step: 1,
                minWidth: 85,
                filterType: 'date'
              };
            } //endregion
            //region Init

          }]);

          function DateColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, DateColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(DateColumn).apply(this, arguments));
            _this.internalCellCls = 'b-date-cell';
            return _this;
          } //endregion
          //region Display

          /**
           * Renderer that displays the date with the specified format. Also adds cls 'date-cell' to the cell.
           * @private
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(DateColumn, [{
            key: "defaultRenderer",
            value: function defaultRenderer(_ref) {
              var value = _ref.value;
              return value ? this.formatValue(value) : '';
            }
            /**
             * Group renderer that displays the date with the specified format.
             * @private
             */

          }, {
            key: "groupRenderer",
            value: function groupRenderer(_ref2) {
              var cellElement = _ref2.cellElement,
                  groupRowFor = _ref2.groupRowFor;
              cellElement.innerHTML = this.formatValue(groupRowFor);
            } //endregion
            //region Formatter

            /**
             * Used by both renderer and groupRenderer to do the actual formatting of the date
             * @private
             * @param value
             * @returns {String}
             */

          }, {
            key: "formatValue",
            value: function formatValue(value) {
              // Ideally we should be served a date, but if not make it easier for the user by parsing
              if (typeof value === 'string') {
                value = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].parse(value, this.format);
              }

              return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].format(value, this.format);
            } //endregion
            //region Getters/setters

            /**
             * Get/Set format for date displayed in cell and editor (see {@link Common.helper.DateHelper#function-format-static} for formatting options)
             * @property {String}
             */

          }, {
            key: "format",
            set: function set(value) {
              var me = this,
                  editor = me.editor;
              me.set('format', value);

              if (editor) {
                editor.format = me.format;
              }
            },
            get: function get() {
              return this.get('format');
            }
          }, {
            key: "defaultEditor",
            get: function get() {
              var me = this;
              return {
                name: me.field,
                type: 'date',
                calendarContainerCls: 'b-grid-cell-editor-related',
                format: me.format,
                pickerFormat: me.pickerFormat || me.format,
                step: me.step
              };
            } //endregion

          }]);

          return DateColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerColumnType(DateColumn);

        DateColumn.exposeProperties();
        DateColumn._$name = 'DateColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/NumberColumn.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Grid/column/NumberColumn.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnNumberColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return NumberColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/NumberColumn
         */

        /**
         * A column for showing/editing numbers
         *
         * @extends Grid/column/Column
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *         { type: 'number', min: 0, max : 100, field: 'score' }
         *     ]
         * });
         *
         * @classType number
         * @externalexample column/NumberColumn.js
         */

        var NumberColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(NumberColumn, _Column);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(NumberColumn, null, [{
            key: "type",
            //region Config
            get: function get() {
              return 'number';
            }
          }, {
            key: "fields",
            get: function get() {
              return [
              /**
               * The minimum value for the field used during editing.
               * @config {Number} min
               * @category Common
               */
              'min',
              /**
               * The maximum value for the field used during editing.
               * @config {Number} max
               * @category Common
               */
              'max',
              /**
               * Step size for the field used during editing. Specify a fractional step size to allow entering decimal
               * numbers.
               * @config {Number} step
               * @category Common
               */
              'step',
              /**
               * Unit to append to displayed value.
               * @config {String} unit
               * @category Common
               */
              'unit'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                filterType: 'number'
              };
            }
          }]);

          function NumberColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, NumberColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(NumberColumn).apply(this, arguments));
            _this.internalCellCls = 'b-number-cell';
            return _this;
          } //endregion
          //region Init


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(NumberColumn, [{
            key: "defaultRenderer",

            /**
             * Renderer that displays value + optional unit in the cell
             * @private
             */
            value: function defaultRenderer(_ref) {
              var _ref$value = _ref.value,
                  value = _ref$value === void 0 ? 0 : _ref$value;

              if (this.unit) {
                return "".concat(value).concat(this.unit);
              }

              return value;
            }
          }, {
            key: "defaultEditor",
            get: function get() {
              return {
                name: this.field,
                type: 'numberfield',
                max: this.max,
                min: this.min,
                step: this.step
              };
            }
          }]);

          return NumberColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerColumnType(NumberColumn);

        NumberColumn.exposeProperties();
        NumberColumn._$name = 'NumberColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/PercentColumn.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Grid/column/PercentColumn.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnPercentColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return PercentColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/PercentColumn
         */

        /**
         * A column that display a basic progress bar
         *
         * @extends Grid/column/Column
         *
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *         { type: 'percent', text: 'Progress', data: 'progress' }
         *     ]
         * });
         *
         * @classType percent
         * @externalexample column/PercentColumn.js
         */

        var PercentColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(PercentColumn, _Column);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PercentColumn, null, [{
            key: "type",
            get: function get() {
              return 'percent';
            }
          }, {
            key: "fields",
            get: function get() {
              return ['lowThreshold'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                /**
                 * PercentColumn uses a {@link Common.widget.NumberField} configured with an allowed interval 0 - 100 as
                 * its default editor.
                 * @config {Object|String}
                 * @default Common.widget.NumberField
                 * @category Misc
                 */
                editor: {
                  type: 'number',
                  min: 0,
                  max: 100
                },

                /**
                 * When below this percentage the bar will have `b-low` CSS class added. By default it turns the bar red.
                 * @config {Number}
                 * @category Rendering
                 */
                lowThreshold: 20,
                filterType: 'number',
                htmlEncode: false,
                searchable: false,
                summaryRenderer: function summaryRenderer(sum) {
                  return "".concat(sum, "%");
                }
              };
            }
          }]);

          function PercentColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, PercentColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(PercentColumn).apply(this, arguments));
            _this.internalCellCls = 'b-percent-bar-cell';
            return _this;
          }
          /**
           * Renderer that displays a progress bar in the cell.
           * @private
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(PercentColumn, [{
            key: "renderer",
            value: function renderer(_ref) {
              var value = _ref.value,
                  cellElement = _ref.cellElement;
              value = value || 0;

              if (!cellElement.percentBarElement) {
                cellElement.percentBarElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].createElement({
                  tag: 'div',
                  className: 'b-percent-bar-outer',
                  parent: cellElement,
                  children: [{
                    tag: 'div',
                    className: 'b-percent-bar',
                    html: '%'
                  }]
                }, true)[1];
              }

              var percentBarElement = cellElement.percentBarElement;
              percentBarElement.classList[value === 0 ? 'add' : 'remove']('b-zero');
              percentBarElement.classList[value < this.lowThreshold ? 'add' : 'remove']('b-low');
              percentBarElement.style.width = value + '%';
              percentBarElement.firstChild.data = value + '%';
            } // Overrides base implementation to cleanup the checkbox, for example when a cell is reused as part of group header

          }, {
            key: "clearCell",
            value: function clearCell(cellElement) {
              if (cellElement.percentBarElement) {
                cellElement.percentBarElement = null;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(PercentColumn.prototype), "clearCell", this).call(this, cellElement);
            } // Null implementation because the column width drives the width of its content.
            // So the concept of sizing to content is invalid here.

          }, {
            key: "resizeToFitContent",
            value: function resizeToFitContent() {}
          }]);

          return PercentColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        PercentColumn.sum = 'average';

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerColumnType(PercentColumn);

        PercentColumn._$name = 'PercentColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/RatingColumn.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Grid/column/RatingColumn.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnRatingColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RatingColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _NumberColumn_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./NumberColumn.js */
        "../Grid/lib/Grid/column/NumberColumn.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");

        var productName = 'scheduler'; // TODO: resuse icon elements

        /**
         * @module Grid/column/RatingColumn
         */

        /**
         * A column that displays a star rating. Click a start to set a value, shift+click to unset a single start from the end.
         * Clicking the first and only star toggles it.
         *
         * @extends Grid/column/NumberColumn
         *
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *         { type: 'rating', max : 10, field: 'rating' }
         *     ]
         * });
         *
         * @classType percent
         * @externalexample column/RatingColumn.js
         */

        var RatingColumn =
        /*#__PURE__*/
        function (_NumberColumn) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(RatingColumn, _NumberColumn);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(RatingColumn, null, [{
            key: "type",
            get: function get() {
              return 'rating';
            }
          }, {
            key: "fields",
            get: function get() {
              return ['emptyIcon', 'filledIcon', 'editable'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                min: 0,
                max: 5,

                /**
                 * The empty rating icon to show
                 * @config {String}
                 * @category Rendering
                 */
                emptyIcon: 'b-icon b-icon-star',

                /**
                 * The filled rating icon to show
                 * @config {String}
                 * @category Rendering
                 */
                filledIcon: 'b-icon b-icon-star',

                /**
                 * Allow user to click an icon to change the value
                 * @config {Boolean}
                 * @category Interaction
                 */
                editable: true,
                filterType: 'number',
                searchable: false,
                width: '11.2em',
                htmlEncode: false,
                autoSyncHtml: true,
                minWidth: '11.2em',
                editor: false
              };
            }
          }]);

          function RatingColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RatingColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(RatingColumn).apply(this, arguments));
            _this.internalCellCls = 'b-rating-cell';
            return _this;
          }
          /**
           * Renderer that displays a number of stars in the cell. Also adds CSS class 'b-rating-cell' to the cell.
           * @private
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(RatingColumn, [{
            key: "renderer",
            value: function renderer(_ref) {
              var value = _ref.value;
              var html = "<div class=\"b-rating-cell-inner ".concat(!this.editable ? 'b-not-editable' : '', "\">");

              for (var i = 0; i < this.max; i++) {
                var filled = i < value;
                html += "<i class=\"b-rating-icon ".concat(filled ? 'b-filled ' + this.filledIcon : 'b-empty ' + this.emptyIcon, "\"></i>");
              }

              html += '</div>';
              return html;
            }
          }, {
            key: "onCellClick",
            value: function onCellClick(_ref2) {
              var grid = _ref2.grid,
                  column = _ref2.column,
                  record = _ref2.record,
                  cellSelector = _ref2.cellSelector,
                  target = _ref2.target,
                  event = _ref2.event;

              if (target.classList.contains('b-rating-icon') && !grid.readOnly && column.editable) {
                var starIndex = [].indexOf.call(target.parentNode.childNodes, target);

                if (target.classList.contains('b-filled') && (event.metaKey || event.shiftKey)) {
                  starIndex = starIndex - 1;
                } // Clicking first star when it is only one removes it


                if (record.get(column.field) === 1 && starIndex === 0) {
                  starIndex = -1;
                }

                record.set(column.field, starIndex + 1);
              }
            }
          }]);

          return RatingColumn;
        }(_NumberColumn_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerColumnType(RatingColumn);

        RatingColumn.exposeProperties();
        RatingColumn._$name = 'RatingColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/RowNumberColumn.js":
      /*!**************************************************!*\
        !*** ../Grid/lib/Grid/column/RowNumberColumn.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnRowNumberColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RowNumberColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/RowNumberColumn
         */

        /**
         * A column that displays the row number in each cell
         *
         * @extends Grid/column/Column
         *
         * @example
         * let grid = new Grid({
            appendTo : targetElement,
            width    : 300,
            columns  : [
                { type : 'rownumber' }
            ]
        });
         *
         * @classType rownumber
         * @externalexample column/RowNumberColumn.js
         */

        var RowNumberColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RowNumberColumn, _Column);

          function RowNumberColumn() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RowNumberColumn);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RowNumberColumn).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(RowNumberColumn, [{
            key: "construct",
            value: function construct(config, store) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RowNumberColumn.prototype), "construct", this).apply(this, arguments); // Update our width when the store mutates (tests test Columns in isolation with no grid, so we must handle that!)


              if (me.grid) {
                me.grid.store.on({
                  change: me.resizeToFitContent,
                  thisObj: me
                });

                if (me.grid.store.count) {
                  me.grid.on({
                    render: me.resizeToFitContent,
                    thisObj: me,
                    once: true
                  });
                }
              }

              me.internalCellCls = 'b-row-number-cell';
            }
          }, {
            key: "renderer",

            /**
             * Renderer that displays the row number in the cell.
             * @private
             */
            value: function renderer(_ref) {
              var record = _ref.record,
                  grid = _ref.grid;
              return record.meta.specialRow ? '' : grid.store.indexOf(record, true) + 1;
            }
            /**
             * Resizes the column to match the widest string in it. Called when you double click the edge between column
             * headers
             */

          }, {
            key: "resizeToFitContent",
            value: function resizeToFitContent() {
              var grid = this.grid,
                  store = grid.store,
                  count = store.count;

              if (count && !this.hidden) {
                var cellElement = grid.element.querySelector(".b-grid-cell[data-column-id=".concat(this.id, "]")); // cellElement might not exist, e.g. when trial is expired

                if (cellElement) {
                  var cellStyle = window.getComputedStyle(cellElement),
                      cellPadding = parseInt(cellStyle['padding-left']),
                      maxWidth = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].measureText(count, cellElement);

                  this.width = maxWidth + 2 * cellPadding;
                }
              }
            }
          }, {
            key: "flex",
            set: function set(f) {}
          }], [{
            key: "defaults",
            get: function get() {
              return {
                groupable: false,
                sortable: false,
                filterable: false,
                searchable: false,
                resizable: false,
                minWidth: 50,
                width: 50,
                align: 'right',
                text: '#',
                editor: false
              };
            }
          }, {
            key: "type",
            get: function get() {
              return 'rownumber';
            }
          }]);

          return RowNumberColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerColumnType(RowNumberColumn);

        RowNumberColumn._$name = 'RowNumberColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/TemplateColumn.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Grid/column/TemplateColumn.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnTemplateColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TemplateColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/assertThisInitialized */
        "../Grid/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/TemplateColumn
         */

        /**
         * A column that uses a template for cell content. Any function can be used as template, and the function is passed { value, record, field } properties.
         * It should return a string which will be rendered in the cell
         *
         * @extends Grid/column/Column
         *
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *         { type: 'template', field: 'age', template: value => `${value} years old` }
         *     ]
         * });
         *
         * @classType template
         * @externalexample column/TemplateColumn.js
         */

        var TemplateColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(TemplateColumn, _Column);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TemplateColumn, null, [{
            key: "fields",
            get: function get() {
              return [
              /**
               * Template function used to generate a value displayed in the cell. Called with arguments { value, record, field }
               * @config {Function} template
               * @category Common
               */
              'template'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                htmlEncode: false
              };
            }
          }]);

          function TemplateColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TemplateColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(TemplateColumn).apply(this, arguments));

            var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this));

            if (!me.template) throw new Error(me.L('noTemplate'));
            if (typeof me.template !== 'function') throw new Error(me.L('noFunction'));
            return _this;
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TemplateColumn, [{
            key: "renderer",

            /**
             * Renderer that uses a template for cell content.
             * @private
             */
            value: function renderer(renderData) {
              // If it's a special row, such as a group row, we can't use the user's template
              if (!renderData.record.meta.specialRow) {
                return this.template({
                  value: renderData.value,
                  record: renderData.record,
                  field: renderData.column.field
                });
              }
            }
          }], [{
            key: "type",
            get: function get() {
              return 'template';
            }
          }]);

          return TemplateColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerColumnType(TemplateColumn);

        TemplateColumn.exposeProperties();
        TemplateColumn._$name = 'TemplateColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/TimeColumn.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Grid/column/TimeColumn.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnTimeColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/TimeColumn
         */

        /**
         * A column that displays a time in the specified format (see {@link Common.helper.DateHelper#function-format-static} for formatting options),
         * with a time picker as default editor.
         *
         * @extends Grid/column/Column
         *
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *          { type: 'time', text: 'Start time', format: 'HH:mm:ss', data: 'start' }
         *     ]
         * });
         *
         * @classType time
         * @externalexample column/TimeColumn.js
         */

        var TimeColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(TimeColumn, _Column);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TimeColumn, null, [{
            key: "type",
            //region Config
            get: function get() {
              return 'time';
            }
          }, {
            key: "fields",
            get: function get() {
              return ['format'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                /**
                 * Time format
                 * @config {String}
                 * @category Common
                 */
                format: 'LT',
                minWidth: 140,
                filterType: 'time'
              };
            } //endregion
            //region Init

          }]);

          function TimeColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TimeColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(TimeColumn).apply(this, arguments));
            _this.internalCellCls = 'b-time-cell';
            return _this;
          } //endregion
          //region Display

          /**
           * Renderer that displays the time with the specified format. Also adds cls 'b-time-cell' to the cell.
           * @private
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TimeColumn, [{
            key: "defaultRenderer",
            value: function defaultRenderer(_ref) {
              var value = _ref.value;
              return value ? this.formatValue(value) : '';
            }
            /**
             * Group renderer that displays the time with the specified format.
             * @private
             */

          }, {
            key: "groupRenderer",
            value: function groupRenderer(_ref2) {
              var cellElement = _ref2.cellElement,
                  groupRowFor = _ref2.groupRowFor;
              cellElement.innerHTML = this.formatValue(groupRowFor);
            } //endregion
            //region Formatter

            /**
             * Used by both renderer and groupRenderer to do the actual formatting of the time
             * @private
             * @param value
             * @returns {String}
             */

          }, {
            key: "formatValue",
            value: function formatValue(value) {
              var me = this; // Ideally we should be served a time, but if not make it easier for the user by parsing

              if (typeof value === 'string') {
                value = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].parse(value, me.format);
              }

              return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].format(value, me.format);
            } //endregion
            //region Getters/Setters

            /**
             * Get/Set format for time displayed in cell and editor (see {@link Common.helper.DateHelper#function-format-static} for formatting options)
             * @property {String}
             */

          }, {
            key: "format",
            set: function set(value) {
              var me = this,
                  editor = me.editor;
              me.set('format', value);

              if (editor) {
                editor.format = me.format;
              }
            },
            get: function get() {
              return this.get('format');
            }
          }, {
            key: "defaultEditor",
            get: function get() {
              return {
                name: this.field,
                type: 'time',
                format: this.format
              };
            } //endregion

          }]);

          return TimeColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerColumnType(TimeColumn);

        TimeColumn.exposeProperties();
        TimeColumn._$name = 'TimeColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/TreeColumn.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Grid/column/TreeColumn.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnTreeColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TreeColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/assertThisInitialized */
        "../Grid/node_modules/@babel/runtime/helpers/assertThisInitialized.js");
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");

        var productName = 'scheduler';
        /**
         * @module Grid/column/TreeColumn
         */

        var currentParentHasIcon = false;
        /**
         * A column that displays a tree structure when using the {@link Grid.feature.Tree tree} feature.
         *
         * When the TreeColumn renders its cells, it will look for two special fields {@link Grid.data.GridRowModel#field-href} and {@link Grid.data.GridRowModel#field-target}. Specifying `href` will produce a link for the TreeNode, and `target` will
         * have the same meaning as in an A tag:
         *
         * ```javascript
         * {
         *    id        : 1,
         *    name      : 'Some external link'
         *    href      : '//www.website.com",
         *    target    : '_blank"
         * }
         * ```
         *
         * @example
         * new TreeGrid({
         *     appendTo : document.body,
         *
         *     columns : [
         *          { type: 'tree', field: 'name' }
         *     ]
         * });
         *
         * @classType tree
         * @extends Grid/column/Column
         * @externalexample column/TreeColumn.js
         */

        var TreeColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(TreeColumn, _Column);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TreeColumn, null, [{
            key: "defaults",
            get: function get() {
              return {
                tree: true,
                hideable: false,
                minWidth: 150
              };
            }
          }, {
            key: "fields",
            get: function get() {
              return [
              /**
               * The icon to use for the collapse icon in collapsed state
               * @config {String} expandIconCls
               */
              {
                name: 'expandIconCls',
                defaultValue: 'b-icon b-icon-tree-expand'
              },
              /**
               * The icon to use for the collapse icon in expanded state
               * @config {String} collapseIconCls
               */
              {
                name: 'collapseIconCls',
                defaultValue: 'b-icon b-icon-tree-collapse'
              },
              /**
               * The icon to use for the collapse icon in expanded state
               * @config {String} collapsedFolderIconCls
               */
              //{ name : 'collapsedFolderIconCls', defaultValue : 'b-icon b-icon-tree-folder' },
              {
                name: 'collapsedFolderIconCls'
              },
              /**
               * The icon to use for the collapse icon in expanded state
               * @config {String} expandedFolderIconCls
               */
              //{ name : 'expandedFolderIconCls', defaultValue : 'b-icon b-icon-tree-folder-open' },
              {
                name: 'expandedFolderIconCls'
              },
              /**
               * The icon to use for the leaf nodes in the tree
               * @config {String} leafIconCls
               */
              {
                name: 'leafIconCls',
                defaultValue: 'b-icon b-icon-tree-leaf'
              }, {
                name: 'editTargetSelector',
                defaultValue: '.b-tree-cell-value'
              }];
            }
          }, {
            key: "type",
            get: function get() {
              return 'tree';
            }
          }]);

          function TreeColumn(config, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TreeColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(TreeColumn).apply(this, arguments));

            var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this));

            me.internalCellCls = 'b-tree-cell'; // We handle htmlEncoding in this class rather than relying on the generic Row DOM manipulation
            // since this class requires quite a lot of DOM infrastructure around the actual rendered content

            me.shouldHtmlEncode = me.htmlEncode;
            me.tempDiv = document.createElement('div');
            me.setData('htmlEncode', false); // add tree renderer (which calls original renderer internally)

            if (me.renderer) {
              me.originalRenderer = me.renderer;
            }

            me.renderer = me.treeRenderer.bind(me);
            return _this;
          }
          /**
           * A column renderer that is automatically added to the column with { tree: true }. It adds padding and node icons
           * to the cell to make the grid appear to be a tree. The original renderer is called in the process.
           * @private
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TreeColumn, [{
            key: "treeRenderer",
            value: function treeRenderer(renderData) {
              var me = this;
              var cellElement = renderData.cellElement,
                  row = renderData.row,
                  record = renderData.record,
                  value = renderData.value,
                  html = '',
                  gridMeta = record.instanceMeta(renderData.grid.store),
                  cls = '',
                  tag = record.href ? 'a' : 'div',
                  iconCls;

              if (me.originalRenderer) {
                var rendererHtml = me.originalRenderer(renderData);
                value = rendererHtml === false ? cellElement.innerHTML : rendererHtml;
              }

              if (!record.isLeaf) {
                row.addCls && row.addCls('b-tree-parent-row');
                cellElement.classList.add('b-tree-parent-cell'); // Spinner while loading children, added to row in Tree#toggleCollapse but needs to be readded if row is
                // rerendered during load

                if (gridMeta.isLoadingChildren) {
                  row.addCls('b-loading-children');
                } // TODO remove IE 11 is no longer supported (doesnt support this)
                //cellElement.classList.toggle('b-tree-collapsed', record.meta.collapsed === true);


                html += "<div class=\"b-tree-expander ".concat(gridMeta.collapsed ? me.expandIconCls + ' b-tree-collapsed' : me.collapseIconCls + ' b-tree-expanded', "\"></div>"); // Allow user to customize tree icon or opt out entirely

                currentParentHasIcon = iconCls = renderData.iconCls || record.iconCls || (gridMeta.collapsed ? me.collapsedFolderIconCls : me.expandedFolderIconCls);

                if (iconCls) {
                  html += "<div class=\"b-tree-icon ".concat(iconCls, "\"></div>");
                }
              } else {
                // TODO: Cleanup for reusing dom nodes should be done elsewhere, also cleanup selection
                cellElement.classList.add('b-tree-leaf-cell'); // Allow user to customize tree icon or opt out entirely

                iconCls = renderData.iconCls || record.iconCls || me.leafIconCls;

                if (iconCls) {
                  cls += iconCls;
                }
              }

              value = value != null ? value : '';

              if (me.shouldHtmlEncode) {
                me.tempDiv.innerText = value;
                value = me.tempDiv.innerHTML;
              }

              html += "<div class=\"b-tree-cell-value\">".concat(value, "</div>"); // TODO: make size configurable

              var padding = record.childLevel * 1.7 + (record.isLeaf ? currentParentHasIcon ? 1.8 : iconCls ? 0.4 : 0.3 : 0);
              return "<".concat(tag, " ").concat(record.href ? "href=\"".concat(record.href, "\"") : '', " ").concat(tag === 'a' && record.target ? "target=\"".concat(record.target, "\"") : '', " class=\"b-tree-cell-inner ").concat(cls, "\" style=\"padding-left:").concat(padding, "em\">").concat(html, "</").concat(tag, ">");
            }
          }]);

          return TreeColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerColumnType(TreeColumn);

        TreeColumn.exposeProperties();
        TreeColumn._$name = 'TreeColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/column/WidgetColumn.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Grid/column/WidgetColumn.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridColumnWidgetColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return WidgetColumn;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "../Grid/node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Column_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");

        var productName = 'scheduler'; //TODO: Currently widgets reuse elements already in cell, but performance would improve if entire widget was reused
        //TODO: Leaking widget on rerender of row, since the old one is not destroyed

        /**
         * @module Grid/column/WidgetColumn
         */

        /**
         * A column that displays widgets in the cells
         *
         * @extends Grid/column/Column
         *
         * @example
         * new Grid({
         *     appendTo : document.body,
         *
         *     columns : [
         *         { type: 'widget', text: 'Increase age', widget: { type: 'button', icon: 'add' }, data: 'age' }
         *     ]
         * });
         *
         * @classType widget
         * @externalexample column/WidgetColumn.js
         */

        var WidgetColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(WidgetColumn, _Column);

          function WidgetColumn() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, WidgetColumn);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(WidgetColumn).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(WidgetColumn, [{
            key: "construct",
            //endregion
            //region Init / Destroy
            value: function construct(config, store) {
              this.widgetMap = {};
              this.internalCellCls = 'b-widget-cell';

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(WidgetColumn.prototype), "construct", this).apply(this, arguments);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              // Destroy all the widgets we created.
              var _arr = Object.values(this.widgetMap);

              for (var _i = 0; _i < _arr.length; _i++) {
                var widget = _arr[_i];
                widget.destroy && widget.destroy();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(WidgetColumn.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Render

            /**
             * Renderer that displays a widget in the cell.
             * @param {Object} event Render event
             * @private
             */

          }, {
            key: "renderer",
            value: function renderer(event) {
              var me = this,
                  cellElement = event.cellElement,
                  column = event.column,
                  value = event.value,
                  record = event.record,
                  widgets = column.widgets;

              if (widgets) {
                // If there is no widgets yet and we're going to add them,
                // need to make sure there is no content left in the cell after its previous usage
                // by grid features such as grouping feature or so.
                if (!cellElement.widgets) {
                  // Reset cell content
                  me.clearCell(cellElement);
                }

                cellElement.widgets = widgets.map(function (widgetCfg, i) {
                  var widget, widgetNextSibling; // If cell element already has widgets, check if we need to destroy/remove one

                  if (cellElement.widgets) {
                    // Current widget
                    widget = cellElement.widgets[i]; // Store next element sibling to insert widget to correct position later

                    widgetNextSibling = widget.element.nextElementSibling; // If we are not syncing content for present widget, remove it from cell and render again later

                    if (widgetCfg.recreate && widget) {
                      // destroy widget and remove reference to it
                      delete me.widgetMap[widget.id];
                      widget.destroy();
                      cellElement.widgets[i] = null;
                    }
                  } // Ensure widget is created if first time through


                  if (!widget) {
                    me.onBeforeWidgetCreate(widgetCfg, event);
                    widget = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].append(widgetCfg, widgetNextSibling ? {
                      insertBefore: widgetNextSibling
                    } : cellElement)[0];
                    me.widgetMap[widget.id] = widget;
                    me.onAfterWidgetCreate(widget, event);
                  }

                  widget.cellInfo = {
                    cellElement: cellElement,
                    value: value,
                    record: record,
                    column: column
                  };

                  if (me.grid) {
                    widget.readOnly = me.grid.readOnly;
                  }

                  if (me.onBeforeWidgetSetValue(widget, event) !== false) {
                    if (!widgetCfg.noValueOnRender) {
                      if (widgetCfg.valueProperty) {
                        widget[widgetCfg.valueProperty] = value;
                      } else if (widget.defaultBindProperty) {
                        widget[widget.defaultBindProperty] = value;
                      } else {
                        widget.text = widget.value = value;
                      }
                    }
                  }

                  return widget;
                });
              }
            } //endregion
            //region Other

            /**
             * Called before widget is created on rendering
             * @param {Object} widgetCfg Widget config
             * @param {Object} event Render event
             * @private
             */

          }, {
            key: "onBeforeWidgetCreate",
            value: function onBeforeWidgetCreate(widgetCfg, event) {}
            /**
             * Called after widget is created on rendering
             * @param {Common.widget.Widget} widget Created widget
             * @param {Object} event Render event
             * @private
             */

          }, {
            key: "onAfterWidgetCreate",
            value: function onAfterWidgetCreate(widget, event) {}
            /**
             * Called before widget gets value on rendering. Pass `false` to skip value setting while rendering
             * @param {Common.widget.Widget} widget Created widget
             * @param {Object} event Render event
             * @private
             */

          }, {
            key: "onBeforeWidgetSetValue",
            value: function onBeforeWidgetSetValue(widget, renderEvent) {} // Overrides base implementation to cleanup widgets, for example when a cell is reused as part of group header

          }, {
            key: "clearCell",
            value: function clearCell(cellElement) {
              var _this = this;

              if (cellElement.widgets) {
                cellElement.widgets.forEach(function (widget) {
                  // Destroy widget and remove reference to it
                  delete _this.widgetMap[widget.id];
                  widget.destroy();
                });
                cellElement.widgets = null;
              } // Even if there is no widgets need to make sure there is no content left, for example after a cell has been reused as part of group header


              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(WidgetColumn.prototype), "clearCell", this).call(this, cellElement);
            } // Null implementation because there is no way of ascertaining whether the widgets get their width from
            // the column, or the column shrinkwraps the Widget.
            // Remember that the widget could have a width from a CSS rule which we cannot read.
            // It might have width: 100%, or a flex which would mean it is sized by us, but we cannot read that -
            // getComputedStyle would return the numeric width.

          }, {
            key: "resizeToFitContent",
            value: function resizeToFitContent() {} //endregion

          }], [{
            key: "type",
            //region Config
            get: function get() {
              return 'widget';
            }
          }, {
            key: "fields",
            get: function get() {
              return [
              /**
               * An array of widget config objects
               * @config {Object[]} widgets
               * @category Common
               */
              'widgets'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                filterable: false,
                sortable: false,
                editor: false,
                searchable: false
              };
            }
          }]);

          return WidgetColumn;
        }(_Column_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerColumnType(WidgetColumn);

        WidgetColumn.exposeProperties();
        WidgetColumn._$name = 'WidgetColumn';
        /***/
      },

      /***/
      "../Grid/lib/Grid/data/ColumnStore.js":
      /*!********************************************!*\
        !*** ../Grid/lib/Grid/data/ColumnStore.js ***!
        \********************************************/

      /*! exports provided: default, columnResizeEvent */

      /***/
      function GridLibGridDataColumnStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ColumnStore;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "columnResizeEvent", function () {
          return columnResizeEvent;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "../Grid/node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _column_Column_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../column/Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");

        var productName = 'scheduler';
        /**
         * @module Grid/data/ColumnStore
         */

        /**
         * A store specialized in handling columns. Used by the Grid to hold its columns and used as a chained store by each SubGrid
         * to hold theirs. Should not be instanced directly, instead access it through `grid.columns` or `subGrid.columns`
         *
         * ```
         * // resize first column
         * grid.columns.first.width = 200;
         *
         * // remove city column
         * grid.columns.get('city').remove();
         *
         * // add new column
         * grid.columns.add({text : 'New column'});
         *
         * // add new column to specific region (SubGrid)
         * grid.columns.add({text : 'New column', region : 'locked'});
         *
         * // add new column to 'locked' region (SubGrid)
         * grid.columns.add({text : 'New column', locked : true});
         * ```
         *
         * @extends Common/data/Store
         */

        var ColumnStore =
        /*#__PURE__*/
        function (_Localizable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ColumnStore, _Localizable);

          function ColumnStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ColumnStore);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ColumnStore).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ColumnStore, [{
            key: "construct",
            value: function construct(config) {
              var me = this; // Consequences of ColumnStore construction can cause reading of grid.columns
              // so set the property early.

              if (config.grid) {
                config.grid._columnStore = me;
                me.id = "".concat(config.grid.id, "-columns");
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ColumnStore.prototype), "construct", this).call(this, config); // So that we can invalidate cached collections which take computing so that we compute them
              // only when necessary. For example when asking for the visible leaf columns, we do not want
              // to compute that each time.


              me.on({
                change: me.clearCaches,
                scope: me,
                prio: 1
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var allColumns = [];
              this.traverse(function (column) {
                return allColumns.push(column);
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ColumnStore.prototype), "doDestroy", this).call(this); // Store's destroy unjoins all records. Destroy all columns *after* that.


              allColumns.forEach(function (column) {
                return column.destroy();
              });
            } // Overridden because the flat collection only contains top level columns,
            // not leaves - group columns are *not* expanded.

          }, {
            key: "getById",
            value: function getById(id) {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ColumnStore.prototype), "getById", this).call(this, id) || this.idRegister[id];
            }
          }, {
            key: "forEach",
            value: function forEach(fn) {
              var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this; // Override to omit root

              if (this.tree) {
                this.rootNode.traverseWhile(function (n, i) {
                  return fn.call(thisObj, n, i);
                }, true);
              } // stores on subgrids are chained and are not trees
              else {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ColumnStore.prototype), "forEach", this).call(this, fn, thisObj);
                }
            }
          }, {
            key: "clearCaches",
            value: function clearCaches() {
              this._visibleColumns = null;
            }
          }, {
            key: "onMasterDataChanged",
            value: function onMasterDataChanged(event) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ColumnStore.prototype), "onMasterDataChanged", this).call(this, event); // If master store has changes we also need to clear cached columns, in case a column was hidden


              this.clearCaches();
            }
          }, {
            key: "getAdjacentVisibleLeafColumn",
            value: function getAdjacentVisibleLeafColumn(columnOrId) {
              var next = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var columns = this.visibleColumns,
                  column = columnOrId instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_11__["default"] ? columnOrId : this.getById(columnOrId),
                  idx = columns.indexOf(column) + (next ? 1 : -1); // If we walked off either end, wrap if directed to do so,
              // otherwise, return null;

              if (!columns[idx]) {
                if (wrap) {
                  idx = next ? 0 : columns.length - 1;
                } else {
                  return null;
                }
              }

              return columns[idx];
            }
            /**
             * Bottom columns are the ones displayed in the bottom row of a grouped header, or all columns if not using a grouped
             * header. They are the columns that actually display any data.
             * @returns {Grid.column.Column[]}
             * @readonly
             */

          }, {
            key: "get",

            /**
             * Get column by field. To be sure that you are getting exactly the intended column, use {@link Common.data.Store#function-getById Store#getById()} with the
             * columns id instead.
             * @param {String} field Field name
             * @returns {Grid.column.Column}
             */
            value: function get(field) {
              return this.findRecord('field', field, true);
            }
            /**
             * Used internally to create a new record in the store. Creates a column of the correct type by looking up the
             * specified type among registered columns.
             * @private
             */

          }, {
            key: "createRecord",
            value: function createRecord(data) {
              var columnClass = this.modelClass;

              if (data.type) {
                columnClass = ColumnStore.getColumnClass(data.type);
                if (!columnClass) throw new Error(this.L('columnTypeNotFound', data));
              }

              if (data.locked) {
                data.region = 'locked';
                delete data.locked;
              }

              var column = new columnClass(data, this); // Doing this after construction, in case the columnClass has a default value for region (Schedulers
              // TimeAxisColumn has)

              if (!column.data.region) {
                column.data.region = this.grid ? this.grid.defaultRegion : 'normal'; // Some ColumnStore tests lacks Grid
              }

              return column;
            }
            /**
             * indexOf extended to also accept a columns field, for backward compatibility.
             * ```
             * grid.columns.indexOf('name');
             * ```
             * @param recordOrId
             * @returns {Number}
             */

          }, {
            key: "indexOf",
            value: function indexOf(recordOrId) {
              // TODO: build the need for field away
              var index = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ColumnStore.prototype), "indexOf", this).call(this, recordOrId);

              if (index > -1) return index; // no record found by id, find by field since old code relies on that instead of id
              // TODO: replace such cases with columns id

              return this.records.findIndex(function (r) {
                return r.field === recordOrId;
              });
            } //region Column types

            /**
             * Call from custom column to register it with ColumnStore. Required to be able to specify type in column config.
             * @param columnClass The class
             * @example
             * // create and register custom column
             * class CustomColumn {
             *  static get type() {
             *      return 'custom';
             *  }
             * }
             * ColumnStore.registerColumnType(CustomColumn);
             * // now possible to specify in column config
             * let grid = new Grid({
             *   columns: [
             *     { type: 'custom', field: 'id' }
             *   ]
             * });
             */

          }, {
            key: "totalFixedWidth",
            get: function get() {
              var result = 0;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var col = _step.value;

                  if (!col.hidden) {
                    if (col.flex) {
                      result += col.measureSize(_column_Column_js__WEBPACK_IMPORTED_MODULE_11__["default"].defaultWidth);
                    } else {
                      result += Math.max(col.measureSize(col.width), col.measureSize(col.minWidth));
                    }
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              return result;
            }
            /**
             * Returns the visible leaf headers which drive the rows' cell content.
             * @property {Grid.column.Column[]}
             * @readonly
             */

          }, {
            key: "visibleColumns",
            get: function get() {
              var me = this;

              if (!me._visibleColumns) {
                me._visibleColumns = me.leaves.filter(function (column) {
                  return !column.hidden;
                });
              }

              return me._visibleColumns;
            }
          }, {
            key: "bottomColumns",
            get: function get() {
              return this.leaves;
            }
          }], [{
            key: "registerColumnType",
            value: function registerColumnType(columnClass) {
              if (!ColumnStore.columnTypes) ColumnStore.columnTypes = {};
              ColumnStore.columnTypes[columnClass.type] = columnClass;
            }
            /**
             * Returns registered column class for specified type.
             * @param type Type name
             * @returns {Grid.column.Column}
             * @internal
             */

          }, {
            key: "getColumnClass",
            value: function getColumnClass(type) {
              return ColumnStore.columnTypes && ColumnStore.columnTypes[type];
            } //endregion

          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                modelClass: _column_Column_js__WEBPACK_IMPORTED_MODULE_11__["default"],
                tree: true
              };
            }
          }]);

          return ColumnStore;
        }(Object(_Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_12__["default"])(_Common_data_Store_js__WEBPACK_IMPORTED_MODULE_10__["default"]));
        /**
         * Custom {@link Grid.data.ColumnStore} event which triggers when a column is resized, i.e. its width has been changed
         *
         * @param {Function} handler
         * @param {Object} [thisObj]
         */


        var columnResizeEvent = function columnResizeEvent(handler, thisObj) {
          return {
            'update': function update(_ref) {
              var store = _ref.store,
                  record = _ref.record,
                  changes = _ref.changes;
              var result = true;

              if ('width' in changes || 'minWidth' in changes || 'flex' in changes) {
                result = handler.call(thisObj, {
                  store: store,
                  record: record,
                  changes: changes
                });
              }

              return result;
            }
          };
        }; // Can't have this in Column due to circular dependencies


        ColumnStore.registerColumnType(_column_Column_js__WEBPACK_IMPORTED_MODULE_11__["default"]);
        ColumnStore._$name = 'ColumnStore';
        /***/
      },

      /***/
      "../Grid/lib/Grid/data/GridRowModel.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Grid/data/GridRowModel.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridDataGridRowModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return GridRowModel;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
         * @module Grid/data/GridRowModel
         */

        /**
         * Model extended with some fields related to grid rendering. Used as default model type in the grids store if nothing
         * else is specified.
         *
         * Using this model is optional. If you use a custom model instead and need the functionality of any of the fields
         * below, you just have to remember to add fields with the same name to your model.
         *
         * @extends Common/data/Model
         */

        var GridRowModel =
        /*#__PURE__*/
        function (_Model) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(GridRowModel, _Model);

          function GridRowModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, GridRowModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(GridRowModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(GridRowModel, null, [{
            key: "fields",
            get: function get() {
              return [
              /**
               * Icon for row (used automatically in tree, feel free to use it in renderer in other cases)
               * @field {String} iconCls
               */
              'iconCls',
              /**
               * Start expanded or not (only valid for tree data)
               * @field {Boolean} expanded
               */
              'expanded',
              /**
               * CSS class (or several classes divided by space) to append to row elements
               * @field {String} cls
               */
              'cls',
              /**
               * Row height, set it to use another height then the default for a row
               * @field {Number} rowHeight
               */
              'rowHeight',
              /**
               * A link to use for this record when rendered into a {@link Grid.column.TreeColumn}.
               * @field {String} href
               */
              'href',
              /**
               * The target to use if this tree node provides a value for the {@link #field-href} field.
               * @field {String} target
               */
              'target'];
            }
          }]);

          return GridRowModel;
        }(_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        GridRowModel.exposeProperties();
        GridRowModel._$name = 'GridRowModel';
        /***/
      },

      /***/
      "../Grid/lib/Grid/feature/CellEdit.js":
      /*!********************************************!*\
        !*** ../Grid/lib/Grid/feature/CellEdit.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureCellEditJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CellEdit;
        });
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _Common_widget_Editor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/widget/Editor.js */
        "../Grid/lib/Common/widget/Editor.js");
        /* harmony import */


        var _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler'; //TODO: Maybe some more way to stop editing in touch mode (in case grid fills entire page...)

        var validNonEditingKeys = {
          Enter: 1,
          F2: 1
        };
        var validEditingKeys = {
          ArrowUp: 1,
          ArrowDown: 1,
          ArrowLeft: 1,
          ArrowRight: 1
        };
        /**
         * @module Grid/feature/CellEdit
         */

        /**
         * Adding this feature to the grid enables cell editing, usage instructions:
         * <h3>Start editing</h3>
         * * Double click on a cell
         * * Press [ENTER] or [F2] with a cell selected
         *
         * <h3>While editing</h3>
         * * [ENTER] <dd>Finish editing and start editing the same cell in next row
         * * [SHIFT] + [ENTER] <dd>Same as above put with previous row
         * * [F2] <dd>Finish editing
         * * [CMD/CTRL] + [ENTER] <dd>Finish editing
         * * [ESC] <dd>Cancel editing
         * * [TAB] <dd>Finish editing and start editing the next cell
         * * [SHIFT] + [TAB] <dd>Finish editing and start editing the previous cell
         *
         * Columns specify editor in their config, editor can
         * also by set by using a column type.
         *
         * <h3>Preventing editing of certain cells</h3>
         * You can prevent editing on a column by setting `editor` to false:
         *
         * ```javascript
         * new Grid({
         *    columns : [
         *       {
         *          type   : 'number',
         *          text   : 'Age',
         *          field  : 'age',
         *          editor : false
         *       }
         *    ]
         * ```
         * To prevent editing in a specific cell, listen to the {@link #event-beforeCellEditStart} and return false:
         *
         * ```javascript
         * grid.on('beforeCellEditStart', ({ editorContext }) => {
         *     return editorContext.column.field !== 'id';
         * });
         * ```
         *
         * This feature is <strong>enabled</strong> by default.
         *
         * @example
         * { data: 'name', text: 'Name', editor: 'text' }
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo celledit
         * @classtype cellEdit
         * @externalexample feature/CellEdit.js
         */

        var CellEdit =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(CellEdit, _Delayable);

          function CellEdit() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, CellEdit);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CellEdit).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(CellEdit, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(grid, config) {
              var me = this;
              me.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CellEdit.prototype), "construct", this).call(this, grid, config);

              me.storeListenerDetacher = grid.store.on({
                update: 'onStoreUpdate',
                thisObj: me
              });
              me.listenerDetacher = grid.on({
                cellclick: 'onCellClick',
                celldblclick: 'onCellDblClick',
                beforerenderrows: 'onGridBeforeRenderRows',
                thisObj: me
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.cancelEditing(true);
              this.listenerDetacher();
              this.storeListenerDetacher();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CellEdit.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Editing

            /**
             * Is any cell currently being edited?
             * @returns {boolean}
             */

          }, {
            key: "getEditorForCell",

            /**
             * Internal function to create of get existing editor for specified cell.
             * @private
             * @param cellContext Cell to get or create editor for
             * @returns {{editor: (Element|*|null), field: *, widget: *}}
             * @category Internal
             */
            value: function getEditorForCell(_ref) {
              var column = _ref.column,
                  selector = _ref.selector;
              var me = this,
                  grid = me.grid; // Reuse the editor by caching it on the column

              var editor = column._cellEditor;

              if (!editor) {
                column.editor.autoSelect = me.autoSelect;
                editor = column._cellEditor = new me.editorClass({
                  cls: 'b-cell-editor',
                  inputField: column.editor,
                  blurAction: 'none',
                  completeKey: false,
                  cancelKey: false,
                  owner: grid,
                  listeners: me.getEditorListeners()
                }); // Keep the record synced with the value

                if (column.instantUpdate) {
                  _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].wrapProperty(column.editor, 'value', null, function (v) {
                    // Only tickle the record if the value has changed.
                    if (me.editorContext && !_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isEqual(me.editorContext.record[me.editorContext.column.field], v)) {
                      me.editorContext.record[me.editorContext.column.field] = v;
                    }
                  });
                }
              }

              var widgetWrapperData = editor.element.dataset;
              widgetWrapperData.rowId = selector.id;
              widgetWrapperData.columnId = selector.columnId;
              widgetWrapperData.field = column.field;
              return me.editor = editor;
            } // Turned into function to allow overriding in Gantt, and make more configurable in general

          }, {
            key: "getEditorListeners",
            value: function getEditorListeners() {
              return {
                focusout: 'onEditorFocusOut',
                focusin: 'onEditorFocusIn',
                start: 'onEditorStart',
                beforecomplete: 'onEditorBeforeComplete',
                complete: 'onEditorComplete',
                cancel: 'onEditorCancel',
                thisObj: this
              };
            }
          }, {
            key: "onEditorStart",
            value: function onEditorStart(_ref2) {
              var editor = _ref2.source;
              var me = this,
                  editorContext = me.editorContext = editor.cellEditorContext;

              if (editorContext) {
                var grid = me.grid,
                    cell = editorContext.cell,
                    _editor = editorContext.editor,
                    column = editorContext.column; // Match editorTarget size and position

                if (column.editTargetSelector) {
                  var editorTarget = cell.querySelector(column.editTargetSelector);

                  if (editorTarget) {
                    _editor.width -= editorTarget.offsetLeft;

                    _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].addTranslateX(_editor.element, editorTarget.offsetLeft);
                  }
                }

                cell.classList.add('b-editing');
                me.grid.on({
                  cellclick: 'onCellClickWhileEditing',
                  viewportResize: 'onViewportResizeWhileEditing'
                }, me); // Handle tapping outside of the grid element. Use GlobalEvents
                // because it uses a capture:true listener before any other handlers
                // might stop propagation.
                // Cannot use delegate here. A tapped cell will match :not(#body-container)

                me.removeEditingListeners = _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_13__["default"].addListener({
                  globaltap: 'onTapOut',
                  thisObj: me
                });
                /**
                 * Fires on the owning Grid when editing starts
                 * @event startCellEdit
                 * @param {Grid.view.Grid} grid **Deprecated** Use `source` instead
                 * @param {Grid.view.Grid} source Owner grid
                 * @param {Object} editorContext Editing context
                 * @param {Common.widget.Editor} editorContext.editor The Editor being used.
                 * Will contain an `inputField` property which is the field being used to perform the editing.
                 * @param {Grid.column.Column} editorContext.column Target column
                 * @param {Common.data.Model} editorContext.record Target record
                 * @param {HTMLElement} editorContext.cell Target cell
                 * @param {*} editorContext.value Cell value
                 */

                grid.trigger('startCellEdit', {
                  grid: grid,
                  editorContext: editorContext
                });
              }
            }
          }, {
            key: "onEditorBeforeComplete",
            value: function onEditorBeforeComplete(context) {
              var grid = this.grid,
                  editor = context.source,
                  editorContext = editor.cellEditorContext;
              context.grid = grid;
              context.editorContext = editorContext;
              /**
               * Fires on the owning Grid before the cell editing is finished, return false to signal that the value is invalid and editing should not be finalized.
               * @event beforeFinishCellEdit
               * @param {Grid.view.Grid} grid Target grid
               * @param {Object} editorContext Editing context
               * @param {Common.widget.Editor} editorContext.editor The Editor being used.
               * Will contain an `inputField` property which is the field being used to perform the editing.
               * @param {Grid.column.Column} editorContext.column Target column
               * @param {Common.data.Model} editorContext.record Target record
               * @param {HTMLElement} editorContext.cell Target cell
               * @param {*} editorContext.value Cell value
               */

              return grid.trigger('beforeFinishCellEdit', context);
            }
          }, {
            key: "onEditorComplete",
            value: function onEditorComplete(_ref3) {
              var editor = _ref3.source;
              var grid = this.grid,
                  editorContext = editor.cellEditorContext; // Ensure the docs below are accurate!

              editorContext.value = editor.inputField.value;
              /**
               * Fires on the owning Grid when cell editing is finished
               * @event finishCellEdit
               * @param {Grid.view.Grid} grid Target grid
               * @param {Object} editorContext Editing context
               * @param {Common.widget.Editor} editorContext.editor The Editor being used.
               * Will contain an `inputField` property which is the field being used to perform the editing.
               * @param {Grid.column.Column} editorContext.column Target column
               * @param {Common.data.Model} editorContext.record Target record
               * @param {HTMLElement} editorContext.cell Target cell
               * @param {*} editorContext.value Cell value
               */

              grid.trigger('finishCellEdit', {
                grid: grid,
                editorContext: editorContext
              });
              this.cleanupAfterEdit(editorContext);
            }
          }, {
            key: "onEditorCancel",
            value: function onEditorCancel() {
              var editorContext = this.editorContext,
                  muteEvents = this.muteEvents,
                  grid = this.grid;

              if (editorContext) {
                this.cleanupAfterEdit(editorContext);
              }

              if (!muteEvents) {
                /**
                 * Fires on the owning Grid when editing is cancelled
                 * @event cancelCellEdit
                 * @param {Grid.view.Grid} grid **Deprecated** Use `source` instead
                 * @param {Grid.view.Grid} source Owner grid
                 */
                grid.trigger('cancelCellEdit', {
                  grid: grid
                });
              }
            }
          }, {
            key: "cleanupAfterEdit",
            value: function cleanupAfterEdit(editorContext) {
              var me = this,
                  editor = editorContext.editor;
              editorContext.cell.classList.remove('b-editing');
              editor.cellEditorContext = me.editorContext = null;
              me.grid.un({
                cellclick: 'onCellClickWhileEditing',
                viewportResize: 'onViewportResizeWhileEditing'
              }, me);
              me.removeEditingListeners(); // MS Edge workaround.
              // At this moment active element is grid.element, but removing editor element still triggers focusout event
              // which is processed by the GlobalEvents, which decides that focus goes to body element. That, in turn, triggers
              // clearFocus on grid navigation, removing focused cell from cache etc, eventually focus actually goes to body.
              // Suspending listener to seamlessly remove element keeping focus where it belongs.
              // NOTE: not reproducible in IFrame, so our tests cannot catch this

              _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_13__["default"].suspendFocusEvents();

              editor.element.remove();

              _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_13__["default"].resumeFocusEvents();
            }
            /**
             * Find the next succeeding or preceding cell which is editable (column.editor != false)
             * @param {Object} cellInfo
             * @param {Boolean} isForward
             * @returns {Object}
             * @private
             * @category Internal
             */

          }, {
            key: "getAdjacentEditableCell",
            value: function getAdjacentEditableCell(cellInfo, isForward) {
              var addNewAtEnd = this.addNewAtEnd,
                  grid = this.grid,
                  store = grid.store,
                  rowManager = grid.rowManager,
                  rowId = cellInfo.id,
                  columnId = cellInfo.columnId,
                  columns = grid.columns,
                  column = columns.getAdjacentLeaf(columnId, isForward);

              while (rowId) {
                var record = store.getById(rowId);

                if (column) {
                  columnId = column.id;

                  if (!column.hidden && column.editor && column.canEdit(record)) {
                    return {
                      id: rowId,
                      columnId: column.id
                    };
                  }

                  column = columns.getAdjacentLeaf(columnId, isForward);
                } else {
                  var editRec = store.getAdjacent(cellInfo.id, isForward, false, true);

                  if (!editRec && isForward && addNewAtEnd) {
                    editRec = store.add(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(addNewAtEnd) === 'object' ? _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].clone(addNewAtEnd) : {})[0]; // If the new record was not added due to it being off the end of the rendered block
                    // ensure we force it to be there before we attempt to edit it.

                    if (!rowManager.getRowFor(editRec)) {
                      rowManager.displayRecordAtBottom();
                    }
                  }

                  rowId = editRec && editRec.id;

                  if (editRec) {
                    column = isForward ? columns.first : columns.leaves[columns.leaves.length - 1];
                  }
                }
              }

              return null;
            }
            /**
             * Creates an editing context object for the passed cell context (target cell must be in the DOM).
             *
             * If the referenced cell is editable, an object returned will
             * be returned containing the following properties:
             *
             *     - column
             *     - record
             *     - cell
             *     - value
             *     - selector
             *
             * If the references cell is _not_ editable, `false` will be returned.
             * @param {Object} cellContext an object which encapsulates a cell.
             * @param {String} cellContext.id The record id of the row to edit
             * @param {String} cellContext.columnId The column id of the column to edit
             * @private
             */

          }, {
            key: "getEditingContext",
            value: function getEditingContext(cellContext) {
              cellContext = this.grid.normalizeCellContext(cellContext);
              var me = this,
                  grid = me.grid,
                  column = grid.columns.getById(cellContext.columnId),
                  record = grid.store.getById(cellContext.id),
                  cell = grid.getCell(cellContext); // Cell must be in the DOM to edit.
              // Cannot edit hidden columns and columns without an editor.
              // Cannot edit special rows (groups etc).

              if (cell && column && !column.hidden && column.editor && record && !record.meta.specialRow && column.canEdit(record)) {
                var value = record && record[column.field];
                return {
                  column: column,
                  record: record,
                  cell: cell,
                  value: value === undefined ? null : value,
                  selector: cellContext
                };
              } else {
                return false;
              }
            }
            /**
             * Start editing specified cell. If no cellContext is given it starts with the first cell in the first row.
             * This function is exposed on Grid and can thus be called as `grid.startEditing(...)`
             * @param {Object} cellContext Cell specified in format { id: 'x', columnId/column/field: 'xxx' }. See {@link Grid.view.Grid#function-getCell} for details.
             * @fires startCellEdit
             * @returns {Boolean} editingStarted
             * @category Editing
             */

          }, {
            key: "startEditing",
            value: function startEditing() {
              var cellContext = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var me = this; // If already editing, or grid is readonly, no can do.

              if (!(me.editorContext || me.disabled || me.grid.readOnly || me.grid.disabled)) {
                var grid = me.grid,
                    normalizedContext = grid.normalizeCellContext(cellContext); // First scroll record into view and register it as last focusedCell

                grid.focusCell(cellContext);
                var editorContext = me.getEditingContext(normalizedContext);
                /**
                 * Fires on the owning Grid before editing starts, return `false` to prevent editing
                 * @event beforeCellEditStart
                 * @preventable
                 * @param {Grid.view.Grid} source Owner grid
                 * @param {Object} editorContext Editing context
                 * @param {Grid.column.Column} editorContext.column Target column
                 * @param {Common.data.Model} editorContext.record Target record
                 * @param {HTMLElement} editorContext.cell Target cell
                 * @param {*} editorContext.value Cell value
                 */

                if (grid.trigger('beforeCellEditStart', {
                  grid: grid,
                  editorContext: editorContext
                }) === false) {
                  return false;
                } // Cannot edit hidden columns and columns without an editor
                // Cannot edit special rows (groups etc).


                if (editorContext) {
                  // Focus grid element to preserve focus inside once editing is started
                  // https://app.assembla.com/spaces/bryntum/tickets/8155-grid-cell-not-properly-focused-in-advanced-demo
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].focusWithoutScrolling(grid.element);

                  var editor = editorContext.editor = me.getEditorForCell(editorContext),
                      cell = editorContext.cell,
                      record = editorContext.record,
                      column = editorContext.column; // Prevent highlight when setting the value in the editor

                  editor.inputField.highlightExternalChange = false;
                  editor.cellEditorContext = editorContext;
                  editor.render(me.grid.getSubGridFromColumn(column).element); // Attempt to start edit.
                  // We will set up our context in onEditorStart *if* the start was successful.

                  editor.startEdit({
                    target: cell,
                    record: record
                  });
                  return true;
                }
              }

              return false;
            }
            /**
             * Cancel editing, destroys the editor
             * @param {Boolean} silent Pass true to prevent method from firing event
             * @fires cancelCellEdit
             * @category Editing
             */

          }, {
            key: "cancelEditing",
            value: function cancelEditing() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  editorContext = me.editorContext,
                  editor = me.editor,
                  grid = me.grid;

              if (editorContext) {
                // If cancel was not called from onEditorFocusOut, then refocus the grid.
                if (editor.containsFocus) {
                  // Kill editorContext before we destroy the editor so that we know we are not editing
                  // in ensuing focusout event handling
                  me.editorContext = null; // Control focus reversion if we own focus

                  if (editor.inputField.owns(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].activeElement)) {
                    grid.focus();
                  }

                  me.editorContext = editorContext;
                }

                me.muteEvents = silent;
                editor.cancelEdit();
                me.muteEvents = false;
              }
            }
            /**
             * Finish editing, update the underlying record and destroy the editor
             * @fires finishCellEdit
             * @category Editing
             * @returns `false` if the edit could not be finished due to the value being invalid or the
             * Editor's `complete` event was vetoed.
             */

          }, {
            key: "finishEditing",
            value: function finishEditing() {
              var editorContext = this.editorContext;

              if (editorContext) {
                return editorContext.editor.completeEdit();
              }

              return false;
            } //endregion
            //region Context menu
            // /**
            //  * Populates the cell context menu with an 'Edit cell' item.
            //  * @private
            //  * @param column
            //  * @param {Common.data.Model} record
            //  * @param {Array} items
            //  * @returns {Array}
            //  * @category Internal
            //  */
            // getCellMenuItems(column, record, items) {
            //     const me = this;
            //
            //     if (column.editor !== false) {
            //         items.push({
            //             text   : this.L('editCell'),
            //             icon   : 'edit',
            //             id     : 'cellEdit',
            //             onItem : () => {
            //                 me.editorContext && me.finishEditing();
            //                 // selecting in context menu triggers cancel, which is fine in other cases...
            //                 me.startEditing({ id : record.id, columnId : column.id, field : column.field });
            //                 me.preventFinish = true;
            //             }
            //         });
            //     }
            //     return items;
            // }
            //endregion
            //region Events

            /**
             * Event handler added when editing is active called when user clicks a cell in the grid during editing.
             * It finishes editing and moves editor to the selected cell instead.
             * @private
             * @category Internal event handling
             */

          }, {
            key: "onCellClickWhileEditing",
            value: function onCellClickWhileEditing(_ref4) {
              var event = _ref4.event,
                  cellSelector = _ref4.cellSelector;
              var me = this; // Ignore clicks in the editor.

              if (!me.editorContext.editor.owns(event.target)) {
                if (me.getEditingContext(cellSelector)) {
                  // Attempt to finish the current edit.
                  // Will return false if the field is invalid.
                  if (me.finishEditing()) {
                    me.startEditing(cellSelector);
                  } // Previous edit was invalid, return to it.
                  else {
                      me.grid.focusCell(me.editorContext.selector);
                      me.editor.inputField.focus();
                    }
                } else {
                  me.finishEditing();
                }
              }
            }
          }, {
            key: "onViewportResizeWhileEditing",
            value: function onViewportResizeWhileEditing() {
              var _this$editorContext = this.editorContext,
                  editor = _this$editorContext.editor,
                  column = _this$editorContext.column;
              editor.width = column.element.offsetWidth;
            }
            /**
             * Starts editing if user taps selected cell again on touch device. Chained function called when user clicks a cell.
             * @private
             * @category Internal event handling
             */

          }, {
            key: "onCellClick",
            value: function onCellClick(_ref5) {
              var grid = _ref5.source,
                  record = _ref5.record,
                  cellSelector = _ref5.cellSelector,
                  cellElement = _ref5.cellElement,
                  target = _ref5.target,
                  event = _ref5.event;
              var selected = grid.focusedCell || {},
                  column = grid.columns.getById(cellSelector.columnId); // Columns may provide their own handling of cell editing

              if (column.onCellClick) {
                column.onCellClick({
                  grid: grid,
                  column: column,
                  record: record,
                  cellSelector: cellSelector,
                  cellElement: cellElement,
                  target: target,
                  event: event
                });
              } else if (target.matches('.b-tree-expander')) {
                this.cancelEditing();
                return false;
              } else if (_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isTouchEvent && cellSelector.id == selected.id && cellSelector.columnId == selected.columnId) {
                this.startEditing(cellSelector);
              }
            }
            /**
             * Chained function called when user dbl clicks a cell. Starts editing.
             * @private
             * @category Internal event handling
             */

          }, {
            key: "onCellDblClick",
            value: function onCellDblClick(_ref6) {
              var cellSelector = _ref6.cellSelector;
              var me = this;

              if (me.editorContext && !me.finishEditing()) {
                return;
              }

              me.startEditing(cellSelector);
            }
            /**
             * Update the input field if underlying data changes during edit.
             * @private
             * @category Internal event handling
             */

          }, {
            key: "onStoreUpdate",
            value: function onStoreUpdate(_ref7) {
              var changes = _ref7.changes,
                  record = _ref7.record;
              var editorContext = this.editorContext;

              if (editorContext && editorContext.editor.isVisible) {
                if (record === editorContext.record && editorContext.editor.dataField in changes) {
                  editorContext.editor.refreshEdit();
                }
              }
            }
            /**
             * Invalidate editor when grid renders rows.
             * @private
             * @category Internal event handling
             */

          }, {
            key: "onGridBeforeRenderRows",
            value: function onGridBeforeRenderRows() {
              // grid rows are being rerendered, meaning the underlying data might be changed.
              // the editor probably won't be over the same record, so cancel
              if (this.editorContext && this.editorContext.editor.isVisible) {
                this.cancelEditing();
              }
            }
            /**
             * Chained function called on key down. [enter] or [f2] starts editing. [enter] also finishes editing and starts
             * editing next row, [f2] also finishes editing without moving to the next row. [esc] cancels editing. [tab]
             * edits next column, [shift] + [tab] edits previous.
             * @param event
             * @private
             * @category Internal event handling
             */

          }, {
            key: "onElementKeyDown",
            value: function onElementKeyDown(event) {
              var me = this; // flagging event with handled = true used to signal that other features should probably not care about it

              if (event.handled) return;

              if (!me.editorContext) {
                var key = event.key,
                    editingStartedWithCharacterKey = me.autoEdit && (key.length === 1 || key === 'Backspace'); // enter or f2 to edit, or any character key if autoEdit is enabled

                if ((editingStartedWithCharacterKey || validNonEditingKeys[key]) && me.grid.focusedCell) {
                  event.preventDefault();

                  if (!me.startEditing(me.grid.focusedCell)) {
                    return;
                  }

                  var inputField = me.editor.inputField,
                      input = inputField.input; // if editing started with a keypress and the editor has an input field, set its value

                  if (editingStartedWithCharacterKey && input) {
                    // Simulate a keydown in an input field by setting input value
                    // plus running our internal processing of that event
                    input.value = key === 'Backspace' ? '' : key;
                    inputField.internalOnInput(event); // IE11 + Edge put caret at 0 when focusing

                    inputField.moveCaretToEnd();
                  }
                }
              } else {
                // enter
                if (event.key === 'Enter') {
                  event.preventDefault();
                  event.stopPropagation();

                  if (me.finishEditing()) {
                    // Finalizing might have been blocked by an invalid value
                    if (!me.isEditing) {
                      // Enter in combination with special keys finishes editing
                      // On touch Enter always finishes editing. Feels more natural since no tab-key etc.
                      if (event.ctrlKey || event.metaKey || event.altKey || me.grid.touch) {
                        return;
                      } // Edit previous
                      else if (event.shiftKey) {
                          if (me.grid.navigateUp()) {
                            me.startEditing(me.grid.focusedCell);
                          }
                        } // Edit next
                        else if (me.grid.navigateDown()) {
                            me.startEditing(me.grid.focusedCell);
                          }
                    }
                  }
                } // f2


                if (event.key === 'F2') {
                  event.preventDefault();
                  me.finishEditing();
                } // esc


                if (event.key === 'Escape') {
                  event.stopPropagation();
                  event.preventDefault();
                  me.cancelEditing();
                } // tab


                if (event.key === 'Tab') {
                  event.preventDefault();
                  var focusedCell = me.grid.focusedCell;

                  if (focusedCell) {
                    var cellInfo = me.getAdjacentEditableCell(focusedCell, !event.shiftKey);

                    if (cellInfo) {
                      if (me.finishEditing()) {
                        me.grid.focusCell(cellInfo, {
                          animate: 100
                        });
                        me.startEditing(cellInfo);
                      }
                    }
                  }
                } // prevent arrow keys from moving editor


                if (validEditingKeys[event.key]) {
                  event.handled = true;
                }
              }
            }
          }, {
            key: "onElementMouseDown",
            value: function onElementMouseDown(event) {
              // If it's a contextmenu mousedown during cell edit, prevent default
              // because the contextmenu handler will move focus directly to the context menu.
              // If we allow it to go through the grid, the edit will not terminate because
              // that usually means begin editing somewhere else in the grid.
              // TODO: This won't be necessary when cells are the focusable DOM unit.
              if (event.button === 2 && this.editorContext) {
                event.preventDefault();
              }
            }
            /**
             * Cancel editing on widget focusout
             * @private
             */

          }, {
            key: "onEditorFocusOut",
            value: function onEditorFocusOut(event) {
              var me = this,
                  grid = me.grid; // If the editor is not losing focus as a result of its tidying up process
              // And focus is moving to outside of the grid, or back to the initiating cell
              // (which indicates a click on empty space below rows), then explicitly terminate.

              if (me.editorContext && !me.editor.isFinishing && me.editor.inputField.owns(event.target) && (event.toWidget !== grid || grid.isLocationEqual(me.grid.focusedCell, me.editorContext.selector))) {
                if (me.blurAction === 'cancel') {
                  me.cancelEditing();
                } else {
                  me.finishEditing();
                }
              }
            }
          }, {
            key: "onEditorFocusIn",
            value: function onEditorFocusIn(event) {
              var widget = event.toWidget;

              if (widget === this.editor.inputField) {
                if (this.autoSelect && widget.selectAll && !widget.readOnly && !widget.disabled) {
                  widget.selectAll();
                }
              }
            }
            /**
             * Cancel edit on touch outside of grid for mobile Safari (focusout not triggering unless you touch something focusable)
             * @private
             */

          }, {
            key: "onTapOut",
            value: function onTapOut(_ref8) {
              var event = _ref8.event;
              var me = this;

              if (!me.grid.bodyContainer.contains(event.target)) {
                if (!me.editor.inputField.owns(event.target)) {
                  if (me.blurAction === 'cancel') {
                    me.cancelEditing();
                  } else {
                    me.finishEditing();
                  }
                }
              }
            }
            /**
             * Finish editing if clicking below rows (only applies when grid is higher than rows).
             * @private
             * @category Internal event handling
             */

          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              var me = this;

              if (event.target.classList.contains('b-grid-body-container') && me.editorContext) {
                me.finishEditing();
              }
            } //endregion

          }, {
            key: "isEditing",
            get: function get() {
              return Boolean(this.editorContext);
            }
          }], [{
            key: "defaultConfig",
            //region Config
            // Default configuration
            get: function get() {
              return {
                /**
                 * Set to true to select the field text when editing starts
                 * @config {Boolean}
                 * @default
                 */
                autoSelect: true,

                /**
                 * What action should be taken when focus moves leaves the cell editor, for example when clicking outside.
                 * May be `'complete'` or `'cancel`'.
                 * @config {String}
                 * @default
                 */
                blurAction: 'complete',

                /**
                 * Set to true to have TAB on the last cell in the data set create a new record
                 * and begin editing it at its first editable cell.
                 *
                 * If this is configured as an object, it is used as the default data value set for each new record.
                 * @config {Boolean/Object}
                 * @default
                 */
                addNewAtEnd: null,

                /**
                 * Set to true to start editing when user starts typing text on a focused cell (as in Excel)
                 * @config {Boolean}
                 * @default
                 */
                autoEdit: false,

                /**
                 * Class to use as an editor. Default value: {@link Common.widget.Editor}
                 * @config {Common.widget.Widget}
                 * @internal
                 */
                editorClass: _Common_widget_Editor_js__WEBPACK_IMPORTED_MODULE_12__["default"]
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                assign: ['startEditing'],
                before: ['onElementKeyDown', 'onElementMouseDown'],
                chain: ['onElementClick']
              };
            }
          }]);

          return CellEdit;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"]));

        CellEdit.featureClass = 'b-cell-edit';
        CellEdit._$name = 'CellEdit';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(CellEdit, true);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/CellTooltip.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Grid/feature/CellTooltip.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureCellTooltipJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CellTooltip;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/CellTooltip
         */

        /**
         * Displays a tooltip when hovering cells. Contents can be customized by specifying a global `tooltipRenderer` function
         * for the feature and/or on a per column basis.
         *
         * Configuration properties passed into this feature are used to configure the {@link Common.widget.Tooltip} instance
         * used.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // Enable CellTooltip and configure it to show the cell's full value
         * let grid = new Grid({
         *   features: {
         *     cellTooltip: ({value}) => value
         *   }
         * });
         *
         * // Column with its own tooltip renderer
         * {
         *   text            : 'Name',
         *   field           : 'name',
         *   tooltipRenderer : ({ record }) => `My name is\xa0<b>${record.name}</b>`
         * }
         *
         * // Async tooltip with some custom settings
         * let grid = new Grid({
         *   features: {
         *     cellTooltip: {
         *       // Time that mouse needs to be over cell before tooltip is shown
         *       hoverDelay : 4000,
         *       // Time after mouse out to hide the tooltip, 0 = instantly
         *       hideDelay  : 0,
         *       // Async tooltip renderer
         *       tooltipRenderer({ record, tip }) {
         *         // Initiate some async action
         *         AjaxHelper.get(`tooltip.php?id=${record.id}`).then(() => {
         *             tip.html = 'Async content here...';
         *         });
         *
         *         // Signal async tooltip. The tooltip will display a load mask until its html is updated (above)
         *         return false;
         *       }
         *     }
         *   }
         * });
         *
         * @demo celltooltip
         * @classtype cellTooltip
         * @externalexample feature/CellTooltip.js
         */

        var CellTooltip =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(CellTooltip, _InstancePlugin);

          function CellTooltip() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, CellTooltip);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CellTooltip).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(CellTooltip, [{
            key: "construct",
            //endregion
            // region Init
            value: function construct(grid, config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CellTooltip.prototype), "construct", this).call(this, grid, me.processConfig(config));

              me.tip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_7__["default"](Object.assign({
                forElement: grid.element,
                forSelector: '.b-grid-cell',
                hoverDelay: 1000,
                trackMouse: false,
                cls: 'b-celltooltip-tip',
                getHtml: me.getTooltipContent.bind(me),
                listeners: {
                  pointerOver: 'onPointerOver',
                  thisObj: me
                }
              }, config));
              me.relayEvents(me.tip, ['beforeshow', 'show']);
            }
          }, {
            key: "onPointerOver",
            value: function onPointerOver(_ref) {
              var target = _ref.target;
              var column = this.client.getColumnFromElement(target); // Veto onPointerOver if column's tooltipRenderer is false

              return column.tooltipRenderer !== false;
            } // CellTooltip feature handles special config cases, where user can supply a function to use as tooltipRenderer
            // instead of a normal config object

          }, {
            key: "processConfig",
            value: function processConfig(config) {
              if (typeof config === 'function') {
                return {
                  tooltipRenderer: config
                };
              }

              return config;
            } // override setConfig to process config before applying it (used mainly from ReactGrid)

          }, {
            key: "setConfig",
            value: function setConfig(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CellTooltip.prototype), "setConfig", this).call(this, this.processConfig(config));
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.tip.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CellTooltip.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Content

            /**
             * Called from Tooltip to populate it with html.
             * @private
             */

          }, {
            key: "getTooltipContent",
            value: function getTooltipContent(_ref2) {
              var tip = _ref2.tip,
                  cellElement = _ref2.forElement,
                  event = _ref2.event;
              var me = this,
                  record = me.client.getRecordFromElement(cellElement),
                  column = me.client.getColumnFromElement(cellElement);
              var result; // If we have not changed context, we should not change content, unless we have a custom target selector
              // (element within the cell)

              if (!me.forSelector && record === me.lastRecord && column === me.lastColumn) {
                return me.tip._html;
              } // first, use columns tooltipRenderer if any


              if (column.tooltipRenderer) {
                result = column.tooltipRenderer({
                  cellElement: cellElement,
                  record: record,
                  column: column,
                  event: event,
                  tip: tip,
                  cellTooltip: me
                });
              } // secondly, try features renderer (but specifying column.tooltipRenderer as false prevents tooltip in that column)
              else if (me.tooltipRenderer && column.tooltipRenderer !== false) {
                  result = me.tooltipRenderer({
                    cellElement: cellElement,
                    record: record,
                    column: column,
                    event: event,
                    tip: tip,
                    cellTooltip: me
                  });
                }

              if (result != null) {
                me.lastRecord = record;
                me.lastColumn = column;
              }

              return result;
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Function called to generated html for the contents of the a cells tooltip. Called with a single argument
                 * with format `{ cellElement, record, column, tip, cellTooltip, event }`. Return a html string, or false to
                 * flag that it will be done async
                 * @config {Function}
                 */
                tooltipRenderer: null
              };
            }
          }]);

          return CellTooltip;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        CellTooltip._$name = 'CellTooltip';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(CellTooltip);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/ColumnDragToolbar.js":
      /*!*****************************************************!*\
        !*** ../Grid/lib/Grid/feature/ColumnDragToolbar.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureColumnDragToolbarJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ColumnDragToolbar;
        });
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        function _templateObject3() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n                        <div class=\"b-target-button\" data-name=\"", "\" data-disabled=\"", "\">\n                            <i class=\"", "\"></i>\n                            ", "\n                        </div>\n                    "]);

          _templateObject3 = function _templateObject3() {
            return data;
          };

          return data;
        }

        function _templateObject2() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n                <div class=\"b-group\">\n                    <div class=\"b-buttons\">\n                    ", "\n                    </div>\n                    <div class=\"b-title\">", "</div>\n                </div>\n            "]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n            <div class=\"b-columndragtoolbar\">     \n            <div class=\"b-title\"></div>          \n            ", "\n            </div>"]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Grid/feature/ColumnDragToolbar
         */

        /**
         * Displays a toolbar while dragging column headers. Drop on a button in the toolbar to activate a certain function,
         * for example to group by that column. This feature simplifies certain operations on touch devices.
         *
         * This feature is <strong>disabled</strong> by default, but turned on automatically on touch devices.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @classtype columnDragToolbar
         * @externalexample feature/ColumnDragToolbar.js
         */

        var ColumnDragToolbar =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(ColumnDragToolbar, _Delayable);

          function ColumnDragToolbar() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, ColumnDragToolbar);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ColumnDragToolbar).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(ColumnDragToolbar, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(grid, config) {
              if (grid.features.columnReorder) {
                grid.features.columnReorder.on('beforedestroy', this.onColumnReorderBeforeDestroy, this);
              }

              this.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ColumnDragToolbar.prototype), "construct", this).call(this, grid, config);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;

              if (me.grid.features.columnReorder && !me.grid.features.columnReorder.isDestroyed) {
                me.detachFromColumnReorder();
              }

              me.element && me.element.remove();
              me.element = null;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ColumnDragToolbar.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "init",
            value: function init() {
              var me = this,
                  grid = me.grid;

              if (!grid.features.columnReorder) {
                return;
              }

              me.reorderDetacher = grid.features.columnReorder.on({
                gridheaderdragstart: function gridheaderdragstart(_ref) {
                  var context = _ref.context;
                  var column = grid.columns.getById(context.element.dataset.columnId);
                  me.showToolbar(column);
                },
                gridheaderdrag: function gridheaderdrag(_ref2) {
                  var context = _ref2.context;
                  return me.onDrag(context);
                },
                gridheaderabort: function gridheaderabort() {
                  me.hideToolbar();
                },
                gridheaderdrop: function gridheaderdrop(_ref3) {
                  var context = _ref3.context;

                  if (context.valid) {
                    me.hideToolbar();
                  } else {
                    me.onDrop(context);
                  }
                }
              });
              me.initialized = true;
            }
          }, {
            key: "onColumnReorderBeforeDestroy",
            value: function onColumnReorderBeforeDestroy() {
              this.detachFromColumnReorder();
            }
          }, {
            key: "detachFromColumnReorder",
            value: function detachFromColumnReorder() {
              var me = this;
              me.grid.features.columnReorder.un('beforedestroy', me.onColumnReorderBeforeDestroy, me);
              me.reorderDetacher && me.reorderDetacher();
              me.reorderDetacher = null;
            }
            /**
             * Initializes this feature on grid render.
             * @private
             */

          }, {
            key: "render",
            value: function render() {
              if (!this.initialized) this.init();
            } //endregion
            //region Toolbar

          }, {
            key: "showToolbar",
            value: function showToolbar(column) {
              var me = this,
                  buttons = me.grid.getColumnDragToolbarItems(column, []),
                  groups = [];
              me.clearTimeout(me.buttonHideTimer);
              me.clearTimeout(me.toolbarHideTimer);
              buttons.forEach(function (button) {
                var group = groups.find(function (group) {
                  return group.text === button.group;
                });

                if (!group) {
                  group = {
                    text: button.group,
                    buttons: []
                  };
                  groups.push(group);
                }

                group.buttons.push(button);
              });
              me.element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].append(me.grid.element, me.template(groups));
              me.groups = groups;
              me.buttons = buttons;
              me.column = column;
            }
          }, {
            key: "hideToolbar",
            value: function hideToolbar() {
              var me = this;
              return new Promise(function (resolve) {
                if (me.element && !me.toolbarHideTimer) {
                  me.element.classList.add('b-remove'); // TODO: use AnimationHelper when available

                  me.toolbarHideTimer = me.setTimeout(function () {
                    me.toolbarHideTimer = null;
                    me.element && me.element.remove();
                    me.element = null;
                    resolve();
                  }, 200);
                }
              });
            } //endregion
            //region Events

          }, {
            key: "onDrag",
            value: function onDrag(info) {
              var me = this;

              if (info.dragProxy.getBoundingClientRect().top - me.grid.element.getBoundingClientRect().top > 100) {
                me.element.classList.add('b-closer');
              } else {
                me.element.classList.remove('b-closer');
              }

              if (me.hoveringButton) {
                me.hoveringButton.classList.remove('b-hover');
                me.hoveringButton = null;
              }

              if (info.targetElement && info.targetElement.closest('.b-columndragtoolbar')) {
                me.element.classList.add('b-hover');
                var button = info.targetElement.closest('.b-columndragtoolbar  .b-target-button:not([data-disabled=true])');

                if (button) {
                  button.classList.add('b-hover');
                  me.hoveringButton = button;
                }
              } else {
                me.element.classList.remove('b-hover');
              }
            }
          }, {
            key: "onDrop",
            value: function onDrop(info) {
              var me = this;

              if (info.targetElement && info.targetElement.matches('.b-columndragtoolbar .b-target-button:not([data-disabled=true])')) {
                var buttonEl = info.targetElement,
                    button = me.buttons.find(function (button) {
                  return button.name === buttonEl.dataset.name;
                });

                if (button) {
                  buttonEl.classList.add('b-activate');
                  me.buttonHideTimer = me.setTimeout(function () {
                    me.hideToolbar();
                    button.onDrop({
                      column: me.column
                    });
                  }, 100);
                }
              } else {
                me.hideToolbar();
              }
            } //endregion

          }, {
            key: "template",
            value: function template(groups) {
              return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].tpl(_templateObject(), groups.map(function (group) {
                return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].tpl(_templateObject2(), group.buttons.map(function (btn) {
                  return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].tpl(_templateObject3(), btn.name, btn.disabled, btn.icon, btn.text);
                }), group.text);
              }));
            }
          }], [{
            key: "pluginConfig",
            //region Config
            // Plugin configuration. This plugin chains some of the functions in Grid
            get: function get() {
              return {
                after: ['render']
              };
            }
          }]);

          return ColumnDragToolbar;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]));

        ColumnDragToolbar.featureClass = 'b-hascolumndragtoolbar'; // used by default on touch devices, can be enabled otherwise

        ColumnDragToolbar._$name = 'ColumnDragToolbar';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(ColumnDragToolbar, _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isTouchDevice);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/ColumnPicker.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Grid/feature/ColumnPicker.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureColumnPickerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ColumnPicker;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/ColumnPicker
         */

        /**
         * Displays a column picker (to show/hide columns) in the header context menu. Columns can be displayed in sub menus
         * by region or tag. Grouped headers are displayed as menu hierarchies.
         *
         * This feature is <strong>enabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo columns
         * @classtype columnPicker
         * @externalexample feature/ColumnPicker.js
         */

        var ColumnPicker =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(ColumnPicker, _InstancePlugin);

          function ColumnPicker() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, ColumnPicker);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(ColumnPicker).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(ColumnPicker, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(grid, config) {
              this.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(ColumnPicker.prototype), "construct", this).call(this, grid, config);
            } //endregion
            //region Context menu

            /**
             * Get menu items, either a straight list of columns or sub menus per subgrid
             * @private
             * @param columnStore Column store to traverse
             * @returns {Object[]} Menu item configs
             */

          }, {
            key: "getColumnPickerItems",
            value: function getColumnPickerItems(columnStore) {
              var me = this;

              if (me.groupByRegion) {
                // submenus for grids regions
                return me.grid.regions.map(function (region) {
                  var columns = me.grid.getSubGrid(region).columns.records;
                  return {
                    text: _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].capitalizeFirstLetter(region),
                    menu: me.buildColumnMenu(columns),
                    disabled: columns.length === 0,
                    region: region
                  };
                });
              } else if (me.groupByTag) {
                // submenus for column tags
                var tags = {};
                columnStore.forEach(function (column) {
                  column.tags && column.hideable && column.tags.forEach(function (tag) {
                    if (!tags[tag]) {
                      tags[tag] = 1;
                    }
                  });
                }); // TODO: as checkitems, but how to handle toggling? hide a column only when all tags for it are unchecked?

                return Object.keys(tags).sort().map(function (tag) {
                  return {
                    text: _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].capitalizeFirstLetter(tag),
                    menu: me.buildColumnMenu(me.getColumnsForTag(tag)),
                    tag: tag,
                    onBeforeSubMenu: function onBeforeSubMenu(_ref) {
                      var item = _ref.item,
                          itemEl = _ref.itemEl;
                      me.refreshTagMenu(item, itemEl);
                    }
                  };
                });
              } else {
                // all columns in same menu
                return me.buildColumnMenu(columnStore.records);
              }
            }
            /**
             * Get all columns that has the specified tag
             * TODO: if tags are useful from somewhere else, move to ColumnStore
             * @private
             * @param tag
             * @returns {Grid.column.Column[]}
             */

          }, {
            key: "getColumnsForTag",
            value: function getColumnsForTag(tag) {
              // TODO: if tags are usefull from somewhere else, move to ColumnStore
              return this.grid.columns.records.filter(function (column) {
                return column.tags && column.tags.includes(tag) && column.hideable !== false;
              });
            }
            /**
             * Refreshes checked status for a tag menu. Needed since columns can appear under multiple tags.
             * @private
             */

          }, {
            key: "refreshTagMenu",
            value: function refreshTagMenu(item, itemEl) {
              var columns = this.getColumnsForTag(item.tag);
              columns.forEach(function (column) {
                var subItem = item.items.find(function (subItem) {
                  return subItem.column === column;
                });
                if (subItem) subItem.checked = column.hidden !== true;
              });
            }
            /**
             * Traverses columns to build menu items for the column picker.
             * @private
             */

          }, {
            key: "buildColumnMenu",
            value: function buildColumnMenu(columns) {
              var _this = this;

              var currentRegion = columns.length > 0 && columns[0].region,
                  grid = this.grid;
              return columns.reduce(function (items, column) {
                var visibleInRegion = _this.grid.columns.visibleColumns.filter(function (col) {
                  return col.region === column.region;
                });

                if (column.hideable !== false) {
                  var itemConfig = {
                    grid: grid,
                    text: column.text,
                    column: column,
                    name: column.id,
                    checked: column.hidden !== true,
                    disabled: column.hidden !== true && visibleInRegion.length === 1,
                    cls: column.region !== currentRegion ? 'b-separator' : ''
                  };
                  currentRegion = column.region;

                  if (column.children) {
                    itemConfig.menu = _this.buildColumnMenu(column.children);
                  }

                  items.push(itemConfig);
                }

                return items;
              }, []);
            }
            /**
             * Supply items for headers context menu.
             * @private
             * @param column Header for this column
             * @param items Array of items to add to
             * @returns {Object[]} Modified items
             */

          }, {
            key: "getHeaderMenuItems",
            value: function getHeaderMenuItems(column, items) {
              var me = this,
                  grid = me.grid,
                  columns = grid.columns;

              if (column.showColumnPicker !== false && columns.some(function (col) {
                return col.hideable;
              })) {
                // column picker
                items.push({
                  text: me.L('columnsMenu'),
                  name: 'columnPicker',
                  icon: 'b-fw-icon b-icon-columns',
                  cls: 'b-separator',
                  weight: 100,
                  menu: me.getColumnPickerItems(columns),
                  onToggle: me.onColumnToggle
                });
              } // menu item for hiding this column


              if (column.hideable !== false) {
                var visibleInRegion = columns.visibleColumns.filter(function (col) {
                  return col.region === column.region;
                });
                items.push({
                  text: me.L('hideColumn'),
                  icon: 'b-fw-icon b-icon-hide-column',
                  weight: 101,
                  name: 'hideColumn',
                  disabled: visibleInRegion.length === 1,
                  onItem: function onItem() {
                    return column.hide();
                  }
                });
              }
            }
            /**
             * Handler for column hide/show menu checkitems.
             * @private
             * @param {Object} The {@link Common.widget.MenuItem#event-toggle} event.
             */

          }, {
            key: "onColumnToggle",
            value: function onColumnToggle(_ref2) {
              var menu = _ref2.menu,
                  item = _ref2.item,
                  checked = _ref2.checked;

              if (!!item.column.hidden !== !checked) {
                item.column[checked ? 'show' : 'hide']();
                var grid = item.grid,
                    column = item.column,
                    columns = grid.columns,
                    siblingItems = menu.items,
                    visibleInRegion = columns.visibleColumns.filter(function (col) {
                  return col.region === item.column.region;
                }),
                    currentMenu = grid.features.contextMenu.currentMenu,
                    hideItem = currentMenu.items.find(function (item) {
                  return item.name === 'hideColumn';
                }); // Do not allow user to hide the last column in any region

                if (visibleInRegion.length === 1) {
                  var lastVisibleItem = siblingItems.find(function (i) {
                    return i.name === visibleInRegion[0].id;
                  });

                  if (lastVisibleItem) {
                    lastVisibleItem.disabled = true;
                  } // Also disable "Hide column" item if only one column left in this region


                  if (hideItem && column.region === item.column.region) {
                    hideItem.disabled = true;
                  }
                } // Multiple columns visible, enable "hide-column" and all items for that region
                else {
                    visibleInRegion.forEach(function (col) {
                      var siblingItem = siblingItems.find(function (sibling) {
                        return sibling.column === col;
                      });

                      if (siblingItem) {
                        siblingItem.disabled = false;
                      }
                    });

                    if (hideItem && column.region === item.column.region) {
                      hideItem.disabled = false;
                    }
                  }

                if (item.menu) {
                  // Reflect status in submenu.
                  // Cannot use short form () => foo because eachWidget aborts on return of false
                  item.menu.eachWidget(function (subItem) {
                    subItem.checked = checked;
                  });
                }

                var parentItem = menu.owner;

                if (parentItem && parentItem.column === column.parent) {
                  var anyChecked = siblingItems.some(function (subItem) {
                    return subItem.checked === true;
                  });
                  parentItem.checked = anyChecked;
                }
              }
            }
            /**
             * Supply items to ColumnDragToolbar
             * @private
             */

          }, {
            key: "getColumnDragToolbarItems",
            value: function getColumnDragToolbarItems(column, items) {
              var visibleInRegion = this.grid.columns.visibleColumns.filter(function (col) {
                return col.region === column.region;
              });

              if (column.hideable !== false && visibleInRegion.length > 1) {
                items.push({
                  text: this.L('hideColumnShort'),
                  group: this.L('Column'),
                  icon: 'b-fw-icon b-icon-hide-column',
                  weight: 101,
                  name: 'hideColumn',
                  onDrop: function onDrop(_ref3) {
                    var column = _ref3.column;
                    return column.hide();
                  }
                });
              }

              return items;
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Groups columns in the picker by region (each region gets its own sub menu)
                 * @config {Boolean}
                 * @default
                 */
                groupByRegion: false,

                /**
                 * Groups columns in the picker by tag, each column may be shown under multiple tags. See
                 * {@link Grid.column.Column#config-tags}
                 * @config {Boolean}
                 * @default
                 */
                groupByTag: false
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['getHeaderMenuItems', 'getColumnDragToolbarItems']
              };
            }
          }]);

          return ColumnPicker;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        ColumnPicker._$name = 'ColumnPicker';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(ColumnPicker, true);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/ColumnReorder.js":
      /*!*************************************************!*\
        !*** ../Grid/lib/Grid/feature/ColumnReorder.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureColumnReorderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ColumnReorder;
        });
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/DragHelper.js */
        "../Grid/lib/Common/helper/DragHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");

        var productName = 'scheduler'; // TODO: Make this work for grouped columns

        /**
         * @module Grid/feature/ColumnReorder
         */

        /**
         * Allows user to reorder columns by dragging headers. To get notified about column reorder listen to `change` event
         * on {@link Grid.data.ColumnStore columns} store.
         *
         * This feature is <strong>enabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo columns
         * @classtype columnReorder
         * @externalexample feature/ColumnReorder.js
         */

        var ColumnReorder =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ColumnReorder, _Delayable);

          function ColumnReorder() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ColumnReorder);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ColumnReorder).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ColumnReorder, [{
            key: "construct",
            //region Init
            value: function construct(grid) {
              this.ignoreSelectors = ['.b-grid-header-resize-handle', '.b-field'];
              this.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ColumnReorder.prototype), "construct", this).call(this, grid);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.dragHelper && this.dragHelper.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ColumnReorder.prototype), "doDestroy", this).call(this);
            }
            /**
             * Initialize drag & drop (called from render)
             * @private
             */

          }, {
            key: "init",
            value: function init() {
              var me = this,
                  grid = me.grid,
                  gridEl = grid.element,
                  containers = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].children(gridEl, '.b-grid-headers');

              containers.push.apply(containers, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].children(gridEl, '.b-grid-header-children')));

              if (me.dragHelper) {
                // update the dragHelper with the new set of containers it should operate upon
                me.dragHelper.containers = containers;
              } else {
                me.dragHelper = new _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
                  name: 'columnReorder',
                  mode: 'container',
                  dragThreshold: 10,
                  targetSelector: '.b-grid-header',
                  outerElement: gridEl.querySelector('header.b-grid-header-container'),
                  containers: containers,
                  isElementDraggable: function isElementDraggable(element) {
                    var abort = Boolean(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].up(element, me.ignoreSelectors.join(',')));

                    if (abort) {
                      return false;
                    }

                    var columnEl = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].up(element, this.targetSelector),
                        column = columnEl && grid.columns.getById(columnEl.dataset.columnId),
                        isLast = column && column.childLevel === 0 && grid.subGrids[column.region].columns.count === 1; // TODO: If we want to prevent dragging last column out of group we can use the code below...

                    /*isLast = column.level !== 0
                            // In grouped header, do not allow dragging last remaining child
                            ? column.parent.children.length === 1
                            // Not in a grouped header, do not allow dragging last remaining column
                            : grid.subGrids[column.region].columns.count === 1;*/


                    return Boolean(column) && column.draggable !== false && !isLast;
                  },
                  ignoreSelector: '.b-filter-icon,.b-grid-header-resize-handle',
                  listeners: {
                    dragstart: me.onDragStart,
                    drag: me.onDrag,
                    drop: me.onDrop,
                    thisObj: me
                  }
                });
                me.relayEvents(me.dragHelper, ['dragstart', 'drag', 'drop', 'abort'], 'gridheader');
              }
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid

          }, {
            key: "onDrag",
            //endregion
            //region Events (drop)
            value: function onDrag(_ref) {
              var context = _ref.context,
                  event = _ref.event;

              var me = this,
                  targetHeader = _Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].fromElement(event.target, 'header'); // If SubGrid is configured with a sealed column set, do not allow moving into it


              if (targetHeader && targetHeader.subGrid.sealedColumns) {
                context.valid = false;
                return;
              } // Require that we drag inside grid header while dragging if we don't have a drag toolbar


              if (!me.grid.features.columnDragToolbar) {
                context.valid = Boolean(event.target.closest('.b-grid-headers'));
              }
            }
          }, {
            key: "onDragStart",
            value: function onDragStart() {
              var me = this;

              if (!me.grid.features.columnDragToolbar) {
                var headerContainerBox = me.grid.element.querySelector('.b-grid-header-container').getBoundingClientRect();
                me.dragHelper.minY = headerContainerBox.top;
                me.dragHelper.maxY = headerContainerBox.bottom;
              }

              this.grid.headerContainer.classList.add('b-dragging-header');
            }
            /**
             * Handle drop
             * @private
             */

          }, {
            key: "onDrop",
            value: function onDrop(_ref2) {
              var context = _ref2.context;

              if (!context.valid) {
                return this.onInvalidDrop({
                  context: context
                });
              }

              var me = this,
                  grid = me.grid,
                  element = context.dragging,
                  onHeader = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].up(context.target, '.b-grid-header'),
                  onColumn = grid.columns.get(onHeader.dataset.column),
                  toRegion = context.draggedTo.dataset.region || onColumn.region,
                  sibling = context.insertBefore,
                  column = grid.columns.getById(element.dataset.columnId),
                  insertBefore = sibling ? grid.columns.getById(sibling.dataset.columnId) : grid.subGrids[toRegion].columns.last.nextSibling,
                  newParent = insertBefore ? insertBefore.parent : grid.columns.rootNode;

              grid.headerContainer.classList.remove('b-dragging-header'); // Dropped into its current position in the same SubGrid - abort

              if (toRegion === column.region && onColumn === column.previousSibling) {
                me.dragHelper.abort();
                return;
              } // Check if we should remove last child


              var emptyParent = column.parent && column.parent.children.length === 1 && column.parent;

              if (emptyParent) {
                emptyParent.parent.removeChild(emptyParent);
              } // Clean up element used during drag drop as it will not be removed by Grid when it refreshes its header elements


              element.remove();
              column.region = toRegion; // Insert the column into its new place

              newParent.insertChild(column, insertBefore);
            }
            /**
             * Handle invalid drop
             * @private
             */

          }, {
            key: "onInvalidDrop",
            value: function onInvalidDrop(_ref3) {
              var context = _ref3.context;
              this.grid.headerContainer.classList.remove('b-dragging-header');
            } //endregion
            //region Render

            /**
             * Updates DragHelper with updated headers when grid contents is rerendered
             * @private
             */

          }, {
            key: "renderContents",
            value: function renderContents() {
              // columns shown, hidden or reordered
              this.init();
            }
            /**
             * Initializes this feature on grid render.
             * @private
             */

          }, {
            key: "render",
            value: function render() {
              // always reinit on render
              this.init();
            } //endregion

          }], [{
            key: "pluginConfig",
            get: function get() {
              return {
                after: ['render', 'renderContents']
              };
            }
          }]);

          return ColumnReorder;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_11__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__["default"]));

        ColumnReorder.featureClass = 'b-column-reorder';
        ColumnReorder._$name = 'ColumnReorder';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(ColumnReorder, true);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/ColumnResize.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Grid/feature/ColumnResize.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureColumnResizeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ColumnResize;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/helper/ResizeHelper.js */
        "../Grid/lib/Common/helper/ResizeHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/ColumnResize
         */

        /**
         * Enables user to resize columns by dragging a handle on the righthand side of the header. To get notified about column
         * resize listen to `change` event on {@link Grid.data.ColumnStore columns} store.
         *
         * This feature is <strong>enabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo columns
         * @classtype columnResize
         * @externalexample feature/ColumnResize.js
         */

        var ColumnResize =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ColumnResize, _InstancePlugin);

          function ColumnResize() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ColumnResize);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ColumnResize).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ColumnResize, [{
            key: "construct",
            //region Init
            value: function construct(grid, config) {
              var me = this;
              me.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ColumnResize.prototype), "construct", this).call(this, grid, config);

              me.resizer = new _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
                name: 'columnResize',
                targetSelector: '.b-grid-header',
                handleSelector: '.b-grid-header-resize-handle',
                outerElement: grid.element,
                listeners: {
                  resizestart: me.onResizeStart,
                  resizing: me.onResizing,
                  resize: me.onResize,
                  thisObj: me
                }
              });
            } //endregion
            // This plugin needs no functions chaining into the client grid

          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.resizer && this.resizer.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ColumnResize.prototype), "doDestroy", this).call(this);
            } //region Events

          }, {
            key: "onResizeStart",
            value: function onResizeStart(_ref) {
              var context = _ref.context;
              var me = this,
                  column = context.column = me.grid.columns.getById(context.element.dataset.columnId);
              me.resizer.minWidth = column.minWidth; // remove minWidth value as it's used as a rendering workaround for IE flexbox bugs

              context.element.style.minWidth = '';
              me.grid.element.classList.add('b-column-resizing');
            }
            /**
             * Handle drag event - resize the column live unless it's a touch gesture
             * @private
             */

          }, {
            key: "onResizing",
            value: function onResizing(_ref2) {
              var context = _ref2.context;

              if (context.valid && this.liveResize) {
                this.grid.dragResizing = true;
                context.column.width = context.newWidth;
              }
            }
            /**
             * Handle drop event (only used for touch)
             * @private
             */

          }, {
            key: "onResize",
            value: function onResize(_ref3) {
              var context = _ref3.context;
              var me = this,
                  column = context.column;
              me.grid.element.classList.remove('b-column-resizing');

              if (context.valid) {
                if (me.liveResize) {
                  me.grid.dragResizing = false;
                  me.grid.afterColumnsResized();
                } else {
                  context.column.width = context.newWidth;
                } // In case of IE 11 we should calculate flex basis to fix header width
                // covered by ColumnResize.t


                if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isIE11 && column.parent && column.parent.flex) {
                  var parent = column.parent,
                      headerEl = me.grid.getHeaderElement(parent.id);
                  headerEl.style.flexBasis = parent.children.reduce(function (result, column) {
                    return result + me.grid.getHeaderElement(column.id).offsetWidth;
                  }, 0) + 'px';
                }
              }
            }
            /**
             * Start resizing on touch start. Only cares about the first touch.
             * @private
             * @param event
             */

            /*onElementTouchStart(event) {
             const me     = this,
             target = event.target;
              if (target.classList.contains('b-resizer')) {
             me.startResize(target, event.touches[0].clientX);
             event.preventDefault();
             }
             }*/

            /**
             * Update size on touch move.
             * @private
             * @param event
             */

            /*onElementTouchMove(event) {
             if (this.element) {
             this.updateResize(event.touches[0].clientX);
             event.preventDefault();
             }
             }*/

            /**
             * Stop resizing on touch end.
             * @private
             * @param event
             * @returns {Boolean}
             */

            /*onElementTouchEnd(event) {
             if (this.element) {
             this.endResize();
             event.preventDefault();
             return false;
             }
             }*/
            //endregion

          }, {
            key: "liveResize",
            set: function set(liveResize) {
              if (liveResize === 'auto') {
                liveResize = !_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isMobileSafari;
              }

              this._liveResize = liveResize;
            },
            get: function get() {
              return this._liveResize;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Resize all cells below a resizing header during dragging.
                 * `'auto'` means `true` on non-mobile platforms.
                 * @config {String/Boolean}
                 * @default
                 */
                liveResize: 'auto'
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return [];
            }
          }]);

          return ColumnResize;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        ColumnResize.featureClass = 'b-column-resize';
        ColumnResize._$name = 'ColumnResize';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(ColumnResize, true);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/ContextMenu.js":
      /*!***********************************************!*\
        !*** ../Grid/lib/Grid/feature/ContextMenu.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureContextMenuJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ContextMenu;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler'; //TODO: Context menu should hide when clicking elsewhere

        /**
         * @module Grid/feature/ContextMenu
         */

        /**
         * Right click to display context menu for headers and cells. Items for the menu are requested by calling
         * {@link Grid.view.Grid#function-getHeaderMenuItems Grid.getHeaderMenuItems()} or
         * {@link Grid.view.Grid#function-getCellMenuItems Grid.getCellMenuItems()} (see {@link Grid.feature.Sort Sort} feature).
         * It is also possible to add items via the features config and via column configs. See examples below.
         *
         * Add extra items to both header and cell for all columns:
         *
         * ```javascript
         * // Extra items for all columns
         * const grid = new Grid({
         *   features: {
         *     contextMenu: {
         *       headerItems: [
         *         { text: 'My header item', icon: 'fa fa-car', weight: 200, onItem : () => ... }
         *       ],
         *
         *       cellItems: [
         *         { text: 'My cell item', icon: 'fa fa-bus', weight: 200, onItem : () => ... }
         *       ]
         *     }
         *   }
         * });
         * ```
         *
         * Add extra items to both header and cell for a single column:
         *
         * ```javascript
         * // Extra items for single column
         * const grid = new Grid({
         *   columns: [
         *     { field: 'name', text: 'Name', headerMenuItems: [
         *       { text: 'My unique header item', icon: 'fa fa-flask', onItem : () => ... }
         *     ]},
         *     { field: 'city', text: 'City', cellMenuItems: [
         *       { text: 'My unique cell item', icon: 'fa fa-beer', onItem : () => ... }
         *     ]},
         *   ]
         * });
         * ```
         *
         * It is also possible to manipulate the default items and add new ones in a processing function (same pattern applies
         * for header menu):
         *
         * ```javascript
         * const grid = new Grid({
         *   features: {
         *     contextMenu: {
         *       processCellItems({items, record}) {
         *           if (record.cost > 5000) {
         *              items.push({ text : 'Split cost' });
         *           }
         *       }
         *     }
         *   }
         * });
         * ```
         *
         * This feature is <strong>enabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         * @demo filtering
         * @classtype contextMenu
         * @externalexample feature/ContextMenu.js
         */

        var ContextMenu =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ContextMenu, _InstancePlugin);

          function ContextMenu() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ContextMenu);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ContextMenu).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ContextMenu, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fired from grid before the context menu is shown for a header. Allows manipulation of the items
             * to show in the same way as in `processHeaderItems`. Returning false from a listener prevents the
             * menu from being shown.
             * @event headerContextMenuBeforeShow
             * @preventable
             * @param {Grid.view.Grid} source
             * @param {Object} items Menu item configs
             * @param {Grid.column.Column} column Column
             */

            /**
             * Fired from grid after showing the context menu for a header
             * @event headerContextMenuShow
             * @preventable
             * @param {Grid.view.Grid} source
             * @param {Common.widget.Menu} menu The menu
             * @param {Grid.column.Column} column Column
             */

            /**
             * Fired from grid before the context menu is shown for a cell. Allows manipulation of the items
             * to show in the same way as in `processCellItems`. Returning false from a listener prevents the
             * menu from being shown.
             * @event cellContextMenuBeforeShow
             * @preventable
             * @param {Grid.view.Grid} source
             * @param {Object} items Menu item configs
             * @param {Grid.column.Column} column Column
             * @param {Common.data.Model} record Record
             */

            /**
             * Fired from grid after showing the context menu for a cell
             * @event cellContextMenuShow
             * @preventable
             * @param {Grid.view.Grid} source
             * @param {Common.widget.Menu} menu The menu
             * @param {Grid.column.Column} column Column
             * @param {Common.data.Model} record Record
             */

            /**
             * Fired when an item is selected in the context menu.
             * @event contextMenuItem
             * @param {Grid.view.Grid} grid The grid
             * @param {Object} item Selected menu item
             * @param {Grid.column.Column} column Column
             * @param {HTMLElement} itemEl Menu item element
             */

            /**
             * Fired when an check item is toggled in the context menu.
             * @event contextMenuToggleItem
             * @param {Grid.view.Grid} grid The grid
             * @param {Object} item Selected menu item
             * @param {Grid.column.Column} column Column
             * @param {Boolean} checked Checked or not
             * @param {HTMLElement} itemEl Menu item element
             */
            //endregion
            //region Init
            value: function construct(grid, config) {
              this.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ContextMenu.prototype), "construct", this).call(this, grid, config);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              if (this.currentMenu) {
                this.currentMenu.destroy();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ContextMenu.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid.
            // The contextmenu event is emulated from a taphold gesture on touch platforms.

          }, {
            key: "onElementContextMenu",
            //endregion
            //region Events
            value: function onElementContextMenu(event) {
              this.triggerEvent === 'contextmenu' && this.showContextMenu(event);
            }
          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              this.triggerEvent === 'click' && this.showContextMenu(event);
            }
          }, {
            key: "onElementDblClick",
            value: function onElementDblClick(event) {
              this.triggerEvent === 'dblclick' && this.showContextMenu(event);
            }
          }, {
            key: "onElementKeyDown",
            value: function onElementKeyDown(event) {
              if (!event.handled && event.target.matches('.b-grid-header.b-depth-0')) {
                switch (event.key) {
                  case ' ':
                  case 'ArrowDown':
                    this.showContextMenu(event);
                    break;
                }
              }
            }
            /**
             * Show context menu.
             * @param event
             * @fires contextmenuitem
             * @fires contextmenutoggleitem
             * @private
             */

          }, {
            key: "showContextMenu",
            value: function showContextMenu(event) {
              var me = this,
                  grid = me.grid,
                  target = event.target,
                  header = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(target, '.b-grid-header'),
                  cellData = grid.getEventData(event);

              if (header) {
                me.handleHeaderContextMenu(header, event);
              } else if (cellData) {
                me.handleCellContextMenu(cellData, event);
              }
            }
          }, {
            key: "handleHeaderContextMenu",
            value: function handleHeaderContextMenu(header, event) {
              if (header.dataset.column) {
                var me = this,
                    grid = me.grid,
                    column = grid.columns.getById(header.dataset.columnId),
                    setColumn = function setColumn(item) {
                  if (!item.column) {
                    item.column = column;
                  }

                  var menu = item.menu;

                  if (menu) {
                    if (!Array.isArray(menu)) {
                      menu = menu.items || menu.widgets;
                    }

                    menu.forEach(setColumn);
                  }
                };

                if (column.enableHeaderContextMenu !== false) {
                  // User's items for all headers and for specific column correspondingly. Check Context Menu demo for details.
                  var items = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(me.headerItems).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(column.headerMenuItems || [])),
                      processHeaderItems = me.processHeaderItems,
                      eventParams = {
                    items: items,
                    column: column,
                    event: event,
                    element: header
                  }; // getHeaderMenuItems() is chained by mixins, thus each feature can supply items


                  grid.getHeaderMenuItems(column, items);

                  if ((!processHeaderItems || processHeaderItems(eventParams) !== false) && items.length > 0) {
                    event.preventDefault();
                    items.sort(function (a, b) {
                      return (a.weight || 150) - (b.weight || 150);
                    }); // Propagate the operating column down to all MenuItem levels
                    // Will not override if they are preconfigured with a column.

                    items.forEach(setColumn); // Trigger event that allows preventing menu or manipulating its items

                    if (grid.trigger('headerContextMenuBeforeShow', eventParams) !== false) {
                      // Align to header element when using arrow down key
                      me.currentMenu = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].showContextMenu(event.type === 'keydown' ? header : [event.clientX + 1, event.clientY + 1], {
                        owner: me.client,
                        constrainTo: document,
                        cls: 'b-context-menu',
                        items: items,
                        // We can only realign if we are aligning to an element.
                        scrollAction: 'hide',
                        onItem: function onItem(_ref) {
                          var source = _ref.source,
                              item = _ref.item,
                              element = _ref.element;
                          grid.trigger('contextMenuItem', {
                            source: grid,
                            item: item,
                            column: column,
                            element: element
                          });
                        },
                        onToggle: function onToggle(_ref2) {
                          var source = _ref2.source,
                              item = _ref2.item,
                              checked = _ref2.checked,
                              element = _ref2.element;
                          grid.trigger('contextMenuToggleItem', {
                            source: grid,
                            item: item,
                            column: column,
                            checked: checked,
                            element: element
                          });
                        },
                        onDestroy: function onDestroy() {
                          // If menu is destroyed by WidgetHelper, make sure we don't keep a reference to it anymore
                          me.currentMenu = null;
                        },
                        listeners: {
                          show: function show(_ref3) {
                            var menu = _ref3.source;
                            eventParams.menu = menu;
                            grid.trigger('headerContextMenuShow', eventParams);
                          }
                        }
                      });
                    }
                  }
                }
              }
            }
          }, {
            key: "handleCellContextMenu",
            value: function handleCellContextMenu(cellData, event) {
              var me = this,
                  grid = me.grid,
                  cell = cellData.cellElement,
                  column = grid.columns.getById(cellData.columnId);

              if (column.enableCellContextMenu !== false) {
                // Process the gesture as navigation so that the use may select/multiselect
                // the items to include in their context menu operation.
                // Also select if not already selected.
                grid.focusCell(cellData.cellSelector, {
                  doSelect: !grid.isSelected(cellData.id),
                  event: event
                });

                var record = cellData.record,
                    items = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(me.cellItems || []).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(column.cellMenuItems || [])),
                    processCellItems = me.processCellItems,
                    eventParams = {
                  items: items,
                  column: column,
                  event: event,
                  record: record,
                  element: cell
                }; // getCellMenuItems() is chained by mixins, thus each feature can supply items


                grid.getCellMenuItems(column, record, items);

                if ((!processCellItems || processCellItems(eventParams) !== false) && items.length > 0) {
                  items.forEach(function (item) {
                    item.column = column;
                    item.record = record;
                  });
                  event.preventDefault();
                  items.sort(function (a, b) {
                    return (a.weight || 150) - (b.weight || 150);
                  }); // Trigger event that allows preventing menu or manipulating its items

                  if (grid.trigger('cellContextMenuBeforeShow', eventParams) !== false) {
                    me.currentMenu = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].showContextMenu([event.clientX + 1, event.clientY + 1], {
                      owner: me.client,
                      items: items,
                      // Load up the item event with the contextual info
                      onBeforeItem: function onBeforeItem(itemEvent) {
                        Object.assign(itemEvent, eventParams);
                      },
                      onItem: function onItem(_ref4) {
                        var item = _ref4.item;
                        grid.trigger('contextMenuItem', {
                          source: grid,
                          item: item,
                          column: column,
                          record: record,
                          cell: cell
                        });
                      },
                      onClose: function onClose(_ref5) {
                        var reason = _ref5.reason; // return focus to grid when context menu is closed, if not cause by clicking outside of grid

                        if (reason !== 'outside') {
                          grid.element.focus();
                        }
                      },
                      onDestroy: function onDestroy() {
                        // If menu is destroyed by WidgetHelper, make sure we don't keep a reference to it anymore
                        me.currentMenu = null;
                      },
                      listeners: {
                        show: function show(_ref6) {
                          var menu = _ref6.source;
                          eventParams.menu = menu;
                          grid.trigger('cellContextMenuShow', eventParams);
                        }
                      }
                    });
                  }
                }
              }
            }
            /**
             * Hides the context menu
             * @protected
             * @internal
             */

          }, {
            key: "hideContextMenu",
            value: function hideContextMenu(animate) {
              this.currentMenu && this.currentMenu.hide(animate);
            } //endregion
            //region Getters/Setters

          }, {
            key: "triggerEvent",
            get: function get() {
              return this._triggerEvent || this.client.contextMenuTriggerEvent;
            },
            set: function set(value) {
              this._triggerEvent = value;
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Extra items to add to the header context menu. See {@link Common.widget.MenuItem} for more info.
                 *
                 * ```javascript
                 * features : {
                 *     contextMenu : {
                 *         headerItems : [
                 *             { text : 'Header item', onItem : () => ... }
                 *         ]
                 *     }
                 * }
                 * ```
                 *
                 * @config {Object[]}
                 */
                headerItems: [],

                /**
                 * A function called before displaying the header menu that allows manipulations of its items. Called with a
                 * single parameter with format { column, items }. Returning `false` from this function prevents
                 * the menu from being shown.
                 *
                 * ```javascript
                 * features : {
                 *     contextMenu : {
                 *         processHeaderItems({record, items}) {
                 *             // Add or remove items here as needed
                 *             if (column.field === 'age') {
                 *                 items.push({ text: 'Hide youngsters', icon : 'b-fa b-fa-fw b-fa-baby' })
                 *             }
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @config {Function}
                 */
                processHeaderItems: null,

                /**
                 * Extra items to add to the cell context menu. See {@link Common.widget.MenuItem} for more info.
                 *
                 * ```javascript
                 * features : {
                 *     contextMenu : {
                 *         cellItems : [
                 *             { text : 'Cell item', onItem : () => ... }
                 *         ]
                 *     }
                 * }
                 * ```
                 *
                 * @config {Object[]}
                 */
                cellItems: [],

                /**
                 * A function called before displaying the cell menu that allows manipulations of its items. Called with a
                 * single parameter with format { record, items }. Returning `false` from this function prevents
                 * the menu from being shown.
                 *
                 * ```javascript
                 * features : {
                 *     contextMenu : {
                 *         processCellItems({record, items}) {
                 *             // Add or remove items here as needed
                 *             if (record.age > 50) {
                 *                 items.push({ text: 'Add extra vacation', icon : 'b-fa b-fa-fw b-fa-umbrella-beach' })
                 *             }
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @config {Function}
                 */
                processCellItems: null,

                /**
                 * Event which is used to show context menu.
                 * Available options are: 'contextmenu', 'click', 'dblclick'.
                 * Default value is used from {@link Grid/view/Grid#config-contextMenuTriggerEvent}
                 * @config {String}
                 */
                triggerEvent: null
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                assign: ['showContextMenu'],
                chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onElementKeyDown']
              };
            }
          }]);

          return ContextMenu;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]);

        ContextMenu.featureClass = '';
        ContextMenu._$name = 'ContextMenu';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(ContextMenu, true);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/Filter.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Grid/feature/Filter.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureFilterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Filter;
        });
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler'; //TODO: Format value in header filter tooltip (see date)

        /**
         * @module Grid/feature/Filter
         */

        /**
         * Feature that allows filtering of the grid by settings filters on columns. The actual filtering is done by the store.
         * For info on programmatically handling filters, see {@link Common.data.mixin.StoreFilter StoreFilter}.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // Filtering turned on but no default filter
         * let grid = new Grid({
         *   features : {
         *     filter : true
         *   }
         * });
         *
         * // Using default filter
         * let grid = new Grid({
         *   features : {
         *     filter : { property : 'city', value : 'Gavle' }
         *   }
         * });
         *
         * // Custom filtering function for a column
         * let grid = new Grid({
         *    features : {
         *        filter : true
         *    },
         *
         *    columns: [
         *        {
         *          field      : 'age',
         *          text       : 'Age',
         *          type       : 'number',
         *          // Custom filtering function that checks "greater than" no matter which field user filled in :)
         *          filterable : ({ record, value, operator }) => record.age > value
         *        }
         *    ]
         * });
         *
         * @demo filtering
         * @classtype filter
         * @externalexample feature/Filter.js
         */

        var Filter =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Filter, _InstancePlugin);

          function Filter() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Filter);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Filter).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Filter, [{
            key: "construct",
            value: function construct(grid, config) {
              var me = this;
              me.grid = grid;
              me.store = grid.store;
              me.closeFilterEditor = me.closeFilterEditor.bind(me);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Filter.prototype), "construct", this).call(this, grid, config);

              me.store.on({
                filter: me.onStoreFilter
              }, me);

              if (config && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_5___default()(config) === 'object') {
                me.store.filter(config, null, me.client.isConfiguring);
              }
            } //endregion
            //region Plugin config

          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.filterTip && me.filterTip.destroy();
              me.store.un({
                sort: me.onStoreFilter
              }, me);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Filter.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Refresh headers

            /**
             * Update headers to match stores filters. Called on store load and grid header render.
             * @param reRenderRows Also refresh rows?
             * @private
             */

          }, {
            key: "refreshHeaders",
            value: function refreshHeaders(reRenderRows) {
              var me = this,
                  grid = me.grid,
                  element = grid.headerContainer;

              if (element) {
                // remove .latest from all filters, will be applied to actual latest
                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].children(element, '.b-filter-icon.b-latest').forEach(function (iconElement) {
                  return iconElement.classList.remove('b-latest');
                });

                if (!me.filterTip) {
                  me.filterTip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
                    forElement: element,
                    forSelector: '.b-filter-icon',
                    getHtml: function getHtml(_ref) {
                      var forElement = _ref.forElement;
                      return forElement.dataset.filterText;
                    }
                  });
                }

                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = grid.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var column = _step.value;

                    if (column.filterable !== false) {
                      var filter = me.store.filters.getBy('property', column.field),
                          headerEl = column.element;

                      if (headerEl) {
                        var textEl = column.textWrapper,
                            filterIconEl = textEl && textEl.querySelector('.b-filter-icon'),
                            filterText = void 0;

                        if (filter) {
                          filterText = me.L('filter') + ': ' + (typeof filter === 'string' ? filter : "".concat(filter.operator, " ").concat(filter.displayValue || filter.value || '')); //TODO: filter.value needs to be formatted using column format or something
                        } else {
                          filterText = me.L('applyFilter');
                        }

                        if (!filterIconEl) {
                          // putting icon in header text to have more options for positioning it
                          filterIconEl = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createElement({
                            parent: textEl,
                            tag: 'div',
                            className: 'b-filter-icon',
                            dataset: {
                              filterText: filterText
                            }
                          });
                          headerEl.classList.add('b-filterable');
                        } else {
                          filterIconEl.dataset.filterText = filterText;
                        } // latest applied filter distinguished with class to enable highlighting etc.


                        if (column.field === me.store.latestFilterField) filterIconEl.classList.add('b-latest');
                        headerEl.classList[filter ? 'add' : 'remove']('b-filter'); // When IE11 support is dropped
                        // headerEl.classList.toggle('b-filter', !!filter);
                      }

                      column.meta.isFiltered = !!filter;
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }

                if (reRenderRows) {
                  grid.refreshRows();
                }
              }
            } //endregion
            //region Filter

          }, {
            key: "applyFilter",
            value: function applyFilter(config) {
              var store = this.store,
                  column = this.grid.columns.get(config.property);

              if (typeof column.filterable === 'function') {
                store.filter({
                  filterBy: function filterBy(record) {
                    return column.filterable(Object.assign({}, config, {
                      record: record
                    }));
                  },
                  // To be able to retrieve the value next time filtering popup is shown, not actually used by the filter
                  value: config.value,
                  property: config.property,
                  operator: config.operator,
                  displayValue: config.displayValue
                });
              } else {
                store.filter(config);
              }
            } // TODO: break out as own views, registering with Filter the same way columns register with ColumnManager

          }, {
            key: "getPopupDateItems",
            value: function getPopupDateItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback) {
              var me = this,
                  onClose = changeCallback,
                  onClear = closeCallback;

              function onChange(_ref2) {
                var source = _ref2.source,
                    value = _ref2.value;

                if (value == null) {
                  closeCallback();
                } else {
                  me.applyFilter({
                    property: field,
                    operator: source.operator,
                    value: value,
                    displayValue: source._value
                  });
                  changeCallback();
                }
              }

              return [{
                type: 'date',
                ref: 'on',
                placeholder: me.L('on'),
                clearable: true,
                label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
                value: filter && filter.operator === '=' ? filter.value : initialValue,
                operator: '=',
                onChange: onChange,
                onClose: onClose,
                onClear: onClear
              }, {
                type: 'date',
                ref: 'before',
                placeholder: me.L('before'),
                clearable: true,
                label: '<i class="b-fw-icon b-icon-filter-before"></i>',
                value: filter && filter.operator === '<' ? filter.value : null,
                operator: '<',
                onChange: onChange,
                onClose: onClose,
                onClear: onClear
              }, {
                type: 'date',
                ref: 'after',
                cls: 'b-last-row',
                placeholder: me.L('after'),
                clearable: true,
                label: '<i class="b-fw-icon b-icon-filter-after"></i>',
                value: filter && filter.operator === '>' ? filter.value : null,
                operator: '>',
                onChange: onChange,
                onClose: onClose,
                onClear: onClear
              }];
            }
          }, {
            key: "getPopupNumberItems",
            value: function getPopupNumberItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback) {
              var me = this,
                  onEsc = changeCallback,
                  onClear = closeCallback;

              function onChange(_ref3) {
                var source = _ref3.source,
                    value = _ref3.value;

                if (value == null) {
                  closeCallback();
                } else {
                  me.applyFilter({
                    property: field,
                    operator: source.operator,
                    value: value
                  });
                  changeCallback();
                }
              }

              return [{
                type: 'number',
                placeholder: me.L('equals'),
                clearable: true,
                label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
                value: filter && filter.operator === '=' ? filter.value : initialValue,
                operator: '=',
                onChange: onChange,
                onEsc: onEsc,
                onClear: onClear
              }, {
                type: 'number',
                placeholder: me.L('lessThan'),
                clearable: true,
                label: '<i class="b-fw-icon b-icon-filter-less"></i>',
                value: filter && filter.operator === '<' ? filter.value : null,
                operator: '<',
                onChange: onChange,
                onEsc: onEsc,
                onClear: onClear
              }, {
                type: 'number',
                cls: 'b-last-row',
                placeholder: me.L('moreThan'),
                clearable: true,
                label: '<i class="b-fw-icon b-icon-filter-more"></i>',
                value: filter && filter.operator === '>' ? filter.value : null,
                operator: '>',
                onChange: onChange,
                onEsc: onEsc,
                onClear: onClear
              }];
            }
          }, {
            key: "getPopupStringItems",
            value: function getPopupStringItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback) {
              var me = this;
              return [{
                type: fieldType,
                cls: 'b-last-row',
                placeholder: me.L('filter'),
                clearable: true,
                label: '<i class="b-fw-icon b-icon-filter-equal"></i>',
                value: filter ? filter.value || filter : initialValue,
                onChange: function onChange(_ref4) {
                  var value = _ref4.value;

                  if (value === '') {
                    closeCallback();
                  } else {
                    me.applyFilter({
                      property: field,
                      value: value
                    });
                    changeCallback();
                  }
                },
                onClose: changeCallback,
                onClear: closeCallback
              }];
            }
            /**
             * Get fields to display in filter popup.
             * @param fieldType Type of field, number, date etc.
             * @param filter Current filter filter
             * @param initialValue
             * @param field Column
             * @param store Grid store
             * @param changeCallback Callback for when filter has changed
             * @param closeCallback Callback for when editor should be closed
             * @returns {*}
             * @private
             */

          }, {
            key: "getPopupItems",
            value: function getPopupItems(fieldType, filter, initialValue, field, store, changeCallback, closeCallback) {
              switch (fieldType) {
                case 'date':
                  return this.getPopupDateItems.apply(this, arguments);

                case 'number':
                  return this.getPopupNumberItems.apply(this, arguments);

                default:
                  return this.getPopupStringItems.apply(this, arguments);
              }
            }
            /**
             * Shows a popup where a filter can be edited.
             * @param {Grid.column.Column} column Column to show filter editor for
             * @param {*} value Value to init field with
             */

          }, {
            key: "showFilterEditor",
            value: function showFilterEditor(column, value) {
              var me = this,
                  col = typeof column === 'string' ? me.grid.columns.getById(column) : column,
                  headerEl = col.element,
                  filter = me.store.filters.getBy('property', col.field),
                  type = col.filterType || col.type || 'string',
                  fieldType = {
                'string': 'text',
                'number': 'number',
                'date': 'date'
              }[type] || 'text';
              if (col.filterable === false) return;
              me.filterEditorPopup = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].openPopup(headerEl, {
                width: '16em',
                cls: 'b-filter-popup',
                scrollAction: 'realign',
                items: me.getPopupItems(fieldType, filter, value, col.field, me.store, me.closeFilterEditor, function () {
                  me.store.removeFieldFilter(col.field);
                  me.closeFilterEditor();
                })
              });
            }
            /**
             * Close the filter editor.
             */

          }, {
            key: "closeFilterEditor",
            value: function closeFilterEditor() {
              var me = this; // Must defer the destroy because it may be closed by an event like a "change" event where
              // there may be plenty of code left to execute which must not execute on destroyed objects.

              me.filterEditorPopup && me.filterEditorPopup.setTimeout(me.filterEditorPopup.destroy);
              me.filterEditorPopup = null;
            } //endregion
            //region Context menu
            //TODO: break out together with getPopupXXItems() (see comment above)

          }, {
            key: "getMenuDateItems",
            value: function getMenuDateItems(column, record) {
              var me = this,
                  value = record[column.field],
                  filter = function filter(operator) {
                me.applyFilter({
                  property: column.field,
                  operator: operator,
                  value: value,
                  displayValue: column.formatValue ? column.formatValue(value) : value
                });
              };

              return [{
                text: me.L('on'),
                icon: 'b-fw-icon b-icon-filter-equal',
                cls: 'b-separator',
                name: 'filterDateEquals',
                onItem: function onItem() {
                  return filter('=');
                }
              }, {
                text: me.L('before'),
                icon: 'b-fw-icon b-icon-filter-before',
                name: 'filterDateBefore',
                onItem: function onItem() {
                  return filter('<');
                }
              }, {
                text: me.L('after'),
                icon: 'b-fw-icon b-icon-filter-after',
                name: 'filterDateAfter',
                onItem: function onItem() {
                  return filter('>');
                }
              }];
            }
          }, {
            key: "getMenuNumberItems",
            value: function getMenuNumberItems(column, record) {
              var me = this,
                  filter = function filter(operator) {
                me.applyFilter({
                  property: column.field,
                  operator: operator,
                  value: record[column.field]
                });
              };

              return [{
                text: me.L('equals'),
                icon: 'b-fw-icon b-icon-filter-equal',
                cls: 'b-separator',
                name: 'filterNumberEquals',
                onItem: function onItem() {
                  return filter('=');
                }
              }, {
                text: me.L('lessThan'),
                icon: 'b-fw-icon b-icon-filter-less',
                name: 'filterNumberLess',
                onItem: function onItem() {
                  return filter('<');
                }
              }, {
                text: me.L('moreThan'),
                icon: 'b-fw-icon b-icon-filter-more',
                name: 'filterNumberMore',
                onItem: function onItem() {
                  return filter('>');
                }
              }];
            }
          }, {
            key: "getMenuStringItems",
            value: function getMenuStringItems(column, record) {
              var _this = this;

              return [{
                text: this.L('equals'),
                icon: 'b-fw-icon b-icon-filter-equal',
                cls: 'b-separator',
                name: 'filterStringEquals',
                onItem: function onItem() {
                  _this.applyFilter({
                    property: column.field,
                    value: record[column.field]
                  });
                }
              }];
            }
            /**
             * Add menu items for filtering, depending on filter type etc.
             * @param column
             * @param record
             * @param items
             * @returns {Object[]}
             * @private
             */

          }, {
            key: "getCellMenuItems",
            value: function getCellMenuItems(column, record, items) {
              var me = this,
                  field = record.getFieldDefinition(column.field);

              if (column.filterable !== false) {
                var filterItems = [];

                if (column.meta.isFiltered) {
                  filterItems.push({
                    text: me.L('removeFilter'),
                    icon: 'b-fw-icon b-icon-clear',
                    cls: 'b-separator',
                    name: 'filterRemove',
                    onItem: function onItem() {
                      me.store.removeFieldFilter(column.field);
                    }
                  });
                }

                switch (column.filterType || column.type || field && field.type) {
                  case 'date':
                    filterItems.push.apply(filterItems, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(me.getMenuDateItems.apply(me, arguments)));
                    break;

                  case 'number':
                    filterItems.push.apply(filterItems, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(me.getMenuNumberItems.apply(me, arguments)));
                    break;

                  default:
                    filterItems.push.apply(filterItems, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(me.getMenuStringItems.apply(me, arguments)));
                    break;
                } // remove separator from second item if filtered


                if (column.meta.isFiltered && filterItems.length > 1) {
                  filterItems[1].cls = '';
                }

                items.push.apply(items, filterItems);
              }
            }
            /**
             * Add menu item for removing filter if column is filtered.
             * @private
             * @param column Column
             * @param items Menu items
             * @returns {Object[]}
             */

          }, {
            key: "getHeaderMenuItems",
            value: function getHeaderMenuItems(column, items) {
              var me = this;

              if (column.meta.isFiltered) {
                items.push({
                  text: me.L('editFilter'),
                  name: 'editFilter',
                  icon: 'b-fw-icon b-icon-filter',
                  cls: 'b-separator',
                  onItem: function onItem() {
                    me.showFilterEditor(column);
                  }
                });
                items.push({
                  text: me.L('removeFilter'),
                  name: 'removeFilter',
                  icon: 'b-fw-icon b-icon-remove',
                  onItem: function onItem() {
                    me.store.removeFieldFilter(column.field);
                  }
                });
              } else if (column.filterable !== false) {
                items.push({
                  text: me.L('filter'),
                  name: 'filter',
                  icon: 'b-fw-icon b-icon-filter',
                  cls: 'b-separator',
                  onItem: function onItem() {
                    me.showFilterEditor(column);
                  }
                });
              }
            } //endregion
            //region Events

            /**
             * Store filtered; refresh headers.
             * @private
             */

          }, {
            key: "onStoreFilter",
            value: function onStoreFilter() {
              // Pass false to not refresh rows.
              // Store's refresh event will refresh the rows.
              this.refreshHeaders(false);
            }
            /**
             * Called after headers are rendered, make headers match stores initial sorters
             * @private
             */

          }, {
            key: "renderHeader",
            value: function renderHeader() {
              this.refreshHeaders(false);
            }
            /**
             * Called when user clicks on the grid. Only care about clicks on the filter icon.
             * @param {MouseEvent} event
             * @private
             */

          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              var target = event.target;
              if (this.filterEditorPopup) this.closeFilterEditor(); // Checks if click is on node expander icon, then toggles expand/collapse

              if (target.classList.contains('b-filter-icon')) {
                var headerEl = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(target, '.b-grid-header');

                this.showFilterEditor(headerEl.dataset.columnId);
                return false;
              }
            } //endregion

          }], [{
            key: "pluginConfig",
            //region Init
            // Plugin configuration. This plugin chains some of the functions in Grid.
            get: function get() {
              return {
                chain: ['renderHeader', 'getCellMenuItems', 'getHeaderMenuItems', 'onElementClick']
              };
            }
          }]);

          return Filter;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__["default"]);

        Filter.featureClass = 'b-filter';
        Filter._$name = 'Filter';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].registerFeature(Filter);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/FilterBar.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Grid/feature/FilterBar.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureFilterBarJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return FilterBar;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.match */
        "../Grid/node_modules/core-js/modules/es6.regexp.match.js");
        /* harmony import */


        var core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_match__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/FilterBar
         */

        /**
         * Feature that allows filtering of the grid by entering filters on column headers.
         * The actual filtering is done by the store.
         * For info on programmatically handling filters, see {@link Common.data.mixin.StoreFilter StoreFilter}.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * The individual filterability of columns is defined by a `filterable`
         * property on the column which defaults to `true`. If `false`, that column
         * is not filterable.
         *
         * The property value may also be a custom filter function.
         *
         * The property value may also be an object which may contain the following two properties:
         *  - **filterFn** : `Function` A custom filtering function
         *  - **filterField** : `Object` A config object for the filter value input field.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // filtering turned on but no default filter
         * let grid = new Grid({
         *   features: {
         *     filterBar : true
         *   }
         * });
         *
         * @example
         * // using default filter
         * let grid = new Grid({
         *   features : {
         *     filterBar : { filter: { property : 'city', value : 'Gavle' } }
         *   }
         * });
         *
         * @example
         * // Custom filtering function for a column
         * let grid = new Grid({
         *   features : {
         *     filter : true
         *   },
         *
         *   columns: [
         *      {
         *        field      : 'age',
         *        text       : 'Age',
         *        type       : 'number',
         *        // Custom filtering function that checks "greater than"
         *        filterable : ({ record, value }) => record.age > value
         *      },
         *        field : 'name',
         *        // Filterable may specify a filterFn and a config for the filtering input field
         *        filterable : {
         *          filterFn : ({ record, value }) => record.name.toLowerCase().indexof(value.toLowerCase()) !== -1,
         *          filterField : {
         *            emptyText : 'Filter name'
         *          }
         *        }
         *      }
         *   ]
         * });
         *
         * @demo filterbar
         * @classtype filterBar
         * @externalexample feature/FilterBar.js
         */

        var FilterBar =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(FilterBar, _InstancePlugin);

          function FilterBar() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, FilterBar);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(FilterBar).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(FilterBar, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(grid, config) {
              var me = this;
              Object.assign(me, {
                filterFieldCls: 'b-filter-bar-field',
                filterFieldInputCls: 'b-filter-bar-field-input',
                filterableColumnCls: 'b-filter-bar-enabled',
                filterFieldInputSelector: '.b-filter-bar-field-input',
                filterableColumnSelector: '.b-filter-bar-enabled',
                filterParseRegExp: /^\s*([<>=*])?(.*)$/,
                storeTrackingSupended: 0,
                store: grid.store,
                grid: grid
              });
              me.onColumnFilterFieldChange = me.onColumnFilterFieldChange.bind(me);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(FilterBar.prototype), "construct", this).call(this, grid, Array.isArray(config) ? {
                filter: config
              } : config);

              me.store.on({
                filter: me.onStoreFilter,
                thisObj: me
              });

              if (me.filter) {
                me.store.filter(me.filter);
              }

              me.gridDetacher = grid.on('beforeelementclick', me.onBeforeElementClick, me);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.destroyFilterBar();
              me.gridDetacher && me.gridDetacher();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(FilterBar.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "destroyFilterBar",
            //endregion
            //region FilterBar
            value: function destroyFilterBar() {
              var me = this,
                  columns = me.grid.columns;
              columns && columns.forEach(me.destroyColumnFilterField, me);
            }
            /**
             * Hides the filtering fields.
             */

          }, {
            key: "hideFilterBar",
            value: function hideFilterBar() {
              var me = this,
                  columns = me.grid.columns; // we don't want to hear back store "filter" event while we're resetting store filters

              me.clearStoreFiltersOnHide && me.suspendStoreTracking(); // hide the fields, each silently - no updating of the store's filtered state until the end

              columns && columns.forEach(function (col) {
                return me.hideColumnFilterField(col, true);
              }); // Now update the filtered state

              me.grid.store.filter();
              me.clearStoreFiltersOnHide && me.resumeStoreTracking();
              me.hidden = true;
            }
            /**
             * Shows the filtering fields.
             */

          }, {
            key: "showFilterBar",
            value: function showFilterBar() {
              this.renderFilterBar();
              this.hidden = false;
            }
            /**
             * Toggles the filtering fields visibility.
             */

          }, {
            key: "toggleFilterBar",
            value: function toggleFilterBar() {
              var me = this;

              if (me.hidden) {
                me.showFilterBar();
              } else {
                me.hideFilterBar();
              }
            }
            /**
             * Renders the filtering fields for filterable columns.
             * @private
             */

          }, {
            key: "renderFilterBar",
            value: function renderFilterBar() {
              var me = this;
              me.grid.columns.visibleColumns.forEach(function (column) {
                return me.renderColumnFilterField(column);
              });
            } //endregion
            //region FilterBar fields

            /**
             * Renders text field filter in the provided column header.
             * @param {Grid.column.Column} column Column to render text field filter for.
             * @private
             */

          }, {
            key: "renderColumnFilterField",
            value: function renderColumnFilterField(column) {
              var me = this,
                  grid = me.grid,
                  filterable = me.getColumnFilterable(column); // we render fields for filterable columns only

              if (filterable && !column.hidden) {
                var headerEl = column.element;
                var widget = me.getColumnFilterField(column); // if we don't haven't created a field yet
                // we build it from scratch

                if (!widget) {
                  var filter = grid.store.filters.getBy('property', column.field),
                      type = "".concat(column.filterType || 'text', "field");
                  widget = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].append(Object.assign({
                    type: type,
                    owner: me.grid,
                    clearable: true,
                    column: column,
                    name: column.field,
                    value: filter && me.buildFilterString(filter),
                    cls: me.filterFieldCls,
                    inputCls: me.filterFieldInputCls,
                    keyStrokeChangeDelay: me.keyStrokeFilterDelay,
                    onChange: me.onColumnFilterFieldChange,
                    onClear: me.onColumnFilterFieldChange
                  }, filterable.filterField), headerEl)[0];
                  me.setColumnFilterField(column, widget);
                } // if we have one..
                else {
                    // re-apply widget filter
                    me.onColumnFilterFieldChange({
                      source: widget,
                      value: widget.value
                    }); // re-append the widget to its parent node (in case the column header was redrawn (happens when resizing columns))

                    widget.render(headerEl); // show widget in case it was hidden

                    widget.show();
                  }

                headerEl.classList.add(me.filterableColumnCls);
              }
            }
            /**
             * Fills in column filter fields with values from the grid store filters.
             * @private
             */

          }, {
            key: "updateColumnFilterFields",
            value: function updateColumnFilterFields() {
              var me = this,
                  grid = me.grid;
              var field, filter;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = grid.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var column = _step.value;
                  field = me.getColumnFilterField(column);

                  if (field) {
                    filter = grid.store.filters.getBy('property', column.field);
                    field.value = filter && me.buildFilterString(filter) || '';
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
          }, {
            key: "getColumnFilterable",
            value: function getColumnFilterable(column) {
              if (!column.isRoot && column.filterable !== false && column.field) {
                if (typeof column.filterable === 'function') {
                  column.filterable = {
                    filterFn: column.filterable
                  };
                }

                return column.filterable;
              }
            }
          }, {
            key: "destroyColumnFilterField",
            value: function destroyColumnFilterField(column) {
              var me = this,
                  widget = me.getColumnFilterField(column);

              if (widget) {
                me.hideColumnFilterField(column); // destroy filter UI field

                widget.destroy(); // remember there is no field bound anymore

                me.setColumnFilterField(column, undefined);
              }
            }
          }, {
            key: "hideColumnFilterField",
            value: function hideColumnFilterField(column, silent) {
              var me = this,
                  store = me.grid.store,
                  columnEl = column.element,
                  widget = me.getColumnFilterField(column);

              if (widget) {
                // hide field
                widget.hide();

                if (me.clearStoreFiltersOnHide && column.field) {
                  store.removeFieldFilter(column.field, silent);
                }

                columnEl.classList.remove(me.filterableColumnCls);
              }
            }
          }, {
            key: "getColumnFilterField",
            value: function getColumnFilterField(column) {
              var me = this;
              return me._columnFilters && me._columnFilters[column.data.id];
            }
          }, {
            key: "setColumnFilterField",
            value: function setColumnFilterField(column, widget) {
              var me = this;
              me._columnFilters = me._columnFilters || {};
              me._columnFilters[column.data.id] = widget;
            } //endregion
            //region Filters

          }, {
            key: "parseFilterValue",
            value: function parseFilterValue(value) {
              var match = String(value).match(this.filterParseRegExp);
              return {
                operator: match[1] || '*',
                value: match[2]
              };
            }
          }, {
            key: "buildFilterString",
            value: function buildFilterString(filter) {
              var result;

              if (filter && !filter.initialConfig.filterBy) {
                result = (filter.operator === '*' ? '' : filter.operator) + filter.value;
              }

              return result;
            } //endregion
            // region Events

            /**
             * Fires when store gets filtered. Refreshes field values in column headers.
             * @private
             */

          }, {
            key: "onStoreFilter",
            value: function onStoreFilter() {
              if (!this.storeTrackingSupended) {
                this.updateColumnFilterFields();
              }
            }
          }, {
            key: "suspendStoreTracking",
            value: function suspendStoreTracking() {
              this.storeTrackingSupended++;
            }
          }, {
            key: "resumeStoreTracking",
            value: function resumeStoreTracking() {
              this.storeTrackingSupended--;
            }
            /**
             * Called after headers are rendered, make headers match stores initial sorters
             * @private
             */

          }, {
            key: "renderHeader",
            value: function renderHeader(element) {
              this.renderFilterBar();
            }
          }, {
            key: "onElementKeyDown",
            value: function onElementKeyDown(event) {
              var me = this; // flagging event with handled = true used to signal that other features should probably not care about it

              if (event.handled) return; // if we are pressing left/right arrow keys while being in a filter editor
              // we set event.handled flag (otherwise other features prevent the event)

              if (event.target.matches(me.filterFieldInputSelector)) {
                switch (event.key) {
                  case 'ArrowLeft':
                  case 'ArrowRight':
                    event.handled = true;
                }
              }
            }
          }, {
            key: "onBeforeElementClick",
            value: function onBeforeElementClick(_ref) {
              var event = _ref.event;
              var me = this; // prevent other features reacting when clicking a filter field (or any element inside it)

              if (event.target.closest('.' + me.filterFieldCls)) {
                return false;
              }
            }
            /**
             * Called when a column text filter field value is changed by user.
             * @param  {TextField} field Filter text field.
             * @param  {String} value New filtering value.
             * @private
             */

          }, {
            key: "onColumnFilterFieldChange",
            value: function onColumnFilterFieldChange(_ref2) {
              var field = _ref2.source,
                  value = _ref2.value;
              var me = this,
                  store = me.grid.store,
                  filterable = me.getColumnFilterable(field.column); // we don't want to hear back store "filter" event
              // so we suspend store tracking

              me.suspendStoreTracking();

              if (value == null || value === '') {
                // remove filter if setting to empty
                store.removeFieldFilter(field.name);
              } else if (filterable.filterFn) {
                store.filter({
                  filterBy: function filterBy(record) {
                    return filterable.filterFn({
                      property: field.name,
                      value: value,
                      record: record
                    });
                  },
                  // To be able to clear the filter
                  property: field.name
                });
              } else {
                store.filter(Object.assign({
                  property: field.name
                }, me.parseFilterValue(value)));
              }

              me.resumeStoreTracking();
            } //endregion
            //region Menu items

            /**
             * Adds a menu item to toggle filter bar visibility.
             * @param column Column
             * @param items Menu items
             * @returns {Object[]} Menu items.
             * @private
             */

          }, {
            key: "getHeaderMenuItems",
            value: function getHeaderMenuItems(column, items) {
              var me = this;
              items.push({
                text: me.L(me.hidden ? 'enableFilterBar' : 'disableFilterBar'),
                name: 'toggleFilterBar',
                icon: 'b-fw-icon b-icon-filter',
                cls: 'b-separator',
                onItem: function onItem() {
                  return me.toggleFilterBar();
                }
              });
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Default config
            get: function get() {
              return {
                /**
                 * The delay in milliseconds to wait after the last keystroke before applying filters.
                 * Set to 0 to not trigger filtering from keystrokes, requires pressing ENTER instead
                 * @config {Number}
                 * @default
                 */
                keyStrokeFilterDelay: 300,
                // Destroying data level filters when we hiding UI is supposed to be optional someday. So far this flag is private
                clearStoreFiltersOnHide: true
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                before: ['onElementKeyDown'],
                chain: ['renderHeader', 'getHeaderMenuItems']
              };
            }
          }]);

          return FilterBar;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        FilterBar.featureClass = 'b-filter-bar';
        FilterBar._$name = 'FilterBar';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(FilterBar);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/GridFeatureManager.js":
      /*!******************************************************!*\
        !*** ../Grid/lib/Grid/feature/GridFeatureManager.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureGridFeatureManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return GridFeatureManager;
        });
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.map */
        "../Grid/node_modules/core-js/modules/es6.map.js");
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/GridFeatureManager
         */

        var consumerToFeatureMap = new Map(),
            consumerToDefaultFeatureMap = new Map(),
            DEFAULT_FOR_TYPE = 'Grid';
        /**
         * Static class intended to register and query grid features
         *
         * @class
         */

        var GridFeatureManager =
        /*#__PURE__*/
        function () {
          function GridFeatureManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, GridFeatureManager);
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(GridFeatureManager, null, [{
            key: "registerFeature",

            /**
             * Register a feature class with the Grid. Enables it to be created and configured using config Grid#features.
             * @param {Common.mixin.InstancePlugin} featureClass Feature to register
             * @param {Boolean} [onByDefault] Specify true to have the feature enabled per default
             * @param {String|String[]} [forType] Specify a type to let the class applying the feature to determine if it should use it
             */
            value: function registerFeature(featureClass) {
              var onByDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var forType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var as = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              as = _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].lowercaseFirstLetter(as || featureClass.$name);

              if (!Array.isArray(forType)) {
                forType = [forType || DEFAULT_FOR_TYPE];
              }

              forType.forEach(function (forType) {
                var consumerFeaturesMap = consumerToFeatureMap.get(forType) || new Map(),
                    consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(forType) || new Map();
                consumerFeaturesMap.set(as, featureClass);
                consumerDefaultFeaturesMap.set(featureClass, onByDefault);
                consumerToFeatureMap.set(forType, consumerFeaturesMap);
                consumerToDefaultFeatureMap.set(forType, consumerDefaultFeaturesMap);
              });
            }
            /**
             * Get all the features registered for the given type name in an object where keys are feature names and values are feature constructors.
             *
             * @param {String} [forType]
             * @return {Object}
             */

          }, {
            key: "getTypeNameFeatures",
            value: function getTypeNameFeatures() {
              var forType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FOR_TYPE;
              var consumerFeaturesMap = consumerToFeatureMap.get(forType),
                  features = {};

              if (consumerFeaturesMap) {
                consumerFeaturesMap.forEach(function (featureClass, as) {
                  return features[as] = featureClass;
                });
              }

              return features;
            }
            /**
             * Get all the default features registered for the given type name in an object where keys are feature names and values are feature constructors.
             *
             * @param {String} [forType]
             * @return {Object}
             */

          }, {
            key: "getTypeNameDefaultFeatures",
            value: function getTypeNameDefaultFeatures() {
              var forType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FOR_TYPE;
              var consumerFeaturesMap = consumerToFeatureMap.get(forType),
                  consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(forType);
              var features = {};

              if (consumerFeaturesMap && consumerDefaultFeaturesMap) {
                consumerFeaturesMap.forEach(function (featureClass, as) {
                  if (consumerDefaultFeaturesMap.get(featureClass)) {
                    features[as] = featureClass;
                  }
                });
              }

              return features;
            }
            /**
             * Gets all the features registered for the given instance type name chain. First builds the type name chain then quaries for features
             * for each type name and combines them into one object, see {@link #function-getTypeNameFeatures-static}() for returned object description.
             * If feature is registered for both parent and child type name then feature for child overrides feature for parent.
             *
             * @param {Object} instance
             * @return {Object}
             */

          }, {
            key: "getInstanceFeatures",
            value: function getInstanceFeatures(instance) {
              var _this = this;

              return instance.classNameHierarchy().reduce(function (features, typeName) {
                return Object.assign(features, _this.getTypeNameFeatures(typeName));
              }, {});
            }
            /**
             * Gets all the *defualt* features registered for the given instance type name chain. First builds the type name chain then quaries for features
             * for each type name and combines them into one object, see {@link #function-getTypeNameFeatures-static}() for returned object description.
             * If feature is registered for both parent and child type name then feature for child overrides feature for parent.
             *
             * @param {Object} instance
             * @return {Object}
             */

          }, {
            key: "getInstanceDefaultFeatures",
            value: function getInstanceDefaultFeatures(instance) {
              var _this2 = this;

              return instance.classNameHierarchy().reduce(function (features, typeName) {
                return Object.entries(_this2.getTypeNameFeatures(typeName)).reduce(function (features, _ref) {
                  var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
                      as = _ref2[0],
                      featureClass = _ref2[1];

                  if (_this2.isDefaultFeatureForTypeName(featureClass, typeName)) {
                    features[as] = featureClass;
                  } else {
                    delete features[as];
                  }

                  return features;
                }, features);
              }, {});
            }
            /**
             * Checks if the given feature class is default for the type name
             *
             * @param {Common.mixin.InstancePlugin} featureClass Feature to check
             * @param {String} [forType]
             * @return {Boolean}
             */

          }, {
            key: "isDefaultFeatureForTypeName",
            value: function isDefaultFeatureForTypeName(featureClass) {
              var forType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_FOR_TYPE;
              var consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(forType);
              return consumerDefaultFeaturesMap && consumerDefaultFeaturesMap.get(featureClass) || false;
            }
            /**
             * Checks if the given feature class is default for the given instance type name chain. If the feature is not default for the
             * parent type name but it is for the child type name, then the child setting overrides the parent one.
             *
             * @param {Common.mixin.InstancePlugin} featureClass Feature to check
             * @param {String} [forType]
             * @return {Boolean}
             */

          }, {
            key: "isDefaultFeatureForInstance",
            value: function isDefaultFeatureForInstance(featureClass, instance) {
              //const typeChain = ObjectHelper.getTypeNameChain(instance);
              var typeChain = instance.classNameHierarchy().reverse();
              var result = null;

              for (var i = 0, len = typeChain.length; i < len && result === null; ++i) {
                var consumerDefaultFeaturesMap = consumerToDefaultFeatureMap.get(typeChain[i]);

                if (consumerDefaultFeaturesMap && consumerDefaultFeaturesMap.has(featureClass)) {
                  result = consumerDefaultFeaturesMap.get(featureClass);
                }
              }

              return result || false;
            }
            /**
             * Resets feature registration date, used in tests to reset state after test
             *
             * @internal
             */

          }, {
            key: "reset",
            value: function reset() {
              consumerToFeatureMap.clear();
              consumerToDefaultFeatureMap.clear();
            }
          }]);

          return GridFeatureManager;
        }();

        GridFeatureManager._$name = 'GridFeatureManager';
        /***/
      },

      /***/
      "../Grid/lib/Grid/feature/Group.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Grid/feature/Group.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureGroupJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Group;
        });
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler'; //TODO: Expand function?
        //TODO: Collapse function?
        //TODO: Sorting breaks grouping if some groups are collapsed
        //TODO: Grouping via context menu doesn't work

        /**
         * @module Grid/feature/Group
         */

        /**
         * Enables rendering and handling of row groups. The actual grouping is done in the store, but triggered by [shift] +
         * clicking headers or by using two finger tap (one on header, one anywhere on grid). Groups can be expanded/collapsed
         * by clicking on the group row or pressing [space] when group row is selected.
         *
         * This feature is <strong>enabled</strong> by default.
         *
         * @example
         * // grouping turned on but no default grouper
         * let grid = new Grid({
         *   features: {
         *     group: true
         *   }
         * });
         *
         * // default grouper, group by field 'name'
         * let grid = new Grid({
         *   features: {
         *     group: 'name'
         *   }
         * });
         *
         * // default grouper and custom renderer, which will be applied to each cell except the "group" cell
         * let grid = new Grid({
         *   features: {
         *     group: {
         *       field: 'name',
         *       ascending: false,
         *       renderer: () => 'Text'
         *     }
         *   }
         * });
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo grouping
         * @classtype group
         * @externalexample feature/Group.js
         */

        var Group =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(Group, _InstancePlugin);

          function Group() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Group);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Group).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Group, [{
            key: "construct",
            //region Init
            value: function construct(grid, config) {
              var me = this;
              if (grid.features.tree) return; // groupSummary feature needs to be initialized first, if it is used

              me._thisIsAUsedExpression(grid.features.groupSummary); // process initial config into an actual config object


              config = me.processConfig(config);
              Object.assign(me, {
                grid: grid,
                rowManager: grid.rowManager,
                store: grid.store
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Group.prototype), "construct", this).call(this, grid, config);

              me.store.on({
                group: me.onStoreGroup,
                groupingoff: me.onStoreGroupingOff,
                thisObj: me
              });
              me.rowManager.on({
                rendercell: me.renderCell,
                thisObj: me
              });
            } // Group feature handles special config cases, where user can supply a string or a group config object
            // instead of a normal config object

          }, {
            key: "processConfig",
            value: function processConfig(config) {
              if (typeof config === 'string') {
                return {
                  field: config,
                  ascending: null
                };
              }

              return config;
            } // override setConfig to process config before applying it (used mainly from ReactGrid)

          }, {
            key: "setConfig",
            value: function setConfig(config) {
              var me = this;

              if (config === null) {
                me.store.clearGroupers();
              } else {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Group.prototype), "setConfig", this).call(this, me.processConfig(config));
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Group.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "toggleCollapse",
            //endregion
            //region Expand/collapse

            /**
             * Collapses or expands a group depending on its current state
             * @param recordOrId Record or records id for a group row to collapse or expand
             * @param collapse Force collapse (true) or expand (true)
             * @fires togglegroup
             */
            value: function toggleCollapse(recordOrId, collapse) {
              this.internalToggleCollapse(recordOrId, collapse);
            }
            /**
             * Collapses or expands a group depending on its current state
             * @param recordOrId Record or records id for a group row to collapse or expand
             * @param collapse Force collapse (true) or expand (true)
             * @param skipRender True to not render rows
             * @internal
             * @fires togglegroup
             */

          }, {
            key: "internalToggleCollapse",
            value: function internalToggleCollapse(recordOrId, collapse) {
              var skipRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  store = me.store,
                  groupRecord = store.getById(recordOrId),
                  meta = groupRecord.meta;
              if (meta.groupRowFor === undefined) return;
              collapse = collapse === undefined ? !meta.collapsed : collapse;

              if (collapse) {
                store.excludeGroupRecords(groupRecord);
              } else {
                store.includeGroupRecords(groupRecord);
              } // note to self, all this could be done in collapsed setter on GroupModel if desired...


              meta.collapsed = collapse;
              /**
               * Group expanded or collapsed
               * @event toggleGroup
               * @param groupRecord Group record
               * @param {Boolean} collapse Collapsed (true) or expanded (false)
               */

              me.grid.trigger('toggleGroup', {
                groupRecord: groupRecord,
                collapse: collapse
              });

              if (!skipRender) {
                // render from grouprecord and down, no need to touch those above
                me.rowManager.renderFromRecord(groupRecord);
              }
            }
            /**
             * Collapse all groups. This function is exposed on Grid and can thus be called as `grid.collapseAll()`
             */

          }, {
            key: "collapseAll",
            value: function collapseAll() {
              var me = this;

              if (me.store.isGrouped) {
                me.store.groupRecords.forEach(function (r) {
                  return me.internalToggleCollapse(r, true, true);
                });
                me.grid.refreshRows(true);
              }
            }
            /**
             * Expand all groups. This function is exposed on Grid and can thus be called as `grid.expandAll()`
             */

          }, {
            key: "expandAll",
            value: function expandAll() {
              var me = this;

              if (me.store.isGrouped) {
                me.store.groupRecords.forEach(function (r) {
                  return me.internalToggleCollapse(r, false, true);
                });
                me.grid.refreshRows();
              }
            } //endregion
            //region Rendering

            /**
             * Called when a cell is rendered, styles the group rows first cell.
             * @private
             */

          }, {
            key: "renderCell",
            value: function renderCell(renderData) {
              var me = this; // no need to run the code below if not grouping

              if (!me.store.isGrouped) return;
              var cellElement = renderData.cellElement,
                  rowElement = renderData.rowElement,
                  column = renderData.column,
                  grid = me.grid,
                  meta = renderData.record.meta,
                  firstColumn = grid.columns.visibleColumns[0],
                  subGrid = grid.getSubGridFromColumn(column);

              if (meta.hasOwnProperty('groupRowFor')) {
                // Let column clear the cell, in case it needs to do some cleanup
                column.clearCell(cellElement); // this is a group row, add css classes
                // IE11 doesnt support this
                //rowElement.classList.toggle('b-grid-group-collapsed', meta.collapsed === undefined ? false : meta.collapsed);

                if (meta.collapsed) {
                  rowElement.classList.add('b-grid-group-collapsed');
                } else {
                  rowElement.classList.remove('b-grid-group-collapsed');
                }

                rowElement.classList.add('b-group-row');

                if (column.region === grid.regions[0] && (firstColumn.type === 'rownumber' && column === subGrid.columns.visibleColumns[1] || firstColumn.type !== 'rownumber' && column === subGrid.columns.visibleColumns[0])) {
                  cellElement.classList.add('b-group-title');
                }

                me.buildGroupHeader(renderData);
              } else {
                // not a group row, remove css classes
                // TODO: use dom query to remove before render instead?
                if (cellElement === rowElement.firstElementChild) {
                  // IE11 doesnt support this
                  //rowElement.classList.remove('b-group-row', 'b-grid-group-collapsed');
                  rowElement.classList.remove('b-group-row');
                  rowElement.classList.remove('b-grid-group-collapsed');
                  cellElement.classList.remove('b-group-title');
                }
              }
            } // renderData.cellElement is required

          }, {
            key: "buildGroupHeader",
            value: function buildGroupHeader(renderData) {
              var me = this,
                  record = renderData.record,
                  cellElement = renderData.cellElement,
                  rowElement = renderData.rowElement,
                  column = renderData.column,
                  persist = renderData.persist,
                  grid = me.grid,
                  meta = record.meta,
                  firstColumn = grid.columns.visibleColumns[0],
                  subGrid = column && grid.getSubGridFromColumn(column);
              var html = null;

              if (persist || column && firstColumn.type === 'rownumber' && column === subGrid.columns.visibleColumns[1] || firstColumn.type !== 'rownumber' && column === subGrid.columns.visibleColumns[0]) {
                // build group header no matter what cell it is or
                // build group value in first cell of first subgrid
                if (persist || column.region === grid.regions[0]) {
                  var groupColumn = grid.columns.get(meta.groupField); // First try using columns groupRenderer (might not even have a column if grouping programmatically)

                  if (groupColumn && groupColumn.groupRenderer) {
                    // groupRenderer could return nothing and just apply changes directly to DOM element
                    html = groupColumn.groupRenderer({
                      cellElement: cellElement,
                      groupRowFor: meta.groupRowFor,
                      record: record,
                      rowElement: rowElement,
                      groupColumn: groupColumn
                    });
                  } // Secondly use features groupRenderer, if configured with one
                  else if (me.groupRenderer) {
                      // groupRenderer could return nothing and just apply changes directly to DOM element
                      html = me.groupRenderer(Object.assign({}, renderData, {
                        groupRowFor: meta.groupRowFor,
                        groupColumn: groupColumn
                      }));
                    } // Third, just display unformatted value and child count
                    else {
                        // Need to adjust count if group summary is used
                        // TODO remove this when grouping has been refactored to not store group headers/footers in the Store
                        var count = meta.childCount - (grid.features.groupSummary ? 1 : 0);
                        html = "".concat(meta.groupRowFor == null ? '' : meta.groupRowFor, " (").concat(count, ")");
                      }
                }
              } else if (me.groupRenderer) {
                // groupRenderer could return nothing and just apply changes directly to DOM element
                html = me.groupRenderer(renderData);
              } // Renderers could return nothing and just apply changes directly to DOM element


              if (typeof html === 'string') {
                cellElement.innerHTML = html;
              }

              return cellElement.innerHTML;
            }
            /**
             * Called when an header is rendered, adds grouping icon if grouped by that column.
             * @private
             * @param headerContainerElement
             */

          }, {
            key: "renderHeader",
            value: function renderHeader(headerContainerElement) {
              var me = this,
                  grid = me.grid,
                  groupers = me.store.groupers; // Sorted from start, reflect in rendering

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = groupers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var groupInfo = _step.value; // Might be grouping by field without column, which is valid

                  var column = grid.columns.get(groupInfo.field),
                      header = column && grid.getHeaderElement(column.id); // IE11 doesnt support this
                  //header && header.classList.add('b-group', groupInfo.ascending ? 'b-asc' : 'b-desc');

                  if (header) {
                    header.classList.add('b-group');
                    header.classList.add(groupInfo.ascending ? 'b-asc' : 'b-desc');
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } //endregion
            //region Context menu

            /**
             * Supply items for headers context menu.
             * @private
             * @param column Header for this column
             * @param items Add items to this array
             * @returns {Object[]} Modified items array
             */

          }, {
            key: "getHeaderMenuItems",
            value: function getHeaderMenuItems(column, items) {
              var me = this,
                  store = me.store;

              if (column.groupable !== false) {
                items.push({
                  text: me.L('groupAscending'),
                  icon: 'b-fw-icon b-icon-group-asc',
                  name: 'groupAsc',
                  cls: 'b-separator',
                  weight: 110,
                  onItem: function onItem(_ref) {
                    var column = _ref.item.column;
                    return store.group(column.field, true);
                  }
                }, {
                  text: me.L('groupDescending'),
                  icon: 'b-fw-icon b-icon-group-desc',
                  name: 'groupDesc',
                  weight: 110,
                  onItem: function onItem(_ref2) {
                    var column = _ref2.item.column;
                    return store.group(column.field, false);
                  }
                });
              }

              if (store.isGrouped) {
                items.push({
                  text: me.L('stopGrouping'),
                  icon: 'b-fw-icon b-icon-clear',
                  name: 'groupRemove',
                  cls: column.groupable ? '' : 'b-separator',
                  weight: 110,
                  onItem: function onItem(_ref3) {
                    var column = _ref3.item.column;
                    return store.clearGroupers();
                  }
                });
              }
            }
            /**
             * Supply items to ColumnDragToolbar
             * @private
             */

          }, {
            key: "getColumnDragToolbarItems",
            value: function getColumnDragToolbarItems(column, items) {
              var me = this,
                  store = me.store;
              items.push({
                text: me.L('groupAscendingShort'),
                group: me.L('Group'),
                icon: 'b-icon b-icon-group-asc',
                name: 'groupAsc',
                cls: 'b-separator',
                weight: 110,
                onDrop: function onDrop(_ref4) {
                  var column = _ref4.column;
                  return store.group(column.field, true);
                }
              });
              items.push({
                text: me.L('groupDescendingShort'),
                group: me.L('Group'),
                icon: 'b-icon b-icon-group-desc',
                name: 'groupDesc',
                weight: 110,
                onDrop: function onDrop(_ref5) {
                  var column = _ref5.column;
                  return store.group(column.field, false);
                }
              });
              var grouped = store.groupers && store.groupers.find(function (col) {
                return col.field === column.field;
              });
              items.push({
                text: me.L('stopGroupingShort'),
                group: me.L('Group'),
                icon: 'b-icon b-icon-clear',
                name: 'groupRemove',
                disabled: !grouped,
                weight: 110,
                onDrop: function onDrop(_ref6) {
                  var column = _ref6.column;
                  return store.removeGrouper(column.field);
                }
              });
              return items;
            } //endregion
            //region Events - Store

            /**
             * Called when store grouping changes. Reflects on header and rerenders rows.
             * @private
             */

          }, {
            key: "onStoreGroup",
            value: function onStoreGroup(_ref7) {
              var groupers = _ref7.groupers;

              var grid = this.grid,
                  element = grid.element,
                  curGroupHeaders = element && _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].children(element, '.b-grid-header.b-group');

              if (element) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = curGroupHeaders[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var header = _step2.value; // IE11 doesnt support this
                    //header.classList.remove('b-group', 'b-asc', 'b-desc');

                    header.classList.remove('b-group');
                    header.classList.remove('b-asc');
                    header.classList.remove('b-desc');
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }

                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = groupers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var groupInfo = _step3.value;

                    var _header = grid.getHeaderElementByField(groupInfo.field); // IE11 doesnt support this
                    //header && header.classList.add('b-group', groupInfo.ascending ? 'b-asc' : 'b-desc');


                    if (_header) {
                      _header.classList.add('b-group');

                      _header.classList.add(groupInfo.ascending ? 'b-asc' : 'b-desc');
                    }
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              }
            }
            /**
             * Called when grouping is turned of in the store. Updates headers and rows.
             * @private
             * @param store
             */

          }, {
            key: "onStoreGroupingOff",
            value: function onStoreGroupingOff() {
              var me = this,
                  grid = me.grid,
                  curGroupHeaders = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].children(grid.element, '.b-grid-header.b-group');

              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = curGroupHeaders[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var header = _step4.value; // IE11 doesnt support this
                  //header.classList.remove('b-group', 'b-asc', 'b-desc');

                  header.classList.remove('b-group');
                  header.classList.remove('b-asc');
                  header.classList.remove('b-desc');
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }

              grid.refreshRows();
            } //endregion
            //region Events - Grid

            /**
             * Store touches when user touches header, used in onElementTouchEnd.
             * @private
             */

          }, {
            key: "onElementTouchStart",
            value: function onElementTouchStart(event) {
              var me = this,
                  target = event.target,
                  header = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(target, '.b-grid-header'),
                  column = header && me.grid.getColumnFromElement(header); // If it's a multi touch, group.


              if (event.touches.length > 1 && column && column.groupable !== false) {
                me.store.group(column.field);
              }
            }
            /**
             * React to click on headers (to group by that column if [alt] is pressed) and on group rows (expand/collapse).
             * @private
             * @param event
             * @returns {Boolean}
             */

          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              var me = this,
                  store = me.store,
                  target = event.target,
                  row = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(target, '.b-group-row'),
                  header = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(target, '.b-grid-header'),
                  field = header && header.dataset.column;

              if (target.classList.contains('b-resizer')) return; // Header

              if (header && field) {
                var columnGrouper = store.groupers.find(function (g) {
                  return g.field === field;
                }); // Store has a grouper for this column's field; flip grouper order

                if (columnGrouper && !event.shiftKey) {
                  store.group(field, !columnGrouper.ascending);
                  return false;
                } // Group or ungroup
                else if (event.shiftKey) {
                    var column = me.grid.columns.get(field);

                    if (column.groupable !== false) {
                      if (event.altKey) {
                        store.removeGrouper(field);
                      } else {
                        store.group(field);
                      }
                    }
                  }

                event.preventDefault();
              } // Anywhere on group-row


              if (row) {
                me.internalToggleCollapse(_Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].get(row).id);
                return false;
              }
            }
            /**
             * Toggle groups with [space].
             * @private
             * @param event
             * @returns {*}
             */

          }, {
            key: "onElementKeyDown",
            value: function onElementKeyDown(event) {
              var me = this; // only catch space on grid element, not in editors etc...

              if (me.store.isGrouped && event.target === me.client.element && event.key === ' ' && me.grid.focusedCell) {
                event.preventDefault();
                me.internalToggleCollapse(me.grid.focusedCell.id);
              }
            } //endregion
            //region Grid overrides

          }, {
            key: "onStoreDataChange",
            value: function onStoreDataChange(data) {
              var store = data.source; // Grouping mixin needs to process data which then makes sure UI is refeshed

              if (store.isGrouped && store.count > 0) return;
              this.overridden.onStoreDataChange(data);
            } //endregion

          }, {
            key: "renderer",
            set: function set(renderer) {
              this.groupRenderer = renderer;
            }
          }, {
            key: "field",
            set: function set(field) {
              this._field = field;
              this.store.group(field, this.ascending);
            },
            get: function get() {
              return this._field;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The name of the record field to group by.
                 * @config {String}
                 * @default
                 */
                field: null,

                /**
                 * A function which yields the HTML for a group header when passed a data block.
                 * The function is called in the context of this Group feature object.
                 * The data block passed contains the following properties:
                 *  - `groupRowFor` The value of the {@link #config-field} for the group.
                 *  - `groupColumn` Optionally, the column under which the {@link #config-field} is shown.
                 *  - `record` The group record representing the group, containing a `groupChildren` property which contains the child records for the group.
                 *
                 * The default renderer displays the `groupRowFor` and `record.meta.childCount`
                 * @config {Function}
                 * @default
                 */
                renderer: null
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                assign: ['collapseAll', 'expandAll'],
                chain: ['renderHeader', 'getHeaderMenuItems', 'getColumnDragToolbarItems', 'onElementTouchStart', 'onElementClick', 'onElementKeyDown'],
                override: ['onStoreDataChange']
              };
            }
          }]);

          return Group;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        Group.featureClass = 'b-group';
        Group._$name = 'Group';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(Group, true, ['Grid', 'Scheduler']);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/GroupSummary.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Grid/feature/GroupSummary.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureGroupSummaryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return GroupSummary;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./mixin/SummaryFormatter.js */
        "../Grid/lib/Grid/feature/mixin/SummaryFormatter.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/GroupSummary
         */

        /**
         * Displays a summary row as a group footer in a grouped grid. Uses same configuration options on columns as
         * {@link Grid.feature.Summary}.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * ```
         * features : {
         *     group        : 'city',
         *     groupSummary : true
         * }
         * ```
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo groupsummary
         * @classtype groupsummary
         * @externalexample feature/GroupSummary.js
         */

        var GroupSummary =
        /*#__PURE__*/
        function (_SummaryFormatter) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(GroupSummary, _SummaryFormatter);

          function GroupSummary() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, GroupSummary);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(GroupSummary, [{
            key: "construct",
            //region Init
            value: function construct(grid, config) {
              var me = this;
              Object.assign(me, {
                grid: grid,
                store: grid.store
              }); // flag that will make the Store insert rows for group footers

              me.store.useGroupFooters = true;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary.prototype), "construct", this).call(this, grid, config);

              if (!grid.features.group) {
                throw new Error('Requires Group feature to work, please enable');
              }

              me.store.on({
                update: me.onStoreUpdate,
                // need to run before grids listener, to flag for full refresh
                prio: 1,
                thisObj: me
              });
              me.grid.rowManager.on({
                beforerenderrow: me.onBeforeRenderRow,
                rendercell: me.renderCell,
                thisObj: me
              });
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "onBeforeRenderRow",
            //endregion
            //region Render

            /**
             * Called before rendering row contents, used to reset rows no longer used as group summary rows
             * @private
             */
            value: function onBeforeRenderRow(_ref) {
              var row = _ref.row,
                  record = _ref.record;

              if (row.isGroupFooter && !record.meta.hasOwnProperty('groupFooterFor')) {
                // not a group row, remove css
                row.isGroupFooter = false;
                row.removeCls('b-group-footer'); // force full "redraw" when rendering cells

                row.forceInnerHTML = true;
              }
            }
            /**
             * Called when a cell is rendered, styles the group rows first cell.
             * @private
             */

          }, {
            key: "renderCell",
            value: function renderCell(_ref2) {
              var column = _ref2.column,
                  cellElement = _ref2.cellElement,
                  rowElement = _ref2.rowElement,
                  row = _ref2.row,
                  record = _ref2.record,
                  size = _ref2.size;
              var me = this; // no need to do the code below if not grouping

              if (!me.store.isGrouped) return;

              if (record.meta.hasOwnProperty('groupFooterFor')) {
                // this is a group row, add css
                rowElement.classList.add('b-group-footer');
                row.isGroupFooter = true; // returns height config or count. config format is { height, count }. where `height is in px and should be
                // added to value calculated from `count

                var heightSetting = me.updateSummaryHtml(cellElement, column, record.meta.groupRecord.groupChildren);
                var count = typeof heightSetting === 'number' ? heightSetting : heightSetting.count; // number of summaries returned, use to calculate cell height

                if (count > 1) {
                  size.height = me.grid.rowHeight + count * me.grid.rowHeight * 0.1;
                } // height config with height specified, added to cell height


                if (heightSetting.height) {
                  size.height += heightSetting.height;
                }
              }
            }
          }, {
            key: "updateSummaryHtml",
            value: function updateSummaryHtml(cellElement, column, records) {
              records = records.slice();
              records.pop(); // last record is group footer, remove

              var html = this.generateHtml(column, records, 'b-grid-group-summary'); // First time, set table

              if (!cellElement.children.length) {
                cellElement.innerHTML = html;
              } // Following times, sync changes
              else {
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].sync(html, cellElement.firstElementChild);
                } // return summary "count", used to set row height


              return column.summaries ? column.summaries.length : column.sum ? 1 : 0;
            } //endregion
            //region Events

            /**
             * Updates summaries on store changes (except record update, handled below)
             * @private
             */

          }, {
            key: "onStoreUpdate",
            value: function onStoreUpdate(_ref3) {
              var _this = this;

              var store = _ref3.source,
                  changes = _ref3.changes; // If a grouping field is among the changes, StoreGroup#onDataChanged will
              // take care of the update by re-sorting.

              if (changes && store.groupers.find(function (grouper) {
                return grouper.field in changes;
              })) {
                return;
              } // only update summary when a field that affects summary is changed
              // TODO: this should maybe be removed, another column might depend on the value for its summary?


              var shouldUpdate = Object.keys(changes).some(function (field) {
                var colField = _this.grid.columns.get(field); // check existence, since a field not used in a column might have changed


                return Boolean(colField) && (Boolean(colField.sum) || Boolean(colField.summaries));
              });

              if (shouldUpdate) {
                this.grid.forceFullRefresh = true;
              }
            } //endregion

          }], [{
            key: "pluginConfig",
            get: function get() {
              return {};
            }
          }]);

          return GroupSummary;
        }(Object(_mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_13__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]));

        GroupSummary.featureClass = 'b-group-summary';
        GroupSummary._$name = 'GroupSummary';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(GroupSummary);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/QuickFind.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Grid/feature/QuickFind.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureQuickFindJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return QuickFind;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.search */
        "../Grid/node_modules/core-js/modules/es6.regexp.search.js");
        /* harmony import */


        var core_js_modules_es6_regexp_search__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_search__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler'; //TODO: Handle date columns
        //TODO: Icons to navigate between hits in the header? or in each cell?
        //TODO: Icon to clear quickfind in header
        //TODO: regex for valid key pressed?

        /**
         * @module Grid/feature/QuickFind
         */

        /**
         * Feature that allows the user to search in a column by focusing a cell and typing. Navigate between hits using the
         * keyboard, [f3] or [ctrl]/[cmd] + [g] moves to next, also pressing [shift] moves to previous.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // enable QuickFind
         * let grid = new Grid({
         *   features: {
         *     quickFind: true
         *   }
         * });
         *
         * // navigate to next hit programmatically
         * grid.features.quickFind.gotoNextHit();
         *
         * @demo quickfind
         * @classtype quickFind
         * @externalexample feature/QuickFind.js
         */

        var QuickFind =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(QuickFind, _InstancePlugin);

          function QuickFind() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, QuickFind);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(QuickFind).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(QuickFind, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(grid, config) {
              var me = this;
              me.grid = grid;
              me.store = grid.store;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(QuickFind.prototype), "construct", this).call(this, grid, config);
            } //endregion
            //region Plugin config
            //endregion
            //region Show/hide QuickFind

            /**
             * Shows a "searchfield" in the header. Triggered automatically when you have a cell focused and start typing.
             * @private
             */

          }, {
            key: "showQuickFind",
            value: function showQuickFind() {
              var me = this,
                  header = me.grid.getHeaderElement(me.columnId);

              if (header) {
                if (!me.headerField) {
                  var _DomHelper$createElem = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].createElement({
                    tag: 'div',
                    className: 'b-quick-hit-header',
                    children: [{
                      tag: 'div',
                      className: 'b-quick-hit-field'
                    }, {
                      tag: 'div',
                      className: 'b-quick-hit-badge'
                    }]
                  }, true),
                      _DomHelper$createElem2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_6___default()(_DomHelper$createElem, 3),
                      element = _DomHelper$createElem2[0],
                      field = _DomHelper$createElem2[1],
                      badge = _DomHelper$createElem2[2];

                  if (me.mode === 'header') {
                    header.appendChild(element);
                  } else {
                    element.className += ' b-quick-hit-mode-grid';
                    me.grid.element.appendChild(element);
                  }

                  me.headerField = {
                    header: element,
                    field: field,
                    badge: badge,
                    colHeader: header
                  };
                }

                me.headerField.field.innerHTML = me.find;
                me.headerField.badge.innerHTML = me.found.length;
                header.classList.add('b-quick-find-header');

                if (!me.renderListenerInitialized) {
                  me.grid.rowManager.on({
                    rendercell: me.renderCell,
                    thisObj: me
                  });
                  me.renderListenerInitialized = true;
                }
              }
            }
            /**
             * Hide the "searchfield" and remove highlighted hits. Called automatically when pressing [esc] or backspacing away
             * the keywords.
             * @private
             */

          }, {
            key: "hideQuickFind",
            value: function hideQuickFind() {
              var me = this; // rerender cells to remove quick-find markup

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = (me.prevFound || me.found)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var hit = _step.value;
                  var row = me.grid.getRowById(hit.id);
                  if (row) row.renderCell(row.getCell(me.columnId), hit.data);
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              if (me.headerField) {
                me.headerField.header.parentNode.removeChild(me.headerField.header);
                me.headerField.colHeader.classList.remove('b-quick-find-header');
                me.headerField = null;
              }

              if (me.renderListenerInitialized) {
                me.grid.rowManager.un({
                  rendercell: me.renderCell
                }, me);
                me.renderListenerInitialized = false;
              }

              me.grid.trigger('hideQuickFind');
            } //endregion
            //region Search

            /**
             * Performs a search and highlights hits. If find is empty, QuickFind is closed.
             * @param find Text to search for
             * @param columnFieldOrId Column to search
             */

          }, {
            key: "search",
            value: function search(find) {
              var columnFieldOrId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.columnId;
              var me = this,
                  column = me.grid.columns.getById(columnFieldOrId) || me.grid.columns.get(columnFieldOrId),
                  found = me.store.findByField(column.field, find),
                  i = 1,
                  grid = me.grid;
              Object.assign(me, {
                foundMap: {},
                prevFound: me.found,
                found: found,
                find: find,
                columnId: column.id
              });

              if (find) {
                me.showQuickFind();
              } else {
                me.hideQuickFind();
              } // reset column to use its normal settings for htmlEncoding


              if (me.currentColumn && me.currentColumn !== column) me.currentColumn.disableHtmlEncode = false; // clear old hits

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].children(grid.element, '.b-quick-hit')[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var cell = _step2.value; //IE11 doesnt support this
                  //cell.classList.remove('b-quick-hit', 'b-quick-hit-cell');

                  cell.classList.remove('b-quick-hit');
                  cell.classList.remove('b-quick-hit-cell'); // rerender cell to remove quick-hit-text

                  var row = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_13__["default"].get(cell).row;

                  row.renderCell(cell);
                } // want to set innerHTML each time for cell decoration to work

              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              column.disableHtmlEncode = true;
              me.currentColumn = column;
              if (!found) return;

              if (found.length > 0) {
                me.gotoClosestHit(grid.focusedCell, found);
              } // highlight hits for visible cells


              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = found[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var hit = _step3.value;
                  me.foundMap[hit.id] = i++;

                  var _row = grid.getRowById(hit.data.id);

                  if (_row) {
                    _row.renderCell(_row.getCell(column.id));
                  } // limit highlighted hits


                  if (i > 1000) break;
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              me.grid.trigger('quickFind', {
                find: find,
                found: found
              });
            }
            /**
             * Clears and closes QuickFind.
             */

          }, {
            key: "clear",
            value: function clear() {
              if (this.found && this.found.length) {
                this.search('');
              }
            }
            /**
             * Number of results found
             * @type {Number}
             * @readonly
             */

          }, {
            key: "gotoHit",

            /**
             * Found results (as returned by Store#findByField), an array in format { index: x, data: record }
             * @member {Object[]} found
             * @readonly
             */
            //endregion
            //region Navigation

            /**
             * Go to specified hit.
             * @param index
             */
            value: function gotoHit(index) {
              var me = this,
                  grid = me.grid,
                  nextHit = me.found[index];

              if (nextHit) {
                grid.focusCell({
                  columnId: me.columnId,
                  id: nextHit.id
                });
              }

              return !!nextHit;
            }
          }, {
            key: "gotoClosestHit",
            value: function gotoClosestHit(focusedCell, found) {
              var focusedIndex = focusedCell ? this.grid.store.indexOf(focusedCell.id) : 0,
                  foundSorted = found.slice().sort(function (a, b) {
                return Math.abs(a.index - focusedIndex) - Math.abs(b.index - focusedIndex);
              });
              this.gotoHit(found.indexOf(foundSorted[0]));
            }
            /**
             * Go to the first hit.
             */

          }, {
            key: "gotoFirstHit",
            value: function gotoFirstHit() {
              this.gotoHit(0);
            }
            /**
             * Go to the last hit.
             */

          }, {
            key: "gotoLastHit",
            value: function gotoLastHit() {
              this.gotoHit(this.found.length - 1);
            }
            /**
             * Select the next hit, scrolling it into view. Triggered with [f3] or [ctrl]/[cmd] + [g].
             */

          }, {
            key: "gotoNextHit",
            value: function gotoNextHit() {
              var me = this,
                  grid = me.grid,
                  // start from focused cell, or if focus has left grid use lastFocusedCell
              currentId = grid._focusedCell ? grid._focusedCell.id : grid.lastFocusedCell.id,
                  currentIndex = grid.store.indexOf(currentId) || 0,
                  nextHit = me.found.find(function (hit) {
                return hit.index > currentIndex;
              });

              if (nextHit) {
                grid.focusCell({
                  columnId: me.columnId,
                  id: nextHit.id
                });
              } else {
                me.gotoFirstHit();
              }
            }
            /**
             * Select the previous hit, scrolling it into view. Triggered with [shift] + [f3] or [shift] + [ctrl]/[cmd] + [g].
             */

          }, {
            key: "gotoPrevHit",
            value: function gotoPrevHit() {
              var me = this,
                  grid = me.grid,
                  currentId = grid._focusedCell ? grid._focusedCell.id : grid.lastFocusedCell.id,
                  currentIndex = grid.store.indexOf(currentId) || 0,
                  found = me.found,
                  prevHit;
              if (!found.length) return;

              for (var i = found.length - 1; i--; i >= 0) {
                if (found[i].index < currentIndex) {
                  prevHit = found[i];
                  break;
                }
              }

              if (prevHit) {
                grid.focusCell({
                  columnId: me.columnId,
                  id: prevHit.id
                });
              } else {
                me.gotoLastHit();
              }
            } //endregion
            //region Render

            /**
             * Called from SubGrid when a cell is rendered.
             * @private
             */

          }, {
            key: "renderCell",
            value: function renderCell(renderData) {
              var me = this,
                  cellElement = renderData.cellElement,
                  foundMap = me.foundMap && me.columnId === renderData.column.id && me.foundMap[renderData.record.id];

              if (foundMap) {
                // Check also TreeColumn's special internal `shouldHtmlEncode` flag
                var htmlEncoded = renderData.column.htmlEncode || renderData.column.shouldHtmlEncode; // highlight cell

                cellElement.classList.add('b-quick-hit'); // Special treatment of columns outputting HTML, just highlight whole cell

                if (!htmlEncoded) {
                  cellElement.classList.add('b-quick-hit-cell');
                } else {
                  // if features have added other stuff to the cell, value is in div.b-grid-cell-value
                  // highlight in cell if found in innerHTML
                  var inner = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].down(cellElement, '.b-grid-cell-value,.b-tree-cell-value') || cellElement,
                      html = inner.innerText,
                      where = html && html.toLowerCase().indexOf(me.find.toLowerCase());

                  if (where > -1) {
                    var end = where + me.find.length,
                        casedFind = html.slice(where, end),
                        spaceChar = ''; // Insert a space if matching char preceded by whitespace

                    if (html[where - 1] === ' ') {
                      spaceChar = '&nbsp;';
                    }

                    html = html.slice(0, where) + "<span class=\"b-quick-hit-text\">".concat(spaceChar).concat(casedFind, "</span>") + html.slice(end);
                    inner.innerHTML = html + "<div class=\"b-quick-hit-cell-badge\">".concat(foundMap, "</div>");
                  } else {
                    cellElement.classList.add('b-quick-hit-cell');
                  }
                }
              }
            } //endregion
            //region Events

            /**
             * Chained function called on grids keydown event. Handles backspace, escape, f3 and ctrl/cmd + g keys.
             * @private
             * @param event KeyboardEvent
             */

          }, {
            key: "onElementKeyDown",
            value: function onElementKeyDown(event) {
              var me = this,
                  filterFeature = this.grid.features.filter; // Only react to keystrokes on grid cell elements. IE11 gets event.target wrong compared to other browsers...

              if (_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].up(event.target, _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].isIE11 ? '.b-widget:not(.b-grid-subgrid):not(.b-grid)' : '.b-widget:not(.b-grid)')) {
                return;
              }

              if (me.find.length > 0) {
                // backspace
                if (event.key === 'Backspace') {
                  event.preventDefault();
                  me.find = me.find.substr(0, me.find.length - 1); //console.log(me.find);

                  me.search(me.find);
                } // escape
                else if (event.key === 'Escape') {
                    event.preventDefault();
                    me.find = '';
                    me.search(me.find);
                  } // F3 or CTRL+g
                  else if (event.key === 'F3' || event.key.toLowerCase() === 'g' && (event.ctrlKey || event.metaKey)) {
                      event.preventDefault();

                      if (event.shiftKey) {
                        me.gotoPrevHit();
                      } else {
                        me.gotoNextHit();
                      }
                    } // Ctrl+Shift+F
                    else if (filterFeature && me.columnId && me.foundCount && event.ctrlKey && event.shiftKey && event.key === 'F') {
                        filterFeature.showFilterEditor(me.grid.columns.getById(me.columnId), me.find);
                      }
              }
            }
            /**
             * Chained function called on grids keypress event. Handles input for "searchfield".
             * @private
             * @param event
             */

          }, {
            key: "onElementKeyPress",
            value: function onElementKeyPress(event) {
              var me = this; // Only react to keystrokes on grid cell elements

              if (_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].up(event.target, _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].isIE11 ? '.b-widget:not(.b-grid-subgrid):not(.b-grid)' : '.b-widget:not(.b-grid)') || event.key === 'Enter') {
                return;
              }

              if (me.grid._focusedCell) {
                var column = me.grid.columns.getById(me.grid._focusedCell.columnId); // if trying to search in invalid column, it's a hard failure

                if (column && column.searchable !== false) {
                  me.columnId = me.grid._focusedCell.columnId;

                  if (event.key && event.key.length === 1) {
                    me.find += event.key;
                    me.search(me.find);
                  }
                }
              }
            }
          }, {
            key: "onCellNavigate",
            value: function onCellNavigate(grid, fromCellSelector, toCellSelector, event) {
              var me = this,
                  found = me.prevFound || me.found;

              if (found && (!toCellSelector || toCellSelector.columnId !== me.columnId)) {
                me.clear();
              }
            } //endregion

          }, {
            key: "foundCount",
            get: function get() {
              return this.found ? this.found.length : 0;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                mode: 'header',
                find: ''
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['onElementKeyDown', 'onElementKeyPress', 'onCellNavigate']
              };
            }
          }]);

          return QuickFind;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__["default"]);

        QuickFind.featureClass = 'b-quick-find';
        QuickFind._$name = 'QuickFind';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].registerFeature(QuickFind);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/RegionResize.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Grid/feature/RegionResize.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureRegionResizeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RegionResize;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/RegionResize
         */

        /**
         * Makes the splitter between grid section draggable so you can resize grid sections.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // enable RegionResize
         * let grid = new Grid({
         *   features: {
         *     regionResize: true
         *   }
         * });
         *
         * @demo features
         * @classtype regionResize
         * @externalexample feature/RegionResize.js
         */

        var RegionResize =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RegionResize, _InstancePlugin);

          function RegionResize() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RegionResize);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RegionResize).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(RegionResize, [{
            key: "construct",
            // region Init
            value: function construct(grid, config) {
              this.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RegionResize.prototype), "construct", this).call(this, grid, config);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              // TODO: Cleanup
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RegionResize.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "onElementDblClick",
            //endregion
            value: function onElementDblClick(event) {
              var me = this,
                  grid = me.grid,
                  splitterEl = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].up(event.target, '.b-grid-splitter-collapsed'); // If collapsed splitter is dblclicked and region is not expanding
              // It is unlikely that user might dblclick splitter twice and even if he does, nothing should happen.
              // But just in case lets not expand twice.


              if (splitterEl && !me.expanding) {
                me.expanding = true;
                var region = splitterEl.dataset.region,
                    subGrid = grid.getSubGrid(region); // Usually collapsed splitter means corresponding region is collapsed. But in case of last two regions one
                // splitter can be collapsed in two directions. So, if corresponding region is expanded then last one is collapsed

                if (!subGrid.collapsed) {
                  region = grid.getLastRegions()[1];
                  subGrid = grid.getSubGrid(region);
                }

                subGrid.expand().then(function () {
                  return me.expanding = false;
                });
              }
            } //region Move splitter

            /**
             * Begin moving splitter.
             * @private
             * @param splitterElement Splitter element
             * @param clientX Initial x position from which new width will be calculated on move
             */

          }, {
            key: "startMove",
            value: function startMove(splitterElement, clientX) {
              var me = this,
                  grid = me.grid,
                  region = splitterElement.dataset.region,
                  gridEl = grid.element,
                  subGrid = grid.getSubGrid(region),
                  nextRegion = grid.regions[grid.regions.indexOf(region) + 1],
                  nextSubGrid = grid.getSubGrid(nextRegion),
                  flip = 1;

              if (subGrid.flex != null) {
                // If subgrid has flex, check if next one does not
                if (nextSubGrid.flex == null) {
                  subGrid = nextSubGrid;
                  flip = -1;
                }
              }

              if (splitterElement.classList.contains('b-grid-splitter-collapsed')) {
                return;
              }

              var availableWidth = subGrid.element.offsetWidth + nextSubGrid.element.offsetWidth;
              me.dragContext = {
                element: splitterElement,
                headerEl: subGrid.header.element,
                subGridEl: subGrid.element,
                subGrid: subGrid,
                originalWidth: subGrid.element.offsetWidth,
                originalX: clientX,
                minWidth: subGrid.minWidth || 0,
                maxWidth: Math.min(availableWidth, subGrid.maxWidth || availableWidth),
                flip: flip
              };
              gridEl.classList.add('b-moving-splitter');
              splitterElement.classList.add('b-moving');
            }
          }, {
            key: "onCollapseClick",
            value: function onCollapseClick(subGrid, splitterEl) {
              var me = this,
                  grid = me.grid,
                  region = splitterEl.dataset.region,
                  regions = grid.getLastRegions(); // Last splitter in the grid is responsible for collapsing/expanding last 2 regions and is always related to the
              // left one. Check if we are working with last splitter

              if (regions[0] === region) {
                var lastSubGrid = grid.getSubGrid(regions[1]);

                if (lastSubGrid.collapsed) {
                  lastSubGrid.expand();
                  return;
                }
              }

              subGrid.collapse();
            }
          }, {
            key: "onExpandClick",
            value: function onExpandClick(subGrid, splitterEl) {
              var me = this,
                  grid = me.grid,
                  region = splitterEl.dataset.region,
                  regions = grid.getLastRegions(); // Last splitter in the grid is responsible for collapsing/expanding last 2 regions and is always related to the
              // left one. Check if we are working with last splitter

              if (regions[0] === region) {
                if (!subGrid.collapsed) {
                  var lastSubGrid = grid.getSubGrid(regions[1]);
                  lastSubGrid.collapse();
                  return;
                }
              }

              subGrid.expand();
            }
            /**
             * Update splitter position.
             * @private
             * @param newClientX
             */

          }, {
            key: "updateMove",
            value: function updateMove(newClientX) {
              var dragContext = this.dragContext;

              if (dragContext) {
                var difX = newClientX - dragContext.originalX,
                    newWidth = Math.min(dragContext.maxWidth, dragContext.originalWidth + difX * dragContext.flip); // SubGrids monitor their own size and keep any splitters synced

                dragContext.subGrid.width = Math.max(newWidth, dragContext.minWidth);
              }
            }
            /**
             * Stop moving splitter.
             * @private
             */

          }, {
            key: "endMove",
            value: function endMove() {
              var me = this,
                  dragContext = me.dragContext;

              if (dragContext) {
                me.grid.element.classList.remove('b-moving-splitter');
                dragContext.element.classList.remove('b-moving');
                me.dragContext = null;
              }
            } //endregion
            //region Events

            /**
             * Start moving splitter on touch start.
             * @private
             * @param event
             */

          }, {
            key: "onElementTouchStart",
            value: function onElementTouchStart(event) {
              var me = this,
                  target = event.target;

              if (target.classList.contains('b-grid-splitter')) {
                me.startMove(target, event.touches[0].clientX);
                event.preventDefault();
              }
            }
            /**
             * Move splitter on touch move.
             * @private
             * @param event
             */

          }, {
            key: "onElementTouchMove",
            value: function onElementTouchMove(event) {
              if (this.dragContext) {
                this.updateMove(event.touches[0].clientX);
                event.preventDefault();
              }
            }
            /**
             * Stop moving splitter on touch end.
             * @private
             * @param event
             */

          }, {
            key: "onElementTouchEnd",
            value: function onElementTouchEnd(event) {
              if (this.dragContext) {
                this.endMove();
                event.preventDefault();
              }
            }
            /**
             * Start moving splitter on mouse down (on splitter).
             * @private
             * @param event
             */

          }, {
            key: "onElementMouseDown",
            value: function onElementMouseDown(event) {
              var me = this,
                  target = event.target,
                  splitter = event.target.closest(':not(.b-row-reordering):not(.b-dragging-event):not(.b-dragging-task):not(.b-dragging-header):not(.b-dragselecting) .b-grid-splitter'),
                  subGrid = splitter && me.grid.getSubGrid(splitter.dataset.region); // Only care about left clicks, avoids a bug found by monkeys

              if (event.button === 0) {
                // In case of touch screen inner splitter has 100% height and we should handle
                // it as target too
                if (target.classList.contains('b-grid-splitter') || target.classList.contains('b-grid-splitter-inner')) {
                  me.startMove(splitter, event.clientX);
                  event.preventDefault();
                } else if (target.classList.contains('b-icon-collapse-gridregion')) {
                  me.onCollapseClick(subGrid, splitter);
                } else if (target.classList.contains('b-icon-expand-gridregion')) {
                  me.onExpandClick(subGrid, splitter);
                }
              }
            }
            /**
             * Move splitter on mouse move.
             * @private
             * @param event
             */

          }, {
            key: "onElementMouseMove",
            value: function onElementMouseMove(event) {
              if (this.dragContext) {
                this.updateMove(event.clientX);
                event.preventDefault();
              }
            }
            /**
             * Stop moving splitter on mouse up.
             * @private
             * @param event
             */

          }, {
            key: "onElementMouseUp",
            value: function onElementMouseUp(event) {
              if (this.dragContext) {
                this.endMove();
                event.preventDefault();
              }
            }
          }, {
            key: "onSubGridCollapse",
            value: function onSubGridCollapse(subGrid) {
              var splitterEl = this.grid.resolveSplitter(subGrid),
                  regions = this.grid.getLastRegions(); // if last region was collapsed

              if (regions[1] === subGrid.region) {
                splitterEl.classList.add('b-grid-splitter-allow-collapse');
              }
            }
          }, {
            key: "onSubGridExpand",
            value: function onSubGridExpand(subGrid) {
              var splitterEl = this.grid.resolveSplitter(subGrid);
              splitterEl.classList.remove('b-grid-splitter-allow-collapse');
            } //endregion

          }, {
            key: "render",
            value: function render() {
              var _this$grid = this.grid,
                  regions = _this$grid.regions,
                  subGrids = _this$grid.subGrids; // Multiple regions, only allow collapsing to the edges by hiding buttons

              if (regions.length > 2) {
                // Only works in a 3 subgrid scenario. To support more subgrids we have to merge splitters or something
                // on collapse. Not going down that path currently...
                subGrids[regions[0]].splitterElement.classList.add('b-left-only');
                subGrids[regions[1]].splitterElement.classList.add('b-right-only');
              }
            }
          }], [{
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['onElementTouchStart', 'onElementTouchMove', 'onElementTouchEnd', 'onElementMouseDown', 'onElementMouseMove', 'onElementDblClick', 'onElementMouseUp', 'onSubGridCollapse', 'onSubGridExpand', 'render']
              };
            }
          }]);

          return RegionResize;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        RegionResize.featureClass = 'b-split';
        RegionResize._$name = 'RegionResize';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(RegionResize);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/RowReorder.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Grid/feature/RowReorder.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureRowReorderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RowReorder;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DragHelper.js */
        "../Grid/lib/Common/helper/DragHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");

        var productName = 'scheduler';
        /**
        * @module Grid/feature/RowReorder
        */

        /**
         * Allows user to reorder rows by dragging them. To get notified about row reorder listen to `change` event
         * on the grid {@link Common.data.Store store}.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * If the grid is set to {@link Grid.view.Grid#config-readOnly}, reordering is disabled.
         *
         * You can validate the drag drop flow by listening to the `gridrowdrag` event. Inside this listener you have access to the `index` property which is the target drop position.
         * For trees you get access to the `parent` record and `index`, where index means the child index inside the parent.
         *
         * ```
         * features : {
         *     rowReorder : {
         *         listeners : {
         *             gridRowDrag : ({ context }) => {
         *                // Here you have access to context.insertBefore, and additionally context.parent for trees
         *
         *                context.valid = false;
         *             }
         *         }
         *     }
         * }
         * ```
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @classtype rowReorder
         */

        var RowReorder =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(RowReorder, _Delayable);

          function RowReorder() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RowReorder);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RowReorder).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(RowReorder, [{
            key: "construct",
            value: function construct(grid, config) {
              this.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RowReorder.prototype), "construct", this).apply(this, arguments);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.dragHelper && this.dragHelper.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RowReorder.prototype), "doDestroy", this).call(this);
            }
            /**
             * Initialize drag & drop (called from render)
             * @private
             */

          }, {
            key: "init",
            value: function init() {
              var me = this,
                  grid = me.grid;
              me.dragHelper = new _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                name: 'rowReorder',
                mode: 'translateXY',
                cloneTarget: true,
                dragThreshold: 10,
                targetSelector: '.b-grid-row',
                lockX: true,
                scrollManager: grid.scrollManager,
                dragWithin: grid.verticalScroller,
                outerElement: grid.verticalScroller,
                // Since parent nodes can expand after hovering, meaning original drag start position now refers to a different point in the tree
                ignoreSamePositionDrop: false,
                createProxy: function createProxy(element) {
                  var clone = element.cloneNode(true),
                      container = document.createElement('div');
                  clone.removeAttribute('id'); // The containing element will be positioned instead

                  clone.style.transform = '';
                  container.appendChild(clone);
                  return container;
                },
                listeners: {
                  beforedragstart: me.onBeforeDragStart,
                  dragstart: me.onDragStart,
                  drag: me.onDrag,
                  drop: me.onDrop,
                  reset: me.onReset,
                  thisObj: me
                }
              });
              me.dropIndicator = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].createElement({
                parent: grid.bodyContainer,
                className: 'b-row-drop-indicator'
              });
              me.relayEvents(me.dragHelper, ['beforeDragStart', 'dragStart', 'drag', 'drop', 'abort'], 'gridRow');
            } //endregion
            //region Plugin config

          }, {
            key: "onBeforeDragStart",
            //endregion
            //region Events (drop)
            value: function onBeforeDragStart(_ref) {
              var context = _ref.context;
              var grid = this.grid,
                  targetSubGrid = grid.regions[0],
                  subGridEl = grid.subGrids[targetSubGrid].element; // Disabled for touch devices until implemented fully. https://app.assembla.com/spaces/bryntum/tickets/8185-fix-row-reorder-for-touch-devices/details#
              // Only dragging enabled in the leftmost grid section

              if (this.disabled || grid.readOnly || _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isTouchEvent || !subGridEl.contains(context.element)) {
                return false;
              }

              var record = this.grid.getRecordFromElement(context.element);
              return !record.meta.specialRow;
            }
          }, {
            key: "onDragStart",
            value: function onDragStart(_ref2) {
              var context = _ref2.context;
              var me = this,
                  record = me.grid.getRecordFromElement(context.grabbed);

              if (!record) {
                throw new Error('Failed to find record for dragged element');
              }

              if (me.grid.features.cellEdit) {
                me.grid.readOnly = true;
                me.grid.features.cellEdit.cancelEditing(true);
              }

              if (me.grid.features.contextMenu) {
                me.grid.features.contextMenu.hideContextMenu(false);
              }

              me.grid.element.classList.add('b-row-reordering');
              var focusedCell = context.element.querySelector('.b-focused');
              focusedCell && focusedCell.classList.remove('b-focused');

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeClasses(context.element.firstElementChild, ['b-selected', 'b-hover']);

              me.record = record;
            }
          }, {
            key: "onDrag",
            value: function onDrag(_ref3) {
              var context = _ref3.context,
                  event = _ref3.event;
              var me = this,
                  _me$grid = me.grid,
                  store = _me$grid.store,
                  rowManager = _me$grid.rowManager; // Ignore if user drags outside grid area

              if (!me.dragHelper.outerElement.contains(event.target) || !event.target.closest('.b-grid-subgrid')) {
                context.valid = false;
                return;
              }

              var valid = context.valid,
                  row = me.grid.rowManager.getRowAt(event.clientY),
                  overRecord,
                  dataIndex,
                  after,
                  insertBefore;

              if (row) {
                var rowTop = row.top + me.grid._bodyRectangle.y,
                    middleY = rowTop + row.height / 2;
                dataIndex = row.dataIndex;
                overRecord = row && store.getAt(dataIndex); // Drop after row below if mouse is in bottom half of hovered row

                after = event.clientY > middleY;
              } // Below the rows. Drop after last row
              else {
                  dataIndex = store.count - 1;
                  overRecord = store.last;
                  row = me.grid.rowManager.getRow(dataIndex);
                  after = true;
                } // Hovering the dragged record. This is a no-op.
              // But still gather the contextual data.


              if (overRecord === me.record) {
                valid = false;
              }

              if (store.tree) {
                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeClsGlobally(me.grid.element, 'b-row-reordering-target-parent');

                insertBefore = after ? overRecord.nextSibling : overRecord; // For trees, prevent moving a parent into its own hierarchy

                if (me.record.contains(overRecord)) {
                  valid = false;
                }

                context.parent = overRecord.parent;

                if (!context.parent.isRoot) {
                  var parentRow = rowManager.getRowById(context.parent);

                  if (parentRow) {
                    parentRow.addCls('b-row-reordering-target-parent');
                  }
                }

                me.clearTimeout(me.hoverTimer);

                if (overRecord && overRecord.isParent && !overRecord.isExpanded(store)) {
                  me.hoverTimer = me.setTimeout(function () {
                    return me.grid.expand(overRecord);
                  }, me.hoverExpandTimeout);
                }
              } else {
                // Public property used for validation
                insertBefore = after ? store.getAt(dataIndex + 1) : overRecord;
              } // Provide visual clue to user of the drop position


              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateY(me.dropIndicator, row.top + (after ? row.height : 0));

              context.insertBefore = insertBefore;
              context.valid = valid;
            }
            /**
             * Handle drop
             * @private
             */

          }, {
            key: "onDrop",
            value: function onDrop(_ref4) {
              var context = _ref4.context;
              var me = this,
                  grid = me.grid,
                  store = grid.store;
              context.asyncCleanup = context.async = true;
              context.element.classList.add('b-dropping');
              me.setTimeout(function () {
                grid.element.classList.remove('b-row-reordering');

                if (context.valid) {
                  if (store.tree) {
                    context.parent.insertChild(me.record, context.insertBefore);
                  } else {
                    store.insert(context.insertBefore ? store.indexOf(context.insertBefore) : store.count, me.record);
                  }

                  store.clearSorters();
                  context.finalize();
                }
              }, 300);
            }
            /**
             * Clean up on reset
             * @private
             */

          }, {
            key: "onReset",
            value: function onReset() {
              var me = this;
              me.grid.element.classList.remove('b-row-reordering');
              me.grid.readOnly = false;

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].removeClsGlobally(me.grid.element, 'b-row-reordering-target-parent');
            } //endregion
            //region Render

            /**
             * Updates DragHelper with updated headers when grid contents is rerendered
             * @private
             */

          }, {
            key: "render",
            value: function render() {
              // columns shown, hidden or reordered
              this.init();
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Events

            /**
             * Fired before dragging starts, return false to prevent the drag operation.
             * @preventable
             * @event beforeGridRowDragStart
             * @param {DragHelper} source
             * @param {Object} context
             * @param {MouseEvent|TouchEvent} event
             */

            /**
             * Fired when dragging starts.
             * @event gridRowDragStart
             * @param {DragHelper} source
             * @param {Object} context
             * @param {MouseEvent|TouchEvent} event
             */

            /**
             * Fired while the row is being dragged, in the listener function you have access to `context.insertBefore` a grid / tree record, and additionally `context.parent` (a TreeNode) for trees. You can
             * signal that the drop position is valid or invalid by setting `context.valid = false;`
             * @event gridRowDrag
             * @param {DragHelper} source
             * @param {Object} context
             * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
             * @param {Common.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
             * @param {Common.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
             * @param {MouseEvent} event
             */

            /**
             * Fired on row drop
             * @event gridRowDrop
             * @param {DragHelper} source
             * @param {Object} context
             * @param {Boolean} context.valid Set this to true or false to indicate whether the drop position is valid.
             * @param {Common.data.Model} context.insertBefore The record to insert before (`null` if inserting at last position of a parent node)
             * @param {Common.data.Model} context.parent The parent record of the current drop position (only applicable for trees)
             * @param {MouseEvent} event
             */

            /**
             * Fired when a row drag operation is aborted
             * @event gridRowAbort
             * @param {DragHelper} source
             * @param {Object} context
             * @param {MouseEvent} event
             */
            //endregion
            //region Init
            get: function get() {
              return {
                /**
                 * If hovering over a parent node for this period of a time in a tree, the node will expand
                 * @config {Number}
                 */
                hoverExpandTimeout: 1000
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                after: ['render']
              };
            }
          }]);

          return RowReorder;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_10__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"]));

        RowReorder.featureClass = '';
        RowReorder._$name = 'RowReorder';

        _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerFeature(RowReorder, false);

        _GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerFeature(RowReorder, true, 'Gantt');
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/Search.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Grid/feature/Search.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureSearchJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Search;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "../Grid/node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_regexp_search__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.search */
        "../Grid/node_modules/core-js/modules/es6.regexp.search.js");
        /* harmony import */


        var core_js_modules_es6_regexp_search__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_search__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");

        var productName = 'scheduler'; //TODO: Should listen for store search also, to work the other way around
        //TODO: Buggy sometimes, try searching for Barcelona tigers, navigate using buttons
        //TODO: Allow regex
        //TODO: Optional case sensitive
        //TODO: build in UI, popup with keyboard shortcut?

        /**
         * @module Grid/feature/Search
         */

        /**
         * Feature that allows the user to search the entire grid. Navigate between hits using the
         * keyboard, [f3] or [ctrl]/[cmd] + [g] moves to next, also pressing [shift] moves to previous.
         *
         * Note that this feature does not include a UI, please build your own and call appropriate methods in the feature. For
         * a demo implementation, see
         * <a href="../examples/search" target="_blank">Search example</a>.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // enable Search
         * let grid = new Grid({
         *   features: {
         *     search: true
         *   }
         * });
         *
         * // perform search
         * grid.features.search.search('steve');
         *
         * @demo search
         * @classtype search
         * @externalexample feature/Search.js
         */

        var Search =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(Search, _InstancePlugin);

          function Search() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, Search);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Search).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(Search, [{
            key: "construct",
            //region Init
            value: function construct(grid, config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Search.prototype), "construct", this).call(this, grid, config);

              Object.assign(me, {
                store: grid.store,
                grid: grid,
                find: '',
                hitEls: []
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.clear(true);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Search.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "search",
            //endregion
            //region Search

            /**
             * Performs a search and highlights hits.
             * @param {String} find Text to search for
             * @param {Boolean} gotoHit Go to first hit after search
             * @param {Boolean} reapply Pass true to force search
             */
            value: function search(find) {
              var gotoHit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var reapply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // empty search considered a clear

              if (!find) {
                return this.clear();
              } // searching for same thing again, do nothing


              if (!reapply && find === this.find) {
                return;
              }

              var me = this,
                  grid = me.grid,
                  // Only search columns in use
              columns = grid.columns.visibleColumns.filter(function (col) {
                return col.searchable !== false;
              }),
                  fields = columns.map(function (col) {
                return col.field;
              }),
                  found = me.store.search(find, fields);
              var i = 1;
              Object.assign(me, {
                foundMap: {},
                prevFound: me.found,
                found: found,
                find: find
              }); // clear old hits

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].children(grid.element, '.b-search-hit')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var cell = _step.value; // IE11 doesnt support this
                  //cell.classList.remove('b-search-hit', 'b-search-hit-cell');

                  cell.classList.remove('b-search-hit');
                  cell.classList.remove('b-search-hit-cell'); // rerender cell to remove search-hit-text

                  var row = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_17__["default"].get(cell).row;

                  row.renderCell(cell);
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              if (!found) return; // columns from previous search, reset htmlEncode

              if (me.hitColumns) {
                me.hitColumns.forEach(function (col) {
                  return col.disableHtmlEncode = false;
                });
              }

              me.hitColumns = []; // highlight hits for visible cells

              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = found[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var hit = _step2.value;
                  me.foundMap[hit.field + '-' + hit.id] = i++; // disable htmlEncode for columns with hits

                  var column = me.grid.columns.get(hit.field);

                  if (column) {
                    column.disableHtmlEncode = true;
                    me.hitColumns.push(column);
                  } // limit hits


                  if (i > 1000) break;
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              if (!me.listenersInitialized) {
                me.grid.rowManager.on({
                  rendercell: me.renderCell
                }, me);
                me.store.on({
                  refresh: me.onStoreRefresh
                }, me);
                me.listenersInitialized = true;
              }

              grid.refreshRows();
              me.grid.trigger('search', {
                grid: grid,
                find: find,
                found: found
              });

              if (gotoHit && !me.isHitFocused) {
                me.gotoNextHit(true);
              }

              return found;
            }
            /**
             * Clears search results.
             */

          }, {
            key: "clear",
            value: function clear() {
              var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  grid = me.grid;

              if (me.foundMap) {
                delete me.foundMap;
                delete me.find;
              }

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].forEachSelector(grid.element, '.b-search-hit', function (cell) {
                // IE11 doesnt support this
                //cell.classList.remove('b-search-hit', 'b-search-hit-cell');
                cell.classList.remove('b-search-hit');
                cell.classList.remove('b-search-hit-cell');
              });

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].removeEachSelector(grid.element, '.b-search-hit-cell-badge,.b-search-hit-text');

              if (me.listenersInitialized) {
                grid.rowManager.un({
                  rendercell: me.renderCell
                }, me);
                me.store.un({
                  refresh: me.onStoreRefresh
                }, me);
                me.listenersInitialized = false;
              }

              if (!silent) {
                grid.refreshRows();
                me.grid.trigger('clearSearch', {
                  grid: grid
                });
              }
            }
            /**
             * Number of results found
             * @readonly
             * @returns {Number}
             */

          }, {
            key: "gotoNextHit",

            /**
             * Select the next hit, scrolling it into view. Triggered with [f3] or [ctrl]/[cmd] + [g].
             */
            value: function gotoNextHit() {
              var fromStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this;
              if (!me.found || !me.found.length) return;
              var grid = me.grid,
                  fromCell = grid.focusedCell || grid.lastFocusedCell,
                  currentIndex = fromCell && !fromStart ? grid.store.indexOf(fromCell.id) : -1,
                  nextHit = me.found.findIndex(function (hit) {
                return hit.index > currentIndex;
              });

              if (nextHit !== -1) {
                me.gotoHit(nextHit);
              }
            }
            /**
             * Select the previous hit, scrolling it into view. Triggered with [shift] + [f3] or [shift] + [ctrl]/[cmd] + [g].
             */

          }, {
            key: "gotoPrevHit",
            value: function gotoPrevHit() {
              var me = this;
              if (!me.found || !me.found.length) return;
              var grid = me.grid,
                  fromCell = grid.focusedCell || grid.lastFocusedCell,
                  currentIndex = fromCell ? grid.store.indexOf(fromCell.id) : 0,
                  found = me.found;

              for (var i = found.length - 1; i--; i >= 0) {
                var hit = found[i];

                if (hit.index < currentIndex) {
                  me.gotoHit(i);
                  break;
                }
              }
            }
            /**
             * Go to specified hit.
             * @param index
             */

          }, {
            key: "gotoHit",
            value: function gotoHit(index) {
              var me = this,
                  grid = me.grid,
                  nextHit = me.found[index];

              if (nextHit) {
                grid.focusCell({
                  field: nextHit.field,
                  id: nextHit.id
                });
              }

              return !!nextHit;
            }
            /**
             * Go to the first hit.
             */

          }, {
            key: "gotoFirstHit",
            value: function gotoFirstHit() {
              this.gotoHit(0);
            }
            /**
             * Go to the last hit.
             */

          }, {
            key: "gotoLastHit",
            value: function gotoLastHit() {
              this.gotoHit(this.found.length - 1);
            } //endregion
            //region Render

            /**
             * Called from SubGrid when a cell is rendered. Highlights search hits.
             * @private
             */

          }, {
            key: "renderCell",
            value: function renderCell(_ref) {
              var cellElement = _ref.cellElement,
                  column = _ref.column,
                  record = _ref.record,
                  value = _ref.value,
                  cellContent = _ref.cellContent;
              var me = this,
                  hitIndex = me.foundMap && me.foundMap[column.field + '-' + record.id]; // clear search stuff from cell, might not be done by rendering since it does not always set innerHTML any longer
              //if (me.hitElements.includes(cellElement)) {
              //    const textElement  = cellElement.querySelector('.b-search-hit-text'),
              //        badgeElement = cellElement.querySelector('.b-search-hit-cell-badge');
              //
              //    textElement && textElement.remove();
              //    badgeElement && badgeElement.remove();
              //
              //    cellElement.classList.remove('b-search-hit');
              //    cellElement.classList.remove('b-search-hit-cell');
              //
              //    me.hitElements.splice(me.hitElements.indexOf(cellElement), 1);
              //}

              if (hitIndex) {
                // highlight cell
                cellElement.classList.add('b-search-hit'); // highlight in cell if found in innerHTML

                var inner = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].down(cellElement, '.b-grid-cell-value') || cellElement,
                    find = String(me.find).toLowerCase();

                if (String(value).toLowerCase() === find) {
                  inner.innerHTML = "<span class=\"b-search-hit-text\">".concat(cellContent, "</span><div class=\"b-search-hit-cell-badge\">").concat(hitIndex, "</div>");
                } else {
                  var _find = String(me.find).toLowerCase(),
                      where = cellContent && cellContent.toLowerCase().indexOf(_find);

                  if (where > -1) {
                    var end = where + _find.length,
                        casedFind = cellContent.slice(where, end);
                    inner.innerHTML = "".concat(cellContent.slice(0, where), "<span class=\"b-search-hit-text\">").concat(casedFind, "</span>").concat(cellContent.slice(end), "<div class=\"b-search-hit-cell-badge\">").concat(hitIndex, "</div>");
                  } else {
                    cellElement.classList.add('b-search-hit-cell');
                  }
                }

                me.hitEls.push(cellElement);
              }
            } //endregion
            //region Context menu

            /**
             * Add search menu item to cell context menu.
             * @param column
             * @param record
             * @param items
             * @returns {*}
             * @private
             */

          }, {
            key: "getCellMenuItems",
            value: function getCellMenuItems(column, record, items) {
              var me = this;

              if (column.searchable) {
                items.push({
                  text: me.L('searchForValue'),
                  icon: 'b-fw-icon b-icon-search',
                  cls: 'b-separator',
                  name: 'search',
                  onItem: function onItem(_ref2) {
                    var item = _ref2.item;
                    var column = item.column,
                        record = item.record; // TODO: Only extract selection from current cell instead? Lazy way for now

                    var sel = window.getSelection().toString();
                    if (!sel) sel = record[column.field];
                    me.search(sel);
                  }
                });
              }

              return items;
            } //endregion
            //region Events

            /**
             * Chained function called on grids keydown event. Handles backspace, escape, f3 and ctrl/cmd + g keys.
             * @private
             * @param event KeyboardEvent
             */

          }, {
            key: "onElementKeyDown",
            value: function onElementKeyDown(event) {
              var me = this;

              if (me.find && me.find !== '') {
                if (event.key === 'F3' || event.key.toLowerCase() === 'g' && (event.ctrlKey || event.metaKey)) {
                  event.preventDefault();

                  if (event.shiftKey) {
                    me.gotoPrevHit();
                  } else {
                    me.gotoNextHit();
                  }
                }
              }
            }
          }, {
            key: "onStoreRefresh",
            value: function onStoreRefresh() {
              this.search(this.find, false, true);
            } //endregion

          }, {
            key: "foundCount",
            get: function get() {
              return this.found && this.found.length || 0;
            } //endregion
            //region Navigation

            /**
             * Checks if focused row is a search hit.
             * @returns {Boolean} Returns true if focused row is a hit
             * @readonly
             */

          }, {
            key: "isHitFocused",
            get: function get() {
              var me = this,
                  grid = me.grid,
                  currentIndex = grid.focusedCell ? grid.store.indexOf(grid.focusedCell.id) : -1,
                  currentColumn = grid.focusedCell ? grid.columns.getById(grid.focusedCell.columnId) : null;
              return currentIndex !== -1 && me.found.some(function (hit) {
                return hit.index === currentIndex && currentColumn && hit.field === currentColumn.field;
              });
            }
          }], [{
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['getCellMenuItems', 'onElementKeyDown']
              };
            }
          }]);

          return Search;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__["default"]);

        Search.featureClass = 'b-search';
        Search._$name = 'Search';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].registerFeature(Search);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/Sort.js":
      /*!****************************************!*\
        !*** ../Grid/lib/Grid/feature/Sort.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureSortJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Sort;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.constructor */
        "../Grid/node_modules/core-js/modules/es6.regexp.constructor.js");
        /* harmony import */


        var core_js_modules_es6_regexp_constructor__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_constructor__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/util/DomClassList.js */
        "../Grid/lib/Common/helper/util/DomClassList.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler'; //TODO: Allow multisort using multitouch?
        //TODO: UI sort of broken with grouped headers, take a look at groupedheaders demo
        // TODO: multisort badge index wrong

        /**
         * @module Grid/feature/Sort
         */

        /**
         * Allows sorting of grid by clicking (or tapping) headers, also displays which columns grid is sorted by (numbered if
         * using multisort). Use modifier keys for multisorting: meta + click to add sorter, meta + alt + click to remove sorter.
         * The actual sorting is done by the store.
         *
         * For info on programmatically handling sorting, see {@link Common.data.mixin.StoreSort StoreSort}.
         *
         * This feature is <strong>enabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // use initial sorting
         * let grid = new Grid({
         *   features: {
         *     sort: 'name'
         *   }
         * });
         *
         * // can also be specified on store
         * let grid = new Grid({
         *   store: {
         *     sorters: [
         *       { field: 'name', ascending: false }
         *     ]
         *   }
         * });
         *
         * @demo sorting
         * @classtype sort
         * @externalexample feature/Sort.js
         */

        var Sort =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Sort, _InstancePlugin);

          function Sort() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, Sort);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Sort).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(Sort, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(grid, config) {
              var me = this; // process initial config into an actual config object

              config = me.processConfig(config);
              me.store = grid.store;
              me.grid = grid;
              me.store.on({
                sort: me.syncHeaderSortState,
                thisObj: me
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Sort.prototype), "construct", this).call(this, grid, config);
            } // Sort feature handles special config cases, where user can supply a string or an array of sorters
            // instead of a normal config object

          }, {
            key: "processConfig",
            value: function processConfig(config) {
              if (typeof config === 'string' || Array.isArray(config)) {
                return {
                  field: config,
                  ascending: null
                };
              }

              return config;
            } // override setConfig to process config before applying it

          }, {
            key: "setConfig",
            value: function setConfig(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Sort.prototype), "setConfig", this).call(this, this.processConfig(config));
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Sort.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "syncHeaderSortState",
            //endregion
            //region Headers

            /**
             * Update headers to match stores sorters (displays sort icon in correct direction on them)
             * @private
             */
            value: function syncHeaderSortState() {
              var me = this,
                  sorterMap = {};

              if (!me.grid.isConfiguring) {
                var storeSorters = me.store.sorters,
                    sorterCount = storeSorters.length,
                    classList = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_13__["default"](),
                    sorter; // Key sorters object by field name so we can find them.

                for (var sortIndex = 0; sortIndex < sorterCount; sortIndex++) {
                  var _sorter = storeSorters[sortIndex];

                  if (_sorter.field) {
                    sorterMap[_sorter.field] = {
                      ascending: _sorter.ascending,
                      sortIndex: sortIndex + 1
                    };
                  }
                } // Sync the sortable, sorted, and sortIndex state of each leaf header element


                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = me.grid.columns.bottomColumns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var leafColumn = _step.value;
                    var leafHeader = leafColumn.element;

                    if (leafHeader) {
                      // TimeAxisColumn in Scheduler has no textWrapper, since it has custom rendering,
                      // but since it cannot be sorted by anyway lets just ignore it
                      var dataset = leafColumn.textWrapper && leafColumn.textWrapper.dataset; // data-sortIndex is 1-based, and only set if there is > 1 sorter.
                      // iOS Safari throws a JS error if the requested delete property is not present.

                      dataset && dataset.sortIndex && delete dataset.sortIndex;
                      classList.value = leafHeader.classList;

                      if (leafColumn.sortable !== false) {
                        classList.add(me.sortableCls);
                        sorter = sorterMap[leafColumn.field];

                        if (sorter) {
                          if (sorterCount > 1 && dataset) {
                            dataset.sortIndex = sorter.sortIndex;
                          }

                          classList.add(me.sortedCls);

                          if (sorter.ascending) {
                            classList.add(me.sortedAscCls);
                            classList.remove(me.sortedDescCls);
                          } else {
                            classList.add(me.sortedDescCls);
                            classList.remove(me.sortedAscCls);
                          }
                        } else {
                          classList.remove(me.sortedCls); // Not optimal, but easiest way to make sure sort feature does not remove needed classes.
                          // Better solution would be to use different names for sorting and grouping

                          if (!classList['b-group']) {
                            classList.remove(me.sortedAscCls);
                            classList.remove(me.sortedDescCls);
                          }
                        }
                      } else {
                        classList.remove(me.sortableCls);
                      } // Update the element's classList


                      _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].syncClassList(leafHeader, classList);
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              }
            } //endregion
            //region Context menu

            /**
             * Adds sort menu items to header context menu.
             * @param column
             * @param items
             * @returns {Object[]}
             * @private
             */

          }, {
            key: "getHeaderMenuItems",
            value: function getHeaderMenuItems(column, items) {
              var me = this;

              if (column.sortable !== false) {
                items.push({
                  text: me.L('sortAscending'),
                  icon: 'b-fw-icon b-icon-sort-asc',
                  name: 'sortAsc',
                  cls: 'b-separator',
                  weight: 105,
                  onItem: function onItem(_ref) {
                    var column = _ref.item.column;
                    return me.store.sort(column.field, true);
                  }
                });
                items.push({
                  text: me.L('sortDescending'),
                  icon: 'b-fw-icon b-icon-sort-desc',
                  name: 'sortDesc',
                  weight: 105,
                  onItem: function onItem(_ref2) {
                    var column = _ref2.item.column;
                    return me.store.sort(column.field, false);
                  }
                });

                if (me.multiSort && me.grid.columns.records.filter(function (col) {
                  return col.sortable;
                }).length > 1) {
                  var sorter = this.grid.store.sorters.find(function (s) {
                    return s.field === column.field;
                  });
                  items.push({
                    text: me.L('multiSort'),
                    icon: 'b-fw-icon b-icon-sort',
                    name: 'multiSort',
                    weight: 105,
                    menu: [{
                      text: sorter ? me.L('toggleSortAscending') : me.L('addSortAscending'),
                      icon: 'b-fw-icon b-icon-sort-asc',
                      name: 'addSortAsc',
                      disabled: sorter && sorter.ascending,
                      weight: 105,
                      onItem: function onItem(_ref3) {
                        var column = _ref3.item.column;
                        return me.store.addSorter(column.field, true);
                      }
                    }, {
                      text: sorter ? me.L('toggleSortDescending') : me.L('addSortDescending'),
                      icon: 'b-fw-icon b-icon-sort-desc',
                      name: 'addSortDesc',
                      disabled: sorter && !sorter.ascending,
                      weight: 105,
                      onItem: function onItem(_ref4) {
                        var column = _ref4.item.column;
                        return me.store.addSorter(column.field, false);
                      }
                    }, {
                      text: me.L('removeSorter'),
                      icon: 'b-fw-icon b-icon-remove',
                      name: 'remove-sorter',
                      weight: 105,
                      disabled: !sorter,
                      onItem: function onItem(_ref5) {
                        var column = _ref5.item.column;
                        return me.store.removeSorter(column.field);
                      }
                    }]
                  });
                }
              }

              return items;
            }
            /**
             * Supply items to ColumnDragToolbar
             * @private
             */

          }, {
            key: "getColumnDragToolbarItems",
            value: function getColumnDragToolbarItems(column, items) {
              var me = this,
                  store = me.store;

              if (column.sortable !== false) {
                items.push({
                  text: me.L('sortAscendingShort'),
                  group: me.L('Sort'),
                  icon: 'b-icon b-icon-sort-asc',
                  name: 'sortAsc',
                  cls: 'b-separator',
                  weight: 105,
                  onDrop: function onDrop(_ref6) {
                    var column = _ref6.column;
                    return store.sort(column.field, true);
                  }
                });
                items.push({
                  text: me.L('sortDescendingShort'),
                  group: me.L('Sort'),
                  icon: 'b-icon b-icon-sort-desc',
                  name: 'sortDesc',
                  weight: 105,
                  onDrop: function onDrop(_ref7) {
                    var column = _ref7.column;
                    return store.sort(column.field, false);
                  }
                });
                var sorter = store.sorters.find(function (s) {
                  return s.field === column.field;
                });
                Array.prototype.push.apply(items, [{
                  text: me.L('addSortAscendingShort'),
                  group: me.L('Multisort'),
                  icon: 'b-icon b-icon-sort-asc',
                  name: 'multisortAddAsc',
                  disabled: sorter && sorter.ascending,
                  weight: 105,
                  onDrop: function onDrop(_ref8) {
                    var column = _ref8.column;
                    return store.addSorter(column.field, true);
                  }
                }, {
                  text: me.L('addSortDescendingShort'),
                  group: me.L('Multisort'),
                  icon: 'b-icon b-icon-sort-desc',
                  name: 'multisortAddDesc',
                  disabled: sorter && !sorter.ascending,
                  weight: 105,
                  onDrop: function onDrop(_ref9) {
                    var column = _ref9.column;
                    return store.addSorter(column.field, false);
                  }
                }, {
                  text: me.L('removeSorterShort'),
                  group: me.L('Multisort'),
                  icon: 'b-icon b-icon-remove',
                  name: 'multisortRemove',
                  weight: 105,
                  disabled: !sorter,
                  onDrop: function onDrop(_ref10) {
                    var column = _ref10.column;
                    return store.removeSorter(column.field);
                  }
                }]);
              }

              return items;
            } //endregion
            //region Events

            /**
             * Clicked on header, sort Store.
             * @private
             */

          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              var me = this,
                  store = me.store,
                  target = event.target,
                  header = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(target, '.b-grid-header.b-sortable'),
                  field = header && header.dataset.column;

              if (me.ignoreRe.test(target.className)) return; //Header

              if (header && field) {
                var column = me.grid.columns.getById(header.dataset.columnId),
                    columnGrouper = store.groupers.find(function (g) {
                  return g.field === field;
                }); // The Group feature will handle the change of the grouper's direction

                if (columnGrouper && !event.shiftKey) {
                  return;
                }

                if (column.sortable && !event.shiftKey) {
                  if (event.metaKey && event.altKey) {
                    store.removeSorter(column.field);
                  } else {
                    var sortBy = column.field;

                    if (typeof column.sortable === 'function') {
                      sortBy = {
                        field: column.field,
                        fn: column.sortable
                      };
                    } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(column.sortable) === 'object') {
                      sortBy = column.sortable; // Handle mismatch between Store#sort and CollectionSorter (field/property)

                      if (!sortBy.field) {
                        sortBy.field = sortBy.property || column.field;
                      }
                    }

                    store.sort(sortBy, null, event.metaKey);
                  }
                }
              }
            }
            /**
             * Called when grid headers are rendered, make headers match current sorters.
             * @private
             */

          }, {
            key: "renderHeader",
            value: function renderHeader() {
              this.syncHeaderSortState();
            } //endregion

          }, {
            key: "field",
            set: function set(field) {
              // Use columns sortable config for initial sorting if it is specified
              var column = this.grid.columns.get(field);

              if (column && _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(column.sortable) === 'object') {
                // Normalization of Store & CollectionSorter differences
                column.sortable.field = column.sortable.property || field;
                field = column.sortable;
              }

              this.store.sort(field, this.ascending);
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Enable multi sort
                 * @config {Boolean}
                 * @default
                 */
                multiSort: true,
                ignoreRe: new RegExp([// Stop this feature from having to know the internals of two other optional features.
                'b-grid-header-resize-handle', 'b-filter-icon'].join('|')),
                sortableCls: 'b-sortable',
                sortedCls: 'b-sort',
                sortedAscCls: 'b-asc',
                sortedDescCls: 'b-desc'
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['onElementClick', 'getHeaderMenuItems', 'getColumnDragToolbarItems', 'renderHeader']
              };
            }
          }]);

          return Sort;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__["default"]);

        Sort.featureClass = 'b-sort';
        Sort._$name = 'Sort';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].registerFeature(Sort, true);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/Stripe.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Grid/feature/Stripe.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureStripeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Stripe;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/Stripe
         */

        /**
         * Stripes rows, by adding even (b-even) or odd (b-odd) css classes to row elements.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * let grid = new Grid({
         *   features: {
         *     stripe: true
         *   }
         * });
         *
         * @demo columns
         * @classtype stripe
         * @externalexample feature/Stripe.js
         */

        var Stripe =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Stripe, _InstancePlugin);

          function Stripe() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Stripe);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Stripe).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Stripe, [{
            key: "construct",
            value: function construct(grid, config) {
              this.grid = grid;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Stripe.prototype), "construct", this).call(this, grid, config);

              grid.rowManager.on({
                renderrow: this.onRenderRow,
                thisObj: this
              });
            }
            /**
             * Applies even/odd CSS when row is rendered
             * @param {Grid.row.Row} rowModel
             * @private
             */

          }, {
            key: "onRenderRow",
            value: function onRenderRow(_ref) {
              var row = _ref.row;
              row.addCls(row.dataIndex % 2 === 0 ? 'b-even' : 'b-odd');
            }
          }]);

          return Stripe;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        Stripe._$name = 'Stripe';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerFeature(Stripe);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/Summary.js":
      /*!*******************************************!*\
        !*** ../Grid/lib/Grid/feature/Summary.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureSummaryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Summary;
        });
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _view_Footer_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../view/Footer.js */
        "../Grid/lib/Grid/view/Footer.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ./mixin/SummaryFormatter.js */
        "../Grid/lib/Grid/feature/mixin/SummaryFormatter.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/Summary
         */

        /**
         * Displays a summary row in the grid footer. Specify type of summary on columns, available types are:
         * <dl class="wide">
         * <dt>sum <dd>Sum of all values in the column
         * <dt>add <dd>Alias for sum
         * <dt>count <dd>Number of rows
         * <dt>countNotEmpty <dd>Number of rows containing a value
         * <dt>average <dd>Average of all values in the column
         * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
         * </dl>
         * Columns can also specify a summaryRenderer to format the calculated sum.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * ```
         * { text : 'Score', data : 'score', width : 80, sum : true }
         * { text : 'Rank', data : 'rank', width : 80, sum : 'average', summaryRenderer: sum => return 'Average rank ' + sum }
         * ```
         *
         * Also it is possible to set up multiple summaries as array of summary configs:
         * ```
         * { text : 'Rank', data : 'rank', summaries : [{ sum : 'average', label : 'Average' }, { sum : 'count', label : 'Count' }] }
         * ```
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo features
         * @classtype summary
         * @externalexample feature/Summary.js
         */

        var Summary =
        /*#__PURE__*/
        function (_SummaryFormatter) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(Summary, _SummaryFormatter);

          function Summary() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, Summary);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Summary).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(Summary, [{
            key: "construct",
            //region Init
            value: function construct(grid, config) {
              var me = this;
              Object.assign(me, {
                grid: grid,
                store: grid.store
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Summary.prototype), "construct", this).call(this, grid, config);

              me.store.on({
                change: me.onStoreChanged,
                thisObj: me
              }); // footers aren't added by default, add

              me.grid.eachSubGrid(function (subGrid) {
                if (!subGrid.footer) {
                  subGrid.footer = new _view_Footer_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
                    subGrid: subGrid,
                    parent: subGrid // Contained widgets need to know their parents

                  });
                }
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Summary.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "renderRows",
            //endregion
            //region Render
            value: function renderRows() {
              this.updateSummaries();
            }
            /**
             * Updates summaries. Summaries are displayed as tables in footer (styling left out to keep brief):
             * ```
             * <table>
             *     <tr><td colspan="2">0</td></tr> // { sum : 'min' } Only a calculation, span entire table
             *     <tr><td>Max</td><td>10</td></tr> // { sum : 'max', label: 'Max' } Label + calculation
             *     <tr><td>Max</td><td>10</td></tr> // { sum : 'sum', label: 'Max' } Label + calculation
             * </table>
             * ```
             * @private
             */

          }, {
            key: "updateSummaries",
            value: function updateSummaries() {
              var me = this,
                  cells = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].children(me.grid.element, '.b-grid-footer'),
                  store = me.store,
                  records = store.storage.values.filter(function (r) {
                return !r.meta.specialRow;
              }); // reset seeds, to not have ever increasing sums :)


              me.grid.columns.forEach(function (column) {
                column.summaries && column.summaries.forEach(function (config) {
                  if ('seed' in config) {
                    if (!('initialSeed' in config)) {
                      config.initialSeed = config.seed;
                    }

                    if (['number', 'string', 'date'].includes(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(config.initialSeed))) {
                      config.seed = config.initialSeed;
                    } else {
                      // create shallow copy
                      config.seed = Object.assign({}, config.initialSeed);
                    }
                  }
                });
              });
              cells.forEach(function (cellElement) {
                var column = me.grid.columns.get(cellElement.dataset.column),
                    html = me.generateHtml(column, records, 'b-grid-footer-summary');

                if (column.summaries ? column.summaries.length : column.sum ? 1 : 0) {
                  // First time, set table
                  if (!cellElement.children.length) {
                    cellElement.innerHTML = html;
                  } // Following times, sync changes
                  else {
                      _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].sync(html, cellElement.firstElementChild);
                    }
                }
              });
            } //endregion
            //region Events

            /**
             * Updates summaries on store changes (except record update, handled below)
             * @private
             */

          }, {
            key: "onStoreChanged",
            value: function onStoreChanged(_ref) {
              var _this = this;

              var action = _ref.action,
                  changes = _ref.changes;
              var shouldUpdate = true;

              if (action === 'update') {
                // only update summary when a field that affects summary is changed
                // TODO: this should maybe be removed, another column might depend on the value for its summary?
                shouldUpdate = Object.keys(changes).some(function (field) {
                  var colField = _this.grid.columns.get(field); // check existence, since a field not used in a column might have changed


                  return Boolean(colField) && (Boolean(colField.sum) || Boolean(colField.summaries));
                });
              }

              if (shouldUpdate) {
                this.updateSummaries();
              }
            } //endregion

          }], [{
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['renderRows']
              };
            }
          }]);

          return Summary;
        }(Object(_mixin_SummaryFormatter_js__WEBPACK_IMPORTED_MODULE_17__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_14__["default"]));

        Summary.featureClass = 'b-summary';
        Summary._$name = 'Summary';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_16__["default"].registerFeature(Summary);
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/Tree.js":
      /*!****************************************!*\
        !*** ../Grid/lib/Grid/feature/Tree.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureTreeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Tree;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../Grid/node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "../Grid/node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/asyncToGenerator */
        "../Grid/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../column/TreeColumn.js */
        "../Grid/lib/Grid/column/TreeColumn.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");

        var productName = 'scheduler'; //TODO: Handle paths? Like expandPath('Parent A/Sub B/Leaf')
        //TODO: Dblclick on row (or at least tree cell) should expand/collapse (if not using celleditor)
        //TODO: Arrows

        /**
         * @module Grid/feature/Tree
         */

        var immediatePromise = new Promise(function (resolve) {
          return resolve();
        });
        /**
         * Feature that makes the grid work more like a tree. Included by default in {@link Grid.view.TreeGrid}. Requires
         * exactly one {@link Grid.column.TreeColumn} among grids columns. That column will have its renderer replaced with a
         * tree renderer that adds padding and icon to give the appearance of a tree. The original renderer is preserved and
         * also called.
         *
         * This feature is <strong>disabled</strong> by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @demo tree
         * @classtype tree
         * @externalexample feature/Tree.js
         */

        var Tree =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(Tree, _Delayable);

          function Tree() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, Tree);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Tree).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(Tree, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(grid, config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Tree.prototype), "construct", this).call(this, grid, config); // find column


              var treeColumn = grid.columns.find(function (col) {
                return col instanceof _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_15__["default"];
              });
              Object.assign(me, {
                grid: grid,
                store: grid.store,
                rowManager: grid.rowManager,
                treeColumn: treeColumn
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              //TODO: Cleanup
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(Tree.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Expand & collapse

            /**
             * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
             * @param {Boolean} [collapse] Force collapse (true) or expand (false)
             * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
             * @returns {Promise}
             */

          }, {
            key: "toggleCollapse",
            value: function () {
              var _toggleCollapse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(idOrRecord, collapse) {
                var skipRefresh,
                    me,
                    store,
                    grid,
                    rowManager,
                    record,
                    meta,
                    success,
                    row,
                    cell,
                    _args = arguments;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        skipRefresh = _args.length > 2 && _args[2] !== undefined ? _args[2] : false;
                        me = this, store = me.store, grid = me.grid, rowManager = grid.rowManager, record = store.getById(idOrRecord), meta = record.instanceMeta(store); // If in the middle of a load, we cannot proceed.
                        // If its a leaf, this is a no-op.

                        if (!(meta.isLoadingChildren || record.isLeaf)) {
                          _context.next = 4;
                          break;
                        }

                        return _context.abrupt("return");

                      case 4:
                        success = true, row = rowManager.getRowFor(record);

                        if (collapse === undefined) {
                          collapse = !meta.collapsed;
                        } // Reject a no-op before the beforeToggleNode is fired


                        if (!(Boolean(meta.collapsed) === collapse)) {
                          _context.next = 8;
                          break;
                        }

                        return _context.abrupt("return");

                      case 8:
                        grid.trigger('beforeToggleNode', {
                          source: grid,
                          record: record,
                          collapse: collapse
                        });
                        meta.collapsed = collapse;

                        if (!meta.collapsed) {
                          _context.next = 14;
                          break;
                        }

                        store.onNodeCollapse(record);
                        _context.next = 32;
                        break;

                      case 14:
                        store.onNodeExpand(record); // Children not yet loaded, ask store for them.
                        // It will append them. Appending to a node which
                        // is expandded will insert the children into the UI.

                        if (record.isLoaded) {
                          _context.next = 32;
                          break;
                        }

                        meta.isLoadingChildren = true;

                        if (row) {
                          row.addCls('b-loading-children');
                        }

                        _context.prev = 18;
                        _context.next = 21;
                        return store.loadChildren(record);

                      case 21:
                        // Recache the row after possible async render
                        row = rowManager.getRowFor(record);
                        _context.next = 28;
                        break;

                      case 24:
                        _context.prev = 24;
                        _context.t0 = _context["catch"](18); // fail triggers event within loadChildren, no need to do much here

                        success = false;
                        meta.collapsed = true;

                      case 28:
                        _context.prev = 28; // row might have changed during load

                        if (row) {
                          row.removeCls('b-loading-children');
                        }

                        meta.isLoadingChildren = false;
                        return _context.finish(28);

                      case 32:
                        if (success) {
                          if (row) {
                            cell = row.getCell(me.treeColumn.id); // Toggle cell's expanded/collapsed state

                            row.renderCell(cell, record);
                          } // Add a temporary cls, used by Scheduler & Gantt to prevent transitions on events/tasks
                          // Block multiple applications in the case of a recursive collapseAll operation


                          if (!me.isTogglingNode) {
                            grid.element.classList.add('b-toggling-node');
                            me.isTogglingNode = true;
                            me.requestAnimationFrame(function () {
                              grid.element.classList.remove('b-toggling-node');
                              me.isTogglingNode = false;
                            });
                          }

                          grid.trigger(meta.collapsed ? 'collapseNode' : 'expandNode', {
                            source: grid,
                            record: record
                          });
                          grid.trigger('toggleNode', {
                            source: grid,
                            record: record,
                            collapse: collapse
                          });
                        }

                      case 33:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this, [[18, 24, 28, 32]]);
              }));

              return function toggleCollapse(_x, _x2) {
                return _toggleCollapse.apply(this, arguments);
              };
            }()
            /**
             * Collapse a single node. This function is exposed on Grid and can thus be called as `grid.collapse()`
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
             * @returns {Promise}
             */

          }, {
            key: "collapse",
            value: function () {
              var _collapse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee2(idOrRecord) {
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        return _context2.abrupt("return", this.toggleCollapse(idOrRecord, true));

                      case 1:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));

              return function collapse(_x3) {
                return _collapse.apply(this, arguments);
              };
            }()
            /**
             * Expand a single node. This function is exposed on Grid and can thus be called as `grid.expand()`
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to expand
             * @returns {Promise}
             */

          }, {
            key: "expand",
            value: function () {
              var _expand = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee3(idOrRecord) {
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", this.toggleCollapse(idOrRecord, false));

                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3, this);
              }));

              return function expand(_x4) {
                return _expand.apply(this, arguments);
              };
            }()
            /**
             * Expand or collapse all nodes, as specified by param, starting at the passed node (which defaults to the root node)
             * @param {Boolean} [collapse] Set to true to collapse, false to expand (defaults to true)
             * @param {Common.data.Model} [topNode] The topmost node from which to cascade a collapse.
             * Defaults to the {@link Common.data.Store#property-rootNode}. Not included in the cascade if
             * the root node is being used.
             * @returns {Promise}
             */

          }, {
            key: "expandOrCollapseAll",
            value: function expandOrCollapseAll() {
              var _this = this;

              var collapse = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var topNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.store.rootNode; // TODO: Some logic here and some in the store, keep in same place maybe

              var grid = this.grid,
                  store = this.store,
                  promises = [];
              grid.trigger('beforeToggleAllNodes', {
                source: grid,
                collapse: collapse
              }); // Each collapse/expand will trigger events on store, avoid that by suspending

              store.suspendEvents();
              topNode.traverse(function (record) {
                var gridMeta = record.instanceMeta(store);

                if (!record.isLeaf) {
                  if (collapse && !gridMeta.collapsed) {
                    _this.toggleCollapse(record, true, true);
                  } else if (!collapse && gridMeta.collapsed) {
                    promises.push(_this.toggleCollapse(record, false, true));
                  }
                }
              }, topNode === store.rootNode);
              store.resumeEvents(); // Return to top when collapsing all

              grid.refreshRows(true);
              grid.trigger('toggleAllNodes', {
                source: grid,
                collapse: collapse
              });
              return collapse ? immediatePromise : Promise.all(promises);
            }
            /**
             * Collapse all nodes. This function is exposed on Grid and can thus be called as `grid.collapseAll()`
             * @returns {Promise}
             */

          }, {
            key: "collapseAll",
            value: function () {
              var _collapseAll = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee4() {
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee4$(_context4) {
                  while (1) {
                    switch (_context4.prev = _context4.next) {
                      case 0:
                        return _context4.abrupt("return", this.expandOrCollapseAll(true));

                      case 1:
                      case "end":
                        return _context4.stop();
                    }
                  }
                }, _callee4, this);
              }));

              return function collapseAll() {
                return _collapseAll.apply(this, arguments);
              };
            }()
            /**
             * Expand all nodes. This function is exposed on Grid and can thus be called as `grid.expandAll()`
             * @returns {Promise}
             */

          }, {
            key: "expandAll",
            value: function () {
              var _expandAll = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee5() {
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        return _context5.abrupt("return", this.expandOrCollapseAll(false));

                      case 1:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5, this);
              }));

              return function expandAll() {
                return _expandAll.apply(this, arguments);
              };
            }()
            /**
             * Expands parent nodes to make this node "visible". This function is exposed on Grid and can thus be called as
             * `grid.expandTo()`
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node
             * @returns {Promise}
             */

          }, {
            key: "expandTo",
            value: function () {
              var _expandTo = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee7(idOrRecord) {
                var me, record, recordMeta, refreshNeeded, parent, parents;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee7$(_context7) {
                  while (1) {
                    switch (_context7.prev = _context7.next) {
                      case 0:
                        me = this, record = me.store.getById(idOrRecord), recordMeta = record.instanceMeta(me.store); // Already visible? abort

                        if (!(recordMeta.hiddenByCollapse === false)) {
                          _context7.next = 3;
                          break;
                        }

                        return _context7.abrupt("return");

                      case 3:
                        // Expand each parent
                        refreshNeeded = false, parent = record.parent, parents = []; // To expand path correctly we need to do it from top
                        // so parent record for each record will be in the store already

                        while (parent && !parent.isRoot) {
                          parents.push(parent);
                          parent = parent.parent;
                        }

                        _context7.next = 7;
                        return parents.reverse().forEach(
                        /*#__PURE__*/
                        function () {
                          var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
                          /*#__PURE__*/
                          _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee6(parent) {
                            return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee6$(_context6) {
                              while (1) {
                                switch (_context6.prev = _context6.next) {
                                  case 0:
                                    if (parent.instanceMeta(me.store).collapsed) {
                                      refreshNeeded = true;
                                    }

                                    _context6.next = 3;
                                    return me.toggleCollapse(parent, false, true);

                                  case 3:
                                  case "end":
                                    return _context6.stop();
                                }
                              }
                            }, _callee6, this);
                          }));

                          return function (_x6) {
                            return _ref.apply(this, arguments);
                          };
                        }());

                      case 7:
                        if (refreshNeeded) {
                          me.grid.refreshRows();
                        }

                        _context7.next = 10;
                        return me.grid.scrollRowIntoView(record);

                      case 10:
                      case "end":
                        return _context7.stop();
                    }
                  }
                }, _callee7, this);
              }));

              return function expandTo(_x5) {
                return _expandTo.apply(this, arguments);
              };
            }() //endregion
            //region Renderer
            //endregion
            //region Events

            /**
             * Called when user clicks somewhere in the grid. Expand/collapse node on icon click.
             * @private
             */

          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              var me = this,
                  target = event.target,
                  cellData = me.grid.getEventData(event); // Checks if click is on node expander icon, then toggles expand/collapse. Also toggles on entire cell if expandOnCellClick is true

              if (target.classList.contains('b-tree-expander') || me.expandOnCellClick && cellData && cellData.record.isParent) {
                me.toggleCollapse(cellData.record);
              }
            }
            /**
             * Called on key down in grid. Expand/collapse node on [space]
             * @private
             */

          }, {
            key: "onElementKeyDown",
            value: function onElementKeyDown(event) {
              // only catch space on grid element, not in editors etc...
              if (event.target === this.client.element && event.key === ' ') {
                event.preventDefault();
                this.toggleCollapse(this.grid.focusedCell.id);
              }
            } //endregion

          }, {
            key: "navigateRight",
            value: function navigateRight(event) {
              var me = this,
                  grid = me.grid,
                  cellSelector = grid.focusedCell;

              if (cellSelector) {
                var record = grid.store.getById(cellSelector.id); // shift triggers tree navigation behaviour, also used by default for single column which is tree

                if (grid.columns.getById(cellSelector.columnId).tree && (event.shiftKey || grid.columns.count === 1)) {
                  // on collapsed parent, expand
                  if (record.isParent && record.instanceMeta(grid.store).collapsed) {
                    me.expand(record);
                  } // otherwise go down
                  else {
                      grid.navigateDown(event);
                    }

                  return false;
                }
              }
            }
          }, {
            key: "navigateLeft",
            value: function navigateLeft(event) {
              var me = this,
                  grid = me.grid,
                  cellSelector = grid.focusedCell;

              if (cellSelector) {
                var record = grid.store.getById(cellSelector.id);

                if (grid.columns.getById(cellSelector.columnId).tree && (event.shiftKey || grid.columns.count === 1)) {
                  // on expanded parent, collapse
                  if (record.isParent && !record.instanceMeta(grid.store).collapsed) {
                    me.collapse(record);
                  } // otherwise go to parent
                  else if (record.parent) {
                      grid.focusCell({
                        id: record.parent.id,
                        columnId: cellSelector.columnId
                      });
                    }

                  return false;
                }
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Expand parent nodes when clicking on their cell
                 * @config {Boolean}
                 * @default
                 */
                expandOnCellClick: false
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                assign: ['collapseAll', 'expandAll', 'collapse', 'expand', 'expandTo', 'toggleCollapse'],
                before: ['navigateRight', 'navigateLeft'],
                chain: ['onElementClick', 'onElementKeyDown']
              };
            }
          }]);

          return Tree;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_16__["default"]));

        Tree.featureClass = 'b-tree';
        Tree._$name = 'Tree';

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_17__["default"].registerFeature(Tree, false, 'Grid');

        _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_17__["default"].registerFeature(Tree, true, 'TreeGrid');
        /***/

      },

      /***/
      "../Grid/lib/Grid/feature/mixin/SummaryFormatter.js":
      /*!**********************************************************!*\
        !*** ../Grid/lib/Grid/feature/mixin/SummaryFormatter.js ***!
        \**********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridFeatureMixinSummaryFormatterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Grid/feature/mixin/SummaryFormatter
         */

        /**
         * Mixin for Summary and GroupSummary that handles formatting sums.
         * @mixin
         * @private
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(SummaryFormatter, _ref);

              function SummaryFormatter() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SummaryFormatter);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(SummaryFormatter).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(SummaryFormatter, [{
                key: "generateHtml",

                /**
                 * Calculates sums and returns as a html table
                 * @param {Grid.column.Column} column Column to calculate sum for
                 * @param {Common.data.Model[]} records Records to include in calculation
                 * @param {String} cls CSS class to apply to summary table
                 * @returns {string}
                 */
                value: function generateHtml(column, records, cls) {
                  var store = this.store,
                      summaries = column.summaries || (column.sum ? [{
                    sum: column.sum,
                    renderer: column.summaryRenderer
                  }] : []);
                  var html = "<table class=\"".concat(cls, "\">");
                  summaries.forEach(function (config) {
                    var type = config.sum,
                        sum = null;
                    if (type === true) type = 'sum';

                    switch (type) {
                      case 'sum':
                      case 'add':
                        sum = store.sum(column.field, records);
                        break;

                      case 'max':
                        sum = store.max(column.field, records);
                        break;

                      case 'min':
                        sum = store.min(column.field, records);
                        break;

                      case 'average':
                      case 'avg':
                        sum = store.average(column.field, records);
                        break;

                      case 'count':
                        sum = records.length;
                        break;

                      case 'countNotEmpty':
                        sum = records.reduce(function (sum, record) {
                          var value = record[column.field];
                          return sum + (value !== null && value !== undefined ? 1 : 0);
                        }, 0);
                        break;
                    }

                    if (typeof type === 'function') {
                      sum = records.reduce(type, 'seed' in config ? config.seed : 0);
                    }

                    if (sum !== null) {
                      var valueCls = 'b-grid-summary-value',
                          // value to display, either using renderer or as is
                      valueHtml = config.renderer ? config.renderer({
                        config: config,
                        sum: sum
                      }) : sum,
                          // optional label
                      labelHtml = config.label ? "<td class=\"b-grid-summary-label\">".concat(config.label, "</td>") : '';
                      var summaryHtml; // no <td>s in html, wrap it (always the case when not using renderer)

                      if (!String(valueHtml).includes('<td>')) {
                        summaryHtml = labelHtml // has label, use returned html as value cell
                        ? "".concat(labelHtml, "<td class=\"").concat(valueCls, "\">").concat(valueHtml, "</td>") // no label, span entire table
                        : "<td colspan=\"2\" class=\"".concat(valueCls, "\">").concat(valueHtml, "</td>");
                      } // user is in charge of giving correct formatting
                      else {
                          summaryHtml = valueHtml;
                        }

                      html += "<tr>".concat(summaryHtml, "</tr>");
                    }
                  });
                  return html + '</table>';
                }
              }]);

              return SummaryFormatter;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/row/Row.js":
      /*!***********************************!*\
        !*** ../Grid/lib/Grid/row/Row.js ***!
        \***********************************/

      /*! exports provided: default */

      /***/
      function GridLibGridRowRowJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Row;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "../Grid/node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");

        var productName = 'scheduler';
        /**
         * @module Grid/row/Row
         */

        /**
         * Represents a single rendered row in the grid. Consists of one row element for each SubGrid in use. The grid only
         * creates as many rows as needed to fill the current viewport (and a buffer). As the grid scrolls
         * the rows are repositioned and reused, there is not a one to one relation between rows and records.
         *
         * For normal use cases you should not have to use this class directly. Rely on using renderers instead.
         * @extends Common/Base
         */

        var Row =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(Row, _Delayable);

          function Row() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Row);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Row).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Row, [{
            key: "construct",
            //region Init

            /**
             * Constructs a Row setting its index.
             * @param {Object} config A configuration object which must contain the following two properties:
             * @param {Grid.view.Grid} config.grid The owning Grid.
             * @param {Grid.row.RowManager} config.rowManager The owning RowManager.
             * @param {Number} index The index of the row within the RowManager's cache.
             * @function constructor
             */
            value: function construct(config) {
              // Set up defaults and properties
              Object.assign(this, {
                _elements: {},
                _elementsArray: [],
                _cells: {},
                _allCells: [],
                _regions: [],
                lastHeight: 0,
                lastTop: -1,
                _dataIndex: 0,
                _top: 0,
                _height: 0,
                _id: null,
                forceInnerHTML: false,
                isGroupFooter: false
              });
              Object.assign(this, config);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Row.prototype), "construct", this).call(this);
            } //endregion
            //region Data getters/setters

            /**
             * Get index in RowManagers rows array
             * @property {Number}
             * @readonly
             */

          }, {
            key: "addElement",
            //endregion
            //region Row elements

            /**
             * Add a row element for specified region.
             * @param {String} region Region to add element for
             * @param {HTMLElement} element Element
             * @private
             */
            value: function addElement(region, element) {
              var me = this;
              var cellElement = element.firstElementChild;
              me._elements[region] = element;

              me._elementsArray.push(element);

              me._regions.push(region);

              _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].assign(element, {
                index: me.index
              });

              me._cells[region] = [];

              while (cellElement) {
                me._cells[region].push(cellElement);

                me._allCells.push(cellElement);

                _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].set(cellElement, {
                  column: cellElement.dataset.column,
                  // TODO: dataset is slow, read from columnstore using index instead
                  columnId: cellElement.dataset.columnId,
                  rowElement: cellElement.parentNode,
                  row: me
                });

                cellElement = cellElement.nextElementSibling;
              } // making css selectors simpler, dataset has bad performance but it is only set once and never read


              element.dataset.index = me.index;
            }
            /**
             * Get the element for the specified region.
             * @param {String} region
             * @returns {HTMLElement}
             */

          }, {
            key: "getElement",
            value: function getElement(region) {
              return this._elements[region];
            }
            /**
             * Execute supplied function for each regions element.
             * @param {Function} fn
             */

          }, {
            key: "eachElement",
            value: function eachElement(fn) {
              for (var i = 0; i < this._elementsArray.length; i++) {
                fn(this._elementsArray[i], i);
              } //this._elementsArray.forEach(fn);

            }
            /**
             * Execute supplied function for each cell.
             * @param {Function} fn
             */

          }, {
            key: "eachCell",
            value: function eachCell(fn) {
              this._allCells.forEach(fn);
            }
            /**
             * Row elements (one for each region)
             * @type {HTMLElement[]}
             * @readonly
             */

          }, {
            key: "getCells",

            /**
             * Get cell elements for specified region.
             * @param {String} region Region to get elements for
             * @returns {HTMLElement[]} Array of cell elements
             */
            value: function getCells(region) {
              return this._cells[region];
            }
            /**
             * Get the cell element for the specified column.
             * @param {String|Number} columnId Column id
             * @returns {HTMLElement} Cell element
             */

          }, {
            key: "getCell",
            value: function getCell(columnId) {
              /*let found = null;
               // look in all regions
               this._regions.forEach(region => {
               if (!found) found = this.getCells(region).find(cell => DomDataStore.get(cell).column === column);
               });*/
              return this._allCells.find(function (cell) {
                var cellData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].get(cell);

                return cellData.columnId === columnId || cellData.column === columnId;
              });
            }
          }, {
            key: "removeElements",
            value: function removeElements() {
              var onlyRelease = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this;

              if (!onlyRelease) {
                me._elementsArray.forEach(function (element) {
                  return element.remove();
                });
              }

              me._elements = {};
              me._cells = {};
              me._elementsArray.length = me._regions.length = me._allCells.length = me.lastHeight = me.height = 0;
              me.lastTop = -1;
            } //endregion
            //region Height

            /**
             * Get/set row height
             * @property {Number}
             */

          }, {
            key: "setHeightIfBigger",

            /**
             * Sets row height, but only if the height is bigger than currently set height (used when rendering rows to
             * match height for highest region element)
             * @param height Height to set
             * @private
             */
            value: function setHeightIfBigger(height) {
              if (height > this.height) this.height = height;
            }
            /**
             * Sync elements height to rows height
             * @private
             */

          }, {
            key: "updateElementsHeight",
            value: function updateElementsHeight() {
              var me = this; // prevent unnecessary style updates

              if (me.lastHeight !== me.height) {
                var elements = me._elementsArray;

                for (var i = 0; i < elements.length; i++) {
                  elements[i].style.height = "".concat(me.offsetHeight, "px");
                }

                me.lastHeight = me.height;
              }
            } //endregion
            //region CSS

            /**
             * Add css classes to each element.
             * @param {...String} classes
             */

          }, {
            key: "addCls",
            value: function addCls() {
              for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
                classes[_key] = arguments[_key];
              }

              this.eachElement(function (element) {
                return _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].addClasses(element, classes);
              });
            }
            /**
             * Remove css classes from each element.
             * @param {...String} classes
             */

          }, {
            key: "removeCls",
            value: function removeCls() {
              for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                classes[_key2] = arguments[_key2];
              }

              this.eachElement(function (element) {
                return _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].removeClasses(element, classes);
              });
            } //endregion
            //region Position

            /**
             * Is this the very first row?
             * @property {Boolean}
             * @readonly
             */

          }, {
            key: "setTop",

            /**
             * Sets top coordinate, translating elements position.
             * @param top Top coordinate
             * @internal
             */
            value: function setTop(top) {
              if (this._top !== top) {
                this._top = top;
                this.translateElements();
              }
            }
            /**
             * Sets bottom coordinate, translating elements position.
             * @param bottom Bottom coordinate
             * @private
             */

          }, {
            key: "setBottom",
            value: function setBottom(bottom) {
              this.setTop(bottom - this.offsetHeight);
            }
            /**
             * Sets css transform to position elements at correct top position (translateY)
             * @private
             */

          }, {
            key: "translateElements",
            value: function translateElements() {
              var me = this,
                  positionMode = me.grid.positionMode;

              if (me.lastTop !== me.top) {
                var elements = me._elementsArray;

                for (var i = 0; i < elements.length; i++) {
                  var style = elements[i].style;

                  if (positionMode === 'translate') {
                    style.transform = "translate(0,".concat(me.top, "px)");
                  } else if (positionMode === 'translate3d') {
                    style.transform = "translate3d(0,".concat(me.top, "px,0)");
                  } else if (positionMode === 'position') {
                    style.top = "".concat(me.top, "px");
                  }
                }

                me.rowManager.trigger('translateRow', {
                  row: me
                });
                me.lastTop = me.top;
              }
            }
            /**
             * Moves all row elements up or down and updates model.
             * @param {Number} offsetTop Pixels to offset the elements
             * @private
             */

          }, {
            key: "offset",
            value: function offset(offsetTop) {
              var newTop = this._top + offsetTop; // Not allowed to go below zero (won't be reachable on scroll in that case)

              if (newTop < 0) {
                offsetTop -= newTop;
                newTop = 0;
              }

              this.setTop(newTop);
              return offsetTop;
            } //endregion
            //region Render

            /**
             * Renders a record into this rows elements (trigger event that subgrids catch to do the actual rendering).
             * @param {Common.data.Model} record
             * @private
             */

          }, {
            key: "render",
            value: function render(recordIndex, record) {
              var updatingSingleRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
              var batch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

              var me = this,
                  cells = me.cells,
                  grid = me.grid,
                  oldId = me._id,
                  elements = me._elementsArray,
                  rowElData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].get(elements[0]),
                  rowManager = me.rowManager,
                  rowHeight = rowManager._rowHeight,
                  oldHeight = me.height,
                  defaultRowCls = updatingSingleRow && grid.transitionDuration ? "".concat(me.cls, " b-grid-row-updating") : me.cls;

              var i = 0,
                  rowElement,
                  cell,
                  size; // no record specified, try looking up in store (false indicates empty row, don't do lookup

              if (!record && record !== false) {
                record = grid.store.getById(rowElData.id);
                recordIndex = grid.store.indexOf(record);
              }

              var selected = record && grid.isSelected(record.id); // used by GroupSummary feature to clear row before

              rowManager.trigger('beforeRenderRow', {
                row: me,
                record: record,
                oldId: oldId
              });

              for (i; i < elements.length; i++) {
                rowElement = elements[i]; // Clean classList

                rowElement.className = defaultRowCls; // Apply cls from data directly to row
                // TODO: should be configurable on grid

                if (selected) {
                  rowElement.classList.add('b-selected');
                } // no record & data says it is displayed, "undisplay" it


                if (!record) {
                  rowElData.displayed = false;
                  rowElement.classList.add('b-grid-row-not-displayed');
                }

                if (record) {
                  if (record.cls) record.cls.split(' ').forEach(function (cls) {
                    return rowElement.classList.add(cls);
                  }); // has record and data says it is not displayed, flag as displayed
                  //if (rowElData.displayed === false) rowEl.classList.remove('b-grid-row-not-displayed');

                  rowElData.displayed = true;
                }
              }

              if (updatingSingleRow && grid.transitionDuration) {
                me.setTimeout(function () {
                  // We should iterate all elements, in case we have regions in the grid
                  elements.forEach(function (element) {
                    element.classList.remove('b-grid-row-updating');
                  });
                }, grid.transitionDuration);
              } // Will be set from renderers


              me.height = 0;

              if (record) {
                me.id = record.id;
                me.dataIndex = recordIndex;
              } else {
                // More rows then records, render it empty for now...
                me.id = null;
                me.dataIndex = null;
              }

              for (i = 0; i < cells.length; i++) {
                cell = cells[i];
                size = me.renderCell(cell, record, i, updatingSingleRow); // we want to make row in all parts as high as the highest cell

                me.setHeightIfBigger(size && size.height || rowHeight);
              } // Height gets set during render, reflect on elements


              me.updateElementsHeight(); // Rerendering a row might change its height, which forces translation of all following rows

              if (updatingSingleRow) {
                if (oldHeight !== me.height) {
                  rowManager.translateFromRow(me, batch);
                }

                rowManager.trigger('updateRow', {
                  row: me,
                  record: record,
                  oldId: oldId
                });
              } // TODO: Make direct function call if no more features than Stripe needs this


              rowManager.trigger('renderRow', {
                row: me,
                record: record,
                oldId: oldId
              });
              me.forceInnerHTML = false;
            }
            /**
             * Renders a single cell, calling features to allow them to hook.
             * @param cellElement Cell element to render
             * @param record Record, fetched from store if undefined
             * @param index
             * @param updatingSingleRow
             * @private
             */

          }, {
            key: "renderCell",
            value: function renderCell(cellElement, record, index) {
              var _newCellClass;

              var updatingSingleRow = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

              var me = this,
                  cellElementData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].get(cellElement),
                  col = me.grid.columns.getById(cellElementData.columnId),
                  rowElement = cellElementData.rowElement,
                  rowElementData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].get(rowElement),
                  internalCellCls = col.internalCellCls,
                  cellCls = col.cellCls,
                  align = col.align,
                  renderer = col.renderer,
                  defaultRenderer = col.defaultRenderer,
                  columnId = col.id,
                  cellContext = {
                columnId: columnId,
                id: rowElementData.id
              },
                  useRenderer = renderer || defaultRenderer;

              if (!record) {
                // Clear out row without record
                // Edge case, only happens if groups/tree is collapsed leading to fewer records than row elements
                if (rowElementData.id === null) {
                  // setting to ' ' (space) makes it not remove firstChild, thus not breaking
                  // when doing real render the next time
                  // NOTE: have opted to not clear cell. might be confusing in DOM but simplifies for cells reusing
                  // elements internally. Another option would be to have a derenderer per column which is called
                  // cell.innerHTML = ' ';
                  cellElement.className = 'b-grid-cell';
                  return;
                }

                record = me.grid.store.getById(rowElementData.id);
                if (!record) return;
              }

              var newCellClass = (_newCellClass = {
                'b-grid-cell': 1
              }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newCellClass, internalCellCls, internalCellCls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newCellClass, cellCls, cellCls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newCellClass, 'b-cell-dirty', record.isFieldModified(col.field)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newCellClass, "b-grid-cell-align-".concat(align), align), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newCellClass, 'b-selected', me.grid.isSelected(cellContext)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_newCellClass, 'b-focused', me.grid.isFocused(cellContext)), _newCellClass);

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].syncClassList(cellElement, newCellClass);

              var // TODO: record.rowHeight should be configurable (which field)
              size = {
                height: record.get('rowHeight') || 0
              },
                  cellContent = col.getRawValue(record),
                  shouldSetContent = true,
                  rendererData = {
                cellElement: cellElement,
                rowElement: rowElement,
                value: cellContent,
                record: record,
                column: col,
                size: size,
                grid: me.grid,
                row: cellElementData.row,
                updatingSingleRow: updatingSingleRow
              }; // Call renderer or set innerHTML directly if none
              // if renderer returns a value, set it in innerHTML below. render is also free to do it itself

              if (useRenderer) {
                cellContent = useRenderer.call(col, rendererData);
                if (cellContent === undefined) shouldSetContent = false;
              } // Listeners might need to know what string went into the DOM
              // Maintainer: the == null test below ensures that values of both null and undefined
              // result in an empty cell.


              var text = rendererData.cellContent = cellContent == null ? '' : String(cellContent);

              if (shouldSetContent) {
                // row might be flagged by GroupSummary to require full "redraw"
                if (me.forceInnerHTML) {
                  cellElement.innerHTML = text;
                } // display cell contents as text or use actual html?
                // (disableHtmlEncode set by features that decorate cell contents)
                else if (col.htmlEncode && !col.disableHtmlEncode) {
                    if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isLinux) {
                      // linux does not have firstChild.data
                      cellElement.innerText = text;
                    } else {
                      // setting firstChild.data is faster than innerText (and innerHTML),
                      // but in some cases the inner node is lost and needs to be recreated
                      var firstChild = cellElement.firstChild;

                      if (!firstChild) {
                        cellElement.innerText = text;
                      } else {
                        firstChild.data = text;
                      }
                    }
                  } else {
                    var hasStringContent = typeof cellContent === 'string';

                    if (col.autoSyncHtml && (!hasStringContent || cellElement.childElementCount)) {
                      // String content in html column is handled as a html template string
                      if (hasStringContent) {
                        // update cell with only changed attributes etc.
                        _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].sync(text, cellElement.firstElementChild);
                      } // Other content is considered to be a DomHelper config object
                      else {
                          _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].sync({
                            elementConfig: cellContent,
                            targetElement: cellElement
                          });
                        }
                    } else {
                      cellElement.innerHTML = text;
                    }
                  }
              } // Allow others to affect rendering


              me.rowManager.trigger('renderCell', rendererData);
              return size;
            } //endregion

          }, {
            key: "index",
            get: function get() {
              return this._index;
            },
            set: function set(index) {
              this._index = index;
            }
            /**
             * Get/set this rows current index in grids store
             * @property {Number}
             */

          }, {
            key: "dataIndex",
            get: function get() {
              return this._dataIndex;
            },
            set: function set(dataIndex) {
              if (this._dataIndex !== dataIndex) {
                var elements = this._elementsArray;
                this._dataIndex = dataIndex;

                for (var i = 0; i < elements.length; i++) {
                  elements[i].dataset.index = dataIndex;
                }
              }
            }
            /**
             * Get/set id for currently rendered record
             * @property {String|Number}
             */

          }, {
            key: "id",
            get: function get() {
              return this._id;
            },
            set: function set(id) {
              var me = this,
                  idObj = {
                id: id
              },
                  idMap = me.rowManager.idMap,
                  elements = me._elementsArray,
                  cells = me._allCells;

              if (me._id != id || idMap[id] !== me) {
                if (idMap[me._id] === me) delete idMap[me._id];
                idMap[id] = me;
                me._id = id;

                for (var i = 0; i < elements.length; i++) {
                  _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].assign(elements[i], idObj);
                }

                for (var _i = 0; _i < cells.length; _i++) {
                  _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_12__["default"].assign(cells[_i], idObj);
                }
              }
            }
          }, {
            key: "elements",
            get: function get() {
              return this._elements;
            } //endregion
            //region Cell elements

            /**
             * Row cell elements
             * @returns {HTMLElement[]}
             * @readonly
             */

          }, {
            key: "cells",
            get: function get() {
              return this._allCells;
            }
          }, {
            key: "height",
            get: function get() {
              return this._height;
            },
            set: function set(height) {
              this._height = height;
            }
            /**
             * Get row height including border
             * @property {Number}
             */

          }, {
            key: "offsetHeight",
            get: function get() {
              // me.height is specified height, add border height to it to get cells height to match specified rowHeight
              // border height is measured in Grid#get rowManager
              return this.height + this.grid._rowBorderHeight;
            }
          }, {
            key: "isFirst",
            get: function get() {
              return this.dataIndex === 0;
            }
            /**
             * Row top coordinate
             * @property {Number}
             * @readonly
             */

          }, {
            key: "top",
            get: function get() {
              return this._top;
            }
            /**
             * Row bottom coordinate
             * @property {Number}
             * @readonly
             */

          }, {
            key: "bottom",
            get: function get() {
              return this._top + this._height + this.grid._rowBorderHeight;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                cls: 'b-grid-row'
              };
            }
          }]);

          return Row;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Common_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]));

        Row._$name = 'Row';
        /***/
      },

      /***/
      "../Grid/lib/Grid/row/RowManager.js":
      /*!******************************************!*\
        !*** ../Grid/lib/Grid/row/RowManager.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridRowRowManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RowManager;
        });
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "../Grid/node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Row_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./Row.js */
        "../Grid/lib/Grid/row/Row.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler'; //TODO: Handle vertical resize, add/remove row elements?

        /**
         * @module Grid/row/RowManager
         * @private
         */

        /**
         * Virtual representation of the grid, using {@link Grid.row.Row} to represent rows. Plugs into {@link Grid.view.Grid}
         * and exposes the following functions on grid itself:
         * * {@link #function-getRecordCoords()}
         * * {@link #function-getRowById()}
         * * {@link #function-getRow()}
         * * {@link #function-getRowFor()}
         * * {@link #function-getRowFromElement()}
         *
         * @example
         * let row = grid.getRowById(1);
         * @private
         */

        var RowManager =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(RowManager, _InstancePlugin);

          function RowManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, RowManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RowManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(RowManager, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(config) {
              config.grid._rowManager = this;
              this.scrollTargetRecordId = null;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(RowManager.prototype), "construct", this).call(this, config.grid, config);
            }
            /**
             * Initializes the RowManager with Rows to fit specified height.
             * @param {Number} height
             * @private
             * @category Init
             */

          }, {
            key: "initWithHeight",
            value: function initWithHeight(height) {
              var isRendering = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this; // no valid height, make room for all rows

              if (me.autoHeight) {
                height = me.store.allCount * me.rowOffsetHeight;
              }

              me.viewHeight = height;
              me.calculateRowCount(isRendering);
              return height;
            }
            /**
             * Releases all elements (not from dom), calculates how many are needed, creates those and renders
             */

          }, {
            key: "reinitialize",
            value: function reinitialize() {
              var returnToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  top = me.topRow ? me.topRow.top : 0;
              me._rows.length = 1;
              me.scrollTargetRecordId = null;

              if (returnToTop) {
                me.topIndex = 0;
                me.lastScrollTop = 0;
              } // any elements currently used for rows should be released.
              // actual removal of elements is done in SubGrid#clearRows


              me.releaseElements(); // Calculate and correct the amount of rows needed (without triggering render)

              me.calculateRowCount(false, true, true);

              if (!returnToTop && me.topRow) {
                // since all rows were removed and new ones added, we need to restore dataIndex and position for rendering
                // to happen at correct pos
                me.topRow.dataIndex = me.topIndex;
                me.topRow.setTop(top);
              } // Need to estimate height in case we have Grid using autoHeight


              me.estimateTotalHeight();
              me.renderFromRow(me.topRow);
            } //endregion
            //region Rows

            /**
             * Add or remove rows to fit row count
             * @private
             * @category Rows
             */

          }, {
            key: "matchRowCount",
            value: function matchRowCount() {
              var skipRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  rows = me._rows,
                  numRows = rows.length,
                  delta = numRows - me.rowCount,
                  grid = me.grid;

              if (delta) {
                if (delta < 0) {
                  var newRows = []; // add rows

                  for (var index = numRows, dataIndex = numRows ? rows[numRows - 1].dataIndex + 1 : 0; index < me.rowCount; index++, dataIndex++) {
                    newRows.push(new _Row_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
                      rowManager: me,
                      grid: grid,
                      index: index,
                      dataIndex: dataIndex
                    }));
                  }

                  rows.push.apply(rows, newRows); // and elements (by triggering event used by SubGrid to add elements)

                  me.trigger('addRows', {
                    rows: newRows
                  });

                  if (!skipRender) {
                    // render
                    me.renderFromRow(rows[Math.max(0, numRows - 1)]);
                  }
                } else {
                  // remove rows from bottom
                  var removedRows = rows.splice(numRows - delta, delta); // and linked elements

                  removedRows.forEach(function (row) {
                    return row.eachElement(function (element) {
                      return element.remove();
                    });
                  }); // trigger event in case some feature needs to cleanup when removing (widget column might be interested)

                  me.trigger('removeRows', {
                    rows: removedRows
                  }); // no need to rerender or such when removing from bottom. all is good :)
                }
              }
            }
            /**
             * Calculates how many rows fit in the available height (view height)
             * @private
             * @category Rows
             */

          }, {
            key: "calculateRowCount",
            value: function calculateRowCount() {
              var skipMatchRowCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var allowRowCountShrink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var skipRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // TODO: replace prependRowBuffer, appendXX with bufferSize

              var me = this,
                  store = me.store,
                  visibleRowCount = Math.ceil(me.viewHeight / me.rowOffsetHeight),
                  // Want whole rows
              maxRenderRowCount = visibleRowCount + me.prependRowBuffer + me.appendRowBuffer;

              if (!me.grid.columns.count) {
                me.rowCount = 0;
                return 0;
              } // when for example jumping we do not want to remove excess rows,
              // since we know they are needed at other scroll locations


              if (maxRenderRowCount < me.rowCount && !allowRowCountShrink) return me.rowCount;
              me.visibleRowCount = visibleRowCount;
              me.rowCount = Math.min(store.count, maxRenderRowCount); // No need for more rows than data

              if (me.rowScrollMode === 'all') {
                me.rowCount = store.allCount;
              } // If the row count doesn't match the calculated, ensure it matches,


              if (!skipMatchRowCount) {
                if (me._rows && me.rowCount !== me._rows.length) {
                  me.matchRowCount(skipRender);
                } else if (!me.rowCount) {
                  me.trigger('changeTotalHeight', {
                    totalHeight: me.totalHeight
                  });
                }

                me.grid.bodyContainer.classList[me.rowCount || store.isLoading ? 'remove' : 'add']('b-grid-empty');
              }

              return me.rowCount;
            }
          }, {
            key: "releaseElements",
            value: function releaseElements() {
              this.forEach(function (row) {
                return row.removeElements(true);
              });
              this._rows.length = 0;
              this.idMap = {};
            } //endregion
            //region Rows - Getters

          }, {
            key: "getRow",

            /**
             * Get the Row at specified index. Returns `undefined` if the row index is not rendered.
             * @param {Number} index
             * @returns {Grid.row.Row}
             * @category Rows
             */
            value: function getRow(index) {
              return this.rowCount && this.rows[index - this.topIndex];
            }
            /**
             * Get Row for specified record id
             * @param {Common.data.Model|String|Number} recordOrId Record id (or a record)
             * @returns {Grid.row.Row} Found Row or null if record not rendered
             * @category Rows
             */

          }, {
            key: "getRowById",
            value: function getRowById(recordOrId) {
              if (!(typeof recordOrId === 'string' || typeof recordOrId === 'number')) {
                recordOrId = recordOrId.id;
              } // Don't use ===, want to match 1 == '1' since id is stored on rowElement in dataset (html attribute, always string)


              return this.idMap[recordOrId]; // || this.rows.find(row => row.id == recordOrId);
            }
            /**
             * Get a Row from an HTMLElement
             * @param {HTMLElement} element
             * @returns {Grid.row.Row} Found Row or null if record not rendered
             * @category Rows
             */

          }, {
            key: "getRowFromElement",
            value: function getRowFromElement(element) {
              element = element.closest('.b-grid-row');
              return element && this.getRow(element.dataset.index);
            }
            /**
             * Get the row at the specified Y coordinate, which is by default viewport-based.
             * @param {Number} y The `Y` coordinate to find the Row for.
             * @param {Boolean} [local=false] Pass `true` if the `Y` coordinate is local to the SubGrid's element.
             * @returns {Grid.row.Row} Found Row or null if no row is rendered at that point.
             */

          }, {
            key: "getRowAt",
            value: function getRowAt(y) {
              var local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // Make it local.

              if (!local) {
                y -= _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(this.grid.bodyContainer, null, true).top; // Adjust for scrolling

                y += this.grid.scrollable.y;
              }

              y = Object(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["roundPx"])(y);
              return this.rows.find(function (r) {
                return y >= r.top && y < r.bottom;
              });
            }
            /**
             * Get a Row for either a record, a record id or an HTMLElement
             * @param {HTMLElement|Common.data.Model|String|Number} recordOrId Record or record id or HTMLElement
             * @returns {Grid.row.Row} Found Row or null if record not rendered
             * @category Rows
             */

          }, {
            key: "getRowFor",
            value: function getRowFor(recordOrId) {
              if (recordOrId instanceof HTMLElement) return this.getRowFromElement(recordOrId);
              return this.getRowById(recordOrId);
            }
            /**
             * Gets the Row following the specified Row (by index or object). Wraps around the end.
             * @param {Number|Grid.row.Row} indexOrRow index or Row
             * @returns {Grid.row.Row}
             * @category Rows
             */

          }, {
            key: "getNextRow",
            value: function getNextRow(indexOrRow) {
              var me = this,
                  index = typeof indexOrRow === 'number' ? indexOrRow : indexOrRow.index;
              return me.getRow((index + 1) % me.rowCount);
            }
            /**
             * Get the Row that is currently displayed at top.
             * @property {Grid.row.Row}
             * @readonly
             * @category Rows
             */

          }, {
            key: "offsetRows",

            /**
             * Calls offset() for each Row passing along offset parameter
             * @param {Number} offset Pixels to translate Row elements.
             * @private
             * @category Rows
             */
            value: function offsetRows(offset) {
              if (offset !== 0) {
                var rows = this.rows,
                    length = rows.length;

                for (var i = 0; i < length; i++) {
                  rows[i].offset(offset);
                }
              }
            } //endregion
            //region Row height
            // TODO: should support setting rowHeight in em and then convert internally to pixels. 1em = font-size. Not needed for 1.0

            /**
             * Set a fixed row height (can still be overridden by renderers) or get configured row height. Setting refreshes all rows
             * @category Rows
             */

          }, {
            key: "getRecordCoords",
            //endregion
            //region Calculations

            /**
             * Returns top and bottom for rendered row or estimated coordinates for unrendered.
             * @param {Common.data.Model|string|Number} recordOrId Record or record id
             * @param {Boolean} [local] Pass true to get relative record coordinates
             * @returns {Common.helper.util.Rectangle} Record bounds with format { x, y, width, height, bottom, right }
             * @category Calculations
             */
            value: function getRecordCoords(recordOrId) {
              var local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  //id  = ['string', 'number'].includes(typeof recordOrId) ? recordOrId : recordOrId.id,
              id = typeof recordOrId === 'string' || typeof recordOrId === 'number' ? recordOrId : recordOrId.id,
                  row = me.getRowById(recordOrId);
              var scrollingViewport = me.client._bodyRectangle; // _bodyRectangle is not updated on page/containing element scroll etc. Need to make sure it is correct in case
              // that has happend. This if-statement should be removed when fixing
              // https://app.assembla.com/spaces/bryntum/tickets/6587-cached-_bodyrectangle-should-be-updated-on--quot-external-quot--scroll/details

              if (!local) {
                scrollingViewport = me.client._bodyRectangle = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].client(me.client.bodyContainer);
              } // Rendered? Then we know position for certain


              if (row) {
                return new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"](scrollingViewport.x, local ? Math.round(row.top) : Math.round(row.top + scrollingViewport.y - me.client.scrollable.y), scrollingViewport.width, row.offsetHeight);
              }

              return me.getRecordCoordsByIndex(me.store.indexOf(id), local);
            }
            /**
             * Returns estimated top and bottom coordinates for specified row.
             * @param {Number} recordIndex Record index
             * @returns {Common.helper.util.Rectangle} Estimated record bounds with format { x, y, width, height, bottom, right }
             * @category Calculations
             */

          }, {
            key: "getRecordCoordsByIndex",
            value: function getRecordCoordsByIndex(recordIndex) {
              var local = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  scrollingViewport = me.client._bodyRectangle,
                  // Not using rowOffsetHeight since it floors the value and that rounding might give big errors far down
              height = me.averageRowHeight || me._rowHeight + me.grid._rowBorderHeight,
                  currentTopIndex = me.topRow.dataIndex,
                  currentBottomIndex = me.bottomRow.dataIndex,
                  // Instead of estimating top from the very top, use closest known coordinate. Makes sure a coordinate is not
              // estimated on wrong side of rendered rows, needed to correctly draw dependencies where one event is located
              // on a unrendered row
              calculateFrom = // bottomRow is closest, calculate from it
              recordIndex > currentBottomIndex ? {
                index: recordIndex - currentBottomIndex - 1,
                y: me.bottomRow.bottom,
                from: 'bottomRow' //  closer to topRow than 0, use topRow

              } : recordIndex > currentTopIndex / 2 ? {
                index: recordIndex - currentTopIndex,
                y: me.topRow.top,
                from: 'topRow' // closer to the very top, use it

              } : {
                index: recordIndex,
                y: 0,
                from: 'top'
              },
                  top = Math.floor(calculateFrom.y + calculateFrom.index * height),
                  //top               = Math.floor(recordIndex * height),
              result = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"](scrollingViewport.x, local ? top : top + scrollingViewport.y - me.client.scrollable.y, scrollingViewport.width, height); // Signal that it's not based on an element, so is only approximate.
              // Grid.scrollRowIntoView will have to go round again using the block options below to ensure it's correct.

              result.virtual = true; // When the block becomes visible, scroll it to the logical position using the scrollIntoView's block
              // option. If it's above, use block: 'start', if below, use block: 'end'.

              result.block = result.bottom < scrollingViewport.y ? 'start' : result.y > scrollingViewport.bottom ? 'end' : 'nearest';
              return result;
            }
            /**
             * Total estimated grid height (used for scroller)
             * @property {Number}
             * @readonly
             * @category Calculations
             */

          }, {
            key: "forEach",
            //endregion
            //region Iteration etc.

            /**
             * Calls a function for each Row
             * @param {Function} fn Function that will be called with Row as first parameter
             * @category Iteration
             */
            value: function forEach(fn) {
              this.rows.forEach(fn);
            }
            /**
             * Iterator that allows you to do for (let row of rowManager)
             * @category Iteration
             */

          }, {
            key: Symbol.iterator,
            value: function value() {
              return this.rows[Symbol.iterator]();
            } //endregion
            //region Scrolling & rendering

            /**
             * Renders from the top of the grid, also resetting scroll to top. Used for example when collapsing all groups.
             * @category Scrolling & rendering
             */

          }, {
            key: "returnToTop",
            value: function returnToTop() {
              var me = this;
              me.topIndex = 0;
              me.lastScrollTop = 0;
              me.topRow.dataIndex = 0; // Force the top row to the top of the scroll range

              me.topRow.setTop(0);
              me.refresh(); // Rows rendered from top, make sure grid is scrolled to top also

              me.grid.scrollable.y = 0;
            }
            /**
             * Renders from specified records row and down (used for example when collapsing a group, does not affect rows above).
             * @param {Common.data.Model} record Record of first row to render
             * @category Scrolling & rendering
             */

          }, {
            key: "renderFromRecord",
            value: function renderFromRecord(record) {
              var row = this.getRowById(record.id);

              if (row) {
                this.renderFromRow(row);
              }
            }
            /**
             * Renders from specified row and down (used for example when collapsing a group, does not affect rows above).
             * @param {Grid.row.Row} fromRow First row to render
             * @category Scrolling & rendering
             */

          }, {
            key: "renderFromRow",
            value: function renderFromRow() {
              var fromRow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              var me = this,
                  _rows = me._rows,
                  store = me.store,
                  storeCount = store.count; // Calculate row count, adding rows if needed, but do not rerender - we are going to do that below.
              // Bail out if no rows. Allow removing rows if we have more than store have rows

              if (me.calculateRowCount(false, storeCount < _rows.length, true) === 0) {
                return;
              }

              var // render from this row
              fromRowIndex = fromRow ? _rows.indexOf(fromRow) : 0,
                  // starting either from its specified dataIndex or from its index (happens on first render, no dataIndex yet)
              dataIndex = fromRow ? fromRow.dataIndex : _rows[0].dataIndex,
                  // amount of records after this one in store
              recordsAfter = storeCount - dataIndex - 1,
                  // render to this row, either the last row or the row which will hold the last record available
              toRowIndex = Math.min(_rows.length - 1, fromRowIndex + recordsAfter),
                  // amount of rows which wont be rendered below last record (if we have fewer records than topRow + row count)
              leftOverCount = _rows.length - toRowIndex - 1,
                  // Start with top correctly just below the previous row's bottom
              top = fromRowIndex > 0 ? _rows[fromRowIndex - 1].bottom : _rows[fromRowIndex].top,
                  row; // _rows array is ordered in display order, just iterate to the end

              for (var i = fromRowIndex; i <= toRowIndex; i++) {
                row = _rows[i]; // Needed in scheduler when translating events, happens before render

                row.dataIndex = dataIndex;
                row.setTop(top);
                row.render(dataIndex, store.getAt(dataIndex++), false);
                top += row.offsetHeight;
              } // if number for records to display has decreased, for example by collapsing a node, we might get unused rows
              // below bottom. move those to top to not have unused rows laying around


              while (leftOverCount-- > 0) {
                me.displayRecordAtTop();
              }

              if (me.averageRowHeight) {
                // Adjust average, subtracting the rendered block's estimated height and then adding the actual height
                me.averageRowHeight = (me.averageRowHeight * (storeCount - me.rowCount) + (top - me.topRow.top)) / storeCount;
              } else {
                me.averageRowHeight = (top - me.topRow.top) / me.rowCount;
              } // Reestimate total height


              me.estimateTotalHeight();
            }
            /**
             * Renders the passed array (or [Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Set)) of {@link Grid.row.Row rows}
             * @param {Grid.row.Row[]|Set} rows The rows to render
             * @category Scrolling & rendering
             */

          }, {
            key: "renderRows",
            value: function renderRows(rows) {
              var oldHeight,
                  heightChanged = false;
              rows = Array.from(rows); // Render the requested rows.

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var row = _step.value;
                  oldHeight = row.height; // Pass updatingSingleRow as false, so that it does not shuffle following
                  // rows downwards on each render. We do that once here after the rows are all refreshed.

                  row.render(null, null, false);
                  heightChanged |= row.height !== oldHeight;
                } // If this caused a height change, shuffle following rows.

              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              if (heightChanged) {
                this.translateFromRow(rows[0], true); // Reestimate total height

                this.estimateTotalHeight();
              }
            }
            /**
             * Translates all rows after the specified row. Used when a single rows height is changed and the others should
             * rearrange. (Called from Row#render)
             * @param {Grid.row.Row} fromRow
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "translateFromRow",
            value: function translateFromRow(fromRow) {
              var batch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  top = fromRow.bottom,
                  storeCount = me.store.count,
                  row,
                  index;

              for (index = fromRow.dataIndex + 1, row = me.getRow(index); row; row = me.getRow(++index)) {
                row.setTop(top);
                top += row.offsetHeight;
              } // Adjust average, subtracting the rendered block's estimated height and then adding the actual height


              me.averageRowHeight = (me.averageRowHeight * (storeCount - me.rowCount) + (me.bottomRow.bottom - me.topRow.top)) / storeCount; // Reestimate total height

              if (!batch) {
                me.estimateTotalHeight();
              }
            }
            /**
             * Rerender all rows
             * @category Scrolling & rendering
             */

          }, {
            key: "refresh",
            value: function refresh() {
              var me = this,
                  topRow = me.topRow; // too early

              if (!topRow) {
                return;
              }

              me.idMap = {};
              me.renderFromRow(topRow);
              me.trigger('refresh');
            }
            /**
             * Makes sure that specified record is displayed in view
             * @param newScrollTop Top of visible section
             * @param [forceRecordIndex] Index of record to display at center
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "jumpToPosition",
            value: function jumpToPosition(newScrollTop, forceRecordIndex) {
              // There are two very different requirements here.
              // If there is a forceRecordIndex, that takes precedence to get it into the center of the
              // viewport, and wherever we render the calculated row block, we may then *adjust the scrollTop*
              // to get that row to the center.
              //
              // If there's no forceRecordIndex, then the scroll position is the primary objective and
              // we must render what we calculate to be correct at that viewport position.
              var me = this,
                  rowHeight = me.rowOffsetHeight,
                  storeCount = me.store.count,
                  // Calculate index of the top of the rendered block.
              // If we are targeting the scrollTop, this will be the top index at the scrollTop minus prepend count.
              // If we are targeting a recordIndex, this will attempt to place that in the center of the rendered block.
              targetIndex = forceRecordIndex == null ? Math.floor(newScrollTop / rowHeight) - me.prependRowBuffer : forceRecordIndex - Math.floor(me.rowCount / 2),
                  startIndex = Math.max(Math.min(targetIndex, storeCount - me.rowCount), 0),
                  viewportTop = me.client.scrollable.y,
                  viewportBottom = Math.min(me.client._bodyRectangle.height + viewportTop + me.appendBufferHeight, me.totalHeight);
              me.lastScrollTop = newScrollTop;
              me.topRow.dataIndex = me.topIndex = startIndex;
              me.topRow.setTop(startIndex * rowHeight, false); // render entire buffer

              me.refresh(); // TODO: It is likely the approach below will be needed for scrolling in opposite direction also, although no
              //   problem encountered yet
              // Not filled all the way down?

              if (me.bottomRow.bottom < viewportBottom) {
                // Fill with available rows (might be available above buffer because of var row height), stop if we run out of records :)
                while (me.bottomRow.bottom < viewportBottom && me._rows[me.prependRowBuffer].top < viewportTop && me.bottomRow.dataIndex < storeCount - 1) {
                  me.displayRecordAtBottom();
                } // Average row height in rendered block


                var blockHeight = me.bottomRow.bottom - me.topRow.top; // Adjust average, subtracting the rendered block's estimated height and then adding the actual height

                me.averageRowHeight = (me.averageRowHeight * (storeCount - me.rowCount) + blockHeight) / storeCount; // TODO: Block below was not needed for current tests, but if row height in one block is enough smaller
                //  than average row height then we will need to add more rows
                // Still not filled all the way down? Need more rows
                // if (me.bottomRow.bottom < viewportBottom) {
                //     //const localAverage = blockHeight / me.rowCount;
                //     while (me.bottomRow.bottom < viewportBottom) {
                //        me.addRecordAtBottom();
                //     }
                // }
              }

              me.estimateTotalHeight(); // If the row index is our priority, then scroll it into the center

              if (forceRecordIndex != null) {
                var targetRow = me.getRow(forceRecordIndex),
                    // When coming from a block of high rowHeights to one with much lower we might still miss the target...
                // TODO: Jump again in these cases?
                rowCenter = targetRow && _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(targetRow._elementsArray[0]).center.y,
                    viewportCenter = me.grid.scrollable.viewport.center.y; // Scroll the targetRow into the center of the viewport


                if (targetRow) {
                  me.grid.scrollable.y = newScrollTop = Math.floor(me.grid.scrollable.y + (rowCenter - viewportCenter));
                }
              }

              return newScrollTop;
            }
            /**
             * Jumps to a position if it is far enough from current position. Otherwise does nothing.
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "warpIfNeeded",
            value: function warpIfNeeded(newScrollTop) {
              var me = this,
                  result = {
                newScrollTop: newScrollTop,
                deltaTop: newScrollTop - me.lastScrollTop
              }; // if gap to fill is large enough, better to jump there than to fill row by row

              if (Math.abs(result.deltaTop) > me.rowCount * me.rowOffsetHeight * 3) {
                // no specific record targeted
                var index; // Specific record specified as target of scroll?

                if (me.scrollTargetRecordId) {
                  index = me.store.indexOf(me.scrollTargetRecordId); // since scroll is happening async record might have been removed after requesting scroll,
                  // in that case we rely on calculated index (as when scrolling without target)
                } // perform the jump and return results


                result.newScrollTop = me.jumpToPosition(newScrollTop, index);
                result.deltaTop = 0; // no extra filling needed
              }

              return result;
            }
            /**
             * Handles virtual rendering (only visible rows + buffer are in dom) for rows
             * @param {Number} newScrollTop The `Y` scroll position for which to render rows.
             * @param {Boolean} [force=false] Pass `true` to update the rendered row block even if the scroll position has not changed.
             * @return {Number} Adjusted height required to fit rows
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "updateRenderedRows",
            value: function updateRenderedRows(newScrollTop, force, ignoreError) {
              var me = this,
                  clientRect = me.client._bodyRectangle; // Changing row height will trigger a scroll, ignore it here

              if (me.ignoreScroll) {
                me.ignoreScroll = false;
                return null;
              } // Might be triggered after removing all records, should not crash


              if (me.rowCount === 0) {
                return 0;
              }

              var result = me.estimatedTotalHeight; // Only react if we have scrolled by more than one row

              if (force || Math.abs(newScrollTop - me.lastScrollTop) > me.rowOffsetHeight) {
                // If scrolled by a large amount, jump instead of rendering each row
                var posInfo = me.warpIfNeeded(newScrollTop);
                me.scrollTargetRecordId = null; // Cache the last correct render scrollTop before fill.
                // it can be adjusted to hide row position corrections.

                me.lastScrollTop = posInfo.newScrollTop;

                if (posInfo.deltaTop > 0) {
                  // Scrolling down
                  me.fillBelow(posInfo.newScrollTop);
                } else if (posInfo.deltaTop < 0) {
                  // Scrolling up
                  me.fillAbove(posInfo.newScrollTop);
                } // Calculate the new height based on new content


                result = me.estimateTotalHeight(); // If it's a temporary scroll, we can be told to ignore the drift.
                // Apart from that, we must correct keep the rendered block position correct.
                // Otherwise, when rolling upwards after a teleport, we may not be able to reach
                // the top. Some rows may end up at -ve positions.

                if (!ignoreError) {
                  // Only correct the rendered block position if we are in danger of running out of scroll space.
                  // That is if we are getting towards the top or bottom of the scroll range.
                  if ( // Scrolling up within top zone
                  posInfo.deltaTop < 0 && newScrollTop < clientRect.height * 2 || // Scrolling down within bottom zone
                  posInfo.deltaTop > 0 && newScrollTop > me.estimatedTotalHeight - clientRect.height * 2 - 3) {
                    // Correct the rendered block position if it's not at the calculated position.
                    // Keep the visual position correct by adjusting the scrollTop by the same amount.
                    // When variable row heights are used, this will keep the rendered block top correct.
                    // TODO: Calc could be eased more, using distance left to have less effect the further away from top/bottom
                    var error = me.topRow.top - me.topIndex * me.rowOffsetHeight;

                    if (error) {
                      me.offsetRows(-error);
                      me.grid.scrollable.y = me.lastScrollTop = me.grid.scrollable.y - error;
                    }
                  }
                }
              }

              return result;
            }
            /**
             * Moves as many rows from the bottom to the top that are needed to fill to current scroll pos.
             * @param newTop Scroll position
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "fillAbove",
            value: function fillAbove(newTop) {
              var me = this,
                  fillHeight = newTop - me.topRow.top - me.prependBufferHeight;
              var accumulatedHeight = 0;

              while (accumulatedHeight > fillHeight && me.topIndex > 0) {
                // We want to show prev record at top of rows
                accumulatedHeight -= me.displayRecordAtTop();
              }
            }
            /**
             * Moves as many rows from the top to the bottom that are needed to fill to current scroll pos.
             * @param newTop Scroll position
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "fillBelow",
            value: function fillBelow(newTop) {
              var me = this,
                  fillHeight = newTop - me.topRow.top - me.prependBufferHeight,
                  recordCount = me.store.count,
                  rowCount = me.rowCount;
              var accumulatedHeight = 0; // Repeat until we have filled empty height

              while (accumulatedHeight < fillHeight && // fill empty height
              me.topIndex + rowCount < recordCount && // as long as we have records left
              me.topRow.top + me.topRow.offsetHeight < newTop // and do not run move top row fully into view (can happen with var row height)
              ) {
                // We want to show next record at bottom of rows
                accumulatedHeight += me.displayRecordAtBottom();
              }
            }
            /**
             * Estimates height needed to fit all rows, based on average row height. Also offsets rows if needed to not be above
             * the reachable area of the view.
             * @returns {Number}
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "estimateTotalHeight",
            value: function estimateTotalHeight() {
              var me = this,
                  recordCount = me.store.count,
                  estimate = Math.floor(recordCount * (me.averageRowHeight || me.rowOffsetHeight)),
                  bottomRow = me.bottomRow; // No bottomRow yet if estimating initial height in autoHeight grid

              if (bottomRow) {
                var bottom = bottomRow.bottom; //top                   = topRow.top;
                // To low estimate or reached the end with scroll left, adjust to fit current bottom

                if (bottom > estimate || me.topIndex + me.rowCount >= recordCount && estimate > bottom) {
                  estimate = bottom; // estimate all the way down

                  if (bottomRow.dataIndex < recordCount - 1) {
                    estimate += (recordCount - 1 - bottomRow.dataIndex) * me.rowOffsetHeight;
                  }
                }
              } // TODO: Remove these lines if tests are green, error correction should handle this
              // We have reached the very first row but are not at top, compensate.
              // Keep the visuals correct by scrolling down by the same amount.
              // if (topRow.isFirst && top !== 0) {
              //     debugger;
              //     me.offsetRows(-top);
              //     me.grid.scrollable.y = me.lastScrollTop = me.grid.scrollable.y - top;
              // }


              if (estimate != me.estimatedTotalHeight) {
                me.trigger('changeTotalHeight', {
                  totalHeight: estimate
                });
              }

              me.estimatedTotalHeight = estimate;
              return estimate;
            }
            /**
             * Moves a row from bottom to top and renders the corresponding record to it.
             * @returns {Number} New row height
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "displayRecordAtTop",
            value: function displayRecordAtTop() {
              var me = this,
                  recordIndex = me.topIndex - 1,
                  record = me.store.getAt(recordIndex),
                  recordCount = me.store.count,
                  // Row currently rendered at the bottom, the row we want to move
              bottomRow = me.bottomRow,
                  bottomRowTop = bottomRow.top;
              me.trigger('beforeTranslateRow', {
                row: bottomRow,
                newRecord: record
              }); // estimated top, for rendering that depends on having top

              bottomRow._top = me.topRow.top - me.rowOffsetHeight;
              bottomRow.estimatedTop = true; // Render row

              bottomRow.render(recordIndex, record, false); // Move it to top. Restore top so that the setter won't reject non-change
              // if the estimate happened to be correct.

              bottomRow._top = bottomRowTop;
              bottomRow.setBottom(me.topRow.top);
              bottomRow.estimatedTop = false; // Prev row is now at top

              me.topIndex--; // move to start of array (bottomRow becomes topRow)

              me._rows.unshift(me._rows.pop());

              me.averageRowHeight = (me.averageRowHeight * (recordCount - 1) + bottomRow.offsetHeight) / recordCount;
              return bottomRow.offsetHeight;
            }
            /**
             * Moves a row from top to bottom and renders the corresponding record to it.
             * @returns {Number} New row height
             * @private
             * @category Scrolling & rendering
             */

          }, {
            key: "displayRecordAtBottom",
            value: function displayRecordAtBottom() {
              var me = this,
                  //scrollMode  = me.rowScrollMode,
              recordIndex = me.topIndex + me.rowCount,
                  record = me.store.getAt(recordIndex),
                  recordCount = me.store.count,
                  // Row currently rendered on the top, the row we want to move
              topRow = me.topRow; // if (scrollMode === 'dom') {
              //     // only for performance evaluation, not to be used
              //
              //     // remove divs
              //     topRow.removeElements();
              //
              //     // add new divs
              //     me.grid.regions.forEach(region => {
              //         let div = me.grid.getSubGrid(region).addNewRowElement();
              //         topRow.addElement(region, div);
              //     });
              // }

              me.trigger('beforeTranslateRow', {
                row: topRow,
                newRecord: record
              });
              topRow.dataIndex = recordIndex; // Move it to bottom

              topRow.setTop(me.bottomRow.bottom); // Render row

              topRow.render(recordIndex, record, false); // Next row is now at top

              me.topIndex++; // move to end of array (topRow becomes bottomRow)

              me._rows.push(me._rows.shift());

              me.averageRowHeight = (me.averageRowHeight * (recordCount - 1) + topRow.offsetHeight) / recordCount;
              return topRow.offsetHeight;
            } //endregion

          }, {
            key: "store",
            get: function get() {
              return this.client.store;
            }
            /**
             * Get all Rows
             * @property {Grid.row.Row[]}
             * @readonly
             * @category Rows
             */

          }, {
            key: "rows",
            get: function get() {
              return this._rows;
            }
          }, {
            key: "topRow",
            get: function get() {
              return this._rows[0];
            }
            /**
             * Get the Row currently displayed furthest down.
             * @property {Grid.row.Row}
             * @readonly
             * @category Rows
             */

          }, {
            key: "bottomRow",
            get: function get() {
              var me = this,
                  // TODO: remove when ticket on making sure rowCount is always up to date is fixed
              rowCount = Math.min(me.rowCount, me.store.count);
              return me.rows[rowCount - 1];
            }
          }, {
            key: "rowHeight",
            get: function get() {
              return this._rowHeight;
            },
            set: function set(height) {
              var me = this,
                  grid = me.grid,
                  oldRowHeight = me._rowHeight;

              _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].assertNumber(height, 'rowHeight');

              me.trigger('beforeRowHeight', {
                height: height
              });
              me._rowHeight = height;
              me.prependBufferHeight = me.prependRowBuffer * me.rowOffsetHeight;
              me.appendBufferHeight = me.appendRowBuffer * me.rowOffsetHeight;

              if (me.rows.length) {
                var average = me.averageRowHeight;
                var oldAverage = average; // Estimate a new averageRowHeight

                average -= grid._rowBorderHeight;
                average *= height / oldRowHeight;
                me.averageRowHeight = average += grid._rowBorderHeight; // Adjust number of rows, since it is only allowed to shrink in refresh()

                me.calculateRowCount(false, true, true); // Reposition the top row since it is used to position the rest

                me.topRow.setTop(me.topRow.dataIndex * average);
                me.refresh();
                var oldY = grid.scrollable.y,
                    newY = oldY * (average / oldAverage); // Apply average diff to grid scroll to keep rows in view, but ignore the updating of rows triggered
                // by the scroll, since they are correctly updated by the refresh above.
                // Only set the ignore flag if there will be a scroll event to clear it.

                if (newY !== oldY) {
                  me.ignoreScroll = true;
                  grid.scrollable.y = newY;
                }
              }

              me.trigger('rowHeight', {
                height: height
              });
            }
            /**
             * Get actually used row height, which includes any border and might be an average if using variable row height.
             * @property {Number}
             */

          }, {
            key: "rowOffsetHeight",
            get: function get() {
              return Math.floor(this.averageRowHeight) || this._rowHeight + this.grid._rowBorderHeight;
            }
          }, {
            key: "totalHeight",
            get: function get() {
              return Math.floor(this.store.count * this.rowOffsetHeight);
            }
          }], [{
            key: "pluginConfig",
            //region Config
            // Plugin configuration.
            get: function get() {
              return {
                chain: ['getRowById', 'topRow', 'bottomRow', 'getRecordCoords', 'getRow', 'getRowFor', 'getRowFromElement', 'destroy'],
                assign: ['rowHeight']
              };
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Number of rows to render above current viewport
                 * @config {Number}
                 * @default
                 */
                prependRowBuffer: 5,

                /**
                 * Number of rows to render below current viewport
                 * @config {Number}
                 * @default
                 */
                appendRowBuffer: 5,

                /**
                 * Default row height, assigned from Grid at construction (either from config
                 * {@link Grid.view.Grid#config-rowHeight} or CSS). Can be set from renderers
                 * @config {Number}
                 * @default
                 */
                rowHeight: null,
                idMap: {},
                rowScrollMode: 'move',
                autoHeight: false,
                // TODO: investigate if topIndex can to built away, since topRow is always first in array and has dataIndex??
                topIndex: 0,
                lastScrollTop: 0,
                _rows: []
              };
            }
          }]);

          return RowManager;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        RowManager._$name = 'RowManager';
        /***/
      },

      /***/
      "../Grid/lib/Grid/util/GridScroller.js":
      /*!*********************************************!*\
        !*** ../Grid/lib/Grid/util/GridScroller.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridUtilGridScrollerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return GridScroller;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/util/Scroller.js */
        "../Grid/lib/Common/helper/util/Scroller.js");

        var productName = 'scheduler';
        /**
         * @module Grid/util/GridScroller
         */

        var xAxis = {
          x: 1
        };
        /**
         * A Scroller subclass which handles scrolling in a grid.
         *
         * If the grid has no parallel scrolling grids (No locked columns), then this functions
         * transparently as a Scroller.
         *
         * If there are locked columns, then scrolling to an _element_ will invoke the scroller
         * of the subgrid which contains that element.
         * @internal
         */

        var GridScroller =
        /*#__PURE__*/
        function (_Scroller) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(GridScroller, _Scroller);

          function GridScroller() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, GridScroller);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(GridScroller).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(GridScroller, [{
            key: "addScroller",
            value: function addScroller(scroller) {
              (this.xScrollers || (this.xScrollers = [])).push(scroller);
            }
          }, {
            key: "addPartner",
            value: function addPartner(otherScroller) {
              var axes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : xAxis;

              if (typeof axes === 'string') {
                axes = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, axes, 1);
              } // Link up all our X scrollers


              if (axes.x) {
                for (var i = 0; i < this.xScrollers.length; i++) {
                  this.xScrollers[i].addPartner(otherScroller.xScrollers[i], 'x');
                }
              } // We are the only Y scroller


              if (axes.y) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(GridScroller.prototype), "addPartner", this).call(this, otherScroller, 'y');
              }
            }
          }, {
            key: "updateOverflowX",
            value: function updateOverflowX(overflowX) {
              this.xScrollers && this.xScrollers.forEach(function (s) {
                return s.overflowX = overflowX;
              });
              this.widget.virtualScrollers.classList[overflowX === false ? 'add' : 'remove']('b-hide-display');
            }
          }, {
            key: "scrollIntoView",
            value: function scrollIntoView(element, options) {
              // If we are after an element, we have to ask the scroller of the SubGrid
              // that the element is in. It will do the X scrolling and delegate the Y
              // scrolling up to this GridScroller.
              if (element.nodeType === 1) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = this.xScrollers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var subGridScroller = _step.value;

                    if (subGridScroller.element.contains(element)) {
                      return subGridScroller.scrollIntoView(element, options);
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                      _iterator.return();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              } else {
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(GridScroller.prototype), "scrollIntoView", this).call(this, element, options);
              }
            }
          }, {
            key: "x",
            set: function set(x) {
              this.xScrollers[0].x = x;
            },
            get: function get() {
              return this.xScrollers[0].x;
            }
          }]);

          return GridScroller;
        }(_Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        GridScroller._$name = 'GridScroller';
        /***/
      },

      /***/
      "../Grid/lib/Grid/util/ScrollManager.js":
      /*!**********************************************!*\
        !*** ../Grid/lib/Grid/util/ScrollManager.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridUtilScrollManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ScrollManager;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/util/ScrollManager
         */

        /**
         * Allows features to scroll grid when for example dragging close to edges. Normally you should not need to interact
         * with this class.
         * @internal
         */

        var ScrollManager =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ScrollManager, _Delayable);

          function ScrollManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, ScrollManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(ScrollManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ScrollManager, [{
            key: "startMonitoring",
            //endregion
            //region Start/stop monitoring

            /**
             * Starts monitoring an element. It will be scrolled if mouse is pressed and within zoneWidth pixels from element edge.
             * @param {HTMLElement|Object} elementOrConfig Element which might be scrolled or config { element, callback, thisObj }
             */
            value: function startMonitoring(elementOrConfig) {
              var me = this,
                  config = elementOrConfig instanceof HTMLElement ? {
                element: elementOrConfig
              } : elementOrConfig,
                  element = config.element,
                  verticalElement = config.verticalElement || me.verticalElement || element; // only interested in elements that exists and are scrollable

              if (element && (element.scrollWidth > element.offsetWidth || verticalElement.scrollHeight > verticalElement.offsetHeight)) {
                // already monitoring, bail out
                if (me.monitoring.find(function (m) {
                  return m.element === element;
                })) return;
                config.direction = config.direction || me.direction; // store some stuff needed later

                Object.assign(config, {
                  verticalElement: verticalElement,
                  scrollManager: me,
                  startScrollLeft: element.scrollLeft,
                  startScrollTop: verticalElement.scrollTop,
                  scrollLeft: element.scrollLeft,
                  scrollTop: verticalElement.scrollTop,
                  scrollRelativeLeft: 0,
                  scrollRelativeTop: 0
                });
                var handler = me.onMouseMove.bind(config); // listen to mousemove to determine if scroll needed or not

                me.mouseMoveDetacher = _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                  mousemove: handler,
                  touchmove: handler,
                  element: element
                }); // Cache scrollWidth because it may actually change in Edge and allow scrolling to empty space when creating
                // dependency

                config.scrollWidth = element.scrollWidth;
                me.monitoring.push(config);
              }
            }
            /**
             * Stops monitoring an element.
             * @param {HTMLElement} element Element for which monitoring is not desired any more and should stop as soon as possible. Preferably right away, but no later than on next frame :)
             */

          }, {
            key: "stopMonitoring",
            value: function stopMonitoring(element) {
              var me = this,
                  config = me.monitoring.find(function (m) {
                return m.element === element;
              }); // cant stop nothing...

              if (!config) return;
              me.stopScroll(config);
              me.mouseMoveDetacher && me.mouseMoveDetacher();
              me.monitoring.splice(me.monitoring.indexOf(config), 1);
            } //endregion
            //region Internals

            /**
             * Starts scrolling (see #performScroll). Called from onMouseMove.
             * @private
             * @param {Object} config Config object
             */

          }, {
            key: "startScroll",
            value: function startScroll(config) {
              config.scrolling = true;
              this.performScroll(config);
            }
            /**
             * Stops scrolling. Called from onMouseMove.
             * @private
             * @param {Object} config
             */

          }, {
            key: "stopScroll",
            value: function stopScroll(config) {
              config.scrolling = false;

              if (config.scrollRequested) {
                this.cancelAnimationFrame(config.frameId);
                config.scrollRequested = false;
              }
            }
            /**
             * Scrolls by an amount determined by config.scrollDeltaX/Y on each frame. Start/stop by calling #startScroll and
             * #stopScroll.
             * @private
             * @param {Object} config Config object
             */

          }, {
            key: "performScroll",
            value: function performScroll(config) {
              var _this = this; // this function is called repeatedly on each frame for as long as scrolling is needed
              // check that scrolling is needed


              if (config.scrolling && !config.scrollRequested) {
                var element = config.element,
                    vertical = config.verticalElement; // scroll the determined amount of pixels

                if (config.scrollDeltaX !== 0) {
                  config.scrollLeft += config.scrollDeltaX; // limit to element edges

                  config.scrollLeft = Math.max(Math.min(config.scrollLeft, config.scrollWidth - element.offsetWidth), 0);
                  config.scrollRelativeLeft = config.scrollLeft - config.startScrollLeft;
                  element.scrollLeft = config.scrollLeft;
                }

                if (config.scrollDeltaY !== 0) {
                  config.scrollTop += config.scrollDeltaY; // limit to element edges

                  config.scrollTop = Math.max(Math.min(config.scrollTop, vertical.scrollHeight - vertical.offsetHeight), 0);
                  config.scrollRelativeTop = config.scrollTop - config.startScrollTop;
                  vertical.scrollTop = config.scrollTop;
                } // call callback if scrolled in any direction


                if ((config.scrollRelativeLeft !== 0 || config.scrollRelativeTop !== 0) && config.callback) {
                  config.callback.call(config.thisObj || this, config);
                } // scroll some more on next frame


                config.scrollRequested = true;
                config.frameId = this.requestAnimationFrame(function () {
                  config.scrollRequested = false;

                  _this.performScroll(config);
                });
              }
            }
            /**
             * Listener for mouse move on monitored element. Determines if scrolling is needed, and if so how fast to scroll.
             * See #zoneWidth & #scrollSpeed configs.
             * @private
             * @param {MouseEvent} event
             */

          }, {
            key: "onMouseMove",
            value: function onMouseMove(event) {
              var config = this,
                  me = config.scrollManager,
                  element = config.element,
                  vertical = config.verticalElement,
                  box = element.getBoundingClientRect(),
                  vbox = vertical.getBoundingClientRect(),
                  width = me.zoneWidth,
                  speed = me.scrollSpeed; // scroll left or right?

              config.scrollDeltaX = 0;

              if (config.direction !== 'vertical') {
                if (event.clientX > box.right - width) {
                  config.scrollDeltaX = Math.round((width - (box.right - event.clientX)) / speed) + 1;
                } else if (event.clientX < box.left + width) {
                  config.scrollDeltaX = -Math.round((width + (box.left - event.clientX)) / speed) - 1;
                }
              } //console.log(config.scrollDeltaX, event.clientX, box.right, element.scrollLeft);
              // scroll up or down?


              config.scrollDeltaY = 0;

              if (config.direction !== 'horizontal') {
                if (event.clientY > vbox.bottom - width) {
                  config.scrollDeltaY = Math.round((width - (vbox.bottom - event.clientY)) / speed) + 1;
                } else if (event.clientY < vbox.top + width) {
                  config.scrollDeltaY = -Math.round((width + (vbox.top - event.clientY)) / speed) - 1;
                }
              }

              if (config.scrollDeltaX === 0 && config.scrollDeltaY === 0) {
                me.stopScroll(config);
              } else {
                me.startScroll(config);
              }
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Default config
            get: function get() {
              return {
                /**
                 * Width in pixels of zone at element edges where scrolling can be triggered
                 * @config {Number}
                 * @default
                 */
                zoneWidth: 50,

                /**
                 * Scroll speed, higher number is slower. Calculated as "distance from zone edge / scrollSpeed"
                 * @config {Number}
                 * @default
                 */
                scrollSpeed: 5,

                /**
                 * Default element to use for vertical scrolling. Can be overridden in calls to `startMonitoring()`.
                 * @config {HTMLElement}
                 */
                verticalElement: null,

                /**
                 * The direction(s) to scroll ('horizontal', 'vertical' or 'both')
                 * @config {String}
                 */
                direction: 'both',
                monitoring: []
              };
            }
          }]);

          return ScrollManager;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_8__["default"])(_Common_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"]));

        ScrollManager._$name = 'ScrollManager';
        /***/
      },

      /***/
      "../Grid/lib/Grid/util/SubGridScroller.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Grid/util/SubGridScroller.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridUtilSubGridScrollerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return SubGridScroller;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/util/Scroller.js */
        "../Grid/lib/Common/helper/util/Scroller.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
        * @module Grid/util/SubGridScroller
        */

        var immediatePromise = new Promise(function (resolve) {
          return resolve();
        }),
            defaultScrollOptions = {
          block: 'nearest'
        };
        /**
         * A Scroller subclass which handles scrolling in a SubGrid. Needs special treatment since the SubGrid itself only
         * allows horizontal scrolling, while the vertical scrolling is done by an outer element containing all subgrids.
         *
         * @internal
         */

        var SubGridScroller =
        /*#__PURE__*/
        function (_Scroller) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(SubGridScroller, _Scroller);

          function SubGridScroller() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SubGridScroller);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(SubGridScroller).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(SubGridScroller, [{
            key: "scrollIntoView",
            value: function scrollIntoView(element) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;

              var me = this,
                  _me$getDeltaTo = me.getDeltaTo(element, options),
                  xDelta = _me$getDeltaTo.xDelta,
                  yDelta = _me$getDeltaTo.yDelta,
                  result = xDelta || yDelta ? me.scrollBy(xDelta, yDelta, options) : immediatePromise;

              if (options.highlight || options.focus) {
                result.then(function () {
                  if (options.highlight) {
                    if (element instanceof _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"]) {
                      element.translate(-xDelta, -yDelta).highlight();
                    } else {
                      _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].highlight(element);
                    }
                  }

                  options.focus && element.focus && element.focus();
                });
              }

              return result;
            }
          }, {
            key: "scrollBy",
            value: function scrollBy(xDelta, yDelta, options) {
              var yPromise = yDelta && this.yScroller.scrollBy(0, yDelta, options),
                  xPromise = xDelta && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(SubGridScroller.prototype), "scrollBy", this).call(this, xDelta, 0, options);

              if (xPromise && xPromise.cancel && yPromise && yPromise.cancel) {
                var cancelX = xPromise.cancel,
                    cancelY = yPromise.cancel; // Set up cross canceling

                xPromise.cancel = yPromise.cancel = function () {
                  cancelX();
                  cancelY();
                };

                return Promise.all([xPromise, yPromise]);
              }

              return xPromise || yPromise;
            }
          }, {
            key: "scrollTo",
            value: function scrollTo(toX, toY, options) {
              var yPromise = toY != null && this.yScroller.scrollTo(null, toY, options),
                  xPromise = toX != null && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(SubGridScroller.prototype), "scrollTo", this).call(this, toX, null, options);

              if (xPromise && xPromise.cancel && yPromise && yPromise.cancel) {
                var cancelX = xPromise.cancel,
                    cancelY = yPromise.cancel; // Set up cross canceling

                xPromise.cancel = yPromise.cancel = function () {
                  cancelX();
                  cancelY();
                };

                return Promise.all([xPromise, yPromise]);
              }

              return xPromise || yPromise;
            }
          }, {
            key: "viewport",
            get: function get() {
              return _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(this.element).intersect(_Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(this.yScroller.element));
            }
          }, {
            key: "y",
            set: function set(y) {
              this.yScroller.y = y;
            },
            get: function get() {
              return this.yScroller ? this.yScroller.y : 0;
            }
          }, {
            key: "maxY",
            get: function get() {
              return this.yScroller ? this.yScroller.maxY : 0;
            }
          }, {
            key: "scrollHeight",
            get: function get() {
              return this.yScroller ? this.yScroller.scrollHeight : 0;
            }
          }, {
            key: "clientHeight",
            get: function get() {
              return this.yScroller ? this.yScroller.clientHeight : 0;
            }
          }]);

          return SubGridScroller;
        }(_Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        SubGridScroller._$name = 'SubGridScroller';
        /***/
      },

      /***/
      "../Grid/lib/Grid/view/Bar.js":
      /*!************************************!*\
        !*** ../Grid/lib/Grid/view/Bar.js ***!
        \************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewBarJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Bar;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/view/Bar
         */

        /**
         * Base class used by Header and Footer. Holds an element for each column. Not intended to be used directly.
         *
         * @extends Common/widget/Widget
         * @internal
         * @abstract
         */

        var Bar =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Bar, _Widget);

          function Bar() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Bar);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Bar).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Bar, [{
            key: "construct",
            //region Init

            /**
             * Construct a bar for the specified SubGrid.
             * @param {Object} config Bar config
             * @function constructor
             */
            value: function construct(config) {
              var subGrid = config.subGrid;

              if (subGrid) {
                config.grid = subGrid.grid;
                config.columns = subGrid.columns;

                if (subGrid.width) {
                  config.width = subGrid.width;
                } else if (subGrid.flex) {
                  config.flex = subGrid.flex;
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Bar.prototype), "construct", this).call(this, config);
            }
          }, {
            key: "fixCellWidths",
            //endregion

            /**
             * Fix cell widths (flex or fixed width) after rendering.
             * Not a part of template any longer because of CSP
             * @private
             */
            value: function fixCellWidths() {
              var me = this;
              var hasFlex = false,
                  flexBasis; // single header "cell"

              me.columns.traverse(function (column) {
                var cellEl = me.getBarCellElement(column.id),
                    domWidth = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setLength(column.width),
                    domMinWidth = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setLength(column.minWidth);

                if (cellEl) {
                  // We have to work round the IE11 bug that flex-basis affects the content-box
                  // and any padding is added as extra.
                  // TODO: Remove  this when IE11 retires.
                  if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isIE11) {
                    flexBasis = "calc(".concat(domWidth, " - ").concat(me.getLrPadding(cellEl), "px)");
                  } else {
                    flexBasis = domWidth;
                  }

                  hasFlex = hasFlex || Boolean(column.flex); // Parent column without any specified width and flex should have flex calculated if any child has flex

                  if (column.isParent && column.width == null && column.flex == null) {
                    var flex = column.children.reduce(function (result, child) {
                      return result += !child.hidden && child.flex || 0;
                    }, 0); // Do not want to store this flex value on the column since it is always calculated

                    cellEl.style.flex = flex > 0 ? "".concat(flex, " 0 auto") : '';

                    if (flex > 0) {
                      // TODO: Figure out a better way of handling this, minWidth on the columns breaks the flexbox
                      //  calculation compared to cells, making them misalign
                      column.traverse(function (col) {
                        return col.data.minWidth = null;
                      });
                    }
                  } // Normal case, set flex, width etc.
                  else {
                      if (parseInt(column.minWidth) >= 0) {
                        cellEl.style.minWidth = domMinWidth;
                      } // Clear all the things we might have to set to correct cell widths


                      cellEl.style.flex = cellEl.style.flexBasis = cellEl.style.width = '';

                      if (column.flex) {
                        // If column has children we need to give it
                        // flex-shrink: 0, flex-basis: auto so that it always
                        // shrinkwraps its children without shrinking
                        if (!isNaN(parseInt(column.flex)) && column.children) {
                          cellEl.style.flex = "".concat(column.flex, " 0 auto");
                        } else {
                          cellEl.style.flex = column.flex;
                        }
                      } else if (parseInt(column.width) >= 0) {
                        var parent = column.parent; // Only grid header bar has a notion of group headers
                        // Column is a child of an unwidthed group. We have to use width
                        // to stretch it.

                        if (me.isHeader && !parent.isRoot && !parent.width) {
                          cellEl.style.width = domWidth;
                        } else {
                          // https://app.assembla.com/spaces/bryntum/tickets/8041
                          // Column header widths must be set using flex-basis.
                          // Using width means that wide widths cause a flexed SubGrid
                          // to bust the flex rules.
                          // TODO: When IE11 retires, remove calc() hacks to overcome its flexbox bugs.
                          // Note that grid in Grid#onColumnsResized and SubGrid#fixCellWidths,
                          // cells MUST still be sized using width since rows
                          // are absolutely positioned and will not cause the busting out
                          // problem, and rows will not stretch to shrinkwrap the cells
                          // unless they are widthed with width.
                          cellEl.style.flexBasis = flexBasis;
                        }
                      }
                    }

                  if (column.height >= 0) {
                    cellEl.style.height = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].setLength(column.height);
                  }
                }
              });
              me.element.classList[hasFlex ? 'add' : 'remove']('b-has-flex');
            }
          }, {
            key: "getLrPadding",
            value: function getLrPadding(cellEl) {
              if (!this.cellLrPadding) {
                var s = cellEl.ownerDocument.defaultView.getComputedStyle(cellEl);
                this.cellLrPadding = parseInt(s.getPropertyValue('padding-left')) + parseInt(s.getPropertyValue('padding-right')) + parseInt(s.getPropertyValue('border-left-width')) + parseInt(s.getPropertyValue('border-right-width'));
              }

              return this.cellLrPadding;
            }
            /**
             * Get the header or footer cell element for the specified column.
             * @param {String} columnId Column id
             * @returns {HTMLElement} Header or footer element, depending on which subclass is in use.
             * @private
             */

          }, {
            key: "getBarCellElement",
            value: function getBarCellElement(columnId) {
              return this.element.querySelector("[data-column-id=\"".concat(columnId, "\"]"));
            }
          }, {
            key: "columns",
            get: function get() {
              return this._columns;
            },
            set: function set(columns) {
              this._columns = columns;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                scrollable: {} // We need a scroller, but no dimensions scroll by default

              };
            }
          }]);

          return Bar;
        }(_Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        Bar._$name = 'Bar';
        /***/
      },

      /***/
      "../Grid/lib/Grid/view/Footer.js":
      /*!***************************************!*\
        !*** ../Grid/lib/Grid/view/Footer.js ***!
        \***************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewFooterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Footer;
        });
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Bar_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./Bar.js */
        "../Grid/lib/Grid/view/Bar.js");

        function _templateObject2() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n                <div \n                    class=\"b-grid-footer ", " ", "\" \n                    data-column=\"", "\" data-column-id=\"", "\" data-all-index=\"", "\"\n                    >\n                    ", "\n                </div>"]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_0___default()(["\n            <div class=\"b-grid-footer-scroller b-grid-footer-scroller-", "\">\n                <div reference=\"footersElement\" class=\"b-grid-footers b-grid-footers-", "\" data-region=\"", "\"></div>\n            </div>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler'; //import styles from '../../../resources/sass/grid/view/footer.scss';

        /**
         * @module Grid/view/Footer
         */

        /**
         * Grid footer, used by Summary feature. You should not need to create instances manually.
         *
         * @extends Grid/view/Bar
         * @internal
         */

        var Footer =
        /*#__PURE__*/
        function (_Bar) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Footer, _Bar);

          function Footer() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Footer);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Footer).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Footer, [{
            key: "startConfigure",
            value: function startConfigure(config) {
              config.scrollable.overflowX = 'hidden-scroll';

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Footer.prototype), "startConfigure", this).call(this, config);
            }
          }, {
            key: "refreshContent",
            value: function refreshContent() {
              this.element.firstElementChild.innerHTML = this.contentTemplate();
              this.fixFooterWidths();
            }
          }, {
            key: "render",
            value: function render(appendToElement) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Footer.prototype), "render", this).call(this, appendToElement);

              this.refreshContent();
            }
          }, {
            key: "template",
            value: function template() {
              var region = this.subGrid.region;
              return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].tpl(_templateObject(), region, region, region);
            }
          }, {
            key: "getFooter",
            //region Getters

            /**
             * Get the footer cell element for the specified column.
             * @param {String} columnId Column id
             * @returns {HTMLElement} Footer cell element
             */
            value: function getFooter(columnId) {
              return this.getBarCellElement(columnId);
            } //endregion

            /**
             * Footer template. Iterates leaf columns to create content.
             * Style not included because of CSP. Widths are fixed up in
             * {@link #function-fixFooterWidths}
             * @private
             */

          }, {
            key: "contentTemplate",
            value: function contentTemplate() {
              var me = this;
              return me.columns.visibleColumns.map(function (column) {
                return column.hidden ? '' : _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].tpl(_templateObject2(), column.align ? "b-grid-footer-align-".concat(column.align) : '', column.cls || '', column.field, column.id, column.allIndex, column.footerText || '');
              }).join('');
            }
            /**
             * Fix footer widths (flex or fixed width) after rendering. Not a part of template any longer because of CSP
             * @private
             */

          }, {
            key: "fixFooterWidths",
            value: function fixFooterWidths() {
              this.fixCellWidths();
            }
          }, {
            key: "subGrid",
            get: function get() {
              return this._subGrid;
            },
            set: function set(subGrid) {
              this._subGrid = this.owner = subGrid;
            }
          }, {
            key: "overflowElement",
            get: function get() {
              return this.footersElement;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                isFooter: true
              };
            }
          }]);

          return Footer;
        }(_Bar_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        Footer._$name = 'Footer';
        /***/
      },

      /***/
      "../Grid/lib/Grid/view/Grid.js":
      /*!*************************************!*\
        !*** ../Grid/lib/Grid/view/Grid.js ***!
        \*************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewGridJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Grid;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "../Grid/node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "../Grid/node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "../Grid/node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_20___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_20__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../../Common/adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../../Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ../../Common/helper/MixinHelper.js */
        "../Grid/lib/Common/helper/MixinHelper.js");
        /* harmony import */


        var _Common_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ../../Common/helper/VersionHelper.js */
        "../Grid/lib/Common/helper/VersionHelper.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
        /*! ../../Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
        /*! ../../Common/localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");
        /* harmony import */


        var _Common_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
        /*! ../../Common/mixin/Pluggable.js */
        "../Grid/lib/Common/mixin/Pluggable.js");
        /* harmony import */


        var _Common_mixin_State_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
        /*! ../../Common/mixin/State.js */
        "../Grid/lib/Common/mixin/State.js");
        /* harmony import */


        var _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
        /*! ../../Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
        /*! ../data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(
        /*! ../data/GridRowModel.js */
        "../Grid/lib/Grid/data/GridRowModel.js");
        /* harmony import */


        var _row_RowManager_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(
        /*! ../row/RowManager.js */
        "../Grid/lib/Grid/row/RowManager.js");
        /* harmony import */


        var _util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(
        /*! ../util/ScrollManager.js */
        "../Grid/lib/Grid/util/ScrollManager.js");
        /* harmony import */


        var _util_GridScroller_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(
        /*! ../util/GridScroller.js */
        "../Grid/lib/Grid/util/GridScroller.js");
        /* harmony import */


        var _Header_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(
        /*! ./Header.js */
        "../Grid/lib/Grid/view/Header.js");
        /* harmony import */


        var _Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(
        /*! ../../Common/mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(
        /*! ../../Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(
        /*! ../../Common/GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony import */


        var _mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(
        /*! ./mixin/GridElementEvents.js */
        "../Grid/lib/Grid/view/mixin/GridElementEvents.js");
        /* harmony import */


        var _mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(
        /*! ./mixin/GridFeatures.js */
        "../Grid/lib/Grid/view/mixin/GridFeatures.js");
        /* harmony import */


        var _mixin_GridNavigation_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(
        /*! ./mixin/GridNavigation.js */
        "../Grid/lib/Grid/view/mixin/GridNavigation.js");
        /* harmony import */


        var _mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(
        /*! ./mixin/GridResponsive.js */
        "../Grid/lib/Grid/view/mixin/GridResponsive.js");
        /* harmony import */


        var _mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(
        /*! ./mixin/GridSelection.js */
        "../Grid/lib/Grid/view/mixin/GridSelection.js");
        /* harmony import */


        var _mixin_GridState_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(
        /*! ./mixin/GridState.js */
        "../Grid/lib/Grid/view/mixin/GridState.js");
        /* harmony import */


        var _mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(
        /*! ./mixin/GridSubGrids.js */
        "../Grid/lib/Grid/view/mixin/GridSubGrids.js");
        /* harmony import */


        var _feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(
        /*! ../feature/CellEdit.js */
        "../Grid/lib/Grid/feature/CellEdit.js");
        /* harmony import */


        var _feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(
        /*! ../feature/ColumnDragToolbar.js */
        "../Grid/lib/Grid/feature/ColumnDragToolbar.js");
        /* harmony import */


        var _feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(
        /*! ../feature/ColumnPicker.js */
        "../Grid/lib/Grid/feature/ColumnPicker.js");
        /* harmony import */


        var _feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(
        /*! ../feature/ColumnReorder.js */
        "../Grid/lib/Grid/feature/ColumnReorder.js");
        /* harmony import */


        var _feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(
        /*! ../feature/ColumnResize.js */
        "../Grid/lib/Grid/feature/ColumnResize.js");
        /* harmony import */


        var _feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(
        /*! ../feature/ContextMenu.js */
        "../Grid/lib/Grid/feature/ContextMenu.js");
        /* harmony import */


        var _feature_Filter_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(
        /*! ../feature/Filter.js */
        "../Grid/lib/Grid/feature/Filter.js");
        /* harmony import */


        var _feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(
        /*! ../feature/FilterBar.js */
        "../Grid/lib/Grid/feature/FilterBar.js");
        /* harmony import */


        var _feature_Group_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(
        /*! ../feature/Group.js */
        "../Grid/lib/Grid/feature/Group.js");
        /* harmony import */


        var _feature_Sort_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(
        /*! ../feature/Sort.js */
        "../Grid/lib/Grid/feature/Sort.js");
        /* harmony import */


        var _feature_Stripe_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(
        /*! ../feature/Stripe.js */
        "../Grid/lib/Grid/feature/Stripe.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(
        /*! ../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _column_Column_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(
        /*! ../column/Column.js */
        "../Grid/lib/Grid/column/Column.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_9___default()(["\n            <div tabindex=\"-1\">\n                <header reference=\"headerContainer\" class=\"b-grid-header-container ", "\"></header>\n                <div reference=\"bodyContainer\" class=\"b-grid-body-container\">\n                    <div reference=\"verticalScroller\" class=\"b-grid-vertical-scroller\"></div>\n                </div>\n                <div reference=\"virtualScrollers\" class=\"b-virtual-scrollers ", "\" style=\"", "\"></div>\n                <footer reference=\"footerContainer\" class=\"b-grid-footer-container b-hidden\"></footer>\n            </div>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler'; //region Import
        // import default features (might be able to skip this when draft on dynamic import is implemented)
        //endregion

        /**
         * @module Grid/view/Grid
         */

        var resolvedPromise = new Promise(function (resolve) {
          return resolve();
        }),
            defaultScrollOptions = {
          block: 'nearest',
          inline: 'nearest'
        };
        /**
         * The Grid component is a very powerful and performant UI component that shows tabular data (or tree data using the {@link Grid.view.TreeGrid}).
         *
         * <h2>Intro</h2>
         * The Grid widget has a wide range of features and a large API to allow users to work with data efficiently in the browser. The two
         * most important configs are {@link #config-store} and {@link #config-columns}. With the store config, you decide which data to load into the grid.
         * You can work with both in-memory arrays or load data using ajax. See the {@link Common.data.Store} class to learn more about loading data into stores.
         *
         * The columns config accepts an array of {@link Grid.column.Column Column} descriptors defining which fields that will be displayed in the grid.
         * The {@link Grid.column.Column#config-field} property in the column descriptor maps to a field in your dataset. The simplest grid configured with inline data and two columns would
         * look like this:
         *
         *      let grid = new Grid({
         *          appendTo : document.body,
         *
         *          columns: [
         *              { field: 'name', text: 'Name' },
         *              { field: 'job', text: 'Job', renderer: ({value}) => value ? value : 'Unemployed' }
         *          ],
         *
         *          data: [
         *              { name: 'Bill', job: 'Retired' },
         *              { name: 'Elon', job: 'Visionary' },
         *              { name: 'Me' }
         *          ]
         *      });
         *
         * {@inlineexample grid/Grid.js}
         * <h2>Features</h2>
         * To avoid the Grid core being bloated, its main features are implemented in separate ´feature´ classes. These can be turned on and off based
         * on your requirements. To configure (or disable) a feature, use the {@link #config-features} object to provide your desired configuration for the features
         * you want to use. Each feature has an ´id´ that you use as a key in the features object:
         *
         *      let grid = new Grid({
         *          appendTo : document.body,
         *
         *          features : {
         *              cellEdit     : false,
         *              regionResize : true,
         *              cellTooltip  : {
         *                  tooltipRenderer : (data) => {
         *                  }
         *              },
         *              ...
         *          }
         *      });
         *
         * {@region Column configuration options}
         * A grid contains a number of columns that control how your data is rendered. The simplest option is to simply point a Column to a field in your dataset, or define a custom {@link Grid.column.Column#config-renderer}.
         * The renderer function receives one object parameter containing rendering data for the current cell being rendered.
         *
         *      let grid = new Grid({
         *          appendTo : document.body,
         *
         *          columns: [
         *              {
         *                  field: 'task',
         *                  text: 'Task',
         *                  renderer: (renderData) => {
         *                      const record = renderData.record;
         *
         *                      if (record.percentDone === 100) {
         *                          renderData.cellElement.classList.add('taskDone');
         *                          renderData.cellElement.style.background = 'green';
         *                      }
         *
         *                      return renderData.value;
         *                  }
         *              }
         *          ]
         *      });
         *
         * {@endregion}
         * {@region Grid sections (aka "locked" or "frozen" columns)}
         * The grid can be divided horizontally into individually scrollable sections. This is great if you have lots of columns that
         * don't fit the available width of the screen. To enable this feature, simply mark the columns you want to `lock`.
         * Locked columns are then displayed in their own section to the left of the other columns:
         *
         *      let grid = new Grid({
         *          appendTo : document.body,
         *          width    : 500,
         *          subGridConfigs : {
         *              // set a fixed locked section width if desired
         *              locked : { width: 300 }
         *          },
         *          columns : [
         *              { field : 'name', text : 'Name', width : 200, locked : true },
         *              { field : 'firstName', text : 'First name', width : 100, locked : true },
         *              { field : 'surName', text : 'Last name', width : 100, locked : true },
         *              { field : 'city', text : 'City', width : 100 },
         *              { type : 'number', field : 'age', text : 'Age', width : 200 },
         *              { field : 'food', text : 'Food', width : 200 }
         *          ]
         *      });
         *
         * {@inlineexample grid/LockedGrid.js}
         * You can also move columns between sections by using drag and drop, or use the built-in header context menu. If you want to be able to resize the
         * locked grid section, enable the {@link Grid.feature.RegionResize regionResize} feature.
         * {@endregion}
         * {@region Filtering}
         * One important requirement of a good Grid component is the ability to filter large datasets to quickly find what you're looking for. To
         * enable filtering (through the context menu), add the {@link Grid.feature.Filter filter} feature:
         *
         *      let grid = new Grid({
         *          features: {
         *              filter: true
         *          }
         *      });
         *
         * Or activate a default filter at initial rendering:
         *
         *      let grid = new Grid({
         *          features: {
         *              filter: { property : 'city', value : 'New York' }
         *          }
         *      });
         *
         * {@inlineexample feature/Filter.js}
         * {@endregion}
         * {@region Tooltips}
         * If you have a data models with many fields, and you want to show
         * additional data when hovering over a cell, use the {@link Grid.feature.CellTooltip cellTooltip} feature. To show a tooltip for all cells:
         *
         *      let grid = new Grid({
         *          features: {
         *              cellTooltip: ({value}) => value
         *          }
         *      });
         *
         * {@inlineexample feature/CellTooltip.js}
         * {@endregion}
         * {@region Inline Editing (default <strong>on</strong>)}
         * To enable inline cell editing in the grid, simply add the {@link Grid.feature.CellEdit cellEdit} feature:
         *
         *      let grid = new Grid({
         *          appendTo : document.body,
         *
         *          features : {
         *              cellEdit : true
         *          },
         *          columns: [
         *              {
         *                  field: 'task',
         *                  text: 'Task'
         *              }
         *          ]
         *      });
         *
         * {@inlineexample feature/CellEdit.js}
         * {@endregion}
         * {@region Context Menu}
         * Use the {@link Grid.feature.ContextMenu contextMenu} feature if you want your users to be able to interact with the data through the context menu:
         *
         *      let grid = new Grid({
         *          features: {
         *              contextMenu: {
         *                  headerItems: [
         *                      {
         *                          text: 'Show info',
         *                          icon: 'fa fa-info-circle',
         *                          weight: 200,
         *                          onItem : ({ item }) => console.log(item.text)
         *                      }
         *                  ],
         *
         *              cellItems: [
         *                  { text: 'Show options', icon: 'fa fa-gear', weight: 200 }
         *              ]
         *          }
         *      }
         *
         * {@inlineexample feature/ContextMenu.js}
         * {@endregion}
         * {@region Grouping}
         * To group rows by a field in your dataset, use the {@link Grid.feature.Group group} feature.
         * {@inlineexample feature/Group.js}
         * {@endregion}
         * {@region Searching}
         * When working with lots of data, a quick alternative to filtering is the {@link Grid.feature.Search search} feature. It highlights
         * matching values in the grid as you type.
         * {@inlineexample feature/Search.js}
         * {@endregion}
         * {@region Loading and saving data}
         * The grid keeps all its data in a {@link Common.data.Store}, which is essentially an Array of {@link Common.data.Model Model} items.
         * You define your own Model representing your data entities and use the Model API to get and set values.
         *
         *      class Person extends Model {}
         *
         *      let person = new Person({
         *          name: 'Steve',
         *          age: 38
         *      });
         *
         *      person.name = 'Linda'; // person object is now `dirty`
         *
         *      let store = new Store({
         *          data : [
         *              { name : 'Don', age : 40 }
         *          ]
         *      });
         *
         *      store.add(person);
         *
         *      console.log(store.count()); // === 2
         *
         *      store.remove(person); // Remove from store
         *
         * When you update a record in a store, it's considered dirty, until you call {@link Common.data.mixin.StoreCRUD#function-commit commit} on the containing Store. You can also configure your Store to commit automatically (like Google docs).
         * If you use an AjaxStore, it will send changes to your server when commit is called.
         * Any changes you make to the Store or its records are immediately reflected in the Grid, so there is no need to tell it to refresh manually.
         *
         * To learn more about loading and saving data, please refer to [this guide](#guides/data/displayingdata.md).
         * {@endregion}
         * {@region Default configs}
         * There is a myriad of configs and features available for Grid, some of them on by default and some of them requiring
         * extra configuration. The code below tries to illustrate the major things that are used by default:
         *
         * ```javascript
         * let grid = new Grid({
         *    // The following features are enabled by default:
         *    features : {
         *        cellEdit      : true,
         *        columnPicker  : true,
         *        columnReorder : true,
         *        columnResize  : true,
         *        contextMenu   : true,
         *        group         : true,
         *        sort          : true
         *    },
         *
         *    animateRemovingRows       : true,  // Rows will slide out on removal
         *    autoHeight                : false, // Grid needs to have a height supplied through CSS (strongly recommended) or by specifying `height`
         *    columnLines               : true,  // Themes might override it to hide lines anyway
         *    emptyText                 : 'Loading Records...',
         *    enableTextSelection       : false, // Not allowed to select text in cells by default,
         *    fillLastColumn            : true,  // By default the last column is stretched to fill the grid
         *    fullRowRefresh            : true,  // Refreshes entire row when a cell value changes
         *    loadMask                  : 'Loading...',
         *    resizeToFitIncludesHeader : true,  // Also measure header when auto resizing columns
         *    responsiveLevels : {
         *      small : 400,
         *      medium : 600,
         *      large : '*'
         *    },
         *    rowHeight                 : null,  // Determined using CSS, it will measure rowHeight
         *    showDirty                 : false, // No indicator for changed cells
         *    showRemoveInContextMenu   : true   // Context menu has "Remove row" item
         * });
         * ```
         * {@endregion}
         * {@region Performance}
         * In general the Grid widget has very good performance and you can try loading any amount of data in the <a target="_blank" href="../examples/bigdataset">bigdataset</a> demo.
         * The overall rendering performance is naturally affected by many other things than
         * the data volume. Other important factors that can impact performance: number of columns, complex cell renderers, locked columns, the number of features enabled
         * and of course the browser (Chrome fastest, IE slowest).
         * {@endregion}
         *
         * @extends Common/widget/Widget
         * @mixes Common/mixin/Events
         * @mixes Common/mixin/Pluggable
         * @mixes Common/mixin/State
         * @mixes Grid/view/mixin/GridElementEvents
         * @mixes Grid/view/mixin/GridFeatures
         * @mixes Grid/view/mixin/GridResponsive
         * @mixes Grid/view/mixin/GridSelection
         * @mixes Grid/view/mixin/GridState
         * @mixes Grid/view/mixin/GridSubGrids
         *
         * @classType grid
         */

        var Grid =
        /*#__PURE__*/
        function (_base$mixes) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default()(Grid, _base$mixes);

          function Grid() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, Grid);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_15___default()(Grid, [{
            key: "finishConfigure",
            //endregion
            //region Init-destroy
            value: function finishConfigure(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "finishConfigure", this).call(this, config);

              me.scrollManager = new _util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_39__["default"]({
                grid: me,
                // Horizontal scrolling might happen on different subgrids, but vertical is always on same element
                verticalElement: me.scrollable.element
              }); // When locale is applied columns react and change, which triggers `change` event on columns store for each
              // changed column, and every change normally triggers rendering view. This overhead becomes noticeable with
              // larger amount of columns. So we set two listeners to locale events: prioritized listener to be executed first
              // and suspend renderContents method and unprioritized one to resume method and call it immediately.

              _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_32__["default"].on({
                locale: 'onBeforeLocaleChange',
                prio: 1,
                thisObj: me
              });

              _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_32__["default"].on({
                locale: 'onLocaleChange',
                prio: -1,
                thisObj: me
              });

              _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_45__["default"].on({
                theme: 'onThemeChange',
                thisObj: me
              }); // Access the property getter to ensure that all regions have been initialized


              me._thisIsAUsedExpression(me.regions); // Add the extra grid classes to the element


              me.setGridClassList(me.element.classList);
            }
          }, {
            key: "onBeforeLocaleChange",
            value: function onBeforeLocaleChange() {
              this._suspendRenderContentsOnColumnsChanged = true;
            }
          }, {
            key: "onLocaleChange",
            value: function onLocaleChange() {
              this._suspendRenderContentsOnColumnsChanged = false;
              this.rendered ? this.renderContents() : this.render();
            }
          }, {
            key: "finalizeInit",
            value: function finalizeInit() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "finalizeInit", this).call(this);

              if (this.store.isLoading) {
                // Maybe show loadmask if store is already loading when grid is constructed
                this.onStoreLoadStart();
              }
            }
            /**
             * Cleanup
             * @private
             */

          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.storeDetacher && me.storeDetacher();

              var _arr = Object.values(me.features);

              for (var _i = 0; _i < _arr.length; _i++) {
                var feature = _arr[_i];
                feature.destroy && feature.destroy();
              }

              if (me.columns) {
                me.columns = null;
              }

              if (me.store) {
                me.store = null;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "doDestroy", this).call(this);
            }
            /**
             * Adds extra classes to the Grid element after it's been configured.
             * Also iterates through features, thus ensuring they have been initialized.
             * @private
             */

          }, {
            key: "setGridClassList",
            value: function setGridClassList(classList) {
              var me = this;
              classList.add("b-grid-".concat(me.positionMode)); // TODO: enableTextSelection should be a setter, enabling toggling at any time

              if (!me.enableTextSelection) {
                classList.add('b-grid-notextselection');
              }

              if (me.autoHeight) {
                classList.add('b-autoheight');
              }

              if (me.readOnly) {
                classList.add('b-readonly');
              }

              if (me.fillLastColumn) {
                classList.add('b-fill-last-column');
              }

              if (me.showDirty) {
                classList.add('b-show-dirty');
              }

              for (var featureName in me.features) {
                var feature = me.features[featureName],
                    featureClass = void 0;

                if (feature.constructor.hasOwnProperty('featureClass')) {
                  featureClass = feature.constructor.featureClass;
                } else {
                  featureClass = "b-".concat(feature instanceof _Common_Base_js__WEBPACK_IMPORTED_MODULE_21__["default"] ? feature.$name : feature.constructor.name);
                }

                if (featureClass) {
                  classList.add(featureClass.toLowerCase());
                }
              }
            } //endregion
            //region Functions & events injected by features
            // For documentation & typings purposes
            //region Feature events

            /**
             * *Only when the {@link Grid.feature.Tree} feature is enabled*.
             * <p>Fired before a record toggles its collapsed state.
             * @event beforeToggleNode
             * @param {Common.data.Model} record The record being toggled.
             * @param {Boolean} collapse `true` if the node is being collapsed.
             */

            /**
             * *Only when the {@link Grid.feature.Tree} feature is enabled*.
             * <p>Fired after a record has been collapsed.
             * @event collapseNode
             * @param {Common.data.Model} record The record which has been collapsed.
             */

            /**
             * *Only when the {@link Grid.feature.Tree} feature is enabled*.
             * <p>Fired after a record has been expanded.
             * @event expandNode
             * @param {Common.data.Model} record The record which has been expanded.
             */

            /**
             * *Only when the {@link Grid.feature.Tree} feature is enabled*.
             * <p>Fired after a record toggles its collapsed state.
             * @event toggleNode
             * @param {Common.data.Model} record The record being toggled.
             * @param {Boolean} collapse `true` if the node is being collapsed.
             */
            //endregion

            /**
             * Collapse all groups/parent nodes.
             *
             * *NOTE: Only available when the {@link Grid/feature/Group Group} or the {@link Grid/feature/Tree Tree} feature is enabled.*
             *
             * @function collapseAll
             * @category Feature shortcuts
             */

            /**
             * Expand all groups/parent nodes.
             *
             * *NOTE: Only available when the {@link Grid/feature/Group Group} or the {@link Grid/feature/Tree Tree} feature is enabled.*
             *
             * @function expandAll
             * @category Feature shortcuts
             */

            /**
             * Start editing specified cell. If no cellContext is given it starts with the first cell in the first row.
             *
             * *NOTE: Only available when the {@link Grid/feature/CellEdit CellEdit} feature is enabled.*
             *
             * @function startEditing
             * @param {Object} cellContext Cell specified in format { id: 'x', columnId/column/field: 'xxx' }. See {@link Grid.view.Grid#function-getCell} for details.
             * @returns {Boolean}
             * @category Feature shortcuts
             */

            /**
             * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
             *
             * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
             *
             * @function toggleCollapse
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
             * @param {Boolean} [collapse] Force collapse (true) or expand (false)
             * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
             * @returns {Promise}
             * @category Feature shortcuts
             */

            /**
             * Collapse a single node.
             *
             * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
             *
             * @function collapse
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
             * @returns {Promise}
             * @category Feature shortcuts
             */

            /**
             * Expand a single node.
             *
             * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
             *
             * @function expand
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to expand
             * @returns {Promise}
             * @category Feature shortcuts
             */

            /**
             * Expands parent nodes to make this node "visible".
             *
             * *NOTE: Only available when the {@link Grid/feature/Tree Tree} feature is enabled.*
             *
             * @function expandTo
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node
             * @returns {Promise}
             * @category Feature shortcuts
             */
            //endregion
            //region Grid template & elements

          }, {
            key: "template",
            value: function template(data) {
              var virtualScrollerStyle = _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isFirefox ? "height:".concat(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].scrollBarWidth, "px") : ''; // SubGrids are set up first time regions are pulled in

              this._thisIsAUsedExpression(data.regions);

              return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_31__["default"].tpl(_templateObject(), this.hideHeaders ? 'b-hidden' : '', _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].scrollBarWidth ? '' : 'b-overlay-scrollbar', virtualScrollerStyle);
            }
          }, {
            key: "onColumnsChanged",
            value: function onColumnsChanged(_ref) {
              var action = _ref.action,
                  changes = _ref.changes,
                  column = _ref.record;
              var me = this;

              if (action === 'update') {
                // Just updating width is already handled in a minimal way.
                if ('width' in changes || 'minWidth' in changes || 'flex' in changes) {
                  // Update any leaf columns that want to be repainted on size change
                  if (me.rendered) {
                    var region = column.region;
                    me.columns.visibleColumns.forEach(function (col) {
                      if (col.region === region && col.repaintOnResize) {
                        me.refreshColumn(col);
                      }
                    });
                  }

                  return;
                } // Column toggled, need to recheck if any visible column has flex


                if ('hidden' in changes) {
                  var subGrid = me.getSubGridFromColumn(column.id);
                  subGrid.header.fixHeaderWidths();

                  if (subGrid.footer) {
                    subGrid.footer.fixFooterWidths();
                  }

                  subGrid.updateHasFlex();
                }
              } // New columns set ("reconfiguring"), or moved to previously not available region


              if (action === 'dataset' || changes && 'region' in changes && !me.regions.includes(changes.region.value)) {
                // Create required subgrids (removing existing)
                me.initSubGrids(); // Render and jump start them

                me.eachSubGrid(function (subGrid) {
                  subGrid.render(me.verticalScroller);
                  subGrid.initScroll();
                });
              }

              if (!me._suspendRenderContentsOnColumnsChanged) {
                me.renderContents();
              }
            }
          }, {
            key: "onColumnsResized",
            value: function onColumnsResized(_ref2) {
              var changes = _ref2.changes,
                  column = _ref2.record;

              var me = this,
                  setWidth = changes.width && column.flex == null,
                  setMinWidth = changes.minWidth && column.flex == null,
                  setFlex = changes.flex && column.width == null,
                  domWidth = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setLength(column.width),
                  domMinWidth = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].setLength(column.minWidth),
                  subGrid = me.getSubGridFromColumn(column.id); // Let header and footer fix their own widths


              subGrid.header.fixHeaderWidths();

              if (subGrid.footer) {
                subGrid.footer.fixFooterWidths();
              }

              subGrid.updateHasFlex();

              if (!me.cellEls || column !== me.lastColumnResized) {
                me.cellEls = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].children(me.element, ".b-grid-cell[data-column-id=".concat(column.id, "]"));
                me.lastColumnResized = column;
              }

              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = me.cellEls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var cell = _step.value;

                  if (setWidth) {
                    // https://app.assembla.com/spaces/bryntum/tickets/8041
                    // Although header and footer elements must be sized
                    // using flex-basis to avoid the busting out problem,
                    // grid cells MUST be sized using width since rows are absolutely
                    // positioned and will not cause the busting out problem,
                    // and rows will not stretch to shrinkwrap the cells
                    // unless they are widthed with width.
                    cell.style.width = domWidth;
                    cell.style.flex = ''; // IE11 calculates flexbox container width based on min-width rather than actual width. When column
                    // has width defined greater than minWidth, row may have incorrect width

                    if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isIE11) {
                      cell.style.minWidth = domWidth;
                    }
                  } else if (setMinWidth) {
                    cell.style.minWidth = domMinWidth;
                  } else if (setFlex) {
                    cell.style.flex = column.flex;
                    cell.style.width = '';
                  } else {
                    cell.style.flex = cell.style.width = cell.style.minWidth = '';
                  }
                } // If we're being driven by the ColumnResizer, it will
                // call afterColumnsResized.

              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              if (!me.dragResizing) {
                me.afterColumnsResized();
              }
            }
          }, {
            key: "afterColumnsResized",
            value: function afterColumnsResized() {
              var me = this;
              me.refreshVirtualScrollbars();
              me.eachSubGrid(function (subGrid) {
                if (!subGrid.collapsed) {
                  subGrid.fixWidths();
                  subGrid.fixRowWidthsInSafariEdge();
                  subGrid.refreshFakeScroll();
                }
              });
              me.lastColumnResized = me.cellEls = null;
            } //endregion
            //region Rows

            /**
             * Get the Row that is currently displayed at top.
             * @member {Grid.row.Row} topRow
             * @readonly
             * @category Rows
             * @private
             */

            /**
             * Get the Row currently displayed furthest down.
             * @member {Grid.row.Row} bottomRow
             * @readonly
             * @category Rows
             * @private
             */

            /**
             * Get Row for specified record id.
             * @function getRowById
             * @param {Common.data.Model|String|Number} recordOrId Record id (or a record)
             * @returns {Grid.row.Row} Found Row or null if record not rendered
             * @category Rows
             * @private
             */

            /**
             * Returns top and bottom for rendered row or estimated coordinates for unrendered.
             * @function getRecordCoords
             * @param {Common.data.Model|string|Number} recordOrId Record or record id
             * @returns {Object} Record bounds with format { top, height, bottom }
             * @category Calculations
             * @private
             */

            /**
             * Get the Row at specified index. "Wraps" index if larger than available rows.
             * @function getRow
             * @param {Number} index
             * @returns {Grid.row.Row}
             * @category Rows
             * @private
             */

            /**
             * Get a Row for either a record, a record id or an HTMLElement
             * @function getRowFor
             * @param {HTMLElement|Common.data.Model|String|Number} recordOrId Record or record id or HTMLElement
             * @returns {Grid.row.Row} Found Row or null if record not rendered
             * @category Rows
             * @private
             */

            /**
             * Get a Row from an HTMLElement
             * @function getRowFromElement
             * @param {HTMLElement} element
             * @returns {Grid.row.Row} Found Row or null if record not rendered
             * @category Rows
             * @private
             */

          }, {
            key: "showEmptyText",
            value: function showEmptyText() {
              this.bodyContainer && this.bodyContainer.classList[this.rowManager.rowCount || this.store.isLoading ? 'remove' : 'add']('b-grid-empty');
            } //endregion
            //region Store

            /**
             * Hooks up data store listeners
             * @private
             * @category Store
             */

          }, {
            key: "bindStore",
            value: function bindStore(store) {
              var me = this;
              me.storeDetacher = store.on({
                refresh: me.onStoreDataChange,
                update: me.onStoreUpdateRecord,
                add: me.onStoreAdd,
                remove: me.onStoreRemove,
                move: me.onStoreMove,
                replace: me.onStoreReplace,
                removeall: me.onStoreRemoveAll,
                loadstart: me.onStoreLoadStart,
                afterrequest: me.onStoreAfterRequest,
                clearchanges: me.onStoreDataChange,
                exception: me.onStoreException
              }, me);
            }
          }, {
            key: "onStoreUpdateRecord",

            /**
             * Rerenders a cell if a record is updated in the store
             * @private
             * @category Store
             */
            value: function onStoreUpdateRecord(_ref3) {
              var store = _ref3.source,
                  record = _ref3.record,
                  data = _ref3.data;
              var me = this;

              if (me.forceFullRefresh) {
                // flagged to need full refresh (probably from using GroupSummary)
                me.rowManager.refresh();
                me.forceFullRefresh = false;
              } else {
                var row; // Search for old row if id was changed

                if (record.isFieldModified('id')) {
                  row = me.getRowFor(record.meta.modified.id);
                }

                row = row || me.getRowFor(record); // not rendered, bail out

                if (!row) return; // We must refresh the full row if it's a special row which has signalled
                // an update because it has no cells.

                if (me.fullRowRefresh || record.meta.specialRow) {
                  var index = store.indexOf(record);

                  if (index !== -1) {
                    row.render(index, record);
                  }
                } else {
                  Object.keys(data).forEach(function (field) {
                    var cell = row.getCell(field);
                    if (cell) row.renderCell(cell, record);
                  });
                }
              }
            }
          }, {
            key: "refreshFromRowOnStoreAdd",
            value: function refreshFromRowOnStoreAdd(row, context) {
              var me = this,
                  rowManager = me.rowManager;
              rowManager.renderFromRow(row);
              rowManager.trigger('changeTotalHeight', {
                totalHeight: rowManager.totalHeight
              }); // First record? Also update fake scrollers
              // TODO: Consider making empty grid scrollable to not have to do this

              if (me.store.count === 1) {
                me.callEachSubGrid('refreshFakeScroll');
              }
            }
            /**
             * Refreshes rows when data is added to the store
             * @private
             * @category Store
             */

          }, {
            key: "onStoreAdd",
            value: function onStoreAdd(_ref4) {
              var store = _ref4.source,
                  records = _ref4.records,
                  index = _ref4.index,
                  oldIndex = _ref4.oldIndex,
                  isChild = _ref4.isChild,
                  oldParent = _ref4.oldParent,
                  isMove = _ref4.isMove; // Do not react if the content has not been rendered

              if (!this.rendered) {
                return;
              } // If it's the addition of a child to a collapsed zone, the UI does not change.


              if (isChild && !records[0].ancestorsExpanded(store)) {
                return;
              }

              this.rowManager.calculateRowCount(false, true, true);
              var me = this,
                  rowManager = me.rowManager,
                  topIndex = rowManager.topIndex,
                  rows = rowManager.rows,
                  rowCount = rowManager.rowCount,
                  bottomIndex = rowManager.topIndex + rowManager.rowCount - 1,
                  dataStart = index,
                  dataEnd = index + records.length - 1,
                  atEnd = bottomIndex >= store.count - records.length - 1; // When moving a node within a tree we might need the redraw to include its old parent and its children. Not worth
              // the complexity of trying to do a partial render for this, rerender all rows to be safe.
              // Moving records within a flat store is handled elsewhere, in onStoreMove
              // TODO: Moving within a tree should also trigger 'move' (https://app.assembla.com/spaces/bryntum/tickets/7270)

              if (oldParent || oldIndex > -1 || isChild && isMove) {
                rowManager.refresh();
              } // Added block starts in our visible block. Render from there downwards.
              else if (dataStart >= topIndex && dataStart < topIndex + rowCount) {
                  me.refreshFromRowOnStoreAdd.apply(me, [rows[dataStart - topIndex]].concat(Array.prototype.slice.call(arguments)));
                } // Added block ends in our visible block, render block
                else if (dataEnd >= topIndex && dataEnd < topIndex + rowCount) {
                    rowManager.refresh();
                  } // If added block is outside of the visible area, no visible change
                  // but potentially a change in total dataset height.
                  else {
                      // If we are against the end of the dataset, and have appended records
                      // ensure they are rendered below
                      if (atEnd && index > bottomIndex) {
                        rowManager.fillBelow(me._scrollTop);
                      }

                      rowManager.trigger('changeTotalHeight', {
                        totalHeight: rowManager.totalHeight
                      });
                    }
            }
            /**
             * Responds to exceptions signalled by the store
             * @private
             * @category Store
             */

          }, {
            key: "onStoreException",
            value: function onStoreException(event) {
              var me = this;
              var message;

              switch (event.type) {
                case 'server':
                  message = event.response.message || 'Unspecified failure';
                  break;

                case 'exception':
                  if (event.exceptionType === 'network') {
                    message = 'Network error';
                  } else {
                    // Server sent something that couldn't be parsed
                    message = event.error && event.error.message || 'Failed to parse server response';
                  }

                  break;

                default:
                  message = event.response.status + ' - ' + event.response.statusText || 'Unknown error';
              } // eslint-disable-next-line


              var messageHTML = "<div class=\"b-grid-load-failure\">\n                <div class=\"b-grid-load-fail\">".concat(me.L('loadFailedMessage'), "</div>\n                <div class=\"b-grid-load-fail\">").concat(event.response.url ? event.response.url + ' responded with' : '', "</div>\n                <div class=\"b-grid-load-fail\">").concat(message, "</div>\n            </div>");

              if (me.activeMask) {
                me.activeMask.icon = me.loadMaskErrorIcon;
                me.activeMask.text = messageHTML;
                me.loadmaskHideTimer = me.setTimeout(function () {
                  me.unmaskBody();
                }, me.loadMaskHideTimeout);
              }
            }
            /**
             * Refreshes rows when data is changed in the store
             * @private
             * @category Store
             */

          }, {
            key: "onStoreDataChange",
            value: function onStoreDataChange(_ref5) {
              var action = _ref5.action,
                  changes = _ref5.changes,
                  store = _ref5.source; // If the next mixin up the inheritance chain has an implementation, call it

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "onStoreDataChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "onStoreDataChange", this).apply(this, arguments);
              var me = this,
                  isGroupFieldChange = store.isGrouped && changes && me.groupers.find(function (grouper) {
                return grouper.field in changes;
              }); // If it's new data, the old calculation is invalidated.

              if (action === 'dataset') {
                me.rowManager.averageRowHeight = null;
              } // No need to rerender if it's a change of the value of the group field which
              // will be responded to by StoreGroup


              if (me.rendered && !isGroupFieldChange) {
                // Return to top if setting new data or is filtering
                me.renderRows(null, action === 'dataset' || action === 'filter');
              }

              me.showEmptyText();
            }
            /**
             * Shows a load mask while the connected store is loading
             * @private
             * @category Store
             */

          }, {
            key: "onStoreLoadStart",
            value: function onStoreLoadStart() {
              if (this.loadMask) {
                this.maskBody(this.loadMask);
              }
            }
            /**
             * Hides load mask after a load request ends either in success or failure
             * @private
             * @category Store
             */

          }, {
            key: "onStoreAfterRequest",
            value: function onStoreAfterRequest(event) {
              if (this.activeMask && !event.exception) {
                this.unmaskBody();
              }
            }
            /**
             * Animates removal of record.
             * @private
             * @category Store
             */

          }, {
            key: "onStoreRemove",
            value: function onStoreRemove(_ref6) {
              var records = _ref6.records,
                  isCollapse = _ref6.isCollapse,
                  isChild = _ref6.isChild,
                  isMove = _ref6.isMove; // Do not react if the content has not been rendered,
              // or if it is a move, which will be handled by onStoreAdd

              if (!this.rendered || isMove) {
                return;
              } // GridSelection mixin does its job on records removing


              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "onStoreRemove", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "onStoreRemove", this).apply(this, arguments);
              var topRowIndex = Math.pow(2, 53) - 1;
              var me = this,
                  rowManager = this.rowManager,
                  rowsToRemove = records.reduce(function (result, record) {
                var row = rowManager.getRowById(record.id);

                if (row) {
                  result.push(row); // Rows are repositioned in the array, it matches visual order. Need to find actual index in it

                  topRowIndex = Math.min(topRowIndex, rowManager.rows.indexOf(row));
                }

                return result;
              }, []);

              if (me.animateRemovingRows && rowsToRemove.length && !isCollapse && !isChild) {
                var topRow = rowsToRemove[0];
                me.isAnimating = true; // As soon as first row has disappeared, rerender the view

                _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_64__["default"].on({
                  element: topRow._elementsArray[0],
                  transitionend: function transitionend(e) {
                    me.isAnimating = false; // hovering triggers background-color transitions, ignore those

                    if (e.propertyName !== 'background-color' && e.propertyName !== 'width') {
                      rowsToRemove.forEach(function (row) {
                        return row.removeCls('b-removing');
                      });
                      rowManager.refresh(); // undocumented internal event for scheduler

                      me.trigger('rowRemove');
                    }
                  },
                  once: true
                });

                rowsToRemove.forEach(function (row) {
                  return row.addCls('b-removing');
                });
              } else {
                // Potentially remove rows and change dataset height
                rowManager.calculateRowCount(false, true, true); // If there were rows below which have moved up into place
                // then repurpose them with their new records

                if (rowManager.rows[topRowIndex]) {
                  rowManager.renderFromRow(rowManager.rows[topRowIndex]);
                } // If nothing to render below, just update dataset height
                else {
                    rowManager.trigger('changeTotalHeight', {
                      totalHeight: rowManager.totalHeight
                    });
                  }

                me.trigger('rowRemove', {
                  isCollapse: isCollapse
                });
              }
            }
          }, {
            key: "onStoreMove",
            value: function onStoreMove(_ref7) {
              var from = _ref7.from,
                  to = _ref7.to;

              var rowManager = this.rowManager,
                  topIndex = rowManager.topIndex,
                  rowCount = rowManager.rowCount,
                  _sort = [from, to].sort(),
                  _sort2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_sort, 2),
                  dataStart = _sort2[0],
                  dataEnd = _sort2[1]; // Changed block starts in our visible block. Render from there downwards.


              if (dataStart >= topIndex && dataStart < topIndex + rowCount) {
                rowManager.renderFromRow(rowManager.rows[dataStart - topIndex]);
              } // Changed block ends in our visible block, render block
              else if (dataEnd >= topIndex && dataEnd < topIndex + rowCount) {
                  rowManager.refresh();
                } // If changed block is outside of the visible area, this is a no-op

            }
          }, {
            key: "onStoreReplace",
            value: function onStoreReplace(_ref8) {
              var _this = this;

              var records = _ref8.records,
                  all = _ref8.all;

              if (all) {
                this.rowManager.refresh();
              } else {
                var rows = records.reduce(function (rows, _ref9) {
                  var _ref10 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref9, 2),
                      record = _ref10[1];

                  var row = _this.getRowFor(record);

                  if (row) {
                    rows.push(row);
                  }

                  return rows;
                }, []);
                this.rowManager.renderRows(rows);
              }
            }
            /**
             * Rerenders grid when all records have been removed
             * @private
             * @category Store
             */

          }, {
            key: "onStoreRemoveAll",
            value: function onStoreRemoveAll() {
              // GridSelection mixin does its job on records removing
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "onStoreRemoveAll", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "onStoreRemoveAll", this).apply(this, arguments);

              if (this.rendered) {
                this.renderRows();
                this.showEmptyText();
              }
            }
            /**
             * Convenience functions for getting/setting data in related store
             * @property {Object[]}
             * @category Common
             */

          }, {
            key: "getHeaderMenuItems",
            //endregion
            //region Context menu items

            /**
             * Populates the header context menu. Chained in features to add menu items.
             * @param column Column for which the menu will be shown
             * @param items Array of menu items, add to it and return it
             * @category Menu items
             * @internal
             */
            value: function getHeaderMenuItems(column, items) {
              var me = this,
                  subGrids = me.subGrids,
                  regions = me.regions;
              var first = true;
              Object.entries(subGrids).forEach(function (_ref11) {
                var _ref12 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref11, 2),
                    region = _ref12[0],
                    subGrid = _ref12[1]; // If SubGrid is configured with a sealed column set, do not allow moving into it


                if (subGrid.sealedColumns) {
                  return;
                }

                if (column.draggable && region !== column.region && (!column.parent && subGrids[column.region].columns.count > 1 || column.parent && column.parent.children.length > 1)) {
                  var moveRight = subGrid.element.compareDocumentPosition(subGrids[column.region].element) === document.DOCUMENT_POSITION_PRECEDING,
                      // With 2 regions, use Move left, Move right. With multiple, include region name
                  text = regions.length > 2 ? me.L('Move column to ') + region : me.L(moveRight ? 'moveColumnRight' : 'moveColumnLeft');
                  items.push({
                    targetSubGrid: region,
                    text: text,
                    icon: 'b-fw-icon ' + (moveRight ? 'b-icon-column-move-right' : 'b-icon-column-move-left'),
                    name: 'moveColumn',
                    cls: first ? 'b-separator' : '',
                    onItem: function onItem(_ref13) {
                      var item = _ref13.item;
                      var column = item.column;
                      column.traverse(function (col) {
                        return col.region = region;
                      }); // Changing region will move the column to the correct SubGrid, but we want it to go last

                      me.columns.insert(me.columns.indexOf(subGrids[item.targetSubGrid].columns.last) + 1, column);
                      me.scrollColumnIntoView(column);
                    }
                  });
                  first = false;
                }
              });
            }
            /**
             * Populates the cell context menu. Chained in features to add menu items.
             * @param column {Grid.column.Column} Column for which the menu will be shown
             * @param record {Common.data.Model} Record (row) for which the menu will be shown
             * @param items {Object[]} Array of menu items, add to it and return it
             * @category Menu items
             * @internal
             */

          }, {
            key: "getCellMenuItems",
            value: function getCellMenuItems(column, record, items) {
              var me = this;

              if (me.showRemoveRowInContextMenu && !me.readOnly && record && !record.meta.specialRow) {
                if (me.selectedRecords.length > 1) {
                  items.push({
                    text: me.L('removeRows'),
                    icon: 'b-fw-icon b-icon-trash',
                    name: 'removeRows',
                    onItem: function onItem() {
                      return me.store.remove(me.selectedRecords);
                    }
                  });
                } else {
                  items.push({
                    text: me.L('removeRow'),
                    icon: 'b-fw-icon b-icon-trash',
                    name: 'removeRow',
                    onItem: function onItem() {
                      return me.store.remove(record);
                    }
                  });
                }
              }
            }
          }, {
            key: "getColumnDragToolbarItems",
            value: function getColumnDragToolbarItems(column, items) {
              return items;
            } //endregion
            //region Getters

          }, {
            key: "normalizeCellContext",
            value: function normalizeCellContext(cellContext) {
              var columns = this.columns,
                  store = this.store; // TODO: should clone instead of modify?
              // TODO: The answer is to use the Grid/util/Location class to robustly encapsulate a record/column intersection
              // And have them immutable, so that to change is to clone, as explained by MaximGB,
              // we want to use columnId for precision, but allow user to specify column name for ease of use...
              // modify cellContext to include columnId in those cases

              if (cellContext instanceof store.modelClass) {
                return {
                  record: cellContext,
                  id: cellContext.id,
                  columnId: columns.bottomColumns[0].id
                };
              }

              if (!('columnId' in cellContext)) {
                if ('field' in cellContext) {
                  var column = columns.get(cellContext.field);
                  cellContext.columnId = column && column.id;
                } else if ('column' in cellContext) {
                  var _column = typeof cellContext.column === 'number' ? columns.bottomColumns[cellContext.column] : cellContext.column;

                  cellContext.columnId = _column && _column.id;
                } // Fall back to first leaf column


                if (!('columnId' in cellContext)) {
                  cellContext.columnId = columns.bottomColumns[0].id;
                }
              }

              if ('id' in cellContext) {
                // If the context is for an element, but it's stale (for a removed record)
                // then fix it up to refer to the record id at the same index.
                if (cellContext.element && !store.getById(cellContext.id)) {
                  // This uses the data-index property to get the row at that index.
                  var newRec = this.getRecordFromElement(cellContext.element); // We have a record at the same index.

                  if (newRec) {
                    cellContext.id = newRec.id;
                  }
                }
              } else {
                if ('row' in cellContext) {
                  cellContext.id = store.getAt(cellContext.row).id;
                } else if ('record' in cellContext) {
                  cellContext.id = cellContext.record.id;
                }
              }

              return cellContext;
            } // TODO: move to RowManager? Or create a CellManager?

            /**
             * Returns a cell if rendered.
             * @param {Object} cellContext { id: rowId, columnId: columnId [,column: column number, field: column field] }
             * @param {Number} [cellContext.row] The row index of the row to access. Exclusive with `id` and 'record'.
             * @param {String|Number} [cellContext.id] The record id of the row to access. Exclusive with `row` and 'record'.
             * @param {Common.data.Model} [cellContext.record] The record of the row to access. Exclusive with `id` and 'row'.
             * @param {Number} [cellContext.column] The column instance or the index of the cell to access.  Exclusive with `columnId`.
             * @param {String|Number} [cellContext.columnId] The column id of the column to access. Exclusive with `column`.
             * @param {String} [cellContext.field] The field of the column to access. Exclusive with `column`.
             * @returns {HTMLElement}
             * @category Getters
             */

          }, {
            key: "getCell",
            value: function getCell(cellContext) {
              var row,
                  result = null;
              cellContext = this.normalizeCellContext(cellContext);

              if (cellContext.id) {
                row = this.getRowById(cellContext.id);
              }

              if (row && cellContext.columnId) {
                result = row.getCell(cellContext.columnId);
              }

              return result;
            } //TODO: Should move to ColumnManager? Or Header?

            /**
             * Returns the header element for the column
             * @param {String|Number|Grid.column.Column} columnId or Column instance
             * @returns {HTMLElement} Header element
             * @category Getters
             */

          }, {
            key: "getHeaderElement",
            value: function getHeaderElement(columnId) {
              if (typeof columnId !== 'string') {
                columnId = columnId.id;
              }

              return this.fromCache(".b-grid-header[data-column-id=\"".concat(columnId, "\"]"));
            }
          }, {
            key: "getHeaderElementByField",
            value: function getHeaderElementByField(field) {
              var column = this.columns.get(field);
              return column ? this.getHeaderElement(column) : null;
            }
            /**
             * Body height
             * @property {Number}
             * @readonly
             * @category Layout
             */

          }, {
            key: "getRecordFromElement",

            /**
             * Searches up from the specified element for a grid row and returns the record associated with that row.
             * @param {HTMLElement} element Element somewhere within a row or the row container element
             * @returns {Common.data.Model} Record for the row
             * @category Getters
             */
            value: function getRecordFromElement(element) {
              var el = element.closest('.b-grid-row');
              if (!el) return null;
              return this.store.getAt(el.dataset.index);
            }
            /**
             * Searches up from specified element for a grid cell or an header and returns the column which the cell belongs to
             * @param {HTMLElement} element Element somewhere in a cell
             * @returns {Grid.column.Column} Column to which the cell belongs
             * @category Getters
             */

          }, {
            key: "getColumnFromElement",
            value: function getColumnFromElement(element) {
              var cell = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].up(element, '.b-grid-cell, .b-grid-header');

              if (!cell) return null;

              if (cell.matches('.b-grid-header')) {
                return this.columns.getById(cell.dataset.columnId);
              }

              var cellData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_24__["default"].get(cell);

              return this.columns.getById(cellData.columnId);
            } // Getter and setter for autoHeight only added for type checking, since it seems common to get it wrong in react/angular

          }, {
            key: "fixSizes",
            //endregion
            //region Fix width & height

            /**
             * Sets widths and heights for headers, rows and other parts of the grid as needed
             * @private
             * @category Width & height
             */
            value: function fixSizes() {
              // subGrid width
              this.callEachSubGrid('fixWidths');
            }
          }, {
            key: "onRowManagerChangeTotalHeight",
            value: function onRowManagerChangeTotalHeight(_ref14) {
              var totalHeight = _ref14.totalHeight;
              this.refreshTotalHeight(totalHeight);
            }
            /**
             * Makes height of vertical scroller match estimated total height of grid. Called when scrolling vertically and
             * when showing/hiding rows.
             * @param {Number} height
             * @private
             * @category Width & height
             */

          }, {
            key: "refreshTotalHeight",
            value: function refreshTotalHeight() {
              var height = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rowManager.totalHeight; // Removed isVisible check here, since rows are rendered on paint now (when grid is visible)

              if (this.renderingRows) {
                return;
              }

              if (this.rowManager.bottomRow) {
                height = Math.max(height, this.rowManager.bottomRow.bottom);
              }

              var me = this,
                  scroller = me.scrollable,
                  delta = Math.abs(me.virtualScrollHeight - height),
                  clientHeight = me._bodyRectangle.height,
                  newMaxY = height - clientHeight;

              if (delta) {
                var // We must update immediately if we are nearing the end of the scroll range.
                isCritical = newMaxY - me._scrollTop < clientHeight * 2 || // Or if we have scrolled pass visual height
                me._verticalScrollHeight && me._verticalScrollHeight - clientHeight < me._scrollTop; // Update the true scroll range using the scroller. This will not cause a repaint.

                scroller.scrollHeight = me.virtualScrollHeight = height; // If we are scrolling, put this off because it causes
                // a full document layout and paint.

                if (me.scrolling && !isCritical) {
                  if (!me.virtualScrollHeightDirty) {
                    me.virtualScrollHeightDirty = scroller.on({
                      scrollend: me.fixElementHeights,
                      thisObj: me,
                      once: true
                    });
                  }
                } else {
                  me.virtualScrollHeightDirty && me.virtualScrollHeightDirty();
                  me.fixElementHeights(height);
                }
              }
            }
          }, {
            key: "fixElementHeights",
            value: function fixElementHeights() {
              var me = this,
                  height = me.virtualScrollHeight,
                  heightInPx = "".concat(height, "px");
              me._verticalScrollHeight = height;
              me.verticalScroller.style.height = heightInPx;
              me.virtualScrollHeightDirty = false;

              if (me.autoHeight) {
                me.bodyContainer.style.height = heightInPx;
                me._bodyHeight = height;
                me._bodyRectangle = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].client(me.bodyContainer);
              }

              me.refreshVirtualScrollbars();
            } //endregion
            //region Scroll & virtual rendering

          }, {
            key: "onRowManagerRequestScrollChange",

            /**
             * Responds to request from RowManager to adjust scroll position. Happens when jumping to a scroll position with
             * variable row height.
             * @param {Number} bottomMostRowY
             * @private
             * @category Scrolling
             */
            value: function onRowManagerRequestScrollChange(_ref15) {
              var bottom = _ref15.bottom;
              this.scrollable.y = bottom - this.bodyHeight;
            }
            /**
             * Scroll syncing for normal headers & grid + triggers virtual rendering for vertical scroll
             * @private
             * @fires scroll
             * @category Scrolling
             */

          }, {
            key: "initScroll",
            value: function initScroll() {
              var me = this; // This method may be called early, before render calls it, so ensure that it's
              // only executed once.

              if (!me.scrollInitialized) {
                var scrollTop,
                    onScroll = me.createOnFrame(function () {
                  scrollTop = me.scrollable.y; // Was getting scroll events in FF where scrollTop was unchanged, ignore those

                  if (scrollTop !== me._scrollTop) {
                    me._scrollTop = scrollTop;

                    if (!me.scrolling) {
                      me.scrolling = true;
                      me.eachSubGrid(function (s) {
                        return s.suspendResizeMonitor = true;
                      });
                    }

                    me.rowManager.updateRenderedRows(scrollTop);
                    /**
                    * Grid has scrolled vertically
                    * @event scroll
                    * @param {Grid.view.Grid} grid
                    * @param {Number} scrollTop
                    */

                    me.trigger('scroll', {
                      scrollTop: scrollTop
                    });
                  }
                });
                me.scrollInitialized = true;
                me.scrollable.on({
                  scroll: onScroll,
                  scrollend: function scrollend() {
                    me.scrolling = false;
                    me.eachSubGrid(function (s) {
                      return s.suspendResizeMonitor = false;
                    });
                  }
                });
                me.callEachSubGrid('initScroll');
              }
            } // TODO: rename to scrollRecordIntoView? Or have an alias?

            /**
             * Scrolls a row into view. If row isn't rendered it tries to calculate position
             * @param {Common.data.Model|String|Number} recordOrId Record or record id
             * @param {Object} [options] How to scroll.
             * @param {String} [options.column] Field name or ID of the column, or the Column instance to scroll to.
             * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
             * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
             * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
             * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
             * @category Scrolling
             * @returns {Promise} A promise which resolves when the specified row has been scrolled into view.
             */

          }, {
            key: "scrollRowIntoView",
            value: function scrollRowIntoView(recordOrId) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;
              var me = this,
                  blockPosition = options.block || 'nearest',
                  rowManager = me.rowManager;
              recordOrId = me.store.getById(recordOrId);

              if (recordOrId) {
                // check that record is "displayable", not filtered out or hidden by collapse
                if (me.store.indexOf(recordOrId) === -1) {
                  return resolvedPromise;
                }

                var scroller = me.scrollable,
                    recordRect = me.getRecordCoords(recordOrId);

                var scrollerRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(scroller.element); // If it was calculated from the index, update the rendered rowScrollMode
                // and scroll to the actual element. Note that this should only be necessary
                // for variableRowHeight.
                // But to "make the tests green", this is a workaround for a buffered rendering
                // bug when teleporting scroll. It does not render the rows at their correct
                // positions. Please do not try to "fix" this. I will do it. NGW


                if (recordRect.virtual) {
                  var virtualBlock = recordRect.block; // Scroll the calculated position to the center of the scrollingViewport
                  // and then update the rendered block while asking the RowManager to
                  // display the required recordOrId.

                  scroller.scrollIntoView(recordRect, {
                    block: 'center'
                  });
                  rowManager.scrollTargetRecordId = recordOrId;
                  rowManager.updateRenderedRows(scroller.y, true);
                  recordRect = me.getRecordCoords(recordOrId);
                  rowManager.lastScrollTop = scroller.y;

                  if (recordRect.virtual) {
                    // bail out to not get caught in infinite loop, since code above is cut out of bundle
                    // eslint-disable-next-line no-useless-return,no-unreachable
                    return resolvedPromise;
                  }

                  var innerOptions = blockPosition !== 'nearest' ? options : {
                    block: virtualBlock
                  }; // Scroll the target just less than append/prepend buffer height out of view so that the animation looks good

                  if (options.animate) {
                    // Do not fire scroll events during this scroll sequence - it's a purely cosmetic operation.
                    // We are scrolling the desired row out of view merely to *animate scroll* it to the requested position.
                    scroller.suspendEvents(); // Scroll to its final position

                    if (blockPosition === 'end' || blockPosition === 'nearest' && virtualBlock === 'end') {
                      scroller.y -= scrollerRect.bottom - recordRect.bottom;
                    } else if (blockPosition === 'start' || blockPosition === 'nearest' && virtualBlock === 'start') {
                      scroller.y += recordRect.y - scrollerRect.y;
                    } // Ensure rendered block is correct at that position


                    rowManager.updateRenderedRows(scroller.y, false, true); // Scroll away from final position to enable a cosmetic scroll to final position

                    if (virtualBlock === 'end') {
                      scroller.y -= rowManager.appendRowBuffer * rowManager.rowHeight - 1;
                    } else {
                      scroller.y += rowManager.prependRowBuffer * rowManager.rowHeight - 1;
                    } // The row will still be rendered, so scroll it using the scroller directly


                    var result = scroller.scrollIntoView(me.getRecordCoords(recordOrId), Object.assign({}, options, innerOptions)); // Now we're at the required position, resume events

                    result.then(function () {
                      return scroller.resumeEvents();
                    });
                    return result;
                  } else {
                    return me.scrollRowIntoView(recordOrId, Object.assign({}, options, innerOptions));
                  }
                } else {
                  var column = options.column;

                  if (column) {
                    if (typeof column === 'string') {
                      column = me.columns.getById(column) || me.columns.get(column);
                    }

                    if (column) {
                      // If we are targetting a column, we must use the scroller of that column's SubGrid
                      scroller = me.getSubGridFromColumn(column).scrollable;

                      var cellRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].from(rowManager.getRowFor(recordOrId).getCell(column.id));

                      recordRect.x = cellRect.x;
                      recordRect.width = cellRect.width;
                    }
                  }

                  return scroller.scrollIntoView(recordRect, options);
                }
              }
            }
            /**
             * Scrolls a column into view (if it is not already)
             * @param {Grid.column.Column|String|Number} column Column name (data) or column index or actual column object.
             * @param {Object} [options] How to scroll.
             * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
             * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
             * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
             * or the number of milliseconds to animate over, or an animation config object.
             * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
             * @param {String} [options.animate.easing] The name of an easing function.
             * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
             * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
             * @returns {Promise} If the column exists, a promise which is resolved when the column header element has been scrolled into view.
             * @category Scrolling
             */

          }, {
            key: "scrollColumnIntoView",
            value: function scrollColumnIntoView(column, options) {
              column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_66__["default"] ? column : this.columns.get(column) || this.columns.getById(column) || this.columns.getAt(column);
              return this.getSubGridFromColumn(column).scrollColumnIntoView(column, options);
            } // TODO The API { id: recordId, column: 'columnName' } is not clear: id has to be renamed to `record` or `recordId` to be self-explanatory;

            /**
             * Scrolls a cell into view (if it is not already)
             * @param {Object} cellContext Cell selector { id: recordId, column: 'columnName' }
             * @category Scrolling
             */

          }, {
            key: "scrollCellIntoView",
            value: function scrollCellIntoView(cellContext, options) {
              return this.scrollRowIntoView(cellContext.id, Object.assign({
                column: cellContext.columnId
              }, options));
            }
            /**
             * Scroll all the way down
             * @returns {Promise} A promise which resolves when the bottom is reached.
             * @category Scrolling
             */

          }, {
            key: "scrollToBottom",
            value: function scrollToBottom(options) {
              // triggers scroll to last record. not using current scroller height because we do not know if it is correct
              return this.scrollRowIntoView(this.store.last, options);
            }
            /**
             * Scroll all the way up
             * @returns {Promise} A promise which resolves when the top is reached.
             * @category Scrolling
             */

          }, {
            key: "scrollToTop",
            value: function scrollToTop(options) {
              return this.scrollable.scrollBy(0, -this.scrollable.y, options);
            }
            /**
             * Store scroll state (scrollTop for entire grid and scrollLeft per sub grid)
             * @returns {{scrollTop: (*|string|number), scrollLeft: {}}}
             * @category Scrolling
             */

          }, {
            key: "storeScroll",
            value: function storeScroll() {
              var me = this,
                  state = me.storedScrollState = {
                scrollTop: me.scrollable.y,
                scrollLeft: {}
              }; // TODO: Implement special multi-element Scroller subclass for Grids which
              // encapsulates the x axis only Scrollers of all its SubGrids.

              me.eachSubGrid(function (subGrid) {
                state.scrollLeft[subGrid.region] = subGrid.scrollable.x;
              });
              return state;
            }
            /**
             * Restore scroll state. If state is not specified, restores the last stored state.
             * @param state Scroll state, optional
             * @category Scrolling
             */

          }, {
            key: "restoreScroll",
            value: function restoreScroll() {
              var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.storedScrollState;
              var me = this; // TODO: Implement special multi-element Scroller subclass for Grids which
              // encapsulates the x axis only Scrollers of all its SubGrids.

              me.eachSubGrid(function (subGrid) {
                subGrid.scrollable.x = state.scrollLeft[subGrid.region];
              });
              me.scrollable.y = state.scrollTop;
            } //endregion
            //region Theme & measuring

            /**
             * Creates a fake subgrid with one row and mesaures its height. Result is used as rowHeight.
             * @private
             */

          }, {
            key: "measureRowHeight",
            value: function measureRowHeight() {
              var me = this,
                  // Create a fake subgrid with one row, since styling for row is specified on .b-grid-subgrid .b-grid-row
              rowMeasureElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].createElement({
                tag: 'div',
                // TODO: should either get correct widgetClassList or query features for measure classes
                className: 'b-grid ' + (me.features.stripe ? 'b-stripe' : ''),
                style: 'position: absolute; visibility: hidden',
                html: '<div class="b-grid-subgrid"><div class="b-grid-row"></div></div>',
                parent: document.getElementById(me.appendTo) || document.body
              }); // Use style height or default height from config.
              // Not using clientHeight since it will have some value even if no height specified in CSS


              var rowEl = rowMeasureElement.firstElementChild.firstElementChild,
                  styleHeight = parseInt(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getStyleValue(rowEl, 'height')),
                  borderTop = parseInt(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getStyleValue(rowEl, 'border-top-width')),
                  borderBottom = parseInt(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getStyleValue(rowEl, 'border-bottom-width')); // Change rowHeight if specified in styling, also remember that value to replace later if theme changes and
              // user has not explicitly set some other height

              if (me.rowHeight == null || me.rowHeight === me._rowHeightFromStyle) {
                me.rowHeight = !isNaN(styleHeight) && styleHeight ? styleHeight : me.defaultRowHeight;
                me._rowHeightFromStyle = me.rowHeight;
              } // this measurement will be added to rowHeight during rendering, to get correct cell height


              me._rowBorderHeight = borderTop + borderBottom;
              me._isRowMeasured = true;
              rowMeasureElement.remove(); // There is a ticket about measuring the actual first row instead:
              // https://app.assembla.com/spaces/bryntum/tickets/5735-measure-first-real-rendered-row-for-rowheight/details
            }
            /**
             * Handler for global theme change event (triggered by shared.js). Remeasures row height.
             * @private
             */

          }, {
            key: "onThemeChange",
            value: function onThemeChange(_ref16) {
              var theme = _ref16.theme;
              this.measureRowHeight();
              this.trigger('theme', {
                theme: theme
              });
            } //endregion
            //region Rendering of rows

            /**
             * Triggers a render of records to all row elements. Call after changing order, grouping etc to reflect changes
             * visually. Preserves scroll.
             * @category Rendering
             */

          }, {
            key: "refreshRows",
            value: function refreshRows() {
              var returnToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              this.element.classList.add('b-notransition');

              if (returnToTop) {
                this.rowManager.returnToTop();
              } else {
                this.rowManager.refresh();
              }

              this.element.classList.remove('b-notransition');
            }
            /**
             * Triggers a render of all the cells in a column.
             * @param {Grid.column.Column} column
             * @category Rendering
             */

          }, {
            key: "refreshColumn",
            value: function refreshColumn(column) {
              var field = column.field;
              this.rowManager.forEach(function (row) {
                var cell = row.getCell(field);
                row.renderCell(cell);
              });
            } //endregion
            //region Render the grid

            /**
             * Recalculates virtual scrollbars widths and scrollWidth
             * @private
             */

          }, {
            key: "refreshVirtualScrollbars",
            value: function refreshVirtualScrollbars() {
              var scrollBarWidth = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].scrollBarWidth;

              if (scrollBarWidth) {
                var me = this,
                    headerContainer = me.headerContainer,
                    footerContainer = me.footerContainer,
                    virtualScrollers = me.virtualScrollers,
                    hasVerticalOverflow = me.virtualScrollHeight > me.bodyHeight,
                    hasHorizontalOverflow = Object.values(me.subGrids).some(function (subGrid) {
                  return subGrid.overflowingHorizontally;
                });

                if (hasHorizontalOverflow) {
                  virtualScrollers.classList.remove('b-hide-display');
                } else {
                  virtualScrollers.classList.add('b-hide-display');
                }

                if (hasVerticalOverflow) {
                  if (!headerContainer.classList.contains('b-grid-vertical-overflow')) {
                    headerContainer.classList.add('b-grid-vertical-overflow');
                  }
                } else {
                  headerContainer.classList.remove('b-grid-vertical-overflow');
                } // can get called before headers are rendered. headers might also be hidden (such as in docs)


                var lastHeaderScroller = headerContainer.querySelector('.b-grid-header-scroller:last-child');

                if (lastHeaderScroller && hasVerticalOverflow) {
                  var headerBorderWidth = parseInt(_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].getStyleValue(lastHeaderScroller, 'border-right-width')); // Add a style to pad the header-container to clear the grid's vertical scrollbar
                  // TODO: regions part of calculation is to compensate for 1px off with third region, but it should be solvable using CSS. Not finding how though...

                  headerContainer.style.paddingRight = scrollBarWidth - headerBorderWidth + (me.regions.length > 2 ? 1 : 0) + 'px';
                  footerContainer.style.paddingRight = "".concat(scrollBarWidth, "px");
                } else {
                  headerContainer.style.paddingRight = '0';
                  footerContainer.style.paddingRight = '0';
                }
              }
            }
          }, {
            key: "onContentChange",
            value: function onContentChange() {
              var me = this,
                  rowManager = me.rowManager;

              if (me.isVisible) {
                var contentHeight = Math.max(rowManager.totalHeight, rowManager.bottomRow ? rowManager.bottomRow.bottom : 0);
                me.paintListener = null; // cache to avoid recalculations in the middle of rendering code (RowManger#getRecordCoords())

                me._bodyRectangle = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].client(me.bodyContainer);
                me._bodyHeight = me.autoHeight ? contentHeight : me._bodyRectangle.height;
                me.refreshTotalHeight(contentHeight);
                me.callEachSubGrid('refreshFakeScroll');
              } // If not visible, this operation MUST be done when we become visible.
              // This is announced by the paint event which is triggered when a Widget
              // really gains visibility, ie is shown or rendered, or it's not hidden,
              // and a hidden/non-rendered ancestor is shown or rendered.
              // See Widget#triggerPaint.
              else if (!me.paintListener) {
                  me.paintListener = me.on({
                    paint: 'onContentChange',
                    once: true,
                    thisObj: me
                  });
                }
            }
            /**
             * Called after headers have been rendered to the headerContainer.
             * This does not do anything, it's just for Features to hook in to.
             * @param {HTMLElement} headerContainer DOM element which contains the headers.
             * @param {HTMLElement} element Grid element
             * @private
             * @category Rendering
             */

          }, {
            key: "renderHeader",
            value: function renderHeader(headerContainer, element) {}
            /**
             * Called after footers have been rendered to the footerContainer.
             * This does not do anything, it's just for Features to hook in to.
             * @param {HTMLElement} footerContainer DOM element which contains the footers.
             * @param {HTMLElement} element Grid element
             * @private
             * @category Rendering
             */

          }, {
            key: "renderFooter",
            value: function renderFooter(footerContainer, element) {}
          }, {
            key: "suspendRefresh",
            value: function suspendRefresh() {
              this.refreshSuspended++;
            }
          }, {
            key: "resumeRefresh",
            value: function resumeRefresh(trigger) {
              if (this.refreshSuspended && ! --this.refreshSuspended) {
                if (trigger) {
                  this.refreshRows();
                }
              }
            }
            /**
             * Rerenders all grid rows, completely replacing all row elements with new ones
             * @category Rendering
             */

          }, {
            key: "renderRows",
            value: function renderRows() {
              var keepScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var returnToTop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  scrollState = keepScroll && me.storeScroll();

              if (me.refreshSuspended) {
                return;
              }
              /**
               * Grid rows are about to be rendered
               * @event beforeRenderRows
               * @param {Grid.view.Grid} grid
               */


              me.trigger('beforeRenderRows');
              me.renderingRows = true; // This allows us to do things like disable animations on a refresh

              me.element.classList.add('b-grid-refreshing'); // remove all row elements from dom (sets innerHTML = '')

              me.callEachSubGrid('clearRows');

              if (returnToTop) {
                me.scrollable.y = me._scrollTop = 0;
              }

              me.rowManager.reinitialize(returnToTop);
              me.renderingRows = false;
              me.onContentChange();

              if (keepScroll) {
                me.restoreScroll(scrollState);
              }

              me.element.classList.remove('b-grid-refreshing');
            }
            /**
             * Rerenders the grids rows, headers and footers, completely replacing all row elements with new ones
             * @category Rendering
             */
            // TODO: Make render call this fn, not very DRY currently

          }, {
            key: "renderContents",
            value: function renderContents() {
              var me = this,
                  element = me.appendTo,
                  headerContainer = me.headerContainer,
                  footerContainer = me.footerContainer;
              me.emptyCache(); // columns will be "drawn" on render anyway, bail out

              if (!me.rendered) return; // reset measured header height, to make next call to get headerHeight measure it

              me._headerHeight = null;
              me.callEachSubGrid('refreshHeader', headerContainer);
              me.callEachSubGrid('refreshFooter', footerContainer); // Note that these are hook methods for features to plug in to. They do not do anything.

              me.renderHeader(headerContainer, element);
              me.renderFooter(footerContainer, element);
              me.fixSizes();
              me.renderRows(false);
            } // Render rows etc. on first paint, to make sure Grids element has been laid out

          }, {
            key: "onPaint",
            value: function onPaint() {
              var me = this,
                  element = me.element,
                  headerContainer = me.headerContainer,
                  bodyContainer = me.bodyContainer,
                  footerContainer = me.footerContainer;

              if (me.rendered) {
                return;
              } // apply any responsive configs before rendering columns and rows


              me.updateResponsive(me.width, 0);
              var maxDepth = 0; // Cached, updated on resize. Used by RowManager and by the subgrids upon their render

              me._bodyRectangle = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_43__["default"].client(me.bodyContainer);
              me.eachSubGrid(function (subGrid) {
                subGrid.render(me.verticalScroller);
              }); // Note that these are hook methods for features to plug in to. They do not do anything.
              // SubGrids take care of their own rendering.

              me.renderHeader(headerContainer, element);
              me.renderFooter(footerContainer, element);

              if (me.autoHeight) {
                me._bodyHeight = me.rowManager.initWithHeight(element.offsetHeight - headerContainer.offsetHeight - footerContainer.offsetHeight, true);
                bodyContainer.style.height = me.bodyHeight + 'px';
              } else {
                me._bodyHeight = me.bodyContainer.offsetHeight;
                me.rowManager.initWithHeight(me._bodyHeight, true);
              }

              me.eachSubGrid(function (subGrid) {
                if (subGrid.header.maxDepth > maxDepth) {
                  maxDepth = subGrid.header.maxDepth;
                }
              });
              headerContainer.dataset.maxDepth = maxDepth;
              me.fixSizes();
              me.renderRows(false);
              me.initScroll();
              me.initInternalEvents();
              me.rendered = true;
            }
          }, {
            key: "render",
            value: function render(target) {
              var me = this; // When displayed inside one of our containers, require a size to be considered visible. Ensures it is painted
              // on display when for example in a tab

              me.requireSize = Boolean(me.owner);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_18___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(Grid.prototype), "render", this).call(this, target); // Sanity check that main element has been given some sizing styles, unless autoHeight is used in which case
              // it will be sized programmatically instead


              if (!me.autoHeight && me.headerContainer.offsetHeight && !me.bodyContainer.offsetHeight) {
                console.warn('Grid element not sized correctly, please check your CSS styles and review how you size the widget');
              }
            } //endregion
            // region Masking

            /**
             * Show a load mask with a spinner and the specified message. When using an AjaxStore masking and unmasking is
             * handled automatically, but if you are loading data in other ways you can call this function manually when your
             * load starts.
             * ```
             * myLoadFunction() {
             *   // Show mask before initiating loading
             *   grid.maskBody('Loading data');
             *   // Your custom loading code
             *   load.then(() => {
             *      // Hide the mask when loading is finished
             *      grid.unmaskBody();
             *   });
             * }
             * ```
             * @param {String} loadMask Message to show next to the spinner
             * @returns {Common.widget.Mask}
             */

          }, {
            key: "maskBody",
            value: function maskBody(loadMask) {
              var me = this;

              if (!me.bodyContainer) {
                return;
              } // remove any existing mask


              me.unmaskBody();

              var _me$activeMask = me.activeMask = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_44__["default"].mask(me.element, loadMask),
                  maskElement = _me$activeMask.maskElement;

              maskElement.style.marginTop = "".concat(me.headerContainer.offsetHeight, "px");
              maskElement.style.marginBottom = "".concat(me.footerContainer.offsetHeight, "px");
              return me.activeMask;
            }
            /**
             * Hide the load mask.
             */

          }, {
            key: "unmaskBody",
            value: function unmaskBody() {
              var me = this;
              me.loadmaskHideTimer && me.clearTimeout(me.loadmaskHideTimer);
              me.loadmaskHideTimer = null;
              me.activeMask && me.activeMask.destroy();
              me.activeMask = null;
            } // endregion

          }, {
            key: "overflowElement",
            get: function get() {
              return this.bodyContainer;
            }
          }, {
            key: "focusElement",
            get: function get() {
              return this.element;
            } //endregion
            //region Columns

          }, {
            key: "columns",
            set: function set(columns) {
              var me = this;

              if (me._columnStore) {
                if (columns) {
                  // TODO: @johan: reconfiguring, ie changing whole column set should work.
                  // That could mean a total recalculation of subGrids.
                  // That's not possible right now, so
                  //throw new Error('Cannot reconfigure column set');
                  // me._columnStore.clear();
                  me._columnStore.data = columns;
                } else {
                  me._columnStore.destroy();
                }
              } else {
                // ColumnStore instance
                if (columns instanceof _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_36__["default"]) {
                  if (!columns.grid) {
                    columns.grid = me;
                  }

                  me._columnStore = columns;
                } // Array of columns
                else if (Array.isArray(columns)) {
                    me._columnStore = new _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_36__["default"]({
                      grid: me,
                      data: columns
                    });
                  } // Store config object
                  else if (columns) {
                      me._columnStore = new _data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_36__["default"](Object.assign({
                        grid: me
                      }, columns));
                    } // changes might be triggered when applying state, before grid is rendered
                // TODO: have this run a lighter weight, non-destructive response.
                // onColumnsChanged is a start, but lots of machinery is hooked to render.


                me._columnStore.on('change', me.onColumnsChanged, me);

                me._columnStore.on(Object(_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_36__["columnResizeEvent"])(me.onColumnsResized, me)); // Add touch class for touch devices


                if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isTouchDevice) {
                  me.touch = true; // apply touchConfig for columns that defines it

                  me._columnStore.forEach(function (column) {
                    var touchConfig = column.touchConfig;

                    if (touchConfig) {
                      column.applyState(touchConfig);
                    }
                  });
                }
              }
            }
            /**
             * Get the {@link Grid.data.ColumnStore ColumnStore} used by this Grid.
             *
             * @property {Grid.data.ColumnStore}
             * @category Common
             * @readonly
             */
            ,
            get: function get() {
              return this._columnStore;
            }
          }, {
            key: "rowManager",
            get: function get() {
              var me = this; // Use row height from CSS if not specified in config. Did not want to turn this into a getter/setter for
              // rowHeight since RowManager will plug its implementation into Grid when created below, and after initial
              // configuration that is what should be used

              if (!me._isRowMeasured) {
                me.measureRowHeight();
              } // RowManager is a plugin, it is configured with its grid as its "client".
              // It uses client.store as its record source.


              return me._rowManager || (me._rowManager = new _row_RowManager_js__WEBPACK_IMPORTED_MODULE_38__["default"]({
                grid: me,
                rowHeight: me.rowHeight,
                rowScrollMode: me.rowScrollMode || 'move',
                autoHeight: me.autoHeight,
                listeners: {
                  changetotalheight: me.onRowManagerChangeTotalHeight,
                  requestscrollchange: me.onRowManagerRequestScrollChange,
                  thisObj: me
                }
              }));
            }
          }, {
            key: "store",
            get: function get() {
              return this._store;
            }
            /**
             * Get/set the store used by this Grid. The setter accepts Store or a configuration object for a store.
             * If the configuration contains a `readUrl`, an AjaxStore will be created.
             * @property {Common.data.Store|Object}
             * @category Common
             */
            ,
            set: function set(store) {
              var me = this,
                  features = me.initialConfig.features;

              if (store !== me._store) {
                if (me.storeDetacher) {
                  me.storeDetacher();
                  me.storeDetacher = null;
                }

                if (store) {
                  if (store instanceof _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_25__["default"]) {} else {
                    var storeCfg = {};

                    if (me.data) {
                      storeCfg.data = me.data;
                    }

                    if (features && features.tree) {
                      storeCfg.tree = true;
                    } // extend GridRowModel to not pollute it with custom fields (if we have multiple grids on page)


                    if (!store.modelClass) {
                      storeCfg.modelClass =
                      /*#__PURE__*/
                      function (_GridRowModel) {
                        _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_19___default()(_class, _GridRowModel);

                        function _class() {
                          _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_14___default()(this, _class);

                          return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_16___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_17___default()(_class).apply(this, arguments));
                        }

                        return _class;
                      }(_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_37__["default"]);
                    }

                    store = new (store.readUrl ? _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_23__["default"] : _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_25__["default"])(Object.assign(storeCfg, store));
                  }

                  me._store = store;
                  me.bindStore(store);
                } else {
                  if (me.destroyStore) {
                    me._store.destroy();
                  }

                  me._store = null;
                }
              }
            }
          }, {
            key: "data",
            get: function get() {
              if (this._store) {
                return this._store.records;
              } else {
                return this._data;
              }
            },
            set: function set(data) {
              if (this._store) {
                this._store.data = data;
              } else {
                this._data = data;
              }
            }
          }, {
            key: "emptyText",
            get: function get() {
              return this._emptyText;
            },
            set: function set(text) {
              this._emptyText = text;
              this.eachSubGrid(function (subGrid) {
                return subGrid.emptyText = text;
              });
            }
          }, {
            key: "bodyHeight",
            get: function get() {
              return this._bodyHeight;
            }
            /**
             * Header height
             * @property {Number}
             * @readonly
             * @category Layout
             */

          }, {
            key: "headerHeight",
            get: function get() {
              var me = this; // measure header if rendered and not stored

              if (me.rendered && !me._headerHeight) {
                me._headerHeight = me.headerContainer.offsetHeight;
              }

              return me._headerHeight;
            }
          }, {
            key: "autoHeight",
            get: function get() {
              return this._autoHeight;
            },
            set: function set(autoHeight) {
              _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_65__["default"].assertBoolean(autoHeight, 'autoHeight');

              this._autoHeight = autoHeight;
            }
            /**
             * Toggle column line visibility. End result might be overruled by/differ between themes.
             * @property {Boolean}
             */

          }, {
            key: "columnLines",
            get: function get() {
              return this._columnLines;
            },
            set: function set(columnLines) {
              _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_65__["default"].assertBoolean(columnLines, 'columnLines');

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].toggleClasses(this.element, 'b-no-column-lines', !columnLines);

              this._columnLines = columnLines;
            } //endregion
            //region ReadOnly

            /**
             * Get/set read only mode, which prevents cell editing etc.
             * Exactly what is prevented is up to each feature.
             * @property {Boolean}
             * @fires readonly
             * @category Common
             */

          }, {
            key: "readOnly",
            set: function set(readOnly) {
              var me = this;
              me._readOnly = readOnly;

              if (me.rendered) {
                /**
                 * Fired when grids read only state is toggled
                 * @event readOnly
                 * @param {Boolean} readOnly Read only or not
                 */
                me.trigger('readOnly', {
                  readOnly: readOnly
                }); // IE11 doesnt support this
                //me.element.classList.toggle('b-readonly', readOnly);

                if (readOnly) {
                  me.element.classList.add('b-readonly');
                } else {
                  me.element.classList.remove('b-readonly');
                }
              }
            },
            get: function get() {
              return this._readOnly;
            }
          }, {
            key: "scrolling",
            set: function set(scrolling) {
              this._scrolling = scrolling;
              this.bodyContainer.classList[scrolling ? 'add' : 'remove']('b-scrolling');
            },
            get: function get() {
              return this._scrolling;
            }
          }, {
            key: "isAnimating",
            get: function get() {
              return this._animating;
            },
            set: function set(value) {
              var me = this;

              if (me.rendered && value !== me.isAnimating) {
                if (value) {
                  me.element.classList.add('b-animating');
                } else {
                  me.element.classList.remove('b-animating');
                }

                me._animating = value;
              }
            }
          }], [{
            key: "getLKey",
            value: function getLKey() {
              return '%LICENSE%';
            }
          }, {
            key: "defaultConfig",
            //region Config
            // Default settings, applied in grids constructor.
            get: function get() {
              return {
                /**
                 * Row height in pixels. When set to null, an empty row will be measured and its height will be used as
                 * default row height, enabling it to be controlled using CSS
                 * @config {Number}
                 * @default null
                 * @category Common
                 */
                rowHeight: null,
                // used if no rowHeight specified and none found in CSS. not public since our themes have row height
                // specified and this is more of an internal failsafe
                defaultRowHeight: 45,

                /**
                 * Text to display when there is no data to display in the grid
                 * @config {String}
                 * @default
                 * @category Common
                 */
                emptyText: this.L('noRows'),

                /**
                 * Refresh entire row when a cells value changes (true) or only the cell (false).
                 * @config {Boolean}
                 * @default
                 * @category Misc
                 */
                fullRowRefresh: true,

                /**
                 * Read only or not
                 * @config {Boolean}
                 * @default false
                 * @category Common
                 */
                readOnly: null,

                /**
                 * True to not create any grid column headers
                 * @config {Boolean}
                 * @default false
                 * @category Misc
                 */
                hideHeaders: null,

                /**
                 * Show "Remove row" item in context menu (if enabled and grid not read only)
                 * @config {Boolean}
                 * @default
                 * @category Misc
                 */
                showRemoveRowInContextMenu: true,

                /**
                 * Automatically set grids height to fit all rows (no scrolling in the grid). In general you should avoid
                 * using `autoHeight: true`, since it will bypass Grids virtual rendering and render all rows at once, which
                 * in a larger grid is really bad for performance.
                 * @config {Boolean}
                 * @default false
                 * @category Layout
                 */
                autoHeight: null,

                /**
                 * Store that holds records to display in the grid, or a store config object.
                 * A store will be created if none is specified
                 * @config {Common.data.Store/Object}
                 * @category Common
                 */
                store: {},

                /**
                 * Data to set in grids store (a Store will be created if none is specified)
                 * @config {Object[]}
                 * @category Common
                 */
                data: null,

                /**
                 * Column definitions for the grid, will be used to create Column instances that are added to a ColumnStore:
                 *
                 * ```
                 * new Grid({
                 *   columns : [
                 *     { text : 'Alias', field : 'alias' },
                 *     { text : 'Superpower', field : 'power' }
                 *   ]
                 * });
                 * ```
                 *
                 * Also accepts a store config object:
                 *
                 * ```
                 * new Grid({
                 *   columns : {
                 *     data : [
                 *       { text : 'Alias', field : 'alias' },
                 *       { text : 'Superpower', field : 'power' }
                 *     ],
                 *     listeners : {
                 *       update() {
                 *         // Some update happened
                 *       }
                 *     }
                 *   }
                 * });
                 * ```
                 *
                 * This store can be accessed using {@link #property-columns}:
                 *
                 * ```
                 * grid.columns.add({ field : 'column', text : 'New column' });
                 * ```
                 * @config {Object[]|Object}
                 * @category Common
                 */
                columns: [],

                /**
                 * Region to which columns are added when they have none specified
                 * @config {String}
                 * @default
                 * @category Misc
                 */
                defaultRegion: 'normal',

                /**
                 * true to destroy the store when the grid is destroyed
                 * @config {Boolean}
                 * @default false
                 * @category Misc
                 */
                destroyStore: null,

                /**
                 * Default selection settings
                 * @config {Object}
                 * @default
                 * @category Selection
                 */
                selectionMode: {
                  row: true,
                  cell: true,
                  multiSelect: true,
                  checkbox: false
                },

                /**
                 * Set to true to allow text selection in the grid cells
                 * @config {Boolean}
                 * @default false
                 * @category Selection
                 */
                enableTextSelection: null,

                /**
                 * A message to be shown when a store is performing a remote operation.
                 * @config {String}
                 * @default "Loading..."
                 * @category Misc
                 */
                loadMask: this.L('loadMask'),

                /**
                 * Set to `false` to inhibit column lines
                 * @config {Boolean}
                 * @default
                 * @category Misc
                 */
                columnLines: true,

                /**
                 * Set to `true` to stretch the last column in a grid with all fixed width columns
                 * to fill extra available space if the grid's width is wider than the sum of all
                 * configured column widths.
                 * @config {Boolean}
                 * @default
                 * @category Layout
                 */
                fillLastColumn: true,

                /**
                 * Set to `false` to only measure cell contents when double clicking the edge between column headers.
                 * @config {Boolean}
                 * @default
                 * @category Layout
                 */
                resizeToFitIncludesHeader: true,

                /**
                 * Set to `false` to prevent remove row animation and remove the delay related to that.
                 * @config {Boolean}
                 * @default
                 * @category Misc
                 */
                animateRemovingRows: !_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].isIE11,
                // IE11 doesn't have reliable firing of transitionend

                /**
                 * Set to `true` to not get a warning when using another base class than GridRowModel for your grid data. If
                 * you do, and would like to use the full feature set of the grid then include the fields from GridRowModel
                 * in your model definition.
                 * @config {Boolean}
                 * @default false
                 * @category Misc
                 */
                disableGridRowModelWarning: null,
                loadMaskErrorIcon: 'b-icon b-icon-warning',
                headerClass: _Header_js__WEBPACK_IMPORTED_MODULE_41__["default"],
                testPerformance: false,
                // TODO: break out as strategies
                positionMode: 'translate',
                // translate, translate3d, position
                rowScrollMode: 'move',
                // move, dom, all

                /**
                 * Grid monitors window resize by default.
                 * @config {Boolean}
                 * @default true
                 * @category Misc
                 */
                monitorResize: true,

                /**
                 * An object containing Feature configuration objects (or `true` if no configuration is required)
                 * keyed by the Feature class name in all lowercase.
                 * @config {Object}
                 * @category Common
                 * @typings any
                 */
                features: true,

                /**
                 * An object containing sub grid configuration objects keyed by a `region` property.
                 * By default, grid has a 'locked' region (if configured with locked columns) and a 'normal' region.
                 * The 'normal' region defaults to use `flex: 1`.
                 *
                 * This config can be used to reconfigure the "built in" sub grids or to define your own.
                 * ```
                 * // Redefining the "built in" regions
                 * new Grid({
                 *   subGridConfigs : {
                 *     locked : { flex : 1 },
                 *     normal : { width : 100 }
                 *   }
                 * });
                 *
                 * // Defining your own multi region sub grids
                 * new Grid({
                 *   subGridConfigs : {
                 *     left   : { width : 100 },
                 *     middle : { flex : 1 },
                 *     right  : { width  : 100 }
                 *   },
                 *
                 *   columns : {
                 *     { field : 'manufacturer', text: 'Manufacturer', region : 'left' },
                 *     { field : 'model', text: 'Model', region : 'middle' },
                 *     { field : 'year', text: 'Year', region : 'middle' },
                 *     { field : 'sales', text: 'Sales', region : 'right' }
                 *   }
                 * });
                 * ```
                 * @config {Object}
                 * @category Misc
                 */
                subGridConfigs: {
                  normal: {
                    flex: 1
                  }
                },

                /**
                 * Configures whether the grid is scrollable in the `Y` axis. This is used to configure a {@link Grid.util.GridScroller}.
                 * See the {@link #config-scrollerClass} config option.
                 * @config {Object}
                 * @category Scrolling
                 */
                scrollable: {
                  // Just Y for now until we implement a special grid.view.Scroller subclass
                  // Which handles the X scrolling of subgrids.
                  overflowY: true
                },

                /**
                 * The class to instantiate to use as the {@link #config-scrollable}. Defaults to {@link Grid.util.GridScroller}.
                 * @config {Common.helper.util.Scroller}
                 * @internal
                 * @category Scrolling
                 */
                scrollerClass: _util_GridScroller_js__WEBPACK_IMPORTED_MODULE_40__["default"],

                /**
                 * Configure as `true` to have the grid show a red "changed" tag in cells who's
                 * field value has changed and not yet been committed.
                 * @config {Boolean}
                 * @default false
                 * @category Misc
                 */
                showDirty: null,
                loadMaskHideTimeout: 3000,
                refreshSuspended: 0,
                transitionDuration: 500,

                /**
                 * Event which is used to show context menus.
                 * Available options are: 'contextmenu', 'click', 'dblclick'.
                 * Default value is 'contextmenu'
                 * @config {String}
                 */
                contextMenuTriggerEvent: 'contextmenu' // Grid requires a size to be considered visible
                //requireSize : true

              };
            }
          }, {
            key: "properties",
            get: function get() {
              return {
                _selectedRecords: [],
                _verticalScrollHeight: 0,
                virtualScrollHeight: 0,
                _scrollTop: null
              };
            }
          }]);

          return Grid;
        }(Object(_Common_helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_28__["base"])(_Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_35__["default"]).mixes(_Common_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_33__["default"], _Common_mixin_State_js__WEBPACK_IMPORTED_MODULE_34__["default"], _mixin_GridElementEvents_js__WEBPACK_IMPORTED_MODULE_46__["default"], _mixin_GridFeatures_js__WEBPACK_IMPORTED_MODULE_47__["default"], _mixin_GridNavigation_js__WEBPACK_IMPORTED_MODULE_48__["default"], _mixin_GridResponsive_js__WEBPACK_IMPORTED_MODULE_49__["default"], _mixin_GridSelection_js__WEBPACK_IMPORTED_MODULE_50__["default"], _mixin_GridState_js__WEBPACK_IMPORTED_MODULE_51__["default"], _mixin_GridSubGrids_js__WEBPACK_IMPORTED_MODULE_52__["default"]));

        Grid._$name = 'Grid';

        _Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_22__["default"].register('grid', Grid);

        _Common_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].setVersion('grid', '2.2.4');
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/Header.js":
      /*!***************************************!*\
        !*** ../Grid/lib/Grid/view/Header.js ***!
        \***************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewHeaderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Header;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Bar_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./Bar.js */
        "../Grid/lib/Grid/view/Bar.js");
        /* harmony import */


        var _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/util/DomClassList.js */
        "../Grid/lib/Common/helper/util/DomClassList.js");

        function _templateObject2() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4___default()(["\n                <div class=\"b-grid-header\" data-column=\"", "\" data-column-id=\"", "\" ", ">\n                    <div class=\"b-grid-header-text\">\n                        <div class=\"b-grid-header-text-content\"></div>\n                    </div>\n                    ", "\n                    <div class=\"b-grid-header-resize-handle\"></div>\n                </div>\n            "]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_4___default()(["\n            <div class=\"b-grid-header-scroller b-grid-header-scroller-", "\">\n                <div reference=\"headersElement\" class=\"b-grid-headers b-grid-headers-", "\" data-region=\"", "\" data-max-depth=\"", "\" reference=\"headersElement\"></div>\n            </div>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Grid/view/Header
         */

        /**
         * The Grid header, which contains simple columns but also allows grouped columns. One instance is created and used per SubGrid
         * automatically, you should not need to instantiate this class manually. See {@link Grid.column.Column} for information about
         * column configuration.
         *
         * @extends Grid/view/Bar
         * @internal
         *
         * @externalexample grid/Header.js
         */

        var Header =
        /*#__PURE__*/
        function (_Bar) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(Header, _Bar);

          function Header() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, Header);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Header).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(Header, [{
            key: "startConfigure",
            value: function startConfigure(config) {
              config.scrollable.overflowX = 'hidden-scroll';

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Header.prototype), "startConfigure", this).call(this, config);
            }
          }, {
            key: "template",
            value: function template() {
              var me = this,
                  region = me.region;
              return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].tpl(_templateObject(), region, region, region, me.maxDepth);
            }
          }, {
            key: "contentTemplate",

            /**
             * Header template, recursive template for column headers.
             * Style not included because of CSP. Widths are fixed up in
             * {@link #function-fixHeaderWidths}
             * @private
             */
            value: function contentTemplate(column) {
              var me = this;

              if (column.hidden) {
                return '';
              } else {
                /* eslint-disable */
                return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].tpl(_templateObject2(), column.field, column.id, column.isLeaf ? 'tabindex="0"' : '', column.children ? "\n                    <div class=\"b-grid-header-children\">\n                            ".concat(column.children.map(function (child) {
                  return me.contentTemplate(child);
                }).join(''), "\n                    </div>\n                    ") : '');
                /* eslint-enable */
              }
            } // used by safari to fix flex when rows width shrink below this value

          }, {
            key: "calculateMinWidthForSafari",
            value: function calculateMinWidthForSafari() {
              var minWidth = 0,
                  columns = this.columns.visibleColumns;
              columns.forEach(function (column) {
                minWidth += column.calculateMinWidth();
              });
              return minWidth;
            }
            /**
             * Fix header widths (flex or fixed width) after rendering. Not a part of template any longer because of CSP
             * @private
             */

          }, {
            key: "fixHeaderWidths",
            value: function fixHeaderWidths() {
              this.fixCellWidths();
            }
          }, {
            key: "refreshHeaders",
            value: function refreshHeaders() {
              var me = this; // run renderers, not done from template to work more like cell rendering

              me.columns.traverse(function (column) {
                var headerElement = me.getBarCellElement(column.id);

                if (headerElement) {
                  var _ref;

                  var classList = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_14__["default"]((_ref = {
                    'b-grid-header': 1,
                    'b-grid-header-parent': column.isParent
                  }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_ref, "b-level-".concat(column.childLevel), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_ref, "b-depth-".concat(column.meta.depth), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_ref, "b-grid-header-align-".concat(column.align), column.align), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_ref, 'b-grid-header-resizable', column.resizable && column.isLeaf), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_ref, column.cls, column.cls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_ref, 'b-last-parent', column.isParent && column.isLastInSubGrid), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_ref, 'b-last-leaf', column.isLeaf && column.isLastInSubGrid), _ref));
                  var html = column.text;
                  headerElement.className = classList;

                  if (column.headerRenderer) {
                    html = column.headerRenderer.call(column.thisObj || me, {
                      column: column,
                      headerElement: headerElement
                    });
                  }

                  if (column.icon) {
                    html = "<i class=\"".concat(column.icon, "\"></i>") + (html || '');
                  }

                  var innerEl = headerElement.querySelector('.b-grid-header-text-content');

                  if (innerEl) {
                    innerEl.innerHTML = html || '';
                  }
                }
              });
              me.fixHeaderWidths();
            }
          }, {
            key: "initDepths",

            /**
             * Depths are used for styling of grouped headers. Sets them on meta.
             * @private
             */
            value: function initDepths() {
              var columns = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.columns;
              var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var me = this,
                  maxDepth = 0;
              if (parent && parent.meta) parent.meta.depth++;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var column = _step.value; // TODO: this should maybe move

                  column.meta.depth = 0;

                  if (column.children) {
                    me.initDepths(column.children, column);
                    if (column.meta.depth && parent) parent.meta.depth += column.meta.depth;
                  }

                  if (column.meta.depth > maxDepth) maxDepth = column.meta.depth;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              if (!parent) {
                this.maxDepth = maxDepth;
              }

              return maxDepth;
            } //endregion
            //region Getters

            /**
             * Get the header cell element for the specified column.
             * @param {String} columnId Column id
             * @returns {HTMLElement} Header cell element
             */

          }, {
            key: "getHeader",
            value: function getHeader(columnId) {
              return this.getBarCellElement(columnId);
            } //endregion

          }, {
            key: "refreshContent",
            value: function refreshContent() {
              var me = this;
              me.content = me.columns.map(function (col) {
                return me.contentTemplate(col);
              }).join('');
              me.refreshHeaders();
            }
          }, {
            key: "render",
            value: function render(appendToElement) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Header.prototype), "render", this).call(this, appendToElement);

              this.refreshContent();
            }
          }, {
            key: "subGrid",
            get: function get() {
              return this._subGrid;
            },
            set: function set(subGrid) {
              this._subGrid = subGrid;
              this.id = subGrid.id + '-header';
            }
          }, {
            key: "region",
            get: function get() {
              return this.subGrid && this.subGrid.region;
            }
          }, {
            key: "overflowElement",
            get: function get() {
              return this.headersElement;
            }
          }, {
            key: "columns",
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Header.prototype), "columns", this);
            },
            set: function set(columns) {
              var me = this;
              me.columnsDetacher && me.columnsDetacher();

              if (columns) {
                // columns is a chained store, it will be repopulated from master when columns change.
                // That action always triggers change with action dataset.
                me.columnsDetacher = columns.on({
                  change: function change() {
                    this.initDepths();
                  },
                  thisObj: me
                });
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(Header.prototype), "columns", columns, this, true);

              me.initDepths();
            }
          }, {
            key: "contentElement",
            get: function get() {
              return this.element.firstElementChild;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                isHeader: true
              };
            }
          }]);

          return Header;
        }(_Bar_js__WEBPACK_IMPORTED_MODULE_12__["default"]);

        Header._$name = 'Header';
        /***/
      },

      /***/
      "../Grid/lib/Grid/view/SubGrid.js":
      /*!****************************************!*\
        !*** ../Grid/lib/Grid/view/SubGrid.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewSubGridJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return SubGrid;
        });
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "../Grid/node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "../Grid/node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "../Grid/node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/asyncToGenerator */
        "../Grid/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _column_Column_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../column/Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _util_SubGridScroller_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../util/SubGridScroller.js */
        "../Grid/lib/Grid/util/SubGridScroller.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../../Common/helper/util/Scroller.js */
        "../Grid/lib/Common/helper/util/Scroller.js");

        function _templateObject3() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7___default()(["\n            <div class=\"b-grid-row\">\n                ", "\n            </div>\n        "]);

          _templateObject3 = function _templateObject3() {
            return data;
          };

          return data;
        }

        function _templateObject2() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7___default()(["\n                <div reference=\"splitterElement\" data-region=\"", "\" class=\"", "\">\n                    <div class=\"b-grid-splitter-inner\"></div>\n                    <i class=\"b-icon b-icon-collapse-gridregion\"></i>\n                    <i class=\"b-icon b-icon-expand-gridregion\"></i>\n                </div>"]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_7___default()(["\n            <div class=\"b-grid-subgrid b-grid-subgrid-", " b-grid-horizontal-scroller\" data-region=\"", "\">\n                <div reference=\"virtualScrollerElement\" class=\"b-virtual-scroller\" data-region=\"", "\">\n                    <div reference=\"virtualScrollerWidth\" class=\"b-virtual-width\"></div>\n                </div>\n                ", "\n            </div>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Grid/view/SubGrid
         */

        /**
         * A SubGrid is a part of the grid (it has at least one and normally no more than two, called locked and normal). It
         * has its own header, which holds the columns to display rows for in the SubGrid. SubGrids are created by Grid, you
         * should not need to create instances directly.
         *
         * If not configured with a width or flex, the SubGrid will be sized to fit its columns. In this case, if all columns
         * have a fixed width (not using flex) then toggling columns will also affect the width of the SubGrid.
         *
         * @extends Common/widget/Widget
         */

        var SubGrid =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(SubGrid, _Widget);

          function SubGrid() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, SubGrid);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(SubGrid, [{
            key: "construct",
            //endregion
            //region Init

            /**
             * SubGrid constructor
             * @param config
             * @private
             */
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid.prototype), "construct", this).call(this, config);

              me.initHeader();
              me.rowManager.on('addrows', me.onAddRow, me);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.header && me.header.destroy();
              me.footer && me.footer.destroy();
              me.fakeScroller && me.fakeScroller.destroy();
              me.virtualScrollerElement && me.virtualScrollerElement.remove();
              me.splitterElement && me.splitterElement.remove();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid.prototype), "doDestroy", this).call(this);
            }
            /**
             * Creates a header for the SubGrid
             * @private
             */

          }, {
            key: "initHeader",
            value: function initHeader() {
              var me = this,
                  config = Object.assign({
                subGrid: me,
                columns: me.columns,
                hidden: me.hideHeaders,
                parent: me // Contained widgets need to know their parents

              }, me.headerConfig);
              me.header = new me.headerClass(config);
            }
            /**
             * Initializes elements for the SubGrid and its header and footer (if any)
             * @private
             */

          }, {
            key: "initElements",
            value: function initElements() {
              var me = this;
              me.footerElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].down(me.grid.element, '.b-grid-footer-scroller-' + me.region);
              me.updateHasFlex();
            } //endregion
            //region Template

          }, {
            key: "template",
            value: function template() {
              var grid = this.grid,
                  region = this.region,
                  isLastSubGrid = !grid || region === grid.regions[grid.regions.length - 1],
                  splitterCls = "b-grid-splitter".concat(_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isIE11 ? ' b-grid-splitter-transform' : ''); // The virtual scroller element in the template below will be moved to the virtual scroller container in grid on
              // render. It is defined as part of the SubGrid template to get references for free
              // Same applies to the splitter. Except for the last SubGrid, it does not have a splitter

              return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].tpl(_templateObject(), region, region, region, isLastSubGrid ? '' : _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].tpl(_templateObject2(), region, splitterCls));
            }
          }, {
            key: "rowTemplate",
            value: function rowTemplate() {
              var me = this;
              return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].tpl(_templateObject3(), me.columns.visibleColumns.map(me.cellTemplate, me));
            }
          }, {
            key: "cellTemplate",
            value: function cellTemplate(column) {
              return "<div class=\"b-grid-cell\" data-column=\"".concat(column.field, "\" data-column-id=\"").concat(column.id, "\"></div>");
            } //endregion
            //region Render

          }, {
            key: "onPaint",
            value: function onPaint() {
              var me = this;

              if (!me.rendered) {
                var grid = me.grid,
                    splitter = grid && grid.resolveSplitter(me); // Unit tests create naked SubGrids so we have to do this.

                if (grid) {
                  // Move virtual scroller & splitter to grids container for them
                  grid.virtualScrollers.appendChild(me.virtualScrollerElement);
                  me.splitterElement && grid.element.appendChild(me.splitterElement);
                  me.renderHeader(grid.headerContainer);
                  me.renderFooter(grid.footerContainer);
                  me.initElements();
                }

                me.syncSplitter(true);
                me.splitterWidth = splitter && splitter.offsetWidth || 1;
                me._collapsed && me.collapse();
                me.rendered = true;
              }
            }
          }, {
            key: "renderHeader",
            value: function renderHeader(appendToElement) {
              if (this.header) {
                this.header.render(appendToElement);
              }
            }
          }, {
            key: "renderFooter",
            value: function renderFooter(appendToElement) {
              if (this.footer) {
                this.footer.render(appendToElement); // footerContainer starts hidden, since it is not used by default. make sure it is visible here

                this.grid.footerContainer.classList.remove('b-hidden');
              }
            }
          }, {
            key: "refreshHeader",
            value: function refreshHeader() {
              this.header.refreshContent();
            }
          }, {
            key: "refreshFooter",
            value: function refreshFooter() {
              this.footer && this.footer.refreshContent();
            } //endregion
            //region Size & resize

            /**
             * Sets cell widths. Cannot be done in template because of CSP
             * @private
             */

          }, {
            key: "fixCellWidths",
            value: function fixCellWidths(rowElement) {
              var visibleColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              if (!visibleColumns) visibleColumns = this.columns.bottomColumns.filter(function (col) {
                return !col.hidden;
              }); // fix cell widths, no longer allowed in template because of CSP

              var cellElement = rowElement.firstElementChild,
                  i = 0;

              while (cellElement) {
                var column = visibleColumns[i];

                if (column.minWidth) {
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].setLength(cellElement, 'minWidth', column.minWidth);
                } // either flex or width, flex has precedence


                if (column.flex) {
                  cellElement.style.flex = column.flex;
                  cellElement.style.width = '';
                } else if (column.width) {
                  // https://app.assembla.com/spaces/bryntum/tickets/8041
                  // Although header and footer elements must be sized
                  // using flex-basis to avoid the busting out problem,
                  // grid cells MUST be sized using width since rows are absolutely
                  // positioned and will not cause the busting out problem,
                  // and rows will not stretch to shrinkwrap the cells
                  // unless they are widthed with width.
                  cellElement.style.flex = '';
                  cellElement.style.width = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].setLength(column.width); // IE11 calculates flexbox container width based on min-width rather than actual width. When column
                  // has width defined greater than minWidth, row may have incorrect width

                  if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isIE11) {
                    cellElement.style.minWidth = cellElement.style.width;
                  }
                } else {
                  cellElement.style.flex = cellElement.style.width = cellElement.style.minWidth = '';
                }

                cellElement = cellElement.nextElementSibling;
                i++;
              }
            }
          }, {
            key: "fixWidths",

            /**
             * Sets header width and scroller width (if needed, depending on if using flex). Might also change the subgrids
             * width, if it uses a width calculated from its columns.
             * @private
             */
            value: function fixWidths() {
              var me = this,
                  element = me.element,
                  header = me.header,
                  footer = me.footer;

              if (me.flex) {
                header.flex = me.flex;

                if (footer) {
                  footer.flex = me.flex;
                }

                element.style.flex = me.flex;
              } else {
                // If width is calculated and no column is using flex, check if total width is less than width. If so,
                // recalculate width and bail out of further processing (since setting width will trigger again)
                if (me.hasCalculatedWidth && !me.columns.some(function (col) {
                  return !col.hidden && col.flex;
                }) && me.totalFixedWidth !== me.width) {
                  me.width = me.totalFixedWidth; // Setting width above clears the hasCalculatedWidth flag, but we want to keep it set to react correctly
                  // next time

                  me.hasCalculatedWidth = true;
                  return;
                }

                var totalWidth = me.width;

                if (!totalWidth) {
                  totalWidth = 0; // summarize column widths, needed as container width when not using flex widths and for correct
                  // overflow check in Edge

                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = me.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var col = _step.value;
                      if (!col.flex && !col.hidden) totalWidth += col.width;
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                } // rows are absolutely positioned, meaning that their width won't affect container width
                // hence we must set it, if not using flex


                element.style.width = "".concat(totalWidth, "px");
                header.width = totalWidth;

                if (footer) {
                  footer.width = totalWidth;
                }
              }

              me.syncScrollingPartners(false);
            } // Safari/Edge do not shrink cells the same way as chrome & ff does without having a width set on the row

          }, {
            key: "fixRowWidthsInSafariEdge",
            value: function fixRowWidthsInSafariEdge() {
              if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isSafari || _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isEdge) {
                var me = this,
                    region = me.region,
                    header = me.header,
                    minWidth = header.calculateMinWidthForSafari(); // fix row widths for safari, it does not size flex cells correctly at small widths otherwise.
                // there should be a css solution, but I have failed to find it

                me.rowManager.forEach(function (row) {
                  // This function runs on resize and rendering a SubGrid triggers a resize. When adding a new SubGrid
                  // on the fly elements wont exists for it yet, so ignore...
                  var element = row.getElement(region); // it is worth noting that setting a width does not prevent the row from growing beyond that with
                  // when making view wider, it is used in flex calculation more like a min-width

                  if (element) {
                    element.style.width = "".concat(minWidth, "px");
                  }
                });
                header.headersElement.style.width = "".concat(minWidth, "px");
              }
            }
            /**
             * Get/set SubGrid width, which also sets header and footer width (if available).
             * @property {Number}
             */

          }, {
            key: "onInternalResize",

            /**
             * Called when grid changes size. SubGrid determines if it has changed size and triggers scroll (for virtual
             * rendering in cells to work when resizing etc.)
             * @private
             */
            value: function onInternalResize(element, newWidth, newHeight, oldWidth, oldHeight) {
              var me = this,
                  grid = me.grid; // Widget caches dimensions

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid.prototype), "onInternalResize", this).call(this, element, newWidth, newHeight, oldWidth, oldHeight); // Unit tests create naked SubGrids so we have to do this.


              if (grid && newWidth !== oldWidth) {
                // trigger scroll, in case anything is done on scroll it needs to be done now also
                grid.trigger('horizontalScroll', {
                  subGrid: me,
                  grid: grid,
                  scrollLeft: me.scrollable.x
                });
                me.refreshFakeScroll(); // Do not sync splitters while rendering, they need to be synced after render to appear at correct positions

                if (grid.rendered) {
                  // One subgrid changing size might affect others, make sure splitters are at correct locations
                  grid.eachSubGrid(function (subGrid) {
                    return subGrid.syncSplitter();
                  });
                }

                me.fixRowWidthsInSafariEdge(); // This was originally triggered from within syncSplitters(). Moved it here since now syncing all splitters

                me.trigger('afterInternalResize', me);
              }
            }
          }, {
            key: "syncSplitter",
            value: function syncSplitter() {
              var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var element = this.element,
                  splitterElement = this.splitterElement;

              if (splitterElement) {
                splitterElement.style.left = "".concat(element.offsetLeft + (this.collapsed && !initial ? 0 : element.offsetWidth), "px");
              }
            }
            /**
             * Get the "viewport" for the SubGrid as a Rectangle
             * @property {Common.helper.util.Rectangle}
             * @readonly
             */

          }, {
            key: "updateHasFlex",

            /**
             * Called when updating column widths to apply 'b-has-flex' which is used when fillLastColumn is configured.
             * @internal
             */
            value: function updateHasFlex() {
              var hasFlex = this.columns.visibleColumns.some(function (column) {
                return column.flex;
              });

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].toggleClasses(this.element, ['b-has-flex'], hasFlex);
            } //endregion
            //region Scroll

            /**
             * Fixes widths of fake scrollers
             * @private
             */

          }, {
            key: "refreshFakeScroll",
            value: function refreshFakeScroll() {
              var me = this,
                  element = me.element,
                  virtualScrollerElement = me.virtualScrollerElement,
                  virtualScrollerWidth = me.virtualScrollerWidth,
                  scroller = me.scrollable; // Use a fixed scroll width if grid is empty, to make it scrollable without rows
              // https://app.assembla.com/spaces/bryntum/tickets/7184

              scroller.scrollWidth = me.store.count ? null : me.totalFixedWidth;
              virtualScrollerElement.style.width = "".concat(element.offsetWidth, "px"); //if (BrowserHelper.isEdge) {
              // Needed for Edge, it does not size correctly

              if (me.totalFixedWidth > scroller.clientWidth) {
                element.classList.add('b-overflowing-horizontally');
              } else {
                element.classList.remove('b-overflowing-horizontally');
              } //}
              // This is if *this* subGrid has horizontal overflow
              // +1 is for Edge, it messes up otherwise


              if (scroller.scrollWidth > scroller.clientWidth + (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isEdge ? 1 : 0)) {
                virtualScrollerWidth.style.width = "".concat(scroller.scrollWidth, "px");
                me.header.element.classList.add('b-overflowing');
                me.footer && me.footer.element.classList.add('b-overflowing');
                me.overflowingHorizontally = true; // If *any* SubGrids have horizontal overflow, the main grid
                // has to show its virtual horizontal scollbar.

                me.grid.virtualScrollers.classList.remove('b-hide-display');
              } else {
                virtualScrollerWidth.style.width = 0;
                me.header.element.classList.remove('b-overflowing');
                me.footer && me.footer.element.classList.remove('b-overflowing');
                me.overflowingHorizontally = false;
              }
            }
            /**
             * Init scroll syncing for header and footer (if available).
             * @private
             */

          }, {
            key: "initScroll",
            value: function initScroll() {
              var me = this,
                  scroller = me.scrollable,
                  virtualScrollerElement = me.virtualScrollerElement;

              if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isFirefox) {
                scroller.element.addEventListener('wheel', function (event) {
                  if (event.deltaX) {
                    scroller.x += event.deltaX;
                    event.preventDefault();
                  }
                });
              }

              scroller.yScroller = me.grid.scrollable; // Add our Scroller to the controlling GridScroller

              scroller.yScroller.addScroller(scroller); // Create a Scroller for the fake horizontal scrollbar so that it can partner

              me.fakeScroller = new _Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_23__["default"]({
                element: virtualScrollerElement,
                overflowX: true
              }); // Fire horizontalscroll when our xScroller reports a scroll

              scroller.on('scroll', me.createOnFrame(me.syncScrollingPartners));
              scroller.on('scrollend', function () {
                me.scrolling = false;
              });
              scroller.addPartner(me.fakeScroller, 'x');

              if (me.header) {
                scroller.addPartner(me.header.scrollable, 'x');
              }

              if (me.footer) {
                scroller.addPartner(me.footer.scrollable, 'x');
              }
            }
          }, {
            key: "syncScrollingPartners",

            /**
             * This syncs the horizontal scroll position of the header and the footer with
             * the horizontal scroll position of the grid. Usually, this will be called automatically
             * when the grid scrolls. In some cases, such as a refresh caused by column changes
             * it will need to be called from elsewhere.
             * @internal
             */
            value: function syncScrollingPartners() {
              var addCls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var subGrid = this,
                  grid = subGrid.grid,
                  scrollLeft = subGrid.scrollable.x;

              if (!subGrid.scrolling && addCls) {
                subGrid.scrolling = true;
              }

              grid.trigger('horizontalScroll', {
                subGrid: subGrid,
                grid: grid,
                scrollLeft: scrollLeft
              });
            }
            /**
             * Scrolls a column into view (if it is not already). Called by Grid#scrollColumnIntoView, use it instead to not
             * have to care about which SubGrid contains a column.
             * @param {Grid.column.Column|String|Number} column Column name (data) or column index or actual column object.
             * @param {Object} [options] How to scroll.
             * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
             * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
             * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
             * or the number of milliseconds to animate over, or an animation config object.
             * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
             * @param {String} [options.animate.easing] The name of an easing function.
             * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
             * @param {Boolean} [options.focus] Set to `true` to focus the element when it is in view.
             * @returns {Promise} If the column exists, a promise which is resolved when the column header element has been scrolled into view.
             */

          }, {
            key: "scrollColumnIntoView",
            value: function scrollColumnIntoView(column, options) {
              var me = this,
                  scroller = me.header.scrollable; // Allow column,column id,or column index to be passed

              column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_20__["default"] ? column : me.columns.get(column) || me.columns.getById(column) || me.columns.getAt(column);

              if (column) {
                // Get the current column header element.
                var columnHeaderElement = me.header.getHeader(column.id);

                if (columnHeaderElement) {
                  return scroller.scrollIntoView(_Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__["default"].from(columnHeaderElement, null, true), options);
                }
              }
            } //endregion
            //region Rows

            /**
             * Creates elements for the new rows when RowManager has determined that more rows are needed
             * @private
             */

          }, {
            key: "onAddRow",
            value: function onAddRow(_ref) {
              var rows = _ref.rows;
              var me = this,
                  html = me.rowTemplate(),
                  visibleColumns = me.columns.bottomColumns.filter(function (col) {
                return !col.hidden;
              }),
                  frag = document.createDocumentFragment();
              rows.forEach(function (row) {
                var rowElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createElementFromTemplate(html);

                frag.appendChild(rowElement);
                row.addElement(me.region, rowElement); // TODO: Stamp the correct width into the cells on creation

                me.fixCellWidths(rowElement, visibleColumns);
              });
              me.fixRowWidthsInSafariEdge(); // Put the row elements into the SubGrid en masse.
              // If 2nd param is null, insertBefore appends.

              me.element.insertBefore(frag, me.insertRowsBefore);
            }
            /**
             * Get all row elements for this SubGrid.
             * @returns {HTMLElement[]} Row elements
             * @readonly
             */

          }, {
            key: "clearRows",

            /**
             * Removes all row elements from the subgrids body and empties cache
             * @private
             */
            value: function clearRows() {
              this.emptyCache();
              var all = this.element.querySelectorAll('.b-grid-row'),
                  range = document.createRange();

              if (all.length) {
                range.setStartBefore(all[0]);
                range.setEndAfter(all[all.length - 1]);
                range.deleteContents();
              }
            } // only called when RowManager.rowScrollMode = 'dom', which is not intended to be used

          }, {
            key: "addNewRowElement",
            value: function addNewRowElement() {
              var rowElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].append(this.element, this.rowTemplate());

              this.fixCellWidths(rowElement);
              return rowElement;
            }
          }, {
            key: "toggleTransitionClasses",
            //endregion
            // region Expand/collapse
            // All usages are commented, uncomment when this is resolved: https://app.assembla.com/spaces/bryntum/tickets/5472
            value: function toggleTransitionClasses() {
              var doRemove = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  grid = me.grid,
                  nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)),
                  splitter = grid.resolveSplitter(nextRegion);
              nextRegion.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
              nextRegion.header.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
              me.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
              me.header.element.classList[doRemove ? 'remove' : 'add']('b-grid-subgrid-animate-collapse');
              splitter.classList[doRemove ? 'remove' : 'add']('b-grid-splitter-animate');
            }
            /**
             * Get/set collapsed state
             * @property {Boolean}
             */

          }, {
            key: "collapse",

            /**
             * Collapses subgrid. If collapsing subgrid is the only one expanded, next subgrid to the right (or previous) will
             * be expanded.
             *
             * @example
             * let locked = grid.getSubGrid('locked');
             * locked.collapse().then(() => {
             *     console.log(locked.collapsed); // Logs 'True'
             * });
             *
             * let normal = grid.getSubGrid('normal');
             * normal.collapse().then(() => {
             *     console.log(locked.collapsed); // Logs 'False'
             *     console.log(normal.collapsed); // Logs 'True'
             * });
             *
             * @async
             * @returns {Promise} A Promise which resolves when this SubGrid is fully collapsed.
             */
            value: function () {
              var _collapse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee() {
                var me, collapsedWidth, grid, nextRegion, expandedRegions;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        me = this, collapsedWidth = me.collapsedStateWidth, grid = me.grid, nextRegion = grid.getSubGrid(grid.getNextRegion(me.region)); // Count all expanded regions. Grid must have always have at least one expanded

                        expandedRegions = 0;
                        grid.eachSubGrid(function (subGrid) {
                          subGrid !== me && !subGrid._collapsed && ++expandedRegions;
                        }); // Current region is the only one expanded, expand next region

                        if (!(expandedRegions === 0)) {
                          _context.next = 6;
                          break;
                        }

                        _context.next = 6;
                        return nextRegion.expand();

                      case 6:
                        return _context.abrupt("return", new Promise(function (resolve) {
                          if (!me._beforeCollapseState) {
                            me._beforeCollapseState = {};
                            var widthChanged = false; // If current width matches width expected after collapse (probably very narrow region plus wide collapse
                            // placeholder) resize event will not be fired. In such case we want to trigger callback immediately

                            if (me.width !== collapsedWidth) {
                              widthChanged = true; // Toggle transition classes here, we will actually change width below
                              // me.toggleTransitionClasses();
                              // afterinternalresize event is buffered, it will be fired only once after animation is finished
                              // and element size is final

                              me.on({
                                afterinternalresize: function afterinternalresize() {
                                  // me.toggleTransitionClasses(true);
                                  resolve(me);
                                },
                                thisObj: me,
                                once: true
                              });
                            } // When trying to collapse region we need its partner to occupy free space. Considering multiple
                            // regions, several cases are possible:
                            // 1) Both left and right regions have fixed width
                            // 2) Left region has fixed width, right region is flexed
                            // 3) Left region is flexed, right region has fixed width
                            // 4) Both regions are flexed
                            //
                            // To collapse flexed region we need to remove flex style, remember it somehow and set fixed width.
                            // If another region is flexed, it will fill the space. If it has fixed width, we need to increase
                            // its width by collapsing region width. Same logic should be appliead to headers.
                            //
                            // Save region width first


                            me._beforeCollapseState.width = me.width; // Save left coordinate too, to restore splitter position

                            me._beforeCollapseState.splitterLeft = grid.resolveSplitter(me).offsetLeft; // Next region is not flexed, need to make it fill the space

                            if (nextRegion.element.style.flex === '') {
                              me._beforeCollapseState.nextRegionWidth = nextRegion.width;
                              nextRegion.width += me._beforeCollapseState.width;
                            } // Current region is flexed, store style to restore on expand


                            if (me.element.style.flex !== '') {
                              me._beforeCollapseState.style = me.element.style.flex; // remove flex state to reduce width later

                              me.header.element.style.flex = me.element.style.flex = '';
                            }

                            me.element.classList.add('b-grid-subgrid-collapsed');
                            me._collapsed = true;

                            if (!widthChanged) {
                              resolve(false);
                            } else {
                              // resize, will trigger afterinternalresize above
                              me.width = collapsedWidth; // Since grid width is animated, we should animate splitter position too . Coordinate is not precise
                              // but it will be fixed after collapse is done

                              grid.resolveSplitter(me).style.left = me.element.offsetLeft;
                            }
                          }
                        }).then(function (value) {
                          if (value !== false) {
                            me.grid.trigger('subGridCollapse', me);
                          }
                        }));

                      case 7:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              return function collapse() {
                return _collapse.apply(this, arguments);
              };
            }()
            /**
             * Expands subgrid.
             *
             * @example
             * grid.getSubGrid('locked').expand().then(() => console.log('locked grid expanded'));
             *
             * @async
             * @returns {Promise} A Promise which resolves when this SubGrid is fully expanded.
             */

          }, {
            key: "expand",
            value: function () {
              var _expand = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_3___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee2() {
                var me, grid, nextRegion;
                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        me = this, grid = me.grid, nextRegion = grid.getSubGrid(grid.getNextRegion(me.region));
                        return _context2.abrupt("return", new Promise(function (resolve) {
                          if (me._beforeCollapseState != null) {
                            // If current width matches width expected after expand resize event will not be fired. In such case
                            // we want to trigger callback immediately
                            var widthChanged = false; // See similar clause in collapse method above

                            if (me.width !== me._beforeCollapseState.width) {
                              widthChanged = true; // Toggle transition classes here, we will actually change width below
                              // me.toggleTransitionClasses();

                              me.on({
                                afterinternalresize: function afterinternalresize() {
                                  // me.toggleTransitionClasses(true);
                                  // Delay the resolve to avoid "ResizeObserver loop limit exceeded" errors
                                  // collapsing the only expanded region and it has to expand its nextRegion
                                  // before it can collapse.
                                  setTimeout(function () {
                                    return resolve(me);
                                  }, 10);
                                },
                                thisObj: me,
                                once: true
                              });
                            } // previous region is not flexed, reduce its width as it was increased in collapse


                            if (nextRegion.element.style.flex === '') {
                              nextRegion.width = me._beforeCollapseState.nextRegionWidth;
                            }

                            me.element.classList.remove('b-grid-subgrid-collapsed');
                            me._collapsed = false; // Always restore width, restoring flex wont trigger resize otherwise

                            me.width = me._beforeCollapseState.width; // This region used to be flex, lets restore it

                            if (me._beforeCollapseState.style) {
                              me.header.element.style.flex = me.element.style.flex = me._beforeCollapseState.style; // set width to be empty, we want styles to be consistent and clean

                              me.header.element.style.width = me.element.style.width = '';
                              me._width = null;
                            } // Since grid width is animated, we should animate splitter position too . Coordinate is not precise
                            // but it will be fixed after collapse is done


                            grid.resolveSplitter(me).style.left = "".concat(me._beforeCollapseState.splitterLeft, "px");
                            me.element.classList.remove('b-grid-subgrid-collapsed');
                            me._collapsed = false;

                            if (!widthChanged) {
                              resolve(false);
                            }

                            delete me._beforeCollapseState;
                          }
                        }).then(function (value) {
                          if (value !== false) {
                            me.grid.trigger('subGridExpand', me);
                          }
                        }));

                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));

              return function expand() {
                return _expand.apply(this, arguments);
              };
            }() //endregion

          }, {
            key: "totalFixedWidth",
            get: function get() {
              return this.columns.totalFixedWidth;
            }
          }, {
            key: "width",
            set: function set(width) {
              var me = this; // Width explicitly set, remember that

              me.hasCalculatedWidth = false;
              if (me.header) me.header.width = width;
              if (me.footer) me.footer.width = width;

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid.prototype), "width", width, this, true); // Can't wait until the  throttled resize occurs - it looks bad.


              if (!me.isConfiguring) {
                me.onElementResize();
              }
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid.prototype), "width", this);
            }
            /**
             * Get/set SubGrid flex, which also sets header and footer flex (if available).
             * @property {Number|String}
             */

          }, {
            key: "flex",
            set: function set(flex) {
              var me = this; // Width explicitly set, remember that

              me.hasCalculatedWidth = false;
              if (me.header) me.header.flex = flex;
              if (me.footer) me.footer.flex = flex;

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid.prototype), "flex", flex, this, true); // Can't wait until the  throttled resize occurs - it looks bad.


              if (!me.isConfiguring) {
                me.onElementResize();
              }
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SubGrid.prototype), "flex", this);
            }
          }, {
            key: "viewRectangle",
            get: function get() {
              var me = this;
              return new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_22__["default"](me.scrollable.x, me.scrollable.y, me._width, me.rowManager.viewHeight);
            }
          }, {
            key: "scrolling",
            set: function set(scrolling) {
              this._scrolling = scrolling;
              this.grid.bodyContainer.classList[scrolling ? 'add' : 'remove']('b-scrolling');
            },
            get: function get() {
              return this._scrolling;
            }
          }, {
            key: "rowElements",
            get: function get() {
              return this.fromCache('.b-grid-row', true);
            }
          }, {
            key: "emptyText",
            get: function get() {
              return this._emptyText;
            },
            set: function set(text) {
              this._emptyText = text;
              this.element.dataset.emptyText = text;
            }
          }, {
            key: "collapsed",
            get: function get() {
              return this._collapsed;
            },
            set: function set(collapsed) {
              if (this.isConfiguring) {
                this._collapsed = collapsed;
              } else {
                if (collapsed) {
                  this.collapse();
                } else {
                  this.expand();
                }
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config

            /**
             * Region (name) for this SubGrid
             * @config {String} region
             */

            /**
             * Column store, a store containing the columns for this SubGrid
             * @config {Grid.data.ColumnStore} columns
             */
            get: function get() {
              return {
                insertRowsBefore: null,
                appendTo: null,
                hideHeaders: null,
                monitorResize: true,
                // Width of the subgrid in the collapsed state
                collapsedStateWidth: 5,
                // Default width of the splitter.
                splitterWidth: 1,

                /**
                 * Set `true` to start subgrid collapsed. To operate collapsed state on subgrid use
                 * {@link #function-collapse}/{@link #function-expand} methods.
                 * @config {Boolean}
                 * @default false
                 */
                collapsed: null,
                scrollable: {
                  // Each SubGrid only handles scrolling in the X axis.
                  // The owning Grid handles the Y axis.
                  overflowX: true
                },
                scrollerClass: _util_SubGridScroller_js__WEBPACK_IMPORTED_MODULE_21__["default"],
                // Will be set to true by GridSubGrids if it calculates the subgrids width based on its columns.
                // Used to determine if hiding a column should affect subgrids width
                hasCalculatedWidth: null,

                /**
                 * Set `true` to disable moving columns into or out of this SubGrid.
                 * @config {Boolean}
                 * @default false
                 * @private
                 */
                sealedColumns: null,
                emptyText: null
              };
            }
          }]);

          return SubGrid;
        }(_Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_19__["default"]);

        SubGrid._$name = 'SubGrid';
        /***/
      },

      /***/
      "../Grid/lib/Grid/view/TreeGrid.js":
      /*!*****************************************!*\
        !*** ../Grid/lib/Grid/view/TreeGrid.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewTreeGridJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TreeGrid;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "../Grid/node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Grid_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./Grid.js */
        "../Grid/lib/Grid/view/Grid.js");
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _feature_Tree_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../feature/Tree.js */
        "../Grid/lib/Grid/feature/Tree.js");
        /* harmony import */


        var _column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../column/TreeColumn.js */
        "../Grid/lib/Grid/column/TreeColumn.js");

        var productName = 'scheduler'; // tree feature will be added by default to TreeGrid, but needs to be imported
        // not used here but enables using `type : tree` in a column config (exactly one required)

        /**
         * @module Grid/view/TreeGrid
         */

        /**
         * A TreeGrid, a Tree combined with a Grid. Must be configured with exactly one {@link Grid.column.TreeColumn} (`type: tree`), but can also have an
         * arbitrary number of other columns. Most features that can be used with Grid also works with TreeGrid, with the
         * exception of the Group feature.
         * @extends Grid/view/Grid
         *
         * @classtype treegrid
         * @externalexample grid/TreeGrid.js
         */

        var TreeGrid =
        /*#__PURE__*/
        function (_Grid) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TreeGrid, _Grid);

          function TreeGrid() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TreeGrid);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TreeGrid).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TreeGrid, [{
            key: "store",
            //region Plugged in functions / inherited configs

            /**
             * Store that holds records to display in the TreeGrid, or a store config object.
             * If you supply a Store, make sure it is configured with `tree : true` to handle tree data.
             * A store will be created if none is specified
             * @config {Common.data.Store|Object} store
             * @default
             */

            /**
             * Collapse an expanded node or expand a collapsed. Optionally forcing a certain state.
             *
             * @function toggleCollapse
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to toggle
             * @param {Boolean} [collapse] Force collapse (true) or expand (false)
             * @param {Boolean} [skipRefresh] Set to true to not refresh rows (if calling in batch)
             * @returns {Promise}
             * @category Feature shortcuts
             */

            /**
             * Collapse a single node.
             *
             * @function collapse
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to collapse
             * @returns {Promise}
             * @category Feature shortcuts
             */

            /**
             * Expand a single node.
             *
             * @function expand
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node to expand
             * @returns {Promise}
             * @category Feature shortcuts
             */

            /**
             * Expands parent nodes to make this node "visible".
             *
             * @function expandTo
             * @param {String|Number|Common.data.Model} idOrRecord Record (the node itself) or id of a node
             * @returns {Promise}
             * @category Feature shortcuts
             */
            //endregion
            //region Store

            /**
             * Get/set the store used by this TreeGrid. Accepts a config or a Store. If assigning an already existing Store,
             * it must be configured with `tree: true`
             * @property {Common.data.Store|Object}
             */
            set: function set(store) {
              if (store && !store.tree) {
                // existing store instance, not much we can do about it
                if (store instanceof _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_8__["default"]) {
                  throw new Error('TreeGrid requires a Store configured with tree : true');
                } // store config, enable tree
                else {
                    store.tree = true;
                  }
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TreeGrid.prototype), "store", store, this, true);
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TreeGrid.prototype), "store", this);
            } //endregion

          }]);

          return TreeGrid;
        }(_Grid_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        TreeGrid._$name = 'TreeGrid';

        _Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_9__["default"].register('treegrid', TreeGrid);
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/mixin/GridElementEvents.js":
      /*!********************************************************!*\
        !*** ../Grid/lib/Grid/view/mixin/GridElementEvents.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewMixinGridElementEventsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler'; //TODO: Should it fire more own events instead and rely less on function chaining?

        var domEventHandlers = {
          touchstart: 'onElementTouchStart',
          touchmove: 'onElementTouchMove',
          touchend: 'onElementTouchEnd',
          mouseover: 'onElementMouseOver',
          mouseout: 'onElementMouseOut',
          mousedown: 'onElementMouseDown',
          mousemove: 'onElementMouseMove',
          mouseup: 'onElementMouseUp',
          click: 'onHandleElementClick',
          dblclick: 'onElementDblClick',
          keydown: 'onElementKeyDown',
          keyup: 'onElementKeyUp',
          keypress: 'onElementKeyPress',
          contextmenu: 'onElementContextMenu',
          focus: 'onGridElementFocus'
        };
        /**
         * @module Grid/view/mixin/GridElementEvents
         */

        /**
         * Mixin for Grid that handles dom events. Some listeners fire own events but all can be chained by features. None of
         * the functions in this class are indented to be called directly.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(GridElementEvents, _ref);

              function GridElementEvents() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, GridElementEvents);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(GridElementEvents).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(GridElementEvents, [{
                key: "initInternalEvents",
                //endregion
                //region Events

                /**
                 * User clicked in a grid cell
                 * @event cellClick
                 * @param {Grid.view.Grid} grid
                 * @param {Common.data.Model} record
                 * @param {Grid.column.Column} column
                 * @param {Object} cellSelector
                 * @param {HTMLElement} cellElement
                 * @param {HTMLElement} target
                 * @param {Event} event
                 */

                /**
                 * User double clicked in a grid cell
                 * @event cellDblClick
                 * @param {Grid.view.Grid} grid
                 * @param {Common.data.Model} record
                 * @param {Grid.column.Column} column
                 * @param {Object} cellSelector
                 * @param {HTMLElement} cellElement
                 * @param {HTMLElement} target
                 * @param {Event} event
                 */

                /**
                 * User activated contextmenu in a grid cell
                 * @event cellContextMenu
                 * @param {Grid.view.Grid} grid
                 * @param {Common.data.Model} record
                 * @param {Grid.column.Column} column
                 * @param {Object} cellSelector
                 * @param {HTMLElement} cellElement
                 * @param {HTMLElement} target
                 * @param {Event} event
                 */

                /**
                 * User moved moused to a grid cell
                 * @event cellMouseOver
                 * @param {Grid.view.Grid} grid
                 * @param {Common.data.Model} record
                 * @param {Grid.column.Column} column
                 * @param {Object} cellSelector
                 * @param {HTMLElement} cellElement
                 * @param {HTMLElement} target
                 * @param {Event} event
                 */

                /**
                 * User moved moused out of a grid cell
                 * @event cellMouseOut
                 * @param {Grid.view.Grid} grid
                 * @param {Common.data.Model} record
                 * @param {Grid.column.Column} column
                 * @param {Object} cellSelector
                 * @param {HTMLElement} cellElement
                 * @param {HTMLElement} target
                 * @param {Event} event
                 */
                //endregion
                //region Event handling

                /**
                 * Init listeners for a bunch of dom events. All events are handled by handleEvent().
                 * @private
                 * @category Events
                 */
                value: function initInternalEvents() {
                  var handledEvents = Object.keys(domEventHandlers),
                      len = handledEvents.length,
                      listeners = {
                    element: this.element,
                    thisObj: this
                  }; // Route all events through handleEvent, so that we can capture this.event
                  // before we route to the handlers

                  for (var i = 0; i < len; i++) {
                    listeners[handledEvents[i]] = 'handleEvent';
                  }

                  _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on(listeners);
                }
                /**
                 * This method find the cell location of the passed event. It returns an object describing the cell.
                 * @param {Event} event A Mouse, Pointer or Touch event targeted at part of the grid.
                 * @returns {Object} An object containing the following properties:
                 * - `cellElement` - The cell element clicked on.
                 * - `columnId` - The `id` of the column clicked under.
                 * - `record` - The {@link Common.data.Model record} clicked on.
                 * - `id` - The `id` of the {@link Common.data.Model record} clicked on.
                 * @private
                 * @category Events
                 */

              }, {
                key: "getEventData",
                value: function getEventData(event) {
                  var me = this,
                      cellElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(event.target, '.b-grid-cell'); // There is a cell


                  if (cellElement) {
                    var cellData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_10__["default"].get(cellElement),
                        id = cellData.id,
                        columnId = cellData.columnId,
                        record = me.store.getById(id); // Row might not have a record, since we transition record removal
                    // https://app.assembla.com/spaces/bryntum/tickets/6805


                    return record ? {
                      cellElement: cellElement,
                      cellData: cellData,
                      columnId: columnId,
                      id: id,
                      record: record,
                      cellSelector: {
                        id: id,
                        columnId: columnId
                      }
                    } : null;
                  }
                }
                /**
                 * Handles all dom events, routing them to correct functions (touchstart -> onElementTouchStart)
                 * @param event
                 * @private
                 * @category Events
                 */

              }, {
                key: "handleEvent",
                value: function handleEvent(event) {
                  if (!this.disabled) {
                    this.event = event;

                    if (domEventHandlers[event.type]) {
                      this[domEventHandlers[event.type]](event);
                    }
                  }
                } //endregion
                //region Touch events

                /**
                 * Touch start, chain this function in features to handle the event.
                 * @param event
                 * @category Touch events
                 * @internal
                 */

              }, {
                key: "onElementTouchStart",
                value: function onElementTouchStart(event) {
                  var me = this;
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isTouchEvent = true;

                  if (event.touches.length === 1) {
                    me.longPressTimeout = setTimeout(function () {
                      me.onElementLongPress(event);
                      event.preventDefault();
                      me.longPressPerformed = true;
                    }, me.longPressTime);
                  }
                }
                /**
                 * Touch move, chain this function in features to handle the event.
                 * @param event
                 * @category Touch events
                 * @internal
                 */

              }, {
                key: "onElementTouchMove",
                value: function onElementTouchMove(event) {
                  if (this.longPressTimeout) {
                    clearTimeout(this.longPressTimeout);
                    this.longPressTimeout = null;
                  }
                }
                /**
                 * Touch end, chain this function in features to handle the event.
                 * @param event
                 * @category Touch events
                 * @internal
                 */

              }, {
                key: "onElementTouchEnd",
                value: function onElementTouchEnd(event) {
                  var me = this;

                  if (me.longPressPerformed) {
                    if (event.cancelable) {
                      event.preventDefault();
                    }

                    me.longPressPerformed = false;
                  }

                  if (me.longPressTimeout) {
                    clearTimeout(me.longPressTimeout);
                    me.longPressTimeout = null;
                  }
                }
              }, {
                key: "onElementLongPress",
                value: function onElementLongPress(event) {} //endregion
                //region Mouse events
                // Trigger events in same style when clicking, dblclicking and for contextmenu

              }, {
                key: "triggerCellMouseEvent",
                value: function triggerCellMouseEvent(name, event) {
                  var me = this,
                      cellData = me.getEventData(event); // There is a cell

                  if (cellData) {
                    var column = me.columns.getById(cellData.columnId);
                    me.trigger('cell' + _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].capitalizeFirstLetter(name), {
                      grid: this,
                      record: cellData.record,
                      column: column,
                      cellSelector: cellData.cellSelector,
                      cellElement: cellData.cellElement,
                      target: event.target,
                      event: event
                    });
                  }
                }
                /**
                 * Mouse down, chain this function in features to handle the event.
                 * @param event
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onElementMouseDown",
                value: function onElementMouseDown(event) {
                  var me = this,
                      cellData = me.getEventData(event);
                  me.skipFocusSelection = true;
                  me.triggerCellMouseEvent('mousedown', event); // Browser event unification fires a mousedown on touch tap prior to focus.

                  if (!event.defaultPrevented) {
                    me.onFocusGesture(cellData, event);
                  }
                }
                /**
                 * Move move, chain this function in features to handle the event.
                 * @param event
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onElementMouseMove",
                value: function onElementMouseMove(event) {}
                /**
                 * Mouse up, chain this function in features to handle the event.
                 * @param event
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onElementMouseUp",
                value: function onElementMouseUp(event) {}
                /**
                 * Called before {@link #function-onElementClick}.
                 * Fires 'beforeElementClick' event which can return false to cancel further onElementClick actions.
                 * @param event
                 * @fires beforeElementClick
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onHandleElementClick",
                value: function onHandleElementClick(event) {
                  if (this.trigger('beforeElementClick', {
                    event: event
                  }) !== false) {
                    this.onElementClick(event);
                  }
                }
                /**
                 * Click, select cell on click and also fire 'cellClick' event.
                 * Chain this function in features to handle the dom event.
                 * @param event
                 * @fires cellClick
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onElementClick",
                value: function onElementClick(event) {
                  var me = this,
                      cellData = me.getEventData(event); // There is a cell

                  if (cellData) {
                    me.triggerCellMouseEvent('click', event); // Clear hover styling when clicking in a row to avoid having it stick around if you keyboard navigate
                    // away from it
                    // https://app.assembla.com/spaces/bryntum/tickets/5848

                    _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_10__["default"].get(cellData.cellElement).row.removeCls('b-hover');
                  }
                }
              }, {
                key: "onFocusGesture",
                value: function onFocusGesture(cellData, event) {
                  //TODO: should be able to cancel focusCell from listeners
                  if (cellData) {
                    this.focusCell(cellData.cellSelector, {
                      doSelect: true,
                      event: event
                    });
                  }
                }
                /**
                 * Double click, fires 'cellDblClick' event.
                 * Chain this function in features to handle the dom event.
                 * @param {Event} event
                 * @fires cellDblClick
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onElementDblClick",
                value: function onElementDblClick(event) {
                  var me = this,
                      target = event.target;
                  me.triggerCellMouseEvent('dblClick', event);

                  if (target.classList.contains('b-grid-header-resize-handle')) {
                    var header = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(target, '.b-grid-header'),
                        column = me.columns.getById(header.dataset.columnId);

                    column.resizeToFitContent();
                  }
                }
                /**
                 * Mouse over, adds 'hover' class to elements.
                 * @param event
                 * @fires mouseOver
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onElementMouseOver",
                value: function onElementMouseOver(event) {
                  // bail out early if scrolling
                  if (!this.scrolling) {
                    var cellElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(event.target, '.b-grid-cell');

                    if (cellElement) {
                      var row = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_10__["default"].get(cellElement).row; // No hover effect needed if a mouse button is pressed (like when resizing window, region, or resizing something etc).
                      // NOTE: 'buttons' not supported in Safari


                      if (row && (typeof event.buttons !== 'number' || event.buttons === 0)) {
                        row.addCls('b-hover');
                      }

                      this.triggerCellMouseEvent('mouseOver', event);
                    }
                    /**
                     * Mouse moved in over element in grid
                     * @event mouseOver
                     * @param {Event} event
                     */


                    this.trigger('mouseOver', {
                      event: event
                    });
                  }
                }
                /**
                 * Mouse out, removes 'hover' class from elements.
                 * @param event
                 * @fires mouseOut
                 * @category Mouse events
                 * @internal
                 */

              }, {
                key: "onElementMouseOut",
                value: function onElementMouseOut(event) {
                  var me = this; // bail out early if scrolling

                  if (!me.scrolling) {
                    var cellElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].up(event.target, '.b-grid-cell');

                    if (cellElement) {
                      var row = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_10__["default"].get(cellElement).row;

                      if (row) row.removeCls('b-hover');
                      me.triggerCellMouseEvent('mouseOut', event);
                    }
                    /**
                     * Mouse moved out from element in grid
                     * @event mouseOut
                     * @param {Event} event
                     */


                    me.trigger('mouseOut', {
                      event: event
                    });
                  }
                } //endregion
                //region Keyboard events

                /**
                 * Key down, handles arrow keys for selection.
                 * Chain this function in features to handle the dom event.
                 * @param event
                 * @category Keyboard events
                 * @internal
                 */

              }, {
                key: "onElementKeyDown",
                value: function onElementKeyDown(event) {
                  var me = this; // flagging event with handled = true used to signal that other features should probably not care about it.
                  // for this to work you should specify overrides for onElementKeyDown to be run before this function
                  // (see for example CellEdit feature)

                  if (event.handled) return;

                  if (event.target.matches('.b-grid-header.b-depth-0')) {
                    me.handleHeaderKeyDown(event);
                  } else if (event.target === this.element || _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isIE11 && event.currentTarget === this.element) {
                    // IE11 Browser check is not placed in EventHelper to maintain built-in delegated functionality
                    me.handleViewKeyDown(event);
                  } // If focus is *within* a cell (eg WidgetColumn or CheckColumn), jump up to focus the cell.
                  else if (event.key === 'Escape' && me.isActionableLocation) {
                      var focusedCell = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].clone(me.focusedCell);

                      focusedCell.element = null;
                      me.focusCell(focusedCell);

                      _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].focusWithoutScrolling(me.element);
                    }
                }
              }, {
                key: "handleViewKeyDown",
                value: function handleViewKeyDown(event) {
                  var me = this;

                  switch (event.key) {
                    case 'ArrowLeft':
                      event.preventDefault();
                      return me.navigateLeft(event);

                    case 'ArrowRight':
                      event.preventDefault();
                      return me.navigateRight(event);

                    case 'ArrowUp':
                      event.preventDefault();
                      return me.navigateUp(event);

                    case 'ArrowDown':
                      event.preventDefault();
                      return me.navigateDown(event);
                  }
                }
              }, {
                key: "handleHeaderKeyDown",
                value: function handleHeaderKeyDown(event) {
                  var me = this,
                      column = me.columns.getById(event.target.dataset.columnId);
                  column.onKeyDown && column.onKeyDown(event);

                  switch (event.key) {
                    case 'ArrowLeft':
                      var prev = me.columns.getAdjacentVisibleLeafColumn(column, false);

                      if (prev) {
                        var _element = me.getHeaderElement(prev.id);

                        _element.focus();
                      }

                      break;

                    case 'ArrowRight':
                      var next = me.columns.getAdjacentVisibleLeafColumn(column, true);

                      if (next) {
                        var _element2 = me.getHeaderElement(next.id);

                        _element2.focus();
                      }

                      break;

                    case 'Enter':
                      var element = me.getHeaderElement(column.id);
                      element.click();
                      break;
                  }
                }
                /**
                 * Key press, chain this function in features to handle the dom event.
                 * @param event
                 * @category Keyboard events
                 * @internal
                 */

              }, {
                key: "onElementKeyPress",
                value: function onElementKeyPress(event) {}
                /**
                 * Key up, chain this function in features to handle the dom event.
                 * @param event
                 * @category Keyboard events
                 * @internal
                 */

              }, {
                key: "onElementKeyUp",
                value: function onElementKeyUp(event) {} //endregion
                //region Other events

                /**
                 * Context menu, chain this function in features to handle the dom event.
                 * In most cases, include ContextMenu feature instead.
                 * @param event
                 * @category Other events
                 * @internal
                 */

              }, {
                key: "onElementContextMenu",
                value: function onElementContextMenu(event) {
                  var me = this,
                      cellData = me.getEventData(event); // There is a cell

                  if (cellData) {
                    me.triggerCellMouseEvent('contextMenu', event); // Focus on tap for touch events.
                    // Selection follows from focus.

                    if (_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].isTouchEvent) {
                      me.onFocusGesture(cellData, event);
                    }
                  }
                }
                /**
                 * Overrides empty base function in View, called when view is resized.
                 * @fires resize
                 * @param element
                 * @param width
                 * @param height
                 * @param oldWidth
                 * @param oldHeight
                 * @category Other events
                 * @internal
                 */

              }, {
                key: "onInternalResize",
                value: function onInternalResize(element, width, height, oldWidth, oldHeight) {
                  var me = this;

                  if (me._devicePixelRatio && me._devicePixelRatio !== window.devicePixelRatio) {
                    // Pixel ratio changed, likely because of browser zoom. This affects the relative scrollbar width also
                    _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].resetScrollBarWidth();
                  }

                  me._devicePixelRatio = window.devicePixelRatio; // cache to avoid recalculations in the middle of rendering code (RowManger#getRecordCoords())

                  me._bodyRectangle = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].client(me.bodyContainer);

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(GridElementEvents.prototype), "onInternalResize", this).apply(this, arguments);

                  if (height !== oldHeight) {
                    me._bodyHeight = me.bodyContainer.offsetHeight;

                    if (me.rendered) {
                      // initial height will be set from render(),
                      // it reaches onInternalResize too early when rendering, headers/footers are not sized yet
                      me.rowManager.initWithHeight(me._bodyHeight);
                    }
                  }

                  me.refreshVirtualScrollbars();

                  if (width !== oldWidth) {
                    // Slightly delay to avoid resize loops.
                    me.setTimeout(function () {
                      if (!me.isDestroyed) {
                        me.updateResponsive(width, oldWidth);
                      }
                    }, 0);
                  }
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                //region Config
                get: function get() {
                  return {
                    /**
                     * Time in ms until a longpress is triggered
                     * @config {Number}
                     * @default
                     * @category Events
                     */
                    longPressTime: 400
                  };
                }
              }]);

              return GridElementEvents;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_9__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/mixin/GridFeatures.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Grid/view/mixin/GridFeatures.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewMixinGridFeaturesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.define-property */
        "../Grid/node_modules/core-js/modules/es6.reflect.define-property.js");
        /* harmony import */


        var core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_define_property__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "../Grid/node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/construct */
        "../Grid/node_modules/@babel/runtime/helpers/construct.js");
        /* harmony import */


        var _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/view/mixin/GridFeatures
         */

        var validConfigTypes = {
          string: 1,
          object: 1,
          function: 1 // used by CellTooltip

        };
        /**
         * Mixin for Grid that handles features. Features are plugins that add functionality to the grid. Feature classes should
         * register with Grid by calling {@link Grid.feature.GridFeatureManager#function-registerFeature-static registerFeature}. This
         * enables features to be specified and configured in grid
         * config.
         *
         * Define which features to use:
         *
         * ```javascript
         * // specify which features to use (note that some features are used by default)
         * const grid = new Grid({
         *   features: {
         *      sort: 'name',
         *      search: true
         *   }
         * });
         * ```
         *
         * Access a feature in use:
         *
         * ```javascript
         * grid.features.search.search('cat');
         * ```
         *
         * Basic example of implementing a feature:
         *
         * ```javascript
         * class MyFeature extends InstancePlugin {
         *
         * }
         *
         * GridFeatures.registerFeature(MyFeature);
         *
         * // using the feature
         * const grid = new Grid({
         *   features: {
         *     myFeature: true
         *   }
         * });
         * ```
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(GridFeatures, _ref);

              function GridFeatures() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, GridFeatures);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridFeatures).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(GridFeatures, [{
                key: "createFeatureInitializer",
                value: function createFeatureInitializer(features, featureName, featureClass, config) {
                  var constructorArgs = [this],
                      construct = featureClass.prototype.construct; // Only pass config if there is one.
                  // The constructor(config = {}) only works for undefined config

                  if (validConfigTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7___default()(config)]) {
                    constructorArgs[1] = config;
                  }

                  return {
                    configurable: true,
                    get: function get() {
                      // Delete this defined property and replace it with the Feature instance.
                      delete features[featureName]; // Ensure the feature is injected into the features object before initialization
                      // so that it is available from call chains from its initialization.

                      featureClass.prototype.construct = function () {
                        features[featureName] = this;

                        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                          args[_key] = arguments[_key];
                        }

                        construct.apply(this, args);
                        featureClass.prototype.construct = construct;
                      }; // Return the Feature instance


                      return _babel_runtime_helpers_construct__WEBPACK_IMPORTED_MODULE_6___default()(featureClass, constructorArgs);
                    }
                  };
                } //endregion
                //region Other stuff

                /**
                 * Check if a feature is included
                 * @param {String} name Feature name, as registered with `GridFeatureManager.registerFeature()`
                 * @returns {Boolean}
                 * @category Misc
                 */

              }, {
                key: "hasFeature",
                value: function hasFeature(name) {
                  return !!(this.features && name in this.features);
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "features",
                //region Init

                /**
                 * Specify which features to use on the grid. Most features accepts a boolean, some also accepts a config object.
                 * Please note that if you are not using the bundles you might need to import the features you want to use.
                 *
                 * ```javascript
                 * const grid = new Grid({
                 *     features : {
                 *         stripe : true,   // Enable stripe feature
                 *         sort   : 'name', // Configure sort feature
                 *         group  : false   // Disable group feature
                 *     }
                 * }
                 * ```
                 *
                 * @config {Object} features
                 * @category Common
                 */

                /**
                 * Map of the features available on the grid. Use it to access them on your grid object
                 *
                 * ```javascript
                 * grid.features.group.expandAll();
                 * ```
                 *
                 * @readonly
                 * @property {Object}
                 * @category Common
                 * @typings any
                 */
                set: function set(features) {
                  var me = this,
                      defaultFeatures = _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].getInstanceDefaultFeatures(this);

                  features = me._features = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].assign({}, features); // default features, enabled unless otherwise specified

                  if (defaultFeatures) {
                    Object.entries(defaultFeatures).forEach(function (_ref2) {
                      var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref2, 2),
                          as = _ref3[0],
                          featureClass = _ref3[1];

                      if (!(as in features)) {
                        features[as] = true;
                      }
                    });
                  } // We *prime* the features so that if any configuration code accesses a feature, it
                  // will self initialize, but if not, they will remain in a primed state until afterConfigure.


                  var featureName, config, featureClass;

                  var registeredInstanceFeatures = _feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_15__["default"].getInstanceFeatures(this);

                  var _arr = Object.keys(features);

                  for (var _i = 0; _i < _arr.length; _i++) {
                    featureName = _arr[_i];
                    config = features[featureName]; // Create feature initialization property if config is truthy.
                    // Config must be a valid configuration value for the feature class.

                    if (config) {
                      // Feature configs name must start with lowercase letter to be valid
                      if (_Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].lowercaseFirstLetter(featureName) !== featureName) {
                        throw new Error(me.L('invalidFeatureNameFormat', featureName));
                      }

                      featureClass = registeredInstanceFeatures[featureName];

                      if (!featureClass) {
                        throw new Error(me.L('featureNotFound', featureName));
                      } // Create a self initializing property on the features object named by the feature name.
                      // when accessed, it will create and return the real feature.
                      // Now, if some Feature initiualization code attempt to access a feature which has not yet been initialized
                      // it will be initialized just in time.


                      Reflect.defineProperty(features, featureName, me.createFeatureInitializer(features, featureName, featureClass, config));
                    }
                  }
                },
                get: function get() {
                  return this._features;
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return GridFeatures;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/mixin/GridNavigation.js":
      /*!*****************************************************!*\
        !*** ../Grid/lib/Grid/view/mixin/GridNavigation.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewMixinGridNavigationJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "../Grid/node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "../Grid/node_modules/core-js/modules/es6.object.freeze.js");
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/view/mixin/GridNavigation
         */

        var defaultFocusOptions = Object.freeze({
          doSelect: true
        });
        /**
         * Mixin for Grid that handles cell to cell navigation.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(GridNavigation, _ref);

              function GridNavigation() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, GridNavigation);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(GridNavigation).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(GridNavigation, [{
                key: "onGridElementFocus",

                /**
                 * Grid element focus, selects first row and cell when grid is focused if none is selected (otherwise user cannot
                 * see that grid is focused).
                 * Chain this function it features to handle the dom event.
                 * @param event
                 * @category Other events
                 * @internal
                 */
                value: function onGridElementFocus(event) {
                  // Select first row if none is selected when grid is focused (to show that it has focus)
                  var me = this,
                      focusOptions = {
                    doSelect: false,
                    event: event
                  };

                  if (me._focusedCell) {
                    me.focusCell(me._focusedCell, focusOptions);
                  } else {
                    // If they just clicked in blank space, do not refocus the last focused cell.
                    // We focus cell 0, 0 on that gesture.
                    var targetCell = me.element.contains(event.relatedTarget) ? null : me.lastFocusedCell;

                    if (targetCell) {
                      // The previously focused record has since been removed.
                      // Fallback to reverting to where focus endtered the grid from.
                      // TODO: CellContext should store the record index
                      // to fall back to if the actual record is no longer present.
                      if (!me.store.getById(targetCell.id)) {
                        me.revertFocus();
                        return;
                      } // flag to not affect selection


                      me.returningFocus = true;
                      me.focusCell(targetCell, focusOptions);
                      me.returningFocus = false;
                    } else if (!me.skipFocusSelection && me.store.first) {
                      me.focusCell({
                        id: me.store.first.id,
                        columnId: me.columns.visibleColumns[0].id
                      }, focusOptions);
                    }
                  }

                  me.skipFocusSelection = false;
                }
              }, {
                key: "onFocusOut",
                value: function onFocusOut(event) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(GridNavigation.prototype), "onFocusOut", this).call(this, event);

                  this.clearFocus();
                }
                /**
                 * Checks whether or not a cell is focused.
                 * @param {Object|string|Number} cellSelector Cell selector { id: x, columnId: xx } or row id
                 * @returns {Boolean} true if cell or row is focused, otherwise false
                 */

              }, {
                key: "isFocused",
                value: function isFocused(cellSelector) {
                  return Boolean(this._focusedCell) && this.isLocationEqual(cellSelector, this._focusedCell);
                }
                /**
                 * Navigates to a cell and/or its row (depending on selectionMode)
                 * @param {Object} cellSelector { id: rowId, columnId: 'columnId' }
                 * @param {Object} options Modifier options for how to deal with focusing the cell. These
                 * are used as the {@link Common.helper.util.Scroller#function-scrollTo} options.
                 * @param {Boolean} [options.doSelect=true] Optionally pass `false` to not continue to selection.
                 * @param {Event} [options.event] Optionally pass the UI event which instigated the focus request.
                 * @returns {Object} Cell selector
                 * @fires navigate
                 */

              }, {
                key: "focusCell",
                value: function focusCell(cellSelector) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFocusOptions; // If we're being passed a context object (as opposed to a record), clone in case we were
                  // passed the _focusedCell, and after refresh isLocationEqual needs to detect a difference.

                  cellSelector = this.normalizeCellContext(cellSelector === Object ? Object.assign({}, cellSelector) : cellSelector);
                  var me = this,
                      doSelect = options.doSelect !== false,
                      event = options.event,
                      lastFocusedCell = me.lastFocusedCell = me._focusedCell,
                      isNotMove = me.isLocationEqual(cellSelector, lastFocusedCell),
                      lastCell = lastFocusedCell && me.getCell(lastFocusedCell);
                  var cell = me.getCell(cellSelector); // If we're focusing due to a mousedown on a focusable element *within* a cell
                  // then we do not "navigate" to the cell - we allow the element to be focused.
                  // For example a CheckColumn or WidgetColumn.

                  if (event && event.type === 'mousedown') {
                    for (var target = event.target; target !== cell; target = target.parentElement) {
                      if (_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].isFocusable(target)) {
                        cellSelector.element = target;
                        return;
                      }
                    }
                  } // No navigation takes place, but the selection still needs to know if a UI event happened.


                  if (isNotMove) {
                    if (event) {
                      me.onCellNavigate && me.onCellNavigate(me, null, me._focusedCell, event, doSelect);
                    }

                    return cellSelector;
                  }

                  if (lastCell) {
                    lastCell.classList.remove('b-focused');
                  }

                  me.scrollRowIntoView(cellSelector.id, Object.assign({
                    column: cellSelector.columnId
                  }, options)); // Get the newly visible cell *after* it has been scrolled into view.
                  // With buffered rendering, it may not have existed before the scroll.

                  cell = me.getCell(cellSelector);

                  if (cell) {
                    cellSelector.element = cell;
                    cell.classList.add('b-focused');
                  } //Remember


                  me._focusedCell = cellSelector;
                  me.onCellNavigate && me.onCellNavigate(me, lastFocusedCell, me._focusedCell, event, doSelect);
                  me.trigger('navigate', {
                    lastFocusedCell: lastFocusedCell,
                    focusedCell: me._focusedCell,
                    event: event
                  }); //TODO: should be able to cancel selectcell from listeners

                  return cellSelector;
                }
              }, {
                key: "isLocationEqual",
                value: function isLocationEqual(cellSelector, otherCellSelector) {
                  return cellSelector && otherCellSelector && cellSelector.id === otherCellSelector.id && cellSelector.columnId === otherCellSelector.columnId && ( // Normalized cellSelectors are not required to have an element, only compare elements if both selectors
                  // have it specified
                  !cellSelector.element || !otherCellSelector.element || cellSelector.element === otherCellSelector.element);
                }
              }, {
                key: "blurCell",
                value: function blurCell(cellSelector) {
                  var me = this,
                      cell = me.getCell(cellSelector);

                  if (cell) {
                    cell.classList.remove('b-focused');
                  }
                }
              }, {
                key: "clearFocus",
                value: function clearFocus() {
                  var me = this;

                  if (me._focusedCell) {
                    // set last to have focus return to previous cell when alt tabbing
                    me.lastFocusedCell = me._focusedCell;
                    me.blurCell(me._focusedCell);
                    me._focusedCell = null;
                  }
                }
                /**
                 * Selects the cell before or after currently focused cell.
                 * @private
                 * @param next Specify true to select the next cell, false to select the previous
                 * @param {Event} [event] Optionally, the UI event which caused navigation.
                 * @returns {Object} Used cell selector
                 */

              }, {
                key: "internalNextPrevCell",
                value: function internalNextPrevCell() {
                  var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                  var event = arguments.length > 1 ? arguments[1] : undefined;
                  var me = this,
                      cellSelector = me._focusedCell;

                  if (cellSelector) {
                    return me.focusCell({
                      id: cellSelector.id,
                      columnId: me.columns.getAdjacentVisibleLeafColumn(cellSelector.columnId, next, true).id
                    }, {
                      doSelect: true,
                      event: event
                    });
                  }

                  return null;
                }
                /**
                 * Select the cell after the currently focused one.
                 * @param {Event} [event] Optionally, the UI event which caused navigation.
                 * @returns {Object} Cell selector
                 */

              }, {
                key: "navigateRight",
                value: function navigateRight(event) {
                  return this.internalNextPrevCell(true, event);
                }
                /**
                 * Select the cell before the currently focused one.
                 * @param {Event} [event] Optionally, the UI event which caused navigation.
                 * @returns {Object} Cell selector
                 */

              }, {
                key: "navigateLeft",
                value: function navigateLeft(event) {
                  return this.internalNextPrevCell(false, event);
                } //endregion
                //region Row

                /**
                 * Selects the next or previous record in relation to the current selection. Scrolls into view if outside.
                 * @private
                 * @param next Next record (true) or previous (false)
                 * @param {Boolean} skipSpecialRows True to not return specialRows like headers
                 * @param {Event} [event] Optionally, the UI event which caused navigation.
                 * @returns {Object/Boolean} Selection context for the focused row (& cell) or false if no selection was made
                 */

              }, {
                key: "internalNextPrevRow",
                value: function internalNextPrevRow(next) {
                  var skipSpecialRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  var event = arguments.length > 2 ? arguments[2] : undefined;
                  var me = this,
                      cell = me._focusedCell;
                  if (!cell) return false;
                  var record = me.store["get".concat(next ? 'Next' : 'Prev')](cell.id, false, skipSpecialRows);
                  if (!record) return false;
                  return me.focusCell({
                    id: record.id,
                    columnId: me._focusedCell && me._focusedCell.columnId
                  }, {
                    doSelect: true,
                    event: event
                  });
                }
                /**
                 * Navigates to the cell below the currently focused cell
                 * @param {Event} [event] Optionally, the UI event which caused navigation.
                 * @returns {Object} Selector for focused row (& cell)
                 */

              }, {
                key: "navigateDown",
                value: function navigateDown(event) {
                  return this.internalNextPrevRow(true, false, event);
                }
                /**
                 * Navigates to the cell above the currently focused cell
                 * @param {Event} [event] Optionally, the UI event which caused navigation.
                 * @returns {Object} Selector for focused row (& cell)
                 */

              }, {
                key: "navigateUp",
                value: function navigateUp(event) {
                  return this.internalNextPrevRow(false, false, event);
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "focusedCell",
                //region Cell

                /**
                 * User navigated to a grid cell
                 * @event navigate
                 * @param {Grid.view.Grid} grid
                 * @param {Object} last focused location
                 * @param {Object} location focus moved to
                 * @param {Event} [event] The UI event which caused navigation.
                 */

                /**
                 * Cell selector for focused cell, set to focus a cell or use {@link #function-focusCell}.
                 * @property {Object}
                 */
                get: function get() {
                  return this._focusedCell;
                }
                /**
                 * This property is `true` if an element _within_ a cell is focused.
                 * @property {Boolean}
                 * @readonly
                 */
                ,
                set: function set(cellSelector) {
                  this.focusCell(cellSelector, {
                    doSelect: false
                  });
                }
              }, {
                key: "isActionableLocation",
                get: function get() {
                  var focusedCell = this._focusedCell;
                  return Boolean(focusedCell && focusedCell.element && this.getCell(focusedCell).contains(focusedCell.element));
                }
              }, {
                key: "focusedRecord",
                get: function get() {
                  if (this._focusedCell) {
                    return this.store.getById(this._focusedCell.id);
                  }
                }
                /**
                 * CSS selector for currently focused cell. Format is "[data-index=index] [data-column-id=columnId]".
                 * @property {String}
                 * @readonly
                 */

              }, {
                key: "cellCSSSelector",
                get: function get() {
                  var me = this,
                      cell = me._focusedCell,
                      row = cell && me.getRowById(cell.id);
                  if (!cell || !row) return '';
                  return "[data-index=".concat(row.index, "] [data-column-id=").concat(cell.columnId, "]");
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return GridNavigation;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/mixin/GridResponsive.js":
      /*!*****************************************************!*\
        !*** ../Grid/lib/Grid/view/mixin/GridResponsive.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewMixinGridResponsiveJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.freeze */
        "../Grid/node_modules/core-js/modules/es6.object.freeze.js");
        /* harmony import */


        var core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_freeze__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Grid/view/mixin/GridResponsive
         */

        /**
         * Simplifies making grid responsive. Supply levels as {@link #config-responsiveLevels} config, default levels are:
         * <dl>
         * <dt>small <dd>< 400px,
         * <dt>medium <dd>< 600px
         * <dt>large <dd>> 600px
         * </dl>
         *
         * Columns can define configs per level to be resized etc:
         *
         * ```
         * let grid = new Grid({
         *   responsiveLevels: {
         *     small: 300,
         *     medium: 400,
         *     large: '*' // everything above 400
         *   },
         *
         *   columns: [
         *     {
         *       field: 'name',
         *       text: 'Name',
         *       responsiveLevels: {
         *         small: { hidden: true },
         *         '*': { hidden: false } // all other levels
         *       }
         *     },
         *     { field: 'xx', ... }
         *   ]
         * });
         * ```
         *
         * It is also possible to give a [Grid state](#Grid/view/mixin/GridState) object instead of a level width, but in that
         * case the object must contain a `levelWidth` property:
         *
         * ```
         * let grid = new Grid({
         *   responsiveLevels: {
         *     small: {
         *       // Width is required
         *       levelWidth : 400,
         *       // Other configs are optional, see GridState for available options
         *       rowHeight  : 30
         *     },
         *     medium : {
         *       levelWidth : 600,
         *       rowHeight  : 40
         *     },
         *     large: {
         *       levelWidth : '*', // everything above 300
         *       rowHeight  : 45
         *     }
         *   }
         * });
         * ```
         *
         * @demo responsive
         * @externalexample grid/Responsive.js
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(GridResponsive, _ref);

              function GridResponsive() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, GridResponsive);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(GridResponsive).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(GridResponsive, [{
                key: "getClosestBiggerLevel",

                /**
                 * Find closes bigger level, aka level we want to use.
                 * @private
                 * @category Misc
                 */
                value: function getClosestBiggerLevel(width) {
                  var me = this,
                      levels = Object.keys(me.responsiveLevels),
                      useLevel = null,
                      minDelta = 99995,
                      biggestLevel = null;
                  levels.forEach(function (level) {
                    var levelSize = me.responsiveLevels[level]; // responsiveLevels can contains config objects, in which case we should use width from it

                    if (!['number', 'string'].includes(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(levelSize))) {
                      levelSize = levelSize.levelWidth;
                    }

                    if (levelSize === '*') {
                      biggestLevel = level;
                    } else if (width < levelSize) {
                      var delta = levelSize - width;

                      if (delta < minDelta) {
                        minDelta = delta;
                        useLevel = level;
                      }
                    }
                  });
                  return useLevel || biggestLevel;
                }
                /**
                 * Get currently used responsive level (as string)
                 * @returns {String}
                 * @readonly
                 * @category Misc
                 */

              }, {
                key: "updateResponsive",

                /**
                 * Check if resize lead to a new responsive level and take appropriate actions
                 * @private
                 * @fires responsive
                 * @param width
                 * @param oldWidth
                 * @category Misc
                 */
                value: function updateResponsive(width, oldWidth) {
                  var me = this,
                      oldLevel = me.getClosestBiggerLevel(oldWidth),
                      level = me.getClosestBiggerLevel(width);

                  if (oldLevel !== level) {
                    // Level might be a state object
                    var levelConfig = me.responsiveLevels[level];

                    if (!['number', 'string'].includes(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(levelConfig))) {
                      me.applyState(levelConfig);
                    } // check columns for responsive config


                    me.columns.forEach(function (column) {
                      var levels = column.responsiveLevels;

                      if (levels) {
                        if (levels[level]) {
                          // using state to apply responsive config, since it already does what we want...
                          column.applyState(levels[level]);
                        } else if (levels['*']) {
                          column.applyState(levels['*']);
                        }
                      }
                    });
                    me.element.classList.remove('b-responsive-' + oldLevel);
                    me.element.classList.add('b-responsive-' + level);
                    /**
                     * Grid resize lead to a new responsive level being applied
                     * @event responsive
                     * @param {Grid.view.Grid} grid Grid that was resized
                     * @param {String} level New responsive level (small, large, etc)
                     * @param {Number} width New width in px
                     * @param {String} oldLevel Old responsive level
                     * @param {Number} oldWidth Old width in px
                     */

                    me.trigger('responsive', {
                      level: level,
                      width: width,
                      oldLevel: oldLevel,
                      oldWidth: oldWidth
                    });
                  }
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "responsiveLevel",
                get: function get() {
                  return this.getClosestBiggerLevel(this.width);
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                get: function get() {
                  return {
                    /**
                     * "Break points" for which responsive config to use for columns and css.
                     * @config {Object}
                     * @category Misc
                     * @default <code>{ small : 400, medium : 600, large : '*' }</code>
                     */
                    responsiveLevels: Object.freeze({
                      small: 400,
                      medium: 600,
                      large: '*'
                    })
                  };
                }
              }]);

              return GridResponsive;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/mixin/GridSelection.js":
      /*!****************************************************!*\
        !*** ../Grid/lib/Grid/view/mixin/GridSelection.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewMixinGridSelectionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "../Grid/node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "../Grid/node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../column/CheckColumn.js */
        "../Grid/lib/Grid/column/CheckColumn.js");
        /* harmony import */


        var _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        var validIdTypes = {
          string: 1,
          number: 1
        };
        /**
         * @module Grid/view/mixin/GridSelection
         */

        /**
         * Mixin for Grid that handles row and cell selection.
         *
         * @example
         * // select a row
         * grid.selectedRow = 7;
         *
         * // select a cell
         * grid.selectedCell = { id: 5, columnId: 'column1' }
         *
         * // select a record
         * grid.selectedRecord = grid.store.last;
         *
         * // select multiple records by ids
         * grid.selectedRecords = [1, 2, 4, 6]
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(GridSelection, _ref);

              function GridSelection() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, GridSelection);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(GridSelection, [{
                key: "afterConfigure",
                //region Init
                value: function afterConfigure() {
                  var me = this; // Inject our CheckColumn into the ColumnStore

                  if (me.selectionMode.checkbox) {
                    var col = me.checkboxColumn = new _column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
                      id: "".concat(me.id, "-selection-column"),
                      width: '4em',
                      field: null,
                      // Always put the checkcolumn in the first region
                      region: Object.keys(me.subGridConfigs).sort()[0]
                    });
                    col.meta.depth = 0; // This is assigned in Column.js for normal columns

                    col._grid = me; // Override renderer to inject the rendered record's selected status into the value

                    var checkboxRenderer = col.renderer;

                    col.renderer = function (renderData) {
                      renderData.value = me.isSelected(renderData.record);
                      checkboxRenderer.call(col, renderData);
                    };

                    col.on({
                      toggle: 'onCheckChange',
                      thisObj: me
                    }); // Insert the checkbox after any rownumber column. If not there, -1 means in at 0.

                    var insertIndex = me.columns.indexOf(me.columns.findRecord('type', 'rownumber')) + 1;
                    me.columns.insert(insertIndex, col);
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "afterConfigure", this).call(this);
                } //endregion
                //region Events

                /**
                 * The selection has been changed.
                 * @event selectionchange
                 * @param {String} action `'select'`/`'deselect'`
                 * @param {String} mode `'row'`/`'cell'`
                 * @param {Grid.view.Grid} source
                 * @param {Common.data.Model[]|Object} deselected The records or cells (depending on the `mode`) deselected in this operation.
                 * @param {Common.data.Model[]|Object} selected The records or cells (depending on the `mode`) selected in this operation.
                 * @param {Common.data.Model[]|Object} selection  The records or cells (depending on the `mode`) in the new selection.
                 */

                /**
                 * Responds to mutations of the underlying storage Collection
                 * @param {Object} event
                 * @private
                 */

              }, {
                key: "onRecordCollectionChange",
                value: function onRecordCollectionChange(_ref2) {
                  var recordCollection = _ref2.source,
                      action = _ref2.action,
                      _ref2$added = _ref2.added,
                      added = _ref2$added === void 0 ? [] : _ref2$added,
                      removed = _ref2.removed;
                  var me = this;

                  if (me._selectedCell && !me.isSelectable(me._selectedCell)) {
                    me.deselectCell(me._selectedCell);
                  } // Filter out unselectable rows


                  added = added.filter(function (row) {
                    return me.isSelectable(row);
                  });
                  me.triggerChangeEvent({
                    mode: 'row',
                    action: added.length ? 'select' : 'deselect',
                    selection: me.selectedRecords,
                    selected: added,
                    deselected: removed
                  }, me.silent);
                }
              }, {
                key: "onCheckChange",
                value: function onCheckChange(_ref3) {
                  var checked = _ref3.checked,
                      record = _ref3.record;

                  if (checked) {
                    this.selectRow(record, false, true);
                  } else {
                    this.deselectRow(record);
                  }
                }
              }, {
                key: "onElementKeyDown",
                value: function onElementKeyDown(event) {
                  var me = this,
                      focusedCell = me.focusedCell,
                      checkboxColumn = me.checkboxColumn;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "onElementKeyDown", this).call(this, event); // SPACE key on our CheckColumn toggles it


                  if (focusedCell && event.key === ' ' && checkboxColumn && me.columns.getById(focusedCell.columnId) === checkboxColumn) {
                    var checkbox = me.getCell(focusedCell).widget;

                    if (checkbox) {
                      checkbox.toggle();
                    }
                  }
                } //endregion
                //region Selection collection

              }, {
                key: "spliceSelectedRecords",

                /**
                 * Removes and adds records to/from the selection at the same time. Analogous
                 * to the `Array` `splice` method.
                 *
                 * Note that if items that are specified for removal are also in the `toAdd` array,
                 * then those items are *not* removed then appended. They remain in the same position
                 * relative to all remaining items.
                 *
                 * @param {Number} index Index at which to remove a block of items. Only valid if the
                 * second, `toRemove` argument is a number.
                 * @param {Object[]|Number} toRemove Either the number of items to remove starting
                 * at the passed `index`, or an array of items to remove (If an array is passed, the `index` is ignored).
                 * @param  {Object[]|Object} toAdd An item, or an array of items to add.
                 */
                value: function spliceSelectedRecords(index, toRemove, toAdd) {
                  this._recordCollection.splice(index, toRemove, toAdd);
                } //endregion
                //region Cell & row

                /**
                 * Checks whether or not a cell or row is selected.
                 * @param {Object|string|Number|Common.data.Model} cellSelectorOrId Cell selector { id: x, column: xx } or row id, or record
                 * @returns {Boolean} true if cell or row is selected, otherwise false
                 * @category Selection
                 */

              }, {
                key: "isSelected",
                value: function isSelected(cellSelectorOrId) {
                  var me = this; // A record passed

                  if (cellSelectorOrId instanceof _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_17__["default"]) {
                    cellSelectorOrId = cellSelectorOrId.id;
                  }

                  if (validIdTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_4___default()(cellSelectorOrId)]) {
                    return me.recordCollection.includes(cellSelectorOrId);
                  } else {
                    return me._selectedCell && me._selectedCell.id == cellSelectorOrId.id && me._selectedCell.columnId === cellSelectorOrId.columnId;
                  }
                }
                /**
                 * Checks whether or not a cell or row can be selected.
                 * @param recordCellOrId Record or cell or record id
                 * @returns {Boolean} true if cell or row cane be selected, otherwise false
                 * @category Selection
                 */

              }, {
                key: "isSelectable",
                value: function isSelectable(recordCellOrId) {
                  // Selection disabled for undefined record, special row (group header / footer) and
                  // record which was already removed from store
                  if (!recordCellOrId) {
                    return false;
                  }

                  var row = this.store.getById(recordCellOrId.id || recordCellOrId);
                  return row && !(row.meta && row.meta.specialRow);
                }
                /**
                 * Cell selector for selected cell, set to select a cell or use {@link #function-selectCell()}.
                 * @property {Object}
                 * @category Selection
                 */

              }, {
                key: "selectRow",

                /**
                 * Selects a row (without selecting a cell).
                 * @param recordOrId Record or record id, specifying null will deselect all
                 * @param {Boolean} scrollIntoView Specify `false` to prevent row from being scrolled into view
                 * @param {Boolean} addToSelection Specify `true` to add to selection, defaults to `false` which replaces
                 * @fires selectionchange
                 * @category Selection
                 */
                value: function selectRow(recordOrId) {
                  var scrollIntoView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  var addToSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var me = this,
                      record = me.store.getById(recordOrId);

                  if (record) {
                    me.selectCell({
                      id: record.id
                    }, scrollIntoView, addToSelection);
                  } else {
                    me.deselectAll();
                  }
                }
                /**
                 * Selects a cell and/or its row (depending on selectionMode)
                 * @param {Object} cellSelector { id: rowId, columnId: 'columnId' }
                 * @param {Boolean} scrollIntoView Specify false to prevent row from being scrolled into view
                 * @param {Boolean} addToSelection Specify `true` to add to selection, defaults to `false` which replaces
                 * @param {Boolean} silent Specify `true` to not trigger any events when selecting the cell
                 * @returns {Object} Cell selector
                 * @fires selectionchange
                 * @category Selection
                 */

              }, {
                key: "selectCell",
                value: function selectCell(cellSelector) {
                  var scrollIntoView = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  var addToSelection = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var silent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                  var me = this,
                      recordCollection = me.recordCollection,
                      selectionMode = me.selectionMode,
                      selector = me.normalizeCellContext(cellSelector),
                      record = selector.record || me.store.getById(selector.id); // Clear selection if row is not selectable

                  if (!me.isSelectable(record)) {
                    this.deselectAll();
                    return;
                  }

                  if (scrollIntoView) {
                    me.scrollRowIntoView(selector.id, {
                      column: selector.columnId
                    });
                  } // Row selection (both sides if locked columns)


                  if (selectionMode.row) {
                    if (silent) {
                      me.silent = (me.silent || 0) + 1;
                    }

                    if (addToSelection) {
                      recordCollection.add(record);
                    } // Clear all others
                    else {
                        recordCollection.splice(0, recordCollection.count, record);
                      }

                    if (silent) {
                      me.silent--;
                    } // When starting a selection, register the start cell


                    if (me.recordCollection.count === 1) {
                      me.startCell = selector;
                      me.lastRange = null;
                    }
                  } // Cell selection


                  if (selectionMode.cell && (selector.columnId || selector.column) && !me.isSelected(selector)) {
                    var deselected = me._selectedCell ? [me._selectedCell] : []; //Remember

                    me._selectedCell = selector;
                    me.triggerChangeEvent({
                      mode: 'cell',
                      action: 'select',
                      selected: [selector],
                      deselected: deselected,
                      selection: [selector]
                    }, silent);
                  }

                  return selector;
                }
                /**
                 * Deselects all selected rows and cells
                 * @category Selection
                 */

              }, {
                key: "deselectAll",
                value: function deselectAll() {
                  var me = this;
                  me.recordCollection.clear();

                  if (me._selectedCell) {
                    me.deselectCell(me._selectedCell);
                  }
                }
                /**
                 * Deselect a row
                 * @param {Common.data.Model|String|Number} recordOrId Record or an id for a record
                 * @category Selection
                 */

              }, {
                key: "deselectRow",
                value: function deselectRow(recordOrId) {
                  var record = recordOrId instanceof _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_17__["default"] ? recordOrId : this.store.getById(recordOrId);
                  record && this.recordCollection.remove(record);
                }
                /**
                 * Deselect a cell/row, depending on settings in Grid#selectionMode
                 * @param {Object} cellSelector
                 * @returns {Object} Normalized cell selector
                 * @category Selection
                 */

              }, {
                key: "deselectCell",
                value: function deselectCell(cellSelector) {
                  var me = this,
                      selector = me.normalizeCellContext(cellSelector),
                      selMode = me.selectionMode,
                      record = selector.record || me.store.getById(selector.id),
                      selectedCell = me._selectedCell; // Row selection (both sides if locked columns)

                  if (selMode.row) {
                    me.recordCollection.remove(record);
                  } // Cell selection


                  if (selMode.cell && selector.columnId && selectedCell) {
                    if (selectedCell.id === selector.id && selectedCell.columnId === selector.columnId) {
                      me._selectedCell = null;
                      me.triggerChangeEvent({
                        mode: 'cell',
                        action: 'deselect',
                        selected: [],
                        deselected: [selector],
                        selection: []
                      });
                    }
                  }

                  return selector;
                } //endregion
                //region Record

                /**
                 * Selects rows corresponding to a range of records (from fromId to toId)
                 * @param {String|Number} fromId
                 * @param {String|Number} toId
                 * @category Selection
                 */

              }, {
                key: "selectRange",
                value: function selectRange(fromId, toId) {
                  var store = this.store,
                      recordCollection = this.recordCollection,
                      fromIndex = store.indexOf(fromId),
                      toIndex = store.indexOf(toId),
                      startIndex = Math.min(fromIndex, toIndex),
                      endIndex = Math.max(fromIndex, toIndex);

                  if (startIndex === -1 || endIndex === -1) {
                    throw new Error('Record not found in selectRange');
                  }

                  recordCollection.splice(0, recordCollection.count, store.getRange(startIndex, endIndex + 1, false));
                }
                /**
                 * Triggered from Grid view when records get removed from the store.
                 * Deselects all records which have been removed.
                 * @private
                 * @category Selection
                 */

              }, {
                key: "onStoreRemove",
                value: function onStoreRemove(event) {
                  // If the next mixin up the inheritance chain has an implementation, call it
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "onStoreRemove", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "onStoreRemove", this).call(this, event);
                  this.recordCollection.remove(event.records);
                }
                /**
                 * Triggered from Grid view when the store changes. This might happen
                 * if store events are batched and then resumed.
                 * Deselects all records which have been removed.
                 * @private
                 * @category Selection
                 */

              }, {
                key: "onStoreDataChange",
                value: function onStoreDataChange(_ref4) {
                  var action = _ref4.action,
                      store = _ref4.source; // If the next mixin up the inheritance chain has an implementation, call it

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "onStoreDataChange", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "onStoreDataChange", this).apply(this, arguments);

                  if (['dataset', 'batch'].includes(action)) {
                    var selectedRecords = this.recordCollection,
                        toRemove = [];
                    selectedRecords.forEach(function (record) {
                      if (!store.includes(record)) {
                        toRemove.push(record);
                      }
                    }); // Remove in one go to fire a single selectionChange event

                    selectedRecords.remove(toRemove);
                  }
                }
                /**
                 * Triggered from Grid view when all records get removed from the store.
                 * Deselects all records.
                 * @private
                 * @category Selection
                 */

              }, {
                key: "onStoreRemoveAll",
                value: function onStoreRemoveAll() {
                  // If the next mixin up the inheritance chain has an implementation, call it
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "onStoreRemoveAll", this) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSelection.prototype), "onStoreRemoveAll", this).call(this);
                  this.deselectAll();
                } //endregion
                //region Handle multiSelect

                /**
                 * Handles multi selection using the mouse. Called from GridElementEvents on mousedown in a cell and
                 * simultaneously pressing a modifier key.
                 * @param cellData
                 * @param event
                 * @private
                 * @category Selection
                 */

              }, {
                key: "handleMouseMultiSelect",
                value: function handleMouseMultiSelect(cellData, event) {
                  var me = this,
                      id = cellData.id;

                  function mergeRange(fromId, toId) {
                    var store = me.store,
                        recordCollection = me.recordCollection,
                        fromIndex = store.indexOf(fromId),
                        toIndex = store.indexOf(toId),
                        startIndex = Math.min(fromIndex, toIndex),
                        endIndex = Math.max(fromIndex, toIndex);

                    if (startIndex === -1 || endIndex === -1) {
                      throw new Error('Record not found in selectRange');
                    }

                    var newRange = store.getRange(startIndex, endIndex + 1, false).filter(function (row) {
                      return me.isSelectable(row);
                    });
                    recordCollection.splice(0, me.lastRange || 0, newRange);
                    me.lastRange = newRange;
                  }

                  if ((event.metaKey || event.ctrlKey) && me.isSelected(id)) {
                    // ctrl/cmd deselects row if selected
                    me.deselectRow(id);
                  } else if (me.selectionMode.multiSelect) {
                    if (event.shiftKey && me.startCell) {
                      // shift appends selected range (if we have previously focused cell)
                      mergeRange(me.startCell.id, id);
                    } else if (event.ctrlKey || event.metaKey) {
                      // ctrl/cmd adds to selection if using multiselect (and not selected)
                      me.selectRow(id, false, true);
                    }
                  }
                } //endregion
                //region Navigation

                /**
                 * Triggered from GridNavigation when focus is moved to another cell within the grid. Selects the cell unless
                 * modifier keys are pressed, in which case it has already been handled
                 * @private
                 * @category Selection
                 */

              }, {
                key: "onCellNavigate",
                value: function onCellNavigate(me, fromCellSelector, toCellSelector, event) {
                  var doSelect = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true; // CheckColumn events are handled by the CheckColumn itself.

                  if (me.columns.getById(toCellSelector.columnId) === me.checkboxColumn) {
                    return;
                  } // 1.do not affect selection if focus is returning to the grid from some widget
                  // 2. don't select when clicking expander icon in a tree


                  if (!doSelect || me.returningFocus || event && event.target.classList.contains('b-tree-expander')) {
                    return;
                  }

                  var isSameRecord = fromCellSelector && toCellSelector.id === fromCellSelector.id,
                      isMouse = event && event.type === 'mousedown',
                      isMouseCtrl = isMouse && event.ctrlKey; // SHIFT for keyboard / mouse and CTRL for mouse events indicate multiselect

                  if (event && (!event.button || event.button === 2) && (event.shiftKey || isMouseCtrl)) {
                    me.handleMouseMultiSelect(toCellSelector, event);
                  } else {
                    me.selectCell(toCellSelector, false, isSameRecord && (!event || event.shiftKey || event.ctrlKey) || event && (isMouseCtrl || event.button === 2 && me.isSelected(toCellSelector.id)));
                  } // Remember last cell with ctrl pressed


                  if (!me.startCell || isMouseCtrl) {
                    me.startCell = toCellSelector;
                    me.lastRange = null;
                  }
                }
                /**
                 * Keeps the UI synced with the selectionchange event before firing it out.
                 * Event is not fired if the `silent` parameter is truthy.
                 * @param {Object} selectionChangeEvent The change event to sync the UI to, and to possibly fire.
                 * @param {Boolean} silent Specify `true` to not trigger any the passed.
                 * @private
                 * @category Selection
                 */

              }, {
                key: "triggerChangeEvent",
                value: function triggerChangeEvent(selectionChangeEvent, silent) {
                  var me = this,
                      mode = selectionChangeEvent.mode,
                      selected = selectionChangeEvent.selected,
                      deselected = selectionChangeEvent.deselected;
                  var i, len, row, cell; // Keep the UI up to date with the triggered changes.
                  // A mode: 'row' change selects and/or deselects records.

                  if (mode === 'row') {
                    for (i = 0, len = selected.length; i < len; i++) {
                      row = me.getRowFor(selected[i]);

                      if (row) {
                        row.addCls('b-selected');

                        if (me.checkboxColumn && !selected[i].meta.specialRow) {
                          row.getCell(me.checkboxColumn.id).widget.checked = true;
                        }
                      }
                    }

                    for (i = 0, len = deselected.length; i < len; i++) {
                      row = me.getRowFor(deselected[i]);

                      if (row) {
                        row.removeCls('b-selected');

                        if (me.checkboxColumn && !deselected[i].meta.specialRow) {
                          row.getCell(me.checkboxColumn.id).widget.checked = false;
                        }
                      }
                    }
                  } // A mode: 'cell' change selects and/or deselects *one* cell right now.
                  // But we always use an array for future-proofing.
                  else if (mode === 'cell') {
                      for (i = 0, len = selected.length; i < len; i++) {
                        cell = me.getCell(selected[i]);

                        if (cell) {
                          cell.classList.add('b-selected');
                        }
                      }

                      for (i = 0, len = deselected.length; i < len; i++) {
                        cell = me.getCell(deselected[i]);

                        if (cell) {
                          cell.classList.remove('b-selected');
                        }
                      }
                    }

                  if (!silent) {
                    me.trigger('selectionChange', selectionChangeEvent);
                  }
                } //endregion
                //region Getters/setters
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "recordCollection",
                set: function set(recordCollection) {
                  if (!(recordCollection instanceof _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_16__["default"])) {
                    recordCollection = new _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_16__["default"](recordCollection);
                  }

                  this._recordCollection = recordCollection; // Fire row change events from onRecordCollectionChange

                  recordCollection.on({
                    change: 'onRecordCollectionChange',
                    thisObj: this
                  });
                },
                get: function get() {
                  return this._recordCollection;
                }
              }, {
                key: "selectedCell",
                get: function get() {
                  return this._selectedCell;
                },
                set: function set(cellSelector) {
                  this.selectCell(cellSelector);
                }
                /**
                 * The last selected record. Set to select a row or use Grid#selectRow. Set to null to
                 * deselect all
                 * @property {Common.data.Model}
                 * @category Selection
                 */

              }, {
                key: "selectedRecord",
                get: function get() {
                  return this.recordCollection.last || null;
                },
                set: function set(record) {
                  this.selectRow(record);
                }
                /**
                 * Selected records.
                 * Can be set as array of ids.
                 * ```
                 * grid.selectedRecords = [1, 2, 4, 6]
                 * ```
                 *
                 * @property {Common.data.Model[]|Number[]}
                 * @category Selection
                 */

              }, {
                key: "selectedRecords",
                get: function get() {
                  return this.recordCollection.values;
                },
                set: function set(selectedRecords) {
                  var recordCollection = this.recordCollection,
                      store = this.store,
                      toSelect = [];

                  if (selectedRecords && selectedRecords.length) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = selectedRecords[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var record = _step.value;
                        record = store.getById(record);

                        if (record) {
                          toSelect.push(record);
                        }
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }
                  } // Replace the entire selected collection with the new record set


                  recordCollection.splice(0, recordCollection.count, toSelect);
                }
                /**
                 * CSS selector for the currently selected cell. Format is "[data-index=index] [data-column=column]".
                 * @type {String}
                 * @category Selection
                 * @readonly
                 */

              }, {
                key: "selectedCellCSSSelector",
                get: function get() {
                  var me = this,
                      cell = me._selectedCell,
                      row = cell && me.getRowById(cell.id);
                  if (!cell || !row) return '';
                  return "[data-index=".concat(row.dataIndex, "] [data-column-id=").concat(cell.columnId, "]");
                }
              }, {
                key: "widgetClass",
                get: function get() {} //endregion

              }], [{
                key: "defaultConfig",
                get: function get() {
                  return {
                    recordCollection: {}
                  };
                }
              }]);

              return GridSelection;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/mixin/GridState.js":
      /*!************************************************!*\
        !*** ../Grid/lib/Grid/view/mixin/GridState.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewMixinGridStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler'; // TODO: prevent multiple rerenders

        /**
         * @module Grid/view/mixin/GridState
         */

        /**
         * Mixin for Grid that handles state. It serializes the following grid properties:
         *
         * * rowHeight
         * * readOnly
         * * selectedCell
         * * selectedRecords
         * * columns (order, widths, visibility)
         * * store (sorters, groupers, filters)
         * * scroll position
         *
         * See {@link Common.mixin.State} for more information on state.
         *
         * @demo state
         * @externalexample grid/State.js
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(GridState, _ref);

              function GridState() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, GridState);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(GridState).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(GridState, [{
                key: "getState",

                /**
                 * Get grids current state for serialization. State includes rowHeight, headerHeight, readOnly, selectedCell,
                 * selectedRecordId, column states and store state.
                 * @returns {Object} State object to be serialized
                 * @private
                 */
                value: function getState() {
                  var me = this,
                      style = me.element.style.cssText,
                      state = {
                    rowHeight: me.rowHeight,
                    readOnly: me.readOnly
                  };

                  if (style) {
                    state.style = style;
                  }

                  if (me.selectedCell) {
                    // TODO: Create wrapper class to avoid JSON.stringify recursion in state.selectedCell.
                    var _me$selectedCell = me.selectedCell,
                        id = _me$selectedCell.id,
                        columnId = _me$selectedCell.columnId;
                    state.selectedCell = {
                      id: id,
                      columnId: columnId
                    };
                  }

                  state.selectedRecords = me.selectedRecords.map(function (entry) {
                    return entry.id;
                  });
                  state.columns = me.columns.map(function (column) {
                    return column.getState();
                  });
                  state.store = me.store.state;
                  state.scroll = me.storeScroll();
                  state.width = {};
                  state.collapsed = {};
                  me.eachSubGrid(function (subGrid) {
                    if (subGrid.flex == null) {
                      state.width[subGrid.region] = subGrid.width;
                    }

                    state.collapsed[subGrid.region] = subGrid.collapsed;
                  });
                  return state;
                }
                /**
                 * Apply previously stored state.
                 * @param {Object} state
                 * @private
                 */

              }, {
                key: "applyState",
                value: function applyState(state) {
                  var me = this;

                  if ('readOnly' in state) {
                    me.readOnly = state.readOnly;
                  }

                  if ('rowHeight' in state) {
                    me.rowHeight = state.rowHeight;
                  }

                  if ('style' in state) {
                    me.style = state.style;
                  }

                  if ('selectedCell' in state) {
                    me.selectedCell = state.selectedCell;
                  }

                  if ('store' in state) {
                    me.store.state = state.store;
                  }

                  if ('selectedRecords' in state) {
                    me.selectedRecords = state.selectedRecords;
                  }

                  if ('columns' in state) {
                    // each column triggers rerender at least once...
                    state.columns.forEach(function (columnState) {
                      var column = me.columns.getById(columnState.id);

                      if (column) {
                        column.applyState(columnState);
                        column.stateSortIndex = columnState.index;
                      }
                    });
                    me.eachSubGrid(function (subGrid) {
                      subGrid.columns.records.sort(function (a, b) {
                        return a.stateSortIndex - b.stateSortIndex;
                      });
                      subGrid.columns.allRecords.sort(function (a, b) {
                        return a.stateSortIndex - b.stateSortIndex;
                      });
                    });
                    me.columns.sort({
                      fn: function fn(a, b) {
                        return a.stateSortIndex - b.stateSortIndex;
                      } // always sort ascending

                    }, true); // manually triggered rerender

                    me.rendered ? me.renderContents() : me.render();
                  }

                  if ('width' in state) {
                    me.eachSubGrid(function (subGrid) {
                      if (subGrid.region in state.width) {
                        subGrid.width = state.width[subGrid.region];
                      }
                    });
                  }

                  if ('collapsed' in state) {
                    me.eachSubGrid(function (subGrid) {
                      subGrid.collapsed = state.collapsed[subGrid.region];
                    });
                  }

                  if ('scroll' in state) {
                    me.restoreScroll(state.scroll);
                  }
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return GridState;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/lib/Grid/view/mixin/GridSubGrids.js":
      /*!***************************************************!*\
        !*** ../Grid/lib/Grid/view/mixin/GridSubGrids.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function GridLibGridViewMixinGridSubGridsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "../Grid/node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "../Grid/node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "../Grid/node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "../Grid/node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "../Grid/node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "../Grid/node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "../Grid/node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "../Grid/node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "../Grid/node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _column_Column_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../column/Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _Grid_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../Grid.js */
        "../Grid/lib/Grid/view/Grid.js");
        /* harmony import */


        var _SubGrid_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../SubGrid.js */
        "../Grid/lib/Grid/view/SubGrid.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Grid/view/mixin/GridSubGrids
         */

        /**
         * Mixin for grid that handles SubGrids. Each SubGrid is scrollable horizontally separately from the other SubGrids.
         * Having two SubGrids allows you to achieve what is usually called locked or frozen columns.
         *
         * By default a Grid has two SubGrids, one named 'locked' and one 'normal'. The `locked` region has fixed width, while
         * the `normal` region grows to fill all available width (flex).
         *
         * Which SubGrid a column belongs to is
         * determined using its {@link Grid.column.Column#config-region} config. For example to put a column into the locked
         * region, specify `{ region: 'locked' }`. For convenience, a column can be put in the locked region using
         * `{ locked: true }`.
         *
         * @example
         * { data: 'name', text: 'Name', locked: true }
         * { data: 'age', text: 'Age', region: 'locked' }
         *
         * @demo features
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(GridSubGrids, _ref);

              function GridSubGrids() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, GridSubGrids);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSubGrids).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(GridSubGrids, [{
                key: "initSubGrids",
                //region Init

                /**
                 * Initializes subGrids from subGrid configs in config.subGridConfigs. Regions specified on columns but not The default config.subGridConfigs is:
                 * { normal: { flex: 1 } }
                 * @private
                 * @category SubGrid
                 */
                value: function initSubGrids() {
                  var me = this,
                      oldRegions = me._regions,
                      usedRegions = new Set();
                  var first = true,
                      hasCalculatedWidth,
                      subGridConfig,
                      subGridColumns; // TODO: move into subgrid or columnmanager

                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = me.columns.records[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var column = _step.value;

                      if (column.region && !me.subGridConfigs[column.region]) {
                        me.subGridConfigs[column.region] = {};
                      }

                      usedRegions.add(column.region);
                    } // If "reconfiguring" columns, we are going to create new subgrids so destroy any existing

                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }

                  if (oldRegions) {
                    oldRegions.forEach(function (region) {
                      return me.subGrids[region].destroy();
                    });
                  }
                  /**
                   * An object containing the {@link Grid.view.SubGrid} region instances, indexed by subGrid id ('locked', normal'...)
                   * @property {Object} subGrids
                   * @readonly
                   */


                  me.subGrids = {};
                  me._regions = Array.from(usedRegions);

                  me._regions.sort(); // Implementer has provided configs for other subGrids but not normal, put defaults in place


                  if (me.subGridConfigs.normal && Object.keys(me.subGridConfigs.normal).length === 0) {
                    me.subGridConfigs.normal = _Grid_js__WEBPACK_IMPORTED_MODULE_16__["default"].defaultConfig.subGridConfigs.normal;
                  }

                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    var _loop = function _loop() {
                      var region = _step2.value;
                      subGridColumns = me.columns.makeChained(function (column) {
                        return column.childLevel === 0 && column.region === region;
                      }, ['region']);
                      subGridConfig = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].assign({}, me.subGridConfigs[region], {
                        owner: me,
                        grid: me,
                        store: me.store,
                        rowManager: me.rowManager,
                        region: region,
                        headerClass: me.subGridConfigs[region].headerClass || me.headerClass,
                        columns: subGridColumns,
                        hideHeaders: me.hideHeaders
                      });
                      hasCalculatedWidth = false;

                      if (!subGridConfig.flex && !subGridConfig.width) {
                        subGridConfig.width = subGridColumns.totalFixedWidth;
                        hasCalculatedWidth = true;
                      }

                      me.subGrids[region] = new _SubGrid_js__WEBPACK_IMPORTED_MODULE_17__["default"](subGridConfig); // Must be set after creation, otherwise reset in SubGrid#set width

                      me.subGrids[region].hasCalculatedWidth = hasCalculatedWidth;

                      if (first) {
                        // Have already done lookups for this in a couple of places, might as well store it...
                        me.subGrids[region].isFirstRegion = true;
                        first = false;
                      }
                    };

                    for (var _iterator2 = me._regions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      _loop();
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                }
                /**
                 * Destroy all SubGrids.
                 * @private
                 */

              }, {
                key: "doDestroy",
                value: function doDestroy() {
                  this.callEachSubGrid('destroy');

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(GridSubGrids.prototype), "doDestroy", this).call(this);
                } //endregion
                //region Iteration & calling

                /**
                 * Iterate over all subGrids, calling the supplied function for each.
                 * @param {Function} fn Function to call for each instance
                 * @param {Object} thisObj `this` reference to call the function in, defaults to the subGrid itself
                 * @category SubGrid
                 * @internal
                 */

              }, {
                key: "eachSubGrid",
                value: function eachSubGrid(fn) {
                  var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                  var me = this; //for (let subGrid of Object.values(this.subGrids)) {

                  me.regions.forEach(function (region, i) {
                    var subGrid = me.subGrids[region];
                    fn.call(thisObj || subGrid, subGrid, i++);
                  });
                }
              }, {
                key: "eachWidget",
                value: function eachWidget(fn) {
                  var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  var me = this;
                  me.regions.forEach(function (region) {
                    var widget = me.subGrids[region];

                    if (fn(widget) === false) {
                      return;
                    }

                    if (deep && widget.eachWidget) {
                      widget.eachWidget(fn, deep);
                    }
                  });
                }
                /**
                 * Call a function by name for all subGrids (that have the function).
                 * @param {String} fnName Name of function to call, uses the subGrid itself as `this` reference
                 * @param params Parameters to call the function with
                 * @return {*} Return value from first SubGrid is returned
                 * @category SubGrid
                 * @internal
                 */

              }, {
                key: "callEachSubGrid",
                value: function callEachSubGrid(fnName) {
                  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    params[_key - 1] = arguments[_key];
                  } // TODO: make object { normal: retval, locked: retval } to return? or store. revisit when needed


                  var me = this,
                      returnValue = null; //Object.values(this.subGrids).forEach((subGrid, i) => {

                  me.regions.forEach(function (region, i) {
                    var subGrid = me.subGrids[region];

                    if (subGrid[fnName]) {
                      var partialReturnValue = subGrid[fnName].apply(subGrid, params);
                      if (i === 0) returnValue = partialReturnValue;
                    }
                  });
                  return returnValue;
                } //endregion
                //region Getters

                /**
                 * This method should return names of the two last regions in the grid as they are visible in the UI. In case
                 * `regions` property cannot be trusted, use different approach. Used by SubGrid and RegionResize to figure out
                 * which region should collapse or expand.
                 * @returns {String[]}
                 * @private
                 * @category SubGrid
                 */

              }, {
                key: "getLastRegions",
                value: function getLastRegions() {
                  var result = this.regions.slice(-2); // ALWAYS return array of length 2 in order to avoid extra conditions. Normally should not be called with 1 region

                  return result.length === 2 ? result : [result[0], result[0]];
                }
                /**
                 * This method should return right neighbour for passed region, or left neighbour in case last visible region is passed.
                 * This method is used to decide which subgrid should take space of the collapsed one.
                 * @param {String} region
                 * @returns {String}
                 * @private
                 * @category SubGrid
                 */

              }, {
                key: "getNextRegion",
                value: function getNextRegion(region) {
                  var regions = this.regions; // return next region or next to last

                  return regions[regions.indexOf(region) + 1] || regions[regions.length - 2];
                }
              }, {
                key: "getPreviousRegion",
                value: function getPreviousRegion(region) {
                  return this.regions[this.regions.indexOf(region) - 1];
                }
                /**
                 * Returns the subGrid for the specified region.
                 * @param {String} region Region, eg. locked or normal (per default)
                 * @returns {Grid.view.SubGrid} A subGrid
                 * @category SubGrid
                 */

              }, {
                key: "getSubGrid",
                value: function getSubGrid(region) {
                  return this.subGrids[region];
                }
                /**
                 * Get the SubGrid that contains specified column
                 * @param {String|Grid.column.Column} column Column "name" or column object
                 * @returns {Grid.view.SubGrid}
                 * @category SubGrid
                 */

              }, {
                key: "getSubGridFromColumn",
                value: function getSubGridFromColumn(column) {
                  column = column instanceof _column_Column_js__WEBPACK_IMPORTED_MODULE_15__["default"] ? column : this.columns.get(column) || this.columns.getById(column);
                  return this.getSubGrid(column.region);
                }
              }, {
                key: "onSubGridCollapse",
                //endregion
                //region Resize
                //endregion
                value: function onSubGridCollapse(subGrid) {
                  var splitterEl = this.resolveSplitter(subGrid);
                  splitterEl.classList.add('b-grid-splitter-collapsed'); // 5 in next 2 lines is the default splitter width as defined in SASS.

                  splitterEl.style.width = "".concat(subGrid.collapsedStateWidth + subGrid.splitterWidth, "px");
                  splitterEl.style.left = "".concat(Math.max(subGrid.element.offsetLeft - subGrid.splitterWidth, 0), "px");
                }
              }, {
                key: "onSubGridExpand",
                value: function onSubGridExpand(subGrid) {
                  var splitterEl = this.resolveSplitter(subGrid);
                  splitterEl.classList.remove('b-grid-splitter-collapsed');
                  splitterEl.style.width = '';
                }
                /**
                 * Returns splitter element for subgrid
                 * @param {Grid.view.SubGrid|String} subGrid
                 * @returns {HTMLElement}
                 * @private
                 * @category SubGrid
                 */

              }, {
                key: "resolveSplitter",
                value: function resolveSplitter(subGrid) {
                  var me = this,
                      regions = me.getLastRegions();
                  var region = subGrid instanceof _SubGrid_js__WEBPACK_IMPORTED_MODULE_17__["default"] ? subGrid.region : subGrid;

                  if (regions[1] === region) {
                    region = regions[0];
                  }

                  return this.subGrids[region].splitterElement;
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "regions",
                get: function get() {
                  if (!this._regions) {
                    this.initSubGrids();
                  }

                  return this._regions;
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return GridSubGrids;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"])
          );
        };
        /***/

      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/arrayWithHoles.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/arrayWithHoles.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersArrayWithHolesJs(module, exports) {
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }

        module.exports = _arrayWithHoles;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
      /*!************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersArrayWithoutHolesJs(module, exports) {
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }
        }

        module.exports = _arrayWithoutHoles;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/assertThisInitialized.js":
      /*!****************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/assertThisInitialized.js ***!
        \****************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersAssertThisInitializedJs(module, exports) {
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return self;
        }

        module.exports = _assertThisInitialized;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/asyncToGenerator.js":
      /*!***********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/asyncToGenerator.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersAsyncToGeneratorJs(module, exports) {
        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }

        module.exports = _asyncToGenerator;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/classCallCheck.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersClassCallCheckJs(module, exports) {
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        module.exports = _classCallCheck;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/construct.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/construct.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersConstructJs(module, exports, __webpack_require__) {
        var setPrototypeOf = __webpack_require__(
        /*! ./setPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/setPrototypeOf.js");

        function isNativeReflectConstruct() {
          if (typeof Reflect === "undefined" || !Reflect.construct) return false;
          if (Reflect.construct.sham) return false;
          if (typeof Proxy === "function") return true;

          try {
            Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
            return true;
          } catch (e) {
            return false;
          }
        }

        function _construct(Parent, args, Class) {
          if (isNativeReflectConstruct()) {
            module.exports = _construct = Reflect.construct;
          } else {
            module.exports = _construct = function _construct(Parent, args, Class) {
              var a = [null];
              a.push.apply(a, args);
              var Constructor = Function.bind.apply(Parent, a);
              var instance = new Constructor();
              if (Class) setPrototypeOf(instance, Class.prototype);
              return instance;
            };
          }

          return _construct.apply(null, arguments);
        }

        module.exports = _construct;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/createClass.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/createClass.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersCreateClassJs(module, exports) {
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        module.exports = _createClass;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/defineProperty.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersDefinePropertyJs(module, exports) {
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        module.exports = _defineProperty;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/get.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/get.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersGetJs(module, exports, __webpack_require__) {
        var getPrototypeOf = __webpack_require__(
        /*! ./getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

        var superPropBase = __webpack_require__(
        /*! ./superPropBase */
        "../Grid/node_modules/@babel/runtime/helpers/superPropBase.js");

        function _get(target, property, receiver) {
          if (typeof Reflect !== "undefined" && Reflect.get) {
            module.exports = _get = Reflect.get;
          } else {
            module.exports = _get = function _get(target, property, receiver) {
              var base = superPropBase(target, property);
              if (!base) return;
              var desc = Object.getOwnPropertyDescriptor(base, property);

              if (desc.get) {
                return desc.get.call(receiver);
              }

              return desc.value;
            };
          }

          return _get(target, property, receiver || target);
        }

        module.exports = _get;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersGetPrototypeOfJs(module, exports) {
        function _getPrototypeOf(o) {
          module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }

        module.exports = _getPrototypeOf;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/inherits.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/inherits.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersInheritsJs(module, exports, __webpack_require__) {
        var setPrototypeOf = __webpack_require__(
        /*! ./setPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/setPrototypeOf.js");

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) setPrototypeOf(subClass, superClass);
        }

        module.exports = _inherits;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/iterableToArray.js":
      /*!**********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/iterableToArray.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersIterableToArrayJs(module, exports) {
        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }

        module.exports = _iterableToArray;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/iterableToArrayLimit.js":
      /*!***************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/iterableToArrayLimit.js ***!
        \***************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersIterableToArrayLimitJs(module, exports) {
        function _iterableToArrayLimit(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"] != null) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        module.exports = _iterableToArrayLimit;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/nonIterableRest.js":
      /*!**********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/nonIterableRest.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersNonIterableRestJs(module, exports) {
        function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }

        module.exports = _nonIterableRest;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/nonIterableSpread.js":
      /*!************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersNonIterableSpreadJs(module, exports) {
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }

        module.exports = _nonIterableSpread;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js":
      /*!********************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js ***!
        \********************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersPossibleConstructorReturnJs(module, exports, __webpack_require__) {
        var _typeof = __webpack_require__(
        /*! ../helpers/typeof */
        "../Grid/node_modules/@babel/runtime/helpers/typeof.js");

        var assertThisInitialized = __webpack_require__(
        /*! ./assertThisInitialized */
        "../Grid/node_modules/@babel/runtime/helpers/assertThisInitialized.js");

        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }

          return assertThisInitialized(self);
        }

        module.exports = _possibleConstructorReturn;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/set.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/set.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersSetJs(module, exports, __webpack_require__) {
        var getPrototypeOf = __webpack_require__(
        /*! ./getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

        var superPropBase = __webpack_require__(
        /*! ./superPropBase */
        "../Grid/node_modules/@babel/runtime/helpers/superPropBase.js");

        var defineProperty = __webpack_require__(
        /*! ./defineProperty */
        "../Grid/node_modules/@babel/runtime/helpers/defineProperty.js");

        function set(target, property, value, receiver) {
          if (typeof Reflect !== "undefined" && Reflect.set) {
            set = Reflect.set;
          } else {
            set = function set(target, property, value, receiver) {
              var base = superPropBase(target, property);
              var desc;

              if (base) {
                desc = Object.getOwnPropertyDescriptor(base, property);

                if (desc.set) {
                  desc.set.call(receiver, value);
                  return true;
                } else if (!desc.writable) {
                  return false;
                }
              }

              desc = Object.getOwnPropertyDescriptor(receiver, property);

              if (desc) {
                if (!desc.writable) {
                  return false;
                }

                desc.value = value;
                Object.defineProperty(receiver, property, desc);
              } else {
                defineProperty(receiver, property, value);
              }

              return true;
            };
          }

          return set(target, property, value, receiver);
        }

        function _set(target, property, value, receiver, isStrict) {
          var s = set(target, property, value, receiver || target);

          if (!s && isStrict) {
            throw new Error('failed to set property');
          }

          return value;
        }

        module.exports = _set;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/setPrototypeOf.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/setPrototypeOf.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersSetPrototypeOfJs(module, exports) {
        function _setPrototypeOf(o, p) {
          module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };

          return _setPrototypeOf(o, p);
        }

        module.exports = _setPrototypeOf;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/slicedToArray.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersSlicedToArrayJs(module, exports, __webpack_require__) {
        var arrayWithHoles = __webpack_require__(
        /*! ./arrayWithHoles */
        "../Grid/node_modules/@babel/runtime/helpers/arrayWithHoles.js");

        var iterableToArrayLimit = __webpack_require__(
        /*! ./iterableToArrayLimit */
        "../Grid/node_modules/@babel/runtime/helpers/iterableToArrayLimit.js");

        var nonIterableRest = __webpack_require__(
        /*! ./nonIterableRest */
        "../Grid/node_modules/@babel/runtime/helpers/nonIterableRest.js");

        function _slicedToArray(arr, i) {
          return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
        }

        module.exports = _slicedToArray;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/superPropBase.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/superPropBase.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersSuperPropBaseJs(module, exports, __webpack_require__) {
        var getPrototypeOf = __webpack_require__(
        /*! ./getPrototypeOf */
        "../Grid/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

        function _superPropBase(object, property) {
          while (!Object.prototype.hasOwnProperty.call(object, property)) {
            object = getPrototypeOf(object);
            if (object === null) break;
          }

          return object;
        }

        module.exports = _superPropBase;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js":
      /*!****************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js ***!
        \****************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersTaggedTemplateLiteralJs(module, exports) {
        function _taggedTemplateLiteral(strings, raw) {
          if (!raw) {
            raw = strings.slice(0);
          }

          return Object.freeze(Object.defineProperties(strings, {
            raw: {
              value: Object.freeze(raw)
            }
          }));
        }

        module.exports = _taggedTemplateLiteral;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js":
      /*!************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersToConsumableArrayJs(module, exports, __webpack_require__) {
        var arrayWithoutHoles = __webpack_require__(
        /*! ./arrayWithoutHoles */
        "../Grid/node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

        var iterableToArray = __webpack_require__(
        /*! ./iterableToArray */
        "../Grid/node_modules/@babel/runtime/helpers/iterableToArray.js");

        var nonIterableSpread = __webpack_require__(
        /*! ./nonIterableSpread */
        "../Grid/node_modules/@babel/runtime/helpers/nonIterableSpread.js");

        function _toConsumableArray(arr) {
          return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
        }

        module.exports = _toConsumableArray;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/helpers/typeof.js":
      /*!*************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/helpers/typeof.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeHelpersTypeofJs(module, exports) {
        function _typeof2(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof2 = function _typeof2(obj) {
              return typeof obj;
            };
          } else {
            _typeof2 = function _typeof2(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }

          return _typeof2(obj);
        }

        function _typeof(obj) {
          if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
            module.exports = _typeof = function _typeof(obj) {
              return _typeof2(obj);
            };
          } else {
            module.exports = _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
            };
          }

          return _typeof(obj);
        }

        module.exports = _typeof;
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime-module.js":
      /*!**********************************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime-module.js ***!
        \**********************************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeModuleJs(module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        // This method of obtaining a reference to the global object needs to be
        // kept identical to the way it is obtained in runtime.js
        var g = function () {
          return this || typeof self === "object" && self;
        }() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
        // `hasOwnProperty` on the global `self` object in a worker. See #183.


        var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

        var oldRuntime = hadRuntime && g.regeneratorRuntime; // Force reevalutation of runtime.js.

        g.regeneratorRuntime = undefined;
        module.exports = __webpack_require__(
        /*! ./runtime */
        "../Grid/node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js");

        if (hadRuntime) {
          // Restore the original runtime.
          g.regeneratorRuntime = oldRuntime;
        } else {
          // Remove the global property added by runtime.js.
          try {
            delete g.regeneratorRuntime;
          } catch (e) {
            g.regeneratorRuntime = undefined;
          }
        }
        /***/

      },

      /***/
      "../Grid/node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js":
      /*!***************************************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeJs(module, exports) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        !function (global) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.

          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
          var inModule = typeof module === "object";
          var runtime = global.regeneratorRuntime;

          if (runtime) {
            if (inModule) {
              // If regeneratorRuntime is defined globally and we're in a module,
              // make the exports object identical to regeneratorRuntime.
              module.exports = runtime;
            } // Don't bother evaluating the rest of this file if the runtime was
            // already defined globally.


            return;
          } // Define the runtime globally (as expected by generated code) as either
          // module.exports (if we're in a module) or a new, empty object.


          runtime = global.regeneratorRuntime = inModule ? module.exports : {};

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.

            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.

          var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.


          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          runtime.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          runtime.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          }; // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.


          runtime.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration.
                  result.value = unwrapped;
                  resolve(result);
                }, function (error) {
                  // If a rejected Promise was yielded, throw the rejection back
                  // into the async generator function so it can be handled there.
                  return invoke("throw", error, resolve, reject);
                });
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            } // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).


            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.

          runtime.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                } // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted; // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.

                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          } // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.


          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === "throw") {
                if (delegate.iterator.return) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

              context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            } // The delegate iterator is finished, so forget it and continue with
            // the outer generator.


            context.delegate = null;
            return ContinueSentinel;
          } // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.


          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          runtime.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse(); // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.

            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              } // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.


              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            } // Return an iterator with no values.


            return {
              next: doneResult
            };
          }

          runtime.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0; // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.

              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              } // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.


              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          };
        }( // In sloppy mode, unbound `this` refers to the global object, fallback to
        // Function constructor if we're in global strict mode. That is sadly a form
        // of indirect eval which violates Content Security Policy.
        function () {
          return this || typeof self === "object" && self;
        }() || Function("return this")());
        /***/
      },

      /***/
      "../Grid/node_modules/@babel/runtime/regenerator/index.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/@babel/runtime/regenerator/index.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesBabelRuntimeRegeneratorIndexJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! regenerator-runtime */
        "../Grid/node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime-module.js");
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_a-function.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_a-function.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_aFunctionJs(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_add-to-unscopables.js":
      /*!*******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_add-to-unscopables.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_addToUnscopablesJs(module, exports, __webpack_require__) {
        // 22.1.3.31 Array.prototype[@@unscopables]
        var UNSCOPABLES = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('unscopables');

        var ArrayProto = Array.prototype;
        if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});

        module.exports = function (key) {
          ArrayProto[UNSCOPABLES][key] = true;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_advance-string-index.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_advance-string-index.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_advanceStringIndexJs(module, exports, __webpack_require__) {
        "use strict";

        var at = __webpack_require__(
        /*! ./_string-at */
        "../Grid/node_modules/core-js/modules/_string-at.js")(true); // `AdvanceStringIndex` abstract operation
        // https://tc39.github.io/ecma262/#sec-advancestringindex


        module.exports = function (S, index, unicode) {
          return index + (unicode ? at(S, index).length : 1);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_an-instance.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_an-instance.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_anInstanceJs(module, exports) {
        module.exports = function (it, Constructor, name, forbiddenField) {
          if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
            throw TypeError(name + ': incorrect invocation!');
          }

          return it;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_an-object.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_an-object.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_anObjectJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_array-includes.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_array-includes.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_arrayIncludesJs(module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../Grid/node_modules/core-js/modules/_to-iobject.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var toAbsoluteIndex = __webpack_require__(
        /*! ./_to-absolute-index */
        "../Grid/node_modules/core-js/modules/_to-absolute-index.js");

        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this);
            var length = toLength(O.length);
            var index = toAbsoluteIndex(fromIndex, length);
            var value; // Array#includes uses SameValueZero equality algorithm
            // eslint-disable-next-line no-self-compare

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++]; // eslint-disable-next-line no-self-compare

              if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }
            return !IS_INCLUDES && -1;
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_array-methods.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_array-methods.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_arrayMethodsJs(module, exports, __webpack_require__) {
        // 0 -> Array#forEach
        // 1 -> Array#map
        // 2 -> Array#filter
        // 3 -> Array#some
        // 4 -> Array#every
        // 5 -> Array#find
        // 6 -> Array#findIndex
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../Grid/node_modules/core-js/modules/_ctx.js");

        var IObject = __webpack_require__(
        /*! ./_iobject */
        "../Grid/node_modules/core-js/modules/_iobject.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../Grid/node_modules/core-js/modules/_to-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var asc = __webpack_require__(
        /*! ./_array-species-create */
        "../Grid/node_modules/core-js/modules/_array-species-create.js");

        module.exports = function (TYPE, $create) {
          var IS_MAP = TYPE == 1;
          var IS_FILTER = TYPE == 2;
          var IS_SOME = TYPE == 3;
          var IS_EVERY = TYPE == 4;
          var IS_FIND_INDEX = TYPE == 6;
          var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
          var create = $create || asc;
          return function ($this, callbackfn, that) {
            var O = toObject($this);
            var self = IObject(O);
            var f = ctx(callbackfn, that, 3);
            var length = toLength(self.length);
            var index = 0;
            var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
            var val, res;

            for (; length > index; index++) {
              if (NO_HOLES || index in self) {
                val = self[index];
                res = f(val, index, O);

                if (TYPE) {
                  if (IS_MAP) result[index] = res; // map
                  else if (res) switch (TYPE) {
                      case 3:
                        return true;
                      // some

                      case 5:
                        return val;
                      // find

                      case 6:
                        return index;
                      // findIndex

                      case 2:
                        result.push(val);
                      // filter
                    } else if (IS_EVERY) return false; // every
                }
              }
            }

            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_array-species-constructor.js":
      /*!**************************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_array-species-constructor.js ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_arraySpeciesConstructorJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var isArray = __webpack_require__(
        /*! ./_is-array */
        "../Grid/node_modules/core-js/modules/_is-array.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (original) {
          var C;

          if (isArray(original)) {
            C = original.constructor; // cross-realm fallback

            if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;

            if (isObject(C)) {
              C = C[SPECIES];
              if (C === null) C = undefined;
            }
          }

          return C === undefined ? Array : C;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_array-species-create.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_array-species-create.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_arraySpeciesCreateJs(module, exports, __webpack_require__) {
        // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
        var speciesConstructor = __webpack_require__(
        /*! ./_array-species-constructor */
        "../Grid/node_modules/core-js/modules/_array-species-constructor.js");

        module.exports = function (original, length) {
          return new (speciesConstructor(original))(length);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_classof.js":
      /*!********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_classof.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_classofJs(module, exports, __webpack_require__) {
        // getting tag from 19.1.3.6 Object.prototype.toString()
        var cof = __webpack_require__(
        /*! ./_cof */
        "../Grid/node_modules/core-js/modules/_cof.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('toStringTag'); // ES3 wrong here


        var ARG = cof(function () {
          return arguments;
        }()) == 'Arguments'; // fallback for IE11 Script Access Denied error

        var tryGet = function tryGet(it, key) {
          try {
            return it[key];
          } catch (e) {
            /* empty */
          }
        };

        module.exports = function (it) {
          var O, T, B;
          return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
          : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
          : ARG ? cof(O) // ES3 arguments fallback
          : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_cof.js":
      /*!****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_cof.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_cofJs(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_collection-strong.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_collection-strong.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_collectionStrongJs(module, exports, __webpack_require__) {
        "use strict";

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f;

        var create = __webpack_require__(
        /*! ./_object-create */
        "../Grid/node_modules/core-js/modules/_object-create.js");

        var redefineAll = __webpack_require__(
        /*! ./_redefine-all */
        "../Grid/node_modules/core-js/modules/_redefine-all.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../Grid/node_modules/core-js/modules/_ctx.js");

        var anInstance = __webpack_require__(
        /*! ./_an-instance */
        "../Grid/node_modules/core-js/modules/_an-instance.js");

        var forOf = __webpack_require__(
        /*! ./_for-of */
        "../Grid/node_modules/core-js/modules/_for-of.js");

        var $iterDefine = __webpack_require__(
        /*! ./_iter-define */
        "../Grid/node_modules/core-js/modules/_iter-define.js");

        var step = __webpack_require__(
        /*! ./_iter-step */
        "../Grid/node_modules/core-js/modules/_iter-step.js");

        var setSpecies = __webpack_require__(
        /*! ./_set-species */
        "../Grid/node_modules/core-js/modules/_set-species.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js");

        var fastKey = __webpack_require__(
        /*! ./_meta */
        "../Grid/node_modules/core-js/modules/_meta.js").fastKey;

        var validate = __webpack_require__(
        /*! ./_validate-collection */
        "../Grid/node_modules/core-js/modules/_validate-collection.js");

        var SIZE = DESCRIPTORS ? '_s' : 'size';

        var getEntry = function getEntry(that, key) {
          // fast case
          var index = fastKey(key);
          var entry;
          if (index !== 'F') return that._i[index]; // frozen object case

          for (entry = that._f; entry; entry = entry.n) {
            if (entry.k == key) return entry;
          }
        };

        module.exports = {
          getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
            var C = wrapper(function (that, iterable) {
              anInstance(that, C, NAME, '_i');
              that._t = NAME; // collection type

              that._i = create(null); // index

              that._f = undefined; // first entry

              that._l = undefined; // last entry

              that[SIZE] = 0; // size

              if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
            });
            redefineAll(C.prototype, {
              // 23.1.3.1 Map.prototype.clear()
              // 23.2.3.2 Set.prototype.clear()
              clear: function clear() {
                for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
                  entry.r = true;
                  if (entry.p) entry.p = entry.p.n = undefined;
                  delete data[entry.i];
                }

                that._f = that._l = undefined;
                that[SIZE] = 0;
              },
              // 23.1.3.3 Map.prototype.delete(key)
              // 23.2.3.4 Set.prototype.delete(value)
              'delete': function _delete(key) {
                var that = validate(this, NAME);
                var entry = getEntry(that, key);

                if (entry) {
                  var next = entry.n;
                  var prev = entry.p;
                  delete that._i[entry.i];
                  entry.r = true;
                  if (prev) prev.n = next;
                  if (next) next.p = prev;
                  if (that._f == entry) that._f = next;
                  if (that._l == entry) that._l = prev;
                  that[SIZE]--;
                }

                return !!entry;
              },
              // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
              // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
              forEach: function forEach(callbackfn
              /* , that = undefined */
              ) {
                validate(this, NAME);
                var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;

                while (entry = entry ? entry.n : this._f) {
                  f(entry.v, entry.k, this); // revert to the last existing entry

                  while (entry && entry.r) {
                    entry = entry.p;
                  }
                }
              },
              // 23.1.3.7 Map.prototype.has(key)
              // 23.2.3.7 Set.prototype.has(value)
              has: function has(key) {
                return !!getEntry(validate(this, NAME), key);
              }
            });
            if (DESCRIPTORS) dP(C.prototype, 'size', {
              get: function get() {
                return validate(this, NAME)[SIZE];
              }
            });
            return C;
          },
          def: function def(that, key, value) {
            var entry = getEntry(that, key);
            var prev, index; // change existing entry

            if (entry) {
              entry.v = value; // create new entry
            } else {
              that._l = entry = {
                i: index = fastKey(key, true),
                // <- index
                k: key,
                // <- key
                v: value,
                // <- value
                p: prev = that._l,
                // <- previous entry
                n: undefined,
                // <- next entry
                r: false // <- removed

              };
              if (!that._f) that._f = entry;
              if (prev) prev.n = entry;
              that[SIZE]++; // add to index

              if (index !== 'F') that._i[index] = entry;
            }

            return that;
          },
          getEntry: getEntry,
          setStrong: function setStrong(C, NAME, IS_MAP) {
            // add .keys, .values, .entries, [@@iterator]
            // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
            $iterDefine(C, NAME, function (iterated, kind) {
              this._t = validate(iterated, NAME); // target

              this._k = kind; // kind

              this._l = undefined; // previous
            }, function () {
              var that = this;
              var kind = that._k;
              var entry = that._l; // revert to the last existing entry

              while (entry && entry.r) {
                entry = entry.p;
              } // get next entry


              if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return step(1);
              } // return step by kind


              if (kind == 'keys') return step(0, entry.k);
              if (kind == 'values') return step(0, entry.v);
              return step(0, [entry.k, entry.v]);
            }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2

            setSpecies(NAME);
          }
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_collection-weak.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_collection-weak.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_collectionWeakJs(module, exports, __webpack_require__) {
        "use strict";

        var redefineAll = __webpack_require__(
        /*! ./_redefine-all */
        "../Grid/node_modules/core-js/modules/_redefine-all.js");

        var getWeak = __webpack_require__(
        /*! ./_meta */
        "../Grid/node_modules/core-js/modules/_meta.js").getWeak;

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var anInstance = __webpack_require__(
        /*! ./_an-instance */
        "../Grid/node_modules/core-js/modules/_an-instance.js");

        var forOf = __webpack_require__(
        /*! ./_for-of */
        "../Grid/node_modules/core-js/modules/_for-of.js");

        var createArrayMethod = __webpack_require__(
        /*! ./_array-methods */
        "../Grid/node_modules/core-js/modules/_array-methods.js");

        var $has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var validate = __webpack_require__(
        /*! ./_validate-collection */
        "../Grid/node_modules/core-js/modules/_validate-collection.js");

        var arrayFind = createArrayMethod(5);
        var arrayFindIndex = createArrayMethod(6);
        var id = 0; // fallback for uncaught frozen keys

        var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
          return that._l || (that._l = new UncaughtFrozenStore());
        };

        var UncaughtFrozenStore = function UncaughtFrozenStore() {
          this.a = [];
        };

        var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
          return arrayFind(store.a, function (it) {
            return it[0] === key;
          });
        };

        UncaughtFrozenStore.prototype = {
          get: function get(key) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) return entry[1];
          },
          has: function has(key) {
            return !!findUncaughtFrozen(this, key);
          },
          set: function set(key, value) {
            var entry = findUncaughtFrozen(this, key);
            if (entry) entry[1] = value;else this.a.push([key, value]);
          },
          'delete': function _delete(key) {
            var index = arrayFindIndex(this.a, function (it) {
              return it[0] === key;
            });
            if (~index) this.a.splice(index, 1);
            return !!~index;
          }
        };
        module.exports = {
          getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
            var C = wrapper(function (that, iterable) {
              anInstance(that, C, NAME, '_i');
              that._t = NAME; // collection type

              that._i = id++; // collection id

              that._l = undefined; // leak store for uncaught frozen objects

              if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
            });
            redefineAll(C.prototype, {
              // 23.3.3.2 WeakMap.prototype.delete(key)
              // 23.4.3.3 WeakSet.prototype.delete(value)
              'delete': function _delete(key) {
                if (!isObject(key)) return false;
                var data = getWeak(key);
                if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
                return data && $has(data, this._i) && delete data[this._i];
              },
              // 23.3.3.4 WeakMap.prototype.has(key)
              // 23.4.3.4 WeakSet.prototype.has(value)
              has: function has(key) {
                if (!isObject(key)) return false;
                var data = getWeak(key);
                if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
                return data && $has(data, this._i);
              }
            });
            return C;
          },
          def: function def(that, key, value) {
            var data = getWeak(anObject(key), true);
            if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
            return that;
          },
          ufstore: uncaughtFrozenStore
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_collection.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_collection.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_collectionJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        var redefineAll = __webpack_require__(
        /*! ./_redefine-all */
        "../Grid/node_modules/core-js/modules/_redefine-all.js");

        var meta = __webpack_require__(
        /*! ./_meta */
        "../Grid/node_modules/core-js/modules/_meta.js");

        var forOf = __webpack_require__(
        /*! ./_for-of */
        "../Grid/node_modules/core-js/modules/_for-of.js");

        var anInstance = __webpack_require__(
        /*! ./_an-instance */
        "../Grid/node_modules/core-js/modules/_an-instance.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        var $iterDetect = __webpack_require__(
        /*! ./_iter-detect */
        "../Grid/node_modules/core-js/modules/_iter-detect.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "../Grid/node_modules/core-js/modules/_set-to-string-tag.js");

        var inheritIfRequired = __webpack_require__(
        /*! ./_inherit-if-required */
        "../Grid/node_modules/core-js/modules/_inherit-if-required.js");

        module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
          var Base = global[NAME];
          var C = Base;
          var ADDER = IS_MAP ? 'set' : 'add';
          var proto = C && C.prototype;
          var O = {};

          var fixMethod = function fixMethod(KEY) {
            var fn = proto[KEY];
            redefine(proto, KEY, KEY == 'delete' ? function (a) {
              return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
            } : KEY == 'has' ? function has(a) {
              return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
            } : KEY == 'get' ? function get(a) {
              return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
            } : KEY == 'add' ? function add(a) {
              fn.call(this, a === 0 ? 0 : a);
              return this;
            } : function set(a, b) {
              fn.call(this, a === 0 ? 0 : a, b);
              return this;
            });
          };

          if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
            new C().entries().next();
          }))) {
            // create collection constructor
            C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
            redefineAll(C.prototype, methods);
            meta.NEED = true;
          } else {
            var instance = new C(); // early implementations not supports chaining

            var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance; // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false

            var THROWS_ON_PRIMITIVES = fails(function () {
              instance.has(1);
            }); // most early implementations doesn't supports iterables, most modern - not close it correctly

            var ACCEPT_ITERABLES = $iterDetect(function (iter) {
              new C(iter);
            }); // eslint-disable-line no-new
            // for early implementations -0 and +0 not the same

            var BUGGY_ZERO = !IS_WEAK && fails(function () {
              // V8 ~ Chromium 42- fails only with 5+ elements
              var $instance = new C();
              var index = 5;

              while (index--) {
                $instance[ADDER](index, index);
              }

              return !$instance.has(-0);
            });

            if (!ACCEPT_ITERABLES) {
              C = wrapper(function (target, iterable) {
                anInstance(target, C, NAME);
                var that = inheritIfRequired(new Base(), target, C);
                if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
                return that;
              });
              C.prototype = proto;
              proto.constructor = C;
            }

            if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
              fixMethod('delete');
              fixMethod('has');
              IS_MAP && fixMethod('get');
            }

            if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

            if (IS_WEAK && proto.clear) delete proto.clear;
          }

          setToStringTag(C, NAME);
          O[NAME] = C;
          $export($export.G + $export.W + $export.F * (C != Base), O);
          if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
          return C;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_core.js":
      /*!*****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_core.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_coreJs(module, exports) {
        var core = module.exports = {
          version: '2.6.9'
        };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_create-property.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_create-property.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_createPropertyJs(module, exports, __webpack_require__) {
        "use strict";

        var $defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../Grid/node_modules/core-js/modules/_property-desc.js");

        module.exports = function (object, index, value) {
          if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_ctx.js":
      /*!****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_ctx.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_ctxJs(module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../Grid/node_modules/core-js/modules/_a-function.js");

        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_defined.js":
      /*!********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_defined.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_definedJs(module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_descriptors.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_descriptors.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_descriptorsJs(module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty({}, 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_dom-create.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_dom-create.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_domCreateJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var document = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js").document; // typeof document.createElement is 'object' in old IE


        var is = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_enum-bug-keys.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_enum-bug-keys.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_enumBugKeysJs(module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_enum-keys.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_enum-keys.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_enumKeysJs(module, exports, __webpack_require__) {
        // all enumerable object keys, includes symbols
        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "../Grid/node_modules/core-js/modules/_object-keys.js");

        var gOPS = __webpack_require__(
        /*! ./_object-gops */
        "../Grid/node_modules/core-js/modules/_object-gops.js");

        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "../Grid/node_modules/core-js/modules/_object-pie.js");

        module.exports = function (it) {
          var result = getKeys(it);
          var getSymbols = gOPS.f;

          if (getSymbols) {
            var symbols = getSymbols(it);
            var isEnum = pIE.f;
            var i = 0;
            var key;

            while (symbols.length > i) {
              if (isEnum.call(it, key = symbols[i++])) result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_export.js":
      /*!*******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_export.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_exportJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../Grid/node_modules/core-js/modules/_core.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../Grid/node_modules/core-js/modules/_ctx.js");

        var PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F;
          var IS_GLOBAL = type & $export.G;
          var IS_STATIC = type & $export.S;
          var IS_PROTO = type & $export.P;
          var IS_BIND = type & $export.B;
          var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
          var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
          var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
          var key, own, out, exp;
          if (IS_GLOBAL) source = name;

          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

            out = (own ? target : source)[key]; // bind timers to global for call from export context

            exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

            if (target) redefine(target, key, out, type & $export.U); // export

            if (exports[key] != out) hide(exports, key, exp);
            if (IS_PROTO && expProto[key] != out) expProto[key] = out;
          }
        };

        global.core = core; // type bitmap

        $export.F = 1; // forced

        $export.G = 2; // global

        $export.S = 4; // static

        $export.P = 8; // proto

        $export.B = 16; // bind

        $export.W = 32; // wrap

        $export.U = 64; // safe

        $export.R = 128; // real proto method for `library`

        module.exports = $export;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_fails-is-regexp.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_fails-is-regexp.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_failsIsRegexpJs(module, exports, __webpack_require__) {
        var MATCH = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('match');

        module.exports = function (KEY) {
          var re = /./;

          try {
            '/./'[KEY](re);
          } catch (e) {
            try {
              re[MATCH] = false;
              return !'/./'[KEY](re);
            } catch (f) {
              /* empty */
            }
          }

          return true;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_fails.js":
      /*!******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_fails.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_failsJs(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_fix-re-wks.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_fix-re-wks.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_fixReWksJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! ./es6.regexp.exec */
        "../Grid/node_modules/core-js/modules/es6.regexp.exec.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js");

        var regexpExec = __webpack_require__(
        /*! ./_regexp-exec */
        "../Grid/node_modules/core-js/modules/_regexp-exec.js");

        var SPECIES = wks('species');
        var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
          // #replace needs built-in support for named groups.
          // #match works fine because it just return the exec results, even if it has
          // a "grops" property.
          var re = /./;

          re.exec = function () {
            var result = [];
            result.groups = {
              a: '7'
            };
            return result;
          };

          return ''.replace(re, '$<a>') !== '7';
        });

        var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = function () {
          // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
          var re = /(?:)/;
          var originalExec = re.exec;

          re.exec = function () {
            return originalExec.apply(this, arguments);
          };

          var result = 'ab'.split(re);
          return result.length === 2 && result[0] === 'a' && result[1] === 'b';
        }();

        module.exports = function (KEY, length, exec) {
          var SYMBOL = wks(KEY);
          var DELEGATES_TO_SYMBOL = !fails(function () {
            // String methods call symbol-named RegEp methods
            var O = {};

            O[SYMBOL] = function () {
              return 7;
            };

            return ''[KEY](O) != 7;
          });
          var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
            // Symbol-named RegExp methods call .exec
            var execCalled = false;
            var re = /a/;

            re.exec = function () {
              execCalled = true;
              return null;
            };

            if (KEY === 'split') {
              // RegExp[@@split] doesn't call the regex's exec method, but first creates
              // a new one. We need to return the patched regex when creating the new one.
              re.constructor = {};

              re.constructor[SPECIES] = function () {
                return re;
              };
            }

            re[SYMBOL]('');
            return !execCalled;
          }) : undefined;

          if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS || KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC) {
            var nativeRegExpMethod = /./[SYMBOL];
            var fns = exec(defined, SYMBOL, ''[KEY], function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
              if (regexp.exec === regexpExec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                  // The native String method already delegates to @@method (this
                  // polyfilled function), leasing to infinite recursion.
                  // We avoid it by directly calling the native @@method method.
                  return {
                    done: true,
                    value: nativeRegExpMethod.call(regexp, str, arg2)
                  };
                }

                return {
                  done: true,
                  value: nativeMethod.call(str, regexp, arg2)
                };
              }

              return {
                done: false
              };
            });
            var strfn = fns[0];
            var rxfn = fns[1];
            redefine(String.prototype, KEY, strfn);
            hide(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
            // 21.2.5.11 RegExp.prototype[@@split](string, limit)
            ? function (string, arg) {
              return rxfn.call(string, this, arg);
            } // 21.2.5.6 RegExp.prototype[@@match](string)
            // 21.2.5.9 RegExp.prototype[@@search](string)
            : function (string) {
              return rxfn.call(string, this);
            });
          }
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_flags.js":
      /*!******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_flags.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_flagsJs(module, exports, __webpack_require__) {
        "use strict"; // 21.2.5.3 get RegExp.prototype.flags

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        module.exports = function () {
          var that = anObject(this);
          var result = '';
          if (that.global) result += 'g';
          if (that.ignoreCase) result += 'i';
          if (that.multiline) result += 'm';
          if (that.unicode) result += 'u';
          if (that.sticky) result += 'y';
          return result;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_for-of.js":
      /*!*******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_for-of.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_forOfJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../Grid/node_modules/core-js/modules/_ctx.js");

        var call = __webpack_require__(
        /*! ./_iter-call */
        "../Grid/node_modules/core-js/modules/_iter-call.js");

        var isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "../Grid/node_modules/core-js/modules/_is-array-iter.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "../Grid/node_modules/core-js/modules/core.get-iterator-method.js");

        var BREAK = {};
        var RETURN = {};

        var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
          var iterFn = ITERATOR ? function () {
            return iterable;
          } : getIterFn(iterable);
          var f = ctx(fn, that, entries ? 2 : 1);
          var index = 0;
          var length, step, iterator, result;
          if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

          if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
            result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
            if (result === BREAK || result === RETURN) return result;
          } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN) return result;
          }
        };

        exports.BREAK = BREAK;
        exports.RETURN = RETURN;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_function-to-string.js":
      /*!*******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_function-to-string.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_functionToStringJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./_shared */
        "../Grid/node_modules/core-js/modules/_shared.js")('native-function-to-string', Function.toString);
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_global.js":
      /*!*******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_global.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_globalJs(module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self // eslint-disable-next-line no-new-func
        : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_has.js":
      /*!****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_has.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_hasJs(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_hide.js":
      /*!*****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_hide.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_hideJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../Grid/node_modules/core-js/modules/_property-desc.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_html.js":
      /*!*****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_html.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_htmlJs(module, exports, __webpack_require__) {
        var document = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js").document;

        module.exports = document && document.documentElement;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_ie8-dom-define.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_ie8-dom-define.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_ie8DomDefineJs(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") && !__webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty(__webpack_require__(
          /*! ./_dom-create */
          "../Grid/node_modules/core-js/modules/_dom-create.js")('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_inherit-if-required.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_inherit-if-required.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_inheritIfRequiredJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var setPrototypeOf = __webpack_require__(
        /*! ./_set-proto */
        "../Grid/node_modules/core-js/modules/_set-proto.js").set;

        module.exports = function (that, target, C) {
          var S = target.constructor;
          var P;

          if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
            setPrototypeOf(that, P);
          }

          return that;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_invoke.js":
      /*!*******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_invoke.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_invokeJs(module, exports) {
        // fast apply, http://jsperf.lnkit.com/fast-apply/5
        module.exports = function (fn, args, that) {
          var un = that === undefined;

          switch (args.length) {
            case 0:
              return un ? fn() : fn.call(that);

            case 1:
              return un ? fn(args[0]) : fn.call(that, args[0]);

            case 2:
              return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

            case 3:
              return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

            case 4:
              return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
          }

          return fn.apply(that, args);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_iobject.js":
      /*!********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_iobject.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_iobjectJs(module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(
        /*! ./_cof */
        "../Grid/node_modules/core-js/modules/_cof.js"); // eslint-disable-next-line no-prototype-builtins


        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_is-array-iter.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_is-array-iter.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_isArrayIterJs(module, exports, __webpack_require__) {
        // check on default Array iterator
        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../Grid/node_modules/core-js/modules/_iterators.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('iterator');

        var ArrayProto = Array.prototype;

        module.exports = function (it) {
          return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_is-array.js":
      /*!*********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_is-array.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_isArrayJs(module, exports, __webpack_require__) {
        // 7.2.2 IsArray(argument)
        var cof = __webpack_require__(
        /*! ./_cof */
        "../Grid/node_modules/core-js/modules/_cof.js");

        module.exports = Array.isArray || function isArray(arg) {
          return cof(arg) == 'Array';
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_is-object.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_is-object.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_isObjectJs(module, exports) {
        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_is-regexp.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_is-regexp.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_isRegexpJs(module, exports, __webpack_require__) {
        // 7.2.8 IsRegExp(argument)
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var cof = __webpack_require__(
        /*! ./_cof */
        "../Grid/node_modules/core-js/modules/_cof.js");

        var MATCH = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('match');

        module.exports = function (it) {
          var isRegExp;
          return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_iter-call.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_iter-call.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_iterCallJs(module, exports, __webpack_require__) {
        // call something on iterator step with safe closing on error
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        module.exports = function (iterator, fn, value, entries) {
          try {
            return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
          } catch (e) {
            var ret = iterator['return'];
            if (ret !== undefined) anObject(ret.call(iterator));
            throw e;
          }
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_iter-create.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_iter-create.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_iterCreateJs(module, exports, __webpack_require__) {
        "use strict";

        var create = __webpack_require__(
        /*! ./_object-create */
        "../Grid/node_modules/core-js/modules/_object-create.js");

        var descriptor = __webpack_require__(
        /*! ./_property-desc */
        "../Grid/node_modules/core-js/modules/_property-desc.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "../Grid/node_modules/core-js/modules/_set-to-string-tag.js");

        var IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()

        __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('iterator'), function () {
          return this;
        });

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, {
            next: descriptor(1, next)
          });
          setToStringTag(Constructor, NAME + ' Iterator');
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_iter-define.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_iter-define.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_iterDefineJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "../Grid/node_modules/core-js/modules/_library.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../Grid/node_modules/core-js/modules/_iterators.js");

        var $iterCreate = __webpack_require__(
        /*! ./_iter-create */
        "../Grid/node_modules/core-js/modules/_iter-create.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "../Grid/node_modules/core-js/modules/_set-to-string-tag.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "../Grid/node_modules/core-js/modules/_object-gpo.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('iterator');

        var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`

        var FF_ITERATOR = '@@iterator';
        var KEYS = 'keys';
        var VALUES = 'values';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next);

          var getMethod = function getMethod(kind) {
            if (!BUGGY && kind in proto) return proto[kind];

            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind);
                };

              case VALUES:
                return function values() {
                  return new Constructor(this, kind);
                };
            }

            return function entries() {
              return new Constructor(this, kind);
            };
          };

          var TAG = NAME + ' Iterator';
          var DEF_VALUES = DEFAULT == VALUES;
          var VALUES_BUG = false;
          var proto = Base.prototype;
          var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
          var $default = $native || getMethod(DEFAULT);
          var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
          var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
          var methods, key, IteratorPrototype; // Fix native

          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

            if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

              if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
            }
          } // fix Array#{values, @@iterator}.name in V8 / FF


          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true;

            $default = function values() {
              return $native.call(this);
            };
          } // Define iterator


          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default);
          } // Plug for library


          Iterators[NAME] = $default;
          Iterators[TAG] = returnThis;

          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries
            };
            if (FORCED) for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
          }

          return methods;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_iter-detect.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_iter-detect.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_iterDetectJs(module, exports, __webpack_require__) {
        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('iterator');

        var SAFE_CLOSING = false;

        try {
          var riter = [7][ITERATOR]();

          riter['return'] = function () {
            SAFE_CLOSING = true;
          }; // eslint-disable-next-line no-throw-literal


          Array.from(riter, function () {
            throw 2;
          });
        } catch (e) {
          /* empty */
        }

        module.exports = function (exec, skipClosing) {
          if (!skipClosing && !SAFE_CLOSING) return false;
          var safe = false;

          try {
            var arr = [7];
            var iter = arr[ITERATOR]();

            iter.next = function () {
              return {
                done: safe = true
              };
            };

            arr[ITERATOR] = function () {
              return iter;
            };

            exec(arr);
          } catch (e) {
            /* empty */
          }

          return safe;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_iter-step.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_iter-step.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_iterStepJs(module, exports) {
        module.exports = function (done, value) {
          return {
            value: value,
            done: !!done
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_iterators.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_iterators.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_iteratorsJs(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_library.js":
      /*!********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_library.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_libraryJs(module, exports) {
        module.exports = false;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_math-sign.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_math-sign.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_mathSignJs(module, exports) {
        // 20.2.2.28 Math.sign(x)
        module.exports = Math.sign || function sign(x) {
          // eslint-disable-next-line no-self-compare
          return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_meta.js":
      /*!*****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_meta.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_metaJs(module, exports, __webpack_require__) {
        var META = __webpack_require__(
        /*! ./_uid */
        "../Grid/node_modules/core-js/modules/_uid.js")('meta');

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var setDesc = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f;

        var id = 0;

        var isExtensible = Object.isExtensible || function () {
          return true;
        };

        var FREEZE = !__webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js")(function () {
          return isExtensible(Object.preventExtensions({}));
        });

        var setMeta = function setMeta(it) {
          setDesc(it, META, {
            value: {
              i: 'O' + ++id,
              // object ID
              w: {} // weak collections IDs

            }
          });
        };

        var fastKey = function fastKey(it, create) {
          // return primitive with prefix
          if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F'; // not necessary to add metadata

            if (!create) return 'E'; // add missing metadata

            setMeta(it); // return object ID
          }

          return it[META].i;
        };

        var getWeak = function getWeak(it, create) {
          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true; // not necessary to add metadata

            if (!create) return false; // add missing metadata

            setMeta(it); // return hash weak collections IDs
          }

          return it[META].w;
        }; // add metadata on freeze-family methods calling


        var onFreeze = function onFreeze(it) {
          if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
          return it;
        };

        var meta = module.exports = {
          KEY: META,
          NEED: false,
          fastKey: fastKey,
          getWeak: getWeak,
          onFreeze: onFreeze
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_microtask.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_microtask.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_microtaskJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var macrotask = __webpack_require__(
        /*! ./_task */
        "../Grid/node_modules/core-js/modules/_task.js").set;

        var Observer = global.MutationObserver || global.WebKitMutationObserver;
        var process = global.process;
        var Promise = global.Promise;
        var isNode = __webpack_require__(
        /*! ./_cof */
        "../Grid/node_modules/core-js/modules/_cof.js")(process) == 'process';

        module.exports = function () {
          var head, last, notify;

          var flush = function flush() {
            var parent, fn;
            if (isNode && (parent = process.domain)) parent.exit();

            while (head) {
              fn = head.fn;
              head = head.next;

              try {
                fn();
              } catch (e) {
                if (head) notify();else last = undefined;
                throw e;
              }
            }

            last = undefined;
            if (parent) parent.enter();
          }; // Node.js


          if (isNode) {
            notify = function notify() {
              process.nextTick(flush);
            }; // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339

          } else if (Observer && !(global.navigator && global.navigator.standalone)) {
            var toggle = true;
            var node = document.createTextNode('');
            new Observer(flush).observe(node, {
              characterData: true
            }); // eslint-disable-line no-new

            notify = function notify() {
              node.data = toggle = !toggle;
            }; // environments with maybe non-completely correct, but existent Promise

          } else if (Promise && Promise.resolve) {
            // Promise.resolve without an argument throws an error in LG WebOS 2
            var promise = Promise.resolve(undefined);

            notify = function notify() {
              promise.then(flush);
            }; // for other environments - macrotask based on:
            // - setImmediate
            // - MessageChannel
            // - window.postMessag
            // - onreadystatechange
            // - setTimeout

          } else {
            notify = function notify() {
              // strange IE + webpack dev server bug - use .call(global)
              macrotask.call(global, flush);
            };
          }

          return function (fn) {
            var task = {
              fn: fn,
              next: undefined
            };
            if (last) last.next = task;

            if (!head) {
              head = task;
              notify();
            }

            last = task;
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_new-promise-capability.js":
      /*!***********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_new-promise-capability.js ***!
        \***********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_newPromiseCapabilityJs(module, exports, __webpack_require__) {
        "use strict"; // 25.4.1.5 NewPromiseCapability(C)

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../Grid/node_modules/core-js/modules/_a-function.js");

        function PromiseCapability(C) {
          var resolve, reject;
          this.promise = new C(function ($$resolve, $$reject) {
            if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
            resolve = $$resolve;
            reject = $$reject;
          });
          this.resolve = aFunction(resolve);
          this.reject = aFunction(reject);
        }

        module.exports.f = function (C) {
          return new PromiseCapability(C);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-assign.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-assign.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectAssignJs(module, exports, __webpack_require__) {
        "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "../Grid/node_modules/core-js/modules/_object-keys.js");

        var gOPS = __webpack_require__(
        /*! ./_object-gops */
        "../Grid/node_modules/core-js/modules/_object-gops.js");

        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "../Grid/node_modules/core-js/modules/_object-pie.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../Grid/node_modules/core-js/modules/_to-object.js");

        var IObject = __webpack_require__(
        /*! ./_iobject */
        "../Grid/node_modules/core-js/modules/_iobject.js");

        var $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)

        module.exports = !$assign || __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js")(function () {
          var A = {};
          var B = {}; // eslint-disable-next-line no-undef

          var S = Symbol();
          var K = 'abcdefghijklmnopqrst';
          A[S] = 7;
          K.split('').forEach(function (k) {
            B[k] = k;
          });
          return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
        }) ? function assign(target, source) {
          // eslint-disable-line no-unused-vars
          var T = toObject(target);
          var aLen = arguments.length;
          var index = 1;
          var getSymbols = gOPS.f;
          var isEnum = pIE.f;

          while (aLen > index) {
            var S = IObject(arguments[index++]);
            var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
            var length = keys.length;
            var j = 0;
            var key;

            while (length > j) {
              key = keys[j++];
              if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
            }
          }

          return T;
        } : $assign;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-create.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-create.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectCreateJs(module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var dPs = __webpack_require__(
        /*! ./_object-dps */
        "../Grid/node_modules/core-js/modules/_object-dps.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "../Grid/node_modules/core-js/modules/_enum-bug-keys.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "../Grid/node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        var Empty = function Empty() {
          /* empty */
        };

        var PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype

        var _createDict = function createDict() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__(
          /*! ./_dom-create */
          "../Grid/node_modules/core-js/modules/_dom-create.js")('iframe');

          var i = enumBugKeys.length;
          var lt = '<';
          var gt = '>';
          var iframeDocument;
          iframe.style.display = 'none';

          __webpack_require__(
          /*! ./_html */
          "../Grid/node_modules/core-js/modules/_html.js").appendChild(iframe);

          iframe.src = 'javascript:'; // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);

          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
          iframeDocument.close();
          _createDict = iframeDocument.F;

          while (i--) {
            delete _createDict[PROTOTYPE][enumBugKeys[i]];
          }

          return _createDict();
        };

        module.exports = Object.create || function create(O, Properties) {
          var result;

          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
          } else result = _createDict();

          return Properties === undefined ? result : dPs(result, Properties);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-dp.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-dp.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectDpJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "../Grid/node_modules/core-js/modules/_ie8-dom-define.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../Grid/node_modules/core-js/modules/_to-primitive.js");

        var dP = Object.defineProperty;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-dps.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-dps.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectDpsJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "../Grid/node_modules/core-js/modules/_object-keys.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = getKeys(Properties);
          var length = keys.length;
          var i = 0;
          var P;

          while (length > i) {
            dP.f(O, P = keys[i++], Properties[P]);
          }

          return O;
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-gopd.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-gopd.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectGopdJs(module, exports, __webpack_require__) {
        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "../Grid/node_modules/core-js/modules/_object-pie.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../Grid/node_modules/core-js/modules/_property-desc.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../Grid/node_modules/core-js/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../Grid/node_modules/core-js/modules/_to-primitive.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "../Grid/node_modules/core-js/modules/_ie8-dom-define.js");

        var gOPD = Object.getOwnPropertyDescriptor;
        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
          O = toIObject(O);
          P = toPrimitive(P, true);
          if (IE8_DOM_DEFINE) try {
            return gOPD(O, P);
          } catch (e) {
            /* empty */
          }
          if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-gopn-ext.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-gopn-ext.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectGopnExtJs(module, exports, __webpack_require__) {
        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../Grid/node_modules/core-js/modules/_to-iobject.js");

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "../Grid/node_modules/core-js/modules/_object-gopn.js").f;

        var toString = {}.toString;
        var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

        var getWindowNames = function getWindowNames(it) {
          try {
            return gOPN(it);
          } catch (e) {
            return windowNames.slice();
          }
        };

        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-gopn.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-gopn.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectGopnJs(module, exports, __webpack_require__) {
        // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "../Grid/node_modules/core-js/modules/_object-keys-internal.js");

        var hiddenKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "../Grid/node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return $keys(O, hiddenKeys);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-gops.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-gops.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectGopsJs(module, exports) {
        exports.f = Object.getOwnPropertySymbols;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-gpo.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-gpo.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectGpoJs(module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../Grid/node_modules/core-js/modules/_to-object.js");

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "../Grid/node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        var ObjectProto = Object.prototype;

        module.exports = Object.getPrototypeOf || function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];

          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }

          return O instanceof Object ? ObjectProto : null;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-keys-internal.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-keys-internal.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectKeysInternalJs(module, exports, __webpack_require__) {
        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../Grid/node_modules/core-js/modules/_to-iobject.js");

        var arrayIndexOf = __webpack_require__(
        /*! ./_array-includes */
        "../Grid/node_modules/core-js/modules/_array-includes.js")(false);

        var IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "../Grid/node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object);
          var i = 0;
          var result = [];
          var key;

          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-keys.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-keys.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "../Grid/node_modules/core-js/modules/_object-keys-internal.js");

        var enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "../Grid/node_modules/core-js/modules/_enum-bug-keys.js");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-pie.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-pie.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectPieJs(module, exports) {
        exports.f = {}.propertyIsEnumerable;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-sap.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-sap.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectSapJs(module, exports, __webpack_require__) {
        // most Object methods by ES6 should accept primitives
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../Grid/node_modules/core-js/modules/_core.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        module.exports = function (KEY, exec) {
          var fn = (core.Object || {})[KEY] || Object[KEY];
          var exp = {};
          exp[KEY] = exec(fn);
          $export($export.S + $export.F * fails(function () {
            fn(1);
          }), 'Object', exp);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_object-to-array.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_object-to-array.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_objectToArrayJs(module, exports, __webpack_require__) {
        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "../Grid/node_modules/core-js/modules/_object-keys.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../Grid/node_modules/core-js/modules/_to-iobject.js");

        var isEnum = __webpack_require__(
        /*! ./_object-pie */
        "../Grid/node_modules/core-js/modules/_object-pie.js").f;

        module.exports = function (isEntries) {
          return function (it) {
            var O = toIObject(it);
            var keys = getKeys(O);
            var length = keys.length;
            var i = 0;
            var result = [];
            var key;

            while (length > i) {
              key = keys[i++];

              if (!DESCRIPTORS || isEnum.call(O, key)) {
                result.push(isEntries ? [key, O[key]] : O[key]);
              }
            }

            return result;
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_own-keys.js":
      /*!*********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_own-keys.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_ownKeysJs(module, exports, __webpack_require__) {
        // all object keys, includes non-enumerable and symbols
        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "../Grid/node_modules/core-js/modules/_object-gopn.js");

        var gOPS = __webpack_require__(
        /*! ./_object-gops */
        "../Grid/node_modules/core-js/modules/_object-gops.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var Reflect = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js").Reflect;

        module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
          var keys = gOPN.f(anObject(it));
          var getSymbols = gOPS.f;
          return getSymbols ? keys.concat(getSymbols(it)) : keys;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_perform.js":
      /*!********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_perform.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_performJs(module, exports) {
        module.exports = function (exec) {
          try {
            return {
              e: false,
              v: exec()
            };
          } catch (e) {
            return {
              e: true,
              v: e
            };
          }
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_promise-resolve.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_promise-resolve.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_promiseResolveJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var newPromiseCapability = __webpack_require__(
        /*! ./_new-promise-capability */
        "../Grid/node_modules/core-js/modules/_new-promise-capability.js");

        module.exports = function (C, x) {
          anObject(C);
          if (isObject(x) && x.constructor === C) return x;
          var promiseCapability = newPromiseCapability.f(C);
          var resolve = promiseCapability.resolve;
          resolve(x);
          return promiseCapability.promise;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_property-desc.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_property-desc.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_propertyDescJs(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_redefine-all.js":
      /*!*************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_redefine-all.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_redefineAllJs(module, exports, __webpack_require__) {
        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        module.exports = function (target, src, safe) {
          for (var key in src) {
            redefine(target, key, src[key], safe);
          }

          return target;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_redefine.js":
      /*!*********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_redefine.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_redefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var SRC = __webpack_require__(
        /*! ./_uid */
        "../Grid/node_modules/core-js/modules/_uid.js")('src');

        var $toString = __webpack_require__(
        /*! ./_function-to-string */
        "../Grid/node_modules/core-js/modules/_function-to-string.js");

        var TO_STRING = 'toString';
        var TPL = ('' + $toString).split(TO_STRING);

        __webpack_require__(
        /*! ./_core */
        "../Grid/node_modules/core-js/modules/_core.js").inspectSource = function (it) {
          return $toString.call(it);
        };

        (module.exports = function (O, key, val, safe) {
          var isFunction = typeof val == 'function';
          if (isFunction) has(val, 'name') || hide(val, 'name', key);
          if (O[key] === val) return;
          if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

          if (O === global) {
            O[key] = val;
          } else if (!safe) {
            delete O[key];
            hide(O, key, val);
          } else if (O[key]) {
            O[key] = val;
          } else {
            hide(O, key, val);
          } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

        })(Function.prototype, TO_STRING, function toString() {
          return typeof this == 'function' && this[SRC] || $toString.call(this);
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_regexp-exec-abstract.js":
      /*!*********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_regexp-exec-abstract.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_regexpExecAbstractJs(module, exports, __webpack_require__) {
        "use strict";

        var classof = __webpack_require__(
        /*! ./_classof */
        "../Grid/node_modules/core-js/modules/_classof.js");

        var builtinExec = RegExp.prototype.exec; // `RegExpExec` abstract operation
        // https://tc39.github.io/ecma262/#sec-regexpexec

        module.exports = function (R, S) {
          var exec = R.exec;

          if (typeof exec === 'function') {
            var result = exec.call(R, S);

            if (typeof result !== 'object') {
              throw new TypeError('RegExp exec method returned something other than an Object or null');
            }

            return result;
          }

          if (classof(R) !== 'RegExp') {
            throw new TypeError('RegExp#exec called on incompatible receiver');
          }

          return builtinExec.call(R, S);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_regexp-exec.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_regexp-exec.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_regexpExecJs(module, exports, __webpack_require__) {
        "use strict";

        var regexpFlags = __webpack_require__(
        /*! ./_flags */
        "../Grid/node_modules/core-js/modules/_flags.js");

        var nativeExec = RegExp.prototype.exec; // This always refers to the native implementation, because the
        // String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
        // which loads this file before patching the method.

        var nativeReplace = String.prototype.replace;
        var patchedExec = nativeExec;
        var LAST_INDEX = 'lastIndex';

        var UPDATES_LAST_INDEX_WRONG = function () {
          var re1 = /a/,
              re2 = /b*/g;
          nativeExec.call(re1, 'a');
          nativeExec.call(re2, 'a');
          return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
        }(); // nonparticipating capturing group, copied from es5-shim's String#split patch.


        var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
        var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

        if (PATCH) {
          patchedExec = function exec(str) {
            var re = this;
            var lastIndex, reCopy, match, i;

            if (NPCG_INCLUDED) {
              reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
            }

            if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
            match = nativeExec.call(re, str);

            if (UPDATES_LAST_INDEX_WRONG && match) {
              re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
            }

            if (NPCG_INCLUDED && match && match.length > 1) {
              // Fix browsers whose `exec` methods don't consistently return `undefined`
              // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
              // eslint-disable-next-line no-loop-func
              nativeReplace.call(match[0], reCopy, function () {
                for (i = 1; i < arguments.length - 2; i++) {
                  if (arguments[i] === undefined) match[i] = undefined;
                }
              });
            }

            return match;
          };
        }

        module.exports = patchedExec;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_same-value.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_same-value.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_sameValueJs(module, exports) {
        // 7.2.9 SameValue(x, y)
        module.exports = Object.is || function is(x, y) {
          // eslint-disable-next-line no-self-compare
          return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_set-proto.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_set-proto.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_setProtoJs(module, exports, __webpack_require__) {
        // Works with __proto__ only. Old v8 can't work with null proto objects.

        /* eslint-disable no-proto */
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var check = function check(O, proto) {
          anObject(O);
          if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
        };

        module.exports = {
          set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
          function (test, buggy, set) {
            try {
              set = __webpack_require__(
              /*! ./_ctx */
              "../Grid/node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__(
              /*! ./_object-gopd */
              "../Grid/node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
              set(test, []);
              buggy = !(test instanceof Array);
            } catch (e) {
              buggy = true;
            }

            return function setPrototypeOf(O, proto) {
              check(O, proto);
              if (buggy) O.__proto__ = proto;else set(O, proto);
              return O;
            };
          }({}, false) : undefined),
          check: check
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_set-species.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_set-species.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_setSpeciesJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (KEY) {
          var C = global[KEY];
          if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
            configurable: true,
            get: function get() {
              return this;
            }
          });
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_set-to-string-tag.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_set-to-string-tag.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_setToStringTagJs(module, exports, __webpack_require__) {
        var def = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f;

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var TAG = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('toStringTag');

        module.exports = function (it, tag, stat) {
          if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
            configurable: true,
            value: tag
          });
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_shared-key.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_shared-key.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_sharedKeyJs(module, exports, __webpack_require__) {
        var shared = __webpack_require__(
        /*! ./_shared */
        "../Grid/node_modules/core-js/modules/_shared.js")('keys');

        var uid = __webpack_require__(
        /*! ./_uid */
        "../Grid/node_modules/core-js/modules/_uid.js");

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_shared.js":
      /*!*******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_shared.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_sharedJs(module, exports, __webpack_require__) {
        var core = __webpack_require__(
        /*! ./_core */
        "../Grid/node_modules/core-js/modules/_core.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var SHARED = '__core-js_shared__';
        var store = global[SHARED] || (global[SHARED] = {});
        (module.exports = function (key, value) {
          return store[key] || (store[key] = value !== undefined ? value : {});
        })('versions', []).push({
          version: core.version,
          mode: __webpack_require__(
          /*! ./_library */
          "../Grid/node_modules/core-js/modules/_library.js") ? 'pure' : 'global',
          copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_species-constructor.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_species-constructor.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_speciesConstructorJs(module, exports, __webpack_require__) {
        // 7.3.20 SpeciesConstructor(O, defaultConstructor)
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../Grid/node_modules/core-js/modules/_a-function.js");

        var SPECIES = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (O, D) {
          var C = anObject(O).constructor;
          var S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_string-at.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_string-at.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_stringAtJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../Grid/node_modules/core-js/modules/_to-integer.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js"); // true  -> String#at
        // false -> String#codePointAt


        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var s = String(defined(that));
            var i = toInteger(pos);
            var l = s.length;
            var a, b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
          };
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_string-context.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_string-context.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_stringContextJs(module, exports, __webpack_require__) {
        // helper for String#{startsWith, endsWith, includes}
        var isRegExp = __webpack_require__(
        /*! ./_is-regexp */
        "../Grid/node_modules/core-js/modules/_is-regexp.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        module.exports = function (that, searchString, NAME) {
          if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
          return String(defined(that));
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_string-html.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_string-html.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_stringHtmlJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        var quot = /"/g; // B.2.3.2.1 CreateHTML(string, tag, attribute, value)

        var createHTML = function createHTML(string, tag, attribute, value) {
          var S = String(defined(string));
          var p1 = '<' + tag;
          if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
          return p1 + '>' + S + '</' + tag + '>';
        };

        module.exports = function (NAME, exec) {
          var O = {};
          O[NAME] = exec(createHTML);
          $export($export.P + $export.F * fails(function () {
            var test = ''[NAME]('"');
            return test !== test.toLowerCase() || test.split('"').length > 3;
          }), 'String', O);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_string-pad.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_string-pad.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_stringPadJs(module, exports, __webpack_require__) {
        // https://github.com/tc39/proposal-string-pad-start-end
        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var repeat = __webpack_require__(
        /*! ./_string-repeat */
        "../Grid/node_modules/core-js/modules/_string-repeat.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        module.exports = function (that, maxLength, fillString, left) {
          var S = String(defined(that));
          var stringLength = S.length;
          var fillStr = fillString === undefined ? ' ' : String(fillString);
          var intMaxLength = toLength(maxLength);
          if (intMaxLength <= stringLength || fillStr == '') return S;
          var fillLen = intMaxLength - stringLength;
          var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
          if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
          return left ? stringFiller + S : S + stringFiller;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_string-repeat.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_string-repeat.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_stringRepeatJs(module, exports, __webpack_require__) {
        "use strict";

        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../Grid/node_modules/core-js/modules/_to-integer.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        module.exports = function repeat(count) {
          var str = String(defined(this));
          var res = '';
          var n = toInteger(count);
          if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");

          for (; n > 0; (n >>>= 1) && (str += str)) {
            if (n & 1) res += str;
          }

          return res;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_string-trim.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_string-trim.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_stringTrimJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        var spaces = __webpack_require__(
        /*! ./_string-ws */
        "../Grid/node_modules/core-js/modules/_string-ws.js");

        var space = '[' + spaces + ']';
        var non = "\u200B\x85";
        var ltrim = RegExp('^' + space + space + '*');
        var rtrim = RegExp(space + space + '*$');

        var exporter = function exporter(KEY, exec, ALIAS) {
          var exp = {};
          var FORCE = fails(function () {
            return !!spaces[KEY]() || non[KEY]() != non;
          });
          var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
          if (ALIAS) exp[ALIAS] = fn;
          $export($export.P + $export.F * FORCE, 'String', exp);
        }; // 1 -> String#trimLeft
        // 2 -> String#trimRight
        // 3 -> String#trim


        var trim = exporter.trim = function (string, TYPE) {
          string = String(defined(string));
          if (TYPE & 1) string = string.replace(ltrim, '');
          if (TYPE & 2) string = string.replace(rtrim, '');
          return string;
        };

        module.exports = exporter;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_string-ws.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_string-ws.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_stringWsJs(module, exports) {
        module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_task.js":
      /*!*****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_task.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_taskJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../Grid/node_modules/core-js/modules/_ctx.js");

        var invoke = __webpack_require__(
        /*! ./_invoke */
        "../Grid/node_modules/core-js/modules/_invoke.js");

        var html = __webpack_require__(
        /*! ./_html */
        "../Grid/node_modules/core-js/modules/_html.js");

        var cel = __webpack_require__(
        /*! ./_dom-create */
        "../Grid/node_modules/core-js/modules/_dom-create.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var process = global.process;
        var setTask = global.setImmediate;
        var clearTask = global.clearImmediate;
        var MessageChannel = global.MessageChannel;
        var Dispatch = global.Dispatch;
        var counter = 0;
        var queue = {};
        var ONREADYSTATECHANGE = 'onreadystatechange';
        var defer, channel, port;

        var run = function run() {
          var id = +this; // eslint-disable-next-line no-prototype-builtins

          if (queue.hasOwnProperty(id)) {
            var fn = queue[id];
            delete queue[id];
            fn();
          }
        };

        var listener = function listener(event) {
          run.call(event.data);
        }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


        if (!setTask || !clearTask) {
          setTask = function setImmediate(fn) {
            var args = [];
            var i = 1;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            queue[++counter] = function () {
              // eslint-disable-next-line no-new-func
              invoke(typeof fn == 'function' ? fn : Function(fn), args);
            };

            defer(counter);
            return counter;
          };

          clearTask = function clearImmediate(id) {
            delete queue[id];
          }; // Node.js 0.8-


          if (__webpack_require__(
          /*! ./_cof */
          "../Grid/node_modules/core-js/modules/_cof.js")(process) == 'process') {
            defer = function defer(id) {
              process.nextTick(ctx(run, id, 1));
            }; // Sphere (JS game engine) Dispatch API

          } else if (Dispatch && Dispatch.now) {
            defer = function defer(id) {
              Dispatch.now(ctx(run, id, 1));
            }; // Browsers with MessageChannel, includes WebWorkers

          } else if (MessageChannel) {
            channel = new MessageChannel();
            port = channel.port2;
            channel.port1.onmessage = listener;
            defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
            // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
          } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
            defer = function defer(id) {
              global.postMessage(id + '', '*');
            };

            global.addEventListener('message', listener, false); // IE8-
          } else if (ONREADYSTATECHANGE in cel('script')) {
            defer = function defer(id) {
              html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
                html.removeChild(this);
                run.call(id);
              };
            }; // Rest old browsers

          } else {
            defer = function defer(id) {
              setTimeout(ctx(run, id, 1), 0);
            };
          }
        }

        module.exports = {
          set: setTask,
          clear: clearTask
        };
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_to-absolute-index.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_to-absolute-index.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_toAbsoluteIndexJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../Grid/node_modules/core-js/modules/_to-integer.js");

        var max = Math.max;
        var min = Math.min;

        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_to-integer.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_to-integer.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_toIntegerJs(module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil;
        var floor = Math.floor;

        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_to-iobject.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_to-iobject.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_toIobjectJs(module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(
        /*! ./_iobject */
        "../Grid/node_modules/core-js/modules/_iobject.js");

        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return IObject(defined(it));
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_to-length.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_to-length.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_toLengthJs(module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../Grid/node_modules/core-js/modules/_to-integer.js");

        var min = Math.min;

        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_to-object.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_to-object.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_toObjectJs(module, exports, __webpack_require__) {
        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__(
        /*! ./_defined */
        "../Grid/node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return Object(defined(it));
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_to-primitive.js":
      /*!*************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_to-primitive.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_toPrimitiveJs(module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js"); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_uid.js":
      /*!****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_uid.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_uidJs(module, exports) {
        var id = 0;
        var px = Math.random();

        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_user-agent.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_user-agent.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_userAgentJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var navigator = global.navigator;
        module.exports = navigator && navigator.userAgent || '';
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_validate-collection.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_validate-collection.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_validateCollectionJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        module.exports = function (it, TYPE) {
          if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
          return it;
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_wks-define.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_wks-define.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_wksDefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var core = __webpack_require__(
        /*! ./_core */
        "../Grid/node_modules/core-js/modules/_core.js");

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "../Grid/node_modules/core-js/modules/_library.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "../Grid/node_modules/core-js/modules/_wks-ext.js");

        var defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f;

        module.exports = function (name) {
          var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
          if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
            value: wksExt.f(name)
          });
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/_wks-ext.js":
      /*!********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_wks-ext.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_wksExtJs(module, exports, __webpack_require__) {
        exports.f = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js");
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/_wks.js":
      /*!****************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/_wks.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModules_wksJs(module, exports, __webpack_require__) {
        var store = __webpack_require__(
        /*! ./_shared */
        "../Grid/node_modules/core-js/modules/_shared.js")('wks');

        var uid = __webpack_require__(
        /*! ./_uid */
        "../Grid/node_modules/core-js/modules/_uid.js");

        var Symbol = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js").Symbol;

        var USE_SYMBOL = typeof Symbol == 'function';

        var $exports = module.exports = function (name) {
          return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
        };

        $exports.store = store;
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/core.get-iterator-method.js":
      /*!************************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/core.get-iterator-method.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesCoreGetIteratorMethodJs(module, exports, __webpack_require__) {
        var classof = __webpack_require__(
        /*! ./_classof */
        "../Grid/node_modules/core-js/modules/_classof.js");

        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js")('iterator');

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../Grid/node_modules/core-js/modules/_iterators.js");

        module.exports = __webpack_require__(
        /*! ./_core */
        "../Grid/node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
          if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
        };
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.array.find-index.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.array.find-index.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ArrayFindIndexJs(module, exports, __webpack_require__) {
        "use strict"; // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var $find = __webpack_require__(
        /*! ./_array-methods */
        "../Grid/node_modules/core-js/modules/_array-methods.js")(6);

        var KEY = 'findIndex';
        var forced = true; // Shouldn't skip holes

        if (KEY in []) Array(1)[KEY](function () {
          forced = false;
        });
        $export($export.P + $export.F * forced, 'Array', {
          findIndex: function findIndex(callbackfn
          /* , that = undefined */
          ) {
            return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__(
        /*! ./_add-to-unscopables */
        "../Grid/node_modules/core-js/modules/_add-to-unscopables.js")(KEY);
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.array.find.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.array.find.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ArrayFindJs(module, exports, __webpack_require__) {
        "use strict"; // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var $find = __webpack_require__(
        /*! ./_array-methods */
        "../Grid/node_modules/core-js/modules/_array-methods.js")(5);

        var KEY = 'find';
        var forced = true; // Shouldn't skip holes

        if (KEY in []) Array(1)[KEY](function () {
          forced = false;
        });
        $export($export.P + $export.F * forced, 'Array', {
          find: function find(callbackfn
          /* , that = undefined */
          ) {
            return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__(
        /*! ./_add-to-unscopables */
        "../Grid/node_modules/core-js/modules/_add-to-unscopables.js")(KEY);
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.array.from.js":
      /*!**************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.array.from.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ArrayFromJs(module, exports, __webpack_require__) {
        "use strict";

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../Grid/node_modules/core-js/modules/_ctx.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../Grid/node_modules/core-js/modules/_to-object.js");

        var call = __webpack_require__(
        /*! ./_iter-call */
        "../Grid/node_modules/core-js/modules/_iter-call.js");

        var isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "../Grid/node_modules/core-js/modules/_is-array-iter.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var createProperty = __webpack_require__(
        /*! ./_create-property */
        "../Grid/node_modules/core-js/modules/_create-property.js");

        var getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "../Grid/node_modules/core-js/modules/core.get-iterator-method.js");

        $export($export.S + $export.F * !__webpack_require__(
        /*! ./_iter-detect */
        "../Grid/node_modules/core-js/modules/_iter-detect.js")(function (iter) {
          Array.from(iter);
        }), 'Array', {
          // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
          from: function from(arrayLike
          /* , mapfn = undefined, thisArg = undefined */
          ) {
            var O = toObject(arrayLike);
            var C = typeof this == 'function' ? this : Array;
            var aLen = arguments.length;
            var mapfn = aLen > 1 ? arguments[1] : undefined;
            var mapping = mapfn !== undefined;
            var index = 0;
            var iterFn = getIterFn(O);
            var length, result, step, iterator;
            if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
              for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
              }
            } else {
              length = toLength(O.length);

              for (result = new C(length); length > index; index++) {
                createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
              }
            }

            result.length = index;
            return result;
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.array.iterator.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.array.iterator.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ArrayIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var addToUnscopables = __webpack_require__(
        /*! ./_add-to-unscopables */
        "../Grid/node_modules/core-js/modules/_add-to-unscopables.js");

        var step = __webpack_require__(
        /*! ./_iter-step */
        "../Grid/node_modules/core-js/modules/_iter-step.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../Grid/node_modules/core-js/modules/_iterators.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../Grid/node_modules/core-js/modules/_to-iobject.js"); // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()


        module.exports = __webpack_require__(
        /*! ./_iter-define */
        "../Grid/node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
          this._t = toIObject(iterated); // target

          this._i = 0; // next index

          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var kind = this._k;
          var index = this._i++;

          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }

          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

        Iterators.Arguments = Iterators.Array;
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.function.name.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.function.name.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6FunctionNameJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f;

        var FProto = Function.prototype;
        var nameRE = /^\s*function ([^ (]*)/;
        var NAME = 'name'; // 19.2.4.2 name

        NAME in FProto || __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
          configurable: true,
          get: function get() {
            try {
              return ('' + this).match(nameRE)[1];
            } catch (e) {
              return '';
            }
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.map.js":
      /*!*******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.map.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6MapJs(module, exports, __webpack_require__) {
        "use strict";

        var strong = __webpack_require__(
        /*! ./_collection-strong */
        "../Grid/node_modules/core-js/modules/_collection-strong.js");

        var validate = __webpack_require__(
        /*! ./_validate-collection */
        "../Grid/node_modules/core-js/modules/_validate-collection.js");

        var MAP = 'Map'; // 23.1 Map Objects

        module.exports = __webpack_require__(
        /*! ./_collection */
        "../Grid/node_modules/core-js/modules/_collection.js")(MAP, function (get) {
          return function Map() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        }, {
          // 23.1.3.6 Map.prototype.get(key)
          get: function get(key) {
            var entry = strong.getEntry(validate(this, MAP), key);
            return entry && entry.v;
          },
          // 23.1.3.9 Map.prototype.set(key, value)
          set: function set(key, value) {
            return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
          }
        }, strong, true);
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.math.sign.js":
      /*!*************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.math.sign.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6MathSignJs(module, exports, __webpack_require__) {
        // 20.2.2.28 Math.sign(x)
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        $export($export.S, 'Math', {
          sign: __webpack_require__(
          /*! ./_math-sign */
          "../Grid/node_modules/core-js/modules/_math-sign.js")
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.number.constructor.js":
      /*!**********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.number.constructor.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6NumberConstructorJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var cof = __webpack_require__(
        /*! ./_cof */
        "../Grid/node_modules/core-js/modules/_cof.js");

        var inheritIfRequired = __webpack_require__(
        /*! ./_inherit-if-required */
        "../Grid/node_modules/core-js/modules/_inherit-if-required.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../Grid/node_modules/core-js/modules/_to-primitive.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "../Grid/node_modules/core-js/modules/_object-gopn.js").f;

        var gOPD = __webpack_require__(
        /*! ./_object-gopd */
        "../Grid/node_modules/core-js/modules/_object-gopd.js").f;

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f;

        var $trim = __webpack_require__(
        /*! ./_string-trim */
        "../Grid/node_modules/core-js/modules/_string-trim.js").trim;

        var NUMBER = 'Number';
        var $Number = global[NUMBER];
        var Base = $Number;
        var proto = $Number.prototype; // Opera ~12 has broken Object#toString

        var BROKEN_COF = cof(__webpack_require__(
        /*! ./_object-create */
        "../Grid/node_modules/core-js/modules/_object-create.js")(proto)) == NUMBER;
        var TRIM = 'trim' in String.prototype; // 7.1.3 ToNumber(argument)

        var toNumber = function toNumber(argument) {
          var it = toPrimitive(argument, false);

          if (typeof it == 'string' && it.length > 2) {
            it = TRIM ? it.trim() : $trim(it, 3);
            var first = it.charCodeAt(0);
            var third, radix, maxCode;

            if (first === 43 || first === 45) {
              third = it.charCodeAt(2);
              if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
            } else if (first === 48) {
              switch (it.charCodeAt(1)) {
                case 66:
                case 98:
                  radix = 2;
                  maxCode = 49;
                  break;
                // fast equal /^0b[01]+$/i

                case 79:
                case 111:
                  radix = 8;
                  maxCode = 55;
                  break;
                // fast equal /^0o[0-7]+$/i

                default:
                  return +it;
              }

              for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
                code = digits.charCodeAt(i); // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols

                if (code < 48 || code > maxCode) return NaN;
              }

              return parseInt(digits, radix);
            }
          }

          return +it;
        };

        if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
          $Number = function Number(value) {
            var it = arguments.length < 1 ? 0 : value;
            var that = this;
            return that instanceof $Number // check on 1..constructor(foo) case
            && (BROKEN_COF ? fails(function () {
              proto.valueOf.call(that);
            }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
          };

          for (var keys = __webpack_require__(
          /*! ./_descriptors */
          "../Grid/node_modules/core-js/modules/_descriptors.js") ? gOPN(Base) : ( // ES3:
          'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES6 (in case, if modules with ES6 Number statics required before):
          'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
            if (has(Base, key = keys[j]) && !has($Number, key)) {
              dP($Number, key, gOPD(Base, key));
            }
          }

          $Number.prototype = proto;
          proto.constructor = $Number;

          __webpack_require__(
          /*! ./_redefine */
          "../Grid/node_modules/core-js/modules/_redefine.js")(global, NUMBER, $Number);
        }
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.number.is-nan.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.number.is-nan.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6NumberIsNanJs(module, exports, __webpack_require__) {
        // 20.1.2.4 Number.isNaN(number)
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        $export($export.S, 'Number', {
          isNaN: function isNaN(number) {
            // eslint-disable-next-line no-self-compare
            return number != number;
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.object.assign.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.object.assign.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ObjectAssignJs(module, exports, __webpack_require__) {
        // 19.1.3.1 Object.assign(target, source)
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        $export($export.S + $export.F, 'Object', {
          assign: __webpack_require__(
          /*! ./_object-assign */
          "../Grid/node_modules/core-js/modules/_object-assign.js")
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.object.freeze.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.object.freeze.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ObjectFreezeJs(module, exports, __webpack_require__) {
        // 19.1.2.5 Object.freeze(O)
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var meta = __webpack_require__(
        /*! ./_meta */
        "../Grid/node_modules/core-js/modules/_meta.js").onFreeze;

        __webpack_require__(
        /*! ./_object-sap */
        "../Grid/node_modules/core-js/modules/_object-sap.js")('freeze', function ($freeze) {
          return function freeze(it) {
            return $freeze && isObject(it) ? $freeze(meta(it)) : it;
          };
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.object.is-extensible.js":
      /*!************************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.object.is-extensible.js ***!
        \************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ObjectIsExtensibleJs(module, exports, __webpack_require__) {
        // 19.1.2.11 Object.isExtensible(O)
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        __webpack_require__(
        /*! ./_object-sap */
        "../Grid/node_modules/core-js/modules/_object-sap.js")('isExtensible', function ($isExtensible) {
          return function isExtensible(it) {
            return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
          };
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.object.is-frozen.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.object.is-frozen.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ObjectIsFrozenJs(module, exports, __webpack_require__) {
        // 19.1.2.12 Object.isFrozen(O)
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        __webpack_require__(
        /*! ./_object-sap */
        "../Grid/node_modules/core-js/modules/_object-sap.js")('isFrozen', function ($isFrozen) {
          return function isFrozen(it) {
            return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
          };
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.object.keys.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.object.keys.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ObjectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 Object.keys(O)
        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../Grid/node_modules/core-js/modules/_to-object.js");

        var $keys = __webpack_require__(
        /*! ./_object-keys */
        "../Grid/node_modules/core-js/modules/_object-keys.js");

        __webpack_require__(
        /*! ./_object-sap */
        "../Grid/node_modules/core-js/modules/_object-sap.js")('keys', function () {
          return function keys(it) {
            return $keys(toObject(it));
          };
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.promise.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.promise.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6PromiseJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "../Grid/node_modules/core-js/modules/_library.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "../Grid/node_modules/core-js/modules/_ctx.js");

        var classof = __webpack_require__(
        /*! ./_classof */
        "../Grid/node_modules/core-js/modules/_classof.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "../Grid/node_modules/core-js/modules/_a-function.js");

        var anInstance = __webpack_require__(
        /*! ./_an-instance */
        "../Grid/node_modules/core-js/modules/_an-instance.js");

        var forOf = __webpack_require__(
        /*! ./_for-of */
        "../Grid/node_modules/core-js/modules/_for-of.js");

        var speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "../Grid/node_modules/core-js/modules/_species-constructor.js");

        var task = __webpack_require__(
        /*! ./_task */
        "../Grid/node_modules/core-js/modules/_task.js").set;

        var microtask = __webpack_require__(
        /*! ./_microtask */
        "../Grid/node_modules/core-js/modules/_microtask.js")();

        var newPromiseCapabilityModule = __webpack_require__(
        /*! ./_new-promise-capability */
        "../Grid/node_modules/core-js/modules/_new-promise-capability.js");

        var perform = __webpack_require__(
        /*! ./_perform */
        "../Grid/node_modules/core-js/modules/_perform.js");

        var userAgent = __webpack_require__(
        /*! ./_user-agent */
        "../Grid/node_modules/core-js/modules/_user-agent.js");

        var promiseResolve = __webpack_require__(
        /*! ./_promise-resolve */
        "../Grid/node_modules/core-js/modules/_promise-resolve.js");

        var PROMISE = 'Promise';
        var TypeError = global.TypeError;
        var process = global.process;
        var versions = process && process.versions;
        var v8 = versions && versions.v8 || '';
        var $Promise = global[PROMISE];
        var isNode = classof(process) == 'process';

        var empty = function empty() {
          /* empty */
        };

        var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
        var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
        var USE_NATIVE = !!function () {
          try {
            // correct subclassing with @@species support
            var promise = $Promise.resolve(1);

            var FakePromise = (promise.constructor = {})[__webpack_require__(
            /*! ./_wks */
            "../Grid/node_modules/core-js/modules/_wks.js")('species')] = function (exec) {
              exec(empty, empty);
            }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


            return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
            // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
            // we can't detect it synchronously, so just check versions
            && v8.indexOf('6.6') !== 0 && userAgent.indexOf('Chrome/66') === -1;
          } catch (e) {
            /* empty */
          }
        }(); // helpers

        var isThenable = function isThenable(it) {
          var then;
          return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
        };

        var notify = function notify(promise, isReject) {
          if (promise._n) return;
          promise._n = true;
          var chain = promise._c;
          microtask(function () {
            var value = promise._v;
            var ok = promise._s == 1;
            var i = 0;

            var run = function run(reaction) {
              var handler = ok ? reaction.ok : reaction.fail;
              var resolve = reaction.resolve;
              var reject = reaction.reject;
              var domain = reaction.domain;
              var result, then, exited;

              try {
                if (handler) {
                  if (!ok) {
                    if (promise._h == 2) onHandleUnhandled(promise);
                    promise._h = 1;
                  }

                  if (handler === true) result = value;else {
                    if (domain) domain.enter();
                    result = handler(value); // may throw

                    if (domain) {
                      domain.exit();
                      exited = true;
                    }
                  }

                  if (result === reaction.promise) {
                    reject(TypeError('Promise-chain cycle'));
                  } else if (then = isThenable(result)) {
                    then.call(result, resolve, reject);
                  } else resolve(result);
                } else reject(value);
              } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
              }
            };

            while (chain.length > i) {
              run(chain[i++]);
            } // variable length - can't use forEach


            promise._c = [];
            promise._n = false;
            if (isReject && !promise._h) onUnhandled(promise);
          });
        };

        var onUnhandled = function onUnhandled(promise) {
          task.call(global, function () {
            var value = promise._v;
            var unhandled = isUnhandled(promise);
            var result, handler, console;

            if (unhandled) {
              result = perform(function () {
                if (isNode) {
                  process.emit('unhandledRejection', value, promise);
                } else if (handler = global.onunhandledrejection) {
                  handler({
                    promise: promise,
                    reason: value
                  });
                } else if ((console = global.console) && console.error) {
                  console.error('Unhandled promise rejection', value);
                }
              }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

              promise._h = isNode || isUnhandled(promise) ? 2 : 1;
            }

            promise._a = undefined;
            if (unhandled && result.e) throw result.v;
          });
        };

        var isUnhandled = function isUnhandled(promise) {
          return promise._h !== 1 && (promise._a || promise._c).length === 0;
        };

        var onHandleUnhandled = function onHandleUnhandled(promise) {
          task.call(global, function () {
            var handler;

            if (isNode) {
              process.emit('rejectionHandled', promise);
            } else if (handler = global.onrejectionhandled) {
              handler({
                promise: promise,
                reason: promise._v
              });
            }
          });
        };

        var $reject = function $reject(value) {
          var promise = this;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          promise._v = value;
          promise._s = 2;
          if (!promise._a) promise._a = promise._c.slice();
          notify(promise, true);
        };

        var $resolve = function $resolve(value) {
          var promise = this;
          var then;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          try {
            if (promise === value) throw TypeError("Promise can't be resolved itself");

            if (then = isThenable(value)) {
              microtask(function () {
                var wrapper = {
                  _w: promise,
                  _d: false
                }; // wrap

                try {
                  then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
                } catch (e) {
                  $reject.call(wrapper, e);
                }
              });
            } else {
              promise._v = value;
              promise._s = 1;
              notify(promise, false);
            }
          } catch (e) {
            $reject.call({
              _w: promise,
              _d: false
            }, e); // wrap
          }
        }; // constructor polyfill


        if (!USE_NATIVE) {
          // 25.4.3.1 Promise(executor)
          $Promise = function Promise(executor) {
            anInstance(this, $Promise, PROMISE, '_h');
            aFunction(executor);
            Internal.call(this);

            try {
              executor(ctx($resolve, this, 1), ctx($reject, this, 1));
            } catch (err) {
              $reject.call(this, err);
            }
          }; // eslint-disable-next-line no-unused-vars


          Internal = function Promise(executor) {
            this._c = []; // <- awaiting reactions

            this._a = undefined; // <- checked in isUnhandled reactions

            this._s = 0; // <- state

            this._d = false; // <- done

            this._v = undefined; // <- value

            this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

            this._n = false; // <- notify
          };

          Internal.prototype = __webpack_require__(
          /*! ./_redefine-all */
          "../Grid/node_modules/core-js/modules/_redefine-all.js")($Promise.prototype, {
            // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
            then: function then(onFulfilled, onRejected) {
              var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
              reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
              reaction.fail = typeof onRejected == 'function' && onRejected;
              reaction.domain = isNode ? process.domain : undefined;

              this._c.push(reaction);

              if (this._a) this._a.push(reaction);
              if (this._s) notify(this, false);
              return reaction.promise;
            },
            // 25.4.5.1 Promise.prototype.catch(onRejected)
            'catch': function _catch(onRejected) {
              return this.then(undefined, onRejected);
            }
          });

          OwnPromiseCapability = function OwnPromiseCapability() {
            var promise = new Internal();
            this.promise = promise;
            this.resolve = ctx($resolve, promise, 1);
            this.reject = ctx($reject, promise, 1);
          };

          newPromiseCapabilityModule.f = newPromiseCapability = function newPromiseCapability(C) {
            return C === $Promise || C === Wrapper ? new OwnPromiseCapability(C) : newGenericPromiseCapability(C);
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Promise: $Promise
        });

        __webpack_require__(
        /*! ./_set-to-string-tag */
        "../Grid/node_modules/core-js/modules/_set-to-string-tag.js")($Promise, PROMISE);

        __webpack_require__(
        /*! ./_set-species */
        "../Grid/node_modules/core-js/modules/_set-species.js")(PROMISE);

        Wrapper = __webpack_require__(
        /*! ./_core */
        "../Grid/node_modules/core-js/modules/_core.js")[PROMISE]; // statics

        $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
          // 25.4.4.5 Promise.reject(r)
          reject: function reject(r) {
            var capability = newPromiseCapability(this);
            var $$reject = capability.reject;
            $$reject(r);
            return capability.promise;
          }
        });
        $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
          // 25.4.4.6 Promise.resolve(x)
          resolve: function resolve(x) {
            return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
          }
        });
        $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(
        /*! ./_iter-detect */
        "../Grid/node_modules/core-js/modules/_iter-detect.js")(function (iter) {
          $Promise.all(iter)['catch'](empty);
        })), PROMISE, {
          // 25.4.4.1 Promise.all(iterable)
          all: function all(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var resolve = capability.resolve;
            var reject = capability.reject;
            var result = perform(function () {
              var values = [];
              var index = 0;
              var remaining = 1;
              forOf(iterable, false, function (promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[$index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (result.e) reject(result.v);
            return capability.promise;
          },
          // 25.4.4.4 Promise.race(iterable)
          race: function race(iterable) {
            var C = this;
            var capability = newPromiseCapability(C);
            var reject = capability.reject;
            var result = perform(function () {
              forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
              });
            });
            if (result.e) reject(result.v);
            return capability.promise;
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.reflect.define-property.js":
      /*!***************************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.reflect.define-property.js ***!
        \***************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ReflectDefinePropertyJs(module, exports, __webpack_require__) {
        // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../Grid/node_modules/core-js/modules/_to-primitive.js"); // MS Edge has broken Reflect.defineProperty - throwing instead of returning false


        $export($export.S + $export.F * __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js")(function () {
          // eslint-disable-next-line no-undef
          Reflect.defineProperty(dP.f({}, 1, {
            value: 1
          }), 1, {
            value: 2
          });
        }), 'Reflect', {
          defineProperty: function defineProperty(target, propertyKey, attributes) {
            anObject(target);
            propertyKey = toPrimitive(propertyKey, true);
            anObject(attributes);

            try {
              dP.f(target, propertyKey, attributes);
              return true;
            } catch (e) {
              return false;
            }
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js":
      /*!***************************************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.reflect.get-own-property-descriptor.js ***!
        \***************************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ReflectGetOwnPropertyDescriptorJs(module, exports, __webpack_require__) {
        // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
        var gOPD = __webpack_require__(
        /*! ./_object-gopd */
        "../Grid/node_modules/core-js/modules/_object-gopd.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        $export($export.S, 'Reflect', {
          getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
            return gOPD.f(anObject(target), propertyKey);
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.reflect.get.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.reflect.get.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ReflectGetJs(module, exports, __webpack_require__) {
        // 26.1.6 Reflect.get(target, propertyKey [, receiver])
        var gOPD = __webpack_require__(
        /*! ./_object-gopd */
        "../Grid/node_modules/core-js/modules/_object-gopd.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "../Grid/node_modules/core-js/modules/_object-gpo.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        function get(target, propertyKey
        /* , receiver */
        ) {
          var receiver = arguments.length < 3 ? target : arguments[2];
          var desc, proto;
          if (anObject(target) === receiver) return target[propertyKey];
          if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
          if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
        }

        $export($export.S, 'Reflect', {
          get: get
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.reflect.own-keys.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.reflect.own-keys.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ReflectOwnKeysJs(module, exports, __webpack_require__) {
        // 26.1.11 Reflect.ownKeys(target)
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        $export($export.S, 'Reflect', {
          ownKeys: __webpack_require__(
          /*! ./_own-keys */
          "../Grid/node_modules/core-js/modules/_own-keys.js")
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.reflect.set.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.reflect.set.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6ReflectSetJs(module, exports, __webpack_require__) {
        // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js");

        var gOPD = __webpack_require__(
        /*! ./_object-gopd */
        "../Grid/node_modules/core-js/modules/_object-gopd.js");

        var getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "../Grid/node_modules/core-js/modules/_object-gpo.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../Grid/node_modules/core-js/modules/_property-desc.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        function set(target, propertyKey, V
        /* , receiver */
        ) {
          var receiver = arguments.length < 4 ? target : arguments[3];
          var ownDesc = gOPD.f(anObject(target), propertyKey);
          var existingDescriptor, proto;

          if (!ownDesc) {
            if (isObject(proto = getPrototypeOf(target))) {
              return set(proto, propertyKey, V, receiver);
            }

            ownDesc = createDesc(0);
          }

          if (has(ownDesc, 'value')) {
            if (ownDesc.writable === false || !isObject(receiver)) return false;

            if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
              if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
              existingDescriptor.value = V;
              dP.f(receiver, propertyKey, existingDescriptor);
            } else dP.f(receiver, propertyKey, createDesc(0, V));

            return true;
          }

          return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
        }

        $export($export.S, 'Reflect', {
          set: set
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.constructor.js":
      /*!**********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.constructor.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpConstructorJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var inheritIfRequired = __webpack_require__(
        /*! ./_inherit-if-required */
        "../Grid/node_modules/core-js/modules/_inherit-if-required.js");

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f;

        var gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "../Grid/node_modules/core-js/modules/_object-gopn.js").f;

        var isRegExp = __webpack_require__(
        /*! ./_is-regexp */
        "../Grid/node_modules/core-js/modules/_is-regexp.js");

        var $flags = __webpack_require__(
        /*! ./_flags */
        "../Grid/node_modules/core-js/modules/_flags.js");

        var $RegExp = global.RegExp;
        var Base = $RegExp;
        var proto = $RegExp.prototype;
        var re1 = /a/g;
        var re2 = /a/g; // "new" creates a new object, old webkit buggy here

        var CORRECT_NEW = new $RegExp(re1) !== re1;

        if (__webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") && (!CORRECT_NEW || __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js")(function () {
          re2[__webpack_require__(
          /*! ./_wks */
          "../Grid/node_modules/core-js/modules/_wks.js")('match')] = false; // RegExp constructor can alter flags and IsRegExp works correct with @@match

          return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
        }))) {
          $RegExp = function RegExp(p, f) {
            var tiRE = this instanceof $RegExp;
            var piRE = isRegExp(p);
            var fiU = f === undefined;
            return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
          };

          var proxy = function proxy(key) {
            key in $RegExp || dP($RegExp, key, {
              configurable: true,
              get: function get() {
                return Base[key];
              },
              set: function set(it) {
                Base[key] = it;
              }
            });
          };

          for (var keys = gOPN(Base), i = 0; keys.length > i;) {
            proxy(keys[i++]);
          }

          proto.constructor = $RegExp;
          $RegExp.prototype = proto;

          __webpack_require__(
          /*! ./_redefine */
          "../Grid/node_modules/core-js/modules/_redefine.js")(global, 'RegExp', $RegExp);
        }

        __webpack_require__(
        /*! ./_set-species */
        "../Grid/node_modules/core-js/modules/_set-species.js")('RegExp');
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.exec.js":
      /*!***************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.exec.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpExecJs(module, exports, __webpack_require__) {
        "use strict";

        var regexpExec = __webpack_require__(
        /*! ./_regexp-exec */
        "../Grid/node_modules/core-js/modules/_regexp-exec.js");

        __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js")({
          target: 'RegExp',
          proto: true,
          forced: regexpExec !== /./.exec
        }, {
          exec: regexpExec
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.flags.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.flags.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpFlagsJs(module, exports, __webpack_require__) {
        // 21.2.5.3 get RegExp.prototype.flags()
        if (__webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
          configurable: true,
          get: __webpack_require__(
          /*! ./_flags */
          "../Grid/node_modules/core-js/modules/_flags.js")
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.match.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.match.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpMatchJs(module, exports, __webpack_require__) {
        "use strict";

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var advanceStringIndex = __webpack_require__(
        /*! ./_advance-string-index */
        "../Grid/node_modules/core-js/modules/_advance-string-index.js");

        var regExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "../Grid/node_modules/core-js/modules/_regexp-exec-abstract.js"); // @@match logic


        __webpack_require__(
        /*! ./_fix-re-wks */
        "../Grid/node_modules/core-js/modules/_fix-re-wks.js")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
          return [// `String.prototype.match` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.match
          function match(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[MATCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
          }, // `RegExp.prototype[@@match]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
          function (regexp) {
            var res = maybeCallNative($match, regexp, this);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            if (!rx.global) return regExpExec(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;

            while ((result = regExpExec(rx, S)) !== null) {
              var matchStr = String(result[0]);
              A[n] = matchStr;
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
              n++;
            }

            return n === 0 ? null : A;
          }];
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.replace.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.replace.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpReplaceJs(module, exports, __webpack_require__) {
        "use strict";

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../Grid/node_modules/core-js/modules/_to-object.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "../Grid/node_modules/core-js/modules/_to-integer.js");

        var advanceStringIndex = __webpack_require__(
        /*! ./_advance-string-index */
        "../Grid/node_modules/core-js/modules/_advance-string-index.js");

        var regExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "../Grid/node_modules/core-js/modules/_regexp-exec-abstract.js");

        var max = Math.max;
        var min = Math.min;
        var floor = Math.floor;
        var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
        var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

        var maybeToString = function maybeToString(it) {
          return it === undefined ? it : String(it);
        }; // @@replace logic


        __webpack_require__(
        /*! ./_fix-re-wks */
        "../Grid/node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
          return [// `String.prototype.replace` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.replace
          function replace(searchValue, replaceValue) {
            var O = defined(this);
            var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
          }, // `RegExp.prototype[@@replace]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
          function (regexp, replaceValue) {
            var res = maybeCallNative($replace, regexp, this, replaceValue);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var functionalReplace = typeof replaceValue === 'function';
            if (!functionalReplace) replaceValue = String(replaceValue);
            var global = rx.global;

            if (global) {
              var fullUnicode = rx.unicode;
              rx.lastIndex = 0;
            }

            var results = [];

            while (true) {
              var result = regExpExec(rx, S);
              if (result === null) break;
              results.push(result);
              if (!global) break;
              var matchStr = String(result[0]);
              if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
            }

            var accumulatedResult = '';
            var nextSourcePosition = 0;

            for (var i = 0; i < results.length; i++) {
              result = results[i];
              var matched = String(result[0]);
              var position = max(min(toInteger(result.index), S.length), 0);
              var captures = []; // NOTE: This is equivalent to
              //   captures = result.slice(1).map(maybeToString)
              // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
              // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
              // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.

              for (var j = 1; j < result.length; j++) {
                captures.push(maybeToString(result[j]));
              }

              var namedCaptures = result.groups;

              if (functionalReplace) {
                var replacerArgs = [matched].concat(captures, position, S);
                if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                var replacement = String(replaceValue.apply(undefined, replacerArgs));
              } else {
                replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
              }

              if (position >= nextSourcePosition) {
                accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                nextSourcePosition = position + matched.length;
              }
            }

            return accumulatedResult + S.slice(nextSourcePosition);
          }]; // https://tc39.github.io/ecma262/#sec-getsubstitution

          function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
            var tailPos = position + matched.length;
            var m = captures.length;
            var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;

            if (namedCaptures !== undefined) {
              namedCaptures = toObject(namedCaptures);
              symbols = SUBSTITUTION_SYMBOLS;
            }

            return $replace.call(replacement, symbols, function (match, ch) {
              var capture;

              switch (ch.charAt(0)) {
                case '$':
                  return '$';

                case '&':
                  return matched;

                case '`':
                  return str.slice(0, position);

                case "'":
                  return str.slice(tailPos);

                case '<':
                  capture = namedCaptures[ch.slice(1, -1)];
                  break;

                default:
                  // \d\d?
                  var n = +ch;
                  if (n === 0) return match;

                  if (n > m) {
                    var f = floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                    return match;
                  }

                  capture = captures[n - 1];
              }

              return capture === undefined ? '' : capture;
            });
          }
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.search.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.search.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpSearchJs(module, exports, __webpack_require__) {
        "use strict";

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var sameValue = __webpack_require__(
        /*! ./_same-value */
        "../Grid/node_modules/core-js/modules/_same-value.js");

        var regExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "../Grid/node_modules/core-js/modules/_regexp-exec-abstract.js"); // @@search logic


        __webpack_require__(
        /*! ./_fix-re-wks */
        "../Grid/node_modules/core-js/modules/_fix-re-wks.js")('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
          return [// `String.prototype.search` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.search
          function search(regexp) {
            var O = defined(this);
            var fn = regexp == undefined ? undefined : regexp[SEARCH];
            return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
          }, // `RegExp.prototype[@@search]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
          function (regexp) {
            var res = maybeCallNative($search, regexp, this);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var previousLastIndex = rx.lastIndex;
            if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
            var result = regExpExec(rx, S);
            if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
            return result === null ? -1 : result.index;
          }];
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.split.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.split.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpSplitJs(module, exports, __webpack_require__) {
        "use strict";

        var isRegExp = __webpack_require__(
        /*! ./_is-regexp */
        "../Grid/node_modules/core-js/modules/_is-regexp.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "../Grid/node_modules/core-js/modules/_species-constructor.js");

        var advanceStringIndex = __webpack_require__(
        /*! ./_advance-string-index */
        "../Grid/node_modules/core-js/modules/_advance-string-index.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var callRegExpExec = __webpack_require__(
        /*! ./_regexp-exec-abstract */
        "../Grid/node_modules/core-js/modules/_regexp-exec-abstract.js");

        var regexpExec = __webpack_require__(
        /*! ./_regexp-exec */
        "../Grid/node_modules/core-js/modules/_regexp-exec.js");

        var fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        var $min = Math.min;
        var $push = [].push;
        var $SPLIT = 'split';
        var LENGTH = 'length';
        var LAST_INDEX = 'lastIndex';
        var MAX_UINT32 = 0xffffffff; // babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError

        var SUPPORTS_Y = !fails(function () {
          RegExp(MAX_UINT32, 'y');
        }); // @@split logic

        __webpack_require__(
        /*! ./_fix-re-wks */
        "../Grid/node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
          var internalSplit;

          if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
            // based on es5-shim implementation, need to rework it
            internalSplit = function internalSplit(separator, limit) {
              var string = String(this);
              if (separator === undefined && limit === 0) return []; // If `separator` is not a regex, use native split

              if (!isRegExp(separator)) return $split.call(string, separator, limit);
              var output = [];
              var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
              var lastLastIndex = 0;
              var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0; // Make `global` and avoid `lastIndex` issues by working with a copy

              var separatorCopy = new RegExp(separator.source, flags + 'g');
              var match, lastIndex, lastLength;

              while (match = regexpExec.call(separatorCopy, string)) {
                lastIndex = separatorCopy[LAST_INDEX];

                if (lastIndex > lastLastIndex) {
                  output.push(string.slice(lastLastIndex, match.index));
                  if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                  lastLength = match[0][LENGTH];
                  lastLastIndex = lastIndex;
                  if (output[LENGTH] >= splitLimit) break;
                }

                if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
              }

              if (lastLastIndex === string[LENGTH]) {
                if (lastLength || !separatorCopy.test('')) output.push('');
              } else output.push(string.slice(lastLastIndex));

              return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
            }; // Chakra, V8

          } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
            internalSplit = function internalSplit(separator, limit) {
              return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
            };
          } else {
            internalSplit = $split;
          }

          return [// `String.prototype.split` method
          // https://tc39.github.io/ecma262/#sec-string.prototype.split
          function split(separator, limit) {
            var O = defined(this);
            var splitter = separator == undefined ? undefined : separator[SPLIT];
            return splitter !== undefined ? splitter.call(separator, O, limit) : internalSplit.call(String(O), separator, limit);
          }, // `RegExp.prototype[@@split]` method
          // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
          //
          // NOTE: This cannot be properly polyfilled in engines that don't support
          // the 'y' flag.
          function (regexp, limit) {
            var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
            if (res.done) return res.value;
            var rx = anObject(regexp);
            var S = String(this);
            var C = speciesConstructor(rx, RegExp);
            var unicodeMatching = rx.unicode;
            var flags = (rx.ignoreCase ? 'i' : '') + (rx.multiline ? 'm' : '') + (rx.unicode ? 'u' : '') + (SUPPORTS_Y ? 'y' : 'g'); // ^(? + rx + ) is needed, in combination with some S slicing, to
            // simulate the 'y' flag.

            var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
            var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
            if (lim === 0) return [];
            if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
            var p = 0;
            var q = 0;
            var A = [];

            while (q < S.length) {
              splitter.lastIndex = SUPPORTS_Y ? q : 0;
              var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
              var e;

              if (z === null || (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p) {
                q = advanceStringIndex(S, q, unicodeMatching);
              } else {
                A.push(S.slice(p, q));
                if (A.length === lim) return A;

                for (var i = 1; i <= z.length - 1; i++) {
                  A.push(z[i]);
                  if (A.length === lim) return A;
                }

                q = p = e;
              }
            }

            A.push(S.slice(p));
            return A;
          }];
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.regexp.to-string.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.regexp.to-string.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6RegexpToStringJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! ./es6.regexp.flags */
        "../Grid/node_modules/core-js/modules/es6.regexp.flags.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var $flags = __webpack_require__(
        /*! ./_flags */
        "../Grid/node_modules/core-js/modules/_flags.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js");

        var TO_STRING = 'toString';
        var $toString = /./[TO_STRING];

        var define = function define(fn) {
          __webpack_require__(
          /*! ./_redefine */
          "../Grid/node_modules/core-js/modules/_redefine.js")(RegExp.prototype, TO_STRING, fn, true);
        }; // 21.2.5.14 RegExp.prototype.toString()


        if (__webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js")(function () {
          return $toString.call({
            source: 'a',
            flags: 'b'
          }) != '/a/b';
        })) {
          define(function toString() {
            var R = anObject(this);
            return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
          }); // FF44- RegExp#toString has a wrong name
        } else if ($toString.name != TO_STRING) {
          define(function toString() {
            return $toString.call(this);
          });
        }
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.set.js":
      /*!*******************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.set.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6SetJs(module, exports, __webpack_require__) {
        "use strict";

        var strong = __webpack_require__(
        /*! ./_collection-strong */
        "../Grid/node_modules/core-js/modules/_collection-strong.js");

        var validate = __webpack_require__(
        /*! ./_validate-collection */
        "../Grid/node_modules/core-js/modules/_validate-collection.js");

        var SET = 'Set'; // 23.2 Set Objects

        module.exports = __webpack_require__(
        /*! ./_collection */
        "../Grid/node_modules/core-js/modules/_collection.js")(SET, function (get) {
          return function Set() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        }, {
          // 23.2.3.1 Set.prototype.add(value)
          add: function add(value) {
            return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
          }
        }, strong);
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.string.anchor.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.string.anchor.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6StringAnchorJs(module, exports, __webpack_require__) {
        "use strict"; // B.2.3.2 String.prototype.anchor(name)

        __webpack_require__(
        /*! ./_string-html */
        "../Grid/node_modules/core-js/modules/_string-html.js")('anchor', function (createHTML) {
          return function anchor(name) {
            return createHTML(this, 'a', 'name', name);
          };
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.string.ends-with.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.string.ends-with.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6StringEndsWithJs(module, exports, __webpack_require__) {
        "use strict"; // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var context = __webpack_require__(
        /*! ./_string-context */
        "../Grid/node_modules/core-js/modules/_string-context.js");

        var ENDS_WITH = 'endsWith';
        var $endsWith = ''[ENDS_WITH];
        $export($export.P + $export.F * __webpack_require__(
        /*! ./_fails-is-regexp */
        "../Grid/node_modules/core-js/modules/_fails-is-regexp.js")(ENDS_WITH), 'String', {
          endsWith: function endsWith(searchString
          /* , endPosition = @length */
          ) {
            var that = context(this, searchString, ENDS_WITH);
            var endPosition = arguments.length > 1 ? arguments[1] : undefined;
            var len = toLength(that.length);
            var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
            var search = String(searchString);
            return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.string.includes.js":
      /*!*******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.string.includes.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6StringIncludesJs(module, exports, __webpack_require__) {
        "use strict"; // 21.1.3.7 String.prototype.includes(searchString, position = 0)

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var context = __webpack_require__(
        /*! ./_string-context */
        "../Grid/node_modules/core-js/modules/_string-context.js");

        var INCLUDES = 'includes';
        $export($export.P + $export.F * __webpack_require__(
        /*! ./_fails-is-regexp */
        "../Grid/node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
          includes: function includes(searchString
          /* , position = 0 */
          ) {
            return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.string.iterator.js":
      /*!*******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.string.iterator.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6StringIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var $at = __webpack_require__(
        /*! ./_string-at */
        "../Grid/node_modules/core-js/modules/_string-at.js")(true); // 21.1.3.27 String.prototype[@@iterator]()


        __webpack_require__(
        /*! ./_iter-define */
        "../Grid/node_modules/core-js/modules/_iter-define.js")(String, 'String', function (iterated) {
          this._t = String(iterated); // target

          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        }, function () {
          var O = this._t;
          var index = this._i;
          var point;
          if (index >= O.length) return {
            value: undefined,
            done: true
          };
          point = $at(O, index);
          this._i += point.length;
          return {
            value: point,
            done: false
          };
        });
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.string.repeat.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.string.repeat.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6StringRepeatJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        $export($export.P, 'String', {
          // 21.1.3.13 String.prototype.repeat(count)
          repeat: __webpack_require__(
          /*! ./_string-repeat */
          "../Grid/node_modules/core-js/modules/_string-repeat.js")
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.string.starts-with.js":
      /*!**********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.string.starts-with.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6StringStartsWithJs(module, exports, __webpack_require__) {
        "use strict"; // 21.1.3.18 String.prototype.startsWith(searchString [, position ])

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var toLength = __webpack_require__(
        /*! ./_to-length */
        "../Grid/node_modules/core-js/modules/_to-length.js");

        var context = __webpack_require__(
        /*! ./_string-context */
        "../Grid/node_modules/core-js/modules/_string-context.js");

        var STARTS_WITH = 'startsWith';
        var $startsWith = ''[STARTS_WITH];
        $export($export.P + $export.F * __webpack_require__(
        /*! ./_fails-is-regexp */
        "../Grid/node_modules/core-js/modules/_fails-is-regexp.js")(STARTS_WITH), 'String', {
          startsWith: function startsWith(searchString
          /* , position = 0 */
          ) {
            var that = context(this, searchString, STARTS_WITH);
            var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
            var search = String(searchString);
            return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.symbol.js":
      /*!**********************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.symbol.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6SymbolJs(module, exports, __webpack_require__) {
        "use strict"; // ECMAScript 6 symbols shim

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var has = __webpack_require__(
        /*! ./_has */
        "../Grid/node_modules/core-js/modules/_has.js");

        var DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "../Grid/node_modules/core-js/modules/_descriptors.js");

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        var META = __webpack_require__(
        /*! ./_meta */
        "../Grid/node_modules/core-js/modules/_meta.js").KEY;

        var $fails = __webpack_require__(
        /*! ./_fails */
        "../Grid/node_modules/core-js/modules/_fails.js");

        var shared = __webpack_require__(
        /*! ./_shared */
        "../Grid/node_modules/core-js/modules/_shared.js");

        var setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "../Grid/node_modules/core-js/modules/_set-to-string-tag.js");

        var uid = __webpack_require__(
        /*! ./_uid */
        "../Grid/node_modules/core-js/modules/_uid.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js");

        var wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "../Grid/node_modules/core-js/modules/_wks-ext.js");

        var wksDefine = __webpack_require__(
        /*! ./_wks-define */
        "../Grid/node_modules/core-js/modules/_wks-define.js");

        var enumKeys = __webpack_require__(
        /*! ./_enum-keys */
        "../Grid/node_modules/core-js/modules/_enum-keys.js");

        var isArray = __webpack_require__(
        /*! ./_is-array */
        "../Grid/node_modules/core-js/modules/_is-array.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "../Grid/node_modules/core-js/modules/_an-object.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var toObject = __webpack_require__(
        /*! ./_to-object */
        "../Grid/node_modules/core-js/modules/_to-object.js");

        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "../Grid/node_modules/core-js/modules/_to-iobject.js");

        var toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "../Grid/node_modules/core-js/modules/_to-primitive.js");

        var createDesc = __webpack_require__(
        /*! ./_property-desc */
        "../Grid/node_modules/core-js/modules/_property-desc.js");

        var _create = __webpack_require__(
        /*! ./_object-create */
        "../Grid/node_modules/core-js/modules/_object-create.js");

        var gOPNExt = __webpack_require__(
        /*! ./_object-gopn-ext */
        "../Grid/node_modules/core-js/modules/_object-gopn-ext.js");

        var $GOPD = __webpack_require__(
        /*! ./_object-gopd */
        "../Grid/node_modules/core-js/modules/_object-gopd.js");

        var $GOPS = __webpack_require__(
        /*! ./_object-gops */
        "../Grid/node_modules/core-js/modules/_object-gops.js");

        var $DP = __webpack_require__(
        /*! ./_object-dp */
        "../Grid/node_modules/core-js/modules/_object-dp.js");

        var $keys = __webpack_require__(
        /*! ./_object-keys */
        "../Grid/node_modules/core-js/modules/_object-keys.js");

        var gOPD = $GOPD.f;
        var dP = $DP.f;
        var gOPN = gOPNExt.f;
        var $Symbol = global.Symbol;
        var $JSON = global.JSON;

        var _stringify = $JSON && $JSON.stringify;

        var PROTOTYPE = 'prototype';
        var HIDDEN = wks('_hidden');
        var TO_PRIMITIVE = wks('toPrimitive');
        var isEnum = {}.propertyIsEnumerable;
        var SymbolRegistry = shared('symbol-registry');
        var AllSymbols = shared('symbols');
        var OPSymbols = shared('op-symbols');
        var ObjectProto = Object[PROTOTYPE];
        var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
        var QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173

        var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

        var setSymbolDesc = DESCRIPTORS && $fails(function () {
          return _create(dP({}, 'a', {
            get: function get() {
              return dP(this, 'a', {
                value: 7
              }).a;
            }
          })).a != 7;
        }) ? function (it, key, D) {
          var protoDesc = gOPD(ObjectProto, key);
          if (protoDesc) delete ObjectProto[key];
          dP(it, key, D);
          if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
        } : dP;

        var wrap = function wrap(tag) {
          var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

          sym._k = tag;
          return sym;
        };

        var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
          return typeof it == 'symbol';
        } : function (it) {
          return it instanceof $Symbol;
        };

        var $defineProperty = function defineProperty(it, key, D) {
          if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
          anObject(it);
          key = toPrimitive(key, true);
          anObject(D);

          if (has(AllSymbols, key)) {
            if (!D.enumerable) {
              if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
              it[HIDDEN][key] = true;
            } else {
              if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
              D = _create(D, {
                enumerable: createDesc(0, false)
              });
            }

            return setSymbolDesc(it, key, D);
          }

          return dP(it, key, D);
        };

        var $defineProperties = function defineProperties(it, P) {
          anObject(it);
          var keys = enumKeys(P = toIObject(P));
          var i = 0;
          var l = keys.length;
          var key;

          while (l > i) {
            $defineProperty(it, key = keys[i++], P[key]);
          }

          return it;
        };

        var $create = function create(it, P) {
          return P === undefined ? _create(it) : $defineProperties(_create(it), P);
        };

        var $propertyIsEnumerable = function propertyIsEnumerable(key) {
          var E = isEnum.call(this, key = toPrimitive(key, true));
          if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
          return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
        };

        var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
          it = toIObject(it);
          key = toPrimitive(key, true);
          if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
          var D = gOPD(it, key);
          if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
          return D;
        };

        var $getOwnPropertyNames = function getOwnPropertyNames(it) {
          var names = gOPN(toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
          }

          return result;
        };

        var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
          var IS_OP = it === ObjectProto;
          var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
          var result = [];
          var i = 0;
          var key;

          while (names.length > i) {
            if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
          }

          return result;
        }; // 19.4.1.1 Symbol([description])


        if (!USE_NATIVE) {
          $Symbol = function Symbol() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
            var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

            var $set = function $set(value) {
              if (this === ObjectProto) $set.call(OPSymbols, value);
              if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
              setSymbolDesc(this, tag, createDesc(1, value));
            };

            if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
              configurable: true,
              set: $set
            });
            return wrap(tag);
          };

          redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return this._k;
          });
          $GOPD.f = $getOwnPropertyDescriptor;
          $DP.f = $defineProperty;
          __webpack_require__(
          /*! ./_object-gopn */
          "../Grid/node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
          __webpack_require__(
          /*! ./_object-pie */
          "../Grid/node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
          $GOPS.f = $getOwnPropertySymbols;

          if (DESCRIPTORS && !__webpack_require__(
          /*! ./_library */
          "../Grid/node_modules/core-js/modules/_library.js")) {
            redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
          }

          wksExt.f = function (name) {
            return wrap(wks(name));
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Symbol: $Symbol
        });

        for (var es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) {
          wks(es6Symbols[j++]);
        }

        for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) {
          wksDefine(wellKnownSymbols[k++]);
        }

        $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
          // 19.4.2.1 Symbol.for(key)
          'for': function _for(key) {
            return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
          },
          // 19.4.2.5 Symbol.keyFor(sym)
          keyFor: function keyFor(sym) {
            if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');

            for (var key in SymbolRegistry) {
              if (SymbolRegistry[key] === sym) return key;
            }
          },
          useSetter: function useSetter() {
            setter = true;
          },
          useSimple: function useSimple() {
            setter = false;
          }
        });
        $export($export.S + $export.F * !USE_NATIVE, 'Object', {
          // 19.1.2.2 Object.create(O [, Properties])
          create: $create,
          // 19.1.2.4 Object.defineProperty(O, P, Attributes)
          defineProperty: $defineProperty,
          // 19.1.2.3 Object.defineProperties(O, Properties)
          defineProperties: $defineProperties,
          // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
          // 19.1.2.7 Object.getOwnPropertyNames(O)
          getOwnPropertyNames: $getOwnPropertyNames,
          // 19.1.2.8 Object.getOwnPropertySymbols(O)
          getOwnPropertySymbols: $getOwnPropertySymbols
        }); // Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
        // https://bugs.chromium.org/p/v8/issues/detail?id=3443

        var FAILS_ON_PRIMITIVES = $fails(function () {
          $GOPS.f(1);
        });
        $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
          getOwnPropertySymbols: function getOwnPropertySymbols(it) {
            return $GOPS.f(toObject(it));
          }
        }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

        $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
          var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
          // WebKit converts symbol values to JSON as null
          // V8 throws on boxed symbols

          return _stringify([S]) != '[null]' || _stringify({
            a: S
          }) != '{}' || _stringify(Object(S)) != '{}';
        })), 'JSON', {
          stringify: function stringify(it) {
            var args = [it];
            var i = 1;
            var replacer, $replacer;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            $replacer = replacer = args[1];
            if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

            if (!isArray(replacer)) replacer = function replacer(key, value) {
              if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
              if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return _stringify.apply($JSON, args);
          }
        }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

        $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

        setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

        setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

        setToStringTag(global.JSON, 'JSON', true);
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es6.weak-map.js":
      /*!************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es6.weak-map.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs6WeakMapJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var each = __webpack_require__(
        /*! ./_array-methods */
        "../Grid/node_modules/core-js/modules/_array-methods.js")(0);

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        var meta = __webpack_require__(
        /*! ./_meta */
        "../Grid/node_modules/core-js/modules/_meta.js");

        var assign = __webpack_require__(
        /*! ./_object-assign */
        "../Grid/node_modules/core-js/modules/_object-assign.js");

        var weak = __webpack_require__(
        /*! ./_collection-weak */
        "../Grid/node_modules/core-js/modules/_collection-weak.js");

        var isObject = __webpack_require__(
        /*! ./_is-object */
        "../Grid/node_modules/core-js/modules/_is-object.js");

        var validate = __webpack_require__(
        /*! ./_validate-collection */
        "../Grid/node_modules/core-js/modules/_validate-collection.js");

        var NATIVE_WEAK_MAP = __webpack_require__(
        /*! ./_validate-collection */
        "../Grid/node_modules/core-js/modules/_validate-collection.js");

        var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
        var WEAK_MAP = 'WeakMap';
        var getWeak = meta.getWeak;
        var isExtensible = Object.isExtensible;
        var uncaughtFrozenStore = weak.ufstore;
        var InternalMap;

        var wrapper = function wrapper(get) {
          return function WeakMap() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        };

        var methods = {
          // 23.3.3.3 WeakMap.prototype.get(key)
          get: function get(key) {
            if (isObject(key)) {
              var data = getWeak(key);
              if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
              return data ? data[this._i] : undefined;
            }
          },
          // 23.3.3.5 WeakMap.prototype.set(key, value)
          set: function set(key, value) {
            return weak.def(validate(this, WEAK_MAP), key, value);
          }
        }; // 23.3 WeakMap Objects

        var $WeakMap = module.exports = __webpack_require__(
        /*! ./_collection */
        "../Grid/node_modules/core-js/modules/_collection.js")(WEAK_MAP, wrapper, methods, weak, true, true); // IE11 WeakMap frozen keys fix


        if (NATIVE_WEAK_MAP && IS_IE11) {
          InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
          assign(InternalMap.prototype, methods);
          meta.NEED = true;
          each(['delete', 'has', 'get', 'set'], function (key) {
            var proto = $WeakMap.prototype;
            var method = proto[key];
            redefine(proto, key, function (a, b) {
              // store frozen objects on internal weakmap shim
              if (isObject(a) && !isExtensible(a)) {
                if (!this._f) this._f = new InternalMap();

                var result = this._f[key](a, b);

                return key == 'set' ? this : result; // store all the rest on native weakmap
              }

              return method.call(this, a, b);
            });
          });
        }
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es7.array.includes.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es7.array.includes.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs7ArrayIncludesJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/Array.prototype.includes

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var $includes = __webpack_require__(
        /*! ./_array-includes */
        "../Grid/node_modules/core-js/modules/_array-includes.js")(true);

        $export($export.P, 'Array', {
          includes: function includes(el
          /* , fromIndex = 0 */
          ) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__(
        /*! ./_add-to-unscopables */
        "../Grid/node_modules/core-js/modules/_add-to-unscopables.js")('includes');
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/es7.object.entries.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es7.object.entries.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs7ObjectEntriesJs(module, exports, __webpack_require__) {
        // https://github.com/tc39/proposal-object-values-entries
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var $entries = __webpack_require__(
        /*! ./_object-to-array */
        "../Grid/node_modules/core-js/modules/_object-to-array.js")(true);

        $export($export.S, 'Object', {
          entries: function entries(it) {
            return $entries(it);
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es7.object.values.js":
      /*!*****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es7.object.values.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs7ObjectValuesJs(module, exports, __webpack_require__) {
        // https://github.com/tc39/proposal-object-values-entries
        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var $values = __webpack_require__(
        /*! ./_object-to-array */
        "../Grid/node_modules/core-js/modules/_object-to-array.js")(false);

        $export($export.S, 'Object', {
          values: function values(it) {
            return $values(it);
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es7.string.pad-end.js":
      /*!******************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es7.string.pad-end.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs7StringPadEndJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/proposal-string-pad-start-end

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var $pad = __webpack_require__(
        /*! ./_string-pad */
        "../Grid/node_modules/core-js/modules/_string-pad.js");

        var userAgent = __webpack_require__(
        /*! ./_user-agent */
        "../Grid/node_modules/core-js/modules/_user-agent.js"); // https://github.com/zloirock/core-js/issues/280


        var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
        $export($export.P + $export.F * WEBKIT_BUG, 'String', {
          padEnd: function padEnd(maxLength
          /* , fillString = ' ' */
          ) {
            return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es7.string.pad-start.js":
      /*!********************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es7.string.pad-start.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs7StringPadStartJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/proposal-string-pad-start-end

        var $export = __webpack_require__(
        /*! ./_export */
        "../Grid/node_modules/core-js/modules/_export.js");

        var $pad = __webpack_require__(
        /*! ./_string-pad */
        "../Grid/node_modules/core-js/modules/_string-pad.js");

        var userAgent = __webpack_require__(
        /*! ./_user-agent */
        "../Grid/node_modules/core-js/modules/_user-agent.js"); // https://github.com/zloirock/core-js/issues/280


        var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
        $export($export.P + $export.F * WEBKIT_BUG, 'String', {
          padStart: function padStart(maxLength
          /* , fillString = ' ' */
          ) {
            return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
          }
        });
        /***/
      },

      /***/
      "../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js":
      /*!*************************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/es7.symbol.async-iterator.js ***!
        \*************************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesEs7SymbolAsyncIteratorJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./_wks-define */
        "../Grid/node_modules/core-js/modules/_wks-define.js")('asyncIterator');
        /***/

      },

      /***/
      "../Grid/node_modules/core-js/modules/web.dom.iterable.js":
      /*!****************************************************************!*\
        !*** ../Grid/node_modules/core-js/modules/web.dom.iterable.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesCoreJsModulesWebDomIterableJs(module, exports, __webpack_require__) {
        var $iterators = __webpack_require__(
        /*! ./es6.array.iterator */
        "../Grid/node_modules/core-js/modules/es6.array.iterator.js");

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "../Grid/node_modules/core-js/modules/_object-keys.js");

        var redefine = __webpack_require__(
        /*! ./_redefine */
        "../Grid/node_modules/core-js/modules/_redefine.js");

        var global = __webpack_require__(
        /*! ./_global */
        "../Grid/node_modules/core-js/modules/_global.js");

        var hide = __webpack_require__(
        /*! ./_hide */
        "../Grid/node_modules/core-js/modules/_hide.js");

        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "../Grid/node_modules/core-js/modules/_iterators.js");

        var wks = __webpack_require__(
        /*! ./_wks */
        "../Grid/node_modules/core-js/modules/_wks.js");

        var ITERATOR = wks('iterator');
        var TO_STRING_TAG = wks('toStringTag');
        var ArrayValues = Iterators.Array;
        var DOMIterables = {
          CSSRuleList: true,
          // TODO: Not spec compliant, should be false.
          CSSStyleDeclaration: false,
          CSSValueList: false,
          ClientRectList: false,
          DOMRectList: false,
          DOMStringList: false,
          DOMTokenList: true,
          DataTransferItemList: false,
          FileList: false,
          HTMLAllCollection: false,
          HTMLCollection: false,
          HTMLFormElement: false,
          HTMLSelectElement: false,
          MediaList: true,
          // TODO: Not spec compliant, should be false.
          MimeTypeArray: false,
          NamedNodeMap: false,
          NodeList: true,
          PaintRequestList: false,
          Plugin: false,
          PluginArray: false,
          SVGLengthList: false,
          SVGNumberList: false,
          SVGPathSegList: false,
          SVGPointList: false,
          SVGStringList: false,
          SVGTransformList: false,
          SourceBufferList: false,
          StyleSheetList: true,
          // TODO: Not spec compliant, should be false.
          TextTrackCueList: false,
          TextTrackList: false,
          TouchList: false
        };

        for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
          var NAME = collections[i];
          var explicit = DOMIterables[NAME];
          var Collection = global[NAME];
          var proto = Collection && Collection.prototype;
          var key;

          if (proto) {
            if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
            if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
            Iterators[NAME] = ArrayValues;
            if (explicit) for (key in $iterators) {
              if (!proto[key]) redefine(proto, key, $iterators[key], true);
            }
          }
        }
        /***/

      },

      /***/
      "../Grid/node_modules/regenerator-runtime/runtime.js":
      /*!***********************************************************!*\
        !*** ../Grid/node_modules/regenerator-runtime/runtime.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function GridNode_modulesRegeneratorRuntimeRuntimeJs(module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        var runtime = function (exports) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.

          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.

            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.

          var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.


          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          exports.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          exports.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          }; // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.


          exports.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration.
                  result.value = unwrapped;
                  resolve(result);
                }, function (error) {
                  // If a rejected Promise was yielded, throw the rejection back
                  // into the async generator function so it can be handled there.
                  return invoke("throw", error, resolve, reject);
                });
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            } // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).


            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.

          exports.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                } // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted; // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.

                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          } // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.


          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === "throw") {
                // Note: ["return"] must be used for ES3 parsing compatibility.
                if (delegate.iterator["return"]) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

              context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            } // The delegate iterator is finished, so forget it and continue with
            // the outer generator.


            context.delegate = null;
            return ContinueSentinel;
          } // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.


          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          exports.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse(); // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.

            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              } // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.


              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            } // Return an iterator with no values.


            return {
              next: doneResult
            };
          }

          exports.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0; // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.

              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              } // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.


              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          }; // Regardless of whether this script is executing as a CommonJS module
          // or not, return the runtime object so that we can declare the variable
          // regeneratorRuntime in the outer scope, which allows this module to be
          // injected easily by `bin/regenerator --include-runtime script.js`.

          return exports;
        }( // If this script is executing as a CommonJS module, use module.exports
        // as the regeneratorRuntime namespace. Otherwise create a new empty
        // object. Either way, the resulting object will be used to initialize
        // the regeneratorRuntime variable at the top of this file.
        true ? module.exports : undefined);

        try {
          regeneratorRuntime = runtime;
        } catch (accidentalStrictMode) {
          // This module should not be running in strict mode, so the above
          // assignment should always work unless something is misconfigured. Just
          // in case runtime.js accidentally runs in strict mode, we can escape
          // strict mode using a global Function call. This could conceivably fail
          // if a Content Security Policy forbids using Function, but in that case
          // the proper solution is to fix the accidental strict mode problem. If
          // you've misconfigured your bundler to force strict mode and applied a
          // CSP to forbid Function, and you're not willing to fix either of those
          // problems, please detail your unique predicament in a GitHub issue.
          Function("r", "regeneratorRuntime = r")(runtime);
        }
        /***/

      },

      /***/
      "./lib/Scheduler/column/ResourceInfoColumn.js":
      /*!****************************************************!*\
        !*** ./lib/Scheduler/column/ResourceInfoColumn.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerColumnResourceInfoColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResourceInfoColumn;
        });
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/column/Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Grid/data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/column/ResourceInfoColumn
         */

        /**
         * Displays resource information. Defaults to showing image + name + event count, but what to show is configurable.
         * Be sure to specify {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImagePath} to instruct the
         * column where to look for the images.
         * @externalexample scheduler/ResourceInfoColumn.js
         * @classType resourceInfo
         * @extends Grid/column/Column
         */

        var ResourceInfoColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(ResourceInfoColumn, _Column);

          function ResourceInfoColumn() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, ResourceInfoColumn);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(ResourceInfoColumn).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ResourceInfoColumn, [{
            key: "construct",
            value: function construct() {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(ResourceInfoColumn.prototype), "construct", this).apply(this, arguments);

              if (me.grid.element) {
                me.addErrorListener();
              } else {
                me.grid.on({
                  paint: me.addErrorListener,
                  thisObj: me,
                  once: true
                });
              }
            }
          }, {
            key: "addErrorListener",
            value: function addErrorListener() {
              var missingImgUrl = "".concat(this.imagePath).concat(this.defaultImageName);

              _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
                element: this.grid.element,
                delegate: '.b-resource-image',
                error: function error(event) {
                  return event.target.src = missingImgUrl;
                },
                capture: true
              });
            }
          }, {
            key: "template",
            value: function template(record) {
              var me = this,
                  showImage = me.showImage,
                  showRole = me.showRole,
                  showEventCount = me.showEventCount,
                  roleField = typeof showRole === 'string' ? showRole : 'role',
                  role = record[roleField],
                  count = record.events.length,
                  value = record.get(me.field);
              var imageUrl;

              if (showImage) {
                if (record.imageUrl) {
                  imageUrl = record.imageUrl;
                } else {
                  // record.image supposed to be a file name, located at imagePath
                  var imageName = typeof showImage === 'string' ? showImage : record.image || value && value.toLowerCase() || me.defaultImageName;
                  imageUrl = me.imagePath + imageName; // Image name supposed to have an extension

                  if (!imageName.includes('.')) {
                    // If validNames is specified, check that imageName is valid
                    if (!me.validNames || me.validNames.includes(imageName)) {
                      imageUrl += '.jpg';
                    } // If name is not valid, use generic image
                    else {
                        imageUrl = me.imagePath + me.defaultImageName;
                      }
                  }
                }
              }

              return " \n            <div class=\"b-resource-info\">\n                ".concat(imageUrl ? "<img class=\"b-resource-image\" draggable=\"false\" src=\"".concat(imageUrl, "\">") : '', "\n                <dl>\n                <dt>").concat(value, "</dt>\n                ").concat(showRole ? "<dd class=\"b-resource-role\">".concat(role, "</dd>") : '', "\n                ").concat(showEventCount ? "<dd class=\"b-resource-events\">".concat(me.L('eventCountText', count), "</dd>") : '', "\n                </dl>\n            </div>\n        ");
            }
          }, {
            key: "renderer",
            value: function renderer(_ref) {
              var grid = _ref.grid,
                  record = _ref.record,
                  cellElement = _ref.cellElement;

              if (record.meta.specialRow) {
                return '';
              }

              if (this.autoScaleThreshold && grid.rowHeight < this.autoScaleThreshold) {
                cellElement.style.fontSize = grid.rowHeight / 40 + 'em';
              } else {
                cellElement.style.fontSize = '';
              }

              return this.template(record);
            }
          }, {
            key: "imagePath",
            set: function set(path) {
              this.set('imagePath', path);
            },
            get: function get() {
              return this.get('imagePath') || this.grid.resourceImagePath;
            }
          }, {
            key: "defaultImageName",
            set: function set(name) {
              this.set('defaultImageName', name);
            },
            get: function get() {
              return this.get('defaultImageName') || this.grid.defaultResourceImageName;
            }
          }], [{
            key: "type",
            get: function get() {
              return 'resourceInfo';
            }
          }, {
            key: "fields",
            get: function get() {
              return ['showEventCount', 'showRole', 'showImage', 'imagePath', 'validNames', 'defaultImageName', 'autoScaleThreshold'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                /**
                 * Show image. Looks for image name in fields on the resource in the following order: 'imageUrl', 'image', 'name'.
                 * Set `showImage` to a field name to use a custom field. Set `imagePath` to specify where to load
                 * images from. If no extension found, defaults to .jpg.
                 * @config {Boolean}
                 * @default
                 */
                showImage: true,

                /**
                 * Show number of events assigned to the resource below the name.
                 * @config {Boolean}
                 * @default
                 */
                showEventCount: true,

                /**
                 * Show resource role below the name. Specify `true` to display data from the `role` field, or specify a field
                 * name to read this value from.
                 * @config {Boolean|String}
                 * @default
                 */
                showRole: false,

                /**
                 * Path to load images from. Defaults to using the value of {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImagePath}
                 * @config {String}
                 * @deprecated 2.2
                 */
                imagePath: null,

                /**
                 * Valid image names. Set to `null` to allow all names.
                 * @config {String[]}
                 * @default
                 */
                validNames: ['amit', 'angelo', 'arcady', 'arnold', 'celia', 'chang', 'dan', 'dave', 'emilia', 'george', 'gloria', 'henrik', 'hitomi', 'jong', 'kate', 'lee', 'linda', 'lisa', 'lola', 'macy', 'madison', 'malik', 'mark', 'maxim', 'mike', 'rob', 'steve'],

                /**
                 * Generic user image, used when an invalid name is specified
                 * @config {String}
                 * @deprecated 2.2
                 */
                defaultImageName: null,

                /**
                 * Specify 0 to prevent the column from adapting its content according to the used row height, or specify a
                 * a threshold (row height) at which scaling should start.
                 * @config {Number}
                 * @default
                 */
                autoScaleThreshold: 40,
                field: 'name',
                htmlEncode: false,
                width: 140,
                autoSyncHtml: true
              };
            }
          }]);

          return ResourceInfoColumn;
        }(_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerColumnType(ResourceInfoColumn);

        ResourceInfoColumn._$name = 'ResourceInfoColumn';
        /***/
      },

      /***/
      "./lib/Scheduler/column/TimeAxisColumn.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/column/TimeAxisColumn.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerColumnTimeAxisColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeAxisColumn;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "./node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/assertThisInitialized */
        "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Grid/column/Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Grid/data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../view/HorizontalTimeAxis.js */
        "./lib/Scheduler/view/HorizontalTimeAxis.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../view/ResourceHeader.js */
        "./lib/Scheduler/view/ResourceHeader.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/column/TimeAxisColumn
         */

        /**
         * A column containing the timeline "viewport", in which events, dependencies etc are drawn. Normally you do not need
         * to interact with or create this column, it is handled by Scheduler/Gantt.
         *
         * @extends Grid/column/Column
         */

        var TimeAxisColumn =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimeAxisColumn, _Events); // region Events

          /**
           * Fires after a click on a time axis cell
           * @event timeAxisHeaderClick
           * @param {Scheduler.column.TimeAxisColumn} column The column object
           * @param {Date} startDate The start date of the header cell
           * @param {Date} endDate The start date of the header cell
           * @param {Event} event The event object
           */

          /**
           * Fires after a double click on a time axis cell
           * @event timeAxisHeaderDblClick
           * @param {Scheduler.column.TimeAxisColumn} column The column object
           * @param {Date} startDate The start date of the header cell
           * @param {Date} endDate The end date of the header cell
           * @param {Event} event The event object
           */

          /**
           * Fires after a right click on a time axis cell
           * @event timeAxisHeaderContextMenu
           * @param {Scheduler.column.TimeAxisColumn} column The column object
           * @param {Date} startDate The start date of the header cell
           * @param {Date} endDate The start date of the header cell
           * @param {Event} event The event object
           */
          //endregion
          //region Init


          function TimeAxisColumn(data, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TimeAxisColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TimeAxisColumn).apply(this, arguments));

            var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this));

            me.initialRender = true;
            me.thisObj = me;
            me.timeAxisViewModel = me.timeline.timeAxisViewModel; // A bit hacky, because mode is a field and not a config
            // eslint-disable-next-line no-self-assign

            me.mode = me.mode;
            return _this;
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TimeAxisColumn, [{
            key: "onViewModelUpdate",
            //endregion
            //region Events
            value: function onViewModelUpdate(_ref) {
              var viewModel = _ref.source;
              var me = this;

              if (me.mode === 'horizontal') {
                // render the time axis view into the column header element
                me.refreshHeader(true);
                me.width = viewModel.totalSize;

                if (!me.isPainting) {
                  me.timeline.refresh();
                }
              } else if (me.mode === 'vertical') {
                if (!me.isPainting) {
                  // Refresh to rerender cells, in the process updating the vertical timeaxis to reflect view model changes
                  me.timeline.refreshRows();
                }
              }
            } // Called on paint. SubGrid has its width so this is the earliest time to configure the TimeAxisViewModel with
            // correct width

          }, {
            key: "onTimelinePaint",
            value: function onTimelinePaint() {
              var me = this;

              if (!me.subGrid.insertRowsBefore) {
                return;
              }

              me.isPainting = true;
              me.timeAxisViewModel.on({
                update: me.onViewModelUpdate,
                thisObj: me
              }); // Upon paint we need to pass the forceUpdate flag in case we are sharing the TimAxisViewModel
              // with another Timeline which will already have done this.

              if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isIE11) {
                // subGrid in IE11 doesn't have height at this point, but container element does so we take it from there
                // TODO: make flex element inherit height from parent (min-height: 100% doesn't work)
                me.timeAxisViewModel.update(me.mode === 'vertical' ? me.subGrid.element.parentElement.offsetHeight : me.subGrid.width, false, true);
              } else {
                me.timeAxisViewModel.update(me.mode === 'vertical' ? me.subGrid.height : me.subGrid.width, false, true);
              }

              me.subGridElement.classList.add('b-timeline-subgrid');

              _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].on({
                element: me.element,
                thisObj: me,
                click: 'onContainerElementClick',
                dblclick: 'onContainerElementClick',
                contextmenu: 'onContainerElementClick'
              });

              if (me.mode === 'vertical') {
                me.refreshHeader();
              }

              me.isPainting = false;
            } //endregion
            //region Rendering

            /**
             * Refreshes the columns header contents (which is either a HorizontalTimeAxis or a ResourceHeader). Useful if you
             * have rendered some extra meta data that depends on external data such as the EventStore or ResourceStore.
             */

          }, {
            key: "refreshHeader",
            value: function refreshHeader(internal) {
              var me = this,
                  element = me.element;

              if (element) {
                if (me.mode === 'horizontal') {
                  // Force timeAxisViewModel to regenerate its column config, which calls header renderers etc.
                  !internal && me.timeAxisViewModel.update(null, true);
                  me.timeAxisView.renderTo(element);
                } else if (me.mode === 'vertical') {
                  if (!me.resourceColumns.currentElement) {
                    // Do not need the normal header markup
                    element.innerHTML = '';
                    me.resourceColumns.render(element);
                  } // Vertical's resourceColumns is redrawn with the events, no need here

                }
              }
            }
          }, {
            key: "renderer",
            value: function renderer(renderData) {
              return this.timeline.currentOrientation.renderer(renderData);
            } //endregion
            // region DOM events

          }, {
            key: "onContainerElementClick",
            value: function onContainerElementClick(event) {
              var target = event.target;

              if (target.matches('.b-sch-header-timeaxis-cell')) {
                var index = Array.from(target.parentElement.children).indexOf(target),
                    position = target.parentElement.getAttribute('headerPosition'),
                    headerConfig = this.timeAxisViewModel.columnConfig[position][index]; // Skip same events with Grid context menu triggerEvent

                var contextMenu = this.grid.features.contextMenu;

                if (!contextMenu || event.type !== contextMenu.triggerEvent) {
                  this.trigger('timeAxisHeader' + _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].capitalizeFirstLetter(event.type), {
                    startDate: headerConfig.start,
                    endDate: headerConfig.end,
                    event: event
                  });
                }
              }
            } // endregion

          }, {
            key: "mode",
            set: function set(mode) {
              var me = this,
                  timeline = me.timeline;
              me.set('mode', mode); // In horizontal mode this column has a time axis header on top, with timeline ticks

              if (mode === 'horizontal') {
                me.timeAxisView = new _view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_13__["default"]({
                  model: me.timeAxisViewModel,
                  timeAxis: timeline.timeAxis,
                  compactCellWidthThreshold: me.compactCellWidthThreshold
                });
              } // In vertical mode, it instead displays resources at top
              else if (mode === 'vertical') {
                  // TODO: Most other vertical stuff is handled in VerticalEventMapper, move there?
                  me.resourceColumns = new _view_ResourceHeader_js__WEBPACK_IMPORTED_MODULE_15__["default"](Object.assign({
                    column: me,
                    resourceStore: timeline.resourceStore,
                    imagePath: timeline.resourceImagePath,
                    defaultImageName: timeline.defaultResourceImageName
                  }, timeline.resourceColumns || {}));
                }
            },
            get: function get() {
              return this.get('mode');
            } // TODO: define all configs as fields and set below to false...

            /**
             * Get the SubGrid to which this column belongs
             * @property {Grid.view.SubGrid}
             * @private
             */

          }, {
            key: "subGrid",
            set: function set(subGrid) {
              var me = this;
              me._subGrid = subGrid;
              subGrid.on({
                paint: me.onTimelinePaint,
                thisObj: me,
                once: true
              });
            },
            get: function get() {
              return this._subGrid;
            }
            /**
             * Get the element for the SubGrid to which this column belongs
             * @property {HTMLElement}
             * @readonly
             * @private
             */

          }, {
            key: "subGridElement",
            get: function get() {
              return this.subGrid.element;
            }
          }], [{
            key: "autoExposeFields",
            get: function get() {
              return true;
            } // endregion
            //region Config

          }, {
            key: "fields",
            get: function get() {
              return ['mode'];
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                /**
                 * Set to false to prevent this column header from being dragged.
                 * @config {Boolean} draggable
                 * @category Interaction
                 * @default false
                 */
                draggable: false,

                /**
                 * Set to false to prevent grouping by this column.
                 * @config {Boolean} groupable
                 * @category Interaction
                 * @default false
                 */
                groupable: false,

                /**
                 * Allow column visibility to be toggled through UI.
                 * @config {Boolean} hideable
                 * @default false
                 * @category Interaction
                 */
                hideable: false,

                /**
                 * Show column picker for the column.
                 * @config {Boolean} showColumnPicker
                 * @default false
                 * @category Menu
                 */
                showColumnPicker: false,

                /**
                 * Allow filtering data in the column (if Filter feature is enabled)
                 * @config {Boolean} filterable
                 * @default false
                 * @category Interaction
                 */
                filterable: false,

                /**
                 * Allow sorting of data in the column
                 * @config {Boolean} sortable
                 * @category Interaction
                 * @default false
                 */
                sortable: false,

                /**
                 * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
                 * @config {Boolean} resizable
                 * @default false
                 * @category Interaction
                 */
                resizable: false,

                /**
                 * Allow searching in the column (respected by QuickFind and Search features)
                 * @config {Boolean} searchable
                 * @default false
                 * @category Interaction
                 */
                searchable: false,

                /**
                 * Specifies if this column should be editable, and define which editor to use for editing cells in the column (if CellEdit feature is enabled)
                 * @config {String} editor
                 * @default false
                 * @category Interaction
                 */
                editor: false,

                /**
                 * false to prevent showing a context menu on the cell elements in this column
                 * @config {Boolean} enableCellContextMenu
                 * @default false
                 * @category Menu
                 */
                enableCellContextMenu: false,

                /**
                 * Renderer function for cell tooltips header (used with CellTooltip feature). Specify false to prevent
                 * tooltip for that column.
                 * @param {HTMLElement} cellElement Cell element
                 * @param {Common.data.Model} record Record for cell row
                 * @param {Grid.column.Column} column Cell column
                 * @param {CellTooltip} cellTooltip Feature instance, used to set tooltip content async
                 * @param {MouseEvent} event The event that triggered the tooltip
                 * @config {Function} tooltipRenderer
                 * @category Rendering
                 * @default false
                 */
                tooltipRenderer: false,

                /**
                 * CSS class added to the header of this column
                 * @config {String} cls
                 * @category Rendering
                 * @default 'b-sch-timeaxiscolumn'
                 */
                cls: 'b-sch-timeaxiscolumn',
                // needs to have width specified, flex-basis messes measurements up
                needWidth: true,
                mode: null,
                region: 'normal'
              };
            }
          }, {
            key: "type",
            get: function get() {
              return 'timeAxis';
            }
          }]);

          return TimeAxisColumn;
        }(Object(_Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_12__["default"])(_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_10__["default"]));

        _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerColumnType(TimeAxisColumn);

        TimeAxisColumn._$name = 'TimeAxisColumn';
        /***/
      },

      /***/
      "./lib/Scheduler/column/VerticalTimeAxisColumn.js":
      /*!********************************************************!*\
        !*** ./lib/Scheduler/column/VerticalTimeAxisColumn.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerColumnVerticalTimeAxisColumnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return VerticalTimeAxisColumn;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Grid/column/Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony import */


        var _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Grid/data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony import */


        var _view_VerticalTimeAxis_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../view/VerticalTimeAxis.js */
        "./lib/Scheduler/view/VerticalTimeAxis.js");

        var productName = 'scheduler';

        var VerticalTimeAxisColumn =
        /*#__PURE__*/
        function (_Column) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(VerticalTimeAxisColumn, _Column);

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(VerticalTimeAxisColumn, null, [{
            key: "type",
            get: function get() {
              return 'verticalTimeAxis';
            }
          }, {
            key: "defaults",
            get: function get() {
              return {
                /**
                 * Set to false to prevent this column header from being dragged.
                 * @config {Boolean} draggable
                 * @category Interaction
                 * @default false
                 * @hide
                 */
                draggable: false,

                /**
                 * Set to false to prevent grouping by this column.
                 * @config {Boolean} groupable
                 * @category Interaction
                 * @default false
                 * @hide
                 */
                groupable: false,

                /**
                 * Allow column visibility to be toggled through UI.
                 * @config {Boolean} hideable
                 * @default false
                 * @category Interaction
                 * @hide
                 */
                hideable: false,

                /**
                 * Show column picker for the column.
                 * @config {Boolean} showColumnPicker
                 * @default false
                 * @category Menu
                 * @hide
                 */
                showColumnPicker: false,

                /**
                 * Allow filtering data in the column (if Filter feature is enabled)
                 * @config {Boolean} filterable
                 * @default false
                 * @category Interaction
                 * @hide
                 */
                filterable: false,

                /**
                 * Allow sorting of data in the column
                 * @config {Boolean} sortable
                 * @category Interaction
                 * @default false
                 * @hide
                 */
                sortable: false,
                // /**
                //  * Set to `false` to prevent the column from being drag-resized when the ColumnResize plugin is enabled.
                //  * @config {Boolean} resizable
                //  * @default false
                //  * @category Interaction
                //  * @hide
                //  */
                // resizable : false,

                /**
                 * Allow searching in the column (respected by QuickFind and Search features)
                 * @config {Boolean} searchable
                 * @default false
                 * @category Interaction
                 * @hide
                 */
                searchable: false,

                /**
                 * Specifies if this column should be editable, and define which editor to use for editing cells in the column (if CellEdit feature is enabled)
                 * @config {String} editor
                 * @default false
                 * @category Interaction
                 * @hide
                 */
                editor: false,

                /**
                 * false to prevent showing a context menu on the cell elements in this column
                 * @config {Boolean} enableCellContextMenu
                 * @default false
                 * @category Menu
                 * @hide
                 */
                enableCellContextMenu: false,

                /**
                 * Renderer function for cell tooltips header (used with CellTooltip feature). Specify false to prevent
                 * tooltip for that column.
                 * @param {HTMLElement} cellElement Cell element
                 * @param {Common.data.Model} record Record for cell row
                 * @param {Grid.column.Column} column Cell column
                 * @param {CellTooltip} cellTooltip Feature instance, used to set tooltip content async
                 * @param {MouseEvent} event The event that triggered the tooltip
                 * @config {Function} tooltipRenderer
                 * @category Rendering
                 * @default false
                 * @hide
                 */
                tooltipRenderer: false,
                cellCls: 'b-verticaltimeaxiscolumn'
              };
            }
          }]);

          function VerticalTimeAxisColumn(data, store) {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, VerticalTimeAxisColumn);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(VerticalTimeAxisColumn).apply(this, arguments));
            _this.timeAxisViewModel = data.timeline.timeAxisViewModel;
            return _this;
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(VerticalTimeAxisColumn, [{
            key: "renderer",
            value: function renderer(_ref) {
              var cellElement = _ref.cellElement,
                  size = _ref.size;
              var me = this;

              if (!me.view) {
                // I feel a bit bad about assigning this here, but it works...
                me.grid.timeView = me.view = new _view_VerticalTimeAxis_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                  timeAxisViewModel: me.timeAxisViewModel
                });
              }

              me.view.render(cellElement);
              size.height = me.view.height;
            }
          }]);

          return VerticalTimeAxisColumn;
        }(_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        _Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerColumnType(VerticalTimeAxisColumn);

        VerticalTimeAxisColumn._$name = 'VerticalTimeAxisColumn';
        /***/
      },

      /***/
      "./lib/Scheduler/crud/AbstractCrudManager.js":
      /*!***************************************************!*\
        !*** ./lib/Scheduler/crud/AbstractCrudManager.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerCrudAbstractCrudManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return AbstractCrudManager;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./AbstractCrudManagerMixin.js */
        "./lib/Scheduler/crud/AbstractCrudManagerMixin.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/crud/AbstractCrudManager
         */

        /**
         * This is an abstract class serving as the base for the {@link Scheduler.data.CrudManager} class.
         * It implements basic mechanisms to organize batch communication with a server.
         * Yet it does not contain methods related to _data transfer_ nor _encoding_.
         * These methods are to be provided in sub-classes by consuming the appropriate mixins.
         *
         * For example, this is how the class can be used to implement an JSON encoding system:
         *
         * ```javascript
         * // let's make new CrudManager using AJAX as a transport system and JSON for encoding
         * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {
         *
         * }
         * ```
         *
         * ## Data transfer and encoding methods
         * These are methods that must be provided by subclasses of this class:
         *
         * - [#sendRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-sendRequest)
         * - [#cancelRequest](#Scheduler/crud/AbstractCrudManagerMixin#function-cancelRequest)
         * - [#encode](#Scheduler/crud/AbstractCrudManagerMixin#function-encode)
         * - [#decode](#Scheduler/crud/AbstractCrudManagerMixin#function-decode)
         *
         * @extends Common/Base
         * @mixes Common/mixin/Events
         * @mixes Scheduler/crud/AbstractCrudManagerMixin
         * @abstract
         */

        var AbstractCrudManager =
        /*#__PURE__*/
        function (_AbstractCrudManagerM) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(AbstractCrudManager, _AbstractCrudManagerM);

          function AbstractCrudManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, AbstractCrudManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AbstractCrudManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(AbstractCrudManager, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

              if (config.stores) {
                config.crudStores = config.stores;
                delete config.stores;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AbstractCrudManager.prototype), "construct", this).call(this, config);
            } //endregion
            //region Store collection (add, remove, get & iterate)

          }, {
            key: "commit",

            /**
             * Commits all records changes of all the registered stores.
             */
            value: function commit() {
              this.commitCrudStores();
            }
            /**
             * Rejects all records changes on all stores and re-insert any records that were removed locally. Any phantom records will be removed.
             */

          }, {
            key: "reject",
            value: function reject() {
              this.rejectCrudStores();
            }
            /**
             * Adds a store to the collection.
             *
             *```javascript
             * // append stores to the end of collection
             * crudManager.addStore([
             *     store1,
             *     // storeId
             *     'bar',
             *     // store descriptor
             *     {
             *         storeId : 'foo',
             *         store   : store3
             *     },
             *     {
             *         storeId         : 'bar',
             *         store           : store4,
             *         // to write all fields of modified records
             *         writeAllFields  : true
             *     }
             * ]);
             *```
             *
             * **Note:** Order in which stores are kept in the collection is very essential sometimes.
             * Exactly in this order the loaded data will be put into each store.
             * @param {Common.data.Store|String|Object|Common.data.Store[]|String[]|Object[]} store
             * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
             * The _store descriptor_ is an object having following properties:
             * @param {String} store.storeId The store identifier that will be used as a key in requests.
             * @param {Common.data.Store} store.store The store itself.
             * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
             * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
             * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
             * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
             * If not specified then store(s) will be appended to the end of collection.
             * Otherwise it will be just a position in stores collection.
             *
             * ```javascript
             * // insert stores store4, store5 to the start of collection
             * crudManager.addStore([ store4, store5 ], 0);
             * ```
             *
             * @param {String|Common.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link Scheduler/crud/AbstractCrudManagerMixin#function-getStoreDescriptor} call).
             *
             * ```javascript
             * // insert store6 just before a store having storeId equal to 'foo'
             * crudManager.addStore(store6, 0, 'foo');
             *
             * // insert store7 just after store3 store
             * crudManager.addStore(store7, 1, store3);
             * ```
             */

          }, {
            key: "addStore",
            value: function addStore() {
              return this.addCrudStore.apply(this, arguments);
            }
          }, {
            key: "removeStore",
            value: function removeStore() {
              return this.removeCrudStore.apply(this, arguments);
            }
          }, {
            key: "getStore",
            value: function getStore() {
              return this.getCrudStore.apply(this, arguments);
            }
          }, {
            key: "hasChanges",
            value: function hasChanges() {
              return this.crudStoreHasChanges.apply(this, arguments);
            }
          }, {
            key: "loadData",
            value: function loadData() {
              return this.loadCrudManagerData.apply(this, arguments);
            }
          }, {
            key: "revision",
            //region Default config

            /**
             * The server revision stamp.
             * The _revision stamp_ is a number which should be incremented after each server-side change.
             * This property reflects the current version of the data retrieved from the server and gets updated after each {@link Scheduler/crud/AbstractCrudManagerMixin#function-load} and {@link Scheduler/crud/AbstractCrudManagerMixin#function-sync} call.
             * @property {Number} revision
             * @readonly
             */
            get: function get() {
              return this.crudRevision;
            },
            set: function set(value) {
              this.crudRevision = value;
            }
          }, {
            key: "stores",
            set: function set(stores) {
              // debugger
              if (stores !== this.crudStores) {
                this.crudStores = stores;
              }
            }
            /**
             * A list of registered stores whose server communication will be collected into a single batch.
             * Each store is represented by a _store descriptor_, an object having following structure:
             * @member {Object[]} stores
             * @property {String} stores.storeId Unique store identifier.
             * @property {Common.data.Store} stores.store Store itself.
             * @property {String} [stores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
             * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
             */
            ,
            get: function get() {
              return this.crudStores;
            } //endregion

            /**
             * Returns true if the crud manager is currently loading data
             * @property {Boolean}
             * @readonly
             * @category CRUD
             */

          }, {
            key: "isLoading",
            get: function get() {
              return this.isCrudManagerLoading;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              // debugger
              return Object.assign({}, this.crudManagerDefaultConfig, {
                overrideCrudStoreLoad: true,

                /**
                 * Sets the list of stores controlled by the CRUD manager.
                 * Store can be provided by itself, its storeId or an object having the following structure:
                 * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
                 * @property {Common.data.Store} stores.store The store itself.
                 * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
                 * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
                 * @config {Common.data.Store[]|String[]|Object[]}
                 */
                stores: null
                /**
                 * Encodes request to the server.
                 * @function encode
                 * @param {Object} request The request to encode.
                 * @returns {String} The encoded request.
                 * @abstract
                 */

                /**
                 * Decodes response from the server.
                 * @function decode
                 * @param {String} response The response to decode.
                 * @returns {Object} The decoded response.
                 * @abstract
                 */

              });
            }
          }]);

          return AbstractCrudManager;
        }(Object(_AbstractCrudManagerMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(Object(_Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_7__["default"])(_Common_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"])));

        AbstractCrudManager._$name = 'AbstractCrudManager';
        /***/
      },

      /***/
      "./lib/Scheduler/crud/AbstractCrudManagerMixin.js":
      /*!********************************************************!*\
        !*** ./lib/Scheduler/crud/AbstractCrudManagerMixin.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerCrudAbstractCrudManagerMixinJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "./node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "./node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/asyncToGenerator */
        "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "./node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "./node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23__);
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _Common_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ../../Common/helper/ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/crud/AbstractCrudManagerMixin
         */

        var storeSortFn = function storeSortFn(lhs, rhs, sortProperty) {
          // TODO: get rid of these StoreDescriptors. Just use Stores.
          if (lhs.store) {
            lhs = lhs.store;
          }

          if (rhs.store) {
            rhs = rhs.store;
          }

          lhs = lhs[sortProperty] || 0;
          rhs = rhs[sortProperty] || 0;
          return lhs < rhs ? -1 : lhs > rhs ? 1 : 0;
        },
            // Sorter function to keep stores in loadPriority order
        storeLoadSortFn = function storeLoadSortFn(lhs, rhs) {
          return storeSortFn(lhs, rhs, 'loadPriority');
        },
            // Sorter function to keep stores in syncPriority order
        storeSyncSortFn = function storeSyncSortFn(lhs, rhs) {
          return storeSortFn(lhs, rhs, 'syncPriority');
        },
            nullFn = function nullFn() {};
        /**
         * An abstract mixin that supplies most of the CrudManager functionality.
         * It implements basic mechanisms of collecting stores to organize batch communication with a server.
         * Yet it does not contain methods related to _data transfer_ nor _encoding_.
         * These methods are to be provided in sub-classes.
         * Out of the box there are mixins implementing {@link Scheduler.crud.transport.AjaxTransport support of AJAX for data transferring}
         * and {@link Scheduler.crud.encoder.JsonEncoder JSON for data encoding system}.
         * For example this is how we make a model that will implement CrudManager protocol and use AJAX/JSON to pass the dada to the server:
         *
         * ```javascript
         * class SystemSettings extends JsonEncode(AjaxTransport(AbstractCrudManagerMixin(Model))) {
         *     ...
         * }
         * ```
         *
         * ## Data transfer and encoding methods
         *
         * These are methods that must be provided by subclasses of this class:
         *
         * - {@link #function-sendRequest sendRequest}
         * - {@link #function-cancelRequest cancelRequest}
         * - {@link #function-encode encode}
         * - {@link #function-decode decode}
         *
         * @mixin
         * @abstract
         */

        /* harmony default export */


        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_Target) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_23___default()(AbstractCrudManagerMixin, _Target);

              function AbstractCrudManagerMixin() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_18___default()(this, AbstractCrudManagerMixin);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_20___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(AbstractCrudManagerMixin).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_19___default()(AbstractCrudManagerMixin, [{
                key: "construct",
                //endregion
                //region Init
                value: function construct() {
                  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  this._requestId = 0;
                  this.activeRequests = {};
                  this.crudStoresIndex = {};
                  this._crudManagerConfig = config;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(AbstractCrudManagerMixin.prototype), "construct", this).call(this, config);
                }
              }, {
                key: "applyCrudManagerMixinConfig",
                value: function applyCrudManagerMixinConfig(config) {
                  var cfg = this.splitCrudManagerConfig(config);

                  if (cfg.crudStores) {
                    this.crudStores = cfg.crudStores;
                    delete cfg.crudStores;
                  }

                  Object.assign(this, cfg);
                }
              }, {
                key: "afterConfigure",
                value: function afterConfigure() {
                  if (!this.initialConfig) {
                    this.applyCrudManagerMixinConfig(this._crudManagerConfig);
                  }
                }
              }, {
                key: "splitCrudManagerConfig",
                value: function splitCrudManagerConfig(config) {
                  // debugger
                  var result = Object.assign({}, this.constructor.crudManagerDefaultConfig); // let result = Object.assign({}, this.constructor.defaultConfig);

                  for (var cfg in config) {
                    if (cfg in result) {
                      result[cfg] = config[cfg];
                      delete config[cfg];
                    }
                  }

                  return result;
                }
              }, {
                key: "afterConstruct",
                value: function afterConstruct() {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_22___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_21___default()(AbstractCrudManagerMixin.prototype), "afterConstruct", this).call(this);

                  if (this.autoLoad) {
                    this.load().catch(function (e) {});
                  }
                } //endregion
                //region Store descriptors & index

                /**
                 * Returns a registered store descriptor.
                 * @param {String|Common.data.Store} storeId The store identifier or registered store instance.
                 * @returns {Object} The descriptor of the store.
                 */

              }, {
                key: "getStoreDescriptor",
                value: function getStoreDescriptor(storeId) {
                  if (!storeId) return null;
                  if (storeId instanceof _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_24__["default"]) return this.crudStores.find(function (storeDesc) {
                    return storeDesc.store === storeId;
                  });
                  if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15___default()(storeId) === 'object') return this.crudStoresIndex[storeId.storeId];
                  return this.crudStoresIndex[storeId] || this.getStoreDescriptor(_Common_data_Store_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStore(storeId));
                }
              }, {
                key: "fillStoreDescriptor",
                value: function fillStoreDescriptor(descriptor) {
                  var store = descriptor.store,
                      storeIdProperty = store.storeIdProperty || this.storeIdProperty,
                      model = store.modelClass && store.modelClass.prototype;
                  !descriptor.storeId && (descriptor.storeId = store[storeIdProperty]);
                  !descriptor.idField && (descriptor.idField = model.idField);
                  !descriptor.phantomIdField && (descriptor.phantomIdField = model && model.phantomIdField);
                  !('writeAllFields' in descriptor) && (descriptor.writeAllFields = store.writeAllFields); // TODO: PORT support for writeAllFields

                  return descriptor;
                }
              }, {
                key: "updateCrudStoreIndex",
                value: function updateCrudStoreIndex() {
                  var crudStoresIndex = this.crudStoresIndex = {};
                  this.crudStores.forEach(function (store) {
                    return store.storeId && (crudStoresIndex[store.storeId] = store);
                  });
                } //endregion
                //region Store collection (add, remove, get & iterate)

                /**
                 * Returns a registered store.
                 * @param {String} storeId Store identifier.
                 * @returns {Common.data.Store} Found store instance.
                 */

              }, {
                key: "getCrudStore",
                value: function getCrudStore(storeId) {
                  var storeInfo = this.getStoreDescriptor(storeId);
                  return storeInfo && storeInfo.store;
                }
              }, {
                key: "forEachCrudStore",
                value: function forEachCrudStore(fn) {
                  var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
                  if (!fn) return;
                  this.crudStores.every(function (store) {
                    return fn.call(thisObj, store.store, store.storeId, store) !== false;
                  });
                }
              }, {
                key: "addCrudStore",

                /**
                 * Adds a store to the collection.
                 *
                 *```javascript
                 * // append stores to the end of collection
                 * crudManager.addCrudStore([
                 *     store1,
                 *     // storeId
                 *     'bar',
                 *     // store descriptor
                 *     {
                 *         storeId : 'foo',
                 *         store   : store3
                 *     },
                 *     {
                 *         storeId         : 'bar',
                 *         store           : store4,
                 *         // to write all fields of modified records
                 *         writeAllFields  : true
                 *     }
                 * ]);
                 *```
                 *
                 * **Note:** Order in which stores are kept in the collection is very essential sometimes.
                 * Exactly in this order the loaded data will be put into each store.
                 * @param {Common.data.Store|String|Object|Common.data.Store[]|String[]|Object[]} store
                 * A store or list of stores. Each store might be specified by its instance, `storeId` or _descriptor_.
                 * The _store descriptor_ is an object having following properties:
                 * @param {String} store.storeId The store identifier that will be used as a key in requests.
                 * @param {Common.data.Store} store.store The store itself.
                 * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
                 * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
                 * @param {Boolean} [store.writeAllFields] Set to true to write all fields from modified records
                 * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
                 * If not specified then store(s) will be appended to the end of collection.
                 * Otherwise it will be just a position in stores collection.
                 *
                 * ```javascript
                 * // insert stores store4, store5 to the start of collection
                 * crudManager.addCrudStore([ store4, store5 ], 0);
                 * ```
                 *
                 * @param {String|Common.data.Store|Object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or descriptor (the result of {@link #function-getStoreDescriptor} call).
                 *
                 * ```javascript
                 * // insert store6 just before a store having storeId equal to 'foo'
                 * crudManager.addCrudStore(store6, 0, 'foo');
                 *
                 * // insert store7 just after store3 store
                 * crudManager.addCrudStore(store7, 1, store3);
                 * ```
                 */
                value: function addCrudStore(store, position, fromStore) {
                  if (!store) return;
                  if (!Array.isArray(store)) store = [store];
                  if (!store.length) return;
                  var me = this,
                      data = []; // loop over list of stores to be added

                  store.forEach(function (storeInfo) {
                    // if store instance provided
                    if (storeInfo instanceof _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_24__["default"]) {
                      storeInfo = {
                        store: storeInfo
                      };
                    } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15___default()(storeInfo) === 'object') {
                      // normalize sub-stores (if any)
                      if (storeInfo.stores) {
                        if (!Array.isArray(storeInfo.stores)) storeInfo.stores = [storeInfo.stores];
                        storeInfo.stores.forEach(function (subStore, j) {
                          var subStoreInfo = subStore;

                          if (typeof subStore === 'string') {
                            subStoreInfo = {
                              storeId: subStore
                            };
                          } // keep reference to the "master" store descriptor


                          subStoreInfo.masterStoreInfo = storeInfo;
                          storeInfo.stores[j] = subStoreInfo;
                        });
                      } // if it's a store identifier

                    } else {
                      storeInfo = {
                        store: _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_24__["default"].getStore(storeInfo)
                      };
                    }

                    data.push(me.fillStoreDescriptor(storeInfo)); // if the store has "setCrudManager" hook - use it

                    if (storeInfo.store.setCrudManager) {
                      storeInfo.store.setCrudManager(me); // otherwise decorate the store w/ "crudManager" property
                    } else {
                      storeInfo.store.crudManager = me;
                    } // Prevent AjaxStores from performing their own CRUD operations


                    if (me.overrideCrudStoreLoad && storeInfo.store.load) {
                      storeInfo.store.load = storeInfo.store.commit = function () {};
                    } // listen to store changes


                    me.bindCrudStoreListeners(storeInfo.store);
                  }); // if no position specified then append stores to the end

                  if (typeof position === 'undefined') {
                    me.crudStores.push.apply(me.crudStores, data); // if position specified
                  } else {
                    var _me$crudStores;

                    var pos = position; // if specified the store relative to which we should insert new one(-s)

                    if (fromStore) {
                      if (fromStore instanceof _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_24__["default"] || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15___default()(fromStore) !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

                      pos += me.crudStores.indexOf(fromStore);
                    } // insert new store(-s)
                    //me.crudStores.splice.apply(me.crudStores, [].concat([pos, 0], data));


                    (_me$crudStores = me.crudStores).splice.apply(_me$crudStores, [pos, 0].concat(data));
                  }

                  me.updateCrudStoreIndex();
                } // Adds configured scheduler stores to the store collection ensuring correct order
                // unless they're already registered.

              }, {
                key: "addPrioritizedStore",
                value: function addPrioritizedStore(store) {
                  var me = this;

                  if (!me.hasCrudStore(store)) {
                    this.addCrudStore(store, _Common_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].findInsertionIndex(store, me.crudStores, storeLoadSortFn));
                  }

                  if (!me.hasApplySequenceStore(store)) {
                    this.addStoreToApplySequence(store, _Common_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].findInsertionIndex(store, me.syncApplySequence, storeSyncSortFn));
                  }
                }
              }, {
                key: "hasCrudStore",
                value: function hasCrudStore(store) {
                  return this.crudStores.some(function (s) {
                    return s === store || s.store === store || s.storeId === store;
                  });
                }
                /**
                 * Removes a store from collection. If the store was registered in alternative sync sequence list
                 * it will be removed from there as well.
                 *
                 * ```javascript
                 *    // remove store having storeId equal to "foo"
                 *    crudManager.removeCrudStore("foo");
                 *
                 *    // remove store3
                 *    crudManager.removeCrudStore(store3);
                 * ```
                 *
                 * @param {Object|String|Common.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
                 */

              }, {
                key: "removeCrudStore",
                value: function removeCrudStore(store) {
                  var me = this,
                      stores = me.crudStores;

                  for (var i = 0, l = stores.length; i < l; i++) {
                    var s = stores[i];

                    if (s === store || s.store === store || s.storeId === store) {
                      // unbind store listeners
                      me.unbindCrudStoreListeners(s.store);
                      delete me.crudStoresIndex[s.storeId];
                      stores.splice(i, 1);

                      if (me.syncApplySequence) {
                        me.removeStoreFromApplySequence(store);
                      }

                      break;
                    }
                  }
                } //endregion
                //region Store listeners

              }, {
                key: "bindCrudStoreListeners",
                value: function bindCrudStoreListeners(store, un) {
                  var me = this,
                      listeners = {
                    update: me.onCrudStoreChange,
                    //me.onStoreUpdate,
                    removeall: me.onCrudStoreChange,
                    detachable: true,
                    thisObj: me
                  }; // TODO: destroying a store should remove listeners from it (should be default behaviour in Events)

                  Object.assign(listeners, {
                    add: me.onCrudStoreChange,
                    remove: me.onCrudStoreChange
                  });
                  store.crudDetatcher = store.on(listeners);
                }
              }, {
                key: "unbindCrudStoreListeners",
                value: function unbindCrudStoreListeners(store) {
                  store.crudDetatcher && store.crudDetatcher();
                } //endregion
                //region Apply sequence

                /**
                 * Adds a store to the alternative sync responses apply sequence.
                 * By default the order in which sync responses are applied to the stores is the same as they registered in.
                 * But this order can be changes either on construction step using {@link #config-syncApplySequence} option
                 * or but calling this method.
                 *
                 * **Please note**, that if the sequence was not initialized before this method call then
                 * you will have to do it yourself like this for example:
                 *
                 *    ```javascript
                 *    // alternative sequence was not set for this crud manager
                 *    // so let's fill it with existing stores keeping the same order
                 *    crudManager.addStoreToApplySequence(crudManager.crudStores);
                 *
                 *    // and now we can add our new store
                 *
                 *    // we will load its data last
                 *    crudManager.addCrudStore(someNewStore);
                 *    // but changes to it will be applied first
                 *    crudManager.addStoreToApplySequence(someNewStore, 0);
                 *    ```
                 * add registered stores to the sequence along with the store(s) you want to add
                 *
                 * @param {Common.data.Store|Object|Common.data.Store[]|Object[]} store The store to add or its _descriptor_ (or array of stores or descriptors).
                 * Where _store descriptor_ is an object having following properties:
                 * @param {String} store.storeId The store identifier that will be used as a key in requests.
                 * @param {Common.data.Store} store.store The store itself.
                 * @param {String} [store.idField] The idField of the store. If not specified will be taken from the store model.
                 * @param {String} [store.phantomIdField] The field holding unique Ids of phantom records (if store has such model).
                  * @param {Number} [position] The relative position of the store. If `fromStore` is specified the this position will be taken relative to it.
                 * If not specified then store(s) will be appended to the end of collection.
                 * Otherwise it will be just a position in stores collection.
                 *
                 *    ```javascript
                 *    // insert stores store4, store5 to the start of sequence
                 *    crudManager.addStoreToApplySequence([ store4, store5 ], 0);
                 *    ```
                 * @param {String|Common.data.Store|object} [fromStore] The store relative to which position should be calculated. Can be defined as a store identifier, instance or its descriptor (the result of {@link #function-getStoreDescriptor} call).
                 *
                 *    ```javascript
                 *    // insert store6 just before a store having storeId equal to 'foo'
                 *    crudManager.addStoreToApplySequence(store6, 0, 'foo');
                 *
                 *    // insert store7 just after store3 store
                 *    crudManager.addStoreToApplySequence(store7, 1, store3);
                 *    ```
                 */

              }, {
                key: "addStoreToApplySequence",
                value: function addStoreToApplySequence(store, position, fromStore) {
                  if (!store) return;
                  if (!Array.isArray(store)) store = [store];
                  var me = this,
                      // loop over list of stores to add
                  data = store.reduce(function (collection, store) {
                    var s = me.getStoreDescriptor(store);
                    if (s) collection.push(s);
                    return collection;
                  }, []); // if no position specified then append stores to the end

                  if (typeof position === 'undefined') {
                    me.syncApplySequence.push.apply(me.syncApplySequence, data); // if position specified
                  } else {
                    var _me$syncApplySequence;

                    var pos = position; // if specified the store relative to which we should insert new one(-s)

                    if (fromStore) {
                      if (fromStore instanceof _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_24__["default"] || _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_15___default()(fromStore) !== 'object') fromStore = me.getStoreDescriptor(fromStore); // get its position

                      pos += me.syncApplySequence.indexOf(fromStore);
                    } // insert new store(-s)
                    //me.syncApplySequence.splice.apply(me.syncApplySequence, [].concat([pos, 0], data));


                    (_me$syncApplySequence = me.syncApplySequence).splice.apply(_me$syncApplySequence, [pos, 0].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_13___default()(data)));
                  }
                }
                /**
                 * Removes a store from the alternative sync sequence.
                 *
                 *    ```javascript
                 *    // remove store having storeId equal to "foo"
                 *    crudManager.removeCrudStore("foo");
                 *
                 *    // remove store3
                 *    crudManager.removeCrudStore(store3);
                 *    ```
                 *
                 * @param {Object|String|Common.data.Store} store The store to remove. Either the store descriptor, store identifier or store itself.
                 */

              }, {
                key: "removeStoreFromApplySequence",
                value: function removeStoreFromApplySequence(store) {
                  var index = this.syncApplySequence.findIndex(function (s) {
                    return s === store || s.store === store || s.storeId === store;
                  });
                  if (index > -1) this.syncApplySequence.splice(index, 1);
                }
              }, {
                key: "hasApplySequenceStore",
                value: function hasApplySequenceStore(store) {
                  return this.syncApplySequence.some(function (s) {
                    return s === store || s.store === store || s.storeId === store;
                  });
                } //endregion
                //region Events
                // onNodeRemove(oldParent) {
                //     var treeStore = oldParent && oldParent.getTreeStore();
                //     // "noderemove" event is fired too early and getRemovedRecords() don't not have the removed node yet
                //     // so we wait till tree store "endupdate" event and only then invoke "onCrudStoreChange" method
                //     treeStore && treeStore.on('endupdate', this.onCrudStoreChange, this, { once : true });
                // }
                // onStoreUpdate(store, record, operation, fields) {
                //     if ((!store.isTreeStore || record !== store.getRoot())) {
                //         // If only a single field was changed, make sure it's a persistable field to avoid full scan of the store
                //         // Collapsing/expanding a tree node will trigger this behavior otherwise
                //         var isSingleNonPersistField = fields && fields.length === 1 && record.getField(fields[0]) && !record.getField(fields[0]).persist;
                //
                //         if (!isSingleNonPersistField) {
                //             this.onCrudStoreChange();
                //         }
                //     }
                // }
                // onTreeStoreInsertOrAppend(parent, child) {
                //     if (!child.isRoot()) {
                //         this.onCrudStoreChange();
                //     }
                // }

              }, {
                key: "onCrudStoreChange",
                value: function onCrudStoreChange() {
                  var me = this;
                  if (me.crudIgnoreUpdates) return;
                  /**
                   * Fires when any record in a registered stores is changed.
                   * ```javascript
                   *     crudManager.on('hasChanges', function (crud) {
                   *         // enable persist changes button when some store gets changed
                   *         saveButton.enable();
                   *     });
                   * ```
                   * @event crudStoreHasChanges
                   * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                   */

                  if (me.crudStoreHasChanges()) {
                    me.trigger('hasChanges');

                    if (me.autoSync) {
                      // add deferred call if it's not scheduled yet
                      if (!me.autoSyncTimerId) {
                        me.autoSyncTimerId = setTimeout(function () {
                          me.autoSyncTimerId = null;
                          me.sync();
                        }, me.autoSyncTimeout);
                      }
                    }
                  } else {
                    me.trigger('noChanges');
                  }
                }
              }, {
                key: "internalOnResponse",
                value: function () {
                  var _internalOnResponse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee(requestType, responseText, responseOptions, options) {
                    var me, response;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            // reset last requested package ID
                            me = this;
                            me.activeRequests[requestType] = null;
                            response = responseText ? me.decode(responseText) : null;

                            if (!(!response || !response.success)) {
                              _context.next = 8;
                              break;
                            }
                            /**
                             * Fires when a request fails.
                             * @event requestfail
                             * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
                             * @param {String} requestType The request type (`sync` or `load`).
                             * @param {Object} response The decoded server response object.
                             * @param {String} responseText The raw server response text
                             * @param {Object} responseOptions The response options.
                             */


                            me.trigger('requestFail', {
                              requestType: requestType,
                              response: response,
                              responseText: responseText,
                              responseOptions: responseOptions
                            });
                            /**
                             * Fires when a {@link #function-load load request} fails.
                             * @event loadFail
                             * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
                             * @param {Object} response The decoded server response object.
                             * @param {String} responseText The raw server response text
                             * @param {Object} responseOptions The response options.
                             * @params {Object} options Options provided to the {@link #function-load} method.
                             */

                            /**
                             * Fires when a {@link #function-sync sync request} fails.
                             * @event syncFail
                             * @param {Scheduler.crud.AbstractCrudManager} source The CRUD manager instance.
                             * @param {Object} response The decoded server response object.
                             * @param {String} responseText The raw server response text
                             * @param {Object} responseOptions The response options.
                             */

                            me.trigger(requestType + 'Fail', {
                              response: response,
                              responseOptions: responseOptions,
                              responseText: responseText,
                              options: options
                            });
                            me.warn('CrudManager: ' + requestType + ' failed, please inspect the server response');
                            return _context.abrupt("return", response);

                          case 8:
                            if (!(me.trigger('beforeResponseApply', {
                              requestType: requestType,
                              response: response
                            }) !== false && me.trigger('before' + _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_26__["default"].capitalizeFirstLetter(requestType) + 'Apply', {
                              response: response,
                              options: options
                            }) !== false)) {
                              _context.next = 15;
                              break;
                            }

                            me.crudRevision = response.revision;
                            _context.next = 12;
                            return me.applyResponse(requestType, response, options);

                          case 12:
                            /**
                             * Fires on successful request completion after data gets applied to the stores.
                             * @event requestdone
                             * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                             * @param {String} requestType The request type (`sync` or `load`).
                             * @param {Object} response The decoded server response object.
                             * @param {Object} responseOptions The server response options.
                             */
                            me.trigger('requestDone', {
                              requestType: requestType,
                              response: response,
                              responseOptions: responseOptions
                            });
                            /**
                             * Fires on successful {@link #function-load load request} completion after data gets loaded to the stores.
                             * @event load
                             * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                             * @param {Object} response The decoded server response object.
                             * @param {Object} responseOptions The server response options.
                             * @params {Object} options Options provided to the {@link #load} method.
                             */

                            /**
                             * Fires on successful {@link #function-sync sync request} completion.
                             * @event sync
                             * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                             * @param {Object} response The decoded server response object.
                             * @param {Object} responseOptions The server response options.
                             */

                            me.trigger(requestType, {
                              response: response,
                              responseOptions: responseOptions,
                              options: options
                            });

                            if (requestType === 'load' || !me.crudStoreHasChanges()) {
                              /**
                               * Fires when registered stores get into state when they don't have any
                               * not persisted change. This happens after {@link #function-load load} or {@link #function-sync sync} request
                               * completion. Or this may happen after a record update which turns its fields back to their original state.
                               *
                               * ```javascript
                               *     crudManager.on('nochanges', function (crud) {
                               *         // disable persist changes button when there is no changes
                               *         saveButton.disable();
                               *     });
                               * ```
                               *
                               * @event nochanges
                               * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                               */
                              me.trigger('noChanges');
                            }

                          case 15:
                            return _context.abrupt("return", response);

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, this);
                  }));

                  return function internalOnResponse(_x, _x2, _x3, _x4) {
                    return _internalOnResponse.apply(this, arguments);
                  };
                }()
              }, {
                key: "internalOnLoad",
                value: function () {
                  var _internalOnLoad = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee2(responseText, responseOptions, options) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            // Successful load request, mark crud manager as loaded
                            this.crudLoaded = true;
                            return _context2.abrupt("return", this.internalOnResponse('load', responseText, responseOptions, options));

                          case 2:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2, this);
                  }));

                  return function internalOnLoad(_x5, _x6, _x7) {
                    return _internalOnLoad.apply(this, arguments);
                  };
                }()
              }, {
                key: "internalOnSync",
                value: function () {
                  var _internalOnSync = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee3(responseText, responseOptions, options) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            return _context3.abrupt("return", this.internalOnResponse('sync', responseText, responseOptions, options));

                          case 1:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));

                  return function internalOnSync(_x8, _x9, _x10) {
                    return _internalOnSync.apply(this, arguments);
                  };
                }() //endregion
                //region Changes tracking

              }, {
                key: "suspendChangesTracking",
                value: function suspendChangesTracking() {
                  this.crudIgnoreUpdates++;
                }
              }, {
                key: "resumeChangesTracking",
                value: function resumeChangesTracking(triggerCheck) {
                  if (this.crudIgnoreUpdates && ! --this.crudIgnoreUpdates) {
                    if (triggerCheck) {
                      this.onCrudStoreChange();
                    }
                  }
                }
                /**
                 * Returns `true` if any of registered stores (or some particular store) has non persisted changes.
                 *
                 *    ```javascript
                 *    // if we have any unsaved changes
                 *    if (crudManager.crudStoreHasChanges()) {
                 *        // persist them
                 *        crudManager.sync();
                 *    // otherwise
                 *    } else {
                 *        alert("There are no unsaved changes...");
                 *    }
                 *    ```
                 *
                 * @param {String|Common.data.Store} [storeId] The store identifier or store instance to check changes for.
                 * If not specified then will check changes for all of the registered stores.
                 * @returns {Boolean} `true` if there are not persisted changes.
                 */

              }, {
                key: "crudStoreHasChanges",
                value: function crudStoreHasChanges(storeId) {
                  if (storeId) {
                    var store = this.getCrudStore(storeId);
                    return store && this.isCrudStoreDirty(store);
                  }

                  return this.crudStores.some(this.isCrudStoreDirty); // for (var i = 0, l = this.crudStores.length; i < l; i++) {
                  //     if (this.isCrudStoreDirty(this.crudStores[i].store)) return true;
                  // }
                  //
                  // return false;
                }
              }, {
                key: "isCrudStoreDirty",
                value: function isCrudStoreDirty(store) {
                  return store.store.changes != null;
                } //endregion
                //region Load

              }, {
                key: "emitCrudStoreEvents",
                value: function emitCrudStoreEvents(stores, eventName) {
                  var event = {
                    action: 'read' + eventName
                  };
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = this.crudStores[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var store = _step.value;

                      if (stores.includes(store.storeId)) {
                        store.store.trigger(eventName, event);
                      }
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                }
              }, {
                key: "getLoadPackage",
                value: function getLoadPackage(options) {
                  var pack = {
                    type: 'load',
                    requestId: this.requestId
                  },
                      stores = this.crudStores,
                      optionsCopy = Object.assign({}, options);
                  pack.stores = stores.map(function (store) {
                    var //filterParam = store.filterParam || store.store.filterParam || this.crudFilterParam,
                    opts = optionsCopy && optionsCopy[store.storeId],
                        pageSize = store.pageSize || store.store && store.store.pageSize; // TODO: PORT currently no support for remote filters
                    // if the store uses remote filtering
                    // if (store.store.remoteFilter && filterParam) {
                    //
                    //     opts = opts || {};
                    //
                    //     var filters = [];
                    //
                    //     store.store.getFilters().each(function(f) {
                    //         filters.push(f.serialize());
                    //     });
                    //
                    //     // put filters info into the package
                    //     opts[filterParam] = filters;
                    // }
                    // TODO: PORT currently no support for paging

                    if (opts || pageSize) {
                      var params = Object.assign({
                        storeId: store.storeId,
                        page: 1,
                        pageSize: pageSize
                      }, opts);
                      store.currentPage = params.page; // Remove from common request options

                      if (opts) {
                        delete optionsCopy[store.storeId];
                      }

                      return params;
                    }

                    return store.storeId;
                  }); // Apply common request options

                  Object.assign(pack, optionsCopy);
                  return pack;
                }
              }, {
                key: "loadCrudStore",
                value: function loadCrudStore(store, data, options, storeDesc) {
                  var rows = data && data.rows;

                  if (options && options.append || data.append) {
                    store.add(rows);
                  } else {
                    store.data = rows;
                  }

                  store.trigger('load', {
                    source: store,
                    data: rows
                  });
                }
              }, {
                key: "loadDataToCrudStore",
                value: function loadDataToCrudStore(storeDesc, data, options) {
                  var me = this,
                      store = storeDesc.store,
                      // nested stores list
                  subStores = storeDesc.stores,
                      idField = storeDesc.idField || 'id',
                      //model && model.meta.idField || 'id',
                  isTree = store.tree,
                      subData,
                      rows = data && data.rows;
                  store.__loading = true; //TODO: PORT meta data on store?
                  // apply server provided meta data to the store
                  // if (metaData) {
                  //     if (store.applyMetaData) {
                  //         store.applyMetaData(metaData);
                  //     } else {
                  //         store.metaData = metaData;
                  //     }
                  // }

                  if (rows) {
                    if (subStores) {
                      subData = me.getSubStoresData(rows, subStores, idField, isTree);
                    }

                    me.loadCrudStore(store, data, options, storeDesc);

                    if (subData) {
                      // load sub-stores as well (if we have them)
                      subData.forEach(function (sub) {
                        me.loadDataToCrudStore(Object.assign({
                          store: store.getById(sub.id).get(sub.storeDesc.storeId) // TODO: PORT have to check what this does

                        }, sub.storeDesc), sub.data);
                      });
                    }
                  }

                  store.__loading = false;
                }
              }, {
                key: "loadCrudManagerData",
                value: function loadCrudManagerData(response) {
                  var _this = this;

                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // we don't want reacting on store changes during loading of them

                  this.suspendChangesTracking(); // we load data to the stores in the order they're kept in this.stores array

                  this.crudStores.forEach(function (storeDesc) {
                    var storeId = storeDesc.storeId,
                        data = response[storeId];

                    if (data) {
                      _this.loadDataToCrudStore(storeDesc, data, options[storeId]);
                    }
                  });
                  this.resumeChangesTracking();
                }
                /**
                 * Returns true if the crud manager is currently loading data
                 * @property {Boolean}
                 * @readonly
                 * @category CRUD
                 */

              }, {
                key: "load",

                /**
                 * Loads data to the stores registered in the crud manager. For example:
                 *
                 * ```javascript
                 * crudManager.load(
                 *     // here are request parameters
                 *     {
                 *         store1 : { append : true, page : 3, smth : 'foo' },
                 *         store2 : { page : 2, bar : '!!!' }
                 *     }
                 * ).then(
                 *     () => alert('OMG! It works!'),
                 *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
                 * );
                 * ```
                 *
                 * ** Note: ** If there is an incomplete load request in progress then system will try to cancel it by calling {@link #function-cancelRequest}.
                 * @param {Object} options The request parameters. This argument can be omitted like this:
                 *
                 * ```javascript
                 * crudManager.load().then(
                 *     () => alert('OMG! It works!'),
                 *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
                 * );
                 * ```
                 *
                 * When presented it should be an object where keys are store Ids and values are, in turn, objects
                 * of parameters related to the corresponding store. And these parameters will be transferred with a load request.
                 *
                 * ```javascript
                 * {
                 *     store1 : { page : 3, append : true, smth : 'foo' },
                 *     store2 : { page : 2, bar : '!!!' }
                 * },
                 * ```
                 *
                 * Additionally for flat stores `append: true` can be specified to add loaded records to the existing records, default is to remove corresponding store's existing records first.
                 * **Please note** that for delta loading you can also use an {@link #config-trackResponseType alternative approach}.
                 * @returns {Promise} Promise, which is resolved if request was successful.
                 * Both the resolve and reject functions are passed a `state` object. State object has following structure:
                 *
                 *     {
                 *         cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
                 *         rawResponse     : String,  // raw response from ajax request, either response xml or text
                 *         rawResponseText : String,  // raw response text as String from ajax request
                 *         response        : Object,  // processed response in form of object
                 *         options         : Object   // options, passed to load request
                 *     }
                 *
                 * If promise was rejected by {@link #event-beforeload} event, `state` object will have structure:
                 *
                 *     {
                 *         cancelled : true
                 *     }
                 *
                 */
                value: function load(options) {
                  var me = this,
                      pack = me.getLoadPackage(options);
                  return new Promise(function (resolve, reject) {
                    /**
                     * Fires before {@link #function-load load request} is sent. Return `false` to cancel load request.
                     * @event beforeload
                     * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                     * @param {Object} request The request object.
                     */
                    if (me.trigger('beforeLoad', {
                      pack: pack
                    }) !== false) {
                      // if another load request is in progress let's cancel it
                      if (me.activeRequests.load) {
                        me.cancelRequest(me.activeRequests.load.desc);
                        me.trigger('loadCanceled', {
                          pack: pack
                        });
                      }

                      me.emitCrudStoreEvents(pack.stores, 'loadStart');
                      me.activeRequests.load = {
                        options: options,
                        pack: pack,
                        resolve: resolve,
                        reject: reject,
                        id: pack.requestId,
                        desc: me.sendRequest({
                          data: me.encode(pack),
                          type: 'load',
                          success: me.onLoadSuccess,
                          failure: me.onLoadFailure,
                          thisObj: me
                        })
                      };
                    } else {
                      /**
                       * Fired after {@link #function-load load request} was canceled by some {@link #event-beforeload} listener
                       * or due to incomplete prior load request.
                       * @event loadcanceled
                       * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                       * @param {Object} request The request object.
                       */
                      me.trigger('loadCanceled', {
                        pack: pack
                      });
                      reject({
                        cancelled: true
                      });
                    }
                  });
                }
              }, {
                key: "onLoadSuccess",
                value: function () {
                  var _onLoadSuccess = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee4(rawResponse, responseOptions) {
                    var responseText, request, options, response;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            responseText = '';
                            request = this.activeRequests.load, options = request.options;
                            _context4.next = 4;
                            return rawResponse.text().then(function (value) {
                              return responseText = value;
                            }).catch(nullFn);

                          case 4:
                            _context4.next = 6;
                            return this.internalOnLoad(responseText, responseOptions, options);

                          case 6:
                            response = _context4.sent;
                            this.emitCrudStoreEvents(request.pack.stores, 'afterRequest');

                            if (!response || !response.success) {
                              request.reject({
                                cancelled: false,
                                response: response,
                                rawResponse: rawResponse,
                                responseText: responseText,
                                options: options
                              });
                            } else {
                              request.resolve({
                                response: response,
                                rawResponse: rawResponse,
                                responseText: responseText,
                                options: options
                              });
                            }

                          case 9:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4, this);
                  }));

                  return function onLoadSuccess(_x11, _x12) {
                    return _onLoadSuccess.apply(this, arguments);
                  };
                }()
              }, {
                key: "onLoadFailure",
                value: function () {
                  var _onLoadFailure = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee5(rawResponse, responseOptions) {
                    var responseText, request, options, response;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            responseText = '';
                            request = this.activeRequests.load, options = request.options;
                            _context5.next = 4;
                            return rawResponse.text().then(function (value) {
                              return responseText = value;
                            }).catch(nullFn);

                          case 4:
                            _context5.next = 6;
                            return this.internalOnLoad(responseText, responseOptions, options);

                          case 6:
                            response = _context5.sent;
                            this.emitCrudStoreEvents(request.pack.stores, 'afterRequest');
                            request.reject({
                              cancelled: false,
                              response: response,
                              rawResponse: rawResponse,
                              responseText: responseText,
                              options: options
                            });

                          case 9:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5, this);
                  }));

                  return function onLoadFailure(_x13, _x14) {
                    return _onLoadFailure.apply(this, arguments);
                  };
                }()
              }, {
                key: "getSubStoresData",
                value: function getSubStoresData(rows, subStores, idField, isTree) {
                  var _this2 = this;

                  if (!rows) return;
                  var result = [];

                  function processRow(row, subStores) {
                    subStores.forEach(function (subStore) {
                      var storeId = subStore.storeId; // if row contains data for this sub-store

                      if (row[storeId]) {
                        // keep them for the later loading
                        result.push({
                          id: row[idField],
                          storeDesc: subStore,
                          data: row[storeId]
                        }); // and remove reference from the row

                        delete row[storeId];
                      }
                    });
                  } // if it's a TreeStore


                  if (isTree) {
                    // loop over nodes
                    rows.forEach(function (row) {
                      processRow(row, subStores); // also let's grab sub-stores from node children

                      var childrenSubData = _this2.getSubStoresData(row.children, subStores, idField, true);

                      if (childrenSubData) {
                        result = result.concat(childrenSubData);
                      }
                    }); // if it's a "flat" store
                  } else {
                    rows.forEach(function (row) {
                      return processRow(row, subStores);
                    });
                  }

                  return result;
                } //endregion
                //region Changes (prepare, process, get)

              }, {
                key: "prepareAdded",
                value: function prepareAdded(list, phantomIdField, stores) {
                  var _this3 = this;

                  return list.filter(function (record) {
                    return record.isValid;
                  }).map(function (record) {
                    var data = Object.assign(record.persistableData, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, phantomIdField, record.id));
                    if (_this3.resetIdsBeforeSync) delete data[record.constructor.idField]; // if the store has embedded ones

                    if (stores) {
                      _this3.processSubStores(record, data, stores);
                    }

                    return data;
                  });
                }
              }, {
                key: "prepareUpdated",
                value: function prepareUpdated(list, stores, storeInfo) {
                  var _this4 = this;

                  var writeAllFields = storeInfo.writeAllFields || storeInfo.writeAllFields !== false && this.writeAllFields; // TODO: root node included into store.modified
                  // need to get rid of it since we don't persist it

                  if (storeInfo.store.tree) {
                    var rootNode = storeInfo.store.rootNode;
                    list = list.filter(function (record) {
                      return record !== rootNode;
                    });
                  }

                  return list.filter(function (record) {
                    return record.isValid;
                  }).reduce(function (data, record) {
                    var recordData; // write all fields

                    if (writeAllFields) {
                      recordData = record.persistableData;
                      recordData[record.constructor.idField] = record.id;
                    } else {
                      recordData = record.modifications;
                      recordData[record.constructor.idField] = record.id; // TODO: PORT critical fields
                      // critical fields should always be presented
                      // const criticalFields = record.getCriticalFields();
                      //
                      // for (var j = 0; j < criticalFields.length; j++) {
                      //     field = criticalFields[j];
                      //
                      //     if (field.serialize) {
                      //         data[field.getName()] = field.serialize(record.get(field.getName()), record);
                      //     } else {
                      //         data[field.getName()] = record.get(field.getName());
                      //     }
                      // }
                    } // if the store has embedded ones


                    if (stores) {
                      _this4.processSubStores(record, recordData, stores);
                    }

                    var persistableFields = Object.keys(recordData);

                    if (persistableFields.length > 1 || persistableFields[0] !== record.constructor.idField) {
                      data.push(recordData);
                    }

                    return data;
                  }, []);
                }
              }, {
                key: "prepareRemoved",
                value: function prepareRemoved(list) {
                  return list.map(function (record) {
                    return _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, record.constructor.idField, record.id);
                  });
                }
              }, {
                key: "processSubStores",
                value: function processSubStores(record, data, stores) {
                  var _this5 = this;

                  stores.forEach(function (store) {
                    var id = store.storeId,
                        subStore = record.get(id); // if embedded store is assigned to the record

                    if (subStore) {
                      // let's collect its changes as well
                      var changes = _this5.getCrudStoreChanges(Object.assign({
                        store: subStore
                      }, store));

                      if (changes) {
                        data[id] = Object.assign(changes, {
                          $store: true
                        });
                      } else {
                        delete data[id];
                      }
                    } else {
                      delete data[id];
                    }
                  });
                }
              }, {
                key: "getCrudStoreChanges",
                value: function getCrudStoreChanges(store) {
                  var phantomIdField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : store.phantomIdField || this.phantomIdField;
                  var s = store.store,
                      added = s.added.values,
                      updated = s.modified.values,
                      removed = s.removed.values,
                      // sub-stores
                  stores = store.stores,
                      result;
                  if (added.length) added = this.prepareAdded(added, phantomIdField, stores);
                  if (updated.length) updated = this.prepareUpdated(updated, stores, store);
                  if (removed.length) removed = this.prepareRemoved(removed); // if this store has changes

                  if (added.length || updated.length || removed.length) {
                    result = {};
                    if (added.length) result.added = added;
                    if (updated.length) result.updated = updated;
                    if (removed.length) result.removed = removed;
                  }

                  return result;
                }
              }, {
                key: "getChangeSetPackage",
                value: function getChangeSetPackage() {
                  var _this6 = this;

                  var pack = {
                    type: 'sync',
                    requestId: this.requestId,
                    revision: this.crudRevision
                  },
                      found = 0;
                  this.crudStores.forEach(function (store) {
                    var changes = _this6.getCrudStoreChanges(store);

                    if (changes) {
                      found++;
                      pack[store.storeId] = changes;
                    }
                  });
                  return found ? pack : null;
                } //endregion
                //region Apply

              }, {
                key: "applyChangesToRecord",
                value: function applyChangesToRecord(record, rawChanges, stores, store) {
                  var me = this,
                      modelClass = record.constructor,
                      fieldDataSourceMap = modelClass.fieldDataSourceMap,
                      recProto = modelClass.prototype,
                      changes = {},
                      data = record.data,
                      done = _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()({}, me.phantomIdField, true);

                  var hasChanges; // if this store has sub-stores assigned to some fields

                  if (stores) {
                    // then first we apply changes to that stores
                    stores.forEach(function (store) {
                      var name = store.storeId;

                      if (rawChanges.hasOwnProperty(name)) {
                        // remember that we processed this field
                        done[name] = true;
                        var subStore = record.get(name);

                        if (subStore) {
                          me.applyChangesToStore(Object.assign({
                            store: subStore
                          }, store), rawChanges[name]);
                        } else {
                          console.log("Can't find store for the response sub-package");
                        }
                      }
                    });
                  } // Collect the changes into a change set for field names.


                  for (var dataSource in rawChanges) {
                    if (rawChanges.hasOwnProperty(dataSource) && !done[dataSource]) {
                      var field = fieldDataSourceMap[dataSource],
                          propName = field ? field.name : dataSource,
                          value = modelClass.processField(propName, rawChanges[dataSource]),
                          oldValue = dataSource in recProto ? record[propName] : _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].getPath(data, dataSource);

                      if (!_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].isEqual(oldValue, value)) {
                        hasChanges = true;
                        changes[propName] = value;
                      }
                    }
                  }

                  if (hasChanges) {
                    me.suspendChangesTracking(); // Set each field seperately until https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.

                    for (var fieldName in changes) {
                      record[fieldName] = changes[fieldName];
                    } // TODO: Re-enable record.set when https://app.assembla.com/spaces/bryntum/tickets/9123 is fixed.
                    // Set fields one go
                    // record.set(changes);


                    me.resumeChangesTracking(); // Clear changes only for the passed record,
                    // not descendant nodes.
                    // TODO: they *might* also be genuinely new
                    // so might have to stay.

                    record.clearChanges(true, false);
                  }
                }
              }, {
                key: "applyRemovals",
                value: function applyRemovals(store, removed, context) {
                  var _this7 = this;

                  var removedStash = store.removed,
                      findByIdFn = context.findByIdFn,
                      removeRecordFn = context.removeRecordFn,
                      applied = 0;
                  removed.forEach(function (remove) {
                    var done = false,
                        id = remove.id; // just remove the record from the removed stash

                    if (removedStash.includes(remove)) {
                      removedStash.remove(remove);
                      done = true; // number of removals applied

                      applied++;
                    } // if responded removed record isn`t found in store.removed
                    // probably don't removed on the client side yet (server driven removal)


                    if (!done) {
                      var record = findByIdFn(id);

                      if (record) {
                        _this7.suspendChangesTracking();

                        removeRecordFn(record);
                        removedStash.remove(record); // number of removals applied

                        applied++;

                        _this7.resumeChangesTracking();
                      } else {
                        console.log('Can\'t find record to remove from the response package');
                      }
                    }
                  });
                  return applied;
                }
              }, {
                key: "getApplyChangesToStoreHelpers",
                value: function getApplyChangesToStoreHelpers(store) {
                  // if it's a tree store
                  if (store.tree) {
                    return {
                      findByPhantomFn: function findByPhantomFn(id) {
                        return store.getById(id);
                      },
                      findByIdFn: function findByIdFn(id) {
                        return store.getById(id);
                      },
                      // TODO: need to support parentIdProperty
                      addRecordFn: function addRecordFn(data) {
                        var parent = data.parentId && store.getById(data.parentId) || store.rootNode;
                        return parent.appendChild(data);
                      },
                      removeRecordFn: function removeRecordFn(record) {
                        return record.remove();
                      }
                    }; // plain store
                  } else {
                    return {
                      findByPhantomFn: function findByPhantomFn(id) {
                        return store.getById(id);
                      },
                      findByIdFn: function findByIdFn(id) {
                        return store.getById(id);
                      },
                      addRecordFn: function addRecordFn(data) {
                        return store.add(data)[0];
                      },
                      removeRecordFn: function removeRecordFn(record) {
                        return store.remove(record);
                      }
                    };
                  }
                }
              }, {
                key: "applyChangesToStore",
                value: function () {
                  var _applyChangesToStore = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee6(storeDesc, storeResponse) {
                    var me, phantomIdField, idField, store, _me$getApplyChangesTo, findByPhantomFn, findByIdFn, addRecordFn, removeRecordFn, rows, removed, stores;

                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            me = this, phantomIdField = storeDesc.phantomIdField || me.phantomIdField, idField = storeDesc.idField || 'id', store = storeDesc.store, _me$getApplyChangesTo = me.getApplyChangesToStoreHelpers(store), findByPhantomFn = _me$getApplyChangesTo.findByPhantomFn, findByIdFn = _me$getApplyChangesTo.findByIdFn, addRecordFn = _me$getApplyChangesTo.addRecordFn, removeRecordFn = _me$getApplyChangesTo.removeRecordFn, rows = storeResponse.rows, removed = storeResponse.removed; // process added/updated records

                            if (rows) {
                              // sub-stores
                              stores = storeDesc.stores;
                              rows.forEach(function (data) {
                                var phantomId = data[phantomIdField],
                                    id = data[idField];
                                var record = null; // if phantomId is provided then we will use it to find added record

                                if (phantomId != null && phantomId != null) {
                                  record = findByPhantomFn(phantomId);
                                } // if id is provided then we will use it to find updated record
                                else if (idField) {
                                    record = findByIdFn(id);
                                  }

                                if (record) {
                                  me.applyChangesToRecord(record, data, stores, store);
                                } else {
                                  me.suspendChangesTracking(); // create new record in the store

                                  record = addRecordFn(data);
                                  me.resumeChangesTracking();
                                  record.clearChanges();
                                }
                              });
                            } // process removed records


                            if (removed && me.applyRemovals(store, removed, {
                              idField: idField,
                              findByIdFn: findByIdFn,
                              removeRecordFn: removeRecordFn
                            })) {
                              store.trigger('dataChanged', {
                                source: store
                              });
                            }

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));

                  return function applyChangesToStore(_x15, _x16) {
                    return _applyChangesToStore.apply(this, arguments);
                  };
                }()
              }, {
                key: "applySyncResponse",
                value: function () {
                  var _applySyncResponse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee8(response) {
                    var me, stores;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee8$(_context8) {
                      while (1) {
                        switch (_context8.prev = _context8.next) {
                          case 0:
                            me = this, stores = me.syncApplySequence.length ? me.syncApplySequence : me.crudStores;
                            me.applyingSyncResponse = true;
                            stores.forEach(
                            /*#__PURE__*/
                            function () {
                              var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                              /*#__PURE__*/
                              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee7(store) {
                                var storeResponse;
                                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee7$(_context7) {
                                  while (1) {
                                    switch (_context7.prev = _context7.next) {
                                      case 0:
                                        storeResponse = response[store.storeId];

                                        if (!storeResponse) {
                                          _context7.next = 4;
                                          break;
                                        }

                                        _context7.next = 4;
                                        return me.applyChangesToStore(store, storeResponse);

                                      case 4:
                                      case "end":
                                        return _context7.stop();
                                    }
                                  }
                                }, _callee7, this);
                              }));

                              return function (_x18) {
                                return _ref2.apply(this, arguments);
                              };
                            }());
                            me.applyingSyncResponse = false;

                          case 4:
                          case "end":
                            return _context8.stop();
                        }
                      }
                    }, _callee8, this);
                  }));

                  return function applySyncResponse(_x17) {
                    return _applySyncResponse.apply(this, arguments);
                  };
                }()
              }, {
                key: "applyLoadResponse",
                value: function () {
                  var _applyLoadResponse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee9(response, options) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            this.applyingLoadResponse = true;
                            this.loadCrudManagerData(response, options);
                            this.applyingLoadResponse = false;

                          case 3:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9, this);
                  }));

                  return function applyLoadResponse(_x19, _x20) {
                    return _applyLoadResponse.apply(this, arguments);
                  };
                }()
              }, {
                key: "applyResponse",
                value: function () {
                  var _applyResponse = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee10(requestType, response, options) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            // in trackResponseType we check response type before deciding how to react on the response
                            if (this.trackResponseType) {
                              requestType = response.type || requestType;
                            }

                            _context10.t0 = requestType;
                            _context10.next = _context10.t0 === 'load' ? 4 : _context10.t0 === 'sync' ? 7 : 10;
                            break;

                          case 4:
                            _context10.next = 6;
                            return this.applyLoadResponse(response, options);

                          case 6:
                            return _context10.abrupt("break", 10);

                          case 7:
                            _context10.next = 9;
                            return this.applySyncResponse(response);

                          case 9:
                            return _context10.abrupt("break", 10);

                          case 10:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10, this);
                  }));

                  return function applyResponse(_x21, _x22, _x23) {
                    return _applyResponse.apply(this, arguments);
                  };
                }() //endregion

                /**
                 * Generates unique request identifier.
                 * @internal
                 * @template
                 * @return {Number} The request identifier.
                 */

              }, {
                key: "sync",

                /**
                 * Persists changes made on the registered stores to the server. Usage:
                 *
                 * ```javascript
                 * // persist and run a callback on request completion
                 * crud.sync().then(
                 *     () => console.log("Changes saved..."),
                 *     ({ response, cancelled }) => console.log(`Error: ${cancelled ? 'Cancelled' : response.message}`)
                 * );
                 * ```
                 *
                 * ** Note: ** If there is an incomplete sync request in progress then system will queue the call and delay it until previous request completion.
                 * In this case {@link #event-syncdelayed} event will be fired.
                 *
                 * ** Note: ** Please take a look at {@link #config-autoSync} config. This option allows to persist changes automatically after any data modification.
                 * @returns {Promise} Promise, which is resolved if request was successful.
                 * Both the resolve and reject functions are passed a `state` object. State object has following structure:
                 *
                 *     {
                 *         cancelled       : Boolean, // **optional** flag, which is present when promise was rejected
                 *         rawResponse     : String,  // raw response from ajax request, either response xml or text
                 *         rawResponseText : String,  // raw response text as String from ajax request
                 *         response        : Object,  // processed response in form of object
                 *     }
                 *
                 * If promise was rejected by {@link #event-beforesync} event, `state` object will have structure:
                 *
                 *     {
                 *         cancelled : true
                 *     }
                 *
                 */
                value: function sync() {
                  var me = this;

                  if (me.activeRequests.sync) {
                    // let's delay this call and start it only after server response

                    /**
                     * Fires after {@link #function-sync sync request} was delayed due to incomplete previous one.
                     * @event syncdelayed
                     * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                     * @param {Object} arguments The arguments of {@link #function-sync} call.
                     */
                    me.trigger('syncDelayed'); // Queue sync request after current one

                    return me.activeSyncPromise = me.activeSyncPromise.then(function () {
                      return me.sync();
                    }, function () {
                      return me.sync();
                    });
                  } // Store current requrest promise. While this one is pending, all following sync requests will create chain
                  // of sequential promises


                  return me.activeSyncPromise = new Promise(function (resolve, reject) {
                    // get current changes set package
                    var pack = me.getChangeSetPackage(); // if no data to persist we resolve immediately

                    if (!pack) {
                      resolve(null);
                      return;
                    }
                    /**
                     * Fires before {@link #function-sync sync request} is sent. Return `false` to cancel sync request.
                     *
                     * ```javascript
                     *     crudManager.on('beforesync', function() {
                     *        // cannot persist changes before at least one record is added
                     *        // to the `someStore` store
                     *        if (!someStore.getCount()) return false;
                     *     });
                     * ```
                     * @event beforesync
                     * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                     * @param {Object} request The request object.
                     */


                    if (me.trigger('beforeSync', {
                      pack: pack
                    }) !== false) {
                      // keep active request details
                      me.activeRequests.sync = {
                        pack: pack,
                        resolve: resolve,
                        reject: reject,
                        id: pack.requestId,
                        desc: me.sendRequest({
                          data: me.encode(pack),
                          type: 'sync',
                          success: me.onSyncSuccess,
                          failure: me.onSyncFailure,
                          thisObj: me
                        })
                      };
                    } else {
                      // if this sync was canceled let's fire event about it

                      /**
                       * Fires after {@link #function-sync sync request} was canceled by some {@link #event-beforesync} listener.
                       * @event synccanceled
                       * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                       * @param {Object} request The request object.
                       */
                      me.trigger('syncCanceled', {
                        pack: pack
                      });
                      reject({
                        cancelled: true
                      });
                    }
                  });
                }
              }, {
                key: "onSyncSuccess",
                value: function () {
                  var _onSyncSuccess = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee11(rawResponse, responseOptions) {
                    var responseText, request, response;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee11$(_context11) {
                      while (1) {
                        switch (_context11.prev = _context11.next) {
                          case 0:
                            responseText = '';
                            _context11.next = 3;
                            return rawResponse.text().then(function (value) {
                              return responseText = value;
                            }).catch(nullFn);

                          case 3:
                            request = this.activeRequests.sync;
                            _context11.next = 6;
                            return this.internalOnSync(responseText, responseOptions);

                          case 6:
                            response = _context11.sent;

                            if (!response || !response.success) {
                              request.reject({
                                cancelled: false,
                                response: response,
                                rawResponse: rawResponse,
                                responseText: responseText,
                                request: request
                              });
                            } else {
                              request.resolve({
                                response: response,
                                rawResponse: rawResponse,
                                responseText: responseText,
                                request: request
                              });
                            }

                          case 8:
                          case "end":
                            return _context11.stop();
                        }
                      }
                    }, _callee11, this);
                  }));

                  return function onSyncSuccess(_x24, _x25) {
                    return _onSyncSuccess.apply(this, arguments);
                  };
                }()
              }, {
                key: "onSyncFailure",
                value: function () {
                  var _onSyncFailure = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_11___default()(
                  /*#__PURE__*/
                  _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee12(rawResponse, responseOptions) {
                    var responseText, request, response;
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee12$(_context12) {
                      while (1) {
                        switch (_context12.prev = _context12.next) {
                          case 0:
                            responseText = '';
                            _context12.next = 3;
                            return rawResponse.text().then(function (value) {
                              return responseText = value;
                            }).catch(nullFn);

                          case 3:
                            request = this.activeRequests.sync;
                            _context12.next = 6;
                            return this.internalOnSync(responseText, responseOptions);

                          case 6:
                            response = _context12.sent;
                            request.reject({
                              cancelled: false,
                              response: response,
                              rawResponse: rawResponse,
                              responseText: responseText,
                              request: request
                            });

                          case 8:
                          case "end":
                            return _context12.stop();
                        }
                      }
                    }, _callee12, this);
                  }));

                  return function onSyncFailure(_x26, _x27) {
                    return _onSyncFailure.apply(this, arguments);
                  };
                }()
                /**
                 * Commits all records changes of all the registered stores.
                 */

              }, {
                key: "commitCrudStores",
                value: function commitCrudStores() {
                  this.crudStores.forEach(function (store) {
                    return store.store.commit();
                  });
                }
                /**
                 * Rejects all records changes on all stores and re-insert any records that were removed locally. Any phantom records will be removed.
                 */

              }, {
                key: "rejectCrudStores",
                value: function rejectCrudStores() {
                  this.crudStores.forEach(function (store) {
                    return store.store.clearChanges();
                  });
                }
              }, {
                key: "warn",
                value: function warn() {
                  if ('console' in window) {
                    var c = console;
                    c.log && c.log.apply && c.log.apply(c, arguments);
                  }
                }
                /**
                 * Removes all stores and cancels active requests.
                 */

              }, {
                key: "doDestroy",
                value: function doDestroy() {
                  var me = this;
                  me.activeRequests.load && me.cancelRequest(me.activeRequests.load.desc);
                  me.activeRequests.sync && me.cancelRequest(me.activeRequests.sync.desc);

                  while (me.crudStores.length > 0) {
                    me.removeCrudStore(me.crudStores[0]);
                  }

                  clearTimeout(me.autoSyncTimerId);
                  me.destroyed = true;
                } // set crudRevision(value) {
                //     debugger
                //     this._crudRevision = value;
                // }
                // get crudRevision() {
                //     return this._crudRevision;
                // }

              }, {
                key: "crudStores",
                set: function set(stores) {
                  this._crudStores = [];
                  this.addCrudStore(stores); // Ensure preconfigured stores stay stable at the start of the array when
                  // addPrioritizedStore attempts to insert in order. Only featured gantt/scheduler stores
                  // must participate in the ordering. If they were configured in, they must not move.

                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = this._crudStores[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var store = _step2.value;
                      store.loadPriority = store.syncPriority = 0;
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                },
                get: function get() {
                  return this._crudStores;
                }
              }, {
                key: "syncApplySequence",
                set: function set(stores) {
                  this._syncApplySequence = [];
                  this.addStoreToApplySequence(stores);
                },
                get: function get() {
                  return this._syncApplySequence;
                }
              }, {
                key: "isCrudManagerLoading",
                get: function get() {
                  return Boolean(this.activeRequests.load || this.applyingLoadResponse);
                }
              }, {
                key: "requestId",
                get: function get() {
                  return Date.now() + '' + this._requestId++;
                }
              }], [{
                key: "crudManagerDefaultConfig",
                //region Default config
                get: function get() {
                  // static get defaultConfig() {
                  return {
                    // overrideCrudStoreLoad : false,

                    /**
                     * The server revision stamp.
                     * The _revision stamp_ is a number which should be incremented after each server-side change.
                     * This property reflects the current version of the data retrieved from the server and gets updated after each {@link #function-load} and {@link #function-sync} call.
                     * @property {Number}
                     * @readonly
                     */
                    crudRevision: null,

                    /**
                     * A list of registered stores whose server communication will be collected into a single batch.
                     * Each store is represented by a _store descriptor_, an object having following structure:
                     * @member {Object[]} crudStores
                     * @property {String} stores.storeId Unique store identifier.
                     * @property {Common.data.Store} stores.store Store itself.
                     * @property {String} [stores.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
                     * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
                     */

                    /**
                     * Sets the list of stores controlled by the CRUD manager.
                     * Store can be provided by itself, its storeId or an object having the following structure:
                     * @property {String} stores.storeId Unique store identifier. Under this name the store related requests/responses will be sent.
                     * @property {Common.data.Store} stores.store The store itself.
                     * @property {String} [stores.phantomIdField] Set this if the store model has a predefined field to keep phantom record identifier.
                     * @property {String} [stores.idField] id field name, if it's not specified then class will try to get it from a store model.
                     * @config {Common.data.Store[]|String[]|Object[]}
                     */
                    crudStores: [],

                    /**
                     * Name of a store property to retrieve store identifiers from.
                     * Store identifier is used as a container name holding corresponding store data while transferring them to/from the server.
                     * By default `storeId` property is used. And in case a container identifier has to differ this config can be used:
                     *
                     * ```javascript
                     * class CatStore extends Store {
                     *     // storeId is "meow" but for sending/receiving store data
                     *     // we want have "cats" container in JSON, so we create a new property "storeIdForCrud"
                     *     storeId          : 'meow',
                     *     storeIdForCrud   : 'cats'
                     * });
                     *
                     * class MyCrudManager extends CrudManager {
                     *     ...
                     *     crudStores           : ['meow'],
                     *     // crud manager will get store identifier from "storeIdForCrud" property
                     *     storeIdProperty  : 'storeIdForCrud'
                     * });
                     * ```
                     * The `storeIdProperty` property can also be specified directly on a store:
                     *
                     * ```javascript
                     * class CatStore extends Store {
                     *     // storeId is "meow" but for sending/receiving store data
                     *     // we want have "cats" container in JSON
                     *     storeId          : 'meow',
                     *     // so we create a new property "storeIdForCrud"..
                     *     storeIdForCrud  : 'cats',
                     *     // and point CrudManager to use it as the store identifier source
                     *     storeIdProperty  : 'storeIdForCrud'
                     * });
                     *
                     * class DogStore extends Store {
                     *     // storeId is "dogs" and it will be used as a container name for the store data
                     *     storeId          : 'dogs'
                     * });
                     *
                     * class MyCrudManager extends CrudManager {
                     *     ...
                     *     crudStores           : ['meow', 'dogs']
                     * });
                     * ```
                     * @config {String}
                     */
                    storeIdProperty: 'storeId',
                    // TODO: no support for remote filtering yet
                    // /**
                    //  * The name of the 'filter' parameter to send in a load request.
                    //  * @config {String}
                    //  * @default
                    //  */
                    crudFilterParam: 'filter',

                    /**
                     * Sends request to the server.
                     * @function sendRequest
                     * @param {Object} request The request to send. An object having following properties:
                     * @param {String} request.data {@link #function-encode Encoded} request.
                     * @param {String} request.type Request type, can be either `load` or `sync`
                     * @param {Function} request.success Callback to be started on successful request transferring
                     * @param {Function} request.failure Callback to be started on request transfer failure
                     * @param {Object} request.thisObj `this` reference for the above `success` and `failure` callbacks
                     * @return {Promise} The request promise.
                     * @abstract
                     */

                    /**
                     * Cancels request to the server.
                     * @function cancelRequest
                     * @param {Object} request The request to cancel (a value returned by corresponding {@link #function-sendRequest} call).
                     * @abstract
                     */

                    /**
                     * Encodes request to the server.
                     * @function encode
                     * @param {Object} request The request to encode.
                     * @returns {String} The encoded request.
                     * @abstract
                     */

                    /**
                     * Decodes response from the server.
                     * @function decode
                     * @param {String} response The response to decode.
                     * @returns {Object} The decoded response.
                     * @abstract
                     */
                    transport: {},

                    /**
                     * When `true` forces the CRUD manager to process responses depending on their `type` attribute.
                     * So `load` request may be responded with `sync` response for example.
                     * Can be used for smart server logic allowing the server to decide when it's better to respond with a complete data set (`load` response)
                     * or it's enough to return just a delta (`sync` response).
                     * @config {Boolean}
                     * @default
                     */
                    trackResponseType: false,

                    /**
                     * Field name to be used to transfer a phantom record identifier.
                     * @config {String}
                     * @default
                     */
                    phantomIdField: '$PhantomId',

                    /**
                     * `true` to automatically call {@link #function-load} method after creation.
                     * @config {Boolean}
                     * @default
                     */
                    autoLoad: false,

                    /**
                     * The timeout in milliseconds to wait before persisting changes to the server.
                     * Used when {@link #config-autoSync} is set to `true`.
                     * @config {Number}
                     * @default
                     */
                    autoSyncTimeout: 100,

                    /**
                     * `true` to automatically persist store changes after edits are made in any of the stores monitored.
                     * Please note that sync request will not be invoked immediately but only after {@link #config-autoSyncTimeout} interval.
                     * @config {Boolean}
                     * @default
                     */
                    autoSync: false,

                    /**
                     * `True` to reset identifiers (defined by `idField` config) of phantom records before submitting them to the server.
                     * @config {Boolean}
                     * @default
                     */
                    resetIdsBeforeSync: true,

                    /**
                     * @member {Object[]} syncApplySequence
                     * An array of stores presenting an alternative sync responses apply order.
                     * Each store is represented by a _store descriptor_, an object having following structure:
                     * @property {String} syncApplySequence.storeId Unique store identifier.
                     * @property {Common.data.Store} syncApplySequence.store Store itself.
                     * @property {String} [syncApplySequence.phantomIdField] Set this if store model has a predefined field to keep phantom record identifier.
                     * @property {String} [syncApplySequence.idField] id field name, if it's not specified then class will try to get it from a store model.
                     */

                    /**
                     * An array of store identifiers sets an alternative sync responses apply order.
                     * By default the order in which sync responses are applied to the stores is the same as they registered in.
                     * But in case of some tricky dependencies between stores this order can be changed:
                     *
                     *```javascript
                     * class MyCrudManager extends CrudManager {
                     *     // register stores (they will be loaded in the same order: 'store1' then 'store2' and finally 'store3')
                     *     crudStores : ['store1', 'store2', 'store3'],
                     *     // but we apply changes from server to them in an opposite order
                     *     syncApplySequence : ['store3', 'store2', 'store1']
                     * });
                     *```
                     * @config {String[]}
                     */
                    syncApplySequence: [],

                    /**
                     * true to write all fields from the record to the server. If set to false it will only send the fields that
                     * were modified. Note that any fields that have `persist` set to false will still be ignored while those
                     * with `critical` set to true will be included.
                     * @config {Boolean}
                     * @default
                     */
                    writeAllFields: false,
                    crudIgnoreUpdates: 0,
                    // Flag that shows if crud manager performed successful load request
                    crudLoaded: false,
                    createMissingRecords: false,
                    autoSyncTimerId: null,
                    applyingLoadResponse: false,
                    applyingSyncResponse: false,
                    callOnFunctions: true
                  };
                }
              }]);

              return AbstractCrudManagerMixin;
            }(Target)
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/crud/encoder/JsonEncoder.js":
      /*!***************************************************!*\
        !*** ./lib/Scheduler/crud/encoder/JsonEncoder.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerCrudEncoderJsonEncoderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/crud/encoder/JsonEncoder
         */

        /**
         * Implements data encoding functional that should be mixed to a {@link Scheduler.crud.AbstractCrudManager} sub-class.
         * Uses _JSON_ as an encoding system.
         *
         * @example
         * // create a new CrudManager using AJAX as a transport system and JSON for encoding
         * class MyCrudManager extends JsonEncode(AjaxTransport(AbstractCrudManager)) {}
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(JsonEncoder, _ref);

              function JsonEncoder() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, JsonEncoder);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(JsonEncoder).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(JsonEncoder, [{
                key: "encode",
                //format  : 'json',

                /**
                 * Encodes an request object to _JSON_ encoded string. If encoding fails (due to circular structure), it returns null.
                 * @param {Object} request The request to encode.
                 * @returns {String} The encoded request.
                 */
                value: function encode(requestConfig) {
                  return _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].safeJsonStringify(requestConfig);
                }
                /**
                 * Decodes (parses) a _JSON_ response string to an object. If parsing fails, it returns null.
                 * @param {String} responseText The response text to decode.
                 * @returns {Object} The decoded response.
                 */

              }, {
                key: "decode",
                value: function decode(responseText) {
                  return _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].safeJsonParse(responseText);
                }
              }]);

              return JsonEncoder;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/crud/transport/AjaxTransport.js":
      /*!*******************************************************!*\
        !*** ./lib/Scheduler/crud/transport/AjaxTransport.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerCrudTransportAjaxTransportJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/helper/AjaxHelper.js */
        "../Grid/lib/Common/helper/AjaxHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/crud/transport/AjaxTransport
         */

        /**
         * Implements data transferring functional that can be used for {@link Scheduler.crud.AbstractCrudManager} super classing.
         * Uses the fetch API for transport, https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
         *
         * @example
         * // create a new CrudManager using AJAX as a transport system and JSON for encoding
         * class MyCrudManager extends AjaxTransport(JsonEncode(AbstractCrudManager)) {}
         *
         * @abstract
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(AjaxTransport, _ref);

              function AjaxTransport() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, AjaxTransport);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AjaxTransport).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(AjaxTransport, [{
                key: "cancelRequest",

                /**
                 * Cancels a sent request.
                 * @param {Promise} requestPromise The Promise object wrapping the Request to be cancelled.
                 * The _requestPromise_ is the return value returned from the corresponding {@link #function-sendRequest} call.
                 */
                value: function cancelRequest(requestPromise) {
                  requestPromise.abort();
                }
                /**
                 * Sends request to the server.
                 * @param {Object} request The request configuration object having following properties:
                 * @param {String} request.data The encoded request.
                 * @param {String} request.type The request type. Either `load` or `sync`.
                 * @param {Function} request.success A function to be started on successful request transferring.
                 * @param {String} request.success.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
                 * @param {Function} request.failure A function to be started on request transfer failure.
                 * @param {String} request.failure.rawResponse `Response` object returned by the [fetch api](https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API).
                 * @param {Object} request.thisObj `this` reference for the above `success` and `failure` functions.
                 * @return {Promise} The fetch Promise object.
                 * @fires beforesend
                 */

              }, {
                key: "sendRequest",
                value: function sendRequest(config) {
                  var me = this,
                      pack = config.data,
                      packCfg = me.transport[config.type] || {},
                      paramName = packCfg.paramName,
                      params = Object.assign({}, packCfg.params),
                      method = packCfg.method || AjaxTransport.defaultMethod[config.type];
                  var requestConfig = Object.assign({
                    url: packCfg.url,
                    method: method,
                    params: params
                  }, packCfg.requestConfig); // if no param name specified then we'll transfer package in the request body

                  if (!paramName) {
                    // TODO: get rid of this legacy code in the next major release
                    // ..here we should simply make: requestConfig.body = pack
                    requestConfig.jsonData = pack; // ..otherwise we use parameter
                  } else {
                    requestConfig.params = requestConfig.params || {};
                    requestConfig.params[paramName] = pack;
                  }
                  /**
                   * Fires before a request is sent to the server.
                   *
                   * ```javascript
                   * crudManager.on('beforesend', function (crud, params, requestType) {
                   *     // let's set "sync" request parameters
                   *     if (requestType == 'sync') {
                   *         // dynamically depending on "flag" value
                   *         if (flag) {
                   *             params.foo = 'bar';
                   *         } else {
                   *             params.foo = 'smth';
                   *         }
                   *     }
                   * });
                   * ```
                   * @event beforesend
                   * @param {Scheduler.crud.AbstractCrudManager} crudManager The CRUD manager.
                   * @param {Object} params Request params
                   * @param {String} requestType Request type (`load`/`sync`)
                   * @param {Object} requestConfig Configuration object for Ajax request call
                   */


                  me.trigger('beforeSend', {
                    params: params,
                    type: config.type,
                    requestConfig: requestConfig,
                    config: config
                  });

                  var responseOptions = Object.assign({
                    method: method,
                    headers: requestConfig.headers,
                    queryParams: params,
                    body: method === 'HEAD' || method === 'GET' ? undefined : requestConfig.jsonData
                  }, requestConfig.fetchOptions),
                      ajaxPromise = _Common_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].fetch(requestConfig.url, responseOptions);

                  ajaxPromise.then(function (response) {
                    if (response.ok) {
                      config.success && config.success.call(config.thisObj || me, response, responseOptions);
                    } else {
                      config.failure && config.failure.call(config.thisObj || me, response, responseOptions);
                    }
                  });
                  return ajaxPromise;
                }
              }], [{
                key: "defaultMethod",

                /**
                 * Configuration of the AJAX requests used to communicate with a server-side.
                 * An object where you can set the following possible properties:
                 * @config {Object} transport
                 * @property {Object} transport.load Load requests configuration:
                 * @property {String} transport.load.url URL to request for data loading.
                 * @property {String} [transport.load.method='POST'] HTTP method to be used for load requests.
                 * @property {String} [transport.load.paramName] Name of parameter in which a packet will be transfered. If not specified then a packet will be transfered in a request body (default).
                 * @property {Object} [transport.load.params] Extra load request params if needed.
                 * @property {Object} [transport.load.requestConfig] Ajax request config. Can be used instead of above `url`, `method`, `params`:
                 *
                 * ```javascript
                 * transport   : {
                 *     load    : {
                 *         requestConfig : {
                 *             url             : 'http://some-url',
                 *             method          : 'GET',
                 *             // get rid of cache-buster parameter
                 *             disableCaching  : false,
                 *             // extra request parameters
                 *             params          : {
                 *                 foo         : 'bar'
                 *             },
                 *             // custom request headers
                 *             headers         : {
                 *                 ...
                 *             },
                 *             fetchOptions    : {
                 *                 credentials : 'include'
                 *             }
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @property {Object} transport.sync Sync requests configuration:
                 * @property {String} transport.sync.url URL to request for data persisting.
                 * @property {String} [transport.sync.method='POST'] HTTP method to be used for sync requests.
                 * @property {String} [transport.sync.paramName] Name of parameter in which a packet will be transfered. If not specified then a packet will be transfered in a request body (default).
                 * @property {Object} [transport.sync.params] Extra sync request params if needed.
                 * @property {Object} [transport.sync.requestConfig] Ajax request config. Can be used instead of above `url`, `method`, `params`:
                 *
                 * ```javascript
                 * transport   : {
                 *     sync    : {
                 *         requestConfig : {
                 *             url             : 'http://some-url',
                 *             method          : 'GET',
                 *             // get rid of cache-buster parameter
                 *             disableCaching  : false,
                 *             // extra request parameters
                 *             params          : {
                 *                 foo         : 'bar'
                 *             },
                 *             // custom request headers
                 *             headers         : {
                 *                 ...
                 *             }
                 *         }
                 *     }
                 * }
                 * ```
                 */
                get: function get() {
                  return {
                    load: 'GET',
                    sync: 'POST'
                  };
                }
              }]);

              return AjaxTransport;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/customElements/SchedulerTag.js":
      /*!******************************************************!*\
        !*** ./lib/Scheduler/customElements/SchedulerTag.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerCustomElementsSchedulerTagJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return SchedulerTag;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/assertThisInitialized */
        "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
        /* harmony import */


        var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _view_Scheduler_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../view/Scheduler.js */
        "./lib/Scheduler/view/Scheduler.js");
        /* harmony import */


        var _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");

        var productName = 'scheduler'; //TODO: If we want to improve on this, add settings as attributes, replace data-field with field etc.

        /**
         * @module Scheduler/customElements/SchedulerTag
         */

        /**
         * Import this file to be able to use the tag **&lt;bryntum-scheduler&gt;** to create a scheduler. This is more of a
         * proof of concept than a ready to use class. Dataset from **&lt;data&gt;** and **&lt;bryntum-scheduler&gt;** tags is
         * applied to record and scheduler config, which means, that you can pass any documented config there, not only
         * demonstrated here. Dataset attributes are translated as follows:
         *
         *  * data-view-preset -> viewPreset
         *  * data-start-date -> startDate
         *
         *  etc.
         * ## Example
         * ```
         * &lt;bryntum-scheduler data-view-preset="weekAndDay" data-start-date="2018-04-02" data-end-date="2018-04-09"&gt;
         *  &lt;column data-field="name"&gt;Name&lt;/column&gt;
         *      &lt;data&gt;
         *          &lt;events&gt;
         *              &lt;data data-id="1" data-resource-id="1" data-start-date="2018-04-03" data-end-date="2018-04-05"&gt;&lt;/data&gt;
         *              &lt;data data-id="2" data-resource-id="2" data-start-date="2018-04-04" data-end-date="2018-04-06"&gt;&lt;/data&gt;
         *              &lt;data data-id="3" data-resource-id="3" data-start-date="2018-04-05" data-end-date="2018-04-07"&gt;&lt;/data&gt;
         *          &lt;/events&gt;
         *          &lt;resources&gt;
         *              &lt;data data-id="1" data-name="Daniel"&gt;&lt;/data&gt;
         *              &lt;data data-id="2" data-name="Steven"&gt;&lt;/data&gt;
         *              &lt;data data-id="3" data-name="Sergei"&gt;&lt;/data&gt;
         *          &lt;/resources&gt;
         *      &lt;/data&gt;
         * &lt;/bryntum-scheduler&gt;
         * ```
         */
        // This is required to make trial build function normally

        var TagBase = window.customElements ? HTMLElement : Object;

        var SchedulerTag =
        /*#__PURE__*/
        function (_TagBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(SchedulerTag, _TagBase);

          function SchedulerTag() {
            var _this;

            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, SchedulerTag);

            _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(SchedulerTag).call(this));

            var me = _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_8___default()(_this)),
                columns = [],
                resources = [],
                events = []; // create columns and data


            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = me.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var tag = _step.value;

                if (tag.tagName === 'COLUMN') {
                  var width = parseInt(tag.dataset.width),
                      flex = parseInt(tag.dataset.flex),
                      column = {
                    field: tag.dataset.field,
                    text: tag.innerHTML
                  };
                  if (width) column.width = width;else if (flex) column.flex = flex;else column.flex = 1;
                  columns.push(column);
                } else if (tag.tagName === 'DATA') {
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = tag.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var storeType = _step2.value;
                      var _iteratorNormalCompletion3 = true;
                      var _didIteratorError3 = false;
                      var _iteratorError3 = undefined;

                      try {
                        for (var _iterator3 = storeType.children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                          var record = _step3.value;
                          var row = {};
                          Object.assign(row, record.dataset);

                          if (storeType.tagName === 'EVENTS') {
                            events.push(row);
                          } else if (storeType.tagName === 'RESOURCES') {
                            resources.push(row);
                          }
                        }
                      } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                          }
                        } finally {
                          if (_didIteratorError3) {
                            throw _iteratorError3;
                          }
                        }
                      }
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            var // go over to the dark side
            shadowRoot = _this.attachShadow({
              mode: 'open'
            }),
                // include css and target div in shadow dom
            link = document.createElement('link');

            link.rel = 'stylesheet';
            link.href = '../../build/scheduler.default.css';

            link.onload = function () {
              var div = document.createElement('div');
              div.id = 'container';
              div.style.width = '100%';
              div.style.height = '100%';
              shadowRoot.appendChild(div); // Listen to focus events on shadow root to handle focus inside the shadow dom

              Object(_Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_10__["setupFocusListeners"])(shadowRoot);
              var config = {
                appendTo: div,
                columns: columns,
                resources: resources,
                events: events
              };
              Object.assign(config, me.dataset); // render as usual

              var scheduler = new _view_Scheduler_js__WEBPACK_IMPORTED_MODULE_9__["default"](config); // for testing, set first scheduler as global variable

              if (!window.scheduler) window.scheduler = scheduler;
            };

            shadowRoot.appendChild(link);
            return _this;
          }

          return SchedulerTag;
        }(TagBase); // Try-catch to make trial work


        try {
          window.customElements && window.customElements.define('bryntum-scheduler', SchedulerTag);
        } catch (error) {}

        SchedulerTag._$name = 'SchedulerTag';
        /***/
      },

      /***/
      "./lib/Scheduler/data/AssignmentStore.js":
      /*!***********************************************!*\
        !*** ./lib/Scheduler/data/AssignmentStore.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataAssignmentStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return AssignmentStore;
        });
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../model/AssignmentModel.js */
        "./lib/Scheduler/model/AssignmentModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/AssignmentStore
         */

        /**
         * A class representing a collection of assignments between events in the {@link Scheduler.data.EventStore} and resources
         * in the {@link Scheduler.data.ResourceStore}.
         *
         * Contains a collection of {@link Scheduler.model.AssignmentModel} records.
         *
         * @extends Common/data/Store
         */

        var AssignmentStore =
        /*#__PURE__*/
        function (_AjaxStore) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(AssignmentStore, _AjaxStore);

          function AssignmentStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, AssignmentStore);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(AssignmentStore).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(AssignmentStore, [{
            key: "doDestroy",
            //region Init & destroy
            value: function doDestroy() {
              var me = this;
              me.eventStoreDetacher && me.eventStoreDetacher();
              me.resourceStoreDetacher && me.resourceStoreDetacher();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(AssignmentStore.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Stores

            /**
             * Get/set the associated event store instance.  Usually it is configured automatically, by the event store itself.
             *
             * @param {Scheduler.data.EventStore}
             */

          }, {
            key: "attachToEventStore",
            value: function attachToEventStore(eventStore) {
              var me = this;
              me.eventStoreDetacher && me.eventStoreDetacher();

              if (eventStore) {
                me.eventStoreDetacher = eventStore.on({
                  'remove': me.onEventRemove,
                  'resourcestorechange': me.onEventStoreResourceStoreChange,
                  thisObj: me,
                  prio: 200 // higher then in cache, we need those handlers to do their job before cache update

                });
              } // If store is assigned after configuration we need to init relations


              if (!me.isConfiguring) {
                me.initRelations(true);
              }

              me.attachToResourceStore(eventStore && eventStore.resourceStore);
            }
          }, {
            key: "attachToResourceStore",
            value: function attachToResourceStore(resourceStore) {
              var me = this;
              me.resourceStore = resourceStore;
              me.resourceStoreDetacher && me.resourceStoreDetacher();

              if (resourceStore) {
                me.resourceStoreDetacher = resourceStore.on({
                  remove: me.onResourceRemove,
                  removeAll: me.onResourceRemoveAll,
                  thisObj: me,
                  prio: 200 // higher then in cache

                }); // If store is assigned after configuration we need to init relations

                if (!me.isConfiguring) {
                  me.initRelations(true);
                }
              }
            }
          }, {
            key: "onEventStoreResourceStoreChange",
            value: function onEventStoreResourceStoreChange(_ref) {
              var newResourceStore = _ref.newResourceStore;
              this.attachToResourceStore(newResourceStore);
            } //endregion
            //region Event & resource events
            // TODO: We have no isMove in our stores

          }, {
            key: "onEventRemove",
            value: function onEventRemove(_ref2) {
              var records = _ref2.records,
                  isMove = _ref2.isMove,
                  isCollapse = _ref2.isCollapse;

              if (!isMove && !isCollapse) {
                var assignments = [];
                records.forEach(function (record) {
                  // traversing in a flat structure will only call fn on self, no need to handle tree case differently
                  record.traverse(function (eventRecord) {
                    assignments.push.apply(assignments, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(eventRecord.assignments));
                  });
                }); // Flag that remove is caused by removing events, to prevent getting stuck in removal loop in SchedulerStores

                this.isRemovingEvent = true;
                assignments.length && this.remove(assignments);
                this.isRemovingEvent = false;
              }
            } // TODO: We have no isMove in our stores

          }, {
            key: "onResourceRemove",
            value: function onResourceRemove(_ref3) {
              var records = _ref3.records,
                  isMove = _ref3.isMove,
                  isCollapse = _ref3.isCollapse;

              if (!isMove && !isCollapse) {
                var assignments = [];
                records.forEach(function (record) {
                  // traversing in a flat structure will only call fn on self, no need to handle tree case differently
                  record.traverse(function (resourceRecord) {
                    assignments.push.apply(assignments, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(resourceRecord.assignments));
                  });
                }); // TODO: Make resource removal behaviour configurable

                assignments.length && this.remove(assignments);
              }
            }
          }, {
            key: "onResourceRemoveAll",
            value: function onResourceRemoveAll() {
              // TODO: Make resource removal behaviour configurable
              this.removeAll();
            } //endregion
            //region Mapping

            /**
             * Maps over event assignments.
             *
             * @param {Scheduler.model.EventModel} event
             * @param {Function} [fn]
             * @param {Function} [filterFn]
             * @return {Array}
             */

          }, {
            key: "mapAssignmentsForEvent",
            value: function mapAssignmentsForEvent(event, fn, filterFn) {
              var me = this,
                  fnSet = Boolean(fn),
                  filterFnSet = Boolean(filterFn),
                  eventId = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_10__["default"].asId(event),
                  assignmentCache = me.relationCache.event && me.relationCache.event[eventId];

              if (!assignmentCache) return [];

              fn = fn || function (a) {
                return a;
              };

              filterFn = filterFn || function () {
                return true;
              };

              if (fnSet || filterFnSet) {
                return assignmentCache.reduce(function (result, assignment) {
                  var mapResult = fn(assignment);

                  if (filterFn(mapResult)) {
                    //result = result.concat([mapResult]);
                    result.push(mapResult);
                  }

                  return result;
                }, []);
              }

              return assignmentCache;
            }
            /**
             * Maps over resource assignments.
             *
             * @param {Scheduler.model.ResourceModel|Number|String} resource
             * @param {Function} [fn]
             * @param {Function} [filterFn]
             * @return {Scheduler.model.ResourceModel[]}
             */

          }, {
            key: "mapAssignmentsForResource",
            value: function mapAssignmentsForResource(resource, fn, filterFn) {
              var me = this,
                  fnSet = Boolean(fn),
                  filterFnSet = Boolean(filterFn),
                  resourceId = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_10__["default"].asId(resource),
                  assignmentCache = me.relationCache.resource && me.relationCache.resource[resourceId];

              if (!assignmentCache) return [];

              fn = fn || function (a) {
                return a;
              };

              filterFn = filterFn || function () {
                return true;
              };

              if (fnSet || filterFnSet) {
                return assignmentCache.reduce(function (result, assignment) {
                  var mapResult = fn(assignment);

                  if (filterFn(mapResult)) {
                    //result = result.concat([mapResult]);
                    result.push(mapResult);
                  }

                  return result;
                }, []);
              }

              return assignmentCache;
            }
            /**
             * Returns all assignments for a given event.
             *
             * @param {Scheduler.model.TimeSpan} event
             * @return {Scheduler.model.AssignmentModel[]}
             */

          }, {
            key: "getAssignmentsForEvent",
            value: function getAssignmentsForEvent(event) {
              return event.assignments;
            }
            /**
             * Removes all assignments for given event
             *
             * @param {Scheduler.model.TimeSpan|Object} event
             */

          }, {
            key: "removeAssignmentsForEvent",
            value: function removeAssignmentsForEvent(event) {
              return this.remove(event.assignments);
            }
            /**
             * Returns all assignments for a given resource.
             *
             * @param {Scheduler.model.ResourceModel|Object} event
             * @return {Scheduler.model.TimeSpan[]}
             */

          }, {
            key: "getAssignmentsForResource",
            value: function getAssignmentsForResource(resource) {
              return this.mapAssignmentsForResource(resource);
            }
            /**
             * Removes all assignments for given resource
             *
             * @param {Scheduler.model.ResourceModel|*} resource
             */

          }, {
            key: "removeAssignmentsForResource",
            value: function removeAssignmentsForResource(resource) {
              this.remove(this.getAssignmentsForResource(resource));
            }
            /**
             * Returns all resources assigned to an event.
             *
             * @param {Scheduler.model.EventModel} event
             * @return {Scheduler.model.ResourceModel[]}
             */

          }, {
            key: "getResourcesForEvent",
            value: function getResourcesForEvent(event) {
              var me = this; // TODO: cache event -> resource
              //if (!me.relationCache.events) return []; //return me.eventResourceCache.get(event);

              return me.mapAssignmentsForEvent(event, function (assignment) {
                return assignment.resource;
              }, function (resource) {
                return Boolean(resource);
              });
            }
            /**
             * Returns all events assigned to a resource
             *
             * @param {Scheduler.model.ResourceModel|*} resource
             * @return {Scheduler.model.TimeSpan[]}
             */

          }, {
            key: "getEventsForResource",
            value: function getEventsForResource(resource) {
              var me = this; //if (me.resourceEventsCache) return me.resourceEventsCache.get(resource);

              return me.mapAssignmentsForResource(resource, function (assignment) {
                return assignment.event;
              }, function (event) {
                return !!event;
              });
            }
            /**
             * Creates and adds assignment record(s) for a given event and resource.
             *
             * @param {Scheduler.model.TimeSpan|*} event
             * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} resource The resource(s) to assign to the event
             * @privateparam {Function} [assignmentSetupFn]
             * @privateparam {Boolean} [removeExistingAssignments] true to first remove existing assignments
             * @return {Scheduler.model.AssignmentModel[]} An array with the created assignment(s)
             */

          }, {
            key: "assignEventToResource",
            value: function assignEventToResource(event, resource) {
              var assignmentSetupFn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (o) {
                return o;
              };
              var removeExistingAssignments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var me = this,
                  resources = Array.isArray(resource) ? resource : [resource];
              var assignments = [];
              me.beginBatch();

              if (removeExistingAssignments) {
                me.removeAssignmentsForEvent(event);
              }

              resources.forEach(function (resource) {
                if (!me.isEventAssignedToResource(event, resource)) {
                  var assignment = new me.modelClass({
                    eventId: _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_10__["default"].asId(event),
                    resourceId: _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_10__["default"].asId(resource)
                  });
                  assignment = assignmentSetupFn(assignment);
                  assignments.push(assignment);
                }
              });
              assignments = me.add(assignments);
              me.endBatch();
              return assignments;
            }
            /**
             * Removes assignment record for a given event and resource.
             *
             * @param {Scheduler.model.TimeSpan|String|Number} event
             * @param {Scheduler.model.ResourceModel|String|Number} [resource] The resource to unassign the event from. If omitted, all resources of the events will be unassigned
             * @return {Scheduler.model.AssignmentModel|Scheduler.model.AssignmentModel[]}
             */

          }, {
            key: "unassignEventFromResource",
            value: function unassignEventFromResource(event, resource) {
              var me = this;
              if (!resource) return me.removeAssignmentsForEvent(event);

              if (me.isEventAssignedToResource(event, resource)) {
                var assignment = me.getAssignmentForEventAndResource(event, resource);
                me.remove(assignment);
                return assignment;
              }

              return null;
            }
            /**
             * Checks whether an event is assigned to a resource.
             *
             * @param {Scheduler.model.EventModel|String|Number} event Event record or id
             * @param {Scheduler.model.ResourceModel|String|Number} resource Resource record or id
             * @return {Boolean}
             */

          }, {
            key: "isEventAssignedToResource",
            value: function isEventAssignedToResource(event, resource) {
              var me = this,
                  records = me.getResourcesForEvent(event),
                  resourceId = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_10__["default"].asId(resource); // noinspection EqualityComparisonWithCoercionJS


              return records.some(function (res) {
                return res.id == resourceId;
              });
            }
            /**
             * Returns an assignment record for a given event and resource
             *
             * @param {Scheduler.model.EventModel|String|Number} event The event or its id
             * @param {Scheduler.model.ResourceModel|String|Number} resource The resource or its id
             * @return {Scheduler.model.AssignmentModel}
             */

          }, {
            key: "getAssignmentForEventAndResource",
            value: function getAssignmentForEventAndResource(event, resource) {
              var me = this;
              event = me.eventStore.getById(event);
              resource = me.resourceStore.getById(resource); //const key = me.modelClass.makeAssignmentEventResourceCompositeKey(event, resource);
              //TODO: PORT key map
              //return me.records.find(a => key == me.modelClass.makeAssignmentEventResourceCompositeKey(a.eventId, a.resourceId));
              // noinspection EqualityComparisonWithCoercionJS

              return me.records.find(function (assignment) {
                return assignment.event == event && assignment.resource == resource;
              });
            } //endregion

          }, {
            key: "eventStore",
            get: function get() {
              return this._eventStore;
            },
            set: function set(eventStore) {
              var me = this,
                  oldStore = me._eventStore;
              me._eventStore = eventStore || null;
              me.attachToEventStore(me._eventStore);

              if ((oldStore || eventStore) && oldStore !== eventStore) {
                /**
                 * Fires when new event store is set via {@link #property-eventStore} method.
                 * @event eventstorechange
                 * @param {Scheduler.data.AssignmentStore} this
                 * @param {Scheduler.data.EventStore} newEventStore
                 * @param {Scheduler.data.EventStore} oldEventStore
                 */
                me.trigger('eventStoreChange', {
                  newEventStore: eventStore,
                  oldEventStore: oldStore
                });
              }
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * CrudManager must load stores in the correct order. Lowest first.
                 * @private
                 */
                loadPriority: 300,

                /**
                 * CrudManager must sync stores in the correct order. Lowest first.
                 * @private
                 */
                syncPriority: 300,
                modelClass: _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_11__["default"]
              };
            }
          }]);

          return AssignmentStore;
        }(_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        AssignmentStore._$name = 'AssignmentStore';
        /***/
      },

      /***/
      "./lib/Scheduler/data/Calendar.js":
      /*!****************************************!*\
        !*** ./lib/Scheduler/data/Calendar.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataCalendarJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Calendar;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _model_CalendarDayModel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../model/CalendarDayModel.js */
        "./lib/Scheduler/model/CalendarDayModel.js");
        /* harmony import */


        var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../model/TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/Calendar
         */

        /**
         * A class representing a customizable calendar with weekends, holidays and availability information for any day.
         * Internally, it's just a subclass of the AjaxStore class which should be loaded with a collection
         * of {@link Scheduler.model.CalendarDayModel} instances. Additionally, calendars may have parent-child relations,
         * allowing "child" calendars to "inherit" all special dates from its "parent" and add its own.
         * See {@link #property-parent} property for details.
         *
         * A calendar can be instantiated like this:
         * ```
         * let calendar = new Scheduler.data.Calendar({
         *     data : [
         *         {
         *             date            : new Date(2010, 0, 13),
         *             cls             : 'national-holiday'
         *         },
         *         {
         *             date            : new Date(2010, 1, 1),
         *             cls             : 'company-holiday'
         *         },
         *         {
         *             date            : new Date(2010, 0, 16),
         *             isWorkingDay    : true
         *         }
         *     ]
         * });
         * ```
         * Please refer to the {@link Scheduler.model.CalendarDayModel} class to learn the data model used for the calendar.
         */

        var Calendar =
        /*#__PURE__*/
        function (_AjaxStore) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(Calendar, _AjaxStore);

          function Calendar() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, Calendar);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Calendar).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(Calendar, [{
            key: "construct",
            value: function construct(config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Calendar.prototype), "construct", this).call(this, config); // TODO: This will be from static get properties() when https://app.assembla.com/spaces/bryntum/tickets/5165 is done


              me.unitsInMs = {
                MILLI: 1,
                SECOND: 1000,
                MINUTE: 60 * 1000,
                HOUR: 60 * 60 * 1000,
                DAY: me.hoursPerDay * 60 * 60 * 1000,
                WEEK: me.daysPerWeek * me.hoursPerDay * 60 * 60 * 1000,
                MONTH: me.daysPerMonth * me.hoursPerDay * 60 * 60 * 1000,
                QUARTER: 3 * me.daysPerMonth * 24 * 60 * 60 * 1000,
                YEAR: 4 * 3 * me.daysPerMonth * 24 * 60 * 60 * 1000
              };
              me.defaultWeekAvailability = me.getDefaultWeekAvailability(); // traditional "on-demand" caching seems to be not so efficient for calendar (in theory)
              // calculating any cached property, like, "weekAvailability" or "nonStandardWeeksStartDates" will require full calendar scan each time
              // so we update ALL cached values on any CRUD operations

              me.on({
                // TODO ignore changes of "name/cls" field?
                change: me.clearCache,
                thisObj: me
              });
              me.clearCache();
            }
            /**
             * Returns the registered calendar with the given id.
             *
             * @param {String} id The calendar id
             * @return {Scheduler.data.Calendar}
             */

          }, {
            key: "getDefaultWeekAvailability",
            value: function getDefaultWeekAvailability() {
              var availability = this.defaultAvailability,
                  weekendFirstDay = this.weekendFirstDay,
                  weekendSecondDay = this.weekendSecondDay,
                  res = [];

              for (var i = 0; i < 7; i++) {
                res.push(this.weekendsAreWorkdays || i != weekendFirstDay && i != weekendSecondDay ? new this.modelClass({
                  type: 'WEEKDAY',
                  weekday: i,
                  availability: availability && availability.slice() || [],
                  isWorkingDay: true
                }) : new this.modelClass({
                  type: 'WEEKDAY',
                  weekday: i,
                  availability: []
                }));
              }

              return res;
            }
            /**
             * Destroys all registered calendars.
             *
             * @return {Scheduler.data.Calendar[]}
             */

          }, {
            key: "removeAll",
            value: function removeAll() {
              Calendar.allCalendars.forEach(function (calendar) {
                calendar.storeId = null; //unregisters from Store map

                calendar.destroy();
              });
            }
            /**
             * Returns `true` or `false` depending whether the given time span intersects with one of the defined week day overrides.
             *
             * @param {Date} startDate The start date of the time span
             * @param {Date} endDate The end date of the time span
             *
             * @return {Boolean}
             */

          }, {
            key: "intersectsWithCurrentWeeks",
            value: function intersectsWithCurrentWeeks(startDate, endDate) {
              var result = false;
              this.forEachNonStandardWeek(function (week) {
                var weekStartDate = week.startDate,
                    weekEndDate = week.endDate;

                if (weekStartDate <= startDate && startDate < weekEndDate || weekStartDate < endDate && endDate <= weekEndDate) {
                  result = true; // stop the iteration

                  return false;
                }
              });
              return result;
            } // will scan through all calendar days in the store and save references to special ones to the properties, for speedup

          }, {
            key: "clearCache",
            value: function clearCache() {
              var me = this;
              if (me.suspendCacheUpdate > 0) return;
              me.holidaysCache = {};
              me.availabilityIntervalsCache = {};
              var daysIndex = me.daysIndex = {},
                  weekAvailability = me.weekAvailability = [],
                  nonStandardWeeksStartDates = me.nonStandardWeeksStartDates = [],
                  nonStandardWeeksByStartDate = me.nonStandardWeeksByStartDate = {};
              me.forEach(function (calendarDay) {
                // backward compat
                var id = calendarDay.id,
                    overrideMatch = /^(\d)-(\d\d\d\d\/\d\d\/\d\d)-(\d\d\d\d\/\d\d\/\d\d)$/.exec(id),
                    weekDayMatch = /^WEEKDAY:(\d+)$/.exec(id),
                    type = calendarDay.type,
                    weekDay = calendarDay.weekday;

                if (type == 'WEEKDAYOVERRIDE' || overrideMatch) {
                  var startDate, endDate;

                  if (type == 'WEEKDAYOVERRIDE') {
                    startDate = calendarDay.overrideStartDate;
                    endDate = calendarDay.overrideEndDate;
                  } // backward compat


                  if (overrideMatch) {
                    startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parse(overrideMatch[2], 'YYYY/MM/DD');
                    endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].parse(overrideMatch[3], 'YYYY/MM/DD');
                    weekDay = overrideMatch[1];
                  } // allow partially defined days - they will not be included in calculations


                  if (startDate && endDate && weekDay != null) {
                    var startDateNum = startDate - 0;

                    if (!nonStandardWeeksByStartDate[startDateNum]) {
                      nonStandardWeeksByStartDate[startDateNum] = {
                        startDate: new Date(startDate),
                        endDate: new Date(endDate),
                        name: calendarDay.getName(),
                        weekAvailability: [],
                        // main day representing the week override itself - for example for overrides w/o any re-defined availability
                        mainDay: null
                      };
                      nonStandardWeeksStartDates.push(startDateNum);
                    }

                    if (weekDay >= 0) {
                      nonStandardWeeksByStartDate[startDateNum].weekAvailability[weekDay] = calendarDay;
                    } else {
                      nonStandardWeeksByStartDate[startDateNum].mainDay = calendarDay;
                    }
                  }
                } else if (type == 'WEEKDAY' || weekDayMatch) {
                  if (weekDayMatch) weekDay = weekDayMatch[1]; // again - only fully defined records will be taken into account

                  if (weekDay != null) {
                    if (weekDay < 0 || weekDay > 6) {
                      throw new Error('Incorrect week day index');
                    }

                    weekAvailability[weekDay] = calendarDay;
                  }
                } else {
                  var date = calendarDay.date;
                  if (date) daysIndex[date - 0] = calendarDay;
                }
              }); // Numeric sort, can't use default JS sort which is string based

              nonStandardWeeksStartDates.sort(function (a, b) {
                return a - b;
              });
              /**
               * Triggered on changes to the calendar.
               * @event calendarChange
               * @param {Scheduler.data.Calendar} source
               */

              me.trigger('calendarChange');
            }
            /**
             * Adds a week day override ("non-standard" week) to the calendar. As a reminder, week day override consists from up to 7 days,
             * that re-defines the default week days availability only within certain time span.
             *
             * @param {Date} startDate The start date of the time span
             * @param {Date} endDate The end date of the time span
             * @param {Scheduler.model.CalendarDayModel[]|String[]} weekAvailability The array indexed from 0 to 7, containing items for week days.
             * Index 0 corresponds to Sunday, 1 to Monday, etc. Some items can be not defined or set to `null`, indicating that override does not
             * change this week day. Item can be - an instance of {@link Scheduler.model.CalendarDayModel} (only `Availability` field needs to be set), or
             * an array of strings, defining the availability (see the description of the `Availability` field in the {@link Scheduler.model.CalendarDayModel}).
             * @param {String} name The name of this week day override
             */

          }, {
            key: "addNonStandardWeek",
            value: function addNonStandardWeek(startDate, endDate, weekAvailability, name) {
              startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(startDate);
              endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(endDate);

              if (this.intersectsWithCurrentWeeks(startDate, endDate)) {
                throw new Error('Can not add intersecting week');
              }

              var DayModel = this.modelClass,
                  days = [];
              weekAvailability.forEach(function (day, index) {
                if (day instanceof _model_CalendarDayModel_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
                  day.type = 'WEEKDAYOVERRIDE';
                  day.overrideStartDate = startDate;
                  day.overrideEndDate = endDate;
                  day.weekday = index;
                  day.name = name || 'Week override';
                  days.push(day);
                } else if (Array.isArray(day)) {
                  var newDay = new DayModel();
                  newDay.type = 'WEEKDAYOVERRIDE';
                  newDay.overrideStartDate = startDate;
                  newDay.overrideEndDate = endDate;
                  newDay.weekday = index;
                  newDay.name = name || 'Week override';
                  newDay.setAvailability(day);
                  days.push(newDay);
                }
              });
              var mainDay = new DayModel();
              mainDay.type = 'WEEKDAYOVERRIDE';
              mainDay.overrideStartDate = startDate;
              mainDay.overrideEndDate = endDate;
              mainDay.weekday = -1;
              mainDay.name = name || 'Week override';
              days.push(mainDay);
              this.add(days);
            }
            /**
             * Returns an object describing a week day override ("non-standard" week), that starts at the given date or `null` if there's no any.
             *
             * @param {Date} startDate The start date of the week day override
             *
             * @return {Object} An object with the following properties
             * @return {Object} return.name A "Name" field of the week days in the override
             * @return {Date} return.startDate An "OverrideStartDate" field of the week days in the override
             * @return {Date} return.endDate An "OverrideEndDate" field of the week days in the override
             * @return {Scheduler.model.CalendarDayModel[]} return.weekAvailability An array with the week days, defined by this override. May be filled only partially if
             * week day override does not contain all days.
             * @return {Scheduler.model.CalendarDayModel} return.mainDay A "main" day instance for this override
             */

          }, {
            key: "getNonStandardWeekByStartDate",
            value: function getNonStandardWeekByStartDate(startDate) {
              return this.nonStandardWeeksByStartDate[_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(startDate) - 0] || null;
            }
            /**
             * Removes all calendar day instances, that forms a week day override ("non-standard" week) with the given start date.
             *
             * @param {Date} startDate The start date of the week day override
             */

          }, {
            key: "removeNonStandardWeek",
            value: function removeNonStandardWeek(startDate) {
              startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(startDate) - 0;
              var week = this.getNonStandardWeekByStartDate(startDate);
              if (!week) return;
              this.remove(_Common_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].clean(week.weekAvailability).concat(week.mainDay));
            }
            /**
             * Returns an object describing a week day override ("non-standard" week), that contains the given date or `null` if there's no any.
             *
             * @param {Date} timeDate The date that falls within some of the week day overrides
             *
             * @return {Object} An object describing week day override. See {@link #function-getNonStandardWeekByStartDate} method for details.
             */

          }, {
            key: "getNonStandardWeekByDate",
            value: function getNonStandardWeekByDate(timeDate) {
              timeDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(timeDate) - 0;
              var nonStandardWeeksStartDates = this.nonStandardWeeksStartDates,
                  nonStandardWeeksByStartDate = this.nonStandardWeeksByStartDate;

              for (var i = 0; i < nonStandardWeeksStartDates.length; i++) {
                var week = nonStandardWeeksByStartDate[nonStandardWeeksStartDates[i]]; // since `nonStandardWeeksStartDates` are sorted inc and week overrides do not intersect
                // we can shorcut in this case

                if (week.startDate > timeDate) break;

                if (week.startDate <= timeDate && timeDate <= week.endDate) {
                  return week;
                }
              }

              return null;
            }
            /**
             * Updates the default availability information based on the value provided.
             *
             * @param {Boolean} value true if weekends should be regarded as working time.
             */

          }, {
            key: "setWeekendsAreWorkDays",
            value: function setWeekendsAreWorkDays(value) {
              var me = this;

              if (value !== me.weekendsAreWorkdays) {
                me.weekendsAreWorkdays = value; // Must generate new defaultWeekAvailability

                me.defaultWeekAvailability = me.getDefaultWeekAvailability();
                me.clearCache();
              }
            }
            /**
             * Returns true if weekends are regarded as working time.
             *
             * @return {Boolean} true if weekends should be regarded as working time.
             */

          }, {
            key: "areWeekendsWorkDays",
            value: function areWeekendsWorkDays() {
              return this.weekendsAreWorkdays;
            }
            /**
             * Iterator for each week day override, defined in this calendar.
             *
             * @param {Function} func The function to call for each override. It will receive a single argument - object, describing the override.
             * See {@link #function-getNonStandardWeekByStartDate} for details. Returning `false` from the function stops the iterator.
             * @param {Object} thisObj `this` reference for the function
             *
             * @return {Boolean} `false` if any of the function calls have returned `false`
             */

          }, {
            key: "forEachNonStandardWeek",
            value: function forEachNonStandardWeek(func, thisObj) {
              var me = this,
                  nonStandardWeeksStartDates = this.nonStandardWeeksStartDates,
                  nonStandardWeeksByStartDate = this.nonStandardWeeksByStartDate;

              for (var i = 0; i < nonStandardWeeksStartDates.length; i++) {
                if (func.call(thisObj || me, nonStandardWeeksByStartDate[nonStandardWeeksStartDates[i]]) === false) return false;
              }
            }
            /**
             * Returns a corresponding {@link Scheduler.model.CalendarDayModel} instance for the given date. First, this method checks for {@link #function-getOverrideDay day overrides}
             * (either in this or parent calendars), then for week days (again, in this or parent calendars) and finally fallbacks to the
             * calendar day with the {@link #config-defaultAvailability} availability.
             *
             * @param {Date} timeDate A date (can contain time portion which will be ignored)
             *
             * @return {Scheduler.model.CalendarDayModel}
             */

          }, {
            key: "getCalendarDay",
            value: function getCalendarDay(timeDate) {
              timeDate = typeof timeDate == 'number' ? new Date(timeDate) : timeDate;
              return this.getOverrideDay(timeDate) || this.getWeekDay(timeDate.getDay(), timeDate) || this.getDefaultCalendarDay(timeDate.getDay());
            }
            /**
             * Returns a day override corresponding to the given date (possibly found in the parent calendars) or `null` if the given date
             * has no overrides in this calendar and all its parents.
             *
             * @param {Date} timeDate The date to check for day overrides for
             * @return {Scheduler.model.CalendarDayModel}
             */

          }, {
            key: "getOverrideDay",
            value: function getOverrideDay(timeDate) {
              return this.getOwnCalendarDay(timeDate) || this.parent && this.parent.getOverrideDay(timeDate) || null;
            }
            /**
             * Returns an "own" day override corresponding to the given date. That is - day override defined in the current calendar only.
             *
             * @param {Date} timeDate The date to check for day overrides for
             * @return {Scheduler.model.CalendarDayModel}
             */

          }, {
            key: "getOwnCalendarDay",
            value: function getOwnCalendarDay(timeDate) {
              timeDate = typeof timeDate == 'number' ? new Date(timeDate) : timeDate;
              return this.daysIndex[_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(timeDate) - 0];
            }
            /**
             * Returns a "special" week day corresponding to the given date. Under "special" week day we mean a calendar day with the `Type = WEEKDAY` or `WEEKDAYOVERRIDE`.
             * See the {@link Scheduler.model.CalendarDayModel} class for details. If the concrete date is given as 2nd argument, this method will
             * first check for any week overrides passing on it.
             *
             * If not found in current calendar, this method will consult parent. If no "special" week day found neither in this calendar, no parents - it returns `null`.
             *
             * @param {Number} weekDayIndex The index of the week day to retrieve (0-Sunday, 1-Monday, etc)
             * @param {Date} [timeDate] The date for which the week day is being retrieved.
             * @return {Scheduler.model.CalendarDayModel}
             */

          }, {
            key: "getWeekDay",
            value: function getWeekDay(weekDayIndex, timeDate) {
              // if 2nd argument is provided then try to search in non-standard weeks first
              if (timeDate) {
                var week = this.getNonStandardWeekByDate(timeDate);
                if (week && week.weekAvailability[weekDayIndex]) return week.weekAvailability[weekDayIndex];
              }

              return this.weekAvailability[weekDayIndex] || this.parent && this.parent.getWeekDay(weekDayIndex, timeDate) || null;
            }
            /**
             * Returns a boolean indicating whether a passed date falls on the weekend or holiday.
             *
             * @param {Date} timeDate A given date (can contain time portion)
             *
             * @return {Boolean}
             */

          }, {
            key: "isHoliday",
            value: function isHoliday(timeDate) {
              var secondsSinceEpoch = timeDate - 0,
                  holidaysCache = this.holidaysCache;

              if (holidaysCache[secondsSinceEpoch] != null) {
                return holidaysCache[secondsSinceEpoch];
              }

              timeDate = typeof timeDate == 'number' ? new Date(timeDate) : timeDate;
              var day = this.getCalendarDay(timeDate);
              if (!day) throw new Error("Can't find day for " + timeDate);
              return holidaysCache[secondsSinceEpoch] = !day.isWorkingDay;
            }
            /**
             * Returns a "default" calendar day instance, corresponding to the one, generated from {@link #config-defaultAvailability}. By default all working days in the week
             * corresponds to the day with {@link #config-defaultAvailability} set in the `Availability` field and non-working days has empty `Availability`.
             *
             * @param {Number} weekDayIndex The index of the "default" week day to retrieve (0-Sunday, 1-Monday, etc)
             * @return {Scheduler.model.CalendarDayModel}
             */

          }, {
            key: "getDefaultCalendarDay",
            value: function getDefaultCalendarDay(weekDayIndex) {
              if (!this.hasOwnProperty('defaultAvailability') && !this.hasOwnProperty('weekendsAreWorkdays') && this.parent) {
                return this.parent.getDefaultCalendarDay(weekDayIndex);
              }

              return this.defaultWeekAvailability[weekDayIndex];
            }
            /**
             * Returns a boolean indicating whether a passed date is a working day.
             *
             * @param {Date} date A given date (can contain time portion which will be ignored)
             *
             * @return {Boolean}
             */

          }, {
            key: "isWorkingDay",
            value: function isWorkingDay(date) {
              return !this.isHoliday(date);
            }
            /**
             * Returns `true` if given date passes on the weekend and `false` otherwise. Weekend days can be re-defined with the {@link #config-weekendFirstDay} and {@link #config-weekendSecondDay} options.
             *
             * @param {Date} timeDate The date to check
             * @return {Boolean}
             */

          }, {
            key: "isWeekend",
            value: function isWeekend(timeDate) {
              var dayIndex = timeDate.getDay();
              return dayIndex === this.weekendFirstDay || dayIndex === this.weekendSecondDay;
            }
            /**
             * Convert the duration given in milliseconds to a given unit. Uses the {@link #config-daysPerMonth} configuration option.
             *
             * @param {Number} durationInMs Duration in milliseconds
             * @param {String} unit Duration unit to which the duration should be converted
             *
             * @return {Number} converted value
             */

          }, {
            key: "convertMSDurationToUnit",
            value: function convertMSDurationToUnit(durationInMs, unit) {
              return durationInMs / this.unitsInMs[_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getUnitByName(unit)];
            }
            /**
             * Convert the duration given in some unit to milliseconds. Uses the {@link #config-daysPerMonth} configuration option.
             *
             * @param {Number} durationInMs
             * @param {String} unit
             *
             * @return {Number} converted value
             */

          }, {
            key: "convertDurationToMs",
            value: function convertDurationToMs(duration, unit) {
              return duration * this.unitsInMs[_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getUnitByName(unit)];
            }
            /**
             * This an iterator that passes through the all availability intervals (working time intervals) in the given date range.
             *
             * For example if the default availability in this calendar is [ '09:00-13:00', '14:00-18:00' ] and this function is called, like this:
             *
             *      calendar.forEachAvailabilityInterval(
             *           //             midnight  Friday                 midnight Tuesday
             *          { startDate : new Date(2013, 1, 8), endDate : new Date(2013, 1, 12) },
             *          function (startDate, endDate) { ... }
             *      )
             * then the provided function will be called 4 times with the following arguments:
             *
             *      startDate : new Date(2013, 1, 8, 9),    endDate : new Date(2013, 1, 8, 13)
             *      startDate : new Date(2013, 1, 8, 14),   endDate : new Date(2013, 1, 8, 18)
             *      startDate : new Date(2013, 1, 11, 9),   endDate : new Date(2013, 1, 11, 13)
             *      startDate : new Date(2013, 1, 11, 14),  endDate : new Date(2013, 1, 11, 18)
             *
             *
             * @param {Object} options An object with the following properties:
             * @param {Date} options.startDate A start date of the date range. Can be omitted, if `isForward` flag is set to `false`. In this case iterator
             * will not stop until the call to `func` will return `false`.
             * @param {Date} options.endDate An end date of the date range. Can be omitted, if `isForward` flag is set to `true`. In this case iterator
             * will not stop until the call to `func` will return `false`.
             * @param {Boolean} [options.isForward=true] A flag, defining the direction, this iterator advances in. If set to `true` iterations
             * will start from the `startDate` option and will advance in date increasing direction. If set to `false` iterations will start from the `endDate`
             * option and will advance in date decreasing direction.
             * @param {Function} func A function to call for each availability interval, in the given date range. It receives 2 arguments - the start date
             * of the availability interval and the end date.
             * @param {Object} thisObj `this` reference for the function
             *
             * @return {Boolean} `false` if any of the calls to `func` has returned `false`
             */

          }, {
            key: "forEachAvailabilityInterval",
            value: function forEachAvailabilityInterval(options, func, thisObj) {
              thisObj = thisObj || this;
              var me = this,
                  startDate = options.startDate,
                  endDate = options.endDate,
                  // isForward by default
              isForward = options.isForward !== false;

              if (isForward ? !startDate : !endDate) {
                throw new Error('At least `startDate` or `endDate` is required, depending from the `isForward` option');
              }

              var cursorDate = new Date(isForward ? startDate : endDate),
                  DATE = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"]; // if no boundary we still have to specify some limit

              if (isForward) {
                if (!endDate) {
                  endDate = DATE.add(startDate, options.availabilitySearchLimit || me.availabilitySearchLimit || 5 * 365, 'day');
                }
              } else {
                if (!startDate) {
                  startDate = DATE.add(endDate, -(options.availabilitySearchLimit || me.availabilitySearchLimit || 5 * 365), 'day');
                }
              } // the clearTime() method is called a lot during this method (like 200k times for 2k tasks project)
              // sometimes w/o real need for it since we always advance to the next day's boundary
              // this optimization brings it down to ~10k, ~10% speed up


              var noNeedToClearTime = false;

              while (isForward ? cursorDate < endDate : cursorDate > startDate) {
                // - 1 for backward direction ensures that we are checking correct day,
                // since the endDate is not inclusive - 02/10/2012 means the end of 02/09/2012
                // for backward direction we always clear time, because intervals are cached by the beginning of the day
                var intervals = me.getAvailabilityIntervalsFor(cursorDate - (isForward ? 0 : 1), isForward ? noNeedToClearTime : false); // the order of processing is different for forward / backward processing

                for (var i = isForward ? 0 : intervals.length - 1; isForward ? i < intervals.length : i >= 0; isForward ? i++ : i--) {
                  var interval = intervals[i],
                      intervalStartDate = interval.startDate,
                      intervalEndDate = interval.endDate; // availability interval is out of [ startDate, endDate )

                  if (intervalStartDate >= endDate || intervalEndDate <= startDate) continue;
                  var countingFrom = intervalStartDate < startDate ? startDate : intervalStartDate,
                      countingTill = intervalEndDate > endDate ? endDate : intervalEndDate;
                  if (func.call(thisObj, countingFrom, countingTill) === false) return false;
                }

                cursorDate = isForward ? DATE.getStartOfNextDay(cursorDate, false, noNeedToClearTime) : DATE.getEndOfPreviousDay(cursorDate, noNeedToClearTime);
                noNeedToClearTime = true;
              }
            }
            /**
             * Calculate the duration in the given `unit` between 2 dates, taking into account the availability/holidays information (non-working time will be excluded from the duration).
             *
             * @param {Date} startDate The start date
             * @param {Date} endDate The end date
             * @param {String} unit One of the units used by DateHelper
             *
             * @return {Number} Working time duration between given dates.
             */

          }, {
            key: "calculateDuration",
            value: function calculateDuration(startDate, endDate, unit) {
              var duration = 0;
              this.forEachAvailabilityInterval({
                startDate: startDate,
                endDate: endDate
              }, function (intervalStartDate, intervalEndDate) {
                var dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();
                duration += intervalEndDate - intervalStartDate + dstDiff * 60 * 1000;
              });
              return this.convertMSDurationToUnit(duration, unit);
            }
            /**
             * Returns an array of ranges for non-working days between `startDate` and `endDate`. For example normally, given a
             * full month, it will return an array of 4 `Scheduler.model.TimeSpan` instances, containing ranges for the
             * weekends. If a holiday lasts for several days and all {@link Scheduler.model.CalendarDayModel} instances have
             * the same `cls` value then all days will be combined into a single range.
             *
             * @param {Date} startDate - A start date of the timeframe to extract the holidays from
             * @param {Date} endDate - An end date of the timeframe to extract the holidays from
             *
             * @return {Scheduler.model.TimeSpan[]}
             */

          }, {
            key: "getHolidaysRanges",
            value: function getHolidaysRanges(startDate, endDate, includeWeekends) {
              if (startDate > endDate) {
                throw new Error("startDate can't be bigger than endDate");
              }

              startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(startDate);
              endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(endDate);
              var ranges = [],
                  currentRange,
                  date;

              for (date = startDate; date < endDate; date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getNext(date, 'day', 1)) {
                if (this.isHoliday(date) || this.weekendsAreWorkdays && includeWeekends && this.isWeekend(date)) {
                  var day = this.getCalendarDay(date),
                      cssClass = day && day.cls || this.defaultNonWorkingTimeCssCls,
                      nextDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getNext(date, 'day', 1); // starts new range


                  if (!currentRange) {
                    currentRange = new _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
                      startDate: date,
                      endDate: nextDate,
                      cls: cssClass
                    });
                  } else {
                    // checks if the range is still the same
                    if (currentRange.cls.isEqual(cssClass)) {
                      currentRange.endDate = nextDate;
                    } else {
                      ranges.push(currentRange);
                      currentRange = new _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
                        startDate: date,
                        endDate: nextDate,
                        cls: cssClass
                      });
                    }
                  }
                } else {
                  if (currentRange) {
                    ranges.push(currentRange);
                    currentRange = null;
                  }
                }
              }

              if (currentRange) {
                ranges.push(currentRange);
              }

              return ranges;
            }
            /**
             * Calculate the end date for the given start date and duration, taking into account the availability/holidays information (non-working time will not be counted as duration).
             *
             * @param {Date} startDate The start date
             * @param {Number} duration The "pure" duration (w/o any non-working time).
             * @param {String} unit One of the units of the {@link Common.helper.DateHelper} class.
             *
             * @return {Date} The end date
             */

          }, {
            key: "calculateEndDate",
            value: function calculateEndDate(startDate, duration, unit) {
              // if duration is 0 - return the same date
              if (!duration) {
                return new Date(startDate);
              }

              var DATE = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"],
                  endDate;
              duration = this.convertDurationToMs(duration, unit);
              var startFrom = // milestone case, which we don't want to re-schedule to the next business days
              // milestones should start/end in the same day as its incoming dependency
              duration === 0 && DATE.clearTime(startDate, true) - startDate === 0 ? DATE.add(startDate, -1, 'day') : startDate;
              this.forEachAvailabilityInterval({
                startDate: startFrom
              }, function (intervalStartDate, intervalEndDate) {
                var diff = intervalEndDate - intervalStartDate,
                    dstDiff = intervalStartDate.getTimezoneOffset() - intervalEndDate.getTimezoneOffset();

                if (diff >= duration) {
                  endDate = new Date(intervalStartDate - 0 + duration);
                  return false;
                } else {
                  duration -= diff + dstDiff * 60 * 1000;
                }
              });
              return endDate;
            }
            /**
             * This method starts from the given `date` and moves forward/backward in time (depending from the `isForward` flag) skiping the non-working time.
             * It returns the nearest edge of the first working time interval it encounters. If the given `date` falls on the working time, then `date` itself is returned.
             *
             * For example, if this function is called with some Saturday as `date` and `isForward` flag is set, it will return the earliest working hours on following Monday.
             * If `isForward` flag will be set to `false` - it will return the latest working hours on previous Friday.
             *
             * @param {Date} date A date (presumably falling on the non-working time).
             * @param {Boolean} isForward Pass `true` to skip the non-working time in forward direction, `false` - in backward
             *
             * @return {Date} Nearest working date.
             */

          }, {
            key: "skipNonWorkingTime",
            value: function skipNonWorkingTime(date, isForward) {
              var found = false; // reseting the date to the earliest availability interval

              this.forEachAvailabilityInterval(isForward ? {
                startDate: date
              } : {
                endDate: date,
                isForward: false
              }, function (intervalStartDate, intervalEndDate) {
                date = isForward ? intervalStartDate : intervalEndDate;
                found = true;
                return false;
              });
              if (!found) throw new Error('skipNonWorkingTime: Cannot skip non-working time, please ensure that this calendar has any working period of time specified');
              return new Date(date);
            }
            /**
             * Calculate the start date for the given end date and duration, taking into account the availability/holidays information (non-working time will not be counted as duration).
             *
             * @param {Date} endDate The end date
             * @param {Number} duration The "pure" duration (w/o any non-working time).
             * @param {String} unit One of the units of the {@link Common.helper.DateHelper} class.
             *
             * @return {Date} The start date
             */

          }, {
            key: "calculateStartDate",
            value: function calculateStartDate(endDate, duration, unit) {
              // if duration is 0 - return the same date
              if (!duration) {
                return new Date(endDate);
              }

              var startDate;
              duration = this.convertDurationToMs(duration, unit);
              this.forEachAvailabilityInterval({
                endDate: endDate,
                isForward: false
              }, function (intervalStartDate, intervalEndDate) {
                var diff = intervalEndDate - intervalStartDate;

                if (diff >= duration) {
                  startDate = new Date(intervalEndDate - duration);
                  return false;
                } else {
                  duration -= diff;
                }
              });
              return startDate;
            }
            /**
             * This method starts from the given `date` and moves forward/backward in time (depending from the `duration` argument).
             * It stops as soon as it skips the amount of *working* time defined by the `duration` and `unit` arguments. Skipped non-working time simply will not
             * be counted.
             *
             * **Note** that this method behaves differently from the {@link #function-skipNonWorkingTime} - that method stops as soon as it encounters the non-working time.
             * This method stops as soon as it accumulate enough skipped working time.
             *
             * @param {Date} date A starting point
             * @param {Number} duration The duration of the working time. To skip working time in backward direction pass a negative value.
             * @param {String} unit One of the units of the {@link Common.helper.DateHelper} class.
             *
             * @return {Date}
             */

          }, {
            key: "skipWorkingTime",
            value: function skipWorkingTime(date, duration, unit) {
              return duration >= 0 ? this.calculateEndDate(date, duration, unit) : this.calculateStartDate(date, -duration, unit);
            }
          }, {
            key: "isChildOf",
            value: function isChildOf(calendar) {
              var parent = this,
                  found = false;

              while (parent && !found) {
                found = parent === calendar;
                parent = parent.parent;
              }

              return found;
            }
          }, {
            key: "getParentableCalendars",
            value: function getParentableCalendars() {
              var me = this,
                  calendars = Calendar.getAllCalendars();
              return calendars.reduce(function (result, calendar) {
                if (calendar !== me && !calendar.isChildOf(me)) {
                  result.push({
                    id: calendar.calendarId,
                    name: calendar.name || calendar.calendarId
                  });
                }

                return result;
              }, []);
            }
          }, {
            key: "getAvailabilityIntervalsFor",

            /**
             * Returns the availability intervals of a specific day. Potentially can consult a parent calendar.
             *
             * @param {Date|Number} timeDate A date or timestamp
             * @return {Object[]} Array of objects, like:
              {
                 startDate       : new Date(...),
                 endDate         : new Date(...)
             }
             */
            value: function getAvailabilityIntervalsFor(timeDate, noNeedToClearTime) {
              if (noNeedToClearTime) {
                timeDate = timeDate.valueOf();
              } else if (timeDate instanceof Date) {
                timeDate = new Date(timeDate.getFullYear(), timeDate.getMonth(), timeDate.getDate()).valueOf();
              } else {
                timeDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].clearTime(new Date(timeDate)).valueOf();
              }

              return this.availabilityIntervalsCache[timeDate] = this.availabilityIntervalsCache[timeDate] || this.getCalendarDay(timeDate).getAvailabilityIntervalsFor(timeDate);
            }
          }, {
            key: "onParentDestroy",
            value: function onParentDestroy() {
              this.parent = null;
            }
          }, {
            key: "isAvailabilityIntersected",
            value: function isAvailabilityIntersected(withCalendar, startDate, endDate) {
              var ownWeekDay, ownAvailability, testWeekDay, testAvailability; // first let's try to find overlapping of weeks (check daily intervals)
              // loop over week days

              for (var i = 0; i < 7; i++) {
                ownWeekDay = this.getWeekDay(i) || this.getDefaultCalendarDay(i);
                testWeekDay = withCalendar.getWeekDay(i) || withCalendar.getDefaultCalendarDay(i);
                if (!ownWeekDay || !testWeekDay) continue; // get daily intervals

                ownAvailability = ownWeekDay.getAvailability();
                testAvailability = testWeekDay.getAvailability(); // loop over intervals to find overlapping

                for (var j = 0, l = ownAvailability.length; j < l; j++) {
                  for (var k = 0, ll = testAvailability.length; k < ll; k++) {
                    if (testAvailability[k].startTime < ownAvailability[j].endTime && testAvailability[k].endTime > ownAvailability[j].startTime) {
                      return true;
                    }
                  }
                }
              }

              var result = false;
              this.forEachNonStandardWeek(function (week) {
                if (week.startDate >= endDate) return false;

                if (startDate < week.endDate) {
                  result = true; // stop the iteration

                  return false;
                }
              });
              return result;
            }
          }, {
            key: "calendarId",

            /**
             * Get/set the calendarId of the current calendar, also registers it in the calendar registry.
             * @property {String}
             */
            get: function get() {
              return this._calendarId;
            }
            /**
             * Sets the {@link #property-parent} for this calendar. Pass `null` to remove the parent.
             *
             * @param {String|Scheduler.data.Calendar} parentOrId String with {@link #config-calendarId} value or calendar instance itself.
             */
            ,
            set: function set(id) {
              var me = this;
              me._calendarId = id;

              if (id != null) {
                me.storeId = 'GNT_CALENDAR:' + id;
              } else {
                me.storeId = null;
              }

              me.params = Object.assign(me.params || {}, {
                calendarId: id
              });
            }
          }, {
            key: "parent",
            set: function set(parentOrId) {
              var me = this,
                  parent = Calendar.getCalendar(parentOrId);
              if (parentOrId && !parent) throw new Error('Invalid parent specified for the calendar');

              if (me.parent != parent) {
                var listeners = {
                  calendarchange: me.clearCache,
                  destroy: me.onParentDestroy,
                  thisObj: me
                };
                var oldParent = me.parent;
                if (oldParent) oldParent.un(listeners);
                me._parent = parent;
                if (parent) parent.on(listeners);
                me.params = Object.assign(me.params || {}, {
                  parentId: parent ? parent.calendarId : null
                });
                me.clearCache();
                /**
                 * Triggered when a calender is assigned to a new parent calendar.
                 * @event parentChange
                 *
                 * @param {Scheduler.data.Calendar} source The calendar which parent has changed
                 * @param {Scheduler.data.Calendar} newParent The new parent of this calendar (can be `null` if parent is being removed)
                 * @param {Scheduler.data.Calendar} oldParent The old parent of this calendar (can be `null` if there was no parent)
                 */

                me.trigger('parentChange', {
                  newParent: parent,
                  oldParent: oldParent
                });
              }
            },
            get: function get() {
              return this._parent;
            }
          }], [{
            key: "getCalendar",
            value: function getCalendar(id) {
              if (id instanceof Calendar) return id;
              return _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_10__["default"].getStore(id);
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                modelClass: _model_CalendarDayModel_js__WEBPACK_IMPORTED_MODULE_13__["default"],

                /**
                 * Number of days per month. Will be used when converting the big duration units like month/year to days.
                 *
                 * @config {Number}
                 * @default
                 */
                daysPerMonth: 30,

                /**
                 * Number of days per week. Will be used when converting the duration in weeks to days.
                 *
                 * @config {Number}
                 * @default
                 */
                daysPerWeek: 7,

                /**
                 * Number of hours per day. Will be used when converting the duration in days to hours.
                 *
                 * **Please note**, that this config is used for duration conversion and not anything else. If you need to change
                 * the number of working hours in the day, update the {@link #config-defaultAvailability}
                 *
                 * @config {Number}
                 * @default
                 */
                hoursPerDay: 24,
                unitsInMs: null,
                defaultNonWorkingTimeCssCls: 'b-nonworkingtime',

                /**
                 * Setting this option to `true` will treat *all* days as working days. Default value is `false`.
                 * @config {Boolean}
                 * @default
                 */
                weekendsAreWorkdays: false,

                /**
                 * The index of the first day in a weekend, 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on. '
                 * Default value is 6 - Saturday
                 * @config {Number}
                 * @default
                 */
                weekendFirstDay: 6,

                /**
                 * The index of the second day in weekend, 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on.
                 * Default value is 0 - Sunday
                 * @config {Number}
                 * @default
                 */
                weekendSecondDay: 0,
                holidaysCache: null,
                availabilityIntervalsCache: null,
                daysIndex: null,
                // a "cached" array of WEEKDAY days
                weekAvailability: null,
                // the "very default" availability array, calculated based on `defaultAvailability` property
                defaultWeekAvailability: null,
                nonStandardWeeksByStartDate: null,
                nonStandardWeeksStartDates: null,

                /**
                 * The unique id for the calendar. Providing a `calendarId` will register this calendar in the calendars
                 * registry and it can be retrieved later with {@link #function-getCalendar-static}. Generally only required if want to use
                 * {@link #property-parent parent-child relations} between the calendars, or assign this calendar to a particular
                 * task or resource.
                 *
                 * @config {String}
                 */
                calendarId: null,

                /**
                 * The parent calendar. Can be provided as the calendar id or calendar instance itself. If this property is
                 * provided or set with {@link #property-parent} property, this calendar becomes a "child" of the specified
                 * calendar. This means that it will "inherit" all day overrides, week days and week day overrides from its
                 * "parent". In the same time, special days, defined in this calendar take priority over the ones from the
                 * "parent".
                 *
                 * You can use this feature if you'd like to create a single "main" calendar for the whole project, and then
                 * allow some task or resource to have slightly different calendar (with an additional day off for example).
                 * You will not have to re-create all special days in the calendar of such task/resource - just set the
                 * "main" calendar as a "parent" for it.
                 *
                 * @config {String|Scheduler.data.Calendar}
                 */
                parent: null,

                /**
                 * The array of default availability intervals (in the format of the
                 * `Availability` field in the {@link Scheduler.model.CalendarDayModel}) for each working weekday (Monday-Friday). Defaults
                 * to whole day (00-24) for backward compatibility.
                 * @config {String[]}
                 * @default
                 */
                defaultAvailability: ['00:00-24:00'],

                /**
                 * The name of this calendar
                 * @config {String}
                 */
                name: null,
                suspendCacheUpdate: 0,

                /**
                 * Maximum number of days to search for calendar availability intervals.
                 * Used in various calculations requiring to respect working time.
                 * In these cases the system iterates through the working time day by day. This option determines the maximum distance
                 * to iterate. Prevents against infinite loop in case of wrong calendar configuration.
                 * @config {Number}
                 * @default
                 */
                availabilitySearchLimit: 1825 //5*365

              };
            }
            /**
             * Returns an array of all registered calendars.
             *
             * @return {Scheduler.data.Calendar[]}
             */

          }, {
            key: "allCalendars",
            get: function get() {
              return (_Common_data_Store_js__WEBPACK_IMPORTED_MODULE_10__["default"].stores || []).filter(function (store) {
                return store instanceof Calendar;
              });
            }
          }]);

          return Calendar;
        }(_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        Calendar._$name = 'Calendar';
        /***/
      },

      /***/
      "./lib/Scheduler/data/CrudManager.js":
      /*!*******************************************!*\
        !*** ./lib/Scheduler/data/CrudManager.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataCrudManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CrudManager;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../crud/AbstractCrudManager.js */
        "./lib/Scheduler/crud/AbstractCrudManager.js");
        /* harmony import */


        var _crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../crud/encoder/JsonEncoder.js */
        "./lib/Scheduler/crud/encoder/JsonEncoder.js");
        /* harmony import */


        var _crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../crud/transport/AjaxTransport.js */
        "./lib/Scheduler/crud/transport/AjaxTransport.js");
        /* harmony import */


        var _ResourceStore_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./ResourceStore.js */
        "./lib/Scheduler/data/ResourceStore.js");
        /* harmony import */


        var _EventStore_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./EventStore.js */
        "./lib/Scheduler/data/EventStore.js");
        /* harmony import */


        var _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./AssignmentStore.js */
        "./lib/Scheduler/data/AssignmentStore.js");
        /* harmony import */


        var _DependencyStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./DependencyStore.js */
        "./lib/Scheduler/data/DependencyStore.js");
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/CrudManager
         */

        /**
         * The Crud Manager (or "CM") is a class implementing centralized loading and saving of data in multiple stores.
         * Loading the stores and saving all changes is done using one ajax request. This class uses AJAX as a transport
         * mechanism and JSON as the data encoding format.
         *
         * ## Scheduler stores
         *
         * The class supports Scheduler specific stores (namely: resource, event and assignment stores).
         * For these stores, the CM has separate configs ({@link #config-resourceStore}, {@link #config-eventStore},
         * {@link #config-assignmentStore}) to register them. The class can also grab them from the task store (this behavior
         * can be changed using {@link #config-addRelatedStores} config).
         *
         * ```javascript
         * let crudManager = new CrudManager({
         *   autoLoad        : true,
         *   resourceStore   : resourceStore,
         *   eventStore      : eventStore,
         *   assignmentStore : assignmentStore,
         *   transport       : {
         *     load    : {
         *       url     : 'php/read.php'
         *     },
         *     sync    : {
         *       url     : 'php/save.php'
         *     }
         *   }
         * });
         * ```
         *
         * ## AJAX request configuration
         *
         * To configure AJAX request parameters please take a look at the
         * {@link Scheduler.crud.transport.AjaxTransport AjaxTransport} docs.
         *
         * ```javascript
         * var crudManager = new CrudManager({
         *     autoLoad        : true,
         *     resourceStore   : resourceStore,
         *     eventStore      : eventStore,
         *     assignmentStore : assignmentStore,
         *     transport       : {
         *         load    : {
         *             url         : 'php/read.php',
         *             // use GET request
         *             method      : 'GET',
         *             // pass request JSON in "rq" parameter
         *             paramName   : 'rq',
         *             // extra HTTP request parameters
         *             params      : {
         *                 foo     : 'bar'
         *             },
         *             requestConfig : {
         *                 fetchOptions : {
         *                     credentials: 'include'
         *                 }
         *             }
         *         },
         *         sync    : {
         *             url     : 'php/save.php'
         *         }
         *     }
         * });
         * ```
         *
         * ## Load order
         *
         * The CM is aware of the proper load order for Scheduler specific stores so you don't need to worry about it.
         * If you provide any extra stores (using {@link Scheduler.crud.AbstractCrudManager#config-stores} config) they will be
         * added to the start of collection before the Scheduler specific stores.
         * If you a different load order, you should use {@link Scheduler.crud.AbstractCrudManager#function-addStore} method to
         * register your store:
         *
         * ```javascript
         * var crudManager = new CrudManager({
         *   resourceStore   : resourceStore,
         *   eventStore      : eventStore,
         *   assignmentStore : assignmentStore,
         *   // extra user defined stores will get to the start of collection
         *   // so they will be loaded first
         *   stores          : [ store1, store2 ],
         *   transport       : {
         *     load    : {
         *       url     : 'php/read.php'
         *     },
         *     sync    : {
         *       url     : 'php/save.php'
         *     }
         *   }
         * });
         *
         * // append store3 to the end so it will be loaded last
         * crudManager.addStore(store3);
         *
         * // now when we registered all the stores let's load them
         * crudManager.load();
         * ```
         *
         * ## Features
         * The Crud Manager can automatically add Scheduler feature stores to the tracked collection.
         * For example, it tracks TimeRanges {@link Scheduler.feature.TimeRanges#config-store}.
         * You can receive a tracked store by its id:
         * ```javascript
         * let timeRangesStore = crudManager.getStore('timeRanges');
         * ```
         *
         * @mixes Scheduler/crud/encoder/JsonEncoder
         * @mixes Scheduler/crud/transport/AjaxTransport
         * @extends Scheduler/crud/AbstractCrudManager
         */

        var CrudManager =
        /*#__PURE__*/
        function (_JsonEncoder) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CrudManager, _JsonEncoder);

          function CrudManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, CrudManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(CrudManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(CrudManager, [{
            key: "construct",
            //endregion
            value: function construct() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

              if (config.scheduler) {
                this.scheduler = config.scheduler; // The effects of this class's initialization are so wide ranging that they may need to
                // access the Scheduler's CrudManager, so ensure it's available immediately.

                this.scheduler._crudManager = this;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(CrudManager.prototype), "construct", this).call(this, config);
            }
          }, {
            key: "afterConstruct",
            value: function afterConstruct() {
              var me = this,
                  scheduler = me.scheduler;

              if (scheduler) {
                // Inject the scheduler stores into the Scheduler.
                // The resourceStore becomes the primary store.
                if (scheduler.isVertical || scheduler.isHorizontal && !scheduler.store) {
                  scheduler.resourceStore = me.resourceStore;
                  scheduler.eventStore = me.eventStore;
                } // Features self initialize if not already initialized.
                // This must be done after the _crudManager is assigned because it may access this.crudManager
                // to get its eventStore.


                var _scheduler$features = scheduler.features,
                    dependencies = _scheduler$features.dependencies,
                    timeRanges = _scheduler$features.timeRanges,
                    resourceTimeRanges = _scheduler$features.resourceTimeRanges; // Special handling of dependency store

                if (dependencies) {
                  me.dependencyStore = dependencies.store;
                }

                if (timeRanges) {
                  me.addCrudStore(timeRanges.store);
                  me._timeRangesStore = timeRanges.store;
                }

                if (resourceTimeRanges) {
                  me.addCrudStore(resourceTimeRanges.store);
                  me._timeRangesStore = resourceTimeRanges.store;
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(CrudManager.prototype), "afterConstruct", this).call(this);
            } //region Stores

            /**
             * Returns store associated with timeRanges feature, if feature is enabled.
             * @property {Common.data.Store}
             * @readonly
             */

          }, {
            key: "addFeaturedStore",
            // Adds configured scheduler stores to the store collection ensuring correct order
            // unless they're already registered.
            value: function addFeaturedStore(store) {
              this.addPrioritizedStore(store);
            }
          }, {
            key: "setFeaturedStore",
            value: function setFeaturedStore(property, store, storeClass) {
              var me = this,
                  oldStore = me[property];
              store = _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStore(store, store && store.storeClass || storeClass);

              if (oldStore) {
                me.removeStore(oldStore);
              }

              me[property] = store && {
                store: store
              } || null;
              me.addFeaturedStore(me[property]);
              return me[property];
            } //endregion

          }, {
            key: "timeRangesStore",
            get: function get() {
              return this._timeRangesStore;
            }
          }, {
            key: "resourceStore",

            /**
             * Get/set the resource store bound to the CRUD manager.
             * @property {Scheduler.data.ResourceStore}
             */
            get: function get() {
              return this._resourceStore && this._resourceStore.store;
            },
            set: function set(store) {
              var me = this;
              me.setFeaturedStore('_resourceStore', store, me.resourceStoreClass);
              me.eventStore.resourceStore = me._resourceStore && me._resourceStore.store;
            }
            /**
             * Get/set the event store bound to the CRUD manager.
             * @property {Scheduler.data.EventStore}
             */

          }, {
            key: "eventStore",
            get: function get() {
              return this._eventStore && this._eventStore.store;
            },
            set: function set(store) {
              var me = this;
              me.setFeaturedStore('_eventStore', store, me.eventStoreClass);
              store = me._eventStore && me._eventStore.store; // If we're configuring, retrieve stores registered on the provided taskStore

              if (me.isConfiguring && store && me.addRelatedStores !== false) {
                var extracted = CrudManager.getEventStoreInfo(store, me.initialConfig),
                    assignmentStore = extracted.assignmentStore,
                    resourceStore = extracted.resourceStore,
                    dependencyStore = extracted.dependencyStore;

                if (assignmentStore) {
                  me.assignmentStore = assignmentStore;
                }

                if (resourceStore) {
                  me.resourceStore = resourceStore;
                }

                if (dependencyStore) {
                  me.dependencyStore = dependencyStore;
                }
              }
            }
            /**
             * Get/set the assignment store bound to the CRUD manager.
             * @property {Scheduler.data.AssignmentStore}
             */

          }, {
            key: "assignmentStore",
            get: function get() {
              return this._assignmentStore && this._assignmentStore.store;
            },
            set: function set(store) {
              this.setFeaturedStore('_assignmentStore', store, this.assignmentStoreClass);
            }
            /**
             * Get/set the dependency store bound to the CRUD manager.
             * @property {Scheduler.data.DependencyStore}
             */

          }, {
            key: "dependencyStore",
            get: function get() {
              return this._dependencyStore && this._dependencyStore.store;
            },
            set: function set(store) {
              this.setFeaturedStore('_dependencyStore', store, this.dependencyStoreClass);
            }
          }], [{
            key: "getEventStoreInfo",
            value: function getEventStoreInfo(eventStore, config) {
              if (!(eventStore instanceof _EventStore_js__WEBPACK_IMPORTED_MODULE_10__["default"])) {
                if (typeof eventStore === 'string') {
                  eventStore = _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStore(eventStore);
                } else {
                  eventStore = eventStore.store;
                }
              }

              var result = {},
                  assignmentStore = config.assignmentStore,
                  resourceStore = config.resourceStore,
                  dependencyStore = config.dependencyStore;
              !assignmentStore && (result.assignmentStore = eventStore.assignmentStore);
              !resourceStore && (result.resourceStore = eventStore.resourceStore);
              !dependencyStore && (result.dependencyStore = eventStore.dependencyStore);
              return result;
            }
          }, {
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                resourceStoreClass: _ResourceStore_js__WEBPACK_IMPORTED_MODULE_9__["default"],
                eventStoreClass: _EventStore_js__WEBPACK_IMPORTED_MODULE_10__["default"],
                assignmentStoreClass: _AssignmentStore_js__WEBPACK_IMPORTED_MODULE_11__["default"],
                dependencyStoreClass: _DependencyStore_js__WEBPACK_IMPORTED_MODULE_12__["default"],

                /**
                 * A store with resources (or its descriptor).
                 * @config {Scheduler.data.ResourceStore|Object}
                 */
                resourceStore: {},

                /**
                 * A store with events (or its descriptor).
                 *
                 * ```
                 * crudManager : {
                 *      eventStore {
                 *          storeClass : MyEventStore
                 *      }
                 * }
                 * ```
                 * @config {Scheduler.data.EventStore|Object}
                 */
                eventStore: {},

                /**
                 * A store with assignments (or its descriptor).
                 * @config {Scheduler.data.AssignmentStore|Object}
                 */
                assignmentStore: null,

                /**
                 * A store with dependencies (or its descriptor).
                 * @config {Scheduler.data.DependencyStore|Object}
                 */
                dependencyStore: null,

                /**
                 * When set to `true` this class will try to get the {@link #config-resourceStore} and {@link #config-assignmentStore} stores from
                 * the specified {@link #config-eventStore} instance.
                 * @config {Boolean}
                 */
                addRelatedStores: true
              };
            }
          }]);

          return CrudManager;
        }(Object(_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_7__["default"])(Object(_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_8__["default"])(_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_6__["default"])));

        ;
        CrudManager._$name = 'CrudManager';
        /***/
      },

      /***/
      "./lib/Scheduler/data/DependencyStore.js":
      /*!***********************************************!*\
        !*** ./lib/Scheduler/data/DependencyStore.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataDependencyStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DependencyStore;
        });
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "./node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");
        /* harmony import */


        var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../model/DependencyModel.js */
        "./lib/Scheduler/model/DependencyModel.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler'; // @tag dependencies

        /**
         * @module Scheduler/data/DependencyStore
         */

        /**
         * A class representing a collection of dependencies between events in the {@link Scheduler.data.EventStore}.
         * Contains a collection of {@link Scheduler.model.DependencyModel} records.
         *
         * @extends Common/data/AjaxStore
         */

        var DependencyStore =
        /*#__PURE__*/
        function (_AjaxStore) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(DependencyStore, _AjaxStore);

          function DependencyStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, DependencyStore);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DependencyStore).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(DependencyStore, [{
            key: "doDestroy",
            //region Init & destroy
            value: function doDestroy() {
              var me = this;
              me.eventStoreDetacher && me.eventStoreDetacher();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DependencyStore.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Stores

            /**
             * Get/set the associated event store instance.
             *
             * @property {Scheduler.data.EventStore}
             */

          }, {
            key: "attachToEventStore",
            value: function attachToEventStore(eventStore) {
              var me = this;
              me.eventStoreDetacher && me.eventStoreDetacher();
              me.eventStoreDetacher = eventStore.on({
                'remove': me.onEventRemove,
                thisObj: me,
                detachable: true
              });
            } //endregion

          }, {
            key: "onEventRemove",
            value: function onEventRemove(_ref) {
              var _this = this;

              var records = _ref.records,
                  _ref$isMove = _ref.isMove,
                  isMove = _ref$isMove === void 0 ? false : _ref$isMove,
                  _ref$isCollapse = _ref.isCollapse,
                  isCollapse = _ref$isCollapse === void 0 ? false : _ref$isCollapse;

              if (!isMove && !isCollapse) {
                records.forEach(function (record) {
                  // traversing in a flat structure will only call fn on self, no need to handle tree case differently
                  record.traverse(function (eventRecord) {
                    return _this.removeEventDependencies(eventRecord, false);
                  });
                });
              }
            } // TODO: document

          }, {
            key: "reduceEventDependencies",
            value: function reduceEventDependencies(event, reduceFn, result) {
              var _this2 = this;

              var flat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
              var depsGetterFn = arguments.length > 4 ? arguments[4] : undefined; // const me       = this,
              //     relation = me.relationCache;

              depsGetterFn = depsGetterFn || function (event) {
                return _this2.getEventDependencies(event); // const eventId      = DependencyModel.asId(event),
                //     sourceEvents = (relation.sourceEvent && relation.sourceEvent[eventId]) || [],
                //     targetEvents = (relation.targetEvent && relation.targetEvent[eventId]) || [];
                //
                // return sourceEvents.concat(targetEvents);
                // return me.eventDependencyCache.get(event, () =>
                //     // Full scan, but cache makes everything possible to avoid it
                //     me.records.filter(dependency =>
                //         dependency.to == eventId || dependency.from == eventId
                //     )
                // );
              };

              event = Array.isArray(event) ? event : [event];
              event.reduce(function (result, event) {
                if (event.children && !flat) {
                  event.traverse(function (evt) {
                    result = depsGetterFn(evt).reduce(reduceFn, result);
                  });
                } else {
                  result = depsGetterFn(event).reduce(reduceFn, result);
                }
              }, result);
              return result;
            } // TODO: document

          }, {
            key: "reduceEventPredecessors",
            value: function reduceEventPredecessors(event, reduceFn, result, flat) {
              var me = this;
              return me.reduceEventDependencies(event, reduceFn, result, flat, function (evt) {// const eventId = Model.asId(evt);
                // return me.eventDependencyCache.getPredecessors(evt, () =>
                //     // Full scan, but cache makes everything possible to avoid it
                //     me.records.filter(dependency =>
                //         dependency.to == eventId
                //     )
                // );
              });
            } // TODO: document

          }, {
            key: "reduceEventSuccessors",
            value: function reduceEventSuccessors(event, reduceFn, result, flat) {
              var me = this;
              return me.reduceEventDependencies(event, reduceFn, result, flat, function (evt) {// const eventId = Model.asId(evt);
                // return me.eventDependencyCache.getSuccessors(evt, () =>
                //     // Full scan, but cache makes everything possible to avoid it
                //     me.records.filter(dependency =>
                //         dependency.getSourceId() == eventId
                //     )
                // );
              });
            } // TODO: document

          }, {
            key: "mapEventDependencies",
            value: function mapEventDependencies(event, fn, filterFn, flat, depsGetterFn) {
              return this.reduceEventDependencies(event, function (result, dependency) {
                filterFn(dependency) && result.push(dependency);
                return result;
              }, [], flat, depsGetterFn);
            } // TODO: document

          }, {
            key: "mapEventPredecessors",
            value: function mapEventPredecessors(event, fn, filterFn, flat) {
              return this.reduceEventPredecessors(event, function (result, dependency) {
                filterFn(dependency) && result.push(dependency);
                return result;
              }, [], flat);
            } // TODO: document

          }, {
            key: "mapEventSuccessors",
            value: function mapEventSuccessors(event, fn, filterFn, flat) {
              return this.reduceEventSuccessors(event, function (result, dependency) {
                filterFn(dependency) && result.push(dependency);
                return result;
              }, [], flat);
            }
            /**
             * Returns all dependencies for a certain event (both incoming and outgoing)
             *
             * @param {Scheduler.model.EventModel} event
             * @param {Boolean} [flat]
             * @return {Scheduler.model.DependencyModel[]}
             */

          }, {
            key: "getEventDependencies",
            value: function getEventDependencies(event) {
              var flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              return [].concat(event.predecessors || [], event.successors || []);
            }
            /**
             * Returns all incoming dependencies of the given event
             *
             * @param {Scheduler.model.EventModel} event
             * @param {Boolean} [flat]
             * @return {Scheduler.model.DependencyModel[]}
             */

          }, {
            key: "getEventPredecessors",
            value: function getEventPredecessors(event) {
              var flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; //return this.mapEventPredecessors(event, o => o, o => true, flat);

              return event.predecessors;
            }
            /**
             * Returns all outcoming dependencies of a event
             *
             * @param {Scheduler.model.EventModel} event
             * @param {Boolean} [flat]
             * @return {Scheduler.model.DependencyModel[]}
             */

          }, {
            key: "getEventSuccessors",
            value: function getEventSuccessors(event) {
              var flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; //return this.mapEventSuccessors(event, o => o, o => true, flat);

              return event.successors;
            }
          }, {
            key: "getUnique",
            value: function getUnique(array) {
              return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(new Set(array));
            } // TODO: document

          }, {
            key: "removeEventDependencies",
            value: function removeEventDependencies(event, flat) {
              var me = this,
                  dependencies = me.getEventDependencies(event, flat);
              dependencies.length && me.remove(me.getUnique(dependencies));
            } // TODO: document

          }, {
            key: "removeEventPredecessors",
            value: function removeEventPredecessors(event, flat) {
              var me = this,
                  dependencies = me.getEventPredecessors(event, flat);
              dependencies.length && me.remove(me.getUnique(dependencies));
            } // TODO: document

          }, {
            key: "removeEventSuccessors",
            value: function removeEventSuccessors(event, flat) {
              var me = this,
                  dependencies = me.getEventSuccessors(event, flat);
              dependencies.length && me.remove(me.getUnique(dependencies));
            }
          }, {
            key: "getBySourceTargetId",
            value: function getBySourceTargetId(key) {
              //TODO: in original code this uses a keymap
              return this.records.find(function (r) {
                return key = DependencyStore.makeDependencySourceTargetCompositeKey(r.from, r.to);
              });
            }
            /**
             * Returns dependency model instance linking tasks with given ids. The dependency can be forward (from 1st
             * task to 2nd) or backward (from 2nd to 1st).
             *
             * @param {Scheduler.model.EventModel|String} sourceEvent 1st event
             * @param {Scheduler.model.EventModel|String} targetEvent 2nd event
             * @return {Scheduler.model.DependencyModel}
             */

          }, {
            key: "getDependencyForSourceAndTargetEvents",
            value: function getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) {
              // NOTE: In case this will not work switch to cache get and linear search
              var me = this;
              sourceEvent = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"].asId(sourceEvent);
              targetEvent = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"].asId(targetEvent);
              return me.getBySourceTargetId(DependencyStore.makeDependencySourceTargetCompositeKey(sourceEvent, targetEvent));
            }
            /**
             * Returns a dependency model instance linking given events if such dependency exists in the store.
             * The dependency can be forward (from 1st event to 2nd) or backward (from 2nd to 1st).
             *
             * @param {Scheduler.model.EventModel|String} sourceEvent
             * @param {Scheduler.model.EventModel|String} targetEvent
             * @return {Scheduler.model.DependencyModel}
             */

          }, {
            key: "getEventsLinkingDependency",
            value: function getEventsLinkingDependency(sourceEvent, targetEvent) {
              var me = this;
              return me.getDependencyForSourceAndTargetEvents(sourceEvent, targetEvent) || me.getDependencyForSourceAndTargetEvents(targetEvent, sourceEvent);
            }
            /**
             * Validation method used to validate a dependency. Override and return `true` to indicate that an
             * existing dependency (or a new dependency being created) between two tasks is valid.
             *
             * @param {Scheduler.model.DependencyModel|Number|String} dependencyOrFromId The dependency model or from event id
             * @param {Number|String} [toId] To event id if the first parameter is not a dependency model instance
             * @param {Number} [type] Dependency {@link Scheduler.model.DependencyBaseModel#property-Type-static}  if the first parameter is not a dependency model instance.
             * @return {Boolean}
             */

          }, {
            key: "isValidDependency",
            value: function isValidDependency(dependencyOrFromId, toId, type) {
              if (arguments.length === 1) {
                type = dependencyOrFromId.type;
                toId = dependencyOrFromId.to;
                dependencyOrFromId = dependencyOrFromId.from;
              }

              return dependencyOrFromId != null && toId != null && dependencyOrFromId !== toId;
            }
            /**
             * Returns all dependencies highlighted with the given CSS class
             *
             * @param {String} cls
             * @return {Scheduler.model.DependencyBaseModel[]}
             */

          }, {
            key: "getHighlightedDependencies",
            value: function getHighlightedDependencies(cls) {
              return this.records.reduce(function (result, dep) {
                if (dep.isHighlightedWith(cls)) result.push(dep);
                return result;
              }, []);
            }
          }, {
            key: "getTimeSpanDependencies",
            //region Product neutral
            value: function getTimeSpanDependencies(record) {
              return this.getEventDependencies(record);
            } //endregion

          }, {
            key: "eventStore",
            get: function get() {
              return this._eventStore;
            },
            set: function set(eventStore) {
              var me = this,
                  oldStore = me._eventStore;
              me._eventStore = eventStore;

              if (eventStore) {
                me.attachToEventStore(eventStore); // If store is assigned after configuration we need to init relations

                if (!me.isConfiguring) {
                  me.initRelations(true);
                }
              }

              if ((oldStore || eventStore) && oldStore !== eventStore) {
                /**
                 * Fires when a new event store is set via the {@link #property-eventStore} property.
                 * @event eventstorechange
                 * @param {Scheduler.data.DependencyStore} this
                 * @param {Scheduler.data.EventStore} newEventStore
                 * @param {Scheduler.data.EventStore} oldEventStore
                 */
                me.trigger('eventStoreChange', {
                  newEventStore: eventStore,
                  oldEventStore: oldStore
                });
              }
            }
          }], [{
            key: "makeDependencySourceTargetCompositeKey",
            value: function makeDependencySourceTargetCompositeKey(from, to) {
              return "source(".concat(from, ")-target(").concat(to, ")");
            }
          }, {
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * CrudManager must load stores in the correct order. Lowest first.
                 * @private
                 */
                loadPriority: 400,

                /**
                 * CrudManager must sync stores in the correct order. Lowest first.
                 * @private
                 */
                syncPriority: 400,
                modelClass: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_13__["default"],
                storeId: 'dependencies'
              };
            }
          }]);

          return DependencyStore;
        }(_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_12__["default"]);

        DependencyStore._$name = 'DependencyStore';
        /***/
      },

      /***/
      "./lib/Scheduler/data/EventStore.js":
      /*!******************************************!*\
        !*** ./lib/Scheduler/data/EventStore.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataEventStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventStore;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");
        /* harmony import */


        var _mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./mixin/EventStoreMixin.js */
        "./lib/Scheduler/data/mixin/EventStoreMixin.js");
        /* harmony import */


        var _model_EventModel_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../model/EventModel.js */
        "./lib/Scheduler/model/EventModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/EventStore
         */

        /**
         * This is a class holding all the {@link Scheduler.model.EventModel events} to be rendered into a {@link Scheduler.view.Scheduler Scheduler}.
         * This class only accepts a model class inheriting from {@link Scheduler.model.EventModel}.
         *
         * @mixes Scheduler/data/mixin/EventStoreMixin
         * @extends Common/data/AjaxStore
         */

        var EventStore =
        /*#__PURE__*/
        function (_EventStoreMixin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(EventStore, _EventStoreMixin);

          function EventStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, EventStore);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(EventStore).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(EventStore, [{
            key: "construct",
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(EventStore.prototype), "construct", this).call(this, config, true);

              if (this.modelClass !== _model_EventModel_js__WEBPACK_IMPORTED_MODULE_8__["default"] && !(this.modelClass.prototype instanceof _model_EventModel_js__WEBPACK_IMPORTED_MODULE_8__["default"])) {
                throw new Error('The model for the EventStore must subclass EventModel');
              }
            }
            /**
             * Appends a new record to the store
             * @param {Scheduler.model.EventModel} record The record to append to the store
             */

          }, {
            key: "append",
            value: function append(record) {
              this.add(record);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * CrudManager must load stores in the correct order. Lowest first.
                 * @private
                 */
                loadPriority: 100,

                /**
                 * CrudManager must sync stores in the correct order. Lowest first.
                 * @private
                 */
                syncPriority: 200,
                modelClass: _model_EventModel_js__WEBPACK_IMPORTED_MODULE_8__["default"],
                storeId: 'events'
              };
            }
          }]);

          return EventStore;
        }(Object(_mixin_EventStoreMixin_js__WEBPACK_IMPORTED_MODULE_7__["default"])(_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_6__["default"]));

        EventStore._$name = 'EventStore';
        /***/
      },

      /***/
      "./lib/Scheduler/data/ResourceStore.js":
      /*!*********************************************!*\
        !*** ./lib/Scheduler/data/ResourceStore.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataResourceStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResourceStore;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./mixin/ResourceStoreMixin.js */
        "./lib/Scheduler/data/mixin/ResourceStoreMixin.js");
        /* harmony import */


        var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../model/ResourceModel.js */
        "./lib/Scheduler/model/ResourceModel.js");
        /* harmony import */


        var _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/ResourceStore
         */

        /**
         * This is a class holding the collection the {@link Scheduler.model.ResourceModel resources} to be rendered into a
         * {@link Scheduler.view.Scheduler scheduler}.
         *
         * @mixes Scheduler/data/mixin/ResourceStoreMixin
         * @extends Common/data/AjaxStore
         */

        var ResourceStore =
        /*#__PURE__*/
        function (_ResourceStoreMixin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(ResourceStore, _ResourceStoreMixin);

          function ResourceStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ResourceStore);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ResourceStore).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ResourceStore, [{
            key: "construct",
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ResourceStore.prototype), "construct", this).call(this, config);

              if (this.modelClass !== _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_10__["default"] && !(this.modelClass.prototype instanceof _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_10__["default"])) {
                throw new Error('Model for ResourceStore must subclass ResourceModel');
              }
            }
          }, {
            key: "remove",
            value: function remove(recordsOrIds) {
              recordsOrIds = Array.isArray(recordsOrIds) ? recordsOrIds : [recordsOrIds];
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = recordsOrIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var r = _step.value;
                  var record = this.getById(r); // Unassign flagged as part of removal, to let UI make intelligent (?) decisions about what to update

                  record.unassignAll(true);
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ResourceStore.prototype), "remove", this).call(this, recordsOrIds);
            }
          }, {
            key: "removeAll",
            value: function removeAll() {
              this.traverse(function (resourceRecord) {
                return resourceRecord.unassignAll(true);
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(ResourceStore.prototype), "removeAll", this).call(this);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * CrudManager must load stores in the correct order. Lowest first.
                 * @private
                 */
                loadPriority: 200,

                /**
                 * CrudManager must sync stores in the correct order. Lowest first.
                 * @private
                 */
                syncPriority: 100,
                modelClass: _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_10__["default"],
                storeId: 'resources',
                autoTree: true
              };
            }
          }]);

          return ResourceStore;
        }(Object(_mixin_ResourceStoreMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_11__["default"]));

        ResourceStore._$name = 'ResourceStore';
        /***/
      },

      /***/
      "./lib/Scheduler/data/ResourceTimeRangeStore.js":
      /*!******************************************************!*\
        !*** ./lib/Scheduler/data/ResourceTimeRangeStore.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataResourceTimeRangeStoreJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResourceTimeRangeStore;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");
        /* harmony import */


        var _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../model/ResourceTimeRangeModel.js */
        "./lib/Scheduler/model/ResourceTimeRangeModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/ResourceTimeRangeStore
         */

        /**
         * A class representing a collection of resource time ranges.
         * Contains a collection of {@link Scheduler.model.ResourceTimeRangeModel} records.
         *
         * @extends Common/data/AjaxStore
         */

        var ResourceTimeRangeStore =
        /*#__PURE__*/
        function (_AjaxStore) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ResourceTimeRangeStore, _AjaxStore);

          function ResourceTimeRangeStore() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ResourceTimeRangeStore);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ResourceTimeRangeStore).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ResourceTimeRangeStore, [{
            key: "getResourcesForEvent",
            // Matching signature in EventStore to allow reusage of SchedulerStores#onInternalEventStoreChange()
            value: function getResourcesForEvent(resourceTimeRange) {
              return [resourceTimeRange.resource];
            }
          }, {
            key: "resourceStore",
            set: function set(store) {
              this._resourceStore = store; // If store is assigned after configuration we need to init relations

              if (!this.isConfiguring) {
                this.initRelations(true);
              }
            },
            get: function get() {
              return this._resourceStore;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * CrudManager must load stores in the correct order. Lowest first.
                 * @private
                 */
                loadPriority: 500,

                /**
                 * CrudManager must sync stores in the correct order. Lowest first.
                 * @private
                 */
                syncPriority: 500,

                /**
                 * This store should be linked to a ResourceStore to link the time ranges to resources
                 * @config {Scheduler.data.ResourceStore}
                 */
                resourceStore: null,
                modelClass: _model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_6__["default"],
                storeId: 'resourceTimeRanges'
              };
            }
          }]);

          return ResourceTimeRangeStore;
        }(_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        ResourceTimeRangeStore._$name = 'ResourceTimeRangeStore';
        /***/
      },

      /***/
      "./lib/Scheduler/data/TimeAxis.js":
      /*!****************************************!*\
        !*** ./lib/Scheduler/data/TimeAxis.js ***!
        \****************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataTimeAxisJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeAxis;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.object.entries */
        "./node_modules/core-js/modules/es7.object.entries.js");
        /* harmony import */


        var core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_entries__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../model/TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");
        /* harmony import */


        var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../preset/PresetManager.js */
        "./lib/Scheduler/preset/PresetManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/TimeAxis
         */

        /**
         * A class representing the time axis of the scheduler. The scheduler timescale is based on the ticks generated by this class.
         * This is a pure "data" (model) representation of the time axis and has no UI elements.
         *
         * The time axis can be {@link #config-continuous} or not. In continuous mode, each timespan starts where the previous ended, and in non-continuous mode
         * there can be gaps between the ticks.
         * A non-continuous time axis can be used when want to filter out certain periods of time (like weekends) from the time axis.
         *
         * To create a non-continuos time axis you have 2 options. First, you can create a time axis containing only the time spans of interest.
         * To do that, subclass this class and override the {@link #function-generateTicks} method.
         *
         * The other alternative is to call the {@link #function-filterBy} method, passing a function to it which should return `false` if the time tick should be filtered out.
         * Calling {@link Common.data.mixin.StoreFilter#function-clearFilters} will return you to a full time axis.
         *
         * @extends Common/data/Store
         */

        var TimeAxis =
        /*#__PURE__*/
        function (_Store) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(TimeAxis, _Store);

          function TimeAxis() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, TimeAxis);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeAxis).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(TimeAxis, [{
            key: "construct",
            //endregion
            //region Init
            // private
            value: function construct(config) {
              var me = this; // TODO: maybe not needed

              me.generateTicksValidatorFn = function () {
                return true;
              };

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeAxis.prototype), "construct", this).call(this, config);

              me.originalContinuous = me.continuous;
              me.on({
                change: function change(_ref) {
                  var action = _ref.action; // If the change was due to filtering, there will be a refresh event
                  // arriving next, so do not reconfigure

                  if (action !== 'filter') {
                    me.trigger('reconfigure', {
                      supressRefresh: false
                    });
                  }
                },
                refresh: function refresh() {
                  return me.trigger('reconfigure', {
                    supressRefresh: false
                  });
                },
                endreconfigure: function endreconfigure(event) {
                  return me.trigger('reconfigure', event);
                }
              });

              if (me.startDate) {
                me.internalOnReconfigure();
                me.trigger('reconfigure');
              } else if (me.viewPreset) {
                var range = me.getAdjustedDates(new Date());
                me.startDate = range.startDate;
                me.endDate = range.endDate;
              }
            } //endregion
            //region Configuration (reconfigure & consumePreset)

            /**
             * Reconfigures the time axis based on the config object supplied and generates the new 'ticks'.
             * @param {Object} config
             * @param {Boolean} [suppressRefresh]
             * @private
             */

          }, {
            key: "reconfigure",
            value: function reconfigure(config) {
              var suppressRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var preventThrow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  normalized = me.getAdjustedDates(config.startDate, config.endDate);

              if (me.trigger('beforeReconfigure', {
                startDate: normalized.startDate,
                endDate: normalized.endDate,
                config: config
              }) !== false) {
                me.trigger('beginReconfigure');
                me._configuredStartDate = config.startDate;
                me._configuredEndDate = config.endDate;
                Object.assign(me, config);

                if (me.internalOnReconfigure(preventThrow) === false) {
                  return false;
                }

                me.trigger('endReconfigure', {
                  suppressRefresh: suppressRefresh,
                  config: config
                });
              }
            }
          }, {
            key: "internalOnReconfigure",
            value: function internalOnReconfigure() {
              var preventThrow = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this;
              me.isConfigured = true;
              var adjusted = me.getAdjustedDates(me.startDate, me.endDate, true),
                  normalized = me.getAdjustedDates(me.startDate, me.endDate),
                  start = normalized.startDate,
                  end = normalized.endDate;

              if (start >= end) {
                throw new Error("Invalid start/end dates. Start date must less than end date. Start date: ".concat(start, ". End date: ").concat(end, "."));
              }

              var unit = me.unit,
                  increment = me.increment || 1,
                  ticks = me.generateTicks(start, end, unit, increment); // Suspending to be able to detect an invalid filter

              me.suspendEvents();
              me.data = ticks;
              var count = me.count;

              if (count === 0) {
                if (preventThrow) {
                  me.resumeEvents();
                  return false;
                }

                throw new Error('Invalid time axis configuration or filter, please check your input data.');
              } // start date is cached, update it to fill after generated ticks


              me.startDate = me.first.startDate;
              me.resumeEvents();
              var checkEnd = me.last.endDate;

              if (me.isContinuous) {
                me.adjustedStart = adjusted.startDate;
                me.adjustedEnd = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getNext(count > 1 ? ticks[count - 1].startDate : adjusted.startDate, unit, increment, me.weekStartDay);
              } else {
                me.adjustedStart = me.startDate;
                me.adjustedEnd = checkEnd;
              } // if visibleTickStart > 1 this means some tick is fully outside of the view - we are not interested in it and want to
              // drop it and adjust "adjustedStart" accordingly


              do {
                // TODO this has to use more sophisticated formula to take into account that months for example can be expressed in ms consistenly
                me.visibleTickStart = (me.startDate - me.adjustedStart) / (_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].asMilliseconds(unit) * increment); // TODO: Changed from round to floor which seems to work, but this is not needed in ExtScheduler. Need to step and see what is different

                if (me.autoAdjust) me.visibleTickStart = Math.floor(me.visibleTickStart);
                if (me.visibleTickStart >= 1) me.adjustedStart = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getNext(me.adjustedStart, unit, increment, me.weekStartDay);
              } while (me.visibleTickStart >= 1);

              do {
                me.visibleTickEnd = count - (me.adjustedEnd - checkEnd) / (_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].asMilliseconds(unit) * increment);
                if (count - me.visibleTickEnd >= 1) me.adjustedEnd = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getNext(me.adjustedEnd, unit, -1, me.weekStartDay);
              } while (count - me.visibleTickEnd >= 1);

              me.updateTickCache(true);
            }
            /**
             * Get/set currently used preset
             * @property {Scheduler.preset.ViewPreset}
             */

          }, {
            key: "setTimeSpan",
            //endregion
            //region Timespan & resolution

            /**
             * Changes the time axis timespan to the supplied start and end dates.
             * @param {Date} newStartDate The new start date
             * @param {Date} newEndDate The new end date
             */
            value: function setTimeSpan(newStartDate, newEndDate) {
              var preventThrow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

              var me = this,
                  _me$getAdjustedDates = me.getAdjustedDates(newStartDate, newEndDate),
                  startDate = _me$getAdjustedDates.startDate,
                  endDate = _me$getAdjustedDates.endDate;

              if (me.startDate - startDate !== 0 || me.endDate - endDate !== 0) {
                return me.reconfigure({
                  startDate: startDate,
                  endDate: endDate
                }, false, preventThrow);
              }
            }
            /**
             * Moves the time axis by the passed amount and unit.
             *
             * NOTE: When using a filtered TimeAxis the result of `shift()` cannot be guaranteed, it might shift into a
             * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
             * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
             * instead.
             *
             * @param {Number} amount The number of units to jump
             * @param {String} [unit] The unit (Day, Week etc)
             */

          }, {
            key: "shift",
            value: function shift(amount) {
              var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.shiftUnit;
              var me = this;
              var startDate = me.startDate,
                  endDate = me.endDate; // Use unfiltered start and end dates when shifting a filtered time axis, to lessen risk of messing it up.
              // Still not guaranteed to work though

              if (me.isFiltered) {
                startDate = me.allRecords[0].startDate;
                endDate = me.allRecords[me.allCount - 1].endDate;
              } // Hack for filtered time axis, for example if weekend is filtered out and you shiftPrev() day from monday


              var tries = 0;

              do {
                startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(startDate, amount, unit);
                endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(endDate, amount, unit);
              } while (tries++ < 100 && me.setTimeSpan(startDate, endDate, true) === false);
            }
            /**
             * Moves the time axis forward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement`
             * config of the current view preset.
             *
             * NOTE: When using a filtered TimeAxis the result of `shiftNext()` cannot be guaranteed, it might shift into a
             * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
             * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
             * instead.
              *
             * @param {Number} [amount] The number of units to jump forward
             */

          }, {
            key: "shiftNext",
            value: function shiftNext() {
              var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.shiftIncrement;
              this.shift(amount);
            }
            /**
             * Moves the time axis backward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement` config of the current view preset.
             *
             * NOTE: When using a filtered TimeAxis the result of `shiftPrev()` cannot be guaranteed, it might shift into a
             * filtered out span. It tries to be smart about it by shifting from unfiltered start and end dates.
             * If that solution does not work for your filtering setup, please call {@link #function-setTimeSpan} directly
             * instead.
              *
             * @param {Number} [amount] The number of units to jump backward
             */

          }, {
            key: "shiftPrevious",
            value: function shiftPrevious() {
              var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.shiftIncrement;
              this.shift(-amount);
            } //endregion
            //region Filter & continous

            /**
             * Filter the time axis by a function. The passed function will be called with each tick in time axis.
             * If the function returns true, the 'tick' is included otherwise it is filtered. If all ticks are filtered out
             * the time axis is considered invalid, triggering `invalidFilter` and then removing the filter.
             * @param {Function} fn The function to be called, it will receive an object with startDate/endDate properties, and 'index' of the tick.
             * @param {Object} [thisObj] `this` reference for the function
             */

          }, {
            key: "filterBy",
            value: function filterBy(fn) {
              var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
              var me = this;
              me.filters.clear();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeAxis.prototype), "filterBy", this).call(this, function (tick, index) {
                return fn.call(thisObj, tick.data, index);
              });

              if (me.count === 0) {
                me.trigger('invalidFilter');
                me.clearFilters();
              }
            }
          }, {
            key: "triggerFilterEvent",
            value: function triggerFilterEvent(event) {
              var me = this;

              if (!event.filters.count) {
                me.continuous = me.originalContinuous;
              } else {
                me.continuous = false;
              } // Filters has been applied (or cleared) but listeners are not informed yet, update tick cache to have start and
              // end dates correct when later redrawing events & header


              me.updateTickCache();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(TimeAxis.prototype), "triggerFilterEvent", this).call(this, event);
            }
            /**
             * Returns `true` if the time axis is continuous (will return `false` when filtered)
             * @return {Boolean}
             */

          }, {
            key: "getAdjustedDates",
            //endregion
            //region Dates
            value: function getAdjustedDates(startDate, endDate) {
              var forceAdjust = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this;
              startDate = startDate || me.startDate;
              endDate = endDate || _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(startDate, me.defaultSpan, me.mainUnit);
              return me.autoAdjust || forceAdjust ? {
                startDate: me.floorDate(startDate, false, me.autoAdjust ? me.mainUnit : me.unit, 1),
                endDate: me.ceilDate(endDate, false, me.autoAdjust ? me.mainUnit : me.unit, 1)
              } : {
                startDate: startDate,
                endDate: endDate
              };
            }
            /**
             * Method to get the current start date of the time axis.
             * @property {Date}
             */

          }, {
            key: "floorDate",
            // Floors a date and optionally snaps it to one of the following resolutions:
            // 1. 'resolutionUnit'. If param 'resolutionUnit' is passed, the date will simply be floored to this unit.
            // 2. If resolutionUnit is not passed: If date should be snapped relative to the timeaxis start date,
            // the resolutionUnit of the timeAxis will be used, or the timeAxis 'mainUnit' will be used to snap the date
            //
            // returns a copy of the original date
            // private
            value: function floorDate(date, relativeToStart, resolutionUnit, incr) {
              relativeToStart = relativeToStart !== false;

              var me = this,
                  relativeTo = relativeToStart ? _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].clone(me.startDate) : null,
                  increment = incr || me.resolutionIncrement,
                  unit = resolutionUnit || (relativeToStart ? me.resolutionUnit : me.mainUnit),
                  snap = function snap(value, increment) {
                return Math.floor(value / increment) * increment;
              };

              if (relativeToStart) {
                var snappedDuration = snap(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].diff(relativeTo, date, unit), increment); // TODO: used to be small unit multipled with factor (minute = seconds, minutes * 60)

                return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(relativeTo, snappedDuration, unit);
              }

              var dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].clone(date);

              if (unit === 'week') {
                var day = dt.getDay() || 7,
                    startDay = me.weekStartDay || 7;
                dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, 'day'), day >= startDay ? startDay - day : -(7 - startDay + day), 'day'); // Watch out for Brazil DST craziness (see test 028_timeaxis_dst.t.js)

                if (dt.getDay() !== startDay && dt.getHours() === 23) {
                  dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(dt, 1, 'hour');
                }
              } else {
                // removes "smaller" units from date (for example minutes; removes seconds and milliseconds)
                dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, unit); // day and year are 1-based so need to make additional adjustments

                var modifier = ['day', 'year'].includes(unit) ? 1 : 0,
                    useUnit = unit === 'day' ? 'date' : unit,
                    snappedValue = snap(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].get(dt, useUnit) - modifier, increment) + modifier;
                dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].set(dt, useUnit, snappedValue);
              }

              return dt;
            }
            /**
             * Rounds the date to nearest unit increment
             * @private
             */

          }, {
            key: "roundDate",
            value: function roundDate(date, relativeTo) {
              var me = this,
                  dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].clone(date),
                  increment = me.resolutionIncrement || 1;

              relativeTo = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].clone(relativeTo || me.startDate);

              switch (me.resolutionUnit) {
                case 'week':
                  _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, 'day');

                  var distanceToWeekStartDay = dt.getDay() - me.weekStartDay,
                      toAdd;

                  if (distanceToWeekStartDay < 0) {
                    distanceToWeekStartDay = 7 + distanceToWeekStartDay;
                  }

                  if (Math.round(distanceToWeekStartDay / 7) === 1) {
                    toAdd = 7 - distanceToWeekStartDay;
                  } else {
                    toAdd = -distanceToWeekStartDay;
                  }

                  return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(dt, toAdd, 'day');

                case 'month':
                  var nbrMonths = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].diff(relativeTo, dt, 'month') + _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].as('month', dt.getDay() / _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].daysInMonth(dt)),
                      //*/DH.as('month', DH.diff(relativeTo, dt)) + (dt.getDay() / DH.daysInMonth(dt)),
                  snappedMonths = Math.round(nbrMonths / increment) * increment;

                  return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(relativeTo, snappedMonths, 'month');

                case 'quarter':
                  _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, 'month');

                  return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(dt, 'month', 3 - dt.getMonth() % 3);

                default:
                  var duration = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].as(me.resolutionUnit, _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].diff(relativeTo, dt)),
                      // Need to find the difference of timezone offsets between relativeTo and original dates. 0 if timezone offsets are the same.
                  offset = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].as(me.resolutionUnit, relativeTo.getTimezoneOffset() - dt.getTimezoneOffset(), 'minute'),
                      // Need to add the offset to the whole duration, so the divided value will take DST into account
                  snappedDuration = Math.round((duration + offset) / increment) * increment; // TODO: used to add one res unit lower * factor, minutes = add seconds, minutes * 60
                  // Now when the round is done, we need to subtract the offset, so the result also will take DST into account


                  return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(relativeTo, snappedDuration - offset, me.resolutionUnit);
              }
            } // private

          }, {
            key: "ceilDate",
            value: function ceilDate(date, relativeToStart, resolutionUnit, increment) {
              var me = this;
              relativeToStart = relativeToStart !== false;
              increment = increment || (relativeToStart ? this.resolutionIncrement : 1);

              var dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].clone(date),
                  doCall = false,
                  unit = resolutionUnit || (relativeToStart ? me.resolutionUnit : me.mainUnit);

              switch (unit) {
                case 'minute':
                  doCall = !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isStartOf(dt, 'minute');
                  break;

                case 'hour':
                  doCall = !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isStartOf(dt, 'hour');
                  break;

                case 'day':
                case 'date':
                  doCall = !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isStartOf(dt, 'day');
                  break;

                case 'week':
                  dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, 'day');
                  doCall = dt.getDay() !== me.weekStartDay || !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isEqual(dt, date);
                  break;

                case 'month':
                  dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, 'day');
                  doCall = dt.getDate() !== 1 || !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isEqual(dt, date);
                  break;

                case 'quarter':
                  dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, 'day');
                  doCall = dt.getMonth() % 3 !== 0 || dt.getDate() !== 1 || !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isEqual(dt, date);
                  break;

                case 'year':
                  dt = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].startOf(dt, 'day');
                  doCall = dt.getMonth() !== 0 || dt.getDate() !== 1 || !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].isEqual(dt, date);
                  break;
              }

              if (doCall) return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getNext(dt, unit, increment, me.weekStartDay);
              return dt;
            } //endregion
            //region Ticks

          }, {
            key: "processExclusion",
            // Check if a certain date is included based on timeAxis.include rules
            value: function processExclusion(startDate, endDate, unit) {
              var include = this.include;

              if (include) {
                return Object.entries(include).some(function (_ref2) {
                  var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref2, 2),
                      includeUnit = _ref3[0],
                      rule = _ref3[1];

                  if (!rule) {
                    return false;
                  }

                  var from = rule.from,
                      to = rule.to; // Including the closest smaller unit with a { from, to} rule should affect start & end of the
                  // generated tick. Currently only works for days or smaller.

                  if (_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].compareUnits('day', unit) >= 0 && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getLargerUnit(includeUnit) === unit) {
                    if (from) {
                      _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].set(startDate, includeUnit, from);
                    }

                    if (to) {
                      var _DH$set;

                      var stepUnit = unit; // Stepping back base on date, not day

                      if (unit === 'day') {
                        stepUnit = 'date';
                      } // Since endDate is not inclusive it points to the next day etc.
                      // Turns for example 2019-01-10T00:00 -> 2019-01-09T18:00


                      _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].set(endDate, (_DH$set = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_DH$set, stepUnit, _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].get(endDate, stepUnit) - 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_DH$set, includeUnit, to), _DH$set));
                    }
                  } // "Greater" unit being included? Then we need to care about it
                  // (for example excluding day will also affect hour, minute etc)


                  if (_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].compareUnits(includeUnit, unit) >= 0) {
                    var datePart = includeUnit === 'day' ? startDate.getDay() : _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].get(startDate, includeUnit);

                    if (from && datePart < from || to && datePart >= to) {
                      return true;
                    }
                  }
                });
              }

              return false;
            } // Calculate constants used for exclusion when scaling within larger ticks

          }, {
            key: "initExclusion",
            value: function initExclusion() {
              Object.entries(this.include).forEach(function (_ref4) {
                var _ref5 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref4, 2),
                    unit = _ref5[0],
                    rule = _ref5[1];

                if (rule) {
                  var from = rule.from,
                      to = rule.to; // For example for hour:
                  // 1. Get the next bigger unit -> day, get ratio -> 24
                  // 2. to 20 - from 8 = 12 hours visible each day. lengthFactor 24 / 12 = 2 means that each hour used
                  // needs to represent 2 hours when drawn (to stretch)
                  // |    ████    | -> |  ████████  |

                  rule.lengthFactor = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getUnitToBaseUnitRatio(unit, _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getLargerUnit(unit)) / (to - from); // TODO: Since `to` is exclusive this should be the correct one... but cannot get it to work throughout

                  rule.lengthFactorExcl = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getUnitToBaseUnitRatio(unit, _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getLargerUnit(unit)) / (to - from - 1); // Calculate weighted center to stretch around |   ██x█ |

                  rule.center = from + from / (rule.lengthFactor - 1);
                }
              });
            }
            /**
             * Method generating the ticks for this time axis. Should return an array of ticks. Each tick is an object of the following structure:
             * ```
             * {
             *    startDate : ..., // start date
             *    endDate   : ...  // end date
             * }
             * ```
             * Take notice, that this function either has to be called with `start`/`end` parameters, or create those variables.
             *
             * @param {Date} axisStartDate The start date of the interval
             * @param {Date} axisEndDate The end date of the interval
             * @param {String} unit The unit of the time axis
             * @param {Number} increment The increment for the unit specified.
             * @return {Array} ticks The ticks representing the time axis
             */

          }, {
            key: "generateTicks",
            value: function generateTicks(axisStartDate, axisEndDate) {
              var unit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.unit;
              var increment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.increment;
              var me = this,
                  ticks = [],
                  usesExclusion = Boolean(me.include);

              var intervalEnd,
                  tickEnd,
                  isExcluded,
                  dstDiff = 0,
                  _me$getAdjustedDates2 = me.getAdjustedDates(axisStartDate, axisEndDate),
                  startDate = _me$getAdjustedDates2.startDate,
                  endDate = _me$getAdjustedDates2.endDate;

              me.tickCache = {};

              if (usesExclusion) {
                me.initExclusion();
              }

              while (startDate < endDate) {
                intervalEnd = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getNext(startDate, unit, increment, me.weekStartDay);

                if (!me.autoAdjust && intervalEnd > endDate) {
                  intervalEnd = endDate;
                } // Handle hourly increments crossing DST boundaries to keep the timescale looking correct
                // Only do this for HOUR resolution currently, and only handle it once per tick generation.


                if (unit === 'hour' && increment > 1 && ticks.length > 0 && dstDiff === 0) {
                  var prev = ticks[ticks.length - 1];
                  dstDiff = (prev.startDate.getHours() + increment) % 24 - prev.endDate.getHours();

                  if (dstDiff !== 0) {
                    // A DST boundary was crossed in previous tick, adjust this tick to keep timeaxis "symmetric".
                    intervalEnd = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(intervalEnd, dstDiff, 'hour');
                  }
                }

                isExcluded = false;

                if (usesExclusion) {
                  tickEnd = new Date(intervalEnd.getTime());
                  isExcluded = me.processExclusion(startDate, intervalEnd, unit);
                } else {
                  tickEnd = intervalEnd;
                }

                if (me.generateTicksValidatorFn(startDate) && !isExcluded) {
                  ticks.push({
                    startDate: startDate,
                    endDate: intervalEnd
                  });
                  me.tickCache[startDate.getTime()] = ticks.length - 1;
                }

                startDate = tickEnd;
              }

              return ticks;
            }
          }, {
            key: "getTickFromDate",

            /**
             * Gets a tick "coordinate" representing the date position on the time scale. Returns -1 if the date is not part of the time axis.
             * @param {Date} date the date
             * @return {Number} the tick position on the scale or -1 if the date is not part of the time axis
             */
            value: function getTickFromDate(date) {
              var me = this,
                  ticks = me.records;
              var begin = 0,
                  end = ticks.length - 1,
                  middle,
                  tick,
                  tickStart,
                  tickEnd; // Quickly eliminate out of range dates or if we have not been set up with a time range yet

              if (!ticks.length || date < ticks[0].startDate || date > ticks[end].endDate) {
                return -1;
              }

              if (me.isContinuous) {
                // TODO: This is the code from ExtScheduler, it is a calculation without iteration so it should perform better,
                //  we should consider using it...
                // if (date - ticks[0].startDate === 0) return this.visibleTickStart;
                // if (date - ticks[end].endDate === 0) return this.visibleTickEnd;
                //
                // const { adjustedStart, adjustedEnd }     = this;
                //
                // let tickIndex       = Math.floor(ticks.length * (date - adjustedStart) / (adjustedEnd - adjustedStart));
                //
                // // for the date == adjustedEnd case
                // if (tickIndex > end) {
                //     tickIndex = end;
                // }
                //
                // const tickStart           = tickIndex === 0 ? adjustedStart : ticks[tickIndex].startDate;
                // const tickEnd             = tickIndex === end ? adjustedEnd : ticks[tickIndex].endDate;
                //
                // tick                = tickIndex + (date - tickStart) / (tickEnd - tickStart);
                //
                // // in case of `autoAdjust : false` the actual visible timespan starts not from 0 tick coordinate, but
                // // from `visibleTickStart` coordinate, this check generally repeats the "quick bailout" check in the begining of the method,
                // // but still
                // if (tick < this.visibleTickStart || tick > this.visibleTickEnd) {
                //     return -1;
                // }
                //
                // return tick;
                // Chop tick cache in half until we find a match
                while (begin < end) {
                  middle = begin + end + 1 >> 1;

                  if (date > ticks[middle].endDate) {
                    begin = middle + 1;
                  } else if (date < ticks[middle].startDate) {
                    end = middle - 1;
                  } else {
                    begin = middle;
                  }
                }

                tick = ticks[begin];
                tickStart = tick.startDate;
                tickEnd = tick.endDate; // Part way though, calculate the fraction

                if (date > tickStart) {
                  begin += (date - tickStart) / (tickEnd - tickStart);
                }

                return Math.min(Math.max(begin, me.visibleTickStart), me.visibleTickEnd);
              } else {
                for (var i = 0; i <= end; i++) {
                  tickEnd = ticks[i].endDate;

                  if (date <= tickEnd) {
                    tickStart = ticks[i].startDate; // date < tickStart can occur in filtered case

                    tick = i + (date > tickStart ? (date - tickStart) / (tickEnd - tickStart) : 0);
                    return tick;
                  }
                }
              }
            }
            /**
             * Gets the time represented by a tick "coordinate".
             * @param {Number} tick the tick "coordinate"
             * @param {String} [roundingMethod] The rounding method to use
             * @return {Date} The date to represented by the tick "coordinate", or null if invalid.
             */

          }, {
            key: "getDateFromTick",
            value: function getDateFromTick(tick, roundingMethod) {
              var me = this;

              if (tick === me.visibleTickEnd) {
                return me.endDate;
              }

              var wholeTick = Math.floor(tick),
                  fraction = tick - wholeTick,
                  t = me.getAt(wholeTick);

              if (!t) {
                return null;
              }

              var start = wholeTick === 0 ? me.adjustedStart : t.startDate,
                  // if we've filtered timeaxis using filterBy, then we cannot trust to adjustedEnd property and should use tick end
              end = wholeTick === me.count - 1 && me.isContinuous ? me.adjustedEnd : t.endDate,
                  date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(start, fraction * (end - start), 'millisecond');

              if (roundingMethod) {
                date = me[roundingMethod + 'Date'](date);
              }

              return date;
            }
            /**
             * Returns the ticks of the timeaxis in an array of objects with a "start" and "end" date.
             * @return {Object[]} the ticks on the scale
             */

          }, {
            key: "updateTickCache",

            /**
             * Caches ticks and start/end dates for faster processing during rendering of events.
             * @private
             */
            value: function updateTickCache() {
              var onlyStartEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this;

              if (me.count) {
                me._start = me.first.startDate;
                me._end = me.last.endDate;
                me._startMS = me.startDate.getTime();
                me._endMS = me.endDate.getTime();
              } else {
                me._start = me._end = me._startMs = me._endMS = null;
              } // onlyStartEnd is true prior to clearing filters, to get start and end dates correctly during that process.
              // No point in filling tickCache yet in that case, it will be done after the filters are cleared


              if (!onlyStartEnd) {
                me.tickCache = {};
                me.forEach(function (tick, i) {
                  return me.tickCache[tick.startDate.getTime()] = i;
                });
              }
            } //endregion
            //region Axis

            /**
             * Returns true if the passed date is inside the span of the current time axis.
             * @param {Date} date The date to query for
             * @return {Boolean} true if the date is part of the timeaxis
             */

          }, {
            key: "dateInAxis",
            value: function dateInAxis(date) {
              var inclusiveEnd = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  axisStart = me.startDate,
                  axisEnd = me.endDate; // Date is between axis start/end and axis is not continuous - need to perform better lookup

              if (me.isContinuous) {
                return inclusiveEnd ? _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].betweenLesserEqual(date, axisStart, axisEnd) : _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].betweenLesser(date, axisStart, axisEnd);
              } else {
                var length = me.getCount(),
                    tickStart,
                    tickEnd,
                    tick;

                for (var i = 0; i < length; i++) {
                  tick = me.getAt(i);
                  tickStart = tick.startDate;
                  tickEnd = tick.endDate;

                  if (inclusiveEnd && date <= tickEnd || !inclusiveEnd && date < tickEnd) {
                    return date >= tickStart;
                  }
                }
              }

              return false;
            }
            /**
             * Returns true if the passed timespan is part of the current time axis (in whole or partially).
             * @param {Date} start The start date
             * @param {Date} end The end date
             * @return {Boolean} true if the timespan is part of the timeaxis
             */

          }, {
            key: "timeSpanInAxis",
            value: function timeSpanInAxis(start, end) {
              var me = this;

              if (end.getTime() === start.getTime()) {
                return this.dateInAxis(start, true);
              }

              if (me.isContinuous) {
                return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].intersectSpans(start, end, me.startDate, me.endDate);
              }

              return start < me.startDate && end > me.endDate || me.getTickFromDate(start) !== me.getTickFromDate(end);
            } // Accepts a TimeSpan model (uses its cached MS values to be a bit faster during rendering)

          }, {
            key: "isTimeSpanInAxis",
            value: function isTimeSpanInAxis(timeSpan) {
              var me = this,
                  startMS = timeSpan.startDateMS,
                  endMS = timeSpan.endDateMS; // only consider fully scheduled ranges

              if (!startMS || !endMS) return false;

              if (endMS === startMS) {
                return this.dateInAxis(timeSpan.startDate, true);
              }

              if (me.isContinuous) {
                return endMS > me.startMS && startMS < me.endMS;
              }

              return startMS < me.startMS && endMS > me.endMS || me.getTickFromDate(timeSpan.startDate) !== me.getTickFromDate(timeSpan.endDate);
            } //endregion
            //region Iteration

            /**
             * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
             * @internal
             * @param {String} unit The unit to use when iterating over the timespan
             * @param {Number} increment The increment to use when iterating over the timespan
             * @param {Function} iteratorFn The function to call
             * @param {Object} [thisObj] `this` reference for the function
             */

          }, {
            key: "forEachAuxInterval",
            value: function forEachAuxInterval(unit) {
              var increment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var iteratorFn = arguments.length > 2 ? arguments[2] : undefined;
              var thisObj = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this;
              var end = this.endDate,
                  dt = this.startDate,
                  i = 0,
                  intervalEnd;
              if (dt > end) throw new Error('Invalid time axis configuration');

              while (dt < end) {
                intervalEnd = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].min(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].getNext(dt, unit, increment, this.weekStartDay), end);
                iteratorFn.call(thisObj, dt, intervalEnd, i);
                dt = intervalEnd;
                i++;
              }
            } //endregion

          }, {
            key: "viewPreset",
            get: function get() {
              return this._viewPreset;
            },
            set: function set(viewPreset) {
              var me = this,
                  preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_18__["default"].getPreset(viewPreset);

              me._viewPreset = preset;
              Object.assign(me, {
                unit: preset.bottomHeader.unit,
                increment: preset.bottomHeader.increment || 1,
                resolutionUnit: preset.timeResolution.unit,
                resolutionIncrement: preset.timeResolution.increment,
                mainUnit: preset.mainHeader.unit,
                shiftUnit: preset.shiftUnit,
                shiftIncrement: preset.shiftIncrement || 1,
                defaultSpan: preset.defaultSpan || 1,
                presetName: preset.name,
                // Weekview columns are updated upon 'datachanged' event on this object.
                // We have to pass headerConfig in order to render them correctly (timeAxisViewModel is incorrect in required time)
                headerConfig: preset.headerConfig
              });
            } //endregion
            //region Getters & setters
            // private

          }, {
            key: "resolution",
            get: function get() {
              return {
                unit: this.resolutionUnit,
                increment: this.resolutionIncrement
              };
            } // private
            ,
            set: function set(resolution) {
              this.resolutionUnit = resolution.unit;
              this.resolutionIncrement = resolution.increment;
            }
          }, {
            key: "resolutionUnit",
            get: function get() {
              return this._resolutionUnit;
            },
            set: function set(resolutionUnit) {
              this._resolutionUnit = resolutionUnit;
            }
          }, {
            key: "resolutionIncrement",
            get: function get() {
              return this._resolutionIncrement;
            },
            set: function set(resolutionIncrement) {
              this._resolutionIncrement = resolutionIncrement || 1;
            }
          }, {
            key: "mainUnit",
            set: function set(mainUnit) {
              this._mainUnit = mainUnit;
            },
            get: function get() {
              return this._mainUnit;
            }
          }, {
            key: "shiftUnit",
            set: function set(shiftUnit) {
              this._shiftUnit = shiftUnit;
            } // private
            ,
            get: function get() {
              return this._shiftUnit || this._mainUnit;
            }
          }, {
            key: "shiftIncrement",
            set: function set(shiftIncrement) {
              this._shiftIncrement = shiftIncrement;
            } // private
            ,
            get: function get() {
              return this._shiftIncrement || 1;
            }
          }, {
            key: "unit",
            set: function set(unit) {
              this._unit = unit;
            } // private
            ,
            get: function get() {
              return this._unit;
            }
          }, {
            key: "increment",
            set: function set(increment) {
              this._increment = increment;
            } // private
            ,
            get: function get() {
              return this._increment;
            }
          }, {
            key: "defaultSpan",
            get: function get() {
              return this._defaultSpan;
            },
            set: function set(defaultSpan) {
              this._defaultSpan = defaultSpan;
            }
          }, {
            key: "isContinuous",
            get: function get() {
              return this.continuous !== false && !this.filtered;
            }
          }, {
            key: "startDate",
            get: function get() {
              // TODO: added _start as caching, might mess something up when reconfiguring? change here if tests fail
              return this._start || (this.first ? new Date(this.first.startDate) : null);
            },
            set: function set(start) {
              this._start = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].parse(start);
            }
            /**
             * Method to get a the current end date of the time axis
             * @property {Date}
             */

          }, {
            key: "endDate",
            get: function get() {
              return this._end || (this.last ? new Date(this.last.endDate) : null);
            },
            set: function set(end) {
              if (end) this._end = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].parse(end);
            } // used in performance critical code for comparisons

          }, {
            key: "startMS",
            get: function get() {
              return this._startMS;
            } // used in performance critical code for comparisons

          }, {
            key: "endMS",
            get: function get() {
              return this._endMS;
            }
          }, {
            key: "include",
            get: function get() {
              return this._include;
            },
            set: function set(include) {
              var me = this;
              me._include = include;
              me.continuous = !include;

              if (!me.isConfiguring) {
                me.startDate = me._configuredStartDate;
                me.endDate = me._configuredEndDate;
                me.internalOnReconfigure();
                me.trigger('includeChange');
              }
            }
          }, {
            key: "visibleTickTimeSpan",
            get: function get() {
              var me = this;
              return me.isContinuous ? me.visibleTickEnd - me.visibleTickStart : me.count;
            }
          }, {
            key: "ticks",
            get: function get() {
              return this.records;
            }
          }], [{
            key: "defaultConfig",
            //region Events

            /**
             * Fires before the timeaxis is about to be reconfigured (e.g. new start/end date or unit/increment). Return false to abort the operation.
             * @event beforereconfigure
             * @param {Scheduler.data.TimeAxis} source The time axis instance
             * @param {Date} startDate The new time axis start date
             * @param {Date} endDate The new time axis end date
             */

            /**
             * Event that is triggered when we end reconfiguring and everything UI-related should be done
             * @event endreconfigure
             * @private
             */

            /**
             * Fires when the timeaxis has been reconfigured (e.g. new start/end date or unit/increment)
             * @event reconfigure
             * @param {Scheduler.data.TimeAxis} source The time axis instance
             */

            /**
             * Fires if all the ticks in the timeaxis are filtered out. After firing the filter is cleared to return the time
             * axis to a valid state.
             * @event invalidFilter
             * @param {Scheduler.data.TimeAxis} source The time axis instance
             */
            //endregion
            //region Default config
            get: function get() {
              return {
                modelClass: _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_17__["default"],

                /**
                 * Set to false if the timeline is not continuous, e.g. the next timespan does not start where the previous ended (for example skipping weekends etc).
                 * @config {Boolean}
                 * @default
                 */
                continuous: true,
                originalContinuous: null,

                /**
                 * Include only certain hours or days in the time axis (makes it `continuous : false`). Accepts and object
                 * with `day` and `hour` properties:
                 * ```
                 * const scheduler = new Scheduler({
                 *     timeAxis : {
                 *         include : {
                 *              // Do not display hours after 17 or before 9 (only display 9 - 17). The `to´ value is not
                 *              // included in the time axis
                 *              hour : {
                 *                  from : 9,
                 *                  to   : 17
                 *              },
                 *              // Do not display sunday or saturday
                 *              day : [0, 6]
                 *         }
                 *     }
                 * }
                 * ```
                 * In most cases we recommend that you use Scheduler's workingTime config instead. It is easier to use and
                 * makes sure all parts of the Scheduler gets updated.
                 * @config {Object}
                 */
                include: null,

                /**
                 * Automatically adjust the timespan when generating ticks with {@link #function-generateTicks} according to
                 * the `viewPreset` configuration. Setting this to false may lead to shifting time/date of ticks.
                 * @config {Boolean}
                 * @default
                 */
                autoAdjust: true,
                unit: null,
                increment: null,
                resolutionUnit: null,
                resolutionIncrement: null,
                weekStartDay: null,
                mainUnit: null,
                shiftUnit: null,
                shiftIncrement: 1,
                //isConfigured : false,
                // in case of `autoAdjust : false`, the 1st and last ticks can be truncated, containing only part of the normal tick
                // these dates will contain adjusted start/end (like if the tick has not been truncated)
                adjustedStart: null,
                adjustedEnd: null,
                // the visible position in the first tick, can actually be > 1 because the adjustment is done by the `mainUnit`
                visibleTickStart: null,
                // the visible position in the first tick, is always ticks count - 1 < value <= ticks count, in case of autoAdjust, always = ticks count
                visibleTickEnd: null,
                // name of the current preset
                //_presetName : null,
                defaultSpan: 1,
                tickCache: {},
                viewPreset: null
              };
            }
          }]);

          return TimeAxis;
        }(_Common_data_Store_js__WEBPACK_IMPORTED_MODULE_15__["default"]);

        TimeAxis._$name = 'TimeAxis';
        /***/
      },

      /***/
      "./lib/Scheduler/data/mixin/EventStoreMixin.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/data/mixin/EventStoreMixin.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataMixinEventStoreMixinJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "./node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "./node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "./node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../util/ModelPersistencyManager.js */
        "./lib/Scheduler/data/util/ModelPersistencyManager.js");
        /* harmony import */


        var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../model/ResourceModel.js */
        "./lib/Scheduler/model/ResourceModel.js");
        /* harmony import */


        var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../model/AssignmentModel.js */
        "./lib/Scheduler/model/AssignmentModel.js");

        var productName = 'scheduler'; // TODO: PORT Make getters/setters?
        // TODO: PORT Find some nice way of replacing @cfg in docs

        /**
         * @module Scheduler/data/mixin/EventStoreMixin
         */

        var validResourceIdTypes = {
          string: 1,
          number: 1
        };
        /**
         * This is a mixin, containing functionality related to managing events.
         *
         * It is consumed by the regular {@link Scheduler.data.EventStore} class and the Gantt `TaskStore` classes
         * to allow data sharing between a Gantt chart and a Scheduler.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(EventStoreMixin, _ref);

              function EventStoreMixin() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EventStoreMixin);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventStoreMixin).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(EventStoreMixin, [{
                key: "construct",

                /**
                 * Provide assignment store to enable multiple connections between events and resources
                 * @config {Scheduler.data.AssignmentStore} assignmentStore
                 */
                //endregion
                //region Init & destroy
                value: function construct(config) {
                  var me = this;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventStoreMixin.prototype), "construct", this).call(this, config);

                  Object.assign(me, {
                    isEventStore: true,
                    autoTree: true,
                    modelPersistencyManager: me.createModelPersistencyManager()
                  });
                }
                /**
                 * Creates and returns model persistency manager
                 *
                 * @return {Scheduler.data.util.ModelPersistencyManager}
                 * @internal
                 */

              }, {
                key: "createModelPersistencyManager",
                value: function createModelPersistencyManager() {
                  var me = this;
                  return new _util_ModelPersistencyManager_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
                    eventStore: me,
                    resourceStore: me.resourceStore,
                    assignmentStore: me.assignmentStore,
                    dependencyStore: me.dependencyStore
                  });
                } //endregion
                //region Events records, iteration etc.

                /**
                 * Returns events between the supplied start and end date
                 * @param {Date} start The start date
                 * @param {Date} end The end date
                 * @param {Boolean} allowPartial false to only include events that start and end inside of the span
                 * @param {Boolean} onlyAssigned true to only include events that are assigned to a resource
                 * @return {Scheduler.model.EventModel[]} the events
                 * @category Events
                 */

              }, {
                key: "getEventsInTimeSpan",
                value: function getEventsInTimeSpan(start, end) {
                  var allowPartial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                  var onlyAssigned = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                  var events = [];
                  this.forEachScheduledEvent(function (event, eventStart, eventEnd) {
                    if (allowPartial && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].intersectSpans(eventStart, eventEnd, start, end) || !allowPartial && eventStart - start >= 0 && end - eventEnd >= 0) {
                      if (!onlyAssigned || event.resources.length > 0) {
                        events.push(event);
                      }
                    }
                  });
                  return events;
                }
                /**
                 * Returns all events that starts on the specified day.
                 * @param start Start date
                 * @returns {Scheduler.model.EventModel[]} Events starting on specified day
                 * @category Events
                 */

              }, {
                key: "getEventsByStartDate",
                value: function getEventsByStartDate(start) {
                  var events = [];
                  this.forEachScheduledEvent(function (event, eventStart, eventEnd) {
                    if (_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].isEqual(eventStart, start, 'day')) {
                      events.push(event);
                    }
                  });
                  return events;
                }
                /**
                 * Calls the supplied iterator function once for every scheduled event, providing these arguments
                 * - event : the event record
                 * - startDate : the event start date
                 * - endDate : the event end date
                 *
                 * Returning false cancels the iteration.
                 *
                 * @param {Function} fn iterator function
                 * @param {Object} thisObj `this` reference for the function
                 * @category Events
                 */

              }, {
                key: "forEachScheduledEvent",
                value: function forEachScheduledEvent(fn) {
                  var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
                  this.forEach(function (event) {
                    var eventStart = event.startDate,
                        eventEnd = event.endDate;
                    if (eventStart && eventEnd) return fn.call(thisObj, event, eventStart, eventEnd);
                  });
                }
                /**
                 * Returns an object defining the earliest start date and the latest end date of all the events in the store.
                 *
                 * @return {Object} An object with 'start' and 'end' Date properties (or null values if data is missing).
                 * @category Events
                 */

              }, {
                key: "getTotalTimeSpan",
                value: function getTotalTimeSpan() {
                  var earliest = new Date(9999, 0, 1),
                      latest = new Date(0);
                  this.forEach(function (r) {
                    if (r.startDate) earliest = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].min(r.startDate, earliest);
                    if (r.endDate) latest = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].max(r.endDate, latest);
                  }); // TODO: this will fail in programs designed to work with events in the past (after Jan 1, 1970)

                  earliest = earliest < new Date(9999, 0, 1) ? earliest : null;
                  latest = latest > new Date(0) ? latest : null; // keep last calculated value to be able to track total timespan changes

                  return this.lastTotalTimeSpan = {
                    startDate: earliest || null,
                    endDate: latest || earliest || null
                  };
                }
                /**
                 * Checks if given event record is persistable.
                 * In case assignment store is used to assign events to resources and vise versa event is considered to be always
                 * persistable. Otherwise backward compatible logic is used, i.e. event is considered to be persistable when
                 * resources it's assigned to are not phantom.
                 *
                 * @param {Scheduler.model.EventModel} event
                 * @return {Boolean}
                 * @category Events
                 */

              }, {
                key: "isEventPersistable",
                value: function isEventPersistable(event) {
                  if (!this.assignmentStore) {
                    return !event.resource || !event.resource.hasGeneratedId;
                  }

                  return true;
                } //endregion
                //region Resource

                /**
                 * Checks if a date range is allocated or not for a given resource.
                 * @param {Date} start The start date
                 * @param {Date} end The end date
                 * @param {Scheduler.model.EventModel} excludeEvent An event to exclude from the check (or null)
                 * @param {Scheduler.model.ResourceModel} resource The resource
                 * @return {Boolean} True if the timespan is available for the resource
                 * @category Resource
                 */

              }, {
                key: "isDateRangeAvailable",
                value: function isDateRangeAvailable(start, end, excludeEvent, resource) {
                  if (excludeEvent instanceof _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_18__["default"]) {
                    var currentEvent = excludeEvent.event,
                        resources = currentEvent.resources,
                        allEvents = new Set(resource.events);
                    resources.forEach(function (resource) {
                      resource.events.forEach(function (e) {
                        return allEvents.add(e);
                      });
                    });
                    allEvents.delete(currentEvent);
                    return !Array.from(allEvents).some(function (ev) {
                      return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].intersectSpans(start, end, ev.startDate, ev.endDate);
                    });
                  }

                  return !this.getEventsForResource(resource).some(function (ev) {
                    return !(excludeEvent === ev || !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].intersectSpans(start, end, ev.startDate, ev.endDate));
                  });
                }
                /**
                 * Filters the events associated with a resource, based on the function provided. An array will be returned for those
                 * events where the passed function returns true.
                 * @param {Scheduler.model.ResourceModel} resource
                 * @param {Function} fn The function
                 * @param {Object} [thisObj] `this` reference for the function
                 * @return {Scheduler.model.EventModel[]} the events in the time span
                 * @private
                 * @category Resource
                 */

              }, {
                key: "filterEventsForResource",
                value: function filterEventsForResource(resource, fn) {
                  var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this; // `getEvents` method of the resource will use either `indexByResource` or perform a full scan of the event store

                  return resource.getEvents(this).filter(fn.bind(thisObj));
                } // This method provides a way for the store to append a new record, and the consuming class has to implement it
                // since Store and TreeStore don't share the add API.
                //append(record) {
                //    throw 'Must be implemented by consuming class';
                //}

                /**
                 * Returns all resources assigned to an event.
                 *
                 * @param {Scheduler.model.EventModel|String|Number} event
                 * @return {Scheduler.model.ResourceModel[]}
                 * @category Resource
                 */

              }, {
                key: "getResourcesForEvent",
                value: function getResourcesForEvent(event) {
                  if (this.assignmentStore) {
                    return this.assignmentStore.getResourcesForEvent(event);
                  }

                  event = this.getById(event);
                  return event.resource && !event.resource.placeHolder ? [event.resource] : [];
                }
                /**
                 * Returns all events assigned to a resource
                 *
                 * @param {Scheduler.model.ResourceModel|String|Number} resource Resource or resource id
                 * @return {Scheduler.model.EventModel[]}
                 * @category Resource
                 */

              }, {
                key: "getEventsForResource",
                value: function getEventsForResource(resource) {
                  var me = this,
                      assignmentStore = me.assignmentStore;

                  if (assignmentStore) {
                    return assignmentStore.getEventsForResource(resource);
                  } // *not* if (!['string', 'number'].includes(typeof resource))
                  // Always avoid array iteration. It was only two, but it's the principle.
                  // Also a constant expression should be declared at module level,
                  // otherwise it becomes collectable garbage on each invocation.


                  if (!validResourceIdTypes[_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(resource)]) {
                    resource = resource.id;
                  } // Could be changed to use resource.events, but that would require getting model by id. This way is a bit faster


                  var cache = me.relationCache.resource && me.relationCache.resource[resource]; // Slice to be safe from outside manipulation of the array

                  return cache ? cache.slice() : [];
                } //endregion
                //region Assignment

                /**
                 * Returns all assignments for a given event.
                 * Works only if {@link #property-assignmentStore} is defined, otherwise returns an empty array.
                 *
                 * @param {Scheduler.model.EventModel|String|Number} event
                 * @return {Scheduler.model.AssignmentModel[]}
                 * @category Assignment
                 */

              }, {
                key: "getAssignmentsForEvent",
                value: function getAssignmentsForEvent(event) {
                  return this.assignmentStore && this.assignmentStore.getAssignmentsForEvent(event) || [];
                }
                /**
                 * Returns all assignments for a given resource.
                 * Works only if {@link #property-assignmentStore} is defined, otherwise returns an empty array.
                 *
                 * @param {Scheduler.model.ResourceModel|String|Number} resource
                 * @return {Scheduler.model.AssignmentModel[]}
                 * @category Assignment
                 */

              }, {
                key: "getAssignmentsForResource",
                value: function getAssignmentsForResource(resource) {
                  return this.assignmentStore && this.assignmentStore.getAssignmentsForResource(resource) || [];
                }
                /**
                 * Creates and adds assignment record for a given event and a resource.
                 *
                 * @param {Scheduler.model.EventModel|String|number} event
                 * @param {Scheduler.model.ResourceModel|String|number|Scheduler.model.ResourceModel[]|String[]|number[]} resource The resource(s) to assign to the event
                 * @privateparam {Boolean} [removeExistingAssignments] true to first remove existing assignments
                 * @category Assignment
                 */

              }, {
                key: "assignEventToResource",
                value: function assignEventToResource(event, resource) {
                  var removeExistingAssignments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                  var me = this,
                      assignmentStore = me.assignmentStore;

                  if (assignmentStore) {
                    assignmentStore.assignEventToResource(event, resource, undefined, removeExistingAssignments);
                  } else {
                    event = me.getById(event);

                    if (Array.isArray(resource)) {
                      resource = resource[0];
                    }

                    resource = resource instanceof _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_17__["default"] ? resource.id : resource; // resource id might be 0 thus we use ? operator

                    if (event) {
                      event.resourceId = resource;
                    }
                  }
                }
                /**
                 * Removes assignment record for a given event and a resource.
                 *
                 * @param {Scheduler.model.EventModel|String|Number} event
                 * @param {Scheduler.model.ResourceModel|String|Number} resource
                 * @category Assignment
                 */

              }, {
                key: "unassignEventFromResource",
                value: function unassignEventFromResource(event, resource) {
                  var me = this,
                      assignmentStore = me.assignmentStore;

                  if (assignmentStore) {
                    assignmentStore.unassignEventFromResource(event, resource);
                  } else {
                    event = me.getById(event);
                    resource = resource instanceof _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_17__["default"] ? resource.id : resource; // resource id might be 0 thus we use ? operator

                    if (event && event.resourceId == resource) {
                      event.resourceId = null;
                    }
                  }
                }
                /**
                 * Reassigns an event from an old resource to a new resource
                 *
                 * @param {Scheduler.model.EventModel}    event    An event or id of the event to reassign
                 * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} oldResource A resource or id to unassign from
                 * @param {Scheduler.model.ResourceModel|Scheduler.model.ResourceModel[]} newResource A resource or id to assign to
                 * @category Assignment
                 */

              }, {
                key: "reassignEventFromResourceToResource",
                value: function reassignEventFromResourceToResource(event, oldResource, newResource) {
                  var me = this,
                      assignmentStore = me.assignmentStore,
                      newResourceId = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"].asId(newResource),
                      oldResourceId = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"].asId(oldResource);

                  if (assignmentStore) {
                    var assignment = assignmentStore.getAssignmentForEventAndResource(event, oldResource);

                    if (assignment) {
                      assignment.resourceId = newResourceId;
                    } else {
                      assignmentStore.assignEventToResource(event, newResource);
                    }
                  } else {
                    event = me.getById(event);

                    if (event.resourceId == oldResourceId) {
                      event.resourceId = newResourceId;
                    }
                  }
                }
                /**
                 * Checks whether an event is assigned to a resource.
                 *
                 * @param {Scheduler.model.EventModel|String|Number} event
                 * @param {Scheduler.model.ResourceModel|String|Number} resource
                 * @return {Boolean}
                 * @category Assignment
                 */

              }, {
                key: "isEventAssignedToResource",
                value: function isEventAssignedToResource(event, resource) {
                  var me = this,
                      assignmentStore = me.assignmentStore;
                  if (assignmentStore) return assignmentStore.isEventAssignedToResource(event, resource);
                  event = me.getById(event);
                  resource = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"].asId(resource);
                  return event && event.resourceId == resource || false;
                }
                /**
                 * Removes all assignments for given event
                 *
                 * @param {Scheduler.model.EventModel|String|Number} event
                 * @category Assignment
                 */

              }, {
                key: "removeAssignmentsForEvent",
                value: function removeAssignmentsForEvent(event) {
                  var me = this,
                      assignmentStore = me.assignmentStore;

                  if (assignmentStore) {
                    assignmentStore.removeAssignmentsForEvent(event);
                  } else {
                    event = me.getById(event);
                    if (event) event.resourceId = null; // This will update resource events cache via 'update' event
                  }
                }
                /**
                 * Removes all assignments for given resource
                 *
                 * @param {Scheduler.model.ResourceModel|String|Number} resource
                 * @category Assignment
                 */

              }, {
                key: "removeAssignmentsForResource",
                value: function removeAssignmentsForResource(resource) {
                  var me = this,
                      assignmentStore = me.assignmentStore,
                      resourceStore = me.resourceStore;

                  if (assignmentStore) {
                    assignmentStore.removeAssignmentsForResource(resource);
                  } else if (resourceStore) {
                    resource = resourceStore.getById(resource); // TODO: change to use model cache
                    //resource && me.resourceEventsCache.get(resource).forEach(event => {
                    //    event.resourceId = null; // This will update resource events cache via 'update' event
                    //});
                  } else {
                    resource = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_14__["default"].asId(resource); // resource id might be 0 thus we use ? operator

                    me.forEach(function (event) {
                      return event.resourceId == resource && (event.resourceId = null);
                    });
                  }
                } //endregion

              }, {
                key: "resourceStore",
                // doDestroy() {
                //      this.modelPersistencyManager.destroy();
                // }
                //endregion
                //region Connected stores (Resource, Assigment & Dependency)

                /**
                 * Get/set the resource store for this store
                 * @property {Scheduler.data.ResourceStore}
                 */
                get: function get() {
                  return this._resourceStore;
                },
                set: function set(resourceStore) {
                  var me = this,
                      oldStore = me._resourceStore;

                  if (oldStore) {
                    oldStore.eventStore = null;
                    if (me.modelPersistencyManager) me.modelPersistencyManager.resourceStore = null;
                  }

                  me._resourceStore = resourceStore || null;

                  if (resourceStore) {
                    if (me.modelPersistencyManager) me.modelPersistencyManager.resourceStore = me._resourceStore;
                    resourceStore.eventStore = me;
                  } // If store is assigned after configuration we need to init relations


                  if (!me.isConfiguring) {
                    me.initRelations(true);
                  }

                  if ((oldStore || resourceStore) && oldStore !== resourceStore) {
                    /**
                     * Fires when new resource store is set via {@link #property-resourceStore} setter.
                     * @event resourcestorechange
                     * @param {Scheduler.data.EventStore}         this
                     * @param {Scheduler.data.ResourceStore} newResourceStore
                     * @param {Scheduler.data.ResourceStore} oldResourceStore
                     */
                    me.trigger('resourceStoreChange', {
                      newResourceStore: resourceStore,
                      oldResourceStore: oldStore
                    });
                  }
                }
                /**
                 * Get/set assignment store this event store is using by default
                 * @property {Scheduler.data.AssignmentStore}
                 */

              }, {
                key: "assignmentStore",
                get: function get() {
                  return this._assignmentStore;
                },
                set: function set(assignmentStore) {
                  var me = this,
                      oldStore = me._assignmentStore;

                  if (oldStore) {
                    oldStore.eventStore = null;
                    if (me.modelPersistencyManager) me.modelPersistencyManager.assignmentStore = null;
                  }

                  me._assignmentStore = assignmentStore || null;

                  if (assignmentStore) {
                    if (me.modelPersistencyManager) me.modelPersistencyManager.assignmentStore = me._assignmentStore;
                    assignmentStore.eventStore = me;
                  } // If store is assigned after configuration we need to init relations


                  if (!me.isConfiguring) {
                    me.initRelations(true);
                  }

                  if ((oldStore || assignmentStore) && oldStore !== assignmentStore) {
                    /**
                     * Fires when new assignment store is set via {@link #property-assignmentStore} setter.
                     * @event assignmentStoreChange
                     * @param {Scheduler.data.EventStore}           this
                     * @param {Scheduler.data.AssignmentStore} newAssignmentStore
                     * @param {Scheduler.data.AssignmentStore} oldAssignmentStore
                     */
                    me.trigger('assignmentStoreChange', {
                      newAssignmentStore: assignmentStore,
                      oldAssignmentStore: oldStore
                    });
                  }
                }
                /**
                 * Get/set a dependecy store instance this event store is associated with
                 * Get/set a dependecy store instance this event store is associated with
                 * @property {Scheduler.data.DependencyStore}
                 */

              }, {
                key: "dependencyStore",
                get: function get() {
                  return this._dependencyStore;
                },
                set: function set(dependencyStore) {
                  var me = this,
                      oldStore = me._dependencyStore;

                  if (oldStore) {
                    oldStore.eventStore = null;
                    if (me.modelPersistencyManager) me.modelPersistencyManager.dependencyStore = null;
                  }

                  me._dependencyStore = dependencyStore || null;

                  if (me._dependencyStore) {
                    if (me.modelPersistencyManager) me.modelPersistencyManager.dependencyStore = me._dependencyStore;
                    me._dependencyStore.eventStore = me;
                  }

                  if ((oldStore || dependencyStore) && oldStore !== dependencyStore) {
                    /**
                     * Fires when new dependency store is set via {@link #property-dependencyStore} setter.
                     * @event dependencystorechange
                     * @param {Scheduler.data.EventStore}           this
                     * @param {Scheduler.data.DependencyStore} newDependencyStore
                     * @param {Scheduler.data.DependencyStore} oldDependencyStore
                     */
                    me.trigger('dependencyStoreChange', {
                      newDependencyStore: dependencyStore,
                      oldDependencyStore: oldStore
                    });
                  }
                }
              }]);

              return EventStoreMixin;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_13__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/data/mixin/ResourceStoreMixin.js":
      /*!********************************************************!*\
        !*** ./lib/Scheduler/data/mixin/ResourceStoreMixin.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataMixinResourceStoreMixinJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/mixin/ResourceStoreMixin
         */

        /**
         * This is a mixin for the ResourceStore functionality. It is consumed by the {@link Scheduler.data.ResourceStore}.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ResourceStoreMixin, _ref);

              function ResourceStoreMixin() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ResourceStoreMixin);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ResourceStoreMixin).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ResourceStoreMixin, [{
                key: "getScheduledEventsInTimeSpan",
                value: function getScheduledEventsInTimeSpan(start, end) {
                  var eventStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.eventStore; // TODO: PORT check if correct

                  return this.reduce(function (events, resource) {
                    events.concat(eventStore.getEventsForResource(resource).reduce(function (events, event) {
                      if (event.intersectsRange(start, end)) events.push(event);
                    }));
                  });
                }
              }, {
                key: "eventStore",

                /**
                 * Get/set the associated event store instance
                 *
                 * @property {Scheduler.data.EventStore}
                 */
                get: function get() {
                  return this._eventStore;
                },
                set: function set(eventStore) {
                  var me = this;

                  if (me._eventStore !== eventStore) {
                    var oldStore = me._eventStore;
                    me._eventStore = eventStore || null;

                    if (eventStore && !eventStore.resourceStore) {
                      eventStore.resourceStore = me;
                    }
                    /**
                     * Fires when new event store is set via {@link #property-eventStore} method.
                     * @event eventstorechange
                     * @param {Scheduler.data.ResourceStore}   this
                     * @param {Scheduler.data.EventStore} newEventStore
                     * @param {Scheduler.data.EventStore} oldEventStore
                     */


                    me.trigger('eventStoreChange', {
                      newEventStore: eventStore,
                      oldEventStore: oldStore
                    });
                  }
                }
              }]);

              return ResourceStoreMixin;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/data/util/ModelPersistencyManager.js":
      /*!************************************************************!*\
        !*** ./lib/Scheduler/data/util/ModelPersistencyManager.js ***!
        \************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerDataUtilModelPersistencyManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ModelPersistencyManager;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/data/util/ModelPersistencyManager
         */

        /**
         * This class manages model persistency, it listens to model stores' beforesync event and removes all non persistable
         * records from sync operation. The logic has meaning only for CRUD-less sync operations.
         *
         * @private
         */

        var ModelPersistencyManager =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ModelPersistencyManager, _Base);

          function ModelPersistencyManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ModelPersistencyManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ModelPersistencyManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ModelPersistencyManager, [{
            key: "onEventStoreBeforeSync",
            // endregion
            // region Event handlers
            value: function onEventStoreBeforeSync(_ref) {
              var changes = _ref.changes;
              var me = this;
              me.removeNonPersistableRecordsToCreate(changes);
              return me.shallContinueSync(changes);
            }
          }, {
            key: "onResourceStoreBeforeSync",
            value: function onResourceStoreBeforeSync(_ref2) {
              var changes = _ref2.changes;
              var me = this;
              me.removeNonPersistableRecordsToCreate(changes);
              return me.shallContinueSync(changes);
            }
          }, {
            key: "onAssignmentStoreBeforeSync",
            value: function onAssignmentStoreBeforeSync(_ref3) {
              var changes = _ref3.changes;
              var me = this;
              me.removeNonPersistableRecordsToCreate(changes);
              return me.shallContinueSync(changes);
            }
          }, {
            key: "onDependencyStoreBeforeSync",
            value: function onDependencyStoreBeforeSync(_ref4) {
              var changes = _ref4.changes;
              var me = this;
              me.removeNonPersistableRecordsToCreate(changes);
              return me.shallContinueSync(changes);
            } // endregion
            // region Management rules

          }, {
            key: "removeNonPersistableRecordsToCreate",
            value: function removeNonPersistableRecordsToCreate(changes) {
              var recordsToCreate = changes.added || [],
                  r,
                  i; // We remove from the array we iterate thus we iterate from end to start

              for (i = recordsToCreate.length - 1; i >= 0; --i) {
                r = recordsToCreate[i];

                if (!r.isPersistable) {
                  recordsToCreate.splice(recordsToCreate.indexOf(r), 1);
                }
              } // Prevent empty create request


              if (recordsToCreate.length === 0) {
                changes.added.length = 0;
              }
            }
          }, {
            key: "shallContinueSync",
            value: function shallContinueSync(options) {
              return Boolean(options.added && options.added.length > 0 || options.modified && options.modified.length > 0 || options.removed && options.removed.length > 0);
            } // endregion

          }, {
            key: "eventStore",
            // region Event attachers
            set: function set(newEventStore) {
              var me = this;
              me.eventStoreDetacher && me.eventStoreDetacher();
              me._eventStore = newEventStore;

              if (newEventStore && newEventStore.autoCommit) {
                me.eventStoreDetacher = newEventStore.on({
                  beforecommit: me.onEventStoreBeforeSync,
                  thisObj: me,
                  detachable: true,
                  // Just in case
                  prio: 100
                });
              }
            },
            get: function get() {
              return this._eventStore;
            }
          }, {
            key: "resourceStore",
            set: function set(newResourceStore) {
              var me = this;
              me.resourceStoreDetacher && me.resourceStoreDetacher();
              me._resourceStore = newResourceStore;

              if (newResourceStore && newResourceStore.autoCommit) {
                me.resourceStoreDetacher = newResourceStore.on({
                  beforecommit: me.onResourceStoreBeforeSync,
                  thisObj: me,
                  detachable: true,
                  // Just in case
                  prio: 100
                });
              }
            },
            get: function get() {
              return this._resourceStore;
            }
          }, {
            key: "assignmentStore",
            set: function set(newAssignmentStore) {
              var me = this;
              me.assignmentStoreDetacher && me.assignmentStoreDetacher();
              me._assignmentStore = newAssignmentStore;

              if (newAssignmentStore && newAssignmentStore.autoSync) {
                me.assignmentStoreDetacher = newAssignmentStore.on({
                  beforecommit: me.onAssignmentStoreBeforeSync,
                  thisObj: me,
                  detachable: true,
                  // Just in case
                  prio: 100
                });
              }
            },
            get: function get() {
              return this._assignmentStore;
            }
          }, {
            key: "dependencyStore",
            set: function set(newDependencyStore) {
              var me = this;
              me.dependencyStoreDetacher && me.dependencyStoreDetacher();
              me._dependencyStore = newDependencyStore;

              if (newDependencyStore && newDependencyStore.autoSync) {
                me.dependencyStoreDetacher = newDependencyStore.on({
                  beforecommit: me.onDependencyStoreBeforeSync,
                  thisObj: me,
                  detachable: true,
                  // Just in case
                  prio: 100
                });
              }
            },
            get: function get() {
              return this._dependencyStore;
            }
          }]);

          return ModelPersistencyManager;
        }(_Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        ModelPersistencyManager._$name = 'ModelPersistencyManager';
        /***/
      },

      /***/
      "./lib/Scheduler/eventlayout/HorizontalLayout.js":
      /*!*******************************************************!*\
        !*** ./lib/Scheduler/eventlayout/HorizontalLayout.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerEventlayoutHorizontalLayoutJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HorizontalLayout;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/eventlayout/HorizontalLayout
         */

        /**
         * Base class for HorizontalLayoutPack & HorizontalLayoutStack. Should not be used directly, instead specify
         * {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventLayout} in Scheduler config (stack, pack or none):
         * @example
         * let scheduler = new Scheduler({
         *   eventLayout: 'stack'
         * });
         * @abstract
         * @private
         */

        var HorizontalLayout =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(HorizontalLayout, _Base);

          function HorizontalLayout() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, HorizontalLayout);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(HorizontalLayout).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(HorizontalLayout, [{
            key: "clearCache",
            value: function clearCache(resource) {
              if (resource) {
                delete this.nbrOfBandsByResource[resource.id];
              } else {
                this.nbrOfBandsByResource = {};
              }
            } // Input:
            // 1. Resource record
            // 2. Array of Event models, or a function to call to receive such event records lazily

          }, {
            key: "getNumberOfBands",
            value: function getNumberOfBands(resource, resourceEventsOrFn) {
              var nbrOfBandsByResource = this.nbrOfBandsByResource;

              if (nbrOfBandsByResource.hasOwnProperty(resource.id)) {
                return nbrOfBandsByResource[resource.id];
              }

              var resourceEvents = typeof resourceEventsOrFn === 'function' ? resourceEventsOrFn() : resourceEventsOrFn,
                  eventsData = resourceEvents.map(function (event) {
                return {
                  start: event.startDate,
                  end: event.endDate,
                  event: event
                };
              });
              return this.applyLayout(eventsData, resource);
            } // TODO DOC

          }, {
            key: "applyLayout",
            value: function applyLayout(events, resource) {
              var rowEvents = events.slice(),
                  // return a number of bands required
              newNbrBands = this.layoutEventsInBands(rowEvents);
              return this.nbrOfBandsByResource[resource.id] = newNbrBands;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                nbrOfBandsByResource: {},
                bandIndexToPxConvertFn: null,
                bandIndexToPxConvertThisObj: null
              };
            }
          }]);

          return HorizontalLayout;
        }(_Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        HorizontalLayout._$name = 'HorizontalLayout';
        /***/
      },

      /***/
      "./lib/Scheduler/eventlayout/HorizontalLayoutPack.js":
      /*!***********************************************************!*\
        !*** ./lib/Scheduler/eventlayout/HorizontalLayoutPack.js ***!
        \***********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerEventlayoutHorizontalLayoutPackJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HorizontalLayoutPack;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./HorizontalLayout.js */
        "./lib/Scheduler/eventlayout/HorizontalLayout.js");
        /* harmony import */


        var _PackMixin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./PackMixin.js */
        "./lib/Scheduler/eventlayout/PackMixin.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/eventlayout/HorizontalLayoutPack
         */

        /**
         * Handles layout of events within a row (resource) in horizontal mode. Packs events (adjusts their height) to fit
         * available row height
         *
         * @extends Scheduler/eventlayout/HorizontalLayout
         * @mixes Scheduler/eventlayout/PackMixin
         * @private
         */

        var HorizontalLayoutPack =
        /*#__PURE__*/
        function (_PackMixin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(HorizontalLayoutPack, _PackMixin);

          function HorizontalLayoutPack() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, HorizontalLayoutPack);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(HorizontalLayoutPack).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(HorizontalLayoutPack, [{
            key: "applyLayout",
            // Packs the events to consume as little space as possible
            value: function applyLayout(events) {
              var _this = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(HorizontalLayoutPack.prototype), "applyLayout", this).call(this, events, function (event, j, slot, slotSize) {
                event.height = slotSize;
                event.top = slot.start + j * slotSize;
              });

              events.forEach(function (event) {
                Object.assign(event, _this.bandIndexToPxConvertFn.call(_this.bandIndexToPxConvertThisObj || _this, event.top, event.height, null, event.event));
              });
            }
          }]);

          return HorizontalLayoutPack;
        }(Object(_PackMixin_js__WEBPACK_IMPORTED_MODULE_9__["default"])(_HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_8__["default"]));

        HorizontalLayoutPack._$name = 'HorizontalLayoutPack';
        /***/
      },

      /***/
      "./lib/Scheduler/eventlayout/HorizontalLayoutStack.js":
      /*!************************************************************!*\
        !*** ./lib/Scheduler/eventlayout/HorizontalLayoutStack.js ***!
        \************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerEventlayoutHorizontalLayoutStackJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HorizontalLayoutStack;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./HorizontalLayout.js */
        "./lib/Scheduler/eventlayout/HorizontalLayout.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/eventlayout/HorizontalLayoutStack
         */

        /**
         * Handles layout of events within a row (resource) in horizontal mode. Stacks events, increasing row height when to fit
         * all overlapping events.
         *
         * This layout is used by default in horizontal mode.
         *
         * @extends Scheduler/eventlayout/HorizontalLayout
         * @private
         */

        var HorizontalLayoutStack =
        /*#__PURE__*/
        function (_HorizontalLayout) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(HorizontalLayoutStack, _HorizontalLayout);

          function HorizontalLayoutStack() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, HorizontalLayoutStack);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(HorizontalLayoutStack).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(HorizontalLayoutStack, [{
            key: "layoutEventsInBands",
            // Input: Array of event layout data
            value: function layoutEventsInBands(events) {
              var verticalPosition = 0;

              do {
                var event = events[0];

                while (event) {
                  // Apply band height to the event cfg
                  event.top = this.bandIndexToPxConvertFn.call(this.bandIndexToPxConvertThisObj || this, verticalPosition, event.event); // Remove it from the array and continue searching

                  events.splice(events.indexOf(event), 1);
                  event = this.findClosestSuccessor(event, events);
                }

                verticalPosition++;
              } while (events.length > 0); // Done!


              return verticalPosition;
            } // TODO: optimize this for better performance with many events per resource

          }, {
            key: "findClosestSuccessor",
            value: function findClosestSuccessor(eventRenderData, events) {
              var minGap = Infinity,
                  closest,
                  eventEnd = eventRenderData.endMs,
                  gap,
                  isMilestone = eventRenderData.event.duration === 0,
                  evt;

              for (var i = 0, l = events.length; i < l; i++) {
                evt = events[i];
                gap = evt.startMs - eventEnd;

                if (gap >= 0 && gap < minGap && ( // Two milestones should not overlap
                gap > 0 || evt.endMs - evt.startMs > 0 || !isMilestone)) {
                  closest = evt;
                  minGap = gap;
                }
              }

              return closest;
            }
          }]);

          return HorizontalLayoutStack;
        }(_HorizontalLayout_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        HorizontalLayoutStack._$name = 'HorizontalLayoutStack';
        /***/
      },

      /***/
      "./lib/Scheduler/eventlayout/PackMixin.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/eventlayout/PackMixin.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerEventlayoutPackMixinJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/eventlayout/PackMixin
         */

        /**
         * Mixin holding functionality shared between HorizontalLayoutPack and VerticalLayout.
         *
         * @mixin
         * @private
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(PackMixin, _ref);

              function PackMixin() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, PackMixin);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PackMixin).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(PackMixin, [{
                key: "applyLayout",
                // Packs the events to consume as little space as possible
                value: function applyLayout(events, applyClusterFn) {
                  var me = this,
                      coordProp = me.coordProp,
                      sizeProp = me.sizeProp;
                  var slot, firstInCluster, cluster, j;

                  for (var i = 0, l = events.length; i < l; i++) {
                    firstInCluster = events[i];
                    slot = me.findStartSlot(events, firstInCluster);
                    cluster = me.getCluster(events, i);

                    if (cluster.length > 1) {
                      firstInCluster[coordProp] = slot.start;
                      firstInCluster[sizeProp] = slot.end - slot.start; // If there are multiple slots and events in the cluster have multiple start dates, group all same-start events into first slot

                      j = 1;

                      while (j < cluster.length - 1 && cluster[j + 1].start - firstInCluster.start === 0) {
                        j++;
                      } // See if there's more than 1 slot available for this cluster, if so - first group in cluster consumes the entire first slot


                      var nextSlot = me.findStartSlot(events, cluster[j]);

                      if (nextSlot && nextSlot.start < 0.8) {
                        cluster.length = j;
                      }
                    }

                    var clusterSize = cluster.length,
                        slotSize = (slot.end - slot.start) / clusterSize; // Apply fraction values

                    for (j = 0; j < clusterSize; j++) {
                      applyClusterFn(cluster[j], j, slot, slotSize);
                    }

                    i += clusterSize - 1;
                  }
                }
              }, {
                key: "findStartSlot",
                value: function findStartSlot(events, event) {
                  var sizeProp = this.sizeProp,
                      coordProp = this.coordProp,
                      priorOverlappers = this.getPriorOverlappingEvents(events, event);
                  var i;

                  if (priorOverlappers.length === 0) {
                    return {
                      start: 0,
                      end: 1
                    };
                  }

                  for (i = 0; i < priorOverlappers.length; i++) {
                    if (i === 0 && priorOverlappers[0][coordProp] > 0) {
                      return {
                        start: 0,
                        end: priorOverlappers[0][coordProp]
                      };
                    } else if (priorOverlappers[i][coordProp] + priorOverlappers[i][sizeProp] < (i < priorOverlappers.length - 1 ? priorOverlappers[i + 1][coordProp] : 1)) {
                      return {
                        start: priorOverlappers[i][coordProp] + priorOverlappers[i][sizeProp],
                        end: i < priorOverlappers.length - 1 ? priorOverlappers[i + 1][coordProp] : 1
                      };
                    }
                  }

                  return false;
                }
              }, {
                key: "getPriorOverlappingEvents",
                value: function getPriorOverlappingEvents(events, event) {
                  var start = event.start,
                      end = event.end,
                      overlappers = [];

                  for (var i = 0, l = events.indexOf(event); i < l; i++) {
                    if (_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].intersectSpans(start, end, events[i].start, events[i].end)) {
                      overlappers.push(events[i]);
                    }
                  }

                  overlappers.sort(this.sortOverlappers.bind(this));
                  return overlappers;
                }
              }, {
                key: "sortOverlappers",
                value: function sortOverlappers(e1, e2) {
                  return e1[this.coordProp] < e2[this.coordProp] ? -1 : 1;
                }
              }, {
                key: "getCluster",
                value: function getCluster(events, startIndex) {
                  var startEvent = events[startIndex];

                  if (startIndex >= events.length - 1) {
                    return [startEvent];
                  }

                  var evts = [startEvent],
                      l = events.length;
                  var start = startEvent.start,
                      end = startEvent.end,
                      i = startIndex + 1;

                  while (i < l && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].intersectSpans(start, end, events[i].start, events[i].end)) {
                    evts.push(events[i]);
                    start = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].max(start, events[i].start);
                    end = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].min(events[i].end, end);
                    i++;
                  }

                  return evts;
                }
              }], [{
                key: "defaultConfig",
                get: function get() {
                  return {
                    coordProp: 'top',
                    sizeProp: 'height'
                  };
                }
              }]);

              return PackMixin;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/eventlayout/VerticalLayout.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/eventlayout/VerticalLayout.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerEventlayoutVerticalLayoutJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return VerticalLayout;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _PackMixin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./PackMixin.js */
        "./lib/Scheduler/eventlayout/PackMixin.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/eventlayout/VerticalLayout
         */

        /**
         * Assists with event layout in vertical mode, handles `eventLayout: none|pack|mixed`
         * @private
         * @mixes Scheduler/eventlayout/PackMixin
         */

        var VerticalLayout =
        /*#__PURE__*/
        function (_PackMixin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(VerticalLayout, _PackMixin);

          function VerticalLayout() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, VerticalLayout);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(VerticalLayout).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(VerticalLayout, [{
            key: "applyLayout",
            // Try to pack the events to consume as little space as possible
            value: function applyLayout(events, columnWidth, resourceMargin, barMargin, columnIndex) {
              var _this = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(VerticalLayout.prototype), "applyLayout", this).call(this, events, function (tplData, clusterIndex, slot, slotSize) {
                // Stretch events to fill available width
                if (_this.scheduler.eventLayout === 'none') {
                  tplData.width = columnWidth - resourceMargin * 2;
                  tplData.left += resourceMargin;
                } else {
                  // Fractions of resource column
                  tplData.widthFactor = slotSize;
                  var leftFactor = tplData.leftFactor = slot.start + clusterIndex * slotSize,
                      // Number of "columns" in the current slot
                  packColumnCount = Math.round(1 / slotSize),
                      // Index among those columns for current event
                  packColumnIndex = leftFactor / slotSize,
                      // Width with all bar margins subtracted
                  availableWidth = columnWidth - resourceMargin * 2 - barMargin * (packColumnCount - 1); // Allowing two events to overlap? Slightly offset the second

                  if (_this.scheduler.eventLayout === 'mixed' && packColumnCount === 2) {
                    tplData.left += leftFactor * columnWidth / 5 + barMargin;
                    tplData.width = columnWidth - leftFactor * columnWidth / 5 - barMargin * 2;
                    tplData.zIndex = 5 + packColumnIndex;
                  } // Pack by default
                  else {
                      // Fractional width
                      tplData.width = slotSize * availableWidth; // Translate to absolute position

                      tplData.left += leftFactor * availableWidth + resourceMargin + barMargin * packColumnIndex;
                    }
                }
              });
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                coordProp: 'leftFactor',
                sizeProp: 'widthFactor'
              };
            }
          }]);

          return VerticalLayout;
        }(Object(_PackMixin_js__WEBPACK_IMPORTED_MODULE_6__["default"])());

        VerticalLayout._$name = 'VerticalLayout';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/AbstractTimeRanges.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/feature/AbstractTimeRanges.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureAbstractTimeRangesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return AbstractTimeRanges;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "./node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/DragHelper.js */
        "../Grid/lib/Common/helper/DragHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../tooltip/ClockTemplate.js */
        "./lib/Scheduler/tooltip/ClockTemplate.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../../Common/helper/ResizeHelper.js */
        "../Grid/lib/Common/helper/ResizeHelper.js");
        /* harmony import */


        var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../model/TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/AbstractTimeRanges
         */

        /**
         * Abstract base class, you should not use this class directly.
         * @abstract
         * @mixes Common/mixin/Delayable
         * @extends Common/mixin/InstancePlugin
         */

        var AbstractTimeRanges =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(AbstractTimeRanges, _Delayable);

          function AbstractTimeRanges() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, AbstractTimeRanges);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(AbstractTimeRanges).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(AbstractTimeRanges, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(client, config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(AbstractTimeRanges.prototype), "construct", this).call(this, client, config); // Add a unique cls used by subclasses to get custom styling of the elements rendered
              // This makes sure that each class only removed its own elements from the DOM


              me.cls = me.cls || "b-timerange-".concat(me.constructor.$name);
              me.baseSelector = ".".concat(me.baseCls, ".").concat(me.cls); // header elements are required for interaction

              if (me.enableResizing) {
                me.showHeaderElements = true;
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.storeDetacher && me.storeDetacher();
              me.timeAxisViewModelDetacher && me.timeAxisViewModelDetacher();
              me.timeAxisDetacher && me.timeAxisDetacher();
              me.clockTemplate && me.clockTemplate.destroy();
              me.tip && me.tip.destroy();
              me.drag && me.drag.destroy();
              me.resize && me.resize.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(AbstractTimeRanges.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Draw

          }, {
            key: "render",
            value: function render() {
              var me = this;
              me.timeAxisViewModel = me.client.timeAxisViewModel;
              me.timeAxisViewModelDetacher = me.timeAxisViewModel.on({
                reconfigure: me.onTimeAxisViewModelUpdate,
                update: me.onTimeAxisViewModelUpdate,
                thisObj: me
              });
              me.timeAxisDetacher = me.client.timeAxis.on({
                includeChange: me.onTimeAxisViewModelUpdate,
                thisObj: me
              });

              if (me.enableResizing) {
                me.drag = new _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
                  name: 'rangeDrag',
                  mode: me.client.isVertical ? 'translateY' : 'translateX',
                  constrain: true,
                  outerElement: me.headerContainerElement,
                  targetSelector: "".concat(me.baseSelector),
                  isElementDraggable: function isElementDraggable(el, event) {
                    return !me.client.readOnly && me.isElementDraggable(el, event);
                  },
                  listeners: {
                    dragstart: me.onDragStart,
                    drag: me.onDrag,
                    drop: me.onDrop,
                    abort: me.onInvalidDrop,
                    thisObj: me
                  }
                });
                me.resize = new _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"]({
                  direction: me.client.mode,
                  targetSelector: "".concat(me.baseSelector, ".b-sch-range"),
                  outerElement: me.headerContainerElement,
                  listeners: {
                    resizestart: me.onResizeStart,
                    resizing: me.onResizeDrag,
                    resize: me.onResize,
                    thisObj: me
                  }
                });
              }

              me.renderRanges();
            }
          }, {
            key: "renderRanges",
            value: function renderRanges() {
              var me = this,
                  element = me.client.foregroundCanvas; // Scheduler/Gantt might not yet be rendered

              if (element) {
                var headerContainerElement = me.headerContainerElement,
                    store = me.store; // remove existing timeRanges

                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].removeEachSelector(element, me.baseSelector);

                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].removeEachSelector(headerContainerElement, me.baseSelector);

                if (!me.disabled) {
                  // add timeRanges
                  var _iteratorNormalCompletion = true;
                  var _didIteratorError = false;
                  var _iteratorError = undefined;

                  try {
                    for (var _iterator = store[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                      var range = _step.value;
                      me.renderRange(range, true);
                    }
                  } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                      }
                    } finally {
                      if (_didIteratorError) {
                        throw _iteratorError;
                      }
                    }
                  }
                }
              }
            }
          }, {
            key: "renderRange",
            value: function renderRange(range, injectIntoDom) {
              var me = this,
                  client = me.client;

              if (!client.rendered) {
                return;
              }

              if (range.duration && client.timeAxis.timeSpanInAxis(range.startDate, range.endDate) || range.startDate && client.timeAxis.dateInAxis(range.startDate)) {
                var startPos = client.getCoordinateFromDate(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].max(range.startDate, client.timeAxis.startDate), {
                  respectExclusion: true
                }),
                    endPos = range.duration && client.getCoordinateFromDate(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].min(range.endDate, client.timeAxis.endDate), {
                  respectExclusion: true,
                  isEnd: true
                }),
                    labelTpl = "<label>".concat(range.name || '&nbsp;', "</label>"),
                    config = {
                  className: "".concat(me.baseCls, " ").concat(me.cls, " ").concat(endPos ? me.rangeCls : me.lineCls, " ").concat(range.cls || ''),
                  dataset: {
                    id: range.id
                  },
                  style: client.isVertical ? "transform: translateY(".concat(startPos, "px); ").concat(endPos ? "height:".concat(endPos - startPos, "px") : '', ";") : "transform: translateX(".concat(startPos, "px); ").concat(endPos ? "width:".concat(endPos - startPos, "px") : '', ";"),
                  retainElement: true // To prevent DomHelper.sync from reusing the element

                },
                    bodyElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement(Object.assign({}, config, {
                  parent: injectIntoDom && client.foregroundCanvas,
                  style: config.style + (range.style || ''),
                  html: me.showHeaderElements ? '' : labelTpl
                }));

                var headerElement;

                if (me.showHeaderElements) {
                  headerElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement(Object.assign({
                    parent: injectIntoDom && me.headerContainerElement,
                    html: range.name ? labelTpl : ''
                  }, config));
                }

                var result = {
                  bodyElement: bodyElement,
                  headerElement: headerElement
                };

                if (injectIntoDom) {
                  // Make the label run vertically if it overflows the width
                  me.rotateLabel(result);
                }

                return result;
              }
            }
          }, {
            key: "rotateLabel",
            value: function rotateLabel(_ref) {
              var bodyElement = _ref.bodyElement;
              var label = bodyElement.firstChild; // Lines have no label

              if (!label) {
                return;
              } // Remove any rotation so with can be measured.


              label.classList.remove('b-vertical');
              var rotate = this.client.isVertical ? label.offsetHeight < bodyElement.offsetHeight : label.offsetWidth > bodyElement.offsetWidth; // If it overflows, rotate it.

              label.classList[rotate ? 'add' : 'remove']('b-vertical');
            } // returns one body el (+ optionally one header el) that represents a time range, or null if timeRanges is not currently rendered

          }, {
            key: "getElementsByRecord",
            value: function getElementsByRecord(idOrRecord) {
              var id = typeof idOrRecord === 'string' ? idOrRecord : idOrRecord.id,
                  bodyElement = this.client.foregroundCanvas.querySelector("".concat(this.baseSelector, "[data-id=\"").concat(id, "\"]")),
                  headerElement = this.headerContainerElement.querySelector("".concat(this.baseSelector, "[data-id=\"").concat(id, "\"]"));
              return bodyElement ? {
                bodyElement: bodyElement,
                headerElement: headerElement
              } : null;
            }
          }, {
            key: "getBodyElementByRecord",
            value: function getBodyElementByRecord(idOrRecord) {
              var id = typeof idOrRecord === 'string' ? idOrRecord : idOrRecord.id;
              return this.client.foregroundCanvas.querySelector("".concat(this.baseSelector, "[data-id=\"").concat(id, "\"]"));
            }
          }, {
            key: "getRecordByElement",
            value: function getRecordByElement(el) {
              return this.store.getById(el.dataset.id);
            }
          }, {
            key: "getHeaderMenuItems",
            //endregion
            //region Menu items

            /**
             * @private
             */
            value: function getHeaderMenuItems(column, items) {
              return [];
            } //endregion
            //region Disable

            /**
             * Get/set the features disabled state
             * @property {Boolean}
             */

          }, {
            key: "onTimeAxisViewModelUpdate",
            //endregion
            //region Events
            value: function onTimeAxisViewModelUpdate() {
              this.renderRanges();
            }
          }, {
            key: "onStoreChanged",
            value: function onStoreChanged(event) {
              var me = this;

              if (me.isConfiguring) {
                return;
              } // Only animate changes that happen as a result of a pure data change, i.e. not after a drag drop


              if (event.action === 'update') {
                var existingElements = me.getElementsByRecord(event.record),
                    redrawnElements = me.renderRange(event.record, !existingElements);

                if (existingElements && !redrawnElements) {
                  existingElements.bodyElement.remove();
                  existingElements.headerElement && existingElements.headerElement.remove();
                }

                if (!existingElements || !redrawnElements) return;
                me.client.runWithTransition(function () {
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].sync(redrawnElements.bodyElement, existingElements.bodyElement);

                  if (me.showHeaderElements) {
                    _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].sync(redrawnElements.headerElement, existingElements.headerElement);
                  } // Make the label run vertically if it overflows the width


                  me.rotateLabel(existingElements);
                });
              } else {
                me.renderRanges();
              }
            } //endregion
            //region Drag drop

          }, {
            key: "showTip",
            value: function showTip(context) {
              var me = this;

              if (me.showTooltip) {
                me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_17__["default"]({
                  timeAxisViewModel: me.client.timeAxisViewModel
                });
                me.tip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
                  cls: 'b-interaction-tooltip',
                  align: 'b-t',
                  autoShow: true,
                  forElement: context.element,
                  getHtml: function getHtml() {
                    return me.getTipHtml(context.record, context.element);
                  }
                });
              }
            }
          }, {
            key: "isElementDraggable",
            value: function isElementDraggable(el) {
              el = el.closest(this.baseSelector);
              return el && !el.classList.contains('b-over-resize-handle');
            }
          }, {
            key: "onDragStart",
            value: function onDragStart(_ref2) {
              var context = _ref2.context;
              var me = this,
                  record = me.getRecordByElement(context.element.closest(me.baseSelector)),
                  rangeBodyEl = me.getBodyElementByRecord(record),
                  drag = me.drag;
              Object.assign(context, {
                record: record,
                rangeBodyEl: rangeBodyEl,
                originRangeX: _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getTranslateX(rangeBodyEl),
                originRangeY: _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getTranslateY(rangeBodyEl)
              });

              if (me.client.isVertical) {
                drag.minY = 0; // Moving the range, you can drag the start marker down until the end of the range hits the time axis end

                drag.maxY = me.timeAxisViewModel.totalSize - context.rangeBodyEl.offsetHeight;
              } else {
                drag.minX = 0; // Moving the range, you can drag the start marker right until the end of the range hits the time axis end

                drag.maxX = me.timeAxisViewModel.totalSize - context.rangeBodyEl.offsetWidth;
              }

              me.showTip(context);
            }
          }, {
            key: "onDrag",
            value: function onDrag(_ref3) {
              var context = _ref3.context; // sync body element with header element (x + width)

              if (this.client.isVertical) {
                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].setTranslateY(context.rangeBodyEl, _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getTranslateY(context.element));
              } else {
                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].setTranslateX(context.rangeBodyEl, _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].getTranslateX(context.element));
              }

              if (this.showTooltip) {
                this.tip.realign();
              }
            }
          }, {
            key: "onDrop",
            value: function onDrop(_ref4) {
              var context = _ref4.context;

              if (!context.valid) {
                return this.onInvalidDrop({
                  context: context
                });
              }

              var me = this,
                  record = context.record,
                  box = context.rangeBodyEl.getBoundingClientRect(),
                  newStart = me.client.getDateFromCoordinate(me.client.isVertical ? box.top : box.left, 'round', false),
                  wasModified = record.startDate - newStart !== 0;

              if (wasModified) {
                record.setStartDate(newStart);
              } else {
                me.onInvalidDrop();
              }

              if (me.tip) {
                me.tip.destroy();
                me.tip = null;
              }
            }
          }, {
            key: "onInvalidDrop",
            value: function onInvalidDrop() {
              var me = this;
              me.drag.reset();
              me.renderRanges();

              if (me.tip) {
                me.tip.destroy();
                me.tip = null;
              }
            } // endregion
            // region resize

          }, {
            key: "onResizeStart",
            value: function onResizeStart(_ref5) {
              var context = _ref5.context;
              var me = this,
                  record = me.getRecordByElement(context.element.closest(me.baseSelector)),
                  rangeBodyEl = me.getBodyElementByRecord(record);
              Object.assign(context, {
                record: record,
                rangeBodyEl: rangeBodyEl
              });
              me.showTip(context);
            }
          }, {
            key: "onResizeDrag",
            value: function onResizeDrag(_ref6) {
              var context = _ref6.context;
              var me = this;

              if (me.client.isVertical) {
                if (context.edge === 'top') {
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].setTranslateY(context.rangeBodyEl, context.newY);
                }

                context.rangeBodyEl.style.height = context.newHeight + 'px';
              } else {
                if (context.edge === 'left') {
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].setTranslateX(context.rangeBodyEl, context.newX);
                }

                context.rangeBodyEl.style.width = context.newWidth + 'px';
              }

              if (me.showTooltip) {
                me.tip.realign();
              }
            }
          }, {
            key: "onResize",
            value: function onResize(_ref7) {
              var context = _ref7.context;
              if (!context.valid) return this.onInvalidDrop({
                context: context
              });
              var me = this,
                  client = me.client,
                  record = context.record,
                  box = context.element.getBoundingClientRect(),
                  startPos = client.isVertical ? box.top : box.left,
                  endPos = client.isVertical ? box.bottom : box.right,
                  newStart = client.getDateFromCoordinate(startPos, 'round', false),
                  isStart = context.edge === 'left' || context.edge === 'top',
                  newEnd = client.getDateFromCoordinate(endPos, 'round', false),
                  wasModified = isStart && record.startDate - newStart !== 0 || newEnd && record.endDate - newEnd !== 0;

              if (wasModified && newEnd > newStart) {
                if (isStart) {
                  // could be that the drag operation placed the range with start/end outside the axis
                  record.setStartDate(newStart, false);
                } else {
                  record.setEndDate(newEnd, false);
                }
              } else {
                me.onInvalidResize();
              }

              if (me.tip) {
                me.tip.destroy();
                me.tip = null;
              }
            }
          }, {
            key: "onInvalidResize",
            value: function onInvalidResize() {
              var me = this;
              me.resize.reset();
              me.renderRanges();

              if (me.tip) {
                me.tip.destroy();
                me.tip = null;
              }
            }
            /**
             * Gets html to display in tooltip during drag drop.
             */

          }, {
            key: "getTipHtml",
            value: function getTipHtml(record, element) {
              var me = this,
                  client = me.client,
                  box = element.getBoundingClientRect(),
                  startPos = client.isVertical ? box.top : box.left,
                  endPos = client.isVertical ? box.bottom : box.right,
                  startDate = client.getDateFromCoordinate(startPos, 'round', false),
                  endDate = record.endDate && client.getDateFromCoordinate(endPos, 'round', false),
                  startText = client.getFormattedDate(startDate),
                  endText = endDate && client.getFormattedEndDate(endDate, startDate);
              return me.dragTipTemplate({
                name: record.name || '',
                startDate: startDate,
                endDate: endDate,
                startText: startText,
                endText: endText,
                startClockHtml: me.clockTemplate.template({
                  date: startDate,
                  text: startText,
                  cls: 'b-sch-tooltip-startdate'
                }),
                endClockHtml: endText && me.clockTemplate.template({
                  date: endDate,
                  text: endText,
                  cls: 'b-sch-tooltip-enddate'
                })
              });
            } //endregion

          }, {
            key: "headerContainerElement",
            get: function get() {
              // Render into the subGrid´s header element or the vertical timeaxis depending on mode
              return this.client.isVertical ? this.client.timeView.element.parentElement : this.client.timeAxisColumn.element.parentElement;
            } //endregion

            /**
             * Get/set if header elements should be rendered
             * @property {boolean}
             */

          }, {
            key: "showHeaderElements",
            get: function get() {
              return this._showHeaderElements;
            },
            set: function set(show) {
              this._showHeaderElements = show;
              if (!this.client.element) return;

              if (show) {
                this.client.element.classList.add('b-sch-timeranges-with-headerelements');
              } else {
                this.client.element.classList.remove('b-sch-timeranges-with-headerelements');
              }

              this.renderRanges();
            }
          }, {
            key: "disabled",
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(AbstractTimeRanges.prototype), "disabled", this);
            },
            set: function set(disabled) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(AbstractTimeRanges.prototype), "disabled", disabled, this, true);

              this.renderRanges();
            }
            /**
             * Returns the {@link Common.data.Store store} used by this feature
             * @property {Common.data.Store}
             */

          }, {
            key: "store",
            get: function get() {
              return this._store;
            },
            set: function set(store) {
              var me = this;
              me._store = _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_13__["default"].getStore(store, _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_13__["default"]);
              var renderRanges = false; // if we had some store assigned before we need to detach it

              if (me.storeDetacher) {
                me.storeDetacher(); // then we'll need to render ranges provided by the new store

                renderRanges = true;
              }

              me.storeDetacher = me._store.on({
                change: me.onStoreChanged,
                thisObj: me
              }); // render ranges if needed

              renderRanges && this.renderRanges();
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                // CSS class to apply to range elements
                rangeCls: 'b-sch-range',
                // CSS class to apply to line elements (0-duration time range)
                lineCls: 'b-sch-line',

                /**
                 * Store that holds timeRanges (using the {@link Scheduler.model.TimeSpan} model or subclass thereof).
                 * A store will be automatically created if none is specified
                 * @config {Object|Common.data.Store}
                 */
                store: {
                  modelClass: _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_21__["default"]
                },

                /**
                 * Set to `true` to enable dragging and resizing of range elements in the header. Only relevant when {@link #config-showHeaderElements} is true.
                 * @config {Boolean}
                 * @defaultValue
                 */
                enableResizing: false,

                /**
                 * Specifies whether or not to show tooltip while resizing range elements
                 * @config {Boolean}
                 * @default
                 */
                showTooltip: true,

                /**
                 * `true` to render range elements into the time axis header
                 * @config {Boolean}
                 * @default
                 */
                showHeaderElements: true,
                dragTipTemplate: function dragTipTemplate(data) {
                  return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    <div class=\"b-sch-tip-name\">").concat(data.name || '', "</div>\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml || '', "\n                </div>\n            ");
                },
                baseCls: 'b-sch-timerange',
                // a unique cls used by subclasses to get custom styling of the elements rendered
                cls: ''
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['render', 'getHeaderMenuItems']
              };
            }
          }]);

          return AbstractTimeRanges;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_19__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_12__["default"]));

        AbstractTimeRanges._$name = 'AbstractTimeRanges';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/ColumnLines.js":
      /*!**********************************************!*\
        !*** ./lib/Scheduler/feature/ColumnLines.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureColumnLinesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ColumnLines;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/ColumnLines
         */

        /**
         * Displays column lines for ticks, with a thicker line for each major tick. If this feature is disabled, no lines are shown.
         * If it's enabled, line are shown for the tick level which is set in current ViewPreset. Please see {@link Scheduler.preset.ViewPreset#config-columnLinesFor} config for details.
         *
         * The lines are drawn to a canvas,
         * converted to an image and used as background in the schedulers background canvas. In certain scenarios, major column
         * lines are drawn as divs.
         *
         * The color and style of the lines are determined by extracting the values for `border-left-color` and
         * `border-left-style` (solid, dashed or dotted are supported) from the css rules for `.b-column-line` and
         * `.b-column-line-major`.
         *
         * This feature is **enabled** by default
         *
         * @extends Common/mixin/InstancePlugin
         * @demo basic
         * @externalexample scheduler/ColumnLines.js
         */

        var ColumnLines =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ColumnLines, _InstancePlugin);

          function ColumnLines() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ColumnLines);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ColumnLines).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ColumnLines, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(client, config) {
              var me = this;
              client.useBackgroundCanvas = true;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ColumnLines.prototype), "construct", this).call(this, client, config);

              me.timeAxisViewModel = client.timeAxisViewModel;
              client.on({
                theme: 'onThemeChange',
                thisObj: me
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.timeAxisViewModelDetatcher && this.timeAxisViewModelDetatcher();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ColumnLines.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Draw

            /**
             * Reads lines colors from temporary element
             * @private
             */

          }, {
            key: "getColorsFromCSS",
            value: function getColorsFromCSS() {
              var me = this; // Create two fake column lines. But only do it once per app.

              if (!me.GotColors) {
                var element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].createElement({
                  style: 'position: absolute; visibility: hidden',
                  html: '<div class="b-column-line"></div><div class="b-column-line-major"></div>',
                  parent: document.body
                }),
                    tickColor = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getStyleValue(element.firstElementChild, 'border-left-color'),
                    majorColor = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getStyleValue(element.lastElementChild, 'border-left-color'),
                    tickStyle = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getStyleValue(element.firstElementChild, 'border-left-style'),
                    majorTickStyle = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getStyleValue(element.lastElementChild, 'border-left-style');

                if (tickColor) {
                  me.tickColor = tickColor;
                }

                if (majorColor) {
                  me.majorTickColor = majorColor;
                }

                if (tickStyle) {
                  me.tickStyle = tickStyle;
                }

                if (majorTickStyle) {
                  me.majorTickStyle = majorTickStyle;
                }

                element.remove();
                me.GotColors = true;
              }
            }
          }, {
            key: "onThemeChange",
            value: function onThemeChange() {
              this.GotColors = false;
              this.render();
            }
            /**
             * Draw lines when scheduler/gantt is rendered.
             * @private
             */

          }, {
            key: "render",
            value: function render() {
              this.getColorsFromCSS();
              this.drawLines();
            }
            /**
             * Draw column lines to a offscreen canvas, convert to base64 and use as background image.
             * @private
             */

          }, {
            key: "drawLines",
            value: function drawLines() {
              // Early bailout for timeaxis without start date
              if (!this.client.timeAxis.startDate) {
                return;
              } // We cannot rely on timeAxisViewModel because rendered header may not include full top header.
              // This means we should generate whole top level tick and then iterate over ticks, calculating lines position
              // depending on header config


              var me = this,
                  client = me.client,
                  timeAxis = client.timeAxis,
                  axisStart = timeAxis.startDate,
                  viewModel = client.timeAxisViewModel,
                  tickSize = viewModel.tickSize,
                  element = client.backgroundCanvas,
                  canvas = document.createElement('canvas'),
                  ctx = canvas.getContext('2d'),
                  linesForLevel = viewModel.columnLinesFor,
                  targetHeader = viewModel.headerConfig[linesForLevel],
                  headers = viewModel.headers,
                  upperHeader = headers[headers.indexOf(targetHeader) - 1] || headers[0],
                  lowerHeader = headers[headers.length - 1],
                  startDate = timeAxis.floorDate(axisStart, false, upperHeader.unit, upperHeader.unit === 'year' ? 1 : upperHeader.increment || 1),
                  endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getNext(startDate, upperHeader.unit, upperHeader.increment || 1, timeAxis.weekStartDay),
                  ticksInHeader = Math.round(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getDurationInUnit(startDate, endDate, lowerHeader.unit)) / (lowerHeader.increment || 1),
                  nbrLinesToDraw = Math.round(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getDurationInUnit(startDate, endDate, targetHeader.unit)) / (targetHeader.increment || 1),
                  ratio = ticksInHeader / nbrLinesToDraw;

              if (client.isHorizontal) {
                if (axisStart) {
                  var doUnitsAlign = headers.length > 1 && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].doesUnitsAlign(upperHeader.unit, targetHeader.unit),
                      offsetDate = doUnitsAlign ? startDate : timeAxis.floorDate(axisStart, false, targetHeader.unit, targetHeader.increment),
                      // TODO: isContinuous check solved the issue I was seeing but not very generic
                  offset = !timeAxis.isContinuous ? 0 : _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].getDurationInUnit(offsetDate, axisStart, lowerHeader.unit, true) / timeAxis.increment * tickSize,
                      // this is position from left side of the canvas to draw first line, otherwi
                  startPos = 10,
                      height = 20;

                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].removeEachSelector(element, '.b-column-line-major');

                  var isMajor = false,
                      majorHeaderIsRegular = true;

                  if (targetHeader !== upperHeader && doUnitsAlign && lowerHeader.unit === 'day' && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].compareUnits(upperHeader.unit, 'month') !== -1) {
                    // This condition means, that major lines are irregular, e.g. when lower level is days and upper is
                    // months. Since months have different duration, we cannot safely repeat images
                    majorHeaderIsRegular = false;
                    timeAxis.forEachAuxInterval(upperHeader.unit, upperHeader.increment, function (start, end) {
                      _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].append(element, {
                        tag: 'div',
                        className: 'b-column-line-major',
                        style: "left:".concat(viewModel.getPositionFromDate(end) - 1, "px;")
                      });
                    });
                  } // hack for FF to not crash when trying to create too wide canvas.


                  canvas.width = Math.min(ticksInHeader * 2 * tickSize, 32767);
                  canvas.height = height;
                  ctx.translate(-0.5, -0.5);
                  ctx.lineWidth = 2;

                  for (var i = 0; i < nbrLinesToDraw; i++) {
                    // Only first interval may be major
                    if (i === 0) {
                      // Filtered time axis should not have any major lines
                      isMajor = upperHeader !== targetHeader && doUnitsAlign && majorHeaderIsRegular && timeAxis.isContinuous;
                    } else {
                      isMajor = false;
                    }

                    var tickStyle = isMajor && me.majorTickStyle || !isMajor && me.tickStyle;

                    if (tickStyle !== 'solid') {
                      switch (tickStyle) {
                        case 'dashed':
                          ctx.setLineDash([6, 4]);
                          break;

                        case 'dotted':
                          ctx.setLineDash([2, 3]);
                          break;
                      }
                    }

                    ctx.beginPath();
                    ctx.strokeStyle = isMajor ? me.majorTickColor : me.tickColor; // draw ticks

                    ctx.moveTo(i * ratio * tickSize * 2 + startPos - 1, 0);
                    ctx.lineTo(i * ratio * tickSize * 2 + startPos - 1, height + 2);
                    ctx.stroke();
                  } // use as background image


                  element.style.backgroundImage = "url(".concat(canvas.toDataURL(), ")");
                  element.style.backgroundSize = "".concat(canvas.width / 2, "px");
                  element.style.backgroundPositionX = "".concat(-(startPos / 2 + offset), "px");
                }
              } else {
                // hack for FF to not crash when trying to create too wide canvas.
                canvas.width = client.timeAxisColumn.resourceColumns.columnWidth * 2;
                canvas.height = 2;
                ctx.translate(-0.5, -0.5);
                ctx.lineWidth = 2;

                if (axisStart) {
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].removeEachSelector(element, '.b-column-line-major'); // Major lines always as divs to not get so large image


                  if (targetHeader !== upperHeader) {
                    timeAxis.forEachAuxInterval(upperHeader.unit, upperHeader.increment, function (start, end) {
                      _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].append(element, {
                        tag: 'div',
                        className: 'b-column-line-major',
                        style: "top:".concat(viewModel.getPositionFromDate(end) - 1, "px;")
                      });
                    });
                  }

                  if (me.tickStyle !== 'solid') {
                    switch (me.tickStyle) {
                      case 'dashed':
                        ctx.setLineDash([6, 4]);
                        break;

                      case 'dotted':
                        ctx.setLineDash([2, 3]);
                        break;
                    }
                  }

                  var _height = ratio * tickSize * 2;

                  canvas.height = _height;
                  ctx.beginPath();
                  ctx.strokeStyle = me.tickColor;
                  ctx.lineWidth = 2; // draw ticks

                  ctx.moveTo(0, _height - 1);
                  ctx.lineTo(canvas.width + 2, _height - 1);
                  ctx.stroke();
                }

                ctx.beginPath();
                ctx.strokeStyle = me.tickColor; // draw ticks

                ctx.moveTo(canvas.width - 1, 0);
                ctx.lineTo(canvas.width - 1, canvas.height + 2);
                ctx.stroke(); // use as background image

                element.style.backgroundImage = "url(".concat(canvas.toDataURL(), ")");
                element.style.backgroundSize = "".concat(canvas.width / 2, "px");
                element.style.backgroundPositionX = '0';
              }
            } //endregion
            //region Events

            /**
             * Redraw lines when time axis changes.
             * @private
             */

          }, {
            key: "updateCanvasSize",
            value: function updateCanvasSize() {
              this.drawLines();
            } //endregion

          }], [{
            key: "properties",
            //region Config
            get: function get() {
              return {
                tickColor: '#e6e6e6',
                majorTickColor: '#999',
                tickStyle: 'solid',
                majorTickStyle: 'solid'
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                after: ['render', 'updateCanvasSize']
              };
            }
          }]);

          return ColumnLines;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        ColumnLines._$name = 'ColumnLines';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(ColumnLines, true, ['Scheduler', 'Gantt']);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/Dependencies.js":
      /*!***********************************************!*\
        !*** ./lib/Scheduler/feature/Dependencies.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureDependenciesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Dependencies;
        });
        /* harmony import */


        var core_js_modules_es7_object_define_getter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.object.define-getter */
        "./node_modules/core-js/modules/es7.object.define-getter.js");
        /* harmony import */


        var core_js_modules_es7_object_define_getter__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_define_getter__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "./node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.map */
        "./node_modules/core-js/modules/es6.map.js");
        /* harmony import */


        var core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_map__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "./node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "./node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "./node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "./node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_16__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22__);
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ../../Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
        /*! ../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
        /*! ./mixin/DependencyCreation.js */
        "./lib/Scheduler/feature/mixin/DependencyCreation.js");
        /* harmony import */


        var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
        /*! ../model/DependencyModel.js */
        "./lib/Scheduler/model/DependencyModel.js");
        /* harmony import */


        var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
        /*! ../data/DependencyStore.js */
        "./lib/Scheduler/data/DependencyStore.js");
        /* harmony import */


        var _util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
        /*! ../util/RectangularPathFinder.js */
        "./lib/Scheduler/util/RectangularPathFinder.js");
        /* harmony import */


        var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
        /*! ../model/ResourceModel.js */
        "./lib/Scheduler/model/ResourceModel.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_5___default()(["\n             <table class=\"b-sch-dependency-tooltip\">\n                <tr>\n                    <td>", ": </td>\n                    <td>", "</td>\n                    <td>\n                        <div class=\"b-sch-box b-", "\"></div>\n                    </td>\n                </tr>\n                <tr>\n                    <td>", ": </td>\n                    <td>", "</td>\n                    <td><div class=\"b-sch-box b-", "\"></div></td>\n                </tr>\n            </table>\n        "]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/Dependencies
         */

        var fromBoxSide = ['left', 'left', 'right', 'right'],
            toBoxSide = ['left', 'right', 'left', 'right'];
        /**
         * Feature that draws dependencies between events Uses a {@link Scheduler.data.DependencyStore DependencyStore} to determine which dependencies to draw, if
         * none is defined one will be created automatically. Dependencies can also be specified as Scheduler#dependencies, see
         * example below.
         *
         * This feature is **disabled** by default. It is **not** supported in vertical mode.
         *
         * @mixes Scheduler/feature/mixin/DependencyCreation
         *
         * @extends Common/mixin/InstancePlugin
         * @demo dependencies
         * @externalexample scheduler/Dependencies.js
         */

        var Dependencies =
        /*#__PURE__*/
        function (_DependencyCreation) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_22___default()(Dependencies, _DependencyCreation);

          function Dependencies() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_17___default()(this, Dependencies);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_19___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Dependencies).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_18___default()(Dependencies, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(client) {
              var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var me = this;
              me.scheduler = client;

              if (client.isVertical) {
                throw new Error('Dependencies feature is not supported in vertical mode');
              } // Many things may schedule a draw. Ensure it only happens once, on the next frame.
              // And Ensure it really is on the *next* frame after invocation by passing
              // the cancelOutstanding flag.


              me.doScheduleDraw = me.createOnFrame('draw', [], me, true); // use scheduler's/gantt's DependencyStore if available

              if (client.dependencyStore) {
                config.store = client.dependencyStore;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Dependencies.prototype), "construct", this).call(this, client, config);

              client.store.on({
                refresh: me.onRowStoreRefresh,
                thisObj: me
              });
              client.rowManager.on({
                // TODO: check if these are needed, might be enough with chained renderContents
                translaterow: me.onTranslateRow,
                refresh: me.onRowsRefresh,
                rerender: me.onRowsRerender,
                changetotalheight: me.onChangeTotalHeight,
                thisObj: me
              }); // dependencies are drawn on scroll, both horizontal and vertical

              client.on({
                horizontalscroll: me.onHorizontalScroll,
                svgcanvascreated: me.createMarkers,
                togglenode: me.onToggleNode,
                scroll: me.onVerticalScroll,
                //            eventlayout      : me.onEventLayout,
                timelineviewportresize: me.onViewportResize,
                thisObj: me
              });
              me.bindEventStoreListeners();
              me.pathFinder = new _util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_35__["default"](me.pathFinderConfig);
              delete me.pathFinderConfig;
              me.lineDefAdjusters = me.createLineDefAdjusters(); // expose getter/setter for dependencies on scheduler

              Object.defineProperty(client, 'dependencies', {
                configurable: true,
                get: function get() {
                  return me.store.records;
                },
                set: function set(dependencies) {
                  return me.store.data = dependencies;
                }
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.tooltip && this.tooltip.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_21___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_20___default()(Dependencies.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "createMarkers",
            value: function createMarkers() {
              var me = this,
                  svg = me.client.svgCanvas,
                  endMarker = me.endMarker = me.initMarkerElement('arrowEnd', '8', 'M0,0 L0,6 L9,3 z'); // Edge and IE11 do not support required svg 2.0 orient value

              if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isEdge || _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11) {
                var startMarker = me.startMarker = me.initMarkerElement('arrowStart', '1', 'M0,3 L9,6 L9,0 z');
                svg.appendChild(startMarker);
              } else {
                endMarker.setAttribute('orient', 'auto-start-reverse');
              }

              svg.appendChild(endMarker);
            }
            /**
             * Creates SVG marker element (arrow) which is used for all dependency lines
             * @private
             * @param {String} id Id of the marker element
             * @param {String} refX
             * @param {String} arrowPath Path defining arrow
             */

          }, {
            key: "initMarkerElement",
            value: function initMarkerElement(id, refX, arrowPath) {
              return _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"].createElement({
                id: id,
                tag: 'marker',
                ns: 'http://www.w3.org/2000/svg',
                markerHeight: 9,
                markerWidth: 9,
                refX: refX,
                refY: 3,
                viewBox: '0 0 9 6',
                orient: 'auto',
                markerUnits: 'userSpaceOnUse',
                children: [{
                  tag: 'path',
                  ns: 'http://www.w3.org/2000/svg',
                  d: arrowPath
                }]
              });
            }
            /**
             * Returns an array of functions used to alter path config when no path found.
             * It first tries to shrink arrow margins and secondly hides arrows entirely
             * @private
             * @returns {Function[]}
             */

          }, {
            key: "createLineDefAdjusters",
            value: function createLineDefAdjusters() {
              var client = this.client;

              function shrinkArrowMargins(lineDef) {
                var adjusted = false;

                if (lineDef.startArrowMargin > client.barMargin || lineDef.endArrowMargin > client.barMargin) {
                  lineDef.startArrowMargin = lineDef.endArrowMargin = client.barMargin;
                  adjusted = true;
                }

                return adjusted ? lineDef : adjusted;
              }

              function resetArrowMargins(lineDef) {
                var adjusted = false;

                if (lineDef.startArrowMargin > 0 || lineDef.endArrowMargin > 0) {
                  lineDef.startArrowMargin = lineDef.endArrowMargin = 0;
                  adjusted = true;
                }

                return adjusted ? lineDef : adjusted;
              } // function shrinkStartEndMarginsBy2(lineDef) {
              //     let adjusted = false;
              //
              //     if (lineDef.hasOwnProperty('startHorizontalMargin') && lineDef.startHorizontalMargin > 2) {
              //         lineDef.startHorizontalMargin = Math.round(lineDef.startHorizontalMargin / 2);
              //         adjusted = true;
              //     }
              //     if (lineDef.hasOwnProperty('startVerticalMargin') && lineDef.startVerticalMargin > 2) {
              //         lineDef.startVerticalMargin = Math.round(lineDef.startVerticalMargin / 2);
              //         adjusted = true;
              //     }
              //     if (lineDef.hasOwnProperty('endHorizontalMargin') && lineDef.endHorizontalMargin > 2) {
              //         lineDef.endHorizontalMargin = Math.round(lineDef.endHorizontalMargin / 2);
              //         adjusted = true;
              //     }
              //     if (lineDef.hasOwnProperty('endVerticalMargin') && lineDef.endVerticalMargin > 2) {
              //         lineDef.endVerticalMargin = Math.round(lineDef.endVerticalMargin / 2);
              //         adjusted = true;
              //     }
              //
              //     return adjusted ? lineDef : adjusted;
              // }
              //
              // function resetArrowSizes(lineDef) {
              //     let adjusted = false;
              //
              //     if (lineDef.startArrowSize > 0 || lineDef.endArrowSize > 0) {
              //         lineDef.startArrowSize = lineDef.endArrowSize = 0;
              //         adjusted = true;
              //     }
              //
              //     return adjusted ? lineDef : adjusted;
              // }


              return [shrinkArrowMargins, resetArrowMargins //,
              // shrinkStartEndMarginsBy2,
              // shrinkStartEndMarginsBy2,
              // shrinkStartEndMarginsBy2,
              // resetArrowSizes
              ];
            } //endregion
            //region Elements

          }, {
            key: "getElementForDependency",
            value: function getElementForDependency(dependency) {
              var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var selector = "[depId=\"".concat(dependency.id, "\"]");

              if (assignmentData) {
                selector += "[fromId=\"".concat(assignmentData.from.id, "\"][toId=\"").concat(assignmentData.to.id, "\"]");
              }

              return this.client.svgCanvas.querySelector(selector);
            }
          }, {
            key: "getDependencyForElement",
            value: function getDependencyForElement(element) {
              var id = typeof element === 'string' ? element : element.getAttribute('depId');
              return this.store.getById(id);
            } //endregion
            //region Events
            //region Events that triggers redraw

          }, {
            key: "onToggleNode",
            value: function onToggleNode() {
              // Need to repopulate grid cache
              this.dependencyGridCache = null; // node toggled in tree, can affect resources both above and below, need to redraw all.

              this.scheduleDraw(true);
            } // onEventLayout() {
            //     this.scheduleDraw(true);
            // }

          }, {
            key: "onViewportResize",
            value: function onViewportResize() {
              this.scheduleDraw(true);
            }
            /**
             * Flags for redrawing if a rows height has changed
             * @private
             */

          }, {
            key: "onTranslateRow",
            value: function onTranslateRow(_ref) {
              var row = _ref.row; // a changetotalheight event is fired after translations, if a rowHeight change is detected here it will redraw
              // all dependencies

              if (row.lastTop >= 0 && row.top !== row.lastTop) {
                this.scheduleDraw(true);
              }
            }
            /**
             * Redraws all dependencies if a rows height changed, as detected in onTranslateRow
             * @private
             */

          }, {
            key: "onChangeTotalHeight",
            value: function onChangeTotalHeight() {
              // redraw all dependencies if the height changes. Could be caused by resource add/remove.
              // in reality not all deps needs to be redrawn, those fully above the row which changed height could be left
              // as is, but determining that would likely require more processing than redrawing
              this.scheduleDraw(true);
            }
            /**
             * Draws dependencies on horizontal scroll
             * @private
             */

          }, {
            key: "onHorizontalScroll",
            value: function onHorizontalScroll() {
              // ResizeMonitor triggers scroll during render, make sure we have been drawn some other way before redrawing
              if (this.isDrawn) {
                this.scheduleDraw(false);
              }
            }
            /**
             * Draws dependencies on vertical scroll
             * @private
             */

          }, {
            key: "onVerticalScroll",
            value: function onVerticalScroll() {
              // ResizeMonitor triggers scroll during render, make sure render is done
              if (this.isDrawn) {
                // Do not invalidate on scroll, if height changes it will be invalidated anyway
                this.scheduleDraw(false);
              }
            }
          }, {
            key: "onRowsRefresh",
            value: function onRowsRefresh() {
              this.scheduleDraw(true);
            }
            /**
             * When rows are rerendered, better redraw dependencies (might have been collapsed etc).
             * @private
             */

          }, {
            key: "onRowsRerender",
            value: function onRowsRerender() {
              this.scheduleDraw(true);
            }
            /**
             * Redraws dependencies when a row has changed
             * @private
             */

          }, {
            key: "onRowStoreRefresh",
            value: function onRowStoreRefresh(_ref2) {
              var action = _ref2.action;

              switch (action) {
                case 'sort':
                case 'filter':
                case 'batch':
                  // Will need to recreate grid cache after sort, filter, and any unspecified
                  // set of operations encapsulated by a batch, and redraw everything
                  this.dependencyGridCache = null;
                  return this.scheduleDraw(true);
              }
            }
            /**
             * Redraws dependencies when a dependency has changed
             * @private
             */

          }, {
            key: "onDependencyChange",
            value: function onDependencyChange(_ref3) {
              var action = _ref3.action,
                  record = _ref3.record,
                  records = _ref3.records;
              var me = this;

              if (!me.scheduler.rendered || me.disabled) {
                return;
              }

              switch (action) {
                case 'dataset':
                  me.dependencyGridCache = {};
                // dataset should fall through to add after clearing the cache
                // eslint disable no-fallthrough

                case 'add':
                  // dependency added, draw it
                  // Check if there is a cache exists. If it does - use it,
                  // if not - create one after all records are drawn, this will cache all existing records
                  var cache = me._dependencyGridCache;
                  records.forEach(function (dependency) {
                    // Previously this code would draw added dependencies here, no matter if in view or not. To not have
                    // to have the logic for determining whats in view or not here also, simply do a full draw below.
                    // Old approach was especially costly when using CrudManager, which adds on load
                    cache && me.addToGridCache(dependency);
                  });

                  if (!cache) {
                    me._thisIsAUsedExpression(me.dependencyGridCache);
                  }

                  me.scheduleDraw();
                  return;

                case 'update':
                  // Dependency updated. Might have changed source or target, redraw it completely
                  return me.scheduleRefreshDependency(record);

                case 'remove':
                  // dependencies removed, release elements and remove from cache
                  records.forEach(function (dependency) {
                    me.releaseDependency(dependency, true);
                    me.removeFromCache(dependency);
                  });
                  me.client.trigger('dependenciesDrawn');
                  return;
                // Removing all or filtering -> full redraw

                case 'removeall':
                case 'filter':
                  me.dependencyGridCache = null; // continue to schedule draw

                  break;
              } // other changes (removeall, dataset, filter) trigger full redraw


              me.scheduleDraw(true);
            }
            /**
             * Attaches listeners to related event store, clears old listener if one exists
             * @private
             */

          }, {
            key: "bindEventStoreListeners",
            value: function bindEventStoreListeners() {
              var me = this;
              me._eventStoreListenersDetacher && me._eventStoreListenersDetacher(); // Maps to taskStore for Gantt

              me._eventStoreListenersDetacher = me.store.eventStore.on({
                change: me.onEventChange,
                thisObj: me
              });
            }
            /**
             * Redraws dependencies when an event has changed
             * @private
             */

          }, {
            key: "onEventChange",
            value: function onEventChange(_ref4) {
              var action = _ref4.action,
                  record = _ref4.record;

              switch (action) {
                case 'filter':
                  // filtering events, need to redraw all dependencies
                  return this.scheduleDraw(true);

                case 'update':
                  // event updated, redraw its dependencies
                  return this.drawForTimeSpan(record, true);

                case 'removeall':
                  this.resetGridCache();
                  return this.scheduleDraw(true);
              } // adding event has no effect on dependencies, unless it changes row height. in which case it will be handled
              // by onTranslateRow().
              // updating an event might also change row height, handled the same way.
              // removing events will also remove dependencies, thus handled in onDependencyChange

            }
          }, {
            key: "onAssignmentRefresh",
            value: function onAssignmentRefresh(_ref5) {
              var action = _ref5.action;

              if (action === 'dataset') {
                // Assigning using EventEdit replaces all assignments. Taking the easy way out, throwing cache away
                this.resetGridCache();
                this.scheduleDraw(true);
              }
            }
          }, {
            key: "onAssignmentChange",
            value: function onAssignmentChange(_ref6) {
              var action = _ref6.action,
                  record = _ref6.record,
                  records = _ref6.records;
              var me = this;

              if (record) {
                records = [record];
              }

              if (action === 'add' || action === 'remove' || action === 'update') {
                records.forEach(function (assignment) {
                  var dependencies = assignment.event ? me.store.getEventDependencies(assignment.event) : [];
                  dependencies.forEach(function (dependency) {
                    // New assignment added by other means than EventEdit
                    if (action === 'add') {
                      me.scheduleRefreshDependency(dependency);
                    } // Event unassigned, remove dep line
                    else if (action === 'remove') {
                        var assignments; // Removed source?

                        if (dependency.from === assignment.eventId) {
                          // Might point to a multi assigned event, need to remove all lines
                          assignments = dependency.targetEvent.assignments.map(function (to) {
                            return {
                              from: assignment,
                              to: to
                            };
                          });
                        } // Nope, target
                        else {
                            // Might point to a multi assigned event, need to remove all lines
                            assignments = dependency.sourceEvent.assignments.map(function (from) {
                              return {
                                from: from,
                                to: assignment
                              };
                            });
                          }

                        assignments.forEach(function (assignmentData) {
                          me.releaseDependency(dependency, assignmentData);
                          me.removeFromCache(dependency, assignmentData);
                        });
                      } // Single assignment updated, redraw lines for it
                      else if (action === 'update') {
                          var _assignments = me.getDependencyAssignments(dependency).filter(function (a) {
                            return a && (a.from === record || a.to === record);
                          });

                          _assignments.forEach(function (assignmentData) {
                            me.scheduleRefreshDependency(dependency, assignmentData);
                          });
                        }
                  });
                });
              }
            } //endregion

          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              var me = this;

              if (event.target.matches('.' + me.baseCls)) {
                var dependency = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_29__["default"].get(event.target).dependency,
                    eventName = event.type === 'click' ? 'Click' : 'DblClick';
                /**
                 * Fires on the owning Scheduler/Gantt when a click is registered on a dependency line.
                 * @event dependencyClick
                 * @param {Scheduler.view.Scheduler} source The scheduler
                 * @param {Scheduler.model.DependencyModel} dependency
                 * @param {MouseEvent} event
                 */

                /**
                 * Fires on the owning Scheduler/Gantt when a click is registered on a dependency line.
                 * @event dependencyDblClick
                 * @param {Scheduler.view.Scheduler} source The scheduler
                 * @param {Scheduler.model.DependencyModel} dependency
                 * @param {MouseEvent} event
                 */


                me.client.trigger("dependency".concat(eventName), {
                  dependency: dependency,
                  event: event
                });
              }
            }
          }, {
            key: "onElementDblClick",
            value: function onElementDblClick(event) {
              return this.onElementClick(event);
            }
          }, {
            key: "onElementMouseOver",
            value: function onElementMouseOver(event) {
              var me = this;

              if (event.target.matches('.' + me.baseCls)) {
                var dependency = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_29__["default"].get(event.target).dependency;
                /**
                 * Fires on the owning Scheduler/Gantt when the mouse moves over a dependency line.
                 * @event dependencyMouseOver
                 * @param {Scheduler.view.Scheduler} source The scheduler
                 * @param {Scheduler.model.DependencyModel} dependency
                 * @param {MouseEvent} event
                 */


                me.client.trigger('dependencyMouseOver', {
                  dependency: dependency,
                  event: event
                });
                if (me.overCls) me.highlight(dependency, me.overCls);
              }
            }
          }, {
            key: "onElementMouseOut",
            value: function onElementMouseOut(event) {
              var me = this;

              if (event.target.matches('.' + me.baseCls)) {
                var dependency = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_29__["default"].get(event.target).dependency;
                /**
                 * Fires on the owning Scheduler/Gantt when the mouse moves out of a dependency line.
                 * @event dependencyMouseOut
                 * @param {Scheduler.view.Scheduler} source The scheduler
                 * @param {Scheduler.model.DependencyModel} dependency
                 * @param {MouseEvent} event
                 */


                me.client.trigger('dependencyMouseOut', {
                  dependency: dependency,
                  event: event
                });
                if (me.overCls && !dependency.meta.removed) me.unhighlight(dependency);
              }
            } //endregion
            //region Highlight

          }, {
            key: "highlight",
            value: function highlight(dependency) {
              var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.overCls;
              var element = this.getElementForDependency(dependency);
              element && element.classList.add(cls);
              dependency.highlight(cls);
            }
          }, {
            key: "unhighlight",
            value: function unhighlight(dependency) {
              var cls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.overCls;
              var element = this.getElementForDependency(dependency);
              element && element.classList.remove(cls);
              dependency.unhighlight(cls);
            }
          }, {
            key: "highlightEventDependencies",
            value: function highlightEventDependencies(timespan) {
              var _this = this;

              timespan.allDependencies.forEach(function (dep) {
                return _this.highlight(dep);
              });
            }
          }, {
            key: "unhighlightEventDependencies",
            value: function unhighlightEventDependencies(timespan) {
              var _this2 = this;

              timespan.allDependencies.forEach(function (dep) {
                return _this2.unhighlight(dep);
              });
            } //endregion
            //region Determining dependencies to draw
            // Neither resource can be hidden for a dependency to be considered visible

          }, {
            key: "isDependencyVisible",
            value: function isDependencyVisible(dependency) {
              var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var from = dependency.sourceEvent,
                  to = dependency.targetEvent; // Bail out early in case source or target doesn't exist

              if (!(from && to)) {
                return false;
              }

              var fromResource, toResource; // Using multi-assignment, resource obtained from assignment

              if (assignmentData) {
                fromResource = assignmentData.from.resource;
                toResource = assignmentData.to.resource;
                var eventStore = this.client.eventStore; // Filtering EventStore does not filter AssignmentStore, determine if Event is available in this case

                if (eventStore.isFiltered && (eventStore.indexOf(from) === -1 || eventStore.indexOf(to) === -1)) {
                  return false;
                }
              } // Not using assignments, resource obtained from event
              else {
                  fromResource = from.resource;
                  toResource = to.resource;
                }

              return from instanceof _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_37__["default"] && // Verify these are real existing Resources and not placeholders (resource not existing in resource store)
              fromResource instanceof _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_36__["default"] && toResource instanceof _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_36__["default"] && !fromResource.instanceMeta(this.scheduler.store).hidden && !toResource.instanceMeta(this.scheduler.store).hidden;
            } // Get the bounding box for either the source or the target event

          }, {
            key: "getBox",
            value: function getBox(dependency, source) {
              var assignmentData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var eventRecord = this.getTimeSpanRecordFromDependency(dependency, source);
              var resource; // Multi-assignment, get resource from assignment

              if (assignmentData) {
                resource = assignmentData[source ? 'from' : 'to'].resource;
              } // Single, get resource from event
              else {
                  resource = eventRecord.resource;
                } // TODO: change getResourceEventBox to use Rectangle


              return this.scheduler.getResourceEventBox(eventRecord, resource, true);
            } // Get source or target events resource

          }, {
            key: "getRowRecordFromDependency",
            value: function getRowRecordFromDependency(dependency, source, assignmentData) {
              // Multi-assigned, use assignments resource
              if (assignmentData) {
                return assignmentData[source ? 'from' : 'to'].resource;
              } // Not multi-assigned, get events resource


              return this.getTimeSpanRecordFromDependency(dependency, source).resource;
            } // Get source or target event

          }, {
            key: "getTimeSpanRecordFromDependency",
            value: function getTimeSpanRecordFromDependency(dependency) {
              var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              return dependency["".concat(source ? 'source' : 'target', "Event")];
            }
          }, {
            key: "getMetaId",
            value: function getMetaId() {
              var assignmentData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
              return assignmentData ? "".concat(this.client.id, "-ass").concat(assignmentData.from.id, "-ass").concat(assignmentData.to.id) : this.client.id;
            } // Gets the source and target events bounds and unions them to determine the dependency bounds

          }, {
            key: "getDependencyBounds",
            value: function getDependencyBounds(dependency) {
              var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var me = this,
                  client = me.client,
                  ddr = dependency.getDateRange(); // quick bailout for hidden rows

              if (!client.rowManager.rowCount || !me.isDependencyVisible(dependency, assignmentData)) {
                return null;
              } // quick bailout in case dependency dates and view dates do not intersect


              if (!(ddr && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"].intersectSpans(ddr.start, ddr.end, client.startDate, client.endDate))) {
                return null;
              }

              var metaId = me.getMetaId(assignmentData),
                  instanceMeta = dependency.instanceMeta(metaId); // If we are forcing recalculation of dep bounds, or there are no calculated bounds for this dependency
              // or the calculated bounds were based on a "best guess", then recalculate the bounds.

              if (me._resetBoundsCache || !instanceMeta.bounds || !instanceMeta.bounds.layout) {
                var startBox = me.getBox(dependency, true, assignmentData),
                    endBox = me.getBox(dependency, false, assignmentData); // cant draw dependency if either start or end is in collapsed row

                if (!startBox || !endBox) {
                  return null;
                }

                var from = me.getTimeSpanRecordFromDependency(dependency, true),
                    to = me.getTimeSpanRecordFromDependency(dependency, false),
                    startRectangle = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_26__["default"](startBox.start, startBox.top, startBox.end - startBox.start, startBox.bottom - startBox.top),
                    endRectangle = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_26__["default"](endBox.start, endBox.top, endBox.end - endBox.start, endBox.bottom - endBox.top),
                    bounds = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_26__["default"].union(startRectangle, endRectangle);

                [[from, startRectangle, startBox], [to, endRectangle, endBox]].map(function (_ref7) {
                  var _ref8 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(_ref7, 3),
                      record = _ref8[0],
                      rectangle = _ref8[1],
                      eventBox = _ref8[2]; // When using other milestoneLayoutMode than default milestones should be treated as normal events.
                  // Milestones are zero width by default, so we must measure the milestone el's height
                  // (or icon el width) and use that as the width. We cannot use the event's calculated height because
                  // if there are labels, the milestone diamond will be smaller.
                  // If the event doesn't have an element, then it's outside of the rendered block and the exact
                  // width doesn't matter.


                  if (client.milestoneLayoutMode === 'default' && record.isMilestone) {
                    if (!client.milestoneWidth && eventBox.eventEl) {
                      client.milestoneWidth = record.iconCls ? eventBox.eventEl.firstElementChild.offsetWidth : parseInt(window.getComputedStyle(eventBox.eventEl, ':before').fontSize);
                    } // If it could not be measured due to the event being outside of the rendered block
                    // we have to use the calculated height.


                    var milestoneWidth = client.milestoneWidth || rectangle.height;
                    rectangle.left -= milestoneWidth / 2;
                    rectangle.right += milestoneWidth / 2;
                  }
                });
                instanceMeta.bounds = {
                  bounds: bounds,
                  startRectangle: startRectangle,
                  endRectangle: endRectangle,
                  // Cache whether both rectangles are based on the true layout
                  // or a best guess approximation to be recalculated
                  // next time through.
                  layout: startBox.layout && endBox.layout
                };
              }

              return dependency.instanceMeta(metaId).bounds;
            } // Grid cache is a virtual grid holding info on which dependencies intersects its virtual cells.
            // Used to determine which dependencies should be considered for drawing, iterating over all dependencies each update
            // gets too costly when count increases (>10000).
            //
            // Illustration shows entire schedule area, dddd is a dependency line, vvv is viewport, xxx virtual cell border:
            //
            // ----------------------------------
            // |     vvvvvxvvvvv                |
            // |     v    x    v                |
            // |     v d  x    v                |
            // |     v d  x    v                |
            // |xxxxxvxdxxx    v                |
            // |     vvdvvxvvvvv                |
            // |       d  x                     |
            // |       d  x                     |
            // |       d  x                     |
            // |xxxxxxxdxxxxxxx                 |
            // |       d  x                     |
            // |       d  x                     |
            // |          x                     |
            // |          x                     |
            // |xxxxxxxxxxxxxxx                 |
            // ----------------------------------
            //
            // The dependency crosses three virtual grid cells [0,0], [0,1] and [0,2]. Stored in a map in cache:
            // {
            //    0 : {
            //      0 : [ d, ... ],
            //      1 : [ d, ... ],
            //      2 : [ d, ... ]
            //    }
            // }
            //
            // Viewport crosses four virtual grid cells [0,0], [1,0], [0,1], [1,1]. Those cells are checked in the cached map to
            // find out which rows should be considered for drawing.
            //
            // This approach minimizes the amount of iteration needed

          }, {
            key: "getDependencyAssignments",
            // With multi-assign each dependency might be drawn several times
            value: function getDependencyAssignments(dependency) {
              if (!this.client.assignmentStore) {
                return [null]; // On purpose, to be iterable
              }

              var fromAssignments = dependency.sourceEvent && dependency.sourceEvent.assignments,
                  toAssignments = dependency.targetEvent && dependency.targetEvent.assignments,
                  assignments = []; // flatMap could be used, but not in Edge yet

              fromAssignments && fromAssignments.forEach(function (from) {
                return toAssignments && toAssignments.forEach(function (to) {
                  assignments.push({
                    from: from,
                    to: to
                  });
                });
              });
              return assignments;
            }
          }, {
            key: "addToGridCache",
            value: function addToGridCache(dependency) {
              var me = this,
                  dependencyGridCache = me.dependencyGridCache,
                  cacheGridSize = me.cacheGridSize,
                  rowStore = me.client.store,
                  assignments = me.getDependencyAssignments(dependency);
              assignments.forEach(function (assignmentData) {
                var dependencyBounds = me.getDependencyBounds(dependency, assignmentData);

                if (dependencyBounds) {
                  var metaId = me.getMetaId(assignmentData),
                      meta = dependency.instanceMeta(metaId),
                      metaGridCache = meta.gridCache = [],
                      // Using index vertically rather than y for reliability with variable row height
                  fromIndex = rowStore.indexOf(me.getRowRecordFromDependency(dependency, true, assignmentData)),
                      toIndex = rowStore.indexOf(me.getRowRecordFromDependency(dependency, false, assignmentData)),
                      topIndex = Math.min(fromIndex, toIndex),
                      bottomIndex = Math.max(fromIndex, toIndex),
                      // Convert dependency bounds/index into virtual grid cells
                  box = dependencyBounds.bounds,
                      boxLeft = Math.floor(Math.max(box.x, 0) / cacheGridSize.x),
                      boxRight = Math.floor(box.right / cacheGridSize.x),
                      boxTop = Math.floor(topIndex / cacheGridSize.index),
                      boxBottom = Math.floor(bottomIndex / cacheGridSize.index);
                  var cacheX, cacheY, x, y; // Store the dependency in the virtual cells which it intersects

                  for (x = boxLeft; x <= boxRight; x++) {
                    cacheX = dependencyGridCache[x] || (dependencyGridCache[x] = {});

                    for (y = boxTop; y <= boxBottom; y++) {
                      cacheY = cacheX[y] || (cacheX[y] = []);
                      cacheY.push({
                        dependency: dependency,
                        assignmentData: assignmentData,
                        metaId: metaId
                      });
                      metaGridCache.push([x, y]);
                    }
                  }
                }
              });
            }
          }, {
            key: "removeFromCache",
            value: function removeFromCache(dependency) {
              var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var me = this,
                  assignments = assignmentData ? [assignmentData] : me.getDependencyAssignments(dependency);
              assignments.forEach(function (assignmentData) {
                var metaId = me.getMetaId(assignmentData),
                    meta = dependency.instanceMeta(metaId);
                meta.gridCache && me._dependencyGridCache && meta.gridCache.forEach(function (_ref9) {
                  var _ref10 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(_ref9, 2),
                      x = _ref10[0],
                      y = _ref10[1];

                  if (me._dependencyGridCache.hasOwnProperty(x) && me._dependencyGridCache[x].hasOwnProperty(y)) {
                    var entries = me._dependencyGridCache[x][y],
                        index = entries.findIndex(function (d) {
                      return d.dependency === dependency && (d.assignmentData === assignmentData || d.assignmentData.from === assignmentData.from && d.assignmentData.to === assignmentData.to);
                    }); // Cannot use ArrayHelper#remove since it cannot compare deeply

                    if (index > -1) {
                      entries.splice(index, 1);
                    }
                  }
                });
                meta.bounds = null;
                meta.gridCache = null;
              });
            }
          }, {
            key: "resetBoundsCache",
            // Reset cached bounds, not grid cache since it is expensive to create. It is so coarse anyway so should be fine
            // with most changes, except for sorting and similar. Reset on demand instead
            value: function resetBoundsCache() {
              // Not actually resetting here, would just be costly to iterate and reset per dependency, instead flagging to
              // force cached value to be updated
              this._resetBoundsCache = true;
            } // In some cases we do need to reset cache, like when time axis is reconfigured

          }, {
            key: "resetGridCache",
            value: function resetGridCache() {
              this.dependencyGridCache = null;
            } //endregion
            //region Draw & render
            //region Lines

          }, {
            key: "prepareLineDef",
            value: function prepareLineDef(dependency, dependencyDrawData) {
              var assignmentData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var me = this,
                  source = me.getTimeSpanRecordFromDependency(dependency, true),
                  target = me.getTimeSpanRecordFromDependency(dependency, false),
                  type = dependency.type;
              var startSide = dependency.fromSide,
                  endSide = dependency.toSide; // Fallback to view trait if dependency start side is not given

              if (!startSide) {
                switch (true) {
                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.StartToEnd:
                    startSide = me.getConnectorStartSide(source);
                    break;

                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.StartToStart:
                    startSide = me.getConnectorStartSide(source);
                    break;

                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.EndToStart:
                    startSide = me.getConnectorEndSide(source);
                    break;

                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.EndToEnd:
                    startSide = me.getConnectorEndSide(source);
                    break;

                  default:
                    throw new Error('Invalid dependency type: ' + type);
                }
              } // Fallback to view trait if dependency end side is not given /*or can be obtained from type*/


              if (!endSide) {
                switch (true) {
                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.StartToEnd:
                    endSide = me.getConnectorEndSide(target);
                    break;

                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.StartToStart:
                    endSide = me.getConnectorStartSide(target);
                    break;

                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.EndToStart:
                    endSide = me.getConnectorStartSide(target);
                    break;

                  case type === _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_33__["default"].Type.EndToEnd:
                    endSide = me.getConnectorEndSide(target);
                    break;

                  default:
                    throw new Error('Invalid dependency type: ' + type);
                }
              }

              var startRectangle = dependencyDrawData.startRectangle,
                  endRectangle = dependencyDrawData.endRectangle;
              return {
                startBox: {
                  start: startRectangle.x,
                  end: startRectangle.right,
                  top: startRectangle.y,
                  bottom: startRectangle.bottom
                },
                endBox: {
                  start: endRectangle.x,
                  end: endRectangle.right,
                  top: endRectangle.y,
                  bottom: endRectangle.bottom
                },
                startSide: startSide,
                endSide: endSide
              };
            } // Draws a single SVG line that represents the dependency

          }, {
            key: "drawLine",
            value: function drawLine(canvas, dependency, points) {
              var assignmentData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
              var client = this.client,
                  metaId = this.getMetaId(assignmentData); // Reuse existing element if possible

              var line = dependency.instanceMeta(metaId).lineElement;

              if (!line) {
                line = dependency.instanceMeta(metaId).lineElement = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
                line.setAttribute('depId', dependency.id);

                if (assignmentData) {
                  line.setAttribute('fromId', assignmentData.from.id);
                  line.setAttribute('toId', assignmentData.to.id);
                }

                canvas.appendChild(line);
              } // TODO: Use DomHelper.syncClassList
              // className is SVGAnimatedString for svg elements, reading attribute instead


              line.classList.length && line.classList.remove.apply(line.classList, line.getAttribute('class').split(' '));
              line.classList.add(this.baseCls);

              if (dependency.cls) {
                line.classList.add(dependency.cls);
              }

              if (dependency.bidirectional) {
                line.classList.add('b-sch-bidirectional-line');
              }

              if (dependency.highlighted) {
                var _line$classList;

                (_line$classList = line.classList).add.apply(_line$classList, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_12___default()(dependency.highlighted.split(' ')));
              }

              if (_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].isIE11) {
                var ddr = dependency.getDateRange(true),
                    viewStart = client.startDate;

                if (ddr.start < viewStart) {
                  line.classList.add('b-no-start-marker');
                }

                if (ddr.end < viewStart) {
                  line.classList.add('b-no-end-marker');
                }
              }

              line.setAttribute('points', !points ? '' : points.map(function (p, i) {
                return i !== points.length - 1 ? "".concat(p.x1, ",").concat(p.y1) : "".concat(p.x1, ",").concat(p.y1, " ").concat(p.x2, ",").concat(p.y2);
              }).join(' '));

              _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_29__["default"].set(line, {
                dependency: dependency
              });
            } //endregion

            /**
             * Re-caches and redraws a dependency, for all assignments.
             * @param {Scheduler.model.DependencyModel} dependency Dependency to refresh
             */

          }, {
            key: "refreshDependency",
            value: function refreshDependency(dependency) {
              var me = this,
                  assignments = me.getDependencyAssignments(dependency); // Release dependency element, for all assignments if using AssignmentStore

              me.releaseDependency(dependency, assignments[0] !== null); // Remove it from grid & bounds cache

              me.removeFromCache(dependency); // Re-add it to grid cache

              me.addToGridCache(dependency); // Draw all assignments

              assignments.forEach(function (assignmentData) {
                return me.drawDependency(dependency, null, assignmentData);
              });
            }
            /**
             * Re-caches and redraws a dependency for given assignment.
             * @param {Scheduler.model.DependencyModel} dependency Dependency to refresh
             * @param {Object} assignmentData
             * @param {Scheduler.model.AssignmentModel} assignmentData.from Source assignment
             * @param {Scheduler.model.AssignmentModel} assignmentData.to Target assignment
             * @private
             */

          }, {
            key: "refreshDependencyAssignment",
            value: function refreshDependencyAssignment(dependency, assignmentData) {
              var me = this; // In case it was assigned to something not in view/timeline, release the line

              me.releaseDependency(dependency, assignmentData); // Update cache to only contain whats left of it

              me.removeFromCache(dependency, assignmentData);
              me.addToGridCache(dependency); // Draw lines

              me.drawDependency(dependency, null, assignmentData);
            }
            /**
             * Stores all dependencies/assignments that were requested to refresh and schedules repaint on next animation frame
             * @param {Scheduler.model.DependencyModel} dependency Dependency model to refresh
             * @param {Object} [assignmentData] Assignment data
             * @param {Scheduler.model.AssignmentModel} [assignmentData.from] Source assignment
             * @param {Scheduler.model.AssignmentModel} [assignmentData.to] Target assignment
             * @private
             */

          }, {
            key: "scheduleRefreshDependency",
            value: function scheduleRefreshDependency(dependency) {
              var _this3 = this;

              var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var map = this.dependenciesToRefresh; // If this method was called once without assignment data - all lines releated should be repainted

              if (!assignmentData) {
                map.set(dependency, true);
              } else if (map.has(dependency)) {
                if (map.get(dependency) !== true) {
                  map.get(dependency).add(assignmentData);
                }
              } else {
                map.set(dependency, new Set([assignmentData]));
              }

              if (map.size === 1) {
                this.requestAnimationFrame(function () {
                  _this3.refreshDependencyOnFrame();
                });
              }
            }
            /**
             * Repaints scheduled dependencies/assignments
             * @private
             */

          }, {
            key: "refreshDependencyOnFrame",
            value: function refreshDependencyOnFrame() {
              var me = this,
                  map = me.dependenciesToRefresh; // First clear cache and release dependencies. This will modify DOM

              map.forEach(function (assignments, dependency) {
                if (assignments === true) {
                  var _assignments2 = me.getDependencyAssignments(dependency); // Release dependency element, for all assignments if using AssignmentStore


                  me.releaseDependency(dependency, _assignments2[0] !== null); // Remove it from grid & bounds cache

                  me.removeFromCache(dependency);
                } else {
                  assignments.forEach(function (assignment) {
                    // In case it was assigned to something not in view/timeline, release the line
                    me.releaseDependency(dependency, assignment); // Update cache to only contain whats left of it

                    me.removeFromCache(dependency, assignment);
                  });
                }
              }); // Then fill cache before drawing dependencies. This will read the DOM forcing reflow

              map.forEach(function (assignments, dependency) {
                // Re-add it to grid cache
                me.addToGridCache(dependency);
              }); // Finally append elements to the DOM

              map.forEach(function (assignments, dependency) {
                if (assignments === true) {
                  assignments = me.getDependencyAssignments(dependency);
                }

                assignments.forEach(function (assignmentData) {
                  me.drawDependency(dependency, null, assignmentData);
                });
              });
              map.clear();
              me.client.trigger('dependenciesDrawn', {
                partial: true
              });
            }
            /**
             * Draws a single dependency (for a single assignment if using multiple), if in view.
             * @param {Scheduler.model.DependencyModel} dependency Dependency to draw
             */

          }, {
            key: "drawDependency",
            value: function drawDependency(dependency) {
              var drawData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var assignmentData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

              var me = this,
                  canvas = me.client.svgCanvas,
                  drawnDependencies = me.drawnDependencies,
                  oldDrawnDependencies = me.oldDrawnDependencies,
                  dependencyDrawData = drawData || me.getDependencyBounds(dependency, assignmentData),
                  lookup = function lookup(d) {
                return d.dependency === dependency && (d.assignmentData === assignmentData || d.assignmentData.from === assignmentData.from && d.assignmentData.to === assignmentData.to);
              };

              if (!me.disabled && dependencyDrawData) {
                // Build line defs
                var lineDef = me.prepareLineDef(dependency, dependencyDrawData),
                    lines = me.pathFinder.findPath(lineDef, me.lineDefAdjusters);
                me.drawLine(canvas, dependency, lines, assignmentData); // Cannot use ArrayHelper#include since object wont be the same, only its contents

                if (!drawnDependencies.some(lookup)) {
                  drawnDependencies.push({
                    dependency: dependency,
                    assignmentData: assignmentData
                  });
                }
              } // Remove from oldDrawnDeps, to not have element removed. Cannot use ArrayHelper#remove as stated above


              var oldIndex = oldDrawnDependencies && oldDrawnDependencies.findIndex(lookup);

              if (oldIndex >= 0) {
                oldDrawnDependencies.splice(oldIndex, 1);
              }
            }
            /**
             * Draws multiple dependencies, called from drawForEvent() or drawFromTask().
             * @private
             */

          }, {
            key: "drawForTimeSpan",
            value: function drawForTimeSpan(timeSpanRecord) {
              var async = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this; // If the client is doing an animated update, we must update at end.
              // That will be asynchronous relative to now, so do not pass on the async flag.

              if (me.client.isAnimating) {
                me.client.on({
                  transitionend: function transitionend() {
                    me.drawForTimeSpan(timeSpanRecord, true);
                  },
                  once: true
                });
              } // Otherwise, schedule the draw for the next frame.
              else {
                  me.store.getTimeSpanDependencies(timeSpanRecord).forEach(function (dependency) {
                    if (async) {
                      me.scheduleRefreshDependency(dependency);
                    } else {
                      me.refreshDependency(dependency);
                    }
                  });
                }
            }
            /**
             * Draws all dependencies for the specified event.
             */

          }, {
            key: "drawForEvent",
            value: function drawForEvent(eventRecord) {
              this.drawForTimeSpan(eventRecord);
            } // Redraw all dependencies for a particular eventRecord, using its current element instead of calculating a box
            // Used to do live redraw while resizing or dragging events

          }, {
            key: "updateDependenciesForTimeSpan",
            value: function updateDependenciesForTimeSpan(timeSpanRecord, element) {
              var me = this,
                  eventRecord = timeSpanRecord.isAssignment ? timeSpanRecord.event : timeSpanRecord,
                  deps = me.store.getTimeSpanDependencies(eventRecord),
                  metaId = me.getMetaId(),
                  client = me.client,
                  originalTaskRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_26__["default"].from(element, client.timeAxisSubGridElement);

              var bounds;
              deps.forEach(function (dep) {
                var assignments = me.getDependencyAssignments(dep);
                assignments.forEach(function (assignmentData) {
                  var taskRect = originalTaskRect.clone();
                  var startRectangle, endRectangle, box; // If dragging one multi assigned event the others wont move until it is dropped. Prevent their dep
                  // lines from updating by bailing out

                  if (assignmentData && assignmentData.from !== timeSpanRecord && assignmentData.to !== timeSpanRecord) {
                    return;
                  } // Bail out if dependency is not visible (other end might be collapsed)


                  if (!me.isDependencyVisible(dep, assignmentData)) {
                    return;
                  }

                  if (me.getTimeSpanRecordFromDependency(dep, true) === eventRecord) {
                    startRectangle = taskRect; // try to look into dependency cache first

                    if (bounds = dep.instanceMeta(metaId).bounds) {
                      endRectangle = bounds.endRectangle;
                    } else {
                      box = me.getBox(dep, false, assignmentData); // Row might be in collapsed node, in which case we get no box

                      if (box) {
                        endRectangle = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_26__["default"](box.start, box.top, box.end - box.start, box.bottom - box.top);
                      }
                    }
                  } else {
                    // try to look into dependency cache first
                    if (bounds = dep.instanceMeta(metaId).bounds) {
                      startRectangle = bounds.startRectangle;
                    } else {
                      box = me.getBox(dep, true, assignmentData); // Row might be in collapsed node, in which case we get no box

                      if (box) {
                        startRectangle = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_26__["default"](box.start, box.top, box.end - box.start, box.bottom - box.top);
                      }
                    }

                    endRectangle = taskRect;
                  }

                  if (startRectangle && endRectangle) {
                    me.drawDependency(dep, {
                      startRectangle: startRectangle,
                      endRectangle: endRectangle
                    }, assignmentData);
                  }
                });
              });
            }
          }, {
            key: "scheduleDraw",
            value: function scheduleDraw() {
              var relayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this; // There way be number of concurrent calls to this method, we need to reset cache if at least
              // once it was called with relayout = true

              if (relayout) {
                me.resetBoundsCache();
              } // If the scheduler/gantt is doing an animated update, schedule the draw
              // for when that's done so that we get correct element boxes.


              if (me.client.isAnimating) {
                if (!me.clientTransitionRemover) {
                  me.clientTransitionRemover = me.client.on({
                    transitionend: function transitionend() {
                      me.clientTransitionRemover();
                      me.clientTransitionRemover = null;
                      me.draw();
                    },
                    once: true
                  });
                }
              } // Otherwise, schedule the draw for the next frame.
              else {
                  me.doScheduleDraw();
                }
            }
            /**
             * Draws all dependencies that overlap the current viewport
             */

          }, {
            key: "draw",
            value: function draw() {
              var reLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this,
                  client = me.client; // Early bailout if we get here before we have any deps

              if (!me.oldDrawnDependencies && !me.store.count) {
                return;
              } // if animation is in progress, schedule drawing and skip current one


              if (client.isAnimating) {
                client.on({
                  transitionend: function transitionend() {
                    me.scheduleDraw(true);
                  },
                  once: true
                });
                return;
              } // viewBox is the bounds of the current viewport, used to determine which dependencies to draw


              var viewBox = me.client.timeAxisSubGrid.viewRectangle;

              if (reLayout) {
                me.resetBoundsCache();
              }

              me.oldDrawnDependencies = me.drawnDependencies;
              me.drawnDependencies = []; // too early

              if (!viewBox.width || !viewBox.height) return []; // expand viewBox with buffer size

              viewBox.inflate(me.bufferSize); // Do not draw if no rows

              if (!me.disabled && client.store.count && client.rowManager.rowCount) {
                var consideredDependencies = {},
                    dependencyGridCache = me.dependencyGridCache,
                    cacheGridSize = me.cacheGridSize,
                    viewLeft = Math.floor(Math.max(viewBox.left, 0) / cacheGridSize.x),
                    viewRight = Math.floor(viewBox.right / cacheGridSize.x),
                    topIndex = Math.floor(client.rowManager.topRow.dataIndex / cacheGridSize.index),
                    bottomIndex = Math.floor(client.rowManager.bottomRow.dataIndex / cacheGridSize.index),
                    dependenciesToDraw = [];
                var x, rowIndex, i; // Iterate over virtual dependency grid cells, pushing each dependency that intersects that cell

                for (x = viewLeft; x <= viewRight; x++) {
                  for (rowIndex = topIndex; rowIndex <= bottomIndex; rowIndex++) {
                    var cacheX = dependencyGridCache[x],
                        deps = cacheX && cacheX[rowIndex];

                    for (i = 0; deps && i < deps.length; i++) {
                      var _deps$i = deps[i],
                          dependency = _deps$i.dependency,
                          assignmentData = _deps$i.assignmentData,
                          metaId = _deps$i.metaId,
                          flagId = dependency.id + '-' + metaId;

                      if (!consideredDependencies[flagId]) {
                        // Only draw those actually in view
                        var bounds = me.getDependencyBounds(dependency, assignmentData);

                        if (bounds && bounds.bounds.intersect(viewBox, true)) {
                          dependenciesToDraw.push([dependency, bounds, assignmentData]);
                        }

                        consideredDependencies[flagId] = true;
                      }
                    }
                  }
                } // Append dependencies to the DOM only after all have been calculated


                dependenciesToDraw.forEach(function (_ref11) {
                  var _ref12 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_15___default()(_ref11, 3),
                      dependency = _ref12[0],
                      bounds = _ref12[1],
                      assignmentData = _ref12[2];

                  me.drawDependency(dependency, bounds, assignmentData);
                });
              } // Stop forcing recalculation of bounds


              me._resetBoundsCache = false; // Release elements for any dependencies that wasn't drawn

              me.oldDrawnDependencies.forEach(function (data) {
                return me.releaseDependency(data.dependency, data.assignmentData);
              });
              client.trigger('dependenciesDrawn');
              this.isDrawn = true;
            }
            /**
             * Release a dependency that is determined to be no longer visible
             * @param {Scheduler.model.DependencyModel} dependency
             */

          }, {
            key: "releaseDependency",
            value: function releaseDependency(dependency) {
              var _this4 = this;

              var assignmentData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null; // Remove for all assignments (related to this client, store might be shared)

              if (assignmentData === true) {
                Object.keys(dependency.meta.map || {}).filter(function (key) {
                  return key.startsWith(_this4.client.id);
                }).forEach(function (key) {
                  var data = dependency.meta.map[key];

                  if (data.lineElement) {
                    data.lineElement.remove();
                    data.lineElement = null;
                  }
                });
              } // Remove specific
              else {
                  var metaId = this.getMetaId(assignmentData),
                      lineElement = dependency.instanceMeta(metaId).lineElement;

                  if (lineElement) {
                    dependency.instanceMeta(metaId).lineElement = null; // Not reusing elements for other lines currently

                    lineElement.remove();
                  }
                }
            }
          }, {
            key: "render",
            value: function render() {
              var me = this,
                  client = me.scheduler;
              me.draw();

              if (me.showTooltip) {
                me.tooltip = me.createTooltip();
              }

              client.timeAxis.on({
                endreconfigure: me.resetGridCache,
                thisObj: me
              });
              client.assignmentStore && client.assignmentStore.on({
                change: me.onAssignmentChange,
                refresh: me.onAssignmentRefresh,
                thisObj: me
              });

              if (me.highlightDependenciesOnEventHover) {
                client.on(client.scheduledEventName + 'MouseEnter', function (params) {
                  return me.highlightEventDependencies(params.eventRecord || params.taskRecord);
                });
                client.on(client.scheduledEventName + 'MouseLeave', function (params) {
                  return me.unhighlightEventDependencies(params.eventRecord || params.taskRecord);
                });
              }
            }
          }, {
            key: "renderContents",
            value: function renderContents() {
              this.draw();
            } //endregion
            //region Connector sides

            /**
             * Gets displaying item start side
             *
             * @param {Scheduler.model.TimeSpan} timeSpanRecord
             * @return {String} 'left' / 'right' / 'top' / 'bottom'
             */

          }, {
            key: "getConnectorStartSide",
            value: function getConnectorStartSide(timeSpanRecord) {
              return this.client.currentOrientation.getConnectorStartSide(timeSpanRecord);
            }
            /**
             * Gets displaying item end side
             *getRowRecordFromDependency
             * @param {Scheduler.model.TimeSpan} timeSpanRecord
             * @return {String} 'left' / 'right' / 'top' / 'bottom'
             */

          }, {
            key: "getConnectorEndSide",
            value: function getConnectorEndSide(timeSpanRecord) {
              return this.client.currentOrientation.getConnectorEndSide(timeSpanRecord);
            } //endregion
            //region Tooltip

          }, {
            key: "createTooltip",
            value: function createTooltip() {
              var me = this;
              return new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_30__["default"](Object.assign({
                align: 'b-t',
                id: "".concat(me.client.id, "-dependency-tip"),
                //TODO: need some way better to specify this. maybe each feature should be queried?
                forSelector: ".b-timelinebase:not(.b-eventeditor-editing):not(.b-resizing-event):not(.b-dragcreating):not(.b-dragging-event):not(.b-creating-dependency) .".concat(me.baseCls),
                clippedBy: [me.client.timeAxisSubGridElement, me.client.bodyContainer],
                forElement: me.client.timeAxisSubGridElement,
                showOnHover: true,
                hoverDelay: 0,
                hideDelay: 0,
                anchorToTarget: false,
                trackMouse: false,
                getHtml: me.getHoverTipHtml.bind(me)
              }, me.tooltip || {}));
            }
            /**
             * Generates html for the tooltip shown when hovering a dependency
             * @param {Object} tooltipConfig
             * @returns {string} Html to display in the tooltip
             * @private
             */

          }, {
            key: "getHoverTipHtml",
            value: function getHoverTipHtml(_ref13) {
              var tip = _ref13.tip,
                  forElement = _ref13.forElement;
              var me = this,
                  dependencyModel = me.getDependencyForElement(forElement),
                  fromEvent = dependencyModel.sourceEvent,
                  toEvent = dependencyModel.targetEvent;
              return _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_27__["default"].tpl(_templateObject(), me.L('from'), fromEvent.name, fromBoxSide[dependencyModel.type], me.L('to'), toEvent.name, toBoxSide[dependencyModel.type]);
            } //endregion

            /**
             * Disable this feature
             * @property {Boolean}
             */

          }, {
            key: "store",
            set: function set(store) {
              var me = this,
                  client = me.client;

              if (store !== me._store) {
                // Create new store if none assigned through config
                me._store = store || (store = new this.storeClass());
                me._detachStoreEvents && me._detachStoreEvents();

                if (!client.dependencyStore) {
                  client._dependencyStore = store;
                }

                if (store) {
                  // dependencies can be set on scheduler or feature, for convenience
                  if (client.dependencies) {
                    store.add(client.dependencies);
                    delete client.dependencies;
                  }

                  if (me.dependencies) {
                    store.add(me.dependencies);
                    delete me.dependencies;
                  } // used to store meta per scheduler on models, in case they are used in multiple schedulers


                  store.metaMapId = client.id; // Ask the client for its eventStore after we set our store.
                  // Its eventStore getter attempts to read our store.

                  store.eventStore = client.eventStore;
                  me._detachStoreEvents = store.on({
                    change: me.onDependencyChange,
                    eventstorechange: me.bindEventStoreListeners,
                    detachable: true,
                    thisObj: me
                  });
                }
              }
            },
            get: function get() {
              return this._store;
            }
          }, {
            key: "dependencyGridCache",
            get: function get() {
              var me = this;

              if (!me._dependencyGridCache) {
                me._dependencyGridCache = {};
                me.store.forEach(function (dependency) {
                  return me.addToGridCache(dependency);
                });
              }

              return me._dependencyGridCache;
            },
            set: function set(cache) {
              this._dependencyGridCache = cache;
            }
          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              this._disabled = disabled;
              this.updateCreateListeners();

              if (this.client.rendered) {
                this.draw();
              }
            }
          }], [{
            key: "defaultConfig",

            /**
             * Fired when dependencies are rendered
             * @event dependenciesDrawn
             * @param {Boolean} [partial] Optional event parameter. `true` when subset of dependencies is repainted, omitted
             * when all lines were repainted.
             */
            //region Config
            get: function get() {
              return {
                /**
                 * Path finder instance configuration
                 * @config {Object}
                 */
                pathFinderConfig: null,

                /**
                 * The CSS class to add to a dependency line when hovering over it
                 * @config {String}
                 * @default
                 * @private
                 */
                overCls: 'b-sch-dependency-over',

                /**
                 * The CSS class applied to dependency lines
                 * @config {String}
                 * @default
                 * @private
                 */
                baseCls: 'b-sch-dependency',

                /**
                 * Store that holds dependencies (using DependencyModel or subclass thereof). A store will be automatically
                 * created if none is specified
                 * @config {Scheduler.data.DependencyStore}
                 */
                store: false,
                // Force invocation of setter, null bypasses the setter

                /**
                 * Dependency definitions (data to DependencyModels). Will be added to store. Can also be specified on
                 * Scheduler for convenience
                 * @config {DependencyModel[]|Object[]}
                 */
                dependencies: null,
                highlightDependenciesOnEventHover: false,

                /**
                 * Set to true to show a tooltip when hovering a dependency line
                 * @config {Boolean}
                 */
                showTooltip: true,

                /**
                 * A tooltip config object that will be applied to the dependency hover tooltip. Can be used to for example
                 * customize delay
                 * @config {Object}
                 */
                tooltip: null,
                bufferSize: 50,
                cacheGridSize: {
                  x: 500,
                  index: 25
                },
                drawnDependencies: [],
                drawnLines: [],
                dependenciesToRefresh: new Map(),
                storeClass: _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_34__["default"]
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['render', 'renderContents', 'onElementClick', 'onElementDblClick', 'onElementMouseOver', 'onElementMouseOut'],
                assign: ['getElementForDependency', 'getDependencyForElement']
              };
            }
          }]);

          return Dependencies;
        }(Object(_mixin_DependencyCreation_js__WEBPACK_IMPORTED_MODULE_32__["default"])(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_38__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_28__["default"])));

        Dependencies._$name = 'Dependencies';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_31__["default"].registerFeature(Dependencies, false, 'Scheduler'); // region polyfills
        // from https://github.com/eligrey/classList.js


        if (document.createElementNS && !('classList' in document.createElementNS('http://www.w3.org/2000/svg', 'g'))) {
          (function (view) {
            if (!('Element' in view)) return;

            var classListProp = 'classList',
                protoProp = 'prototype',
                elemCtrProto = view.Element[protoProp],
                objCtr = Object,
                strTrim = String[protoProp].trim || function () {
              return this.replace(/^\s+|\s+$/g, '');
            },
                arrIndexOf = Array[protoProp].indexOf || function (item) {
              for (var i = 0, len = this.length; i < len; i++) {
                if (i in this && this[i] === item) {
                  return i;
                }
              }

              return -1;
            },
                // Vendors: please allow content code to instantiate DOMExceptions
            DOMEx = function DOMEx(type, message) {
              this.name = type;
              this.code = DOMException[type]; // eslint-disable-line no-undef

              this.message = message;
            },
                checkTokenAndGetIndex = function checkTokenAndGetIndex(classList, token) {
              if (token === '') {
                throw new DOMEx('SYNTAX_ERR', 'The token must not be empty.');
              }

              if (/\s/.test(token)) {
                throw new DOMEx('INVALID_CHARACTER_ERR', 'The token must not contain space characters.');
              }

              return arrIndexOf.call(classList, token);
            },
                ClassList = function ClassList(elem) {
              var trimmedClasses = strTrim.call(elem.getAttribute('class') || ''),
                  classes = trimmedClasses ? trimmedClasses.split(/\s+/) : [];

              for (var i = 0, len = classes.length; i < len; i++) {
                this.push(classes[i]);
              }

              this._updateClassName = function () {
                elem.setAttribute('class', this.toString());
              };
            },
                classListProto = ClassList[protoProp] = [],
                classListGetter = function classListGetter() {
              return new ClassList(this);
            }; // Most DOMException implementations don't allow calling DOMException's toString()
            // on non-DOMExceptions. Error's toString() is sufficient here.


            DOMEx[protoProp] = Error[protoProp];

            classListProto.item = function (i) {
              return this[i] || null;
            };

            classListProto.contains = function (token) {
              return ~checkTokenAndGetIndex(this, token + '');
            };

            classListProto.add = function () {
              var tokens = arguments,
                  i = 0,
                  l = tokens.length,
                  token,
                  updated = false;

              do {
                token = tokens[i] + '';

                if (!~checkTokenAndGetIndex(this, token)) {
                  this.push(token);
                  updated = true;
                }
              } while (++i < l);

              if (updated) {
                this._updateClassName();
              }
            };

            classListProto.remove = function () {
              var tokens = arguments,
                  i = 0,
                  l = tokens.length,
                  token,
                  updated = false,
                  index;

              do {
                token = tokens[i] + '';
                index = checkTokenAndGetIndex(this, token);

                while (~index) {
                  this.splice(index, 1);
                  updated = true;
                  index = checkTokenAndGetIndex(this, token);
                }
              } while (++i < l);

              if (updated) {
                this._updateClassName();
              }
            };

            classListProto.toggle = function (token, force) {
              var result = this.contains(token),
                  method = result ? force !== true && 'remove' : force !== false && 'add';

              if (method) {
                this[method](token);
              }

              if (force === true || force === false) {
                return force;
              } else {
                return !result;
              }
            };

            classListProto.replace = function (token, replacementToken) {
              var index = checkTokenAndGetIndex(token + '');

              if (~index) {
                this.splice(index, 1, replacementToken);

                this._updateClassName();
              }
            };

            classListProto.toString = function () {
              return this.join(' ');
            };

            if (objCtr.defineProperty) {
              var classListPropDesc = {
                get: classListGetter,
                enumerable: true,
                configurable: true
              };

              try {
                objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
              } catch (ex) {
                // IE 8 doesn't support enumerable:true
                // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
                // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
                if (ex.number === undefined || ex.number === -0x7FF5EC54) {
                  classListPropDesc.enumerable = false;
                  objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
                }
              }
            } else if (objCtr[protoProp].__defineGetter__) {
              elemCtrProto.__defineGetter__(classListProp, classListGetter);
            }
          })(window);
        } // There is full or partial native classList support, so just check if we need
        // to normalize the add/remove and toggle APIs.


        (function () {
          var testElement = document.createElement('_');
          testElement.classList.add('c1', 'c2'); // Polyfill for IE 10/11 and Firefox <26, where classList.add and
          // classList.remove exist but support only one argument at a time.

          if (!testElement.classList.contains('c2')) {
            var createMethod = function createMethod(method) {
              var original = DOMTokenList.prototype[method]; // eslint-disable-line no-undef

              DOMTokenList.prototype[method] = function (token) {
                // eslint-disable-line no-undef
                for (var i = 0, len = arguments.length; i < len; i++) {
                  token = arguments[i];
                  original.call(this, token);
                }
              };
            };

            createMethod('add');
            createMethod('remove');
          }

          testElement.classList.toggle('c3', false); // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
          // support the second argument.

          if (testElement.classList.contains('c3')) {
            var _toggle = DOMTokenList.prototype.toggle; // eslint-disable-line no-undef

            DOMTokenList.prototype.toggle = function (token, force) {
              // eslint-disable-line no-undef
              if (1 in arguments && !this.contains(token) === !force) {
                return force;
              } else {
                return _toggle.call(this, token);
              }
            };
          } // replace() polyfill


          if (!('replace' in document.createElement('_').classList)) {
            DOMTokenList.prototype.replace = function (token, replacementToken) {
              // eslint-disable-line no-undef
              var tokens = this.toString().split(' '),
                  index = tokens.indexOf(token + '');

              if (~index) {
                tokens = tokens.slice(index);
                this.remove.apply(this, tokens);
                this.add(replacementToken);
                this.add.apply(this, tokens.slice(1));
              }
            };
          }

          testElement = null;
        })(); // endregion

        /***/

      },

      /***/
      "./lib/Scheduler/feature/DependencyEdit.js":
      /*!*************************************************!*\
        !*** ./lib/Scheduler/feature/DependencyEdit.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureDependencyEditJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DependencyEdit;
        });
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "./node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/widget/DisplayField.js */
        "../Grid/lib/Common/widget/DisplayField.js");
        /* harmony import */


        var _Common_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/widget/DurationField.js */
        "../Grid/lib/Common/widget/DurationField.js");
        /* harmony import */


        var _view_DependencyEditor_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../view/DependencyEditor.js */
        "./lib/Scheduler/view/DependencyEditor.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../model/DependencyModel.js */
        "./lib/Scheduler/model/DependencyModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/DependencyEdit
         */

        /**
         * Feature that displays a popup containing fields for editing a dependency. Requires the {@link Scheduler.feature.Dependencies Dependencies} feature to be enabled.
         *
         * This feature is **disabled** by default. It does **not** support vertical mode.
         *
         * @extends Common/mixin/InstancePlugin
         * @externalexample scheduler/Dependencies.js
         */

        var DependencyEdit =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(DependencyEdit, _InstancePlugin);

          function DependencyEdit() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, DependencyEdit);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DependencyEdit).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(DependencyEdit, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(client, config) {
              var _client$on;

              var me = this;
              client.dependencyEdit = me;
              me.dependencyStore = client.dependencyStore;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DependencyEdit.prototype), "construct", this).call(this, client, config);

              if (!client.features.dependencies) {
                throw new Error('Dependencies feature required when using DependencyEdit');
              }

              me.clientListenersDetacher = client.on((_client$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_client$on, me.triggerEvent, me.onActivateEditor), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_client$on, "thisObj", me), _client$on));
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.clientListenersDetacher();
              this.editor && this.editor.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(DependencyEdit.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Editing

          }, {
            key: "onBeforeSave",

            /**
             * Template method, intended to be overridden. Called before the dependency record has been updated.
             * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record
             *
             **/
            value: function onBeforeSave(dependencyRecord) {}
            /**
             * Template method, intended to be overridden. Called after the dependency record has been updated.
             * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record
             *
             **/

          }, {
            key: "onAfterSave",
            value: function onAfterSave(dependencyRecord) {}
            /**
             * Updates record being edited with values from the editor
             * @private
             */

          }, {
            key: "updateRecord",
            value: function updateRecord(dependency) {
              var values = this.values;
              dependency.beginBatch();
              dependency.set(values);

              if (this.lagField) {
                var lag = this.lagField.value;
                dependency.setLag(lag.magnitude, lag.unit);
              }

              if (this.typeField && 'type' in values) {
                dependency.set({
                  fromSide: null,
                  toSide: null
                });
              }

              dependency.endBatch();
            } //endregion
            //region Events

          }, {
            key: "onPopupKeyDown",
            value: function onPopupKeyDown(_ref) {
              var event = _ref.event;

              if (event.key === 'Enter' && this.saveAndCloseOnEnter && event.target.tagName.toLowerCase() === 'input') {
                // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden
                event.preventDefault();
                this.onSaveClick();
              }
            }
          }, {
            key: "onSaveClick",
            value: function onSaveClick() {
              if (this.save()) {
                this.editor.hide();
              }
            }
          }, {
            key: "onDeleteClick",
            value: function onDeleteClick() {
              this.deleteDependency();
              this.editor.hide();
            }
          }, {
            key: "onCancelClick",
            value: function onCancelClick() {
              this.editor.hide();
            } //region Editing
            // Called from editDependency() to actually show the editor

          }, {
            key: "internalShowEditor",
            value: function internalShowEditor(dependencyRecord) {
              var me = this,
                  scheduler = me.client;
              var showPoint = me.lastPointerDownCoordinate;
              /**
               * Fires on the owning Scheduler before an dependency is displayed in the editor.
               * This may be listened for to allow an application to take over dependency editing duties. Returning `false`
               * stops the default editing UI from being shown.
               * @event beforeDependencyEdit
               * @param {Scheduler.view.Scheduler} source The scheduler
               * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependencyEdit feature
               * @param {Scheduler.model.DependencyModel} dependencyRecord The record about to be shown in the editor.
               * @preventable
               */

              if (scheduler.trigger('beforeDependencyEdit', {
                dependencyEdit: me,
                dependencyRecord: dependencyRecord
              }) === false) {
                return;
              }

              var editor = me.getEditor(dependencyRecord);
              me.loadRecord(dependencyRecord);
              /**
               * Fires on the owning Scheduler when the editor for a dependency is available but before it is shown. Allows
               * manipulating fields etc.
               * @event beforeDependencyEditShow
               * @param {Scheduler.view.Scheduler} source The scheduler
               * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependencyEdit feature
               * @param {Scheduler.model.DependencyModel} dependencyRecord The record about to be shown in the editor.
               * @param {Scheduler.view.DependencyEditor} editor The editor
               */

              scheduler.trigger('beforeDependencyEditShow', {
                dependencyEdit: me,
                dependencyRecord: dependencyRecord,
                editor: editor
              });

              if (!showPoint) {
                var center = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_14__["default"].from(me.client.element).center;

                showPoint = [center.x - editor.width / 2, center.y - editor.height / 2];
              }

              editor.showByPoint(showPoint);
            }
            /**
             * Opens an {@link Scheduler.view.DependencyEditor DependencyEditor} to edit the passed dependency.
             * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency to edit
             */

          }, {
            key: "editDependency",
            value: function editDependency(dependencyRecord) {
              if (this.client.readOnly) return;
              this.internalShowEditor(dependencyRecord);
            } //endregion
            //region Save

            /**
             * Gets an editor instance. Creates on first call, reuses on consecutive
             * @internal
             * @returns {Scheduler.view.DependencyEditor} Editor popup
             */

          }, {
            key: "getEditor",
            value: function getEditor() {
              var me = this;
              var editor = me.editor;

              if (editor) {
                return editor;
              }

              editor = me.editor = new _view_DependencyEditor_js__WEBPACK_IMPORTED_MODULE_17__["default"](_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assign({
                dependencyEditFeature: me,
                autoShow: false,
                anchor: true,
                scrollAction: 'realign',
                clippedBy: [me.client.timeAxisSubGridElement, me.client.bodyContainer],
                constrainTo: window,
                autoClose: me.autoClose,
                cls: me.cls,
                listeners: {
                  keydown: me.onPopupKeyDown,
                  thisObj: me
                }
              }, me.editorConfig));

              if (editor.items.length === 0) {
                console.warn('Editor configured without any `items`');
              } // assign widget refs


              editor.eachWidget(function (widget) {
                var ref = widget.ref || widget.id; // don't overwrite if already defined

                if (ref && !me[ref]) {
                  me[ref] = widget;
                }
              });
              me.saveButton && me.saveButton.on('click', me.onSaveClick, me);
              me.deleteButton && me.deleteButton.on('click', me.onDeleteClick, me);
              me.cancelButton && me.cancelButton.on('click', me.onCancelClick, me);
              return me.editor;
            } //endregion
            //region Delete

            /**
             * Sets fields values from record being edited
             * @private
             */

          }, {
            key: "loadRecord",
            value: function loadRecord(dependency) {
              var me = this;
              me.fromNameField.value = dependency.sourceEvent.name;
              me.toNameField.value = dependency.targetEvent.name;

              if (me.lagField) {
                me.lagField.unit = dependency.lagUnit;
              }

              me.editor.record = me.dependencyRecord = dependency;
            } //endregion
            //region Stores

            /**
             * Saves the changes (applies them to record if valid, if invalid editor stays open)
             * @private
             * @fires beforeDependencySave
             * @fires beforeDependencyAdd
             * @fires afterDependencySave
             * @returns {*}
             */

          }, {
            key: "save",
            value: function save() {
              var me = this,
                  client = me.client,
                  dependencyRecord = me.dependencyRecord;
              if (!dependencyRecord || !me.isValid) return;
              var dependencyStore = me.dependencyStore,
                  values = me.values;
              /**
               * Fires on the owning Scheduler before a dependency is saved
               * @event beforeDependencySave
               * @param {Scheduler.view.Scheduler} source The scheduler instance
               * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be saved
               * @param {Object} values The new values
               * @preventable
               */

              if (client.trigger('beforeDependencySave', {
                dependencyRecord: dependencyRecord,
                values: values
              }) !== false) {
                me.onBeforeSave(dependencyRecord);
                me.updateRecord(dependencyRecord); // Check if this is a new record

                if (dependencyStore && !dependencyRecord.stores.length) {
                  /**
                   * Fires on the owning Scheduler before a dependency is added
                   * @event beforeDependencyAdd
                   * @param {Scheduler.view.Scheduler} source The scheduler
                   * @param {Scheduler.feature.DependencyEdit} dependencyEdit The dependency edit feature
                   * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be added
                   * @preventable
                   */
                  if (client.trigger('beforeDependencyAdd', {
                    dependencyRecord: dependencyRecord,
                    dependencyEdit: me
                  }) !== false) {
                    dependencyStore.add(dependencyRecord);
                  } else {
                    return;
                  }
                }

                client.project && client.project.propagate();
                /**
                 * Fires on the owning Scheduler after a dependency is successfully saved
                 * @event afterDependencySave
                 * @param {Scheduler.view.Scheduler} source The scheduler instance
                 * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency about to be saved
                 */

                client.trigger('afterDependencySave', {
                  dependencyRecord: dependencyRecord
                });
                me.onAfterSave(dependencyRecord);
              }

              return dependencyRecord;
            }
            /**
             * Delete dependency being edited
             * @private
             * @fires beforeDependencyDelete
             */

          }, {
            key: "deleteDependency",
            value: function deleteDependency() {
              var me = this;
              /**
               * Fires on the owning Scheduler before a dependency is deleted
               * @event beforeDependencyDelete
               * @param {Scheduler.view.Scheduler} source The scheduler instance
               * @param {Scheduler.model.DependencyModel} dependencyRecord The dependency record about to be deleted
               * @preventable
               */

              if (me.client.trigger('beforeDependencyDelete', {
                dependencyRecord: me.dependencyRecord
              }) !== false) {
                if (me.editor.containsFocus) {
                  me.editor.revertFocus();
                }

                me.client.dependencyStore.remove(me.dependencyRecord);
                me.client.project && me.client.project.propagate();
                return true;
              }

              return false;
            } //endregion
            //region Events

          }, {
            key: "onActivateEditor",
            value: function onActivateEditor(_ref2) {
              var dependency = _ref2.dependency,
                  event = _ref2.event;

              if (!this.disabled) {
                this.lastPointerDownCoordinate = [event.clientX, event.clientY];
                this.editDependency(dependency);
              }
            } //endregion

            /**
             * Disable this feature
             * @property {Boolean}
             */

          }, {
            key: "editorConfig",
            get: function get() {
              return this._editorConfig;
            },
            set: function set(editorConfig) {
              var me = this,
                  defaultEditorConfig = me.getDefaultConfiguration().editorConfig; // Apply editorConfig to the default editorConfig, allowing users to manipulate for example only bbar

              editorConfig = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].assign({}, defaultEditorConfig, editorConfig);
              editorConfig.items = editorConfig.items || [];
              me._editorConfig = editorConfig;
            } //endregion
            //region Save

          }, {
            key: "isValid",
            get: function get() {
              return Object.values(this.editor.widgetMap).every(function (field) {
                if (!field.name || field.hidden) {
                  return true;
                }

                return field.isValid !== false;
              });
            }
          }, {
            key: "values",
            get: function get() {
              var values = {};
              this.editor.eachWidget(function (widget) {
                if (!widget.name || widget.hidden) return;
                values[widget.name] = widget.value;
              }, true);
              return values;
            }
          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              this._disabled = disabled;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              var _this = this;

              return {
                /**
                 * True to hide this editor if a click is detected outside it (defaults to true)
                 * @config {Boolean}
                 * @default
                 * @category Editor
                 */
                autoClose: true,

                /**
                 * True to save and close this panel if ENTER is pressed in one of the input fields inside the panel.
                 * @config {Boolean}
                 * @default
                 * @category Editor
                 */
                saveAndCloseOnEnter: true,

                /**
                 * True to show a delete button in the form.
                 * @config {Boolean}
                 * @default
                 * @category Editor widgets
                 */
                showDeleteButton: true,

                /**
                 * The event that shall trigger showing the editor. Defaults to `dependencydblclick`, set to empty string or `null` to disable editing of dependencies.
                 * @config {String}
                 * @default
                 * @category Editor
                 */
                triggerEvent: 'dependencydblclick',

                /**
                 * True to show the lag field for the dependency
                 * @config {Boolean}
                 * @default
                 * @category Editor widgets
                 */
                showLagField: false,
                dependencyRecord: null,

                /**
                 * Default editor configuration, which widgets it shows etc.
                 * @config {Object}
                 * @category Editor
                 */
                editorConfig: {
                  title: 'L{Edit dependency}',
                  localeClass: this,
                  closable: true,
                  items: [
                  /**
                   * Reference to the from name
                   * @member {Common.widget.DisplayField} fromNameField
                   * @readonly
                   */
                  {
                    type: 'display',
                    localeClass: this,
                    label: 'L{From}',
                    editable: false,
                    ref: 'fromNameField'
                  },
                  /**
                   * Reference to the to name field
                   * @member {Common.widget.DisplayField} toNameField
                   * @readonly
                   */
                  {
                    type: 'display',
                    localeClass: this,
                    label: 'L{To}',
                    ref: 'toNameField'
                  },
                  /**
                   * Reference to the type field
                   * @member {Common.widget.Combo} typeField
                   * @readonly
                   */
                  {
                    type: 'combo',
                    localeClass: this,
                    label: 'L{Type}',
                    name: 'type',
                    ref: 'typeField',
                    editable: false,
                    valueField: 'id',
                    displayField: 'name',
                    items: Object.keys(_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_19__["default"].Type).map(function (type) {
                      return {
                        id: _model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_19__["default"].Type[type],
                        name: _this.L(type)
                      };
                    })
                  },
                  /**
                   * Reference to the lag field
                   * @member {Common.widget.DurationField} lagField
                   * @readonly
                   */
                  {
                    type: 'duration',
                    localeClass: this,
                    label: 'L{Lag}',
                    name: 'lag',
                    ref: 'lagField'
                  }],
                  bbar: [{
                    type: 'widget',
                    cls: 'b-label-filler'
                  },
                  /**
                   * Reference to the save button, if used
                   * @member {Common.widget.Button} saveButton
                   * @readonly
                   */
                  {
                    color: 'b-green',
                    localeClass: this,
                    text: 'L{Save}',
                    ref: 'saveButton'
                  },
                  /**
                   * Reference to the delete button, if used
                   * @member {Common.widget.Button} deleteButton
                   * @readonly
                   */
                  {
                    color: 'b-gray',
                    localeClass: this,
                    text: 'L{Delete}',
                    ref: 'deleteButton'
                  },
                  /**
                   * Reference to the cancel button, if used
                   * @member {Common.widget.Button} cancelButton
                   * @readonly
                   */
                  {
                    color: 'b-gray',
                    localeClass: this,
                    text: 'L{Cancel}',
                    ref: 'cancelButton'
                  }]
                }
              };
            }
          }]);

          return DependencyEdit;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_18__["default"]);

        DependencyEdit._$name = 'DependencyEdit';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(DependencyEdit, false);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventContextMenu.js":
      /*!***************************************************!*\
        !*** ./lib/Scheduler/feature/EventContextMenu.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventContextMenuJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventContextMenu;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./base/TimeSpanRecordContextMenuBase.js */
        "./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/EventContextMenu
         */

        /**
         * Displays a context menu for events. Items are populated by other features and/or application code.
         *
         * To add extra items for all events (Array notation):
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventContextMenu : {
         *             // Extra items for all events
         *             items : [
         *                 {
         *                     text : 'Extra',
         *                     icon : 'b-fa b-fa-fw b-fa-flag',
         *                     onItem({eventRecord}) {
         *                         eventRecord.flagged = true;
         *                     }
         *                 }
         *             ]
         *         }
         *     }
         * });
         * ```
         *
         * To add extra items for all events (Object notation):
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventContextMenu : {
         *             // Extra items for all events
         *             items : {
         *                 extraItems : {
         *                     text : 'Extra',
         *                     icon : 'b-fa b-fa-fw b-fa-flag',
         *                     onItem({eventRecord}) {
         *                         eventRecord.flagged = true;
         *                     }
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * To remove existing items:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventContextMenu : {
         *             items : {
         *                 deleteEvent   : false,
         *                 unassignEvent : false
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * Manipulate existing items for all events or specific events:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventContextMenu : {
         *             // Process items before menu is shown
         *             processItems({eventRecord, items}) {
         *                  // Push an extra item for conferences
         *                  if (eventRecord.type === 'conference') {
         *                      items.showSessionItem = {
         *                          text : 'Show sessions',
         *                          onItem({eventRecord}) {
         *                              // ...
         *                          }
         *                      };
         *                  }
         *
         *                  // Do not show menu for secret events
         *                  if (eventRecord.type === 'secret') {
         *                      return false;
         *                  }
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * This feature is **enabled** by default
         *
         * @extends Scheduler/feature/base/TimeSpanRecordContextMenuBase
         * @demo eventcontextmenu
         */

        var EventContextMenu =
        /*#__PURE__*/
        function (_TimeSpanRecordContex) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(EventContextMenu, _TimeSpanRecordContex);

          function EventContextMenu() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, EventContextMenu);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(EventContextMenu).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(EventContextMenu, [{
            key: "resolveRecord",
            //endregion
            //region Events

            /**
             * Fired from scheduler before the context menu is shown for an event. Allows manipulation of the items
             * to show in the same way as in `processItems`. Returning false from a listener prevents the menu from
             * being shown.
             * @event eventContextMenuBeforeShow
             * @preventable
             * @param {Scheduler.view.Scheduler} source
             * @param {Object} items Menu item configs
             * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
             * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
             * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
             * @param {HTMLElement} eventElement
             */

            /**
             * Fired from scheduler when an item is selected in the context menu.
             * @event eventContextMenuItem
             * @param {Scheduler.view.Scheduler} source
             * @param {Common.widget.MenuItem} item
             * @param {Scheduler.model.EventModel} eventRecord
             * @param {Scheduler.model.ResourceModel} resourceRecord
             * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
             * @param {HTMLElement} eventElement
             */

            /**
             * Fired from scheduler after showing the context menu for an event
             * @event eventContextMenuShow
             * @preventable
             * @param {Scheduler.view.Scheduler} source
             * @param {Common.widget.Menu} menu The menu
             * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
             * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
             * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
             * @param {HTMLElement} eventElement
             */
            //endregion
            //region Events
            value: function resolveRecord(element) {
              return this.client.resolveEventRecord(element);
            } //endregion

            /**
             * Shows context menu for the provided event. If record is not rendered (outside of time span/filtered)
             * menu won't appear.
             * @param {Scheduler.model.EventModel} eventRecord
             * @param {Object} [options]
             * @param {HTMLElement} options.targetElement Element to align context menu to
             * @param {Event} options.event Browser event. If provided menu will be aligned according to clientX/clientY coordinates.
             * If omitted, context menu will be centered to taskElement
             */

          }, {
            key: "showContextMenuFor",
            value: function showContextMenuFor(eventRecord) {
              var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
                  targetElement = _ref.targetElement,
                  event = _ref.event;

              var me = this,
                  client = me.client;

              if (!targetElement) {
                targetElement = client.getElementsFromEventRecord(eventRecord)[0]; // If record is not rendered, do nothing

                if (!targetElement) {
                  return;
                }
              }

              me.showContextMenu({
                menuType: 'event',
                eventElement: targetElement,
                targetElement: targetElement,
                eventRecord: eventRecord,
                resourceRecord: client.resolveResourceRecord(targetElement),
                assignmentRecord: client.resolveAssignmentRecord(targetElement),
                event: event
              });
            }
          }, {
            key: "defaultItems",
            set: function set(defaultItems) {
              this._defaultItems = defaultItems;
            },
            get: function get() {
              var result = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(EventContextMenu.prototype), "defaultItems", this);

              if (!this.client.assignmentStore) {
                result.unassignEvent = false;
              }

              return result;
            }
          }, {
            key: "namedItems",
            get: function get() {
              var me = this,
                  client = me.client;

              if (!me._namedItems) {
                me._namedItems = {
                  deleteEvent: {
                    text: client.L('Delete event'),
                    icon: 'b-icon b-icon-trash',
                    weight: -160,
                    onItem: function onItem(_ref2) {
                      var menu = _ref2.menu,
                          eventRecord = _ref2.eventRecord; // We must synchronously push focus back into the menu's triggering
                      // event so that the our beforeRemove handlers can move focus onwards
                      // to the closest remaining event.
                      // Otherwise, the menu's default hide processing on hide will attempt
                      // to move focus back to the menu's triggering event which will
                      // by then have been deleted.

                      var revertTarget = menu.focusInEvent && menu.focusInEvent.relatedTarget;

                      if (revertTarget) {
                        revertTarget.focus();
                        client.navigator.activeItem = revertTarget;
                      }

                      client.removeRecords([eventRecord]);
                    }
                  },
                  unassignEvent: {
                    text: client.L('Unassign event'),
                    icon: 'b-icon b-icon-unassign',
                    weight: -150,
                    name: 'unassignEvent',
                    onItem: function onItem(_ref3) {
                      var menu = _ref3.menu,
                          eventRecord = _ref3.eventRecord,
                          resourceRecord = _ref3.resourceRecord; // We must synchronously push focus back into the menu's triggering
                      // event so that the our beforeRemove handlers can move focus onwards
                      // to the closest remaining event.
                      // Otherwise, the menu's default hide processing on hide will attempt
                      // to move focus back to the menu's triggering event which will
                      // by then have been deleted.

                      var revertTarget = menu.focusInEvent && menu.focusInEvent.relatedTarget;

                      if (revertTarget) {
                        revertTarget.focus();
                        client.navigator.activeItem = revertTarget;
                      }

                      eventRecord.unassign(resourceRecord);
                    }
                  }
                };
              }

              return me._namedItems;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * An array of extra menu items to add to the context menu
                 *
                 * ```javascript
                 * const scheduler = new Scheduler({
                 *     features : {
                 *         eventContextMenu : {
                 *             // Extra items for all events
                 *             items : [
                 *                 {
                 *                     text : 'Extra',
                 *                     icon : 'b-fa b-fa-fw b-fa-flag',
                 *                     onItem({eventRecord}) {
                 *                         eventRecord.flagged = true;
                 *                     }
                 *                 }
                 *             ]
                 *         }
                 *     }
                 * });
                 * ```
                 *
                 * or items config to add extra items to the context menu or hide default items
                 *
                 * ```javascript
                 * const scheduler = new Scheduler({
                 *     features : {
                 *         eventContextMenu : {
                 *             items : {
                 *                 // Add custom 'Extra' item
                 *                 extra : {
                 *                     text : 'Extra',
                 *                     icon : 'b-fa b-fa-fw b-fa-flag',
                 *                     onItem({eventRecord}) {
                 *                         eventRecord.flagged = true;
                 *                     }
                 *                 },
                 *                 // Hide default 'Delete event' and 'Unassign event' items
                 *                 deleteEvent   : false,
                 *                 unassignEvent : false
                 *             }
                 *         }
                 *     }
                 * });
                 * ```
                 *
                 * @config {Object|Object[]}
                 */
                items: null,

                /**
                 * A function called before displaying the menu that allows manipulations of its items.
                 * Called with a single parameter with format { date, resourceRecord, items }.
                 * Returning `false` from this function prevents the menu from being shown.
                 *
                 * ```javascript
                 * features : {
                 *     eventContextMenu : {
                 *         // Process items before menu is shown
                 *         processItems({eventRecord, items}) {
                 *              // Push an extra item for conferences
                 *              if (eventRecord.type === 'conference') {
                 *                  items.showSessionItem = {
                 *                      text : 'Show sessions',
                 *                      onItem({eventRecord}) {
                 *                          // ...
                 *                      }
                 *                  };
                 *              }
                 *
                 *              // Do not show menu for secret events
                 *              if (eventRecord.type === 'secret') {
                 *                  return false;
                 *              }
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @config {Function}
                 */
                processItems: null,

                /**
                 * This is a preconfigured set of {@link Common.widget.Container#config-namedItems} used to create the default context menu.
                 *
                 * The provided defaultItems setting is
                 *
                 *```javascript
                 *    {
                 *        deleteEvent   : true,
                 *        unassignEvent : true
                 *    }
                 *```
                 *
                 * The `namedItems` provided by this feature are listed below. These are the property
                 * names which you may configure in the feature's {@link #config-items} config:
                 *
                 * - `deleteEvent` Deletes the context event.
                 * - `unassignEvent` Unassigns the context event from the context resource.
                 *
                 * To remove existing items, set corresponding keys to `false`
                 *
                 * ```javascript
                 * const scheduler = new Scheduler({
                 *     features : {
                 *         eventContextMenu : {
                 *             items : {
                 *                 deleteEvent   : false,
                 *                 unassignEvent : false
                 *             }
                 *         }
                 *     }
                 * });
                 * ```
                 *
                 * See the feature config in the above example for details.
                 * @config {Object}
                 */
                defaultItems: {
                  deleteEvent: true,
                  unassignEvent: true
                }
              };
            }
          }]);

          return EventContextMenu;
        }(_base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        EventContextMenu.featureClass = '';
        EventContextMenu._$name = 'EventContextMenu';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerFeature(EventContextMenu, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventDrag.js":
      /*!********************************************!*\
        !*** ./lib/Scheduler/feature/EventDrag.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventDragJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventDrag;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _base_DragBase_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./base/DragBase.js */
        "./lib/Scheduler/feature/base/DragBase.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../model/AssignmentModel.js */
        "./lib/Scheduler/model/AssignmentModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/EventDrag
         */

        var nullResourceArray = [null]; //TODO: relay events as in Dependencies. (drag -> eventdrag etc)
        //TODO: shift to copy
        //TODO: dragging of event that starts & ends outside of view

        /**
         * Allows user to drag and drop events within the scheduler, to change startDate or resource assignment.
         *
         * This feature is **enabled** by default
         *
         * @example
         * // constrain drag to current resource
         * let scheduler = new Scheduler({
         *   features: {
         *     eventDrag: {
         *       constrainDragToResource: true
         *     }
         *   }
         * });
         *
         * @extends Scheduler/feature/base/DragBase
         * @demo basic
         * @externalexample scheduler/EventDrag.js
         */

        var EventDrag =
        /*#__PURE__*/
        function (_DragBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(EventDrag, _DragBase);

          function EventDrag() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, EventDrag);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventDrag).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(EventDrag, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
             * in the listener, to show a confirmation popup etc
             * ```
             *  scheduler.on('beforeeventdropfinalize', ({context}) => {
             *      context.async = true;
             *      setTimeout(() => {
             *          // async code don't forget to call finalize
             *          context.finalize();
             *      }, 1000);
             *  })
             * ```
             * @event beforeEventDropFinalize
             * @param {Scheduler.view.Scheduler} source Scheduler instance
             * @param {Object} context
             * @param {Boolean} context.async Set true to handle dragdrop asynchronously (e.g. to wait for user
             * @param {Scheduler.model.EventModel} context.targetEventRecord Event record for drop target
             * @param {Scheduler.model.ResourceModel} context.newResource Resource record for drop target
             * confirmation)
             * @param {Function} context.finalize Call this method to finalize dragdrop. This method accepts one
             * argument: pass true to update records, or false, to ignore changes
             */

            /**
             * Fired on the owning Scheduler after event drop
             * @event afterEventDrop
             * @param {Scheduler.view.Scheduler} source
             * @param {Scheduler.model.EventModel[]} eventRecords
             * @param {Boolean} valid
             * @param {Object} context
             */

            /**
             * Fired on the owning Scheduler when an event is dropped
             * @event eventDrop
             * @param {Scheduler.view.Scheduler} source
             * @param {Scheduler.model.EventModel[]} eventRecords
             * @param {Boolean} isCopy
             * @param {Object} context
             * @param {Scheduler.model.EventModel} context.targetEventRecord Event record for drop target
             * @param {Scheduler.model.ResourceModel} context.newResource Resource record for drop target
             */

            /**
             * Fired on the owning Scheduler before event dragging starts. Return false to prevent the action
             * @event beforeEventDrag
             * @param {Scheduler.view.Scheduler} source
             * @param {Scheduler.model.EventModel} eventRecord
             * @param {Object} context
             */

            /**
             * Fired on the owning Scheduler when event dragging starts
             * @event eventDragStart
             * @param {Scheduler.view.Scheduler} source
             * @param {Scheduler.model.EventModel[]} eventRecords
             * @param {Object} context
             */

            /**
             * Fired on the owning Scheduler when event is dragged
             * @event eventDrag
             * @param {Scheduler.view.Scheduler} source
             * @param {Scheduler.model.EventModel[]} eventRecords
             * @param {Date} startDate
             * @param {Date} endDate
             * @param {Scheduler.model.ResourceModel} newResource
             * @param {Object} context
             */
            //endregion
            //region Init
            value: function construct(scheduler, config) {
              this.scheduler = scheduler;
              this.store = scheduler.eventStore;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventDrag.prototype), "construct", this).call(this, scheduler, config);
            } //endregion
            //region Drag events

          }, {
            key: "isElementDraggable",
            value: function isElementDraggable(el, event) {
              var scheduler = this.scheduler,
                  eventElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].up(el, scheduler.eventSelector),
                  eventResize = scheduler.features.eventResize;

              if (!eventElement) {
                return false;
              } // displaying something resizable within the event?


              if (el.matches('[class$="-handle"]')) {
                return false;
              }

              var eventRecord = scheduler.resolveEventRecord(eventElement); // using EventResize and over a virtual handle?
              // Milestones cannot be resized

              if (eventResize && !eventRecord.isMilestone && eventResize.resize.overAnyHandle(event, eventElement)) {
                return false;
              }

              return true;
            }
          }, {
            key: "triggerEventDrag",
            value: function triggerEventDrag(dd, start) {
              // If there has been a change...
              if (dd.startDate - start !== 0 || dd.newResource !== dd.resourceRecord) {
                this.scheduler.trigger('eventDrag', {
                  eventRecords: dd.draggedRecords,
                  startDate: dd.startDate,
                  endDate: dd.endDate,
                  newResource: dd.newResource,
                  context: dd
                });
              }
            }
          }, {
            key: "onDragStart",
            value: function onDragStart(_ref) {
              var context = _ref.context,
                  event = _ref.event;
              var eventContextMenuFeature = this.client.features.eventContextMenu;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventDrag.prototype), "onDragStart", this).call(this, {
                context: context,
                event: event
              }); // If this is a touch action, hide the context menu which may have shown


              if (eventContextMenuFeature) {
                eventContextMenuFeature.hideContextMenu(false);
              }
            } //endregion
            //region Finalization & validation

            /**
             * Checks if an event can be dropped on the specified resource.
             * @private
             * @returns {Boolean} Valid (true) or invalid (false)
             */

          }, {
            key: "isValidDrop",
            value: function isValidDrop(dragData) {
              var newResource = dragData.newResource,
                  resourceRecord = dragData.resourceRecord;
              var sourceRecord = dragData.draggedRecords[0]; // Not allowed to drop an event to group header

              if (newResource.meta.specialRow) {
                return false;
              } // Not allowed to assign an event twice to the same resource -
              // which might happen when we deal with an assignment store


              if (resourceRecord !== newResource) {
                // if we operate assignments
                if (sourceRecord instanceof _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
                  sourceRecord = sourceRecord.event;
                }

                return !sourceRecord.isAssignedTo(newResource);
              }

              return true;
            }
          }, {
            key: "checkDragValidity",
            value: function checkDragValidity(dragData, event) {
              var me = this,
                  scheduler = this.currentOverClient; // First make sure DragHelper thinks it's a valid drag, then scheduler domain checks

              return me.dragData.context.valid && (scheduler.allowOverlap || scheduler.isDateRangeAvailable(dragData.startDate, dragData.endDate, dragData.draggedRecords[0], dragData.newResource)) && me.validatorFn.call(me.validatorFnThisObj || me, dragData, event);
            } //endregion
            //region Update records

            /**
             * Update events being dragged.
             * @private
             * @param context Drag data.
             */

          }, {
            key: "updateRecords",
            value: function updateRecords(context) {
              var me = this,
                  fromScheduler = me.scheduler,
                  toScheduler = me.currentOverClient,
                  copyKeyPressed = false,
                  assignmentStore = fromScheduler.assignmentStore,
                  draggedRecords = context.draggedRecords; // Multiple assignment mode

              if (assignmentStore) {
                if (toScheduler !== fromScheduler) {
                  throw new Error('Assignments cannot be dragged cross-scheduler');
                }

                me.updateRecordsMultipleAssignmentMode(fromScheduler, toScheduler, context, copyKeyPressed);
              } // Single assignment mode
              else {
                  me.updateRecordsSingleAssignmentMode(fromScheduler, toScheduler, context, copyKeyPressed);
                } // Tell the world there was a successful drop


              toScheduler.trigger('eventDrop', {
                eventRecords: draggedRecords,
                isCopy: copyKeyPressed,
                event: context.browserEvent,
                targetEventRecord: context.targetEventRecord,
                targetResourceRecord: context.newResource,
                context: context
              });
            }
            /**
             * Update records being dragged, gantt mode. Sets resource and start date.
             * @private
             */

          }, {
            key: "updateRecordsSingleAssignmentMode",
            value: function updateRecordsSingleAssignmentMode(fromScheduler, toScheduler, context, copy) {
              // The code is written to emit as few store events as possible
              var me = this,
                  isCrossScheduler = fromScheduler !== toScheduler,
                  fromEventStore = fromScheduler.eventStore,
                  resourceStore = fromScheduler.resourceStore,
                  draggedRecords = context.draggedRecords,
                  timeDiff = context.timeDiff,
                  fromResource = context.resourceRecord,
                  toResource = context.newResource,
                  unifiedDrag = me.unifiedDrag || isCrossScheduler && draggedRecords.length > 1,
                  toAdd = [],
                  indexDiff = me.constrainDragToResource ? 0 : resourceStore.indexOf(fromResource) - resourceStore.indexOf(toResource),
                  event1Date = me.adjustStartDate(draggedRecords[0].startDate, timeDiff);
              var updated;
              draggedRecords.forEach(function (draggedEvent, i) {
                var eventBar = context.eventBarEls[i],
                    oldGeneration = draggedEvent.generation,
                    // grabbing resources early, since after ".copy()" the record won't belong to any store
                // and ".getResources()" won't work. If it's a move to another scheduler, ensure the
                // array still has a length. The process function will do an assign as opposed
                // to a reassign
                relatedResources = isCrossScheduler ? nullResourceArray : draggedEvent.resources; // If changing resource, the element wont be found in SchedulerStores#onEventBeforeCommit and thus the
                // committing cls wont be applied. Apply it here, in case we are using a backend. If we are not, it will be
                // replaced anyway on the immediate redraw

                eventBar.querySelector(fromScheduler.eventInnerSelector).classList.add(fromScheduler.committingCls);

                if (copy) {
                  draggedEvent = draggedEvent.fullCopy(null);
                  toAdd.push(draggedEvent);
                } else if (fromEventStore !== toScheduler.eventStore) {
                  // Removing deassigns events from their resources
                  fromEventStore.remove(draggedRecords); // This will not affect the UI because the events are not assigned to any resource

                  toScheduler.eventStore.add(draggedRecords); // Make the event mapper reuse this element

                  draggedEvent.instanceMeta(toScheduler).fromDragProxy = true;
                } // Process original dragged record


                draggedEvent.beginBatch(); // calculate new startDate (and round it) based on timeDiff

                var newStartDate = unifiedDrag ? event1Date : me.adjustStartDate(draggedEvent.startDate, timeDiff);
                (indexDiff !== 0 || unifiedDrag || isCrossScheduler) && relatedResources.length && relatedResources.forEach(function (r) {
                  var newResource = toResource; // If not dragging events as a unified block, distribute each to a new resource
                  // using the same offset as the dragged event.

                  if (!unifiedDrag && !isCrossScheduler) {
                    var newIndex = resourceStore.indexOf(r) - indexDiff;

                    if (newIndex < 0) {
                      newIndex = 0;
                    } else if (newIndex >= resourceStore.getCount()) {
                      newIndex = resourceStore.getCount() - 1;
                    }

                    newResource = resourceStore.getAt(newIndex);
                  }

                  if (r) {
                    draggedEvent.reassign(r, newResource);
                  } else {
                    draggedEvent.assign(newResource);
                  }

                  if (toScheduler.mode !== 'vertical') {
                    var isRendered = toScheduler.rowManager.getRowFor(newResource) && toScheduler.isInTimeAxis(draggedEvent),
                        newId = isRendered ? toScheduler.getEventRenderId(draggedEvent, newResource) : null; // Ensure the element gets preferentially reused for its own new render
                    // when batching of its changes is ended and it fires events through its eventStore

                    if (newId) {
                      // If it's cross-scheduler, the element has to be moved into the element
                      // recycling cache of the toScheduler, and positioned in its foregroundCanvas
                      if (isCrossScheduler) {
                        var elRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(context.context.element, toScheduler.foregroundCanvas, true),
                            clone = context.context.element.cloneNode(true); // Ensure that after inserting the dragged element clone into the toScheduler's foregoundCanvas
                        // it's at the same visual position that it was dragged to.


                        _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].setTranslateXY(clone, elRect.x, elRect.y);

                        clone.classList.remove('b-first-render');
                        clone.classList.remove('b-active');
                        clone.classList.remove('b-drag-proxy');
                        clone.classList.remove('b-dragging'); // This puts a clone of the dragged element into the toScheduler's recycling cache
                        // *AND* inserts it into the toScheduler's foregroundCanvas.

                        toScheduler.currentOrientation.cacheTimeSpanElement(draggedEvent, newResource, clone);
                      } else {
                        toScheduler.currentOrientation.releaseTimeSpanDiv(eventBar, true);
                        toScheduler.currentOrientation.updateElementId(eventBar, newId);
                      }
                    } // If the event has been moved out of rendering, just discard the element
                    else {
                        eventBar.remove();
                      }
                  }
                });
                draggedEvent.setStartDate(newStartDate, true, fromEventStore.skipWeekendsDuringDragDrop);
                draggedEvent.endBatch(); // We need to know whether we have successfully made an update in order to
                // sync the dragContext's valid flag.

                if (draggedEvent.generation !== oldGeneration) {
                  updated = true;
                }
              });

              if (toAdd.length) {
                var count = fromEventStore.count;
                fromEventStore.add(toAdd);

                if (fromEventStore.count !== count) {
                  updated = true;
                }
              }

              if (!updated) {
                context.valid = false;
              }
            }
            /**
             * Update records being dragged, scheduler mode. Sets resource and start date.
             * @private
             */

          }, {
            key: "updateRecordsMultipleAssignmentMode",
            value: function updateRecordsMultipleAssignmentMode(fromScheduler, toScheduler, context, copy) {
              var me = this,
                  isCrosScheduler = fromScheduler !== toScheduler,
                  eventStore = fromScheduler.eventStore,
                  draggedRecords = context.draggedRecords,
                  timeDiff = context.timeDiff,
                  fromResource = context.resourceRecord,
                  toResource = context.newResource,
                  handledEventsMap = {};
              var updated;
              draggedRecords.forEach(function (assignment, i) {
                var event = assignment.event,
                    eventBar = context.eventBarEls[i],
                    oldGeneration = event.generation,
                    newId = fromScheduler.getEventRenderId(assignment.event, toResource);

                if (handledEventsMap[event.id]) {
                  return;
                }

                handledEventsMap[event.id] = true; // Ensure the element gets preferentially reused for its own new render

                if (newId) {
                  // If it's cross-scheduler, the element has to be moved into the element
                  // recycling cache of the toScheduler, and positioned in its foregroundCanvas
                  if (isCrosScheduler) {
                    toScheduler.currentOrientation.cacheTimeSpanElement(event, eventBar);
                  } else {
                    toScheduler.currentOrientation.updateElementId(eventBar, newId);
                  }
                }

                event.setStartDate(me.adjustStartDate(event.startDate, timeDiff), true, eventStore.skipWeekendsDuringDragDrop); // if we dragged the event to a different resource

                if (fromResource !== toResource) {
                  if (copy) {
                    event.assign(toResource);
                  } else if (!event.isAssignedTo(toResource)) {
                    event.reassign(assignment.resource, toResource);
                  } else {
                    event.unassign(assignment.resource);
                  }
                } // We need to know whether we have successfully made an update in order to
                // sync the dragContext's valid flag.


                updated = updated || assignment.resource !== fromResource || event.generation !== oldGeneration;
              });

              if (!updated) {
                context.valid = false;
              }
            } //endregion
            //region Drag data

          }, {
            key: "getProductDragContext",
            value: function getProductDragContext(dd) {
              var targetEventRecord = this.scheduler.resolveEventRecord(dd.browserEvent.target);
              var newResource;

              if (this.constrainDragToResource) {
                newResource = dd.resourceRecord;
              } else if (!this.constrainDragToTimeline) {
                // If we're dragging freely on the page, require to drag onto a resource row always
                newResource = this.resolveResource();
              } else {
                newResource = this.resolveResource() || dd.newResource || dd.resourceRecord;
              }

              return {
                valid: Boolean(newResource),
                newResource: newResource,
                targetEventRecord: targetEventRecord
              };
            }
          }, {
            key: "setupProductDragData",
            value: function setupProductDragData(info) {
              var me = this,
                  scheduler = me.scheduler,
                  element = info.grabbed,
                  eventRecord = scheduler.resolveEventRecord(element),
                  resourceRecord = scheduler.resolveResourceRecord(element),
                  assignmentRecord = scheduler.resolveAssignmentRecord(element),
                  eventRegion = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element),
                  draggedRecords = [assignmentRecord || eventRecord],
                  eventBarEls = [];

              if (me.constrainDragToResource && !resourceRecord) {
                throw new Error('Resource could not be resolved for event: ' + eventRecord.id);
              }

              var dateConstraints = scheduler.getDateConstraints(me.constrainDragToResource ? resourceRecord : null, eventRecord);

              if (me.constrainDragToTimeline) {
                me.setupConstraints(scheduler.getScheduleRegion(me.constrainDragToResource ? resourceRecord : null, eventRecord), eventRegion, scheduler.timeAxisViewModel.snapPixelAmount, Boolean(dateConstraints));
              } // We multi drag other selected events if multiEventSelect is set and
              // (the dragged event is already selected, or the ctrl key is pressed)


              if (scheduler.multiEventSelect && (scheduler.isEventSelected(draggedRecords[0]) || me.drag.startEvent.ctrlKey)) {
                draggedRecords.push.apply(draggedRecords, me.getRelatedRecords(assignmentRecord || eventRecord));
              } // Collecting all elements to drag


              draggedRecords.forEach(function (r) {
                var eventBarEl;

                if (r instanceof _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_13__["default"]) {
                  eventBarEl = scheduler.getElementFromEventRecord(r.event, r.resource);
                } else {
                  eventBarEl = scheduler.getElementFromEventRecord(r, r.resource);
                } // It's selected but unrendered. This happens when multi-selected events are dragged such
                // that on drop, they are outside of the timeline or the rendered block, and become unrendered.
                // Users will expect the event to be "there" so we have to bring it into existence
                // just for the drag.


                if (!eventBarEl) {
                  var rd = scheduler.generateTplData(r, r.resource, {
                    timeAxis: true,
                    viewport: true
                  });
                  rd.top = rd.row ? rd.top + rd.row.top : scheduler.getResourceEventBox(r, r.resource, true).top;
                  eventBarEl = scheduler.currentOrientation.renderTimeSpan(rd, {}, null, true); // Make it be reused after drag

                  scheduler.currentOrientation.availableDivs.add(eventBarEl);
                  eventBarEl = eventBarEl.innerElement;
                }

                eventBarEls.push(eventBarEl);
              }); // What is dragged is the wrapper.

              eventBarEls.forEach(function (el, i) {
                return eventBarEls[i] = el.parentNode;
              });
              return {
                record: eventRecord,
                dateConstraints: dateConstraints,
                eventBarEls: eventBarEls,
                draggedRecords: draggedRecords
              };
            }
            /**
             * Initializes drag data (dates, constraints, dragged events etc). Called when drag starts.
             * @private
             * @param info
             * @param event
             * @returns {*}
             */

          }, {
            key: "getDragData",
            value: function getDragData(info, event) {
              return Object.assign(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventDrag.prototype), "getDragData", this).call(this, info, event), {
                resourceRecord: this.scheduler.resolveResourceRecord(info.grabbed)
              });
            }
            /**
             * Provide your custom implementation of this to allow additional selected records to be dragged together with the original one.
             * @param {Scheduler.model.EventModel} eventRecord The eventRecord about to be dragged
             * @return {Scheduler.model.EventModel[]} An array of event records to drag together with the original event
             */

          }, {
            key: "getRelatedRecords",
            value: function getRelatedRecords(eventRecord) {
              return this.scheduler.selectedEvents.filter(function (selectedRecord) {
                return selectedRecord !== eventRecord;
              });
            }
            /**
             * Get correct axis coordinate depending on schedulers mode (horizontal -> x, vertical -> y). Also takes milestone
             * layout into account.
             * @private
             * @param {Scheduler.model.EventModel} eventRecord Record being dragged
             * @param {HTMLElement} element Element being dragged
             * @param {Number[]} coord XY coordinates
             * @returns {Number|Number[]} X,Y or XY
             */

          }, {
            key: "getCoordinate",
            value: function getCoordinate(eventRecord, element, coord) {
              var scheduler = this.currentOverClient;

              if (scheduler.isHorizontal) {
                var x = coord[0]; // Adjust coordinate for milestones if using a layout mode, since they are aligned differently than events

                if (scheduler.milestoneLayoutMode !== 'default' && eventRecord.isMilestone) {
                  switch (scheduler.milestoneAlign) {
                    case 'center':
                      x += element.offsetWidth / 2;
                      break;

                    case 'end':
                      x += element.offsetWidth;
                      break;
                  }
                }

                return x;
              } else {
                var y = coord[1]; // Adjust coordinate for milestones if using a layout mode, since they are aligned differently than events

                if (scheduler.milestoneLayoutMode !== 'default' && eventRecord.isMilestone) {
                  switch (scheduler.milestoneAlign) {
                    case 'center':
                      y += element.offsetHeight / 2;
                      break;

                    case 'end':
                      y += element.offsetHeight;
                      break;
                  }
                }

                return y;
              }
            }
            /**
             * Get resource record occluded by the drag proxy.
             * @private
             * @returns {Scheduler.model.ResourceModel}
             */

          }, {
            key: "resolveResource",
            value: function resolveResource() {
              var me = this,
                  client = me.currentOverClient,
                  isHorizontal = client.isHorizontal,
                  context = me.dragData.context,
                  element = context.dragProxy || context.element,
                  scrollerElement = client.timeAxisSubGrid.virtualScrollerElement,
                  pageRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, null, true),
                  x = isHorizontal ? context.clientX : pageRect.center.x,
                  y = client.isVertical || me.unifiedDrag ? context.clientY : pageRect.center.y,
                  localRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_11__["default"].from(element, me.currentOverClient.timeAxisSubGridElement, true),
                  _localRect$center = localRect.center,
                  lx = _localRect$center.x,
                  ly = _localRect$center.y; // This is benchmarked as the fastest way to find a Grid Row from a viewport Y coordinate
              // so use it in preference to elementFromPoint (which causes a forced synchonous layout) in horiontal mode.


              if (isHorizontal) {
                var row = client.rowManager.getRowAt(y);

                if (row) {
                  return client.resourceStore.getAt(row.dataIndex);
                }
              } // Do not find the drag element at the x, y position.


              element.style.pointerEvents = 'none'; // Do not find the horizontal scrollbar either

              if (scrollerElement) {
                scrollerElement.style.display = 'none';
              }

              var node = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].elementFromPoint(x, y);

              element.style.pointerEvents = '';

              if (scrollerElement) {
                scrollerElement.style.display = '';
              } // If we found an element there, and it can be used to resolve a resourceRecord, use that


              return node && client.resolveResourceRecord(node, [lx, ly]);
            } //endregion
            //region Other stuff

          }, {
            key: "adjustStartDate",
            value: function adjustStartDate(startDate, timeDiff) {
              var scheduler = this.currentOverClient;
              return scheduler.timeAxis.roundDate(new Date(startDate - 0 + timeDiff), scheduler.snapRelativeToEventStartDate ? startDate : false);
            }
          }, {
            key: "resolveStartEndDates",
            value: function resolveStartEndDates(proxyRect) {
              var scheduler = this.currentOverClient,
                  dd = this.dragData;
              var startEnd,
                  start = dd.origStart,
                  end = dd.origEnd;

              if (!dd.startsOutsideView) {
                startEnd = scheduler.getStartEndDatesFromRectangle(proxyRect, 'round');

                if (startEnd) {
                  // Make sure we didn't target a start date that is filtered out, if we target last hour cell (e.g. 21:00) of
                  // the time axis, and the next tick is 08:00 following day. Trying to drop at end of 21:00 cell should target start of next cell
                  if (startEnd.start && !scheduler.timeAxis.dateInAxis(startEnd.start, false)) {
                    var tick = scheduler.timeAxis.getTickFromDate(startEnd.start);

                    if (tick) {
                      startEnd.start = scheduler.timeAxis.getDateFromTick(tick);
                    }
                  }

                  start = startEnd.start || dd.startDate;
                  end = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(start, dd.duration, 'ms');
                }
              } else if (!dd.endsOutsideView) {
                startEnd = scheduler.getStartEndDatesFromRectangle(proxyRect, 'round');

                if (startEnd) {
                  end = startEnd.end || dd.endDate;
                  start = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(end, -dd.duration, 'ms');
                }
              }

              return {
                startDate: start,
                endDate: end
              };
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Template used to generate drag tooltip contents.
                 * ```
                 * const scheduler = new Scheduler({
                 *   features : {
                 *     eventDrag : {
                 *       dragTipTemplate({eventRecord, startText}) {
                 *         return `${eventRecord.name}: ${startText}`
                 *       }
                 *     }
                 *   }
                 * });
                 * ```
                 * @config {Function} dragTipTemplate
                 * @param {Object} data Tooltip data
                 * @param {Scheduler.model.EventModel} data.eventRecord
                 * @param {Boolean} data.valid Currently over a valid drop target or not
                 * @param {Date} data.startDate New start date
                 * @param {Date} data.endDate New end date
                 * @param {String} data.startText Formatted new start date
                 * @param {String} data.endText Formatted new end date
                 * @param {String} data.startClockHtml Pre-generated HTML to display startDate as clock/calendar
                 * @param {String} data.endClockHtml Pre-generated HTML to display endDate as clock/calendar
                 * @param {Object} data.dragData Detailed drag context
                 * @returns {String}
                 */

                /**
                 * Set to true to only allow dragging events within the same resource.
                 * @config {Boolean}
                 * @default
                 */
                constrainDragToResource: false,

                /**
                 * An empty function by default, but provided so that you can perform custom validation on
                 * the item being dragged. This function is called during the drag and drop process and also after the drop is made.
                 * Return true if the new position is valid, false to prevent the drag.
                 * @param {Object} context A drag drop context object containing { draggedRecords, startDate, endDate, newResource }
                 * @param {Event} e The event object
                 * @return {Boolean}
                 * @config {Function}
                 */
                validatorFn: function validatorFn() {},

                /**
                 * The `this` reference for the validatorFn
                 * @config {Object}
                 */
                validatorFnThisObj: null,

                /**
                 * When the host Scheduler is `{@link Scheduler.view.mixin.EventSelection#config-multiEventSelect multiEventSelect}: true`
                 * then, there are two modes of dragging *within the same Scheduler*.
                 *
                 * Non unified means that all selected events are dragged by the same number of resource rows.
                 *
                 * Unified means that all selected events are collected together and dragged as one, and are all dropped
                 * on the same targeted resource row at the same targeted time.
                 * @config {Boolean}
                 * @default false
                 */
                unifiedDrag: null
              };
            }
          }]);

          return EventDrag;
        }(_base_DragBase_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        EventDrag._$name = 'EventDrag';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].registerFeature(EventDrag, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventDragCreate.js":
      /*!**************************************************!*\
        !*** ./lib/Scheduler/feature/EventDragCreate.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventDragCreateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventDragCreate;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./base/DragCreateBase.js */
        "./lib/Scheduler/feature/base/DragCreateBase.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/EventDragCreate
         */
        // TODO: add hovertip if EventDrag feature not used
        // TODO: some of the code here could be shared with EventResize. make common base class?
        // TODO: touch support
        // TODO: mouse up outside not working as it should

        /**
         * Feature that allows the user to create new events by dragging in empty parts of the scheduler rows.
         *
         * This feature is **enabled** by default
         *
         * **NOTE:** Incompatible with {@link Scheduler.feature.Pan Pan} feature.
         *
         * @extends Scheduler/feature/base/DragCreateBase
         * @demo basic
         * @externalexample scheduler/EventDragCreate.js
         */

        var EventDragCreate =
        /*#__PURE__*/
        function (_DragCreateBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(EventDragCreate, _DragCreateBase);

          function EventDragCreate() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, EventDragCreate);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(EventDragCreate).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(EventDragCreate, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fires on the owning Scheduler after the new event has been created.
             * @event dragCreateEnd
             * @param {Scheduler.view.Scheduler} source
             * @param {Scheduler.model.EventModel} newEventRecord
             * @param {Scheduler.model.ResourceModel} resourceRecord
             * @param {MouseEvent} event The ending mouseup event.
             * @param {HTMLElement} proxyElement The proxy element showing the drag creation zone.
             */

            /**
             * Fires on the owning Scheduler at the beginning of the drag gesture
             * @event beforeDragCreate
             * @param {Scheduler.view.Scheduler} source
             * @param {Scheduler.model.ResourceModel} resourceRecord
             * @param {Date} date The datetime associated with the drag start point.
             */

            /**
             * Fires on the owning Scheduler after the drag start has created a proxy element.
             * @event dragCreateStart
             * @param {Scheduler.view.Scheduler} source
             * @param {HTMLElement} proxyElement The proxy representing the new event.
             */

            /**
             * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
             * in the listener, to show a confirmation popup etc
             * ```
             *  scheduler.on('beforedragcreatefinalize', ({context}) => {
             *      context.async = true;
             *      setTimeout(() => {
             *          // async code don't forget to call finalize
             *          context.finalize();
             *      }, 1000);
             *  })
             * ```
             * @event beforeDragCreateFinalize
             * @param {Scheduler.view.Scheduler} source Scheduler instance
             * @param {HTMLElement} proxyElement Proxy element, representing future event
             * @param {Object} context
             * @param {Boolean} context.async Set true to handle drag create asynchronously (e.g. to wait for user
             * confirmation)
             * @param {Function} context.finalize Call this method to finalize drag create. This method accepts one
             * argument: pass true to update records, or false, to ignore changes
             */

            /**
             * Fires on the owning Scheduler at the end of the drag create gesture whether or not
             * a new event was created by the gesture.
             * @event afterDragCreate
             * @param {Scheduler.view.Scheduler} source
             * @param {HTMLElement} proxyElement The proxy element showing the drag creation zone.
             */
            //endregion
            //region Init
            value: function construct(scheduler, config) {
              var me = this;
              me.scheduler = scheduler; // Assign eventStore as store, it is used when drag creating by shared code

              me.store = scheduler.eventStore;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(EventDragCreate.prototype), "construct", this).call(this, scheduler, config);
            } //endregion
            //region Scheduler specific implementation

          }, {
            key: "finalizeDragCreate",
            value: function finalizeDragCreate(context) {
              var newEventRecord = new this.store.modelClass({
                startDate: context.startDate,
                endDate: context.endDate
              });
              this.proxy.dataset.eventId = newEventRecord.id;
              this.scheduler.trigger('dragCreateEnd', {
                newEventRecord: newEventRecord,
                resourceRecord: context.rowRecord,
                event: context.event,
                proxyElement: this.proxy
              });
            }
          }, {
            key: "handleBeforeDragCreate",
            value: function handleBeforeDragCreate(dateTime, event) {
              var me = this,
                  result = me.scheduler.trigger('beforeDragCreate', {
                resourceRecord: me.createContext.rowRecord,
                date: dateTime,
                event: event
              });

              if (result) {
                // Tooltip will not be activated while drag is in progress,
                // but we need to hide it deliberately on drag start
                var tipFeature = me.scheduler.features.scheduleTooltip;

                if (tipFeature) {
                  tipFeature.hoverTip && tipFeature.hoverTip.hide();
                }
              } // Save date constraints


              me.dateConstraints = me.scheduler.getDateConstraints(me.createContext.rowRecord, dateTime);
              return result;
            }
          }, {
            key: "checkValidity",
            value: function checkValidity(context, event) {
              var me = this,
                  client = me.client; // Nicer for users of validatorFn

              context.resourceRecord = context.rowRecord;
              return (client.allowOverlap || client.isDateRangeAvailable(context.startDate, context.endDate, null, context.resourceRecord)) && me.validatorFn.call(me.validatorFnThisObj || me, context, event);
            } // Determine if resource already has events or not

          }, {
            key: "isRowEmpty",
            value: function isRowEmpty(resourceRecord) {
              var events = this.store.getEventsForResource(resourceRecord);
              return !events || !events.length;
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                // used by gantt to only allow one task per row
                preventMultiple: false,

                /**
                 * An empty function by default, but provided so that you can perform custom validation on the event being created.
                 * Return true if the new event is valid, false to prevent an event being created.
                 * @param {Object} context A drag create context, containing at least { startDate, endDate, resourceRecord }
                 * @param {Event} event The event object
                 * @return {Boolean} isValid
                 * @config {function}
                 */
                validatorFn: function validatorFn() {}
              };
            }
          }]);

          return EventDragCreate;
        }(_base_DragCreateBase_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        EventDragCreate._$name = 'EventDragCreate';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerFeature(EventDragCreate, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventDragSelect.js":
      /*!**************************************************!*\
        !*** ./lib/Scheduler/feature/EventDragSelect.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventDragSelectJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventDragSelect;
        });
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "./node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/EventDragSelect
         */

        /**
         * Enables users to click and drag to select events inside the Scheduler's timeline.
         *
         * This feature is **disabled** by default.
         *
         * **NOTE:** Incompatible with {@link Scheduler.feature.EventDragCreate EventDragCreate} and the {@link Scheduler.feature.Pan Pan} features.
         *
         * @extends Common/mixin/InstancePlugin
         * @mixes Common/mixin/Delayable
         *
         * @example
         * let scheduler = new Scheduler({
         *   features : {
         *     eventDragSelect      : true,
         *     eventDragCreate      : false
         *   }
         * });
         *
         * @classtype eventDragSelect
         */

        var EventDragSelect =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(EventDragSelect, _Delayable);

          function EventDragSelect() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, EventDragSelect);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventDragSelect).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(EventDragSelect, [{
            key: "construct",
            // region Init
            value: function construct(timeline, config) {
              this.timeline = timeline;
              timeline.multiEventSelect = true;

              if (timeline.features.eventDragCreate || timeline.features.pan) {
                throw new Error('Cannot combine this feature with Pan or EventDragCreate features');
              }

              var targetSelectors = ['.b-grid-cell', '.b-timeline-subgrid'];
              this.targetSelector = targetSelectors.join(',');

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventDragSelect.prototype), "construct", this).call(this, timeline, config);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Scheduler.

          }, {
            key: "onElementMouseDown",
            //endregion
            value: function onElementMouseDown(event) {
              var me = this,
                  scheduler = me.client; // only react to mouse input, and left button

              if (event.touches || event.button !== 0) {
                return;
              } // only react to mousedown directly on grid cell or subgrid element


              if (event.target.matches(me.targetSelector)) {
                me.startX = event.clientX;
                me.startY = event.clientY;
                me.element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].createElement({
                  tag: 'div',
                  className: 'b-dragselect-rect'
                }, true)[0];

                _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_14__["default"].floatRoot.appendChild(me.element);

                scheduler.element.classList.add('b-dragselecting');
                me.eventRectangles = Array.from(scheduler.element.querySelectorAll(scheduler.eventSelector)).map(function (el) {
                  return {
                    rectangle: _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(el),
                    record: scheduler.resolveEventRecord(el)
                  };
                });
                scheduler.clearEventSelection();
                me.subGridElementRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(scheduler.timeAxisSubGrid.element); // No key processing during drag selection

                scheduler.navigator.disabled = true;
              }
            }
          }, {
            key: "onElementMouseMove",
            value: function onElementMouseMove(event) {
              var me = this; // Synthetic mousemove event has no button for IE11
              // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

              if (event.buttons === 0 && !_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isSafari && (!_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isIE11 || event.isTrusted)) {
                me.onElementMouseUp(event);
                return;
              }

              if (typeof me.startX === 'number') {
                var x = Math.max(event.clientX, me.subGridElementRect.left),
                    y = Math.max(event.clientY, me.subGridElementRect.top),
                    left = Math.min(me.startX, x),
                    top = Math.min(me.startY, y),
                    width = Math.abs(me.startX - x),
                    height = Math.abs(me.startY - y),
                    rect = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"](left, top, width, height).constrainTo(me.subGridElementRect);

                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].setTranslateXY(me.element, rect.left, rect.top);

                me.element.style.width = rect.width + 'px';
                me.element.style.height = rect.height + 'px';
                me.rectangle = rect;
                me.updateSelection();
              }
            }
          }, {
            key: "onElementMouseUp",
            value: function onElementMouseUp(event) {
              var me = this;

              if (typeof me.startX === 'number') {
                me.element && me.element.remove();
                me.client.element.classList.remove('b-dragselecting');
                me.startX = me.startY = null; // Navigator will react to the 'click' event which clears selection, bypass this with a short timeout

                me.setTimeout(function () {
                  return me.client.navigator.disabled = false;
                }, 100);
              }
            }
          }, {
            key: "updateSelection",
            value: function updateSelection() {
              var me = this,
                  renderedEventRects = me.eventRectangles,
                  rectangle = me.rectangle;

              for (var i = 0, len = renderedEventRects.length; i < len; i++) {
                var eventData = renderedEventRects[i],
                    shouldSelect = rectangle.intersect(eventData.rectangle, true);

                if (shouldSelect && !eventData.selected) {
                  eventData.selected = true;
                  me.client.selectEvent(eventData.record, true);
                } else if (!shouldSelect && eventData.selected) {
                  eventData.selected = false;
                  me.client.deselectEvent(eventData.record);
                }
              }
            }
          }], [{
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
              };
            }
          }]);

          return EventDragSelect;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_13__["default"])(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"]));

        EventDragSelect._$name = 'EventDragSelect';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(EventDragSelect, false, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventEdit.js":
      /*!********************************************!*\
        !*** ./lib/Scheduler/feature/EventEdit.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventEditJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventEdit;
        });
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "./node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "./node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _base_EditBase_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./base/EditBase.js */
        "./lib/Scheduler/feature/base/EditBase.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _view_EventEditor_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../view/EventEditor.js */
        "./lib/Scheduler/view/EventEditor.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/EventEdit
         */

        /**
         * Feature that displays a popup containing fields for editing event data.
         *
         * To customize its contents you can:
         *
         * * Toggle visibility of some built in widgets: `showResourceField`, `showNameField` and `showDeleteButton`
         * * Change the date format of the date & time fields: `dateFormat` and `timeFormat`
         * * Configure date & time fields: `startDateConfig`, `startTimeConfig`, `endDateConfig` and `endTimeConfig`
         * * Configure the resource field: `resourceFieldConfig`
         * * Append additional fields: `extraItems`
         * * Advanced: Replace entire contents using `editorConfig`
         *
         * This feature is **enabled** by default
         *
         * @extends Scheduler/feature/base/EditBase
         * @demo eventeditor
         * @externalexample scheduler/EventEdit.js
         */

        var EventEdit =
        /*#__PURE__*/
        function (_EditBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(EventEdit, _EditBase);

          function EventEdit() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, EventEdit);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventEdit).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(EventEdit, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(scheduler, config) {
              var me = this;
              me.scheduler = scheduler;
              me.eventStore = scheduler.eventStore;
              me.resourceStore = scheduler.resourceStore;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventEdit.prototype), "construct", this).call(this, scheduler, config);
            } //endregion
            //region Editing

            /**
             * Get/set readonly state
             * @property {Boolean}
             */

          }, {
            key: "getEditor",

            /**
             * Gets an editor instance. Creates on first call, reuses on consecutive
             * @internal
             * @returns {Common.widget.Popup} Editor popup
             */
            value: function getEditor() {
              var me = this;
              var editor = me.editor;

              if (editor) {
                return editor;
              }

              editor = me.editor = new _view_EventEditor_js__WEBPACK_IMPORTED_MODULE_17__["default"](_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].assign({
                eventEditFeature: me,
                align: 'b-t',
                id: "".concat(me.scheduler.id, "-event-editor"),
                autoShow: false,
                anchor: true,
                scrollAction: 'realign',
                clippedBy: [me.scheduler.timeAxisSubGridElement, me.scheduler.bodyContainer],
                constrainTo: window,
                autoClose: me.autoClose,
                cls: me.cls,
                readOnly: me.readOnly
              }, me.editorConfig));

              if (editor.items.length === 0) {
                console.warn('Event Editor configured without any `items`');
              } // add listeners programmatically so users cannot override them accidentally


              editor.on({
                beforehide: me.onPopupBeforeHide,
                keydown: me.onPopupKeyDown,
                thisObj: me
              }); // assign widget variables, using widget name: startDate -> me.startDateField
              // widgets with id set use that instead, id -> me.idField

              Object.values(editor.widgetMap).forEach(function (widget) {
                var ref = widget.ref || widget.id; // don't overwrite if already defined

                if (ref && !me[ref]) {
                  me[ref] = widget;

                  switch (widget.name) {
                    case 'startDate':
                    case 'endDate':
                      widget.on('change', me.onDatesChange, me);
                      break;
                  }
                }
              });
              me.eventTypeField && me.eventTypeField.on('change', me.onEventTypeChange, me);
              me.saveButton && me.saveButton.on('click', me.onSaveClick, me);
              me.deleteButton && me.deleteButton.on('click', me.onDeleteClick, me);
              me.cancelButton && me.cancelButton.on('click', me.onCancelClick, me);
              return me.editor;
            } // Called from editEvent() to actually show the editor

          }, {
            key: "internalShowEditor",
            value: function internalShowEditor(eventRecord, resourceRecord) {
              var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

              var me = this,
                  scheduler = me.scheduler,
                  // Align to the element (b-sch-event) and not the wrapper
              eventElement = element || _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].down(scheduler.getElementFromEventRecord(eventRecord, resourceRecord), scheduler.eventInnerSelector); // Event not in current TimeAxis - cannot be edited without extending the TimeAxis.
              // If there's no event element and the eventRecord is not in the store, we still
              // edit centered on the Scheduler - we're adding a new event


              if (eventElement || !eventRecord.isPartOfStore(scheduler.eventStore)) {
                /**
                 * Fires on the owning Scheduler before an event is displayed in an editor.
                 * This may be listened for to allow an application to take over event editing duties. Returning `false`
                 * stops the default editing UI from being shown.
                 * @event beforeEventEdit
                 * @param {Scheduler.view.Scheduler} source The scheduler
                 * @param {Scheduler.feature.EventEdit} eventEdit The eventEdit feature
                 * @param {Scheduler.model.EventModel} eventRecord The record about to be shown in the event editor.
                 * @param {Scheduler.model.ResourceModel} resourceRecord The Resource record for the event. If the event
                 * is being created, it will not contain a resource, so this parameter specifies the resource the
                 * event is being created for.
                 * @param {HTMLElement} eventElement The element which represents the event in the scheduler display.
                 * @preventable
                 */
                if (scheduler.trigger('beforeEventEdit', {
                  eventEdit: me,
                  eventRecord: eventRecord,
                  resourceRecord: resourceRecord,
                  eventElement: eventElement
                }) === false) {
                  scheduler.element.classList.remove('b-eventeditor-editing');
                  me.dragProxyElement && me.dragProxyElement.remove();
                  me.dragProxyElement = null;
                  return;
                }

                me.resourceRecord = resourceRecord;
                var editor = me.getEditor(eventRecord);

                if (me.typeField) {
                  me.toggleEventType(eventRecord.get(me.typeField));
                }
                /**
                 * Fires on the owning Scheduler when the editor for an event is available but before it is populated with
                 * data and shown. Allows manipulating fields etc.
                 * @event beforeEventEditShow
                 * @param {Scheduler.view.Scheduler} source The scheduler
                 * @param {Scheduler.feature.EventEdit} eventEdit The eventEdit feature
                 * @param {Scheduler.model.EventModel} eventRecord The record about to be shown in the event editor.
                 * @param {Scheduler.model.ResourceModel} resourceRecord The Resource record for the event. If the event
                 * is being created, it will not contain a resource, so this parameter specifies the resource the
                 * event is being created for.
                 * @param {HTMLElement} eventElement The element which represents the event in the scheduler display.
                 * @param {Common.widget.Popup} editor The editor
                 */


                scheduler.trigger('beforeEventEditShow', {
                  eventEdit: me,
                  eventRecord: eventRecord,
                  resourceRecord: resourceRecord,
                  eventElement: eventElement,
                  editor: editor
                });
                me.loadRecord(eventRecord, resourceRecord);

                if (eventElement) {
                  eventElement.classList.add('b-editing');
                  editor.anchor = true;
                  editor.showBy(eventElement);
                } // We are adding a new event. Display the editor centered in the Scheduler
                else {
                    editor.anchor = false;
                    editor.showBy({
                      target: scheduler.element,
                      align: 'c-c'
                    });
                  } // Adjust time field step increment based on timeAxis resolution


                var timeResolution = scheduler.timeAxisViewModel.timeResolution;

                if (timeResolution.unit === 'hour' || timeResolution.unit === 'minute') {
                  me.startTimeField.step = me.endTimeField.step = "".concat(timeResolution.increment).concat(timeResolution.unit);
                }
              }
            }
            /**
             * Opens an editor for the passed event. This function is exposed on Scheduler and can be called as
             * `scheduler.editEvent()`.
             * @param {Scheduler.model.EventModel} eventRecord Event to edit
             * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
             * This parameter is needed if the event is newly created for a resource and has not been assigned, or when using
             * multi assignment.
             * @param {HTMLElement} [element] Element to anchor editor to (defaults to events element)
             */

          }, {
            key: "editEvent",
            value: function editEvent(eventRecord, resourceRecord) {
              var element = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
              var me = this,
                  scheduler = me.scheduler;
              if (scheduler.readOnly) return; // The Promise being async allows a mouseover to trigger the event tip
              // unless we add the editing class immediately.

              scheduler.element.classList.add('b-eventeditor-editing');

              if (!resourceRecord) {
                if (eventRecord.resource) {
                  resourceRecord = eventRecord.resource;
                } // New event not yet in store has not got the relation set up, use id if available
                else if (eventRecord.resourceId) {
                    resourceRecord = scheduler.resourceStore.getById(eventRecord.resourceId);
                  }
              } // If element is specified (call triggered by EventDragCreate)
              // Then we can align to that, and no scrolling is necessary.
              // If we are simply being asked to edit a new event which is not
              // yet added, the editor is centered, and no scroll is necessary


              if (element || scheduler.eventStore.indexOf(eventRecord) < 0) {
                me.internalShowEditor(eventRecord, resourceRecord, element);
              } else {
                // Ensure event is in view before showing the editor.
                // Note that we first need to extend the time axis to include
                // currently out of range events.
                scheduler.scrollResourceEventIntoView(resourceRecord, eventRecord, null, {
                  animate: true,
                  edgeOffset: 0,
                  extendTimeAxis: false
                }).then(function () {
                  return me.internalShowEditor(eventRecord, resourceRecord);
                }, function () {
                  return scheduler.element.classList.remove('b-eventeditor-editing');
                });
              }
            }
            /**
             * Sets fields values from record being edited
             * @private
             */

          }, {
            key: "loadRecord",
            value: function loadRecord(eventRecord, resourceRecord) {
              var me = this,
                  eventStore = me.client.eventStore;
              me.eventRecord = eventRecord;
              me.resourceRecord = resourceRecord;
              me.editor.record = eventRecord;

              if (me.resourceField) {
                var resources = eventStore.getResourcesForEvent(eventRecord); // If this is an unassigned event, select the resource we've been provided

                if (!eventStore.storage.includes(eventRecord, true) && me.resourceRecord) {
                  me.resourceField.value = me.resourceRecord[me.resourceField.valueField];
                } else if (me.scheduler.assignmentStore) {
                  me.resourceField.value = resources.map(function (resource) {
                    return resource[me.resourceField.valueField];
                  });
                }
              }
            }
          }, {
            key: "toggleEventType",
            value: function toggleEventType(eventType) {
              // expose eventType in dataset, for querying and styling
              this.editor.element.dataset.eventType = eventType || ''; // toggle visibility of widgets belonging to eventTypes

              this.editor.eachWidget(function (widget) {
                return widget.dataset && widget.dataset.eventType && (widget.hidden = widget.dataset.eventType !== eventType);
              });
            } //endregion
            //region Save
            // Override of EditBase get values, to exclude resourceId when using an AssignmentStore. Without this
            // event.resourceId would end up as [r1, r2] etc. Which in turn breaks the event -> resource relation

          }, {
            key: "save",

            /**
             * Saves the changes (applies them to record if valid, if invalid editor stays open)
             * @private
             * @fires beforeeventsave
             * @fires beforeeventadd
             * @fires aftereventsave
             * @returns {*}
             */
            value: function save() {
              var me = this,
                  scheduler = me.scheduler,
                  eventRecord = me.eventRecord;

              if (!eventRecord || !me.isValid) {
                return;
              }

              var eventStore = me.eventStore,
                  values = me.values,
                  resourceRecords = me.resourceField && me.resourceField.records || [me.resourceRecord]; // Check for potential overlap scenarios before saving. TODO needs to be indicated in the UI

              if (!me.scheduler.allowOverlap && eventStore) {
                var abort = resourceRecords.some(function (resource) {
                  return !eventStore.isDateRangeAvailable(values.startDate, values.endDate, eventRecord, resource);
                });

                if (abort) {
                  return;
                }
              }
              /**
               * Fires on the owning Scheduler before an event is saved
               * @event beforeeventsave
               * @param {Scheduler.view.Scheduler} source The scheduler instance
               * @param {Scheduler.model.EventModel} eventRecord The record about to be saved
               * @param {Scheduler.model.ResourceModel} resourceRecord [DEPRECATED IN FAVOR OF `resourceRecords`] The resource to which the event is assigned
               * @param {Scheduler.model.ResourceModel[]} resourceRecords The resources to which the event is assigned
               * @param {Object} values The new values
               * @preventable
               */


              if (scheduler.trigger('beforeEventSave', {
                eventRecord: eventRecord,
                resourceRecords: resourceRecords,
                resourceRecord: resourceRecords[0],
                values: values
              }) !== false) {
                me.onBeforeSave(eventRecord);
                eventRecord.beginBatch();
                me.updateRecord(eventRecord);
                eventRecord.endBatch(); // Check if this is a new record

                if (eventStore && !eventRecord.stores.length) {
                  /**
                   * Fires on the owning Scheduler before an event is added
                   * @event beforeEventAdd
                   * @param {Scheduler.view.Scheduler} source The Scheduler instance.
                   * @param {Scheduler.model.EventModel} eventRecord The record about to be added
                   * @param {Scheduler.model.ResourceModel[]} resources **Deprecated** Use `resourceRecords` instead
                   * @param {Scheduler.model.ResourceModel[]} resourceRecords Resources that the record is assigned to
                   * @preventable
                   */
                  if (scheduler.trigger('beforeEventAdd', {
                    eventRecord: eventRecord,
                    resourceRecords: resourceRecords,
                    resources: resourceRecords
                  }) !== false) {
                    // Hand over the proxy element to be used by the new event
                    if (me.dragProxyElement) {
                      var eventTpl = scheduler.generateTplData(eventRecord, resourceRecords[0]); // Adopt the proxy as an event element.

                      if (eventTpl) {
                        _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].syncClassList(me.dragProxyElement, eventTpl.wrapperCls);

                        _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement({
                          tag: 'div',
                          parent: me.dragProxyElement,
                          className: eventTpl.cls.toString()
                        }); // This is a signal that it's from a drag-create, so needs to stay


                        me.dragProxyElement.classList.add('b-sch-dragcreator-proxy');
                        me.dragProxyElement.id = eventTpl.id;
                        scheduler.isHorizontal && scheduler.currentOrientation.releaseTimeSpanDiv(me.dragProxyElement, true);
                        me.dragProxyElement = null; // Flag to let HorizontalEventMapper know that it should reuse the element even though the
                        // event is new

                        eventRecord.instanceMeta(scheduler).fromDragProxy = true;
                      }
                    } // Add to eventStore first, then assign the resource. Order is necessary since assigning might
                    // involve an AssignmentStore


                    me.eventStore.add(eventRecord);
                    me.eventStore.assignEventToResource(eventRecord, resourceRecords); // If a filter was reapplied and filtered out the newly added event we need to clean up the drag proxy...

                    if (!me.eventStore.includes(eventRecord)) {
                      // Feels a bit strange having that responsibility here, but since it is already handled
                      var proxyElement = scheduler.element.querySelector('.b-sch-dragcreator-proxy');

                      if (proxyElement) {
                        scheduler.currentOrientation.availableDivs.remove(proxyElement);
                        proxyElement.remove();
                      }
                    }
                  } else {
                    return;
                  }
                } else if (scheduler.assignmentStore) {
                  me.eventStore.assignEventToResource(eventRecord, resourceRecords, true);
                }
                /**
                 * Fires on the owning Scheduler after an event is successfully saved
                 * @event afterEventSave
                 * @param {Scheduler.view.Scheduler} source The scheduler instance
                 * @param {Scheduler.model.EventModel} eventRecord The record about to be saved
                 */


                scheduler.trigger('afterEventSave', {
                  eventRecord: eventRecord
                });
                me.onAfterSave(eventRecord);
              }

              return eventRecord;
            } //endregion
            //region Delete

            /**
             * Delete event being edited
             * @private
             * @fires beforeeventdelete
             */

          }, {
            key: "deleteEvent",
            value: function deleteEvent() {
              var me = this,
                  eventRecord = me.eventRecord;
              /**
               * Fires on the owning Scheduler before an event is deleted
               * @event beforeeventdelete
               * @param {Scheduler.view.Scheduler} source The Scheduler instance.
               * @param {Scheduler.model.EventModel} eventRecord The record about to be deleted
               * @preventable
               */

              if (me.scheduler.trigger('beforeEventDelete', {
                eventRecord: eventRecord
              }) !== false) {
                // The reason it does it here is to move focus *before* it gets deleted,
                // and then there's code in the delete to see that it's deleting the focused one,
                // and jump forwards or backwards to move to the next or previous event
                // See 'Should allow key activation' test in tests/view/mixins/EventNavigation.t.js
                if (me.editor.containsFocus) {
                  me.editor.revertFocus();
                }

                me.scheduler.removeRecords([eventRecord]);
                return true;
              }

              return false;
            } //endregion
            //region Stores

          }, {
            key: "onActivateEditor",
            //endregion
            //region Events
            value: function onActivateEditor(_ref) {
              var eventRecord = _ref.eventRecord,
                  resourceRecord = _ref.resourceRecord;
              this.editEvent(eventRecord, resourceRecord);
            }
          }, {
            key: "onDragCreateEnd",
            value: function onDragCreateEnd(_ref2) {
              var newEventRecord = _ref2.newEventRecord,
                  resourceRecord = _ref2.resourceRecord,
                  proxyElement = _ref2.proxyElement;
              var me = this; // Call scheduler template method

              me.scheduler.onEventCreated(newEventRecord); // Clone proxy after showing editor so it's not deleted

              var dragProxyElement = proxyElement.cloneNode(true);
              dragProxyElement.removeAttribute('id');
              proxyElement.parentElement.appendChild(dragProxyElement);
              me.dragProxyElement = dragProxyElement;
              me.editEvent(newEventRecord, resourceRecord, dragProxyElement);
            } // chained from EventNavigation

          }, {
            key: "onEventEnterKey",
            value: function onEventEnterKey(_ref3) {
              var assignmentRecord = _ref3.assignmentRecord,
                  eventRecord = _ref3.eventRecord;

              if (assignmentRecord) {
                this.editEvent(eventRecord, assignmentRecord.resource);
              } else if (eventRecord) {
                this.editEvent(eventRecord, eventRecord.resource);
              }
            } // Toggle fields visibility when changing eventType

          }, {
            key: "onEventTypeChange",
            value: function onEventTypeChange(_ref4) {
              var value = _ref4.value;
              this.toggleEventType(value);
            } //endregion
            //region Context menu

          }, {
            key: "getEventMenuItems",
            value: function getEventMenuItems(_ref5) {
              var _this = this;

              var eventRecord = _ref5.eventRecord,
                  resourceRecord = _ref5.resourceRecord,
                  items = _ref5.items;

              if (!this.scheduler.readOnly) {
                items.editEvent = {
                  text: this.L('Edit Event'),
                  icon: 'b-icon b-icon-edit',
                  weight: -200,
                  onItem: function onItem() {
                    _this.editEvent(eventRecord, resourceRecord);
                  }
                };
              }
            } //endregion

          }, {
            key: "readOnly",
            get: function get() {
              return this.editor ? this.editor.readOnly : this._readOnly;
            },
            set: function set(readOnly) {
              this._readOnly = readOnly;

              if (this.editor) {
                this.editor.readOnly = readOnly;
              }
            }
          }, {
            key: "values",
            get: function get() {
              var values = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_11___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(EventEdit.prototype), "values", this);

              if (this.scheduler.assignmentStore) {
                // Not used with AssignmentStore
                delete values.resourceId;
              }

              return values;
            }
          }, {
            key: "resourceStore",
            get: function get() {
              return this._resourceStore;
            },
            set: function set(store) {
              this._resourceStore = store;

              if (this.resourceField) {
                this.resourceField.store = store;
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            // TODO: check which configs are actually used
            get: function get() {
              return {
                /**
                 * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
                 * @config {String}
                 * @default
                 * @category Editor
                 */
                triggerEvent: 'eventdblclick',

                /**
                 * True to show a combo for picking resource
                 * @config {Boolean}
                 * @default
                 * @category Editor widgets
                 */
                showResourceField: true,
                // TODO remove this config?

                /**
                 * Config for the resourceField constructor.
                 * @config {Object}
                 * @category Editor widgets
                 */
                resourceFieldConfig: null,

                /**
                 * The data field in the model that defines the eventType.
                 * Applied as class (b-eventtype-xx) to the editors element, to allow showing/hiding fields depending on
                 * eventType. Dynamic toggling of fields in the editor is activated by using `ref: 'eventTypeField'` on
                 * your widget:
                 *
                 * ```javascript
                 * const scheduler = new Scheduler({
                 *    features : {
                 *       eventEdit  : {
                 *           extraItems : [
                 *               {
                 *                   type  : 'combo',
                 *                   name  : 'eventType',
                 *                   ref   : 'eventTypeField',
                 *                   label : 'Type',
                 *                   items : ['Appointment', 'Internal', 'Meeting']
                 *               }
                 *           ]
                 *        }
                 *     }
                 * });
                 * ```
                 *
                 * @config {String}
                 * @default
                 * @category Editor
                 */
                typeField: 'eventType',

                /**
                 * The current {@link Scheduler.model.EventModel} record, which is being edited by the event editor.
                 * @property {Scheduler.model.EventModel}
                 * @readonly
                 */
                eventRecord: null,

                /**
                 * Specify `true` to put the editor in read only mode.
                 * @config {Boolean}
                 * @default false
                 */
                readOnly: null,

                /**
                 * Default editor configuration, which widgets it shows etc.
                 * @config {Object}
                 * @category Editor
                 */
                editorConfig: {
                  title: 'L{Edit Event}',
                  localeClass: this,
                  closable: true,
                  items: [
                  /**
                   * Reference to the name field, if used
                   * @member {Common.widget.TextField} nameField
                   * @readonly
                   */
                  {
                    type: 'text',
                    localeClass: this,
                    label: 'L{Name}',
                    clearable: true,
                    name: 'name',
                    ref: 'nameField'
                  },
                  /**
                   * Reference to the resource field, if used
                   * @member {Common.widget.Combo} resourceField
                   * @readonly
                   */
                  {
                    type: 'combo',
                    localeClass: this,
                    label: 'L{Resource}',
                    name: 'resource',
                    ref: 'resourceField',
                    editable: false,
                    valueField: 'id',
                    displayField: 'name'
                  },
                  /**
                   * Reference to the start date field, if used
                   * @member {Common.widget.DateField} startDateField
                   * @readonly
                   */
                  {
                    type: 'date',
                    cls: 'b-inline',
                    clearable: false,
                    required: true,
                    localeClass: this,
                    label: 'L{Start}',
                    name: 'startDate',
                    ref: 'startDateField',
                    flex: '1 0 60%'
                  },
                  /**
                   * Reference to the start time field, if used
                   * @member {Common.widget.TimeField} startTimeField
                   * @readonly
                   */
                  {
                    type: 'time',
                    clearable: false,
                    required: true,
                    name: 'startDate',
                    ref: 'startTimeField',
                    cls: 'b-match-label',
                    flex: '1 0 40%'
                  },
                  /**
                   * Reference to the end date field, if used
                   * @member {Common.widget.DateField} endDateField
                   * @readonly
                   */
                  {
                    type: 'date',
                    cls: 'b-inline',
                    clearable: false,
                    required: true,
                    localeClass: this,
                    label: 'L{End}',
                    name: 'endDate',
                    ref: 'endDateField',
                    flex: '1 0 60%'
                  },
                  /**
                   * Reference to the end time field, if used
                   * @member {Common.widget.TimeField} endTimeField
                   * @readonly
                   */
                  {
                    type: 'time',
                    clearable: false,
                    required: true,
                    name: 'endDate',
                    ref: 'endTimeField',
                    cls: 'b-match-label',
                    flex: '1 0 40%'
                  }, {
                    // widgets specified in extraItems will be inserted here
                    type: 'extraItems'
                  }],
                  bbar: [{
                    type: 'widget',
                    cls: 'b-label-filler'
                  },
                  /**
                   * Reference to the save button, if used
                   * @member {Common.widget.Button} saveButton
                   * @readonly
                   */
                  {
                    color: 'b-green',
                    localeClass: this,
                    text: 'L{Save}',
                    ref: 'saveButton'
                  },
                  /**
                   * Reference to the delete button, if used
                   * @member {Common.widget.Button} deleteButton
                   * @readonly
                   */
                  {
                    color: 'b-gray',
                    localeClass: this,
                    text: 'L{Delete}',
                    ref: 'deleteButton'
                  },
                  /**
                   * Reference to the cancel button, if used
                   * @member {Common.widget.Button} cancelButton
                   * @readonly
                   */
                  {
                    color: 'b-gray',
                    localeClass: this,
                    text: 'L{Cancel}',
                    ref: 'cancelButton'
                  }]
                }
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['getEventMenuItems', 'onEventEnterKey'],
                assign: ['editEvent']
              };
            }
          }]);

          return EventEdit;
        }(_base_EditBase_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        EventEdit._$name = 'EventEdit';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].registerFeature(EventEdit, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventFilter.js":
      /*!**********************************************!*\
        !*** ./lib/Scheduler/feature/EventFilter.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventFilterJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventFilter;
        });
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/EventFilter
         */

        /**
         * Adds event filter menu items to the timeline header context menu.
         *
         * This feature is **enabled** by default
         *
         * @extends Common/mixin/InstancePlugin
         */

        var EventFilter =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(EventFilter, _InstancePlugin);

          function EventFilter() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, EventFilter);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventFilter).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(EventFilter, [{
            key: "construct",
            value: function construct(scheduler, config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventFilter.prototype), "construct", this).call(this, scheduler, config);

              this.scheduler = scheduler;
            }
            /**
             * Populates the header context menu items.
             * @param {Grid.column.Column} column Column for which the menu will be shown
             * @param {Object[]} items Array of menu items
             * @internal
             */

          }, {
            key: "getHeaderMenuItems",
            value: function getHeaderMenuItems(column, items) {
              var me = this;
              if (column.type !== 'timeAxis') return;
              items.push({
                text: me.L('filterEvents'),
                icon: 'b-fw-icon b-icon-filter',
                menu: {
                  type: 'popup',
                  items: [{
                    type: 'textfield',
                    cls: 'b-eventfilter b-last-row',
                    clearable: true,
                    keyStrokeChangeDelay: 300,
                    label: me.L('byName'),
                    width: 200,
                    listeners: {
                      change: me.onEventFilterChange,
                      thisObj: me
                    }
                  }],
                  onBeforeShow: function onBeforeShow(_ref) {
                    var menu = _ref.source;

                    var _menu$items = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(menu.items, 1),
                        filterByName = _menu$items[0],
                        filter = me.scheduler.eventStore.filters.getBy('property', 'name');

                    filterByName.value = filter && filter.value;
                  }
                }
              });
            }
          }, {
            key: "onEventFilterChange",
            value: function onEventFilterChange(_ref2) {
              var value = _ref2.value;
              var me = this;

              if (value !== '') {
                me.scheduler.eventStore.filter('name', value);
              } else {
                me.scheduler.eventStore.removeFieldFilter('name');
              }
            }
          }], [{
            key: "pluginConfig",
            // Plugin configuration. This plugin chains some of the functions in Grid.
            get: function get() {
              return {
                chain: ['getHeaderMenuItems']
              };
            }
          }]);

          return EventFilter;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        EventFilter.featureClass = 'b-event-filter';
        EventFilter._$name = 'EventFilter';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(EventFilter, true, ['Scheduler', 'Gantt']);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventResize.js":
      /*!**********************************************!*\
        !*** ./lib/Scheduler/feature/EventResize.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventResizeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventResize;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _base_ResizeBase_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./base/ResizeBase.js */
        "./lib/Scheduler/feature/base/ResizeBase.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/ResizeHelper.js */
        "../Grid/lib/Common/helper/ResizeHelper.js");

        var productName = 'scheduler'; //TODO: Prevent right click while resizing (do it in ResizeHelper?)
        //TODO: Scroll

        /**
         * @module Scheduler/feature/EventResize
         */

        /**
         * Feature that allows resizing an event by dragging its end.
         *
         * By default it displays a tooltip with the new start and end dates, formatted using
         * {@link Scheduler/view/mixin/TimelineViewPresets#config-displayDateFormat}.
         *
         * This feature is **enabled** by default
         *
         * @extends Scheduler/feature/base/ResizeBase
         * @demo basic
         * @externalexample scheduler/EventResize.js
         */

        var EventResize =
        /*#__PURE__*/
        function (_ResizeBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(EventResize, _ResizeBase);

          function EventResize() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, EventResize);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventResize).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(EventResize, [{
            key: "createResizeHelper",
            //region Events

            /**
             * Fired on the owning Scheduler before resizing starts. Return false to prevent operation
             * @event beforeEventResize
             * @param {Scheduler.model.EventModel} eventRecord
             * @param {Event} event
             */

            /**
             * Fires on the owning Scheduler when event resizing starts
             * @event eventResizeStart
             * @param {Scheduler.model.EventModel} eventRecord
             * @param {Event} event
             */

            /**
             * Fires on the owning Scheduler on each resize move event
             * @event eventPartialResize
             * @param {Scheduler.model.EventModel} eventRecord
             * @param {Date} startDate
             * @param {Date} endDate
             * @param {HTMLElement} element
             */

            /**
             * Fired on the owning Scheduler to allow implementer to prevent immediate finalization by setting `data.context.async = true`
             * in the listener, to show a confirmation popup etc
             * ```
             *  scheduler.on('beforeeventresizefinalize', ({context}) => {
             *      context.async = true;
             *      setTimeout(() => {
             *          // async code don't forget to call finalize
             *          context.finalize();
             *      }, 1000);
             *  })
             * ```
             * @event beforeEventResizeFinalize
             * @param {Object} data
             * @param {Scheduler.view.Scheduler} data.source Scheduler instance
             * @param {Object} data.context
             * @param {Boolean} data.context.async Set true to handle resize asynchronously (e.g. to wait for user
             * confirmation)
             * @param {Function} data.context.finalize Call this method to finalize resize. This method accepts one
             * argument: pass true to update records, or false, to ignore changes
             */

            /**
             * Fires on the owning Scheduler after the resizing gesture has finished.
             * @event eventResizeEnd
             * @param {Boolean} wasChanged
             * @param {Scheduler.model.EventModel} eventRecord
             */
            //endregion
            //region Scheduler specifics
            value: function createResizeHelper() {
              var me = this,
                  client = me.client;
              return new _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
                direction: client.isVertical ? 'vertical' : 'horizontal',
                name: me.constructor.$name,
                // for debugging
                isElementResizable: function isElementResizable(el, event) {
                  return me.isElementResizable(el, event);
                },
                targetSelector: client.eventSelector,
                handleContainerSelector: client.eventInnerSelector,
                resizingCls: 'b-sch-event-wrap-resizing',
                allowResize: me.isElementResizable.bind(me),
                outerElement: client.timeAxisSubGridElement,
                // constrain resize to view
                scrollManager: client.scrollManager,
                dragThreshold: 0,
                scroller: client.timeAxisSubGrid.scrollable,
                // allow reading correct x & y scroll
                listeners: {
                  beforeresizestart: me.onBeforeResizeStart,
                  resizestart: me.onResizeStart,
                  resizing: me.onResizing,
                  resize: me.onFinishResize,
                  cancel: me.onCancelResize,
                  thisObj: me
                }
              });
            } // Store used by ResizeBase to detect updates on dropped record

          }, {
            key: "getTimespanRecord",
            // Used by ResizeBase to get an eventRecord from the drag context
            value: function getTimespanRecord(context) {
              return context.eventRecord;
            }
          }, {
            key: "getRowRecord",
            value: function getRowRecord(context) {
              return context.resourceRecord;
            } // Injects Scheduler specific data into the drag context

          }, {
            key: "setupProductResizeContext",
            value: function setupProductResizeContext(context, event) {
              var scheduler = this.client,
                  eventRecord = scheduler.resolveEventRecord(context.element),
                  resourceRecord = scheduler.resolveResourceRecord(context.element);
              Object.assign(context, {
                eventRecord: eventRecord,
                resourceRecord: resourceRecord,
                dateConstraints: scheduler.getDateConstraints(resourceRecord, eventRecord)
              });
            }
          }, {
            key: "onResizeStart",
            value: function onResizeStart(_ref) {
              var context = _ref.context,
                  event = _ref.event;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventResize.prototype), "onResizeStart", this).call(this, {
                context: context,
                event: event
              }); // Hide terminals when resizing starts


              if (this.client.features.dependencies) {
                this.client.features.dependencies.hideTerminals(context.element);
              } // Add resizing cls to inner element, as expected by styling


              context.element.querySelector('.b-sch-event').classList.add('b-sch-event-resizing');
            }
          }, {
            key: "checkValidity",
            value: function checkValidity(context, event) {
              return (this.client.allowOverlap || this.client.isDateRangeAvailable(context.startDate, context.endDate, context.eventRecord, context.resourceRecord)) && _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventResize.prototype), "checkValidity", this).call(this, context, event);
            }
          }, {
            key: "onFinishResize",
            value: function onFinishResize(_ref2) {
              var source = _ref2.source,
                  context = _ref2.context,
                  event = _ref2.event;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventResize.prototype), "onFinishResize", this).call(this, {
                source: source,
                context: context,
                event: event
              }); // When resizing is done successfully, mouse should be over element, so we show terminals


              if (this.client.features.dependencies) {
                this.client.features.dependencies.showTerminals(context.eventRecord, context.element);
              }
            }
          }, {
            key: "internalUpdateRecord",
            value: function internalUpdateRecord(context, timespanRecord) {
              var store = this.store,
                  generation = timespanRecord.generation;

              if (context.edge === 'left' || context.edge === 'top') {
                timespanRecord.setStartDate(context.startDate, false, store.skipWeekendsDuringDragDrop);
              } else {
                timespanRecord.setEndDate(context.endDate, false, store.skipWeekendsDuringDragDrop);
              } // The record has been changed


              if (timespanRecord.generation !== generation) {
                return true;
              } // The record has not been changed


              this.client.repaintEventsForResource(context.resourceRecord);
              return false;
            }
          }, {
            key: "finalize",
            value: function finalize(updateRecord) {
              this.resize.context.element.querySelector('.b-sch-event').classList.remove('b-sch-event-resizing');

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventResize.prototype), "finalize", this).call(this, updateRecord);
            } //endregion

          }, {
            key: "store",
            get: function get() {
              return this.client.eventStore;
            }
          }]);

          return EventResize;
        }(_base_ResizeBase_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        EventResize._$name = 'EventResize';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(EventResize, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/EventTooltip.js":
      /*!***********************************************!*\
        !*** ./lib/Scheduler/feature/EventTooltip.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureEventTooltipJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventTooltip;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./base/TooltipBase.js */
        "./lib/Scheduler/feature/base/TooltipBase.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/EventTooltip
         */

        /**
         * Displays a tooltip when hovering events. The template used to render the tooltip can be customized, see {@link #config-template}.
         * Config options are also applied to the tooltip shown, see {@link Common.widget.Tooltip} for available options.
         *
         * ```javascript
         * new Scheduler({
         *   features : {
         *     eventTooltip : {
         *         // Tooltip configs can be used here
         *         align : 'l-r' // Align left to right
         *     }
         *   }
         * });
         * ```
         *
         * This feature is **enabled** by default
         *
         * @extends Scheduler/feature/base/TooltipBase
         * @demo basic
         * @externalexample scheduler/EventTooltip.js
         */

        var EventTooltip =
        /*#__PURE__*/
        function (_TooltipBase) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(EventTooltip, _TooltipBase);

          function EventTooltip() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, EventTooltip);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventTooltip).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(EventTooltip, null, [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Template (a function accepting event data and returning a string) used to display info in the tooltip.
                 * The template will be called with an object containing the fields below
                 * @param {Object} data
                 * @param {Scheduler.model.EventModel} data.eventRecord
                 * @param {Date} data.startDate
                 * @param {Date} data.endDate
                 * @param {String} data.startText
                 * @param {String} data.endText
                 * @config {Function} template
                 */
                template: function template(data) {
                  return "\n                ".concat(data.eventRecord.name ? "<div class=\"b-sch-event-title\">".concat(data.eventRecord.name, "</div>") : '', "\n                ").concat(data.startClockHtml, "\n                ").concat(data.endClockHtml);
                },
                cls: 'b-sch-event-tooltip'
              };
            } //endregion

          }]);

          return EventTooltip;
        }(_base_TooltipBase_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        EventTooltip._$name = 'EventTooltip';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerFeature(EventTooltip, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/GroupSummary.js":
      /*!***********************************************!*\
        !*** ./lib/Scheduler/feature/GroupSummary.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureGroupSummaryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return GroupSummary;
        });
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.from */
        "./node_modules/core-js/modules/es6.array.from.js");
        /* harmony import */


        var core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_from__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Grid/feature/GroupSummary.js */
        "../Grid/lib/Grid/feature/GroupSummary.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Scheduler/view/Scheduler.js */
        "./lib/Scheduler/view/Scheduler.js");

        var productName = 'scheduler'; // Actions that trigger rerendering of group summary rows

        var refreshActions = {
          add: 1,
          remove: 1,
          update: 1,
          removeAll: 1,
          filter: 1
        };
        /**
         * @module Scheduler/feature/GroupSummary
         */
        // noinspection JSClosureCompilerSyntax

        /**
         * A special version of the Grid GroupSummary feature that enables summaries within scheduler. To use a single summary
         * it is easiest to configure {@link #config-renderer}, for multiple summaries see {@link #config-summaries}.
         *
         * This feature is <strong>disabled</strong> by default. It is **not** supported in vertical mode.
         *
         * @extends Grid/feature/GroupSummary test
         *
         * @classtype groupsummary
         * @externalexample scheduler/GroupSummary.js
         * @demo groupsummary
         * @typings Grid/feature/GroupSummary -> Grid/feature/GridGroupSummary
         */

        var GroupSummary =
        /*#__PURE__*/
        function (_GridGroupSummary) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(GroupSummary, _GridGroupSummary);

          function GroupSummary() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, GroupSummary);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(GroupSummary, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(scheduler, config) {
              var me = this;

              if (scheduler.isVertical) {
                throw new Error('GroupSummary feature is not supported in vertical mode');
              }

              me.scheduler = scheduler;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary.prototype), "construct", this).call(this, scheduler, config);

              if (!me.summaries && me.renderer) {
                me.summaries = [{
                  renderer: me.renderer
                }];
              }

              me.isScheduler = scheduler instanceof _Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_15__["default"];

              if (me.isScheduler) {
                scheduler.eventStore.on({
                  change: me.onEventStoreChange,
                  thisObj: me
                });
                scheduler.timeAxis.on({
                  reconfigure: me.onTimeAxisChange,
                  thisObj: me
                });
                scheduler.timeAxisViewModel.on({
                  update: me.onTimeAxisChange,
                  thisObj: me
                });
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              if (this._tip) {
                this._tip.destroy();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Events

          }, {
            key: "onTimeAxisChange",
            value: function onTimeAxisChange() {
              this.rerenderGroupSummaries();
            }
          }, {
            key: "onEventStoreChange",
            value: function onEventStoreChange(_ref) {
              var action = _ref.action; // Scheduler does minimal update on event changes, it will not rerender the summary rows.
              // Need to handle that here

              if (refreshActions[action]) {
                this.rerenderGroupSummaries();
              }
            }
          }, {
            key: "rerenderGroupSummaries",
            value: function rerenderGroupSummaries() {
              // TODO: Sort out the affected rows by checking events resources
              this.scheduler.rowManager.rows.forEach(function (row) {
                if (row.isGroupFooter) {
                  row.render();
                }
              });
            } //endregion
            //region Render

            /**
             * Called before rendering row contents, used to reset rows no longer used as group summary rows
             * @private
             */

          }, {
            key: "onBeforeRenderRow",
            value: function onBeforeRenderRow(_ref2) {
              var row = _ref2.row,
                  record = _ref2.record;

              if (row.isGroupFooter && !record.meta.hasOwnProperty('groupFooterFor')) {
                var timeaxisCell = row.elements.normal.querySelector('.b-sch-timeaxis-cell'); // remove summary cells if exist

                if (timeaxisCell) {
                  timeaxisCell.innerHTML = '';
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary.prototype), "onBeforeRenderRow", this).apply(this, arguments);
            }
            /**
             * Called by parent class to fill timeaxis with summary contents. Generates tick "cells" and populates them with
             * summaries.
             * ```
             * <div class="b-timeaxis-group-summary">
             *     <div class="b-timeaxis-tick">
             *         <div class="b-timeaxix-summary-value">x</div>
             *         ...
             *     </div>
             *     ...
             * </div>
             * ```
             * @private
             */

          }, {
            key: "generateHtml",
            value: function generateHtml(column, records, cls) {
              if (column.type === 'timeAxis') {
                var me = this,
                    scheduler = me.scheduler,
                    tickSize = scheduler.tickSize;
                var html = '';
                scheduler.timeAxis.forEach(function (tick) {
                  var // events for current tick
                  events = scheduler.eventStore.getEventsInTimeSpan(tick.startDate, tick.endDate, true, true),
                      // filter those events to current groups
                  groupEvents = events.filter(function (event) {
                    return event.resources.some(function (resource) {
                      return records.includes(resource);
                    });
                  }); // TODO: could turn this into a template

                  var sumHtml = me.summaries.map(function (config) {
                    // summary renderer used to calculate and format value
                    var value = config.renderer({
                      startDate: tick.startDate,
                      endDate: tick.endDate,
                      eventStore: scheduler.eventStore,
                      resourceStore: scheduler.resourceStore,
                      events: groupEvents
                    });
                    return "<div class=\"b-timeaxis-summary-value\">".concat(value, "</div>");
                  }).join('');
                  html += "<div class=\"b-timeaxis-tick\" style=\"width: ".concat(tickSize, "px\">").concat(sumHtml, "</div>");
                });
                return "<div class=\"b-timeaxis-group-summary\">".concat(html, "</div>");
              }

              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary.prototype), "generateHtml", this).call(this, column, records, cls);
            }
            /**
             * Overrides parents function to return correct summary count, used when sizing row
             * @private
             */

          }, {
            key: "updateSummaryHtml",
            value: function updateSummaryHtml(cellElement, column, records) {
              var count = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(GroupSummary.prototype), "updateSummaryHtml", this).call(this, cellElement, column, records);

              if (column.type === 'timeAxis') {
                var result = {
                  count: 0,
                  height: 0
                };
                this.summaries.forEach(function (config) {
                  if (config.height) {
                    result.height += config.height;
                  } else {
                    result.count++;
                  }
                });
                return result;
              }

              return count;
            }
            /**
             * Generates tooltip contents for hovered summary tick
             * @private
             */

          }, {
            key: "getTipHtml",
            value: function getTipHtml(_ref3) {
              var forElement = _ref3.forElement;
              var me = this,
                  index = Array.from(forElement.parentElement.children).indexOf(forElement),
                  tick = me.scheduler.timeAxis.getAt(index);
              var tipHtml = "<header>".concat(me.L('Summary for'), " ").concat(me.scheduler.getFormattedDate(tick.startDate), "</header>"),
                  showTip = false;

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].forEachSelector(forElement, '.b-timeaxis-summary-value', function (element, i) {
                var label = me._labels[i],
                    text = element.innerText.trim();
                tipHtml += "<label>".concat(label || '', "</label><div class=\"b-timeaxis-summary-value\">").concat(text, "</div>");
                if (element.innerHTML) showTip = true;
              });

              return showTip ? tipHtml : null;
            }
            /**
             * Initialize tooltip on render
             * @private
             */

          }, {
            key: "render",
            value: function render() {
              var me = this,
                  scheduler = me.scheduler;

              if (me.isScheduler) {
                // if any sum config has a label, init tooltip
                if (me.summaries && me.summaries.some(function (config) {
                  return config.label;
                }) && me.showTooltip && !me._tip) {
                  me._labels = me.summaries.map(function (config) {
                    return config.label || '';
                  });
                  me._tip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
                    id: "".concat(scheduler.id, "-groupsummary-tip"),
                    cls: 'b-timeaxis-summary-tip',
                    hoverDelay: 0,
                    hideDelay: 0,
                    forElement: scheduler.timeAxisSubGridElement,
                    anchorToTarget: true,
                    forSelector: '.b-timeaxis-group-summary .b-timeaxis-tick',
                    clippedBy: [scheduler.timeAxisSubGridElement, scheduler.bodyContainer],
                    getHtml: me.getTipHtml.bind(me)
                  });
                }
              }
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Show tooltip containing summary values and labels
                 * @config {Boolean}
                 * @default
                 */
                showTooltip: true,

                /**
                 * Array of summary configs, with format
                 * `[{ label: 'Label', renderer : ({startDate, endDate, eventStore, resourceStore, events, element}) }]`.
                 * @config {Object[]}
                 */
                summaries: null,

                /**
                 * Easier way to configure when using a single summary. Accepts a renderer function with the format specified
                 * in {@link #config-summaries}
                 * @config {Function}
                 */
                renderer: null
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['render']
              };
            }
          }]);

          return GroupSummary;
        }(_Grid_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // Needed for module bundle, which turns class name into GroupSummary$1 and registers it wrong


        GroupSummary._$name = 'GroupSummary'; // Override Grids GroupSummary with this improved version

        GroupSummary._$name = 'GroupSummary';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_13__["default"].registerFeature(GroupSummary, false, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/HeaderContextMenu.js":
      /*!****************************************************!*\
        !*** ./lib/Scheduler/feature/HeaderContextMenu.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureHeaderContextMenuJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HeaderContextMenu;
        });
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_widget_DateField_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/widget/DateField.js */
        "../Grid/lib/Common/widget/DateField.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/HeaderContextMenu
         */

        /**
         * Adds scheduler specific menu items to the timeline header context menu.
         * By default the menu has the following items:
         * * Filter tasks (if {@link Scheduler.feature.EventFilter EventFilter} is enabled)
         * * Zoom
         * * Date range
         * Can be populated by other features.
         *
         *  * To add extra items to the menu:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         headerContextMenu : {
         *             // Extra items
         *             extraItems : [
         *                 {
         *                     text : 'Extra',
         *                     icon : 'b-fa b-fa-fw b-fa-flag',
         *                     onItem() {
         *                         ...
         *                     }
         *                 }
         *             ]
         *         }
         *     }
         * });
         * ```
         *
         * Manipulate existing menu items in the timeaxis header menu:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         headerContextMenu : {
         *             // Process items before menu is shown
         *             processItems({ items }) {
         *                  // Push an extra item
         *                 items.push({
         *                     text : 'Cool action',
         *                     onItem() {
         *                           // ...
         *                     }
         *                  }
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * To disable header context menu for locked grid, but leave it for normal grid:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         contextMenu : {
         *             // to disable menu for headers except timeline header
         *             processHeaderItems : ({ column }) => column instanceof TimeAxisColumn,
         *             // to disable menu for cells
         *             processCellItems   : () => false
         *         }
         *     }
         * });
         * ```
         *
         * This feature is **enabled** by default
         *
         * @extends Common/mixin/InstancePlugin
         * @externalexample scheduler/HeaderContextMenu.js
         * @demo basic
         */

        var HeaderContextMenu =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(HeaderContextMenu, _InstancePlugin);

          function HeaderContextMenu() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, HeaderContextMenu);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(HeaderContextMenu).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(HeaderContextMenu, [{
            key: "construct",
            value: function construct(scheduler, config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(HeaderContextMenu.prototype), "construct", this).call(this, scheduler, config);

              this.scheduler = scheduler;
            }
            /**
             * Populates the header context menu items.
             * @param column Column for which the menu will be shown
             * @param items Array of menu items
             * @internal
             */

          }, {
            key: "getHeaderMenuItems",
            value: function getHeaderMenuItems(column, items) {
              var me = this,
                  scheduler = me.scheduler,
                  timeAxis = scheduler.timeAxis,
                  dateStep = {
                magnitude: timeAxis.shiftIncrement,
                unit: timeAxis.shiftUnit
              };

              if (column.type !== 'timeAxis') {
                return;
              }

              items.push({
                text: me.L('pickZoomLevel'),
                icon: 'b-fw-icon b-icon-search-plus',
                disabled: !scheduler.zoomLevels.length,
                menu: {
                  type: 'popup',
                  items: [{
                    type: 'slider',
                    showValue: false,
                    listeners: {
                      input: me.onZoomSliderChange,
                      thisObj: me
                    },
                    // set width for IE11
                    minWidth: 130
                  }],
                  onBeforeShow: function onBeforeShow(_ref) {
                    var menu = _ref.source;

                    var _menu$items = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(menu.items, 1),
                        zoom = _menu$items[0];

                    zoom.min = scheduler.minZoomLevel;
                    zoom.max = scheduler.maxZoomLevel;
                    zoom.value = scheduler.zoomLevel;
                  }
                }
              });
              me.startDateField = new _Common_widget_DateField_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
                label: me.L('startText'),
                labelWidth: '6em',
                required: true,
                step: dateStep,
                listeners: {
                  change: me.onRangeDateFieldChange,
                  thisObj: me
                }
              });
              me.endDateField = new _Common_widget_DateField_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
                label: me.L('endText'),
                labelWidth: '6em',
                required: true,
                step: dateStep,
                listeners: {
                  change: me.onRangeDateFieldChange,
                  thisObj: me
                }
              });
              items.push({
                text: me.L('activeDateRange'),
                icon: 'b-fw-icon b-icon-calendar',
                menu: {
                  type: 'popup',
                  width: '20em',
                  items: [me.startDateField, me.endDateField, {
                    type: 'button',
                    cls: 'b-left-nav-btn',
                    icon: 'b-icon b-icon-prev',
                    color: 'b-blue b-raised',
                    flex: 1,
                    margin: 0,
                    listeners: {
                      click: me.onLeftShiftBtnClick,
                      thisObj: me
                    }
                  }, {
                    type: 'button',
                    cls: 'b-today-nav-btn',
                    color: 'b-blue b-raised',
                    text: me.L('todayText'),
                    flex: 4,
                    margin: '0 8',
                    listeners: {
                      click: me.onTodayBtnClick,
                      thisObj: me
                    }
                  }, {
                    type: 'button',
                    cls: 'b-right-nav-btn',
                    icon: 'b-icon b-icon-next',
                    color: 'b-blue b-raised',
                    flex: 1,
                    listeners: {
                      click: me.onRightShiftBtnClick,
                      thisObj: me
                    }
                  }],
                  onBeforeShow: function onBeforeShow() {
                    return me.initDates();
                  }
                }
              });

              if (me.extraItems) {
                items.push.apply(items, me.extraItems);
              }

              var context = {
                items: items
              },
                  processItems = me.processItems; // Allow user to process the items

              if (processItems) {
                processItems(context);
              }
            }
          }, {
            key: "onZoomSliderChange",
            value: function onZoomSliderChange(_ref2) {
              var value = _ref2.value;
              this.scheduler.zoomLevel = value;
            }
          }, {
            key: "initDates",
            value: function initDates() {
              var me = this;
              me.startDateField.suspendEvents();
              me.endDateField.suspendEvents(); // The actual scheduler start dates may include time, but our Date field cannot currently handle
              // a time portion and throws it away, so when we need the value from an unchanged field, we need
              // to use the initialValue set from the timeAxis values.
              // Until our DateField can optionally include a time value, this is the solution.

              me.startDateField.value = me.startDateFieldInitialValue = me.scheduler.startDate;
              me.endDateField.value = me.endDateFieldInitialValue = me.scheduler.endDate;
              me.startDateField.resumeEvents();
              me.endDateField.resumeEvents();
            }
          }, {
            key: "onRangeDateFieldChange",
            value: function onRangeDateFieldChange(_ref3) {
              var source = _ref3.source;
              var me = this,
                  startDateChanged = source === me.startDateField,
                  client = me.client,
                  timeResolution = client.timeResolution,
                  scrollable = client.timeAxisSubGrid.scrollable,
                  startDate = me.startDateFieldInitialValue && !startDateChanged ? me.startDateFieldInitialValue : me.startDateField.value,
                  viewportStartDate = client.getDateFromX(scrollable.x);
              var endDate = me.endDateFieldInitialValue && startDateChanged ? me.endDateFieldInitialValue : me.endDateField.value; // When either of the fields is changed, we no longer use its initialValue from the timeAxis start or end
              // so that gets nulled to indicate that it's unavailable and the real field value is to be used.

              if (startDateChanged) {
                me.startDateFieldInitialValue = null;
              } else {
                me.endDateFieldInitialValue = null;
              } // Because the start and end dates are exclusive, avoid a zero
              // length time axis by incrementing the end by one tick unit
              // if they are the same.


              if (!(endDate - startDate)) {
                endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(endDate, timeResolution.increment, timeResolution.unit);
              } // if start date got bigger than end date set end date to start date plus one tick
              else if (endDate < startDate) {
                  endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(startDate, timeResolution.increment, timeResolution.unit);
                }

              me.scheduler.timeAxis.setTimeSpan(startDate, endDate); // Keep the visual start time the same

              scrollable.x = client.getCoordinateFromDate(viewportStartDate, true);
              me.initDates();
            }
          }, {
            key: "onLeftShiftBtnClick",
            value: function onLeftShiftBtnClick() {
              var me = this;
              me.scheduler.timeAxis.shiftPrevious();
              me.initDates();
            }
          }, {
            key: "onTodayBtnClick",
            value: function onTodayBtnClick() {
              var me = this,
                  today = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].clearTime(new Date());

              me.scheduler.timeAxis.setTimeSpan(today, _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(today, 1, 'day'));
              me.initDates();
            }
          }, {
            key: "onRightShiftBtnClick",
            value: function onRightShiftBtnClick() {
              var me = this;
              me.scheduler.timeAxis.shiftNext();
              me.initDates();
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * An array of additional items to add to the menu
                 * @config {Object[]}
                 * @default
                 */
                extraItems: null,

                /**
                 * A function called before displaying the menu that allows manipulations of its items. Called with a
                 * single parameter with format { eventRecord, resourceRecord, eventElement, items }.
                 *
                 * ```javascript
                 * features : {
                 *     headerContextMenu : {
                 *         processItems({ items }) {
                 *             // Add or remove items here as needed
                 *             items.push({ text: 'Some action', icon : 'b-fa b-fa-fw b-fa-ban' })
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @config {Function}
                 */
                processItems: null
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['getHeaderMenuItems']
              };
            }
          }]);

          return HeaderContextMenu;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        HeaderContextMenu.featureClass = '';
        HeaderContextMenu._$name = 'HeaderContextMenu';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(HeaderContextMenu, true, ['Scheduler', 'Gantt']);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/HeaderZoom.js":
      /*!*********************************************!*\
        !*** ./lib/Scheduler/feature/HeaderZoom.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureHeaderZoomJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HeaderZoom;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/HeaderZoom
         */

        /**
         * Enables users to click and drag to zoom to a date range in Scheduler's header time axis.
         *
         * This feature is **disabled** by default.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * let scheduler = new Scheduler({
         *   features : {
         *     headerZoom      : true
         *   }
         * });
         *
         * @classtype HeaderZoom
         * @externalexample scheduler/HeaderZoom.js
         */

        var HeaderZoom =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(HeaderZoom, _InstancePlugin);

          function HeaderZoom() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, HeaderZoom);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(HeaderZoom).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(HeaderZoom, [{
            key: "onElementMouseDown",
            //endregion
            value: function onElementMouseDown(event) {
              var me = this,
                  scheduler = me.client; // only react to mouse input, and left button

              if (event.touches || event.button !== 0) {
                return;
              } // only react to mousedown directly on timeaxis cell


              if (event.target.matches('.b-sch-header-timeaxis-cell')) {
                var headerEl = scheduler.subGrids.normal.header.headersElement;
                me.startX = event.clientX;
                me.element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].createElement({
                  parent: headerEl,
                  tag: 'div',
                  className: 'b-headerzoom-rect'
                });
                me.headerElementRect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"].from(headerEl);
              }
            }
          }, {
            key: "onElementMouseMove",
            value: function onElementMouseMove(event) {
              var me = this; // Synthetic mousemove event has no button for IE11
              // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

              if (event.buttons === 0 && !_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isSafari && (!_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].isIE11 || event.isTrusted)) {
                me.onElementMouseUp(event);
                return;
              }

              if (typeof me.startX === 'number') {
                var x = Math.max(event.clientX, me.headerElementRect.left),
                    left = Math.min(me.startX, x),
                    width = Math.abs(me.startX - x),
                    rect = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"](left - me.headerElementRect.x + me.client.scrollLeft, 0, width, me.headerElementRect.height);

                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].setTranslateX(me.element, rect.left);

                me.element.style.width = rect.width + 'px';
              }
            }
          }, {
            key: "onElementMouseUp",
            value: function onElementMouseUp(event) {
              var me = this;

              if (typeof me.startX === 'number') {
                var timeline = me.client,
                    rect = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"].from(me.element),
                    startDate = timeline.getDateFromCoordinate(rect.left, 'round', false),
                    endDate = timeline.getDateFromCoordinate(rect.right, 'round', false);

                me.element && me.element.remove();
                me.startX = null;
                me.client.zoomToSpan({
                  startDate: startDate,
                  endDate: endDate
                });
              }
            }
          }], [{
            key: "pluginConfig",
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Scheduler.
            get: function get() {
              return {
                chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
              };
            }
          }]);

          return HeaderZoom;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        HeaderZoom._$name = 'HeaderZoom';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].registerFeature(HeaderZoom, false, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/Labels.js":
      /*!*****************************************!*\
        !*** ./lib/Scheduler/feature/Labels.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureLabelsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Labels;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_reflect_has__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.reflect.has */
        "./node_modules/core-js/modules/es6.reflect.has.js");
        /* harmony import */


        var core_js_modules_es6_reflect_has__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_reflect_has__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_widget_Editor_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/widget/Editor.js */
        "../Grid/lib/Common/widget/Editor.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/Labels
         */

        var sides = ['top', 'left', 'right', 'bottom'],
            editorAlign = {
          top: 'b-b',
          right: 'l-l',
          bottom: 't-t',
          left: 'r-r'
        },
            topBottom = {
          top: 1,
          bottom: 1
        };
        /**
         * Displays labels at positions {@link #config-top}, {@link #config-right}, {@link #config-bottom} and {@link #config-left}.
         *
         * Text in labels can be set from a field on the {@link Scheduler.model.EventModel EventModel}
         * or the {@link Scheduler.model.ResourceModel ResourceModel} or using a custom renderer.
         *
         * Since `top` and `bottom` labels occupy space that would otherwise be used by the event we recommend using bigger rowHeights
         * (>55px for both labels with default styling) and zero barMargins because `top`/`bottom` labels give space around events anyway.
         *
         * This feature is **disabled** by default. It is **not** supported in vertical mode.
         *
         * @extends Common/mixin/InstancePlugin
         * @demo labels
         * @externalexample scheduler/Labels.js
         */

        var Labels =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Labels, _InstancePlugin);

          function Labels() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Labels);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Labels).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Labels, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(scheduler, config) {
              var me = this;

              if (scheduler.isVertical) {
                throw new Error('Labels feature is not supported in vertical mode');
              }

              me.scheduler = scheduler;
              me.labelElements = {};

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Labels.prototype), "construct", this).call(this, scheduler, config);

              var top = me.top,
                  bottom = me.bottom,
                  left = me.left,
                  right = me.right;

              if (top || bottom || left || right) {
                me.schedulerDetatcher = scheduler.on({
                  eventpaint: 'onEventPaint',
                  eventrepaint: 'onEventPaint',
                  taskpaint: 'onEventPaint',
                  taskrepaint: 'onEventPaint',
                  thisObj: me
                });
                me.updateHostClasslist(); // rowHeight warning, not in use
                //const labelCount = !!me.topLabel + !!me.bottomLabel;
                //if (scheduler.rowHeight < 60 - labelCount * 12) console.log('')
              }
            }
          }, {
            key: "updateHostClasslist",
            value: function updateHostClasslist() {
              var top = this.top,
                  bottom = this.bottom,
                  classList = this.scheduler.element.classList;
              classList.remove('b-labels-topbottom');
              classList.remove('b-labels-top');
              classList.remove('b-labels-bottom'); // OR is correct. This means that there are labels above OR below.

              if (top || bottom) {
                classList.add('b-labels-topbottom');

                if (top) {
                  classList.add('b-labels-top');
                }

                if (bottom) {
                  classList.add('b-labels-bottom');
                }
              }
            }
          }, {
            key: "onEventDblClick",
            value: function onEventDblClick(eventDblclick) {
              var me = this,
                  event = eventDblclick.event,
                  target = event.target.closest('.b-sch-label');

              if (target && !me.scheduler.readOnly) {
                var side = target.dataset.side,
                    labelConfig = me[side],
                    editor = labelConfig.editor,
                    field = labelConfig.field,
                    recordType = labelConfig.recordType;

                if (editor) {
                  if (!(editor instanceof _Common_widget_Editor_js__WEBPACK_IMPORTED_MODULE_12__["default"])) {
                    labelConfig.editor = new _Common_widget_Editor_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
                      appendTo: me.scheduler.element,
                      blurAction: me.blurAction,
                      inputField: editor,
                      scrollAction: 'realign'
                    });
                  }

                  labelConfig.editor.startEdit({
                    target: target,
                    align: editorAlign[side],
                    matchSize: false,
                    record: eventDblclick["".concat(recordType, "Record")],
                    field: field
                  });
                  event.stopImmediatePropagation();
                  return false;
                }
              }
            }
          }, {
            key: "processLabelSpec",
            value: function processLabelSpec(labelSpec, side) {
              if (typeof labelSpec === 'function') {
                labelSpec = {
                  renderer: labelSpec
                };
              } else if (typeof labelSpec === 'string') {
                labelSpec = {
                  field: labelSpec
                };
              } // Allow us to mutate ownProperties in the labelSpec without mutating outside object
              else if (labelSpec) {
                  labelSpec = Object.setPrototypeOf({}, labelSpec);
                } else {
                  return;
                }

              var scheduler = this.scheduler,
                  eventStore = scheduler.eventStore,
                  resourceStore = scheduler.resourceStore,
                  taskStore = scheduler.taskStore,
                  id = scheduler.id,
                  _labelSpec = labelSpec,
                  field = _labelSpec.field,
                  editor = _labelSpec.editor; // If there are milestones, and we are changing the available height
              // either by adding a top/bottom label, or adding a top/bottom label
              // then during the next dependency refresh, milestone width must be recalculated.

              if (topBottom[side]) {
                scheduler.milestoneWidth = null;
              } // Find the field definition or property from whichever store and cache the type.


              if (field) {
                var fieldDef;

                if (eventStore && !taskStore) {
                  fieldDef = eventStore.modelClass.fieldMap[field];

                  if (fieldDef) {
                    labelSpec.fieldDef = fieldDef;
                    labelSpec.recordType = 'event';
                  } // Check if it references a property
                  else if (Reflect.has(eventStore.modelClass.prototype, field)) {
                      labelSpec.recordType = 'event';
                    }
                }

                if (!fieldDef && taskStore) {
                  fieldDef = taskStore.modelClass.fieldMap[field];

                  if (fieldDef) {
                    labelSpec.fieldDef = fieldDef;
                    labelSpec.recordType = 'task';
                  } // Check if it references a property
                  else if (Reflect.has(resourceStore.modelClass.prototype, field)) {
                      labelSpec.recordType = 'task';
                    }
                }

                if (!fieldDef && resourceStore) {
                  fieldDef = resourceStore.modelClass.fieldMap[field];

                  if (fieldDef) {
                    labelSpec.fieldDef = fieldDef;
                    labelSpec.recordType = 'resource';
                  } // Check if it references a property
                  else if (Reflect.has(resourceStore.modelClass.prototype, field)) {
                      labelSpec.recordType = 'resource';
                    }
                }

                if (editor) {
                  if (typeof editor === 'boolean') {
                    scheduler.editor = {
                      type: 'textfield'
                    };
                  } else if (typeof editor === 'string') {
                    scheduler.editor = {
                      type: editor
                    };
                  }

                  scheduler.on({
                    eventdblclick: 'onEventDblClick',
                    taskdblclick: 'onEventDblClick',
                    thisObj: this
                  });
                }
              }

              return labelSpec;
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.schedulerDetatcher && this.schedulerDetatcher();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Labels.prototype), "doDestroy", this).call(this);
            }
            /**
             * Disable this feature
             * @property {Boolean}
             */

          }, {
            key: "onEventPaint",
            //endregion
            //region Events

            /**
             * Called when a new event element is created or updated. Make correct label state.
             * @private
             */
            value: function onEventPaint(paintEvent) {
              // Tear down old label setup (we may have been reconfigured)
              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].removeEachSelector(paintEvent.element, '.b-sch-label');

              if (!this.disabled) {
                // Insert all configured labels
                for (var _i = 0; _i < sides.length; _i++) {
                  var side = sides[_i];

                  if (this[side]) {
                    this.appendLabel(side, paintEvent.element, paintEvent);
                  }
                }
              }
            } //endregion
            //region Labels

            /**
             * Appends a label to a wrapping element
             * @private
             * @param side
             * @param appendTo
             * @param eventRecord
             */

          }, {
            key: "appendLabel",
            value: function appendLabel(side, appendTo, paintEvent) {
              this.labelElements[side] = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].createElement({
                tag: 'label',
                dataset: {
                  side: side
                },
                parent: appendTo
              });
              this.updateLabel(side, paintEvent);
            }
            /**
             * Updates a labels content
             * @private
             * @param side
             * @param eventRecord
             */

          }, {
            key: "updateLabel",
            value: function updateLabel(side, paintEvent) {
              var me = this,
                  _me$side = me[side],
                  field = _me$side.field,
                  fieldDef = _me$side.fieldDef,
                  recordType = _me$side.recordType,
                  renderer = _me$side.renderer,
                  thisObj = _me$side.thisObj,
                  labelElement = me.labelElements[side];
              var value; // Correct class name in case of element recycling from another render condition.

              labelElement.className = "".concat(me.labelCls, " ").concat(me.labelCls, "-").concat(side); // If there's a renderer, use that by preference

              if (renderer) {
                value = renderer.call(thisObj || me.thisObj || me, Object.assign({
                  labelElement: labelElement
                }, paintEvent));
              } else {
                value = paintEvent["".concat(recordType, "Record")][field]; // If it's a date, format it according to the Scheduler's defaults

                if (fieldDef && fieldDef.type === 'date' && !renderer) {
                  value = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].format(value, me.scheduler.displayDateFormat);
                }
              }

              labelElement.innerHTML = value || '\xa0';
            } //endregion

          }, {
            key: "top",
            set: function set(top) {
              this._top = this.processLabelSpec(top, 'top');
              this.updateHostClasslist();
            },
            get: function get() {
              return this._top;
            }
          }, {
            key: "right",
            set: function set(right) {
              this._right = this.processLabelSpec(right, 'right');
              this.updateHostClasslist();
            },
            get: function get() {
              return this._right;
            }
          }, {
            key: "bottom",
            set: function set(bottom) {
              this._bottom = this.processLabelSpec(bottom, 'bottom');
              this.updateHostClasslist();
            },
            get: function get() {
              return this._bottom;
            }
          }, {
            key: "left",
            set: function set(left) {
              this._left = this.processLabelSpec(left, 'left');
              this.updateHostClasslist();
            },
            get: function get() {
              return this._left;
            }
          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              this._disabled = disabled;

              if (this.client.rendered) {
                this.client.refresh();
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            // Default configuration.
            get: function get() {
              return {
                /**
                 * CSS class to apply to label elements
                 * @config {String}
                 * @default
                 */
                labelCls: 'b-sch-label',

                /**
                 * Top label configuration object. May contain the following properties:
                 * - field : [String](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String) The name of a field in one of the associated records,  {@link Scheduler.model.EventModel EventModel} or  {@link Scheduler.model.ResourceModel ResourceModel}. The record from which the field value is drawn will be ascertained by checking for field definitions by the specified name.<br>
                 * - renderer : [Function](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function) A function, which when passed an object containing `eventRecord`, `resourceRecord` and `labelElement` properties, returns the HTML to display as the label.<br>
                 * - thisObj : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) The `this` reference to use in the `renderer`.
                 * - editor : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) / {@link Common.widget.Field Field} If the label is to be editable, a field configuration object with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to work**.
                 * @config {Object}
                 * @default
                 */
                top: null,

                /**
                 * Right label configuration object. May contain the following properties:
                 * - field : [String](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String) The name of a field in one of the associated records,  {@link Scheduler.model.EventModel EventModel} or  {@link Scheduler.model.ResourceModel ResourceModel}. The record from which the field value is drawn will be ascertained by checking for field definitions by the specified name.<br>
                 * - renderer : [Function](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function) A function, which when passed an object containing `eventRecord`, `resourceRecord` and `labelElement` properties, returns the HTML to display as the label.<br>
                 * - thisObj : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) The `this` reference to use in the `renderer`.
                 * - editor : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) / {@link Common.widget.Field Field} If the label is to be editable, a field configuration object with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to work**.
                 * @config {Object}
                 * @default
                 */
                right: null,

                /**
                 * Bottom label configuration object. May contain the following properties:
                 * - field : [String](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String) The name of a field in one of the associated records,  {@link Scheduler.model.EventModel EventModel} or  {@link Scheduler.model.ResourceModel ResourceModel}. The record from which the field value is drawn will be ascertained by checking for field definitions by the specified name.<br>
                 * - renderer : [Function](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function) A function, which when passed an object containing `eventRecord`, `resourceRecord` and `labelElement` properties, returns the HTML to display as the label.<br>
                 * - thisObj : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) The `this` reference to use in the `renderer`.
                 * - editor : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) / {@link Common.widget.Field Field} If the label is to be editable, a field configuration object with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to work**.
                 * @config {Object}
                 * @default
                 */
                bottom: null,

                /**
                 * Left label configuration object. May contain the following properties:
                 * - field : [String](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String) The name of a field in one of the associated records,  {@link Scheduler.model.EventModel EventModel} or  {@link Scheduler.model.ResourceModel ResourceModel}. The record from which the field value is drawn will be ascertained by checking for field definitions by the specified name.<br>
                 * - renderer : [Function](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function) A function, which when passed an object containing `eventRecord`, `resourceRecord` and `labelElement` properties, returns the HTML to display as the label.<br>
                 * - thisObj : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) The `this` reference to use in the `renderer`.
                 * - editor : [Object](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object) / {@link Common.widget.Field Field} If the label is to be editable, a field configuration object with a `type` property, or an instantiated Field. **The `field` property is mandatory for editing to work**.
                 * @config {Object}
                 * @default
                 */
                left: null,
                thisObj: null,

                /**
                 * What action should be taken when focus moves leaves the cell editor, for example when clicking outside.
                 * May be `'complete'` or `'cancel`'.
                 * @config {String}
                 * @default
                 */
                blurAction: 'cancel'
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {};
            }
          }]);

          return Labels;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_8__["default"]); // TODO: Refactor the SASS, so that the auto-generated class name of ''b-' + cls.name.toLowerCase() can be used.


        Labels.featureClass = 'b-sch-labels';
        Labels._$name = 'Labels';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(Labels, false, ['Scheduler', 'Gantt']);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/NonWorkingTime.js":
      /*!*************************************************!*\
        !*** ./lib/Scheduler/feature/NonWorkingTime.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureNonWorkingTimeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return NonWorkingTime;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./AbstractTimeRanges.js */
        "./lib/Scheduler/feature/AbstractTimeRanges.js");
        /* harmony import */


        var _data_Calendar_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../data/Calendar.js */
        "./lib/Scheduler/data/Calendar.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/NonWorkingTime
         */

        /**
         * Feature that allows styling of weekends (and other non working time) by adding timeRanges for those days.
         *
         * This feature is **disabled** by default
         *
         * @extends Scheduler/feature/AbstractTimeRanges
         * @demo configuration
         * @externalexample scheduler/NonWorkingTime.js
         */

        var NonWorkingTime =
        /*#__PURE__*/
        function (_AbstractTimeRanges) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(NonWorkingTime, _AbstractTimeRanges);

          function NonWorkingTime() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, NonWorkingTime);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(NonWorkingTime).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(NonWorkingTime, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(client, config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(NonWorkingTime.prototype), "construct", this).call(this, client, config);

              if (!me.calendar || !client.calendar) {
                me.calendar = new _data_Calendar_js__WEBPACK_IMPORTED_MODULE_7__["default"]();
              }

              me.bindCalendar(me.calendar);
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.bindCalendar(null);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(NonWorkingTime.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Calendar

          }, {
            key: "bindCalendar",
            value: function bindCalendar(calendar) {
              var me = this;
              if (me.calendarDetacher) me.calendarDetacher();

              if (calendar) {
                me.calendarDetacher = calendar.on({
                  change: me.renderRanges,
                  thisObj: me,
                  delay: 1
                });
              }

              me.calendar = calendar;
              me.renderRanges();
            } //endregion
            //region Draw

          }, {
            key: "renderRanges",
            value: function renderRanges() {
              var me = this;

              if (me.store && !me.store.isDestroyed) {
                var shouldPaint = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].as(me.client.timeAxis.unit, 1, 'week') >= 1;
                me.store.removeAll(true);

                if (me.calendar && me.highlightWeekends && shouldPaint) {
                  me.store.add(me.calendar.getHolidaysRanges(me.client.timeAxis.startDate, me.client.timeAxis.endDate, true), true);
                }
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(NonWorkingTime.prototype), "renderRanges", this).call(this);
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Default config
            get: function get() {
              return {
                /**
                 * Highlight weekends
                 * @config {Boolean}
                 * @default
                 */
                highlightWeekends: true,
                showHeaderElements: true,
                cls: 'b-sch-nonworkingtime'
              };
            }
          }]);

          return NonWorkingTime;
        }(_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        NonWorkingTime._$name = 'NonWorkingTime';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(NonWorkingTime, false, ['Scheduler', 'Gantt']);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/Pan.js":
      /*!**************************************!*\
        !*** ./lib/Scheduler/feature/Pan.js ***!
        \**************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeaturePanJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Pan;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "./node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _base_DragBase_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./base/DragBase.js */
        "./lib/Scheduler/feature/base/DragBase.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/Pan
         */

        /**
         * Makes the scheduler's timeline pannable by dragging with the mouses.
         *
         * This feature is **disabled** by default.
         *
         * **NOTE:** Incompatible with {@link Scheduler.feature.EventDragCreate EventDragCreate} feature.
         *
         * @extends Common/mixin/InstancePlugin
         *
         * @example
         * // enable Pan
         * let scheduler = new Scheduler({
         *   features : {
         *     pan : true,
         *     eventDragCreate : false
         *   }
         * });
         *
         * @classtype pan
         */

        var Pan =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(Pan, _InstancePlugin);

          function Pan() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, Pan);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Pan).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(Pan, [{
            key: "construct",
            value: function construct(timeline, config) {
              this.timeline = timeline;
              if (timeline.features.eventDragCreate) throw new Error('Cannot combine Pan and eventDragCreate features');
              var targetSelectors = ['.b-grid-cell', '.b-timeline-subgrid'];
              this.targetSelector = targetSelectors.join(',');

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Pan.prototype), "construct", this).call(this, timeline, config);
            } //endregion
            //region Plugin config
            // Plugin configuration. This plugin chains some of the functions in Scheduler.

          }, {
            key: "onElementMouseDown",
            //endregion
            value: function onElementMouseDown(event) {
              var me = this,
                  timeline = me.timeline,
                  dragFeature = Object.values(timeline.features).find(function (feature) {
                return feature instanceof _base_DragBase_js__WEBPACK_IMPORTED_MODULE_13__["default"];
              }),
                  enablePanOnEvents = timeline.readOnly || !dragFeature || dragFeature.disabled; // only react to mouse input, and left button

              if (event.touches || event.button !== 0) {
                return;
              } // only react to mousedown directly on grid cell, subgrid element or if drag is disabled - the events too


              if (event.target.matches(me.targetSelector) || enablePanOnEvents && event.target.closest(timeline.eventSelector)) {
                me.mouseX = event.clientX;
                me.mouseY = event.clientY;
              }
            }
          }, {
            key: "onElementMouseMove",
            value: function onElementMouseMove(event) {
              var me = this; // Synthetic mousemove event has no button for IE11
              // Detect if a mouseup happened outside our element (or browser window for that matter). Note 'buttons' is not supported by Safari

              if (event.buttons === 0 && !_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isSafari && (!_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isIE11 || event.isTrusted)) {
                me.onElementMouseUp();
                return;
              }

              if (typeof me.mouseX === 'number') {
                var xScroller = me.timeline.subGrids.normal.scrollable,
                    yScroller = me.timeline.scrollable,
                    x = event.clientX,
                    y = event.clientY;
                event.preventDefault();

                if (me.vertical) {
                  yScroller.scrollBy(0, me.mouseY - y);
                }

                xScroller.scrollBy(me.mouseX - x);
                me.mouseX = x;
                me.mouseY = y;
              }
            }
          }, {
            key: "onElementMouseUp",
            value: function onElementMouseUp(event) {
              this.mouseX = this.mouseY = null;
            } //endregion

          }], [{
            key: "defaultConfig",
            // region Init
            get: function get() {
              return {
                /**
                 * Set to false to only pan horizontally
                 * @config {Boolean}
                 * @default
                 */
                vertical: true
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['onElementMouseDown', 'onElementMouseMove', 'onElementMouseUp']
              };
            }
          }]);

          return Pan;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        Pan._$name = 'Pan';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_11__["default"].registerFeature(Pan, false, ['Scheduler', 'Gantt']);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/ResourceTimeRanges.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/feature/ResourceTimeRanges.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureResourceTimeRangesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResourceTimeRanges;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../data/ResourceTimeRangeStore.js */
        "./lib/Scheduler/data/ResourceTimeRangeStore.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/ResourceTimeRanges
         */

        /**
         * Feature that draws resource time ranges, shaded areas displayed behind events. These zones are similar to events in
         * that they have a start and end date but different in that they do not take part in the event layout and they always
         * occupy full row height.
         *
         * Each time range is represented by an instances of {@link Scheduler.model.ResourceTimeRangeModel}, held in a
         * {@link Scheduler.data.ResourceTimeRangeStore}. Currently the they are readonly UI-wise, but can be manipulated on
         * the data level. To style the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field or use the {@link Scheduler.model.ResourceTimeRangeModel#field-timeRangeColor} field.
         *
         * Data can be provided either using the {@link #config-store} config:
         *
         * ```javascript
         * new Scheduler({
         *   features :  {
         *       resourceTimeRanges : {
         *          store : new Scheduler.data.ResourceTimeRangeStore({
         *              readUrl : './resourceTimeRanges/'
         *          })
         *       }
         *   }
         * })
         * ```
         *
         * or the `resourceTimeRanges` config on the Scheduler config object:
         *
         * ```javascript
         * new Scheduler({
         *   features :  {
         *       resourceTimeRanges : true
         *   },
         *
         *   // Data specified directly on the Scheduler instance
         *   resourceTimeRanges : [
         *     // Either specify startDate & endDate or startDate & duration when defining a range
         *     { startDate : new Date(2019,0,1), endDate : new Date(2019,0,3), name : 'Occupied', timeRangeColor : 'red' },
         *     { startDate : new Date(2019,0,3), duration : 2, durationUnit : 'd', name : 'Available' },
         *   ]
         * })
         * ```
         *
         * This feature is **disabled** by default
         *
         * @extends Common/mixin/InstancePlugin
         * @demo resourcetimeranges
         * @externalexample scheduler/ResourceTimeRanges.js
         */

        var ResourceTimeRanges =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ResourceTimeRanges, _InstancePlugin);

          function ResourceTimeRanges() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ResourceTimeRanges);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ResourceTimeRanges).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ResourceTimeRanges, [{
            key: "noFeatureElementsInAxis",
            // Let Scheduler know if we have ResourceTimeRanges in view or not
            value: function noFeatureElementsInAxis() {
              var timeAxis = this.scheduler.timeAxis;
              return !this.store.storage.values.some(function (t) {
                return timeAxis.isTimeSpanInAxis(t);
              });
            } //endregion
            //region Init

          }, {
            key: "construct",
            value: function construct(scheduler, config) {
              var me = this;
              me.scheduler = scheduler;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ResourceTimeRanges.prototype), "construct", this).call(this, scheduler, config); // expose getter/setter for resourceTimeRanges on scheduler


              Object.defineProperty(scheduler, 'resourceTimeRanges', {
                get: function get() {
                  return me.store.records;
                },
                set: function set(resourceTimeRanges) {
                  return me.store.data = resourceTimeRanges;
                }
              });
            }
            /**
             * Called during construction to do product specific store setup
             * @private
             */

          }, {
            key: "getEventsToRender",
            //endregion
            // Called on render of resources events to get events to render. Add any ranges
            // (chained function from Scheduler)
            value: function getEventsToRender(resource, events) {
              if (resource.timeRanges && resource.timeRanges.length) {
                events.push.apply(events, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(resource.timeRanges));
              }

              return events;
            } // Called for each event during render, allows manipulation of render data. Adjust any resource time ranges
            // (chained function from Scheduler)

          }, {
            key: "onEventDataGenerated",
            value: function onEventDataGenerated(renderData) {
              var me = this,
                  record = renderData.event || renderData.eventRecord; // Differs by mode

              if (record.isResourceTimeRange) {
                if (me.scheduler.isVertical) {
                  renderData.width = me.scheduler.resourceColumnWidth;
                } else {
                  renderData.top = 0; // Avoid colliding ids by using a prefix

                  renderData.id = "".concat(me.scheduler.id, "-").concat(me.idPrefix, "-").concat(record.id);
                } // Flag that we should fill entire row/col


                renderData.fillSize = true; // Needed for caching

                renderData.eventId = "".concat(me.idPrefix, "-").concat(record.id); // Add our own cls

                renderData.wrapperCls[me.rangeCls] = 1;
                renderData.wrapperCls["b-sch-color-".concat(record.timeRangeColor)] = record.timeRangeColor; // Add label

                renderData.body = document.createDocumentFragment();
                renderData.body.textContent = record.name;
              }
            } // Called when a ResourceTimeRangeModel is manipulated, relays to Scheduler#onInternalEventStoreChange which updates to UI

          }, {
            key: "onStoreChange",
            value: function onStoreChange(event) {
              this.scheduler.onInternalEventStoreChange(event);
            }
          }, {
            key: "store",
            set: function set(store) {
              var me = this,
                  scheduler = me.scheduler;
              me._store = store = store || new _data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_12__["default"]();

              if (!scheduler.resourceTimeRangeStore) {
                scheduler.resourceTimeRangeStore = store;
              } // ResourceZones can be set on scheduler or feature, for convenience


              if (scheduler.resourceTimeRanges) {
                store.add(scheduler.resourceTimeRanges);
                delete scheduler.resourceTimeRanges;
              } // Link to schedulers resourceStore if not already linked to one


              if (!store.resourceStore) {
                store.resourceStore = scheduler.resourceStore;
              }

              me.storeDetacher && me.storeDetacher();
              me.storeDetacher = me.store.on({
                change: me.onStoreChange,
                thisObj: me
              });
            },
            get: function get() {
              return this._store;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                idPrefix: 'resourcetimerange',
                rangeCls: 'b-sch-resourcetimerange',

                /**
                 * Store that holds resource time ranges (using ResourceTimeRangeModel or subclass thereof). A store will be
                 * automatically created if none is specified
                 * @config {Scheduler.data.ResourceTimeRangeStore}
                 */
                store: false,

                /**
                 * Time range definitions (data to ResourceTimeRangeModels). Will be added to store. Can also be specified
                 * on Scheduler for convenience
                 * @config {Scheduler.model.ResourceTimeRangeModel[]|Object[]}
                 */
                resourceTimeRanges: null
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['getEventsToRender', 'onEventDataGenerated', 'noFeatureElementsInAxis']
              };
            }
          }]);

          return ResourceTimeRanges;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_11__["default"]); // No feature based styling needed, do not add a cls to Scheduler


        ResourceTimeRanges.featureClass = '';
        ResourceTimeRanges._$name = 'ResourceTimeRanges';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(ResourceTimeRanges, false, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/ScheduleContextMenu.js":
      /*!******************************************************!*\
        !*** ./lib/Scheduler/feature/ScheduleContextMenu.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureScheduleContextMenuJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ScheduleContextMenu;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Scheduler_feature_base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Scheduler/feature/base/TimeSpanRecordContextMenuBase.js */
        "./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/ScheduleContextMenu
         */

        /**
         * Displays a context menu for empty parts of the schedule. Items are populated in the first place
         * by configurations of this Feature, then by other features and/or application code.
         *
         * To add extra items (Array notation):
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         scheduleContextMenu : {
         *             // Extra items for all events
         *             items : [
         *                 {
         *                     text : 'Extra',
         *                     icon : 'b-fa b-fa-fw b-fa-flag',
         *                     onItem({date, resourceRecord, items}) {
         *                         // Custom date based action
         *                     }
         *                 }
         *             ]
         *         }
         *     }
         * });
         * ```
         *
         * To add extra items (Object notation):
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         scheduleContextMenu : {
         *             // Extra items for all events
         *             items : {
         *                 extraItem : {
         *                     text : 'Extra',
         *                     icon : 'b-fa b-fa-fw b-fa-flag',
         *                     onItem({date, resourceRecord, items}) {
         *                         // Custom date based action
         *                     }
         *                 }
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * To remove existing items:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         scheduleContextMenu : {
         *             items : {
         *                 addEvent : false
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * Manipulate existing menu items:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         scheduleContextMenu : {
         *             // Process items before menu is shown
         *             processItems({date, resourceRecord, items}) {
         *                  // Push an extra item for ancient times
         *                  if (date < new Date(2018, 11, 17)) {
         *                      items.modernize = {
         *                          text : 'Modernize',
         *                          ontItem({date}) {
         *                              // Custom date based action
         *                          }
         *                      };
         *                  }
         *
         *                  // Do not show menu for Sundays
         *                  if (date.getDay() === 0) {
         *                      return false;
         *                  }
         *             }
         *         }
         *     }
         * });
         * ```
         *
         * This feature is **enabled** by default
         *
         * @extends Scheduler/feature/base/TimeSpanRecordContextMenuBase
         */

        var ScheduleContextMenu =
        /*#__PURE__*/
        function (_TimeSpanRecordContex) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ScheduleContextMenu, _TimeSpanRecordContex);

          function ScheduleContextMenu() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ScheduleContextMenu);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ScheduleContextMenu).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ScheduleContextMenu, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fired from scheduler before the context menu is shown for an event. Allows manipulation of the items
             * to show in the same way as in `processItems`. Returning false from a listener prevents the menu from
             * being shown.
             * @event scheduleContextMenuBeforeShow
             * @preventable
             * @param {Scheduler.view.Scheduler} source
             * @param {Object} items Menu item configs
             * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
             * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
             * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
             * @param {HTMLElement} eventElement
             */

            /**
             * Fired from scheduler when an item is selected in the context menu.
             * @event scheduleContextMenuItem
             * @param {Scheduler.view.Scheduler} source
             * @param {Common.widget.MenuItem} item
             * @param {Scheduler.model.EventModel} eventRecord
             * @param {Scheduler.model.ResourceModel} resourceRecord
             * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
             * @param {HTMLElement} eventElement
             */

            /**
             * Fired from scheduler after showing the context menu for an event
             * @event scheduleContextMenuShow
             * @preventable
             * @param {Scheduler.view.Scheduler} source
             * @param {Common.widget.Menu} menu The menu
             * @param {Scheduler.model.EventModel} eventRecord Event record for which the menu was triggered
             * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
             * @param {Scheduler.model.AssignmentModel} assignmentRecord Assignment record, if assignments are used
             * @param {HTMLElement} eventElement
             */
            //endregion
            //region Init
            value: function construct(scheduler, config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ScheduleContextMenu.prototype), "construct", this).call(this, scheduler, config);

              this.scheduler = scheduler;
            } //endregion
            //region Events

          }, {
            key: "showEventContextMenu",
            value: function showEventContextMenu(event) {
              var scheduler = this.scheduler,
                  cellData = scheduler.getEventData(event),
                  isTimeAxisColumn = cellData ? scheduler.columns.getById(cellData.columnId) === scheduler.timeAxisColumn : scheduler.timeAxisSubGrid.element === event.target,
                  // For vertical mode the resource must be resolved from the event
              resourceRecord = scheduler.resolveResourceRecord(event) || scheduler.resourceStore.last;

              if (isTimeAxisColumn) {
                this.showContextMenu({
                  menuType: 'schedule',
                  date: scheduler.getDateFromDomEvent(event, 'floor'),
                  resourceRecord: resourceRecord,
                  event: event
                });
                event.preventDefault();
              }
            } //endregion

          }, {
            key: "namedItems",
            get: function get() {
              var client = this.client;

              if (!this._namedItems) {
                this._namedItems = {
                  addEvent: {
                    text: client.L('Add event', null),
                    icon: 'b-icon b-icon-add',
                    disabled: client.resourceStore.count === 0,
                    weight: 100,
                    onItem: function onItem(_ref) {
                      var date = _ref.date,
                          resourceRecord = _ref.resourceRecord;
                      client.internalAddEvent(date, resourceRecord, client.getRowFor(resourceRecord));
                    }
                  }
                };
              }

              return this._namedItems;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * An array of extra menu items to add to the context menu
                 *
                 * ```javascript
                 * const scheduler = new Scheduler({
                 *     features : {
                 *         scheduleContextMenu : {
                 *             // Extra items for all events
                 *             items : [
                 *                 {
                 *                     text : 'Add meeting',
                 *                     icon : 'b-fa b-fa-fw b-fa-calendar-plus',
                 *                     onItem({ date, resourceRecord }) {
                 *                         scheduler.eventStore.add({
                 *                             name : 'Meeting',
                 *                             startDate : date,
                 *                             duration: 2,
                 *                             resourceId : resourceRecord.id
                 *                         });
                 *                     }
                 *                 }
                 *             ]
                 *         }
                 *     }
                 * });
                 * ```
                 *
                 * or items config to add extra items to the context menu or hide default items
                 *
                 * ```javascript
                 * features : {
                 *     scheduleContextMenu : {
                 *         items : {
                 *             // Add custom 'Add meeting' item
                 *             addMeeting : {
                 *                 text : 'Add meeting',
                 *                 icon : 'b-fa b-fa-fw b-fa-calendar-plus',
                 *                 onItem({ date, resourceRecord }) {
                 *                     scheduler.eventStore.add({
                 *                         name : 'Meeting',
                 *                         startDate : date,
                 *                         duration: 2,
                 *                         resourceId : resourceRecord.id
                 *                     });
                 *                 }
                 *             },
                 *             // Hide default 'Add event' item
                 *             addEvent : false
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @config {Object|Object[]}
                 */
                items: null,

                /**
                 * A function called before displaying the menu that allows manipulations of its items.
                 * Called with a single parameter with format { date, resourceRecord, items }.
                 * Returning `false` from this function prevents the menu from being shown.
                 *
                 * ```javascript
                 * const scheduler = new Scheduler({
                 *     features : {
                 *         scheduleContextMenu : {
                 *             // Process items before menu is shown
                 *             processItems({date, resourceRecord, items}) {
                 *                  // Push an extra item for ancient times
                 *                  if (date < new Date(2018, 11, 17)) {
                 *                      items.modernize = {
                 *                          text : 'Modernize',
                 *                          ontItem({date}) {
                 *                              // Custom date based action
                 *                          }
                 *                      };
                 *                  }
                 *
                 *                  // Do not show menu for Sundays
                 *                  if (date.getDay() === 0) {
                 *                      return false;
                 *                  }
                 *             }
                 *         }
                 *     }
                 * });
                 * ```
                 *
                 * @config {Function}
                 */
                processItems: null,

                /**
                 * This is a preconfigured set of {@link Common.widget.Container#config-namedItems} used to create the default context menu.
                 *
                 * The provided defaultItems setting is
                 *
                 *```javascript
                 *    {
                 *        addEvent : true
                 *    }
                 *```
                 *
                 * The `namedItems` provided by this feature are listed below. These are the property
                 * names which you may configure in the feature's {@link #config-items} config:
                 *
                 * - `addEvent` Add an event for at the resource and time indicated by the `contextmenu` event.
                 *
                 * To remove existing items, set corresponding keys to `false`
                 *
                 * ```javascript
                 * const scheduler = new Scheduler({
                 *     features : {
                 *         scheduleContextMenu : {
                 *             items : {
                 *                 addEvent : false
                 *             }
                 *         }
                 *     }
                 * });
                 * ```
                 *
                 * @config {Object}
                 */
                defaultItems: {
                  addEvent: true
                }
              };
            }
          }]);

          return ScheduleContextMenu;
        }(_Scheduler_feature_base_TimeSpanRecordContextMenuBase_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        ScheduleContextMenu.featureClass = '';
        ScheduleContextMenu._$name = 'ScheduleContextMenu';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerFeature(ScheduleContextMenu, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/ScheduleTooltip.js":
      /*!**************************************************!*\
        !*** ./lib/Scheduler/feature/ScheduleTooltip.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureScheduleTooltipJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ScheduleTooltip;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../tooltip/ClockTemplate.js */
        "./lib/Scheduler/tooltip/ClockTemplate.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/ScheduleTooltip
         */

        /**
         * Feature that displays a tooltip containing the time at the mouse position when hovering empty parts of the schedule. To not show the tooltip, just disable this feature:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         scheduleTooltip : false
         *     }
         * });
         * ```
         *
         * @extends Common/mixin/InstancePlugin
         * @demo basic
         * @externalexample scheduler/ScheduleTooltip.js
         */

        var ScheduleTooltip =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ScheduleTooltip, _InstancePlugin);

          function ScheduleTooltip() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ScheduleTooltip);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ScheduleTooltip).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ScheduleTooltip, [{
            key: "render",
            //endregion
            //region Init

            /**
             * Called when scheduler is rendered. Sets up drag and drop and hover tooltip.
             * @private
             */
            value: function render() {
              var me = this,
                  scheduler = me.client; // TODO: render should not ever be called twice.

              if (me.hoverTip) {
                me.hoverTip.destroy();
              }

              var reshowListener;
              var tip = me.hoverTip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
                id: "".concat(scheduler.id, "-schedule-tip"),
                cls: 'b-sch-scheduletip',
                allowOver: true,
                hoverDelay: 0,
                hideDelay: 100,
                showOnHover: true,
                forElement: scheduler.timeAxisSubGridElement,
                anchorToTarget: false,
                trackMouse: true,
                forSelector: '.b-scheduler:not(.b-animating):not(.b-dragging-event):not(.b-dragcreating) .b-timeline-subgrid > :not(.b-sch-foreground-canvas):not(.b-group-footer):not(.b-group-row) *',
                // Do not constrain at all, want it to be able to go outside of the viewport to not get in the way
                constrainTo: null,
                getHtml: me.getHoverTipHtml.bind(me),
                onDocumentMouseDown: function onDocumentMouseDown(event) {
                  // Click on the scheduler hides until the very next
                  // non-button-pressed mouse move!
                  if (tip.forElement.contains(event.event.target)) {
                    reshowListener = _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on({
                      element: scheduler.timeAxisSubGridElement,
                      mousemove: function mousemove(e) {
                        return tip.internalOnPointerOver(e);
                      },
                      capture: true
                    });
                  }

                  var hideAnimation = tip.hideAnimation;
                  tip.hideAnimation = false;
                  tip.constructor.prototype.onDocumentMouseDown.call(tip, event);
                  tip.hideAnimation = hideAnimation;
                },
                listeners: {
                  pointerover: function pointerover(_ref) {
                    var event = _ref.event;
                    var buttonsPressed = 'buttons' in event ? event.buttons > 0 : event.which > 0; // fallback for Safari which doesn't support 'buttons'
                    // This is the non-button-pressed mousemove
                    // after the document mousedown

                    if (!buttonsPressed && reshowListener) {
                      reshowListener();
                    } // Never any tooltip while interaction is ongoing and a mouse button is pressed


                    return !me.disabled && !scheduler.readOnly && !buttonsPressed;
                  }
                }
              }); // Do this to make tip CSP compliant. Not possible to have inline styles

              var tipMouseMove = tip.onMouseMove;

              tip.onMouseMove = function (event) {
                tipMouseMove.call(tip, event);
                me.onTipMove(tip, event);
              };

              me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
                timeAxisViewModel: scheduler.timeAxisViewModel
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.clockTemplate && me.clockTemplate.destroy();
              me.hoverTip && me.hoverTip.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ScheduleTooltip.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Contents

          }, {
            key: "onTipMove",
            value: function onTipMove(tip, event) {
              this.clockTemplate.updateDateIndicator(tip.element, this.lastTime);
            }
            /**
             * Gets html to display in hover tooltip (tooltip displayed on empty parts of scheduler)
             */

          }, {
            key: "getHoverTipHtml",
            value: function getHoverTipHtml(_ref2) {
              var tip = _ref2.tip,
                  event = _ref2.event;
              var me = this,
                  scheduler = me.client,
                  time = event && scheduler.getDateFromDomEvent(event, 'floor', true);
              var html = me.lastHtml;

              if (time) {
                var resourceRecord = scheduler.resolveResourceRecord(event);

                if (time - me.lastTime !== 0 || resourceRecord !== me.lastResource) {
                  me.lastResource = resourceRecord;
                  html = me.lastHtml = me.updateHoverTip(time, event);
                }
              } else {
                tip.hide();
                me.lastTime = null;
                me.lastResource = null;
              }

              return html;
            }
            /**
             * Called from getHoverTipHtml(), fills templates used.
             * @private
             */

          }, {
            key: "updateHoverTip",
            value: function updateHoverTip(date, event) {
              if (date) {
                var me = this,
                    clockHtml = me.clockTemplate.template({
                  date: date,
                  text: me.client.getFormattedDate(date)
                }),
                    messageHtml = me.messageTemplate({
                  message: me.getText(date, event) || ''
                });
                me.lastTime = date;
                return clockHtml + messageHtml;
              }
            }
            /**
             * Override this to render custom text to default hover tip
             * @param {Date} date
             * @param {Event} event Browser event
             * @return {String}
             */

          }, {
            key: "getText",
            value: function getText(date, event) {} //endregion

            /**
             * Disable this feature
             * @property {Boolean}
             */

          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              this._disabled = disabled;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                messageTemplate: function messageTemplate(data) {
                  return "<div class=\"b-sch-hovertip-msg\">".concat(data.message, "</div>");
                }
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['render']
              };
            }
          }]);

          return ScheduleTooltip;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_6__["default"]); // TODO: Refactor SASS so thet auto-generated class name of 'b-' + cls.name.toLowerCase() can be used.


        ScheduleTooltip.featureClass = 'b-scheduletip';
        ScheduleTooltip._$name = 'ScheduleTooltip';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_7__["default"].registerFeature(ScheduleTooltip, true, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/SimpleEventEdit.js":
      /*!**************************************************!*\
        !*** ./lib/Scheduler/feature/SimpleEventEdit.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureSimpleEventEditJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return SimpleEventEdit;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../model/AssignmentModel.js */
        "./lib/Scheduler/model/AssignmentModel.js");
        /* harmony import */


        var _Common_widget_Editor_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/widget/Editor.js */
        "../Grid/lib/Common/widget/Editor.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/SimpleEventEdit
         */

        /**
         * Feature that displays a text field to edit the event name. You can control the flow of this by listening to the events relayed by this class from the underlying {@link Common.widget.Editor}.
         * To use this feature, you also need to disable the built-in default editing feature:
         *
         * ```javascript
         * const scheduler = new Scheduler({
         *     features : {
         *         eventEdit       : false,
         *         simpleEventEdit : true
         *     }
         * });
         * ```
         *
         * This feature is **disabled** by default
         *
         * @extends Common/mixin/InstancePlugin
         * @demo simpleeditor
         * @externalexample scheduler/SimpleEventEdit.js
         */

        var SimpleEventEdit =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(SimpleEventEdit, _InstancePlugin);

          function SimpleEventEdit() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, SimpleEventEdit);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(SimpleEventEdit).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(SimpleEventEdit, [{
            key: "construct",
            //endregion
            //region Editing
            value: function construct(scheduler, config) {
              var _scheduler$on;

              var me = this;
              me.scheduler = scheduler;
              me.eventStore = scheduler.eventStore;
              scheduler.eventEdit = me;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(SimpleEventEdit.prototype), "construct", this).call(this, scheduler, config);

              me.clientListenersDetacher = scheduler.on((_scheduler$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_scheduler$on, me.triggerEvent, function (_ref) {
                var eventRecord = _ref.eventRecord,
                    eventElement = _ref.eventElement;
                return me.editEvent(eventRecord, eventRecord.resource, eventElement);
              }), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_scheduler$on, "dragcreateend", me.onDragCreateEnd), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_scheduler$on, "thisObj", me), _scheduler$on));
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.clientListenersDetacher();
              this.editor && this.editor.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(SimpleEventEdit.prototype), "doDestroy", this).call(this);
            } // region Editor

            /**
             * Opens an Editor for the passed event. This function is exposed on Scheduler and can be called as
             * `scheduler.editEvent()`.
             * @param {Scheduler.model.EventModel} eventRecord The Event to edit
             * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
             */

          }, {
            key: "editEvent",
            value: function editEvent(eventRecord, resourceRecord, element) {
              var me = this,
                  scheduler = me.scheduler;

              if (scheduler.readOnly) {
                return;
              }

              eventRecord = eventRecord instanceof _model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_10__["default"] ? eventRecord.event : eventRecord;
              me.resource = resourceRecord;
              me.event = eventRecord;
              me.element = element;
              scheduler.element.classList.add('b-eventeditor-editing');

              if (!me.editor) {
                me.editor = new _Common_widget_Editor_js__WEBPACK_IMPORTED_MODULE_11__["default"](Object.assign({
                  appendTo: me.scheduler.element,
                  scrollAction: 'realign',
                  cls: 'b-simpleeventeditor',
                  listeners: {
                    complete: me.onEditorComplete,
                    cancel: me.onEditorCancel,
                    thisObj: me
                  }
                }, me.editorConfig));
                me.relayEvents(me.editor, ['beforestart', 'start', 'beforecomplete', 'complete', 'beforecancel', 'cancel']);
              }

              me.editor.startEdit({
                target: element,
                record: eventRecord,
                field: me.field
              });
            }
          }, {
            key: "onEditorComplete",
            value: function onEditorComplete() {
              var me = this;

              if (me.event.stores.length === 0) {
                me.eventStore.add(me.editor.record);
                me.event.assign(me.resource);
                me.element.remove();
              }

              me.scheduler.element.classList.remove('b-eventeditor-editing');
            }
          }, {
            key: "onEditorCancel",
            value: function onEditorCancel() {
              if (this.event.stores.length === 0) {
                this.element.remove();
              }

              this.scheduler.element.classList.remove('b-eventeditor-editing');
            } //endregion
            // chained from EventNavigation

          }, {
            key: "onEventEnterKey",
            value: function onEventEnterKey(_ref2) {
              var assignmentRecord = _ref2.assignmentRecord,
                  eventRecord = _ref2.eventRecord;
              var element = assignmentRecord ? this.scheduler.getElementFromAssignmentRecord(assignmentRecord) : this.scheduler.getElementFromEventRecord(eventRecord),
                  resourceRecord = (assignmentRecord || eventRecord).resource;
              this.editEvent(eventRecord, resourceRecord, element);
            } //endregion

          }, {
            key: "onDragCreateEnd",
            value: function onDragCreateEnd(_ref3) {
              var newEventRecord = _ref3.newEventRecord,
                  resourceRecord = _ref3.resourceRecord,
                  proxyElement = _ref3.proxyElement;
              var me = this; // Call scheduler template method

              me.scheduler.onEventCreated(newEventRecord); // Clone proxy after showing editor so it's not deleted

              var dragProxyElement = proxyElement.cloneNode(true);
              dragProxyElement.removeAttribute('id');
              proxyElement.parentElement.appendChild(dragProxyElement);
              me.element = dragProxyElement;
              me.editEvent(newEventRecord, resourceRecord, dragProxyElement);
            }
          }], [{
            key: "defaultConfig",
            // region Events

            /**
             * Fired before the editor is shown to start an edit operation. Returning `false` from a handler vetoes the edit operation.
             * @event beforeStart
             * @preventable
             * @property {Object} value - The value to be edited.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             */

            /**
             * Fired when an edit operation has begun.
             * @event start
             * @property {Object} value - The starting value of the field.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             */

            /**
             * Fired when an edit completion has been requested, either by `ENTER`, or focus loss (if configured to complete on blur).
             * The completion may be vetoed, in which case, focus is moved back into the editor.
             * @event beforeComplete
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The new value.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             * @preventable
             */

            /**
             * Edit has been completed, and any associated record or element has been updated.
             * @event complete
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The new value.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             */

            /**
             * Fired when cancellation has been requested, either by `ESC`, or focus loss (if configured to cancel on blur).
             * The cancellation may be vetoed, in which case, focus is moved back into the editor.
             * @event beforeCancel
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The new value.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             * @preventable
             */

            /**
             * Edit has been canceled without updating the associated record or element.
             * @event cancel
             * @property {Object} oldValue - The original value.
             * @property {Object} value - The value of the field.
             * @property {Common.widget.Editor} source - The Editor that triggered the event.
             */
            // endregion
            //region Config
            get: function get() {
              return {
                /**
                 * The event that shall trigger showing the editor. Defaults to `eventdblclick`, set to `` or null to disable editing of existing events.
                 * @config {String}
                 * @default
                 * @category Editor
                 */
                triggerEvent: 'eventdblclick',

                /**
                 * The current {@link Scheduler.model.EventModel} record, which is being edited by the event editor.
                 * @property {Scheduler.model.EventModel}
                 * @readonly
                 */
                eventRecord: null,

                /**
                 * The {@link Scheduler.model.EventModel} field to edit
                 * @config {String}
                 * @category Editor
                 */
                field: 'name',

                /**
                 * The editor configuration, where you can control which widget to show
                 * @config {Object}
                 * @category Editor
                 */
                editorConfig: null
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['onEventEnterKey'],
                assign: ['editEvent']
              };
            }
          }]);

          return SimpleEventEdit;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        SimpleEventEdit._$name = 'SimpleEventEdit';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_8__["default"].registerFeature(SimpleEventEdit, false, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/Summary.js":
      /*!******************************************!*\
        !*** ./lib/Scheduler/feature/Summary.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureSummaryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Summary;
        });
        /* harmony import */


        var core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.string.repeat */
        "./node_modules/core-js/modules/es6.string.repeat.js");
        /* harmony import */


        var core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_repeat__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/feature/Summary.js */
        "../Grid/lib/Grid/feature/Summary.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _view_Scheduler_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../view/Scheduler.js */
        "./lib/Scheduler/view/Scheduler.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/Summary
         */
        // noinspection JSClosureCompilerSyntax

        /**
         * A special version of the Grid Summary feature. This feature displays a summary row in the grid footer.
         * For regular columns in the locked section - specify type of summary on columns, available types are:
         * <dl class="wide">
         * <dt>sum <dd>Sum of all values in the column
         * <dt>add <dd>Alias for sum
         * <dt>count <dd>Number of rows
         * <dt>countNotEmpty <dd>Number of rows containing a value
         * <dt>average <dd>Average of all values in the column
         * <dt>function <dd>A custom function, used with store.reduce. Should take arguments (sum, record)
         * </dl>
         * Columns can also specify a summaryRender to format the calculated sum.
         *
         * To summarize events, either provide a {@link #config-renderer} or use {@link #config-summaries}
         *
         * This feature is <strong>disabled</strong> by default. It is **not** supported in vertical mode.
         *
         * @extends Grid/feature/Summary
         *
         * @classtype summary
         * @externalexample scheduler/Summary.js
         * @demo summary
         * @typings Grid/feature/Summary -> Grid/feature/GridSummary
         */

        var Summary =
        /*#__PURE__*/
        function (_GridSummary) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(Summary, _GridSummary);

          function Summary() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, Summary);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Summary).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(Summary, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(scheduler, config) {
              var me = this;

              if (scheduler.isVertical) {
                throw new Error('Summary feature is not supported in vertical mode');
              }

              me.scheduler = scheduler;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Summary.prototype), "construct", this).call(this, scheduler, config);

              if (!me.summaries) me.summaries = [{
                renderer: me.renderer
              }]; // Feature might be run from Grid (in docs), should not crash
              // https://app.assembla.com/spaces/bryntum/tickets/6801/details

              if (scheduler instanceof _view_Scheduler_js__WEBPACK_IMPORTED_MODULE_12__["default"]) {
                scheduler.eventStore.on({
                  change: me.updateScheduleSummaries,
                  thisObj: me
                });
                scheduler.resourceStore.on({
                  change: me.updateScheduleSummaries,
                  thisObj: me
                });
                scheduler.timeAxisViewModel.on({
                  update: me.renderRows,
                  thisObj: me
                });
              }
            } //endregion
            //region Render

          }, {
            key: "renderRows",
            value: function renderRows() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Summary.prototype), "renderRows", this).call(this);

              this.render();
            }
            /**
             * Updates summaries.
             * @private
             */

          }, {
            key: "updateScheduleSummaries",
            value: function updateScheduleSummaries() {
              var me = this,
                  scheduler = me.scheduler,
                  summaryContainer = scheduler.element.querySelector('.b-grid-footer.b-sch-timeaxiscolumn');

              if (summaryContainer) {
                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].forEachSelector(summaryContainer, '.b-timeaxis-tick', function (element, i) {
                  var tick = scheduler.timeAxis.getAt(i),
                      events = scheduler.eventStore.getEventsInTimeSpan(tick.startDate, tick.endDate, true, true);
                  var html = '',
                      tipHtml = "<header>".concat(me.L('Summary for'), " ").concat(scheduler.getFormattedDate(tick.startDate), "</header>");
                  me.summaries.forEach(function (config) {
                    var value = config.renderer({
                      startDate: tick.startDate,
                      endDate: tick.endDate,
                      eventStore: scheduler.eventStore,
                      resourceStore: scheduler.resourceStore,
                      events: events,
                      element: element
                    }),
                        valueHtml = "<div class=\"b-timeaxis-summary-value\">".concat(value, "</div>");
                    if (me.summaries.length > 1 || value !== '') html += valueHtml;
                    tipHtml += "<label>".concat(config.label || '', "</label>") + valueHtml;
                  });
                  element.innerHTML = html;
                  element._tipHtml = tipHtml;
                });
              }
            }
          }, {
            key: "render",
            value: function render() {
              var me = this,
                  scheduler = me.scheduler,
                  summaryEl = scheduler.element.querySelector('.b-grid-footer.b-sch-timeaxiscolumn');

              if (summaryEl) {
                // if any sum config has a label, init tooltip
                if (me.summaries.some(function (config) {
                  return config.label;
                }) && me.showTooltip && !me._tip) {
                  me._tip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
                    id: "".concat(scheduler.id, "-summary-tip"),
                    cls: 'b-timeaxis-summary-tip',
                    hoverDelay: 0,
                    hideDelay: 100,
                    forElement: summaryEl,
                    anchorToTarget: true,
                    trackMouse: false,
                    forSelector: '.b-timeaxis-tick',
                    getHtml: function getHtml(_ref) {
                      var forElement = _ref.forElement;
                      return forElement._tipHtml;
                    }
                  });
                }

                summaryEl.innerHTML = "<div class=\"b-timeaxis-tick\" style=\"width: ".concat(scheduler.tickSize, "px\"></div>").repeat(scheduler.timeAxis.count);
                me.updateScheduleSummaries();
              }
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Show tooltip containing summary values and labels
                 * @config {Boolean}
                 * @default
                 */
                showTooltip: true,

                /**
                 * Array of summary configs, with format
                 * `[{ label: 'Label', renderer : ({startDate, endDate, eventStore, resourceStore, events, element}) }]`.
                 * @config {Object[]}
                 */
                summaries: null,

                /**
                 * Easier way to configure When using single summary, accepts a renderer function with the format specified
                 * in {@link #config-summaries}
                 * @config {Function}
                 */
                renderer: null
              };
            }
          }]);

          return Summary;
        }(_Grid_feature_Summary_js__WEBPACK_IMPORTED_MODULE_8__["default"]); // Needed for module bundle, which turns class name into Summary$1 and registers it wrong


        Summary._$name = 'Summary'; // Override Grids Summary with this improved version

        Summary._$name = 'Summary';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].registerFeature(Summary, false, 'Scheduler');
        /***/

      },

      /***/
      "./lib/Scheduler/feature/TimeRanges.js":
      /*!*********************************************!*\
        !*** ./lib/Scheduler/feature/TimeRanges.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureTimeRangesJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeRanges;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "./node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./AbstractTimeRanges.js */
        "./lib/Scheduler/feature/AbstractTimeRanges.js");
        /* harmony import */


        var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../model/TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");
        /* harmony import */


        var _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/TimeRanges
         */

        /**
         * Feature that renders global ranges of time in the timeline. Use this feature to visualize a `range` like a 1 hr lunch or some important point in time
         * (a `line`, i.e. a range with 0 duration). This feature can also show a current time indicator if you set {@link #config-showCurrentTimeLine} to true. To style
         * the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field of the `TimeSpan` class.
         *
         * Each time range is represented by an instances of {@link Scheduler.model.TimeSpan}, held in a simple {@link Common.data.Store}.
         * If {@link Scheduler.data.CrudManager} is specified for the scheduler, the {@link #config-store} will be added at the end of the CrudManager
         * {@link Scheduler.crud.AbstractCrudManager#property-stores} collection.
         *
         * This feature is **disabled** by default
         *
         * @extends Scheduler/feature/AbstractTimeRanges
         * @classtype timeRanges
         * @demo timeranges
         * @externalexample scheduler/TimeRanges.js
         */

        var TimeRanges =
        /*#__PURE__*/
        function (_AbstractTimeRanges) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TimeRanges, _AbstractTimeRanges);

          function TimeRanges() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TimeRanges);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimeRanges).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TimeRanges, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(client, config) {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimeRanges.prototype), "construct", this).call(this, client, config);

              if (!client._timeRangesExposed) {
                // expose getter/setter for timeRanges on scheduler/gantt
                Object.defineProperty(client, 'timeRanges', {
                  get: function get() {
                    return me.store.records;
                  },
                  set: function set(timeRanges) {
                    return me.store.data = timeRanges;
                  }
                });
                client._timeRangesExposed = true;
              }
            }
          }, {
            key: "startConfigure",
            value: function startConfigure(config) {
              var client = this.client; // If the client's project has a timeRangeStore, we must use that

              if (client.project) {
                var store = client.project.timeRangeStore;

                if (store) {
                  config.store = store;
                }
              }
            } //endregion
            //region Current time line

          }, {
            key: "initCurrentTimeLine",
            value: function initCurrentTimeLine() {
              var me = this,
                  now = new Date();

              if (me.currentTimeLine || !me.showCurrentTimeLine) {
                return;
              }

              me.currentTimeLine = new me.store.modelClass({
                'id': 'currentTime',
                cls: 'b-sch-current-time',
                startDate: now,
                name: _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(now, me.currentDateFormat)
              });
              me.currentTimeInterval = me.setInterval(function () {
                me.currentTimeLine.startDate = new Date();
                me.currentTimeLine.name = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].format(me.currentTimeLine.startDate, me.currentDateFormat);
                me.onStoreChanged({
                  action: 'update',
                  record: me.currentTimeLine
                });
              }, me.updateCurrentTimeLineInterval);

              if (me.client.rendered) {
                me.renderRanges();
              }
            }
          }, {
            key: "hideCurrentTimeLine",
            value: function hideCurrentTimeLine() {
              var me = this;

              if (!me.currentTimeLine) {
                return;
              }

              me.clearInterval(me.currentTimeInterval);
              me.currentTimeLine = null;

              if (me.client.rendered) {
                me.renderRanges();
              }
            }
          }, {
            key: "renderRanges",
            value: function renderRanges() {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimeRanges.prototype), "renderRanges", this).call(this);

              if (me.showCurrentTimeLine && !me.disabled) {
                me.renderRange(me.currentTimeLine, true);
              }
            }
            /**
             * Get/set the current time line display state
             * @property {boolean}
             */

          }, {
            key: "getHeaderMenuItems",
            //endregion
            //region Menu items

            /**
             * Adds a menu item to show/hide current time line.
             * @param column Column
             * @param items Menu items
             * @returns {Object[]} Menu items
             * @private
             */
            value: function getHeaderMenuItems(column, items) {
              var me = this;

              if (!items.some(function (item) {
                return item.isCurrentTimeline;
              }) && column.type === 'timeAxis') {
                items.push({
                  isCurrentTimeline: true,
                  text: me.L('showCurrentTimeLine'),
                  checked: me.showCurrentTimeLine,
                  onToggle: function onToggle(_ref) {
                    var checked = _ref.checked;
                    me.showCurrentTimeLine = checked;
                  }
                });
              }
            } //endregion
            //region Disable

            /**
             * Get/set the features disabled state
             * @property {Boolean}
             */

          }, {
            key: "showCurrentTimeLine",
            get: function get() {
              return this._showCurrentTimeLine;
            },
            set: function set(show) {
              this._showCurrentTimeLine = show;

              if (show) {
                this.initCurrentTimeLine();
              } else {
                this.hideCurrentTimeLine();
              }
            }
          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              this._disabled = disabled;

              if (this.client.rendered) {
                this.renderRanges();
              }
            }
            /**
             * Returns the {@link Common.data.Store store} used by this feature
             * @property {Common.data.Store}
             */

          }, {
            key: "store",
            get: function get() {
              return this._store;
            },
            set: function set(store) {
              var me = this,
                  client = me.client;

              if (!store.storeId) {
                store.storeId = 'timeRanges';
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimeRanges.prototype), "store", store, this, true); // timeRanges can be set on scheduler/gantt or feature, for convenience. Should only be processed by the TimeRanges
              // and not any subclasses


              if (client.timeRanges && !client._timeRangesExposed) {
                me._store.add(client.timeRanges);

                delete client.timeRanges;
              }

              if (me.timeRanges) {
                me._store.add(me.timeRanges);

                delete me.timeRanges;
              }
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Store that holds timeRanges (using the {@link Scheduler.model.TimeSpan} model or subclass thereof).
                 * A store will be automatically created if none is specified
                 * @config {Object|Common.data.Store}
                 */
                store: {
                  modelClass: _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_8__["default"],
                  storeId: 'timeRanges'
                },
                updateCurrentTimeLineInterval: 10000,

                /**
                 * The date format to show in the header for the current time line, see {@link #config-showCurrentTimeLine}
                 * @config {String}
                 * @default
                 */
                currentDateFormat: 'HH:mm',

                /**
                 * Range definitions (data to {@link Scheduler.model.TimeSpan} models). Will be added to store.
                 * @config {Scheduler.model.TimeSpan[]|Object[]}
                 */
                timeRanges: null,

                /**
                 * Show a line indicating current time
                 * @config {Boolean}
                 * @default
                 */
                showCurrentTimeLine: false
              };
            }
          }]);

          return TimeRanges;
        }(_AbstractTimeRanges_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        TimeRanges._$name = 'TimeRanges';

        _Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_9__["default"].registerFeature(TimeRanges, false, ['Scheduler', 'Gantt']);
        /***/

      },

      /***/
      "./lib/Scheduler/feature/base/DragBase.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/feature/base/DragBase.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureBaseDragBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DragBase;
        });
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/regenerator */
        "./node_modules/@babel/runtime/regenerator/index.js");
        /* harmony import */


        var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "./node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! regenerator-runtime/runtime */
        "./node_modules/regenerator-runtime/runtime.js");
        /* harmony import */


        var regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(regenerator_runtime_runtime__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/asyncToGenerator */
        "./node_modules/@babel/runtime/helpers/asyncToGenerator.js");
        /* harmony import */


        var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../../Common/helper/DragHelper.js */
        "../Grid/lib/Common/helper/DragHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../../tooltip/ClockTemplate.js */
        "./lib/Scheduler/tooltip/ClockTemplate.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../../../Common/helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/base/DragBase
         */
        //TODO: shift to copy
        //TODO: dragging of event that starts & ends outside of view

        /**
         * Base class for EventDrag (Scheduler) and TaskDrag (Gantt) features. Contains shared code. Not to be used directly.
         *
         * @extends Common/mixin/InstancePlugin
         * @abstract
         */

        var DragBase =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_14___default()(DragBase, _InstancePlugin);

          function DragBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, DragBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DragBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(DragBase, [{
            key: "render",
            //endregion
            //region Init

            /**
             * Called when scheduler is rendered. Sets up drag and drop and hover tooltip.
             * @private
             */
            value: function render() {
              var me = this,
                  view = me.client;

              if (me.drag) {
                me.drag.destroy();
              }

              me.drag = new _Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"]({
                name: me.constructor.name,
                // usefull when debugging with multiple draggers
                mode: 'translateXY',
                lockY: me.constrainDragToResource,
                minX: true,
                // Allows dropping before time axis
                constrain: false,
                cloneTarget: !me.constrainDragToTimeline,
                dragWithin: me.constrainDragToTimeline ? null : document.body,
                hideOriginalElement: true,
                outerElement: view.timeAxisSubGridElement,
                targetSelector: view.eventSelector,
                isElementDraggable: function isElementDraggable(el, event) {
                  return !view.readOnly && me.isElementDraggable(el, event);
                },
                scrollManager: me.constrainDragToTimeline ? view.scrollManager : null,
                listeners: {
                  beforedragstart: 'onBeforeDragStart',
                  dragstart: 'onDragStart',
                  drag: 'onDrag',
                  drop: 'onDrop',
                  abort: 'onDragAbort',
                  reset: 'onDragReset',
                  thisObj: me
                }
              });

              if (!me.constrainDragToResource) {
                view.rowManager.on({
                  changeTotalHeight: 'updateYConstraint',
                  thisObj: me
                });
              }

              if (me.showTooltip) {
                me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_20__["default"]({
                  timeAxisViewModel: view.timeAxisViewModel
                });
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.drag && me.drag.destroy();
              me.clockTemplate && me.clockTemplate.destroy();
              me.tip && me.tip.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_13___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(DragBase.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Drag events

          }, {
            key: "onBeforeDragStart",
            value: function onBeforeDragStart(_ref) {
              var context = _ref.context,
                  event = _ref.event;
              var me = this,
                  client = me.client,
                  name = client.scheduledEventName,
                  eventRecord = client.resolveEventRecord(context.element);

              if (me.disabled || !eventRecord || !eventRecord.isDraggable) {
                return false;
              }

              return client.trigger("before".concat(name, "Drag"), {
                eventRecord: eventRecord,
                context: me.dragData
              }) !== false;
            }
            /**
             * Triggered when dragging of an event starts. Initializes drag data associated with the event being dragged.
             * @private
             */

          }, {
            key: "onDragStart",
            value: function onDragStart(_ref2) {
              var _client$trigger;

              var context = _ref2.context,
                  event = _ref2.event;
              var me = this,
                  client = me.client,
                  name = client.scheduledEventName;
              me.currentOverClient = client;
              me.scrollClients = {};
              me.onMouseOverNewTimeline(client);
              var dragData = me.dragData = me.getDragData(context, event);

              if (me.showTooltip) {
                var tipTarget = dragData.context.dragProxy ? dragData.context.dragProxy.firstChild : context.element;

                if (!me.tip) {
                  me.tip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_21__["default"]({
                    id: "".concat(client.id, "-event-drag-tip"),
                    align: 'b-t',
                    autoShow: true,
                    clippedBy: me.constrainDragToTimeline ? [client.timeAxisSubGridElement, client.bodyContainer] : null,
                    forElement: tipTarget,
                    getHtml: me.getTipHtml.bind(me),
                    // During drag, it must be impossible for the mouse to be over the tip.
                    style: 'pointer-events:none',
                    cls: me.tooltipCls
                  });
                  me.tip.on('innerhtmlupdate', me.updateDateIndicator, me);
                } else {
                  me.tip.showBy(tipTarget);
                }
              } // me.copyKeyPressed = me.isCopyKeyPressed();
              //
              // if (me.copyKeyPressed) {
              //     dragData.refElements.addCls('sch-event-copy');
              //     dragData.originalHidden = true;
              // }
              // Trigger eventDragStart or taskDragStart depending on product


              client.trigger("".concat(name, "DragStart"), (_client$trigger = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger, "".concat(name, "Records"), dragData.draggedRecords), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger, "context", dragData), _client$trigger));
            }
          }, {
            key: "updateDateIndicator",
            value: function updateDateIndicator() {
              var _this$dragData = this.dragData,
                  startDate = _this$dragData.startDate,
                  endDate = _this$dragData.endDate,
                  tip = this.tip,
                  endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');
              this.clockTemplate.updateDateIndicator(tip.element, startDate);
              endDateElement && this.clockTemplate.updateDateIndicator(endDateElement, endDate);
            }
            /**
             * Triggered while dragging an event. Updates drag data, validation etc.
             * @private
             */

          }, {
            key: "onDrag",
            value: function onDrag(_ref3) {
              var context = _ref3.context,
                  event = _ref3.event;
              var me = this,
                  dd = me.dragData,
                  start = dd.startDate;
              var client;

              if (me.constrainToTimeline) {
                client = me.client;
              } else {
                var target = event.target; // Can't detect target under a touch event

                if (/^touch/.test(event.type)) {
                  var center = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_19__["default"].from(dd.context.element, null, true).center;

                  target = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].elementFromPoint(center.x, center.y);
                }

                client = _Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"].fromElement(target, 'timelinebase');
              }

              var depFeature = me.client.features.dependencies,
                  x = context.newX,
                  y = context.newY;

              if (!client) {
                if (depFeature) {
                  depFeature.updateDependenciesForTimeSpan(dd.draggedRecords[0], dd.context.element);
                }

                return;
              }

              if (client !== me.currentOverClient) {
                me.onMouseOverNewTimeline(client);
              } //this.checkShiftChange();


              me.updateDragContext(context, event); // Snapping not supported when dragging outside a scheduler

              if (me.constrainDragToTimeline && (me.showExactDropPosition || me.client.timeAxisViewModel.snap)) {
                var newDate = client.getDateFromCoordinate(me.getCoordinate(dd.draggedRecords[0], context.element, [x, y])),
                    timeDiff = newDate - dd.sourceDate,
                    realStart = new Date(dd.origStart - 0 + timeDiff),
                    offset = client.timeAxisViewModel.getDistanceBetweenDates(realStart, dd.startDate);

                if (dd.startDate >= client.timeAxis.startDate && offset != null) {
                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].addTranslateX(context.element, offset);
                }
              } // Let product specific implementations trigger drag event (eventDrag, taskDrag)


              me.triggerEventDrag(dd, start);
              var valid = me.checkDragValidity(dd, event);

              if (valid && typeof valid !== 'boolean') {
                context.message = valid.message || '';
                valid = valid.valid;
              }

              context.valid = valid !== false;

              if (me.showTooltip) {
                me.tip.realign();
              }

              if (depFeature) {
                depFeature.updateDependenciesForTimeSpan(dd.draggedRecords[0], dd.context.element.querySelector(client.eventInnerSelector));
              }
            }
          }, {
            key: "onMouseOverNewTimeline",
            value: function onMouseOverNewTimeline(newTimeline) {
              var me = this,
                  scrollClients = me.scrollClients;
              me.currentOverClient.element.classList.remove('b-dragging-' + me.currentOverClient.scheduledEventName);
              newTimeline.element.classList.add('b-dragging-' + newTimeline.scheduledEventName);

              if (!(newTimeline.id in scrollClients)) {
                var scrollManager = newTimeline.scrollManager;
                scrollManager.startMonitoring({
                  element: newTimeline.timeAxisSubGridElement
                });
                scrollClients[newTimeline.id] = newTimeline;
              }

              me.currentOverClient = newTimeline;
            }
            /**
             * Triggered when dropping an event. Finalizes the operation.
             * @private
             */

          }, {
            key: "onDrop",
            value: function onDrop(_ref4) {
              var context = _ref4.context,
                  event = _ref4.event;
              var me = this,
                  currentOverClient = me.currentOverClient,
                  dragData = me.dragData;

              if (!context.valid) {
                return me.onInvalidDrop({
                  context: context,
                  event: event
                });
              }

              var modified = false;
              me.updateDragContext(context, event);

              if (me.tip) {
                me.tip.hide();
              }

              if (context.valid && dragData.startDate && dragData.endDate) {
                dragData.finalize = function () {
                  me.finalize.apply(me, arguments);
                  context.finalize.apply(context, arguments);
                }; // Allow implementer to take control of the flow, by returning false from this listener,
                // to show a confirmation popup etc. This event is documented in EventDrag and TaskDrag


                currentOverClient.trigger("before".concat(currentOverClient.capitalizedEventName, "DropFinalize"), {
                  context: dragData,
                  event: event
                });
                context.async = dragData.async; // Internal validation, making sure all dragged records fit inside the view

                if (!context.async && me.isValidDrop(dragData)) {
                  modified = dragData.startDate - dragData.origStart !== 0 || dragData.newResource !== dragData.resourceRecord;
                }
              }

              if (!context.async) {
                me.finalize(dragData.valid && context.valid && modified);
              }
            }
          }, {
            key: "onDragAbort",
            value: function onDragAbort(_ref5) {
              var context = _ref5.context;
              this.client.currentOrientation.onDragAbort(context);

              if (this.tip) {
                this.tip.hide();
              }
            }
            /**
             * Triggered by drag handler on invalid drop, cleans up.
             * @private
             */

          }, {
            key: "onInvalidDrop",
            value: function onInvalidDrop() {
              var me = this;
              me.dragData.draggedRecords.forEach(function (record) {
                return record.instanceMeta(me.currentOverClient).retainElement = false;
              });

              if (me.tip) {
                me.tip.hide();
              }
            } // For the drag across multiple schedulers, tell all involved scroll managers to stop monitoring

          }, {
            key: "onDragReset",
            value: function onDragReset(_ref6) {
              var dragHelper = _ref6.source;
              var me = this;

              for (var managerId in me.scrollClients || {}) {
                me.scrollClients[managerId].scrollManager.stopMonitoring(me.scrollClients[managerId].timeAxisSubGridElement);
              }

              if (dragHelper.context && dragHelper.context.started) {
                var eventBarEls = me.dragData.eventBarEls;
                eventBarEls[0].classList.remove('b-drag-main');
              }

              me.scrollClients = null;

              if (me.currentOverClient) {
                me.currentOverClient.element.classList.remove('b-dragging-' + me.currentOverClient.scheduledEventName);
              } // Dependencies are updated dynamically during drag, so ensure they are redrawn
              // if the event snaps back with no change after abort or an invalid drop.


              if (me.dragData && !me.dragData.context.valid) {
                var dependencies = me.currentOverClient.features.dependencies;

                if (dependencies) {
                  dependencies.scheduleDraw(true);
                }
              } // TODO we should clean this up, requires review of the flow first
              // me.dragData = null;

            }
            /**
             * Triggered internally on invalid drop.
             * @private
             */

          }, {
            key: "onInternalInvalidDrop",
            value: function onInternalInvalidDrop() {
              var _currentOverClient$tr;

              var me = this,
                  currentOverClient = me.currentOverClient;

              if (me.tip) {
                me.tip.hide();
              }

              me.drag.abort(); // Documented on EventDrag & TaskDrag features

              currentOverClient.trigger("after".concat(currentOverClient.capitalizedEventName, "Drop"), (_currentOverClient$tr = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_currentOverClient$tr, currentOverClient.scheduledEventName + 'Records', me.dragData.draggedRecords), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_currentOverClient$tr, "valid", false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_currentOverClient$tr, "context", me.dragData), _currentOverClient$tr));
            } //endregion
            //region Finalization & validation

            /**
             * Called on drop to update the record of the event being dropped.
             * @private
             * @param {Boolean} updateRecords Specify true to update the record, false to treat as invalid
             */

          }, {
            key: "finalize",
            value: function () {
              var _finalize = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_5___default()(
              /*#__PURE__*/
              _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(updateRecords) {
                var me, client, dragData, context, draggedRecords, result, _client$trigger2;

                return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        me = this, client = me.currentOverClient, dragData = me.dragData, context = dragData.context, draggedRecords = dragData.draggedRecords;
                        draggedRecords.forEach(function (record, i) {
                          // Clear flag which makes the event not rerender
                          record.instanceMeta(client).retainElement = false; // Ensure the dragged elements are available from the EventMapper's cache
                          // It won't return an event that is in use by dragging.

                          dragData.eventBarEls[i].classList.remove(me.drag.draggingCls);
                        });

                        if (!updateRecords) {
                          _context.next = 11;
                          break;
                        } // updateRecords may or may not be async.
                        // We see if it returns a Promise.


                        result = me.updateRecords(dragData); // If updateRecords is async, the calling DragHelper must know this and
                        // go into a awaitingFinalization state.

                        if (!(result instanceof Promise)) {
                          _context.next = 8;
                          break;
                        }

                        context.async = true;
                        _context.next = 8;
                        return result;

                      case 8:
                        // If the finalize handler decided to change the dragData's validity...
                        if (!dragData.valid) {
                          me.onInternalInvalidDrop();
                        } else {
                          me.drag.reset(); // Trigger afterEventDrop or afterTaskDrop depending on product

                          client.trigger("after".concat(client.capitalizedEventName, "Drop"), (_client$trigger2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger2, "".concat(client.scheduledEventName, "Records"), draggedRecords), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger2, "valid", true), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_client$trigger2, "context", dragData), _client$trigger2));
                        }

                        _context.next = 12;
                        break;

                      case 11:
                        me.onInternalInvalidDrop();

                      case 12:
                        return _context.abrupt("return", result);

                      case 13:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, this);
              }));

              return function finalize(_x) {
                return _finalize.apply(this, arguments);
              };
            }() //endregion
            //region Drag data

            /**
             * Updates drag datas dates and validity (calls #validatorFn if specified)
             * @private
             */

          }, {
            key: "updateDragContext",
            value: function updateDragContext(info, event) {
              var me = this,
                  dd = me.dragData,
                  client = me.currentOverClient,
                  x = info.newX,
                  y = info.newY,
                  cx = info.clientX,
                  cy = info.clientY,
                  element = info.element,
                  proxyRegion = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_19__["default"].from(element, client.timeAxisSubGridElement),
                  record = dd.draggedRecords[0],
                  eventRecord = record.isAssignment ? record.event : record;

              dd.browserEvent = event;

              if (client.timeAxis.isContinuous) {
                var newDate = client.getDateFromCoordinate(me.getCoordinate(eventRecord, element, [cx, cy]), null, false); // Date not found if mouse outside of schedule

                if (!newDate) {
                  // Date at right edge (endDate), using local coords
                  newDate = client.getDateFromCoordinate(me.getCoordinate(eventRecord, element, [x + element.offsetWidth, y])); // Also out of time axis? Flag as invalid

                  if (!newDate) {
                    dd.context.valid = false;
                    return;
                  } // Subtract duration to get startDate


                  newDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(newDate, -eventRecord.duration, eventRecord.durationUnit);
                  dd.timeDiff = newDate - dd.sourceDate;
                } else {
                  dd.timeDiff = newDate - dd.screenSourceDate;
                } // calculate and round new startDate based on actual dd.timeDiff


                dd.startDate = me.adjustStartDate(dd.origStart, dd.timeDiff);
                dd.endDate = new Date(dd.startDate - 0 + dd.duration);
              } else {
                var range = me.resolveStartEndDates(proxyRegion);
                dd.startDate = range.startDate;
                dd.endDate = range.endDate;
                dd.timeDiff = dd.startDate - dd.origStart;
              }

              Object.assign(dd, me.getProductDragContext(dd));

              if (dd.valid && dd.endDate > client.timeAxis.startDate && dd.startDate < client.timeAxis.endDate) {
                var result = !event || me.checkDragValidity(dd, event);

                if (!result || typeof result === 'boolean') {
                  dd.context.valid = result !== false;
                  dd.context.message = '';
                } else {
                  dd.context.valid = result.valid !== false;
                  dd.context.message = result.message;
                }
              } else {
                dd.context.valid = false;
              }
            }
            /**
             * Initializes drag data (dates, constraints, dragged events etc). Called when drag starts.
             * @private
             * @param info
             * @param event
             * @returns {*}
             */

          }, {
            key: "getDragData",
            value: function getDragData(info, event) {
              var me = this,
                  client = me.client,
                  _me$setupProductDragD = me.setupProductDragData(info),
                  record = _me$setupProductDragD.record,
                  dateConstraints = _me$setupProductDragD.dateConstraints,
                  eventBarEls = _me$setupProductDragD.eventBarEls,
                  draggedRecords = _me$setupProductDragD.draggedRecords;

              var origStart = record.startDate,
                  origEnd = record.endDate,
                  timeAxis = client.timeAxis,
                  startsOutsideView = origStart < timeAxis.startDate,
                  endsOutsideView = origEnd > timeAxis.endDate;
              var coordinate = me.getCoordinate(record, info.element, [info.elementStartX, info.elementStartY]),
                  clientCoordinate = me.getCoordinate(record, info.element, [info.startClientX, info.startClientY]); // prevent elements from being released when out of view

              draggedRecords.forEach(function (record) {
                return record.instanceMeta(client).retainElement = true;
              }); // Select current without deselecting other events if Ctrl key is pressed

              if (me.drag.startEvent.ctrlKey) {
                me.client.selectEvent(draggedRecords[0], true);
              }

              var dragData = {
                context: info,
                dateConstraints: dateConstraints,
                eventBarEls: eventBarEls,
                record: record,
                draggedRecords: draggedRecords,
                sourceDate: startsOutsideView ? origStart : client.getDateFromCoordinate(coordinate),
                screenSourceDate: client.getDateFromCoordinate(clientCoordinate, null, false),
                origStart: origStart,
                origEnd: origEnd,
                startDate: origStart,
                endDate: origEnd,
                timeDiff: 0,
                startsOutsideView: startsOutsideView,
                endsOutsideView: endsOutsideView,
                duration: origEnd - origStart,
                browserEvent: event // So we can know if SHIFT/CTRL was pressed

              };
              eventBarEls.forEach(function (el, i) {
                el.classList.add(me.drag.draggingCls);
                el.classList.remove('b-sch-event-hover');
                el.classList.remove('b-active');
                el.classList.remove('b-first-render');
              });

              if (eventBarEls.length > 1) {
                // RelatedElements are secondary elements moved by the same delta as the grabbed element
                info.relatedElements = eventBarEls.slice(1);
                info.relatedElStartPos = [];
                info.relatedElDragFromPos = []; // Move the selected events into a unified cascade.

                if (me.unifiedDrag) {
                  // EventBarEls should animate into the cascade
                  me.client.isAnimating = true;

                  _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"].on({
                    element: eventBarEls[1],
                    transitionend: function transitionend(e) {
                      me.client.isAnimating = false;
                    },
                    once: true
                  }); // Main dragged element should not look different. The relatedElements do.


                  eventBarEls[0].classList.add('b-drag-main');

                  var _DomHelper$getTransla = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getTranslateXY(info.element),
                      _DomHelper$getTransla2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_DomHelper$getTransla, 2),
                      x = _DomHelper$getTransla2[0],
                      y = _DomHelper$getTransla2[1];

                  info.relatedElements.forEach(function (el, i) {
                    // Cache the start pos for reversion in case of invalid drag
                    info.relatedElStartPos[i] = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getTranslateXY(el); // Move into cascade and cache the dragFrom pos

                    x += 10;
                    y += 10;

                    _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].setTranslateXY(el, x, y);

                    info.relatedElDragFromPos[i] = [x, y];
                  });
                } else {
                  // Start pos and dragFrom pos are the same for non-unified
                  info.relatedElements.forEach(function (el, i) {
                    info.relatedElStartPos[i] = info.relatedElDragFromPos[i] = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getTranslateXY(el);
                  });
                }
              }

              return dragData;
            } // Provide your custom implementation of this to allow additional selected records to be dragged together with the original one.

          }, {
            key: "getRelatedRecords",
            value: function getRelatedRecords(record) {
              return [];
            } //endregion
            //region Constraints
            // private

          }, {
            key: "setupConstraints",
            value: function setupConstraints(constrainRegion, elRegion, tickSize, constrained) {
              var me = this,
                  xTickSize = !me.showExactDropPosition && tickSize > 1 ? tickSize : 0,
                  yTickSize = 0; // if `constrained` is false then we haven't specified getDateConstraint method and should constrain mouse position to scheduling area
              // else we have specified date constraints and so we should limit mouse position to smaller region inside of constrained region using offsets and width.

              if (constrained) {
                me.setXConstraint(constrainRegion.left, constrainRegion.right - elRegion.width, xTickSize);
              }

              me.setYConstraint(constrainRegion.top, constrainRegion.bottom - elRegion.height, yTickSize);
            }
          }, {
            key: "updateYConstraint",
            value: function updateYConstraint() {
              var me = this,
                  dragData = me.dragData,
                  context = me.drag.context; // If we're dragging when the vertical size is recalculated by the host grid,
              // we must update our Y constraint

              if (context) {
                var constrainRegion = me.scheduler.getScheduleRegion(null, dragData.record);
                me.setYConstraint(constrainRegion.top, constrainRegion.bottom - context.grabbed.offsetHeight, 0);
              }
            }
          }, {
            key: "setXConstraint",
            value: function setXConstraint(iLeft, iRight, iTickSize) {
              var me = this,
                  drag = me.drag;
              drag.leftConstraint = iLeft;
              drag.rightConstraint = iRight;
              drag.minX = iLeft;
              drag.maxX = iRight;
            }
          }, {
            key: "setYConstraint",
            value: function setYConstraint(iUp, iDown, iTickSize) {
              var me = this,
                  drag = me.drag;
              drag.topConstraint = iUp;
              drag.bottomConstraint = iDown;
              drag.minY = iUp;
              drag.maxY = iDown;
            } //endregion
            //region Other stuff

          }, {
            key: "adjustStartDate",
            value: function adjustStartDate(startDate, timeDiff) {
              return this.client.timeAxis.roundDate(new Date(startDate - 0 + timeDiff), this.client.snapRelativeToEventStartDate ? startDate : false);
            }
          }, {
            key: "resolveStartEndDates",
            value: function resolveStartEndDates(proxyRect) {
              var dd = this.dragData,
                  startEnd,
                  start = dd.origStart,
                  end = dd.origEnd;

              if (!dd.startsOutsideView) {
                startEnd = this.client.getStartEndDatesFromRectangle(proxyRect, 'round');

                if (startEnd) {
                  start = startEnd.start || dd.startDate;
                  end = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(start, dd.duration, 'ms');
                }
              } else if (!dd.endsOutsideView) {
                startEnd = this.client.getStartEndDatesFromRectangle(proxyRect, 'round');

                if (startEnd) {
                  end = startEnd.end || dd.endDate;
                  start = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].add(end, -dd.duration, 'ms');
                }
              }

              return {
                startDate: start,
                endDate: end
              };
            } //endregion
            //region Dragtip

            /**
             * Gets html to display in tooltip while dragging event. Uses clockTemplate to display start & end dates.
             */

          }, {
            key: "getTipHtml",
            value: function getTipHtml() {
              var _me$dragTipTemplate;

              var me = this,
                  _me$dragData = me.dragData,
                  startDate = _me$dragData.startDate,
                  endDate = _me$dragData.endDate,
                  draggedRecords = _me$dragData.draggedRecords,
                  startText = me.client.getFormattedDate(startDate),
                  endText = me.client.getFormattedEndDate(endDate, startDate),
                  _me$dragData$context = me.dragData.context,
                  valid = _me$dragData$context.valid,
                  message = _me$dragData$context.message;
              return me.dragTipTemplate((_me$dragTipTemplate = {
                valid: valid,
                startDate: startDate,
                endDate: endDate,
                startText: startText,
                endText: endText,
                message: message || ''
              }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$dragTipTemplate, me.client.scheduledEventName + 'Record', draggedRecords[0]), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$dragTipTemplate, "dragData", me.dragData), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$dragTipTemplate, "startClockHtml", me.clockTemplate.template({
                date: startDate,
                text: startText,
                cls: 'b-sch-tooltip-startdate'
              })), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_7___default()(_me$dragTipTemplate, "endClockHtml", draggedRecords[0].isMilestone ? '' : me.clockTemplate.template({
                date: endDate,
                text: endText,
                cls: 'b-sch-tooltip-enddate'
              })), _me$dragTipTemplate));
            } //endregion

            /**
             * Disable this feature
             * @property {Boolean}
             */

          }, {
            key: "isValidDrop",
            //region Product specific, implemented in subclasses
            // Check if element can be dropped at desired location
            value: function isValidDrop(dragData) {
              throw new Error('Implement in subclass');
            } // Similar to the fn above but also calls validatorFn

          }, {
            key: "checkDragValidity",
            value: function checkDragValidity(dragData) {
              throw new Error('Implement in subclass');
            } // Update records being dragged

          }, {
            key: "updateRecords",
            value: function updateRecords(context) {
              throw new Error('Implement in subclass');
            } // Determine if an element can be dragged

          }, {
            key: "isElementDraggable",
            value: function isElementDraggable(el, event) {
              throw new Error('Implement in subclass');
            } // Get coordinate for correct axis

          }, {
            key: "getCoordinate",
            value: function getCoordinate(record, element, coord) {
              throw new Error('Implement in subclass');
            } // Product specific drag data

          }, {
            key: "setupProductDragData",
            value: function setupProductDragData(info) {
              throw new Error('Implement in subclass');
            } // Product specific data in drag context

          }, {
            key: "getProductDragContext",
            value: function getProductDragContext(dd) {
              throw new Error('Implement in subclass');
            } //endregion

          }, {
            key: "disabled",
            get: function get() {
              return this._disabled;
            },
            set: function set(disabled) {
              this._disabled = disabled;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                // documented on Schedulers EventDrag feature and Gantts TaskDrag
                dragTipTemplate: function dragTipTemplate(data) {
                  return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml, "\n                    <div class=\"b-sch-tip-message\">").concat(data.message, "</div>\n                </div>\n            ");
                },
                // documented on Schedulers EventDrag feature, not used for Gantt
                constrainDragToResource: true,

                /**
                 * Specifies whether or not to show tooltip while dragging event
                 * @config {Boolean}
                 * @default
                 */
                showTooltip: true,

                /**
                 * When enabled, the event being dragged always "snaps" to the exact start date that it will have after drop.
                 * @config {Boolean}
                 * @default
                 */
                showExactDropPosition: false,

                /**
                 * Set to false to allow dragging tasks freely on the page, useful when you want to drag tasks between multiple Scheduler instances
                 * @config {Boolean}
                 * @default
                 */
                constrainDragToTimeline: true,

                /*
                * The store from which the dragged items are mapped to the UI.
                * In Scheduler's implementation of this base class, this will be
                * an EventStore, in Gantt's implementations, this will be a TaskStore.
                * Because both derive from this base, we must refer to it as this.store.
                * @private
                */
                store: null,
                tooltipCls: null
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['render']
              };
            }
          }]);

          return DragBase;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_15__["default"]);

        DragBase._$name = 'DragBase';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/base/DragCreateBase.js":
      /*!******************************************************!*\
        !*** ./lib/Scheduler/feature/base/DragCreateBase.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureBaseDragCreateBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DragCreateBase;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "./node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/helper/ResizeHelper.js */
        "../Grid/lib/Common/helper/ResizeHelper.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../tooltip/ClockTemplate.js */
        "./lib/Scheduler/tooltip/ClockTemplate.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/base/DragCreateBase
         */
        // TODO: add hovertip if EvenDrag feature not used
        // TODO: some of the code here could be shared with EventResize. make common base class?
        // TODO: touch support
        // TODO: mouse up outside not working as it should

        /**
         * Base class for EventDragCreate (Scheduler) and TaskDragCreate (Gantt) features. Contains shared code. Not to be used directly.
         *
         * @extends Common/mixin/InstancePlugin
         */

        var DragCreateBase =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(DragCreateBase, _InstancePlugin);

          function DragCreateBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, DragCreateBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(DragCreateBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(DragCreateBase, [{
            key: "doDestroy",
            value: function doDestroy() {
              this.tip && this.tip.destroy();
              this.resize && this.resize.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(DragCreateBase.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Proxy element & resizing

            /**
             * Adds a proxy element to illustrate the timespan that might be created
             * @param config
             * @param {Common.data.Model} config.rowRecord  The row for which an event proxy element is being created.
             * @param {Number} config.startX the position along the time axis at which to display the proxy element.
             * @param {Number} [config.width] the width of the proxy element.
             */

          }, {
            key: "addProxy",
            value: function addProxy(config) {
              var me = this,
                  client = me.client,
                  barMargin = client.barMargin,
                  region = client.currentOrientation.getRowRegion(config.rowRecord);
              var width, height, proxyX, proxyY;

              if (client.isHorizontal) {
                proxyX = 'currentX' in config ? Math.min(config.startX, config.currentX + 1) : config.startX;
                proxyY = region.y + barMargin;
                width = config.width || me.dragTolerance;
                height = region.height - barMargin * 2;
              } else {
                proxyX = region.x + barMargin;
                proxyY = 'currentY' in config ? Math.min(config.startY, config.currentY + 1) : config.startY;
                width = region.width - barMargin * 2;
                height = config.height || me.dragTolerance;
              } // This CSS class is to block further drag creates when one is in progress (like awaiting async finalization)


              client.element.classList.add('b-dragcreating'); // This CSS class is to block hover for other events during actually dragging the proxy

              client.element.classList.add('b-dragcreating-proxy-sizing'); // We are dragging to size element from nothing. Its size on drag is calculated by its *initial size*, plus the
              // mouse movement delta, so it MUST start at zero for that to yield the correct result.

              return me.proxy = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createElement({
                parent: client.foregroundCanvas,
                className: me.proxyCls,
                style: "transform:translate(".concat(proxyX, "px, ").concat(proxyY, "px);width:").concat(width, "px;height:").concat(height, "px"),
                // Prevent element from being recycled by DomHelper.sync()
                retainElement: true
              });
            }
            /**
             * Remove proxy element and clean up related stuff
             * @private
             */

          }, {
            key: "removeProxy",
            value: function removeProxy() {
              var me = this;

              if (me.proxy) {
                me.proxy.remove();
                me.resize.destroy();
                me.proxy = me.resize = null; // This CSS class is to block further drag creates when one is in progress (like awaiting async finalization)

                me.client.element.classList.remove('b-dragcreating'); // This CSS class is to block hover for other events during actually dragging the proxy

                me.client.element.classList.remove('b-dragcreating-proxy-sizing');
                me.tip && me.tip.hide();
              }
            }
            /**
             * Creates an instance of ResizeHelper used to resize the proxy element
             * @param event
             * @param data
             */

          }, {
            key: "initResizer",
            value: function initResizer(event, data) {
              var me = this;
              var edge;

              if (me.client.isHorizontal) {
                edge = data.currentX > data.startX ? 'right' : 'left';
              } else {
                edge = data.currentY > data.startY ? 'bottom' : 'top';
              }

              me.resize && me.resize.destroy();
              me.resize = new _Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
                name: me.constructor.name,
                // For debugging
                direction: me.client.isVertical ? 'vertical' : 'horizontal',
                isTouch: event.type.startsWith('touch'),
                grab: {
                  element: me.proxy,
                  edge: edge,
                  event: data.startEvent
                },
                allowEdgeSwitch: true,
                // Means that they can switch edges; the mouse can cross the zero point and drag the other way
                outerElement: me.client.timeAxisSubGridElement,
                // Constrain resize to view
                scrollManager: me.client.scrollManager,
                scroller: me.client.timeAxisSubGrid.scrollable,
                // Scroll in both directions
                listeners: {
                  resizing: me.onResizing,
                  resize: me.onResize,
                  cancel: me.onCancel,
                  thisObj: me
                }
              });
              me.resize.context.resource = data.resource;
            } //endregion
            //region Tooltip

            /**
             * Creates a tooltip that displays start & end dates. Anchored to the proxy element
             */

          }, {
            key: "initTooltip",
            value: function initTooltip() {
              var me = this,
                  client = me.client;

              if (me.showTooltip) {
                if (me.tip) {
                  me.tip.showBy(me.getTooltipTarget());
                } else {
                  me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
                    timeAxisViewModel: client.timeAxisViewModel
                  });
                  me.tip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
                    id: "".concat(client.id, "-drag-create-tip"),
                    autoShow: true,
                    trackMouse: false,
                    getHtml: me.getTipHtml.bind(me),
                    align: client.isVertical ? 't-b' : 'b100-t100',
                    hideDelay: 0,
                    axisLock: true // Don't want it flipping to the side where we are dragging

                  });
                  me.tip.on('innerhtmlupdate', me.updateDateIndicator, me);
                }
              }
            }
          }, {
            key: "updateDateIndicator",
            value: function updateDateIndicator() {
              var me = this,
                  _me$createContext = me.createContext,
                  startDate = _me$createContext.startDate,
                  endDate = _me$createContext.endDate,
                  tip = me.tip,
                  endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');

              if (startDate && endDate) {
                me.clockTemplate.updateDateIndicator(tip.element, startDate);
                endDateElement && me.clockTemplate.updateDateIndicator(endDateElement, endDate);
              }
            }
            /**
             * Updates tooltips contents
             * @returns {*}
             */

          }, {
            key: "getTipHtml",
            value: function getTipHtml() {
              if (!this.resize.context) return; // keeping this on separate row to not mess up look of other declarations

              var me = this,
                  client = me.client,
                  _me$resize$context = me.resize.context,
                  edge = _me$resize$context.edge,
                  newX = _me$resize$context.newX,
                  newY = _me$resize$context.newY,
                  elementStartX = _me$resize$context.elementStartX,
                  elementStartY = _me$resize$context.elementStartY,
                  elementWidth = _me$resize$context.elementWidth,
                  elementHeight = _me$resize$context.elementHeight,
                  newWidth = _me$resize$context.newWidth,
                  newHeight = _me$resize$context.newHeight,
                  valid = _me$resize$context.valid,
                  message = _me$resize$context.message;
              var start, end;

              if (client.isHorizontal) {
                var x = edge === 'left' ? newX : elementStartX,
                    // Coordinates are 0 based, widths are not so subtracting 1 from the widths
                endX = Math.min(Math.max(x + (newWidth || elementWidth) - 1, 0), client.timeAxisViewModel.totalSize - 1);
                start = client.getDateFromCoordinate(x, 'round', true);
                end = client.getDateFromCoordinate(endX, 'round', true);
              } else {
                var y = edge === 'top' ? newY : elementStartY,
                    // Coordinates are 0 based, widths are not so subtracting 1 from the widths
                endY = Math.min(Math.max(y + (newHeight || elementHeight) - 1, 0), client.timeAxisViewModel.totalSize - 1);
                start = client.getDateFromCoordinate(y, 'round', true);
                end = client.getDateFromCoordinate(endY, 'round', true);
              }

              var first = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].min(start, end),
                  last = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].max(start, end),
                  startText = first && client.getFormattedDate(first),
                  endText = last && end && client.getFormattedEndDate(last, first);

              return me.tipTemplate({
                valid: valid,
                startDate: first,
                endDate: last,
                startText: startText,
                endText: endText,
                message: message,
                startClockHtml: me.clockTemplate.template({
                  date: first,
                  text: startText,
                  cls: 'b-sch-tooltip-startdate'
                }),
                endClockHtml: me.clockTemplate.template({
                  // actual end date and display date may differ
                  date: client.getDisplayEndDate(last, first),
                  text: endText,
                  cls: 'b-sch-tooltip-enddate'
                })
              });
            } //endregion
            //region Finalize (create EventModel)

          }, {
            key: "finalize",
            value: function finalize(doCreate) {
              var me = this;

              if (doCreate) {
                // Call product specific implementation
                me.finalizeDragCreate(me.createContext);
              }

              me.proxy.retainElement = false;
              me.client.trigger('afterDragCreate', {
                proxyElement: me.proxy
              });
              me.reset();
            } //endregion
            //region Events

          }, {
            key: "onElementMouseDown",
            value: function onElementMouseDown(event) {
              var me = this,
                  client = me.client; // detect mouse down directly in scheduler cell

              if (event.button === 0 && event.target.matches('.b-sch-timeaxis-cell') && !me.disabled && !client.readOnly) {
                var rowRecord = client.isVertical ? client.resolveResourceRecord(event) : client.getRecordFromElement(event.target); // no drag creation in group headers etc.

                if (rowRecord.meta.specialRow) {
                  return;
                }

                if (me.preventMultiple && !me.isRowEmpty(rowRecord)) {
                  return;
                }

                me.monitorMove = true;
                me.createContext = {
                  startEvent: event,
                  startScreenX: event.screenX,
                  startScreenY: event.screenY,
                  startX: event.offsetX,
                  startY: event.offsetY,
                  cellElement: event.target,
                  rowRecord: rowRecord
                };
                me.mouseUpDetacher = _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
                  element: document.body,
                  mouseup: 'onMouseUp',
                  once: true,
                  thisObj: this
                });
              }
            }
          }, {
            key: "onElementMouseMove",
            value: function onElementMouseMove(event) {
              var me = this;

              if (me.monitorMove) {
                var createContext = me.createContext,
                    client = me.client,
                    delta = me.client.isVertical ? createContext.startScreenY - event.screenY : createContext.startScreenX - event.screenX;

                if (Math.abs(delta) > me.dragTolerance) {
                  var dateTime = client.getDateFromDomEvent(event),
                      region = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(client.timeAxisSubGridElement, null, true);

                  if (me.handleBeforeDragCreate(dateTime, event) === false) {
                    me.monitorMove = false;
                    return;
                  } // Math.max with 0 because if the mousedown is within dragTolerance of
                  // the left edge and then drag goes left, dragging can begin with
                  // the X in negative territory.


                  createContext.currentX = Math.max(event.clientX - region.x + client.timeAxisSubGrid.scrollable.x, 0);
                  createContext.currentY = Math.max(event.clientY - region.y + client.timeAxisSubGrid.scrollable.y, 0);
                  me.addProxy(me.createContext);
                  me.initResizer(event, me.createContext);
                  me.initTooltip();
                  me.monitorMove = false;
                  client.trigger('dragCreateStart', {
                    proxyElement: me.proxy
                  });
                }
              } // If dragcreate is async, resizer was already reset and we should not
              // align tooltip anymore


              if (me.proxy && me.showTooltip && me.resize.context) {
                me.tip.alignTo(me.getTooltipTarget());
              }
            }
          }, {
            key: "getTooltipTarget",
            value: function getTooltipTarget() {
              var me = this,
                  target = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(me.proxy, null, true);

              if (me.client.isVertical) {
                // Align to the dragged edge of the proxy, and then bump bottom so that the anchor aligns perfectly.
                if (me.resize.context.edge === 'bottom') {
                  target.y = target.bottom - 1;
                }

                target.height = me.tip.anchorSize[1] / 2;
              } else {
                // Align to the dragged edge of the proxy, and then bump right so that the anchor aligns perfectly.
                if (me.resize.context.edge === 'right') {
                  target.x = target.right - 1;
                }

                target.width = me.tip.anchorSize[0] / 2;
              }

              return {
                target: target
              };
            }
          }, {
            key: "onMouseUp",
            value: function onMouseUp() {
              var me = this;
              me.client.element.classList.remove('b-dragcreating-proxy-sizing');
              me.monitorMove = false;
            }
            /**
             * Prevent right click when drag creating
             * @returns {Boolean}
             * @internal
             */

          }, {
            key: "onElementContextMenu",
            value: function onElementContextMenu() {
              if (this.proxy) return false;
            }
          }, {
            key: "onResizing",
            value: function onResizing(_ref) {
              var context = _ref.context,
                  event = _ref.event;
              var me = this,
                  client = me.client,
                  x = context.edge === 'left' ? context.newX : context.elementStartX,
                  y = context.edge === 'top' ? context.newY : context.elementStartY,
                  // Coordinates are 0 based, widths are not so subtracting 1 from the widths
              endX = Math.min(x + Math.max((context.newWidth || context.elementWidth) - 1, 0), client.timeAxisViewModel.totalSize - 1),
                  endY = Math.min(y + Math.max((context.newHeight || context.elementHeight) - 1, 0), client.timeAxisViewModel.totalSize - 1),
                  startCoord = client.isVertical ? y : x,
                  endCoord = client.isVertical ? endY : endX,
                  first = client.getDateFromCoordinate(startCoord, 'round', true),
                  last = client.getDateFromCoordinate(endCoord, 'round', true),
                  dc = me.dateConstraints;

              var start = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].min(first, last),
                  end = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].max(first, last);

              if (dc) {
                end = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].constrain(end, dc.start, dc.end);
                start = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].constrain(start, dc.start, dc.end);
              }

              Object.assign(me.createContext, {
                startDate: start,
                endDate: end
              });
              context.valid = me.checkValidity(me.createContext, event);
              context.message = '';

              if (context.valid && typeof context.valid !== 'boolean') {
                context.message = context.valid.message;
                context.valid = context.valid.valid;
              } // If users returns nothing, that's interpreted as valid


              context.valid = context.valid !== false;
            }
          }, {
            key: "onResize",
            value: function onResize(_ref2) {
              var valid = _ref2.context.valid,
                  event = _ref2.event;
              var me = this,
                  _me$createContext2 = me.createContext,
                  startDate = _me$createContext2.startDate,
                  endDate = _me$createContext2.endDate;
              if (!startDate || !endDate || endDate - startDate <= 0) valid = false;
              Object.assign(me.createContext, {
                event: event,
                async: false,
                finalize: function finalize(doCreate) {
                  return me.finalize(doCreate);
                }
              });

              if (valid) {
                me.client.trigger('beforeDragCreateFinalize', {
                  context: me.createContext,
                  event: event,
                  proxyElement: me.proxy
                });
              } // Drag create could be finalized immediately


              if (me.createContext) {
                // OMG, how not to confuse those contexts?
                me.resize.context.async = me.createContext.async;

                if (!me.createContext.async) {
                  me.finalize(valid);
                } else {
                  // We do not want to remove resizer yet, because it will also remove context and proxy element (or resize to 0 width)
                  // Instead we blindfold resize helper to prevent event resize from starting parallel drag create
                  me.resize.removeListeners();
                }
              }
            }
          }, {
            key: "onCancel",
            value: function onCancel() {
              this.cancel();
            }
          }, {
            key: "cancel",
            value: function cancel() {
              this.reset();
              this.mouseUpDetacher && this.mouseUpDetacher();
            }
          }, {
            key: "reset",
            value: function reset() {
              var me = this;
              me.removeProxy();
              me.createContext = null;
              me.monitorMove = false;
            } //endregion
            //region Product specific, implemented in subclasses

          }, {
            key: "checkValidity",
            value: function checkValidity(context, event) {
              throw new Error('Implement in subclass');
            }
          }, {
            key: "triggerDragCreateEnd",
            value: function triggerDragCreateEnd(newRecord, context) {
              throw new Error('Implement in subclass');
            }
          }, {
            key: "handleBeforeDragCreate",
            value: function handleBeforeDragCreate(dateTime, event) {
              throw new Error('Implement in subclass');
            }
          }, {
            key: "isRowEmpty",
            value: function isRowEmpty(rowRecord) {
              throw new Error('Implement in subclass');
            } //endregion

          }, {
            key: "dragging",
            get: function get() {
              return this.resize;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * true to start disabled
                 * @config {Boolean}
                 * @default
                 */
                disabled: false,

                /**
                 * true to show a time tooltip when dragging to create a new event
                 * @config {Boolean}
                 * @default
                 */
                showTooltip: true,

                /**
                 * Number of pixels the drag target must be moved before dragging is considered to have started. Defaults to 2.
                 * @config {Number}
                 * @default
                 */
                dragTolerance: 2,
                // used by gantt to only allow one task per row
                preventMultiple: false,
                validatorFn: function validatorFn() {},

                /**
                 * `this` reference for the validatorFn
                 * @config {Object}
                 */
                validatorFnThisObj: null,

                /**
                 * CSS class to add to proxy used when creating a new event
                 * @config {String}
                 * @default
                 * @private
                 */
                proxyCls: 'b-sch-dragcreator-proxy',
                tipTemplate: function tipTemplate(data) {
                  return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml, "\n                    <div class=\"b-sch-tip-message\">").concat(data.message, "</div>\n                </div>\n            ");
                }
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['onElementMouseDown', 'onElementMouseMove'],
                before: ['onElementContextMenu']
              };
            }
          }]);

          return DragCreateBase;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        DragCreateBase._$name = 'DragCreateBase';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/base/EditBase.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/feature/base/EditBase.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureBaseEditBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EditBase;
        });
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "./node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "./node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_widget_DateField_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/widget/DateField.js */
        "../Grid/lib/Common/widget/DateField.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/base/EditBase
         */

        var DH = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"],
            makeDate = function makeDate(fields) {
          // single field, update record directly
          if (fields.length === 1) return fields[0].value; // two fields, date + time
          else if (fields.length === 2) {
              var _ref = fields[0] instanceof _Common_widget_DateField_js__WEBPACK_IMPORTED_MODULE_14__["default"] ? fields : fields.reverse(),
                  _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_12___default()(_ref, 2),
                  date = _ref2[0],
                  time = _ref2[1],
                  dateValue = DH.parse(date.value);

              dateValue.setHours(time.value.getHours(), time.value.getMinutes(), time.value.getSeconds(), time.value.getMilliseconds());
              return dateValue;
            } // shouldn't happen...

          return null;
        },
            copyTime = function copyTime(dateTo, dateFrom) {
          var d = new Date(dateTo.getTime());
          d.setHours(dateFrom.getHours(), dateFrom.getMinutes());
          return d;
        },
            adjustEndDate = function adjustEndDate(startDate, startTime, me) {
          // The end datetime just moves in response to the changed start datetime, keeping the same duration.
          if (startDate && startTime) {
            var newEndDate = DH.add(copyTime(me.startDateField.value, me.startTimeField.value), me.eventRecord.durationMS, 'milliseconds');
            me.endDateField.value = newEndDate;
            me.endTimeField.value = DH.clone(newEndDate);
          }
        };
        /**
         * Base class for EventEdit (Scheduler) and TaskEdit (Gantt) features. Contains shared code. Not to be used directly.
         *
         * @extends Common/mixin/InstancePlugin
         */


        var EditBase =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(EditBase, _InstancePlugin);

          function EditBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_6___default()(this, EditBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_8___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(EditBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_7___default()(EditBase, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(client, config) {
              var _client$on;

              var me = this;
              client.eventEdit = me;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(EditBase.prototype), "construct", this).call(this, client, config);

              me.clientListenersDetacher = client.on((_client$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_client$on, me.triggerEvent, me.onActivateEditor), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_client$on, "dragcreateend", me.onDragCreateEnd), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_client$on, "thisObj", me), _client$on));
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.clientListenersDetacher();
              this.editor && this.editor.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(EditBase.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Editing

          }, {
            key: "insertExtraWidgetsIntoDefaultWidgets",

            /**
             * Insert extra fields into default Editor fields according to specific rules:
             * - If no index provided insert them into `extraItems` placeholder (or at the end if not);
             * - If index provided sort ASC and insert one by one, but only after no-index fields are inserted;
             * - If `extraItems` placeholder exists, don't take widgets that go after it into account;
             * @private
             */
            value: function insertExtraWidgetsIntoDefaultWidgets(editorConfig) {
              var me = this;

              if (!me.extraItems || !me.extraItems.length) {
                return;
              } // Find default extra widgets position


              var index = editorConfig.items.findIndex(function (widget) {
                return widget.type === 'extraItems';
              }),
                  tail; // If extra widgets placeholder exists

              if (index > -1) {
                // Remove extra widgets placeholder from its position
                editorConfig.items.splice(index, 1); // Backup everything that goes after extra widgets placeholder, like Save/Delete/Cancel buttons

                tail = editorConfig.items.splice(index);
              } // Split extra widgets on 2 parts: those which have index and those which haven't


              var withIndex = me.extraItems.filter(function (widget) {
                return widget.index >= 0;
              }),
                  withoutIndex = me.extraItems.filter(function (widget) {
                return !(widget.index >= 0);
              }); // Add those without index to the end of the default widgets

              editorConfig.items = editorConfig.items.concat(withoutIndex); // Sort those which have index in ASC order, so we insert fields in series

              withIndex.sort(function (widgetA, widgetB) {
                return widgetA.index - widgetB.index;
              }); // And now insert extra widgets at their individually specified index

              withIndex.forEach(function (widget) {
                return editorConfig.items.splice(widget.index, 0, widget);
              });

              if (tail && tail.length) {
                // Return backuped fields to the end of the widgets
                editorConfig.items = editorConfig.items.concat(tail);
              }
            }
          }, {
            key: "onDatesChange",
            value: function onDatesChange(params) {
              var me = this,
                  field = params.source,
                  value = params.value;

              switch (field.ref) {
                case 'startDateField':
                  me.startTimeField && adjustEndDate(value, me.startTimeField.value, me);
                  break;

                case 'startTimeField':
                  me.startDateField && adjustEndDate(me.startDateField.value, value, me);
                  break;
              }

              if (me.endTimeField) {
                // If the event starts and ends on the same day, the time fields need
                // to have their min and max set against each other.
                if (DH.isEqual(DH.clearTime(me.startDateField.value), DH.clearTime(me.endDateField.value))) {
                  me.endTimeField.min = me.startTimeField.value;
                } else {
                  me.endTimeField.min = null;
                }
              }
            } //endregion
            //region Save

          }, {
            key: "save",
            value: function save() {
              throw new Error('Implement in subclass');
            }
          }, {
            key: "onBeforeSave",

            /**
             * Template method, intended to be overridden. Called before the event record has been updated.
             * @param {Scheduler.model.EventModel} eventRecord The event record
             *
             **/
            value: function onBeforeSave(eventRecord) {}
            /**
             * Template method, intended to be overridden. Called after the event record has been updated.
             * @param {Scheduler.model.EventModel} eventRecord The event record
             *
             **/

          }, {
            key: "onAfterSave",
            value: function onAfterSave(eventRecord) {}
            /**
             * Updates record being edited with values from the editor
             * @private
             */

          }, {
            key: "updateRecord",
            value: function updateRecord(record) {
              var values = this.values; // Clean resourceId / resources out of values when using assignment store, it will handle the assignment

              if (this.scheduler.assignmentStore) {
                delete values.resource;
              }

              record.set(values);
            } //endregion
            //region Events

          }, {
            key: "onPopupBeforeHide",
            value: function onPopupBeforeHide() {
              var me = this;
              me.client.element.classList.remove('b-eventeditor-editing');
              me.dragProxyElement && me.dragProxyElement.remove();
              me.dragProxyElement = null;
            }
          }, {
            key: "onPopupKeyDown",
            value: function onPopupKeyDown(_ref3) {
              var event = _ref3.event;

              if (event.key === 'Enter' && this.saveAndCloseOnEnter && event.target.tagName.toLowerCase() === 'input') {
                // Need to prevent this key events from being fired on whatever receives focus after the editor is hidden
                event.preventDefault(); // If enter key was hit in an input element of a start field, need to adjust end date fields (the same way as if #onDatesChange handler was called)

                if (event.target.name === 'startDate') {
                  adjustEndDate(this.startDateField.value, this.startTimeField.value, this);
                }

                this.onSaveClick();
              }
            }
          }, {
            key: "onSaveClick",
            value: function onSaveClick() {
              if (this.save()) {
                this.editor.close();
              }
            }
          }, {
            key: "onDeleteClick",
            value: function onDeleteClick() {
              if (this.deleteEvent()) {
                // We expect deleteEvent will trigger close if autoClose is true and focus has moved out,
                // otherwise need to call it manually
                if (!this.editor.autoClose || this.editor.containsFocus) {
                  this.editor.close();
                }
              }
            }
          }, {
            key: "onCancelClick",
            value: function onCancelClick() {
              this.editor.close();
            } //endregion

          }, {
            key: "editorConfig",
            get: function get() {
              return this._editorConfig;
            },
            set: function set(editorConfig) {
              var me = this,
                  defaultEditorConfig = me.getDefaultConfiguration().editorConfig; // Apply editorConfig to the default editorConfig, allowing users to manipulate for example only bbar

              editorConfig = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].assign({}, defaultEditorConfig, editorConfig);
              editorConfig.items = editorConfig.items || []; // Massage the incoming widgets according to our needs before caching the configuration for use in getEditor.

              me.insertExtraWidgetsIntoDefaultWidgets(editorConfig);
              me._editorConfig = editorConfig;
            }
          }, {
            key: "extraWidgets",
            get: function get() {
              if (!this._skipWarn) {
                console.warn('`extraWidgets` was deprecated in 2.1, please change your code to use `extraItems`');
              }

              return this._extraItems;
            },
            set: function set(widgets) {
              console.warn('`extraWidgets` was deprecated in 2.1, please change your code to use `extraItems`');
              this._extraItems = widgets;
            } // TODO: When removing extraWidgets above, these can also be removed

          }, {
            key: "extraItems",
            get: function get() {
              var me = this; // Pull in extraWidgets, for compatibility

              me._skipWarn = true;

              me._thisIsAUsedExpression(me.extraWidgets);

              me._skipWarn = false;
              return me._extraItems;
            },
            set: function set(items) {
              this._extraItems = items;
            }
          }, {
            key: "isValid",
            get: function get() {
              var me = this;
              return Object.values(me.editor.widgetMap).every(function (field) {
                if (!field.name || field.hidden) {
                  return true;
                }

                return field.isValid !== false;
              });
            }
          }, {
            key: "values",
            get: function get() {
              var me = this,
                  startFields = [],
                  endFields = [],
                  values = {};
              me.editor.eachWidget(function (widget) {
                var name = widget.name;
                if (!name || widget.hidden) return;

                if (name === 'startDate') {
                  startFields.push(widget);
                } else if (name === 'endDate') {
                  endFields.push(widget);
                } else {
                  values[name] = widget.value;
                }
              }, true);
              values.startDate = makeDate(startFields);
              values.endDate = makeDate(endFields); // Since there is no duration field in the editor,
              // we don't need to recalc duration value on each date change.
              // It's enough to return correct duration value in `values`,
              // so the record will get updated with the correct data.

              values.duration = DH.diff(values.startDate, values.endDate, me.editor.record.durationUnit, true);
              return values;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            // TODO: check which configs are actually used
            get: function get() {
              return {
                /**
                 * True to hide this editor if a click is detected outside it (defaults to true)
                 * @config {Boolean}
                 * @default
                 * @category Editor
                 */
                autoClose: true,

                /**
                 * True to save and close this panel if ENTER is pressed in one of the input fields inside the panel.
                 * @config {Boolean}
                 * @default
                 * @category Editor
                 */
                saveAndCloseOnEnter: true,
                triggerEvent: null,

                /**
                 * True to show a delete button in the form.
                 * @config {Boolean}
                 * @default
                 * @category Editor widgets
                 */
                showDeleteButton: true,

                /**
                 * True to show a text field for entering event name
                 * @config {Boolean}
                 * @default
                 * @category Editor widgets
                 */
                showNameField: true,

                /**
                 * Config for the `startTimeField` constructor.
                 * @config {Object}
                 * @category Editor widgets
                 */
                startTimeConfig: null,

                /**
                 * Config for the `startDateField` constructor.
                 * @config {Object}
                 * @category Editor widgets
                 */
                startDateConfig: null,

                /**
                 * Config for the `endTimeField` constructor.
                 * @config {Object}
                 * @category Editor widgets
                 */
                endTimeConfig: null,

                /**
                 * Config for the `endDateField` constructor.
                 * @config {Object}
                 * @category Editor widgets
                 */
                endDateConfig: null,

                /**
                 * This config parameter is passed to the `startDateField` and `endDateField` constructor.
                 * @config {String}
                 * @default
                 * @category Editor widgets
                 */
                dateFormat: 'L',
                // date format that uses browser locale

                /**
                 * This config parameter is passed to the `startTimeField` and `endTimeField` constructor.
                 * @config {String}
                 * @default
                 * @category Editor widgets
                 */
                timeFormat: 'LT',
                // date format that uses browser locale

                /**
                 * Default editor configuration, which widgets it shows etc.
                 * @config {Object}
                 * @category Editor
                 */
                editorConfig: null,

                /**
                 * Array of widgets. Will be inserted above buttons unless an index is
                 * specified for the widget:
                 * ```
                 * new Grid({
                 *   features : {
                 *     eventEdit : {
                 *       extraItems : [
                 *         { type : 'text', index : 1 },
                 *         ...
                 *       ]
                 *     }
                 *   }
                 * });
                 * ```
                 * @config {String|Object[]}
                 * @category Editor widgets
                 */
                extraItems: null,

                /**
                 * This config has been deprecated in favour of {@link #config-extraItems}.
                 * @deprecated 2.1
                 * @config {String|Object[]}
                 * @category Editor widgets
                 */
                extraWidgets: null
              };
            }
          }]);

          return EditBase;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_13__["default"]);

        EditBase._$name = 'EditBase';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/base/ResizeBase.js":
      /*!**************************************************!*\
        !*** ./lib/Scheduler/feature/base/ResizeBase.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureBaseResizeBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResizeBase;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../tooltip/ClockTemplate.js */
        "./lib/Scheduler/tooltip/ClockTemplate.js");

        var productName = 'scheduler'; //TODO: Prevent right click while resizing (do it in ResizeHelper?)
        //TODO: Scroll

        /**
         * @module Scheduler/feature/base/ResizeBase
         */

        var tipAlign = {
          'top': 'b-t',
          'right': 'b100-t100',
          'bottom': 't-b',
          'left': 'b0-t0'
        };
        /**
         * Base class for EventResize (Scheduler) and TaskResize (Gantt) features. Contains shared code. Not to be used directly.
         *
         * @extends Common/mixin/InstancePlugin
         * @abstract
         */

        var ResizeBase =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ResizeBase, _InstancePlugin);

          function ResizeBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ResizeBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ResizeBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ResizeBase, [{
            key: "render",
            //endregion
            //region Init & destroy
            value: function render() {
              var me = this,
                  client = me.client;
              me.resize && me.resize.destroy();
              me.resize = me.createResizeHelper();

              if (me.showTooltip) {
                me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
                  timeAxisViewModel: client.timeAxisViewModel
                });
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this;
              me.tip && me.tip.destroy();
              me.clockTemplate && me.clockTemplate.destroy();
              me.resize && me.resize.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ResizeBase.prototype), "doDestroy", this).call(this);
            } //endregion
            //region Events

          }, {
            key: "isElementResizable",
            value: function isElementResizable(element, event) {
              var client = this.client,
                  resize = this.resize,
                  timespanRecord = client.resolveTimeSpanRecord(element);

              if (client.readOnly) {
                return false;
              }

              var resizable = timespanRecord && timespanRecord.isResizable; // go up from "handle" to resizable element

              element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(event.target, client.eventSelector); // Not resizable if the mousedown is on a resizing handle of
              // a percent bar.

              var handleHoldingElement = element ? element.firstElementChild : element,
                  handleEl = event.target.closest('[class$="-handle"]');

              if (!resizable || handleEl && handleEl !== handleHoldingElement) {
                return false;
              }

              var startsOutside = element.classList.contains('b-sch-event-startsoutside'),
                  endsOutside = element.classList.contains('b-sch-event-endsoutside');

              if (resizable === true) {
                if (startsOutside && endsOutside) {
                  return false;
                } else if (startsOutside) {
                  resizable = 'end';
                } else if (endsOutside) {
                  resizable = 'start';
                } else {
                  return resize.overStartHandle(event, element) || resize.overEndHandle(event, element);
                }
              }

              if (startsOutside && resizable === 'start' || endsOutside && resizable === 'end') {
                return false;
              }

              if (resize.overStartHandle(event, element) && resizable === 'start' || resize.overEndHandle(event, element) && resizable === 'end') {
                return true;
              }

              return false;
            }
          }, {
            key: "onBeforeResizeStart",
            value: function onBeforeResizeStart(_ref) {
              var _client$trigger;

              var element = _ref.element,
                  event = _ref.event;
              var client = this.client,
                  name = client.scheduledEventName,
                  timespanRecord = client.resolveTimeSpanRecord(element); // trigger beforeEventResize or beforeTaskResize depending on product

              return client.trigger("before".concat(client.capitalizedEventName, "Resize"), (_client$trigger = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger, name + 'Record', timespanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger, "event", event), _client$trigger)) !== false;
            }
          }, {
            key: "onResizeStart",
            value: function onResizeStart(_ref2) {
              var _client$trigger2;

              var context = _ref2.context,
                  event = _ref2.event;
              var me = this,
                  client = me.client,
                  timespanRecord = client.resolveTimeSpanRecord(context.element),
                  name = client.scheduledEventName;
              client.element.classList.add('b-resizing-event'); // Let products to their specific stuff

              me.setupProductResizeContext(context, event);

              if (me.showTooltip) {
                if (me.tip) {
                  me.tip.align = tipAlign[context.edge];
                  me.tip.showBy(me.getTooltipTarget());
                } else {
                  me.tip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
                    id: "".concat(client.id, "-event-resize-tip"),
                    autoShow: true,
                    axisLock: true,
                    trackMouse: false,
                    getHtml: me.getTipHtml.bind(me),
                    align: tipAlign[context.edge],
                    hideDelay: 0
                  });
                  me.tip.on('innerhtmlupdate', me.updateDateIndicator, me);
                }
              } // flag to not allow release of element when scrolling


              timespanRecord.instanceMeta(client).retainElement = true; // Trigger eventResizeStart or taskResizeStart depending on product

              client.trigger("".concat(name, "ResizeStart"), (_client$trigger2 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger2, "".concat(name, "Record"), timespanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger2, "event", event), _client$trigger2));
            }
          }, {
            key: "updateDateIndicator",
            value: function updateDateIndicator() {
              var _this$resize$context = this.resize.context,
                  edge = _this$resize$context.edge,
                  startDate = _this$resize$context.startDate,
                  endDate = _this$resize$context.endDate,
                  element = this.tip.element;

              if (startDate || endDate) {
                if (edge === 'right' || edge === 'bottom') {
                  this.clockTemplate.updateDateIndicator(element.querySelector('.b-sch-tooltip-enddate'), endDate);
                } else {
                  this.clockTemplate.updateDateIndicator(element, startDate);
                }
              }
            }
          }, {
            key: "getTooltipTarget",
            value: function getTooltipTarget() {
              var me = this,
                  target = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_10__["default"].from(me.resize.context.element, null, true);

              if (me.resize.direction === 'horizontal') {
                // Align to the dragged edge of the proxy, and then bump right so that the anchor aligns perfectly.
                if (me.resize.context.edge === 'right') {
                  target.x = target.right - 1;
                }

                target.width = me.tip.anchorSize[0] / 2;
              } else {
                // Align to the dragged edge of the proxy, and then bump bottom so that the anchor aligns perfectly.
                if (me.resize.context.edge === 'bottom') {
                  target.y = target.bottom - 1;
                }

                target.height = me.tip.anchorSize[1] / 2;
              }

              return {
                target: target
              };
            }
          }, {
            key: "onResizing",
            value: function onResizing(_ref3) {
              var _client$trigger3;

              var context = _ref3.context,
                  event = _ref3.event;

              var me = this,
                  client = me.client,
                  depFeature = client.features.dependencies,
                  timespanRecord = me.getTimespanRecord(context),
                  name = client.scheduledEventName,
                  element = context.element,
                  edge = context.edge,
                  xy = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].getTranslateXY(element);

              var start, end;

              if (edge === 'top' || edge === 'left') {
                end = timespanRecord.endDate;

                if (client.snapRelativeToEventStartDate) {
                  start = client.getDateFromXY(xy, null, true);
                  start = client.timeAxis.roundDate(start, timespanRecord.startDate);
                } else {
                  start = client.getDateFromXY(xy, 'round', true);
                }
              } // bottom || right
              else {
                  xy[0] += element.offsetWidth;
                  xy[1] += element.offsetHeight;
                  start = timespanRecord && timespanRecord.startDate;

                  if (client.snapRelativeToEventStartDate) {
                    end = client.getDateFromXY(xy, null, true);
                    end = client.timeAxis.roundDate(end, timespanRecord.endDate);
                  } else {
                    end = client.getDateFromXY(xy, 'round', true);
                  }
                }

              start = start || context.startDate;
              end = end || context.endDate;

              if (context.dateConstraints) {
                start = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].constrain(start, context.dateConstraints.start, context.dateConstraints.end);
                end = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].constrain(end, context.dateConstraints.start, context.dateConstraints.end);
              }

              if (me.showExactResizePosition || client.timeAxisViewModel.snap) {
                var exactSize = edge === 'top' || edge === 'left' ? client.timeAxisViewModel.getDistanceBetweenDates(start, timespanRecord.endDate) : client.timeAxisViewModel.getDistanceBetweenDates(timespanRecord.startDate, end);

                switch (edge) {
                  case 'top':
                    _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateY(element, context.elementStartY + context.elementWidth - exactSize);

                    element.style.height = exactSize + 'px';
                    break;

                  case 'right':
                    element.style.width = exactSize + 'px';
                    break;

                  case 'bottom':
                    element.style.height = exactSize + 'px';
                    break;

                  case 'left':
                    _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].setTranslateX(element, context.elementStartX + context.elementWidth - exactSize);

                    element.style.width = exactSize + 'px';
                    break;
                }
              }

              var dateChanged = context.endDate - end !== 0 || context.startDate - start !== 0;
              context.endDate = end;
              context.startDate = start; // No need to query on every pixel of mouse move

              if (dateChanged) {
                context.valid = me.checkValidity(context, event);
              } // Trigger eventPartialResize or taskPartialResize depending on product


              client.trigger("".concat(name, "PartialResize"), (_client$trigger3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger3, "".concat(name, "Record"), timespanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger3, "startDate", start), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger3, "endDate", end), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger3, "element", element), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_client$trigger3, "context", context), _client$trigger3));

              if (depFeature) {
                depFeature.updateDependenciesForTimeSpan(timespanRecord, element);
              }

              if (me.showTooltip) {
                me.tip.alignTo(me.getTooltipTarget());
              }
            }
          }, {
            key: "checkValidity",
            value: function checkValidity(context, event) {
              var valid = context.startDate && context.endDate > context.startDate && this.validatorFn.call(this.validatorFnThisObj || this, context, event);

              if (valid && typeof valid !== 'boolean') {
                context.message = valid.message || '';
                valid = valid.valid;
              }

              return valid !== false;
            }
          }, {
            key: "onFinishResize",
            value: function onFinishResize(_ref4) {
              var drag = _ref4.source,
                  context = _ref4.context,
                  event = _ref4.event;
              var me = this,
                  timespanRecord = me.getTimespanRecord(context),
                  oldStart = timespanRecord.startDate,
                  oldEnd = timespanRecord.endDate,
                  start = context.startDate || oldStart,
                  end = context.endDate || oldEnd,
                  client = me.client;
              var modified = false; // allow release of element again

              timespanRecord.instanceMeta(client).retainElement = false;
              var old = context.finalize;

              context.finalize = function () {
                for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
                  params[_key] = arguments[_key];
                } // We are overriding context of the resize helper. It is finalized automatically on sync resize. Which means,
                // we should only call finalize if context is async.


                context.async && me.finalize.apply(me, params);
                old.call(context, params);
              };

              context.valid = start && end && end - start > 0 && ( // Input sanity check
              start - oldStart !== 0 || end - oldEnd !== 0) && // Make sure start OR end changed
              context.valid !== false;

              if (context.valid) {
                // Seems to be a valid resize operation, ask outside world if anyone wants to take control over the finalizing,
                // to show a confirm dialog prior to applying the new values. Triggers beforeEventResizeFinalize or
                // beforeTaskResizeFinalize depending on product
                client.trigger("before".concat(client.scheduledEventName, "ResizeFinalize"), {
                  context: context,
                  event: event
                });
                modified = true;
              }

              if (!context.async) {
                me.finalize(modified);
              }
            }
          }, {
            key: "onCancelResize",
            value: function onCancelResize(_ref5) {
              var context = _ref5.context;
              var timespanRecord = this.getTimespanRecord(context); // resizing may not have started at all (just clicking a resize handle)

              if (timespanRecord) {
                timespanRecord.instanceMeta(this.client).retainElement = false;
              }

              this.finalize(false);
            }
          }, {
            key: "finalize",
            value: function finalize(updateRecord) {
              var me = this,
                  client = me.client,
                  context = me.resize.context,
                  timespanRecord = me.getTimespanRecord(context),
                  name = client.scheduledEventName;
              var wasChanged = false;

              if (me.tip) {
                me.tip.hide();
              }

              if (context.started) {
                if (updateRecord) {
                  // Scheduler and gantt updates the record differently
                  wasChanged = me.internalUpdateRecord(context, timespanRecord);
                }

                if (!updateRecord || !wasChanged) {
                  var dependencies = client.features.dependencies; // Dependencies are updated dynamically during resize, so ensure they are redrawn
                  // if the event snaps back with no change.

                  if (dependencies) {
                    dependencies.scheduleDraw(true);
                  }

                  client.repaintEventsForResource(me.getRowRecord(context));
                }
              }

              client.element.classList.remove('b-resizing-event'); // Triggers eventResizeEnd or taskResizeEnd depending on product

              client.trigger("".concat(name, "ResizeEnd"), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({
                changed: wasChanged
              }, "".concat(name, "Record"), timespanRecord || client.resolveEventRecord(context.element)));
            } //endregion
            //region Tooltip

          }, {
            key: "getTipHtml",
            value: function getTipHtml(_ref6) {
              var tip = _ref6.tip;
              var me = this;
              var _me$resize$context = me.resize.context,
                  startDate = _me$resize$context.startDate,
                  endDate = _me$resize$context.endDate,
                  valid = _me$resize$context.valid,
                  message = _me$resize$context.message; // Empty string hides the tip - we get called before the Resizer, so first call will be empty

              if (!startDate || !endDate) {
                return tip.html;
              }

              if (message === undefined) message = '';
              endDate = me.client.getDisplayEndDate(endDate, startDate);
              var startText = me.client.getFormattedDate(startDate),
                  endText = me.client.getFormattedDate(endDate);
              return me.tipTemplate({
                valid: valid,
                startDate: startDate,
                endDate: endDate,
                startText: startText,
                endText: endText,
                message: message,
                startClockHtml: me.clockTemplate.template({
                  date: startDate,
                  text: startText,
                  cls: 'b-sch-tooltip-startdate'
                }),
                endClockHtml: me.clockTemplate.template({
                  date: endDate,
                  text: endText,
                  cls: 'b-sch-tooltip-enddate'
                })
              });
            } //endregion
            //region Product specific, implemented in subclasses

          }, {
            key: "getRowRecord",
            value: function getRowRecord(context) {
              throw new Error('Implement in subclass');
            }
          }, {
            key: "getTimespanRecord",
            value: function getTimespanRecord(context) {
              throw new Error('Implement in subclass');
            }
          }, {
            key: "setupProductResizeContext",
            value: function setupProductResizeContext(context, event) {
              throw new Error('Implement in subclass');
            } // Store containing the timespan record being resized

          }, {
            key: "store",
            get: function get() {
              throw new Error('Implement in subclass');
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * `false` to not show a tooltip while resizing
                 * @config {Boolean}
                 * @default
                 */
                showTooltip: true,

                /**
                 * true to see exact event length during resizing
                 * @config {Boolean}
                 * @default
                 */
                showExactResizePosition: false,

                /**
                 * An empty function by default, but provided so that you can perform custom validation on
                 * the item being resized. Return true if the new duration is valid, false to signal that it is not.
                 * @param {Object} context The resize context, contains the record & dates.
                 * @param {Event} e The browser Event object
                 * @return {Boolean}
                 * @config {Function}
                 */
                validatorFn: function validatorFn() {},

                /**
                 * `this` reference for the validatorFn
                 * @config {Object}
                 */
                validatorFnThisObj: null,

                /**
                 * The tooltip instance to show while resizing an event or a configuration object for the {@link Common.widget.Tooltip}.
                 * @config {Common.widget.Tooltip}
                 */
                tip: null,
                tipTemplate: function tipTemplate(data) {
                  return "\n                <div class=\"b-sch-tip-".concat(data.valid ? 'valid' : 'invalid', "\">\n                    ").concat(data.startClockHtml, "\n                    ").concat(data.endClockHtml, "\n                    <div class=\"b-sch-tip-message\">").concat(data.message, "</div>\n                </div>\n            ");
                }
              };
            }
          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['render']
              };
            }
          }]);

          return ResizeBase;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        ResizeBase._$name = 'ResizeBase';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js":
      /*!*********************************************************************!*\
        !*** ./lib/Scheduler/feature/base/TimeSpanRecordContextMenuBase.js ***!
        \*********************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureBaseTimeSpanRecordContextMenuBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeSpanRecordContextMenuBase;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "./node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/base/TimeSpanRecordContextMenuBase
         */
        // This is a version of what Containers do, except that we have to apply our namedItems
        // all the way down any configured menu hierarchy, and the resulting structure must
        // be available *before* menu instantiation for the processItems method to interrogate.

        var applyNamedItems = function applyNamedItems(items, namedItems) {
          for (var ref in items) {
            var item = items[ref];

            if (item) {
              if (ref in namedItems) {
                item = items[ref] = _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_6___default()(item) === 'object' ? _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].merge(_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].clone(namedItems[ref]), item) : namedItems[ref];
              } // Our namedItems must apply all the way down any descendant menus.
              // Extract menu here because it may have been applied by a namedItem.


              var menu = item.menu;

              if (menu) {
                applyNamedItems('items' in menu ? menu.items : menu, namedItems);
              }
            }
          }
        };
        /**
         * Abstract base class used by other context menu features such as {@link Scheduler/feature/EventContextMenu EventContextMenu} and
         * {@link Scheduler/feature/ScheduleContextMenu ScheduleContextMenu}.
         * @extends Common/mixin/InstancePlugin
         * @abstract
         */


        var TimeSpanRecordContextMenuBase =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(TimeSpanRecordContextMenuBase, _InstancePlugin);

          function TimeSpanRecordContextMenuBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, TimeSpanRecordContextMenuBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimeSpanRecordContextMenuBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(TimeSpanRecordContextMenuBase, [{
            key: "doDestroy",
            //endregion
            //region Init
            value: function doDestroy() {
              if (this.menu) {
                this.menu.destroy();
              }
            } //endregion
            //region Events

          }, {
            key: "onElementContextMenu",
            value: function onElementContextMenu(event) {
              this.triggerEvent === 'contextmenu' && this.showEventContextMenu(event);
            }
          }, {
            key: "onElementClick",
            value: function onElementClick(event) {
              this.triggerEvent === 'click' && this.showEventContextMenu(event);
            }
          }, {
            key: "onElementDblClick",
            value: function onElementDblClick(event) {
              this.triggerEvent === 'dblclick' && this.showEventContextMenu(event);
            } // chained from EventNavigation

          }, {
            key: "onEventSpaceKey",
            value: function onEventSpaceKey(keyEvent) {
              var targetPoint = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(keyEvent.target).center,
                  contextmenuEvent = new MouseEvent('contextmenu', Object.assign({
                clientX: targetPoint.x,
                clientY: targetPoint.y
              }, keyEvent));

              Object.defineProperty(contextmenuEvent, 'target', {
                get: function get() {
                  return keyEvent.target;
                }
              });
              this.showEventContextMenu(contextmenuEvent);
            } //endregion
            //region Menu handlers

            /**
             * Show event context menu.
             * @param event
             * @fires eventContextMenuItem
             * @internal
             */

          }, {
            key: "showEventContextMenu",
            value: function showEventContextMenu(event) {
              var me = this,
                  client = me.client,
                  target = event.target,
                  eventElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(target, client.eventSelector) || target;

              if (eventElement) {
                event.preventDefault();
                var record = me.resolveRecord(eventElement);

                if (record) {
                  me.showContextMenuFor(record, {
                    targetElement: eventElement,
                    event: event
                  });
                }
              }
            }
            /**
             * Shows context menu for the provided record. If record is not rendered (outside of time span, or collapsed)
             * menu won't appear.
             * @param {Scheduler.model.TimeSpan} record
             * @param {Object} [options]
             * @param {HTMLElement} options.targetElement Element to align context menu to
             * @param {Event} options.event Browser event. If provided menu will be aligned according to clientX/clientY coordinates.
             * If omitted, context menu will be centered to targetElement
             */

          }, {
            key: "showContextMenuFor",
            value: function showContextMenuFor(record, options) {} // Implement in subclasses to massage options or veto show.

          }, {
            key: "beforeContextMenuShow",
            value: function beforeContextMenuShow() {} //endregion
            //region Show/Hide

            /**
             * @param {Object} eventParams
             * @param {Object[]} items
             * @protected
             * @internal
             */

          }, {
            key: "showContextMenu",
            value: function showContextMenu(eventParams) {
              var me = this,
                  event = eventParams.event,
                  menuType = eventParams.menuType.toLowerCase(),
                  eventType = _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].lowercaseFirstLetter(menuType),
                  clientGetItemsMethod = "get".concat(_Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].capitalizeFirstLetter(menuType), "MenuItems"),
                  client = me.client,
                  processItems = me.processItems,
                  defaultItems = me.defaultItems,
                  namedItems = me.namedItems,
                  point = event ? [event.clientX + 1, event.clientY + 1] : _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(eventParams.targetElement).center,
                  items = eventParams.items = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isEmpty(me.items) ? _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].clone(defaultItems) : _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].merge(_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].clone(defaultItems), me.items);

              eventParams.namedItems = namedItems;
              eventParams.selection = client.selectedRecords; // Apply the named items prior to Container's item processing.
              // Our namedItems must cascade to all descendant Menu levels.
              // And they MUST have all been converted prior to the processItems call.

              applyNamedItems(items, namedItems); // Call the chainable method which other features use to add their own menu items.
              // For example getEventMenuItems

              if (client[clientGetItemsMethod]) {
                client[clientGetItemsMethod](eventParams, items);
              } // Allow user a chance at processing the items and preventing the menu from showing


              if ((!processItems || processItems(eventParams) !== false) && !_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].isEmpty(eventParams.items)) {
                // beforeContextMenuShow is a lifecycle method which may be implemented in subclasses to
                // preprocess the event.
                if (me.beforeContextMenuShow(eventParams) !== false) {
                  // Trigger event that allows preventing menu or manipulating its items
                  if (client.trigger("".concat(eventType, "ContextMenuBeforeShow"), eventParams) !== false) {
                    me.menu = _Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].showContextMenu(point, {
                      owner: client,
                      scrollAction: 'hide',
                      clippedBy: [client.timeAxisSubGridElement, client.bodyContainer],
                      constrainTo: window,
                      items: items,
                      onDestroy: function onDestroy() {
                        me.menu = null;
                      },
                      // Load up the item event with the contextual info
                      onBeforeItem: function onBeforeItem(itemEvent) {
                        Object.assign(itemEvent, eventParams);
                      },
                      onItem: function onItem(itemEvent) {
                        return client.trigger("".concat(eventType, "ContextMenuItem"), itemEvent);
                      },
                      listeners: {
                        show: function show(_ref) {
                          var menu = _ref.source;
                          eventParams.menu = menu;
                          client.trigger("".concat(eventType, "ContextMenuShow"), eventParams);
                        }
                      }
                    });
                  }
                }
              }
            }
            /**
             * Hides the context menu
             * @protected
             * @internal
             */

          }, {
            key: "hideContextMenu",
            value: function hideContextMenu(animate) {
              this.menu && this.menu.hide(animate);
            } //endregion
            //region Getters/Setters

            /**
             * Provides the default configuration of the context menu.
             *
             * Concrete classes must all provide their own defaultItems value in their defaultConfig blocks
             * @private
             */

          }, {
            key: "defaultItems",
            set: function set(defaultItems) {
              this._defaultItems = defaultItems;
            },
            get: function get() {
              var result = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].clone(this._defaultItems); // Read-only client should have no default items enabled


              if (this.client.readOnly) {
                for (var item in result) {
                  result[item] = false;
                }
              }

              return result;
            }
          }, {
            key: "triggerEvent",
            get: function get() {
              return this._triggerEvent || this.client.contextMenuTriggerEvent;
            },
            set: function set(value) {
              this._triggerEvent = value;
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * This is a preconfigured set of {@link Common.widget.Container#config-namedItems} used to create the default
                 * context menu.
                 * @config {Object}
                 */
                defaultItems: null,

                /**
                 * An {@link Common.widget.Menu Menu} items object containing named child menu items
                 * to apply to the feature's provided context menu, see {@link #config-defaultItems}.
                 *
                 * This may add extra items as below, but may also remove any of the {@link #config-defaultItems}
                 * by configuring the name of the item as `false`
                 *
                 * ```javascript
                 * features : {
                 *     taskContextMenu : { // use eventContextMenu in the Scheduler product
                 *         // This object is applied to the Feature's predefined defaultItems object
                 *         items : {
                 *             switchToDog : {
                 *                 text : 'Dog',
                 *                 icon : 'b-fa b-fa-fw b-fa-dog',
                 *                 onItem({contextRecord}) {
                 *                     contextRecord.dog = true;
                 *                     contextRecord.cat = false;
                 *                 },
                 *                 weight : 500     // Make this second from end
                 *             },
                 *             switchToCat : {
                 *                 text : 'Cat',
                 *                 icon : 'b-fa b-fa-fw b-fa-cat',
                 *                 onItem({contextRecord}) {
                 *                     contextRecord.dog = false;
                 *                     contextRecord.cat = true;
                 *                 },
                 *                 weight : 510     // Make this sink to end
                 *             },
                 *             add : false // We do not want the "Add" submenu to be available
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @config {Object|Object[]}
                 */
                items: null,

                /**
                 * A function called before displaying the menu that allows manipulations of its items. Called with a
                 * single parameter with format { contextRecord, eventElement, items }. Returning `false`
                 * from this function prevents the menu from being shown.
                 *
                 * ```javascript
                 * features : {
                 *     taskContextMenu : {
                 *         processItems({contextRecord, items}) {
                 *             // Add or remove items here as needed
                 *             if (contextRecord.type === 'Meeting') {
                 *                 items.cancel = {
                 *                     text   : 'Cancel',
                 *                     icon   : 'b-fa b-fa-fw b-fa-ban',
                 *                     weight : 200 // Move to end
                 *                 };
                 *             }
                 *
                 *             // Hide delete for parents
                 *             items.deleteTask.hidden = contextRecord.isParent;
                 *         }
                 *     }
                 * }
                 * ```
                 *
                 * @config {Function}
                 */
                processItems: null,

                /**
                 * Event which is used to show context menu.
                 * Available options are: 'contextmenu', 'click', 'dblclick'.
                 * Default value is used from {@link Grid/view/Grid#config-contextMenuTriggerEvent}
                 * @config {String}
                 */
                triggerEvent: null
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                assign: ['showEventContextMenu'],
                chain: ['onElementContextMenu', 'onElementClick', 'onElementDblClick', 'onEventSpaceKey']
              };
            }
          }]);

          return TimeSpanRecordContextMenuBase;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        TimeSpanRecordContextMenuBase._$name = 'TimeSpanRecordContextMenuBase';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/base/TooltipBase.js":
      /*!***************************************************!*\
        !*** ./lib/Scheduler/feature/base/TooltipBase.js ***!
        \***************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureBaseTooltipBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TooltipBase;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../tooltip/ClockTemplate.js */
        "./lib/Scheduler/tooltip/ClockTemplate.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/base/TooltipBase
         */

        /**
         * Base class for EventTooltip (Scheduler) and TaskTooltip (Gantt) features. Contains shared code. Not to be used directly.
         *
         * @extends Common/mixin/InstancePlugin
         */

        var TooltipBase =
        /*#__PURE__*/
        function (_InstancePlugin) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(TooltipBase, _InstancePlugin);

          function TooltipBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, TooltipBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TooltipBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(TooltipBase, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(client, config) {
              var me = this; // process initial config into an actual config object

              config = me.processConfig(config);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TooltipBase.prototype), "construct", this).call(this, client, config); // Default triggering selector is the client's inner element selector


              if (!me.forSelector) {
                me.forSelector = "".concat(client.eventInnerSelector, ":not(.b-dragproxy)");
              }

              me.clockTemplate = new _tooltip_ClockTemplate_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
                timeAxisViewModel: client.timeAxisViewModel
              });
              client.on(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()({}, "before".concat(client.scheduledEventName, "drag"), function beforedrag() {
                me.tooltip && me.tooltip.hide();
              }));
            } // TooltipBase feature handles special config cases, where user can supply a function to use as template
            // instead of a normal config object

          }, {
            key: "processConfig",
            value: function processConfig(config) {
              if (typeof config === 'function') {
                return {
                  template: config
                };
              }

              return config;
            } // override setConfig to process config before applying it (used mainly from ReactScheduler)

          }, {
            key: "setConfig",
            value: function setConfig(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TooltipBase.prototype), "setConfig", this).call(this, this.processConfig(config));
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.clockTemplate && this.clockTemplate.destroy();
              this.tooltip && this.tooltip.destroy();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(TooltipBase.prototype), "doDestroy", this).call(this);
            } //endregion

          }, {
            key: "render",
            value: function render() {
              var me = this,
                  client = me.client,
                  ignoreSelector = ['.b-dragselecting', '.b-eventeditor-editing', '.b-resizing-event', '.b-dragcreating', ".b-dragging-".concat(client.scheduledEventName), '.b-creating-dependency', '.b-dragproxy'].map(function (cls) {
                return ":not(".concat(cls, ")");
              }).join('');
              if (me.tooltip) me.tooltip.destroy();
              /**
               * A reference to the tooltip instance, which will have a special `eventRecord` property that
               * you can use to get data from the contextual event record to which this tooltip is related.
               * @member {Common.widget.Tooltip} tooltip
               * @readonly
               */

              me.tooltip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_10__["default"](Object.assign({
                axisLock: 'flexible',
                id: me.tipId || "".concat(me.client.id, "-event-tip"),
                cls: me.tipCls,
                forSelector: ".b-timelinebase".concat(ignoreSelector, " ").concat(me.forSelector),
                scrollAction: 'realign',
                clippedBy: [client.timeAxisSubGridElement, client.bodyContainer],
                forElement: client.timeAxisSubGridElement,
                showOnHover: true,
                hoverDelay: 0,
                hideDelay: 100,
                anchorToTarget: true,
                allowOver: true,
                getHtml: me.getTipHtml.bind(me)
              }, me.config));
              me.tooltip.on('innerhtmlupdate', me.updateDateIndicator, me);
            }
          }, {
            key: "updateDateIndicator",
            value: function updateDateIndicator() {
              var me = this,
                  client = me.client,
                  tip = me.tooltip,
                  timeSpanRecord = tip.activeTarget && client.resolveTimeSpanRecord(tip.activeTarget),
                  endDateElement = tip.element.querySelector('.b-sch-tooltip-enddate');
              if (!timeSpanRecord) return;
              me.clockTemplate.updateDateIndicator(tip.element, timeSpanRecord.startDate);
              endDateElement && me.clockTemplate.updateDateIndicator(endDateElement, timeSpanRecord.endDate);
            }
          }, {
            key: "resolveTimeSpanRecord",
            value: function resolveTimeSpanRecord(forElement) {
              return this.client.resolveTimeSpanRecord(forElement);
            }
          }, {
            key: "getTipHtml",
            value: function getTipHtml(_ref) {
              var tip = _ref.tip,
                  forElement = _ref.forElement;
              var me = this,
                  client = me.client,
                  recordProp = me.recordType || "".concat(client.scheduledEventName, "Record"),
                  timeSpanRecord = me.resolveTimeSpanRecord(forElement); // If user has mouseovered a fading away element of a deleted event,
              // an event record will not be found. In this case the tip must hide.

              if (timeSpanRecord) {
                var _me$template;

                var startDate = timeSpanRecord.startDate,
                    endDate = timeSpanRecord.endDate,
                    startText = client.getFormattedDate(startDate),
                    endDateValue = client.getDisplayEndDate(endDate, startDate),
                    endText = client.getFormattedDate(endDateValue);
                tip.eventRecord = timeSpanRecord;
                tip.title = timeSpanRecord.name;
                return me.template((_me$template = {
                  tip: tip
                }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_me$template, "".concat(recordProp), timeSpanRecord), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_me$template, "startDate", startDate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_me$template, "endDate", endDate), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_me$template, "startText", startText), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_me$template, "endText", endText), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_me$template, "startClockHtml", me.clockTemplate.template({
                  date: startDate,
                  text: startText,
                  cls: 'b-sch-tooltip-startdate'
                })), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2___default()(_me$template, "endClockHtml", timeSpanRecord.isMilestone ? '' : me.clockTemplate.template({
                  date: endDateValue,
                  text: endText,
                  cls: 'b-sch-tooltip-enddate'
                })), _me$template));
              } else {
                tip.hide();
                return '';
              }
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Specify true to have tooltip updated when mouse moves, if you for example want to display date at mouse
                 * position.
                 * @config {Boolean}
                 * @default
                 */
                autoUpdate: false,
                template: null,
                cls: null,
                align: 'b-t',
                clockTemplate: null
              };
            } // Plugin configuration. This plugin chains some of the functions in Grid.

          }, {
            key: "pluginConfig",
            get: function get() {
              return {
                chain: ['render']
              };
            }
          }]);

          return TooltipBase;
        }(_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_9__["default"]);

        TooltipBase._$name = 'TooltipBase';
        /***/
      },

      /***/
      "./lib/Scheduler/feature/mixin/DependencyCreation.js":
      /*!***********************************************************!*\
        !*** ./lib/Scheduler/feature/mixin/DependencyCreation.js ***!
        \***********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerFeatureMixinDependencyCreationJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "./node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../model/DependencyBaseModel.js */
        "./lib/Scheduler/model/DependencyBaseModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/feature/mixin/DependencyCreation
         */

        /**
         * Mixin for Dependencies feature that handles dependency creation (drag & drop from terminals which are shown on hover).
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_Delayable) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_10___default()(DependencyCreation, _Delayable);

              function DependencyCreation() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, DependencyCreation);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DependencyCreation).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(DependencyCreation, [{
                key: "construct",
                //endregion
                //region Init & destroy
                value: function construct(view, config) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DependencyCreation.prototype), "construct", this).call(this, view, config);

                  var me = this;
                  me.view = view;
                  me.eventName = view.scheduledEventName;
                  me.view.on('readOnly', function () {
                    return me.updateCreateListeners();
                  });
                  me.updateCreateListeners();
                }
              }, {
                key: "doDestroy",
                value: function doDestroy() {
                  var me = this;
                  me.listenersDetacher && me.listenersDetacher();
                  me.abort();
                  me.creationTooltip && me.creationTooltip.destroy();

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_9___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(DependencyCreation.prototype), "doDestroy", this).call(this);
                }
              }, {
                key: "updateCreateListeners",
                value: function updateCreateListeners() {
                  var me = this;

                  if (!me.view) {
                    return;
                  }

                  me.listenersDetacher && me.listenersDetacher();
                  me.listenersDetacher = null;

                  if (me.isCreateAllowed) {
                    var _me$view$on;

                    me.listenersDetacher = me.view.on((_me$view$on = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_me$view$on, "".concat(me.eventName, "mouseenter"), me.onTimeSpanMouseEnter), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_me$view$on, "".concat(me.eventName, "mouseleave"), me.onTimeSpanMouseLeave), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_4___default()(_me$view$on, "thisObj", me), _me$view$on));
                  }
                }
              }, {
                key: "onTimeSpanMouseEnter",
                //endregion
                //region Events

                /**
                 * Show terminals when mouse enters event/task element
                 * @private
                 */
                value: function onTimeSpanMouseEnter(event) {
                  var record = event["".concat(this.eventName, "Record")],
                      element = event["".concat(this.eventName, "Element")];
                  this.showTerminals(record, _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].down(element, event.source.eventInnerSelector));
                }
                /**
                 * Hide terminals when mouse leaves event/task element
                 * @private
                 */

              }, {
                key: "onTimeSpanMouseLeave",
                value: function onTimeSpanMouseLeave(event) {
                  var me = this,
                      element = event["".concat(me.eventName, "Element")];

                  if (!me.creationData || !_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isDescendant(element, me.creationData.sourceTerminal.parentElement)) {
                    me.hideTerminals(element);
                  }
                }
                /**
                 * Remove hover styling when mouse leaves terminal. Also hides terminals when mouse leaves one it and not creating a dependency.
                 * @private
                 */

              }, {
                key: "onTerminalMouseOut",
                value: function onTerminalMouseOut(event) {
                  var me = this,
                      el = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].up(event.target, me.view.eventSelector);

                  if (!_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].isDescendant(el, me.showingTerminalsFor) && (!me.creationData || el !== me.creationData.sourceTerminal.parentElement)) {
                    me.hideTerminals(el);
                    me.view.unhover(event);
                  }
                }
                /**
                 * Start creating a dependency when mouse is pressed over terminal
                 * @private
                 */

              }, {
                key: "onTerminalMouseDown",
                value: function onTerminalMouseDown(event) {
                  // ignore non-left button clicks
                  if (event.button === 0) {
                    var me = this,
                        view = me.view,
                        timeAxisSubGridElement = view.timeAxisSubGridElement,
                        terminal = event.target,
                        element = terminal.parentElement.closest(view.eventSelector),
                        viewBounds = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(view.element, document.body);

                    event.preventDefault();
                    event.stopPropagation();
                    me.creationData = {
                      source: view.resolveTimeSpanRecord(element),
                      sourceTerminal: terminal,
                      startPoint: _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(terminal, timeAxisSubGridElement).center,
                      startX: event.pageX - viewBounds.x + view.scrollLeft,
                      startY: event.pageY - viewBounds.y + view.scrollTop,
                      valid: false
                    };

                    if (view.resolveResourceRecord) {
                      me.creationData.sourceResource = view.resolveResourceRecord(element);
                    }

                    me.mouseDetacher = _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
                      mouseup: {
                        element: document.body,
                        handler: 'onMouseUp'
                      },
                      mousemove: {
                        element: timeAxisSubGridElement,
                        handler: 'onMouseMove'
                      },
                      thisObj: me
                    });
                  }
                }
                /**
                 * Update connector line showing dependency between source and target when mouse moves. Also check if mouse is over a valid
                 * target terminal
                 * @private
                 */

              }, {
                key: "onMouseMove",
                value: function onMouseMove(event) {
                  var me = this,
                      view = me.view,
                      data = me.creationData,
                      viewBounds = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_13__["default"].from(view.element, document.body),
                      deltaX = event.pageX - viewBounds.x + view.scrollLeft - data.startX,
                      deltaY = event.pageY - viewBounds.y + view.scrollTop - data.startY,
                      length = Math.round(Math.sqrt(deltaX * deltaX + deltaY * deltaY)) - 3,
                      angle = Math.atan2(deltaY, deltaX);

                  if (!me.connector) {
                    /**
                     * Fired on the owning Scheduler/Gantt before a dependency creation drag operation starts. Return false to prevent it
                     * @event beforeDependencyCreateDrag
                     * @param {object} data
                     */
                    if (view.trigger('beforeDependencyCreateDrag', {
                      data: me.creationData
                    }) === false) {
                      me.abort();
                      return;
                    }

                    me.createConnector(data.startPoint.x, data.startPoint.y);
                    /**
                     * Fired on the owning Scheduler/Gantt when a dependency creation drag operation starts
                     * @event dependencyCreateDragStart
                     * @param {object} data
                     */

                    view.trigger('dependencyCreateDragStart', {
                      data: me.creationData
                    });
                  }

                  me.connector.style.width = "".concat(length, "px");
                  me.connector.style.transform = "rotate(".concat(angle, "rad)");

                  if (event.target.matches(".".concat(me.terminalCls)) && event.target !== data.sourceTerminal) {
                    data.targetTerminal = event.target;
                    data.target = view.resolveTimeSpanRecord(event.target);

                    if (view.resolveResourceRecord) {
                      data.targetResource = view.resolveResourceRecord(event.target);
                    }

                    var fromSide = data.sourceTerminal.dataset.side,
                        toSide = data.targetTerminal.dataset.side,
                        updateValidity = function updateValidity(valid) {
                      data.valid = valid;
                      event.target.classList.add(valid ? 'b-valid' : 'b-invalid');
                      me.connector.classList.add(valid ? 'b-valid' : 'b-invalid');
                    };

                    var type; // NOTE: Top/Bottom sides are not taken into account due to
                    //       scheduler doesn't check for type value anyway, whereas
                    //       gantt will reject any other dependency types undefined in
                    //       DependencyBaseModel.Type enumeration.

                    switch (true) {
                      case fromSide === 'left' && toSide === 'left':
                        type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_17__["default"].Type.StartToStart;
                        break;

                      case fromSide === 'left' && toSide === 'right':
                        type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_17__["default"].Type.StartToEnd;
                        break;

                      case fromSide === 'right' && toSide === 'left':
                        type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_17__["default"].Type.EndToStart;
                        break;

                      case fromSide === 'right' && toSide === 'right':
                        type = _model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_17__["default"].Type.EndToEnd;
                        break;
                    }

                    data.valid = view.dependencyStore.isValidDependency(data.source.id, data.target.id, type); // Promise is returned when using the engine

                    if (data.valid instanceof Promise) {
                      data.valid.then(updateValidity);
                    } else {
                      updateValidity(data.valid);
                    }
                  } else {
                    data.target = data.targetTerminal = null;
                    data.valid = false;
                    me.connector.classList.remove('b-valid');
                    me.connector.classList.remove('b-invalid');
                  }

                  me.lastMouseMoveEvent = event;
                }
                /**
                 * Create a new dependency if mouse release over valid terminal. Hides connector
                 * @private
                 */

              }, {
                key: "onMouseUp",
                value: function onMouseUp(event) {
                  var me = this,
                      data = me.creationData,
                      target = event.target; // TODO: should call finalize and allow user to hook it (as in EventDrag, EventResize)

                  if (data.valid && target.matches(".".concat(me.terminalCls))) {
                    data.targetTerminal = target;
                    me.createDependency();
                    data.valid = true;
                    /**
                     * Fired on the owning Scheduler/Gantt when a dependency drag creation operation succeeds
                     * @event dependencyCreateDrop
                     * @param {object} data
                     */

                    me.view.trigger('dependencyCreateDrop', {
                      data: data
                    });
                  } else {
                    data.valid = false;
                  }
                  /**
                   * Fired on the owning Scheduler/Gantt after a dependency drag creation operation finished, no matter to outcome
                   * @event afterDependencyCreateDrop
                   * @param {object} data
                   */


                  me.view.trigger('afterDependencyCreateDrop', {
                    data: data
                  });
                  me.abort();
                }
                /**
                 * Aborts dependency creation, removes proxy and cleans up listeners
                 */

              }, {
                key: "abort",
                value: function abort() {
                  var me = this,
                      view = me.view,
                      creationData = me.creationData; // Remove terminals from source and target events.

                  if (creationData) {
                    var source = creationData.source,
                        sourceResource = creationData.sourceResource,
                        target = creationData.target,
                        targetResource = creationData.targetResource;

                    if (source) {
                      var el = view.getElementFromEventRecord(source, sourceResource);

                      if (el) {
                        me.hideTerminals(el);
                      }
                    }

                    if (target) {
                      var _el = view.getElementFromEventRecord(target, targetResource);

                      if (_el) {
                        me.hideTerminals(_el);
                      }
                    }
                  }

                  me.creationData = null;
                  me.mouseDetacher && me.mouseDetacher();
                  me.removeConnector();
                } //endregion
                //region Connector

                /**
                 * Creates a connector line that visualizes dependency source & target
                 * @private
                 */

              }, {
                key: "createConnector",
                value: function createConnector(x, y) {
                  var me = this,
                      view = me.view;
                  me.connector = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createElement({
                    parent: view.timeAxisSubGridElement,
                    className: "".concat(me.baseCls, "-connector"),
                    style: "left:".concat(x, "px;top:").concat(y, "px")
                  });
                  view.element.classList.add('b-creating-dependency');

                  if (me.showCreationTooltip) {
                    if (me.creationTooltip) {
                      me.creationTooltip.show();
                    } else {
                      me.creationTooltip = new _Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_14__["default"](Object.assign({
                        id: "".concat(view.id, "-dependency-drag-tip"),
                        cls: 'b-sch-dependency-creation-tooltip',
                        autoShow: true,
                        anchorToTarget: false,
                        trackMouse: true,
                        // Do not constrain at all, want it to be able to go outside of the viewport to not get in the way
                        constrainTo: null,
                        onBeforeAlign: function onBeforeAlign(e) {
                          return me.updateTipContent(e.source, me.creationData);
                        },
                        header: {
                          dock: 'right'
                        }
                      }, me.creationTooltip || {}));
                    }
                  }

                  view.scrollManager.startMonitoring({
                    element: view.timeAxisSubGridElement,
                    callback: function callback() {
                      return me.creationData && me.lastMouseMoveEvent && me.onMouseMove(me.lastMouseMoveEvent);
                    },
                    thisObj: me
                  });
                }
                /**
                 * Remove connector
                 * @private
                 */

              }, {
                key: "removeConnector",
                value: function removeConnector(callback) {
                  var me = this,
                      connector = me.connector,
                      view = me.view;

                  if (connector) {
                    connector.classList.add('b-removing');
                    connector.style.width = '0';
                    me.setTimeout(function () {
                      connector.remove();
                      me.connector = null;

                      if (callback) {
                        callback.call(me);
                      }
                    }, 200);
                  }

                  view.element.classList.remove('b-creating-dependency');
                  me.creationTooltip && me.creationTooltip.hide();
                  view.scrollManager.stopMonitoring(view.timeAxisSubGridElement);
                } //endregion
                //region Terminals

                /**
                 * Show terminals for specified event at sides defined in #terminalSides.
                 * @param {Scheduler.model.TimeSpan} timeSpanRecord Event/task to show terminals for
                 * @param {HTMLElement} element Event/task element
                 */

              }, {
                key: "showTerminals",
                value: function showTerminals(timeSpanRecord, element) {
                  var me = this;

                  if (!me.isCreateAllowed) {
                    return;
                  }

                  var cls = me.terminalCls,
                      terminalsVisibleCls = "".concat(cls, "s-visible"); // We operate on the event bar, not the wrap

                  element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].down(element, me.view.eventInnerSelector); // bail out if terminals already shown or if view is readonly
                  // do not draw new terminals if we are resizing event

                  if (element.classList.contains(terminalsVisibleCls) || this.view.element.classList.contains('b-resizing-event') || me.view.readOnly) return; // create terminals for desired sides

                  me.terminalSides.forEach(function (side) {
                    var terminal = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createElement({
                      parent: element,
                      className: "".concat(cls, " ").concat(cls, "-").concat(side),
                      dataset: {
                        side: side,
                        feature: true
                      }
                    });

                    terminal.detacher = _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].on({
                      element: terminal,
                      mouseout: 'onTerminalMouseOut',
                      mousedown: {
                        handler: 'onTerminalMouseDown',
                        capture: true
                      },
                      thisObj: me
                    });
                  });
                  element.classList.add(terminalsVisibleCls);
                  timeSpanRecord.cls.add(terminalsVisibleCls);
                  me.showingTerminalsFor = element;
                }
                /**
                 * Hide terminals for specified event
                 * @param {HTMLElement} eventElement Event element
                 */

              }, {
                key: "hideTerminals",
                value: function hideTerminals(eventElement) {
                  // remove all terminals
                  var me = this,
                      eventParams = me.client.getTimeSpanMouseEventParams(eventElement),
                      timeSpanRecord = eventParams["".concat(this.eventName, "Record")],
                      terminalsVisibleCls = "".concat(me.terminalCls, "s-visible");

                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].forEachSelector(eventElement, ".".concat(me.terminalCls), function (terminal) {
                    terminal.detacher && terminal.detacher();
                    terminal.remove();
                  });

                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].down(eventElement, me.view.eventInnerSelector).classList.remove(terminalsVisibleCls);

                  timeSpanRecord.cls.remove(terminalsVisibleCls);
                  me.showingTerminalsFor = null;
                } //endregion
                //region Dependency creation

                /**
                 * Create a new dependency from source terminal to target terminal
                 * @internal
                 */

              }, {
                key: "createDependency",
                value: function createDependency() {
                  var me = this,
                      data = me.creationData,
                      source = data.source,
                      target = data.target,
                      fromSide = data.sourceTerminal.dataset.side,
                      toSide = data.targetTerminal.dataset.side,
                      type = (fromSide === 'left' ? 0 : 2) + (toSide === 'right' ? 1 : 0);
                  me.store.add({
                    from: source.id,
                    to: target.id,
                    type: type,
                    fromSide: fromSide,
                    toSide: toSide
                  });
                } //endregion
                //region Tooltip

                /**
                 * Update dependency creation tooltip
                 * @private
                 */

              }, {
                key: "updateTipContent",
                value: function updateTipContent(tip, data) {
                  var me = this;
                  var valid = data.valid;
                  Object.assign(data, {
                    fromText: data.source.name,
                    toText: data.target ? data.target.name : '',
                    fromSide: data.sourceTerminal.dataset.side,
                    toSide: data.targetTerminal ? data.targetTerminal.dataset.side : ''
                  });
                  var tipTitleIconClsSuffix, tipTitleText; // Promise, when using engine

                  if (valid instanceof Promise) {
                    tip.element.classList.remove('b-invalid');
                    tip.element.classList.add('b-checking');
                    tipTitleIconClsSuffix = 'checking';
                    tipTitleText = me.L('Checking');
                    valid.then(function (valid) {
                      data.valid = valid;

                      if (!tip.isDestroyed) {
                        me.updateTipContent(tip, data);
                      }
                    });
                  } // Valid
                  else if (valid === true) {
                      tip.element.classList.remove('b-invalid');
                      tip.element.classList.remove('b-checking');
                      tipTitleIconClsSuffix = 'valid';
                      tipTitleText = me.L('valid');
                    } // Invalid
                    else {
                        tip.element.classList.remove('b-checking');
                        tip.element.classList.add('b-invalid');
                        tipTitleIconClsSuffix = 'invalid';
                        tipTitleText = me.L('invalid');
                      }

                  tip.titleElement.innerHTML = "<i class=\"b-icon b-icon-".concat(tipTitleIconClsSuffix, "\"></i>").concat(tipTitleText);
                  tip.html = "<table class=\"b-sch-dependency-creation-tooltip\">\n                        <tr><td>".concat(me.L('from'), ": </td><td>").concat(data.fromText, "</td><td><div class=\"b-sch-box b-").concat(data.fromSide, "\"></div></td></tr>\n                        <tr><td>").concat(me.L('to'), ": </td><td>").concat(data.toText, "</td><td><div class=\"b-sch-box b-").concat(data.toSide, "\"></div></td></tr>\n                    </table>");
                } //endregion

              }, {
                key: "allowCreate",
                set: function set(value) {
                  this._allowCreate = value;
                  this.updateCreateListeners();
                },
                get: function get() {
                  return this._allowCreate;
                }
              }, {
                key: "isCreateAllowed",
                get: function get() {
                  return this.allowCreate && !this.view.readOnly && !this.disabled;
                }
              }], [{
                key: "defaultConfig",
                //region Config
                get: function get() {
                  return {
                    /**
                     * `false` to not show a tooltip while creating a dependency
                     * @config {Boolean}
                     * @default
                     */
                    showCreationTooltip: true,

                    /**
                     * A tooltip config object that will be applied to the dependency creation tooltip
                     * @config {Object}
                     */
                    creationTooltip: null,

                    /**
                     * CSS class used for terminals
                     * @config {String}
                     * @default
                     */
                    terminalCls: 'b-sch-terminal',

                    /**
                     * Where (at events borders) to display terminals
                     * @config {String[]}
                     * @default
                     */
                    terminalSides: ['left', 'top', 'right', 'bottom'],

                    /**
                     * Set to `false` to not allow creating dependencies
                     * @config {Boolean}
                     * @default
                     */
                    allowCreate: true
                  };
                }
              }]);

              return DependencyCreation;
            }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__["default"])(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_11__["default"]))
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/localization/En.js":
      /*!******************************************!*\
        !*** ./lib/Scheduler/localization/En.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerLocalizationEnJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../../Common/localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");
        /* harmony import */


        var _Common_localization_En_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../../Common/localization/En.js */
        "../Grid/lib/Common/localization/En.js");

        var productName = 'scheduler'; // extends locale from grid
        //const locale = Object.assign(gridLocale, {

        var locale = {
          ExcelExporter: {
            'No resource assigned': 'No resource assigned'
          },
          ResourceInfoColumn: {
            eventCountText: function eventCountText(data) {
              return data + ' event' + (data !== 1 ? 's' : '');
            }
          },
          Dependencies: {
            from: 'From',
            to: 'To',
            valid: 'Valid',
            invalid: 'Invalid',
            Checking: 'Checking…'
          },
          DependencyEdit: {
            From: 'From',
            To: 'To',
            Type: 'Type',
            Lag: 'Lag',
            'Edit dependency': 'Edit dependency',
            Save: 'Save',
            Delete: 'Delete',
            Cancel: 'Cancel',
            StartToStart: 'Start to Start',
            StartToEnd: 'Start to End',
            EndToStart: 'End to Start',
            EndToEnd: 'End to End'
          },
          EventEdit: {
            Name: 'Name',
            Resource: 'Resource',
            Start: 'Start',
            End: 'End',
            Save: 'Save',
            Delete: 'Delete',
            Cancel: 'Cancel',
            'Edit Event': 'Edit event'
          },
          Scheduler: {
            'Add event': 'Add event',
            'Delete event': 'Delete event',
            'Unassign event': 'Unassign event'
          },
          HeaderContextMenu: {
            pickZoomLevel: 'Zoom',
            activeDateRange: 'Date range',
            startText: 'Start date',
            endText: 'End date',
            todayText: 'Today'
          },
          EventFilter: {
            filterEvents: 'Filter tasks',
            byName: 'By name'
          },
          TimeRanges: {
            showCurrentTimeLine: 'Show current timeline'
          },
          PresetManager: {
            minuteAndHour: {
              topDateFormat: 'ddd MM/DD, hA'
            },
            hourAndDay: {
              topDateFormat: 'ddd MM/DD'
            },
            weekAndDay: {
              displayDateFormat: 'hh:mm A'
            }
          }
        }; // cannot use Object.assign above in IE11. also dont want to have polyfill in locale

        for (var i in _Common_localization_En_js__WEBPACK_IMPORTED_MODULE_1__["default"]) {
          locale[i] = _Common_localization_En_js__WEBPACK_IMPORTED_MODULE_1__["default"][i];
        }
        /* harmony default export */


        __webpack_exports__["default"] = locale;

        _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_0__["default"].registerLocale('En', {
          desc: 'English',
          locale: locale
        });
        /***/

      },

      /***/
      "./lib/Scheduler/model/AssignmentModel.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/model/AssignmentModel.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelAssignmentModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return AssignmentModel;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/AssignmentModel
         */

        /**
         * This class represent a single assignment of a resource to an event in scheduler.
         * It is a subclass of {@link Common.data.Model} class.
         * Please refer to the documentation for that class to become familiar with the base interface of this class.
         *
         * An Assignment has the following fields:
         * - `id` - The id of the assignment
         * - `resourceId` - The id of the resource assigned
         * - `eventId` - The id of the event to which the resource is assigned
         *
         * The data source for these fields can be customized by subclassing this class.
         *
         * @extends Common/data/Model
         */

        var AssignmentModel =
        /*#__PURE__*/
        function (_Model) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(AssignmentModel, _Model);

          function AssignmentModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, AssignmentModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(AssignmentModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(AssignmentModel, [{
            key: "getResource",
            // /**
            //  * Returns an event associated with this assignment.
            //  *
            //  * @privateparam  {Scheduler.data.EventStore} [eventStore]
            //  * @return {Scheduler.model.TimeSpan} Event instance
            //  */
            // getEvent(eventStore = this.eventStore) {
            //     // removed assignment will not have "this.joined" so we are providing a way to get an event via provided
            //     // event store
            //     return eventStore && eventStore.getById(this.eventId);
            // }

            /**
             * Returns the resource associated with this assignment.
             *
             * @privateparam {Scheduler.data.ResourceStore} [resourceStore]
             * @return {Scheduler.model.ResourceModel} Instance of resource
             */
            value: function getResource() {
              var resourceStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.resourceStore; // removed assignment will not have "this.joined" so we are providing a way to get a resource via provided
              // resource store

              return resourceStore && resourceStore.getById(this.resourceId);
            } // /**
            //  * Convenience method to get a name of the associated event.
            //  *
            //  * @privateparam  {Scheduler.data.EventStore} [eventStore]
            //  * @return {String} name
            //  */
            // getEventName(eventStore) {
            //     const evnt = this.getEvent(eventStore);
            //     return evnt && evnt.name || '';
            // }
            // /**
            //  * Convenience method to get a name of the associated resource.
            //  *
            //  * @privateparam {Scheduler.data.ResourceStore} [resourceStore]
            //  * @return {String} name
            //  */
            // getResourceName(resourceStore) {
            //     const resource = this.getResource(resourceStore);
            //     return resource && resource.name || '';
            // }
            //endregion
            // Convenience getter to not have to check `instanceof AssignmentModel`

          }, {
            key: "fullCopy",
            value: function fullCopy() {
              // NOT IMPLEMENTED
              //return this.copy.apply(this, arguments);
              throw new Error('Not implemented');
            } // private

          }, {
            key: "assignmentStore",
            //endregion
            //region Stores

            /**
             * Returns an assigment store this assignment is part of. Assignment must be part of an assigment store
             * to be able to retrieve it.
             *
             * @return {Scheduler.data.AssignmentStore}
             */
            get: function get() {
              return this.stores && this.stores[0];
            }
            /**
             * Returns an event store this assignment uses as default event store. Assignment must be part
             * of an assignment store to be able to retrieve default event store.
             *
             * @return {Scheduler.data.EventStore}
             */

          }, {
            key: "eventStore",
            get: function get() {
              var assignmentStore = this.assignmentStore;
              return assignmentStore && assignmentStore.eventStore;
            }
            /**
             * Returns a resource store this assignment uses as default resource store. Assignment must be part
             * of an assignment store to be able to retrieve default resource store.
             *
             * @return {Scheduler.data.ResourceStore}
             */

          }, {
            key: "resourceStore",
            get: function get() {
              var eventStore = this.eventStore;
              return eventStore && eventStore.resourceStore;
            } //endregion
            //region Event & resource

            /**
             * Convenience property to get the name of the associated event.
             * @property {String}
             * @readonly
             */

          }, {
            key: "eventName",
            get: function get() {
              return this.event && this.event.name;
            }
            /**
             * Convenience property to get the name of the associated resource.
             * @property {String}
             * @readonly
             */

          }, {
            key: "resourceName",
            get: function get() {
              return this.resource && this.resource.name;
            }
          }, {
            key: "isAssignment",
            get: function get() {
              return true;
            }
            /**
             * Returns true if the Assignment can be persisted (e.g. task and resource are not 'phantoms')
             *
             * @return {Boolean} true if this model can be persisted to server.
             */

          }, {
            key: "isPersistable",
            get: function get() {
              var event = this.event,
                  resource = this.resource;
              return this.isValid && !event.hasGeneratedId && !resource.hasGeneratedId;
            }
          }, {
            key: "isValid",
            get: function get() {
              return this.resource != null && this.event != null;
            }
          }, {
            key: "eventResourceCompositeKey",
            get: function get() {
              return AssignmentModel.makeAssignmentEventResourceCompositeKey(this.eventId, this.resourceId);
            }
          }], [{
            key: "makeAssignmentEventResourceCompositeKey",
            value: function makeAssignmentEventResourceCompositeKey(eventId, resourceId) {
              return "event(".concat(eventId, ")-resource(").concat(resourceId, ")");
            }
          }, {
            key: "fields",
            //region Fields
            get: function get() {
              return [
              /**
               * Id for the resource assigned
               * @field {String|Number} resourceId
               */
              {
                name: 'resourceId'
              },
              /**
               * Id for the event assigned
               * @field {String|Number} eventId
               */
              {
                name: 'eventId'
              }];
            }
          }, {
            key: "relationConfig",
            get: function get() {
              return [
              /**
               * Resource assigned
               * @member {Scheduler.model.ResourceModel} resource
               */
              {
                relationName: 'resource',
                fieldName: 'resourceId',
                store: 'resourceStore',
                collectionName: 'assignments'
              },
              /**
               * Event assigned
               * @member {Scheduler.model.EventModel} event
               */
              {
                relationName: 'event',
                fieldName: 'eventId',
                store: 'eventStore',
                collectionName: 'assignments'
              }];
            }
          }]);

          return AssignmentModel;
        }(_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        AssignmentModel.exposeProperties();
        AssignmentModel._$name = 'AssignmentModel';
        /***/
      },

      /***/
      "./lib/Scheduler/model/CalendarDayModel.js":
      /*!*************************************************!*\
        !*** ./lib/Scheduler/model/CalendarDayModel.js ***!
        \*************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelCalendarDayModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return CalendarDayModel;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/CalendarDayModel
         */

        /**
         * A model representing a single day in the calendar. Depending on the `type` field, day may be a concrete day per se (2012/01/01),
         * a certain weekday (all Thursdays), or an override for all certain weekdays in the timeframe
         * (all Fridays between 2012/01/01 - 2012/01/15, inclusive).
         *
         * A collection of CalendarDayModel instances to be provided for the {@link Scheduler.data.Calendar calendar}
         *
         * @extends Common/data/Model
         */

        var CalendarDayModel =
        /*#__PURE__*/
        function (_Model) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CalendarDayModel, _Model);

          function CalendarDayModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, CalendarDayModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(CalendarDayModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(CalendarDayModel, [{
            key: "clearDate",

            /**
             * Clears the date for this day
             */
            value: function clearDate() {
              this.set('date', null);
            } // needed since you cannot override setter only

          }, {
            key: "getAvailability",

            /**
             * This method returns the availability for this day. By default it will decode an array of strings '08:00-12:00' to
             * an array of objects like:
             * ```javascript
             * {
             *    startTime       : new Date(0, 0, 0, 8),
             *    endTime         : new Date(0, 0, 0, 12)
             * }
             * ```
             * You can pass the "asString" flag to disable that and just return strings.
             *
             * @param {Boolean} asString Whether to just return an array of strings, instead of objects.
             * @return {Object[]|String[]} Array of objects with "startTime", "endTime" properties.
             */
            value: function getAvailability(asString) {
              var me = this; // Return the raw availability array with strings

              if (asString) return me.get('availability');
              if (me.availabilityCache) return me.availabilityCache;
              var parsed = me.get('availability').map(function (value) {
                return typeof value === 'string' ? me.parseInterval(value) : value;
              });
              me.verifyAvailability(parsed);
              return me.availabilityCache = parsed;
            }
          }, {
            key: "verifyAvailability",
            value: function verifyAvailability(intervals) {
              var me = this;
              intervals.sort(function (a, b) {
                return a.startTime - b.startTime;
              });
              intervals.forEach(function (interval, i) {
                if (interval.startTime > interval.endTime) {
                  throw new Error("Start time ".concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].format(interval.startTime, 'HH:mm'), " is greater than end time ").concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].format(interval.endTime, 'HH:mm')));
                }

                if (i > 0 && intervals[i - 1].endTime > interval.startTime) {
                  throw new Error("Availability intervals should not intersect: [".concat(me.stringifyInterval(intervals[i - 1]), "] and [").concat(me.stringifyInterval(interval), "]"));
                }
              });
            } //prependZero(value) {
            //    return value < 10 ? '0' + value : value;
            //}

          }, {
            key: "stringifyInterval",
            value: function stringifyInterval(interval) {
              var startTime = interval.startTime,
                  endTime = interval.endTime;
              return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].format(startTime, 'HH:mm') + '-' + _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].format(endTime, 'HH:mm'); //return this.prependZero(startTime.getHours()) + ':' + this.prependZero(startTime.getMinutes()) + '-' +
              //    (endTime.getDate() == 1 ? 24 : this.prependZero(endTime.getHours())) + ':' + this.prependZero(endTime.getMinutes());
            }
          }, {
            key: "stringifyIntervals",
            value: function stringifyIntervals(intervals) {
              var me = this;
              return intervals.map(function (interval) {
                return typeof interval === 'string' ? interval : me.stringifyInterval(interval);
              });
            }
          }, {
            key: "parseInterval",
            value: function parseInterval(string) {
              var match = /(\d\d):(\d\d)-(\d\d):(\d\d)/.exec(string);
              if (!match) throw new Error("Invalid format for availability string: ".concat(String, ". It should have exact format: hh:mm-hh:mm"));
              return {
                startTime: new Date(0, 0, 0, match[1], match[2]),
                endTime: new Date(0, 0, 0, match[3], match[4])
              };
            }
            /**
             * Returns the total length of all availability intervals for this day in hours.
             *
             * @property {Number}
             * @readonly
             */

          }, {
            key: "addAvailabilityInterval",

            /**
             * Adds a new availability interval to this day. Both arguments should have the same format.
             *
             * @param {Date|String} startTime Start time of the interval. Can be a Date object (new Date(0, 0, 0, 8)) or just a plain string: '08'
             * @param {Date|String} endTime End time of the interval. Can be a Date object (new Date(0, 0, 0, 12)) or just a plain string: '12'
             */
            value: function addAvailabilityInterval(startTime, endTime) {
              var interval;

              if (startTime instanceof Date) {
                interval = {
                  startTime: startTime,
                  endTime: endTime
                };
              } else {
                interval = this.parseInterval(startTime + (endTime ? '-' + endTime : ''));
              }

              var intervals = this.getAvailability().concat(interval);
              this.verifyAvailability(intervals);
              this.setAvailability(intervals);
            }
            /**
             * Removes the availability interval by its index.
             *
             * @param {Number} index Ordinal position of the interval to be removed
             */

          }, {
            key: "removeAvailabilityInterval",
            value: function removeAvailabilityInterval(index) {
              var intervals = this.getAvailability();
              intervals.splice(index, 1);
              this.setAvailability(intervals);
            }
            /**
             * Applies the availability intervals to a concrete day. For example the availability intervals [ '08:00-12:00', '13:00-17:00' ],
             * applied to a day 2012/01/01 will return the following result:
             * ```javascript
             * [
             * {
             *     startDate       : new Date(2012, 0, 1, 8),
             *     endDate         : new Date(2012, 0, 1, 12)
             * },
             * {
             *     startDate       : new Date(2012, 0, 1, 13),
             *     endDate         : new Date(2012, 0, 1, 17)
             * }
             * ]
             * ```
             * @param {Date} timeDate The date to apply the intervals to
             * @returns {Object[]} Array of objects with "startDate / endDate" properties.
             */

          }, {
            key: "getAvailabilityIntervalsFor",
            value: function getAvailabilityIntervalsFor(timeDate) {
              timeDate = typeof timeDate === 'number' ? new Date(timeDate) : timeDate;
              var year = timeDate.getFullYear(),
                  month = timeDate.getMonth(),
                  date = timeDate.getDate();
              return this.getAvailability().map(function (interval) {
                var endDate = interval.endTime.getDate();
                return {
                  startDate: new Date(year, month, date, interval.startTime.getHours(), interval.startTime.getMinutes()),
                  endDate: new Date(year, month, date + (endDate == 1 ? 1 : 0), interval.endTime.getHours(), interval.endTime.getMinutes())
                };
              });
            }
            /**
             * Returns the earliest available time for the given date. If this day has no availability intervals it returns `null`.
             *
             * @param {Date} timeDate The date to get the earliest availability time for.
             * @return {Date}
             */

          }, {
            key: "getAvailabilityStartFor",
            value: function getAvailabilityStartFor(timeDate) {
              var intervals = this.getAvailabilityIntervalsFor(timeDate);
              if (!intervals.length) return null;
              return intervals[0].startDate;
            }
            /**
             * Returns the latest available time for the given date. If this day has no availability intervals, it returns `null`.
             *
             * @param {Date} timeDate The date to get the latest availability time for.
             * @return {Date}
             */

          }, {
            key: "getAvailabilityEndFor",
            value: function getAvailabilityEndFor(timeDate) {
              var intervals = this.getAvailabilityIntervalsFor(timeDate);
              if (!intervals.length) return null;
              return intervals[intervals.length - 1].endDate;
            }
          }, {
            key: "date",
            set: function set(date) {
              if (date) date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].startOf(date, 'day');
              this.set('date', date);
            },
            get: function get() {
              return this.get('date');
            }
          }, {
            key: "availability",
            get: function get() {
              return this.get('availability');
            },
            set: function set(intervals) {
              // clear cache
              this.availabilityCache = null;
              this.set('availability', this.stringifyIntervals(intervals)); // to trigger the `verifyAvailability`

              this.getAvailability();
            }
          }, {
            key: "totalHours",
            get: function get() {
              return this.getTotalMS() / 1000 / 60 / 60;
            }
            /**
             * Returns the total length of all availability intervals for this day in milliseconds.
             *
             * @property {Number}
             * @readonly
             */

          }, {
            key: "totalMS",
            get: function get() {
              return this.getAvailability().reduce(function (totalMS, interval) {
                return totalMS += interval.endTime - interval.startTime;
              }, 0);
            }
          }], [{
            key: "fields",
            get: function get() {
              return [
              /**
               * The id of the date. Can be an arbitrary unique value, assigned by the server
               * @field {String|Number} id
               */

              /**
               * The date for this day in the ISO 8601 format. Any time information in this field will be cleared. If this
               * instance represents a weekday or week override, this field will be ignored.
               * @field {String|Date} date
               */
              {
                name: 'date',
                type: 'date',
                format: 'YYYY-MM-DD',
                persist: true
              },
              /**
               * The index of the week day (0 - Sunday, 1 - Monday and so on) if this instance contains information about the week day (applicable for `WEEKDAY` and `WEEKDAYOVERRIDE`).
               * Should be set to -1 for the "main" instance of the week overrides.
               * @field {Number} weekday
               */
              {
                name: 'weekday',
                type: 'int'
              },
              /**
               * The start date of the timespan for week day override.
               * @field {Date} overrideStartDate
               */
              {
                name: 'overrideStartDate',
                type: 'date',
                dateFormat: 'YYYY-MM-DD'
              },
              /**
               * The end date of the timespan for week day override.
               * @field {Date} overrideEndDate
               */
              {
                name: 'overrideEndDate',
                type: 'date',
                dateFormat: 'YYYY-MM-DD'
              },
              /**
               * The type of this calendar day. Can be one of the following `DAY`, `WEEKDAY`, `WEEKDAYOVERRIDE`:
               * - Default value is `DAY` meaning this day represents a "real" day in the calendar (2012/01/01 for example) and contains availability information for that particular day only.
               * The date is stored in the `Date` field.
               * - The `WEEKDAY` value means calendar day contains information about all weekdays with the index, given in the `Weekday` field (0 - Sunday, 1 - Monday and so on).
               * For example - all Fridays. `Date` field is ignored.
               * - <p>The `WEEKDAYOVERRIDE` value means calendar day contains information about all weekdays within certain timespan. For example - all Fridays between 2012/01/01 - 2012/01/15.
               * Week day index should be stored in the `Weekday` field again, beginning of the timespan - in the `OverrideStartDate` field and the end of timespan - in the `OverrideEndDate`.
               * </p>
               * <p>
               * A single day instance contains the override for a single week day. So, to define overrides for several days (Monday and Tuesday for example) - add an additional instance
               * to the calendar with the same `Name/OverrideStartDate/OverrideEndDate` values. There's no need to define an override for every weekday - if some day is not defined - the
               * default availability will be used.
               * </p>
               * <p>
               * * **Note** Every week override should also have a "main" calendar day instance, representing the override itself. It should have the same
               * values for `Name/OverrideStartDate/OverrideEndDate` fields and -1 for `Weekday`. Also, the timespans of all week overrides should not intersect.
               * </p>
               * <p>
               * To avoid manual creation of week overrides you can use the calendar API (for example, {@link Scheduler.data.Calendar#function-addNonStandardWeek addNonStandardWeek},
               * {@link Scheduler.data.Calendar#function-removeNonStandardWeek removeNonStandardWeek} methods).
               * </p>
               * @field {String} type
               * @default 'DAY'
               */
              {
                name: 'type',
                defaultValue: 'DAY' // 'DAY', 'WEEKDAY', 'WEEKDAYOVERRIDE'

              },
              /**
               * Optional boolean flag, allowing you to specify exceptions - working days which falls on weekends. Default value is `false`. **Please note**, that simply setting this
               * field to "true" is not enough - you also need to specify the exact hours that are available for work with the `Availability` field (see below).
               * @field {Boolean} isWorkingDay
               * @default false
               */
              {
                name: 'isWorkingDay',
                type: 'boolean',
                defaultValue: false
              },
              /**
               * Optional name of the CSS class, which can be used by various plugins working with weekends and holidays.
               * Default value is `gnt-holiday` If a holiday lasts for several days, then all days should have the same
               * `cls` value.
               * @field {String} cls
               */
              {
                name: 'cls' //,
                //defaultValue : 'b-sch-nonworkingtime'

              },
              /**
               * Optional name of the day (holiday name for example)
               * @field {String} name
               */
              {
                name: 'name'
              },
              /**
               * Availability information for this day. Should be an array of strings or objects, containing the hourly
               * availability for this day. Strings should have the following format:
               * ```javascript
               * // two working intervals
               * [ '08:00-12:00', '13:00-17:00' ]
               *
               * // whole 24 hours are available
               * [ '00:00-24:00' ]
               * ```
               * Objects:
               * ```
               * [{
               *    startTime       : new Date(0, 0, 0, 8),
               *    endTime         : new Date(0, 0, 0, 12)
               * }]
               * ```
               * **Please note**, that this field overrides `isWorkingDay` - for example, a day with
               * "isWorkingDay : false" and "Availability : [ '08:00-12:00' ]" - will be considered a working day.
               * @field {String[]|Object[]} availability
               */
              {
                name: 'availability',
                persist: true //,
                // convert : function(value, record) {
                //     if (value) {
                //         return typeof value === 'string' ? [value] : value;
                //     } else {
                //         return [];
                //     }
                // }

              }];
            }
          }]);

          return CalendarDayModel;
        }(_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        CalendarDayModel._$name = 'CalendarDayModel';
        /***/
      },

      /***/
      "./lib/Scheduler/model/DependencyBaseModel.js":
      /*!****************************************************!*\
        !*** ./lib/Scheduler/model/DependencyBaseModel.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelDependencyBaseModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DependencyBaseModel;
        });
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find-index */
        "./node_modules/core-js/modules/es6.array.find-index.js");
        /* harmony import */


        var core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find_index__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "./node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");
        /* harmony import */


        var _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/DependencyBaseModel
         */

        var canonicalDependencyTypes = ['SS', 'SF', 'FS', 'FF'];
        /**
         * Base class used for both Ext Scheduler and Ext Gantt. Not intended to be used directly
         *
         * @extends Common/data/Model
         */

        var DependencyBaseModel =
        /*#__PURE__*/
        function (_Model) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(DependencyBaseModel, _Model);

          function DependencyBaseModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, DependencyBaseModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(DependencyBaseModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(DependencyBaseModel, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(data) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(DependencyBaseModel.prototype), "construct", this).apply(this, arguments);

              if (data) {
                // Allow passing in event instances too
                if (data.from && data.from instanceof _TimeSpan_js__WEBPACK_IMPORTED_MODULE_12__["default"]) {
                  this.setSourceEvent(data.from);
                  delete data.from;
                }

                if (data.to && data.to instanceof _TimeSpan_js__WEBPACK_IMPORTED_MODULE_12__["default"]) {
                  this.setTargetEvent(data.to);
                  delete data.to;
                }
              }
            } //endregion

          }, {
            key: "getHardType",

            /**
             * Returns dependency hard type, see {@link #property-hardType}.
             *
             * @return {Number}
             */
            value: function getHardType() {
              return this.get('type');
            }
            /**
             * Sets dependency {@link #field-type} and resets {@link #field-fromSide} and {@link #field-toSide} to null.
             *
             * @param {Number} type
             */

          }, {
            key: "setHardType",
            value: function setHardType(type) {
              var result;

              if (type !== this.getHardType()) {
                result = this.set({
                  type: type,
                  fromSide: null,
                  toSide: null
                });
              }

              return result;
            }
          }, {
            key: "setLag",

            /**
             * Sets lag and lagUnit in one go. Only allowed way to change lagUnit, the lagUnit field is
             * readonly after creation
             * @param {Number|String|Object} lag The lag value. May be just a numeric magnitude, or a full string descriptor eg '1d'
             * @param {String} [lagUnit] Unit for numeric lag value, see {@link #field-lagUnit} for valid values
             */
            value: function setLag(lag, lagUnit) {
              // Either they're only setting the magnitude
              // or, if it's a string, parse the full duration.
              if (arguments.length === 1) {
                if (typeof lag === 'number') {
                  this.lag = lag;
                } else {
                  lag = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].parseDuration(lag);
                  this.set({
                    lag: lag.magnitude,
                    lagUnit: lag.unit
                  });
                }

                return;
              } // Must be a number


              lag = parseFloat(lag);
              this.set({
                lag: lag,
                lagUnit: lagUnit
              });
            }
          }, {
            key: "getLag",
            value: function getLag() {
              if (this.lag) {
                return "".concat(this.lag < 0 ? '-' : '+').concat(Math.abs(this.lag)).concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].getShortNameOfUnit(this.lagUnit));
              }

              return '';
            }
            /**
             * Property which encapsulates the lag's magnitude and units.
             * An object which contains two properties:
             * - magnitude : [Number](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number) The magnitude of the duration.
             * - unit : [String](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String) The unit in which the duration is measured, eg `'d'` for days.
             * @property {Object}
             */

          }, {
            key: "getSourceEvent",

            /**
             * Returns the source event of the dependency
             *
             * @return {Scheduler.model.EventModel} The source event of this dependency
             */
            value: function getSourceEvent() {
              var eventStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.eventStore;
              return eventStore.getById(this.from);
            }
            /**
             * Gets/sets the dependency type
             *
             * @property {Number}
             */

            /**
             * Gets/sets the name of field holding the CSS class for each rendered dependency element
             *
             * @property {String} cls
             */

            /**
             * Returns the target event of the dependency
             *
             * @return {Scheduler.model.EventModel} The target event of this dependency
             */

          }, {
            key: "getTargetEvent",
            value: function getTargetEvent() {
              var eventStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.eventStore;
              return eventStore.getById(this.to);
            }
          }, {
            key: "getDateRange",
            value: function getDateRange() {
              var doNotNormalize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var sourceTask = this.sourceEvent,
                  targetTask = this.targetEvent;

              if (sourceTask && targetTask && sourceTask.isScheduled && targetTask.isScheduled) {
                var Type = DependencyBaseModel.Type,
                    sourceDate,
                    targetDate;

                switch (this.type) {
                  case Type.StartToStart:
                    sourceDate = sourceTask.startDate;
                    targetDate = targetTask.startDate;
                    break;

                  case Type.StartToEnd:
                    sourceDate = sourceTask.startDate;
                    targetDate = targetTask.endDate;
                    break;

                  case Type.EndToEnd:
                    sourceDate = sourceTask.endDate;
                    targetDate = targetTask.endDate;
                    break;

                  case Type.EndToStart:
                    sourceDate = sourceTask.endDate;
                    targetDate = targetTask.startDate;
                    break;
                }

                return {
                  start: doNotNormalize ? sourceDate : _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].min(sourceDate, targetDate),
                  end: doNotNormalize ? targetDate : _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].max(sourceDate, targetDate)
                };
              }

              return null;
            }
            /**
             * Applies given CSS class to dependency, the value doesn't persist
             *
             * @param {String} cls
             */

          }, {
            key: "highlight",
            value: function highlight(cls) {
              var me = this,
                  h = me.highlighted ? me.highlighted.split(' ') : [];
              if (!h.includes(cls)) me.highlighted = h.concat(cls).join(' ');
            }
            /**
             * Removes given CSS class from dependency if applied, the value doesn't persist
             *
             * @param {String} cls
             */

          }, {
            key: "unhighlight",
            value: function unhighlight(cls) {
              var me = this,
                  highlighted = me.highlighted;

              if (highlighted) {
                var h = highlighted.split(' '),
                    idx = h.findIndex(function (i) {
                  return i === cls;
                });

                if (idx >= 0) {
                  h.splice(idx, 1);
                  me.highlighted = h.join(' ');
                }
              }
            }
            /**
             * Checks if the given CSS class is applied to dependency.
             *
             * @param {String} cls
             * @return {Boolean}
             */

          }, {
            key: "isHighlightedWith",
            value: function isHighlightedWith(cls) {
              var me = this,
                  highlighted = me.highlighted;
              return highlighted && highlighted.split(' ').includes(cls);
            }
          }, {
            key: "getConnectorString",
            value: function getConnectorString(raw) {
              var rawValue = canonicalDependencyTypes[this.type];

              if (raw) {
                return rawValue;
              } // FS => empty string; it's the default


              if (this.type === DependencyBaseModel.Type.EndToStart) {
                return '';
              }

              var locale = _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_13__["default"].locale; // See if there is a local version of SS, SF or FF

              if (locale) {
                var localized = locale.Scheduler && locale.Scheduler[rawValue];

                if (localized) {
                  return localized;
                }
              }

              return rawValue;
            }
          }, {
            key: "toString",
            value: function toString() {
              return "".concat(this.from).concat(this.getConnectorString()).concat(this.getLag());
            }
            /**
             * Returns `true` if the dependency is valid. Has valid type and both source and target ids set and not links to itself.
             *
             * @return {Boolean}
             * @typings ignore
             */

          }, {
            key: "isValid",
            value: function isValid(taskStore) {
              var from = this.from,
                  to = this.to,
                  type = this.type;
              return typeof type === 'number' && from && from !== '' && to != null && to !== '' && from !== to;
            }
          }, {
            key: "eventStore",
            get: function get() {
              return this.stores[0].eventStore;
            }
            /**
             * Alias to dependency type, but when set resets {@link #field-fromSide} {@link #field-toSide} to null as well.
             *
             * @property {Number}
             */

          }, {
            key: "hardType",
            get: function get() {
              return this.getHardType();
            },
            set: function set(type) {
              this.setHardType(type);
            }
          }, {
            key: "lag",
            get: function get() {
              return this.get('lag');
            },
            set: function set(lag) {
              if (typeof lag === 'number') {
                this.set({
                  lag: lag
                });
              } else {
                this.setLag(lag);
              }
            }
          }, {
            key: "fullLag",
            get: function get() {
              return {
                unit: this.lagUnit,
                magnitude: this.lag
              };
            },
            set: function set(lag) {
              if (typeof lag === 'string') {
                this.setLag(lag);
              } else {
                this.setLag(lag.magnitude, lag.unit);
              }
            }
            /**
             * Gets/sets the source event of the dependency
             *
             * @property {Scheduler.model.EventModel}
             */

          }, {
            key: "sourceEvent",
            set: function set(event) {
              this.from = event.id;
            }
            /**
             * Gets/sets the target event of the dependency
             *
             * @property {Scheduler.model.EventModel}
             */

          }, {
            key: "targetEvent",
            set: function set(event) {
              this.to = event.id;
            }
            /**
             * Returns true if the linked events have been persisted (e.g. neither of them are 'phantoms')
             *
             * @property {Boolean}
             * @readonly
             */

          }, {
            key: "isPersistable",
            get: function get() {
              var me = this,
                  source = me.getSourceEvent(),
                  target = me.getTargetEvent();
              return source && !source.hasGeneratedId && target && !target.hasGeneratedId;
            }
          }], [{
            key: "Type",
            //region Fields

            /**
             * An enumerable object, containing names for the dependency types integer constants.
             * - 0 StartToStart
             * - 1 StartToEnd
             * - 2 EndToStart
             * - 3 EndToEnd
             * @property {Object}
             * @readonly
             */
            get: function get() {
              return {
                StartToStart: 0,
                StartToEnd: 1,
                EndToStart: 2,
                EndToEnd: 3
              };
            }
          }, {
            key: "fields",
            get: function get() {
              return [// 3 mandatory fields

              /**
               * From event, id of source event
               * @field {String|number} from
               */
              {
                name: 'from'
              },
              /**
               * To event, id of target event
               * @field {String|number} to
               */
              {
                name: 'to'
              },
              /**
               * Dependency type, see static property Type
               * @field {Number} type
               * @default 2
               */
              {
                name: 'type',
                type: 'int',
                defaultValue: 2
              },
              /**
               * CSS class to apply to lines drawn for the dependency
               * @field {String} cls
               */
              {
                name: 'cls',
                defaultValue: ''
              },
              /**
               * Bidirectional, drawn with arrows in both directions
               * @field {Boolean} bidirectional
               */
              {
                name: 'bidirectional',
                type: 'boolean'
              },
              /**
               * Start side on source (top, left, bottom, right)
               * @field {String} fromSide
               */
              {
                name: 'fromSide',
                type: 'string'
              },
              /**
               * End side on target (top, left, bottom, right)
               * @field {String} toSide
               */
              {
                name: 'toSide',
                type: 'string'
              },
              /**
               * The magnitude of this dependency's lag (the number of units).
               * @field {Number} lag
               */
              {
                name: 'lag',
                type: 'number',
                allowNull: true,
                defaultValue: 0
              },
              /**
               * The units of this dependency's lag, defaults to "d" (days). Valid values are:
               *
               * - "ms" (milliseconds)
               * - "s" (seconds)
               * - "m" (minutes)
               * - "h" (hours)
               * - "d" (days)
               * - "w" (weeks)
               * - "M" (months)
               * - "y" (years)
               *
               * This field is readonly after creation, to change lagUnit use #setlag().
               * @field {String} lagUnit
               */
              {
                name: 'lagUnit',
                type: 'string',
                defaultValue: 'd' //{ name : 'highlighted', type : 'string', persist : false }

              }];
            }
          }, {
            key: "relationConfig",
            get: function get() {
              return [{
                relationName: 'sourceEvent',
                fieldName: 'from',
                store: 'eventStore',
                collectionName: 'successors'
              }, {
                relationName: 'targetEvent',
                fieldName: 'to',
                store: 'eventStore',
                collectionName: 'predecessors'
              }];
            }
          }]);

          return DependencyBaseModel;
        }(_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_11__["default"]);

        DependencyBaseModel.exposeProperties();
        DependencyBaseModel._$name = 'DependencyBaseModel';
        /***/
      },

      /***/
      "./lib/Scheduler/model/DependencyModel.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/model/DependencyModel.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelDependencyModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DependencyModel;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./DependencyBaseModel.js */
        "./lib/Scheduler/model/DependencyBaseModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/DependencyModel
         */

        /**
         * This class represents a single Dependency between two events. It is a subclass of the {@link Scheduler.model.DependencyBaseModel}
         * class, which in its turn subclasses {@link Common.data.Model}.
         * Please refer to documentation of those classes to become familiar with the base interface of this class.
         *
         * A Dependency has the following fields:
         *
         * - `id` - The id of the dependency itself
         * - `from` - The id of the event at which the dependency starts
         * - `to` - The id of the event at which the dependency ends
         * - `cls` - A CSS class that will be applied to each rendered dependency DOM element
         * - `type` - An integer constant representing the type of the dependency:
         *   - 0 - start-to-start dependency
         *   - 1 - start-to-end dependency
         *   - 2 - end-to-start dependency
         *   - 3 - end-to-end dependency
         * - `bidirectional` - A boolean indicating if a dependency goes both directions (default false)
         *
         * Subclassing the Dependency class
         * --------------------
         *
         * The name of any fields data source can be customized in the subclass, see the example below. Please also refer to {@link Common.data.Model}
         * for details.
         * @example
         * class MyDependency extends DependencyModel {
         *       static get fields() {
         *           return [
         *               { name: 'to', dataSource: 'targetId' },
         *               { name: 'from', dataSource: 'sourceId' }
         *           ]);
         *       }
         *
         *       ...
         *  }
         *
         * @extends Scheduler/model/DependencyBaseModel
         */

        var DependencyModel =
        /*#__PURE__*/
        function (_DependencyBaseModel) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(DependencyModel, _DependencyBaseModel);

          function DependencyModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, DependencyModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(DependencyModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(DependencyModel, [{
            key: "getTypeFromSides",
            // Determines the type of dependency based on fromSide and toSide
            // TODO: Check with vertical orientation
            value: function getTypeFromSides(fromSide, toSide, rtl) {
              var types = _DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_5__["default"].Type,
                  startSide = rtl ? 'right' : 'left',
                  endSide = rtl ? 'left' : 'right';

              if (fromSide === startSide) {
                return toSide === startSide ? types.StartToStart : types.StartToEnd;
              }

              return toSide === endSide ? types.EndToEnd : types.EndToStart;
            }
          }]);

          return DependencyModel;
        }(_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        DependencyModel.exposeProperties();
        DependencyModel._$name = 'DependencyModel';
        /***/
      },

      /***/
      "./lib/Scheduler/model/EventModel.js":
      /*!*******************************************!*\
        !*** ./lib/Scheduler/model/EventModel.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelEventModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventModel;
        });
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/EventModel
         */

        /**
         * This class represent a single event in your schedule. It is a subclass of the {@link Scheduler.model.TimeSpan}, which is in turn subclass of {@link Common.data.Model}.
         * Please refer to documentation of that class to become familiar with the base interface of the event.
         *
         * The Event model has a few predefined fields as seen below. If you want to add new fields or change the options for the existing fields,
         * you can do that by subclassing this class (see example below).
         *
         * Subclassing the Event model class
         * --------------------
         * ```
         * class MyEvent extends EventModel {
         *
         *     static get fields() {
         *         return [
         *            // Add new field
         *            { name: 'myField', type : 'number', defaultValue : 0 }
         *         ];
         *     },
         *
         *     myCheckMethod() {
         *         return this.myField > 0
         *     },
         *
         *     ...
         * });
         * ```
         * If you in your data want to use other names for the startDate, endDate, resourceId and name fields you can configure
         * them as seen below:
         * ```
         * class MyEvent extends EventModel {
         *
         *     static get fields() {
         *         return [
         *            { name: 'startDate', dataSource 'taskStart', type: 'date', format: 'YYYY-MM-DD' },
         *            { name: 'endDate', dataSource 'taskEnd', type: 'date', format: 'YYYY-MM-DD' },
         *            { name: 'resourceId', dataSource 'userId' },
         *            { name: 'name', dataSource 'taskTitle' },
         *         ];
         *     },
         *     ...
         * });
         * ```
         * Please refer to {@link Common.data.Model} for additional details.
         *
         * @extends Scheduler/model/TimeSpan
         */

        var EventModel =
        /*#__PURE__*/
        function (_TimeSpan) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(EventModel, _TimeSpan);

          function EventModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, EventModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(EventModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(EventModel, [{
            key: "forEachResource",

            /**
             * Iterate over all associated resources
             * @private
             */
            value: function forEachResource(fn) {
              var thisObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = this.resources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var resource = _step.value;
                  if (fn.call(thisObj, resource) === false) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            }
            /**
             * Returns either the resource associated with this event (when called w/o `resourceId`) or resource
             * with specified id.
             *
             * @param {String} resourceId (optional)
             * @return {Scheduler.model.ResourceModel}
             */

          }, {
            key: "getResource",
            value: function getResource() {
              var resourceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.resourceId;
              var me = this,
                  eventStore = me.eventStore,
                  resourceStore = eventStore && eventStore.resourceStore;

              if (eventStore && resourceId) {
                var result = eventStore.getResourcesForEvent(me);
                if (result.length == 1) return result[0];
                if (result.length > 1) throw new Error('Event::getResource() is not applicable for events with multiple assignments, please use Event::resources instead.');
                return null;
              }

              if (resourceStore) return resourceStore ? resourceStore.getById(resourceId) : null;
            }
            /**
             * Sets the resource which the event should belong to.
             *
             * @param {Scheduler.model.ResourceModel|String|Number} resource The new resource
             */
            // set resource(resource) {
            //     const me         = this,
            //           eventStore = me.eventStore;
            //
            //     eventStore && eventStore.removeAssignmentsForEvent(me);
            //
            //     me.assign(resource);
            // }
            //endregion
            //region Is
            // Used internally to differentiate between Event and ResourceTimeRange

          }, {
            key: "assign",
            //endregion
            //region Assignment

            /**'
             * Assigns this event to the specified resource.
             *
             * @param {Scheduler.model.ResourceModel|String|Number} resource A new resource for this event, either as a full Resource record or an id (or an array of such).
             */
            value: function assign(resource) {
              var me = this,
                  eventStore = me.eventStore;
              resource = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_9__["default"].asId(resource);

              if (eventStore) {
                eventStore.assignEventToResource(me, resource);
              } else {
                me.resourceId = resource;
              }
            }
            /**
             * Unassigns this event from the specified resource
             *
             * @param {Scheduler.model.ResourceModel|String|Number|Array} [resource] The resource to unassign from.
             */

          }, {
            key: "unassign",
            value: function unassign(resource, removingResource) {
              var me = this,
                  eventStore = me.eventStore;
              resource = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_9__["default"].asId(resource); // If unassigned is caused by removing the resource the UI should be able to find out to not do extra redraws etc.

              me.meta.removingResource = removingResource;

              if (eventStore) {
                eventStore.unassignEventFromResource(me, resource);
              } else if (me.resourceId == resource) {
                me.resourceId = null;
              }

              me.meta.removingResource = null;
            }
            /**
             * Reassigns an event from an old resource to a new resource
             *
             * @param {Scheduler.model.ResourceModel|String|Number} oldResourceId A resource to unassign from or its id
             * @param {Scheduler.model.ResourceModel|String|Number} newResourceId A resource to assign to or its id
             */

          }, {
            key: "reassign",
            value: function reassign(oldResourceId, newResourceId) {
              var me = this,
                  eventStore = me.eventStore;
              oldResourceId = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_9__["default"].asId(oldResourceId);
              newResourceId = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_9__["default"].asId(newResourceId);

              if (eventStore) {
                eventStore.reassignEventFromResourceToResource(me, oldResourceId, newResourceId);
              } else {
                me.resourceId = newResourceId;
              }
            }
            /**
             * Returns true if this event is assigned to a certain resource.
             *
             * @param {Scheduler.model.ResourceModel|String|Number} resource The resource to query for
             * @return {Boolean}
             */

          }, {
            key: "isAssignedTo",
            value: function isAssignedTo(resource) {
              var me = this,
                  eventStore = me.eventStore;
              resource = _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_9__["default"].asId(resource);
              if (eventStore) return eventStore.isEventAssignedToResource(me, resource);
              return me.resourceId == resource;
            } //endregion

          }, {
            key: "eventStore",
            //endregion
            //region Stores

            /**
             * Returns the event store this event is part of.
             *
             * @return {Scheduler.data.EventStore}
             * @readonly
             */
            get: function get() {
              var me = this;

              if (!me._eventStore) {
                me._eventStore = me.stores && me.stores.find(function (s) {
                  return s.isEventStore;
                });
              }

              return me._eventStore;
            }
            /**
             * Returns the resource store this event uses as its default resource store. Event must be part
             * of an event store to be able to retrieve default resource store.
             *
             * @return {Scheduler.data.ResourceStore}
             * @readonly
             */

          }, {
            key: "resourceStore",
            get: function get() {
              var eventStore = this.eventStore;
              return eventStore && eventStore.resourceStore;
            }
            /**
             * Returns the assigment store this event uses as its default assignment store. Event must be part
             * of an event store to be able to retrieve default assignment store.
             *
             * @return {Scheduler.data.AssignmentStore}
             * @readonly
             */

          }, {
            key: "assignmentStore",
            get: function get() {
              var eventStore = this.eventStore;
              return eventStore && eventStore.assignmentStore;
            } //endregion
            //region Resources

            /**
             * Returns all resources assigned to an event.
             *
             * @return {Scheduler.model.ResourceModel[]}
             * @readonly
             */

          }, {
            key: "resources",
            get: function get() {
              return this.eventStore && this.eventStore.getResourcesForEvent(this) || [];
            }
          }, {
            key: "isEvent",
            get: function get() {
              return true;
            }
            /**
             * Returns true if event can be drag and dropped
             * @return {Boolean} The draggable state for the event.
             * @readonly
             */

          }, {
            key: "isDraggable",
            get: function get() {
              return this.draggable;
            }
            /**
             * Returns true if event can be resized, but can additionally return 'start' or 'end' indicating how this event can be resized.
             * @return {*} true, false, 'start' or 'end'
             * @readonly
             */

          }, {
            key: "isResizable",
            get: function get() {
              return !this.isMilestone && this.resizable;
            }
            /**
             * Returns false if a linked resource is a phantom record, i.e. it's not persisted in the database.
             *
             * @return {Boolean} true if persistable
             * @readonly
             */

          }, {
            key: "isPersistable",
            get: function get() {
              var me = this,
                  eventStore = me.eventStore;
              return eventStore && eventStore.isEventPersistable(me);
            }
          }], [{
            key: "fields",
            //region Fields
            // TODO: handle persist? defaultValue?
            get: function get() {
              return [
              /**
               * The unique identifier of a task (mandatory)
               * @field {String|Number} id
               */

              /**
               * CSS class specifying an icon to apply to the event
               * @field {String} iconCls
               */
              {
                name: 'iconCls'
              },
              /**
               * Id of the resource this event is associated with (only usable for single assignments)
               * @field {String|Number} resourceId
               */
              {
                name: 'resourceId'
              },
              /**
               * Specify false to prevent the event from being dragged (if EventDrag feature is used)
               * @field {Boolean} draggable
               * @default true
               */
              {
                name: 'draggable',
                type: 'boolean',
                persist: false,
                defaultValue: true
              }, // true or false

              /**
               * Specify false to prevent the event from being resized (if EventResize feature is used). You can also
               * specify 'start' or 'end' to only allow resizing in one direction
               * @field {boolean|String} resizable
               * @default true
               */
              {
                name: 'resizable',
                persist: false,
                defaultValue: true
              }, // true, false, 'start' or 'end'

              /**
               * Controls this events appearance, see {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle} for available
               * options.
               * @field {String} eventStyle
               */
              'eventStyle',
              /**
               * Controls the primary color of the event, defaults to using current themes default event color. What the color
               * affects is decided by {@link #field-eventStyle}
               * @field {String} eventColor
               */
              'eventColor',
              /**
               * Width (in px) to use for this milestone when using Scheduler#milestoneLayoutMode 'data'.
               * @field {Number} milestoneWidth
               */
              'milestoneWidth'];
            } // EventModel#assignments is created by a relation defined in AssignmentModel

            /**
             * Returns all assignments for the event. Event must be part of the store for this method to work.
             * @member {Scheduler.model.AssignmentModel[]} assignments
             */

            /**
             * Returns the assigned resource. Only valid when not using an AssignmentStore (single assignment)
             * @member {Scheduler.model.ResourceModel} resource
             */

          }, {
            key: "relationConfig",
            get: function get() {
              return [{
                relationName: 'resource',
                fieldName: 'resourceId',
                store: 'resourceStore',
                collectionName: 'events'
              }];
            }
          }]);

          return EventModel;
        }(_TimeSpan_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        EventModel.exposeProperties();
        EventModel._$name = 'EventModel';
        /***/
      },

      /***/
      "./lib/Scheduler/model/ResourceModel.js":
      /*!**********************************************!*\
        !*** ./lib/Scheduler/model/ResourceModel.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelResourceModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResourceModel;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Grid/data/GridRowModel.js */
        "../Grid/lib/Grid/data/GridRowModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/ResourceModel
         */

        /**
         * This class represent a single Resource in the scheduler chart. It's a subclass of  {@link Common.data.Model}.
         * Please refer to the documentation for that class to become familiar with the base interface of the resource.
         *
         * A Resource has only 2 mandatory fields - `id` and `name`. If you want to add more fields with meta data describing your resources then you should subclass this class:
         *
         * ```javascript
         * class MyResource extends ResourceModel {
         *
         *   static get fields() {
         *     [
         *       // `Id` and `Name` fields are already provided by the superclass
         *       { name: 'company', type : 'string' }
         *     ];
         *   }
         *
         *   getCompany() {
         *     return this.company;
         *   }
         *   ...
         * });
         * ```
         * If you want to use other names in your data for the id and name fields you can configure them as seen below:
         * ```javascript
         * class MyResource extends ResourceModel {
         *
         *   static get fields() {
         *     return [
         *        { name: 'name', dataSource: 'userName' }
         *     ];
         *   },
         *   ...
         * });
         * ```
         * Please refer to {@link Common.data.Model} for details.
         *
         * @extends Grid/data/GridRowModel
         */

        var ResourceModel =
        /*#__PURE__*/
        function (_GridRowModel) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ResourceModel, _GridRowModel);

          function ResourceModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ResourceModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ResourceModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ResourceModel, [{
            key: "getEvents",
            // /**
            //  * Returns all assignments for the resource. Resource must be part of the store for this method to work.
            //  *
            //  * @return {Scheduler.model.AssignmentModel[]}
            //  * @readonly
            //  */
            // get assignments() {
            //     const me         = this,
            //         eventStore = me.eventStore;
            //
            //     return eventStore && eventStore.getAssignmentsForResource(me);
            // }

            /**
             * Returns an array of events, associated with this resource
             *
             * @param {Scheduler.data.EventStore} eventStore (optional) The event store to get events for (if a resource is bound to multiple stores)
             * @return {Scheduler.model.TimeSpan[]}
             */
            // TODO: Needed?
            value: function getEvents() {
              var eventStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.eventStore;
              return eventStore && eventStore.getEventsForResource(this) || [];
            }
            /**
             * Returns true if the Resource can be persisted.
             * In a flat store resource is always considered to be persistable, in a tree store resource is considered to
             * be persitable if it's parent node is persistable.
             *
             * @return {Boolean} true if this model can be persisted to server.
             * @readonly
             */

          }, {
            key: "isAbove",
            //endregion

            /**
             * Returns true if this resource model is above the passed resource model
             * @param {Scheduler.model.ResourceModel} otherResource
             * @returns {Boolean}
             */
            value: function isAbove(otherResource) {
              var me = this,
                  store = me.resourceStore,
                  current,
                  myAncestors,
                  otherAncestors,
                  commonAncestorsLength,
                  lastCommonAncestor;
              if (me === otherResource) return false;

              if (store.tree) {
                //TODO: not ported
                // Getting self ancestors this node including
                current = me;
                myAncestors = [];

                while (current) {
                  myAncestors.push(current);
                  current = current.parentNode;
                } // Getting other ancestors other node including


                current = otherResource;
                otherAncestors = [];

                while (current) {
                  otherAncestors.push(current);
                  current = current.parentNode;
                } // Getting common ancestors sequence length


                commonAncestorsLength = 0;

                while (commonAncestorsLength < myAncestors.length - 1 && commonAncestorsLength < otherAncestors.length - 1 && myAncestors[commonAncestorsLength] == otherAncestors[commonAncestorsLength]) {
                  ++commonAncestorsLength;
                } // Getting last common ancesstor


                lastCommonAncestor = myAncestors[commonAncestorsLength]; // Here the next ancestor in myAncestors and next ancesstor in otherAncestors are siblings and
                // thus designate which node is above

                me = myAncestors[commonAncestorsLength + 1];
                otherResource = otherAncestors[commonAncestorsLength + 1];
                return lastCommonAncestor.indexOf(me) < lastCommonAncestor.indexOf(otherResource);
              }

              return store.indexOf(me) < store.indexOf(otherResource);
            }
            /**
             * Unassigns this Resource from all its Events
             */

          }, {
            key: "unassignAll",
            value: function unassignAll(removingResource) {
              var _this = this;

              this.events && this.events.slice().forEach(function (event) {
                return event.unassign(_this, removingResource);
              });
            }
          }, {
            key: "resourceStore",
            // ResoureModel#assignments is created by a relation defined in AssignmentModel

            /**
             * Returns all assignments for the resource. Resource must be part of the store for this method to work.
             * @member {Scheduler.model.AssignmentModel[]} assignments
             */
            //endregion
            //region Stores

            /**
             * Returns a resource store this resource is part of. Resource must be part
             * of a resource store to be able to retrieve resource store.
             *
             * @return {Scheduler.data.ResourceStore}
             * @readonly
             */
            get: function get() {
              return this.stores && this.stores[0];
            }
            /**
             * Returns an event store this resource uses as default. Resource must be part
             * of a resource store to be able to retrieve event store.
             *
             * @return {Scheduler.data.EventStore}
             * @readonly
             */

          }, {
            key: "eventStore",
            get: function get() {
              var resourceStore = this.resourceStore; // TODO: this.parentNode... is not ported

              return resourceStore && resourceStore.eventStore || this.parentNode && this.parentNode.eventStore;
            }
            /**
             * Returns as assignment store this resources uses as default. Resource must be part
             * of a resource store to be able to retrieve default assignment store.
             *
             * @return {Scheduler.data.AssignmentStore}
             * @readonly
             */

          }, {
            key: "assignmentStore",
            get: function get() {
              var eventStore = this.eventStore;
              return eventStore && eventStore.assignmentStore;
            } //endregion
            //region Getters

            /**
             * Get associated events
             * @returns {Scheduler.model.EventModel[]}
             * @readonly
             */

          }, {
            key: "events",
            get: function get() {
              // Cannot use relation here, since it wont work in mult assignment
              // TODO: Investigate making relations handle many-to-many using intermediate store? To have it cached
              return this.eventStore && this.eventStore.getEventsForResource(this);
            }
          }, {
            key: "isPersistable",
            get: function get() {
              var parent = this.parentNode; // TODO: not ported yet

              return !parent || !parent.phantom || parent.isRoot && parent.isRoot();
            }
          }], [{
            key: "fields",
            //region Fields
            get: function get() {
              return [
              /**
               * Unique identifier
               * @field {String|Number} id
               */

              /**
               * Get or set resource name
               * @field {String} name
               */
              {
                name: 'name',
                type: 'string',
                persist: true
              },
              /**
               * Controls the primary color used for events assigned to this resource. Can be overridden per event using
               * {@link Scheduler/model/EventModel#field-eventColor}
               * @field {String} eventColor
               */
              'eventColor',
              /**
               * Controls the style used for events assigned to this resource. Can be overridden per event using
               * {@link Scheduler/model/EventModel#field-eventStyle}
               * @field {String} eventStyle
               */
              'eventStyle',
              /**
               * Image URL, used by `ResourceInfoColumn` and vertical modes `ResourceHeader` to display a miniature image
               * for the resource.
               * @field {String} imageUrl
               */
              'imageUrl'];
            }
          }]);

          return ResourceModel;
        }(_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        ResourceModel.exposeProperties();
        ResourceModel._$name = 'ResourceModel';
        /***/
      },

      /***/
      "./lib/Scheduler/model/ResourceTimeRangeModel.js":
      /*!*******************************************************!*\
        !*** ./lib/Scheduler/model/ResourceTimeRangeModel.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelResourceTimeRangeModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResourceTimeRangeModel;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _TimeSpan_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/ResourceTimeRangeModel
         */

        /**
         * This class represent a single resource time range in your schedule. To style
         * the rendered elements, use the {@link Scheduler.model.TimeSpan#field-cls cls} field of the `TimeSpan` class, or use the {@link #field-timeRangeColor} field.
         *
         * @extends Scheduler/model/TimeSpan
         */

        var ResourceTimeRangeModel =
        /*#__PURE__*/
        function (_TimeSpan) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ResourceTimeRangeModel, _TimeSpan);

          function ResourceTimeRangeModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ResourceTimeRangeModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ResourceTimeRangeModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ResourceTimeRangeModel, [{
            key: "isResourceTimeRange",
            //endregion
            // Used internally to differentiate between Event and ResourceTimeRange
            get: function get() {
              return true;
            } // To match EventModel API

          }, {
            key: "resources",
            get: function get() {
              return [this.resource];
            }
          }], [{
            key: "fields",
            //region Fields
            get: function get() {
              return [
              /**
               * Id of the resource this time range is associated with
               * @field {String|Number} resourceId
               */
              'resourceId',
              /**
               * Controls this time ranges primary color, defaults to using current themes default time range color.
               * @field {String} timeRangeColor
               */
              'timeRangeColor'];
            }
          }, {
            key: "relationConfig",
            get: function get() {
              return [
              /**
               * The associated resource, retrieved using a relation to a ResourceStore determined by the value assigned
               * to `resourceId`. The relation also lets you access all time ranges on a resource through
               * `ResourceModel#timeRanges`.
               * @property {Scheduler.model.ResourceModel} resource
               */
              {
                relationName: 'resource',
                fieldName: 'resourceId',
                store: 'resourceStore',
                collectionName: 'timeRanges',
                nullFieldOnRemove: true
              }];
            }
          }]);

          return ResourceTimeRangeModel;
        }(_TimeSpan_js__WEBPACK_IMPORTED_MODULE_5__["default"]);

        ResourceTimeRangeModel._$name = 'ResourceTimeRangeModel';
        /***/
      },

      /***/
      "./lib/Scheduler/model/TimeSpan.js":
      /*!*****************************************!*\
        !*** ./lib/Scheduler/model/TimeSpan.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerModelTimeSpanJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeSpan;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_data_Model_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony import */


        var _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/util/DomClassList.js */
        "../Grid/lib/Common/helper/util/DomClassList.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/model/TimeSpan
         */

        /**
         * This class represent a simple date range. It is being used in various subclasses and plugins which operate on date ranges.
         *
         * Its a subclass of  {@link Common.data.Model}.
         * Please refer to documentation of those classes to become familar with the base interface of this class.
         *
         * A TimeSpan has the following fields:
         *
         * - `startDate`    - start date of the task in the ISO 8601 format
         * - `endDate`      - end date of the task in the ISO 8601 format (not inclusive)
         * - `duration`     - duration, time between start date and end date
         * - `durationUnit` - unit used to express the duration
         * - `name`         - an optional name of the range
         * - `cls`          - an optional CSS class to be associated with the range.
         *
         * The data source of any field can be customized in the subclass. Please refer to {@link Common.data.Model} for details. To specify
         * another date format:
         *
         * ```javascript
         * class MyTimeSpan extends TimeSpan {
         *   static get fields() {
         *      { name: 'startDate', type: 'date', dateFormat: 'DD/MM/YY' }
         *   }
         * }
         * ```
         *
         * @extends Common/data/Model
         */

        var TimeSpan =
        /*#__PURE__*/
        function (_Model) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimeSpan, _Model);

          function TimeSpan() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, TimeSpan);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(TimeSpan).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TimeSpan, [{
            key: "afterConstruct",
            //endregion
            //region Init
            value: function afterConstruct() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(TimeSpan.prototype), "afterConstruct", this).call(this); // This should probably be a property setter of some mandatory config, then we would not need an afterConfigure implementation.


              this.normalize();
            }
          }, {
            key: "normalize",
            value: function normalize() {
              var me = this,
                  startDate = me.startDate,
                  endDate = me.endDate,
                  duration = me.duration,
                  durationUnit = me.durationUnit,
                  hasDuration = duration != null; // need to calculate duration (checking first since seemed most likely to happen)

              if (startDate && endDate && !hasDuration) {
                me.setData('duration', _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].diff(startDate, endDate, durationUnit, true));
              } // need to calculate endDate?
              else if (startDate && !endDate && hasDuration) {
                  me.setData('endDate', _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(startDate, duration, durationUnit));
                } // need to calculate startDate
                else if (!startDate && endDate && hasDuration) {
                    me.setData('startDate', _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(endDate, -duration, durationUnit));
                  }

              this.clearCachedValues();
            } //endregion
            //region Getters & Setters

          }, {
            key: "setDuration",

            /**
             * Sets duration and durationUnit in one go. Only allowed way to change durationUnit, the durationUnit field is
             * readonly after creation
             * @param {Number} duration Duration value
             * @param {String} durationUnit Unit for specified duration value, see {@link #field-durationUnit} for valid values
             */
            value: function setDuration(duration) {
              var durationUnit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.durationUnit; // Must be a number

              duration = parseFloat(duration);
              var toSet = {
                duration: duration,
                durationUnit: durationUnit
              };

              if (this.startDate) {
                toSet.endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(this.startDate, duration, durationUnit);
              } else if (this.endDate) {
                toSet.startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(this.endDate, -duration, durationUnit);
              }

              this.set(toSet);
            }
            /**
             * Property which encapsulates the duration's magnitude and units.
             */

          }, {
            key: "setStartDate",

            /**
             * Sets the range start date
             *
             * @param {Date} date The new start date
             * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
             * Defaults to `true`
             */
            value: function setStartDate(date) {
              var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var me = this,
                  toSet = {
                startDate: date
              };

              if (date) {
                var calcEndDate;

                if (keepDuration) {
                  calcEndDate = me.duration != null;
                } else {
                  if (me.endDate) {
                    toSet.duration = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].diff(date, me.endDate, me.durationUnit, true);
                    if (toSet.duration < 0) throw new Error('Negative duration');
                  } else {
                    calcEndDate = this.duration != null;
                  }
                }

                if (calcEndDate) {
                  toSet.endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(date, me.duration, me.durationUnit);
                }
              } else {
                toSet.duration = null;
              }

              me.set(toSet);
            }
            /**
             * Sets the range end date
             *
             * @param {Date} date The new end date
             * @param {Boolean} keepDuration Pass `true` to keep the duration of the task ("move" the event), `false` to change the duration ("resize" the event).
             * Defaults to `false`
             */

          }, {
            key: "setEndDate",
            value: function setEndDate(date) {
              var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  toSet = {
                endDate: date
              };

              if (date) {
                var calcStartDate;

                if (keepDuration === true) {
                  calcStartDate = me.duration != null;
                } else {
                  if (me.startDate) {
                    toSet.duration = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].diff(me.startDate, date, me.durationUnit, true);
                    if (toSet.duration < 0) throw new Error('Negative duration');
                  } else {
                    calcStartDate = this.duration != null;
                  }
                }

                if (calcStartDate) {
                  toSet.startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(date, -me.duration, me.durationUnit);
                }
              }

              me.set(toSet);
            }
            /**
             * Sets the event start and end dates
             *
             * @param {Date} start The new start date
             * @param {Date} end The new end date
             */

          }, {
            key: "setStartEndDate",
            value: function setStartEndDate(start, end) {
              this.set({
                startDate: start,
                endDate: end
              });
            }
            /**
             * Returns an array of dates in this range. If the range starts/ends not at the beginning of day, the whole day will be included.
             * @return {Date[]}
             */

          }, {
            key: "clearCachedValues",
            // Caching isMilestone, startDate and endDate ms conversion since it costs a bit during rendering
            value: function clearCachedValues() {
              this._startDateMS = null;
              this._endDateMS = null;
              this._isMilestone = null;
            }
          }, {
            key: "inSetNormalize",
            value: function inSetNormalize(field) {
              if (typeof field !== 'string') {
                // If user is updating multiple properties in one go using an object, we help out
                // by filling out missing schedule related data
                field = Object.assign({}, field);

                if ('duration' in field) {
                  if (field.startDate && !field.endDate) {
                    field.endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(field.startDate, field.duration, field.durationUnit || this.durationUnit, true, true);
                  }

                  if (!field.startDate && field.endDate) {
                    field.startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(field.endDate, -field.duration, field.durationUnit || this.durationUnit, true, true);
                  }
                } else if (field.startDate && field.endDate) {
                  field.duration = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].diff(field.startDate, field.endDate, field.durationUnit || this.durationUnit, true);
                }

                return field;
              }
            }
          }, {
            key: "inSet",
            value: function inSet(field, value, silent, fromRelationUpdate) {
              this.clearCachedValues();
              field = this.inSetNormalize(field) || field;
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(TimeSpan.prototype), "inSet", this).call(this, field, value, silent, fromRelationUpdate);
            } //endregion
            //region Iteration

            /**
             * Iterates over the {@link #property-dates}
             * @param {Function} func The function to call for each date
             * @param {Object} thisObj `this` reference for the function
             */

          }, {
            key: "forEachDate",
            value: function forEachDate(func, thisObj) {
              return this.dates.forEach(func.bind(thisObj));
            } //endregion

            /**
             * Checks if the range record has both start and end dates set and start <= end
             *
             * @return {Boolean}
             */

          }, {
            key: "shift",

            /**
             * Shift the dates for the date range by the passed amount and unit
             * @param {String} unit The unit to shift by, see {@Common.helper.DateHelper} for more information on valid formats.
             * @param {Number} amount The amount to shift
             */
            value: function shift(amount) {
              var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.durationUnit; // TODO REMOVE FOR 2.0

              if (typeof amount === 'string') {
                var u = amount;
                amount = unit;
                unit = u;
              }

              this.setStartDate(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(this.startDate, amount, unit, true), true);
            }
            /**
             * Returns the WBS code of this model (only relevant when it's part of a tree store).
             * @return {String} The WBS code string
             * @private
             */

          }, {
            key: "fullCopy",
            value: function fullCopy() {
              //NOT PORTED
              return this.copy.apply(this, arguments);
            }
          }, {
            key: "intersects",
            value: function intersects(timeSpan) {
              return this.intersectsRange(timeSpan.startDate, timeSpan.endDate);
            }
          }, {
            key: "intersectsRange",
            value: function intersectsRange(start, end) {
              var myStart = this.startDate,
                  myEnd = this.endDate;
              return myStart && myEnd && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].intersectSpans(myStart, myEnd, start, end);
            }
            /**
             * Splits this event into two pieces at the desired position.
             *
             * @param {Number} splitPoint A number greater than 0 and less than 1, indicating how this event will be split. 0.5 means cut it in half
             * @return {Scheduler.model.TimeSpan} The newly created split section of the timespan
             */

          }, {
            key: "split",
            value: function split() {
              var splitPoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
              var me = this,
                  clone = this.copy(),
                  eventStore = me.firstStore,
                  assignmentStore = eventStore && eventStore.assignmentStore,
                  ownNewDuration = me.duration * splitPoint,
                  cloneDuration = me.duration - ownNewDuration;

              if (splitPoint <= 0 || splitPoint >= 1) {
                throw new Error('Split point must be > 0 and < 1');
              }

              me.duration = ownNewDuration;
              clone.startDate = me.endDate;
              clone.duration = cloneDuration;

              if (eventStore) {
                eventStore.add(clone);
              }

              if (assignmentStore) {
                assignmentStore.add(me.assignments.map(function (assignment) {
                  var clonedData = Object.assign({}, assignment.data, {
                    eventId: clone.id
                  });
                  delete clonedData.id;
                  return clonedData;
                }));
              }

              return clone;
            }
          }, {
            key: "cls",
            get: function get() {
              if (!this._cls) {
                this._cls = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_9__["default"](_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(TimeSpan.prototype), "get", this).call(this, 'cls'));
              }

              return this._cls;
            },
            set: function set(cls) {
              var me = this;

              if (me._cls) {
                me._cls.value = cls;
              } else {
                me._cls = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_9__["default"](cls);
              }

              me.set('cls', me._cls.value);
            }
          }, {
            key: "startDate",
            get: function get() {
              return this.get('startDate');
            },
            set: function set(date) {
              this.setStartDate(date);
            }
          }, {
            key: "endDate",
            get: function get() {
              return this.get('endDate');
            },
            set: function set(date) {
              this.setEndDate(date);
            }
          }, {
            key: "duration",
            get: function get() {
              return this.get('duration');
            },
            set: function set(duration) {
              this.setDuration(duration, this.durationUnit);
            }
          }, {
            key: "durationUnit",
            get: function get() {
              return this.get('durationUnit');
            }
          }, {
            key: "fullDuration",
            get: function get() {
              return {
                unit: this.durationUnit,
                magnitude: this.duration
              };
            },
            set: function set(duration) {
              if (typeof duration === 'string') {
                duration = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].parseDuration(duration, true, this.durationUnit);
              }

              this.setDuration(duration.magnitude, duration.unit);
            }
          }, {
            key: "dates",
            get: function get() {
              var dates = [],
                  startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].startOf(this.startDate, 'day'),
                  endDate = this.endDate;

              for (var date = startDate; date < endDate; date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].add(date, 1, 'day')) {
                dates.push(date);
              }

              return dates;
            }
            /**
             * Returns the duration of this Event in milliseconds.
             * @private
             */

          }, {
            key: "durationMS",
            get: function get() {
              if (this.endDate && this.startDate) {
                return this.endDateMS - this.startDateMS;
              } else {
                return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].asMilliseconds(this.duration || 0, this.durationUnit);
              }
            }
          }, {
            key: "endDateMS",
            get: function get() {
              var me = this;

              if (!me._endDateMS) {
                me._endDateMS = me.endDate && me.endDate.getTime();
              }

              return me._endDateMS;
            }
          }, {
            key: "startDateMS",
            get: function get() {
              var me = this;

              if (!me._startDateMS) {
                me._startDateMS = me.startDate && me.startDate.getTime();
              }

              return me._startDateMS;
            }
          }, {
            key: "isMilestone",
            get: function get() {
              var me = this;

              if (!me._isMilestone) {
                me._isMilestone = me.endDateMS === me.startDateMS;
              }

              return me._isMilestone;
            }
          }, {
            key: "isScheduled",
            get: function get() {
              var me = this;
              return Boolean(me.startDate && me.endDate && me.hasValidDates);
            } // Simple check if end date is greater than start date

          }, {
            key: "isValid",
            get: function get() {
              var me = this,
                  result = true; //super.isValid(),

              if (result) {
                var start = me.startDate,
                    end = me.endDate;
                result = !start || !end || end - start >= 0;
              }

              return result;
            } // Simple check if just end date is greater than start date

          }, {
            key: "hasValidDates",
            get: function get() {
              var me = this,
                  start = me.startDateMS,
                  end = me.endDateMS;
              return !start || !end || end - start >= 0;
            }
          }, {
            key: "wbsCode",
            get: function get() {
              return this.indexPath.join('.');
            }
          }], [{
            key: "fields",
            //region Field definitions
            get: function get() {
              return [
              /**
               * The start date of a time span (or Event / Task). Uses ISO 8601 date format by default (1962-06-17T09:21:34.125Z). To specify another
               * format, subclass TimeSpan and change the dateFormat
               * @field {String|Date} startDate
               */
              {
                name: 'startDate',
                type: 'date',
                dateFormat: 'YYYY-MM-DDTHH:mm:ssZ'
              },
              /**
               * The end date of a time span (or Event / Task). Uses ISO 8601 date format by default (1962-06-17T09:21:34.125Z). To specify another
               * format, subclass TimeSpan and change the dateFormat
               * @field {String|Date} endDate
               */
              {
                name: 'endDate',
                type: 'date',
                dateFormat: 'YYYY-MM-DDTHH:mm:ssZ'
              },
              /**
               * The numeric part of the timespans duration (the number of units).
               * @field {Number} duration
               */
              {
                name: 'duration',
                type: 'number',
                allowNull: true
              },
              /**
               * The unit part of the TimeSpan duration, defaults to "d" (days). Valid values are:
               *
               * - "ms" (milliseconds)
               * - "s" (seconds)
               * - "m" (minutes)
               * - "h" (hours)
               * - "d" (days)
               * - "w" (weeks)
               * - "M" (months)
               * - "y" (years)
               *
               * This field is readonly after creation, to change durationUnit use #setDuration().
               * @field {String} durationUnit
               */
              {
                name: 'durationUnit',
                type: 'string',
                defaultValue: 'd'
              }, {
                name: 'fullDuration'
              },
              /**
               * An encapsulation of the CSS classes to add to the rendered time span element.
               * @field {Common.helper.util.DomClassList|String} cls
               *
               * This may be accessed as a string, but for granular control of adding and
               * removing individual classes, it is recommended to use the
               * {@link Common.helper.util.DomClassList DomClassList} API.
               */
              {
                name: 'cls',
                defaultValue: ''
              },
              /**
               * A CSS style string (applied to `style.cssText`) or object (applied to `style`)
               * ```
               * record.style = 'color: red;font-weight: 800';
               * ```
               *
               * @field {String} style
               */
              {
                name: 'style',
                type: 'object'
              },
              /**
               * The name of the time span (or Event / Task)
               * @field {String} name
               */
              {
                name: 'name',
                type: 'string'
              }];
            }
          }]);

          return TimeSpan;
        }(_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        TimeSpan._$name = 'TimeSpan';
        /***/
      },

      /***/
      "./lib/Scheduler/preset/PresetManager.js":
      /*!***********************************************!*\
        !*** ./lib/Scheduler/preset/PresetManager.js ***!
        \***********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerPresetPresetManagerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return PresetManager;
        });
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "./node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "./node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _ViewPreset_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./ViewPreset.js */
        "./lib/Scheduler/preset/ViewPreset.js");
        /* harmony import */


        var _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");
        /* harmony import */


        var _Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");

        var productName = 'scheduler'; // eslint-disable-next-line import/no-named-default
        //TODO: break presets out to own files

        /**
         * @module Scheduler/preset/PresetManager
         */

        /**
         * Provides a registry of the possible view presets that any instance of Scheduler can use.
         *
         * See the {@link Scheduler.preset.ViewPreset} and {@link Scheduler.preset.ViewPresetHeaderRow} classes for a description of the view preset properties.
         *
         * Available presets are:
         *
         * - `secondAndMinute` - creates 2 level header - minute and seconds within it:
         * {@inlineexample scheduler/viewpresets/secondAndMinute.js}
         * - `minuteAndHour` - creates 2 level header - hour and minutes within it:
         * {@inlineexample scheduler/viewpresets/minuteAndHour.js}
         * - `hourAndDay` - creates 2 level header - day and hours within it:
         * {@inlineexample scheduler/viewpresets/hourAndDay.js}
         * - `dayAndWeek` - creates 2 level header - week and days within it:
         * {@inlineexample scheduler/viewpresets/dayAndWeek.js}
         * - `weekAndDay` - just like `dayAndWeek` but with different formatting:
         * {@inlineexample scheduler/viewpresets/weekAndDay.js}
         * - `weekAndDayLetter` - creates 2 level header - with weeks and day letters within it:
         * {@inlineexample scheduler/viewpresets/weekAndDayLetter.js}
         * - `weekAndMonth` - creates 2 level header - month and weeks within it:
         * {@inlineexample scheduler/viewpresets/weekAndMonth.js}
         * - `weekDateAndMonth` - creates 2 level header - month and weeks within it (weeks shown by first day only):
         * {@inlineexample scheduler/viewpresets/weekDateAndMonth.js}
         * - `monthAndYear` - creates 2 level header - year and months within it:
         * {@inlineexample scheduler/viewpresets/monthAndYear.js}
         * - `year` - creates 2 level header - year and quarters within it:
         * {@inlineexample scheduler/viewpresets/year.js}
         * - `manyYears` - creates 2 level header - 5-years and year within it:
         * {@inlineexample scheduler/viewpresets/manyYears.js}
         *
         * You can register your own preset with the {@link #function-registerPreset-static} call or pass a preset configuration in the scheduler panel.
         * @singleton
         */

        var PresetManager =
        /*#__PURE__*/
        function (_Localizable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(PresetManager, _Localizable);

          function PresetManager() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, PresetManager);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(PresetManager).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(PresetManager, null, [{
            key: "onLocalized",
            value: function onLocalized() {
              var me = this;

              if (me.presets) {
                Object.values(me.presets).forEach(function (preset) {
                  var locale = me.L(preset.name);

                  if (locale) {
                    locale.displayDateFormat && (preset.displayDateFormat = locale.displayDateFormat);
                    locale.middleDateFormat && (preset.headerConfig.middle.dateFormat = locale.middleDateFormat);
                    locale.topDateFormat && (preset.headerConfig.top.dateFormat = locale.topDateFormat);
                    locale.bottomDateFormat && (preset.headerConfig.bottom.dateFormat = locale.bottomDateFormat);
                  }
                });
              }
            }
            /**
             * Registers a new view preset to be used by any scheduler grid or tree on the page.
             * @param {String} name The unique name identifying this preset
             * @param {Object} config The configuration properties of the view preset (see {@link Scheduler.preset.ViewPreset} for more information)
             */

          }, {
            key: "registerPreset",
            value: function registerPreset(name, config) {
              config.name = name;
              var preset = new _ViewPreset_js__WEBPACK_IMPORTED_MODULE_13__["default"](config);
              if (!this.presets) this.presets = {};

              if (preset.isValid) {
                //if (this.containsKey(name)) this.removeAtKey(name);
                //this.add(name, preset);
                this.presets[name] = preset;
              } else {
                throw new Error('Invalid preset, please check your configuration');
              }
            }
            /**
             * Fetches a view preset from the global cache
             * @param {String|Object} preset The preset of the preset or a preset config object
             * @return {Object} The view preset, see {@link Scheduler.preset.ViewPreset} for more information
             */

          }, {
            key: "getPreset",
            value: function getPreset(preset) {
              if (typeof preset === 'string') {
                preset = this.presets[preset];
              } else if (!(preset instanceof _ViewPreset_js__WEBPACK_IMPORTED_MODULE_13__["default"])) {
                preset = new _ViewPreset_js__WEBPACK_IMPORTED_MODULE_13__["default"](preset);
              }

              return preset;
            }
            /**
             * Applies preset customizations or fetches a preset view preset using its name.
             * @param {String|Object} presetOrName Name of a predefined preset or a preset config object
             * @returns {Scheduler.preset.ViewPreset} Resulting ViewPreset instance
             */

          }, {
            key: "normalizePreset",
            value: function normalizePreset(presetOrName) {
              var me = this,
                  preset = presetOrName;

              if (!(preset instanceof _ViewPreset_js__WEBPACK_IMPORTED_MODULE_13__["default"])) {
                if (typeof preset === 'string') {
                  preset = me.getPreset(preset);

                  if (!preset) {
                    throw new Error('You must define a valid view preset. See PresetManager for reference');
                  }
                } else if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(preset) === 'object') {
                  var registeredPreset = preset.name && me.getPreset(preset.name);

                  if (registeredPreset) {
                    // TODO: detangle this
                    preset = new _ViewPreset_js__WEBPACK_IMPORTED_MODULE_13__["default"](Object.assign(registeredPreset.config, preset));
                  } else {
                    var name = preset.name || 'preset' + Object.keys(me.presets).length;
                    me.registerPreset(name, preset);
                    preset = me.getPreset(name);
                  }
                } else {
                  throw new Error('Invalid preset, specify a preset name or config object');
                }
              }

              return preset;
            }
            /**
             * Deletes a view preset
             * @param {String} name The name of the preset
             */

          }, {
            key: "deletePreset",
            value: function deletePreset(name) {
              delete this.presets[name]; //this.removeAtKey(name);
            }
          }, {
            key: "registerDefaults",
            value: function registerDefaults() {
              var me = this,
                  presets = me.defaultPresets;

              for (var presetName in presets) {
                me.registerPreset(presetName, presets[presetName]);
              }
            }
          }, {
            key: "defaultPresets",
            get: function get() {
              return {
                secondAndMinute: {
                  tickWidth: 30,
                  // Time column width
                  tickHeight: 40,
                  displayDateFormat: 'll LTS',
                  // Controls how dates will be displayed in tooltips etc
                  shiftIncrement: 10,
                  // Controls how much time to skip when calling shiftNext and shiftPrevious.
                  shiftUnit: 'minute',
                  // Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
                  defaultSpan: 24,
                  // By default, if no end date is supplied to a view it will show 24 hours
                  timeResolution: {
                    // Dates will be snapped to this resolution
                    unit: 'second',
                    // Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
                    increment: 5
                  },
                  // This defines your header, you must include a "middle" object, top/bottom are optional.
                  // For each row you can define "unit", "increment", "dateFormat", "renderer", "align", and "thisObj"
                  headerConfig: {
                    middle: {
                      unit: 'second',
                      increment: 10,
                      dateFormat: 'ss'
                    },
                    top: {
                      unit: 'minute',
                      dateFormat: 'llll'
                    }
                  }
                },
                minuteAndHour: {
                  tickWidth: 100,
                  // Time column width
                  tickHeight: 60,
                  displayDateFormat: 'll LT',
                  // Controls how dates will be displayed in tooltips etc
                  shiftIncrement: 1,
                  // Controls how much time to skip when calling shiftNext and shiftPrevious.
                  shiftUnit: 'hour',
                  // Valid values are "MILLI", "SECOND", "minute", "HOUR", "DAY", "WEEK", "MONTH", "QUARTER", "YEAR".
                  defaultSpan: 24,
                  // By default, if no end date is supplied to a view it will show 24 hours
                  timeResolution: {
                    // Dates will be snapped to this resolution
                    unit: 'minute',
                    // Valid values are "MILLI", "SECOND", "minute", "HOUR", "DAY", "WEEK", "MONTH", "QUARTER", "YEAR".
                    increment: 30
                  },
                  // This defines your header, you must include a "middle" object, top/bottom are optional.
                  // For each row you can define "unit", "increment", "dateFormat", "renderer", "align", and "thisObj"
                  headerConfig: {
                    middle: {
                      unit: 'minute',
                      increment: '30',
                      dateFormat: 'mm'
                    },
                    top: {
                      unit: 'hour',
                      dateFormat: 'ddd MM/DD, hA'
                    }
                  }
                },
                hourAndDay: {
                  tickWidth: 70,
                  tickHeight: 40,
                  displayDateFormat: 'll LT',
                  shiftIncrement: 1,
                  shiftUnit: 'day',
                  defaultSpan: 24,
                  timeResolution: {
                    unit: 'minute',
                    increment: 30
                  },
                  headerConfig: {
                    middle: {
                      unit: 'hour',
                      dateFormat: 'LT'
                    },
                    top: {
                      unit: 'day',
                      dateFormat: 'ddd DD/MM' //Mon 01/10

                    }
                  }
                },
                dayAndWeek: {
                  tickWidth: 100,
                  tickHeight: 80,
                  displayDateFormat: 'll LT',
                  shiftUnit: 'day',
                  shiftIncrement: 1,
                  defaultSpan: 5,
                  timeResolution: {
                    unit: 'hour',
                    increment: 1
                  },
                  headerConfig: {
                    middle: {
                      unit: 'day',
                      dateFormat: 'dd DD'
                    },
                    top: {
                      unit: 'week',
                      renderer: function renderer(start) {
                        return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getShortNameOfUnit('week') + '.' + _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(start, 'WW MMM YYYY');
                      }
                    }
                  }
                },
                weekAndDay: {
                  tickWidth: 100,
                  tickHeight: 80,
                  displayDateFormat: 'll hh:mm A',
                  shiftUnit: 'week',
                  shiftIncrement: 1,
                  defaultSpan: 1,
                  timeResolution: {
                    unit: 'day',
                    increment: 1
                  },
                  columnLinesFor: 'bottom',
                  headerConfig: {
                    bottom: {
                      unit: 'day',
                      increment: 1,
                      dateFormat: 'DD MMM'
                    },
                    middle: {
                      unit: 'week',
                      dateFormat: 'YYYY MMMM DD' // 2017 January 01

                    }
                  }
                },
                weekAndMonth: {
                  tickWidth: 100,
                  tickHeight: 105,
                  displayDateFormat: 'll',
                  shiftUnit: 'week',
                  shiftIncrement: 5,
                  defaultSpan: 6,
                  timeResolution: {
                    unit: 'day',
                    increment: 1
                  },
                  headerConfig: {
                    middle: {
                      unit: 'week',
                      dateFormat: 'DD MMM'
                    },
                    top: {
                      unit: 'month',
                      dateFormat: 'MMM YYYY' //Jan 2017

                    }
                  }
                },
                monthAndYear: {
                  tickWidth: 110,
                  tickHeight: 110,
                  displayDateFormat: 'll',
                  shiftIncrement: 3,
                  shiftUnit: 'month',
                  defaultSpan: 12,
                  timeResolution: {
                    unit: 'day',
                    increment: 1
                  },
                  headerConfig: {
                    middle: {
                      unit: 'month',
                      dateFormat: 'MMM YYYY' //Jan 2017

                    },
                    top: {
                      unit: 'year',
                      dateFormat: 'YYYY' //2017

                    }
                  }
                },
                year: {
                  tickWidth: 100,
                  tickHeight: 100,
                  resourceColumnWidth: 100,
                  displayDateFormat: 'll',
                  shiftUnit: 'year',
                  shiftIncrement: 1,
                  defaultSpan: 1,
                  timeResolution: {
                    unit: 'month',
                    increment: 1
                  },
                  headerConfig: {
                    middle: {
                      unit: 'quarter',
                      renderer: function renderer(start, end, cfg) {
                        return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].getShortNameOfUnit('quarter').toUpperCase() + (Math.floor(start.getMonth() / 3) + 1);
                      }
                    },
                    top: {
                      unit: 'year',
                      dateFormat: 'YYYY'
                    }
                  }
                },
                manyYears: {
                  tickWidth: 50,
                  tickHeight: 50,
                  displayDateFormat: 'll',
                  shiftUnit: 'year',
                  shiftIncrement: 1,
                  defaultSpan: 1,
                  timeResolution: {
                    unit: 'year',
                    increment: 1
                  },
                  columnLinesFor: 'bottom',
                  headerConfig: {
                    middle: {
                      unit: 'year',
                      dateFormat: 'YYYY',
                      increment: 5
                    },
                    // smallest zoom level looked back
                    // we have to specify increments here since 'increment' in zoomLevel affects only bottom header
                    bottom: {
                      unit: 'year',
                      dateFormat: 'YY',
                      increment: 1
                    }
                  }
                },
                weekAndDayLetter: {
                  tickWidth: 20,
                  tickHeight: 50,
                  displayDateFormat: 'll',
                  shiftUnit: 'week',
                  shiftIncrement: 1,
                  defaultSpan: 10,
                  timeResolution: {
                    unit: 'day',
                    increment: 1
                  },
                  columnLinesFor: 'bottom',
                  headerConfig: {
                    bottom: {
                      unit: 'day',
                      renderer: function renderer(start) {
                        return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(start, 'dd').substring(0, 1);
                      },
                      verticalColumnWidth: 25
                    },
                    middle: {
                      unit: 'week',
                      dateFormat: 'ddd DD MMM YYYY',
                      // Mon 01 Jan 2017
                      verticalColumnWidth: 115
                    }
                  }
                },
                weekDateAndMonth: {
                  tickWidth: 30,
                  tickHeight: 40,
                  displayDateFormat: 'll',
                  shiftUnit: 'week',
                  shiftIncrement: 1,
                  defaultSpan: 10,
                  timeResolution: {
                    unit: 'day',
                    increment: 1
                  },
                  headerConfig: {
                    middle: {
                      unit: 'week',
                      dateFormat: 'DD'
                    },
                    top: {
                      unit: 'month',
                      dateFormat: 'YYYY MMMM'
                    }
                  }
                },
                day: {
                  displayDateFormat: 'LT',
                  shiftIncrement: 1,
                  shiftUnit: 'day',
                  defaultSpan: 1,
                  timeResolution: {
                    unit: 'minute',
                    increment: 30
                  },
                  columnLinesFor: 'bottom',
                  headerConfig: {
                    bottom: {
                      unit: 'hour',
                      renderer: function renderer(value) {
                        return "\n                                <div class=\"b-sch-calendarcolumn-ct\"><span class=\"b-sch-calendarcolumn-hours\">".concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(value, 'HH'), "</span>\n                                <span class=\"b-sch-calendarcolumn-minutes\">").concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(value, 'mm'), "</span></div>\n                            ");
                      }
                    },
                    middle: {
                      unit: 'day',
                      dateFormat: 'ddd DD/MM',
                      // Mon 01/02
                      splitUnit: 'day'
                    }
                  }
                },
                week: {
                  displayDateFormat: 'LT',
                  shiftIncrement: 1,
                  shiftUnit: 'week',
                  defaultSpan: 24,
                  timeResolution: {
                    unit: 'minute',
                    increment: 30
                  },
                  columnLinesFor: 'bottom',
                  headerConfig: {
                    bottom: {
                      unit: 'hour',
                      dateFormat: 'LT',
                      // will be overridden by renderer
                      renderer: function renderer(value) {
                        return "\n                                <div class=\"sch-calendarcolumn-ct\">\n                                <span class=\"sch-calendarcolumn-hours\">".concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(value, 'HH'), "</span>\n                                <span class=\"sch-calendarcolumn-minutes\">").concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].format(value, 'mm'), "</span>\n                                </div>\n                            ");
                      }
                    },
                    middle: {
                      unit: 'week',
                      dateFormat: 'D d',
                      splitUnit: 'day'
                    }
                  }
                }
              };
            }
          }]);

          return PresetManager;
        }(Object(_Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_15__["default"])());

        _Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_14__["default"].on('locale', PresetManager.onLocalized.bind(PresetManager));

        PresetManager.registerDefaults(); // Apply any already loaded locale

        PresetManager.onLocalized();
        PresetManager._$name = 'PresetManager';
        /***/
      },

      /***/
      "./lib/Scheduler/preset/ViewPreset.js":
      /*!********************************************!*\
        !*** ./lib/Scheduler/preset/ViewPreset.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerPresetViewPresetJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ViewPreset;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler'; // eslint-disable-next-line import/no-named-default

        var clonedConfigs = ['rowHeight', 'tickWidth', 'tickHeight', 'displayDateFormat', 'shiftUnit', 'shiftIncrement', 'defaultSpan', 'timeResolution', 'columnLinesFor', 'headerConfig'];
        /**
         * @module Scheduler/preset/ViewPreset
         */

        /**
         * Not used directly, but the properties below are rather provided inline as seen in the source of {@link Scheduler.preset.PresetManager}. This class is just provided for documentation purposes.
         *
         * A sample preset looks like:
         * ```javascript
         * hourAndDay : {
         *   tickWidth           : 60,       // Time column width in horizontal mode
         *   tickHeight          : 30,       // Time column height in vertical mode
         *
         *   displayDateFormat   : 'HH:mm',  // Controls how dates will be displayed in tooltips etc
         *
         *   shiftIncrement      : 1,        // Controls how much time to skip when calling shiftNext and shiftPrevious.
         *   shiftUnit           : 'day',    // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
         *   defaultSpan         : 12,       // By default, if no end date is supplied to a view it will show 12 hours
         *
         *   timeResolution      : {         // Dates will be snapped to this resolution
         *     unit        : 'minute',       // Valid values are 'millisecond', 'second', 'minute', 'hour', 'day', 'week', 'month', 'quarter', 'year'.
         *     increment   : 15
         *   },
         *
         *   headerConfig        : {         // This defines your header, you must include a 'middle' object, and top/bottom are optional.
         *     middle : {                    // For each row you can define 'unit', 'increment', 'dateFormat', 'renderer', 'align', and 'thisObj'
         *       unit        : 'hour',
         *       dateFormat  : 'HH:mm'
         *     },
         *     top    : {
         *       unit        : 'day',
         *       dateFormat  : 'ddd DD/MM'
         *     }
         *   },
         *
         *   columnLinesFor      : 'middle'  // Defines header level column lines will be drawn for
         * }
         * ```
         * See the {@link Scheduler.preset.PresetManager} for the list of available presets.
         *
         * ## Duration units
         *
         * There are a number of configs for duration units ({@link #config-shiftUnit} or `unit` in {@link #config-timeResolution}, {@link #config-headerConfig} configs).
         *
         * When registering a preset using {@link Scheduler.preset.PresetManager#function-registerPreset-static} method you can provide their values using short constants names ('day', 'week' etc.):
         * ```javascript
         * PresetManager.registerPreset('hour', {
         *   displayDateFormat : 'HH:mm',
         *   shiftIncrement    : 1,
         *   shiftUnit         : 'day',
         *   tickWidth         : 150,
         *   timeResolution    : {
         *     unit      : 'minute',
         *     increment : 5
         *   },
         *   headerConfig      : {
         *     middle : {
         *       unit       : 'hour',
         *       dateFormat : 'HH:mm'
         *     },
         *     top    : {
         *       unit       : 'day',
         *       dateFormat : 'ddd DD/MM'
         *     }
         *   }
         * });
         * ```
         */

        var ViewPreset =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(ViewPreset, _Base);

          function ViewPreset() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, ViewPreset);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ViewPreset).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(ViewPreset, [{
            key: "construct",
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(ViewPreset.prototype), "construct", this).call(this, config);

              this.normalizeUnits();
            }
          }, {
            key: "normalizeUnits",
            value: function normalizeUnits() {
              var me = this,
                  timeResolution = me.timeResolution,
                  headerConfig = me.headerConfig; // Make sure date "unit" constant specified in the preset are resolved

              Object.keys(headerConfig).forEach(function (o) {
                headerConfig[o].unit = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].normalizeUnit(headerConfig[o].unit);

                if (headerConfig[o].splitUnit) {
                  headerConfig[o].splitUnit = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].normalizeUnit(headerConfig[o].splitUnit);
                }
              });

              if (timeResolution) {
                timeResolution.unit = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].normalizeUnit(timeResolution.unit);
              }

              if (me.shiftUnit) {
                me.shiftUnit = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].normalizeUnit(me.shiftUnit);
              }
            }
          }, {
            key: "clone",
            value: function clone() {
              var _this = this;

              var config = {};
              clonedConfigs.forEach(function (name) {
                config[name] = _this[name];
              });
              return new ViewPreset(config);
            }
          }, {
            key: "headers",
            get: function get() {
              var me = this;

              if (!me._headers) {
                var headers = me._headers = [],
                    _me$headerConfig = me.headerConfig,
                    top = _me$headerConfig.top,
                    middle = _me$headerConfig.middle,
                    bottom = _me$headerConfig.bottom;
                top && headers.push(top);
                middle && headers.push(middle);
                bottom && headers.push(bottom);
              }

              return me._headers;
            }
          }, {
            key: "mainHeader",
            get: function get() {
              return this.headerConfig.middle;
            }
          }, {
            key: "bottomHeader",
            get: function get() {
              return this.headers[this.headers.length - 1];
            }
          }, {
            key: "isValid",
            get: function get() {
              var me = this,
                  ownKeys = {};
              var valid = true; // Make sure all date "unit" constants are valid

              Object.keys(me.headerConfig).forEach(function (o) {
                ownKeys[o] = true;
                valid = valid && Boolean(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].normalizeUnit(me.headerConfig[o].unit));
              });

              if (!(me.columnLinesFor in ownKeys)) {
                me.columnLinesFor = 'middle';
              }

              if (me.timeResolution) {
                valid = valid && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].normalizeUnit(me.timeResolution.unit);
              }

              if (me.shiftUnit) {
                valid = valid && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].normalizeUnit(me.shiftUnit);
              }

              return valid;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * The name of the preset by which it is registered in the Manager
                 * @config {String}
                 */
                name: null,

                /**
                 * The height of the row in horizontal orientation
                 * @config {Number}
                 * @default
                 */
                rowHeight: 24,

                /**
                 * The width of the time tick column in horizontal orientation
                 * @config {Number}
                 * @default
                 */
                tickWidth: 50,

                /**
                 * The height of the time tick column in vertical orientation
                 * @config {Number}
                 * @default
                 */
                tickHeight: 50,

                /**
                 * Defines how dates will be formatted in tooltips etc
                 * @config {String}
                 * @default
                 */
                displayDateFormat: 'HH:mm',

                /**
                 * The unit to shift when calling shiftNext/shiftPrevious to navigate in the chart.
                 * Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
                 * @config {String}
                 * @default
                 */
                shiftUnit: 'hour',

                /**
                 * The amount to shift (in shiftUnits)
                 * @config {Number}
                 * @default
                 */
                shiftIncrement: 1,

                /**
                 * The amount of time to show by default in a view (in the unit defined by the middle header)
                 * @config {Number}
                 * @default
                 */
                defaultSpan: 12,

                /**
                 * An object containing a unit identifier and an increment variable. Example:
                 * ```javascript
                 * timeResolution : {
                 *   unit      : "hour",  //Valid values are "millisecond", "second", "minute", "hour", "day", "week", "month", "quarter", "year".
                 *   increment : 1
                 * }
                 * ```
                 * @config {Object}
                 */
                timeResolution: null,

                /**
                 * An object containing one or more {@link Scheduler.preset.ViewPresetHeaderRow} rows defining how your headers shall be composed.
                 * Your 'main' unit should be the middle header unit. This object can contain "bottom", "middle" and "top" header definitions. The 'middle' header is mandatory.
                 * @config {Object}
                 */
                headerConfig: null,

                /**
                 * Defines the header level that the column lines will be drawn for. See {@link Scheduler.feature.ColumnLines}
                 * @config {String}
                 * @default
                 */
                columnLinesFor: 'middle',
                // internal properties
                _headers: null,

                /**
                 * The viewPreset to use and extend when the preset is passed as a config object.
                 * @config {String}
                 */
                ptype: ''
              };
            }
          }]);

          return ViewPreset;
        }(_Common_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        ViewPreset._$name = 'ViewPreset';
        /***/
      },

      /***/
      "./lib/Scheduler/tooltip/ClockTemplate.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/tooltip/ClockTemplate.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerTooltipClockTemplateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ClockTemplate;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler'; //import styles from '../../../resources/sass/tooltip/clocktemplate.scss';

        /**
         * @module Scheduler/tooltip/ClockTemplate
         */

        /**
         * A template showing a clock, it consumes an object containing a date and a text
         * @private
         */

        var ClockTemplate =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ClockTemplate, _Base);

          function ClockTemplate() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ClockTemplate);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ClockTemplate).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ClockTemplate, [{
            key: "construct",
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ClockTemplate.prototype), "construct", this).call(this, config);

              this.timeAxisViewModelDetacher = this.timeAxisViewModel.on({
                update: this.onTimeAxisViewModelUpdate,
                thisObj: this
              });
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.timeAxisViewModelDetacher && this.timeAxisViewModelDetacher();
            }
          }, {
            key: "onTimeAxisViewModelUpdate",
            value: function onTimeAxisViewModelUpdate() {
              delete this._mode;
            }
          }, {
            key: "updateDateIndicator",
            value: function updateDateIndicator(tipEl, date) {
              var me = this,
                  hourIndicatorEl = tipEl.querySelector('.b-sch-hour-indicator'),
                  minuteIndicatorEl = tipEl.querySelector('.b-sch-minute-indicator');

              if (date && hourIndicatorEl && minuteIndicatorEl) {
                if (me.mode === 'hour') {
                  hourIndicatorEl.style.transform = "rotate(".concat(date.getHours() % 12 * 30, "deg)");
                  minuteIndicatorEl.style.transform = "rotate(".concat(date.getMinutes() * 6, "deg)");
                } else {
                  hourIndicatorEl.style.transform = 'none';
                  minuteIndicatorEl.style.transform = 'none';
                }
              }
            }
          }, {
            key: "mode",
            get: function get() {
              // 'hour' for a clock view or 'day' for a calendar view
              return this._mode || (this._mode = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].compareUnits(this.timeAxisViewModel.timeResolution.unit, 'day') >= 0 ? 'day' : 'hour');
            }
          }, {
            key: "template",
            set: function set(template) {
              this._template = template;
            }
            /**
             * Get the clock template, which accepts an object of format { date, text }
             * @returns {function(*): string}
             */
            ,
            get: function get() {
              return this._template;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                minuteHeight: 8,
                minuteTop: 2,
                hourHeight: 8,
                hourTop: 2,
                handLeft: 10,
                timeAxisViewModel: null,
                template: function template(data) {
                  return "<div class=\"b-sch-clockwrap b-sch-clock-".concat(this.mode, " ").concat(data.cls || '', "\">\n                    <div class=\"b-sch-clock\">\n                        <div class=\"b-sch-hour-indicator\">").concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].format(data.date, 'MMM'), "</div>\n                        <div class=\"b-sch-minute-indicator\">").concat(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].format(data.date, 'D'), "</div>\n                        <div class=\"b-sch-clock-dot\"></div>\n                    </div>\n                    <span class=\"b-sch-clock-text\">").concat(data.text, "</span>\n                </div>");
                }
              };
            }
          }]);

          return ClockTemplate;
        }(_Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        ClockTemplate._$name = 'ClockTemplate';
        /***/
      },

      /***/
      "./lib/Scheduler/util/RectangularPathFinder.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/util/RectangularPathFinder.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerUtilRectangularPathFinderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return RectangularPathFinder;
        });
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "./node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/WalkHelper.js */
        "../Grid/lib/Common/helper/WalkHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/util/RectangularPathFinder
         */

        /**
         * Class which finds rectangular path, i.e. path with 90 degrees turns, between two boxes.
         * @private
         */

        var RectangularPathFinder =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(RectangularPathFinder, _Base);

          function RectangularPathFinder() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_7___default()(this, RectangularPathFinder);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RectangularPathFinder).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_8___default()(RectangularPathFinder, [{
            key: "findPath",

            /**
             * Returns list of horizontal and vertical segments connecting two boxes
             * <pre>
             *    |    | |  |    |       |
             *  --+----+----+----*-------*---
             *  --+=>Start  +----*-------*--
             *  --+----+----+----*-------*--
             *    |    | |  |    |       |
             *    |    | |  |    |       |
             *  --*----*-+-------+-------+--
             *  --*----*-+         End <=+--
             *  --*----*-+-------+-------+--
             *    |    | |  |    |       |
             * </pre>
             * Path goes by lines (-=) and turns at intersections (+), boxes depicted are adjusted by horizontal/vertical
             * margin and arrow margin, original boxes are smaller (path can't go at original box borders). Algorithm finds
             * the shortest path with minimum amount of turns. In short it's mix of "Lee" and "Dijkstra pathfinding"
             * with turns amount taken into account for distance calculation.
             *
             * The algorithm is not very performant though, it's O(N^2), where N is amount of
             * points in the grid, but since the maximum amount of points in the grid might be up to 34 (not 36 since
             * two box middle points are not permitted) that might be ok for now.
             *
             * @param {Object} lineDef An object containing any of the class configuration option overrides as well
             *                         as `startBox`, `endBox`, `startHorizontalMargin`, `startVerticalMargin`,
             *                         `endHorizontalMargin`, `endVerticalMargin` properties
             * @param {Object} lineDef.startBox An object containing `start`, `end`, `top`, `bottom` properties
             * @param {Object} lineDef.endBox   An object containing `start`, `end`, `top`, `bottom` properties
             * @param {Number} lineDef.startHorizontalMargin Horizontal margin override for start box
             * @param {Number} lineDef.startVerticalMargin   Vertical margin override for start box
             * @param {Number} lineDef.endHorizontalMargin   Horizontal margin override for end box
             * @param {Number} lineDef.endVerticalMargin     Vertical margin override for end box
             *
             *
             * @return {Object[]|Boolean} Array of line segments or false if path cannot be found
             * @return {Number} return.x1
             * @return {Number} return.y1
             * @return {Number} return.x2
             * @return {Number} return.y2
             */
            //
            //@ignore
            //@privateparam {Function[]|Function} noPathFallbackFn
            //     A function or array of functions which will be tried in case a path can't be found
            //     Each function will be given a line definition it might try to adjust somehow and return.
            //     The new line definition returned will be tried to find a path.
            //     If a function returns false, then next function will be called if any.
            //
            value: function findPath(lineDef, noPathFallbackFn) {
              var me = this,
                  lineDefFull,
                  startBox,
                  endBox,
                  startShift,
                  endShift,
                  startSide,
                  endSide,
                  startArrowSize,
                  endArrowSize,
                  startArrowMargin,
                  endArrowMargin,
                  horizontalMargin,
                  verticalMargin,
                  startHorizontalMargin,
                  startVerticalMargin,
                  endHorizontalMargin,
                  endVerticalMargin,
                  otherHorizontalMargin,
                  otherVerticalMargin,
                  otherBoxes,
                  connStartPoint,
                  connEndPoint,
                  pathStartPoint,
                  pathEndPoint,
                  gridStartPoint,
                  gridEndPoint,
                  startGridBox,
                  endGridBox,
                  grid,
                  path,
                  tryNum;

              if (noPathFallbackFn && !Array.isArray(noPathFallbackFn)) {
                noPathFallbackFn = [noPathFallbackFn];
              }

              for (tryNum = 0; lineDef && !path;) {
                lineDefFull = Object.assign(me.config, lineDef);
                startBox = lineDefFull.startBox;
                endBox = lineDefFull.endBox;
                startShift = lineDefFull.startShift;
                endShift = lineDefFull.endShift;
                startSide = lineDefFull.startSide;
                endSide = lineDefFull.endSide;
                startArrowSize = lineDefFull.startArrowSize;
                endArrowSize = lineDefFull.endArrowSize;
                startArrowMargin = lineDefFull.startArrowMargin;
                endArrowMargin = lineDefFull.endArrowMargin;
                horizontalMargin = lineDefFull.horizontalMargin;
                verticalMargin = lineDefFull.verticalMargin;
                startHorizontalMargin = lineDefFull.hasOwnProperty('startHorizontalMargin') ? lineDefFull.startHorizontalMargin : horizontalMargin;
                startVerticalMargin = lineDefFull.hasOwnProperty('startVerticalMargin') ? lineDefFull.startVerticalMargin : verticalMargin;
                endHorizontalMargin = lineDefFull.hasOwnProperty('endHorizontalMargin') ? lineDefFull.endHorizontalMargin : horizontalMargin;
                endVerticalMargin = lineDefFull.hasOwnProperty('endVerticalMargin') ? lineDefFull.endVerticalMargin : verticalMargin;
                otherHorizontalMargin = lineDefFull.hasOwnProperty('otherHorizontalMargin') ? lineDefFull.otherHorizontalMargin : horizontalMargin;
                otherVerticalMargin = lineDefFull.hasOwnProperty('otherVerticalMargin') ? lineDefFull.otherVerticalMargin : verticalMargin;
                otherBoxes = lineDefFull.otherBoxes;
                startSide = me.normalizeSide(startSide);
                endSide = me.normalizeSide(endSide);
                connStartPoint = me.getConnectionCoordinatesFromBoxSideShift(startBox, startSide, startShift);
                connEndPoint = me.getConnectionCoordinatesFromBoxSideShift(endBox, endSide, endShift);
                startGridBox = me.calcGridBaseBoxFromBoxAndDrawParams(startBox, startSide, startArrowSize, startArrowMargin, startHorizontalMargin, startVerticalMargin);
                endGridBox = me.calcGridBaseBoxFromBoxAndDrawParams(endBox, endSide, endArrowSize, endArrowMargin, endHorizontalMargin, endVerticalMargin);
                otherBoxes = otherBoxes && otherBoxes.map(function (box) {
                  return me.calcGridBaseBoxFromBoxAndDrawParams(box, false, 0, 0, otherHorizontalMargin, otherVerticalMargin);
                });
                pathStartPoint = me.getConnectionCoordinatesFromBoxSideShift(startGridBox, startSide, startShift);
                pathEndPoint = me.getConnectionCoordinatesFromBoxSideShift(endGridBox, endSide, endShift);
                grid = me.buildPathGrid(startGridBox, endGridBox, pathStartPoint, pathEndPoint, startSide, endSide, otherBoxes);
                gridStartPoint = me.convertDecartPointToGridPoint(grid, pathStartPoint);
                gridEndPoint = me.convertDecartPointToGridPoint(grid, pathEndPoint);
                path = me.findPathOnGrid(grid, gridStartPoint, gridEndPoint, startSide, endSide); // Loop if
                // - path is still not found
                // - have no next line definition (which should be obtained from call to one of the functions from noPathFallbackFn array
                // - have noPathFallBackFn array
                // - current try number is less then noPathFallBackFn array length

                for (lineDef = false; !path && !lineDef && noPathFallbackFn && tryNum < noPathFallbackFn.length; tryNum++) {
                  lineDef = noPathFallbackFn[tryNum](lineDefFull);
                }
              }

              if (path) {
                path = me.prependPathWithArrowStaffSegment(path, connStartPoint, startArrowSize, startSide);
                path = me.appendPathWithArrowStaffSegment(path, connEndPoint, endArrowSize, endSide);
                path = me.optimizePath(path);
              }

              return path;
            }
          }, {
            key: "getConnectionCoordinatesFromBoxSideShift",
            value: function getConnectionCoordinatesFromBoxSideShift(box, side, shift) {
              var coords;

              switch (side) {
                case 'left':
                  coords = {
                    x: box.start,
                    y: (box.top + box.bottom) / 2 + shift
                  };
                  break;

                case 'right':
                  coords = {
                    x: box.end,
                    y: (box.top + box.bottom) / 2 + shift
                  };
                  break;

                case 'top':
                  coords = {
                    x: (box.start + box.end) / 2 + shift,
                    y: box.top
                  };
                  break;

                case 'bottom':
                  coords = {
                    x: (box.start + box.end) / 2 + shift,
                    y: box.bottom
                  };
                  break;
              }

              return coords;
            }
          }, {
            key: "calcGridBaseBoxFromBoxAndDrawParams",
            value: function calcGridBaseBoxFromBoxAndDrawParams(box, side, arrowSize, arrowMargin, horizontalMargin, verticalMargin) {
              var gridBox;

              switch (side) {
                case 'left':
                  gridBox = {
                    start: box.start - Math.max(arrowSize + arrowMargin, horizontalMargin),
                    end: box.end + horizontalMargin,
                    top: box.top - verticalMargin,
                    bottom: box.bottom + verticalMargin
                  };
                  break;

                case 'right':
                  gridBox = {
                    start: box.start - horizontalMargin,
                    end: box.end + Math.max(arrowSize + arrowMargin, horizontalMargin),
                    top: box.top - verticalMargin,
                    bottom: box.bottom + verticalMargin
                  };
                  break;

                case 'top':
                  gridBox = {
                    start: box.start - horizontalMargin,
                    end: box.end + horizontalMargin,
                    top: box.top - Math.max(arrowSize + arrowMargin, verticalMargin),
                    bottom: box.bottom + verticalMargin
                  };
                  break;

                case 'bottom':
                  gridBox = {
                    start: box.start - horizontalMargin,
                    end: box.end + horizontalMargin,
                    top: box.top - verticalMargin,
                    bottom: box.bottom + Math.max(arrowSize + arrowMargin, verticalMargin)
                  };
                  break;

                default:
                  gridBox = {
                    start: box.start - horizontalMargin,
                    end: box.end + horizontalMargin,
                    top: box.top - verticalMargin,
                    bottom: box.bottom + verticalMargin
                  };
              }

              return gridBox;
            }
          }, {
            key: "buildPathGrid",
            value: function buildPathGrid(startGridBox, endGridBox, pathStartPoint, pathEndPoint, startSide, endSide, otherGridBoxes) {
              var xs,
                  ys,
                  y,
                  x,
                  ix,
                  iy,
                  xslen,
                  yslen,
                  ib,
                  blen,
                  box,
                  permitted,
                  point,
                  points = {},
                  linearPoints = [];
              xs = [startGridBox.start, startSide === 'left' || startSide === 'right' ? (startGridBox.start + startGridBox.end) / 2 : pathStartPoint.x, startGridBox.end, endGridBox.start, endSide === 'left' || endSide === 'right' ? (endGridBox.start + endGridBox.end) / 2 : pathEndPoint.x, endGridBox.end];
              ys = [startGridBox.top, startSide === 'top' || startSide === 'bottom' ? (startGridBox.top + startGridBox.bottom) / 2 : pathStartPoint.y, startGridBox.bottom, endGridBox.top, endSide === 'top' || endSide === 'bottom' ? (endGridBox.top + endGridBox.bottom) / 2 : pathEndPoint.y, endGridBox.bottom];

              if (otherGridBoxes) {
                otherGridBoxes.forEach(function (box) {
                  xs.push(box.start, (box.start + box.end) / 2, box.end);
                  ys.push(box.top, (box.top + box.bottom) / 2, box.bottom);
                });
              }

              xs = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(new Set(xs.sort(function (a, b) {
                return a - b;
              })));
              ys = _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_4___default()(new Set(ys.sort(function (a, b) {
                return a - b;
              }))); // TODO: fastest way to make unique, Set is slower
              // for ( let i = 0, I = array.length; i < I; i++ ) {
              //     if ( ~array.indexOf( array[ i ], i + 1 ) ) {
              //         array.splice( i, 1 );
              //         i--;
              //         I--;
              //     }
              // }

              for (iy = 0, yslen = ys.length; iy < yslen; ++iy) {
                points[iy] = points[iy] || {};
                y = ys[iy];

                for (ix = 0, xslen = xs.length; ix < xslen; ++ix) {
                  x = xs[ix];
                  permitted = (x <= startGridBox.start || x >= startGridBox.end || y <= startGridBox.top || y >= startGridBox.bottom) && (x <= endGridBox.start || x >= endGridBox.end || y <= endGridBox.top || y >= endGridBox.bottom);

                  if (otherGridBoxes) {
                    for (ib = 0, blen = otherGridBoxes.length; permitted && ib < blen; ++ib) {
                      box = otherGridBoxes[ib];
                      permitted = x <= box.start || x >= box.end || y <= box.top || y >= box.bottom || // Allow point if it is a path start/end even if point is inside any box
                      x === pathStartPoint.x && y === pathStartPoint.y || x === pathEndPoint.x && y === pathEndPoint.y;
                    }
                  }

                  point = {
                    distance: Math.pow(2, 53) - 1,
                    // Number.MAX_SAFE_INTEGER (not supported in Opera/IE)
                    permitted: permitted,
                    x: x,
                    y: y,
                    ix: ix,
                    iy: iy
                  };
                  points[iy][ix] = point;
                  linearPoints.push(point);
                }
              }

              return {
                width: xs.length,
                height: ys.length,
                xs: xs,
                ys: ys,
                points: points,
                linearPoints: linearPoints
              };
            }
          }, {
            key: "convertDecartPointToGridPoint",
            value: function convertDecartPointToGridPoint(grid, point) {
              var x = grid.xs.indexOf(point.x),
                  y = grid.ys.indexOf(point.y);
              return grid.points[y][x];
            }
          }, {
            key: "findPathOnGrid",
            value: function findPathOnGrid(grid, gridStartPoint, gridEndPoint, startSide, endSide) {
              var me = this,
                  path = false;

              if (gridStartPoint.permitted && gridEndPoint.permitted) {
                grid = me.waveForward(grid, gridStartPoint, 0);
                path = me.collectPath(grid, gridEndPoint, endSide);
              }

              return path;
            } // Returns neighbors from Von Neiman ambit (see Lee pathfinding algorithm description)

          }, {
            key: "getGridPointNeighbors",
            value: function getGridPointNeighbors(grid, gridPoint, predicateFn) {
              var ix = gridPoint.ix,
                  iy = gridPoint.iy,
                  result = [],
                  neighbor; // NOTE:
              // It's important to push bottom neighbors first since this method is used
              // in collectPath(), which reversively collects path from end to start node
              // and if bottom neighbors are pushed first in result array then collectPath()
              // will produce a line which is more suitable (pleasant looking) for our purposes.

              if (iy < grid.height - 1) {
                neighbor = grid.points[iy + 1][ix];
                (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
              }

              if (iy > 0) {
                neighbor = grid.points[iy - 1][ix];
                (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
              }

              if (ix < grid.width - 1) {
                neighbor = grid.points[iy][ix + 1];
                (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
              }

              if (ix > 0) {
                neighbor = grid.points[iy][ix - 1];
                (!predicateFn || predicateFn(neighbor)) && result.push(neighbor);
              }

              return result;
            }
          }, {
            key: "waveForward",
            value: function waveForward(grid, gridStartPoint, distance) {
              var me = this; // I use the WalkHelper here because a point on a grid and it's neighbors might be considered as a hierarchy.
              // The point is the parent node, and it's neighbors are the children nodes. Thus the grid here is hierarchical
              // data structure which can be walked. WalkHelper walks non-recursivelly which is exactly what I need as well.

              _Common_helper_WalkHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].preWalkUnordered( // Walk starting point - a node is a grid point and it's distance from the starting point
              [gridStartPoint, distance], // Children query function
              // NOTE: It's important to fix neighbor distance first, before waving to a neighbor, otherwise waving might
              //       get through a neighbor point setting it's distance to a value more then (distance + 1) whereas we,
              //       at the children quering moment in time, already know that the possibly optimal distance is (distance + 1)
              function (_ref) {
                var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
                    point = _ref2[0],
                    distance = _ref2[1];

                return me.getGridPointNeighbors(grid, point, function (neighborPoint) {
                  return neighborPoint.permitted && neighborPoint.distance > distance + 1;
                }).map(function (neighborPoint) {
                  return [neighborPoint, distance + 1];
                } // Neighbor distance fixation
                );
              }, // Walk step iterator function
              function (_ref3) {
                var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, 2),
                    point = _ref4[0],
                    distance = _ref4[1];

                return point.distance = distance;
              } // Neighbor distance applying
              );

              return grid;
            }
          }, {
            key: "collectPath",
            value: function collectPath(grid, gridEndPoint, endSide) {
              var me = this,
                  pathFound = true,
                  neighbors,
                  lowestDistanceNeighbor,
                  xDiff,
                  yDiff,
                  path = [];

              while (pathFound && gridEndPoint.distance) {
                neighbors = me.getGridPointNeighbors(grid, gridEndPoint, function (point) {
                  return point.permitted && point.distance == gridEndPoint.distance - 1;
                });
                pathFound = neighbors.length > 0;

                if (pathFound) {
                  // Prefer turnless neighbors first
                  neighbors = neighbors.sort(function (a, b) {
                    var xDiff, yDiff;
                    xDiff = a.ix - gridEndPoint.ix;
                    yDiff = a.iy - gridEndPoint.iy;
                    var resultA = (endSide === 'left' || endSide === 'right') && yDiff === 0 || (endSide === 'top' || endSide === 'bottom') && xDiff === 0 ? -1 : 1;
                    xDiff = b.ix - gridEndPoint.ix;
                    yDiff = b.iy - gridEndPoint.iy;
                    var resultB = (endSide === 'left' || endSide === 'right') && yDiff === 0 || (endSide === 'top' || endSide === 'bottom') && xDiff === 0 ? -1 : 1;
                    if (resultA > resultB) return 1;
                    if (resultA < resultB) return -1; // apply additional sorting to be sure to pick bottom path in IE

                    if (resultA === resultB) return a.y > b.y ? -1 : 1;
                  });
                  lowestDistanceNeighbor = neighbors[0];
                  path.push({
                    x1: lowestDistanceNeighbor.x,
                    y1: lowestDistanceNeighbor.y,
                    x2: gridEndPoint.x,
                    y2: gridEndPoint.y
                  }); // Detecting new side, either xDiff or yDiff must be 0 (but not both)

                  xDiff = lowestDistanceNeighbor.ix - gridEndPoint.ix;
                  yDiff = lowestDistanceNeighbor.iy - gridEndPoint.iy;

                  switch (true) {
                    case !yDiff && xDiff > 0:
                      endSide = 'left';
                      break;

                    case !yDiff && xDiff < 0:
                      endSide = 'right';
                      break;

                    case !xDiff && yDiff > 0:
                      endSide = 'top';
                      break;

                    case !xDiff && yDiff < 0:
                      endSide = 'bottom';
                      break;
                  }

                  gridEndPoint = lowestDistanceNeighbor;
                }
              }

              return pathFound && path.reverse() || false;
            }
          }, {
            key: "prependPathWithArrowStaffSegment",
            value: function prependPathWithArrowStaffSegment(path, connStartPoint, startArrowSize, startSide) {
              var prependSegment, firstSegment;

              if (path.length > 0) {
                firstSegment = path[0];
                prependSegment = {
                  x2: firstSegment.x1,
                  y2: firstSegment.y1
                };

                switch (startSide) {
                  case 'left':
                    prependSegment.x1 = connStartPoint.x - startArrowSize;
                    prependSegment.y1 = firstSegment.y1;
                    break;

                  case 'right':
                    prependSegment.x1 = connStartPoint.x + startArrowSize;
                    prependSegment.y1 = firstSegment.y1;
                    break;

                  case 'top':
                    prependSegment.x1 = firstSegment.x1;
                    prependSegment.y1 = connStartPoint.y - startArrowSize;
                    break;

                  case 'bottom':
                    prependSegment.x1 = firstSegment.x1;
                    prependSegment.y1 = connStartPoint.y + startArrowSize;
                    break;
                }

                path.unshift(prependSegment);
              }

              return path;
            }
          }, {
            key: "appendPathWithArrowStaffSegment",
            value: function appendPathWithArrowStaffSegment(path, connEndPoint, endArrowSize, endSide) {
              var appendSegment, lastSegment;

              if (path.length > 0) {
                lastSegment = path[path.length - 1];
                appendSegment = {
                  x1: lastSegment.x2,
                  y1: lastSegment.y2
                };

                switch (endSide) {
                  case 'left':
                    appendSegment.x2 = connEndPoint.x - endArrowSize;
                    appendSegment.y2 = lastSegment.y2;
                    break;

                  case 'right':
                    appendSegment.x2 = connEndPoint.x + endArrowSize;
                    appendSegment.y2 = lastSegment.y2;
                    break;

                  case 'top':
                    appendSegment.x2 = lastSegment.x2;
                    appendSegment.y2 = connEndPoint.y - endArrowSize;
                    break;

                  case 'bottom':
                    appendSegment.x2 = lastSegment.x2;
                    appendSegment.y2 = connEndPoint.y + endArrowSize;
                    break;
                }

                path.push(appendSegment);
              }

              return path;
            }
          }, {
            key: "optimizePath",
            value: function optimizePath(path) {
              var optPath = [],
                  prevSegment,
                  curSegment;

              if (path.length > 0) {
                prevSegment = path.shift();
                optPath.push(prevSegment);

                while (path.length > 0) {
                  curSegment = path.shift(); // both segments are equal

                  if (prevSegment.x1 == curSegment.x1 && prevSegment.y1 == curSegment.y1 && prevSegment.x2 == curSegment.x2 && prevSegment.y2 == curSegment.y2) {
                    prevSegment = curSegment;
                  } // both segments are horizontal
                  else if (prevSegment.y1 - prevSegment.y2 === 0 && curSegment.y1 - curSegment.y2 === 0) {
                      prevSegment.x2 = curSegment.x2;
                    } // both segments are vertical
                    else if (prevSegment.x1 - prevSegment.x2 === 0 && curSegment.x1 - curSegment.x2 === 0) {
                        prevSegment.y2 = curSegment.y2;
                      } // segments has different orientation (path turn)
                      else {
                          optPath.push(curSegment);
                          prevSegment = curSegment;
                        }
                }
              }

              return optPath;
            }
          }, {
            key: "normalizeSide",
            value: function normalizeSide(side) {
              return RectangularPathFinder.sideToSide[side] || side;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                /**
                 * Default start connection side: 'left', 'right', 'top', 'bottom'
                 * @config {String|Boolean}
                 * @default
                 */
                startSide: 'right',

                /**
                 * Default start arrow size in pixels
                 * @config {Number}
                 * @default
                 */
                startArrowSize: 0,

                /**
                 * Default start arrow staff size in pixels
                 * @config {Number}
                 * @default
                 */
                startArrowMargin: 12,

                /**
                 * Default starting connection point shift from box's arrow pointing side middle point
                 * @config {Number}
                 * @default
                 */
                startShift: 0,

                /**
                 * Default end arrow pointing direction, possible values are: 'left', 'right', 'top', 'bottom'
                 * @config {String|Boolean}
                 * @default
                 */
                endSide: 'left',

                /**
                 * Default end arrow size in pixels
                 * @config {Number}
                 * @default
                 */
                endArrowSize: 0,

                /**
                 * Default end arrow staff size in pixels
                 * @config {Number}
                 * @default
                 */
                endArrowMargin: 12,

                /**
                 * Default ending connection point shift from box's arrow pointing side middle point
                 * @config {Number}
                 * @default
                 */
                endShift: 0,

                /**
                 * Start / End box vertical margin, the amount of pixels from top and bottom line of a box where drawing
                 * is prohibited
                 * @config {Number}
                 * @default
                 */
                verticalMargin: 2,

                /**
                 * Start / End box horizontal margin, the amount of pixels from left and right line of a box where drawing
                 * @config {Number}
                 * @default
                 */
                horizontalMargin: 5,

                /**
                 * Other rectangular areas (obstacles) to search path through
                 * @config {Object[]}
                 * @default
                 */
                otherBoxes: null
              };
            }
          }, {
            key: "sideToSide",
            get: function get() {
              return {
                'l': 'left',
                'r': 'right',
                't': 'top',
                'b': 'bottom'
              };
            }
          }]);

          return RectangularPathFinder;
        }(_Common_Base_js__WEBPACK_IMPORTED_MODULE_12__["default"]);

        RectangularPathFinder._$name = 'RectangularPathFinder';
        /***/
      },

      /***/
      "./lib/Scheduler/view/DependencyEditor.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/view/DependencyEditor.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewDependencyEditorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return DependencyEditor;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_widget_Popup_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/widget/Popup.js */
        "../Grid/lib/Common/widget/Popup.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/DependencyEditor
         */

        /**
         * A dependency editor popup.
         *
         * @extends Common/widget/Popup
         * @private
         */

        var DependencyEditor =
        /*#__PURE__*/
        function (_Popup) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(DependencyEditor, _Popup);

          function DependencyEditor() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DependencyEditor);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DependencyEditor).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DependencyEditor, [{
            key: "processWidgetConfig",
            value: function processWidgetConfig(widget) {
              var dependencyEditFeature = this.dependencyEditFeature;
              var fieldConfig = {};

              if (widget.ref === 'lagField' && !dependencyEditFeature.showLagField) {
                return false;
              }

              if (widget.ref === 'deleteButton' && !dependencyEditFeature.showDeleteButton) {
                return false;
              }

              Object.assign(widget, fieldConfig);
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DependencyEditor.prototype), "processWidgetConfig", this).call(this, widget);
            }
          }, {
            key: "afterShow",
            value: function afterShow() {
              var _get2;

              var deleteButton = this.widgetMap.deleteButton; // Only show delete button if the dependency record belongs to a store

              if (deleteButton) {
                deleteButton.hidden = !this.record.isPartOfStore();
              }

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DependencyEditor.prototype), "afterShow", this)).call.apply(_get2, [this].concat(args));
            }
          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(event) {
              this.trigger('keyDown', {
                event: event
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(DependencyEditor.prototype), "onInternalKeyDown", this).call(this, event);
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                items: [],
                draggable: {
                  handleSelector: ':not(button,.b-field-inner)' // blacklist buttons and field inners

                },
                axisLock: 'flexible'
              };
            }
          }]);

          return DependencyEditor;
        }(_Common_widget_Popup_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        DependencyEditor._$name = 'DependencyEditor';
        /***/
      },

      /***/
      "./lib/Scheduler/view/EventEditor.js":
      /*!*******************************************!*\
        !*** ./lib/Scheduler/view/EventEditor.js ***!
        \*******************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewEventEditorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return EventEditor;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_widget_Popup_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/widget/Popup.js */
        "../Grid/lib/Common/widget/Popup.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/EventEditor
         */

        /**
         * Provided event editor dialog.
         *
         * @extends Common/widget/Popup
         * @private
         */

        var EventEditor =
        /*#__PURE__*/
        function (_Popup) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(EventEditor, _Popup);

          function EventEditor() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, EventEditor);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventEditor).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(EventEditor, [{
            key: "processWidgetConfig",
            value: function processWidgetConfig(widget) {
              var me = this,
                  eventEditFeature = me.eventEditFeature;

              if (widget.type === 'extraItems') {
                return false;
              }

              var fieldConfig = {};

              if (widget.ref === 'resourceField') {
                if (!eventEditFeature.showResourceField) return false; // Can't use store directly since it may be grouped and then contains irrelevant group records

                me.resourceStore = widget.store = new eventEditFeature.resourceStore.constructor({
                  chained: true,
                  chainAllRecords: true,
                  // By default it chains processedRecords, leading to only "expanded" resources showing up in editor
                  masterStore: eventEditFeature.resourceStore,
                  chainedFilterFn: function chainedFilterFn(record) {
                    return !record.meta.specialRow;
                  }
                });
                widget.multiSelect = Boolean(eventEditFeature.scheduler.assignmentStore);
                if (eventEditFeature.resourceFieldConfig) fieldConfig = eventEditFeature.resourceFieldConfig;
              }

              if (widget.ref === 'nameField' && !eventEditFeature.showNameField) return false;
              if (widget.ref === 'deleteButton' && !eventEditFeature.showDeleteButton) return false;

              if ((widget.name === 'startDate' || widget.name === 'endDate') && widget.type === 'date') {
                fieldConfig.format = eventEditFeature.dateFormat;
              }

              if ((widget.name === 'startDate' || widget.name === 'endDate') && widget.type === 'time') {
                fieldConfig.format = eventEditFeature.timeFormat;
              }

              if (eventEditFeature.startDateConfig && widget.name === 'startDate' && widget.type === 'date') {
                fieldConfig = eventEditFeature.startDateConfig;
              }

              if (eventEditFeature.startTimeConfig && widget.name === 'startDate' && widget.type === 'time') {
                fieldConfig = eventEditFeature.startTimeConfig;
              }

              if (eventEditFeature.endDateConfig && widget.name === 'endDate' && widget.type === 'date') {
                fieldConfig = eventEditFeature.endDateConfig;
              }

              if (eventEditFeature.endTimeConfig && widget.name === 'endDate' && widget.type === 'time') {
                fieldConfig = eventEditFeature.endTimeConfig;
              }

              Object.assign(widget, fieldConfig);
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventEditor.prototype), "processWidgetConfig", this).call(this, widget);
            }
          }, {
            key: "show",
            value: function show() {
              var _get2; // Updated chained store. It is not done automatically for grouping/trees.


              if (this.resourceStore) {
                this.resourceStore.fillFromMaster();
              }

              for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }

              (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventEditor.prototype), "show", this)).call.apply(_get2, [this].concat(args));
            }
          }, {
            key: "afterShow",
            value: function afterShow() {
              var _get3;

              var deleteButton = this.widgetMap.deleteButton; // Only show delete button if the event belongs to a store

              if (deleteButton) {
                deleteButton.hidden = this.readOnly || !this.record.stores.length;
              }

              for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
              }

              (_get3 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventEditor.prototype), "afterShow", this)).call.apply(_get3, [this].concat(args));
            }
          }, {
            key: "onInternalKeyDown",
            value: function onInternalKeyDown(event) {
              this.trigger('keyDown', {
                event: event
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(EventEditor.prototype), "onInternalKeyDown", this).call(this, event);
            }
          }, {
            key: "readOnly",
            set: function set(readOnly) {
              var _this$widgetMap = this.widgetMap,
                  deleteButton = _this$widgetMap.deleteButton,
                  saveButton = _this$widgetMap.saveButton,
                  cancelButton = _this$widgetMap.cancelButton;
              this._readOnly = readOnly;
              this.element.classList[readOnly ? 'add' : 'remove']('b-readonly');
              this.eachWidget(function (widget) {
                widget.readOnly = readOnly;
              });

              if (deleteButton) {
                deleteButton.hidden = readOnly;
              }

              if (saveButton) {
                saveButton.hidden = readOnly;
              }

              if (cancelButton) {
                cancelButton.hidden = readOnly;
              }
            },
            get: function get() {
              return this._readOnly;
            }
          }], [{
            key: "defaultConfig",
            get: function get() {
              return {
                items: [],
                draggable: {
                  handleSelector: ':not(button,.b-field-inner)' // blacklist buttons and field inners

                },
                axisLock: 'flexible'
              };
            }
          }]);

          return EventEditor;
        }(_Common_widget_Popup_js__WEBPACK_IMPORTED_MODULE_8__["default"]);

        EventEditor._$name = 'EventEditor';
        /***/
      },

      /***/
      "./lib/Scheduler/view/Header.js":
      /*!**************************************!*\
        !*** ./lib/Scheduler/view/Header.js ***!
        \**************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewHeaderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Header;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../Grid/view/Header.js */
        "../Grid/lib/Grid/view/Header.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/Header
         */

        /**
         * Custom header subclass which handles the existence of the special TimeAxisColumn
         *
         * @extends Grid/view/Header
         * @private
         */

        var Header =
        /*#__PURE__*/
        function (_GridHeader) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(Header, _GridHeader);

          function Header() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Header);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Header).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Header, [{
            key: "refreshContent",
            value: function refreshContent() {
              // Only render contents into the header once as it contains the special rendering of the TimeAxisColumn
              if (this.headersElement && this.headersElement.childNodes.length === 0) {
                _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Header.prototype), "refreshContent", this).call(this);
              }
            }
          }]);

          return Header;
        }(_Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_6__["default"]);

        Header._$name = 'Header';
        /***/
      },

      /***/
      "./lib/Scheduler/view/HorizontalTimeAxis.js":
      /*!**************************************************!*\
        !*** ./lib/Scheduler/view/HorizontalTimeAxis.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewHorizontalTimeAxisJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HorizontalTimeAxis;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/taggedTemplateLiteral */
        "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
        /* harmony import */


        var _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        function _templateObject2() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default()(["<div class=\"b-sch-header-row b-sch-header-row-", "\" headerPosition=\"", "\">\n                ", "\n            </div>"]);

          _templateObject2 = function _templateObject2() {
            return data;
          };

          return data;
        }

        function _templateObject() {
          var data = _babel_runtime_helpers_taggedTemplateLiteral__WEBPACK_IMPORTED_MODULE_1___default()(["", ""]);

          _templateObject = function _templateObject() {
            return data;
          };

          return data;
        }

        var productName = 'scheduler';
        var tpl = _Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].tpl;
        /**
         * @module Scheduler/view/HorizontalTimeAxis
         */

        /**
         * A visual representation of the time axis described in the {@link Scheduler.preset.ViewPreset#config-headerConfig headerConfig}.
         * Normally you should not interact with this class directly.
         *
         * @mixes Common/mixin/Events
         * @private
         */

        var HorizontalTimeAxis =
        /*#__PURE__*/
        function (_Base) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(HorizontalTimeAxis, _Base);

          function HorizontalTimeAxis() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, HorizontalTimeAxis);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(HorizontalTimeAxis).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(HorizontalTimeAxis, [{
            key: "headerHtmlRowTpl",
            //endregion
            //region Init
            value: function headerHtmlRowTpl(data) {
              return tpl(_templateObject(), data.levels.map(function (level) {
                return tpl(_templateObject2(), level.position, level.position, level.cells.map(function (cell, i) {
                  return "<div class=\"b-sch-header-timeaxis-cell ".concat(cell.headerCellCls, "  ").concat(cell.align ? 'b-align-' + cell.align : '', "\">").concat(cell.value, "</div>\n                ");
                }));
              }));
            } //Needed to be CSP compliant

          }, {
            key: "fixHtmlHeaderStyles",
            value: function fixHtmlHeaderStyles(element, levels) {
              levels.forEach(function (level) {
                var nodes = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].children(element, '[headerPosition=' + level.position + '] .b-sch-header-timeaxis-cell');

                nodes.forEach(function (node, index) {
                  node.style.width = node.style.minWidth = "".concat(level.cells[index].width, "px");
                });
              });
            } //endregion
            //region Html & rendering
            // Produces the tables and cells based on the header row config in the active viewPreset

          }, {
            key: "renderTo",
            value: function renderTo(element) {
              var me = this,
                  columnConfig = me.model.columnConfig,
                  levels = [];

              if (columnConfig.top) {
                levels.push({
                  position: 'top',
                  cells: columnConfig.top
                });
              }

              if (columnConfig.middle) {
                levels.push({
                  position: 'middle',
                  cells: columnConfig.middle,
                  cls: !columnConfig.bottom && me.model.tickSize <= me.compactCellWidthThreshold ? 'b-sch-header-row-compact' : ''
                });
              }

              if (columnConfig.bottom) {
                levels.push({
                  position: 'bottom',
                  cells: columnConfig.bottom,
                  cls: me.model.tickSize <= me.compactCellWidthThreshold ? 'b-sch-header-row-compact' : ''
                });
              }

              element.innerHTML = me.headerHtmlRowTpl({
                levels: levels
              }); // TODO clean up when this is fixed: https://app.assembla.com/spaces/bryntum/tickets/8413-horizontaltimeaxis-should-not-completely-overwrite-contents-of-column-el/details#

              var parentEl = element.parentElement;
              [1, 2, 3].forEach(function (i) {
                return parentEl.classList.remove("b-sch-timeaxiscolumn-levels-".concat(i));
              });
              parentEl.classList.add("b-sch-timeaxiscolumn-levels-".concat(levels.length));
              me.fixHtmlHeaderStyles(element, levels);
            } //endregion

          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * The minimum width for a bottom row header cell to be considered 'compact', which adds a special CSS class
                 * to the row (for special styling).
                 * @config {Number}
                 * @default
                 */
                compactCellWidthThreshold: 15
              };
            }
          }]);

          return HorizontalTimeAxis;
        }(_Common_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        HorizontalTimeAxis._$name = 'HorizontalTimeAxis';
        /***/
      },

      /***/
      "./lib/Scheduler/view/ResourceHeader.js":
      /*!**********************************************!*\
        !*** ./lib/Scheduler/view/ResourceHeader.js ***!
        \**********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewResourceHeaderJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return ResourceHeader;
        });
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/helper/util/DomClassList.js */
        "../Grid/lib/Common/helper/util/DomClassList.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/ResourceHeader
         */

        /**
         * Header widget that renders resource column headers and acts as the interaction point for resource columns in vertical
         * mode. Note that it uses virtual rendering and element reusage to gain performance, only headers in view are available
         * in DOM. Because of this you should avoid direct element manipulation, any such changes can be discarded at any time.
         *
         * By default it displays resources `name` and also applies its `iconCls` if any, like this:
         *
         * ```
         * <i class="iconCls">name</i>
         * ```
         *
         * If Scheduler is configured with a {@link Scheduler.view.mixin.SchedulerEventRendering#config-resourceImagePath} the
         * header will render miniatures for the resources, using {@link Scheduler.model.ResourceModel#field-imageUrl} with
         * fallback to {@link Scheduler.model.ResourceModel#field-name} + .jpg for unset values.
         *
         * The contents and styling of the resource cells in the header can be customized using {@link #config-headerRenderer}:
         *
         * ```
         * new Scheduler({
         *     mode            : 'vertical',
         *     resourceColumns : {
         *         headerRenderer : ({ resourceRecord }) => `Hello ${resourceRecord.name}`
         *     }
         * }
         *```
         *
         * The width of the resource columns is determined by the {@link #config-columnWidth} config.
         *
         * @extends Common/widget/Widget
         */

        var ResourceHeader =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ResourceHeader, _Widget);

          function ResourceHeader() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ResourceHeader);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ResourceHeader).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(ResourceHeader, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(ResourceHeader.prototype), "construct", this).call(this, config);

              var me = this;

              if (me.imagePath != null) {
                var missingImgUrl = me.missingImgUrl = "".concat(me.imagePath).concat(me.defaultImageName); // Apply default image on load errors

                _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].on({
                  element: me.element,
                  delegate: '.b-resource-image',
                  capture: true,
                  error: function error(event) {
                    var target = event.target;

                    if (target.src !== target._lastMissingUrl) {
                      target._lastMissingUrl = target.src;
                      target.src = missingImgUrl;
                    }
                  }
                }); // Need to gain some height when displaying images


                me.element.classList.add('b-has-images');
              }
            } //endregion
            //region ResourceStore

          }, {
            key: "onResourceStoreDataChange",
            // Redraw resource headers on any data change
            value: function onResourceStoreDataChange(_ref) {
              var action = _ref.action;
              var me = this,
                  width = me.resourceStore.count * me.columnWidth;

              if (width !== me.width) {
                me.element.style.width = width + 'px'; // During setup, silently set the width. It will then render correctly. After setup, let the world know...

                me.column.set('width', width, me.column.grid.isConfiguring);
              }

              if (action === 'removeall') {
                // Keep nothing
                me.element.innerHTML = '';
              }

              if (action === 'remove' || action === 'add' || action === 'filter') {
                me.refreshWidths();
              }
            } //endregion
            //region Properties

          }, {
            key: "refreshWidths",
            // Updates the column widths according to fill and fit settings
            value: function refreshWidths() {
              var me = this,
                  availableWidth = me.availableWidth,
                  _originalColumnWidth = me._originalColumnWidth,
                  count = me.resourceStore && me.resourceStore.count; // Bail out if availableWidth not yet set or resource store not assigned/loaded

              if (!availableWidth || !count) {
                return;
              }

              me.refreshingWidths = true;
              var // Fit width if configured to do so or if configured to fill and used width is less than available width
              fit = me.fitWidth || me.fillWidth && _originalColumnWidth * count < availableWidth,
                  useWidth = fit ? Math.floor(availableWidth / count) : _originalColumnWidth,
                  shouldAnimate = me.column.grid.enableEventAnimations && Math.abs(me._columnWidth - useWidth) > 30;

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].addTemporaryClass(me.element, 'b-animating', shouldAnimate ? 300 : 0);

              me.columnWidth = useWidth;
              me.refreshingWidths = false;
            } //endregion
            //region Rendering
            // Visual resource range, set by VerticalEventMapper

          }, {
            key: "refresh",

            /**
             * Refreshes the visible headers
             */
            value: function refresh() {
              var me = this,
                  firstResource = me.firstResource,
                  lastResource = me.lastResource; // Bail out if we are configuring or have no resources to show

              if (me.column.grid.isConfiguring || firstResource === -1 || lastResource === -1 || lastResource >= me.resourceStore.count) {
                return;
              }

              var configs = []; // Gather element configs for resource headers in view

              for (var i = firstResource; i <= lastResource; i++) {
                var resourceRecord = me.resourceStore.getAt(i),
                    elementConfig = {
                  // Might look like overkill to use DomClassList here, but can be used in headerRenderer
                  className: new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
                    'b-resourceheader-cell': 1
                  }),
                  dataset: {
                    resourceId: resourceRecord.id
                  },
                  style: {
                    left: i * me.columnWidth,
                    width: me.columnWidth
                  },
                  children: []
                }; // Let a configured headerRenderer have a go at it before applying

                if (me.headerRenderer) {
                  var value = me.headerRenderer({
                    elementConfig: elementConfig,
                    resourceRecord: resourceRecord
                  });

                  if (value != null) {
                    elementConfig.html = value;
                  }
                } // No headerRenderer, apply default markup
                else {
                    // Optionally displaying a miniature image
                    if (me.imagePath != null) {
                      var imgSrc = resourceRecord.name ? me.imagePath + (resourceRecord.imageUrl || resourceRecord.name.toLowerCase() + '.jpg') : me.missingImgUrl;
                      elementConfig.children.push({
                        tag: 'img',
                        className: 'b-resource-image',
                        src: imgSrc
                      });
                    } // Optionally displaying an icon


                    if (resourceRecord.iconCls) {
                      elementConfig.children.push({
                        tag: 'i',
                        className: resourceRecord.iconCls
                      });
                    } // By default showing resource name


                    elementConfig.children.push({
                      tag: 'span',
                      className: 'b-resource-name',
                      html: resourceRecord.name
                    });
                  }

                configs.push(elementConfig);
              } // Sync changes to the header


              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].sync({
                elementConfig: {
                  onlyChildren: true,
                  children: configs
                },
                targetElement: me.element,
                useSyncId: 'resourceId' // TODO: Add callback here to trigger events when rendering/derendering header cells. Sooner or later
                //  someone is going to ask for a way to render JSX or what not to the header

              });
            } //endregion

          }, {
            key: "resourceStore",
            set: function set(store) {
              var me = this;

              if (store !== me._resourceStore) {
                me.resourceStoreDetacher && me.resourceStoreDetacher();
                me._resourceStore = store;
                me.resourceStoreDatacher = store.on({
                  change: 'onResourceStoreDataChange',
                  thisObj: me
                });
              }
            },
            get: function get() {
              return this._resourceStore;
            }
          }, {
            key: "columnWidth",
            get: function get() {
              return this._columnWidth;
            },
            set: function set(width) {
              var me = this;

              if (width !== me._columnWidth) {
                var oldWidth = me._columnWidth;
                me._columnWidth = width; // Flag set in refreshWidths, do not want to create a loop

                if (!me.refreshingWidths) {
                  me._originalColumnWidth = width;
                  me.refreshWidths();
                }

                if (!me.isConfiguring) {
                  me.refresh(); // Cannot trigger with requested width, might have changed because of fit/fill

                  me.trigger('columnWidthChange', {
                    width: me._columnWidth,
                    oldWidth: oldWidth
                  });
                }
              }
            }
            /**
             * Assign to toggle resource columns **fill* mode. `true` means they will stretch (grow) to fill viewport, `false`
             * that they will respect their configured `columnWidth`.
             * @property {Boolean}
             */

          }, {
            key: "fillWidth",
            get: function get() {
              return this._fillWidth;
            },
            set: function set(fill) {
              this._fillWidth = fill;
              this.refreshWidths();
            }
            /**
             * Assign to toggle resource columns **fit* mode. `true` means they will grow or shrink to always fit viewport,
             * `false` that they will respect their configured `columnWidth`.
             * @property {Boolean}
             */

          }, {
            key: "fitWidth",
            get: function get() {
              return this._fitWidth;
            },
            set: function set(fit) {
              this._fitWidth = fit;
              this.refreshWidths();
            }
          }, {
            key: "imagePath",
            get: function get() {
              return this._imagePath;
            },
            set: function set(path) {
              this._imagePath = path;
              this.refresh();
            } //endregion
            //region Fit to width

          }, {
            key: "availableWidth",
            get: function get() {
              return this._availableWidth;
            },
            set: function set(width) {
              this._availableWidth = width;
              this.refreshWidths();
            }
          }, {
            key: "range",
            set: function set(range) {
              var me = this;
              me.firstResource = range.firstResource;
              me.lastResource = range.lastResource;
              me.refresh();
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Resource store used to render resource headers. Assigned from Scheduler.
                 * @config {Scheduler.data.ResourceStore}
                 * @private
                 */
                resourceStore: null,
                // TODO: Read this value from CSS as we do with rowHeight?

                /**
                 * Width for each resource column
                 * @config {Number}
                 */
                columnWidth: 150,

                /**
                 * Custom header renderer function. Can be used to manipulate the element config used to create the element
                 * for the header:
                 *
                 * ```
                 * new Scheduler({
                 *   resourceColumns : {
                 *     headerRenderer({ elementConfig, resourceRecord }) {
                 *       elementConfig.dataset.myExtraData = 'extra';
                 *       elementConfig.style.fontWeight = 'bold';
                 *     }
                 *   }
                 * });
                 * ```
                 *
                 * See {@link Common.helper.DomHelper#function-createElement-static DomHelper#createElement()} for more information.
                 * Please take care to not break the default configs :)
                 *
                 * Or as a template by returning HTML from the function:
                 *
                 * ```
                 * new Scheduler({
                 *   resourceColumns : {
                 *     headerRenderer : ({ resourceRecord }) => `
                 *       <div class="my-custom-template">
                 *       ${resourceRecord.firstName} {resourceRecord.surname}
                 *       </div>
                 *     `
                 *   }
                 * });
                 * ```
                 *
                 * NOTE: When using `headerRenderer` no default internal markup is applied to the resource header cell,
                 * `iconCls` and `imageUrl` will have no effect unless you supply custom markup for them.
                 *
                 * @config {Function}
                 * @param {Object} params Object containing the params below
                 * @param {Scheduler.model.ResourceModel} resourceRecord Resource whose header is being rendered
                 * @param {Object} elementConfig A {@link Common.helper.DomHelper#function-createElement-static} config object used to create the element for the resource
                 */
                headerRenderer: null,

                /**
                 * Automatically resize resource columns to **fill** available width. Set to `false` to always respect the
                 * configured `columnWidth`
                 * @config {Boolean}
                 * @default
                 */
                fillWidth: true,

                /**
                 * Automatically resize resource columns to always **fit** available width
                 * @config {Boolean}
                 * @default
                 */
                fitWidth: false,
                // Copied from Scheduler#resourceImagePath on creation in TimeAxisColumn.js
                imagePath: null,
                // Copied from Scheduler#resourceImagePath on creation in TimeAxisColumn.js
                defaultImageName: null
              };
            }
          }, {
            key: "properties",
            get: function get() {
              return {
                firstResource: -1,
                lastResource: -1
              };
            }
          }]);

          return ResourceHeader;
        }(_Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        ResourceHeader._$name = 'ResourceHeader';
        /***/
      },

      /***/
      "./lib/Scheduler/view/Scheduler.js":
      /*!*****************************************!*\
        !*** ./lib/Scheduler/view/Scheduler.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewSchedulerJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Scheduler;
        });
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "./node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _TimelineBase_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./TimelineBase.js */
        "./lib/Scheduler/view/TimelineBase.js");
        /* harmony import */


        var _Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Grid/feature/RegionResize.js */
        "../Grid/lib/Grid/feature/RegionResize.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../Common/adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony import */


        var _Common_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../Common/helper/VersionHelper.js */
        "../Grid/lib/Common/helper/VersionHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/MixinHelper.js */
        "../Grid/lib/Common/helper/MixinHelper.js");
        /* harmony import */


        var _localization_En_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../localization/En.js */
        "./lib/Scheduler/localization/En.js");
        /* harmony import */


        var _mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ./mixin/SchedulerDom.js */
        "./lib/Scheduler/view/mixin/SchedulerDom.js");
        /* harmony import */


        var _mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ./mixin/SchedulerDomEvents.js */
        "./lib/Scheduler/view/mixin/SchedulerDomEvents.js");
        /* harmony import */


        var _mixin_SchedulerDragResize_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ./mixin/SchedulerDragResize.js */
        "./lib/Scheduler/view/mixin/SchedulerDragResize.js");
        /* harmony import */


        var _mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ./mixin/SchedulerEventRendering.js */
        "./lib/Scheduler/view/mixin/SchedulerEventRendering.js");
        /* harmony import */


        var _mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ./mixin/SchedulerStores.js */
        "./lib/Scheduler/view/mixin/SchedulerStores.js");
        /* harmony import */


        var _mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ./mixin/SchedulerScroll.js */
        "./lib/Scheduler/view/mixin/SchedulerScroll.js");
        /* harmony import */


        var _mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ./mixin/SchedulerRegions.js */
        "./lib/Scheduler/view/mixin/SchedulerRegions.js");
        /* harmony import */


        var _mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ./mixin/SchedulerState.js */
        "./lib/Scheduler/view/mixin/SchedulerState.js");
        /* harmony import */


        var _mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ./mixin/EventSelection.js */
        "./lib/Scheduler/view/mixin/EventSelection.js");
        /* harmony import */


        var _mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ./mixin/EventNavigation.js */
        "./lib/Scheduler/view/mixin/EventNavigation.js");
        /* harmony import */


        var _orientation_HorizontalEventMapper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ./orientation/HorizontalEventMapper.js */
        "./lib/Scheduler/view/orientation/HorizontalEventMapper.js");
        /* harmony import */


        var _orientation_VerticalEventMapper_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ./orientation/VerticalEventMapper.js */
        "./lib/Scheduler/view/orientation/VerticalEventMapper.js");
        /* harmony import */


        var _column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ../column/TimeAxisColumn.js */
        "./lib/Scheduler/column/TimeAxisColumn.js");
        /* harmony import */


        var _column_VerticalTimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ../column/VerticalTimeAxisColumn.js */
        "./lib/Scheduler/column/VerticalTimeAxisColumn.js");
        /* harmony import */


        var _feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ../feature/ColumnLines.js */
        "./lib/Scheduler/feature/ColumnLines.js");
        /* harmony import */


        var _feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
        /*! ../feature/EventContextMenu.js */
        "./lib/Scheduler/feature/EventContextMenu.js");
        /* harmony import */


        var _feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
        /*! ../feature/EventFilter.js */
        "./lib/Scheduler/feature/EventFilter.js");
        /* harmony import */


        var _feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
        /*! ../feature/EventDrag.js */
        "./lib/Scheduler/feature/EventDrag.js");
        /* harmony import */


        var _feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
        /*! ../feature/EventDragCreate.js */
        "./lib/Scheduler/feature/EventDragCreate.js");
        /* harmony import */


        var _feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
        /*! ../feature/EventEdit.js */
        "./lib/Scheduler/feature/EventEdit.js");
        /* harmony import */


        var _feature_EventResize_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
        /*! ../feature/EventResize.js */
        "./lib/Scheduler/feature/EventResize.js");
        /* harmony import */


        var _feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
        /*! ../feature/EventTooltip.js */
        "./lib/Scheduler/feature/EventTooltip.js");
        /* harmony import */


        var _feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(
        /*! ../feature/HeaderContextMenu.js */
        "./lib/Scheduler/feature/HeaderContextMenu.js");
        /* harmony import */


        var _feature_ScheduleContextMenu_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(
        /*! ../feature/ScheduleContextMenu.js */
        "./lib/Scheduler/feature/ScheduleContextMenu.js");
        /* harmony import */


        var _feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(
        /*! ../feature/ScheduleTooltip.js */
        "./lib/Scheduler/feature/ScheduleTooltip.js");

        var productName = 'scheduler'; // default features

        /**
         * @module Scheduler/view/Scheduler
         */

        /**
         * The Scheduler widget is a very powerful and performant UI component that displays an arbitrary number of "locked"
         * columns with a schedule occupying the remaining space. The schedule has a timeaxis at the top, one row per resource
         * and any number of events per resource.
         *
         * ## Intro
         * The Scheduler widget has a wide range of features and a large API to allow users to work with it efficiently in the
         * browser.
         *
         * The timeaxis displayed at the top of the Scheduler is configured using a {@link Scheduler.view.TimelineBase#config-startDate},
         * {@link Scheduler.view.TimelineBase#config-endDate} and a {@link Scheduler.view.mixin.TimelineViewPresets#config-viewPreset}. The dates
         * determine the outer limits of the range shown in the timeaxis while the {@link Scheduler.preset.ViewPreset} decides
         * the appearance and which dates are actually shown. The Scheduler ships with a selection of predefined view presets,
         * which can be found in {@link Scheduler.preset.PresetManager}.
         *
         * The Scheduler uses a {@link Scheduler.data.ResourceStore} to hold resources and an {@link Scheduler.data.EventStore}
         * to hold events. You can use inline data or load data using ajax, see the "Working with data" guides for more
         * information.
         *
         * The simplest schedule configured with inline data would look like this:
         *
         *      let scheduler = new Scheduler({
         *          appendTo : document.body,
         *
         *          startDate  : new Date(2018,4,6),
         *          endDate    : new Date(2018,4,12),
         *          viewPreset : 'dayAndWeek',
         *
         *           columns : [
         *              { field : 'name', text : 'Name', width: 100 }
         *          ],
         *
         *          resources : [
         *              { id : 1, name : 'Bernard' },
         *              { id : 2, name : 'Bianca' }
         *          ],
         *
         *          events : [
         *              { id : 1, resourceId : 1, name : 'Interview', startDate : '2018-05-06', endDate : '2018-05-07' },
         *              { id : 2, resourceId : 1, name : 'Press conference', startDate : '2018-05-08', endDate : '2018-05-09' },
         *              { id : 3, resourceId : 2, name : 'Audition', startDate : '2018-05-06', endDate : '2018-05-08' },
         *              { id : 4, resourceId : 2, name : 'Script deadline', startDate : '2018-05-11', endDate : '2018-05-11' }
         *          ]
         *      });
         *
         * {@inlineexample scheduler/Simplest.js}
         * ## Inheriting from Bryntum Grid
         * Bryntum Scheduler inherits from Bryntum Grid, meaning that most features available for the grid are also available
         * for the scheduler. Common features include columns, cell editing, context menus, row grouping, sorting and more.
         *
         * For more information on configuring columns, filtering, search etc. please see the {@link Grid.view.Grid Grid API docs}.
         * {@region Loading data}
         * As mentioned above Bryntum Scheduler uses an {@link Scheduler.data.EventStore} and a {@link Scheduler.data.ResourceStore}
         * to hold its data. Data is expected to be in JSON format and can be assigned inline (from memory) using the
         * {@link Scheduler.view.mixin.SchedulerStores#config-events} and
         * {@link Scheduler.view.mixin.SchedulerStores#config-resources} shortcuts:
         * ```
         * let scheduler = new Scheduler({
         *    events : myArrayOfEventData,
         *    resources : myArrayOfResourceData
         * });
         * ```
         * If you need to give additional store configuration, you can also specify store configs or instances:
         * ```
         * let resourceStore = new ResourceStore({
         *   // ResourceStore config object
         * })
         *
         * let scheduler = new Scheduler({
         *    // EventStore config object
         *    eventStore : {
         *       ...
         *    },
         *
         *    // Already existing ResourceStore instance
         *    resourceStore
         * });
         * ```
         * To use Ajax to fetch data from a server, specify {@link Common.data.AjaxStore#config-readUrl}:
         * ```
         * let scheduler = new Scheduler({
         *    eventStore : {
         *        readUrl  : 'backend/read_events.php',
         *        autoLoad : true
         *    }
         * });
         * // If you do not specify autoLoad, trigger loading manually:
         * scheduler.eventStore.load();
         * ```
         * For more information, see the "Working with data" guides.
         * {@endregion}
         * {@region Event styling}
         * Bryntum Schedulers appearance can be affected in a few different ways:
         *
         * * Switching themes
         * * Choosing event styles and colors
         * * Using renderer functions
         *
         * ### Switching themes
         * Scheduler ships with four different themes, simply include the css file for the theme you would like to use on your
         * page. The themes are located in the `/build` folder. For example to include the light theme:
         * ```
         * <link rel="stylesheet" href="build/scheduler.light.css" id="bryntum-theme">
         * ```
         * Included themes are (from left to right) light, default, dark and material:
         *
         * <img src="../examples/basic/meta/thumb.light.png" alt="Light theme" width="300" style="margin-right: .5rem">
         * <img src="../examples/basic/meta/thumb.default.png" alt="Default theme" width="300" style="margin-right: .5rem">
         * <img src="../examples/basic/meta/thumb.dark.png" alt="Dark theme" width="300" style="margin-right: .5rem">
         * <img src="../examples/basic/meta/thumb.material.png" alt="Material theme" width="300">
         *
         * ### Choosing event styles and colors
         * The style and color of each event can be changed by assigning to the `eventStyle` and `eventColor` configs. These
         * configs are available at 3 different levels:
         *
         * * Scheduler level, affects all events (see {@link Scheduler.view.mixin.TimelineEventRendering#config-eventStyle} and {@link Scheduler.view.mixin.TimelineEventRendering#config-eventColor}).
         * * Resource level, affects all events assigned to that resource (see {@link Scheduler.model.ResourceModel#field-eventStyle}
         * and {@link Scheduler.model.ResourceModel#field-eventColor}).
         * * Event level, affects that event (see {@link Scheduler.model.EventModel#field-eventStyle} and
         * {@link Scheduler.model.EventModel#field-eventColor}).
         *
         * {@inlineexample scheduler/Styles.js}
         *
         * For available styles, see {@link Scheduler.view.mixin/TimelineEventRendering#config-eventStyle}. For colors,
         * {@link Scheduler.view.mixin/TimelineEventRendering#config-eventColor}. Also take a look at the
         * <a href="../examples/eventstyles" target="_blank">eventstyles demo</a>.
         *
         * ### Using render functions
         * Render function can be used to manipulate the rendering of rows (resources) and events. For information on row
         * renderers, see {@link Grid.column.Column#config-renderer}.
         *
         * Event rendering can be manipulated by specifying an {@link Scheduler.view.mixin/SchedulerEventRendering#config-eventRenderer} function. The function is called
         * for each event before it is rendered to DOM. By using its arguments you can add CSS classes, modify styling and
         * determine the contents of the event:
         * ```
         * let scheduler = new Scheduler({
         *
         *   events    : [...],
         *   resources : [...],
         *
         *   ...,
         *
         *   eventRenderer({resourceRecord, eventRecord, tplData}) {
         *      // add css class to the event
         *      tplData.cls.add('my-css-class');
         *
         *      // use an icon
         *      tplData.iconCls = 'b-fa b-fa-some-nice-icon';
         *
         *      // returnvalue is used as events text
         *      return `${resourceRecord.name}: ${eventRecord.name}`;
         *   }
         * });
         * ```
         * {@endregion}
         * {@region Event manipulation}
         * You can programmatically manipulate the events using data operations, see the "Working with data" guides for more
         * information. Events are reactive, changes reflect on the UI automatically. A small example on manipulating events:
         * ```
         * // change startDate of first event
         * scheduler.eventStore.first.startDate = new Date(2018,5,10);
         *
         * // remove last event
         * scheduler.eventStore.last.remove();
         *
         * // reassign an event
         * scheduler.eventStore.getById(10).resourceId = 2;
         * ```
         *
         * You can also allow your users to manipulate the events using the following features:
         *
         * * {@link Scheduler.feature.EventDrag}, drag and drop events within the schedule
         * * {@link Scheduler.feature.EventDragCreate}, create new events by click-dragging an empty area
         * * {@link Scheduler.feature.EventEdit}, show an event editing form
         * * {@link Scheduler.feature.SimpleEventEdit}, edit the event name easily
         * * {@link Scheduler.feature.EventResize}, resize events by dragging resize handles
         *
         * All of the features mentioned above are enabled by default.
         * {@endregion}
         *
         * {@region Default configs}
         * There is a myriad of configs and features available for Scheduler (browse the API docs to find them), some of them on
         * by default and some of them requiring extra configuration. The code below tries to illustrate the major things that
         * are used by default:
         *
         * ```javascript
         * let scheduler = new Scheduler({
         *    // The following features are enabled by default:
         *    features : {
         *        cellEdit            : true, // Cell editing in the columns part
         *        columnLines         : true, // Column lines in the schedule part
         *        columnPicker        : true, // Header context menu item to toggle visible columns
         *        columnReorder       : true, // Reorder columns in grid part using drag and drop
         *        columnResize        : true, // Resize columns in grid part using the mouse
         *        contextMenu         : true, // Context menu for cells and headers in the grid part
         *        eventContextMenu    : true, // Context menu for events
         *        eventDrag           : true, // Dragging events
         *        eventDragCreate     : true, // Drag creating events
         *        eventEdit           : true, // Event editor dialog
         *        eventFilter         : true, // Filtering events using header context menu
         *        eventResize         : true, // Resizing events using the mouse
         *        eventTooltip        : true, // Tooltips for events
         *        group               : true, // Row grouping
         *        headerContextMenu   : true, // Header context menu for schedule part
         *        scheduleContextMenu : true, // Context menu for empty parts of the schedule
         *        scheduleTooltip     : true, // Tooltip for empty parts of the schedule
         *        sort                : true  // Row sorting
         *    },
         *
         *    // From Grid
         *    animateRemovingRows       : false, // Rows will not slide out on removal
         *    autoHeight                : false, // Grid needs to have a height supplied through CSS (strongly recommended) or by specifying `height
         *    columnLines               : true,  // Grid part, themes might override it to hide lines anyway
         *    emptyText                 : 'Loading Records...',
         *    enableTextSelection       : false, // Not allowed to select text in cells by default,
         *    fillLastColumn            : true,  // By default the last column is stretched to fill the grid
         *    fullRowRefresh            : true,  // Refreshes entire row when a cell value changes
         *    loadMask                  : 'Loading...',
         *    resizeToFitIncludesHeader : true,  // Also measure header when auto resizing columns
         *    responsiveLevels : {
         *      small : 400,
         *      medium : 600,
         *      large : '*'
         *    },
         *    rowHeight                 : 60,    // Scheduler specifies a default rowHeight in pixels
         *    showDirty                 : false, // No indicator for changed cells
         *    showRemoveInContextMenu   : true   // Context menu has "Remove row" item,
         *
         *    // Scheduler specific
         *    autoAdjustTimeAxis             : true,      // startDate & endDate will be adjusted to display a suitable range
         *    allowOverlap                   : true,      // Events are allowed to overlap (overlays, stacks or packs depending on eventLayout)
         *    barMargin                      : 10,        // Space above + below each event
         *    createEventOnDblClick          : true,      // Allow creating new events by double clicking empty space
         *    enableDeleteKey                : true,      // Allow deleting events with delete / backspace keys
         *    enableEventAnimations          : true,      // Animate event changes
         *    eventBarTextField              : 'name',    // Field on EventModel to display in events
         *    eventColor                     : 'green',   // Use green as default color for events
         *    eventLayout                    : 'stack',   // Stack overlapping events by default
         *    eventStyle                     : 'plain',   // Use plain as default style for events
         *    managedEventSizing             : true,      // Calculate event sizes based on rowHeight & barMargin
         *    milestoneCharWidth             : 10,
         *    milestoneLayoutMode            : 'default',
         *    removeUnassignedEvent          : true,      // Remove event when all assignments for it are removed
         *    useInitialAnimation            : true,      // Fade in events initially
         *    viewPreset                     : 'weekAndDayLetter',
         *    zoomOnMouseWheel               : true,
         *    zoomOnTimeAxisDoubleClick      : true
         * });
         * ```
         * {@endregion}
         *
         * {@region Performance}
         * To make scheduler performance as good as possible it only renders the events and resources that are within view (plus
         * an additional buffer). Since adding to and removing from DOM comes with a performance penalty the elements are
         * instead repositioned and reused as you scroll. A side effect of this is that you cannot do direct DOM element
         * manipulation in a reliable way, instead you should use row and event renderer functions to achive what you want (see
         * the section on event styling above).
         *
         * To put the scheduler to the test, try our <a href="../examples/bigdataset" target="_blank">bigdataset demo</a>.
         * {@endregion}
         *
         * @mixes Scheduler/view/mixin/EventNavigation
         * @mixes Scheduler/view/mixin/EventSelection
         * @mixes Scheduler/view/mixin/SchedulerDom
         * @mixes Scheduler/view/mixin/SchedulerDomEvents
         * @mixes Scheduler/view/mixin/SchedulerEventRendering
         * @mixes Scheduler/view/mixin/SchedulerRegions
         * @mixes Scheduler/view/mixin/SchedulerScroll
         * @mixes Scheduler/view/mixin/SchedulerState
         * @mixes Scheduler/view/mixin/SchedulerStores
         * @mixes Scheduler/view/mixin/TimelineDateMapper
         * @mixes Scheduler/view/mixin/TimelineDomEvents
         * @mixes Scheduler/view/mixin/TimelineEventRendering
         * @mixes Scheduler/view/mixin/TimelineScroll
         * @mixes Scheduler/view/mixin/TimelineViewPresets
         * @mixes Scheduler/view/mixin/TimelineZoomable
         *
         * @extends Scheduler/view/TimelineBase
         */
        // SchedulerDragResize not included as @mixes above on purpose, since it is private

        var Scheduler =
        /*#__PURE__*/
        function (_base$mixes) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(Scheduler, _base$mixes);

          function Scheduler() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Scheduler);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Scheduler, [{
            key: "construct",
            //endregion
            //region Events

            /**
             * Fired after rendering an event, when its element is available in DOM.
             * @event renderEvent
             * @param {Scheduler.view.Scheduler} source This Scheduler
             * @param {Scheduler.model.EventModel} eventRecord The event record
             * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
             * @param {Scheduler.model.AssignmentModel} assignmentRecord The assignment record, if using an AssignmentStore
             * @param {Object} tplData An object containing details about the event rendering, see {@link Scheduler.view.mixin.SchedulerEventRendering#config-eventRenderer} for details
             * @param {HTMLElement} element The events element
             */
            //endregion
            //region Functions injected by features
            // For documentation & typings purposes

            /**
             * Opens an {@link Scheduler.view.EventEditor EventEditor} to edit the passed event.
             *
             * *NOTE: Only available when the {@link Scheduler/feature/EventEdit EventEdit} feature is enabled.*
             *
             * @function editEvent
             * @param {Scheduler.model.EventModel} eventRecord Event to edit
             * @param {Scheduler.model.ResourceModel} [resourceRecord] The Resource record for the event.
             * This parameter is needed if the event is newly created for a resource and has not been assigned, or when using
             * multi assignment.
             * @param {HTMLElement} [element] Element to anchor editor to (defaults to events element)
             * @category Feature shortcuts
             */
            //endregion
            //region Init
            value: function construct() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "construct", this).call(this, config);

              if (me.createEventOnDblClick) {
                me.on('scheduledblclick', me.onSchedulerDblClick);
              }
            } //endregion
            //region Config getters/setters
            // Overrides TimelineBase to supply eventStore as its store (which is only used in passed events)

          }, {
            key: "onLocaleChange",
            //endregion
            //region Event handlers
            value: function onLocaleChange() {
              this.currentOrientation.onLocaleChange();

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onLocaleChange", this).call(this);
            }
          }, {
            key: "onSchedulerHorizontalScroll",
            value: function onSchedulerHorizontalScroll(subGrid, scrollLeft) {
              // rerender cells in scheduler column on horizontal scroll to display events in view
              this.currentOrientation.updateFromHorizontalScroll(scrollLeft);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onSchedulerHorizontalScroll", this).call(this, subGrid, scrollLeft);
            }
          }, {
            key: "onSchedulerDblClick",
            value: function onSchedulerDblClick(_ref) {
              var startDate = _ref.date,
                  resourceRecord = _ref.resourceRecord,
                  row = _ref.row;
              var me = this;

              if (me.readOnly || resourceRecord.meta.specialRow) {
                return;
              }

              me.internalAddEvent(startDate, resourceRecord, row);
            }
          }, {
            key: "onTimeAxisViewModelUpdate",
            value: function onTimeAxisViewModelUpdate() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onTimeAxisViewModelUpdate", this).call(this);

              this.currentOrientation.onTimeAxisViewModelUpdate();
            }
          }, {
            key: "onColumnsChanged",
            value: function onColumnsChanged(_ref2) {
              var action = _ref2.action,
                  changes = _ref2.changes,
                  column = _ref2.record; // TODO: Have ResourceHeader call this directly instead of relying on event?

              if (column === this.timeAxisColumn && 'width' in changes) {
                this.updateCanvasSize();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onColumnsChanged", this).apply(this, arguments);
            } // Only used in vertical mode

          }, {
            key: "onVerticalScroll",
            value: function onVerticalScroll(_ref3) {
              var scrollTop = _ref3.scrollTop;
              this.currentOrientation.updateFromVerticalScroll(scrollTop);
            }
            /**
             * Called when new event is created.
             * Сan be overriden to supply default record values etc.
             * @param {Scheduler.model.EventModel} eventRecord Newly created event
            */

          }, {
            key: "onEventCreated",
            value: function onEventCreated(eventRecord) {} //endregion
            //region Mode

            /**
             * Checks if scheduler is in horizontal mode
             * @returns {Boolean}
             * @readonly
             * @category Common
             * @private
             */

          }, {
            key: "onElementKeyDown",
            //endregion
            //region Dom event dummies
            // this is ugly, but needed since super cannot be called from SchedulerDomEvents mixin...
            value: function onElementKeyDown(event) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onElementKeyDown", this).call(this, event);
            }
          }, {
            key: "onElementKeyUp",
            value: function onElementKeyUp(event) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onElementKeyUp", this).call(this, event);
            }
          }, {
            key: "onElementMouseOver",
            value: function onElementMouseOver(event) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onElementMouseOver", this).call(this, event);
            }
          }, {
            key: "onElementMouseOut",
            value: function onElementMouseOut(event) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "onElementMouseOut", this).call(this, event);
            } //endregion
            //region Context menu

            /**
             * A chainable function which Features may hook to add their own event context menu items
             * when context menu is invoked on an event.
             * @param {Object} params An object containing the available contextual information.
             * @param {Scheduler.model.EventModel} params.eventRecord The context event.
             * @param {Scheduler.model.ResourceModel} params.resourceRecord The context resource
             * @param {Scheduler.model.AssignmentModel} params.assignmentRecord The context assignment if any.
             * @param {HTMLElement} params.eventElement The context event's DOM element.
             * @param {Event} params.event The triggering DOM `contextmenu` event.
             */

          }, {
            key: "getEventMenuItems",
            value: function getEventMenuItems() {}
            /**
             * A chainable function which Features may hook to add their own Scheduler context menu items
             * when context menu is invoked on the scheduler, but not on an event.
             * @param {Object} params An object containing the available contextual information.
             * @param {Scheduler.model.ResourceModel} params.resourceRecord The context resource
             * @param {Date} params.date The Date corresponding to the mouse position in the time axis.
             * @param {HTMLElement} params.eventElement The context event's DOM element.
             * @param {Event} params.event The triggering DOM `contextmenu` event.
             */

          }, {
            key: "getScheduleMenuItems",
            value: function getScheduleMenuItems() {} //endregion
            //region Scheduler specific date mapping functions

          }, {
            key: "internalAddEvent",
            value: function internalAddEvent(startDate, resourceRecord, row) {
              var me = this,
                  resourceRecords = [resourceRecord],
                  eventRecord = new me.eventStore.modelClass({
                startDate: startDate,
                endDate: _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].add(startDate, 1, me.timeAxis.unit)
              });
              me.onEventCreated(eventRecord);

              if (me.eventEdit) {
                var eventData = me.currentOrientation.getTimeSpanRenderData(eventRecord, resourceRecord),
                    proxyEl = me.eventEdit.dragProxyElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].createElement({
                  parent: me.foregroundCanvas,
                  className: 'b-sch-dragcreator-proxy',
                  style: "width:".concat(eventData.width, "px;height:").concat(eventData.height, "px")
                });

                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"].setTranslateXY(proxyEl, eventData.left, (row && row.top || 0) + eventData.top);

                me.editEvent(eventRecord, resourceRecord, proxyEl);
                return;
              }
              /**
               * Fires before an event is added. Can be triggered by schedule double click, drag create action, or by the event editor.
               * @event beforeEventAdd
               * @param {Scheduler.view.Scheduler} source The Scheduler instance
               * @param {Scheduler.model.EventModel} eventRecord The record about to be added
               * @param {Scheduler.model.ResourceModel[]} resources **Deprecated** Use `resourceRecords` instead
               * @param {Scheduler.model.ResourceModel[]} resourceRecords Resources that the record is assigned to
               * @preventable
               */


              if (me.trigger('beforeEventAdd', {
                eventRecord: eventRecord,
                resourceRecords: resourceRecords,
                resources: resourceRecords
              }) !== false) {
                me.eventStore.add(eventRecord);
                me.eventStore.assignEventToResource(eventRecord, resourceRecord);
              }
            }
            /**
             * Checks if a date range is allocated or not for a given resource.
             * @param {Date} start The start date
             * @param {Date} end The end date
             * @param {Scheduler.model.EventModel} excludeEvent An event to exclude from the check (or null)
             * @param {Scheduler.model.ResourceModel} resource The resource
             * @return {Boolean} True if the timespan is available for the resource
             * @category Dates
             */

          }, {
            key: "isDateRangeAvailable",
            value: function isDateRangeAvailable(start, end, excludeEvent, resource) {
              return this.eventStore.isDateRangeAvailable(start, end, excludeEvent, resource);
            } //endregion

          }, {
            key: "timeAxisViewModel",
            set: function set(timeAxisViewModel) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "timeAxisViewModel", timeAxisViewModel, this, true);

              if (this.eventStore) {
                this.timeAxisViewModel.eventStore = this.eventStore;
              }
            },
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "timeAxisViewModel", this);
            } // Placeholder getter/setter for mixins, please make any changes needed to SchedulerStores#store instead

          }, {
            key: "store",
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "store", this);
            },
            set: function set(store) {
              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(Scheduler.prototype), "store", store, this, true);
            }
          }, {
            key: "isHorizontal",
            get: function get() {
              return this.mode === 'horizontal';
            }
            /**
             * Checks if scheduler is in vertical mode
             * @returns {Boolean}
             * @readonly
             * @category Common
             * @private
             */

          }, {
            key: "isVertical",
            get: function get() {
              return this.mode === 'vertical';
            }
            /**
             * Get/set mode (horizontal/vertical)
             * @property {String}
             * @private
             * @category Common
             */

          }, {
            key: "mode",
            get: function get() {
              return this._mode;
            },
            set: function set(mode) {
              var me = this;
              me._mode = mode;

              if (!me[mode]) {
                if (mode === 'horizontal') {
                  me.horizontal = new _orientation_HorizontalEventMapper_js__WEBPACK_IMPORTED_MODULE_25__["default"](me);

                  if (me.rendered) {
                    me.horizontal.init();
                  }

                  me.un('scroll', me.onVerticalScroll, me);
                } else if (mode === 'vertical') {
                  // Zooming is not yet supported in vertical mode, disable it
                  me.zoomOnTimeAxisDoubleClick = me.zoomOnMouseWheel = false;
                  me.vertical = new _orientation_VerticalEventMapper_js__WEBPACK_IMPORTED_MODULE_26__["default"](me);

                  if (me.rendered) {
                    me.vertical.init();
                  }

                  me.on('scroll', me.onVerticalScroll, me);
                }
              }
            }
          }, {
            key: "currentOrientation",
            get: function get() {
              return this[this.mode];
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * Scheduler mode. Supported values: horizontal, vertical
                 * @config {String} mode
                 * @default
                 */
                mode: 'horizontal',

                /**
                 * CSS class to add to rendered events
                 * @config {String}
                 * @category CSS
                 * @private
                 * @default
                 */
                eventCls: 'b-sch-event',

                /**
                 * CSS class to add to cells in the timeaxis column
                 * @config {String}
                 * @category CSS
                 * @private
                 * @default
                 */
                timeCellCls: 'b-sch-timeaxis-cell',
                timeCellSelector: '.b-sch-timeaxis-cell',
                scheduledEventName: 'event',

                /**
                 * A CSS class to apply to each event in the view on mouseover (defaults to 'b-sch-event-hover').
                 * @config {String}
                 * @default
                 * @category CSS
                 * @private
                 */
                overScheduledEventClass: 'b-sch-event-hover',

                /**
                 * Set to false if you don't want to allow events overlapping (defaults to true).
                 * @config {Boolean}
                 * @default
                 * @category Scheduled events
                 */
                allowOverlap: true,

                /**
                 * The height in pixels of Scheduler rows.
                 * @config {Boolean}
                 * @default
                 */
                rowHeight: 60,

                /**
                 * Factor representing the avarge char width in pixels used to determine milestone width when configured
                 * with `milestoneLayoutMode: 'estimate'`.
                 * @config {Number}
                 * @default
                 */
                milestoneCharWidth: 10,

                /**
                 * How to align milestones in relation to their startDate. Only applies when using a `milestoneLayoutMode`
                 * other than `default`. Valid values are:
                 * * start
                 * * center (default)
                 * * end
                 */
                milestoneAlign: 'center',
                // This is determined by styling, in the future it should be measured
                milestoneMinWidth: 40
              };
            }
          }]);

          return Scheduler;
        }(Object(_Common_helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_13__["base"])(_TimelineBase_js__WEBPACK_IMPORTED_MODULE_7__["default"]).mixes(_mixin_SchedulerDom_js__WEBPACK_IMPORTED_MODULE_15__["default"], _mixin_SchedulerDomEvents_js__WEBPACK_IMPORTED_MODULE_16__["default"], _mixin_SchedulerDragResize_js__WEBPACK_IMPORTED_MODULE_17__["default"], _mixin_SchedulerStores_js__WEBPACK_IMPORTED_MODULE_19__["default"], _mixin_SchedulerScroll_js__WEBPACK_IMPORTED_MODULE_20__["default"], _mixin_SchedulerState_js__WEBPACK_IMPORTED_MODULE_22__["default"], _mixin_SchedulerEventRendering_js__WEBPACK_IMPORTED_MODULE_18__["default"], _mixin_SchedulerRegions_js__WEBPACK_IMPORTED_MODULE_21__["default"], _mixin_EventSelection_js__WEBPACK_IMPORTED_MODULE_23__["default"], _mixin_EventNavigation_js__WEBPACK_IMPORTED_MODULE_24__["default"]));

        Scheduler._$name = 'Scheduler';

        _Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_10__["default"].register('scheduler', Scheduler);

        _Common_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].setVersion('scheduler', '2.2.4');
        /***/

      },

      /***/
      "./lib/Scheduler/view/TimelineBase.js":
      /*!********************************************!*\
        !*** ./lib/Scheduler/view/TimelineBase.js ***!
        \********************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewTimelineBaseJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimelineBase;
        });
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "./node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../Grid/view/Grid.js */
        "../Grid/lib/Grid/view/Grid.js");
        /* harmony import */


        var _Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../Common/helper/FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony import */


        var _Header_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ./Header.js */
        "./lib/Scheduler/view/Header.js");
        /* harmony import */


        var _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../data/TimeAxis.js */
        "./lib/Scheduler/data/TimeAxis.js");
        /* harmony import */


        var _model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ./model/TimeAxisViewModel.js */
        "./lib/Scheduler/view/model/TimeAxisViewModel.js");
        /* harmony import */


        var _Common_helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../../Common/helper/MixinHelper.js */
        "../Grid/lib/Common/helper/MixinHelper.js");
        /* harmony import */


        var _mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ./mixin/TimelineDateMapper.js */
        "./lib/Scheduler/view/mixin/TimelineDateMapper.js");
        /* harmony import */


        var _mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ./mixin/TimelineDomEvents.js */
        "./lib/Scheduler/view/mixin/TimelineDomEvents.js");
        /* harmony import */


        var _mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ./mixin/TimelineViewPresets.js */
        "./lib/Scheduler/view/mixin/TimelineViewPresets.js");
        /* harmony import */


        var _mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ./mixin/TimelineZoomable.js */
        "./lib/Scheduler/view/mixin/TimelineZoomable.js");
        /* harmony import */


        var _mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ./mixin/TimelineEventRendering.js */
        "./lib/Scheduler/view/mixin/TimelineEventRendering.js");
        /* harmony import */


        var _mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ./mixin/TimelineScroll.js */
        "./lib/Scheduler/view/mixin/TimelineScroll.js");
        /* harmony import */


        var _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ../../Common/util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        var timeAxisColumnConfigs = ['viewPreset', 'eventBarTextField', 'eventRenderer', 'eventRendererThisObj', 'eventBodyTemplate'],
            exitTransition = {
          fn: 'exitTransition',
          delay: 0,
          cancelOutstanding: true
        };
        /**
         * @module Scheduler/view/TimelineBase
         */

        /**
         * Abstract base class used by timeline based components such as Scheduler and Gantt. Based on Grid, supplies a "locked"
         * region for columns and a "normal" for rendering of events etc.
         * @abstract
         *
         * @mixes Scheduler/view/mixin/TimelineDateMapper
         * @mixes Scheduler/view/mixin/TimelineDomEvents
         * @mixes Scheduler/view/mixin/TimelineEventRendering
         * @mixes Scheduler/view/mixin/TimelineScroll
         * @mixes Scheduler/view/mixin/TimelineViewPresets
         * @mixes Scheduler/view/mixin/TimelineZoomable
         *
         * @extends Grid/view/Grid
         */

        var TimelineBase =
        /*#__PURE__*/
        function (_base$mixes) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_11___default()(TimelineBase, _base$mixes);

          function TimelineBase() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, TimelineBase);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(TimelineBase, [{
            key: "construct",
            //endregion
            //region Init
            value: function construct() {
              var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              var me = this,
                  region = config.schedulerRegion || 'normal',
                  _config$subGridConfig = config.subGridConfigs,
                  subGridConfigs = _config$subGridConfig === void 0 ? {} : _config$subGridConfig;
              config.subGridConfigs = subGridConfigs;
              subGridConfigs[region] = subGridConfigs[region] || {};
              subGridConfigs[region].headerClass = _Header_js__WEBPACK_IMPORTED_MODULE_18__["default"]; // If user have not specified a width or flex for scheduler region, default to flex=1

              if (!('flex' in subGridConfigs[region] || 'width' in subGridConfigs[region])) {
                subGridConfigs[region].flex = 1;
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "construct", this).call(this, config); // Buffer resize, since resize does full redraw it is costly


              me.onSchedulerViewportResize = me.throttle(me.onSchedulerViewportResize, 250);
              me.initDomEvents();
              me.currentOrientation.init();
              me.rowManager.on('refresh', function () {
                me.forceLayout = false;
              });

              if (me.loadMask && me.crudManager && me.crudManager.isLoading) {
                // Show loadmask if crud manager is already loading
                me.maskBody(me.loadMask);
              }
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              var me = this,
                  currentOrientation = this.currentOrientation;

              if (currentOrientation) {
                currentOrientation.destroy();
              } // Break links between this TimeLine and any partners.


              if (me.partneredWith) {
                me.partneredWith.forEach(function (p) {
                  me.removePartner(p);
                });
                me.partneredWith.destroy();
              }

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "doDestroy", this).call(this);
            }
          }, {
            key: "startConfigure",
            value: function startConfigure(config) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "startConfigure", this).call(this, config); // partner needs to be initialized first so that the various shared
              // configs are assigned first before we default them in.


              this._thisIsAUsedExpression(this.partner);
            }
          }, {
            key: "initSubGrids",
            value: function initSubGrids() {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "initSubGrids", this).call(this);

              var me = this,
                  timeAxisSubGrid = me.timeAxisSubGrid = me.timeAxisColumn.subGrid = me.subGrids[me.timeAxisColumn.region]; // Scheduler SubGrid doesn't accept external columns moving in

              timeAxisSubGrid.sealedColumns = true;
              timeAxisSubGrid.on({
                resize: me.onTimeAxisSubGridResize,
                thisObj: me
              });
            }
            /**
             * Overrides initScroll from Grid, listens for horizontal scroll to do virtual event rendering
             * @private
             */

          }, {
            key: "initScroll",
            value: function initScroll() {
              var me = this,
                  frameCount = 0;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "initScroll", this).call(this);

              me.on('horizontalscroll', function (_ref) {
                var subGrid = _ref.subGrid,
                    scrollLeft = _ref.scrollLeft;

                if (me.rendered && subGrid === me.timeAxisSubGrid) {
                  me.onSchedulerHorizontalScroll(subGrid, scrollLeft);
                }

                frameCount++;
              });

              if (me.testPerformance === 'horizontal') {
                setTimeout(function () {
                  var start = performance.now(),
                      // eslint-disable-line no-undef
                  scrollSpeed = 5,
                      direction = 1;
                  var scrollInterval = setInterval(function () {
                    scrollSpeed = scrollSpeed + 5;
                    me.scrollLeft += (10 + Math.floor(scrollSpeed)) * direction;

                    if (direction === 1 && me.scrollLeft > 5500) {
                      direction = -1;
                      scrollSpeed = 5;
                    }

                    if (direction === -1 && me.scrollLeft <= 0) {
                      var done = performance.now(),
                          // eslint-disable-line no-undef
                      elapsed = done - start;
                      var timePerFrame = elapsed / frameCount,
                          fps = 1000 / timePerFrame;
                      fps = Math.round(fps * 10) / 10;
                      clearInterval(scrollInterval);
                      console.log(me.eventPositionMode, me.eventScrollMode, fps + 'fps');
                    }
                  }, 0);
                }, 500);
              }
            } //endregion
            //region Config getters/setters

            /**
             * Returns `true` if any of the events/tasks or feature injected elements (such as ResourceTimeRanges) are within
             * the {@link #config-timeAxis}
             * @property {Boolean}
             * @readonly
             */

          }, {
            key: "noFeatureElementsInAxis",
            // Template function to be chained in features to determine if any elements are in time axis (needed since we cannot
            // currently chain getters). Negated to not break chain. First feature that has elements visible returns false,
            // which prevents other features from being queried.
            value: function noFeatureElementsInAxis() {} // Private getter used to piece togheter event names such as beforeEventDrag / beforeTaskDrag. Could also be used
            // in templates.

          }, {
            key: "removePartner",
            value: function removePartner(partner) {
              var me = this,
                  partneredWith = me.partneredWith;

              if (partneredWith && partneredWith.includes(partner)) {
                partneredWith.remove(partner);
                partner.partneredWith.remove(me);
                partner.scrollable.removePartner(me.scrollable);
                partner.un({
                  presetchange: 'onPartnerPresetChange',
                  thisObj: me
                });
                me.un({
                  presetchange: 'onPartnerPresetChange',
                  thisObj: partner
                });
              }
            }
          }, {
            key: "onPartnerPresetChange",
            value: function onPartnerPresetChange(_ref2) {
              var preset = _ref2.preset,
                  startDate = _ref2.startDate,
                  endDate = _ref2.endDate,
                  centerDate = _ref2.centerDate;

              if (this.viewPreset !== preset) {
                // Passing more params directly to make zoom behave identically. See #8764
                this.setViewPreset(preset, startDate, endDate, false, {
                  centerDate: centerDate
                });
              }
            }
          }, {
            key: "applyWorkingTime",
            // Translates the workingTime configs into TimeAxis#include rules, applies them and then refreshes the header and
            // redraws the events
            value: function applyWorkingTime(timeAxis) {
              var me = this,
                  config = me._workingTime;

              if (config) {
                var hour = null; // Only use valid values

                if (config.fromHour >= 0 && config.fromHour < 24 && config.toHour > config.fromHour && config.toHour <= 24 && config.toHour - config.fromHour < 24) {
                  hour = {
                    from: config.fromHour,
                    to: config.toHour
                  };
                }

                var day = null; // Only use valid values

                if (config.fromDay >= 0 && config.fromDay < 7 && config.toDay > config.fromDay && config.toDay <= 7 && config.toDay - config.fromDay < 7) {
                  day = {
                    from: config.fromDay,
                    to: config.toDay
                  };
                }

                if (hour || day) {
                  timeAxis.include = {
                    hour: hour,
                    day: day
                  };
                } else {
                  // No valid rules, restore timeAxis
                  timeAxis.include = null;
                }
              } else {
                // No rules, restore timeAxis
                timeAxis.include = null;
              }

              if (me.rendered) {
                // Refreshing header, which also recalculate tickSize and header data
                me.timeAxisColumn.refreshHeader(); // Update column lines

                if (me.features.columnLines) {
                  me.features.columnLines.drawLines();
                } // Animate event changes


                me.refreshWithTransition();
              }
            }
            /**
             * Get/set startDate. Defaults to current date if none specified.
             *
             * **Note:** If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
             * @property {Date}
             * @category Common
             */

          }, {
            key: "setStartDate",

            /**
             * Sets the timeline start date.
             *
             * **Note:**
             * - If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
             * - If keepDuration is false and new start date is greater than end date, it will throw an exception.
             *
             * @param {Date} date The new start date
             * @param {Boolean} keepDuration Pass `true` to keep the duration of the timeline ("move" the timeline),
             * `false` to change the duration ("resize" the timeline). Defaults to `true`.
             */
            value: function setStartDate(date) {
              var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var me = this,
                  ta = me._timeAxis || {},
                  startDate = ta.startDate,
                  endDate = ta.endDate,
                  mainUnit = ta.mainUnit;

              if (me._timeAxis && endDate) {
                if (date) {
                  var calcEndDate = endDate;

                  if (keepDuration && startDate) {
                    var diff = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].diff(startDate, endDate, mainUnit, true);

                    calcEndDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].add(date, diff, mainUnit);
                  }

                  ta.setTimeSpan(date, calcEndDate);
                }
              } else {
                me._tempStartDate = date;
              }
            }
          }, {
            key: "setEndDate",

            /**
             * Sets the timeline end date
             *
             * **Note:**
             * - If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
             * - If keepDuration is false and new end date is less than start date, it will throw an exception.
             *
             * @param {Date} date The new end date
             * @param {Boolean} keepDuration Pass `true` to keep the duration of the timeline ("move" the timeline),
             * `false` to change the duration ("resize" the timeline). Defaults to `false`.
             */
            value: function setEndDate(date) {
              var keepDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  ta = me._timeAxis || {},
                  startDate = ta.startDate,
                  endDate = ta.endDate,
                  mainUnit = ta.mainUnit;

              if (me._timeAxis && startDate) {
                if (date) {
                  var calcStartDate = startDate;

                  if (keepDuration && endDate) {
                    var diff = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].diff(startDate, endDate, mainUnit, true);

                    calcStartDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].add(date, -diff, mainUnit);
                  }

                  ta.setTimeSpan(calcStartDate, date);
                }
              } else {
                me._tempEndDate = date;
              }
            }
          }, {
            key: "onLocaleChange",
            //endregion
            //region Event handlers
            value: function onLocaleChange() {
              // Clear events in case they use date as part of displayed info
              //        this.currentOrientation.cache.clear();
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "onLocaleChange", this).call(this);

              this.timeAxisColumn.refreshHeader();
            }
            /**
             * This is a template method called by Widget when the encapsulating Scheduler SubGrid size.
             * Width changes *might* affect the Scheduler SubGrid, and *that* will trigger its
             * handler below, if that is the case. Here, we are only interested in the height changing because the
             * encapsulating grid is what dictates the scrolling viewport height.
             * @param {HTMLElement} element
             * @param {Number} width
             * @param {Number} height
             * @param {Number} oldWidth
             * @param {Number} oldHeight
             * @private
             */

          }, {
            key: "onInternalResize",
            value: function onInternalResize(element, width, height, oldWidth, oldHeight) {
              // Cache before its updated by super call.
              var oldSchedulerBodyRect = this._bodyRectangle;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "onInternalResize", this).call(this, element, width, height, oldWidth, oldHeight); // The Scheduler (The Grid) dictates the viewport height.


              if (oldSchedulerBodyRect && height !== oldHeight) {
                this.onSchedulerViewportResize(oldSchedulerBodyRect.width, this.bodyContainer.offsetHeight, oldSchedulerBodyRect.width, oldSchedulerBodyRect.height);
              }
            }
            /**
             * This is an event handler triggered when the Scheduler SubGrid changes size.
             * Its height changes when content height changes, and that is not what we are
             * interested in here. If the *width* changes, that means the visible viewport
             * has changed size.
             * @param {HTMLElement} element
             * @param {Number} width
             * @param {Number} height
             * @param {Number} oldWidth
             * @param {Number} oldHeight
             * @private
             */

          }, {
            key: "onTimeAxisSubGridResize",
            value: function onTimeAxisSubGridResize(_ref3) {
              var width = _ref3.width,
                  height = _ref3.height,
                  oldWidth = _ref3.oldWidth,
                  oldHeight = _ref3.oldHeight; // The timeAxisSubGrid dictates the viewport width.

              if (width !== oldWidth) {
                var schedulerBodyRect = this._bodyRectangle;
                this.onSchedulerViewportResize(width, schedulerBodyRect.height, oldWidth, schedulerBodyRect.height);
              }
            } // Note: This function is throttled in construct(), since it will do a full redraw per call

          }, {
            key: "onSchedulerViewportResize",
            value: function onSchedulerViewportResize(width, height, oldWidth, oldHeight) {
              var me = this,
                  subGrid = me.timeAxisSubGrid;

              if (me.rendered) {
                me.currentOrientation.onViewportResize(width, height, oldWidth, oldHeight); // Ignore resize caused by toggling vertical scrollbar visibility, since those might otherwise lead to an
                // infinite loop when the difference between on/off causes horizontal scrolling to also toggle

                if (me._lastOverflow == null || me._lastOverflow === subGrid.overflowingHorizontally) {
                  // Responding by triggering a layout in the same frame seems to trigger an infinite resize
                  // loop when using ResizeObserver, so push the response out into the next frame.
                  me.setTimeout(function () {
                    me.timeAxisViewModel.availableSpace = me.isHorizontal ? subGrid.width : subGrid.height;
                  }, 0);
                  me.partneredWith && !me.isSyncingFromPartner && me.partneredWith.forEach(function (p) {
                    if (!p.isSyncingFromPartner) {
                      p.isSyncingFromPartner = true;
                      me.eachSubGrid(function (subGrid) {
                        var partnerSubGrid = p.subGrids[subGrid.region]; // If there is a difference, sync the partner SubGrid state

                        if (partnerSubGrid.width !== subGrid.width) {
                          if (subGrid.collapsed) {
                            partnerSubGrid.collapse();
                          } else {
                            if (partnerSubGrid.collapsed) {
                              partnerSubGrid.expand();
                            } // When using flexed subgrid, make sure flex values has prio over width


                            if (subGrid.flex) {
                              // If flex values match, resize should be fine without changing anything
                              if (subGrid.flex !== partnerSubGrid.flex) {
                                partnerSubGrid.flex = subGrid.flex;
                              }
                            } else {
                              partnerSubGrid.width = subGrid.width;
                            }
                          }
                        }
                      });
                      p.isSyncingFromPartner = false;
                    }
                  });
                } // NOTE: Moved out of the if-statement above since that prevented event from being triggered in all
                // scenarios where size has changed

                /**
                 * Fired when the *scheduler* viewport (not the overall Scheduler element) changes size.
                 * This happens when the grid changes height, or when the subgrid which encapsulates the
                 * scheduler column changes width.
                 * @event timelineViewportResize
                 * @param {Common.widget.Widget} source - This Scheduler
                 * @param {Number} width The new width
                 * @param {Number} height The new height
                 * @param {Number} oldWidth The old width
                 * @param {Number} oldHeight The old height
                 */


                me.trigger('timelineViewportResize', {
                  width: width,
                  height: height,
                  oldWidth: oldWidth,
                  oldHeight: oldHeight
                });
                me._lastOverflow = subGrid.overflowingHorizontally;
              }
            }
          }, {
            key: "onTimeAxisViewModelUpdate",
            value: function onTimeAxisViewModelUpdate() {
              this.updateCanvasSize();

              if (this.isHorizontal) {
                // might also have changed total width of timeaxiscolumn, make sure scrollers are in sync
                // TODO: should this be detected by resizeobserver instead? but it is the actual column changing size and not the subgrid so might not make sense
                this.callEachSubGrid('refreshFakeScroll');
                this.refreshVirtualScrollbars();
              }
            } //endregion
            //region Mode

          }, {
            key: "updateCanvasSize",
            value: function updateCanvasSize() {
              var me = this;

              if (me.isHorizontal) {
                if (me.backgroundCanvas) {
                  me.backgroundCanvas.style.width = "".concat(me.timeAxisViewModel.totalSize, "px");
                }

                me.foregroundCanvas.style.width = "".concat(me.timeAxisViewModel.totalSize, "px");
              } else {
                if (me.backgroundCanvas) {
                  me.backgroundCanvas.style.width = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].setLength(me.timeAxisColumn.width);
                }

                me.foregroundCanvas.style.width = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].setLength(me.timeAxisColumn.width);
              }
            } //endregion
            //region Grid overrides

          }, {
            key: "refresh",
            value: function refresh() {
              var forceLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
              var refreshMoreFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var me = this;

              if (me.rendered && !me.refreshSuspended) {
                if (me.hasVisibleEvents) {
                  me.refreshRows(false, forceLayout);

                  if (refreshMoreFn) {
                    refreshMoreFn();
                  }
                } // Even if there are no events in our timeline, Features
                // assume there will be a refresh event from the RowManager
                // after a refresh request so fire it here.
                else {
                    me.rowManager.trigger('refresh');
                  }
              }
            }
          }, {
            key: "render",
            value: function render(element) {
              var me = this,
                  schedulerEl = me.timeAxisSubGridElement;

              if (me.useBackgroundCanvas) {
                me._backgroundCanvas = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement({
                  className: 'b-sch-background-canvas',
                  parent: schedulerEl,
                  nextSibling: schedulerEl.firstElementChild
                });
              }

              var fgCanvas = me._foregroundCanvas = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElement({
                className: 'b-sch-foreground-canvas',
                style: "font-size:".concat(me.rowHeight - me.barMargin * 2, "px"),
                parent: schedulerEl
              });

              me.timeAxisSubGrid.insertRowsBefore = fgCanvas;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "render", this).call(this, element);
            } // TODO: refreshRows -> refresh in grid?

          }, {
            key: "refreshRows",
            value: function refreshRows() {
              var returnToTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var reLayoutEvents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
              var me = this;

              if (me.isConfiguring) {
                return;
              }

              me.currentOrientation.refreshRows(reLayoutEvents);

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "refreshRows", this).call(this, returnToTop);
            } // TODO: Dont think we have this in grid any longer??

          }, {
            key: "reRender",
            value: function reRender() {
              var skipPreRenderRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              this.refreshFromRerender = true;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "reRender", this).call(this, skipPreRenderRefresh);

              this.initDomEvents();
            } //endregion
            //region Other

          }, {
            key: "getDateConstraints",
            value: function getDateConstraints() {} // duration = false prevents transition

          }, {
            key: "runWithTransition",
            value: function runWithTransition(fn, duration) {
              var me = this; // Do not attempt to enter animating state if we are not visible

              if (me.isVisible) {
                // Allow calling with true/false to keep code simpler in other places
                if (duration == null || duration === true) {
                  duration = me.transitionDuration;
                } // Ask Grid superclass to enter the animated state if requested and enabled.


                if (duration && me.enableEventAnimations) {
                  me.isAnimating = true; // Exit animating state in duration milliseconds.
                  // Cancel any previous outstanding exit timer.

                  exitTransition.delay = duration;
                  me.setTimeout(exitTransition);
                }
              }

              fn();
            }
          }, {
            key: "exitTransition",
            value: function exitTransition() {
              this.isAnimating = false;
              this.trigger('transitionend');
            }
            /**
             * Refreshes the grid with transitions enabled.
             */

          }, {
            key: "refreshWithTransition",
            value: function refreshWithTransition(forceLayout) {
              var _this = this;

              this.runWithTransition(function () {
                return _this.refresh(forceLayout);
              });
            }
            /**
             * Returns an object representing the visible date range, with `startDate` and `endDate` properties
             * @return {Object} The date range
             * @return {Date} return.startDate Start date
             * @return {Date} return.endDate End date
             */

          }, {
            key: "getVisibleDateRange",
            value: function getVisibleDateRange() {
              return this.currentOrientation.getVisibleDateRange();
            } //endregion

          }, {
            key: "hasVisibleEvents",
            get: function get() {
              var _this2 = this;

              return !this.noFeatureElementsInAxis() || this.eventStore.storage.values.some(function (t) {
                return _this2.timeAxis.isTimeSpanInAxis(t);
              });
            }
          }, {
            key: "capitalizedEventName",
            get: function get() {
              if (!this._capitalizedEventName) {
                this._capitalizedEventName = _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].capitalizeFirstLetter(this.scheduledEventName);
              }

              return this._capitalizedEventName;
            }
          }, {
            key: "partner",
            set: function set(partner) {
              var me = this,
                  partneredWith = me.partneredWith || (me.partneredWith = new _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_28__["default"]());
              me._partner = partner;

              if (!partneredWith.includes(partner)) {
                // Each must know about the other so that they can sync others upon region resize
                partneredWith.add(partner);
                (partner.partneredWith || (partner.partneredWith = new _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_28__["default"]())).add(me);
                partner.on({
                  presetchange: 'onPartnerPresetChange',
                  thisObj: me
                });
                me.on({
                  presetchange: 'onPartnerPresetChange',
                  thisObj: partner
                });
                me.setConfig({
                  viewPreset: partner.viewPreset,
                  timeAxis: partner.timeAxis,
                  timeAxisViewModel: partner.timeAxisViewModel
                }); // When initScroll comes round, make sure it syncs with the partner

                me.initScroll = _Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].createSequence(me.initScroll, function () {
                  me.scrollable.addPartner(partner.scrollable, 'x');
                }, me);
              }
            },
            get: function get() {
              return this._partner;
            }
          }, {
            key: "timeAxisColumn",
            get: function get() {
              return this.columns && this._timeAxisColumn;
            }
          }, {
            key: "columns",
            get: function get() {
              // Maintainer. If we do not implement a getter to go along with our setter, this
              // property becomes unreadable at this class level.
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "columns", this);
            },
            set: function set(columns) {
              var me = this;
              var timeAxisColumnIndex = columns && columns.length,
                  timeAxisColumnConfig = {},
                  timeAxisColumn,
                  value; // No columns means destroy

              if (columns) {
                columns.forEach(function (col, index) {
                  if (col.type === 'timeAxis') {
                    timeAxisColumnIndex = index;
                    timeAxisColumnConfig = col;
                  }
                }); // TODO : This is scheduler specific, override `set columns` instead
                // No additional columns allowed in vertical mode, but store the specified set in case we toggle mode later

                if (me.isVertical) {
                  me._horizontalColumns = columns;
                  columns = [{
                    type: 'verticalTimeAxis',
                    locked: true,
                    timeline: me
                  }, columns[timeAxisColumnIndex]];
                  timeAxisColumnIndex = 1;
                } else {
                  // We're going to mutate this array which we do not own, so copy it first.
                  columns = columns.slice();
                } // Fix up the timeAxisColumn config in place


                timeAxisColumnConfig = columns[timeAxisColumnIndex] = Object.assign({
                  type: 'timeAxis',
                  locked: false,
                  timeline: me,
                  cellCls: me.timeCellCls,
                  mode: me.mode
                }, timeAxisColumnConfig); // Pass these configs into the timeAxisColumnConfig

                timeAxisColumnConfigs.forEach(function (configName) {
                  value = me[configName];

                  if (value != null) {
                    timeAxisColumnConfig[configName] = value;
                  }
                });
              } // Invoke Grid's setter. Will create a ColumnStore which is returned by the columns setter.


              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "columns", columns, this, true);

              if (columns) {
                timeAxisColumn = me._timeAxisColumn = me.columns.getAt(timeAxisColumnIndex); // Set up event relaying early

                timeAxisColumn.relayAll(me);
              }
            }
          }, {
            key: "eventCls",
            set: function set(eventCls) {
              var me = this;
              me._eventCls = eventCls;

              if (!me.eventSelector) {
                me.eventSelector = ".".concat(eventCls, "-wrap");
                me.unreleasedEventSelector = "".concat(me.eventSelector, ":not(.b-sch-released)");
              }

              if (!me.eventInnerSelector) {
                me.eventInnerSelector = '.' + eventCls;
              }
            },
            get: function get() {
              return this._eventCls;
            }
          }, {
            key: "timeAxisViewModel",
            set: function set(timeAxisViewModel) {
              var me = this,
                  tavmListeners = {
                update: 'onTimeAxisViewModelUpdate',
                prio: 100,
                thisObj: me
              };

              if (me.partner && !timeAxisViewModel) {
                return;
              }

              if (timeAxisViewModel instanceof _model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_20__["default"]) {
                timeAxisViewModel.on(tavmListeners);
              } else {
                timeAxisViewModel = Object.assign({
                  mode: me._mode,
                  snap: me.snap,
                  forceFit: me.forceFit,
                  timeAxis: me.timeAxis,
                  listeners: tavmListeners
                }, timeAxisViewModel);
                timeAxisViewModel = new _model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_20__["default"](timeAxisViewModel);
              }

              me._timeAxisViewModel = timeAxisViewModel;
            }
            /**
             * The internal view model, describing the visual representation of the time axis.
             * @property {Scheduler.view.model.TimeAxisViewModel}
             * @readonly
             */
            ,
            get: function get() {
              if (!this._timeAxisViewModel) {
                this.timeAxisViewModel = null;
              }

              return this._timeAxisViewModel;
            }
          }, {
            key: "timeAxis",
            set: function set(timeAxis) {
              var me = this;

              if (me.partner && !timeAxis) {
                return;
              }

              me.timeAxisDetacher && me.timeAxisDetacher();

              if (!(timeAxis instanceof _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_19__["default"])) {
                timeAxis = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_29__["default"].assign({
                  viewPreset: me.viewPreset,
                  autoAdjust: me.autoAdjustTimeAxis,
                  mode: 'plain',
                  weekStartDay: me.weekStartDay
                }, timeAxis);

                if (me.startDate) {
                  timeAxis.startDate = me.startDate;
                }

                if (me.endDate) {
                  timeAxis.endDate = me.endDate;
                }

                if (me.workingTime) {
                  me.applyWorkingTime(timeAxis);
                }

                timeAxis = new _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_19__["default"](timeAxis);
              } // Inform about reconfiguring the timeaxis, to allow users to react to start & end date changes


              me.timeAxisDetacher = timeAxis.on({
                thisObj: me,
                reconfigure: function reconfigure(_ref4) {
                  var config = _ref4.config;
                  /**
                   * Fired when the timeaxis has changed, for example by zooming or configuring a new time span.
                   * @event timeAxisChange
                   * @param {Scheduler.view.Scheduler} source - This Scheduler
                   * @param {Object} config Config object used to reconfigure the time axis.
                   * @param {Date} config.start New start date (if supplied)
                   * @param {Date} config.end New end date (if supplied)
                   */

                  me.trigger('timeAxisChange', {
                    config: config
                  });
                }
              });
              me._timeAxis = timeAxis;
            },
            get: function get() {
              if (!this._timeAxis) {
                this.timeAxis = null;
              }

              return this._timeAxis;
            }
            /**
             * Get/set working time. Assign `null` to stop using working time. See {@link #config-workingTime} config for details.
             * @property {Object}
             */

          }, {
            key: "workingTime",
            set: function set(config) {
              this._workingTime = config;

              if (!this.isConfiguring) {
                this.applyWorkingTime(this.timeAxis);
              }
            },
            get: function get() {
              return this._workingTime;
            }
          }, {
            key: "startDate",
            set: function set(date) {
              this.setStartDate(date);
            },
            get: function get() {
              var me = this;

              if (me._timeAxis) {
                return me._timeAxis.startDate;
              }

              return me._tempStartDate || new Date();
            }
            /**
             * Get/set endDate. Defaults to startDate + default span of the used ViewPreset.
             *
             * **Note:** If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
             * @property {Date}
             * @category Common
             */

          }, {
            key: "endDate",
            set: function set(date) {
              this.setEndDate(date);
            },
            get: function get() {
              var me = this;

              if (me._timeAxis) {
                return me._timeAxis.endDate;
              }

              return me._tempEndDate || _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].add(me.startDate, me.viewPreset.defaultSpan, me.viewPreset.mainHeader.unit);
            }
          }, {
            key: "features",
            get: function get() {
              return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_10___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "features", this);
            } // add region resize by default
            ,
            set: function set(features) {
              features = features === true ? {} : features;

              if (!('regionResize' in features)) {
                features.regionResize = true;
              }

              _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_9___default()(TimelineBase.prototype), "features", features, this, true);
            }
          }, {
            key: "eventStyle",
            get: function get() {
              return this._eventStyle;
            },
            set: function set(style) {
              var me = this;
              me._eventStyle = style;

              if (me.rendered) {
                me.refreshWithTransition();
              }
            }
          }, {
            key: "eventColor",
            get: function get() {
              return this._eventColor;
            },
            set: function set(color) {
              var me = this;
              me._eventColor = color;

              if (me.rendered) {
                me.refreshWithTransition();
              }
            }
          }, {
            key: "currentOrientation",
            get: function get() {
              throw new Error('Implement in subclass');
            } // Horizontal is the default, overridden in scheduler

          }, {
            key: "isHorizontal",
            get: function get() {
              return true;
            } //endregion
            //region Canvases and elements

          }, {
            key: "backgroundCanvas",
            get: function get() {
              return this._backgroundCanvas;
            }
          }, {
            key: "foregroundCanvas",
            get: function get() {
              return this._foregroundCanvas;
            }
          }, {
            key: "svgCanvas",
            get: function get() {
              var me = this;

              if (!me._svgCanvas) {
                var svg = me._svgCanvas = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                me.foregroundCanvas.appendChild(svg);
                me.trigger('svgCanvasCreated');
              }

              return me._svgCanvas;
            }
          }, {
            key: "timeAxisSubGridElement",
            get: function get() {
              return this.timeAxisColumn && this.timeAxisColumn.subGridElement;
            }
          }], [{
            key: "defaultConfig",
            //region Config
            get: function get() {
              return {
                /**
                 * A valid JS day index between 0-6 (0: Sunday, 1: Monday etc.) to be considered the start day of the week.
                 * When omitted, the week start day is retrieved from the active locale class.
                 * @config {Number}
                 * @category Time axis
                 */
                weekStartDay: _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].weekStartDay,

                /**
                 * An object with format `{ fromDay, toDay, fromHour, toHour }` that describes the working days and hours.
                 * This object will be used to populate TimeAxis {@link Scheduler.data.TimeAxis#config-include} property.
                 *
                 * Using it results in a non-continuous time axis. Any ticks not covered by the working days and hours will
                 * be excluded. Events within larger ticks (for example if using week as the unit for ticks) will be
                 * stretched to fill the gap otherwise left by the non working hours.
                 *
                 * As with end dates, `toDay` and `toHour` are exclusive. Thus `toDay : 6` means that day 6 (saturday) will
                 * not be included.
                 *
                 *
                 * **NOTE:** When this feature is enabled {@link Scheduler.view.mixin.TimelineZoomable Zooming feature} is not supported. It's recommended to disable zooming controls:
                 *
                 * ```javascript
                 * new Scheduler({
                 *     zoomOnMouseWheel          : false,
                 *     zoomOnTimeAxisDoubleClick : false,
                 *     ...
                 * });
                 * ```
                 *
                 * @config {Object}
                 * @category Time axis
                 */
                workingTime: null,

                /**
                 * The backing store providing the input date data for the timeline panel. Created automatically if none
                 * supplied.
                 * @config {Scheduler.data.TimeAxis}
                 * @category Time axis
                 */
                timeAxis: null,

                /**
                 * The backing view model for the visual representation of the time axis.
                 * Either a real instance or a simple config object.
                 * @private
                 * @config {Scheduler.view.model.TimeAxisViewModel|Object}
                 * @category Time axis
                 */
                timeAxisViewModel: null,

                /**
                 * You can set this option to `false` to make the timeline panel start and end on the exact provided
                 * {@link #config-startDate}/{@link #config-endDate} w/o adjusting them.
                 * @config {Boolean}
                 * @default
                 * @category Time axis
                 */
                autoAdjustTimeAxis: true,

                /**
                 * The start date of the timeline. If omitted, and a TimeAxis has been set, the start date of the provided {@link Scheduler.data.TimeAxis} will be used.
                 * If no TimeAxis has been configured, it'll use the start/end dates of the loaded event dataset. If no date information exists in the event data
                 * set, it defaults to the current date and time.
                 *
                 * **Note:** If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
                 * @config {Date}
                 * @category Common
                 */
                startDate: null,

                /**
                 * The end date of the timeline. If omitted, it will be calculated based on the {@link #config-startDate} setting and
                 * the 'defaultSpan' property of the current {@link Scheduler.view.mixin.TimelineViewPresets#config-viewPreset}.
                 *
                 * **Note:** If you need to set start and end date at the same time, use {@link Scheduler.view.mixin.TimelineZoomable#function-setTimeSpan} method.
                 * @config {Date}
                 * @category Common
                 */
                endDate: null,

                /**
                 * true to snap to resolution increment while interacting with scheduled events.
                 * @config {Boolean}
                 * @default
                 * @category Scheduled events
                 */
                snap: false,

                /**
                 * Affects drag drop and resizing of events when {@link #config-snap} is enabled. If set to `true`, dates will be snapped relative to event start.
                 * e.g. for a zoom level with timeResolution = { unit: "s", increment: "20" }, an event that starts at 10:00:03 and is dragged would snap its start date to 10:00:23, 10:00:43 etc.
                 * When set to `false`, dates will be snapped relative to the timeAxis startDate (tick start) - 10:00:03, 10:00:20, 10:00:40 etc.
                 * @config {Boolean}
                 * @default
                 * @category Scheduled events
                 */
                snapRelativeToEventStartDate: false,

                /**
                 * Set to true to force the time columns to fit to the available horizontal space.
                 * @config {Boolean}
                 * @default
                 * @category Time axis
                 */
                forceFit: false,

                /**
                 * CSS class to add to rendered events
                 * @config {String}
                 * @category CSS
                 * @private
                 */
                eventCls: null,

                /**
                 * Returns dates that will constrain resize and drag operations. The method will be called with the Resource, and
                 * for operations on existing events - the event. For drag create operation, the mousedown date will be passed as the second parameter
                 * @return {Object} Constraining object
                 * @return {Date} return.start Start date
                 * @return {Date} return.end End date
                 * @config {Number}
                 * @category Scheduled events
                 */
                getDateConstraints: null,

                /**
                 * CSS class to add to cells in the timeaxis column
                 * @config {String}
                 * @category CSS
                 * @private
                 */
                timeCellCls: null,
                timeCellSelector: null,
                scheduledEventName: null,

                /**
                 * Create event on double click if scheduler is not in read only mode.
                 * Set to false to turn creating off.
                 * @config {Boolean}
                 * @default
                 * @category Scheduled events
                 */
                createEventOnDblClick: true,
                //dblClickTime : 200,

                /**
                 * A CSS class to apply to each event in the view on mouseover.
                 * @config {String}
                 * @category CSS
                 * @private
                 */
                overScheduledEventClass: null,
                // allow the panel to prevent adding the hover CSS class in some cases - during drag drop operations
                preventOverCls: false,
                // The last hovered over event bar HTML node
                hoveredEventNode: null,
                // This setting is set to true by features that need it
                useBackgroundCanvas: false,

                /**
                 * Set to `false` if you don't want event bar DOM updates to animate. Animations are disabled in IE11 by default.
                 * @config {Boolean}
                 * @default true
                 * @category Scheduled events
                 */
                enableEventAnimations: !_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].isIE11,
                disableGridRowModelWarning: true,
                // does not look good with locked columns and also interferes with event animations
                animateRemovingRows: false,

                /**
                 * Partners this Timeline panel with another Timeline in order to sync their region sizes (sub-grids like locked, normal will get the same width),
                 * start and end dates, view preset, zoom level and scrolling position. All these values will be synced with the timeline defined as the `partner`.
                 * @config {Scheduler.view.TimelineBase}
                 * @category Time axis
                 */
                partner: null,
                schedulerRegion: 'normal',
                transitionDuration: 200,
                // internal timer id reference
                animationTimeout: null,

                /**
                 * How to handle milestones during event layout. Options are:
                 * * default - Milestones do not affect event layout
                 * * estimate - Milestone width is estimated by multiplying text length with Scheduler#milestoneCharWidth
                 * * data - Milestone width is determined by checking EventModel#milestoneWidth
                 * * measure - Milestone width is determined by measuring label width
                 * Please note that currently text width is always determined using EventModel#name.
                 * Also note that only 'default' is supported by eventStyles line, dashed and minimal.
                 * @config {String}
                 * @default
                 * @category Scheduled events
                 */
                milestoneLayoutMode: 'default',

                /**
                 * Region to which columns are added when they have none specified
                 * @config {string}
                 * @default
                 * @category Misc
                 */
                defaultRegion: 'locked'
              };
            }
          }]);

          return TimelineBase;
        }(Object(_Common_helper_MixinHelper_js__WEBPACK_IMPORTED_MODULE_21__["base"])(_Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_12__["default"]).mixes(_mixin_TimelineDateMapper_js__WEBPACK_IMPORTED_MODULE_22__["default"], _mixin_TimelineDomEvents_js__WEBPACK_IMPORTED_MODULE_23__["default"], _mixin_TimelineEventRendering_js__WEBPACK_IMPORTED_MODULE_26__["default"], _mixin_TimelineScroll_js__WEBPACK_IMPORTED_MODULE_27__["default"], _mixin_TimelineViewPresets_js__WEBPACK_IMPORTED_MODULE_24__["default"], _mixin_TimelineZoomable_js__WEBPACK_IMPORTED_MODULE_25__["default"]));

        TimelineBase._$name = 'TimelineBase';
        /***/
      },

      /***/
      "./lib/Scheduler/view/VerticalTimeAxis.js":
      /*!************************************************!*\
        !*** ./lib/Scheduler/view/VerticalTimeAxis.js ***!
        \************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewVerticalTimeAxisJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return VerticalTimeAxis;
        });
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../Common/helper/util/DomClassList.js */
        "../Grid/lib/Common/helper/util/DomClassList.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/VerticalTimeAxis
         */

        function isLastLevel(level, levels) {
          return level === levels.length - 1;
        }

        function isLastCell(level, cell) {
          return cell === level.cells[level.cells.length - 1];
        }
        /**
         * Widget that renders a vertical time axis. Only renders ticks in view. Used in vertical mode.
         * @extends Common/widget/Widget
         * @private
         */


        var VerticalTimeAxis =
        /*#__PURE__*/
        function (_Widget) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(VerticalTimeAxis, _Widget);

          function VerticalTimeAxis() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, VerticalTimeAxis);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(VerticalTimeAxis).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(VerticalTimeAxis, [{
            key: "buildCells",
            // Generates element configs for all levels defined by the current ViewPreset
            value: function buildCells() {
              var me = this; // noinspection JSSuspiciousNameCombination

              return {
                className: 'b-widget b-verticaltimeaxis',
                style: {
                  height: me._height
                },
                children: me.levels.map(function (level, i) {
                  var _ref;

                  return {
                    className: new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_9__["default"]((_ref = {
                      'b-sch-header-row': 1
                    }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, "b-sch-header-row-".concat(level.position), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 'b-lowest', isLastLevel(i, me.levels)), _ref)),
                    dataset: {
                      tickIndex: i,
                      headerPosition: level.position
                    },
                    // Only include cells in view
                    children: level.cells.filter(function (cell) {
                      return cell.start < me.bottomDate && cell.end > me.topDate;
                    }).map(function (cell) {
                      var _ref2;

                      return {
                        className: new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_9__["default"]((_ref2 = {
                          'b-sch-header-timeaxis-cell': 1
                        }, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, cell.headerCellCls, cell.headerCellCls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, "b-align-".concat(cell.align), cell.align), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(_ref2, 'b-last', isLastCell(level, cell)), _ref2)),
                        dataset: {
                          tickIndex: cell.index
                        },
                        style: {
                          // DomHelper appends px to numeric dimensions
                          top: cell.coord,
                          height: cell.width,
                          minHeight: cell.width
                        },
                        children: [{
                          className: 'b-sch-header-text',
                          html: cell.value
                        }]
                      };
                    })
                  };
                })
              };
            }
          }, {
            key: "render",
            value: function render(targetElement) {
              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(VerticalTimeAxis.prototype), "render", this).call(this, targetElement);

              this.refresh(true);
            }
          }, {
            key: "refresh",

            /**
             * Refresh the UI
             * @param {Boolean} [rebuild] Specify `true` to force a rebuild of the underlying header level definitions
             */
            value: function refresh() {
              var rebuild = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.levels.length;
              var me = this,
                  columnConfig = me.timeAxisViewModel.columnConfig,
                  levels = me.levels;

              if (rebuild) {
                levels.length = 0;

                if (columnConfig.top) {
                  levels.push({
                    position: 'top',
                    cells: columnConfig.top
                  });
                }

                if (columnConfig.middle) {
                  levels.push({
                    position: 'middle',
                    cells: columnConfig.middle
                  });
                }

                if (columnConfig.bottom) {
                  levels.push({
                    position: 'bottom',
                    cells: columnConfig.bottom
                  });
                }

                me._height = levels[0].cells.reduce(function (sum, cell) {
                  return sum += cell.width;
                }, 0);
              }

              if (!me.topDate || !me.bottomDate) {
                return;
              } // Boil down levels to only show what is in view


              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].sync({
                elementConfig: me.buildCells(),
                targetElement: me.element,
                useSyncId: 'tickIndex'
              });
            }
          }, {
            key: "height",
            get: function get() {
              return this._height;
            } // Set visible date range

          }, {
            key: "range",
            set: function set(range) {
              this.topDate = range.topDate;
              this.bottomDate = range.bottomDate;
              this.refresh();
            }
          }], [{
            key: "properties",
            get: function get() {
              return {
                topDate: null,
                bottomDate: null,
                levels: []
              };
            }
          }]);

          return VerticalTimeAxis;
        }(_Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_7__["default"]);

        VerticalTimeAxis._$name = 'VerticalTimeAxis';
        /***/
      },

      /***/
      "./lib/Scheduler/view/mixin/EventNavigation.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/view/mixin/EventNavigation.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinEventNavigationJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/helper/util/Navigator.js */
        "../Grid/lib/Common/helper/util/Navigator.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/helper/FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/EventNavigation
         */

        var sortByStartDate = function sortByStartDate(l, r) {
          return l.startDate - r.startDate;
        },
            preventDefault = function preventDefault(e) {
          return e.preventDefault();
        };
        /**
         * Mixin that tracks event or assignment selection by clicking on one or more events in the scheduler.
         * @mixin
         */

        /* harmony default export */


        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(EventNavigation, _ref);

              function EventNavigation() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, EventNavigation);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventNavigation).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(EventNavigation, [{
                key: "construct",
                //endregion
                //region Events
                //endregion
                value: function construct(config) {
                  var me = this,
                      onDeleteKey = _Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].createThrottled(me.onDeleteKey, 500, me);

                  me.isInTimeAxis = me.isInTimeAxis.bind(me);

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventNavigation.prototype), "construct", this).call(this, config);

                  var navigatorConfig = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].merge({
                    ownerCmp: me,
                    target: me.timeAxisSubGridElement,
                    processEvent: me.processEvent,
                    itemSelector: ".".concat(me.eventCls, "-wrap"),
                    focusCls: me.focusCls,
                    navigatePrevious: _Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].createThrottled(me.navigatePrevious, 200, me, null, preventDefault),
                    navigateNext: _Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].createThrottled(me.navigateNext, 200, me, null, preventDefault),
                    allowCtrlKey: true,
                    scrollSilently: true,
                    keys: {
                      Space: 'onEventSpaceKey',
                      Enter: 'onEventEnterKey',
                      Delete: onDeleteKey,
                      Backspace: onDeleteKey
                    }
                  }, me.navigator);

                  me.navigator = new _Common_helper_util_Navigator_js__WEBPACK_IMPORTED_MODULE_8__["default"](navigatorConfig);
                }
              }, {
                key: "doDestroy",
                value: function doDestroy() {
                  this.navigator.destroy();

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventNavigation.prototype), "doDestroy", this).call(this);
                }
              }, {
                key: "isInTimeAxis",
                value: function isInTimeAxis(record) {
                  // If event is hidden by workingTime configs, horizontal mapper would raise a flag on instance meta
                  // We still need to check if time span is included in axis
                  return !record.instanceMeta(this).excluded && this.timeAxis.isTimeSpanInAxis(record);
                }
                /*
                 * Override of GridNavigation#focusCell method to handle the TimeAxisColumn.
                 * Not needed until we implement full keyboard accessibiliy.
                 */

              }, {
                key: "accessibleFocusCell",
                value: function accessibleFocusCell(cellSelector, options) {
                  var me = this;
                  cellSelector = me.normalizeCellContext(cellSelector);

                  if (cellSelector.columnId === me.timeAxisColumn.id) {// const lastFocusedCell        = me.lastFocusedCell = me._focusedCell,
                    //     lastFocusedCellElement = lastFocusedCell && me.getCell(lastFocusedCell),
                    //     newCell = me.getCell(cellSelector),
                    //     // Flag if the lastFocusedCellElement is DOCUMENT_POSITION_FOLLOWING newCell
                    //     backwards = !!(lastFocusedCellElement && (newCell.compareDocumentPosition(lastFocusedCellElement) & 4));
                    // // Navigating into the Sheduler, need to enable this back (for situations where we know focus was requested as a result of a keyboard input)...
                    // let newEvent = me.getRecordFromElement(newCell);
                    // me._focusedCell = cellSelector;
                    // // Scheduler where row is a Resource which might have many events
                    // // TODO: https://app.assembla.com/spaces/bryntum/tickets/6526 this class should
                    // // not know about Gantt.
                    // if (!newEvent.isTask) {
                    //     const resourceEvents = newEvent.getEvents().filter(me.isInTimeAxis).sort(sortByStartDate);
                    //     newEvent = resourceEvents[backwards ? resourceEvents.length - 1 : 0];
                    // }
                    // options.event.eventRecord = newEvent;
                    // if (newEvent && me.activeEvent !== newEvent) {
                    //     lastFocusedCellElement && lastFocusedCellElement.classList.remove('b-focused');
                    //     me.scrollResourceEventIntoView(me.store.getById(cellSelector.id), newEvent, null, {
                    //         animate : 100
                    //     }).then(() => {
                    //         me.activeEvent = newEvent;
                    //     });
                    // }
                  } else {
                    return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventNavigation.prototype), "focusCell", this).call(this, cellSelector, options);
                  }
                }
              }, {
                key: "getPrevious",
                value: function getPrevious(eventOrAssignmentRecord, isDelete) {
                  var me = this,
                      resourceStore = me.resourceStore,
                      isAssignment = eventOrAssignmentRecord.isAssignment; // TODO: https://app.assembla.com/spaces/bryntum/tickets/6526 this class should not know about Gantt.

                  if (eventOrAssignmentRecord.isTask) {
                    return me.eventStore.getAt(me.eventStore.indexOf(eventOrAssignmentRecord) - 1);
                  }

                  var resourceRecord = eventOrAssignmentRecord.resource || me.eventStore.getResourcesForEvent(eventOrAssignmentRecord)[0],
                      resourceEvents = resourceRecord.getEvents().filter(me.isInTimeAxis).sort(sortByStartDate),
                      eventRecord = isAssignment ? eventOrAssignmentRecord.event : eventOrAssignmentRecord,
                      previousEvent = resourceEvents[resourceEvents.indexOf(eventRecord) - 1]; // At first event for resource, traverse up the resource store.

                  if (!previousEvent) {
                    // If we are deleting an event, skip other instances of the event which we may encounter
                    // due to multi-assignment.
                    for (var rowIdx = resourceStore.indexOf(resourceRecord) - 1; (!previousEvent || isDelete && previousEvent === eventRecord) && rowIdx >= 0; rowIdx--) {
                      resourceRecord = resourceStore.getAt(rowIdx);
                      var events = resourceRecord.getEvents().filter(me.isInTimeAxis).sort(sortByStartDate);
                      previousEvent = events.length && events[events.length - 1];
                    }
                  } // If an assignment was passed, return one


                  return isAssignment ? me.assignmentStore.getAssignmentForEventAndResource(previousEvent, resourceRecord) : previousEvent;
                }
              }, {
                key: "navigatePrevious",
                value: function navigatePrevious(keyEvent) {
                  var me = this,
                      previousEvent = me.getPrevious(keyEvent.assignmentRecord || keyEvent.eventRecord);
                  keyEvent.preventDefault();

                  if (previousEvent) {
                    if (!keyEvent.ctrlKey) {
                      me.clearEventSelection();
                    }

                    me.navigateTo(previousEvent, keyEvent);
                  }
                }
              }, {
                key: "getNext",
                value: function getNext(eventOrAssignmentRecord, isDelete) {
                  var me = this,
                      resourceStore = me.resourceStore,
                      isAssignment = eventOrAssignmentRecord.isAssignment; // TODO: https://app.assembla.com/spaces/bryntum/tickets/6526 this class should not know about Gantt.

                  if (eventOrAssignmentRecord.isTask) {
                    return me.eventStore.getAt(me.eventStore.indexOf(eventOrAssignmentRecord) + 1);
                  }

                  var resourceRecord = isAssignment ? eventOrAssignmentRecord.resource : eventOrAssignmentRecord.resources[0],
                      //|| me.eventStore.getResourcesForEvent(eventOrAssignmentRecord)[0],
                  resourceEvents = resourceRecord.getEvents().filter(me.isInTimeAxis).sort(sortByStartDate),
                      eventRecord = isAssignment ? eventOrAssignmentRecord.event : eventOrAssignmentRecord,
                      nextEvent = resourceEvents[resourceEvents.indexOf(eventRecord) + 1]; // At last event for resource, traverse down the resource store

                  if (!nextEvent) {
                    // If we are deleting an event, skip other instances of the event which we may encounter
                    // due to multi-assignment.
                    for (var rowIdx = resourceStore.indexOf(resourceRecord) + 1; (!nextEvent || isDelete && nextEvent === eventRecord) && rowIdx < resourceStore.count; rowIdx++) {
                      resourceRecord = resourceStore.getAt(rowIdx);
                      nextEvent = resourceRecord.getEvents().filter(me.isInTimeAxis).sort(sortByStartDate)[0];
                    }
                  } // If an assignment was passed, return one


                  return isAssignment ? me.assignmentStore.getAssignmentForEventAndResource(nextEvent, resourceRecord) : nextEvent;
                }
              }, {
                key: "navigateNext",
                value: function navigateNext(keyEvent) {
                  var me = this,
                      nextEvent = me.getNext(keyEvent.assignmentRecord || keyEvent.eventRecord);
                  keyEvent.preventDefault();

                  if (nextEvent) {
                    if (!keyEvent.ctrlKey) {
                      me.clearEventSelection();
                    }

                    me.navigateTo(nextEvent, keyEvent);
                  }
                }
              }, {
                key: "navigateTo",
                value: function navigateTo(targetEvent) {
                  var uiEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  var me = this;

                  if (targetEvent) {
                    // No key processing during scroll
                    me.navigator.disabled = true;
                    var resource = targetEvent.resource;
                    me.scrollResourceEventIntoView(resource, targetEvent.isAssignment ? targetEvent.event : targetEvent, null, {
                      animate: 100
                    }).then(function () {
                      // Panel can be destroyed before promise is resolved
                      if (!me.isDestroyed) {
                        me.navigator.disabled = false;
                        me.activeEvent = targetEvent;
                        me.navigator.trigger('navigate', {
                          event: uiEvent,
                          item: _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(me.getElementFromEventRecord(targetEvent, resource), me.navigator.itemSelector)
                        });
                      }
                    });
                  }
                }
              }, {
                key: "processEvent",
                value: function processEvent(keyEvent) {
                  var me = this,
                      eventElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(keyEvent.target, me.eventSelector);

                  if (!me.navigator.disabled && eventElement) {
                    keyEvent.assignmentRecord = me.resolveAssignmentRecord(eventElement);
                    keyEvent.eventRecord = me.resolveEventRecord(eventElement);
                    keyEvent.resourceRecord = me.resolveResourceRecord(eventElement);
                  }

                  return keyEvent;
                }
              }, {
                key: "onDeleteKey",
                value: function onDeleteKey(keyEvent) {
                  var record = keyEvent.assignmentRecord || keyEvent.eventRecord;

                  if (!this.readOnly && this.enableDeleteKey && record) {
                    this.removeRecords([record]);
                  }
                }
              }, {
                key: "removeRecords",
                value: function removeRecords(records) {
                  if (!this.readOnly && records.length) {
                    records.forEach(function (r) {
                      return r.remove();
                    });
                  }
                }
              }, {
                key: "onEventSpaceKey",
                value: function onEventSpaceKey(keyEvent) {// Empty, to be chained by features (used by TimeSpanRecordContextMenuBase)
                }
              }, {
                key: "onEventEnterKey",
                value: function onEventEnterKey(keyEvent) {// Empty, to be chained by features (used by EventEdit)
                }
              }, {
                key: "activeEvent",
                set: function set(eventOrAssignmentRec) {
                  var eventEl = this.getElementFromEventRecord(eventOrAssignmentRec.isAssignment ? eventOrAssignmentRec.event : eventOrAssignmentRec, eventOrAssignmentRec.resource);
                  this.navigator.activeItem = eventEl.parentNode;
                },
                get: function get() {
                  var activeItem = this.navigator.activeItem;

                  if (activeItem) {
                    return this.resolveEventRecord(activeItem);
                  }
                }
              }, {
                key: "isActionableLocation",
                get: function get() {
                  // Override from grid if the Navigator's location is an event (or task if we're in Gantt)
                  // Being focused on a task/event means that it's *not* actionable. It's not valid to report
                  // that we're "inside" the cell in a TimeLine, so ESC must not attempt to focus the cell.
                  if (!this.navigator.activeItem) {
                    return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(EventNavigation.prototype), "isActionableLocation", this);
                  }
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                //region Default config
                get: function get() {
                  return {
                    /**
                     * A config object to use when creating the {@link Common.helper.util.Navigator}
                     * to use to perform keyboard navigation in the timeline.
                     * @config {Object}
                     * @default
                     */
                    navigator: null,

                    /**
                     * A CSS class name to add to focused events.
                     * @config {String}
                     * @default
                     * @category CSS
                     * @private
                     */
                    focusCls: 'b-active',

                    /**
                     * Allow using [Delete] and [Backspace] to remove events/assignments
                     * @config {Boolean}
                     * @default
                     * @category Misc
                     */
                    enableDeleteKey: true
                  };
                }
              }]);

              return EventNavigation;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/EventSelection.js":
      /*!****************************************************!*\
        !*** ./lib/Scheduler/view/mixin/EventSelection.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinEventSelectionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/EventSelection
         */

        /**
         * Mixin that tracks event or assignment selection by clicking on one or more events in the scheduler.
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(EventSelection, _ref);

              function EventSelection() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, EventSelection);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(EventSelection).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(EventSelection, [{
                key: "afterConstruct",
                //endregion
                //region Events

                /**
                 * Fired any time there is a change to the events selected in the Scheduler.
                 * @event eventSelectionChange
                 * @param {String} action One of the actions 'select', 'deselect', 'update', 'clear'
                 * @param {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]} selected An array of the Events or Assignments added to the selection.
                 * @param {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]} deselected An array of the Events or Assignments removed from the selection.
                 * @param {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]} selection The new selection.
                 */
                //endregion
                //region Init
                value: function afterConstruct() {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(EventSelection.prototype), "afterConstruct", this).call(this);

                  this.navigator.on({
                    navigate: 'onEventNavigate',
                    thisObj: this
                  });
                } //endregion
                //region Selected Collection

              }, {
                key: "isEventSelected",

                /**
                 * Returns `true` if the {@link Scheduler.model.EventModel event} or {@link Scheduler.model.AssignmentModel assignment} is selected.
                 * @param {Scheduler.model.EventModel|Scheduler.model.AssignmentModel} event The event or assignment
                 * @category Selection
                 */
                value: function isEventSelected(event) {
                  return this.selectedCollection.includes(event);
                }
                /**
                 * Selects the passed {@link Scheduler.model.EventModel event} or {@link Scheduler.model.AssignmentModel assignment}
                 * *if it is not selected*.
                 * @param {Scheduler.model.EventModel|Scheduler.model.AssignmentModel} event The event or assignment to select. When using multi assignment, supply an AssignmentModel
                 * @param {Boolean} [preserveSelection=false] Pass `true` to preserve any other selected events or assignments
                 * @category Selection
                 */

              }, {
                key: "selectEvent",
                value: function selectEvent(event) {
                  var preserveSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false; // If there event is already selected, this is a no-op.
                  // In this case, selection must not be cleared even in the absence of preserveSelection

                  if (!this.isEventSelected(event)) {
                    preserveSelection ? this.selectedCollection.add(event) : this.selectedEvents = event;
                  }
                }
                /**
                 * Deselects the passed {@link Scheduler.model.EventModel event} or {@link Scheduler.model.AssignmentModel assignment}
                 * *if it is selected*.
                 * @param {Scheduler.model.EventModel|Scheduler.model.AssignmentModel} event The event or assignment to deselect. When using multi assignment, supply an AssignmentModel
                 * @category Selection
                 */

              }, {
                key: "deselectEvent",
                value: function deselectEvent(event) {
                  var preserveSelection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                  if (this.isEventSelected(event)) {
                    this.selectedCollection.remove(event);
                  }
                }
                /**
                 * Adds {@link Scheduler.model.EventModel events} or {@link Scheduler.model.AssignmentModel assignments} to the selection.
                 * @param {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]} events Events or assignments to be deselected
                 * @category Selection
                 */

              }, {
                key: "selectEvents",
                value: function selectEvents(events) {
                  this.selectedCollection.add(events);
                }
                /**
                 * Removes {@link Scheduler.model.EventModel events} or {@link Scheduler.model.AssignmentModel assignments} from the selection.
                 * @param {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]} events Events or assignments  to be deselected
                 * @category Selection
                 */

              }, {
                key: "deselectEvents",
                value: function deselectEvents(events) {
                  this.selectedCollection.remove(events);
                }
                /**
                 * Deselects all {@link Scheduler.model.EventModel events} or {@link Scheduler.model.AssignmentModel assignments}.
                 * @category Selection
                 */

              }, {
                key: "clearEventSelection",
                value: function clearEventSelection() {
                  this.selectedEvents = [];
                } //endregion
                //region Events

                /**
                 * Responds to mutations of the underlying selection Collection.
                 * Keeps the UI synced, eventSelectionChange event is fired when `me.silent` is falsy.
                 * @private
                 */

              }, {
                key: "onSelectedCollectionChange",
                value: function onSelectedCollectionChange(_ref2) {
                  var added = _ref2.added,
                      removed = _ref2.removed;
                  var me = this,
                      selection = me.selectedEvents,
                      selected = added || [],
                      deselected = removed || [];

                  function updateSelection(record, select) {
                    var resourceRecord = record.isTask ? record : record.resource,
                        eventRecord = record.isAssignment ? record.event : record;

                    if (eventRecord) {
                      var element = me.getElementFromEventRecord(eventRecord, resourceRecord);
                      me.currentOrientation.toggleCls(eventRecord, resourceRecord, me.eventSelectedCls, select);

                      if (record.isAssignment) {
                        me.getElementsFromEventRecord(eventRecord).forEach(function (el) {
                          if (el !== element) {
                            el.classList[select ? 'add' : 'remove'](me.eventAssignHighlightCls);
                          }
                        });
                      }
                    }
                  }

                  selected.forEach(function (record) {
                    return updateSelection(record, true);
                  });
                  deselected.forEach(function (record) {
                    return updateSelection(record, false);
                  });

                  if (!me.silent) {
                    me.trigger('eventSelectionChange', {
                      action: selection.length > 0 ? selected.length > 0 && deselected.length > 0 ? 'update' : selected.length > 0 ? 'select' : 'deselect' : 'clear',
                      selection: selection,
                      selected: selected,
                      deselected: deselected
                    });
                  }
                }
                /**
                 * Store data change listener to remove events from selection which are no longer in the store.
                 * @private
                 */

              }, {
                key: "onInternalEventStoreChange",
                value: function onInternalEventStoreChange(_ref3) {
                  var action = _ref3.action,
                      events = _ref3.records,
                      eventStore = _ref3.source;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(EventSelection.prototype), "onInternalEventStoreChange", this).apply(this, arguments);

                  var me = this;
                  me.silent = !me.triggerSelectionChangeOnRemove;

                  if (action === 'remove') {
                    me.deselectEvents(events);
                  } else if (action === 'dataset') {
                    if (!me.maintainSelectionOnDatasetChange) {
                      me.clearEventSelection();
                    } else {
                      me.selectedEvents = me.selectedEvents.filter(function (event) {
                        return eventStore.includes(event);
                      });
                    }
                  }

                  me.silent = false;
                }
                /**
                 * Assignment change listener to remove events from selection which are no longer in the assignments.
                 * @private
                 */

              }, {
                key: "onAssignmentRemove",
                value: function onAssignmentRemove(_ref4) {
                  var assignments = _ref4.records;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(EventSelection.prototype), "onAssignmentRemove", this).apply(this, arguments);

                  var me = this;
                  me.silent = !me.triggerSelectionChangeOnRemove;
                  me.deselectEvents(assignments);
                  me.silent = false;
                }
                /**
                 * Mouse listener to update selection.
                 * @private
                 */

              }, {
                key: "onEventSelectionClick",
                value: function onEventSelectionClick(event, clickedRecord) {
                  var me = this; // Multi selection: CTRL means preserve selection, just add or remove the event.
                  // Single selection: CTRL deselects already selected event

                  if (me.isEventSelected(clickedRecord)) {
                    event.ctrlKey && me.deselectEvent(clickedRecord, me.multiEventSelect);
                  } else {
                    me.selectEvent(clickedRecord, event.ctrlKey && me.multiEventSelect);
                  }
                }
                /**
                 * Navigation listener to update selection.
                 * @private
                 */

              }, {
                key: "onEventNavigate",
                value: function onEventNavigate(_ref5) {
                  var event = _ref5.event,
                      item = _ref5.item;

                  if (!this.eventSelectionDisabled) {
                    var me = this,
                        record = item && (item.nodeType === 1 ? me.assignmentStore ? me.resolveAssignmentRecord(item) : me.resolveEventRecord(item) : item);

                    if (record) {
                      me.onEventSelectionClick(event, record);
                    } // Click outside of an event/assignment;
                    else {
                        me.clearEventSelection();
                      }
                  }
                } //endregion
                //region Getters/Setters
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "selectedCollection",
                set: function set(selectedCollection) {
                  if (!(selectedCollection instanceof _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_11__["default"])) {
                    selectedCollection = new _Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_11__["default"](selectedCollection);
                  }

                  this._selectedCollection = selectedCollection; // Fire row change events from onSelectedCollectionChange

                  selectedCollection.on({
                    change: 'onSelectedCollectionChange',
                    thisObj: this
                  });
                },
                get: function get() {
                  return this._selectedCollection;
                } //endregion
                //region Modify selection

                /**
                 * The {@link Scheduler.model.EventModel events} or {@link Scheduler.model.AssignmentModel assignments} which are selected.
                 * @returns {Scheduler.model.EventModel[]|Scheduler.model.AssignmentModel[]}
                 * @category Selection
                 */

              }, {
                key: "selectedEvents",
                get: function get() {
                  return this.selectedCollection.values;
                },
                set: function set(events) {
                  // Replace the entire selected collection with the new record set
                  this.selectedCollection.splice(0, this.selectedCollection.count, events || []);
                }
              }, {
                key: "widgetClass",
                get: function get() {} //endregion

              }], [{
                key: "defaultConfig",
                //region Default config
                get: function get() {
                  return {
                    /**
                     * Configure as `true` to allow `CTRL+click` to select multiple events in the scheduler.
                     * @config {Boolean}
                     * @category Selection
                     */
                    multiEventSelect: false,

                    /**
                     * Configure as `true`, or set property to `true` to disable event selection.
                     * @config {Boolean}
                     * @category Selection
                     */
                    eventSelectionDisabled: false,

                    /**
                     * CSS class to add to selected events.
                     * @config {String}
                     * @default
                     * @category CSS
                     * @private
                     */
                    eventSelectedCls: 'b-sch-event-selected',

                    /**
                     * Configure as `true` to trigger `selectionChange` when removing a selected event/assignment.
                     * @config {Boolean}
                     * @default
                     * @category Selection
                     */
                    triggerSelectionChangeOnRemove: false,

                    /**
                     * This flag controls whether Scheduler should maintain its selection of events when loading a new dataset (if selected event ids are included in the newly loaded dataset).
                     * @config {Boolean}
                     * @default
                     * @category Selection
                     */
                    maintainSelectionOnDatasetChange: true,

                    /**
                     * CSS class to add to other instances of a selected event, to highlight them.
                     * @config {String}
                     * @default
                     * @category CSS
                     * @private
                     */
                    eventAssignHighlightCls: 'b-sch-event-assign-selected',

                    /**
                     * Collection to store selection.
                     * @config {Common.util.Collection}
                     * @private
                     */
                    selectedCollection: {}
                  };
                }
              }]);

              return EventSelection;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerDom.js":
      /*!**************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerDom.js ***!
        \**************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerDomJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.split */
        "./node_modules/core-js/modules/es6.regexp.split.js");
        /* harmony import */


        var core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_split__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/SchedulerDom
         */

        /**
         * Mixin with EventModel and ResourceModel <-> HTMLElement mapping functions
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(SchedulerDom, _ref);

              function SchedulerDom() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, SchedulerDom);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(SchedulerDom).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerDom, [{
                key: "getElementFromAssignmentRecord",
                //region Get

                /**
                 * Returns a single HTMLElement representing an event record assigned to a specific resource.
                 * @param {Scheduler.model.AssignmentModel} assignmentRecord An assignment record
                 * @return {HTMLElement} The element representing the event record
                 */
                value: function getElementFromAssignmentRecord(assignmentRecord) {
                  return this.currentOrientation.getElementFromEventRecord(assignmentRecord.event, assignmentRecord.resource);
                }
                /**
                 * Returns a single HTMLElement representing an event record assigned to a specific resource.
                 * @param {Scheduler.model.EventModel} eventRecord An event record
                 * @param {Scheduler.model.ResourceModel} resourceRecord A resource record
                 * @return {HTMLElement} The element representing the event record
                 */

              }, {
                key: "getElementFromEventRecord",
                value: function getElementFromEventRecord(eventRecord, resourceRecord) {
                  return this.currentOrientation.getElementFromEventRecord(eventRecord, resourceRecord);
                }
                /**
                 * Returns all the HTMLElements representing an event record.
                 *
                 * @param {Scheduler.model.EventModel} eventRecord An event record
                 * @param {Scheduler.model.ResourceModel} [resourceRecord] A resource record
                 *
                 * @return {HTMLElement[]} The element(s) representing the event record
                 */

              }, {
                key: "getElementsFromEventRecord",
                value: function getElementsFromEventRecord(eventRecord, resourceRecord) {
                  return this.currentOrientation.getElementsFromEventRecord(eventRecord, resourceRecord);
                }
                /**
                 * Returns the event id for a DOM id
                 * @private
                 * @param {String} id The id of the DOM node
                 * @return {String} An event record (internal) id
                 */

              }, {
                key: "getEventIdFromDomNodeId",
                value: function getEventIdFromDomNodeId(id) {
                  var eventId = id.substring(this.eventPrefix.length).split('-')[0]; // id format is "PREFIX"-eventid-resourceid[-part]
                  // do not want - from other sources in it, replace with ._.
                  // TODO: come up with something risk free

                  return eventId && eventId.replace(/\._\./g, '-');
                }
                /**
                 * Returns the event record for a DOM id
                 * @param {String} id The id of the DOM node
                 * @return {Scheduler.model.EventModel} The event record
                 */

              }, {
                key: "getEventRecordFromDomId",
                value: function getEventRecordFromDomId(id) {
                  id = this.getEventIdFromDomNodeId(id);
                  return this.eventStore.getById(id);
                }
                /**
                 * Returns a resource id for a DOM id
                 * @private
                 * @param {String} id An id of an event DOM node
                 * @return {String} A resource record (internal) id
                 */

              }, {
                key: "getResourceIdFromDomNodeId",
                value: function getResourceIdFromDomNodeId(id) {
                  var resourceId = id.substring(this.eventPrefix.length).split('-')[1]; // id format is "PREFIX"-eventid-resourceid[-part]
                  // do not want - from other sources in it, replace with ._.
                  // TODO: come up with something risk free

                  return resourceId && resourceId.replace(/\._\./g, '-');
                }
                /**
                 * Returns a resource record for a DOM id
                 * @param {String} id An id of an event DOM node
                 * @return {Scheduler.model.ResourceModel} A resource record
                 */

              }, {
                key: "getResourceRecordFromDomId",
                value: function getResourceRecordFromDomId(id) {
                  id = this.getResourceIdFromDomNodeId(id);
                  return this.resourceStore.getById(id);
                } //endregion
                //region Resolve

                /**
                 * Resolves the resource based on a dom element or event. In vertical mode, if resolving from an element higher up in
                 * the hierarchy than event elements, then it is required to supply an coordinates since resources are virtual
                 * columns.
                 * @param {HTMLElement|Event} elementOrEvent The HTML element or DOM event to resolve a resource from
                 * @param {Number[]} [xy] X and Y coordinates, required in some cases in vertical mode, disregarded in horizontal
                 * @return {Scheduler.model.ResourceModel} The resource corresponding to the element, or null if not found.
                 */

              }, {
                key: "resolveResourceRecord",
                value: function resolveResourceRecord(elementOrEvent, xy) {
                  return this.currentOrientation.resolveRowRecord(elementOrEvent, xy);
                }
                /**
                 * Returns the event record for a DOM element
                 * @param {HTMLElement} element The DOM node to lookup
                 * @return {Scheduler.model.EventModel} The event record
                 */

              }, {
                key: "resolveEventRecord",
                value: function resolveEventRecord(element) {
                  element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(element, this.eventSelector);

                  if (element) {
                    if (element.dataset.eventId) {
                      return this.eventStore.getById(element.dataset.eventId);
                    }

                    if (element.dataset.assignmentId) {
                      return this.assignmentStore.getById(element.dataset.assignmentId).event;
                    }
                  }

                  return null;
                } // Used by shared features to resolve an event or task

              }, {
                key: "resolveTimeSpanRecord",
                value: function resolveTimeSpanRecord(element) {
                  return this.resolveEventRecord(element);
                }
                /**
                 * Returns an assignment record for a DOM element
                 * @param {HTMLElement} element The DOM node to lookup
                 * @return {Scheduler.model.AssignmentModel} The assignment record
                 */

              }, {
                key: "resolveAssignmentRecord",
                value: function resolveAssignmentRecord(element) {
                  var assignmentStore = this.eventStore.assignmentStore;
                  var assignment = null;

                  if (assignmentStore) {
                    var eventElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].up(element, this.eventSelector),
                        event = this.resolveEventRecord(eventElement),
                        resource = this.resolveResourceRecord(eventElement);

                    if (event && resource) {
                      assignment = assignmentStore.getAssignmentForEventAndResource(event, resource);
                    }
                  }

                  return assignment;
                } //endregion
                // Decide if a record is inside a collapsed tree node, or inside a collapsed group (using grouping feature)

              }, {
                key: "isRowVisible",
                value: function isRowVisible(resourceRecord) {
                  // records in collapsed groups/brances etc are removed from processedRecords
                  return this.store.indexOf(resourceRecord) >= 0;
                }
                /**
                 * Determines width of a milestones label. How width is determined is decided by configuring Scheduler#milestoneLayoutMode.
                 * Please note that currently text width is always determined using EventModel#name.
                 * @param {Scheduler.model.EventModel} eventRecord
                 * @returns {Number}
                 */

              }, {
                key: "getMilestoneLabelWidth",
                value: function getMilestoneLabelWidth(eventRecord) {
                  var me = this,
                      mode = me.milestoneLayoutMode;

                  if (mode === 'measure') {
                    var element = me.milestoneMeasureElement || (me.milestoneMeasureElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].createElement({
                      className: 'b-sch-event-wrap b-milestone-wrap b-measure',
                      children: [{
                        className: 'b-sch-event b-milestone',
                        html: "<label></label>"
                      }],
                      parent: me.foregroundCanvas
                    }));

                    element.firstElementChild.firstElementChild.innerHTML = eventRecord.name;
                    return element.offsetWidth;
                  }

                  if (mode === 'estimate') {
                    return Math.max(eventRecord.name.length * me.milestoneCharWidth, me.milestoneMinWidth);
                  }

                  if (mode === 'data') {
                    return Math.max(eventRecord.milestoneWidth, me.milestoneMinWidth);
                  }

                  return 0;
                }
              }, {
                key: "milestoneLayoutMode",
                set: function set(mode) {
                  var me = this;
                  me._milestoneLayoutMode = mode;
                  me.element.classList[mode !== 'default' ? 'add' : 'remove']('b-sch-layout-milestones');
                  me.refresh();
                },
                get: function get() {
                  return this._milestoneLayoutMode;
                }
              }, {
                key: "milestoneAlign",
                set: function set(align) {
                  this._milestoneAlign = align;
                  this.refresh();
                },
                get: function get() {
                  return this._milestoneAlign;
                }
              }, {
                key: "milestoneCharWidth",
                set: function set(width) {
                  this._milestoneCharWidth = width;
                  this.refresh();
                },
                get: function get() {
                  return this._milestoneCharWidth;
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return SchedulerDom;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_8__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerDomEvents.js":
      /*!********************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerDomEvents.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerDomEventsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/SchedulerDomEvents
         */

        /**
         * Mixin that handles dom events (click etc) for scheduler and rendered events.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(SchedulerDomEvents, _ref);

              function SchedulerDomEvents() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, SchedulerDomEvents);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerDomEvents).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(SchedulerDomEvents, [{
                key: "getTimeSpanMouseEventParams",
                //region Events

                /**
                 * Triggered when user clicks an empty area in the schedule.
                 * @event scheduleClick
                 * @param {Scheduler.view.TimelineBase} source This TimelineBase
                 * @param {Date} date Date at mouse position
                 * @param {Grid.row.Row} row Clicked row
                 * @param {Number} index Index of clicked resource
                 * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered when user clicks an empty area in the schedule.
                 * @event scheduleDblClick
                 * @param {Scheduler.view.TimelineBase} source This TimelineBase
                 * @param {Date} date Date at mouse position
                 * @param {Grid.row.Row} row Double clicked row
                 * @param {Number} index Index of double clicked resource
                 * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered when user right clicks an empty area in the schedule.
                 * @event scheduleContextMenu
                 * @param {Scheduler.view.TimelineBase} source This TimelineBase
                 * @param {Date} date Date at mouse position
                 * @param {Grid.row.Row} row Clicked row
                 * @param {Number} index Index of clicked resource
                 * @param {Scheduler.model.ResourceModel} resourceRecord Resource record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered for mouse down on an event.
                 * @event eventMouseDown
                 * @param {Scheduler.view.Scheduler} source This Scheduler
                 * @param {Scheduler.model.EventModel} eventRecord Event record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered for mouse up on an event.
                 * @event eventMouseUp
                 * @param {Scheduler.view.Scheduler} source This Scheduler
                 * @param {Scheduler.model.EventModel} eventRecord Event record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered for click on an event.
                 * @event eventClick
                 * @param {Scheduler.view.Scheduler} source This Scheduler
                 * @param {Scheduler.model.EventModel} eventRecord Event record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered for double click on an event.
                 * @event eventDblClick
                 * @param {Scheduler.view.Scheduler} source This Scheduler
                 * @param {Scheduler.model.EventModel} eventRecord Event record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered for right click on an event.
                 * @event eventContextMenu
                 * @param {Scheduler.view.Scheduler} source This Scheduler
                 * @param {Scheduler.model.EventModel} eventRecord Event record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered for mouse over on an event.
                 * @event eventMouseOver
                 * @param {Scheduler.view.Scheduler} source This Scheduler
                 * @param {Scheduler.model.EventModel} eventRecord Event record
                 * @param {MouseEvent} event Browser event
                 */

                /**
                 * Triggered for mouse out from an event.
                 * @event eventMouseOut
                 * @param {Scheduler.view.Scheduler} source This Scheduler
                 * @param {Scheduler.model.EventModel} eventRecord Event record
                 * @param {MouseEvent} event Browser event
                 */
                //endregion
                //region Event handling
                value: function getTimeSpanMouseEventParams(eventElement, event) {
                  return {
                    eventRecord: this.resolveEventRecord(eventElement),
                    resourceRecord: this.resolveResourceRecord(eventElement),
                    assignmentRecord: this.resolveAssignmentRecord(eventElement),
                    eventElement: eventElement,
                    event: event
                  };
                }
              }, {
                key: "getScheduleMouseEventParams",
                value: function getScheduleMouseEventParams(cellData, event) {
                  var resourceRecord = this.isVertical ? this.resolveResourceRecord(event) : this.store.getById(cellData.id);
                  return {
                    resourceRecord: resourceRecord
                  };
                }
                /**
                 * Relays keydown events as eventkeydown if we have a selected task.
                 * @private
                 */

              }, {
                key: "onElementKeyDown",
                value: function onElementKeyDown(event) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerDomEvents.prototype), "onElementKeyDown", this).call(this, event);

                  var me = this;

                  if (me.selectedEvents.length) {
                    me.trigger(me.scheduledEventName + 'KeyDown', {
                      eventRecord: me.selectedEvents
                    });
                  }
                }
                /**
                 * Relays keyup events as eventkeyup if we have a selected task.
                 * @private
                 */

              }, {
                key: "onElementKeyUp",
                value: function onElementKeyUp(event) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerDomEvents.prototype), "onElementKeyUp", this).call(this, event);

                  var me = this;

                  if (me.selectedEvents.length) {
                    me.trigger(me.scheduledEventName + 'KeyUp', {
                      eventRecord: me.selectedEvents
                    });
                  }
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return SchedulerDomEvents;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerDragResize.js":
      /*!*********************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerDragResize.js ***!
        \*********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerDragResizeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/SchedulerDragResize
         */

        /**
         * Mixin for triggering event editor on drag creation etc.
         * @private
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(SchedulerDragResize, _ref);

              function SchedulerDragResize() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, SchedulerDragResize);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerDragResize).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(SchedulerDragResize, [{
                key: "construct",
                value: function construct(config) {
                  var me = this;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerDragResize.prototype), "construct", this).call(this, config);

                  if (me.hasFeature('eventDragCreate')) {
                    me.on({
                      dragcreateend: me.internalOnDragCreateEnd,
                      thisObj: me
                    });
                  }
                }
              }, {
                key: "internalOnDragCreateEnd",
                value: function internalOnDragCreateEnd(_ref2) {
                  var eventRecord = _ref2.newEventRecord,
                      resourceRecord = _ref2.resourceRecord;
                  var me = this; // If an event editor is defined, it has to manage how/if/when the event is added to the event store

                  if (!me.eventEdit) {
                    var resourceRecords = resourceRecord ? [resourceRecord] : []; // resources **Deprecated** Use `resourceRecords` instead

                    if (me.trigger('beforeEventAdd', {
                      eventRecord: eventRecord,
                      resourceRecords: resourceRecords,
                      resources: resourceRecords
                    }) !== false) {
                      me.onEventCreated(eventRecord);
                      me.eventStore.add(eventRecord);
                      eventRecord.assign(resourceRecord);
                    }
                  }
                }
              }, {
                key: "eventEditor",
                get: function get() {
                  return this._eventEditor;
                },
                set: function set(editor) {
                  this._eventEditor = editor;
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return SchedulerDragResize;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerEventRendering.js":
      /*!*************************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerEventRendering.js ***!
        \*************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerEventRenderingJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.to-string */
        "./node_modules/core-js/modules/es6.regexp.to-string.js");
        /* harmony import */


        var core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_to_string__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.string.starts-with */
        "./node_modules/core-js/modules/es6.string.starts-with.js");
        /* harmony import */


        var core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_starts_with__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/util/DomClassList.js */
        "../Grid/lib/Common/helper/util/DomClassList.js");
        /* harmony import */


        var _eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../eventlayout/HorizontalLayoutStack.js */
        "./lib/Scheduler/eventlayout/HorizontalLayoutStack.js");
        /* harmony import */


        var _eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../eventlayout/HorizontalLayoutPack.js */
        "./lib/Scheduler/eventlayout/HorizontalLayoutPack.js");
        /* harmony import */


        var _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../model/TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");
        /* harmony import */


        var _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../../model/ResourceModel.js */
        "./lib/Scheduler/model/ResourceModel.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/SchedulerEventRendering
         */

        var hyphenRe = /-/g;
        /**
         * Functions to handle event rendering (EventModel -> dom elements).
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerEventRendering, _ref);

              function SchedulerEventRendering() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, SchedulerEventRendering);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_12___default()(SchedulerEventRendering).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(SchedulerEventRendering, [{
                key: "getEventsToRender",
                //endregion
                //region Event rendering
                // Chainable function called with the events to render for a specific resource. Allows features to add/remove.
                // Chained by ResourceTimeRanges
                value: function getEventsToRender(resource, events) {
                  return events;
                }
                /**
                 * Rerenders events for specified resource (by rerendering the entire row).
                 * @param {Scheduler.model.ResourceModel} resourceRecord
                 */

              }, {
                key: "repaintEventsForResource",
                value: function repaintEventsForResource(resourceRecord
                /*, refreshSelections*/
                ) {
                  var me = this;

                  if (me.isHorizontal) {
                    me.currentOrientation.cache.clearRow(resourceRecord.id);
                    var row = me.getRowFor(resourceRecord);

                    if (row) {
                      // Update the affected row, if it changes height RowManger will take care of translating the rest of the rows
                      row.render();
                    }
                  } // TODO: PORT selection model not ported yet
                  // if (refreshSelections) {
                  //     const sm     = me.getEventSelectionModel(),
                  //           events = me.getEventStore().getEventsForResource(resourceRecord);
                  //
                  //     events.forEach(ev =>
                  //         sm.forEachEventRelatedSelection(ev, selectedRecord =>
                  //             me.onEventBarSelect(selectedRecord, true)
                  //         )
                  //     );
                  // }

                }
                /**
                 * Rerenders the events for all resources connected to the specified event
                 * @param {Scheduler.model.EventModel} eventRecord
                 * @private
                 */

              }, {
                key: "repaintEvent",
                value: function repaintEvent(eventRecord) {
                  var _this = this;

                  var resources = this.eventStore.getResourcesForEvent(eventRecord);
                  resources.forEach(function (resourceRecord) {
                    return _this.repaintEventsForResource(resourceRecord);
                  });
                } //endregion
                //region Template

                /**
                 * Generates data used in the template when rendering an event. For example which css classes to use. Also applies
                 * #eventBodyTemplate and calls the {@link #config-eventRenderer}.
                 * @private
                 * @param {Scheduler.model.EventModel} eventRecord Event to generate data for
                 * @param {Scheduler.model.ResourceModel} resourceRecord Events resource
                 * @param {Boolean|Object} includeOutside Specify true to get boxes for timespans outside of the rendered zone in both
                 * dimensions. This option is used when calculating dependency lines, and we need to include routes from timespans
                 * which may be outside the rendered zone.
                 * @param {Boolean} includeOutside.timeAxis Pass as `true` to include timespans outside of the TimeAxis's bounds
                 * @param {Boolean} includeOutside.viewport Pass as `true` to include timespans outside of the vertical timespan viewport's bounds.
                 * @returns {Object} Data to use in event template, or `undefined` if the event is outside of the rendered zone.
                 */

              }, {
                key: "generateTplData",
                value: function generateTplData(eventRecord, resourceRecord) {
                  var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    viewport: true
                  };
                  var me = this,
                      // generateTplData calculates layout for events which are outside of the vertical viewport
                  // because the RowManager needs to know a row height.
                  renderData = me.currentOrientation.getTimeSpanRenderData(eventRecord, resourceRecord, includeOutside);
                  var eventContent = '';

                  if (renderData) {
                    var _Object$assign;

                    var resizable = eventRecord.isResizable;

                    if (renderData.startsOutsideView) {
                      if (resizable === true) resizable = 'end';else if (resizable === 'start') resizable = false;
                    }

                    if (renderData.endsOutsideView) {
                      if (resizable === true) resizable = 'start';else if (resizable === 'end') resizable = false;
                    } // Event record cls properties are now DomClassList instances, so clone them
                    // so that they can be manipulated here and by renderers.
                    // Truthy value means the key will be added as a class name.
                    // ResourceTimeRanges applies custom cls to wrapper.


                    var clsList = eventRecord.isResourceTimeRange ? new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__["default"]() : eventRecord.cls.clone(),
                        wrapperClsList = eventRecord.isResourceTimeRange ? eventRecord.cls.clone() : new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__["default"]();
                    Object.assign(clsList, (_Object$assign = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, resourceRecord.cls, resourceRecord.cls), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, me.generatedIdCls, eventRecord.hasGeneratedId), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, me.dirtyCls, eventRecord.modifications), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, me.committingCls, eventRecord.isCommitting), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, me.endsOutsideViewCls, renderData.endsOutsideView), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, me.startsOutsideViewCls, renderData.startsOutsideView), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, 'b-clipped-start', renderData.clippedStart), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign, 'b-clipped-end', renderData.clippedEnd), _Object$assign));
                    Object.assign(wrapperClsList, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()({}, "".concat(me.eventCls, "-parent"), resourceRecord.isParent)); // Event specifics, things that do not apply to ResourceTimeRanges

                    if (eventRecord.isEvent || eventRecord.isTask) {
                      var _Object$assign3, _Object$assign4;

                      Object.assign(clsList, (_Object$assign3 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign3, me.eventCls, 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign3, 'b-milestone', eventRecord.isMilestone), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign3, 'b-sch-event-narrow', renderData.width < 10), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign3, me.fixedEventCls, eventRecord.isDraggable === false), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign3, "b-sch-event-resizable-".concat(resizable), Boolean(me.features.eventResize)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign3, me.eventSelectedCls, me.isEventSelected(eventRecord)), _Object$assign3));
                      renderData.eventId = eventRecord.id; // this is important for getElement(s)FromEventRecord()

                      renderData.id = me.getEventRenderId(eventRecord, resourceRecord); // If id has changed we want to reuse the element for the old id, to not steal some other events element
                      // and to allow any other changes from the server to be animated

                      if ('id' in eventRecord.meta.modified) {
                        renderData.oldId = me.getEventRenderId(eventRecord.meta.modified.id, resourceRecord);
                      }

                      Object.assign(wrapperClsList, (_Object$assign4 = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign4, "".concat(me.eventCls, "-wrap"), 1), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6___default()(_Object$assign4, 'b-milestone-wrap', eventRecord.isMilestone), _Object$assign4));
                      var eventStyle = eventRecord.eventStyle || resourceRecord.eventStyle || me.eventStyle,
                          eventColor = eventRecord.eventColor || resourceRecord.eventColor || me.eventColor;
                      renderData.eventColor = eventColor;
                      renderData.eventStyle = eventStyle; // Using multi assignment? Supply AssignmentModel to rendering process also. Might not be available
                      // if adding a new event and using EventEdit, since it might be converting a dragproxy prior to adding
                      // to store. Not needed in that case anyway

                      if (me.assignmentStore && eventRecord.assignments) {
                        renderData.assignment = eventRecord.assignments.find(function (a) {
                          return a.resourceId === resourceRecord.id;
                        });
                      }
                    } // If not using a wrapping div, this cls will be added to event div for correct rendering


                    renderData.wrapperCls = wrapperClsList;
                    renderData.cls = clsList;
                    renderData.iconCls = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__["default"](eventRecord.get(me.eventBarIconClsField) || eventRecord.iconCls); // ResourceTimeRanges applies custom style to the wrapper

                    if (eventRecord.isResourceTimeRange) {
                      renderData.style = '';
                      renderData.wrapperStyle = eventRecord.style || '';
                    } // Others to inner
                    else {
                        renderData.style = eventRecord.style || '';
                      }

                    renderData.resource = resourceRecord;
                    renderData.resourceId = renderData.rowId;

                    if (eventRecord.isEvent || eventRecord.isTask) {
                      if (me.eventRenderer) {
                        // User has specified a renderer fn, either to return a simple string, or an object intended for the eventBodyTemplate
                        var value = me.eventRenderer.call(me.eventRendererThisObj || me, {
                          eventRecord: eventRecord,
                          resourceRecord: resourceRecord,
                          assignmentRecord: renderData.assignment,
                          tplData: renderData
                        }); // If the user's renderer coerced it into a string, recreate a DomClassList.

                        if (typeof renderData.cls === 'string') {
                          renderData.cls = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__["default"](renderData.cls);
                        }

                        if (typeof renderData.wrapperCls === 'string') {
                          renderData.wrapperCls = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__["default"](renderData.wrapperCls);
                        } // Same goes for iconCls


                        if (typeof renderData.iconCls === 'string') {
                          renderData.iconCls = new _Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__["default"](renderData.iconCls);
                        }

                        eventContent = me.eventBodyTemplate && me.eventBodyTemplate(value) || (value == null ? '' : String(value));
                      } else if (me.eventBodyTemplate) {
                        // User has specified an eventBodyTemplate, but no renderer - just apply the entire event record data.
                        eventContent = me.eventBodyTemplate(eventRecord);
                      } else if (me.eventBarTextField) {
                        // User has specified a field in the data model to read from
                        eventContent = eventRecord.data[me.eventBarTextField] || '';
                      }

                      if (!me.eventBodyTemplate) {
                        // Give milestone a dedicated label element so we can use padding
                        if (eventRecord.isMilestone && eventContent) {
                          eventContent = "<label>".concat(eventContent, "</label>");
                        }

                        if (renderData.iconCls && renderData.iconCls.length) {
                          eventContent = "<i class=\"".concat(renderData.iconCls, "\"></i>").concat(eventContent);
                        }
                      } // renderers have last say on style & color


                      renderData.wrapperCls["b-sch-style-".concat(renderData.eventStyle)] = renderData.eventStyle;

                      if (renderData.eventColor && renderData.eventColor.startsWith('#')) {
                        renderData.style = "background-color:".concat(renderData.eventColor, ";") + renderData.style;
                      } else {
                        renderData.wrapperCls["b-sch-color-".concat(renderData.eventColor)] = renderData.eventColor;
                      }
                    } // If there are any iconCls entries...


                    renderData.cls['b-sch-event-withicon'] = renderData.iconCls.length; // html, use templates fragment

                    if (eventContent.includes('<')) {
                      // Create content as a DocumentFragment which may now be exposed to Features.
                      renderData.body = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].createElementFromTemplate(eventContent, {
                        fragment: true
                      });
                    } // plain text, create fragment with the text in it
                    else {
                        renderData.body = document.createDocumentFragment();
                        renderData.body.textContent = eventContent;
                      } // For comparison in sync, cheaper than comparing DocumentFragments


                    renderData.eventContent = eventContent; // Method which features may chain in to

                    me.onEventDataGenerated(renderData);
                  }

                  return renderData;
                }
                /**
                 * A method which may be chained by features. It is called when an event's render
                 * data is calculated so that features may update the style, class list or body.
                 * @param {Object} eventData
                 */

              }, {
                key: "onEventDataGenerated",
                value: function onEventDataGenerated(eventData) {}
                /**
                 * Generates the element `id` for an event element. This is used when
                 * recycling an event div which has been moved from one resource to
                 * another. The event is assigned its new render id *before* being
                 * returned to the free pool, so that when the render engine requests
                 * a div from the free pool, the same div will be returned.
                 * @param {Scheduler.model.EventModel|String|Number} eventRecord Event record or id
                 * @param {Scheduler.model.ResourceModel|String|Number} resourceRecord Resource record or id
                 * @private
                 */

              }, {
                key: "getEventRenderId",
                value: function getEventRenderId(eventRecord, resourceRecord) {
                  // Replacing and - in the id with ._. to not break `getResourceIdFromDomNodeId()`
                  var eventId = eventRecord instanceof _model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_19__["default"] ? eventRecord.id : eventRecord,
                      eventIdWithoutDash = eventId.toString().replace(hyphenRe, '._.'),
                      resourceId = resourceRecord instanceof _model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_20__["default"] ? resourceRecord.id : resourceRecord,
                      resourceIdWithoutDash = resourceId.toString().replace(hyphenRe, '._.');
                  return this.eventPrefix + "".concat(eventIdWithoutDash, "-").concat(resourceIdWithoutDash, "-x");
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "eventPrefix",
                //endregion
                //region Init
                get: function get() {
                  return this._eventPrefix;
                },
                set: function set(eventPrefix) {
                  this._eventPrefix = eventPrefix || this.id + '-';
                } //endregion
                //region Settings

              }, {
                key: "layouts",
                get: function get() {
                  var me = this;

                  if (!me._eventLayout) {
                    me._eventLayout = {}; // pack, fit all events in available height by adjusting their height

                    if (me.horizontalLayoutPackClass) {
                      me._eventLayout.horizontalPack = new me.horizontalLayoutPackClass(Object.assign( // this is required for table layout
                      {
                        scheduler: me,
                        timeAxisViewModel: me.timeAxisViewModel,
                        bandIndexToPxConvertFn: me.horizontal.layoutEventVerticallyPack,
                        bandIndexToPxConvertThisObj: me.horizontal
                      }, me.horizontalEventSorterFn ? {
                        sortEvents: this.horizontalEventSorterFn
                      } : {}));
                    } // stack, adjust row height to fit all events


                    if (me.horizontalLayoutStackClass) {
                      me._eventLayout.horizontalStack = new me.horizontalLayoutStackClass(Object.assign( // this is required for table layout
                      {
                        scheduler: me,
                        timeAxisViewModel: me.timeAxisViewModel,
                        bandIndexToPxConvertFn: me.horizontal.layoutEventVerticallyStack,
                        bandIndexToPxConvertThisObj: me.horizontal
                      }, me.horizontalEventSorterFn ? {
                        sortEvents: this.horizontalEventSorterFn
                      } : {}));
                    }
                  }

                  return me._eventLayout;
                }
                /**
                 * Get/set overlap mode. See config, valid values are stack (horizontal), pack, mixed (vertical) and none
                 * @property {String}
                 * @category Scheduled events
                 */

              }, {
                key: "eventLayout",
                get: function get() {
                  return this._overlapMode;
                },
                set: function set(eventLayout) {
                  var me = this;

                  if (eventLayout != me._overlapMode) {
                    me.element.classList.remove("b-eventlayout-".concat(me._overlapMode));
                    me._overlapMode = eventLayout;
                    me.runWithTransition(function () {
                      me.element.classList.add("b-eventlayout-".concat(me._overlapMode));
                      me.refresh();
                    });
                  }
                }
                /**
                 * Get/set fillTicks setting. If set to true it forces the rendered events to fill entire ticks.
                 * @property {String}
                 * @category Scheduled events
                 */

              }, {
                key: "fillTicks",
                get: function get() {
                  return this._fillTicks;
                },
                set: function set(fill) {
                  var me = this;

                  if (fill != me._fillTicks) {
                    me._fillTicks = fill;
                    me.refreshWithTransition();
                  }
                }
                /**
                 * Control how much space to leave between the first event/last event and the resources edge (top/bottom margin within
                 * the resource row in horizontal mode, left/right margin within the resource column in vertical mode),
                 * in px. Defaults to the value of {@link Scheduler.view.mixin.TimelineEventRendering#config-barMargin}.
                 * @member {Number} resourceMargin
                 * @category Scheduled events
                 */

                /**
                 * Gets currently used event layout class. The event layout class decides the vertical placement of the events
                 * within a resource. Returns null if no eventLayout is used (if Scheduler#eventLayout is set to "none")
                 * @internal
                 * @returns {*}
                 * @readonly
                 * @category Scheduled events
                 */

              }, {
                key: "currentEventLayout",
                get: function get() {
                  var me = this;
                  if (!me.isHorizontal) return null;

                  switch (me.eventLayout) {
                    case 'stack':
                      return me.layouts.horizontalStack;

                    case 'pack':
                      return me.layouts.horizontalPack;

                    default:
                      return null;
                  }
                }
              }, {
                key: "useInitialAnimation",
                get: function get() {
                  return this._useInitialAnimation;
                },
                set: function set(name) {
                  var me = this;

                  if (me._useInitialAnimation) {
                    me.element.classList.remove("b-initial-".concat(me._useInitialAnimation));
                  }

                  me._useInitialAnimation = name === true ? 'fade-in' : name;

                  if (name) {
                    me.element.classList.add("b-initial-".concat(me._useInitialAnimation));
                  }
                }
              }, {
                key: "isFirstRender",
                set: function set(value) {
                  var me = this;
                  me._isFirstRender = value;

                  if (!me._firstRenderDone && value) {
                    me._firstRenderDone = me.createOnFrame(function () {
                      me._isFirstRender = false;
                      me._firstRenderDone = null;
                    });
                  }
                },
                get: function get() {
                  return this._isFirstRender;
                } //endregion
                //region Resource header/columns
                // NOTE: The configs below are initially applied to the resource header in `TimeAxisColumn#set mode`

              }, {
                key: "resourceColumns",
                set: function set(config) {
                  this._resourceColumns = config;
                }
                /**
                 * Use it to manipulate resource column properties at runtime.
                 * @property {Scheduler.view.ResourceHeader}
                 * @readonly
                 */
                ,
                get: function get() {
                  return this.timeAxisColumn && this.timeAxisColumn.resourceColumns || this._resourceColumns;
                }
                /**
                 * Get resource column width. Only applies to vertical mode. To set it, assign to
                 * `scheduler.resourceColumns.columnWidth`.
                 * @property {Number}
                 * @readonly
                 */

              }, {
                key: "resourceColumnWidth",
                get: function get() {
                  return this.resourceColumns ? this.resourceColumns.columnWidth : null;
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                //region Default config
                get: function get() {
                  return {
                    /**
                     * An empty function by default, but provided so that you can override it. This function is called each time
                     * an event is rendered into the schedule to render the contents of the event. It's called with the event,
                     * its resource and a tplData object which allows you to populate data placeholders inside the event
                     * template. **IMPORTANT** You should never modify any data on the EventModel inside this method.
                     * By default, the DOM markup of an event bar includes placeholders for 'cls' and 'style'. The cls property is a
                     * {@link Common.helper.util.DomClassList} which will be added to the event element. The style property is an inline style declaration for
                     * the event element.
                     *
                     * ```javascript
                     * eventRenderer({eventRecord, resourceRecord, tplData}) {
                     *   tplData.style = 'color:white';                 // You can use inline styles too.
                     *
                     *   // Property names with truthy values are added to the resulting elements CSS class.
                     *   tplData.cls.isImportant = this.isImportant(eventRecord);
                     *   tplData.cls.isModified = eventRecord.isModified;
                     *
                     *   // Remove a class name by setting the property to false
                     *   tplData.cls[scheduler.generatedIdCls] = false;
                     *
                     *   // Or, you can treat it as a string, but this is less efficient, especially
                     *   // if your renderer wants to *remove* classes that may be there.
                     *   tplData.cls += ' extra-class'
                     *
                     *   return DateHelper.format(eventRecord.startDate, 'YYYY-MM-DD') + ': ' + eventRecord.name;
                     * }
                     * ```
                     *
                     * @param {Object} detail An object containing the information needed to render an Event.
                     * @param {Scheduler.model.EventModel} detail.eventRecord The event record.
                     * @param {Scheduler.model.ResourceModel} detail.resourceRecord The resource record.
                     * @param {Scheduler.model.AssignmentModel} detail.assignmentRecord The assignment record, if using an AssignmentStore.
                     * @param {Object} detail.tplData An object containing details about the event rendering.
                     * @param {Scheduler.model.EventModel} detail.tplData.event The event record.
                     * @param {Common.helper.util.DomClassList|String} detail.tplData.cls An object whose property names represent the CSS class names
                     * to be added to the event bar element. Set a property's value to truthy or falsy to add or remove the class
                     * name based on the property name. Using this technique, you do not have to know whether the class is already
                     * there, or deal with concatenation.
                     * @param {Common.helper.util.DomClassList|String} detail.tplData.wrapperCls An object whose property names represent the CSS class names
                     * to be added to the event wrapper element. Set a property's value to truthy or falsy to add or remove the class
                     * name based on the property name. Using this technique, you do not have to know whether the class is already
                     * there, or deal with concatenation.
                     * @param {Common.helper.util.DomClassList|String} detail.tplData.iconCls An object whose property names represent the CSS class
                     * names to be added to an event icon element.
                     * @param {Number} detail.tplData.left Vertical offset position (in pixels) on the time axis.
                     * @param {Number} detail.tplData.width Width in pixels of the event element.
                     * @param {Number} detail.tplData.height Height in pixels of the event element.
                     * @param {String} detail.tplData.eventStyle The `eventStyle` of the event. Use this to apply custom styles to the event DOM element
                     * @param {String} detail.tplData.eventColor The `eventColor` of the event. Use this to set a custom color for the rendererd event
                     * @returns {String|Object} A simple string, or a custom object which will be applied to the {@link #config-eventBodyTemplate}, creating the actual HTML
                     * @config {function}
                     * @category Scheduled events
                     */
                    eventRenderer: null,

                    /**
                     * `this` reference for the {@link #config-eventRenderer} function
                     * @config {Object}
                     * @category Scheduled events
                     */
                    eventRendererThisObj: null,
                    eventPrefix: '',

                    /**
                     * How to handle overlapping events. Valid values are:
                     * - stack, adjusts row height (only horizontal)
                     * - pack, adjusts event height
                     * - mixed, allows two events to overlap, more packs (only vertical)
                     * - none, allows events to overlap
                     * @config {String}
                     * @default
                     * @category Scheduled events
                     */
                    eventLayout: 'stack',

                    /**
                     * The class responsible for the packing horizontal event layout process.
                     * Override this to take control over the layout process.
                     * @config {Scheduler.eventlayout.HorizontalLayout}
                     * @default
                     * @private
                     * @category Misc
                     */
                    horizontalLayoutPackClass: _eventlayout_HorizontalLayoutPack_js__WEBPACK_IMPORTED_MODULE_18__["default"],

                    /**
                     * The class name responsible for the stacking horizontal event layout process.
                     * Override this to take control over the layout process.
                     * @config {Scheduler.eventlayout.HorizontalLayout}
                     * @default
                     * @private
                     * @category Misc
                     */
                    horizontalLayoutStackClass: _eventlayout_HorizontalLayoutStack_js__WEBPACK_IMPORTED_MODULE_17__["default"],

                    /**
                     * Override this method to provide a custom sort function to sort any overlapping events. By default,
                     * overlapping events are laid out based on the start date. If the start date is equal, events with earlier
                     * end date go first.
                     *
                     * Here's a sample sort function, sorting on start- and end date. If this function returns -1, then event a
                     * is placed above event b.
                     * ```javascript
                     * horizontalEventSorterFn(a, b) {
                     *
                     *   let startA = a.startDate, endA = a.endDate;
                     *   let startB = b.startDate, endB = b.endDate;
                     *
                     *   let sameStart = (startA - startB === 0);
                     *
                     *   if (sameStart) {
                     *     return endA > endB ? -1 : 1;
                     *   } else {
                     *     return (startA < startB) ? -1 : 1;
                     *   }
                     * }
                     * ```
                     * @param  {Scheduler.model.EventModel} a
                     * @param  {Scheduler.model.EventModel} b
                     * @return {Number}
                     * @config {function}
                     * @category Misc
                     */
                    horizontalEventSorterFn: null,

                    /**
                     * Field from EventModel displayed as text in the bar when rendering
                     * @config {String}
                     * @default
                     * @category Scheduled events
                     */
                    eventBarTextField: 'name',

                    /**
                     * The template used to generate the markup of your events in the scheduler. To 'populate' the
                     * eventBodyTemplate with data, use the {@link #config-eventRenderer} method
                     * @config {Function}
                     * @category Scheduled events
                     */
                    eventBodyTemplate: null,
                    eventPositionMode: 'translate',
                    eventScrollMode: 'move',

                    /**
                     * Specify `true` to force rendered events to fill entire ticks. This only affects rendering, events retain
                     * their set start and end dates on the data level. When enabling this config you should probably also
                     * disable EventDrag and EventResize, otherwise their behaviour will not be what a user expects.
                     * @config {Boolean}
                     * @default
                     * @category Scheduled events
                     */
                    fillTicks: false,

                    /**
                     * By default scheduler fades events in on load. Specify `false` to prevent this animation or specify one
                     * of the available animation types to use it (`true` equals `'fade-in'`):
                     * * fade-in (default)
                     * * slide-from-left
                     * * slide-from-top
                     * ```
                     * // Slide events in from the left on load
                     * scheduler = new Scheduler({
                     *     useInitialAnimation : 'slide-from-left'
                     * });
                     * ```
                     * @config {Boolean|String}
                     * @default
                     * @category Misc
                     */
                    useInitialAnimation: true,

                    /**
                     * A config object used to configure the resource columns in vertical mode.
                     * See {@link Scheduler.view.ResourceHeader} for more details on available properties.
                     *
                     * ```
                     * new Scheduler({
                     *   resourceColumns : {
                     *     columnWidth : 100,
                     *     headerRenderer({ resourceRecord }) => `${resourceRecord.id} - ${resourceRecord.name}`
                     *   }
                     * })
                     * ```
                     * @config {Object}
                     * @category Resources
                     */
                    resourceColumns: null,

                    /**
                     * Path to load resource images from. Used by the resource header in vertical mode and the
                     * {@link Scheduler.column.ResourceInfoColumn} in horizontal mode. Set this to display miniature
                     * images for each resource using their 'imageUrl` field. If set and a resource has not `imageUrl` specified
                     * it will try using the resources name with `.jpg` appended.
                     *
                     * **NOTE**: The path should end with a `/`:
                     *
                     * ```
                     * new Scheduler({
                     *   resourceImagePath : 'images/resources/'
                     * });
                     * ```
                     * @config {String}
                     * @category Resources
                     */
                    resourceImagePath: null,

                    /**
                     * Generic resource image, used when `imageUrl` or `name.jpg` for a resource is invalid
                     * @config {String}
                     * @category Resources
                     */
                    defaultResourceImageName: 'none.png',

                    /**
                     * Control how much space to leave between the first event/last event and the resources edge (top/bottom
                     * margin within the resource row in horizontal mode, left/right margin within the resource column in
                     * vertical mode), in px. Defaults to the value of {@link Scheduler.view.mixin.TimelineEventRendering#config-barMargin}.
                     * @config {Number}
                     * @category Scheduled events
                     */
                    resourceMargin: null,
                    // Used to animate events on first render
                    isFirstRender: true
                  };
                }
              }]);

              return SchedulerEventRendering;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerRegions.js":
      /*!******************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerRegions.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerRegionsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler'; // eslint-disable-next-line import/no-named-default

        /**
         * @module Scheduler/view/mixin/SchedulerRegions
         */

        /**
         * Functions to get regions (bounding boxes) for scheduler, events etc.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(SchedulerRegions, _ref);

              function SchedulerRegions() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, SchedulerRegions);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerRegions).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(SchedulerRegions, [{
                key: "getScheduleRegion",
                //region Orientation depended regions

                /**
                 * Gets the region represented by the schedule and optionally only for a single resource. The view will ask the scheduler for
                 * the resource availability by calling getResourceAvailability. By overriding that method you can constrain events differently for
                 * different resources.
                 * @param {Scheduler.model.ResourceModel} resourceRecord (optional) The resource record
                 * @param {Scheduler.model.EventModel} eventRecord (optional) The event record
                 * @return {Object} The region of the schedule
                 */
                value: function getScheduleRegion(resourceRecord, eventRecord) {
                  var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                  return this.currentOrientation.getScheduleRegion(resourceRecord, eventRecord, local);
                }
                /**
                 * Gets the region representing the passed resource and optionally just for a certain date interval.
                 * @param {Scheduler.model.ResourceModel} resourceRecord The resource record
                 * @param {Date} startDate A start date constraining the region
                 * @param {Date} endDate An end date constraining the region
                 * @return {Common.helper.util.Rectangle} A Rectangle which encapsulates the resource time span
                 */

              }, {
                key: "getResourceRegion",
                value: function getResourceRegion(resourceRecord, startDate, endDate) {
                  return this.currentOrientation.getRowRegion(resourceRecord, startDate, endDate);
                }
                /**
                 * Gets the start and end dates for an element Region
                 * @param {Common.helper.util.Rectangle} rect The rectangle to map to start and end dates
                 * @param {String} roundingMethod The rounding method to use
                 * @returns {Object} an object containing start/end properties
                 */

              }, {
                key: "getStartEndDatesFromRectangle",
                value: function getStartEndDatesFromRectangle(rect, roundingMethod) {
                  return this.currentOrientation.getStartEndDatesFromRectangle(rect, roundingMethod);
                } //endregion
                //region ResourceEventBox

                /**
                 * Get the region for a specified resources specified event.
                 * @param {Scheduler.model.EventModel} eventRecord
                 * @param {Scheduler.model.ResourceModel} resourceRecord
                 * @param {Boolean} includeOutside Specify true to get boxes for events outside of the rendered zone in both dimensions. This option is used when calculating
                 * dependency lines, and we need to include routes from events which may be outside the rendered zone.
                 * @returns {*}
                 */

              }, {
                key: "getResourceEventBox",
                value: function getResourceEventBox(eventRecord, resourceRecord) {
                  var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false; // event caches its position when rendered, return it if available

                  var me = this,
                      // Vertical always returns a box here
                  cached = me.currentOrientation.getResourceEventBox(eventRecord.id, resourceRecord.id);

                  if (cached) {
                    return cached;
                  } // TODO: Move to HorizontalEventMapper


                  var viewStartDate = me.timeAxis.startDate,
                      viewEndDate = me.timeAxis.endDate,
                      eventStartDate = eventRecord.startDate,
                      eventEndDate = eventRecord.endDate;
                  /* eslint-disable */

                  var result = null,
                      eventLayout,
                      rowEventsLayoutData,
                      eventRecordData,
                      rowElement,
                      rowIndex,
                      rowTop,
                      rowHeight,
                      rowNbrOfBands,
                      eventElements,
                      eventElement,
                      eventElOffsets,
                      eventElBox,
                      firstRowIndex,
                      firstRowRecord,
                      lastRowIndex,
                      lastRowRecord,
                      lastRowEl,
                      foundTplData;
                  /* eslint-enable */
                  // Checking if event record is within current time axis timespan and is visible, i.e. it's not rendered
                  // within a collapsed row (scheduler supports resource tree store as well as flat resource store).

                  if (eventStartDate && eventEndDate && (includeOutside || _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].intersectSpans(eventStartDate, eventEndDate, viewStartDate, viewEndDate)) && this.isRowVisible(resourceRecord)) {
                    rowElement = me.getRowFor(resourceRecord); // If resource row is rendered and displayed

                    if (rowElement) {
                      // Managed event sizing means that the view is responsible for event height setting, the oposite case
                      // is when event height is controlled by CSS's top and height properties.
                      // Fast case: managed event sizing on, querying the view for box position and dimensions
                      if (me.managedEventSizing) {
                        eventLayout = me.currentEventLayout; // Preparing events layout data for event layout instance to process

                        rowEventsLayoutData = me.eventStore.getEventsForResource(resourceRecord).reduce(function (result, event) {
                          var eventBox = me[me.mode].getTimeSpanRenderData(event, resourceRecord, includeOutside);

                          if (eventBox) {
                            result.push(eventBox);
                          }

                          return result;
                        }, []); // Processing event layout data injecting event vertical position into each item of `rowEventsLayoutData`
                        // This layout application takes into account view's `dynamicRowHeight` property

                        eventLayout && eventLayout.applyLayout(rowEventsLayoutData, resourceRecord); // Now we are to find our particular event data inside all events data for the given row record

                        eventRecordData = rowEventsLayoutData.find(function (eventData) {
                          return eventData.event == eventRecord;
                        }); // We must find our event record corresponding layout data object here, but just to make sure

                        if (eventRecordData) {
                          // We have event record data with coordinates within the row node, but we need
                          // those coordinates to be translated relative to view's viewport top.
                          rowTop = me.getRecordCoords(resourceRecord, true).y; // Finally we have all the data needed to calculated the event record box

                          result = {
                            layout: true,
                            start: eventRecordData.hasOwnProperty('left') ? eventRecordData.left : eventRecordData.right,
                            // it depends on view's `rtl` configuration
                            end: (eventRecordData.hasOwnProperty('left') ? eventRecordData.left : eventRecordData.right) + eventRecordData.width,
                            top: rowTop + eventRecordData.top,
                            bottom: rowTop + eventRecordData.top + eventRecordData.height
                          };
                        }
                      } // Slow case: managed event sizing off, querying the DOM for box position and dimensions
                      else {
                          eventElements = me.getElementsFromEventRecord(eventRecord, eventRecord !== resourceRecord && resourceRecord); // We must have at one and only one element here, but just to make sure

                          if (eventElements.length) {
                            eventElement = eventElements[0]; // TODO: PORT getOffsetsTo and getBox

                            eventElOffsets = eventElement.getOffsetsTo(me.getEl());
                            eventElBox = eventElement.getBox();
                            result = {
                              layout: true,
                              start: eventElOffsets[0],
                              end: eventElOffsets[0] + eventElBox.width,
                              top: eventElOffsets[1],
                              bottom: eventElOffsets[1] + eventElBox.height
                            };
                          }
                        }
                    } // Resource row is not rendered, and it's not collapsed. We are to calculate event record box approximately.
                    else {
                        result = {
                          layout: false,
                          start: me.getCoordinateFromDate(Math.max(eventRecord.startDateMS, me.timeAxis.startMS)),
                          end: me.getCoordinateFromDate(Math.min(eventRecord.endDateMS, me.timeAxis.endMS)) // top and bottom to go

                        }; // Request local record coordinates within the scroll range.

                        var recordCoords = me.rowManager.getRecordCoords(resourceRecord, true); // faster than Object.assign...

                        result.top = recordCoords.y + me.barMargin;
                        result.height = Math.max(me.rowManager.rowHeight - 2 * me.barMargin, 1);
                        result.bottom = result.top + result.height;
                      } // Some boxes might need special adjustments


                    if (result) {
                      result = me.adjustItemBox(eventRecord, result);
                    }
                  }

                  return result;
                } //endregion
                //region Item box

                /**
                 * Gets box for displayed item designated by the record. If several boxes are displayed for the given item
                 * then the method returns all of them. Box coordinates are in view coordinate system.
                 *
                 * Boxes outside scheduling view timeaxis timespan and inside collapsed rows (if row defining store is a tree store)
                 * will not be returned. Boxes outside scheduling view vertical visible area (i.e. boxes above currently visible
                 * top row or below currently visible bottom row) will be calculated approximately.
                 *
                 * @param {Scheduler.model.EventModel} event
                 * @return {Object|Object[]}
                 * @return {Boolean} return.rendered Whether the box was calculated for the rendered scheduled record or was
                 *                                   approximatelly calculated for the scheduled record outside of the current
                 *                                   vertical view area.
                 * @return {Number} return.top
                 * @return {Number} return.bottom
                 * @return {Number} return.start
                 * @return {Number} return.end
                 * @return {String} return.relPos if the item is not rendered then provides a view relative position one of 'before', 'after'
                 * @internal
                 */

              }, {
                key: "getItemBox",
                value: function getItemBox(event) {
                  var _this = this;

                  var includeOutside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                  return event.resources.map(function (resource) {
                    return _this.getResourceEventBox(event, resource, includeOutside);
                  });
                }
                /**
                 * Adjusts event record box if needed
                 *
                 * @param {Scheduler.model.EventModel} eventRecord
                 * @param {Object} eventRecordBox
                 * @return {Number} eventRecordBox.top
                 * @return {Number} eventRecordBox.bottom
                 * @return {Number} eventRecordBox.start
                 * @return {Number} eventRecordBox.end
                 * @return {Object}
                 * @return {Number} return.top
                 * @return {Number} return.bottom
                 * @return {Number} return.start
                 * @return {Number} return.end
                 * @internal
                 */

              }, {
                key: "adjustItemBox",
                value: function adjustItemBox(eventRecord, eventRecordBox) {
                  var viewStartMS = this.timeAxis.startMS,
                      viewEndMS = this.timeAxis.endMS,
                      eventStartMS = eventRecord.startDateMS,
                      eventEndMS = eventRecord.endDateMS,
                      width = this.timeAxisViewModel.totalSize,
                      OUTSIDE_VIEW_OFFSET = 40; // To make sure non-relevant dependency lines aren't seen
                  // adjust event box to render dependency lines for events that are outside of the view

                  if (viewStartMS > eventStartMS) eventRecordBox.start = -OUTSIDE_VIEW_OFFSET;
                  if (viewStartMS > eventEndMS) eventRecordBox.end = -OUTSIDE_VIEW_OFFSET;
                  if (viewEndMS < eventStartMS) eventRecordBox.start = width + OUTSIDE_VIEW_OFFSET;
                  if (viewEndMS < eventEndMS) eventRecordBox.end = width + OUTSIDE_VIEW_OFFSET;
                  return eventRecordBox;
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return SchedulerRegions;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerScroll.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerScroll.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerScrollJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.promise */
        "./node_modules/core-js/modules/es6.promise.js");
        /* harmony import */


        var core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_promise__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/SchedulerScroll
         */

        var immediatePromise = new Promise(function (resolve) {
          return resolve();
        }),
            defaultScrollOptions = {
          block: 'nearest',
          edgeOffset: 20
        };
        /**
         * Functions for scrolling to events, dates etc.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(SchedulerScroll, _ref);

              function SchedulerScroll() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, SchedulerScroll);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(SchedulerScroll).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(SchedulerScroll, [{
                key: "scrollEventIntoView",
                //region Scroll to event

                /**
                 * Scrolls an event record into the viewport.
                 * If the resource store is a tree store, this method will also expand all relevant parent nodes to locate the event.
                 *
                 * @param {Scheduler.model.EventModel} eventRec the event record to scroll into view
                 * @param {Object} [options] How to scroll.
                 * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
                 * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
                 * @param {Boolean/Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
                 * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
                 * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
                 * @returns {Promise} A Promise which resolves when the scrolling is complete.
                 *
                 * This function is not applicable for events with multiple assignments, please use #scrollResourceEventIntoView instead.
                 */
                value: function scrollEventIntoView(eventRec) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;
                  var me = this,
                      resources = eventRec.resources || [eventRec];

                  if (resources.length > 1) {
                    throw new Error('scrollEventIntoView() is not applicable for events with multiple assignments, please use scrollResourceEventIntoView() instead.');
                  }

                  if (!resources.length) {
                    console.warn('You have asked to scroll to an event which is not assigned to a resource');
                    return immediatePromise;
                  }

                  return me.scrollResourceEventIntoView(resources[0], eventRec, null, options);
                }
                /**
                 * Scrolls a resource event record into the viewport.
                 *
                 * If the resource store is a tree store, this method will also expand all relevant parent nodes
                 * to locate the event.
                 *
                 * @param {Scheduler.model.ResourceModel} resourceRec A resource record an event record is assigned to
                 * @param {Scheduler.model.EventModel} eventRec An event record to scroll into view
                 * @param {Number} index DOM node index, applicable only for weekview
                 * @param {Object} [options] How to scroll.
                 * @param {String} [options.block=nearest] How far to scroll the event: `start/end/center/nearest`.
                 * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the event to bring into view.
                 * @param {Boolean/Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
                 * @param {Boolean} [options.extendTimeAxis=true] By default, if the requested event is outside the time axis, the time axis is extended.
                 * @param {Boolean} [options.highlight] Set to `true` to highlight the event element when it is in view.
                 * @param {Boolean} [options.focus] Set to `true` to focus the event element when it is in view.
                 * @returns {Promise} A Promise which resolves when the scrolling is complete.
                 */

              }, {
                key: "scrollResourceEventIntoView",
                value: function scrollResourceEventIntoView(resourceRec, eventRec, index) {
                  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultScrollOptions;
                  var me = this,
                      eventStart = eventRec.startDate,
                      eventEnd = eventRec.endDate,
                      eventIsOutside = eventStart < me.timeAxis.startDate | (eventEnd > me.timeAxis.endDate) << 1;
                  var el;

                  if (options.edgeOffset == null) {
                    options.edgeOffset = 20;
                  } // Make sure event is within TimeAxis time span unless extendTimeAxis passed as false.
                  // The EventEdit feature passes false because it must not mutate the TimeAxis.
                  // Bitwise flag:
                  //  1 === start is before TimeAxis start.
                  //  2 === end is after TimeAxis end.


                  if (eventIsOutside && options.extendTimeAxis !== false) {
                    var currentTimeSpanRange = me.timeAxis.endDate - me.timeAxis.startDate,
                        startAnchorPoint,
                        endAnchorPoint; // Event is too wide, expand the range to encompass it.

                    if (eventIsOutside === 3) {
                      me.timeAxis.setTimeSpan(new Date(eventStart.valueOf() - currentTimeSpanRange / 2), new Date(eventEnd.getTime() + currentTimeSpanRange / 2));
                    } // Event is partially or wholly outside but will fit.
                    // Move the TimeAxis to include it. Attempt to maintain visual position.
                    else {
                        startAnchorPoint = eventIsOutside & 1 ? me.getCoordinateFromDate(eventRec.endDate) : me.getCoordinateFromDate(eventRec.startDate); // Event starts before

                        if (eventIsOutside & 1) {
                          me.timeAxis.setTimeSpan(new Date(eventStart), new Date(eventStart.valueOf() + currentTimeSpanRange));
                        } // Event ends after
                        else {
                            me.timeAxis.setTimeSpan(new Date(eventEnd.valueOf() - currentTimeSpanRange), new Date(eventEnd));
                          } // Restore view to same relative scroll position.


                        endAnchorPoint = eventIsOutside & 1 ? me.getCoordinateFromDate(eventRec.endDate) : me.getCoordinateFromDate(eventRec.startDate);
                        me.timeAxisSubGrid.scrollable.scrollBy(endAnchorPoint - startAnchorPoint);
                      }
                  } // Establishing element to scroll to


                  el = me.getElementFromEventRecord(eventRec, resourceRec);

                  if (el) {
                    // It's usually the event wrapper that holds focus
                    if (!_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isFocusable(el)) {
                      el = el.parentNode;
                    }

                    var scroller = me.timeAxisSubGrid.scrollable; // Scroll into view with animation and highlighting if needed.
                    // Mute scroll events during the scroll so that event rendering doesn't replace
                    // the target element.

                    return scroller.scrollIntoView(el, _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].assign({
                      silent: true
                    }, options));
                  } else if (eventIsOutside && options.extendTimeAxis === false) {
                    console.warn('You have asked to scroll to an event which is outside the current view and extending timeaxis is disabled');
                    return immediatePromise;
                  } else if (!me.eventStore.isAvailable(eventRec)) {
                    console.warn('You have asked to scroll to an event which is not available');
                    return immediatePromise;
                  } else {
                    // Event not rendered, scroll to calculated location
                    return me.scrollUnrenderedEventIntoView(resourceRec, eventRec, options);
                  }
                }
                /**
                 * Scrolls an unrendered event into view. Internal function used from #scrollResourceEventIntoView.
                 * @private
                 */

              }, {
                key: "scrollUnrenderedEventIntoView",
                value: function scrollUnrenderedEventIntoView(resourceRec, eventRec) {
                  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultScrollOptions;

                  if (options.edgeOffset == null) {
                    options.edgeOffset = 20;
                  }

                  var me = this,
                      scroller = me.timeAxisSubGrid.scrollable,
                      box = me.getResourceEventBox(eventRec, resourceRec),
                      // TODO: have all "box" type objects use Rectangle
                  scrollerViewport = scroller.viewport,
                      targetRect = new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_9__["default"](box.start, box.top, box.end - box.start, box.bottom - box.top).translate(scrollerViewport.x - scroller.x, scrollerViewport.y - scroller.y),
                      result = scroller.scrollIntoView(targetRect, Object.assign({}, options, {
                    highlight: false
                  }));

                  if (options.highlight || options.focus) {
                    var detatcher = me.on({
                      eventrepaint: function eventrepaint(_ref2) {
                        var scheduler = _ref2.scheduler,
                            eventRecord = _ref2.eventRecord,
                            resourceRecord = _ref2.resourceRecord,
                            element = _ref2.element;

                        if (eventRecord === eventRec) {
                          detatcher();
                          result.then(function () {
                            options.highlight && _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].highlight(element);
                            options.focus && element.focus();
                          });
                        }
                      }
                    });
                  }

                  return result;
                }
                /**
                 * Scrolls the specified resource into view, works for both horizontal and vertical modes.
                 * @param {Scheduler.model.ResourceModel} resourceRecord A resource record an event record is assigned to
                 * @param {Object} [options] How to scroll.
                 * @param {String} [options.column] Field name or ID of the column, or the Column instance to scroll to (in horizontal mode).
                 * @param {String} [options.block] How far to scroll the element: `start/end/center/nearest`.
                 * @param {Number} [options.edgeOffset] edgeOffset A margin around the element or rectangle to bring into view.
                 * @param {Boolean|Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
                 * @param {Boolean} [options.highlight] Set to `true` to highlight the element when it is in view.
                 * @returns {Promise} A promise which is resolved when the scrolling has finished.
                 */

              }, {
                key: "scrollResourceIntoView",
                value: function scrollResourceIntoView(resourceRecord) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultScrollOptions;

                  if (this.isVertical) {
                    return this.currentOrientation.scrollResourceIntoView(resourceRecord, options);
                  } else {
                    return this.scrollRowIntoView(resourceRecord, options);
                  }
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return SchedulerScroll;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerState.js":
      /*!****************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerState.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/SchedulerState
         */

        var copyProperties = ['eventLayout', 'barMargin', 'mode', 'tickSize', 'zoomLevel', 'eventColor', 'eventStyle', 'fillTicks'];
        /**
         * Mixin for Scheduler that handles state. It serializes the following scheduler properties:
         *
         * * eventLayout
         * * barMargin
         * * mode
         * * tickSize
         * * zoomLevel
         * * eventColor
         * * eventStyle
         *
         * See {@link Grid.view.mixin.GridState} and {@link Common.mixin.State} for more information on state.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(SchedulerState, _ref);

              function SchedulerState() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, SchedulerState);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerState).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(SchedulerState, [{
                key: "getState",

                /**
                 * Get schedulers current state for serialization. State includes rowHeight, headerHeight, readOnly, selectedCell,
                 * selectedRecordId, column states and store state.
                 * @returns {Object} State object to be serialized
                 * @private
                 */
                value: function getState() {
                  return _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].copyProperties(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerState.prototype), "getState", this).call(this), this, copyProperties);
                }
                /**
                 * Apply previously stored state.
                 * @param {Object} state
                 * @private
                 */

              }, {
                key: "applyState",
                value: function applyState(state) {
                  _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].copyProperties(this, state, copyProperties);

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(SchedulerState.prototype), "applyState", this).call(this, state);
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return SchedulerState;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/SchedulerStores.js":
      /*!*****************************************************!*\
        !*** ./lib/Scheduler/view/mixin/SchedulerStores.js ***!
        \*****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinSchedulerStoresJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "./node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "./node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/toConsumableArray */
        "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
        /* harmony import */


        var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/set */
        "./node_modules/@babel/runtime/helpers/set.js");
        /* harmony import */


        var _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../../Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _data_CrudManager_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../data/CrudManager.js */
        "./lib/Scheduler/data/CrudManager.js");
        /* harmony import */


        var _data_EventStore_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../../data/EventStore.js */
        "./lib/Scheduler/data/EventStore.js");
        /* harmony import */


        var _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ../../data/ResourceStore.js */
        "./lib/Scheduler/data/ResourceStore.js");
        /* harmony import */


        var _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ../../data/AssignmentStore.js */
        "./lib/Scheduler/data/AssignmentStore.js");
        /* harmony import */


        var _Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ../../../Common/GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony import */


        var _data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ../../data/DependencyStore.js */
        "./lib/Scheduler/data/DependencyStore.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/SchedulerStores
         */

        var MAX_VALUE = Math.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1,
            checkResources = {
          add: 1,
          update: 1,
          remove: 1,
          filter: 1
        };
        /**
         * Functions for store assignment and store event listeners
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_15___default()(SchedulerStores, _ref);

              function SchedulerStores() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_9___default()(this, SchedulerStores);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_11___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_10___default()(SchedulerStores, [{
                key: "onStoreDataChange",
                //endregion
                value: function onStoreDataChange(_ref2) {
                  var store = _ref2.source,
                      action = _ref2.action;
                  this.currentOrientation.clearEvents();

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "onStoreDataChange", this).apply(this, arguments);
                } // Wrap w/ transition refreshFromRowOnStoreAdd() inherited from Grid

              }, {
                key: "refreshFromRowOnStoreAdd",
                value: function refreshFromRowOnStoreAdd(row, _ref3) {
                  var _this = this;

                  var isExpand = _ref3.isExpand;
                  var args = arguments;
                  this.runWithTransition(function () {
                    var _get2;

                    return (_get2 = _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "refreshFromRowOnStoreAdd", _this)).call.apply(_get2, [_this, row].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(args)));
                  }, !isExpand);
                }
              }, {
                key: "onStoreAdd",
                value: function onStoreAdd(_ref4) {
                  var store = _ref4.source,
                      records = _ref4.records,
                      isChild = _ref4.isChild;
                  var me = this,
                      rowManager = me.rowManager; // If it was an appendChild to a parent that is not expanded,
                  // do nothing

                  if (isChild && !records[0].parent.isExpanded(me)) {
                    return;
                  }

                  rowManager.calculateRowCount(false, true, true);
                  var endIndex = Math.max(rowManager.topIndex + rowManager.rowCount, Math.min(rowManager.visibleRowCount, store.count)); // Need to find topmost resource because we have to update from there downwards

                  records = records.sort(function (lhs, rhs) {
                    return store.indexOf(lhs) - store.indexOf(rhs);
                  });
                  var firstUpdatedIndex = store.indexOf(records[0]); // If the update is below the rendered block, ignore it

                  if (firstUpdatedIndex < endIndex) {
                    // Start updating from the first affected record, or the rendered block
                    // top if the record is above the rendered block.
                    firstUpdatedIndex = Math.max(firstUpdatedIndex, rowManager.topIndex); // Clear events on every row below the first record

                    for (var i = firstUpdatedIndex; i < endIndex; i++) {
                      me.currentOrientation.onRowRecordUpdate({
                        record: store.getAt(i)
                      });
                    }
                  } else {
                    // Still might have changed total height
                    rowManager.estimateTotalHeight();
                  }

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "onStoreAdd", this).apply(this, arguments);
                }
                /**
                 * Overrides event handler in Grid, to pass on to current orientation class
                 * @private
                 */

              }, {
                key: "onStoreUpdateRecord",
                value: function onStoreUpdateRecord() {
                  // need to update events when resource changes (might use data in renderers, templates)
                  if (!this.suspendStoreRedraw) {
                    var _this$currentOrientat;

                    (_this$currentOrientat = this.currentOrientation).onRowRecordUpdate.apply(_this$currentOrientat, arguments);

                    _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "onStoreUpdateRecord", this).apply(this, arguments);
                  }
                }
              }, {
                key: "onStoreRemove",
                value: function onStoreRemove() {
                  var _this$currentOrientat2;

                  (_this$currentOrientat2 = this.currentOrientation).onRowRecordRemove.apply(_this$currentOrientat2, arguments);

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "onStoreRemove", this).apply(this, arguments);
                }
              }, {
                key: "onStoreRemoveAll",
                value: function onStoreRemoveAll() {
                  this.currentOrientation.clearEvents();

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "onStoreRemoveAll", this).call(this);
                } //region destroy
                // Cleanup, destroys stores if Scheduler.destroyStores is true.

              }, {
                key: "doDestroy",
                value: function doDestroy() {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "doDestroy", this).call(this);

                  var me = this;

                  if (me.destroyStores) {
                    // TODO: Use me.destroyMembers when available.
                    if (me.assignmentStore) me.assignmentStore.destroy();
                    if (me.resourceStore) me.resourceStore.destroy();
                    if (me.dependencyStore) me.dependencyStore.destroy();
                    if (me.eventStore) me.eventStore.destroy();
                  }
                } //endregion
                //region Row store

              }, {
                key: "onEventIdChange",
                //endregion
                //region Events
                value: function onEventIdChange(params) {
                  this.currentOrientation.onEventStoreIdChange && this.currentOrientation.onEventStoreIdChange(params);
                }
                /**
                 * Calls appropriate functions for current event layout when the event store is modified.
                 * @private
                 */
                // Named as Internal to avoid naming collision with wrappers that relay events

              }, {
                key: "onInternalEventStoreChange",
                value: function onInternalEventStoreChange(params) {
                  var me = this; // Too early, bail out

                  if (!me._mode) {
                    return;
                  }

                  if (me.isVertical) {
                    me.currentOrientation.onEventStoreChange(params);
                  } else {
                    var _ret = function () {
                      // TODO: Move this to horizontal
                      var layout = me.currentOrientation,
                          eventStore = params.source,
                          rowManager = me.rowManager,
                          resourceStore = me.resourceStore,
                          action = params.action,
                          changes = params.changes,
                          isCollapse = params.isCollapse,
                          events = params.records || (params.record ? [params.record] : null),
                          resources = [];
                      var rows = new Set(),
                          useTransition = false,
                          len,
                          i;

                      if (!me.rendered) {
                        return {
                          v: void 0
                        };
                      } // Ignore update caused by collapse or removing associated resource, will be handled by resource removal code


                      if (isCollapse || action === 'update' && events.length && events[0].meta.removingResource) {
                        return {
                          v: void 0
                        };
                      } // resource timeranges feature embeds into regular events drawing procedure
                      // which means in some cases we should repaint all rows


                      var skipRows = action === 'filter' && me.hasFeature('resourceTimeRanges'); // If events were changed

                      if (!skipRows && checkResources[action] && events) {
                        // For event resource change, the "from" resource is part of the changed resource set.
                        if (changes && 'resourceId' in changes && changes.resourceId.oldValue != null) {
                          var prevResource = resourceStore.getById(changes.resourceId.oldValue),
                              prevRow = prevResource && rowManager.getRowFor(prevResource); // Old resource might not exist in store, https://app.assembla.com/spaces/bryntum/tickets/7070.
                          // Happens for example when dropping from another scheduler.

                          if (prevRow) {
                            resources.push(prevResource);
                            rows.add(prevRow);
                          }
                        } // We are only interested in associated resources which exist in the store and are in the rendered block.


                        for (i = 0, len = events.length; i < len; i++) {
                          resources.push.apply(resources, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(eventStore.getResourcesForEvent(events[i]).filter(function (resource) {
                            if (resource) {
                              var row = rowManager.getRowFor(resource);

                              if (row) {
                                rows.add(row);
                                return true;
                              }
                            }

                            return false;
                          })));
                        }

                        if (resources.length) {
                          // Sort rows if more than one
                          if (rows.size > 1) {
                            rows = new Set(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(rows).sort(function (a, b) {
                              return a.dataIndex - b.dataIndex;
                            }));
                          } // If all affected rows are outside of the rendered range, do nothing
                          else if (!rows.size) {
                              return {
                                v: void 0
                              };
                            }
                        } // No resources in the rendered block were visible (or all events filtered out, in which case a full redraw
                        // is performed). Nothing to update in the UI, but the dataset height might have changed.
                        else if (!(action === 'filter' && !events.length)) {
                            rowManager.estimateTotalHeight();
                            return {
                              v: void 0
                            };
                          }

                        params.resources = resources;
                      }

                      switch (action) {
                        case 'dataset':
                          layout.onEventDataset();
                          break;

                        case 'add':
                          layout.onEventAdd(params);
                          useTransition = true;
                          break;

                        case 'update':
                          layout.onEventUpdate(params);
                          useTransition = true;
                          break;

                        case 'remove':
                          layout.onEventRemove(params);
                          useTransition = true;
                          break;

                        case 'removeall':
                          layout.onEventRemoveAll();
                          break;

                        case 'filter':
                          layout.onEventFilter(params);
                          break;

                        case 'clearchanges':
                          layout.onEventClearChanges(params);
                          break;
                      }

                      me.runWithTransition(function () {
                        if (rows.size) {
                          // Render the affected rows.
                          rowManager.renderRows(rows);
                        } // No specific rows affected, for example a dataset. Draw all
                        else {
                            // TODO: change to refresh() when merged to master
                            rowManager.renderFromRow();
                          }
                      }, useTransition);
                    }();

                    if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_3___default()(_ret) === "object") return _ret.v;
                  }
                }
                /**
                 * If events are changed in batch, endBatch fires refresh, so we must refresh the view
                 * @private
                 */

              }, {
                key: "onEventStoreRefresh",
                value: function onEventStoreRefresh(_ref5) {
                  var action = _ref5.action;

                  if (action === 'batch' && this.rowManager.rowCount) {
                    this.currentOrientation.onEventDataset && this.currentOrientation.onEventDataset(); // TODO: Run with transition?

                    this.refresh();
                  }
                }
                /**
                 * Moves focus before the currently active event is removed.
                 * @private
                 */

              }, {
                key: "onBeforeEventRemove",
                value: function onBeforeEventRemove(_ref6) {
                  var records = _ref6.records;
                  var me = this; // Active event is being removed.

                  if (me.activeEvent && records.includes(me.activeEvent)) {
                    var moveTo; // If being done by a keyboard gesture then look for a close target
                    // until we find an existing record, not scheduled for removal.
                    // Otherwise, per Mats, push focus outside of the Scheduler.

                    if (_Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_23__["default"].lastInteractionType === 'key') {
                      for (var i = 0, l = records.length; i < l && (!moveTo || records.includes(moveTo)); i++) {
                        if (me.eventStore.getResourcesForEvent(records[i]).length) {
                          var event = records[i],
                              from = event.assignments && event.assignments.length ? event.assignments[0] : event;
                          moveTo = me.getNext(from, true) || me.getPrevious(from, true);
                        }
                      }
                    } // Move focus away from the element which will soon have no
                    // backing data.


                    if (moveTo) {
                      me.navigateTo(moveTo);
                    } // Focus must exit the Scheduler's subgrid, otherwise, if a navigation
                    // key gesture is delivered before the outgoing event's element has faded
                    // out and been removed, navigation will be attempted from a deleted
                    // event. Animated hiding is problematic.
                    //
                    // We cannot just revertFocus() because that might move focus back to an
                    // element in a floating EventEditor which is not yet faded out and
                    // been removed. Animated hiding is problematic.
                    //
                    // We cannot focus scheduler.timeAxisColumn.element because the browser
                    // would scroll it in some way if we have horizontal overflow.
                    //
                    // The only thing we can know about to focus here is the Scheduler itself.
                    else {
                        me.element.focus();
                      }
                  }
                }
                /**
                 * Refreshes committed events, to remove dirty/committing flag.
                 * CSS is added
                 * @private
                 */

              }, {
                key: "onEventCommit",
                value: function onEventCommit(_ref7) {
                  var _this2 = this;

                  var changes = _ref7.changes;

                  _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(changes.added).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(changes.modified)).forEach(function (eventRecord) {
                    return _this2.repaintEvent(eventRecord);
                  });
                }
                /**
                 * Adds the committing flag to changed events before commit.
                 * @private
                 */

              }, {
                key: "onEventBeforeCommit",
                value: function onEventBeforeCommit(_ref8) {
                  var _this3 = this;

                  var changes = _ref8.changes; // Committing sets a flag in meta that during eventrendering applies a CSS class. But to not mess up drag and
                  // drop between resources no redraw is performed before committing, so class is never applied to the element(s).
                  // Applying here instead

                  _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(changes.added).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(changes.modified)).forEach(function (eventRecord) {
                    return _this3.getElementsFromEventRecord(eventRecord).forEach(function (element) {
                      return element.classList.add(_this3.committingCls);
                    });
                  });
                } // Clear committing flag

              }, {
                key: "onEventException",
                value: function onEventException(_ref9) {
                  var _this4 = this;

                  var action = _ref9.action;

                  if (action === 'commit') {
                    var changes = this.eventStore.changes;

                    _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(changes.added).concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(changes.modified), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_8___default()(changes.removed)).forEach(function (eventRecord) {
                      return _this4.repaintEvent(eventRecord);
                    });
                  }
                }
                /**
                 * Refreshes scheduler when event changes are cleared.
                 * @private
                 */

              }, {
                key: "onEventClearChanges",
                value: function onEventClearChanges() {
                  this.refresh();
                }
                /**
                 * Refreshes scheduler when data is assigned to the assigment store
                 * @private
                 */

              }, {
                key: "onAssignmentRefresh",
                value: function onAssignmentRefresh(event) {
                  if (this.isHorizontal && (event.action === 'dataset' || event.action === 'batch')) {
                    this.refresh();
                  }
                }
                /**
                 * Repaints affected resources when assignments are added.
                 * @private
                 */

              }, {
                key: "onAssignmentAdd",
                value: function onAssignmentAdd(_ref10) {
                  var _this5 = this;

                  var records = _ref10.records;

                  if (this.isHorizontal) {
                    records.forEach(function (assignment) {
                      var resource = assignment.resource;
                      resource && _this5.repaintEventsForResource(resource);
                    });
                  }
                }
                /**
                 * Repaints affected resources when assignments are updated.
                 * @private
                 */

              }, {
                key: "onAssignmentUpdate",
                value: function onAssignmentUpdate(_ref11) {
                  var record = _ref11.record,
                      changes = _ref11.changes;

                  if (this.isHorizontal) {
                    // TODO: Move to HorizontalEventMapper
                    var rowManager = this.rowManager,
                        layoutCache = this.currentOrientation.cache,
                        oldResourceId = 'resourceId' in changes && changes.resourceId.oldValue,
                        newResourceId = record.resourceId;
                    var row,
                        fromRow = MAX_VALUE;

                    if (oldResourceId != null && (row = rowManager.getRowFor(oldResourceId))) {
                      layoutCache.clearRow(oldResourceId);
                      fromRow = Math.min(fromRow, row.index);
                    }

                    if (newResourceId && (row = rowManager.getRowFor(newResourceId))) {
                      layoutCache.clearRow(newResourceId);
                      fromRow = Math.min(fromRow, row.index);
                    } // Render from the first mutated row in the rendered block;


                    if (fromRow !== MAX_VALUE) {
                      rowManager.renderFromRow(rowManager.rows[fromRow]);
                    }
                  }
                }
              }, {
                key: "onBeforeAssignmentRemove",
                value: function onBeforeAssignmentRemove(_ref12) {
                  var source = _ref12.source,
                      records = _ref12.records; // Bail out if caused by the remove below

                  if (source.isRemovingEvent) {
                    return;
                  }

                  var me = this,
                      events = records.reduce(function (result, assignment) {
                    var event = assignment.event;

                    if (event && !event.placeHolder && !result.includes(event)) {
                      result.push(event);
                    }

                    return result;
                  }, []);
                  var moveTo; // Deassigning the active assignment

                  if (me.activeEvent && events.includes(me.activeEvent)) {
                    // If being done by a keyboard gesture then look for a close target
                    // until we find an existing record, not scheduled for removal.
                    // Otherwise, per Mats, push focus outside of the Scheduler.
                    if (_Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_23__["default"].lastInteractionType === 'key') {
                      // Look for a close target until we find an existing record, not scheduled for removal
                      for (var i = 0, l = records.length; i < l && (!moveTo || records.includes(moveTo)); i++) {
                        if (me.eventStore.getResourcesForEvent(records[i].event).length) {
                          var event = records[i],
                              from = event.assignments && event.assignments.length ? event.assignments[0] : event;
                          moveTo = me.getNext(from) || me.getPrevious(from);
                        }
                      }
                    } // Move focus away from the element which will soon have no
                    // backing data.


                    if (moveTo) {
                      me.navigateTo(moveTo);
                    } // Focus must exit the Scheduler's subgrid, otherwise, if a navigation
                    // key gesture is delivered before the outgoing event's element has faded
                    // out and been removed, navigation will be attempted from a deleted
                    // event. Animated hiding is problematic.
                    //
                    // We cannot just revertFocus() because that might move focus back to an
                    // element in a floating EventEditor which is not yet faded out and
                    // been removed. Animated hiding is problematic.
                    //
                    // We cannot focus scheduler.timeAxisColumn.element because the browser
                    // would scroll it in some way if we have horizontal overflow.
                    //
                    // The only thing we can know about to focus here is the Scheduler itself.
                    else {
                        me.element.focus();
                      }
                  }

                  if (me.removeUnassignedEvent && !me.isRemoving) {
                    // Collect all events that will unassigned after the remove
                    var toRemove = events.reduce(function (result, eventRecord) {
                      var assignmentCount = eventRecord.assignments ? eventRecord.assignments.length : 0;
                      assignmentCount -= records.filter(function (r) {
                        return r.event === eventRecord;
                      }).length;

                      if (!assignmentCount) {
                        result.push(eventRecord);
                      }

                      return result;
                    }, []); // And remove them

                    me.eventStore.remove(toRemove);
                  }
                }
                /**
                 * Repaints affected resources when assignments are removed.
                 * @private
                 */

              }, {
                key: "onAssignmentRemove",
                value: function onAssignmentRemove(_ref13) {
                  var _this6 = this;

                  var records = _ref13.records;

                  if (this.isHorizontal) {
                    records.forEach(function (assignment) {
                      var resource = assignment.resource;
                      resource && _this6.repaintEventsForResource(resource);
                    });
                  }
                }
                /**
                 * Repaints resources when all assignments are removed.
                 * @private
                 */

              }, {
                key: "onAssignmentRemoveAll",
                value: function onAssignmentRemoveAll() {
                  if (this.isHorizontal) {
                    this.refresh();
                  }
                }
                /**
                 * Refreshes scheduler when assignment store is filtered.
                 */

              }, {
                key: "onAssignmentFilter",
                value: function onAssignmentFilter() {
                  if (this.isHorizontal) {
                    this.refresh();
                  }
                } //endregion
                //region Other functions

                /**
                 * Applies the start and end date to each event store request (formatted in the same way as the start date, defined in the EventStore Model class).
                 * @category Data
                 */

              }, {
                key: "applyStartEndParameters",
                value: function applyStartEndParameters(_ref14) {
                  var eventStore = _ref14.source,
                      params = _ref14.params;
                  var me = this,
                      dateFormat = eventStore.modelClass.fieldMap.startDate.dateFormat;
                  params[me.startParamName] = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].format(me.startDate, dateFormat);
                  params[me.endParamName] = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"].format(me.endDate, dateFormat);
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "store",
                get: function get() {
                  var me = this; // Spin up the resourceStore if possible.
                  // If there are configured resources, this will load them too.

                  me._thisIsAUsedExpression(me.resources); // Vertical uses a dummy store


                  if (!me._store && me.isVertical) {
                    // TODO: Make this store readonly, since we are using single cell approach
                    me._store = new _Common_data_Store_js__WEBPACK_IMPORTED_MODULE_17__["default"]({
                      data: [{
                        id: 'verticalTimeAxisRow'
                      }]
                    });
                  }

                  return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_14___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "store", this);
                },
                set: function set(store) {
                  _babel_runtime_helpers_set__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_13___default()(SchedulerStores.prototype), "store", store, this, true);
                } //endregion
                //region ResourceStore

                /**
                 * Get/set resources, applies to the assigned ResourceStore
                 * @property {Scheduler.model.ResourceModel[]|Object[]}
                 * @category Data
                 */

              }, {
                key: "resources",
                get: function get() {
                  var resourceStore = this.resourceStore;
                  return resourceStore && resourceStore.records;
                },
                set: function set(resources) {
                  this.resourceStore.data = resources;
                }
                /**
                 * Get/set the resource store instance
                 * @property {Scheduler.data.ResourceStore}
                 * @category Data
                 */

              }, {
                key: "resourceStore",
                get: function get() {
                  var me = this; // If there's a CrudManager, it injects its resourceStore.
                  // If not, we create our own instance.

                  if (!me._resourceStore) {
                    if (!me.crudManager || !me.crudManager.resourceStore) {
                      me.resourceStore = new _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_21__["default"]();
                    }
                  }

                  return me._resourceStore;
                },
                set: function set(newResourceStore) {
                  var me = this,
                      oldResourceStore = me._resourceStore;

                  if (newResourceStore === oldResourceStore) {
                    return;
                  }

                  if (!(newResourceStore instanceof _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_21__["default"])) {
                    newResourceStore = new _data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_21__["default"](newResourceStore);
                  }

                  if (oldResourceStore) {
                    var isBackingRowStore = oldResourceStore === me.store;
                    me._resourceStore = newResourceStore; // Reconfigure grid if resourceStore is backing the rows

                    if (newResourceStore && me.isHorizontal) {
                      if (isBackingRowStore) {
                        me.store = me.resourceStore;
                        me.store.metaMapId = me.id;
                      } else {
                        me.refresh();
                      }
                    }
                  } else {
                    me._resourceStore = newResourceStore;
                  }

                  if (newResourceStore) {
                    // In vertical, resource store is not the row store but should toggle the load mask
                    if (me.isVertical) {
                      newResourceStore.on('load', function () {
                        return me.unmaskBody();
                      });
                    }

                    me.trigger('resourceStoreChange', {
                      newResourceStore: newResourceStore,
                      oldResourceStore: oldResourceStore
                    });
                  }

                  if (me.isHorizontal && !me._store) {
                    me.store = newResourceStore;
                  }
                } //endregion
                //region EventStore

                /**
                 * Get/set events, applies to the assigned EventStore
                 * @property {Scheduler.model.EventModel[]|Object[]}
                 * @category Data
                 */

              }, {
                key: "events",
                get: function get() {
                  return this._eventStore.records;
                },
                set: function set(events) {
                  this.eventStore.data = events;
                }
                /**
                 * Get/set the event store instance
                 * @property {Scheduler.data.EventStore}
                 * @category Data
                 */

              }, {
                key: "eventStore",
                get: function get() {
                  var me = this; // If there's a CrudManager, we use its eventStore.
                  // If not, we create our own instance.

                  if (!me._eventStore) {
                    if (!me.crudManager || !me.crudManager.eventStore) {
                      me.eventStore = new _data_EventStore_js__WEBPACK_IMPORTED_MODULE_20__["default"]({
                        resourceStore: me.resourceStore
                      });
                    }
                  }

                  return this._eventStore;
                },
                set: function set(newEventStore) {
                  var me = this,
                      oldEventStore = me._eventStore;
                  var triggerLoad = false;

                  if (newEventStore === oldEventStore) {
                    return;
                  }

                  var resourceStore = me.resourceStore; // Reconfiguring

                  if (oldEventStore) {
                    var _oldEventStore = me.eventStore,
                        assignmentStore = me.assignmentStore,
                        dependencyStore = me.dependencyStore;

                    if (newEventStore === _oldEventStore) {
                      return;
                    }

                    me.eventStoreDetacher && me.eventStoreDetacher();
                    me._eventStore = newEventStore;
                    me.timeAxisViewModel.eventStore = newEventStore;

                    if (newEventStore) {
                      if (resourceStore && !newEventStore.resourceStore) {
                        newEventStore.resourceStore = resourceStore;
                      }

                      if (assignmentStore && !newEventStore.assignmentStore) {
                        newEventStore.assignmentStore = assignmentStore;
                      }

                      if (dependencyStore && !newEventStore.dependencyStore) {
                        newEventStore.dependencyStore = dependencyStore;
                      }

                      me.trigger('eventStoreChange', {
                        newEventStore: newEventStore,
                        oldEventStore: _oldEventStore
                      });
                      me.refresh();
                    }
                  } else {
                    if (newEventStore.isEventStore) {
                      if (resourceStore && newEventStore.resourceStore !== resourceStore) {
                        // Sanity check.
                        // An eventStore cannot be shared between two Schedulers with different
                        // resourceStores. Prevent this Scheduler being handed an eventStore that
                        // is already attached to another resourceStore
                        if (newEventStore.resourceStore) {
                          throw new Error("eventStore ".concat(newEventStore.id, " is already linked to resourceStore ").concat(newEventStore.resourceStore.id));
                        }

                        newEventStore.resourceStore = resourceStore;
                      }
                    } else {
                      triggerLoad = newEventStore.autoLoad;
                      newEventStore.autoLoad = false;
                      newEventStore = new _data_EventStore_js__WEBPACK_IMPORTED_MODULE_20__["default"](Object.assign({
                        resourceStore: me.resourceStore
                      }, newEventStore));
                    }

                    me._eventStore = newEventStore;
                  }

                  if (newEventStore) {
                    var listenerCfg = {
                      thisObj: me,
                      detachable: true,
                      // There is no separate dataset event any more.
                      // It's a refresh event with action: 'dataset'
                      change: 'onInternalEventStoreChange',
                      clearchanges: 'onEventClearChanges',
                      beforecommit: 'onEventBeforeCommit',
                      commit: 'onEventCommit',
                      beforeRemove: 'onBeforeEventRemove',
                      refresh: 'onEventStoreRefresh',
                      exception: 'onEventException',
                      idchange: 'onEventIdChange' // TODO: PORT saving tree for later
                      // If the eventStore is a TreeStore
                      //nodeinsert : me.onEventAdd,
                      //nodeappend : me.onEventAdd

                    };

                    if (me.passStartEndParameters) {
                      listenerCfg.beforeload = me.applyStartEndParameters;
                    }

                    me.eventStoreDetacher && me.eventStoreDetacher(); // TODO: PORT don't have autoDestroy yet

                    /*if (me.eventStore) {
                     if (eventStore !== me.eventStore && me.eventStore.autoDestroy) {
                     me.eventStore.destroy();
                     }
                     }*/

                    me.eventStoreDetacher = newEventStore.on(listenerCfg);

                    if (newEventStore.assignmentStore) {
                      me.assignmentStore = newEventStore.assignmentStore;
                    }

                    if (triggerLoad) {
                      newEventStore.load().catch(function () {});
                    }
                  } // flag checked when adding events, to trigger full render first time


                  if (me.eventStore.count > 0) {
                    me.eventsRendered = true;
                  }
                } //endregion
                //region AssignmentStore

                /**
                 * Get/set assignments, applies to the assigned AssignmentStore
                 * @property {Scheduler.model.AssignmentModel[]|Object[]}
                 * @category Data
                 */

              }, {
                key: "assignments",
                get: function get() {
                  return this.assignmentStore && this.assignmentStore.records;
                },
                set: function set(assignments) {
                  // Creating AssignmentStore here and not in `get assignmentStore` since it is optional, but if user assigns
                  // assignments we can be sure one is needed.
                  if (!this.assignmentStore) {
                    this.eventStore.assignmentStore = this.assignmentStore = new _data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_22__["default"]();
                  }

                  this.assignmentStore.data = assignments;
                }
                /**
                 * Get/set the assignment store instance
                 * @property {Scheduler.data.AssignmentStore}
                 * @category Data
                 */

              }, {
                key: "assignmentStore",
                get: function get() {
                  var me = this,
                      eventStore = me.eventStore;
                  return eventStore && eventStore.assignmentStore;
                },
                set: function set(newAssignmentStore) {
                  var me = this,
                      oldAssignmentStore = me.assignmentStore;

                  if (me.eventStore.assignmentStore !== newAssignmentStore) {
                    me.eventStore.assignmentStore = newAssignmentStore;
                  }

                  me.assignmentStoreDetacher && me.assignmentStoreDetacher();

                  if (newAssignmentStore) {
                    // In case there is an assignment store used
                    me.assignmentStoreDetacher = newAssignmentStore.on({
                      thisObj: me,
                      //refresh    : me.onEventDataRefresh,
                      refresh: me.onAssignmentRefresh,
                      update: me.onAssignmentUpdate,
                      add: me.onAssignmentAdd,
                      beforeRemove: {
                        fn: me.onBeforeAssignmentRemove,
                        // We must go last in case an app vetoes a remove
                        // by returning false from a handler.
                        prio: -1000
                      },
                      remove: me.onAssignmentRemove,
                      filter: me.onAssignmentFilter,
                      removeall: me.onAssignmentRemoveAll
                    });
                    me.trigger('assignmentStoreChange', {
                      newAssignmentStore: newAssignmentStore,
                      oldAssignmentStore: oldAssignmentStore
                    });
                    me.refresh();
                  }
                } //endregion
                //region DependencyStore

                /**
                 * Get/set the dependency store instance
                 * @property {Scheduler.data.DependencyStore}
                 * @category Data
                 */

              }, {
                key: "dependencyStore",
                get: function get() {
                  var me = this,
                      eventStore = me.eventStore;
                  return eventStore && eventStore.dependencyStore || me._dependencyStore;
                },
                set: function set(newDependencyStore) {
                  var me = this;

                  if (!me.isConfigured) {
                    me._dependencyStore = newDependencyStore;
                  } else {
                    var oldDependencyStore = me.dependencyStore;
                    me.eventStore.dependencyStore = newDependencyStore;

                    if (newDependencyStore) {
                      me.trigger('dependencyStoreChange', {
                        newDependencyStore: newDependencyStore,
                        oldDependencyStore: oldDependencyStore
                      });
                      me.refresh();
                    }
                  }
                } //endregion
                //region CrudManager

                /**
                 * Get/set the CrudManager instance
                 * @property {Scheduler.data.CrudManager}
                 * @category Data
                 */

              }, {
                key: "crudManager",
                get: function get() {
                  return this._crudManager;
                },
                set: function set(crudManager) {
                  var me = this;

                  if (!(crudManager instanceof _data_CrudManager_js__WEBPACK_IMPORTED_MODULE_19__["default"])) {
                    // CrudManager injects itself into is Scheduler's _crudManager property
                    // because code it triggers needs to access it through its getter.
                    crudManager = new _data_CrudManager_js__WEBPACK_IMPORTED_MODULE_19__["default"](Object.assign({
                      scheduler: me
                    }, crudManager));
                  } else {
                    me._crudManager = crudManager;
                  }
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                //region Default config
                get: function get() {
                  return {
                    /**
                     * The {@link Scheduler.data.EventStore} holding the events to be rendered into the scheduler (required)
                     * @config {Scheduler.data.EventStore}
                     * @category Data
                     */
                    eventStore: null,

                    /**
                     * The {@link Scheduler.data.ResourceStore} holding the resources to be rendered into the scheduler (required)
                     * @config {Scheduler.data.ResourceStore}
                     * @category Data
                     */
                    resourceStore: null,

                    /**
                     * The optional {@link Scheduler.data.AssignmentStore}, holding assigments between resources and events.
                     * Required for multi assignments.
                     * @config {Scheduler.data.AssignmentStore}
                     * @category Data
                     */
                    assignmentStore: null,
                    dependencyStore: null,

                    /**
                     * Overridden to *not* auto create a store at the Scheduler level.
                     * The store is the {@link #config-resourceStore} which is either configured in
                     * or acquired from the {@link #config-crudManager}.
                     * @config {Common.data.Store}
                     * @private
                     */
                    store: null,

                    /**
                     * The name of the start date parameter that will be passed to in every `eventStore` load request.
                     * @config {String}
                     * @category Data
                     */
                    startParamName: 'startDate',

                    /**
                     * The name of the end date parameter that will be passed to in every `eventStore` load request.
                     * @config {String}
                     * @category Data
                     */
                    endParamName: 'endDate',

                    /**
                     * true to apply start and end dates of the current view to any `eventStore` load requests.
                     * @config {Boolean}
                     * @category Data
                     */
                    passStartEndParameters: false,

                    /**
                     * Supply a CrudManager config object if you want to use CrudManager for handling data
                     * @config {Object}
                     * @category Data
                     */
                    crudManager: null,

                    /**
                     * Inline events, will be loaded into an internally created EventStore
                     * @config {Scheduler.model.EventModel[]|Object[]}
                     * @category Data
                     */
                    events: null,

                    /**
                     * Inline resources, will be loaded into an internally created ResourceStore
                     * @config {Scheduler.model.ResourceModel[]|Object[]}
                     * @category Data
                     */
                    resources: null,

                    /**
                     * Inline assignments, will be loaded into an internally created AssignmentStore
                     * @config {Scheduler.model.AssignmentModel[]|Object[]}
                     * @category Data
                     */
                    assignments: null,

                    /**
                     * Configure with `true` to also remove the event when removing the last assignment
                     * @config {Boolean}
                     * @default
                     * @category Misc
                     */
                    removeUnassignedEvent: true
                  };
                }
              }]);

              return SchedulerStores;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_16__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/TimelineDateMapper.js":
      /*!********************************************************!*\
        !*** ./lib/Scheduler/view/mixin/TimelineDateMapper.js ***!
        \********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinTimelineDateMapperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.regexp.replace */
        "./node_modules/core-js/modules/es6.regexp.replace.js");
        /* harmony import */


        var core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_regexp_replace__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler'; // Used to avoid having to create huge amounts of Date objects

        var tempDate = new Date();
        /**
         * @module Scheduler/view/mixin/TimelineDateMapper
         */

        /**
         * Mixin that contains functionality to convert between coordinates and dates etc.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(TimelineDateMapper, _ref);

              function TimelineDateMapper() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, TimelineDateMapper);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimelineDateMapper).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(TimelineDateMapper, [{
                key: "getDateFromCoordinate",
                //region Coordinate <-> Date

                /**
                 * Gets the date for an X or Y coordinate, either local to the view element or the page based on the 3rd argument.
                 * @param {Number} coordinate The X or Y coordinate
                 * @param {String} [roundingMethod] The rounding method to use
                 * @param {Boolean} [local], true if the coordinate is local to the scheduler view element
                 * @returns {Date} the Date corresponding to the xy coordinate
                 * @category Dates
                 */
                value: function getDateFromCoordinate(coordinate, roundingMethod) {
                  var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                  if (!local) {
                    coordinate = this.currentOrientation.translateToScheduleCoordinate(coordinate);
                  }

                  return this.timeAxisViewModel.getDateFromPosition(coordinate, roundingMethod);
                }
                /**
                 * Gets the date for the passed X coordinate.
                 * If the coordinate is not in the currently rendered view, -1 will be returned.
                 * @param {Number} x The X coordinate
                 * @param {String} roundingMethod The rounding method to use
                 * @returns {Date} the Date corresponding to the x coordinate
                 * @param {Boolean} [local] true if the coordinate is local to the scheduler element
                 * @category Dates
                 */

              }, {
                key: "getDateFromX",
                value: function getDateFromX(x, roundingMethod) {
                  var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                  return this.getDateFromCoordinate(x, roundingMethod, local);
                }
                /**
                 * Gets the date for an XY coordinate
                 * @param {Array} xy The page X and Y coordinates
                 * @param {String} [roundingMethod] Optional, 'floor' to floor the value or 'round' to round the value to nearest increment
                 * @param {Boolean} [local] true if the coordinate is local to the scheduler element
                 * @returns {Date} the Date corresponding to the xy coordinate
                 * @category Dates
                 */

              }, {
                key: "getDateFromXY",
                value: function getDateFromXY(xy, roundingMethod) {
                  var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                  return this.currentOrientation.getDateFromXY(xy, roundingMethod, local);
                } //endregion
                //region Date display

                /**
                 * Get/set format to use when displaying dates. Usually set by specifying a view preset
                 * @property {String}
                 * @category Dates
                 */

              }, {
                key: "getFormattedDate",

                /**
                 * Method to get a formatted display date
                 * @private
                 * @param {Date} date The date
                 * @return {String} The formatted date
                 */
                value: function getFormattedDate(date) {
                  return _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].format(date, this.displayDateFormat);
                }
                /**
                 * Method to get a displayed end date value, see {@link #function-getFormattedEndDate} for more info.
                 * @private
                 * @param {Date} endDate The date to format
                 * @param {Date} startDate The start date
                 * @return {Date} The date value to display
                 */

              }, {
                key: "getDisplayEndDate",
                value: function getDisplayEndDate(endDate, startDate) {
                  var format = this.displayDateFormat,
                      stripEscapeRe = /(\\.)/g,
                      hourInfoRe = /([gGhHisucUOPZ]|MS)/; // TODO: PORT!

                  if ( // If time is midnight,
                  endDate.getHours() === 0 && endDate.getMinutes() === 0 && ( // and end date is greater then start date
                  !startDate || !(endDate.getYear() === startDate.getYear() && endDate.getMonth() === startDate.getMonth() && endDate.getDate() === startDate.getDate())) && // and UI display format doesn't contain hour info (in this case we'll just display the exact date)
                  !hourInfoRe.test(format.replace(stripEscapeRe, ''))) {
                    // format the date inclusively as 'the whole previous day'.
                    endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].add(endDate, -1, 'day');
                  }

                  return endDate;
                }
                /**
                 * Method to get a formatted end date for a scheduled event, the grid uses the "displayDateFormat" property defined in the current view preset.
                 * End dates are formatted as 'inclusive', meaning when an end date falls on midnight and the date format doesn't involve any hour/minute information,
                 * 1ms will be subtracted (e.g. 2010-01-08T00:00:00 will first be modified to 2010-01-07 before being formatted).
                 * @private
                 * @param {Date} endDate The date to format
                 * @param {Date} startDate The start date
                 * @return {String} The formatted date
                 */

              }, {
                key: "getFormattedEndDate",
                value: function getFormattedEndDate(endDate, startDate) {
                  return this.getFormattedDate(this.getDisplayEndDate(endDate, startDate));
                } //endregion
                //region Other date functions

                /**
                 * Gets the x or y coordinate relative to the scheduler element, or page coordinate (based on the 'local' flag)
                 * If the coordinate is not in the currently rendered view, -1 will be returned.
                 * @param {Date|Number} date the date to query for (or a date as ms)
                 * @param {Boolean|Object} options true to return a coordinate local to the scheduler view element (defaults to true),
                 * also accepts a config object like { local : true }.
                 * @returns {Number} the x or y position representing the date on the time axis
                 * @category Dates
                 */

              }, {
                key: "getCoordinateFromDate",
                value: function getCoordinateFromDate(date) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  var me = this,
                      timeAxisViewModel = me.timeAxisViewModel,
                      _me$timeAxis = me.timeAxis,
                      isContinuous = _me$timeAxis.isContinuous,
                      startMS = _me$timeAxis.startMS,
                      endMS = _me$timeAxis.endMS,
                      startDate = _me$timeAxis.startDate,
                      unit = _me$timeAxis.unit,
                      dateMS = date.valueOf(); // Avoiding to break the API while allowing passing options through to getPositionFromDate()

                  if (options === true) {
                    options = {
                      local: true
                    };
                  } else if (!options) {
                    options = {
                      local: false
                    };
                  } else if (!('local' in options)) {
                    options.local = true;
                  }

                  var pos; // TODO for 2.0 try to normalize and just use dates as input for this method,
                  // then this if-statement would not be needed

                  if (!(date instanceof Date)) {
                    tempDate.setTime(date);
                    date = tempDate;
                  } // Shortcut for continuous time axis that is using a unit that can be reliably translated to days (or smaller)


                  if (isContinuous && date.getTimezoneOffset() === startDate.getTimezoneOffset() && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_7__["default"].getUnitToBaseUnitRatio(unit, 'day') !== -1) {
                    if (dateMS < startMS || dateMS > endMS) {
                      return -1;
                    }

                    pos = Math.round((dateMS - startMS) / (endMS - startMS) * timeAxisViewModel.totalSize);
                  } // Non-continuous or using for example months (vary in length)
                  else {
                      pos = timeAxisViewModel.getPositionFromDate(date, options);
                    }

                  if (!options.local) {
                    pos = me.currentOrientation.translateToPageCoordinate(pos);
                  }

                  return pos;
                }
                /**
                 * Gets the time for a DOM event such as 'mousemove' or 'click'
                 * @param {Event} e the Event instance
                 * @param {String} [roundingMethod] Optional, 'floor' to floor the value or 'round' to round the value to nearest increment
                 * @param {Boolean} [local], true if the event is local to the scheduler element
                 * @returns {Date} The date corresponding to the EventObject x coordinate
                 * @category Dates
                 */

              }, {
                key: "getDateFromDomEvent",
                value: function getDateFromDomEvent(e, roundingMethod) {
                  var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                  var x = local ? e.offsetX : e.x,
                      y = local ? e.offsetY : e.y;
                  return this.getDateFromXY([x, y], roundingMethod, local);
                }
                /**
                 * Returns the distance in pixels for the time span in the view.
                 * @param {Date} startDate The start date of the span
                 * @param {Date} endDate The end date of the span
                 * @return {Number} The distance in pixels
                 * @category Dates
                 */

              }, {
                key: "getTimeSpanDistance",
                value: function getTimeSpanDistance(startDate, endDate) {
                  return this.timeAxisViewModel.getDistanceBetweenDates(startDate, endDate);
                }
                /**
                 * Returns the center date of the currently visible timespan of scheduler.
                 *
                 * @return {Date} date Center date for the viewport.
                 * @readonly
                 * @category Dates
                 */

              }, {
                key: "onSchedulerHorizontalScroll",
                //endregion
                value: function onSchedulerHorizontalScroll(_ref2) {
                  var subGrid = _ref2.subGrid,
                      scrollLeft = _ref2.scrollLeft; // Invalidate cached center date unless we are scrolling to center on it.

                  if (!this.scrollingToCenter) {
                    this.cachedCenterDate = null;
                  }
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "displayDateFormat",
                get: function get() {
                  return this._displayDateFormat;
                },
                set: function set(format) {
                  this._displayDateFormat = format; // Start/EndDateColumn listens for this to change their format to match

                  this.trigger('displayDateFormatChange', {
                    format: format
                  });
                }
              }, {
                key: "viewportCenterDate",
                get: function get() {
                  var me = this,
                      timeAxis = me.timeAxis,
                      subGrid = me.timeAxisSubGrid,
                      scroller = subGrid.scrollable,
                      centerX = scroller.x + subGrid.width / 2,
                      centerY = scroller.y + subGrid.height / 2;

                  if (timeAxis.isContinuous) {
                    // Calculate center pixel in the viewport.
                    // Then Calculate how far through the axis range that is.
                    var scrollCenter = me.isHorizontal ? centerX / scroller.scrollWidth : centerY / scroller.scrollHeight,
                        centerMilli = timeAxis.startMS + (timeAxis.endMS - timeAxis.startMS) * scrollCenter;
                    return new Date(centerMilli);
                  } else {
                    var xy = me.isHorizontal ? [centerX, 0] : [0, centerY];
                    return me.getDateFromXY(xy, null, true);
                  }
                }
              }, {
                key: "viewportCenterDateCached",
                get: function get() {
                  return this.cachedCenterDate || (this.cachedCenterDate = this.viewportCenterDate);
                } //endregion
                //region TimeAxis getters/setters

                /**
                 * Gets/sets the current time resolution object, which contains a unit identifier and an increment count { unit, increment}
                 * @property {Object}
                 * @category Dates
                 */

              }, {
                key: "timeResolution",
                get: function get() {
                  return this.timeAxis.resolution;
                },
                set: function set(increment) {
                  this.timeAxis.resolution = {
                    increment: increment,
                    unit: this.timeAxis.resolution.unit
                  };
                } //endregion
                //region Snap

                /**
                 * Controls whether the scheduler should snap to the resolution when interacting with it
                 * @property {Boolean}
                 * @category Dates
                 */

              }, {
                key: "snap",
                set: function set(enabled) {
                  // timeAxisViewModel is not created yet during configuration
                  if (!this.isConfiguring) {
                    this.timeAxisViewModel.snap = enabled;
                  } else {
                    this._snap = enabled;
                  }
                },
                get: function get() {
                  // timeAxisViewModel is not created yet during configuration
                  if (this.isConfiguring) {
                    return this._snap;
                  }

                  return this.timeAxisViewModel.snap;
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return TimelineDateMapper;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_6__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/TimelineDomEvents.js":
      /*!*******************************************************!*\
        !*** ./lib/Scheduler/view/mixin/TimelineDomEvents.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinTimelineDomEventsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/TimelineDomEvents
         */

        var eventNameMap = {
          mousedown: 'MouseDown',
          mouseup: 'MouseUp',
          click: 'Click',
          dblclick: 'DblClick',
          contextmenu: 'ContextMenu',
          mouseover: 'MouseOver',
          mouseout: 'MouseOut'
        };
        /**
         * Mixin that handles dom events (click etc) for scheduler and rendered events.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TimelineDomEvents, _ref);

              function TimelineDomEvents() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, TimelineDomEvents);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimelineDomEvents).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(TimelineDomEvents, [{
                key: "initDomEvents",
                //endregion
                //region Init

                /**
                 * Adds listeners for DOM events for the scheduler and its events.
                 * Which events is specified in Scheduler#scheduledBarEvents and Scheduler#schedulerEvents.
                 * @private
                 */
                value: function initDomEvents() {
                  var me = this; // Set thisObj and element of the configured listener specs.

                  me.scheduledBarEvents.element = me.schedulerEvents.element = me.timeAxisSubGridElement;
                  me.scheduledBarEvents.thisObj = me.schedulerEvents.thisObj = me; // same listener used for different events

                  _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on(me.scheduledBarEvents);

                  _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"].on(me.schedulerEvents);
                } //endregion
                //region Event handling

              }, {
                key: "getTimeSpanMouseEventParams",
                value: function getTimeSpanMouseEventParams(eventElement, event) {
                  throw new Error('Implement in subclass');
                }
              }, {
                key: "getScheduleMouseEventParams",
                value: function getScheduleMouseEventParams(cellData, event) {
                  throw new Error('Implement in subclass');
                }
                /**
                 * Wraps dom Events for rendered scheduler EventModels and fires prefixed as our events.
                 * For example click -> eventclick
                 * @private
                 * @param event
                 */

              }, {
                key: "handleScheduledBarEvent",
                value: function handleScheduledBarEvent(event) {
                  var me = this,
                      eventElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].up(event.target, me.eventSelector),
                      eventName = eventNameMap[event.type] || _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].capitalizeFirstLetter(event.type);

                  if (eventElement) {
                    me.trigger(me.scheduledEventName + eventName, me.getTimeSpanMouseEventParams(eventElement, event));
                  }
                }
                /**
                 * Wraps dom Events for the scheduler and fires as our events.
                 * For example click -> scheduleClick
                 * @private
                 * @param event
                 */

              }, {
                key: "handleScheduleEvent",
                value: function handleScheduleEvent(event) {
                  var me = this,
                      eventElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].up(event.target, me.eventSelector),
                      cellElement = !eventElement && _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].up(event.target, '.' + me.timeCellCls),
                      eventName = eventNameMap[event.type] || _Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"].capitalizeFirstLetter(event.type);

                  if (cellElement) {
                    var clickedDate = me.getDateFromDomEvent(event, 'floor'),
                        cellData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_11__["default"].get(cellElement),
                        index = cellData.row.dataIndex; // TODO: PORT vertical later
                    // } else {
                    //     const cellNode = event.getTarget(me.timeCellSelector, 5);
                    //
                    //     if (cellNode) {
                    //         const cellIndex = typeof cellNode.cellIndex == 'number' ? cellNode.cellIndex : cellNode.getAttribute('data-cellIndex'),
                    //               header    = me.headerCt.getGridColumns()[cellIndex];
                    //
                    //         resource = header && header.model;
                    //     }
                    // }
                    // TODO: PORT pinch event
                    //if (event.type.indexOf('pinch') >= 0) {
                    //    me.fireEvent('schedule' + event.type, me, event);
                    //} else {


                    me.trigger('schedule' + eventName, Object.assign({
                      date: clickedDate,
                      row: cellData.row,
                      index: index,
                      event: event
                    }, me.getScheduleMouseEventParams(cellData, event))); //}
                  }
                }
                /**
                 * Relays mouseover events as eventmouseenter if over rendered event.
                 * Also adds Scheduler#overScheduledEventClass to the hovered element.
                 * @private
                 */

              }, {
                key: "onElementMouseOver",
                value: function onElementMouseOver(event) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimelineDomEvents.prototype), "onElementMouseOver", this).call(this, event);

                  var me = this,
                      target = event.target; // We must be over the event bar

                  if (target.closest(me.eventInnerSelector)) {
                    var eventElement = target.closest(me.eventSelector);
                    eventElement.classList.add(me.overScheduledEventClass);

                    if (eventElement !== me.hoveredEventNode && !me.preventOverCls) {
                      me.hoveredEventNode = eventElement;
                      var params = me.getTimeSpanMouseEventParams(eventElement, event);

                      if (params) {
                        // do not fire this event if model cannot be found
                        // this can be the case for "b-sch-dragcreator-proxy" elements for example
                        me.trigger(me.scheduledEventName + 'MouseEnter', params);
                      }
                    }
                  } else {
                    me.hoveredEventNode = null;
                  }
                }
                /**
                 * Relays mouseout events as eventmouseleave if out from rendered event.
                 * Also removes Scheduler#overScheduledEventClass from the hovered element.
                 * @private
                 */

              }, {
                key: "onElementMouseOut",
                value: function onElementMouseOut(event) {
                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TimelineDomEvents.prototype), "onElementMouseOut", this).call(this, event);

                  var me = this; // We must be over the event bar

                  if (event.target.closest(me.eventInnerSelector) && me.resolveTimeSpanRecord(event.target) && me.hoveredEventNode) {
                    // out to child shouldn't count...
                    if (event.relatedTarget && _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].isDescendant(event.target.closest(me.eventInnerSelector), event.relatedTarget)) return;
                    me.unhover(event);
                  }
                }
              }, {
                key: "unhover",
                value: function unhover(event) {
                  var me = this,
                      eventElement = me.hoveredEventNode;

                  if (eventElement) {
                    eventElement.classList.remove(me.overScheduledEventClass);
                    me.trigger(me.scheduledEventName + 'MouseLeave', me.getTimeSpanMouseEventParams(eventElement, event));
                    me.hoveredEventNode = null;
                  }
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                //region Default config
                get: function get() {
                  return {
                    // TODO: PORT longpress missing
                    scheduledBarEvents: {
                      mousedown: 'handleScheduledBarEvent',
                      mouseup: 'handleScheduledBarEvent',
                      click: 'handleScheduledBarEvent',
                      dblclick: 'handleScheduledBarEvent',
                      contextmenu: 'handleScheduledBarEvent',
                      mouseover: 'handleScheduledBarEvent',
                      mouseout: 'handleScheduledBarEvent'
                    },
                    // TODO: PORT pinch, pinchstart, pinchend missing
                    schedulerEvents: {
                      click: 'handleScheduleEvent',
                      dblclick: 'handleScheduleEvent',
                      contextmenu: 'handleScheduleEvent'
                    }
                  };
                }
              }]);

              return TimelineDomEvents;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_7__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/TimelineEventRendering.js":
      /*!************************************************************!*\
        !*** ./lib/Scheduler/view/mixin/TimelineEventRendering.js ***!
        \************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinTimelineEventRenderingJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/TimelineEventRendering
         */

        /**
         * Functions to handle event rendering (EventModel -> dom elements).
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(TimelineEventRendering, _ref);

              function TimelineEventRendering() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TimelineEventRendering);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(TimelineEventRendering).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TimelineEventRendering, [{
                key: "barMargin",
                //endregion
                //region Settings

                /**
                 * Control how much space to leave between stacked event bars in px. Value will be constrained by half the row height.
                 * @property {Number}
                 * @category Scheduled events
                 */
                get: function get() {
                  return this._barMargin;
                },
                set: function set(margin) {
                  var me = this;

                  _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assertNumber(margin, 'barMargin'); // bar margin should not exceed half of the row height


                  if (me.isHorizontal && me.rowHeight) {
                    margin = Math.min(Math.ceil(me.rowHeight / 2), margin);
                  }

                  if (me._barMargin !== margin) {
                    me._barMargin = margin;

                    if (me.rendered) {
                      me.currentOrientation.onBeforeRowHeightChange();
                      me.refreshWithTransition();
                    }
                  }
                } // Documented in SchedulerEventRendering to not show up in Gantt docs

              }, {
                key: "resourceMargin",
                get: function get() {
                  return this._resourceMargin == null ? this.barMargin : this._resourceMargin;
                },
                set: function set(margin) {
                  var me = this;

                  _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assertNumber(margin, 'resourceMargin'); // bar margin should not exceed half of the row height


                  if (me.isHorizontal && me.rowHeight) {
                    margin = Math.min(Math.ceil(me.rowHeight / 2), margin);
                  }

                  if (me._resourceMargin !== margin) {
                    me._resourceMargin = margin;

                    if (me.rendered) {
                      me.currentOrientation.onBeforeRowHeightChange();
                      me.refreshWithTransition();
                    }
                  }
                } // /**
                //  * Distance between bars when using eventLayout pack
                //  * @property {Number}
                //  */
                // get barPackMargin() {
                //     return this._barPackMargin;
                // }
                //
                // set barPackMargin(margin) {
                //     if (this._barPackMargin !== margin) {
                //         this._barPackMargin = margin;
                //         this.refresh();
                //     }
                // }

                /**
                 * Get/set the widths of all the time columns to the supplied value. Only applicable when {@link Scheduler.view.TimelineBase#config-forceFit} is set to false.
                 * Deprecated in favor of {@link #property-tickSize}
                 * @property {Number}
                 * @deprecated 2.2
                 * @category Scheduled events
                 */

              }, {
                key: "tickWidth",
                set: function set(width) {
                  this.tickSize = width;
                },
                get: function get() {
                  return this.tickSize;
                }
                /**
                 * Get/set the width/height (depending on mode) of all the time columns to the supplied value. Only applicable when
                 * {@link Scheduler.view.TimelineBase#config-forceFit} is set to false.
                 * @property {Number}
                 * @category Scheduled events
                 */

              }, {
                key: "tickSize",
                set: function set(width) {
                  _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_6__["default"].assertNumber(width, 'tickSize');

                  this.timeAxisViewModel.tickSize = width;
                },
                get: function get() {
                  return this.timeAxisViewModel.tickSize;
                }
                /**
                 * Predefined event colors, useful in combos etc.
                 * @type {String}
                 * @category Scheduled events
                 */

              }, {
                key: "widgetClass",
                //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.
                get: function get() {}
              }], [{
                key: "defaultConfig",
                //region Default config
                get: function get() {
                  return {
                    /**
                     * Controls how much space to leave between stacked event bars in px
                     * @config {Number}
                     * @default
                     * @category Scheduled events
                     */
                    barMargin: 10,
                    resourceMargin: null,

                    /**
                     * True to size events based on the rowHeight and barMargin settings. Set this to false if you want to
                     * control height and top properties via CSS instead.
                     * @config {Boolean}
                     * @default
                     * @category Scheduled events
                     */
                    managedEventSizing: true,

                    /**
                     * The CSS class added to an event/assignment when it is newly created
                     * in the UI and unsynced with the server.
                     * @config {String}
                     * @default
                     * @private
                     * @category CSS
                     */
                    generatedIdCls: 'b-sch-dirty-new',

                    /**
                     * The CSS class added to an event when it has unsaved modifications
                     * @config {String}
                     * @default
                     * @private
                     * @category CSS
                     */
                    dirtyCls: 'b-sch-dirty',

                    /**
                     * The CSS class added to an event when it is currently committing changes
                     * @config {String}
                     * @default
                     * @private
                     * @category CSS
                     */
                    committingCls: 'b-sch-committing',

                    /**
                     * The CSS class added to an event/assignment when it ends outside of the visible time range.
                     * @config {String}
                     * @default
                     * @private
                     * @category CSS
                     */
                    endsOutsideViewCls: 'b-sch-event-endsoutside',

                    /**
                     * The CSS class added to an event/assignment when it starts outside of the visible time range.
                     * @config {String}
                     * @default
                     * @private
                     * @category CSS
                     */
                    startsOutsideViewCls: 'b-sch-event-startsoutside',

                    /**
                     * The CSS class added to an event/assignment when it is not draggable.
                     * @config {String}
                     * @default
                     * @private
                     * @category CSS
                     */
                    fixedEventCls: 'b-sch-event-fixed',

                    /**
                     * Event style used by default. Events and resources can specify their own style, with priority order being:
                     * Event -> Resource -> Scheduler default. Determines the appearance of the event by assigning a CSS class
                     * to it. Available styles are:
                     * * plain (default), flat look
                     * * border, has border in darker shade of events color
                     * * colored, has colored text and wide left border in same color
                     * * hollow, only border + text until hovered
                     * * line, as a line with the text below it
                     * * dashed, as a dashed line with the text below it
                     * * minimal, as a thin line with small text above it
                     * @config {String}
                     * @default
                     * @category Scheduled events
                     */
                    eventStyle: 'plain',

                    /**
                     * Event color used by default. Events and resources can specify their own color, with priority order being:
                     * Event -> Resource -> Scheduler default. Available colors are:
                     * * red
                     * * pink
                     * * purple
                     * * violet
                     * * indigo
                     * * blue
                     * * cyan
                     * * teal
                     * * green
                     * * lime
                     * * yellow
                     * * orange
                     * * gray
                     * @config {String}
                     * @default
                     * @category Scheduled events
                     */
                    eventColor: 'green'
                  };
                }
              }, {
                key: "eventColors",
                get: function get() {
                  return ['red', 'pink', 'purple', 'violet', 'indigo', 'blue', 'cyan', 'teal', 'green', 'lime', 'yellow', 'orange', 'gray'];
                }
                /**
                 * Predefined event styles , useful in combos etc.
                 * @type {String}
                 * @category Scheduled events
                 */

              }, {
                key: "eventStyles",
                get: function get() {
                  return ['plain', 'border', 'hollow', 'colored', 'line', 'dashed', 'minimal'];
                }
              }]);

              return TimelineEventRendering;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/TimelineScroll.js":
      /*!****************************************************!*\
        !*** ./lib/Scheduler/view/mixin/TimelineScroll.js ***!
        \****************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinTimelineScrollJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/TimelineScroll
         */

        /**
         * Functions for scrolling to events, dates etc.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(TimelineScroll, _ref);

              function TimelineScroll() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TimelineScroll);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(TimelineScroll).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TimelineScroll, [{
                key: "scrollToDate",
                //region Scroll to date

                /**
                 * Scrolls the time line "tick" encapsulating the passed `Date` into view according to the passed options.
                 * @param {Date} date The date to which to scroll the time line
                 * @param {Object} [options] How to scroll.
                 * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
                 * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the tick to bring into view.
                 * @param {Boolean/Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
                 * @returns {Promise} A Promise which resolves when the scrolling is complete.
                 */
                value: function scrollToDate(date) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  var me = this,
                      scroller = me.timeAxisSubGrid.scrollable,
                      scrollerViewport = scroller.viewport,
                      localCoordinate = me.getCoordinateFromDate(date, true),
                      target = me.isHorizontal ? new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"](me.getCoordinateFromDate(date, false), scrollerViewport.y, me.timeAxisViewModel.tickSize, scrollerViewport.height) : new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_6__["default"](scrollerViewport.x, me.getCoordinateFromDate(date, false), scrollerViewport.width, me.timeAxisViewModel.tickSize);
                  return me.scrollToCoordinate(localCoordinate, target, date, options);
                }
                /**
                 * Scrolls to current time.
                 * @param {Object} [options] How to scroll.
                 * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
                 * @param {Number} [options.edgeOffset=20] edgeOffset A margin *in pixels* around the tick to bring into view.
                 * @param {Boolean/Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
                 * @returns {Promise} A Promise which resolves when the scrolling is complete.
                 */

              }, {
                key: "scrollToNow",
                value: function scrollToNow() {
                  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                  return this.scrollToDate(new Date(), options);
                }
                /**
                 * Used by {@link #function-scrollToDate} to scroll to correct coordinate.
                 * @param {Number} localCoordinate Coordinate to scroll to
                 * @param {Date} date Date to scroll to, used for reconfiguring the time axis
                 * @param {Object} [options] How to scroll.
                 * @param {String} [options.block=nearest] How far to scroll the tick: `start/end/center/nearest`.
                 * @param {Number} [options.edgeOffset] edgeOffset A margin *in pixels* around the tick to bring into view.
                 * @param {Boolean/Number} [options.animate] Set to `true` to animate the scroll, or the number of milliseconds to animate over.
                 * @returns {Promise} A Promise which resolves when the scrolling is complete.
                 * @private
                 */

              }, {
                key: "scrollToCoordinate",
                value: function scrollToCoordinate(localCoordinate, target, date) {
                  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                  var me = this; // Not currently have this date in a timeaxis. Ignore negative scroll in weekview, it can be just 'filtered' with
                  // startTime/endTime config

                  if (localCoordinate < 0) {
                    // adjust the timeaxis first
                    var halfVisibleSpan = (me.timeAxis.endDate - me.timeAxis.startDate) / 2,
                        newStartDate = new Date(date.getTime() - halfVisibleSpan),
                        newEndDate = new Date(date.getTime() + halfVisibleSpan); // We're trying to reconfigure time span to current dates, which means we are as close to center as it
                    // could be. Do nothing then.
                    // covered by 1102_panel_api

                    if (newStartDate - me.startDate !== 0 && newEndDate - me.endDate !== 0) {
                      me.setTimeSpan(newStartDate, newEndDate);
                      return me.scrollToDate(date, options);
                    }

                    return;
                  }

                  return me.timeAxisSubGrid.scrollable.scrollIntoView(target, options);
                } //endregion
                //region Relative scrolling
                // These methods are important to users because although they are mixed into the top level Grid/Scheduler,
                // for X scrolling the explicitly target the SubGrid that holds the scheduler.

                /**
                 * Get/set horizontal scroll. Applies to the SubGrid that holds the scheduler
                 * @property {Number}
                 * @category Scrolling
                 */

              }, {
                key: "scrollHorizontallyTo",

                /**
                 * Horizontal scrolling. Applies to the SubGrid that holds the scheduler
                 * @param {Number} x
                 * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
                 * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
                 * or the number of milliseconds to animate over, or an animation config object.
                 * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
                 * @param {String} [options.animate.easing] The name of an easing function.
                 * @returns {Promise} A promise which is resolved when the scrolling has finished.
                 */
                value: function scrollHorizontallyTo(coordinate) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  return this.timeAxisSubGrid.scrollable.scrollTo(coordinate, null, options);
                }
                /**
                 * Vertical scrolling
                 * @param {Number} y
                 * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
                 * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
                 * or the number of milliseconds to animate over, or an animation config object.
                 * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
                 * @param {String} [options.animate.easing] The name of an easing function.
                 * @returns {Promise} A promise which is resolved when the scrolling has finished.
                 */

              }, {
                key: "scrollVerticallyTo",
                value: function scrollVerticallyTo(y) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  return this.scrollable.scrollTo(null, y, options);
                }
                /**
                 * Scrolls the subgrid that contains the scheduler
                 * @param {Number} x
                 * @param {Object|Boolean} [options] How to scroll. May be passed as `true` to animate.
                 * @param {Object|Boolean|Number} [options.animate] Set to `true` to animate the scroll by 300ms,
                 * or the number of milliseconds to animate over, or an animation config object.
                 * @param {Number} [options.animate.duration] The number of milliseconds to animate over.
                 * @param {String} [options.animate.easing] The name of an easing function.
                 * @returns {Promise} A promise which is resolved when the scrolling has finished.
                 */

              }, {
                key: "scrollTo",
                value: function scrollTo(x) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                  return this.timeAxisSubGrid.scrollable.scrollTo(x, null, options);
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "scrollLeft",
                set: function set(left) {
                  this.timeAxisSubGrid.scrollable.x = left;
                }
                /**
                 * Get/set vertical scroll
                 * @property {Number}
                 * @category Scrolling
                 */
                ,
                get: function get() {
                  return this.timeAxisSubGrid.scrollable.x;
                }
              }, {
                key: "scrollTop",
                set: function set(top) {
                  this.scrollable.y = top;
                },
                get: function get() {
                  return this.scrollable.y;
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }]);

              return TimelineScroll;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/TimelineViewPresets.js":
      /*!*********************************************************!*\
        !*** ./lib/Scheduler/view/mixin/TimelineViewPresets.js ***!
        \*********************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinTimelineViewPresetsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../../preset/PresetManager.js */
        "./lib/Scheduler/preset/PresetManager.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/TimelineViewPresets
         */

        /**
         * View preset handling
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(TimelineViewPresets, _ref);

              function TimelineViewPresets() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TimelineViewPresets);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(TimelineViewPresets).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TimelineViewPresets, [{
                key: "setViewPreset",

                /**
                 * Sets the current view preset. See the {@link Scheduler.preset.PresetManager} class for details.
                 *
                 * @param {String|Object|Scheduler.preset.ViewPreset} preset The id of the new preset (see {@link Scheduler.preset.PresetManager} for details)
                 * @param {Date} [startDate] A new start date for the time axis
                 * @param {Date} [endDate] A new end date for the time axis
                 * @private
                 */
                value: function setViewPreset(preset, startDate, endDate, initial) {
                  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                  var me = this; // This is set if the object is inside the Base constructor's configure method.

                  initial = initial || me.isConfiguring;
                  var centerDate = options.centerDate,
                      timeAxis = me._timeAxis; // Do not tickle the getter, we are just peeking to see if it's there yet.
                  // normalize preset (applies preset customizations or gets a predefined preset)

                  preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_6__["default"].normalizePreset(preset);

                  if (initial || me.trigger('beforePresetChange', {
                    preset: preset,
                    startDate: startDate,
                    endDate: endDate
                  }) !== false) {
                    me._viewPreset = preset; // prefer to use displayDateFormat configured on the panel

                    me.displayDateFormat = me.config.displayDateFormat || preset.displayDateFormat;
                    var isHorizontal = me.isHorizontal;

                    if (timeAxis) {
                      // None of this reconfiguring should cause a refresh
                      me.suspendRefresh(); // Timeaxis may already be configured (in case of sharing with the timeline partner), no need to reconfigure it

                      if (!(initial && timeAxis.isConfigured)) {
                        var timeAxisCfg = {
                          weekStartDay: me.weekStartDay,
                          startTime: me.startTime,
                          endTime: me.endTime
                        };

                        if (initial) {
                          if (timeAxis.count === 0 || startDate) {
                            timeAxisCfg.startDate = startDate || new Date();
                            timeAxisCfg.endDate = endDate;
                          }
                        } else {
                          // if startDate is provided we use it and the provided endDate
                          if (startDate) {
                            timeAxisCfg.startDate = startDate;
                            timeAxisCfg.endDate = endDate; // if both dates are provided we can calculate centerDate for the viewport

                            if (!centerDate && endDate) {
                              // TODO: PORT infitieScroll stuff
                              // if (me.infiniteScroll && view.cachedScrollDate && view.cachedScrollDateIsCentered) {
                              //     centerDate = view.cachedScrollDate;
                              // } else {
                              centerDate = new Date((startDate.getTime() + endDate.getTime()) / 2); //}
                            } // when no start/end dates are provided we use the current timespan

                          } else {
                            timeAxisCfg.startDate = timeAxis.startDate;
                            timeAxisCfg.endDate = endDate || timeAxis.endDate;

                            if (!centerDate) {
                              // TODO: PORT inifiteScroll stuff
                              // if (me.infiniteScroll && view.cachedScrollDate && view.cachedScrollDateIsCentered) {
                              //     centerDate = view.cachedScrollDate;
                              // } else {
                              // TODO: PORT needed?
                              //centerDate = me.getViewportCenterDateCached();
                              centerDate = me.viewportCenterDate; //}
                            }
                          }
                        }

                        timeAxis.isConfigured = false;
                        timeAxis.viewPreset = preset;
                        timeAxis.reconfigure(timeAxisCfg, true);
                        me.timeAxisViewModel.reconfigure({
                          // update preset name in viewmodel to simplify zooming sync for partner panels
                          viewPreset: me.viewPreset,
                          headerConfig: preset.headerConfig,
                          columnLinesFor: preset.columnLinesFor || 'middle',
                          // TODO: PORT rowHeightHorizontal??
                          rowHeightHorizontal: me.readRowHeightFromPreset ? preset.rowHeight : me.rowHeight,
                          tickSize: isHorizontal ? preset.tickWidth : preset.tickHeight || preset.tickWidth || 60
                        }); // Allow refresh to run after the reconfiguring

                        me.resumeRefresh();
                      } // TODO: PORT vertical later
                      // if (isVertical) {
                      //     me.setColumnWidth(me.resourceColumnWidth || preset.resourceColumnWidth || 100, true);
                      // }


                      me.refresh(); // if view is rendered and scroll is not disabled by "notScroll" option

                      if (!options.notScroll && me.rendered) {
                        // and we have centerDate to scroll to
                        if (centerDate) {
                          // remember the central date we scroll to (it gets reset after user scroll)
                          me.cachedCenterDate = centerDate;
                          var x = null; // TODO: PORT vertical later
                          // if (isVertical) {
                          //     y = Math.max(Math.floor(view.getCoordinateFromDate(centerDate, true) - view.getViewContainerHeight() / 2), 0);
                          //     me.viewPresetActiveScroll = { top : y };
                          //     view.scrollVerticallyTo(y);
                          // } else {

                          x = Math.max(Math.floor(me.getCoordinateFromDate(centerDate, true) - me.timeAxisSubGrid.width / 2), 0);
                          me.viewPresetActiveScroll = {
                            left: x
                          }; // The horizontal scroll handler must not invalidate the cached center
                          // when this scroll event rolls round on the next frame.

                          me.scrollingToCenter = true;
                          me.scrollHorizontallyTo(x, false); // Release the lock on scrolling invalidating the cached center.

                          me.setTimeout(function () {
                            me.scrollingToCenter = false;
                          }, 100); //}
                          // if we don't have a central date to scroll at we reset scroll (this is bw compatible behavior)
                        } else {
                          // TODO: PORT vertical later
                          // if (isHorizontal) {
                          me.scrollHorizontallyTo(0, false); //} else {
                          //    view.scrollVerticallyTo(0);
                          //}
                        }
                      }

                      me.trigger('presetChange', {
                        preset: preset,
                        startDate: startDate,
                        endDate: endDate,
                        centerDate: centerDate
                      });
                    }
                  }
                } //endregion
                // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "viewPreset",
                //endregion
                //region Get/set

                /**
                 * Get/set the current view preset
                 * @property {Scheduler.preset.ViewPreset|String}
                 * @category Common
                */
                get: function get() {
                  return this._viewPreset;
                },
                set: function set(preset) {
                  if (this._viewPreset !== preset) {
                    this.setViewPreset(preset);
                  }
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                //region Default config
                get: function get() {
                  //if (!PresetManager.presets) PresetManager.registerDefaults();
                  return {
                    /**
                     * A string key used to lookup a predefined {@link Scheduler.preset.ViewPreset} (e.g. 'weekAndDay', 'hourAndDay'),
                     * managed by {@link Scheduler.preset.PresetManager}. See {@link Scheduler.preset.PresetManager} for more information.
                     * Or a config object for a viewPreset.
                     *
                     * Options:
                     * - 'secondAndMinute'
                     * - 'minuteAndHour'
                     * - 'hourAndDay'
                     * - 'dayAndWeek'
                     * - 'weekAndDay'
                     * - 'weekAndMonth',
                     * - 'monthAndYear'
                     * - 'year'
                     * - 'manyYears'
                     * - 'weekAndDayLetter'
                     * - 'weekDateAndMonth'
                     * - 'day'
                     * - 'week'
                     *
                     * If passed as a config object, the settings from the viewPreset with the provided 'name' property will be used along
                     * with any overridden values in your object.
                     *
                     * To override:
                     * ```javascript
                     * viewPreset       : {
                     *   name                : 'hourAndDay',
                     *   headerConfig        : {
                     *       middle          : {
                     *           unit       : "hour",
                     *           increment  : 12,
                     *           renderer   : (startDate, endDate, headerConfig, cellIdx) => {
                     *               return "";
                     *           }
                     *       }
                     *   }
                     * }
                     * ```
                     * or set a new valid preset config if the preset is not registered in the {@link Scheduler.preset.PresetManager}.
                     *
                     * When you use scheduler in weekview mode, this config is used to pick view preset. If passed view preset is not
                     * supported by weekview (only 2 supported by default - 'day' and 'week') default preset will be used - 'week'.
                     * @config {String|Object}
                     * @default
                     * @category Common
                     */
                    viewPreset: 'weekAndDayLetter',

                    /**
                     * Defines how dates will be formatted in tooltips etc. This config has priority over similar config on the
                     * view preset. For allowed values see {@link Common.helper.DateHelper##function-format-static}.
                     * @config {String}
                     * @category Scheduled events
                     */
                    displayDateFormat: null
                  };
                }
              }]);

              return TimelineViewPresets;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_5__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/mixin/TimelineZoomable.js":
      /*!******************************************************!*\
        !*** ./lib/Scheduler/view/mixin/TimelineZoomable.js ***!
        \******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewMixinTimelineZoomableJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! @babel/runtime/helpers/typeof */
        "./node_modules/@babel/runtime/helpers/typeof.js");
        /* harmony import */


        var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.number.constructor */
        "./node_modules/core-js/modules/es6.number.constructor.js");
        /* harmony import */


        var core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_number_constructor__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../preset/PresetManager.js */
        "./lib/Scheduler/preset/PresetManager.js");
        /* harmony import */


        var _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/mixin/TimelineZoomable
         */

        /**
         * Mixin providing "zooming" functionality.
         *
         * The zooming feature works by reconfiguring the time axis with the current zoom level values selected from the {@link #config-zoomLevels} array.
         * Zoom levels can be added and removed from the array to change the amount of available steps. Range of zooming in/out can be also
         * modified with {@link #config-maxZoomLevel} / {@link #config-minZoomLevel} properties.
         *
         * This mixin adds additional methods to the column : {@link #property-maxZoomLevel}, {@link #property-minZoomLevel}, {@link #function-zoomToLevel}, {@link #function-zoomIn},
         * {@link #function-zoomOut}, {@link #function-zoomInFull}, {@link #function-zoomOutFull}.
         *
         * **Notice**: Zooming doesn't work properly when `forceFit` option is set to true for the column or for filtered timeaxis.
         *
         * @mixin
         */

        /* harmony default export */

        __webpack_exports__["default"] = function (Target) {
          return (
            /*#__PURE__*/
            function (_ref) {
              _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(TimelineZoomable, _ref);

              function TimelineZoomable() {
                _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, TimelineZoomable);

                return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimelineZoomable).apply(this, arguments));
              }

              _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(TimelineZoomable, [{
                key: "construct",
                value: function construct(config) {
                  var me = this;

                  _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(TimelineZoomable.prototype), "construct", this).call(this, config);

                  if (me.zoomOnMouseWheel) {
                    _Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].on({
                      element: me.timeAxisSubGridElement,
                      wheel: 'onWheel',
                      thisObj: me,
                      capture: true,
                      passive: false
                    });
                  }

                  if (me.zoomOnTimeAxisDoubleClick) {
                    me.on('timeaxisheaderdblclick', function (_ref2) {
                      var startDate = _ref2.startDate,
                          endDate = _ref2.endDate;

                      if (!me.isVertical) {
                        me.zoomToSpan({
                          startDate: startDate,
                          endDate: endDate
                        });
                      }
                    });
                  }
                }
              }, {
                key: "getZoomLevelUnit",
                value: function getZoomLevelUnit(zoomLevel) {
                  return _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPreset(zoomLevel.preset).bottomHeader.unit;
                }
              }, {
                key: "presetToZoomLevel",
                value: function presetToZoomLevel(presetName) {
                  var preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPreset(presetName);

                  return {
                    preset: presetName,
                    increment: preset.bottomHeader.increment || 1,
                    resolution: preset.timeResolution.increment,
                    resolutionUnit: preset.timeResolution.unit,
                    width: preset.tickWidth
                  };
                }
              }, {
                key: "calculateCurrentZoomLevel",
                value: function calculateCurrentZoomLevel() {
                  var me = this,
                      zoomLevel = me.presetToZoomLevel(me.viewPreset.name),
                      min = Number.MAX_VALUE,
                      viewModel = me.timeAxisViewModel,
                      actualWidth = viewModel.tickSize;
                  zoomLevel.width = actualWidth;
                  zoomLevel.increment = viewModel.bottomHeader.increment || 1; // when calculating current zoom level we should use tick width from defined zoomLevels
                  // otherwise levels might be skipped

                  for (var i = 0, l = me.zoomLevels.length; i < l; i++) {
                    var curentLevel = me.zoomLevels[i]; // search for a zoom level having the same preset...

                    if (curentLevel.preset !== zoomLevel.preset) continue; // and the most close column width to the actual one

                    var delta = Math.abs(curentLevel.width - actualWidth);

                    if (delta < min) {
                      min = delta;
                      zoomLevel.actualWidth = curentLevel.actualWidth;
                      zoomLevel.width = curentLevel.width;
                    }
                  }

                  return zoomLevel;
                }
                /**
                 * Get/set current zoom level
                 * @property {Number}
                 * @category Zoom
                 */

              }, {
                key: "getMilliSecondsPerPixelForZoomLevel",

                /*
                 * @private
                 * Returns number of milliseconds per pixel.
                 * @param {Object} level Element from array of {@link #config-zoomLevels}.
                 * @param {Boolean} ignoreActualWidth If true, then density will be calculated using default zoom level settings.
                 * Otherwise density will be calculated for actual tick width.
                 * @return {Number} Return number of milliseconds per pixel.
                 */
                value: function getMilliSecondsPerPixelForZoomLevel(level, ignoreActualWidth) {
                  // trying to convert the unit + increment to a number of milliseconds
                  // this number is not fixed (month can be 28, 30 or 31 day), but at least this conversion
                  // will be consistent (should be no DST changes at year 1)
                  return Math.round((_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(new Date(1, 0, 1), level.increment, this.getZoomLevelUnit(level)) - new Date(1, 0, 1)) / ( // `actualWidth` is a column width after view adjustments applied to it (see `calculateTickWidth`)
                  // we use it if available to return the precise index value from `getCurrentZoomLevelIndex`
                  ignoreActualWidth ? level.width : level.actualWidth || level.width));
                }
                /**
                 * Zooms to passed view preset, saving center date. Method accepts config object as a first argument, which can be
                 * reduced to primitive type (string,number) when no additional options required. e.g.:
                 * ```
                 * // zooming to preset
                 * scheduler.zoomTo({ preset : 'hourAndDay' })
                 * // shorthand
                 * scheduler.zoomTo('hourAndDay')
                 *
                 * // zooming to level
                 * scheduler.zoomTo({ level : 0 })
                 * // shorthand
                 * scheduler.zoomTo(0)
                 * ```
                 *
                 * It is also possible to zoom to a time span by omitting `preset` and `level` configs, in which case scheduler sets
                 * the time frame to a specified range and applies zoom level which allows to fit all columns to this range. The
                 * given time span will be centered in the scheduling view (unless `centerDate` config provided). In the same time,
                 * the start/end date of the whole time axis will be extended to allow scrolling for user.
                 * ```
                 * // zooming to time span
                 * scheduler.zoomTo({ startDate : new Date(..), endDate : new Date(...) })
                 *
                 * ```
                 *
                 * @param {Object|String|Number} config Config object, preset name or zoom level index.
                 * @param {String} config.preset Preset name to zoom to. Ignores level config in this case
                 * @param {Number} config.level Zoom level to zoom to. Is ignored, if preset config is provided
                 * @param {Date} config.startDate New time frame start. If provided along with end, view will be centered in this time
                 * interval (unless `centerDate` is present)
                 * @param {Date} config.endDate New time frame end
                 * @param {Date} config.centerDate Date that should be kept in the center. Has priority over start and end params
                 * @param {Number} config.width Lowest tick width. Might be increased automatically
                 * @param {Number} [config.leftMargin] Amount of pixels to extend span start on (used, when zooming to span)
                 * @param {Number} [config.rightMargin] Amount of pixels to extend span end on (used, when zooming to span)
                 * @param {Number} [config.adjustStart] Amount of units to extend span start on (used, when zooming to span)
                 * @param {Number} [config.adjustEnd] Amount of units to extend span end on (used, when zooming to span)
                 * @category Zoom
                 */

              }, {
                key: "zoomTo",
                value: function zoomTo(config) {
                  var me = this;

                  if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_1___default()(config) === 'object') {
                    if (config.preset) {
                      var zoomLevel = me.presetToZoomLevel(config.preset);
                      this.internalZoomToLevel(zoomLevel, config);
                    } else if (config.level != null) {
                      me.zoomToLevel(config.level, config);
                    } else {
                      me.zoomToSpan(config);
                    }
                  } else if (typeof config === 'number') {
                    me.zoomToLevel(config);
                  } else {
                    var _zoomLevel = me.presetToZoomLevel(config);

                    this.internalZoomToLevel(_zoomLevel);
                  }
                }
                /**
                 * Allows zooming to certain level of {@link #config-zoomLevels} array. Automatically limits zooming between {@link #config-maxZoomLevel}
                 * and {@link #config-minZoomLevel}. Can also set time axis timespan to the supplied start and end dates.
                 *
                 * @param {Number} level Level to zoom to.
                 * @param {Object} [options] Object, containing options for this method
                 * @param {Date} options.startDate New time frame start. If provided along with end, view will be centered in this time
                 * interval, ignoring centerDate config.
                 * @param {Date} options.endDate New time frame end.
                 * @param {Date} options.centerDate Date that should be kept in center. Is ignored when start and end are provided.
                 * @param {Number} options.width Lowest tick width. Might be increased automatically
                 * @return {Number} level Current zoom level or null if it hasn't changed.
                 * @category Zoom
                 * @internal
                 */

              }, {
                key: "zoomToLevel",
                value: function zoomToLevel(level) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  var me = this;
                  level = Math.min(Math.max(level, me.minZoomLevel), me.maxZoomLevel);
                  var currentZoomLevel = me.calculateCurrentZoomLevel(),
                      currentFactor = me.getMilliSecondsPerPixelForZoomLevel(currentZoomLevel),
                      nextZoomLevel = me.zoomLevels[level],
                      nextFactor = me.getMilliSecondsPerPixelForZoomLevel(nextZoomLevel);

                  if (currentFactor === nextFactor && !(options.startDate || options.endDate)) {
                    // already at requested zoom level
                    return null;
                  }

                  me.internalZoomToLevel(nextZoomLevel, options);
                  return level;
                }
                /**
                 * @param {Object} level Zoom level configuration
                 * @param {String} level.preset View preset to zoom to
                 * @param {Number} [level.width] Tick width for preset
                 * @param {Number} [level.increment] Preset increment
                 * @param {String} [level.resolutionUnit] Preset resolution unit
                 * @param {Number} [level.resolution] Preset resolution unit increment
                 * @param {Object} [options] Additional options
                 * @param {Date} options.startDate New time frame start. If provided along with end, view will be centered in this time
                 * interval (unless centerDate is present)
                 * @param {Date} options.endDate New time frame end.
                 * @param {Date} options.centerDate Date that should be kept in center. Has priority over start and end params.
                 * @param {Number} options.width Lowest tick width. Might be increased automatically
                 * @private
                 */

              }, {
                key: "internalZoomToLevel",
                value: function internalZoomToLevel(level) {
                  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                  var me = this; // this event is used to prevent sync suspend during zooming

                  me.trigger('beforeZoomChange', {
                    level: level
                  });

                  var isVertical = me.isVertical,
                      startDate = options.startDate,
                      endDate = options.endDate,
                      span = startDate && endDate ? {
                    startDate: startDate,
                    endDate: endDate
                  } : null,
                      centerDate = options.centerDate || (span ? new Date((startDate.getTime() + endDate.getTime()) / 2) : me.viewportCenterDateCached),
                      // // eslint-disable-next-line no-undef
                  panelSize = me.timeAxisSubGrid.width,
                      presetCopy = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPreset(level.preset).clone(),
                      bottomHeader = presetCopy.bottomHeader;

                  span = span || me.calculateOptimalDateRange(centerDate, panelSize, level); // clone doesn't copy the preset name

                  presetCopy.name = level.preset;
                  presetCopy[isVertical ? 'tickHeight' : 'tickWidth'] = options.width || level.width;
                  bottomHeader.increment = level.increment;
                  me.isZooming = true;
                  presetCopy.increment = level.increment;
                  presetCopy.timeResolution.unit = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getUnitByName(level.resolutionUnit || presetCopy.timeResolution.unit || bottomHeader.unit);
                  presetCopy.timeResolution.increment = level.resolution;
                  me.setViewPreset(presetCopy, span.startDate || me.startDate, span.endDate || me.endDate, false, {
                    centerDate: centerDate
                  }); // after switching the view preset the `width` config of the zoom level may change, because of adjustments
                  // we will save the real value in the `actualWidth` property, so that `getCurrentZoomLevelIndex` method
                  // will return the exact level index after zooming

                  level.actualWidth = me.timeAxisViewModel.tickSize;
                  me.isZooming = false;
                  /**
                   * Fires after zoom level change
                   * @event zoomChange
                   * @param {Scheduler.view.Scheduler} source The TimeAxisColumn object
                   * @param {Number} level The index of the new zoom level
                   * @param {Object} levelConfig An object containing the configuration properties of the new zoom level
                   */

                  me.trigger('zoomChange', {
                    level: me.zoomLevels.indexOf(level),
                    levelConfig: level
                  });
                }
                /**
                 * Changes the range of the scheduling chart to fit all the events in its event store.
                 * @param {Object} [options] Options object for the zooming operation.
                 * @param {Number} [options.leftMargin] Defines margin in pixel between the first event start date and first visible date
                 * @param {Number} [options.rightMargin] Defines margin in pixel between the last event end date and last visible date
                 */

              }, {
                key: "zoomToFit",
                value: function zoomToFit(options) {
                  var eventStore = this.eventStore,
                      span = eventStore.getTotalTimeSpan();
                  options = Object.assign({
                    leftMargin: 0,
                    rightMargin: 0
                  }, options, span); // Make sure we received a time span, event store might be empty

                  if (options.startDate && options.endDate) {
                    this.zoomToSpan(options);
                  }
                }
                /**
                 * Sets time frame to specified range and applies zoom level which allows to fit all columns to this range.
                 *
                 * The given time span will be centered in the scheduling view, in the same time, the start/end date of the whole time axis
                 * will be extended in the same way as {@link #function-zoomToLevel} method does, to allow scrolling for user.
                 *
                 * @param {Object} config The time frame.
                 * @param {Date} config.startDate The time frame start.
                 * @param {Date} config.endDate The time frame end.
                 * @param {Date} [config.centerDate] Date that should be kept in the center. Has priority over start and end params
                 * @param {Number} [config.leftMargin] Amount of pixels to extend span start on
                 * @param {Number} [config.rightMargin] Amount of pixels to extend span end on
                 * @param {Number} [config.adjustStart] Amount of units to extend span start on
                 * @param {Number} [config.adjustEnd] Amount of units to extend span end on
                 *
                 * @return {Number} level Current zoom level or null if it hasn't changed.
                 * @category Zoom
                 * @internal
                 */

              }, {
                key: "zoomToSpan",
                value: function zoomToSpan() {
                  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

                  if (config.leftMargin || config.rightMargin) {
                    config.adjustStart = 0;
                    config.adjustEnd = 0;
                  }

                  if (!config.leftMargin) config.leftMargin = 0;
                  if (!config.rightMargin) config.rightMargin = 0;
                  if (!config.startDate || !config.endDate) throw new Error('zoomToSpan: must provide startDate + endDate dates');
                  var me = this,
                      startDate = config.startDate,
                      endDate = config.endDate,
                      // this config enables old zoomToSpan behavior which we want to use for zoomToFit in Gantt
                  needToAdjust = config.adjustStart >= 0 || config.adjustEnd >= 0;

                  if (needToAdjust) {
                    startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(startDate, -config.adjustStart, me.timeAxis.mainUnit);
                    endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(endDate, config.adjustEnd, me.timeAxis.mainUnit);
                  }

                  if (startDate <= endDate) {
                    // get scheduling view width
                    var availableSpace = me.timeAxisViewModel.availableSpace; // if potential width of col is less than col width provided by zoom level
                    //   - we'll zoom out panel until col width fit into width from zoom level
                    // and if width of column is more than width from zoom level
                    //   - we'll zoom in until col width fit won't fit into width from zoom level

                    var currLevel = Math.floor(me.zoomLevel); // if we zoomed out even more than the highest zoom level - limit it to the highest zoom level

                    if (currLevel === -1) currLevel = 0;
                    var zoomLevels = me.zoomLevels;
                    var diffMS = endDate - startDate || 1,
                        msPerPixel = me.getMilliSecondsPerPixelForZoomLevel(zoomLevels[currLevel], true),
                        // increment to get next zoom level:
                    // -1 means that given timespan won't fit the available width in the current zoom level, we need to zoom out,
                    // so that more content will "fit" into 1 px
                    //
                    // +1 mean that given timespan will already fit into available width in the current zoom level, but,
                    // perhaps if we'll zoom in a bit more, the fitting will be better
                    inc = diffMS / msPerPixel + config.leftMargin + config.rightMargin > availableSpace ? -1 : 1,
                        candidateLevel = currLevel + inc,
                        zoomLevel,
                        levelToZoom = null; // loop over zoom levels

                    while (candidateLevel >= 0 && candidateLevel <= zoomLevels.length - 1) {
                      // get zoom level
                      zoomLevel = zoomLevels[candidateLevel];
                      msPerPixel = me.getMilliSecondsPerPixelForZoomLevel(zoomLevel, true);
                      var spanWidth = diffMS / msPerPixel + config.leftMargin + config.rightMargin; // if zooming out

                      if (inc === -1) {
                        // if columns fit into available space, then all is fine, we've found appropriate zoom level
                        if (spanWidth <= availableSpace) {
                          levelToZoom = candidateLevel; // stop searching

                          break;
                        } // if zooming in

                      } else {
                        // if columns still fits into available space, we need to remember the candidate zoom level as a potential
                        // resulting zoom level, the indication that we've found correct zoom level will be that timespan won't fit
                        // into available view
                        if (spanWidth <= availableSpace) {
                          // if it's not currently active level
                          if (currLevel !== candidateLevel - inc) {
                            // remember this level as applicable
                            levelToZoom = candidateLevel;
                          }
                        } else {
                          // Sanity check to find the following case:
                          // If we're already zoomed in at the appropriate level, but the current zoomLevel is "too small" to fit and had to be expanded,
                          // there is an edge case where we should actually just stop and use the currently selected zoomLevel
                          break;
                        }
                      }

                      candidateLevel += inc;
                    } // If we didn't find a large/small enough zoom level, use the lowest/highest level


                    levelToZoom = levelToZoom != null ? levelToZoom : candidateLevel - inc;
                    zoomLevel = zoomLevels[levelToZoom];

                    var unitToZoom = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_12__["default"].getPreset(zoomLevel.preset).bottomHeader.unit;

                    if (config.leftMargin || config.rightMargin) {
                      // time axis doesn't yet know about new view preset (zoom level) so it cannot round/ceil date correctly
                      startDate = new Date(startDate.getTime() - msPerPixel * config.leftMargin);
                      endDate = new Date(endDate.getTime() + msPerPixel * config.rightMargin);
                    }

                    var tickCount = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].getDurationInUnit(startDate, endDate, unitToZoom, true) / zoomLevel.increment;

                    if (tickCount === 0) {
                      return null;
                    }

                    var customWidth = Math.floor(availableSpace / tickCount),
                        centerDate = config.centerDate || new Date((startDate.getTime() + endDate.getTime()) / 2),
                        range;

                    if (needToAdjust) {
                      range = {
                        startDate: startDate,
                        endDate: endDate
                      };
                    } else {
                      range = me.calculateOptimalDateRange(centerDate, availableSpace, zoomLevel);
                    }

                    return me.zoomToLevel(levelToZoom, Object.assign(range, {
                      width: customWidth,
                      centerDate: centerDate
                    }));
                  }

                  return null;
                }
                /**
                 * Zooms in the timeline according to the array of zoom levels. If the amount of levels to zoom is given, the view will zoom in by this value.
                 * Otherwise a value of `1` will be used.
                 *
                 * @param {Number} levels (optional) amount of levels to zoom in
                 *
                 * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
                 * @category Zoom
                 */

              }, {
                key: "zoomIn",
                value: function zoomIn() {
                  var levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                  var currentZoomLevelIndex = this.zoomLevel;
                  if (currentZoomLevelIndex >= this.zoomLevels.length - 1) return null;
                  return this.zoomToLevel(Math.floor(currentZoomLevelIndex) + levels);
                }
                /**
                 * Zooms out the timeline according to the array of zoom levels. If the amount of levels to zoom is given, the view will zoom out by this value.
                 * Otherwise a value of `1` will be used.
                 *
                 * @param {Number} levels (optional) amount of levels to zoom out
                 *
                 * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
                 * @category Zoom
                 */

              }, {
                key: "zoomOut",
                value: function zoomOut() {
                  var levels = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                  var currentZoomLevelIndex = this.zoomLevel;
                  if (currentZoomLevelIndex <= 0) return null;
                  return this.zoomToLevel(Math.ceil(currentZoomLevelIndex) - levels);
                }
                /**
                 * Zooms in the timeline to the {@link #config-maxZoomLevel} according to the array of zoom levels.
                 *
                 * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
                 * @category Zoom
                 */

              }, {
                key: "zoomInFull",
                value: function zoomInFull() {
                  return this.zoomToLevel(this.maxZoomLevel);
                }
                /**
                 * Zooms out the timeline to the {@link #config-minZoomLevel} according to the array of zoom levels.
                 *
                 * @return {Number} currentLevel New zoom level of the panel or null if level hasn't changed.
                 * @category Zoom
                 */

              }, {
                key: "zoomOutFull",
                value: function zoomOutFull() {
                  return this.zoomToLevel(this.minZoomLevel);
                }
                /*
                 * Adjusts the timespan of the panel to the new zoom level. Used for performance reasons,
                 * as rendering too many columns takes noticeable amount of time so their number is limited.
                 * @category Zoom
                 * @private
                 */

              }, {
                key: "calculateOptimalDateRange",
                value: function calculateOptimalDateRange(centerDate, panelSize, zoomLevel, userProvidedSpan) {
                  // this line allows us to always use the `calculateOptimalDateRange` method when calculating date range for zooming
                  // (even in case when user has provided own interval)
                  // other methods may override/hook into `calculateOptimalDateRange` to insert own processing
                  // (infinite scrolling feature does)
                  if (userProvidedSpan) return userProvidedSpan;
                  var timeAxis = this.timeAxis;

                  if (this.zoomKeepsOriginalTimespan) {
                    return {
                      startDate: timeAxis.startDate,
                      endDate: timeAxis.endDate
                    };
                  }

                  var unit = this.getZoomLevelUnit(zoomLevel),
                      difference = Math.ceil(panelSize / zoomLevel.width * zoomLevel.increment * this.visibleZoomFactor / 2),
                      startDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(centerDate, -difference, unit),
                      endDate = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"].add(centerDate, difference, unit);

                  return {
                    startDate: timeAxis.floorDate(startDate, false, unit, zoomLevel.increment),
                    endDate: timeAxis.ceilDate(endDate, false, unit, zoomLevel.increment)
                  };
                }
              }, {
                key: "onWheel",
                value: function onWheel(event) {
                  var me = this;

                  if (event.ctrlKey) {
                    event.preventDefault();

                    if (!me.preventScrollZoom) {
                      if (event.deltaY > 0) {
                        me.zoomOut();
                      } else if (event.deltaY < 0) {
                        me.zoomIn();
                      }

                      me.preventScrollZoom = true;
                      me.setTimeout(function () {
                        return me.preventScrollZoom = false;
                      }, 30);
                    }
                  }
                }
                /**
                 * Changes the time axis timespan to the supplied start and end dates.
                 * @param {Date} startDate The new start date
                 * @param {Date} endDate The new end date. If not supplied, the {@link Scheduler.preset.ViewPreset#config-defaultSpan} property of the current view preset will be used to calculate the new end date.
                 */

              }, {
                key: "setTimeSpan",
                value: function setTimeSpan(startDate, endDate) {
                  this.timeAxis.setTimeSpan(startDate, endDate);
                }
                /**
                 * Moves the time axis by the passed amount and unit.
                 *
                 * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shift} for more information.
                 *
                 * @param {Number} amount The number of units to jump
                 * @param {String} [unit] The unit (Day, Week etc)
                 */

              }, {
                key: "shift",
                value: function shift(amount, unit) {
                  this.timeAxis.shift(amount, unit);
                }
                /**
                 * Moves the time axis forward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement`
                 * config of the current view preset.
                 *
                 * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shiftNext} for more information.
                 *
                 * @param {Number} [amount] The number of units to jump forward
                 */

              }, {
                key: "shiftNext",
                value: function shiftNext(amount) {
                  this.timeAxis.shiftNext(amount);
                }
                /**
                 * Moves the time axis backward in time in units specified by the view preset `shiftUnit`, and by the amount specified by the `shiftIncrement` config of the current view preset.
                 *
                 * NOTE: If using a filtered time axis, see {@link Scheduler.data.TimeAxis#function-shiftPrevious} for more information.
                 *
                 * @param {Number} [amount] The number of units to jump backward
                 */

              }, {
                key: "shiftPrevious",
                value: function shiftPrevious(amount) {
                  this.timeAxis.shiftPrevious(amount);
                } // This does not need a className on Widgets.
                // Each *Class* which doesn't need 'b-' + constructor.name.toLowerCase() automatically adding
                // to the Widget it's mixed in to should implement thus.

              }, {
                key: "maxZoomLevel",
                get: function get() {
                  return this._maxZoomLevel;
                }
                /**
                 * Get/set the {@link #config-maxZoomLevel} value
                 * @property {Number}
                 * @category Zoom
                 */
                ,
                set: function set(level) {
                  if (typeof level !== 'number') {
                    level = this.zoomLevels.length - 1;
                  }

                  if (level < 0 || level >= this.zoomLevels.length) {
                    throw new Error('Invalid range for `setMinZoomLevel`');
                  }

                  this._maxZoomLevel = level;
                }
              }, {
                key: "minZoomLevel",
                get: function get() {
                  return this._minZoomLevel;
                }
                /**
                 * Sets the {@link #config-minZoomLevel} value
                 * @property {Number}
                 * @category Zoom
                 */
                ,
                set: function set(level) {
                  if (typeof level !== 'number') {
                    level = 0;
                  }

                  if (level < 0 || level >= this.zoomLevels.length) {
                    throw new Error('Invalid range for `minZoomLevel`');
                  }

                  this._minZoomLevel = level;
                }
              }, {
                key: "zoomLevel",
                get: function get() {
                  var me = this,
                      currentZoomLevel = me.calculateCurrentZoomLevel(),
                      currentFactor = me.getMilliSecondsPerPixelForZoomLevel(currentZoomLevel),
                      zoomLevels = me.zoomLevels;

                  for (var i = 0; i < zoomLevels.length; i++) {
                    var zoomLevelFactor = me.getMilliSecondsPerPixelForZoomLevel(zoomLevels[i]);
                    if (zoomLevelFactor === currentFactor) return i; // current zoom level is outside of pre-defined zoom levels

                    if (i === 0 && currentFactor > zoomLevelFactor) return -0.5;
                    if (i === zoomLevels.length - 1 && currentFactor < zoomLevelFactor) return zoomLevels.length - 1 + 0.5;
                    var nextLevelFactor = me.getMilliSecondsPerPixelForZoomLevel(zoomLevels[i + 1]);
                    if (zoomLevelFactor > currentFactor && currentFactor > nextLevelFactor) return i + 0.5;
                  }

                  throw new Error("Can't find current zoom level index");
                } // noinspection JSAnnotator
                ,
                set: function set(level) {
                  this.zoomToLevel(level);
                }
              }, {
                key: "widgetClass",
                get: function get() {}
              }], [{
                key: "defaultConfig",
                get: function get() {
                  return {
                    /**
                     * If true, you can zoom in and out on the the time axis using CTRL-key + mouse wheel.
                     * @config {Boolean}
                     * @default
                     * @category Zoom
                     */
                    zoomOnMouseWheel: true,

                    /**
                     * True to zoom to time span when double clicking a time axis cell.
                     * @config {Boolean}
                     * @category Zoom
                     */
                    zoomOnTimeAxisDoubleClick: true,
                    preventScrollZoom: false,

                    /**
                     * Predefined map of zoom levels for each preset in the ascending order. Zoom level is basically a
                     * {@link Scheduler.preset.ViewPreset view preset}, which is based on another preset, with some values
                     * overridden.
                     *
                     * Each element is an {Object} with the following parameters :
                     *
                     * - `preset` (String)      - {@link Scheduler.preset.ViewPreset} to be used for this zoom level. This must be a valid preset name registered in {@link Scheduler.preset.PresetManager preset manager}.
                     * - `width` (Int)          - {@link Scheduler.preset.ViewPreset#config-tickWidth tickWidth} time column width value from the preset
                     * - `increment` (Int)      - {@link Scheduler.preset.ViewPresetHeaderRow#config-increment increment} value from the bottom header row of the preset
                     * - `resolution` (Int)     - {@link Scheduler.preset.ViewPreset#config-timeResolution increment} part of the `timeResolution` object in the preset
                     * - `resolutionUnit` (String) (Optional) - {@link Scheduler.preset.ViewPreset#config-timeResolution unit} part of the `timeResolution` object in the preset
                     *
                     *  The `zoomLevels` config can be set in the scheduler like this:
                     * ```javascript
                     * let scheduler = new Scheduler({
                     *   resourceStore : resourceStore,
                     *   eventStore    : eventStore,
                     *   viewPreset    : 'hourAndDay',
                     *   zoomLevels: [
                     *       { width: 50,    increment: 4,   resolution: 60, preset: 'hourAndDay', resolutionUnit: 'minute' },
                     *       { width: 60,    increment: 3,   resolution: 60, preset: 'hourAndDay', resolutionUnit: 'minute' },
                     *       { width: 80,    increment: 2,   resolution: 30, preset: 'hourAndDay', resolutionUnit: 'minute' },
                     *       { width: 100,   increment: 1,   resolution: 15, preset: 'hourAndDay', resolutionUnit: 'minute' }
                     *   ]
                     * });
                     * ```
                     * In the case above:
                     *
                     * - The `width` specifies the amount of space in pixels for the bottom cell.
                     * - The `increment` specifies the number of hours between each bottom cell.
                     * - The `resolution` specifies the size of the slots in the bottom cell accordingly to the defined `resolutionUnit`.
                     *
                     * In the case above we have four zoomlevel steps within the `hourAndDay` preset. When zooming in we go up
                     * in the zoomlevel array, when zooming out we go down in the zoomlevel array. In this case the zoomlevel
                     * with `increment` set to 1 and `width` set to 100 is the most detailed level, the max level. While the
                     * first item in the array is the minimal zoomlevel. In a higher zoomlevel the `resolution` can be set lower
                     * to make the granularity of the cell smaller. That means smaller slots for the events to fit in.
                     * @config {Object[]}
                     * @category Zoom
                     */
                    zoomLevels: [//YEAR
                    {
                      width: 40,
                      increment: 1,
                      resolution: 1,
                      preset: 'manyYears',
                      resolutionUnit: 'YEAR'
                    }, {
                      width: 80,
                      increment: 1,
                      resolution: 1,
                      preset: 'manyYears',
                      resolutionUnit: 'YEAR'
                    }, {
                      width: 30,
                      increment: 1,
                      resolution: 1,
                      preset: 'year',
                      resolutionUnit: 'MONTH'
                    }, {
                      width: 50,
                      increment: 1,
                      resolution: 1,
                      preset: 'year',
                      resolutionUnit: 'MONTH'
                    }, {
                      width: 100,
                      increment: 1,
                      resolution: 1,
                      preset: 'year',
                      resolutionUnit: 'MONTH'
                    }, {
                      width: 200,
                      increment: 1,
                      resolution: 1,
                      preset: 'year',
                      resolutionUnit: 'MONTH'
                    }, //MONTH
                    {
                      width: 100,
                      increment: 1,
                      resolution: 7,
                      preset: 'monthAndYear',
                      resolutionUnit: 'DAY'
                    }, {
                      width: 30,
                      increment: 1,
                      resolution: 1,
                      preset: 'weekDateAndMonth',
                      resolutionUnit: 'DAY'
                    }, //WEEK
                    {
                      width: 50,
                      increment: 1,
                      resolution: 1,
                      preset: 'weekAndMonth',
                      resolutionUnit: 'DAY'
                    }, {
                      width: 20,
                      increment: 1,
                      resolution: 1,
                      preset: 'weekAndDayLetter'
                    }, //DAY
                    {
                      width: 54,
                      increment: 1,
                      resolution: 1,
                      preset: 'weekAndDay',
                      resolutionUnit: 'HOUR'
                    }, {
                      width: 100,
                      increment: 1,
                      resolution: 1,
                      preset: 'weekAndDay',
                      resolutionUnit: 'HOUR'
                    }, //HOUR
                    {
                      width: 64,
                      increment: 6,
                      resolution: 30,
                      preset: 'hourAndDay',
                      resolutionUnit: 'MINUTE'
                    }, {
                      width: 100,
                      increment: 6,
                      resolution: 30,
                      preset: 'hourAndDay',
                      resolutionUnit: 'MINUTE'
                    }, {
                      width: 64,
                      increment: 2,
                      resolution: 30,
                      preset: 'hourAndDay',
                      resolutionUnit: 'MINUTE'
                    }, {
                      width: 64,
                      increment: 1,
                      resolution: 30,
                      preset: 'hourAndDay',
                      resolutionUnit: 'MINUTE'
                    }, //MINUTE
                    {
                      width: 30,
                      increment: 15,
                      resolution: 5,
                      preset: 'minuteAndHour'
                    }, {
                      width: 60,
                      increment: 15,
                      resolution: 5,
                      preset: 'minuteAndHour'
                    }, {
                      width: 130,
                      increment: 15,
                      resolution: 5,
                      preset: 'minuteAndHour'
                    }, {
                      width: 60,
                      increment: 5,
                      resolution: 5,
                      preset: 'minuteAndHour'
                    }, {
                      width: 100,
                      increment: 5,
                      resolution: 5,
                      preset: 'minuteAndHour'
                    }, //SECOND
                    {
                      width: 30,
                      increment: 10,
                      resolution: 5,
                      preset: 'secondAndMinute'
                    }, {
                      width: 60,
                      increment: 10,
                      resolution: 5,
                      preset: 'secondAndMinute'
                    }, {
                      width: 130,
                      increment: 5,
                      resolution: 5,
                      preset: 'secondAndMinute'
                    }],

                    /**
                     * Minimal zoom level to which {@link #function-zoomOut} will work
                     * @config {Number}
                     * @category Zoom
                     */
                    minZoomLevel: true,

                    /**
                     * Maximal zoom level to which {@link #function-zoomIn} will work
                     * @config {Number}
                     * @category Zoom
                     */
                    maxZoomLevel: true,

                    /**
                     * Integer number indicating the size of timespan during zooming. When zooming, the timespan is adjusted to make the scrolling area `visibleZoomFactor` times
                     * wider than the timeline area itself. Used in {@link #function-zoomToSpan} and {@link #function-zoomToLevel} functions.
                     * @config {Number}
                     * @default
                     * @category Zoom
                     */
                    visibleZoomFactor: 5,

                    /**
                     * Whether the originally rendered timespan should be preserved while zooming. By default it is set to `false`,
                     * meaning the timeline panel will adjust the currently rendered timespan to limit the amount of HTML content to render. When setting this option
                     * to `true`, be careful not to allow to zoom a big timespan in seconds resolution for example. That will cause **a lot** of HTML content
                     * to be rendered and affect performance. You can use {@link #config-minZoomLevel} and {@link #config-maxZoomLevel} config options for that.
                     * @config {Boolean}
                     * @default
                     * @category Zoom
                     */
                    zoomKeepsOriginalTimespan: false
                  };
                }
              }]);

              return TimelineZoomable;
            }(Target || _Common_Base_js__WEBPACK_IMPORTED_MODULE_10__["default"])
          );
        };
        /***/

      },

      /***/
      "./lib/Scheduler/view/model/TimeAxisViewModel.js":
      /*!*******************************************************!*\
        !*** ./lib/Scheduler/view/model/TimeAxisViewModel.js ***!
        \*******************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewModelTimeAxisViewModelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return TimeAxisViewModel;
        });
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.assign */
        "./node_modules/core-js/modules/es6.object.assign.js");
        /* harmony import */


        var core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_assign__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ../../../Common/mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony import */


        var _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ../../preset/PresetManager.js */
        "./lib/Scheduler/preset/PresetManager.js");
        /* harmony import */


        var _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ../../preset/ViewPreset.js */
        "./lib/Scheduler/preset/ViewPreset.js");
        /* harmony import */


        var _data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../data/TimeAxis.js */
        "./lib/Scheduler/data/TimeAxis.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/model/TimeAxisViewModel
         */

        /**
         * This class is an internal view model class, describing the visual representation of a {@link Scheduler.data.TimeAxis}.
         * The config for the header rows is described in the {@link Scheduler.preset.ViewPreset#config-headerConfig headerConfig}.
         * To calculate the size of each cell in the time axis, this class requires:
         *
         * - availableSpace  - The total width or height available for the rendering
         * - tickSize       - The fixed width or height of each cell in the lowest header row. This value is normally read from the
         * {@link Scheduler.preset.ViewPreset viewPreset} but this can also be updated programmatically using the {@link #property-tickSize} setter
         *
         * Normally you should not interact with this class directly.
         *
         * @extends Common/mixin/Events
         */

        var TimeAxisViewModel =
        /*#__PURE__*/
        function (_Events) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_7___default()(TimeAxisViewModel, _Events);

          function TimeAxisViewModel() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, TimeAxisViewModel);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(TimeAxisViewModel).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(TimeAxisViewModel, [{
            key: "construct",
            //endregion
            //region Init & destroy
            value: function construct(config) {
              var me = this; // getSingleUnitInPixels results are memoized because of frequent calls during rendering.

              me.unitToPixelsCache = {};

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_6___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(TimeAxisViewModel.prototype), "construct", this).call(this, config);

              var viewPreset = me.timeAxis.viewPreset || me.viewPreset;

              if (viewPreset) {
                if (viewPreset instanceof _preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_11__["default"]) {
                  me.consumeViewPreset(viewPreset);
                } else {
                  var preset = _preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_10__["default"].getPreset(viewPreset);

                  preset && me.consumeViewPreset(preset);
                }
              } // When time axis is changed, reconfigure the model


              me.timeAxis.on('reconfigure', me.onTimeAxisReconfigure, me);
              me.configured = true;
            }
          }, {
            key: "doDestroy",
            value: function doDestroy() {
              this.timeAxis.un('reconfigure', this.onTimeAxisReconfigure, this);
            }
            /**
             * Returns a model object of the current timeAxis, containing an array representing the cells for each level in the header.
             * This object will always contain a 'middle' array, and depending on the {@link Scheduler.preset.ViewPreset#config-headerConfig} it can also contain a 'top' and 'bottom' property.
             * @return {Object} The model representing each cell (with start date and end date) in the timeline representation.
             * @internal
             */

          }, {
            key: "reconfigure",
            //endregion
            //region Reconfigure & update
            value: function reconfigure(config) {
              // clear the cached headers
              var me = this;
              me._headers = null;
              Object.assign(me, config);
              me.trigger('reconfigure');
            }
          }, {
            key: "onTimeAxisReconfigure",
            value: function onTimeAxisReconfigure(_ref) {
              var timeAxis = _ref.source,
                  suppressRefresh = _ref.suppressRefresh;

              if (this.viewPreset !== timeAxis.viewPreset) {
                this.consumeViewPreset(timeAxis.viewPreset);
              }

              if (!suppressRefresh) {
                this.update();
              }
            }
            /**
             * Updates the view model current timeAxis configuration and available space.
             * @param {Number} [availableSpace] The available space for the rendering of the axis (used in forceFit mode)
             * @param {Boolean} [silent] Pass `true` to suppress the firing of the `update` event.
             * @param {Boolean} [forceUpdate] Pass `true` to fire the `update` event even if the size has not changed.
             * @internal
             */

          }, {
            key: "update",
            value: function update(availableSpace) {
              var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var forceUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  timeAxis = me.timeAxis,
                  headerConfig = me.headerConfig; // We're in configuration, or no change, quit

              if (me.isConfiguring || me._availableSpace === availableSpace) {
                if (forceUpdate) {
                  me.trigger('update');
                }

                return;
              }

              me._availableSpace = Math.max(availableSpace || me.availableSpace || 0, 0);

              if (typeof me.availableSpace !== 'number') {
                throw new Error('Invalid available space provided to TimeAxisModel');
              } // Despite available space is 0, we still should generate column config in order for scheduler to render


              if (me.availableSpace <= 0) {
                console.warn('No available space provided for time axis. Make sure you have set width for horizontal mode and height for vertical');
              }

              me.columnConfig = {}; // The "column width" is considered to be the width of each tick in the lowest header row and this width
              // has to be same for all cells in the lowest row.

              var tickSize = me._tickSize = me.calculateTickSize(me.originalTickSize);

              if (typeof tickSize !== 'number' || tickSize <= 0) {
                throw new Error('Invalid timeAxis tick size');
              } // getSingleUnitInPixels results are memoized because of frequent calls during rendering.


              me.unitToPixelsCache = {}; // totalSize is cached because of frequent calls which calculate it.

              me._totalSize = null; // Generate the underlying date ranges for each header row, which will provide input to the cell rendering

              for (var pos in headerConfig) {
                if (headerConfig[pos].cellGenerator) {
                  me.columnConfig[pos] = headerConfig[pos].cellGenerator.call(me, timeAxis.startDate, timeAxis.endDate);
                } else {
                  me.columnConfig[pos] = me.createHeaderRow(pos, headerConfig[pos]);
                }
              }

              if (!silent) {
                me.trigger('update');
              }
            } //endregion
            //region CalendarColumn
            // /**
            //  * Will update columns start/end dates to perform date/coordinate lookups
            //  * @param {Object[]} columns Array of column configs including start/end dates
            //  * @private
            //  */
            // updateCalendarColumnDates(columns) {
            //     this.calendarColumnDates = [];
            //
            //     for (let i = 0; i < columns.length; i++) {
            //         let obj = columns[i];
            //         this.calendarColumnDates.push([obj.start, obj.end]);
            //     }
            // }
            // // TODO: make getter
            // /**
            //  * Returns current column start/end dates array
            //  * @returns {Date[]}
            //  * @private
            //  */
            // getCalendarColumnDates() {
            //     return this.calendarColumnDates;
            // }
            //endregion
            //region Date / position mapping

            /**
             * Returns the distance in pixels for a timespan with the given start and end date.
             * @param {Date} start start date
             * @param {Date} end end date
             * @return {Number} The length of the time span
             * @category Date mapping
             */

          }, {
            key: "getDistanceBetweenDates",
            value: function getDistanceBetweenDates(start, end) {
              return Math.round(this.getPositionFromDate(end) - this.getPositionFromDate(start));
            }
            /**
             * Returns the distance in pixels for a time span
             * @param {Number} durationMS Time span duration in ms
             * @return {Number} The length of the time span
             * @category Date mapping
             */

          }, {
            key: "getDistanceForDuration",
            value: function getDistanceForDuration(durationMs) {
              var me = this,
                  tick = this.timeAxis.getAt(0),
                  pxPerMs = me.tickSize / (tick.endDate - tick.startDate);
              return pxPerMs * durationMs;
            }
            /**
             * Gets the position of a date on the projected time axis or -1 if the date is not in the timeAxis.
             * @param {Date} date the date to query for.
             * @returns {Number} the coordinate representing the date
             * @category Date mapping
             */

          }, {
            key: "getPositionFromDate",
            value: function getPositionFromDate(date) {
              var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
              var me = this,
                  tick = me.getScaledTick(date, options);

              if (tick === -1) {
                return -1;
              }

              return Math.round(me.tickSize * (tick - me.timeAxis.visibleTickStart));
            } // Translates a tick along the time axis to facilitate scaling events when excluding certain days or hours

          }, {
            key: "getScaledTick",
            value: function getScaledTick(date, _ref2) {
              var respectExclusion = _ref2.respectExclusion,
                  snapToNextIncluded = _ref2.snapToNextIncluded,
                  isEnd = _ref2.isEnd,
                  min = _ref2.min,
                  max = _ref2.max;
              var timeAxis = this.timeAxis,
                  include = timeAxis.include,
                  unit = timeAxis.unit,
                  weekStartDay = timeAxis.weekStartDay;
              var tick = timeAxis.getTickFromDate(date);

              if (tick !== -1 && respectExclusion && include) {
                var tickChanged = false; // Stretch if we are using a larger unit than 'hour', except if it is 'day'. If so, it is already handled
                // by a cheaper reconfiguration of the ticks in `generateTicks`

                if (include.hour && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].compareUnits(unit, 'hour') > 0 && unit !== 'day') {
                  var _include$hour = include.hour,
                      from = _include$hour.from,
                      to = _include$hour.to,
                      lengthFactor = _include$hour.lengthFactor,
                      center = _include$hour.center,
                      originalHours = date.getHours(),
                      croppedHours = Math.min(Math.max(originalHours, from), to); // If we are not asked to snap (when other part of span is not included) any cropped away hour
                  // should be considered excluded

                  if (!snapToNextIncluded && croppedHours !== originalHours) {
                    return -1;
                  }

                  var // Should scale hour and smaller units (seconds will hardly affect visible result...)
                  fractionalHours = croppedHours + date.getMinutes() / 60,
                      // Number of hours from the center    |xxxx|123c----|xxx|
                  hoursFromCenter = center - fractionalHours,
                      // Step from center to stretch event  |x|112233c----|xxx|
                  newHours = center - hoursFromCenter * lengthFactor; // Adding instead of setting to get a clone of the date, to not affect the original

                  date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].add(date, newHours - originalHours, 'h');
                  tickChanged = true;
                }

                if (include.day && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].compareUnits(unit, 'day') > 0) {
                  var _include$day = include.day,
                      _from = _include$day.from,
                      _to = _include$day.to,
                      _lengthFactor = _include$day.lengthFactor,
                      _center = _include$day.center; //region Crop

                  var checkDay = date.getDay(); // End date is exclusive, check the day before if at 00:00

                  if (isEnd && date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0 && date.getMilliseconds() === 0) {
                    if (--checkDay < 0) {
                      checkDay = 6;
                    }
                  }

                  var addDays = 0;

                  if (checkDay < _from || checkDay >= _to) {
                    // If end date is in view but start date is excluded, snap to next included day
                    if (snapToNextIncluded) {
                      // Step back to "to-1" (not inclusive) for end date
                      if (isEnd) {
                        addDays = (_to - checkDay - 8) % 7;
                      } // Step forward to "from" for start date
                      else {
                          addDays = (_from - checkDay + 7) % 7;
                        }

                      date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].add(date, addDays, 'd');
                      date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].startOf(date, 'd', false); // Keep end after start and vice versa

                      if (max && date.getTime() >= max || min && date.getTime() <= min) {
                        return -1;
                      }
                    } else {
                      // day excluded at not snapping to next
                      return -1;
                    }
                  } //endregion


                  var // Center to stretch around, for some reason pre-calculated cannot be used for sundays :)
                  fixedCenter = date.getDay() === 0 ? 0 : _center,
                      // Should scale day and smaller units (minutes will hardly affect visible result...)
                  fractionalDay = date.getDay() + date.getHours() / 24,
                      //+ dateClone.getMinutes() / (24 * 1440),
                  // Number of days from the calculated center
                  daysFromCenter = fixedCenter - fractionalDay,
                      // Step from center to stretch event
                  newDay = fixedCenter - daysFromCenter * _lengthFactor; // Adding instead of setting to get a clone of the date, to not affect the original

                  date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].add(date, newDay - fractionalDay + weekStartDay, 'd');
                  tickChanged = true;
                } // Now the date might start somewhere else (fraction of ticks)


                if (tickChanged) {
                  // When stretching date might end up outside of time axis, making it invalid to use. Clip it to time axis
                  // to circumvent this
                  date = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].constrain(date, timeAxis.startDate, timeAxis.endDate); // Get a new tick based on the "scaled" date

                  tick = timeAxis.getTickFromDate(date);
                }
              }

              return tick;
            }
            /**
             * Gets the date for a position on the time axis
             * @param {Number} position The page X or Y coordinate
             * @param {String} [roundingMethod] The rounding method to use
             * @returns {Date} the Date corresponding to the xy coordinate
             * @category Date mapping
             */

          }, {
            key: "getDateFromPosition",
            value: function getDateFromPosition(position, roundingMethod) {
              var me = this,
                  timeAxis = me.timeAxis,
                  tick = me.getScaledPosition(position) / me.tickSize + timeAxis.visibleTickStart;

              if (tick < 0 || tick > timeAxis.count) {
                return null;
              }

              return timeAxis.getDateFromTick(tick, roundingMethod);
            } // Translates a position along the time axis to facilitate scaling events when excluding certain days or hours

          }, {
            key: "getScaledPosition",
            value: function getScaledPosition(position) {
              var _this$timeAxis = this.timeAxis,
                  include = _this$timeAxis.include,
                  unit = _this$timeAxis.unit,
                  weekStartDay = _this$timeAxis.weekStartDay; // Calculations are

              if (include) {
                var dayWidth = this.getSingleUnitInPixels('day'); // Have to calculate day before hour to get end result correct

                if (include.day && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].compareUnits(unit, 'day') > 0) {
                  var _include$day2 = include.day,
                      from = _include$day2.from,
                      lengthFactor = _include$day2.lengthFactor,
                      positionInWeek = position % (dayWidth * 7),
                      weekStartPosition = position - positionInWeek; // Scale position using calculated length per day factor, adding the width of excluded days

                  position = positionInWeek / lengthFactor + (from - weekStartDay) * dayWidth + weekStartPosition;
                } // Hours are not taken into account when viewing days, since the day ticks are reconfigured in
                // `generateTicks` instead


                if (include.hour && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].compareUnits(unit, 'hour') > 0 && unit !== 'day') {
                  var _include$hour2 = include.hour,
                      _from2 = _include$hour2.from,
                      lengthFactorExcl = _include$hour2.lengthFactorExcl,
                      hourWidth = this.getSingleUnitInPixels('hour'),
                      positionInDay = position % dayWidth,
                      dayStartPosition = position - positionInDay; // Scale position using calculated length per day factor, adding the width of excluded hours

                  position = positionInDay / lengthFactorExcl + _from2 * hourWidth + dayStartPosition;
                }
              }

              return position;
            }
            /**
             * Returns the amount of pixels for a single unit
             * @internal
             * @return {Number} The unit in pixel
             */

          }, {
            key: "getSingleUnitInPixels",
            value: function getSingleUnitInPixels(unit) {
              var me = this;
              return me.unitToPixelsCache[unit] || (me.unitToPixelsCache[unit] = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getUnitToBaseUnitRatio(me.timeAxis.unit, unit, true) * me.tickSize / me.timeAxis.increment);
            }
            /**
             * [Experimental] Returns the pixel increment for the current view resolution.
             * @internal
             * @return {Number} The increment
             */

          }, {
            key: "setTickSize",
            value: function setTickSize(size, suppressEvent) {
              this._tickSize = this.originalTickSize = size;
              this.update(undefined, suppressEvent);
            }
          }, {
            key: "calculateTickSize",
            // Calculates the time column width/height based on the value defined viewPreset "tickWidth/tickHeight". It also
            // checks for the forceFit view option and the snap, both of which impose constraints on the time column width
            // configuration.
            value: function calculateTickSize(proposedSize) {
              var me = this,
                  forceFit = me.forceFit,
                  timeAxis = me.timeAxis,
                  timelineUnit = timeAxis.unit;
              var size = 0,
                  ratio = 1; //Number.MAX_VALUE;

              if (me.snap) {
                var resolution = timeAxis.resolution;
                ratio = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].getUnitToBaseUnitRatio(timelineUnit, resolution.unit) * resolution.increment;
              } // else {
              //     const measuringUnit = DH.getMeasuringUnit(timelineUnit);
              //     Math.min(ratio, DH.getUnitToBaseUnitRatio(timelineUnit, measuringUnit));
              // }


              if (!me.suppressFit) {
                var ticks = timeAxis.visibleTickTimeSpan,
                    // TODO: change this to always floor if we want to prevent scheduler scroll when not really needed
                fittingSize = Math[forceFit ? 'floor' : 'round'](me.availableSpace / ticks);
                size = forceFit || proposedSize < fittingSize ? fittingSize : proposedSize;

                if (ratio > 0 && (!forceFit || ratio < 1)) {
                  // For touch, make sure we always fill the available space with forceFit (to not show edges of side-time-pickers)
                  var method = forceFit ? 'floor' : 'round';
                  size = Math.round(Math.max(1, Math[method](ratio * size)) / ratio);
                }
              } else {
                size = proposedSize;
              }

              return size;
            }
            /**
             * Returns the total width/height of the time axis representation, depending on mode.
             * @return {Number} The width or height
             * @internal
             * @readonly
             */

          }, {
            key: "getDates",
            //endregion
            //region Fitting & snapping

            /**
             * Returns start dates for ticks at the specified level in format { date, isMajor }.
             * @param {String} level Level in headerConfig (top, bottom, middle)
             * @param {Boolean} useLowestHeader Use lowest level
             * @param getEnd
             * @returns {Array}
             * @internal
             */
            value: function getDates() {
              var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.columnLinesFor;
              var useLowestHeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var getEnd = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

              var me = this,
                  ticks = [],
                  linesForLevel = useLowestHeader ? me.lowestHeader : level,
                  majorLevel = me.majorHeaderName,
                  levelUnit = me.headerConfig && me.headerConfig[level].unit,
                  majorUnit = majorLevel && me.headerConfig && me.headerConfig[majorLevel].unit,
                  validMajor = majorLevel && _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].doesUnitsAlign(majorUnit, levelUnit),
                  hasGenerator = !!(me.headerConfig && me.headerConfig[linesForLevel].cellGenerator);

              if (hasGenerator) {
                var cells = me.columnConfig[linesForLevel];

                for (var i = 1, l = cells.length; i < l; i++) {
                  ticks.push({
                    date: cells[i].startDate
                  });
                }
              } else {
                me.forEachInterval(linesForLevel, function (start, end) {
                  ticks.push({
                    date: getEnd ? end : start,
                    // do not want to consider tick to be major tick, hence the check for majorHeaderName
                    isMajor: majorLevel !== level && validMajor && me.isMajorTick(getEnd ? end : start)
                  });
                });
              }

              return ticks;
            }
          }, {
            key: "fitToAvailableSpace",

            /**
             * This function fits the time columns into the available space in the time axis column.
             * @param {Boolean} suppressEvent `true` to skip firing the 'update' event.
             * @internal
             */
            value: function fitToAvailableSpace(suppressEvent) {
              var proposedSize = Math.floor(this.availableSpace / this.timeAxis.visibleTickTimeSpan);
              this.setTickSize(proposedSize, suppressEvent);
            }
          }, {
            key: "createHeaderRow",
            //endregion
            //region Headers
            // private
            value: function createHeaderRow(position, headerRowConfig) {
              var _this = this;

              var me = this,
                  cells = [],
                  align = headerRowConfig.align,
                  today = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].clearTime(new Date()),
                  headerCellCls = headerRowConfig.headerCellCls || '';

              var size = 0;
              me.headersDatesCache[position] = {};
              me.forEachInterval(position, function (start, end, i) {
                var value = _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].format(start, headerRowConfig.dateFormat),
                    cellData = {
                  align: align,
                  start: start,
                  end: end,
                  value: value,
                  headerCellCls: headerCellCls,
                  width: _this.getDistanceBetweenDates(start, end),
                  index: i
                };

                if (cellData.width === 0) {
                  return;
                } // Vertical mode uses absolute positioning for header cells


                cellData.coord = size;
                size += cellData.width;
                me.headersDatesCache[position][start.getTime()] = 1;

                if (headerRowConfig.renderer) {
                  value = headerRowConfig.renderer.call(headerRowConfig.thisObj || me, start, end, cellData, i, me.eventStore);
                  cellData.value = value == null ? '' : value;
                } // To be able to style individual day cells, weekends or other important days


                if (headerRowConfig.unit === 'day' && (!headerRowConfig.increment || headerRowConfig.increment === 1)) {
                  cellData.headerCellCls += ' b-sch-dayheadercell-' + start.getDay();

                  if (me.calendar && me.calendar.isWeekend(start)) {
                    cellData.headerCellCls += ' b-sch-dayheadercell-nonworking';
                  }

                  if (_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_8__["default"].clearTime(start, true) - today === 0) {
                    cellData.headerCellCls += ' b-sch-dayheadercell-today';
                  }
                }

                cells.push(cellData);
              });
              return cells;
            }
          }, {
            key: "isMajorTick",
            //endregion
            //region Ticks

            /**
             * For vertical view (and column lines plugin) we sometimes want to know if current tick starts along with the
             * upper header level.
             * @param {Date} date
             * @return {Boolean}
             * @private
             */
            value: function isMajorTick(date) {
              var nextLevel = this.majorHeaderName; // if forceFit is used headersDatesCache won´t have been generated yet on the first call here,
              // since no size is set yet

              return nextLevel && this.headersDatesCache[nextLevel] && this.headersDatesCache[nextLevel][date.getTime()] || false;
            }
            /**
             * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
             * Return false to break the iteration.
             * @param {String} position 'main' (middle), 'top' or 'bottom'
             * @param {Function} iteratorFn The function to call, will be called with start date, end date and "tick index"
             * @param {Object} [thisObj] `this` reference for the function
             * @internal
             */

          }, {
            key: "forEachInterval",
            value: function forEachInterval(position, iteratorFn) {
              var thisObj = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this;
              var headerConfig = this.headerConfig;
              if (!headerConfig) return; // Not initialized

              if (position === 'top' || position === 'middle' && headerConfig.bottom) {
                var header = headerConfig[position];
                this.timeAxis.forEachAuxInterval(header.unit, header.increment, iteratorFn, thisObj);
              } else {
                // This is the lowest header row, which should be fed the data in the tickStore (or a row above using same unit)
                this.timeAxis.forEach(function (r, index) {
                  return iteratorFn.call(thisObj, r.startDate, r.endDate, index);
                });
              }
            }
            /**
             * Calls the supplied iterator function once per interval. The function will be called with three parameters, start date and end date and an index.
             * Return false to break the iteration.
             * @internal
             * @param {Function} iteratorFn The function to call
             * @param {Object} [thisObj] `this` reference for the function
             */

          }, {
            key: "forEachMainInterval",
            value: function forEachMainInterval(iteratorFn, thisObj) {
              this.forEachInterval('middle', iteratorFn, thisObj);
            } //endregion
            //region ViewPreset

          }, {
            key: "consumeViewPreset",
            value: function consumeViewPreset(preset) {
              var me = this; // clear the cached headers

              me._headers = null;

              me._thisIsAUsedExpression(me.tickSize); // Since we are bypassing the tickSize setter below, ensure that
              // the config initial setter has been removed by referencing the property.
              // We only do this to avoid multiple updates from this. TODO: Fix this issue,
              // and do not bypass setters.


              me._viewPreset = preset;
              Object.assign(me, {
                headerConfig: preset.headerConfig,
                columnLinesFor: preset.columnLinesFor || 'middle',
                _tickSize: me.isHorizontal ? preset.tickWidth : preset.tickHeight
              });
              me.originalTickSize = me.tickSize;
            } //endregion
            // //region Calendar
            //
            // setCalendar(cal) {
            //     if (cal !== this.calendar) {
            //         this.calendar = cal;
            //
            //         if (cal) {
            //             this.update();
            //         }
            //     }
            // }
            //
            // //endregion

          }, {
            key: "columnConfig",
            get: function get() {
              return this._columnConfig;
            },
            set: function set(config) {
              this._columnConfig = config;
            } //endregion
            //region Events

            /**
             * Fires after the model has been updated.
             * @event update
             * @param {Scheduler.view.model.TimeAxisViewModel} source The model instance
             */

            /**
             * Fires after the model has been reconfigured.
             * @event reconfigure
             * @param {Scheduler.view.model.TimeAxisViewModel} source The model instance
             */
            //endregion
            //region Mode

            /**
             * Using horizontal mode?
             * @returns {Boolean}
             * @readonly
             * @internal
             */

          }, {
            key: "isHorizontal",
            get: function get() {
              return this.mode !== 'vertical';
            }
            /**
             * Using vertical mode?
             * @returns {Boolean}
             * @readonly
             * @internal
             */

          }, {
            key: "isVertical",
            get: function get() {
              return this.mode === 'vertical';
            }
            /**
             * Gets/sets the forceFit value for the model. Setting it will cause it to update its contents and fire the
             * {@link #event-update} event.
             * @property {Boolean}
             * @internal
             */

          }, {
            key: "forceFit",
            set: function set(value) {
              if (value !== this._forceFit) {
                this._forceFit = value;
                this.update();
              }
            },
            get: function get() {
              return this._forceFit;
            }
          }, {
            key: "snapPixelAmount",
            get: function get() {
              if (this.snap) {
                var resolution = this.timeAxis.resolution;
                return (resolution.increment || 1) * this.getSingleUnitInPixels(resolution.unit);
              } else {
                return 1;
              }
            } //endregion
            //region Sizes

            /**
             * Get/set the current time column size (the width or height of a cell in the bottom-most time axis header row,
             * depending on mode)
             * @internal
             * @property {Number}
             */

          }, {
            key: "tickSize",
            get: function get() {
              return this._tickSize;
            },
            set: function set(size) {
              this.setTickSize(size, false);
            }
          }, {
            key: "timeResolution",
            get: function get() {
              return this.timeAxis.resolution;
            }
          }, {
            key: "totalSize",
            get: function get() {
              return this._totalSize || (this._totalSize = Math.round(this.tickSize * this.timeAxis.visibleTickTimeSpan));
            }
            /**
             * Get/set the available space for the time axis representation. If size changes it will cause it to update its
             * contents and fire the {@link #event-update} event.
             * @internal
             * @property {Number}
             */

          }, {
            key: "availableSpace",
            get: function get() {
              return this._availableSpace;
            },
            set: function set(space) {
              var me = this; // We should only need to repaint fully if the tick width has changed (which will happen if forceFit is set, or if the full size of the time axis doesn't
              // occupy the available space - and gets stretched

              me._availableSpace = Math.max(0, space);

              if (me._availableSpace > 0) {
                var newTickSize = me.calculateTickSize(me.originalTickSize);

                if (newTickSize > 0 && newTickSize !== me.tickSize) {
                  me.update();
                }
              }
            }
          }, {
            key: "snap",
            get: function get() {
              return this._snap;
            }
            /**
             * Gets/sets the snap value for the model. Setting it will cause it to update its contents and fire the
             * {@link #event-update} event.
             * @property {Boolean}
             * @internal
             */
            ,
            set: function set(value) {
              if (value !== this._snap) {
                this._snap = value;
                if (this.configured) this.update();
              }
            }
          }, {
            key: "headers",
            get: function get() {
              var me = this;

              if (!me._headers) {
                var headers = me._headers = [],
                    _me$headerConfig = me.headerConfig,
                    top = _me$headerConfig.top,
                    middle = _me$headerConfig.middle,
                    bottom = _me$headerConfig.bottom;
                top && headers.push(top);
                middle && headers.push(middle);
                bottom && headers.push(bottom);
              }

              return me._headers;
            }
          }, {
            key: "mainHeader",
            get: function get() {
              // main header is always `middle` (which is always requires to present in `headerConfig`)
              return this.headerConfig.middle;
            }
          }, {
            key: "bottomHeader",
            get: function get() {
              return this.headers[this.headers.length - 1];
            }
          }, {
            key: "lowestHeader",
            get: function get() {
              return 'bottom' in this.headerConfig ? 'bottom' : 'middle';
            }
            /**
             * This method is meant to return name of the header which 2nd lowest. It is used for {@link #function-isMajorTick} method
             * @return {String}
             * @private
             */

          }, {
            key: "majorHeaderName",
            get: function get() {
              var headerConfig = this.headerConfig; // If there's a bottom header - return middle one as it's required

              if (headerConfig.bottom) {
                return 'middle';
              } // if there is a top header - return that, because middle is required and we do not have bottom for sure


              if (headerConfig.top) {
                return 'top';
              }

              return null;
            }
          }], [{
            key: "defaultConfig",
            //region Default config
            // TODO: replace _availableSpace etc with availableSpace in config and make setters work during config phase
            get: function get() {
              return {
                /**
                 * The time axis providing the underlying data to be visualized
                 * @config {Scheduler.data.TimeAxis}
                 * @internal
                 */
                timeAxis: null,

                /**
                 * The available width/height, this is normally not known by the consuming UI component using this model
                 * class until it has been fully rendered. The consumer of this model should set
                 * {@link #property-availableSpace} when its width has changed.
                 * @config {Number}
                 * @internal
                 */
                availableSpace: null,

                /**
                 * The "tick width" for horizontal mode or "tick height" for vertical mode, to use for the cells in the
                 * bottom most header row.
                 * This value is normally read from the {@link Scheduler.preset.ViewPreset viewPreset}
                 * @config {Number}
                 * @default
                 * @internal
                 */
                tickSize: 100,

                /**
                 * true if there is a requirement to be able to snap events to a certain view resolution.
                 * This has implications of the {@link #config-tickSize} that can be used, since all widths must be in even pixels.
                 * @config {Boolean}
                 * @default
                 * @internal
                 */
                snap: false,

                /**
                 * true if cells in the bottom-most row should be fitted to the {@link #property-availableSpace available space}.
                 * @config {Boolean}
                 * @default
                 * @internal
                 */
                forceFit: false,
                headerConfig: null,
                calendar: null,
                mode: 'horizontal',
                // or 'vertical'
                //used for Exporting. Make sure the tick columns are not recalculated when resizing.
                suppressFit: false,
                // cache of the config currently used.
                columnConfig: {},
                // the view preset name to apply initially
                viewPreset: null,
                // The default header level to draw column lines for
                columnLinesFor: 'middle',
                // To give a link to the eventStore inside the header renderer if provided
                eventStore: null,
                originalTickSize: null,
                headersDatesCache: {}
              };
            }
          }]);

          return TimeAxisViewModel;
        }(Object(_Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_9__["default"])());

        TimeAxisViewModel._$name = 'TimeAxisViewModel';
        /***/
      },

      /***/
      "./lib/Scheduler/view/orientation/BaseHorizontalMapper.js":
      /*!****************************************************************!*\
        !*** ./lib/Scheduler/view/orientation/BaseHorizontalMapper.js ***!
        \****************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewOrientationBaseHorizontalMapperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return BaseHorizontalMapper;
        });
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es7.symbol.async-iterator */
        "./node_modules/core-js/modules/es7.symbol.async-iterator.js");
        /* harmony import */


        var core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_symbol_async_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.symbol */
        "./node_modules/core-js/modules/es6.symbol.js");
        /* harmony import */


        var core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_symbol__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.array.find */
        "./node_modules/core-js/modules/es6.array.find.js");
        /* harmony import */


        var core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_find__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");
        /* harmony import */


        var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es7.array.includes */
        "./node_modules/core-js/modules/es7.array.includes.js");
        /* harmony import */


        var core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_array_includes__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es6.string.includes */
        "./node_modules/core-js/modules/es6.string.includes.js");
        /* harmony import */


        var core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_includes__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../../Common/data/DomDataStore.js */
        "../Grid/lib/Common/data/DomDataStore.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_util_Bag_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../../Common/util/Bag.js */
        "../Grid/lib/Common/util/Bag.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/orientation/BaseHorizontalMapper
         */

        var emptyObject = {},
            elRange = document.createRange(),
            MAX_WIDTH = 9999999;

        function isEventElAvailable(element) {
          return !(element.classList.contains('b-dragging') || element.classList.contains('b-resizing'));
        }
        /**
         * Base class for task & event rendering in horizontal mode, used by Scheduler and Gantt
         * @private
         * @abstract
         */


        var BaseHorizontalMapper =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_12___default()(BaseHorizontalMapper, _Delayable);

          function BaseHorizontalMapper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, BaseHorizontalMapper);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(BaseHorizontalMapper).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(BaseHorizontalMapper, [{
            key: "construct",
            //region Init
            value: function construct(view) {
              var me = this;
              me.view = view;
              me.innerElCls = "".concat(view.eventCls);
              me.availableDivs = new _Common_util_Bag_js__WEBPACK_IMPORTED_MODULE_19__["default"]();
              me.reservedIds = {};
              me.divCount = 0;
            }
          }, {
            key: "init",
            value: function init() {
              var me = this;
              me.view.rowManager.on({
                beforetranslaterow: me.onBeforeTranslateRow,
                translaterow: me.onTranslateRow,
                beforerowheight: me.onBeforeRowHeightChange,
                thisObj: me
              });
              me.view.on({
                beforetogglenode: me.onBeforeToggleNode,
                togglenode: me.onToggleNode,
                beforetoggleallnodes: me.onBeforeToggleAllNodes,
                toggleallnodes: me.onToggleAllNodes,
                thisObj: me
              });
            } //endregion
            //region Helpers

          }, {
            key: "translateToPageCoordinate",
            value: function translateToPageCoordinate(x) {
              var element = this.column.subGridElement;
              return x + element.getBoundingClientRect().left - element.scrollLeft;
            } //endregion
            //Region View hooks

          }, {
            key: "refreshRows",
            value: function refreshRows(reLayoutEvents) {
              if (reLayoutEvents) {
                this.cache.clear(this.refreshFromRerender);
                this.view.refreshFromRerender = false;
              }
            } // If we dragged an event outside of its rendered block, it will have been released
            // but releaseTimeSpanDiv won't hide it if it has b-dragging, so we have to
            // hide it now.

          }, {
            key: "onDragAbort",
            value: function onDragAbort(context) {
              if (this.view.currentOrientation.availableDivs.includes(context.element)) {
                context.element.classList.add('b-sch-released');
              }
            }
          }, {
            key: "onLocaleChange",
            value: function onLocaleChange() {
              // Clear events in case they use date as part of displayed info
              this.cache.clear();
            } //endregion
            //region Layout & render

            /**
             * Converts a start/endDate into a MS value used when rendering the timeSpan
             * @private
             * @abstract
             */

          }, {
            key: "calculateMS",
            value: function calculateMS(timespanRecord) {
              throw new Error('Implement in subclass');
            }
            /**
             * Gets timespan coordinates etc. Relative to containing row. If the timespan is outside of the zone in
             * which timespans are rendered, that is outside of the TimeAxis, or outside of the vertical zone in which timespans
             * are rendered, then `undefined` is returned.
             * @private
             * @param {Scheduler.model.TimeSpan} timeSpan TimeSpan record
             * @param {Common.data.Model} rowRecord Row record
             * @param {Boolean|Object} includeOutside Specify true to get boxes for timespans outside of the rendered zone in both
             * dimensions. This option is used when calculating dependency lines, and we need to include routes from timespans
             * which may be outside the rendered zone.
             * @param {Boolean} includeOutside.timeAxis Pass as `true` to include timespans outside of the TimeAxis's bounds
             * @param {Boolean} includeOutside.viewport Pass as `true` to include timespans outside of the vertical timespan viewport's bounds.
             * @returns {{event/task: *, left: number, width: number, start: (Date), end: (Date), startMs: number, endMs: number, startsOutsideView: boolean, endsOutsideView: boolean}}
             */

          }, {
            key: "getTimeSpanRenderData",
            value: function getTimeSpanRenderData(timeSpan, rowRecord) {
              var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  timeAxis = me.timeAxis,
                  includeOutsideTimeAxis = includeOutside === true || includeOutside.timeAxis,
                  includeOutsideViewport = includeOutside === true || includeOutside.viewport; // If timespan is outside the TimeAxis, give up trying to calculate a layout (Unless we're including timespans
              // outside our zone)

              if (includeOutsideTimeAxis || timeAxis.isTimeSpanInAxis(timeSpan)) {
                var view = me.view,
                    row = view.getRowById(rowRecord); // If row is outside the rendered block, we cannot compute a timespan layout.

                if (row || includeOutsideViewport) {
                  // TODO: buffer size as config
                  var scrollTop = view.scrollable.y,
                      viewportTop = Math.max(scrollTop - 50, 0),
                      viewportBottom = Math.min(scrollTop + view._bodyRectangle.height + 50, view.virtualScrollHeight); // If the row is outside the zone in which we render timespans, give up trying to calculate a
                  // layout (Unless we're including timespans outside our zone)

                  if (includeOutsideViewport || row.top < viewportBottom && row.top + (row.height || row.lastHeight) >= viewportTop) {
                    var _data;

                    var pxPerMinute = me.timeAxisViewModel.getSingleUnitInPixels('minute'),
                        timespanStart = timeSpan.startDate,
                        timespanEnd = timeSpan.endDate || timespanStart,
                        viewStartMS = timeAxis.startMS,
                        viewEndMS = timeAxis.endMS,
                        _me$calculateMS = me.calculateMS(timeSpan),
                        startMS = _me$calculateMS.startMS,
                        endMS = _me$calculateMS.endMS,
                        durationMS = _me$calculateMS.durationMS,
                        startsOutsideView = startMS < viewStartMS | (startMS > viewEndMS) << 1,
                        endsOutsideView = endMS > viewEndMS | (endMS <= viewStartMS) << 1,
                        durationMinutes = durationMS / (1000 * 60),
                        width = endsOutsideView ? pxPerMinute * durationMinutes : null; //view.getCoordinateFromDate(viewStartMS + durationMS),


                    var endX = view.getCoordinateFromDate(endMS, {
                      local: true,
                      respectExclusion: true,
                      isEnd: true
                    }),
                        startX,
                        clippedStart = false,
                        clippedEnd = false; // If event starts outside of view, estimate where.

                    if (startsOutsideView) {
                      startX = (startMS - viewStartMS) / (1000 * 60) * pxPerMinute;
                    } // Starts in view, calculate exactly
                    else {
                        // If end date is included in time axis but start date is not (when using time axis exclusions), snap start date to next included data
                        startX = view.getCoordinateFromDate(startMS, {
                          local: true,
                          respectExclusion: true,
                          isEnd: false,
                          snapToNextIncluded: endX !== -1
                        });
                        clippedStart = startX === -1;
                      }

                    if (endsOutsideView) {
                      endX = startX + width;
                    } else {
                      clippedEnd = endX === -1;
                    }

                    if (clippedEnd && !clippedStart) {
                      // We know where to start but not where to end, snap it (the opposite is already handled by the
                      // snapToNextIncluded flag when calculating startX above)
                      endX = view.getCoordinateFromDate(endMS, {
                        local: true,
                        respectExclusion: true,
                        isEnd: true,
                        snapToNextIncluded: true
                      });
                    } // If the element is very wide there's no point in displaying it all.
                    // Indeed the element may not be displayable at extremely large widths.


                    if (width > MAX_WIDTH) {
                      // The start is before the TimeAxis start
                      if (startsOutsideView === 1) {
                        // Both ends outside - spans TimeAxis
                        if (endsOutsideView === 1) {
                          startX = -100;
                          endX = view.timeAxisColumn.width + 100;
                        } // End is in view
                        else {
                            startX = endX - MAX_WIDTH;
                          }
                      } // The end is after, but the start is in view
                      else if (endsOutsideView === 1) {
                          endX = startX + MAX_WIDTH;
                        }
                    }

                    if (clippedStart && clippedEnd) {
                      // Both ends excluded, but there might be some part in between that should be displayed...
                      startX = view.getCoordinateFromDate(startMS, {
                        local: true,
                        respectExclusion: true,
                        isEnd: false,
                        snapToNextIncluded: true,
                        max: endMS
                      });
                      endX = view.getCoordinateFromDate(endMS, {
                        local: true,
                        respectExclusion: true,
                        isEnd: true,
                        snapToNextIncluded: true,
                        min: startMS
                      });

                      if (startX === endX) {
                        // Raise flag on instance meta to avoid duplicating this logic
                        timeSpan.instanceMeta(view).excluded = true; // Excluded by time axis exclusion rules, render nothing

                        return null;
                      }
                    }

                    var data = (_data = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, me.view.scheduledEventName, timeSpan), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "left", Math.min(startX, endX)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "width", Math.abs(endX - startX)), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "start", timespanStart), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "end", timespanEnd), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "startMs", startMS), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "endMs", endMS), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "rowId", rowRecord.id), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "startsOutsideView", startsOutsideView), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "endsOutsideView", endsOutsideView), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "clippedStart", clippedStart), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "clippedEnd", clippedEnd), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_5___default()(_data, "row", row), _data); // If filling ticks we need to also keep datas MS values, since they are used for sorting timespans

                    if (me.view.fillTicks) {
                      data.dataStartMs = data.start.getTime();
                      data.dataEndMs = data.end.getTime();
                    } // in ExtScheduler this is only checked when managedEventSizing is true, but we need top because of positioning


                    data.top = Math.max(0, view.resourceMargin);

                    if (view.managedEventSizing) {
                      // Timespan height should be at least 1px
                      data.height = Math.max(view.rowManager.rowHeight - 2 * view.resourceMargin, 1);
                    }

                    return data;
                  }
                }
              }
            }
          }, {
            key: "onTranslateRow",
            value: function onTranslateRow(_ref) {
              var row = _ref.source;
            }
          }, {
            key: "onBeforeRowHeightChange",
            value: function onBeforeRowHeightChange(event) {
              var view = this.view,
                  newHeight = event ? event.height : this.rowHeight;
              this.cache.clear(); // TODO: should move out of here to scheduler

              if (view.foregroundCanvas) {
                view.element.classList.add('b-notransition');
                view.foregroundCanvas.style.fontSize = "".concat(newHeight - view.resourceMargin * 2, "px"); // We must force a style recalculation so that the next measurement of milestoneWidth
                // gets the new value.

                this._thisIsAUsedExpression(window.getComputedStyle(view.foregroundCanvas).fontSize);

                view.element.classList.remove('b-notransition');
              } // The Dependencies feature will have to recalculate its milestoneWidth when it is refreshed next.


              view.milestoneWidth = null;
            }
          }, {
            key: "onBeforeTranslateRow",
            value: function onBeforeTranslateRow(_ref2) {
              var row = _ref2.row; // Triggered before row is repurposed with new record on scroll.
              // Clear layout for the outgoing record.

              this.cache.clearRow(row.id);
            }
          }, {
            key: "onViewportResize",
            value: function onViewportResize() {
              // Force layout even if scroll positions have not changed.
              this.lastUpdateScrollPos = null; // Update the layout.

              this.update();
            } // /**
            //  * Called when all rows are rerendered, following a sort operation etc.
            //  * @private
            //  */
            // onBeforeFullRender() {
            //     this.cache.clear();
            // }

          }, {
            key: "positionTimeSpan",
            value: function positionTimeSpan(el, x, y) {
              var mode = this.view.eventPositionMode || 'translate';

              switch (mode) {
                case 'position':
                  el.style.left = "".concat(x, "px");
                  el.style.top = "".concat(y, "px");
                  return;

                case 'translate':
                  el.style.transform = "translate(".concat(x, "px,").concat(y, "px)");
                  return;

                case 'translate3d':
                  el.style.transform = "translate3d(".concat(x, "px,").concat(y, "px,0)");
              }
            }
          }, {
            key: "getTimeSpanDiv",
            value: function getTimeSpanDiv(timeSpanData) {
              var me = this,
                  availableDivs = me.availableDivs,
                  id = timeSpanData.id,
                  oldId = timeSpanData.oldId;

              if (me.view.eventScrollMode === 'move') {
                var wrapperElement; // Allow a TimeSpan to reuse the last div that was assigned to it so that transitions may be used when
                // editing an event. Will fallback to old id, to cover cases where id has changed since last update

                if (id) {
                  wrapperElement = availableDivs.get(id) || availableDivs.get(oldId);
                } // Do not return it if it's in use by drag/drop or resize


                if (wrapperElement && !isEventElAvailable(wrapperElement)) {
                  wrapperElement = null;
                } // No element which matches the requested element id available.
                // Just allocate one from the cache which is not being dragged or resized.


                if (!wrapperElement) {
                  wrapperElement = availableDivs.find(isEventElAvailable);
                }

                if (wrapperElement) {
                  availableDivs.remove(wrapperElement);
                  wrapperElement.classList.remove('b-sch-released');
                }

                return wrapperElement;
              }

              return null;
            }
          }, {
            key: "releaseTimeSpanDiv",
            value: function releaseTimeSpanDiv(div) {
              var remainVisible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var me = this,
                  divStyle = div.style;

              if (me.view.eventScrollMode === 'move') {
                me.availableDivs.add(div);

                if (!remainVisible && isEventElAvailable(div)) {
                  div.classList.add('b-sch-released');
                }
              } else {
                if (!remainVisible) {
                  divStyle.opacity = 0;
                  divStyle.pointerEvents = 'none';
                  me.setTimeout(function () {
                    div.remove();
                    divStyle.opacity = 1;
                    divStyle.pointerEvents = '';
                  }, 200);
                }
              }
            }
          }, {
            key: "updateElementId",
            value: function updateElementId(element, newId) {
              var availableDivs = this.availableDivs; // Change the id, and move it to the end so that it won't be immediately
              // be consumed by the next request for an element, but is more likely to
              // remain to be found by its original owner TimeSpan

              if (availableDivs.includes(element)) {
                availableDivs.changeId(element, newId); // Used to be Collection.move(). Deleting and adding to end of Bags Set to mimic

                availableDivs.items.delete(element);
                availableDivs.items.add(element);
              }
            }
          }, {
            key: "triggerPaint",
            value: function triggerPaint(data, element) {
              throw new Error('Implement in subclass');
            } // forceNewElement is true for newly added events, to not "steal" an element that might be needed later on in the
            // same row (which triggers a transition from that location to the new)

          }, {
            key: "renderTimeSpan",
            value: function renderTimeSpan(data, cache, renderedTimeSpan) {
              var forceNewElement = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var me = this,
                  view = me.view;
              var cls = data.cls,
                  id = data.id,
                  wrapperElement = cache && cache.div,
                  changedDiv = false,
                  isDragCreateProxy,
                  trigger = false,
                  isRepaint = false,
                  innerElement = cache && cache.eventEl; // TODO: this fn should not need to be called for events already in view, unless there is some update. might give a little better performance
              // No div assigned, reuse one if possible and such mode is used

              if (!forceNewElement && !wrapperElement && (wrapperElement = me.getTimeSpanDiv(data))) {
                // changedDiv means that we're using somebody else's element.
                changedDiv = wrapperElement.id !== id;
              }

              isDragCreateProxy = wrapperElement && wrapperElement.classList.contains('b-sch-dragcreator-proxy'); // No div assigned or reusing some other TimeSpan's released div

              if (!wrapperElement || changedDiv) {
                // Reusing another TimeSpan's released element.
                // It needs to be emptied.
                if (changedDiv) {
                  // If there's no .b-sch-event, then it could be a resourceTimeRange element
                  // so just use firstElementChild.
                  innerElement = wrapperElement.innerElement || wrapperElement.firstElementChild;
                  innerElement.innerHTML = '';
                  innerElement.style.cssText = '';

                  if (innerElement.nextSibling) {
                    elRange.setStartAfter(innerElement);
                    elRange.setEndAfter(wrapperElement.lastChild);
                    elRange.deleteContents();
                  }
                } // New element needed
                else {
                    var _DomHelper$createElem = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].createElement({
                      tabIndex: 0,
                      // adding inner div which will be rendered as the event
                      children: [{
                        className: "".concat(me.innerElCls)
                      }]
                    }, true);

                    var _DomHelper$createElem2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_3___default()(_DomHelper$createElem, 2);

                    wrapperElement = _DomHelper$createElem2[0];
                    innerElement = _DomHelper$createElem2[1]; // To not have to retrieve it from DOM later

                    wrapperElement.innerElement = innerElement;
                  }

                wrapperElement.id = id; // Add event/task id to wrappers dataset

                if (data[view.scheduledEventName + 'Id']) {
                  wrapperElement.dataset[view.scheduledEventName + 'Id'] = data[view.scheduledEventName + 'Id'];
                }

                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].syncClassList(wrapperElement, data.wrapperCls);

                if (wrapperElement.parentNode !== view.foregroundCanvas) {
                  view.foregroundCanvas.appendChild(wrapperElement);
                } // set all attributes


                _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].syncClassList(innerElement, cls);

                if (data.style || data.internalStyle) {
                  innerElement.style.cssText = (data.internalStyle || '') + (data.style || '');
                } // Only update content if the data block has new content in it


                if (data.body) {
                  // Clone because this operation has to be repeatable
                  innerElement.appendChild(data.body.cloneNode(true));
                } // positioning and sizing wrapper


                wrapperElement.style.cssText = "width:".concat(data.width, "px;height:").concat(data.height, "px;").concat(data.wrapperStyle || '');
                me.positionTimeSpan(wrapperElement, data.left, data.top);
                trigger = true;
              } // Reusing TimeSpan's own div - it's a repaint
              else {
                  // has div, update attributes if needed.
                  var old = renderedTimeSpan && cache.div ? renderedTimeSpan : emptyObject;
                  innerElement = wrapperElement.querySelector(".".concat(me.innerElCls)) || wrapperElement.firstElementChild; // We are updating an existing event here, it may have lifecycle classes
                  // such as resizing, or terminals visible etc.
                  // Surgically update the class list of the elements.

                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].syncClassList(wrapperElement, data.wrapperCls);

                  _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].syncClassList(innerElement, data.cls); // TODO: have to apply style on each update when specified, or store it and check if changed


                  if (data.style) {
                    innerElement.style.cssText = data.style;
                  } // Clear style, might have changed from having a style to not having
                  else {
                      innerElement.style.cssText = '';
                    } // Only update content if the data block has new content in it


                  if (data.body) {
                    var oldInnerHTML = innerElement.innerHTML,
                        // TODO: Not in use? Should be used by labels? Percent bar in gantt? Store them in an array to avoid QSA
                    featureEls = innerElement.featureEls; //innerElement.querySelectorAll('[data-feature]');

                    if (featureEls) {
                      featureEls.forEach(function (featureEl) {
                        return data.body.appendChild(featureEl);
                      });
                    }

                    innerElement.innerHTML = ''; // Clone because this operation has to be repeatable

                    innerElement.appendChild(data.body.cloneNode(true)); // trigger only if content changed

                    trigger = innerElement.innerHTML !== oldInnerHTML;
                  } // Wrapper element gets the focus class.


                  if (document.activeElement && document.activeElement.id === data.id) {
                    wrapperElement.classList.add(view.focusCls);
                  } // updates to wrapper


                  isRepaint = true;

                  if (data.wrapperStyle) {
                    wrapperElement.style.cssText += data.wrapperStyle;
                  }

                  if (old.left !== data.left || old.top !== data.top || data.style) {
                    me.positionTimeSpan(wrapperElement, data.left, data.top);
                    trigger = true;
                  }

                  if (old.width !== data.width || data.style) {
                    wrapperElement.style.width = "".concat(data.width, "px");
                    trigger = true;
                  }

                  if (old.height !== data.height || data.style) {
                    wrapperElement.style.height = "".concat(data.height, "px");
                    trigger = true;
                  }
                }

              cache.div = wrapperElement;
              cache.eventEl = innerElement;

              if (trigger) {
                // If we are rendering to a drag-create proxy, it's not a repaint
                if (isRepaint && isDragCreateProxy) {
                  isRepaint = false;
                  wrapperElement.classList.remove('b-sch-dragcreator-proxy');
                } // trigger paint or repaint, for features to hook into


                me.triggerPaint(data, wrapperElement, isRepaint);
              }

              return wrapperElement;
            }
            /**
             * Adds an element for recycling to the event element recycling cache for the passed Event/Task if
             * there is no cache entry. Use this to prevent cache misses and the re-use by
             * event rendering of elements for other events which means that the element would have to be heavily
             * modified.
             * @param {Scheduler.model.TimeSpan} timeSpanRecord The event/task to create an element recycling cache entry for.
             * @param {Scheduler.model.ResourceModel} [resourceRecord] The associated resource record.
             * @param {HTMLElement} [element] The element to add to the element recycling cache under that id.
             */

          }, {
            key: "cacheTimeSpanElement",
            value: function cacheTimeSpanElement(timeSpanRecord, resourceRecord, element) {
              var me = this,
                  availableDivs = me.availableDivs,
                  view = me.view,
                  timeSpanRecordId = view.getEventRenderId(timeSpanRecord, resourceRecord);

              if (!availableDivs.includes(timeSpanRecordId)) {
                if (element) {
                  element.id = timeSpanRecordId;
                  view.foregroundCanvas.appendChild(element);
                } else {
                  element = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].createElement({
                    id: timeSpanRecordId,
                    tabIndex: 0,
                    // adding inner div which will be rendered as the event
                    children: [{
                      className: "".concat(me.innerElCls)
                    }]
                  });
                }

                availableDivs.add(element);
              }
            }
          }, {
            key: "updateRowTimeSpans",
            value: function updateRowTimeSpans(row, rowRecord) {
              var forceLayout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var fromHorizontalScroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            }
          }, {
            key: "renderer",
            value: function renderer(renderData) {}
          }, {
            key: "updateFromHorizontalScroll",
            value: function updateFromHorizontalScroll(scrollLeft) {
              var me = this,
                  view = me.view,
                  width = view.timeAxisSubGrid.width,
                  startDate = view.getDateFromX(Math.max(0, scrollLeft - 100)),
                  endDate = view.getDateFromX(scrollLeft + width + 100) || view.timeAxis.endDate,
                  x = me.view.timeAxisSubGrid.scrollable.x,
                  lastUpdateScrollPos = me.lastUpdateScrollPos; // TODO: make buffer width a config, add in correct unit

              me.viewportStart = startDate && startDate.getTime();
              me.viewportEnd = endDate && endDate.getTime(); // Only rerender all events if we have scrolled horizontally by at least half
              // of the buffer zone above which is 100 pixels.

              if (!lastUpdateScrollPos || Math.abs(x - lastUpdateScrollPos.x) > 50) {
                me.update();
              }
            }
          }, {
            key: "update",
            value: function update() {
              var me = this,
                  view = me.view;
              me.lastUpdateScrollPos = {
                x: view.timeAxisSubGrid.scrollable.x,
                y: view.scrollable.y
              };
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = view.rowManager[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var row = _step.value;

                  var cell = row.getCell(view.timeAxisColumn.id),
                      cellData = _Common_data_DomDataStore_js__WEBPACK_IMPORTED_MODULE_17__["default"].get(cell),
                      record = view.store.getById(cellData.id);

                  if (record) {
                    me.updateRowTimeSpans(cellData.row, record, false, true);
                  }
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } //endregion
            //region Dates

          }, {
            key: "getDateFromXY",
            value: function getDateFromXY(xy, roundingMethod, local) {
              var coord = xy[0];

              if (!local) {
                coord = this.translateToScheduleCoordinate(coord);
              }

              return this.timeAxisViewModel.getDateFromPosition(coord, roundingMethod);
            }
          }, {
            key: "translateToScheduleCoordinate",
            value: function translateToScheduleCoordinate(x) {
              var pos = x - this.column.subGridElement.getBoundingClientRect().left;
              return pos + this.view.scrollLeft;
            } //endregion
            //region Store events

            /**
             * User toggled a node in a tree grid, events needs to be redrawn since they might appear/disappear
             * @private
             */

          }, {
            key: "onBeforeToggleNode",
            value: function onBeforeToggleNode(_ref3) {
              var record = _ref3.record;
              var me = this,
                  childCount = record.children && record.children.length; // If there are no children to toggle, we must not clear below the
              // toggling line because there's going to be no upcoming data change to fix it.

              if (childCount) {
                // The node being toggled doesn't need events clearing.
                // It just has its expand/collapse icon toggled.
                var currentRowRecord = me.view.store.getNext(record);

                while (currentRowRecord && me.view.getRowFor(currentRowRecord)) {
                  me.cache.clearRow(currentRowRecord.id);
                  currentRowRecord = me.view.store.getNext(currentRowRecord.id);
                }
              } // Flag to force drawing all events within row buffer, needed since expanding rows do not give them their
              // height right away


              me.togglingNode = true;
            }
          }, {
            key: "onToggleNode",
            value: function onToggleNode() {
              // Ignore when toggling all nodes
              if (!this.togglingAllNodes) {
                this.togglingNode = false;
              }
            }
          }, {
            key: "onBeforeToggleAllNodes",
            value: function onBeforeToggleAllNodes() {
              this.cache.clear();
              this.togglingAllNodes = this.togglingNode = true;
            }
          }, {
            key: "onToggleAllNodes",
            value: function onToggleAllNodes() {
              this.togglingAllNodes = this.togglingNode = false;
            } // Row updated, clear cache keeping div to animate changes

          }, {
            key: "onRowRecordUpdate",
            value: function onRowRecordUpdate(_ref4) {
              var record = _ref4.record;
              this.cache.clearRow(record.id, false, true);
            } // Row removed (resource/task), clear cache

          }, {
            key: "onRowRecordRemove",
            value: function onRowRecordRemove(_ref5) {
              var _this = this;

              var records = _ref5.records; // Records might be parents, always traversing makes sure children are also cleared. For leafs, traverse only
              // affects the node itself. If a parent and its children are removed at once, it will still work since clearing
              // cache again has no side effects

              records.forEach(function (record) {
                return record.traverse(function (r) {
                  return _this.cache.clearRow(r.id);
                });
              });
            } //endregion
            //region Region

            /**
             * Gets the Region, relative to the timeline view element, representing the passed row and optionally just for a
             * certain date interval.
             * @param {Common.data.Model} rowRecord The row record
             * @param {Date} startDate A start date constraining the region
             * @param {Date} endDate An end date constraining the region
             * @return {Common.helper.util.Rectangle} The Rectangle which encapsulates the row
             */

          }, {
            key: "getRowRegion",
            value: function getRowRegion(rowRecord, startDate, endDate) {
              var view = this.view,
                  column = this.column,
                  row = view.getRowById(rowRecord.id); // might not be rendered

              if (!row) {
                return null;
              }

              var rowElement = row.getElement(column.region),
                  taStart = this.timeAxis.startDate,
                  taEnd = this.timeAxis.endDate,
                  start = startDate ? _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].max(taStart, startDate) : taStart,
                  end = endDate ? _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].min(taEnd, endDate) : taEnd,
                  startX = view.getCoordinateFromDate(start),
                  endX = view.getCoordinateFromDate(end, true, true),
                  y = row.top + view.verticalScroller.scrollTop,
                  x = Math.min(startX, endX),
                  bottom = y + rowElement.offsetHeight;
              return new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_15__["default"](x, y, Math.max(startX, endX) - x, bottom - y);
            }
            /**
             * Gets the start and end dates for an element rectangle
             * @param {Common.helper.util.Rectangle} rect The Rectangle to map to start and end dates
             * @param {String} roundingMethod The rounding method to use
             * @returns {Object} an object containing start/end properties
             */

          }, {
            key: "getStartEndDatesFromRectangle",
            value: function getStartEndDatesFromRectangle(rect, roundingMethod) {
              var view = this.view,
                  leftDate = view.getDateFromCoordinate(rect.x, roundingMethod, true),
                  rightDate = view.getDateFromCoordinate(rect.right, roundingMethod, true);

              if (leftDate && rightDate) {
                return {
                  start: _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].min(leftDate, rightDate),
                  end: _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].max(leftDate, rightDate)
                };
              }

              return null;
            }
          }, {
            key: "getVisibleDateRange",
            value: function getVisibleDateRange() {
              var view = this.view,
                  scrollPos = view.timeAxisSubGrid.scrollable.x,
                  width = view.timeAxisSubGrid.width;
              return {
                startDate: view.getDateFromX(scrollPos),
                endDate: view.getDateFromX(scrollPos + width) || view.timeAxis.endDate
              };
            } //endregion
            //region Dependency connectors

            /**
             * Gets displaying item start side
             *
             * @param {Scheduler.model.EventModel} eventRecord
             * @return {String} 'left' / 'right' / 'top' / 'bottom'
             */

          }, {
            key: "getConnectorStartSide",
            value: function getConnectorStartSide(eventRecord) {}
            /**
             * Gets displaying item end side
             *
             * @param {Scheduler.model.EventModel} eventRecord
             * @return {String} 'left' / 'right' / 'top' / 'bottom'
             */

          }, {
            key: "getConnectorEndSide",
            value: function getConnectorEndSide(eventRecord) {} //endregion

          }, {
            key: "column",
            get: function get() {
              return this.view.timeAxisColumn;
            }
          }, {
            key: "timeAxis",
            get: function get() {
              return this.view.timeAxis;
            }
          }, {
            key: "timeAxisViewModel",
            get: function get() {
              return this.view.timeAxisViewModel;
            }
          }]);

          return BaseHorizontalMapper;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_18__["default"])(_Common_Base_js__WEBPACK_IMPORTED_MODULE_13__["default"]));

        BaseHorizontalMapper._$name = 'BaseHorizontalMapper';
        /***/
      },

      /***/
      "./lib/Scheduler/view/orientation/HorizontalEventMapper.js":
      /*!*****************************************************************!*\
        !*** ./lib/Scheduler/view/orientation/HorizontalEventMapper.js ***!
        \*****************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewOrientationHorizontalEventMapperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HorizontalEventMapper;
        });
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _BaseHorizontalMapper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./BaseHorizontalMapper.js */
        "./lib/Scheduler/view/orientation/BaseHorizontalMapper.js");
        /* harmony import */


        var _HorizontalEventMapperCache_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./HorizontalEventMapperCache.js */
        "./lib/Scheduler/view/orientation/HorizontalEventMapperCache.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");

        var productName = 'scheduler';
        /**
         * @module Scheduler/view/orientation/HorizontalEventMapper
         */

        var getStartEnd = function getStartEnd(view, timeAxis, date, dateMS, useEnd) {
          if (view.fillTicks) {
            var tickIndex = Math.floor(timeAxis.getTickFromDate(date)),
                tick = timeAxis.getAt(tickIndex);

            if (tick) {
              return tick[useEnd ? 'endDate' : 'startDate'].getTime();
            }
          }

          return dateMS;
        };
        /**
         * Handles rendering of events when scheduler uses horizontal mode. The need to interact with this class should be
         * minimal, most functions are called from Scheduler or its mixins.
         * @private
         */


        var HorizontalEventMapper =
        /*#__PURE__*/
        function (_BaseHorizontalMapper) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_9___default()(HorizontalEventMapper, _BaseHorizontalMapper);

          function HorizontalEventMapper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4___default()(this, HorizontalEventMapper);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(HorizontalEventMapper).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_5___default()(HorizontalEventMapper, [{
            key: "construct",
            //region Init
            value: function construct(scheduler) {
              this.scheduler = scheduler;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(HorizontalEventMapper.prototype), "construct", this).call(this, scheduler);

              this.cache = new _HorizontalEventMapperCache_js__WEBPACK_IMPORTED_MODULE_11__["default"](this);
            }
          }, {
            key: "init",
            value: function init() {
              var me = this;

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_8___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(HorizontalEventMapper.prototype), "init", this).call(this);

              this.scheduler.on({
                togglegroup: me.onToggleGroup,
                rowremove: me.onRowRemove,
                prio: 2,
                thisObj: me
              });
            } //endregion
            //region Div reusage
            // called from cache when removing events

          }, {
            key: "clearDiv",
            value: function clearDiv(div, remove, remainVisible) {
              var me = this,
                  divStyle = div.style;

              if (!remove || remainVisible) {
                me.releaseTimeSpanDiv(div, remainVisible);
              } // For example when adding events we remove all existing immediately to not have the new event transition into
              // place by from reusing an existing element. Also want to remove right away when not using event animations.
              else if (remove === 'immediate' || !me.scheduler.enableEventAnimations) {
                  div.remove();
                } else {
                  // The div doesn't get removed until the opacity transition has done.
                  // Avoid id collisions if the event is rerendered immediately.
                  // Can't set it to "" because of test requirements.
                  div.id = _Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"].generateId('obsolete-event');
                  divStyle.opacity = 0;
                  divStyle.pointerEvents = 'none';
                  me.setTimeout(function () {
                    div.remove();
                    divStyle.opacity = 1;
                    divStyle.pointerEvents = '';
                  }, 200);
                }
            } // called from cache when removing events

          }, {
            key: "clearAllDivs",
            value: function clearAllDivs() {
              var me = this;
              me.availableDivs.forEach(function (div) {
                return div.remove();
              });
              me.availableDivs.clear();
            }
          }, {
            key: "clearEvents",
            value: function clearEvents() {
              this.cache.clear(true);
            }
            /**
             * Releases elements for events no longer in view.
             */

          }, {
            key: "releaseEvent",
            value: function releaseEvent(rowId, timeSpanElementId) {
              var remainVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  timeSpanData = me.cache.getRenderedTimeSpan(rowId, timeSpanElementId),
                  cache = timeSpanData && me.cache.getTimeSpan(timeSpanData.eventId, rowId);

              if (cache && cache.div) {
                // release div. remember for reuse, if such mode is used
                me.releaseTimeSpanDiv(cache.div, remainVisible);
                cache.div = cache.eventEl = null;
              }

              return me.cache.clearRenderedTimeSpan(rowId, timeSpanElementId);
            } //endregion
            //region Elements

          }, {
            key: "getElementFromEventRecord",
            value: function getElementFromEventRecord(eventRecord) {
              var resourceRecord = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.scheduler.eventStore.getResourcesForEvent(eventRecord)[0];

              if (resourceRecord) {
                var renderedRowEvents = this.cache.getRenderedEvents(resourceRecord.id);

                if (renderedRowEvents) {
                  var layoutId = this.scheduler.getEventRenderId(eventRecord, resourceRecord),
                      layout = renderedRowEvents[layoutId],
                      layoutCache = layout && layout.layoutCache;
                  return layoutCache && layoutCache.eventEl;
                }
              }
            }
          }, {
            key: "getElementsFromEventRecord",
            value: function getElementsFromEventRecord(eventRecord, resourceRecord) {
              var me = this; // Single event instance, as array

              if (resourceRecord) {
                return [me.getElementFromEventRecord(eventRecord, resourceRecord)];
              } // All instances
              else {
                  return me.scheduler.eventStore.getResourcesForEvent(eventRecord).reduce(function (result, resourceRecord) {
                    var el = me.getElementFromEventRecord(eventRecord, resourceRecord);

                    if (el) {
                      result.push(el);
                    }

                    return result;
                  }, []);
                }
            }
          }, {
            key: "resolveRowRecord",
            value: function resolveRowRecord(elementOrEvent) {
              var me = this,
                  view = me.view,
                  element = elementOrEvent instanceof Event ? elementOrEvent.target : elementOrEvent,
                  el = element.nodeType === 3 ? element.parentElement : element,
                  eventNode = el.matches(view.eventSelector) && el || _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].up(el, view.eventSelector);

              if (eventNode) {
                return view.getResourceRecordFromDomId(eventNode.id);
              }

              return view.getRecordFromElement(el);
            }
          }, {
            key: "toggleCls",
            value: function toggleCls(eventRecord, resourceRecord, cls) {
              var add = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

              if (!resourceRecord) {
                return;
              }

              var eventLayout = this.cache.getRenderedTimeSpan(resourceRecord.id, this.scheduler.getEventRenderId(eventRecord, resourceRecord)),
                  element = this.getElementFromEventRecord(eventRecord, resourceRecord);

              if (eventLayout) {
                eventLayout.cls[cls] = add ? 1 : 0;
              }

              if (element) {
                element.classList[add ? 'add' : 'remove'](cls);
              }
            } //endregion
            //region Region

          }, {
            key: "getResourceEventBox",
            value: function getResourceEventBox(eventId, resourceId) {
              var cached = this.cache.getTimeSpan(eventId, resourceId);

              if (cached) {
                return cached;
              }
            }
            /**
             * Gets the region, relative to the page, represented by the schedule and optionally only for a single resource. This method will call getDateConstraints to
             * allow for additional resource/event based constraints. By overriding that method you can constrain events differently for
             * different resources.
             * @param {Common.data.Model} rowRecord (optional) The row record
             * @param {Scheduler.model.EventModel} eventRecord (optional) The event record
             * @return {Object} The region of the schedule
             */

          }, {
            key: "getScheduleRegion",
            value: function getScheduleRegion(rowRecord, eventRecord) {
              var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
              var me = this,
                  view = me.view,
                  column = me.column,
                  region;

              if (rowRecord) {
                var eventElement = eventRecord && me.getElementsFromEventRecord(eventRecord, rowRecord)[0];
                region = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(view.getRowById(rowRecord.id).getElement('locked'));

                if (eventElement) {
                  var eventRegion = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(eventElement, column.subGridElement);

                  region.y = eventRegion.y;
                  region.bottom = eventRegion.bottom;
                } else {
                  region.y = region.y + view.resourceMargin;
                  region.bottom = region.bottom - view.resourceMargin;
                }
              } else {
                // TODO: This is what the bizarre function that was removed here did.
                // The coordinate space needs to be sorted out here!
                region = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_12__["default"].from(column.subGridElement).moveTo(null, 0);
                region.width = column.subGridElement.scrollWidth;
                region.y = region.y + view.resourceMargin;
                region.bottom = region.bottom - view.resourceMargin;
              }

              var taStart = me.timeAxis.startDate,
                  taEnd = me.timeAxis.endDate,
                  dateConstraints = view.getDateConstraints(rowRecord, eventRecord) || {
                start: taStart,
                end: taEnd
              },
                  startX = view.getCoordinateFromDate(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].max(taStart, dateConstraints.start)),
                  //startX          = this.translateToPageCoordinate(scheduler.getCoordinateFromDate(DateHelper.max(taStart, dateConstraints.start))),
              endX = view.getCoordinateFromDate(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"].min(taEnd, dateConstraints.end)),
                  //endX            = this.translateToPageCoordinate(scheduler.getCoordinateFromDate(DateHelper.min(taEnd, dateConstraints.end))),
              top = region.y,
                  bottom = region.bottom;

              if (!local) {
                startX = me.translateToPageCoordinate(startX);
                endX = me.translateToPageCoordinate(endX);
              }

              return {
                top: top,
                right: Math.max(startX, endX),
                bottom: bottom,
                left: Math.min(startX, endX)
              };
            }
          }, {
            key: "getResoureEventBox",
            value: function getResoureEventBox(eventId, resourceId) {
              return this.cache.getTimeSpan(eventId, resourceId);
            } //endregion
            //region Layout & render
            //region Stack & pack

          }, {
            key: "layoutEventVerticallyStack",
            value: function layoutEventVerticallyStack(bandIndex) {
              var _this$scheduler = this.scheduler,
                  resourceMargin = _this$scheduler.resourceMargin,
                  rowHeight = _this$scheduler.rowHeight,
                  barMargin = _this$scheduler.barMargin;
              return bandIndex === 0 ? resourceMargin : resourceMargin + bandIndex * (rowHeight - resourceMargin * 2) + bandIndex * barMargin;
            }
          }, {
            key: "layoutEventVerticallyPack",
            value: function layoutEventVerticallyPack(topFraction, heightFraction) {
              var _this$scheduler2 = this.scheduler,
                  resourceMargin = _this$scheduler2.resourceMargin,
                  rowHeight = _this$scheduler2.rowHeight,
                  barMargin = _this$scheduler2.barMargin,
                  availableHeight = rowHeight - 2 * resourceMargin,
                  count = 1 / heightFraction,
                  bandIndex = topFraction * count,
                  height = (availableHeight - (count - 1) * barMargin) * heightFraction,
                  top = resourceMargin + bandIndex * height + bandIndex * barMargin;
              return {
                top: top,
                height: height
              };
            } //endregion

            /**
             * Converts a start/endDate into a MS value used when rendering the event. If scheduler is configured with
             * `fillTicks: true` the value returned will be snapped to tick start/end.
             * @private
             * @param {Scheduler.model.EventModel} eventRecord
             * @returns {Object} Object of format { startMS, endMS, durationMS }
             */

          }, {
            key: "calculateMS",
            value: function calculateMS(eventRecord) {
              var me = this,
                  view = me.view;
              var startMS = getStartEnd(view, me.timeAxis, eventRecord.startDate, eventRecord.startDateMS, false),
                  endMS = getStartEnd(view, me.timeAxis, eventRecord.endDate, eventRecord.endDateMS, true),
                  durationMS = endMS - startMS;

              if (view.milestoneLayoutMode !== 'default' && durationMS === 0) {
                var pxPerMinute = me.timeAxisViewModel.getSingleUnitInPixels('minute'),
                    lengthInPx = view.getMilestoneLabelWidth(eventRecord),
                    duration = lengthInPx * (1 / pxPerMinute);
                durationMS = duration * 60 * 1000;

                switch (view.milestoneAlign) {
                  case 'start':
                  case 'left':
                    endMS = startMS + durationMS;
                    break;

                  case 'end':
                  case 'right':
                    endMS = startMS;
                    startMS = endMS - durationMS;
                    break;

                  default:
                    // using center as default
                    endMS = startMS + durationMS / 2;
                    startMS = endMS - durationMS;
                    break;
                }
              }

              return {
                startMS: startMS,
                endMS: endMS,
                durationMS: durationMS
              };
            }
            /**
             * Layouts events on a row, caching on each event and the entire result on the resource
             * @private
             * @param {Scheduler.view.Scheduler} scheduler
             * @param {Scheduler.model.ResourceModel} resource
             * @param {Grid.row.Row} row
             * @returns {Boolean} Returns false if no events on row, otherwise true
             */

          }, {
            key: "layoutEvents",
            value: function layoutEvents(scheduler, resource, row) {
              var me = this,
                  timeAxis = me.timeAxis,
                  eventStore = scheduler.eventStore,
                  resourceId = resource.id,
                  resourceEvents = eventStore.getEventsForResource(resourceId),
                  availableEvents = eventStore.isFiltered ? resourceEvents.filter(function (eventRecord) {
                return eventStore.indexOf(eventRecord) > -1;
              }) : resourceEvents,
                  allEvents = scheduler.getEventsToRender(resource, availableEvents) || [],
                  events = allEvents.filter(function (e) {
                return timeAxis.isTimeSpanInAxis(e);
              }),
                  eventsTplData = events.reduce(function (result, event) {
                var eventBox = scheduler.generateTplData(event, resource); // Collect layouts of visible events

                if (eventBox) {
                  result.push(eventBox);
                } // Release events that are no longer visible
                else if (me.cache.getRenderedEvents(resourceId)) {
                    me.releaseEvent(resourceId, scheduler.getEventRenderId(event, resource));
                  }

                return result;
              }, []); // If there are no events within the rendering zone, clear the resource layout cache.
              // Return false to indicate that there's nothing to render.

              if (!eventsTplData.length) {
                me.cache.clearRenderedEvents(resourceId);
                return false;
              } // Ensure the events are rendered in natural order so that navigation works.


              eventsTplData.sort(me.eventSorter);
              var rowHeight = scheduler.rowHeight;
              var layout = scheduler.currentEventLayout,
                  // Only events and tasks should be considered during layout (not resource time ranges if any)
              layoutEventData = eventsTplData.filter(function (d) {
                return d.event.isEvent || d.event.isTask;
              }); // Event data is now gathered, calculate layout properties for each event

              if (scheduler.eventLayout === 'stack') {
                var nbrOfBandsRequired = layout.applyLayout(layoutEventData, resource),
                    heightPerEvent = scheduler.rowHeight - scheduler.resourceMargin * 2;
                rowHeight = nbrOfBandsRequired * heightPerEvent + (nbrOfBandsRequired - 1) * scheduler.barMargin + scheduler.resourceMargin * 2;
              } else if (scheduler.eventLayout === 'pack') {
                layout.applyLayout(layoutEventData, resource);
              }

              var absoluteTop = row.top; // adjust row top, when it is rendered on top (since in that case top is not known until height is set)

              if (rowHeight !== row.height && row.estimatedTop) {
                absoluteTop = row.top + row.height - rowHeight;
              }

              var cache = {
                _allEvents: eventsTplData,
                _rowHeight: rowHeight
              }; // cache boxes

              eventsTplData.forEach(function (data) {
                var layout = me.cache.getTimeSpan(data.eventId, resourceId),
                    relativeTop = data.top;
                data.top += absoluteTop;
                data.rowTop = absoluteTop; // ResourceTimeRanges sets this flag to fill the entire row (can't use 100% since it is not actually in the row).
                // Also cant set it in ResourceTimeRanges#onEventDataGenerated since it is called prior to laying out

                if (data.fillSize) {
                  data.height = rowHeight;
                } // TODO: Include directly in data instead, to simplify cache a wee bit
                // cache layout to not have to recalculate every time


                data.layoutCache = {
                  layout: true,
                  // reuse div if already assigned (for example when resizing an event)
                  div: layout && layout.div,
                  eventEl: layout && layout.eventEl,
                  width: data.width,
                  height: data.height,
                  start: data.left,
                  end: data.left + data.width,
                  relativeTop: relativeTop,
                  top: data.top,
                  relativeBottom: relativeTop + data.height,
                  bottom: data.top + data.height
                };
                cache[data.eventId] = data;
              });
              me.cache.addRow(resourceId, cache); //me.resourceLayoutCache[resourceId] = eventsTplData;

              return true;
            } // Earlier start dates are above later tasks
            // If same start date, longer tasks float to top
            // If same start + duration, sort by name

          }, {
            key: "eventSorter",
            value: function eventSorter(a, b) {
              var startA = a.dataStartMs || a.startMs,
                  // dataXX are used if configured with fillTicks
              endA = a.dataEndMs || a.endMs,
                  startB = b.dataStartMs || b.startMs,
                  endB = b.dataEndMs || b.endMs,
                  sameStart = startA === startB;

              if (sameStart) {
                if (endA - endB === 0) {
                  return a.event.name < b.event.name ? -1 : 1;
                }

                return endA > endB ? -1 : 1;
              }

              return startA < startB ? -1 : 1;
            }
            /**
             * Called when rows are translated. Since events "float" on top of everything they must be adjusted if translation
             * changes.
             * @private
             */

          }, {
            key: "onTranslateRow",
            value: function onTranslateRow(_ref) {
              var row = _ref.row;
              this.matchRowTranslation(row);
            }
            /**
             * Renders a single event, creating a div for it if needed or updates an existing div.
             * @private
             * @param data
             */

          }, {
            key: "renderEvent",
            value: function renderEvent(data) {
              var me = this,
                  eventIdProperty = me.view.scheduledEventName + 'Id',
                  eventId = data[eventIdProperty],
                  layoutCache = me.cache.getTimeSpan(eventId, data.resourceId),
                  renderedEvents = me.cache.getRenderedEvents(data.resourceId),
                  meta = data.event.instanceMeta(me.scheduler),
                  // Event might be flagged to require a new element in onEventAdd, but if it is a drag proxy it should still
              // reuse an existing element (it will be correctly linked to the drag proxy element)
              wrapperElement = me.renderTimeSpan(data, layoutCache, renderedEvents[data.id], meta.requireElement && !meta.fromDragProxy);

              if (data.assignment) {
                wrapperElement.dataset.assignmentId = data.assignment.id;
              } // Add event/task id to wrappers dataset
              // Otherwise event element won't have event id property in it's dataset and scheduler
              // won't be able to resolve event by element reference (#8943)


              if (eventId) {
                wrapperElement.dataset[eventIdProperty] = eventId;
              }

              renderedEvents[data.id] = data;

              if (meta.requireElement) {
                delete meta.requireElement;
                delete meta.fromDragProxy;
              } // This event is documented on Scheduler


              me.scheduler.trigger('renderEvent', {
                eventRecord: data.event,
                resourceRecord: data.resource,
                assignmentRecord: data.assignment,
                element: wrapperElement,
                tplData: data
              });
            } // Overrides fn from baseclass to trigger a paint event with correct params

          }, {
            key: "triggerPaint",
            value: function triggerPaint(data, element) {
              var isRepaint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var scheduler = this.scheduler;
              scheduler.trigger(isRepaint ? 'eventRepaint' : 'eventPaint', {
                scheduler: scheduler,
                eventRecord: data.event,
                resourceRecord: data.resource,
                element: element
              });
            } // We only have to ask this question in the horizontal axis.
            // Vertical rendering is driven fully by the Grid's RowManager
            // rendering and derendering rows.

          }, {
            key: "isEventInView",
            value: function isEventInView(eventLayout) {
              // Milestones need to be visible at start & end
              if (eventLayout.startMs === eventLayout.endMs) {
                return eventLayout.startMs <= this.viewportEnd && eventLayout.endMs > this.viewportStart;
              } // But normal events do not


              return eventLayout.startMs < this.viewportEnd && eventLayout.endMs > this.viewportStart;
            } // Displays events that are in view, hides/recycles those that are no longer

          }, {
            key: "updateRowTimeSpans",
            value: function updateRowTimeSpans(row, resource) {
              var forceLayout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var fromHorizontalScroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var me = this,
                  scheduler = me.scheduler,
                  resourceId = resource.id;
              var renderedEvents = me.cache.getRenderedEvents(resourceId),
                  resourceLayoutCache = me.cache.getRow(resourceId); // no need to relayout events if only scrolling horizontally

              if ((scheduler.forceLayout || forceLayout || !resourceLayoutCache) && !me.layoutEvents(scheduler, resource, row)) {
                return resourceLayoutCache && resourceLayoutCache._rowHeight || 0;
              } // might have been updated above


              resourceLayoutCache = me.cache.getRow(resourceId);
              if (!resourceLayoutCache) return 0;

              var eventsInView = resourceLayoutCache._allEvents.filter(function (evt) {
                return (// Keep events flagged by for example EventDrag
                  evt.event.instanceMeta(scheduler).retainElement || // Assignment might also be flagged if used
                  evt.assignment && evt.assignment.instanceMeta(scheduler).retainElement || // And keep events actually in view :)
                  me.isEventInView(evt)
                );
              });

              if (!renderedEvents) {
                renderedEvents = {};
                me.cache.addRenderedEvents(resourceId, renderedEvents);
              } // Add events not already in dom or refresh those that are


              for (var i = 0; i < eventsInView.length; i++) {
                var data = eventsInView[i]; // There are multiple pathways that might lead to the first render of events. This is the first reliable
                // place were we can determine that something will be rendered

                scheduler._firstRenderDone && scheduler._firstRenderDone(); // Do not render events whose element is retained, or if scrolling horizontally already has an element

                if (!fromHorizontalScroll && !data.event.instanceMeta(scheduler).retainElement || fromHorizontalScroll && !data.layoutCache.div) {
                  var animation = scheduler.isFirstRender && data.top < scheduler.bodyHeight && scheduler.useInitialAnimation;

                  if (animation) {
                    data.wrapperCls.add('b-first-render');
                    data.internalStyle = "animation-delay: ".concat(data.row.index / 20, "s;");
                  }

                  me.renderEvent(data);
                  data.wrapperCls['b-first-render'] = null;
                }
              } // Remove already rendered events that are now outside of view


              var renderedEventIds = Object.keys(renderedEvents);

              var _loop = function _loop(_i) {
                var eventId = renderedEventIds[_i];

                if (!eventsInView.some(function (e) {
                  return e.id === eventId;
                })) {
                  me.releaseEvent(resourceId, eventId);
                }
              };

              for (var _i = 0; _i < renderedEventIds.length; _i++) {
                _loop(_i);
              }

              return resourceLayoutCache._rowHeight;
            }
          }, {
            key: "renderer",
            value: function renderer(renderData) {
              // Render the resource's events.
              renderData.size.height = this.updateRowTimeSpans(renderData.row, renderData.record);
            } //endregion
            //region Store events

          }, {
            key: "matchRowTranslation",
            value: function matchRowTranslation(row) {
              var me = this,
                  // Cannot check row.id because translation happens before render, id might not be updated.
              recordId = me.scheduler.store.getAt(row.dataIndex).id,
                  resourceCache = me.cache.getRow(recordId),
                  first = resourceCache && resourceCache._allEvents.length > 0 && resourceCache._allEvents[0]; // only update events whose resource has changed top

              if (first && first.rowTop !== row.top) {
                var deltaY = row.top - first.rowTop;

                resourceCache._allEvents.forEach(function (data) {
                  var eventLayout = data.layoutCache;
                  eventLayout.top += deltaY;
                  eventLayout.bottom += deltaY;

                  if (eventLayout.div) {
                    me.positionTimeSpan(eventLayout.div, eventLayout.start, eventLayout.top);
                  }

                  data.top += deltaY;
                  data.rowTop = row.top;
                });
              }
            }
          }, {
            key: "onTimeAxisViewModelUpdate",
            value: function onTimeAxisViewModelUpdate() {
              // if we do not clear cache, refresh will happen and will use older cache
              // caught by test 012_dragdrop
              this.cache.clear(); // TODO: this always happen, unnecessary to perform layout prior to this?
              // always update view bounds and redraw events

              this.updateFromHorizontalScroll(this.scheduler.timeAxisSubGrid.scrollable.x);
            } // resource removed, move all affected events up

          }, {
            key: "onRowRemove",
            value: function onRowRemove(_ref2) {
              var _this = this;

              var isCollapse = _ref2.isCollapse;
              var scheduler = this.scheduler;

              if (!isCollapse) {
                scheduler.runWithTransition(function () {
                  scheduler.rowManager.forEach(function (row) {
                    return _this.matchRowTranslation(row);
                  });
                });
              }
            }
            /**
             * User toggled a group in a grouped grid, events needs to be redrawn since they might appear/disappear
             * @private
             */

          }, {
            key: "onToggleGroup",
            value: function onToggleGroup(_ref3) {
              var _this2 = this;

              var groupRecord = _ref3.groupRecord,
                  collapse = _ref3.collapse;
              var store = this.scheduler.store,
                  // First record in next group
              recordIndex = store.indexOf(groupRecord) + (collapse ? 1 : groupRecord.groupChildren.length); // Handle this group

              if (collapse) {
                // Collapsing -> events in the group will be hidden, remove them from cache
                groupRecord.groupChildren.forEach(function (child) {
                  _this2.cache.clearRow(child.id);
                });
              } // TODO: this should not need to loop til the end, since only events in view are drawn. will be costly with large amount of resources
              // Loop starting at the next group


              for (; recordIndex < store.count; recordIndex++) {
                this.cache.clearRow(store.getAt(recordIndex).id);
              }
            }
          }, {
            key: "onEventDataset",
            value: function onEventDataset() {
              // Previously dataset would use onEventAdd, but if we get fewer events than we had some will stick around
              // just for the fun of it. Better clear all
              this.cache.clear(true);
            }
          }, {
            key: "onEventAdd",
            value: function onEventAdd(_ref4) {
              var _this3 = this;

              var records = _ref4.records,
                  resources = _ref4.resources;
              var me = this,
                  startDate,
                  endDate; //        me.scheduler.rowManager.averageRowHeight = null; // force recalculation, since moving events might have affected row height

              records.forEach(function (event) {
                startDate = event.startDate;
                endDate = event.endDate;

                if (startDate && endDate && me.timeAxis.timeSpanInAxis(startDate, endDate)) {
                  var eventResources = event.resources; // Flag that this event needs a new element, it should not steal some other released events element because
                  // that might lead to a transition. Only set if event will be in view

                  if (eventResources && eventResources.some(function (resource) {
                    return me.scheduler.getRowFor(resource);
                  })) {
                    event.instanceMeta(me.scheduler).requireElement = true;
                  } // TODO: this does not make sense when adding multiple events, resources are then not tied to the event
                  // repaint row only if event is in time axis


                  resources.forEach(function (resource) {
                    _this3.cache.clearRow(resource.id, false, true);
                  });
                }
              });
            }
          }, {
            key: "onEventRemove",
            value: function onEventRemove(_ref5) {
              var records = _ref5.records,
                  resources = _ref5.resources;
              var me = this; // Remove the divs fully since creation now adopts the proxy to use as the event div

              resources.forEach(function (resource) {
                return me.cache.clearRow(resource.id, true);
              } //scheduler.store.getIndex(resource) >= 0 && scheduler.repaintEventsForResource(resource)
              );
            }
          }, {
            key: "onEventUpdate",
            value: function onEventUpdate(_ref6) {
              var eventStore = _ref6.source,
                  eventRecord = _ref6.record,
                  _ref6$changes = _ref6.changes,
                  changes = _ref6$changes === void 0 ? {} : _ref6$changes,
                  resources = _ref6.resources;
              var me = this,
                  resourceWasChanged = 'resourceId' in changes; // A change happened to an event missing a resource, do nothing

              if (!resourceWasChanged && !resources.length) return; // Moved to another resource, invalidate both old and new (only applies when not using an AssignmentStore)

              if (resourceWasChanged) {
                var oldResource = eventStore.resourceStore.getById(changes.resourceId.oldValue),
                    newResource = eventRecord.resource,
                    eventRenderedAfterUpdate = newResource && !newResource.placeHolder,
                    isVisible = eventRecord.resource && Boolean(me.getTimeSpanRenderData(eventRecord, eventRecord.resource)); // invalidate old and new resource event layouts

                if (oldResource) {
                  var oldLayout = me.cache.getTimeSpan(eventRecord.id, oldResource.id); // If the event is layed out for oldResource, that resources needs to be redrawn

                  if (oldLayout) {
                    // If it's to be rerendered after the change, set the div's
                    // id so that after it's returned to the cache, it will be plucked
                    // out by the renderer to be reused.
                    if (eventRenderedAfterUpdate) {
                      // If it has an element, release the div, but release it under the id for
                      // which it *will* be used when the cleared resource rows are rerendered.
                      if (oldLayout.div && newResource) {
                        oldLayout.div.id = me.scheduler.getEventRenderId(eventRecord, newResource);
                      }

                      me.cache.clearRow(oldResource.id, false, eventRenderedAfterUpdate);
                    } // If it's not going to be rerendered, dump the div completely
                    else {
                        me.cache.clearEvent(eventRecord.id, changes.resourceId.oldValue, true);
                      }
                  }
                } // Event was added first and then assigned to a resource (or similar scenario). There will be no div tied to
                // the event and it might reuse an element reserved for some other event (which will transition in to place)
                // TODO: Rework element reusage to always process events with existing elements first and then "new",
                //   when done this workaround and the one in onEventAdd() can be removed
                else if (eventRenderedAfterUpdate) {
                    eventRecord.instanceMeta(me.scheduler).requireElement = true;
                  }

                eventRenderedAfterUpdate && me.cache.clearRow(newResource.id, false, isVisible); // TODO: Not so sure we should throw the average away on account of a single row that might change height,
                //  check if it works good without this/make gradual adjustment

                me.scheduler.rowManager.averageRowHeight = null; // force recalculation, since moving events might have affected row height
              } // start or end date changed, need to update layout
              else if ('startDate' in changes || 'endDate' in changes) {
                  resources.forEach(function (resourceRecord) {
                    // Moving events on a row with multiple events might affect those other events, or the height of the row
                    // which affects everything below
                    if (me.scheduler.eventStore.getEventsForResource(resourceRecord).length > 1) {
                      // TODO: Not so sure we should throw the average away on account of a single row that might change height,
                      //  check if it works good without this/make gradual adjustment
                      me.scheduler.rowManager.averageRowHeight = null;
                    }
                  });
                }

              resources.forEach(function (resourceRecord) {
                var eventLayoutData = me.getTimeSpanRenderData(eventRecord, resourceRecord),
                    isVisible = Boolean(eventLayoutData && me.isEventInView(eventLayoutData)); // Clear cache, avoiding to hide the element if visible

                me.cache.clearRow(resourceRecord.id, false, isVisible);
              });
            } // Event id changed, change elements id to have it reused correctly on redraw

          }, {
            key: "onEventStoreIdChange",
            value: function onEventStoreIdChange(_ref7) {
              var oldValue = _ref7.oldValue,
                  value = _ref7.value;
              var view = this.view;

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"].forEachSelector(view.element, "[data-event-id=\"".concat(oldValue, "\"]"), function (el) {
                el.id = view.getEventRenderId(value, view.getResourceIdFromDomNodeId(el.id));
              });
            }
          }, {
            key: "onEventClearChanges",
            value: function onEventClearChanges() {
              this.cache.clear();
            }
          }, {
            key: "onEventFilter",
            value: function onEventFilter() {
              this.cache.clear();
            }
          }, {
            key: "onEventRemoveAll",
            value: function onEventRemoveAll() {
              this.view.rowManager.averageRowHeight = null; // force recalculation, since moving events might have affected row height

              this.cache.clear(true);
            } //endregion
            //region Dependency connectors

            /**
             * Gets displaying item start side
             *
             * @param {Scheduler.model.EventModel} eventRecord
             * @return {String} 'left' / 'right' / 'top' / 'bottom'
             */

          }, {
            key: "getConnectorStartSide",
            value: function getConnectorStartSide(eventRecord) {
              return 'left';
            }
            /**
             * Gets displaying item end side
             *
             * @param {Scheduler.model.EventModel} eventRecord
             * @return {String} 'left' / 'right' / 'top' / 'bottom'
             */

          }, {
            key: "getConnectorEndSide",
            value: function getConnectorEndSide(eventRecord) {
              return 'right';
            } //endregion

          }]);

          return HorizontalEventMapper;
        }(_BaseHorizontalMapper_js__WEBPACK_IMPORTED_MODULE_10__["default"]);

        HorizontalEventMapper._$name = 'HorizontalEventMapper';
        /***/
      },

      /***/
      "./lib/Scheduler/view/orientation/HorizontalEventMapperCache.js":
      /*!**********************************************************************!*\
        !*** ./lib/Scheduler/view/orientation/HorizontalEventMapperCache.js ***!
        \**********************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewOrientationHorizontalEventMapperCacheJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return HorizontalEventMapperCache;
        });
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);

        var productName = 'scheduler';

        var HorizontalEventMapperCache =
        /*#__PURE__*/
        function () {
          function HorizontalEventMapperCache(mapper) {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, HorizontalEventMapperCache);

            var me = this;
            me.mapper = mapper; // caching layout calculations

            me.renderedEventsMap = {};
            me.rowLayoutCache = {};
          }
          /**
           * Clear event & row layout cache (removes cached layout for all resources and events)
           * @internal
           */


          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(HorizontalEventMapperCache, [{
            key: "clear",
            value: function clear() {
              var removeDivs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var me = this;
              me.renderedEventsMap = {};
              Object.keys(me.rowLayoutCache).forEach(function (resourceId) {
                return me.clearRow(resourceId, removeDivs ? 'immediate' : false);
              });
            } //region Render data

          }, {
            key: "addRenderedEvents",
            value: function addRenderedEvents(resourceId, data) {
              this.renderedEventsMap[resourceId] = data;
            }
          }, {
            key: "addRenderedEvent",
            value: function addRenderedEvent(eventData) {
              // If the resource is not layed out (outside of rendered block)
              // then this is a no-op.
              if (eventData.resourceId in this.renderedEventsMap) {
                var resourceRenderedEvents = this.renderedEventsMap[eventData.resourceId] || (this.renderedEventsMap[eventData.resourceId] = {});
                resourceRenderedEvents[eventData.id] = eventData;
              }
            }
          }, {
            key: "getRenderedTimeSpan",
            value: function getRenderedTimeSpan(resourceId, eventElementId) {
              var resourceRenderedEvents = this.renderedEventsMap[resourceId];
              return resourceRenderedEvents && resourceRenderedEvents[eventElementId];
            }
          }, {
            key: "clearRenderedTimeSpan",
            value: function clearRenderedTimeSpan(resourceId, eventElementId) {
              var resourceRenderedEvents = this.renderedEventsMap[resourceId];

              if (resourceRenderedEvents) {
                var result = this.renderedEventsMap[resourceId][eventElementId];
                delete this.renderedEventsMap[resourceId][eventElementId];
                return result;
              }
            }
          }, {
            key: "getRenderedEvents",
            value: function getRenderedEvents(resourceId) {
              return this.renderedEventsMap[resourceId];
            }
          }, {
            key: "clearRenderedEvents",
            value: function clearRenderedEvents(resourceId) {
              this.renderedEventsMap[resourceId] = null;
            } //endregion
            //region TimeSpans

          }, {
            key: "getTimeSpan",
            value: function getTimeSpan(timeSpanId, rowId) {
              var resourceCache = this.rowLayoutCache[rowId],
                  timeSpanCache = resourceCache && resourceCache[timeSpanId];
              if (!timeSpanCache) return null;
              return timeSpanCache.layoutCache;
            }
            /**
             * Clears the event layout for the passed event and resource. Will usually preserve
             * the event DIVs for recycling unless `removeDiv` is passed. If preserving them,
             * it will hide the div unless `remainVisible` is passed.
             * @param {*} eventId ID of event
             * @param {*} resourceId ID of resource
             * @param {*} removeDiv Defaults to false
             * @param {*} remainVisible Defaults to false
             * @private
             */

          }, {
            key: "clearEvent",
            value: function clearEvent(eventId, resourceId) {
              var removeDiv = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var remainVisible = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
              var me = this,
                  eventCache = me.getTimeSpan(eventId, resourceId);
              if (!eventCache) return null;

              if (eventCache.div) {
                me.mapper.clearDiv(eventCache.div, removeDiv, remainVisible);
              }

              me.rowLayoutCache[resourceId][eventId].layoutCache = null;
            } //endregion
            //region Row

          }, {
            key: "getRow",
            value: function getRow(resourceId) {
              return this.rowLayoutCache[resourceId];
            }
          }, {
            key: "addRow",
            value: function addRow(resourceId, data) {
              this.rowLayoutCache[resourceId] = data;
            }
          }, {
            key: "clearRow",
            value: function clearRow(resourceId) {
              var removeDivs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
              var remainVisible = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  resourceCache = me.rowLayoutCache[resourceId];
              if (!resourceCache) return;
              if (me.renderedEventsMap[resourceId]) delete me.renderedEventsMap[resourceId];
              Object.keys(resourceCache).forEach(function (eventId) {
                if (eventId !== '_allEvents' && eventId !== '_rowHeight') {
                  me.clearEvent(eventId, resourceId, removeDivs, remainVisible);
                }
              });
              delete me.rowLayoutCache[resourceId];
            } //endregion

          }]);

          return HorizontalEventMapperCache;
        }();

        HorizontalEventMapperCache._$name = 'HorizontalEventMapperCache';
        /***/
      },

      /***/
      "./lib/Scheduler/view/orientation/VerticalEventMapper.js":
      /*!***************************************************************!*\
        !*** ./lib/Scheduler/view/orientation/VerticalEventMapper.js ***!
        \***************************************************************/

      /*! exports provided: default */

      /***/
      function libSchedulerViewOrientationVerticalEventMapperJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "default", function () {
          return VerticalEventMapper;
        });
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! core-js/modules/es6.object.keys */
        "./node_modules/core-js/modules/es6.object.keys.js");
        /* harmony import */


        var core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_object_keys__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! core-js/modules/es6.function.name */
        "./node_modules/core-js/modules/es6.function.name.js");
        /* harmony import */


        var core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_function_name__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! @babel/runtime/helpers/slicedToArray */
        "./node_modules/@babel/runtime/helpers/slicedToArray.js");
        /* harmony import */


        var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! core-js/modules/es6.string.iterator */
        "./node_modules/core-js/modules/es6.string.iterator.js");
        /* harmony import */


        var core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_string_iterator__WEBPACK_IMPORTED_MODULE_3__);
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! core-js/modules/es6.set */
        "./node_modules/core-js/modules/es6.set.js");
        /* harmony import */


        var core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_set__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! core-js/modules/web.dom.iterable */
        "./node_modules/core-js/modules/web.dom.iterable.js");
        /* harmony import */


        var core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_web_dom_iterable__WEBPACK_IMPORTED_MODULE_5__);
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! core-js/modules/es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js");
        /* harmony import */


        var core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es6_array_iterator__WEBPACK_IMPORTED_MODULE_6__);
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! core-js/modules/es7.object.values */
        "./node_modules/core-js/modules/es7.object.values.js");
        /* harmony import */


        var core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(core_js_modules_es7_object_values__WEBPACK_IMPORTED_MODULE_7__);
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! @babel/runtime/helpers/classCallCheck */
        "./node_modules/@babel/runtime/helpers/classCallCheck.js");
        /* harmony import */


        var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8__);
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! @babel/runtime/helpers/createClass */
        "./node_modules/@babel/runtime/helpers/createClass.js");
        /* harmony import */


        var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! @babel/runtime/helpers/possibleConstructorReturn */
        "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
        /* harmony import */


        var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10__);
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! @babel/runtime/helpers/getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
        /* harmony import */


        var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! @babel/runtime/helpers/get */
        "./node_modules/@babel/runtime/helpers/get.js");
        /* harmony import */


        var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12__);
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! @babel/runtime/helpers/inherits */
        "./node_modules/@babel/runtime/helpers/inherits.js");
        /* harmony import */


        var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default =
        /*#__PURE__*/
        __webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13__);
        /* harmony import */


        var _Common_Base_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ../../../Common/Base.js */
        "../Grid/lib/Common/Base.js");
        /* harmony import */


        var _Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ../../../Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony import */


        var _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ../../../Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony import */


        var _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ../../../Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony import */


        var _eventlayout_VerticalLayout_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ../../eventlayout/VerticalLayout.js */
        "./lib/Scheduler/eventlayout/VerticalLayout.js");
        /* harmony import */


        var _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ../../../Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony import */


        var _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ../../../Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");

        var productName = 'scheduler';
        var releaseEventActions = {
          'releaseElement': 1,
          // Not used at all at the moment
          'reuseElement': 1 // Used by some other element

        },
            renderEventActions = {
          'newElement': 1,
          'reuseOwnElement': 1,
          'reuseElement': 1
        };

        var VerticalEventMapper =
        /*#__PURE__*/
        function (_Delayable) {
          _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_13___default()(VerticalEventMapper, _Delayable);

          function VerticalEventMapper() {
            _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_8___default()(this, VerticalEventMapper);

            return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_10___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(VerticalEventMapper).apply(this, arguments));
          }

          _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_9___default()(VerticalEventMapper, [{
            key: "construct",
            value: function construct(scheduler) {
              this.scheduler = scheduler;
              this.timeAxisViewModel = scheduler.timeAxisViewModel;
              this.verticalLayout = new _eventlayout_VerticalLayout_js__WEBPACK_IMPORTED_MODULE_18__["default"]({
                scheduler: scheduler
              });

              _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_12___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_11___default()(VerticalEventMapper.prototype), "construct", this).call(this, {});
            }
          }, {
            key: "init",
            value: function init() {
              var me = this,
                  scheduler = me.scheduler; // Resource header/columns

              me.resourceColumns = scheduler.timeAxisColumn.resourceColumns; // Vertical time axis

              me.timeView = scheduler.timeView;
              scheduler.element.classList.add('b-sch-vertical');
              scheduler.on({
                assignmentstorechange: me.onChangeAssignmentStore,
                resourcestorechange: me.onChangeResourceStore,
                thisObj: me
              });
              me.resourceColumns.on({
                columnWidthChange: me.onResourceColumnWidthChange,
                thisObj: me
              });
              me.resourceStore = scheduler.resourceStore;
              me.assignmentStore = scheduler.assignmentStore;
              me.initialized = true;
              me.renderer();
              me.resourceColumns.availableWidth = scheduler.timeAxisSubGrid.width;
            } //endregion
            //region Elements <-> Records

          }, {
            key: "resolveRowRecord",
            value: function resolveRowRecord(elementOrEvent, xy) {
              var me = this,
                  scheduler = me.scheduler,
                  event = elementOrEvent instanceof Event ? elementOrEvent : null,
                  element = event ? event.target : elementOrEvent,
                  coords = event ? [event.offsetX, event.offsetY] : xy,
                  el = element.nodeType === 3 ? element.parentElement : element,
                  eventElement = _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].up(el, scheduler.eventSelector);

              if (eventElement) {
                return scheduler.resourceStore.getById(eventElement.dataset.resourceId);
              } // Need to be inside schedule at least


              if (!_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].up(element, '.b-sch-timeaxis-cell')) {
                return null;
              }

              var index = Math.floor(coords[0] / me.resourceColumns.columnWidth);
              return scheduler.resourceStore.getAt(index);
            }
          }, {
            key: "getElementFromEventRecord",
            value: function getElementFromEventRecord(eventRecord, resourceRecord) {
              // All elements for event + optionally assigned resource
              var elements = this.getElementsFromEventRecord(eventRecord, resourceRecord); // Return first one

              return elements.length ? elements[0] : null;
            }
          }, {
            key: "getElementsFromEventRecord",
            value: function getElementsFromEventRecord(eventRecord) {
              // Holds resources for which the event is drawn
              var map = this.eventMap[eventRecord.id]; // Return the elements for those

              return Object.values(map).map(function (data) {
                return data.element;
              });
            }
          }, {
            key: "toggleCls",
            value: function toggleCls(eventRecord, resourceRecord, cls) {
              var add = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

              var eventData = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getPath(this.eventMap, "".concat(eventRecord.id, ".").concat(resourceRecord.id));

              if (eventData) {
                eventData.tplData.cls[cls] = add ? 1 : 0;

                if (eventData.element) {
                  eventData.element.querySelector(this.scheduler.eventInnerSelector).classList[add ? 'add' : 'remove'](cls);
                }
              }
            } //endregion
            //region Coordinate <-> Date

          }, {
            key: "getDateFromXY",
            value: function getDateFromXY(xy, roundingMethod, local) {
              var coord = xy[1];

              if (!local) {
                coord = this.translateToScheduleCoordinate(coord);
              }

              return this.timeAxisViewModel.getDateFromPosition(coord, roundingMethod);
            }
          }, {
            key: "translateToScheduleCoordinate",
            value: function translateToScheduleCoordinate(y) {
              return y - this.scheduler._bodyRectangle.y + this.scheduler.scrollTop;
            }
          }, {
            key: "translateToPageCoordinate",
            value: function translateToPageCoordinate(y) {
              return y + this.scheduler._bodyRectangle.y - this.scheduler.scrollTop;
            } //endregion
            //region Regions

          }, {
            key: "getResourceEventBox",
            value: function getResourceEventBox(eventId, resourceId) {
              var _ref = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getPath(this.eventMap, "".concat(eventId, ".").concat(resourceId)) || {},
                  tplData = _ref.tplData;

              if (!tplData) {
                // Never been in view, lay it out
                this.layoutResource(this.scheduler.resourceStore.getById(resourceId)); // Have another go at getting the layout data

                tplData = _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].getPath(this.eventMap, "".concat(eventId, ".").concat(resourceId)).tplData;
              }

              return tplData ? {
                start: tplData.left,
                end: tplData.left + tplData.width,
                top: tplData.top,
                bottom: tplData.bottom
              } : null;
            }
          }, {
            key: "getScheduleRegion",
            value: function getScheduleRegion(resourceRecord, eventRecord, local) {
              var me = this,
                  scheduler = me.scheduler;

              var region = _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_19__["default"].from(scheduler.timeAxisSubGridElement);

              if (resourceRecord) {
                // TODO: How to account for eventRecord here?
                region.left = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth;
                region.right = region.left + scheduler.resourceColumnWidth;
              }

              var start = scheduler.timeAxis.startDate,
                  end = scheduler.timeAxis.endDate,
                  dateConstraints = scheduler.getDateConstraints(resourceRecord, eventRecord) || {
                start: start,
                end: end
              },
                  startY = scheduler.getCoordinateFromDate(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].max(start, dateConstraints.start)),
                  endY = scheduler.getCoordinateFromDate(_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].min(end, dateConstraints.end));

              if (!local) {
                region.top = me.translateToPageCoordinate(startY);
                region.bottom = me.translateToPageCoordinate(endY);
              } else {
                region.top = startY;
                region.bottom = endY;
              }

              return region;
            }
          }, {
            key: "getRowRegion",
            value: function getRowRegion(resourceRecord, startDate, endDate) {
              var me = this,
                  scheduler = me.scheduler,
                  x = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth,
                  taStart = scheduler.timeAxis.startDate,
                  taEnd = scheduler.timeAxis.endDate,
                  start = startDate ? _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].max(taStart, startDate) : taStart,
                  end = endDate ? _Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].min(taEnd, endDate) : taEnd,
                  startY = scheduler.getCoordinateFromDate(start),
                  endY = scheduler.getCoordinateFromDate(end, true, true),
                  y = Math.min(startY, endY),
                  height = Math.abs(startY - endY);
              return new _Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_19__["default"](x, y, scheduler.resourceColumnWidth, height);
            }
          }, {
            key: "getVisibleDateRange",
            value: function getVisibleDateRange() {
              var scheduler = this.scheduler,
                  scrollPos = scheduler.scrollable.y,
                  height = scheduler.scrollable.clientHeight;
              return {
                startDate: scheduler.getDateFromCoordinate(scrollPos),
                endDate: scheduler.getDateFromCoordinate(scrollPos + height) || scheduler.timeAxis.endDate
              };
            } //endregion
            //region Events
            // Column width changed, rerender fully

          }, {
            key: "onResourceColumnWidthChange",
            value: function onResourceColumnWidthChange(_ref2) {
              var width = _ref2.width,
                  oldWidth = _ref2.oldWidth;
              var me = this,
                  scheduler = me.scheduler; // Fix width of column & header

              me.resourceColumns.width = scheduler.timeAxisColumn.width = me.resourceStore.count * width;
              me.clearAll(); // Only transition large changes, otherwise it is janky when dragging slider in demo

              scheduler.runWithTransition(function () {
                return me.renderer();
              }, Math.abs(width - oldWidth) > 30); // Not detected by resizeobserver? Need to call this for virtual scrolling to react to update
              //        scheduler.callEachSubGrid('refreshFakeScroll');
              //        scheduler.refreshVirtualScrollbars();
            } //endregion
            //region EventStore

          }, {
            key: "onEventStoreChange",
            value: function onEventStoreChange(_ref3) {
              var source = _ref3.source,
                  action = _ref3.action,
                  records = _ref3.records,
                  record = _ref3.record,
                  replaced = _ref3.replaced,
                  changes = _ref3.changes;
              var me = this,
                  eventRecords = records || (record ? [record] : []),
                  resourceIds = new Set();
              var transition = true;
              eventRecords.forEach(function (eventRecord) {
                eventRecord.resources.forEach(function (resourceRecord) {
                  return resourceIds.add(resourceRecord.id);
                });
              });

              switch (action) {
                // No-ops
                case 'sort':
                case 'group':
                case 'move':
                  // Order in EventStore does not matter, so these actions are no-ops
                  return;

                case 'dataset':
                  me.clearAll();
                  transition = false;
                  break;

                case 'add':
                case 'remove':
                case 'updateMultiple':
                  // Clear all affected resources
                  me.clearResources(resourceIds);
                  break;

                case 'replace':
                  // Gather resources from both the old record and the new one
                  replaced.forEach(function (_ref4) {
                    var _ref5 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref4, 2),
                        oldEvent = _ref5[0],
                        newEvent = _ref5[1];

                    oldEvent.resources.map(function (resourceRecord) {
                      return resourceIds.add(resourceRecord.id);
                    });
                    newEvent.resources.map(function (resourceRecord) {
                      return resourceIds.add(resourceRecord.id);
                    });
                  }); // And clear them

                  me.clearResources(resourceIds);
                  break;

                case 'removeall':
                case 'filter':
                  // Clear all when filtering for simplicity. If that turns out to give bad performance, one would need to
                  // figure out which events was filtered out and only clear their resources.
                  me.clearAll();
                  break;

                case 'update':
                  // Removing a resource will unassign events, triggering an update. Ignore this case, since it will be
                  // handled by the resource store listener
                  if (record.meta.removingResource) {
                    return;
                  }

                  var processed = false; // Potentially affecting more elements in the same resource

                  if ('startDate' in changes || 'endDate' in changes || 'duration' in changes) {
                    me.clearResources(resourceIds);
                    processed = true;
                  } // Moved between resources, redraw both ends (new value already extracted above)


                  if ('resourceId' in changes) {
                    resourceIds.add(changes.resourceId.oldValue);
                    me.clearResources(resourceIds);
                    processed = true;
                  } // "Internal" change, not affecting layout


                  if (!processed) {
                    var eventDatas = Object.values(me.eventMap[record.id]);
                    eventDatas.forEach(function (eventData) {
                      // Update layout/contents
                      var tplData = eventData.tplData;
                      eventData.tplData = me.scheduler.generateTplData(tplData.eventRecord, tplData.resourceRecord);
                      eventData.tplData.left = tplData.left;
                      eventData.tplData.width = tplData.width;
                    });
                  }

                  break;
              }

              me.scheduler.runWithTransition(function () {
                return me.renderer();
              }, transition);
            } //endregion
            //region ResourceStore
            // Hook up resource store for the mapper and the resource header

          }, {
            key: "onChangeResourceStore",
            value: function onChangeResourceStore(_ref6) {
              var newResourceStore = _ref6.newResourceStore;
              var me = this; // Invalidate resource range and events

              me.firstResource = me.lastResource = null;
              me.clearAll();
              me.resourceStore = newResourceStore;
              me.renderer();
            }
          }, {
            key: "onResourceStoreChange",
            value: function onResourceStoreChange(_ref7) {
              var resourceStore = _ref7.source,
                  action = _ref7.action,
                  records = _ref7.records,
                  record = _ref7.record;
              var me = this,
                  resourceRecords = records || (record ? [record] : []);
              var transition = true; // Invalidate resource range

              me.firstResource = me.lastResource = null;

              switch (action) {
                case 'add':
                  // Make sure all existing events following added resources are offset correctly
                  var firstIndex = resourceRecords.reduce(function (index, record) {
                    return Math.min(index, resourceStore.indexOf(record));
                  }, resourceStore.count);

                  for (var i = firstIndex; i < resourceStore.count; i++) {
                    me.clearResources([resourceStore.getAt(i).id]);
                  }

                  return;
                // Will be redrawn from column width change

                case 'remove':
                case 'removeall':
                  // Cannot tell from which index a record was removed, update all.
                  me.clearAll();
                  return;
                // Will be redrawn from column width change

                case 'replace':
                case 'update':
                  // Only the invalidation above needed
                  break;

                case 'filter':
                  // All filtered out resources needs clearing and so does those not filtered out since they might have
                  // moved horizontally when others hide
                  me.clearAll();
                  break;
              }

              me.scheduler.runWithTransition(function () {
                return me.renderer();
              }, transition);
            }
          }, {
            key: "onResourceStoreRefresh",
            value: function onResourceStoreRefresh(_ref8) {
              var action = _ref8.action;
              var me = this;

              if (action === 'group') {
                throw new Error('Grouping of resources not supported in vertical mode');
              }

              if (action === 'sort') {
                // Invalidate resource range
                me.firstResource = me.lastResource = null;
                me.clearAll();
                me.scheduler.runWithTransition(function () {
                  return me.renderer();
                });
              }
            } //endregion
            //region AssignmentStore
            // Hook up assignment store for the mapper

          }, {
            key: "onChangeAssignmentStore",
            value: function onChangeAssignmentStore(_ref9) {
              var newAssignmentStore = _ref9.newAssignmentStore;
              this.assignmentStore = newAssignmentStore;
            }
          }, {
            key: "onAssignmentStoreChange",
            value: function onAssignmentStoreChange(_ref10) {
              var action = _ref10.action,
                  records = _ref10.records,
                  replaced = _ref10.replaced,
                  record = _ref10.record,
                  changes = _ref10.changes;
              var me = this,
                  assignmentRecords = records || (record ? [record] : []),
                  resourceIds = new Set(assignmentRecords.map(function (assignmentRecord) {
                return assignmentRecord.resourceId;
              }));
              var transition = true;

              switch (action) {
                case 'add':
                case 'remove':
                case 'updateMultiple':
                  me.clearResources(resourceIds);
                  break;

                case 'filter':
                case 'removeall':
                  me.clearAll();
                  break;

                case 'replace':
                  // Gather resources from both the old record and the new one
                  replaced.forEach(function (_ref11) {
                    var _ref12 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_2___default()(_ref11, 2),
                        oldAssignment = _ref12[0],
                        newAssignment = _ref12[1];

                    resourceIds.add(oldAssignment.resourceId);
                    resourceIds.add(newAssignment.resourceId);
                  }); // And clear them

                  me.clearResources(resourceIds);
                  break;

                case 'update':
                  // When reassigning, clear old resource also
                  if ('resourceId' in changes) {
                    resourceIds.add(changes.resourceId.oldValue);
                  }

                  me.clearResources(resourceIds);
                  break;
              }

              me.scheduler.runWithTransition(function () {
                return me.renderer();
              }, transition);
            } //endregion
            //region View hooks

          }, {
            key: "refreshRows",
            value: function refreshRows(reLayoutEvents) {
              if (reLayoutEvents) {
                this.clearAll();
                this.scheduler.refreshFromRerender = false;
              }
            }
          }, {
            key: "updateFromHorizontalScroll",
            value: function updateFromHorizontalScroll(scrollLeft) {
              if (scrollLeft !== this.prevScrollLeft) {
                this.renderer();
                this.prevScrollLeft = scrollLeft;
              }
            }
          }, {
            key: "updateFromVerticalScroll",
            value: function updateFromVerticalScroll() {
              this.renderer();
            }
          }, {
            key: "scrollResourceIntoView",
            value: function scrollResourceIntoView(resourceRecord, options) {
              var scheduler = this.scheduler,
                  x = scheduler.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth;
              return scheduler.scrollHorizontallyTo(x, options);
            } // Called when viewport size changes

          }, {
            key: "onViewportResize",
            value: function onViewportResize(width) {
              this.resourceColumns.availableWidth = width;
              this.renderer();
            } // Clear events in case they use date as part of displayed info

          }, {
            key: "onLocaleChange",
            value: function onLocaleChange() {
              this.clearAll();
            } // No need to do anything special

          }, {
            key: "onDragAbort",
            value: function onDragAbort() {}
          }, {
            key: "onBeforeRowHeightChange",
            value: function onBeforeRowHeightChange() {}
          }, {
            key: "onTimeAxisViewModelUpdate",
            value: function onTimeAxisViewModelUpdate() {}
          }, {
            key: "clearEvents",
            value: function clearEvents() {}
          }, {
            key: "updateElementId",
            value: function updateElementId() {}
          }, {
            key: "releaseTimeSpanDiv",
            value: function releaseTimeSpanDiv() {} //endregion
            //region Rendering
            // Resources in view + buffer

          }, {
            key: "getTimeSpanRenderData",
            value: function getTimeSpanRenderData(eventRecord, resourceRecord) {
              var includeOutside = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
              var me = this,
                  scheduler = me.scheduler,
                  startDate = eventRecord.startDate,
                  endDate = eventRecord.endDate,
                  top = scheduler.getCoordinateFromDate(startDate),
                  left = me.resourceStore.indexOf(resourceRecord) * scheduler.resourceColumnWidth,
                  width = scheduler.resourceColumnWidth - scheduler.resourceMargin * 2,
                  startDateMS = startDate.getTime(),
                  endDateMS = endDate.getTime();
              var bottom = scheduler.getCoordinateFromDate(endDate),
                  height = bottom - top; // Below, estimate height

              if (bottom === -1) {
                height = Math.round((endDateMS - startDateMS) * scheduler.timeAxisViewModel.getSingleUnitInPixels('ms'));
                bottom = top + height;
              }

              return {
                eventRecord: eventRecord,
                resourceRecord: resourceRecord,
                left: left,
                top: top,
                bottom: bottom,
                width: width,
                height: height,
                startDate: startDate,
                endDate: endDate,
                startDateMS: startDateMS,
                endDateMS: endDateMS,
                // to match horizontal, TODO: should change there
                start: startDate,
                end: endDate,
                startMs: startDateMS,
                endMs: endDateMS
              };
            } // Earlier start dates are above later tasks
            // If same start date, longer tasks float to top
            // If same start + duration, sort by name

          }, {
            key: "eventSorter",
            value: function eventSorter(a, b) {
              var startA = a.dataStartMs || a.startDateMS,
                  // dataXX are used if configured with fillTicks
              endA = a.dataEndMs || a.endDateMS,
                  startB = b.dataStartMs || b.startDateMS,
                  endB = b.dataEndMs || b.endDateMS,
                  sameStart = startA === startB;

              if (sameStart) {
                if (endA - endB === 0) {
                  return a.eventRecord.name < b.eventRecord.name ? -1 : 1;
                }

                return endA > endB ? -1 : 1;
              }

              return startA < startB ? -1 : 1;
            } // Calculate the layout for all events assigned to a resource. Since we are never stacking, the layout of one
            // resource will never affect the others

          }, {
            key: "layoutResource",
            value: function layoutResource(resourceRecord) {
              var me = this,
                  scheduler = me.scheduler,
                  cache = me.resourceMap[resourceRecord.id] = {},
                  resourceIndex = scheduler.resourceStore.indexOf(resourceRecord); // All events for the resource

              var events = scheduler.eventStore.getEventsForResource(resourceRecord); // Hook for features to inject additional timespans to render

              events = scheduler.getEventsToRender(resourceRecord, events); // Generate template data for all events, used for rendering and layout

              var layoutData = events.reduce(function (toLayout, eventRecord) {
                var tplData = scheduler.generateTplData(eventRecord, resourceRecord),
                    // Elements will be appended to eventData during syncing
                eventData = {
                  tplData: tplData
                }; // Cache per event, { e1 : { r1 : { xxx }, r2 : ... }, e2 : ... }
                // Uses tplData.eventId in favor of eventRecord.id to work with ResourceTimeRanges

                _Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"].setPath(me.eventMap, "".concat(tplData.eventId, ".").concat(resourceRecord.id), eventData); // Cache per resource


                cache[tplData.eventId] = eventData; // Position ResourceTimeRanges directly, they do not affect the layout of others

                if (tplData.fillSize) {
                  tplData.left = resourceIndex * scheduler.resourceColumnWidth;
                  tplData.width = scheduler.resourceColumnWidth;
                } // Anything not flagged with `fillSize` should take part in layout
                else {
                    toLayout.push(tplData);
                  }

                return toLayout;
              }, []); // Ensure the events are rendered in natural order so that navigation works.

              layoutData.sort(me.eventSorter); // Apply per resource event layout (pack, overlap or mixed)

              me.verticalLayout.applyLayout(layoutData, scheduler.resourceColumnWidth, scheduler.resourceMargin, scheduler.barMargin, resourceIndex);
              return cache;
            } // Render a single event, aborting if already in DOM. To update an event, first release its element and then render
            // it again. The element will be reused and updated. Keeps code simpler

          }, {
            key: "renderEvent",
            value: function renderEvent(eventData) {
              // No point in rendering event that already has an element
              var data = eventData.tplData,
                  resourceRecord = data.resourceRecord,
                  eventRecord = data.eventRecord,
                  elementConfig = {
                className: data.wrapperCls,
                tabIndex: '0',
                children: [{
                  className: data.cls,
                  style: (data.internalStyle || '') + (data.style || ''),
                  // Clone to be repeatable
                  html: data.body.cloneNode(true),
                  // Used for comparison, cheaper than comparing fragment from above
                  compareHtml: data.eventContent
                }],
                style: {
                  transform: "translate(".concat(data.left, "px, ").concat(data.top, "px)"),
                  // DomHelper appends px to dimensions when using numbers
                  height: data.height,
                  width: data.width,
                  zIndex: data.zIndex
                },
                dataset: {
                  resourceId: resourceRecord.id,
                  eventId: data.eventId,
                  // Not using eventRecord.id to distinguish between Event and ResourceTimeRange
                  // Sync using assignment id in multi assignment mode or event id in single assignment mode
                  syncId: data.assignment ? data.assignment.id : data.eventId
                },
                // Will not be part of DOM, but attached to the element
                elementData: eventData,
                // Dragging etc. flags element as retained, to not reuse/release it during that operation
                retainElement: eventRecord.instanceMeta(this.scheduler).retainElement
              }; // Do not want to spam dataset with empty prop when not using assignments

              if (data.assignment) {
                elementConfig.dataset.assignmentId = data.assignment.id;
              }

              return elementConfig;
            }
          }, {
            key: "renderResource",
            value: function renderResource(resourceRecord) {
              var me = this,
                  topDateMS = me.topDateMS,
                  bottomDateMS = me.bottomDateMS,
                  syncConfigs = [];
              var resourceEntry = me.resourceMap[resourceRecord.id]; // Layout all events for the resource unless already done

              if (!resourceEntry) {
                resourceEntry = me.layoutResource(resourceRecord);
              } // Iterate over all events for the resource


              for (var eventId in resourceEntry) {
                var eventData = resourceEntry[eventId]; // Only collect configs for those actually in view

                if (eventData.tplData.endDateMS >= topDateMS && eventData.tplData.startDateMS <= bottomDateMS) {
                  syncConfigs.push(me.renderEvent(eventData));
                }
              }

              return syncConfigs;
            } // Single cell so only one call to this renderer, determine which events are in view and draw them.
            // Drawing on scroll is triggered by `updateFromVerticalScroll()` and `updateFromHorizontalScroll()`

          }, {
            key: "renderer",
            value: function renderer() {
              var me = this,
                  scheduler = me.scheduler,
                  resourceStore = scheduler.resourceStore,
                  _me$resourceRange = me.resourceRange,
                  firstResource = _me$resourceRange.firstResource,
                  lastResource = _me$resourceRange.lastResource,
                  _me$dateRange = me.dateRange,
                  topDate = _me$dateRange.topDate,
                  bottomDate = _me$dateRange.bottomDate,
                  syncConfigs = [];

              if (!me.initialized) {
                return;
              } // Update current time range, reflecting the change on the vertical time axis header


              if (!_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isEqual(topDate, me.topDate) || !_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"].isEqual(bottomDate, me.bottomDate)) {
                // Calculated values used by `renderResource()`
                me.topDate = topDate;
                me.bottomDate = bottomDate;
                me.topDateMS = topDate.getTime();
                me.bottomDateMS = bottomDate.getTime();
                me.timeView.range = {
                  topDate: topDate,
                  bottomDate: bottomDate
                };
              }

              if (firstResource !== -1 && lastResource !== -1) {
                // Collect all events for resources in view
                for (var i = firstResource; i <= lastResource; i++) {
                  syncConfigs.push.apply(syncConfigs, me.renderResource(resourceStore.getAt(i)));
                }
              }

              _Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_16__["default"].sync({
                elementConfig: {
                  onlyChildren: true,
                  children: syncConfigs
                },
                targetElement: scheduler.foregroundCanvas,
                useSyncId: true,
                // Called by DomHelper when it creates, releases or reuses elements
                callback: function callback(_ref13) {
                  var action = _ref13.action,
                      config = _ref13.config,
                      oldConfig = _ref13.oldConfig,
                      element = _ref13.element; // If element is an event wrap, trigger appropriate events

                  if (config && config.className && config.className[scheduler.eventCls + '-wrap']) {
                    var // Some actions are considered first a release and then a render (reusing another element).
                    // This gives clients code a chance to clean up before reusing an element
                    isRelease = releaseEventActions[action],
                        isRender = renderEventActions[action]; // If we are reusing an element that was previously released we should not trigger again

                    if (isRelease && oldConfig) {
                      var data = oldConfig.elementData.tplData,
                          event = {
                        tplData: data,
                        assignmentRecord: data.assignment,
                        eventRecord: data.eventRecord,
                        resourceRecord: data.resourceRecord,
                        element: element
                      }; // This event is documented on Scheduler

                      scheduler.trigger('releaseEvent', event);
                    }

                    if (isRender) {
                      var _data = config.elementData.tplData,
                          _event = {
                        tplData: _data,
                        assignmentRecord: _data.assignment,
                        eventRecord: _data.eventRecord,
                        resourceRecord: _data.resourceRecord,
                        element: element
                      }; // Store element to allow easy mapping from record

                      element.elementData.element = element;
                      _event.reusingElement = action === 'reuseElement'; // This event is documented on Scheduler

                      scheduler.trigger('renderEvent', _event);
                    } // No changes during sync, but might need to hook up element again in case cache was cleared


                    if (action === 'none') {
                      config.elementData.element = element;
                    }
                  }
                }
              }); // Change in displayed resources?


              if (me.firstResource !== firstResource || me.lastResource !== lastResource) {
                // Update header to match
                me.resourceColumns.range = {
                  firstResource: firstResource,
                  lastResource: lastResource
                }; // Store which resources are currently in view

                me.firstResource = firstResource;
                me.lastResource = lastResource;
              }
            } //endregion
            //region Cache
            // Clears cached resource layout

          }, {
            key: "clearResources",
            value: function clearResources(resourceIds) {
              var _this = this;

              resourceIds.forEach(function (resourceId) {
                if (_this.resourceMap[resourceId]) {
                  Object.keys(_this.resourceMap[resourceId]).forEach(function (eventId) {
                    delete _this.eventMap[eventId][resourceId];
                  });
                  delete _this.resourceMap[resourceId];
                }
              });
            }
          }, {
            key: "clearAll",
            value: function clearAll() {
              this.resourceMap = {};
              this.eventMap = {};
            } //endregion

          }, {
            key: "resourceStore",
            set: function set(store) {
              var me = this;
              me.resourceStoreDetacher && me.resourceStoreDetacher();
              me.resourceColumns.resourceStore = me._resourceStore = store;
              me.resourceStoreDetacher = store.on({
                change: me.onResourceStoreChange,
                refresh: me.onResourceStoreRefresh,
                thisObj: me,
                prio: 1 // Call before others to clear cache before redraw

              });
            },
            get: function get() {
              return this._resourceStore;
            }
          }, {
            key: "assignmentStore",
            set: function set(store) {
              var me = this;
              me.assignmentStoreDetacher && me.assignmentStoreDetacher();
              me._assignmentStore = store;

              if (store) {
                me.assignmentStoreDetacher = store.on({
                  change: me.onAssignmentStoreChange,
                  thisObj: me
                });
              }
            },
            get: function get() {
              return this._assignmentStore;
            }
          }, {
            key: "resourceRange",
            get: function get() {
              var scheduler = this.scheduler,
                  resourceStore = this.resourceStore;

              if (!resourceStore || !resourceStore.count) {
                return {
                  firstResource: -1,
                  lastResource: -1
                };
              }

              return {
                firstResource: Math.max(Math.floor(scheduler.scrollLeft / scheduler.resourceColumnWidth) - 1, 0),
                lastResource: Math.min(Math.floor((scheduler.scrollLeft + scheduler.timeAxisSubGrid.width) / scheduler.resourceColumnWidth) + 1, resourceStore.count - 1)
              };
            } // Dates in view + buffer

          }, {
            key: "dateRange",
            get: function get() {
              var scheduler = this.scheduler;
              var bottomDate = scheduler.getDateFromCoordinate(Math.min(scheduler.scrollTop + scheduler.bodyHeight + scheduler.tickSize - 1, (scheduler.virtualScrollHeight || scheduler.scrollable.scrollHeight) - 1)); // Might end up below time axis (out of ticks)
              // TODO: Change call order on refresh to make sure this is not needed?

              if (!bottomDate) {
                bottomDate = scheduler.timeAxis.last.endDate;
              }

              return {
                topDate: scheduler.getDateFromCoordinate(Math.max(scheduler.scrollTop - scheduler.tickSize, 0)),
                bottomDate: bottomDate
              };
            }
          }], [{
            key: "properties",
            //region Config & Init
            get: function get() {
              return {
                eventMap: {},
                resourceMap: {},
                releasedElements: {}
              };
            }
          }]);

          return VerticalEventMapper;
        }(Object(_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_15__["default"])(_Common_Base_js__WEBPACK_IMPORTED_MODULE_14__["default"]));

        VerticalEventMapper._$name = 'VerticalEventMapper';
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/arrayWithHoles.js":
      /*!***************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/arrayWithHoles.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersArrayWithHolesJs(module, exports) {
        function _arrayWithHoles(arr) {
          if (Array.isArray(arr)) return arr;
        }

        module.exports = _arrayWithHoles;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
      /*!******************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersArrayWithoutHolesJs(module, exports) {
        function _arrayWithoutHoles(arr) {
          if (Array.isArray(arr)) {
            for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }

            return arr2;
          }
        }

        module.exports = _arrayWithoutHoles;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/assertThisInitialized.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/assertThisInitialized.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersAssertThisInitializedJs(module, exports) {
        function _assertThisInitialized(self) {
          if (self === void 0) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return self;
        }

        module.exports = _assertThisInitialized;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/asyncToGenerator.js":
      /*!*****************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/asyncToGenerator.js ***!
        \*****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersAsyncToGeneratorJs(module, exports) {
        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
          try {
            var info = gen[key](arg);
            var value = info.value;
          } catch (error) {
            reject(error);
            return;
          }

          if (info.done) {
            resolve(value);
          } else {
            Promise.resolve(value).then(_next, _throw);
          }
        }

        function _asyncToGenerator(fn) {
          return function () {
            var self = this,
                args = arguments;
            return new Promise(function (resolve, reject) {
              var gen = fn.apply(self, args);

              function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
              }

              function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
              }

              _next(undefined);
            });
          };
        }

        module.exports = _asyncToGenerator;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/classCallCheck.js":
      /*!***************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersClassCallCheckJs(module, exports) {
        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        module.exports = _classCallCheck;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/createClass.js":
      /*!************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersCreateClassJs(module, exports) {
        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        module.exports = _createClass;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/defineProperty.js":
      /*!***************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/defineProperty.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersDefinePropertyJs(module, exports) {
        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }

          return obj;
        }

        module.exports = _defineProperty;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/get.js":
      /*!****************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/get.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersGetJs(module, exports, __webpack_require__) {
        var getPrototypeOf = __webpack_require__(
        /*! ./getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");

        var superPropBase = __webpack_require__(
        /*! ./superPropBase */
        "./node_modules/@babel/runtime/helpers/superPropBase.js");

        function _get(target, property, receiver) {
          if (typeof Reflect !== "undefined" && Reflect.get) {
            module.exports = _get = Reflect.get;
          } else {
            module.exports = _get = function _get(target, property, receiver) {
              var base = superPropBase(target, property);
              if (!base) return;
              var desc = Object.getOwnPropertyDescriptor(base, property);

              if (desc.get) {
                return desc.get.call(receiver);
              }

              return desc.value;
            };
          }

          return _get(target, property, receiver || target);
        }

        module.exports = _get;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/getPrototypeOf.js":
      /*!***************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/getPrototypeOf.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersGetPrototypeOfJs(module, exports) {
        function _getPrototypeOf(o) {
          module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
          };
          return _getPrototypeOf(o);
        }

        module.exports = _getPrototypeOf;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/inherits.js":
      /*!*********************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/inherits.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersInheritsJs(module, exports, __webpack_require__) {
        var setPrototypeOf = __webpack_require__(
        /*! ./setPrototypeOf */
        "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function");
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              writable: true,
              configurable: true
            }
          });
          if (superClass) setPrototypeOf(subClass, superClass);
        }

        module.exports = _inherits;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/iterableToArray.js":
      /*!****************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersIterableToArrayJs(module, exports) {
        function _iterableToArray(iter) {
          if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
        }

        module.exports = _iterableToArray;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js":
      /*!*********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js ***!
        \*********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersIterableToArrayLimitJs(module, exports) {
        function _iterableToArrayLimit(arr, i) {
          var _arr = [];
          var _n = true;
          var _d = false;
          var _e = undefined;

          try {
            for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
              _arr.push(_s.value);

              if (i && _arr.length === i) break;
            }
          } catch (err) {
            _d = true;
            _e = err;
          } finally {
            try {
              if (!_n && _i["return"] != null) _i["return"]();
            } finally {
              if (_d) throw _e;
            }
          }

          return _arr;
        }

        module.exports = _iterableToArrayLimit;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/nonIterableRest.js":
      /*!****************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/nonIterableRest.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersNonIterableRestJs(module, exports) {
        function _nonIterableRest() {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }

        module.exports = _nonIterableRest;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/nonIterableSpread.js":
      /*!******************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersNonIterableSpreadJs(module, exports) {
        function _nonIterableSpread() {
          throw new TypeError("Invalid attempt to spread non-iterable instance");
        }

        module.exports = _nonIterableSpread;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js":
      /*!**************************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js ***!
        \**************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersPossibleConstructorReturnJs(module, exports, __webpack_require__) {
        var _typeof = __webpack_require__(
        /*! ../helpers/typeof */
        "./node_modules/@babel/runtime/helpers/typeof.js");

        var assertThisInitialized = __webpack_require__(
        /*! ./assertThisInitialized */
        "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");

        function _possibleConstructorReturn(self, call) {
          if (call && (_typeof(call) === "object" || typeof call === "function")) {
            return call;
          }

          return assertThisInitialized(self);
        }

        module.exports = _possibleConstructorReturn;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/set.js":
      /*!****************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/set.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersSetJs(module, exports, __webpack_require__) {
        var getPrototypeOf = __webpack_require__(
        /*! ./getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");

        var superPropBase = __webpack_require__(
        /*! ./superPropBase */
        "./node_modules/@babel/runtime/helpers/superPropBase.js");

        var defineProperty = __webpack_require__(
        /*! ./defineProperty */
        "./node_modules/@babel/runtime/helpers/defineProperty.js");

        function set(target, property, value, receiver) {
          if (typeof Reflect !== "undefined" && Reflect.set) {
            set = Reflect.set;
          } else {
            set = function set(target, property, value, receiver) {
              var base = superPropBase(target, property);
              var desc;

              if (base) {
                desc = Object.getOwnPropertyDescriptor(base, property);

                if (desc.set) {
                  desc.set.call(receiver, value);
                  return true;
                } else if (!desc.writable) {
                  return false;
                }
              }

              desc = Object.getOwnPropertyDescriptor(receiver, property);

              if (desc) {
                if (!desc.writable) {
                  return false;
                }

                desc.value = value;
                Object.defineProperty(receiver, property, desc);
              } else {
                defineProperty(receiver, property, value);
              }

              return true;
            };
          }

          return set(target, property, value, receiver);
        }

        function _set(target, property, value, receiver, isStrict) {
          var s = set(target, property, value, receiver || target);

          if (!s && isStrict) {
            throw new Error('failed to set property');
          }

          return value;
        }

        module.exports = _set;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/setPrototypeOf.js":
      /*!***************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/setPrototypeOf.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersSetPrototypeOfJs(module, exports) {
        function _setPrototypeOf(o, p) {
          module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
          };

          return _setPrototypeOf(o, p);
        }

        module.exports = _setPrototypeOf;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/slicedToArray.js":
      /*!**************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/slicedToArray.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersSlicedToArrayJs(module, exports, __webpack_require__) {
        var arrayWithHoles = __webpack_require__(
        /*! ./arrayWithHoles */
        "./node_modules/@babel/runtime/helpers/arrayWithHoles.js");

        var iterableToArrayLimit = __webpack_require__(
        /*! ./iterableToArrayLimit */
        "./node_modules/@babel/runtime/helpers/iterableToArrayLimit.js");

        var nonIterableRest = __webpack_require__(
        /*! ./nonIterableRest */
        "./node_modules/@babel/runtime/helpers/nonIterableRest.js");

        function _slicedToArray(arr, i) {
          return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
        }

        module.exports = _slicedToArray;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/superPropBase.js":
      /*!**************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/superPropBase.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersSuperPropBaseJs(module, exports, __webpack_require__) {
        var getPrototypeOf = __webpack_require__(
        /*! ./getPrototypeOf */
        "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");

        function _superPropBase(object, property) {
          while (!Object.prototype.hasOwnProperty.call(object, property)) {
            object = getPrototypeOf(object);
            if (object === null) break;
          }

          return object;
        }

        module.exports = _superPropBase;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js":
      /*!**********************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js ***!
        \**********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersTaggedTemplateLiteralJs(module, exports) {
        function _taggedTemplateLiteral(strings, raw) {
          if (!raw) {
            raw = strings.slice(0);
          }

          return Object.freeze(Object.defineProperties(strings, {
            raw: {
              value: Object.freeze(raw)
            }
          }));
        }

        module.exports = _taggedTemplateLiteral;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/toConsumableArray.js":
      /*!******************************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersToConsumableArrayJs(module, exports, __webpack_require__) {
        var arrayWithoutHoles = __webpack_require__(
        /*! ./arrayWithoutHoles */
        "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

        var iterableToArray = __webpack_require__(
        /*! ./iterableToArray */
        "./node_modules/@babel/runtime/helpers/iterableToArray.js");

        var nonIterableSpread = __webpack_require__(
        /*! ./nonIterableSpread */
        "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");

        function _toConsumableArray(arr) {
          return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
        }

        module.exports = _toConsumableArray;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/helpers/typeof.js":
      /*!*******************************************************!*\
        !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeHelpersTypeofJs(module, exports) {
        function _typeof2(obj) {
          if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
            _typeof2 = function _typeof2(obj) {
              return typeof obj;
            };
          } else {
            _typeof2 = function _typeof2(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
          }

          return _typeof2(obj);
        }

        function _typeof(obj) {
          if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
            module.exports = _typeof = function _typeof(obj) {
              return _typeof2(obj);
            };
          } else {
            module.exports = _typeof = function _typeof(obj) {
              return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
            };
          }

          return _typeof(obj);
        }

        module.exports = _typeof;
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime-module.js":
      /*!****************************************************************************************!*\
        !*** ./node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime-module.js ***!
        \****************************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeModuleJs(module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        // This method of obtaining a reference to the global object needs to be
        // kept identical to the way it is obtained in runtime.js
        var g = function () {
          return this || typeof self === "object" && self;
        }() || Function("return this")(); // Use `getOwnPropertyNames` because not all browsers support calling
        // `hasOwnProperty` on the global `self` object in a worker. See #183.


        var hadRuntime = g.regeneratorRuntime && Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0; // Save the old regeneratorRuntime in case it needs to be restored later.

        var oldRuntime = hadRuntime && g.regeneratorRuntime; // Force reevalutation of runtime.js.

        g.regeneratorRuntime = undefined;
        module.exports = __webpack_require__(
        /*! ./runtime */
        "./node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js");

        if (hadRuntime) {
          // Restore the original runtime.
          g.regeneratorRuntime = oldRuntime;
        } else {
          // Remove the global property added by runtime.js.
          try {
            delete g.regeneratorRuntime;
          } catch (e) {
            g.regeneratorRuntime = undefined;
          }
        }
        /***/

      },

      /***/
      "./node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js":
      /*!*********************************************************************************!*\
        !*** ./node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime.js ***!
        \*********************************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeNode_modulesRegeneratorRuntimeRuntimeJs(module, exports) {
        /**
         * Copyright (c) 2014-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        !function (global) {
          "use strict";

          var Op = Object.prototype;
          var hasOwn = Op.hasOwnProperty;
          var undefined; // More compressible than void 0.

          var $Symbol = typeof Symbol === "function" ? Symbol : {};
          var iteratorSymbol = $Symbol.iterator || "@@iterator";
          var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
          var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
          var inModule = typeof module === "object";
          var runtime = global.regeneratorRuntime;

          if (runtime) {
            if (inModule) {
              // If regeneratorRuntime is defined globally and we're in a module,
              // make the exports object identical to regeneratorRuntime.
              module.exports = runtime;
            } // Don't bother evaluating the rest of this file if the runtime was
            // already defined globally.


            return;
          } // Define the runtime globally (as expected by generated code) as either
          // module.exports (if we're in a module) or a new, empty object.


          runtime = global.regeneratorRuntime = inModule ? module.exports : {};

          function wrap(innerFn, outerFn, self, tryLocsList) {
            // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
            var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
            var generator = Object.create(protoGenerator.prototype);
            var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
            // .throw, and .return methods.

            generator._invoke = makeInvokeMethod(innerFn, self, context);
            return generator;
          }

          runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
          // record like context.tryEntries[i].completion. This interface could
          // have been (and was previously) designed to take a closure to be
          // invoked without arguments, but in all the cases we care about we
          // already have an existing method we want to call, so there's no need
          // to create a new function object. We can even get away with assuming
          // the method takes exactly one argument, since that happens to be true
          // in every case, so we don't have to touch the arguments object. The
          // only additional allocation required is the completion record, which
          // has a stable shape and so hopefully should be cheap to allocate.

          function tryCatch(fn, obj, arg) {
            try {
              return {
                type: "normal",
                arg: fn.call(obj, arg)
              };
            } catch (err) {
              return {
                type: "throw",
                arg: err
              };
            }
          }

          var GenStateSuspendedStart = "suspendedStart";
          var GenStateSuspendedYield = "suspendedYield";
          var GenStateExecuting = "executing";
          var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
          // breaking out of the dispatch switch statement.

          var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
          // .constructor.prototype properties for functions that return Generator
          // objects. For full spec compliance, you may wish to configure your
          // minifier not to mangle the names of these two functions.

          function Generator() {}

          function GeneratorFunction() {}

          function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
          // don't natively support it.


          var IteratorPrototype = {};

          IteratorPrototype[iteratorSymbol] = function () {
            return this;
          };

          var getProto = Object.getPrototypeOf;
          var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

          if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
            // This environment has a native %IteratorPrototype%; use it instead
            // of the polyfill.
            IteratorPrototype = NativeIteratorPrototype;
          }

          var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
          GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
          GeneratorFunctionPrototype.constructor = GeneratorFunction;
          GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
          // Iterator interface in terms of a single ._invoke method.

          function defineIteratorMethods(prototype) {
            ["next", "throw", "return"].forEach(function (method) {
              prototype[method] = function (arg) {
                return this._invoke(method, arg);
              };
            });
          }

          runtime.isGeneratorFunction = function (genFun) {
            var ctor = typeof genFun === "function" && genFun.constructor;
            return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
            // do is to check its .name property.
            (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
          };

          runtime.mark = function (genFun) {
            if (Object.setPrototypeOf) {
              Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
            } else {
              genFun.__proto__ = GeneratorFunctionPrototype;

              if (!(toStringTagSymbol in genFun)) {
                genFun[toStringTagSymbol] = "GeneratorFunction";
              }
            }

            genFun.prototype = Object.create(Gp);
            return genFun;
          }; // Within the body of any async function, `await x` is transformed to
          // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
          // `hasOwn.call(value, "__await")` to determine if the yielded value is
          // meant to be awaited.


          runtime.awrap = function (arg) {
            return {
              __await: arg
            };
          };

          function AsyncIterator(generator) {
            function invoke(method, arg, resolve, reject) {
              var record = tryCatch(generator[method], generator, arg);

              if (record.type === "throw") {
                reject(record.arg);
              } else {
                var result = record.arg;
                var value = result.value;

                if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                  return Promise.resolve(value.__await).then(function (value) {
                    invoke("next", value, resolve, reject);
                  }, function (err) {
                    invoke("throw", err, resolve, reject);
                  });
                }

                return Promise.resolve(value).then(function (unwrapped) {
                  // When a yielded Promise is resolved, its final value becomes
                  // the .value of the Promise<{value,done}> result for the
                  // current iteration.
                  result.value = unwrapped;
                  resolve(result);
                }, function (error) {
                  // If a rejected Promise was yielded, throw the rejection back
                  // into the async generator function so it can be handled there.
                  return invoke("throw", error, resolve, reject);
                });
              }
            }

            var previousPromise;

            function enqueue(method, arg) {
              function callInvokeWithMethodAndArg() {
                return new Promise(function (resolve, reject) {
                  invoke(method, arg, resolve, reject);
                });
              }

              return previousPromise = // If enqueue has been called before, then we want to wait until
              // all previous Promises have been resolved before calling invoke,
              // so that results are always delivered in the correct order. If
              // enqueue has not been called before, then it is important to
              // call invoke immediately, without waiting on a callback to fire,
              // so that the async generator function has the opportunity to do
              // any necessary setup in a predictable way. This predictability
              // is why the Promise constructor synchronously invokes its
              // executor callback, and why async functions synchronously
              // execute code before the first await. Since we implement simple
              // async functions in terms of async generators, it is especially
              // important to get this right, even though it requires care.
              previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
              // invocations of the iterator.
              callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            } // Define the unified helper method that is used to implement .next,
            // .throw, and .return (see defineIteratorMethods).


            this._invoke = enqueue;
          }

          defineIteratorMethods(AsyncIterator.prototype);

          AsyncIterator.prototype[asyncIteratorSymbol] = function () {
            return this;
          };

          runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
          // AsyncIterator objects; they just return a Promise for the value of
          // the final result produced by the iterator.

          runtime.async = function (innerFn, outerFn, self, tryLocsList) {
            var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
            return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
            : iter.next().then(function (result) {
              return result.done ? result.value : iter.next();
            });
          };

          function makeInvokeMethod(innerFn, self, context) {
            var state = GenStateSuspendedStart;
            return function invoke(method, arg) {
              if (state === GenStateExecuting) {
                throw new Error("Generator is already running");
              }

              if (state === GenStateCompleted) {
                if (method === "throw") {
                  throw arg;
                } // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                return doneResult();
              }

              context.method = method;
              context.arg = arg;

              while (true) {
                var delegate = context.delegate;

                if (delegate) {
                  var delegateResult = maybeInvokeDelegate(delegate, context);

                  if (delegateResult) {
                    if (delegateResult === ContinueSentinel) continue;
                    return delegateResult;
                  }
                }

                if (context.method === "next") {
                  // Setting context._sent for legacy support of Babel's
                  // function.sent implementation.
                  context.sent = context._sent = context.arg;
                } else if (context.method === "throw") {
                  if (state === GenStateSuspendedStart) {
                    state = GenStateCompleted;
                    throw context.arg;
                  }

                  context.dispatchException(context.arg);
                } else if (context.method === "return") {
                  context.abrupt("return", context.arg);
                }

                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);

                if (record.type === "normal") {
                  // If an exception is thrown from innerFn, we leave state ===
                  // GenStateExecuting and loop back for another invocation.
                  state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                  if (record.arg === ContinueSentinel) {
                    continue;
                  }

                  return {
                    value: record.arg,
                    done: context.done
                  };
                } else if (record.type === "throw") {
                  state = GenStateCompleted; // Dispatch the exception by looping back around to the
                  // context.dispatchException(context.arg) call above.

                  context.method = "throw";
                  context.arg = record.arg;
                }
              }
            };
          } // Call delegate.iterator[context.method](context.arg) and handle the
          // result, either by returning a { value, done } result from the
          // delegate iterator, or by modifying context.method and context.arg,
          // setting context.delegate to null, and returning the ContinueSentinel.


          function maybeInvokeDelegate(delegate, context) {
            var method = delegate.iterator[context.method];

            if (method === undefined) {
              // A .throw or .return when the delegate iterator has no .throw
              // method always terminates the yield* loop.
              context.delegate = null;

              if (context.method === "throw") {
                if (delegate.iterator.return) {
                  // If the delegate iterator has a return method, give it a
                  // chance to clean up.
                  context.method = "return";
                  context.arg = undefined;
                  maybeInvokeDelegate(delegate, context);

                  if (context.method === "throw") {
                    // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                  }
                }

                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
              }

              return ContinueSentinel;
            }

            var record = tryCatch(method, delegate.iterator, context.arg);

            if (record.type === "throw") {
              context.method = "throw";
              context.arg = record.arg;
              context.delegate = null;
              return ContinueSentinel;
            }

            var info = record.arg;

            if (!info) {
              context.method = "throw";
              context.arg = new TypeError("iterator result is not an object");
              context.delegate = null;
              return ContinueSentinel;
            }

            if (info.done) {
              // Assign the result of the finished delegate to the temporary
              // variable specified by delegate.resultName (see delegateYield).
              context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

              context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
              // exception, let the outer generator proceed normally. If
              // context.method was "next", forget context.arg since it has been
              // "consumed" by the delegate iterator. If context.method was
              // "return", allow the original .return call to continue in the
              // outer generator.

              if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
              }
            } else {
              // Re-yield the result returned by the delegate method.
              return info;
            } // The delegate iterator is finished, so forget it and continue with
            // the outer generator.


            context.delegate = null;
            return ContinueSentinel;
          } // Define Generator.prototype.{next,throw,return} in terms of the
          // unified ._invoke helper method.


          defineIteratorMethods(Gp);
          Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
          // @@iterator function is called on it. Some browsers' implementations of the
          // iterator prototype chain incorrectly implement this, causing the Generator
          // object to not be returned from this call. This ensures that doesn't happen.
          // See https://github.com/facebook/regenerator/issues/274 for more details.

          Gp[iteratorSymbol] = function () {
            return this;
          };

          Gp.toString = function () {
            return "[object Generator]";
          };

          function pushTryEntry(locs) {
            var entry = {
              tryLoc: locs[0]
            };

            if (1 in locs) {
              entry.catchLoc = locs[1];
            }

            if (2 in locs) {
              entry.finallyLoc = locs[2];
              entry.afterLoc = locs[3];
            }

            this.tryEntries.push(entry);
          }

          function resetTryEntry(entry) {
            var record = entry.completion || {};
            record.type = "normal";
            delete record.arg;
            entry.completion = record;
          }

          function Context(tryLocsList) {
            // The root entry object (effectively a try statement without a catch
            // or a finally block) gives us a place to store values thrown from
            // locations where there is no enclosing try statement.
            this.tryEntries = [{
              tryLoc: "root"
            }];
            tryLocsList.forEach(pushTryEntry, this);
            this.reset(true);
          }

          runtime.keys = function (object) {
            var keys = [];

            for (var key in object) {
              keys.push(key);
            }

            keys.reverse(); // Rather than returning an object with a next method, we keep
            // things simple and return the next function itself.

            return function next() {
              while (keys.length) {
                var key = keys.pop();

                if (key in object) {
                  next.value = key;
                  next.done = false;
                  return next;
                }
              } // To avoid creating an additional object, we just hang the .value
              // and .done properties off the next function object itself. This
              // also ensures that the minifier will not anonymize the function.


              next.done = true;
              return next;
            };
          };

          function values(iterable) {
            if (iterable) {
              var iteratorMethod = iterable[iteratorSymbol];

              if (iteratorMethod) {
                return iteratorMethod.call(iterable);
              }

              if (typeof iterable.next === "function") {
                return iterable;
              }

              if (!isNaN(iterable.length)) {
                var i = -1,
                    next = function next() {
                  while (++i < iterable.length) {
                    if (hasOwn.call(iterable, i)) {
                      next.value = iterable[i];
                      next.done = false;
                      return next;
                    }
                  }

                  next.value = undefined;
                  next.done = true;
                  return next;
                };

                return next.next = next;
              }
            } // Return an iterator with no values.


            return {
              next: doneResult
            };
          }

          runtime.values = values;

          function doneResult() {
            return {
              value: undefined,
              done: true
            };
          }

          Context.prototype = {
            constructor: Context,
            reset: function reset(skipTempReset) {
              this.prev = 0;
              this.next = 0; // Resetting context._sent for legacy support of Babel's
              // function.sent implementation.

              this.sent = this._sent = undefined;
              this.done = false;
              this.delegate = null;
              this.method = "next";
              this.arg = undefined;
              this.tryEntries.forEach(resetTryEntry);

              if (!skipTempReset) {
                for (var name in this) {
                  // Not sure about the optimal order of these conditions:
                  if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                    this[name] = undefined;
                  }
                }
              }
            },
            stop: function stop() {
              this.done = true;
              var rootEntry = this.tryEntries[0];
              var rootRecord = rootEntry.completion;

              if (rootRecord.type === "throw") {
                throw rootRecord.arg;
              }

              return this.rval;
            },
            dispatchException: function dispatchException(exception) {
              if (this.done) {
                throw exception;
              }

              var context = this;

              function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;

                if (caught) {
                  // If the dispatched exception was caught by a catch block,
                  // then let that catch block handle the exception normally.
                  context.method = "next";
                  context.arg = undefined;
                }

                return !!caught;
              }

              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];
                var record = entry.completion;

                if (entry.tryLoc === "root") {
                  // Exception thrown outside of any try block that could handle
                  // it, so set the completion value of the entire function to
                  // throw the exception.
                  return handle("end");
                }

                if (entry.tryLoc <= this.prev) {
                  var hasCatch = hasOwn.call(entry, "catchLoc");
                  var hasFinally = hasOwn.call(entry, "finallyLoc");

                  if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    } else if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else if (hasCatch) {
                    if (this.prev < entry.catchLoc) {
                      return handle(entry.catchLoc, true);
                    }
                  } else if (hasFinally) {
                    if (this.prev < entry.finallyLoc) {
                      return handle(entry.finallyLoc);
                    }
                  } else {
                    throw new Error("try statement without catch or finally");
                  }
                }
              }
            },
            abrupt: function abrupt(type, arg) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                  var finallyEntry = entry;
                  break;
                }
              }

              if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                // Ignore the finally entry if control is not jumping to a
                // location outside the try/catch block.
                finallyEntry = null;
              }

              var record = finallyEntry ? finallyEntry.completion : {};
              record.type = type;
              record.arg = arg;

              if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
              }

              return this.complete(record);
            },
            complete: function complete(record, afterLoc) {
              if (record.type === "throw") {
                throw record.arg;
              }

              if (record.type === "break" || record.type === "continue") {
                this.next = record.arg;
              } else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
              } else if (record.type === "normal" && afterLoc) {
                this.next = afterLoc;
              }

              return ContinueSentinel;
            },
            finish: function finish(finallyLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.finallyLoc === finallyLoc) {
                  this.complete(entry.completion, entry.afterLoc);
                  resetTryEntry(entry);
                  return ContinueSentinel;
                }
              }
            },
            "catch": function _catch(tryLoc) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var entry = this.tryEntries[i];

                if (entry.tryLoc === tryLoc) {
                  var record = entry.completion;

                  if (record.type === "throw") {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                  }

                  return thrown;
                }
              } // The context.catch method must only be called with a location
              // argument that corresponds to a known catch block.


              throw new Error("illegal catch attempt");
            },
            delegateYield: function delegateYield(iterable, resultName, nextLoc) {
              this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
              };

              if (this.method === "next") {
                // Deliberately forget the last sent value so that we don't
                // accidentally pass it on to the delegate.
                this.arg = undefined;
              }

              return ContinueSentinel;
            }
          };
        }( // In sloppy mode, unbound `this` refers to the global object, fallback to
        // Function constructor if we're in global strict mode. That is sadly a form
        // of indirect eval which violates Content Security Policy.
        function () {
          return this || typeof self === "object" && self;
        }() || Function("return this")());
        /***/
      },

      /***/
      "./node_modules/@babel/runtime/regenerator/index.js":
      /*!**********************************************************!*\
        !*** ./node_modules/@babel/runtime/regenerator/index.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesBabelRuntimeRegeneratorIndexJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! regenerator-runtime */
        "./node_modules/@babel/runtime/node_modules/regenerator-runtime/runtime-module.js");
        /***/
      },

      /***/
      "./node_modules/abortcontroller-polyfill/dist/umd-polyfill.js":
      /*!********************************************************************!*\
        !*** ./node_modules/abortcontroller-polyfill/dist/umd-polyfill.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesAbortcontrollerPolyfillDistUmdPolyfillJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

          (function (factory) {
            true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = factory, __WEBPACK_AMD_DEFINE_RESULT__ = typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? __WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module) : __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : undefined;
          })(function () {
            'use strict';

            function _classCallCheck(instance, Constructor) {
              if (!(instance instanceof Constructor)) {
                throw new TypeError("Cannot call a class as a function");
              }
            }

            function _defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }

            function _createClass(Constructor, protoProps, staticProps) {
              if (protoProps) _defineProperties(Constructor.prototype, protoProps);
              if (staticProps) _defineProperties(Constructor, staticProps);
              return Constructor;
            }

            function _inherits(subClass, superClass) {
              if (typeof superClass !== "function" && superClass !== null) {
                throw new TypeError("Super expression must either be null or a function");
              }

              subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                  value: subClass,
                  writable: true,
                  configurable: true
                }
              });
              if (superClass) _setPrototypeOf(subClass, superClass);
            }

            function _getPrototypeOf(o) {
              _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
              };
              return _getPrototypeOf(o);
            }

            function _setPrototypeOf(o, p) {
              _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
              };

              return _setPrototypeOf(o, p);
            }

            function _assertThisInitialized(self) {
              if (self === void 0) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              }

              return self;
            }

            function _possibleConstructorReturn(self, call) {
              if (call && (typeof call === "object" || typeof call === "function")) {
                return call;
              }

              return _assertThisInitialized(self);
            }

            function _superPropBase(object, property) {
              while (!Object.prototype.hasOwnProperty.call(object, property)) {
                object = _getPrototypeOf(object);
                if (object === null) break;
              }

              return object;
            }

            function _get(target, property, receiver) {
              if (typeof Reflect !== "undefined" && Reflect.get) {
                _get = Reflect.get;
              } else {
                _get = function _get(target, property, receiver) {
                  var base = _superPropBase(target, property);

                  if (!base) return;
                  var desc = Object.getOwnPropertyDescriptor(base, property);

                  if (desc.get) {
                    return desc.get.call(receiver);
                  }

                  return desc.value;
                };
              }

              return _get(target, property, receiver || target);
            }

            var Emitter =
            /*#__PURE__*/
            function () {
              function Emitter() {
                _classCallCheck(this, Emitter);

                Object.defineProperty(this, 'listeners', {
                  value: {},
                  writable: true,
                  configurable: true
                });
              }

              _createClass(Emitter, [{
                key: "addEventListener",
                value: function addEventListener(type, callback) {
                  if (!(type in this.listeners)) {
                    this.listeners[type] = [];
                  }

                  this.listeners[type].push(callback);
                }
              }, {
                key: "removeEventListener",
                value: function removeEventListener(type, callback) {
                  if (!(type in this.listeners)) {
                    return;
                  }

                  var stack = this.listeners[type];

                  for (var i = 0, l = stack.length; i < l; i++) {
                    if (stack[i] === callback) {
                      stack.splice(i, 1);
                      return;
                    }
                  }
                }
              }, {
                key: "dispatchEvent",
                value: function dispatchEvent(event) {
                  var _this = this;

                  if (!(event.type in this.listeners)) {
                    return;
                  }

                  var debounce = function debounce(callback) {
                    setTimeout(function () {
                      return callback.call(_this, event);
                    });
                  };

                  var stack = this.listeners[event.type];

                  for (var i = 0, l = stack.length; i < l; i++) {
                    debounce(stack[i]);
                  }

                  return !event.defaultPrevented;
                }
              }]);

              return Emitter;
            }();

            var AbortSignal =
            /*#__PURE__*/
            function (_Emitter) {
              _inherits(AbortSignal, _Emitter);

              function AbortSignal() {
                var _this2;

                _classCallCheck(this, AbortSignal);

                _this2 = _possibleConstructorReturn(this, _getPrototypeOf(AbortSignal).call(this)); // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
                // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl

                Object.defineProperty(_assertThisInitialized(_this2), 'aborted', {
                  value: false,
                  writable: true,
                  configurable: true
                });
                Object.defineProperty(_assertThisInitialized(_this2), 'onabort', {
                  value: null,
                  writable: true,
                  configurable: true
                });
                return _this2;
              }

              _createClass(AbortSignal, [{
                key: "toString",
                value: function toString() {
                  return '[object AbortSignal]';
                }
              }, {
                key: "dispatchEvent",
                value: function dispatchEvent(event) {
                  if (event.type === 'abort') {
                    this.aborted = true;

                    if (typeof this.onabort === 'function') {
                      this.onabort.call(this, event);
                    }
                  }

                  _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
                }
              }]);

              return AbortSignal;
            }(Emitter);

            var AbortController =
            /*#__PURE__*/
            function () {
              function AbortController() {
                _classCallCheck(this, AbortController); // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
                // we want Object.keys(new AbortController()) to be [] for compat with the native impl


                Object.defineProperty(this, 'signal', {
                  value: new AbortSignal(),
                  writable: true,
                  configurable: true
                });
              }

              _createClass(AbortController, [{
                key: "abort",
                value: function abort() {
                  var event;

                  try {
                    event = new Event('abort');
                  } catch (e) {
                    if (typeof document !== 'undefined') {
                      if (!document.createEvent) {
                        // For Internet Explorer 8:
                        event = document.createEventObject();
                        event.type = 'abort';
                      } else {
                        // For Internet Explorer 11:
                        event = document.createEvent('Event');
                        event.initEvent('abort', false, false);
                      }
                    } else {
                      // Fallback where document isn't available:
                      event = {
                        type: 'abort',
                        bubbles: false,
                        cancelable: false
                      };
                    }
                  }

                  this.signal.dispatchEvent(event);
                }
              }, {
                key: "toString",
                value: function toString() {
                  return '[object AbortController]';
                }
              }]);

              return AbortController;
            }();

            if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
              // These are necessary to make sure that we get correct output for:
              // Object.prototype.toString.call(new AbortController())
              AbortController.prototype[Symbol.toStringTag] = 'AbortController';
              AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
            }

            function polyfillNeeded(self) {
              if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
                console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
                return true;
              } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
              // defining window.Request, and this polyfill need to work on top of unfetch
              // so the below feature detection needs the !self.AbortController part.
              // The Request.prototype check is also needed because Safari versions 11.1.2
              // up to and including 12.1.x has a window.AbortController present but still
              // does NOT correctly implement abortable fetch:
              // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


              return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
            }
            /**
             * Note: the "fetch.Request" default value is available for fetch imported from
             * the "node-fetch" package and not in browsers. This is OK since browsers
             * will be importing umd-polyfill.js from that path "self" is passed the
             * decorator so the default value will not be used (because browsers that define
             * fetch also has Request). One quirky setup where self.fetch exists but
             * self.Request does not is when the "unfetch" minimal fetch polyfill is used
             * on top of IE11; for this case the browser will try to use the fetch.Request
             * default value which in turn will be undefined but then then "if (Request)"
             * will ensure that you get a patched fetch but still no Request (as expected).
             * @param {fetch, Request = fetch.Request}
             * @returns {fetch: abortableFetch, Request: AbortableRequest}
             */


            function abortableFetchDecorator(patchTargets) {
              if ('function' === typeof patchTargets) {
                patchTargets = {
                  fetch: patchTargets
                };
              }

              var _patchTargets = patchTargets,
                  fetch = _patchTargets.fetch,
                  _patchTargets$Request = _patchTargets.Request,
                  NativeRequest = _patchTargets$Request === void 0 ? fetch.Request : _patchTargets$Request,
                  NativeAbortController = _patchTargets.AbortController,
                  _patchTargets$__FORCE = _patchTargets.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL,
                  __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL = _patchTargets$__FORCE === void 0 ? false : _patchTargets$__FORCE;

              if (!polyfillNeeded({
                fetch: fetch,
                Request: NativeRequest,
                AbortController: NativeAbortController,
                __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL: __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL
              })) {
                return {
                  fetch: fetch,
                  Request: Request
                };
              }

              var Request = NativeRequest; // Note that the "unfetch" minimal fetch polyfill defines fetch() without
              // defining window.Request, and this polyfill need to work on top of unfetch
              // hence we only patch it if it's available. Also we don't patch it if signal
              // is already available on the Request prototype because in this case support
              // is present and the patching below can cause a crash since it assigns to
              // request.signal which is technically a read-only property. This latter error
              // happens when you run the main5.js node-fetch example in the repo
              // "abortcontroller-polyfill-examples". The exact error is:
              //   request.signal = init.signal;
              //   ^
              // TypeError: Cannot set property signal of #<Request> which has only a getter

              if (Request && !Request.prototype.hasOwnProperty('signal') || __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
                Request = function Request(input, init) {
                  var signal;

                  if (init && init.signal) {
                    signal = init.signal; // Never pass init.signal to the native Request implementation when the polyfill has
                    // been installed because if we're running on top of a browser with a
                    // working native AbortController (i.e. the polyfill was installed due to
                    // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
                    // fake AbortSignal to the native fetch will trigger:
                    // TypeError: Failed to construct 'Request': member signal is not of type AbortSignal.

                    delete init.signal;
                  }

                  var request = new NativeRequest(input, init);

                  if (signal) {
                    Object.defineProperty(request, 'signal', {
                      writable: false,
                      enumerable: false,
                      configurable: true,
                      value: signal
                    });
                  }

                  return request;
                };

                Request.prototype = NativeRequest.prototype;
              }

              var realFetch = fetch;

              var abortableFetch = function abortableFetch(input, init) {
                var signal = Request && Request.prototype.isPrototypeOf(input) ? input.signal : init ? init.signal : undefined;

                if (signal) {
                  var abortError;

                  try {
                    abortError = new DOMException('Aborted', 'AbortError');
                  } catch (err) {
                    // IE 11 does not support calling the DOMException constructor, use a
                    // regular error object on it instead.
                    abortError = new Error('Aborted');
                    abortError.name = 'AbortError';
                  } // Return early if already aborted, thus avoiding making an HTTP request


                  if (signal.aborted) {
                    return Promise.reject(abortError);
                  } // Turn an event into a promise, reject it once `abort` is dispatched


                  var cancellation = new Promise(function (_, reject) {
                    signal.addEventListener('abort', function () {
                      return reject(abortError);
                    }, {
                      once: true
                    });
                  });

                  if (init && init.signal) {
                    // Never pass .signal to the native implementation when the polyfill has
                    // been installed because if we're running on top of a browser with a
                    // working native AbortController (i.e. the polyfill was installed due to
                    // __FORCE_INSTALL_ABORTCONTROLLER_POLYFILL being set), then passing our
                    // fake AbortSignal to the native fetch will trigger:
                    // TypeError: Failed to execute 'fetch' on 'Window': member signal is not of type AbortSignal.
                    delete init.signal;
                  } // Return the fastest promise (don't need to wait for request to finish)


                  return Promise.race([cancellation, realFetch(input, init)]);
                }

                return realFetch(input, init);
              };

              return {
                fetch: abortableFetch,
                Request: Request
              };
            }

            (function (self) {
              if (!polyfillNeeded(self)) {
                return;
              }

              if (!self.fetch) {
                console.warn('fetch() is not available, cannot install abortcontroller-polyfill');
                return;
              }

              var _abortableFetch = abortableFetchDecorator(self),
                  fetch = _abortableFetch.fetch,
                  Request = _abortableFetch.Request;

              self.fetch = fetch;
              self.Request = Request;
              Object.defineProperty(self, 'AbortController', {
                writable: true,
                enumerable: false,
                configurable: true,
                value: AbortController
              });
              Object.defineProperty(self, 'AbortSignal', {
                writable: true,
                enumerable: false,
                configurable: true,
                value: AbortSignal
              });
            })(typeof self !== 'undefined' ? self : global);
          });
          /* WEBPACK VAR INJECTION */

        }).call(this, __webpack_require__(
        /*! ./../../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_a-function.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_a-function.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_aFunctionJs(module, exports) {
        module.exports = function (it) {
          if (typeof it != 'function') throw TypeError(it + ' is not a function!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_add-to-unscopables.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/_add-to-unscopables.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_addToUnscopablesJs(module, exports, __webpack_require__) {
        // 22.1.3.31 Array.prototype[@@unscopables]
        var UNSCOPABLES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('unscopables'),
            ArrayProto = Array.prototype;

        if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")(ArrayProto, UNSCOPABLES, {});

        module.exports = function (key) {
          ArrayProto[UNSCOPABLES][key] = true;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_an-instance.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_an-instance.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_anInstanceJs(module, exports) {
        module.exports = function (it, Constructor, name, forbiddenField) {
          if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
            throw TypeError(name + ': incorrect invocation!');
          }

          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_an-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_an-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_anObjectJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js");

        module.exports = function (it) {
          if (!isObject(it)) throw TypeError(it + ' is not an object!');
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_array-includes.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_array-includes.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_arrayIncludesJs(module, exports, __webpack_require__) {
        // false -> Array#indexOf
        // true  -> Array#includes
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"),
            toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js"),
            toIndex = __webpack_require__(
        /*! ./_to-index */
        "./node_modules/core-js/modules/_to-index.js");

        module.exports = function (IS_INCLUDES) {
          return function ($this, el, fromIndex) {
            var O = toIObject($this),
                length = toLength(O.length),
                index = toIndex(fromIndex, length),
                value; // Array#includes uses SameValueZero equality algorithm

            if (IS_INCLUDES && el != el) while (length > index) {
              value = O[index++];
              if (value != value) return true; // Array#toIndex ignores holes, Array#includes - not
            } else for (; length > index; index++) {
              if (IS_INCLUDES || index in O) {
                if (O[index] === el) return IS_INCLUDES || index || 0;
              }
            }
            return !IS_INCLUDES && -1;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_array-methods.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_array-methods.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_arrayMethodsJs(module, exports, __webpack_require__) {
        // 0 -> Array#forEach
        // 1 -> Array#map
        // 2 -> Array#filter
        // 3 -> Array#some
        // 4 -> Array#every
        // 5 -> Array#find
        // 6 -> Array#findIndex
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js"),
            IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/modules/_iobject.js"),
            toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js"),
            toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js"),
            asc = __webpack_require__(
        /*! ./_array-species-create */
        "./node_modules/core-js/modules/_array-species-create.js");

        module.exports = function (TYPE, $create) {
          var IS_MAP = TYPE == 1,
              IS_FILTER = TYPE == 2,
              IS_SOME = TYPE == 3,
              IS_EVERY = TYPE == 4,
              IS_FIND_INDEX = TYPE == 6,
              NO_HOLES = TYPE == 5 || IS_FIND_INDEX,
              create = $create || asc;
          return function ($this, callbackfn, that) {
            var O = toObject($this),
                self = IObject(O),
                f = ctx(callbackfn, that, 3),
                length = toLength(self.length),
                index = 0,
                result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined,
                val,
                res;

            for (; length > index; index++) {
              if (NO_HOLES || index in self) {
                val = self[index];
                res = f(val, index, O);

                if (TYPE) {
                  if (IS_MAP) result[index] = res; // map
                  else if (res) switch (TYPE) {
                      case 3:
                        return true;
                      // some

                      case 5:
                        return val;
                      // find

                      case 6:
                        return index;
                      // findIndex

                      case 2:
                        result.push(val);
                      // filter
                    } else if (IS_EVERY) return false; // every
                }
              }
            }

            return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_array-species-constructor.js":
      /*!********************************************************************!*\
        !*** ./node_modules/core-js/modules/_array-species-constructor.js ***!
        \********************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_arraySpeciesConstructorJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            isArray = __webpack_require__(
        /*! ./_is-array */
        "./node_modules/core-js/modules/_is-array.js"),
            SPECIES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (original) {
          var C;

          if (isArray(original)) {
            C = original.constructor; // cross-realm fallback

            if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;

            if (isObject(C)) {
              C = C[SPECIES];
              if (C === null) C = undefined;
            }
          }

          return C === undefined ? Array : C;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_array-species-create.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/modules/_array-species-create.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_arraySpeciesCreateJs(module, exports, __webpack_require__) {
        // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
        var speciesConstructor = __webpack_require__(
        /*! ./_array-species-constructor */
        "./node_modules/core-js/modules/_array-species-constructor.js");

        module.exports = function (original, length) {
          return new (speciesConstructor(original))(length);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_classof.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_classof.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_classofJs(module, exports, __webpack_require__) {
        // getting tag from 19.1.3.6 Object.prototype.toString()
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js"),
            TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('toStringTag') // ES3 wrong here
        ,
            ARG = cof(function () {
          return arguments;
        }()) == 'Arguments'; // fallback for IE11 Script Access Denied error


        var tryGet = function tryGet(it, key) {
          try {
            return it[key];
          } catch (e) {
            /* empty */
          }
        };

        module.exports = function (it) {
          var O, T, B;
          return it === undefined ? 'Undefined' : it === null ? 'Null' // @@toStringTag case
          : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T // builtinTag case
          : ARG ? cof(O) // ES3 arguments fallback
          : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_cof.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_cof.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_cofJs(module, exports) {
        var toString = {}.toString;

        module.exports = function (it) {
          return toString.call(it).slice(8, -1);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_collection-strong.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_collection-strong.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_collectionStrongJs(module, exports, __webpack_require__) {
        "use strict";

        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f,
            create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js"),
            redefineAll = __webpack_require__(
        /*! ./_redefine-all */
        "./node_modules/core-js/modules/_redefine-all.js"),
            ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js"),
            anInstance = __webpack_require__(
        /*! ./_an-instance */
        "./node_modules/core-js/modules/_an-instance.js"),
            defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js"),
            forOf = __webpack_require__(
        /*! ./_for-of */
        "./node_modules/core-js/modules/_for-of.js"),
            $iterDefine = __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/modules/_iter-define.js"),
            step = __webpack_require__(
        /*! ./_iter-step */
        "./node_modules/core-js/modules/_iter-step.js"),
            setSpecies = __webpack_require__(
        /*! ./_set-species */
        "./node_modules/core-js/modules/_set-species.js"),
            DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js"),
            fastKey = __webpack_require__(
        /*! ./_meta */
        "./node_modules/core-js/modules/_meta.js").fastKey,
            SIZE = DESCRIPTORS ? '_s' : 'size';

        var getEntry = function getEntry(that, key) {
          // fast case
          var index = fastKey(key),
              entry;
          if (index !== 'F') return that._i[index]; // frozen object case

          for (entry = that._f; entry; entry = entry.n) {
            if (entry.k == key) return entry;
          }
        };

        module.exports = {
          getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
            var C = wrapper(function (that, iterable) {
              anInstance(that, C, NAME, '_i');
              that._i = create(null); // index

              that._f = undefined; // first entry

              that._l = undefined; // last entry

              that[SIZE] = 0; // size

              if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
            });
            redefineAll(C.prototype, {
              // 23.1.3.1 Map.prototype.clear()
              // 23.2.3.2 Set.prototype.clear()
              clear: function clear() {
                for (var that = this, data = that._i, entry = that._f; entry; entry = entry.n) {
                  entry.r = true;
                  if (entry.p) entry.p = entry.p.n = undefined;
                  delete data[entry.i];
                }

                that._f = that._l = undefined;
                that[SIZE] = 0;
              },
              // 23.1.3.3 Map.prototype.delete(key)
              // 23.2.3.4 Set.prototype.delete(value)
              'delete': function _delete(key) {
                var that = this,
                    entry = getEntry(that, key);

                if (entry) {
                  var next = entry.n,
                      prev = entry.p;
                  delete that._i[entry.i];
                  entry.r = true;
                  if (prev) prev.n = next;
                  if (next) next.p = prev;
                  if (that._f == entry) that._f = next;
                  if (that._l == entry) that._l = prev;
                  that[SIZE]--;
                }

                return !!entry;
              },
              // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
              // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
              forEach: function forEach(callbackfn
              /*, that = undefined */
              ) {
                anInstance(this, C, 'forEach');
                var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3),
                    entry;

                while (entry = entry ? entry.n : this._f) {
                  f(entry.v, entry.k, this); // revert to the last existing entry

                  while (entry && entry.r) {
                    entry = entry.p;
                  }
                }
              },
              // 23.1.3.7 Map.prototype.has(key)
              // 23.2.3.7 Set.prototype.has(value)
              has: function has(key) {
                return !!getEntry(this, key);
              }
            });
            if (DESCRIPTORS) dP(C.prototype, 'size', {
              get: function get() {
                return defined(this[SIZE]);
              }
            });
            return C;
          },
          def: function def(that, key, value) {
            var entry = getEntry(that, key),
                prev,
                index; // change existing entry

            if (entry) {
              entry.v = value; // create new entry
            } else {
              that._l = entry = {
                i: index = fastKey(key, true),
                // <- index
                k: key,
                // <- key
                v: value,
                // <- value
                p: prev = that._l,
                // <- previous entry
                n: undefined,
                // <- next entry
                r: false // <- removed

              };
              if (!that._f) that._f = entry;
              if (prev) prev.n = entry;
              that[SIZE]++; // add to index

              if (index !== 'F') that._i[index] = entry;
            }

            return that;
          },
          getEntry: getEntry,
          setStrong: function setStrong(C, NAME, IS_MAP) {
            // add .keys, .values, .entries, [@@iterator]
            // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
            $iterDefine(C, NAME, function (iterated, kind) {
              this._t = iterated; // target

              this._k = kind; // kind

              this._l = undefined; // previous
            }, function () {
              var that = this,
                  kind = that._k,
                  entry = that._l; // revert to the last existing entry

              while (entry && entry.r) {
                entry = entry.p;
              } // get next entry


              if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return step(1);
              } // return step by kind


              if (kind == 'keys') return step(0, entry.k);
              if (kind == 'values') return step(0, entry.v);
              return step(0, [entry.k, entry.v]);
            }, IS_MAP ? 'entries' : 'values', !IS_MAP, true); // add [@@species], 23.1.2.2, 23.2.2.2

            setSpecies(NAME);
          }
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_collection.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_collection.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_collectionJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js"),
            redefineAll = __webpack_require__(
        /*! ./_redefine-all */
        "./node_modules/core-js/modules/_redefine-all.js"),
            meta = __webpack_require__(
        /*! ./_meta */
        "./node_modules/core-js/modules/_meta.js"),
            forOf = __webpack_require__(
        /*! ./_for-of */
        "./node_modules/core-js/modules/_for-of.js"),
            anInstance = __webpack_require__(
        /*! ./_an-instance */
        "./node_modules/core-js/modules/_an-instance.js"),
            isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js"),
            $iterDetect = __webpack_require__(
        /*! ./_iter-detect */
        "./node_modules/core-js/modules/_iter-detect.js"),
            setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js"),
            inheritIfRequired = __webpack_require__(
        /*! ./_inherit-if-required */
        "./node_modules/core-js/modules/_inherit-if-required.js");

        module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
          var Base = global[NAME],
              C = Base,
              ADDER = IS_MAP ? 'set' : 'add',
              proto = C && C.prototype,
              O = {};

          var fixMethod = function fixMethod(KEY) {
            var fn = proto[KEY];
            redefine(proto, KEY, KEY == 'delete' ? function (a) {
              return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
            } : KEY == 'has' ? function has(a) {
              return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
            } : KEY == 'get' ? function get(a) {
              return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
            } : KEY == 'add' ? function add(a) {
              fn.call(this, a === 0 ? 0 : a);
              return this;
            } : function set(a, b) {
              fn.call(this, a === 0 ? 0 : a, b);
              return this;
            });
          };

          if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
            new C().entries().next();
          }))) {
            // create collection constructor
            C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
            redefineAll(C.prototype, methods);
            meta.NEED = true;
          } else {
            var instance = new C() // early implementations not supports chaining
            ,
                HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
            ,
                THROWS_ON_PRIMITIVES = fails(function () {
              instance.has(1);
            }) // most early implementations doesn't supports iterables, most modern - not close it correctly
            ,
                ACCEPT_ITERABLES = $iterDetect(function (iter) {
              new C(iter);
            }) // eslint-disable-line no-new
            // for early implementations -0 and +0 not the same
            ,
                BUGGY_ZERO = !IS_WEAK && fails(function () {
              // V8 ~ Chromium 42- fails only with 5+ elements
              var $instance = new C(),
                  index = 5;

              while (index--) {
                $instance[ADDER](index, index);
              }

              return !$instance.has(-0);
            });

            if (!ACCEPT_ITERABLES) {
              C = wrapper(function (target, iterable) {
                anInstance(target, C, NAME);
                var that = inheritIfRequired(new Base(), target, C);
                if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
                return that;
              });
              C.prototype = proto;
              proto.constructor = C;
            }

            if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
              fixMethod('delete');
              fixMethod('has');
              IS_MAP && fixMethod('get');
            }

            if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER); // weak collections should not contains .clear method

            if (IS_WEAK && proto.clear) delete proto.clear;
          }

          setToStringTag(C, NAME);
          O[NAME] = C;
          $export($export.G + $export.W + $export.F * (C != Base), O);
          if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
          return C;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_core.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_core.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_coreJs(module, exports) {
        var core = module.exports = {
          version: '2.4.0'
        };
        if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_create-property.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_create-property.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_createPropertyJs(module, exports, __webpack_require__) {
        "use strict";

        var $defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js"),
            createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        module.exports = function (object, index, value) {
          if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_ctx.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_ctx.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ctxJs(module, exports, __webpack_require__) {
        // optional / simple context binding
        var aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js");

        module.exports = function (fn, that, length) {
          aFunction(fn);
          if (that === undefined) return fn;

          switch (length) {
            case 1:
              return function (a) {
                return fn.call(that, a);
              };

            case 2:
              return function (a, b) {
                return fn.call(that, a, b);
              };

            case 3:
              return function (a, b, c) {
                return fn.call(that, a, b, c);
              };
          }

          return function ()
          /* ...args */
          {
            return fn.apply(that, arguments);
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_defined.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_defined.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_definedJs(module, exports) {
        // 7.2.1 RequireObjectCoercible(argument)
        module.exports = function (it) {
          if (it == undefined) throw TypeError("Can't call method on  " + it);
          return it;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_descriptors.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_descriptors.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_descriptorsJs(module, exports, __webpack_require__) {
        // Thank's IE8 for his funny defineProperty
        module.exports = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty({}, 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_dom-create.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_dom-create.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_domCreateJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            document = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").document // in old IE typeof document.createElement is 'object'
        ,
            is = isObject(document) && isObject(document.createElement);

        module.exports = function (it) {
          return is ? document.createElement(it) : {};
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_enum-bug-keys.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_enum-bug-keys.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_enumBugKeysJs(module, exports) {
        // IE 8- don't enum bug keys
        module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_enum-keys.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_enum-keys.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_enumKeysJs(module, exports, __webpack_require__) {
        // all enumerable object keys, includes symbols
        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js"),
            gOPS = __webpack_require__(
        /*! ./_object-gops */
        "./node_modules/core-js/modules/_object-gops.js"),
            pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/modules/_object-pie.js");

        module.exports = function (it) {
          var result = getKeys(it),
              getSymbols = gOPS.f;

          if (getSymbols) {
            var symbols = getSymbols(it),
                isEnum = pIE.f,
                i = 0,
                key;

            while (symbols.length > i) {
              if (isEnum.call(it, key = symbols[i++])) result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_export.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_export.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_exportJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js"),
            hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js"),
            redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js"),
            ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js"),
            PROTOTYPE = 'prototype';

        var $export = function $export(type, name, source) {
          var IS_FORCED = type & $export.F,
              IS_GLOBAL = type & $export.G,
              IS_STATIC = type & $export.S,
              IS_PROTO = type & $export.P,
              IS_BIND = type & $export.B,
              target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE],
              exports = IS_GLOBAL ? core : core[name] || (core[name] = {}),
              expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {}),
              key,
              own,
              out,
              exp;
          if (IS_GLOBAL) source = name;

          for (key in source) {
            // contains in native
            own = !IS_FORCED && target && target[key] !== undefined; // export native or passed

            out = (own ? target : source)[key]; // bind timers to global for call from export context

            exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out; // extend global

            if (target) redefine(target, key, out, type & $export.U); // export

            if (exports[key] != out) hide(exports, key, exp);
            if (IS_PROTO && expProto[key] != out) expProto[key] = out;
          }
        };

        global.core = core; // type bitmap

        $export.F = 1; // forced

        $export.G = 2; // global

        $export.S = 4; // static

        $export.P = 8; // proto

        $export.B = 16; // bind

        $export.W = 32; // wrap

        $export.U = 64; // safe

        $export.R = 128; // real proto method for `library` 

        module.exports = $export;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_fails-is-regexp.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_fails-is-regexp.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_failsIsRegexpJs(module, exports, __webpack_require__) {
        var MATCH = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('match');

        module.exports = function (KEY) {
          var re = /./;

          try {
            '/./'[KEY](re);
          } catch (e) {
            try {
              re[MATCH] = false;
              return !'/./'[KEY](re);
            } catch (f) {
              /* empty */
            }
          }

          return true;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_fails.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_fails.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_failsJs(module, exports) {
        module.exports = function (exec) {
          try {
            return !!exec();
          } catch (e) {
            return true;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_fix-re-wks.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_fix-re-wks.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_fixReWksJs(module, exports, __webpack_require__) {
        "use strict";

        var hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js"),
            redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js"),
            fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js"),
            defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js"),
            wks = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js");

        module.exports = function (KEY, length, exec) {
          var SYMBOL = wks(KEY),
              fns = exec(defined, SYMBOL, ''[KEY]),
              strfn = fns[0],
              rxfn = fns[1];

          if (fails(function () {
            var O = {};

            O[SYMBOL] = function () {
              return 7;
            };

            return ''[KEY](O) != 7;
          })) {
            redefine(String.prototype, KEY, strfn);
            hide(RegExp.prototype, SYMBOL, length == 2 // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
            // 21.2.5.11 RegExp.prototype[@@split](string, limit)
            ? function (string, arg) {
              return rxfn.call(string, this, arg);
            } // 21.2.5.6 RegExp.prototype[@@match](string)
            // 21.2.5.9 RegExp.prototype[@@search](string)
            : function (string) {
              return rxfn.call(string, this);
            });
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_flags.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_flags.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_flagsJs(module, exports, __webpack_require__) {
        "use strict"; // 21.2.5.3 get RegExp.prototype.flags

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        module.exports = function () {
          var that = anObject(this),
              result = '';
          if (that.global) result += 'g';
          if (that.ignoreCase) result += 'i';
          if (that.multiline) result += 'm';
          if (that.unicode) result += 'u';
          if (that.sticky) result += 'y';
          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_for-of.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_for-of.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_forOfJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js"),
            call = __webpack_require__(
        /*! ./_iter-call */
        "./node_modules/core-js/modules/_iter-call.js"),
            isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "./node_modules/core-js/modules/_is-array-iter.js"),
            anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js"),
            toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js"),
            getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "./node_modules/core-js/modules/core.get-iterator-method.js"),
            BREAK = {},
            RETURN = {};

        var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
          var iterFn = ITERATOR ? function () {
            return iterable;
          } : getIterFn(iterable),
              f = ctx(fn, that, entries ? 2 : 1),
              index = 0,
              length,
              step,
              iterator,
              result;
          if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!'); // fast case for arrays with default iterator

          if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
            result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
            if (result === BREAK || result === RETURN) return result;
          } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
            result = call(iterator, f, step.value, entries);
            if (result === BREAK || result === RETURN) return result;
          }
        };

        exports.BREAK = BREAK;
        exports.RETURN = RETURN;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_global.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_global.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_globalJs(module, exports) {
        // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
        var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
        if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

        /***/
      },

      /***/
      "./node_modules/core-js/modules/_has.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_has.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hasJs(module, exports) {
        var hasOwnProperty = {}.hasOwnProperty;

        module.exports = function (it, key) {
          return hasOwnProperty.call(it, key);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_hide.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_hide.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_hideJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js"),
            createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? function (object, key, value) {
          return dP.f(object, key, createDesc(1, value));
        } : function (object, key, value) {
          object[key] = value;
          return object;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_html.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_html.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_htmlJs(module, exports, __webpack_require__) {
        module.exports = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").document && document.documentElement;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_ie8-dom-define.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_ie8-dom-define.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_ie8DomDefineJs(module, exports, __webpack_require__) {
        module.exports = !__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return Object.defineProperty(__webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/modules/_dom-create.js")('div'), 'a', {
            get: function get() {
              return 7;
            }
          }).a != 7;
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_inherit-if-required.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/_inherit-if-required.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_inheritIfRequiredJs(module, exports, __webpack_require__) {
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            setPrototypeOf = __webpack_require__(
        /*! ./_set-proto */
        "./node_modules/core-js/modules/_set-proto.js").set;

        module.exports = function (that, target, C) {
          var P,
              S = target.constructor;

          if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
            setPrototypeOf(that, P);
          }

          return that;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_invoke.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_invoke.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_invokeJs(module, exports) {
        // fast apply, http://jsperf.lnkit.com/fast-apply/5
        module.exports = function (fn, args, that) {
          var un = that === undefined;

          switch (args.length) {
            case 0:
              return un ? fn() : fn.call(that);

            case 1:
              return un ? fn(args[0]) : fn.call(that, args[0]);

            case 2:
              return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);

            case 3:
              return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);

            case 4:
              return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
          }

          return fn.apply(that, args);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iobject.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_iobject.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iobjectJs(module, exports, __webpack_require__) {
        // fallback for non-array-like ES3 and non-enumerable old V8 strings
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js");

        module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
          return cof(it) == 'String' ? it.split('') : Object(it);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_is-array-iter.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_is-array-iter.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isArrayIterJs(module, exports, __webpack_require__) {
        // check on default Array iterator
        var Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js"),
            ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator'),
            ArrayProto = Array.prototype;

        module.exports = function (it) {
          return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_is-array.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/modules/_is-array.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isArrayJs(module, exports, __webpack_require__) {
        // 7.2.2 IsArray(argument)
        var cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js");

        module.exports = Array.isArray || function isArray(arg) {
          return cof(arg) == 'Array';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_is-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_is-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isObjectJs(module, exports) {
        module.exports = function (it) {
          return typeof it === 'object' ? it !== null : typeof it === 'function';
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_is-regexp.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_is-regexp.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_isRegexpJs(module, exports, __webpack_require__) {
        // 7.2.8 IsRegExp(argument)
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js"),
            MATCH = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('match');

        module.exports = function (it) {
          var isRegExp;
          return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-call.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-call.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterCallJs(module, exports, __webpack_require__) {
        // call something on iterator step with safe closing on error
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        module.exports = function (iterator, fn, value, entries) {
          try {
            return entries ? fn(anObject(value)[0], value[1]) : fn(value); // 7.4.6 IteratorClose(iterator, completion)
          } catch (e) {
            var ret = iterator['return'];
            if (ret !== undefined) anObject(ret.call(iterator));
            throw e;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-create.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-create.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterCreateJs(module, exports, __webpack_require__) {
        "use strict";

        var create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js"),
            descriptor = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js"),
            setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js"),
            IteratorPrototype = {}; // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()


        __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")(IteratorPrototype, __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator'), function () {
          return this;
        });

        module.exports = function (Constructor, NAME, next) {
          Constructor.prototype = create(IteratorPrototype, {
            next: descriptor(1, next)
          });
          setToStringTag(Constructor, NAME + ' Iterator');
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-define.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-define.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterDefineJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/modules/_library.js"),
            $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js"),
            hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js"),
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js"),
            $iterCreate = __webpack_require__(
        /*! ./_iter-create */
        "./node_modules/core-js/modules/_iter-create.js"),
            setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js"),
            getPrototypeOf = __webpack_require__(
        /*! ./_object-gpo */
        "./node_modules/core-js/modules/_object-gpo.js"),
            ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator'),
            BUGGY = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
        ,
            FF_ITERATOR = '@@iterator',
            KEYS = 'keys',
            VALUES = 'values';

        var returnThis = function returnThis() {
          return this;
        };

        module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
          $iterCreate(Constructor, NAME, next);

          var getMethod = function getMethod(kind) {
            if (!BUGGY && kind in proto) return proto[kind];

            switch (kind) {
              case KEYS:
                return function keys() {
                  return new Constructor(this, kind);
                };

              case VALUES:
                return function values() {
                  return new Constructor(this, kind);
                };
            }

            return function entries() {
              return new Constructor(this, kind);
            };
          };

          var TAG = NAME + ' Iterator',
              DEF_VALUES = DEFAULT == VALUES,
              VALUES_BUG = false,
              proto = Base.prototype,
              $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT],
              $default = $native || getMethod(DEFAULT),
              $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined,
              $anyNative = NAME == 'Array' ? proto.entries || $native : $native,
              methods,
              key,
              IteratorPrototype; // Fix native

          if ($anyNative) {
            IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));

            if (IteratorPrototype !== Object.prototype) {
              // Set @@toStringTag to native iterators
              setToStringTag(IteratorPrototype, TAG, true); // fix for some old engines

              if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
            }
          } // fix Array#{values, @@iterator}.name in V8 / FF


          if (DEF_VALUES && $native && $native.name !== VALUES) {
            VALUES_BUG = true;

            $default = function values() {
              return $native.call(this);
            };
          } // Define iterator


          if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
            hide(proto, ITERATOR, $default);
          } // Plug for library


          Iterators[NAME] = $default;
          Iterators[TAG] = returnThis;

          if (DEFAULT) {
            methods = {
              values: DEF_VALUES ? $default : getMethod(VALUES),
              keys: IS_SET ? $default : getMethod(KEYS),
              entries: $entries
            };
            if (FORCED) for (key in methods) {
              if (!(key in proto)) redefine(proto, key, methods[key]);
            } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
          }

          return methods;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-detect.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-detect.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterDetectJs(module, exports, __webpack_require__) {
        var ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator'),
            SAFE_CLOSING = false;

        try {
          var riter = [7][ITERATOR]();

          riter['return'] = function () {
            SAFE_CLOSING = true;
          };

          Array.from(riter, function () {
            throw 2;
          });
        } catch (e) {
          /* empty */
        }

        module.exports = function (exec, skipClosing) {
          if (!skipClosing && !SAFE_CLOSING) return false;
          var safe = false;

          try {
            var arr = [7],
                iter = arr[ITERATOR]();

            iter.next = function () {
              return {
                done: safe = true
              };
            };

            arr[ITERATOR] = function () {
              return iter;
            };

            exec(arr);
          } catch (e) {
            /* empty */
          }

          return safe;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iter-step.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iter-step.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iterStepJs(module, exports) {
        module.exports = function (done, value) {
          return {
            value: value,
            done: !!done
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_iterators.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_iterators.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_iteratorsJs(module, exports) {
        module.exports = {};
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_keyof.js":
      /*!************************************************!*\
        !*** ./node_modules/core-js/modules/_keyof.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_keyofJs(module, exports, __webpack_require__) {
        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js"),
            toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js");

        module.exports = function (object, el) {
          var O = toIObject(object),
              keys = getKeys(O),
              length = keys.length,
              index = 0,
              key;

          while (length > index) {
            if (O[key = keys[index++]] === el) return key;
          }
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_library.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_library.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_libraryJs(module, exports) {
        module.exports = false;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_meta.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_meta.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_metaJs(module, exports, __webpack_require__) {
        var META = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js")('meta'),
            isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            setDesc = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f,
            id = 0;

        var isExtensible = Object.isExtensible || function () {
          return true;
        };

        var FREEZE = !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return isExtensible(Object.preventExtensions({}));
        });

        var setMeta = function setMeta(it) {
          setDesc(it, META, {
            value: {
              i: 'O' + ++id,
              // object ID
              w: {} // weak collections IDs

            }
          });
        };

        var fastKey = function fastKey(it, create) {
          // return primitive with prefix
          if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;

          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return 'F'; // not necessary to add metadata

            if (!create) return 'E'; // add missing metadata

            setMeta(it); // return object ID
          }

          return it[META].i;
        };

        var getWeak = function getWeak(it, create) {
          if (!has(it, META)) {
            // can't set metadata to uncaught frozen object
            if (!isExtensible(it)) return true; // not necessary to add metadata

            if (!create) return false; // add missing metadata

            setMeta(it); // return hash weak collections IDs
          }

          return it[META].w;
        }; // add metadata on freeze-family methods calling


        var onFreeze = function onFreeze(it) {
          if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
          return it;
        };

        var meta = module.exports = {
          KEY: META,
          NEED: false,
          fastKey: fastKey,
          getWeak: getWeak,
          onFreeze: onFreeze
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_microtask.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_microtask.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_microtaskJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            macrotask = __webpack_require__(
        /*! ./_task */
        "./node_modules/core-js/modules/_task.js").set,
            Observer = global.MutationObserver || global.WebKitMutationObserver,
            process = global.process,
            Promise = global.Promise,
            isNode = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js")(process) == 'process';

        module.exports = function () {
          var head, last, notify;

          var flush = function flush() {
            var parent, fn;
            if (isNode && (parent = process.domain)) parent.exit();

            while (head) {
              fn = head.fn;
              head = head.next;

              try {
                fn();
              } catch (e) {
                if (head) notify();else last = undefined;
                throw e;
              }
            }

            last = undefined;
            if (parent) parent.enter();
          }; // Node.js


          if (isNode) {
            notify = function notify() {
              process.nextTick(flush);
            }; // browsers with MutationObserver

          } else if (Observer) {
            var toggle = true,
                node = document.createTextNode('');
            new Observer(flush).observe(node, {
              characterData: true
            }); // eslint-disable-line no-new

            notify = function notify() {
              node.data = toggle = !toggle;
            }; // environments with maybe non-completely correct, but existent Promise

          } else if (Promise && Promise.resolve) {
            var promise = Promise.resolve();

            notify = function notify() {
              promise.then(flush);
            }; // for other environments - macrotask based on:
            // - setImmediate
            // - MessageChannel
            // - window.postMessag
            // - onreadystatechange
            // - setTimeout

          } else {
            notify = function notify() {
              // strange IE + webpack dev server bug - use .call(global)
              macrotask.call(global, flush);
            };
          }

          return function (fn) {
            var task = {
              fn: fn,
              next: undefined
            };
            if (last) last.next = task;

            if (!head) {
              head = task;
              notify();
            }

            last = task;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-assign.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-assign.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectAssignJs(module, exports, __webpack_require__) {
        "use strict"; // 19.1.2.1 Object.assign(target, source, ...)

        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js"),
            gOPS = __webpack_require__(
        /*! ./_object-gops */
        "./node_modules/core-js/modules/_object-gops.js"),
            pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/modules/_object-pie.js"),
            toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js"),
            IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/modules/_iobject.js"),
            $assign = Object.assign; // should work with symbols and should have deterministic property order (V8 bug)


        module.exports = !$assign || __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          var A = {},
              B = {},
              S = Symbol(),
              K = 'abcdefghijklmnopqrst';
          A[S] = 7;
          K.split('').forEach(function (k) {
            B[k] = k;
          });
          return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
        }) ? function assign(target, source) {
          // eslint-disable-line no-unused-vars
          var T = toObject(target),
              aLen = arguments.length,
              index = 1,
              getSymbols = gOPS.f,
              isEnum = pIE.f;

          while (aLen > index) {
            var S = IObject(arguments[index++]),
                keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S),
                length = keys.length,
                j = 0,
                key;

            while (length > j) {
              if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
            }
          }

          return T;
        } : $assign;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-create.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-create.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectCreateJs(module, exports, __webpack_require__) {
        // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js"),
            dPs = __webpack_require__(
        /*! ./_object-dps */
        "./node_modules/core-js/modules/_object-dps.js"),
            enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js"),
            IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO'),
            Empty = function Empty() {
          /* empty */
        },
            PROTOTYPE = 'prototype'; // Create object with fake `null` prototype: use iframe Object with cleared prototype


        var _createDict2 = function createDict() {
          // Thrash, waste and sodomy: IE GC bug
          var iframe = __webpack_require__(
          /*! ./_dom-create */
          "./node_modules/core-js/modules/_dom-create.js")('iframe'),
              i = enumBugKeys.length,
              lt = '<',
              gt = '>',
              iframeDocument;

          iframe.style.display = 'none';

          __webpack_require__(
          /*! ./_html */
          "./node_modules/core-js/modules/_html.js").appendChild(iframe);

          iframe.src = 'javascript:'; // eslint-disable-line no-script-url
          // createDict = iframe.contentWindow.Object;
          // html.removeChild(iframe);

          iframeDocument = iframe.contentWindow.document;
          iframeDocument.open();
          iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
          iframeDocument.close();
          _createDict2 = iframeDocument.F;

          while (i--) {
            delete _createDict2[PROTOTYPE][enumBugKeys[i]];
          }

          return _createDict2();
        };

        module.exports = Object.create || function create(O, Properties) {
          var result;

          if (O !== null) {
            Empty[PROTOTYPE] = anObject(O);
            result = new Empty();
            Empty[PROTOTYPE] = null; // add "__proto__" for Object.getPrototypeOf polyfill

            result[IE_PROTO] = O;
          } else result = _createDict2();

          return Properties === undefined ? result : dPs(result, Properties);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-dp.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-dp.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectDpJs(module, exports, __webpack_require__) {
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js"),
            IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/modules/_ie8-dom-define.js"),
            toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js"),
            dP = Object.defineProperty;

        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
          anObject(O);
          P = toPrimitive(P, true);
          anObject(Attributes);
          if (IE8_DOM_DEFINE) try {
            return dP(O, P, Attributes);
          } catch (e) {
            /* empty */
          }
          if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
          if ('value' in Attributes) O[P] = Attributes.value;
          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-dps.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-dps.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectDpsJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js"),
            anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js"),
            getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        module.exports = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? Object.defineProperties : function defineProperties(O, Properties) {
          anObject(O);
          var keys = getKeys(Properties),
              length = keys.length,
              i = 0,
              P;

          while (length > i) {
            dP.f(O, P = keys[i++], Properties[P]);
          }

          return O;
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-forced-pam.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_object-forced-pam.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectForcedPamJs(module, exports, __webpack_require__) {
        // Forced replacement prototype accessors methods
        module.exports = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/modules/_library.js") || !__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          var K = Math.random(); // In FF throws only define methods

          __defineSetter__.call(null, K, function () {
            /* empty */
          });

          delete __webpack_require__(
          /*! ./_global */
          "./node_modules/core-js/modules/_global.js")[K];
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-gopd.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gopd.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopdJs(module, exports, __webpack_require__) {
        var pIE = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/modules/_object-pie.js"),
            createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js"),
            toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"),
            toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js"),
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            IE8_DOM_DEFINE = __webpack_require__(
        /*! ./_ie8-dom-define */
        "./node_modules/core-js/modules/_ie8-dom-define.js"),
            gOPD = Object.getOwnPropertyDescriptor;

        exports.f = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") ? gOPD : function getOwnPropertyDescriptor(O, P) {
          O = toIObject(O);
          P = toPrimitive(P, true);
          if (IE8_DOM_DEFINE) try {
            return gOPD(O, P);
          } catch (e) {
            /* empty */
          }
          if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-gopn-ext.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gopn-ext.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopnExtJs(module, exports, __webpack_require__) {
        // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
        var toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"),
            gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "./node_modules/core-js/modules/_object-gopn.js").f,
            toString = {}.toString;

        var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

        var getWindowNames = function getWindowNames(it) {
          try {
            return gOPN(it);
          } catch (e) {
            return windowNames.slice();
          }
        };

        module.exports.f = function getOwnPropertyNames(it) {
          return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-gopn.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gopn.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopnJs(module, exports, __webpack_require__) {
        // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/modules/_object-keys-internal.js"),
            hiddenKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js").concat('length', 'prototype');

        exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
          return $keys(O, hiddenKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-gops.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gops.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGopsJs(module, exports) {
        exports.f = Object.getOwnPropertySymbols;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-gpo.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-gpo.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectGpoJs(module, exports, __webpack_require__) {
        // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js"),
            IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO'),
            ObjectProto = Object.prototype;

        module.exports = Object.getPrototypeOf || function (O) {
          O = toObject(O);
          if (has(O, IE_PROTO)) return O[IE_PROTO];

          if (typeof O.constructor == 'function' && O instanceof O.constructor) {
            return O.constructor.prototype;
          }

          return O instanceof Object ? ObjectProto : null;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-keys-internal.js":
      /*!***************************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys-internal.js ***!
        \***************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysInternalJs(module, exports, __webpack_require__) {
        var has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"),
            arrayIndexOf = __webpack_require__(
        /*! ./_array-includes */
        "./node_modules/core-js/modules/_array-includes.js")(false),
            IE_PROTO = __webpack_require__(
        /*! ./_shared-key */
        "./node_modules/core-js/modules/_shared-key.js")('IE_PROTO');

        module.exports = function (object, names) {
          var O = toIObject(object),
              i = 0,
              result = [],
              key;

          for (key in O) {
            if (key != IE_PROTO) has(O, key) && result.push(key);
          } // Don't enum bug & hidden keys


          while (names.length > i) {
            if (has(O, key = names[i++])) {
              ~arrayIndexOf(result, key) || result.push(key);
            }
          }

          return result;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-keys.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_object-keys.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 / 15.2.3.14 Object.keys(O)
        var $keys = __webpack_require__(
        /*! ./_object-keys-internal */
        "./node_modules/core-js/modules/_object-keys-internal.js"),
            enumBugKeys = __webpack_require__(
        /*! ./_enum-bug-keys */
        "./node_modules/core-js/modules/_enum-bug-keys.js");

        module.exports = Object.keys || function keys(O) {
          return $keys(O, enumBugKeys);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-pie.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-pie.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectPieJs(module, exports) {
        exports.f = {}.propertyIsEnumerable;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_object-sap.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_object-sap.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectSapJs(module, exports, __webpack_require__) {
        // most Object methods by ES6 should accept primitives
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js"),
            fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js");

        module.exports = function (KEY, exec) {
          var fn = (core.Object || {})[KEY] || Object[KEY],
              exp = {};
          exp[KEY] = exec(fn);
          $export($export.S + $export.F * fails(function () {
            fn(1);
          }), 'Object', exp);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_object-to-array.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/_object-to-array.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_objectToArrayJs(module, exports, __webpack_require__) {
        var getKeys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js"),
            toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"),
            isEnum = __webpack_require__(
        /*! ./_object-pie */
        "./node_modules/core-js/modules/_object-pie.js").f;

        module.exports = function (isEntries) {
          return function (it) {
            var O = toIObject(it),
                keys = getKeys(O),
                length = keys.length,
                i = 0,
                result = [],
                key;

            while (length > i) {
              if (isEnum.call(O, key = keys[i++])) {
                result.push(isEntries ? [key, O[key]] : O[key]);
              }
            }

            return result;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_property-desc.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_property-desc.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_propertyDescJs(module, exports) {
        module.exports = function (bitmap, value) {
          return {
            enumerable: !(bitmap & 1),
            configurable: !(bitmap & 2),
            writable: !(bitmap & 4),
            value: value
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_redefine-all.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/modules/_redefine-all.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_redefineAllJs(module, exports, __webpack_require__) {
        var redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js");

        module.exports = function (target, src, safe) {
          for (var key in src) {
            redefine(target, key, src[key], safe);
          }

          return target;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_redefine.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/modules/_redefine.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_redefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js"),
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            SRC = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js")('src'),
            TO_STRING = 'toString',
            $toString = Function[TO_STRING],
            TPL = ('' + $toString).split(TO_STRING);

        __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js").inspectSource = function (it) {
          return $toString.call(it);
        };

        (module.exports = function (O, key, val, safe) {
          var isFunction = typeof val == 'function';
          if (isFunction) has(val, 'name') || hide(val, 'name', key);
          if (O[key] === val) return;
          if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));

          if (O === global) {
            O[key] = val;
          } else {
            if (!safe) {
              delete O[key];
              hide(O, key, val);
            } else {
              if (O[key]) O[key] = val;else hide(O, key, val);
            }
          } // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative

        })(Function.prototype, TO_STRING, function toString() {
          return typeof this == 'function' && this[SRC] || $toString.call(this);
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_set-proto.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_set-proto.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_setProtoJs(module, exports, __webpack_require__) {
        // Works with __proto__ only. Old v8 can't work with null proto objects.

        /* eslint-disable no-proto */
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js");

        var check = function check(O, proto) {
          anObject(O);
          if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
        };

        module.exports = {
          set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
          function (test, buggy, set) {
            try {
              set = __webpack_require__(
              /*! ./_ctx */
              "./node_modules/core-js/modules/_ctx.js")(Function.call, __webpack_require__(
              /*! ./_object-gopd */
              "./node_modules/core-js/modules/_object-gopd.js").f(Object.prototype, '__proto__').set, 2);
              set(test, []);
              buggy = !(test instanceof Array);
            } catch (e) {
              buggy = true;
            }

            return function setPrototypeOf(O, proto) {
              check(O, proto);
              if (buggy) O.__proto__ = proto;else set(O, proto);
              return O;
            };
          }({}, false) : undefined),
          check: check
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_set-species.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_set-species.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_setSpeciesJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js"),
            DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js"),
            SPECIES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (KEY) {
          var C = global[KEY];
          if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
            configurable: true,
            get: function get() {
              return this;
            }
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_set-to-string-tag.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/_set-to-string-tag.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_setToStringTagJs(module, exports, __webpack_require__) {
        var def = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f,
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            TAG = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('toStringTag');

        module.exports = function (it, tag, stat) {
          if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, {
            configurable: true,
            value: tag
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_shared-key.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_shared-key.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedKeyJs(module, exports, __webpack_require__) {
        var shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('keys'),
            uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js");

        module.exports = function (key) {
          return shared[key] || (shared[key] = uid(key));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_shared.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/_shared.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_sharedJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            SHARED = '__core-js_shared__',
            store = global[SHARED] || (global[SHARED] = {});

        module.exports = function (key) {
          return store[key] || (store[key] = {});
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_species-constructor.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/_species-constructor.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_speciesConstructorJs(module, exports, __webpack_require__) {
        // 7.3.20 SpeciesConstructor(O, defaultConstructor)
        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js"),
            aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js"),
            SPECIES = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('species');

        module.exports = function (O, D) {
          var C = anObject(O).constructor,
              S;
          return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_string-at.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_string-at.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringAtJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js"),
            defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js"); // true  -> String#at
        // false -> String#codePointAt


        module.exports = function (TO_STRING) {
          return function (that, pos) {
            var s = String(defined(that)),
                i = toInteger(pos),
                l = s.length,
                a,
                b;
            if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
            a = s.charCodeAt(i);
            return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
          };
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_string-context.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/_string-context.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringContextJs(module, exports, __webpack_require__) {
        // helper for String#{startsWith, endsWith, includes}
        var isRegExp = __webpack_require__(
        /*! ./_is-regexp */
        "./node_modules/core-js/modules/_is-regexp.js"),
            defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (that, searchString, NAME) {
          if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
          return String(defined(that));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_string-repeat.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/_string-repeat.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringRepeatJs(module, exports, __webpack_require__) {
        "use strict";

        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js"),
            defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function repeat(count) {
          var str = String(defined(this)),
              res = '',
              n = toInteger(count);
          if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");

          for (; n > 0; (n >>>= 1) && (str += str)) {
            if (n & 1) res += str;
          }

          return res;
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_string-trim.js":
      /*!******************************************************!*\
        !*** ./node_modules/core-js/modules/_string-trim.js ***!
        \******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringTrimJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js"),
            fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js"),
            spaces = __webpack_require__(
        /*! ./_string-ws */
        "./node_modules/core-js/modules/_string-ws.js"),
            space = '[' + spaces + ']',
            non = "\u200B\x85",
            ltrim = RegExp('^' + space + space + '*'),
            rtrim = RegExp(space + space + '*$');

        var exporter = function exporter(KEY, exec, ALIAS) {
          var exp = {};
          var FORCE = fails(function () {
            return !!spaces[KEY]() || non[KEY]() != non;
          });
          var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
          if (ALIAS) exp[ALIAS] = fn;
          $export($export.P + $export.F * FORCE, 'String', exp);
        }; // 1 -> String#trimLeft
        // 2 -> String#trimRight
        // 3 -> String#trim


        var trim = exporter.trim = function (string, TYPE) {
          string = String(defined(string));
          if (TYPE & 1) string = string.replace(ltrim, '');
          if (TYPE & 2) string = string.replace(rtrim, '');
          return string;
        };

        module.exports = exporter;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_string-ws.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_string-ws.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_stringWsJs(module, exports) {
        module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_task.js":
      /*!***********************************************!*\
        !*** ./node_modules/core-js/modules/_task.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_taskJs(module, exports, __webpack_require__) {
        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js"),
            invoke = __webpack_require__(
        /*! ./_invoke */
        "./node_modules/core-js/modules/_invoke.js"),
            html = __webpack_require__(
        /*! ./_html */
        "./node_modules/core-js/modules/_html.js"),
            cel = __webpack_require__(
        /*! ./_dom-create */
        "./node_modules/core-js/modules/_dom-create.js"),
            global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            process = global.process,
            setTask = global.setImmediate,
            clearTask = global.clearImmediate,
            MessageChannel = global.MessageChannel,
            counter = 0,
            queue = {},
            ONREADYSTATECHANGE = 'onreadystatechange',
            defer,
            channel,
            port;

        var run = function run() {
          var id = +this;

          if (queue.hasOwnProperty(id)) {
            var fn = queue[id];
            delete queue[id];
            fn();
          }
        };

        var listener = function listener(event) {
          run.call(event.data);
        }; // Node.js 0.9+ & IE10+ has setImmediate, otherwise:


        if (!setTask || !clearTask) {
          setTask = function setImmediate(fn) {
            var args = [],
                i = 1;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            queue[++counter] = function () {
              invoke(typeof fn == 'function' ? fn : Function(fn), args);
            };

            defer(counter);
            return counter;
          };

          clearTask = function clearImmediate(id) {
            delete queue[id];
          }; // Node.js 0.8-


          if (__webpack_require__(
          /*! ./_cof */
          "./node_modules/core-js/modules/_cof.js")(process) == 'process') {
            defer = function defer(id) {
              process.nextTick(ctx(run, id, 1));
            }; // Browsers with MessageChannel, includes WebWorkers

          } else if (MessageChannel) {
            channel = new MessageChannel();
            port = channel.port2;
            channel.port1.onmessage = listener;
            defer = ctx(port.postMessage, port, 1); // Browsers with postMessage, skip WebWorkers
            // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
          } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
            defer = function defer(id) {
              global.postMessage(id + '', '*');
            };

            global.addEventListener('message', listener, false); // IE8-
          } else if (ONREADYSTATECHANGE in cel('script')) {
            defer = function defer(id) {
              html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
                html.removeChild(this);
                run.call(id);
              };
            }; // Rest old browsers

          } else {
            defer = function defer(id) {
              setTimeout(ctx(run, id, 1), 0);
            };
          }
        }

        module.exports = {
          set: setTask,
          clear: clearTask
        };
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_to-index.js":
      /*!***************************************************!*\
        !*** ./node_modules/core-js/modules/_to-index.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIndexJs(module, exports, __webpack_require__) {
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js"),
            max = Math.max,
            min = Math.min;

        module.exports = function (index, length) {
          index = toInteger(index);
          return index < 0 ? max(index + length, 0) : min(index, length);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-integer.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-integer.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIntegerJs(module, exports) {
        // 7.1.4 ToInteger
        var ceil = Math.ceil,
            floor = Math.floor;

        module.exports = function (it) {
          return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-iobject.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-iobject.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toIobjectJs(module, exports, __webpack_require__) {
        // to indexed object, toObject with fallback for non-array-like ES3 strings
        var IObject = __webpack_require__(
        /*! ./_iobject */
        "./node_modules/core-js/modules/_iobject.js"),
            defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return IObject(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-length.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-length.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toLengthJs(module, exports, __webpack_require__) {
        // 7.1.15 ToLength
        var toInteger = __webpack_require__(
        /*! ./_to-integer */
        "./node_modules/core-js/modules/_to-integer.js"),
            min = Math.min;

        module.exports = function (it) {
          return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-object.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/_to-object.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toObjectJs(module, exports, __webpack_require__) {
        // 7.1.13 ToObject(argument)
        var defined = __webpack_require__(
        /*! ./_defined */
        "./node_modules/core-js/modules/_defined.js");

        module.exports = function (it) {
          return Object(defined(it));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_to-primitive.js":
      /*!*******************************************************!*\
        !*** ./node_modules/core-js/modules/_to-primitive.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_toPrimitiveJs(module, exports, __webpack_require__) {
        // 7.1.1 ToPrimitive(input [, PreferredType])
        var isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"); // instead of the ES6 spec version, we didn't implement @@toPrimitive case
        // and the second argument - flag - preferred type is a string


        module.exports = function (it, S) {
          if (!isObject(it)) return it;
          var fn, val;
          if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
          if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
          throw TypeError("Can't convert object to primitive value");
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_uid.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_uid.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_uidJs(module, exports) {
        var id = 0,
            px = Math.random();

        module.exports = function (key) {
          return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_wks-define.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/_wks-define.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_wksDefineJs(module, exports, __webpack_require__) {
        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            core = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js"),
            LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/modules/_library.js"),
            wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "./node_modules/core-js/modules/_wks-ext.js"),
            defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f;

        module.exports = function (name) {
          var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
          if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, {
            value: wksExt.f(name)
          });
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/_wks-ext.js":
      /*!**************************************************!*\
        !*** ./node_modules/core-js/modules/_wks-ext.js ***!
        \**************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_wksExtJs(module, exports, __webpack_require__) {
        exports.f = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js");
        /***/
      },

      /***/
      "./node_modules/core-js/modules/_wks.js":
      /*!**********************************************!*\
        !*** ./node_modules/core-js/modules/_wks.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModules_wksJs(module, exports, __webpack_require__) {
        var store = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js")('wks'),
            uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js"),
            Symbol = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js").Symbol,
            USE_SYMBOL = typeof Symbol == 'function';

        var $exports = module.exports = function (name) {
          return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
        };

        $exports.store = store;
        /***/
      },

      /***/
      "./node_modules/core-js/modules/core.get-iterator-method.js":
      /*!******************************************************************!*\
        !*** ./node_modules/core-js/modules/core.get-iterator-method.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesCoreGetIteratorMethodJs(module, exports, __webpack_require__) {
        var classof = __webpack_require__(
        /*! ./_classof */
        "./node_modules/core-js/modules/_classof.js"),
            ITERATOR = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js")('iterator'),
            Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js");

        module.exports = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js").getIteratorMethod = function (it) {
          if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
        };
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.array.find-index.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.array.find-index.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ArrayFindIndexJs(module, exports, __webpack_require__) {
        "use strict"; // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            $find = __webpack_require__(
        /*! ./_array-methods */
        "./node_modules/core-js/modules/_array-methods.js")(6),
            KEY = 'findIndex',
            forced = true; // Shouldn't skip holes


        if (KEY in []) Array(1)[KEY](function () {
          forced = false;
        });
        $export($export.P + $export.F * forced, 'Array', {
          findIndex: function findIndex(callbackfn
          /*, that = undefined */
          ) {
            return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/modules/_add-to-unscopables.js")(KEY);
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.array.find.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.array.find.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ArrayFindJs(module, exports, __webpack_require__) {
        "use strict"; // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            $find = __webpack_require__(
        /*! ./_array-methods */
        "./node_modules/core-js/modules/_array-methods.js")(5),
            KEY = 'find',
            forced = true; // Shouldn't skip holes


        if (KEY in []) Array(1)[KEY](function () {
          forced = false;
        });
        $export($export.P + $export.F * forced, 'Array', {
          find: function find(callbackfn
          /*, that = undefined */
          ) {
            return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/modules/_add-to-unscopables.js")(KEY);
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.array.from.js":
      /*!********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.array.from.js ***!
        \********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ArrayFromJs(module, exports, __webpack_require__) {
        "use strict";

        var ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js"),
            $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js"),
            call = __webpack_require__(
        /*! ./_iter-call */
        "./node_modules/core-js/modules/_iter-call.js"),
            isArrayIter = __webpack_require__(
        /*! ./_is-array-iter */
        "./node_modules/core-js/modules/_is-array-iter.js"),
            toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js"),
            createProperty = __webpack_require__(
        /*! ./_create-property */
        "./node_modules/core-js/modules/_create-property.js"),
            getIterFn = __webpack_require__(
        /*! ./core.get-iterator-method */
        "./node_modules/core-js/modules/core.get-iterator-method.js");

        $export($export.S + $export.F * !__webpack_require__(
        /*! ./_iter-detect */
        "./node_modules/core-js/modules/_iter-detect.js")(function (iter) {
          Array.from(iter);
        }), 'Array', {
          // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
          from: function from(arrayLike
          /*, mapfn = undefined, thisArg = undefined*/
          ) {
            var O = toObject(arrayLike),
                C = typeof this == 'function' ? this : Array,
                aLen = arguments.length,
                mapfn = aLen > 1 ? arguments[1] : undefined,
                mapping = mapfn !== undefined,
                index = 0,
                iterFn = getIterFn(O),
                length,
                result,
                step,
                iterator;
            if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2); // if object isn't iterable or it's array with default iterator - use simple case

            if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
              for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
              }
            } else {
              length = toLength(O.length);

              for (result = new C(length); length > index; index++) {
                createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
              }
            }

            result.length = index;
            return result;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.array.iterator.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.array.iterator.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ArrayIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var addToUnscopables = __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/modules/_add-to-unscopables.js"),
            step = __webpack_require__(
        /*! ./_iter-step */
        "./node_modules/core-js/modules/_iter-step.js"),
            Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js"),
            toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"); // 22.1.3.4 Array.prototype.entries()
        // 22.1.3.13 Array.prototype.keys()
        // 22.1.3.29 Array.prototype.values()
        // 22.1.3.30 Array.prototype[@@iterator]()


        module.exports = __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/modules/_iter-define.js")(Array, 'Array', function (iterated, kind) {
          this._t = toIObject(iterated); // target

          this._i = 0; // next index

          this._k = kind; // kind
          // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
        }, function () {
          var O = this._t,
              kind = this._k,
              index = this._i++;

          if (!O || index >= O.length) {
            this._t = undefined;
            return step(1);
          }

          if (kind == 'keys') return step(0, index);
          if (kind == 'values') return step(0, O[index]);
          return step(0, [index, O[index]]);
        }, 'values'); // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)

        Iterators.Arguments = Iterators.Array;
        addToUnscopables('keys');
        addToUnscopables('values');
        addToUnscopables('entries');
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.function.name.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.function.name.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6FunctionNameJs(module, exports, __webpack_require__) {
        var dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f,
            createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js"),
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            FProto = Function.prototype,
            nameRE = /^\s*function ([^ (]*)/,
            NAME = 'name';

        var isExtensible = Object.isExtensible || function () {
          return true;
        }; // 19.2.4.2 name


        NAME in FProto || __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && dP(FProto, NAME, {
          configurable: true,
          get: function get() {
            try {
              var that = this,
                  name = ('' + that).match(nameRE)[1];
              has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
              return name;
            } catch (e) {
              return '';
            }
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.map.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/es6.map.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6MapJs(module, exports, __webpack_require__) {
        "use strict";

        var strong = __webpack_require__(
        /*! ./_collection-strong */
        "./node_modules/core-js/modules/_collection-strong.js"); // 23.1 Map Objects


        module.exports = __webpack_require__(
        /*! ./_collection */
        "./node_modules/core-js/modules/_collection.js")('Map', function (get) {
          return function Map() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        }, {
          // 23.1.3.6 Map.prototype.get(key)
          get: function get(key) {
            var entry = strong.getEntry(this, key);
            return entry && entry.v;
          },
          // 23.1.3.9 Map.prototype.set(key, value)
          set: function set(key, value) {
            return strong.def(this, key === 0 ? 0 : key, value);
          }
        }, strong, true);
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.number.constructor.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.number.constructor.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6NumberConstructorJs(module, exports, __webpack_require__) {
        "use strict";

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            cof = __webpack_require__(
        /*! ./_cof */
        "./node_modules/core-js/modules/_cof.js"),
            inheritIfRequired = __webpack_require__(
        /*! ./_inherit-if-required */
        "./node_modules/core-js/modules/_inherit-if-required.js"),
            toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js"),
            fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js"),
            gOPN = __webpack_require__(
        /*! ./_object-gopn */
        "./node_modules/core-js/modules/_object-gopn.js").f,
            gOPD = __webpack_require__(
        /*! ./_object-gopd */
        "./node_modules/core-js/modules/_object-gopd.js").f,
            dP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f,
            $trim = __webpack_require__(
        /*! ./_string-trim */
        "./node_modules/core-js/modules/_string-trim.js").trim,
            NUMBER = 'Number',
            $Number = global[NUMBER],
            Base = $Number,
            proto = $Number.prototype // Opera ~12 has broken Object#toString
        ,
            BROKEN_COF = cof(__webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js")(proto)) == NUMBER,
            TRIM = 'trim' in String.prototype; // 7.1.3 ToNumber(argument)


        var toNumber = function toNumber(argument) {
          var it = toPrimitive(argument, false);

          if (typeof it == 'string' && it.length > 2) {
            it = TRIM ? it.trim() : $trim(it, 3);
            var first = it.charCodeAt(0),
                third,
                radix,
                maxCode;

            if (first === 43 || first === 45) {
              third = it.charCodeAt(2);
              if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
            } else if (first === 48) {
              switch (it.charCodeAt(1)) {
                case 66:
                case 98:
                  radix = 2;
                  maxCode = 49;
                  break;
                // fast equal /^0b[01]+$/i

                case 79:
                case 111:
                  radix = 8;
                  maxCode = 55;
                  break;
                // fast equal /^0o[0-7]+$/i

                default:
                  return +it;
              }

              for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
                code = digits.charCodeAt(i); // parseInt parses a string to a first unavailable symbol
                // but ToNumber should return NaN if a string contains unavailable symbols

                if (code < 48 || code > maxCode) return NaN;
              }

              return parseInt(digits, radix);
            }
          }

          return +it;
        };

        if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
          $Number = function Number(value) {
            var it = arguments.length < 1 ? 0 : value,
                that = this;
            return that instanceof $Number // check on 1..constructor(foo) case
            && (BROKEN_COF ? fails(function () {
              proto.valueOf.call(that);
            }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
          };

          for (var keys = __webpack_require__(
          /*! ./_descriptors */
          "./node_modules/core-js/modules/_descriptors.js") ? gOPN(Base) : ( // ES3:
          'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' + // ES6 (in case, if modules with ES6 Number statics required before):
          'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
            if (has(Base, key = keys[j]) && !has($Number, key)) {
              dP($Number, key, gOPD(Base, key));
            }
          }

          $Number.prototype = proto;
          proto.constructor = $Number;

          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(global, NUMBER, $Number);
        }
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.object.assign.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.object.assign.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ObjectAssignJs(module, exports, __webpack_require__) {
        // 19.1.3.1 Object.assign(target, source)
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        $export($export.S + $export.F, 'Object', {
          assign: __webpack_require__(
          /*! ./_object-assign */
          "./node_modules/core-js/modules/_object-assign.js")
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.object.keys.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.object.keys.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ObjectKeysJs(module, exports, __webpack_require__) {
        // 19.1.2.14 Object.keys(O)
        var toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js"),
            $keys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js");

        __webpack_require__(
        /*! ./_object-sap */
        "./node_modules/core-js/modules/_object-sap.js")('keys', function () {
          return function keys(it) {
            return $keys(toObject(it));
          };
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.promise.js":
      /*!*****************************************************!*\
        !*** ./node_modules/core-js/modules/es6.promise.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6PromiseJs(module, exports, __webpack_require__) {
        "use strict";

        var LIBRARY = __webpack_require__(
        /*! ./_library */
        "./node_modules/core-js/modules/_library.js"),
            global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            ctx = __webpack_require__(
        /*! ./_ctx */
        "./node_modules/core-js/modules/_ctx.js"),
            classof = __webpack_require__(
        /*! ./_classof */
        "./node_modules/core-js/modules/_classof.js"),
            $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            isObject = __webpack_require__(
        /*! ./_is-object */
        "./node_modules/core-js/modules/_is-object.js"),
            aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js"),
            anInstance = __webpack_require__(
        /*! ./_an-instance */
        "./node_modules/core-js/modules/_an-instance.js"),
            forOf = __webpack_require__(
        /*! ./_for-of */
        "./node_modules/core-js/modules/_for-of.js"),
            speciesConstructor = __webpack_require__(
        /*! ./_species-constructor */
        "./node_modules/core-js/modules/_species-constructor.js"),
            task = __webpack_require__(
        /*! ./_task */
        "./node_modules/core-js/modules/_task.js").set,
            microtask = __webpack_require__(
        /*! ./_microtask */
        "./node_modules/core-js/modules/_microtask.js")(),
            PROMISE = 'Promise',
            TypeError = global.TypeError,
            process = global.process,
            $Promise = global[PROMISE],
            process = global.process,
            isNode = classof(process) == 'process',
            empty = function empty() {
          /* empty */
        },
            Internal,
            GenericPromiseCapability,
            Wrapper;

        var USE_NATIVE = !!function () {
          try {
            // correct subclassing with @@species support
            var promise = $Promise.resolve(1),
                FakePromise = (promise.constructor = {})[__webpack_require__(
            /*! ./_wks */
            "./node_modules/core-js/modules/_wks.js")('species')] = function (exec) {
              exec(empty, empty);
            }; // unhandled rejections tracking support, NodeJS Promise without it fails @@species test


            return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
          } catch (e) {
            /* empty */
          }
        }(); // helpers

        var sameConstructor = function sameConstructor(a, b) {
          // with library wrapper special case
          return a === b || a === $Promise && b === Wrapper;
        };

        var isThenable = function isThenable(it) {
          var then;
          return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
        };

        var newPromiseCapability = function newPromiseCapability(C) {
          return sameConstructor($Promise, C) ? new PromiseCapability(C) : new GenericPromiseCapability(C);
        };

        var PromiseCapability = GenericPromiseCapability = function GenericPromiseCapability(C) {
          var resolve, reject;
          this.promise = new C(function ($$resolve, $$reject) {
            if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
            resolve = $$resolve;
            reject = $$reject;
          });
          this.resolve = aFunction(resolve);
          this.reject = aFunction(reject);
        };

        var perform = function perform(exec) {
          try {
            exec();
          } catch (e) {
            return {
              error: e
            };
          }
        };

        var notify = function notify(promise, isReject) {
          if (promise._n) return;
          promise._n = true;
          var chain = promise._c;
          microtask(function () {
            var value = promise._v,
                ok = promise._s == 1,
                i = 0;

            var run = function run(reaction) {
              var handler = ok ? reaction.ok : reaction.fail,
                  resolve = reaction.resolve,
                  reject = reaction.reject,
                  domain = reaction.domain,
                  result,
                  then;

              try {
                if (handler) {
                  if (!ok) {
                    if (promise._h == 2) onHandleUnhandled(promise);
                    promise._h = 1;
                  }

                  if (handler === true) result = value;else {
                    if (domain) domain.enter();
                    result = handler(value);
                    if (domain) domain.exit();
                  }

                  if (result === reaction.promise) {
                    reject(TypeError('Promise-chain cycle'));
                  } else if (then = isThenable(result)) {
                    then.call(result, resolve, reject);
                  } else resolve(result);
                } else reject(value);
              } catch (e) {
                reject(e);
              }
            };

            while (chain.length > i) {
              run(chain[i++]);
            } // variable length - can't use forEach


            promise._c = [];
            promise._n = false;
            if (isReject && !promise._h) onUnhandled(promise);
          });
        };

        var onUnhandled = function onUnhandled(promise) {
          task.call(global, function () {
            var value = promise._v,
                abrupt,
                handler,
                console;

            if (isUnhandled(promise)) {
              abrupt = perform(function () {
                if (isNode) {
                  process.emit('unhandledRejection', value, promise);
                } else if (handler = global.onunhandledrejection) {
                  handler({
                    promise: promise,
                    reason: value
                  });
                } else if ((console = global.console) && console.error) {
                  console.error('Unhandled promise rejection', value);
                }
              }); // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should

              promise._h = isNode || isUnhandled(promise) ? 2 : 1;
            }

            promise._a = undefined;
            if (abrupt) throw abrupt.error;
          });
        };

        var isUnhandled = function isUnhandled(promise) {
          if (promise._h == 1) return false;
          var chain = promise._a || promise._c,
              i = 0,
              reaction;

          while (chain.length > i) {
            reaction = chain[i++];
            if (reaction.fail || !isUnhandled(reaction.promise)) return false;
          }

          return true;
        };

        var onHandleUnhandled = function onHandleUnhandled(promise) {
          task.call(global, function () {
            var handler;

            if (isNode) {
              process.emit('rejectionHandled', promise);
            } else if (handler = global.onrejectionhandled) {
              handler({
                promise: promise,
                reason: promise._v
              });
            }
          });
        };

        var $reject = function $reject(value) {
          var promise = this;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          promise._v = value;
          promise._s = 2;
          if (!promise._a) promise._a = promise._c.slice();
          notify(promise, true);
        };

        var $resolve = function $resolve(value) {
          var promise = this,
              then;
          if (promise._d) return;
          promise._d = true;
          promise = promise._w || promise; // unwrap

          try {
            if (promise === value) throw TypeError("Promise can't be resolved itself");

            if (then = isThenable(value)) {
              microtask(function () {
                var wrapper = {
                  _w: promise,
                  _d: false
                }; // wrap

                try {
                  then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
                } catch (e) {
                  $reject.call(wrapper, e);
                }
              });
            } else {
              promise._v = value;
              promise._s = 1;
              notify(promise, false);
            }
          } catch (e) {
            $reject.call({
              _w: promise,
              _d: false
            }, e); // wrap
          }
        }; // constructor polyfill


        if (!USE_NATIVE) {
          // 25.4.3.1 Promise(executor)
          $Promise = function Promise(executor) {
            anInstance(this, $Promise, PROMISE, '_h');
            aFunction(executor);
            Internal.call(this);

            try {
              executor(ctx($resolve, this, 1), ctx($reject, this, 1));
            } catch (err) {
              $reject.call(this, err);
            }
          };

          Internal = function Promise(executor) {
            this._c = []; // <- awaiting reactions

            this._a = undefined; // <- checked in isUnhandled reactions

            this._s = 0; // <- state

            this._d = false; // <- done

            this._v = undefined; // <- value

            this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled

            this._n = false; // <- notify
          };

          Internal.prototype = __webpack_require__(
          /*! ./_redefine-all */
          "./node_modules/core-js/modules/_redefine-all.js")($Promise.prototype, {
            // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
            then: function then(onFulfilled, onRejected) {
              var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
              reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
              reaction.fail = typeof onRejected == 'function' && onRejected;
              reaction.domain = isNode ? process.domain : undefined;

              this._c.push(reaction);

              if (this._a) this._a.push(reaction);
              if (this._s) notify(this, false);
              return reaction.promise;
            },
            // 25.4.5.1 Promise.prototype.catch(onRejected)
            'catch': function _catch(onRejected) {
              return this.then(undefined, onRejected);
            }
          });

          PromiseCapability = function PromiseCapability() {
            var promise = new Internal();
            this.promise = promise;
            this.resolve = ctx($resolve, promise, 1);
            this.reject = ctx($reject, promise, 1);
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Promise: $Promise
        });

        __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js")($Promise, PROMISE);

        __webpack_require__(
        /*! ./_set-species */
        "./node_modules/core-js/modules/_set-species.js")(PROMISE);

        Wrapper = __webpack_require__(
        /*! ./_core */
        "./node_modules/core-js/modules/_core.js")[PROMISE]; // statics

        $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
          // 25.4.4.5 Promise.reject(r)
          reject: function reject(r) {
            var capability = newPromiseCapability(this),
                $$reject = capability.reject;
            $$reject(r);
            return capability.promise;
          }
        });
        $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
          // 25.4.4.6 Promise.resolve(x)
          resolve: function resolve(x) {
            // instanceof instead of internal slot check because we should fix it without replacement native Promise core
            if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
            var capability = newPromiseCapability(this),
                $$resolve = capability.resolve;
            $$resolve(x);
            return capability.promise;
          }
        });
        $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(
        /*! ./_iter-detect */
        "./node_modules/core-js/modules/_iter-detect.js")(function (iter) {
          $Promise.all(iter)['catch'](empty);
        })), PROMISE, {
          // 25.4.4.1 Promise.all(iterable)
          all: function all(iterable) {
            var C = this,
                capability = newPromiseCapability(C),
                resolve = capability.resolve,
                reject = capability.reject;
            var abrupt = perform(function () {
              var values = [],
                  index = 0,
                  remaining = 1;
              forOf(iterable, false, function (promise) {
                var $index = index++,
                    alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function (value) {
                  if (alreadyCalled) return;
                  alreadyCalled = true;
                  values[$index] = value;
                  --remaining || resolve(values);
                }, reject);
              });
              --remaining || resolve(values);
            });
            if (abrupt) reject(abrupt.error);
            return capability.promise;
          },
          // 25.4.4.4 Promise.race(iterable)
          race: function race(iterable) {
            var C = this,
                capability = newPromiseCapability(C),
                reject = capability.reject;
            var abrupt = perform(function () {
              forOf(iterable, false, function (promise) {
                C.resolve(promise).then(capability.resolve, reject);
              });
            });
            if (abrupt) reject(abrupt.error);
            return capability.promise;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.reflect.has.js":
      /*!*********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.reflect.has.js ***!
        \*********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6ReflectHasJs(module, exports, __webpack_require__) {
        // 26.1.9 Reflect.has(target, propertyKey)
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        $export($export.S, 'Reflect', {
          has: function has(target, propertyKey) {
            return propertyKey in target;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.flags.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.flags.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpFlagsJs(module, exports, __webpack_require__) {
        // 21.2.5.3 get RegExp.prototype.flags()
        if (__webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && /./g.flags != 'g') __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js").f(RegExp.prototype, 'flags', {
          configurable: true,
          get: __webpack_require__(
          /*! ./_flags */
          "./node_modules/core-js/modules/_flags.js")
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.replace.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.replace.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpReplaceJs(module, exports, __webpack_require__) {
        // @@replace logic
        __webpack_require__(
        /*! ./_fix-re-wks */
        "./node_modules/core-js/modules/_fix-re-wks.js")('replace', 2, function (defined, REPLACE, $replace) {
          // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
          return [function replace(searchValue, replaceValue) {
            'use strict';

            var O = defined(this),
                fn = searchValue == undefined ? undefined : searchValue[REPLACE];
            return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
          }, $replace];
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.split.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.split.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpSplitJs(module, exports, __webpack_require__) {
        // @@split logic
        __webpack_require__(
        /*! ./_fix-re-wks */
        "./node_modules/core-js/modules/_fix-re-wks.js")('split', 2, function (defined, SPLIT, $split) {
          'use strict';

          var isRegExp = __webpack_require__(
          /*! ./_is-regexp */
          "./node_modules/core-js/modules/_is-regexp.js"),
              _split = $split,
              $push = [].push,
              $SPLIT = 'split',
              LENGTH = 'length',
              LAST_INDEX = 'lastIndex';

          if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
            var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
            // based on es5-shim implementation, need to rework it

            $split = function $split(separator, limit) {
              var string = String(this);
              if (separator === undefined && limit === 0) return []; // If `separator` is not a regex, use native split

              if (!isRegExp(separator)) return _split.call(string, separator, limit);
              var output = [];
              var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
              var lastLastIndex = 0;
              var splitLimit = limit === undefined ? 4294967295 : limit >>> 0; // Make `global` and avoid `lastIndex` issues by working with a copy

              var separatorCopy = new RegExp(separator.source, flags + 'g');
              var separator2, match, lastIndex, lastLength, i; // Doesn't need flags gy, but they don't hurt

              if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);

              while (match = separatorCopy.exec(string)) {
                // `separatorCopy.lastIndex` is not reliable cross-browser
                lastIndex = match.index + match[0][LENGTH];

                if (lastIndex > lastLastIndex) {
                  output.push(string.slice(lastLastIndex, match.index)); // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG

                  if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
                    for (i = 1; i < arguments[LENGTH] - 2; i++) {
                      if (arguments[i] === undefined) match[i] = undefined;
                    }
                  });
                  if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                  lastLength = match[0][LENGTH];
                  lastLastIndex = lastIndex;
                  if (output[LENGTH] >= splitLimit) break;
                }

                if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
              }

              if (lastLastIndex === string[LENGTH]) {
                if (lastLength || !separatorCopy.test('')) output.push('');
              } else output.push(string.slice(lastLastIndex));

              return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
            }; // Chakra, V8

          } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
            $split = function $split(separator, limit) {
              return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
            };
          } // 21.1.3.17 String.prototype.split(separator, limit)


          return [function split(separator, limit) {
            var O = defined(this),
                fn = separator == undefined ? undefined : separator[SPLIT];
            return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
          }, $split];
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.regexp.to-string.js":
      /*!**************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.regexp.to-string.js ***!
        \**************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6RegexpToStringJs(module, exports, __webpack_require__) {
        "use strict";

        __webpack_require__(
        /*! ./es6.regexp.flags */
        "./node_modules/core-js/modules/es6.regexp.flags.js");

        var anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js"),
            $flags = __webpack_require__(
        /*! ./_flags */
        "./node_modules/core-js/modules/_flags.js"),
            DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js"),
            TO_STRING = 'toString',
            $toString = /./[TO_STRING];

        var define = function define(fn) {
          __webpack_require__(
          /*! ./_redefine */
          "./node_modules/core-js/modules/_redefine.js")(RegExp.prototype, TO_STRING, fn, true);
        }; // 21.2.5.14 RegExp.prototype.toString()


        if (__webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js")(function () {
          return $toString.call({
            source: 'a',
            flags: 'b'
          }) != '/a/b';
        })) {
          define(function toString() {
            var R = anObject(this);
            return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
          }); // FF44- RegExp#toString has a wrong name
        } else if ($toString.name != TO_STRING) {
          define(function toString() {
            return $toString.call(this);
          });
        }
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.set.js":
      /*!*************************************************!*\
        !*** ./node_modules/core-js/modules/es6.set.js ***!
        \*************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6SetJs(module, exports, __webpack_require__) {
        "use strict";

        var strong = __webpack_require__(
        /*! ./_collection-strong */
        "./node_modules/core-js/modules/_collection-strong.js"); // 23.2 Set Objects


        module.exports = __webpack_require__(
        /*! ./_collection */
        "./node_modules/core-js/modules/_collection.js")('Set', function (get) {
          return function Set() {
            return get(this, arguments.length > 0 ? arguments[0] : undefined);
          };
        }, {
          // 23.2.3.1 Set.prototype.add(value)
          add: function add(value) {
            return strong.def(this, value = value === 0 ? 0 : value, value);
          }
        }, strong);
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.string.includes.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.string.includes.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6StringIncludesJs(module, exports, __webpack_require__) {
        "use strict"; // 21.1.3.7 String.prototype.includes(searchString, position = 0)

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            context = __webpack_require__(
        /*! ./_string-context */
        "./node_modules/core-js/modules/_string-context.js"),
            INCLUDES = 'includes';

        $export($export.P + $export.F * __webpack_require__(
        /*! ./_fails-is-regexp */
        "./node_modules/core-js/modules/_fails-is-regexp.js")(INCLUDES), 'String', {
          includes: function includes(searchString
          /*, position = 0 */
          ) {
            return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.string.iterator.js":
      /*!*************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.string.iterator.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6StringIteratorJs(module, exports, __webpack_require__) {
        "use strict";

        var $at = __webpack_require__(
        /*! ./_string-at */
        "./node_modules/core-js/modules/_string-at.js")(true); // 21.1.3.27 String.prototype[@@iterator]()


        __webpack_require__(
        /*! ./_iter-define */
        "./node_modules/core-js/modules/_iter-define.js")(String, 'String', function (iterated) {
          this._t = String(iterated); // target

          this._i = 0; // next index
          // 21.1.5.2.1 %StringIteratorPrototype%.next()
        }, function () {
          var O = this._t,
              index = this._i,
              point;
          if (index >= O.length) return {
            value: undefined,
            done: true
          };
          point = $at(O, index);
          this._i += point.length;
          return {
            value: point,
            done: false
          };
        });
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es6.string.repeat.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es6.string.repeat.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6StringRepeatJs(module, exports, __webpack_require__) {
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js");

        $export($export.P, 'String', {
          // 21.1.3.13 String.prototype.repeat(count)
          repeat: __webpack_require__(
          /*! ./_string-repeat */
          "./node_modules/core-js/modules/_string-repeat.js")
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.string.starts-with.js":
      /*!****************************************************************!*\
        !*** ./node_modules/core-js/modules/es6.string.starts-with.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6StringStartsWithJs(module, exports, __webpack_require__) {
        "use strict"; // 21.1.3.18 String.prototype.startsWith(searchString [, position ])

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            toLength = __webpack_require__(
        /*! ./_to-length */
        "./node_modules/core-js/modules/_to-length.js"),
            context = __webpack_require__(
        /*! ./_string-context */
        "./node_modules/core-js/modules/_string-context.js"),
            STARTS_WITH = 'startsWith',
            $startsWith = ''[STARTS_WITH];

        $export($export.P + $export.F * __webpack_require__(
        /*! ./_fails-is-regexp */
        "./node_modules/core-js/modules/_fails-is-regexp.js")(STARTS_WITH), 'String', {
          startsWith: function startsWith(searchString
          /*, position = 0 */
          ) {
            var that = context(this, searchString, STARTS_WITH),
                index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length)),
                search = String(searchString);
            return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es6.symbol.js":
      /*!****************************************************!*\
        !*** ./node_modules/core-js/modules/es6.symbol.js ***!
        \****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs6SymbolJs(module, exports, __webpack_require__) {
        "use strict"; // ECMAScript 6 symbols shim

        var global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            has = __webpack_require__(
        /*! ./_has */
        "./node_modules/core-js/modules/_has.js"),
            DESCRIPTORS = __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js"),
            $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js"),
            META = __webpack_require__(
        /*! ./_meta */
        "./node_modules/core-js/modules/_meta.js").KEY,
            $fails = __webpack_require__(
        /*! ./_fails */
        "./node_modules/core-js/modules/_fails.js"),
            shared = __webpack_require__(
        /*! ./_shared */
        "./node_modules/core-js/modules/_shared.js"),
            setToStringTag = __webpack_require__(
        /*! ./_set-to-string-tag */
        "./node_modules/core-js/modules/_set-to-string-tag.js"),
            uid = __webpack_require__(
        /*! ./_uid */
        "./node_modules/core-js/modules/_uid.js"),
            wks = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js"),
            wksExt = __webpack_require__(
        /*! ./_wks-ext */
        "./node_modules/core-js/modules/_wks-ext.js"),
            wksDefine = __webpack_require__(
        /*! ./_wks-define */
        "./node_modules/core-js/modules/_wks-define.js"),
            keyOf = __webpack_require__(
        /*! ./_keyof */
        "./node_modules/core-js/modules/_keyof.js"),
            enumKeys = __webpack_require__(
        /*! ./_enum-keys */
        "./node_modules/core-js/modules/_enum-keys.js"),
            isArray = __webpack_require__(
        /*! ./_is-array */
        "./node_modules/core-js/modules/_is-array.js"),
            anObject = __webpack_require__(
        /*! ./_an-object */
        "./node_modules/core-js/modules/_an-object.js"),
            toIObject = __webpack_require__(
        /*! ./_to-iobject */
        "./node_modules/core-js/modules/_to-iobject.js"),
            toPrimitive = __webpack_require__(
        /*! ./_to-primitive */
        "./node_modules/core-js/modules/_to-primitive.js"),
            createDesc = __webpack_require__(
        /*! ./_property-desc */
        "./node_modules/core-js/modules/_property-desc.js"),
            _create = __webpack_require__(
        /*! ./_object-create */
        "./node_modules/core-js/modules/_object-create.js"),
            gOPNExt = __webpack_require__(
        /*! ./_object-gopn-ext */
        "./node_modules/core-js/modules/_object-gopn-ext.js"),
            $GOPD = __webpack_require__(
        /*! ./_object-gopd */
        "./node_modules/core-js/modules/_object-gopd.js"),
            $DP = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js"),
            $keys = __webpack_require__(
        /*! ./_object-keys */
        "./node_modules/core-js/modules/_object-keys.js"),
            gOPD = $GOPD.f,
            dP = $DP.f,
            gOPN = gOPNExt.f,
            $Symbol = global.Symbol,
            $JSON = global.JSON,
            _stringify = $JSON && $JSON.stringify,
            PROTOTYPE = 'prototype',
            HIDDEN = wks('_hidden'),
            TO_PRIMITIVE = wks('toPrimitive'),
            isEnum = {}.propertyIsEnumerable,
            SymbolRegistry = shared('symbol-registry'),
            AllSymbols = shared('symbols'),
            OPSymbols = shared('op-symbols'),
            ObjectProto = Object[PROTOTYPE],
            USE_NATIVE = typeof $Symbol == 'function',
            QObject = global.QObject; // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173


        var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild; // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687

        var setSymbolDesc = DESCRIPTORS && $fails(function () {
          return _create(dP({}, 'a', {
            get: function get() {
              return dP(this, 'a', {
                value: 7
              }).a;
            }
          })).a != 7;
        }) ? function (it, key, D) {
          var protoDesc = gOPD(ObjectProto, key);
          if (protoDesc) delete ObjectProto[key];
          dP(it, key, D);
          if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
        } : dP;

        var wrap = function wrap(tag) {
          var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);

          sym._k = tag;
          return sym;
        };

        var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
          return typeof it == 'symbol';
        } : function (it) {
          return it instanceof $Symbol;
        };

        var $defineProperty = function defineProperty(it, key, D) {
          if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
          anObject(it);
          key = toPrimitive(key, true);
          anObject(D);

          if (has(AllSymbols, key)) {
            if (!D.enumerable) {
              if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
              it[HIDDEN][key] = true;
            } else {
              if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
              D = _create(D, {
                enumerable: createDesc(0, false)
              });
            }

            return setSymbolDesc(it, key, D);
          }

          return dP(it, key, D);
        };

        var $defineProperties = function defineProperties(it, P) {
          anObject(it);
          var keys = enumKeys(P = toIObject(P)),
              i = 0,
              l = keys.length,
              key;

          while (l > i) {
            $defineProperty(it, key = keys[i++], P[key]);
          }

          return it;
        };

        var $create = function create(it, P) {
          return P === undefined ? _create(it) : $defineProperties(_create(it), P);
        };

        var $propertyIsEnumerable = function propertyIsEnumerable(key) {
          var E = isEnum.call(this, key = toPrimitive(key, true));
          if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
          return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
        };

        var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
          it = toIObject(it);
          key = toPrimitive(key, true);
          if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
          var D = gOPD(it, key);
          if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
          return D;
        };

        var $getOwnPropertyNames = function getOwnPropertyNames(it) {
          var names = gOPN(toIObject(it)),
              result = [],
              i = 0,
              key;

          while (names.length > i) {
            if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
          }

          return result;
        };

        var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
          var IS_OP = it === ObjectProto,
              names = gOPN(IS_OP ? OPSymbols : toIObject(it)),
              result = [],
              i = 0,
              key;

          while (names.length > i) {
            if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
          }

          return result;
        }; // 19.4.1.1 Symbol([description])


        if (!USE_NATIVE) {
          $Symbol = function Symbol() {
            if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
            var tag = uid(arguments.length > 0 ? arguments[0] : undefined);

            var $set = function $set(value) {
              if (this === ObjectProto) $set.call(OPSymbols, value);
              if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
              setSymbolDesc(this, tag, createDesc(1, value));
            };

            if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, {
              configurable: true,
              set: $set
            });
            return wrap(tag);
          };

          redefine($Symbol[PROTOTYPE], 'toString', function toString() {
            return this._k;
          });
          $GOPD.f = $getOwnPropertyDescriptor;
          $DP.f = $defineProperty;
          __webpack_require__(
          /*! ./_object-gopn */
          "./node_modules/core-js/modules/_object-gopn.js").f = gOPNExt.f = $getOwnPropertyNames;
          __webpack_require__(
          /*! ./_object-pie */
          "./node_modules/core-js/modules/_object-pie.js").f = $propertyIsEnumerable;
          __webpack_require__(
          /*! ./_object-gops */
          "./node_modules/core-js/modules/_object-gops.js").f = $getOwnPropertySymbols;

          if (DESCRIPTORS && !__webpack_require__(
          /*! ./_library */
          "./node_modules/core-js/modules/_library.js")) {
            redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
          }

          wksExt.f = function (name) {
            return wrap(wks(name));
          };
        }

        $export($export.G + $export.W + $export.F * !USE_NATIVE, {
          Symbol: $Symbol
        });

        for (var symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
        'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), i = 0; symbols.length > i;) {
          wks(symbols[i++]);
        }

        for (var symbols = $keys(wks.store), i = 0; symbols.length > i;) {
          wksDefine(symbols[i++]);
        }

        $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
          // 19.4.2.1 Symbol.for(key)
          'for': function _for(key) {
            return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
          },
          // 19.4.2.5 Symbol.keyFor(sym)
          keyFor: function keyFor(key) {
            if (isSymbol(key)) return keyOf(SymbolRegistry, key);
            throw TypeError(key + ' is not a symbol!');
          },
          useSetter: function useSetter() {
            setter = true;
          },
          useSimple: function useSimple() {
            setter = false;
          }
        });
        $export($export.S + $export.F * !USE_NATIVE, 'Object', {
          // 19.1.2.2 Object.create(O [, Properties])
          create: $create,
          // 19.1.2.4 Object.defineProperty(O, P, Attributes)
          defineProperty: $defineProperty,
          // 19.1.2.3 Object.defineProperties(O, Properties)
          defineProperties: $defineProperties,
          // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
          getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
          // 19.1.2.7 Object.getOwnPropertyNames(O)
          getOwnPropertyNames: $getOwnPropertyNames,
          // 19.1.2.8 Object.getOwnPropertySymbols(O)
          getOwnPropertySymbols: $getOwnPropertySymbols
        }); // 24.3.2 JSON.stringify(value [, replacer [, space]])

        $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
          var S = $Symbol(); // MS Edge converts symbol values to JSON as {}
          // WebKit converts symbol values to JSON as null
          // V8 throws on boxed symbols

          return _stringify([S]) != '[null]' || _stringify({
            a: S
          }) != '{}' || _stringify(Object(S)) != '{}';
        })), 'JSON', {
          stringify: function stringify(it) {
            if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined

            var args = [it],
                i = 1,
                replacer,
                $replacer;

            while (arguments.length > i) {
              args.push(arguments[i++]);
            }

            replacer = args[1];
            if (typeof replacer == 'function') $replacer = replacer;
            if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
              if ($replacer) value = $replacer.call(this, key, value);
              if (!isSymbol(value)) return value;
            };
            args[1] = replacer;
            return _stringify.apply($JSON, args);
          }
        }); // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)

        $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf); // 19.4.3.5 Symbol.prototype[@@toStringTag]

        setToStringTag($Symbol, 'Symbol'); // 20.2.1.9 Math[@@toStringTag]

        setToStringTag(Math, 'Math', true); // 24.3.3 JSON[@@toStringTag]

        setToStringTag(global.JSON, 'JSON', true);
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es7.array.includes.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es7.array.includes.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7ArrayIncludesJs(module, exports, __webpack_require__) {
        "use strict"; // https://github.com/tc39/Array.prototype.includes

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            $includes = __webpack_require__(
        /*! ./_array-includes */
        "./node_modules/core-js/modules/_array-includes.js")(true);

        $export($export.P, 'Array', {
          includes: function includes(el
          /*, fromIndex = 0 */
          ) {
            return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
          }
        });

        __webpack_require__(
        /*! ./_add-to-unscopables */
        "./node_modules/core-js/modules/_add-to-unscopables.js")('includes');
        /***/

      },

      /***/
      "./node_modules/core-js/modules/es7.object.define-getter.js":
      /*!******************************************************************!*\
        !*** ./node_modules/core-js/modules/es7.object.define-getter.js ***!
        \******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7ObjectDefineGetterJs(module, exports, __webpack_require__) {
        "use strict";

        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            toObject = __webpack_require__(
        /*! ./_to-object */
        "./node_modules/core-js/modules/_to-object.js"),
            aFunction = __webpack_require__(
        /*! ./_a-function */
        "./node_modules/core-js/modules/_a-function.js"),
            $defineProperty = __webpack_require__(
        /*! ./_object-dp */
        "./node_modules/core-js/modules/_object-dp.js"); // B.2.2.2 Object.prototype.__defineGetter__(P, getter)


        __webpack_require__(
        /*! ./_descriptors */
        "./node_modules/core-js/modules/_descriptors.js") && $export($export.P + __webpack_require__(
        /*! ./_object-forced-pam */
        "./node_modules/core-js/modules/_object-forced-pam.js"), 'Object', {
          __defineGetter__: function __defineGetter__(P, getter) {
            $defineProperty.f(toObject(this), P, {
              get: aFunction(getter),
              enumerable: true,
              configurable: true
            });
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es7.object.entries.js":
      /*!************************************************************!*\
        !*** ./node_modules/core-js/modules/es7.object.entries.js ***!
        \************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7ObjectEntriesJs(module, exports, __webpack_require__) {
        // https://github.com/tc39/proposal-object-values-entries
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            $entries = __webpack_require__(
        /*! ./_object-to-array */
        "./node_modules/core-js/modules/_object-to-array.js")(true);

        $export($export.S, 'Object', {
          entries: function entries(it) {
            return $entries(it);
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es7.object.values.js":
      /*!***********************************************************!*\
        !*** ./node_modules/core-js/modules/es7.object.values.js ***!
        \***********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7ObjectValuesJs(module, exports, __webpack_require__) {
        // https://github.com/tc39/proposal-object-values-entries
        var $export = __webpack_require__(
        /*! ./_export */
        "./node_modules/core-js/modules/_export.js"),
            $values = __webpack_require__(
        /*! ./_object-to-array */
        "./node_modules/core-js/modules/_object-to-array.js")(false);

        $export($export.S, 'Object', {
          values: function values(it) {
            return $values(it);
          }
        });
        /***/
      },

      /***/
      "./node_modules/core-js/modules/es7.symbol.async-iterator.js":
      /*!*******************************************************************!*\
        !*** ./node_modules/core-js/modules/es7.symbol.async-iterator.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesEs7SymbolAsyncIteratorJs(module, exports, __webpack_require__) {
        __webpack_require__(
        /*! ./_wks-define */
        "./node_modules/core-js/modules/_wks-define.js")('asyncIterator');
        /***/

      },

      /***/
      "./node_modules/core-js/modules/web.dom.iterable.js":
      /*!**********************************************************!*\
        !*** ./node_modules/core-js/modules/web.dom.iterable.js ***!
        \**********************************************************/

      /*! no static exports found */

      /***/
      function node_modulesCoreJsModulesWebDomIterableJs(module, exports, __webpack_require__) {
        var $iterators = __webpack_require__(
        /*! ./es6.array.iterator */
        "./node_modules/core-js/modules/es6.array.iterator.js"),
            redefine = __webpack_require__(
        /*! ./_redefine */
        "./node_modules/core-js/modules/_redefine.js"),
            global = __webpack_require__(
        /*! ./_global */
        "./node_modules/core-js/modules/_global.js"),
            hide = __webpack_require__(
        /*! ./_hide */
        "./node_modules/core-js/modules/_hide.js"),
            Iterators = __webpack_require__(
        /*! ./_iterators */
        "./node_modules/core-js/modules/_iterators.js"),
            wks = __webpack_require__(
        /*! ./_wks */
        "./node_modules/core-js/modules/_wks.js"),
            ITERATOR = wks('iterator'),
            TO_STRING_TAG = wks('toStringTag'),
            ArrayValues = Iterators.Array;

        for (var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++) {
          var NAME = collections[i],
              Collection = global[NAME],
              proto = Collection && Collection.prototype,
              key;

          if (proto) {
            if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
            if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
            Iterators[NAME] = ArrayValues;

            for (key in $iterators) {
              if (!proto[key]) redefine(proto, key, $iterators[key], true);
            }
          }
        }
        /***/

      },

      /***/
      "./node_modules/regenerator-runtime/runtime.js":
      /*!*****************************************************!*\
        !*** ./node_modules/regenerator-runtime/runtime.js ***!
        \*****************************************************/

      /*! no static exports found */

      /***/
      function node_modulesRegeneratorRuntimeRuntimeJs(module, exports, __webpack_require__) {
        /* WEBPACK VAR INJECTION */
        (function (global) {
          /**
          * Copyright (c) 2014, Facebook, Inc.
          * All rights reserved.
          *
          * This source code is licensed under the BSD-style license found in the
          * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
          * additional grant of patent rights can be found in the PATENTS file in
          * the same directory.
          */
          !function (global) {
            "use strict";

            var Op = Object.prototype;
            var hasOwn = Op.hasOwnProperty;
            var undefined; // More compressible than void 0.

            var $Symbol = typeof Symbol === "function" ? Symbol : {};
            var iteratorSymbol = $Symbol.iterator || "@@iterator";
            var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
            var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
            var inModule = typeof module === "object";
            var runtime = global.regeneratorRuntime;

            if (runtime) {
              if (inModule) {
                // If regeneratorRuntime is defined globally and we're in a module,
                // make the exports object identical to regeneratorRuntime.
                module.exports = runtime;
              } // Don't bother evaluating the rest of this file if the runtime was
              // already defined globally.


              return;
            } // Define the runtime globally (as expected by generated code) as either
            // module.exports (if we're in a module) or a new, empty object.


            runtime = global.regeneratorRuntime = inModule ? module.exports : {};

            function wrap(innerFn, outerFn, self, tryLocsList) {
              // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
              var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
              var generator = Object.create(protoGenerator.prototype);
              var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
              // .throw, and .return methods.

              generator._invoke = makeInvokeMethod(innerFn, self, context);
              return generator;
            }

            runtime.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
            // record like context.tryEntries[i].completion. This interface could
            // have been (and was previously) designed to take a closure to be
            // invoked without arguments, but in all the cases we care about we
            // already have an existing method we want to call, so there's no need
            // to create a new function object. We can even get away with assuming
            // the method takes exactly one argument, since that happens to be true
            // in every case, so we don't have to touch the arguments object. The
            // only additional allocation required is the completion record, which
            // has a stable shape and so hopefully should be cheap to allocate.

            function tryCatch(fn, obj, arg) {
              try {
                return {
                  type: "normal",
                  arg: fn.call(obj, arg)
                };
              } catch (err) {
                return {
                  type: "throw",
                  arg: err
                };
              }
            }

            var GenStateSuspendedStart = "suspendedStart";
            var GenStateSuspendedYield = "suspendedYield";
            var GenStateExecuting = "executing";
            var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
            // breaking out of the dispatch switch statement.

            var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
            // .constructor.prototype properties for functions that return Generator
            // objects. For full spec compliance, you may wish to configure your
            // minifier not to mangle the names of these two functions.

            function Generator() {}

            function GeneratorFunction() {}

            function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
            // don't natively support it.


            var IteratorPrototype = {};

            IteratorPrototype[iteratorSymbol] = function () {
              return this;
            };

            var getProto = Object.getPrototypeOf;
            var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

            if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
              // This environment has a native %IteratorPrototype%; use it instead
              // of the polyfill.
              IteratorPrototype = NativeIteratorPrototype;
            }

            var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
            GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
            GeneratorFunctionPrototype.constructor = GeneratorFunction;
            GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction"; // Helper for defining the .next, .throw, and .return methods of the
            // Iterator interface in terms of a single ._invoke method.

            function defineIteratorMethods(prototype) {
              ["next", "throw", "return"].forEach(function (method) {
                prototype[method] = function (arg) {
                  return this._invoke(method, arg);
                };
              });
            }

            runtime.isGeneratorFunction = function (genFun) {
              var ctor = typeof genFun === "function" && genFun.constructor;
              return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
              // do is to check its .name property.
              (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
            };

            runtime.mark = function (genFun) {
              if (Object.setPrototypeOf) {
                Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
              } else {
                genFun.__proto__ = GeneratorFunctionPrototype;

                if (!(toStringTagSymbol in genFun)) {
                  genFun[toStringTagSymbol] = "GeneratorFunction";
                }
              }

              genFun.prototype = Object.create(Gp);
              return genFun;
            }; // Within the body of any async function, `await x` is transformed to
            // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
            // `hasOwn.call(value, "__await")` to determine if the yielded value is
            // meant to be awaited.


            runtime.awrap = function (arg) {
              return {
                __await: arg
              };
            };

            function AsyncIterator(generator) {
              function invoke(method, arg, resolve, reject) {
                var record = tryCatch(generator[method], generator, arg);

                if (record.type === "throw") {
                  reject(record.arg);
                } else {
                  var result = record.arg;
                  var value = result.value;

                  if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
                    return Promise.resolve(value.__await).then(function (value) {
                      invoke("next", value, resolve, reject);
                    }, function (err) {
                      invoke("throw", err, resolve, reject);
                    });
                  }

                  return Promise.resolve(value).then(function (unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration. If the Promise is rejected, however, the
                    // result for this iteration will be rejected with the same
                    // reason. Note that rejections of yielded Promises are not
                    // thrown back into the generator function, as is the case
                    // when an awaited Promise is rejected. This difference in
                    // behavior between yield and await is important, because it
                    // allows the consumer to decide what to do with the yielded
                    // rejection (swallow it and continue, manually .throw it back
                    // into the generator, abandon iteration, whatever). With
                    // await, by contrast, there is no opportunity to examine the
                    // rejection reason outside the generator function, so the
                    // only option is to throw it from the await expression, and
                    // let the generator function handle the exception.
                    result.value = unwrapped;
                    resolve(result);
                  }, reject);
                }
              }

              if (typeof global.process === "object" && global.process.domain) {
                invoke = global.process.domain.bind(invoke);
              }

              var previousPromise;

              function enqueue(method, arg) {
                function callInvokeWithMethodAndArg() {
                  return new Promise(function (resolve, reject) {
                    invoke(method, arg, resolve, reject);
                  });
                }

                return previousPromise = // If enqueue has been called before, then we want to wait until
                // all previous Promises have been resolved before calling invoke,
                // so that results are always delivered in the correct order. If
                // enqueue has not been called before, then it is important to
                // call invoke immediately, without waiting on a callback to fire,
                // so that the async generator function has the opportunity to do
                // any necessary setup in a predictable way. This predictability
                // is why the Promise constructor synchronously invokes its
                // executor callback, and why async functions synchronously
                // execute code before the first await. Since we implement simple
                // async functions in terms of async generators, it is especially
                // important to get this right, even though it requires care.
                previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
                // invocations of the iterator.
                callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
              } // Define the unified helper method that is used to implement .next,
              // .throw, and .return (see defineIteratorMethods).


              this._invoke = enqueue;
            }

            defineIteratorMethods(AsyncIterator.prototype);

            AsyncIterator.prototype[asyncIteratorSymbol] = function () {
              return this;
            };

            runtime.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
            // AsyncIterator objects; they just return a Promise for the value of
            // the final result produced by the iterator.

            runtime.async = function (innerFn, outerFn, self, tryLocsList) {
              var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
              return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
              : iter.next().then(function (result) {
                return result.done ? result.value : iter.next();
              });
            };

            function makeInvokeMethod(innerFn, self, context) {
              var state = GenStateSuspendedStart;
              return function invoke(method, arg) {
                if (state === GenStateExecuting) {
                  throw new Error("Generator is already running");
                }

                if (state === GenStateCompleted) {
                  if (method === "throw") {
                    throw arg;
                  } // Be forgiving, per 25.3.3.3.3 of the spec:
                  // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


                  return doneResult();
                }

                context.method = method;
                context.arg = arg;

                while (true) {
                  var delegate = context.delegate;

                  if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);

                    if (delegateResult) {
                      if (delegateResult === ContinueSentinel) continue;
                      return delegateResult;
                    }
                  }

                  if (context.method === "next") {
                    // Setting context._sent for legacy support of Babel's
                    // function.sent implementation.
                    context.sent = context._sent = context.arg;
                  } else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                      state = GenStateCompleted;
                      throw context.arg;
                    }

                    context.dispatchException(context.arg);
                  } else if (context.method === "return") {
                    context.abrupt("return", context.arg);
                  }

                  state = GenStateExecuting;
                  var record = tryCatch(innerFn, self, context);

                  if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;

                    if (record.arg === ContinueSentinel) {
                      continue;
                    }

                    return {
                      value: record.arg,
                      done: context.done
                    };
                  } else if (record.type === "throw") {
                    state = GenStateCompleted; // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.

                    context.method = "throw";
                    context.arg = record.arg;
                  }
                }
              };
            } // Call delegate.iterator[context.method](context.arg) and handle the
            // result, either by returning a { value, done } result from the
            // delegate iterator, or by modifying context.method and context.arg,
            // setting context.delegate to null, and returning the ContinueSentinel.


            function maybeInvokeDelegate(delegate, context) {
              var method = delegate.iterator[context.method];

              if (method === undefined) {
                // A .throw or .return when the delegate iterator has no .throw
                // method always terminates the yield* loop.
                context.delegate = null;

                if (context.method === "throw") {
                  if (delegate.iterator.return) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);

                    if (context.method === "throw") {
                      // If maybeInvokeDelegate(context) changed context.method from
                      // "return" to "throw", let that override the TypeError below.
                      return ContinueSentinel;
                    }
                  }

                  context.method = "throw";
                  context.arg = new TypeError("The iterator does not provide a 'throw' method");
                }

                return ContinueSentinel;
              }

              var record = tryCatch(method, delegate.iterator, context.arg);

              if (record.type === "throw") {
                context.method = "throw";
                context.arg = record.arg;
                context.delegate = null;
                return ContinueSentinel;
              }

              var info = record.arg;

              if (!info) {
                context.method = "throw";
                context.arg = new TypeError("iterator result is not an object");
                context.delegate = null;
                return ContinueSentinel;
              }

              if (info.done) {
                // Assign the result of the finished delegate to the temporary
                // variable specified by delegate.resultName (see delegateYield).
                context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

                context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
                // exception, let the outer generator proceed normally. If
                // context.method was "next", forget context.arg since it has been
                // "consumed" by the delegate iterator. If context.method was
                // "return", allow the original .return call to continue in the
                // outer generator.

                if (context.method !== "return") {
                  context.method = "next";
                  context.arg = undefined;
                }
              } else {
                // Re-yield the result returned by the delegate method.
                return info;
              } // The delegate iterator is finished, so forget it and continue with
              // the outer generator.


              context.delegate = null;
              return ContinueSentinel;
            } // Define Generator.prototype.{next,throw,return} in terms of the
            // unified ._invoke helper method.


            defineIteratorMethods(Gp);
            Gp[toStringTagSymbol] = "Generator"; // A Generator should always return itself as the iterator object when the
            // @@iterator function is called on it. Some browsers' implementations of the
            // iterator prototype chain incorrectly implement this, causing the Generator
            // object to not be returned from this call. This ensures that doesn't happen.
            // See https://github.com/facebook/regenerator/issues/274 for more details.

            Gp[iteratorSymbol] = function () {
              return this;
            };

            Gp.toString = function () {
              return "[object Generator]";
            };

            function pushTryEntry(locs) {
              var entry = {
                tryLoc: locs[0]
              };

              if (1 in locs) {
                entry.catchLoc = locs[1];
              }

              if (2 in locs) {
                entry.finallyLoc = locs[2];
                entry.afterLoc = locs[3];
              }

              this.tryEntries.push(entry);
            }

            function resetTryEntry(entry) {
              var record = entry.completion || {};
              record.type = "normal";
              delete record.arg;
              entry.completion = record;
            }

            function Context(tryLocsList) {
              // The root entry object (effectively a try statement without a catch
              // or a finally block) gives us a place to store values thrown from
              // locations where there is no enclosing try statement.
              this.tryEntries = [{
                tryLoc: "root"
              }];
              tryLocsList.forEach(pushTryEntry, this);
              this.reset(true);
            }

            runtime.keys = function (object) {
              var keys = [];

              for (var key in object) {
                keys.push(key);
              }

              keys.reverse(); // Rather than returning an object with a next method, we keep
              // things simple and return the next function itself.

              return function next() {
                while (keys.length) {
                  var key = keys.pop();

                  if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                  }
                } // To avoid creating an additional object, we just hang the .value
                // and .done properties off the next function object itself. This
                // also ensures that the minifier will not anonymize the function.


                next.done = true;
                return next;
              };
            };

            function values(iterable) {
              if (iterable) {
                var iteratorMethod = iterable[iteratorSymbol];

                if (iteratorMethod) {
                  return iteratorMethod.call(iterable);
                }

                if (typeof iterable.next === "function") {
                  return iterable;
                }

                if (!isNaN(iterable.length)) {
                  var i = -1,
                      next = function next() {
                    while (++i < iterable.length) {
                      if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                      }
                    }

                    next.value = undefined;
                    next.done = true;
                    return next;
                  };

                  return next.next = next;
                }
              } // Return an iterator with no values.


              return {
                next: doneResult
              };
            }

            runtime.values = values;

            function doneResult() {
              return {
                value: undefined,
                done: true
              };
            }

            Context.prototype = {
              constructor: Context,
              reset: function reset(skipTempReset) {
                this.prev = 0;
                this.next = 0; // Resetting context._sent for legacy support of Babel's
                // function.sent implementation.

                this.sent = this._sent = undefined;
                this.done = false;
                this.delegate = null;
                this.method = "next";
                this.arg = undefined;
                this.tryEntries.forEach(resetTryEntry);

                if (!skipTempReset) {
                  for (var name in this) {
                    // Not sure about the optimal order of these conditions:
                    if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
                      this[name] = undefined;
                    }
                  }
                }
              },
              stop: function stop() {
                this.done = true;
                var rootEntry = this.tryEntries[0];
                var rootRecord = rootEntry.completion;

                if (rootRecord.type === "throw") {
                  throw rootRecord.arg;
                }

                return this.rval;
              },
              dispatchException: function dispatchException(exception) {
                if (this.done) {
                  throw exception;
                }

                var context = this;

                function handle(loc, caught) {
                  record.type = "throw";
                  record.arg = exception;
                  context.next = loc;

                  if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                  }

                  return !!caught;
                }

                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                  var entry = this.tryEntries[i];
                  var record = entry.completion;

                  if (entry.tryLoc === "root") {
                    // Exception thrown outside of any try block that could handle
                    // it, so set the completion value of the entire function to
                    // throw the exception.
                    return handle("end");
                  }

                  if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");

                    if (hasCatch && hasFinally) {
                      if (this.prev < entry.catchLoc) {
                        return handle(entry.catchLoc, true);
                      } else if (this.prev < entry.finallyLoc) {
                        return handle(entry.finallyLoc);
                      }
                    } else if (hasCatch) {
                      if (this.prev < entry.catchLoc) {
                        return handle(entry.catchLoc, true);
                      }
                    } else if (hasFinally) {
                      if (this.prev < entry.finallyLoc) {
                        return handle(entry.finallyLoc);
                      }
                    } else {
                      throw new Error("try statement without catch or finally");
                    }
                  }
                }
              },
              abrupt: function abrupt(type, arg) {
                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                  var entry = this.tryEntries[i];

                  if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                  }
                }

                if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
                  // Ignore the finally entry if control is not jumping to a
                  // location outside the try/catch block.
                  finallyEntry = null;
                }

                var record = finallyEntry ? finallyEntry.completion : {};
                record.type = type;
                record.arg = arg;

                if (finallyEntry) {
                  this.method = "next";
                  this.next = finallyEntry.finallyLoc;
                  return ContinueSentinel;
                }

                return this.complete(record);
              },
              complete: function complete(record, afterLoc) {
                if (record.type === "throw") {
                  throw record.arg;
                }

                if (record.type === "break" || record.type === "continue") {
                  this.next = record.arg;
                } else if (record.type === "return") {
                  this.rval = this.arg = record.arg;
                  this.method = "return";
                  this.next = "end";
                } else if (record.type === "normal" && afterLoc) {
                  this.next = afterLoc;
                }

                return ContinueSentinel;
              },
              finish: function finish(finallyLoc) {
                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                  var entry = this.tryEntries[i];

                  if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                  }
                }
              },
              "catch": function _catch(tryLoc) {
                for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                  var entry = this.tryEntries[i];

                  if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;

                    if (record.type === "throw") {
                      var thrown = record.arg;
                      resetTryEntry(entry);
                    }

                    return thrown;
                  }
                } // The context.catch method must only be called with a location
                // argument that corresponds to a known catch block.


                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                this.delegate = {
                  iterator: values(iterable),
                  resultName: resultName,
                  nextLoc: nextLoc
                };

                if (this.method === "next") {
                  // Deliberately forget the last sent value so that we don't
                  // accidentally pass it on to the delegate.
                  this.arg = undefined;
                }

                return ContinueSentinel;
              }
            };
          }( // Among the various tricks for obtaining a reference to the global
          // object, this seems to be the most reliable technique that does not
          // use indirect eval (which violates Content Security Policy).
          typeof global === "object" ? global : typeof window === "object" ? window : typeof self === "object" ? self : this);
          /* WEBPACK VAR INJECTION */
        }).call(this, __webpack_require__(
        /*! ./../webpack/buildin/global.js */
        "./node_modules/webpack/buildin/global.js"));
        /***/
      },

      /***/
      "./node_modules/webpack/buildin/global.js":
      /*!***********************************!*\
        !*** (webpack)/buildin/global.js ***!
        \***********************************/

      /*! no static exports found */

      /***/
      function node_modulesWebpackBuildinGlobalJs(module, exports) {
        var g; // This works in non-strict mode

        g = function () {
          return this;
        }();

        try {
          // This works if eval is allowed (see CSP)
          g = g || new Function("return this")();
        } catch (e) {
          // This works if the window reference is available
          if (typeof window === "object") g = window;
        } // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}


        module.exports = g;
        /***/
      },

      /***/
      "./node_modules/whatwg-fetch/fetch.js":
      /*!********************************************!*\
        !*** ./node_modules/whatwg-fetch/fetch.js ***!
        \********************************************/

      /*! exports provided: Headers, Request, Response, DOMException, fetch */

      /***/
      function node_modulesWhatwgFetchFetchJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Headers", function () {
          return Headers;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Request", function () {
          return Request;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "Response", function () {
          return Response;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "DOMException", function () {
          return DOMException;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "fetch", function () {
          return fetch;
        });

        var support = {
          searchParams: 'URLSearchParams' in self,
          iterable: 'Symbol' in self && 'iterator' in Symbol,
          blob: 'FileReader' in self && 'Blob' in self && function () {
            try {
              new Blob();
              return true;
            } catch (e) {
              return false;
            }
          }(),
          formData: 'FormData' in self,
          arrayBuffer: 'ArrayBuffer' in self
        };

        function isDataView(obj) {
          return obj && DataView.prototype.isPrototypeOf(obj);
        }

        if (support.arrayBuffer) {
          var viewClasses = ['[object Int8Array]', '[object Uint8Array]', '[object Uint8ClampedArray]', '[object Int16Array]', '[object Uint16Array]', '[object Int32Array]', '[object Uint32Array]', '[object Float32Array]', '[object Float64Array]'];

          var isArrayBufferView = ArrayBuffer.isView || function (obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
          };
        }

        function normalizeName(name) {
          if (typeof name !== 'string') {
            name = String(name);
          }

          if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
            throw new TypeError('Invalid character in header field name');
          }

          return name.toLowerCase();
        }

        function normalizeValue(value) {
          if (typeof value !== 'string') {
            value = String(value);
          }

          return value;
        } // Build a destructive iterator for the value list


        function iteratorFor(items) {
          var iterator = {
            next: function next() {
              var value = items.shift();
              return {
                done: value === undefined,
                value: value
              };
            }
          };

          if (support.iterable) {
            iterator[Symbol.iterator] = function () {
              return iterator;
            };
          }

          return iterator;
        }

        function Headers(headers) {
          this.map = {};

          if (headers instanceof Headers) {
            headers.forEach(function (value, name) {
              this.append(name, value);
            }, this);
          } else if (Array.isArray(headers)) {
            headers.forEach(function (header) {
              this.append(header[0], header[1]);
            }, this);
          } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function (name) {
              this.append(name, headers[name]);
            }, this);
          }
        }

        Headers.prototype.append = function (name, value) {
          name = normalizeName(name);
          value = normalizeValue(value);
          var oldValue = this.map[name];
          this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };

        Headers.prototype['delete'] = function (name) {
          delete this.map[normalizeName(name)];
        };

        Headers.prototype.get = function (name) {
          name = normalizeName(name);
          return this.has(name) ? this.map[name] : null;
        };

        Headers.prototype.has = function (name) {
          return this.map.hasOwnProperty(normalizeName(name));
        };

        Headers.prototype.set = function (name, value) {
          this.map[normalizeName(name)] = normalizeValue(value);
        };

        Headers.prototype.forEach = function (callback, thisArg) {
          for (var name in this.map) {
            if (this.map.hasOwnProperty(name)) {
              callback.call(thisArg, this.map[name], name, this);
            }
          }
        };

        Headers.prototype.keys = function () {
          var items = [];
          this.forEach(function (value, name) {
            items.push(name);
          });
          return iteratorFor(items);
        };

        Headers.prototype.values = function () {
          var items = [];
          this.forEach(function (value) {
            items.push(value);
          });
          return iteratorFor(items);
        };

        Headers.prototype.entries = function () {
          var items = [];
          this.forEach(function (value, name) {
            items.push([name, value]);
          });
          return iteratorFor(items);
        };

        if (support.iterable) {
          Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        }

        function consumed(body) {
          if (body.bodyUsed) {
            return Promise.reject(new TypeError('Already read'));
          }

          body.bodyUsed = true;
        }

        function fileReaderReady(reader) {
          return new Promise(function (resolve, reject) {
            reader.onload = function () {
              resolve(reader.result);
            };

            reader.onerror = function () {
              reject(reader.error);
            };
          });
        }

        function readBlobAsArrayBuffer(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsArrayBuffer(blob);
          return promise;
        }

        function readBlobAsText(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsText(blob);
          return promise;
        }

        function readArrayBufferAsText(buf) {
          var view = new Uint8Array(buf);
          var chars = new Array(view.length);

          for (var i = 0; i < view.length; i++) {
            chars[i] = String.fromCharCode(view[i]);
          }

          return chars.join('');
        }

        function bufferClone(buf) {
          if (buf.slice) {
            return buf.slice(0);
          } else {
            var view = new Uint8Array(buf.byteLength);
            view.set(new Uint8Array(buf));
            return view.buffer;
          }
        }

        function Body() {
          this.bodyUsed = false;

          this._initBody = function (body) {
            this._bodyInit = body;

            if (!body) {
              this._bodyText = '';
            } else if (typeof body === 'string') {
              this._bodyText = body;
            } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
              this._bodyBlob = body;
            } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
              this._bodyFormData = body;
            } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this._bodyText = body.toString();
            } else if (support.arrayBuffer && support.blob && isDataView(body)) {
              this._bodyArrayBuffer = bufferClone(body.buffer); // IE 10-11 can't handle a DataView body.

              this._bodyInit = new Blob([this._bodyArrayBuffer]);
            } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
              this._bodyArrayBuffer = bufferClone(body);
            } else {
              this._bodyText = body = Object.prototype.toString.call(body);
            }

            if (!this.headers.get('content-type')) {
              if (typeof body === 'string') {
                this.headers.set('content-type', 'text/plain;charset=UTF-8');
              } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set('content-type', this._bodyBlob.type);
              } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
              }
            }
          };

          if (support.blob) {
            this.blob = function () {
              var rejected = consumed(this);

              if (rejected) {
                return rejected;
              }

              if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob);
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              } else if (this._bodyFormData) {
                throw new Error('could not read FormData body as blob');
              } else {
                return Promise.resolve(new Blob([this._bodyText]));
              }
            };

            this.arrayBuffer = function () {
              if (this._bodyArrayBuffer) {
                return consumed(this) || Promise.resolve(this._bodyArrayBuffer);
              } else {
                return this.blob().then(readBlobAsArrayBuffer);
              }
            };
          }

          this.text = function () {
            var rejected = consumed(this);

            if (rejected) {
              return rejected;
            }

            if (this._bodyBlob) {
              return readBlobAsText(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            } else if (this._bodyFormData) {
              throw new Error('could not read FormData body as text');
            } else {
              return Promise.resolve(this._bodyText);
            }
          };

          if (support.formData) {
            this.formData = function () {
              return this.text().then(decode);
            };
          }

          this.json = function () {
            return this.text().then(JSON.parse);
          };

          return this;
        } // HTTP methods whose capitalization should be normalized


        var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

        function normalizeMethod(method) {
          var upcased = method.toUpperCase();
          return methods.indexOf(upcased) > -1 ? upcased : method;
        }

        function Request(input, options) {
          options = options || {};
          var body = options.body;

          if (input instanceof Request) {
            if (input.bodyUsed) {
              throw new TypeError('Already read');
            }

            this.url = input.url;
            this.credentials = input.credentials;

            if (!options.headers) {
              this.headers = new Headers(input.headers);
            }

            this.method = input.method;
            this.mode = input.mode;
            this.signal = input.signal;

            if (!body && input._bodyInit != null) {
              body = input._bodyInit;
              input.bodyUsed = true;
            }
          } else {
            this.url = String(input);
          }

          this.credentials = options.credentials || this.credentials || 'same-origin';

          if (options.headers || !this.headers) {
            this.headers = new Headers(options.headers);
          }

          this.method = normalizeMethod(options.method || this.method || 'GET');
          this.mode = options.mode || this.mode || null;
          this.signal = options.signal || this.signal;
          this.referrer = null;

          if ((this.method === 'GET' || this.method === 'HEAD') && body) {
            throw new TypeError('Body not allowed for GET or HEAD requests');
          }

          this._initBody(body);
        }

        Request.prototype.clone = function () {
          return new Request(this, {
            body: this._bodyInit
          });
        };

        function decode(body) {
          var form = new FormData();
          body.trim().split('&').forEach(function (bytes) {
            if (bytes) {
              var split = bytes.split('=');
              var name = split.shift().replace(/\+/g, ' ');
              var value = split.join('=').replace(/\+/g, ' ');
              form.append(decodeURIComponent(name), decodeURIComponent(value));
            }
          });
          return form;
        }

        function parseHeaders(rawHeaders) {
          var headers = new Headers(); // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
          // https://tools.ietf.org/html/rfc7230#section-3.2

          var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
          preProcessedHeaders.split(/\r?\n/).forEach(function (line) {
            var parts = line.split(':');
            var key = parts.shift().trim();

            if (key) {
              var value = parts.join(':').trim();
              headers.append(key, value);
            }
          });
          return headers;
        }

        Body.call(Request.prototype);

        function Response(bodyInit, options) {
          if (!options) {
            options = {};
          }

          this.type = 'default';
          this.status = options.status === undefined ? 200 : options.status;
          this.ok = this.status >= 200 && this.status < 300;
          this.statusText = 'statusText' in options ? options.statusText : 'OK';
          this.headers = new Headers(options.headers);
          this.url = options.url || '';

          this._initBody(bodyInit);
        }

        Body.call(Response.prototype);

        Response.prototype.clone = function () {
          return new Response(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers(this.headers),
            url: this.url
          });
        };

        Response.error = function () {
          var response = new Response(null, {
            status: 0,
            statusText: ''
          });
          response.type = 'error';
          return response;
        };

        var redirectStatuses = [301, 302, 303, 307, 308];

        Response.redirect = function (url, status) {
          if (redirectStatuses.indexOf(status) === -1) {
            throw new RangeError('Invalid status code');
          }

          return new Response(null, {
            status: status,
            headers: {
              location: url
            }
          });
        };

        var DOMException = self.DOMException;

        try {
          new DOMException();
        } catch (err) {
          DOMException = function DOMException(message, name) {
            this.message = message;
            this.name = name;
            var error = Error(message);
            this.stack = error.stack;
          };

          DOMException.prototype = Object.create(Error.prototype);
          DOMException.prototype.constructor = DOMException;
        }

        function fetch(input, init) {
          return new Promise(function (resolve, reject) {
            var request = new Request(input, init);

            if (request.signal && request.signal.aborted) {
              return reject(new DOMException('Aborted', 'AbortError'));
            }

            var xhr = new XMLHttpRequest();

            function abortXhr() {
              xhr.abort();
            }

            xhr.onload = function () {
              var options = {
                status: xhr.status,
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || '')
              };
              options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
              var body = 'response' in xhr ? xhr.response : xhr.responseText;
              resolve(new Response(body, options));
            };

            xhr.onerror = function () {
              reject(new TypeError('Network request failed'));
            };

            xhr.ontimeout = function () {
              reject(new TypeError('Network request failed'));
            };

            xhr.onabort = function () {
              reject(new DOMException('Aborted', 'AbortError'));
            };

            xhr.open(request.method, request.url, true);

            if (request.credentials === 'include') {
              xhr.withCredentials = true;
            } else if (request.credentials === 'omit') {
              xhr.withCredentials = false;
            }

            if ('responseType' in xhr && support.blob) {
              xhr.responseType = 'blob';
            }

            request.headers.forEach(function (value, name) {
              xhr.setRequestHeader(name, value);
            });

            if (request.signal) {
              request.signal.addEventListener('abort', abortXhr);

              xhr.onreadystatechange = function () {
                // DONE (success or failure)
                if (xhr.readyState === 4) {
                  request.signal.removeEventListener('abort', abortXhr);
                }
              };
            }

            xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
          });
        }

        fetch.polyfill = true;

        if (!self.fetch) {
          self.fetch = fetch;
          self.Headers = Headers;
          self.Request = Request;
          self.Response = Response;
        }
        /***/

      },

      /***/
      "./webpack.entry.js":
      /*!**************************!*\
        !*** ./webpack.entry.js ***!
        \**************************/

      /*! exports provided: Localizable, LocaleManager, AjaxHelper, ArrayHelper, BrowserHelper, CSSHelper, DateHelper, DomHelper, DomClassList, DragHelper, EventHelper, FunctionHelper, IdHelper, ObjectHelper, ResizeHelper, StringHelper, TemplateHelper, VersionHelper, WidgetHelper, Point, Rectangle, ResizeMonitor, GlobalEvents, DataGenerator, RandomGenerator, DemoBot, Fullscreen, Scroller, Delayable, Events, InstancePlugin, Override, Pluggable, State, BooleanCombo, Button, ButtonGroup, CalendarPanel, Checkbox, Combo, Container, Field, FileField, FilePicker, FlagField, DateField, DatePicker, DisplayField, DurationField, List, ChipView, Mask, Menu, MenuItem, NumberField, Tool, Panel, Popup, Ripple, Slider, TabPanel, TextField, TextAreaField, TimeField, TimePicker, Toast, Tooltip, Widget, BryntumWidgetAdapter, BryntumWidgetAdapterRegister, AjaxStore, Model, Store, StateTrackingManager, Transaction, Column, CheckColumn, DateColumn, PercentColumn, RatingColumn, RowNumberColumn, TemplateColumn, TimeColumn, TreeColumn, WidgetColumn, TimeAxisColumn, ResourceInfoColumn, GridFeatureManager, CellEdit, CellTooltip, ColumnPicker, ColumnReorder, ColumnResize, ContextMenu, Filter, FilterBar, Group, QuickFind, Search, Sort, RegionResize, RowReorder, Stripe, Tree, Grid, TreeGrid, AjaxTransport, AbstractCrudManager, JsonEncoder, ColumnStore, AssignmentStore, Calendar, CrudManager, DependencyStore, EventStore, ResourceStore, ResourceTimeRangeStore, TimeAxis, ColumnLines, Dependencies, DependencyEdit, EventContextMenu, EventDrag, EventDragCreate, EventDragSelect, EventEdit, EventFilter, EventResize, EventTooltip, GroupSummary, HeaderContextMenu, HeaderZoom, Labels, NonWorkingTime, Pan, ResourceTimeRanges, ScheduleTooltip, SimpleEventEdit, Summary, TimeRanges, AssignmentModel, CalendarDayModel, DependencyBaseModel, DependencyModel, EventModel, ResourceModel, ResourceTimeRangeModel, TimeSpan, PresetManager, ViewPreset, RectangularPathFinder, TimeAxisViewModel, HorizontalTimeAxis, Scheduler, RowManager, SchedulerTag */

      /***/
      function webpackEntryJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var whatwg_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! whatwg-fetch */
        "./node_modules/whatwg-fetch/fetch.js");
        /* harmony import */


        var abortcontroller_polyfill__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! abortcontroller-polyfill */
        "./node_modules/abortcontroller-polyfill/dist/umd-polyfill.js");
        /* harmony import */


        var abortcontroller_polyfill__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(abortcontroller_polyfill__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _lib_Common_adapter_widget_BryntumWidgetAdapter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./lib/Common/adapter/widget/BryntumWidgetAdapter.js */
        "../Grid/lib/Common/adapter/widget/BryntumWidgetAdapter.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "BryntumWidgetAdapter", function () {
          return _lib_Common_adapter_widget_BryntumWidgetAdapter_js__WEBPACK_IMPORTED_MODULE_2__["default"];
        });
        /* harmony import */


        var _lib_Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js */
        "../Grid/lib/Common/adapter/widget/util/BryntumWidgetAdapterRegister.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "BryntumWidgetAdapterRegister", function () {
          return _lib_Common_adapter_widget_util_BryntumWidgetAdapterRegister_js__WEBPACK_IMPORTED_MODULE_3__["default"];
        });
        /* harmony import */


        var _lib_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./lib/Common/data/AjaxStore.js */
        "../Grid/lib/Common/data/AjaxStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "AjaxStore", function () {
          return _lib_Common_data_AjaxStore_js__WEBPACK_IMPORTED_MODULE_4__["default"];
        });
        /* harmony import */


        var _lib_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./lib/Common/data/Model.js */
        "../Grid/lib/Common/data/Model.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Model", function () {
          return _lib_Common_data_Model_js__WEBPACK_IMPORTED_MODULE_5__["default"];
        });
        /* harmony import */


        var _lib_Common_data_Store_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./lib/Common/data/Store.js */
        "../Grid/lib/Common/data/Store.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Store", function () {
          return _lib_Common_data_Store_js__WEBPACK_IMPORTED_MODULE_6__["default"];
        });
        /* harmony import */


        var _lib_Common_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./lib/Common/data/stm/StateTrackingManager.js */
        "../Grid/lib/Common/data/stm/StateTrackingManager.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "StateTrackingManager", function () {
          return _lib_Common_data_stm_StateTrackingManager_js__WEBPACK_IMPORTED_MODULE_7__["default"];
        });
        /* harmony import */


        var _lib_Common_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./lib/Common/data/stm/Transaction.js */
        "../Grid/lib/Common/data/stm/Transaction.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Transaction", function () {
          return _lib_Common_data_stm_Transaction_js__WEBPACK_IMPORTED_MODULE_8__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./lib/Common/helper/AjaxHelper.js */
        "../Grid/lib/Common/helper/AjaxHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "AjaxHelper", function () {
          return _lib_Common_helper_AjaxHelper_js__WEBPACK_IMPORTED_MODULE_9__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./lib/Common/helper/ArrayHelper.js */
        "../Grid/lib/Common/helper/ArrayHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ArrayHelper", function () {
          return _lib_Common_helper_ArrayHelper_js__WEBPACK_IMPORTED_MODULE_10__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! ./lib/Common/helper/BrowserHelper.js */
        "../Grid/lib/Common/helper/BrowserHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "BrowserHelper", function () {
          return _lib_Common_helper_BrowserHelper_js__WEBPACK_IMPORTED_MODULE_11__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! ./lib/Common/helper/CSSHelper.js */
        "../Grid/lib/Common/helper/CSSHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "CSSHelper", function () {
          return _lib_Common_helper_CSSHelper_js__WEBPACK_IMPORTED_MODULE_12__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(
        /*! ./lib/Common/helper/DateHelper.js */
        "../Grid/lib/Common/helper/DateHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DateHelper", function () {
          return _lib_Common_helper_DateHelper_js__WEBPACK_IMPORTED_MODULE_13__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(
        /*! ./lib/Common/helper/DragHelper.js */
        "../Grid/lib/Common/helper/DragHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DragHelper", function () {
          return _lib_Common_helper_DragHelper_js__WEBPACK_IMPORTED_MODULE_14__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(
        /*! ./lib/Common/helper/DomHelper.js */
        "../Grid/lib/Common/helper/DomHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DomHelper", function () {
          return _lib_Common_helper_DomHelper_js__WEBPACK_IMPORTED_MODULE_15__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(
        /*! ./lib/Common/helper/util/DomClassList.js */
        "../Grid/lib/Common/helper/util/DomClassList.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DomClassList", function () {
          return _lib_Common_helper_util_DomClassList_js__WEBPACK_IMPORTED_MODULE_16__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(
        /*! ./lib/Common/helper/EventHelper.js */
        "../Grid/lib/Common/helper/EventHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventHelper", function () {
          return _lib_Common_helper_EventHelper_js__WEBPACK_IMPORTED_MODULE_17__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(
        /*! ./lib/Common/helper/FunctionHelper.js */
        "../Grid/lib/Common/helper/FunctionHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "FunctionHelper", function () {
          return _lib_Common_helper_FunctionHelper_js__WEBPACK_IMPORTED_MODULE_18__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(
        /*! ./lib/Common/helper/IdHelper.js */
        "../Grid/lib/Common/helper/IdHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "IdHelper", function () {
          return _lib_Common_helper_IdHelper_js__WEBPACK_IMPORTED_MODULE_19__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(
        /*! ./lib/Common/helper/ObjectHelper.js */
        "../Grid/lib/Common/helper/ObjectHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ObjectHelper", function () {
          return _lib_Common_helper_ObjectHelper_js__WEBPACK_IMPORTED_MODULE_20__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(
        /*! ./lib/Common/helper/ResizeHelper.js */
        "../Grid/lib/Common/helper/ResizeHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResizeHelper", function () {
          return _lib_Common_helper_ResizeHelper_js__WEBPACK_IMPORTED_MODULE_21__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(
        /*! ./lib/Common/helper/StringHelper.js */
        "../Grid/lib/Common/helper/StringHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "StringHelper", function () {
          return _lib_Common_helper_StringHelper_js__WEBPACK_IMPORTED_MODULE_22__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(
        /*! ./lib/Common/helper/TemplateHelper.js */
        "../Grid/lib/Common/helper/TemplateHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TemplateHelper", function () {
          return _lib_Common_helper_TemplateHelper_js__WEBPACK_IMPORTED_MODULE_23__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(
        /*! ./lib/Common/helper/VersionHelper.js */
        "../Grid/lib/Common/helper/VersionHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "VersionHelper", function () {
          return _lib_Common_helper_VersionHelper_js__WEBPACK_IMPORTED_MODULE_24__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(
        /*! ./lib/Common/helper/WidgetHelper.js */
        "../Grid/lib/Common/helper/WidgetHelper.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "WidgetHelper", function () {
          return _lib_Common_helper_WidgetHelper_js__WEBPACK_IMPORTED_MODULE_25__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(
        /*! ./lib/Common/helper/util/DataGenerator.js */
        "../Grid/lib/Common/helper/util/DataGenerator.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DataGenerator", function () {
          return _lib_Common_helper_util_DataGenerator_js__WEBPACK_IMPORTED_MODULE_26__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(
        /*! ./lib/Common/helper/util/RandomGenerator.js */
        "../Grid/lib/Common/helper/util/RandomGenerator.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RandomGenerator", function () {
          return _lib_Common_helper_util_RandomGenerator_js__WEBPACK_IMPORTED_MODULE_27__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(
        /*! ./lib/Common/helper/util/DemoBot.js */
        "../Grid/lib/Common/helper/util/DemoBot.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DemoBot", function () {
          return _lib_Common_helper_util_DemoBot_js__WEBPACK_IMPORTED_MODULE_28__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(
        /*! ./lib/Common/helper/util/Fullscreen.js */
        "../Grid/lib/Common/helper/util/Fullscreen.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Fullscreen", function () {
          return _lib_Common_helper_util_Fullscreen_js__WEBPACK_IMPORTED_MODULE_29__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(
        /*! ./lib/Common/helper/util/Scroller.js */
        "../Grid/lib/Common/helper/util/Scroller.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Scroller", function () {
          return _lib_Common_helper_util_Scroller_js__WEBPACK_IMPORTED_MODULE_30__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(
        /*! ./lib/Common/helper/util/Point.js */
        "../Grid/lib/Common/helper/util/Point.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Point", function () {
          return _lib_Common_helper_util_Point_js__WEBPACK_IMPORTED_MODULE_31__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(
        /*! ./lib/Common/helper/util/Rectangle.js */
        "../Grid/lib/Common/helper/util/Rectangle.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Rectangle", function () {
          return _lib_Common_helper_util_Rectangle_js__WEBPACK_IMPORTED_MODULE_32__["default"];
        });
        /* harmony import */


        var _lib_Common_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(
        /*! ./lib/Common/helper/ResizeMonitor.js */
        "../Grid/lib/Common/helper/ResizeMonitor.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResizeMonitor", function () {
          return _lib_Common_helper_ResizeMonitor_js__WEBPACK_IMPORTED_MODULE_33__["default"];
        });
        /* harmony import */


        var _lib_Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(
        /*! ./lib/Common/GlobalEvents.js */
        "../Grid/lib/Common/GlobalEvents.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "GlobalEvents", function () {
          return _lib_Common_GlobalEvents_js__WEBPACK_IMPORTED_MODULE_34__["default"];
        });
        /* harmony import */


        var _lib_Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(
        /*! ./lib/Common/localization/Localizable.js */
        "../Grid/lib/Common/localization/Localizable.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Localizable", function () {
          return _lib_Common_localization_Localizable_js__WEBPACK_IMPORTED_MODULE_35__["default"];
        });
        /* harmony import */


        var _lib_Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(
        /*! ./lib/Common/localization/LocaleManager.js */
        "../Grid/lib/Common/localization/LocaleManager.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "LocaleManager", function () {
          return _lib_Common_localization_LocaleManager_js__WEBPACK_IMPORTED_MODULE_36__["default"];
        });
        /* harmony import */


        var _lib_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(
        /*! ./lib/Common/mixin/Delayable.js */
        "../Grid/lib/Common/mixin/Delayable.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Delayable", function () {
          return _lib_Common_mixin_Delayable_js__WEBPACK_IMPORTED_MODULE_37__["default"];
        });
        /* harmony import */


        var _lib_Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(
        /*! ./lib/Common/mixin/Events.js */
        "../Grid/lib/Common/mixin/Events.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Events", function () {
          return _lib_Common_mixin_Events_js__WEBPACK_IMPORTED_MODULE_38__["default"];
        });
        /* harmony import */


        var _lib_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(
        /*! ./lib/Common/mixin/InstancePlugin.js */
        "../Grid/lib/Common/mixin/InstancePlugin.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "InstancePlugin", function () {
          return _lib_Common_mixin_InstancePlugin_js__WEBPACK_IMPORTED_MODULE_39__["default"];
        });
        /* harmony import */


        var _lib_Common_mixin_Override_js__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(
        /*! ./lib/Common/mixin/Override.js */
        "../Grid/lib/Common/mixin/Override.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Override", function () {
          return _lib_Common_mixin_Override_js__WEBPACK_IMPORTED_MODULE_40__["default"];
        });
        /* harmony import */


        var _lib_Common_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(
        /*! ./lib/Common/mixin/Pluggable.js */
        "../Grid/lib/Common/mixin/Pluggable.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Pluggable", function () {
          return _lib_Common_mixin_Pluggable_js__WEBPACK_IMPORTED_MODULE_41__["default"];
        });
        /* harmony import */


        var _lib_Common_mixin_State_js__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(
        /*! ./lib/Common/mixin/State.js */
        "../Grid/lib/Common/mixin/State.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "State", function () {
          return _lib_Common_mixin_State_js__WEBPACK_IMPORTED_MODULE_42__["default"];
        });
        /* harmony import */


        var _lib_Common_util_CollectionFilter_js__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(
        /*! ./lib/Common/util/CollectionFilter.js */
        "../Grid/lib/Common/util/CollectionFilter.js");
        /* harmony import */


        var _lib_Common_util_CollectionSorter_js__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(
        /*! ./lib/Common/util/CollectionSorter.js */
        "../Grid/lib/Common/util/CollectionSorter.js");
        /* harmony import */


        var _lib_Common_util_Collection_js__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(
        /*! ./lib/Common/util/Collection.js */
        "../Grid/lib/Common/util/Collection.js");
        /* harmony import */


        var _lib_Common_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(
        /*! ./lib/Common/widget/BooleanCombo.js */
        "../Grid/lib/Common/widget/BooleanCombo.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "BooleanCombo", function () {
          return _lib_Common_widget_BooleanCombo_js__WEBPACK_IMPORTED_MODULE_46__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Button_js__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(
        /*! ./lib/Common/widget/Button.js */
        "../Grid/lib/Common/widget/Button.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Button", function () {
          return _lib_Common_widget_Button_js__WEBPACK_IMPORTED_MODULE_47__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(
        /*! ./lib/Common/widget/ButtonGroup.js */
        "../Grid/lib/Common/widget/ButtonGroup.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ButtonGroup", function () {
          return _lib_Common_widget_ButtonGroup_js__WEBPACK_IMPORTED_MODULE_48__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(
        /*! ./lib/Common/widget/CalendarPanel.js */
        "../Grid/lib/Common/widget/CalendarPanel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "CalendarPanel", function () {
          return _lib_Common_widget_CalendarPanel_js__WEBPACK_IMPORTED_MODULE_49__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(
        /*! ./lib/Common/widget/Checkbox.js */
        "../Grid/lib/Common/widget/Checkbox.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Checkbox", function () {
          return _lib_Common_widget_Checkbox_js__WEBPACK_IMPORTED_MODULE_50__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Combo_js__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(
        /*! ./lib/Common/widget/Combo.js */
        "../Grid/lib/Common/widget/Combo.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Combo", function () {
          return _lib_Common_widget_Combo_js__WEBPACK_IMPORTED_MODULE_51__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Container_js__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(
        /*! ./lib/Common/widget/Container.js */
        "../Grid/lib/Common/widget/Container.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Container", function () {
          return _lib_Common_widget_Container_js__WEBPACK_IMPORTED_MODULE_52__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Field_js__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(
        /*! ./lib/Common/widget/Field.js */
        "../Grid/lib/Common/widget/Field.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Field", function () {
          return _lib_Common_widget_Field_js__WEBPACK_IMPORTED_MODULE_53__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_FileField_js__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(
        /*! ./lib/Common/widget/FileField.js */
        "../Grid/lib/Common/widget/FileField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "FileField", function () {
          return _lib_Common_widget_FileField_js__WEBPACK_IMPORTED_MODULE_54__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(
        /*! ./lib/Common/widget/FilePicker.js */
        "../Grid/lib/Common/widget/FilePicker.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "FilePicker", function () {
          return _lib_Common_widget_FilePicker_js__WEBPACK_IMPORTED_MODULE_55__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_FlagField_js__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(
        /*! ./lib/Common/widget/FlagField.js */
        "../Grid/lib/Common/widget/FlagField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "FlagField", function () {
          return _lib_Common_widget_FlagField_js__WEBPACK_IMPORTED_MODULE_56__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_DateField_js__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(
        /*! ./lib/Common/widget/DateField.js */
        "../Grid/lib/Common/widget/DateField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DateField", function () {
          return _lib_Common_widget_DateField_js__WEBPACK_IMPORTED_MODULE_57__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(
        /*! ./lib/Common/widget/DatePicker.js */
        "../Grid/lib/Common/widget/DatePicker.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DatePicker", function () {
          return _lib_Common_widget_DatePicker_js__WEBPACK_IMPORTED_MODULE_58__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(
        /*! ./lib/Common/widget/DisplayField.js */
        "../Grid/lib/Common/widget/DisplayField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DisplayField", function () {
          return _lib_Common_widget_DisplayField_js__WEBPACK_IMPORTED_MODULE_59__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(
        /*! ./lib/Common/widget/DurationField.js */
        "../Grid/lib/Common/widget/DurationField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DurationField", function () {
          return _lib_Common_widget_DurationField_js__WEBPACK_IMPORTED_MODULE_60__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_List_js__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(
        /*! ./lib/Common/widget/List.js */
        "../Grid/lib/Common/widget/List.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "List", function () {
          return _lib_Common_widget_List_js__WEBPACK_IMPORTED_MODULE_61__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(
        /*! ./lib/Common/widget/ChipView.js */
        "../Grid/lib/Common/widget/ChipView.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ChipView", function () {
          return _lib_Common_widget_ChipView_js__WEBPACK_IMPORTED_MODULE_62__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Mask_js__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(
        /*! ./lib/Common/widget/Mask.js */
        "../Grid/lib/Common/widget/Mask.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Mask", function () {
          return _lib_Common_widget_Mask_js__WEBPACK_IMPORTED_MODULE_63__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Menu_js__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(
        /*! ./lib/Common/widget/Menu.js */
        "../Grid/lib/Common/widget/Menu.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Menu", function () {
          return _lib_Common_widget_Menu_js__WEBPACK_IMPORTED_MODULE_64__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(
        /*! ./lib/Common/widget/MenuItem.js */
        "../Grid/lib/Common/widget/MenuItem.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "MenuItem", function () {
          return _lib_Common_widget_MenuItem_js__WEBPACK_IMPORTED_MODULE_65__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(
        /*! ./lib/Common/widget/NumberField.js */
        "../Grid/lib/Common/widget/NumberField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "NumberField", function () {
          return _lib_Common_widget_NumberField_js__WEBPACK_IMPORTED_MODULE_66__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Tool_js__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(
        /*! ./lib/Common/widget/Tool.js */
        "../Grid/lib/Common/widget/Tool.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Tool", function () {
          return _lib_Common_widget_Tool_js__WEBPACK_IMPORTED_MODULE_67__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Panel_js__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(
        /*! ./lib/Common/widget/Panel.js */
        "../Grid/lib/Common/widget/Panel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Panel", function () {
          return _lib_Common_widget_Panel_js__WEBPACK_IMPORTED_MODULE_68__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Popup_js__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(
        /*! ./lib/Common/widget/Popup.js */
        "../Grid/lib/Common/widget/Popup.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Popup", function () {
          return _lib_Common_widget_Popup_js__WEBPACK_IMPORTED_MODULE_69__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(
        /*! ./lib/Common/widget/Ripple.js */
        "../Grid/lib/Common/widget/Ripple.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Ripple", function () {
          return _lib_Common_widget_Ripple_js__WEBPACK_IMPORTED_MODULE_70__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Slider_js__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(
        /*! ./lib/Common/widget/Slider.js */
        "../Grid/lib/Common/widget/Slider.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Slider", function () {
          return _lib_Common_widget_Slider_js__WEBPACK_IMPORTED_MODULE_71__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(
        /*! ./lib/Common/widget/TabPanel.js */
        "../Grid/lib/Common/widget/TabPanel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TabPanel", function () {
          return _lib_Common_widget_TabPanel_js__WEBPACK_IMPORTED_MODULE_72__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(
        /*! ./lib/Common/widget/TextAreaField.js */
        "../Grid/lib/Common/widget/TextAreaField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TextAreaField", function () {
          return _lib_Common_widget_TextAreaField_js__WEBPACK_IMPORTED_MODULE_73__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_TextField_js__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(
        /*! ./lib/Common/widget/TextField.js */
        "../Grid/lib/Common/widget/TextField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TextField", function () {
          return _lib_Common_widget_TextField_js__WEBPACK_IMPORTED_MODULE_74__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(
        /*! ./lib/Common/widget/TimeField.js */
        "../Grid/lib/Common/widget/TimeField.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimeField", function () {
          return _lib_Common_widget_TimeField_js__WEBPACK_IMPORTED_MODULE_75__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(
        /*! ./lib/Common/widget/TimePicker.js */
        "../Grid/lib/Common/widget/TimePicker.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimePicker", function () {
          return _lib_Common_widget_TimePicker_js__WEBPACK_IMPORTED_MODULE_76__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Toast_js__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(
        /*! ./lib/Common/widget/Toast.js */
        "../Grid/lib/Common/widget/Toast.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Toast", function () {
          return _lib_Common_widget_Toast_js__WEBPACK_IMPORTED_MODULE_77__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(
        /*! ./lib/Common/widget/Tooltip.js */
        "../Grid/lib/Common/widget/Tooltip.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Tooltip", function () {
          return _lib_Common_widget_Tooltip_js__WEBPACK_IMPORTED_MODULE_78__["default"];
        });
        /* harmony import */


        var _lib_Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(
        /*! ./lib/Common/widget/Widget.js */
        "../Grid/lib/Common/widget/Widget.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Widget", function () {
          return _lib_Common_widget_Widget_js__WEBPACK_IMPORTED_MODULE_79__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(
        /*! ./lib/Grid/column/Column.js */
        "../Grid/lib/Grid/column/Column.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Column", function () {
          return _lib_Grid_column_Column_js__WEBPACK_IMPORTED_MODULE_80__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(
        /*! ./lib/Grid/column/CheckColumn.js */
        "../Grid/lib/Grid/column/CheckColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "CheckColumn", function () {
          return _lib_Grid_column_CheckColumn_js__WEBPACK_IMPORTED_MODULE_81__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(
        /*! ./lib/Grid/column/DateColumn.js */
        "../Grid/lib/Grid/column/DateColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DateColumn", function () {
          return _lib_Grid_column_DateColumn_js__WEBPACK_IMPORTED_MODULE_82__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_PercentColumn_js__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(
        /*! ./lib/Grid/column/PercentColumn.js */
        "../Grid/lib/Grid/column/PercentColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "PercentColumn", function () {
          return _lib_Grid_column_PercentColumn_js__WEBPACK_IMPORTED_MODULE_83__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_RatingColumn_js__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(
        /*! ./lib/Grid/column/RatingColumn.js */
        "../Grid/lib/Grid/column/RatingColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RatingColumn", function () {
          return _lib_Grid_column_RatingColumn_js__WEBPACK_IMPORTED_MODULE_84__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_RowNumberColumn_js__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(
        /*! ./lib/Grid/column/RowNumberColumn.js */
        "../Grid/lib/Grid/column/RowNumberColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RowNumberColumn", function () {
          return _lib_Grid_column_RowNumberColumn_js__WEBPACK_IMPORTED_MODULE_85__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_TemplateColumn_js__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(
        /*! ./lib/Grid/column/TemplateColumn.js */
        "../Grid/lib/Grid/column/TemplateColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TemplateColumn", function () {
          return _lib_Grid_column_TemplateColumn_js__WEBPACK_IMPORTED_MODULE_86__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_TimeColumn_js__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(
        /*! ./lib/Grid/column/TimeColumn.js */
        "../Grid/lib/Grid/column/TimeColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimeColumn", function () {
          return _lib_Grid_column_TimeColumn_js__WEBPACK_IMPORTED_MODULE_87__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(
        /*! ./lib/Grid/column/TreeColumn.js */
        "../Grid/lib/Grid/column/TreeColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TreeColumn", function () {
          return _lib_Grid_column_TreeColumn_js__WEBPACK_IMPORTED_MODULE_88__["default"];
        });
        /* harmony import */


        var _lib_Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(
        /*! ./lib/Grid/column/WidgetColumn.js */
        "../Grid/lib/Grid/column/WidgetColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "WidgetColumn", function () {
          return _lib_Grid_column_WidgetColumn_js__WEBPACK_IMPORTED_MODULE_89__["default"];
        });
        /* harmony import */


        var _lib_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(
        /*! ./lib/Grid/data/ColumnStore.js */
        "../Grid/lib/Grid/data/ColumnStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ColumnStore", function () {
          return _lib_Grid_data_ColumnStore_js__WEBPACK_IMPORTED_MODULE_90__["default"];
        });
        /* harmony import */


        var _lib_Grid_data_GridRowModel_js__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(
        /*! ./lib/Grid/data/GridRowModel.js */
        "../Grid/lib/Grid/data/GridRowModel.js");
        /* harmony import */


        var _lib_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(
        /*! ./lib/Grid/feature/GridFeatureManager.js */
        "../Grid/lib/Grid/feature/GridFeatureManager.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "GridFeatureManager", function () {
          return _lib_Grid_feature_GridFeatureManager_js__WEBPACK_IMPORTED_MODULE_92__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(
        /*! ./lib/Grid/feature/CellEdit.js */
        "../Grid/lib/Grid/feature/CellEdit.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "CellEdit", function () {
          return _lib_Grid_feature_CellEdit_js__WEBPACK_IMPORTED_MODULE_93__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_ColumnDragToolbar_js__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(
        /*! ./lib/Grid/feature/ColumnDragToolbar.js */
        "../Grid/lib/Grid/feature/ColumnDragToolbar.js");
        /* harmony import */


        var _lib_Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_95__ = __webpack_require__(
        /*! ./lib/Grid/feature/ColumnPicker.js */
        "../Grid/lib/Grid/feature/ColumnPicker.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ColumnPicker", function () {
          return _lib_Grid_feature_ColumnPicker_js__WEBPACK_IMPORTED_MODULE_95__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_96__ = __webpack_require__(
        /*! ./lib/Grid/feature/ColumnReorder.js */
        "../Grid/lib/Grid/feature/ColumnReorder.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ColumnReorder", function () {
          return _lib_Grid_feature_ColumnReorder_js__WEBPACK_IMPORTED_MODULE_96__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_97__ = __webpack_require__(
        /*! ./lib/Grid/feature/ColumnResize.js */
        "../Grid/lib/Grid/feature/ColumnResize.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ColumnResize", function () {
          return _lib_Grid_feature_ColumnResize_js__WEBPACK_IMPORTED_MODULE_97__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_98__ = __webpack_require__(
        /*! ./lib/Grid/feature/ContextMenu.js */
        "../Grid/lib/Grid/feature/ContextMenu.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ContextMenu", function () {
          return _lib_Grid_feature_ContextMenu_js__WEBPACK_IMPORTED_MODULE_98__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_CellTooltip_js__WEBPACK_IMPORTED_MODULE_99__ = __webpack_require__(
        /*! ./lib/Grid/feature/CellTooltip.js */
        "../Grid/lib/Grid/feature/CellTooltip.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "CellTooltip", function () {
          return _lib_Grid_feature_CellTooltip_js__WEBPACK_IMPORTED_MODULE_99__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_100__ = __webpack_require__(
        /*! ./lib/Grid/feature/Filter.js */
        "../Grid/lib/Grid/feature/Filter.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Filter", function () {
          return _lib_Grid_feature_Filter_js__WEBPACK_IMPORTED_MODULE_100__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_101__ = __webpack_require__(
        /*! ./lib/Grid/feature/FilterBar.js */
        "../Grid/lib/Grid/feature/FilterBar.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "FilterBar", function () {
          return _lib_Grid_feature_FilterBar_js__WEBPACK_IMPORTED_MODULE_101__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_102__ = __webpack_require__(
        /*! ./lib/Grid/feature/Group.js */
        "../Grid/lib/Grid/feature/Group.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Group", function () {
          return _lib_Grid_feature_Group_js__WEBPACK_IMPORTED_MODULE_102__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_QuickFind_js__WEBPACK_IMPORTED_MODULE_103__ = __webpack_require__(
        /*! ./lib/Grid/feature/QuickFind.js */
        "../Grid/lib/Grid/feature/QuickFind.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "QuickFind", function () {
          return _lib_Grid_feature_QuickFind_js__WEBPACK_IMPORTED_MODULE_103__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_Search_js__WEBPACK_IMPORTED_MODULE_104__ = __webpack_require__(
        /*! ./lib/Grid/feature/Search.js */
        "../Grid/lib/Grid/feature/Search.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Search", function () {
          return _lib_Grid_feature_Search_js__WEBPACK_IMPORTED_MODULE_104__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_105__ = __webpack_require__(
        /*! ./lib/Grid/feature/Sort.js */
        "../Grid/lib/Grid/feature/Sort.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Sort", function () {
          return _lib_Grid_feature_Sort_js__WEBPACK_IMPORTED_MODULE_105__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_106__ = __webpack_require__(
        /*! ./lib/Grid/feature/RegionResize.js */
        "../Grid/lib/Grid/feature/RegionResize.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RegionResize", function () {
          return _lib_Grid_feature_RegionResize_js__WEBPACK_IMPORTED_MODULE_106__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_RowReorder_js__WEBPACK_IMPORTED_MODULE_107__ = __webpack_require__(
        /*! ./lib/Grid/feature/RowReorder.js */
        "../Grid/lib/Grid/feature/RowReorder.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RowReorder", function () {
          return _lib_Grid_feature_RowReorder_js__WEBPACK_IMPORTED_MODULE_107__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_108__ = __webpack_require__(
        /*! ./lib/Grid/feature/Stripe.js */
        "../Grid/lib/Grid/feature/Stripe.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Stripe", function () {
          return _lib_Grid_feature_Stripe_js__WEBPACK_IMPORTED_MODULE_108__["default"];
        });
        /* harmony import */


        var _lib_Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_109__ = __webpack_require__(
        /*! ./lib/Grid/feature/Tree.js */
        "../Grid/lib/Grid/feature/Tree.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Tree", function () {
          return _lib_Grid_feature_Tree_js__WEBPACK_IMPORTED_MODULE_109__["default"];
        });
        /* harmony import */


        var _lib_Grid_util_ScrollManager_js__WEBPACK_IMPORTED_MODULE_110__ = __webpack_require__(
        /*! ./lib/Grid/util/ScrollManager.js */
        "../Grid/lib/Grid/util/ScrollManager.js");
        /* harmony import */


        var _lib_Grid_row_RowManager_js__WEBPACK_IMPORTED_MODULE_111__ = __webpack_require__(
        /*! ./lib/Grid/row/RowManager.js */
        "../Grid/lib/Grid/row/RowManager.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RowManager", function () {
          return _lib_Grid_row_RowManager_js__WEBPACK_IMPORTED_MODULE_111__["default"];
        });
        /* harmony import */


        var _lib_Grid_view_Footer_js__WEBPACK_IMPORTED_MODULE_112__ = __webpack_require__(
        /*! ./lib/Grid/view/Footer.js */
        "../Grid/lib/Grid/view/Footer.js");
        /* harmony import */


        var _lib_Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_113__ = __webpack_require__(
        /*! ./lib/Grid/view/Grid.js */
        "../Grid/lib/Grid/view/Grid.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Grid", function () {
          return _lib_Grid_view_Grid_js__WEBPACK_IMPORTED_MODULE_113__["default"];
        });
        /* harmony import */


        var _lib_Grid_view_Header_js__WEBPACK_IMPORTED_MODULE_114__ = __webpack_require__(
        /*! ./lib/Grid/view/Header.js */
        "../Grid/lib/Grid/view/Header.js");
        /* harmony import */


        var _lib_Grid_view_TreeGrid_js__WEBPACK_IMPORTED_MODULE_115__ = __webpack_require__(
        /*! ./lib/Grid/view/TreeGrid.js */
        "../Grid/lib/Grid/view/TreeGrid.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TreeGrid", function () {
          return _lib_Grid_view_TreeGrid_js__WEBPACK_IMPORTED_MODULE_115__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_116__ = __webpack_require__(
        /*! ./lib/Scheduler/crud/transport/AjaxTransport.js */
        "./lib/Scheduler/crud/transport/AjaxTransport.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "AjaxTransport", function () {
          return _lib_Scheduler_crud_transport_AjaxTransport_js__WEBPACK_IMPORTED_MODULE_116__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_117__ = __webpack_require__(
        /*! ./lib/Scheduler/crud/AbstractCrudManager.js */
        "./lib/Scheduler/crud/AbstractCrudManager.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "AbstractCrudManager", function () {
          return _lib_Scheduler_crud_AbstractCrudManager_js__WEBPACK_IMPORTED_MODULE_117__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_118__ = __webpack_require__(
        /*! ./lib/Scheduler/crud/encoder/JsonEncoder.js */
        "./lib/Scheduler/crud/encoder/JsonEncoder.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "JsonEncoder", function () {
          return _lib_Scheduler_crud_encoder_JsonEncoder_js__WEBPACK_IMPORTED_MODULE_118__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_119__ = __webpack_require__(
        /*! ./lib/Scheduler/data/AssignmentStore.js */
        "./lib/Scheduler/data/AssignmentStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "AssignmentStore", function () {
          return _lib_Scheduler_data_AssignmentStore_js__WEBPACK_IMPORTED_MODULE_119__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_Calendar_js__WEBPACK_IMPORTED_MODULE_120__ = __webpack_require__(
        /*! ./lib/Scheduler/data/Calendar.js */
        "./lib/Scheduler/data/Calendar.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Calendar", function () {
          return _lib_Scheduler_data_Calendar_js__WEBPACK_IMPORTED_MODULE_120__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_121__ = __webpack_require__(
        /*! ./lib/Scheduler/data/CrudManager.js */
        "./lib/Scheduler/data/CrudManager.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "CrudManager", function () {
          return _lib_Scheduler_data_CrudManager_js__WEBPACK_IMPORTED_MODULE_121__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_122__ = __webpack_require__(
        /*! ./lib/Scheduler/data/DependencyStore.js */
        "./lib/Scheduler/data/DependencyStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DependencyStore", function () {
          return _lib_Scheduler_data_DependencyStore_js__WEBPACK_IMPORTED_MODULE_122__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_123__ = __webpack_require__(
        /*! ./lib/Scheduler/data/EventStore.js */
        "./lib/Scheduler/data/EventStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventStore", function () {
          return _lib_Scheduler_data_EventStore_js__WEBPACK_IMPORTED_MODULE_123__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_124__ = __webpack_require__(
        /*! ./lib/Scheduler/data/ResourceStore.js */
        "./lib/Scheduler/data/ResourceStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResourceStore", function () {
          return _lib_Scheduler_data_ResourceStore_js__WEBPACK_IMPORTED_MODULE_124__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_125__ = __webpack_require__(
        /*! ./lib/Scheduler/data/ResourceTimeRangeStore.js */
        "./lib/Scheduler/data/ResourceTimeRangeStore.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeStore", function () {
          return _lib_Scheduler_data_ResourceTimeRangeStore_js__WEBPACK_IMPORTED_MODULE_125__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_126__ = __webpack_require__(
        /*! ./lib/Scheduler/data/TimeAxis.js */
        "./lib/Scheduler/data/TimeAxis.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimeAxis", function () {
          return _lib_Scheduler_data_TimeAxis_js__WEBPACK_IMPORTED_MODULE_126__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_127__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/ColumnLines.js */
        "./lib/Scheduler/feature/ColumnLines.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ColumnLines", function () {
          return _lib_Scheduler_feature_ColumnLines_js__WEBPACK_IMPORTED_MODULE_127__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_128__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/Dependencies.js */
        "./lib/Scheduler/feature/Dependencies.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Dependencies", function () {
          return _lib_Scheduler_feature_Dependencies_js__WEBPACK_IMPORTED_MODULE_128__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_129__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/DependencyEdit.js */
        "./lib/Scheduler/feature/DependencyEdit.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DependencyEdit", function () {
          return _lib_Scheduler_feature_DependencyEdit_js__WEBPACK_IMPORTED_MODULE_129__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_130__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventContextMenu.js */
        "./lib/Scheduler/feature/EventContextMenu.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventContextMenu", function () {
          return _lib_Scheduler_feature_EventContextMenu_js__WEBPACK_IMPORTED_MODULE_130__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_131__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventDrag.js */
        "./lib/Scheduler/feature/EventDrag.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventDrag", function () {
          return _lib_Scheduler_feature_EventDrag_js__WEBPACK_IMPORTED_MODULE_131__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_132__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventDragCreate.js */
        "./lib/Scheduler/feature/EventDragCreate.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventDragCreate", function () {
          return _lib_Scheduler_feature_EventDragCreate_js__WEBPACK_IMPORTED_MODULE_132__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventDragSelect_js__WEBPACK_IMPORTED_MODULE_133__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventDragSelect.js */
        "./lib/Scheduler/feature/EventDragSelect.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventDragSelect", function () {
          return _lib_Scheduler_feature_EventDragSelect_js__WEBPACK_IMPORTED_MODULE_133__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_134__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventEdit.js */
        "./lib/Scheduler/feature/EventEdit.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventEdit", function () {
          return _lib_Scheduler_feature_EventEdit_js__WEBPACK_IMPORTED_MODULE_134__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_135__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventFilter.js */
        "./lib/Scheduler/feature/EventFilter.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventFilter", function () {
          return _lib_Scheduler_feature_EventFilter_js__WEBPACK_IMPORTED_MODULE_135__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_136__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventResize.js */
        "./lib/Scheduler/feature/EventResize.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventResize", function () {
          return _lib_Scheduler_feature_EventResize_js__WEBPACK_IMPORTED_MODULE_136__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_137__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/EventTooltip.js */
        "./lib/Scheduler/feature/EventTooltip.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventTooltip", function () {
          return _lib_Scheduler_feature_EventTooltip_js__WEBPACK_IMPORTED_MODULE_137__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_138__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/GroupSummary.js */
        "./lib/Scheduler/feature/GroupSummary.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "GroupSummary", function () {
          return _lib_Scheduler_feature_GroupSummary_js__WEBPACK_IMPORTED_MODULE_138__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_139__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/HeaderContextMenu.js */
        "./lib/Scheduler/feature/HeaderContextMenu.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "HeaderContextMenu", function () {
          return _lib_Scheduler_feature_HeaderContextMenu_js__WEBPACK_IMPORTED_MODULE_139__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_HeaderZoom_js__WEBPACK_IMPORTED_MODULE_140__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/HeaderZoom.js */
        "./lib/Scheduler/feature/HeaderZoom.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "HeaderZoom", function () {
          return _lib_Scheduler_feature_HeaderZoom_js__WEBPACK_IMPORTED_MODULE_140__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_141__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/Labels.js */
        "./lib/Scheduler/feature/Labels.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Labels", function () {
          return _lib_Scheduler_feature_Labels_js__WEBPACK_IMPORTED_MODULE_141__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_142__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/NonWorkingTime.js */
        "./lib/Scheduler/feature/NonWorkingTime.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "NonWorkingTime", function () {
          return _lib_Scheduler_feature_NonWorkingTime_js__WEBPACK_IMPORTED_MODULE_142__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_Pan_js__WEBPACK_IMPORTED_MODULE_143__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/Pan.js */
        "./lib/Scheduler/feature/Pan.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Pan", function () {
          return _lib_Scheduler_feature_Pan_js__WEBPACK_IMPORTED_MODULE_143__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_ResourceTimeRanges_js__WEBPACK_IMPORTED_MODULE_144__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/ResourceTimeRanges.js */
        "./lib/Scheduler/feature/ResourceTimeRanges.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResourceTimeRanges", function () {
          return _lib_Scheduler_feature_ResourceTimeRanges_js__WEBPACK_IMPORTED_MODULE_144__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_145__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/ScheduleTooltip.js */
        "./lib/Scheduler/feature/ScheduleTooltip.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ScheduleTooltip", function () {
          return _lib_Scheduler_feature_ScheduleTooltip_js__WEBPACK_IMPORTED_MODULE_145__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_SimpleEventEdit_js__WEBPACK_IMPORTED_MODULE_146__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/SimpleEventEdit.js */
        "./lib/Scheduler/feature/SimpleEventEdit.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "SimpleEventEdit", function () {
          return _lib_Scheduler_feature_SimpleEventEdit_js__WEBPACK_IMPORTED_MODULE_146__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_Summary_js__WEBPACK_IMPORTED_MODULE_147__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/Summary.js */
        "./lib/Scheduler/feature/Summary.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Summary", function () {
          return _lib_Scheduler_feature_Summary_js__WEBPACK_IMPORTED_MODULE_147__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_feature_TimeRanges_js__WEBPACK_IMPORTED_MODULE_148__ = __webpack_require__(
        /*! ./lib/Scheduler/feature/TimeRanges.js */
        "./lib/Scheduler/feature/TimeRanges.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimeRanges", function () {
          return _lib_Scheduler_feature_TimeRanges_js__WEBPACK_IMPORTED_MODULE_148__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_149__ = __webpack_require__(
        /*! ./lib/Scheduler/column/TimeAxisColumn.js */
        "./lib/Scheduler/column/TimeAxisColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimeAxisColumn", function () {
          return _lib_Scheduler_column_TimeAxisColumn_js__WEBPACK_IMPORTED_MODULE_149__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_150__ = __webpack_require__(
        /*! ./lib/Scheduler/column/ResourceInfoColumn.js */
        "./lib/Scheduler/column/ResourceInfoColumn.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResourceInfoColumn", function () {
          return _lib_Scheduler_column_ResourceInfoColumn_js__WEBPACK_IMPORTED_MODULE_150__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_151__ = __webpack_require__(
        /*! ./lib/Scheduler/model/AssignmentModel.js */
        "./lib/Scheduler/model/AssignmentModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "AssignmentModel", function () {
          return _lib_Scheduler_model_AssignmentModel_js__WEBPACK_IMPORTED_MODULE_151__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_CalendarDayModel_js__WEBPACK_IMPORTED_MODULE_152__ = __webpack_require__(
        /*! ./lib/Scheduler/model/CalendarDayModel.js */
        "./lib/Scheduler/model/CalendarDayModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "CalendarDayModel", function () {
          return _lib_Scheduler_model_CalendarDayModel_js__WEBPACK_IMPORTED_MODULE_152__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_153__ = __webpack_require__(
        /*! ./lib/Scheduler/model/DependencyBaseModel.js */
        "./lib/Scheduler/model/DependencyBaseModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DependencyBaseModel", function () {
          return _lib_Scheduler_model_DependencyBaseModel_js__WEBPACK_IMPORTED_MODULE_153__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_154__ = __webpack_require__(
        /*! ./lib/Scheduler/model/DependencyModel.js */
        "./lib/Scheduler/model/DependencyModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "DependencyModel", function () {
          return _lib_Scheduler_model_DependencyModel_js__WEBPACK_IMPORTED_MODULE_154__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_155__ = __webpack_require__(
        /*! ./lib/Scheduler/model/EventModel.js */
        "./lib/Scheduler/model/EventModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "EventModel", function () {
          return _lib_Scheduler_model_EventModel_js__WEBPACK_IMPORTED_MODULE_155__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_156__ = __webpack_require__(
        /*! ./lib/Scheduler/model/ResourceModel.js */
        "./lib/Scheduler/model/ResourceModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResourceModel", function () {
          return _lib_Scheduler_model_ResourceModel_js__WEBPACK_IMPORTED_MODULE_156__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_157__ = __webpack_require__(
        /*! ./lib/Scheduler/model/ResourceTimeRangeModel.js */
        "./lib/Scheduler/model/ResourceTimeRangeModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ResourceTimeRangeModel", function () {
          return _lib_Scheduler_model_ResourceTimeRangeModel_js__WEBPACK_IMPORTED_MODULE_157__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_158__ = __webpack_require__(
        /*! ./lib/Scheduler/model/TimeSpan.js */
        "./lib/Scheduler/model/TimeSpan.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimeSpan", function () {
          return _lib_Scheduler_model_TimeSpan_js__WEBPACK_IMPORTED_MODULE_158__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_159__ = __webpack_require__(
        /*! ./lib/Scheduler/preset/PresetManager.js */
        "./lib/Scheduler/preset/PresetManager.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "PresetManager", function () {
          return _lib_Scheduler_preset_PresetManager_js__WEBPACK_IMPORTED_MODULE_159__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_160__ = __webpack_require__(
        /*! ./lib/Scheduler/preset/ViewPreset.js */
        "./lib/Scheduler/preset/ViewPreset.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "ViewPreset", function () {
          return _lib_Scheduler_preset_ViewPreset_js__WEBPACK_IMPORTED_MODULE_160__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_161__ = __webpack_require__(
        /*! ./lib/Scheduler/util/RectangularPathFinder.js */
        "./lib/Scheduler/util/RectangularPathFinder.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "RectangularPathFinder", function () {
          return _lib_Scheduler_util_RectangularPathFinder_js__WEBPACK_IMPORTED_MODULE_161__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_view_model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_162__ = __webpack_require__(
        /*! ./lib/Scheduler/view/model/TimeAxisViewModel.js */
        "./lib/Scheduler/view/model/TimeAxisViewModel.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "TimeAxisViewModel", function () {
          return _lib_Scheduler_view_model_TimeAxisViewModel_js__WEBPACK_IMPORTED_MODULE_162__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_163__ = __webpack_require__(
        /*! ./lib/Scheduler/view/HorizontalTimeAxis.js */
        "./lib/Scheduler/view/HorizontalTimeAxis.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "HorizontalTimeAxis", function () {
          return _lib_Scheduler_view_HorizontalTimeAxis_js__WEBPACK_IMPORTED_MODULE_163__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_164__ = __webpack_require__(
        /*! ./lib/Scheduler/view/Scheduler.js */
        "./lib/Scheduler/view/Scheduler.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "Scheduler", function () {
          return _lib_Scheduler_view_Scheduler_js__WEBPACK_IMPORTED_MODULE_164__["default"];
        });
        /* harmony import */


        var _lib_Scheduler_customElements_SchedulerTag_js__WEBPACK_IMPORTED_MODULE_165__ = __webpack_require__(
        /*! ./lib/Scheduler/customElements/SchedulerTag.js */
        "./lib/Scheduler/customElements/SchedulerTag.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "SchedulerTag", function () {
          return _lib_Scheduler_customElements_SchedulerTag_js__WEBPACK_IMPORTED_MODULE_165__["default"];
        });

        var productName = 'scheduler';
        /* eslint-disable */
        // leave in, comment removed in bryntum-loader. also needs to go at top since polyfill is used by other code
        //import "nodelist-foreach-polyfill";

        if (!window.bryntum) window.bryntum = {}; //region Common
        // adapter
        // data
        // helpers
        // localization
        // mixin
        // util
        // widget
        //endregion
        //region Grid
        // columns
        //import GridTag from './lib/Grid/customElements/GridTag.js';
        // data
        // features
        // util
        // view
        //endregion
        //region Scheduler
        // crud
        // data
        // features
        // columns
        // model
        // preset
        // util
        //view
        // IMPORTANT NOTE: Tag should be imported last to be last in the rolled up bundle. We rely on its position to embed
        //endregion

        /***/
      }
      /******/

    })
  );
});